/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Json: `scalar.Json` as const,
	_RelationSide: "enum" as const,
	_OnDeleteBehaviour: "enum" as const,
	_OrderByDirection: "enum" as const,
	Query:{
		getGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere"
		},
		listGeneral:{
			filter:"GeneralWhere",
			orderBy:"GeneralOrderBy"
		},
		paginateGeneral:{
			filter:"GeneralWhere",
			orderBy:"GeneralOrderBy"
		},
		validateCreateGeneral:{
			data:"GeneralCreateInput"
		},
		validateUpdateGeneral:{
			by:"GeneralUniqueWhere",
			data:"GeneralUpdateInput"
		},
		getImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		listImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		paginateImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		validateCreateImage:{
			data:"ImageCreateInput"
		},
		validateUpdateImage:{
			by:"ImageUniqueWhere",
			data:"ImageUpdateInput"
		},
		getGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere"
		},
		listGenericPage:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		paginateGenericPage:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		validateCreateGenericPage:{
			data:"GenericPageCreateInput"
		},
		validateUpdateGenericPage:{
			by:"GenericPageUniqueWhere",
			data:"GenericPageUpdateInput"
		},
		getLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		listLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		paginateLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		validateCreateLinkable:{
			data:"LinkableCreateInput"
		},
		validateUpdateLinkable:{
			by:"LinkableUniqueWhere",
			data:"LinkableUpdateInput"
		},
		getSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		listSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		paginateSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		validateCreateSeo:{
			data:"SeoCreateInput"
		},
		validateUpdateSeo:{
			by:"SeoUniqueWhere",
			data:"SeoUpdateInput"
		},
		getContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		listContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		paginateContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		validateCreateContent:{
			data:"ContentCreateInput"
		},
		validateUpdateContent:{
			by:"ContentUniqueWhere",
			data:"ContentUpdateInput"
		},
		getContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		listContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		paginateContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		validateCreateContentBlock:{
			data:"ContentBlockCreateInput"
		},
		validateUpdateContentBlock:{
			by:"ContentBlockUniqueWhere",
			data:"ContentBlockUpdateInput"
		},
		getContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		listContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		paginateContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		validateCreateContentReference:{
			data:"ContentReferenceCreateInput"
		},
		validateUpdateContentReference:{
			by:"ContentReferenceUniqueWhere",
			data:"ContentReferenceUpdateInput"
		},
		getContentReferenceLinkableItem:{
			by:"ContentReferenceLinkableItemUniqueWhere",
			filter:"ContentReferenceLinkableItemWhere"
		},
		listContentReferenceLinkableItem:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		paginateContentReferenceLinkableItem:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		getGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		listGeneralLocale:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		paginateGeneralLocale:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		validateCreateGeneralLocale:{
			data:"GeneralLocaleCreateInput"
		},
		validateUpdateGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			data:"GeneralLocaleUpdateInput"
		},
		getGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		listGenericPageLocale:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		paginateGenericPageLocale:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		validateCreateGenericPageLocale:{
			data:"GenericPageLocaleCreateInput"
		},
		validateUpdateGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			data:"GenericPageLocaleUpdateInput"
		},
		getLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		listLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		paginateLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		validateCreateLocale:{
			data:"LocaleCreateInput"
		},
		validateUpdateLocale:{
			by:"LocaleUniqueWhere",
			data:"LocaleUpdateInput"
		},
		getVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		listVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		paginateVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		validateCreateVideo:{
			data:"VideoCreateInput"
		},
		validateUpdateVideo:{
			by:"VideoUniqueWhere",
			data:"VideoUpdateInput"
		},
		getLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		listLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		paginateLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		validateCreateLink:{
			data:"LinkCreateInput"
		},
		validateUpdateLink:{
			by:"LinkUniqueWhere",
			data:"LinkUpdateInput"
		},
		getPost:{
			by:"PostUniqueWhere",
			filter:"PostWhere"
		},
		listPost:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		paginatePost:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		validateCreatePost:{
			data:"PostCreateInput"
		},
		validateUpdatePost:{
			by:"PostUniqueWhere",
			data:"PostUpdateInput"
		},
		getPostLocale:{
			by:"PostLocaleUniqueWhere",
			filter:"PostLocaleWhere"
		},
		listPostLocale:{
			filter:"PostLocaleWhere",
			orderBy:"PostLocaleOrderBy"
		},
		paginatePostLocale:{
			filter:"PostLocaleWhere",
			orderBy:"PostLocaleOrderBy"
		},
		validateCreatePostLocale:{
			data:"PostLocaleCreateInput"
		},
		validateUpdatePostLocale:{
			by:"PostLocaleUniqueWhere",
			data:"PostLocaleUpdateInput"
		},
		getPostArea:{
			by:"PostAreaUniqueWhere",
			filter:"PostAreaWhere"
		},
		listPostArea:{
			filter:"PostAreaWhere",
			orderBy:"PostAreaOrderBy"
		},
		paginatePostArea:{
			filter:"PostAreaWhere",
			orderBy:"PostAreaOrderBy"
		},
		validateCreatePostArea:{
			data:"PostAreaCreateInput"
		},
		validateUpdatePostArea:{
			by:"PostAreaUniqueWhere",
			data:"PostAreaUpdateInput"
		},
		getPostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		listPostAreaLocale:{
			filter:"PostAreaLocaleWhere",
			orderBy:"PostAreaLocaleOrderBy"
		},
		paginatePostAreaLocale:{
			filter:"PostAreaLocaleWhere",
			orderBy:"PostAreaLocaleOrderBy"
		},
		validateCreatePostAreaLocale:{
			data:"PostAreaLocaleCreateInput"
		},
		validateUpdatePostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			data:"PostAreaLocaleUpdateInput"
		},
		getPostOrganization:{
			by:"PostOrganizationUniqueWhere",
			filter:"PostOrganizationWhere"
		},
		listPostOrganization:{
			filter:"PostOrganizationWhere",
			orderBy:"PostOrganizationOrderBy"
		},
		paginatePostOrganization:{
			filter:"PostOrganizationWhere",
			orderBy:"PostOrganizationOrderBy"
		},
		validateCreatePostOrganization:{
			data:"PostOrganizationCreateInput"
		},
		validateUpdatePostOrganization:{
			by:"PostOrganizationUniqueWhere",
			data:"PostOrganizationUpdateInput"
		},
		getPostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		listPostOrganizationLocale:{
			filter:"PostOrganizationLocaleWhere",
			orderBy:"PostOrganizationLocaleOrderBy"
		},
		paginatePostOrganizationLocale:{
			filter:"PostOrganizationLocaleWhere",
			orderBy:"PostOrganizationLocaleOrderBy"
		},
		validateCreatePostOrganizationLocale:{
			data:"PostOrganizationLocaleCreateInput"
		},
		validateUpdatePostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			data:"PostOrganizationLocaleUpdateInput"
		},
		getDonation:{
			by:"DonationUniqueWhere",
			filter:"DonationWhere"
		},
		listDonation:{
			filter:"DonationWhere",
			orderBy:"DonationOrderBy"
		},
		paginateDonation:{
			filter:"DonationWhere",
			orderBy:"DonationOrderBy"
		},
		validateCreateDonation:{
			data:"DonationCreateInput"
		},
		validateUpdateDonation:{
			by:"DonationUniqueWhere",
			data:"DonationUpdateInput"
		},
		getDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			filter:"DonationAmountItemWhere"
		},
		listDonationAmountItem:{
			filter:"DonationAmountItemWhere",
			orderBy:"DonationAmountItemOrderBy"
		},
		paginateDonationAmountItem:{
			filter:"DonationAmountItemWhere",
			orderBy:"DonationAmountItemOrderBy"
		},
		validateCreateDonationAmountItem:{
			data:"DonationAmountItemCreateInput"
		},
		validateUpdateDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			data:"DonationAmountItemUpdateInput"
		},
		getDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			filter:"DonationAmountsRegionItemWhere"
		},
		listDonationAmountsRegionItem:{
			filter:"DonationAmountsRegionItemWhere",
			orderBy:"DonationAmountsRegionItemOrderBy"
		},
		paginateDonationAmountsRegionItem:{
			filter:"DonationAmountsRegionItemWhere",
			orderBy:"DonationAmountsRegionItemOrderBy"
		},
		validateCreateDonationAmountsRegionItem:{
			data:"DonationAmountsRegionItemCreateInput"
		},
		validateUpdateDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			data:"DonationAmountsRegionItemUpdateInput"
		},
		getDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			filter:"DonationAmountsRegionListWhere"
		},
		listDonationAmountsRegionList:{
			filter:"DonationAmountsRegionListWhere",
			orderBy:"DonationAmountsRegionListOrderBy"
		},
		paginateDonationAmountsRegionList:{
			filter:"DonationAmountsRegionListWhere",
			orderBy:"DonationAmountsRegionListOrderBy"
		},
		validateCreateDonationAmountsRegionList:{
			data:"DonationAmountsRegionListCreateInput"
		},
		validateUpdateDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			data:"DonationAmountsRegionListUpdateInput"
		},
		getRegion:{
			by:"RegionUniqueWhere",
			filter:"RegionWhere"
		},
		listRegion:{
			filter:"RegionWhere",
			orderBy:"RegionOrderBy"
		},
		paginateRegion:{
			filter:"RegionWhere",
			orderBy:"RegionOrderBy"
		},
		validateCreateRegion:{
			data:"RegionCreateInput"
		},
		validateUpdateRegion:{
			by:"RegionUniqueWhere",
			data:"RegionUpdateInput"
		},
		getLinkItem:{
			by:"LinkItemUniqueWhere",
			filter:"LinkItemWhere"
		},
		listLinkItem:{
			filter:"LinkItemWhere",
			orderBy:"LinkItemOrderBy"
		},
		paginateLinkItem:{
			filter:"LinkItemWhere",
			orderBy:"LinkItemOrderBy"
		},
		validateCreateLinkItem:{
			data:"LinkItemCreateInput"
		},
		validateUpdateLinkItem:{
			by:"LinkItemUniqueWhere",
			data:"LinkItemUpdateInput"
		},
		getLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere"
		},
		listLinkList:{
			filter:"LinkListWhere",
			orderBy:"LinkListOrderBy"
		},
		paginateLinkList:{
			filter:"LinkListWhere",
			orderBy:"LinkListOrderBy"
		},
		validateCreateLinkList:{
			data:"LinkListCreateInput"
		},
		validateUpdateLinkList:{
			by:"LinkListUniqueWhere",
			data:"LinkListUpdateInput"
		},
		getHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere"
		},
		listHeader:{
			filter:"HeaderWhere",
			orderBy:"HeaderOrderBy"
		},
		paginateHeader:{
			filter:"HeaderWhere",
			orderBy:"HeaderOrderBy"
		},
		validateCreateHeader:{
			data:"HeaderCreateInput"
		},
		validateUpdateHeader:{
			by:"HeaderUniqueWhere",
			data:"HeaderUpdateInput"
		},
		getHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		listHeaderLocale:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		paginateHeaderLocale:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		validateCreateHeaderLocale:{
			data:"HeaderLocaleCreateInput"
		},
		validateUpdateHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			data:"HeaderLocaleUpdateInput"
		},
		getFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere"
		},
		listFooter:{
			filter:"FooterWhere",
			orderBy:"FooterOrderBy"
		},
		paginateFooter:{
			filter:"FooterWhere",
			orderBy:"FooterOrderBy"
		},
		validateCreateFooter:{
			data:"FooterCreateInput"
		},
		validateUpdateFooter:{
			by:"FooterUniqueWhere",
			data:"FooterUpdateInput"
		},
		getFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		listFooterLocale:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		paginateFooterLocale:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		validateCreateFooterLocale:{
			data:"FooterLocaleCreateInput"
		},
		validateUpdateFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			data:"FooterLocaleUpdateInput"
		},
		getPostList:{
			by:"PostListUniqueWhere",
			filter:"PostListWhere"
		},
		listPostList:{
			filter:"PostListWhere",
			orderBy:"PostListOrderBy"
		},
		paginatePostList:{
			filter:"PostListWhere",
			orderBy:"PostListOrderBy"
		},
		validateCreatePostList:{
			data:"PostListCreateInput"
		},
		validateUpdatePostList:{
			by:"PostListUniqueWhere",
			data:"PostListUpdateInput"
		},
		getPostListItem:{
			by:"PostListItemUniqueWhere",
			filter:"PostListItemWhere"
		},
		listPostListItem:{
			filter:"PostListItemWhere",
			orderBy:"PostListItemOrderBy"
		},
		paginatePostListItem:{
			filter:"PostListItemWhere",
			orderBy:"PostListItemOrderBy"
		},
		validateCreatePostListItem:{
			data:"PostListItemCreateInput"
		},
		validateUpdatePostListItem:{
			by:"PostListItemUniqueWhere",
			data:"PostListItemUpdateInput"
		},
		getAppBanner:{
			by:"AppBannerUniqueWhere",
			filter:"AppBannerWhere"
		},
		listAppBanner:{
			filter:"AppBannerWhere",
			orderBy:"AppBannerOrderBy"
		},
		paginateAppBanner:{
			filter:"AppBannerWhere",
			orderBy:"AppBannerOrderBy"
		},
		validateCreateAppBanner:{
			data:"AppBannerCreateInput"
		},
		validateUpdateAppBanner:{
			by:"AppBannerUniqueWhere",
			data:"AppBannerUpdateInput"
		},
		getGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			filter:"GenericPageAboutSettingsWhere"
		},
		listGenericPageAboutSettings:{
			filter:"GenericPageAboutSettingsWhere",
			orderBy:"GenericPageAboutSettingsOrderBy"
		},
		paginateGenericPageAboutSettings:{
			filter:"GenericPageAboutSettingsWhere",
			orderBy:"GenericPageAboutSettingsOrderBy"
		},
		validateCreateGenericPageAboutSettings:{
			data:"GenericPageAboutSettingsCreateInput"
		},
		validateUpdateGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			data:"GenericPageAboutSettingsUpdateInput"
		},
		getGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		listGenericPageAboutSettingsLocale:{
			filter:"GenericPageAboutSettingsLocaleWhere",
			orderBy:"GenericPageAboutSettingsLocaleOrderBy"
		},
		paginateGenericPageAboutSettingsLocale:{
			filter:"GenericPageAboutSettingsLocaleWhere",
			orderBy:"GenericPageAboutSettingsLocaleOrderBy"
		},
		validateCreateGenericPageAboutSettingsLocale:{
			data:"GenericPageAboutSettingsLocaleCreateInput"
		},
		validateUpdateGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			data:"GenericPageAboutSettingsLocaleUpdateInput"
		},
		getValue:{
			by:"ValueUniqueWhere",
			filter:"ValueWhere"
		},
		listValue:{
			filter:"ValueWhere",
			orderBy:"ValueOrderBy"
		},
		paginateValue:{
			filter:"ValueWhere",
			orderBy:"ValueOrderBy"
		},
		validateCreateValue:{
			data:"ValueCreateInput"
		},
		validateUpdateValue:{
			by:"ValueUniqueWhere",
			data:"ValueUpdateInput"
		},
		getValueItem:{
			by:"ValueItemUniqueWhere",
			filter:"ValueItemWhere"
		},
		listValueItem:{
			filter:"ValueItemWhere",
			orderBy:"ValueItemOrderBy"
		},
		paginateValueItem:{
			filter:"ValueItemWhere",
			orderBy:"ValueItemOrderBy"
		},
		validateCreateValueItem:{
			data:"ValueItemCreateInput"
		},
		validateUpdateValueItem:{
			by:"ValueItemUniqueWhere",
			data:"ValueItemUpdateInput"
		},
		getValueList:{
			by:"ValueListUniqueWhere",
			filter:"ValueListWhere"
		},
		listValueList:{
			filter:"ValueListWhere",
			orderBy:"ValueListOrderBy"
		},
		paginateValueList:{
			filter:"ValueListWhere",
			orderBy:"ValueListOrderBy"
		},
		validateCreateValueList:{
			data:"ValueListCreateInput"
		},
		validateUpdateValueList:{
			by:"ValueListUniqueWhere",
			data:"ValueListUpdateInput"
		},
		getImageLink:{
			by:"ImageLinkUniqueWhere",
			filter:"ImageLinkWhere"
		},
		listImageLink:{
			filter:"ImageLinkWhere",
			orderBy:"ImageLinkOrderBy"
		},
		paginateImageLink:{
			filter:"ImageLinkWhere",
			orderBy:"ImageLinkOrderBy"
		},
		validateCreateImageLink:{
			data:"ImageLinkCreateInput"
		},
		validateUpdateImageLink:{
			by:"ImageLinkUniqueWhere",
			data:"ImageLinkUpdateInput"
		},
		getImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			filter:"ImageLinkItemWhere"
		},
		listImageLinkItem:{
			filter:"ImageLinkItemWhere",
			orderBy:"ImageLinkItemOrderBy"
		},
		paginateImageLinkItem:{
			filter:"ImageLinkItemWhere",
			orderBy:"ImageLinkItemOrderBy"
		},
		validateCreateImageLinkItem:{
			data:"ImageLinkItemCreateInput"
		},
		validateUpdateImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			data:"ImageLinkItemUpdateInput"
		},
		getImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			filter:"ImageLinkListWhere"
		},
		listImageLinkList:{
			filter:"ImageLinkListWhere",
			orderBy:"ImageLinkListOrderBy"
		},
		paginateImageLinkList:{
			filter:"ImageLinkListWhere",
			orderBy:"ImageLinkListOrderBy"
		},
		validateCreateImageLinkList:{
			data:"ImageLinkListCreateInput"
		},
		validateUpdateImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			data:"ImageLinkListUpdateInput"
		},
		getPostAreaList:{
			by:"PostAreaListUniqueWhere",
			filter:"PostAreaListWhere"
		},
		listPostAreaList:{
			filter:"PostAreaListWhere",
			orderBy:"PostAreaListOrderBy"
		},
		paginatePostAreaList:{
			filter:"PostAreaListWhere",
			orderBy:"PostAreaListOrderBy"
		},
		validateCreatePostAreaList:{
			data:"PostAreaListCreateInput"
		},
		validateUpdatePostAreaList:{
			by:"PostAreaListUniqueWhere",
			data:"PostAreaListUpdateInput"
		},
		getPostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			filter:"PostAreaListItemWhere"
		},
		listPostAreaListItem:{
			filter:"PostAreaListItemWhere",
			orderBy:"PostAreaListItemOrderBy"
		},
		paginatePostAreaListItem:{
			filter:"PostAreaListItemWhere",
			orderBy:"PostAreaListItemOrderBy"
		},
		validateCreatePostAreaListItem:{
			data:"PostAreaListItemCreateInput"
		},
		validateUpdatePostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			data:"PostAreaListItemUpdateInput"
		},
		getAccordion:{
			by:"AccordionUniqueWhere",
			filter:"AccordionWhere"
		},
		listAccordion:{
			filter:"AccordionWhere",
			orderBy:"AccordionOrderBy"
		},
		paginateAccordion:{
			filter:"AccordionWhere",
			orderBy:"AccordionOrderBy"
		},
		validateCreateAccordion:{
			data:"AccordionCreateInput"
		},
		validateUpdateAccordion:{
			by:"AccordionUniqueWhere",
			data:"AccordionUpdateInput"
		},
		getAccordionItem:{
			by:"AccordionItemUniqueWhere",
			filter:"AccordionItemWhere"
		},
		listAccordionItem:{
			filter:"AccordionItemWhere",
			orderBy:"AccordionItemOrderBy"
		},
		paginateAccordionItem:{
			filter:"AccordionItemWhere",
			orderBy:"AccordionItemOrderBy"
		},
		validateCreateAccordionItem:{
			data:"AccordionItemCreateInput"
		},
		validateUpdateAccordionItem:{
			by:"AccordionItemUniqueWhere",
			data:"AccordionItemUpdateInput"
		},
		getUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere"
		},
		listUser:{
			filter:"UserWhere",
			orderBy:"UserOrderBy"
		},
		paginateUser:{
			filter:"UserWhere",
			orderBy:"UserOrderBy"
		},
		validateCreateUser:{
			data:"UserCreateInput"
		},
		validateUpdateUser:{
			by:"UserUniqueWhere",
			data:"UserUpdateInput"
		},
		getUserPayment:{
			by:"UserPaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		listUserPayment:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		paginateUserPayment:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		validateCreateUserPayment:{
			data:"UserPaymentCreateInput"
		},
		validateUpdateUserPayment:{
			by:"UserPaymentUniqueWhere",
			data:"UserPaymentUpdateInput"
		},
		getCurrency:{
			by:"CurrencyUniqueWhere",
			filter:"CurrencyWhere"
		},
		listCurrency:{
			filter:"CurrencyWhere",
			orderBy:"CurrencyOrderBy"
		},
		paginateCurrency:{
			filter:"CurrencyWhere",
			orderBy:"CurrencyOrderBy"
		},
		validateCreateCurrency:{
			data:"CurrencyCreateInput"
		},
		validateUpdateCurrency:{
			by:"CurrencyUniqueWhere",
			data:"CurrencyUpdateInput"
		},
		getMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		listMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		paginateMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		validateCreateMedium:{
			data:"MediumCreateInput"
		},
		validateUpdateMedium:{
			by:"MediumUniqueWhere",
			data:"MediumUpdateInput"
		},
		getMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere"
		},
		listMediumItem:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		paginateMediumItem:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		validateCreateMediumItem:{
			data:"MediumItemCreateInput"
		},
		validateUpdateMediumItem:{
			by:"MediumItemUniqueWhere",
			data:"MediumItemUpdateInput"
		},
		getMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere"
		},
		listMediumList:{
			filter:"MediumListWhere",
			orderBy:"MediumListOrderBy"
		},
		paginateMediumList:{
			filter:"MediumListWhere",
			orderBy:"MediumListOrderBy"
		},
		validateCreateMediumList:{
			data:"MediumListCreateInput"
		},
		validateUpdateMediumList:{
			by:"MediumListUniqueWhere",
			data:"MediumListUpdateInput"
		},
		getUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			filter:"UserPaymentOrderIdWhere"
		},
		listUserPaymentOrderId:{
			filter:"UserPaymentOrderIdWhere",
			orderBy:"UserPaymentOrderIdOrderBy"
		},
		paginateUserPaymentOrderId:{
			filter:"UserPaymentOrderIdWhere",
			orderBy:"UserPaymentOrderIdOrderBy"
		},
		validateCreateUserPaymentOrderId:{
			data:"UserPaymentOrderIdCreateInput"
		},
		validateUpdateUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			data:"UserPaymentOrderIdUpdateInput"
		},
		getPostRevision:{
			by:"PostRevisionUniqueWhere",
			filter:"PostRevisionWhere"
		},
		listPostRevision:{
			filter:"PostRevisionWhere",
			orderBy:"PostRevisionOrderBy"
		},
		paginatePostRevision:{
			filter:"PostRevisionWhere",
			orderBy:"PostRevisionOrderBy"
		},
		validateCreatePostRevision:{
			data:"PostRevisionCreateInput"
		},
		validateUpdatePostRevision:{
			by:"PostRevisionUniqueWhere",
			data:"PostRevisionUpdateInput"
		},
		getUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			filter:"UserRecurringPaymentWhere"
		},
		listUserRecurringPayment:{
			filter:"UserRecurringPaymentWhere",
			orderBy:"UserRecurringPaymentOrderBy"
		},
		paginateUserRecurringPayment:{
			filter:"UserRecurringPaymentWhere",
			orderBy:"UserRecurringPaymentOrderBy"
		},
		validateCreateUserRecurringPayment:{
			data:"UserRecurringPaymentCreateInput"
		},
		validateUpdateUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			data:"UserRecurringPaymentUpdateInput"
		},
		getUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			filter:"UserRecurringPaymentItemWhere"
		},
		listUserRecurringPaymentItem:{
			filter:"UserRecurringPaymentItemWhere",
			orderBy:"UserRecurringPaymentItemOrderBy"
		},
		paginateUserRecurringPaymentItem:{
			filter:"UserRecurringPaymentItemWhere",
			orderBy:"UserRecurringPaymentItemOrderBy"
		},
		validateCreateUserRecurringPaymentItem:{
			data:"UserRecurringPaymentItemCreateInput"
		},
		validateUpdateUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			data:"UserRecurringPaymentItemUpdateInput"
		},
		getPostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		listPostRevisionLocale:{
			filter:"PostRevisionLocaleWhere",
			orderBy:"PostRevisionLocaleOrderBy"
		},
		paginatePostRevisionLocale:{
			filter:"PostRevisionLocaleWhere",
			orderBy:"PostRevisionLocaleOrderBy"
		},
		validateCreatePostRevisionLocale:{
			data:"PostRevisionLocaleCreateInput"
		},
		validateUpdatePostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			data:"PostRevisionLocaleUpdateInput"
		},
		getTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		listTranslationCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		paginateTranslationCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		validateCreateTranslationCatalogue:{
			data:"TranslationCatalogueCreateInput"
		},
		validateUpdateTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			data:"TranslationCatalogueUpdateInput"
		},
		getTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere"
		},
		listTranslationCataloguesIdentifier:{
			filter:"TranslationCataloguesIdentifierWhere",
			orderBy:"TranslationCataloguesIdentifierOrderBy"
		},
		paginateTranslationCataloguesIdentifier:{
			filter:"TranslationCataloguesIdentifierWhere",
			orderBy:"TranslationCataloguesIdentifierOrderBy"
		},
		validateCreateTranslationCataloguesIdentifier:{
			data:"TranslationCataloguesIdentifierCreateInput"
		},
		validateUpdateTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			data:"TranslationCataloguesIdentifierUpdateInput"
		},
		getTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere"
		},
		listTranslationDomain:{
			filter:"TranslationDomainWhere",
			orderBy:"TranslationDomainOrderBy"
		},
		paginateTranslationDomain:{
			filter:"TranslationDomainWhere",
			orderBy:"TranslationDomainOrderBy"
		},
		validateCreateTranslationDomain:{
			data:"TranslationDomainCreateInput"
		},
		validateUpdateTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			data:"TranslationDomainUpdateInput"
		},
		getTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		listTranslationKey:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		paginateTranslationKey:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		validateCreateTranslationKey:{
			data:"TranslationKeyCreateInput"
		},
		validateUpdateTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			data:"TranslationKeyUpdateInput"
		},
		getTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		listTranslationValue:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		paginateTranslationValue:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		validateCreateTranslationValue:{
			data:"TranslationValueCreateInput"
		},
		validateUpdateTranslationValue:{
			by:"TranslationValueUniqueWhere",
			data:"TranslationValueUpdateInput"
		},
		getGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere"
		},
		listGenericPageAboutGroupLinksLocale:{
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			orderBy:"GenericPageAboutGroupLinksLocaleOrderBy"
		},
		paginateGenericPageAboutGroupLinksLocale:{
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			orderBy:"GenericPageAboutGroupLinksLocaleOrderBy"
		},
		validateCreateGenericPageAboutGroupLinksLocale:{
			data:"GenericPageAboutGroupLinksLocaleCreateInput"
		},
		validateUpdateGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			data:"GenericPageAboutGroupLinksLocaleUpdateInput"
		},
		getMemberList:{
			by:"MemberListUniqueWhere",
			filter:"MemberListWhere"
		},
		listMemberList:{
			filter:"MemberListWhere",
			orderBy:"MemberListOrderBy"
		},
		paginateMemberList:{
			filter:"MemberListWhere",
			orderBy:"MemberListOrderBy"
		},
		validateCreateMemberList:{
			data:"MemberListCreateInput"
		},
		validateUpdateMemberList:{
			by:"MemberListUniqueWhere",
			data:"MemberListUpdateInput"
		},
		getMemberListItem:{
			by:"MemberListItemUniqueWhere",
			filter:"MemberListItemWhere"
		},
		listMemberListItem:{
			filter:"MemberListItemWhere",
			orderBy:"MemberListItemOrderBy"
		},
		paginateMemberListItem:{
			filter:"MemberListItemWhere",
			orderBy:"MemberListItemOrderBy"
		},
		validateCreateMemberListItem:{
			data:"MemberListItemCreateInput"
		},
		validateUpdateMemberListItem:{
			by:"MemberListItemUniqueWhere",
			data:"MemberListItemUpdateInput"
		},
		getFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			filter:"FilledTaxFormWhere"
		},
		listFilledTaxForm:{
			filter:"FilledTaxFormWhere",
			orderBy:"FilledTaxFormOrderBy"
		},
		paginateFilledTaxForm:{
			filter:"FilledTaxFormWhere",
			orderBy:"FilledTaxFormOrderBy"
		},
		validateCreateFilledTaxForm:{
			data:"FilledTaxFormCreateInput"
		},
		validateUpdateFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			data:"FilledTaxFormUpdateInput"
		},
		getFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			filter:"FilledTaxFormEmailAddressWhere"
		},
		listFilledTaxFormEmailAddress:{
			filter:"FilledTaxFormEmailAddressWhere",
			orderBy:"FilledTaxFormEmailAddressOrderBy"
		},
		paginateFilledTaxFormEmailAddress:{
			filter:"FilledTaxFormEmailAddressWhere",
			orderBy:"FilledTaxFormEmailAddressOrderBy"
		},
		validateCreateFilledTaxFormEmailAddress:{
			data:"FilledTaxFormEmailAddressCreateInput"
		},
		validateUpdateFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			data:"FilledTaxFormEmailAddressUpdateInput"
		},
		getForm:{
			by:"FormUniqueWhere",
			filter:"FormWhere"
		},
		listForm:{
			filter:"FormWhere",
			orderBy:"FormOrderBy"
		},
		paginateForm:{
			filter:"FormWhere",
			orderBy:"FormOrderBy"
		},
		validateCreateForm:{
			data:"FormCreateInput"
		},
		validateUpdateForm:{
			by:"FormUniqueWhere",
			data:"FormUpdateInput"
		},
		getCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			filter:"CsobPaymentWhere"
		},
		listCsobPayment:{
			filter:"CsobPaymentWhere",
			orderBy:"CsobPaymentOrderBy"
		},
		paginateCsobPayment:{
			filter:"CsobPaymentWhere",
			orderBy:"CsobPaymentOrderBy"
		},
		validateCreateCsobPayment:{
			data:"CsobPaymentCreateInput"
		},
		validateUpdateCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			data:"CsobPaymentUpdateInput"
		},
		getCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			filter:"CsobPaymentStatusChangeWhere"
		},
		listCsobPaymentStatusChange:{
			filter:"CsobPaymentStatusChangeWhere",
			orderBy:"CsobPaymentStatusChangeOrderBy"
		},
		paginateCsobPaymentStatusChange:{
			filter:"CsobPaymentStatusChangeWhere",
			orderBy:"CsobPaymentStatusChangeOrderBy"
		},
		validateCreateCsobPaymentStatusChange:{
			data:"CsobPaymentStatusChangeCreateInput"
		},
		validateUpdateCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			data:"CsobPaymentStatusChangeUpdateInput"
		},
		getStripePayment:{
			by:"StripePaymentUniqueWhere",
			filter:"StripePaymentWhere"
		},
		listStripePayment:{
			filter:"StripePaymentWhere",
			orderBy:"StripePaymentOrderBy"
		},
		paginateStripePayment:{
			filter:"StripePaymentWhere",
			orderBy:"StripePaymentOrderBy"
		},
		validateCreateStripePayment:{
			data:"StripePaymentCreateInput"
		},
		validateUpdateStripePayment:{
			by:"StripePaymentUniqueWhere",
			data:"StripePaymentUpdateInput"
		},
		getStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			filter:"StripePaymentStatusChangeWhere"
		},
		listStripePaymentStatusChange:{
			filter:"StripePaymentStatusChangeWhere",
			orderBy:"StripePaymentStatusChangeOrderBy"
		},
		paginateStripePaymentStatusChange:{
			filter:"StripePaymentStatusChangeWhere",
			orderBy:"StripePaymentStatusChangeOrderBy"
		},
		validateCreateStripePaymentStatusChange:{
			data:"StripePaymentStatusChangeCreateInput"
		},
		validateUpdateStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			data:"StripePaymentStatusChangeUpdateInput"
		},
		getRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere"
		},
		listRegionPaymentMethod:{
			filter:"RegionPaymentMethodWhere",
			orderBy:"RegionPaymentMethodOrderBy"
		},
		paginateRegionPaymentMethod:{
			filter:"RegionPaymentMethodWhere",
			orderBy:"RegionPaymentMethodOrderBy"
		},
		validateCreateRegionPaymentMethod:{
			data:"RegionPaymentMethodCreateInput"
		},
		validateUpdateRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			data:"RegionPaymentMethodUpdateInput"
		},
		getPostAreaMetaData:{
			by:"PostAreaMetaDataUniqueWhere",
			filter:"PostAreaMetaDataWhere"
		},
		listPostAreaMetaData:{
			filter:"PostAreaMetaDataWhere",
			orderBy:"PostAreaMetaDataOrderBy"
		},
		paginatePostAreaMetaData:{
			filter:"PostAreaMetaDataWhere",
			orderBy:"PostAreaMetaDataOrderBy"
		},
		getPostMetaData:{
			by:"PostMetaDataUniqueWhere",
			filter:"PostMetaDataWhere"
		},
		listPostMetaData:{
			filter:"PostMetaDataWhere",
			orderBy:"PostMetaDataOrderBy"
		},
		paginatePostMetaData:{
			filter:"PostMetaDataWhere",
			orderBy:"PostMetaDataOrderBy"
		},
		getPostOrganizationMetaData:{
			by:"PostOrganizationMetaDataUniqueWhere",
			filter:"PostOrganizationMetaDataWhere"
		},
		listPostOrganizationMetaData:{
			filter:"PostOrganizationMetaDataWhere",
			orderBy:"PostOrganizationMetaDataOrderBy"
		},
		paginatePostOrganizationMetaData:{
			filter:"PostOrganizationMetaDataWhere",
			orderBy:"PostOrganizationMetaDataOrderBy"
		},
		getTileItem:{
			by:"TileItemUniqueWhere",
			filter:"TileItemWhere"
		},
		listTileItem:{
			filter:"TileItemWhere",
			orderBy:"TileItemOrderBy"
		},
		paginateTileItem:{
			filter:"TileItemWhere",
			orderBy:"TileItemOrderBy"
		},
		validateCreateTileItem:{
			data:"TileItemCreateInput"
		},
		validateUpdateTileItem:{
			by:"TileItemUniqueWhere",
			data:"TileItemUpdateInput"
		},
		getTileList:{
			by:"TileListUniqueWhere",
			filter:"TileListWhere"
		},
		listTileList:{
			filter:"TileListWhere",
			orderBy:"TileListOrderBy"
		},
		paginateTileList:{
			filter:"TileListWhere",
			orderBy:"TileListOrderBy"
		},
		validateCreateTileList:{
			data:"TileListCreateInput"
		},
		validateUpdateTileList:{
			by:"TileListUniqueWhere",
			data:"TileListUpdateInput"
		},
		getFeedPage:{
			by:"FeedPageUniqueWhere",
			filter:"FeedPageWhere"
		},
		listFeedPage:{
			filter:"FeedPageWhere",
			orderBy:"FeedPageOrderBy"
		},
		paginateFeedPage:{
			filter:"FeedPageWhere",
			orderBy:"FeedPageOrderBy"
		},
		validateCreateFeedPage:{
			data:"FeedPageCreateInput"
		},
		validateUpdateFeedPage:{
			by:"FeedPageUniqueWhere",
			data:"FeedPageUpdateInput"
		},
		getFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		listFeedPageLocale:{
			filter:"FeedPageLocaleWhere",
			orderBy:"FeedPageLocaleOrderBy"
		},
		paginateFeedPageLocale:{
			filter:"FeedPageLocaleWhere",
			orderBy:"FeedPageLocaleOrderBy"
		},
		validateCreateFeedPageLocale:{
			data:"FeedPageLocaleCreateInput"
		},
		validateUpdateFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			data:"FeedPageLocaleUpdateInput"
		},
		getFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			filter:"FeedPageSectionWhere"
		},
		listFeedPageSection:{
			filter:"FeedPageSectionWhere",
			orderBy:"FeedPageSectionOrderBy"
		},
		paginateFeedPageSection:{
			filter:"FeedPageSectionWhere",
			orderBy:"FeedPageSectionOrderBy"
		},
		validateCreateFeedPageSection:{
			data:"FeedPageSectionCreateInput"
		},
		validateUpdateFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			data:"FeedPageSectionUpdateInput"
		},
		getFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			filter:"FeedPageTileStripeWhere"
		},
		listFeedPageTileStripe:{
			filter:"FeedPageTileStripeWhere",
			orderBy:"FeedPageTileStripeOrderBy"
		},
		paginateFeedPageTileStripe:{
			filter:"FeedPageTileStripeWhere",
			orderBy:"FeedPageTileStripeOrderBy"
		},
		validateCreateFeedPageTileStripe:{
			data:"FeedPageTileStripeCreateInput"
		},
		validateUpdateFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			data:"FeedPageTileStripeUpdateInput"
		},
		getCardItem:{
			by:"CardItemUniqueWhere",
			filter:"CardItemWhere"
		},
		listCardItem:{
			filter:"CardItemWhere",
			orderBy:"CardItemOrderBy"
		},
		paginateCardItem:{
			filter:"CardItemWhere",
			orderBy:"CardItemOrderBy"
		},
		validateCreateCardItem:{
			data:"CardItemCreateInput"
		},
		validateUpdateCardItem:{
			by:"CardItemUniqueWhere",
			data:"CardItemUpdateInput"
		},
		getCardList:{
			by:"CardListUniqueWhere",
			filter:"CardListWhere"
		},
		listCardList:{
			filter:"CardListWhere",
			orderBy:"CardListOrderBy"
		},
		paginateCardList:{
			filter:"CardListWhere",
			orderBy:"CardListOrderBy"
		},
		validateCreateCardList:{
			data:"CardListCreateInput"
		},
		validateUpdateCardList:{
			by:"CardListUniqueWhere",
			data:"CardListUpdateInput"
		},
		getOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			filter:"OnBehalfDonationWhere"
		},
		listOnBehalfDonation:{
			filter:"OnBehalfDonationWhere",
			orderBy:"OnBehalfDonationOrderBy"
		},
		paginateOnBehalfDonation:{
			filter:"OnBehalfDonationWhere",
			orderBy:"OnBehalfDonationOrderBy"
		},
		validateCreateOnBehalfDonation:{
			data:"OnBehalfDonationCreateInput"
		},
		validateUpdateOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			data:"OnBehalfDonationUpdateInput"
		},
		getUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			filter:"UserPaymentTriesCollectionWhere"
		},
		listUserPaymentTriesCollection:{
			filter:"UserPaymentTriesCollectionWhere",
			orderBy:"UserPaymentTriesCollectionOrderBy"
		},
		paginateUserPaymentTriesCollection:{
			filter:"UserPaymentTriesCollectionWhere",
			orderBy:"UserPaymentTriesCollectionOrderBy"
		},
		validateCreateUserPaymentTriesCollection:{
			data:"UserPaymentTriesCollectionCreateInput"
		},
		validateUpdateUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			data:"UserPaymentTriesCollectionUpdateInput"
		},
		getRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			filter:"RecurringPaymentPageWhere"
		},
		listRecurringPaymentPage:{
			filter:"RecurringPaymentPageWhere",
			orderBy:"RecurringPaymentPageOrderBy"
		},
		paginateRecurringPaymentPage:{
			filter:"RecurringPaymentPageWhere",
			orderBy:"RecurringPaymentPageOrderBy"
		},
		validateCreateRecurringPaymentPage:{
			data:"RecurringPaymentPageCreateInput"
		},
		validateUpdateRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			data:"RecurringPaymentPageUpdateInput"
		},
		getRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		listRecurringPaymentPageLocale:{
			filter:"RecurringPaymentPageLocaleWhere",
			orderBy:"RecurringPaymentPageLocaleOrderBy"
		},
		paginateRecurringPaymentPageLocale:{
			filter:"RecurringPaymentPageLocaleWhere",
			orderBy:"RecurringPaymentPageLocaleOrderBy"
		},
		validateCreateRecurringPaymentPageLocale:{
			data:"RecurringPaymentPageLocaleCreateInput"
		},
		validateUpdateRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			data:"RecurringPaymentPageLocaleUpdateInput"
		},
		getStoryGuide:{
			by:"StoryGuideUniqueWhere",
			filter:"StoryGuideWhere"
		},
		listStoryGuide:{
			filter:"StoryGuideWhere",
			orderBy:"StoryGuideOrderBy"
		},
		paginateStoryGuide:{
			filter:"StoryGuideWhere",
			orderBy:"StoryGuideOrderBy"
		},
		validateCreateStoryGuide:{
			data:"StoryGuideCreateInput"
		},
		validateUpdateStoryGuide:{
			by:"StoryGuideUniqueWhere",
			data:"StoryGuideUpdateInput"
		},
		getStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			filter:"StoryGuideItemWhere"
		},
		listStoryGuideItem:{
			filter:"StoryGuideItemWhere",
			orderBy:"StoryGuideItemOrderBy"
		},
		paginateStoryGuideItem:{
			filter:"StoryGuideItemWhere",
			orderBy:"StoryGuideItemOrderBy"
		},
		validateCreateStoryGuideItem:{
			data:"StoryGuideItemCreateInput"
		},
		validateUpdateStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			data:"StoryGuideItemUpdateInput"
		},
		getStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			filter:"StoryGuideListWhere"
		},
		listStoryGuideList:{
			filter:"StoryGuideListWhere",
			orderBy:"StoryGuideListOrderBy"
		},
		paginateStoryGuideList:{
			filter:"StoryGuideListWhere",
			orderBy:"StoryGuideListOrderBy"
		},
		validateCreateStoryGuideList:{
			data:"StoryGuideListCreateInput"
		},
		validateUpdateStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			data:"StoryGuideListUpdateInput"
		},
		getStripePaymentMetadata:{
			by:"StripePaymentMetadataUniqueWhere",
			filter:"StripePaymentMetadataWhere"
		},
		listStripePaymentMetadata:{
			filter:"StripePaymentMetadataWhere",
			orderBy:"StripePaymentMetadataOrderBy"
		},
		paginateStripePaymentMetadata:{
			filter:"StripePaymentMetadataWhere",
			orderBy:"StripePaymentMetadataOrderBy"
		},
		getOnBehalfDonationMetadata:{
			by:"OnBehalfDonationMetadataUniqueWhere",
			filter:"OnBehalfDonationMetadataWhere"
		},
		listOnBehalfDonationMetadata:{
			filter:"OnBehalfDonationMetadataWhere",
			orderBy:"OnBehalfDonationMetadataOrderBy"
		},
		paginateOnBehalfDonationMetadata:{
			filter:"OnBehalfDonationMetadataWhere",
			orderBy:"OnBehalfDonationMetadataOrderBy"
		},
		getUserPaymentTriesCollectionMetadata:{
			by:"UserPaymentTriesCollectionMetadataUniqueWhere",
			filter:"UserPaymentTriesCollectionMetadataWhere"
		},
		listUserPaymentTriesCollectionMetadata:{
			filter:"UserPaymentTriesCollectionMetadataWhere",
			orderBy:"UserPaymentTriesCollectionMetadataOrderBy"
		},
		paginateUserPaymentTriesCollectionMetadata:{
			filter:"UserPaymentTriesCollectionMetadataWhere",
			orderBy:"UserPaymentTriesCollectionMetadataOrderBy"
		},
		getUserPaymentTriesCollectionMetadataLocale:{
			by:"UserPaymentTriesCollectionMetadataLocaleUniqueWhere",
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere"
		},
		listUserPaymentTriesCollectionMetadataLocale:{
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere",
			orderBy:"UserPaymentTriesCollectionMetadataLocaleOrderBy"
		},
		paginateUserPaymentTriesCollectionMetadataLocale:{
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere",
			orderBy:"UserPaymentTriesCollectionMetadataLocaleOrderBy"
		},
		getCsobPaymentMetadata:{
			by:"CsobPaymentMetadataUniqueWhere",
			filter:"CsobPaymentMetadataWhere"
		},
		listCsobPaymentMetadata:{
			filter:"CsobPaymentMetadataWhere",
			orderBy:"CsobPaymentMetadataOrderBy"
		},
		paginateCsobPaymentMetadata:{
			filter:"CsobPaymentMetadataWhere",
			orderBy:"CsobPaymentMetadataOrderBy"
		},
		getHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			filter:"HeroCarouselWhere"
		},
		listHeroCarousel:{
			filter:"HeroCarouselWhere",
			orderBy:"HeroCarouselOrderBy"
		},
		paginateHeroCarousel:{
			filter:"HeroCarouselWhere",
			orderBy:"HeroCarouselOrderBy"
		},
		validateCreateHeroCarousel:{
			data:"HeroCarouselCreateInput"
		},
		validateUpdateHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			data:"HeroCarouselUpdateInput"
		},
		getPostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			filter:"PostOrganizationListWhere"
		},
		listPostOrganizationList:{
			filter:"PostOrganizationListWhere",
			orderBy:"PostOrganizationListOrderBy"
		},
		paginatePostOrganizationList:{
			filter:"PostOrganizationListWhere",
			orderBy:"PostOrganizationListOrderBy"
		},
		validateCreatePostOrganizationList:{
			data:"PostOrganizationListCreateInput"
		},
		validateUpdatePostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			data:"PostOrganizationListUpdateInput"
		},
		getPostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			filter:"PostOrganizationListItemWhere"
		},
		listPostOrganizationListItem:{
			filter:"PostOrganizationListItemWhere",
			orderBy:"PostOrganizationListItemOrderBy"
		},
		paginatePostOrganizationListItem:{
			filter:"PostOrganizationListItemWhere",
			orderBy:"PostOrganizationListItemOrderBy"
		},
		validateCreatePostOrganizationListItem:{
			data:"PostOrganizationListItemCreateInput"
		},
		validateUpdatePostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			data:"PostOrganizationListItemUpdateInput"
		},
		getInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			filter:"InfoCarouselWhere"
		},
		listInfoCarousel:{
			filter:"InfoCarouselWhere",
			orderBy:"InfoCarouselOrderBy"
		},
		paginateInfoCarousel:{
			filter:"InfoCarouselWhere",
			orderBy:"InfoCarouselOrderBy"
		},
		validateCreateInfoCarousel:{
			data:"InfoCarouselCreateInput"
		},
		validateUpdateInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			data:"InfoCarouselUpdateInput"
		},
		getInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			filter:"InfoCarouselItemWhere"
		},
		listInfoCarouselItem:{
			filter:"InfoCarouselItemWhere",
			orderBy:"InfoCarouselItemOrderBy"
		},
		paginateInfoCarouselItem:{
			filter:"InfoCarouselItemWhere",
			orderBy:"InfoCarouselItemOrderBy"
		},
		validateCreateInfoCarouselItem:{
			data:"InfoCarouselItemCreateInput"
		},
		validateUpdateInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			data:"InfoCarouselItemUpdateInput"
		},
		getPersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere"
		},
		listPersonSeenInfoCarousel:{
			filter:"PersonSeenInfoCarouselWhere",
			orderBy:"PersonSeenInfoCarouselOrderBy"
		},
		paginatePersonSeenInfoCarousel:{
			filter:"PersonSeenInfoCarouselWhere",
			orderBy:"PersonSeenInfoCarouselOrderBy"
		},
		validateCreatePersonSeenInfoCarousel:{
			data:"PersonSeenInfoCarouselCreateInput"
		},
		validateUpdatePersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			data:"PersonSeenInfoCarouselUpdateInput"
		},
		getGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			filter:"GivenGiftsPageWhere"
		},
		listGivenGiftsPage:{
			filter:"GivenGiftsPageWhere",
			orderBy:"GivenGiftsPageOrderBy"
		},
		paginateGivenGiftsPage:{
			filter:"GivenGiftsPageWhere",
			orderBy:"GivenGiftsPageOrderBy"
		},
		validateCreateGivenGiftsPage:{
			data:"GivenGiftsPageCreateInput"
		},
		validateUpdateGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			data:"GivenGiftsPageUpdateInput"
		},
		getGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		listGivenGiftsPageLocale:{
			filter:"GivenGiftsPageLocaleWhere",
			orderBy:"GivenGiftsPageLocaleOrderBy"
		},
		paginateGivenGiftsPageLocale:{
			filter:"GivenGiftsPageLocaleWhere",
			orderBy:"GivenGiftsPageLocaleOrderBy"
		},
		validateCreateGivenGiftsPageLocale:{
			data:"GivenGiftsPageLocaleCreateInput"
		},
		validateUpdateGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			data:"GivenGiftsPageLocaleUpdateInput"
		},
		getReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			filter:"ReceivedGiftsPageWhere"
		},
		listReceivedGiftsPage:{
			filter:"ReceivedGiftsPageWhere",
			orderBy:"ReceivedGiftsPageOrderBy"
		},
		paginateReceivedGiftsPage:{
			filter:"ReceivedGiftsPageWhere",
			orderBy:"ReceivedGiftsPageOrderBy"
		},
		validateCreateReceivedGiftsPage:{
			data:"ReceivedGiftsPageCreateInput"
		},
		validateUpdateReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			data:"ReceivedGiftsPageUpdateInput"
		},
		getReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		listReceivedGiftsPageLocale:{
			filter:"ReceivedGiftsPageLocaleWhere",
			orderBy:"ReceivedGiftsPageLocaleOrderBy"
		},
		paginateReceivedGiftsPageLocale:{
			filter:"ReceivedGiftsPageLocaleWhere",
			orderBy:"ReceivedGiftsPageLocaleOrderBy"
		},
		validateCreateReceivedGiftsPageLocale:{
			data:"ReceivedGiftsPageLocaleCreateInput"
		},
		validateUpdateReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			data:"ReceivedGiftsPageLocaleUpdateInput"
		},
		getReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			filter:"ReportNavigationWhere"
		},
		listReportNavigation:{
			filter:"ReportNavigationWhere",
			orderBy:"ReportNavigationOrderBy"
		},
		paginateReportNavigation:{
			filter:"ReportNavigationWhere",
			orderBy:"ReportNavigationOrderBy"
		},
		validateCreateReportNavigation:{
			data:"ReportNavigationCreateInput"
		},
		validateUpdateReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			data:"ReportNavigationUpdateInput"
		},
		getReportPage:{
			by:"ReportPageUniqueWhere",
			filter:"ReportPageWhere"
		},
		listReportPage:{
			filter:"ReportPageWhere",
			orderBy:"ReportPageOrderBy"
		},
		paginateReportPage:{
			filter:"ReportPageWhere",
			orderBy:"ReportPageOrderBy"
		},
		validateCreateReportPage:{
			data:"ReportPageCreateInput"
		},
		validateUpdateReportPage:{
			by:"ReportPageUniqueWhere",
			data:"ReportPageUpdateInput"
		},
		getReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		listReportPageLocale:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		paginateReportPageLocale:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		validateCreateReportPageLocale:{
			data:"ReportPageLocaleCreateInput"
		},
		validateUpdateReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			data:"ReportPageLocaleUpdateInput"
		},
		getReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere"
		},
		listReportNavigationLocale:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		},
		paginateReportNavigationLocale:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		},
		validateCreateReportNavigationLocale:{
			data:"ReportNavigationLocaleCreateInput"
		},
		validateUpdateReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			data:"ReportNavigationLocaleUpdateInput"
		},
		getSentPayment:{
			by:"SentPaymentUniqueWhere",
			filter:"SentPaymentWhere"
		},
		listSentPayment:{
			filter:"SentPaymentWhere",
			orderBy:"SentPaymentOrderBy"
		},
		paginateSentPayment:{
			filter:"SentPaymentWhere",
			orderBy:"SentPaymentOrderBy"
		},
		validateCreateSentPayment:{
			data:"SentPaymentCreateInput"
		},
		validateUpdateSentPayment:{
			by:"SentPaymentUniqueWhere",
			data:"SentPaymentUpdateInput"
		},
		getPostAreaSentPaymentCurrencySum:{
			by:"PostAreaSentPaymentCurrencySumUniqueWhere",
			filter:"PostAreaSentPaymentCurrencySumWhere"
		},
		listPostAreaSentPaymentCurrencySum:{
			filter:"PostAreaSentPaymentCurrencySumWhere",
			orderBy:"PostAreaSentPaymentCurrencySumOrderBy"
		},
		paginatePostAreaSentPaymentCurrencySum:{
			filter:"PostAreaSentPaymentCurrencySumWhere",
			orderBy:"PostAreaSentPaymentCurrencySumOrderBy"
		},
		getPostAreaSentPaymentSum:{
			by:"PostAreaSentPaymentSumUniqueWhere",
			filter:"PostAreaSentPaymentSumWhere"
		},
		listPostAreaSentPaymentSum:{
			filter:"PostAreaSentPaymentSumWhere",
			orderBy:"PostAreaSentPaymentSumOrderBy"
		},
		paginatePostAreaSentPaymentSum:{
			filter:"PostAreaSentPaymentSumWhere",
			orderBy:"PostAreaSentPaymentSumOrderBy"
		},
		getNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			filter:"NotificationTargetGroupWhere"
		},
		listNotificationTargetGroup:{
			filter:"NotificationTargetGroupWhere",
			orderBy:"NotificationTargetGroupOrderBy"
		},
		paginateNotificationTargetGroup:{
			filter:"NotificationTargetGroupWhere",
			orderBy:"NotificationTargetGroupOrderBy"
		},
		validateCreateNotificationTargetGroup:{
			data:"NotificationTargetGroupCreateInput"
		},
		validateUpdateNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			data:"NotificationTargetGroupUpdateInput"
		},
		getProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationWhere"
		},
		listProcessedNotification:{
			filter:"ProcessedNotificationWhere",
			orderBy:"ProcessedNotificationOrderBy"
		},
		paginateProcessedNotification:{
			filter:"ProcessedNotificationWhere",
			orderBy:"ProcessedNotificationOrderBy"
		},
		validateCreateProcessedNotification:{
			data:"ProcessedNotificationCreateInput"
		},
		validateUpdateProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			data:"ProcessedNotificationUpdateInput"
		},
		getScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			filter:"ScheduledNotificationWhere"
		},
		listScheduledNotification:{
			filter:"ScheduledNotificationWhere",
			orderBy:"ScheduledNotificationOrderBy"
		},
		paginateScheduledNotification:{
			filter:"ScheduledNotificationWhere",
			orderBy:"ScheduledNotificationOrderBy"
		},
		validateCreateScheduledNotification:{
			data:"ScheduledNotificationCreateInput"
		},
		validateUpdateScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			data:"ScheduledNotificationUpdateInput"
		},
		getProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			filter:"ProcessedNotificationSourceWhere"
		},
		listProcessedNotificationSource:{
			filter:"ProcessedNotificationSourceWhere",
			orderBy:"ProcessedNotificationSourceOrderBy"
		},
		paginateProcessedNotificationSource:{
			filter:"ProcessedNotificationSourceWhere",
			orderBy:"ProcessedNotificationSourceOrderBy"
		},
		validateCreateProcessedNotificationSource:{
			data:"ProcessedNotificationSourceCreateInput"
		},
		validateUpdateProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			data:"ProcessedNotificationSourceUpdateInput"
		},
		getDevice:{
			by:"DeviceUniqueWhere",
			filter:"DeviceWhere"
		},
		listDevice:{
			filter:"DeviceWhere",
			orderBy:"DeviceOrderBy"
		},
		paginateDevice:{
			filter:"DeviceWhere",
			orderBy:"DeviceOrderBy"
		},
		validateCreateDevice:{
			data:"DeviceCreateInput"
		},
		validateUpdateDevice:{
			by:"DeviceUniqueWhere",
			data:"DeviceUpdateInput"
		},
		getScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere"
		},
		listScheduledNotificationLocale:{
			filter:"ScheduledNotificationLocaleWhere",
			orderBy:"ScheduledNotificationLocaleOrderBy"
		},
		paginateScheduledNotificationLocale:{
			filter:"ScheduledNotificationLocaleWhere",
			orderBy:"ScheduledNotificationLocaleOrderBy"
		},
		validateCreateScheduledNotificationLocale:{
			data:"ScheduledNotificationLocaleCreateInput"
		},
		validateUpdateScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			data:"ScheduledNotificationLocaleUpdateInput"
		},
		getInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere"
		},
		listInfoCarouselItemLocale:{
			filter:"InfoCarouselItemLocaleWhere",
			orderBy:"InfoCarouselItemLocaleOrderBy"
		},
		paginateInfoCarouselItemLocale:{
			filter:"InfoCarouselItemLocaleWhere",
			orderBy:"InfoCarouselItemLocaleOrderBy"
		},
		validateCreateInfoCarouselItemLocale:{
			data:"InfoCarouselItemLocaleCreateInput"
		},
		validateUpdateInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			data:"InfoCarouselItemLocaleUpdateInput"
		},
		getSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere"
		},
		listSentPaymentLocale:{
			filter:"SentPaymentLocaleWhere",
			orderBy:"SentPaymentLocaleOrderBy"
		},
		paginateSentPaymentLocale:{
			filter:"SentPaymentLocaleWhere",
			orderBy:"SentPaymentLocaleOrderBy"
		},
		validateCreateSentPaymentLocale:{
			data:"SentPaymentLocaleCreateInput"
		},
		validateUpdateSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			data:"SentPaymentLocaleUpdateInput"
		},
		getUserPaymentMetadata:{
			by:"UserPaymentMetadataUniqueWhere",
			filter:"UserPaymentMetadataWhere"
		},
		listUserPaymentMetadata:{
			filter:"UserPaymentMetadataWhere",
			orderBy:"UserPaymentMetadataOrderBy"
		},
		paginateUserPaymentMetadata:{
			filter:"UserPaymentMetadataWhere",
			orderBy:"UserPaymentMetadataOrderBy"
		},
		getPostAreaCurrencySum:{
			by:"PostAreaCurrencySumUniqueWhere",
			filter:"PostAreaCurrencySumWhere"
		},
		listPostAreaCurrencySum:{
			filter:"PostAreaCurrencySumWhere",
			orderBy:"PostAreaCurrencySumOrderBy"
		},
		paginatePostAreaCurrencySum:{
			filter:"PostAreaCurrencySumWhere",
			orderBy:"PostAreaCurrencySumOrderBy"
		},
		getPostAreaSum:{
			by:"PostAreaSumUniqueWhere",
			filter:"PostAreaSumWhere"
		},
		listPostAreaSum:{
			filter:"PostAreaSumWhere",
			orderBy:"PostAreaSumOrderBy"
		},
		paginatePostAreaSum:{
			filter:"PostAreaSumWhere",
			orderBy:"PostAreaSumOrderBy"
		},
		getPostOrganizationCurrencySum:{
			by:"PostOrganizationCurrencySumUniqueWhere",
			filter:"PostOrganizationCurrencySumWhere"
		},
		listPostOrganizationCurrencySum:{
			filter:"PostOrganizationCurrencySumWhere",
			orderBy:"PostOrganizationCurrencySumOrderBy"
		},
		paginatePostOrganizationCurrencySum:{
			filter:"PostOrganizationCurrencySumWhere",
			orderBy:"PostOrganizationCurrencySumOrderBy"
		},
		getPostOrganizationSum:{
			by:"PostOrganizationSumUniqueWhere",
			filter:"PostOrganizationSumWhere"
		},
		listPostOrganizationSum:{
			filter:"PostOrganizationSumWhere",
			orderBy:"PostOrganizationSumOrderBy"
		},
		paginatePostOrganizationSum:{
			filter:"PostOrganizationSumWhere",
			orderBy:"PostOrganizationSumOrderBy"
		},
		getStats:{
			by:"StatsUniqueWhere",
			filter:"StatsWhere"
		},
		listStats:{
			filter:"StatsWhere",
			orderBy:"StatsOrderBy"
		},
		paginateStats:{
			filter:"StatsWhere",
			orderBy:"StatsOrderBy"
		},
		getUserRecurringPaymentItemMetadata:{
			by:"UserRecurringPaymentItemMetadataUniqueWhere",
			filter:"UserRecurringPaymentItemMetadataWhere"
		},
		listUserRecurringPaymentItemMetadata:{
			filter:"UserRecurringPaymentItemMetadataWhere",
			orderBy:"UserRecurringPaymentItemMetadataOrderBy"
		},
		paginateUserRecurringPaymentItemMetadata:{
			filter:"UserRecurringPaymentItemMetadataWhere",
			orderBy:"UserRecurringPaymentItemMetadataOrderBy"
		},
		getUpcomingUserRecurringPaymentMetadata:{
			by:"UpcomingUserRecurringPaymentMetadataUniqueWhere",
			filter:"UpcomingUserRecurringPaymentMetadataWhere"
		},
		listUpcomingUserRecurringPaymentMetadata:{
			filter:"UpcomingUserRecurringPaymentMetadataWhere",
			orderBy:"UpcomingUserRecurringPaymentMetadataOrderBy"
		},
		paginateUpcomingUserRecurringPaymentMetadata:{
			filter:"UpcomingUserRecurringPaymentMetadataWhere",
			orderBy:"UpcomingUserRecurringPaymentMetadataOrderBy"
		},
		getUserAreaStats:{
			by:"UserAreaStatsUniqueWhere",
			filter:"UserAreaStatsWhere"
		},
		listUserAreaStats:{
			filter:"UserAreaStatsWhere",
			orderBy:"UserAreaStatsOrderBy"
		},
		paginateUserAreaStats:{
			filter:"UserAreaStatsWhere",
			orderBy:"UserAreaStatsOrderBy"
		},
		getUserCurrencyStats:{
			by:"UserCurrencyStatsUniqueWhere",
			filter:"UserCurrencyStatsWhere"
		},
		listUserCurrencyStats:{
			filter:"UserCurrencyStatsWhere",
			orderBy:"UserCurrencyStatsOrderBy"
		},
		paginateUserCurrencyStats:{
			filter:"UserCurrencyStatsWhere",
			orderBy:"UserCurrencyStatsOrderBy"
		},
		getUserOrganizationStats:{
			by:"UserOrganizationStatsUniqueWhere",
			filter:"UserOrganizationStatsWhere"
		},
		listUserOrganizationStats:{
			filter:"UserOrganizationStatsWhere",
			orderBy:"UserOrganizationStatsOrderBy"
		},
		paginateUserOrganizationStats:{
			filter:"UserOrganizationStatsWhere",
			orderBy:"UserOrganizationStatsOrderBy"
		},
		getUserPostStats:{
			by:"UserPostStatsUniqueWhere",
			filter:"UserPostStatsWhere"
		},
		listUserPostStats:{
			filter:"UserPostStatsWhere",
			orderBy:"UserPostStatsOrderBy"
		},
		paginateUserPostStats:{
			filter:"UserPostStatsWhere",
			orderBy:"UserPostStatsOrderBy"
		},
		getUserStats:{
			by:"UserStatsUniqueWhere",
			filter:"UserStatsWhere"
		},
		listUserStats:{
			filter:"UserStatsWhere",
			orderBy:"UserStatsOrderBy"
		},
		paginateUserStats:{
			filter:"UserStatsWhere",
			orderBy:"UserStatsOrderBy"
		},
		getTextImageList:{
			by:"TextImageListUniqueWhere",
			filter:"TextImageListWhere"
		},
		listTextImageList:{
			filter:"TextImageListWhere",
			orderBy:"TextImageListOrderBy"
		},
		paginateTextImageList:{
			filter:"TextImageListWhere",
			orderBy:"TextImageListOrderBy"
		},
		validateCreateTextImageList:{
			data:"TextImageListCreateInput"
		},
		validateUpdateTextImageList:{
			by:"TextImageListUniqueWhere",
			data:"TextImageListUpdateInput"
		},
		getTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			filter:"TextImageListItemWhere"
		},
		listTextImageListItem:{
			filter:"TextImageListItemWhere",
			orderBy:"TextImageListItemOrderBy"
		},
		paginateTextImageListItem:{
			filter:"TextImageListItemWhere",
			orderBy:"TextImageListItemOrderBy"
		},
		validateCreateTextImageListItem:{
			data:"TextImageListItemCreateInput"
		},
		validateUpdateTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			data:"TextImageListItemUpdateInput"
		},
		getPostCurrencySum:{
			by:"PostCurrencySumUniqueWhere",
			filter:"PostCurrencySumWhere"
		},
		listPostCurrencySum:{
			filter:"PostCurrencySumWhere",
			orderBy:"PostCurrencySumOrderBy"
		},
		paginatePostCurrencySum:{
			filter:"PostCurrencySumWhere",
			orderBy:"PostCurrencySumOrderBy"
		},
		getPostSum:{
			by:"PostSumUniqueWhere",
			filter:"PostSumWhere"
		},
		listPostSum:{
			filter:"PostSumWhere",
			orderBy:"PostSumOrderBy"
		},
		paginatePostSum:{
			filter:"PostSumWhere",
			orderBy:"PostSumOrderBy"
		},
		getPostFundraisingProgress:{
			by:"PostFundraisingProgressUniqueWhere",
			filter:"PostFundraisingProgressWhere"
		},
		listPostFundraisingProgress:{
			filter:"PostFundraisingProgressWhere",
			orderBy:"PostFundraisingProgressOrderBy"
		},
		paginatePostFundraisingProgress:{
			filter:"PostFundraisingProgressWhere",
			orderBy:"PostFundraisingProgressOrderBy"
		},
		getHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			filter:"HeroCarouselItemWhere"
		},
		listHeroCarouselItem:{
			filter:"HeroCarouselItemWhere",
			orderBy:"HeroCarouselItemOrderBy"
		},
		paginateHeroCarouselItem:{
			filter:"HeroCarouselItemWhere",
			orderBy:"HeroCarouselItemOrderBy"
		},
		validateCreateHeroCarouselItem:{
			data:"HeroCarouselItemCreateInput"
		},
		validateUpdateHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			data:"HeroCarouselItemUpdateInput"
		}
	},
	General:{
		locales:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		allAreasIcon:{
			filter:"ImageWhere"
		},
		allOrganizationsIcon:{
			filter:"ImageWhere"
		},
		organizationList:{
			filter:"PostOrganizationListWhere"
		},
		localesByLocale:{
			by:"GeneralLocalesByLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		localesBySeo:{
			by:"GeneralLocalesBySeoUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		localesByAppStoreLink:{
			by:"GeneralLocalesByAppStoreLinkUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		localesByGooglePlayLink:{
			by:"GeneralLocalesByGooglePlayLinkUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		paginateLocales:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		}
	},
	UUID: `scalar.UUID` as const,
	One: "enum" as const,
	GeneralLocale:{
		root:{
			filter:"GeneralWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		appStoreLink:{
			filter:"LinkWhere"
		},
		googlePlayLink:{
			filter:"LinkWhere"
		}
	},
	GeneralWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"GeneralLocaleWhere",
		allAreasIcon:"ImageWhere",
		allOrganizationsIcon:"ImageWhere",
		organizationList:"PostOrganizationListWhere",
		and:"GeneralWhere",
		or:"GeneralWhere",
		not:"GeneralWhere"
	},
	UUIDCondition:{
		and:"UUIDCondition",
		or:"UUIDCondition",
		not:"UUIDCondition",
		eq:"UUID",
		notEq:"UUID",
		in:"UUID",
		notIn:"UUID",
		lt:"UUID",
		lte:"UUID",
		gt:"UUID",
		gte:"UUID"
	},
	OneCondition:{
		and:"OneCondition",
		or:"OneCondition",
		not:"OneCondition",
		eq:"One",
		notEq:"One",
		in:"One",
		notIn:"One",
		lt:"One",
		lte:"One",
		gt:"One",
		gte:"One"
	},
	GeneralLocaleWhere:{
		id:"UUIDCondition",
		root:"GeneralWhere",
		locale:"LocaleWhere",
		seo:"SeoWhere",
		appStoreLink:"LinkWhere",
		googlePlayLink:"LinkWhere",
		allAreasDescription:"StringCondition",
		allOrganizationsDescription:"StringCondition",
		and:"GeneralLocaleWhere",
		or:"GeneralLocaleWhere",
		not:"GeneralLocaleWhere"
	},
	LocaleWhere:{
		id:"UUIDCondition",
		code:"StringCondition",
		label:"StringCondition",
		order:"IntCondition",
		generals:"GeneralLocaleWhere",
		genericPages:"GenericPageLocaleWhere",
		posts:"PostLocaleWhere",
		postAreas:"PostAreaLocaleWhere",
		postOrganizations:"PostOrganizationLocaleWhere",
		headers:"HeaderLocaleWhere",
		footers:"FooterLocaleWhere",
		genericPageAboutSettings:"GenericPageAboutSettingsLocaleWhere",
		postRevisions:"PostRevisionLocaleWhere",
		flagImage:"ImageWhere",
		feedPages:"FeedPageLocaleWhere",
		recurringPaymentPages:"RecurringPaymentPageLocaleWhere",
		givenGiftsPages:"GivenGiftsPageLocaleWhere",
		receivedGiftsPages:"ReceivedGiftsPageLocaleWhere",
		reportPages:"ReportPageLocaleWhere",
		reportNavigations:"ReportNavigationLocaleWhere",
		scheduledNotifications:"ScheduledNotificationLocaleWhere",
		sentPayments:"SentPaymentLocaleWhere",
		and:"LocaleWhere",
		or:"LocaleWhere",
		not:"LocaleWhere"
	},
	StringCondition:{
		and:"StringCondition",
		or:"StringCondition",
		not:"StringCondition"
	},
	IntCondition:{
		and:"IntCondition",
		or:"IntCondition",
		not:"IntCondition"
	},
	GenericPageLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		root:"GenericPageWhere",
		locale:"LocaleWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		link:"LinkableWhere",
		subtitle:"StringCondition",
		and:"GenericPageLocaleWhere",
		or:"GenericPageLocaleWhere",
		not:"GenericPageLocaleWhere"
	},
	GenericPageWhere:{
		id:"UUIDCondition",
		locales:"GenericPageLocaleWhere",
		type:"GenericPageTypeCondition",
		order:"IntCondition",
		reportNavigation:"ReportNavigationLocaleWhere",
		and:"GenericPageWhere",
		or:"GenericPageWhere",
		not:"GenericPageWhere"
	},
	GenericPageTypeCondition:{
		and:"GenericPageTypeCondition",
		or:"GenericPageTypeCondition",
		not:"GenericPageTypeCondition",
		eq:"GenericPageType",
		notEq:"GenericPageType",
		in:"GenericPageType",
		notIn:"GenericPageType",
		lt:"GenericPageType",
		lte:"GenericPageType",
		gt:"GenericPageType",
		gte:"GenericPageType"
	},
	GenericPageType: "enum" as const,
	ReportNavigationLocaleWhere:{
		id:"UUIDCondition",
		root:"ReportNavigationWhere",
		locale:"LocaleWhere",
		pages:"GenericPageWhere",
		and:"ReportNavigationLocaleWhere",
		or:"ReportNavigationLocaleWhere",
		not:"ReportNavigationLocaleWhere"
	},
	ReportNavigationWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"ReportNavigationLocaleWhere",
		and:"ReportNavigationWhere",
		or:"ReportNavigationWhere",
		not:"ReportNavigationWhere"
	},
	ContentWhere:{
		id:"UUIDCondition",
		blocks:"ContentBlockWhere",
		and:"ContentWhere",
		or:"ContentWhere",
		not:"ContentWhere"
	},
	ContentBlockWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		json:"StringCondition",
		content:"ContentWhere",
		references:"ContentReferenceWhere",
		and:"ContentBlockWhere",
		or:"ContentBlockWhere",
		not:"ContentBlockWhere"
	},
	ContentReferenceWhere:{
		id:"UUIDCondition",
		type:"ContentReferenceTypeCondition",
		primaryText:"StringCondition",
		block:"ContentBlockWhere",
		image:"ImageWhere",
		linkables:"ContentReferenceLinkableItemWhere",
		video:"VideoWhere",
		secondaryText:"StringCondition",
		link:"LinkWhere",
		contentAlignment:"ContentAlignmentCondition",
		valueList:"ValueListWhere",
		imageLinkList:"ImageLinkListWhere",
		areaList:"PostAreaListWhere",
		isAppsVisible:"BooleanCondition",
		accordion:"AccordionWhere",
		media:"MediumListWhere",
		memberList:"MemberListWhere",
		asideMediaContentLayout:"AsideMediaContentLayoutCondition",
		isAsideMediaContentMobileLayout:"BooleanCondition",
		form:"FormWhere",
		isTitleBigger:"BooleanCondition",
		contentWithoutBlocks:"ContentWhere",
		heroCarousel:"HeroCarouselWhere",
		organizationList:"PostOrganizationListWhere",
		isCentered:"BooleanCondition",
		posts:"PostWhere",
		textImageList:"TextImageListWhere",
		and:"ContentReferenceWhere",
		or:"ContentReferenceWhere",
		not:"ContentReferenceWhere"
	},
	ContentReferenceTypeCondition:{
		and:"ContentReferenceTypeCondition",
		or:"ContentReferenceTypeCondition",
		not:"ContentReferenceTypeCondition",
		eq:"ContentReferenceType",
		notEq:"ContentReferenceType",
		in:"ContentReferenceType",
		notIn:"ContentReferenceType",
		lt:"ContentReferenceType",
		lte:"ContentReferenceType",
		gt:"ContentReferenceType",
		gte:"ContentReferenceType"
	},
	ContentReferenceType: "enum" as const,
	ImageWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		width:"IntCondition",
		height:"IntCondition",
		size:"IntCondition",
		type:"StringCondition",
		alt:"StringCondition",
		fileName:"StringCondition",
		focalPointX:"FloatCondition",
		focalPointY:"FloatCondition",
		and:"ImageWhere",
		or:"ImageWhere",
		not:"ImageWhere"
	},
	FloatCondition:{
		and:"FloatCondition",
		or:"FloatCondition",
		not:"FloatCondition"
	},
	ContentReferenceLinkableItemWhere:{
		id:"UUIDCondition",
		item:"LinkableWhere",
		reference:"ContentReferenceWhere",
		and:"ContentReferenceLinkableItemWhere",
		or:"ContentReferenceLinkableItemWhere",
		not:"ContentReferenceLinkableItemWhere"
	},
	LinkableWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		genericPage:"GenericPageLocaleWhere",
		post:"PostLocaleWhere",
		postArea:"PostAreaLocaleWhere",
		postOrganization:"PostOrganizationLocaleWhere",
		reportPage:"ReportPageLocaleWhere",
		givenGiftsPage:"GivenGiftsPageLocaleWhere",
		receivedGiftsPage:"ReceivedGiftsPageLocaleWhere",
		and:"LinkableWhere",
		or:"LinkableWhere",
		not:"LinkableWhere"
	},
	PostLocaleWhere:{
		id:"UUIDCondition",
		content:"ContentWhere",
		seo:"SeoWhere",
		link:"LinkableWhere",
		locale:"LocaleWhere",
		root:"PostWhere",
		paymentName:"StringCondition",
		publishedAt:"DateTimeCondition",
		and:"PostLocaleWhere",
		or:"PostLocaleWhere",
		not:"PostLocaleWhere"
	},
	SeoWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		description:"StringCondition",
		ogTitle:"StringCondition",
		ogDescription:"StringCondition",
		noIndex:"BooleanCondition",
		noFollow:"BooleanCondition",
		ogImage:"ImageWhere",
		and:"SeoWhere",
		or:"SeoWhere",
		not:"SeoWhere"
	},
	BooleanCondition:{
		and:"BooleanCondition",
		or:"BooleanCondition",
		not:"BooleanCondition"
	},
	PostWhere:{
		id:"UUIDCondition",
		organization:"PostOrganizationWhere",
		area:"PostAreaWhere",
		specificSymbol:"IntCondition",
		activeRevision:"PostRevisionWhere",
		revisions:"PostRevisionWhere",
		locales:"PostLocaleWhere",
		isPinnedInArea:"BooleanCondition",
		isPinnedInOrganization:"BooleanCondition",
		state:"PostStateCondition",
		meta:"PostMetaDataWhere",
		isPublishedAtHidden:"BooleanCondition",
		heroCarousel:"HeroCarouselWhere",
		reportPage:"ReportPageLocaleWhere",
		content:"ContentReferenceWhere",
		fundraiseIsActive:"BooleanCondition",
		fundraiseEndDate:"DateCondition",
		fundraiseTargetAmount:"IntCondition",
		fundraiseFakeAddOnAmount:"IntCondition",
		fundraiseCurrency:"CurrencyWhere",
		fundraiseCurrencySums:"PostCurrencySumWhere",
		fundraiseSum:"PostSumWhere",
		fundraisingProgress:"PostFundraisingProgressWhere",
		and:"PostWhere",
		or:"PostWhere",
		not:"PostWhere"
	},
	PostOrganizationWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		posts:"PostWhere",
		icon:"ImageWhere",
		locales:"PostOrganizationLocaleWhere",
		specificSymbol:"IntCondition",
		area:"PostAreaWhere",
		meta:"PostOrganizationMetaDataWhere",
		mobileHeroImage:"ImageWhere",
		isHidden:"BooleanCondition",
		color:"StringCondition",
		plainIcon:"ImageWhere",
		desktopHeroImage:"ImageWhere",
		sentPayments:"SentPaymentWhere",
		organizationCurrencySums:"PostOrganizationCurrencySumWhere",
		organizationSum:"PostOrganizationSumWhere",
		and:"PostOrganizationWhere",
		or:"PostOrganizationWhere",
		not:"PostOrganizationWhere"
	},
	PostOrganizationLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		description:"StringCondition",
		link:"LinkableWhere",
		root:"PostOrganizationWhere",
		locale:"LocaleWhere",
		domain:"LinkWhere",
		seo:"SeoWhere",
		content:"ContentWhere",
		translatedByAI:"BooleanCondition",
		and:"PostOrganizationLocaleWhere",
		or:"PostOrganizationLocaleWhere",
		not:"PostOrganizationLocaleWhere"
	},
	LinkWhere:{
		id:"UUIDCondition",
		type:"LinkEnumCondition",
		title:"StringCondition",
		externalLink:"StringCondition",
		internalLink:"LinkableWhere",
		isTargetBlank:"BooleanCondition",
		and:"LinkWhere",
		or:"LinkWhere",
		not:"LinkWhere"
	},
	LinkEnumCondition:{
		and:"LinkEnumCondition",
		or:"LinkEnumCondition",
		not:"LinkEnumCondition",
		eq:"LinkEnum",
		notEq:"LinkEnum",
		in:"LinkEnum",
		notIn:"LinkEnum",
		lt:"LinkEnum",
		lte:"LinkEnum",
		gt:"LinkEnum",
		gte:"LinkEnum"
	},
	LinkEnum: "enum" as const,
	PostAreaWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		icon:"ImageWhere",
		locales:"PostAreaLocaleWhere",
		regionListOverride:"DonationAmountsRegionListWhere",
		color:"StringCondition",
		posts:"PostWhere",
		specificSymbol:"IntCondition",
		region:"RegionWhere",
		meta:"PostAreaMetaDataWhere",
		mobileHeroImage:"ImageWhere",
		plainIcon:"ImageWhere",
		sentPayments:"SentPaymentWhere",
		areaSentPaymentCurrencySums:"PostAreaSentPaymentCurrencySumWhere",
		areaSentPaymentSum:"PostAreaSentPaymentSumWhere",
		areaCurrencySums:"PostAreaCurrencySumWhere",
		areaSum:"PostAreaSumWhere",
		and:"PostAreaWhere",
		or:"PostAreaWhere",
		not:"PostAreaWhere"
	},
	PostAreaLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		description:"StringCondition",
		link:"LinkableWhere",
		root:"PostAreaWhere",
		locale:"LocaleWhere",
		seo:"SeoWhere",
		banner:"AppBannerWhere",
		shortDescription:"StringCondition",
		content:"ContentWhere",
		translatedByAI:"BooleanCondition",
		and:"PostAreaLocaleWhere",
		or:"PostAreaLocaleWhere",
		not:"PostAreaLocaleWhere"
	},
	AppBannerWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		imageSmall:"ImageWhere",
		imageBig:"ImageWhere",
		textContent:"ContentWhere",
		and:"AppBannerWhere",
		or:"AppBannerWhere",
		not:"AppBannerWhere"
	},
	DonationAmountsRegionListWhere:{
		id:"UUIDCondition",
		regions:"DonationAmountsRegionItemWhere",
		donation:"DonationWhere",
		and:"DonationAmountsRegionListWhere",
		or:"DonationAmountsRegionListWhere",
		not:"DonationAmountsRegionListWhere"
	},
	DonationAmountsRegionItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		items:"DonationAmountItemWhere",
		list:"DonationAmountsRegionListWhere",
		region:"RegionWhere",
		minimumAmount:"FloatCondition",
		and:"DonationAmountsRegionItemWhere",
		or:"DonationAmountsRegionItemWhere",
		not:"DonationAmountsRegionItemWhere"
	},
	DonationAmountItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		amount:"FloatCondition",
		regionItem:"DonationAmountsRegionItemWhere",
		and:"DonationAmountItemWhere",
		or:"DonationAmountItemWhere",
		not:"DonationAmountItemWhere"
	},
	RegionWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		code:"StringCondition",
		label:"StringCondition",
		currency:"CurrencyWhere",
		enabledPaymentMethods:"RegionPaymentMethodWhere",
		donationItems:"DonationAmountsRegionItemWhere",
		timezone:"StringCondition",
		and:"RegionWhere",
		or:"RegionWhere",
		not:"RegionWhere"
	},
	CurrencyWhere:{
		id:"UUIDCondition",
		identifier:"CurrencyIdentifierCondition",
		label:"StringCondition",
		sign:"StringCondition",
		signAlignment:"CurrencySignAlignmentCondition",
		defaultDonationAmount:"IntCondition",
		rateAgainstCzk:"FloatCondition",
		areaSentPaymentCurrencySums:"PostAreaSentPaymentCurrencySumWhere",
		areaCurrencySums:"PostAreaCurrencySumWhere",
		organizationCurrencySums:"PostOrganizationCurrencySumWhere",
		postCurrencySums:"PostCurrencySumWhere",
		and:"CurrencyWhere",
		or:"CurrencyWhere",
		not:"CurrencyWhere"
	},
	CurrencyIdentifierCondition:{
		and:"CurrencyIdentifierCondition",
		or:"CurrencyIdentifierCondition",
		not:"CurrencyIdentifierCondition",
		eq:"CurrencyIdentifier",
		notEq:"CurrencyIdentifier",
		in:"CurrencyIdentifier",
		notIn:"CurrencyIdentifier",
		lt:"CurrencyIdentifier",
		lte:"CurrencyIdentifier",
		gt:"CurrencyIdentifier",
		gte:"CurrencyIdentifier"
	},
	CurrencyIdentifier: "enum" as const,
	CurrencySignAlignmentCondition:{
		and:"CurrencySignAlignmentCondition",
		or:"CurrencySignAlignmentCondition",
		not:"CurrencySignAlignmentCondition",
		eq:"CurrencySignAlignment",
		notEq:"CurrencySignAlignment",
		in:"CurrencySignAlignment",
		notIn:"CurrencySignAlignment",
		lt:"CurrencySignAlignment",
		lte:"CurrencySignAlignment",
		gt:"CurrencySignAlignment",
		gte:"CurrencySignAlignment"
	},
	CurrencySignAlignment: "enum" as const,
	PostAreaSentPaymentCurrencySumWhere:{
		id:"UUIDCondition",
		currencyIdentifier:"StringCondition",
		rateAgainstCzk:"FloatCondition",
		totalCents:"IntCondition",
		currency:"CurrencyWhere",
		area:"PostAreaWhere",
		and:"PostAreaSentPaymentCurrencySumWhere",
		or:"PostAreaSentPaymentCurrencySumWhere",
		not:"PostAreaSentPaymentCurrencySumWhere"
	},
	PostAreaCurrencySumWhere:{
		id:"UUIDCondition",
		currencyIdentifier:"StringCondition",
		rateAgainstCzk:"FloatCondition",
		totalCents:"IntCondition",
		currency:"CurrencyWhere",
		area:"PostAreaWhere",
		and:"PostAreaCurrencySumWhere",
		or:"PostAreaCurrencySumWhere",
		not:"PostAreaCurrencySumWhere"
	},
	PostOrganizationCurrencySumWhere:{
		id:"UUIDCondition",
		currencyIdentifier:"StringCondition",
		rateAgainstCzk:"FloatCondition",
		totalCents:"IntCondition",
		currency:"CurrencyWhere",
		organization:"PostOrganizationWhere",
		and:"PostOrganizationCurrencySumWhere",
		or:"PostOrganizationCurrencySumWhere",
		not:"PostOrganizationCurrencySumWhere"
	},
	PostCurrencySumWhere:{
		id:"UUIDCondition",
		currencyIdentifier:"StringCondition",
		rateAgainstCzk:"FloatCondition",
		totalCents:"IntCondition",
		currency:"CurrencyWhere",
		post:"PostWhere",
		and:"PostCurrencySumWhere",
		or:"PostCurrencySumWhere",
		not:"PostCurrencySumWhere"
	},
	RegionPaymentMethodWhere:{
		id:"UUIDCondition",
		allowRecurringPayments:"BooleanCondition",
		region:"RegionWhere",
		method:"PaymentMethodsCondition",
		order:"IntCondition",
		and:"RegionPaymentMethodWhere",
		or:"RegionPaymentMethodWhere",
		not:"RegionPaymentMethodWhere"
	},
	PaymentMethodsCondition:{
		and:"PaymentMethodsCondition",
		or:"PaymentMethodsCondition",
		not:"PaymentMethodsCondition",
		eq:"PaymentMethods",
		notEq:"PaymentMethods",
		in:"PaymentMethods",
		notIn:"PaymentMethods",
		lt:"PaymentMethods",
		lte:"PaymentMethods",
		gt:"PaymentMethods",
		gte:"PaymentMethods"
	},
	PaymentMethods: "enum" as const,
	DonationWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		regionList:"DonationAmountsRegionListWhere",
		and:"DonationWhere",
		or:"DonationWhere",
		not:"DonationWhere"
	},
	PostAreaMetaDataWhere:{
		id:"UUIDCondition",
		nameWithFallback:"StringCondition",
		formattedSpecificSymbol:"StringCondition",
		fullFormattedSpecificSymbol:"StringCondition",
		area:"PostAreaWhere",
		and:"PostAreaMetaDataWhere",
		or:"PostAreaMetaDataWhere",
		not:"PostAreaMetaDataWhere"
	},
	SentPaymentWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		cents:"IntCondition",
		sendAt:"DateTimeCondition",
		currency:"CurrencyWhere",
		area:"PostAreaWhere",
		organization:"PostOrganizationWhere",
		locales:"SentPaymentLocaleWhere",
		and:"SentPaymentWhere",
		or:"SentPaymentWhere",
		not:"SentPaymentWhere"
	},
	DateTimeCondition:{
		and:"DateTimeCondition",
		or:"DateTimeCondition",
		not:"DateTimeCondition",
		eq:"DateTime",
		notEq:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime"
	},
	DateTime: `scalar.DateTime` as const,
	SentPaymentLocaleWhere:{
		id:"UUIDCondition",
		organizationText:"StringCondition",
		root:"SentPaymentWhere",
		locale:"LocaleWhere",
		and:"SentPaymentLocaleWhere",
		or:"SentPaymentLocaleWhere",
		not:"SentPaymentLocaleWhere"
	},
	PostAreaSentPaymentSumWhere:{
		id:"UUIDCondition",
		totalCents:"IntCondition",
		czkPercentage:"FloatCondition",
		area:"PostAreaWhere",
		and:"PostAreaSentPaymentSumWhere",
		or:"PostAreaSentPaymentSumWhere",
		not:"PostAreaSentPaymentSumWhere"
	},
	PostAreaSumWhere:{
		id:"UUIDCondition",
		totalCents:"IntCondition",
		czkPercentage:"FloatCondition",
		area:"PostAreaWhere",
		and:"PostAreaSumWhere",
		or:"PostAreaSumWhere",
		not:"PostAreaSumWhere"
	},
	PostOrganizationMetaDataWhere:{
		id:"UUIDCondition",
		nameWithFallback:"StringCondition",
		formattedSpecificSymbol:"StringCondition",
		fullFormattedSpecificSymbol:"StringCondition",
		organization:"PostOrganizationWhere",
		and:"PostOrganizationMetaDataWhere",
		or:"PostOrganizationMetaDataWhere",
		not:"PostOrganizationMetaDataWhere"
	},
	PostOrganizationSumWhere:{
		id:"UUIDCondition",
		totalCents:"IntCondition",
		czkPercentage:"FloatCondition",
		organization:"PostOrganizationWhere",
		and:"PostOrganizationSumWhere",
		or:"PostOrganizationSumWhere",
		not:"PostOrganizationSumWhere"
	},
	PostRevisionWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		createdById:"UUIDCondition",
		publishedById:"UUIDCondition",
		type:"PostTypeCondition",
		publishedAt:"DateTimeCondition",
		post:"PostWhere",
		tileImage:"ImageWhere",
		tileVideo:"VideoWhere",
		heroImage:"ImageWhere",
		locales:"PostRevisionLocaleWhere",
		regionListOverride:"DonationAmountsRegionListWhere",
		isOrganizationVisible:"BooleanCondition",
		sendPublishNotifications:"BooleanCondition",
		isArchived:"BooleanCondition",
		and:"PostRevisionWhere",
		or:"PostRevisionWhere",
		not:"PostRevisionWhere"
	},
	PostTypeCondition:{
		and:"PostTypeCondition",
		or:"PostTypeCondition",
		not:"PostTypeCondition",
		eq:"PostType",
		notEq:"PostType",
		in:"PostType",
		notIn:"PostType",
		lt:"PostType",
		lte:"PostType",
		gt:"PostType",
		gte:"PostType"
	},
	PostType: "enum" as const,
	VideoWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		width:"IntCondition",
		height:"IntCondition",
		size:"IntCondition",
		type:"StringCondition",
		poster:"ImageWhere",
		shapeType:"VideoShapeTypeCondition",
		and:"VideoWhere",
		or:"VideoWhere",
		not:"VideoWhere"
	},
	VideoShapeTypeCondition:{
		and:"VideoShapeTypeCondition",
		or:"VideoShapeTypeCondition",
		not:"VideoShapeTypeCondition",
		eq:"VideoShapeType",
		notEq:"VideoShapeType",
		in:"VideoShapeType",
		notIn:"VideoShapeType",
		lt:"VideoShapeType",
		lte:"VideoShapeType",
		gt:"VideoShapeType",
		gte:"VideoShapeType"
	},
	VideoShapeType: "enum" as const,
	PostRevisionLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		root:"PostRevisionWhere",
		locale:"LocaleWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		leadContent:"ContentWhere",
		publishNotificationText:"StringCondition",
		translatedByAI:"BooleanCondition",
		and:"PostRevisionLocaleWhere",
		or:"PostRevisionLocaleWhere",
		not:"PostRevisionLocaleWhere"
	},
	PostStateCondition:{
		and:"PostStateCondition",
		or:"PostStateCondition",
		not:"PostStateCondition",
		eq:"PostState",
		notEq:"PostState",
		in:"PostState",
		notIn:"PostState",
		lt:"PostState",
		lte:"PostState",
		gt:"PostState",
		gte:"PostState"
	},
	PostState: "enum" as const,
	PostMetaDataWhere:{
		id:"UUIDCondition",
		titleWithFallback:"StringCondition",
		formattedSpecificSymbol:"StringCondition",
		fullFormattedSpecificSymbol:"StringCondition",
		latestRevision:"PostRevisionWhere",
		post:"PostWhere",
		and:"PostMetaDataWhere",
		or:"PostMetaDataWhere",
		not:"PostMetaDataWhere"
	},
	HeroCarouselWhere:{
		id:"UUIDCondition",
		createdAt:"DateCondition",
		posts:"PostWhere",
		items:"HeroCarouselItemWhere",
		and:"HeroCarouselWhere",
		or:"HeroCarouselWhere",
		not:"HeroCarouselWhere"
	},
	DateCondition:{
		and:"DateCondition",
		or:"DateCondition",
		not:"DateCondition",
		eq:"Date",
		notEq:"Date",
		in:"Date",
		notIn:"Date",
		lt:"Date",
		lte:"Date",
		gt:"Date",
		gte:"Date"
	},
	Date: `scalar.Date` as const,
	HeroCarouselItemWhere:{
		id:"UUIDCondition",
		createdAt:"DateCondition",
		order:"IntCondition",
		list:"HeroCarouselWhere",
		item:"PostWhere",
		and:"HeroCarouselItemWhere",
		or:"HeroCarouselItemWhere",
		not:"HeroCarouselItemWhere"
	},
	ReportPageLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		subtitle:"StringCondition",
		postTitle:"StringCondition",
		giftTitle:"StringCondition",
		link:"LinkableWhere",
		root:"ReportPageWhere",
		locale:"LocaleWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		posts:"PostWhere",
		and:"ReportPageLocaleWhere",
		or:"ReportPageLocaleWhere",
		not:"ReportPageLocaleWhere"
	},
	ReportPageWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"ReportPageLocaleWhere",
		and:"ReportPageWhere",
		or:"ReportPageWhere",
		not:"ReportPageWhere"
	},
	PostSumWhere:{
		id:"UUIDCondition",
		totalCents:"IntCondition",
		czkPercentage:"FloatCondition",
		post:"PostWhere",
		and:"PostSumWhere",
		or:"PostSumWhere",
		not:"PostSumWhere"
	},
	PostFundraisingProgressWhere:{
		id:"UUIDCondition",
		progress:"FloatCondition",
		post:"PostWhere",
		and:"PostFundraisingProgressWhere",
		or:"PostFundraisingProgressWhere",
		not:"PostFundraisingProgressWhere"
	},
	GivenGiftsPageLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		subtitle:"StringCondition",
		giftTitle:"StringCondition",
		giftText:"StringCondition",
		note:"StringCondition",
		root:"GivenGiftsPageWhere",
		locale:"LocaleWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		link:"LinkableWhere",
		and:"GivenGiftsPageLocaleWhere",
		or:"GivenGiftsPageLocaleWhere",
		not:"GivenGiftsPageLocaleWhere"
	},
	GivenGiftsPageWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"GivenGiftsPageLocaleWhere",
		and:"GivenGiftsPageWhere",
		or:"GivenGiftsPageWhere",
		not:"GivenGiftsPageWhere"
	},
	ReceivedGiftsPageLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		subtitle:"StringCondition",
		giftTitle:"StringCondition",
		giftText:"StringCondition",
		note:"StringCondition",
		link:"LinkableWhere",
		root:"ReceivedGiftsPageWhere",
		locale:"LocaleWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		and:"ReceivedGiftsPageLocaleWhere",
		or:"ReceivedGiftsPageLocaleWhere",
		not:"ReceivedGiftsPageLocaleWhere"
	},
	ReceivedGiftsPageWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"ReceivedGiftsPageLocaleWhere",
		and:"ReceivedGiftsPageWhere",
		or:"ReceivedGiftsPageWhere",
		not:"ReceivedGiftsPageWhere"
	},
	ContentAlignmentCondition:{
		and:"ContentAlignmentCondition",
		or:"ContentAlignmentCondition",
		not:"ContentAlignmentCondition",
		eq:"ContentAlignment",
		notEq:"ContentAlignment",
		in:"ContentAlignment",
		notIn:"ContentAlignment",
		lt:"ContentAlignment",
		lte:"ContentAlignment",
		gt:"ContentAlignment",
		gte:"ContentAlignment"
	},
	ContentAlignment: "enum" as const,
	ValueListWhere:{
		id:"UUIDCondition",
		items:"ValueItemWhere",
		and:"ValueListWhere",
		or:"ValueListWhere",
		not:"ValueListWhere"
	},
	ValueItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"ValueListWhere",
		item:"ValueWhere",
		and:"ValueItemWhere",
		or:"ValueItemWhere",
		not:"ValueItemWhere"
	},
	ValueWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		textContent:"ContentWhere",
		and:"ValueWhere",
		or:"ValueWhere",
		not:"ValueWhere"
	},
	ImageLinkListWhere:{
		id:"UUIDCondition",
		items:"ImageLinkItemWhere",
		and:"ImageLinkListWhere",
		or:"ImageLinkListWhere",
		not:"ImageLinkListWhere"
	},
	ImageLinkItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"ImageLinkListWhere",
		item:"ImageLinkWhere",
		and:"ImageLinkItemWhere",
		or:"ImageLinkItemWhere",
		not:"ImageLinkItemWhere"
	},
	ImageLinkWhere:{
		id:"UUIDCondition",
		image:"ImageWhere",
		link:"LinkWhere",
		and:"ImageLinkWhere",
		or:"ImageLinkWhere",
		not:"ImageLinkWhere"
	},
	PostAreaListWhere:{
		id:"UUIDCondition",
		items:"PostAreaListItemWhere",
		and:"PostAreaListWhere",
		or:"PostAreaListWhere",
		not:"PostAreaListWhere"
	},
	PostAreaListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"PostAreaListWhere",
		item:"PostAreaWhere",
		and:"PostAreaListItemWhere",
		or:"PostAreaListItemWhere",
		not:"PostAreaListItemWhere"
	},
	AccordionWhere:{
		id:"UUIDCondition",
		items:"AccordionItemWhere",
		and:"AccordionWhere",
		or:"AccordionWhere",
		not:"AccordionWhere"
	},
	AccordionItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		name:"StringCondition",
		list:"AccordionWhere",
		descriptionContent:"ContentWhere",
		and:"AccordionItemWhere",
		or:"AccordionItemWhere",
		not:"AccordionItemWhere"
	},
	MediumListWhere:{
		id:"UUIDCondition",
		items:"MediumItemWhere",
		and:"MediumListWhere",
		or:"MediumListWhere",
		not:"MediumListWhere"
	},
	MediumItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"MediumListWhere",
		medium:"MediumWhere",
		and:"MediumItemWhere",
		or:"MediumItemWhere",
		not:"MediumItemWhere"
	},
	MediumWhere:{
		id:"UUIDCondition",
		type:"MediumTypeCondition",
		image:"ImageWhere",
		video:"VideoWhere",
		and:"MediumWhere",
		or:"MediumWhere",
		not:"MediumWhere"
	},
	MediumTypeCondition:{
		and:"MediumTypeCondition",
		or:"MediumTypeCondition",
		not:"MediumTypeCondition",
		eq:"MediumType",
		notEq:"MediumType",
		in:"MediumType",
		notIn:"MediumType",
		lt:"MediumType",
		lte:"MediumType",
		gt:"MediumType",
		gte:"MediumType"
	},
	MediumType: "enum" as const,
	MemberListWhere:{
		id:"UUIDCondition",
		items:"MemberListItemWhere",
		and:"MemberListWhere",
		or:"MemberListWhere",
		not:"MemberListWhere"
	},
	MemberListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		name:"StringCondition",
		position:"StringCondition",
		list:"MemberListWhere",
		image:"ImageWhere",
		descriptionContent:"ContentWhere",
		and:"MemberListItemWhere",
		or:"MemberListItemWhere",
		not:"MemberListItemWhere"
	},
	AsideMediaContentLayoutCondition:{
		and:"AsideMediaContentLayoutCondition",
		or:"AsideMediaContentLayoutCondition",
		not:"AsideMediaContentLayoutCondition",
		eq:"AsideMediaContentLayout",
		notEq:"AsideMediaContentLayout",
		in:"AsideMediaContentLayout",
		notIn:"AsideMediaContentLayout",
		lt:"AsideMediaContentLayout",
		lte:"AsideMediaContentLayout",
		gt:"AsideMediaContentLayout",
		gte:"AsideMediaContentLayout"
	},
	AsideMediaContentLayout: "enum" as const,
	FormWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		type:"FormTypeCondition",
		tax:"FilledTaxFormWhere",
		and:"FormWhere",
		or:"FormWhere",
		not:"FormWhere"
	},
	FormTypeCondition:{
		and:"FormTypeCondition",
		or:"FormTypeCondition",
		not:"FormTypeCondition",
		eq:"FormType",
		notEq:"FormType",
		in:"FormType",
		notIn:"FormType",
		lt:"FormType",
		lte:"FormType",
		gt:"FormType",
		gte:"FormType"
	},
	FormType: "enum" as const,
	FilledTaxFormWhere:{
		id:"UUIDCondition",
		publishedAt:"DateTimeCondition",
		userId:"StringCondition",
		email:"StringCondition",
		name:"StringCondition",
		vatId:"StringCondition",
		address1:"StringCondition",
		address2:"StringCondition",
		city:"StringCondition",
		postalCode:"StringCondition",
		state:"StringCondition",
		country:"RegionWhere",
		dateFrom:"DateCondition",
		dateTo:"DateCondition",
		year:"IntCondition",
		isPdfGenerated:"BooleanCondition",
		pdfObjectKey:"StringCondition",
		and:"FilledTaxFormWhere",
		or:"FilledTaxFormWhere",
		not:"FilledTaxFormWhere"
	},
	PostOrganizationListWhere:{
		id:"UUIDCondition",
		items:"PostOrganizationListItemWhere",
		and:"PostOrganizationListWhere",
		or:"PostOrganizationListWhere",
		not:"PostOrganizationListWhere"
	},
	PostOrganizationListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"PostOrganizationListWhere",
		item:"PostOrganizationWhere",
		type:"PostOrganizationListItemTypeCondition",
		link:"LinkWhere",
		image:"ImageWhere",
		and:"PostOrganizationListItemWhere",
		or:"PostOrganizationListItemWhere",
		not:"PostOrganizationListItemWhere"
	},
	PostOrganizationListItemTypeCondition:{
		and:"PostOrganizationListItemTypeCondition",
		or:"PostOrganizationListItemTypeCondition",
		not:"PostOrganizationListItemTypeCondition",
		eq:"PostOrganizationListItemType",
		notEq:"PostOrganizationListItemType",
		in:"PostOrganizationListItemType",
		notIn:"PostOrganizationListItemType",
		lt:"PostOrganizationListItemType",
		lte:"PostOrganizationListItemType",
		gt:"PostOrganizationListItemType",
		gte:"PostOrganizationListItemType"
	},
	PostOrganizationListItemType: "enum" as const,
	TextImageListWhere:{
		id:"UUIDCondition",
		items:"TextImageListItemWhere",
		and:"TextImageListWhere",
		or:"TextImageListWhere",
		not:"TextImageListWhere"
	},
	TextImageListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"TextImageListWhere",
		image:"ImageWhere",
		text:"StringCondition",
		link:"LinkWhere",
		and:"TextImageListItemWhere",
		or:"TextImageListItemWhere",
		not:"TextImageListItemWhere"
	},
	HeaderLocaleWhere:{
		id:"UUIDCondition",
		root:"HeaderWhere",
		locale:"LocaleWhere",
		links:"LinkListWhere",
		and:"HeaderLocaleWhere",
		or:"HeaderLocaleWhere",
		not:"HeaderLocaleWhere"
	},
	HeaderWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		logo:"ImageWhere",
		locales:"HeaderLocaleWhere",
		organizationList:"PostOrganizationListWhere",
		and:"HeaderWhere",
		or:"HeaderWhere",
		not:"HeaderWhere"
	},
	LinkListWhere:{
		id:"UUIDCondition",
		items:"LinkItemWhere",
		and:"LinkListWhere",
		or:"LinkListWhere",
		not:"LinkListWhere"
	},
	LinkItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"LinkListWhere",
		link:"LinkWhere",
		and:"LinkItemWhere",
		or:"LinkItemWhere",
		not:"LinkItemWhere"
	},
	FooterLocaleWhere:{
		id:"UUIDCondition",
		copyright:"StringCondition",
		root:"FooterWhere",
		locale:"LocaleWhere",
		linkList:"LinkListWhere",
		contactEmail:"StringCondition",
		addressInfo:"ContentWhere",
		imageLinkList:"ImageLinkListWhere",
		and:"FooterLocaleWhere",
		or:"FooterLocaleWhere",
		not:"FooterLocaleWhere"
	},
	FooterWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"FooterLocaleWhere",
		logo:"ImageWhere",
		and:"FooterWhere",
		or:"FooterWhere",
		not:"FooterWhere"
	},
	GenericPageAboutSettingsLocaleWhere:{
		id:"UUIDCondition",
		root:"GenericPageAboutSettingsWhere",
		locale:"LocaleWhere",
		linkGroups:"GenericPageAboutGroupLinksLocaleWhere",
		and:"GenericPageAboutSettingsLocaleWhere",
		or:"GenericPageAboutSettingsLocaleWhere",
		not:"GenericPageAboutSettingsLocaleWhere"
	},
	GenericPageAboutSettingsWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"GenericPageAboutSettingsLocaleWhere",
		and:"GenericPageAboutSettingsWhere",
		or:"GenericPageAboutSettingsWhere",
		not:"GenericPageAboutSettingsWhere"
	},
	GenericPageAboutGroupLinksLocaleWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		settings:"GenericPageAboutSettingsLocaleWhere",
		linkList:"LinkListWhere",
		and:"GenericPageAboutGroupLinksLocaleWhere",
		or:"GenericPageAboutGroupLinksLocaleWhere",
		not:"GenericPageAboutGroupLinksLocaleWhere"
	},
	FeedPageLocaleWhere:{
		id:"UUIDCondition",
		root:"FeedPageWhere",
		locale:"LocaleWhere",
		heroTiles:"TileListWhere",
		sectionList:"FeedPageSectionWhere",
		cardList:"CardListWhere",
		storyGuideList:"StoryGuideListWhere",
		and:"FeedPageLocaleWhere",
		or:"FeedPageLocaleWhere",
		not:"FeedPageLocaleWhere"
	},
	FeedPageWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"FeedPageLocaleWhere",
		and:"FeedPageWhere",
		or:"FeedPageWhere",
		not:"FeedPageWhere"
	},
	TileListWhere:{
		id:"UUIDCondition",
		size:"TileListSizeCondition",
		title:"StringCondition",
		items:"TileItemWhere",
		areaType:"PostAreaWhere",
		and:"TileListWhere",
		or:"TileListWhere",
		not:"TileListWhere"
	},
	TileListSizeCondition:{
		and:"TileListSizeCondition",
		or:"TileListSizeCondition",
		not:"TileListSizeCondition",
		eq:"TileListSize",
		notEq:"TileListSize",
		in:"TileListSize",
		notIn:"TileListSize",
		lt:"TileListSize",
		lte:"TileListSize",
		gt:"TileListSize",
		gte:"TileListSize"
	},
	TileListSize: "enum" as const,
	TileItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		type:"TileItemTypeCondition",
		title:"StringCondition",
		description:"StringCondition",
		list:"TileListWhere",
		post:"PostWhere",
		area:"PostAreaWhere",
		image:"ImageWhere",
		link:"LinkWhere",
		organization:"PostOrganizationWhere",
		and:"TileItemWhere",
		or:"TileItemWhere",
		not:"TileItemWhere"
	},
	TileItemTypeCondition:{
		and:"TileItemTypeCondition",
		or:"TileItemTypeCondition",
		not:"TileItemTypeCondition",
		eq:"TileItemType",
		notEq:"TileItemType",
		in:"TileItemType",
		notIn:"TileItemType",
		lt:"TileItemType",
		lte:"TileItemType",
		gt:"TileItemType",
		gte:"TileItemType"
	},
	TileItemType: "enum" as const,
	FeedPageSectionWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		feedPageLocale:"FeedPageLocaleWhere",
		tileStripeList:"FeedPageTileStripeWhere",
		and:"FeedPageSectionWhere",
		or:"FeedPageSectionWhere",
		not:"FeedPageSectionWhere"
	},
	FeedPageTileStripeWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		section:"FeedPageSectionWhere",
		tileList:"TileListWhere",
		and:"FeedPageTileStripeWhere",
		or:"FeedPageTileStripeWhere",
		not:"FeedPageTileStripeWhere"
	},
	CardListWhere:{
		id:"UUIDCondition",
		items:"CardItemWhere",
		and:"CardListWhere",
		or:"CardListWhere",
		not:"CardListWhere"
	},
	CardItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		description:"StringCondition",
		list:"CardListWhere",
		link:"LinkWhere",
		and:"CardItemWhere",
		or:"CardItemWhere",
		not:"CardItemWhere"
	},
	StoryGuideListWhere:{
		id:"UUIDCondition",
		items:"StoryGuideItemWhere",
		and:"StoryGuideListWhere",
		or:"StoryGuideListWhere",
		not:"StoryGuideListWhere"
	},
	StoryGuideItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"StoryGuideListWhere",
		guide:"StoryGuideWhere",
		and:"StoryGuideItemWhere",
		or:"StoryGuideItemWhere",
		not:"StoryGuideItemWhere"
	},
	StoryGuideWhere:{
		id:"UUIDCondition",
		mediaType:"MediaTypeCondition",
		title:"StringCondition",
		subtitle:"StringCondition",
		image:"ImageWhere",
		secondaryImage:"ImageWhere",
		and:"StoryGuideWhere",
		or:"StoryGuideWhere",
		not:"StoryGuideWhere"
	},
	MediaTypeCondition:{
		and:"MediaTypeCondition",
		or:"MediaTypeCondition",
		not:"MediaTypeCondition",
		eq:"MediaType",
		notEq:"MediaType",
		in:"MediaType",
		notIn:"MediaType",
		lt:"MediaType",
		lte:"MediaType",
		gt:"MediaType",
		gte:"MediaType"
	},
	MediaType: "enum" as const,
	RecurringPaymentPageLocaleWhere:{
		id:"UUIDCondition",
		root:"RecurringPaymentPageWhere",
		locale:"LocaleWhere",
		favouritePosts:"PostListWhere",
		storyGuideList:"StoryGuideListWhere",
		and:"RecurringPaymentPageLocaleWhere",
		or:"RecurringPaymentPageLocaleWhere",
		not:"RecurringPaymentPageLocaleWhere"
	},
	RecurringPaymentPageWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"RecurringPaymentPageLocaleWhere",
		and:"RecurringPaymentPageWhere",
		or:"RecurringPaymentPageWhere",
		not:"RecurringPaymentPageWhere"
	},
	PostListWhere:{
		id:"UUIDCondition",
		items:"PostListItemWhere",
		and:"PostListWhere",
		or:"PostListWhere",
		not:"PostListWhere"
	},
	PostListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"PostListWhere",
		post:"PostWhere",
		and:"PostListItemWhere",
		or:"PostListItemWhere",
		not:"PostListItemWhere"
	},
	ScheduledNotificationLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		description:"StringCondition",
		root:"ScheduledNotificationWhere",
		locale:"LocaleWhere",
		and:"ScheduledNotificationLocaleWhere",
		or:"ScheduledNotificationLocaleWhere",
		not:"ScheduledNotificationLocaleWhere"
	},
	ScheduledNotificationWhere:{
		id:"UUIDCondition",
		localMsFromMidnight:"IntCondition",
		scheduledDate:"DateCondition",
		internalTitle:"StringCondition",
		target:"NotificationTargetGroupWhere",
		locales:"ScheduledNotificationLocaleWhere",
		image:"ImageWhere",
		completedAt:"DateTimeCondition",
		processedNotifications:"ProcessedNotificationSourceWhere",
		and:"ScheduledNotificationWhere",
		or:"ScheduledNotificationWhere",
		not:"ScheduledNotificationWhere"
	},
	NotificationTargetGroupWhere:{
		id:"UUIDCondition",
		type:"NotificationTargetTypeCondition",
		regions:"RegionWhere",
		and:"NotificationTargetGroupWhere",
		or:"NotificationTargetGroupWhere",
		not:"NotificationTargetGroupWhere"
	},
	NotificationTargetTypeCondition:{
		and:"NotificationTargetTypeCondition",
		or:"NotificationTargetTypeCondition",
		not:"NotificationTargetTypeCondition",
		eq:"NotificationTargetType",
		notEq:"NotificationTargetType",
		in:"NotificationTargetType",
		notIn:"NotificationTargetType",
		lt:"NotificationTargetType",
		lte:"NotificationTargetType",
		gt:"NotificationTargetType",
		gte:"NotificationTargetType"
	},
	NotificationTargetType: "enum" as const,
	ProcessedNotificationSourceWhere:{
		id:"UUIDCondition",
		type:"ProcessedNotificationSourceTypeCondition",
		processedNotification:"ProcessedNotificationWhere",
		donationReminderUser:"UserWhere",
		scheduledNotification:"ScheduledNotificationWhere",
		and:"ProcessedNotificationSourceWhere",
		or:"ProcessedNotificationSourceWhere",
		not:"ProcessedNotificationSourceWhere"
	},
	ProcessedNotificationSourceTypeCondition:{
		and:"ProcessedNotificationSourceTypeCondition",
		or:"ProcessedNotificationSourceTypeCondition",
		not:"ProcessedNotificationSourceTypeCondition",
		eq:"ProcessedNotificationSourceType",
		notEq:"ProcessedNotificationSourceType",
		in:"ProcessedNotificationSourceType",
		notIn:"ProcessedNotificationSourceType",
		lt:"ProcessedNotificationSourceType",
		lte:"ProcessedNotificationSourceType",
		gt:"ProcessedNotificationSourceType",
		gte:"ProcessedNotificationSourceType"
	},
	ProcessedNotificationSourceType: "enum" as const,
	ProcessedNotificationWhere:{
		id:"UUIDCondition",
		topic:"StringCondition",
		sentAt:"DateTimeCondition",
		errorMessage:"StringCondition",
		errorCode:"StringCondition",
		isSuccess:"BooleanCondition",
		source:"ProcessedNotificationSourceWhere",
		title:"StringCondition",
		body:"StringCondition",
		and:"ProcessedNotificationWhere",
		or:"ProcessedNotificationWhere",
		not:"ProcessedNotificationWhere"
	},
	UserWhere:{
		id:"UUIDCondition",
		tenantPersonId:"UUIDCondition",
		createdAt:"DateTimeCondition",
		email:"StringCondition",
		name:"StringCondition",
		payments:"UserPaymentWhere",
		variableSymbol:"IntCondition",
		lastActiveAt:"DateTimeCondition",
		region:"RegionWhere",
		currency:"CurrencyWhere",
		recurringPayments:"UserRecurringPaymentWhere",
		stripeId:"StringCondition",
		isDeactivated:"BooleanCondition",
		onBehalfDonations:"OnBehalfDonationWhere",
		publicProfileSecret:"StringCondition",
		publicProfileCustomNote:"StringCondition",
		publicProfileCustomNoteEnabled:"BooleanCondition",
		donationConfirmationEmailEnabled:"BooleanCondition",
		locale:"LocaleWhere",
		signedUp:"BooleanCondition",
		devices:"DeviceWhere",
		processedNotifications:"ProcessedNotificationSourceWhere",
		areaStats:"UserAreaStatsWhere",
		organizationStats:"UserOrganizationStatsWhere",
		postStats:"UserPostStatsWhere",
		currencyStats:"UserCurrencyStatsWhere",
		stats:"UserStatsWhere",
		and:"UserWhere",
		or:"UserWhere",
		not:"UserWhere"
	},
	UserPaymentWhere:{
		id:"UUIDCondition",
		cents:"IntCondition",
		createdAt:"DateTimeCondition",
		specificSymbol:"StringCondition",
		currency:"CurrencyWhere",
		order:"UserPaymentOrderIdWhere",
		csobPayment:"CsobPaymentWhere",
		stripePayment:"StripePaymentWhere",
		recurringPaymentItem:"UserRecurringPaymentItemWhere",
		method:"UserPaymentMethodCondition",
		region:"RegionWhere",
		user:"UserWhere",
		isReusable:"BooleanCondition",
		onBehalfDonation:"OnBehalfDonationWhere",
		triesCollection:"UserPaymentTriesCollectionWhere",
		successEmailSentAt:"DateTimeCondition",
		isSuccessful:"BooleanCondition",
		isFinished:"BooleanCondition",
		metadata:"UserPaymentMetadataWhere",
		and:"UserPaymentWhere",
		or:"UserPaymentWhere",
		not:"UserPaymentWhere"
	},
	UserPaymentOrderIdWhere:{
		id:"UUIDCondition",
		seq:"IntCondition",
		and:"UserPaymentOrderIdWhere",
		or:"UserPaymentOrderIdWhere",
		not:"UserPaymentOrderIdWhere"
	},
	CsobPaymentWhere:{
		id:"UUIDCondition",
		payId:"StringCondition",
		statusChanges:"CsobPaymentStatusChangeWhere",
		payment:"UserPaymentWhere",
		originalPayId:"StringCondition",
		metadata:"CsobPaymentMetadataWhere",
		and:"CsobPaymentWhere",
		or:"CsobPaymentWhere",
		not:"CsobPaymentWhere"
	},
	CsobPaymentStatusChangeWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		dttm:"StringCondition",
		status:"IntCondition",
		resultCode:"IntCondition",
		message:"StringCondition",
		authCode:"StringCondition",
		statusDetail:"StringCondition",
		actions:"StringCondition",
		payment:"CsobPaymentWhere",
		and:"CsobPaymentStatusChangeWhere",
		or:"CsobPaymentStatusChangeWhere",
		not:"CsobPaymentStatusChangeWhere"
	},
	CsobPaymentMetadataWhere:{
		id:"UUIDCondition",
		status:"IntCondition",
		isSuccessful:"BooleanCondition",
		isFinished:"BooleanCondition",
		resolvedOriginalPayId:"StringCondition",
		csobPayment:"CsobPaymentWhere",
		and:"CsobPaymentMetadataWhere",
		or:"CsobPaymentMetadataWhere",
		not:"CsobPaymentMetadataWhere"
	},
	StripePaymentWhere:{
		id:"UUIDCondition",
		identifier:"StringCondition",
		statusChanges:"StripePaymentStatusChangeWhere",
		payment:"UserPaymentWhere",
		metadata:"StripePaymentMetadataWhere",
		and:"StripePaymentWhere",
		or:"StripePaymentWhere",
		not:"StripePaymentWhere"
	},
	StripePaymentStatusChangeWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		payment:"StripePaymentWhere",
		timestamp:"IntCondition",
		eventId:"StringCondition",
		paymentIntentStatus:"StripePaymentStatusChangePaymentIntentStatusCondition",
		and:"StripePaymentStatusChangeWhere",
		or:"StripePaymentStatusChangeWhere",
		not:"StripePaymentStatusChangeWhere"
	},
	StripePaymentStatusChangePaymentIntentStatusCondition:{
		and:"StripePaymentStatusChangePaymentIntentStatusCondition",
		or:"StripePaymentStatusChangePaymentIntentStatusCondition",
		not:"StripePaymentStatusChangePaymentIntentStatusCondition",
		eq:"StripePaymentStatusChangePaymentIntentStatus",
		notEq:"StripePaymentStatusChangePaymentIntentStatus",
		in:"StripePaymentStatusChangePaymentIntentStatus",
		notIn:"StripePaymentStatusChangePaymentIntentStatus",
		lt:"StripePaymentStatusChangePaymentIntentStatus",
		lte:"StripePaymentStatusChangePaymentIntentStatus",
		gt:"StripePaymentStatusChangePaymentIntentStatus",
		gte:"StripePaymentStatusChangePaymentIntentStatus"
	},
	StripePaymentStatusChangePaymentIntentStatus: "enum" as const,
	StripePaymentMetadataWhere:{
		id:"UUIDCondition",
		status:"IntCondition",
		isSuccessful:"BooleanCondition",
		isFinished:"BooleanCondition",
		stripePayment:"StripePaymentWhere",
		and:"StripePaymentMetadataWhere",
		or:"StripePaymentMetadataWhere",
		not:"StripePaymentMetadataWhere"
	},
	UserRecurringPaymentItemWhere:{
		id:"UUIDCondition",
		recurrenceCounter:"IntCondition",
		createdAt:"DateTimeCondition",
		taskId:"StringCondition",
		payments:"UserPaymentWhere",
		recurringPayment:"UserRecurringPaymentWhere",
		isFailed:"BooleanCondition",
		failedEmailSentAt:"DateTimeCondition",
		meta:"UserRecurringPaymentItemMetadataWhere",
		and:"UserRecurringPaymentItemWhere",
		or:"UserRecurringPaymentItemWhere",
		not:"UserRecurringPaymentItemWhere"
	},
	UserRecurringPaymentWhere:{
		id:"UUIDCondition",
		activeSince:"DateTimeCondition",
		cancelledAt:"DateTimeCondition",
		cents:"IntCondition",
		interval:"UserRecurringPaymentIntervalCondition",
		currency:"CurrencyWhere",
		items:"UserRecurringPaymentItemWhere",
		user:"UserWhere",
		meta:"UpcomingUserRecurringPaymentMetadataWhere",
		and:"UserRecurringPaymentWhere",
		or:"UserRecurringPaymentWhere",
		not:"UserRecurringPaymentWhere"
	},
	UserRecurringPaymentIntervalCondition:{
		and:"UserRecurringPaymentIntervalCondition",
		or:"UserRecurringPaymentIntervalCondition",
		not:"UserRecurringPaymentIntervalCondition",
		eq:"UserRecurringPaymentInterval",
		notEq:"UserRecurringPaymentInterval",
		in:"UserRecurringPaymentInterval",
		notIn:"UserRecurringPaymentInterval",
		lt:"UserRecurringPaymentInterval",
		lte:"UserRecurringPaymentInterval",
		gt:"UserRecurringPaymentInterval",
		gte:"UserRecurringPaymentInterval"
	},
	UserRecurringPaymentInterval: "enum" as const,
	UpcomingUserRecurringPaymentMetadataWhere:{
		id:"UUIDCondition",
		recurrenceCounter:"IntCondition",
		isBehindPayments:"BooleanCondition",
		nextPaymentDate:"DateTimeCondition",
		shouldBeProcessed:"BooleanCondition",
		firstPayment:"UserPaymentWhere",
		firstSuccessfulPayment:"UserPaymentWhere",
		drivingPayment:"UserPaymentWhere",
		recurringPayment:"UserRecurringPaymentWhere",
		and:"UpcomingUserRecurringPaymentMetadataWhere",
		or:"UpcomingUserRecurringPaymentMetadataWhere",
		not:"UpcomingUserRecurringPaymentMetadataWhere"
	},
	UserRecurringPaymentItemMetadataWhere:{
		id:"UUIDCondition",
		isSuccessfullyPaid:"BooleanCondition",
		shouldBeProcessed:"BooleanCondition",
		firstPayment:"UserPaymentWhere",
		lastPayment:"UserPaymentWhere",
		firstSuccessfulPayment:"UserPaymentWhere",
		drivingPayment:"UserPaymentWhere",
		recurringPaymentItem:"UserRecurringPaymentItemWhere",
		and:"UserRecurringPaymentItemMetadataWhere",
		or:"UserRecurringPaymentItemMetadataWhere",
		not:"UserRecurringPaymentItemMetadataWhere"
	},
	UserPaymentMethodCondition:{
		and:"UserPaymentMethodCondition",
		or:"UserPaymentMethodCondition",
		not:"UserPaymentMethodCondition",
		eq:"UserPaymentMethod",
		notEq:"UserPaymentMethod",
		in:"UserPaymentMethod",
		notIn:"UserPaymentMethod",
		lt:"UserPaymentMethod",
		lte:"UserPaymentMethod",
		gt:"UserPaymentMethod",
		gte:"UserPaymentMethod"
	},
	UserPaymentMethod: "enum" as const,
	OnBehalfDonationWhere:{
		id:"UUIDCondition",
		secretCode:"StringCondition",
		specificSymbol:"StringCondition",
		createdAt:"DateTimeCondition",
		payments:"UserPaymentWhere",
		onBehalfOf:"UserWhere",
		meta:"OnBehalfDonationMetadataWhere",
		and:"OnBehalfDonationWhere",
		or:"OnBehalfDonationWhere",
		not:"OnBehalfDonationWhere"
	},
	OnBehalfDonationMetadataWhere:{
		id:"UUIDCondition",
		area:"PostAreaWhere",
		organization:"PostOrganizationWhere",
		post:"PostWhere",
		onBehalfOfDonation:"OnBehalfDonationWhere",
		and:"OnBehalfDonationMetadataWhere",
		or:"OnBehalfDonationMetadataWhere",
		not:"OnBehalfDonationMetadataWhere"
	},
	UserPaymentTriesCollectionWhere:{
		id:"UUIDCondition",
		cents:"IntCondition",
		specificSymbol:"StringCondition",
		createdAt:"DateTimeCondition",
		orderUrl:"StringCondition",
		payment:"UserPaymentWhere",
		user:"UserWhere",
		currency:"CurrencyWhere",
		onBehalfDonation:"OnBehalfDonationWhere",
		recurring:"UserRecurringPaymentWhere",
		metadata:"UserPaymentTriesCollectionMetadataWhere",
		metadataLocales:"UserPaymentTriesCollectionMetadataLocaleWhere",
		medium:"PaymentMediumCondition",
		and:"UserPaymentTriesCollectionWhere",
		or:"UserPaymentTriesCollectionWhere",
		not:"UserPaymentTriesCollectionWhere"
	},
	UserPaymentTriesCollectionMetadataWhere:{
		id:"UUIDCondition",
		area:"PostAreaWhere",
		organization:"PostOrganizationWhere",
		post:"PostWhere",
		triesCollection:"UserPaymentTriesCollectionWhere",
		and:"UserPaymentTriesCollectionMetadataWhere",
		or:"UserPaymentTriesCollectionMetadataWhere",
		not:"UserPaymentTriesCollectionMetadataWhere"
	},
	UserPaymentTriesCollectionMetadataLocaleWhere:{
		id:"UUIDCondition",
		locale:"LocaleWhere",
		title:"StringCondition",
		parent:"UserPaymentTriesCollectionWhere",
		and:"UserPaymentTriesCollectionMetadataLocaleWhere",
		or:"UserPaymentTriesCollectionMetadataLocaleWhere",
		not:"UserPaymentTriesCollectionMetadataLocaleWhere"
	},
	PaymentMediumCondition:{
		and:"PaymentMediumCondition",
		or:"PaymentMediumCondition",
		not:"PaymentMediumCondition",
		eq:"PaymentMedium",
		notEq:"PaymentMedium",
		in:"PaymentMedium",
		notIn:"PaymentMedium",
		lt:"PaymentMedium",
		lte:"PaymentMedium",
		gt:"PaymentMedium",
		gte:"PaymentMedium"
	},
	PaymentMedium: "enum" as const,
	UserPaymentMetadataWhere:{
		id:"UUIDCondition",
		area:"PostAreaWhere",
		organization:"PostOrganizationWhere",
		organizationUnfiltered:"PostOrganizationWhere",
		post:"PostWhere",
		countToUser:"UserWhere",
		paymentType:"StringCondition",
		statusLabel:"StringCondition",
		isSuccessful:"BooleanCondition",
		isFinished:"BooleanCondition",
		needsCacheUpdate:"BooleanCondition",
		isSuccessfulNotCached:"BooleanCondition",
		isFinishedNotCached:"BooleanCondition",
		userPayment:"UserPaymentWhere",
		and:"UserPaymentMetadataWhere",
		or:"UserPaymentMetadataWhere",
		not:"UserPaymentMetadataWhere"
	},
	DeviceWhere:{
		id:"UUIDCondition",
		user:"UserWhere",
		fcmToken:"StringCondition",
		createdAt:"DateTimeCondition",
		ipAddress:"StringCondition",
		userAgent:"StringCondition",
		lastActiveAt:"DateTimeCondition",
		and:"DeviceWhere",
		or:"DeviceWhere",
		not:"DeviceWhere"
	},
	UserAreaStatsWhere:{
		id:"UUIDCondition",
		area:"PostAreaWhere",
		currency:"CurrencyWhere",
		totalCents:"IntCondition",
		user:"UserWhere",
		and:"UserAreaStatsWhere",
		or:"UserAreaStatsWhere",
		not:"UserAreaStatsWhere"
	},
	UserOrganizationStatsWhere:{
		id:"UUIDCondition",
		organization:"PostOrganizationWhere",
		currency:"CurrencyWhere",
		totalCents:"IntCondition",
		user:"UserWhere",
		and:"UserOrganizationStatsWhere",
		or:"UserOrganizationStatsWhere",
		not:"UserOrganizationStatsWhere"
	},
	UserPostStatsWhere:{
		id:"UUIDCondition",
		post:"PostWhere",
		currency:"CurrencyWhere",
		totalCents:"IntCondition",
		user:"UserWhere",
		and:"UserPostStatsWhere",
		or:"UserPostStatsWhere",
		not:"UserPostStatsWhere"
	},
	UserCurrencyStatsWhere:{
		id:"UUIDCondition",
		currency:"CurrencyWhere",
		totalAmountPaymentsOnce:"IntCondition",
		totalAmountPaymentsRegular:"IntCondition",
		user:"UserWhere",
		and:"UserCurrencyStatsWhere",
		or:"UserCurrencyStatsWhere",
		not:"UserCurrencyStatsWhere"
	},
	UserStatsWhere:{
		id:"UUIDCondition",
		totalPaymentsSuccessful:"IntCondition",
		totalPaymentsUnsuccessful:"IntCondition",
		user:"UserWhere",
		and:"UserStatsWhere",
		or:"UserStatsWhere",
		not:"UserStatsWhere"
	},
	Locale:{
		generals:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		genericPages:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		posts:{
			filter:"PostLocaleWhere",
			orderBy:"PostLocaleOrderBy"
		},
		postAreas:{
			filter:"PostAreaLocaleWhere",
			orderBy:"PostAreaLocaleOrderBy"
		},
		postOrganizations:{
			filter:"PostOrganizationLocaleWhere",
			orderBy:"PostOrganizationLocaleOrderBy"
		},
		headers:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		footers:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		genericPageAboutSettings:{
			filter:"GenericPageAboutSettingsLocaleWhere",
			orderBy:"GenericPageAboutSettingsLocaleOrderBy"
		},
		postRevisions:{
			filter:"PostRevisionLocaleWhere",
			orderBy:"PostRevisionLocaleOrderBy"
		},
		flagImage:{
			filter:"ImageWhere"
		},
		feedPages:{
			filter:"FeedPageLocaleWhere",
			orderBy:"FeedPageLocaleOrderBy"
		},
		recurringPaymentPages:{
			filter:"RecurringPaymentPageLocaleWhere",
			orderBy:"RecurringPaymentPageLocaleOrderBy"
		},
		givenGiftsPages:{
			filter:"GivenGiftsPageLocaleWhere",
			orderBy:"GivenGiftsPageLocaleOrderBy"
		},
		receivedGiftsPages:{
			filter:"ReceivedGiftsPageLocaleWhere",
			orderBy:"ReceivedGiftsPageLocaleOrderBy"
		},
		reportPages:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		reportNavigations:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		},
		scheduledNotifications:{
			filter:"ScheduledNotificationLocaleWhere",
			orderBy:"ScheduledNotificationLocaleOrderBy"
		},
		sentPayments:{
			filter:"SentPaymentLocaleWhere",
			orderBy:"SentPaymentLocaleOrderBy"
		},
		generalsByRoot:{
			by:"LocaleGeneralsByRootUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		generalsBySeo:{
			by:"LocaleGeneralsBySeoUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		generalsByAppStoreLink:{
			by:"LocaleGeneralsByAppStoreLinkUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		generalsByGooglePlayLink:{
			by:"LocaleGeneralsByGooglePlayLinkUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		genericPagesByRoot:{
			by:"LocaleGenericPagesByRootUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		genericPagesByContent:{
			by:"LocaleGenericPagesByContentUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		genericPagesBySeo:{
			by:"LocaleGenericPagesBySeoUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		genericPagesByLink:{
			by:"LocaleGenericPagesByLinkUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		postsByRoot:{
			by:"LocalePostsByRootUniqueWhere",
			filter:"PostLocaleWhere"
		},
		postsByContent:{
			by:"LocalePostsByContentUniqueWhere",
			filter:"PostLocaleWhere"
		},
		postsBySeo:{
			by:"LocalePostsBySeoUniqueWhere",
			filter:"PostLocaleWhere"
		},
		postsByLink:{
			by:"LocalePostsByLinkUniqueWhere",
			filter:"PostLocaleWhere"
		},
		postAreasByRoot:{
			by:"LocalePostAreasByRootUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		postAreasByLink:{
			by:"LocalePostAreasByLinkUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		postAreasBySeo:{
			by:"LocalePostAreasBySeoUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		postAreasByBanner:{
			by:"LocalePostAreasByBannerUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		postAreasByContent:{
			by:"LocalePostAreasByContentUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		postOrganizationsByRoot:{
			by:"LocalePostOrganizationsByRootUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		postOrganizationsByLink:{
			by:"LocalePostOrganizationsByLinkUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		postOrganizationsByDomain:{
			by:"LocalePostOrganizationsByDomainUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		postOrganizationsBySeo:{
			by:"LocalePostOrganizationsBySeoUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		postOrganizationsByContent:{
			by:"LocalePostOrganizationsByContentUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		headersByRoot:{
			by:"LocaleHeadersByRootUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		headersByLinks:{
			by:"LocaleHeadersByLinksUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		footersByRoot:{
			by:"LocaleFootersByRootUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByLinkList:{
			by:"LocaleFootersByLinkListUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByAddressInfo:{
			by:"LocaleFootersByAddressInfoUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByImageLinkList:{
			by:"LocaleFootersByImageLinkListUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		genericPageAboutSettingsByRoot:{
			by:"LocaleGenericPageAboutSettingsByRootUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		genericPageAboutSettingsByLinkGroups:{
			by:"LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		postRevisionsByRoot:{
			by:"LocalePostRevisionsByRootUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		postRevisionsByContent:{
			by:"LocalePostRevisionsByContentUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		postRevisionsBySeo:{
			by:"LocalePostRevisionsBySeoUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		postRevisionsByLeadContent:{
			by:"LocalePostRevisionsByLeadContentUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		feedPagesByRoot:{
			by:"LocaleFeedPagesByRootUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		feedPagesByHeroTiles:{
			by:"LocaleFeedPagesByHeroTilesUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		feedPagesBySectionList:{
			by:"LocaleFeedPagesBySectionListUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		feedPagesByCardList:{
			by:"LocaleFeedPagesByCardListUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		feedPagesByStoryGuideList:{
			by:"LocaleFeedPagesByStoryGuideListUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		recurringPaymentPagesByRoot:{
			by:"LocaleRecurringPaymentPagesByRootUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		recurringPaymentPagesByFavouritePosts:{
			by:"LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		recurringPaymentPagesByStoryGuideList:{
			by:"LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		givenGiftsPagesByRoot:{
			by:"LocaleGivenGiftsPagesByRootUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		givenGiftsPagesByContent:{
			by:"LocaleGivenGiftsPagesByContentUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		givenGiftsPagesBySeo:{
			by:"LocaleGivenGiftsPagesBySeoUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		givenGiftsPagesByLink:{
			by:"LocaleGivenGiftsPagesByLinkUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		receivedGiftsPagesByRoot:{
			by:"LocaleReceivedGiftsPagesByRootUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		receivedGiftsPagesByLink:{
			by:"LocaleReceivedGiftsPagesByLinkUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		receivedGiftsPagesByContent:{
			by:"LocaleReceivedGiftsPagesByContentUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		receivedGiftsPagesBySeo:{
			by:"LocaleReceivedGiftsPagesBySeoUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		reportPagesByRoot:{
			by:"LocaleReportPagesByRootUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		reportPagesByLink:{
			by:"LocaleReportPagesByLinkUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		reportPagesByContent:{
			by:"LocaleReportPagesByContentUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		reportPagesBySeo:{
			by:"LocaleReportPagesBySeoUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		reportNavigationsByRoot:{
			by:"LocaleReportNavigationsByRootUniqueWhere",
			filter:"ReportNavigationLocaleWhere"
		},
		scheduledNotificationsByRoot:{
			by:"LocaleScheduledNotificationsByRootUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere"
		},
		sentPaymentsByRoot:{
			by:"LocaleSentPaymentsByRootUniqueWhere",
			filter:"SentPaymentLocaleWhere"
		},
		paginateGenerals:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		paginateGenericPages:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		paginatePosts:{
			filter:"PostLocaleWhere",
			orderBy:"PostLocaleOrderBy"
		},
		paginatePostAreas:{
			filter:"PostAreaLocaleWhere",
			orderBy:"PostAreaLocaleOrderBy"
		},
		paginatePostOrganizations:{
			filter:"PostOrganizationLocaleWhere",
			orderBy:"PostOrganizationLocaleOrderBy"
		},
		paginateHeaders:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		paginateFooters:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		paginateGenericPageAboutSettings:{
			filter:"GenericPageAboutSettingsLocaleWhere",
			orderBy:"GenericPageAboutSettingsLocaleOrderBy"
		},
		paginatePostRevisions:{
			filter:"PostRevisionLocaleWhere",
			orderBy:"PostRevisionLocaleOrderBy"
		},
		paginateFeedPages:{
			filter:"FeedPageLocaleWhere",
			orderBy:"FeedPageLocaleOrderBy"
		},
		paginateRecurringPaymentPages:{
			filter:"RecurringPaymentPageLocaleWhere",
			orderBy:"RecurringPaymentPageLocaleOrderBy"
		},
		paginateGivenGiftsPages:{
			filter:"GivenGiftsPageLocaleWhere",
			orderBy:"GivenGiftsPageLocaleOrderBy"
		},
		paginateReceivedGiftsPages:{
			filter:"ReceivedGiftsPageLocaleWhere",
			orderBy:"ReceivedGiftsPageLocaleOrderBy"
		},
		paginateReportPages:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		paginateReportNavigations:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		},
		paginateScheduledNotifications:{
			filter:"ScheduledNotificationLocaleWhere",
			orderBy:"ScheduledNotificationLocaleOrderBy"
		},
		paginateSentPayments:{
			filter:"SentPaymentLocaleWhere",
			orderBy:"SentPaymentLocaleOrderBy"
		}
	},
	GeneralLocaleOrderBy:{
		id:"OrderDirection",
		root:"GeneralOrderBy",
		locale:"LocaleOrderBy",
		seo:"SeoOrderBy",
		appStoreLink:"LinkOrderBy",
		googlePlayLink:"LinkOrderBy",
		allAreasDescription:"OrderDirection",
		allOrganizationsDescription:"OrderDirection"
	},
	OrderDirection: "enum" as const,
	GeneralOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		allAreasIcon:"ImageOrderBy",
		allOrganizationsIcon:"ImageOrderBy",
		organizationList:"PostOrganizationListOrderBy"
	},
	ImageOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		width:"OrderDirection",
		height:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		alt:"OrderDirection",
		fileName:"OrderDirection",
		focalPointX:"OrderDirection",
		focalPointY:"OrderDirection"
	},
	PostOrganizationListOrderBy:{
		id:"OrderDirection"
	},
	LocaleOrderBy:{
		id:"OrderDirection",
		code:"OrderDirection",
		label:"OrderDirection",
		order:"OrderDirection",
		flagImage:"ImageOrderBy"
	},
	SeoOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		description:"OrderDirection",
		ogTitle:"OrderDirection",
		ogDescription:"OrderDirection",
		noIndex:"OrderDirection",
		noFollow:"OrderDirection",
		ogImage:"ImageOrderBy"
	},
	LinkOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		title:"OrderDirection",
		externalLink:"OrderDirection",
		internalLink:"LinkableOrderBy",
		isTargetBlank:"OrderDirection"
	},
	LinkableOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		genericPage:"GenericPageLocaleOrderBy",
		post:"PostLocaleOrderBy",
		postArea:"PostAreaLocaleOrderBy",
		postOrganization:"PostOrganizationLocaleOrderBy",
		reportPage:"ReportPageLocaleOrderBy",
		givenGiftsPage:"GivenGiftsPageLocaleOrderBy",
		receivedGiftsPage:"ReceivedGiftsPageLocaleOrderBy"
	},
	GenericPageLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		root:"GenericPageOrderBy",
		locale:"LocaleOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		link:"LinkableOrderBy",
		subtitle:"OrderDirection"
	},
	GenericPageOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		order:"OrderDirection"
	},
	ContentOrderBy:{
		id:"OrderDirection"
	},
	PostLocaleOrderBy:{
		id:"OrderDirection",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		link:"LinkableOrderBy",
		locale:"LocaleOrderBy",
		root:"PostOrderBy",
		paymentName:"OrderDirection",
		publishedAt:"OrderDirection"
	},
	PostOrderBy:{
		id:"OrderDirection",
		organization:"PostOrganizationOrderBy",
		area:"PostAreaOrderBy",
		specificSymbol:"OrderDirection",
		activeRevision:"PostRevisionOrderBy",
		isPinnedInArea:"OrderDirection",
		isPinnedInOrganization:"OrderDirection",
		state:"OrderDirection",
		meta:"PostMetaDataOrderBy",
		isPublishedAtHidden:"OrderDirection",
		fundraiseIsActive:"OrderDirection",
		fundraiseEndDate:"OrderDirection",
		fundraiseTargetAmount:"OrderDirection",
		fundraiseFakeAddOnAmount:"OrderDirection",
		fundraiseCurrency:"CurrencyOrderBy",
		fundraiseSum:"PostSumOrderBy",
		fundraisingProgress:"PostFundraisingProgressOrderBy"
	},
	PostOrganizationOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		icon:"ImageOrderBy",
		specificSymbol:"OrderDirection",
		area:"PostAreaOrderBy",
		meta:"PostOrganizationMetaDataOrderBy",
		mobileHeroImage:"ImageOrderBy",
		isHidden:"OrderDirection",
		color:"OrderDirection",
		plainIcon:"ImageOrderBy",
		desktopHeroImage:"ImageOrderBy",
		organizationSum:"PostOrganizationSumOrderBy"
	},
	PostAreaOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		icon:"ImageOrderBy",
		regionListOverride:"DonationAmountsRegionListOrderBy",
		color:"OrderDirection",
		specificSymbol:"OrderDirection",
		region:"RegionOrderBy",
		meta:"PostAreaMetaDataOrderBy",
		mobileHeroImage:"ImageOrderBy",
		plainIcon:"ImageOrderBy",
		areaSentPaymentSum:"PostAreaSentPaymentSumOrderBy",
		areaSum:"PostAreaSumOrderBy"
	},
	DonationAmountsRegionListOrderBy:{
		id:"OrderDirection",
		donation:"DonationOrderBy"
	},
	DonationOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		regionList:"DonationAmountsRegionListOrderBy"
	},
	RegionOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		code:"OrderDirection",
		label:"OrderDirection",
		currency:"CurrencyOrderBy",
		timezone:"OrderDirection"
	},
	CurrencyOrderBy:{
		id:"OrderDirection",
		identifier:"OrderDirection",
		label:"OrderDirection",
		sign:"OrderDirection",
		signAlignment:"OrderDirection",
		defaultDonationAmount:"OrderDirection",
		rateAgainstCzk:"OrderDirection"
	},
	PostAreaMetaDataOrderBy:{
		id:"OrderDirection",
		nameWithFallback:"OrderDirection",
		formattedSpecificSymbol:"OrderDirection",
		fullFormattedSpecificSymbol:"OrderDirection",
		area:"PostAreaOrderBy"
	},
	PostAreaSentPaymentSumOrderBy:{
		id:"OrderDirection",
		totalCents:"OrderDirection",
		czkPercentage:"OrderDirection",
		area:"PostAreaOrderBy"
	},
	PostAreaSumOrderBy:{
		id:"OrderDirection",
		totalCents:"OrderDirection",
		czkPercentage:"OrderDirection",
		area:"PostAreaOrderBy"
	},
	PostOrganizationMetaDataOrderBy:{
		id:"OrderDirection",
		nameWithFallback:"OrderDirection",
		formattedSpecificSymbol:"OrderDirection",
		fullFormattedSpecificSymbol:"OrderDirection",
		organization:"PostOrganizationOrderBy"
	},
	PostOrganizationSumOrderBy:{
		id:"OrderDirection",
		totalCents:"OrderDirection",
		czkPercentage:"OrderDirection",
		organization:"PostOrganizationOrderBy"
	},
	PostRevisionOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		createdById:"OrderDirection",
		publishedById:"OrderDirection",
		type:"OrderDirection",
		publishedAt:"OrderDirection",
		post:"PostOrderBy",
		tileImage:"ImageOrderBy",
		tileVideo:"VideoOrderBy",
		heroImage:"ImageOrderBy",
		regionListOverride:"DonationAmountsRegionListOrderBy",
		isOrganizationVisible:"OrderDirection",
		sendPublishNotifications:"OrderDirection",
		isArchived:"OrderDirection"
	},
	VideoOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		width:"OrderDirection",
		height:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		poster:"ImageOrderBy",
		shapeType:"OrderDirection"
	},
	PostMetaDataOrderBy:{
		id:"OrderDirection",
		titleWithFallback:"OrderDirection",
		formattedSpecificSymbol:"OrderDirection",
		fullFormattedSpecificSymbol:"OrderDirection",
		latestRevision:"PostRevisionOrderBy",
		post:"PostOrderBy"
	},
	PostSumOrderBy:{
		id:"OrderDirection",
		totalCents:"OrderDirection",
		czkPercentage:"OrderDirection",
		post:"PostOrderBy"
	},
	PostFundraisingProgressOrderBy:{
		id:"OrderDirection",
		progress:"OrderDirection",
		post:"PostOrderBy"
	},
	PostAreaLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		description:"OrderDirection",
		link:"LinkableOrderBy",
		root:"PostAreaOrderBy",
		locale:"LocaleOrderBy",
		seo:"SeoOrderBy",
		banner:"AppBannerOrderBy",
		shortDescription:"OrderDirection",
		content:"ContentOrderBy",
		translatedByAI:"OrderDirection"
	},
	AppBannerOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		imageSmall:"ImageOrderBy",
		imageBig:"ImageOrderBy",
		textContent:"ContentOrderBy"
	},
	PostOrganizationLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		description:"OrderDirection",
		link:"LinkableOrderBy",
		root:"PostOrganizationOrderBy",
		locale:"LocaleOrderBy",
		domain:"LinkOrderBy",
		seo:"SeoOrderBy",
		content:"ContentOrderBy",
		translatedByAI:"OrderDirection"
	},
	ReportPageLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		subtitle:"OrderDirection",
		postTitle:"OrderDirection",
		giftTitle:"OrderDirection",
		link:"LinkableOrderBy",
		root:"ReportPageOrderBy",
		locale:"LocaleOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy"
	},
	ReportPageOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	GivenGiftsPageLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		subtitle:"OrderDirection",
		giftTitle:"OrderDirection",
		giftText:"OrderDirection",
		note:"OrderDirection",
		root:"GivenGiftsPageOrderBy",
		locale:"LocaleOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		link:"LinkableOrderBy"
	},
	GivenGiftsPageOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	ReceivedGiftsPageLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		subtitle:"OrderDirection",
		giftTitle:"OrderDirection",
		giftText:"OrderDirection",
		note:"OrderDirection",
		link:"LinkableOrderBy",
		root:"ReceivedGiftsPageOrderBy",
		locale:"LocaleOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy"
	},
	ReceivedGiftsPageOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	GenericPageLocale:{
		root:{
			filter:"GenericPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		link:{
			filter:"LinkableWhere"
		}
	},
	GenericPage:{
		locales:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		reportNavigation:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		},
		localesByLocale:{
			by:"GenericPageLocalesByLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		localesByContent:{
			by:"GenericPageLocalesByContentUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		localesBySeo:{
			by:"GenericPageLocalesBySeoUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		localesByLink:{
			by:"GenericPageLocalesByLinkUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		paginateLocales:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		paginateReportNavigation:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		}
	},
	ReportNavigationLocale:{
		root:{
			filter:"ReportNavigationWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		pages:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		paginatePages:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		}
	},
	ReportNavigation:{
		locales:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		},
		localesByLocale:{
			by:"ReportNavigationLocalesByLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere"
		},
		paginateLocales:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		}
	},
	ReportNavigationLocaleOrderBy:{
		id:"OrderDirection",
		root:"ReportNavigationOrderBy",
		locale:"LocaleOrderBy"
	},
	ReportNavigationOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	ReportNavigationLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	LocaleUniqueWhere:{
		id:"UUID",
		generals:"GeneralLocaleUniqueWhere",
		genericPages:"GenericPageLocaleUniqueWhere",
		posts:"PostLocaleUniqueWhere",
		postAreas:"PostAreaLocaleUniqueWhere",
		postOrganizations:"PostOrganizationLocaleUniqueWhere",
		headers:"HeaderLocaleUniqueWhere",
		footers:"FooterLocaleUniqueWhere",
		genericPageAboutSettings:"GenericPageAboutSettingsLocaleUniqueWhere",
		postRevisions:"PostRevisionLocaleUniqueWhere",
		feedPages:"FeedPageLocaleUniqueWhere",
		recurringPaymentPages:"RecurringPaymentPageLocaleUniqueWhere",
		givenGiftsPages:"GivenGiftsPageLocaleUniqueWhere",
		receivedGiftsPages:"ReceivedGiftsPageLocaleUniqueWhere",
		reportPages:"ReportPageLocaleUniqueWhere",
		reportNavigations:"ReportNavigationLocaleUniqueWhere",
		scheduledNotifications:"ScheduledNotificationLocaleUniqueWhere",
		sentPayments:"SentPaymentLocaleUniqueWhere"
	},
	GeneralLocaleUniqueWhere:{
		id:"UUID",
		root:"GeneralUniqueWhere",
		locale:"LocaleUniqueWhere",
		seo:"SeoUniqueWhere",
		appStoreLink:"LinkUniqueWhere",
		googlePlayLink:"LinkUniqueWhere"
	},
	GeneralUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"GeneralLocaleUniqueWhere",
		allAreasIcon:"ImageUniqueWhere",
		allOrganizationsIcon:"ImageUniqueWhere",
		organizationList:"PostOrganizationListUniqueWhere"
	},
	ImageUniqueWhere:{
		id:"UUID"
	},
	PostOrganizationListUniqueWhere:{
		id:"UUID",
		items:"PostOrganizationListItemUniqueWhere"
	},
	PostOrganizationListItemUniqueWhere:{
		id:"UUID",
		link:"LinkUniqueWhere"
	},
	LinkUniqueWhere:{
		id:"UUID"
	},
	SeoUniqueWhere:{
		id:"UUID",
		ogImage:"ImageUniqueWhere"
	},
	GenericPageLocaleUniqueWhere:{
		id:"UUID",
		root:"GenericPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		link:"LinkableUniqueWhere"
	},
	GenericPageUniqueWhere:{
		id:"UUID",
		locales:"GenericPageLocaleUniqueWhere"
	},
	ContentUniqueWhere:{
		id:"UUID",
		blocks:"ContentBlockUniqueWhere"
	},
	ContentBlockUniqueWhere:{
		id:"UUID",
		references:"ContentReferenceUniqueWhere"
	},
	ContentReferenceUniqueWhere:{
		id:"UUID",
		linkables:"ContentReferenceLinkableItemUniqueWhere",
		link:"LinkUniqueWhere",
		valueList:"ValueListUniqueWhere",
		imageLinkList:"ImageLinkListUniqueWhere",
		areaList:"PostAreaListUniqueWhere",
		accordion:"AccordionUniqueWhere",
		media:"MediumListUniqueWhere",
		memberList:"MemberListUniqueWhere",
		contentWithoutBlocks:"ContentUniqueWhere",
		organizationList:"PostOrganizationListUniqueWhere",
		textImageList:"TextImageListUniqueWhere"
	},
	ContentReferenceLinkableItemUniqueWhere:{
		id:"UUID",
		item:"LinkableUniqueWhere"
	},
	LinkableUniqueWhere:{
		id:"UUID",
		genericPage:"GenericPageLocaleUniqueWhere",
		post:"PostLocaleUniqueWhere",
		postArea:"PostAreaLocaleUniqueWhere",
		postOrganization:"PostOrganizationLocaleUniqueWhere",
		reportPage:"ReportPageLocaleUniqueWhere",
		givenGiftsPage:"GivenGiftsPageLocaleUniqueWhere",
		receivedGiftsPage:"ReceivedGiftsPageLocaleUniqueWhere"
	},
	PostLocaleUniqueWhere:{
		id:"UUID",
		root:"PostUniqueWhere",
		locale:"LocaleUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		link:"LinkableUniqueWhere"
	},
	PostUniqueWhere:{
		id:"UUID",
		activeRevision:"PostRevisionUniqueWhere",
		revisions:"PostRevisionUniqueWhere",
		locales:"PostLocaleUniqueWhere",
		meta:"PostMetaDataUniqueWhere",
		fundraiseCurrencySums:"PostCurrencySumUniqueWhere",
		fundraiseSum:"PostSumUniqueWhere",
		fundraisingProgress:"PostFundraisingProgressUniqueWhere"
	},
	PostRevisionUniqueWhere:{
		id:"UUID",
		locales:"PostRevisionLocaleUniqueWhere",
		regionListOverride:"DonationAmountsRegionListUniqueWhere"
	},
	PostRevisionLocaleUniqueWhere:{
		id:"UUID",
		root:"PostRevisionUniqueWhere",
		locale:"LocaleUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		leadContent:"ContentUniqueWhere"
	},
	DonationAmountsRegionListUniqueWhere:{
		id:"UUID",
		regions:"DonationAmountsRegionItemUniqueWhere",
		donation:"DonationUniqueWhere"
	},
	DonationAmountsRegionItemUniqueWhere:{
		id:"UUID",
		list:"DonationAmountsRegionListUniqueWhere",
		region:"RegionUniqueWhere",
		items:"DonationAmountItemUniqueWhere"
	},
	RegionUniqueWhere:{
		id:"UUID",
		enabledPaymentMethods:"RegionPaymentMethodUniqueWhere",
		donationItems:"DonationAmountsRegionItemUniqueWhere"
	},
	RegionPaymentMethodUniqueWhere:{
		id:"UUID",
		region:"RegionUniqueWhere",
		method:"PaymentMethods"
	},
	DonationAmountItemUniqueWhere:{
		id:"UUID"
	},
	DonationUniqueWhere:{
		id:"UUID",
		unique:"One",
		regionList:"DonationAmountsRegionListUniqueWhere"
	},
	PostMetaDataUniqueWhere:{
		id:"UUID",
		latestRevision:"PostRevisionUniqueWhere",
		post:"PostUniqueWhere"
	},
	PostCurrencySumUniqueWhere:{
		id:"UUID"
	},
	PostSumUniqueWhere:{
		id:"UUID",
		post:"PostUniqueWhere"
	},
	PostFundraisingProgressUniqueWhere:{
		id:"UUID",
		post:"PostUniqueWhere"
	},
	PostAreaLocaleUniqueWhere:{
		id:"UUID",
		root:"PostAreaUniqueWhere",
		locale:"LocaleUniqueWhere",
		link:"LinkableUniqueWhere",
		seo:"SeoUniqueWhere",
		banner:"AppBannerUniqueWhere",
		content:"ContentUniqueWhere"
	},
	PostAreaUniqueWhere:{
		id:"UUID",
		locales:"PostAreaLocaleUniqueWhere",
		regionListOverride:"DonationAmountsRegionListUniqueWhere",
		posts:"PostUniqueWhere",
		meta:"PostAreaMetaDataUniqueWhere",
		sentPayments:"SentPaymentUniqueWhere",
		areaSentPaymentCurrencySums:"PostAreaSentPaymentCurrencySumUniqueWhere",
		areaSentPaymentSum:"PostAreaSentPaymentSumUniqueWhere",
		areaCurrencySums:"PostAreaCurrencySumUniqueWhere",
		areaSum:"PostAreaSumUniqueWhere"
	},
	PostAreaMetaDataUniqueWhere:{
		id:"UUID",
		area:"PostAreaUniqueWhere"
	},
	SentPaymentUniqueWhere:{
		id:"UUID",
		locales:"SentPaymentLocaleUniqueWhere"
	},
	SentPaymentLocaleUniqueWhere:{
		id:"UUID",
		root:"SentPaymentUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	PostAreaSentPaymentCurrencySumUniqueWhere:{
		id:"UUID"
	},
	PostAreaSentPaymentSumUniqueWhere:{
		id:"UUID",
		area:"PostAreaUniqueWhere"
	},
	PostAreaCurrencySumUniqueWhere:{
		id:"UUID"
	},
	PostAreaSumUniqueWhere:{
		id:"UUID",
		area:"PostAreaUniqueWhere"
	},
	AppBannerUniqueWhere:{
		id:"UUID",
		textContent:"ContentUniqueWhere"
	},
	PostOrganizationLocaleUniqueWhere:{
		id:"UUID",
		root:"PostOrganizationUniqueWhere",
		locale:"LocaleUniqueWhere",
		link:"LinkableUniqueWhere",
		domain:"LinkUniqueWhere",
		seo:"SeoUniqueWhere",
		content:"ContentUniqueWhere"
	},
	PostOrganizationUniqueWhere:{
		id:"UUID",
		posts:"PostUniqueWhere",
		locales:"PostOrganizationLocaleUniqueWhere",
		meta:"PostOrganizationMetaDataUniqueWhere",
		sentPayments:"SentPaymentUniqueWhere",
		organizationCurrencySums:"PostOrganizationCurrencySumUniqueWhere",
		organizationSum:"PostOrganizationSumUniqueWhere"
	},
	PostOrganizationMetaDataUniqueWhere:{
		id:"UUID",
		organization:"PostOrganizationUniqueWhere"
	},
	PostOrganizationCurrencySumUniqueWhere:{
		id:"UUID"
	},
	PostOrganizationSumUniqueWhere:{
		id:"UUID",
		organization:"PostOrganizationUniqueWhere"
	},
	ReportPageLocaleUniqueWhere:{
		id:"UUID",
		root:"ReportPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		link:"LinkableUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere"
	},
	ReportPageUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"ReportPageLocaleUniqueWhere"
	},
	GivenGiftsPageLocaleUniqueWhere:{
		id:"UUID",
		root:"GivenGiftsPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		link:"LinkableUniqueWhere"
	},
	GivenGiftsPageUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"GivenGiftsPageLocaleUniqueWhere"
	},
	ReceivedGiftsPageLocaleUniqueWhere:{
		id:"UUID",
		root:"ReceivedGiftsPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		link:"LinkableUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere"
	},
	ReceivedGiftsPageUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"ReceivedGiftsPageLocaleUniqueWhere"
	},
	ValueListUniqueWhere:{
		id:"UUID",
		items:"ValueItemUniqueWhere"
	},
	ValueItemUniqueWhere:{
		id:"UUID"
	},
	ImageLinkListUniqueWhere:{
		id:"UUID",
		items:"ImageLinkItemUniqueWhere"
	},
	ImageLinkItemUniqueWhere:{
		id:"UUID"
	},
	PostAreaListUniqueWhere:{
		id:"UUID",
		items:"PostAreaListItemUniqueWhere"
	},
	PostAreaListItemUniqueWhere:{
		id:"UUID"
	},
	AccordionUniqueWhere:{
		id:"UUID",
		items:"AccordionItemUniqueWhere"
	},
	AccordionItemUniqueWhere:{
		id:"UUID",
		descriptionContent:"ContentUniqueWhere"
	},
	MediumListUniqueWhere:{
		id:"UUID",
		items:"MediumItemUniqueWhere"
	},
	MediumItemUniqueWhere:{
		id:"UUID"
	},
	MemberListUniqueWhere:{
		id:"UUID",
		items:"MemberListItemUniqueWhere"
	},
	MemberListItemUniqueWhere:{
		id:"UUID",
		descriptionContent:"ContentUniqueWhere"
	},
	TextImageListUniqueWhere:{
		id:"UUID",
		items:"TextImageListItemUniqueWhere"
	},
	TextImageListItemUniqueWhere:{
		id:"UUID"
	},
	HeaderLocaleUniqueWhere:{
		id:"UUID",
		root:"HeaderUniqueWhere",
		locale:"LocaleUniqueWhere",
		links:"LinkListUniqueWhere"
	},
	HeaderUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"HeaderLocaleUniqueWhere",
		organizationList:"PostOrganizationListUniqueWhere"
	},
	LinkListUniqueWhere:{
		id:"UUID",
		items:"LinkItemUniqueWhere"
	},
	LinkItemUniqueWhere:{
		id:"UUID",
		link:"LinkUniqueWhere"
	},
	FooterLocaleUniqueWhere:{
		id:"UUID",
		root:"FooterUniqueWhere",
		locale:"LocaleUniqueWhere",
		linkList:"LinkListUniqueWhere",
		addressInfo:"ContentUniqueWhere",
		imageLinkList:"ImageLinkListUniqueWhere"
	},
	FooterUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"FooterLocaleUniqueWhere"
	},
	GenericPageAboutSettingsLocaleUniqueWhere:{
		id:"UUID",
		root:"GenericPageAboutSettingsUniqueWhere",
		locale:"LocaleUniqueWhere",
		linkGroups:"GenericPageAboutGroupLinksLocaleUniqueWhere"
	},
	GenericPageAboutSettingsUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"GenericPageAboutSettingsLocaleUniqueWhere"
	},
	GenericPageAboutGroupLinksLocaleUniqueWhere:{
		id:"UUID",
		linkList:"LinkListUniqueWhere"
	},
	FeedPageLocaleUniqueWhere:{
		id:"UUID",
		root:"FeedPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		heroTiles:"TileListUniqueWhere",
		sectionList:"FeedPageSectionUniqueWhere",
		cardList:"CardListUniqueWhere",
		storyGuideList:"StoryGuideListUniqueWhere"
	},
	FeedPageUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"FeedPageLocaleUniqueWhere"
	},
	TileListUniqueWhere:{
		id:"UUID",
		items:"TileItemUniqueWhere"
	},
	TileItemUniqueWhere:{
		id:"UUID",
		link:"LinkUniqueWhere"
	},
	FeedPageSectionUniqueWhere:{
		id:"UUID",
		tileStripeList:"FeedPageTileStripeUniqueWhere"
	},
	FeedPageTileStripeUniqueWhere:{
		id:"UUID"
	},
	CardListUniqueWhere:{
		id:"UUID",
		items:"CardItemUniqueWhere"
	},
	CardItemUniqueWhere:{
		id:"UUID",
		link:"LinkUniqueWhere"
	},
	StoryGuideListUniqueWhere:{
		id:"UUID",
		items:"StoryGuideItemUniqueWhere"
	},
	StoryGuideItemUniqueWhere:{
		id:"UUID"
	},
	RecurringPaymentPageLocaleUniqueWhere:{
		id:"UUID",
		root:"RecurringPaymentPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		favouritePosts:"PostListUniqueWhere",
		storyGuideList:"StoryGuideListUniqueWhere"
	},
	RecurringPaymentPageUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"RecurringPaymentPageLocaleUniqueWhere"
	},
	PostListUniqueWhere:{
		id:"UUID",
		items:"PostListItemUniqueWhere"
	},
	PostListItemUniqueWhere:{
		id:"UUID"
	},
	ReportNavigationLocaleUniqueWhere:{
		id:"UUID",
		root:"ReportNavigationUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	ReportNavigationUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"ReportNavigationLocaleUniqueWhere"
	},
	ScheduledNotificationLocaleUniqueWhere:{
		id:"UUID",
		root:"ScheduledNotificationUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	ScheduledNotificationUniqueWhere:{
		id:"UUID",
		locales:"ScheduledNotificationLocaleUniqueWhere",
		image:"ImageUniqueWhere",
		processedNotifications:"ProcessedNotificationSourceUniqueWhere"
	},
	ProcessedNotificationSourceUniqueWhere:{
		id:"UUID",
		processedNotification:"ProcessedNotificationUniqueWhere"
	},
	ProcessedNotificationUniqueWhere:{
		id:"UUID",
		source:"ProcessedNotificationSourceUniqueWhere"
	},
	GenericPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	GenericPageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	GenericPageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	GenericPageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	Content:{
		blocks:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		blocksByReferences:{
			by:"ContentBlocksByReferencesUniqueWhere",
			filter:"ContentBlockWhere"
		},
		paginateBlocks:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		}
	},
	ContentBlock:{
		content:{
			filter:"ContentWhere"
		},
		references:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		referencesByLinkables:{
			by:"ContentBlockReferencesByLinkablesUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByLink:{
			by:"ContentBlockReferencesByLinkUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByValueList:{
			by:"ContentBlockReferencesByValueListUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByImageLinkList:{
			by:"ContentBlockReferencesByImageLinkListUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByAreaList:{
			by:"ContentBlockReferencesByAreaListUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByAccordion:{
			by:"ContentBlockReferencesByAccordionUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByMedia:{
			by:"ContentBlockReferencesByMediaUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByMemberList:{
			by:"ContentBlockReferencesByMemberListUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByContentWithoutBlocks:{
			by:"ContentBlockReferencesByContentWithoutBlocksUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByOrganizationList:{
			by:"ContentBlockReferencesByOrganizationListUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByTextImageList:{
			by:"ContentBlockReferencesByTextImageListUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		paginateReferences:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		}
	},
	ContentReference:{
		block:{
			filter:"ContentBlockWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		linkables:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		video:{
			filter:"VideoWhere"
		},
		link:{
			filter:"LinkWhere"
		},
		valueList:{
			filter:"ValueListWhere"
		},
		imageLinkList:{
			filter:"ImageLinkListWhere"
		},
		areaList:{
			filter:"PostAreaListWhere"
		},
		accordion:{
			filter:"AccordionWhere"
		},
		media:{
			filter:"MediumListWhere"
		},
		memberList:{
			filter:"MemberListWhere"
		},
		form:{
			filter:"FormWhere"
		},
		contentWithoutBlocks:{
			filter:"ContentWhere"
		},
		heroCarousel:{
			filter:"HeroCarouselWhere"
		},
		organizationList:{
			filter:"PostOrganizationListWhere"
		},
		posts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		textImageList:{
			filter:"TextImageListWhere"
		},
		linkablesByItem:{
			by:"ContentReferenceLinkablesByItemUniqueWhere",
			filter:"ContentReferenceLinkableItemWhere"
		},
		paginateLinkables:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		paginatePosts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		}
	},
	ContentReferenceLinkableItem:{
		item:{
			filter:"LinkableWhere"
		},
		reference:{
			filter:"ContentReferenceWhere"
		}
	},
	Linkable:{
		genericPage:{
			filter:"GenericPageLocaleWhere"
		},
		post:{
			filter:"PostLocaleWhere"
		},
		postArea:{
			filter:"PostAreaLocaleWhere"
		},
		postOrganization:{
			filter:"PostOrganizationLocaleWhere"
		},
		reportPage:{
			filter:"ReportPageLocaleWhere"
		},
		givenGiftsPage:{
			filter:"GivenGiftsPageLocaleWhere"
		},
		receivedGiftsPage:{
			filter:"ReceivedGiftsPageLocaleWhere"
		}
	},
	PostLocale:{
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		link:{
			filter:"LinkableWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		root:{
			filter:"PostWhere"
		}
	},
	Seo:{
		ogImage:{
			filter:"ImageWhere"
		}
	},
	Post:{
		organization:{
			filter:"PostOrganizationWhere"
		},
		area:{
			filter:"PostAreaWhere"
		},
		activeRevision:{
			filter:"PostRevisionWhere"
		},
		revisions:{
			filter:"PostRevisionWhere",
			orderBy:"PostRevisionOrderBy"
		},
		locales:{
			filter:"PostLocaleWhere",
			orderBy:"PostLocaleOrderBy"
		},
		meta:{
			filter:"PostMetaDataWhere"
		},
		heroCarousel:{
			filter:"HeroCarouselWhere",
			orderBy:"HeroCarouselOrderBy"
		},
		reportPage:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		content:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		fundraiseCurrency:{
			filter:"CurrencyWhere"
		},
		fundraiseCurrencySums:{
			filter:"PostCurrencySumWhere",
			orderBy:"PostCurrencySumOrderBy"
		},
		fundraiseSum:{
			filter:"PostSumWhere"
		},
		fundraisingProgress:{
			filter:"PostFundraisingProgressWhere"
		},
		revisionsByLocales:{
			by:"PostRevisionsByLocalesUniqueWhere",
			filter:"PostRevisionWhere"
		},
		revisionsByRegionListOverride:{
			by:"PostRevisionsByRegionListOverrideUniqueWhere",
			filter:"PostRevisionWhere"
		},
		localesByLocale:{
			by:"PostLocalesByLocaleUniqueWhere",
			filter:"PostLocaleWhere"
		},
		localesByContent:{
			by:"PostLocalesByContentUniqueWhere",
			filter:"PostLocaleWhere"
		},
		localesBySeo:{
			by:"PostLocalesBySeoUniqueWhere",
			filter:"PostLocaleWhere"
		},
		localesByLink:{
			by:"PostLocalesByLinkUniqueWhere",
			filter:"PostLocaleWhere"
		},
		paginateRevisions:{
			filter:"PostRevisionWhere",
			orderBy:"PostRevisionOrderBy"
		},
		paginateLocales:{
			filter:"PostLocaleWhere",
			orderBy:"PostLocaleOrderBy"
		},
		paginateHeroCarousel:{
			filter:"HeroCarouselWhere",
			orderBy:"HeroCarouselOrderBy"
		},
		paginateReportPage:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		paginateContent:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		paginateFundraiseCurrencySums:{
			filter:"PostCurrencySumWhere",
			orderBy:"PostCurrencySumOrderBy"
		}
	},
	PostOrganization:{
		posts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		icon:{
			filter:"ImageWhere"
		},
		locales:{
			filter:"PostOrganizationLocaleWhere",
			orderBy:"PostOrganizationLocaleOrderBy"
		},
		area:{
			filter:"PostAreaWhere"
		},
		meta:{
			filter:"PostOrganizationMetaDataWhere"
		},
		mobileHeroImage:{
			filter:"ImageWhere"
		},
		plainIcon:{
			filter:"ImageWhere"
		},
		desktopHeroImage:{
			filter:"ImageWhere"
		},
		sentPayments:{
			filter:"SentPaymentWhere",
			orderBy:"SentPaymentOrderBy"
		},
		organizationCurrencySums:{
			filter:"PostOrganizationCurrencySumWhere",
			orderBy:"PostOrganizationCurrencySumOrderBy"
		},
		organizationSum:{
			filter:"PostOrganizationSumWhere"
		},
		postsBySpecificSymbol:{
			by:"PostOrganizationPostsBySpecificSymbolUniqueWhere",
			filter:"PostWhere"
		},
		postsByActiveRevision:{
			by:"PostOrganizationPostsByActiveRevisionUniqueWhere",
			filter:"PostWhere"
		},
		postsByRevisions:{
			by:"PostOrganizationPostsByRevisionsUniqueWhere",
			filter:"PostWhere"
		},
		postsByLocales:{
			by:"PostOrganizationPostsByLocalesUniqueWhere",
			filter:"PostWhere"
		},
		postsByMeta:{
			by:"PostOrganizationPostsByMetaUniqueWhere",
			filter:"PostWhere"
		},
		postsByFundraiseCurrencySums:{
			by:"PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere",
			filter:"PostWhere"
		},
		postsByFundraiseSum:{
			by:"PostOrganizationPostsByFundraiseSumUniqueWhere",
			filter:"PostWhere"
		},
		postsByFundraisingProgress:{
			by:"PostOrganizationPostsByFundraisingProgressUniqueWhere",
			filter:"PostWhere"
		},
		localesByLocale:{
			by:"PostOrganizationLocalesByLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		localesByLink:{
			by:"PostOrganizationLocalesByLinkUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		localesByDomain:{
			by:"PostOrganizationLocalesByDomainUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		localesBySeo:{
			by:"PostOrganizationLocalesBySeoUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		localesByContent:{
			by:"PostOrganizationLocalesByContentUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		sentPaymentsByLocales:{
			by:"PostOrganizationSentPaymentsByLocalesUniqueWhere",
			filter:"SentPaymentWhere"
		},
		paginatePosts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		paginateLocales:{
			filter:"PostOrganizationLocaleWhere",
			orderBy:"PostOrganizationLocaleOrderBy"
		},
		paginateSentPayments:{
			filter:"SentPaymentWhere",
			orderBy:"SentPaymentOrderBy"
		},
		paginateOrganizationCurrencySums:{
			filter:"PostOrganizationCurrencySumWhere",
			orderBy:"PostOrganizationCurrencySumOrderBy"
		}
	},
	PostOrganizationLocale:{
		link:{
			filter:"LinkableWhere"
		},
		root:{
			filter:"PostOrganizationWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		domain:{
			filter:"LinkWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		content:{
			filter:"ContentWhere"
		}
	},
	Link:{
		internalLink:{
			filter:"LinkableWhere"
		}
	},
	PostArea:{
		icon:{
			filter:"ImageWhere"
		},
		locales:{
			filter:"PostAreaLocaleWhere",
			orderBy:"PostAreaLocaleOrderBy"
		},
		regionListOverride:{
			filter:"DonationAmountsRegionListWhere"
		},
		posts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		region:{
			filter:"RegionWhere"
		},
		meta:{
			filter:"PostAreaMetaDataWhere"
		},
		mobileHeroImage:{
			filter:"ImageWhere"
		},
		plainIcon:{
			filter:"ImageWhere"
		},
		sentPayments:{
			filter:"SentPaymentWhere",
			orderBy:"SentPaymentOrderBy"
		},
		areaSentPaymentCurrencySums:{
			filter:"PostAreaSentPaymentCurrencySumWhere",
			orderBy:"PostAreaSentPaymentCurrencySumOrderBy"
		},
		areaSentPaymentSum:{
			filter:"PostAreaSentPaymentSumWhere"
		},
		areaCurrencySums:{
			filter:"PostAreaCurrencySumWhere",
			orderBy:"PostAreaCurrencySumOrderBy"
		},
		areaSum:{
			filter:"PostAreaSumWhere"
		},
		localesByLocale:{
			by:"PostAreaLocalesByLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		localesByLink:{
			by:"PostAreaLocalesByLinkUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		localesBySeo:{
			by:"PostAreaLocalesBySeoUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		localesByBanner:{
			by:"PostAreaLocalesByBannerUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		localesByContent:{
			by:"PostAreaLocalesByContentUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		postsBySpecificSymbol:{
			by:"PostAreaPostsBySpecificSymbolUniqueWhere",
			filter:"PostWhere"
		},
		postsByActiveRevision:{
			by:"PostAreaPostsByActiveRevisionUniqueWhere",
			filter:"PostWhere"
		},
		postsByRevisions:{
			by:"PostAreaPostsByRevisionsUniqueWhere",
			filter:"PostWhere"
		},
		postsByLocales:{
			by:"PostAreaPostsByLocalesUniqueWhere",
			filter:"PostWhere"
		},
		postsByMeta:{
			by:"PostAreaPostsByMetaUniqueWhere",
			filter:"PostWhere"
		},
		postsByFundraiseCurrencySums:{
			by:"PostAreaPostsByFundraiseCurrencySumsUniqueWhere",
			filter:"PostWhere"
		},
		postsByFundraiseSum:{
			by:"PostAreaPostsByFundraiseSumUniqueWhere",
			filter:"PostWhere"
		},
		postsByFundraisingProgress:{
			by:"PostAreaPostsByFundraisingProgressUniqueWhere",
			filter:"PostWhere"
		},
		sentPaymentsByLocales:{
			by:"PostAreaSentPaymentsByLocalesUniqueWhere",
			filter:"SentPaymentWhere"
		},
		paginateLocales:{
			filter:"PostAreaLocaleWhere",
			orderBy:"PostAreaLocaleOrderBy"
		},
		paginatePosts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		paginateSentPayments:{
			filter:"SentPaymentWhere",
			orderBy:"SentPaymentOrderBy"
		},
		paginateAreaSentPaymentCurrencySums:{
			filter:"PostAreaSentPaymentCurrencySumWhere",
			orderBy:"PostAreaSentPaymentCurrencySumOrderBy"
		},
		paginateAreaCurrencySums:{
			filter:"PostAreaCurrencySumWhere",
			orderBy:"PostAreaCurrencySumOrderBy"
		}
	},
	PostAreaLocale:{
		link:{
			filter:"LinkableWhere"
		},
		root:{
			filter:"PostAreaWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		banner:{
			filter:"AppBannerWhere"
		},
		content:{
			filter:"ContentWhere"
		}
	},
	AppBanner:{
		imageSmall:{
			filter:"ImageWhere"
		},
		imageBig:{
			filter:"ImageWhere"
		},
		textContent:{
			filter:"ContentWhere"
		}
	},
	DonationAmountsRegionList:{
		regions:{
			filter:"DonationAmountsRegionItemWhere",
			orderBy:"DonationAmountsRegionItemOrderBy"
		},
		donation:{
			filter:"DonationWhere"
		},
		regionsByRegion:{
			by:"DonationAmountsRegionListRegionsByRegionUniqueWhere",
			filter:"DonationAmountsRegionItemWhere"
		},
		regionsByItems:{
			by:"DonationAmountsRegionListRegionsByItemsUniqueWhere",
			filter:"DonationAmountsRegionItemWhere"
		},
		paginateRegions:{
			filter:"DonationAmountsRegionItemWhere",
			orderBy:"DonationAmountsRegionItemOrderBy"
		}
	},
	DonationAmountsRegionItem:{
		items:{
			filter:"DonationAmountItemWhere",
			orderBy:"DonationAmountItemOrderBy"
		},
		list:{
			filter:"DonationAmountsRegionListWhere"
		},
		region:{
			filter:"RegionWhere"
		},
		paginateItems:{
			filter:"DonationAmountItemWhere",
			orderBy:"DonationAmountItemOrderBy"
		}
	},
	DonationAmountItem:{
		regionItem:{
			filter:"DonationAmountsRegionItemWhere"
		}
	},
	DonationAmountItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		amount:"OrderDirection",
		regionItem:"DonationAmountsRegionItemOrderBy"
	},
	DonationAmountsRegionItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"DonationAmountsRegionListOrderBy",
		region:"RegionOrderBy",
		minimumAmount:"OrderDirection"
	},
	Region:{
		currency:{
			filter:"CurrencyWhere"
		},
		enabledPaymentMethods:{
			filter:"RegionPaymentMethodWhere",
			orderBy:"RegionPaymentMethodOrderBy"
		},
		donationItems:{
			filter:"DonationAmountsRegionItemWhere",
			orderBy:"DonationAmountsRegionItemOrderBy"
		},
		enabledPaymentMethodsByMethod:{
			by:"RegionEnabledPaymentMethodsByMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere"
		},
		donationItemsByList:{
			by:"RegionDonationItemsByListUniqueWhere",
			filter:"DonationAmountsRegionItemWhere"
		},
		donationItemsByItems:{
			by:"RegionDonationItemsByItemsUniqueWhere",
			filter:"DonationAmountsRegionItemWhere"
		},
		paginateEnabledPaymentMethods:{
			filter:"RegionPaymentMethodWhere",
			orderBy:"RegionPaymentMethodOrderBy"
		},
		paginateDonationItems:{
			filter:"DonationAmountsRegionItemWhere",
			orderBy:"DonationAmountsRegionItemOrderBy"
		}
	},
	Currency:{
		areaSentPaymentCurrencySums:{
			filter:"PostAreaSentPaymentCurrencySumWhere",
			orderBy:"PostAreaSentPaymentCurrencySumOrderBy"
		},
		areaCurrencySums:{
			filter:"PostAreaCurrencySumWhere",
			orderBy:"PostAreaCurrencySumOrderBy"
		},
		organizationCurrencySums:{
			filter:"PostOrganizationCurrencySumWhere",
			orderBy:"PostOrganizationCurrencySumOrderBy"
		},
		postCurrencySums:{
			filter:"PostCurrencySumWhere",
			orderBy:"PostCurrencySumOrderBy"
		},
		paginateAreaSentPaymentCurrencySums:{
			filter:"PostAreaSentPaymentCurrencySumWhere",
			orderBy:"PostAreaSentPaymentCurrencySumOrderBy"
		},
		paginateAreaCurrencySums:{
			filter:"PostAreaCurrencySumWhere",
			orderBy:"PostAreaCurrencySumOrderBy"
		},
		paginateOrganizationCurrencySums:{
			filter:"PostOrganizationCurrencySumWhere",
			orderBy:"PostOrganizationCurrencySumOrderBy"
		},
		paginatePostCurrencySums:{
			filter:"PostCurrencySumWhere",
			orderBy:"PostCurrencySumOrderBy"
		}
	},
	PostAreaSentPaymentCurrencySum:{
		currency:{
			filter:"CurrencyWhere"
		},
		area:{
			filter:"PostAreaWhere"
		}
	},
	PostAreaSentPaymentCurrencySumOrderBy:{
		id:"OrderDirection",
		currencyIdentifier:"OrderDirection",
		rateAgainstCzk:"OrderDirection",
		totalCents:"OrderDirection",
		currency:"CurrencyOrderBy",
		area:"PostAreaOrderBy"
	},
	PostAreaCurrencySum:{
		currency:{
			filter:"CurrencyWhere"
		},
		area:{
			filter:"PostAreaWhere"
		}
	},
	PostAreaCurrencySumOrderBy:{
		id:"OrderDirection",
		currencyIdentifier:"OrderDirection",
		rateAgainstCzk:"OrderDirection",
		totalCents:"OrderDirection",
		currency:"CurrencyOrderBy",
		area:"PostAreaOrderBy"
	},
	PostOrganizationCurrencySum:{
		currency:{
			filter:"CurrencyWhere"
		},
		organization:{
			filter:"PostOrganizationWhere"
		}
	},
	PostOrganizationCurrencySumOrderBy:{
		id:"OrderDirection",
		currencyIdentifier:"OrderDirection",
		rateAgainstCzk:"OrderDirection",
		totalCents:"OrderDirection",
		currency:"CurrencyOrderBy",
		organization:"PostOrganizationOrderBy"
	},
	PostCurrencySum:{
		currency:{
			filter:"CurrencyWhere"
		},
		post:{
			filter:"PostWhere"
		}
	},
	PostCurrencySumOrderBy:{
		id:"OrderDirection",
		currencyIdentifier:"OrderDirection",
		rateAgainstCzk:"OrderDirection",
		totalCents:"OrderDirection",
		currency:"CurrencyOrderBy",
		post:"PostOrderBy"
	},
	RegionPaymentMethod:{
		region:{
			filter:"RegionWhere"
		}
	},
	RegionPaymentMethodOrderBy:{
		id:"OrderDirection",
		allowRecurringPayments:"OrderDirection",
		region:"RegionOrderBy",
		method:"OrderDirection",
		order:"OrderDirection"
	},
	RegionEnabledPaymentMethodsByMethodUniqueWhere:{
		method:"PaymentMethods"
	},
	RegionDonationItemsByListUniqueWhere:{
		list:"DonationAmountsRegionListUniqueWhere"
	},
	RegionDonationItemsByItemsUniqueWhere:{
		items:"DonationAmountItemUniqueWhere"
	},
	Donation:{
		regionList:{
			filter:"DonationAmountsRegionListWhere"
		}
	},
	DonationAmountsRegionListRegionsByRegionUniqueWhere:{
		region:"RegionUniqueWhere"
	},
	DonationAmountsRegionListRegionsByItemsUniqueWhere:{
		items:"DonationAmountItemUniqueWhere"
	},
	PostAreaMetaData:{
		area:{
			filter:"PostAreaWhere"
		}
	},
	SentPayment:{
		currency:{
			filter:"CurrencyWhere"
		},
		area:{
			filter:"PostAreaWhere"
		},
		organization:{
			filter:"PostOrganizationWhere"
		},
		locales:{
			filter:"SentPaymentLocaleWhere",
			orderBy:"SentPaymentLocaleOrderBy"
		},
		localesByLocale:{
			by:"SentPaymentLocalesByLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere"
		},
		paginateLocales:{
			filter:"SentPaymentLocaleWhere",
			orderBy:"SentPaymentLocaleOrderBy"
		}
	},
	SentPaymentLocale:{
		root:{
			filter:"SentPaymentWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	SentPaymentLocaleOrderBy:{
		id:"OrderDirection",
		organizationText:"OrderDirection",
		root:"SentPaymentOrderBy",
		locale:"LocaleOrderBy"
	},
	SentPaymentOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		cents:"OrderDirection",
		sendAt:"OrderDirection",
		currency:"CurrencyOrderBy",
		area:"PostAreaOrderBy",
		organization:"PostOrganizationOrderBy"
	},
	SentPaymentLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PostAreaSentPaymentSum:{
		area:{
			filter:"PostAreaWhere"
		}
	},
	PostAreaSum:{
		area:{
			filter:"PostAreaWhere"
		}
	},
	PostAreaLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PostAreaLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	PostAreaLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	PostAreaLocalesByBannerUniqueWhere:{
		banner:"AppBannerUniqueWhere"
	},
	PostAreaLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	PostAreaPostsBySpecificSymbolUniqueWhere:{

	},
	PostAreaPostsByActiveRevisionUniqueWhere:{
		activeRevision:"PostRevisionUniqueWhere"
	},
	PostAreaPostsByRevisionsUniqueWhere:{
		revisions:"PostRevisionUniqueWhere"
	},
	PostAreaPostsByLocalesUniqueWhere:{
		locales:"PostLocaleUniqueWhere"
	},
	PostAreaPostsByMetaUniqueWhere:{
		meta:"PostMetaDataUniqueWhere"
	},
	PostAreaPostsByFundraiseCurrencySumsUniqueWhere:{
		fundraiseCurrencySums:"PostCurrencySumUniqueWhere"
	},
	PostAreaPostsByFundraiseSumUniqueWhere:{
		fundraiseSum:"PostSumUniqueWhere"
	},
	PostAreaPostsByFundraisingProgressUniqueWhere:{
		fundraisingProgress:"PostFundraisingProgressUniqueWhere"
	},
	PostAreaSentPaymentsByLocalesUniqueWhere:{
		locales:"SentPaymentLocaleUniqueWhere"
	},
	PostOrganizationMetaData:{
		organization:{
			filter:"PostOrganizationWhere"
		}
	},
	PostOrganizationSum:{
		organization:{
			filter:"PostOrganizationWhere"
		}
	},
	PostOrganizationPostsBySpecificSymbolUniqueWhere:{

	},
	PostOrganizationPostsByActiveRevisionUniqueWhere:{
		activeRevision:"PostRevisionUniqueWhere"
	},
	PostOrganizationPostsByRevisionsUniqueWhere:{
		revisions:"PostRevisionUniqueWhere"
	},
	PostOrganizationPostsByLocalesUniqueWhere:{
		locales:"PostLocaleUniqueWhere"
	},
	PostOrganizationPostsByMetaUniqueWhere:{
		meta:"PostMetaDataUniqueWhere"
	},
	PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere:{
		fundraiseCurrencySums:"PostCurrencySumUniqueWhere"
	},
	PostOrganizationPostsByFundraiseSumUniqueWhere:{
		fundraiseSum:"PostSumUniqueWhere"
	},
	PostOrganizationPostsByFundraisingProgressUniqueWhere:{
		fundraisingProgress:"PostFundraisingProgressUniqueWhere"
	},
	PostOrganizationLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PostOrganizationLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	PostOrganizationLocalesByDomainUniqueWhere:{
		domain:"LinkUniqueWhere"
	},
	PostOrganizationLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	PostOrganizationLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	PostOrganizationSentPaymentsByLocalesUniqueWhere:{
		locales:"SentPaymentLocaleUniqueWhere"
	},
	PostRevision:{
		post:{
			filter:"PostWhere"
		},
		tileImage:{
			filter:"ImageWhere"
		},
		tileVideo:{
			filter:"VideoWhere"
		},
		heroImage:{
			filter:"ImageWhere"
		},
		locales:{
			filter:"PostRevisionLocaleWhere",
			orderBy:"PostRevisionLocaleOrderBy"
		},
		regionListOverride:{
			filter:"DonationAmountsRegionListWhere"
		},
		localesByLocale:{
			by:"PostRevisionLocalesByLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		localesByContent:{
			by:"PostRevisionLocalesByContentUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		localesBySeo:{
			by:"PostRevisionLocalesBySeoUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		localesByLeadContent:{
			by:"PostRevisionLocalesByLeadContentUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		paginateLocales:{
			filter:"PostRevisionLocaleWhere",
			orderBy:"PostRevisionLocaleOrderBy"
		}
	},
	Video:{
		poster:{
			filter:"ImageWhere"
		}
	},
	PostRevisionLocale:{
		root:{
			filter:"PostRevisionWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		leadContent:{
			filter:"ContentWhere"
		}
	},
	PostRevisionLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		root:"PostRevisionOrderBy",
		locale:"LocaleOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		leadContent:"ContentOrderBy",
		publishNotificationText:"OrderDirection",
		translatedByAI:"OrderDirection"
	},
	PostRevisionLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PostRevisionLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	PostRevisionLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	PostRevisionLocalesByLeadContentUniqueWhere:{
		leadContent:"ContentUniqueWhere"
	},
	PostMetaData:{
		latestRevision:{
			filter:"PostRevisionWhere"
		},
		post:{
			filter:"PostWhere"
		}
	},
	HeroCarousel:{
		posts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		items:{
			filter:"HeroCarouselItemWhere",
			orderBy:"HeroCarouselItemOrderBy"
		},
		paginatePosts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		paginateItems:{
			filter:"HeroCarouselItemWhere",
			orderBy:"HeroCarouselItemOrderBy"
		}
	},
	HeroCarouselItem:{
		list:{
			filter:"HeroCarouselWhere"
		},
		item:{
			filter:"PostWhere"
		}
	},
	HeroCarouselItemOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		order:"OrderDirection",
		list:"HeroCarouselOrderBy",
		item:"PostOrderBy"
	},
	HeroCarouselOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection"
	},
	ReportPageLocale:{
		link:{
			filter:"LinkableWhere"
		},
		root:{
			filter:"ReportPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		posts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		paginatePosts:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		}
	},
	ReportPage:{
		locales:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		localesByLocale:{
			by:"ReportPageLocalesByLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		localesByLink:{
			by:"ReportPageLocalesByLinkUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		localesByContent:{
			by:"ReportPageLocalesByContentUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		localesBySeo:{
			by:"ReportPageLocalesBySeoUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		paginateLocales:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		}
	},
	ReportPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	ReportPageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	ReportPageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	ReportPageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	ContentReferenceOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		primaryText:"OrderDirection",
		block:"ContentBlockOrderBy",
		image:"ImageOrderBy",
		video:"VideoOrderBy",
		secondaryText:"OrderDirection",
		link:"LinkOrderBy",
		contentAlignment:"OrderDirection",
		valueList:"ValueListOrderBy",
		imageLinkList:"ImageLinkListOrderBy",
		areaList:"PostAreaListOrderBy",
		isAppsVisible:"OrderDirection",
		accordion:"AccordionOrderBy",
		media:"MediumListOrderBy",
		memberList:"MemberListOrderBy",
		asideMediaContentLayout:"OrderDirection",
		isAsideMediaContentMobileLayout:"OrderDirection",
		form:"FormOrderBy",
		isTitleBigger:"OrderDirection",
		contentWithoutBlocks:"ContentOrderBy",
		heroCarousel:"HeroCarouselOrderBy",
		organizationList:"PostOrganizationListOrderBy",
		isCentered:"OrderDirection",
		textImageList:"TextImageListOrderBy"
	},
	ContentBlockOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		json:"OrderDirection",
		content:"ContentOrderBy"
	},
	ValueListOrderBy:{
		id:"OrderDirection"
	},
	ImageLinkListOrderBy:{
		id:"OrderDirection"
	},
	PostAreaListOrderBy:{
		id:"OrderDirection"
	},
	AccordionOrderBy:{
		id:"OrderDirection"
	},
	MediumListOrderBy:{
		id:"OrderDirection"
	},
	MemberListOrderBy:{
		id:"OrderDirection"
	},
	FormOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		type:"OrderDirection",
		tax:"FilledTaxFormOrderBy"
	},
	FilledTaxFormOrderBy:{
		id:"OrderDirection",
		publishedAt:"OrderDirection",
		userId:"OrderDirection",
		email:"OrderDirection",
		name:"OrderDirection",
		vatId:"OrderDirection",
		address1:"OrderDirection",
		address2:"OrderDirection",
		city:"OrderDirection",
		postalCode:"OrderDirection",
		state:"OrderDirection",
		country:"RegionOrderBy",
		dateFrom:"OrderDirection",
		dateTo:"OrderDirection",
		year:"OrderDirection",
		isPdfGenerated:"OrderDirection",
		pdfObjectKey:"OrderDirection"
	},
	TextImageListOrderBy:{
		id:"OrderDirection"
	},
	PostSum:{
		post:{
			filter:"PostWhere"
		}
	},
	PostFundraisingProgress:{
		post:{
			filter:"PostWhere"
		}
	},
	PostRevisionsByLocalesUniqueWhere:{
		locales:"PostRevisionLocaleUniqueWhere"
	},
	PostRevisionsByRegionListOverrideUniqueWhere:{
		regionListOverride:"DonationAmountsRegionListUniqueWhere"
	},
	PostLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PostLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	PostLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	PostLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	GivenGiftsPageLocale:{
		root:{
			filter:"GivenGiftsPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		link:{
			filter:"LinkableWhere"
		}
	},
	GivenGiftsPage:{
		locales:{
			filter:"GivenGiftsPageLocaleWhere",
			orderBy:"GivenGiftsPageLocaleOrderBy"
		},
		localesByLocale:{
			by:"GivenGiftsPageLocalesByLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		localesByContent:{
			by:"GivenGiftsPageLocalesByContentUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		localesBySeo:{
			by:"GivenGiftsPageLocalesBySeoUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		localesByLink:{
			by:"GivenGiftsPageLocalesByLinkUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		paginateLocales:{
			filter:"GivenGiftsPageLocaleWhere",
			orderBy:"GivenGiftsPageLocaleOrderBy"
		}
	},
	GivenGiftsPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	GivenGiftsPageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	GivenGiftsPageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	GivenGiftsPageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	ReceivedGiftsPageLocale:{
		link:{
			filter:"LinkableWhere"
		},
		root:{
			filter:"ReceivedGiftsPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		}
	},
	ReceivedGiftsPage:{
		locales:{
			filter:"ReceivedGiftsPageLocaleWhere",
			orderBy:"ReceivedGiftsPageLocaleOrderBy"
		},
		localesByLocale:{
			by:"ReceivedGiftsPageLocalesByLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		localesByLink:{
			by:"ReceivedGiftsPageLocalesByLinkUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		localesByContent:{
			by:"ReceivedGiftsPageLocalesByContentUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		localesBySeo:{
			by:"ReceivedGiftsPageLocalesBySeoUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		paginateLocales:{
			filter:"ReceivedGiftsPageLocaleWhere",
			orderBy:"ReceivedGiftsPageLocaleOrderBy"
		}
	},
	ReceivedGiftsPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	ReceivedGiftsPageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	ReceivedGiftsPageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	ReceivedGiftsPageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	ContentReferenceLinkableItemOrderBy:{
		id:"OrderDirection",
		item:"LinkableOrderBy",
		reference:"ContentReferenceOrderBy"
	},
	ValueList:{
		items:{
			filter:"ValueItemWhere",
			orderBy:"ValueItemOrderBy"
		},
		paginateItems:{
			filter:"ValueItemWhere",
			orderBy:"ValueItemOrderBy"
		}
	},
	ValueItem:{
		list:{
			filter:"ValueListWhere"
		},
		item:{
			filter:"ValueWhere"
		}
	},
	Value:{
		textContent:{
			filter:"ContentWhere"
		}
	},
	ValueItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"ValueListOrderBy",
		item:"ValueOrderBy"
	},
	ValueOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		textContent:"ContentOrderBy"
	},
	ImageLinkList:{
		items:{
			filter:"ImageLinkItemWhere",
			orderBy:"ImageLinkItemOrderBy"
		},
		paginateItems:{
			filter:"ImageLinkItemWhere",
			orderBy:"ImageLinkItemOrderBy"
		}
	},
	ImageLinkItem:{
		list:{
			filter:"ImageLinkListWhere"
		},
		item:{
			filter:"ImageLinkWhere"
		}
	},
	ImageLink:{
		image:{
			filter:"ImageWhere"
		},
		link:{
			filter:"LinkWhere"
		}
	},
	ImageLinkItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"ImageLinkListOrderBy",
		item:"ImageLinkOrderBy"
	},
	ImageLinkOrderBy:{
		id:"OrderDirection",
		image:"ImageOrderBy",
		link:"LinkOrderBy"
	},
	PostAreaList:{
		items:{
			filter:"PostAreaListItemWhere",
			orderBy:"PostAreaListItemOrderBy"
		},
		paginateItems:{
			filter:"PostAreaListItemWhere",
			orderBy:"PostAreaListItemOrderBy"
		}
	},
	PostAreaListItem:{
		list:{
			filter:"PostAreaListWhere"
		},
		item:{
			filter:"PostAreaWhere"
		}
	},
	PostAreaListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"PostAreaListOrderBy",
		item:"PostAreaOrderBy"
	},
	Accordion:{
		items:{
			filter:"AccordionItemWhere",
			orderBy:"AccordionItemOrderBy"
		},
		itemsByDescriptionContent:{
			by:"AccordionItemsByDescriptionContentUniqueWhere",
			filter:"AccordionItemWhere"
		},
		paginateItems:{
			filter:"AccordionItemWhere",
			orderBy:"AccordionItemOrderBy"
		}
	},
	AccordionItem:{
		list:{
			filter:"AccordionWhere"
		},
		descriptionContent:{
			filter:"ContentWhere"
		}
	},
	AccordionItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		name:"OrderDirection",
		list:"AccordionOrderBy",
		descriptionContent:"ContentOrderBy"
	},
	AccordionItemsByDescriptionContentUniqueWhere:{
		descriptionContent:"ContentUniqueWhere"
	},
	MediumList:{
		items:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		paginateItems:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		}
	},
	MediumItem:{
		list:{
			filter:"MediumListWhere"
		},
		medium:{
			filter:"MediumWhere"
		}
	},
	Medium:{
		image:{
			filter:"ImageWhere"
		},
		video:{
			filter:"VideoWhere"
		}
	},
	MediumItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"MediumListOrderBy",
		medium:"MediumOrderBy"
	},
	MediumOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		image:"ImageOrderBy",
		video:"VideoOrderBy"
	},
	MemberList:{
		items:{
			filter:"MemberListItemWhere",
			orderBy:"MemberListItemOrderBy"
		},
		itemsByDescriptionContent:{
			by:"MemberListItemsByDescriptionContentUniqueWhere",
			filter:"MemberListItemWhere"
		},
		paginateItems:{
			filter:"MemberListItemWhere",
			orderBy:"MemberListItemOrderBy"
		}
	},
	MemberListItem:{
		list:{
			filter:"MemberListWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		descriptionContent:{
			filter:"ContentWhere"
		}
	},
	MemberListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		name:"OrderDirection",
		position:"OrderDirection",
		list:"MemberListOrderBy",
		image:"ImageOrderBy",
		descriptionContent:"ContentOrderBy"
	},
	MemberListItemsByDescriptionContentUniqueWhere:{
		descriptionContent:"ContentUniqueWhere"
	},
	Form:{
		tax:{
			filter:"FilledTaxFormWhere"
		}
	},
	FilledTaxForm:{
		country:{
			filter:"RegionWhere"
		}
	},
	PostOrganizationList:{
		items:{
			filter:"PostOrganizationListItemWhere",
			orderBy:"PostOrganizationListItemOrderBy"
		},
		itemsByLink:{
			by:"PostOrganizationListItemsByLinkUniqueWhere",
			filter:"PostOrganizationListItemWhere"
		},
		paginateItems:{
			filter:"PostOrganizationListItemWhere",
			orderBy:"PostOrganizationListItemOrderBy"
		}
	},
	PostOrganizationListItem:{
		list:{
			filter:"PostOrganizationListWhere"
		},
		item:{
			filter:"PostOrganizationWhere"
		},
		link:{
			filter:"LinkWhere"
		},
		image:{
			filter:"ImageWhere"
		}
	},
	PostOrganizationListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"PostOrganizationListOrderBy",
		item:"PostOrganizationOrderBy",
		type:"OrderDirection",
		link:"LinkOrderBy",
		image:"ImageOrderBy"
	},
	PostOrganizationListItemsByLinkUniqueWhere:{
		link:"LinkUniqueWhere"
	},
	TextImageList:{
		items:{
			filter:"TextImageListItemWhere",
			orderBy:"TextImageListItemOrderBy"
		},
		paginateItems:{
			filter:"TextImageListItemWhere",
			orderBy:"TextImageListItemOrderBy"
		}
	},
	TextImageListItem:{
		list:{
			filter:"TextImageListWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		link:{
			filter:"LinkWhere"
		}
	},
	TextImageListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"TextImageListOrderBy",
		image:"ImageOrderBy",
		text:"OrderDirection",
		link:"LinkOrderBy"
	},
	ContentReferenceLinkablesByItemUniqueWhere:{
		item:"LinkableUniqueWhere"
	},
	ContentBlockReferencesByLinkablesUniqueWhere:{
		linkables:"ContentReferenceLinkableItemUniqueWhere"
	},
	ContentBlockReferencesByLinkUniqueWhere:{
		link:"LinkUniqueWhere"
	},
	ContentBlockReferencesByValueListUniqueWhere:{
		valueList:"ValueListUniqueWhere"
	},
	ContentBlockReferencesByImageLinkListUniqueWhere:{
		imageLinkList:"ImageLinkListUniqueWhere"
	},
	ContentBlockReferencesByAreaListUniqueWhere:{
		areaList:"PostAreaListUniqueWhere"
	},
	ContentBlockReferencesByAccordionUniqueWhere:{
		accordion:"AccordionUniqueWhere"
	},
	ContentBlockReferencesByMediaUniqueWhere:{
		media:"MediumListUniqueWhere"
	},
	ContentBlockReferencesByMemberListUniqueWhere:{
		memberList:"MemberListUniqueWhere"
	},
	ContentBlockReferencesByContentWithoutBlocksUniqueWhere:{
		contentWithoutBlocks:"ContentUniqueWhere"
	},
	ContentBlockReferencesByOrganizationListUniqueWhere:{
		organizationList:"PostOrganizationListUniqueWhere"
	},
	ContentBlockReferencesByTextImageListUniqueWhere:{
		textImageList:"TextImageListUniqueWhere"
	},
	ContentBlocksByReferencesUniqueWhere:{
		references:"ContentReferenceUniqueWhere"
	},
	HeaderLocale:{
		root:{
			filter:"HeaderWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		links:{
			filter:"LinkListWhere"
		}
	},
	Header:{
		logo:{
			filter:"ImageWhere"
		},
		locales:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		organizationList:{
			filter:"PostOrganizationListWhere"
		},
		localesByLocale:{
			by:"HeaderLocalesByLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		localesByLinks:{
			by:"HeaderLocalesByLinksUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		paginateLocales:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		}
	},
	HeaderLocaleOrderBy:{
		id:"OrderDirection",
		root:"HeaderOrderBy",
		locale:"LocaleOrderBy",
		links:"LinkListOrderBy"
	},
	HeaderOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		logo:"ImageOrderBy",
		organizationList:"PostOrganizationListOrderBy"
	},
	LinkListOrderBy:{
		id:"OrderDirection"
	},
	HeaderLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	HeaderLocalesByLinksUniqueWhere:{
		links:"LinkListUniqueWhere"
	},
	LinkList:{
		items:{
			filter:"LinkItemWhere",
			orderBy:"LinkItemOrderBy"
		},
		itemsByLink:{
			by:"LinkListItemsByLinkUniqueWhere",
			filter:"LinkItemWhere"
		},
		paginateItems:{
			filter:"LinkItemWhere",
			orderBy:"LinkItemOrderBy"
		}
	},
	LinkItem:{
		list:{
			filter:"LinkListWhere"
		},
		link:{
			filter:"LinkWhere"
		}
	},
	LinkItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"LinkListOrderBy",
		link:"LinkOrderBy"
	},
	LinkListItemsByLinkUniqueWhere:{
		link:"LinkUniqueWhere"
	},
	FooterLocale:{
		root:{
			filter:"FooterWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		linkList:{
			filter:"LinkListWhere"
		},
		addressInfo:{
			filter:"ContentWhere"
		},
		imageLinkList:{
			filter:"ImageLinkListWhere"
		}
	},
	Footer:{
		locales:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		logo:{
			filter:"ImageWhere"
		},
		localesByLocale:{
			by:"FooterLocalesByLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByLinkList:{
			by:"FooterLocalesByLinkListUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByAddressInfo:{
			by:"FooterLocalesByAddressInfoUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByImageLinkList:{
			by:"FooterLocalesByImageLinkListUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		paginateLocales:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		}
	},
	FooterLocaleOrderBy:{
		id:"OrderDirection",
		copyright:"OrderDirection",
		root:"FooterOrderBy",
		locale:"LocaleOrderBy",
		linkList:"LinkListOrderBy",
		contactEmail:"OrderDirection",
		addressInfo:"ContentOrderBy",
		imageLinkList:"ImageLinkListOrderBy"
	},
	FooterOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		logo:"ImageOrderBy"
	},
	FooterLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	FooterLocalesByLinkListUniqueWhere:{
		linkList:"LinkListUniqueWhere"
	},
	FooterLocalesByAddressInfoUniqueWhere:{
		addressInfo:"ContentUniqueWhere"
	},
	FooterLocalesByImageLinkListUniqueWhere:{
		imageLinkList:"ImageLinkListUniqueWhere"
	},
	GenericPageAboutSettingsLocale:{
		root:{
			filter:"GenericPageAboutSettingsWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		linkGroups:{
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			orderBy:"GenericPageAboutGroupLinksLocaleOrderBy"
		},
		linkGroupsByLinkList:{
			by:"GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere"
		},
		paginateLinkGroups:{
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			orderBy:"GenericPageAboutGroupLinksLocaleOrderBy"
		}
	},
	GenericPageAboutSettings:{
		locales:{
			filter:"GenericPageAboutSettingsLocaleWhere",
			orderBy:"GenericPageAboutSettingsLocaleOrderBy"
		},
		localesByLocale:{
			by:"GenericPageAboutSettingsLocalesByLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		localesByLinkGroups:{
			by:"GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		paginateLocales:{
			filter:"GenericPageAboutSettingsLocaleWhere",
			orderBy:"GenericPageAboutSettingsLocaleOrderBy"
		}
	},
	GenericPageAboutSettingsLocaleOrderBy:{
		id:"OrderDirection",
		root:"GenericPageAboutSettingsOrderBy",
		locale:"LocaleOrderBy"
	},
	GenericPageAboutSettingsOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	GenericPageAboutSettingsLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere:{
		linkGroups:"GenericPageAboutGroupLinksLocaleUniqueWhere"
	},
	GenericPageAboutGroupLinksLocale:{
		settings:{
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		linkList:{
			filter:"LinkListWhere"
		}
	},
	GenericPageAboutGroupLinksLocaleOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		settings:"GenericPageAboutSettingsLocaleOrderBy",
		linkList:"LinkListOrderBy"
	},
	GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere:{
		linkList:"LinkListUniqueWhere"
	},
	FeedPageLocale:{
		root:{
			filter:"FeedPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		heroTiles:{
			filter:"TileListWhere"
		},
		sectionList:{
			filter:"FeedPageSectionWhere",
			orderBy:"FeedPageSectionOrderBy"
		},
		cardList:{
			filter:"CardListWhere"
		},
		storyGuideList:{
			filter:"StoryGuideListWhere"
		},
		sectionListByTileStripeList:{
			by:"FeedPageLocaleSectionListByTileStripeListUniqueWhere",
			filter:"FeedPageSectionWhere"
		},
		paginateSectionList:{
			filter:"FeedPageSectionWhere",
			orderBy:"FeedPageSectionOrderBy"
		}
	},
	FeedPage:{
		locales:{
			filter:"FeedPageLocaleWhere",
			orderBy:"FeedPageLocaleOrderBy"
		},
		localesByLocale:{
			by:"FeedPageLocalesByLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		localesByHeroTiles:{
			by:"FeedPageLocalesByHeroTilesUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		localesBySectionList:{
			by:"FeedPageLocalesBySectionListUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		localesByCardList:{
			by:"FeedPageLocalesByCardListUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		localesByStoryGuideList:{
			by:"FeedPageLocalesByStoryGuideListUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		paginateLocales:{
			filter:"FeedPageLocaleWhere",
			orderBy:"FeedPageLocaleOrderBy"
		}
	},
	FeedPageLocaleOrderBy:{
		id:"OrderDirection",
		root:"FeedPageOrderBy",
		locale:"LocaleOrderBy",
		heroTiles:"TileListOrderBy",
		cardList:"CardListOrderBy",
		storyGuideList:"StoryGuideListOrderBy"
	},
	FeedPageOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	TileListOrderBy:{
		id:"OrderDirection",
		size:"OrderDirection",
		title:"OrderDirection",
		areaType:"PostAreaOrderBy"
	},
	CardListOrderBy:{
		id:"OrderDirection"
	},
	StoryGuideListOrderBy:{
		id:"OrderDirection"
	},
	FeedPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	FeedPageLocalesByHeroTilesUniqueWhere:{
		heroTiles:"TileListUniqueWhere"
	},
	FeedPageLocalesBySectionListUniqueWhere:{
		sectionList:"FeedPageSectionUniqueWhere"
	},
	FeedPageLocalesByCardListUniqueWhere:{
		cardList:"CardListUniqueWhere"
	},
	FeedPageLocalesByStoryGuideListUniqueWhere:{
		storyGuideList:"StoryGuideListUniqueWhere"
	},
	TileList:{
		items:{
			filter:"TileItemWhere",
			orderBy:"TileItemOrderBy"
		},
		areaType:{
			filter:"PostAreaWhere"
		},
		itemsByLink:{
			by:"TileListItemsByLinkUniqueWhere",
			filter:"TileItemWhere"
		},
		paginateItems:{
			filter:"TileItemWhere",
			orderBy:"TileItemOrderBy"
		}
	},
	TileItem:{
		list:{
			filter:"TileListWhere"
		},
		post:{
			filter:"PostWhere"
		},
		area:{
			filter:"PostAreaWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		link:{
			filter:"LinkWhere"
		},
		organization:{
			filter:"PostOrganizationWhere"
		}
	},
	TileItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		type:"OrderDirection",
		title:"OrderDirection",
		description:"OrderDirection",
		list:"TileListOrderBy",
		post:"PostOrderBy",
		area:"PostAreaOrderBy",
		image:"ImageOrderBy",
		link:"LinkOrderBy",
		organization:"PostOrganizationOrderBy"
	},
	TileListItemsByLinkUniqueWhere:{
		link:"LinkUniqueWhere"
	},
	FeedPageSection:{
		feedPageLocale:{
			filter:"FeedPageLocaleWhere"
		},
		tileStripeList:{
			filter:"FeedPageTileStripeWhere",
			orderBy:"FeedPageTileStripeOrderBy"
		},
		paginateTileStripeList:{
			filter:"FeedPageTileStripeWhere",
			orderBy:"FeedPageTileStripeOrderBy"
		}
	},
	FeedPageTileStripe:{
		section:{
			filter:"FeedPageSectionWhere"
		},
		tileList:{
			filter:"TileListWhere"
		}
	},
	FeedPageTileStripeOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		section:"FeedPageSectionOrderBy",
		tileList:"TileListOrderBy"
	},
	FeedPageSectionOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		feedPageLocale:"FeedPageLocaleOrderBy"
	},
	CardList:{
		items:{
			filter:"CardItemWhere",
			orderBy:"CardItemOrderBy"
		},
		itemsByLink:{
			by:"CardListItemsByLinkUniqueWhere",
			filter:"CardItemWhere"
		},
		paginateItems:{
			filter:"CardItemWhere",
			orderBy:"CardItemOrderBy"
		}
	},
	CardItem:{
		list:{
			filter:"CardListWhere"
		},
		link:{
			filter:"LinkWhere"
		}
	},
	CardItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		description:"OrderDirection",
		list:"CardListOrderBy",
		link:"LinkOrderBy"
	},
	CardListItemsByLinkUniqueWhere:{
		link:"LinkUniqueWhere"
	},
	StoryGuideList:{
		items:{
			filter:"StoryGuideItemWhere",
			orderBy:"StoryGuideItemOrderBy"
		},
		paginateItems:{
			filter:"StoryGuideItemWhere",
			orderBy:"StoryGuideItemOrderBy"
		}
	},
	StoryGuideItem:{
		list:{
			filter:"StoryGuideListWhere"
		},
		guide:{
			filter:"StoryGuideWhere"
		}
	},
	StoryGuide:{
		image:{
			filter:"ImageWhere"
		},
		secondaryImage:{
			filter:"ImageWhere"
		}
	},
	StoryGuideItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"StoryGuideListOrderBy",
		guide:"StoryGuideOrderBy"
	},
	StoryGuideOrderBy:{
		id:"OrderDirection",
		mediaType:"OrderDirection",
		title:"OrderDirection",
		subtitle:"OrderDirection",
		image:"ImageOrderBy",
		secondaryImage:"ImageOrderBy"
	},
	FeedPageLocaleSectionListByTileStripeListUniqueWhere:{
		tileStripeList:"FeedPageTileStripeUniqueWhere"
	},
	RecurringPaymentPageLocale:{
		root:{
			filter:"RecurringPaymentPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		favouritePosts:{
			filter:"PostListWhere"
		},
		storyGuideList:{
			filter:"StoryGuideListWhere"
		}
	},
	RecurringPaymentPage:{
		locales:{
			filter:"RecurringPaymentPageLocaleWhere",
			orderBy:"RecurringPaymentPageLocaleOrderBy"
		},
		localesByLocale:{
			by:"RecurringPaymentPageLocalesByLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		localesByFavouritePosts:{
			by:"RecurringPaymentPageLocalesByFavouritePostsUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		localesByStoryGuideList:{
			by:"RecurringPaymentPageLocalesByStoryGuideListUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		paginateLocales:{
			filter:"RecurringPaymentPageLocaleWhere",
			orderBy:"RecurringPaymentPageLocaleOrderBy"
		}
	},
	RecurringPaymentPageLocaleOrderBy:{
		id:"OrderDirection",
		root:"RecurringPaymentPageOrderBy",
		locale:"LocaleOrderBy",
		favouritePosts:"PostListOrderBy",
		storyGuideList:"StoryGuideListOrderBy"
	},
	RecurringPaymentPageOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	PostListOrderBy:{
		id:"OrderDirection"
	},
	RecurringPaymentPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	RecurringPaymentPageLocalesByFavouritePostsUniqueWhere:{
		favouritePosts:"PostListUniqueWhere"
	},
	RecurringPaymentPageLocalesByStoryGuideListUniqueWhere:{
		storyGuideList:"StoryGuideListUniqueWhere"
	},
	PostList:{
		items:{
			filter:"PostListItemWhere",
			orderBy:"PostListItemOrderBy"
		},
		paginateItems:{
			filter:"PostListItemWhere",
			orderBy:"PostListItemOrderBy"
		}
	},
	PostListItem:{
		list:{
			filter:"PostListWhere"
		},
		post:{
			filter:"PostWhere"
		}
	},
	PostListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"PostListOrderBy",
		post:"PostOrderBy"
	},
	ScheduledNotificationLocale:{
		root:{
			filter:"ScheduledNotificationWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	ScheduledNotification:{
		target:{
			filter:"NotificationTargetGroupWhere"
		},
		locales:{
			filter:"ScheduledNotificationLocaleWhere",
			orderBy:"ScheduledNotificationLocaleOrderBy"
		},
		image:{
			filter:"ImageWhere"
		},
		processedNotifications:{
			filter:"ProcessedNotificationSourceWhere",
			orderBy:"ProcessedNotificationSourceOrderBy"
		},
		localesByLocale:{
			by:"ScheduledNotificationLocalesByLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere"
		},
		processedNotificationsByProcessedNotification:{
			by:"ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationSourceWhere"
		},
		paginateLocales:{
			filter:"ScheduledNotificationLocaleWhere",
			orderBy:"ScheduledNotificationLocaleOrderBy"
		},
		paginateProcessedNotifications:{
			filter:"ProcessedNotificationSourceWhere",
			orderBy:"ProcessedNotificationSourceOrderBy"
		}
	},
	NotificationTargetGroup:{
		regions:{
			filter:"RegionWhere",
			orderBy:"RegionOrderBy"
		},
		paginateRegions:{
			filter:"RegionWhere",
			orderBy:"RegionOrderBy"
		}
	},
	ScheduledNotificationLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		description:"OrderDirection",
		root:"ScheduledNotificationOrderBy",
		locale:"LocaleOrderBy"
	},
	ScheduledNotificationOrderBy:{
		id:"OrderDirection",
		localMsFromMidnight:"OrderDirection",
		scheduledDate:"OrderDirection",
		internalTitle:"OrderDirection",
		target:"NotificationTargetGroupOrderBy",
		image:"ImageOrderBy",
		completedAt:"OrderDirection"
	},
	NotificationTargetGroupOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection"
	},
	ProcessedNotificationSource:{
		processedNotification:{
			filter:"ProcessedNotificationWhere"
		},
		donationReminderUser:{
			filter:"UserWhere"
		},
		scheduledNotification:{
			filter:"ScheduledNotificationWhere"
		}
	},
	ProcessedNotification:{
		source:{
			filter:"ProcessedNotificationSourceWhere"
		}
	},
	User:{
		payments:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		region:{
			filter:"RegionWhere"
		},
		currency:{
			filter:"CurrencyWhere"
		},
		recurringPayments:{
			filter:"UserRecurringPaymentWhere",
			orderBy:"UserRecurringPaymentOrderBy"
		},
		onBehalfDonations:{
			filter:"OnBehalfDonationWhere",
			orderBy:"OnBehalfDonationOrderBy"
		},
		locale:{
			filter:"LocaleWhere"
		},
		devices:{
			filter:"DeviceWhere",
			orderBy:"DeviceOrderBy"
		},
		processedNotifications:{
			filter:"ProcessedNotificationSourceWhere",
			orderBy:"ProcessedNotificationSourceOrderBy"
		},
		areaStats:{
			filter:"UserAreaStatsWhere",
			orderBy:"UserAreaStatsOrderBy"
		},
		organizationStats:{
			filter:"UserOrganizationStatsWhere",
			orderBy:"UserOrganizationStatsOrderBy"
		},
		postStats:{
			filter:"UserPostStatsWhere",
			orderBy:"UserPostStatsOrderBy"
		},
		currencyStats:{
			filter:"UserCurrencyStatsWhere",
			orderBy:"UserCurrencyStatsOrderBy"
		},
		stats:{
			filter:"UserStatsWhere"
		},
		paymentsByOrder:{
			by:"UserPaymentsByOrderUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByCsobPayment:{
			by:"UserPaymentsByCsobPaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByStripePayment:{
			by:"UserPaymentsByStripePaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByMetadata:{
			by:"UserPaymentsByMetadataUniqueWhere",
			filter:"UserPaymentWhere"
		},
		recurringPaymentsByItems:{
			by:"UserRecurringPaymentsByItemsUniqueWhere",
			filter:"UserRecurringPaymentWhere"
		},
		recurringPaymentsByMeta:{
			by:"UserRecurringPaymentsByMetaUniqueWhere",
			filter:"UserRecurringPaymentWhere"
		},
		onBehalfDonationsBySecretCode:{
			by:"UserOnBehalfDonationsBySecretCodeUniqueWhere",
			filter:"OnBehalfDonationWhere"
		},
		onBehalfDonationsByPayments:{
			by:"UserOnBehalfDonationsByPaymentsUniqueWhere",
			filter:"OnBehalfDonationWhere"
		},
		onBehalfDonationsByMeta:{
			by:"UserOnBehalfDonationsByMetaUniqueWhere",
			filter:"OnBehalfDonationWhere"
		},
		devicesByFcmToken:{
			by:"UserDevicesByFcmTokenUniqueWhere",
			filter:"DeviceWhere"
		},
		processedNotificationsByProcessedNotification:{
			by:"UserProcessedNotificationsByProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationSourceWhere"
		},
		paginatePayments:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		paginateRecurringPayments:{
			filter:"UserRecurringPaymentWhere",
			orderBy:"UserRecurringPaymentOrderBy"
		},
		paginateOnBehalfDonations:{
			filter:"OnBehalfDonationWhere",
			orderBy:"OnBehalfDonationOrderBy"
		},
		paginateDevices:{
			filter:"DeviceWhere",
			orderBy:"DeviceOrderBy"
		},
		paginateProcessedNotifications:{
			filter:"ProcessedNotificationSourceWhere",
			orderBy:"ProcessedNotificationSourceOrderBy"
		},
		paginateAreaStats:{
			filter:"UserAreaStatsWhere",
			orderBy:"UserAreaStatsOrderBy"
		},
		paginateOrganizationStats:{
			filter:"UserOrganizationStatsWhere",
			orderBy:"UserOrganizationStatsOrderBy"
		},
		paginatePostStats:{
			filter:"UserPostStatsWhere",
			orderBy:"UserPostStatsOrderBy"
		},
		paginateCurrencyStats:{
			filter:"UserCurrencyStatsWhere",
			orderBy:"UserCurrencyStatsOrderBy"
		}
	},
	UserPayment:{
		currency:{
			filter:"CurrencyWhere"
		},
		order:{
			filter:"UserPaymentOrderIdWhere"
		},
		csobPayment:{
			filter:"CsobPaymentWhere"
		},
		stripePayment:{
			filter:"StripePaymentWhere"
		},
		recurringPaymentItem:{
			filter:"UserRecurringPaymentItemWhere"
		},
		region:{
			filter:"RegionWhere"
		},
		user:{
			filter:"UserWhere"
		},
		onBehalfDonation:{
			filter:"OnBehalfDonationWhere"
		},
		triesCollection:{
			filter:"UserPaymentTriesCollectionWhere"
		},
		metadata:{
			filter:"UserPaymentMetadataWhere"
		}
	},
	CsobPayment:{
		statusChanges:{
			filter:"CsobPaymentStatusChangeWhere",
			orderBy:"CsobPaymentStatusChangeOrderBy"
		},
		payment:{
			filter:"UserPaymentWhere"
		},
		metadata:{
			filter:"CsobPaymentMetadataWhere"
		},
		paginateStatusChanges:{
			filter:"CsobPaymentStatusChangeWhere",
			orderBy:"CsobPaymentStatusChangeOrderBy"
		}
	},
	CsobPaymentStatusChange:{
		payment:{
			filter:"CsobPaymentWhere"
		}
	},
	CsobPaymentStatusChangeOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		dttm:"OrderDirection",
		status:"OrderDirection",
		resultCode:"OrderDirection",
		message:"OrderDirection",
		authCode:"OrderDirection",
		statusDetail:"OrderDirection",
		actions:"OrderDirection",
		payment:"CsobPaymentOrderBy"
	},
	CsobPaymentOrderBy:{
		id:"OrderDirection",
		payId:"OrderDirection",
		payment:"UserPaymentOrderBy",
		originalPayId:"OrderDirection",
		metadata:"CsobPaymentMetadataOrderBy"
	},
	UserPaymentOrderBy:{
		id:"OrderDirection",
		cents:"OrderDirection",
		createdAt:"OrderDirection",
		specificSymbol:"OrderDirection",
		currency:"CurrencyOrderBy",
		order:"UserPaymentOrderIdOrderBy",
		csobPayment:"CsobPaymentOrderBy",
		stripePayment:"StripePaymentOrderBy",
		recurringPaymentItem:"UserRecurringPaymentItemOrderBy",
		method:"OrderDirection",
		region:"RegionOrderBy",
		user:"UserOrderBy",
		isReusable:"OrderDirection",
		onBehalfDonation:"OnBehalfDonationOrderBy",
		triesCollection:"UserPaymentTriesCollectionOrderBy",
		successEmailSentAt:"OrderDirection",
		isSuccessful:"OrderDirection",
		isFinished:"OrderDirection",
		metadata:"UserPaymentMetadataOrderBy"
	},
	UserPaymentOrderIdOrderBy:{
		id:"OrderDirection",
		seq:"OrderDirection"
	},
	StripePaymentOrderBy:{
		id:"OrderDirection",
		identifier:"OrderDirection",
		payment:"UserPaymentOrderBy",
		metadata:"StripePaymentMetadataOrderBy"
	},
	StripePaymentMetadataOrderBy:{
		id:"OrderDirection",
		status:"OrderDirection",
		isSuccessful:"OrderDirection",
		isFinished:"OrderDirection",
		stripePayment:"StripePaymentOrderBy"
	},
	UserRecurringPaymentItemOrderBy:{
		id:"OrderDirection",
		recurrenceCounter:"OrderDirection",
		createdAt:"OrderDirection",
		taskId:"OrderDirection",
		recurringPayment:"UserRecurringPaymentOrderBy",
		isFailed:"OrderDirection",
		failedEmailSentAt:"OrderDirection",
		meta:"UserRecurringPaymentItemMetadataOrderBy"
	},
	UserRecurringPaymentOrderBy:{
		id:"OrderDirection",
		activeSince:"OrderDirection",
		cancelledAt:"OrderDirection",
		cents:"OrderDirection",
		interval:"OrderDirection",
		currency:"CurrencyOrderBy",
		user:"UserOrderBy",
		meta:"UpcomingUserRecurringPaymentMetadataOrderBy"
	},
	UserOrderBy:{
		id:"OrderDirection",
		tenantPersonId:"OrderDirection",
		createdAt:"OrderDirection",
		email:"OrderDirection",
		name:"OrderDirection",
		variableSymbol:"OrderDirection",
		lastActiveAt:"OrderDirection",
		region:"RegionOrderBy",
		currency:"CurrencyOrderBy",
		stripeId:"OrderDirection",
		isDeactivated:"OrderDirection",
		publicProfileSecret:"OrderDirection",
		publicProfileCustomNote:"OrderDirection",
		publicProfileCustomNoteEnabled:"OrderDirection",
		donationConfirmationEmailEnabled:"OrderDirection",
		locale:"LocaleOrderBy",
		signedUp:"OrderDirection",
		stats:"UserStatsOrderBy"
	},
	UserStatsOrderBy:{
		id:"OrderDirection",
		totalPaymentsSuccessful:"OrderDirection",
		totalPaymentsUnsuccessful:"OrderDirection",
		user:"UserOrderBy"
	},
	UpcomingUserRecurringPaymentMetadataOrderBy:{
		id:"OrderDirection",
		recurrenceCounter:"OrderDirection",
		isBehindPayments:"OrderDirection",
		nextPaymentDate:"OrderDirection",
		shouldBeProcessed:"OrderDirection",
		firstPayment:"UserPaymentOrderBy",
		firstSuccessfulPayment:"UserPaymentOrderBy",
		drivingPayment:"UserPaymentOrderBy",
		recurringPayment:"UserRecurringPaymentOrderBy"
	},
	UserRecurringPaymentItemMetadataOrderBy:{
		id:"OrderDirection",
		isSuccessfullyPaid:"OrderDirection",
		shouldBeProcessed:"OrderDirection",
		firstPayment:"UserPaymentOrderBy",
		lastPayment:"UserPaymentOrderBy",
		firstSuccessfulPayment:"UserPaymentOrderBy",
		drivingPayment:"UserPaymentOrderBy",
		recurringPaymentItem:"UserRecurringPaymentItemOrderBy"
	},
	OnBehalfDonationOrderBy:{
		id:"OrderDirection",
		secretCode:"OrderDirection",
		specificSymbol:"OrderDirection",
		createdAt:"OrderDirection",
		onBehalfOf:"UserOrderBy",
		meta:"OnBehalfDonationMetadataOrderBy"
	},
	OnBehalfDonationMetadataOrderBy:{
		id:"OrderDirection",
		area:"PostAreaOrderBy",
		organization:"PostOrganizationOrderBy",
		post:"PostOrderBy",
		onBehalfOfDonation:"OnBehalfDonationOrderBy"
	},
	UserPaymentTriesCollectionOrderBy:{
		id:"OrderDirection",
		cents:"OrderDirection",
		specificSymbol:"OrderDirection",
		createdAt:"OrderDirection",
		orderUrl:"OrderDirection",
		user:"UserOrderBy",
		currency:"CurrencyOrderBy",
		onBehalfDonation:"OnBehalfDonationOrderBy",
		recurring:"UserRecurringPaymentOrderBy",
		metadata:"UserPaymentTriesCollectionMetadataOrderBy",
		medium:"OrderDirection"
	},
	UserPaymentTriesCollectionMetadataOrderBy:{
		id:"OrderDirection",
		area:"PostAreaOrderBy",
		organization:"PostOrganizationOrderBy",
		post:"PostOrderBy",
		triesCollection:"UserPaymentTriesCollectionOrderBy"
	},
	UserPaymentMetadataOrderBy:{
		id:"OrderDirection",
		area:"PostAreaOrderBy",
		organization:"PostOrganizationOrderBy",
		organizationUnfiltered:"PostOrganizationOrderBy",
		post:"PostOrderBy",
		countToUser:"UserOrderBy",
		paymentType:"OrderDirection",
		statusLabel:"OrderDirection",
		isSuccessful:"OrderDirection",
		isFinished:"OrderDirection",
		needsCacheUpdate:"OrderDirection",
		isSuccessfulNotCached:"OrderDirection",
		isFinishedNotCached:"OrderDirection",
		userPayment:"UserPaymentOrderBy"
	},
	CsobPaymentMetadataOrderBy:{
		id:"OrderDirection",
		status:"OrderDirection",
		isSuccessful:"OrderDirection",
		isFinished:"OrderDirection",
		resolvedOriginalPayId:"OrderDirection",
		csobPayment:"CsobPaymentOrderBy"
	},
	CsobPaymentMetadata:{
		csobPayment:{
			filter:"CsobPaymentWhere"
		}
	},
	StripePayment:{
		statusChanges:{
			filter:"StripePaymentStatusChangeWhere",
			orderBy:"StripePaymentStatusChangeOrderBy"
		},
		payment:{
			filter:"UserPaymentWhere"
		},
		metadata:{
			filter:"StripePaymentMetadataWhere"
		},
		paginateStatusChanges:{
			filter:"StripePaymentStatusChangeWhere",
			orderBy:"StripePaymentStatusChangeOrderBy"
		}
	},
	StripePaymentStatusChange:{
		payment:{
			filter:"StripePaymentWhere"
		}
	},
	StripePaymentStatusChangeOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		payment:"StripePaymentOrderBy",
		timestamp:"OrderDirection",
		eventId:"OrderDirection",
		paymentIntentStatus:"OrderDirection"
	},
	StripePaymentMetadata:{
		stripePayment:{
			filter:"StripePaymentWhere"
		}
	},
	UserRecurringPaymentItem:{
		payments:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		recurringPayment:{
			filter:"UserRecurringPaymentWhere"
		},
		meta:{
			filter:"UserRecurringPaymentItemMetadataWhere"
		},
		paymentsByOrder:{
			by:"UserRecurringPaymentItemPaymentsByOrderUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByCsobPayment:{
			by:"UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByStripePayment:{
			by:"UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByMetadata:{
			by:"UserRecurringPaymentItemPaymentsByMetadataUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paginatePayments:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		}
	},
	UserRecurringPayment:{
		currency:{
			filter:"CurrencyWhere"
		},
		items:{
			filter:"UserRecurringPaymentItemWhere",
			orderBy:"UserRecurringPaymentItemOrderBy"
		},
		user:{
			filter:"UserWhere"
		},
		meta:{
			filter:"UpcomingUserRecurringPaymentMetadataWhere"
		},
		itemsByRecurrenceCounter:{
			by:"UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere",
			filter:"UserRecurringPaymentItemWhere"
		},
		itemsByPayments:{
			by:"UserRecurringPaymentItemsByPaymentsUniqueWhere",
			filter:"UserRecurringPaymentItemWhere"
		},
		itemsByMeta:{
			by:"UserRecurringPaymentItemsByMetaUniqueWhere",
			filter:"UserRecurringPaymentItemWhere"
		},
		paginateItems:{
			filter:"UserRecurringPaymentItemWhere",
			orderBy:"UserRecurringPaymentItemOrderBy"
		}
	},
	UpcomingUserRecurringPaymentMetadata:{
		firstPayment:{
			filter:"UserPaymentWhere"
		},
		firstSuccessfulPayment:{
			filter:"UserPaymentWhere"
		},
		drivingPayment:{
			filter:"UserPaymentWhere"
		},
		recurringPayment:{
			filter:"UserRecurringPaymentWhere"
		}
	},
	UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere:{

	},
	UserRecurringPaymentItemsByPaymentsUniqueWhere:{
		payments:"UserPaymentUniqueWhere"
	},
	UserPaymentUniqueWhere:{
		id:"UUID",
		order:"UserPaymentOrderIdUniqueWhere",
		csobPayment:"CsobPaymentUniqueWhere",
		stripePayment:"StripePaymentUniqueWhere",
		metadata:"UserPaymentMetadataUniqueWhere"
	},
	UserPaymentOrderIdUniqueWhere:{
		id:"UUID"
	},
	CsobPaymentUniqueWhere:{
		id:"UUID",
		statusChanges:"CsobPaymentStatusChangeUniqueWhere",
		payment:"UserPaymentUniqueWhere",
		metadata:"CsobPaymentMetadataUniqueWhere"
	},
	CsobPaymentStatusChangeUniqueWhere:{
		id:"UUID"
	},
	CsobPaymentMetadataUniqueWhere:{
		id:"UUID",
		csobPayment:"CsobPaymentUniqueWhere"
	},
	StripePaymentUniqueWhere:{
		id:"UUID",
		statusChanges:"StripePaymentStatusChangeUniqueWhere",
		payment:"UserPaymentUniqueWhere",
		metadata:"StripePaymentMetadataUniqueWhere"
	},
	StripePaymentStatusChangeUniqueWhere:{
		id:"UUID"
	},
	StripePaymentMetadataUniqueWhere:{
		id:"UUID",
		stripePayment:"StripePaymentUniqueWhere"
	},
	UserPaymentMetadataUniqueWhere:{
		id:"UUID",
		userPayment:"UserPaymentUniqueWhere"
	},
	UserRecurringPaymentItemsByMetaUniqueWhere:{
		meta:"UserRecurringPaymentItemMetadataUniqueWhere"
	},
	UserRecurringPaymentItemMetadataUniqueWhere:{
		id:"UUID",
		firstPayment:"UserPaymentUniqueWhere",
		lastPayment:"UserPaymentUniqueWhere",
		recurringPaymentItem:"UserRecurringPaymentItemUniqueWhere"
	},
	UserRecurringPaymentItemUniqueWhere:{
		id:"UUID",
		recurringPayment:"UserRecurringPaymentUniqueWhere",
		payments:"UserPaymentUniqueWhere",
		meta:"UserRecurringPaymentItemMetadataUniqueWhere"
	},
	UserRecurringPaymentUniqueWhere:{
		id:"UUID",
		items:"UserRecurringPaymentItemUniqueWhere",
		meta:"UpcomingUserRecurringPaymentMetadataUniqueWhere"
	},
	UpcomingUserRecurringPaymentMetadataUniqueWhere:{
		id:"UUID",
		firstPayment:"UserPaymentUniqueWhere",
		recurringPayment:"UserRecurringPaymentUniqueWhere"
	},
	UserRecurringPaymentItemMetadata:{
		firstPayment:{
			filter:"UserPaymentWhere"
		},
		lastPayment:{
			filter:"UserPaymentWhere"
		},
		firstSuccessfulPayment:{
			filter:"UserPaymentWhere"
		},
		drivingPayment:{
			filter:"UserPaymentWhere"
		},
		recurringPaymentItem:{
			filter:"UserRecurringPaymentItemWhere"
		}
	},
	UserRecurringPaymentItemPaymentsByOrderUniqueWhere:{
		order:"UserPaymentOrderIdUniqueWhere"
	},
	UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere:{
		csobPayment:"CsobPaymentUniqueWhere"
	},
	UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere:{
		stripePayment:"StripePaymentUniqueWhere"
	},
	UserRecurringPaymentItemPaymentsByMetadataUniqueWhere:{
		metadata:"UserPaymentMetadataUniqueWhere"
	},
	OnBehalfDonation:{
		payments:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		onBehalfOf:{
			filter:"UserWhere"
		},
		meta:{
			filter:"OnBehalfDonationMetadataWhere"
		},
		paymentsByOrder:{
			by:"OnBehalfDonationPaymentsByOrderUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByCsobPayment:{
			by:"OnBehalfDonationPaymentsByCsobPaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByStripePayment:{
			by:"OnBehalfDonationPaymentsByStripePaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentsByMetadata:{
			by:"OnBehalfDonationPaymentsByMetadataUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paginatePayments:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		}
	},
	OnBehalfDonationMetadata:{
		area:{
			filter:"PostAreaWhere"
		},
		organization:{
			filter:"PostOrganizationWhere"
		},
		post:{
			filter:"PostWhere"
		},
		onBehalfOfDonation:{
			filter:"OnBehalfDonationWhere"
		}
	},
	OnBehalfDonationPaymentsByOrderUniqueWhere:{
		order:"UserPaymentOrderIdUniqueWhere"
	},
	OnBehalfDonationPaymentsByCsobPaymentUniqueWhere:{
		csobPayment:"CsobPaymentUniqueWhere"
	},
	OnBehalfDonationPaymentsByStripePaymentUniqueWhere:{
		stripePayment:"StripePaymentUniqueWhere"
	},
	OnBehalfDonationPaymentsByMetadataUniqueWhere:{
		metadata:"UserPaymentMetadataUniqueWhere"
	},
	UserPaymentTriesCollection:{
		payment:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		user:{
			filter:"UserWhere"
		},
		currency:{
			filter:"CurrencyWhere"
		},
		onBehalfDonation:{
			filter:"OnBehalfDonationWhere"
		},
		recurring:{
			filter:"UserRecurringPaymentWhere"
		},
		metadata:{
			filter:"UserPaymentTriesCollectionMetadataWhere"
		},
		metadataLocales:{
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere",
			orderBy:"UserPaymentTriesCollectionMetadataLocaleOrderBy"
		},
		paymentByOrder:{
			by:"UserPaymentTriesCollectionPaymentByOrderUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentByCsobPayment:{
			by:"UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentByStripePayment:{
			by:"UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		paymentByMetadata:{
			by:"UserPaymentTriesCollectionPaymentByMetadataUniqueWhere",
			filter:"UserPaymentWhere"
		},
		metadataLocalesByLocale:{
			by:"UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere",
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere"
		},
		paginatePayment:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		paginateMetadataLocales:{
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere",
			orderBy:"UserPaymentTriesCollectionMetadataLocaleOrderBy"
		}
	},
	UserPaymentTriesCollectionMetadata:{
		area:{
			filter:"PostAreaWhere"
		},
		organization:{
			filter:"PostOrganizationWhere"
		},
		post:{
			filter:"PostWhere"
		},
		triesCollection:{
			filter:"UserPaymentTriesCollectionWhere"
		}
	},
	UserPaymentTriesCollectionMetadataLocale:{
		locale:{
			filter:"LocaleWhere"
		},
		parent:{
			filter:"UserPaymentTriesCollectionWhere"
		}
	},
	UserPaymentTriesCollectionMetadataLocaleOrderBy:{
		id:"OrderDirection",
		locale:"LocaleOrderBy",
		title:"OrderDirection",
		parent:"UserPaymentTriesCollectionOrderBy"
	},
	UserPaymentTriesCollectionPaymentByOrderUniqueWhere:{
		order:"UserPaymentOrderIdUniqueWhere"
	},
	UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere:{
		csobPayment:"CsobPaymentUniqueWhere"
	},
	UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere:{
		stripePayment:"StripePaymentUniqueWhere"
	},
	UserPaymentTriesCollectionPaymentByMetadataUniqueWhere:{
		metadata:"UserPaymentMetadataUniqueWhere"
	},
	UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	UserPaymentMetadata:{
		area:{
			filter:"PostAreaWhere"
		},
		organization:{
			filter:"PostOrganizationWhere"
		},
		organizationUnfiltered:{
			filter:"PostOrganizationWhere"
		},
		post:{
			filter:"PostWhere"
		},
		countToUser:{
			filter:"UserWhere"
		},
		userPayment:{
			filter:"UserPaymentWhere"
		}
	},
	Device:{
		user:{
			filter:"UserWhere"
		}
	},
	DeviceOrderBy:{
		id:"OrderDirection",
		user:"UserOrderBy",
		fcmToken:"OrderDirection",
		createdAt:"OrderDirection",
		ipAddress:"OrderDirection",
		userAgent:"OrderDirection",
		lastActiveAt:"OrderDirection"
	},
	ProcessedNotificationSourceOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		processedNotification:"ProcessedNotificationOrderBy",
		donationReminderUser:"UserOrderBy",
		scheduledNotification:"ScheduledNotificationOrderBy"
	},
	ProcessedNotificationOrderBy:{
		id:"OrderDirection",
		topic:"OrderDirection",
		sentAt:"OrderDirection",
		errorMessage:"OrderDirection",
		errorCode:"OrderDirection",
		isSuccess:"OrderDirection",
		source:"ProcessedNotificationSourceOrderBy",
		title:"OrderDirection",
		body:"OrderDirection"
	},
	UserAreaStats:{
		area:{
			filter:"PostAreaWhere"
		},
		currency:{
			filter:"CurrencyWhere"
		},
		user:{
			filter:"UserWhere"
		}
	},
	UserAreaStatsOrderBy:{
		id:"OrderDirection",
		area:"PostAreaOrderBy",
		currency:"CurrencyOrderBy",
		totalCents:"OrderDirection",
		user:"UserOrderBy"
	},
	UserOrganizationStats:{
		organization:{
			filter:"PostOrganizationWhere"
		},
		currency:{
			filter:"CurrencyWhere"
		},
		user:{
			filter:"UserWhere"
		}
	},
	UserOrganizationStatsOrderBy:{
		id:"OrderDirection",
		organization:"PostOrganizationOrderBy",
		currency:"CurrencyOrderBy",
		totalCents:"OrderDirection",
		user:"UserOrderBy"
	},
	UserPostStats:{
		post:{
			filter:"PostWhere"
		},
		currency:{
			filter:"CurrencyWhere"
		},
		user:{
			filter:"UserWhere"
		}
	},
	UserPostStatsOrderBy:{
		id:"OrderDirection",
		post:"PostOrderBy",
		currency:"CurrencyOrderBy",
		totalCents:"OrderDirection",
		user:"UserOrderBy"
	},
	UserCurrencyStats:{
		currency:{
			filter:"CurrencyWhere"
		},
		user:{
			filter:"UserWhere"
		}
	},
	UserCurrencyStatsOrderBy:{
		id:"OrderDirection",
		currency:"CurrencyOrderBy",
		totalAmountPaymentsOnce:"OrderDirection",
		totalAmountPaymentsRegular:"OrderDirection",
		user:"UserOrderBy"
	},
	UserStats:{
		user:{
			filter:"UserWhere"
		}
	},
	UserPaymentsByOrderUniqueWhere:{
		order:"UserPaymentOrderIdUniqueWhere"
	},
	UserPaymentsByCsobPaymentUniqueWhere:{
		csobPayment:"CsobPaymentUniqueWhere"
	},
	UserPaymentsByStripePaymentUniqueWhere:{
		stripePayment:"StripePaymentUniqueWhere"
	},
	UserPaymentsByMetadataUniqueWhere:{
		metadata:"UserPaymentMetadataUniqueWhere"
	},
	UserRecurringPaymentsByItemsUniqueWhere:{
		items:"UserRecurringPaymentItemUniqueWhere"
	},
	UserRecurringPaymentsByMetaUniqueWhere:{
		meta:"UpcomingUserRecurringPaymentMetadataUniqueWhere"
	},
	UserOnBehalfDonationsBySecretCodeUniqueWhere:{

	},
	UserOnBehalfDonationsByPaymentsUniqueWhere:{
		payments:"UserPaymentUniqueWhere"
	},
	UserOnBehalfDonationsByMetaUniqueWhere:{
		meta:"OnBehalfDonationMetadataUniqueWhere"
	},
	OnBehalfDonationMetadataUniqueWhere:{
		id:"UUID",
		onBehalfOfDonation:"OnBehalfDonationUniqueWhere"
	},
	OnBehalfDonationUniqueWhere:{
		id:"UUID",
		payments:"UserPaymentUniqueWhere",
		meta:"OnBehalfDonationMetadataUniqueWhere"
	},
	UserDevicesByFcmTokenUniqueWhere:{

	},
	UserProcessedNotificationsByProcessedNotificationUniqueWhere:{
		processedNotification:"ProcessedNotificationUniqueWhere"
	},
	ScheduledNotificationLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere:{
		processedNotification:"ProcessedNotificationUniqueWhere"
	},
	LocaleGeneralsByRootUniqueWhere:{
		root:"GeneralUniqueWhere"
	},
	LocaleGeneralsBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleGeneralsByAppStoreLinkUniqueWhere:{
		appStoreLink:"LinkUniqueWhere"
	},
	LocaleGeneralsByGooglePlayLinkUniqueWhere:{
		googlePlayLink:"LinkUniqueWhere"
	},
	LocaleGenericPagesByRootUniqueWhere:{
		root:"GenericPageUniqueWhere"
	},
	LocaleGenericPagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleGenericPagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleGenericPagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocalePostsByRootUniqueWhere:{
		root:"PostUniqueWhere"
	},
	LocalePostsByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocalePostsBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocalePostsByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocalePostAreasByRootUniqueWhere:{
		root:"PostAreaUniqueWhere"
	},
	LocalePostAreasByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocalePostAreasBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocalePostAreasByBannerUniqueWhere:{
		banner:"AppBannerUniqueWhere"
	},
	LocalePostAreasByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocalePostOrganizationsByRootUniqueWhere:{
		root:"PostOrganizationUniqueWhere"
	},
	LocalePostOrganizationsByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocalePostOrganizationsByDomainUniqueWhere:{
		domain:"LinkUniqueWhere"
	},
	LocalePostOrganizationsBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocalePostOrganizationsByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleHeadersByRootUniqueWhere:{
		root:"HeaderUniqueWhere"
	},
	LocaleHeadersByLinksUniqueWhere:{
		links:"LinkListUniqueWhere"
	},
	LocaleFootersByRootUniqueWhere:{
		root:"FooterUniqueWhere"
	},
	LocaleFootersByLinkListUniqueWhere:{
		linkList:"LinkListUniqueWhere"
	},
	LocaleFootersByAddressInfoUniqueWhere:{
		addressInfo:"ContentUniqueWhere"
	},
	LocaleFootersByImageLinkListUniqueWhere:{
		imageLinkList:"ImageLinkListUniqueWhere"
	},
	LocaleGenericPageAboutSettingsByRootUniqueWhere:{
		root:"GenericPageAboutSettingsUniqueWhere"
	},
	LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere:{
		linkGroups:"GenericPageAboutGroupLinksLocaleUniqueWhere"
	},
	LocalePostRevisionsByRootUniqueWhere:{
		root:"PostRevisionUniqueWhere"
	},
	LocalePostRevisionsByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocalePostRevisionsBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocalePostRevisionsByLeadContentUniqueWhere:{
		leadContent:"ContentUniqueWhere"
	},
	LocaleFeedPagesByRootUniqueWhere:{
		root:"FeedPageUniqueWhere"
	},
	LocaleFeedPagesByHeroTilesUniqueWhere:{
		heroTiles:"TileListUniqueWhere"
	},
	LocaleFeedPagesBySectionListUniqueWhere:{
		sectionList:"FeedPageSectionUniqueWhere"
	},
	LocaleFeedPagesByCardListUniqueWhere:{
		cardList:"CardListUniqueWhere"
	},
	LocaleFeedPagesByStoryGuideListUniqueWhere:{
		storyGuideList:"StoryGuideListUniqueWhere"
	},
	LocaleRecurringPaymentPagesByRootUniqueWhere:{
		root:"RecurringPaymentPageUniqueWhere"
	},
	LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere:{
		favouritePosts:"PostListUniqueWhere"
	},
	LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere:{
		storyGuideList:"StoryGuideListUniqueWhere"
	},
	LocaleGivenGiftsPagesByRootUniqueWhere:{
		root:"GivenGiftsPageUniqueWhere"
	},
	LocaleGivenGiftsPagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleGivenGiftsPagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleGivenGiftsPagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleReceivedGiftsPagesByRootUniqueWhere:{
		root:"ReceivedGiftsPageUniqueWhere"
	},
	LocaleReceivedGiftsPagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleReceivedGiftsPagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleReceivedGiftsPagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleReportPagesByRootUniqueWhere:{
		root:"ReportPageUniqueWhere"
	},
	LocaleReportPagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleReportPagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleReportPagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleReportNavigationsByRootUniqueWhere:{
		root:"ReportNavigationUniqueWhere"
	},
	LocaleScheduledNotificationsByRootUniqueWhere:{
		root:"ScheduledNotificationUniqueWhere"
	},
	LocaleSentPaymentsByRootUniqueWhere:{
		root:"SentPaymentUniqueWhere"
	},
	GeneralLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	GeneralLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	GeneralLocalesByAppStoreLinkUniqueWhere:{
		appStoreLink:"LinkUniqueWhere"
	},
	GeneralLocalesByGooglePlayLinkUniqueWhere:{
		googlePlayLink:"LinkUniqueWhere"
	},
	GeneralCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"GeneralCreateLocalesEntityRelationInput",
		allAreasIcon:"GeneralCreateAllAreasIconEntityRelationInput",
		allOrganizationsIcon:"GeneralCreateAllOrganizationsIconEntityRelationInput",
		organizationList:"GeneralCreateOrganizationListEntityRelationInput"
	},
	GeneralCreateLocalesEntityRelationInput:{
		connect:"GeneralLocaleUniqueWhere",
		create:"GeneralLocaleWithoutRootCreateInput",
		connectOrCreate:"GeneralConnectOrCreateLocalesRelationInput"
	},
	GeneralLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"GeneralLocaleCreateLocaleEntityRelationInput",
		seo:"GeneralLocaleCreateSeoEntityRelationInput",
		appStoreLink:"GeneralLocaleCreateAppStoreLinkEntityRelationInput",
		googlePlayLink:"GeneralLocaleCreateGooglePlayLinkEntityRelationInput"
	},
	GeneralLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGeneralsCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutGeneralsCreateInput:{
		id:"UUID",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreateGenericPagesEntityRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateGenericPagesRelationInput"
	},
	GenericPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"GenericPageLocaleCreateRootEntityRelationInput",
		content:"GenericPageLocaleCreateContentEntityRelationInput",
		seo:"GenericPageLocaleCreateSeoEntityRelationInput",
		link:"GenericPageLocaleCreateLinkEntityRelationInput"
	},
	GenericPageLocaleCreateRootEntityRelationInput:{
		connect:"GenericPageUniqueWhere",
		create:"GenericPageWithoutLocalesCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateRootRelationInput"
	},
	GenericPageWithoutLocalesCreateInput:{
		id:"UUID",
		type:"GenericPageType",
		reportNavigation:"GenericPageCreateReportNavigationEntityRelationInput"
	},
	GenericPageCreateReportNavigationEntityRelationInput:{
		connect:"ReportNavigationLocaleUniqueWhere",
		create:"ReportNavigationLocaleWithoutPagesCreateInput",
		connectOrCreate:"GenericPageConnectOrCreateReportNavigationRelationInput"
	},
	ReportNavigationLocaleWithoutPagesCreateInput:{
		id:"UUID",
		root:"ReportNavigationLocaleCreateRootEntityRelationInput",
		locale:"ReportNavigationLocaleCreateLocaleEntityRelationInput"
	},
	ReportNavigationLocaleCreateRootEntityRelationInput:{
		connect:"ReportNavigationUniqueWhere",
		create:"ReportNavigationWithoutLocalesCreateInput",
		connectOrCreate:"ReportNavigationLocaleConnectOrCreateRootRelationInput"
	},
	ReportNavigationWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	ReportNavigationLocaleConnectOrCreateRootRelationInput:{
		connect:"ReportNavigationUniqueWhere",
		create:"ReportNavigationWithoutLocalesCreateInput"
	},
	ReportNavigationLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReportNavigationsCreateInput",
		connectOrCreate:"ReportNavigationLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutReportNavigationsCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreateGeneralsEntityRelationInput:{
		connect:"GeneralLocaleUniqueWhere",
		create:"GeneralLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateGeneralsRelationInput"
	},
	GeneralLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"GeneralLocaleCreateRootEntityRelationInput",
		seo:"GeneralLocaleCreateSeoEntityRelationInput",
		appStoreLink:"GeneralLocaleCreateAppStoreLinkEntityRelationInput",
		googlePlayLink:"GeneralLocaleCreateGooglePlayLinkEntityRelationInput"
	},
	GeneralLocaleCreateRootEntityRelationInput:{
		connect:"GeneralUniqueWhere",
		create:"GeneralWithoutLocalesCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateRootRelationInput"
	},
	GeneralWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One",
		allAreasIcon:"GeneralCreateAllAreasIconEntityRelationInput",
		allOrganizationsIcon:"GeneralCreateAllOrganizationsIconEntityRelationInput",
		organizationList:"GeneralCreateOrganizationListEntityRelationInput"
	},
	GeneralCreateAllAreasIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GeneralConnectOrCreateAllAreasIconRelationInput"
	},
	ImageCreateInput:{
		id:"UUID"
	},
	GeneralConnectOrCreateAllAreasIconRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	GeneralCreateAllOrganizationsIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GeneralConnectOrCreateAllOrganizationsIconRelationInput"
	},
	GeneralConnectOrCreateAllOrganizationsIconRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	GeneralCreateOrganizationListEntityRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput",
		connectOrCreate:"GeneralConnectOrCreateOrganizationListRelationInput"
	},
	PostOrganizationListCreateInput:{
		id:"UUID",
		items:"PostOrganizationListCreateItemsEntityRelationInput"
	},
	PostOrganizationListCreateItemsEntityRelationInput:{
		connect:"PostOrganizationListItemUniqueWhere",
		create:"PostOrganizationListItemWithoutListCreateInput",
		connectOrCreate:"PostOrganizationListConnectOrCreateItemsRelationInput"
	},
	PostOrganizationListItemWithoutListCreateInput:{
		id:"UUID",
		item:"PostOrganizationListItemCreateItemEntityRelationInput",
		type:"PostOrganizationListItemType",
		link:"PostOrganizationListItemCreateLinkEntityRelationInput",
		image:"PostOrganizationListItemCreateImageEntityRelationInput"
	},
	PostOrganizationListItemCreateItemEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationCreateInput",
		connectOrCreate:"PostOrganizationListItemConnectOrCreateItemRelationInput"
	},
	PostOrganizationCreateInput:{
		id:"UUID",
		posts:"PostOrganizationCreatePostsEntityRelationInput",
		icon:"PostOrganizationCreateIconEntityRelationInput",
		locales:"PostOrganizationCreateLocalesEntityRelationInput",
		area:"PostOrganizationCreateAreaEntityRelationInput",
		meta:"PostOrganizationCreateMetaEntityRelationInput",
		mobileHeroImage:"PostOrganizationCreateMobileHeroImageEntityRelationInput",
		plainIcon:"PostOrganizationCreatePlainIconEntityRelationInput",
		desktopHeroImage:"PostOrganizationCreateDesktopHeroImageEntityRelationInput",
		sentPayments:"PostOrganizationCreateSentPaymentsEntityRelationInput",
		organizationCurrencySums:"PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput",
		organizationSum:"PostOrganizationCreateOrganizationSumEntityRelationInput"
	},
	PostOrganizationCreatePostsEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutOrganizationCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreatePostsRelationInput"
	},
	PostWithoutOrganizationCreateInput:{
		id:"UUID",
		area:"PostCreateAreaEntityRelationInput",
		activeRevision:"PostCreateActiveRevisionEntityRelationInput",
		revisions:"PostCreateRevisionsEntityRelationInput",
		locales:"PostCreateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostCreateMetaEntityRelationInput",
		heroCarousel:"PostCreateHeroCarouselEntityRelationInput",
		reportPage:"PostCreateReportPageEntityRelationInput",
		content:"PostCreateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostCreateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostCreateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostCreateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostCreateFundraisingProgressEntityRelationInput"
	},
	PostCreateAreaEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutPostsCreateInput",
		connectOrCreate:"PostConnectOrCreateAreaRelationInput"
	},
	PostAreaWithoutPostsCreateInput:{
		id:"UUID",
		icon:"PostAreaCreateIconEntityRelationInput",
		locales:"PostAreaCreateLocalesEntityRelationInput",
		regionListOverride:"PostAreaCreateRegionListOverrideEntityRelationInput",
		region:"PostAreaCreateRegionEntityRelationInput",
		meta:"PostAreaCreateMetaEntityRelationInput",
		mobileHeroImage:"PostAreaCreateMobileHeroImageEntityRelationInput",
		plainIcon:"PostAreaCreatePlainIconEntityRelationInput",
		sentPayments:"PostAreaCreateSentPaymentsEntityRelationInput",
		areaSentPaymentCurrencySums:"PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaSentPaymentSum:"PostAreaCreateAreaSentPaymentSumEntityRelationInput",
		areaCurrencySums:"PostAreaCreateAreaCurrencySumsEntityRelationInput",
		areaSum:"PostAreaCreateAreaSumEntityRelationInput"
	},
	PostAreaCreateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateIconRelationInput"
	},
	PostAreaConnectOrCreateIconRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostAreaCreateLocalesEntityRelationInput:{
		connect:"PostAreaLocaleUniqueWhere",
		create:"PostAreaLocaleWithoutRootCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateLocalesRelationInput"
	},
	PostAreaLocaleWithoutRootCreateInput:{
		id:"UUID",
		link:"PostAreaLocaleCreateLinkEntityRelationInput",
		locale:"PostAreaLocaleCreateLocaleEntityRelationInput",
		seo:"PostAreaLocaleCreateSeoEntityRelationInput",
		banner:"PostAreaLocaleCreateBannerEntityRelationInput",
		content:"PostAreaLocaleCreateContentEntityRelationInput"
	},
	PostAreaLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostAreaCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutPostAreaCreateInput:{
		id:"UUID",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		post:"LinkableCreatePostEntityRelationInput",
		postOrganization:"LinkableCreatePostOrganizationEntityRelationInput",
		reportPage:"LinkableCreateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableCreateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableCreateReceivedGiftsPageEntityRelationInput"
	},
	LinkableCreateGenericPageEntityRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateGenericPageRelationInput"
	},
	GenericPageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"GenericPageLocaleCreateRootEntityRelationInput",
		locale:"GenericPageLocaleCreateLocaleEntityRelationInput",
		content:"GenericPageLocaleCreateContentEntityRelationInput",
		seo:"GenericPageLocaleCreateSeoEntityRelationInput"
	},
	GenericPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPagesCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutGenericPagesCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreatePostsEntityRelationInput:{
		connect:"PostLocaleUniqueWhere",
		create:"PostLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreatePostsRelationInput"
	},
	PostLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		content:"PostLocaleCreateContentEntityRelationInput",
		seo:"PostLocaleCreateSeoEntityRelationInput",
		link:"PostLocaleCreateLinkEntityRelationInput",
		root:"PostLocaleCreateRootEntityRelationInput",
		publishedAt:"DateTime"
	},
	PostLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateContentRelationInput"
	},
	ContentCreateInput:{
		id:"UUID",
		blocks:"ContentCreateBlocksEntityRelationInput"
	},
	ContentCreateBlocksEntityRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutContentCreateInput",
		connectOrCreate:"ContentConnectOrCreateBlocksRelationInput"
	},
	ContentBlockWithoutContentCreateInput:{
		id:"UUID",
		references:"ContentBlockCreateReferencesEntityRelationInput"
	},
	ContentBlockCreateReferencesEntityRelationInput:{
		connect:"ContentReferenceUniqueWhere",
		create:"ContentReferenceWithoutBlockCreateInput",
		connectOrCreate:"ContentBlockConnectOrCreateReferencesRelationInput"
	},
	ContentReferenceWithoutBlockCreateInput:{
		id:"UUID",
		type:"ContentReferenceType",
		image:"ContentReferenceCreateImageEntityRelationInput",
		linkables:"ContentReferenceCreateLinkablesEntityRelationInput",
		video:"ContentReferenceCreateVideoEntityRelationInput",
		link:"ContentReferenceCreateLinkEntityRelationInput",
		contentAlignment:"ContentAlignment",
		valueList:"ContentReferenceCreateValueListEntityRelationInput",
		imageLinkList:"ContentReferenceCreateImageLinkListEntityRelationInput",
		areaList:"ContentReferenceCreateAreaListEntityRelationInput",
		accordion:"ContentReferenceCreateAccordionEntityRelationInput",
		media:"ContentReferenceCreateMediaEntityRelationInput",
		memberList:"ContentReferenceCreateMemberListEntityRelationInput",
		asideMediaContentLayout:"AsideMediaContentLayout",
		form:"ContentReferenceCreateFormEntityRelationInput",
		contentWithoutBlocks:"ContentReferenceCreateContentWithoutBlocksEntityRelationInput",
		heroCarousel:"ContentReferenceCreateHeroCarouselEntityRelationInput",
		organizationList:"ContentReferenceCreateOrganizationListEntityRelationInput",
		posts:"ContentReferenceCreatePostsEntityRelationInput",
		textImageList:"ContentReferenceCreateTextImageListEntityRelationInput"
	},
	ContentReferenceCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateImageRelationInput"
	},
	ContentReferenceConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ContentReferenceCreateLinkablesEntityRelationInput:{
		connect:"ContentReferenceLinkableItemUniqueWhere"
	},
	ContentReferenceCreateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateVideoRelationInput"
	},
	VideoUniqueWhere:{
		id:"UUID"
	},
	VideoCreateInput:{
		id:"UUID",
		poster:"VideoCreatePosterEntityRelationInput",
		shapeType:"VideoShapeType"
	},
	VideoCreatePosterEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"VideoConnectOrCreatePosterRelationInput"
	},
	VideoConnectOrCreatePosterRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ContentReferenceConnectOrCreateVideoRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput"
	},
	ContentReferenceCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateLinkRelationInput"
	},
	LinkCreateInput:{
		id:"UUID",
		type:"LinkEnum",
		internalLink:"LinkCreateInternalLinkEntityRelationInput"
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableCreateInput",
		connectOrCreate:"LinkConnectOrCreateInternalLinkRelationInput"
	},
	LinkableCreateInput:{
		id:"UUID",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		post:"LinkableCreatePostEntityRelationInput",
		postArea:"LinkableCreatePostAreaEntityRelationInput",
		postOrganization:"LinkableCreatePostOrganizationEntityRelationInput",
		reportPage:"LinkableCreateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableCreateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableCreateReceivedGiftsPageEntityRelationInput"
	},
	LinkableCreatePostEntityRelationInput:{
		connect:"PostLocaleUniqueWhere",
		create:"PostLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreatePostRelationInput"
	},
	PostLocaleWithoutLinkCreateInput:{
		id:"UUID",
		content:"PostLocaleCreateContentEntityRelationInput",
		seo:"PostLocaleCreateSeoEntityRelationInput",
		locale:"PostLocaleCreateLocaleEntityRelationInput",
		root:"PostLocaleCreateRootEntityRelationInput",
		publishedAt:"DateTime"
	},
	PostLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateSeoRelationInput"
	},
	SeoCreateInput:{
		id:"UUID",
		ogImage:"SeoCreateOgImageEntityRelationInput"
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"SeoConnectOrCreateOgImageRelationInput"
	},
	SeoConnectOrCreateOgImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	PostLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostsCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutPostsCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreatePostAreasEntityRelationInput:{
		connect:"PostAreaLocaleUniqueWhere",
		create:"PostAreaLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreatePostAreasRelationInput"
	},
	PostAreaLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		link:"PostAreaLocaleCreateLinkEntityRelationInput",
		root:"PostAreaLocaleCreateRootEntityRelationInput",
		seo:"PostAreaLocaleCreateSeoEntityRelationInput",
		banner:"PostAreaLocaleCreateBannerEntityRelationInput",
		content:"PostAreaLocaleCreateContentEntityRelationInput"
	},
	PostAreaLocaleCreateRootEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutLocalesCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateRootRelationInput"
	},
	PostAreaWithoutLocalesCreateInput:{
		id:"UUID",
		icon:"PostAreaCreateIconEntityRelationInput",
		regionListOverride:"PostAreaCreateRegionListOverrideEntityRelationInput",
		posts:"PostAreaCreatePostsEntityRelationInput",
		region:"PostAreaCreateRegionEntityRelationInput",
		meta:"PostAreaCreateMetaEntityRelationInput",
		mobileHeroImage:"PostAreaCreateMobileHeroImageEntityRelationInput",
		plainIcon:"PostAreaCreatePlainIconEntityRelationInput",
		sentPayments:"PostAreaCreateSentPaymentsEntityRelationInput",
		areaSentPaymentCurrencySums:"PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaSentPaymentSum:"PostAreaCreateAreaSentPaymentSumEntityRelationInput",
		areaCurrencySums:"PostAreaCreateAreaCurrencySumsEntityRelationInput",
		areaSum:"PostAreaCreateAreaSumEntityRelationInput"
	},
	PostAreaCreateRegionListOverrideEntityRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateRegionListOverrideRelationInput"
	},
	DonationAmountsRegionListCreateInput:{
		id:"UUID",
		regions:"DonationAmountsRegionListCreateRegionsEntityRelationInput",
		donation:"DonationAmountsRegionListCreateDonationEntityRelationInput"
	},
	DonationAmountsRegionListCreateRegionsEntityRelationInput:{
		connect:"DonationAmountsRegionItemUniqueWhere",
		create:"DonationAmountsRegionItemWithoutListCreateInput",
		connectOrCreate:"DonationAmountsRegionListConnectOrCreateRegionsRelationInput"
	},
	DonationAmountsRegionItemWithoutListCreateInput:{
		id:"UUID",
		items:"DonationAmountsRegionItemCreateItemsEntityRelationInput",
		region:"DonationAmountsRegionItemCreateRegionEntityRelationInput"
	},
	DonationAmountsRegionItemCreateItemsEntityRelationInput:{
		connect:"DonationAmountItemUniqueWhere",
		create:"DonationAmountItemWithoutRegionItemCreateInput",
		connectOrCreate:"DonationAmountsRegionItemConnectOrCreateItemsRelationInput"
	},
	DonationAmountItemWithoutRegionItemCreateInput:{
		id:"UUID"
	},
	DonationAmountsRegionItemConnectOrCreateItemsRelationInput:{
		connect:"DonationAmountItemUniqueWhere",
		create:"DonationAmountItemWithoutRegionItemCreateInput"
	},
	DonationAmountsRegionItemCreateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionWithoutDonationItemsCreateInput",
		connectOrCreate:"DonationAmountsRegionItemConnectOrCreateRegionRelationInput"
	},
	RegionWithoutDonationItemsCreateInput:{
		id:"UUID",
		currency:"RegionCreateCurrencyEntityRelationInput",
		enabledPaymentMethods:"RegionCreateEnabledPaymentMethodsEntityRelationInput"
	},
	RegionCreateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"RegionConnectOrCreateCurrencyRelationInput"
	},
	CurrencyUniqueWhere:{
		id:"UUID",
		identifier:"CurrencyIdentifier",
		areaSentPaymentCurrencySums:"PostAreaSentPaymentCurrencySumUniqueWhere",
		areaCurrencySums:"PostAreaCurrencySumUniqueWhere",
		organizationCurrencySums:"PostOrganizationCurrencySumUniqueWhere",
		postCurrencySums:"PostCurrencySumUniqueWhere"
	},
	CurrencyCreateInput:{
		id:"UUID",
		identifier:"CurrencyIdentifier",
		signAlignment:"CurrencySignAlignment",
		areaSentPaymentCurrencySums:"CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaCurrencySums:"CurrencyCreateAreaCurrencySumsEntityRelationInput",
		organizationCurrencySums:"CurrencyCreateOrganizationCurrencySumsEntityRelationInput",
		postCurrencySums:"CurrencyCreatePostCurrencySumsEntityRelationInput"
	},
	CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput:{
		connect:"PostAreaSentPaymentCurrencySumUniqueWhere"
	},
	CurrencyCreateAreaCurrencySumsEntityRelationInput:{
		connect:"PostAreaCurrencySumUniqueWhere"
	},
	CurrencyCreateOrganizationCurrencySumsEntityRelationInput:{
		connect:"PostOrganizationCurrencySumUniqueWhere"
	},
	CurrencyCreatePostCurrencySumsEntityRelationInput:{
		connect:"PostCurrencySumUniqueWhere"
	},
	RegionConnectOrCreateCurrencyRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput"
	},
	RegionCreateEnabledPaymentMethodsEntityRelationInput:{
		connect:"RegionPaymentMethodUniqueWhere",
		create:"RegionPaymentMethodWithoutRegionCreateInput",
		connectOrCreate:"RegionConnectOrCreateEnabledPaymentMethodsRelationInput"
	},
	RegionPaymentMethodWithoutRegionCreateInput:{
		id:"UUID",
		method:"PaymentMethods"
	},
	RegionConnectOrCreateEnabledPaymentMethodsRelationInput:{
		connect:"RegionPaymentMethodUniqueWhere",
		create:"RegionPaymentMethodWithoutRegionCreateInput"
	},
	DonationAmountsRegionItemConnectOrCreateRegionRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionWithoutDonationItemsCreateInput"
	},
	DonationAmountsRegionListConnectOrCreateRegionsRelationInput:{
		connect:"DonationAmountsRegionItemUniqueWhere",
		create:"DonationAmountsRegionItemWithoutListCreateInput"
	},
	DonationAmountsRegionListCreateDonationEntityRelationInput:{
		connect:"DonationUniqueWhere",
		create:"DonationWithoutRegionListCreateInput",
		connectOrCreate:"DonationAmountsRegionListConnectOrCreateDonationRelationInput"
	},
	DonationWithoutRegionListCreateInput:{
		id:"UUID",
		unique:"One"
	},
	DonationAmountsRegionListConnectOrCreateDonationRelationInput:{
		connect:"DonationUniqueWhere",
		create:"DonationWithoutRegionListCreateInput"
	},
	PostAreaConnectOrCreateRegionListOverrideRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListCreateInput"
	},
	PostAreaCreatePostsEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutAreaCreateInput",
		connectOrCreate:"PostAreaConnectOrCreatePostsRelationInput"
	},
	PostWithoutAreaCreateInput:{
		id:"UUID",
		organization:"PostCreateOrganizationEntityRelationInput",
		activeRevision:"PostCreateActiveRevisionEntityRelationInput",
		revisions:"PostCreateRevisionsEntityRelationInput",
		locales:"PostCreateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostCreateMetaEntityRelationInput",
		heroCarousel:"PostCreateHeroCarouselEntityRelationInput",
		reportPage:"PostCreateReportPageEntityRelationInput",
		content:"PostCreateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostCreateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostCreateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostCreateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostCreateFundraisingProgressEntityRelationInput"
	},
	PostCreateOrganizationEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutPostsCreateInput",
		connectOrCreate:"PostConnectOrCreateOrganizationRelationInput"
	},
	PostOrganizationWithoutPostsCreateInput:{
		id:"UUID",
		icon:"PostOrganizationCreateIconEntityRelationInput",
		locales:"PostOrganizationCreateLocalesEntityRelationInput",
		area:"PostOrganizationCreateAreaEntityRelationInput",
		meta:"PostOrganizationCreateMetaEntityRelationInput",
		mobileHeroImage:"PostOrganizationCreateMobileHeroImageEntityRelationInput",
		plainIcon:"PostOrganizationCreatePlainIconEntityRelationInput",
		desktopHeroImage:"PostOrganizationCreateDesktopHeroImageEntityRelationInput",
		sentPayments:"PostOrganizationCreateSentPaymentsEntityRelationInput",
		organizationCurrencySums:"PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput",
		organizationSum:"PostOrganizationCreateOrganizationSumEntityRelationInput"
	},
	PostOrganizationCreateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateIconRelationInput"
	},
	PostOrganizationConnectOrCreateIconRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostOrganizationCreateLocalesEntityRelationInput:{
		connect:"PostOrganizationLocaleUniqueWhere",
		create:"PostOrganizationLocaleWithoutRootCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateLocalesRelationInput"
	},
	PostOrganizationLocaleWithoutRootCreateInput:{
		id:"UUID",
		link:"PostOrganizationLocaleCreateLinkEntityRelationInput",
		locale:"PostOrganizationLocaleCreateLocaleEntityRelationInput",
		domain:"PostOrganizationLocaleCreateDomainEntityRelationInput",
		seo:"PostOrganizationLocaleCreateSeoEntityRelationInput",
		content:"PostOrganizationLocaleCreateContentEntityRelationInput"
	},
	PostOrganizationLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostOrganizationCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutPostOrganizationCreateInput:{
		id:"UUID",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		post:"LinkableCreatePostEntityRelationInput",
		postArea:"LinkableCreatePostAreaEntityRelationInput",
		reportPage:"LinkableCreateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableCreateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableCreateReceivedGiftsPageEntityRelationInput"
	},
	LinkableCreatePostAreaEntityRelationInput:{
		connect:"PostAreaLocaleUniqueWhere",
		create:"PostAreaLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreatePostAreaRelationInput"
	},
	PostAreaLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"PostAreaLocaleCreateRootEntityRelationInput",
		locale:"PostAreaLocaleCreateLocaleEntityRelationInput",
		seo:"PostAreaLocaleCreateSeoEntityRelationInput",
		banner:"PostAreaLocaleCreateBannerEntityRelationInput",
		content:"PostAreaLocaleCreateContentEntityRelationInput"
	},
	PostAreaLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostAreasCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutPostAreasCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreatePostOrganizationsEntityRelationInput:{
		connect:"PostOrganizationLocaleUniqueWhere",
		create:"PostOrganizationLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreatePostOrganizationsRelationInput"
	},
	PostOrganizationLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		link:"PostOrganizationLocaleCreateLinkEntityRelationInput",
		root:"PostOrganizationLocaleCreateRootEntityRelationInput",
		domain:"PostOrganizationLocaleCreateDomainEntityRelationInput",
		seo:"PostOrganizationLocaleCreateSeoEntityRelationInput",
		content:"PostOrganizationLocaleCreateContentEntityRelationInput"
	},
	PostOrganizationLocaleCreateRootEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutLocalesCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateRootRelationInput"
	},
	PostOrganizationWithoutLocalesCreateInput:{
		id:"UUID",
		posts:"PostOrganizationCreatePostsEntityRelationInput",
		icon:"PostOrganizationCreateIconEntityRelationInput",
		area:"PostOrganizationCreateAreaEntityRelationInput",
		meta:"PostOrganizationCreateMetaEntityRelationInput",
		mobileHeroImage:"PostOrganizationCreateMobileHeroImageEntityRelationInput",
		plainIcon:"PostOrganizationCreatePlainIconEntityRelationInput",
		desktopHeroImage:"PostOrganizationCreateDesktopHeroImageEntityRelationInput",
		sentPayments:"PostOrganizationCreateSentPaymentsEntityRelationInput",
		organizationCurrencySums:"PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput",
		organizationSum:"PostOrganizationCreateOrganizationSumEntityRelationInput"
	},
	PostOrganizationCreateAreaEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateAreaRelationInput"
	},
	PostAreaCreateInput:{
		id:"UUID",
		icon:"PostAreaCreateIconEntityRelationInput",
		locales:"PostAreaCreateLocalesEntityRelationInput",
		regionListOverride:"PostAreaCreateRegionListOverrideEntityRelationInput",
		posts:"PostAreaCreatePostsEntityRelationInput",
		region:"PostAreaCreateRegionEntityRelationInput",
		meta:"PostAreaCreateMetaEntityRelationInput",
		mobileHeroImage:"PostAreaCreateMobileHeroImageEntityRelationInput",
		plainIcon:"PostAreaCreatePlainIconEntityRelationInput",
		sentPayments:"PostAreaCreateSentPaymentsEntityRelationInput",
		areaSentPaymentCurrencySums:"PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaSentPaymentSum:"PostAreaCreateAreaSentPaymentSumEntityRelationInput",
		areaCurrencySums:"PostAreaCreateAreaCurrencySumsEntityRelationInput",
		areaSum:"PostAreaCreateAreaSumEntityRelationInput"
	},
	PostAreaCreateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateRegionRelationInput"
	},
	RegionCreateInput:{
		id:"UUID",
		currency:"RegionCreateCurrencyEntityRelationInput",
		enabledPaymentMethods:"RegionCreateEnabledPaymentMethodsEntityRelationInput",
		donationItems:"RegionCreateDonationItemsEntityRelationInput"
	},
	RegionCreateDonationItemsEntityRelationInput:{
		connect:"DonationAmountsRegionItemUniqueWhere",
		create:"DonationAmountsRegionItemWithoutRegionCreateInput",
		connectOrCreate:"RegionConnectOrCreateDonationItemsRelationInput"
	},
	DonationAmountsRegionItemWithoutRegionCreateInput:{
		id:"UUID",
		items:"DonationAmountsRegionItemCreateItemsEntityRelationInput",
		list:"DonationAmountsRegionItemCreateListEntityRelationInput"
	},
	DonationAmountsRegionItemCreateListEntityRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListWithoutRegionsCreateInput",
		connectOrCreate:"DonationAmountsRegionItemConnectOrCreateListRelationInput"
	},
	DonationAmountsRegionListWithoutRegionsCreateInput:{
		id:"UUID",
		donation:"DonationAmountsRegionListCreateDonationEntityRelationInput"
	},
	DonationAmountsRegionItemConnectOrCreateListRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListWithoutRegionsCreateInput"
	},
	RegionConnectOrCreateDonationItemsRelationInput:{
		connect:"DonationAmountsRegionItemUniqueWhere",
		create:"DonationAmountsRegionItemWithoutRegionCreateInput"
	},
	PostAreaConnectOrCreateRegionRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput"
	},
	PostAreaCreateMetaEntityRelationInput:{
		connect:"PostAreaMetaDataUniqueWhere"
	},
	PostAreaCreateMobileHeroImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateMobileHeroImageRelationInput"
	},
	PostAreaConnectOrCreateMobileHeroImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostAreaCreatePlainIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostAreaConnectOrCreatePlainIconRelationInput"
	},
	PostAreaConnectOrCreatePlainIconRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostAreaCreateSentPaymentsEntityRelationInput:{
		connect:"SentPaymentUniqueWhere",
		create:"SentPaymentWithoutAreaCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateSentPaymentsRelationInput"
	},
	SentPaymentWithoutAreaCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		sendAt:"DateTime",
		currency:"SentPaymentCreateCurrencyEntityRelationInput",
		organization:"SentPaymentCreateOrganizationEntityRelationInput",
		locales:"SentPaymentCreateLocalesEntityRelationInput"
	},
	SentPaymentCreateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"SentPaymentConnectOrCreateCurrencyRelationInput"
	},
	SentPaymentConnectOrCreateCurrencyRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput"
	},
	SentPaymentCreateOrganizationEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutSentPaymentsCreateInput",
		connectOrCreate:"SentPaymentConnectOrCreateOrganizationRelationInput"
	},
	PostOrganizationWithoutSentPaymentsCreateInput:{
		id:"UUID",
		posts:"PostOrganizationCreatePostsEntityRelationInput",
		icon:"PostOrganizationCreateIconEntityRelationInput",
		locales:"PostOrganizationCreateLocalesEntityRelationInput",
		area:"PostOrganizationCreateAreaEntityRelationInput",
		meta:"PostOrganizationCreateMetaEntityRelationInput",
		mobileHeroImage:"PostOrganizationCreateMobileHeroImageEntityRelationInput",
		plainIcon:"PostOrganizationCreatePlainIconEntityRelationInput",
		desktopHeroImage:"PostOrganizationCreateDesktopHeroImageEntityRelationInput",
		organizationCurrencySums:"PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput",
		organizationSum:"PostOrganizationCreateOrganizationSumEntityRelationInput"
	},
	PostOrganizationCreateMetaEntityRelationInput:{
		connect:"PostOrganizationMetaDataUniqueWhere"
	},
	PostOrganizationCreateMobileHeroImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateMobileHeroImageRelationInput"
	},
	PostOrganizationConnectOrCreateMobileHeroImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostOrganizationCreatePlainIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreatePlainIconRelationInput"
	},
	PostOrganizationConnectOrCreatePlainIconRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostOrganizationCreateDesktopHeroImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"
	},
	PostOrganizationConnectOrCreateDesktopHeroImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput:{
		connect:"PostOrganizationCurrencySumUniqueWhere"
	},
	PostOrganizationCreateOrganizationSumEntityRelationInput:{
		connect:"PostOrganizationSumUniqueWhere"
	},
	SentPaymentConnectOrCreateOrganizationRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutSentPaymentsCreateInput"
	},
	SentPaymentCreateLocalesEntityRelationInput:{
		connect:"SentPaymentLocaleUniqueWhere",
		create:"SentPaymentLocaleWithoutRootCreateInput",
		connectOrCreate:"SentPaymentConnectOrCreateLocalesRelationInput"
	},
	SentPaymentLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"SentPaymentLocaleCreateLocaleEntityRelationInput"
	},
	SentPaymentLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutSentPaymentsCreateInput",
		connectOrCreate:"SentPaymentLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutSentPaymentsCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput"
	},
	LocaleCreateHeadersEntityRelationInput:{
		connect:"HeaderLocaleUniqueWhere",
		create:"HeaderLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateHeadersRelationInput"
	},
	HeaderLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"HeaderLocaleCreateRootEntityRelationInput",
		links:"HeaderLocaleCreateLinksEntityRelationInput"
	},
	HeaderLocaleCreateRootEntityRelationInput:{
		connect:"HeaderUniqueWhere",
		create:"HeaderWithoutLocalesCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateRootRelationInput"
	},
	HeaderWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One",
		logo:"HeaderCreateLogoEntityRelationInput",
		organizationList:"HeaderCreateOrganizationListEntityRelationInput"
	},
	HeaderCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HeaderConnectOrCreateLogoRelationInput"
	},
	HeaderConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	HeaderCreateOrganizationListEntityRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput",
		connectOrCreate:"HeaderConnectOrCreateOrganizationListRelationInput"
	},
	HeaderConnectOrCreateOrganizationListRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput"
	},
	HeaderLocaleConnectOrCreateRootRelationInput:{
		connect:"HeaderUniqueWhere",
		create:"HeaderWithoutLocalesCreateInput"
	},
	HeaderLocaleCreateLinksEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLinksRelationInput"
	},
	LinkListCreateInput:{
		id:"UUID",
		items:"LinkListCreateItemsEntityRelationInput"
	},
	LinkListCreateItemsEntityRelationInput:{
		connect:"LinkItemUniqueWhere",
		create:"LinkItemWithoutListCreateInput",
		connectOrCreate:"LinkListConnectOrCreateItemsRelationInput"
	},
	LinkItemWithoutListCreateInput:{
		id:"UUID",
		link:"LinkItemCreateLinkEntityRelationInput"
	},
	LinkItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"LinkItemConnectOrCreateLinkRelationInput"
	},
	LinkItemConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	LinkListConnectOrCreateItemsRelationInput:{
		connect:"LinkItemUniqueWhere",
		create:"LinkItemWithoutListCreateInput"
	},
	HeaderLocaleConnectOrCreateLinksRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput"
	},
	LocaleConnectOrCreateHeadersRelationInput:{
		connect:"HeaderLocaleUniqueWhere",
		create:"HeaderLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateFootersEntityRelationInput:{
		connect:"FooterLocaleUniqueWhere",
		create:"FooterLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateFootersRelationInput"
	},
	FooterLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"FooterLocaleCreateRootEntityRelationInput",
		linkList:"FooterLocaleCreateLinkListEntityRelationInput",
		addressInfo:"FooterLocaleCreateAddressInfoEntityRelationInput",
		imageLinkList:"FooterLocaleCreateImageLinkListEntityRelationInput"
	},
	FooterLocaleCreateRootEntityRelationInput:{
		connect:"FooterUniqueWhere",
		create:"FooterWithoutLocalesCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateRootRelationInput"
	},
	FooterWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One",
		logo:"FooterCreateLogoEntityRelationInput"
	},
	FooterCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"FooterConnectOrCreateLogoRelationInput"
	},
	FooterConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	FooterLocaleConnectOrCreateRootRelationInput:{
		connect:"FooterUniqueWhere",
		create:"FooterWithoutLocalesCreateInput"
	},
	FooterLocaleCreateLinkListEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateLinkListRelationInput"
	},
	FooterLocaleConnectOrCreateLinkListRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput"
	},
	FooterLocaleCreateAddressInfoEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateAddressInfoRelationInput"
	},
	FooterLocaleConnectOrCreateAddressInfoRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	FooterLocaleCreateImageLinkListEntityRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateImageLinkListRelationInput"
	},
	ImageLinkListCreateInput:{
		id:"UUID",
		items:"ImageLinkListCreateItemsEntityRelationInput"
	},
	ImageLinkListCreateItemsEntityRelationInput:{
		connect:"ImageLinkItemUniqueWhere",
		create:"ImageLinkItemWithoutListCreateInput",
		connectOrCreate:"ImageLinkListConnectOrCreateItemsRelationInput"
	},
	ImageLinkItemWithoutListCreateInput:{
		id:"UUID",
		item:"ImageLinkItemCreateItemEntityRelationInput"
	},
	ImageLinkItemCreateItemEntityRelationInput:{
		connect:"ImageLinkUniqueWhere",
		create:"ImageLinkCreateInput",
		connectOrCreate:"ImageLinkItemConnectOrCreateItemRelationInput"
	},
	ImageLinkUniqueWhere:{
		id:"UUID"
	},
	ImageLinkCreateInput:{
		id:"UUID",
		image:"ImageLinkCreateImageEntityRelationInput",
		link:"ImageLinkCreateLinkEntityRelationInput"
	},
	ImageLinkCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ImageLinkConnectOrCreateImageRelationInput"
	},
	ImageLinkConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ImageLinkCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"ImageLinkConnectOrCreateLinkRelationInput"
	},
	ImageLinkConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	ImageLinkItemConnectOrCreateItemRelationInput:{
		connect:"ImageLinkUniqueWhere",
		create:"ImageLinkCreateInput"
	},
	ImageLinkListConnectOrCreateItemsRelationInput:{
		connect:"ImageLinkItemUniqueWhere",
		create:"ImageLinkItemWithoutListCreateInput"
	},
	FooterLocaleConnectOrCreateImageLinkListRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListCreateInput"
	},
	LocaleConnectOrCreateFootersRelationInput:{
		connect:"FooterLocaleUniqueWhere",
		create:"FooterLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateGenericPageAboutSettingsEntityRelationInput:{
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		create:"GenericPageAboutSettingsLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"
	},
	GenericPageAboutSettingsLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"GenericPageAboutSettingsLocaleCreateRootEntityRelationInput",
		linkGroups:"GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"
	},
	GenericPageAboutSettingsLocaleCreateRootEntityRelationInput:{
		connect:"GenericPageAboutSettingsUniqueWhere",
		create:"GenericPageAboutSettingsWithoutLocalesCreateInput",
		connectOrCreate:"GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"
	},
	GenericPageAboutSettingsWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput:{
		connect:"GenericPageAboutSettingsUniqueWhere",
		create:"GenericPageAboutSettingsWithoutLocalesCreateInput"
	},
	GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput:{
		connect:"GenericPageAboutGroupLinksLocaleUniqueWhere",
		create:"GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput",
		connectOrCreate:"GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"
	},
	GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput:{
		id:"UUID",
		linkList:"GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"
	},
	GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput",
		connectOrCreate:"GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"
	},
	GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput"
	},
	GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput:{
		connect:"GenericPageAboutGroupLinksLocaleUniqueWhere",
		create:"GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"
	},
	LocaleConnectOrCreateGenericPageAboutSettingsRelationInput:{
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		create:"GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"
	},
	LocaleCreatePostRevisionsEntityRelationInput:{
		connect:"PostRevisionLocaleUniqueWhere",
		create:"PostRevisionLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreatePostRevisionsRelationInput"
	},
	PostRevisionLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"PostRevisionLocaleCreateRootEntityRelationInput",
		content:"PostRevisionLocaleCreateContentEntityRelationInput",
		seo:"PostRevisionLocaleCreateSeoEntityRelationInput",
		leadContent:"PostRevisionLocaleCreateLeadContentEntityRelationInput"
	},
	PostRevisionLocaleCreateRootEntityRelationInput:{
		connect:"PostRevisionUniqueWhere",
		create:"PostRevisionWithoutLocalesCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateRootRelationInput"
	},
	PostRevisionWithoutLocalesCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		createdById:"UUID",
		publishedById:"UUID",
		type:"PostType",
		publishedAt:"DateTime",
		post:"PostRevisionCreatePostEntityRelationInput",
		tileImage:"PostRevisionCreateTileImageEntityRelationInput",
		tileVideo:"PostRevisionCreateTileVideoEntityRelationInput",
		heroImage:"PostRevisionCreateHeroImageEntityRelationInput",
		regionListOverride:"PostRevisionCreateRegionListOverrideEntityRelationInput"
	},
	PostRevisionCreatePostEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutRevisionsCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreatePostRelationInput"
	},
	PostWithoutRevisionsCreateInput:{
		id:"UUID",
		organization:"PostCreateOrganizationEntityRelationInput",
		area:"PostCreateAreaEntityRelationInput",
		activeRevision:"PostCreateActiveRevisionEntityRelationInput",
		locales:"PostCreateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostCreateMetaEntityRelationInput",
		heroCarousel:"PostCreateHeroCarouselEntityRelationInput",
		reportPage:"PostCreateReportPageEntityRelationInput",
		content:"PostCreateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostCreateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostCreateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostCreateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostCreateFundraisingProgressEntityRelationInput"
	},
	PostCreateActiveRevisionEntityRelationInput:{
		connect:"PostRevisionUniqueWhere",
		create:"PostRevisionCreateInput",
		connectOrCreate:"PostConnectOrCreateActiveRevisionRelationInput"
	},
	PostRevisionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		createdById:"UUID",
		publishedById:"UUID",
		type:"PostType",
		publishedAt:"DateTime",
		post:"PostRevisionCreatePostEntityRelationInput",
		tileImage:"PostRevisionCreateTileImageEntityRelationInput",
		tileVideo:"PostRevisionCreateTileVideoEntityRelationInput",
		heroImage:"PostRevisionCreateHeroImageEntityRelationInput",
		locales:"PostRevisionCreateLocalesEntityRelationInput",
		regionListOverride:"PostRevisionCreateRegionListOverrideEntityRelationInput"
	},
	PostRevisionCreateTileImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateTileImageRelationInput"
	},
	PostRevisionConnectOrCreateTileImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostRevisionCreateTileVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateTileVideoRelationInput"
	},
	PostRevisionConnectOrCreateTileVideoRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput"
	},
	PostRevisionCreateHeroImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateHeroImageRelationInput"
	},
	PostRevisionConnectOrCreateHeroImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostRevisionCreateLocalesEntityRelationInput:{
		connect:"PostRevisionLocaleUniqueWhere",
		create:"PostRevisionLocaleWithoutRootCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateLocalesRelationInput"
	},
	PostRevisionLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"PostRevisionLocaleCreateLocaleEntityRelationInput",
		content:"PostRevisionLocaleCreateContentEntityRelationInput",
		seo:"PostRevisionLocaleCreateSeoEntityRelationInput",
		leadContent:"PostRevisionLocaleCreateLeadContentEntityRelationInput"
	},
	PostRevisionLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostRevisionsCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutPostRevisionsCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreateFlagImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"LocaleConnectOrCreateFlagImageRelationInput"
	},
	LocaleConnectOrCreateFlagImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	LocaleCreateFeedPagesEntityRelationInput:{
		connect:"FeedPageLocaleUniqueWhere",
		create:"FeedPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateFeedPagesRelationInput"
	},
	FeedPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"FeedPageLocaleCreateRootEntityRelationInput",
		heroTiles:"FeedPageLocaleCreateHeroTilesEntityRelationInput",
		sectionList:"FeedPageLocaleCreateSectionListEntityRelationInput",
		cardList:"FeedPageLocaleCreateCardListEntityRelationInput",
		storyGuideList:"FeedPageLocaleCreateStoryGuideListEntityRelationInput"
	},
	FeedPageLocaleCreateRootEntityRelationInput:{
		connect:"FeedPageUniqueWhere",
		create:"FeedPageWithoutLocalesCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateRootRelationInput"
	},
	FeedPageWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	FeedPageLocaleConnectOrCreateRootRelationInput:{
		connect:"FeedPageUniqueWhere",
		create:"FeedPageWithoutLocalesCreateInput"
	},
	FeedPageLocaleCreateHeroTilesEntityRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateHeroTilesRelationInput"
	},
	TileListCreateInput:{
		id:"UUID",
		size:"TileListSize",
		items:"TileListCreateItemsEntityRelationInput",
		areaType:"TileListCreateAreaTypeEntityRelationInput"
	},
	TileListCreateItemsEntityRelationInput:{
		connect:"TileItemUniqueWhere",
		create:"TileItemWithoutListCreateInput",
		connectOrCreate:"TileListConnectOrCreateItemsRelationInput"
	},
	TileItemWithoutListCreateInput:{
		id:"UUID",
		type:"TileItemType",
		post:"TileItemCreatePostEntityRelationInput",
		area:"TileItemCreateAreaEntityRelationInput",
		image:"TileItemCreateImageEntityRelationInput",
		link:"TileItemCreateLinkEntityRelationInput",
		organization:"TileItemCreateOrganizationEntityRelationInput"
	},
	TileItemCreatePostEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput",
		connectOrCreate:"TileItemConnectOrCreatePostRelationInput"
	},
	PostCreateInput:{
		id:"UUID",
		organization:"PostCreateOrganizationEntityRelationInput",
		area:"PostCreateAreaEntityRelationInput",
		activeRevision:"PostCreateActiveRevisionEntityRelationInput",
		revisions:"PostCreateRevisionsEntityRelationInput",
		locales:"PostCreateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostCreateMetaEntityRelationInput",
		heroCarousel:"PostCreateHeroCarouselEntityRelationInput",
		reportPage:"PostCreateReportPageEntityRelationInput",
		content:"PostCreateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostCreateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostCreateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostCreateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostCreateFundraisingProgressEntityRelationInput"
	},
	PostCreateRevisionsEntityRelationInput:{
		connect:"PostRevisionUniqueWhere",
		create:"PostRevisionWithoutPostCreateInput",
		connectOrCreate:"PostConnectOrCreateRevisionsRelationInput"
	},
	PostRevisionWithoutPostCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		createdById:"UUID",
		publishedById:"UUID",
		type:"PostType",
		publishedAt:"DateTime",
		tileImage:"PostRevisionCreateTileImageEntityRelationInput",
		tileVideo:"PostRevisionCreateTileVideoEntityRelationInput",
		heroImage:"PostRevisionCreateHeroImageEntityRelationInput",
		locales:"PostRevisionCreateLocalesEntityRelationInput",
		regionListOverride:"PostRevisionCreateRegionListOverrideEntityRelationInput"
	},
	PostRevisionCreateRegionListOverrideEntityRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateRegionListOverrideRelationInput"
	},
	PostRevisionConnectOrCreateRegionListOverrideRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListCreateInput"
	},
	PostConnectOrCreateRevisionsRelationInput:{
		connect:"PostRevisionUniqueWhere",
		create:"PostRevisionWithoutPostCreateInput"
	},
	PostCreateLocalesEntityRelationInput:{
		connect:"PostLocaleUniqueWhere",
		create:"PostLocaleWithoutRootCreateInput",
		connectOrCreate:"PostConnectOrCreateLocalesRelationInput"
	},
	PostLocaleWithoutRootCreateInput:{
		id:"UUID",
		content:"PostLocaleCreateContentEntityRelationInput",
		seo:"PostLocaleCreateSeoEntityRelationInput",
		link:"PostLocaleCreateLinkEntityRelationInput",
		locale:"PostLocaleCreateLocaleEntityRelationInput",
		publishedAt:"DateTime"
	},
	PostLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutPostCreateInput:{
		id:"UUID",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		postArea:"LinkableCreatePostAreaEntityRelationInput",
		postOrganization:"LinkableCreatePostOrganizationEntityRelationInput",
		reportPage:"LinkableCreateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableCreateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableCreateReceivedGiftsPageEntityRelationInput"
	},
	LinkableCreatePostOrganizationEntityRelationInput:{
		connect:"PostOrganizationLocaleUniqueWhere",
		create:"PostOrganizationLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreatePostOrganizationRelationInput"
	},
	PostOrganizationLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"PostOrganizationLocaleCreateRootEntityRelationInput",
		locale:"PostOrganizationLocaleCreateLocaleEntityRelationInput",
		domain:"PostOrganizationLocaleCreateDomainEntityRelationInput",
		seo:"PostOrganizationLocaleCreateSeoEntityRelationInput",
		content:"PostOrganizationLocaleCreateContentEntityRelationInput"
	},
	PostOrganizationLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostOrganizationsCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutPostOrganizationsCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreateRecurringPaymentPagesEntityRelationInput:{
		connect:"RecurringPaymentPageLocaleUniqueWhere",
		create:"RecurringPaymentPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateRecurringPaymentPagesRelationInput"
	},
	RecurringPaymentPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"RecurringPaymentPageLocaleCreateRootEntityRelationInput",
		favouritePosts:"RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput",
		storyGuideList:"RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"
	},
	RecurringPaymentPageLocaleCreateRootEntityRelationInput:{
		connect:"RecurringPaymentPageUniqueWhere",
		create:"RecurringPaymentPageWithoutLocalesCreateInput",
		connectOrCreate:"RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"
	},
	RecurringPaymentPageWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	RecurringPaymentPageLocaleConnectOrCreateRootRelationInput:{
		connect:"RecurringPaymentPageUniqueWhere",
		create:"RecurringPaymentPageWithoutLocalesCreateInput"
	},
	RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput:{
		connect:"PostListUniqueWhere",
		create:"PostListCreateInput",
		connectOrCreate:"RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"
	},
	PostListCreateInput:{
		id:"UUID",
		items:"PostListCreateItemsEntityRelationInput"
	},
	PostListCreateItemsEntityRelationInput:{
		connect:"PostListItemUniqueWhere",
		create:"PostListItemWithoutListCreateInput",
		connectOrCreate:"PostListConnectOrCreateItemsRelationInput"
	},
	PostListItemWithoutListCreateInput:{
		id:"UUID",
		post:"PostListItemCreatePostEntityRelationInput"
	},
	PostListItemCreatePostEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput",
		connectOrCreate:"PostListItemConnectOrCreatePostRelationInput"
	},
	PostListItemConnectOrCreatePostRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput"
	},
	PostListConnectOrCreateItemsRelationInput:{
		connect:"PostListItemUniqueWhere",
		create:"PostListItemWithoutListCreateInput"
	},
	RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput:{
		connect:"PostListUniqueWhere",
		create:"PostListCreateInput"
	},
	RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListCreateInput",
		connectOrCreate:"RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"
	},
	StoryGuideListCreateInput:{
		id:"UUID",
		items:"StoryGuideListCreateItemsEntityRelationInput"
	},
	StoryGuideListCreateItemsEntityRelationInput:{
		connect:"StoryGuideItemUniqueWhere",
		create:"StoryGuideItemWithoutListCreateInput",
		connectOrCreate:"StoryGuideListConnectOrCreateItemsRelationInput"
	},
	StoryGuideItemWithoutListCreateInput:{
		id:"UUID",
		guide:"StoryGuideItemCreateGuideEntityRelationInput"
	},
	StoryGuideItemCreateGuideEntityRelationInput:{
		connect:"StoryGuideUniqueWhere",
		create:"StoryGuideCreateInput",
		connectOrCreate:"StoryGuideItemConnectOrCreateGuideRelationInput"
	},
	StoryGuideUniqueWhere:{
		id:"UUID"
	},
	StoryGuideCreateInput:{
		id:"UUID",
		mediaType:"MediaType",
		image:"StoryGuideCreateImageEntityRelationInput",
		secondaryImage:"StoryGuideCreateSecondaryImageEntityRelationInput"
	},
	StoryGuideCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"StoryGuideConnectOrCreateImageRelationInput"
	},
	StoryGuideConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	StoryGuideCreateSecondaryImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"StoryGuideConnectOrCreateSecondaryImageRelationInput"
	},
	StoryGuideConnectOrCreateSecondaryImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	StoryGuideItemConnectOrCreateGuideRelationInput:{
		connect:"StoryGuideUniqueWhere",
		create:"StoryGuideCreateInput"
	},
	StoryGuideListConnectOrCreateItemsRelationInput:{
		connect:"StoryGuideItemUniqueWhere",
		create:"StoryGuideItemWithoutListCreateInput"
	},
	RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListCreateInput"
	},
	LocaleConnectOrCreateRecurringPaymentPagesRelationInput:{
		connect:"RecurringPaymentPageLocaleUniqueWhere",
		create:"RecurringPaymentPageLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateGivenGiftsPagesEntityRelationInput:{
		connect:"GivenGiftsPageLocaleUniqueWhere",
		create:"GivenGiftsPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateGivenGiftsPagesRelationInput"
	},
	GivenGiftsPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"GivenGiftsPageLocaleCreateRootEntityRelationInput",
		content:"GivenGiftsPageLocaleCreateContentEntityRelationInput",
		seo:"GivenGiftsPageLocaleCreateSeoEntityRelationInput",
		link:"GivenGiftsPageLocaleCreateLinkEntityRelationInput"
	},
	GivenGiftsPageLocaleCreateRootEntityRelationInput:{
		connect:"GivenGiftsPageUniqueWhere",
		create:"GivenGiftsPageWithoutLocalesCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateRootRelationInput"
	},
	GivenGiftsPageWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	GivenGiftsPageLocaleConnectOrCreateRootRelationInput:{
		connect:"GivenGiftsPageUniqueWhere",
		create:"GivenGiftsPageWithoutLocalesCreateInput"
	},
	GivenGiftsPageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateContentRelationInput"
	},
	GivenGiftsPageLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	GivenGiftsPageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"
	},
	GivenGiftsPageLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	GivenGiftsPageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGivenGiftsPageCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutGivenGiftsPageCreateInput:{
		id:"UUID",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		post:"LinkableCreatePostEntityRelationInput",
		postArea:"LinkableCreatePostAreaEntityRelationInput",
		postOrganization:"LinkableCreatePostOrganizationEntityRelationInput",
		reportPage:"LinkableCreateReportPageEntityRelationInput",
		receivedGiftsPage:"LinkableCreateReceivedGiftsPageEntityRelationInput"
	},
	LinkableCreateReportPageEntityRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateReportPageRelationInput"
	},
	ReportPageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"ReportPageLocaleCreateRootEntityRelationInput",
		locale:"ReportPageLocaleCreateLocaleEntityRelationInput",
		content:"ReportPageLocaleCreateContentEntityRelationInput",
		seo:"ReportPageLocaleCreateSeoEntityRelationInput",
		posts:"ReportPageLocaleCreatePostsEntityRelationInput"
	},
	ReportPageLocaleCreateRootEntityRelationInput:{
		connect:"ReportPageUniqueWhere",
		create:"ReportPageWithoutLocalesCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateRootRelationInput"
	},
	ReportPageWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	ReportPageLocaleConnectOrCreateRootRelationInput:{
		connect:"ReportPageUniqueWhere",
		create:"ReportPageWithoutLocalesCreateInput"
	},
	ReportPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReportPagesCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutReportPagesCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreateReceivedGiftsPagesEntityRelationInput:{
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		create:"ReceivedGiftsPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateReceivedGiftsPagesRelationInput"
	},
	ReceivedGiftsPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		link:"ReceivedGiftsPageLocaleCreateLinkEntityRelationInput",
		root:"ReceivedGiftsPageLocaleCreateRootEntityRelationInput",
		content:"ReceivedGiftsPageLocaleCreateContentEntityRelationInput",
		seo:"ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"
	},
	ReceivedGiftsPageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutReceivedGiftsPageCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutReceivedGiftsPageCreateInput:{
		id:"UUID",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		post:"LinkableCreatePostEntityRelationInput",
		postArea:"LinkableCreatePostAreaEntityRelationInput",
		postOrganization:"LinkableCreatePostOrganizationEntityRelationInput",
		reportPage:"LinkableCreateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableCreateGivenGiftsPageEntityRelationInput"
	},
	LinkableCreateGivenGiftsPageEntityRelationInput:{
		connect:"GivenGiftsPageLocaleUniqueWhere",
		create:"GivenGiftsPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateGivenGiftsPageRelationInput"
	},
	GivenGiftsPageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"GivenGiftsPageLocaleCreateRootEntityRelationInput",
		locale:"GivenGiftsPageLocaleCreateLocaleEntityRelationInput",
		content:"GivenGiftsPageLocaleCreateContentEntityRelationInput",
		seo:"GivenGiftsPageLocaleCreateSeoEntityRelationInput"
	},
	GivenGiftsPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGivenGiftsPagesCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutGivenGiftsPagesCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreateReportPagesEntityRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateReportPagesRelationInput"
	},
	ReportPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		link:"ReportPageLocaleCreateLinkEntityRelationInput",
		root:"ReportPageLocaleCreateRootEntityRelationInput",
		content:"ReportPageLocaleCreateContentEntityRelationInput",
		seo:"ReportPageLocaleCreateSeoEntityRelationInput",
		posts:"ReportPageLocaleCreatePostsEntityRelationInput"
	},
	ReportPageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutReportPageCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutReportPageCreateInput:{
		id:"UUID",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		post:"LinkableCreatePostEntityRelationInput",
		postArea:"LinkableCreatePostAreaEntityRelationInput",
		postOrganization:"LinkableCreatePostOrganizationEntityRelationInput",
		givenGiftsPage:"LinkableCreateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableCreateReceivedGiftsPageEntityRelationInput"
	},
	LinkableCreateReceivedGiftsPageEntityRelationInput:{
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		create:"ReceivedGiftsPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateReceivedGiftsPageRelationInput"
	},
	ReceivedGiftsPageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"ReceivedGiftsPageLocaleCreateRootEntityRelationInput",
		locale:"ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput",
		content:"ReceivedGiftsPageLocaleCreateContentEntityRelationInput",
		seo:"ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"
	},
	ReceivedGiftsPageLocaleCreateRootEntityRelationInput:{
		connect:"ReceivedGiftsPageUniqueWhere",
		create:"ReceivedGiftsPageWithoutLocalesCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"
	},
	ReceivedGiftsPageWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput:{
		connect:"ReceivedGiftsPageUniqueWhere",
		create:"ReceivedGiftsPageWithoutLocalesCreateInput"
	},
	ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReceivedGiftsPagesCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutReceivedGiftsPagesCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreateReportNavigationsEntityRelationInput:{
		connect:"ReportNavigationLocaleUniqueWhere",
		create:"ReportNavigationLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateReportNavigationsRelationInput"
	},
	ReportNavigationLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ReportNavigationLocaleCreateRootEntityRelationInput",
		pages:"ReportNavigationLocaleCreatePagesEntityRelationInput"
	},
	ReportNavigationLocaleCreatePagesEntityRelationInput:{
		connect:"GenericPageUniqueWhere",
		create:"GenericPageWithoutReportNavigationCreateInput",
		connectOrCreate:"ReportNavigationLocaleConnectOrCreatePagesRelationInput"
	},
	GenericPageWithoutReportNavigationCreateInput:{
		id:"UUID",
		locales:"GenericPageCreateLocalesEntityRelationInput",
		type:"GenericPageType"
	},
	GenericPageCreateLocalesEntityRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutRootCreateInput",
		connectOrCreate:"GenericPageConnectOrCreateLocalesRelationInput"
	},
	GenericPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"GenericPageLocaleCreateLocaleEntityRelationInput",
		content:"GenericPageLocaleCreateContentEntityRelationInput",
		seo:"GenericPageLocaleCreateSeoEntityRelationInput",
		link:"GenericPageLocaleCreateLinkEntityRelationInput"
	},
	GenericPageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateContentRelationInput"
	},
	GenericPageLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	GenericPageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateSeoRelationInput"
	},
	GenericPageLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	GenericPageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGenericPageCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutGenericPageCreateInput:{
		id:"UUID",
		post:"LinkableCreatePostEntityRelationInput",
		postArea:"LinkableCreatePostAreaEntityRelationInput",
		postOrganization:"LinkableCreatePostOrganizationEntityRelationInput",
		reportPage:"LinkableCreateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableCreateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableCreateReceivedGiftsPageEntityRelationInput"
	},
	GenericPageLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGenericPageCreateInput"
	},
	GenericPageConnectOrCreateLocalesRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutRootCreateInput"
	},
	ReportNavigationLocaleConnectOrCreatePagesRelationInput:{
		connect:"GenericPageUniqueWhere",
		create:"GenericPageWithoutReportNavigationCreateInput"
	},
	LocaleConnectOrCreateReportNavigationsRelationInput:{
		connect:"ReportNavigationLocaleUniqueWhere",
		create:"ReportNavigationLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateScheduledNotificationsEntityRelationInput:{
		connect:"ScheduledNotificationLocaleUniqueWhere",
		create:"ScheduledNotificationLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateScheduledNotificationsRelationInput"
	},
	ScheduledNotificationLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ScheduledNotificationLocaleCreateRootEntityRelationInput"
	},
	ScheduledNotificationLocaleCreateRootEntityRelationInput:{
		connect:"ScheduledNotificationUniqueWhere",
		create:"ScheduledNotificationWithoutLocalesCreateInput",
		connectOrCreate:"ScheduledNotificationLocaleConnectOrCreateRootRelationInput"
	},
	ScheduledNotificationWithoutLocalesCreateInput:{
		id:"UUID",
		scheduledDate:"Date",
		target:"ScheduledNotificationCreateTargetEntityRelationInput",
		image:"ScheduledNotificationCreateImageEntityRelationInput",
		completedAt:"DateTime",
		processedNotifications:"ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"
	},
	ScheduledNotificationCreateTargetEntityRelationInput:{
		connect:"NotificationTargetGroupUniqueWhere",
		create:"NotificationTargetGroupCreateInput",
		connectOrCreate:"ScheduledNotificationConnectOrCreateTargetRelationInput"
	},
	NotificationTargetGroupUniqueWhere:{
		id:"UUID"
	},
	NotificationTargetGroupCreateInput:{
		id:"UUID",
		type:"NotificationTargetType",
		regions:"NotificationTargetGroupCreateRegionsEntityRelationInput"
	},
	NotificationTargetGroupCreateRegionsEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"NotificationTargetGroupConnectOrCreateRegionsRelationInput"
	},
	NotificationTargetGroupConnectOrCreateRegionsRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput"
	},
	ScheduledNotificationConnectOrCreateTargetRelationInput:{
		connect:"NotificationTargetGroupUniqueWhere",
		create:"NotificationTargetGroupCreateInput"
	},
	ScheduledNotificationCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ScheduledNotificationConnectOrCreateImageRelationInput"
	},
	ScheduledNotificationConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ScheduledNotificationCreateProcessedNotificationsEntityRelationInput:{
		connect:"ProcessedNotificationSourceUniqueWhere",
		create:"ProcessedNotificationSourceWithoutScheduledNotificationCreateInput",
		connectOrCreate:"ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"
	},
	ProcessedNotificationSourceWithoutScheduledNotificationCreateInput:{
		id:"UUID",
		type:"ProcessedNotificationSourceType",
		processedNotification:"ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput",
		donationReminderUser:"ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"
	},
	ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput:{
		connect:"ProcessedNotificationUniqueWhere",
		create:"ProcessedNotificationWithoutSourceCreateInput",
		connectOrCreate:"ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"
	},
	ProcessedNotificationWithoutSourceCreateInput:{
		id:"UUID",
		sentAt:"DateTime"
	},
	ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput:{
		connect:"ProcessedNotificationUniqueWhere",
		create:"ProcessedNotificationWithoutSourceCreateInput"
	},
	ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutProcessedNotificationsCreateInput",
		connectOrCreate:"ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"
	},
	UserUniqueWhere:{
		id:"UUID",
		tenantPersonId:"UUID",
		payments:"UserPaymentUniqueWhere",
		recurringPayments:"UserRecurringPaymentUniqueWhere",
		onBehalfDonations:"OnBehalfDonationUniqueWhere",
		devices:"DeviceUniqueWhere",
		processedNotifications:"ProcessedNotificationSourceUniqueWhere",
		areaStats:"UserAreaStatsUniqueWhere",
		organizationStats:"UserOrganizationStatsUniqueWhere",
		postStats:"UserPostStatsUniqueWhere",
		currencyStats:"UserCurrencyStatsUniqueWhere",
		stats:"UserStatsUniqueWhere"
	},
	DeviceUniqueWhere:{
		id:"UUID",
		user:"UserUniqueWhere"
	},
	UserAreaStatsUniqueWhere:{
		id:"UUID"
	},
	UserOrganizationStatsUniqueWhere:{
		id:"UUID"
	},
	UserPostStatsUniqueWhere:{
		id:"UUID"
	},
	UserCurrencyStatsUniqueWhere:{
		id:"UUID"
	},
	UserStatsUniqueWhere:{
		id:"UUID",
		user:"UserUniqueWhere"
	},
	UserWithoutProcessedNotificationsCreateInput:{
		id:"UUID",
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserCreatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserCreateRegionEntityRelationInput",
		currency:"UserCreateCurrencyEntityRelationInput",
		recurringPayments:"UserCreateRecurringPaymentsEntityRelationInput",
		onBehalfDonations:"UserCreateOnBehalfDonationsEntityRelationInput",
		locale:"UserCreateLocaleEntityRelationInput",
		devices:"UserCreateDevicesEntityRelationInput",
		areaStats:"UserCreateAreaStatsEntityRelationInput",
		organizationStats:"UserCreateOrganizationStatsEntityRelationInput",
		postStats:"UserCreatePostStatsEntityRelationInput",
		currencyStats:"UserCreateCurrencyStatsEntityRelationInput"
	},
	UserCreatePaymentsEntityRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutUserCreateInput",
		connectOrCreate:"UserConnectOrCreatePaymentsRelationInput"
	},
	UserPaymentWithoutUserCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		currency:"UserPaymentCreateCurrencyEntityRelationInput",
		order:"UserPaymentCreateOrderEntityRelationInput",
		csobPayment:"UserPaymentCreateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentCreateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentCreateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentCreateRegionEntityRelationInput",
		onBehalfDonation:"UserPaymentCreateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentCreateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentCreateMetadataEntityRelationInput"
	},
	UserPaymentCreateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateCurrencyRelationInput"
	},
	UserPaymentConnectOrCreateCurrencyRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput"
	},
	UserPaymentCreateOrderEntityRelationInput:{
		connect:"UserPaymentOrderIdUniqueWhere",
		create:"UserPaymentOrderIdCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateOrderRelationInput"
	},
	UserPaymentOrderIdCreateInput:{
		id:"UUID"
	},
	UserPaymentConnectOrCreateOrderRelationInput:{
		connect:"UserPaymentOrderIdUniqueWhere",
		create:"UserPaymentOrderIdCreateInput"
	},
	UserPaymentCreateCsobPaymentEntityRelationInput:{
		connect:"CsobPaymentUniqueWhere",
		create:"CsobPaymentWithoutPaymentCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateCsobPaymentRelationInput"
	},
	CsobPaymentWithoutPaymentCreateInput:{
		id:"UUID",
		statusChanges:"CsobPaymentCreateStatusChangesEntityRelationInput",
		metadata:"CsobPaymentCreateMetadataEntityRelationInput"
	},
	CsobPaymentCreateStatusChangesEntityRelationInput:{
		connect:"CsobPaymentStatusChangeUniqueWhere",
		create:"CsobPaymentStatusChangeWithoutPaymentCreateInput",
		connectOrCreate:"CsobPaymentConnectOrCreateStatusChangesRelationInput"
	},
	CsobPaymentStatusChangeWithoutPaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	CsobPaymentConnectOrCreateStatusChangesRelationInput:{
		connect:"CsobPaymentStatusChangeUniqueWhere",
		create:"CsobPaymentStatusChangeWithoutPaymentCreateInput"
	},
	CsobPaymentCreateMetadataEntityRelationInput:{
		connect:"CsobPaymentMetadataUniqueWhere"
	},
	UserPaymentConnectOrCreateCsobPaymentRelationInput:{
		connect:"CsobPaymentUniqueWhere",
		create:"CsobPaymentWithoutPaymentCreateInput"
	},
	UserPaymentCreateStripePaymentEntityRelationInput:{
		connect:"StripePaymentUniqueWhere",
		create:"StripePaymentWithoutPaymentCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateStripePaymentRelationInput"
	},
	StripePaymentWithoutPaymentCreateInput:{
		id:"UUID",
		statusChanges:"StripePaymentCreateStatusChangesEntityRelationInput",
		metadata:"StripePaymentCreateMetadataEntityRelationInput"
	},
	StripePaymentCreateStatusChangesEntityRelationInput:{
		connect:"StripePaymentStatusChangeUniqueWhere",
		create:"StripePaymentStatusChangeWithoutPaymentCreateInput",
		connectOrCreate:"StripePaymentConnectOrCreateStatusChangesRelationInput"
	},
	StripePaymentStatusChangeWithoutPaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		paymentIntentStatus:"StripePaymentStatusChangePaymentIntentStatus"
	},
	StripePaymentConnectOrCreateStatusChangesRelationInput:{
		connect:"StripePaymentStatusChangeUniqueWhere",
		create:"StripePaymentStatusChangeWithoutPaymentCreateInput"
	},
	StripePaymentCreateMetadataEntityRelationInput:{
		connect:"StripePaymentMetadataUniqueWhere"
	},
	UserPaymentConnectOrCreateStripePaymentRelationInput:{
		connect:"StripePaymentUniqueWhere",
		create:"StripePaymentWithoutPaymentCreateInput"
	},
	UserPaymentCreateRecurringPaymentItemEntityRelationInput:{
		connect:"UserRecurringPaymentItemUniqueWhere",
		create:"UserRecurringPaymentItemWithoutPaymentsCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"
	},
	UserRecurringPaymentItemWithoutPaymentsCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		recurringPayment:"UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput",
		failedEmailSentAt:"DateTime",
		meta:"UserRecurringPaymentItemCreateMetaEntityRelationInput"
	},
	UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput:{
		connect:"UserRecurringPaymentUniqueWhere",
		create:"UserRecurringPaymentWithoutItemsCreateInput",
		connectOrCreate:"UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"
	},
	UserRecurringPaymentWithoutItemsCreateInput:{
		id:"UUID",
		activeSince:"DateTime",
		cancelledAt:"DateTime",
		interval:"UserRecurringPaymentInterval",
		currency:"UserRecurringPaymentCreateCurrencyEntityRelationInput",
		user:"UserRecurringPaymentCreateUserEntityRelationInput",
		meta:"UserRecurringPaymentCreateMetaEntityRelationInput"
	},
	UserRecurringPaymentCreateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"UserRecurringPaymentConnectOrCreateCurrencyRelationInput"
	},
	UserRecurringPaymentConnectOrCreateCurrencyRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput"
	},
	UserRecurringPaymentCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutRecurringPaymentsCreateInput",
		connectOrCreate:"UserRecurringPaymentConnectOrCreateUserRelationInput"
	},
	UserWithoutRecurringPaymentsCreateInput:{
		id:"UUID",
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserCreatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserCreateRegionEntityRelationInput",
		currency:"UserCreateCurrencyEntityRelationInput",
		onBehalfDonations:"UserCreateOnBehalfDonationsEntityRelationInput",
		locale:"UserCreateLocaleEntityRelationInput",
		devices:"UserCreateDevicesEntityRelationInput",
		processedNotifications:"UserCreateProcessedNotificationsEntityRelationInput",
		areaStats:"UserCreateAreaStatsEntityRelationInput",
		organizationStats:"UserCreateOrganizationStatsEntityRelationInput",
		postStats:"UserCreatePostStatsEntityRelationInput",
		currencyStats:"UserCreateCurrencyStatsEntityRelationInput"
	},
	UserCreateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"UserConnectOrCreateRegionRelationInput"
	},
	UserConnectOrCreateRegionRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput"
	},
	UserCreateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"UserConnectOrCreateCurrencyRelationInput"
	},
	UserConnectOrCreateCurrencyRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput"
	},
	UserCreateOnBehalfDonationsEntityRelationInput:{
		connect:"OnBehalfDonationUniqueWhere",
		create:"OnBehalfDonationWithoutOnBehalfOfCreateInput",
		connectOrCreate:"UserConnectOrCreateOnBehalfDonationsRelationInput"
	},
	OnBehalfDonationWithoutOnBehalfOfCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		payments:"OnBehalfDonationCreatePaymentsEntityRelationInput",
		meta:"OnBehalfDonationCreateMetaEntityRelationInput"
	},
	OnBehalfDonationCreatePaymentsEntityRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutOnBehalfDonationCreateInput",
		connectOrCreate:"OnBehalfDonationConnectOrCreatePaymentsRelationInput"
	},
	UserPaymentWithoutOnBehalfDonationCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		currency:"UserPaymentCreateCurrencyEntityRelationInput",
		order:"UserPaymentCreateOrderEntityRelationInput",
		csobPayment:"UserPaymentCreateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentCreateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentCreateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentCreateRegionEntityRelationInput",
		user:"UserPaymentCreateUserEntityRelationInput",
		triesCollection:"UserPaymentCreateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentCreateMetadataEntityRelationInput"
	},
	UserPaymentCreateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateRegionRelationInput"
	},
	UserPaymentConnectOrCreateRegionRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput"
	},
	UserPaymentCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutPaymentsCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateUserRelationInput"
	},
	UserWithoutPaymentsCreateInput:{
		id:"UUID",
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		region:"UserCreateRegionEntityRelationInput",
		currency:"UserCreateCurrencyEntityRelationInput",
		recurringPayments:"UserCreateRecurringPaymentsEntityRelationInput",
		onBehalfDonations:"UserCreateOnBehalfDonationsEntityRelationInput",
		locale:"UserCreateLocaleEntityRelationInput",
		devices:"UserCreateDevicesEntityRelationInput",
		processedNotifications:"UserCreateProcessedNotificationsEntityRelationInput",
		areaStats:"UserCreateAreaStatsEntityRelationInput",
		organizationStats:"UserCreateOrganizationStatsEntityRelationInput",
		postStats:"UserCreatePostStatsEntityRelationInput",
		currencyStats:"UserCreateCurrencyStatsEntityRelationInput"
	},
	UserCreateRecurringPaymentsEntityRelationInput:{
		connect:"UserRecurringPaymentUniqueWhere",
		create:"UserRecurringPaymentWithoutUserCreateInput",
		connectOrCreate:"UserConnectOrCreateRecurringPaymentsRelationInput"
	},
	UserRecurringPaymentWithoutUserCreateInput:{
		id:"UUID",
		activeSince:"DateTime",
		cancelledAt:"DateTime",
		interval:"UserRecurringPaymentInterval",
		currency:"UserRecurringPaymentCreateCurrencyEntityRelationInput",
		items:"UserRecurringPaymentCreateItemsEntityRelationInput",
		meta:"UserRecurringPaymentCreateMetaEntityRelationInput"
	},
	UserRecurringPaymentCreateItemsEntityRelationInput:{
		connect:"UserRecurringPaymentItemUniqueWhere",
		create:"UserRecurringPaymentItemWithoutRecurringPaymentCreateInput",
		connectOrCreate:"UserRecurringPaymentConnectOrCreateItemsRelationInput"
	},
	UserRecurringPaymentItemWithoutRecurringPaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		payments:"UserRecurringPaymentItemCreatePaymentsEntityRelationInput",
		failedEmailSentAt:"DateTime",
		meta:"UserRecurringPaymentItemCreateMetaEntityRelationInput"
	},
	UserRecurringPaymentItemCreatePaymentsEntityRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutRecurringPaymentItemCreateInput",
		connectOrCreate:"UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"
	},
	UserPaymentWithoutRecurringPaymentItemCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		currency:"UserPaymentCreateCurrencyEntityRelationInput",
		order:"UserPaymentCreateOrderEntityRelationInput",
		csobPayment:"UserPaymentCreateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentCreateStripePaymentEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentCreateRegionEntityRelationInput",
		user:"UserPaymentCreateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentCreateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentCreateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentCreateMetadataEntityRelationInput"
	},
	UserPaymentCreateOnBehalfDonationEntityRelationInput:{
		connect:"OnBehalfDonationUniqueWhere",
		create:"OnBehalfDonationWithoutPaymentsCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateOnBehalfDonationRelationInput"
	},
	OnBehalfDonationWithoutPaymentsCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		onBehalfOf:"OnBehalfDonationCreateOnBehalfOfEntityRelationInput",
		meta:"OnBehalfDonationCreateMetaEntityRelationInput"
	},
	OnBehalfDonationCreateOnBehalfOfEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutOnBehalfDonationsCreateInput",
		connectOrCreate:"OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"
	},
	UserWithoutOnBehalfDonationsCreateInput:{
		id:"UUID",
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserCreatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserCreateRegionEntityRelationInput",
		currency:"UserCreateCurrencyEntityRelationInput",
		recurringPayments:"UserCreateRecurringPaymentsEntityRelationInput",
		locale:"UserCreateLocaleEntityRelationInput",
		devices:"UserCreateDevicesEntityRelationInput",
		processedNotifications:"UserCreateProcessedNotificationsEntityRelationInput",
		areaStats:"UserCreateAreaStatsEntityRelationInput",
		organizationStats:"UserCreateOrganizationStatsEntityRelationInput",
		postStats:"UserCreatePostStatsEntityRelationInput",
		currencyStats:"UserCreateCurrencyStatsEntityRelationInput"
	},
	UserCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleCreateInput",
		connectOrCreate:"UserConnectOrCreateLocaleRelationInput"
	},
	LocaleCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	LocaleCreateSentPaymentsEntityRelationInput:{
		connect:"SentPaymentLocaleUniqueWhere",
		create:"SentPaymentLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateSentPaymentsRelationInput"
	},
	SentPaymentLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"SentPaymentLocaleCreateRootEntityRelationInput"
	},
	SentPaymentLocaleCreateRootEntityRelationInput:{
		connect:"SentPaymentUniqueWhere",
		create:"SentPaymentWithoutLocalesCreateInput",
		connectOrCreate:"SentPaymentLocaleConnectOrCreateRootRelationInput"
	},
	SentPaymentWithoutLocalesCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		sendAt:"DateTime",
		currency:"SentPaymentCreateCurrencyEntityRelationInput",
		area:"SentPaymentCreateAreaEntityRelationInput",
		organization:"SentPaymentCreateOrganizationEntityRelationInput"
	},
	SentPaymentCreateAreaEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutSentPaymentsCreateInput",
		connectOrCreate:"SentPaymentConnectOrCreateAreaRelationInput"
	},
	PostAreaWithoutSentPaymentsCreateInput:{
		id:"UUID",
		icon:"PostAreaCreateIconEntityRelationInput",
		locales:"PostAreaCreateLocalesEntityRelationInput",
		regionListOverride:"PostAreaCreateRegionListOverrideEntityRelationInput",
		posts:"PostAreaCreatePostsEntityRelationInput",
		region:"PostAreaCreateRegionEntityRelationInput",
		meta:"PostAreaCreateMetaEntityRelationInput",
		mobileHeroImage:"PostAreaCreateMobileHeroImageEntityRelationInput",
		plainIcon:"PostAreaCreatePlainIconEntityRelationInput",
		areaSentPaymentCurrencySums:"PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaSentPaymentSum:"PostAreaCreateAreaSentPaymentSumEntityRelationInput",
		areaCurrencySums:"PostAreaCreateAreaCurrencySumsEntityRelationInput",
		areaSum:"PostAreaCreateAreaSumEntityRelationInput"
	},
	PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput:{
		connect:"PostAreaSentPaymentCurrencySumUniqueWhere"
	},
	PostAreaCreateAreaSentPaymentSumEntityRelationInput:{
		connect:"PostAreaSentPaymentSumUniqueWhere"
	},
	PostAreaCreateAreaCurrencySumsEntityRelationInput:{
		connect:"PostAreaCurrencySumUniqueWhere"
	},
	PostAreaCreateAreaSumEntityRelationInput:{
		connect:"PostAreaSumUniqueWhere"
	},
	SentPaymentConnectOrCreateAreaRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutSentPaymentsCreateInput"
	},
	SentPaymentLocaleConnectOrCreateRootRelationInput:{
		connect:"SentPaymentUniqueWhere",
		create:"SentPaymentWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateSentPaymentsRelationInput:{
		connect:"SentPaymentLocaleUniqueWhere",
		create:"SentPaymentLocaleWithoutLocaleCreateInput"
	},
	UserConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleCreateInput"
	},
	UserCreateDevicesEntityRelationInput:{
		connect:"DeviceUniqueWhere",
		create:"DeviceWithoutUserCreateInput",
		connectOrCreate:"UserConnectOrCreateDevicesRelationInput"
	},
	DeviceWithoutUserCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime"
	},
	UserConnectOrCreateDevicesRelationInput:{
		connect:"DeviceUniqueWhere",
		create:"DeviceWithoutUserCreateInput"
	},
	UserCreateProcessedNotificationsEntityRelationInput:{
		connect:"ProcessedNotificationSourceUniqueWhere",
		create:"ProcessedNotificationSourceWithoutDonationReminderUserCreateInput",
		connectOrCreate:"UserConnectOrCreateProcessedNotificationsRelationInput"
	},
	ProcessedNotificationSourceWithoutDonationReminderUserCreateInput:{
		id:"UUID",
		type:"ProcessedNotificationSourceType",
		processedNotification:"ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput",
		scheduledNotification:"ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"
	},
	ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput:{
		connect:"ScheduledNotificationUniqueWhere",
		create:"ScheduledNotificationWithoutProcessedNotificationsCreateInput",
		connectOrCreate:"ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"
	},
	ScheduledNotificationWithoutProcessedNotificationsCreateInput:{
		id:"UUID",
		scheduledDate:"Date",
		target:"ScheduledNotificationCreateTargetEntityRelationInput",
		locales:"ScheduledNotificationCreateLocalesEntityRelationInput",
		image:"ScheduledNotificationCreateImageEntityRelationInput",
		completedAt:"DateTime"
	},
	ScheduledNotificationCreateLocalesEntityRelationInput:{
		connect:"ScheduledNotificationLocaleUniqueWhere",
		create:"ScheduledNotificationLocaleWithoutRootCreateInput",
		connectOrCreate:"ScheduledNotificationConnectOrCreateLocalesRelationInput"
	},
	ScheduledNotificationLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ScheduledNotificationLocaleCreateLocaleEntityRelationInput"
	},
	ScheduledNotificationLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutScheduledNotificationsCreateInput",
		connectOrCreate:"ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutScheduledNotificationsCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutScheduledNotificationsCreateInput"
	},
	ScheduledNotificationConnectOrCreateLocalesRelationInput:{
		connect:"ScheduledNotificationLocaleUniqueWhere",
		create:"ScheduledNotificationLocaleWithoutRootCreateInput"
	},
	ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput:{
		connect:"ScheduledNotificationUniqueWhere",
		create:"ScheduledNotificationWithoutProcessedNotificationsCreateInput"
	},
	UserConnectOrCreateProcessedNotificationsRelationInput:{
		connect:"ProcessedNotificationSourceUniqueWhere",
		create:"ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"
	},
	UserCreateAreaStatsEntityRelationInput:{
		connect:"UserAreaStatsUniqueWhere"
	},
	UserCreateOrganizationStatsEntityRelationInput:{
		connect:"UserOrganizationStatsUniqueWhere"
	},
	UserCreatePostStatsEntityRelationInput:{
		connect:"UserPostStatsUniqueWhere"
	},
	UserCreateCurrencyStatsEntityRelationInput:{
		connect:"UserCurrencyStatsUniqueWhere"
	},
	OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutOnBehalfDonationsCreateInput"
	},
	OnBehalfDonationCreateMetaEntityRelationInput:{
		connect:"OnBehalfDonationMetadataUniqueWhere"
	},
	UserPaymentConnectOrCreateOnBehalfDonationRelationInput:{
		connect:"OnBehalfDonationUniqueWhere",
		create:"OnBehalfDonationWithoutPaymentsCreateInput"
	},
	UserPaymentCreateTriesCollectionEntityRelationInput:{
		connect:"UserPaymentTriesCollectionUniqueWhere",
		create:"UserPaymentTriesCollectionWithoutPaymentCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateTriesCollectionRelationInput"
	},
	UserPaymentTriesCollectionUniqueWhere:{
		id:"UUID",
		payment:"UserPaymentUniqueWhere",
		metadata:"UserPaymentTriesCollectionMetadataUniqueWhere",
		metadataLocales:"UserPaymentTriesCollectionMetadataLocaleUniqueWhere"
	},
	UserPaymentTriesCollectionMetadataUniqueWhere:{
		id:"UUID",
		triesCollection:"UserPaymentTriesCollectionUniqueWhere"
	},
	UserPaymentTriesCollectionMetadataLocaleUniqueWhere:{
		id:"UUID",
		parent:"UserPaymentTriesCollectionUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	UserPaymentTriesCollectionWithoutPaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		user:"UserPaymentTriesCollectionCreateUserEntityRelationInput",
		currency:"UserPaymentTriesCollectionCreateCurrencyEntityRelationInput",
		onBehalfDonation:"UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput",
		recurring:"UserPaymentTriesCollectionCreateRecurringEntityRelationInput",
		metadataLocales:"UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput",
		medium:"PaymentMedium"
	},
	UserPaymentTriesCollectionCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreateUserRelationInput"
	},
	UserCreateInput:{
		id:"UUID",
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserCreatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserCreateRegionEntityRelationInput",
		currency:"UserCreateCurrencyEntityRelationInput",
		recurringPayments:"UserCreateRecurringPaymentsEntityRelationInput",
		onBehalfDonations:"UserCreateOnBehalfDonationsEntityRelationInput",
		locale:"UserCreateLocaleEntityRelationInput",
		devices:"UserCreateDevicesEntityRelationInput",
		processedNotifications:"UserCreateProcessedNotificationsEntityRelationInput",
		areaStats:"UserCreateAreaStatsEntityRelationInput",
		organizationStats:"UserCreateOrganizationStatsEntityRelationInput",
		postStats:"UserCreatePostStatsEntityRelationInput",
		currencyStats:"UserCreateCurrencyStatsEntityRelationInput"
	},
	UserPaymentTriesCollectionConnectOrCreateUserRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserCreateInput"
	},
	UserPaymentTriesCollectionCreateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"
	},
	UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput"
	},
	UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput:{
		connect:"OnBehalfDonationUniqueWhere",
		create:"OnBehalfDonationCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"
	},
	OnBehalfDonationCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		payments:"OnBehalfDonationCreatePaymentsEntityRelationInput",
		onBehalfOf:"OnBehalfDonationCreateOnBehalfOfEntityRelationInput",
		meta:"OnBehalfDonationCreateMetaEntityRelationInput"
	},
	UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput:{
		connect:"OnBehalfDonationUniqueWhere",
		create:"OnBehalfDonationCreateInput"
	},
	UserPaymentTriesCollectionCreateRecurringEntityRelationInput:{
		connect:"UserRecurringPaymentUniqueWhere",
		create:"UserRecurringPaymentCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"
	},
	UserRecurringPaymentCreateInput:{
		id:"UUID",
		activeSince:"DateTime",
		cancelledAt:"DateTime",
		interval:"UserRecurringPaymentInterval",
		currency:"UserRecurringPaymentCreateCurrencyEntityRelationInput",
		items:"UserRecurringPaymentCreateItemsEntityRelationInput",
		user:"UserRecurringPaymentCreateUserEntityRelationInput",
		meta:"UserRecurringPaymentCreateMetaEntityRelationInput"
	},
	UserRecurringPaymentCreateMetaEntityRelationInput:{
		connect:"UpcomingUserRecurringPaymentMetadataUniqueWhere"
	},
	UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput:{
		connect:"UserRecurringPaymentUniqueWhere",
		create:"UserRecurringPaymentCreateInput"
	},
	UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput:{
		connect:"UserPaymentTriesCollectionMetadataLocaleUniqueWhere"
	},
	UserPaymentConnectOrCreateTriesCollectionRelationInput:{
		connect:"UserPaymentTriesCollectionUniqueWhere",
		create:"UserPaymentTriesCollectionWithoutPaymentCreateInput"
	},
	UserPaymentCreateMetadataEntityRelationInput:{
		connect:"UserPaymentMetadataUniqueWhere"
	},
	UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutRecurringPaymentItemCreateInput"
	},
	UserRecurringPaymentItemCreateMetaEntityRelationInput:{
		connect:"UserRecurringPaymentItemMetadataUniqueWhere"
	},
	UserRecurringPaymentConnectOrCreateItemsRelationInput:{
		connect:"UserRecurringPaymentItemUniqueWhere",
		create:"UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"
	},
	UserConnectOrCreateRecurringPaymentsRelationInput:{
		connect:"UserRecurringPaymentUniqueWhere",
		create:"UserRecurringPaymentWithoutUserCreateInput"
	},
	UserPaymentConnectOrCreateUserRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutPaymentsCreateInput"
	},
	OnBehalfDonationConnectOrCreatePaymentsRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutOnBehalfDonationCreateInput"
	},
	UserConnectOrCreateOnBehalfDonationsRelationInput:{
		connect:"OnBehalfDonationUniqueWhere",
		create:"OnBehalfDonationWithoutOnBehalfOfCreateInput"
	},
	UserRecurringPaymentConnectOrCreateUserRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutRecurringPaymentsCreateInput"
	},
	UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput:{
		connect:"UserRecurringPaymentUniqueWhere",
		create:"UserRecurringPaymentWithoutItemsCreateInput"
	},
	UserPaymentConnectOrCreateRecurringPaymentItemRelationInput:{
		connect:"UserRecurringPaymentItemUniqueWhere",
		create:"UserRecurringPaymentItemWithoutPaymentsCreateInput"
	},
	UserConnectOrCreatePaymentsRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutUserCreateInput"
	},
	ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutProcessedNotificationsCreateInput"
	},
	ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput:{
		connect:"ProcessedNotificationSourceUniqueWhere",
		create:"ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"
	},
	ScheduledNotificationLocaleConnectOrCreateRootRelationInput:{
		connect:"ScheduledNotificationUniqueWhere",
		create:"ScheduledNotificationWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateScheduledNotificationsRelationInput:{
		connect:"ScheduledNotificationLocaleUniqueWhere",
		create:"ScheduledNotificationLocaleWithoutLocaleCreateInput"
	},
	ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReceivedGiftsPagesCreateInput"
	},
	ReceivedGiftsPageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"
	},
	ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	ReceivedGiftsPageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"
	},
	ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	LinkableConnectOrCreateReceivedGiftsPageRelationInput:{
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		create:"ReceivedGiftsPageLocaleWithoutLinkCreateInput"
	},
	ReportPageLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutReportPageCreateInput"
	},
	ReportPageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateContentRelationInput"
	},
	ReportPageLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	ReportPageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateSeoRelationInput"
	},
	ReportPageLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	ReportPageLocaleCreatePostsEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutReportPageCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreatePostsRelationInput"
	},
	PostWithoutReportPageCreateInput:{
		id:"UUID",
		organization:"PostCreateOrganizationEntityRelationInput",
		area:"PostCreateAreaEntityRelationInput",
		activeRevision:"PostCreateActiveRevisionEntityRelationInput",
		revisions:"PostCreateRevisionsEntityRelationInput",
		locales:"PostCreateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostCreateMetaEntityRelationInput",
		heroCarousel:"PostCreateHeroCarouselEntityRelationInput",
		content:"PostCreateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostCreateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostCreateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostCreateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostCreateFundraisingProgressEntityRelationInput"
	},
	PostCreateMetaEntityRelationInput:{
		connect:"PostMetaDataUniqueWhere"
	},
	PostCreateHeroCarouselEntityRelationInput:{
		connect:"HeroCarouselUniqueWhere",
		create:"HeroCarouselWithoutPostsCreateInput",
		connectOrCreate:"PostConnectOrCreateHeroCarouselRelationInput"
	},
	HeroCarouselUniqueWhere:{
		id:"UUID",
		items:"HeroCarouselItemUniqueWhere"
	},
	HeroCarouselItemUniqueWhere:{
		id:"UUID"
	},
	HeroCarouselWithoutPostsCreateInput:{
		id:"UUID",
		createdAt:"Date",
		items:"HeroCarouselCreateItemsEntityRelationInput"
	},
	HeroCarouselCreateItemsEntityRelationInput:{
		connect:"HeroCarouselItemUniqueWhere",
		create:"HeroCarouselItemWithoutListCreateInput",
		connectOrCreate:"HeroCarouselConnectOrCreateItemsRelationInput"
	},
	HeroCarouselItemWithoutListCreateInput:{
		id:"UUID",
		createdAt:"Date",
		item:"HeroCarouselItemCreateItemEntityRelationInput"
	},
	HeroCarouselItemCreateItemEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput",
		connectOrCreate:"HeroCarouselItemConnectOrCreateItemRelationInput"
	},
	HeroCarouselItemConnectOrCreateItemRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput"
	},
	HeroCarouselConnectOrCreateItemsRelationInput:{
		connect:"HeroCarouselItemUniqueWhere",
		create:"HeroCarouselItemWithoutListCreateInput"
	},
	PostConnectOrCreateHeroCarouselRelationInput:{
		connect:"HeroCarouselUniqueWhere",
		create:"HeroCarouselWithoutPostsCreateInput"
	},
	PostCreateContentEntityRelationInput:{
		connect:"ContentReferenceUniqueWhere",
		create:"ContentReferenceWithoutPostsCreateInput",
		connectOrCreate:"PostConnectOrCreateContentRelationInput"
	},
	ContentReferenceWithoutPostsCreateInput:{
		id:"UUID",
		type:"ContentReferenceType",
		block:"ContentReferenceCreateBlockEntityRelationInput",
		image:"ContentReferenceCreateImageEntityRelationInput",
		linkables:"ContentReferenceCreateLinkablesEntityRelationInput",
		video:"ContentReferenceCreateVideoEntityRelationInput",
		link:"ContentReferenceCreateLinkEntityRelationInput",
		contentAlignment:"ContentAlignment",
		valueList:"ContentReferenceCreateValueListEntityRelationInput",
		imageLinkList:"ContentReferenceCreateImageLinkListEntityRelationInput",
		areaList:"ContentReferenceCreateAreaListEntityRelationInput",
		accordion:"ContentReferenceCreateAccordionEntityRelationInput",
		media:"ContentReferenceCreateMediaEntityRelationInput",
		memberList:"ContentReferenceCreateMemberListEntityRelationInput",
		asideMediaContentLayout:"AsideMediaContentLayout",
		form:"ContentReferenceCreateFormEntityRelationInput",
		contentWithoutBlocks:"ContentReferenceCreateContentWithoutBlocksEntityRelationInput",
		heroCarousel:"ContentReferenceCreateHeroCarouselEntityRelationInput",
		organizationList:"ContentReferenceCreateOrganizationListEntityRelationInput",
		textImageList:"ContentReferenceCreateTextImageListEntityRelationInput"
	},
	ContentReferenceCreateBlockEntityRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutReferencesCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateBlockRelationInput"
	},
	ContentBlockWithoutReferencesCreateInput:{
		id:"UUID",
		content:"ContentBlockCreateContentEntityRelationInput"
	},
	ContentBlockCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentWithoutBlocksCreateInput",
		connectOrCreate:"ContentBlockConnectOrCreateContentRelationInput"
	},
	ContentWithoutBlocksCreateInput:{
		id:"UUID"
	},
	ContentBlockConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentWithoutBlocksCreateInput"
	},
	ContentReferenceConnectOrCreateBlockRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutReferencesCreateInput"
	},
	ContentReferenceCreateValueListEntityRelationInput:{
		connect:"ValueListUniqueWhere",
		create:"ValueListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateValueListRelationInput"
	},
	ValueListCreateInput:{
		id:"UUID",
		items:"ValueListCreateItemsEntityRelationInput"
	},
	ValueListCreateItemsEntityRelationInput:{
		connect:"ValueItemUniqueWhere",
		create:"ValueItemWithoutListCreateInput",
		connectOrCreate:"ValueListConnectOrCreateItemsRelationInput"
	},
	ValueItemWithoutListCreateInput:{
		id:"UUID",
		item:"ValueItemCreateItemEntityRelationInput"
	},
	ValueItemCreateItemEntityRelationInput:{
		connect:"ValueUniqueWhere",
		create:"ValueCreateInput",
		connectOrCreate:"ValueItemConnectOrCreateItemRelationInput"
	},
	ValueUniqueWhere:{
		id:"UUID",
		textContent:"ContentUniqueWhere"
	},
	ValueCreateInput:{
		id:"UUID",
		textContent:"ValueCreateTextContentEntityRelationInput"
	},
	ValueCreateTextContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"ValueConnectOrCreateTextContentRelationInput"
	},
	ValueConnectOrCreateTextContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	ValueItemConnectOrCreateItemRelationInput:{
		connect:"ValueUniqueWhere",
		create:"ValueCreateInput"
	},
	ValueListConnectOrCreateItemsRelationInput:{
		connect:"ValueItemUniqueWhere",
		create:"ValueItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateValueListRelationInput:{
		connect:"ValueListUniqueWhere",
		create:"ValueListCreateInput"
	},
	ContentReferenceCreateImageLinkListEntityRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateImageLinkListRelationInput"
	},
	ContentReferenceConnectOrCreateImageLinkListRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListCreateInput"
	},
	ContentReferenceCreateAreaListEntityRelationInput:{
		connect:"PostAreaListUniqueWhere",
		create:"PostAreaListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateAreaListRelationInput"
	},
	PostAreaListCreateInput:{
		id:"UUID",
		items:"PostAreaListCreateItemsEntityRelationInput"
	},
	PostAreaListCreateItemsEntityRelationInput:{
		connect:"PostAreaListItemUniqueWhere",
		create:"PostAreaListItemWithoutListCreateInput",
		connectOrCreate:"PostAreaListConnectOrCreateItemsRelationInput"
	},
	PostAreaListItemWithoutListCreateInput:{
		id:"UUID",
		item:"PostAreaListItemCreateItemEntityRelationInput"
	},
	PostAreaListItemCreateItemEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput",
		connectOrCreate:"PostAreaListItemConnectOrCreateItemRelationInput"
	},
	PostAreaListItemConnectOrCreateItemRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput"
	},
	PostAreaListConnectOrCreateItemsRelationInput:{
		connect:"PostAreaListItemUniqueWhere",
		create:"PostAreaListItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateAreaListRelationInput:{
		connect:"PostAreaListUniqueWhere",
		create:"PostAreaListCreateInput"
	},
	ContentReferenceCreateAccordionEntityRelationInput:{
		connect:"AccordionUniqueWhere",
		create:"AccordionCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateAccordionRelationInput"
	},
	AccordionCreateInput:{
		id:"UUID",
		items:"AccordionCreateItemsEntityRelationInput"
	},
	AccordionCreateItemsEntityRelationInput:{
		connect:"AccordionItemUniqueWhere",
		create:"AccordionItemWithoutListCreateInput",
		connectOrCreate:"AccordionConnectOrCreateItemsRelationInput"
	},
	AccordionItemWithoutListCreateInput:{
		id:"UUID",
		descriptionContent:"AccordionItemCreateDescriptionContentEntityRelationInput"
	},
	AccordionItemCreateDescriptionContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"AccordionItemConnectOrCreateDescriptionContentRelationInput"
	},
	AccordionItemConnectOrCreateDescriptionContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	AccordionConnectOrCreateItemsRelationInput:{
		connect:"AccordionItemUniqueWhere",
		create:"AccordionItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateAccordionRelationInput:{
		connect:"AccordionUniqueWhere",
		create:"AccordionCreateInput"
	},
	ContentReferenceCreateMediaEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateMediaRelationInput"
	},
	MediumListCreateInput:{
		id:"UUID",
		items:"MediumListCreateItemsEntityRelationInput"
	},
	MediumListCreateItemsEntityRelationInput:{
		connect:"MediumItemUniqueWhere",
		create:"MediumItemWithoutListCreateInput",
		connectOrCreate:"MediumListConnectOrCreateItemsRelationInput"
	},
	MediumItemWithoutListCreateInput:{
		id:"UUID",
		medium:"MediumItemCreateMediumEntityRelationInput"
	},
	MediumItemCreateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput",
		connectOrCreate:"MediumItemConnectOrCreateMediumRelationInput"
	},
	MediumUniqueWhere:{
		id:"UUID"
	},
	MediumCreateInput:{
		id:"UUID",
		type:"MediumType",
		image:"MediumCreateImageEntityRelationInput",
		video:"MediumCreateVideoEntityRelationInput"
	},
	MediumCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"MediumConnectOrCreateImageRelationInput"
	},
	MediumConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	MediumCreateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"MediumConnectOrCreateVideoRelationInput"
	},
	MediumConnectOrCreateVideoRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput"
	},
	MediumItemConnectOrCreateMediumRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput"
	},
	MediumListConnectOrCreateItemsRelationInput:{
		connect:"MediumItemUniqueWhere",
		create:"MediumItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateMediaRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput"
	},
	ContentReferenceCreateMemberListEntityRelationInput:{
		connect:"MemberListUniqueWhere",
		create:"MemberListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateMemberListRelationInput"
	},
	MemberListCreateInput:{
		id:"UUID",
		items:"MemberListCreateItemsEntityRelationInput"
	},
	MemberListCreateItemsEntityRelationInput:{
		connect:"MemberListItemUniqueWhere",
		create:"MemberListItemWithoutListCreateInput",
		connectOrCreate:"MemberListConnectOrCreateItemsRelationInput"
	},
	MemberListItemWithoutListCreateInput:{
		id:"UUID",
		image:"MemberListItemCreateImageEntityRelationInput",
		descriptionContent:"MemberListItemCreateDescriptionContentEntityRelationInput"
	},
	MemberListItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"MemberListItemConnectOrCreateImageRelationInput"
	},
	MemberListItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	MemberListItemCreateDescriptionContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"MemberListItemConnectOrCreateDescriptionContentRelationInput"
	},
	MemberListItemConnectOrCreateDescriptionContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	MemberListConnectOrCreateItemsRelationInput:{
		connect:"MemberListItemUniqueWhere",
		create:"MemberListItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateMemberListRelationInput:{
		connect:"MemberListUniqueWhere",
		create:"MemberListCreateInput"
	},
	ContentReferenceCreateFormEntityRelationInput:{
		connect:"FormUniqueWhere",
		create:"FormCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateFormRelationInput"
	},
	FormUniqueWhere:{
		id:"UUID",
		tax:"FilledTaxFormUniqueWhere"
	},
	FilledTaxFormUniqueWhere:{
		id:"UUID"
	},
	FormCreateInput:{
		id:"UUID",
		type:"FormType",
		tax:"FormCreateTaxEntityRelationInput"
	},
	FormCreateTaxEntityRelationInput:{
		connect:"FilledTaxFormUniqueWhere",
		create:"FilledTaxFormCreateInput",
		connectOrCreate:"FormConnectOrCreateTaxRelationInput"
	},
	FilledTaxFormCreateInput:{
		id:"UUID",
		publishedAt:"DateTime",
		country:"FilledTaxFormCreateCountryEntityRelationInput",
		dateFrom:"Date",
		dateTo:"Date"
	},
	FilledTaxFormCreateCountryEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"FilledTaxFormConnectOrCreateCountryRelationInput"
	},
	FilledTaxFormConnectOrCreateCountryRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput"
	},
	FormConnectOrCreateTaxRelationInput:{
		connect:"FilledTaxFormUniqueWhere",
		create:"FilledTaxFormCreateInput"
	},
	ContentReferenceConnectOrCreateFormRelationInput:{
		connect:"FormUniqueWhere",
		create:"FormCreateInput"
	},
	ContentReferenceCreateContentWithoutBlocksEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"
	},
	ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	ContentReferenceCreateHeroCarouselEntityRelationInput:{
		connect:"HeroCarouselUniqueWhere",
		create:"HeroCarouselCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateHeroCarouselRelationInput"
	},
	HeroCarouselCreateInput:{
		id:"UUID",
		createdAt:"Date",
		posts:"HeroCarouselCreatePostsEntityRelationInput",
		items:"HeroCarouselCreateItemsEntityRelationInput"
	},
	HeroCarouselCreatePostsEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutHeroCarouselCreateInput",
		connectOrCreate:"HeroCarouselConnectOrCreatePostsRelationInput"
	},
	PostWithoutHeroCarouselCreateInput:{
		id:"UUID",
		organization:"PostCreateOrganizationEntityRelationInput",
		area:"PostCreateAreaEntityRelationInput",
		activeRevision:"PostCreateActiveRevisionEntityRelationInput",
		revisions:"PostCreateRevisionsEntityRelationInput",
		locales:"PostCreateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostCreateMetaEntityRelationInput",
		reportPage:"PostCreateReportPageEntityRelationInput",
		content:"PostCreateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostCreateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostCreateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostCreateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostCreateFundraisingProgressEntityRelationInput"
	},
	PostCreateReportPageEntityRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutPostsCreateInput",
		connectOrCreate:"PostConnectOrCreateReportPageRelationInput"
	},
	ReportPageLocaleWithoutPostsCreateInput:{
		id:"UUID",
		link:"ReportPageLocaleCreateLinkEntityRelationInput",
		root:"ReportPageLocaleCreateRootEntityRelationInput",
		locale:"ReportPageLocaleCreateLocaleEntityRelationInput",
		content:"ReportPageLocaleCreateContentEntityRelationInput",
		seo:"ReportPageLocaleCreateSeoEntityRelationInput"
	},
	PostConnectOrCreateReportPageRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutPostsCreateInput"
	},
	PostCreateFundraiseCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"PostConnectOrCreateFundraiseCurrencyRelationInput"
	},
	PostConnectOrCreateFundraiseCurrencyRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput"
	},
	PostCreateFundraiseCurrencySumsEntityRelationInput:{
		connect:"PostCurrencySumUniqueWhere"
	},
	PostCreateFundraiseSumEntityRelationInput:{
		connect:"PostSumUniqueWhere"
	},
	PostCreateFundraisingProgressEntityRelationInput:{
		connect:"PostFundraisingProgressUniqueWhere"
	},
	HeroCarouselConnectOrCreatePostsRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutHeroCarouselCreateInput"
	},
	ContentReferenceConnectOrCreateHeroCarouselRelationInput:{
		connect:"HeroCarouselUniqueWhere",
		create:"HeroCarouselCreateInput"
	},
	ContentReferenceCreateOrganizationListEntityRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateOrganizationListRelationInput"
	},
	ContentReferenceConnectOrCreateOrganizationListRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput"
	},
	ContentReferenceCreateTextImageListEntityRelationInput:{
		connect:"TextImageListUniqueWhere",
		create:"TextImageListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateTextImageListRelationInput"
	},
	TextImageListCreateInput:{
		id:"UUID",
		items:"TextImageListCreateItemsEntityRelationInput"
	},
	TextImageListCreateItemsEntityRelationInput:{
		connect:"TextImageListItemUniqueWhere",
		create:"TextImageListItemWithoutListCreateInput",
		connectOrCreate:"TextImageListConnectOrCreateItemsRelationInput"
	},
	TextImageListItemWithoutListCreateInput:{
		id:"UUID",
		image:"TextImageListItemCreateImageEntityRelationInput",
		link:"TextImageListItemCreateLinkEntityRelationInput"
	},
	TextImageListItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"TextImageListItemConnectOrCreateImageRelationInput"
	},
	TextImageListItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	TextImageListItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"TextImageListItemConnectOrCreateLinkRelationInput"
	},
	TextImageListItemConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	TextImageListConnectOrCreateItemsRelationInput:{
		connect:"TextImageListItemUniqueWhere",
		create:"TextImageListItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateTextImageListRelationInput:{
		connect:"TextImageListUniqueWhere",
		create:"TextImageListCreateInput"
	},
	PostConnectOrCreateContentRelationInput:{
		connect:"ContentReferenceUniqueWhere",
		create:"ContentReferenceWithoutPostsCreateInput"
	},
	ReportPageLocaleConnectOrCreatePostsRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutReportPageCreateInput"
	},
	LocaleConnectOrCreateReportPagesRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutLocaleCreateInput"
	},
	GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGivenGiftsPagesCreateInput"
	},
	LinkableConnectOrCreateGivenGiftsPageRelationInput:{
		connect:"GivenGiftsPageLocaleUniqueWhere",
		create:"GivenGiftsPageLocaleWithoutLinkCreateInput"
	},
	ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutReceivedGiftsPageCreateInput"
	},
	LocaleConnectOrCreateReceivedGiftsPagesRelationInput:{
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		create:"ReceivedGiftsPageLocaleWithoutLocaleCreateInput"
	},
	ReportPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReportPagesCreateInput"
	},
	LinkableConnectOrCreateReportPageRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutLinkCreateInput"
	},
	GivenGiftsPageLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGivenGiftsPageCreateInput"
	},
	LocaleConnectOrCreateGivenGiftsPagesRelationInput:{
		connect:"GivenGiftsPageLocaleUniqueWhere",
		create:"GivenGiftsPageLocaleWithoutLocaleCreateInput"
	},
	PostOrganizationLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostOrganizationsCreateInput"
	},
	PostOrganizationLocaleCreateDomainEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateDomainRelationInput"
	},
	PostOrganizationLocaleConnectOrCreateDomainRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	PostOrganizationLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateSeoRelationInput"
	},
	PostOrganizationLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	PostOrganizationLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateContentRelationInput"
	},
	PostOrganizationLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	LinkableConnectOrCreatePostOrganizationRelationInput:{
		connect:"PostOrganizationLocaleUniqueWhere",
		create:"PostOrganizationLocaleWithoutLinkCreateInput"
	},
	PostLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostCreateInput"
	},
	PostConnectOrCreateLocalesRelationInput:{
		connect:"PostLocaleUniqueWhere",
		create:"PostLocaleWithoutRootCreateInput"
	},
	TileItemConnectOrCreatePostRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput"
	},
	TileItemCreateAreaEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput",
		connectOrCreate:"TileItemConnectOrCreateAreaRelationInput"
	},
	TileItemConnectOrCreateAreaRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput"
	},
	TileItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"TileItemConnectOrCreateImageRelationInput"
	},
	TileItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	TileItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"TileItemConnectOrCreateLinkRelationInput"
	},
	TileItemConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	TileItemCreateOrganizationEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationCreateInput",
		connectOrCreate:"TileItemConnectOrCreateOrganizationRelationInput"
	},
	TileItemConnectOrCreateOrganizationRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationCreateInput"
	},
	TileListConnectOrCreateItemsRelationInput:{
		connect:"TileItemUniqueWhere",
		create:"TileItemWithoutListCreateInput"
	},
	TileListCreateAreaTypeEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput",
		connectOrCreate:"TileListConnectOrCreateAreaTypeRelationInput"
	},
	TileListConnectOrCreateAreaTypeRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput"
	},
	FeedPageLocaleConnectOrCreateHeroTilesRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListCreateInput"
	},
	FeedPageLocaleCreateSectionListEntityRelationInput:{
		connect:"FeedPageSectionUniqueWhere",
		create:"FeedPageSectionWithoutFeedPageLocaleCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateSectionListRelationInput"
	},
	FeedPageSectionWithoutFeedPageLocaleCreateInput:{
		id:"UUID",
		tileStripeList:"FeedPageSectionCreateTileStripeListEntityRelationInput"
	},
	FeedPageSectionCreateTileStripeListEntityRelationInput:{
		connect:"FeedPageTileStripeUniqueWhere",
		create:"FeedPageTileStripeWithoutSectionCreateInput",
		connectOrCreate:"FeedPageSectionConnectOrCreateTileStripeListRelationInput"
	},
	FeedPageTileStripeWithoutSectionCreateInput:{
		id:"UUID",
		tileList:"FeedPageTileStripeCreateTileListEntityRelationInput"
	},
	FeedPageTileStripeCreateTileListEntityRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListCreateInput",
		connectOrCreate:"FeedPageTileStripeConnectOrCreateTileListRelationInput"
	},
	FeedPageTileStripeConnectOrCreateTileListRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListCreateInput"
	},
	FeedPageSectionConnectOrCreateTileStripeListRelationInput:{
		connect:"FeedPageTileStripeUniqueWhere",
		create:"FeedPageTileStripeWithoutSectionCreateInput"
	},
	FeedPageLocaleConnectOrCreateSectionListRelationInput:{
		connect:"FeedPageSectionUniqueWhere",
		create:"FeedPageSectionWithoutFeedPageLocaleCreateInput"
	},
	FeedPageLocaleCreateCardListEntityRelationInput:{
		connect:"CardListUniqueWhere",
		create:"CardListCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateCardListRelationInput"
	},
	CardListCreateInput:{
		id:"UUID",
		items:"CardListCreateItemsEntityRelationInput"
	},
	CardListCreateItemsEntityRelationInput:{
		connect:"CardItemUniqueWhere",
		create:"CardItemWithoutListCreateInput",
		connectOrCreate:"CardListConnectOrCreateItemsRelationInput"
	},
	CardItemWithoutListCreateInput:{
		id:"UUID",
		link:"CardItemCreateLinkEntityRelationInput"
	},
	CardItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"CardItemConnectOrCreateLinkRelationInput"
	},
	CardItemConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	CardListConnectOrCreateItemsRelationInput:{
		connect:"CardItemUniqueWhere",
		create:"CardItemWithoutListCreateInput"
	},
	FeedPageLocaleConnectOrCreateCardListRelationInput:{
		connect:"CardListUniqueWhere",
		create:"CardListCreateInput"
	},
	FeedPageLocaleCreateStoryGuideListEntityRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"
	},
	FeedPageLocaleConnectOrCreateStoryGuideListRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListCreateInput"
	},
	LocaleConnectOrCreateFeedPagesRelationInput:{
		connect:"FeedPageLocaleUniqueWhere",
		create:"FeedPageLocaleWithoutLocaleCreateInput"
	},
	PostRevisionLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostRevisionsCreateInput"
	},
	PostRevisionLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateContentRelationInput"
	},
	PostRevisionLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	PostRevisionLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateSeoRelationInput"
	},
	PostRevisionLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	PostRevisionLocaleCreateLeadContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateLeadContentRelationInput"
	},
	PostRevisionLocaleConnectOrCreateLeadContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	PostRevisionConnectOrCreateLocalesRelationInput:{
		connect:"PostRevisionLocaleUniqueWhere",
		create:"PostRevisionLocaleWithoutRootCreateInput"
	},
	PostConnectOrCreateActiveRevisionRelationInput:{
		connect:"PostRevisionUniqueWhere",
		create:"PostRevisionCreateInput"
	},
	PostRevisionConnectOrCreatePostRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutRevisionsCreateInput"
	},
	PostRevisionLocaleConnectOrCreateRootRelationInput:{
		connect:"PostRevisionUniqueWhere",
		create:"PostRevisionWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreatePostRevisionsRelationInput:{
		connect:"PostRevisionLocaleUniqueWhere",
		create:"PostRevisionLocaleWithoutLocaleCreateInput"
	},
	SentPaymentLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutSentPaymentsCreateInput"
	},
	SentPaymentConnectOrCreateLocalesRelationInput:{
		connect:"SentPaymentLocaleUniqueWhere",
		create:"SentPaymentLocaleWithoutRootCreateInput"
	},
	PostAreaConnectOrCreateSentPaymentsRelationInput:{
		connect:"SentPaymentUniqueWhere",
		create:"SentPaymentWithoutAreaCreateInput"
	},
	PostOrganizationConnectOrCreateAreaRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput"
	},
	PostOrganizationCreateSentPaymentsEntityRelationInput:{
		connect:"SentPaymentUniqueWhere",
		create:"SentPaymentWithoutOrganizationCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateSentPaymentsRelationInput"
	},
	SentPaymentWithoutOrganizationCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		sendAt:"DateTime",
		currency:"SentPaymentCreateCurrencyEntityRelationInput",
		area:"SentPaymentCreateAreaEntityRelationInput",
		locales:"SentPaymentCreateLocalesEntityRelationInput"
	},
	PostOrganizationConnectOrCreateSentPaymentsRelationInput:{
		connect:"SentPaymentUniqueWhere",
		create:"SentPaymentWithoutOrganizationCreateInput"
	},
	PostOrganizationLocaleConnectOrCreateRootRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreatePostOrganizationsRelationInput:{
		connect:"PostOrganizationLocaleUniqueWhere",
		create:"PostOrganizationLocaleWithoutLocaleCreateInput"
	},
	PostAreaLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostAreasCreateInput"
	},
	PostAreaLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateSeoRelationInput"
	},
	PostAreaLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	PostAreaLocaleCreateBannerEntityRelationInput:{
		connect:"AppBannerUniqueWhere",
		create:"AppBannerCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateBannerRelationInput"
	},
	AppBannerCreateInput:{
		id:"UUID",
		imageSmall:"AppBannerCreateImageSmallEntityRelationInput",
		imageBig:"AppBannerCreateImageBigEntityRelationInput",
		textContent:"AppBannerCreateTextContentEntityRelationInput"
	},
	AppBannerCreateImageSmallEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"AppBannerConnectOrCreateImageSmallRelationInput"
	},
	AppBannerConnectOrCreateImageSmallRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	AppBannerCreateImageBigEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"AppBannerConnectOrCreateImageBigRelationInput"
	},
	AppBannerConnectOrCreateImageBigRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	AppBannerCreateTextContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"AppBannerConnectOrCreateTextContentRelationInput"
	},
	AppBannerConnectOrCreateTextContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	PostAreaLocaleConnectOrCreateBannerRelationInput:{
		connect:"AppBannerUniqueWhere",
		create:"AppBannerCreateInput"
	},
	PostAreaLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateContentRelationInput"
	},
	PostAreaLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	LinkableConnectOrCreatePostAreaRelationInput:{
		connect:"PostAreaLocaleUniqueWhere",
		create:"PostAreaLocaleWithoutLinkCreateInput"
	},
	PostOrganizationLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostOrganizationCreateInput"
	},
	PostOrganizationConnectOrCreateLocalesRelationInput:{
		connect:"PostOrganizationLocaleUniqueWhere",
		create:"PostOrganizationLocaleWithoutRootCreateInput"
	},
	PostConnectOrCreateOrganizationRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutPostsCreateInput"
	},
	PostAreaConnectOrCreatePostsRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutAreaCreateInput"
	},
	PostAreaLocaleConnectOrCreateRootRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreatePostAreasRelationInput:{
		connect:"PostAreaLocaleUniqueWhere",
		create:"PostAreaLocaleWithoutLocaleCreateInput"
	},
	PostLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostsCreateInput"
	},
	PostLocaleCreateRootEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutLocalesCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateRootRelationInput"
	},
	PostWithoutLocalesCreateInput:{
		id:"UUID",
		organization:"PostCreateOrganizationEntityRelationInput",
		area:"PostCreateAreaEntityRelationInput",
		activeRevision:"PostCreateActiveRevisionEntityRelationInput",
		revisions:"PostCreateRevisionsEntityRelationInput",
		state:"PostState",
		meta:"PostCreateMetaEntityRelationInput",
		heroCarousel:"PostCreateHeroCarouselEntityRelationInput",
		reportPage:"PostCreateReportPageEntityRelationInput",
		content:"PostCreateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostCreateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostCreateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostCreateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostCreateFundraisingProgressEntityRelationInput"
	},
	PostLocaleConnectOrCreateRootRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutLocalesCreateInput"
	},
	LinkableConnectOrCreatePostRelationInput:{
		connect:"PostLocaleUniqueWhere",
		create:"PostLocaleWithoutLinkCreateInput"
	},
	LinkConnectOrCreateInternalLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableCreateInput"
	},
	ContentReferenceConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	ContentReferenceCreatePostsEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutContentCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreatePostsRelationInput"
	},
	PostWithoutContentCreateInput:{
		id:"UUID",
		organization:"PostCreateOrganizationEntityRelationInput",
		area:"PostCreateAreaEntityRelationInput",
		activeRevision:"PostCreateActiveRevisionEntityRelationInput",
		revisions:"PostCreateRevisionsEntityRelationInput",
		locales:"PostCreateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostCreateMetaEntityRelationInput",
		heroCarousel:"PostCreateHeroCarouselEntityRelationInput",
		reportPage:"PostCreateReportPageEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostCreateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostCreateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostCreateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostCreateFundraisingProgressEntityRelationInput"
	},
	ContentReferenceConnectOrCreatePostsRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutContentCreateInput"
	},
	ContentBlockConnectOrCreateReferencesRelationInput:{
		connect:"ContentReferenceUniqueWhere",
		create:"ContentReferenceWithoutBlockCreateInput"
	},
	ContentConnectOrCreateBlocksRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutContentCreateInput"
	},
	PostLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	LocaleConnectOrCreatePostsRelationInput:{
		connect:"PostLocaleUniqueWhere",
		create:"PostLocaleWithoutLocaleCreateInput"
	},
	GenericPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPagesCreateInput"
	},
	LinkableConnectOrCreateGenericPageRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLinkCreateInput"
	},
	PostAreaLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostAreaCreateInput"
	},
	PostAreaConnectOrCreateLocalesRelationInput:{
		connect:"PostAreaLocaleUniqueWhere",
		create:"PostAreaLocaleWithoutRootCreateInput"
	},
	PostConnectOrCreateAreaRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutPostsCreateInput"
	},
	PostOrganizationConnectOrCreatePostsRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutOrganizationCreateInput"
	},
	PostOrganizationListItemConnectOrCreateItemRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationCreateInput"
	},
	PostOrganizationListItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"PostOrganizationListItemConnectOrCreateLinkRelationInput"
	},
	PostOrganizationListItemConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	PostOrganizationListItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationListItemConnectOrCreateImageRelationInput"
	},
	PostOrganizationListItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PostOrganizationListConnectOrCreateItemsRelationInput:{
		connect:"PostOrganizationListItemUniqueWhere",
		create:"PostOrganizationListItemWithoutListCreateInput"
	},
	GeneralConnectOrCreateOrganizationListRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput"
	},
	GeneralLocaleConnectOrCreateRootRelationInput:{
		connect:"GeneralUniqueWhere",
		create:"GeneralWithoutLocalesCreateInput"
	},
	GeneralLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateSeoRelationInput"
	},
	GeneralLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	GeneralLocaleCreateAppStoreLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"
	},
	GeneralLocaleConnectOrCreateAppStoreLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	GeneralLocaleCreateGooglePlayLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"
	},
	GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	LocaleConnectOrCreateGeneralsRelationInput:{
		connect:"GeneralLocaleUniqueWhere",
		create:"GeneralLocaleWithoutLocaleCreateInput"
	},
	ReportNavigationLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReportNavigationsCreateInput"
	},
	GenericPageConnectOrCreateReportNavigationRelationInput:{
		connect:"ReportNavigationLocaleUniqueWhere",
		create:"ReportNavigationLocaleWithoutPagesCreateInput"
	},
	GenericPageLocaleConnectOrCreateRootRelationInput:{
		connect:"GenericPageUniqueWhere",
		create:"GenericPageWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateGenericPagesRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLocaleCreateInput"
	},
	GeneralLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGeneralsCreateInput"
	},
	GeneralConnectOrCreateLocalesRelationInput:{
		connect:"GeneralLocaleUniqueWhere",
		create:"GeneralLocaleWithoutRootCreateInput"
	},
	GeneralUpdateInput:{
		unique:"One",
		locales:"GeneralUpdateLocalesEntityRelationInput",
		allAreasIcon:"GeneralUpdateAllAreasIconEntityRelationInput",
		allOrganizationsIcon:"GeneralUpdateAllOrganizationsIconEntityRelationInput",
		organizationList:"GeneralUpdateOrganizationListEntityRelationInput"
	},
	GeneralUpdateLocalesEntityRelationInput:{
		create:"GeneralLocaleWithoutRootCreateInput",
		update:"GeneralUpdateLocalesRelationInput",
		upsert:"GeneralUpsertLocalesRelationInput",
		connect:"GeneralLocaleUniqueWhere",
		disconnect:"GeneralLocaleUniqueWhere",
		delete:"GeneralLocaleUniqueWhere"
	},
	GeneralUpdateLocalesRelationInput:{
		by:"GeneralLocaleUniqueWhere",
		data:"GeneralLocaleWithoutRootUpdateInput"
	},
	GeneralLocaleWithoutRootUpdateInput:{
		locale:"GeneralLocaleUpdateLocaleEntityRelationInput",
		seo:"GeneralLocaleUpdateSeoEntityRelationInput",
		appStoreLink:"GeneralLocaleUpdateAppStoreLinkEntityRelationInput",
		googlePlayLink:"GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"
	},
	GeneralLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGeneralsCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutGeneralsUpdateInput",
		upsert:"GeneralLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutGeneralsUpdateInput:{
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdateGenericPagesEntityRelationInput:{
		create:"GenericPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateGenericPagesRelationInput",
		upsert:"LocaleUpsertGenericPagesRelationInput",
		connect:"GenericPageLocaleUniqueWhere",
		disconnect:"GenericPageLocaleUniqueWhere",
		delete:"GenericPageLocaleUniqueWhere"
	},
	LocaleUpdateGenericPagesRelationInput:{
		by:"GenericPageLocaleUniqueWhere",
		data:"GenericPageLocaleWithoutLocaleUpdateInput"
	},
	GenericPageLocaleWithoutLocaleUpdateInput:{
		root:"GenericPageLocaleUpdateRootEntityRelationInput",
		content:"GenericPageLocaleUpdateContentEntityRelationInput",
		seo:"GenericPageLocaleUpdateSeoEntityRelationInput",
		link:"GenericPageLocaleUpdateLinkEntityRelationInput"
	},
	GenericPageLocaleUpdateRootEntityRelationInput:{
		connect:"GenericPageUniqueWhere",
		create:"GenericPageWithoutLocalesCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateRootRelationInput",
		update:"GenericPageWithoutLocalesUpdateInput",
		upsert:"GenericPageLocaleUpsertRootRelationInput"
	},
	GenericPageWithoutLocalesUpdateInput:{
		type:"GenericPageType",
		reportNavigation:"GenericPageUpdateReportNavigationEntityRelationInput"
	},
	GenericPageUpdateReportNavigationEntityRelationInput:{
		create:"ReportNavigationLocaleWithoutPagesCreateInput",
		update:"GenericPageUpdateReportNavigationRelationInput",
		upsert:"GenericPageUpsertReportNavigationRelationInput",
		connect:"ReportNavigationLocaleUniqueWhere",
		disconnect:"ReportNavigationLocaleUniqueWhere",
		delete:"ReportNavigationLocaleUniqueWhere"
	},
	GenericPageUpdateReportNavigationRelationInput:{
		by:"ReportNavigationLocaleUniqueWhere",
		data:"ReportNavigationLocaleWithoutPagesUpdateInput"
	},
	ReportNavigationLocaleWithoutPagesUpdateInput:{
		root:"ReportNavigationLocaleUpdateRootEntityRelationInput",
		locale:"ReportNavigationLocaleUpdateLocaleEntityRelationInput"
	},
	ReportNavigationLocaleUpdateRootEntityRelationInput:{
		connect:"ReportNavigationUniqueWhere",
		create:"ReportNavigationWithoutLocalesCreateInput",
		connectOrCreate:"ReportNavigationLocaleConnectOrCreateRootRelationInput",
		update:"ReportNavigationWithoutLocalesUpdateInput",
		upsert:"ReportNavigationLocaleUpsertRootRelationInput"
	},
	ReportNavigationWithoutLocalesUpdateInput:{
		unique:"One"
	},
	ReportNavigationLocaleUpsertRootRelationInput:{
		update:"ReportNavigationWithoutLocalesUpdateInput",
		create:"ReportNavigationWithoutLocalesCreateInput"
	},
	ReportNavigationLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReportNavigationsCreateInput",
		connectOrCreate:"ReportNavigationLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutReportNavigationsUpdateInput",
		upsert:"ReportNavigationLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutReportNavigationsUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdateGeneralsEntityRelationInput:{
		create:"GeneralLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateGeneralsRelationInput",
		upsert:"LocaleUpsertGeneralsRelationInput",
		connect:"GeneralLocaleUniqueWhere",
		disconnect:"GeneralLocaleUniqueWhere",
		delete:"GeneralLocaleUniqueWhere"
	},
	LocaleUpdateGeneralsRelationInput:{
		by:"GeneralLocaleUniqueWhere",
		data:"GeneralLocaleWithoutLocaleUpdateInput"
	},
	GeneralLocaleWithoutLocaleUpdateInput:{
		root:"GeneralLocaleUpdateRootEntityRelationInput",
		seo:"GeneralLocaleUpdateSeoEntityRelationInput",
		appStoreLink:"GeneralLocaleUpdateAppStoreLinkEntityRelationInput",
		googlePlayLink:"GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"
	},
	GeneralLocaleUpdateRootEntityRelationInput:{
		connect:"GeneralUniqueWhere",
		create:"GeneralWithoutLocalesCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateRootRelationInput",
		update:"GeneralWithoutLocalesUpdateInput",
		upsert:"GeneralLocaleUpsertRootRelationInput"
	},
	GeneralWithoutLocalesUpdateInput:{
		unique:"One",
		allAreasIcon:"GeneralUpdateAllAreasIconEntityRelationInput",
		allOrganizationsIcon:"GeneralUpdateAllOrganizationsIconEntityRelationInput",
		organizationList:"GeneralUpdateOrganizationListEntityRelationInput"
	},
	GeneralUpdateAllAreasIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GeneralConnectOrCreateAllAreasIconRelationInput",
		update:"ImageUpdateInput",
		upsert:"GeneralUpsertAllAreasIconRelationInput"
	},
	ImageUpdateInput:{

	},
	GeneralUpsertAllAreasIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	GeneralUpdateAllOrganizationsIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GeneralConnectOrCreateAllOrganizationsIconRelationInput",
		update:"ImageUpdateInput",
		upsert:"GeneralUpsertAllOrganizationsIconRelationInput"
	},
	GeneralUpsertAllOrganizationsIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	GeneralUpdateOrganizationListEntityRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput",
		connectOrCreate:"GeneralConnectOrCreateOrganizationListRelationInput",
		update:"PostOrganizationListUpdateInput",
		upsert:"GeneralUpsertOrganizationListRelationInput"
	},
	PostOrganizationListUpdateInput:{
		items:"PostOrganizationListUpdateItemsEntityRelationInput"
	},
	PostOrganizationListUpdateItemsEntityRelationInput:{
		create:"PostOrganizationListItemWithoutListCreateInput",
		update:"PostOrganizationListUpdateItemsRelationInput",
		upsert:"PostOrganizationListUpsertItemsRelationInput",
		connect:"PostOrganizationListItemUniqueWhere",
		disconnect:"PostOrganizationListItemUniqueWhere",
		delete:"PostOrganizationListItemUniqueWhere"
	},
	PostOrganizationListUpdateItemsRelationInput:{
		by:"PostOrganizationListItemUniqueWhere",
		data:"PostOrganizationListItemWithoutListUpdateInput"
	},
	PostOrganizationListItemWithoutListUpdateInput:{
		item:"PostOrganizationListItemUpdateItemEntityRelationInput",
		type:"PostOrganizationListItemType",
		link:"PostOrganizationListItemUpdateLinkEntityRelationInput",
		image:"PostOrganizationListItemUpdateImageEntityRelationInput"
	},
	PostOrganizationListItemUpdateItemEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationCreateInput",
		connectOrCreate:"PostOrganizationListItemConnectOrCreateItemRelationInput",
		update:"PostOrganizationUpdateInput",
		upsert:"PostOrganizationListItemUpsertItemRelationInput"
	},
	PostOrganizationUpdateInput:{
		posts:"PostOrganizationUpdatePostsEntityRelationInput",
		icon:"PostOrganizationUpdateIconEntityRelationInput",
		locales:"PostOrganizationUpdateLocalesEntityRelationInput",
		area:"PostOrganizationUpdateAreaEntityRelationInput",
		meta:"PostOrganizationUpdateMetaEntityRelationInput",
		mobileHeroImage:"PostOrganizationUpdateMobileHeroImageEntityRelationInput",
		plainIcon:"PostOrganizationUpdatePlainIconEntityRelationInput",
		desktopHeroImage:"PostOrganizationUpdateDesktopHeroImageEntityRelationInput",
		sentPayments:"PostOrganizationUpdateSentPaymentsEntityRelationInput",
		organizationCurrencySums:"PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput",
		organizationSum:"PostOrganizationUpdateOrganizationSumEntityRelationInput"
	},
	PostOrganizationUpdatePostsEntityRelationInput:{
		create:"PostWithoutOrganizationCreateInput",
		update:"PostOrganizationUpdatePostsRelationInput",
		upsert:"PostOrganizationUpsertPostsRelationInput",
		connect:"PostUniqueWhere",
		disconnect:"PostUniqueWhere",
		delete:"PostUniqueWhere"
	},
	PostOrganizationUpdatePostsRelationInput:{
		by:"PostUniqueWhere",
		data:"PostWithoutOrganizationUpdateInput"
	},
	PostWithoutOrganizationUpdateInput:{
		area:"PostUpdateAreaEntityRelationInput",
		activeRevision:"PostUpdateActiveRevisionEntityRelationInput",
		revisions:"PostUpdateRevisionsEntityRelationInput",
		locales:"PostUpdateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostUpdateMetaEntityRelationInput",
		heroCarousel:"PostUpdateHeroCarouselEntityRelationInput",
		reportPage:"PostUpdateReportPageEntityRelationInput",
		content:"PostUpdateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostUpdateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostUpdateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostUpdateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostUpdateFundraisingProgressEntityRelationInput"
	},
	PostUpdateAreaEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutPostsCreateInput",
		connectOrCreate:"PostConnectOrCreateAreaRelationInput",
		update:"PostAreaWithoutPostsUpdateInput",
		upsert:"PostUpsertAreaRelationInput"
	},
	PostAreaWithoutPostsUpdateInput:{
		icon:"PostAreaUpdateIconEntityRelationInput",
		locales:"PostAreaUpdateLocalesEntityRelationInput",
		regionListOverride:"PostAreaUpdateRegionListOverrideEntityRelationInput",
		region:"PostAreaUpdateRegionEntityRelationInput",
		meta:"PostAreaUpdateMetaEntityRelationInput",
		mobileHeroImage:"PostAreaUpdateMobileHeroImageEntityRelationInput",
		plainIcon:"PostAreaUpdatePlainIconEntityRelationInput",
		sentPayments:"PostAreaUpdateSentPaymentsEntityRelationInput",
		areaSentPaymentCurrencySums:"PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaSentPaymentSum:"PostAreaUpdateAreaSentPaymentSumEntityRelationInput",
		areaCurrencySums:"PostAreaUpdateAreaCurrencySumsEntityRelationInput",
		areaSum:"PostAreaUpdateAreaSumEntityRelationInput"
	},
	PostAreaUpdateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateIconRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostAreaUpsertIconRelationInput"
	},
	PostAreaUpsertIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostAreaUpdateLocalesEntityRelationInput:{
		create:"PostAreaLocaleWithoutRootCreateInput",
		update:"PostAreaUpdateLocalesRelationInput",
		upsert:"PostAreaUpsertLocalesRelationInput",
		connect:"PostAreaLocaleUniqueWhere",
		disconnect:"PostAreaLocaleUniqueWhere",
		delete:"PostAreaLocaleUniqueWhere"
	},
	PostAreaUpdateLocalesRelationInput:{
		by:"PostAreaLocaleUniqueWhere",
		data:"PostAreaLocaleWithoutRootUpdateInput"
	},
	PostAreaLocaleWithoutRootUpdateInput:{
		link:"PostAreaLocaleUpdateLinkEntityRelationInput",
		locale:"PostAreaLocaleUpdateLocaleEntityRelationInput",
		seo:"PostAreaLocaleUpdateSeoEntityRelationInput",
		banner:"PostAreaLocaleUpdateBannerEntityRelationInput",
		content:"PostAreaLocaleUpdateContentEntityRelationInput"
	},
	PostAreaLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostAreaCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutPostAreaUpdateInput",
		upsert:"PostAreaLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutPostAreaUpdateInput:{
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		post:"LinkableUpdatePostEntityRelationInput",
		postOrganization:"LinkableUpdatePostOrganizationEntityRelationInput",
		reportPage:"LinkableUpdateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableUpdateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableUpdateReceivedGiftsPageEntityRelationInput"
	},
	LinkableUpdateGenericPageEntityRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateGenericPageRelationInput",
		update:"GenericPageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertGenericPageRelationInput"
	},
	GenericPageLocaleWithoutLinkUpdateInput:{
		root:"GenericPageLocaleUpdateRootEntityRelationInput",
		locale:"GenericPageLocaleUpdateLocaleEntityRelationInput",
		content:"GenericPageLocaleUpdateContentEntityRelationInput",
		seo:"GenericPageLocaleUpdateSeoEntityRelationInput"
	},
	GenericPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPagesCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutGenericPagesUpdateInput",
		upsert:"GenericPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutGenericPagesUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdatePostsEntityRelationInput:{
		create:"PostLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdatePostsRelationInput",
		upsert:"LocaleUpsertPostsRelationInput",
		connect:"PostLocaleUniqueWhere",
		disconnect:"PostLocaleUniqueWhere",
		delete:"PostLocaleUniqueWhere"
	},
	LocaleUpdatePostsRelationInput:{
		by:"PostLocaleUniqueWhere",
		data:"PostLocaleWithoutLocaleUpdateInput"
	},
	PostLocaleWithoutLocaleUpdateInput:{
		content:"PostLocaleUpdateContentEntityRelationInput",
		seo:"PostLocaleUpdateSeoEntityRelationInput",
		link:"PostLocaleUpdateLinkEntityRelationInput",
		root:"PostLocaleUpdateRootEntityRelationInput",
		publishedAt:"DateTime"
	},
	PostLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"PostLocaleUpsertContentRelationInput"
	},
	ContentUpdateInput:{
		blocks:"ContentUpdateBlocksEntityRelationInput"
	},
	ContentUpdateBlocksEntityRelationInput:{
		create:"ContentBlockWithoutContentCreateInput",
		update:"ContentUpdateBlocksRelationInput",
		upsert:"ContentUpsertBlocksRelationInput",
		connect:"ContentBlockUniqueWhere",
		disconnect:"ContentBlockUniqueWhere",
		delete:"ContentBlockUniqueWhere"
	},
	ContentUpdateBlocksRelationInput:{
		by:"ContentBlockUniqueWhere",
		data:"ContentBlockWithoutContentUpdateInput"
	},
	ContentBlockWithoutContentUpdateInput:{
		references:"ContentBlockUpdateReferencesEntityRelationInput"
	},
	ContentBlockUpdateReferencesEntityRelationInput:{
		create:"ContentReferenceWithoutBlockCreateInput",
		update:"ContentBlockUpdateReferencesRelationInput",
		upsert:"ContentBlockUpsertReferencesRelationInput",
		connect:"ContentReferenceUniqueWhere",
		disconnect:"ContentReferenceUniqueWhere",
		delete:"ContentReferenceUniqueWhere"
	},
	ContentBlockUpdateReferencesRelationInput:{
		by:"ContentReferenceUniqueWhere",
		data:"ContentReferenceWithoutBlockUpdateInput"
	},
	ContentReferenceWithoutBlockUpdateInput:{
		type:"ContentReferenceType",
		image:"ContentReferenceUpdateImageEntityRelationInput",
		linkables:"ContentReferenceUpdateLinkablesEntityRelationInput",
		video:"ContentReferenceUpdateVideoEntityRelationInput",
		link:"ContentReferenceUpdateLinkEntityRelationInput",
		contentAlignment:"ContentAlignment",
		valueList:"ContentReferenceUpdateValueListEntityRelationInput",
		imageLinkList:"ContentReferenceUpdateImageLinkListEntityRelationInput",
		areaList:"ContentReferenceUpdateAreaListEntityRelationInput",
		accordion:"ContentReferenceUpdateAccordionEntityRelationInput",
		media:"ContentReferenceUpdateMediaEntityRelationInput",
		memberList:"ContentReferenceUpdateMemberListEntityRelationInput",
		asideMediaContentLayout:"AsideMediaContentLayout",
		form:"ContentReferenceUpdateFormEntityRelationInput",
		contentWithoutBlocks:"ContentReferenceUpdateContentWithoutBlocksEntityRelationInput",
		heroCarousel:"ContentReferenceUpdateHeroCarouselEntityRelationInput",
		organizationList:"ContentReferenceUpdateOrganizationListEntityRelationInput",
		posts:"ContentReferenceUpdatePostsEntityRelationInput",
		textImageList:"ContentReferenceUpdateTextImageListEntityRelationInput"
	},
	ContentReferenceUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"ContentReferenceUpsertImageRelationInput"
	},
	ContentReferenceUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ContentReferenceUpdateLinkablesEntityRelationInput:{
		connect:"ContentReferenceLinkableItemUniqueWhere",
		disconnect:"ContentReferenceLinkableItemUniqueWhere",
		delete:"ContentReferenceLinkableItemUniqueWhere"
	},
	ContentReferenceUpdateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateVideoRelationInput",
		update:"VideoUpdateInput",
		upsert:"ContentReferenceUpsertVideoRelationInput"
	},
	VideoUpdateInput:{
		poster:"VideoUpdatePosterEntityRelationInput",
		shapeType:"VideoShapeType"
	},
	VideoUpdatePosterEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"VideoConnectOrCreatePosterRelationInput",
		update:"ImageUpdateInput",
		upsert:"VideoUpsertPosterRelationInput"
	},
	VideoUpsertPosterRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ContentReferenceUpsertVideoRelationInput:{
		update:"VideoUpdateInput",
		create:"VideoCreateInput"
	},
	ContentReferenceUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"ContentReferenceUpsertLinkRelationInput"
	},
	LinkUpdateInput:{
		type:"LinkEnum",
		internalLink:"LinkUpdateInternalLinkEntityRelationInput"
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableCreateInput",
		connectOrCreate:"LinkConnectOrCreateInternalLinkRelationInput",
		update:"LinkableUpdateInput",
		upsert:"LinkUpsertInternalLinkRelationInput"
	},
	LinkableUpdateInput:{
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		post:"LinkableUpdatePostEntityRelationInput",
		postArea:"LinkableUpdatePostAreaEntityRelationInput",
		postOrganization:"LinkableUpdatePostOrganizationEntityRelationInput",
		reportPage:"LinkableUpdateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableUpdateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableUpdateReceivedGiftsPageEntityRelationInput"
	},
	LinkableUpdatePostEntityRelationInput:{
		connect:"PostLocaleUniqueWhere",
		create:"PostLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreatePostRelationInput",
		update:"PostLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertPostRelationInput"
	},
	PostLocaleWithoutLinkUpdateInput:{
		content:"PostLocaleUpdateContentEntityRelationInput",
		seo:"PostLocaleUpdateSeoEntityRelationInput",
		locale:"PostLocaleUpdateLocaleEntityRelationInput",
		root:"PostLocaleUpdateRootEntityRelationInput",
		publishedAt:"DateTime"
	},
	PostLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"PostLocaleUpsertSeoRelationInput"
	},
	SeoUpdateInput:{
		ogImage:"SeoUpdateOgImageEntityRelationInput"
	},
	SeoUpdateOgImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"SeoConnectOrCreateOgImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"SeoUpsertOgImageRelationInput"
	},
	SeoUpsertOgImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	PostLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostsCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutPostsUpdateInput",
		upsert:"PostLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutPostsUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdatePostAreasEntityRelationInput:{
		create:"PostAreaLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdatePostAreasRelationInput",
		upsert:"LocaleUpsertPostAreasRelationInput",
		connect:"PostAreaLocaleUniqueWhere",
		disconnect:"PostAreaLocaleUniqueWhere",
		delete:"PostAreaLocaleUniqueWhere"
	},
	LocaleUpdatePostAreasRelationInput:{
		by:"PostAreaLocaleUniqueWhere",
		data:"PostAreaLocaleWithoutLocaleUpdateInput"
	},
	PostAreaLocaleWithoutLocaleUpdateInput:{
		link:"PostAreaLocaleUpdateLinkEntityRelationInput",
		root:"PostAreaLocaleUpdateRootEntityRelationInput",
		seo:"PostAreaLocaleUpdateSeoEntityRelationInput",
		banner:"PostAreaLocaleUpdateBannerEntityRelationInput",
		content:"PostAreaLocaleUpdateContentEntityRelationInput"
	},
	PostAreaLocaleUpdateRootEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutLocalesCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateRootRelationInput",
		update:"PostAreaWithoutLocalesUpdateInput",
		upsert:"PostAreaLocaleUpsertRootRelationInput"
	},
	PostAreaWithoutLocalesUpdateInput:{
		icon:"PostAreaUpdateIconEntityRelationInput",
		regionListOverride:"PostAreaUpdateRegionListOverrideEntityRelationInput",
		posts:"PostAreaUpdatePostsEntityRelationInput",
		region:"PostAreaUpdateRegionEntityRelationInput",
		meta:"PostAreaUpdateMetaEntityRelationInput",
		mobileHeroImage:"PostAreaUpdateMobileHeroImageEntityRelationInput",
		plainIcon:"PostAreaUpdatePlainIconEntityRelationInput",
		sentPayments:"PostAreaUpdateSentPaymentsEntityRelationInput",
		areaSentPaymentCurrencySums:"PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaSentPaymentSum:"PostAreaUpdateAreaSentPaymentSumEntityRelationInput",
		areaCurrencySums:"PostAreaUpdateAreaCurrencySumsEntityRelationInput",
		areaSum:"PostAreaUpdateAreaSumEntityRelationInput"
	},
	PostAreaUpdateRegionListOverrideEntityRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateRegionListOverrideRelationInput",
		update:"DonationAmountsRegionListUpdateInput",
		upsert:"PostAreaUpsertRegionListOverrideRelationInput"
	},
	DonationAmountsRegionListUpdateInput:{
		regions:"DonationAmountsRegionListUpdateRegionsEntityRelationInput",
		donation:"DonationAmountsRegionListUpdateDonationEntityRelationInput"
	},
	DonationAmountsRegionListUpdateRegionsEntityRelationInput:{
		create:"DonationAmountsRegionItemWithoutListCreateInput",
		update:"DonationAmountsRegionListUpdateRegionsRelationInput",
		upsert:"DonationAmountsRegionListUpsertRegionsRelationInput",
		connect:"DonationAmountsRegionItemUniqueWhere",
		disconnect:"DonationAmountsRegionItemUniqueWhere",
		delete:"DonationAmountsRegionItemUniqueWhere"
	},
	DonationAmountsRegionListUpdateRegionsRelationInput:{
		by:"DonationAmountsRegionItemUniqueWhere",
		data:"DonationAmountsRegionItemWithoutListUpdateInput"
	},
	DonationAmountsRegionItemWithoutListUpdateInput:{
		items:"DonationAmountsRegionItemUpdateItemsEntityRelationInput",
		region:"DonationAmountsRegionItemUpdateRegionEntityRelationInput"
	},
	DonationAmountsRegionItemUpdateItemsEntityRelationInput:{
		create:"DonationAmountItemWithoutRegionItemCreateInput",
		update:"DonationAmountsRegionItemUpdateItemsRelationInput",
		upsert:"DonationAmountsRegionItemUpsertItemsRelationInput",
		connect:"DonationAmountItemUniqueWhere",
		disconnect:"DonationAmountItemUniqueWhere",
		delete:"DonationAmountItemUniqueWhere"
	},
	DonationAmountsRegionItemUpdateItemsRelationInput:{
		by:"DonationAmountItemUniqueWhere",
		data:"DonationAmountItemWithoutRegionItemUpdateInput"
	},
	DonationAmountItemWithoutRegionItemUpdateInput:{

	},
	DonationAmountsRegionItemUpsertItemsRelationInput:{
		by:"DonationAmountItemUniqueWhere",
		update:"DonationAmountItemWithoutRegionItemUpdateInput",
		create:"DonationAmountItemWithoutRegionItemCreateInput"
	},
	DonationAmountsRegionItemUpdateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionWithoutDonationItemsCreateInput",
		connectOrCreate:"DonationAmountsRegionItemConnectOrCreateRegionRelationInput",
		update:"RegionWithoutDonationItemsUpdateInput",
		upsert:"DonationAmountsRegionItemUpsertRegionRelationInput"
	},
	RegionWithoutDonationItemsUpdateInput:{
		currency:"RegionUpdateCurrencyEntityRelationInput",
		enabledPaymentMethods:"RegionUpdateEnabledPaymentMethodsEntityRelationInput"
	},
	RegionUpdateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"RegionConnectOrCreateCurrencyRelationInput",
		update:"CurrencyUpdateInput",
		upsert:"RegionUpsertCurrencyRelationInput"
	},
	CurrencyUpdateInput:{
		identifier:"CurrencyIdentifier",
		signAlignment:"CurrencySignAlignment",
		areaSentPaymentCurrencySums:"CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaCurrencySums:"CurrencyUpdateAreaCurrencySumsEntityRelationInput",
		organizationCurrencySums:"CurrencyUpdateOrganizationCurrencySumsEntityRelationInput",
		postCurrencySums:"CurrencyUpdatePostCurrencySumsEntityRelationInput"
	},
	CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput:{
		connect:"PostAreaSentPaymentCurrencySumUniqueWhere",
		disconnect:"PostAreaSentPaymentCurrencySumUniqueWhere",
		delete:"PostAreaSentPaymentCurrencySumUniqueWhere"
	},
	CurrencyUpdateAreaCurrencySumsEntityRelationInput:{
		connect:"PostAreaCurrencySumUniqueWhere",
		disconnect:"PostAreaCurrencySumUniqueWhere",
		delete:"PostAreaCurrencySumUniqueWhere"
	},
	CurrencyUpdateOrganizationCurrencySumsEntityRelationInput:{
		connect:"PostOrganizationCurrencySumUniqueWhere",
		disconnect:"PostOrganizationCurrencySumUniqueWhere",
		delete:"PostOrganizationCurrencySumUniqueWhere"
	},
	CurrencyUpdatePostCurrencySumsEntityRelationInput:{
		connect:"PostCurrencySumUniqueWhere",
		disconnect:"PostCurrencySumUniqueWhere",
		delete:"PostCurrencySumUniqueWhere"
	},
	RegionUpsertCurrencyRelationInput:{
		update:"CurrencyUpdateInput",
		create:"CurrencyCreateInput"
	},
	RegionUpdateEnabledPaymentMethodsEntityRelationInput:{
		create:"RegionPaymentMethodWithoutRegionCreateInput",
		update:"RegionUpdateEnabledPaymentMethodsRelationInput",
		upsert:"RegionUpsertEnabledPaymentMethodsRelationInput",
		connect:"RegionPaymentMethodUniqueWhere",
		disconnect:"RegionPaymentMethodUniqueWhere",
		delete:"RegionPaymentMethodUniqueWhere"
	},
	RegionUpdateEnabledPaymentMethodsRelationInput:{
		by:"RegionPaymentMethodUniqueWhere",
		data:"RegionPaymentMethodWithoutRegionUpdateInput"
	},
	RegionPaymentMethodWithoutRegionUpdateInput:{
		method:"PaymentMethods"
	},
	RegionUpsertEnabledPaymentMethodsRelationInput:{
		by:"RegionPaymentMethodUniqueWhere",
		update:"RegionPaymentMethodWithoutRegionUpdateInput",
		create:"RegionPaymentMethodWithoutRegionCreateInput"
	},
	DonationAmountsRegionItemUpsertRegionRelationInput:{
		update:"RegionWithoutDonationItemsUpdateInput",
		create:"RegionWithoutDonationItemsCreateInput"
	},
	DonationAmountsRegionListUpsertRegionsRelationInput:{
		by:"DonationAmountsRegionItemUniqueWhere",
		update:"DonationAmountsRegionItemWithoutListUpdateInput",
		create:"DonationAmountsRegionItemWithoutListCreateInput"
	},
	DonationAmountsRegionListUpdateDonationEntityRelationInput:{
		connect:"DonationUniqueWhere",
		create:"DonationWithoutRegionListCreateInput",
		connectOrCreate:"DonationAmountsRegionListConnectOrCreateDonationRelationInput",
		update:"DonationWithoutRegionListUpdateInput",
		upsert:"DonationAmountsRegionListUpsertDonationRelationInput"
	},
	DonationWithoutRegionListUpdateInput:{
		unique:"One"
	},
	DonationAmountsRegionListUpsertDonationRelationInput:{
		update:"DonationWithoutRegionListUpdateInput",
		create:"DonationWithoutRegionListCreateInput"
	},
	PostAreaUpsertRegionListOverrideRelationInput:{
		update:"DonationAmountsRegionListUpdateInput",
		create:"DonationAmountsRegionListCreateInput"
	},
	PostAreaUpdatePostsEntityRelationInput:{
		create:"PostWithoutAreaCreateInput",
		update:"PostAreaUpdatePostsRelationInput",
		upsert:"PostAreaUpsertPostsRelationInput",
		connect:"PostUniqueWhere",
		disconnect:"PostUniqueWhere",
		delete:"PostUniqueWhere"
	},
	PostAreaUpdatePostsRelationInput:{
		by:"PostUniqueWhere",
		data:"PostWithoutAreaUpdateInput"
	},
	PostWithoutAreaUpdateInput:{
		organization:"PostUpdateOrganizationEntityRelationInput",
		activeRevision:"PostUpdateActiveRevisionEntityRelationInput",
		revisions:"PostUpdateRevisionsEntityRelationInput",
		locales:"PostUpdateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostUpdateMetaEntityRelationInput",
		heroCarousel:"PostUpdateHeroCarouselEntityRelationInput",
		reportPage:"PostUpdateReportPageEntityRelationInput",
		content:"PostUpdateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostUpdateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostUpdateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostUpdateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostUpdateFundraisingProgressEntityRelationInput"
	},
	PostUpdateOrganizationEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutPostsCreateInput",
		connectOrCreate:"PostConnectOrCreateOrganizationRelationInput",
		update:"PostOrganizationWithoutPostsUpdateInput",
		upsert:"PostUpsertOrganizationRelationInput"
	},
	PostOrganizationWithoutPostsUpdateInput:{
		icon:"PostOrganizationUpdateIconEntityRelationInput",
		locales:"PostOrganizationUpdateLocalesEntityRelationInput",
		area:"PostOrganizationUpdateAreaEntityRelationInput",
		meta:"PostOrganizationUpdateMetaEntityRelationInput",
		mobileHeroImage:"PostOrganizationUpdateMobileHeroImageEntityRelationInput",
		plainIcon:"PostOrganizationUpdatePlainIconEntityRelationInput",
		desktopHeroImage:"PostOrganizationUpdateDesktopHeroImageEntityRelationInput",
		sentPayments:"PostOrganizationUpdateSentPaymentsEntityRelationInput",
		organizationCurrencySums:"PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput",
		organizationSum:"PostOrganizationUpdateOrganizationSumEntityRelationInput"
	},
	PostOrganizationUpdateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateIconRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostOrganizationUpsertIconRelationInput"
	},
	PostOrganizationUpsertIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostOrganizationUpdateLocalesEntityRelationInput:{
		create:"PostOrganizationLocaleWithoutRootCreateInput",
		update:"PostOrganizationUpdateLocalesRelationInput",
		upsert:"PostOrganizationUpsertLocalesRelationInput",
		connect:"PostOrganizationLocaleUniqueWhere",
		disconnect:"PostOrganizationLocaleUniqueWhere",
		delete:"PostOrganizationLocaleUniqueWhere"
	},
	PostOrganizationUpdateLocalesRelationInput:{
		by:"PostOrganizationLocaleUniqueWhere",
		data:"PostOrganizationLocaleWithoutRootUpdateInput"
	},
	PostOrganizationLocaleWithoutRootUpdateInput:{
		link:"PostOrganizationLocaleUpdateLinkEntityRelationInput",
		locale:"PostOrganizationLocaleUpdateLocaleEntityRelationInput",
		domain:"PostOrganizationLocaleUpdateDomainEntityRelationInput",
		seo:"PostOrganizationLocaleUpdateSeoEntityRelationInput",
		content:"PostOrganizationLocaleUpdateContentEntityRelationInput"
	},
	PostOrganizationLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostOrganizationCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutPostOrganizationUpdateInput",
		upsert:"PostOrganizationLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutPostOrganizationUpdateInput:{
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		post:"LinkableUpdatePostEntityRelationInput",
		postArea:"LinkableUpdatePostAreaEntityRelationInput",
		reportPage:"LinkableUpdateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableUpdateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableUpdateReceivedGiftsPageEntityRelationInput"
	},
	LinkableUpdatePostAreaEntityRelationInput:{
		connect:"PostAreaLocaleUniqueWhere",
		create:"PostAreaLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreatePostAreaRelationInput",
		update:"PostAreaLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertPostAreaRelationInput"
	},
	PostAreaLocaleWithoutLinkUpdateInput:{
		root:"PostAreaLocaleUpdateRootEntityRelationInput",
		locale:"PostAreaLocaleUpdateLocaleEntityRelationInput",
		seo:"PostAreaLocaleUpdateSeoEntityRelationInput",
		banner:"PostAreaLocaleUpdateBannerEntityRelationInput",
		content:"PostAreaLocaleUpdateContentEntityRelationInput"
	},
	PostAreaLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostAreasCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutPostAreasUpdateInput",
		upsert:"PostAreaLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutPostAreasUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdatePostOrganizationsEntityRelationInput:{
		create:"PostOrganizationLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdatePostOrganizationsRelationInput",
		upsert:"LocaleUpsertPostOrganizationsRelationInput",
		connect:"PostOrganizationLocaleUniqueWhere",
		disconnect:"PostOrganizationLocaleUniqueWhere",
		delete:"PostOrganizationLocaleUniqueWhere"
	},
	LocaleUpdatePostOrganizationsRelationInput:{
		by:"PostOrganizationLocaleUniqueWhere",
		data:"PostOrganizationLocaleWithoutLocaleUpdateInput"
	},
	PostOrganizationLocaleWithoutLocaleUpdateInput:{
		link:"PostOrganizationLocaleUpdateLinkEntityRelationInput",
		root:"PostOrganizationLocaleUpdateRootEntityRelationInput",
		domain:"PostOrganizationLocaleUpdateDomainEntityRelationInput",
		seo:"PostOrganizationLocaleUpdateSeoEntityRelationInput",
		content:"PostOrganizationLocaleUpdateContentEntityRelationInput"
	},
	PostOrganizationLocaleUpdateRootEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutLocalesCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateRootRelationInput",
		update:"PostOrganizationWithoutLocalesUpdateInput",
		upsert:"PostOrganizationLocaleUpsertRootRelationInput"
	},
	PostOrganizationWithoutLocalesUpdateInput:{
		posts:"PostOrganizationUpdatePostsEntityRelationInput",
		icon:"PostOrganizationUpdateIconEntityRelationInput",
		area:"PostOrganizationUpdateAreaEntityRelationInput",
		meta:"PostOrganizationUpdateMetaEntityRelationInput",
		mobileHeroImage:"PostOrganizationUpdateMobileHeroImageEntityRelationInput",
		plainIcon:"PostOrganizationUpdatePlainIconEntityRelationInput",
		desktopHeroImage:"PostOrganizationUpdateDesktopHeroImageEntityRelationInput",
		sentPayments:"PostOrganizationUpdateSentPaymentsEntityRelationInput",
		organizationCurrencySums:"PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput",
		organizationSum:"PostOrganizationUpdateOrganizationSumEntityRelationInput"
	},
	PostOrganizationUpdateAreaEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateAreaRelationInput",
		update:"PostAreaUpdateInput",
		upsert:"PostOrganizationUpsertAreaRelationInput"
	},
	PostAreaUpdateInput:{
		icon:"PostAreaUpdateIconEntityRelationInput",
		locales:"PostAreaUpdateLocalesEntityRelationInput",
		regionListOverride:"PostAreaUpdateRegionListOverrideEntityRelationInput",
		posts:"PostAreaUpdatePostsEntityRelationInput",
		region:"PostAreaUpdateRegionEntityRelationInput",
		meta:"PostAreaUpdateMetaEntityRelationInput",
		mobileHeroImage:"PostAreaUpdateMobileHeroImageEntityRelationInput",
		plainIcon:"PostAreaUpdatePlainIconEntityRelationInput",
		sentPayments:"PostAreaUpdateSentPaymentsEntityRelationInput",
		areaSentPaymentCurrencySums:"PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaSentPaymentSum:"PostAreaUpdateAreaSentPaymentSumEntityRelationInput",
		areaCurrencySums:"PostAreaUpdateAreaCurrencySumsEntityRelationInput",
		areaSum:"PostAreaUpdateAreaSumEntityRelationInput"
	},
	PostAreaUpdateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateRegionRelationInput",
		update:"RegionUpdateInput",
		upsert:"PostAreaUpsertRegionRelationInput"
	},
	RegionUpdateInput:{
		currency:"RegionUpdateCurrencyEntityRelationInput",
		enabledPaymentMethods:"RegionUpdateEnabledPaymentMethodsEntityRelationInput",
		donationItems:"RegionUpdateDonationItemsEntityRelationInput"
	},
	RegionUpdateDonationItemsEntityRelationInput:{
		create:"DonationAmountsRegionItemWithoutRegionCreateInput",
		update:"RegionUpdateDonationItemsRelationInput",
		upsert:"RegionUpsertDonationItemsRelationInput",
		connect:"DonationAmountsRegionItemUniqueWhere",
		disconnect:"DonationAmountsRegionItemUniqueWhere",
		delete:"DonationAmountsRegionItemUniqueWhere"
	},
	RegionUpdateDonationItemsRelationInput:{
		by:"DonationAmountsRegionItemUniqueWhere",
		data:"DonationAmountsRegionItemWithoutRegionUpdateInput"
	},
	DonationAmountsRegionItemWithoutRegionUpdateInput:{
		items:"DonationAmountsRegionItemUpdateItemsEntityRelationInput",
		list:"DonationAmountsRegionItemUpdateListEntityRelationInput"
	},
	DonationAmountsRegionItemUpdateListEntityRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListWithoutRegionsCreateInput",
		connectOrCreate:"DonationAmountsRegionItemConnectOrCreateListRelationInput",
		update:"DonationAmountsRegionListWithoutRegionsUpdateInput",
		upsert:"DonationAmountsRegionItemUpsertListRelationInput"
	},
	DonationAmountsRegionListWithoutRegionsUpdateInput:{
		donation:"DonationAmountsRegionListUpdateDonationEntityRelationInput"
	},
	DonationAmountsRegionItemUpsertListRelationInput:{
		update:"DonationAmountsRegionListWithoutRegionsUpdateInput",
		create:"DonationAmountsRegionListWithoutRegionsCreateInput"
	},
	RegionUpsertDonationItemsRelationInput:{
		by:"DonationAmountsRegionItemUniqueWhere",
		update:"DonationAmountsRegionItemWithoutRegionUpdateInput",
		create:"DonationAmountsRegionItemWithoutRegionCreateInput"
	},
	PostAreaUpsertRegionRelationInput:{
		update:"RegionUpdateInput",
		create:"RegionCreateInput"
	},
	PostAreaUpdateMetaEntityRelationInput:{
		connect:"PostAreaMetaDataUniqueWhere"
	},
	PostAreaUpdateMobileHeroImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostAreaConnectOrCreateMobileHeroImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostAreaUpsertMobileHeroImageRelationInput"
	},
	PostAreaUpsertMobileHeroImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostAreaUpdatePlainIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostAreaConnectOrCreatePlainIconRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostAreaUpsertPlainIconRelationInput"
	},
	PostAreaUpsertPlainIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostAreaUpdateSentPaymentsEntityRelationInput:{
		create:"SentPaymentWithoutAreaCreateInput",
		update:"PostAreaUpdateSentPaymentsRelationInput",
		upsert:"PostAreaUpsertSentPaymentsRelationInput",
		connect:"SentPaymentUniqueWhere",
		disconnect:"SentPaymentUniqueWhere",
		delete:"SentPaymentUniqueWhere"
	},
	PostAreaUpdateSentPaymentsRelationInput:{
		by:"SentPaymentUniqueWhere",
		data:"SentPaymentWithoutAreaUpdateInput"
	},
	SentPaymentWithoutAreaUpdateInput:{
		createdAt:"DateTime",
		sendAt:"DateTime",
		currency:"SentPaymentUpdateCurrencyEntityRelationInput",
		organization:"SentPaymentUpdateOrganizationEntityRelationInput",
		locales:"SentPaymentUpdateLocalesEntityRelationInput"
	},
	SentPaymentUpdateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"SentPaymentConnectOrCreateCurrencyRelationInput",
		update:"CurrencyUpdateInput",
		upsert:"SentPaymentUpsertCurrencyRelationInput"
	},
	SentPaymentUpsertCurrencyRelationInput:{
		update:"CurrencyUpdateInput",
		create:"CurrencyCreateInput"
	},
	SentPaymentUpdateOrganizationEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationWithoutSentPaymentsCreateInput",
		connectOrCreate:"SentPaymentConnectOrCreateOrganizationRelationInput",
		update:"PostOrganizationWithoutSentPaymentsUpdateInput",
		upsert:"SentPaymentUpsertOrganizationRelationInput"
	},
	PostOrganizationWithoutSentPaymentsUpdateInput:{
		posts:"PostOrganizationUpdatePostsEntityRelationInput",
		icon:"PostOrganizationUpdateIconEntityRelationInput",
		locales:"PostOrganizationUpdateLocalesEntityRelationInput",
		area:"PostOrganizationUpdateAreaEntityRelationInput",
		meta:"PostOrganizationUpdateMetaEntityRelationInput",
		mobileHeroImage:"PostOrganizationUpdateMobileHeroImageEntityRelationInput",
		plainIcon:"PostOrganizationUpdatePlainIconEntityRelationInput",
		desktopHeroImage:"PostOrganizationUpdateDesktopHeroImageEntityRelationInput",
		organizationCurrencySums:"PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput",
		organizationSum:"PostOrganizationUpdateOrganizationSumEntityRelationInput"
	},
	PostOrganizationUpdateMetaEntityRelationInput:{
		connect:"PostOrganizationMetaDataUniqueWhere"
	},
	PostOrganizationUpdateMobileHeroImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateMobileHeroImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostOrganizationUpsertMobileHeroImageRelationInput"
	},
	PostOrganizationUpsertMobileHeroImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostOrganizationUpdatePlainIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreatePlainIconRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostOrganizationUpsertPlainIconRelationInput"
	},
	PostOrganizationUpsertPlainIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostOrganizationUpdateDesktopHeroImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationConnectOrCreateDesktopHeroImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostOrganizationUpsertDesktopHeroImageRelationInput"
	},
	PostOrganizationUpsertDesktopHeroImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput:{
		connect:"PostOrganizationCurrencySumUniqueWhere",
		disconnect:"PostOrganizationCurrencySumUniqueWhere",
		delete:"PostOrganizationCurrencySumUniqueWhere"
	},
	PostOrganizationUpdateOrganizationSumEntityRelationInput:{
		connect:"PostOrganizationSumUniqueWhere"
	},
	SentPaymentUpsertOrganizationRelationInput:{
		update:"PostOrganizationWithoutSentPaymentsUpdateInput",
		create:"PostOrganizationWithoutSentPaymentsCreateInput"
	},
	SentPaymentUpdateLocalesEntityRelationInput:{
		create:"SentPaymentLocaleWithoutRootCreateInput",
		update:"SentPaymentUpdateLocalesRelationInput",
		upsert:"SentPaymentUpsertLocalesRelationInput",
		connect:"SentPaymentLocaleUniqueWhere",
		disconnect:"SentPaymentLocaleUniqueWhere",
		delete:"SentPaymentLocaleUniqueWhere"
	},
	SentPaymentUpdateLocalesRelationInput:{
		by:"SentPaymentLocaleUniqueWhere",
		data:"SentPaymentLocaleWithoutRootUpdateInput"
	},
	SentPaymentLocaleWithoutRootUpdateInput:{
		locale:"SentPaymentLocaleUpdateLocaleEntityRelationInput"
	},
	SentPaymentLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutSentPaymentsCreateInput",
		connectOrCreate:"SentPaymentLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutSentPaymentsUpdateInput",
		upsert:"SentPaymentLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutSentPaymentsUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput"
	},
	LocaleUpdateHeadersEntityRelationInput:{
		create:"HeaderLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateHeadersRelationInput",
		upsert:"LocaleUpsertHeadersRelationInput",
		connect:"HeaderLocaleUniqueWhere",
		disconnect:"HeaderLocaleUniqueWhere",
		delete:"HeaderLocaleUniqueWhere"
	},
	LocaleUpdateHeadersRelationInput:{
		by:"HeaderLocaleUniqueWhere",
		data:"HeaderLocaleWithoutLocaleUpdateInput"
	},
	HeaderLocaleWithoutLocaleUpdateInput:{
		root:"HeaderLocaleUpdateRootEntityRelationInput",
		links:"HeaderLocaleUpdateLinksEntityRelationInput"
	},
	HeaderLocaleUpdateRootEntityRelationInput:{
		connect:"HeaderUniqueWhere",
		create:"HeaderWithoutLocalesCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateRootRelationInput",
		update:"HeaderWithoutLocalesUpdateInput",
		upsert:"HeaderLocaleUpsertRootRelationInput"
	},
	HeaderWithoutLocalesUpdateInput:{
		unique:"One",
		logo:"HeaderUpdateLogoEntityRelationInput",
		organizationList:"HeaderUpdateOrganizationListEntityRelationInput"
	},
	HeaderUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HeaderConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"HeaderUpsertLogoRelationInput"
	},
	HeaderUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	HeaderUpdateOrganizationListEntityRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput",
		connectOrCreate:"HeaderConnectOrCreateOrganizationListRelationInput",
		update:"PostOrganizationListUpdateInput",
		upsert:"HeaderUpsertOrganizationListRelationInput"
	},
	HeaderUpsertOrganizationListRelationInput:{
		update:"PostOrganizationListUpdateInput",
		create:"PostOrganizationListCreateInput"
	},
	HeaderLocaleUpsertRootRelationInput:{
		update:"HeaderWithoutLocalesUpdateInput",
		create:"HeaderWithoutLocalesCreateInput"
	},
	HeaderLocaleUpdateLinksEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLinksRelationInput",
		update:"LinkListUpdateInput",
		upsert:"HeaderLocaleUpsertLinksRelationInput"
	},
	LinkListUpdateInput:{
		items:"LinkListUpdateItemsEntityRelationInput"
	},
	LinkListUpdateItemsEntityRelationInput:{
		create:"LinkItemWithoutListCreateInput",
		update:"LinkListUpdateItemsRelationInput",
		upsert:"LinkListUpsertItemsRelationInput",
		connect:"LinkItemUniqueWhere",
		disconnect:"LinkItemUniqueWhere",
		delete:"LinkItemUniqueWhere"
	},
	LinkListUpdateItemsRelationInput:{
		by:"LinkItemUniqueWhere",
		data:"LinkItemWithoutListUpdateInput"
	},
	LinkItemWithoutListUpdateInput:{
		link:"LinkItemUpdateLinkEntityRelationInput"
	},
	LinkItemUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"LinkItemConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"LinkItemUpsertLinkRelationInput"
	},
	LinkItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	LinkListUpsertItemsRelationInput:{
		by:"LinkItemUniqueWhere",
		update:"LinkItemWithoutListUpdateInput",
		create:"LinkItemWithoutListCreateInput"
	},
	HeaderLocaleUpsertLinksRelationInput:{
		update:"LinkListUpdateInput",
		create:"LinkListCreateInput"
	},
	LocaleUpsertHeadersRelationInput:{
		by:"HeaderLocaleUniqueWhere",
		update:"HeaderLocaleWithoutLocaleUpdateInput",
		create:"HeaderLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateFootersEntityRelationInput:{
		create:"FooterLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateFootersRelationInput",
		upsert:"LocaleUpsertFootersRelationInput",
		connect:"FooterLocaleUniqueWhere",
		disconnect:"FooterLocaleUniqueWhere",
		delete:"FooterLocaleUniqueWhere"
	},
	LocaleUpdateFootersRelationInput:{
		by:"FooterLocaleUniqueWhere",
		data:"FooterLocaleWithoutLocaleUpdateInput"
	},
	FooterLocaleWithoutLocaleUpdateInput:{
		root:"FooterLocaleUpdateRootEntityRelationInput",
		linkList:"FooterLocaleUpdateLinkListEntityRelationInput",
		addressInfo:"FooterLocaleUpdateAddressInfoEntityRelationInput",
		imageLinkList:"FooterLocaleUpdateImageLinkListEntityRelationInput"
	},
	FooterLocaleUpdateRootEntityRelationInput:{
		connect:"FooterUniqueWhere",
		create:"FooterWithoutLocalesCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateRootRelationInput",
		update:"FooterWithoutLocalesUpdateInput",
		upsert:"FooterLocaleUpsertRootRelationInput"
	},
	FooterWithoutLocalesUpdateInput:{
		unique:"One",
		logo:"FooterUpdateLogoEntityRelationInput"
	},
	FooterUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"FooterConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"FooterUpsertLogoRelationInput"
	},
	FooterUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	FooterLocaleUpsertRootRelationInput:{
		update:"FooterWithoutLocalesUpdateInput",
		create:"FooterWithoutLocalesCreateInput"
	},
	FooterLocaleUpdateLinkListEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateLinkListRelationInput",
		update:"LinkListUpdateInput",
		upsert:"FooterLocaleUpsertLinkListRelationInput"
	},
	FooterLocaleUpsertLinkListRelationInput:{
		update:"LinkListUpdateInput",
		create:"LinkListCreateInput"
	},
	FooterLocaleUpdateAddressInfoEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateAddressInfoRelationInput",
		update:"ContentUpdateInput",
		upsert:"FooterLocaleUpsertAddressInfoRelationInput"
	},
	FooterLocaleUpsertAddressInfoRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	FooterLocaleUpdateImageLinkListEntityRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateImageLinkListRelationInput",
		update:"ImageLinkListUpdateInput",
		upsert:"FooterLocaleUpsertImageLinkListRelationInput"
	},
	ImageLinkListUpdateInput:{
		items:"ImageLinkListUpdateItemsEntityRelationInput"
	},
	ImageLinkListUpdateItemsEntityRelationInput:{
		create:"ImageLinkItemWithoutListCreateInput",
		update:"ImageLinkListUpdateItemsRelationInput",
		upsert:"ImageLinkListUpsertItemsRelationInput",
		connect:"ImageLinkItemUniqueWhere",
		disconnect:"ImageLinkItemUniqueWhere",
		delete:"ImageLinkItemUniqueWhere"
	},
	ImageLinkListUpdateItemsRelationInput:{
		by:"ImageLinkItemUniqueWhere",
		data:"ImageLinkItemWithoutListUpdateInput"
	},
	ImageLinkItemWithoutListUpdateInput:{
		item:"ImageLinkItemUpdateItemEntityRelationInput"
	},
	ImageLinkItemUpdateItemEntityRelationInput:{
		connect:"ImageLinkUniqueWhere",
		create:"ImageLinkCreateInput",
		connectOrCreate:"ImageLinkItemConnectOrCreateItemRelationInput",
		update:"ImageLinkUpdateInput",
		upsert:"ImageLinkItemUpsertItemRelationInput"
	},
	ImageLinkUpdateInput:{
		image:"ImageLinkUpdateImageEntityRelationInput",
		link:"ImageLinkUpdateLinkEntityRelationInput"
	},
	ImageLinkUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ImageLinkConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"ImageLinkUpsertImageRelationInput"
	},
	ImageLinkUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ImageLinkUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"ImageLinkConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"ImageLinkUpsertLinkRelationInput"
	},
	ImageLinkUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	ImageLinkItemUpsertItemRelationInput:{
		update:"ImageLinkUpdateInput",
		create:"ImageLinkCreateInput"
	},
	ImageLinkListUpsertItemsRelationInput:{
		by:"ImageLinkItemUniqueWhere",
		update:"ImageLinkItemWithoutListUpdateInput",
		create:"ImageLinkItemWithoutListCreateInput"
	},
	FooterLocaleUpsertImageLinkListRelationInput:{
		update:"ImageLinkListUpdateInput",
		create:"ImageLinkListCreateInput"
	},
	LocaleUpsertFootersRelationInput:{
		by:"FooterLocaleUniqueWhere",
		update:"FooterLocaleWithoutLocaleUpdateInput",
		create:"FooterLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateGenericPageAboutSettingsEntityRelationInput:{
		create:"GenericPageAboutSettingsLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateGenericPageAboutSettingsRelationInput",
		upsert:"LocaleUpsertGenericPageAboutSettingsRelationInput",
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		disconnect:"GenericPageAboutSettingsLocaleUniqueWhere",
		delete:"GenericPageAboutSettingsLocaleUniqueWhere"
	},
	LocaleUpdateGenericPageAboutSettingsRelationInput:{
		by:"GenericPageAboutSettingsLocaleUniqueWhere",
		data:"GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"
	},
	GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput:{
		root:"GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput",
		linkGroups:"GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"
	},
	GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput:{
		connect:"GenericPageAboutSettingsUniqueWhere",
		create:"GenericPageAboutSettingsWithoutLocalesCreateInput",
		connectOrCreate:"GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput",
		update:"GenericPageAboutSettingsWithoutLocalesUpdateInput",
		upsert:"GenericPageAboutSettingsLocaleUpsertRootRelationInput"
	},
	GenericPageAboutSettingsWithoutLocalesUpdateInput:{
		unique:"One"
	},
	GenericPageAboutSettingsLocaleUpsertRootRelationInput:{
		update:"GenericPageAboutSettingsWithoutLocalesUpdateInput",
		create:"GenericPageAboutSettingsWithoutLocalesCreateInput"
	},
	GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput:{
		create:"GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput",
		update:"GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput",
		upsert:"GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput",
		connect:"GenericPageAboutGroupLinksLocaleUniqueWhere",
		disconnect:"GenericPageAboutGroupLinksLocaleUniqueWhere",
		delete:"GenericPageAboutGroupLinksLocaleUniqueWhere"
	},
	GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput:{
		by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
		data:"GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"
	},
	GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput:{
		linkList:"GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"
	},
	GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput",
		connectOrCreate:"GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput",
		update:"LinkListUpdateInput",
		upsert:"GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"
	},
	GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput:{
		update:"LinkListUpdateInput",
		create:"LinkListCreateInput"
	},
	GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput:{
		by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
		update:"GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput",
		create:"GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"
	},
	LocaleUpsertGenericPageAboutSettingsRelationInput:{
		by:"GenericPageAboutSettingsLocaleUniqueWhere",
		update:"GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput",
		create:"GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdatePostRevisionsEntityRelationInput:{
		create:"PostRevisionLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdatePostRevisionsRelationInput",
		upsert:"LocaleUpsertPostRevisionsRelationInput",
		connect:"PostRevisionLocaleUniqueWhere",
		disconnect:"PostRevisionLocaleUniqueWhere",
		delete:"PostRevisionLocaleUniqueWhere"
	},
	LocaleUpdatePostRevisionsRelationInput:{
		by:"PostRevisionLocaleUniqueWhere",
		data:"PostRevisionLocaleWithoutLocaleUpdateInput"
	},
	PostRevisionLocaleWithoutLocaleUpdateInput:{
		root:"PostRevisionLocaleUpdateRootEntityRelationInput",
		content:"PostRevisionLocaleUpdateContentEntityRelationInput",
		seo:"PostRevisionLocaleUpdateSeoEntityRelationInput",
		leadContent:"PostRevisionLocaleUpdateLeadContentEntityRelationInput"
	},
	PostRevisionLocaleUpdateRootEntityRelationInput:{
		connect:"PostRevisionUniqueWhere",
		create:"PostRevisionWithoutLocalesCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateRootRelationInput",
		update:"PostRevisionWithoutLocalesUpdateInput",
		upsert:"PostRevisionLocaleUpsertRootRelationInput"
	},
	PostRevisionWithoutLocalesUpdateInput:{
		createdAt:"DateTime",
		createdById:"UUID",
		publishedById:"UUID",
		type:"PostType",
		publishedAt:"DateTime",
		post:"PostRevisionUpdatePostEntityRelationInput",
		tileImage:"PostRevisionUpdateTileImageEntityRelationInput",
		tileVideo:"PostRevisionUpdateTileVideoEntityRelationInput",
		heroImage:"PostRevisionUpdateHeroImageEntityRelationInput",
		regionListOverride:"PostRevisionUpdateRegionListOverrideEntityRelationInput"
	},
	PostRevisionUpdatePostEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutRevisionsCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreatePostRelationInput",
		update:"PostWithoutRevisionsUpdateInput",
		upsert:"PostRevisionUpsertPostRelationInput"
	},
	PostWithoutRevisionsUpdateInput:{
		organization:"PostUpdateOrganizationEntityRelationInput",
		area:"PostUpdateAreaEntityRelationInput",
		activeRevision:"PostUpdateActiveRevisionEntityRelationInput",
		locales:"PostUpdateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostUpdateMetaEntityRelationInput",
		heroCarousel:"PostUpdateHeroCarouselEntityRelationInput",
		reportPage:"PostUpdateReportPageEntityRelationInput",
		content:"PostUpdateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostUpdateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostUpdateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostUpdateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostUpdateFundraisingProgressEntityRelationInput"
	},
	PostUpdateActiveRevisionEntityRelationInput:{
		connect:"PostRevisionUniqueWhere",
		create:"PostRevisionCreateInput",
		connectOrCreate:"PostConnectOrCreateActiveRevisionRelationInput",
		update:"PostRevisionUpdateInput",
		upsert:"PostUpsertActiveRevisionRelationInput"
	},
	PostRevisionUpdateInput:{
		createdAt:"DateTime",
		createdById:"UUID",
		publishedById:"UUID",
		type:"PostType",
		publishedAt:"DateTime",
		post:"PostRevisionUpdatePostEntityRelationInput",
		tileImage:"PostRevisionUpdateTileImageEntityRelationInput",
		tileVideo:"PostRevisionUpdateTileVideoEntityRelationInput",
		heroImage:"PostRevisionUpdateHeroImageEntityRelationInput",
		locales:"PostRevisionUpdateLocalesEntityRelationInput",
		regionListOverride:"PostRevisionUpdateRegionListOverrideEntityRelationInput"
	},
	PostRevisionUpdateTileImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateTileImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostRevisionUpsertTileImageRelationInput"
	},
	PostRevisionUpsertTileImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostRevisionUpdateTileVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateTileVideoRelationInput",
		update:"VideoUpdateInput",
		upsert:"PostRevisionUpsertTileVideoRelationInput"
	},
	PostRevisionUpsertTileVideoRelationInput:{
		update:"VideoUpdateInput",
		create:"VideoCreateInput"
	},
	PostRevisionUpdateHeroImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateHeroImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostRevisionUpsertHeroImageRelationInput"
	},
	PostRevisionUpsertHeroImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostRevisionUpdateLocalesEntityRelationInput:{
		create:"PostRevisionLocaleWithoutRootCreateInput",
		update:"PostRevisionUpdateLocalesRelationInput",
		upsert:"PostRevisionUpsertLocalesRelationInput",
		connect:"PostRevisionLocaleUniqueWhere",
		disconnect:"PostRevisionLocaleUniqueWhere",
		delete:"PostRevisionLocaleUniqueWhere"
	},
	PostRevisionUpdateLocalesRelationInput:{
		by:"PostRevisionLocaleUniqueWhere",
		data:"PostRevisionLocaleWithoutRootUpdateInput"
	},
	PostRevisionLocaleWithoutRootUpdateInput:{
		locale:"PostRevisionLocaleUpdateLocaleEntityRelationInput",
		content:"PostRevisionLocaleUpdateContentEntityRelationInput",
		seo:"PostRevisionLocaleUpdateSeoEntityRelationInput",
		leadContent:"PostRevisionLocaleUpdateLeadContentEntityRelationInput"
	},
	PostRevisionLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostRevisionsCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutPostRevisionsUpdateInput",
		upsert:"PostRevisionLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutPostRevisionsUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdateFlagImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"LocaleConnectOrCreateFlagImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"LocaleUpsertFlagImageRelationInput"
	},
	LocaleUpsertFlagImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	LocaleUpdateFeedPagesEntityRelationInput:{
		create:"FeedPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateFeedPagesRelationInput",
		upsert:"LocaleUpsertFeedPagesRelationInput",
		connect:"FeedPageLocaleUniqueWhere",
		disconnect:"FeedPageLocaleUniqueWhere",
		delete:"FeedPageLocaleUniqueWhere"
	},
	LocaleUpdateFeedPagesRelationInput:{
		by:"FeedPageLocaleUniqueWhere",
		data:"FeedPageLocaleWithoutLocaleUpdateInput"
	},
	FeedPageLocaleWithoutLocaleUpdateInput:{
		root:"FeedPageLocaleUpdateRootEntityRelationInput",
		heroTiles:"FeedPageLocaleUpdateHeroTilesEntityRelationInput",
		sectionList:"FeedPageLocaleUpdateSectionListEntityRelationInput",
		cardList:"FeedPageLocaleUpdateCardListEntityRelationInput",
		storyGuideList:"FeedPageLocaleUpdateStoryGuideListEntityRelationInput"
	},
	FeedPageLocaleUpdateRootEntityRelationInput:{
		connect:"FeedPageUniqueWhere",
		create:"FeedPageWithoutLocalesCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateRootRelationInput",
		update:"FeedPageWithoutLocalesUpdateInput",
		upsert:"FeedPageLocaleUpsertRootRelationInput"
	},
	FeedPageWithoutLocalesUpdateInput:{
		unique:"One"
	},
	FeedPageLocaleUpsertRootRelationInput:{
		update:"FeedPageWithoutLocalesUpdateInput",
		create:"FeedPageWithoutLocalesCreateInput"
	},
	FeedPageLocaleUpdateHeroTilesEntityRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateHeroTilesRelationInput",
		update:"TileListUpdateInput",
		upsert:"FeedPageLocaleUpsertHeroTilesRelationInput"
	},
	TileListUpdateInput:{
		size:"TileListSize",
		items:"TileListUpdateItemsEntityRelationInput",
		areaType:"TileListUpdateAreaTypeEntityRelationInput"
	},
	TileListUpdateItemsEntityRelationInput:{
		create:"TileItemWithoutListCreateInput",
		update:"TileListUpdateItemsRelationInput",
		upsert:"TileListUpsertItemsRelationInput",
		connect:"TileItemUniqueWhere",
		disconnect:"TileItemUniqueWhere",
		delete:"TileItemUniqueWhere"
	},
	TileListUpdateItemsRelationInput:{
		by:"TileItemUniqueWhere",
		data:"TileItemWithoutListUpdateInput"
	},
	TileItemWithoutListUpdateInput:{
		type:"TileItemType",
		post:"TileItemUpdatePostEntityRelationInput",
		area:"TileItemUpdateAreaEntityRelationInput",
		image:"TileItemUpdateImageEntityRelationInput",
		link:"TileItemUpdateLinkEntityRelationInput",
		organization:"TileItemUpdateOrganizationEntityRelationInput"
	},
	TileItemUpdatePostEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput",
		connectOrCreate:"TileItemConnectOrCreatePostRelationInput",
		update:"PostUpdateInput",
		upsert:"TileItemUpsertPostRelationInput"
	},
	PostUpdateInput:{
		organization:"PostUpdateOrganizationEntityRelationInput",
		area:"PostUpdateAreaEntityRelationInput",
		activeRevision:"PostUpdateActiveRevisionEntityRelationInput",
		revisions:"PostUpdateRevisionsEntityRelationInput",
		locales:"PostUpdateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostUpdateMetaEntityRelationInput",
		heroCarousel:"PostUpdateHeroCarouselEntityRelationInput",
		reportPage:"PostUpdateReportPageEntityRelationInput",
		content:"PostUpdateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostUpdateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostUpdateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostUpdateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostUpdateFundraisingProgressEntityRelationInput"
	},
	PostUpdateRevisionsEntityRelationInput:{
		create:"PostRevisionWithoutPostCreateInput",
		update:"PostUpdateRevisionsRelationInput",
		upsert:"PostUpsertRevisionsRelationInput",
		connect:"PostRevisionUniqueWhere",
		disconnect:"PostRevisionUniqueWhere",
		delete:"PostRevisionUniqueWhere"
	},
	PostUpdateRevisionsRelationInput:{
		by:"PostRevisionUniqueWhere",
		data:"PostRevisionWithoutPostUpdateInput"
	},
	PostRevisionWithoutPostUpdateInput:{
		createdAt:"DateTime",
		createdById:"UUID",
		publishedById:"UUID",
		type:"PostType",
		publishedAt:"DateTime",
		tileImage:"PostRevisionUpdateTileImageEntityRelationInput",
		tileVideo:"PostRevisionUpdateTileVideoEntityRelationInput",
		heroImage:"PostRevisionUpdateHeroImageEntityRelationInput",
		locales:"PostRevisionUpdateLocalesEntityRelationInput",
		regionListOverride:"PostRevisionUpdateRegionListOverrideEntityRelationInput"
	},
	PostRevisionUpdateRegionListOverrideEntityRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListCreateInput",
		connectOrCreate:"PostRevisionConnectOrCreateRegionListOverrideRelationInput",
		update:"DonationAmountsRegionListUpdateInput",
		upsert:"PostRevisionUpsertRegionListOverrideRelationInput"
	},
	PostRevisionUpsertRegionListOverrideRelationInput:{
		update:"DonationAmountsRegionListUpdateInput",
		create:"DonationAmountsRegionListCreateInput"
	},
	PostUpsertRevisionsRelationInput:{
		by:"PostRevisionUniqueWhere",
		update:"PostRevisionWithoutPostUpdateInput",
		create:"PostRevisionWithoutPostCreateInput"
	},
	PostUpdateLocalesEntityRelationInput:{
		create:"PostLocaleWithoutRootCreateInput",
		update:"PostUpdateLocalesRelationInput",
		upsert:"PostUpsertLocalesRelationInput",
		connect:"PostLocaleUniqueWhere",
		disconnect:"PostLocaleUniqueWhere",
		delete:"PostLocaleUniqueWhere"
	},
	PostUpdateLocalesRelationInput:{
		by:"PostLocaleUniqueWhere",
		data:"PostLocaleWithoutRootUpdateInput"
	},
	PostLocaleWithoutRootUpdateInput:{
		content:"PostLocaleUpdateContentEntityRelationInput",
		seo:"PostLocaleUpdateSeoEntityRelationInput",
		link:"PostLocaleUpdateLinkEntityRelationInput",
		locale:"PostLocaleUpdateLocaleEntityRelationInput",
		publishedAt:"DateTime"
	},
	PostLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPostCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutPostUpdateInput",
		upsert:"PostLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutPostUpdateInput:{
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		postArea:"LinkableUpdatePostAreaEntityRelationInput",
		postOrganization:"LinkableUpdatePostOrganizationEntityRelationInput",
		reportPage:"LinkableUpdateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableUpdateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableUpdateReceivedGiftsPageEntityRelationInput"
	},
	LinkableUpdatePostOrganizationEntityRelationInput:{
		connect:"PostOrganizationLocaleUniqueWhere",
		create:"PostOrganizationLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreatePostOrganizationRelationInput",
		update:"PostOrganizationLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertPostOrganizationRelationInput"
	},
	PostOrganizationLocaleWithoutLinkUpdateInput:{
		root:"PostOrganizationLocaleUpdateRootEntityRelationInput",
		locale:"PostOrganizationLocaleUpdateLocaleEntityRelationInput",
		domain:"PostOrganizationLocaleUpdateDomainEntityRelationInput",
		seo:"PostOrganizationLocaleUpdateSeoEntityRelationInput",
		content:"PostOrganizationLocaleUpdateContentEntityRelationInput"
	},
	PostOrganizationLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPostOrganizationsCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutPostOrganizationsUpdateInput",
		upsert:"PostOrganizationLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutPostOrganizationsUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdateRecurringPaymentPagesEntityRelationInput:{
		create:"RecurringPaymentPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateRecurringPaymentPagesRelationInput",
		upsert:"LocaleUpsertRecurringPaymentPagesRelationInput",
		connect:"RecurringPaymentPageLocaleUniqueWhere",
		disconnect:"RecurringPaymentPageLocaleUniqueWhere",
		delete:"RecurringPaymentPageLocaleUniqueWhere"
	},
	LocaleUpdateRecurringPaymentPagesRelationInput:{
		by:"RecurringPaymentPageLocaleUniqueWhere",
		data:"RecurringPaymentPageLocaleWithoutLocaleUpdateInput"
	},
	RecurringPaymentPageLocaleWithoutLocaleUpdateInput:{
		root:"RecurringPaymentPageLocaleUpdateRootEntityRelationInput",
		favouritePosts:"RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput",
		storyGuideList:"RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"
	},
	RecurringPaymentPageLocaleUpdateRootEntityRelationInput:{
		connect:"RecurringPaymentPageUniqueWhere",
		create:"RecurringPaymentPageWithoutLocalesCreateInput",
		connectOrCreate:"RecurringPaymentPageLocaleConnectOrCreateRootRelationInput",
		update:"RecurringPaymentPageWithoutLocalesUpdateInput",
		upsert:"RecurringPaymentPageLocaleUpsertRootRelationInput"
	},
	RecurringPaymentPageWithoutLocalesUpdateInput:{
		unique:"One"
	},
	RecurringPaymentPageLocaleUpsertRootRelationInput:{
		update:"RecurringPaymentPageWithoutLocalesUpdateInput",
		create:"RecurringPaymentPageWithoutLocalesCreateInput"
	},
	RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput:{
		connect:"PostListUniqueWhere",
		create:"PostListCreateInput",
		connectOrCreate:"RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput",
		update:"PostListUpdateInput",
		upsert:"RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"
	},
	PostListUpdateInput:{
		items:"PostListUpdateItemsEntityRelationInput"
	},
	PostListUpdateItemsEntityRelationInput:{
		create:"PostListItemWithoutListCreateInput",
		update:"PostListUpdateItemsRelationInput",
		upsert:"PostListUpsertItemsRelationInput",
		connect:"PostListItemUniqueWhere",
		disconnect:"PostListItemUniqueWhere",
		delete:"PostListItemUniqueWhere"
	},
	PostListUpdateItemsRelationInput:{
		by:"PostListItemUniqueWhere",
		data:"PostListItemWithoutListUpdateInput"
	},
	PostListItemWithoutListUpdateInput:{
		post:"PostListItemUpdatePostEntityRelationInput"
	},
	PostListItemUpdatePostEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput",
		connectOrCreate:"PostListItemConnectOrCreatePostRelationInput",
		update:"PostUpdateInput",
		upsert:"PostListItemUpsertPostRelationInput"
	},
	PostListItemUpsertPostRelationInput:{
		update:"PostUpdateInput",
		create:"PostCreateInput"
	},
	PostListUpsertItemsRelationInput:{
		by:"PostListItemUniqueWhere",
		update:"PostListItemWithoutListUpdateInput",
		create:"PostListItemWithoutListCreateInput"
	},
	RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput:{
		update:"PostListUpdateInput",
		create:"PostListCreateInput"
	},
	RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListCreateInput",
		connectOrCreate:"RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput",
		update:"StoryGuideListUpdateInput",
		upsert:"RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"
	},
	StoryGuideListUpdateInput:{
		items:"StoryGuideListUpdateItemsEntityRelationInput"
	},
	StoryGuideListUpdateItemsEntityRelationInput:{
		create:"StoryGuideItemWithoutListCreateInput",
		update:"StoryGuideListUpdateItemsRelationInput",
		upsert:"StoryGuideListUpsertItemsRelationInput",
		connect:"StoryGuideItemUniqueWhere",
		disconnect:"StoryGuideItemUniqueWhere",
		delete:"StoryGuideItemUniqueWhere"
	},
	StoryGuideListUpdateItemsRelationInput:{
		by:"StoryGuideItemUniqueWhere",
		data:"StoryGuideItemWithoutListUpdateInput"
	},
	StoryGuideItemWithoutListUpdateInput:{
		guide:"StoryGuideItemUpdateGuideEntityRelationInput"
	},
	StoryGuideItemUpdateGuideEntityRelationInput:{
		connect:"StoryGuideUniqueWhere",
		create:"StoryGuideCreateInput",
		connectOrCreate:"StoryGuideItemConnectOrCreateGuideRelationInput",
		update:"StoryGuideUpdateInput",
		upsert:"StoryGuideItemUpsertGuideRelationInput"
	},
	StoryGuideUpdateInput:{
		mediaType:"MediaType",
		image:"StoryGuideUpdateImageEntityRelationInput",
		secondaryImage:"StoryGuideUpdateSecondaryImageEntityRelationInput"
	},
	StoryGuideUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"StoryGuideConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"StoryGuideUpsertImageRelationInput"
	},
	StoryGuideUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	StoryGuideUpdateSecondaryImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"StoryGuideConnectOrCreateSecondaryImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"StoryGuideUpsertSecondaryImageRelationInput"
	},
	StoryGuideUpsertSecondaryImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	StoryGuideItemUpsertGuideRelationInput:{
		update:"StoryGuideUpdateInput",
		create:"StoryGuideCreateInput"
	},
	StoryGuideListUpsertItemsRelationInput:{
		by:"StoryGuideItemUniqueWhere",
		update:"StoryGuideItemWithoutListUpdateInput",
		create:"StoryGuideItemWithoutListCreateInput"
	},
	RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput:{
		update:"StoryGuideListUpdateInput",
		create:"StoryGuideListCreateInput"
	},
	LocaleUpsertRecurringPaymentPagesRelationInput:{
		by:"RecurringPaymentPageLocaleUniqueWhere",
		update:"RecurringPaymentPageLocaleWithoutLocaleUpdateInput",
		create:"RecurringPaymentPageLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateGivenGiftsPagesEntityRelationInput:{
		create:"GivenGiftsPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateGivenGiftsPagesRelationInput",
		upsert:"LocaleUpsertGivenGiftsPagesRelationInput",
		connect:"GivenGiftsPageLocaleUniqueWhere",
		disconnect:"GivenGiftsPageLocaleUniqueWhere",
		delete:"GivenGiftsPageLocaleUniqueWhere"
	},
	LocaleUpdateGivenGiftsPagesRelationInput:{
		by:"GivenGiftsPageLocaleUniqueWhere",
		data:"GivenGiftsPageLocaleWithoutLocaleUpdateInput"
	},
	GivenGiftsPageLocaleWithoutLocaleUpdateInput:{
		root:"GivenGiftsPageLocaleUpdateRootEntityRelationInput",
		content:"GivenGiftsPageLocaleUpdateContentEntityRelationInput",
		seo:"GivenGiftsPageLocaleUpdateSeoEntityRelationInput",
		link:"GivenGiftsPageLocaleUpdateLinkEntityRelationInput"
	},
	GivenGiftsPageLocaleUpdateRootEntityRelationInput:{
		connect:"GivenGiftsPageUniqueWhere",
		create:"GivenGiftsPageWithoutLocalesCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateRootRelationInput",
		update:"GivenGiftsPageWithoutLocalesUpdateInput",
		upsert:"GivenGiftsPageLocaleUpsertRootRelationInput"
	},
	GivenGiftsPageWithoutLocalesUpdateInput:{
		unique:"One"
	},
	GivenGiftsPageLocaleUpsertRootRelationInput:{
		update:"GivenGiftsPageWithoutLocalesUpdateInput",
		create:"GivenGiftsPageWithoutLocalesCreateInput"
	},
	GivenGiftsPageLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"GivenGiftsPageLocaleUpsertContentRelationInput"
	},
	GivenGiftsPageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	GivenGiftsPageLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"GivenGiftsPageLocaleUpsertSeoRelationInput"
	},
	GivenGiftsPageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	GivenGiftsPageLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGivenGiftsPageCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutGivenGiftsPageUpdateInput",
		upsert:"GivenGiftsPageLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutGivenGiftsPageUpdateInput:{
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		post:"LinkableUpdatePostEntityRelationInput",
		postArea:"LinkableUpdatePostAreaEntityRelationInput",
		postOrganization:"LinkableUpdatePostOrganizationEntityRelationInput",
		reportPage:"LinkableUpdateReportPageEntityRelationInput",
		receivedGiftsPage:"LinkableUpdateReceivedGiftsPageEntityRelationInput"
	},
	LinkableUpdateReportPageEntityRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateReportPageRelationInput",
		update:"ReportPageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertReportPageRelationInput"
	},
	ReportPageLocaleWithoutLinkUpdateInput:{
		root:"ReportPageLocaleUpdateRootEntityRelationInput",
		locale:"ReportPageLocaleUpdateLocaleEntityRelationInput",
		content:"ReportPageLocaleUpdateContentEntityRelationInput",
		seo:"ReportPageLocaleUpdateSeoEntityRelationInput",
		posts:"ReportPageLocaleUpdatePostsEntityRelationInput"
	},
	ReportPageLocaleUpdateRootEntityRelationInput:{
		connect:"ReportPageUniqueWhere",
		create:"ReportPageWithoutLocalesCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateRootRelationInput",
		update:"ReportPageWithoutLocalesUpdateInput",
		upsert:"ReportPageLocaleUpsertRootRelationInput"
	},
	ReportPageWithoutLocalesUpdateInput:{
		unique:"One"
	},
	ReportPageLocaleUpsertRootRelationInput:{
		update:"ReportPageWithoutLocalesUpdateInput",
		create:"ReportPageWithoutLocalesCreateInput"
	},
	ReportPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReportPagesCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutReportPagesUpdateInput",
		upsert:"ReportPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutReportPagesUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdateReceivedGiftsPagesEntityRelationInput:{
		create:"ReceivedGiftsPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateReceivedGiftsPagesRelationInput",
		upsert:"LocaleUpsertReceivedGiftsPagesRelationInput",
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		disconnect:"ReceivedGiftsPageLocaleUniqueWhere",
		delete:"ReceivedGiftsPageLocaleUniqueWhere"
	},
	LocaleUpdateReceivedGiftsPagesRelationInput:{
		by:"ReceivedGiftsPageLocaleUniqueWhere",
		data:"ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"
	},
	ReceivedGiftsPageLocaleWithoutLocaleUpdateInput:{
		link:"ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput",
		root:"ReceivedGiftsPageLocaleUpdateRootEntityRelationInput",
		content:"ReceivedGiftsPageLocaleUpdateContentEntityRelationInput",
		seo:"ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"
	},
	ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutReceivedGiftsPageCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutReceivedGiftsPageUpdateInput",
		upsert:"ReceivedGiftsPageLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutReceivedGiftsPageUpdateInput:{
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		post:"LinkableUpdatePostEntityRelationInput",
		postArea:"LinkableUpdatePostAreaEntityRelationInput",
		postOrganization:"LinkableUpdatePostOrganizationEntityRelationInput",
		reportPage:"LinkableUpdateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableUpdateGivenGiftsPageEntityRelationInput"
	},
	LinkableUpdateGivenGiftsPageEntityRelationInput:{
		connect:"GivenGiftsPageLocaleUniqueWhere",
		create:"GivenGiftsPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateGivenGiftsPageRelationInput",
		update:"GivenGiftsPageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertGivenGiftsPageRelationInput"
	},
	GivenGiftsPageLocaleWithoutLinkUpdateInput:{
		root:"GivenGiftsPageLocaleUpdateRootEntityRelationInput",
		locale:"GivenGiftsPageLocaleUpdateLocaleEntityRelationInput",
		content:"GivenGiftsPageLocaleUpdateContentEntityRelationInput",
		seo:"GivenGiftsPageLocaleUpdateSeoEntityRelationInput"
	},
	GivenGiftsPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGivenGiftsPagesCreateInput",
		connectOrCreate:"GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutGivenGiftsPagesUpdateInput",
		upsert:"GivenGiftsPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutGivenGiftsPagesUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdateReportPagesEntityRelationInput:{
		create:"ReportPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateReportPagesRelationInput",
		upsert:"LocaleUpsertReportPagesRelationInput",
		connect:"ReportPageLocaleUniqueWhere",
		disconnect:"ReportPageLocaleUniqueWhere",
		delete:"ReportPageLocaleUniqueWhere"
	},
	LocaleUpdateReportPagesRelationInput:{
		by:"ReportPageLocaleUniqueWhere",
		data:"ReportPageLocaleWithoutLocaleUpdateInput"
	},
	ReportPageLocaleWithoutLocaleUpdateInput:{
		link:"ReportPageLocaleUpdateLinkEntityRelationInput",
		root:"ReportPageLocaleUpdateRootEntityRelationInput",
		content:"ReportPageLocaleUpdateContentEntityRelationInput",
		seo:"ReportPageLocaleUpdateSeoEntityRelationInput",
		posts:"ReportPageLocaleUpdatePostsEntityRelationInput"
	},
	ReportPageLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutReportPageCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutReportPageUpdateInput",
		upsert:"ReportPageLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutReportPageUpdateInput:{
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		post:"LinkableUpdatePostEntityRelationInput",
		postArea:"LinkableUpdatePostAreaEntityRelationInput",
		postOrganization:"LinkableUpdatePostOrganizationEntityRelationInput",
		givenGiftsPage:"LinkableUpdateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableUpdateReceivedGiftsPageEntityRelationInput"
	},
	LinkableUpdateReceivedGiftsPageEntityRelationInput:{
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		create:"ReceivedGiftsPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateReceivedGiftsPageRelationInput",
		update:"ReceivedGiftsPageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertReceivedGiftsPageRelationInput"
	},
	ReceivedGiftsPageLocaleWithoutLinkUpdateInput:{
		root:"ReceivedGiftsPageLocaleUpdateRootEntityRelationInput",
		locale:"ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput",
		content:"ReceivedGiftsPageLocaleUpdateContentEntityRelationInput",
		seo:"ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"
	},
	ReceivedGiftsPageLocaleUpdateRootEntityRelationInput:{
		connect:"ReceivedGiftsPageUniqueWhere",
		create:"ReceivedGiftsPageWithoutLocalesCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput",
		update:"ReceivedGiftsPageWithoutLocalesUpdateInput",
		upsert:"ReceivedGiftsPageLocaleUpsertRootRelationInput"
	},
	ReceivedGiftsPageWithoutLocalesUpdateInput:{
		unique:"One"
	},
	ReceivedGiftsPageLocaleUpsertRootRelationInput:{
		update:"ReceivedGiftsPageWithoutLocalesUpdateInput",
		create:"ReceivedGiftsPageWithoutLocalesCreateInput"
	},
	ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutReceivedGiftsPagesCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutReceivedGiftsPagesUpdateInput",
		upsert:"ReceivedGiftsPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutReceivedGiftsPagesUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdateReportNavigationsEntityRelationInput:{
		create:"ReportNavigationLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateReportNavigationsRelationInput",
		upsert:"LocaleUpsertReportNavigationsRelationInput",
		connect:"ReportNavigationLocaleUniqueWhere",
		disconnect:"ReportNavigationLocaleUniqueWhere",
		delete:"ReportNavigationLocaleUniqueWhere"
	},
	LocaleUpdateReportNavigationsRelationInput:{
		by:"ReportNavigationLocaleUniqueWhere",
		data:"ReportNavigationLocaleWithoutLocaleUpdateInput"
	},
	ReportNavigationLocaleWithoutLocaleUpdateInput:{
		root:"ReportNavigationLocaleUpdateRootEntityRelationInput",
		pages:"ReportNavigationLocaleUpdatePagesEntityRelationInput"
	},
	ReportNavigationLocaleUpdatePagesEntityRelationInput:{
		create:"GenericPageWithoutReportNavigationCreateInput",
		update:"ReportNavigationLocaleUpdatePagesRelationInput",
		upsert:"ReportNavigationLocaleUpsertPagesRelationInput",
		connect:"GenericPageUniqueWhere",
		disconnect:"GenericPageUniqueWhere",
		delete:"GenericPageUniqueWhere"
	},
	ReportNavigationLocaleUpdatePagesRelationInput:{
		by:"GenericPageUniqueWhere",
		data:"GenericPageWithoutReportNavigationUpdateInput"
	},
	GenericPageWithoutReportNavigationUpdateInput:{
		locales:"GenericPageUpdateLocalesEntityRelationInput",
		type:"GenericPageType"
	},
	GenericPageUpdateLocalesEntityRelationInput:{
		create:"GenericPageLocaleWithoutRootCreateInput",
		update:"GenericPageUpdateLocalesRelationInput",
		upsert:"GenericPageUpsertLocalesRelationInput",
		connect:"GenericPageLocaleUniqueWhere",
		disconnect:"GenericPageLocaleUniqueWhere",
		delete:"GenericPageLocaleUniqueWhere"
	},
	GenericPageUpdateLocalesRelationInput:{
		by:"GenericPageLocaleUniqueWhere",
		data:"GenericPageLocaleWithoutRootUpdateInput"
	},
	GenericPageLocaleWithoutRootUpdateInput:{
		locale:"GenericPageLocaleUpdateLocaleEntityRelationInput",
		content:"GenericPageLocaleUpdateContentEntityRelationInput",
		seo:"GenericPageLocaleUpdateSeoEntityRelationInput",
		link:"GenericPageLocaleUpdateLinkEntityRelationInput"
	},
	GenericPageLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"GenericPageLocaleUpsertContentRelationInput"
	},
	GenericPageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	GenericPageLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"GenericPageLocaleUpsertSeoRelationInput"
	},
	GenericPageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	GenericPageLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGenericPageCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutGenericPageUpdateInput",
		upsert:"GenericPageLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutGenericPageUpdateInput:{
		post:"LinkableUpdatePostEntityRelationInput",
		postArea:"LinkableUpdatePostAreaEntityRelationInput",
		postOrganization:"LinkableUpdatePostOrganizationEntityRelationInput",
		reportPage:"LinkableUpdateReportPageEntityRelationInput",
		givenGiftsPage:"LinkableUpdateGivenGiftsPageEntityRelationInput",
		receivedGiftsPage:"LinkableUpdateReceivedGiftsPageEntityRelationInput"
	},
	GenericPageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutGenericPageUpdateInput",
		create:"LinkableWithoutGenericPageCreateInput"
	},
	GenericPageUpsertLocalesRelationInput:{
		by:"GenericPageLocaleUniqueWhere",
		update:"GenericPageLocaleWithoutRootUpdateInput",
		create:"GenericPageLocaleWithoutRootCreateInput"
	},
	ReportNavigationLocaleUpsertPagesRelationInput:{
		by:"GenericPageUniqueWhere",
		update:"GenericPageWithoutReportNavigationUpdateInput",
		create:"GenericPageWithoutReportNavigationCreateInput"
	},
	LocaleUpsertReportNavigationsRelationInput:{
		by:"ReportNavigationLocaleUniqueWhere",
		update:"ReportNavigationLocaleWithoutLocaleUpdateInput",
		create:"ReportNavigationLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateScheduledNotificationsEntityRelationInput:{
		create:"ScheduledNotificationLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateScheduledNotificationsRelationInput",
		upsert:"LocaleUpsertScheduledNotificationsRelationInput",
		connect:"ScheduledNotificationLocaleUniqueWhere",
		disconnect:"ScheduledNotificationLocaleUniqueWhere",
		delete:"ScheduledNotificationLocaleUniqueWhere"
	},
	LocaleUpdateScheduledNotificationsRelationInput:{
		by:"ScheduledNotificationLocaleUniqueWhere",
		data:"ScheduledNotificationLocaleWithoutLocaleUpdateInput"
	},
	ScheduledNotificationLocaleWithoutLocaleUpdateInput:{
		root:"ScheduledNotificationLocaleUpdateRootEntityRelationInput"
	},
	ScheduledNotificationLocaleUpdateRootEntityRelationInput:{
		connect:"ScheduledNotificationUniqueWhere",
		create:"ScheduledNotificationWithoutLocalesCreateInput",
		connectOrCreate:"ScheduledNotificationLocaleConnectOrCreateRootRelationInput",
		update:"ScheduledNotificationWithoutLocalesUpdateInput",
		upsert:"ScheduledNotificationLocaleUpsertRootRelationInput"
	},
	ScheduledNotificationWithoutLocalesUpdateInput:{
		scheduledDate:"Date",
		target:"ScheduledNotificationUpdateTargetEntityRelationInput",
		image:"ScheduledNotificationUpdateImageEntityRelationInput",
		completedAt:"DateTime",
		processedNotifications:"ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"
	},
	ScheduledNotificationUpdateTargetEntityRelationInput:{
		connect:"NotificationTargetGroupUniqueWhere",
		create:"NotificationTargetGroupCreateInput",
		connectOrCreate:"ScheduledNotificationConnectOrCreateTargetRelationInput",
		update:"NotificationTargetGroupUpdateInput",
		upsert:"ScheduledNotificationUpsertTargetRelationInput"
	},
	NotificationTargetGroupUpdateInput:{
		type:"NotificationTargetType",
		regions:"NotificationTargetGroupUpdateRegionsEntityRelationInput"
	},
	NotificationTargetGroupUpdateRegionsEntityRelationInput:{
		create:"RegionCreateInput",
		update:"NotificationTargetGroupUpdateRegionsRelationInput",
		upsert:"NotificationTargetGroupUpsertRegionsRelationInput",
		connect:"RegionUniqueWhere",
		disconnect:"RegionUniqueWhere",
		delete:"RegionUniqueWhere"
	},
	NotificationTargetGroupUpdateRegionsRelationInput:{
		by:"RegionUniqueWhere",
		data:"RegionUpdateInput"
	},
	NotificationTargetGroupUpsertRegionsRelationInput:{
		by:"RegionUniqueWhere",
		update:"RegionUpdateInput",
		create:"RegionCreateInput"
	},
	ScheduledNotificationUpsertTargetRelationInput:{
		update:"NotificationTargetGroupUpdateInput",
		create:"NotificationTargetGroupCreateInput"
	},
	ScheduledNotificationUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ScheduledNotificationConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"ScheduledNotificationUpsertImageRelationInput"
	},
	ScheduledNotificationUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput:{
		create:"ProcessedNotificationSourceWithoutScheduledNotificationCreateInput",
		update:"ScheduledNotificationUpdateProcessedNotificationsRelationInput",
		upsert:"ScheduledNotificationUpsertProcessedNotificationsRelationInput",
		connect:"ProcessedNotificationSourceUniqueWhere",
		disconnect:"ProcessedNotificationSourceUniqueWhere",
		delete:"ProcessedNotificationSourceUniqueWhere"
	},
	ScheduledNotificationUpdateProcessedNotificationsRelationInput:{
		by:"ProcessedNotificationSourceUniqueWhere",
		data:"ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"
	},
	ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput:{
		type:"ProcessedNotificationSourceType",
		processedNotification:"ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput",
		donationReminderUser:"ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"
	},
	ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput:{
		connect:"ProcessedNotificationUniqueWhere",
		create:"ProcessedNotificationWithoutSourceCreateInput",
		connectOrCreate:"ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput",
		update:"ProcessedNotificationWithoutSourceUpdateInput",
		upsert:"ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"
	},
	ProcessedNotificationWithoutSourceUpdateInput:{
		sentAt:"DateTime"
	},
	ProcessedNotificationSourceUpsertProcessedNotificationRelationInput:{
		update:"ProcessedNotificationWithoutSourceUpdateInput",
		create:"ProcessedNotificationWithoutSourceCreateInput"
	},
	ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutProcessedNotificationsCreateInput",
		connectOrCreate:"ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput",
		update:"UserWithoutProcessedNotificationsUpdateInput",
		upsert:"ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"
	},
	UserWithoutProcessedNotificationsUpdateInput:{
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserUpdatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserUpdateRegionEntityRelationInput",
		currency:"UserUpdateCurrencyEntityRelationInput",
		recurringPayments:"UserUpdateRecurringPaymentsEntityRelationInput",
		onBehalfDonations:"UserUpdateOnBehalfDonationsEntityRelationInput",
		locale:"UserUpdateLocaleEntityRelationInput",
		devices:"UserUpdateDevicesEntityRelationInput",
		areaStats:"UserUpdateAreaStatsEntityRelationInput",
		organizationStats:"UserUpdateOrganizationStatsEntityRelationInput",
		postStats:"UserUpdatePostStatsEntityRelationInput",
		currencyStats:"UserUpdateCurrencyStatsEntityRelationInput"
	},
	UserUpdatePaymentsEntityRelationInput:{
		create:"UserPaymentWithoutUserCreateInput",
		update:"UserUpdatePaymentsRelationInput",
		upsert:"UserUpsertPaymentsRelationInput",
		connect:"UserPaymentUniqueWhere",
		disconnect:"UserPaymentUniqueWhere",
		delete:"UserPaymentUniqueWhere"
	},
	UserUpdatePaymentsRelationInput:{
		by:"UserPaymentUniqueWhere",
		data:"UserPaymentWithoutUserUpdateInput"
	},
	UserPaymentWithoutUserUpdateInput:{
		createdAt:"DateTime",
		currency:"UserPaymentUpdateCurrencyEntityRelationInput",
		order:"UserPaymentUpdateOrderEntityRelationInput",
		csobPayment:"UserPaymentUpdateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentUpdateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentUpdateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentUpdateRegionEntityRelationInput",
		onBehalfDonation:"UserPaymentUpdateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentUpdateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentUpdateMetadataEntityRelationInput"
	},
	UserPaymentUpdateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateCurrencyRelationInput",
		update:"CurrencyUpdateInput",
		upsert:"UserPaymentUpsertCurrencyRelationInput"
	},
	UserPaymentUpsertCurrencyRelationInput:{
		update:"CurrencyUpdateInput",
		create:"CurrencyCreateInput"
	},
	UserPaymentUpdateOrderEntityRelationInput:{
		connect:"UserPaymentOrderIdUniqueWhere",
		create:"UserPaymentOrderIdCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateOrderRelationInput",
		update:"UserPaymentOrderIdUpdateInput",
		upsert:"UserPaymentUpsertOrderRelationInput"
	},
	UserPaymentOrderIdUpdateInput:{

	},
	UserPaymentUpsertOrderRelationInput:{
		update:"UserPaymentOrderIdUpdateInput",
		create:"UserPaymentOrderIdCreateInput"
	},
	UserPaymentUpdateCsobPaymentEntityRelationInput:{
		connect:"CsobPaymentUniqueWhere",
		create:"CsobPaymentWithoutPaymentCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateCsobPaymentRelationInput",
		update:"CsobPaymentWithoutPaymentUpdateInput",
		upsert:"UserPaymentUpsertCsobPaymentRelationInput"
	},
	CsobPaymentWithoutPaymentUpdateInput:{
		statusChanges:"CsobPaymentUpdateStatusChangesEntityRelationInput",
		metadata:"CsobPaymentUpdateMetadataEntityRelationInput"
	},
	CsobPaymentUpdateStatusChangesEntityRelationInput:{
		create:"CsobPaymentStatusChangeWithoutPaymentCreateInput",
		update:"CsobPaymentUpdateStatusChangesRelationInput",
		upsert:"CsobPaymentUpsertStatusChangesRelationInput",
		connect:"CsobPaymentStatusChangeUniqueWhere",
		disconnect:"CsobPaymentStatusChangeUniqueWhere",
		delete:"CsobPaymentStatusChangeUniqueWhere"
	},
	CsobPaymentUpdateStatusChangesRelationInput:{
		by:"CsobPaymentStatusChangeUniqueWhere",
		data:"CsobPaymentStatusChangeWithoutPaymentUpdateInput"
	},
	CsobPaymentStatusChangeWithoutPaymentUpdateInput:{
		createdAt:"DateTime"
	},
	CsobPaymentUpsertStatusChangesRelationInput:{
		by:"CsobPaymentStatusChangeUniqueWhere",
		update:"CsobPaymentStatusChangeWithoutPaymentUpdateInput",
		create:"CsobPaymentStatusChangeWithoutPaymentCreateInput"
	},
	CsobPaymentUpdateMetadataEntityRelationInput:{
		connect:"CsobPaymentMetadataUniqueWhere"
	},
	UserPaymentUpsertCsobPaymentRelationInput:{
		update:"CsobPaymentWithoutPaymentUpdateInput",
		create:"CsobPaymentWithoutPaymentCreateInput"
	},
	UserPaymentUpdateStripePaymentEntityRelationInput:{
		connect:"StripePaymentUniqueWhere",
		create:"StripePaymentWithoutPaymentCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateStripePaymentRelationInput",
		update:"StripePaymentWithoutPaymentUpdateInput",
		upsert:"UserPaymentUpsertStripePaymentRelationInput"
	},
	StripePaymentWithoutPaymentUpdateInput:{
		statusChanges:"StripePaymentUpdateStatusChangesEntityRelationInput",
		metadata:"StripePaymentUpdateMetadataEntityRelationInput"
	},
	StripePaymentUpdateStatusChangesEntityRelationInput:{
		create:"StripePaymentStatusChangeWithoutPaymentCreateInput",
		update:"StripePaymentUpdateStatusChangesRelationInput",
		upsert:"StripePaymentUpsertStatusChangesRelationInput",
		connect:"StripePaymentStatusChangeUniqueWhere",
		disconnect:"StripePaymentStatusChangeUniqueWhere",
		delete:"StripePaymentStatusChangeUniqueWhere"
	},
	StripePaymentUpdateStatusChangesRelationInput:{
		by:"StripePaymentStatusChangeUniqueWhere",
		data:"StripePaymentStatusChangeWithoutPaymentUpdateInput"
	},
	StripePaymentStatusChangeWithoutPaymentUpdateInput:{
		createdAt:"DateTime",
		paymentIntentStatus:"StripePaymentStatusChangePaymentIntentStatus"
	},
	StripePaymentUpsertStatusChangesRelationInput:{
		by:"StripePaymentStatusChangeUniqueWhere",
		update:"StripePaymentStatusChangeWithoutPaymentUpdateInput",
		create:"StripePaymentStatusChangeWithoutPaymentCreateInput"
	},
	StripePaymentUpdateMetadataEntityRelationInput:{
		connect:"StripePaymentMetadataUniqueWhere"
	},
	UserPaymentUpsertStripePaymentRelationInput:{
		update:"StripePaymentWithoutPaymentUpdateInput",
		create:"StripePaymentWithoutPaymentCreateInput"
	},
	UserPaymentUpdateRecurringPaymentItemEntityRelationInput:{
		connect:"UserRecurringPaymentItemUniqueWhere",
		create:"UserRecurringPaymentItemWithoutPaymentsCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateRecurringPaymentItemRelationInput",
		update:"UserRecurringPaymentItemWithoutPaymentsUpdateInput",
		upsert:"UserPaymentUpsertRecurringPaymentItemRelationInput"
	},
	UserRecurringPaymentItemWithoutPaymentsUpdateInput:{
		createdAt:"DateTime",
		recurringPayment:"UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput",
		failedEmailSentAt:"DateTime",
		meta:"UserRecurringPaymentItemUpdateMetaEntityRelationInput"
	},
	UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput:{
		connect:"UserRecurringPaymentUniqueWhere",
		create:"UserRecurringPaymentWithoutItemsCreateInput",
		connectOrCreate:"UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput",
		update:"UserRecurringPaymentWithoutItemsUpdateInput",
		upsert:"UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"
	},
	UserRecurringPaymentWithoutItemsUpdateInput:{
		activeSince:"DateTime",
		cancelledAt:"DateTime",
		interval:"UserRecurringPaymentInterval",
		currency:"UserRecurringPaymentUpdateCurrencyEntityRelationInput",
		user:"UserRecurringPaymentUpdateUserEntityRelationInput",
		meta:"UserRecurringPaymentUpdateMetaEntityRelationInput"
	},
	UserRecurringPaymentUpdateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"UserRecurringPaymentConnectOrCreateCurrencyRelationInput",
		update:"CurrencyUpdateInput",
		upsert:"UserRecurringPaymentUpsertCurrencyRelationInput"
	},
	UserRecurringPaymentUpsertCurrencyRelationInput:{
		update:"CurrencyUpdateInput",
		create:"CurrencyCreateInput"
	},
	UserRecurringPaymentUpdateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutRecurringPaymentsCreateInput",
		connectOrCreate:"UserRecurringPaymentConnectOrCreateUserRelationInput",
		update:"UserWithoutRecurringPaymentsUpdateInput",
		upsert:"UserRecurringPaymentUpsertUserRelationInput"
	},
	UserWithoutRecurringPaymentsUpdateInput:{
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserUpdatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserUpdateRegionEntityRelationInput",
		currency:"UserUpdateCurrencyEntityRelationInput",
		onBehalfDonations:"UserUpdateOnBehalfDonationsEntityRelationInput",
		locale:"UserUpdateLocaleEntityRelationInput",
		devices:"UserUpdateDevicesEntityRelationInput",
		processedNotifications:"UserUpdateProcessedNotificationsEntityRelationInput",
		areaStats:"UserUpdateAreaStatsEntityRelationInput",
		organizationStats:"UserUpdateOrganizationStatsEntityRelationInput",
		postStats:"UserUpdatePostStatsEntityRelationInput",
		currencyStats:"UserUpdateCurrencyStatsEntityRelationInput"
	},
	UserUpdateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"UserConnectOrCreateRegionRelationInput",
		update:"RegionUpdateInput",
		upsert:"UserUpsertRegionRelationInput"
	},
	UserUpsertRegionRelationInput:{
		update:"RegionUpdateInput",
		create:"RegionCreateInput"
	},
	UserUpdateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"UserConnectOrCreateCurrencyRelationInput",
		update:"CurrencyUpdateInput",
		upsert:"UserUpsertCurrencyRelationInput"
	},
	UserUpsertCurrencyRelationInput:{
		update:"CurrencyUpdateInput",
		create:"CurrencyCreateInput"
	},
	UserUpdateOnBehalfDonationsEntityRelationInput:{
		create:"OnBehalfDonationWithoutOnBehalfOfCreateInput",
		update:"UserUpdateOnBehalfDonationsRelationInput",
		upsert:"UserUpsertOnBehalfDonationsRelationInput",
		connect:"OnBehalfDonationUniqueWhere",
		disconnect:"OnBehalfDonationUniqueWhere",
		delete:"OnBehalfDonationUniqueWhere"
	},
	UserUpdateOnBehalfDonationsRelationInput:{
		by:"OnBehalfDonationUniqueWhere",
		data:"OnBehalfDonationWithoutOnBehalfOfUpdateInput"
	},
	OnBehalfDonationWithoutOnBehalfOfUpdateInput:{
		createdAt:"DateTime",
		payments:"OnBehalfDonationUpdatePaymentsEntityRelationInput",
		meta:"OnBehalfDonationUpdateMetaEntityRelationInput"
	},
	OnBehalfDonationUpdatePaymentsEntityRelationInput:{
		create:"UserPaymentWithoutOnBehalfDonationCreateInput",
		update:"OnBehalfDonationUpdatePaymentsRelationInput",
		upsert:"OnBehalfDonationUpsertPaymentsRelationInput",
		connect:"UserPaymentUniqueWhere",
		disconnect:"UserPaymentUniqueWhere",
		delete:"UserPaymentUniqueWhere"
	},
	OnBehalfDonationUpdatePaymentsRelationInput:{
		by:"UserPaymentUniqueWhere",
		data:"UserPaymentWithoutOnBehalfDonationUpdateInput"
	},
	UserPaymentWithoutOnBehalfDonationUpdateInput:{
		createdAt:"DateTime",
		currency:"UserPaymentUpdateCurrencyEntityRelationInput",
		order:"UserPaymentUpdateOrderEntityRelationInput",
		csobPayment:"UserPaymentUpdateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentUpdateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentUpdateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentUpdateRegionEntityRelationInput",
		user:"UserPaymentUpdateUserEntityRelationInput",
		triesCollection:"UserPaymentUpdateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentUpdateMetadataEntityRelationInput"
	},
	UserPaymentUpdateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateRegionRelationInput",
		update:"RegionUpdateInput",
		upsert:"UserPaymentUpsertRegionRelationInput"
	},
	UserPaymentUpsertRegionRelationInput:{
		update:"RegionUpdateInput",
		create:"RegionCreateInput"
	},
	UserPaymentUpdateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutPaymentsCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateUserRelationInput",
		update:"UserWithoutPaymentsUpdateInput",
		upsert:"UserPaymentUpsertUserRelationInput"
	},
	UserWithoutPaymentsUpdateInput:{
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		region:"UserUpdateRegionEntityRelationInput",
		currency:"UserUpdateCurrencyEntityRelationInput",
		recurringPayments:"UserUpdateRecurringPaymentsEntityRelationInput",
		onBehalfDonations:"UserUpdateOnBehalfDonationsEntityRelationInput",
		locale:"UserUpdateLocaleEntityRelationInput",
		devices:"UserUpdateDevicesEntityRelationInput",
		processedNotifications:"UserUpdateProcessedNotificationsEntityRelationInput",
		areaStats:"UserUpdateAreaStatsEntityRelationInput",
		organizationStats:"UserUpdateOrganizationStatsEntityRelationInput",
		postStats:"UserUpdatePostStatsEntityRelationInput",
		currencyStats:"UserUpdateCurrencyStatsEntityRelationInput"
	},
	UserUpdateRecurringPaymentsEntityRelationInput:{
		create:"UserRecurringPaymentWithoutUserCreateInput",
		update:"UserUpdateRecurringPaymentsRelationInput",
		upsert:"UserUpsertRecurringPaymentsRelationInput",
		connect:"UserRecurringPaymentUniqueWhere",
		disconnect:"UserRecurringPaymentUniqueWhere",
		delete:"UserRecurringPaymentUniqueWhere"
	},
	UserUpdateRecurringPaymentsRelationInput:{
		by:"UserRecurringPaymentUniqueWhere",
		data:"UserRecurringPaymentWithoutUserUpdateInput"
	},
	UserRecurringPaymentWithoutUserUpdateInput:{
		activeSince:"DateTime",
		cancelledAt:"DateTime",
		interval:"UserRecurringPaymentInterval",
		currency:"UserRecurringPaymentUpdateCurrencyEntityRelationInput",
		items:"UserRecurringPaymentUpdateItemsEntityRelationInput",
		meta:"UserRecurringPaymentUpdateMetaEntityRelationInput"
	},
	UserRecurringPaymentUpdateItemsEntityRelationInput:{
		create:"UserRecurringPaymentItemWithoutRecurringPaymentCreateInput",
		update:"UserRecurringPaymentUpdateItemsRelationInput",
		upsert:"UserRecurringPaymentUpsertItemsRelationInput",
		connect:"UserRecurringPaymentItemUniqueWhere",
		disconnect:"UserRecurringPaymentItemUniqueWhere",
		delete:"UserRecurringPaymentItemUniqueWhere"
	},
	UserRecurringPaymentUpdateItemsRelationInput:{
		by:"UserRecurringPaymentItemUniqueWhere",
		data:"UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"
	},
	UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput:{
		createdAt:"DateTime",
		payments:"UserRecurringPaymentItemUpdatePaymentsEntityRelationInput",
		failedEmailSentAt:"DateTime",
		meta:"UserRecurringPaymentItemUpdateMetaEntityRelationInput"
	},
	UserRecurringPaymentItemUpdatePaymentsEntityRelationInput:{
		create:"UserPaymentWithoutRecurringPaymentItemCreateInput",
		update:"UserRecurringPaymentItemUpdatePaymentsRelationInput",
		upsert:"UserRecurringPaymentItemUpsertPaymentsRelationInput",
		connect:"UserPaymentUniqueWhere",
		disconnect:"UserPaymentUniqueWhere",
		delete:"UserPaymentUniqueWhere"
	},
	UserRecurringPaymentItemUpdatePaymentsRelationInput:{
		by:"UserPaymentUniqueWhere",
		data:"UserPaymentWithoutRecurringPaymentItemUpdateInput"
	},
	UserPaymentWithoutRecurringPaymentItemUpdateInput:{
		createdAt:"DateTime",
		currency:"UserPaymentUpdateCurrencyEntityRelationInput",
		order:"UserPaymentUpdateOrderEntityRelationInput",
		csobPayment:"UserPaymentUpdateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentUpdateStripePaymentEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentUpdateRegionEntityRelationInput",
		user:"UserPaymentUpdateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentUpdateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentUpdateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentUpdateMetadataEntityRelationInput"
	},
	UserPaymentUpdateOnBehalfDonationEntityRelationInput:{
		connect:"OnBehalfDonationUniqueWhere",
		create:"OnBehalfDonationWithoutPaymentsCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateOnBehalfDonationRelationInput",
		update:"OnBehalfDonationWithoutPaymentsUpdateInput",
		upsert:"UserPaymentUpsertOnBehalfDonationRelationInput"
	},
	OnBehalfDonationWithoutPaymentsUpdateInput:{
		createdAt:"DateTime",
		onBehalfOf:"OnBehalfDonationUpdateOnBehalfOfEntityRelationInput",
		meta:"OnBehalfDonationUpdateMetaEntityRelationInput"
	},
	OnBehalfDonationUpdateOnBehalfOfEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutOnBehalfDonationsCreateInput",
		connectOrCreate:"OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput",
		update:"UserWithoutOnBehalfDonationsUpdateInput",
		upsert:"OnBehalfDonationUpsertOnBehalfOfRelationInput"
	},
	UserWithoutOnBehalfDonationsUpdateInput:{
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserUpdatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserUpdateRegionEntityRelationInput",
		currency:"UserUpdateCurrencyEntityRelationInput",
		recurringPayments:"UserUpdateRecurringPaymentsEntityRelationInput",
		locale:"UserUpdateLocaleEntityRelationInput",
		devices:"UserUpdateDevicesEntityRelationInput",
		processedNotifications:"UserUpdateProcessedNotificationsEntityRelationInput",
		areaStats:"UserUpdateAreaStatsEntityRelationInput",
		organizationStats:"UserUpdateOrganizationStatsEntityRelationInput",
		postStats:"UserUpdatePostStatsEntityRelationInput",
		currencyStats:"UserUpdateCurrencyStatsEntityRelationInput"
	},
	UserUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleCreateInput",
		connectOrCreate:"UserConnectOrCreateLocaleRelationInput",
		update:"LocaleUpdateInput",
		upsert:"UserUpsertLocaleRelationInput"
	},
	LocaleUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	LocaleUpdateSentPaymentsEntityRelationInput:{
		create:"SentPaymentLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateSentPaymentsRelationInput",
		upsert:"LocaleUpsertSentPaymentsRelationInput",
		connect:"SentPaymentLocaleUniqueWhere",
		disconnect:"SentPaymentLocaleUniqueWhere",
		delete:"SentPaymentLocaleUniqueWhere"
	},
	LocaleUpdateSentPaymentsRelationInput:{
		by:"SentPaymentLocaleUniqueWhere",
		data:"SentPaymentLocaleWithoutLocaleUpdateInput"
	},
	SentPaymentLocaleWithoutLocaleUpdateInput:{
		root:"SentPaymentLocaleUpdateRootEntityRelationInput"
	},
	SentPaymentLocaleUpdateRootEntityRelationInput:{
		connect:"SentPaymentUniqueWhere",
		create:"SentPaymentWithoutLocalesCreateInput",
		connectOrCreate:"SentPaymentLocaleConnectOrCreateRootRelationInput",
		update:"SentPaymentWithoutLocalesUpdateInput",
		upsert:"SentPaymentLocaleUpsertRootRelationInput"
	},
	SentPaymentWithoutLocalesUpdateInput:{
		createdAt:"DateTime",
		sendAt:"DateTime",
		currency:"SentPaymentUpdateCurrencyEntityRelationInput",
		area:"SentPaymentUpdateAreaEntityRelationInput",
		organization:"SentPaymentUpdateOrganizationEntityRelationInput"
	},
	SentPaymentUpdateAreaEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaWithoutSentPaymentsCreateInput",
		connectOrCreate:"SentPaymentConnectOrCreateAreaRelationInput",
		update:"PostAreaWithoutSentPaymentsUpdateInput",
		upsert:"SentPaymentUpsertAreaRelationInput"
	},
	PostAreaWithoutSentPaymentsUpdateInput:{
		icon:"PostAreaUpdateIconEntityRelationInput",
		locales:"PostAreaUpdateLocalesEntityRelationInput",
		regionListOverride:"PostAreaUpdateRegionListOverrideEntityRelationInput",
		posts:"PostAreaUpdatePostsEntityRelationInput",
		region:"PostAreaUpdateRegionEntityRelationInput",
		meta:"PostAreaUpdateMetaEntityRelationInput",
		mobileHeroImage:"PostAreaUpdateMobileHeroImageEntityRelationInput",
		plainIcon:"PostAreaUpdatePlainIconEntityRelationInput",
		areaSentPaymentCurrencySums:"PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput",
		areaSentPaymentSum:"PostAreaUpdateAreaSentPaymentSumEntityRelationInput",
		areaCurrencySums:"PostAreaUpdateAreaCurrencySumsEntityRelationInput",
		areaSum:"PostAreaUpdateAreaSumEntityRelationInput"
	},
	PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput:{
		connect:"PostAreaSentPaymentCurrencySumUniqueWhere",
		disconnect:"PostAreaSentPaymentCurrencySumUniqueWhere",
		delete:"PostAreaSentPaymentCurrencySumUniqueWhere"
	},
	PostAreaUpdateAreaSentPaymentSumEntityRelationInput:{
		connect:"PostAreaSentPaymentSumUniqueWhere"
	},
	PostAreaUpdateAreaCurrencySumsEntityRelationInput:{
		connect:"PostAreaCurrencySumUniqueWhere",
		disconnect:"PostAreaCurrencySumUniqueWhere",
		delete:"PostAreaCurrencySumUniqueWhere"
	},
	PostAreaUpdateAreaSumEntityRelationInput:{
		connect:"PostAreaSumUniqueWhere"
	},
	SentPaymentUpsertAreaRelationInput:{
		update:"PostAreaWithoutSentPaymentsUpdateInput",
		create:"PostAreaWithoutSentPaymentsCreateInput"
	},
	SentPaymentLocaleUpsertRootRelationInput:{
		update:"SentPaymentWithoutLocalesUpdateInput",
		create:"SentPaymentWithoutLocalesCreateInput"
	},
	LocaleUpsertSentPaymentsRelationInput:{
		by:"SentPaymentLocaleUniqueWhere",
		update:"SentPaymentLocaleWithoutLocaleUpdateInput",
		create:"SentPaymentLocaleWithoutLocaleCreateInput"
	},
	UserUpsertLocaleRelationInput:{
		update:"LocaleUpdateInput",
		create:"LocaleCreateInput"
	},
	UserUpdateDevicesEntityRelationInput:{
		create:"DeviceWithoutUserCreateInput",
		update:"UserUpdateDevicesRelationInput",
		upsert:"UserUpsertDevicesRelationInput",
		connect:"DeviceUniqueWhere",
		disconnect:"DeviceUniqueWhere",
		delete:"DeviceUniqueWhere"
	},
	UserUpdateDevicesRelationInput:{
		by:"DeviceUniqueWhere",
		data:"DeviceWithoutUserUpdateInput"
	},
	DeviceWithoutUserUpdateInput:{
		createdAt:"DateTime",
		lastActiveAt:"DateTime"
	},
	UserUpsertDevicesRelationInput:{
		by:"DeviceUniqueWhere",
		update:"DeviceWithoutUserUpdateInput",
		create:"DeviceWithoutUserCreateInput"
	},
	UserUpdateProcessedNotificationsEntityRelationInput:{
		create:"ProcessedNotificationSourceWithoutDonationReminderUserCreateInput",
		update:"UserUpdateProcessedNotificationsRelationInput",
		upsert:"UserUpsertProcessedNotificationsRelationInput",
		connect:"ProcessedNotificationSourceUniqueWhere",
		disconnect:"ProcessedNotificationSourceUniqueWhere",
		delete:"ProcessedNotificationSourceUniqueWhere"
	},
	UserUpdateProcessedNotificationsRelationInput:{
		by:"ProcessedNotificationSourceUniqueWhere",
		data:"ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"
	},
	ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput:{
		type:"ProcessedNotificationSourceType",
		processedNotification:"ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput",
		scheduledNotification:"ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"
	},
	ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput:{
		connect:"ScheduledNotificationUniqueWhere",
		create:"ScheduledNotificationWithoutProcessedNotificationsCreateInput",
		connectOrCreate:"ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput",
		update:"ScheduledNotificationWithoutProcessedNotificationsUpdateInput",
		upsert:"ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"
	},
	ScheduledNotificationWithoutProcessedNotificationsUpdateInput:{
		scheduledDate:"Date",
		target:"ScheduledNotificationUpdateTargetEntityRelationInput",
		locales:"ScheduledNotificationUpdateLocalesEntityRelationInput",
		image:"ScheduledNotificationUpdateImageEntityRelationInput",
		completedAt:"DateTime"
	},
	ScheduledNotificationUpdateLocalesEntityRelationInput:{
		create:"ScheduledNotificationLocaleWithoutRootCreateInput",
		update:"ScheduledNotificationUpdateLocalesRelationInput",
		upsert:"ScheduledNotificationUpsertLocalesRelationInput",
		connect:"ScheduledNotificationLocaleUniqueWhere",
		disconnect:"ScheduledNotificationLocaleUniqueWhere",
		delete:"ScheduledNotificationLocaleUniqueWhere"
	},
	ScheduledNotificationUpdateLocalesRelationInput:{
		by:"ScheduledNotificationLocaleUniqueWhere",
		data:"ScheduledNotificationLocaleWithoutRootUpdateInput"
	},
	ScheduledNotificationLocaleWithoutRootUpdateInput:{
		locale:"ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"
	},
	ScheduledNotificationLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutScheduledNotificationsCreateInput",
		connectOrCreate:"ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutScheduledNotificationsUpdateInput",
		upsert:"ScheduledNotificationLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutScheduledNotificationsUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	ScheduledNotificationLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutScheduledNotificationsUpdateInput",
		create:"LocaleWithoutScheduledNotificationsCreateInput"
	},
	ScheduledNotificationUpsertLocalesRelationInput:{
		by:"ScheduledNotificationLocaleUniqueWhere",
		update:"ScheduledNotificationLocaleWithoutRootUpdateInput",
		create:"ScheduledNotificationLocaleWithoutRootCreateInput"
	},
	ProcessedNotificationSourceUpsertScheduledNotificationRelationInput:{
		update:"ScheduledNotificationWithoutProcessedNotificationsUpdateInput",
		create:"ScheduledNotificationWithoutProcessedNotificationsCreateInput"
	},
	UserUpsertProcessedNotificationsRelationInput:{
		by:"ProcessedNotificationSourceUniqueWhere",
		update:"ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput",
		create:"ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"
	},
	UserUpdateAreaStatsEntityRelationInput:{
		connect:"UserAreaStatsUniqueWhere",
		disconnect:"UserAreaStatsUniqueWhere",
		delete:"UserAreaStatsUniqueWhere"
	},
	UserUpdateOrganizationStatsEntityRelationInput:{
		connect:"UserOrganizationStatsUniqueWhere",
		disconnect:"UserOrganizationStatsUniqueWhere",
		delete:"UserOrganizationStatsUniqueWhere"
	},
	UserUpdatePostStatsEntityRelationInput:{
		connect:"UserPostStatsUniqueWhere",
		disconnect:"UserPostStatsUniqueWhere",
		delete:"UserPostStatsUniqueWhere"
	},
	UserUpdateCurrencyStatsEntityRelationInput:{
		connect:"UserCurrencyStatsUniqueWhere",
		disconnect:"UserCurrencyStatsUniqueWhere",
		delete:"UserCurrencyStatsUniqueWhere"
	},
	OnBehalfDonationUpsertOnBehalfOfRelationInput:{
		update:"UserWithoutOnBehalfDonationsUpdateInput",
		create:"UserWithoutOnBehalfDonationsCreateInput"
	},
	OnBehalfDonationUpdateMetaEntityRelationInput:{
		connect:"OnBehalfDonationMetadataUniqueWhere"
	},
	UserPaymentUpsertOnBehalfDonationRelationInput:{
		update:"OnBehalfDonationWithoutPaymentsUpdateInput",
		create:"OnBehalfDonationWithoutPaymentsCreateInput"
	},
	UserPaymentUpdateTriesCollectionEntityRelationInput:{
		connect:"UserPaymentTriesCollectionUniqueWhere",
		create:"UserPaymentTriesCollectionWithoutPaymentCreateInput",
		connectOrCreate:"UserPaymentConnectOrCreateTriesCollectionRelationInput",
		update:"UserPaymentTriesCollectionWithoutPaymentUpdateInput",
		upsert:"UserPaymentUpsertTriesCollectionRelationInput"
	},
	UserPaymentTriesCollectionWithoutPaymentUpdateInput:{
		createdAt:"DateTime",
		user:"UserPaymentTriesCollectionUpdateUserEntityRelationInput",
		currency:"UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput",
		onBehalfDonation:"UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput",
		recurring:"UserPaymentTriesCollectionUpdateRecurringEntityRelationInput",
		metadataLocales:"UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput",
		medium:"PaymentMedium"
	},
	UserPaymentTriesCollectionUpdateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreateUserRelationInput",
		update:"UserUpdateInput",
		upsert:"UserPaymentTriesCollectionUpsertUserRelationInput"
	},
	UserUpdateInput:{
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserUpdatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserUpdateRegionEntityRelationInput",
		currency:"UserUpdateCurrencyEntityRelationInput",
		recurringPayments:"UserUpdateRecurringPaymentsEntityRelationInput",
		onBehalfDonations:"UserUpdateOnBehalfDonationsEntityRelationInput",
		locale:"UserUpdateLocaleEntityRelationInput",
		devices:"UserUpdateDevicesEntityRelationInput",
		processedNotifications:"UserUpdateProcessedNotificationsEntityRelationInput",
		areaStats:"UserUpdateAreaStatsEntityRelationInput",
		organizationStats:"UserUpdateOrganizationStatsEntityRelationInput",
		postStats:"UserUpdatePostStatsEntityRelationInput",
		currencyStats:"UserUpdateCurrencyStatsEntityRelationInput"
	},
	UserPaymentTriesCollectionUpsertUserRelationInput:{
		update:"UserUpdateInput",
		create:"UserCreateInput"
	},
	UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput",
		update:"CurrencyUpdateInput",
		upsert:"UserPaymentTriesCollectionUpsertCurrencyRelationInput"
	},
	UserPaymentTriesCollectionUpsertCurrencyRelationInput:{
		update:"CurrencyUpdateInput",
		create:"CurrencyCreateInput"
	},
	UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput:{
		connect:"OnBehalfDonationUniqueWhere",
		create:"OnBehalfDonationCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput",
		update:"OnBehalfDonationUpdateInput",
		upsert:"UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"
	},
	OnBehalfDonationUpdateInput:{
		createdAt:"DateTime",
		payments:"OnBehalfDonationUpdatePaymentsEntityRelationInput",
		onBehalfOf:"OnBehalfDonationUpdateOnBehalfOfEntityRelationInput",
		meta:"OnBehalfDonationUpdateMetaEntityRelationInput"
	},
	UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput:{
		update:"OnBehalfDonationUpdateInput",
		create:"OnBehalfDonationCreateInput"
	},
	UserPaymentTriesCollectionUpdateRecurringEntityRelationInput:{
		connect:"UserRecurringPaymentUniqueWhere",
		create:"UserRecurringPaymentCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput",
		update:"UserRecurringPaymentUpdateInput",
		upsert:"UserPaymentTriesCollectionUpsertRecurringRelationInput"
	},
	UserRecurringPaymentUpdateInput:{
		activeSince:"DateTime",
		cancelledAt:"DateTime",
		interval:"UserRecurringPaymentInterval",
		currency:"UserRecurringPaymentUpdateCurrencyEntityRelationInput",
		items:"UserRecurringPaymentUpdateItemsEntityRelationInput",
		user:"UserRecurringPaymentUpdateUserEntityRelationInput",
		meta:"UserRecurringPaymentUpdateMetaEntityRelationInput"
	},
	UserRecurringPaymentUpdateMetaEntityRelationInput:{
		connect:"UpcomingUserRecurringPaymentMetadataUniqueWhere"
	},
	UserPaymentTriesCollectionUpsertRecurringRelationInput:{
		update:"UserRecurringPaymentUpdateInput",
		create:"UserRecurringPaymentCreateInput"
	},
	UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput:{
		connect:"UserPaymentTriesCollectionMetadataLocaleUniqueWhere",
		disconnect:"UserPaymentTriesCollectionMetadataLocaleUniqueWhere",
		delete:"UserPaymentTriesCollectionMetadataLocaleUniqueWhere"
	},
	UserPaymentUpsertTriesCollectionRelationInput:{
		update:"UserPaymentTriesCollectionWithoutPaymentUpdateInput",
		create:"UserPaymentTriesCollectionWithoutPaymentCreateInput"
	},
	UserPaymentUpdateMetadataEntityRelationInput:{
		connect:"UserPaymentMetadataUniqueWhere"
	},
	UserRecurringPaymentItemUpsertPaymentsRelationInput:{
		by:"UserPaymentUniqueWhere",
		update:"UserPaymentWithoutRecurringPaymentItemUpdateInput",
		create:"UserPaymentWithoutRecurringPaymentItemCreateInput"
	},
	UserRecurringPaymentItemUpdateMetaEntityRelationInput:{
		connect:"UserRecurringPaymentItemMetadataUniqueWhere"
	},
	UserRecurringPaymentUpsertItemsRelationInput:{
		by:"UserRecurringPaymentItemUniqueWhere",
		update:"UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput",
		create:"UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"
	},
	UserUpsertRecurringPaymentsRelationInput:{
		by:"UserRecurringPaymentUniqueWhere",
		update:"UserRecurringPaymentWithoutUserUpdateInput",
		create:"UserRecurringPaymentWithoutUserCreateInput"
	},
	UserPaymentUpsertUserRelationInput:{
		update:"UserWithoutPaymentsUpdateInput",
		create:"UserWithoutPaymentsCreateInput"
	},
	OnBehalfDonationUpsertPaymentsRelationInput:{
		by:"UserPaymentUniqueWhere",
		update:"UserPaymentWithoutOnBehalfDonationUpdateInput",
		create:"UserPaymentWithoutOnBehalfDonationCreateInput"
	},
	UserUpsertOnBehalfDonationsRelationInput:{
		by:"OnBehalfDonationUniqueWhere",
		update:"OnBehalfDonationWithoutOnBehalfOfUpdateInput",
		create:"OnBehalfDonationWithoutOnBehalfOfCreateInput"
	},
	UserRecurringPaymentUpsertUserRelationInput:{
		update:"UserWithoutRecurringPaymentsUpdateInput",
		create:"UserWithoutRecurringPaymentsCreateInput"
	},
	UserRecurringPaymentItemUpsertRecurringPaymentRelationInput:{
		update:"UserRecurringPaymentWithoutItemsUpdateInput",
		create:"UserRecurringPaymentWithoutItemsCreateInput"
	},
	UserPaymentUpsertRecurringPaymentItemRelationInput:{
		update:"UserRecurringPaymentItemWithoutPaymentsUpdateInput",
		create:"UserRecurringPaymentItemWithoutPaymentsCreateInput"
	},
	UserUpsertPaymentsRelationInput:{
		by:"UserPaymentUniqueWhere",
		update:"UserPaymentWithoutUserUpdateInput",
		create:"UserPaymentWithoutUserCreateInput"
	},
	ProcessedNotificationSourceUpsertDonationReminderUserRelationInput:{
		update:"UserWithoutProcessedNotificationsUpdateInput",
		create:"UserWithoutProcessedNotificationsCreateInput"
	},
	ScheduledNotificationUpsertProcessedNotificationsRelationInput:{
		by:"ProcessedNotificationSourceUniqueWhere",
		update:"ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput",
		create:"ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"
	},
	ScheduledNotificationLocaleUpsertRootRelationInput:{
		update:"ScheduledNotificationWithoutLocalesUpdateInput",
		create:"ScheduledNotificationWithoutLocalesCreateInput"
	},
	LocaleUpsertScheduledNotificationsRelationInput:{
		by:"ScheduledNotificationLocaleUniqueWhere",
		update:"ScheduledNotificationLocaleWithoutLocaleUpdateInput",
		create:"ScheduledNotificationLocaleWithoutLocaleCreateInput"
	},
	ReceivedGiftsPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutReceivedGiftsPagesUpdateInput",
		create:"LocaleWithoutReceivedGiftsPagesCreateInput"
	},
	ReceivedGiftsPageLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"ReceivedGiftsPageLocaleUpsertContentRelationInput"
	},
	ReceivedGiftsPageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"ReceivedGiftsPageLocaleUpsertSeoRelationInput"
	},
	ReceivedGiftsPageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	LinkableUpsertReceivedGiftsPageRelationInput:{
		update:"ReceivedGiftsPageLocaleWithoutLinkUpdateInput",
		create:"ReceivedGiftsPageLocaleWithoutLinkCreateInput"
	},
	ReportPageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutReportPageUpdateInput",
		create:"LinkableWithoutReportPageCreateInput"
	},
	ReportPageLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"ReportPageLocaleUpsertContentRelationInput"
	},
	ReportPageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	ReportPageLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"ReportPageLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"ReportPageLocaleUpsertSeoRelationInput"
	},
	ReportPageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	ReportPageLocaleUpdatePostsEntityRelationInput:{
		create:"PostWithoutReportPageCreateInput",
		update:"ReportPageLocaleUpdatePostsRelationInput",
		upsert:"ReportPageLocaleUpsertPostsRelationInput",
		connect:"PostUniqueWhere",
		disconnect:"PostUniqueWhere",
		delete:"PostUniqueWhere"
	},
	ReportPageLocaleUpdatePostsRelationInput:{
		by:"PostUniqueWhere",
		data:"PostWithoutReportPageUpdateInput"
	},
	PostWithoutReportPageUpdateInput:{
		organization:"PostUpdateOrganizationEntityRelationInput",
		area:"PostUpdateAreaEntityRelationInput",
		activeRevision:"PostUpdateActiveRevisionEntityRelationInput",
		revisions:"PostUpdateRevisionsEntityRelationInput",
		locales:"PostUpdateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostUpdateMetaEntityRelationInput",
		heroCarousel:"PostUpdateHeroCarouselEntityRelationInput",
		content:"PostUpdateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostUpdateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostUpdateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostUpdateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostUpdateFundraisingProgressEntityRelationInput"
	},
	PostUpdateMetaEntityRelationInput:{
		connect:"PostMetaDataUniqueWhere"
	},
	PostUpdateHeroCarouselEntityRelationInput:{
		create:"HeroCarouselWithoutPostsCreateInput",
		update:"PostUpdateHeroCarouselRelationInput",
		upsert:"PostUpsertHeroCarouselRelationInput",
		connect:"HeroCarouselUniqueWhere",
		disconnect:"HeroCarouselUniqueWhere",
		delete:"HeroCarouselUniqueWhere"
	},
	PostUpdateHeroCarouselRelationInput:{
		by:"HeroCarouselUniqueWhere",
		data:"HeroCarouselWithoutPostsUpdateInput"
	},
	HeroCarouselWithoutPostsUpdateInput:{
		createdAt:"Date",
		items:"HeroCarouselUpdateItemsEntityRelationInput"
	},
	HeroCarouselUpdateItemsEntityRelationInput:{
		create:"HeroCarouselItemWithoutListCreateInput",
		update:"HeroCarouselUpdateItemsRelationInput",
		upsert:"HeroCarouselUpsertItemsRelationInput",
		connect:"HeroCarouselItemUniqueWhere",
		disconnect:"HeroCarouselItemUniqueWhere",
		delete:"HeroCarouselItemUniqueWhere"
	},
	HeroCarouselUpdateItemsRelationInput:{
		by:"HeroCarouselItemUniqueWhere",
		data:"HeroCarouselItemWithoutListUpdateInput"
	},
	HeroCarouselItemWithoutListUpdateInput:{
		createdAt:"Date",
		item:"HeroCarouselItemUpdateItemEntityRelationInput"
	},
	HeroCarouselItemUpdateItemEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput",
		connectOrCreate:"HeroCarouselItemConnectOrCreateItemRelationInput",
		update:"PostUpdateInput",
		upsert:"HeroCarouselItemUpsertItemRelationInput"
	},
	HeroCarouselItemUpsertItemRelationInput:{
		update:"PostUpdateInput",
		create:"PostCreateInput"
	},
	HeroCarouselUpsertItemsRelationInput:{
		by:"HeroCarouselItemUniqueWhere",
		update:"HeroCarouselItemWithoutListUpdateInput",
		create:"HeroCarouselItemWithoutListCreateInput"
	},
	PostUpsertHeroCarouselRelationInput:{
		by:"HeroCarouselUniqueWhere",
		update:"HeroCarouselWithoutPostsUpdateInput",
		create:"HeroCarouselWithoutPostsCreateInput"
	},
	PostUpdateContentEntityRelationInput:{
		create:"ContentReferenceWithoutPostsCreateInput",
		update:"PostUpdateContentRelationInput",
		upsert:"PostUpsertContentRelationInput",
		connect:"ContentReferenceUniqueWhere",
		disconnect:"ContentReferenceUniqueWhere",
		delete:"ContentReferenceUniqueWhere"
	},
	PostUpdateContentRelationInput:{
		by:"ContentReferenceUniqueWhere",
		data:"ContentReferenceWithoutPostsUpdateInput"
	},
	ContentReferenceWithoutPostsUpdateInput:{
		type:"ContentReferenceType",
		block:"ContentReferenceUpdateBlockEntityRelationInput",
		image:"ContentReferenceUpdateImageEntityRelationInput",
		linkables:"ContentReferenceUpdateLinkablesEntityRelationInput",
		video:"ContentReferenceUpdateVideoEntityRelationInput",
		link:"ContentReferenceUpdateLinkEntityRelationInput",
		contentAlignment:"ContentAlignment",
		valueList:"ContentReferenceUpdateValueListEntityRelationInput",
		imageLinkList:"ContentReferenceUpdateImageLinkListEntityRelationInput",
		areaList:"ContentReferenceUpdateAreaListEntityRelationInput",
		accordion:"ContentReferenceUpdateAccordionEntityRelationInput",
		media:"ContentReferenceUpdateMediaEntityRelationInput",
		memberList:"ContentReferenceUpdateMemberListEntityRelationInput",
		asideMediaContentLayout:"AsideMediaContentLayout",
		form:"ContentReferenceUpdateFormEntityRelationInput",
		contentWithoutBlocks:"ContentReferenceUpdateContentWithoutBlocksEntityRelationInput",
		heroCarousel:"ContentReferenceUpdateHeroCarouselEntityRelationInput",
		organizationList:"ContentReferenceUpdateOrganizationListEntityRelationInput",
		textImageList:"ContentReferenceUpdateTextImageListEntityRelationInput"
	},
	ContentReferenceUpdateBlockEntityRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutReferencesCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateBlockRelationInput",
		update:"ContentBlockWithoutReferencesUpdateInput",
		upsert:"ContentReferenceUpsertBlockRelationInput"
	},
	ContentBlockWithoutReferencesUpdateInput:{
		content:"ContentBlockUpdateContentEntityRelationInput"
	},
	ContentBlockUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentWithoutBlocksCreateInput",
		connectOrCreate:"ContentBlockConnectOrCreateContentRelationInput",
		update:"ContentWithoutBlocksUpdateInput",
		upsert:"ContentBlockUpsertContentRelationInput"
	},
	ContentWithoutBlocksUpdateInput:{

	},
	ContentBlockUpsertContentRelationInput:{
		update:"ContentWithoutBlocksUpdateInput",
		create:"ContentWithoutBlocksCreateInput"
	},
	ContentReferenceUpsertBlockRelationInput:{
		update:"ContentBlockWithoutReferencesUpdateInput",
		create:"ContentBlockWithoutReferencesCreateInput"
	},
	ContentReferenceUpdateValueListEntityRelationInput:{
		connect:"ValueListUniqueWhere",
		create:"ValueListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateValueListRelationInput",
		update:"ValueListUpdateInput",
		upsert:"ContentReferenceUpsertValueListRelationInput"
	},
	ValueListUpdateInput:{
		items:"ValueListUpdateItemsEntityRelationInput"
	},
	ValueListUpdateItemsEntityRelationInput:{
		create:"ValueItemWithoutListCreateInput",
		update:"ValueListUpdateItemsRelationInput",
		upsert:"ValueListUpsertItemsRelationInput",
		connect:"ValueItemUniqueWhere",
		disconnect:"ValueItemUniqueWhere",
		delete:"ValueItemUniqueWhere"
	},
	ValueListUpdateItemsRelationInput:{
		by:"ValueItemUniqueWhere",
		data:"ValueItemWithoutListUpdateInput"
	},
	ValueItemWithoutListUpdateInput:{
		item:"ValueItemUpdateItemEntityRelationInput"
	},
	ValueItemUpdateItemEntityRelationInput:{
		connect:"ValueUniqueWhere",
		create:"ValueCreateInput",
		connectOrCreate:"ValueItemConnectOrCreateItemRelationInput",
		update:"ValueUpdateInput",
		upsert:"ValueItemUpsertItemRelationInput"
	},
	ValueUpdateInput:{
		textContent:"ValueUpdateTextContentEntityRelationInput"
	},
	ValueUpdateTextContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"ValueConnectOrCreateTextContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"ValueUpsertTextContentRelationInput"
	},
	ValueUpsertTextContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	ValueItemUpsertItemRelationInput:{
		update:"ValueUpdateInput",
		create:"ValueCreateInput"
	},
	ValueListUpsertItemsRelationInput:{
		by:"ValueItemUniqueWhere",
		update:"ValueItemWithoutListUpdateInput",
		create:"ValueItemWithoutListCreateInput"
	},
	ContentReferenceUpsertValueListRelationInput:{
		update:"ValueListUpdateInput",
		create:"ValueListCreateInput"
	},
	ContentReferenceUpdateImageLinkListEntityRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateImageLinkListRelationInput",
		update:"ImageLinkListUpdateInput",
		upsert:"ContentReferenceUpsertImageLinkListRelationInput"
	},
	ContentReferenceUpsertImageLinkListRelationInput:{
		update:"ImageLinkListUpdateInput",
		create:"ImageLinkListCreateInput"
	},
	ContentReferenceUpdateAreaListEntityRelationInput:{
		connect:"PostAreaListUniqueWhere",
		create:"PostAreaListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateAreaListRelationInput",
		update:"PostAreaListUpdateInput",
		upsert:"ContentReferenceUpsertAreaListRelationInput"
	},
	PostAreaListUpdateInput:{
		items:"PostAreaListUpdateItemsEntityRelationInput"
	},
	PostAreaListUpdateItemsEntityRelationInput:{
		create:"PostAreaListItemWithoutListCreateInput",
		update:"PostAreaListUpdateItemsRelationInput",
		upsert:"PostAreaListUpsertItemsRelationInput",
		connect:"PostAreaListItemUniqueWhere",
		disconnect:"PostAreaListItemUniqueWhere",
		delete:"PostAreaListItemUniqueWhere"
	},
	PostAreaListUpdateItemsRelationInput:{
		by:"PostAreaListItemUniqueWhere",
		data:"PostAreaListItemWithoutListUpdateInput"
	},
	PostAreaListItemWithoutListUpdateInput:{
		item:"PostAreaListItemUpdateItemEntityRelationInput"
	},
	PostAreaListItemUpdateItemEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput",
		connectOrCreate:"PostAreaListItemConnectOrCreateItemRelationInput",
		update:"PostAreaUpdateInput",
		upsert:"PostAreaListItemUpsertItemRelationInput"
	},
	PostAreaListItemUpsertItemRelationInput:{
		update:"PostAreaUpdateInput",
		create:"PostAreaCreateInput"
	},
	PostAreaListUpsertItemsRelationInput:{
		by:"PostAreaListItemUniqueWhere",
		update:"PostAreaListItemWithoutListUpdateInput",
		create:"PostAreaListItemWithoutListCreateInput"
	},
	ContentReferenceUpsertAreaListRelationInput:{
		update:"PostAreaListUpdateInput",
		create:"PostAreaListCreateInput"
	},
	ContentReferenceUpdateAccordionEntityRelationInput:{
		connect:"AccordionUniqueWhere",
		create:"AccordionCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateAccordionRelationInput",
		update:"AccordionUpdateInput",
		upsert:"ContentReferenceUpsertAccordionRelationInput"
	},
	AccordionUpdateInput:{
		items:"AccordionUpdateItemsEntityRelationInput"
	},
	AccordionUpdateItemsEntityRelationInput:{
		create:"AccordionItemWithoutListCreateInput",
		update:"AccordionUpdateItemsRelationInput",
		upsert:"AccordionUpsertItemsRelationInput",
		connect:"AccordionItemUniqueWhere",
		disconnect:"AccordionItemUniqueWhere",
		delete:"AccordionItemUniqueWhere"
	},
	AccordionUpdateItemsRelationInput:{
		by:"AccordionItemUniqueWhere",
		data:"AccordionItemWithoutListUpdateInput"
	},
	AccordionItemWithoutListUpdateInput:{
		descriptionContent:"AccordionItemUpdateDescriptionContentEntityRelationInput"
	},
	AccordionItemUpdateDescriptionContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"AccordionItemConnectOrCreateDescriptionContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"AccordionItemUpsertDescriptionContentRelationInput"
	},
	AccordionItemUpsertDescriptionContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	AccordionUpsertItemsRelationInput:{
		by:"AccordionItemUniqueWhere",
		update:"AccordionItemWithoutListUpdateInput",
		create:"AccordionItemWithoutListCreateInput"
	},
	ContentReferenceUpsertAccordionRelationInput:{
		update:"AccordionUpdateInput",
		create:"AccordionCreateInput"
	},
	ContentReferenceUpdateMediaEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateMediaRelationInput",
		update:"MediumListUpdateInput",
		upsert:"ContentReferenceUpsertMediaRelationInput"
	},
	MediumListUpdateInput:{
		items:"MediumListUpdateItemsEntityRelationInput"
	},
	MediumListUpdateItemsEntityRelationInput:{
		create:"MediumItemWithoutListCreateInput",
		update:"MediumListUpdateItemsRelationInput",
		upsert:"MediumListUpsertItemsRelationInput",
		connect:"MediumItemUniqueWhere",
		disconnect:"MediumItemUniqueWhere",
		delete:"MediumItemUniqueWhere"
	},
	MediumListUpdateItemsRelationInput:{
		by:"MediumItemUniqueWhere",
		data:"MediumItemWithoutListUpdateInput"
	},
	MediumItemWithoutListUpdateInput:{
		medium:"MediumItemUpdateMediumEntityRelationInput"
	},
	MediumItemUpdateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput",
		connectOrCreate:"MediumItemConnectOrCreateMediumRelationInput",
		update:"MediumUpdateInput",
		upsert:"MediumItemUpsertMediumRelationInput"
	},
	MediumUpdateInput:{
		type:"MediumType",
		image:"MediumUpdateImageEntityRelationInput",
		video:"MediumUpdateVideoEntityRelationInput"
	},
	MediumUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"MediumConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"MediumUpsertImageRelationInput"
	},
	MediumUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	MediumUpdateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"MediumConnectOrCreateVideoRelationInput",
		update:"VideoUpdateInput",
		upsert:"MediumUpsertVideoRelationInput"
	},
	MediumUpsertVideoRelationInput:{
		update:"VideoUpdateInput",
		create:"VideoCreateInput"
	},
	MediumItemUpsertMediumRelationInput:{
		update:"MediumUpdateInput",
		create:"MediumCreateInput"
	},
	MediumListUpsertItemsRelationInput:{
		by:"MediumItemUniqueWhere",
		update:"MediumItemWithoutListUpdateInput",
		create:"MediumItemWithoutListCreateInput"
	},
	ContentReferenceUpsertMediaRelationInput:{
		update:"MediumListUpdateInput",
		create:"MediumListCreateInput"
	},
	ContentReferenceUpdateMemberListEntityRelationInput:{
		connect:"MemberListUniqueWhere",
		create:"MemberListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateMemberListRelationInput",
		update:"MemberListUpdateInput",
		upsert:"ContentReferenceUpsertMemberListRelationInput"
	},
	MemberListUpdateInput:{
		items:"MemberListUpdateItemsEntityRelationInput"
	},
	MemberListUpdateItemsEntityRelationInput:{
		create:"MemberListItemWithoutListCreateInput",
		update:"MemberListUpdateItemsRelationInput",
		upsert:"MemberListUpsertItemsRelationInput",
		connect:"MemberListItemUniqueWhere",
		disconnect:"MemberListItemUniqueWhere",
		delete:"MemberListItemUniqueWhere"
	},
	MemberListUpdateItemsRelationInput:{
		by:"MemberListItemUniqueWhere",
		data:"MemberListItemWithoutListUpdateInput"
	},
	MemberListItemWithoutListUpdateInput:{
		image:"MemberListItemUpdateImageEntityRelationInput",
		descriptionContent:"MemberListItemUpdateDescriptionContentEntityRelationInput"
	},
	MemberListItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"MemberListItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"MemberListItemUpsertImageRelationInput"
	},
	MemberListItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	MemberListItemUpdateDescriptionContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"MemberListItemConnectOrCreateDescriptionContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"MemberListItemUpsertDescriptionContentRelationInput"
	},
	MemberListItemUpsertDescriptionContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	MemberListUpsertItemsRelationInput:{
		by:"MemberListItemUniqueWhere",
		update:"MemberListItemWithoutListUpdateInput",
		create:"MemberListItemWithoutListCreateInput"
	},
	ContentReferenceUpsertMemberListRelationInput:{
		update:"MemberListUpdateInput",
		create:"MemberListCreateInput"
	},
	ContentReferenceUpdateFormEntityRelationInput:{
		connect:"FormUniqueWhere",
		create:"FormCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateFormRelationInput",
		update:"FormUpdateInput",
		upsert:"ContentReferenceUpsertFormRelationInput"
	},
	FormUpdateInput:{
		type:"FormType",
		tax:"FormUpdateTaxEntityRelationInput"
	},
	FormUpdateTaxEntityRelationInput:{
		connect:"FilledTaxFormUniqueWhere",
		create:"FilledTaxFormCreateInput",
		connectOrCreate:"FormConnectOrCreateTaxRelationInput",
		update:"FilledTaxFormUpdateInput",
		upsert:"FormUpsertTaxRelationInput"
	},
	FilledTaxFormUpdateInput:{
		publishedAt:"DateTime",
		country:"FilledTaxFormUpdateCountryEntityRelationInput",
		dateFrom:"Date",
		dateTo:"Date"
	},
	FilledTaxFormUpdateCountryEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionCreateInput",
		connectOrCreate:"FilledTaxFormConnectOrCreateCountryRelationInput",
		update:"RegionUpdateInput",
		upsert:"FilledTaxFormUpsertCountryRelationInput"
	},
	FilledTaxFormUpsertCountryRelationInput:{
		update:"RegionUpdateInput",
		create:"RegionCreateInput"
	},
	FormUpsertTaxRelationInput:{
		update:"FilledTaxFormUpdateInput",
		create:"FilledTaxFormCreateInput"
	},
	ContentReferenceUpsertFormRelationInput:{
		update:"FormUpdateInput",
		create:"FormCreateInput"
	},
	ContentReferenceUpdateContentWithoutBlocksEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput",
		update:"ContentUpdateInput",
		upsert:"ContentReferenceUpsertContentWithoutBlocksRelationInput"
	},
	ContentReferenceUpsertContentWithoutBlocksRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	ContentReferenceUpdateHeroCarouselEntityRelationInput:{
		connect:"HeroCarouselUniqueWhere",
		create:"HeroCarouselCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateHeroCarouselRelationInput",
		update:"HeroCarouselUpdateInput",
		upsert:"ContentReferenceUpsertHeroCarouselRelationInput"
	},
	HeroCarouselUpdateInput:{
		createdAt:"Date",
		posts:"HeroCarouselUpdatePostsEntityRelationInput",
		items:"HeroCarouselUpdateItemsEntityRelationInput"
	},
	HeroCarouselUpdatePostsEntityRelationInput:{
		create:"PostWithoutHeroCarouselCreateInput",
		update:"HeroCarouselUpdatePostsRelationInput",
		upsert:"HeroCarouselUpsertPostsRelationInput",
		connect:"PostUniqueWhere",
		disconnect:"PostUniqueWhere",
		delete:"PostUniqueWhere"
	},
	HeroCarouselUpdatePostsRelationInput:{
		by:"PostUniqueWhere",
		data:"PostWithoutHeroCarouselUpdateInput"
	},
	PostWithoutHeroCarouselUpdateInput:{
		organization:"PostUpdateOrganizationEntityRelationInput",
		area:"PostUpdateAreaEntityRelationInput",
		activeRevision:"PostUpdateActiveRevisionEntityRelationInput",
		revisions:"PostUpdateRevisionsEntityRelationInput",
		locales:"PostUpdateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostUpdateMetaEntityRelationInput",
		reportPage:"PostUpdateReportPageEntityRelationInput",
		content:"PostUpdateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostUpdateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostUpdateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostUpdateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostUpdateFundraisingProgressEntityRelationInput"
	},
	PostUpdateReportPageEntityRelationInput:{
		create:"ReportPageLocaleWithoutPostsCreateInput",
		update:"PostUpdateReportPageRelationInput",
		upsert:"PostUpsertReportPageRelationInput",
		connect:"ReportPageLocaleUniqueWhere",
		disconnect:"ReportPageLocaleUniqueWhere",
		delete:"ReportPageLocaleUniqueWhere"
	},
	PostUpdateReportPageRelationInput:{
		by:"ReportPageLocaleUniqueWhere",
		data:"ReportPageLocaleWithoutPostsUpdateInput"
	},
	ReportPageLocaleWithoutPostsUpdateInput:{
		link:"ReportPageLocaleUpdateLinkEntityRelationInput",
		root:"ReportPageLocaleUpdateRootEntityRelationInput",
		locale:"ReportPageLocaleUpdateLocaleEntityRelationInput",
		content:"ReportPageLocaleUpdateContentEntityRelationInput",
		seo:"ReportPageLocaleUpdateSeoEntityRelationInput"
	},
	PostUpsertReportPageRelationInput:{
		by:"ReportPageLocaleUniqueWhere",
		update:"ReportPageLocaleWithoutPostsUpdateInput",
		create:"ReportPageLocaleWithoutPostsCreateInput"
	},
	PostUpdateFundraiseCurrencyEntityRelationInput:{
		connect:"CurrencyUniqueWhere",
		create:"CurrencyCreateInput",
		connectOrCreate:"PostConnectOrCreateFundraiseCurrencyRelationInput",
		update:"CurrencyUpdateInput",
		upsert:"PostUpsertFundraiseCurrencyRelationInput"
	},
	PostUpsertFundraiseCurrencyRelationInput:{
		update:"CurrencyUpdateInput",
		create:"CurrencyCreateInput"
	},
	PostUpdateFundraiseCurrencySumsEntityRelationInput:{
		connect:"PostCurrencySumUniqueWhere",
		disconnect:"PostCurrencySumUniqueWhere",
		delete:"PostCurrencySumUniqueWhere"
	},
	PostUpdateFundraiseSumEntityRelationInput:{
		connect:"PostSumUniqueWhere"
	},
	PostUpdateFundraisingProgressEntityRelationInput:{
		connect:"PostFundraisingProgressUniqueWhere"
	},
	HeroCarouselUpsertPostsRelationInput:{
		by:"PostUniqueWhere",
		update:"PostWithoutHeroCarouselUpdateInput",
		create:"PostWithoutHeroCarouselCreateInput"
	},
	ContentReferenceUpsertHeroCarouselRelationInput:{
		update:"HeroCarouselUpdateInput",
		create:"HeroCarouselCreateInput"
	},
	ContentReferenceUpdateOrganizationListEntityRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateOrganizationListRelationInput",
		update:"PostOrganizationListUpdateInput",
		upsert:"ContentReferenceUpsertOrganizationListRelationInput"
	},
	ContentReferenceUpsertOrganizationListRelationInput:{
		update:"PostOrganizationListUpdateInput",
		create:"PostOrganizationListCreateInput"
	},
	ContentReferenceUpdateTextImageListEntityRelationInput:{
		connect:"TextImageListUniqueWhere",
		create:"TextImageListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateTextImageListRelationInput",
		update:"TextImageListUpdateInput",
		upsert:"ContentReferenceUpsertTextImageListRelationInput"
	},
	TextImageListUpdateInput:{
		items:"TextImageListUpdateItemsEntityRelationInput"
	},
	TextImageListUpdateItemsEntityRelationInput:{
		create:"TextImageListItemWithoutListCreateInput",
		update:"TextImageListUpdateItemsRelationInput",
		upsert:"TextImageListUpsertItemsRelationInput",
		connect:"TextImageListItemUniqueWhere",
		disconnect:"TextImageListItemUniqueWhere",
		delete:"TextImageListItemUniqueWhere"
	},
	TextImageListUpdateItemsRelationInput:{
		by:"TextImageListItemUniqueWhere",
		data:"TextImageListItemWithoutListUpdateInput"
	},
	TextImageListItemWithoutListUpdateInput:{
		image:"TextImageListItemUpdateImageEntityRelationInput",
		link:"TextImageListItemUpdateLinkEntityRelationInput"
	},
	TextImageListItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"TextImageListItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"TextImageListItemUpsertImageRelationInput"
	},
	TextImageListItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	TextImageListItemUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"TextImageListItemConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"TextImageListItemUpsertLinkRelationInput"
	},
	TextImageListItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	TextImageListUpsertItemsRelationInput:{
		by:"TextImageListItemUniqueWhere",
		update:"TextImageListItemWithoutListUpdateInput",
		create:"TextImageListItemWithoutListCreateInput"
	},
	ContentReferenceUpsertTextImageListRelationInput:{
		update:"TextImageListUpdateInput",
		create:"TextImageListCreateInput"
	},
	PostUpsertContentRelationInput:{
		by:"ContentReferenceUniqueWhere",
		update:"ContentReferenceWithoutPostsUpdateInput",
		create:"ContentReferenceWithoutPostsCreateInput"
	},
	ReportPageLocaleUpsertPostsRelationInput:{
		by:"PostUniqueWhere",
		update:"PostWithoutReportPageUpdateInput",
		create:"PostWithoutReportPageCreateInput"
	},
	LocaleUpsertReportPagesRelationInput:{
		by:"ReportPageLocaleUniqueWhere",
		update:"ReportPageLocaleWithoutLocaleUpdateInput",
		create:"ReportPageLocaleWithoutLocaleCreateInput"
	},
	GivenGiftsPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutGivenGiftsPagesUpdateInput",
		create:"LocaleWithoutGivenGiftsPagesCreateInput"
	},
	LinkableUpsertGivenGiftsPageRelationInput:{
		update:"GivenGiftsPageLocaleWithoutLinkUpdateInput",
		create:"GivenGiftsPageLocaleWithoutLinkCreateInput"
	},
	ReceivedGiftsPageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutReceivedGiftsPageUpdateInput",
		create:"LinkableWithoutReceivedGiftsPageCreateInput"
	},
	LocaleUpsertReceivedGiftsPagesRelationInput:{
		by:"ReceivedGiftsPageLocaleUniqueWhere",
		update:"ReceivedGiftsPageLocaleWithoutLocaleUpdateInput",
		create:"ReceivedGiftsPageLocaleWithoutLocaleCreateInput"
	},
	ReportPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutReportPagesUpdateInput",
		create:"LocaleWithoutReportPagesCreateInput"
	},
	LinkableUpsertReportPageRelationInput:{
		update:"ReportPageLocaleWithoutLinkUpdateInput",
		create:"ReportPageLocaleWithoutLinkCreateInput"
	},
	GivenGiftsPageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutGivenGiftsPageUpdateInput",
		create:"LinkableWithoutGivenGiftsPageCreateInput"
	},
	LocaleUpsertGivenGiftsPagesRelationInput:{
		by:"GivenGiftsPageLocaleUniqueWhere",
		update:"GivenGiftsPageLocaleWithoutLocaleUpdateInput",
		create:"GivenGiftsPageLocaleWithoutLocaleCreateInput"
	},
	PostOrganizationLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutPostOrganizationsUpdateInput",
		create:"LocaleWithoutPostOrganizationsCreateInput"
	},
	PostOrganizationLocaleUpdateDomainEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateDomainRelationInput",
		update:"LinkUpdateInput",
		upsert:"PostOrganizationLocaleUpsertDomainRelationInput"
	},
	PostOrganizationLocaleUpsertDomainRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	PostOrganizationLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"PostOrganizationLocaleUpsertSeoRelationInput"
	},
	PostOrganizationLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	PostOrganizationLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostOrganizationLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"PostOrganizationLocaleUpsertContentRelationInput"
	},
	PostOrganizationLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	LinkableUpsertPostOrganizationRelationInput:{
		update:"PostOrganizationLocaleWithoutLinkUpdateInput",
		create:"PostOrganizationLocaleWithoutLinkCreateInput"
	},
	PostLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutPostUpdateInput",
		create:"LinkableWithoutPostCreateInput"
	},
	PostUpsertLocalesRelationInput:{
		by:"PostLocaleUniqueWhere",
		update:"PostLocaleWithoutRootUpdateInput",
		create:"PostLocaleWithoutRootCreateInput"
	},
	TileItemUpsertPostRelationInput:{
		update:"PostUpdateInput",
		create:"PostCreateInput"
	},
	TileItemUpdateAreaEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput",
		connectOrCreate:"TileItemConnectOrCreateAreaRelationInput",
		update:"PostAreaUpdateInput",
		upsert:"TileItemUpsertAreaRelationInput"
	},
	TileItemUpsertAreaRelationInput:{
		update:"PostAreaUpdateInput",
		create:"PostAreaCreateInput"
	},
	TileItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"TileItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"TileItemUpsertImageRelationInput"
	},
	TileItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	TileItemUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"TileItemConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"TileItemUpsertLinkRelationInput"
	},
	TileItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	TileItemUpdateOrganizationEntityRelationInput:{
		connect:"PostOrganizationUniqueWhere",
		create:"PostOrganizationCreateInput",
		connectOrCreate:"TileItemConnectOrCreateOrganizationRelationInput",
		update:"PostOrganizationUpdateInput",
		upsert:"TileItemUpsertOrganizationRelationInput"
	},
	TileItemUpsertOrganizationRelationInput:{
		update:"PostOrganizationUpdateInput",
		create:"PostOrganizationCreateInput"
	},
	TileListUpsertItemsRelationInput:{
		by:"TileItemUniqueWhere",
		update:"TileItemWithoutListUpdateInput",
		create:"TileItemWithoutListCreateInput"
	},
	TileListUpdateAreaTypeEntityRelationInput:{
		connect:"PostAreaUniqueWhere",
		create:"PostAreaCreateInput",
		connectOrCreate:"TileListConnectOrCreateAreaTypeRelationInput",
		update:"PostAreaUpdateInput",
		upsert:"TileListUpsertAreaTypeRelationInput"
	},
	TileListUpsertAreaTypeRelationInput:{
		update:"PostAreaUpdateInput",
		create:"PostAreaCreateInput"
	},
	FeedPageLocaleUpsertHeroTilesRelationInput:{
		update:"TileListUpdateInput",
		create:"TileListCreateInput"
	},
	FeedPageLocaleUpdateSectionListEntityRelationInput:{
		create:"FeedPageSectionWithoutFeedPageLocaleCreateInput",
		update:"FeedPageLocaleUpdateSectionListRelationInput",
		upsert:"FeedPageLocaleUpsertSectionListRelationInput",
		connect:"FeedPageSectionUniqueWhere",
		disconnect:"FeedPageSectionUniqueWhere",
		delete:"FeedPageSectionUniqueWhere"
	},
	FeedPageLocaleUpdateSectionListRelationInput:{
		by:"FeedPageSectionUniqueWhere",
		data:"FeedPageSectionWithoutFeedPageLocaleUpdateInput"
	},
	FeedPageSectionWithoutFeedPageLocaleUpdateInput:{
		tileStripeList:"FeedPageSectionUpdateTileStripeListEntityRelationInput"
	},
	FeedPageSectionUpdateTileStripeListEntityRelationInput:{
		create:"FeedPageTileStripeWithoutSectionCreateInput",
		update:"FeedPageSectionUpdateTileStripeListRelationInput",
		upsert:"FeedPageSectionUpsertTileStripeListRelationInput",
		connect:"FeedPageTileStripeUniqueWhere",
		disconnect:"FeedPageTileStripeUniqueWhere",
		delete:"FeedPageTileStripeUniqueWhere"
	},
	FeedPageSectionUpdateTileStripeListRelationInput:{
		by:"FeedPageTileStripeUniqueWhere",
		data:"FeedPageTileStripeWithoutSectionUpdateInput"
	},
	FeedPageTileStripeWithoutSectionUpdateInput:{
		tileList:"FeedPageTileStripeUpdateTileListEntityRelationInput"
	},
	FeedPageTileStripeUpdateTileListEntityRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListCreateInput",
		connectOrCreate:"FeedPageTileStripeConnectOrCreateTileListRelationInput",
		update:"TileListUpdateInput",
		upsert:"FeedPageTileStripeUpsertTileListRelationInput"
	},
	FeedPageTileStripeUpsertTileListRelationInput:{
		update:"TileListUpdateInput",
		create:"TileListCreateInput"
	},
	FeedPageSectionUpsertTileStripeListRelationInput:{
		by:"FeedPageTileStripeUniqueWhere",
		update:"FeedPageTileStripeWithoutSectionUpdateInput",
		create:"FeedPageTileStripeWithoutSectionCreateInput"
	},
	FeedPageLocaleUpsertSectionListRelationInput:{
		by:"FeedPageSectionUniqueWhere",
		update:"FeedPageSectionWithoutFeedPageLocaleUpdateInput",
		create:"FeedPageSectionWithoutFeedPageLocaleCreateInput"
	},
	FeedPageLocaleUpdateCardListEntityRelationInput:{
		connect:"CardListUniqueWhere",
		create:"CardListCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateCardListRelationInput",
		update:"CardListUpdateInput",
		upsert:"FeedPageLocaleUpsertCardListRelationInput"
	},
	CardListUpdateInput:{
		items:"CardListUpdateItemsEntityRelationInput"
	},
	CardListUpdateItemsEntityRelationInput:{
		create:"CardItemWithoutListCreateInput",
		update:"CardListUpdateItemsRelationInput",
		upsert:"CardListUpsertItemsRelationInput",
		connect:"CardItemUniqueWhere",
		disconnect:"CardItemUniqueWhere",
		delete:"CardItemUniqueWhere"
	},
	CardListUpdateItemsRelationInput:{
		by:"CardItemUniqueWhere",
		data:"CardItemWithoutListUpdateInput"
	},
	CardItemWithoutListUpdateInput:{
		link:"CardItemUpdateLinkEntityRelationInput"
	},
	CardItemUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"CardItemConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"CardItemUpsertLinkRelationInput"
	},
	CardItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	CardListUpsertItemsRelationInput:{
		by:"CardItemUniqueWhere",
		update:"CardItemWithoutListUpdateInput",
		create:"CardItemWithoutListCreateInput"
	},
	FeedPageLocaleUpsertCardListRelationInput:{
		update:"CardListUpdateInput",
		create:"CardListCreateInput"
	},
	FeedPageLocaleUpdateStoryGuideListEntityRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateStoryGuideListRelationInput",
		update:"StoryGuideListUpdateInput",
		upsert:"FeedPageLocaleUpsertStoryGuideListRelationInput"
	},
	FeedPageLocaleUpsertStoryGuideListRelationInput:{
		update:"StoryGuideListUpdateInput",
		create:"StoryGuideListCreateInput"
	},
	LocaleUpsertFeedPagesRelationInput:{
		by:"FeedPageLocaleUniqueWhere",
		update:"FeedPageLocaleWithoutLocaleUpdateInput",
		create:"FeedPageLocaleWithoutLocaleCreateInput"
	},
	PostRevisionLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutPostRevisionsUpdateInput",
		create:"LocaleWithoutPostRevisionsCreateInput"
	},
	PostRevisionLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"PostRevisionLocaleUpsertContentRelationInput"
	},
	PostRevisionLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	PostRevisionLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"PostRevisionLocaleUpsertSeoRelationInput"
	},
	PostRevisionLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	PostRevisionLocaleUpdateLeadContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostRevisionLocaleConnectOrCreateLeadContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"PostRevisionLocaleUpsertLeadContentRelationInput"
	},
	PostRevisionLocaleUpsertLeadContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	PostRevisionUpsertLocalesRelationInput:{
		by:"PostRevisionLocaleUniqueWhere",
		update:"PostRevisionLocaleWithoutRootUpdateInput",
		create:"PostRevisionLocaleWithoutRootCreateInput"
	},
	PostUpsertActiveRevisionRelationInput:{
		update:"PostRevisionUpdateInput",
		create:"PostRevisionCreateInput"
	},
	PostRevisionUpsertPostRelationInput:{
		update:"PostWithoutRevisionsUpdateInput",
		create:"PostWithoutRevisionsCreateInput"
	},
	PostRevisionLocaleUpsertRootRelationInput:{
		update:"PostRevisionWithoutLocalesUpdateInput",
		create:"PostRevisionWithoutLocalesCreateInput"
	},
	LocaleUpsertPostRevisionsRelationInput:{
		by:"PostRevisionLocaleUniqueWhere",
		update:"PostRevisionLocaleWithoutLocaleUpdateInput",
		create:"PostRevisionLocaleWithoutLocaleCreateInput"
	},
	SentPaymentLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutSentPaymentsUpdateInput",
		create:"LocaleWithoutSentPaymentsCreateInput"
	},
	SentPaymentUpsertLocalesRelationInput:{
		by:"SentPaymentLocaleUniqueWhere",
		update:"SentPaymentLocaleWithoutRootUpdateInput",
		create:"SentPaymentLocaleWithoutRootCreateInput"
	},
	PostAreaUpsertSentPaymentsRelationInput:{
		by:"SentPaymentUniqueWhere",
		update:"SentPaymentWithoutAreaUpdateInput",
		create:"SentPaymentWithoutAreaCreateInput"
	},
	PostOrganizationUpsertAreaRelationInput:{
		update:"PostAreaUpdateInput",
		create:"PostAreaCreateInput"
	},
	PostOrganizationUpdateSentPaymentsEntityRelationInput:{
		create:"SentPaymentWithoutOrganizationCreateInput",
		update:"PostOrganizationUpdateSentPaymentsRelationInput",
		upsert:"PostOrganizationUpsertSentPaymentsRelationInput",
		connect:"SentPaymentUniqueWhere",
		disconnect:"SentPaymentUniqueWhere",
		delete:"SentPaymentUniqueWhere"
	},
	PostOrganizationUpdateSentPaymentsRelationInput:{
		by:"SentPaymentUniqueWhere",
		data:"SentPaymentWithoutOrganizationUpdateInput"
	},
	SentPaymentWithoutOrganizationUpdateInput:{
		createdAt:"DateTime",
		sendAt:"DateTime",
		currency:"SentPaymentUpdateCurrencyEntityRelationInput",
		area:"SentPaymentUpdateAreaEntityRelationInput",
		locales:"SentPaymentUpdateLocalesEntityRelationInput"
	},
	PostOrganizationUpsertSentPaymentsRelationInput:{
		by:"SentPaymentUniqueWhere",
		update:"SentPaymentWithoutOrganizationUpdateInput",
		create:"SentPaymentWithoutOrganizationCreateInput"
	},
	PostOrganizationLocaleUpsertRootRelationInput:{
		update:"PostOrganizationWithoutLocalesUpdateInput",
		create:"PostOrganizationWithoutLocalesCreateInput"
	},
	LocaleUpsertPostOrganizationsRelationInput:{
		by:"PostOrganizationLocaleUniqueWhere",
		update:"PostOrganizationLocaleWithoutLocaleUpdateInput",
		create:"PostOrganizationLocaleWithoutLocaleCreateInput"
	},
	PostAreaLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutPostAreasUpdateInput",
		create:"LocaleWithoutPostAreasCreateInput"
	},
	PostAreaLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"PostAreaLocaleUpsertSeoRelationInput"
	},
	PostAreaLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	PostAreaLocaleUpdateBannerEntityRelationInput:{
		connect:"AppBannerUniqueWhere",
		create:"AppBannerCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateBannerRelationInput",
		update:"AppBannerUpdateInput",
		upsert:"PostAreaLocaleUpsertBannerRelationInput"
	},
	AppBannerUpdateInput:{
		imageSmall:"AppBannerUpdateImageSmallEntityRelationInput",
		imageBig:"AppBannerUpdateImageBigEntityRelationInput",
		textContent:"AppBannerUpdateTextContentEntityRelationInput"
	},
	AppBannerUpdateImageSmallEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"AppBannerConnectOrCreateImageSmallRelationInput",
		update:"ImageUpdateInput",
		upsert:"AppBannerUpsertImageSmallRelationInput"
	},
	AppBannerUpsertImageSmallRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	AppBannerUpdateImageBigEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"AppBannerConnectOrCreateImageBigRelationInput",
		update:"ImageUpdateInput",
		upsert:"AppBannerUpsertImageBigRelationInput"
	},
	AppBannerUpsertImageBigRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	AppBannerUpdateTextContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"AppBannerConnectOrCreateTextContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"AppBannerUpsertTextContentRelationInput"
	},
	AppBannerUpsertTextContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	PostAreaLocaleUpsertBannerRelationInput:{
		update:"AppBannerUpdateInput",
		create:"AppBannerCreateInput"
	},
	PostAreaLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"PostAreaLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"PostAreaLocaleUpsertContentRelationInput"
	},
	PostAreaLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	LinkableUpsertPostAreaRelationInput:{
		update:"PostAreaLocaleWithoutLinkUpdateInput",
		create:"PostAreaLocaleWithoutLinkCreateInput"
	},
	PostOrganizationLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutPostOrganizationUpdateInput",
		create:"LinkableWithoutPostOrganizationCreateInput"
	},
	PostOrganizationUpsertLocalesRelationInput:{
		by:"PostOrganizationLocaleUniqueWhere",
		update:"PostOrganizationLocaleWithoutRootUpdateInput",
		create:"PostOrganizationLocaleWithoutRootCreateInput"
	},
	PostUpsertOrganizationRelationInput:{
		update:"PostOrganizationWithoutPostsUpdateInput",
		create:"PostOrganizationWithoutPostsCreateInput"
	},
	PostAreaUpsertPostsRelationInput:{
		by:"PostUniqueWhere",
		update:"PostWithoutAreaUpdateInput",
		create:"PostWithoutAreaCreateInput"
	},
	PostAreaLocaleUpsertRootRelationInput:{
		update:"PostAreaWithoutLocalesUpdateInput",
		create:"PostAreaWithoutLocalesCreateInput"
	},
	LocaleUpsertPostAreasRelationInput:{
		by:"PostAreaLocaleUniqueWhere",
		update:"PostAreaLocaleWithoutLocaleUpdateInput",
		create:"PostAreaLocaleWithoutLocaleCreateInput"
	},
	PostLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutPostsUpdateInput",
		create:"LocaleWithoutPostsCreateInput"
	},
	PostLocaleUpdateRootEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostWithoutLocalesCreateInput",
		connectOrCreate:"PostLocaleConnectOrCreateRootRelationInput",
		update:"PostWithoutLocalesUpdateInput",
		upsert:"PostLocaleUpsertRootRelationInput"
	},
	PostWithoutLocalesUpdateInput:{
		organization:"PostUpdateOrganizationEntityRelationInput",
		area:"PostUpdateAreaEntityRelationInput",
		activeRevision:"PostUpdateActiveRevisionEntityRelationInput",
		revisions:"PostUpdateRevisionsEntityRelationInput",
		state:"PostState",
		meta:"PostUpdateMetaEntityRelationInput",
		heroCarousel:"PostUpdateHeroCarouselEntityRelationInput",
		reportPage:"PostUpdateReportPageEntityRelationInput",
		content:"PostUpdateContentEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostUpdateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostUpdateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostUpdateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostUpdateFundraisingProgressEntityRelationInput"
	},
	PostLocaleUpsertRootRelationInput:{
		update:"PostWithoutLocalesUpdateInput",
		create:"PostWithoutLocalesCreateInput"
	},
	LinkableUpsertPostRelationInput:{
		update:"PostLocaleWithoutLinkUpdateInput",
		create:"PostLocaleWithoutLinkCreateInput"
	},
	LinkUpsertInternalLinkRelationInput:{
		update:"LinkableUpdateInput",
		create:"LinkableCreateInput"
	},
	ContentReferenceUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	ContentReferenceUpdatePostsEntityRelationInput:{
		create:"PostWithoutContentCreateInput",
		update:"ContentReferenceUpdatePostsRelationInput",
		upsert:"ContentReferenceUpsertPostsRelationInput",
		connect:"PostUniqueWhere",
		disconnect:"PostUniqueWhere",
		delete:"PostUniqueWhere"
	},
	ContentReferenceUpdatePostsRelationInput:{
		by:"PostUniqueWhere",
		data:"PostWithoutContentUpdateInput"
	},
	PostWithoutContentUpdateInput:{
		organization:"PostUpdateOrganizationEntityRelationInput",
		area:"PostUpdateAreaEntityRelationInput",
		activeRevision:"PostUpdateActiveRevisionEntityRelationInput",
		revisions:"PostUpdateRevisionsEntityRelationInput",
		locales:"PostUpdateLocalesEntityRelationInput",
		state:"PostState",
		meta:"PostUpdateMetaEntityRelationInput",
		heroCarousel:"PostUpdateHeroCarouselEntityRelationInput",
		reportPage:"PostUpdateReportPageEntityRelationInput",
		fundraiseEndDate:"Date",
		fundraiseCurrency:"PostUpdateFundraiseCurrencyEntityRelationInput",
		fundraiseCurrencySums:"PostUpdateFundraiseCurrencySumsEntityRelationInput",
		fundraiseSum:"PostUpdateFundraiseSumEntityRelationInput",
		fundraisingProgress:"PostUpdateFundraisingProgressEntityRelationInput"
	},
	ContentReferenceUpsertPostsRelationInput:{
		by:"PostUniqueWhere",
		update:"PostWithoutContentUpdateInput",
		create:"PostWithoutContentCreateInput"
	},
	ContentBlockUpsertReferencesRelationInput:{
		by:"ContentReferenceUniqueWhere",
		update:"ContentReferenceWithoutBlockUpdateInput",
		create:"ContentReferenceWithoutBlockCreateInput"
	},
	ContentUpsertBlocksRelationInput:{
		by:"ContentBlockUniqueWhere",
		update:"ContentBlockWithoutContentUpdateInput",
		create:"ContentBlockWithoutContentCreateInput"
	},
	PostLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	LocaleUpsertPostsRelationInput:{
		by:"PostLocaleUniqueWhere",
		update:"PostLocaleWithoutLocaleUpdateInput",
		create:"PostLocaleWithoutLocaleCreateInput"
	},
	GenericPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutGenericPagesUpdateInput",
		create:"LocaleWithoutGenericPagesCreateInput"
	},
	LinkableUpsertGenericPageRelationInput:{
		update:"GenericPageLocaleWithoutLinkUpdateInput",
		create:"GenericPageLocaleWithoutLinkCreateInput"
	},
	PostAreaLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutPostAreaUpdateInput",
		create:"LinkableWithoutPostAreaCreateInput"
	},
	PostAreaUpsertLocalesRelationInput:{
		by:"PostAreaLocaleUniqueWhere",
		update:"PostAreaLocaleWithoutRootUpdateInput",
		create:"PostAreaLocaleWithoutRootCreateInput"
	},
	PostUpsertAreaRelationInput:{
		update:"PostAreaWithoutPostsUpdateInput",
		create:"PostAreaWithoutPostsCreateInput"
	},
	PostOrganizationUpsertPostsRelationInput:{
		by:"PostUniqueWhere",
		update:"PostWithoutOrganizationUpdateInput",
		create:"PostWithoutOrganizationCreateInput"
	},
	PostOrganizationListItemUpsertItemRelationInput:{
		update:"PostOrganizationUpdateInput",
		create:"PostOrganizationCreateInput"
	},
	PostOrganizationListItemUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"PostOrganizationListItemConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"PostOrganizationListItemUpsertLinkRelationInput"
	},
	PostOrganizationListItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	PostOrganizationListItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"PostOrganizationListItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"PostOrganizationListItemUpsertImageRelationInput"
	},
	PostOrganizationListItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PostOrganizationListUpsertItemsRelationInput:{
		by:"PostOrganizationListItemUniqueWhere",
		update:"PostOrganizationListItemWithoutListUpdateInput",
		create:"PostOrganizationListItemWithoutListCreateInput"
	},
	GeneralUpsertOrganizationListRelationInput:{
		update:"PostOrganizationListUpdateInput",
		create:"PostOrganizationListCreateInput"
	},
	GeneralLocaleUpsertRootRelationInput:{
		update:"GeneralWithoutLocalesUpdateInput",
		create:"GeneralWithoutLocalesCreateInput"
	},
	GeneralLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"GeneralLocaleUpsertSeoRelationInput"
	},
	GeneralLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	GeneralLocaleUpdateAppStoreLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateAppStoreLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"GeneralLocaleUpsertAppStoreLinkRelationInput"
	},
	GeneralLocaleUpsertAppStoreLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	GeneralLocaleUpdateGooglePlayLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"GeneralLocaleUpsertGooglePlayLinkRelationInput"
	},
	GeneralLocaleUpsertGooglePlayLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	LocaleUpsertGeneralsRelationInput:{
		by:"GeneralLocaleUniqueWhere",
		update:"GeneralLocaleWithoutLocaleUpdateInput",
		create:"GeneralLocaleWithoutLocaleCreateInput"
	},
	ReportNavigationLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutReportNavigationsUpdateInput",
		create:"LocaleWithoutReportNavigationsCreateInput"
	},
	GenericPageUpsertReportNavigationRelationInput:{
		by:"ReportNavigationLocaleUniqueWhere",
		update:"ReportNavigationLocaleWithoutPagesUpdateInput",
		create:"ReportNavigationLocaleWithoutPagesCreateInput"
	},
	GenericPageLocaleUpsertRootRelationInput:{
		update:"GenericPageWithoutLocalesUpdateInput",
		create:"GenericPageWithoutLocalesCreateInput"
	},
	LocaleUpsertGenericPagesRelationInput:{
		by:"GenericPageLocaleUniqueWhere",
		update:"GenericPageLocaleWithoutLocaleUpdateInput",
		create:"GenericPageLocaleWithoutLocaleCreateInput"
	},
	GeneralLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutGeneralsUpdateInput",
		create:"LocaleWithoutGeneralsCreateInput"
	},
	GeneralUpsertLocalesRelationInput:{
		by:"GeneralLocaleUniqueWhere",
		update:"GeneralLocaleWithoutRootUpdateInput",
		create:"GeneralLocaleWithoutRootCreateInput"
	},
	GenericPageCreateInput:{
		id:"UUID",
		locales:"GenericPageCreateLocalesEntityRelationInput",
		type:"GenericPageType",
		reportNavigation:"GenericPageCreateReportNavigationEntityRelationInput"
	},
	GenericPageUpdateInput:{
		locales:"GenericPageUpdateLocalesEntityRelationInput",
		type:"GenericPageType",
		reportNavigation:"GenericPageUpdateReportNavigationEntityRelationInput"
	},
	ContentBlockCreateInput:{
		id:"UUID",
		content:"ContentBlockCreateContentEntityRelationInput",
		references:"ContentBlockCreateReferencesEntityRelationInput"
	},
	ContentBlockUpdateInput:{
		content:"ContentBlockUpdateContentEntityRelationInput",
		references:"ContentBlockUpdateReferencesEntityRelationInput"
	},
	ContentReferenceCreateInput:{
		id:"UUID",
		type:"ContentReferenceType",
		block:"ContentReferenceCreateBlockEntityRelationInput",
		image:"ContentReferenceCreateImageEntityRelationInput",
		linkables:"ContentReferenceCreateLinkablesEntityRelationInput",
		video:"ContentReferenceCreateVideoEntityRelationInput",
		link:"ContentReferenceCreateLinkEntityRelationInput",
		contentAlignment:"ContentAlignment",
		valueList:"ContentReferenceCreateValueListEntityRelationInput",
		imageLinkList:"ContentReferenceCreateImageLinkListEntityRelationInput",
		areaList:"ContentReferenceCreateAreaListEntityRelationInput",
		accordion:"ContentReferenceCreateAccordionEntityRelationInput",
		media:"ContentReferenceCreateMediaEntityRelationInput",
		memberList:"ContentReferenceCreateMemberListEntityRelationInput",
		asideMediaContentLayout:"AsideMediaContentLayout",
		form:"ContentReferenceCreateFormEntityRelationInput",
		contentWithoutBlocks:"ContentReferenceCreateContentWithoutBlocksEntityRelationInput",
		heroCarousel:"ContentReferenceCreateHeroCarouselEntityRelationInput",
		organizationList:"ContentReferenceCreateOrganizationListEntityRelationInput",
		posts:"ContentReferenceCreatePostsEntityRelationInput",
		textImageList:"ContentReferenceCreateTextImageListEntityRelationInput"
	},
	ContentReferenceUpdateInput:{
		type:"ContentReferenceType",
		block:"ContentReferenceUpdateBlockEntityRelationInput",
		image:"ContentReferenceUpdateImageEntityRelationInput",
		linkables:"ContentReferenceUpdateLinkablesEntityRelationInput",
		video:"ContentReferenceUpdateVideoEntityRelationInput",
		link:"ContentReferenceUpdateLinkEntityRelationInput",
		contentAlignment:"ContentAlignment",
		valueList:"ContentReferenceUpdateValueListEntityRelationInput",
		imageLinkList:"ContentReferenceUpdateImageLinkListEntityRelationInput",
		areaList:"ContentReferenceUpdateAreaListEntityRelationInput",
		accordion:"ContentReferenceUpdateAccordionEntityRelationInput",
		media:"ContentReferenceUpdateMediaEntityRelationInput",
		memberList:"ContentReferenceUpdateMemberListEntityRelationInput",
		asideMediaContentLayout:"AsideMediaContentLayout",
		form:"ContentReferenceUpdateFormEntityRelationInput",
		contentWithoutBlocks:"ContentReferenceUpdateContentWithoutBlocksEntityRelationInput",
		heroCarousel:"ContentReferenceUpdateHeroCarouselEntityRelationInput",
		organizationList:"ContentReferenceUpdateOrganizationListEntityRelationInput",
		posts:"ContentReferenceUpdatePostsEntityRelationInput",
		textImageList:"ContentReferenceUpdateTextImageListEntityRelationInput"
	},
	GeneralLocaleCreateInput:{
		id:"UUID",
		root:"GeneralLocaleCreateRootEntityRelationInput",
		locale:"GeneralLocaleCreateLocaleEntityRelationInput",
		seo:"GeneralLocaleCreateSeoEntityRelationInput",
		appStoreLink:"GeneralLocaleCreateAppStoreLinkEntityRelationInput",
		googlePlayLink:"GeneralLocaleCreateGooglePlayLinkEntityRelationInput"
	},
	GeneralLocaleUpdateInput:{
		root:"GeneralLocaleUpdateRootEntityRelationInput",
		locale:"GeneralLocaleUpdateLocaleEntityRelationInput",
		seo:"GeneralLocaleUpdateSeoEntityRelationInput",
		appStoreLink:"GeneralLocaleUpdateAppStoreLinkEntityRelationInput",
		googlePlayLink:"GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"
	},
	GenericPageLocaleCreateInput:{
		id:"UUID",
		root:"GenericPageLocaleCreateRootEntityRelationInput",
		locale:"GenericPageLocaleCreateLocaleEntityRelationInput",
		content:"GenericPageLocaleCreateContentEntityRelationInput",
		seo:"GenericPageLocaleCreateSeoEntityRelationInput",
		link:"GenericPageLocaleCreateLinkEntityRelationInput"
	},
	GenericPageLocaleUpdateInput:{
		root:"GenericPageLocaleUpdateRootEntityRelationInput",
		locale:"GenericPageLocaleUpdateLocaleEntityRelationInput",
		content:"GenericPageLocaleUpdateContentEntityRelationInput",
		seo:"GenericPageLocaleUpdateSeoEntityRelationInput",
		link:"GenericPageLocaleUpdateLinkEntityRelationInput"
	},
	PostLocaleCreateInput:{
		id:"UUID",
		content:"PostLocaleCreateContentEntityRelationInput",
		seo:"PostLocaleCreateSeoEntityRelationInput",
		link:"PostLocaleCreateLinkEntityRelationInput",
		locale:"PostLocaleCreateLocaleEntityRelationInput",
		root:"PostLocaleCreateRootEntityRelationInput",
		publishedAt:"DateTime"
	},
	PostLocaleUpdateInput:{
		content:"PostLocaleUpdateContentEntityRelationInput",
		seo:"PostLocaleUpdateSeoEntityRelationInput",
		link:"PostLocaleUpdateLinkEntityRelationInput",
		locale:"PostLocaleUpdateLocaleEntityRelationInput",
		root:"PostLocaleUpdateRootEntityRelationInput",
		publishedAt:"DateTime"
	},
	PostAreaLocaleCreateInput:{
		id:"UUID",
		link:"PostAreaLocaleCreateLinkEntityRelationInput",
		root:"PostAreaLocaleCreateRootEntityRelationInput",
		locale:"PostAreaLocaleCreateLocaleEntityRelationInput",
		seo:"PostAreaLocaleCreateSeoEntityRelationInput",
		banner:"PostAreaLocaleCreateBannerEntityRelationInput",
		content:"PostAreaLocaleCreateContentEntityRelationInput"
	},
	PostAreaLocaleUpdateInput:{
		link:"PostAreaLocaleUpdateLinkEntityRelationInput",
		root:"PostAreaLocaleUpdateRootEntityRelationInput",
		locale:"PostAreaLocaleUpdateLocaleEntityRelationInput",
		seo:"PostAreaLocaleUpdateSeoEntityRelationInput",
		banner:"PostAreaLocaleUpdateBannerEntityRelationInput",
		content:"PostAreaLocaleUpdateContentEntityRelationInput"
	},
	PostOrganizationLocaleCreateInput:{
		id:"UUID",
		link:"PostOrganizationLocaleCreateLinkEntityRelationInput",
		root:"PostOrganizationLocaleCreateRootEntityRelationInput",
		locale:"PostOrganizationLocaleCreateLocaleEntityRelationInput",
		domain:"PostOrganizationLocaleCreateDomainEntityRelationInput",
		seo:"PostOrganizationLocaleCreateSeoEntityRelationInput",
		content:"PostOrganizationLocaleCreateContentEntityRelationInput"
	},
	PostOrganizationLocaleUpdateInput:{
		link:"PostOrganizationLocaleUpdateLinkEntityRelationInput",
		root:"PostOrganizationLocaleUpdateRootEntityRelationInput",
		locale:"PostOrganizationLocaleUpdateLocaleEntityRelationInput",
		domain:"PostOrganizationLocaleUpdateDomainEntityRelationInput",
		seo:"PostOrganizationLocaleUpdateSeoEntityRelationInput",
		content:"PostOrganizationLocaleUpdateContentEntityRelationInput"
	},
	DonationCreateInput:{
		id:"UUID",
		unique:"One",
		regionList:"DonationCreateRegionListEntityRelationInput"
	},
	DonationCreateRegionListEntityRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListWithoutDonationCreateInput",
		connectOrCreate:"DonationConnectOrCreateRegionListRelationInput"
	},
	DonationAmountsRegionListWithoutDonationCreateInput:{
		id:"UUID",
		regions:"DonationAmountsRegionListCreateRegionsEntityRelationInput"
	},
	DonationConnectOrCreateRegionListRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListWithoutDonationCreateInput"
	},
	DonationUpdateInput:{
		unique:"One",
		regionList:"DonationUpdateRegionListEntityRelationInput"
	},
	DonationUpdateRegionListEntityRelationInput:{
		connect:"DonationAmountsRegionListUniqueWhere",
		create:"DonationAmountsRegionListWithoutDonationCreateInput",
		connectOrCreate:"DonationConnectOrCreateRegionListRelationInput",
		update:"DonationAmountsRegionListWithoutDonationUpdateInput",
		upsert:"DonationUpsertRegionListRelationInput"
	},
	DonationAmountsRegionListWithoutDonationUpdateInput:{
		regions:"DonationAmountsRegionListUpdateRegionsEntityRelationInput"
	},
	DonationUpsertRegionListRelationInput:{
		update:"DonationAmountsRegionListWithoutDonationUpdateInput",
		create:"DonationAmountsRegionListWithoutDonationCreateInput"
	},
	DonationAmountItemCreateInput:{
		id:"UUID",
		regionItem:"DonationAmountItemCreateRegionItemEntityRelationInput"
	},
	DonationAmountItemCreateRegionItemEntityRelationInput:{
		connect:"DonationAmountsRegionItemUniqueWhere",
		create:"DonationAmountsRegionItemWithoutItemsCreateInput",
		connectOrCreate:"DonationAmountItemConnectOrCreateRegionItemRelationInput"
	},
	DonationAmountsRegionItemWithoutItemsCreateInput:{
		id:"UUID",
		list:"DonationAmountsRegionItemCreateListEntityRelationInput",
		region:"DonationAmountsRegionItemCreateRegionEntityRelationInput"
	},
	DonationAmountItemConnectOrCreateRegionItemRelationInput:{
		connect:"DonationAmountsRegionItemUniqueWhere",
		create:"DonationAmountsRegionItemWithoutItemsCreateInput"
	},
	DonationAmountItemUpdateInput:{
		regionItem:"DonationAmountItemUpdateRegionItemEntityRelationInput"
	},
	DonationAmountItemUpdateRegionItemEntityRelationInput:{
		connect:"DonationAmountsRegionItemUniqueWhere",
		create:"DonationAmountsRegionItemWithoutItemsCreateInput",
		connectOrCreate:"DonationAmountItemConnectOrCreateRegionItemRelationInput",
		update:"DonationAmountsRegionItemWithoutItemsUpdateInput",
		upsert:"DonationAmountItemUpsertRegionItemRelationInput"
	},
	DonationAmountsRegionItemWithoutItemsUpdateInput:{
		list:"DonationAmountsRegionItemUpdateListEntityRelationInput",
		region:"DonationAmountsRegionItemUpdateRegionEntityRelationInput"
	},
	DonationAmountItemUpsertRegionItemRelationInput:{
		update:"DonationAmountsRegionItemWithoutItemsUpdateInput",
		create:"DonationAmountsRegionItemWithoutItemsCreateInput"
	},
	DonationAmountsRegionItemCreateInput:{
		id:"UUID",
		items:"DonationAmountsRegionItemCreateItemsEntityRelationInput",
		list:"DonationAmountsRegionItemCreateListEntityRelationInput",
		region:"DonationAmountsRegionItemCreateRegionEntityRelationInput"
	},
	DonationAmountsRegionItemUpdateInput:{
		items:"DonationAmountsRegionItemUpdateItemsEntityRelationInput",
		list:"DonationAmountsRegionItemUpdateListEntityRelationInput",
		region:"DonationAmountsRegionItemUpdateRegionEntityRelationInput"
	},
	LinkItemCreateInput:{
		id:"UUID",
		list:"LinkItemCreateListEntityRelationInput",
		link:"LinkItemCreateLinkEntityRelationInput"
	},
	LinkItemCreateListEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListWithoutItemsCreateInput",
		connectOrCreate:"LinkItemConnectOrCreateListRelationInput"
	},
	LinkListWithoutItemsCreateInput:{
		id:"UUID"
	},
	LinkItemConnectOrCreateListRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListWithoutItemsCreateInput"
	},
	LinkItemUpdateInput:{
		list:"LinkItemUpdateListEntityRelationInput",
		link:"LinkItemUpdateLinkEntityRelationInput"
	},
	LinkItemUpdateListEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListWithoutItemsCreateInput",
		connectOrCreate:"LinkItemConnectOrCreateListRelationInput",
		update:"LinkListWithoutItemsUpdateInput",
		upsert:"LinkItemUpsertListRelationInput"
	},
	LinkListWithoutItemsUpdateInput:{

	},
	LinkItemUpsertListRelationInput:{
		update:"LinkListWithoutItemsUpdateInput",
		create:"LinkListWithoutItemsCreateInput"
	},
	HeaderCreateInput:{
		id:"UUID",
		unique:"One",
		logo:"HeaderCreateLogoEntityRelationInput",
		locales:"HeaderCreateLocalesEntityRelationInput",
		organizationList:"HeaderCreateOrganizationListEntityRelationInput"
	},
	HeaderCreateLocalesEntityRelationInput:{
		connect:"HeaderLocaleUniqueWhere",
		create:"HeaderLocaleWithoutRootCreateInput",
		connectOrCreate:"HeaderConnectOrCreateLocalesRelationInput"
	},
	HeaderLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"HeaderLocaleCreateLocaleEntityRelationInput",
		links:"HeaderLocaleCreateLinksEntityRelationInput"
	},
	HeaderLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHeadersCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutHeadersCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	HeaderLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHeadersCreateInput"
	},
	HeaderConnectOrCreateLocalesRelationInput:{
		connect:"HeaderLocaleUniqueWhere",
		create:"HeaderLocaleWithoutRootCreateInput"
	},
	HeaderUpdateInput:{
		unique:"One",
		logo:"HeaderUpdateLogoEntityRelationInput",
		locales:"HeaderUpdateLocalesEntityRelationInput",
		organizationList:"HeaderUpdateOrganizationListEntityRelationInput"
	},
	HeaderUpdateLocalesEntityRelationInput:{
		create:"HeaderLocaleWithoutRootCreateInput",
		update:"HeaderUpdateLocalesRelationInput",
		upsert:"HeaderUpsertLocalesRelationInput",
		connect:"HeaderLocaleUniqueWhere",
		disconnect:"HeaderLocaleUniqueWhere",
		delete:"HeaderLocaleUniqueWhere"
	},
	HeaderUpdateLocalesRelationInput:{
		by:"HeaderLocaleUniqueWhere",
		data:"HeaderLocaleWithoutRootUpdateInput"
	},
	HeaderLocaleWithoutRootUpdateInput:{
		locale:"HeaderLocaleUpdateLocaleEntityRelationInput",
		links:"HeaderLocaleUpdateLinksEntityRelationInput"
	},
	HeaderLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHeadersCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutHeadersUpdateInput",
		upsert:"HeaderLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutHeadersUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	HeaderLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutHeadersUpdateInput",
		create:"LocaleWithoutHeadersCreateInput"
	},
	HeaderUpsertLocalesRelationInput:{
		by:"HeaderLocaleUniqueWhere",
		update:"HeaderLocaleWithoutRootUpdateInput",
		create:"HeaderLocaleWithoutRootCreateInput"
	},
	HeaderLocaleCreateInput:{
		id:"UUID",
		root:"HeaderLocaleCreateRootEntityRelationInput",
		locale:"HeaderLocaleCreateLocaleEntityRelationInput",
		links:"HeaderLocaleCreateLinksEntityRelationInput"
	},
	HeaderLocaleUpdateInput:{
		root:"HeaderLocaleUpdateRootEntityRelationInput",
		locale:"HeaderLocaleUpdateLocaleEntityRelationInput",
		links:"HeaderLocaleUpdateLinksEntityRelationInput"
	},
	FooterCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"FooterCreateLocalesEntityRelationInput",
		logo:"FooterCreateLogoEntityRelationInput"
	},
	FooterCreateLocalesEntityRelationInput:{
		connect:"FooterLocaleUniqueWhere",
		create:"FooterLocaleWithoutRootCreateInput",
		connectOrCreate:"FooterConnectOrCreateLocalesRelationInput"
	},
	FooterLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"FooterLocaleCreateLocaleEntityRelationInput",
		linkList:"FooterLocaleCreateLinkListEntityRelationInput",
		addressInfo:"FooterLocaleCreateAddressInfoEntityRelationInput",
		imageLinkList:"FooterLocaleCreateImageLinkListEntityRelationInput"
	},
	FooterLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFootersCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutFootersCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	FooterLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFootersCreateInput"
	},
	FooterConnectOrCreateLocalesRelationInput:{
		connect:"FooterLocaleUniqueWhere",
		create:"FooterLocaleWithoutRootCreateInput"
	},
	FooterUpdateInput:{
		unique:"One",
		locales:"FooterUpdateLocalesEntityRelationInput",
		logo:"FooterUpdateLogoEntityRelationInput"
	},
	FooterUpdateLocalesEntityRelationInput:{
		create:"FooterLocaleWithoutRootCreateInput",
		update:"FooterUpdateLocalesRelationInput",
		upsert:"FooterUpsertLocalesRelationInput",
		connect:"FooterLocaleUniqueWhere",
		disconnect:"FooterLocaleUniqueWhere",
		delete:"FooterLocaleUniqueWhere"
	},
	FooterUpdateLocalesRelationInput:{
		by:"FooterLocaleUniqueWhere",
		data:"FooterLocaleWithoutRootUpdateInput"
	},
	FooterLocaleWithoutRootUpdateInput:{
		locale:"FooterLocaleUpdateLocaleEntityRelationInput",
		linkList:"FooterLocaleUpdateLinkListEntityRelationInput",
		addressInfo:"FooterLocaleUpdateAddressInfoEntityRelationInput",
		imageLinkList:"FooterLocaleUpdateImageLinkListEntityRelationInput"
	},
	FooterLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFootersCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutFootersUpdateInput",
		upsert:"FooterLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutFootersUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	FooterLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutFootersUpdateInput",
		create:"LocaleWithoutFootersCreateInput"
	},
	FooterUpsertLocalesRelationInput:{
		by:"FooterLocaleUniqueWhere",
		update:"FooterLocaleWithoutRootUpdateInput",
		create:"FooterLocaleWithoutRootCreateInput"
	},
	FooterLocaleCreateInput:{
		id:"UUID",
		root:"FooterLocaleCreateRootEntityRelationInput",
		locale:"FooterLocaleCreateLocaleEntityRelationInput",
		linkList:"FooterLocaleCreateLinkListEntityRelationInput",
		addressInfo:"FooterLocaleCreateAddressInfoEntityRelationInput",
		imageLinkList:"FooterLocaleCreateImageLinkListEntityRelationInput"
	},
	FooterLocaleUpdateInput:{
		root:"FooterLocaleUpdateRootEntityRelationInput",
		locale:"FooterLocaleUpdateLocaleEntityRelationInput",
		linkList:"FooterLocaleUpdateLinkListEntityRelationInput",
		addressInfo:"FooterLocaleUpdateAddressInfoEntityRelationInput",
		imageLinkList:"FooterLocaleUpdateImageLinkListEntityRelationInput"
	},
	PostListItemCreateInput:{
		id:"UUID",
		list:"PostListItemCreateListEntityRelationInput",
		post:"PostListItemCreatePostEntityRelationInput"
	},
	PostListItemCreateListEntityRelationInput:{
		connect:"PostListUniqueWhere",
		create:"PostListWithoutItemsCreateInput",
		connectOrCreate:"PostListItemConnectOrCreateListRelationInput"
	},
	PostListWithoutItemsCreateInput:{
		id:"UUID"
	},
	PostListItemConnectOrCreateListRelationInput:{
		connect:"PostListUniqueWhere",
		create:"PostListWithoutItemsCreateInput"
	},
	PostListItemUpdateInput:{
		list:"PostListItemUpdateListEntityRelationInput",
		post:"PostListItemUpdatePostEntityRelationInput"
	},
	PostListItemUpdateListEntityRelationInput:{
		connect:"PostListUniqueWhere",
		create:"PostListWithoutItemsCreateInput",
		connectOrCreate:"PostListItemConnectOrCreateListRelationInput",
		update:"PostListWithoutItemsUpdateInput",
		upsert:"PostListItemUpsertListRelationInput"
	},
	PostListWithoutItemsUpdateInput:{

	},
	PostListItemUpsertListRelationInput:{
		update:"PostListWithoutItemsUpdateInput",
		create:"PostListWithoutItemsCreateInput"
	},
	GenericPageAboutSettingsCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"GenericPageAboutSettingsCreateLocalesEntityRelationInput"
	},
	GenericPageAboutSettingsCreateLocalesEntityRelationInput:{
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		create:"GenericPageAboutSettingsLocaleWithoutRootCreateInput",
		connectOrCreate:"GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"
	},
	GenericPageAboutSettingsLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput",
		linkGroups:"GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"
	},
	GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPageAboutSettingsCreateInput",
		connectOrCreate:"GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutGenericPageAboutSettingsCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPageAboutSettingsCreateInput"
	},
	GenericPageAboutSettingsConnectOrCreateLocalesRelationInput:{
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		create:"GenericPageAboutSettingsLocaleWithoutRootCreateInput"
	},
	GenericPageAboutSettingsUpdateInput:{
		unique:"One",
		locales:"GenericPageAboutSettingsUpdateLocalesEntityRelationInput"
	},
	GenericPageAboutSettingsUpdateLocalesEntityRelationInput:{
		create:"GenericPageAboutSettingsLocaleWithoutRootCreateInput",
		update:"GenericPageAboutSettingsUpdateLocalesRelationInput",
		upsert:"GenericPageAboutSettingsUpsertLocalesRelationInput",
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		disconnect:"GenericPageAboutSettingsLocaleUniqueWhere",
		delete:"GenericPageAboutSettingsLocaleUniqueWhere"
	},
	GenericPageAboutSettingsUpdateLocalesRelationInput:{
		by:"GenericPageAboutSettingsLocaleUniqueWhere",
		data:"GenericPageAboutSettingsLocaleWithoutRootUpdateInput"
	},
	GenericPageAboutSettingsLocaleWithoutRootUpdateInput:{
		locale:"GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput",
		linkGroups:"GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"
	},
	GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPageAboutSettingsCreateInput",
		connectOrCreate:"GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutGenericPageAboutSettingsUpdateInput",
		upsert:"GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutGenericPageAboutSettingsUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	GenericPageAboutSettingsLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutGenericPageAboutSettingsUpdateInput",
		create:"LocaleWithoutGenericPageAboutSettingsCreateInput"
	},
	GenericPageAboutSettingsUpsertLocalesRelationInput:{
		by:"GenericPageAboutSettingsLocaleUniqueWhere",
		update:"GenericPageAboutSettingsLocaleWithoutRootUpdateInput",
		create:"GenericPageAboutSettingsLocaleWithoutRootCreateInput"
	},
	GenericPageAboutSettingsLocaleCreateInput:{
		id:"UUID",
		root:"GenericPageAboutSettingsLocaleCreateRootEntityRelationInput",
		locale:"GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput",
		linkGroups:"GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"
	},
	GenericPageAboutSettingsLocaleUpdateInput:{
		root:"GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput",
		locale:"GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput",
		linkGroups:"GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"
	},
	ValueItemCreateInput:{
		id:"UUID",
		list:"ValueItemCreateListEntityRelationInput",
		item:"ValueItemCreateItemEntityRelationInput"
	},
	ValueItemCreateListEntityRelationInput:{
		connect:"ValueListUniqueWhere",
		create:"ValueListWithoutItemsCreateInput",
		connectOrCreate:"ValueItemConnectOrCreateListRelationInput"
	},
	ValueListWithoutItemsCreateInput:{
		id:"UUID"
	},
	ValueItemConnectOrCreateListRelationInput:{
		connect:"ValueListUniqueWhere",
		create:"ValueListWithoutItemsCreateInput"
	},
	ValueItemUpdateInput:{
		list:"ValueItemUpdateListEntityRelationInput",
		item:"ValueItemUpdateItemEntityRelationInput"
	},
	ValueItemUpdateListEntityRelationInput:{
		connect:"ValueListUniqueWhere",
		create:"ValueListWithoutItemsCreateInput",
		connectOrCreate:"ValueItemConnectOrCreateListRelationInput",
		update:"ValueListWithoutItemsUpdateInput",
		upsert:"ValueItemUpsertListRelationInput"
	},
	ValueListWithoutItemsUpdateInput:{

	},
	ValueItemUpsertListRelationInput:{
		update:"ValueListWithoutItemsUpdateInput",
		create:"ValueListWithoutItemsCreateInput"
	},
	ImageLinkItemCreateInput:{
		id:"UUID",
		list:"ImageLinkItemCreateListEntityRelationInput",
		item:"ImageLinkItemCreateItemEntityRelationInput"
	},
	ImageLinkItemCreateListEntityRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListWithoutItemsCreateInput",
		connectOrCreate:"ImageLinkItemConnectOrCreateListRelationInput"
	},
	ImageLinkListWithoutItemsCreateInput:{
		id:"UUID"
	},
	ImageLinkItemConnectOrCreateListRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListWithoutItemsCreateInput"
	},
	ImageLinkItemUpdateInput:{
		list:"ImageLinkItemUpdateListEntityRelationInput",
		item:"ImageLinkItemUpdateItemEntityRelationInput"
	},
	ImageLinkItemUpdateListEntityRelationInput:{
		connect:"ImageLinkListUniqueWhere",
		create:"ImageLinkListWithoutItemsCreateInput",
		connectOrCreate:"ImageLinkItemConnectOrCreateListRelationInput",
		update:"ImageLinkListWithoutItemsUpdateInput",
		upsert:"ImageLinkItemUpsertListRelationInput"
	},
	ImageLinkListWithoutItemsUpdateInput:{

	},
	ImageLinkItemUpsertListRelationInput:{
		update:"ImageLinkListWithoutItemsUpdateInput",
		create:"ImageLinkListWithoutItemsCreateInput"
	},
	PostAreaListItemCreateInput:{
		id:"UUID",
		list:"PostAreaListItemCreateListEntityRelationInput",
		item:"PostAreaListItemCreateItemEntityRelationInput"
	},
	PostAreaListItemCreateListEntityRelationInput:{
		connect:"PostAreaListUniqueWhere",
		create:"PostAreaListWithoutItemsCreateInput",
		connectOrCreate:"PostAreaListItemConnectOrCreateListRelationInput"
	},
	PostAreaListWithoutItemsCreateInput:{
		id:"UUID"
	},
	PostAreaListItemConnectOrCreateListRelationInput:{
		connect:"PostAreaListUniqueWhere",
		create:"PostAreaListWithoutItemsCreateInput"
	},
	PostAreaListItemUpdateInput:{
		list:"PostAreaListItemUpdateListEntityRelationInput",
		item:"PostAreaListItemUpdateItemEntityRelationInput"
	},
	PostAreaListItemUpdateListEntityRelationInput:{
		connect:"PostAreaListUniqueWhere",
		create:"PostAreaListWithoutItemsCreateInput",
		connectOrCreate:"PostAreaListItemConnectOrCreateListRelationInput",
		update:"PostAreaListWithoutItemsUpdateInput",
		upsert:"PostAreaListItemUpsertListRelationInput"
	},
	PostAreaListWithoutItemsUpdateInput:{

	},
	PostAreaListItemUpsertListRelationInput:{
		update:"PostAreaListWithoutItemsUpdateInput",
		create:"PostAreaListWithoutItemsCreateInput"
	},
	AccordionItemCreateInput:{
		id:"UUID",
		list:"AccordionItemCreateListEntityRelationInput",
		descriptionContent:"AccordionItemCreateDescriptionContentEntityRelationInput"
	},
	AccordionItemCreateListEntityRelationInput:{
		connect:"AccordionUniqueWhere",
		create:"AccordionWithoutItemsCreateInput",
		connectOrCreate:"AccordionItemConnectOrCreateListRelationInput"
	},
	AccordionWithoutItemsCreateInput:{
		id:"UUID"
	},
	AccordionItemConnectOrCreateListRelationInput:{
		connect:"AccordionUniqueWhere",
		create:"AccordionWithoutItemsCreateInput"
	},
	AccordionItemUpdateInput:{
		list:"AccordionItemUpdateListEntityRelationInput",
		descriptionContent:"AccordionItemUpdateDescriptionContentEntityRelationInput"
	},
	AccordionItemUpdateListEntityRelationInput:{
		connect:"AccordionUniqueWhere",
		create:"AccordionWithoutItemsCreateInput",
		connectOrCreate:"AccordionItemConnectOrCreateListRelationInput",
		update:"AccordionWithoutItemsUpdateInput",
		upsert:"AccordionItemUpsertListRelationInput"
	},
	AccordionWithoutItemsUpdateInput:{

	},
	AccordionItemUpsertListRelationInput:{
		update:"AccordionWithoutItemsUpdateInput",
		create:"AccordionWithoutItemsCreateInput"
	},
	UserPaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		currency:"UserPaymentCreateCurrencyEntityRelationInput",
		order:"UserPaymentCreateOrderEntityRelationInput",
		csobPayment:"UserPaymentCreateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentCreateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentCreateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentCreateRegionEntityRelationInput",
		user:"UserPaymentCreateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentCreateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentCreateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentCreateMetadataEntityRelationInput"
	},
	UserPaymentUpdateInput:{
		createdAt:"DateTime",
		currency:"UserPaymentUpdateCurrencyEntityRelationInput",
		order:"UserPaymentUpdateOrderEntityRelationInput",
		csobPayment:"UserPaymentUpdateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentUpdateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentUpdateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentUpdateRegionEntityRelationInput",
		user:"UserPaymentUpdateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentUpdateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentUpdateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentUpdateMetadataEntityRelationInput"
	},
	MediumItemCreateInput:{
		id:"UUID",
		list:"MediumItemCreateListEntityRelationInput",
		medium:"MediumItemCreateMediumEntityRelationInput"
	},
	MediumItemCreateListEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListWithoutItemsCreateInput",
		connectOrCreate:"MediumItemConnectOrCreateListRelationInput"
	},
	MediumListWithoutItemsCreateInput:{
		id:"UUID"
	},
	MediumItemConnectOrCreateListRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListWithoutItemsCreateInput"
	},
	MediumItemUpdateInput:{
		list:"MediumItemUpdateListEntityRelationInput",
		medium:"MediumItemUpdateMediumEntityRelationInput"
	},
	MediumItemUpdateListEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListWithoutItemsCreateInput",
		connectOrCreate:"MediumItemConnectOrCreateListRelationInput",
		update:"MediumListWithoutItemsUpdateInput",
		upsert:"MediumItemUpsertListRelationInput"
	},
	MediumListWithoutItemsUpdateInput:{

	},
	MediumItemUpsertListRelationInput:{
		update:"MediumListWithoutItemsUpdateInput",
		create:"MediumListWithoutItemsCreateInput"
	},
	UserRecurringPaymentItemCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		payments:"UserRecurringPaymentItemCreatePaymentsEntityRelationInput",
		recurringPayment:"UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput",
		failedEmailSentAt:"DateTime",
		meta:"UserRecurringPaymentItemCreateMetaEntityRelationInput"
	},
	UserRecurringPaymentItemUpdateInput:{
		createdAt:"DateTime",
		payments:"UserRecurringPaymentItemUpdatePaymentsEntityRelationInput",
		recurringPayment:"UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput",
		failedEmailSentAt:"DateTime",
		meta:"UserRecurringPaymentItemUpdateMetaEntityRelationInput"
	},
	PostRevisionLocaleCreateInput:{
		id:"UUID",
		root:"PostRevisionLocaleCreateRootEntityRelationInput",
		locale:"PostRevisionLocaleCreateLocaleEntityRelationInput",
		content:"PostRevisionLocaleCreateContentEntityRelationInput",
		seo:"PostRevisionLocaleCreateSeoEntityRelationInput",
		leadContent:"PostRevisionLocaleCreateLeadContentEntityRelationInput"
	},
	PostRevisionLocaleUpdateInput:{
		root:"PostRevisionLocaleUpdateRootEntityRelationInput",
		locale:"PostRevisionLocaleUpdateLocaleEntityRelationInput",
		content:"PostRevisionLocaleUpdateContentEntityRelationInput",
		seo:"PostRevisionLocaleUpdateSeoEntityRelationInput",
		leadContent:"PostRevisionLocaleUpdateLeadContentEntityRelationInput"
	},
	TranslationCatalogue:{
		domain:{
			filter:"TranslationDomainWhere"
		},
		identifier:{
			filter:"TranslationCataloguesIdentifierWhere"
		},
		fallback:{
			filter:"TranslationCatalogueWhere"
		},
		values:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		valuesByKey:{
			by:"TranslationCatalogueValuesByKeyUniqueWhere",
			filter:"TranslationValueWhere"
		},
		paginateValues:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		}
	},
	TranslationDomain:{
		catalogues:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		keys:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		cataloguesByIdentifier:{
			by:"TranslationDomainCataloguesByIdentifierUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		cataloguesByValues:{
			by:"TranslationDomainCataloguesByValuesUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		keysByIdentifier:{
			by:"TranslationDomainKeysByIdentifierUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		keysByValues:{
			by:"TranslationDomainKeysByValuesUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		paginateCatalogues:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		paginateKeys:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		}
	},
	TranslationCatalogueWhere:{
		id:"UUIDCondition",
		domain:"TranslationDomainWhere",
		identifier:"TranslationCataloguesIdentifierWhere",
		fallback:"TranslationCatalogueWhere",
		values:"TranslationValueWhere",
		and:"TranslationCatalogueWhere",
		or:"TranslationCatalogueWhere",
		not:"TranslationCatalogueWhere"
	},
	TranslationDomainWhere:{
		id:"UUIDCondition",
		identifier:"StringCondition",
		name:"StringCondition",
		catalogues:"TranslationCatalogueWhere",
		keys:"TranslationKeyWhere",
		and:"TranslationDomainWhere",
		or:"TranslationDomainWhere",
		not:"TranslationDomainWhere"
	},
	TranslationKeyWhere:{
		id:"UUIDCondition",
		identifier:"StringCondition",
		contentType:"TranslationKeyContentTypeCondition",
		note:"StringCondition",
		domain:"TranslationDomainWhere",
		values:"TranslationValueWhere",
		and:"TranslationKeyWhere",
		or:"TranslationKeyWhere",
		not:"TranslationKeyWhere"
	},
	TranslationKeyContentTypeCondition:{
		and:"TranslationKeyContentTypeCondition",
		or:"TranslationKeyContentTypeCondition",
		not:"TranslationKeyContentTypeCondition",
		eq:"TranslationKeyContentType",
		notEq:"TranslationKeyContentType",
		in:"TranslationKeyContentType",
		notIn:"TranslationKeyContentType",
		lt:"TranslationKeyContentType",
		lte:"TranslationKeyContentType",
		gt:"TranslationKeyContentType",
		gte:"TranslationKeyContentType"
	},
	TranslationKeyContentType: "enum" as const,
	TranslationValueWhere:{
		id:"UUIDCondition",
		value:"StringCondition",
		catalogue:"TranslationCatalogueWhere",
		key:"TranslationKeyWhere",
		and:"TranslationValueWhere",
		or:"TranslationValueWhere",
		not:"TranslationValueWhere"
	},
	TranslationCataloguesIdentifierWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		catalogue:"TranslationCatalogueWhere",
		and:"TranslationCataloguesIdentifierWhere",
		or:"TranslationCataloguesIdentifierWhere",
		not:"TranslationCataloguesIdentifierWhere"
	},
	TranslationCatalogueOrderBy:{
		id:"OrderDirection",
		domain:"TranslationDomainOrderBy",
		identifier:"TranslationCataloguesIdentifierOrderBy",
		fallback:"TranslationCatalogueOrderBy"
	},
	TranslationDomainOrderBy:{
		id:"OrderDirection",
		identifier:"OrderDirection",
		name:"OrderDirection"
	},
	TranslationCataloguesIdentifierOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection"
	},
	TranslationKey:{
		domain:{
			filter:"TranslationDomainWhere"
		},
		values:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		valuesByCatalogue:{
			by:"TranslationKeyValuesByCatalogueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		paginateValues:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		}
	},
	TranslationValue:{
		catalogue:{
			filter:"TranslationCatalogueWhere"
		},
		key:{
			filter:"TranslationKeyWhere"
		}
	},
	TranslationValueOrderBy:{
		id:"OrderDirection",
		value:"OrderDirection",
		catalogue:"TranslationCatalogueOrderBy",
		key:"TranslationKeyOrderBy"
	},
	TranslationKeyOrderBy:{
		id:"OrderDirection",
		identifier:"OrderDirection",
		contentType:"OrderDirection",
		note:"OrderDirection",
		domain:"TranslationDomainOrderBy"
	},
	TranslationKeyValuesByCatalogueUniqueWhere:{
		catalogue:"TranslationCatalogueUniqueWhere"
	},
	TranslationCatalogueUniqueWhere:{
		id:"UUID",
		domain:"TranslationDomainUniqueWhere",
		identifier:"TranslationCataloguesIdentifierUniqueWhere",
		values:"TranslationValueUniqueWhere"
	},
	TranslationDomainUniqueWhere:{
		id:"UUID",
		catalogues:"TranslationCatalogueUniqueWhere",
		keys:"TranslationKeyUniqueWhere"
	},
	TranslationKeyUniqueWhere:{
		id:"UUID",
		domain:"TranslationDomainUniqueWhere",
		values:"TranslationValueUniqueWhere"
	},
	TranslationValueUniqueWhere:{
		id:"UUID",
		catalogue:"TranslationCatalogueUniqueWhere",
		key:"TranslationKeyUniqueWhere"
	},
	TranslationCataloguesIdentifierUniqueWhere:{
		id:"UUID",
		catalogue:"TranslationCatalogueUniqueWhere"
	},
	TranslationDomainCataloguesByIdentifierUniqueWhere:{
		identifier:"TranslationCataloguesIdentifierUniqueWhere"
	},
	TranslationDomainCataloguesByValuesUniqueWhere:{
		values:"TranslationValueUniqueWhere"
	},
	TranslationDomainKeysByIdentifierUniqueWhere:{

	},
	TranslationDomainKeysByValuesUniqueWhere:{
		values:"TranslationValueUniqueWhere"
	},
	TranslationCataloguesIdentifier:{
		catalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		catalogueByDomain:{
			by:"TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		catalogueByValues:{
			by:"TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		paginateCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		}
	},
	TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere:{
		domain:"TranslationDomainUniqueWhere"
	},
	TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere:{
		values:"TranslationValueUniqueWhere"
	},
	TranslationCatalogueValuesByKeyUniqueWhere:{
		key:"TranslationKeyUniqueWhere"
	},
	TranslationCatalogueCreateInput:{
		id:"UUID",
		domain:"TranslationCatalogueCreateDomainEntityRelationInput",
		identifier:"TranslationCatalogueCreateIdentifierEntityRelationInput",
		fallback:"TranslationCatalogueCreateFallbackEntityRelationInput",
		values:"TranslationCatalogueCreateValuesEntityRelationInput"
	},
	TranslationCatalogueCreateDomainEntityRelationInput:{
		connect:"TranslationDomainUniqueWhere",
		create:"TranslationDomainWithoutCataloguesCreateInput",
		connectOrCreate:"TranslationCatalogueConnectOrCreateDomainRelationInput"
	},
	TranslationDomainWithoutCataloguesCreateInput:{
		id:"UUID",
		keys:"TranslationDomainCreateKeysEntityRelationInput"
	},
	TranslationDomainCreateKeysEntityRelationInput:{
		connect:"TranslationKeyUniqueWhere",
		create:"TranslationKeyWithoutDomainCreateInput",
		connectOrCreate:"TranslationDomainConnectOrCreateKeysRelationInput"
	},
	TranslationKeyWithoutDomainCreateInput:{
		id:"UUID",
		contentType:"TranslationKeyContentType",
		values:"TranslationKeyCreateValuesEntityRelationInput"
	},
	TranslationKeyCreateValuesEntityRelationInput:{
		connect:"TranslationValueUniqueWhere",
		create:"TranslationValueWithoutKeyCreateInput",
		connectOrCreate:"TranslationKeyConnectOrCreateValuesRelationInput"
	},
	TranslationValueWithoutKeyCreateInput:{
		id:"UUID",
		catalogue:"TranslationValueCreateCatalogueEntityRelationInput"
	},
	TranslationValueCreateCatalogueEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutValuesCreateInput",
		connectOrCreate:"TranslationValueConnectOrCreateCatalogueRelationInput"
	},
	TranslationCatalogueWithoutValuesCreateInput:{
		id:"UUID",
		domain:"TranslationCatalogueCreateDomainEntityRelationInput",
		identifier:"TranslationCatalogueCreateIdentifierEntityRelationInput",
		fallback:"TranslationCatalogueCreateFallbackEntityRelationInput"
	},
	TranslationCatalogueCreateIdentifierEntityRelationInput:{
		connect:"TranslationCataloguesIdentifierUniqueWhere",
		create:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
		connectOrCreate:"TranslationCatalogueConnectOrCreateIdentifierRelationInput"
	},
	TranslationCataloguesIdentifierWithoutCatalogueCreateInput:{
		id:"UUID"
	},
	TranslationCatalogueConnectOrCreateIdentifierRelationInput:{
		connect:"TranslationCataloguesIdentifierUniqueWhere",
		create:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput"
	},
	TranslationCatalogueCreateFallbackEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueCreateInput",
		connectOrCreate:"TranslationCatalogueConnectOrCreateFallbackRelationInput"
	},
	TranslationCatalogueConnectOrCreateFallbackRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueCreateInput"
	},
	TranslationValueConnectOrCreateCatalogueRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutValuesCreateInput"
	},
	TranslationKeyConnectOrCreateValuesRelationInput:{
		connect:"TranslationValueUniqueWhere",
		create:"TranslationValueWithoutKeyCreateInput"
	},
	TranslationDomainConnectOrCreateKeysRelationInput:{
		connect:"TranslationKeyUniqueWhere",
		create:"TranslationKeyWithoutDomainCreateInput"
	},
	TranslationCatalogueConnectOrCreateDomainRelationInput:{
		connect:"TranslationDomainUniqueWhere",
		create:"TranslationDomainWithoutCataloguesCreateInput"
	},
	TranslationCatalogueCreateValuesEntityRelationInput:{
		connect:"TranslationValueUniqueWhere",
		create:"TranslationValueWithoutCatalogueCreateInput",
		connectOrCreate:"TranslationCatalogueConnectOrCreateValuesRelationInput"
	},
	TranslationValueWithoutCatalogueCreateInput:{
		id:"UUID",
		key:"TranslationValueCreateKeyEntityRelationInput"
	},
	TranslationValueCreateKeyEntityRelationInput:{
		connect:"TranslationKeyUniqueWhere",
		create:"TranslationKeyWithoutValuesCreateInput",
		connectOrCreate:"TranslationValueConnectOrCreateKeyRelationInput"
	},
	TranslationKeyWithoutValuesCreateInput:{
		id:"UUID",
		contentType:"TranslationKeyContentType",
		domain:"TranslationKeyCreateDomainEntityRelationInput"
	},
	TranslationKeyCreateDomainEntityRelationInput:{
		connect:"TranslationDomainUniqueWhere",
		create:"TranslationDomainWithoutKeysCreateInput",
		connectOrCreate:"TranslationKeyConnectOrCreateDomainRelationInput"
	},
	TranslationDomainWithoutKeysCreateInput:{
		id:"UUID",
		catalogues:"TranslationDomainCreateCataloguesEntityRelationInput"
	},
	TranslationDomainCreateCataloguesEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutDomainCreateInput",
		connectOrCreate:"TranslationDomainConnectOrCreateCataloguesRelationInput"
	},
	TranslationCatalogueWithoutDomainCreateInput:{
		id:"UUID",
		identifier:"TranslationCatalogueCreateIdentifierEntityRelationInput",
		fallback:"TranslationCatalogueCreateFallbackEntityRelationInput",
		values:"TranslationCatalogueCreateValuesEntityRelationInput"
	},
	TranslationDomainConnectOrCreateCataloguesRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutDomainCreateInput"
	},
	TranslationKeyConnectOrCreateDomainRelationInput:{
		connect:"TranslationDomainUniqueWhere",
		create:"TranslationDomainWithoutKeysCreateInput"
	},
	TranslationValueConnectOrCreateKeyRelationInput:{
		connect:"TranslationKeyUniqueWhere",
		create:"TranslationKeyWithoutValuesCreateInput"
	},
	TranslationCatalogueConnectOrCreateValuesRelationInput:{
		connect:"TranslationValueUniqueWhere",
		create:"TranslationValueWithoutCatalogueCreateInput"
	},
	TranslationCatalogueUpdateInput:{
		domain:"TranslationCatalogueUpdateDomainEntityRelationInput",
		identifier:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
		fallback:"TranslationCatalogueUpdateFallbackEntityRelationInput",
		values:"TranslationCatalogueUpdateValuesEntityRelationInput"
	},
	TranslationCatalogueUpdateDomainEntityRelationInput:{
		connect:"TranslationDomainUniqueWhere",
		create:"TranslationDomainWithoutCataloguesCreateInput",
		connectOrCreate:"TranslationCatalogueConnectOrCreateDomainRelationInput",
		update:"TranslationDomainWithoutCataloguesUpdateInput",
		upsert:"TranslationCatalogueUpsertDomainRelationInput"
	},
	TranslationDomainWithoutCataloguesUpdateInput:{
		keys:"TranslationDomainUpdateKeysEntityRelationInput"
	},
	TranslationDomainUpdateKeysEntityRelationInput:{
		create:"TranslationKeyWithoutDomainCreateInput",
		update:"TranslationDomainUpdateKeysRelationInput",
		upsert:"TranslationDomainUpsertKeysRelationInput",
		connect:"TranslationKeyUniqueWhere",
		disconnect:"TranslationKeyUniqueWhere",
		delete:"TranslationKeyUniqueWhere"
	},
	TranslationDomainUpdateKeysRelationInput:{
		by:"TranslationKeyUniqueWhere",
		data:"TranslationKeyWithoutDomainUpdateInput"
	},
	TranslationKeyWithoutDomainUpdateInput:{
		contentType:"TranslationKeyContentType",
		values:"TranslationKeyUpdateValuesEntityRelationInput"
	},
	TranslationKeyUpdateValuesEntityRelationInput:{
		create:"TranslationValueWithoutKeyCreateInput",
		update:"TranslationKeyUpdateValuesRelationInput",
		upsert:"TranslationKeyUpsertValuesRelationInput",
		connect:"TranslationValueUniqueWhere",
		disconnect:"TranslationValueUniqueWhere",
		delete:"TranslationValueUniqueWhere"
	},
	TranslationKeyUpdateValuesRelationInput:{
		by:"TranslationValueUniqueWhere",
		data:"TranslationValueWithoutKeyUpdateInput"
	},
	TranslationValueWithoutKeyUpdateInput:{
		catalogue:"TranslationValueUpdateCatalogueEntityRelationInput"
	},
	TranslationValueUpdateCatalogueEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutValuesCreateInput",
		connectOrCreate:"TranslationValueConnectOrCreateCatalogueRelationInput",
		update:"TranslationCatalogueWithoutValuesUpdateInput",
		upsert:"TranslationValueUpsertCatalogueRelationInput"
	},
	TranslationCatalogueWithoutValuesUpdateInput:{
		domain:"TranslationCatalogueUpdateDomainEntityRelationInput",
		identifier:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
		fallback:"TranslationCatalogueUpdateFallbackEntityRelationInput"
	},
	TranslationCatalogueUpdateIdentifierEntityRelationInput:{
		connect:"TranslationCataloguesIdentifierUniqueWhere",
		create:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
		connectOrCreate:"TranslationCatalogueConnectOrCreateIdentifierRelationInput",
		update:"TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
		upsert:"TranslationCatalogueUpsertIdentifierRelationInput"
	},
	TranslationCataloguesIdentifierWithoutCatalogueUpdateInput:{

	},
	TranslationCatalogueUpsertIdentifierRelationInput:{
		update:"TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
		create:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput"
	},
	TranslationCatalogueUpdateFallbackEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueCreateInput",
		connectOrCreate:"TranslationCatalogueConnectOrCreateFallbackRelationInput",
		update:"TranslationCatalogueUpdateInput",
		upsert:"TranslationCatalogueUpsertFallbackRelationInput"
	},
	TranslationCatalogueUpsertFallbackRelationInput:{
		update:"TranslationCatalogueUpdateInput",
		create:"TranslationCatalogueCreateInput"
	},
	TranslationValueUpsertCatalogueRelationInput:{
		update:"TranslationCatalogueWithoutValuesUpdateInput",
		create:"TranslationCatalogueWithoutValuesCreateInput"
	},
	TranslationKeyUpsertValuesRelationInput:{
		by:"TranslationValueUniqueWhere",
		update:"TranslationValueWithoutKeyUpdateInput",
		create:"TranslationValueWithoutKeyCreateInput"
	},
	TranslationDomainUpsertKeysRelationInput:{
		by:"TranslationKeyUniqueWhere",
		update:"TranslationKeyWithoutDomainUpdateInput",
		create:"TranslationKeyWithoutDomainCreateInput"
	},
	TranslationCatalogueUpsertDomainRelationInput:{
		update:"TranslationDomainWithoutCataloguesUpdateInput",
		create:"TranslationDomainWithoutCataloguesCreateInput"
	},
	TranslationCatalogueUpdateValuesEntityRelationInput:{
		create:"TranslationValueWithoutCatalogueCreateInput",
		update:"TranslationCatalogueUpdateValuesRelationInput",
		upsert:"TranslationCatalogueUpsertValuesRelationInput",
		connect:"TranslationValueUniqueWhere",
		disconnect:"TranslationValueUniqueWhere",
		delete:"TranslationValueUniqueWhere"
	},
	TranslationCatalogueUpdateValuesRelationInput:{
		by:"TranslationValueUniqueWhere",
		data:"TranslationValueWithoutCatalogueUpdateInput"
	},
	TranslationValueWithoutCatalogueUpdateInput:{
		key:"TranslationValueUpdateKeyEntityRelationInput"
	},
	TranslationValueUpdateKeyEntityRelationInput:{
		connect:"TranslationKeyUniqueWhere",
		create:"TranslationKeyWithoutValuesCreateInput",
		connectOrCreate:"TranslationValueConnectOrCreateKeyRelationInput",
		update:"TranslationKeyWithoutValuesUpdateInput",
		upsert:"TranslationValueUpsertKeyRelationInput"
	},
	TranslationKeyWithoutValuesUpdateInput:{
		contentType:"TranslationKeyContentType",
		domain:"TranslationKeyUpdateDomainEntityRelationInput"
	},
	TranslationKeyUpdateDomainEntityRelationInput:{
		connect:"TranslationDomainUniqueWhere",
		create:"TranslationDomainWithoutKeysCreateInput",
		connectOrCreate:"TranslationKeyConnectOrCreateDomainRelationInput",
		update:"TranslationDomainWithoutKeysUpdateInput",
		upsert:"TranslationKeyUpsertDomainRelationInput"
	},
	TranslationDomainWithoutKeysUpdateInput:{
		catalogues:"TranslationDomainUpdateCataloguesEntityRelationInput"
	},
	TranslationDomainUpdateCataloguesEntityRelationInput:{
		create:"TranslationCatalogueWithoutDomainCreateInput",
		update:"TranslationDomainUpdateCataloguesRelationInput",
		upsert:"TranslationDomainUpsertCataloguesRelationInput",
		connect:"TranslationCatalogueUniqueWhere",
		disconnect:"TranslationCatalogueUniqueWhere",
		delete:"TranslationCatalogueUniqueWhere"
	},
	TranslationDomainUpdateCataloguesRelationInput:{
		by:"TranslationCatalogueUniqueWhere",
		data:"TranslationCatalogueWithoutDomainUpdateInput"
	},
	TranslationCatalogueWithoutDomainUpdateInput:{
		identifier:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
		fallback:"TranslationCatalogueUpdateFallbackEntityRelationInput",
		values:"TranslationCatalogueUpdateValuesEntityRelationInput"
	},
	TranslationDomainUpsertCataloguesRelationInput:{
		by:"TranslationCatalogueUniqueWhere",
		update:"TranslationCatalogueWithoutDomainUpdateInput",
		create:"TranslationCatalogueWithoutDomainCreateInput"
	},
	TranslationKeyUpsertDomainRelationInput:{
		update:"TranslationDomainWithoutKeysUpdateInput",
		create:"TranslationDomainWithoutKeysCreateInput"
	},
	TranslationValueUpsertKeyRelationInput:{
		update:"TranslationKeyWithoutValuesUpdateInput",
		create:"TranslationKeyWithoutValuesCreateInput"
	},
	TranslationCatalogueUpsertValuesRelationInput:{
		by:"TranslationValueUniqueWhere",
		update:"TranslationValueWithoutCatalogueUpdateInput",
		create:"TranslationValueWithoutCatalogueCreateInput"
	},
	TranslationCataloguesIdentifierCreateInput:{
		id:"UUID",
		catalogue:"TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"
	},
	TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutIdentifierCreateInput",
		connectOrCreate:"TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"
	},
	TranslationCatalogueWithoutIdentifierCreateInput:{
		id:"UUID",
		domain:"TranslationCatalogueCreateDomainEntityRelationInput",
		fallback:"TranslationCatalogueCreateFallbackEntityRelationInput",
		values:"TranslationCatalogueCreateValuesEntityRelationInput"
	},
	TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutIdentifierCreateInput"
	},
	TranslationCataloguesIdentifierUpdateInput:{
		catalogue:"TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"
	},
	TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput:{
		create:"TranslationCatalogueWithoutIdentifierCreateInput",
		update:"TranslationCataloguesIdentifierUpdateCatalogueRelationInput",
		upsert:"TranslationCataloguesIdentifierUpsertCatalogueRelationInput",
		connect:"TranslationCatalogueUniqueWhere",
		disconnect:"TranslationCatalogueUniqueWhere",
		delete:"TranslationCatalogueUniqueWhere"
	},
	TranslationCataloguesIdentifierUpdateCatalogueRelationInput:{
		by:"TranslationCatalogueUniqueWhere",
		data:"TranslationCatalogueWithoutIdentifierUpdateInput"
	},
	TranslationCatalogueWithoutIdentifierUpdateInput:{
		domain:"TranslationCatalogueUpdateDomainEntityRelationInput",
		fallback:"TranslationCatalogueUpdateFallbackEntityRelationInput",
		values:"TranslationCatalogueUpdateValuesEntityRelationInput"
	},
	TranslationCataloguesIdentifierUpsertCatalogueRelationInput:{
		by:"TranslationCatalogueUniqueWhere",
		update:"TranslationCatalogueWithoutIdentifierUpdateInput",
		create:"TranslationCatalogueWithoutIdentifierCreateInput"
	},
	TranslationDomainCreateInput:{
		id:"UUID",
		catalogues:"TranslationDomainCreateCataloguesEntityRelationInput",
		keys:"TranslationDomainCreateKeysEntityRelationInput"
	},
	TranslationDomainUpdateInput:{
		catalogues:"TranslationDomainUpdateCataloguesEntityRelationInput",
		keys:"TranslationDomainUpdateKeysEntityRelationInput"
	},
	TranslationKeyCreateInput:{
		id:"UUID",
		contentType:"TranslationKeyContentType",
		domain:"TranslationKeyCreateDomainEntityRelationInput",
		values:"TranslationKeyCreateValuesEntityRelationInput"
	},
	TranslationKeyUpdateInput:{
		contentType:"TranslationKeyContentType",
		domain:"TranslationKeyUpdateDomainEntityRelationInput",
		values:"TranslationKeyUpdateValuesEntityRelationInput"
	},
	TranslationValueCreateInput:{
		id:"UUID",
		catalogue:"TranslationValueCreateCatalogueEntityRelationInput",
		key:"TranslationValueCreateKeyEntityRelationInput"
	},
	TranslationValueUpdateInput:{
		catalogue:"TranslationValueUpdateCatalogueEntityRelationInput",
		key:"TranslationValueUpdateKeyEntityRelationInput"
	},
	GenericPageAboutGroupLinksLocaleCreateInput:{
		id:"UUID",
		settings:"GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput",
		linkList:"GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"
	},
	GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput:{
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		create:"GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput",
		connectOrCreate:"GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"
	},
	GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput:{
		id:"UUID",
		root:"GenericPageAboutSettingsLocaleCreateRootEntityRelationInput",
		locale:"GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"
	},
	GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput:{
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		create:"GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"
	},
	GenericPageAboutGroupLinksLocaleUpdateInput:{
		settings:"GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput",
		linkList:"GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"
	},
	GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput:{
		connect:"GenericPageAboutSettingsLocaleUniqueWhere",
		create:"GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput",
		connectOrCreate:"GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput",
		update:"GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput",
		upsert:"GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"
	},
	GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput:{
		root:"GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput",
		locale:"GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"
	},
	GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput:{
		update:"GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput",
		create:"GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"
	},
	MemberListItemCreateInput:{
		id:"UUID",
		list:"MemberListItemCreateListEntityRelationInput",
		image:"MemberListItemCreateImageEntityRelationInput",
		descriptionContent:"MemberListItemCreateDescriptionContentEntityRelationInput"
	},
	MemberListItemCreateListEntityRelationInput:{
		connect:"MemberListUniqueWhere",
		create:"MemberListWithoutItemsCreateInput",
		connectOrCreate:"MemberListItemConnectOrCreateListRelationInput"
	},
	MemberListWithoutItemsCreateInput:{
		id:"UUID"
	},
	MemberListItemConnectOrCreateListRelationInput:{
		connect:"MemberListUniqueWhere",
		create:"MemberListWithoutItemsCreateInput"
	},
	MemberListItemUpdateInput:{
		list:"MemberListItemUpdateListEntityRelationInput",
		image:"MemberListItemUpdateImageEntityRelationInput",
		descriptionContent:"MemberListItemUpdateDescriptionContentEntityRelationInput"
	},
	MemberListItemUpdateListEntityRelationInput:{
		connect:"MemberListUniqueWhere",
		create:"MemberListWithoutItemsCreateInput",
		connectOrCreate:"MemberListItemConnectOrCreateListRelationInput",
		update:"MemberListWithoutItemsUpdateInput",
		upsert:"MemberListItemUpsertListRelationInput"
	},
	MemberListWithoutItemsUpdateInput:{

	},
	MemberListItemUpsertListRelationInput:{
		update:"MemberListWithoutItemsUpdateInput",
		create:"MemberListWithoutItemsCreateInput"
	},
	FilledTaxFormEmailAddressUniqueWhere:{
		id:"UUID"
	},
	FilledTaxFormEmailAddressWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		email:"StringCondition",
		and:"FilledTaxFormEmailAddressWhere",
		or:"FilledTaxFormEmailAddressWhere",
		not:"FilledTaxFormEmailAddressWhere"
	},
	FilledTaxFormEmailAddressOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		email:"OrderDirection"
	},
	FilledTaxFormEmailAddressCreateInput:{
		id:"UUID"
	},
	FilledTaxFormEmailAddressUpdateInput:{

	},
	CsobPaymentCreateInput:{
		id:"UUID",
		statusChanges:"CsobPaymentCreateStatusChangesEntityRelationInput",
		payment:"CsobPaymentCreatePaymentEntityRelationInput",
		metadata:"CsobPaymentCreateMetadataEntityRelationInput"
	},
	CsobPaymentCreatePaymentEntityRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutCsobPaymentCreateInput",
		connectOrCreate:"CsobPaymentConnectOrCreatePaymentRelationInput"
	},
	UserPaymentWithoutCsobPaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		currency:"UserPaymentCreateCurrencyEntityRelationInput",
		order:"UserPaymentCreateOrderEntityRelationInput",
		stripePayment:"UserPaymentCreateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentCreateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentCreateRegionEntityRelationInput",
		user:"UserPaymentCreateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentCreateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentCreateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentCreateMetadataEntityRelationInput"
	},
	CsobPaymentConnectOrCreatePaymentRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutCsobPaymentCreateInput"
	},
	CsobPaymentUpdateInput:{
		statusChanges:"CsobPaymentUpdateStatusChangesEntityRelationInput",
		payment:"CsobPaymentUpdatePaymentEntityRelationInput",
		metadata:"CsobPaymentUpdateMetadataEntityRelationInput"
	},
	CsobPaymentUpdatePaymentEntityRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutCsobPaymentCreateInput",
		connectOrCreate:"CsobPaymentConnectOrCreatePaymentRelationInput",
		update:"UserPaymentWithoutCsobPaymentUpdateInput",
		upsert:"CsobPaymentUpsertPaymentRelationInput"
	},
	UserPaymentWithoutCsobPaymentUpdateInput:{
		createdAt:"DateTime",
		currency:"UserPaymentUpdateCurrencyEntityRelationInput",
		order:"UserPaymentUpdateOrderEntityRelationInput",
		stripePayment:"UserPaymentUpdateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentUpdateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentUpdateRegionEntityRelationInput",
		user:"UserPaymentUpdateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentUpdateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentUpdateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentUpdateMetadataEntityRelationInput"
	},
	CsobPaymentUpsertPaymentRelationInput:{
		update:"UserPaymentWithoutCsobPaymentUpdateInput",
		create:"UserPaymentWithoutCsobPaymentCreateInput"
	},
	CsobPaymentStatusChangeCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		payment:"CsobPaymentStatusChangeCreatePaymentEntityRelationInput"
	},
	CsobPaymentStatusChangeCreatePaymentEntityRelationInput:{
		connect:"CsobPaymentUniqueWhere",
		create:"CsobPaymentWithoutStatusChangesCreateInput",
		connectOrCreate:"CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"
	},
	CsobPaymentWithoutStatusChangesCreateInput:{
		id:"UUID",
		payment:"CsobPaymentCreatePaymentEntityRelationInput",
		metadata:"CsobPaymentCreateMetadataEntityRelationInput"
	},
	CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput:{
		connect:"CsobPaymentUniqueWhere",
		create:"CsobPaymentWithoutStatusChangesCreateInput"
	},
	CsobPaymentStatusChangeUpdateInput:{
		createdAt:"DateTime",
		payment:"CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"
	},
	CsobPaymentStatusChangeUpdatePaymentEntityRelationInput:{
		connect:"CsobPaymentUniqueWhere",
		create:"CsobPaymentWithoutStatusChangesCreateInput",
		connectOrCreate:"CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput",
		update:"CsobPaymentWithoutStatusChangesUpdateInput",
		upsert:"CsobPaymentStatusChangeUpsertPaymentRelationInput"
	},
	CsobPaymentWithoutStatusChangesUpdateInput:{
		payment:"CsobPaymentUpdatePaymentEntityRelationInput",
		metadata:"CsobPaymentUpdateMetadataEntityRelationInput"
	},
	CsobPaymentStatusChangeUpsertPaymentRelationInput:{
		update:"CsobPaymentWithoutStatusChangesUpdateInput",
		create:"CsobPaymentWithoutStatusChangesCreateInput"
	},
	StripePaymentCreateInput:{
		id:"UUID",
		statusChanges:"StripePaymentCreateStatusChangesEntityRelationInput",
		payment:"StripePaymentCreatePaymentEntityRelationInput",
		metadata:"StripePaymentCreateMetadataEntityRelationInput"
	},
	StripePaymentCreatePaymentEntityRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutStripePaymentCreateInput",
		connectOrCreate:"StripePaymentConnectOrCreatePaymentRelationInput"
	},
	UserPaymentWithoutStripePaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		currency:"UserPaymentCreateCurrencyEntityRelationInput",
		order:"UserPaymentCreateOrderEntityRelationInput",
		csobPayment:"UserPaymentCreateCsobPaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentCreateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentCreateRegionEntityRelationInput",
		user:"UserPaymentCreateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentCreateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentCreateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentCreateMetadataEntityRelationInput"
	},
	StripePaymentConnectOrCreatePaymentRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutStripePaymentCreateInput"
	},
	StripePaymentUpdateInput:{
		statusChanges:"StripePaymentUpdateStatusChangesEntityRelationInput",
		payment:"StripePaymentUpdatePaymentEntityRelationInput",
		metadata:"StripePaymentUpdateMetadataEntityRelationInput"
	},
	StripePaymentUpdatePaymentEntityRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutStripePaymentCreateInput",
		connectOrCreate:"StripePaymentConnectOrCreatePaymentRelationInput",
		update:"UserPaymentWithoutStripePaymentUpdateInput",
		upsert:"StripePaymentUpsertPaymentRelationInput"
	},
	UserPaymentWithoutStripePaymentUpdateInput:{
		createdAt:"DateTime",
		currency:"UserPaymentUpdateCurrencyEntityRelationInput",
		order:"UserPaymentUpdateOrderEntityRelationInput",
		csobPayment:"UserPaymentUpdateCsobPaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentUpdateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentUpdateRegionEntityRelationInput",
		user:"UserPaymentUpdateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentUpdateOnBehalfDonationEntityRelationInput",
		triesCollection:"UserPaymentUpdateTriesCollectionEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentUpdateMetadataEntityRelationInput"
	},
	StripePaymentUpsertPaymentRelationInput:{
		update:"UserPaymentWithoutStripePaymentUpdateInput",
		create:"UserPaymentWithoutStripePaymentCreateInput"
	},
	StripePaymentStatusChangeCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		payment:"StripePaymentStatusChangeCreatePaymentEntityRelationInput",
		paymentIntentStatus:"StripePaymentStatusChangePaymentIntentStatus"
	},
	StripePaymentStatusChangeCreatePaymentEntityRelationInput:{
		connect:"StripePaymentUniqueWhere",
		create:"StripePaymentWithoutStatusChangesCreateInput",
		connectOrCreate:"StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"
	},
	StripePaymentWithoutStatusChangesCreateInput:{
		id:"UUID",
		payment:"StripePaymentCreatePaymentEntityRelationInput",
		metadata:"StripePaymentCreateMetadataEntityRelationInput"
	},
	StripePaymentStatusChangeConnectOrCreatePaymentRelationInput:{
		connect:"StripePaymentUniqueWhere",
		create:"StripePaymentWithoutStatusChangesCreateInput"
	},
	StripePaymentStatusChangeUpdateInput:{
		createdAt:"DateTime",
		payment:"StripePaymentStatusChangeUpdatePaymentEntityRelationInput",
		paymentIntentStatus:"StripePaymentStatusChangePaymentIntentStatus"
	},
	StripePaymentStatusChangeUpdatePaymentEntityRelationInput:{
		connect:"StripePaymentUniqueWhere",
		create:"StripePaymentWithoutStatusChangesCreateInput",
		connectOrCreate:"StripePaymentStatusChangeConnectOrCreatePaymentRelationInput",
		update:"StripePaymentWithoutStatusChangesUpdateInput",
		upsert:"StripePaymentStatusChangeUpsertPaymentRelationInput"
	},
	StripePaymentWithoutStatusChangesUpdateInput:{
		payment:"StripePaymentUpdatePaymentEntityRelationInput",
		metadata:"StripePaymentUpdateMetadataEntityRelationInput"
	},
	StripePaymentStatusChangeUpsertPaymentRelationInput:{
		update:"StripePaymentWithoutStatusChangesUpdateInput",
		create:"StripePaymentWithoutStatusChangesCreateInput"
	},
	RegionPaymentMethodCreateInput:{
		id:"UUID",
		region:"RegionPaymentMethodCreateRegionEntityRelationInput",
		method:"PaymentMethods"
	},
	RegionPaymentMethodCreateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionWithoutEnabledPaymentMethodsCreateInput",
		connectOrCreate:"RegionPaymentMethodConnectOrCreateRegionRelationInput"
	},
	RegionWithoutEnabledPaymentMethodsCreateInput:{
		id:"UUID",
		currency:"RegionCreateCurrencyEntityRelationInput",
		donationItems:"RegionCreateDonationItemsEntityRelationInput"
	},
	RegionPaymentMethodConnectOrCreateRegionRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionWithoutEnabledPaymentMethodsCreateInput"
	},
	RegionPaymentMethodUpdateInput:{
		region:"RegionPaymentMethodUpdateRegionEntityRelationInput",
		method:"PaymentMethods"
	},
	RegionPaymentMethodUpdateRegionEntityRelationInput:{
		connect:"RegionUniqueWhere",
		create:"RegionWithoutEnabledPaymentMethodsCreateInput",
		connectOrCreate:"RegionPaymentMethodConnectOrCreateRegionRelationInput",
		update:"RegionWithoutEnabledPaymentMethodsUpdateInput",
		upsert:"RegionPaymentMethodUpsertRegionRelationInput"
	},
	RegionWithoutEnabledPaymentMethodsUpdateInput:{
		currency:"RegionUpdateCurrencyEntityRelationInput",
		donationItems:"RegionUpdateDonationItemsEntityRelationInput"
	},
	RegionPaymentMethodUpsertRegionRelationInput:{
		update:"RegionWithoutEnabledPaymentMethodsUpdateInput",
		create:"RegionWithoutEnabledPaymentMethodsCreateInput"
	},
	TileItemCreateInput:{
		id:"UUID",
		type:"TileItemType",
		list:"TileItemCreateListEntityRelationInput",
		post:"TileItemCreatePostEntityRelationInput",
		area:"TileItemCreateAreaEntityRelationInput",
		image:"TileItemCreateImageEntityRelationInput",
		link:"TileItemCreateLinkEntityRelationInput",
		organization:"TileItemCreateOrganizationEntityRelationInput"
	},
	TileItemCreateListEntityRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListWithoutItemsCreateInput",
		connectOrCreate:"TileItemConnectOrCreateListRelationInput"
	},
	TileListWithoutItemsCreateInput:{
		id:"UUID",
		size:"TileListSize",
		areaType:"TileListCreateAreaTypeEntityRelationInput"
	},
	TileItemConnectOrCreateListRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListWithoutItemsCreateInput"
	},
	TileItemUpdateInput:{
		type:"TileItemType",
		list:"TileItemUpdateListEntityRelationInput",
		post:"TileItemUpdatePostEntityRelationInput",
		area:"TileItemUpdateAreaEntityRelationInput",
		image:"TileItemUpdateImageEntityRelationInput",
		link:"TileItemUpdateLinkEntityRelationInput",
		organization:"TileItemUpdateOrganizationEntityRelationInput"
	},
	TileItemUpdateListEntityRelationInput:{
		connect:"TileListUniqueWhere",
		create:"TileListWithoutItemsCreateInput",
		connectOrCreate:"TileItemConnectOrCreateListRelationInput",
		update:"TileListWithoutItemsUpdateInput",
		upsert:"TileItemUpsertListRelationInput"
	},
	TileListWithoutItemsUpdateInput:{
		size:"TileListSize",
		areaType:"TileListUpdateAreaTypeEntityRelationInput"
	},
	TileItemUpsertListRelationInput:{
		update:"TileListWithoutItemsUpdateInput",
		create:"TileListWithoutItemsCreateInput"
	},
	FeedPageCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"FeedPageCreateLocalesEntityRelationInput"
	},
	FeedPageCreateLocalesEntityRelationInput:{
		connect:"FeedPageLocaleUniqueWhere",
		create:"FeedPageLocaleWithoutRootCreateInput",
		connectOrCreate:"FeedPageConnectOrCreateLocalesRelationInput"
	},
	FeedPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"FeedPageLocaleCreateLocaleEntityRelationInput",
		heroTiles:"FeedPageLocaleCreateHeroTilesEntityRelationInput",
		sectionList:"FeedPageLocaleCreateSectionListEntityRelationInput",
		cardList:"FeedPageLocaleCreateCardListEntityRelationInput",
		storyGuideList:"FeedPageLocaleCreateStoryGuideListEntityRelationInput"
	},
	FeedPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFeedPagesCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutFeedPagesCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		recurringPaymentPages:"LocaleCreateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	FeedPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFeedPagesCreateInput"
	},
	FeedPageConnectOrCreateLocalesRelationInput:{
		connect:"FeedPageLocaleUniqueWhere",
		create:"FeedPageLocaleWithoutRootCreateInput"
	},
	FeedPageUpdateInput:{
		unique:"One",
		locales:"FeedPageUpdateLocalesEntityRelationInput"
	},
	FeedPageUpdateLocalesEntityRelationInput:{
		create:"FeedPageLocaleWithoutRootCreateInput",
		update:"FeedPageUpdateLocalesRelationInput",
		upsert:"FeedPageUpsertLocalesRelationInput",
		connect:"FeedPageLocaleUniqueWhere",
		disconnect:"FeedPageLocaleUniqueWhere",
		delete:"FeedPageLocaleUniqueWhere"
	},
	FeedPageUpdateLocalesRelationInput:{
		by:"FeedPageLocaleUniqueWhere",
		data:"FeedPageLocaleWithoutRootUpdateInput"
	},
	FeedPageLocaleWithoutRootUpdateInput:{
		locale:"FeedPageLocaleUpdateLocaleEntityRelationInput",
		heroTiles:"FeedPageLocaleUpdateHeroTilesEntityRelationInput",
		sectionList:"FeedPageLocaleUpdateSectionListEntityRelationInput",
		cardList:"FeedPageLocaleUpdateCardListEntityRelationInput",
		storyGuideList:"FeedPageLocaleUpdateStoryGuideListEntityRelationInput"
	},
	FeedPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFeedPagesCreateInput",
		connectOrCreate:"FeedPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutFeedPagesUpdateInput",
		upsert:"FeedPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutFeedPagesUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		recurringPaymentPages:"LocaleUpdateRecurringPaymentPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	FeedPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutFeedPagesUpdateInput",
		create:"LocaleWithoutFeedPagesCreateInput"
	},
	FeedPageUpsertLocalesRelationInput:{
		by:"FeedPageLocaleUniqueWhere",
		update:"FeedPageLocaleWithoutRootUpdateInput",
		create:"FeedPageLocaleWithoutRootCreateInput"
	},
	FeedPageLocaleCreateInput:{
		id:"UUID",
		root:"FeedPageLocaleCreateRootEntityRelationInput",
		locale:"FeedPageLocaleCreateLocaleEntityRelationInput",
		heroTiles:"FeedPageLocaleCreateHeroTilesEntityRelationInput",
		sectionList:"FeedPageLocaleCreateSectionListEntityRelationInput",
		cardList:"FeedPageLocaleCreateCardListEntityRelationInput",
		storyGuideList:"FeedPageLocaleCreateStoryGuideListEntityRelationInput"
	},
	FeedPageLocaleUpdateInput:{
		root:"FeedPageLocaleUpdateRootEntityRelationInput",
		locale:"FeedPageLocaleUpdateLocaleEntityRelationInput",
		heroTiles:"FeedPageLocaleUpdateHeroTilesEntityRelationInput",
		sectionList:"FeedPageLocaleUpdateSectionListEntityRelationInput",
		cardList:"FeedPageLocaleUpdateCardListEntityRelationInput",
		storyGuideList:"FeedPageLocaleUpdateStoryGuideListEntityRelationInput"
	},
	FeedPageSectionCreateInput:{
		id:"UUID",
		feedPageLocale:"FeedPageSectionCreateFeedPageLocaleEntityRelationInput",
		tileStripeList:"FeedPageSectionCreateTileStripeListEntityRelationInput"
	},
	FeedPageSectionCreateFeedPageLocaleEntityRelationInput:{
		connect:"FeedPageLocaleUniqueWhere",
		create:"FeedPageLocaleWithoutSectionListCreateInput",
		connectOrCreate:"FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"
	},
	FeedPageLocaleWithoutSectionListCreateInput:{
		id:"UUID",
		root:"FeedPageLocaleCreateRootEntityRelationInput",
		locale:"FeedPageLocaleCreateLocaleEntityRelationInput",
		heroTiles:"FeedPageLocaleCreateHeroTilesEntityRelationInput",
		cardList:"FeedPageLocaleCreateCardListEntityRelationInput",
		storyGuideList:"FeedPageLocaleCreateStoryGuideListEntityRelationInput"
	},
	FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput:{
		connect:"FeedPageLocaleUniqueWhere",
		create:"FeedPageLocaleWithoutSectionListCreateInput"
	},
	FeedPageSectionUpdateInput:{
		feedPageLocale:"FeedPageSectionUpdateFeedPageLocaleEntityRelationInput",
		tileStripeList:"FeedPageSectionUpdateTileStripeListEntityRelationInput"
	},
	FeedPageSectionUpdateFeedPageLocaleEntityRelationInput:{
		connect:"FeedPageLocaleUniqueWhere",
		create:"FeedPageLocaleWithoutSectionListCreateInput",
		connectOrCreate:"FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput",
		update:"FeedPageLocaleWithoutSectionListUpdateInput",
		upsert:"FeedPageSectionUpsertFeedPageLocaleRelationInput"
	},
	FeedPageLocaleWithoutSectionListUpdateInput:{
		root:"FeedPageLocaleUpdateRootEntityRelationInput",
		locale:"FeedPageLocaleUpdateLocaleEntityRelationInput",
		heroTiles:"FeedPageLocaleUpdateHeroTilesEntityRelationInput",
		cardList:"FeedPageLocaleUpdateCardListEntityRelationInput",
		storyGuideList:"FeedPageLocaleUpdateStoryGuideListEntityRelationInput"
	},
	FeedPageSectionUpsertFeedPageLocaleRelationInput:{
		update:"FeedPageLocaleWithoutSectionListUpdateInput",
		create:"FeedPageLocaleWithoutSectionListCreateInput"
	},
	FeedPageTileStripeCreateInput:{
		id:"UUID",
		section:"FeedPageTileStripeCreateSectionEntityRelationInput",
		tileList:"FeedPageTileStripeCreateTileListEntityRelationInput"
	},
	FeedPageTileStripeCreateSectionEntityRelationInput:{
		connect:"FeedPageSectionUniqueWhere",
		create:"FeedPageSectionWithoutTileStripeListCreateInput",
		connectOrCreate:"FeedPageTileStripeConnectOrCreateSectionRelationInput"
	},
	FeedPageSectionWithoutTileStripeListCreateInput:{
		id:"UUID",
		feedPageLocale:"FeedPageSectionCreateFeedPageLocaleEntityRelationInput"
	},
	FeedPageTileStripeConnectOrCreateSectionRelationInput:{
		connect:"FeedPageSectionUniqueWhere",
		create:"FeedPageSectionWithoutTileStripeListCreateInput"
	},
	FeedPageTileStripeUpdateInput:{
		section:"FeedPageTileStripeUpdateSectionEntityRelationInput",
		tileList:"FeedPageTileStripeUpdateTileListEntityRelationInput"
	},
	FeedPageTileStripeUpdateSectionEntityRelationInput:{
		connect:"FeedPageSectionUniqueWhere",
		create:"FeedPageSectionWithoutTileStripeListCreateInput",
		connectOrCreate:"FeedPageTileStripeConnectOrCreateSectionRelationInput",
		update:"FeedPageSectionWithoutTileStripeListUpdateInput",
		upsert:"FeedPageTileStripeUpsertSectionRelationInput"
	},
	FeedPageSectionWithoutTileStripeListUpdateInput:{
		feedPageLocale:"FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"
	},
	FeedPageTileStripeUpsertSectionRelationInput:{
		update:"FeedPageSectionWithoutTileStripeListUpdateInput",
		create:"FeedPageSectionWithoutTileStripeListCreateInput"
	},
	CardItemCreateInput:{
		id:"UUID",
		list:"CardItemCreateListEntityRelationInput",
		link:"CardItemCreateLinkEntityRelationInput"
	},
	CardItemCreateListEntityRelationInput:{
		connect:"CardListUniqueWhere",
		create:"CardListWithoutItemsCreateInput",
		connectOrCreate:"CardItemConnectOrCreateListRelationInput"
	},
	CardListWithoutItemsCreateInput:{
		id:"UUID"
	},
	CardItemConnectOrCreateListRelationInput:{
		connect:"CardListUniqueWhere",
		create:"CardListWithoutItemsCreateInput"
	},
	CardItemUpdateInput:{
		list:"CardItemUpdateListEntityRelationInput",
		link:"CardItemUpdateLinkEntityRelationInput"
	},
	CardItemUpdateListEntityRelationInput:{
		connect:"CardListUniqueWhere",
		create:"CardListWithoutItemsCreateInput",
		connectOrCreate:"CardItemConnectOrCreateListRelationInput",
		update:"CardListWithoutItemsUpdateInput",
		upsert:"CardItemUpsertListRelationInput"
	},
	CardListWithoutItemsUpdateInput:{

	},
	CardItemUpsertListRelationInput:{
		update:"CardListWithoutItemsUpdateInput",
		create:"CardListWithoutItemsCreateInput"
	},
	UserPaymentTriesCollectionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		payment:"UserPaymentTriesCollectionCreatePaymentEntityRelationInput",
		user:"UserPaymentTriesCollectionCreateUserEntityRelationInput",
		currency:"UserPaymentTriesCollectionCreateCurrencyEntityRelationInput",
		onBehalfDonation:"UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput",
		recurring:"UserPaymentTriesCollectionCreateRecurringEntityRelationInput",
		metadataLocales:"UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput",
		medium:"PaymentMedium"
	},
	UserPaymentTriesCollectionCreatePaymentEntityRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutTriesCollectionCreateInput",
		connectOrCreate:"UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"
	},
	UserPaymentWithoutTriesCollectionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		currency:"UserPaymentCreateCurrencyEntityRelationInput",
		order:"UserPaymentCreateOrderEntityRelationInput",
		csobPayment:"UserPaymentCreateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentCreateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentCreateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentCreateRegionEntityRelationInput",
		user:"UserPaymentCreateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentCreateOnBehalfDonationEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentCreateMetadataEntityRelationInput"
	},
	UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput:{
		connect:"UserPaymentUniqueWhere",
		create:"UserPaymentWithoutTriesCollectionCreateInput"
	},
	UserPaymentTriesCollectionUpdateInput:{
		createdAt:"DateTime",
		payment:"UserPaymentTriesCollectionUpdatePaymentEntityRelationInput",
		user:"UserPaymentTriesCollectionUpdateUserEntityRelationInput",
		currency:"UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput",
		onBehalfDonation:"UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput",
		recurring:"UserPaymentTriesCollectionUpdateRecurringEntityRelationInput",
		metadataLocales:"UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput",
		medium:"PaymentMedium"
	},
	UserPaymentTriesCollectionUpdatePaymentEntityRelationInput:{
		create:"UserPaymentWithoutTriesCollectionCreateInput",
		update:"UserPaymentTriesCollectionUpdatePaymentRelationInput",
		upsert:"UserPaymentTriesCollectionUpsertPaymentRelationInput",
		connect:"UserPaymentUniqueWhere",
		disconnect:"UserPaymentUniqueWhere",
		delete:"UserPaymentUniqueWhere"
	},
	UserPaymentTriesCollectionUpdatePaymentRelationInput:{
		by:"UserPaymentUniqueWhere",
		data:"UserPaymentWithoutTriesCollectionUpdateInput"
	},
	UserPaymentWithoutTriesCollectionUpdateInput:{
		createdAt:"DateTime",
		currency:"UserPaymentUpdateCurrencyEntityRelationInput",
		order:"UserPaymentUpdateOrderEntityRelationInput",
		csobPayment:"UserPaymentUpdateCsobPaymentEntityRelationInput",
		stripePayment:"UserPaymentUpdateStripePaymentEntityRelationInput",
		recurringPaymentItem:"UserPaymentUpdateRecurringPaymentItemEntityRelationInput",
		method:"UserPaymentMethod",
		region:"UserPaymentUpdateRegionEntityRelationInput",
		user:"UserPaymentUpdateUserEntityRelationInput",
		onBehalfDonation:"UserPaymentUpdateOnBehalfDonationEntityRelationInput",
		successEmailSentAt:"DateTime",
		metadata:"UserPaymentUpdateMetadataEntityRelationInput"
	},
	UserPaymentTriesCollectionUpsertPaymentRelationInput:{
		by:"UserPaymentUniqueWhere",
		update:"UserPaymentWithoutTriesCollectionUpdateInput",
		create:"UserPaymentWithoutTriesCollectionCreateInput"
	},
	RecurringPaymentPageCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"RecurringPaymentPageCreateLocalesEntityRelationInput"
	},
	RecurringPaymentPageCreateLocalesEntityRelationInput:{
		connect:"RecurringPaymentPageLocaleUniqueWhere",
		create:"RecurringPaymentPageLocaleWithoutRootCreateInput",
		connectOrCreate:"RecurringPaymentPageConnectOrCreateLocalesRelationInput"
	},
	RecurringPaymentPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"RecurringPaymentPageLocaleCreateLocaleEntityRelationInput",
		favouritePosts:"RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput",
		storyGuideList:"RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"
	},
	RecurringPaymentPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutRecurringPaymentPagesCreateInput",
		connectOrCreate:"RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutRecurringPaymentPagesCreateInput:{
		id:"UUID",
		generals:"LocaleCreateGeneralsEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		posts:"LocaleCreatePostsEntityRelationInput",
		postAreas:"LocaleCreatePostAreasEntityRelationInput",
		postOrganizations:"LocaleCreatePostOrganizationsEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleCreateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleCreatePostRevisionsEntityRelationInput",
		flagImage:"LocaleCreateFlagImageEntityRelationInput",
		feedPages:"LocaleCreateFeedPagesEntityRelationInput",
		givenGiftsPages:"LocaleCreateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleCreateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleCreateReportPagesEntityRelationInput",
		reportNavigations:"LocaleCreateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleCreateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleCreateSentPaymentsEntityRelationInput"
	},
	RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutRecurringPaymentPagesCreateInput"
	},
	RecurringPaymentPageConnectOrCreateLocalesRelationInput:{
		connect:"RecurringPaymentPageLocaleUniqueWhere",
		create:"RecurringPaymentPageLocaleWithoutRootCreateInput"
	},
	RecurringPaymentPageUpdateInput:{
		unique:"One",
		locales:"RecurringPaymentPageUpdateLocalesEntityRelationInput"
	},
	RecurringPaymentPageUpdateLocalesEntityRelationInput:{
		create:"RecurringPaymentPageLocaleWithoutRootCreateInput",
		update:"RecurringPaymentPageUpdateLocalesRelationInput",
		upsert:"RecurringPaymentPageUpsertLocalesRelationInput",
		connect:"RecurringPaymentPageLocaleUniqueWhere",
		disconnect:"RecurringPaymentPageLocaleUniqueWhere",
		delete:"RecurringPaymentPageLocaleUniqueWhere"
	},
	RecurringPaymentPageUpdateLocalesRelationInput:{
		by:"RecurringPaymentPageLocaleUniqueWhere",
		data:"RecurringPaymentPageLocaleWithoutRootUpdateInput"
	},
	RecurringPaymentPageLocaleWithoutRootUpdateInput:{
		locale:"RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput",
		favouritePosts:"RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput",
		storyGuideList:"RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"
	},
	RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutRecurringPaymentPagesCreateInput",
		connectOrCreate:"RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutRecurringPaymentPagesUpdateInput",
		upsert:"RecurringPaymentPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutRecurringPaymentPagesUpdateInput:{
		generals:"LocaleUpdateGeneralsEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		posts:"LocaleUpdatePostsEntityRelationInput",
		postAreas:"LocaleUpdatePostAreasEntityRelationInput",
		postOrganizations:"LocaleUpdatePostOrganizationsEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPageAboutSettings:"LocaleUpdateGenericPageAboutSettingsEntityRelationInput",
		postRevisions:"LocaleUpdatePostRevisionsEntityRelationInput",
		flagImage:"LocaleUpdateFlagImageEntityRelationInput",
		feedPages:"LocaleUpdateFeedPagesEntityRelationInput",
		givenGiftsPages:"LocaleUpdateGivenGiftsPagesEntityRelationInput",
		receivedGiftsPages:"LocaleUpdateReceivedGiftsPagesEntityRelationInput",
		reportPages:"LocaleUpdateReportPagesEntityRelationInput",
		reportNavigations:"LocaleUpdateReportNavigationsEntityRelationInput",
		scheduledNotifications:"LocaleUpdateScheduledNotificationsEntityRelationInput",
		sentPayments:"LocaleUpdateSentPaymentsEntityRelationInput"
	},
	RecurringPaymentPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutRecurringPaymentPagesUpdateInput",
		create:"LocaleWithoutRecurringPaymentPagesCreateInput"
	},
	RecurringPaymentPageUpsertLocalesRelationInput:{
		by:"RecurringPaymentPageLocaleUniqueWhere",
		update:"RecurringPaymentPageLocaleWithoutRootUpdateInput",
		create:"RecurringPaymentPageLocaleWithoutRootCreateInput"
	},
	RecurringPaymentPageLocaleCreateInput:{
		id:"UUID",
		root:"RecurringPaymentPageLocaleCreateRootEntityRelationInput",
		locale:"RecurringPaymentPageLocaleCreateLocaleEntityRelationInput",
		favouritePosts:"RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput",
		storyGuideList:"RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"
	},
	RecurringPaymentPageLocaleUpdateInput:{
		root:"RecurringPaymentPageLocaleUpdateRootEntityRelationInput",
		locale:"RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput",
		favouritePosts:"RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput",
		storyGuideList:"RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"
	},
	StoryGuideItemCreateInput:{
		id:"UUID",
		list:"StoryGuideItemCreateListEntityRelationInput",
		guide:"StoryGuideItemCreateGuideEntityRelationInput"
	},
	StoryGuideItemCreateListEntityRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListWithoutItemsCreateInput",
		connectOrCreate:"StoryGuideItemConnectOrCreateListRelationInput"
	},
	StoryGuideListWithoutItemsCreateInput:{
		id:"UUID"
	},
	StoryGuideItemConnectOrCreateListRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListWithoutItemsCreateInput"
	},
	StoryGuideItemUpdateInput:{
		list:"StoryGuideItemUpdateListEntityRelationInput",
		guide:"StoryGuideItemUpdateGuideEntityRelationInput"
	},
	StoryGuideItemUpdateListEntityRelationInput:{
		connect:"StoryGuideListUniqueWhere",
		create:"StoryGuideListWithoutItemsCreateInput",
		connectOrCreate:"StoryGuideItemConnectOrCreateListRelationInput",
		update:"StoryGuideListWithoutItemsUpdateInput",
		upsert:"StoryGuideItemUpsertListRelationInput"
	},
	StoryGuideListWithoutItemsUpdateInput:{

	},
	StoryGuideItemUpsertListRelationInput:{
		update:"StoryGuideListWithoutItemsUpdateInput",
		create:"StoryGuideListWithoutItemsCreateInput"
	},
	PostOrganizationListItemCreateInput:{
		id:"UUID",
		list:"PostOrganizationListItemCreateListEntityRelationInput",
		item:"PostOrganizationListItemCreateItemEntityRelationInput",
		type:"PostOrganizationListItemType",
		link:"PostOrganizationListItemCreateLinkEntityRelationInput",
		image:"PostOrganizationListItemCreateImageEntityRelationInput"
	},
	PostOrganizationListItemCreateListEntityRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListWithoutItemsCreateInput",
		connectOrCreate:"PostOrganizationListItemConnectOrCreateListRelationInput"
	},
	PostOrganizationListWithoutItemsCreateInput:{
		id:"UUID"
	},
	PostOrganizationListItemConnectOrCreateListRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListWithoutItemsCreateInput"
	},
	PostOrganizationListItemUpdateInput:{
		list:"PostOrganizationListItemUpdateListEntityRelationInput",
		item:"PostOrganizationListItemUpdateItemEntityRelationInput",
		type:"PostOrganizationListItemType",
		link:"PostOrganizationListItemUpdateLinkEntityRelationInput",
		image:"PostOrganizationListItemUpdateImageEntityRelationInput"
	},
	PostOrganizationListItemUpdateListEntityRelationInput:{
		connect:"PostOrganizationListUniqueWhere",
		create:"PostOrganizationListWithoutItemsCreateInput",
		connectOrCreate:"PostOrganizationListItemConnectOrCreateListRelationInput",
		update:"PostOrganizationListWithoutItemsUpdateInput",
		upsert:"PostOrganizationListItemUpsertListRelationInput"
	},
	PostOrganizationListWithoutItemsUpdateInput:{

	},
	PostOrganizationListItemUpsertListRelationInput:{
		update:"PostOrganizationListWithoutItemsUpdateInput",
		create:"PostOrganizationListWithoutItemsCreateInput"
	},
	InfoCarousel:{
		items:{
			filter:"InfoCarouselItemWhere",
			orderBy:"InfoCarouselItemOrderBy"
		},
		seenBy:{
			filter:"PersonSeenInfoCarouselWhere",
			orderBy:"PersonSeenInfoCarouselOrderBy"
		},
		itemsByLocales:{
			by:"InfoCarouselItemsByLocalesUniqueWhere",
			filter:"InfoCarouselItemWhere"
		},
		seenByByUser:{
			by:"InfoCarouselSeenByByUserUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere"
		},
		paginateItems:{
			filter:"InfoCarouselItemWhere",
			orderBy:"InfoCarouselItemOrderBy"
		},
		paginateSeenBy:{
			filter:"PersonSeenInfoCarouselWhere",
			orderBy:"PersonSeenInfoCarouselOrderBy"
		}
	},
	InfoCarouselItem:{
		carousel:{
			filter:"InfoCarouselWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		post:{
			filter:"PostWhere"
		},
		locales:{
			filter:"InfoCarouselItemLocaleWhere",
			orderBy:"InfoCarouselItemLocaleOrderBy"
		},
		localesByLocale:{
			by:"InfoCarouselItemLocalesByLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere"
		},
		paginateLocales:{
			filter:"InfoCarouselItemLocaleWhere",
			orderBy:"InfoCarouselItemLocaleOrderBy"
		}
	},
	InfoCarouselWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		isEnabled:"BooleanCondition",
		validFrom:"DateTimeCondition",
		validTo:"DateTimeCondition",
		items:"InfoCarouselItemWhere",
		seenBy:"PersonSeenInfoCarouselWhere",
		and:"InfoCarouselWhere",
		or:"InfoCarouselWhere",
		not:"InfoCarouselWhere"
	},
	InfoCarouselItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		carousel:"InfoCarouselWhere",
		image:"ImageWhere",
		post:"PostWhere",
		subtitle:"StringCondition",
		type:"InfoCarouselItemTypeCondition",
		locales:"InfoCarouselItemLocaleWhere",
		and:"InfoCarouselItemWhere",
		or:"InfoCarouselItemWhere",
		not:"InfoCarouselItemWhere"
	},
	InfoCarouselItemTypeCondition:{
		and:"InfoCarouselItemTypeCondition",
		or:"InfoCarouselItemTypeCondition",
		not:"InfoCarouselItemTypeCondition",
		eq:"InfoCarouselItemType",
		notEq:"InfoCarouselItemType",
		in:"InfoCarouselItemType",
		notIn:"InfoCarouselItemType",
		lt:"InfoCarouselItemType",
		lte:"InfoCarouselItemType",
		gt:"InfoCarouselItemType",
		gte:"InfoCarouselItemType"
	},
	InfoCarouselItemType: "enum" as const,
	InfoCarouselItemLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		subtitle:"StringCondition",
		root:"InfoCarouselItemWhere",
		locale:"LocaleWhere",
		and:"InfoCarouselItemLocaleWhere",
		or:"InfoCarouselItemLocaleWhere",
		not:"InfoCarouselItemLocaleWhere"
	},
	PersonSeenInfoCarouselWhere:{
		id:"UUIDCondition",
		seenAt:"DateTimeCondition",
		user:"UserWhere",
		carousel:"InfoCarouselWhere",
		and:"PersonSeenInfoCarouselWhere",
		or:"PersonSeenInfoCarouselWhere",
		not:"PersonSeenInfoCarouselWhere"
	},
	InfoCarouselItemLocale:{
		root:{
			filter:"InfoCarouselItemWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	InfoCarouselItemLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		subtitle:"OrderDirection",
		root:"InfoCarouselItemOrderBy",
		locale:"LocaleOrderBy"
	},
	InfoCarouselItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		carousel:"InfoCarouselOrderBy",
		image:"ImageOrderBy",
		post:"PostOrderBy",
		subtitle:"OrderDirection",
		type:"OrderDirection"
	},
	InfoCarouselOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		isEnabled:"OrderDirection",
		validFrom:"OrderDirection",
		validTo:"OrderDirection"
	},
	InfoCarouselItemLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PersonSeenInfoCarousel:{
		user:{
			filter:"UserWhere"
		},
		carousel:{
			filter:"InfoCarouselWhere"
		}
	},
	PersonSeenInfoCarouselOrderBy:{
		id:"OrderDirection",
		seenAt:"OrderDirection",
		user:"UserOrderBy",
		carousel:"InfoCarouselOrderBy"
	},
	InfoCarouselItemsByLocalesUniqueWhere:{
		locales:"InfoCarouselItemLocaleUniqueWhere"
	},
	InfoCarouselItemLocaleUniqueWhere:{
		id:"UUID",
		root:"InfoCarouselItemUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	InfoCarouselItemUniqueWhere:{
		id:"UUID",
		locales:"InfoCarouselItemLocaleUniqueWhere"
	},
	InfoCarouselSeenByByUserUniqueWhere:{
		user:"UserUniqueWhere"
	},
	InfoCarouselUniqueWhere:{
		id:"UUID",
		items:"InfoCarouselItemUniqueWhere",
		seenBy:"PersonSeenInfoCarouselUniqueWhere"
	},
	PersonSeenInfoCarouselUniqueWhere:{
		id:"UUID",
		user:"UserUniqueWhere",
		carousel:"InfoCarouselUniqueWhere"
	},
	InfoCarouselCreateInput:{
		id:"UUID",
		validFrom:"DateTime",
		validTo:"DateTime",
		items:"InfoCarouselCreateItemsEntityRelationInput",
		seenBy:"InfoCarouselCreateSeenByEntityRelationInput"
	},
	InfoCarouselCreateItemsEntityRelationInput:{
		connect:"InfoCarouselItemUniqueWhere",
		create:"InfoCarouselItemWithoutCarouselCreateInput",
		connectOrCreate:"InfoCarouselConnectOrCreateItemsRelationInput"
	},
	InfoCarouselItemWithoutCarouselCreateInput:{
		id:"UUID",
		image:"InfoCarouselItemCreateImageEntityRelationInput",
		post:"InfoCarouselItemCreatePostEntityRelationInput",
		type:"InfoCarouselItemType",
		locales:"InfoCarouselItemCreateLocalesEntityRelationInput"
	},
	InfoCarouselItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"InfoCarouselItemConnectOrCreateImageRelationInput"
	},
	InfoCarouselItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	InfoCarouselItemCreatePostEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput",
		connectOrCreate:"InfoCarouselItemConnectOrCreatePostRelationInput"
	},
	InfoCarouselItemConnectOrCreatePostRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput"
	},
	InfoCarouselItemCreateLocalesEntityRelationInput:{
		connect:"InfoCarouselItemLocaleUniqueWhere",
		create:"InfoCarouselItemLocaleWithoutRootCreateInput",
		connectOrCreate:"InfoCarouselItemConnectOrCreateLocalesRelationInput"
	},
	InfoCarouselItemLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"InfoCarouselItemLocaleCreateLocaleEntityRelationInput"
	},
	InfoCarouselItemLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleCreateInput",
		connectOrCreate:"InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"
	},
	InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleCreateInput"
	},
	InfoCarouselItemConnectOrCreateLocalesRelationInput:{
		connect:"InfoCarouselItemLocaleUniqueWhere",
		create:"InfoCarouselItemLocaleWithoutRootCreateInput"
	},
	InfoCarouselConnectOrCreateItemsRelationInput:{
		connect:"InfoCarouselItemUniqueWhere",
		create:"InfoCarouselItemWithoutCarouselCreateInput"
	},
	InfoCarouselCreateSeenByEntityRelationInput:{
		connect:"PersonSeenInfoCarouselUniqueWhere",
		create:"PersonSeenInfoCarouselWithoutCarouselCreateInput",
		connectOrCreate:"InfoCarouselConnectOrCreateSeenByRelationInput"
	},
	PersonSeenInfoCarouselWithoutCarouselCreateInput:{
		id:"UUID",
		seenAt:"DateTime",
		user:"PersonSeenInfoCarouselCreateUserEntityRelationInput"
	},
	PersonSeenInfoCarouselCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserCreateInput",
		connectOrCreate:"PersonSeenInfoCarouselConnectOrCreateUserRelationInput"
	},
	PersonSeenInfoCarouselConnectOrCreateUserRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserCreateInput"
	},
	InfoCarouselConnectOrCreateSeenByRelationInput:{
		connect:"PersonSeenInfoCarouselUniqueWhere",
		create:"PersonSeenInfoCarouselWithoutCarouselCreateInput"
	},
	InfoCarouselUpdateInput:{
		validFrom:"DateTime",
		validTo:"DateTime",
		items:"InfoCarouselUpdateItemsEntityRelationInput",
		seenBy:"InfoCarouselUpdateSeenByEntityRelationInput"
	},
	InfoCarouselUpdateItemsEntityRelationInput:{
		create:"InfoCarouselItemWithoutCarouselCreateInput",
		update:"InfoCarouselUpdateItemsRelationInput",
		upsert:"InfoCarouselUpsertItemsRelationInput",
		connect:"InfoCarouselItemUniqueWhere",
		disconnect:"InfoCarouselItemUniqueWhere",
		delete:"InfoCarouselItemUniqueWhere"
	},
	InfoCarouselUpdateItemsRelationInput:{
		by:"InfoCarouselItemUniqueWhere",
		data:"InfoCarouselItemWithoutCarouselUpdateInput"
	},
	InfoCarouselItemWithoutCarouselUpdateInput:{
		image:"InfoCarouselItemUpdateImageEntityRelationInput",
		post:"InfoCarouselItemUpdatePostEntityRelationInput",
		type:"InfoCarouselItemType",
		locales:"InfoCarouselItemUpdateLocalesEntityRelationInput"
	},
	InfoCarouselItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"InfoCarouselItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"InfoCarouselItemUpsertImageRelationInput"
	},
	InfoCarouselItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	InfoCarouselItemUpdatePostEntityRelationInput:{
		connect:"PostUniqueWhere",
		create:"PostCreateInput",
		connectOrCreate:"InfoCarouselItemConnectOrCreatePostRelationInput",
		update:"PostUpdateInput",
		upsert:"InfoCarouselItemUpsertPostRelationInput"
	},
	InfoCarouselItemUpsertPostRelationInput:{
		update:"PostUpdateInput",
		create:"PostCreateInput"
	},
	InfoCarouselItemUpdateLocalesEntityRelationInput:{
		create:"InfoCarouselItemLocaleWithoutRootCreateInput",
		update:"InfoCarouselItemUpdateLocalesRelationInput",
		upsert:"InfoCarouselItemUpsertLocalesRelationInput",
		connect:"InfoCarouselItemLocaleUniqueWhere",
		disconnect:"InfoCarouselItemLocaleUniqueWhere",
		delete:"InfoCarouselItemLocaleUniqueWhere"
	},
	InfoCarouselItemUpdateLocalesRelationInput:{
		by:"InfoCarouselItemLocaleUniqueWhere",
		data:"InfoCarouselItemLocaleWithoutRootUpdateInput"
	},
	InfoCarouselItemLocaleWithoutRootUpdateInput:{
		locale:"InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"
	},
	InfoCarouselItemLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleCreateInput",
		connectOrCreate:"InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleUpdateInput",
		upsert:"InfoCarouselItemLocaleUpsertLocaleRelationInput"
	},
	InfoCarouselItemLocaleUpsertLocaleRelationInput:{
		update:"LocaleUpdateInput",
		create:"LocaleCreateInput"
	},
	InfoCarouselItemUpsertLocalesRelationInput:{
		by:"InfoCarouselItemLocaleUniqueWhere",
		update:"InfoCarouselItemLocaleWithoutRootUpdateInput",
		create:"InfoCarouselItemLocaleWithoutRootCreateInput"
	},
	InfoCarouselUpsertItemsRelationInput:{
		by:"InfoCarouselItemUniqueWhere",
		update:"InfoCarouselItemWithoutCarouselUpdateInput",
		create:"InfoCarouselItemWithoutCarouselCreateInput"
	},
	InfoCarouselUpdateSeenByEntityRelationInput:{
		create:"PersonSeenInfoCarouselWithoutCarouselCreateInput",
		update:"InfoCarouselUpdateSeenByRelationInput",
		upsert:"InfoCarouselUpsertSeenByRelationInput",
		connect:"PersonSeenInfoCarouselUniqueWhere",
		disconnect:"PersonSeenInfoCarouselUniqueWhere",
		delete:"PersonSeenInfoCarouselUniqueWhere"
	},
	InfoCarouselUpdateSeenByRelationInput:{
		by:"PersonSeenInfoCarouselUniqueWhere",
		data:"PersonSeenInfoCarouselWithoutCarouselUpdateInput"
	},
	PersonSeenInfoCarouselWithoutCarouselUpdateInput:{
		seenAt:"DateTime",
		user:"PersonSeenInfoCarouselUpdateUserEntityRelationInput"
	},
	PersonSeenInfoCarouselUpdateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserCreateInput",
		connectOrCreate:"PersonSeenInfoCarouselConnectOrCreateUserRelationInput",
		update:"UserUpdateInput",
		upsert:"PersonSeenInfoCarouselUpsertUserRelationInput"
	},
	PersonSeenInfoCarouselUpsertUserRelationInput:{
		update:"UserUpdateInput",
		create:"UserCreateInput"
	},
	InfoCarouselUpsertSeenByRelationInput:{
		by:"PersonSeenInfoCarouselUniqueWhere",
		update:"PersonSeenInfoCarouselWithoutCarouselUpdateInput",
		create:"PersonSeenInfoCarouselWithoutCarouselCreateInput"
	},
	InfoCarouselItemCreateInput:{
		id:"UUID",
		carousel:"InfoCarouselItemCreateCarouselEntityRelationInput",
		image:"InfoCarouselItemCreateImageEntityRelationInput",
		post:"InfoCarouselItemCreatePostEntityRelationInput",
		type:"InfoCarouselItemType",
		locales:"InfoCarouselItemCreateLocalesEntityRelationInput"
	},
	InfoCarouselItemCreateCarouselEntityRelationInput:{
		connect:"InfoCarouselUniqueWhere",
		create:"InfoCarouselWithoutItemsCreateInput",
		connectOrCreate:"InfoCarouselItemConnectOrCreateCarouselRelationInput"
	},
	InfoCarouselWithoutItemsCreateInput:{
		id:"UUID",
		validFrom:"DateTime",
		validTo:"DateTime",
		seenBy:"InfoCarouselCreateSeenByEntityRelationInput"
	},
	InfoCarouselItemConnectOrCreateCarouselRelationInput:{
		connect:"InfoCarouselUniqueWhere",
		create:"InfoCarouselWithoutItemsCreateInput"
	},
	InfoCarouselItemUpdateInput:{
		carousel:"InfoCarouselItemUpdateCarouselEntityRelationInput",
		image:"InfoCarouselItemUpdateImageEntityRelationInput",
		post:"InfoCarouselItemUpdatePostEntityRelationInput",
		type:"InfoCarouselItemType",
		locales:"InfoCarouselItemUpdateLocalesEntityRelationInput"
	},
	InfoCarouselItemUpdateCarouselEntityRelationInput:{
		connect:"InfoCarouselUniqueWhere",
		create:"InfoCarouselWithoutItemsCreateInput",
		connectOrCreate:"InfoCarouselItemConnectOrCreateCarouselRelationInput",
		update:"InfoCarouselWithoutItemsUpdateInput",
		upsert:"InfoCarouselItemUpsertCarouselRelationInput"
	},
	InfoCarouselWithoutItemsUpdateInput:{
		validFrom:"DateTime",
		validTo:"DateTime",
		seenBy:"InfoCarouselUpdateSeenByEntityRelationInput"
	},
	InfoCarouselItemUpsertCarouselRelationInput:{
		update:"InfoCarouselWithoutItemsUpdateInput",
		create:"InfoCarouselWithoutItemsCreateInput"
	},
	PersonSeenInfoCarouselCreateInput:{
		id:"UUID",
		seenAt:"DateTime",
		user:"PersonSeenInfoCarouselCreateUserEntityRelationInput",
		carousel:"PersonSeenInfoCarouselCreateCarouselEntityRelationInput"
	},
	PersonSeenInfoCarouselCreateCarouselEntityRelationInput:{
		connect:"InfoCarouselUniqueWhere",
		create:"InfoCarouselWithoutSeenByCreateInput",
		connectOrCreate:"PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"
	},
	InfoCarouselWithoutSeenByCreateInput:{
		id:"UUID",
		validFrom:"DateTime",
		validTo:"DateTime",
		items:"InfoCarouselCreateItemsEntityRelationInput"
	},
	PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput:{
		connect:"InfoCarouselUniqueWhere",
		create:"InfoCarouselWithoutSeenByCreateInput"
	},
	PersonSeenInfoCarouselUpdateInput:{
		seenAt:"DateTime",
		user:"PersonSeenInfoCarouselUpdateUserEntityRelationInput",
		carousel:"PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"
	},
	PersonSeenInfoCarouselUpdateCarouselEntityRelationInput:{
		connect:"InfoCarouselUniqueWhere",
		create:"InfoCarouselWithoutSeenByCreateInput",
		connectOrCreate:"PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput",
		update:"InfoCarouselWithoutSeenByUpdateInput",
		upsert:"PersonSeenInfoCarouselUpsertCarouselRelationInput"
	},
	InfoCarouselWithoutSeenByUpdateInput:{
		validFrom:"DateTime",
		validTo:"DateTime",
		items:"InfoCarouselUpdateItemsEntityRelationInput"
	},
	PersonSeenInfoCarouselUpsertCarouselRelationInput:{
		update:"InfoCarouselWithoutSeenByUpdateInput",
		create:"InfoCarouselWithoutSeenByCreateInput"
	},
	GivenGiftsPageCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"GivenGiftsPageCreateLocalesEntityRelationInput"
	},
	GivenGiftsPageCreateLocalesEntityRelationInput:{
		connect:"GivenGiftsPageLocaleUniqueWhere",
		create:"GivenGiftsPageLocaleWithoutRootCreateInput",
		connectOrCreate:"GivenGiftsPageConnectOrCreateLocalesRelationInput"
	},
	GivenGiftsPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"GivenGiftsPageLocaleCreateLocaleEntityRelationInput",
		content:"GivenGiftsPageLocaleCreateContentEntityRelationInput",
		seo:"GivenGiftsPageLocaleCreateSeoEntityRelationInput",
		link:"GivenGiftsPageLocaleCreateLinkEntityRelationInput"
	},
	GivenGiftsPageConnectOrCreateLocalesRelationInput:{
		connect:"GivenGiftsPageLocaleUniqueWhere",
		create:"GivenGiftsPageLocaleWithoutRootCreateInput"
	},
	GivenGiftsPageUpdateInput:{
		unique:"One",
		locales:"GivenGiftsPageUpdateLocalesEntityRelationInput"
	},
	GivenGiftsPageUpdateLocalesEntityRelationInput:{
		create:"GivenGiftsPageLocaleWithoutRootCreateInput",
		update:"GivenGiftsPageUpdateLocalesRelationInput",
		upsert:"GivenGiftsPageUpsertLocalesRelationInput",
		connect:"GivenGiftsPageLocaleUniqueWhere",
		disconnect:"GivenGiftsPageLocaleUniqueWhere",
		delete:"GivenGiftsPageLocaleUniqueWhere"
	},
	GivenGiftsPageUpdateLocalesRelationInput:{
		by:"GivenGiftsPageLocaleUniqueWhere",
		data:"GivenGiftsPageLocaleWithoutRootUpdateInput"
	},
	GivenGiftsPageLocaleWithoutRootUpdateInput:{
		locale:"GivenGiftsPageLocaleUpdateLocaleEntityRelationInput",
		content:"GivenGiftsPageLocaleUpdateContentEntityRelationInput",
		seo:"GivenGiftsPageLocaleUpdateSeoEntityRelationInput",
		link:"GivenGiftsPageLocaleUpdateLinkEntityRelationInput"
	},
	GivenGiftsPageUpsertLocalesRelationInput:{
		by:"GivenGiftsPageLocaleUniqueWhere",
		update:"GivenGiftsPageLocaleWithoutRootUpdateInput",
		create:"GivenGiftsPageLocaleWithoutRootCreateInput"
	},
	GivenGiftsPageLocaleCreateInput:{
		id:"UUID",
		root:"GivenGiftsPageLocaleCreateRootEntityRelationInput",
		locale:"GivenGiftsPageLocaleCreateLocaleEntityRelationInput",
		content:"GivenGiftsPageLocaleCreateContentEntityRelationInput",
		seo:"GivenGiftsPageLocaleCreateSeoEntityRelationInput",
		link:"GivenGiftsPageLocaleCreateLinkEntityRelationInput"
	},
	GivenGiftsPageLocaleUpdateInput:{
		root:"GivenGiftsPageLocaleUpdateRootEntityRelationInput",
		locale:"GivenGiftsPageLocaleUpdateLocaleEntityRelationInput",
		content:"GivenGiftsPageLocaleUpdateContentEntityRelationInput",
		seo:"GivenGiftsPageLocaleUpdateSeoEntityRelationInput",
		link:"GivenGiftsPageLocaleUpdateLinkEntityRelationInput"
	},
	ReceivedGiftsPageCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"ReceivedGiftsPageCreateLocalesEntityRelationInput"
	},
	ReceivedGiftsPageCreateLocalesEntityRelationInput:{
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		create:"ReceivedGiftsPageLocaleWithoutRootCreateInput",
		connectOrCreate:"ReceivedGiftsPageConnectOrCreateLocalesRelationInput"
	},
	ReceivedGiftsPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		link:"ReceivedGiftsPageLocaleCreateLinkEntityRelationInput",
		locale:"ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput",
		content:"ReceivedGiftsPageLocaleCreateContentEntityRelationInput",
		seo:"ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"
	},
	ReceivedGiftsPageConnectOrCreateLocalesRelationInput:{
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		create:"ReceivedGiftsPageLocaleWithoutRootCreateInput"
	},
	ReceivedGiftsPageUpdateInput:{
		unique:"One",
		locales:"ReceivedGiftsPageUpdateLocalesEntityRelationInput"
	},
	ReceivedGiftsPageUpdateLocalesEntityRelationInput:{
		create:"ReceivedGiftsPageLocaleWithoutRootCreateInput",
		update:"ReceivedGiftsPageUpdateLocalesRelationInput",
		upsert:"ReceivedGiftsPageUpsertLocalesRelationInput",
		connect:"ReceivedGiftsPageLocaleUniqueWhere",
		disconnect:"ReceivedGiftsPageLocaleUniqueWhere",
		delete:"ReceivedGiftsPageLocaleUniqueWhere"
	},
	ReceivedGiftsPageUpdateLocalesRelationInput:{
		by:"ReceivedGiftsPageLocaleUniqueWhere",
		data:"ReceivedGiftsPageLocaleWithoutRootUpdateInput"
	},
	ReceivedGiftsPageLocaleWithoutRootUpdateInput:{
		link:"ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput",
		locale:"ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput",
		content:"ReceivedGiftsPageLocaleUpdateContentEntityRelationInput",
		seo:"ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"
	},
	ReceivedGiftsPageUpsertLocalesRelationInput:{
		by:"ReceivedGiftsPageLocaleUniqueWhere",
		update:"ReceivedGiftsPageLocaleWithoutRootUpdateInput",
		create:"ReceivedGiftsPageLocaleWithoutRootCreateInput"
	},
	ReceivedGiftsPageLocaleCreateInput:{
		id:"UUID",
		link:"ReceivedGiftsPageLocaleCreateLinkEntityRelationInput",
		root:"ReceivedGiftsPageLocaleCreateRootEntityRelationInput",
		locale:"ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput",
		content:"ReceivedGiftsPageLocaleCreateContentEntityRelationInput",
		seo:"ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"
	},
	ReceivedGiftsPageLocaleUpdateInput:{
		link:"ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput",
		root:"ReceivedGiftsPageLocaleUpdateRootEntityRelationInput",
		locale:"ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput",
		content:"ReceivedGiftsPageLocaleUpdateContentEntityRelationInput",
		seo:"ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"
	},
	ReportNavigationCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"ReportNavigationCreateLocalesEntityRelationInput"
	},
	ReportNavigationCreateLocalesEntityRelationInput:{
		connect:"ReportNavigationLocaleUniqueWhere",
		create:"ReportNavigationLocaleWithoutRootCreateInput",
		connectOrCreate:"ReportNavigationConnectOrCreateLocalesRelationInput"
	},
	ReportNavigationLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ReportNavigationLocaleCreateLocaleEntityRelationInput",
		pages:"ReportNavigationLocaleCreatePagesEntityRelationInput"
	},
	ReportNavigationConnectOrCreateLocalesRelationInput:{
		connect:"ReportNavigationLocaleUniqueWhere",
		create:"ReportNavigationLocaleWithoutRootCreateInput"
	},
	ReportNavigationUpdateInput:{
		unique:"One",
		locales:"ReportNavigationUpdateLocalesEntityRelationInput"
	},
	ReportNavigationUpdateLocalesEntityRelationInput:{
		create:"ReportNavigationLocaleWithoutRootCreateInput",
		update:"ReportNavigationUpdateLocalesRelationInput",
		upsert:"ReportNavigationUpsertLocalesRelationInput",
		connect:"ReportNavigationLocaleUniqueWhere",
		disconnect:"ReportNavigationLocaleUniqueWhere",
		delete:"ReportNavigationLocaleUniqueWhere"
	},
	ReportNavigationUpdateLocalesRelationInput:{
		by:"ReportNavigationLocaleUniqueWhere",
		data:"ReportNavigationLocaleWithoutRootUpdateInput"
	},
	ReportNavigationLocaleWithoutRootUpdateInput:{
		locale:"ReportNavigationLocaleUpdateLocaleEntityRelationInput",
		pages:"ReportNavigationLocaleUpdatePagesEntityRelationInput"
	},
	ReportNavigationUpsertLocalesRelationInput:{
		by:"ReportNavigationLocaleUniqueWhere",
		update:"ReportNavigationLocaleWithoutRootUpdateInput",
		create:"ReportNavigationLocaleWithoutRootCreateInput"
	},
	ReportPageCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"ReportPageCreateLocalesEntityRelationInput"
	},
	ReportPageCreateLocalesEntityRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutRootCreateInput",
		connectOrCreate:"ReportPageConnectOrCreateLocalesRelationInput"
	},
	ReportPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		link:"ReportPageLocaleCreateLinkEntityRelationInput",
		locale:"ReportPageLocaleCreateLocaleEntityRelationInput",
		content:"ReportPageLocaleCreateContentEntityRelationInput",
		seo:"ReportPageLocaleCreateSeoEntityRelationInput",
		posts:"ReportPageLocaleCreatePostsEntityRelationInput"
	},
	ReportPageConnectOrCreateLocalesRelationInput:{
		connect:"ReportPageLocaleUniqueWhere",
		create:"ReportPageLocaleWithoutRootCreateInput"
	},
	ReportPageUpdateInput:{
		unique:"One",
		locales:"ReportPageUpdateLocalesEntityRelationInput"
	},
	ReportPageUpdateLocalesEntityRelationInput:{
		create:"ReportPageLocaleWithoutRootCreateInput",
		update:"ReportPageUpdateLocalesRelationInput",
		upsert:"ReportPageUpsertLocalesRelationInput",
		connect:"ReportPageLocaleUniqueWhere",
		disconnect:"ReportPageLocaleUniqueWhere",
		delete:"ReportPageLocaleUniqueWhere"
	},
	ReportPageUpdateLocalesRelationInput:{
		by:"ReportPageLocaleUniqueWhere",
		data:"ReportPageLocaleWithoutRootUpdateInput"
	},
	ReportPageLocaleWithoutRootUpdateInput:{
		link:"ReportPageLocaleUpdateLinkEntityRelationInput",
		locale:"ReportPageLocaleUpdateLocaleEntityRelationInput",
		content:"ReportPageLocaleUpdateContentEntityRelationInput",
		seo:"ReportPageLocaleUpdateSeoEntityRelationInput",
		posts:"ReportPageLocaleUpdatePostsEntityRelationInput"
	},
	ReportPageUpsertLocalesRelationInput:{
		by:"ReportPageLocaleUniqueWhere",
		update:"ReportPageLocaleWithoutRootUpdateInput",
		create:"ReportPageLocaleWithoutRootCreateInput"
	},
	ReportPageLocaleCreateInput:{
		id:"UUID",
		link:"ReportPageLocaleCreateLinkEntityRelationInput",
		root:"ReportPageLocaleCreateRootEntityRelationInput",
		locale:"ReportPageLocaleCreateLocaleEntityRelationInput",
		content:"ReportPageLocaleCreateContentEntityRelationInput",
		seo:"ReportPageLocaleCreateSeoEntityRelationInput",
		posts:"ReportPageLocaleCreatePostsEntityRelationInput"
	},
	ReportPageLocaleUpdateInput:{
		link:"ReportPageLocaleUpdateLinkEntityRelationInput",
		root:"ReportPageLocaleUpdateRootEntityRelationInput",
		locale:"ReportPageLocaleUpdateLocaleEntityRelationInput",
		content:"ReportPageLocaleUpdateContentEntityRelationInput",
		seo:"ReportPageLocaleUpdateSeoEntityRelationInput",
		posts:"ReportPageLocaleUpdatePostsEntityRelationInput"
	},
	ReportNavigationLocaleCreateInput:{
		id:"UUID",
		root:"ReportNavigationLocaleCreateRootEntityRelationInput",
		locale:"ReportNavigationLocaleCreateLocaleEntityRelationInput",
		pages:"ReportNavigationLocaleCreatePagesEntityRelationInput"
	},
	ReportNavigationLocaleUpdateInput:{
		root:"ReportNavigationLocaleUpdateRootEntityRelationInput",
		locale:"ReportNavigationLocaleUpdateLocaleEntityRelationInput",
		pages:"ReportNavigationLocaleUpdatePagesEntityRelationInput"
	},
	SentPaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		sendAt:"DateTime",
		currency:"SentPaymentCreateCurrencyEntityRelationInput",
		area:"SentPaymentCreateAreaEntityRelationInput",
		organization:"SentPaymentCreateOrganizationEntityRelationInput",
		locales:"SentPaymentCreateLocalesEntityRelationInput"
	},
	SentPaymentUpdateInput:{
		createdAt:"DateTime",
		sendAt:"DateTime",
		currency:"SentPaymentUpdateCurrencyEntityRelationInput",
		area:"SentPaymentUpdateAreaEntityRelationInput",
		organization:"SentPaymentUpdateOrganizationEntityRelationInput",
		locales:"SentPaymentUpdateLocalesEntityRelationInput"
	},
	ProcessedNotificationCreateInput:{
		id:"UUID",
		sentAt:"DateTime",
		source:"ProcessedNotificationCreateSourceEntityRelationInput"
	},
	ProcessedNotificationCreateSourceEntityRelationInput:{
		connect:"ProcessedNotificationSourceUniqueWhere",
		create:"ProcessedNotificationSourceWithoutProcessedNotificationCreateInput",
		connectOrCreate:"ProcessedNotificationConnectOrCreateSourceRelationInput"
	},
	ProcessedNotificationSourceWithoutProcessedNotificationCreateInput:{
		id:"UUID",
		type:"ProcessedNotificationSourceType",
		donationReminderUser:"ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput",
		scheduledNotification:"ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"
	},
	ProcessedNotificationConnectOrCreateSourceRelationInput:{
		connect:"ProcessedNotificationSourceUniqueWhere",
		create:"ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"
	},
	ProcessedNotificationUpdateInput:{
		sentAt:"DateTime",
		source:"ProcessedNotificationUpdateSourceEntityRelationInput"
	},
	ProcessedNotificationUpdateSourceEntityRelationInput:{
		connect:"ProcessedNotificationSourceUniqueWhere",
		create:"ProcessedNotificationSourceWithoutProcessedNotificationCreateInput",
		connectOrCreate:"ProcessedNotificationConnectOrCreateSourceRelationInput",
		update:"ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput",
		upsert:"ProcessedNotificationUpsertSourceRelationInput"
	},
	ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput:{
		type:"ProcessedNotificationSourceType",
		donationReminderUser:"ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput",
		scheduledNotification:"ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"
	},
	ProcessedNotificationUpsertSourceRelationInput:{
		update:"ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput",
		create:"ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"
	},
	ScheduledNotificationCreateInput:{
		id:"UUID",
		scheduledDate:"Date",
		target:"ScheduledNotificationCreateTargetEntityRelationInput",
		locales:"ScheduledNotificationCreateLocalesEntityRelationInput",
		image:"ScheduledNotificationCreateImageEntityRelationInput",
		completedAt:"DateTime",
		processedNotifications:"ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"
	},
	ScheduledNotificationUpdateInput:{
		scheduledDate:"Date",
		target:"ScheduledNotificationUpdateTargetEntityRelationInput",
		locales:"ScheduledNotificationUpdateLocalesEntityRelationInput",
		image:"ScheduledNotificationUpdateImageEntityRelationInput",
		completedAt:"DateTime",
		processedNotifications:"ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"
	},
	ProcessedNotificationSourceCreateInput:{
		id:"UUID",
		type:"ProcessedNotificationSourceType",
		processedNotification:"ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput",
		donationReminderUser:"ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput",
		scheduledNotification:"ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"
	},
	ProcessedNotificationSourceUpdateInput:{
		type:"ProcessedNotificationSourceType",
		processedNotification:"ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput",
		donationReminderUser:"ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput",
		scheduledNotification:"ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"
	},
	DeviceCreateInput:{
		id:"UUID",
		user:"DeviceCreateUserEntityRelationInput",
		createdAt:"DateTime",
		lastActiveAt:"DateTime"
	},
	DeviceCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutDevicesCreateInput",
		connectOrCreate:"DeviceConnectOrCreateUserRelationInput"
	},
	UserWithoutDevicesCreateInput:{
		id:"UUID",
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserCreatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserCreateRegionEntityRelationInput",
		currency:"UserCreateCurrencyEntityRelationInput",
		recurringPayments:"UserCreateRecurringPaymentsEntityRelationInput",
		onBehalfDonations:"UserCreateOnBehalfDonationsEntityRelationInput",
		locale:"UserCreateLocaleEntityRelationInput",
		processedNotifications:"UserCreateProcessedNotificationsEntityRelationInput",
		areaStats:"UserCreateAreaStatsEntityRelationInput",
		organizationStats:"UserCreateOrganizationStatsEntityRelationInput",
		postStats:"UserCreatePostStatsEntityRelationInput",
		currencyStats:"UserCreateCurrencyStatsEntityRelationInput"
	},
	DeviceConnectOrCreateUserRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutDevicesCreateInput"
	},
	DeviceUpdateInput:{
		user:"DeviceUpdateUserEntityRelationInput",
		createdAt:"DateTime",
		lastActiveAt:"DateTime"
	},
	DeviceUpdateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutDevicesCreateInput",
		connectOrCreate:"DeviceConnectOrCreateUserRelationInput",
		update:"UserWithoutDevicesUpdateInput",
		upsert:"DeviceUpsertUserRelationInput"
	},
	UserWithoutDevicesUpdateInput:{
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		payments:"UserUpdatePaymentsEntityRelationInput",
		lastActiveAt:"DateTime",
		region:"UserUpdateRegionEntityRelationInput",
		currency:"UserUpdateCurrencyEntityRelationInput",
		recurringPayments:"UserUpdateRecurringPaymentsEntityRelationInput",
		onBehalfDonations:"UserUpdateOnBehalfDonationsEntityRelationInput",
		locale:"UserUpdateLocaleEntityRelationInput",
		processedNotifications:"UserUpdateProcessedNotificationsEntityRelationInput",
		areaStats:"UserUpdateAreaStatsEntityRelationInput",
		organizationStats:"UserUpdateOrganizationStatsEntityRelationInput",
		postStats:"UserUpdatePostStatsEntityRelationInput",
		currencyStats:"UserUpdateCurrencyStatsEntityRelationInput"
	},
	DeviceUpsertUserRelationInput:{
		update:"UserWithoutDevicesUpdateInput",
		create:"UserWithoutDevicesCreateInput"
	},
	ScheduledNotificationLocaleCreateInput:{
		id:"UUID",
		root:"ScheduledNotificationLocaleCreateRootEntityRelationInput",
		locale:"ScheduledNotificationLocaleCreateLocaleEntityRelationInput"
	},
	ScheduledNotificationLocaleUpdateInput:{
		root:"ScheduledNotificationLocaleUpdateRootEntityRelationInput",
		locale:"ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"
	},
	InfoCarouselItemLocaleCreateInput:{
		id:"UUID",
		root:"InfoCarouselItemLocaleCreateRootEntityRelationInput",
		locale:"InfoCarouselItemLocaleCreateLocaleEntityRelationInput"
	},
	InfoCarouselItemLocaleCreateRootEntityRelationInput:{
		connect:"InfoCarouselItemUniqueWhere",
		create:"InfoCarouselItemWithoutLocalesCreateInput",
		connectOrCreate:"InfoCarouselItemLocaleConnectOrCreateRootRelationInput"
	},
	InfoCarouselItemWithoutLocalesCreateInput:{
		id:"UUID",
		carousel:"InfoCarouselItemCreateCarouselEntityRelationInput",
		image:"InfoCarouselItemCreateImageEntityRelationInput",
		post:"InfoCarouselItemCreatePostEntityRelationInput",
		type:"InfoCarouselItemType"
	},
	InfoCarouselItemLocaleConnectOrCreateRootRelationInput:{
		connect:"InfoCarouselItemUniqueWhere",
		create:"InfoCarouselItemWithoutLocalesCreateInput"
	},
	InfoCarouselItemLocaleUpdateInput:{
		root:"InfoCarouselItemLocaleUpdateRootEntityRelationInput",
		locale:"InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"
	},
	InfoCarouselItemLocaleUpdateRootEntityRelationInput:{
		connect:"InfoCarouselItemUniqueWhere",
		create:"InfoCarouselItemWithoutLocalesCreateInput",
		connectOrCreate:"InfoCarouselItemLocaleConnectOrCreateRootRelationInput",
		update:"InfoCarouselItemWithoutLocalesUpdateInput",
		upsert:"InfoCarouselItemLocaleUpsertRootRelationInput"
	},
	InfoCarouselItemWithoutLocalesUpdateInput:{
		carousel:"InfoCarouselItemUpdateCarouselEntityRelationInput",
		image:"InfoCarouselItemUpdateImageEntityRelationInput",
		post:"InfoCarouselItemUpdatePostEntityRelationInput",
		type:"InfoCarouselItemType"
	},
	InfoCarouselItemLocaleUpsertRootRelationInput:{
		update:"InfoCarouselItemWithoutLocalesUpdateInput",
		create:"InfoCarouselItemWithoutLocalesCreateInput"
	},
	SentPaymentLocaleCreateInput:{
		id:"UUID",
		root:"SentPaymentLocaleCreateRootEntityRelationInput",
		locale:"SentPaymentLocaleCreateLocaleEntityRelationInput"
	},
	SentPaymentLocaleUpdateInput:{
		root:"SentPaymentLocaleUpdateRootEntityRelationInput",
		locale:"SentPaymentLocaleUpdateLocaleEntityRelationInput"
	},
	StatsUniqueWhere:{
		id:"UUID",
		unique:"One"
	},
	StatsWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		totalUserCount:"IntCondition",
		successfulPaymentCount:"IntCondition",
		sentPaymentCount:"IntCondition",
		totalAreaCents:"IntCondition",
		totalAreaSentPaymentCents:"IntCondition",
		totalAreaCzkPercentage:"FloatCondition",
		totalAreaSentPaymentCzkPercentage:"FloatCondition",
		and:"StatsWhere",
		or:"StatsWhere",
		not:"StatsWhere"
	},
	StatsOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		totalUserCount:"OrderDirection",
		successfulPaymentCount:"OrderDirection",
		sentPaymentCount:"OrderDirection",
		totalAreaCents:"OrderDirection",
		totalAreaSentPaymentCents:"OrderDirection",
		totalAreaCzkPercentage:"OrderDirection",
		totalAreaSentPaymentCzkPercentage:"OrderDirection"
	},
	TextImageListItemCreateInput:{
		id:"UUID",
		list:"TextImageListItemCreateListEntityRelationInput",
		image:"TextImageListItemCreateImageEntityRelationInput",
		link:"TextImageListItemCreateLinkEntityRelationInput"
	},
	TextImageListItemCreateListEntityRelationInput:{
		connect:"TextImageListUniqueWhere",
		create:"TextImageListWithoutItemsCreateInput",
		connectOrCreate:"TextImageListItemConnectOrCreateListRelationInput"
	},
	TextImageListWithoutItemsCreateInput:{
		id:"UUID"
	},
	TextImageListItemConnectOrCreateListRelationInput:{
		connect:"TextImageListUniqueWhere",
		create:"TextImageListWithoutItemsCreateInput"
	},
	TextImageListItemUpdateInput:{
		list:"TextImageListItemUpdateListEntityRelationInput",
		image:"TextImageListItemUpdateImageEntityRelationInput",
		link:"TextImageListItemUpdateLinkEntityRelationInput"
	},
	TextImageListItemUpdateListEntityRelationInput:{
		connect:"TextImageListUniqueWhere",
		create:"TextImageListWithoutItemsCreateInput",
		connectOrCreate:"TextImageListItemConnectOrCreateListRelationInput",
		update:"TextImageListWithoutItemsUpdateInput",
		upsert:"TextImageListItemUpsertListRelationInput"
	},
	TextImageListWithoutItemsUpdateInput:{

	},
	TextImageListItemUpsertListRelationInput:{
		update:"TextImageListWithoutItemsUpdateInput",
		create:"TextImageListWithoutItemsCreateInput"
	},
	HeroCarouselItemCreateInput:{
		id:"UUID",
		createdAt:"Date",
		list:"HeroCarouselItemCreateListEntityRelationInput",
		item:"HeroCarouselItemCreateItemEntityRelationInput"
	},
	HeroCarouselItemCreateListEntityRelationInput:{
		connect:"HeroCarouselUniqueWhere",
		create:"HeroCarouselWithoutItemsCreateInput",
		connectOrCreate:"HeroCarouselItemConnectOrCreateListRelationInput"
	},
	HeroCarouselWithoutItemsCreateInput:{
		id:"UUID",
		createdAt:"Date",
		posts:"HeroCarouselCreatePostsEntityRelationInput"
	},
	HeroCarouselItemConnectOrCreateListRelationInput:{
		connect:"HeroCarouselUniqueWhere",
		create:"HeroCarouselWithoutItemsCreateInput"
	},
	HeroCarouselItemUpdateInput:{
		createdAt:"Date",
		list:"HeroCarouselItemUpdateListEntityRelationInput",
		item:"HeroCarouselItemUpdateItemEntityRelationInput"
	},
	HeroCarouselItemUpdateListEntityRelationInput:{
		connect:"HeroCarouselUniqueWhere",
		create:"HeroCarouselWithoutItemsCreateInput",
		connectOrCreate:"HeroCarouselItemConnectOrCreateListRelationInput",
		update:"HeroCarouselWithoutItemsUpdateInput",
		upsert:"HeroCarouselItemUpsertListRelationInput"
	},
	HeroCarouselWithoutItemsUpdateInput:{
		createdAt:"Date",
		posts:"HeroCarouselUpdatePostsEntityRelationInput"
	},
	HeroCarouselItemUpsertListRelationInput:{
		update:"HeroCarouselWithoutItemsUpdateInput",
		create:"HeroCarouselWithoutItemsCreateInput"
	},
	QueryTransaction:{
		getGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere"
		},
		listGeneral:{
			filter:"GeneralWhere",
			orderBy:"GeneralOrderBy"
		},
		paginateGeneral:{
			filter:"GeneralWhere",
			orderBy:"GeneralOrderBy"
		},
		validateCreateGeneral:{
			data:"GeneralCreateInput"
		},
		validateUpdateGeneral:{
			by:"GeneralUniqueWhere",
			data:"GeneralUpdateInput"
		},
		getImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		listImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		paginateImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		validateCreateImage:{
			data:"ImageCreateInput"
		},
		validateUpdateImage:{
			by:"ImageUniqueWhere",
			data:"ImageUpdateInput"
		},
		getGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere"
		},
		listGenericPage:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		paginateGenericPage:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		validateCreateGenericPage:{
			data:"GenericPageCreateInput"
		},
		validateUpdateGenericPage:{
			by:"GenericPageUniqueWhere",
			data:"GenericPageUpdateInput"
		},
		getLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		listLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		paginateLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		validateCreateLinkable:{
			data:"LinkableCreateInput"
		},
		validateUpdateLinkable:{
			by:"LinkableUniqueWhere",
			data:"LinkableUpdateInput"
		},
		getSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		listSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		paginateSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		validateCreateSeo:{
			data:"SeoCreateInput"
		},
		validateUpdateSeo:{
			by:"SeoUniqueWhere",
			data:"SeoUpdateInput"
		},
		getContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		listContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		paginateContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		validateCreateContent:{
			data:"ContentCreateInput"
		},
		validateUpdateContent:{
			by:"ContentUniqueWhere",
			data:"ContentUpdateInput"
		},
		getContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		listContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		paginateContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		validateCreateContentBlock:{
			data:"ContentBlockCreateInput"
		},
		validateUpdateContentBlock:{
			by:"ContentBlockUniqueWhere",
			data:"ContentBlockUpdateInput"
		},
		getContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		listContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		paginateContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		validateCreateContentReference:{
			data:"ContentReferenceCreateInput"
		},
		validateUpdateContentReference:{
			by:"ContentReferenceUniqueWhere",
			data:"ContentReferenceUpdateInput"
		},
		getContentReferenceLinkableItem:{
			by:"ContentReferenceLinkableItemUniqueWhere",
			filter:"ContentReferenceLinkableItemWhere"
		},
		listContentReferenceLinkableItem:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		paginateContentReferenceLinkableItem:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		getGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		listGeneralLocale:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		paginateGeneralLocale:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		validateCreateGeneralLocale:{
			data:"GeneralLocaleCreateInput"
		},
		validateUpdateGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			data:"GeneralLocaleUpdateInput"
		},
		getGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		listGenericPageLocale:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		paginateGenericPageLocale:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		validateCreateGenericPageLocale:{
			data:"GenericPageLocaleCreateInput"
		},
		validateUpdateGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			data:"GenericPageLocaleUpdateInput"
		},
		getLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		listLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		paginateLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		validateCreateLocale:{
			data:"LocaleCreateInput"
		},
		validateUpdateLocale:{
			by:"LocaleUniqueWhere",
			data:"LocaleUpdateInput"
		},
		getVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		listVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		paginateVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		validateCreateVideo:{
			data:"VideoCreateInput"
		},
		validateUpdateVideo:{
			by:"VideoUniqueWhere",
			data:"VideoUpdateInput"
		},
		getLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		listLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		paginateLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		validateCreateLink:{
			data:"LinkCreateInput"
		},
		validateUpdateLink:{
			by:"LinkUniqueWhere",
			data:"LinkUpdateInput"
		},
		getPost:{
			by:"PostUniqueWhere",
			filter:"PostWhere"
		},
		listPost:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		paginatePost:{
			filter:"PostWhere",
			orderBy:"PostOrderBy"
		},
		validateCreatePost:{
			data:"PostCreateInput"
		},
		validateUpdatePost:{
			by:"PostUniqueWhere",
			data:"PostUpdateInput"
		},
		getPostLocale:{
			by:"PostLocaleUniqueWhere",
			filter:"PostLocaleWhere"
		},
		listPostLocale:{
			filter:"PostLocaleWhere",
			orderBy:"PostLocaleOrderBy"
		},
		paginatePostLocale:{
			filter:"PostLocaleWhere",
			orderBy:"PostLocaleOrderBy"
		},
		validateCreatePostLocale:{
			data:"PostLocaleCreateInput"
		},
		validateUpdatePostLocale:{
			by:"PostLocaleUniqueWhere",
			data:"PostLocaleUpdateInput"
		},
		getPostArea:{
			by:"PostAreaUniqueWhere",
			filter:"PostAreaWhere"
		},
		listPostArea:{
			filter:"PostAreaWhere",
			orderBy:"PostAreaOrderBy"
		},
		paginatePostArea:{
			filter:"PostAreaWhere",
			orderBy:"PostAreaOrderBy"
		},
		validateCreatePostArea:{
			data:"PostAreaCreateInput"
		},
		validateUpdatePostArea:{
			by:"PostAreaUniqueWhere",
			data:"PostAreaUpdateInput"
		},
		getPostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		listPostAreaLocale:{
			filter:"PostAreaLocaleWhere",
			orderBy:"PostAreaLocaleOrderBy"
		},
		paginatePostAreaLocale:{
			filter:"PostAreaLocaleWhere",
			orderBy:"PostAreaLocaleOrderBy"
		},
		validateCreatePostAreaLocale:{
			data:"PostAreaLocaleCreateInput"
		},
		validateUpdatePostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			data:"PostAreaLocaleUpdateInput"
		},
		getPostOrganization:{
			by:"PostOrganizationUniqueWhere",
			filter:"PostOrganizationWhere"
		},
		listPostOrganization:{
			filter:"PostOrganizationWhere",
			orderBy:"PostOrganizationOrderBy"
		},
		paginatePostOrganization:{
			filter:"PostOrganizationWhere",
			orderBy:"PostOrganizationOrderBy"
		},
		validateCreatePostOrganization:{
			data:"PostOrganizationCreateInput"
		},
		validateUpdatePostOrganization:{
			by:"PostOrganizationUniqueWhere",
			data:"PostOrganizationUpdateInput"
		},
		getPostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		listPostOrganizationLocale:{
			filter:"PostOrganizationLocaleWhere",
			orderBy:"PostOrganizationLocaleOrderBy"
		},
		paginatePostOrganizationLocale:{
			filter:"PostOrganizationLocaleWhere",
			orderBy:"PostOrganizationLocaleOrderBy"
		},
		validateCreatePostOrganizationLocale:{
			data:"PostOrganizationLocaleCreateInput"
		},
		validateUpdatePostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			data:"PostOrganizationLocaleUpdateInput"
		},
		getDonation:{
			by:"DonationUniqueWhere",
			filter:"DonationWhere"
		},
		listDonation:{
			filter:"DonationWhere",
			orderBy:"DonationOrderBy"
		},
		paginateDonation:{
			filter:"DonationWhere",
			orderBy:"DonationOrderBy"
		},
		validateCreateDonation:{
			data:"DonationCreateInput"
		},
		validateUpdateDonation:{
			by:"DonationUniqueWhere",
			data:"DonationUpdateInput"
		},
		getDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			filter:"DonationAmountItemWhere"
		},
		listDonationAmountItem:{
			filter:"DonationAmountItemWhere",
			orderBy:"DonationAmountItemOrderBy"
		},
		paginateDonationAmountItem:{
			filter:"DonationAmountItemWhere",
			orderBy:"DonationAmountItemOrderBy"
		},
		validateCreateDonationAmountItem:{
			data:"DonationAmountItemCreateInput"
		},
		validateUpdateDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			data:"DonationAmountItemUpdateInput"
		},
		getDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			filter:"DonationAmountsRegionItemWhere"
		},
		listDonationAmountsRegionItem:{
			filter:"DonationAmountsRegionItemWhere",
			orderBy:"DonationAmountsRegionItemOrderBy"
		},
		paginateDonationAmountsRegionItem:{
			filter:"DonationAmountsRegionItemWhere",
			orderBy:"DonationAmountsRegionItemOrderBy"
		},
		validateCreateDonationAmountsRegionItem:{
			data:"DonationAmountsRegionItemCreateInput"
		},
		validateUpdateDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			data:"DonationAmountsRegionItemUpdateInput"
		},
		getDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			filter:"DonationAmountsRegionListWhere"
		},
		listDonationAmountsRegionList:{
			filter:"DonationAmountsRegionListWhere",
			orderBy:"DonationAmountsRegionListOrderBy"
		},
		paginateDonationAmountsRegionList:{
			filter:"DonationAmountsRegionListWhere",
			orderBy:"DonationAmountsRegionListOrderBy"
		},
		validateCreateDonationAmountsRegionList:{
			data:"DonationAmountsRegionListCreateInput"
		},
		validateUpdateDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			data:"DonationAmountsRegionListUpdateInput"
		},
		getRegion:{
			by:"RegionUniqueWhere",
			filter:"RegionWhere"
		},
		listRegion:{
			filter:"RegionWhere",
			orderBy:"RegionOrderBy"
		},
		paginateRegion:{
			filter:"RegionWhere",
			orderBy:"RegionOrderBy"
		},
		validateCreateRegion:{
			data:"RegionCreateInput"
		},
		validateUpdateRegion:{
			by:"RegionUniqueWhere",
			data:"RegionUpdateInput"
		},
		getLinkItem:{
			by:"LinkItemUniqueWhere",
			filter:"LinkItemWhere"
		},
		listLinkItem:{
			filter:"LinkItemWhere",
			orderBy:"LinkItemOrderBy"
		},
		paginateLinkItem:{
			filter:"LinkItemWhere",
			orderBy:"LinkItemOrderBy"
		},
		validateCreateLinkItem:{
			data:"LinkItemCreateInput"
		},
		validateUpdateLinkItem:{
			by:"LinkItemUniqueWhere",
			data:"LinkItemUpdateInput"
		},
		getLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere"
		},
		listLinkList:{
			filter:"LinkListWhere",
			orderBy:"LinkListOrderBy"
		},
		paginateLinkList:{
			filter:"LinkListWhere",
			orderBy:"LinkListOrderBy"
		},
		validateCreateLinkList:{
			data:"LinkListCreateInput"
		},
		validateUpdateLinkList:{
			by:"LinkListUniqueWhere",
			data:"LinkListUpdateInput"
		},
		getHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere"
		},
		listHeader:{
			filter:"HeaderWhere",
			orderBy:"HeaderOrderBy"
		},
		paginateHeader:{
			filter:"HeaderWhere",
			orderBy:"HeaderOrderBy"
		},
		validateCreateHeader:{
			data:"HeaderCreateInput"
		},
		validateUpdateHeader:{
			by:"HeaderUniqueWhere",
			data:"HeaderUpdateInput"
		},
		getHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		listHeaderLocale:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		paginateHeaderLocale:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		validateCreateHeaderLocale:{
			data:"HeaderLocaleCreateInput"
		},
		validateUpdateHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			data:"HeaderLocaleUpdateInput"
		},
		getFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere"
		},
		listFooter:{
			filter:"FooterWhere",
			orderBy:"FooterOrderBy"
		},
		paginateFooter:{
			filter:"FooterWhere",
			orderBy:"FooterOrderBy"
		},
		validateCreateFooter:{
			data:"FooterCreateInput"
		},
		validateUpdateFooter:{
			by:"FooterUniqueWhere",
			data:"FooterUpdateInput"
		},
		getFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		listFooterLocale:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		paginateFooterLocale:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		validateCreateFooterLocale:{
			data:"FooterLocaleCreateInput"
		},
		validateUpdateFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			data:"FooterLocaleUpdateInput"
		},
		getPostList:{
			by:"PostListUniqueWhere",
			filter:"PostListWhere"
		},
		listPostList:{
			filter:"PostListWhere",
			orderBy:"PostListOrderBy"
		},
		paginatePostList:{
			filter:"PostListWhere",
			orderBy:"PostListOrderBy"
		},
		validateCreatePostList:{
			data:"PostListCreateInput"
		},
		validateUpdatePostList:{
			by:"PostListUniqueWhere",
			data:"PostListUpdateInput"
		},
		getPostListItem:{
			by:"PostListItemUniqueWhere",
			filter:"PostListItemWhere"
		},
		listPostListItem:{
			filter:"PostListItemWhere",
			orderBy:"PostListItemOrderBy"
		},
		paginatePostListItem:{
			filter:"PostListItemWhere",
			orderBy:"PostListItemOrderBy"
		},
		validateCreatePostListItem:{
			data:"PostListItemCreateInput"
		},
		validateUpdatePostListItem:{
			by:"PostListItemUniqueWhere",
			data:"PostListItemUpdateInput"
		},
		getAppBanner:{
			by:"AppBannerUniqueWhere",
			filter:"AppBannerWhere"
		},
		listAppBanner:{
			filter:"AppBannerWhere",
			orderBy:"AppBannerOrderBy"
		},
		paginateAppBanner:{
			filter:"AppBannerWhere",
			orderBy:"AppBannerOrderBy"
		},
		validateCreateAppBanner:{
			data:"AppBannerCreateInput"
		},
		validateUpdateAppBanner:{
			by:"AppBannerUniqueWhere",
			data:"AppBannerUpdateInput"
		},
		getGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			filter:"GenericPageAboutSettingsWhere"
		},
		listGenericPageAboutSettings:{
			filter:"GenericPageAboutSettingsWhere",
			orderBy:"GenericPageAboutSettingsOrderBy"
		},
		paginateGenericPageAboutSettings:{
			filter:"GenericPageAboutSettingsWhere",
			orderBy:"GenericPageAboutSettingsOrderBy"
		},
		validateCreateGenericPageAboutSettings:{
			data:"GenericPageAboutSettingsCreateInput"
		},
		validateUpdateGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			data:"GenericPageAboutSettingsUpdateInput"
		},
		getGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		listGenericPageAboutSettingsLocale:{
			filter:"GenericPageAboutSettingsLocaleWhere",
			orderBy:"GenericPageAboutSettingsLocaleOrderBy"
		},
		paginateGenericPageAboutSettingsLocale:{
			filter:"GenericPageAboutSettingsLocaleWhere",
			orderBy:"GenericPageAboutSettingsLocaleOrderBy"
		},
		validateCreateGenericPageAboutSettingsLocale:{
			data:"GenericPageAboutSettingsLocaleCreateInput"
		},
		validateUpdateGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			data:"GenericPageAboutSettingsLocaleUpdateInput"
		},
		getValue:{
			by:"ValueUniqueWhere",
			filter:"ValueWhere"
		},
		listValue:{
			filter:"ValueWhere",
			orderBy:"ValueOrderBy"
		},
		paginateValue:{
			filter:"ValueWhere",
			orderBy:"ValueOrderBy"
		},
		validateCreateValue:{
			data:"ValueCreateInput"
		},
		validateUpdateValue:{
			by:"ValueUniqueWhere",
			data:"ValueUpdateInput"
		},
		getValueItem:{
			by:"ValueItemUniqueWhere",
			filter:"ValueItemWhere"
		},
		listValueItem:{
			filter:"ValueItemWhere",
			orderBy:"ValueItemOrderBy"
		},
		paginateValueItem:{
			filter:"ValueItemWhere",
			orderBy:"ValueItemOrderBy"
		},
		validateCreateValueItem:{
			data:"ValueItemCreateInput"
		},
		validateUpdateValueItem:{
			by:"ValueItemUniqueWhere",
			data:"ValueItemUpdateInput"
		},
		getValueList:{
			by:"ValueListUniqueWhere",
			filter:"ValueListWhere"
		},
		listValueList:{
			filter:"ValueListWhere",
			orderBy:"ValueListOrderBy"
		},
		paginateValueList:{
			filter:"ValueListWhere",
			orderBy:"ValueListOrderBy"
		},
		validateCreateValueList:{
			data:"ValueListCreateInput"
		},
		validateUpdateValueList:{
			by:"ValueListUniqueWhere",
			data:"ValueListUpdateInput"
		},
		getImageLink:{
			by:"ImageLinkUniqueWhere",
			filter:"ImageLinkWhere"
		},
		listImageLink:{
			filter:"ImageLinkWhere",
			orderBy:"ImageLinkOrderBy"
		},
		paginateImageLink:{
			filter:"ImageLinkWhere",
			orderBy:"ImageLinkOrderBy"
		},
		validateCreateImageLink:{
			data:"ImageLinkCreateInput"
		},
		validateUpdateImageLink:{
			by:"ImageLinkUniqueWhere",
			data:"ImageLinkUpdateInput"
		},
		getImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			filter:"ImageLinkItemWhere"
		},
		listImageLinkItem:{
			filter:"ImageLinkItemWhere",
			orderBy:"ImageLinkItemOrderBy"
		},
		paginateImageLinkItem:{
			filter:"ImageLinkItemWhere",
			orderBy:"ImageLinkItemOrderBy"
		},
		validateCreateImageLinkItem:{
			data:"ImageLinkItemCreateInput"
		},
		validateUpdateImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			data:"ImageLinkItemUpdateInput"
		},
		getImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			filter:"ImageLinkListWhere"
		},
		listImageLinkList:{
			filter:"ImageLinkListWhere",
			orderBy:"ImageLinkListOrderBy"
		},
		paginateImageLinkList:{
			filter:"ImageLinkListWhere",
			orderBy:"ImageLinkListOrderBy"
		},
		validateCreateImageLinkList:{
			data:"ImageLinkListCreateInput"
		},
		validateUpdateImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			data:"ImageLinkListUpdateInput"
		},
		getPostAreaList:{
			by:"PostAreaListUniqueWhere",
			filter:"PostAreaListWhere"
		},
		listPostAreaList:{
			filter:"PostAreaListWhere",
			orderBy:"PostAreaListOrderBy"
		},
		paginatePostAreaList:{
			filter:"PostAreaListWhere",
			orderBy:"PostAreaListOrderBy"
		},
		validateCreatePostAreaList:{
			data:"PostAreaListCreateInput"
		},
		validateUpdatePostAreaList:{
			by:"PostAreaListUniqueWhere",
			data:"PostAreaListUpdateInput"
		},
		getPostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			filter:"PostAreaListItemWhere"
		},
		listPostAreaListItem:{
			filter:"PostAreaListItemWhere",
			orderBy:"PostAreaListItemOrderBy"
		},
		paginatePostAreaListItem:{
			filter:"PostAreaListItemWhere",
			orderBy:"PostAreaListItemOrderBy"
		},
		validateCreatePostAreaListItem:{
			data:"PostAreaListItemCreateInput"
		},
		validateUpdatePostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			data:"PostAreaListItemUpdateInput"
		},
		getAccordion:{
			by:"AccordionUniqueWhere",
			filter:"AccordionWhere"
		},
		listAccordion:{
			filter:"AccordionWhere",
			orderBy:"AccordionOrderBy"
		},
		paginateAccordion:{
			filter:"AccordionWhere",
			orderBy:"AccordionOrderBy"
		},
		validateCreateAccordion:{
			data:"AccordionCreateInput"
		},
		validateUpdateAccordion:{
			by:"AccordionUniqueWhere",
			data:"AccordionUpdateInput"
		},
		getAccordionItem:{
			by:"AccordionItemUniqueWhere",
			filter:"AccordionItemWhere"
		},
		listAccordionItem:{
			filter:"AccordionItemWhere",
			orderBy:"AccordionItemOrderBy"
		},
		paginateAccordionItem:{
			filter:"AccordionItemWhere",
			orderBy:"AccordionItemOrderBy"
		},
		validateCreateAccordionItem:{
			data:"AccordionItemCreateInput"
		},
		validateUpdateAccordionItem:{
			by:"AccordionItemUniqueWhere",
			data:"AccordionItemUpdateInput"
		},
		getUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere"
		},
		listUser:{
			filter:"UserWhere",
			orderBy:"UserOrderBy"
		},
		paginateUser:{
			filter:"UserWhere",
			orderBy:"UserOrderBy"
		},
		validateCreateUser:{
			data:"UserCreateInput"
		},
		validateUpdateUser:{
			by:"UserUniqueWhere",
			data:"UserUpdateInput"
		},
		getUserPayment:{
			by:"UserPaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		listUserPayment:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		paginateUserPayment:{
			filter:"UserPaymentWhere",
			orderBy:"UserPaymentOrderBy"
		},
		validateCreateUserPayment:{
			data:"UserPaymentCreateInput"
		},
		validateUpdateUserPayment:{
			by:"UserPaymentUniqueWhere",
			data:"UserPaymentUpdateInput"
		},
		getCurrency:{
			by:"CurrencyUniqueWhere",
			filter:"CurrencyWhere"
		},
		listCurrency:{
			filter:"CurrencyWhere",
			orderBy:"CurrencyOrderBy"
		},
		paginateCurrency:{
			filter:"CurrencyWhere",
			orderBy:"CurrencyOrderBy"
		},
		validateCreateCurrency:{
			data:"CurrencyCreateInput"
		},
		validateUpdateCurrency:{
			by:"CurrencyUniqueWhere",
			data:"CurrencyUpdateInput"
		},
		getMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		listMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		paginateMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		validateCreateMedium:{
			data:"MediumCreateInput"
		},
		validateUpdateMedium:{
			by:"MediumUniqueWhere",
			data:"MediumUpdateInput"
		},
		getMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere"
		},
		listMediumItem:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		paginateMediumItem:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		validateCreateMediumItem:{
			data:"MediumItemCreateInput"
		},
		validateUpdateMediumItem:{
			by:"MediumItemUniqueWhere",
			data:"MediumItemUpdateInput"
		},
		getMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere"
		},
		listMediumList:{
			filter:"MediumListWhere",
			orderBy:"MediumListOrderBy"
		},
		paginateMediumList:{
			filter:"MediumListWhere",
			orderBy:"MediumListOrderBy"
		},
		validateCreateMediumList:{
			data:"MediumListCreateInput"
		},
		validateUpdateMediumList:{
			by:"MediumListUniqueWhere",
			data:"MediumListUpdateInput"
		},
		getUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			filter:"UserPaymentOrderIdWhere"
		},
		listUserPaymentOrderId:{
			filter:"UserPaymentOrderIdWhere",
			orderBy:"UserPaymentOrderIdOrderBy"
		},
		paginateUserPaymentOrderId:{
			filter:"UserPaymentOrderIdWhere",
			orderBy:"UserPaymentOrderIdOrderBy"
		},
		validateCreateUserPaymentOrderId:{
			data:"UserPaymentOrderIdCreateInput"
		},
		validateUpdateUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			data:"UserPaymentOrderIdUpdateInput"
		},
		getPostRevision:{
			by:"PostRevisionUniqueWhere",
			filter:"PostRevisionWhere"
		},
		listPostRevision:{
			filter:"PostRevisionWhere",
			orderBy:"PostRevisionOrderBy"
		},
		paginatePostRevision:{
			filter:"PostRevisionWhere",
			orderBy:"PostRevisionOrderBy"
		},
		validateCreatePostRevision:{
			data:"PostRevisionCreateInput"
		},
		validateUpdatePostRevision:{
			by:"PostRevisionUniqueWhere",
			data:"PostRevisionUpdateInput"
		},
		getUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			filter:"UserRecurringPaymentWhere"
		},
		listUserRecurringPayment:{
			filter:"UserRecurringPaymentWhere",
			orderBy:"UserRecurringPaymentOrderBy"
		},
		paginateUserRecurringPayment:{
			filter:"UserRecurringPaymentWhere",
			orderBy:"UserRecurringPaymentOrderBy"
		},
		validateCreateUserRecurringPayment:{
			data:"UserRecurringPaymentCreateInput"
		},
		validateUpdateUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			data:"UserRecurringPaymentUpdateInput"
		},
		getUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			filter:"UserRecurringPaymentItemWhere"
		},
		listUserRecurringPaymentItem:{
			filter:"UserRecurringPaymentItemWhere",
			orderBy:"UserRecurringPaymentItemOrderBy"
		},
		paginateUserRecurringPaymentItem:{
			filter:"UserRecurringPaymentItemWhere",
			orderBy:"UserRecurringPaymentItemOrderBy"
		},
		validateCreateUserRecurringPaymentItem:{
			data:"UserRecurringPaymentItemCreateInput"
		},
		validateUpdateUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			data:"UserRecurringPaymentItemUpdateInput"
		},
		getPostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		listPostRevisionLocale:{
			filter:"PostRevisionLocaleWhere",
			orderBy:"PostRevisionLocaleOrderBy"
		},
		paginatePostRevisionLocale:{
			filter:"PostRevisionLocaleWhere",
			orderBy:"PostRevisionLocaleOrderBy"
		},
		validateCreatePostRevisionLocale:{
			data:"PostRevisionLocaleCreateInput"
		},
		validateUpdatePostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			data:"PostRevisionLocaleUpdateInput"
		},
		getTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		listTranslationCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		paginateTranslationCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		validateCreateTranslationCatalogue:{
			data:"TranslationCatalogueCreateInput"
		},
		validateUpdateTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			data:"TranslationCatalogueUpdateInput"
		},
		getTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere"
		},
		listTranslationCataloguesIdentifier:{
			filter:"TranslationCataloguesIdentifierWhere",
			orderBy:"TranslationCataloguesIdentifierOrderBy"
		},
		paginateTranslationCataloguesIdentifier:{
			filter:"TranslationCataloguesIdentifierWhere",
			orderBy:"TranslationCataloguesIdentifierOrderBy"
		},
		validateCreateTranslationCataloguesIdentifier:{
			data:"TranslationCataloguesIdentifierCreateInput"
		},
		validateUpdateTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			data:"TranslationCataloguesIdentifierUpdateInput"
		},
		getTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere"
		},
		listTranslationDomain:{
			filter:"TranslationDomainWhere",
			orderBy:"TranslationDomainOrderBy"
		},
		paginateTranslationDomain:{
			filter:"TranslationDomainWhere",
			orderBy:"TranslationDomainOrderBy"
		},
		validateCreateTranslationDomain:{
			data:"TranslationDomainCreateInput"
		},
		validateUpdateTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			data:"TranslationDomainUpdateInput"
		},
		getTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		listTranslationKey:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		paginateTranslationKey:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		validateCreateTranslationKey:{
			data:"TranslationKeyCreateInput"
		},
		validateUpdateTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			data:"TranslationKeyUpdateInput"
		},
		getTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		listTranslationValue:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		paginateTranslationValue:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		validateCreateTranslationValue:{
			data:"TranslationValueCreateInput"
		},
		validateUpdateTranslationValue:{
			by:"TranslationValueUniqueWhere",
			data:"TranslationValueUpdateInput"
		},
		getGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere"
		},
		listGenericPageAboutGroupLinksLocale:{
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			orderBy:"GenericPageAboutGroupLinksLocaleOrderBy"
		},
		paginateGenericPageAboutGroupLinksLocale:{
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			orderBy:"GenericPageAboutGroupLinksLocaleOrderBy"
		},
		validateCreateGenericPageAboutGroupLinksLocale:{
			data:"GenericPageAboutGroupLinksLocaleCreateInput"
		},
		validateUpdateGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			data:"GenericPageAboutGroupLinksLocaleUpdateInput"
		},
		getMemberList:{
			by:"MemberListUniqueWhere",
			filter:"MemberListWhere"
		},
		listMemberList:{
			filter:"MemberListWhere",
			orderBy:"MemberListOrderBy"
		},
		paginateMemberList:{
			filter:"MemberListWhere",
			orderBy:"MemberListOrderBy"
		},
		validateCreateMemberList:{
			data:"MemberListCreateInput"
		},
		validateUpdateMemberList:{
			by:"MemberListUniqueWhere",
			data:"MemberListUpdateInput"
		},
		getMemberListItem:{
			by:"MemberListItemUniqueWhere",
			filter:"MemberListItemWhere"
		},
		listMemberListItem:{
			filter:"MemberListItemWhere",
			orderBy:"MemberListItemOrderBy"
		},
		paginateMemberListItem:{
			filter:"MemberListItemWhere",
			orderBy:"MemberListItemOrderBy"
		},
		validateCreateMemberListItem:{
			data:"MemberListItemCreateInput"
		},
		validateUpdateMemberListItem:{
			by:"MemberListItemUniqueWhere",
			data:"MemberListItemUpdateInput"
		},
		getFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			filter:"FilledTaxFormWhere"
		},
		listFilledTaxForm:{
			filter:"FilledTaxFormWhere",
			orderBy:"FilledTaxFormOrderBy"
		},
		paginateFilledTaxForm:{
			filter:"FilledTaxFormWhere",
			orderBy:"FilledTaxFormOrderBy"
		},
		validateCreateFilledTaxForm:{
			data:"FilledTaxFormCreateInput"
		},
		validateUpdateFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			data:"FilledTaxFormUpdateInput"
		},
		getFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			filter:"FilledTaxFormEmailAddressWhere"
		},
		listFilledTaxFormEmailAddress:{
			filter:"FilledTaxFormEmailAddressWhere",
			orderBy:"FilledTaxFormEmailAddressOrderBy"
		},
		paginateFilledTaxFormEmailAddress:{
			filter:"FilledTaxFormEmailAddressWhere",
			orderBy:"FilledTaxFormEmailAddressOrderBy"
		},
		validateCreateFilledTaxFormEmailAddress:{
			data:"FilledTaxFormEmailAddressCreateInput"
		},
		validateUpdateFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			data:"FilledTaxFormEmailAddressUpdateInput"
		},
		getForm:{
			by:"FormUniqueWhere",
			filter:"FormWhere"
		},
		listForm:{
			filter:"FormWhere",
			orderBy:"FormOrderBy"
		},
		paginateForm:{
			filter:"FormWhere",
			orderBy:"FormOrderBy"
		},
		validateCreateForm:{
			data:"FormCreateInput"
		},
		validateUpdateForm:{
			by:"FormUniqueWhere",
			data:"FormUpdateInput"
		},
		getCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			filter:"CsobPaymentWhere"
		},
		listCsobPayment:{
			filter:"CsobPaymentWhere",
			orderBy:"CsobPaymentOrderBy"
		},
		paginateCsobPayment:{
			filter:"CsobPaymentWhere",
			orderBy:"CsobPaymentOrderBy"
		},
		validateCreateCsobPayment:{
			data:"CsobPaymentCreateInput"
		},
		validateUpdateCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			data:"CsobPaymentUpdateInput"
		},
		getCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			filter:"CsobPaymentStatusChangeWhere"
		},
		listCsobPaymentStatusChange:{
			filter:"CsobPaymentStatusChangeWhere",
			orderBy:"CsobPaymentStatusChangeOrderBy"
		},
		paginateCsobPaymentStatusChange:{
			filter:"CsobPaymentStatusChangeWhere",
			orderBy:"CsobPaymentStatusChangeOrderBy"
		},
		validateCreateCsobPaymentStatusChange:{
			data:"CsobPaymentStatusChangeCreateInput"
		},
		validateUpdateCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			data:"CsobPaymentStatusChangeUpdateInput"
		},
		getStripePayment:{
			by:"StripePaymentUniqueWhere",
			filter:"StripePaymentWhere"
		},
		listStripePayment:{
			filter:"StripePaymentWhere",
			orderBy:"StripePaymentOrderBy"
		},
		paginateStripePayment:{
			filter:"StripePaymentWhere",
			orderBy:"StripePaymentOrderBy"
		},
		validateCreateStripePayment:{
			data:"StripePaymentCreateInput"
		},
		validateUpdateStripePayment:{
			by:"StripePaymentUniqueWhere",
			data:"StripePaymentUpdateInput"
		},
		getStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			filter:"StripePaymentStatusChangeWhere"
		},
		listStripePaymentStatusChange:{
			filter:"StripePaymentStatusChangeWhere",
			orderBy:"StripePaymentStatusChangeOrderBy"
		},
		paginateStripePaymentStatusChange:{
			filter:"StripePaymentStatusChangeWhere",
			orderBy:"StripePaymentStatusChangeOrderBy"
		},
		validateCreateStripePaymentStatusChange:{
			data:"StripePaymentStatusChangeCreateInput"
		},
		validateUpdateStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			data:"StripePaymentStatusChangeUpdateInput"
		},
		getRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere"
		},
		listRegionPaymentMethod:{
			filter:"RegionPaymentMethodWhere",
			orderBy:"RegionPaymentMethodOrderBy"
		},
		paginateRegionPaymentMethod:{
			filter:"RegionPaymentMethodWhere",
			orderBy:"RegionPaymentMethodOrderBy"
		},
		validateCreateRegionPaymentMethod:{
			data:"RegionPaymentMethodCreateInput"
		},
		validateUpdateRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			data:"RegionPaymentMethodUpdateInput"
		},
		getPostAreaMetaData:{
			by:"PostAreaMetaDataUniqueWhere",
			filter:"PostAreaMetaDataWhere"
		},
		listPostAreaMetaData:{
			filter:"PostAreaMetaDataWhere",
			orderBy:"PostAreaMetaDataOrderBy"
		},
		paginatePostAreaMetaData:{
			filter:"PostAreaMetaDataWhere",
			orderBy:"PostAreaMetaDataOrderBy"
		},
		getPostMetaData:{
			by:"PostMetaDataUniqueWhere",
			filter:"PostMetaDataWhere"
		},
		listPostMetaData:{
			filter:"PostMetaDataWhere",
			orderBy:"PostMetaDataOrderBy"
		},
		paginatePostMetaData:{
			filter:"PostMetaDataWhere",
			orderBy:"PostMetaDataOrderBy"
		},
		getPostOrganizationMetaData:{
			by:"PostOrganizationMetaDataUniqueWhere",
			filter:"PostOrganizationMetaDataWhere"
		},
		listPostOrganizationMetaData:{
			filter:"PostOrganizationMetaDataWhere",
			orderBy:"PostOrganizationMetaDataOrderBy"
		},
		paginatePostOrganizationMetaData:{
			filter:"PostOrganizationMetaDataWhere",
			orderBy:"PostOrganizationMetaDataOrderBy"
		},
		getTileItem:{
			by:"TileItemUniqueWhere",
			filter:"TileItemWhere"
		},
		listTileItem:{
			filter:"TileItemWhere",
			orderBy:"TileItemOrderBy"
		},
		paginateTileItem:{
			filter:"TileItemWhere",
			orderBy:"TileItemOrderBy"
		},
		validateCreateTileItem:{
			data:"TileItemCreateInput"
		},
		validateUpdateTileItem:{
			by:"TileItemUniqueWhere",
			data:"TileItemUpdateInput"
		},
		getTileList:{
			by:"TileListUniqueWhere",
			filter:"TileListWhere"
		},
		listTileList:{
			filter:"TileListWhere",
			orderBy:"TileListOrderBy"
		},
		paginateTileList:{
			filter:"TileListWhere",
			orderBy:"TileListOrderBy"
		},
		validateCreateTileList:{
			data:"TileListCreateInput"
		},
		validateUpdateTileList:{
			by:"TileListUniqueWhere",
			data:"TileListUpdateInput"
		},
		getFeedPage:{
			by:"FeedPageUniqueWhere",
			filter:"FeedPageWhere"
		},
		listFeedPage:{
			filter:"FeedPageWhere",
			orderBy:"FeedPageOrderBy"
		},
		paginateFeedPage:{
			filter:"FeedPageWhere",
			orderBy:"FeedPageOrderBy"
		},
		validateCreateFeedPage:{
			data:"FeedPageCreateInput"
		},
		validateUpdateFeedPage:{
			by:"FeedPageUniqueWhere",
			data:"FeedPageUpdateInput"
		},
		getFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		listFeedPageLocale:{
			filter:"FeedPageLocaleWhere",
			orderBy:"FeedPageLocaleOrderBy"
		},
		paginateFeedPageLocale:{
			filter:"FeedPageLocaleWhere",
			orderBy:"FeedPageLocaleOrderBy"
		},
		validateCreateFeedPageLocale:{
			data:"FeedPageLocaleCreateInput"
		},
		validateUpdateFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			data:"FeedPageLocaleUpdateInput"
		},
		getFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			filter:"FeedPageSectionWhere"
		},
		listFeedPageSection:{
			filter:"FeedPageSectionWhere",
			orderBy:"FeedPageSectionOrderBy"
		},
		paginateFeedPageSection:{
			filter:"FeedPageSectionWhere",
			orderBy:"FeedPageSectionOrderBy"
		},
		validateCreateFeedPageSection:{
			data:"FeedPageSectionCreateInput"
		},
		validateUpdateFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			data:"FeedPageSectionUpdateInput"
		},
		getFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			filter:"FeedPageTileStripeWhere"
		},
		listFeedPageTileStripe:{
			filter:"FeedPageTileStripeWhere",
			orderBy:"FeedPageTileStripeOrderBy"
		},
		paginateFeedPageTileStripe:{
			filter:"FeedPageTileStripeWhere",
			orderBy:"FeedPageTileStripeOrderBy"
		},
		validateCreateFeedPageTileStripe:{
			data:"FeedPageTileStripeCreateInput"
		},
		validateUpdateFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			data:"FeedPageTileStripeUpdateInput"
		},
		getCardItem:{
			by:"CardItemUniqueWhere",
			filter:"CardItemWhere"
		},
		listCardItem:{
			filter:"CardItemWhere",
			orderBy:"CardItemOrderBy"
		},
		paginateCardItem:{
			filter:"CardItemWhere",
			orderBy:"CardItemOrderBy"
		},
		validateCreateCardItem:{
			data:"CardItemCreateInput"
		},
		validateUpdateCardItem:{
			by:"CardItemUniqueWhere",
			data:"CardItemUpdateInput"
		},
		getCardList:{
			by:"CardListUniqueWhere",
			filter:"CardListWhere"
		},
		listCardList:{
			filter:"CardListWhere",
			orderBy:"CardListOrderBy"
		},
		paginateCardList:{
			filter:"CardListWhere",
			orderBy:"CardListOrderBy"
		},
		validateCreateCardList:{
			data:"CardListCreateInput"
		},
		validateUpdateCardList:{
			by:"CardListUniqueWhere",
			data:"CardListUpdateInput"
		},
		getOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			filter:"OnBehalfDonationWhere"
		},
		listOnBehalfDonation:{
			filter:"OnBehalfDonationWhere",
			orderBy:"OnBehalfDonationOrderBy"
		},
		paginateOnBehalfDonation:{
			filter:"OnBehalfDonationWhere",
			orderBy:"OnBehalfDonationOrderBy"
		},
		validateCreateOnBehalfDonation:{
			data:"OnBehalfDonationCreateInput"
		},
		validateUpdateOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			data:"OnBehalfDonationUpdateInput"
		},
		getUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			filter:"UserPaymentTriesCollectionWhere"
		},
		listUserPaymentTriesCollection:{
			filter:"UserPaymentTriesCollectionWhere",
			orderBy:"UserPaymentTriesCollectionOrderBy"
		},
		paginateUserPaymentTriesCollection:{
			filter:"UserPaymentTriesCollectionWhere",
			orderBy:"UserPaymentTriesCollectionOrderBy"
		},
		validateCreateUserPaymentTriesCollection:{
			data:"UserPaymentTriesCollectionCreateInput"
		},
		validateUpdateUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			data:"UserPaymentTriesCollectionUpdateInput"
		},
		getRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			filter:"RecurringPaymentPageWhere"
		},
		listRecurringPaymentPage:{
			filter:"RecurringPaymentPageWhere",
			orderBy:"RecurringPaymentPageOrderBy"
		},
		paginateRecurringPaymentPage:{
			filter:"RecurringPaymentPageWhere",
			orderBy:"RecurringPaymentPageOrderBy"
		},
		validateCreateRecurringPaymentPage:{
			data:"RecurringPaymentPageCreateInput"
		},
		validateUpdateRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			data:"RecurringPaymentPageUpdateInput"
		},
		getRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		listRecurringPaymentPageLocale:{
			filter:"RecurringPaymentPageLocaleWhere",
			orderBy:"RecurringPaymentPageLocaleOrderBy"
		},
		paginateRecurringPaymentPageLocale:{
			filter:"RecurringPaymentPageLocaleWhere",
			orderBy:"RecurringPaymentPageLocaleOrderBy"
		},
		validateCreateRecurringPaymentPageLocale:{
			data:"RecurringPaymentPageLocaleCreateInput"
		},
		validateUpdateRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			data:"RecurringPaymentPageLocaleUpdateInput"
		},
		getStoryGuide:{
			by:"StoryGuideUniqueWhere",
			filter:"StoryGuideWhere"
		},
		listStoryGuide:{
			filter:"StoryGuideWhere",
			orderBy:"StoryGuideOrderBy"
		},
		paginateStoryGuide:{
			filter:"StoryGuideWhere",
			orderBy:"StoryGuideOrderBy"
		},
		validateCreateStoryGuide:{
			data:"StoryGuideCreateInput"
		},
		validateUpdateStoryGuide:{
			by:"StoryGuideUniqueWhere",
			data:"StoryGuideUpdateInput"
		},
		getStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			filter:"StoryGuideItemWhere"
		},
		listStoryGuideItem:{
			filter:"StoryGuideItemWhere",
			orderBy:"StoryGuideItemOrderBy"
		},
		paginateStoryGuideItem:{
			filter:"StoryGuideItemWhere",
			orderBy:"StoryGuideItemOrderBy"
		},
		validateCreateStoryGuideItem:{
			data:"StoryGuideItemCreateInput"
		},
		validateUpdateStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			data:"StoryGuideItemUpdateInput"
		},
		getStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			filter:"StoryGuideListWhere"
		},
		listStoryGuideList:{
			filter:"StoryGuideListWhere",
			orderBy:"StoryGuideListOrderBy"
		},
		paginateStoryGuideList:{
			filter:"StoryGuideListWhere",
			orderBy:"StoryGuideListOrderBy"
		},
		validateCreateStoryGuideList:{
			data:"StoryGuideListCreateInput"
		},
		validateUpdateStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			data:"StoryGuideListUpdateInput"
		},
		getStripePaymentMetadata:{
			by:"StripePaymentMetadataUniqueWhere",
			filter:"StripePaymentMetadataWhere"
		},
		listStripePaymentMetadata:{
			filter:"StripePaymentMetadataWhere",
			orderBy:"StripePaymentMetadataOrderBy"
		},
		paginateStripePaymentMetadata:{
			filter:"StripePaymentMetadataWhere",
			orderBy:"StripePaymentMetadataOrderBy"
		},
		getOnBehalfDonationMetadata:{
			by:"OnBehalfDonationMetadataUniqueWhere",
			filter:"OnBehalfDonationMetadataWhere"
		},
		listOnBehalfDonationMetadata:{
			filter:"OnBehalfDonationMetadataWhere",
			orderBy:"OnBehalfDonationMetadataOrderBy"
		},
		paginateOnBehalfDonationMetadata:{
			filter:"OnBehalfDonationMetadataWhere",
			orderBy:"OnBehalfDonationMetadataOrderBy"
		},
		getUserPaymentTriesCollectionMetadata:{
			by:"UserPaymentTriesCollectionMetadataUniqueWhere",
			filter:"UserPaymentTriesCollectionMetadataWhere"
		},
		listUserPaymentTriesCollectionMetadata:{
			filter:"UserPaymentTriesCollectionMetadataWhere",
			orderBy:"UserPaymentTriesCollectionMetadataOrderBy"
		},
		paginateUserPaymentTriesCollectionMetadata:{
			filter:"UserPaymentTriesCollectionMetadataWhere",
			orderBy:"UserPaymentTriesCollectionMetadataOrderBy"
		},
		getUserPaymentTriesCollectionMetadataLocale:{
			by:"UserPaymentTriesCollectionMetadataLocaleUniqueWhere",
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere"
		},
		listUserPaymentTriesCollectionMetadataLocale:{
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere",
			orderBy:"UserPaymentTriesCollectionMetadataLocaleOrderBy"
		},
		paginateUserPaymentTriesCollectionMetadataLocale:{
			filter:"UserPaymentTriesCollectionMetadataLocaleWhere",
			orderBy:"UserPaymentTriesCollectionMetadataLocaleOrderBy"
		},
		getCsobPaymentMetadata:{
			by:"CsobPaymentMetadataUniqueWhere",
			filter:"CsobPaymentMetadataWhere"
		},
		listCsobPaymentMetadata:{
			filter:"CsobPaymentMetadataWhere",
			orderBy:"CsobPaymentMetadataOrderBy"
		},
		paginateCsobPaymentMetadata:{
			filter:"CsobPaymentMetadataWhere",
			orderBy:"CsobPaymentMetadataOrderBy"
		},
		getHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			filter:"HeroCarouselWhere"
		},
		listHeroCarousel:{
			filter:"HeroCarouselWhere",
			orderBy:"HeroCarouselOrderBy"
		},
		paginateHeroCarousel:{
			filter:"HeroCarouselWhere",
			orderBy:"HeroCarouselOrderBy"
		},
		validateCreateHeroCarousel:{
			data:"HeroCarouselCreateInput"
		},
		validateUpdateHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			data:"HeroCarouselUpdateInput"
		},
		getPostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			filter:"PostOrganizationListWhere"
		},
		listPostOrganizationList:{
			filter:"PostOrganizationListWhere",
			orderBy:"PostOrganizationListOrderBy"
		},
		paginatePostOrganizationList:{
			filter:"PostOrganizationListWhere",
			orderBy:"PostOrganizationListOrderBy"
		},
		validateCreatePostOrganizationList:{
			data:"PostOrganizationListCreateInput"
		},
		validateUpdatePostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			data:"PostOrganizationListUpdateInput"
		},
		getPostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			filter:"PostOrganizationListItemWhere"
		},
		listPostOrganizationListItem:{
			filter:"PostOrganizationListItemWhere",
			orderBy:"PostOrganizationListItemOrderBy"
		},
		paginatePostOrganizationListItem:{
			filter:"PostOrganizationListItemWhere",
			orderBy:"PostOrganizationListItemOrderBy"
		},
		validateCreatePostOrganizationListItem:{
			data:"PostOrganizationListItemCreateInput"
		},
		validateUpdatePostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			data:"PostOrganizationListItemUpdateInput"
		},
		getInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			filter:"InfoCarouselWhere"
		},
		listInfoCarousel:{
			filter:"InfoCarouselWhere",
			orderBy:"InfoCarouselOrderBy"
		},
		paginateInfoCarousel:{
			filter:"InfoCarouselWhere",
			orderBy:"InfoCarouselOrderBy"
		},
		validateCreateInfoCarousel:{
			data:"InfoCarouselCreateInput"
		},
		validateUpdateInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			data:"InfoCarouselUpdateInput"
		},
		getInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			filter:"InfoCarouselItemWhere"
		},
		listInfoCarouselItem:{
			filter:"InfoCarouselItemWhere",
			orderBy:"InfoCarouselItemOrderBy"
		},
		paginateInfoCarouselItem:{
			filter:"InfoCarouselItemWhere",
			orderBy:"InfoCarouselItemOrderBy"
		},
		validateCreateInfoCarouselItem:{
			data:"InfoCarouselItemCreateInput"
		},
		validateUpdateInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			data:"InfoCarouselItemUpdateInput"
		},
		getPersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere"
		},
		listPersonSeenInfoCarousel:{
			filter:"PersonSeenInfoCarouselWhere",
			orderBy:"PersonSeenInfoCarouselOrderBy"
		},
		paginatePersonSeenInfoCarousel:{
			filter:"PersonSeenInfoCarouselWhere",
			orderBy:"PersonSeenInfoCarouselOrderBy"
		},
		validateCreatePersonSeenInfoCarousel:{
			data:"PersonSeenInfoCarouselCreateInput"
		},
		validateUpdatePersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			data:"PersonSeenInfoCarouselUpdateInput"
		},
		getGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			filter:"GivenGiftsPageWhere"
		},
		listGivenGiftsPage:{
			filter:"GivenGiftsPageWhere",
			orderBy:"GivenGiftsPageOrderBy"
		},
		paginateGivenGiftsPage:{
			filter:"GivenGiftsPageWhere",
			orderBy:"GivenGiftsPageOrderBy"
		},
		validateCreateGivenGiftsPage:{
			data:"GivenGiftsPageCreateInput"
		},
		validateUpdateGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			data:"GivenGiftsPageUpdateInput"
		},
		getGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		listGivenGiftsPageLocale:{
			filter:"GivenGiftsPageLocaleWhere",
			orderBy:"GivenGiftsPageLocaleOrderBy"
		},
		paginateGivenGiftsPageLocale:{
			filter:"GivenGiftsPageLocaleWhere",
			orderBy:"GivenGiftsPageLocaleOrderBy"
		},
		validateCreateGivenGiftsPageLocale:{
			data:"GivenGiftsPageLocaleCreateInput"
		},
		validateUpdateGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			data:"GivenGiftsPageLocaleUpdateInput"
		},
		getReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			filter:"ReceivedGiftsPageWhere"
		},
		listReceivedGiftsPage:{
			filter:"ReceivedGiftsPageWhere",
			orderBy:"ReceivedGiftsPageOrderBy"
		},
		paginateReceivedGiftsPage:{
			filter:"ReceivedGiftsPageWhere",
			orderBy:"ReceivedGiftsPageOrderBy"
		},
		validateCreateReceivedGiftsPage:{
			data:"ReceivedGiftsPageCreateInput"
		},
		validateUpdateReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			data:"ReceivedGiftsPageUpdateInput"
		},
		getReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		listReceivedGiftsPageLocale:{
			filter:"ReceivedGiftsPageLocaleWhere",
			orderBy:"ReceivedGiftsPageLocaleOrderBy"
		},
		paginateReceivedGiftsPageLocale:{
			filter:"ReceivedGiftsPageLocaleWhere",
			orderBy:"ReceivedGiftsPageLocaleOrderBy"
		},
		validateCreateReceivedGiftsPageLocale:{
			data:"ReceivedGiftsPageLocaleCreateInput"
		},
		validateUpdateReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			data:"ReceivedGiftsPageLocaleUpdateInput"
		},
		getReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			filter:"ReportNavigationWhere"
		},
		listReportNavigation:{
			filter:"ReportNavigationWhere",
			orderBy:"ReportNavigationOrderBy"
		},
		paginateReportNavigation:{
			filter:"ReportNavigationWhere",
			orderBy:"ReportNavigationOrderBy"
		},
		validateCreateReportNavigation:{
			data:"ReportNavigationCreateInput"
		},
		validateUpdateReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			data:"ReportNavigationUpdateInput"
		},
		getReportPage:{
			by:"ReportPageUniqueWhere",
			filter:"ReportPageWhere"
		},
		listReportPage:{
			filter:"ReportPageWhere",
			orderBy:"ReportPageOrderBy"
		},
		paginateReportPage:{
			filter:"ReportPageWhere",
			orderBy:"ReportPageOrderBy"
		},
		validateCreateReportPage:{
			data:"ReportPageCreateInput"
		},
		validateUpdateReportPage:{
			by:"ReportPageUniqueWhere",
			data:"ReportPageUpdateInput"
		},
		getReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		listReportPageLocale:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		paginateReportPageLocale:{
			filter:"ReportPageLocaleWhere",
			orderBy:"ReportPageLocaleOrderBy"
		},
		validateCreateReportPageLocale:{
			data:"ReportPageLocaleCreateInput"
		},
		validateUpdateReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			data:"ReportPageLocaleUpdateInput"
		},
		getReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere"
		},
		listReportNavigationLocale:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		},
		paginateReportNavigationLocale:{
			filter:"ReportNavigationLocaleWhere",
			orderBy:"ReportNavigationLocaleOrderBy"
		},
		validateCreateReportNavigationLocale:{
			data:"ReportNavigationLocaleCreateInput"
		},
		validateUpdateReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			data:"ReportNavigationLocaleUpdateInput"
		},
		getSentPayment:{
			by:"SentPaymentUniqueWhere",
			filter:"SentPaymentWhere"
		},
		listSentPayment:{
			filter:"SentPaymentWhere",
			orderBy:"SentPaymentOrderBy"
		},
		paginateSentPayment:{
			filter:"SentPaymentWhere",
			orderBy:"SentPaymentOrderBy"
		},
		validateCreateSentPayment:{
			data:"SentPaymentCreateInput"
		},
		validateUpdateSentPayment:{
			by:"SentPaymentUniqueWhere",
			data:"SentPaymentUpdateInput"
		},
		getPostAreaSentPaymentCurrencySum:{
			by:"PostAreaSentPaymentCurrencySumUniqueWhere",
			filter:"PostAreaSentPaymentCurrencySumWhere"
		},
		listPostAreaSentPaymentCurrencySum:{
			filter:"PostAreaSentPaymentCurrencySumWhere",
			orderBy:"PostAreaSentPaymentCurrencySumOrderBy"
		},
		paginatePostAreaSentPaymentCurrencySum:{
			filter:"PostAreaSentPaymentCurrencySumWhere",
			orderBy:"PostAreaSentPaymentCurrencySumOrderBy"
		},
		getPostAreaSentPaymentSum:{
			by:"PostAreaSentPaymentSumUniqueWhere",
			filter:"PostAreaSentPaymentSumWhere"
		},
		listPostAreaSentPaymentSum:{
			filter:"PostAreaSentPaymentSumWhere",
			orderBy:"PostAreaSentPaymentSumOrderBy"
		},
		paginatePostAreaSentPaymentSum:{
			filter:"PostAreaSentPaymentSumWhere",
			orderBy:"PostAreaSentPaymentSumOrderBy"
		},
		getNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			filter:"NotificationTargetGroupWhere"
		},
		listNotificationTargetGroup:{
			filter:"NotificationTargetGroupWhere",
			orderBy:"NotificationTargetGroupOrderBy"
		},
		paginateNotificationTargetGroup:{
			filter:"NotificationTargetGroupWhere",
			orderBy:"NotificationTargetGroupOrderBy"
		},
		validateCreateNotificationTargetGroup:{
			data:"NotificationTargetGroupCreateInput"
		},
		validateUpdateNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			data:"NotificationTargetGroupUpdateInput"
		},
		getProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationWhere"
		},
		listProcessedNotification:{
			filter:"ProcessedNotificationWhere",
			orderBy:"ProcessedNotificationOrderBy"
		},
		paginateProcessedNotification:{
			filter:"ProcessedNotificationWhere",
			orderBy:"ProcessedNotificationOrderBy"
		},
		validateCreateProcessedNotification:{
			data:"ProcessedNotificationCreateInput"
		},
		validateUpdateProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			data:"ProcessedNotificationUpdateInput"
		},
		getScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			filter:"ScheduledNotificationWhere"
		},
		listScheduledNotification:{
			filter:"ScheduledNotificationWhere",
			orderBy:"ScheduledNotificationOrderBy"
		},
		paginateScheduledNotification:{
			filter:"ScheduledNotificationWhere",
			orderBy:"ScheduledNotificationOrderBy"
		},
		validateCreateScheduledNotification:{
			data:"ScheduledNotificationCreateInput"
		},
		validateUpdateScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			data:"ScheduledNotificationUpdateInput"
		},
		getProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			filter:"ProcessedNotificationSourceWhere"
		},
		listProcessedNotificationSource:{
			filter:"ProcessedNotificationSourceWhere",
			orderBy:"ProcessedNotificationSourceOrderBy"
		},
		paginateProcessedNotificationSource:{
			filter:"ProcessedNotificationSourceWhere",
			orderBy:"ProcessedNotificationSourceOrderBy"
		},
		validateCreateProcessedNotificationSource:{
			data:"ProcessedNotificationSourceCreateInput"
		},
		validateUpdateProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			data:"ProcessedNotificationSourceUpdateInput"
		},
		getDevice:{
			by:"DeviceUniqueWhere",
			filter:"DeviceWhere"
		},
		listDevice:{
			filter:"DeviceWhere",
			orderBy:"DeviceOrderBy"
		},
		paginateDevice:{
			filter:"DeviceWhere",
			orderBy:"DeviceOrderBy"
		},
		validateCreateDevice:{
			data:"DeviceCreateInput"
		},
		validateUpdateDevice:{
			by:"DeviceUniqueWhere",
			data:"DeviceUpdateInput"
		},
		getScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere"
		},
		listScheduledNotificationLocale:{
			filter:"ScheduledNotificationLocaleWhere",
			orderBy:"ScheduledNotificationLocaleOrderBy"
		},
		paginateScheduledNotificationLocale:{
			filter:"ScheduledNotificationLocaleWhere",
			orderBy:"ScheduledNotificationLocaleOrderBy"
		},
		validateCreateScheduledNotificationLocale:{
			data:"ScheduledNotificationLocaleCreateInput"
		},
		validateUpdateScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			data:"ScheduledNotificationLocaleUpdateInput"
		},
		getInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere"
		},
		listInfoCarouselItemLocale:{
			filter:"InfoCarouselItemLocaleWhere",
			orderBy:"InfoCarouselItemLocaleOrderBy"
		},
		paginateInfoCarouselItemLocale:{
			filter:"InfoCarouselItemLocaleWhere",
			orderBy:"InfoCarouselItemLocaleOrderBy"
		},
		validateCreateInfoCarouselItemLocale:{
			data:"InfoCarouselItemLocaleCreateInput"
		},
		validateUpdateInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			data:"InfoCarouselItemLocaleUpdateInput"
		},
		getSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere"
		},
		listSentPaymentLocale:{
			filter:"SentPaymentLocaleWhere",
			orderBy:"SentPaymentLocaleOrderBy"
		},
		paginateSentPaymentLocale:{
			filter:"SentPaymentLocaleWhere",
			orderBy:"SentPaymentLocaleOrderBy"
		},
		validateCreateSentPaymentLocale:{
			data:"SentPaymentLocaleCreateInput"
		},
		validateUpdateSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			data:"SentPaymentLocaleUpdateInput"
		},
		getUserPaymentMetadata:{
			by:"UserPaymentMetadataUniqueWhere",
			filter:"UserPaymentMetadataWhere"
		},
		listUserPaymentMetadata:{
			filter:"UserPaymentMetadataWhere",
			orderBy:"UserPaymentMetadataOrderBy"
		},
		paginateUserPaymentMetadata:{
			filter:"UserPaymentMetadataWhere",
			orderBy:"UserPaymentMetadataOrderBy"
		},
		getPostAreaCurrencySum:{
			by:"PostAreaCurrencySumUniqueWhere",
			filter:"PostAreaCurrencySumWhere"
		},
		listPostAreaCurrencySum:{
			filter:"PostAreaCurrencySumWhere",
			orderBy:"PostAreaCurrencySumOrderBy"
		},
		paginatePostAreaCurrencySum:{
			filter:"PostAreaCurrencySumWhere",
			orderBy:"PostAreaCurrencySumOrderBy"
		},
		getPostAreaSum:{
			by:"PostAreaSumUniqueWhere",
			filter:"PostAreaSumWhere"
		},
		listPostAreaSum:{
			filter:"PostAreaSumWhere",
			orderBy:"PostAreaSumOrderBy"
		},
		paginatePostAreaSum:{
			filter:"PostAreaSumWhere",
			orderBy:"PostAreaSumOrderBy"
		},
		getPostOrganizationCurrencySum:{
			by:"PostOrganizationCurrencySumUniqueWhere",
			filter:"PostOrganizationCurrencySumWhere"
		},
		listPostOrganizationCurrencySum:{
			filter:"PostOrganizationCurrencySumWhere",
			orderBy:"PostOrganizationCurrencySumOrderBy"
		},
		paginatePostOrganizationCurrencySum:{
			filter:"PostOrganizationCurrencySumWhere",
			orderBy:"PostOrganizationCurrencySumOrderBy"
		},
		getPostOrganizationSum:{
			by:"PostOrganizationSumUniqueWhere",
			filter:"PostOrganizationSumWhere"
		},
		listPostOrganizationSum:{
			filter:"PostOrganizationSumWhere",
			orderBy:"PostOrganizationSumOrderBy"
		},
		paginatePostOrganizationSum:{
			filter:"PostOrganizationSumWhere",
			orderBy:"PostOrganizationSumOrderBy"
		},
		getStats:{
			by:"StatsUniqueWhere",
			filter:"StatsWhere"
		},
		listStats:{
			filter:"StatsWhere",
			orderBy:"StatsOrderBy"
		},
		paginateStats:{
			filter:"StatsWhere",
			orderBy:"StatsOrderBy"
		},
		getUserRecurringPaymentItemMetadata:{
			by:"UserRecurringPaymentItemMetadataUniqueWhere",
			filter:"UserRecurringPaymentItemMetadataWhere"
		},
		listUserRecurringPaymentItemMetadata:{
			filter:"UserRecurringPaymentItemMetadataWhere",
			orderBy:"UserRecurringPaymentItemMetadataOrderBy"
		},
		paginateUserRecurringPaymentItemMetadata:{
			filter:"UserRecurringPaymentItemMetadataWhere",
			orderBy:"UserRecurringPaymentItemMetadataOrderBy"
		},
		getUpcomingUserRecurringPaymentMetadata:{
			by:"UpcomingUserRecurringPaymentMetadataUniqueWhere",
			filter:"UpcomingUserRecurringPaymentMetadataWhere"
		},
		listUpcomingUserRecurringPaymentMetadata:{
			filter:"UpcomingUserRecurringPaymentMetadataWhere",
			orderBy:"UpcomingUserRecurringPaymentMetadataOrderBy"
		},
		paginateUpcomingUserRecurringPaymentMetadata:{
			filter:"UpcomingUserRecurringPaymentMetadataWhere",
			orderBy:"UpcomingUserRecurringPaymentMetadataOrderBy"
		},
		getUserAreaStats:{
			by:"UserAreaStatsUniqueWhere",
			filter:"UserAreaStatsWhere"
		},
		listUserAreaStats:{
			filter:"UserAreaStatsWhere",
			orderBy:"UserAreaStatsOrderBy"
		},
		paginateUserAreaStats:{
			filter:"UserAreaStatsWhere",
			orderBy:"UserAreaStatsOrderBy"
		},
		getUserCurrencyStats:{
			by:"UserCurrencyStatsUniqueWhere",
			filter:"UserCurrencyStatsWhere"
		},
		listUserCurrencyStats:{
			filter:"UserCurrencyStatsWhere",
			orderBy:"UserCurrencyStatsOrderBy"
		},
		paginateUserCurrencyStats:{
			filter:"UserCurrencyStatsWhere",
			orderBy:"UserCurrencyStatsOrderBy"
		},
		getUserOrganizationStats:{
			by:"UserOrganizationStatsUniqueWhere",
			filter:"UserOrganizationStatsWhere"
		},
		listUserOrganizationStats:{
			filter:"UserOrganizationStatsWhere",
			orderBy:"UserOrganizationStatsOrderBy"
		},
		paginateUserOrganizationStats:{
			filter:"UserOrganizationStatsWhere",
			orderBy:"UserOrganizationStatsOrderBy"
		},
		getUserPostStats:{
			by:"UserPostStatsUniqueWhere",
			filter:"UserPostStatsWhere"
		},
		listUserPostStats:{
			filter:"UserPostStatsWhere",
			orderBy:"UserPostStatsOrderBy"
		},
		paginateUserPostStats:{
			filter:"UserPostStatsWhere",
			orderBy:"UserPostStatsOrderBy"
		},
		getUserStats:{
			by:"UserStatsUniqueWhere",
			filter:"UserStatsWhere"
		},
		listUserStats:{
			filter:"UserStatsWhere",
			orderBy:"UserStatsOrderBy"
		},
		paginateUserStats:{
			filter:"UserStatsWhere",
			orderBy:"UserStatsOrderBy"
		},
		getTextImageList:{
			by:"TextImageListUniqueWhere",
			filter:"TextImageListWhere"
		},
		listTextImageList:{
			filter:"TextImageListWhere",
			orderBy:"TextImageListOrderBy"
		},
		paginateTextImageList:{
			filter:"TextImageListWhere",
			orderBy:"TextImageListOrderBy"
		},
		validateCreateTextImageList:{
			data:"TextImageListCreateInput"
		},
		validateUpdateTextImageList:{
			by:"TextImageListUniqueWhere",
			data:"TextImageListUpdateInput"
		},
		getTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			filter:"TextImageListItemWhere"
		},
		listTextImageListItem:{
			filter:"TextImageListItemWhere",
			orderBy:"TextImageListItemOrderBy"
		},
		paginateTextImageListItem:{
			filter:"TextImageListItemWhere",
			orderBy:"TextImageListItemOrderBy"
		},
		validateCreateTextImageListItem:{
			data:"TextImageListItemCreateInput"
		},
		validateUpdateTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			data:"TextImageListItemUpdateInput"
		},
		getPostCurrencySum:{
			by:"PostCurrencySumUniqueWhere",
			filter:"PostCurrencySumWhere"
		},
		listPostCurrencySum:{
			filter:"PostCurrencySumWhere",
			orderBy:"PostCurrencySumOrderBy"
		},
		paginatePostCurrencySum:{
			filter:"PostCurrencySumWhere",
			orderBy:"PostCurrencySumOrderBy"
		},
		getPostSum:{
			by:"PostSumUniqueWhere",
			filter:"PostSumWhere"
		},
		listPostSum:{
			filter:"PostSumWhere",
			orderBy:"PostSumOrderBy"
		},
		paginatePostSum:{
			filter:"PostSumWhere",
			orderBy:"PostSumOrderBy"
		},
		getPostFundraisingProgress:{
			by:"PostFundraisingProgressUniqueWhere",
			filter:"PostFundraisingProgressWhere"
		},
		listPostFundraisingProgress:{
			filter:"PostFundraisingProgressWhere",
			orderBy:"PostFundraisingProgressOrderBy"
		},
		paginatePostFundraisingProgress:{
			filter:"PostFundraisingProgressWhere",
			orderBy:"PostFundraisingProgressOrderBy"
		},
		getHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			filter:"HeroCarouselItemWhere"
		},
		listHeroCarouselItem:{
			filter:"HeroCarouselItemWhere",
			orderBy:"HeroCarouselItemOrderBy"
		},
		paginateHeroCarouselItem:{
			filter:"HeroCarouselItemWhere",
			orderBy:"HeroCarouselItemOrderBy"
		},
		validateCreateHeroCarouselItem:{
			data:"HeroCarouselItemCreateInput"
		},
		validateUpdateHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			data:"HeroCarouselItemUpdateInput"
		}
	},
	Mutation:{
		generateUploadUrl:{
			input:"S3GenerateSignedUploadInput"
		},
		generateReadUrl:{

		},
		createGeneral:{
			data:"GeneralCreateInput"
		},
		deleteGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere"
		},
		updateGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere",
			data:"GeneralUpdateInput"
		},
		upsertGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere",
			update:"GeneralUpdateInput",
			create:"GeneralCreateInput"
		},
		createImage:{
			data:"ImageCreateInput"
		},
		deleteImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		updateImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			data:"ImageUpdateInput"
		},
		upsertImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			update:"ImageUpdateInput",
			create:"ImageCreateInput"
		},
		createGenericPage:{
			data:"GenericPageCreateInput"
		},
		deleteGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere"
		},
		updateGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere",
			data:"GenericPageUpdateInput"
		},
		upsertGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere",
			update:"GenericPageUpdateInput",
			create:"GenericPageCreateInput"
		},
		createLinkable:{
			data:"LinkableCreateInput"
		},
		deleteLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		updateLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			data:"LinkableUpdateInput"
		},
		upsertLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			update:"LinkableUpdateInput",
			create:"LinkableCreateInput"
		},
		createSeo:{
			data:"SeoCreateInput"
		},
		deleteSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		updateSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			data:"SeoUpdateInput"
		},
		upsertSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			update:"SeoUpdateInput",
			create:"SeoCreateInput"
		},
		createContent:{
			data:"ContentCreateInput"
		},
		deleteContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		updateContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			data:"ContentUpdateInput"
		},
		upsertContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			update:"ContentUpdateInput",
			create:"ContentCreateInput"
		},
		createContentBlock:{
			data:"ContentBlockCreateInput"
		},
		deleteContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		updateContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			data:"ContentBlockUpdateInput"
		},
		upsertContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			update:"ContentBlockUpdateInput",
			create:"ContentBlockCreateInput"
		},
		createContentReference:{
			data:"ContentReferenceCreateInput"
		},
		deleteContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		updateContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			data:"ContentReferenceUpdateInput"
		},
		upsertContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			update:"ContentReferenceUpdateInput",
			create:"ContentReferenceCreateInput"
		},
		createGeneralLocale:{
			data:"GeneralLocaleCreateInput"
		},
		deleteGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		updateGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere",
			data:"GeneralLocaleUpdateInput"
		},
		upsertGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere",
			update:"GeneralLocaleUpdateInput",
			create:"GeneralLocaleCreateInput"
		},
		createGenericPageLocale:{
			data:"GenericPageLocaleCreateInput"
		},
		deleteGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		updateGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere",
			data:"GenericPageLocaleUpdateInput"
		},
		upsertGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere",
			update:"GenericPageLocaleUpdateInput",
			create:"GenericPageLocaleCreateInput"
		},
		createLocale:{
			data:"LocaleCreateInput"
		},
		deleteLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		updateLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			data:"LocaleUpdateInput"
		},
		upsertLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			update:"LocaleUpdateInput",
			create:"LocaleCreateInput"
		},
		createVideo:{
			data:"VideoCreateInput"
		},
		deleteVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		updateVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			data:"VideoUpdateInput"
		},
		upsertVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			update:"VideoUpdateInput",
			create:"VideoCreateInput"
		},
		createLink:{
			data:"LinkCreateInput"
		},
		deleteLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		updateLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			data:"LinkUpdateInput"
		},
		upsertLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			update:"LinkUpdateInput",
			create:"LinkCreateInput"
		},
		createPost:{
			data:"PostCreateInput"
		},
		deletePost:{
			by:"PostUniqueWhere",
			filter:"PostWhere"
		},
		updatePost:{
			by:"PostUniqueWhere",
			filter:"PostWhere",
			data:"PostUpdateInput"
		},
		upsertPost:{
			by:"PostUniqueWhere",
			filter:"PostWhere",
			update:"PostUpdateInput",
			create:"PostCreateInput"
		},
		createPostLocale:{
			data:"PostLocaleCreateInput"
		},
		deletePostLocale:{
			by:"PostLocaleUniqueWhere",
			filter:"PostLocaleWhere"
		},
		updatePostLocale:{
			by:"PostLocaleUniqueWhere",
			filter:"PostLocaleWhere",
			data:"PostLocaleUpdateInput"
		},
		upsertPostLocale:{
			by:"PostLocaleUniqueWhere",
			filter:"PostLocaleWhere",
			update:"PostLocaleUpdateInput",
			create:"PostLocaleCreateInput"
		},
		createPostArea:{
			data:"PostAreaCreateInput"
		},
		deletePostArea:{
			by:"PostAreaUniqueWhere",
			filter:"PostAreaWhere"
		},
		updatePostArea:{
			by:"PostAreaUniqueWhere",
			filter:"PostAreaWhere",
			data:"PostAreaUpdateInput"
		},
		upsertPostArea:{
			by:"PostAreaUniqueWhere",
			filter:"PostAreaWhere",
			update:"PostAreaUpdateInput",
			create:"PostAreaCreateInput"
		},
		createPostAreaLocale:{
			data:"PostAreaLocaleCreateInput"
		},
		deletePostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		updatePostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere",
			data:"PostAreaLocaleUpdateInput"
		},
		upsertPostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere",
			update:"PostAreaLocaleUpdateInput",
			create:"PostAreaLocaleCreateInput"
		},
		createPostOrganization:{
			data:"PostOrganizationCreateInput"
		},
		deletePostOrganization:{
			by:"PostOrganizationUniqueWhere",
			filter:"PostOrganizationWhere"
		},
		updatePostOrganization:{
			by:"PostOrganizationUniqueWhere",
			filter:"PostOrganizationWhere",
			data:"PostOrganizationUpdateInput"
		},
		upsertPostOrganization:{
			by:"PostOrganizationUniqueWhere",
			filter:"PostOrganizationWhere",
			update:"PostOrganizationUpdateInput",
			create:"PostOrganizationCreateInput"
		},
		createPostOrganizationLocale:{
			data:"PostOrganizationLocaleCreateInput"
		},
		deletePostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		updatePostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere",
			data:"PostOrganizationLocaleUpdateInput"
		},
		upsertPostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere",
			update:"PostOrganizationLocaleUpdateInput",
			create:"PostOrganizationLocaleCreateInput"
		},
		createDonation:{
			data:"DonationCreateInput"
		},
		deleteDonation:{
			by:"DonationUniqueWhere",
			filter:"DonationWhere"
		},
		updateDonation:{
			by:"DonationUniqueWhere",
			filter:"DonationWhere",
			data:"DonationUpdateInput"
		},
		upsertDonation:{
			by:"DonationUniqueWhere",
			filter:"DonationWhere",
			update:"DonationUpdateInput",
			create:"DonationCreateInput"
		},
		createDonationAmountItem:{
			data:"DonationAmountItemCreateInput"
		},
		deleteDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			filter:"DonationAmountItemWhere"
		},
		updateDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			filter:"DonationAmountItemWhere",
			data:"DonationAmountItemUpdateInput"
		},
		upsertDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			filter:"DonationAmountItemWhere",
			update:"DonationAmountItemUpdateInput",
			create:"DonationAmountItemCreateInput"
		},
		createDonationAmountsRegionItem:{
			data:"DonationAmountsRegionItemCreateInput"
		},
		deleteDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			filter:"DonationAmountsRegionItemWhere"
		},
		updateDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			filter:"DonationAmountsRegionItemWhere",
			data:"DonationAmountsRegionItemUpdateInput"
		},
		upsertDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			filter:"DonationAmountsRegionItemWhere",
			update:"DonationAmountsRegionItemUpdateInput",
			create:"DonationAmountsRegionItemCreateInput"
		},
		createDonationAmountsRegionList:{
			data:"DonationAmountsRegionListCreateInput"
		},
		deleteDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			filter:"DonationAmountsRegionListWhere"
		},
		updateDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			filter:"DonationAmountsRegionListWhere",
			data:"DonationAmountsRegionListUpdateInput"
		},
		upsertDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			filter:"DonationAmountsRegionListWhere",
			update:"DonationAmountsRegionListUpdateInput",
			create:"DonationAmountsRegionListCreateInput"
		},
		createRegion:{
			data:"RegionCreateInput"
		},
		deleteRegion:{
			by:"RegionUniqueWhere",
			filter:"RegionWhere"
		},
		updateRegion:{
			by:"RegionUniqueWhere",
			filter:"RegionWhere",
			data:"RegionUpdateInput"
		},
		upsertRegion:{
			by:"RegionUniqueWhere",
			filter:"RegionWhere",
			update:"RegionUpdateInput",
			create:"RegionCreateInput"
		},
		createLinkItem:{
			data:"LinkItemCreateInput"
		},
		deleteLinkItem:{
			by:"LinkItemUniqueWhere",
			filter:"LinkItemWhere"
		},
		updateLinkItem:{
			by:"LinkItemUniqueWhere",
			filter:"LinkItemWhere",
			data:"LinkItemUpdateInput"
		},
		upsertLinkItem:{
			by:"LinkItemUniqueWhere",
			filter:"LinkItemWhere",
			update:"LinkItemUpdateInput",
			create:"LinkItemCreateInput"
		},
		createLinkList:{
			data:"LinkListCreateInput"
		},
		deleteLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere"
		},
		updateLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere",
			data:"LinkListUpdateInput"
		},
		upsertLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere",
			update:"LinkListUpdateInput",
			create:"LinkListCreateInput"
		},
		createHeader:{
			data:"HeaderCreateInput"
		},
		deleteHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere"
		},
		updateHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere",
			data:"HeaderUpdateInput"
		},
		upsertHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere",
			update:"HeaderUpdateInput",
			create:"HeaderCreateInput"
		},
		createHeaderLocale:{
			data:"HeaderLocaleCreateInput"
		},
		deleteHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		updateHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere",
			data:"HeaderLocaleUpdateInput"
		},
		upsertHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere",
			update:"HeaderLocaleUpdateInput",
			create:"HeaderLocaleCreateInput"
		},
		createFooter:{
			data:"FooterCreateInput"
		},
		deleteFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere"
		},
		updateFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere",
			data:"FooterUpdateInput"
		},
		upsertFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere",
			update:"FooterUpdateInput",
			create:"FooterCreateInput"
		},
		createFooterLocale:{
			data:"FooterLocaleCreateInput"
		},
		deleteFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		updateFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere",
			data:"FooterLocaleUpdateInput"
		},
		upsertFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere",
			update:"FooterLocaleUpdateInput",
			create:"FooterLocaleCreateInput"
		},
		createPostList:{
			data:"PostListCreateInput"
		},
		deletePostList:{
			by:"PostListUniqueWhere",
			filter:"PostListWhere"
		},
		updatePostList:{
			by:"PostListUniqueWhere",
			filter:"PostListWhere",
			data:"PostListUpdateInput"
		},
		upsertPostList:{
			by:"PostListUniqueWhere",
			filter:"PostListWhere",
			update:"PostListUpdateInput",
			create:"PostListCreateInput"
		},
		createPostListItem:{
			data:"PostListItemCreateInput"
		},
		deletePostListItem:{
			by:"PostListItemUniqueWhere",
			filter:"PostListItemWhere"
		},
		updatePostListItem:{
			by:"PostListItemUniqueWhere",
			filter:"PostListItemWhere",
			data:"PostListItemUpdateInput"
		},
		upsertPostListItem:{
			by:"PostListItemUniqueWhere",
			filter:"PostListItemWhere",
			update:"PostListItemUpdateInput",
			create:"PostListItemCreateInput"
		},
		createAppBanner:{
			data:"AppBannerCreateInput"
		},
		deleteAppBanner:{
			by:"AppBannerUniqueWhere",
			filter:"AppBannerWhere"
		},
		updateAppBanner:{
			by:"AppBannerUniqueWhere",
			filter:"AppBannerWhere",
			data:"AppBannerUpdateInput"
		},
		upsertAppBanner:{
			by:"AppBannerUniqueWhere",
			filter:"AppBannerWhere",
			update:"AppBannerUpdateInput",
			create:"AppBannerCreateInput"
		},
		createGenericPageAboutSettings:{
			data:"GenericPageAboutSettingsCreateInput"
		},
		deleteGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			filter:"GenericPageAboutSettingsWhere"
		},
		updateGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			filter:"GenericPageAboutSettingsWhere",
			data:"GenericPageAboutSettingsUpdateInput"
		},
		upsertGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			filter:"GenericPageAboutSettingsWhere",
			update:"GenericPageAboutSettingsUpdateInput",
			create:"GenericPageAboutSettingsCreateInput"
		},
		createGenericPageAboutSettingsLocale:{
			data:"GenericPageAboutSettingsLocaleCreateInput"
		},
		deleteGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		updateGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere",
			data:"GenericPageAboutSettingsLocaleUpdateInput"
		},
		upsertGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere",
			update:"GenericPageAboutSettingsLocaleUpdateInput",
			create:"GenericPageAboutSettingsLocaleCreateInput"
		},
		createValue:{
			data:"ValueCreateInput"
		},
		deleteValue:{
			by:"ValueUniqueWhere",
			filter:"ValueWhere"
		},
		updateValue:{
			by:"ValueUniqueWhere",
			filter:"ValueWhere",
			data:"ValueUpdateInput"
		},
		upsertValue:{
			by:"ValueUniqueWhere",
			filter:"ValueWhere",
			update:"ValueUpdateInput",
			create:"ValueCreateInput"
		},
		createValueItem:{
			data:"ValueItemCreateInput"
		},
		deleteValueItem:{
			by:"ValueItemUniqueWhere",
			filter:"ValueItemWhere"
		},
		updateValueItem:{
			by:"ValueItemUniqueWhere",
			filter:"ValueItemWhere",
			data:"ValueItemUpdateInput"
		},
		upsertValueItem:{
			by:"ValueItemUniqueWhere",
			filter:"ValueItemWhere",
			update:"ValueItemUpdateInput",
			create:"ValueItemCreateInput"
		},
		createValueList:{
			data:"ValueListCreateInput"
		},
		deleteValueList:{
			by:"ValueListUniqueWhere",
			filter:"ValueListWhere"
		},
		updateValueList:{
			by:"ValueListUniqueWhere",
			filter:"ValueListWhere",
			data:"ValueListUpdateInput"
		},
		upsertValueList:{
			by:"ValueListUniqueWhere",
			filter:"ValueListWhere",
			update:"ValueListUpdateInput",
			create:"ValueListCreateInput"
		},
		createImageLink:{
			data:"ImageLinkCreateInput"
		},
		deleteImageLink:{
			by:"ImageLinkUniqueWhere",
			filter:"ImageLinkWhere"
		},
		updateImageLink:{
			by:"ImageLinkUniqueWhere",
			filter:"ImageLinkWhere",
			data:"ImageLinkUpdateInput"
		},
		upsertImageLink:{
			by:"ImageLinkUniqueWhere",
			filter:"ImageLinkWhere",
			update:"ImageLinkUpdateInput",
			create:"ImageLinkCreateInput"
		},
		createImageLinkItem:{
			data:"ImageLinkItemCreateInput"
		},
		deleteImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			filter:"ImageLinkItemWhere"
		},
		updateImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			filter:"ImageLinkItemWhere",
			data:"ImageLinkItemUpdateInput"
		},
		upsertImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			filter:"ImageLinkItemWhere",
			update:"ImageLinkItemUpdateInput",
			create:"ImageLinkItemCreateInput"
		},
		createImageLinkList:{
			data:"ImageLinkListCreateInput"
		},
		deleteImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			filter:"ImageLinkListWhere"
		},
		updateImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			filter:"ImageLinkListWhere",
			data:"ImageLinkListUpdateInput"
		},
		upsertImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			filter:"ImageLinkListWhere",
			update:"ImageLinkListUpdateInput",
			create:"ImageLinkListCreateInput"
		},
		createPostAreaList:{
			data:"PostAreaListCreateInput"
		},
		deletePostAreaList:{
			by:"PostAreaListUniqueWhere",
			filter:"PostAreaListWhere"
		},
		updatePostAreaList:{
			by:"PostAreaListUniqueWhere",
			filter:"PostAreaListWhere",
			data:"PostAreaListUpdateInput"
		},
		upsertPostAreaList:{
			by:"PostAreaListUniqueWhere",
			filter:"PostAreaListWhere",
			update:"PostAreaListUpdateInput",
			create:"PostAreaListCreateInput"
		},
		createPostAreaListItem:{
			data:"PostAreaListItemCreateInput"
		},
		deletePostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			filter:"PostAreaListItemWhere"
		},
		updatePostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			filter:"PostAreaListItemWhere",
			data:"PostAreaListItemUpdateInput"
		},
		upsertPostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			filter:"PostAreaListItemWhere",
			update:"PostAreaListItemUpdateInput",
			create:"PostAreaListItemCreateInput"
		},
		createAccordion:{
			data:"AccordionCreateInput"
		},
		deleteAccordion:{
			by:"AccordionUniqueWhere",
			filter:"AccordionWhere"
		},
		updateAccordion:{
			by:"AccordionUniqueWhere",
			filter:"AccordionWhere",
			data:"AccordionUpdateInput"
		},
		upsertAccordion:{
			by:"AccordionUniqueWhere",
			filter:"AccordionWhere",
			update:"AccordionUpdateInput",
			create:"AccordionCreateInput"
		},
		createAccordionItem:{
			data:"AccordionItemCreateInput"
		},
		deleteAccordionItem:{
			by:"AccordionItemUniqueWhere",
			filter:"AccordionItemWhere"
		},
		updateAccordionItem:{
			by:"AccordionItemUniqueWhere",
			filter:"AccordionItemWhere",
			data:"AccordionItemUpdateInput"
		},
		upsertAccordionItem:{
			by:"AccordionItemUniqueWhere",
			filter:"AccordionItemWhere",
			update:"AccordionItemUpdateInput",
			create:"AccordionItemCreateInput"
		},
		createUser:{
			data:"UserCreateInput"
		},
		deleteUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere"
		},
		updateUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere",
			data:"UserUpdateInput"
		},
		upsertUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere",
			update:"UserUpdateInput",
			create:"UserCreateInput"
		},
		createUserPayment:{
			data:"UserPaymentCreateInput"
		},
		deleteUserPayment:{
			by:"UserPaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		updateUserPayment:{
			by:"UserPaymentUniqueWhere",
			filter:"UserPaymentWhere",
			data:"UserPaymentUpdateInput"
		},
		upsertUserPayment:{
			by:"UserPaymentUniqueWhere",
			filter:"UserPaymentWhere",
			update:"UserPaymentUpdateInput",
			create:"UserPaymentCreateInput"
		},
		createCurrency:{
			data:"CurrencyCreateInput"
		},
		deleteCurrency:{
			by:"CurrencyUniqueWhere",
			filter:"CurrencyWhere"
		},
		updateCurrency:{
			by:"CurrencyUniqueWhere",
			filter:"CurrencyWhere",
			data:"CurrencyUpdateInput"
		},
		upsertCurrency:{
			by:"CurrencyUniqueWhere",
			filter:"CurrencyWhere",
			update:"CurrencyUpdateInput",
			create:"CurrencyCreateInput"
		},
		createMedium:{
			data:"MediumCreateInput"
		},
		deleteMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		updateMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			data:"MediumUpdateInput"
		},
		upsertMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			update:"MediumUpdateInput",
			create:"MediumCreateInput"
		},
		createMediumItem:{
			data:"MediumItemCreateInput"
		},
		deleteMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere"
		},
		updateMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere",
			data:"MediumItemUpdateInput"
		},
		upsertMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere",
			update:"MediumItemUpdateInput",
			create:"MediumItemCreateInput"
		},
		createMediumList:{
			data:"MediumListCreateInput"
		},
		deleteMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere"
		},
		updateMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere",
			data:"MediumListUpdateInput"
		},
		upsertMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere",
			update:"MediumListUpdateInput",
			create:"MediumListCreateInput"
		},
		createUserPaymentOrderId:{
			data:"UserPaymentOrderIdCreateInput"
		},
		deleteUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			filter:"UserPaymentOrderIdWhere"
		},
		updateUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			filter:"UserPaymentOrderIdWhere",
			data:"UserPaymentOrderIdUpdateInput"
		},
		upsertUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			filter:"UserPaymentOrderIdWhere",
			update:"UserPaymentOrderIdUpdateInput",
			create:"UserPaymentOrderIdCreateInput"
		},
		createPostRevision:{
			data:"PostRevisionCreateInput"
		},
		deletePostRevision:{
			by:"PostRevisionUniqueWhere",
			filter:"PostRevisionWhere"
		},
		updatePostRevision:{
			by:"PostRevisionUniqueWhere",
			filter:"PostRevisionWhere",
			data:"PostRevisionUpdateInput"
		},
		upsertPostRevision:{
			by:"PostRevisionUniqueWhere",
			filter:"PostRevisionWhere",
			update:"PostRevisionUpdateInput",
			create:"PostRevisionCreateInput"
		},
		createUserRecurringPayment:{
			data:"UserRecurringPaymentCreateInput"
		},
		deleteUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			filter:"UserRecurringPaymentWhere"
		},
		updateUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			filter:"UserRecurringPaymentWhere",
			data:"UserRecurringPaymentUpdateInput"
		},
		upsertUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			filter:"UserRecurringPaymentWhere",
			update:"UserRecurringPaymentUpdateInput",
			create:"UserRecurringPaymentCreateInput"
		},
		createUserRecurringPaymentItem:{
			data:"UserRecurringPaymentItemCreateInput"
		},
		deleteUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			filter:"UserRecurringPaymentItemWhere"
		},
		updateUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			filter:"UserRecurringPaymentItemWhere",
			data:"UserRecurringPaymentItemUpdateInput"
		},
		upsertUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			filter:"UserRecurringPaymentItemWhere",
			update:"UserRecurringPaymentItemUpdateInput",
			create:"UserRecurringPaymentItemCreateInput"
		},
		createPostRevisionLocale:{
			data:"PostRevisionLocaleCreateInput"
		},
		deletePostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		updatePostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere",
			data:"PostRevisionLocaleUpdateInput"
		},
		upsertPostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere",
			update:"PostRevisionLocaleUpdateInput",
			create:"PostRevisionLocaleCreateInput"
		},
		createTranslationCatalogue:{
			data:"TranslationCatalogueCreateInput"
		},
		deleteTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		updateTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere",
			data:"TranslationCatalogueUpdateInput"
		},
		upsertTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere",
			update:"TranslationCatalogueUpdateInput",
			create:"TranslationCatalogueCreateInput"
		},
		createTranslationCataloguesIdentifier:{
			data:"TranslationCataloguesIdentifierCreateInput"
		},
		deleteTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere"
		},
		updateTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere",
			data:"TranslationCataloguesIdentifierUpdateInput"
		},
		upsertTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere",
			update:"TranslationCataloguesIdentifierUpdateInput",
			create:"TranslationCataloguesIdentifierCreateInput"
		},
		createTranslationDomain:{
			data:"TranslationDomainCreateInput"
		},
		deleteTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere"
		},
		updateTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere",
			data:"TranslationDomainUpdateInput"
		},
		upsertTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere",
			update:"TranslationDomainUpdateInput",
			create:"TranslationDomainCreateInput"
		},
		createTranslationKey:{
			data:"TranslationKeyCreateInput"
		},
		deleteTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		updateTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere",
			data:"TranslationKeyUpdateInput"
		},
		upsertTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere",
			update:"TranslationKeyUpdateInput",
			create:"TranslationKeyCreateInput"
		},
		createTranslationValue:{
			data:"TranslationValueCreateInput"
		},
		deleteTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		updateTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere",
			data:"TranslationValueUpdateInput"
		},
		upsertTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere",
			update:"TranslationValueUpdateInput",
			create:"TranslationValueCreateInput"
		},
		createGenericPageAboutGroupLinksLocale:{
			data:"GenericPageAboutGroupLinksLocaleCreateInput"
		},
		deleteGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere"
		},
		updateGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			data:"GenericPageAboutGroupLinksLocaleUpdateInput"
		},
		upsertGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			update:"GenericPageAboutGroupLinksLocaleUpdateInput",
			create:"GenericPageAboutGroupLinksLocaleCreateInput"
		},
		createMemberList:{
			data:"MemberListCreateInput"
		},
		deleteMemberList:{
			by:"MemberListUniqueWhere",
			filter:"MemberListWhere"
		},
		updateMemberList:{
			by:"MemberListUniqueWhere",
			filter:"MemberListWhere",
			data:"MemberListUpdateInput"
		},
		upsertMemberList:{
			by:"MemberListUniqueWhere",
			filter:"MemberListWhere",
			update:"MemberListUpdateInput",
			create:"MemberListCreateInput"
		},
		createMemberListItem:{
			data:"MemberListItemCreateInput"
		},
		deleteMemberListItem:{
			by:"MemberListItemUniqueWhere",
			filter:"MemberListItemWhere"
		},
		updateMemberListItem:{
			by:"MemberListItemUniqueWhere",
			filter:"MemberListItemWhere",
			data:"MemberListItemUpdateInput"
		},
		upsertMemberListItem:{
			by:"MemberListItemUniqueWhere",
			filter:"MemberListItemWhere",
			update:"MemberListItemUpdateInput",
			create:"MemberListItemCreateInput"
		},
		createFilledTaxForm:{
			data:"FilledTaxFormCreateInput"
		},
		deleteFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			filter:"FilledTaxFormWhere"
		},
		updateFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			filter:"FilledTaxFormWhere",
			data:"FilledTaxFormUpdateInput"
		},
		upsertFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			filter:"FilledTaxFormWhere",
			update:"FilledTaxFormUpdateInput",
			create:"FilledTaxFormCreateInput"
		},
		createFilledTaxFormEmailAddress:{
			data:"FilledTaxFormEmailAddressCreateInput"
		},
		deleteFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			filter:"FilledTaxFormEmailAddressWhere"
		},
		updateFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			filter:"FilledTaxFormEmailAddressWhere",
			data:"FilledTaxFormEmailAddressUpdateInput"
		},
		upsertFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			filter:"FilledTaxFormEmailAddressWhere",
			update:"FilledTaxFormEmailAddressUpdateInput",
			create:"FilledTaxFormEmailAddressCreateInput"
		},
		createForm:{
			data:"FormCreateInput"
		},
		deleteForm:{
			by:"FormUniqueWhere",
			filter:"FormWhere"
		},
		updateForm:{
			by:"FormUniqueWhere",
			filter:"FormWhere",
			data:"FormUpdateInput"
		},
		upsertForm:{
			by:"FormUniqueWhere",
			filter:"FormWhere",
			update:"FormUpdateInput",
			create:"FormCreateInput"
		},
		createCsobPayment:{
			data:"CsobPaymentCreateInput"
		},
		deleteCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			filter:"CsobPaymentWhere"
		},
		updateCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			filter:"CsobPaymentWhere",
			data:"CsobPaymentUpdateInput"
		},
		upsertCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			filter:"CsobPaymentWhere",
			update:"CsobPaymentUpdateInput",
			create:"CsobPaymentCreateInput"
		},
		createCsobPaymentStatusChange:{
			data:"CsobPaymentStatusChangeCreateInput"
		},
		deleteCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			filter:"CsobPaymentStatusChangeWhere"
		},
		updateCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			filter:"CsobPaymentStatusChangeWhere",
			data:"CsobPaymentStatusChangeUpdateInput"
		},
		upsertCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			filter:"CsobPaymentStatusChangeWhere",
			update:"CsobPaymentStatusChangeUpdateInput",
			create:"CsobPaymentStatusChangeCreateInput"
		},
		createStripePayment:{
			data:"StripePaymentCreateInput"
		},
		deleteStripePayment:{
			by:"StripePaymentUniqueWhere",
			filter:"StripePaymentWhere"
		},
		updateStripePayment:{
			by:"StripePaymentUniqueWhere",
			filter:"StripePaymentWhere",
			data:"StripePaymentUpdateInput"
		},
		upsertStripePayment:{
			by:"StripePaymentUniqueWhere",
			filter:"StripePaymentWhere",
			update:"StripePaymentUpdateInput",
			create:"StripePaymentCreateInput"
		},
		createStripePaymentStatusChange:{
			data:"StripePaymentStatusChangeCreateInput"
		},
		deleteStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			filter:"StripePaymentStatusChangeWhere"
		},
		updateStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			filter:"StripePaymentStatusChangeWhere",
			data:"StripePaymentStatusChangeUpdateInput"
		},
		upsertStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			filter:"StripePaymentStatusChangeWhere",
			update:"StripePaymentStatusChangeUpdateInput",
			create:"StripePaymentStatusChangeCreateInput"
		},
		createRegionPaymentMethod:{
			data:"RegionPaymentMethodCreateInput"
		},
		deleteRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere"
		},
		updateRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere",
			data:"RegionPaymentMethodUpdateInput"
		},
		upsertRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere",
			update:"RegionPaymentMethodUpdateInput",
			create:"RegionPaymentMethodCreateInput"
		},
		createTileItem:{
			data:"TileItemCreateInput"
		},
		deleteTileItem:{
			by:"TileItemUniqueWhere",
			filter:"TileItemWhere"
		},
		updateTileItem:{
			by:"TileItemUniqueWhere",
			filter:"TileItemWhere",
			data:"TileItemUpdateInput"
		},
		upsertTileItem:{
			by:"TileItemUniqueWhere",
			filter:"TileItemWhere",
			update:"TileItemUpdateInput",
			create:"TileItemCreateInput"
		},
		createTileList:{
			data:"TileListCreateInput"
		},
		deleteTileList:{
			by:"TileListUniqueWhere",
			filter:"TileListWhere"
		},
		updateTileList:{
			by:"TileListUniqueWhere",
			filter:"TileListWhere",
			data:"TileListUpdateInput"
		},
		upsertTileList:{
			by:"TileListUniqueWhere",
			filter:"TileListWhere",
			update:"TileListUpdateInput",
			create:"TileListCreateInput"
		},
		createFeedPage:{
			data:"FeedPageCreateInput"
		},
		deleteFeedPage:{
			by:"FeedPageUniqueWhere",
			filter:"FeedPageWhere"
		},
		updateFeedPage:{
			by:"FeedPageUniqueWhere",
			filter:"FeedPageWhere",
			data:"FeedPageUpdateInput"
		},
		upsertFeedPage:{
			by:"FeedPageUniqueWhere",
			filter:"FeedPageWhere",
			update:"FeedPageUpdateInput",
			create:"FeedPageCreateInput"
		},
		createFeedPageLocale:{
			data:"FeedPageLocaleCreateInput"
		},
		deleteFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		updateFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere",
			data:"FeedPageLocaleUpdateInput"
		},
		upsertFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere",
			update:"FeedPageLocaleUpdateInput",
			create:"FeedPageLocaleCreateInput"
		},
		createFeedPageSection:{
			data:"FeedPageSectionCreateInput"
		},
		deleteFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			filter:"FeedPageSectionWhere"
		},
		updateFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			filter:"FeedPageSectionWhere",
			data:"FeedPageSectionUpdateInput"
		},
		upsertFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			filter:"FeedPageSectionWhere",
			update:"FeedPageSectionUpdateInput",
			create:"FeedPageSectionCreateInput"
		},
		createFeedPageTileStripe:{
			data:"FeedPageTileStripeCreateInput"
		},
		deleteFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			filter:"FeedPageTileStripeWhere"
		},
		updateFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			filter:"FeedPageTileStripeWhere",
			data:"FeedPageTileStripeUpdateInput"
		},
		upsertFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			filter:"FeedPageTileStripeWhere",
			update:"FeedPageTileStripeUpdateInput",
			create:"FeedPageTileStripeCreateInput"
		},
		createCardItem:{
			data:"CardItemCreateInput"
		},
		deleteCardItem:{
			by:"CardItemUniqueWhere",
			filter:"CardItemWhere"
		},
		updateCardItem:{
			by:"CardItemUniqueWhere",
			filter:"CardItemWhere",
			data:"CardItemUpdateInput"
		},
		upsertCardItem:{
			by:"CardItemUniqueWhere",
			filter:"CardItemWhere",
			update:"CardItemUpdateInput",
			create:"CardItemCreateInput"
		},
		createCardList:{
			data:"CardListCreateInput"
		},
		deleteCardList:{
			by:"CardListUniqueWhere",
			filter:"CardListWhere"
		},
		updateCardList:{
			by:"CardListUniqueWhere",
			filter:"CardListWhere",
			data:"CardListUpdateInput"
		},
		upsertCardList:{
			by:"CardListUniqueWhere",
			filter:"CardListWhere",
			update:"CardListUpdateInput",
			create:"CardListCreateInput"
		},
		createOnBehalfDonation:{
			data:"OnBehalfDonationCreateInput"
		},
		deleteOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			filter:"OnBehalfDonationWhere"
		},
		updateOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			filter:"OnBehalfDonationWhere",
			data:"OnBehalfDonationUpdateInput"
		},
		upsertOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			filter:"OnBehalfDonationWhere",
			update:"OnBehalfDonationUpdateInput",
			create:"OnBehalfDonationCreateInput"
		},
		createUserPaymentTriesCollection:{
			data:"UserPaymentTriesCollectionCreateInput"
		},
		deleteUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			filter:"UserPaymentTriesCollectionWhere"
		},
		updateUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			filter:"UserPaymentTriesCollectionWhere",
			data:"UserPaymentTriesCollectionUpdateInput"
		},
		upsertUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			filter:"UserPaymentTriesCollectionWhere",
			update:"UserPaymentTriesCollectionUpdateInput",
			create:"UserPaymentTriesCollectionCreateInput"
		},
		createRecurringPaymentPage:{
			data:"RecurringPaymentPageCreateInput"
		},
		deleteRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			filter:"RecurringPaymentPageWhere"
		},
		updateRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			filter:"RecurringPaymentPageWhere",
			data:"RecurringPaymentPageUpdateInput"
		},
		upsertRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			filter:"RecurringPaymentPageWhere",
			update:"RecurringPaymentPageUpdateInput",
			create:"RecurringPaymentPageCreateInput"
		},
		createRecurringPaymentPageLocale:{
			data:"RecurringPaymentPageLocaleCreateInput"
		},
		deleteRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		updateRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere",
			data:"RecurringPaymentPageLocaleUpdateInput"
		},
		upsertRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere",
			update:"RecurringPaymentPageLocaleUpdateInput",
			create:"RecurringPaymentPageLocaleCreateInput"
		},
		createStoryGuide:{
			data:"StoryGuideCreateInput"
		},
		deleteStoryGuide:{
			by:"StoryGuideUniqueWhere",
			filter:"StoryGuideWhere"
		},
		updateStoryGuide:{
			by:"StoryGuideUniqueWhere",
			filter:"StoryGuideWhere",
			data:"StoryGuideUpdateInput"
		},
		upsertStoryGuide:{
			by:"StoryGuideUniqueWhere",
			filter:"StoryGuideWhere",
			update:"StoryGuideUpdateInput",
			create:"StoryGuideCreateInput"
		},
		createStoryGuideItem:{
			data:"StoryGuideItemCreateInput"
		},
		deleteStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			filter:"StoryGuideItemWhere"
		},
		updateStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			filter:"StoryGuideItemWhere",
			data:"StoryGuideItemUpdateInput"
		},
		upsertStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			filter:"StoryGuideItemWhere",
			update:"StoryGuideItemUpdateInput",
			create:"StoryGuideItemCreateInput"
		},
		createStoryGuideList:{
			data:"StoryGuideListCreateInput"
		},
		deleteStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			filter:"StoryGuideListWhere"
		},
		updateStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			filter:"StoryGuideListWhere",
			data:"StoryGuideListUpdateInput"
		},
		upsertStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			filter:"StoryGuideListWhere",
			update:"StoryGuideListUpdateInput",
			create:"StoryGuideListCreateInput"
		},
		createHeroCarousel:{
			data:"HeroCarouselCreateInput"
		},
		deleteHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			filter:"HeroCarouselWhere"
		},
		updateHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			filter:"HeroCarouselWhere",
			data:"HeroCarouselUpdateInput"
		},
		upsertHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			filter:"HeroCarouselWhere",
			update:"HeroCarouselUpdateInput",
			create:"HeroCarouselCreateInput"
		},
		createPostOrganizationList:{
			data:"PostOrganizationListCreateInput"
		},
		deletePostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			filter:"PostOrganizationListWhere"
		},
		updatePostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			filter:"PostOrganizationListWhere",
			data:"PostOrganizationListUpdateInput"
		},
		upsertPostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			filter:"PostOrganizationListWhere",
			update:"PostOrganizationListUpdateInput",
			create:"PostOrganizationListCreateInput"
		},
		createPostOrganizationListItem:{
			data:"PostOrganizationListItemCreateInput"
		},
		deletePostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			filter:"PostOrganizationListItemWhere"
		},
		updatePostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			filter:"PostOrganizationListItemWhere",
			data:"PostOrganizationListItemUpdateInput"
		},
		upsertPostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			filter:"PostOrganizationListItemWhere",
			update:"PostOrganizationListItemUpdateInput",
			create:"PostOrganizationListItemCreateInput"
		},
		createInfoCarousel:{
			data:"InfoCarouselCreateInput"
		},
		deleteInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			filter:"InfoCarouselWhere"
		},
		updateInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			filter:"InfoCarouselWhere",
			data:"InfoCarouselUpdateInput"
		},
		upsertInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			filter:"InfoCarouselWhere",
			update:"InfoCarouselUpdateInput",
			create:"InfoCarouselCreateInput"
		},
		createInfoCarouselItem:{
			data:"InfoCarouselItemCreateInput"
		},
		deleteInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			filter:"InfoCarouselItemWhere"
		},
		updateInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			filter:"InfoCarouselItemWhere",
			data:"InfoCarouselItemUpdateInput"
		},
		upsertInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			filter:"InfoCarouselItemWhere",
			update:"InfoCarouselItemUpdateInput",
			create:"InfoCarouselItemCreateInput"
		},
		createPersonSeenInfoCarousel:{
			data:"PersonSeenInfoCarouselCreateInput"
		},
		deletePersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere"
		},
		updatePersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere",
			data:"PersonSeenInfoCarouselUpdateInput"
		},
		upsertPersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere",
			update:"PersonSeenInfoCarouselUpdateInput",
			create:"PersonSeenInfoCarouselCreateInput"
		},
		createGivenGiftsPage:{
			data:"GivenGiftsPageCreateInput"
		},
		deleteGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			filter:"GivenGiftsPageWhere"
		},
		updateGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			filter:"GivenGiftsPageWhere",
			data:"GivenGiftsPageUpdateInput"
		},
		upsertGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			filter:"GivenGiftsPageWhere",
			update:"GivenGiftsPageUpdateInput",
			create:"GivenGiftsPageCreateInput"
		},
		createGivenGiftsPageLocale:{
			data:"GivenGiftsPageLocaleCreateInput"
		},
		deleteGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		updateGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere",
			data:"GivenGiftsPageLocaleUpdateInput"
		},
		upsertGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere",
			update:"GivenGiftsPageLocaleUpdateInput",
			create:"GivenGiftsPageLocaleCreateInput"
		},
		createReceivedGiftsPage:{
			data:"ReceivedGiftsPageCreateInput"
		},
		deleteReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			filter:"ReceivedGiftsPageWhere"
		},
		updateReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			filter:"ReceivedGiftsPageWhere",
			data:"ReceivedGiftsPageUpdateInput"
		},
		upsertReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			filter:"ReceivedGiftsPageWhere",
			update:"ReceivedGiftsPageUpdateInput",
			create:"ReceivedGiftsPageCreateInput"
		},
		createReceivedGiftsPageLocale:{
			data:"ReceivedGiftsPageLocaleCreateInput"
		},
		deleteReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		updateReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere",
			data:"ReceivedGiftsPageLocaleUpdateInput"
		},
		upsertReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere",
			update:"ReceivedGiftsPageLocaleUpdateInput",
			create:"ReceivedGiftsPageLocaleCreateInput"
		},
		createReportNavigation:{
			data:"ReportNavigationCreateInput"
		},
		deleteReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			filter:"ReportNavigationWhere"
		},
		updateReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			filter:"ReportNavigationWhere",
			data:"ReportNavigationUpdateInput"
		},
		upsertReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			filter:"ReportNavigationWhere",
			update:"ReportNavigationUpdateInput",
			create:"ReportNavigationCreateInput"
		},
		createReportPage:{
			data:"ReportPageCreateInput"
		},
		deleteReportPage:{
			by:"ReportPageUniqueWhere",
			filter:"ReportPageWhere"
		},
		updateReportPage:{
			by:"ReportPageUniqueWhere",
			filter:"ReportPageWhere",
			data:"ReportPageUpdateInput"
		},
		upsertReportPage:{
			by:"ReportPageUniqueWhere",
			filter:"ReportPageWhere",
			update:"ReportPageUpdateInput",
			create:"ReportPageCreateInput"
		},
		createReportPageLocale:{
			data:"ReportPageLocaleCreateInput"
		},
		deleteReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		updateReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere",
			data:"ReportPageLocaleUpdateInput"
		},
		upsertReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere",
			update:"ReportPageLocaleUpdateInput",
			create:"ReportPageLocaleCreateInput"
		},
		createReportNavigationLocale:{
			data:"ReportNavigationLocaleCreateInput"
		},
		deleteReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere"
		},
		updateReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere",
			data:"ReportNavigationLocaleUpdateInput"
		},
		upsertReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere",
			update:"ReportNavigationLocaleUpdateInput",
			create:"ReportNavigationLocaleCreateInput"
		},
		createSentPayment:{
			data:"SentPaymentCreateInput"
		},
		deleteSentPayment:{
			by:"SentPaymentUniqueWhere",
			filter:"SentPaymentWhere"
		},
		updateSentPayment:{
			by:"SentPaymentUniqueWhere",
			filter:"SentPaymentWhere",
			data:"SentPaymentUpdateInput"
		},
		upsertSentPayment:{
			by:"SentPaymentUniqueWhere",
			filter:"SentPaymentWhere",
			update:"SentPaymentUpdateInput",
			create:"SentPaymentCreateInput"
		},
		createNotificationTargetGroup:{
			data:"NotificationTargetGroupCreateInput"
		},
		deleteNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			filter:"NotificationTargetGroupWhere"
		},
		updateNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			filter:"NotificationTargetGroupWhere",
			data:"NotificationTargetGroupUpdateInput"
		},
		upsertNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			filter:"NotificationTargetGroupWhere",
			update:"NotificationTargetGroupUpdateInput",
			create:"NotificationTargetGroupCreateInput"
		},
		createProcessedNotification:{
			data:"ProcessedNotificationCreateInput"
		},
		deleteProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationWhere"
		},
		updateProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationWhere",
			data:"ProcessedNotificationUpdateInput"
		},
		upsertProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationWhere",
			update:"ProcessedNotificationUpdateInput",
			create:"ProcessedNotificationCreateInput"
		},
		createScheduledNotification:{
			data:"ScheduledNotificationCreateInput"
		},
		deleteScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			filter:"ScheduledNotificationWhere"
		},
		updateScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			filter:"ScheduledNotificationWhere",
			data:"ScheduledNotificationUpdateInput"
		},
		upsertScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			filter:"ScheduledNotificationWhere",
			update:"ScheduledNotificationUpdateInput",
			create:"ScheduledNotificationCreateInput"
		},
		createProcessedNotificationSource:{
			data:"ProcessedNotificationSourceCreateInput"
		},
		deleteProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			filter:"ProcessedNotificationSourceWhere"
		},
		updateProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			filter:"ProcessedNotificationSourceWhere",
			data:"ProcessedNotificationSourceUpdateInput"
		},
		upsertProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			filter:"ProcessedNotificationSourceWhere",
			update:"ProcessedNotificationSourceUpdateInput",
			create:"ProcessedNotificationSourceCreateInput"
		},
		createDevice:{
			data:"DeviceCreateInput"
		},
		deleteDevice:{
			by:"DeviceUniqueWhere",
			filter:"DeviceWhere"
		},
		updateDevice:{
			by:"DeviceUniqueWhere",
			filter:"DeviceWhere",
			data:"DeviceUpdateInput"
		},
		upsertDevice:{
			by:"DeviceUniqueWhere",
			filter:"DeviceWhere",
			update:"DeviceUpdateInput",
			create:"DeviceCreateInput"
		},
		createScheduledNotificationLocale:{
			data:"ScheduledNotificationLocaleCreateInput"
		},
		deleteScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere"
		},
		updateScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere",
			data:"ScheduledNotificationLocaleUpdateInput"
		},
		upsertScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere",
			update:"ScheduledNotificationLocaleUpdateInput",
			create:"ScheduledNotificationLocaleCreateInput"
		},
		createInfoCarouselItemLocale:{
			data:"InfoCarouselItemLocaleCreateInput"
		},
		deleteInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere"
		},
		updateInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere",
			data:"InfoCarouselItemLocaleUpdateInput"
		},
		upsertInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere",
			update:"InfoCarouselItemLocaleUpdateInput",
			create:"InfoCarouselItemLocaleCreateInput"
		},
		createSentPaymentLocale:{
			data:"SentPaymentLocaleCreateInput"
		},
		deleteSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere"
		},
		updateSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere",
			data:"SentPaymentLocaleUpdateInput"
		},
		upsertSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere",
			update:"SentPaymentLocaleUpdateInput",
			create:"SentPaymentLocaleCreateInput"
		},
		createTextImageList:{
			data:"TextImageListCreateInput"
		},
		deleteTextImageList:{
			by:"TextImageListUniqueWhere",
			filter:"TextImageListWhere"
		},
		updateTextImageList:{
			by:"TextImageListUniqueWhere",
			filter:"TextImageListWhere",
			data:"TextImageListUpdateInput"
		},
		upsertTextImageList:{
			by:"TextImageListUniqueWhere",
			filter:"TextImageListWhere",
			update:"TextImageListUpdateInput",
			create:"TextImageListCreateInput"
		},
		createTextImageListItem:{
			data:"TextImageListItemCreateInput"
		},
		deleteTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			filter:"TextImageListItemWhere"
		},
		updateTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			filter:"TextImageListItemWhere",
			data:"TextImageListItemUpdateInput"
		},
		upsertTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			filter:"TextImageListItemWhere",
			update:"TextImageListItemUpdateInput",
			create:"TextImageListItemCreateInput"
		},
		createHeroCarouselItem:{
			data:"HeroCarouselItemCreateInput"
		},
		deleteHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			filter:"HeroCarouselItemWhere"
		},
		updateHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			filter:"HeroCarouselItemWhere",
			data:"HeroCarouselItemUpdateInput"
		},
		upsertHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			filter:"HeroCarouselItemWhere",
			update:"HeroCarouselItemUpdateInput",
			create:"HeroCarouselItemCreateInput"
		},
		transaction:{
			options:"MutationTransactionOptions"
		}
	},
	S3GenerateSignedUploadInput:{
		contentDisposition:"S33ContentDisposition",
		acl:"S3Acl"
	},
	S33ContentDisposition: "enum" as const,
	S3Acl: "enum" as const,
	_MutationErrorType: "enum" as const,
	MutationTransaction:{
		generateUploadUrl:{
			input:"S3GenerateSignedUploadInput"
		},
		generateReadUrl:{

		},
		createGeneral:{
			data:"GeneralCreateInput"
		},
		deleteGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere"
		},
		updateGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere",
			data:"GeneralUpdateInput"
		},
		upsertGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere",
			update:"GeneralUpdateInput",
			create:"GeneralCreateInput"
		},
		createImage:{
			data:"ImageCreateInput"
		},
		deleteImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		updateImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			data:"ImageUpdateInput"
		},
		upsertImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			update:"ImageUpdateInput",
			create:"ImageCreateInput"
		},
		createGenericPage:{
			data:"GenericPageCreateInput"
		},
		deleteGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere"
		},
		updateGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere",
			data:"GenericPageUpdateInput"
		},
		upsertGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere",
			update:"GenericPageUpdateInput",
			create:"GenericPageCreateInput"
		},
		createLinkable:{
			data:"LinkableCreateInput"
		},
		deleteLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		updateLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			data:"LinkableUpdateInput"
		},
		upsertLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			update:"LinkableUpdateInput",
			create:"LinkableCreateInput"
		},
		createSeo:{
			data:"SeoCreateInput"
		},
		deleteSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		updateSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			data:"SeoUpdateInput"
		},
		upsertSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			update:"SeoUpdateInput",
			create:"SeoCreateInput"
		},
		createContent:{
			data:"ContentCreateInput"
		},
		deleteContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		updateContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			data:"ContentUpdateInput"
		},
		upsertContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			update:"ContentUpdateInput",
			create:"ContentCreateInput"
		},
		createContentBlock:{
			data:"ContentBlockCreateInput"
		},
		deleteContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		updateContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			data:"ContentBlockUpdateInput"
		},
		upsertContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			update:"ContentBlockUpdateInput",
			create:"ContentBlockCreateInput"
		},
		createContentReference:{
			data:"ContentReferenceCreateInput"
		},
		deleteContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		updateContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			data:"ContentReferenceUpdateInput"
		},
		upsertContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			update:"ContentReferenceUpdateInput",
			create:"ContentReferenceCreateInput"
		},
		createGeneralLocale:{
			data:"GeneralLocaleCreateInput"
		},
		deleteGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		updateGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere",
			data:"GeneralLocaleUpdateInput"
		},
		upsertGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere",
			update:"GeneralLocaleUpdateInput",
			create:"GeneralLocaleCreateInput"
		},
		createGenericPageLocale:{
			data:"GenericPageLocaleCreateInput"
		},
		deleteGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		updateGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere",
			data:"GenericPageLocaleUpdateInput"
		},
		upsertGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere",
			update:"GenericPageLocaleUpdateInput",
			create:"GenericPageLocaleCreateInput"
		},
		createLocale:{
			data:"LocaleCreateInput"
		},
		deleteLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		updateLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			data:"LocaleUpdateInput"
		},
		upsertLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			update:"LocaleUpdateInput",
			create:"LocaleCreateInput"
		},
		createVideo:{
			data:"VideoCreateInput"
		},
		deleteVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		updateVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			data:"VideoUpdateInput"
		},
		upsertVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			update:"VideoUpdateInput",
			create:"VideoCreateInput"
		},
		createLink:{
			data:"LinkCreateInput"
		},
		deleteLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		updateLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			data:"LinkUpdateInput"
		},
		upsertLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			update:"LinkUpdateInput",
			create:"LinkCreateInput"
		},
		createPost:{
			data:"PostCreateInput"
		},
		deletePost:{
			by:"PostUniqueWhere",
			filter:"PostWhere"
		},
		updatePost:{
			by:"PostUniqueWhere",
			filter:"PostWhere",
			data:"PostUpdateInput"
		},
		upsertPost:{
			by:"PostUniqueWhere",
			filter:"PostWhere",
			update:"PostUpdateInput",
			create:"PostCreateInput"
		},
		createPostLocale:{
			data:"PostLocaleCreateInput"
		},
		deletePostLocale:{
			by:"PostLocaleUniqueWhere",
			filter:"PostLocaleWhere"
		},
		updatePostLocale:{
			by:"PostLocaleUniqueWhere",
			filter:"PostLocaleWhere",
			data:"PostLocaleUpdateInput"
		},
		upsertPostLocale:{
			by:"PostLocaleUniqueWhere",
			filter:"PostLocaleWhere",
			update:"PostLocaleUpdateInput",
			create:"PostLocaleCreateInput"
		},
		createPostArea:{
			data:"PostAreaCreateInput"
		},
		deletePostArea:{
			by:"PostAreaUniqueWhere",
			filter:"PostAreaWhere"
		},
		updatePostArea:{
			by:"PostAreaUniqueWhere",
			filter:"PostAreaWhere",
			data:"PostAreaUpdateInput"
		},
		upsertPostArea:{
			by:"PostAreaUniqueWhere",
			filter:"PostAreaWhere",
			update:"PostAreaUpdateInput",
			create:"PostAreaCreateInput"
		},
		createPostAreaLocale:{
			data:"PostAreaLocaleCreateInput"
		},
		deletePostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere"
		},
		updatePostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere",
			data:"PostAreaLocaleUpdateInput"
		},
		upsertPostAreaLocale:{
			by:"PostAreaLocaleUniqueWhere",
			filter:"PostAreaLocaleWhere",
			update:"PostAreaLocaleUpdateInput",
			create:"PostAreaLocaleCreateInput"
		},
		createPostOrganization:{
			data:"PostOrganizationCreateInput"
		},
		deletePostOrganization:{
			by:"PostOrganizationUniqueWhere",
			filter:"PostOrganizationWhere"
		},
		updatePostOrganization:{
			by:"PostOrganizationUniqueWhere",
			filter:"PostOrganizationWhere",
			data:"PostOrganizationUpdateInput"
		},
		upsertPostOrganization:{
			by:"PostOrganizationUniqueWhere",
			filter:"PostOrganizationWhere",
			update:"PostOrganizationUpdateInput",
			create:"PostOrganizationCreateInput"
		},
		createPostOrganizationLocale:{
			data:"PostOrganizationLocaleCreateInput"
		},
		deletePostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere"
		},
		updatePostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere",
			data:"PostOrganizationLocaleUpdateInput"
		},
		upsertPostOrganizationLocale:{
			by:"PostOrganizationLocaleUniqueWhere",
			filter:"PostOrganizationLocaleWhere",
			update:"PostOrganizationLocaleUpdateInput",
			create:"PostOrganizationLocaleCreateInput"
		},
		createDonation:{
			data:"DonationCreateInput"
		},
		deleteDonation:{
			by:"DonationUniqueWhere",
			filter:"DonationWhere"
		},
		updateDonation:{
			by:"DonationUniqueWhere",
			filter:"DonationWhere",
			data:"DonationUpdateInput"
		},
		upsertDonation:{
			by:"DonationUniqueWhere",
			filter:"DonationWhere",
			update:"DonationUpdateInput",
			create:"DonationCreateInput"
		},
		createDonationAmountItem:{
			data:"DonationAmountItemCreateInput"
		},
		deleteDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			filter:"DonationAmountItemWhere"
		},
		updateDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			filter:"DonationAmountItemWhere",
			data:"DonationAmountItemUpdateInput"
		},
		upsertDonationAmountItem:{
			by:"DonationAmountItemUniqueWhere",
			filter:"DonationAmountItemWhere",
			update:"DonationAmountItemUpdateInput",
			create:"DonationAmountItemCreateInput"
		},
		createDonationAmountsRegionItem:{
			data:"DonationAmountsRegionItemCreateInput"
		},
		deleteDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			filter:"DonationAmountsRegionItemWhere"
		},
		updateDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			filter:"DonationAmountsRegionItemWhere",
			data:"DonationAmountsRegionItemUpdateInput"
		},
		upsertDonationAmountsRegionItem:{
			by:"DonationAmountsRegionItemUniqueWhere",
			filter:"DonationAmountsRegionItemWhere",
			update:"DonationAmountsRegionItemUpdateInput",
			create:"DonationAmountsRegionItemCreateInput"
		},
		createDonationAmountsRegionList:{
			data:"DonationAmountsRegionListCreateInput"
		},
		deleteDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			filter:"DonationAmountsRegionListWhere"
		},
		updateDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			filter:"DonationAmountsRegionListWhere",
			data:"DonationAmountsRegionListUpdateInput"
		},
		upsertDonationAmountsRegionList:{
			by:"DonationAmountsRegionListUniqueWhere",
			filter:"DonationAmountsRegionListWhere",
			update:"DonationAmountsRegionListUpdateInput",
			create:"DonationAmountsRegionListCreateInput"
		},
		createRegion:{
			data:"RegionCreateInput"
		},
		deleteRegion:{
			by:"RegionUniqueWhere",
			filter:"RegionWhere"
		},
		updateRegion:{
			by:"RegionUniqueWhere",
			filter:"RegionWhere",
			data:"RegionUpdateInput"
		},
		upsertRegion:{
			by:"RegionUniqueWhere",
			filter:"RegionWhere",
			update:"RegionUpdateInput",
			create:"RegionCreateInput"
		},
		createLinkItem:{
			data:"LinkItemCreateInput"
		},
		deleteLinkItem:{
			by:"LinkItemUniqueWhere",
			filter:"LinkItemWhere"
		},
		updateLinkItem:{
			by:"LinkItemUniqueWhere",
			filter:"LinkItemWhere",
			data:"LinkItemUpdateInput"
		},
		upsertLinkItem:{
			by:"LinkItemUniqueWhere",
			filter:"LinkItemWhere",
			update:"LinkItemUpdateInput",
			create:"LinkItemCreateInput"
		},
		createLinkList:{
			data:"LinkListCreateInput"
		},
		deleteLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere"
		},
		updateLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere",
			data:"LinkListUpdateInput"
		},
		upsertLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere",
			update:"LinkListUpdateInput",
			create:"LinkListCreateInput"
		},
		createHeader:{
			data:"HeaderCreateInput"
		},
		deleteHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere"
		},
		updateHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere",
			data:"HeaderUpdateInput"
		},
		upsertHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere",
			update:"HeaderUpdateInput",
			create:"HeaderCreateInput"
		},
		createHeaderLocale:{
			data:"HeaderLocaleCreateInput"
		},
		deleteHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		updateHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere",
			data:"HeaderLocaleUpdateInput"
		},
		upsertHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere",
			update:"HeaderLocaleUpdateInput",
			create:"HeaderLocaleCreateInput"
		},
		createFooter:{
			data:"FooterCreateInput"
		},
		deleteFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere"
		},
		updateFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere",
			data:"FooterUpdateInput"
		},
		upsertFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere",
			update:"FooterUpdateInput",
			create:"FooterCreateInput"
		},
		createFooterLocale:{
			data:"FooterLocaleCreateInput"
		},
		deleteFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		updateFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere",
			data:"FooterLocaleUpdateInput"
		},
		upsertFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere",
			update:"FooterLocaleUpdateInput",
			create:"FooterLocaleCreateInput"
		},
		createPostList:{
			data:"PostListCreateInput"
		},
		deletePostList:{
			by:"PostListUniqueWhere",
			filter:"PostListWhere"
		},
		updatePostList:{
			by:"PostListUniqueWhere",
			filter:"PostListWhere",
			data:"PostListUpdateInput"
		},
		upsertPostList:{
			by:"PostListUniqueWhere",
			filter:"PostListWhere",
			update:"PostListUpdateInput",
			create:"PostListCreateInput"
		},
		createPostListItem:{
			data:"PostListItemCreateInput"
		},
		deletePostListItem:{
			by:"PostListItemUniqueWhere",
			filter:"PostListItemWhere"
		},
		updatePostListItem:{
			by:"PostListItemUniqueWhere",
			filter:"PostListItemWhere",
			data:"PostListItemUpdateInput"
		},
		upsertPostListItem:{
			by:"PostListItemUniqueWhere",
			filter:"PostListItemWhere",
			update:"PostListItemUpdateInput",
			create:"PostListItemCreateInput"
		},
		createAppBanner:{
			data:"AppBannerCreateInput"
		},
		deleteAppBanner:{
			by:"AppBannerUniqueWhere",
			filter:"AppBannerWhere"
		},
		updateAppBanner:{
			by:"AppBannerUniqueWhere",
			filter:"AppBannerWhere",
			data:"AppBannerUpdateInput"
		},
		upsertAppBanner:{
			by:"AppBannerUniqueWhere",
			filter:"AppBannerWhere",
			update:"AppBannerUpdateInput",
			create:"AppBannerCreateInput"
		},
		createGenericPageAboutSettings:{
			data:"GenericPageAboutSettingsCreateInput"
		},
		deleteGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			filter:"GenericPageAboutSettingsWhere"
		},
		updateGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			filter:"GenericPageAboutSettingsWhere",
			data:"GenericPageAboutSettingsUpdateInput"
		},
		upsertGenericPageAboutSettings:{
			by:"GenericPageAboutSettingsUniqueWhere",
			filter:"GenericPageAboutSettingsWhere",
			update:"GenericPageAboutSettingsUpdateInput",
			create:"GenericPageAboutSettingsCreateInput"
		},
		createGenericPageAboutSettingsLocale:{
			data:"GenericPageAboutSettingsLocaleCreateInput"
		},
		deleteGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere"
		},
		updateGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere",
			data:"GenericPageAboutSettingsLocaleUpdateInput"
		},
		upsertGenericPageAboutSettingsLocale:{
			by:"GenericPageAboutSettingsLocaleUniqueWhere",
			filter:"GenericPageAboutSettingsLocaleWhere",
			update:"GenericPageAboutSettingsLocaleUpdateInput",
			create:"GenericPageAboutSettingsLocaleCreateInput"
		},
		createValue:{
			data:"ValueCreateInput"
		},
		deleteValue:{
			by:"ValueUniqueWhere",
			filter:"ValueWhere"
		},
		updateValue:{
			by:"ValueUniqueWhere",
			filter:"ValueWhere",
			data:"ValueUpdateInput"
		},
		upsertValue:{
			by:"ValueUniqueWhere",
			filter:"ValueWhere",
			update:"ValueUpdateInput",
			create:"ValueCreateInput"
		},
		createValueItem:{
			data:"ValueItemCreateInput"
		},
		deleteValueItem:{
			by:"ValueItemUniqueWhere",
			filter:"ValueItemWhere"
		},
		updateValueItem:{
			by:"ValueItemUniqueWhere",
			filter:"ValueItemWhere",
			data:"ValueItemUpdateInput"
		},
		upsertValueItem:{
			by:"ValueItemUniqueWhere",
			filter:"ValueItemWhere",
			update:"ValueItemUpdateInput",
			create:"ValueItemCreateInput"
		},
		createValueList:{
			data:"ValueListCreateInput"
		},
		deleteValueList:{
			by:"ValueListUniqueWhere",
			filter:"ValueListWhere"
		},
		updateValueList:{
			by:"ValueListUniqueWhere",
			filter:"ValueListWhere",
			data:"ValueListUpdateInput"
		},
		upsertValueList:{
			by:"ValueListUniqueWhere",
			filter:"ValueListWhere",
			update:"ValueListUpdateInput",
			create:"ValueListCreateInput"
		},
		createImageLink:{
			data:"ImageLinkCreateInput"
		},
		deleteImageLink:{
			by:"ImageLinkUniqueWhere",
			filter:"ImageLinkWhere"
		},
		updateImageLink:{
			by:"ImageLinkUniqueWhere",
			filter:"ImageLinkWhere",
			data:"ImageLinkUpdateInput"
		},
		upsertImageLink:{
			by:"ImageLinkUniqueWhere",
			filter:"ImageLinkWhere",
			update:"ImageLinkUpdateInput",
			create:"ImageLinkCreateInput"
		},
		createImageLinkItem:{
			data:"ImageLinkItemCreateInput"
		},
		deleteImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			filter:"ImageLinkItemWhere"
		},
		updateImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			filter:"ImageLinkItemWhere",
			data:"ImageLinkItemUpdateInput"
		},
		upsertImageLinkItem:{
			by:"ImageLinkItemUniqueWhere",
			filter:"ImageLinkItemWhere",
			update:"ImageLinkItemUpdateInput",
			create:"ImageLinkItemCreateInput"
		},
		createImageLinkList:{
			data:"ImageLinkListCreateInput"
		},
		deleteImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			filter:"ImageLinkListWhere"
		},
		updateImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			filter:"ImageLinkListWhere",
			data:"ImageLinkListUpdateInput"
		},
		upsertImageLinkList:{
			by:"ImageLinkListUniqueWhere",
			filter:"ImageLinkListWhere",
			update:"ImageLinkListUpdateInput",
			create:"ImageLinkListCreateInput"
		},
		createPostAreaList:{
			data:"PostAreaListCreateInput"
		},
		deletePostAreaList:{
			by:"PostAreaListUniqueWhere",
			filter:"PostAreaListWhere"
		},
		updatePostAreaList:{
			by:"PostAreaListUniqueWhere",
			filter:"PostAreaListWhere",
			data:"PostAreaListUpdateInput"
		},
		upsertPostAreaList:{
			by:"PostAreaListUniqueWhere",
			filter:"PostAreaListWhere",
			update:"PostAreaListUpdateInput",
			create:"PostAreaListCreateInput"
		},
		createPostAreaListItem:{
			data:"PostAreaListItemCreateInput"
		},
		deletePostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			filter:"PostAreaListItemWhere"
		},
		updatePostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			filter:"PostAreaListItemWhere",
			data:"PostAreaListItemUpdateInput"
		},
		upsertPostAreaListItem:{
			by:"PostAreaListItemUniqueWhere",
			filter:"PostAreaListItemWhere",
			update:"PostAreaListItemUpdateInput",
			create:"PostAreaListItemCreateInput"
		},
		createAccordion:{
			data:"AccordionCreateInput"
		},
		deleteAccordion:{
			by:"AccordionUniqueWhere",
			filter:"AccordionWhere"
		},
		updateAccordion:{
			by:"AccordionUniqueWhere",
			filter:"AccordionWhere",
			data:"AccordionUpdateInput"
		},
		upsertAccordion:{
			by:"AccordionUniqueWhere",
			filter:"AccordionWhere",
			update:"AccordionUpdateInput",
			create:"AccordionCreateInput"
		},
		createAccordionItem:{
			data:"AccordionItemCreateInput"
		},
		deleteAccordionItem:{
			by:"AccordionItemUniqueWhere",
			filter:"AccordionItemWhere"
		},
		updateAccordionItem:{
			by:"AccordionItemUniqueWhere",
			filter:"AccordionItemWhere",
			data:"AccordionItemUpdateInput"
		},
		upsertAccordionItem:{
			by:"AccordionItemUniqueWhere",
			filter:"AccordionItemWhere",
			update:"AccordionItemUpdateInput",
			create:"AccordionItemCreateInput"
		},
		createUser:{
			data:"UserCreateInput"
		},
		deleteUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere"
		},
		updateUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere",
			data:"UserUpdateInput"
		},
		upsertUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere",
			update:"UserUpdateInput",
			create:"UserCreateInput"
		},
		createUserPayment:{
			data:"UserPaymentCreateInput"
		},
		deleteUserPayment:{
			by:"UserPaymentUniqueWhere",
			filter:"UserPaymentWhere"
		},
		updateUserPayment:{
			by:"UserPaymentUniqueWhere",
			filter:"UserPaymentWhere",
			data:"UserPaymentUpdateInput"
		},
		upsertUserPayment:{
			by:"UserPaymentUniqueWhere",
			filter:"UserPaymentWhere",
			update:"UserPaymentUpdateInput",
			create:"UserPaymentCreateInput"
		},
		createCurrency:{
			data:"CurrencyCreateInput"
		},
		deleteCurrency:{
			by:"CurrencyUniqueWhere",
			filter:"CurrencyWhere"
		},
		updateCurrency:{
			by:"CurrencyUniqueWhere",
			filter:"CurrencyWhere",
			data:"CurrencyUpdateInput"
		},
		upsertCurrency:{
			by:"CurrencyUniqueWhere",
			filter:"CurrencyWhere",
			update:"CurrencyUpdateInput",
			create:"CurrencyCreateInput"
		},
		createMedium:{
			data:"MediumCreateInput"
		},
		deleteMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		updateMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			data:"MediumUpdateInput"
		},
		upsertMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			update:"MediumUpdateInput",
			create:"MediumCreateInput"
		},
		createMediumItem:{
			data:"MediumItemCreateInput"
		},
		deleteMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere"
		},
		updateMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere",
			data:"MediumItemUpdateInput"
		},
		upsertMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere",
			update:"MediumItemUpdateInput",
			create:"MediumItemCreateInput"
		},
		createMediumList:{
			data:"MediumListCreateInput"
		},
		deleteMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere"
		},
		updateMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere",
			data:"MediumListUpdateInput"
		},
		upsertMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere",
			update:"MediumListUpdateInput",
			create:"MediumListCreateInput"
		},
		createUserPaymentOrderId:{
			data:"UserPaymentOrderIdCreateInput"
		},
		deleteUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			filter:"UserPaymentOrderIdWhere"
		},
		updateUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			filter:"UserPaymentOrderIdWhere",
			data:"UserPaymentOrderIdUpdateInput"
		},
		upsertUserPaymentOrderId:{
			by:"UserPaymentOrderIdUniqueWhere",
			filter:"UserPaymentOrderIdWhere",
			update:"UserPaymentOrderIdUpdateInput",
			create:"UserPaymentOrderIdCreateInput"
		},
		createPostRevision:{
			data:"PostRevisionCreateInput"
		},
		deletePostRevision:{
			by:"PostRevisionUniqueWhere",
			filter:"PostRevisionWhere"
		},
		updatePostRevision:{
			by:"PostRevisionUniqueWhere",
			filter:"PostRevisionWhere",
			data:"PostRevisionUpdateInput"
		},
		upsertPostRevision:{
			by:"PostRevisionUniqueWhere",
			filter:"PostRevisionWhere",
			update:"PostRevisionUpdateInput",
			create:"PostRevisionCreateInput"
		},
		createUserRecurringPayment:{
			data:"UserRecurringPaymentCreateInput"
		},
		deleteUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			filter:"UserRecurringPaymentWhere"
		},
		updateUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			filter:"UserRecurringPaymentWhere",
			data:"UserRecurringPaymentUpdateInput"
		},
		upsertUserRecurringPayment:{
			by:"UserRecurringPaymentUniqueWhere",
			filter:"UserRecurringPaymentWhere",
			update:"UserRecurringPaymentUpdateInput",
			create:"UserRecurringPaymentCreateInput"
		},
		createUserRecurringPaymentItem:{
			data:"UserRecurringPaymentItemCreateInput"
		},
		deleteUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			filter:"UserRecurringPaymentItemWhere"
		},
		updateUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			filter:"UserRecurringPaymentItemWhere",
			data:"UserRecurringPaymentItemUpdateInput"
		},
		upsertUserRecurringPaymentItem:{
			by:"UserRecurringPaymentItemUniqueWhere",
			filter:"UserRecurringPaymentItemWhere",
			update:"UserRecurringPaymentItemUpdateInput",
			create:"UserRecurringPaymentItemCreateInput"
		},
		createPostRevisionLocale:{
			data:"PostRevisionLocaleCreateInput"
		},
		deletePostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere"
		},
		updatePostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere",
			data:"PostRevisionLocaleUpdateInput"
		},
		upsertPostRevisionLocale:{
			by:"PostRevisionLocaleUniqueWhere",
			filter:"PostRevisionLocaleWhere",
			update:"PostRevisionLocaleUpdateInput",
			create:"PostRevisionLocaleCreateInput"
		},
		createTranslationCatalogue:{
			data:"TranslationCatalogueCreateInput"
		},
		deleteTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		updateTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere",
			data:"TranslationCatalogueUpdateInput"
		},
		upsertTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere",
			update:"TranslationCatalogueUpdateInput",
			create:"TranslationCatalogueCreateInput"
		},
		createTranslationCataloguesIdentifier:{
			data:"TranslationCataloguesIdentifierCreateInput"
		},
		deleteTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere"
		},
		updateTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere",
			data:"TranslationCataloguesIdentifierUpdateInput"
		},
		upsertTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere",
			update:"TranslationCataloguesIdentifierUpdateInput",
			create:"TranslationCataloguesIdentifierCreateInput"
		},
		createTranslationDomain:{
			data:"TranslationDomainCreateInput"
		},
		deleteTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere"
		},
		updateTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere",
			data:"TranslationDomainUpdateInput"
		},
		upsertTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere",
			update:"TranslationDomainUpdateInput",
			create:"TranslationDomainCreateInput"
		},
		createTranslationKey:{
			data:"TranslationKeyCreateInput"
		},
		deleteTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		updateTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere",
			data:"TranslationKeyUpdateInput"
		},
		upsertTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere",
			update:"TranslationKeyUpdateInput",
			create:"TranslationKeyCreateInput"
		},
		createTranslationValue:{
			data:"TranslationValueCreateInput"
		},
		deleteTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		updateTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere",
			data:"TranslationValueUpdateInput"
		},
		upsertTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere",
			update:"TranslationValueUpdateInput",
			create:"TranslationValueCreateInput"
		},
		createGenericPageAboutGroupLinksLocale:{
			data:"GenericPageAboutGroupLinksLocaleCreateInput"
		},
		deleteGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere"
		},
		updateGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			data:"GenericPageAboutGroupLinksLocaleUpdateInput"
		},
		upsertGenericPageAboutGroupLinksLocale:{
			by:"GenericPageAboutGroupLinksLocaleUniqueWhere",
			filter:"GenericPageAboutGroupLinksLocaleWhere",
			update:"GenericPageAboutGroupLinksLocaleUpdateInput",
			create:"GenericPageAboutGroupLinksLocaleCreateInput"
		},
		createMemberList:{
			data:"MemberListCreateInput"
		},
		deleteMemberList:{
			by:"MemberListUniqueWhere",
			filter:"MemberListWhere"
		},
		updateMemberList:{
			by:"MemberListUniqueWhere",
			filter:"MemberListWhere",
			data:"MemberListUpdateInput"
		},
		upsertMemberList:{
			by:"MemberListUniqueWhere",
			filter:"MemberListWhere",
			update:"MemberListUpdateInput",
			create:"MemberListCreateInput"
		},
		createMemberListItem:{
			data:"MemberListItemCreateInput"
		},
		deleteMemberListItem:{
			by:"MemberListItemUniqueWhere",
			filter:"MemberListItemWhere"
		},
		updateMemberListItem:{
			by:"MemberListItemUniqueWhere",
			filter:"MemberListItemWhere",
			data:"MemberListItemUpdateInput"
		},
		upsertMemberListItem:{
			by:"MemberListItemUniqueWhere",
			filter:"MemberListItemWhere",
			update:"MemberListItemUpdateInput",
			create:"MemberListItemCreateInput"
		},
		createFilledTaxForm:{
			data:"FilledTaxFormCreateInput"
		},
		deleteFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			filter:"FilledTaxFormWhere"
		},
		updateFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			filter:"FilledTaxFormWhere",
			data:"FilledTaxFormUpdateInput"
		},
		upsertFilledTaxForm:{
			by:"FilledTaxFormUniqueWhere",
			filter:"FilledTaxFormWhere",
			update:"FilledTaxFormUpdateInput",
			create:"FilledTaxFormCreateInput"
		},
		createFilledTaxFormEmailAddress:{
			data:"FilledTaxFormEmailAddressCreateInput"
		},
		deleteFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			filter:"FilledTaxFormEmailAddressWhere"
		},
		updateFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			filter:"FilledTaxFormEmailAddressWhere",
			data:"FilledTaxFormEmailAddressUpdateInput"
		},
		upsertFilledTaxFormEmailAddress:{
			by:"FilledTaxFormEmailAddressUniqueWhere",
			filter:"FilledTaxFormEmailAddressWhere",
			update:"FilledTaxFormEmailAddressUpdateInput",
			create:"FilledTaxFormEmailAddressCreateInput"
		},
		createForm:{
			data:"FormCreateInput"
		},
		deleteForm:{
			by:"FormUniqueWhere",
			filter:"FormWhere"
		},
		updateForm:{
			by:"FormUniqueWhere",
			filter:"FormWhere",
			data:"FormUpdateInput"
		},
		upsertForm:{
			by:"FormUniqueWhere",
			filter:"FormWhere",
			update:"FormUpdateInput",
			create:"FormCreateInput"
		},
		createCsobPayment:{
			data:"CsobPaymentCreateInput"
		},
		deleteCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			filter:"CsobPaymentWhere"
		},
		updateCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			filter:"CsobPaymentWhere",
			data:"CsobPaymentUpdateInput"
		},
		upsertCsobPayment:{
			by:"CsobPaymentUniqueWhere",
			filter:"CsobPaymentWhere",
			update:"CsobPaymentUpdateInput",
			create:"CsobPaymentCreateInput"
		},
		createCsobPaymentStatusChange:{
			data:"CsobPaymentStatusChangeCreateInput"
		},
		deleteCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			filter:"CsobPaymentStatusChangeWhere"
		},
		updateCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			filter:"CsobPaymentStatusChangeWhere",
			data:"CsobPaymentStatusChangeUpdateInput"
		},
		upsertCsobPaymentStatusChange:{
			by:"CsobPaymentStatusChangeUniqueWhere",
			filter:"CsobPaymentStatusChangeWhere",
			update:"CsobPaymentStatusChangeUpdateInput",
			create:"CsobPaymentStatusChangeCreateInput"
		},
		createStripePayment:{
			data:"StripePaymentCreateInput"
		},
		deleteStripePayment:{
			by:"StripePaymentUniqueWhere",
			filter:"StripePaymentWhere"
		},
		updateStripePayment:{
			by:"StripePaymentUniqueWhere",
			filter:"StripePaymentWhere",
			data:"StripePaymentUpdateInput"
		},
		upsertStripePayment:{
			by:"StripePaymentUniqueWhere",
			filter:"StripePaymentWhere",
			update:"StripePaymentUpdateInput",
			create:"StripePaymentCreateInput"
		},
		createStripePaymentStatusChange:{
			data:"StripePaymentStatusChangeCreateInput"
		},
		deleteStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			filter:"StripePaymentStatusChangeWhere"
		},
		updateStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			filter:"StripePaymentStatusChangeWhere",
			data:"StripePaymentStatusChangeUpdateInput"
		},
		upsertStripePaymentStatusChange:{
			by:"StripePaymentStatusChangeUniqueWhere",
			filter:"StripePaymentStatusChangeWhere",
			update:"StripePaymentStatusChangeUpdateInput",
			create:"StripePaymentStatusChangeCreateInput"
		},
		createRegionPaymentMethod:{
			data:"RegionPaymentMethodCreateInput"
		},
		deleteRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere"
		},
		updateRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere",
			data:"RegionPaymentMethodUpdateInput"
		},
		upsertRegionPaymentMethod:{
			by:"RegionPaymentMethodUniqueWhere",
			filter:"RegionPaymentMethodWhere",
			update:"RegionPaymentMethodUpdateInput",
			create:"RegionPaymentMethodCreateInput"
		},
		createTileItem:{
			data:"TileItemCreateInput"
		},
		deleteTileItem:{
			by:"TileItemUniqueWhere",
			filter:"TileItemWhere"
		},
		updateTileItem:{
			by:"TileItemUniqueWhere",
			filter:"TileItemWhere",
			data:"TileItemUpdateInput"
		},
		upsertTileItem:{
			by:"TileItemUniqueWhere",
			filter:"TileItemWhere",
			update:"TileItemUpdateInput",
			create:"TileItemCreateInput"
		},
		createTileList:{
			data:"TileListCreateInput"
		},
		deleteTileList:{
			by:"TileListUniqueWhere",
			filter:"TileListWhere"
		},
		updateTileList:{
			by:"TileListUniqueWhere",
			filter:"TileListWhere",
			data:"TileListUpdateInput"
		},
		upsertTileList:{
			by:"TileListUniqueWhere",
			filter:"TileListWhere",
			update:"TileListUpdateInput",
			create:"TileListCreateInput"
		},
		createFeedPage:{
			data:"FeedPageCreateInput"
		},
		deleteFeedPage:{
			by:"FeedPageUniqueWhere",
			filter:"FeedPageWhere"
		},
		updateFeedPage:{
			by:"FeedPageUniqueWhere",
			filter:"FeedPageWhere",
			data:"FeedPageUpdateInput"
		},
		upsertFeedPage:{
			by:"FeedPageUniqueWhere",
			filter:"FeedPageWhere",
			update:"FeedPageUpdateInput",
			create:"FeedPageCreateInput"
		},
		createFeedPageLocale:{
			data:"FeedPageLocaleCreateInput"
		},
		deleteFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere"
		},
		updateFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere",
			data:"FeedPageLocaleUpdateInput"
		},
		upsertFeedPageLocale:{
			by:"FeedPageLocaleUniqueWhere",
			filter:"FeedPageLocaleWhere",
			update:"FeedPageLocaleUpdateInput",
			create:"FeedPageLocaleCreateInput"
		},
		createFeedPageSection:{
			data:"FeedPageSectionCreateInput"
		},
		deleteFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			filter:"FeedPageSectionWhere"
		},
		updateFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			filter:"FeedPageSectionWhere",
			data:"FeedPageSectionUpdateInput"
		},
		upsertFeedPageSection:{
			by:"FeedPageSectionUniqueWhere",
			filter:"FeedPageSectionWhere",
			update:"FeedPageSectionUpdateInput",
			create:"FeedPageSectionCreateInput"
		},
		createFeedPageTileStripe:{
			data:"FeedPageTileStripeCreateInput"
		},
		deleteFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			filter:"FeedPageTileStripeWhere"
		},
		updateFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			filter:"FeedPageTileStripeWhere",
			data:"FeedPageTileStripeUpdateInput"
		},
		upsertFeedPageTileStripe:{
			by:"FeedPageTileStripeUniqueWhere",
			filter:"FeedPageTileStripeWhere",
			update:"FeedPageTileStripeUpdateInput",
			create:"FeedPageTileStripeCreateInput"
		},
		createCardItem:{
			data:"CardItemCreateInput"
		},
		deleteCardItem:{
			by:"CardItemUniqueWhere",
			filter:"CardItemWhere"
		},
		updateCardItem:{
			by:"CardItemUniqueWhere",
			filter:"CardItemWhere",
			data:"CardItemUpdateInput"
		},
		upsertCardItem:{
			by:"CardItemUniqueWhere",
			filter:"CardItemWhere",
			update:"CardItemUpdateInput",
			create:"CardItemCreateInput"
		},
		createCardList:{
			data:"CardListCreateInput"
		},
		deleteCardList:{
			by:"CardListUniqueWhere",
			filter:"CardListWhere"
		},
		updateCardList:{
			by:"CardListUniqueWhere",
			filter:"CardListWhere",
			data:"CardListUpdateInput"
		},
		upsertCardList:{
			by:"CardListUniqueWhere",
			filter:"CardListWhere",
			update:"CardListUpdateInput",
			create:"CardListCreateInput"
		},
		createOnBehalfDonation:{
			data:"OnBehalfDonationCreateInput"
		},
		deleteOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			filter:"OnBehalfDonationWhere"
		},
		updateOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			filter:"OnBehalfDonationWhere",
			data:"OnBehalfDonationUpdateInput"
		},
		upsertOnBehalfDonation:{
			by:"OnBehalfDonationUniqueWhere",
			filter:"OnBehalfDonationWhere",
			update:"OnBehalfDonationUpdateInput",
			create:"OnBehalfDonationCreateInput"
		},
		createUserPaymentTriesCollection:{
			data:"UserPaymentTriesCollectionCreateInput"
		},
		deleteUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			filter:"UserPaymentTriesCollectionWhere"
		},
		updateUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			filter:"UserPaymentTriesCollectionWhere",
			data:"UserPaymentTriesCollectionUpdateInput"
		},
		upsertUserPaymentTriesCollection:{
			by:"UserPaymentTriesCollectionUniqueWhere",
			filter:"UserPaymentTriesCollectionWhere",
			update:"UserPaymentTriesCollectionUpdateInput",
			create:"UserPaymentTriesCollectionCreateInput"
		},
		createRecurringPaymentPage:{
			data:"RecurringPaymentPageCreateInput"
		},
		deleteRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			filter:"RecurringPaymentPageWhere"
		},
		updateRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			filter:"RecurringPaymentPageWhere",
			data:"RecurringPaymentPageUpdateInput"
		},
		upsertRecurringPaymentPage:{
			by:"RecurringPaymentPageUniqueWhere",
			filter:"RecurringPaymentPageWhere",
			update:"RecurringPaymentPageUpdateInput",
			create:"RecurringPaymentPageCreateInput"
		},
		createRecurringPaymentPageLocale:{
			data:"RecurringPaymentPageLocaleCreateInput"
		},
		deleteRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere"
		},
		updateRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere",
			data:"RecurringPaymentPageLocaleUpdateInput"
		},
		upsertRecurringPaymentPageLocale:{
			by:"RecurringPaymentPageLocaleUniqueWhere",
			filter:"RecurringPaymentPageLocaleWhere",
			update:"RecurringPaymentPageLocaleUpdateInput",
			create:"RecurringPaymentPageLocaleCreateInput"
		},
		createStoryGuide:{
			data:"StoryGuideCreateInput"
		},
		deleteStoryGuide:{
			by:"StoryGuideUniqueWhere",
			filter:"StoryGuideWhere"
		},
		updateStoryGuide:{
			by:"StoryGuideUniqueWhere",
			filter:"StoryGuideWhere",
			data:"StoryGuideUpdateInput"
		},
		upsertStoryGuide:{
			by:"StoryGuideUniqueWhere",
			filter:"StoryGuideWhere",
			update:"StoryGuideUpdateInput",
			create:"StoryGuideCreateInput"
		},
		createStoryGuideItem:{
			data:"StoryGuideItemCreateInput"
		},
		deleteStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			filter:"StoryGuideItemWhere"
		},
		updateStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			filter:"StoryGuideItemWhere",
			data:"StoryGuideItemUpdateInput"
		},
		upsertStoryGuideItem:{
			by:"StoryGuideItemUniqueWhere",
			filter:"StoryGuideItemWhere",
			update:"StoryGuideItemUpdateInput",
			create:"StoryGuideItemCreateInput"
		},
		createStoryGuideList:{
			data:"StoryGuideListCreateInput"
		},
		deleteStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			filter:"StoryGuideListWhere"
		},
		updateStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			filter:"StoryGuideListWhere",
			data:"StoryGuideListUpdateInput"
		},
		upsertStoryGuideList:{
			by:"StoryGuideListUniqueWhere",
			filter:"StoryGuideListWhere",
			update:"StoryGuideListUpdateInput",
			create:"StoryGuideListCreateInput"
		},
		createHeroCarousel:{
			data:"HeroCarouselCreateInput"
		},
		deleteHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			filter:"HeroCarouselWhere"
		},
		updateHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			filter:"HeroCarouselWhere",
			data:"HeroCarouselUpdateInput"
		},
		upsertHeroCarousel:{
			by:"HeroCarouselUniqueWhere",
			filter:"HeroCarouselWhere",
			update:"HeroCarouselUpdateInput",
			create:"HeroCarouselCreateInput"
		},
		createPostOrganizationList:{
			data:"PostOrganizationListCreateInput"
		},
		deletePostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			filter:"PostOrganizationListWhere"
		},
		updatePostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			filter:"PostOrganizationListWhere",
			data:"PostOrganizationListUpdateInput"
		},
		upsertPostOrganizationList:{
			by:"PostOrganizationListUniqueWhere",
			filter:"PostOrganizationListWhere",
			update:"PostOrganizationListUpdateInput",
			create:"PostOrganizationListCreateInput"
		},
		createPostOrganizationListItem:{
			data:"PostOrganizationListItemCreateInput"
		},
		deletePostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			filter:"PostOrganizationListItemWhere"
		},
		updatePostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			filter:"PostOrganizationListItemWhere",
			data:"PostOrganizationListItemUpdateInput"
		},
		upsertPostOrganizationListItem:{
			by:"PostOrganizationListItemUniqueWhere",
			filter:"PostOrganizationListItemWhere",
			update:"PostOrganizationListItemUpdateInput",
			create:"PostOrganizationListItemCreateInput"
		},
		createInfoCarousel:{
			data:"InfoCarouselCreateInput"
		},
		deleteInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			filter:"InfoCarouselWhere"
		},
		updateInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			filter:"InfoCarouselWhere",
			data:"InfoCarouselUpdateInput"
		},
		upsertInfoCarousel:{
			by:"InfoCarouselUniqueWhere",
			filter:"InfoCarouselWhere",
			update:"InfoCarouselUpdateInput",
			create:"InfoCarouselCreateInput"
		},
		createInfoCarouselItem:{
			data:"InfoCarouselItemCreateInput"
		},
		deleteInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			filter:"InfoCarouselItemWhere"
		},
		updateInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			filter:"InfoCarouselItemWhere",
			data:"InfoCarouselItemUpdateInput"
		},
		upsertInfoCarouselItem:{
			by:"InfoCarouselItemUniqueWhere",
			filter:"InfoCarouselItemWhere",
			update:"InfoCarouselItemUpdateInput",
			create:"InfoCarouselItemCreateInput"
		},
		createPersonSeenInfoCarousel:{
			data:"PersonSeenInfoCarouselCreateInput"
		},
		deletePersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere"
		},
		updatePersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere",
			data:"PersonSeenInfoCarouselUpdateInput"
		},
		upsertPersonSeenInfoCarousel:{
			by:"PersonSeenInfoCarouselUniqueWhere",
			filter:"PersonSeenInfoCarouselWhere",
			update:"PersonSeenInfoCarouselUpdateInput",
			create:"PersonSeenInfoCarouselCreateInput"
		},
		createGivenGiftsPage:{
			data:"GivenGiftsPageCreateInput"
		},
		deleteGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			filter:"GivenGiftsPageWhere"
		},
		updateGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			filter:"GivenGiftsPageWhere",
			data:"GivenGiftsPageUpdateInput"
		},
		upsertGivenGiftsPage:{
			by:"GivenGiftsPageUniqueWhere",
			filter:"GivenGiftsPageWhere",
			update:"GivenGiftsPageUpdateInput",
			create:"GivenGiftsPageCreateInput"
		},
		createGivenGiftsPageLocale:{
			data:"GivenGiftsPageLocaleCreateInput"
		},
		deleteGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere"
		},
		updateGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere",
			data:"GivenGiftsPageLocaleUpdateInput"
		},
		upsertGivenGiftsPageLocale:{
			by:"GivenGiftsPageLocaleUniqueWhere",
			filter:"GivenGiftsPageLocaleWhere",
			update:"GivenGiftsPageLocaleUpdateInput",
			create:"GivenGiftsPageLocaleCreateInput"
		},
		createReceivedGiftsPage:{
			data:"ReceivedGiftsPageCreateInput"
		},
		deleteReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			filter:"ReceivedGiftsPageWhere"
		},
		updateReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			filter:"ReceivedGiftsPageWhere",
			data:"ReceivedGiftsPageUpdateInput"
		},
		upsertReceivedGiftsPage:{
			by:"ReceivedGiftsPageUniqueWhere",
			filter:"ReceivedGiftsPageWhere",
			update:"ReceivedGiftsPageUpdateInput",
			create:"ReceivedGiftsPageCreateInput"
		},
		createReceivedGiftsPageLocale:{
			data:"ReceivedGiftsPageLocaleCreateInput"
		},
		deleteReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere"
		},
		updateReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere",
			data:"ReceivedGiftsPageLocaleUpdateInput"
		},
		upsertReceivedGiftsPageLocale:{
			by:"ReceivedGiftsPageLocaleUniqueWhere",
			filter:"ReceivedGiftsPageLocaleWhere",
			update:"ReceivedGiftsPageLocaleUpdateInput",
			create:"ReceivedGiftsPageLocaleCreateInput"
		},
		createReportNavigation:{
			data:"ReportNavigationCreateInput"
		},
		deleteReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			filter:"ReportNavigationWhere"
		},
		updateReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			filter:"ReportNavigationWhere",
			data:"ReportNavigationUpdateInput"
		},
		upsertReportNavigation:{
			by:"ReportNavigationUniqueWhere",
			filter:"ReportNavigationWhere",
			update:"ReportNavigationUpdateInput",
			create:"ReportNavigationCreateInput"
		},
		createReportPage:{
			data:"ReportPageCreateInput"
		},
		deleteReportPage:{
			by:"ReportPageUniqueWhere",
			filter:"ReportPageWhere"
		},
		updateReportPage:{
			by:"ReportPageUniqueWhere",
			filter:"ReportPageWhere",
			data:"ReportPageUpdateInput"
		},
		upsertReportPage:{
			by:"ReportPageUniqueWhere",
			filter:"ReportPageWhere",
			update:"ReportPageUpdateInput",
			create:"ReportPageCreateInput"
		},
		createReportPageLocale:{
			data:"ReportPageLocaleCreateInput"
		},
		deleteReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere"
		},
		updateReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere",
			data:"ReportPageLocaleUpdateInput"
		},
		upsertReportPageLocale:{
			by:"ReportPageLocaleUniqueWhere",
			filter:"ReportPageLocaleWhere",
			update:"ReportPageLocaleUpdateInput",
			create:"ReportPageLocaleCreateInput"
		},
		createReportNavigationLocale:{
			data:"ReportNavigationLocaleCreateInput"
		},
		deleteReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere"
		},
		updateReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere",
			data:"ReportNavigationLocaleUpdateInput"
		},
		upsertReportNavigationLocale:{
			by:"ReportNavigationLocaleUniqueWhere",
			filter:"ReportNavigationLocaleWhere",
			update:"ReportNavigationLocaleUpdateInput",
			create:"ReportNavigationLocaleCreateInput"
		},
		createSentPayment:{
			data:"SentPaymentCreateInput"
		},
		deleteSentPayment:{
			by:"SentPaymentUniqueWhere",
			filter:"SentPaymentWhere"
		},
		updateSentPayment:{
			by:"SentPaymentUniqueWhere",
			filter:"SentPaymentWhere",
			data:"SentPaymentUpdateInput"
		},
		upsertSentPayment:{
			by:"SentPaymentUniqueWhere",
			filter:"SentPaymentWhere",
			update:"SentPaymentUpdateInput",
			create:"SentPaymentCreateInput"
		},
		createNotificationTargetGroup:{
			data:"NotificationTargetGroupCreateInput"
		},
		deleteNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			filter:"NotificationTargetGroupWhere"
		},
		updateNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			filter:"NotificationTargetGroupWhere",
			data:"NotificationTargetGroupUpdateInput"
		},
		upsertNotificationTargetGroup:{
			by:"NotificationTargetGroupUniqueWhere",
			filter:"NotificationTargetGroupWhere",
			update:"NotificationTargetGroupUpdateInput",
			create:"NotificationTargetGroupCreateInput"
		},
		createProcessedNotification:{
			data:"ProcessedNotificationCreateInput"
		},
		deleteProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationWhere"
		},
		updateProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationWhere",
			data:"ProcessedNotificationUpdateInput"
		},
		upsertProcessedNotification:{
			by:"ProcessedNotificationUniqueWhere",
			filter:"ProcessedNotificationWhere",
			update:"ProcessedNotificationUpdateInput",
			create:"ProcessedNotificationCreateInput"
		},
		createScheduledNotification:{
			data:"ScheduledNotificationCreateInput"
		},
		deleteScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			filter:"ScheduledNotificationWhere"
		},
		updateScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			filter:"ScheduledNotificationWhere",
			data:"ScheduledNotificationUpdateInput"
		},
		upsertScheduledNotification:{
			by:"ScheduledNotificationUniqueWhere",
			filter:"ScheduledNotificationWhere",
			update:"ScheduledNotificationUpdateInput",
			create:"ScheduledNotificationCreateInput"
		},
		createProcessedNotificationSource:{
			data:"ProcessedNotificationSourceCreateInput"
		},
		deleteProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			filter:"ProcessedNotificationSourceWhere"
		},
		updateProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			filter:"ProcessedNotificationSourceWhere",
			data:"ProcessedNotificationSourceUpdateInput"
		},
		upsertProcessedNotificationSource:{
			by:"ProcessedNotificationSourceUniqueWhere",
			filter:"ProcessedNotificationSourceWhere",
			update:"ProcessedNotificationSourceUpdateInput",
			create:"ProcessedNotificationSourceCreateInput"
		},
		createDevice:{
			data:"DeviceCreateInput"
		},
		deleteDevice:{
			by:"DeviceUniqueWhere",
			filter:"DeviceWhere"
		},
		updateDevice:{
			by:"DeviceUniqueWhere",
			filter:"DeviceWhere",
			data:"DeviceUpdateInput"
		},
		upsertDevice:{
			by:"DeviceUniqueWhere",
			filter:"DeviceWhere",
			update:"DeviceUpdateInput",
			create:"DeviceCreateInput"
		},
		createScheduledNotificationLocale:{
			data:"ScheduledNotificationLocaleCreateInput"
		},
		deleteScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere"
		},
		updateScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere",
			data:"ScheduledNotificationLocaleUpdateInput"
		},
		upsertScheduledNotificationLocale:{
			by:"ScheduledNotificationLocaleUniqueWhere",
			filter:"ScheduledNotificationLocaleWhere",
			update:"ScheduledNotificationLocaleUpdateInput",
			create:"ScheduledNotificationLocaleCreateInput"
		},
		createInfoCarouselItemLocale:{
			data:"InfoCarouselItemLocaleCreateInput"
		},
		deleteInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere"
		},
		updateInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere",
			data:"InfoCarouselItemLocaleUpdateInput"
		},
		upsertInfoCarouselItemLocale:{
			by:"InfoCarouselItemLocaleUniqueWhere",
			filter:"InfoCarouselItemLocaleWhere",
			update:"InfoCarouselItemLocaleUpdateInput",
			create:"InfoCarouselItemLocaleCreateInput"
		},
		createSentPaymentLocale:{
			data:"SentPaymentLocaleCreateInput"
		},
		deleteSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere"
		},
		updateSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere",
			data:"SentPaymentLocaleUpdateInput"
		},
		upsertSentPaymentLocale:{
			by:"SentPaymentLocaleUniqueWhere",
			filter:"SentPaymentLocaleWhere",
			update:"SentPaymentLocaleUpdateInput",
			create:"SentPaymentLocaleCreateInput"
		},
		createTextImageList:{
			data:"TextImageListCreateInput"
		},
		deleteTextImageList:{
			by:"TextImageListUniqueWhere",
			filter:"TextImageListWhere"
		},
		updateTextImageList:{
			by:"TextImageListUniqueWhere",
			filter:"TextImageListWhere",
			data:"TextImageListUpdateInput"
		},
		upsertTextImageList:{
			by:"TextImageListUniqueWhere",
			filter:"TextImageListWhere",
			update:"TextImageListUpdateInput",
			create:"TextImageListCreateInput"
		},
		createTextImageListItem:{
			data:"TextImageListItemCreateInput"
		},
		deleteTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			filter:"TextImageListItemWhere"
		},
		updateTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			filter:"TextImageListItemWhere",
			data:"TextImageListItemUpdateInput"
		},
		upsertTextImageListItem:{
			by:"TextImageListItemUniqueWhere",
			filter:"TextImageListItemWhere",
			update:"TextImageListItemUpdateInput",
			create:"TextImageListItemCreateInput"
		},
		createHeroCarouselItem:{
			data:"HeroCarouselItemCreateInput"
		},
		deleteHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			filter:"HeroCarouselItemWhere"
		},
		updateHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			filter:"HeroCarouselItemWhere",
			data:"HeroCarouselItemUpdateInput"
		},
		upsertHeroCarouselItem:{
			by:"HeroCarouselItemUniqueWhere",
			filter:"HeroCarouselItemWhere",
			update:"HeroCarouselItemUpdateInput",
			create:"HeroCarouselItemCreateInput"
		}
	},
	MutationTransactionOptions:{

	}
}

export const ReturnTypes: Record<string,any> = {
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_RuleMessage:{
		text:"String"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	Json: `scalar.Json` as const,
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	Query:{
		schema:"_Schema",
		s3DummyQuery:"String",
		getGeneral:"General",
		listGeneral:"General",
		paginateGeneral:"GeneralConnection",
		validateCreateGeneral:"_ValidationResult",
		validateUpdateGeneral:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getGenericPage:"GenericPage",
		listGenericPage:"GenericPage",
		paginateGenericPage:"GenericPageConnection",
		validateCreateGenericPage:"_ValidationResult",
		validateUpdateGenericPage:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getContentReferenceLinkableItem:"ContentReferenceLinkableItem",
		listContentReferenceLinkableItem:"ContentReferenceLinkableItem",
		paginateContentReferenceLinkableItem:"ContentReferenceLinkableItemConnection",
		getGeneralLocale:"GeneralLocale",
		listGeneralLocale:"GeneralLocale",
		paginateGeneralLocale:"GeneralLocaleConnection",
		validateCreateGeneralLocale:"_ValidationResult",
		validateUpdateGeneralLocale:"_ValidationResult",
		getGenericPageLocale:"GenericPageLocale",
		listGenericPageLocale:"GenericPageLocale",
		paginateGenericPageLocale:"GenericPageLocaleConnection",
		validateCreateGenericPageLocale:"_ValidationResult",
		validateUpdateGenericPageLocale:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getPost:"Post",
		listPost:"Post",
		paginatePost:"PostConnection",
		validateCreatePost:"_ValidationResult",
		validateUpdatePost:"_ValidationResult",
		getPostLocale:"PostLocale",
		listPostLocale:"PostLocale",
		paginatePostLocale:"PostLocaleConnection",
		validateCreatePostLocale:"_ValidationResult",
		validateUpdatePostLocale:"_ValidationResult",
		getPostArea:"PostArea",
		listPostArea:"PostArea",
		paginatePostArea:"PostAreaConnection",
		validateCreatePostArea:"_ValidationResult",
		validateUpdatePostArea:"_ValidationResult",
		getPostAreaLocale:"PostAreaLocale",
		listPostAreaLocale:"PostAreaLocale",
		paginatePostAreaLocale:"PostAreaLocaleConnection",
		validateCreatePostAreaLocale:"_ValidationResult",
		validateUpdatePostAreaLocale:"_ValidationResult",
		getPostOrganization:"PostOrganization",
		listPostOrganization:"PostOrganization",
		paginatePostOrganization:"PostOrganizationConnection",
		validateCreatePostOrganization:"_ValidationResult",
		validateUpdatePostOrganization:"_ValidationResult",
		getPostOrganizationLocale:"PostOrganizationLocale",
		listPostOrganizationLocale:"PostOrganizationLocale",
		paginatePostOrganizationLocale:"PostOrganizationLocaleConnection",
		validateCreatePostOrganizationLocale:"_ValidationResult",
		validateUpdatePostOrganizationLocale:"_ValidationResult",
		getDonation:"Donation",
		listDonation:"Donation",
		paginateDonation:"DonationConnection",
		validateCreateDonation:"_ValidationResult",
		validateUpdateDonation:"_ValidationResult",
		getDonationAmountItem:"DonationAmountItem",
		listDonationAmountItem:"DonationAmountItem",
		paginateDonationAmountItem:"DonationAmountItemConnection",
		validateCreateDonationAmountItem:"_ValidationResult",
		validateUpdateDonationAmountItem:"_ValidationResult",
		getDonationAmountsRegionItem:"DonationAmountsRegionItem",
		listDonationAmountsRegionItem:"DonationAmountsRegionItem",
		paginateDonationAmountsRegionItem:"DonationAmountsRegionItemConnection",
		validateCreateDonationAmountsRegionItem:"_ValidationResult",
		validateUpdateDonationAmountsRegionItem:"_ValidationResult",
		getDonationAmountsRegionList:"DonationAmountsRegionList",
		listDonationAmountsRegionList:"DonationAmountsRegionList",
		paginateDonationAmountsRegionList:"DonationAmountsRegionListConnection",
		validateCreateDonationAmountsRegionList:"_ValidationResult",
		validateUpdateDonationAmountsRegionList:"_ValidationResult",
		getRegion:"Region",
		listRegion:"Region",
		paginateRegion:"RegionConnection",
		validateCreateRegion:"_ValidationResult",
		validateUpdateRegion:"_ValidationResult",
		getLinkItem:"LinkItem",
		listLinkItem:"LinkItem",
		paginateLinkItem:"LinkItemConnection",
		validateCreateLinkItem:"_ValidationResult",
		validateUpdateLinkItem:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLocale:"HeaderLocale",
		listHeaderLocale:"HeaderLocale",
		paginateHeaderLocale:"HeaderLocaleConnection",
		validateCreateHeaderLocale:"_ValidationResult",
		validateUpdateHeaderLocale:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterLocale:"FooterLocale",
		listFooterLocale:"FooterLocale",
		paginateFooterLocale:"FooterLocaleConnection",
		validateCreateFooterLocale:"_ValidationResult",
		validateUpdateFooterLocale:"_ValidationResult",
		getPostList:"PostList",
		listPostList:"PostList",
		paginatePostList:"PostListConnection",
		validateCreatePostList:"_ValidationResult",
		validateUpdatePostList:"_ValidationResult",
		getPostListItem:"PostListItem",
		listPostListItem:"PostListItem",
		paginatePostListItem:"PostListItemConnection",
		validateCreatePostListItem:"_ValidationResult",
		validateUpdatePostListItem:"_ValidationResult",
		getAppBanner:"AppBanner",
		listAppBanner:"AppBanner",
		paginateAppBanner:"AppBannerConnection",
		validateCreateAppBanner:"_ValidationResult",
		validateUpdateAppBanner:"_ValidationResult",
		getGenericPageAboutSettings:"GenericPageAboutSettings",
		listGenericPageAboutSettings:"GenericPageAboutSettings",
		paginateGenericPageAboutSettings:"GenericPageAboutSettingsConnection",
		validateCreateGenericPageAboutSettings:"_ValidationResult",
		validateUpdateGenericPageAboutSettings:"_ValidationResult",
		getGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocale",
		listGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocale",
		paginateGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleConnection",
		validateCreateGenericPageAboutSettingsLocale:"_ValidationResult",
		validateUpdateGenericPageAboutSettingsLocale:"_ValidationResult",
		getValue:"Value",
		listValue:"Value",
		paginateValue:"ValueConnection",
		validateCreateValue:"_ValidationResult",
		validateUpdateValue:"_ValidationResult",
		getValueItem:"ValueItem",
		listValueItem:"ValueItem",
		paginateValueItem:"ValueItemConnection",
		validateCreateValueItem:"_ValidationResult",
		validateUpdateValueItem:"_ValidationResult",
		getValueList:"ValueList",
		listValueList:"ValueList",
		paginateValueList:"ValueListConnection",
		validateCreateValueList:"_ValidationResult",
		validateUpdateValueList:"_ValidationResult",
		getImageLink:"ImageLink",
		listImageLink:"ImageLink",
		paginateImageLink:"ImageLinkConnection",
		validateCreateImageLink:"_ValidationResult",
		validateUpdateImageLink:"_ValidationResult",
		getImageLinkItem:"ImageLinkItem",
		listImageLinkItem:"ImageLinkItem",
		paginateImageLinkItem:"ImageLinkItemConnection",
		validateCreateImageLinkItem:"_ValidationResult",
		validateUpdateImageLinkItem:"_ValidationResult",
		getImageLinkList:"ImageLinkList",
		listImageLinkList:"ImageLinkList",
		paginateImageLinkList:"ImageLinkListConnection",
		validateCreateImageLinkList:"_ValidationResult",
		validateUpdateImageLinkList:"_ValidationResult",
		getPostAreaList:"PostAreaList",
		listPostAreaList:"PostAreaList",
		paginatePostAreaList:"PostAreaListConnection",
		validateCreatePostAreaList:"_ValidationResult",
		validateUpdatePostAreaList:"_ValidationResult",
		getPostAreaListItem:"PostAreaListItem",
		listPostAreaListItem:"PostAreaListItem",
		paginatePostAreaListItem:"PostAreaListItemConnection",
		validateCreatePostAreaListItem:"_ValidationResult",
		validateUpdatePostAreaListItem:"_ValidationResult",
		getAccordion:"Accordion",
		listAccordion:"Accordion",
		paginateAccordion:"AccordionConnection",
		validateCreateAccordion:"_ValidationResult",
		validateUpdateAccordion:"_ValidationResult",
		getAccordionItem:"AccordionItem",
		listAccordionItem:"AccordionItem",
		paginateAccordionItem:"AccordionItemConnection",
		validateCreateAccordionItem:"_ValidationResult",
		validateUpdateAccordionItem:"_ValidationResult",
		getUser:"User",
		listUser:"User",
		paginateUser:"UserConnection",
		validateCreateUser:"_ValidationResult",
		validateUpdateUser:"_ValidationResult",
		getUserPayment:"UserPayment",
		listUserPayment:"UserPayment",
		paginateUserPayment:"UserPaymentConnection",
		validateCreateUserPayment:"_ValidationResult",
		validateUpdateUserPayment:"_ValidationResult",
		getCurrency:"Currency",
		listCurrency:"Currency",
		paginateCurrency:"CurrencyConnection",
		validateCreateCurrency:"_ValidationResult",
		validateUpdateCurrency:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getMediumItem:"MediumItem",
		listMediumItem:"MediumItem",
		paginateMediumItem:"MediumItemConnection",
		validateCreateMediumItem:"_ValidationResult",
		validateUpdateMediumItem:"_ValidationResult",
		getMediumList:"MediumList",
		listMediumList:"MediumList",
		paginateMediumList:"MediumListConnection",
		validateCreateMediumList:"_ValidationResult",
		validateUpdateMediumList:"_ValidationResult",
		getUserPaymentOrderId:"UserPaymentOrderId",
		listUserPaymentOrderId:"UserPaymentOrderId",
		paginateUserPaymentOrderId:"UserPaymentOrderIdConnection",
		validateCreateUserPaymentOrderId:"_ValidationResult",
		validateUpdateUserPaymentOrderId:"_ValidationResult",
		getPostRevision:"PostRevision",
		listPostRevision:"PostRevision",
		paginatePostRevision:"PostRevisionConnection",
		validateCreatePostRevision:"_ValidationResult",
		validateUpdatePostRevision:"_ValidationResult",
		getUserRecurringPayment:"UserRecurringPayment",
		listUserRecurringPayment:"UserRecurringPayment",
		paginateUserRecurringPayment:"UserRecurringPaymentConnection",
		validateCreateUserRecurringPayment:"_ValidationResult",
		validateUpdateUserRecurringPayment:"_ValidationResult",
		getUserRecurringPaymentItem:"UserRecurringPaymentItem",
		listUserRecurringPaymentItem:"UserRecurringPaymentItem",
		paginateUserRecurringPaymentItem:"UserRecurringPaymentItemConnection",
		validateCreateUserRecurringPaymentItem:"_ValidationResult",
		validateUpdateUserRecurringPaymentItem:"_ValidationResult",
		getPostRevisionLocale:"PostRevisionLocale",
		listPostRevisionLocale:"PostRevisionLocale",
		paginatePostRevisionLocale:"PostRevisionLocaleConnection",
		validateCreatePostRevisionLocale:"_ValidationResult",
		validateUpdatePostRevisionLocale:"_ValidationResult",
		getTranslationCatalogue:"TranslationCatalogue",
		listTranslationCatalogue:"TranslationCatalogue",
		paginateTranslationCatalogue:"TranslationCatalogueConnection",
		validateCreateTranslationCatalogue:"_ValidationResult",
		validateUpdateTranslationCatalogue:"_ValidationResult",
		getTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		listTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		paginateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierConnection",
		validateCreateTranslationCataloguesIdentifier:"_ValidationResult",
		validateUpdateTranslationCataloguesIdentifier:"_ValidationResult",
		getTranslationDomain:"TranslationDomain",
		listTranslationDomain:"TranslationDomain",
		paginateTranslationDomain:"TranslationDomainConnection",
		validateCreateTranslationDomain:"_ValidationResult",
		validateUpdateTranslationDomain:"_ValidationResult",
		getTranslationKey:"TranslationKey",
		listTranslationKey:"TranslationKey",
		paginateTranslationKey:"TranslationKeyConnection",
		validateCreateTranslationKey:"_ValidationResult",
		validateUpdateTranslationKey:"_ValidationResult",
		getTranslationValue:"TranslationValue",
		listTranslationValue:"TranslationValue",
		paginateTranslationValue:"TranslationValueConnection",
		validateCreateTranslationValue:"_ValidationResult",
		validateUpdateTranslationValue:"_ValidationResult",
		getGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocale",
		listGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocale",
		paginateGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleConnection",
		validateCreateGenericPageAboutGroupLinksLocale:"_ValidationResult",
		validateUpdateGenericPageAboutGroupLinksLocale:"_ValidationResult",
		getMemberList:"MemberList",
		listMemberList:"MemberList",
		paginateMemberList:"MemberListConnection",
		validateCreateMemberList:"_ValidationResult",
		validateUpdateMemberList:"_ValidationResult",
		getMemberListItem:"MemberListItem",
		listMemberListItem:"MemberListItem",
		paginateMemberListItem:"MemberListItemConnection",
		validateCreateMemberListItem:"_ValidationResult",
		validateUpdateMemberListItem:"_ValidationResult",
		getFilledTaxForm:"FilledTaxForm",
		listFilledTaxForm:"FilledTaxForm",
		paginateFilledTaxForm:"FilledTaxFormConnection",
		validateCreateFilledTaxForm:"_ValidationResult",
		validateUpdateFilledTaxForm:"_ValidationResult",
		getFilledTaxFormEmailAddress:"FilledTaxFormEmailAddress",
		listFilledTaxFormEmailAddress:"FilledTaxFormEmailAddress",
		paginateFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressConnection",
		validateCreateFilledTaxFormEmailAddress:"_ValidationResult",
		validateUpdateFilledTaxFormEmailAddress:"_ValidationResult",
		getForm:"Form",
		listForm:"Form",
		paginateForm:"FormConnection",
		validateCreateForm:"_ValidationResult",
		validateUpdateForm:"_ValidationResult",
		getCsobPayment:"CsobPayment",
		listCsobPayment:"CsobPayment",
		paginateCsobPayment:"CsobPaymentConnection",
		validateCreateCsobPayment:"_ValidationResult",
		validateUpdateCsobPayment:"_ValidationResult",
		getCsobPaymentStatusChange:"CsobPaymentStatusChange",
		listCsobPaymentStatusChange:"CsobPaymentStatusChange",
		paginateCsobPaymentStatusChange:"CsobPaymentStatusChangeConnection",
		validateCreateCsobPaymentStatusChange:"_ValidationResult",
		validateUpdateCsobPaymentStatusChange:"_ValidationResult",
		getStripePayment:"StripePayment",
		listStripePayment:"StripePayment",
		paginateStripePayment:"StripePaymentConnection",
		validateCreateStripePayment:"_ValidationResult",
		validateUpdateStripePayment:"_ValidationResult",
		getStripePaymentStatusChange:"StripePaymentStatusChange",
		listStripePaymentStatusChange:"StripePaymentStatusChange",
		paginateStripePaymentStatusChange:"StripePaymentStatusChangeConnection",
		validateCreateStripePaymentStatusChange:"_ValidationResult",
		validateUpdateStripePaymentStatusChange:"_ValidationResult",
		getRegionPaymentMethod:"RegionPaymentMethod",
		listRegionPaymentMethod:"RegionPaymentMethod",
		paginateRegionPaymentMethod:"RegionPaymentMethodConnection",
		validateCreateRegionPaymentMethod:"_ValidationResult",
		validateUpdateRegionPaymentMethod:"_ValidationResult",
		getPostAreaMetaData:"PostAreaMetaData",
		listPostAreaMetaData:"PostAreaMetaData",
		paginatePostAreaMetaData:"PostAreaMetaDataConnection",
		getPostMetaData:"PostMetaData",
		listPostMetaData:"PostMetaData",
		paginatePostMetaData:"PostMetaDataConnection",
		getPostOrganizationMetaData:"PostOrganizationMetaData",
		listPostOrganizationMetaData:"PostOrganizationMetaData",
		paginatePostOrganizationMetaData:"PostOrganizationMetaDataConnection",
		getTileItem:"TileItem",
		listTileItem:"TileItem",
		paginateTileItem:"TileItemConnection",
		validateCreateTileItem:"_ValidationResult",
		validateUpdateTileItem:"_ValidationResult",
		getTileList:"TileList",
		listTileList:"TileList",
		paginateTileList:"TileListConnection",
		validateCreateTileList:"_ValidationResult",
		validateUpdateTileList:"_ValidationResult",
		getFeedPage:"FeedPage",
		listFeedPage:"FeedPage",
		paginateFeedPage:"FeedPageConnection",
		validateCreateFeedPage:"_ValidationResult",
		validateUpdateFeedPage:"_ValidationResult",
		getFeedPageLocale:"FeedPageLocale",
		listFeedPageLocale:"FeedPageLocale",
		paginateFeedPageLocale:"FeedPageLocaleConnection",
		validateCreateFeedPageLocale:"_ValidationResult",
		validateUpdateFeedPageLocale:"_ValidationResult",
		getFeedPageSection:"FeedPageSection",
		listFeedPageSection:"FeedPageSection",
		paginateFeedPageSection:"FeedPageSectionConnection",
		validateCreateFeedPageSection:"_ValidationResult",
		validateUpdateFeedPageSection:"_ValidationResult",
		getFeedPageTileStripe:"FeedPageTileStripe",
		listFeedPageTileStripe:"FeedPageTileStripe",
		paginateFeedPageTileStripe:"FeedPageTileStripeConnection",
		validateCreateFeedPageTileStripe:"_ValidationResult",
		validateUpdateFeedPageTileStripe:"_ValidationResult",
		getCardItem:"CardItem",
		listCardItem:"CardItem",
		paginateCardItem:"CardItemConnection",
		validateCreateCardItem:"_ValidationResult",
		validateUpdateCardItem:"_ValidationResult",
		getCardList:"CardList",
		listCardList:"CardList",
		paginateCardList:"CardListConnection",
		validateCreateCardList:"_ValidationResult",
		validateUpdateCardList:"_ValidationResult",
		getOnBehalfDonation:"OnBehalfDonation",
		listOnBehalfDonation:"OnBehalfDonation",
		paginateOnBehalfDonation:"OnBehalfDonationConnection",
		validateCreateOnBehalfDonation:"_ValidationResult",
		validateUpdateOnBehalfDonation:"_ValidationResult",
		getUserPaymentTriesCollection:"UserPaymentTriesCollection",
		listUserPaymentTriesCollection:"UserPaymentTriesCollection",
		paginateUserPaymentTriesCollection:"UserPaymentTriesCollectionConnection",
		validateCreateUserPaymentTriesCollection:"_ValidationResult",
		validateUpdateUserPaymentTriesCollection:"_ValidationResult",
		getRecurringPaymentPage:"RecurringPaymentPage",
		listRecurringPaymentPage:"RecurringPaymentPage",
		paginateRecurringPaymentPage:"RecurringPaymentPageConnection",
		validateCreateRecurringPaymentPage:"_ValidationResult",
		validateUpdateRecurringPaymentPage:"_ValidationResult",
		getRecurringPaymentPageLocale:"RecurringPaymentPageLocale",
		listRecurringPaymentPageLocale:"RecurringPaymentPageLocale",
		paginateRecurringPaymentPageLocale:"RecurringPaymentPageLocaleConnection",
		validateCreateRecurringPaymentPageLocale:"_ValidationResult",
		validateUpdateRecurringPaymentPageLocale:"_ValidationResult",
		getStoryGuide:"StoryGuide",
		listStoryGuide:"StoryGuide",
		paginateStoryGuide:"StoryGuideConnection",
		validateCreateStoryGuide:"_ValidationResult",
		validateUpdateStoryGuide:"_ValidationResult",
		getStoryGuideItem:"StoryGuideItem",
		listStoryGuideItem:"StoryGuideItem",
		paginateStoryGuideItem:"StoryGuideItemConnection",
		validateCreateStoryGuideItem:"_ValidationResult",
		validateUpdateStoryGuideItem:"_ValidationResult",
		getStoryGuideList:"StoryGuideList",
		listStoryGuideList:"StoryGuideList",
		paginateStoryGuideList:"StoryGuideListConnection",
		validateCreateStoryGuideList:"_ValidationResult",
		validateUpdateStoryGuideList:"_ValidationResult",
		getStripePaymentMetadata:"StripePaymentMetadata",
		listStripePaymentMetadata:"StripePaymentMetadata",
		paginateStripePaymentMetadata:"StripePaymentMetadataConnection",
		getOnBehalfDonationMetadata:"OnBehalfDonationMetadata",
		listOnBehalfDonationMetadata:"OnBehalfDonationMetadata",
		paginateOnBehalfDonationMetadata:"OnBehalfDonationMetadataConnection",
		getUserPaymentTriesCollectionMetadata:"UserPaymentTriesCollectionMetadata",
		listUserPaymentTriesCollectionMetadata:"UserPaymentTriesCollectionMetadata",
		paginateUserPaymentTriesCollectionMetadata:"UserPaymentTriesCollectionMetadataConnection",
		getUserPaymentTriesCollectionMetadataLocale:"UserPaymentTriesCollectionMetadataLocale",
		listUserPaymentTriesCollectionMetadataLocale:"UserPaymentTriesCollectionMetadataLocale",
		paginateUserPaymentTriesCollectionMetadataLocale:"UserPaymentTriesCollectionMetadataLocaleConnection",
		getCsobPaymentMetadata:"CsobPaymentMetadata",
		listCsobPaymentMetadata:"CsobPaymentMetadata",
		paginateCsobPaymentMetadata:"CsobPaymentMetadataConnection",
		getHeroCarousel:"HeroCarousel",
		listHeroCarousel:"HeroCarousel",
		paginateHeroCarousel:"HeroCarouselConnection",
		validateCreateHeroCarousel:"_ValidationResult",
		validateUpdateHeroCarousel:"_ValidationResult",
		getPostOrganizationList:"PostOrganizationList",
		listPostOrganizationList:"PostOrganizationList",
		paginatePostOrganizationList:"PostOrganizationListConnection",
		validateCreatePostOrganizationList:"_ValidationResult",
		validateUpdatePostOrganizationList:"_ValidationResult",
		getPostOrganizationListItem:"PostOrganizationListItem",
		listPostOrganizationListItem:"PostOrganizationListItem",
		paginatePostOrganizationListItem:"PostOrganizationListItemConnection",
		validateCreatePostOrganizationListItem:"_ValidationResult",
		validateUpdatePostOrganizationListItem:"_ValidationResult",
		getInfoCarousel:"InfoCarousel",
		listInfoCarousel:"InfoCarousel",
		paginateInfoCarousel:"InfoCarouselConnection",
		validateCreateInfoCarousel:"_ValidationResult",
		validateUpdateInfoCarousel:"_ValidationResult",
		getInfoCarouselItem:"InfoCarouselItem",
		listInfoCarouselItem:"InfoCarouselItem",
		paginateInfoCarouselItem:"InfoCarouselItemConnection",
		validateCreateInfoCarouselItem:"_ValidationResult",
		validateUpdateInfoCarouselItem:"_ValidationResult",
		getPersonSeenInfoCarousel:"PersonSeenInfoCarousel",
		listPersonSeenInfoCarousel:"PersonSeenInfoCarousel",
		paginatePersonSeenInfoCarousel:"PersonSeenInfoCarouselConnection",
		validateCreatePersonSeenInfoCarousel:"_ValidationResult",
		validateUpdatePersonSeenInfoCarousel:"_ValidationResult",
		getGivenGiftsPage:"GivenGiftsPage",
		listGivenGiftsPage:"GivenGiftsPage",
		paginateGivenGiftsPage:"GivenGiftsPageConnection",
		validateCreateGivenGiftsPage:"_ValidationResult",
		validateUpdateGivenGiftsPage:"_ValidationResult",
		getGivenGiftsPageLocale:"GivenGiftsPageLocale",
		listGivenGiftsPageLocale:"GivenGiftsPageLocale",
		paginateGivenGiftsPageLocale:"GivenGiftsPageLocaleConnection",
		validateCreateGivenGiftsPageLocale:"_ValidationResult",
		validateUpdateGivenGiftsPageLocale:"_ValidationResult",
		getReceivedGiftsPage:"ReceivedGiftsPage",
		listReceivedGiftsPage:"ReceivedGiftsPage",
		paginateReceivedGiftsPage:"ReceivedGiftsPageConnection",
		validateCreateReceivedGiftsPage:"_ValidationResult",
		validateUpdateReceivedGiftsPage:"_ValidationResult",
		getReceivedGiftsPageLocale:"ReceivedGiftsPageLocale",
		listReceivedGiftsPageLocale:"ReceivedGiftsPageLocale",
		paginateReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleConnection",
		validateCreateReceivedGiftsPageLocale:"_ValidationResult",
		validateUpdateReceivedGiftsPageLocale:"_ValidationResult",
		getReportNavigation:"ReportNavigation",
		listReportNavigation:"ReportNavigation",
		paginateReportNavigation:"ReportNavigationConnection",
		validateCreateReportNavigation:"_ValidationResult",
		validateUpdateReportNavigation:"_ValidationResult",
		getReportPage:"ReportPage",
		listReportPage:"ReportPage",
		paginateReportPage:"ReportPageConnection",
		validateCreateReportPage:"_ValidationResult",
		validateUpdateReportPage:"_ValidationResult",
		getReportPageLocale:"ReportPageLocale",
		listReportPageLocale:"ReportPageLocale",
		paginateReportPageLocale:"ReportPageLocaleConnection",
		validateCreateReportPageLocale:"_ValidationResult",
		validateUpdateReportPageLocale:"_ValidationResult",
		getReportNavigationLocale:"ReportNavigationLocale",
		listReportNavigationLocale:"ReportNavigationLocale",
		paginateReportNavigationLocale:"ReportNavigationLocaleConnection",
		validateCreateReportNavigationLocale:"_ValidationResult",
		validateUpdateReportNavigationLocale:"_ValidationResult",
		getSentPayment:"SentPayment",
		listSentPayment:"SentPayment",
		paginateSentPayment:"SentPaymentConnection",
		validateCreateSentPayment:"_ValidationResult",
		validateUpdateSentPayment:"_ValidationResult",
		getPostAreaSentPaymentCurrencySum:"PostAreaSentPaymentCurrencySum",
		listPostAreaSentPaymentCurrencySum:"PostAreaSentPaymentCurrencySum",
		paginatePostAreaSentPaymentCurrencySum:"PostAreaSentPaymentCurrencySumConnection",
		getPostAreaSentPaymentSum:"PostAreaSentPaymentSum",
		listPostAreaSentPaymentSum:"PostAreaSentPaymentSum",
		paginatePostAreaSentPaymentSum:"PostAreaSentPaymentSumConnection",
		getNotificationTargetGroup:"NotificationTargetGroup",
		listNotificationTargetGroup:"NotificationTargetGroup",
		paginateNotificationTargetGroup:"NotificationTargetGroupConnection",
		validateCreateNotificationTargetGroup:"_ValidationResult",
		validateUpdateNotificationTargetGroup:"_ValidationResult",
		getProcessedNotification:"ProcessedNotification",
		listProcessedNotification:"ProcessedNotification",
		paginateProcessedNotification:"ProcessedNotificationConnection",
		validateCreateProcessedNotification:"_ValidationResult",
		validateUpdateProcessedNotification:"_ValidationResult",
		getScheduledNotification:"ScheduledNotification",
		listScheduledNotification:"ScheduledNotification",
		paginateScheduledNotification:"ScheduledNotificationConnection",
		validateCreateScheduledNotification:"_ValidationResult",
		validateUpdateScheduledNotification:"_ValidationResult",
		getProcessedNotificationSource:"ProcessedNotificationSource",
		listProcessedNotificationSource:"ProcessedNotificationSource",
		paginateProcessedNotificationSource:"ProcessedNotificationSourceConnection",
		validateCreateProcessedNotificationSource:"_ValidationResult",
		validateUpdateProcessedNotificationSource:"_ValidationResult",
		getDevice:"Device",
		listDevice:"Device",
		paginateDevice:"DeviceConnection",
		validateCreateDevice:"_ValidationResult",
		validateUpdateDevice:"_ValidationResult",
		getScheduledNotificationLocale:"ScheduledNotificationLocale",
		listScheduledNotificationLocale:"ScheduledNotificationLocale",
		paginateScheduledNotificationLocale:"ScheduledNotificationLocaleConnection",
		validateCreateScheduledNotificationLocale:"_ValidationResult",
		validateUpdateScheduledNotificationLocale:"_ValidationResult",
		getInfoCarouselItemLocale:"InfoCarouselItemLocale",
		listInfoCarouselItemLocale:"InfoCarouselItemLocale",
		paginateInfoCarouselItemLocale:"InfoCarouselItemLocaleConnection",
		validateCreateInfoCarouselItemLocale:"_ValidationResult",
		validateUpdateInfoCarouselItemLocale:"_ValidationResult",
		getSentPaymentLocale:"SentPaymentLocale",
		listSentPaymentLocale:"SentPaymentLocale",
		paginateSentPaymentLocale:"SentPaymentLocaleConnection",
		validateCreateSentPaymentLocale:"_ValidationResult",
		validateUpdateSentPaymentLocale:"_ValidationResult",
		getUserPaymentMetadata:"UserPaymentMetadata",
		listUserPaymentMetadata:"UserPaymentMetadata",
		paginateUserPaymentMetadata:"UserPaymentMetadataConnection",
		getPostAreaCurrencySum:"PostAreaCurrencySum",
		listPostAreaCurrencySum:"PostAreaCurrencySum",
		paginatePostAreaCurrencySum:"PostAreaCurrencySumConnection",
		getPostAreaSum:"PostAreaSum",
		listPostAreaSum:"PostAreaSum",
		paginatePostAreaSum:"PostAreaSumConnection",
		getPostOrganizationCurrencySum:"PostOrganizationCurrencySum",
		listPostOrganizationCurrencySum:"PostOrganizationCurrencySum",
		paginatePostOrganizationCurrencySum:"PostOrganizationCurrencySumConnection",
		getPostOrganizationSum:"PostOrganizationSum",
		listPostOrganizationSum:"PostOrganizationSum",
		paginatePostOrganizationSum:"PostOrganizationSumConnection",
		getStats:"Stats",
		listStats:"Stats",
		paginateStats:"StatsConnection",
		getUserRecurringPaymentItemMetadata:"UserRecurringPaymentItemMetadata",
		listUserRecurringPaymentItemMetadata:"UserRecurringPaymentItemMetadata",
		paginateUserRecurringPaymentItemMetadata:"UserRecurringPaymentItemMetadataConnection",
		getUpcomingUserRecurringPaymentMetadata:"UpcomingUserRecurringPaymentMetadata",
		listUpcomingUserRecurringPaymentMetadata:"UpcomingUserRecurringPaymentMetadata",
		paginateUpcomingUserRecurringPaymentMetadata:"UpcomingUserRecurringPaymentMetadataConnection",
		getUserAreaStats:"UserAreaStats",
		listUserAreaStats:"UserAreaStats",
		paginateUserAreaStats:"UserAreaStatsConnection",
		getUserCurrencyStats:"UserCurrencyStats",
		listUserCurrencyStats:"UserCurrencyStats",
		paginateUserCurrencyStats:"UserCurrencyStatsConnection",
		getUserOrganizationStats:"UserOrganizationStats",
		listUserOrganizationStats:"UserOrganizationStats",
		paginateUserOrganizationStats:"UserOrganizationStatsConnection",
		getUserPostStats:"UserPostStats",
		listUserPostStats:"UserPostStats",
		paginateUserPostStats:"UserPostStatsConnection",
		getUserStats:"UserStats",
		listUserStats:"UserStats",
		paginateUserStats:"UserStatsConnection",
		getTextImageList:"TextImageList",
		listTextImageList:"TextImageList",
		paginateTextImageList:"TextImageListConnection",
		validateCreateTextImageList:"_ValidationResult",
		validateUpdateTextImageList:"_ValidationResult",
		getTextImageListItem:"TextImageListItem",
		listTextImageListItem:"TextImageListItem",
		paginateTextImageListItem:"TextImageListItemConnection",
		validateCreateTextImageListItem:"_ValidationResult",
		validateUpdateTextImageListItem:"_ValidationResult",
		getPostCurrencySum:"PostCurrencySum",
		listPostCurrencySum:"PostCurrencySum",
		paginatePostCurrencySum:"PostCurrencySumConnection",
		getPostSum:"PostSum",
		listPostSum:"PostSum",
		paginatePostSum:"PostSumConnection",
		getPostFundraisingProgress:"PostFundraisingProgress",
		listPostFundraisingProgress:"PostFundraisingProgress",
		paginatePostFundraisingProgress:"PostFundraisingProgressConnection",
		getHeroCarouselItem:"HeroCarouselItem",
		listHeroCarouselItem:"HeroCarouselItem",
		paginateHeroCarouselItem:"HeroCarouselItemConnection",
		validateCreateHeroCarouselItem:"_ValidationResult",
		validateUpdateHeroCarouselItem:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	General:{
		_meta:"GeneralMeta",
		id:"UUID",
		unique:"One",
		locales:"GeneralLocale",
		allAreasIcon:"Image",
		allOrganizationsIcon:"Image",
		organizationList:"PostOrganizationList",
		localesByLocale:"GeneralLocale",
		localesBySeo:"GeneralLocale",
		localesByAppStoreLink:"GeneralLocale",
		localesByGooglePlayLink:"GeneralLocale",
		paginateLocales:"GeneralLocaleConnection"
	},
	GeneralMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		allAreasIcon:"FieldMeta",
		allOrganizationsIcon:"FieldMeta",
		organizationList:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	UUID: `scalar.UUID` as const,
	GeneralLocale:{
		_meta:"GeneralLocaleMeta",
		id:"UUID",
		root:"General",
		locale:"Locale",
		seo:"Seo",
		appStoreLink:"Link",
		googlePlayLink:"Link",
		allAreasDescription:"String",
		allOrganizationsDescription:"String"
	},
	GeneralLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta",
		appStoreLink:"FieldMeta",
		googlePlayLink:"FieldMeta",
		allAreasDescription:"FieldMeta",
		allOrganizationsDescription:"FieldMeta"
	},
	DateTime: `scalar.DateTime` as const,
	Date: `scalar.Date` as const,
	Locale:{
		_meta:"LocaleMeta",
		id:"UUID",
		code:"String",
		label:"String",
		order:"Int",
		generals:"GeneralLocale",
		genericPages:"GenericPageLocale",
		posts:"PostLocale",
		postAreas:"PostAreaLocale",
		postOrganizations:"PostOrganizationLocale",
		headers:"HeaderLocale",
		footers:"FooterLocale",
		genericPageAboutSettings:"GenericPageAboutSettingsLocale",
		postRevisions:"PostRevisionLocale",
		flagImage:"Image",
		feedPages:"FeedPageLocale",
		recurringPaymentPages:"RecurringPaymentPageLocale",
		givenGiftsPages:"GivenGiftsPageLocale",
		receivedGiftsPages:"ReceivedGiftsPageLocale",
		reportPages:"ReportPageLocale",
		reportNavigations:"ReportNavigationLocale",
		scheduledNotifications:"ScheduledNotificationLocale",
		sentPayments:"SentPaymentLocale",
		generalsByRoot:"GeneralLocale",
		generalsBySeo:"GeneralLocale",
		generalsByAppStoreLink:"GeneralLocale",
		generalsByGooglePlayLink:"GeneralLocale",
		genericPagesByRoot:"GenericPageLocale",
		genericPagesByContent:"GenericPageLocale",
		genericPagesBySeo:"GenericPageLocale",
		genericPagesByLink:"GenericPageLocale",
		postsByRoot:"PostLocale",
		postsByContent:"PostLocale",
		postsBySeo:"PostLocale",
		postsByLink:"PostLocale",
		postAreasByRoot:"PostAreaLocale",
		postAreasByLink:"PostAreaLocale",
		postAreasBySeo:"PostAreaLocale",
		postAreasByBanner:"PostAreaLocale",
		postAreasByContent:"PostAreaLocale",
		postOrganizationsByRoot:"PostOrganizationLocale",
		postOrganizationsByLink:"PostOrganizationLocale",
		postOrganizationsByDomain:"PostOrganizationLocale",
		postOrganizationsBySeo:"PostOrganizationLocale",
		postOrganizationsByContent:"PostOrganizationLocale",
		headersByRoot:"HeaderLocale",
		headersByLinks:"HeaderLocale",
		footersByRoot:"FooterLocale",
		footersByLinkList:"FooterLocale",
		footersByAddressInfo:"FooterLocale",
		footersByImageLinkList:"FooterLocale",
		genericPageAboutSettingsByRoot:"GenericPageAboutSettingsLocale",
		genericPageAboutSettingsByLinkGroups:"GenericPageAboutSettingsLocale",
		postRevisionsByRoot:"PostRevisionLocale",
		postRevisionsByContent:"PostRevisionLocale",
		postRevisionsBySeo:"PostRevisionLocale",
		postRevisionsByLeadContent:"PostRevisionLocale",
		feedPagesByRoot:"FeedPageLocale",
		feedPagesByHeroTiles:"FeedPageLocale",
		feedPagesBySectionList:"FeedPageLocale",
		feedPagesByCardList:"FeedPageLocale",
		feedPagesByStoryGuideList:"FeedPageLocale",
		recurringPaymentPagesByRoot:"RecurringPaymentPageLocale",
		recurringPaymentPagesByFavouritePosts:"RecurringPaymentPageLocale",
		recurringPaymentPagesByStoryGuideList:"RecurringPaymentPageLocale",
		givenGiftsPagesByRoot:"GivenGiftsPageLocale",
		givenGiftsPagesByContent:"GivenGiftsPageLocale",
		givenGiftsPagesBySeo:"GivenGiftsPageLocale",
		givenGiftsPagesByLink:"GivenGiftsPageLocale",
		receivedGiftsPagesByRoot:"ReceivedGiftsPageLocale",
		receivedGiftsPagesByLink:"ReceivedGiftsPageLocale",
		receivedGiftsPagesByContent:"ReceivedGiftsPageLocale",
		receivedGiftsPagesBySeo:"ReceivedGiftsPageLocale",
		reportPagesByRoot:"ReportPageLocale",
		reportPagesByLink:"ReportPageLocale",
		reportPagesByContent:"ReportPageLocale",
		reportPagesBySeo:"ReportPageLocale",
		reportNavigationsByRoot:"ReportNavigationLocale",
		scheduledNotificationsByRoot:"ScheduledNotificationLocale",
		sentPaymentsByRoot:"SentPaymentLocale",
		paginateGenerals:"GeneralLocaleConnection",
		paginateGenericPages:"GenericPageLocaleConnection",
		paginatePosts:"PostLocaleConnection",
		paginatePostAreas:"PostAreaLocaleConnection",
		paginatePostOrganizations:"PostOrganizationLocaleConnection",
		paginateHeaders:"HeaderLocaleConnection",
		paginateFooters:"FooterLocaleConnection",
		paginateGenericPageAboutSettings:"GenericPageAboutSettingsLocaleConnection",
		paginatePostRevisions:"PostRevisionLocaleConnection",
		paginateFeedPages:"FeedPageLocaleConnection",
		paginateRecurringPaymentPages:"RecurringPaymentPageLocaleConnection",
		paginateGivenGiftsPages:"GivenGiftsPageLocaleConnection",
		paginateReceivedGiftsPages:"ReceivedGiftsPageLocaleConnection",
		paginateReportPages:"ReportPageLocaleConnection",
		paginateReportNavigations:"ReportNavigationLocaleConnection",
		paginateScheduledNotifications:"ScheduledNotificationLocaleConnection",
		paginateSentPayments:"SentPaymentLocaleConnection"
	},
	LocaleMeta:{
		id:"FieldMeta",
		code:"FieldMeta",
		label:"FieldMeta",
		order:"FieldMeta",
		generals:"FieldMeta",
		genericPages:"FieldMeta",
		posts:"FieldMeta",
		postAreas:"FieldMeta",
		postOrganizations:"FieldMeta",
		headers:"FieldMeta",
		footers:"FieldMeta",
		genericPageAboutSettings:"FieldMeta",
		postRevisions:"FieldMeta",
		flagImage:"FieldMeta",
		feedPages:"FieldMeta",
		recurringPaymentPages:"FieldMeta",
		givenGiftsPages:"FieldMeta",
		receivedGiftsPages:"FieldMeta",
		reportPages:"FieldMeta",
		reportNavigations:"FieldMeta",
		scheduledNotifications:"FieldMeta",
		sentPayments:"FieldMeta"
	},
	GenericPageLocale:{
		_meta:"GenericPageLocaleMeta",
		id:"UUID",
		title:"String",
		root:"GenericPage",
		locale:"Locale",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		subtitle:"String"
	},
	GenericPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		subtitle:"FieldMeta"
	},
	GenericPage:{
		_meta:"GenericPageMeta",
		id:"UUID",
		locales:"GenericPageLocale",
		type:"GenericPageType",
		order:"Int",
		reportNavigation:"ReportNavigationLocale",
		localesByLocale:"GenericPageLocale",
		localesByContent:"GenericPageLocale",
		localesBySeo:"GenericPageLocale",
		localesByLink:"GenericPageLocale",
		paginateLocales:"GenericPageLocaleConnection",
		paginateReportNavigation:"ReportNavigationLocaleConnection"
	},
	GenericPageMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		type:"FieldMeta",
		order:"FieldMeta",
		reportNavigation:"FieldMeta"
	},
	ReportNavigationLocale:{
		_meta:"ReportNavigationLocaleMeta",
		id:"UUID",
		root:"ReportNavigation",
		locale:"Locale",
		pages:"GenericPage",
		paginatePages:"GenericPageConnection"
	},
	ReportNavigationLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		pages:"FieldMeta"
	},
	ReportNavigation:{
		_meta:"ReportNavigationMeta",
		id:"UUID",
		unique:"One",
		locales:"ReportNavigationLocale",
		localesByLocale:"ReportNavigationLocale",
		paginateLocales:"ReportNavigationLocaleConnection"
	},
	ReportNavigationMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	ReportNavigationLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ReportNavigationLocaleEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	ReportNavigationLocaleEdge:{
		node:"ReportNavigationLocale"
	},
	GenericPageConnection:{
		pageInfo:"PageInfo",
		edges:"GenericPageEdge"
	},
	GenericPageEdge:{
		node:"GenericPage"
	},
	GenericPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"GenericPageLocaleEdge"
	},
	GenericPageLocaleEdge:{
		node:"GenericPageLocale"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		blocks:"ContentBlock",
		blocksByReferences:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		blocks:"FieldMeta"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		referencesByLinkables:"ContentReference",
		referencesByLink:"ContentReference",
		referencesByValueList:"ContentReference",
		referencesByImageLinkList:"ContentReference",
		referencesByAreaList:"ContentReference",
		referencesByAccordion:"ContentReference",
		referencesByMedia:"ContentReference",
		referencesByMemberList:"ContentReference",
		referencesByContentWithoutBlocks:"ContentReference",
		referencesByOrganizationList:"ContentReference",
		referencesByTextImageList:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		primaryText:"String",
		block:"ContentBlock",
		image:"Image",
		linkables:"ContentReferenceLinkableItem",
		video:"Video",
		secondaryText:"String",
		link:"Link",
		contentAlignment:"ContentAlignment",
		valueList:"ValueList",
		imageLinkList:"ImageLinkList",
		areaList:"PostAreaList",
		isAppsVisible:"Boolean",
		accordion:"Accordion",
		media:"MediumList",
		memberList:"MemberList",
		asideMediaContentLayout:"AsideMediaContentLayout",
		isAsideMediaContentMobileLayout:"Boolean",
		form:"Form",
		isTitleBigger:"Boolean",
		contentWithoutBlocks:"Content",
		heroCarousel:"HeroCarousel",
		organizationList:"PostOrganizationList",
		isCentered:"Boolean",
		posts:"Post",
		textImageList:"TextImageList",
		linkablesByItem:"ContentReferenceLinkableItem",
		paginateLinkables:"ContentReferenceLinkableItemConnection",
		paginatePosts:"PostConnection"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		primaryText:"FieldMeta",
		block:"FieldMeta",
		image:"FieldMeta",
		linkables:"FieldMeta",
		video:"FieldMeta",
		secondaryText:"FieldMeta",
		link:"FieldMeta",
		contentAlignment:"FieldMeta",
		valueList:"FieldMeta",
		imageLinkList:"FieldMeta",
		areaList:"FieldMeta",
		isAppsVisible:"FieldMeta",
		accordion:"FieldMeta",
		media:"FieldMeta",
		memberList:"FieldMeta",
		asideMediaContentLayout:"FieldMeta",
		isAsideMediaContentMobileLayout:"FieldMeta",
		form:"FieldMeta",
		isTitleBigger:"FieldMeta",
		contentWithoutBlocks:"FieldMeta",
		heroCarousel:"FieldMeta",
		organizationList:"FieldMeta",
		isCentered:"FieldMeta",
		posts:"FieldMeta",
		textImageList:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String",
		fileName:"String",
		focalPointX:"Float",
		focalPointY:"Float"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta",
		fileName:"FieldMeta",
		focalPointX:"FieldMeta",
		focalPointY:"FieldMeta"
	},
	ContentReferenceLinkableItem:{
		_meta:"ContentReferenceLinkableItemMeta",
		id:"UUID",
		item:"Linkable",
		reference:"ContentReference"
	},
	ContentReferenceLinkableItemMeta:{
		id:"FieldMeta",
		item:"FieldMeta",
		reference:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		genericPage:"GenericPageLocale",
		post:"PostLocale",
		postArea:"PostAreaLocale",
		postOrganization:"PostOrganizationLocale",
		reportPage:"ReportPageLocale",
		givenGiftsPage:"GivenGiftsPageLocale",
		receivedGiftsPage:"ReceivedGiftsPageLocale"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		genericPage:"FieldMeta",
		post:"FieldMeta",
		postArea:"FieldMeta",
		postOrganization:"FieldMeta",
		reportPage:"FieldMeta",
		givenGiftsPage:"FieldMeta",
		receivedGiftsPage:"FieldMeta"
	},
	PostLocale:{
		_meta:"PostLocaleMeta",
		id:"UUID",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		locale:"Locale",
		root:"Post",
		paymentName:"String",
		publishedAt:"DateTime"
	},
	PostLocaleMeta:{
		id:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		locale:"FieldMeta",
		root:"FieldMeta",
		paymentName:"FieldMeta",
		publishedAt:"FieldMeta"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		noIndex:"Boolean",
		noFollow:"Boolean",
		ogImage:"Image"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		noIndex:"FieldMeta",
		noFollow:"FieldMeta",
		ogImage:"FieldMeta"
	},
	Post:{
		_meta:"PostMeta",
		id:"UUID",
		organization:"PostOrganization",
		area:"PostArea",
		specificSymbol:"Int",
		activeRevision:"PostRevision",
		revisions:"PostRevision",
		locales:"PostLocale",
		isPinnedInArea:"Boolean",
		isPinnedInOrganization:"Boolean",
		state:"PostState",
		meta:"PostMetaData",
		isPublishedAtHidden:"Boolean",
		heroCarousel:"HeroCarousel",
		reportPage:"ReportPageLocale",
		content:"ContentReference",
		fundraiseIsActive:"Boolean",
		fundraiseEndDate:"Date",
		fundraiseTargetAmount:"Int",
		fundraiseFakeAddOnAmount:"Int",
		fundraiseCurrency:"Currency",
		fundraiseCurrencySums:"PostCurrencySum",
		fundraiseSum:"PostSum",
		fundraisingProgress:"PostFundraisingProgress",
		revisionsByLocales:"PostRevision",
		revisionsByRegionListOverride:"PostRevision",
		localesByLocale:"PostLocale",
		localesByContent:"PostLocale",
		localesBySeo:"PostLocale",
		localesByLink:"PostLocale",
		paginateRevisions:"PostRevisionConnection",
		paginateLocales:"PostLocaleConnection",
		paginateHeroCarousel:"HeroCarouselConnection",
		paginateReportPage:"ReportPageLocaleConnection",
		paginateContent:"ContentReferenceConnection",
		paginateFundraiseCurrencySums:"PostCurrencySumConnection"
	},
	PostMeta:{
		id:"FieldMeta",
		organization:"FieldMeta",
		area:"FieldMeta",
		specificSymbol:"FieldMeta",
		activeRevision:"FieldMeta",
		revisions:"FieldMeta",
		locales:"FieldMeta",
		isPinnedInArea:"FieldMeta",
		isPinnedInOrganization:"FieldMeta",
		state:"FieldMeta",
		meta:"FieldMeta",
		isPublishedAtHidden:"FieldMeta",
		heroCarousel:"FieldMeta",
		reportPage:"FieldMeta",
		content:"FieldMeta",
		fundraiseIsActive:"FieldMeta",
		fundraiseEndDate:"FieldMeta",
		fundraiseTargetAmount:"FieldMeta",
		fundraiseFakeAddOnAmount:"FieldMeta",
		fundraiseCurrency:"FieldMeta",
		fundraiseCurrencySums:"FieldMeta",
		fundraiseSum:"FieldMeta",
		fundraisingProgress:"FieldMeta"
	},
	PostOrganization:{
		_meta:"PostOrganizationMeta",
		id:"UUID",
		order:"Int",
		posts:"Post",
		icon:"Image",
		locales:"PostOrganizationLocale",
		specificSymbol:"Int",
		area:"PostArea",
		meta:"PostOrganizationMetaData",
		mobileHeroImage:"Image",
		isHidden:"Boolean",
		color:"String",
		plainIcon:"Image",
		desktopHeroImage:"Image",
		sentPayments:"SentPayment",
		organizationCurrencySums:"PostOrganizationCurrencySum",
		organizationSum:"PostOrganizationSum",
		postsBySpecificSymbol:"Post",
		postsByActiveRevision:"Post",
		postsByRevisions:"Post",
		postsByLocales:"Post",
		postsByMeta:"Post",
		postsByFundraiseCurrencySums:"Post",
		postsByFundraiseSum:"Post",
		postsByFundraisingProgress:"Post",
		localesByLocale:"PostOrganizationLocale",
		localesByLink:"PostOrganizationLocale",
		localesByDomain:"PostOrganizationLocale",
		localesBySeo:"PostOrganizationLocale",
		localesByContent:"PostOrganizationLocale",
		sentPaymentsByLocales:"SentPayment",
		paginatePosts:"PostConnection",
		paginateLocales:"PostOrganizationLocaleConnection",
		paginateSentPayments:"SentPaymentConnection",
		paginateOrganizationCurrencySums:"PostOrganizationCurrencySumConnection"
	},
	PostOrganizationMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		posts:"FieldMeta",
		icon:"FieldMeta",
		locales:"FieldMeta",
		specificSymbol:"FieldMeta",
		area:"FieldMeta",
		meta:"FieldMeta",
		mobileHeroImage:"FieldMeta",
		isHidden:"FieldMeta",
		color:"FieldMeta",
		plainIcon:"FieldMeta",
		desktopHeroImage:"FieldMeta",
		sentPayments:"FieldMeta",
		organizationCurrencySums:"FieldMeta",
		organizationSum:"FieldMeta"
	},
	PostOrganizationLocale:{
		_meta:"PostOrganizationLocaleMeta",
		id:"UUID",
		name:"String",
		description:"String",
		link:"Linkable",
		root:"PostOrganization",
		locale:"Locale",
		domain:"Link",
		seo:"Seo",
		content:"Content",
		translatedByAI:"Boolean"
	},
	PostOrganizationLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		description:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		domain:"FieldMeta",
		seo:"FieldMeta",
		content:"FieldMeta",
		translatedByAI:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkEnum",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable",
		isTargetBlank:"Boolean"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta",
		isTargetBlank:"FieldMeta"
	},
	PostArea:{
		_meta:"PostAreaMeta",
		id:"UUID",
		order:"Int",
		icon:"Image",
		locales:"PostAreaLocale",
		regionListOverride:"DonationAmountsRegionList",
		color:"String",
		posts:"Post",
		specificSymbol:"Int",
		region:"Region",
		meta:"PostAreaMetaData",
		mobileHeroImage:"Image",
		plainIcon:"Image",
		sentPayments:"SentPayment",
		areaSentPaymentCurrencySums:"PostAreaSentPaymentCurrencySum",
		areaSentPaymentSum:"PostAreaSentPaymentSum",
		areaCurrencySums:"PostAreaCurrencySum",
		areaSum:"PostAreaSum",
		localesByLocale:"PostAreaLocale",
		localesByLink:"PostAreaLocale",
		localesBySeo:"PostAreaLocale",
		localesByBanner:"PostAreaLocale",
		localesByContent:"PostAreaLocale",
		postsBySpecificSymbol:"Post",
		postsByActiveRevision:"Post",
		postsByRevisions:"Post",
		postsByLocales:"Post",
		postsByMeta:"Post",
		postsByFundraiseCurrencySums:"Post",
		postsByFundraiseSum:"Post",
		postsByFundraisingProgress:"Post",
		sentPaymentsByLocales:"SentPayment",
		paginateLocales:"PostAreaLocaleConnection",
		paginatePosts:"PostConnection",
		paginateSentPayments:"SentPaymentConnection",
		paginateAreaSentPaymentCurrencySums:"PostAreaSentPaymentCurrencySumConnection",
		paginateAreaCurrencySums:"PostAreaCurrencySumConnection"
	},
	PostAreaMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		icon:"FieldMeta",
		locales:"FieldMeta",
		regionListOverride:"FieldMeta",
		color:"FieldMeta",
		posts:"FieldMeta",
		specificSymbol:"FieldMeta",
		region:"FieldMeta",
		meta:"FieldMeta",
		mobileHeroImage:"FieldMeta",
		plainIcon:"FieldMeta",
		sentPayments:"FieldMeta",
		areaSentPaymentCurrencySums:"FieldMeta",
		areaSentPaymentSum:"FieldMeta",
		areaCurrencySums:"FieldMeta",
		areaSum:"FieldMeta"
	},
	PostAreaLocale:{
		_meta:"PostAreaLocaleMeta",
		id:"UUID",
		name:"String",
		description:"String",
		link:"Linkable",
		root:"PostArea",
		locale:"Locale",
		seo:"Seo",
		banner:"AppBanner",
		shortDescription:"String",
		content:"Content",
		translatedByAI:"Boolean"
	},
	PostAreaLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		description:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta",
		banner:"FieldMeta",
		shortDescription:"FieldMeta",
		content:"FieldMeta",
		translatedByAI:"FieldMeta"
	},
	AppBanner:{
		_meta:"AppBannerMeta",
		id:"UUID",
		title:"String",
		imageSmall:"Image",
		imageBig:"Image",
		textContent:"Content"
	},
	AppBannerMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		imageSmall:"FieldMeta",
		imageBig:"FieldMeta",
		textContent:"FieldMeta"
	},
	DonationAmountsRegionList:{
		_meta:"DonationAmountsRegionListMeta",
		id:"UUID",
		regions:"DonationAmountsRegionItem",
		donation:"Donation",
		regionsByRegion:"DonationAmountsRegionItem",
		regionsByItems:"DonationAmountsRegionItem",
		paginateRegions:"DonationAmountsRegionItemConnection"
	},
	DonationAmountsRegionListMeta:{
		id:"FieldMeta",
		regions:"FieldMeta",
		donation:"FieldMeta"
	},
	DonationAmountsRegionItem:{
		_meta:"DonationAmountsRegionItemMeta",
		id:"UUID",
		order:"Int",
		items:"DonationAmountItem",
		list:"DonationAmountsRegionList",
		region:"Region",
		minimumAmount:"Float",
		paginateItems:"DonationAmountItemConnection"
	},
	DonationAmountsRegionItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		items:"FieldMeta",
		list:"FieldMeta",
		region:"FieldMeta",
		minimumAmount:"FieldMeta"
	},
	DonationAmountItem:{
		_meta:"DonationAmountItemMeta",
		id:"UUID",
		order:"Int",
		amount:"Float",
		regionItem:"DonationAmountsRegionItem"
	},
	DonationAmountItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		amount:"FieldMeta",
		regionItem:"FieldMeta"
	},
	Region:{
		_meta:"RegionMeta",
		id:"UUID",
		order:"Int",
		code:"String",
		label:"String",
		currency:"Currency",
		enabledPaymentMethods:"RegionPaymentMethod",
		donationItems:"DonationAmountsRegionItem",
		timezone:"String",
		enabledPaymentMethodsByMethod:"RegionPaymentMethod",
		donationItemsByList:"DonationAmountsRegionItem",
		donationItemsByItems:"DonationAmountsRegionItem",
		paginateEnabledPaymentMethods:"RegionPaymentMethodConnection",
		paginateDonationItems:"DonationAmountsRegionItemConnection"
	},
	RegionMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		code:"FieldMeta",
		label:"FieldMeta",
		currency:"FieldMeta",
		enabledPaymentMethods:"FieldMeta",
		donationItems:"FieldMeta",
		timezone:"FieldMeta"
	},
	Currency:{
		_meta:"CurrencyMeta",
		id:"UUID",
		identifier:"CurrencyIdentifier",
		label:"String",
		sign:"String",
		signAlignment:"CurrencySignAlignment",
		defaultDonationAmount:"Int",
		rateAgainstCzk:"Float",
		areaSentPaymentCurrencySums:"PostAreaSentPaymentCurrencySum",
		areaCurrencySums:"PostAreaCurrencySum",
		organizationCurrencySums:"PostOrganizationCurrencySum",
		postCurrencySums:"PostCurrencySum",
		paginateAreaSentPaymentCurrencySums:"PostAreaSentPaymentCurrencySumConnection",
		paginateAreaCurrencySums:"PostAreaCurrencySumConnection",
		paginateOrganizationCurrencySums:"PostOrganizationCurrencySumConnection",
		paginatePostCurrencySums:"PostCurrencySumConnection"
	},
	CurrencyMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		label:"FieldMeta",
		sign:"FieldMeta",
		signAlignment:"FieldMeta",
		defaultDonationAmount:"FieldMeta",
		rateAgainstCzk:"FieldMeta",
		areaSentPaymentCurrencySums:"FieldMeta",
		areaCurrencySums:"FieldMeta",
		organizationCurrencySums:"FieldMeta",
		postCurrencySums:"FieldMeta"
	},
	PostAreaSentPaymentCurrencySum:{
		_meta:"PostAreaSentPaymentCurrencySumMeta",
		id:"UUID",
		currencyIdentifier:"String",
		rateAgainstCzk:"Float",
		totalCents:"Int",
		currency:"Currency",
		area:"PostArea"
	},
	PostAreaSentPaymentCurrencySumMeta:{
		id:"FieldMeta",
		currencyIdentifier:"FieldMeta",
		rateAgainstCzk:"FieldMeta",
		totalCents:"FieldMeta",
		currency:"FieldMeta",
		area:"FieldMeta"
	},
	PostAreaCurrencySum:{
		_meta:"PostAreaCurrencySumMeta",
		id:"UUID",
		currencyIdentifier:"String",
		rateAgainstCzk:"Float",
		totalCents:"Int",
		currency:"Currency",
		area:"PostArea"
	},
	PostAreaCurrencySumMeta:{
		id:"FieldMeta",
		currencyIdentifier:"FieldMeta",
		rateAgainstCzk:"FieldMeta",
		totalCents:"FieldMeta",
		currency:"FieldMeta",
		area:"FieldMeta"
	},
	PostOrganizationCurrencySum:{
		_meta:"PostOrganizationCurrencySumMeta",
		id:"UUID",
		currencyIdentifier:"String",
		rateAgainstCzk:"Float",
		totalCents:"Int",
		currency:"Currency",
		organization:"PostOrganization"
	},
	PostOrganizationCurrencySumMeta:{
		id:"FieldMeta",
		currencyIdentifier:"FieldMeta",
		rateAgainstCzk:"FieldMeta",
		totalCents:"FieldMeta",
		currency:"FieldMeta",
		organization:"FieldMeta"
	},
	PostCurrencySum:{
		_meta:"PostCurrencySumMeta",
		id:"UUID",
		currencyIdentifier:"String",
		rateAgainstCzk:"Float",
		totalCents:"Int",
		currency:"Currency",
		post:"Post"
	},
	PostCurrencySumMeta:{
		id:"FieldMeta",
		currencyIdentifier:"FieldMeta",
		rateAgainstCzk:"FieldMeta",
		totalCents:"FieldMeta",
		currency:"FieldMeta",
		post:"FieldMeta"
	},
	PostAreaSentPaymentCurrencySumConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaSentPaymentCurrencySumEdge"
	},
	PostAreaSentPaymentCurrencySumEdge:{
		node:"PostAreaSentPaymentCurrencySum"
	},
	PostAreaCurrencySumConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaCurrencySumEdge"
	},
	PostAreaCurrencySumEdge:{
		node:"PostAreaCurrencySum"
	},
	PostOrganizationCurrencySumConnection:{
		pageInfo:"PageInfo",
		edges:"PostOrganizationCurrencySumEdge"
	},
	PostOrganizationCurrencySumEdge:{
		node:"PostOrganizationCurrencySum"
	},
	PostCurrencySumConnection:{
		pageInfo:"PageInfo",
		edges:"PostCurrencySumEdge"
	},
	PostCurrencySumEdge:{
		node:"PostCurrencySum"
	},
	RegionPaymentMethod:{
		_meta:"RegionPaymentMethodMeta",
		id:"UUID",
		allowRecurringPayments:"Boolean",
		region:"Region",
		method:"PaymentMethods",
		order:"Int"
	},
	RegionPaymentMethodMeta:{
		id:"FieldMeta",
		allowRecurringPayments:"FieldMeta",
		region:"FieldMeta",
		method:"FieldMeta",
		order:"FieldMeta"
	},
	RegionPaymentMethodConnection:{
		pageInfo:"PageInfo",
		edges:"RegionPaymentMethodEdge"
	},
	RegionPaymentMethodEdge:{
		node:"RegionPaymentMethod"
	},
	DonationAmountsRegionItemConnection:{
		pageInfo:"PageInfo",
		edges:"DonationAmountsRegionItemEdge"
	},
	DonationAmountsRegionItemEdge:{
		node:"DonationAmountsRegionItem"
	},
	DonationAmountItemConnection:{
		pageInfo:"PageInfo",
		edges:"DonationAmountItemEdge"
	},
	DonationAmountItemEdge:{
		node:"DonationAmountItem"
	},
	Donation:{
		_meta:"DonationMeta",
		id:"UUID",
		unique:"One",
		regionList:"DonationAmountsRegionList"
	},
	DonationMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		regionList:"FieldMeta"
	},
	PostAreaMetaData:{
		_meta:"PostAreaMetaDataMeta",
		id:"UUID",
		nameWithFallback:"String",
		formattedSpecificSymbol:"String",
		fullFormattedSpecificSymbol:"String",
		area:"PostArea"
	},
	PostAreaMetaDataMeta:{
		id:"FieldMeta",
		nameWithFallback:"FieldMeta",
		formattedSpecificSymbol:"FieldMeta",
		fullFormattedSpecificSymbol:"FieldMeta",
		area:"FieldMeta"
	},
	SentPayment:{
		_meta:"SentPaymentMeta",
		id:"UUID",
		createdAt:"DateTime",
		cents:"Int",
		sendAt:"DateTime",
		currency:"Currency",
		area:"PostArea",
		organization:"PostOrganization",
		locales:"SentPaymentLocale",
		localesByLocale:"SentPaymentLocale",
		paginateLocales:"SentPaymentLocaleConnection"
	},
	SentPaymentMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		cents:"FieldMeta",
		sendAt:"FieldMeta",
		currency:"FieldMeta",
		area:"FieldMeta",
		organization:"FieldMeta",
		locales:"FieldMeta"
	},
	SentPaymentLocale:{
		_meta:"SentPaymentLocaleMeta",
		id:"UUID",
		organizationText:"String",
		root:"SentPayment",
		locale:"Locale"
	},
	SentPaymentLocaleMeta:{
		id:"FieldMeta",
		organizationText:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	SentPaymentLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"SentPaymentLocaleEdge"
	},
	SentPaymentLocaleEdge:{
		node:"SentPaymentLocale"
	},
	PostAreaSentPaymentSum:{
		_meta:"PostAreaSentPaymentSumMeta",
		id:"UUID",
		totalCents:"Int",
		czkPercentage:"Float",
		area:"PostArea"
	},
	PostAreaSentPaymentSumMeta:{
		id:"FieldMeta",
		totalCents:"FieldMeta",
		czkPercentage:"FieldMeta",
		area:"FieldMeta"
	},
	PostAreaSum:{
		_meta:"PostAreaSumMeta",
		id:"UUID",
		totalCents:"Int",
		czkPercentage:"Float",
		area:"PostArea"
	},
	PostAreaSumMeta:{
		id:"FieldMeta",
		totalCents:"FieldMeta",
		czkPercentage:"FieldMeta",
		area:"FieldMeta"
	},
	PostAreaLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaLocaleEdge"
	},
	PostAreaLocaleEdge:{
		node:"PostAreaLocale"
	},
	PostConnection:{
		pageInfo:"PageInfo",
		edges:"PostEdge"
	},
	PostEdge:{
		node:"Post"
	},
	SentPaymentConnection:{
		pageInfo:"PageInfo",
		edges:"SentPaymentEdge"
	},
	SentPaymentEdge:{
		node:"SentPayment"
	},
	PostOrganizationMetaData:{
		_meta:"PostOrganizationMetaDataMeta",
		id:"UUID",
		nameWithFallback:"String",
		formattedSpecificSymbol:"String",
		fullFormattedSpecificSymbol:"String",
		organization:"PostOrganization"
	},
	PostOrganizationMetaDataMeta:{
		id:"FieldMeta",
		nameWithFallback:"FieldMeta",
		formattedSpecificSymbol:"FieldMeta",
		fullFormattedSpecificSymbol:"FieldMeta",
		organization:"FieldMeta"
	},
	PostOrganizationSum:{
		_meta:"PostOrganizationSumMeta",
		id:"UUID",
		totalCents:"Int",
		czkPercentage:"Float",
		organization:"PostOrganization"
	},
	PostOrganizationSumMeta:{
		id:"FieldMeta",
		totalCents:"FieldMeta",
		czkPercentage:"FieldMeta",
		organization:"FieldMeta"
	},
	PostOrganizationLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PostOrganizationLocaleEdge"
	},
	PostOrganizationLocaleEdge:{
		node:"PostOrganizationLocale"
	},
	PostRevision:{
		_meta:"PostRevisionMeta",
		id:"UUID",
		createdAt:"DateTime",
		createdById:"UUID",
		publishedById:"UUID",
		type:"PostType",
		publishedAt:"DateTime",
		post:"Post",
		tileImage:"Image",
		tileVideo:"Video",
		heroImage:"Image",
		locales:"PostRevisionLocale",
		regionListOverride:"DonationAmountsRegionList",
		isOrganizationVisible:"Boolean",
		sendPublishNotifications:"Boolean",
		isArchived:"Boolean",
		localesByLocale:"PostRevisionLocale",
		localesByContent:"PostRevisionLocale",
		localesBySeo:"PostRevisionLocale",
		localesByLeadContent:"PostRevisionLocale",
		paginateLocales:"PostRevisionLocaleConnection"
	},
	PostRevisionMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		createdById:"FieldMeta",
		publishedById:"FieldMeta",
		type:"FieldMeta",
		publishedAt:"FieldMeta",
		post:"FieldMeta",
		tileImage:"FieldMeta",
		tileVideo:"FieldMeta",
		heroImage:"FieldMeta",
		locales:"FieldMeta",
		regionListOverride:"FieldMeta",
		isOrganizationVisible:"FieldMeta",
		sendPublishNotifications:"FieldMeta",
		isArchived:"FieldMeta"
	},
	Video:{
		_meta:"VideoMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		poster:"Image",
		shapeType:"VideoShapeType"
	},
	VideoMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		poster:"FieldMeta",
		shapeType:"FieldMeta"
	},
	PostRevisionLocale:{
		_meta:"PostRevisionLocaleMeta",
		id:"UUID",
		title:"String",
		root:"PostRevision",
		locale:"Locale",
		content:"Content",
		seo:"Seo",
		leadContent:"Content",
		publishNotificationText:"String",
		translatedByAI:"Boolean"
	},
	PostRevisionLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		leadContent:"FieldMeta",
		publishNotificationText:"FieldMeta",
		translatedByAI:"FieldMeta"
	},
	PostRevisionLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PostRevisionLocaleEdge"
	},
	PostRevisionLocaleEdge:{
		node:"PostRevisionLocale"
	},
	PostMetaData:{
		_meta:"PostMetaDataMeta",
		id:"UUID",
		titleWithFallback:"String",
		formattedSpecificSymbol:"String",
		fullFormattedSpecificSymbol:"String",
		latestRevision:"PostRevision",
		post:"Post"
	},
	PostMetaDataMeta:{
		id:"FieldMeta",
		titleWithFallback:"FieldMeta",
		formattedSpecificSymbol:"FieldMeta",
		fullFormattedSpecificSymbol:"FieldMeta",
		latestRevision:"FieldMeta",
		post:"FieldMeta"
	},
	HeroCarousel:{
		_meta:"HeroCarouselMeta",
		id:"UUID",
		createdAt:"Date",
		posts:"Post",
		items:"HeroCarouselItem",
		paginatePosts:"PostConnection",
		paginateItems:"HeroCarouselItemConnection"
	},
	HeroCarouselMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		posts:"FieldMeta",
		items:"FieldMeta"
	},
	HeroCarouselItem:{
		_meta:"HeroCarouselItemMeta",
		id:"UUID",
		createdAt:"Date",
		order:"Int",
		list:"HeroCarousel",
		item:"Post"
	},
	HeroCarouselItemMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		item:"FieldMeta"
	},
	HeroCarouselItemConnection:{
		pageInfo:"PageInfo",
		edges:"HeroCarouselItemEdge"
	},
	HeroCarouselItemEdge:{
		node:"HeroCarouselItem"
	},
	ReportPageLocale:{
		_meta:"ReportPageLocaleMeta",
		id:"UUID",
		title:"String",
		subtitle:"String",
		postTitle:"String",
		giftTitle:"String",
		link:"Linkable",
		root:"ReportPage",
		locale:"Locale",
		content:"Content",
		seo:"Seo",
		posts:"Post",
		paginatePosts:"PostConnection"
	},
	ReportPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		subtitle:"FieldMeta",
		postTitle:"FieldMeta",
		giftTitle:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		posts:"FieldMeta"
	},
	ReportPage:{
		_meta:"ReportPageMeta",
		id:"UUID",
		unique:"One",
		locales:"ReportPageLocale",
		localesByLocale:"ReportPageLocale",
		localesByLink:"ReportPageLocale",
		localesByContent:"ReportPageLocale",
		localesBySeo:"ReportPageLocale",
		paginateLocales:"ReportPageLocaleConnection"
	},
	ReportPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	ReportPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ReportPageLocaleEdge"
	},
	ReportPageLocaleEdge:{
		node:"ReportPageLocale"
	},
	PostSum:{
		_meta:"PostSumMeta",
		id:"UUID",
		totalCents:"Int",
		czkPercentage:"Float",
		post:"Post"
	},
	PostSumMeta:{
		id:"FieldMeta",
		totalCents:"FieldMeta",
		czkPercentage:"FieldMeta",
		post:"FieldMeta"
	},
	PostFundraisingProgress:{
		_meta:"PostFundraisingProgressMeta",
		id:"UUID",
		progress:"Float",
		post:"Post"
	},
	PostFundraisingProgressMeta:{
		id:"FieldMeta",
		progress:"FieldMeta",
		post:"FieldMeta"
	},
	PostRevisionConnection:{
		pageInfo:"PageInfo",
		edges:"PostRevisionEdge"
	},
	PostRevisionEdge:{
		node:"PostRevision"
	},
	PostLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PostLocaleEdge"
	},
	PostLocaleEdge:{
		node:"PostLocale"
	},
	HeroCarouselConnection:{
		pageInfo:"PageInfo",
		edges:"HeroCarouselEdge"
	},
	HeroCarouselEdge:{
		node:"HeroCarousel"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	GivenGiftsPageLocale:{
		_meta:"GivenGiftsPageLocaleMeta",
		id:"UUID",
		title:"String",
		subtitle:"String",
		giftTitle:"String",
		giftText:"String",
		note:"String",
		root:"GivenGiftsPage",
		locale:"Locale",
		content:"Content",
		seo:"Seo",
		link:"Linkable"
	},
	GivenGiftsPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		subtitle:"FieldMeta",
		giftTitle:"FieldMeta",
		giftText:"FieldMeta",
		note:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta"
	},
	GivenGiftsPage:{
		_meta:"GivenGiftsPageMeta",
		id:"UUID",
		unique:"One",
		locales:"GivenGiftsPageLocale",
		localesByLocale:"GivenGiftsPageLocale",
		localesByContent:"GivenGiftsPageLocale",
		localesBySeo:"GivenGiftsPageLocale",
		localesByLink:"GivenGiftsPageLocale",
		paginateLocales:"GivenGiftsPageLocaleConnection"
	},
	GivenGiftsPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	GivenGiftsPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"GivenGiftsPageLocaleEdge"
	},
	GivenGiftsPageLocaleEdge:{
		node:"GivenGiftsPageLocale"
	},
	ReceivedGiftsPageLocale:{
		_meta:"ReceivedGiftsPageLocaleMeta",
		id:"UUID",
		title:"String",
		subtitle:"String",
		giftTitle:"String",
		giftText:"String",
		note:"String",
		link:"Linkable",
		root:"ReceivedGiftsPage",
		locale:"Locale",
		content:"Content",
		seo:"Seo"
	},
	ReceivedGiftsPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		subtitle:"FieldMeta",
		giftTitle:"FieldMeta",
		giftText:"FieldMeta",
		note:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta"
	},
	ReceivedGiftsPage:{
		_meta:"ReceivedGiftsPageMeta",
		id:"UUID",
		unique:"One",
		locales:"ReceivedGiftsPageLocale",
		localesByLocale:"ReceivedGiftsPageLocale",
		localesByLink:"ReceivedGiftsPageLocale",
		localesByContent:"ReceivedGiftsPageLocale",
		localesBySeo:"ReceivedGiftsPageLocale",
		paginateLocales:"ReceivedGiftsPageLocaleConnection"
	},
	ReceivedGiftsPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	ReceivedGiftsPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ReceivedGiftsPageLocaleEdge"
	},
	ReceivedGiftsPageLocaleEdge:{
		node:"ReceivedGiftsPageLocale"
	},
	ValueList:{
		_meta:"ValueListMeta",
		id:"UUID",
		items:"ValueItem",
		paginateItems:"ValueItemConnection"
	},
	ValueListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ValueItem:{
		_meta:"ValueItemMeta",
		id:"UUID",
		order:"Int",
		list:"ValueList",
		item:"Value"
	},
	ValueItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		item:"FieldMeta"
	},
	Value:{
		_meta:"ValueMeta",
		id:"UUID",
		title:"String",
		textContent:"Content"
	},
	ValueMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		textContent:"FieldMeta"
	},
	ValueItemConnection:{
		pageInfo:"PageInfo",
		edges:"ValueItemEdge"
	},
	ValueItemEdge:{
		node:"ValueItem"
	},
	ImageLinkList:{
		_meta:"ImageLinkListMeta",
		id:"UUID",
		items:"ImageLinkItem",
		paginateItems:"ImageLinkItemConnection"
	},
	ImageLinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ImageLinkItem:{
		_meta:"ImageLinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"ImageLinkList",
		item:"ImageLink"
	},
	ImageLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		item:"FieldMeta"
	},
	ImageLink:{
		_meta:"ImageLinkMeta",
		id:"UUID",
		image:"Image",
		link:"Link"
	},
	ImageLinkMeta:{
		id:"FieldMeta",
		image:"FieldMeta",
		link:"FieldMeta"
	},
	ImageLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"ImageLinkItemEdge"
	},
	ImageLinkItemEdge:{
		node:"ImageLinkItem"
	},
	PostAreaList:{
		_meta:"PostAreaListMeta",
		id:"UUID",
		items:"PostAreaListItem",
		paginateItems:"PostAreaListItemConnection"
	},
	PostAreaListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	PostAreaListItem:{
		_meta:"PostAreaListItemMeta",
		id:"UUID",
		order:"Int",
		list:"PostAreaList",
		item:"PostArea"
	},
	PostAreaListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		item:"FieldMeta"
	},
	PostAreaListItemConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaListItemEdge"
	},
	PostAreaListItemEdge:{
		node:"PostAreaListItem"
	},
	Accordion:{
		_meta:"AccordionMeta",
		id:"UUID",
		items:"AccordionItem",
		itemsByDescriptionContent:"AccordionItem",
		paginateItems:"AccordionItemConnection"
	},
	AccordionMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	AccordionItem:{
		_meta:"AccordionItemMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		list:"Accordion",
		descriptionContent:"Content"
	},
	AccordionItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		list:"FieldMeta",
		descriptionContent:"FieldMeta"
	},
	AccordionItemConnection:{
		pageInfo:"PageInfo",
		edges:"AccordionItemEdge"
	},
	AccordionItemEdge:{
		node:"AccordionItem"
	},
	MediumList:{
		_meta:"MediumListMeta",
		id:"UUID",
		items:"MediumItem",
		paginateItems:"MediumItemConnection"
	},
	MediumListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	MediumItem:{
		_meta:"MediumItemMeta",
		id:"UUID",
		order:"Int",
		list:"MediumList",
		medium:"Medium"
	},
	MediumItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		medium:"FieldMeta"
	},
	Medium:{
		_meta:"MediumMeta",
		id:"UUID",
		type:"MediumType",
		image:"Image",
		video:"Video"
	},
	MediumMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		image:"FieldMeta",
		video:"FieldMeta"
	},
	MediumItemConnection:{
		pageInfo:"PageInfo",
		edges:"MediumItemEdge"
	},
	MediumItemEdge:{
		node:"MediumItem"
	},
	MemberList:{
		_meta:"MemberListMeta",
		id:"UUID",
		items:"MemberListItem",
		itemsByDescriptionContent:"MemberListItem",
		paginateItems:"MemberListItemConnection"
	},
	MemberListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	MemberListItem:{
		_meta:"MemberListItemMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		position:"String",
		list:"MemberList",
		image:"Image",
		descriptionContent:"Content"
	},
	MemberListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		position:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta",
		descriptionContent:"FieldMeta"
	},
	MemberListItemConnection:{
		pageInfo:"PageInfo",
		edges:"MemberListItemEdge"
	},
	MemberListItemEdge:{
		node:"MemberListItem"
	},
	Form:{
		_meta:"FormMeta",
		id:"UUID",
		name:"String",
		type:"FormType",
		tax:"FilledTaxForm"
	},
	FormMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		type:"FieldMeta",
		tax:"FieldMeta"
	},
	FilledTaxForm:{
		_meta:"FilledTaxFormMeta",
		id:"UUID",
		publishedAt:"DateTime",
		userId:"String",
		email:"String",
		name:"String",
		vatId:"String",
		address1:"String",
		address2:"String",
		city:"String",
		postalCode:"String",
		state:"String",
		country:"Region",
		dateFrom:"Date",
		dateTo:"Date",
		year:"Int",
		isPdfGenerated:"Boolean",
		pdfObjectKey:"String"
	},
	FilledTaxFormMeta:{
		id:"FieldMeta",
		publishedAt:"FieldMeta",
		userId:"FieldMeta",
		email:"FieldMeta",
		name:"FieldMeta",
		vatId:"FieldMeta",
		address1:"FieldMeta",
		address2:"FieldMeta",
		city:"FieldMeta",
		postalCode:"FieldMeta",
		state:"FieldMeta",
		country:"FieldMeta",
		dateFrom:"FieldMeta",
		dateTo:"FieldMeta",
		year:"FieldMeta",
		isPdfGenerated:"FieldMeta",
		pdfObjectKey:"FieldMeta"
	},
	PostOrganizationList:{
		_meta:"PostOrganizationListMeta",
		id:"UUID",
		items:"PostOrganizationListItem",
		itemsByLink:"PostOrganizationListItem",
		paginateItems:"PostOrganizationListItemConnection"
	},
	PostOrganizationListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	PostOrganizationListItem:{
		_meta:"PostOrganizationListItemMeta",
		id:"UUID",
		order:"Int",
		list:"PostOrganizationList",
		item:"PostOrganization",
		type:"PostOrganizationListItemType",
		link:"Link",
		image:"Image"
	},
	PostOrganizationListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		item:"FieldMeta",
		type:"FieldMeta",
		link:"FieldMeta",
		image:"FieldMeta"
	},
	PostOrganizationListItemConnection:{
		pageInfo:"PageInfo",
		edges:"PostOrganizationListItemEdge"
	},
	PostOrganizationListItemEdge:{
		node:"PostOrganizationListItem"
	},
	TextImageList:{
		_meta:"TextImageListMeta",
		id:"UUID",
		items:"TextImageListItem",
		paginateItems:"TextImageListItemConnection"
	},
	TextImageListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	TextImageListItem:{
		_meta:"TextImageListItemMeta",
		id:"UUID",
		order:"Int",
		list:"TextImageList",
		image:"Image",
		text:"String",
		link:"Link"
	},
	TextImageListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta",
		text:"FieldMeta",
		link:"FieldMeta"
	},
	TextImageListItemConnection:{
		pageInfo:"PageInfo",
		edges:"TextImageListItemEdge"
	},
	TextImageListItemEdge:{
		node:"TextImageListItem"
	},
	ContentReferenceLinkableItemConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceLinkableItemEdge"
	},
	ContentReferenceLinkableItemEdge:{
		node:"ContentReferenceLinkableItem"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	HeaderLocale:{
		_meta:"HeaderLocaleMeta",
		id:"UUID",
		root:"Header",
		locale:"Locale",
		links:"LinkList"
	},
	HeaderLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		links:"FieldMeta"
	},
	Header:{
		_meta:"HeaderMeta",
		id:"UUID",
		unique:"One",
		logo:"Image",
		locales:"HeaderLocale",
		organizationList:"PostOrganizationList",
		localesByLocale:"HeaderLocale",
		localesByLinks:"HeaderLocale",
		paginateLocales:"HeaderLocaleConnection"
	},
	HeaderMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		logo:"FieldMeta",
		locales:"FieldMeta",
		organizationList:"FieldMeta"
	},
	HeaderLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderLocaleEdge"
	},
	HeaderLocaleEdge:{
		node:"HeaderLocale"
	},
	LinkList:{
		_meta:"LinkListMeta",
		id:"UUID",
		items:"LinkItem",
		itemsByLink:"LinkItem",
		paginateItems:"LinkItemConnection"
	},
	LinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	LinkItem:{
		_meta:"LinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"LinkList",
		link:"Link"
	},
	LinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta"
	},
	LinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"LinkItemEdge"
	},
	LinkItemEdge:{
		node:"LinkItem"
	},
	FooterLocale:{
		_meta:"FooterLocaleMeta",
		id:"UUID",
		copyright:"String",
		root:"Footer",
		locale:"Locale",
		linkList:"LinkList",
		contactEmail:"String",
		addressInfo:"Content",
		imageLinkList:"ImageLinkList"
	},
	FooterLocaleMeta:{
		id:"FieldMeta",
		copyright:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		linkList:"FieldMeta",
		contactEmail:"FieldMeta",
		addressInfo:"FieldMeta",
		imageLinkList:"FieldMeta"
	},
	Footer:{
		_meta:"FooterMeta",
		id:"UUID",
		unique:"One",
		locales:"FooterLocale",
		logo:"Image",
		localesByLocale:"FooterLocale",
		localesByLinkList:"FooterLocale",
		localesByAddressInfo:"FooterLocale",
		localesByImageLinkList:"FooterLocale",
		paginateLocales:"FooterLocaleConnection"
	},
	FooterMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		logo:"FieldMeta"
	},
	FooterLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"FooterLocaleEdge"
	},
	FooterLocaleEdge:{
		node:"FooterLocale"
	},
	GenericPageAboutSettingsLocale:{
		_meta:"GenericPageAboutSettingsLocaleMeta",
		id:"UUID",
		root:"GenericPageAboutSettings",
		locale:"Locale",
		linkGroups:"GenericPageAboutGroupLinksLocale",
		linkGroupsByLinkList:"GenericPageAboutGroupLinksLocale",
		paginateLinkGroups:"GenericPageAboutGroupLinksLocaleConnection"
	},
	GenericPageAboutSettingsLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		linkGroups:"FieldMeta"
	},
	GenericPageAboutSettings:{
		_meta:"GenericPageAboutSettingsMeta",
		id:"UUID",
		unique:"One",
		locales:"GenericPageAboutSettingsLocale",
		localesByLocale:"GenericPageAboutSettingsLocale",
		localesByLinkGroups:"GenericPageAboutSettingsLocale",
		paginateLocales:"GenericPageAboutSettingsLocaleConnection"
	},
	GenericPageAboutSettingsMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	GenericPageAboutSettingsLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"GenericPageAboutSettingsLocaleEdge"
	},
	GenericPageAboutSettingsLocaleEdge:{
		node:"GenericPageAboutSettingsLocale"
	},
	GenericPageAboutGroupLinksLocale:{
		_meta:"GenericPageAboutGroupLinksLocaleMeta",
		id:"UUID",
		order:"Int",
		settings:"GenericPageAboutSettingsLocale",
		linkList:"LinkList"
	},
	GenericPageAboutGroupLinksLocaleMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		settings:"FieldMeta",
		linkList:"FieldMeta"
	},
	GenericPageAboutGroupLinksLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"GenericPageAboutGroupLinksLocaleEdge"
	},
	GenericPageAboutGroupLinksLocaleEdge:{
		node:"GenericPageAboutGroupLinksLocale"
	},
	FeedPageLocale:{
		_meta:"FeedPageLocaleMeta",
		id:"UUID",
		root:"FeedPage",
		locale:"Locale",
		heroTiles:"TileList",
		sectionList:"FeedPageSection",
		cardList:"CardList",
		storyGuideList:"StoryGuideList",
		sectionListByTileStripeList:"FeedPageSection",
		paginateSectionList:"FeedPageSectionConnection"
	},
	FeedPageLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		heroTiles:"FieldMeta",
		sectionList:"FieldMeta",
		cardList:"FieldMeta",
		storyGuideList:"FieldMeta"
	},
	FeedPage:{
		_meta:"FeedPageMeta",
		id:"UUID",
		unique:"One",
		locales:"FeedPageLocale",
		localesByLocale:"FeedPageLocale",
		localesByHeroTiles:"FeedPageLocale",
		localesBySectionList:"FeedPageLocale",
		localesByCardList:"FeedPageLocale",
		localesByStoryGuideList:"FeedPageLocale",
		paginateLocales:"FeedPageLocaleConnection"
	},
	FeedPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	FeedPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"FeedPageLocaleEdge"
	},
	FeedPageLocaleEdge:{
		node:"FeedPageLocale"
	},
	TileList:{
		_meta:"TileListMeta",
		id:"UUID",
		size:"TileListSize",
		title:"String",
		items:"TileItem",
		areaType:"PostArea",
		itemsByLink:"TileItem",
		paginateItems:"TileItemConnection"
	},
	TileListMeta:{
		id:"FieldMeta",
		size:"FieldMeta",
		title:"FieldMeta",
		items:"FieldMeta",
		areaType:"FieldMeta"
	},
	TileItem:{
		_meta:"TileItemMeta",
		id:"UUID",
		order:"Int",
		type:"TileItemType",
		title:"String",
		description:"String",
		list:"TileList",
		post:"Post",
		area:"PostArea",
		image:"Image",
		link:"Link",
		organization:"PostOrganization"
	},
	TileItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		list:"FieldMeta",
		post:"FieldMeta",
		area:"FieldMeta",
		image:"FieldMeta",
		link:"FieldMeta",
		organization:"FieldMeta"
	},
	TileItemConnection:{
		pageInfo:"PageInfo",
		edges:"TileItemEdge"
	},
	TileItemEdge:{
		node:"TileItem"
	},
	FeedPageSection:{
		_meta:"FeedPageSectionMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		feedPageLocale:"FeedPageLocale",
		tileStripeList:"FeedPageTileStripe",
		paginateTileStripeList:"FeedPageTileStripeConnection"
	},
	FeedPageSectionMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		feedPageLocale:"FieldMeta",
		tileStripeList:"FieldMeta"
	},
	FeedPageTileStripe:{
		_meta:"FeedPageTileStripeMeta",
		id:"UUID",
		order:"Int",
		section:"FeedPageSection",
		tileList:"TileList"
	},
	FeedPageTileStripeMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		section:"FieldMeta",
		tileList:"FieldMeta"
	},
	FeedPageTileStripeConnection:{
		pageInfo:"PageInfo",
		edges:"FeedPageTileStripeEdge"
	},
	FeedPageTileStripeEdge:{
		node:"FeedPageTileStripe"
	},
	CardList:{
		_meta:"CardListMeta",
		id:"UUID",
		items:"CardItem",
		itemsByLink:"CardItem",
		paginateItems:"CardItemConnection"
	},
	CardListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	CardItem:{
		_meta:"CardItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		description:"String",
		list:"CardList",
		link:"Link"
	},
	CardItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta"
	},
	CardItemConnection:{
		pageInfo:"PageInfo",
		edges:"CardItemEdge"
	},
	CardItemEdge:{
		node:"CardItem"
	},
	StoryGuideList:{
		_meta:"StoryGuideListMeta",
		id:"UUID",
		items:"StoryGuideItem",
		paginateItems:"StoryGuideItemConnection"
	},
	StoryGuideListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	StoryGuideItem:{
		_meta:"StoryGuideItemMeta",
		id:"UUID",
		order:"Int",
		list:"StoryGuideList",
		guide:"StoryGuide"
	},
	StoryGuideItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		guide:"FieldMeta"
	},
	StoryGuide:{
		_meta:"StoryGuideMeta",
		id:"UUID",
		mediaType:"MediaType",
		title:"String",
		subtitle:"String",
		image:"Image",
		secondaryImage:"Image"
	},
	StoryGuideMeta:{
		id:"FieldMeta",
		mediaType:"FieldMeta",
		title:"FieldMeta",
		subtitle:"FieldMeta",
		image:"FieldMeta",
		secondaryImage:"FieldMeta"
	},
	StoryGuideItemConnection:{
		pageInfo:"PageInfo",
		edges:"StoryGuideItemEdge"
	},
	StoryGuideItemEdge:{
		node:"StoryGuideItem"
	},
	FeedPageSectionConnection:{
		pageInfo:"PageInfo",
		edges:"FeedPageSectionEdge"
	},
	FeedPageSectionEdge:{
		node:"FeedPageSection"
	},
	RecurringPaymentPageLocale:{
		_meta:"RecurringPaymentPageLocaleMeta",
		id:"UUID",
		root:"RecurringPaymentPage",
		locale:"Locale",
		favouritePosts:"PostList",
		storyGuideList:"StoryGuideList"
	},
	RecurringPaymentPageLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		favouritePosts:"FieldMeta",
		storyGuideList:"FieldMeta"
	},
	RecurringPaymentPage:{
		_meta:"RecurringPaymentPageMeta",
		id:"UUID",
		unique:"One",
		locales:"RecurringPaymentPageLocale",
		localesByLocale:"RecurringPaymentPageLocale",
		localesByFavouritePosts:"RecurringPaymentPageLocale",
		localesByStoryGuideList:"RecurringPaymentPageLocale",
		paginateLocales:"RecurringPaymentPageLocaleConnection"
	},
	RecurringPaymentPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	RecurringPaymentPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"RecurringPaymentPageLocaleEdge"
	},
	RecurringPaymentPageLocaleEdge:{
		node:"RecurringPaymentPageLocale"
	},
	PostList:{
		_meta:"PostListMeta",
		id:"UUID",
		items:"PostListItem",
		paginateItems:"PostListItemConnection"
	},
	PostListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	PostListItem:{
		_meta:"PostListItemMeta",
		id:"UUID",
		order:"Int",
		list:"PostList",
		post:"Post"
	},
	PostListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		post:"FieldMeta"
	},
	PostListItemConnection:{
		pageInfo:"PageInfo",
		edges:"PostListItemEdge"
	},
	PostListItemEdge:{
		node:"PostListItem"
	},
	ScheduledNotificationLocale:{
		_meta:"ScheduledNotificationLocaleMeta",
		id:"UUID",
		title:"String",
		description:"String",
		root:"ScheduledNotification",
		locale:"Locale"
	},
	ScheduledNotificationLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	ScheduledNotification:{
		_meta:"ScheduledNotificationMeta",
		id:"UUID",
		localMsFromMidnight:"Int",
		scheduledDate:"Date",
		internalTitle:"String",
		target:"NotificationTargetGroup",
		locales:"ScheduledNotificationLocale",
		image:"Image",
		completedAt:"DateTime",
		processedNotifications:"ProcessedNotificationSource",
		localesByLocale:"ScheduledNotificationLocale",
		processedNotificationsByProcessedNotification:"ProcessedNotificationSource",
		paginateLocales:"ScheduledNotificationLocaleConnection",
		paginateProcessedNotifications:"ProcessedNotificationSourceConnection"
	},
	ScheduledNotificationMeta:{
		id:"FieldMeta",
		localMsFromMidnight:"FieldMeta",
		scheduledDate:"FieldMeta",
		internalTitle:"FieldMeta",
		target:"FieldMeta",
		locales:"FieldMeta",
		image:"FieldMeta",
		completedAt:"FieldMeta",
		processedNotifications:"FieldMeta"
	},
	NotificationTargetGroup:{
		_meta:"NotificationTargetGroupMeta",
		id:"UUID",
		type:"NotificationTargetType",
		regions:"Region",
		paginateRegions:"RegionConnection"
	},
	NotificationTargetGroupMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		regions:"FieldMeta"
	},
	RegionConnection:{
		pageInfo:"PageInfo",
		edges:"RegionEdge"
	},
	RegionEdge:{
		node:"Region"
	},
	ProcessedNotificationSource:{
		_meta:"ProcessedNotificationSourceMeta",
		id:"UUID",
		type:"ProcessedNotificationSourceType",
		processedNotification:"ProcessedNotification",
		donationReminderUser:"User",
		scheduledNotification:"ScheduledNotification"
	},
	ProcessedNotificationSourceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		processedNotification:"FieldMeta",
		donationReminderUser:"FieldMeta",
		scheduledNotification:"FieldMeta"
	},
	ProcessedNotification:{
		_meta:"ProcessedNotificationMeta",
		id:"UUID",
		topic:"String",
		sentAt:"DateTime",
		errorMessage:"String",
		errorCode:"String",
		isSuccess:"Boolean",
		source:"ProcessedNotificationSource",
		title:"String",
		body:"String"
	},
	ProcessedNotificationMeta:{
		id:"FieldMeta",
		topic:"FieldMeta",
		sentAt:"FieldMeta",
		errorMessage:"FieldMeta",
		errorCode:"FieldMeta",
		isSuccess:"FieldMeta",
		source:"FieldMeta",
		title:"FieldMeta",
		body:"FieldMeta"
	},
	User:{
		_meta:"UserMeta",
		id:"UUID",
		tenantPersonId:"UUID",
		createdAt:"DateTime",
		email:"String",
		name:"String",
		payments:"UserPayment",
		variableSymbol:"Int",
		lastActiveAt:"DateTime",
		region:"Region",
		currency:"Currency",
		recurringPayments:"UserRecurringPayment",
		stripeId:"String",
		isDeactivated:"Boolean",
		onBehalfDonations:"OnBehalfDonation",
		publicProfileSecret:"String",
		publicProfileCustomNote:"String",
		publicProfileCustomNoteEnabled:"Boolean",
		donationConfirmationEmailEnabled:"Boolean",
		locale:"Locale",
		signedUp:"Boolean",
		devices:"Device",
		processedNotifications:"ProcessedNotificationSource",
		areaStats:"UserAreaStats",
		organizationStats:"UserOrganizationStats",
		postStats:"UserPostStats",
		currencyStats:"UserCurrencyStats",
		stats:"UserStats",
		paymentsByOrder:"UserPayment",
		paymentsByCsobPayment:"UserPayment",
		paymentsByStripePayment:"UserPayment",
		paymentsByMetadata:"UserPayment",
		recurringPaymentsByItems:"UserRecurringPayment",
		recurringPaymentsByMeta:"UserRecurringPayment",
		onBehalfDonationsBySecretCode:"OnBehalfDonation",
		onBehalfDonationsByPayments:"OnBehalfDonation",
		onBehalfDonationsByMeta:"OnBehalfDonation",
		devicesByFcmToken:"Device",
		processedNotificationsByProcessedNotification:"ProcessedNotificationSource",
		paginatePayments:"UserPaymentConnection",
		paginateRecurringPayments:"UserRecurringPaymentConnection",
		paginateOnBehalfDonations:"OnBehalfDonationConnection",
		paginateDevices:"DeviceConnection",
		paginateProcessedNotifications:"ProcessedNotificationSourceConnection",
		paginateAreaStats:"UserAreaStatsConnection",
		paginateOrganizationStats:"UserOrganizationStatsConnection",
		paginatePostStats:"UserPostStatsConnection",
		paginateCurrencyStats:"UserCurrencyStatsConnection"
	},
	UserMeta:{
		id:"FieldMeta",
		tenantPersonId:"FieldMeta",
		createdAt:"FieldMeta",
		email:"FieldMeta",
		name:"FieldMeta",
		payments:"FieldMeta",
		variableSymbol:"FieldMeta",
		lastActiveAt:"FieldMeta",
		region:"FieldMeta",
		currency:"FieldMeta",
		recurringPayments:"FieldMeta",
		stripeId:"FieldMeta",
		isDeactivated:"FieldMeta",
		onBehalfDonations:"FieldMeta",
		publicProfileSecret:"FieldMeta",
		publicProfileCustomNote:"FieldMeta",
		publicProfileCustomNoteEnabled:"FieldMeta",
		donationConfirmationEmailEnabled:"FieldMeta",
		locale:"FieldMeta",
		signedUp:"FieldMeta",
		devices:"FieldMeta",
		processedNotifications:"FieldMeta",
		areaStats:"FieldMeta",
		organizationStats:"FieldMeta",
		postStats:"FieldMeta",
		currencyStats:"FieldMeta",
		stats:"FieldMeta"
	},
	UserPayment:{
		_meta:"UserPaymentMeta",
		id:"UUID",
		cents:"Int",
		createdAt:"DateTime",
		specificSymbol:"String",
		currency:"Currency",
		order:"UserPaymentOrderId",
		csobPayment:"CsobPayment",
		stripePayment:"StripePayment",
		recurringPaymentItem:"UserRecurringPaymentItem",
		method:"UserPaymentMethod",
		region:"Region",
		user:"User",
		isReusable:"Boolean",
		onBehalfDonation:"OnBehalfDonation",
		triesCollection:"UserPaymentTriesCollection",
		successEmailSentAt:"DateTime",
		isSuccessful:"Boolean",
		isFinished:"Boolean",
		metadata:"UserPaymentMetadata"
	},
	UserPaymentMeta:{
		id:"FieldMeta",
		cents:"FieldMeta",
		createdAt:"FieldMeta",
		specificSymbol:"FieldMeta",
		currency:"FieldMeta",
		order:"FieldMeta",
		csobPayment:"FieldMeta",
		stripePayment:"FieldMeta",
		recurringPaymentItem:"FieldMeta",
		method:"FieldMeta",
		region:"FieldMeta",
		user:"FieldMeta",
		isReusable:"FieldMeta",
		onBehalfDonation:"FieldMeta",
		triesCollection:"FieldMeta",
		successEmailSentAt:"FieldMeta",
		isSuccessful:"FieldMeta",
		isFinished:"FieldMeta",
		metadata:"FieldMeta"
	},
	UserPaymentOrderId:{
		_meta:"UserPaymentOrderIdMeta",
		id:"UUID",
		seq:"Int"
	},
	UserPaymentOrderIdMeta:{
		id:"FieldMeta",
		seq:"FieldMeta"
	},
	CsobPayment:{
		_meta:"CsobPaymentMeta",
		id:"UUID",
		payId:"String",
		statusChanges:"CsobPaymentStatusChange",
		payment:"UserPayment",
		originalPayId:"String",
		metadata:"CsobPaymentMetadata",
		paginateStatusChanges:"CsobPaymentStatusChangeConnection"
	},
	CsobPaymentMeta:{
		id:"FieldMeta",
		payId:"FieldMeta",
		statusChanges:"FieldMeta",
		payment:"FieldMeta",
		originalPayId:"FieldMeta",
		metadata:"FieldMeta"
	},
	CsobPaymentStatusChange:{
		_meta:"CsobPaymentStatusChangeMeta",
		id:"UUID",
		createdAt:"DateTime",
		dttm:"String",
		status:"Int",
		resultCode:"Int",
		message:"String",
		authCode:"String",
		statusDetail:"String",
		actions:"String",
		payment:"CsobPayment"
	},
	CsobPaymentStatusChangeMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		dttm:"FieldMeta",
		status:"FieldMeta",
		resultCode:"FieldMeta",
		message:"FieldMeta",
		authCode:"FieldMeta",
		statusDetail:"FieldMeta",
		actions:"FieldMeta",
		payment:"FieldMeta"
	},
	CsobPaymentMetadata:{
		_meta:"CsobPaymentMetadataMeta",
		id:"UUID",
		status:"Int",
		isSuccessful:"Boolean",
		isFinished:"Boolean",
		resolvedOriginalPayId:"String",
		csobPayment:"CsobPayment"
	},
	CsobPaymentMetadataMeta:{
		id:"FieldMeta",
		status:"FieldMeta",
		isSuccessful:"FieldMeta",
		isFinished:"FieldMeta",
		resolvedOriginalPayId:"FieldMeta",
		csobPayment:"FieldMeta"
	},
	CsobPaymentStatusChangeConnection:{
		pageInfo:"PageInfo",
		edges:"CsobPaymentStatusChangeEdge"
	},
	CsobPaymentStatusChangeEdge:{
		node:"CsobPaymentStatusChange"
	},
	StripePayment:{
		_meta:"StripePaymentMeta",
		id:"UUID",
		identifier:"String",
		statusChanges:"StripePaymentStatusChange",
		payment:"UserPayment",
		metadata:"StripePaymentMetadata",
		paginateStatusChanges:"StripePaymentStatusChangeConnection"
	},
	StripePaymentMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		statusChanges:"FieldMeta",
		payment:"FieldMeta",
		metadata:"FieldMeta"
	},
	StripePaymentStatusChange:{
		_meta:"StripePaymentStatusChangeMeta",
		id:"UUID",
		createdAt:"DateTime",
		payment:"StripePayment",
		timestamp:"Int",
		eventId:"String",
		paymentIntentStatus:"StripePaymentStatusChangePaymentIntentStatus"
	},
	StripePaymentStatusChangeMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		payment:"FieldMeta",
		timestamp:"FieldMeta",
		eventId:"FieldMeta",
		paymentIntentStatus:"FieldMeta"
	},
	StripePaymentMetadata:{
		_meta:"StripePaymentMetadataMeta",
		id:"UUID",
		status:"Int",
		isSuccessful:"Boolean",
		isFinished:"Boolean",
		stripePayment:"StripePayment"
	},
	StripePaymentMetadataMeta:{
		id:"FieldMeta",
		status:"FieldMeta",
		isSuccessful:"FieldMeta",
		isFinished:"FieldMeta",
		stripePayment:"FieldMeta"
	},
	StripePaymentStatusChangeConnection:{
		pageInfo:"PageInfo",
		edges:"StripePaymentStatusChangeEdge"
	},
	StripePaymentStatusChangeEdge:{
		node:"StripePaymentStatusChange"
	},
	UserRecurringPaymentItem:{
		_meta:"UserRecurringPaymentItemMeta",
		id:"UUID",
		recurrenceCounter:"Int",
		createdAt:"DateTime",
		taskId:"String",
		payments:"UserPayment",
		recurringPayment:"UserRecurringPayment",
		isFailed:"Boolean",
		failedEmailSentAt:"DateTime",
		meta:"UserRecurringPaymentItemMetadata",
		paymentsByOrder:"UserPayment",
		paymentsByCsobPayment:"UserPayment",
		paymentsByStripePayment:"UserPayment",
		paymentsByMetadata:"UserPayment",
		paginatePayments:"UserPaymentConnection"
	},
	UserRecurringPaymentItemMeta:{
		id:"FieldMeta",
		recurrenceCounter:"FieldMeta",
		createdAt:"FieldMeta",
		taskId:"FieldMeta",
		payments:"FieldMeta",
		recurringPayment:"FieldMeta",
		isFailed:"FieldMeta",
		failedEmailSentAt:"FieldMeta",
		meta:"FieldMeta"
	},
	UserRecurringPayment:{
		_meta:"UserRecurringPaymentMeta",
		id:"UUID",
		activeSince:"DateTime",
		cancelledAt:"DateTime",
		cents:"Int",
		interval:"UserRecurringPaymentInterval",
		currency:"Currency",
		items:"UserRecurringPaymentItem",
		user:"User",
		meta:"UpcomingUserRecurringPaymentMetadata",
		itemsByRecurrenceCounter:"UserRecurringPaymentItem",
		itemsByPayments:"UserRecurringPaymentItem",
		itemsByMeta:"UserRecurringPaymentItem",
		paginateItems:"UserRecurringPaymentItemConnection"
	},
	UserRecurringPaymentMeta:{
		id:"FieldMeta",
		activeSince:"FieldMeta",
		cancelledAt:"FieldMeta",
		cents:"FieldMeta",
		interval:"FieldMeta",
		currency:"FieldMeta",
		items:"FieldMeta",
		user:"FieldMeta",
		meta:"FieldMeta"
	},
	UpcomingUserRecurringPaymentMetadata:{
		_meta:"UpcomingUserRecurringPaymentMetadataMeta",
		id:"UUID",
		recurrenceCounter:"Int",
		isBehindPayments:"Boolean",
		nextPaymentDate:"DateTime",
		shouldBeProcessed:"Boolean",
		firstPayment:"UserPayment",
		firstSuccessfulPayment:"UserPayment",
		drivingPayment:"UserPayment",
		recurringPayment:"UserRecurringPayment"
	},
	UpcomingUserRecurringPaymentMetadataMeta:{
		id:"FieldMeta",
		recurrenceCounter:"FieldMeta",
		isBehindPayments:"FieldMeta",
		nextPaymentDate:"FieldMeta",
		shouldBeProcessed:"FieldMeta",
		firstPayment:"FieldMeta",
		firstSuccessfulPayment:"FieldMeta",
		drivingPayment:"FieldMeta",
		recurringPayment:"FieldMeta"
	},
	UserRecurringPaymentItemConnection:{
		pageInfo:"PageInfo",
		edges:"UserRecurringPaymentItemEdge"
	},
	UserRecurringPaymentItemEdge:{
		node:"UserRecurringPaymentItem"
	},
	UserRecurringPaymentItemMetadata:{
		_meta:"UserRecurringPaymentItemMetadataMeta",
		id:"UUID",
		isSuccessfullyPaid:"Boolean",
		shouldBeProcessed:"Boolean",
		firstPayment:"UserPayment",
		lastPayment:"UserPayment",
		firstSuccessfulPayment:"UserPayment",
		drivingPayment:"UserPayment",
		recurringPaymentItem:"UserRecurringPaymentItem"
	},
	UserRecurringPaymentItemMetadataMeta:{
		id:"FieldMeta",
		isSuccessfullyPaid:"FieldMeta",
		shouldBeProcessed:"FieldMeta",
		firstPayment:"FieldMeta",
		lastPayment:"FieldMeta",
		firstSuccessfulPayment:"FieldMeta",
		drivingPayment:"FieldMeta",
		recurringPaymentItem:"FieldMeta"
	},
	UserPaymentConnection:{
		pageInfo:"PageInfo",
		edges:"UserPaymentEdge"
	},
	UserPaymentEdge:{
		node:"UserPayment"
	},
	OnBehalfDonation:{
		_meta:"OnBehalfDonationMeta",
		id:"UUID",
		secretCode:"String",
		specificSymbol:"String",
		createdAt:"DateTime",
		payments:"UserPayment",
		onBehalfOf:"User",
		meta:"OnBehalfDonationMetadata",
		paymentsByOrder:"UserPayment",
		paymentsByCsobPayment:"UserPayment",
		paymentsByStripePayment:"UserPayment",
		paymentsByMetadata:"UserPayment",
		paginatePayments:"UserPaymentConnection"
	},
	OnBehalfDonationMeta:{
		id:"FieldMeta",
		secretCode:"FieldMeta",
		specificSymbol:"FieldMeta",
		createdAt:"FieldMeta",
		payments:"FieldMeta",
		onBehalfOf:"FieldMeta",
		meta:"FieldMeta"
	},
	OnBehalfDonationMetadata:{
		_meta:"OnBehalfDonationMetadataMeta",
		id:"UUID",
		area:"PostArea",
		organization:"PostOrganization",
		post:"Post",
		onBehalfOfDonation:"OnBehalfDonation"
	},
	OnBehalfDonationMetadataMeta:{
		id:"FieldMeta",
		area:"FieldMeta",
		organization:"FieldMeta",
		post:"FieldMeta",
		onBehalfOfDonation:"FieldMeta"
	},
	UserPaymentTriesCollection:{
		_meta:"UserPaymentTriesCollectionMeta",
		id:"UUID",
		cents:"Int",
		specificSymbol:"String",
		createdAt:"DateTime",
		orderUrl:"String",
		payment:"UserPayment",
		user:"User",
		currency:"Currency",
		onBehalfDonation:"OnBehalfDonation",
		recurring:"UserRecurringPayment",
		metadata:"UserPaymentTriesCollectionMetadata",
		metadataLocales:"UserPaymentTriesCollectionMetadataLocale",
		medium:"PaymentMedium",
		paymentByOrder:"UserPayment",
		paymentByCsobPayment:"UserPayment",
		paymentByStripePayment:"UserPayment",
		paymentByMetadata:"UserPayment",
		metadataLocalesByLocale:"UserPaymentTriesCollectionMetadataLocale",
		paginatePayment:"UserPaymentConnection",
		paginateMetadataLocales:"UserPaymentTriesCollectionMetadataLocaleConnection"
	},
	UserPaymentTriesCollectionMeta:{
		id:"FieldMeta",
		cents:"FieldMeta",
		specificSymbol:"FieldMeta",
		createdAt:"FieldMeta",
		orderUrl:"FieldMeta",
		payment:"FieldMeta",
		user:"FieldMeta",
		currency:"FieldMeta",
		onBehalfDonation:"FieldMeta",
		recurring:"FieldMeta",
		metadata:"FieldMeta",
		metadataLocales:"FieldMeta",
		medium:"FieldMeta"
	},
	UserPaymentTriesCollectionMetadata:{
		_meta:"UserPaymentTriesCollectionMetadataMeta",
		id:"UUID",
		area:"PostArea",
		organization:"PostOrganization",
		post:"Post",
		triesCollection:"UserPaymentTriesCollection"
	},
	UserPaymentTriesCollectionMetadataMeta:{
		id:"FieldMeta",
		area:"FieldMeta",
		organization:"FieldMeta",
		post:"FieldMeta",
		triesCollection:"FieldMeta"
	},
	UserPaymentTriesCollectionMetadataLocale:{
		_meta:"UserPaymentTriesCollectionMetadataLocaleMeta",
		id:"UUID",
		locale:"Locale",
		title:"String",
		parent:"UserPaymentTriesCollection"
	},
	UserPaymentTriesCollectionMetadataLocaleMeta:{
		id:"FieldMeta",
		locale:"FieldMeta",
		title:"FieldMeta",
		parent:"FieldMeta"
	},
	UserPaymentTriesCollectionMetadataLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"UserPaymentTriesCollectionMetadataLocaleEdge"
	},
	UserPaymentTriesCollectionMetadataLocaleEdge:{
		node:"UserPaymentTriesCollectionMetadataLocale"
	},
	UserPaymentMetadata:{
		_meta:"UserPaymentMetadataMeta",
		id:"UUID",
		area:"PostArea",
		organization:"PostOrganization",
		organizationUnfiltered:"PostOrganization",
		post:"Post",
		countToUser:"User",
		paymentType:"String",
		statusLabel:"String",
		isSuccessful:"Boolean",
		isFinished:"Boolean",
		needsCacheUpdate:"Boolean",
		isSuccessfulNotCached:"Boolean",
		isFinishedNotCached:"Boolean",
		userPayment:"UserPayment"
	},
	UserPaymentMetadataMeta:{
		id:"FieldMeta",
		area:"FieldMeta",
		organization:"FieldMeta",
		organizationUnfiltered:"FieldMeta",
		post:"FieldMeta",
		countToUser:"FieldMeta",
		paymentType:"FieldMeta",
		statusLabel:"FieldMeta",
		isSuccessful:"FieldMeta",
		isFinished:"FieldMeta",
		needsCacheUpdate:"FieldMeta",
		isSuccessfulNotCached:"FieldMeta",
		isFinishedNotCached:"FieldMeta",
		userPayment:"FieldMeta"
	},
	Device:{
		_meta:"DeviceMeta",
		id:"UUID",
		user:"User",
		fcmToken:"String",
		createdAt:"DateTime",
		ipAddress:"String",
		userAgent:"String",
		lastActiveAt:"DateTime"
	},
	DeviceMeta:{
		id:"FieldMeta",
		user:"FieldMeta",
		fcmToken:"FieldMeta",
		createdAt:"FieldMeta",
		ipAddress:"FieldMeta",
		userAgent:"FieldMeta",
		lastActiveAt:"FieldMeta"
	},
	UserAreaStats:{
		_meta:"UserAreaStatsMeta",
		id:"UUID",
		area:"PostArea",
		currency:"Currency",
		totalCents:"Int",
		user:"User"
	},
	UserAreaStatsMeta:{
		id:"FieldMeta",
		area:"FieldMeta",
		currency:"FieldMeta",
		totalCents:"FieldMeta",
		user:"FieldMeta"
	},
	UserOrganizationStats:{
		_meta:"UserOrganizationStatsMeta",
		id:"UUID",
		organization:"PostOrganization",
		currency:"Currency",
		totalCents:"Int",
		user:"User"
	},
	UserOrganizationStatsMeta:{
		id:"FieldMeta",
		organization:"FieldMeta",
		currency:"FieldMeta",
		totalCents:"FieldMeta",
		user:"FieldMeta"
	},
	UserPostStats:{
		_meta:"UserPostStatsMeta",
		id:"UUID",
		post:"Post",
		currency:"Currency",
		totalCents:"Int",
		user:"User"
	},
	UserPostStatsMeta:{
		id:"FieldMeta",
		post:"FieldMeta",
		currency:"FieldMeta",
		totalCents:"FieldMeta",
		user:"FieldMeta"
	},
	UserCurrencyStats:{
		_meta:"UserCurrencyStatsMeta",
		id:"UUID",
		currency:"Currency",
		totalAmountPaymentsOnce:"Int",
		totalAmountPaymentsRegular:"Int",
		user:"User"
	},
	UserCurrencyStatsMeta:{
		id:"FieldMeta",
		currency:"FieldMeta",
		totalAmountPaymentsOnce:"FieldMeta",
		totalAmountPaymentsRegular:"FieldMeta",
		user:"FieldMeta"
	},
	UserStats:{
		_meta:"UserStatsMeta",
		id:"UUID",
		totalPaymentsSuccessful:"Int",
		totalPaymentsUnsuccessful:"Int",
		user:"User"
	},
	UserStatsMeta:{
		id:"FieldMeta",
		totalPaymentsSuccessful:"FieldMeta",
		totalPaymentsUnsuccessful:"FieldMeta",
		user:"FieldMeta"
	},
	UserRecurringPaymentConnection:{
		pageInfo:"PageInfo",
		edges:"UserRecurringPaymentEdge"
	},
	UserRecurringPaymentEdge:{
		node:"UserRecurringPayment"
	},
	OnBehalfDonationConnection:{
		pageInfo:"PageInfo",
		edges:"OnBehalfDonationEdge"
	},
	OnBehalfDonationEdge:{
		node:"OnBehalfDonation"
	},
	DeviceConnection:{
		pageInfo:"PageInfo",
		edges:"DeviceEdge"
	},
	DeviceEdge:{
		node:"Device"
	},
	ProcessedNotificationSourceConnection:{
		pageInfo:"PageInfo",
		edges:"ProcessedNotificationSourceEdge"
	},
	ProcessedNotificationSourceEdge:{
		node:"ProcessedNotificationSource"
	},
	UserAreaStatsConnection:{
		pageInfo:"PageInfo",
		edges:"UserAreaStatsEdge"
	},
	UserAreaStatsEdge:{
		node:"UserAreaStats"
	},
	UserOrganizationStatsConnection:{
		pageInfo:"PageInfo",
		edges:"UserOrganizationStatsEdge"
	},
	UserOrganizationStatsEdge:{
		node:"UserOrganizationStats"
	},
	UserPostStatsConnection:{
		pageInfo:"PageInfo",
		edges:"UserPostStatsEdge"
	},
	UserPostStatsEdge:{
		node:"UserPostStats"
	},
	UserCurrencyStatsConnection:{
		pageInfo:"PageInfo",
		edges:"UserCurrencyStatsEdge"
	},
	UserCurrencyStatsEdge:{
		node:"UserCurrencyStats"
	},
	ScheduledNotificationLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ScheduledNotificationLocaleEdge"
	},
	ScheduledNotificationLocaleEdge:{
		node:"ScheduledNotificationLocale"
	},
	GeneralLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"GeneralLocaleEdge"
	},
	GeneralLocaleEdge:{
		node:"GeneralLocale"
	},
	GeneralConnection:{
		pageInfo:"PageInfo",
		edges:"GeneralEdge"
	},
	GeneralEdge:{
		node:"General"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	LocaleConnection:{
		pageInfo:"PageInfo",
		edges:"LocaleEdge"
	},
	LocaleEdge:{
		node:"Locale"
	},
	VideoConnection:{
		pageInfo:"PageInfo",
		edges:"VideoEdge"
	},
	VideoEdge:{
		node:"Video"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	PostAreaConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaEdge"
	},
	PostAreaEdge:{
		node:"PostArea"
	},
	PostOrganizationConnection:{
		pageInfo:"PageInfo",
		edges:"PostOrganizationEdge"
	},
	PostOrganizationEdge:{
		node:"PostOrganization"
	},
	DonationConnection:{
		pageInfo:"PageInfo",
		edges:"DonationEdge"
	},
	DonationEdge:{
		node:"Donation"
	},
	DonationAmountsRegionListConnection:{
		pageInfo:"PageInfo",
		edges:"DonationAmountsRegionListEdge"
	},
	DonationAmountsRegionListEdge:{
		node:"DonationAmountsRegionList"
	},
	LinkListConnection:{
		pageInfo:"PageInfo",
		edges:"LinkListEdge"
	},
	LinkListEdge:{
		node:"LinkList"
	},
	HeaderConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderEdge"
	},
	HeaderEdge:{
		node:"Header"
	},
	FooterConnection:{
		pageInfo:"PageInfo",
		edges:"FooterEdge"
	},
	FooterEdge:{
		node:"Footer"
	},
	PostListConnection:{
		pageInfo:"PageInfo",
		edges:"PostListEdge"
	},
	PostListEdge:{
		node:"PostList"
	},
	AppBannerConnection:{
		pageInfo:"PageInfo",
		edges:"AppBannerEdge"
	},
	AppBannerEdge:{
		node:"AppBanner"
	},
	GenericPageAboutSettingsConnection:{
		pageInfo:"PageInfo",
		edges:"GenericPageAboutSettingsEdge"
	},
	GenericPageAboutSettingsEdge:{
		node:"GenericPageAboutSettings"
	},
	ValueConnection:{
		pageInfo:"PageInfo",
		edges:"ValueEdge"
	},
	ValueEdge:{
		node:"Value"
	},
	ValueListConnection:{
		pageInfo:"PageInfo",
		edges:"ValueListEdge"
	},
	ValueListEdge:{
		node:"ValueList"
	},
	ImageLinkConnection:{
		pageInfo:"PageInfo",
		edges:"ImageLinkEdge"
	},
	ImageLinkEdge:{
		node:"ImageLink"
	},
	ImageLinkListConnection:{
		pageInfo:"PageInfo",
		edges:"ImageLinkListEdge"
	},
	ImageLinkListEdge:{
		node:"ImageLinkList"
	},
	PostAreaListConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaListEdge"
	},
	PostAreaListEdge:{
		node:"PostAreaList"
	},
	AccordionConnection:{
		pageInfo:"PageInfo",
		edges:"AccordionEdge"
	},
	AccordionEdge:{
		node:"Accordion"
	},
	UserConnection:{
		pageInfo:"PageInfo",
		edges:"UserEdge"
	},
	UserEdge:{
		node:"User"
	},
	CurrencyConnection:{
		pageInfo:"PageInfo",
		edges:"CurrencyEdge"
	},
	CurrencyEdge:{
		node:"Currency"
	},
	MediumConnection:{
		pageInfo:"PageInfo",
		edges:"MediumEdge"
	},
	MediumEdge:{
		node:"Medium"
	},
	MediumListConnection:{
		pageInfo:"PageInfo",
		edges:"MediumListEdge"
	},
	MediumListEdge:{
		node:"MediumList"
	},
	UserPaymentOrderIdConnection:{
		pageInfo:"PageInfo",
		edges:"UserPaymentOrderIdEdge"
	},
	UserPaymentOrderIdEdge:{
		node:"UserPaymentOrderId"
	},
	TranslationCatalogue:{
		_meta:"TranslationCatalogueMeta",
		id:"UUID",
		domain:"TranslationDomain",
		identifier:"TranslationCataloguesIdentifier",
		fallback:"TranslationCatalogue",
		values:"TranslationValue",
		valuesByKey:"TranslationValue",
		paginateValues:"TranslationValueConnection"
	},
	TranslationCatalogueMeta:{
		id:"FieldMeta",
		domain:"FieldMeta",
		identifier:"FieldMeta",
		fallback:"FieldMeta",
		values:"FieldMeta"
	},
	TranslationDomain:{
		_meta:"TranslationDomainMeta",
		id:"UUID",
		identifier:"String",
		name:"String",
		catalogues:"TranslationCatalogue",
		keys:"TranslationKey",
		cataloguesByIdentifier:"TranslationCatalogue",
		cataloguesByValues:"TranslationCatalogue",
		keysByIdentifier:"TranslationKey",
		keysByValues:"TranslationKey",
		paginateCatalogues:"TranslationCatalogueConnection",
		paginateKeys:"TranslationKeyConnection"
	},
	TranslationDomainMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		name:"FieldMeta",
		catalogues:"FieldMeta",
		keys:"FieldMeta"
	},
	TranslationKey:{
		_meta:"TranslationKeyMeta",
		id:"UUID",
		identifier:"String",
		contentType:"TranslationKeyContentType",
		note:"String",
		domain:"TranslationDomain",
		values:"TranslationValue",
		valuesByCatalogue:"TranslationValue",
		paginateValues:"TranslationValueConnection"
	},
	TranslationKeyMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		contentType:"FieldMeta",
		note:"FieldMeta",
		domain:"FieldMeta",
		values:"FieldMeta"
	},
	TranslationValue:{
		_meta:"TranslationValueMeta",
		id:"UUID",
		value:"String",
		catalogue:"TranslationCatalogue",
		key:"TranslationKey"
	},
	TranslationValueMeta:{
		id:"FieldMeta",
		value:"FieldMeta",
		catalogue:"FieldMeta",
		key:"FieldMeta"
	},
	TranslationValueConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationValueEdge"
	},
	TranslationValueEdge:{
		node:"TranslationValue"
	},
	TranslationCatalogueConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationCatalogueEdge"
	},
	TranslationCatalogueEdge:{
		node:"TranslationCatalogue"
	},
	TranslationKeyConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationKeyEdge"
	},
	TranslationKeyEdge:{
		node:"TranslationKey"
	},
	TranslationCataloguesIdentifier:{
		_meta:"TranslationCataloguesIdentifierMeta",
		id:"UUID",
		name:"String",
		code:"String",
		catalogue:"TranslationCatalogue",
		catalogueByDomain:"TranslationCatalogue",
		catalogueByValues:"TranslationCatalogue",
		paginateCatalogue:"TranslationCatalogueConnection"
	},
	TranslationCataloguesIdentifierMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		catalogue:"FieldMeta"
	},
	TranslationCataloguesIdentifierConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationCataloguesIdentifierEdge"
	},
	TranslationCataloguesIdentifierEdge:{
		node:"TranslationCataloguesIdentifier"
	},
	TranslationDomainConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationDomainEdge"
	},
	TranslationDomainEdge:{
		node:"TranslationDomain"
	},
	MemberListConnection:{
		pageInfo:"PageInfo",
		edges:"MemberListEdge"
	},
	MemberListEdge:{
		node:"MemberList"
	},
	FilledTaxFormConnection:{
		pageInfo:"PageInfo",
		edges:"FilledTaxFormEdge"
	},
	FilledTaxFormEdge:{
		node:"FilledTaxForm"
	},
	FilledTaxFormEmailAddress:{
		_meta:"FilledTaxFormEmailAddressMeta",
		id:"UUID",
		order:"Int",
		email:"String"
	},
	FilledTaxFormEmailAddressMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		email:"FieldMeta"
	},
	FilledTaxFormEmailAddressConnection:{
		pageInfo:"PageInfo",
		edges:"FilledTaxFormEmailAddressEdge"
	},
	FilledTaxFormEmailAddressEdge:{
		node:"FilledTaxFormEmailAddress"
	},
	FormConnection:{
		pageInfo:"PageInfo",
		edges:"FormEdge"
	},
	FormEdge:{
		node:"Form"
	},
	CsobPaymentConnection:{
		pageInfo:"PageInfo",
		edges:"CsobPaymentEdge"
	},
	CsobPaymentEdge:{
		node:"CsobPayment"
	},
	StripePaymentConnection:{
		pageInfo:"PageInfo",
		edges:"StripePaymentEdge"
	},
	StripePaymentEdge:{
		node:"StripePayment"
	},
	PostAreaMetaDataConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaMetaDataEdge"
	},
	PostAreaMetaDataEdge:{
		node:"PostAreaMetaData"
	},
	PostMetaDataConnection:{
		pageInfo:"PageInfo",
		edges:"PostMetaDataEdge"
	},
	PostMetaDataEdge:{
		node:"PostMetaData"
	},
	PostOrganizationMetaDataConnection:{
		pageInfo:"PageInfo",
		edges:"PostOrganizationMetaDataEdge"
	},
	PostOrganizationMetaDataEdge:{
		node:"PostOrganizationMetaData"
	},
	TileListConnection:{
		pageInfo:"PageInfo",
		edges:"TileListEdge"
	},
	TileListEdge:{
		node:"TileList"
	},
	FeedPageConnection:{
		pageInfo:"PageInfo",
		edges:"FeedPageEdge"
	},
	FeedPageEdge:{
		node:"FeedPage"
	},
	CardListConnection:{
		pageInfo:"PageInfo",
		edges:"CardListEdge"
	},
	CardListEdge:{
		node:"CardList"
	},
	UserPaymentTriesCollectionConnection:{
		pageInfo:"PageInfo",
		edges:"UserPaymentTriesCollectionEdge"
	},
	UserPaymentTriesCollectionEdge:{
		node:"UserPaymentTriesCollection"
	},
	RecurringPaymentPageConnection:{
		pageInfo:"PageInfo",
		edges:"RecurringPaymentPageEdge"
	},
	RecurringPaymentPageEdge:{
		node:"RecurringPaymentPage"
	},
	StoryGuideConnection:{
		pageInfo:"PageInfo",
		edges:"StoryGuideEdge"
	},
	StoryGuideEdge:{
		node:"StoryGuide"
	},
	StoryGuideListConnection:{
		pageInfo:"PageInfo",
		edges:"StoryGuideListEdge"
	},
	StoryGuideListEdge:{
		node:"StoryGuideList"
	},
	StripePaymentMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"StripePaymentMetadataEdge"
	},
	StripePaymentMetadataEdge:{
		node:"StripePaymentMetadata"
	},
	OnBehalfDonationMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"OnBehalfDonationMetadataEdge"
	},
	OnBehalfDonationMetadataEdge:{
		node:"OnBehalfDonationMetadata"
	},
	UserPaymentTriesCollectionMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"UserPaymentTriesCollectionMetadataEdge"
	},
	UserPaymentTriesCollectionMetadataEdge:{
		node:"UserPaymentTriesCollectionMetadata"
	},
	CsobPaymentMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"CsobPaymentMetadataEdge"
	},
	CsobPaymentMetadataEdge:{
		node:"CsobPaymentMetadata"
	},
	PostOrganizationListConnection:{
		pageInfo:"PageInfo",
		edges:"PostOrganizationListEdge"
	},
	PostOrganizationListEdge:{
		node:"PostOrganizationList"
	},
	InfoCarousel:{
		_meta:"InfoCarouselMeta",
		id:"UUID",
		name:"String",
		isEnabled:"Boolean",
		validFrom:"DateTime",
		validTo:"DateTime",
		items:"InfoCarouselItem",
		seenBy:"PersonSeenInfoCarousel",
		itemsByLocales:"InfoCarouselItem",
		seenByByUser:"PersonSeenInfoCarousel",
		paginateItems:"InfoCarouselItemConnection",
		paginateSeenBy:"PersonSeenInfoCarouselConnection"
	},
	InfoCarouselMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		isEnabled:"FieldMeta",
		validFrom:"FieldMeta",
		validTo:"FieldMeta",
		items:"FieldMeta",
		seenBy:"FieldMeta"
	},
	InfoCarouselItem:{
		_meta:"InfoCarouselItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		carousel:"InfoCarousel",
		image:"Image",
		post:"Post",
		subtitle:"String",
		type:"InfoCarouselItemType",
		locales:"InfoCarouselItemLocale",
		localesByLocale:"InfoCarouselItemLocale",
		paginateLocales:"InfoCarouselItemLocaleConnection"
	},
	InfoCarouselItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		carousel:"FieldMeta",
		image:"FieldMeta",
		post:"FieldMeta",
		subtitle:"FieldMeta",
		type:"FieldMeta",
		locales:"FieldMeta"
	},
	InfoCarouselItemLocale:{
		_meta:"InfoCarouselItemLocaleMeta",
		id:"UUID",
		title:"String",
		subtitle:"String",
		root:"InfoCarouselItem",
		locale:"Locale"
	},
	InfoCarouselItemLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		subtitle:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	InfoCarouselItemLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"InfoCarouselItemLocaleEdge"
	},
	InfoCarouselItemLocaleEdge:{
		node:"InfoCarouselItemLocale"
	},
	PersonSeenInfoCarousel:{
		_meta:"PersonSeenInfoCarouselMeta",
		id:"UUID",
		seenAt:"DateTime",
		user:"User",
		carousel:"InfoCarousel"
	},
	PersonSeenInfoCarouselMeta:{
		id:"FieldMeta",
		seenAt:"FieldMeta",
		user:"FieldMeta",
		carousel:"FieldMeta"
	},
	InfoCarouselItemConnection:{
		pageInfo:"PageInfo",
		edges:"InfoCarouselItemEdge"
	},
	InfoCarouselItemEdge:{
		node:"InfoCarouselItem"
	},
	PersonSeenInfoCarouselConnection:{
		pageInfo:"PageInfo",
		edges:"PersonSeenInfoCarouselEdge"
	},
	PersonSeenInfoCarouselEdge:{
		node:"PersonSeenInfoCarousel"
	},
	InfoCarouselConnection:{
		pageInfo:"PageInfo",
		edges:"InfoCarouselEdge"
	},
	InfoCarouselEdge:{
		node:"InfoCarousel"
	},
	GivenGiftsPageConnection:{
		pageInfo:"PageInfo",
		edges:"GivenGiftsPageEdge"
	},
	GivenGiftsPageEdge:{
		node:"GivenGiftsPage"
	},
	ReceivedGiftsPageConnection:{
		pageInfo:"PageInfo",
		edges:"ReceivedGiftsPageEdge"
	},
	ReceivedGiftsPageEdge:{
		node:"ReceivedGiftsPage"
	},
	ReportNavigationConnection:{
		pageInfo:"PageInfo",
		edges:"ReportNavigationEdge"
	},
	ReportNavigationEdge:{
		node:"ReportNavigation"
	},
	ReportPageConnection:{
		pageInfo:"PageInfo",
		edges:"ReportPageEdge"
	},
	ReportPageEdge:{
		node:"ReportPage"
	},
	PostAreaSentPaymentSumConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaSentPaymentSumEdge"
	},
	PostAreaSentPaymentSumEdge:{
		node:"PostAreaSentPaymentSum"
	},
	NotificationTargetGroupConnection:{
		pageInfo:"PageInfo",
		edges:"NotificationTargetGroupEdge"
	},
	NotificationTargetGroupEdge:{
		node:"NotificationTargetGroup"
	},
	ProcessedNotificationConnection:{
		pageInfo:"PageInfo",
		edges:"ProcessedNotificationEdge"
	},
	ProcessedNotificationEdge:{
		node:"ProcessedNotification"
	},
	ScheduledNotificationConnection:{
		pageInfo:"PageInfo",
		edges:"ScheduledNotificationEdge"
	},
	ScheduledNotificationEdge:{
		node:"ScheduledNotification"
	},
	UserPaymentMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"UserPaymentMetadataEdge"
	},
	UserPaymentMetadataEdge:{
		node:"UserPaymentMetadata"
	},
	PostAreaSumConnection:{
		pageInfo:"PageInfo",
		edges:"PostAreaSumEdge"
	},
	PostAreaSumEdge:{
		node:"PostAreaSum"
	},
	PostOrganizationSumConnection:{
		pageInfo:"PageInfo",
		edges:"PostOrganizationSumEdge"
	},
	PostOrganizationSumEdge:{
		node:"PostOrganizationSum"
	},
	Stats:{
		_meta:"StatsMeta",
		id:"UUID",
		unique:"One",
		totalUserCount:"Int",
		successfulPaymentCount:"Int",
		sentPaymentCount:"Int",
		totalAreaCents:"Int",
		totalAreaSentPaymentCents:"Int",
		totalAreaCzkPercentage:"Float",
		totalAreaSentPaymentCzkPercentage:"Float"
	},
	StatsMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		totalUserCount:"FieldMeta",
		successfulPaymentCount:"FieldMeta",
		sentPaymentCount:"FieldMeta",
		totalAreaCents:"FieldMeta",
		totalAreaSentPaymentCents:"FieldMeta",
		totalAreaCzkPercentage:"FieldMeta",
		totalAreaSentPaymentCzkPercentage:"FieldMeta"
	},
	StatsConnection:{
		pageInfo:"PageInfo",
		edges:"StatsEdge"
	},
	StatsEdge:{
		node:"Stats"
	},
	UserRecurringPaymentItemMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"UserRecurringPaymentItemMetadataEdge"
	},
	UserRecurringPaymentItemMetadataEdge:{
		node:"UserRecurringPaymentItemMetadata"
	},
	UpcomingUserRecurringPaymentMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"UpcomingUserRecurringPaymentMetadataEdge"
	},
	UpcomingUserRecurringPaymentMetadataEdge:{
		node:"UpcomingUserRecurringPaymentMetadata"
	},
	UserStatsConnection:{
		pageInfo:"PageInfo",
		edges:"UserStatsEdge"
	},
	UserStatsEdge:{
		node:"UserStats"
	},
	TextImageListConnection:{
		pageInfo:"PageInfo",
		edges:"TextImageListEdge"
	},
	TextImageListEdge:{
		node:"TextImageList"
	},
	PostSumConnection:{
		pageInfo:"PageInfo",
		edges:"PostSumEdge"
	},
	PostSumEdge:{
		node:"PostSum"
	},
	PostFundraisingProgressConnection:{
		pageInfo:"PageInfo",
		edges:"PostFundraisingProgressEdge"
	},
	PostFundraisingProgressEdge:{
		node:"PostFundraisingProgress"
	},
	QueryTransaction:{
		schema:"_Schema",
		s3DummyQuery:"String",
		getGeneral:"General",
		listGeneral:"General",
		paginateGeneral:"GeneralConnection",
		validateCreateGeneral:"_ValidationResult",
		validateUpdateGeneral:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getGenericPage:"GenericPage",
		listGenericPage:"GenericPage",
		paginateGenericPage:"GenericPageConnection",
		validateCreateGenericPage:"_ValidationResult",
		validateUpdateGenericPage:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getContentReferenceLinkableItem:"ContentReferenceLinkableItem",
		listContentReferenceLinkableItem:"ContentReferenceLinkableItem",
		paginateContentReferenceLinkableItem:"ContentReferenceLinkableItemConnection",
		getGeneralLocale:"GeneralLocale",
		listGeneralLocale:"GeneralLocale",
		paginateGeneralLocale:"GeneralLocaleConnection",
		validateCreateGeneralLocale:"_ValidationResult",
		validateUpdateGeneralLocale:"_ValidationResult",
		getGenericPageLocale:"GenericPageLocale",
		listGenericPageLocale:"GenericPageLocale",
		paginateGenericPageLocale:"GenericPageLocaleConnection",
		validateCreateGenericPageLocale:"_ValidationResult",
		validateUpdateGenericPageLocale:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getPost:"Post",
		listPost:"Post",
		paginatePost:"PostConnection",
		validateCreatePost:"_ValidationResult",
		validateUpdatePost:"_ValidationResult",
		getPostLocale:"PostLocale",
		listPostLocale:"PostLocale",
		paginatePostLocale:"PostLocaleConnection",
		validateCreatePostLocale:"_ValidationResult",
		validateUpdatePostLocale:"_ValidationResult",
		getPostArea:"PostArea",
		listPostArea:"PostArea",
		paginatePostArea:"PostAreaConnection",
		validateCreatePostArea:"_ValidationResult",
		validateUpdatePostArea:"_ValidationResult",
		getPostAreaLocale:"PostAreaLocale",
		listPostAreaLocale:"PostAreaLocale",
		paginatePostAreaLocale:"PostAreaLocaleConnection",
		validateCreatePostAreaLocale:"_ValidationResult",
		validateUpdatePostAreaLocale:"_ValidationResult",
		getPostOrganization:"PostOrganization",
		listPostOrganization:"PostOrganization",
		paginatePostOrganization:"PostOrganizationConnection",
		validateCreatePostOrganization:"_ValidationResult",
		validateUpdatePostOrganization:"_ValidationResult",
		getPostOrganizationLocale:"PostOrganizationLocale",
		listPostOrganizationLocale:"PostOrganizationLocale",
		paginatePostOrganizationLocale:"PostOrganizationLocaleConnection",
		validateCreatePostOrganizationLocale:"_ValidationResult",
		validateUpdatePostOrganizationLocale:"_ValidationResult",
		getDonation:"Donation",
		listDonation:"Donation",
		paginateDonation:"DonationConnection",
		validateCreateDonation:"_ValidationResult",
		validateUpdateDonation:"_ValidationResult",
		getDonationAmountItem:"DonationAmountItem",
		listDonationAmountItem:"DonationAmountItem",
		paginateDonationAmountItem:"DonationAmountItemConnection",
		validateCreateDonationAmountItem:"_ValidationResult",
		validateUpdateDonationAmountItem:"_ValidationResult",
		getDonationAmountsRegionItem:"DonationAmountsRegionItem",
		listDonationAmountsRegionItem:"DonationAmountsRegionItem",
		paginateDonationAmountsRegionItem:"DonationAmountsRegionItemConnection",
		validateCreateDonationAmountsRegionItem:"_ValidationResult",
		validateUpdateDonationAmountsRegionItem:"_ValidationResult",
		getDonationAmountsRegionList:"DonationAmountsRegionList",
		listDonationAmountsRegionList:"DonationAmountsRegionList",
		paginateDonationAmountsRegionList:"DonationAmountsRegionListConnection",
		validateCreateDonationAmountsRegionList:"_ValidationResult",
		validateUpdateDonationAmountsRegionList:"_ValidationResult",
		getRegion:"Region",
		listRegion:"Region",
		paginateRegion:"RegionConnection",
		validateCreateRegion:"_ValidationResult",
		validateUpdateRegion:"_ValidationResult",
		getLinkItem:"LinkItem",
		listLinkItem:"LinkItem",
		paginateLinkItem:"LinkItemConnection",
		validateCreateLinkItem:"_ValidationResult",
		validateUpdateLinkItem:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLocale:"HeaderLocale",
		listHeaderLocale:"HeaderLocale",
		paginateHeaderLocale:"HeaderLocaleConnection",
		validateCreateHeaderLocale:"_ValidationResult",
		validateUpdateHeaderLocale:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterLocale:"FooterLocale",
		listFooterLocale:"FooterLocale",
		paginateFooterLocale:"FooterLocaleConnection",
		validateCreateFooterLocale:"_ValidationResult",
		validateUpdateFooterLocale:"_ValidationResult",
		getPostList:"PostList",
		listPostList:"PostList",
		paginatePostList:"PostListConnection",
		validateCreatePostList:"_ValidationResult",
		validateUpdatePostList:"_ValidationResult",
		getPostListItem:"PostListItem",
		listPostListItem:"PostListItem",
		paginatePostListItem:"PostListItemConnection",
		validateCreatePostListItem:"_ValidationResult",
		validateUpdatePostListItem:"_ValidationResult",
		getAppBanner:"AppBanner",
		listAppBanner:"AppBanner",
		paginateAppBanner:"AppBannerConnection",
		validateCreateAppBanner:"_ValidationResult",
		validateUpdateAppBanner:"_ValidationResult",
		getGenericPageAboutSettings:"GenericPageAboutSettings",
		listGenericPageAboutSettings:"GenericPageAboutSettings",
		paginateGenericPageAboutSettings:"GenericPageAboutSettingsConnection",
		validateCreateGenericPageAboutSettings:"_ValidationResult",
		validateUpdateGenericPageAboutSettings:"_ValidationResult",
		getGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocale",
		listGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocale",
		paginateGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleConnection",
		validateCreateGenericPageAboutSettingsLocale:"_ValidationResult",
		validateUpdateGenericPageAboutSettingsLocale:"_ValidationResult",
		getValue:"Value",
		listValue:"Value",
		paginateValue:"ValueConnection",
		validateCreateValue:"_ValidationResult",
		validateUpdateValue:"_ValidationResult",
		getValueItem:"ValueItem",
		listValueItem:"ValueItem",
		paginateValueItem:"ValueItemConnection",
		validateCreateValueItem:"_ValidationResult",
		validateUpdateValueItem:"_ValidationResult",
		getValueList:"ValueList",
		listValueList:"ValueList",
		paginateValueList:"ValueListConnection",
		validateCreateValueList:"_ValidationResult",
		validateUpdateValueList:"_ValidationResult",
		getImageLink:"ImageLink",
		listImageLink:"ImageLink",
		paginateImageLink:"ImageLinkConnection",
		validateCreateImageLink:"_ValidationResult",
		validateUpdateImageLink:"_ValidationResult",
		getImageLinkItem:"ImageLinkItem",
		listImageLinkItem:"ImageLinkItem",
		paginateImageLinkItem:"ImageLinkItemConnection",
		validateCreateImageLinkItem:"_ValidationResult",
		validateUpdateImageLinkItem:"_ValidationResult",
		getImageLinkList:"ImageLinkList",
		listImageLinkList:"ImageLinkList",
		paginateImageLinkList:"ImageLinkListConnection",
		validateCreateImageLinkList:"_ValidationResult",
		validateUpdateImageLinkList:"_ValidationResult",
		getPostAreaList:"PostAreaList",
		listPostAreaList:"PostAreaList",
		paginatePostAreaList:"PostAreaListConnection",
		validateCreatePostAreaList:"_ValidationResult",
		validateUpdatePostAreaList:"_ValidationResult",
		getPostAreaListItem:"PostAreaListItem",
		listPostAreaListItem:"PostAreaListItem",
		paginatePostAreaListItem:"PostAreaListItemConnection",
		validateCreatePostAreaListItem:"_ValidationResult",
		validateUpdatePostAreaListItem:"_ValidationResult",
		getAccordion:"Accordion",
		listAccordion:"Accordion",
		paginateAccordion:"AccordionConnection",
		validateCreateAccordion:"_ValidationResult",
		validateUpdateAccordion:"_ValidationResult",
		getAccordionItem:"AccordionItem",
		listAccordionItem:"AccordionItem",
		paginateAccordionItem:"AccordionItemConnection",
		validateCreateAccordionItem:"_ValidationResult",
		validateUpdateAccordionItem:"_ValidationResult",
		getUser:"User",
		listUser:"User",
		paginateUser:"UserConnection",
		validateCreateUser:"_ValidationResult",
		validateUpdateUser:"_ValidationResult",
		getUserPayment:"UserPayment",
		listUserPayment:"UserPayment",
		paginateUserPayment:"UserPaymentConnection",
		validateCreateUserPayment:"_ValidationResult",
		validateUpdateUserPayment:"_ValidationResult",
		getCurrency:"Currency",
		listCurrency:"Currency",
		paginateCurrency:"CurrencyConnection",
		validateCreateCurrency:"_ValidationResult",
		validateUpdateCurrency:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getMediumItem:"MediumItem",
		listMediumItem:"MediumItem",
		paginateMediumItem:"MediumItemConnection",
		validateCreateMediumItem:"_ValidationResult",
		validateUpdateMediumItem:"_ValidationResult",
		getMediumList:"MediumList",
		listMediumList:"MediumList",
		paginateMediumList:"MediumListConnection",
		validateCreateMediumList:"_ValidationResult",
		validateUpdateMediumList:"_ValidationResult",
		getUserPaymentOrderId:"UserPaymentOrderId",
		listUserPaymentOrderId:"UserPaymentOrderId",
		paginateUserPaymentOrderId:"UserPaymentOrderIdConnection",
		validateCreateUserPaymentOrderId:"_ValidationResult",
		validateUpdateUserPaymentOrderId:"_ValidationResult",
		getPostRevision:"PostRevision",
		listPostRevision:"PostRevision",
		paginatePostRevision:"PostRevisionConnection",
		validateCreatePostRevision:"_ValidationResult",
		validateUpdatePostRevision:"_ValidationResult",
		getUserRecurringPayment:"UserRecurringPayment",
		listUserRecurringPayment:"UserRecurringPayment",
		paginateUserRecurringPayment:"UserRecurringPaymentConnection",
		validateCreateUserRecurringPayment:"_ValidationResult",
		validateUpdateUserRecurringPayment:"_ValidationResult",
		getUserRecurringPaymentItem:"UserRecurringPaymentItem",
		listUserRecurringPaymentItem:"UserRecurringPaymentItem",
		paginateUserRecurringPaymentItem:"UserRecurringPaymentItemConnection",
		validateCreateUserRecurringPaymentItem:"_ValidationResult",
		validateUpdateUserRecurringPaymentItem:"_ValidationResult",
		getPostRevisionLocale:"PostRevisionLocale",
		listPostRevisionLocale:"PostRevisionLocale",
		paginatePostRevisionLocale:"PostRevisionLocaleConnection",
		validateCreatePostRevisionLocale:"_ValidationResult",
		validateUpdatePostRevisionLocale:"_ValidationResult",
		getTranslationCatalogue:"TranslationCatalogue",
		listTranslationCatalogue:"TranslationCatalogue",
		paginateTranslationCatalogue:"TranslationCatalogueConnection",
		validateCreateTranslationCatalogue:"_ValidationResult",
		validateUpdateTranslationCatalogue:"_ValidationResult",
		getTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		listTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		paginateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierConnection",
		validateCreateTranslationCataloguesIdentifier:"_ValidationResult",
		validateUpdateTranslationCataloguesIdentifier:"_ValidationResult",
		getTranslationDomain:"TranslationDomain",
		listTranslationDomain:"TranslationDomain",
		paginateTranslationDomain:"TranslationDomainConnection",
		validateCreateTranslationDomain:"_ValidationResult",
		validateUpdateTranslationDomain:"_ValidationResult",
		getTranslationKey:"TranslationKey",
		listTranslationKey:"TranslationKey",
		paginateTranslationKey:"TranslationKeyConnection",
		validateCreateTranslationKey:"_ValidationResult",
		validateUpdateTranslationKey:"_ValidationResult",
		getTranslationValue:"TranslationValue",
		listTranslationValue:"TranslationValue",
		paginateTranslationValue:"TranslationValueConnection",
		validateCreateTranslationValue:"_ValidationResult",
		validateUpdateTranslationValue:"_ValidationResult",
		getGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocale",
		listGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocale",
		paginateGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleConnection",
		validateCreateGenericPageAboutGroupLinksLocale:"_ValidationResult",
		validateUpdateGenericPageAboutGroupLinksLocale:"_ValidationResult",
		getMemberList:"MemberList",
		listMemberList:"MemberList",
		paginateMemberList:"MemberListConnection",
		validateCreateMemberList:"_ValidationResult",
		validateUpdateMemberList:"_ValidationResult",
		getMemberListItem:"MemberListItem",
		listMemberListItem:"MemberListItem",
		paginateMemberListItem:"MemberListItemConnection",
		validateCreateMemberListItem:"_ValidationResult",
		validateUpdateMemberListItem:"_ValidationResult",
		getFilledTaxForm:"FilledTaxForm",
		listFilledTaxForm:"FilledTaxForm",
		paginateFilledTaxForm:"FilledTaxFormConnection",
		validateCreateFilledTaxForm:"_ValidationResult",
		validateUpdateFilledTaxForm:"_ValidationResult",
		getFilledTaxFormEmailAddress:"FilledTaxFormEmailAddress",
		listFilledTaxFormEmailAddress:"FilledTaxFormEmailAddress",
		paginateFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressConnection",
		validateCreateFilledTaxFormEmailAddress:"_ValidationResult",
		validateUpdateFilledTaxFormEmailAddress:"_ValidationResult",
		getForm:"Form",
		listForm:"Form",
		paginateForm:"FormConnection",
		validateCreateForm:"_ValidationResult",
		validateUpdateForm:"_ValidationResult",
		getCsobPayment:"CsobPayment",
		listCsobPayment:"CsobPayment",
		paginateCsobPayment:"CsobPaymentConnection",
		validateCreateCsobPayment:"_ValidationResult",
		validateUpdateCsobPayment:"_ValidationResult",
		getCsobPaymentStatusChange:"CsobPaymentStatusChange",
		listCsobPaymentStatusChange:"CsobPaymentStatusChange",
		paginateCsobPaymentStatusChange:"CsobPaymentStatusChangeConnection",
		validateCreateCsobPaymentStatusChange:"_ValidationResult",
		validateUpdateCsobPaymentStatusChange:"_ValidationResult",
		getStripePayment:"StripePayment",
		listStripePayment:"StripePayment",
		paginateStripePayment:"StripePaymentConnection",
		validateCreateStripePayment:"_ValidationResult",
		validateUpdateStripePayment:"_ValidationResult",
		getStripePaymentStatusChange:"StripePaymentStatusChange",
		listStripePaymentStatusChange:"StripePaymentStatusChange",
		paginateStripePaymentStatusChange:"StripePaymentStatusChangeConnection",
		validateCreateStripePaymentStatusChange:"_ValidationResult",
		validateUpdateStripePaymentStatusChange:"_ValidationResult",
		getRegionPaymentMethod:"RegionPaymentMethod",
		listRegionPaymentMethod:"RegionPaymentMethod",
		paginateRegionPaymentMethod:"RegionPaymentMethodConnection",
		validateCreateRegionPaymentMethod:"_ValidationResult",
		validateUpdateRegionPaymentMethod:"_ValidationResult",
		getPostAreaMetaData:"PostAreaMetaData",
		listPostAreaMetaData:"PostAreaMetaData",
		paginatePostAreaMetaData:"PostAreaMetaDataConnection",
		getPostMetaData:"PostMetaData",
		listPostMetaData:"PostMetaData",
		paginatePostMetaData:"PostMetaDataConnection",
		getPostOrganizationMetaData:"PostOrganizationMetaData",
		listPostOrganizationMetaData:"PostOrganizationMetaData",
		paginatePostOrganizationMetaData:"PostOrganizationMetaDataConnection",
		getTileItem:"TileItem",
		listTileItem:"TileItem",
		paginateTileItem:"TileItemConnection",
		validateCreateTileItem:"_ValidationResult",
		validateUpdateTileItem:"_ValidationResult",
		getTileList:"TileList",
		listTileList:"TileList",
		paginateTileList:"TileListConnection",
		validateCreateTileList:"_ValidationResult",
		validateUpdateTileList:"_ValidationResult",
		getFeedPage:"FeedPage",
		listFeedPage:"FeedPage",
		paginateFeedPage:"FeedPageConnection",
		validateCreateFeedPage:"_ValidationResult",
		validateUpdateFeedPage:"_ValidationResult",
		getFeedPageLocale:"FeedPageLocale",
		listFeedPageLocale:"FeedPageLocale",
		paginateFeedPageLocale:"FeedPageLocaleConnection",
		validateCreateFeedPageLocale:"_ValidationResult",
		validateUpdateFeedPageLocale:"_ValidationResult",
		getFeedPageSection:"FeedPageSection",
		listFeedPageSection:"FeedPageSection",
		paginateFeedPageSection:"FeedPageSectionConnection",
		validateCreateFeedPageSection:"_ValidationResult",
		validateUpdateFeedPageSection:"_ValidationResult",
		getFeedPageTileStripe:"FeedPageTileStripe",
		listFeedPageTileStripe:"FeedPageTileStripe",
		paginateFeedPageTileStripe:"FeedPageTileStripeConnection",
		validateCreateFeedPageTileStripe:"_ValidationResult",
		validateUpdateFeedPageTileStripe:"_ValidationResult",
		getCardItem:"CardItem",
		listCardItem:"CardItem",
		paginateCardItem:"CardItemConnection",
		validateCreateCardItem:"_ValidationResult",
		validateUpdateCardItem:"_ValidationResult",
		getCardList:"CardList",
		listCardList:"CardList",
		paginateCardList:"CardListConnection",
		validateCreateCardList:"_ValidationResult",
		validateUpdateCardList:"_ValidationResult",
		getOnBehalfDonation:"OnBehalfDonation",
		listOnBehalfDonation:"OnBehalfDonation",
		paginateOnBehalfDonation:"OnBehalfDonationConnection",
		validateCreateOnBehalfDonation:"_ValidationResult",
		validateUpdateOnBehalfDonation:"_ValidationResult",
		getUserPaymentTriesCollection:"UserPaymentTriesCollection",
		listUserPaymentTriesCollection:"UserPaymentTriesCollection",
		paginateUserPaymentTriesCollection:"UserPaymentTriesCollectionConnection",
		validateCreateUserPaymentTriesCollection:"_ValidationResult",
		validateUpdateUserPaymentTriesCollection:"_ValidationResult",
		getRecurringPaymentPage:"RecurringPaymentPage",
		listRecurringPaymentPage:"RecurringPaymentPage",
		paginateRecurringPaymentPage:"RecurringPaymentPageConnection",
		validateCreateRecurringPaymentPage:"_ValidationResult",
		validateUpdateRecurringPaymentPage:"_ValidationResult",
		getRecurringPaymentPageLocale:"RecurringPaymentPageLocale",
		listRecurringPaymentPageLocale:"RecurringPaymentPageLocale",
		paginateRecurringPaymentPageLocale:"RecurringPaymentPageLocaleConnection",
		validateCreateRecurringPaymentPageLocale:"_ValidationResult",
		validateUpdateRecurringPaymentPageLocale:"_ValidationResult",
		getStoryGuide:"StoryGuide",
		listStoryGuide:"StoryGuide",
		paginateStoryGuide:"StoryGuideConnection",
		validateCreateStoryGuide:"_ValidationResult",
		validateUpdateStoryGuide:"_ValidationResult",
		getStoryGuideItem:"StoryGuideItem",
		listStoryGuideItem:"StoryGuideItem",
		paginateStoryGuideItem:"StoryGuideItemConnection",
		validateCreateStoryGuideItem:"_ValidationResult",
		validateUpdateStoryGuideItem:"_ValidationResult",
		getStoryGuideList:"StoryGuideList",
		listStoryGuideList:"StoryGuideList",
		paginateStoryGuideList:"StoryGuideListConnection",
		validateCreateStoryGuideList:"_ValidationResult",
		validateUpdateStoryGuideList:"_ValidationResult",
		getStripePaymentMetadata:"StripePaymentMetadata",
		listStripePaymentMetadata:"StripePaymentMetadata",
		paginateStripePaymentMetadata:"StripePaymentMetadataConnection",
		getOnBehalfDonationMetadata:"OnBehalfDonationMetadata",
		listOnBehalfDonationMetadata:"OnBehalfDonationMetadata",
		paginateOnBehalfDonationMetadata:"OnBehalfDonationMetadataConnection",
		getUserPaymentTriesCollectionMetadata:"UserPaymentTriesCollectionMetadata",
		listUserPaymentTriesCollectionMetadata:"UserPaymentTriesCollectionMetadata",
		paginateUserPaymentTriesCollectionMetadata:"UserPaymentTriesCollectionMetadataConnection",
		getUserPaymentTriesCollectionMetadataLocale:"UserPaymentTriesCollectionMetadataLocale",
		listUserPaymentTriesCollectionMetadataLocale:"UserPaymentTriesCollectionMetadataLocale",
		paginateUserPaymentTriesCollectionMetadataLocale:"UserPaymentTriesCollectionMetadataLocaleConnection",
		getCsobPaymentMetadata:"CsobPaymentMetadata",
		listCsobPaymentMetadata:"CsobPaymentMetadata",
		paginateCsobPaymentMetadata:"CsobPaymentMetadataConnection",
		getHeroCarousel:"HeroCarousel",
		listHeroCarousel:"HeroCarousel",
		paginateHeroCarousel:"HeroCarouselConnection",
		validateCreateHeroCarousel:"_ValidationResult",
		validateUpdateHeroCarousel:"_ValidationResult",
		getPostOrganizationList:"PostOrganizationList",
		listPostOrganizationList:"PostOrganizationList",
		paginatePostOrganizationList:"PostOrganizationListConnection",
		validateCreatePostOrganizationList:"_ValidationResult",
		validateUpdatePostOrganizationList:"_ValidationResult",
		getPostOrganizationListItem:"PostOrganizationListItem",
		listPostOrganizationListItem:"PostOrganizationListItem",
		paginatePostOrganizationListItem:"PostOrganizationListItemConnection",
		validateCreatePostOrganizationListItem:"_ValidationResult",
		validateUpdatePostOrganizationListItem:"_ValidationResult",
		getInfoCarousel:"InfoCarousel",
		listInfoCarousel:"InfoCarousel",
		paginateInfoCarousel:"InfoCarouselConnection",
		validateCreateInfoCarousel:"_ValidationResult",
		validateUpdateInfoCarousel:"_ValidationResult",
		getInfoCarouselItem:"InfoCarouselItem",
		listInfoCarouselItem:"InfoCarouselItem",
		paginateInfoCarouselItem:"InfoCarouselItemConnection",
		validateCreateInfoCarouselItem:"_ValidationResult",
		validateUpdateInfoCarouselItem:"_ValidationResult",
		getPersonSeenInfoCarousel:"PersonSeenInfoCarousel",
		listPersonSeenInfoCarousel:"PersonSeenInfoCarousel",
		paginatePersonSeenInfoCarousel:"PersonSeenInfoCarouselConnection",
		validateCreatePersonSeenInfoCarousel:"_ValidationResult",
		validateUpdatePersonSeenInfoCarousel:"_ValidationResult",
		getGivenGiftsPage:"GivenGiftsPage",
		listGivenGiftsPage:"GivenGiftsPage",
		paginateGivenGiftsPage:"GivenGiftsPageConnection",
		validateCreateGivenGiftsPage:"_ValidationResult",
		validateUpdateGivenGiftsPage:"_ValidationResult",
		getGivenGiftsPageLocale:"GivenGiftsPageLocale",
		listGivenGiftsPageLocale:"GivenGiftsPageLocale",
		paginateGivenGiftsPageLocale:"GivenGiftsPageLocaleConnection",
		validateCreateGivenGiftsPageLocale:"_ValidationResult",
		validateUpdateGivenGiftsPageLocale:"_ValidationResult",
		getReceivedGiftsPage:"ReceivedGiftsPage",
		listReceivedGiftsPage:"ReceivedGiftsPage",
		paginateReceivedGiftsPage:"ReceivedGiftsPageConnection",
		validateCreateReceivedGiftsPage:"_ValidationResult",
		validateUpdateReceivedGiftsPage:"_ValidationResult",
		getReceivedGiftsPageLocale:"ReceivedGiftsPageLocale",
		listReceivedGiftsPageLocale:"ReceivedGiftsPageLocale",
		paginateReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleConnection",
		validateCreateReceivedGiftsPageLocale:"_ValidationResult",
		validateUpdateReceivedGiftsPageLocale:"_ValidationResult",
		getReportNavigation:"ReportNavigation",
		listReportNavigation:"ReportNavigation",
		paginateReportNavigation:"ReportNavigationConnection",
		validateCreateReportNavigation:"_ValidationResult",
		validateUpdateReportNavigation:"_ValidationResult",
		getReportPage:"ReportPage",
		listReportPage:"ReportPage",
		paginateReportPage:"ReportPageConnection",
		validateCreateReportPage:"_ValidationResult",
		validateUpdateReportPage:"_ValidationResult",
		getReportPageLocale:"ReportPageLocale",
		listReportPageLocale:"ReportPageLocale",
		paginateReportPageLocale:"ReportPageLocaleConnection",
		validateCreateReportPageLocale:"_ValidationResult",
		validateUpdateReportPageLocale:"_ValidationResult",
		getReportNavigationLocale:"ReportNavigationLocale",
		listReportNavigationLocale:"ReportNavigationLocale",
		paginateReportNavigationLocale:"ReportNavigationLocaleConnection",
		validateCreateReportNavigationLocale:"_ValidationResult",
		validateUpdateReportNavigationLocale:"_ValidationResult",
		getSentPayment:"SentPayment",
		listSentPayment:"SentPayment",
		paginateSentPayment:"SentPaymentConnection",
		validateCreateSentPayment:"_ValidationResult",
		validateUpdateSentPayment:"_ValidationResult",
		getPostAreaSentPaymentCurrencySum:"PostAreaSentPaymentCurrencySum",
		listPostAreaSentPaymentCurrencySum:"PostAreaSentPaymentCurrencySum",
		paginatePostAreaSentPaymentCurrencySum:"PostAreaSentPaymentCurrencySumConnection",
		getPostAreaSentPaymentSum:"PostAreaSentPaymentSum",
		listPostAreaSentPaymentSum:"PostAreaSentPaymentSum",
		paginatePostAreaSentPaymentSum:"PostAreaSentPaymentSumConnection",
		getNotificationTargetGroup:"NotificationTargetGroup",
		listNotificationTargetGroup:"NotificationTargetGroup",
		paginateNotificationTargetGroup:"NotificationTargetGroupConnection",
		validateCreateNotificationTargetGroup:"_ValidationResult",
		validateUpdateNotificationTargetGroup:"_ValidationResult",
		getProcessedNotification:"ProcessedNotification",
		listProcessedNotification:"ProcessedNotification",
		paginateProcessedNotification:"ProcessedNotificationConnection",
		validateCreateProcessedNotification:"_ValidationResult",
		validateUpdateProcessedNotification:"_ValidationResult",
		getScheduledNotification:"ScheduledNotification",
		listScheduledNotification:"ScheduledNotification",
		paginateScheduledNotification:"ScheduledNotificationConnection",
		validateCreateScheduledNotification:"_ValidationResult",
		validateUpdateScheduledNotification:"_ValidationResult",
		getProcessedNotificationSource:"ProcessedNotificationSource",
		listProcessedNotificationSource:"ProcessedNotificationSource",
		paginateProcessedNotificationSource:"ProcessedNotificationSourceConnection",
		validateCreateProcessedNotificationSource:"_ValidationResult",
		validateUpdateProcessedNotificationSource:"_ValidationResult",
		getDevice:"Device",
		listDevice:"Device",
		paginateDevice:"DeviceConnection",
		validateCreateDevice:"_ValidationResult",
		validateUpdateDevice:"_ValidationResult",
		getScheduledNotificationLocale:"ScheduledNotificationLocale",
		listScheduledNotificationLocale:"ScheduledNotificationLocale",
		paginateScheduledNotificationLocale:"ScheduledNotificationLocaleConnection",
		validateCreateScheduledNotificationLocale:"_ValidationResult",
		validateUpdateScheduledNotificationLocale:"_ValidationResult",
		getInfoCarouselItemLocale:"InfoCarouselItemLocale",
		listInfoCarouselItemLocale:"InfoCarouselItemLocale",
		paginateInfoCarouselItemLocale:"InfoCarouselItemLocaleConnection",
		validateCreateInfoCarouselItemLocale:"_ValidationResult",
		validateUpdateInfoCarouselItemLocale:"_ValidationResult",
		getSentPaymentLocale:"SentPaymentLocale",
		listSentPaymentLocale:"SentPaymentLocale",
		paginateSentPaymentLocale:"SentPaymentLocaleConnection",
		validateCreateSentPaymentLocale:"_ValidationResult",
		validateUpdateSentPaymentLocale:"_ValidationResult",
		getUserPaymentMetadata:"UserPaymentMetadata",
		listUserPaymentMetadata:"UserPaymentMetadata",
		paginateUserPaymentMetadata:"UserPaymentMetadataConnection",
		getPostAreaCurrencySum:"PostAreaCurrencySum",
		listPostAreaCurrencySum:"PostAreaCurrencySum",
		paginatePostAreaCurrencySum:"PostAreaCurrencySumConnection",
		getPostAreaSum:"PostAreaSum",
		listPostAreaSum:"PostAreaSum",
		paginatePostAreaSum:"PostAreaSumConnection",
		getPostOrganizationCurrencySum:"PostOrganizationCurrencySum",
		listPostOrganizationCurrencySum:"PostOrganizationCurrencySum",
		paginatePostOrganizationCurrencySum:"PostOrganizationCurrencySumConnection",
		getPostOrganizationSum:"PostOrganizationSum",
		listPostOrganizationSum:"PostOrganizationSum",
		paginatePostOrganizationSum:"PostOrganizationSumConnection",
		getStats:"Stats",
		listStats:"Stats",
		paginateStats:"StatsConnection",
		getUserRecurringPaymentItemMetadata:"UserRecurringPaymentItemMetadata",
		listUserRecurringPaymentItemMetadata:"UserRecurringPaymentItemMetadata",
		paginateUserRecurringPaymentItemMetadata:"UserRecurringPaymentItemMetadataConnection",
		getUpcomingUserRecurringPaymentMetadata:"UpcomingUserRecurringPaymentMetadata",
		listUpcomingUserRecurringPaymentMetadata:"UpcomingUserRecurringPaymentMetadata",
		paginateUpcomingUserRecurringPaymentMetadata:"UpcomingUserRecurringPaymentMetadataConnection",
		getUserAreaStats:"UserAreaStats",
		listUserAreaStats:"UserAreaStats",
		paginateUserAreaStats:"UserAreaStatsConnection",
		getUserCurrencyStats:"UserCurrencyStats",
		listUserCurrencyStats:"UserCurrencyStats",
		paginateUserCurrencyStats:"UserCurrencyStatsConnection",
		getUserOrganizationStats:"UserOrganizationStats",
		listUserOrganizationStats:"UserOrganizationStats",
		paginateUserOrganizationStats:"UserOrganizationStatsConnection",
		getUserPostStats:"UserPostStats",
		listUserPostStats:"UserPostStats",
		paginateUserPostStats:"UserPostStatsConnection",
		getUserStats:"UserStats",
		listUserStats:"UserStats",
		paginateUserStats:"UserStatsConnection",
		getTextImageList:"TextImageList",
		listTextImageList:"TextImageList",
		paginateTextImageList:"TextImageListConnection",
		validateCreateTextImageList:"_ValidationResult",
		validateUpdateTextImageList:"_ValidationResult",
		getTextImageListItem:"TextImageListItem",
		listTextImageListItem:"TextImageListItem",
		paginateTextImageListItem:"TextImageListItemConnection",
		validateCreateTextImageListItem:"_ValidationResult",
		validateUpdateTextImageListItem:"_ValidationResult",
		getPostCurrencySum:"PostCurrencySum",
		listPostCurrencySum:"PostCurrencySum",
		paginatePostCurrencySum:"PostCurrencySumConnection",
		getPostSum:"PostSum",
		listPostSum:"PostSum",
		paginatePostSum:"PostSumConnection",
		getPostFundraisingProgress:"PostFundraisingProgress",
		listPostFundraisingProgress:"PostFundraisingProgress",
		paginatePostFundraisingProgress:"PostFundraisingProgressConnection",
		getHeroCarouselItem:"HeroCarouselItem",
		listHeroCarouselItem:"HeroCarouselItem",
		paginateHeroCarouselItem:"HeroCarouselItemConnection",
		validateCreateHeroCarouselItem:"_ValidationResult",
		validateUpdateHeroCarouselItem:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead",
		createGeneral:"GeneralCreateResult",
		deleteGeneral:"GeneralDeleteResult",
		updateGeneral:"GeneralUpdateResult",
		upsertGeneral:"GeneralUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createGenericPage:"GenericPageCreateResult",
		deleteGenericPage:"GenericPageDeleteResult",
		updateGenericPage:"GenericPageUpdateResult",
		upsertGenericPage:"GenericPageUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createGeneralLocale:"GeneralLocaleCreateResult",
		deleteGeneralLocale:"GeneralLocaleDeleteResult",
		updateGeneralLocale:"GeneralLocaleUpdateResult",
		upsertGeneralLocale:"GeneralLocaleUpsertResult",
		createGenericPageLocale:"GenericPageLocaleCreateResult",
		deleteGenericPageLocale:"GenericPageLocaleDeleteResult",
		updateGenericPageLocale:"GenericPageLocaleUpdateResult",
		upsertGenericPageLocale:"GenericPageLocaleUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createPost:"PostCreateResult",
		deletePost:"PostDeleteResult",
		updatePost:"PostUpdateResult",
		upsertPost:"PostUpsertResult",
		createPostLocale:"PostLocaleCreateResult",
		deletePostLocale:"PostLocaleDeleteResult",
		updatePostLocale:"PostLocaleUpdateResult",
		upsertPostLocale:"PostLocaleUpsertResult",
		createPostArea:"PostAreaCreateResult",
		deletePostArea:"PostAreaDeleteResult",
		updatePostArea:"PostAreaUpdateResult",
		upsertPostArea:"PostAreaUpsertResult",
		createPostAreaLocale:"PostAreaLocaleCreateResult",
		deletePostAreaLocale:"PostAreaLocaleDeleteResult",
		updatePostAreaLocale:"PostAreaLocaleUpdateResult",
		upsertPostAreaLocale:"PostAreaLocaleUpsertResult",
		createPostOrganization:"PostOrganizationCreateResult",
		deletePostOrganization:"PostOrganizationDeleteResult",
		updatePostOrganization:"PostOrganizationUpdateResult",
		upsertPostOrganization:"PostOrganizationUpsertResult",
		createPostOrganizationLocale:"PostOrganizationLocaleCreateResult",
		deletePostOrganizationLocale:"PostOrganizationLocaleDeleteResult",
		updatePostOrganizationLocale:"PostOrganizationLocaleUpdateResult",
		upsertPostOrganizationLocale:"PostOrganizationLocaleUpsertResult",
		createDonation:"DonationCreateResult",
		deleteDonation:"DonationDeleteResult",
		updateDonation:"DonationUpdateResult",
		upsertDonation:"DonationUpsertResult",
		createDonationAmountItem:"DonationAmountItemCreateResult",
		deleteDonationAmountItem:"DonationAmountItemDeleteResult",
		updateDonationAmountItem:"DonationAmountItemUpdateResult",
		upsertDonationAmountItem:"DonationAmountItemUpsertResult",
		createDonationAmountsRegionItem:"DonationAmountsRegionItemCreateResult",
		deleteDonationAmountsRegionItem:"DonationAmountsRegionItemDeleteResult",
		updateDonationAmountsRegionItem:"DonationAmountsRegionItemUpdateResult",
		upsertDonationAmountsRegionItem:"DonationAmountsRegionItemUpsertResult",
		createDonationAmountsRegionList:"DonationAmountsRegionListCreateResult",
		deleteDonationAmountsRegionList:"DonationAmountsRegionListDeleteResult",
		updateDonationAmountsRegionList:"DonationAmountsRegionListUpdateResult",
		upsertDonationAmountsRegionList:"DonationAmountsRegionListUpsertResult",
		createRegion:"RegionCreateResult",
		deleteRegion:"RegionDeleteResult",
		updateRegion:"RegionUpdateResult",
		upsertRegion:"RegionUpsertResult",
		createLinkItem:"LinkItemCreateResult",
		deleteLinkItem:"LinkItemDeleteResult",
		updateLinkItem:"LinkItemUpdateResult",
		upsertLinkItem:"LinkItemUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLocale:"HeaderLocaleCreateResult",
		deleteHeaderLocale:"HeaderLocaleDeleteResult",
		updateHeaderLocale:"HeaderLocaleUpdateResult",
		upsertHeaderLocale:"HeaderLocaleUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterLocale:"FooterLocaleCreateResult",
		deleteFooterLocale:"FooterLocaleDeleteResult",
		updateFooterLocale:"FooterLocaleUpdateResult",
		upsertFooterLocale:"FooterLocaleUpsertResult",
		createPostList:"PostListCreateResult",
		deletePostList:"PostListDeleteResult",
		updatePostList:"PostListUpdateResult",
		upsertPostList:"PostListUpsertResult",
		createPostListItem:"PostListItemCreateResult",
		deletePostListItem:"PostListItemDeleteResult",
		updatePostListItem:"PostListItemUpdateResult",
		upsertPostListItem:"PostListItemUpsertResult",
		createAppBanner:"AppBannerCreateResult",
		deleteAppBanner:"AppBannerDeleteResult",
		updateAppBanner:"AppBannerUpdateResult",
		upsertAppBanner:"AppBannerUpsertResult",
		createGenericPageAboutSettings:"GenericPageAboutSettingsCreateResult",
		deleteGenericPageAboutSettings:"GenericPageAboutSettingsDeleteResult",
		updateGenericPageAboutSettings:"GenericPageAboutSettingsUpdateResult",
		upsertGenericPageAboutSettings:"GenericPageAboutSettingsUpsertResult",
		createGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleCreateResult",
		deleteGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleDeleteResult",
		updateGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleUpdateResult",
		upsertGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleUpsertResult",
		createValue:"ValueCreateResult",
		deleteValue:"ValueDeleteResult",
		updateValue:"ValueUpdateResult",
		upsertValue:"ValueUpsertResult",
		createValueItem:"ValueItemCreateResult",
		deleteValueItem:"ValueItemDeleteResult",
		updateValueItem:"ValueItemUpdateResult",
		upsertValueItem:"ValueItemUpsertResult",
		createValueList:"ValueListCreateResult",
		deleteValueList:"ValueListDeleteResult",
		updateValueList:"ValueListUpdateResult",
		upsertValueList:"ValueListUpsertResult",
		createImageLink:"ImageLinkCreateResult",
		deleteImageLink:"ImageLinkDeleteResult",
		updateImageLink:"ImageLinkUpdateResult",
		upsertImageLink:"ImageLinkUpsertResult",
		createImageLinkItem:"ImageLinkItemCreateResult",
		deleteImageLinkItem:"ImageLinkItemDeleteResult",
		updateImageLinkItem:"ImageLinkItemUpdateResult",
		upsertImageLinkItem:"ImageLinkItemUpsertResult",
		createImageLinkList:"ImageLinkListCreateResult",
		deleteImageLinkList:"ImageLinkListDeleteResult",
		updateImageLinkList:"ImageLinkListUpdateResult",
		upsertImageLinkList:"ImageLinkListUpsertResult",
		createPostAreaList:"PostAreaListCreateResult",
		deletePostAreaList:"PostAreaListDeleteResult",
		updatePostAreaList:"PostAreaListUpdateResult",
		upsertPostAreaList:"PostAreaListUpsertResult",
		createPostAreaListItem:"PostAreaListItemCreateResult",
		deletePostAreaListItem:"PostAreaListItemDeleteResult",
		updatePostAreaListItem:"PostAreaListItemUpdateResult",
		upsertPostAreaListItem:"PostAreaListItemUpsertResult",
		createAccordion:"AccordionCreateResult",
		deleteAccordion:"AccordionDeleteResult",
		updateAccordion:"AccordionUpdateResult",
		upsertAccordion:"AccordionUpsertResult",
		createAccordionItem:"AccordionItemCreateResult",
		deleteAccordionItem:"AccordionItemDeleteResult",
		updateAccordionItem:"AccordionItemUpdateResult",
		upsertAccordionItem:"AccordionItemUpsertResult",
		createUser:"UserCreateResult",
		deleteUser:"UserDeleteResult",
		updateUser:"UserUpdateResult",
		upsertUser:"UserUpsertResult",
		createUserPayment:"UserPaymentCreateResult",
		deleteUserPayment:"UserPaymentDeleteResult",
		updateUserPayment:"UserPaymentUpdateResult",
		upsertUserPayment:"UserPaymentUpsertResult",
		createCurrency:"CurrencyCreateResult",
		deleteCurrency:"CurrencyDeleteResult",
		updateCurrency:"CurrencyUpdateResult",
		upsertCurrency:"CurrencyUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createMediumItem:"MediumItemCreateResult",
		deleteMediumItem:"MediumItemDeleteResult",
		updateMediumItem:"MediumItemUpdateResult",
		upsertMediumItem:"MediumItemUpsertResult",
		createMediumList:"MediumListCreateResult",
		deleteMediumList:"MediumListDeleteResult",
		updateMediumList:"MediumListUpdateResult",
		upsertMediumList:"MediumListUpsertResult",
		createUserPaymentOrderId:"UserPaymentOrderIdCreateResult",
		deleteUserPaymentOrderId:"UserPaymentOrderIdDeleteResult",
		updateUserPaymentOrderId:"UserPaymentOrderIdUpdateResult",
		upsertUserPaymentOrderId:"UserPaymentOrderIdUpsertResult",
		createPostRevision:"PostRevisionCreateResult",
		deletePostRevision:"PostRevisionDeleteResult",
		updatePostRevision:"PostRevisionUpdateResult",
		upsertPostRevision:"PostRevisionUpsertResult",
		createUserRecurringPayment:"UserRecurringPaymentCreateResult",
		deleteUserRecurringPayment:"UserRecurringPaymentDeleteResult",
		updateUserRecurringPayment:"UserRecurringPaymentUpdateResult",
		upsertUserRecurringPayment:"UserRecurringPaymentUpsertResult",
		createUserRecurringPaymentItem:"UserRecurringPaymentItemCreateResult",
		deleteUserRecurringPaymentItem:"UserRecurringPaymentItemDeleteResult",
		updateUserRecurringPaymentItem:"UserRecurringPaymentItemUpdateResult",
		upsertUserRecurringPaymentItem:"UserRecurringPaymentItemUpsertResult",
		createPostRevisionLocale:"PostRevisionLocaleCreateResult",
		deletePostRevisionLocale:"PostRevisionLocaleDeleteResult",
		updatePostRevisionLocale:"PostRevisionLocaleUpdateResult",
		upsertPostRevisionLocale:"PostRevisionLocaleUpsertResult",
		createTranslationCatalogue:"TranslationCatalogueCreateResult",
		deleteTranslationCatalogue:"TranslationCatalogueDeleteResult",
		updateTranslationCatalogue:"TranslationCatalogueUpdateResult",
		upsertTranslationCatalogue:"TranslationCatalogueUpsertResult",
		createTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierCreateResult",
		deleteTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierDeleteResult",
		updateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpdateResult",
		upsertTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpsertResult",
		createTranslationDomain:"TranslationDomainCreateResult",
		deleteTranslationDomain:"TranslationDomainDeleteResult",
		updateTranslationDomain:"TranslationDomainUpdateResult",
		upsertTranslationDomain:"TranslationDomainUpsertResult",
		createTranslationKey:"TranslationKeyCreateResult",
		deleteTranslationKey:"TranslationKeyDeleteResult",
		updateTranslationKey:"TranslationKeyUpdateResult",
		upsertTranslationKey:"TranslationKeyUpsertResult",
		createTranslationValue:"TranslationValueCreateResult",
		deleteTranslationValue:"TranslationValueDeleteResult",
		updateTranslationValue:"TranslationValueUpdateResult",
		upsertTranslationValue:"TranslationValueUpsertResult",
		createGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleCreateResult",
		deleteGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleDeleteResult",
		updateGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleUpdateResult",
		upsertGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleUpsertResult",
		createMemberList:"MemberListCreateResult",
		deleteMemberList:"MemberListDeleteResult",
		updateMemberList:"MemberListUpdateResult",
		upsertMemberList:"MemberListUpsertResult",
		createMemberListItem:"MemberListItemCreateResult",
		deleteMemberListItem:"MemberListItemDeleteResult",
		updateMemberListItem:"MemberListItemUpdateResult",
		upsertMemberListItem:"MemberListItemUpsertResult",
		createFilledTaxForm:"FilledTaxFormCreateResult",
		deleteFilledTaxForm:"FilledTaxFormDeleteResult",
		updateFilledTaxForm:"FilledTaxFormUpdateResult",
		upsertFilledTaxForm:"FilledTaxFormUpsertResult",
		createFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressCreateResult",
		deleteFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressDeleteResult",
		updateFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressUpdateResult",
		upsertFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressUpsertResult",
		createForm:"FormCreateResult",
		deleteForm:"FormDeleteResult",
		updateForm:"FormUpdateResult",
		upsertForm:"FormUpsertResult",
		createCsobPayment:"CsobPaymentCreateResult",
		deleteCsobPayment:"CsobPaymentDeleteResult",
		updateCsobPayment:"CsobPaymentUpdateResult",
		upsertCsobPayment:"CsobPaymentUpsertResult",
		createCsobPaymentStatusChange:"CsobPaymentStatusChangeCreateResult",
		deleteCsobPaymentStatusChange:"CsobPaymentStatusChangeDeleteResult",
		updateCsobPaymentStatusChange:"CsobPaymentStatusChangeUpdateResult",
		upsertCsobPaymentStatusChange:"CsobPaymentStatusChangeUpsertResult",
		createStripePayment:"StripePaymentCreateResult",
		deleteStripePayment:"StripePaymentDeleteResult",
		updateStripePayment:"StripePaymentUpdateResult",
		upsertStripePayment:"StripePaymentUpsertResult",
		createStripePaymentStatusChange:"StripePaymentStatusChangeCreateResult",
		deleteStripePaymentStatusChange:"StripePaymentStatusChangeDeleteResult",
		updateStripePaymentStatusChange:"StripePaymentStatusChangeUpdateResult",
		upsertStripePaymentStatusChange:"StripePaymentStatusChangeUpsertResult",
		createRegionPaymentMethod:"RegionPaymentMethodCreateResult",
		deleteRegionPaymentMethod:"RegionPaymentMethodDeleteResult",
		updateRegionPaymentMethod:"RegionPaymentMethodUpdateResult",
		upsertRegionPaymentMethod:"RegionPaymentMethodUpsertResult",
		createTileItem:"TileItemCreateResult",
		deleteTileItem:"TileItemDeleteResult",
		updateTileItem:"TileItemUpdateResult",
		upsertTileItem:"TileItemUpsertResult",
		createTileList:"TileListCreateResult",
		deleteTileList:"TileListDeleteResult",
		updateTileList:"TileListUpdateResult",
		upsertTileList:"TileListUpsertResult",
		createFeedPage:"FeedPageCreateResult",
		deleteFeedPage:"FeedPageDeleteResult",
		updateFeedPage:"FeedPageUpdateResult",
		upsertFeedPage:"FeedPageUpsertResult",
		createFeedPageLocale:"FeedPageLocaleCreateResult",
		deleteFeedPageLocale:"FeedPageLocaleDeleteResult",
		updateFeedPageLocale:"FeedPageLocaleUpdateResult",
		upsertFeedPageLocale:"FeedPageLocaleUpsertResult",
		createFeedPageSection:"FeedPageSectionCreateResult",
		deleteFeedPageSection:"FeedPageSectionDeleteResult",
		updateFeedPageSection:"FeedPageSectionUpdateResult",
		upsertFeedPageSection:"FeedPageSectionUpsertResult",
		createFeedPageTileStripe:"FeedPageTileStripeCreateResult",
		deleteFeedPageTileStripe:"FeedPageTileStripeDeleteResult",
		updateFeedPageTileStripe:"FeedPageTileStripeUpdateResult",
		upsertFeedPageTileStripe:"FeedPageTileStripeUpsertResult",
		createCardItem:"CardItemCreateResult",
		deleteCardItem:"CardItemDeleteResult",
		updateCardItem:"CardItemUpdateResult",
		upsertCardItem:"CardItemUpsertResult",
		createCardList:"CardListCreateResult",
		deleteCardList:"CardListDeleteResult",
		updateCardList:"CardListUpdateResult",
		upsertCardList:"CardListUpsertResult",
		createOnBehalfDonation:"OnBehalfDonationCreateResult",
		deleteOnBehalfDonation:"OnBehalfDonationDeleteResult",
		updateOnBehalfDonation:"OnBehalfDonationUpdateResult",
		upsertOnBehalfDonation:"OnBehalfDonationUpsertResult",
		createUserPaymentTriesCollection:"UserPaymentTriesCollectionCreateResult",
		deleteUserPaymentTriesCollection:"UserPaymentTriesCollectionDeleteResult",
		updateUserPaymentTriesCollection:"UserPaymentTriesCollectionUpdateResult",
		upsertUserPaymentTriesCollection:"UserPaymentTriesCollectionUpsertResult",
		createRecurringPaymentPage:"RecurringPaymentPageCreateResult",
		deleteRecurringPaymentPage:"RecurringPaymentPageDeleteResult",
		updateRecurringPaymentPage:"RecurringPaymentPageUpdateResult",
		upsertRecurringPaymentPage:"RecurringPaymentPageUpsertResult",
		createRecurringPaymentPageLocale:"RecurringPaymentPageLocaleCreateResult",
		deleteRecurringPaymentPageLocale:"RecurringPaymentPageLocaleDeleteResult",
		updateRecurringPaymentPageLocale:"RecurringPaymentPageLocaleUpdateResult",
		upsertRecurringPaymentPageLocale:"RecurringPaymentPageLocaleUpsertResult",
		createStoryGuide:"StoryGuideCreateResult",
		deleteStoryGuide:"StoryGuideDeleteResult",
		updateStoryGuide:"StoryGuideUpdateResult",
		upsertStoryGuide:"StoryGuideUpsertResult",
		createStoryGuideItem:"StoryGuideItemCreateResult",
		deleteStoryGuideItem:"StoryGuideItemDeleteResult",
		updateStoryGuideItem:"StoryGuideItemUpdateResult",
		upsertStoryGuideItem:"StoryGuideItemUpsertResult",
		createStoryGuideList:"StoryGuideListCreateResult",
		deleteStoryGuideList:"StoryGuideListDeleteResult",
		updateStoryGuideList:"StoryGuideListUpdateResult",
		upsertStoryGuideList:"StoryGuideListUpsertResult",
		createHeroCarousel:"HeroCarouselCreateResult",
		deleteHeroCarousel:"HeroCarouselDeleteResult",
		updateHeroCarousel:"HeroCarouselUpdateResult",
		upsertHeroCarousel:"HeroCarouselUpsertResult",
		createPostOrganizationList:"PostOrganizationListCreateResult",
		deletePostOrganizationList:"PostOrganizationListDeleteResult",
		updatePostOrganizationList:"PostOrganizationListUpdateResult",
		upsertPostOrganizationList:"PostOrganizationListUpsertResult",
		createPostOrganizationListItem:"PostOrganizationListItemCreateResult",
		deletePostOrganizationListItem:"PostOrganizationListItemDeleteResult",
		updatePostOrganizationListItem:"PostOrganizationListItemUpdateResult",
		upsertPostOrganizationListItem:"PostOrganizationListItemUpsertResult",
		createInfoCarousel:"InfoCarouselCreateResult",
		deleteInfoCarousel:"InfoCarouselDeleteResult",
		updateInfoCarousel:"InfoCarouselUpdateResult",
		upsertInfoCarousel:"InfoCarouselUpsertResult",
		createInfoCarouselItem:"InfoCarouselItemCreateResult",
		deleteInfoCarouselItem:"InfoCarouselItemDeleteResult",
		updateInfoCarouselItem:"InfoCarouselItemUpdateResult",
		upsertInfoCarouselItem:"InfoCarouselItemUpsertResult",
		createPersonSeenInfoCarousel:"PersonSeenInfoCarouselCreateResult",
		deletePersonSeenInfoCarousel:"PersonSeenInfoCarouselDeleteResult",
		updatePersonSeenInfoCarousel:"PersonSeenInfoCarouselUpdateResult",
		upsertPersonSeenInfoCarousel:"PersonSeenInfoCarouselUpsertResult",
		createGivenGiftsPage:"GivenGiftsPageCreateResult",
		deleteGivenGiftsPage:"GivenGiftsPageDeleteResult",
		updateGivenGiftsPage:"GivenGiftsPageUpdateResult",
		upsertGivenGiftsPage:"GivenGiftsPageUpsertResult",
		createGivenGiftsPageLocale:"GivenGiftsPageLocaleCreateResult",
		deleteGivenGiftsPageLocale:"GivenGiftsPageLocaleDeleteResult",
		updateGivenGiftsPageLocale:"GivenGiftsPageLocaleUpdateResult",
		upsertGivenGiftsPageLocale:"GivenGiftsPageLocaleUpsertResult",
		createReceivedGiftsPage:"ReceivedGiftsPageCreateResult",
		deleteReceivedGiftsPage:"ReceivedGiftsPageDeleteResult",
		updateReceivedGiftsPage:"ReceivedGiftsPageUpdateResult",
		upsertReceivedGiftsPage:"ReceivedGiftsPageUpsertResult",
		createReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleCreateResult",
		deleteReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleDeleteResult",
		updateReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleUpdateResult",
		upsertReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleUpsertResult",
		createReportNavigation:"ReportNavigationCreateResult",
		deleteReportNavigation:"ReportNavigationDeleteResult",
		updateReportNavigation:"ReportNavigationUpdateResult",
		upsertReportNavigation:"ReportNavigationUpsertResult",
		createReportPage:"ReportPageCreateResult",
		deleteReportPage:"ReportPageDeleteResult",
		updateReportPage:"ReportPageUpdateResult",
		upsertReportPage:"ReportPageUpsertResult",
		createReportPageLocale:"ReportPageLocaleCreateResult",
		deleteReportPageLocale:"ReportPageLocaleDeleteResult",
		updateReportPageLocale:"ReportPageLocaleUpdateResult",
		upsertReportPageLocale:"ReportPageLocaleUpsertResult",
		createReportNavigationLocale:"ReportNavigationLocaleCreateResult",
		deleteReportNavigationLocale:"ReportNavigationLocaleDeleteResult",
		updateReportNavigationLocale:"ReportNavigationLocaleUpdateResult",
		upsertReportNavigationLocale:"ReportNavigationLocaleUpsertResult",
		createSentPayment:"SentPaymentCreateResult",
		deleteSentPayment:"SentPaymentDeleteResult",
		updateSentPayment:"SentPaymentUpdateResult",
		upsertSentPayment:"SentPaymentUpsertResult",
		createNotificationTargetGroup:"NotificationTargetGroupCreateResult",
		deleteNotificationTargetGroup:"NotificationTargetGroupDeleteResult",
		updateNotificationTargetGroup:"NotificationTargetGroupUpdateResult",
		upsertNotificationTargetGroup:"NotificationTargetGroupUpsertResult",
		createProcessedNotification:"ProcessedNotificationCreateResult",
		deleteProcessedNotification:"ProcessedNotificationDeleteResult",
		updateProcessedNotification:"ProcessedNotificationUpdateResult",
		upsertProcessedNotification:"ProcessedNotificationUpsertResult",
		createScheduledNotification:"ScheduledNotificationCreateResult",
		deleteScheduledNotification:"ScheduledNotificationDeleteResult",
		updateScheduledNotification:"ScheduledNotificationUpdateResult",
		upsertScheduledNotification:"ScheduledNotificationUpsertResult",
		createProcessedNotificationSource:"ProcessedNotificationSourceCreateResult",
		deleteProcessedNotificationSource:"ProcessedNotificationSourceDeleteResult",
		updateProcessedNotificationSource:"ProcessedNotificationSourceUpdateResult",
		upsertProcessedNotificationSource:"ProcessedNotificationSourceUpsertResult",
		createDevice:"DeviceCreateResult",
		deleteDevice:"DeviceDeleteResult",
		updateDevice:"DeviceUpdateResult",
		upsertDevice:"DeviceUpsertResult",
		createScheduledNotificationLocale:"ScheduledNotificationLocaleCreateResult",
		deleteScheduledNotificationLocale:"ScheduledNotificationLocaleDeleteResult",
		updateScheduledNotificationLocale:"ScheduledNotificationLocaleUpdateResult",
		upsertScheduledNotificationLocale:"ScheduledNotificationLocaleUpsertResult",
		createInfoCarouselItemLocale:"InfoCarouselItemLocaleCreateResult",
		deleteInfoCarouselItemLocale:"InfoCarouselItemLocaleDeleteResult",
		updateInfoCarouselItemLocale:"InfoCarouselItemLocaleUpdateResult",
		upsertInfoCarouselItemLocale:"InfoCarouselItemLocaleUpsertResult",
		createSentPaymentLocale:"SentPaymentLocaleCreateResult",
		deleteSentPaymentLocale:"SentPaymentLocaleDeleteResult",
		updateSentPaymentLocale:"SentPaymentLocaleUpdateResult",
		upsertSentPaymentLocale:"SentPaymentLocaleUpsertResult",
		createTextImageList:"TextImageListCreateResult",
		deleteTextImageList:"TextImageListDeleteResult",
		updateTextImageList:"TextImageListUpdateResult",
		upsertTextImageList:"TextImageListUpsertResult",
		createTextImageListItem:"TextImageListItemCreateResult",
		deleteTextImageListItem:"TextImageListItemDeleteResult",
		updateTextImageListItem:"TextImageListItemUpdateResult",
		upsertTextImageListItem:"TextImageListItemUpsertResult",
		createHeroCarouselItem:"HeroCarouselItemCreateResult",
		deleteHeroCarouselItem:"HeroCarouselItemDeleteResult",
		updateHeroCarouselItem:"HeroCarouselItemUpdateResult",
		upsertHeroCarouselItem:"HeroCarouselItemUpsertResult",
		transaction:"MutationTransaction",
		query:"Query"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	},
	GeneralCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"General",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on GeneralCreateResult": "GeneralCreateResult",
		"...on GeneralDeleteResult": "GeneralDeleteResult",
		"...on GeneralUpdateResult": "GeneralUpdateResult",
		"...on GeneralUpsertResult": "GeneralUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on GenericPageCreateResult": "GenericPageCreateResult",
		"...on GenericPageDeleteResult": "GenericPageDeleteResult",
		"...on GenericPageUpdateResult": "GenericPageUpdateResult",
		"...on GenericPageUpsertResult": "GenericPageUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on GeneralLocaleCreateResult": "GeneralLocaleCreateResult",
		"...on GeneralLocaleDeleteResult": "GeneralLocaleDeleteResult",
		"...on GeneralLocaleUpdateResult": "GeneralLocaleUpdateResult",
		"...on GeneralLocaleUpsertResult": "GeneralLocaleUpsertResult",
		"...on GenericPageLocaleCreateResult": "GenericPageLocaleCreateResult",
		"...on GenericPageLocaleDeleteResult": "GenericPageLocaleDeleteResult",
		"...on GenericPageLocaleUpdateResult": "GenericPageLocaleUpdateResult",
		"...on GenericPageLocaleUpsertResult": "GenericPageLocaleUpsertResult",
		"...on LocaleCreateResult": "LocaleCreateResult",
		"...on LocaleDeleteResult": "LocaleDeleteResult",
		"...on LocaleUpdateResult": "LocaleUpdateResult",
		"...on LocaleUpsertResult": "LocaleUpsertResult",
		"...on VideoCreateResult": "VideoCreateResult",
		"...on VideoDeleteResult": "VideoDeleteResult",
		"...on VideoUpdateResult": "VideoUpdateResult",
		"...on VideoUpsertResult": "VideoUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on PostCreateResult": "PostCreateResult",
		"...on PostDeleteResult": "PostDeleteResult",
		"...on PostUpdateResult": "PostUpdateResult",
		"...on PostUpsertResult": "PostUpsertResult",
		"...on PostLocaleCreateResult": "PostLocaleCreateResult",
		"...on PostLocaleDeleteResult": "PostLocaleDeleteResult",
		"...on PostLocaleUpdateResult": "PostLocaleUpdateResult",
		"...on PostLocaleUpsertResult": "PostLocaleUpsertResult",
		"...on PostAreaCreateResult": "PostAreaCreateResult",
		"...on PostAreaDeleteResult": "PostAreaDeleteResult",
		"...on PostAreaUpdateResult": "PostAreaUpdateResult",
		"...on PostAreaUpsertResult": "PostAreaUpsertResult",
		"...on PostAreaLocaleCreateResult": "PostAreaLocaleCreateResult",
		"...on PostAreaLocaleDeleteResult": "PostAreaLocaleDeleteResult",
		"...on PostAreaLocaleUpdateResult": "PostAreaLocaleUpdateResult",
		"...on PostAreaLocaleUpsertResult": "PostAreaLocaleUpsertResult",
		"...on PostOrganizationCreateResult": "PostOrganizationCreateResult",
		"...on PostOrganizationDeleteResult": "PostOrganizationDeleteResult",
		"...on PostOrganizationUpdateResult": "PostOrganizationUpdateResult",
		"...on PostOrganizationUpsertResult": "PostOrganizationUpsertResult",
		"...on PostOrganizationLocaleCreateResult": "PostOrganizationLocaleCreateResult",
		"...on PostOrganizationLocaleDeleteResult": "PostOrganizationLocaleDeleteResult",
		"...on PostOrganizationLocaleUpdateResult": "PostOrganizationLocaleUpdateResult",
		"...on PostOrganizationLocaleUpsertResult": "PostOrganizationLocaleUpsertResult",
		"...on DonationCreateResult": "DonationCreateResult",
		"...on DonationDeleteResult": "DonationDeleteResult",
		"...on DonationUpdateResult": "DonationUpdateResult",
		"...on DonationUpsertResult": "DonationUpsertResult",
		"...on DonationAmountItemCreateResult": "DonationAmountItemCreateResult",
		"...on DonationAmountItemDeleteResult": "DonationAmountItemDeleteResult",
		"...on DonationAmountItemUpdateResult": "DonationAmountItemUpdateResult",
		"...on DonationAmountItemUpsertResult": "DonationAmountItemUpsertResult",
		"...on DonationAmountsRegionItemCreateResult": "DonationAmountsRegionItemCreateResult",
		"...on DonationAmountsRegionItemDeleteResult": "DonationAmountsRegionItemDeleteResult",
		"...on DonationAmountsRegionItemUpdateResult": "DonationAmountsRegionItemUpdateResult",
		"...on DonationAmountsRegionItemUpsertResult": "DonationAmountsRegionItemUpsertResult",
		"...on DonationAmountsRegionListCreateResult": "DonationAmountsRegionListCreateResult",
		"...on DonationAmountsRegionListDeleteResult": "DonationAmountsRegionListDeleteResult",
		"...on DonationAmountsRegionListUpdateResult": "DonationAmountsRegionListUpdateResult",
		"...on DonationAmountsRegionListUpsertResult": "DonationAmountsRegionListUpsertResult",
		"...on RegionCreateResult": "RegionCreateResult",
		"...on RegionDeleteResult": "RegionDeleteResult",
		"...on RegionUpdateResult": "RegionUpdateResult",
		"...on RegionUpsertResult": "RegionUpsertResult",
		"...on LinkItemCreateResult": "LinkItemCreateResult",
		"...on LinkItemDeleteResult": "LinkItemDeleteResult",
		"...on LinkItemUpdateResult": "LinkItemUpdateResult",
		"...on LinkItemUpsertResult": "LinkItemUpsertResult",
		"...on LinkListCreateResult": "LinkListCreateResult",
		"...on LinkListDeleteResult": "LinkListDeleteResult",
		"...on LinkListUpdateResult": "LinkListUpdateResult",
		"...on LinkListUpsertResult": "LinkListUpsertResult",
		"...on HeaderCreateResult": "HeaderCreateResult",
		"...on HeaderDeleteResult": "HeaderDeleteResult",
		"...on HeaderUpdateResult": "HeaderUpdateResult",
		"...on HeaderUpsertResult": "HeaderUpsertResult",
		"...on HeaderLocaleCreateResult": "HeaderLocaleCreateResult",
		"...on HeaderLocaleDeleteResult": "HeaderLocaleDeleteResult",
		"...on HeaderLocaleUpdateResult": "HeaderLocaleUpdateResult",
		"...on HeaderLocaleUpsertResult": "HeaderLocaleUpsertResult",
		"...on FooterCreateResult": "FooterCreateResult",
		"...on FooterDeleteResult": "FooterDeleteResult",
		"...on FooterUpdateResult": "FooterUpdateResult",
		"...on FooterUpsertResult": "FooterUpsertResult",
		"...on FooterLocaleCreateResult": "FooterLocaleCreateResult",
		"...on FooterLocaleDeleteResult": "FooterLocaleDeleteResult",
		"...on FooterLocaleUpdateResult": "FooterLocaleUpdateResult",
		"...on FooterLocaleUpsertResult": "FooterLocaleUpsertResult",
		"...on PostListCreateResult": "PostListCreateResult",
		"...on PostListDeleteResult": "PostListDeleteResult",
		"...on PostListUpdateResult": "PostListUpdateResult",
		"...on PostListUpsertResult": "PostListUpsertResult",
		"...on PostListItemCreateResult": "PostListItemCreateResult",
		"...on PostListItemDeleteResult": "PostListItemDeleteResult",
		"...on PostListItemUpdateResult": "PostListItemUpdateResult",
		"...on PostListItemUpsertResult": "PostListItemUpsertResult",
		"...on AppBannerCreateResult": "AppBannerCreateResult",
		"...on AppBannerDeleteResult": "AppBannerDeleteResult",
		"...on AppBannerUpdateResult": "AppBannerUpdateResult",
		"...on AppBannerUpsertResult": "AppBannerUpsertResult",
		"...on GenericPageAboutSettingsCreateResult": "GenericPageAboutSettingsCreateResult",
		"...on GenericPageAboutSettingsDeleteResult": "GenericPageAboutSettingsDeleteResult",
		"...on GenericPageAboutSettingsUpdateResult": "GenericPageAboutSettingsUpdateResult",
		"...on GenericPageAboutSettingsUpsertResult": "GenericPageAboutSettingsUpsertResult",
		"...on GenericPageAboutSettingsLocaleCreateResult": "GenericPageAboutSettingsLocaleCreateResult",
		"...on GenericPageAboutSettingsLocaleDeleteResult": "GenericPageAboutSettingsLocaleDeleteResult",
		"...on GenericPageAboutSettingsLocaleUpdateResult": "GenericPageAboutSettingsLocaleUpdateResult",
		"...on GenericPageAboutSettingsLocaleUpsertResult": "GenericPageAboutSettingsLocaleUpsertResult",
		"...on ValueCreateResult": "ValueCreateResult",
		"...on ValueDeleteResult": "ValueDeleteResult",
		"...on ValueUpdateResult": "ValueUpdateResult",
		"...on ValueUpsertResult": "ValueUpsertResult",
		"...on ValueItemCreateResult": "ValueItemCreateResult",
		"...on ValueItemDeleteResult": "ValueItemDeleteResult",
		"...on ValueItemUpdateResult": "ValueItemUpdateResult",
		"...on ValueItemUpsertResult": "ValueItemUpsertResult",
		"...on ValueListCreateResult": "ValueListCreateResult",
		"...on ValueListDeleteResult": "ValueListDeleteResult",
		"...on ValueListUpdateResult": "ValueListUpdateResult",
		"...on ValueListUpsertResult": "ValueListUpsertResult",
		"...on ImageLinkCreateResult": "ImageLinkCreateResult",
		"...on ImageLinkDeleteResult": "ImageLinkDeleteResult",
		"...on ImageLinkUpdateResult": "ImageLinkUpdateResult",
		"...on ImageLinkUpsertResult": "ImageLinkUpsertResult",
		"...on ImageLinkItemCreateResult": "ImageLinkItemCreateResult",
		"...on ImageLinkItemDeleteResult": "ImageLinkItemDeleteResult",
		"...on ImageLinkItemUpdateResult": "ImageLinkItemUpdateResult",
		"...on ImageLinkItemUpsertResult": "ImageLinkItemUpsertResult",
		"...on ImageLinkListCreateResult": "ImageLinkListCreateResult",
		"...on ImageLinkListDeleteResult": "ImageLinkListDeleteResult",
		"...on ImageLinkListUpdateResult": "ImageLinkListUpdateResult",
		"...on ImageLinkListUpsertResult": "ImageLinkListUpsertResult",
		"...on PostAreaListCreateResult": "PostAreaListCreateResult",
		"...on PostAreaListDeleteResult": "PostAreaListDeleteResult",
		"...on PostAreaListUpdateResult": "PostAreaListUpdateResult",
		"...on PostAreaListUpsertResult": "PostAreaListUpsertResult",
		"...on PostAreaListItemCreateResult": "PostAreaListItemCreateResult",
		"...on PostAreaListItemDeleteResult": "PostAreaListItemDeleteResult",
		"...on PostAreaListItemUpdateResult": "PostAreaListItemUpdateResult",
		"...on PostAreaListItemUpsertResult": "PostAreaListItemUpsertResult",
		"...on AccordionCreateResult": "AccordionCreateResult",
		"...on AccordionDeleteResult": "AccordionDeleteResult",
		"...on AccordionUpdateResult": "AccordionUpdateResult",
		"...on AccordionUpsertResult": "AccordionUpsertResult",
		"...on AccordionItemCreateResult": "AccordionItemCreateResult",
		"...on AccordionItemDeleteResult": "AccordionItemDeleteResult",
		"...on AccordionItemUpdateResult": "AccordionItemUpdateResult",
		"...on AccordionItemUpsertResult": "AccordionItemUpsertResult",
		"...on UserCreateResult": "UserCreateResult",
		"...on UserDeleteResult": "UserDeleteResult",
		"...on UserUpdateResult": "UserUpdateResult",
		"...on UserUpsertResult": "UserUpsertResult",
		"...on UserPaymentCreateResult": "UserPaymentCreateResult",
		"...on UserPaymentDeleteResult": "UserPaymentDeleteResult",
		"...on UserPaymentUpdateResult": "UserPaymentUpdateResult",
		"...on UserPaymentUpsertResult": "UserPaymentUpsertResult",
		"...on CurrencyCreateResult": "CurrencyCreateResult",
		"...on CurrencyDeleteResult": "CurrencyDeleteResult",
		"...on CurrencyUpdateResult": "CurrencyUpdateResult",
		"...on CurrencyUpsertResult": "CurrencyUpsertResult",
		"...on MediumCreateResult": "MediumCreateResult",
		"...on MediumDeleteResult": "MediumDeleteResult",
		"...on MediumUpdateResult": "MediumUpdateResult",
		"...on MediumUpsertResult": "MediumUpsertResult",
		"...on MediumItemCreateResult": "MediumItemCreateResult",
		"...on MediumItemDeleteResult": "MediumItemDeleteResult",
		"...on MediumItemUpdateResult": "MediumItemUpdateResult",
		"...on MediumItemUpsertResult": "MediumItemUpsertResult",
		"...on MediumListCreateResult": "MediumListCreateResult",
		"...on MediumListDeleteResult": "MediumListDeleteResult",
		"...on MediumListUpdateResult": "MediumListUpdateResult",
		"...on MediumListUpsertResult": "MediumListUpsertResult",
		"...on UserPaymentOrderIdCreateResult": "UserPaymentOrderIdCreateResult",
		"...on UserPaymentOrderIdDeleteResult": "UserPaymentOrderIdDeleteResult",
		"...on UserPaymentOrderIdUpdateResult": "UserPaymentOrderIdUpdateResult",
		"...on UserPaymentOrderIdUpsertResult": "UserPaymentOrderIdUpsertResult",
		"...on PostRevisionCreateResult": "PostRevisionCreateResult",
		"...on PostRevisionDeleteResult": "PostRevisionDeleteResult",
		"...on PostRevisionUpdateResult": "PostRevisionUpdateResult",
		"...on PostRevisionUpsertResult": "PostRevisionUpsertResult",
		"...on UserRecurringPaymentCreateResult": "UserRecurringPaymentCreateResult",
		"...on UserRecurringPaymentDeleteResult": "UserRecurringPaymentDeleteResult",
		"...on UserRecurringPaymentUpdateResult": "UserRecurringPaymentUpdateResult",
		"...on UserRecurringPaymentUpsertResult": "UserRecurringPaymentUpsertResult",
		"...on UserRecurringPaymentItemCreateResult": "UserRecurringPaymentItemCreateResult",
		"...on UserRecurringPaymentItemDeleteResult": "UserRecurringPaymentItemDeleteResult",
		"...on UserRecurringPaymentItemUpdateResult": "UserRecurringPaymentItemUpdateResult",
		"...on UserRecurringPaymentItemUpsertResult": "UserRecurringPaymentItemUpsertResult",
		"...on PostRevisionLocaleCreateResult": "PostRevisionLocaleCreateResult",
		"...on PostRevisionLocaleDeleteResult": "PostRevisionLocaleDeleteResult",
		"...on PostRevisionLocaleUpdateResult": "PostRevisionLocaleUpdateResult",
		"...on PostRevisionLocaleUpsertResult": "PostRevisionLocaleUpsertResult",
		"...on TranslationCatalogueCreateResult": "TranslationCatalogueCreateResult",
		"...on TranslationCatalogueDeleteResult": "TranslationCatalogueDeleteResult",
		"...on TranslationCatalogueUpdateResult": "TranslationCatalogueUpdateResult",
		"...on TranslationCatalogueUpsertResult": "TranslationCatalogueUpsertResult",
		"...on TranslationCataloguesIdentifierCreateResult": "TranslationCataloguesIdentifierCreateResult",
		"...on TranslationCataloguesIdentifierDeleteResult": "TranslationCataloguesIdentifierDeleteResult",
		"...on TranslationCataloguesIdentifierUpdateResult": "TranslationCataloguesIdentifierUpdateResult",
		"...on TranslationCataloguesIdentifierUpsertResult": "TranslationCataloguesIdentifierUpsertResult",
		"...on TranslationDomainCreateResult": "TranslationDomainCreateResult",
		"...on TranslationDomainDeleteResult": "TranslationDomainDeleteResult",
		"...on TranslationDomainUpdateResult": "TranslationDomainUpdateResult",
		"...on TranslationDomainUpsertResult": "TranslationDomainUpsertResult",
		"...on TranslationKeyCreateResult": "TranslationKeyCreateResult",
		"...on TranslationKeyDeleteResult": "TranslationKeyDeleteResult",
		"...on TranslationKeyUpdateResult": "TranslationKeyUpdateResult",
		"...on TranslationKeyUpsertResult": "TranslationKeyUpsertResult",
		"...on TranslationValueCreateResult": "TranslationValueCreateResult",
		"...on TranslationValueDeleteResult": "TranslationValueDeleteResult",
		"...on TranslationValueUpdateResult": "TranslationValueUpdateResult",
		"...on TranslationValueUpsertResult": "TranslationValueUpsertResult",
		"...on GenericPageAboutGroupLinksLocaleCreateResult": "GenericPageAboutGroupLinksLocaleCreateResult",
		"...on GenericPageAboutGroupLinksLocaleDeleteResult": "GenericPageAboutGroupLinksLocaleDeleteResult",
		"...on GenericPageAboutGroupLinksLocaleUpdateResult": "GenericPageAboutGroupLinksLocaleUpdateResult",
		"...on GenericPageAboutGroupLinksLocaleUpsertResult": "GenericPageAboutGroupLinksLocaleUpsertResult",
		"...on MemberListCreateResult": "MemberListCreateResult",
		"...on MemberListDeleteResult": "MemberListDeleteResult",
		"...on MemberListUpdateResult": "MemberListUpdateResult",
		"...on MemberListUpsertResult": "MemberListUpsertResult",
		"...on MemberListItemCreateResult": "MemberListItemCreateResult",
		"...on MemberListItemDeleteResult": "MemberListItemDeleteResult",
		"...on MemberListItemUpdateResult": "MemberListItemUpdateResult",
		"...on MemberListItemUpsertResult": "MemberListItemUpsertResult",
		"...on FilledTaxFormCreateResult": "FilledTaxFormCreateResult",
		"...on FilledTaxFormDeleteResult": "FilledTaxFormDeleteResult",
		"...on FilledTaxFormUpdateResult": "FilledTaxFormUpdateResult",
		"...on FilledTaxFormUpsertResult": "FilledTaxFormUpsertResult",
		"...on FilledTaxFormEmailAddressCreateResult": "FilledTaxFormEmailAddressCreateResult",
		"...on FilledTaxFormEmailAddressDeleteResult": "FilledTaxFormEmailAddressDeleteResult",
		"...on FilledTaxFormEmailAddressUpdateResult": "FilledTaxFormEmailAddressUpdateResult",
		"...on FilledTaxFormEmailAddressUpsertResult": "FilledTaxFormEmailAddressUpsertResult",
		"...on FormCreateResult": "FormCreateResult",
		"...on FormDeleteResult": "FormDeleteResult",
		"...on FormUpdateResult": "FormUpdateResult",
		"...on FormUpsertResult": "FormUpsertResult",
		"...on CsobPaymentCreateResult": "CsobPaymentCreateResult",
		"...on CsobPaymentDeleteResult": "CsobPaymentDeleteResult",
		"...on CsobPaymentUpdateResult": "CsobPaymentUpdateResult",
		"...on CsobPaymentUpsertResult": "CsobPaymentUpsertResult",
		"...on CsobPaymentStatusChangeCreateResult": "CsobPaymentStatusChangeCreateResult",
		"...on CsobPaymentStatusChangeDeleteResult": "CsobPaymentStatusChangeDeleteResult",
		"...on CsobPaymentStatusChangeUpdateResult": "CsobPaymentStatusChangeUpdateResult",
		"...on CsobPaymentStatusChangeUpsertResult": "CsobPaymentStatusChangeUpsertResult",
		"...on StripePaymentCreateResult": "StripePaymentCreateResult",
		"...on StripePaymentDeleteResult": "StripePaymentDeleteResult",
		"...on StripePaymentUpdateResult": "StripePaymentUpdateResult",
		"...on StripePaymentUpsertResult": "StripePaymentUpsertResult",
		"...on StripePaymentStatusChangeCreateResult": "StripePaymentStatusChangeCreateResult",
		"...on StripePaymentStatusChangeDeleteResult": "StripePaymentStatusChangeDeleteResult",
		"...on StripePaymentStatusChangeUpdateResult": "StripePaymentStatusChangeUpdateResult",
		"...on StripePaymentStatusChangeUpsertResult": "StripePaymentStatusChangeUpsertResult",
		"...on RegionPaymentMethodCreateResult": "RegionPaymentMethodCreateResult",
		"...on RegionPaymentMethodDeleteResult": "RegionPaymentMethodDeleteResult",
		"...on RegionPaymentMethodUpdateResult": "RegionPaymentMethodUpdateResult",
		"...on RegionPaymentMethodUpsertResult": "RegionPaymentMethodUpsertResult",
		"...on TileItemCreateResult": "TileItemCreateResult",
		"...on TileItemDeleteResult": "TileItemDeleteResult",
		"...on TileItemUpdateResult": "TileItemUpdateResult",
		"...on TileItemUpsertResult": "TileItemUpsertResult",
		"...on TileListCreateResult": "TileListCreateResult",
		"...on TileListDeleteResult": "TileListDeleteResult",
		"...on TileListUpdateResult": "TileListUpdateResult",
		"...on TileListUpsertResult": "TileListUpsertResult",
		"...on FeedPageCreateResult": "FeedPageCreateResult",
		"...on FeedPageDeleteResult": "FeedPageDeleteResult",
		"...on FeedPageUpdateResult": "FeedPageUpdateResult",
		"...on FeedPageUpsertResult": "FeedPageUpsertResult",
		"...on FeedPageLocaleCreateResult": "FeedPageLocaleCreateResult",
		"...on FeedPageLocaleDeleteResult": "FeedPageLocaleDeleteResult",
		"...on FeedPageLocaleUpdateResult": "FeedPageLocaleUpdateResult",
		"...on FeedPageLocaleUpsertResult": "FeedPageLocaleUpsertResult",
		"...on FeedPageSectionCreateResult": "FeedPageSectionCreateResult",
		"...on FeedPageSectionDeleteResult": "FeedPageSectionDeleteResult",
		"...on FeedPageSectionUpdateResult": "FeedPageSectionUpdateResult",
		"...on FeedPageSectionUpsertResult": "FeedPageSectionUpsertResult",
		"...on FeedPageTileStripeCreateResult": "FeedPageTileStripeCreateResult",
		"...on FeedPageTileStripeDeleteResult": "FeedPageTileStripeDeleteResult",
		"...on FeedPageTileStripeUpdateResult": "FeedPageTileStripeUpdateResult",
		"...on FeedPageTileStripeUpsertResult": "FeedPageTileStripeUpsertResult",
		"...on CardItemCreateResult": "CardItemCreateResult",
		"...on CardItemDeleteResult": "CardItemDeleteResult",
		"...on CardItemUpdateResult": "CardItemUpdateResult",
		"...on CardItemUpsertResult": "CardItemUpsertResult",
		"...on CardListCreateResult": "CardListCreateResult",
		"...on CardListDeleteResult": "CardListDeleteResult",
		"...on CardListUpdateResult": "CardListUpdateResult",
		"...on CardListUpsertResult": "CardListUpsertResult",
		"...on OnBehalfDonationCreateResult": "OnBehalfDonationCreateResult",
		"...on OnBehalfDonationDeleteResult": "OnBehalfDonationDeleteResult",
		"...on OnBehalfDonationUpdateResult": "OnBehalfDonationUpdateResult",
		"...on OnBehalfDonationUpsertResult": "OnBehalfDonationUpsertResult",
		"...on UserPaymentTriesCollectionCreateResult": "UserPaymentTriesCollectionCreateResult",
		"...on UserPaymentTriesCollectionDeleteResult": "UserPaymentTriesCollectionDeleteResult",
		"...on UserPaymentTriesCollectionUpdateResult": "UserPaymentTriesCollectionUpdateResult",
		"...on UserPaymentTriesCollectionUpsertResult": "UserPaymentTriesCollectionUpsertResult",
		"...on RecurringPaymentPageCreateResult": "RecurringPaymentPageCreateResult",
		"...on RecurringPaymentPageDeleteResult": "RecurringPaymentPageDeleteResult",
		"...on RecurringPaymentPageUpdateResult": "RecurringPaymentPageUpdateResult",
		"...on RecurringPaymentPageUpsertResult": "RecurringPaymentPageUpsertResult",
		"...on RecurringPaymentPageLocaleCreateResult": "RecurringPaymentPageLocaleCreateResult",
		"...on RecurringPaymentPageLocaleDeleteResult": "RecurringPaymentPageLocaleDeleteResult",
		"...on RecurringPaymentPageLocaleUpdateResult": "RecurringPaymentPageLocaleUpdateResult",
		"...on RecurringPaymentPageLocaleUpsertResult": "RecurringPaymentPageLocaleUpsertResult",
		"...on StoryGuideCreateResult": "StoryGuideCreateResult",
		"...on StoryGuideDeleteResult": "StoryGuideDeleteResult",
		"...on StoryGuideUpdateResult": "StoryGuideUpdateResult",
		"...on StoryGuideUpsertResult": "StoryGuideUpsertResult",
		"...on StoryGuideItemCreateResult": "StoryGuideItemCreateResult",
		"...on StoryGuideItemDeleteResult": "StoryGuideItemDeleteResult",
		"...on StoryGuideItemUpdateResult": "StoryGuideItemUpdateResult",
		"...on StoryGuideItemUpsertResult": "StoryGuideItemUpsertResult",
		"...on StoryGuideListCreateResult": "StoryGuideListCreateResult",
		"...on StoryGuideListDeleteResult": "StoryGuideListDeleteResult",
		"...on StoryGuideListUpdateResult": "StoryGuideListUpdateResult",
		"...on StoryGuideListUpsertResult": "StoryGuideListUpsertResult",
		"...on HeroCarouselCreateResult": "HeroCarouselCreateResult",
		"...on HeroCarouselDeleteResult": "HeroCarouselDeleteResult",
		"...on HeroCarouselUpdateResult": "HeroCarouselUpdateResult",
		"...on HeroCarouselUpsertResult": "HeroCarouselUpsertResult",
		"...on PostOrganizationListCreateResult": "PostOrganizationListCreateResult",
		"...on PostOrganizationListDeleteResult": "PostOrganizationListDeleteResult",
		"...on PostOrganizationListUpdateResult": "PostOrganizationListUpdateResult",
		"...on PostOrganizationListUpsertResult": "PostOrganizationListUpsertResult",
		"...on PostOrganizationListItemCreateResult": "PostOrganizationListItemCreateResult",
		"...on PostOrganizationListItemDeleteResult": "PostOrganizationListItemDeleteResult",
		"...on PostOrganizationListItemUpdateResult": "PostOrganizationListItemUpdateResult",
		"...on PostOrganizationListItemUpsertResult": "PostOrganizationListItemUpsertResult",
		"...on InfoCarouselCreateResult": "InfoCarouselCreateResult",
		"...on InfoCarouselDeleteResult": "InfoCarouselDeleteResult",
		"...on InfoCarouselUpdateResult": "InfoCarouselUpdateResult",
		"...on InfoCarouselUpsertResult": "InfoCarouselUpsertResult",
		"...on InfoCarouselItemCreateResult": "InfoCarouselItemCreateResult",
		"...on InfoCarouselItemDeleteResult": "InfoCarouselItemDeleteResult",
		"...on InfoCarouselItemUpdateResult": "InfoCarouselItemUpdateResult",
		"...on InfoCarouselItemUpsertResult": "InfoCarouselItemUpsertResult",
		"...on PersonSeenInfoCarouselCreateResult": "PersonSeenInfoCarouselCreateResult",
		"...on PersonSeenInfoCarouselDeleteResult": "PersonSeenInfoCarouselDeleteResult",
		"...on PersonSeenInfoCarouselUpdateResult": "PersonSeenInfoCarouselUpdateResult",
		"...on PersonSeenInfoCarouselUpsertResult": "PersonSeenInfoCarouselUpsertResult",
		"...on GivenGiftsPageCreateResult": "GivenGiftsPageCreateResult",
		"...on GivenGiftsPageDeleteResult": "GivenGiftsPageDeleteResult",
		"...on GivenGiftsPageUpdateResult": "GivenGiftsPageUpdateResult",
		"...on GivenGiftsPageUpsertResult": "GivenGiftsPageUpsertResult",
		"...on GivenGiftsPageLocaleCreateResult": "GivenGiftsPageLocaleCreateResult",
		"...on GivenGiftsPageLocaleDeleteResult": "GivenGiftsPageLocaleDeleteResult",
		"...on GivenGiftsPageLocaleUpdateResult": "GivenGiftsPageLocaleUpdateResult",
		"...on GivenGiftsPageLocaleUpsertResult": "GivenGiftsPageLocaleUpsertResult",
		"...on ReceivedGiftsPageCreateResult": "ReceivedGiftsPageCreateResult",
		"...on ReceivedGiftsPageDeleteResult": "ReceivedGiftsPageDeleteResult",
		"...on ReceivedGiftsPageUpdateResult": "ReceivedGiftsPageUpdateResult",
		"...on ReceivedGiftsPageUpsertResult": "ReceivedGiftsPageUpsertResult",
		"...on ReceivedGiftsPageLocaleCreateResult": "ReceivedGiftsPageLocaleCreateResult",
		"...on ReceivedGiftsPageLocaleDeleteResult": "ReceivedGiftsPageLocaleDeleteResult",
		"...on ReceivedGiftsPageLocaleUpdateResult": "ReceivedGiftsPageLocaleUpdateResult",
		"...on ReceivedGiftsPageLocaleUpsertResult": "ReceivedGiftsPageLocaleUpsertResult",
		"...on ReportNavigationCreateResult": "ReportNavigationCreateResult",
		"...on ReportNavigationDeleteResult": "ReportNavigationDeleteResult",
		"...on ReportNavigationUpdateResult": "ReportNavigationUpdateResult",
		"...on ReportNavigationUpsertResult": "ReportNavigationUpsertResult",
		"...on ReportPageCreateResult": "ReportPageCreateResult",
		"...on ReportPageDeleteResult": "ReportPageDeleteResult",
		"...on ReportPageUpdateResult": "ReportPageUpdateResult",
		"...on ReportPageUpsertResult": "ReportPageUpsertResult",
		"...on ReportPageLocaleCreateResult": "ReportPageLocaleCreateResult",
		"...on ReportPageLocaleDeleteResult": "ReportPageLocaleDeleteResult",
		"...on ReportPageLocaleUpdateResult": "ReportPageLocaleUpdateResult",
		"...on ReportPageLocaleUpsertResult": "ReportPageLocaleUpsertResult",
		"...on ReportNavigationLocaleCreateResult": "ReportNavigationLocaleCreateResult",
		"...on ReportNavigationLocaleDeleteResult": "ReportNavigationLocaleDeleteResult",
		"...on ReportNavigationLocaleUpdateResult": "ReportNavigationLocaleUpdateResult",
		"...on ReportNavigationLocaleUpsertResult": "ReportNavigationLocaleUpsertResult",
		"...on SentPaymentCreateResult": "SentPaymentCreateResult",
		"...on SentPaymentDeleteResult": "SentPaymentDeleteResult",
		"...on SentPaymentUpdateResult": "SentPaymentUpdateResult",
		"...on SentPaymentUpsertResult": "SentPaymentUpsertResult",
		"...on NotificationTargetGroupCreateResult": "NotificationTargetGroupCreateResult",
		"...on NotificationTargetGroupDeleteResult": "NotificationTargetGroupDeleteResult",
		"...on NotificationTargetGroupUpdateResult": "NotificationTargetGroupUpdateResult",
		"...on NotificationTargetGroupUpsertResult": "NotificationTargetGroupUpsertResult",
		"...on ProcessedNotificationCreateResult": "ProcessedNotificationCreateResult",
		"...on ProcessedNotificationDeleteResult": "ProcessedNotificationDeleteResult",
		"...on ProcessedNotificationUpdateResult": "ProcessedNotificationUpdateResult",
		"...on ProcessedNotificationUpsertResult": "ProcessedNotificationUpsertResult",
		"...on ScheduledNotificationCreateResult": "ScheduledNotificationCreateResult",
		"...on ScheduledNotificationDeleteResult": "ScheduledNotificationDeleteResult",
		"...on ScheduledNotificationUpdateResult": "ScheduledNotificationUpdateResult",
		"...on ScheduledNotificationUpsertResult": "ScheduledNotificationUpsertResult",
		"...on ProcessedNotificationSourceCreateResult": "ProcessedNotificationSourceCreateResult",
		"...on ProcessedNotificationSourceDeleteResult": "ProcessedNotificationSourceDeleteResult",
		"...on ProcessedNotificationSourceUpdateResult": "ProcessedNotificationSourceUpdateResult",
		"...on ProcessedNotificationSourceUpsertResult": "ProcessedNotificationSourceUpsertResult",
		"...on DeviceCreateResult": "DeviceCreateResult",
		"...on DeviceDeleteResult": "DeviceDeleteResult",
		"...on DeviceUpdateResult": "DeviceUpdateResult",
		"...on DeviceUpsertResult": "DeviceUpsertResult",
		"...on ScheduledNotificationLocaleCreateResult": "ScheduledNotificationLocaleCreateResult",
		"...on ScheduledNotificationLocaleDeleteResult": "ScheduledNotificationLocaleDeleteResult",
		"...on ScheduledNotificationLocaleUpdateResult": "ScheduledNotificationLocaleUpdateResult",
		"...on ScheduledNotificationLocaleUpsertResult": "ScheduledNotificationLocaleUpsertResult",
		"...on InfoCarouselItemLocaleCreateResult": "InfoCarouselItemLocaleCreateResult",
		"...on InfoCarouselItemLocaleDeleteResult": "InfoCarouselItemLocaleDeleteResult",
		"...on InfoCarouselItemLocaleUpdateResult": "InfoCarouselItemLocaleUpdateResult",
		"...on InfoCarouselItemLocaleUpsertResult": "InfoCarouselItemLocaleUpsertResult",
		"...on SentPaymentLocaleCreateResult": "SentPaymentLocaleCreateResult",
		"...on SentPaymentLocaleDeleteResult": "SentPaymentLocaleDeleteResult",
		"...on SentPaymentLocaleUpdateResult": "SentPaymentLocaleUpdateResult",
		"...on SentPaymentLocaleUpsertResult": "SentPaymentLocaleUpsertResult",
		"...on TextImageListCreateResult": "TextImageListCreateResult",
		"...on TextImageListDeleteResult": "TextImageListDeleteResult",
		"...on TextImageListUpdateResult": "TextImageListUpdateResult",
		"...on TextImageListUpsertResult": "TextImageListUpsertResult",
		"...on TextImageListItemCreateResult": "TextImageListItemCreateResult",
		"...on TextImageListItemDeleteResult": "TextImageListItemDeleteResult",
		"...on TextImageListItemUpdateResult": "TextImageListItemUpdateResult",
		"...on TextImageListItemUpsertResult": "TextImageListItemUpsertResult",
		"...on HeroCarouselItemCreateResult": "HeroCarouselItemCreateResult",
		"...on HeroCarouselItemDeleteResult": "HeroCarouselItemDeleteResult",
		"...on HeroCarouselItemUpdateResult": "HeroCarouselItemUpdateResult",
		"...on HeroCarouselItemUpsertResult": "HeroCarouselItemUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	GeneralDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"General"
	},
	GeneralUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"General",
		validation:"_ValidationResult"
	},
	GeneralUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"General",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	GenericPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	GenericPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage"
	},
	GenericPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	GenericPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	GeneralLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GeneralLocale",
		validation:"_ValidationResult"
	},
	GeneralLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GeneralLocale"
	},
	GeneralLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GeneralLocale",
		validation:"_ValidationResult"
	},
	GeneralLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GeneralLocale",
		validation:"_ValidationResult"
	},
	GenericPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageLocale",
		validation:"_ValidationResult"
	},
	GenericPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageLocale"
	},
	GenericPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageLocale",
		validation:"_ValidationResult"
	},
	GenericPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageLocale",
		validation:"_ValidationResult"
	},
	LocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale"
	},
	LocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	VideoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video"
	},
	VideoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	PostCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Post",
		validation:"_ValidationResult"
	},
	PostDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Post"
	},
	PostUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Post",
		validation:"_ValidationResult"
	},
	PostUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Post",
		validation:"_ValidationResult"
	},
	PostLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostLocale",
		validation:"_ValidationResult"
	},
	PostLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostLocale"
	},
	PostLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostLocale",
		validation:"_ValidationResult"
	},
	PostLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostLocale",
		validation:"_ValidationResult"
	},
	PostAreaCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostArea",
		validation:"_ValidationResult"
	},
	PostAreaDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostArea"
	},
	PostAreaUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostArea",
		validation:"_ValidationResult"
	},
	PostAreaUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostArea",
		validation:"_ValidationResult"
	},
	PostAreaLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaLocale",
		validation:"_ValidationResult"
	},
	PostAreaLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaLocale"
	},
	PostAreaLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaLocale",
		validation:"_ValidationResult"
	},
	PostAreaLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaLocale",
		validation:"_ValidationResult"
	},
	PostOrganizationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganization",
		validation:"_ValidationResult"
	},
	PostOrganizationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganization"
	},
	PostOrganizationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganization",
		validation:"_ValidationResult"
	},
	PostOrganizationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganization",
		validation:"_ValidationResult"
	},
	PostOrganizationLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationLocale",
		validation:"_ValidationResult"
	},
	PostOrganizationLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationLocale"
	},
	PostOrganizationLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationLocale",
		validation:"_ValidationResult"
	},
	PostOrganizationLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationLocale",
		validation:"_ValidationResult"
	},
	DonationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Donation",
		validation:"_ValidationResult"
	},
	DonationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Donation"
	},
	DonationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Donation",
		validation:"_ValidationResult"
	},
	DonationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Donation",
		validation:"_ValidationResult"
	},
	DonationAmountItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountItem",
		validation:"_ValidationResult"
	},
	DonationAmountItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountItem"
	},
	DonationAmountItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountItem",
		validation:"_ValidationResult"
	},
	DonationAmountItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountItem",
		validation:"_ValidationResult"
	},
	DonationAmountsRegionItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountsRegionItem",
		validation:"_ValidationResult"
	},
	DonationAmountsRegionItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountsRegionItem"
	},
	DonationAmountsRegionItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountsRegionItem",
		validation:"_ValidationResult"
	},
	DonationAmountsRegionItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountsRegionItem",
		validation:"_ValidationResult"
	},
	DonationAmountsRegionListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountsRegionList",
		validation:"_ValidationResult"
	},
	DonationAmountsRegionListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountsRegionList"
	},
	DonationAmountsRegionListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountsRegionList",
		validation:"_ValidationResult"
	},
	DonationAmountsRegionListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DonationAmountsRegionList",
		validation:"_ValidationResult"
	},
	RegionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Region",
		validation:"_ValidationResult"
	},
	RegionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Region"
	},
	RegionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Region",
		validation:"_ValidationResult"
	},
	RegionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Region",
		validation:"_ValidationResult"
	},
	LinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem"
	},
	LinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList"
	},
	LinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	HeaderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header"
	},
	HeaderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HeaderLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale"
	},
	HeaderLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HeaderLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	FooterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer"
	},
	FooterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale"
	},
	FooterLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	PostListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostList",
		validation:"_ValidationResult"
	},
	PostListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostList"
	},
	PostListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostList",
		validation:"_ValidationResult"
	},
	PostListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostList",
		validation:"_ValidationResult"
	},
	PostListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostListItem",
		validation:"_ValidationResult"
	},
	PostListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostListItem"
	},
	PostListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostListItem",
		validation:"_ValidationResult"
	},
	PostListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostListItem",
		validation:"_ValidationResult"
	},
	AppBannerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppBanner",
		validation:"_ValidationResult"
	},
	AppBannerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppBanner"
	},
	AppBannerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppBanner",
		validation:"_ValidationResult"
	},
	AppBannerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppBanner",
		validation:"_ValidationResult"
	},
	GenericPageAboutSettingsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutSettings",
		validation:"_ValidationResult"
	},
	GenericPageAboutSettingsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutSettings"
	},
	GenericPageAboutSettingsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutSettings",
		validation:"_ValidationResult"
	},
	GenericPageAboutSettingsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutSettings",
		validation:"_ValidationResult"
	},
	GenericPageAboutSettingsLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutSettingsLocale",
		validation:"_ValidationResult"
	},
	GenericPageAboutSettingsLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutSettingsLocale"
	},
	GenericPageAboutSettingsLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutSettingsLocale",
		validation:"_ValidationResult"
	},
	GenericPageAboutSettingsLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutSettingsLocale",
		validation:"_ValidationResult"
	},
	ValueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Value",
		validation:"_ValidationResult"
	},
	ValueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Value"
	},
	ValueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Value",
		validation:"_ValidationResult"
	},
	ValueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Value",
		validation:"_ValidationResult"
	},
	ValueItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ValueItem",
		validation:"_ValidationResult"
	},
	ValueItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ValueItem"
	},
	ValueItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ValueItem",
		validation:"_ValidationResult"
	},
	ValueItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ValueItem",
		validation:"_ValidationResult"
	},
	ValueListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ValueList",
		validation:"_ValidationResult"
	},
	ValueListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ValueList"
	},
	ValueListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ValueList",
		validation:"_ValidationResult"
	},
	ValueListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ValueList",
		validation:"_ValidationResult"
	},
	ImageLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLink",
		validation:"_ValidationResult"
	},
	ImageLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLink"
	},
	ImageLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLink",
		validation:"_ValidationResult"
	},
	ImageLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLink",
		validation:"_ValidationResult"
	},
	ImageLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLinkItem",
		validation:"_ValidationResult"
	},
	ImageLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLinkItem"
	},
	ImageLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLinkItem",
		validation:"_ValidationResult"
	},
	ImageLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLinkItem",
		validation:"_ValidationResult"
	},
	ImageLinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLinkList",
		validation:"_ValidationResult"
	},
	ImageLinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLinkList"
	},
	ImageLinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLinkList",
		validation:"_ValidationResult"
	},
	ImageLinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageLinkList",
		validation:"_ValidationResult"
	},
	PostAreaListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaList",
		validation:"_ValidationResult"
	},
	PostAreaListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaList"
	},
	PostAreaListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaList",
		validation:"_ValidationResult"
	},
	PostAreaListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaList",
		validation:"_ValidationResult"
	},
	PostAreaListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaListItem",
		validation:"_ValidationResult"
	},
	PostAreaListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaListItem"
	},
	PostAreaListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaListItem",
		validation:"_ValidationResult"
	},
	PostAreaListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostAreaListItem",
		validation:"_ValidationResult"
	},
	AccordionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Accordion",
		validation:"_ValidationResult"
	},
	AccordionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Accordion"
	},
	AccordionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Accordion",
		validation:"_ValidationResult"
	},
	AccordionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Accordion",
		validation:"_ValidationResult"
	},
	AccordionItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AccordionItem",
		validation:"_ValidationResult"
	},
	AccordionItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AccordionItem"
	},
	AccordionItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AccordionItem",
		validation:"_ValidationResult"
	},
	AccordionItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AccordionItem",
		validation:"_ValidationResult"
	},
	UserCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	UserDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User"
	},
	UserUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	UserUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	UserPaymentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPayment",
		validation:"_ValidationResult"
	},
	UserPaymentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPayment"
	},
	UserPaymentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPayment",
		validation:"_ValidationResult"
	},
	UserPaymentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPayment",
		validation:"_ValidationResult"
	},
	CurrencyCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Currency",
		validation:"_ValidationResult"
	},
	CurrencyDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Currency"
	},
	CurrencyUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Currency",
		validation:"_ValidationResult"
	},
	CurrencyUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Currency",
		validation:"_ValidationResult"
	},
	MediumCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium"
	},
	MediumUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem"
	},
	MediumItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	MediumListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList"
	},
	MediumListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	MediumListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	UserPaymentOrderIdCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPaymentOrderId",
		validation:"_ValidationResult"
	},
	UserPaymentOrderIdDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPaymentOrderId"
	},
	UserPaymentOrderIdUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPaymentOrderId",
		validation:"_ValidationResult"
	},
	UserPaymentOrderIdUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPaymentOrderId",
		validation:"_ValidationResult"
	},
	PostRevisionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostRevision",
		validation:"_ValidationResult"
	},
	PostRevisionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostRevision"
	},
	PostRevisionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostRevision",
		validation:"_ValidationResult"
	},
	PostRevisionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostRevision",
		validation:"_ValidationResult"
	},
	UserRecurringPaymentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserRecurringPayment",
		validation:"_ValidationResult"
	},
	UserRecurringPaymentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserRecurringPayment"
	},
	UserRecurringPaymentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserRecurringPayment",
		validation:"_ValidationResult"
	},
	UserRecurringPaymentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserRecurringPayment",
		validation:"_ValidationResult"
	},
	UserRecurringPaymentItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserRecurringPaymentItem",
		validation:"_ValidationResult"
	},
	UserRecurringPaymentItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserRecurringPaymentItem"
	},
	UserRecurringPaymentItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserRecurringPaymentItem",
		validation:"_ValidationResult"
	},
	UserRecurringPaymentItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserRecurringPaymentItem",
		validation:"_ValidationResult"
	},
	PostRevisionLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostRevisionLocale",
		validation:"_ValidationResult"
	},
	PostRevisionLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostRevisionLocale"
	},
	PostRevisionLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostRevisionLocale",
		validation:"_ValidationResult"
	},
	PostRevisionLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostRevisionLocale",
		validation:"_ValidationResult"
	},
	TranslationCatalogueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCatalogueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue"
	},
	TranslationCatalogueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCatalogueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier"
	},
	TranslationCataloguesIdentifierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationDomainCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationDomainDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain"
	},
	TranslationDomainUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationDomainUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationKeyCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationKeyDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey"
	},
	TranslationKeyUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationKeyUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationValueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationValueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue"
	},
	TranslationValueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationValueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	GenericPageAboutGroupLinksLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutGroupLinksLocale",
		validation:"_ValidationResult"
	},
	GenericPageAboutGroupLinksLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutGroupLinksLocale"
	},
	GenericPageAboutGroupLinksLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutGroupLinksLocale",
		validation:"_ValidationResult"
	},
	GenericPageAboutGroupLinksLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageAboutGroupLinksLocale",
		validation:"_ValidationResult"
	},
	MemberListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberList",
		validation:"_ValidationResult"
	},
	MemberListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberList"
	},
	MemberListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberList",
		validation:"_ValidationResult"
	},
	MemberListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberList",
		validation:"_ValidationResult"
	},
	MemberListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberListItem",
		validation:"_ValidationResult"
	},
	MemberListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberListItem"
	},
	MemberListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberListItem",
		validation:"_ValidationResult"
	},
	MemberListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberListItem",
		validation:"_ValidationResult"
	},
	FilledTaxFormCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilledTaxForm",
		validation:"_ValidationResult"
	},
	FilledTaxFormDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilledTaxForm"
	},
	FilledTaxFormUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilledTaxForm",
		validation:"_ValidationResult"
	},
	FilledTaxFormUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilledTaxForm",
		validation:"_ValidationResult"
	},
	FilledTaxFormEmailAddressCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilledTaxFormEmailAddress",
		validation:"_ValidationResult"
	},
	FilledTaxFormEmailAddressDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilledTaxFormEmailAddress"
	},
	FilledTaxFormEmailAddressUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilledTaxFormEmailAddress",
		validation:"_ValidationResult"
	},
	FilledTaxFormEmailAddressUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FilledTaxFormEmailAddress",
		validation:"_ValidationResult"
	},
	FormCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Form",
		validation:"_ValidationResult"
	},
	FormDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Form"
	},
	FormUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Form",
		validation:"_ValidationResult"
	},
	FormUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Form",
		validation:"_ValidationResult"
	},
	CsobPaymentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CsobPayment",
		validation:"_ValidationResult"
	},
	CsobPaymentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CsobPayment"
	},
	CsobPaymentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CsobPayment",
		validation:"_ValidationResult"
	},
	CsobPaymentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CsobPayment",
		validation:"_ValidationResult"
	},
	CsobPaymentStatusChangeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CsobPaymentStatusChange",
		validation:"_ValidationResult"
	},
	CsobPaymentStatusChangeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CsobPaymentStatusChange"
	},
	CsobPaymentStatusChangeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CsobPaymentStatusChange",
		validation:"_ValidationResult"
	},
	CsobPaymentStatusChangeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CsobPaymentStatusChange",
		validation:"_ValidationResult"
	},
	StripePaymentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StripePayment",
		validation:"_ValidationResult"
	},
	StripePaymentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StripePayment"
	},
	StripePaymentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StripePayment",
		validation:"_ValidationResult"
	},
	StripePaymentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StripePayment",
		validation:"_ValidationResult"
	},
	StripePaymentStatusChangeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StripePaymentStatusChange",
		validation:"_ValidationResult"
	},
	StripePaymentStatusChangeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StripePaymentStatusChange"
	},
	StripePaymentStatusChangeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StripePaymentStatusChange",
		validation:"_ValidationResult"
	},
	StripePaymentStatusChangeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StripePaymentStatusChange",
		validation:"_ValidationResult"
	},
	RegionPaymentMethodCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RegionPaymentMethod",
		validation:"_ValidationResult"
	},
	RegionPaymentMethodDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RegionPaymentMethod"
	},
	RegionPaymentMethodUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RegionPaymentMethod",
		validation:"_ValidationResult"
	},
	RegionPaymentMethodUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RegionPaymentMethod",
		validation:"_ValidationResult"
	},
	TileItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TileItem",
		validation:"_ValidationResult"
	},
	TileItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TileItem"
	},
	TileItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TileItem",
		validation:"_ValidationResult"
	},
	TileItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TileItem",
		validation:"_ValidationResult"
	},
	TileListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TileList",
		validation:"_ValidationResult"
	},
	TileListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TileList"
	},
	TileListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TileList",
		validation:"_ValidationResult"
	},
	TileListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TileList",
		validation:"_ValidationResult"
	},
	FeedPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPage",
		validation:"_ValidationResult"
	},
	FeedPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPage"
	},
	FeedPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPage",
		validation:"_ValidationResult"
	},
	FeedPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPage",
		validation:"_ValidationResult"
	},
	FeedPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageLocale",
		validation:"_ValidationResult"
	},
	FeedPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageLocale"
	},
	FeedPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageLocale",
		validation:"_ValidationResult"
	},
	FeedPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageLocale",
		validation:"_ValidationResult"
	},
	FeedPageSectionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageSection",
		validation:"_ValidationResult"
	},
	FeedPageSectionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageSection"
	},
	FeedPageSectionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageSection",
		validation:"_ValidationResult"
	},
	FeedPageSectionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageSection",
		validation:"_ValidationResult"
	},
	FeedPageTileStripeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageTileStripe",
		validation:"_ValidationResult"
	},
	FeedPageTileStripeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageTileStripe"
	},
	FeedPageTileStripeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageTileStripe",
		validation:"_ValidationResult"
	},
	FeedPageTileStripeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FeedPageTileStripe",
		validation:"_ValidationResult"
	},
	CardItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardItem",
		validation:"_ValidationResult"
	},
	CardItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardItem"
	},
	CardItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardItem",
		validation:"_ValidationResult"
	},
	CardItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardItem",
		validation:"_ValidationResult"
	},
	CardListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardList",
		validation:"_ValidationResult"
	},
	CardListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardList"
	},
	CardListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardList",
		validation:"_ValidationResult"
	},
	CardListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardList",
		validation:"_ValidationResult"
	},
	OnBehalfDonationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OnBehalfDonation",
		validation:"_ValidationResult"
	},
	OnBehalfDonationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OnBehalfDonation"
	},
	OnBehalfDonationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OnBehalfDonation",
		validation:"_ValidationResult"
	},
	OnBehalfDonationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OnBehalfDonation",
		validation:"_ValidationResult"
	},
	UserPaymentTriesCollectionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPaymentTriesCollection",
		validation:"_ValidationResult"
	},
	UserPaymentTriesCollectionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPaymentTriesCollection"
	},
	UserPaymentTriesCollectionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPaymentTriesCollection",
		validation:"_ValidationResult"
	},
	UserPaymentTriesCollectionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserPaymentTriesCollection",
		validation:"_ValidationResult"
	},
	RecurringPaymentPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecurringPaymentPage",
		validation:"_ValidationResult"
	},
	RecurringPaymentPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecurringPaymentPage"
	},
	RecurringPaymentPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecurringPaymentPage",
		validation:"_ValidationResult"
	},
	RecurringPaymentPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecurringPaymentPage",
		validation:"_ValidationResult"
	},
	RecurringPaymentPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecurringPaymentPageLocale",
		validation:"_ValidationResult"
	},
	RecurringPaymentPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecurringPaymentPageLocale"
	},
	RecurringPaymentPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecurringPaymentPageLocale",
		validation:"_ValidationResult"
	},
	RecurringPaymentPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecurringPaymentPageLocale",
		validation:"_ValidationResult"
	},
	StoryGuideCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuide",
		validation:"_ValidationResult"
	},
	StoryGuideDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuide"
	},
	StoryGuideUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuide",
		validation:"_ValidationResult"
	},
	StoryGuideUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuide",
		validation:"_ValidationResult"
	},
	StoryGuideItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuideItem",
		validation:"_ValidationResult"
	},
	StoryGuideItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuideItem"
	},
	StoryGuideItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuideItem",
		validation:"_ValidationResult"
	},
	StoryGuideItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuideItem",
		validation:"_ValidationResult"
	},
	StoryGuideListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuideList",
		validation:"_ValidationResult"
	},
	StoryGuideListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuideList"
	},
	StoryGuideListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuideList",
		validation:"_ValidationResult"
	},
	StoryGuideListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoryGuideList",
		validation:"_ValidationResult"
	},
	HeroCarouselCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeroCarousel",
		validation:"_ValidationResult"
	},
	HeroCarouselDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeroCarousel"
	},
	HeroCarouselUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeroCarousel",
		validation:"_ValidationResult"
	},
	HeroCarouselUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeroCarousel",
		validation:"_ValidationResult"
	},
	PostOrganizationListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationList",
		validation:"_ValidationResult"
	},
	PostOrganizationListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationList"
	},
	PostOrganizationListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationList",
		validation:"_ValidationResult"
	},
	PostOrganizationListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationList",
		validation:"_ValidationResult"
	},
	PostOrganizationListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationListItem",
		validation:"_ValidationResult"
	},
	PostOrganizationListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationListItem"
	},
	PostOrganizationListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationListItem",
		validation:"_ValidationResult"
	},
	PostOrganizationListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PostOrganizationListItem",
		validation:"_ValidationResult"
	},
	InfoCarouselCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarousel",
		validation:"_ValidationResult"
	},
	InfoCarouselDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarousel"
	},
	InfoCarouselUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarousel",
		validation:"_ValidationResult"
	},
	InfoCarouselUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarousel",
		validation:"_ValidationResult"
	},
	InfoCarouselItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarouselItem",
		validation:"_ValidationResult"
	},
	InfoCarouselItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarouselItem"
	},
	InfoCarouselItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarouselItem",
		validation:"_ValidationResult"
	},
	InfoCarouselItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarouselItem",
		validation:"_ValidationResult"
	},
	PersonSeenInfoCarouselCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PersonSeenInfoCarousel",
		validation:"_ValidationResult"
	},
	PersonSeenInfoCarouselDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PersonSeenInfoCarousel"
	},
	PersonSeenInfoCarouselUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PersonSeenInfoCarousel",
		validation:"_ValidationResult"
	},
	PersonSeenInfoCarouselUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PersonSeenInfoCarousel",
		validation:"_ValidationResult"
	},
	GivenGiftsPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GivenGiftsPage",
		validation:"_ValidationResult"
	},
	GivenGiftsPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GivenGiftsPage"
	},
	GivenGiftsPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GivenGiftsPage",
		validation:"_ValidationResult"
	},
	GivenGiftsPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GivenGiftsPage",
		validation:"_ValidationResult"
	},
	GivenGiftsPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GivenGiftsPageLocale",
		validation:"_ValidationResult"
	},
	GivenGiftsPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GivenGiftsPageLocale"
	},
	GivenGiftsPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GivenGiftsPageLocale",
		validation:"_ValidationResult"
	},
	GivenGiftsPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GivenGiftsPageLocale",
		validation:"_ValidationResult"
	},
	ReceivedGiftsPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReceivedGiftsPage",
		validation:"_ValidationResult"
	},
	ReceivedGiftsPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReceivedGiftsPage"
	},
	ReceivedGiftsPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReceivedGiftsPage",
		validation:"_ValidationResult"
	},
	ReceivedGiftsPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReceivedGiftsPage",
		validation:"_ValidationResult"
	},
	ReceivedGiftsPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReceivedGiftsPageLocale",
		validation:"_ValidationResult"
	},
	ReceivedGiftsPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReceivedGiftsPageLocale"
	},
	ReceivedGiftsPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReceivedGiftsPageLocale",
		validation:"_ValidationResult"
	},
	ReceivedGiftsPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReceivedGiftsPageLocale",
		validation:"_ValidationResult"
	},
	ReportNavigationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportNavigation",
		validation:"_ValidationResult"
	},
	ReportNavigationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportNavigation"
	},
	ReportNavigationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportNavigation",
		validation:"_ValidationResult"
	},
	ReportNavigationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportNavigation",
		validation:"_ValidationResult"
	},
	ReportPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportPage",
		validation:"_ValidationResult"
	},
	ReportPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportPage"
	},
	ReportPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportPage",
		validation:"_ValidationResult"
	},
	ReportPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportPage",
		validation:"_ValidationResult"
	},
	ReportPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportPageLocale",
		validation:"_ValidationResult"
	},
	ReportPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportPageLocale"
	},
	ReportPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportPageLocale",
		validation:"_ValidationResult"
	},
	ReportPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportPageLocale",
		validation:"_ValidationResult"
	},
	ReportNavigationLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportNavigationLocale",
		validation:"_ValidationResult"
	},
	ReportNavigationLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportNavigationLocale"
	},
	ReportNavigationLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportNavigationLocale",
		validation:"_ValidationResult"
	},
	ReportNavigationLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReportNavigationLocale",
		validation:"_ValidationResult"
	},
	SentPaymentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SentPayment",
		validation:"_ValidationResult"
	},
	SentPaymentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SentPayment"
	},
	SentPaymentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SentPayment",
		validation:"_ValidationResult"
	},
	SentPaymentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SentPayment",
		validation:"_ValidationResult"
	},
	NotificationTargetGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NotificationTargetGroup",
		validation:"_ValidationResult"
	},
	NotificationTargetGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NotificationTargetGroup"
	},
	NotificationTargetGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NotificationTargetGroup",
		validation:"_ValidationResult"
	},
	NotificationTargetGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NotificationTargetGroup",
		validation:"_ValidationResult"
	},
	ProcessedNotificationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProcessedNotification",
		validation:"_ValidationResult"
	},
	ProcessedNotificationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProcessedNotification"
	},
	ProcessedNotificationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProcessedNotification",
		validation:"_ValidationResult"
	},
	ProcessedNotificationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProcessedNotification",
		validation:"_ValidationResult"
	},
	ScheduledNotificationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ScheduledNotification",
		validation:"_ValidationResult"
	},
	ScheduledNotificationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ScheduledNotification"
	},
	ScheduledNotificationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ScheduledNotification",
		validation:"_ValidationResult"
	},
	ScheduledNotificationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ScheduledNotification",
		validation:"_ValidationResult"
	},
	ProcessedNotificationSourceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProcessedNotificationSource",
		validation:"_ValidationResult"
	},
	ProcessedNotificationSourceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProcessedNotificationSource"
	},
	ProcessedNotificationSourceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProcessedNotificationSource",
		validation:"_ValidationResult"
	},
	ProcessedNotificationSourceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProcessedNotificationSource",
		validation:"_ValidationResult"
	},
	DeviceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Device",
		validation:"_ValidationResult"
	},
	DeviceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Device"
	},
	DeviceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Device",
		validation:"_ValidationResult"
	},
	DeviceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Device",
		validation:"_ValidationResult"
	},
	ScheduledNotificationLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ScheduledNotificationLocale",
		validation:"_ValidationResult"
	},
	ScheduledNotificationLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ScheduledNotificationLocale"
	},
	ScheduledNotificationLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ScheduledNotificationLocale",
		validation:"_ValidationResult"
	},
	ScheduledNotificationLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ScheduledNotificationLocale",
		validation:"_ValidationResult"
	},
	InfoCarouselItemLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarouselItemLocale",
		validation:"_ValidationResult"
	},
	InfoCarouselItemLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarouselItemLocale"
	},
	InfoCarouselItemLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarouselItemLocale",
		validation:"_ValidationResult"
	},
	InfoCarouselItemLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoCarouselItemLocale",
		validation:"_ValidationResult"
	},
	SentPaymentLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SentPaymentLocale",
		validation:"_ValidationResult"
	},
	SentPaymentLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SentPaymentLocale"
	},
	SentPaymentLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SentPaymentLocale",
		validation:"_ValidationResult"
	},
	SentPaymentLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SentPaymentLocale",
		validation:"_ValidationResult"
	},
	TextImageListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextImageList",
		validation:"_ValidationResult"
	},
	TextImageListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextImageList"
	},
	TextImageListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextImageList",
		validation:"_ValidationResult"
	},
	TextImageListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextImageList",
		validation:"_ValidationResult"
	},
	TextImageListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextImageListItem",
		validation:"_ValidationResult"
	},
	TextImageListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextImageListItem"
	},
	TextImageListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextImageListItem",
		validation:"_ValidationResult"
	},
	TextImageListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextImageListItem",
		validation:"_ValidationResult"
	},
	HeroCarouselItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeroCarouselItem",
		validation:"_ValidationResult"
	},
	HeroCarouselItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeroCarouselItem"
	},
	HeroCarouselItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeroCarouselItem",
		validation:"_ValidationResult"
	},
	HeroCarouselItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeroCarouselItem",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead",
		createGeneral:"GeneralCreateResult",
		deleteGeneral:"GeneralDeleteResult",
		updateGeneral:"GeneralUpdateResult",
		upsertGeneral:"GeneralUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createGenericPage:"GenericPageCreateResult",
		deleteGenericPage:"GenericPageDeleteResult",
		updateGenericPage:"GenericPageUpdateResult",
		upsertGenericPage:"GenericPageUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createGeneralLocale:"GeneralLocaleCreateResult",
		deleteGeneralLocale:"GeneralLocaleDeleteResult",
		updateGeneralLocale:"GeneralLocaleUpdateResult",
		upsertGeneralLocale:"GeneralLocaleUpsertResult",
		createGenericPageLocale:"GenericPageLocaleCreateResult",
		deleteGenericPageLocale:"GenericPageLocaleDeleteResult",
		updateGenericPageLocale:"GenericPageLocaleUpdateResult",
		upsertGenericPageLocale:"GenericPageLocaleUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createPost:"PostCreateResult",
		deletePost:"PostDeleteResult",
		updatePost:"PostUpdateResult",
		upsertPost:"PostUpsertResult",
		createPostLocale:"PostLocaleCreateResult",
		deletePostLocale:"PostLocaleDeleteResult",
		updatePostLocale:"PostLocaleUpdateResult",
		upsertPostLocale:"PostLocaleUpsertResult",
		createPostArea:"PostAreaCreateResult",
		deletePostArea:"PostAreaDeleteResult",
		updatePostArea:"PostAreaUpdateResult",
		upsertPostArea:"PostAreaUpsertResult",
		createPostAreaLocale:"PostAreaLocaleCreateResult",
		deletePostAreaLocale:"PostAreaLocaleDeleteResult",
		updatePostAreaLocale:"PostAreaLocaleUpdateResult",
		upsertPostAreaLocale:"PostAreaLocaleUpsertResult",
		createPostOrganization:"PostOrganizationCreateResult",
		deletePostOrganization:"PostOrganizationDeleteResult",
		updatePostOrganization:"PostOrganizationUpdateResult",
		upsertPostOrganization:"PostOrganizationUpsertResult",
		createPostOrganizationLocale:"PostOrganizationLocaleCreateResult",
		deletePostOrganizationLocale:"PostOrganizationLocaleDeleteResult",
		updatePostOrganizationLocale:"PostOrganizationLocaleUpdateResult",
		upsertPostOrganizationLocale:"PostOrganizationLocaleUpsertResult",
		createDonation:"DonationCreateResult",
		deleteDonation:"DonationDeleteResult",
		updateDonation:"DonationUpdateResult",
		upsertDonation:"DonationUpsertResult",
		createDonationAmountItem:"DonationAmountItemCreateResult",
		deleteDonationAmountItem:"DonationAmountItemDeleteResult",
		updateDonationAmountItem:"DonationAmountItemUpdateResult",
		upsertDonationAmountItem:"DonationAmountItemUpsertResult",
		createDonationAmountsRegionItem:"DonationAmountsRegionItemCreateResult",
		deleteDonationAmountsRegionItem:"DonationAmountsRegionItemDeleteResult",
		updateDonationAmountsRegionItem:"DonationAmountsRegionItemUpdateResult",
		upsertDonationAmountsRegionItem:"DonationAmountsRegionItemUpsertResult",
		createDonationAmountsRegionList:"DonationAmountsRegionListCreateResult",
		deleteDonationAmountsRegionList:"DonationAmountsRegionListDeleteResult",
		updateDonationAmountsRegionList:"DonationAmountsRegionListUpdateResult",
		upsertDonationAmountsRegionList:"DonationAmountsRegionListUpsertResult",
		createRegion:"RegionCreateResult",
		deleteRegion:"RegionDeleteResult",
		updateRegion:"RegionUpdateResult",
		upsertRegion:"RegionUpsertResult",
		createLinkItem:"LinkItemCreateResult",
		deleteLinkItem:"LinkItemDeleteResult",
		updateLinkItem:"LinkItemUpdateResult",
		upsertLinkItem:"LinkItemUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLocale:"HeaderLocaleCreateResult",
		deleteHeaderLocale:"HeaderLocaleDeleteResult",
		updateHeaderLocale:"HeaderLocaleUpdateResult",
		upsertHeaderLocale:"HeaderLocaleUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterLocale:"FooterLocaleCreateResult",
		deleteFooterLocale:"FooterLocaleDeleteResult",
		updateFooterLocale:"FooterLocaleUpdateResult",
		upsertFooterLocale:"FooterLocaleUpsertResult",
		createPostList:"PostListCreateResult",
		deletePostList:"PostListDeleteResult",
		updatePostList:"PostListUpdateResult",
		upsertPostList:"PostListUpsertResult",
		createPostListItem:"PostListItemCreateResult",
		deletePostListItem:"PostListItemDeleteResult",
		updatePostListItem:"PostListItemUpdateResult",
		upsertPostListItem:"PostListItemUpsertResult",
		createAppBanner:"AppBannerCreateResult",
		deleteAppBanner:"AppBannerDeleteResult",
		updateAppBanner:"AppBannerUpdateResult",
		upsertAppBanner:"AppBannerUpsertResult",
		createGenericPageAboutSettings:"GenericPageAboutSettingsCreateResult",
		deleteGenericPageAboutSettings:"GenericPageAboutSettingsDeleteResult",
		updateGenericPageAboutSettings:"GenericPageAboutSettingsUpdateResult",
		upsertGenericPageAboutSettings:"GenericPageAboutSettingsUpsertResult",
		createGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleCreateResult",
		deleteGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleDeleteResult",
		updateGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleUpdateResult",
		upsertGenericPageAboutSettingsLocale:"GenericPageAboutSettingsLocaleUpsertResult",
		createValue:"ValueCreateResult",
		deleteValue:"ValueDeleteResult",
		updateValue:"ValueUpdateResult",
		upsertValue:"ValueUpsertResult",
		createValueItem:"ValueItemCreateResult",
		deleteValueItem:"ValueItemDeleteResult",
		updateValueItem:"ValueItemUpdateResult",
		upsertValueItem:"ValueItemUpsertResult",
		createValueList:"ValueListCreateResult",
		deleteValueList:"ValueListDeleteResult",
		updateValueList:"ValueListUpdateResult",
		upsertValueList:"ValueListUpsertResult",
		createImageLink:"ImageLinkCreateResult",
		deleteImageLink:"ImageLinkDeleteResult",
		updateImageLink:"ImageLinkUpdateResult",
		upsertImageLink:"ImageLinkUpsertResult",
		createImageLinkItem:"ImageLinkItemCreateResult",
		deleteImageLinkItem:"ImageLinkItemDeleteResult",
		updateImageLinkItem:"ImageLinkItemUpdateResult",
		upsertImageLinkItem:"ImageLinkItemUpsertResult",
		createImageLinkList:"ImageLinkListCreateResult",
		deleteImageLinkList:"ImageLinkListDeleteResult",
		updateImageLinkList:"ImageLinkListUpdateResult",
		upsertImageLinkList:"ImageLinkListUpsertResult",
		createPostAreaList:"PostAreaListCreateResult",
		deletePostAreaList:"PostAreaListDeleteResult",
		updatePostAreaList:"PostAreaListUpdateResult",
		upsertPostAreaList:"PostAreaListUpsertResult",
		createPostAreaListItem:"PostAreaListItemCreateResult",
		deletePostAreaListItem:"PostAreaListItemDeleteResult",
		updatePostAreaListItem:"PostAreaListItemUpdateResult",
		upsertPostAreaListItem:"PostAreaListItemUpsertResult",
		createAccordion:"AccordionCreateResult",
		deleteAccordion:"AccordionDeleteResult",
		updateAccordion:"AccordionUpdateResult",
		upsertAccordion:"AccordionUpsertResult",
		createAccordionItem:"AccordionItemCreateResult",
		deleteAccordionItem:"AccordionItemDeleteResult",
		updateAccordionItem:"AccordionItemUpdateResult",
		upsertAccordionItem:"AccordionItemUpsertResult",
		createUser:"UserCreateResult",
		deleteUser:"UserDeleteResult",
		updateUser:"UserUpdateResult",
		upsertUser:"UserUpsertResult",
		createUserPayment:"UserPaymentCreateResult",
		deleteUserPayment:"UserPaymentDeleteResult",
		updateUserPayment:"UserPaymentUpdateResult",
		upsertUserPayment:"UserPaymentUpsertResult",
		createCurrency:"CurrencyCreateResult",
		deleteCurrency:"CurrencyDeleteResult",
		updateCurrency:"CurrencyUpdateResult",
		upsertCurrency:"CurrencyUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createMediumItem:"MediumItemCreateResult",
		deleteMediumItem:"MediumItemDeleteResult",
		updateMediumItem:"MediumItemUpdateResult",
		upsertMediumItem:"MediumItemUpsertResult",
		createMediumList:"MediumListCreateResult",
		deleteMediumList:"MediumListDeleteResult",
		updateMediumList:"MediumListUpdateResult",
		upsertMediumList:"MediumListUpsertResult",
		createUserPaymentOrderId:"UserPaymentOrderIdCreateResult",
		deleteUserPaymentOrderId:"UserPaymentOrderIdDeleteResult",
		updateUserPaymentOrderId:"UserPaymentOrderIdUpdateResult",
		upsertUserPaymentOrderId:"UserPaymentOrderIdUpsertResult",
		createPostRevision:"PostRevisionCreateResult",
		deletePostRevision:"PostRevisionDeleteResult",
		updatePostRevision:"PostRevisionUpdateResult",
		upsertPostRevision:"PostRevisionUpsertResult",
		createUserRecurringPayment:"UserRecurringPaymentCreateResult",
		deleteUserRecurringPayment:"UserRecurringPaymentDeleteResult",
		updateUserRecurringPayment:"UserRecurringPaymentUpdateResult",
		upsertUserRecurringPayment:"UserRecurringPaymentUpsertResult",
		createUserRecurringPaymentItem:"UserRecurringPaymentItemCreateResult",
		deleteUserRecurringPaymentItem:"UserRecurringPaymentItemDeleteResult",
		updateUserRecurringPaymentItem:"UserRecurringPaymentItemUpdateResult",
		upsertUserRecurringPaymentItem:"UserRecurringPaymentItemUpsertResult",
		createPostRevisionLocale:"PostRevisionLocaleCreateResult",
		deletePostRevisionLocale:"PostRevisionLocaleDeleteResult",
		updatePostRevisionLocale:"PostRevisionLocaleUpdateResult",
		upsertPostRevisionLocale:"PostRevisionLocaleUpsertResult",
		createTranslationCatalogue:"TranslationCatalogueCreateResult",
		deleteTranslationCatalogue:"TranslationCatalogueDeleteResult",
		updateTranslationCatalogue:"TranslationCatalogueUpdateResult",
		upsertTranslationCatalogue:"TranslationCatalogueUpsertResult",
		createTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierCreateResult",
		deleteTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierDeleteResult",
		updateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpdateResult",
		upsertTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpsertResult",
		createTranslationDomain:"TranslationDomainCreateResult",
		deleteTranslationDomain:"TranslationDomainDeleteResult",
		updateTranslationDomain:"TranslationDomainUpdateResult",
		upsertTranslationDomain:"TranslationDomainUpsertResult",
		createTranslationKey:"TranslationKeyCreateResult",
		deleteTranslationKey:"TranslationKeyDeleteResult",
		updateTranslationKey:"TranslationKeyUpdateResult",
		upsertTranslationKey:"TranslationKeyUpsertResult",
		createTranslationValue:"TranslationValueCreateResult",
		deleteTranslationValue:"TranslationValueDeleteResult",
		updateTranslationValue:"TranslationValueUpdateResult",
		upsertTranslationValue:"TranslationValueUpsertResult",
		createGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleCreateResult",
		deleteGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleDeleteResult",
		updateGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleUpdateResult",
		upsertGenericPageAboutGroupLinksLocale:"GenericPageAboutGroupLinksLocaleUpsertResult",
		createMemberList:"MemberListCreateResult",
		deleteMemberList:"MemberListDeleteResult",
		updateMemberList:"MemberListUpdateResult",
		upsertMemberList:"MemberListUpsertResult",
		createMemberListItem:"MemberListItemCreateResult",
		deleteMemberListItem:"MemberListItemDeleteResult",
		updateMemberListItem:"MemberListItemUpdateResult",
		upsertMemberListItem:"MemberListItemUpsertResult",
		createFilledTaxForm:"FilledTaxFormCreateResult",
		deleteFilledTaxForm:"FilledTaxFormDeleteResult",
		updateFilledTaxForm:"FilledTaxFormUpdateResult",
		upsertFilledTaxForm:"FilledTaxFormUpsertResult",
		createFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressCreateResult",
		deleteFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressDeleteResult",
		updateFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressUpdateResult",
		upsertFilledTaxFormEmailAddress:"FilledTaxFormEmailAddressUpsertResult",
		createForm:"FormCreateResult",
		deleteForm:"FormDeleteResult",
		updateForm:"FormUpdateResult",
		upsertForm:"FormUpsertResult",
		createCsobPayment:"CsobPaymentCreateResult",
		deleteCsobPayment:"CsobPaymentDeleteResult",
		updateCsobPayment:"CsobPaymentUpdateResult",
		upsertCsobPayment:"CsobPaymentUpsertResult",
		createCsobPaymentStatusChange:"CsobPaymentStatusChangeCreateResult",
		deleteCsobPaymentStatusChange:"CsobPaymentStatusChangeDeleteResult",
		updateCsobPaymentStatusChange:"CsobPaymentStatusChangeUpdateResult",
		upsertCsobPaymentStatusChange:"CsobPaymentStatusChangeUpsertResult",
		createStripePayment:"StripePaymentCreateResult",
		deleteStripePayment:"StripePaymentDeleteResult",
		updateStripePayment:"StripePaymentUpdateResult",
		upsertStripePayment:"StripePaymentUpsertResult",
		createStripePaymentStatusChange:"StripePaymentStatusChangeCreateResult",
		deleteStripePaymentStatusChange:"StripePaymentStatusChangeDeleteResult",
		updateStripePaymentStatusChange:"StripePaymentStatusChangeUpdateResult",
		upsertStripePaymentStatusChange:"StripePaymentStatusChangeUpsertResult",
		createRegionPaymentMethod:"RegionPaymentMethodCreateResult",
		deleteRegionPaymentMethod:"RegionPaymentMethodDeleteResult",
		updateRegionPaymentMethod:"RegionPaymentMethodUpdateResult",
		upsertRegionPaymentMethod:"RegionPaymentMethodUpsertResult",
		createTileItem:"TileItemCreateResult",
		deleteTileItem:"TileItemDeleteResult",
		updateTileItem:"TileItemUpdateResult",
		upsertTileItem:"TileItemUpsertResult",
		createTileList:"TileListCreateResult",
		deleteTileList:"TileListDeleteResult",
		updateTileList:"TileListUpdateResult",
		upsertTileList:"TileListUpsertResult",
		createFeedPage:"FeedPageCreateResult",
		deleteFeedPage:"FeedPageDeleteResult",
		updateFeedPage:"FeedPageUpdateResult",
		upsertFeedPage:"FeedPageUpsertResult",
		createFeedPageLocale:"FeedPageLocaleCreateResult",
		deleteFeedPageLocale:"FeedPageLocaleDeleteResult",
		updateFeedPageLocale:"FeedPageLocaleUpdateResult",
		upsertFeedPageLocale:"FeedPageLocaleUpsertResult",
		createFeedPageSection:"FeedPageSectionCreateResult",
		deleteFeedPageSection:"FeedPageSectionDeleteResult",
		updateFeedPageSection:"FeedPageSectionUpdateResult",
		upsertFeedPageSection:"FeedPageSectionUpsertResult",
		createFeedPageTileStripe:"FeedPageTileStripeCreateResult",
		deleteFeedPageTileStripe:"FeedPageTileStripeDeleteResult",
		updateFeedPageTileStripe:"FeedPageTileStripeUpdateResult",
		upsertFeedPageTileStripe:"FeedPageTileStripeUpsertResult",
		createCardItem:"CardItemCreateResult",
		deleteCardItem:"CardItemDeleteResult",
		updateCardItem:"CardItemUpdateResult",
		upsertCardItem:"CardItemUpsertResult",
		createCardList:"CardListCreateResult",
		deleteCardList:"CardListDeleteResult",
		updateCardList:"CardListUpdateResult",
		upsertCardList:"CardListUpsertResult",
		createOnBehalfDonation:"OnBehalfDonationCreateResult",
		deleteOnBehalfDonation:"OnBehalfDonationDeleteResult",
		updateOnBehalfDonation:"OnBehalfDonationUpdateResult",
		upsertOnBehalfDonation:"OnBehalfDonationUpsertResult",
		createUserPaymentTriesCollection:"UserPaymentTriesCollectionCreateResult",
		deleteUserPaymentTriesCollection:"UserPaymentTriesCollectionDeleteResult",
		updateUserPaymentTriesCollection:"UserPaymentTriesCollectionUpdateResult",
		upsertUserPaymentTriesCollection:"UserPaymentTriesCollectionUpsertResult",
		createRecurringPaymentPage:"RecurringPaymentPageCreateResult",
		deleteRecurringPaymentPage:"RecurringPaymentPageDeleteResult",
		updateRecurringPaymentPage:"RecurringPaymentPageUpdateResult",
		upsertRecurringPaymentPage:"RecurringPaymentPageUpsertResult",
		createRecurringPaymentPageLocale:"RecurringPaymentPageLocaleCreateResult",
		deleteRecurringPaymentPageLocale:"RecurringPaymentPageLocaleDeleteResult",
		updateRecurringPaymentPageLocale:"RecurringPaymentPageLocaleUpdateResult",
		upsertRecurringPaymentPageLocale:"RecurringPaymentPageLocaleUpsertResult",
		createStoryGuide:"StoryGuideCreateResult",
		deleteStoryGuide:"StoryGuideDeleteResult",
		updateStoryGuide:"StoryGuideUpdateResult",
		upsertStoryGuide:"StoryGuideUpsertResult",
		createStoryGuideItem:"StoryGuideItemCreateResult",
		deleteStoryGuideItem:"StoryGuideItemDeleteResult",
		updateStoryGuideItem:"StoryGuideItemUpdateResult",
		upsertStoryGuideItem:"StoryGuideItemUpsertResult",
		createStoryGuideList:"StoryGuideListCreateResult",
		deleteStoryGuideList:"StoryGuideListDeleteResult",
		updateStoryGuideList:"StoryGuideListUpdateResult",
		upsertStoryGuideList:"StoryGuideListUpsertResult",
		createHeroCarousel:"HeroCarouselCreateResult",
		deleteHeroCarousel:"HeroCarouselDeleteResult",
		updateHeroCarousel:"HeroCarouselUpdateResult",
		upsertHeroCarousel:"HeroCarouselUpsertResult",
		createPostOrganizationList:"PostOrganizationListCreateResult",
		deletePostOrganizationList:"PostOrganizationListDeleteResult",
		updatePostOrganizationList:"PostOrganizationListUpdateResult",
		upsertPostOrganizationList:"PostOrganizationListUpsertResult",
		createPostOrganizationListItem:"PostOrganizationListItemCreateResult",
		deletePostOrganizationListItem:"PostOrganizationListItemDeleteResult",
		updatePostOrganizationListItem:"PostOrganizationListItemUpdateResult",
		upsertPostOrganizationListItem:"PostOrganizationListItemUpsertResult",
		createInfoCarousel:"InfoCarouselCreateResult",
		deleteInfoCarousel:"InfoCarouselDeleteResult",
		updateInfoCarousel:"InfoCarouselUpdateResult",
		upsertInfoCarousel:"InfoCarouselUpsertResult",
		createInfoCarouselItem:"InfoCarouselItemCreateResult",
		deleteInfoCarouselItem:"InfoCarouselItemDeleteResult",
		updateInfoCarouselItem:"InfoCarouselItemUpdateResult",
		upsertInfoCarouselItem:"InfoCarouselItemUpsertResult",
		createPersonSeenInfoCarousel:"PersonSeenInfoCarouselCreateResult",
		deletePersonSeenInfoCarousel:"PersonSeenInfoCarouselDeleteResult",
		updatePersonSeenInfoCarousel:"PersonSeenInfoCarouselUpdateResult",
		upsertPersonSeenInfoCarousel:"PersonSeenInfoCarouselUpsertResult",
		createGivenGiftsPage:"GivenGiftsPageCreateResult",
		deleteGivenGiftsPage:"GivenGiftsPageDeleteResult",
		updateGivenGiftsPage:"GivenGiftsPageUpdateResult",
		upsertGivenGiftsPage:"GivenGiftsPageUpsertResult",
		createGivenGiftsPageLocale:"GivenGiftsPageLocaleCreateResult",
		deleteGivenGiftsPageLocale:"GivenGiftsPageLocaleDeleteResult",
		updateGivenGiftsPageLocale:"GivenGiftsPageLocaleUpdateResult",
		upsertGivenGiftsPageLocale:"GivenGiftsPageLocaleUpsertResult",
		createReceivedGiftsPage:"ReceivedGiftsPageCreateResult",
		deleteReceivedGiftsPage:"ReceivedGiftsPageDeleteResult",
		updateReceivedGiftsPage:"ReceivedGiftsPageUpdateResult",
		upsertReceivedGiftsPage:"ReceivedGiftsPageUpsertResult",
		createReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleCreateResult",
		deleteReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleDeleteResult",
		updateReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleUpdateResult",
		upsertReceivedGiftsPageLocale:"ReceivedGiftsPageLocaleUpsertResult",
		createReportNavigation:"ReportNavigationCreateResult",
		deleteReportNavigation:"ReportNavigationDeleteResult",
		updateReportNavigation:"ReportNavigationUpdateResult",
		upsertReportNavigation:"ReportNavigationUpsertResult",
		createReportPage:"ReportPageCreateResult",
		deleteReportPage:"ReportPageDeleteResult",
		updateReportPage:"ReportPageUpdateResult",
		upsertReportPage:"ReportPageUpsertResult",
		createReportPageLocale:"ReportPageLocaleCreateResult",
		deleteReportPageLocale:"ReportPageLocaleDeleteResult",
		updateReportPageLocale:"ReportPageLocaleUpdateResult",
		upsertReportPageLocale:"ReportPageLocaleUpsertResult",
		createReportNavigationLocale:"ReportNavigationLocaleCreateResult",
		deleteReportNavigationLocale:"ReportNavigationLocaleDeleteResult",
		updateReportNavigationLocale:"ReportNavigationLocaleUpdateResult",
		upsertReportNavigationLocale:"ReportNavigationLocaleUpsertResult",
		createSentPayment:"SentPaymentCreateResult",
		deleteSentPayment:"SentPaymentDeleteResult",
		updateSentPayment:"SentPaymentUpdateResult",
		upsertSentPayment:"SentPaymentUpsertResult",
		createNotificationTargetGroup:"NotificationTargetGroupCreateResult",
		deleteNotificationTargetGroup:"NotificationTargetGroupDeleteResult",
		updateNotificationTargetGroup:"NotificationTargetGroupUpdateResult",
		upsertNotificationTargetGroup:"NotificationTargetGroupUpsertResult",
		createProcessedNotification:"ProcessedNotificationCreateResult",
		deleteProcessedNotification:"ProcessedNotificationDeleteResult",
		updateProcessedNotification:"ProcessedNotificationUpdateResult",
		upsertProcessedNotification:"ProcessedNotificationUpsertResult",
		createScheduledNotification:"ScheduledNotificationCreateResult",
		deleteScheduledNotification:"ScheduledNotificationDeleteResult",
		updateScheduledNotification:"ScheduledNotificationUpdateResult",
		upsertScheduledNotification:"ScheduledNotificationUpsertResult",
		createProcessedNotificationSource:"ProcessedNotificationSourceCreateResult",
		deleteProcessedNotificationSource:"ProcessedNotificationSourceDeleteResult",
		updateProcessedNotificationSource:"ProcessedNotificationSourceUpdateResult",
		upsertProcessedNotificationSource:"ProcessedNotificationSourceUpsertResult",
		createDevice:"DeviceCreateResult",
		deleteDevice:"DeviceDeleteResult",
		updateDevice:"DeviceUpdateResult",
		upsertDevice:"DeviceUpsertResult",
		createScheduledNotificationLocale:"ScheduledNotificationLocaleCreateResult",
		deleteScheduledNotificationLocale:"ScheduledNotificationLocaleDeleteResult",
		updateScheduledNotificationLocale:"ScheduledNotificationLocaleUpdateResult",
		upsertScheduledNotificationLocale:"ScheduledNotificationLocaleUpsertResult",
		createInfoCarouselItemLocale:"InfoCarouselItemLocaleCreateResult",
		deleteInfoCarouselItemLocale:"InfoCarouselItemLocaleDeleteResult",
		updateInfoCarouselItemLocale:"InfoCarouselItemLocaleUpdateResult",
		upsertInfoCarouselItemLocale:"InfoCarouselItemLocaleUpsertResult",
		createSentPaymentLocale:"SentPaymentLocaleCreateResult",
		deleteSentPaymentLocale:"SentPaymentLocaleDeleteResult",
		updateSentPaymentLocale:"SentPaymentLocaleUpdateResult",
		upsertSentPaymentLocale:"SentPaymentLocaleUpsertResult",
		createTextImageList:"TextImageListCreateResult",
		deleteTextImageList:"TextImageListDeleteResult",
		updateTextImageList:"TextImageListUpdateResult",
		upsertTextImageList:"TextImageListUpsertResult",
		createTextImageListItem:"TextImageListItemCreateResult",
		deleteTextImageListItem:"TextImageListItemDeleteResult",
		updateTextImageListItem:"TextImageListItemUpdateResult",
		upsertTextImageListItem:"TextImageListItemUpsertResult",
		createHeroCarouselItem:"HeroCarouselItemCreateResult",
		deleteHeroCarouselItem:"HeroCarouselItemDeleteResult",
		updateHeroCarouselItem:"HeroCarouselItemUpdateResult",
		upsertHeroCarouselItem:"HeroCarouselItemUpsertResult",
		query:"Query"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}


export const HOST="Specify host"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json();
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

export const Thunder =
  (fn: FetchFunction) =>
  <O extends keyof typeof Ops, SCLR extends ScalarDefinition, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<SCLR>,
  ) =>
  <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions & { variables?: Record<string, unknown> }) =>
    fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: graphqlOptions?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (graphqlOptions?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: graphqlOptions.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, SCLR>>;

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  (fn: SubscriptionFunction) =>
  <O extends keyof typeof Ops, SCLR extends ScalarDefinition, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<SCLR>,
  ) =>
  <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions & { variables?: ExtractVariables<Z> }) => {
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: graphqlOptions?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], SCLR>;
    if (returnedFunction?.on && graphqlOptions?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, SCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, SCLR>) => {
          if (graphqlOptions?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: graphqlOptions.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z | ValueTypes[R],
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    return Object.fromEntries(Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])]));
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any, source?: any) => any;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : Record<string, unknown>
        : never;
    }[keyof DST] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <T>(t: T | V) => T;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['ID']: unknown;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariables<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = GraphQLTypes["_Field"] | GraphQLTypes["MutationResult"]
export type ScalarCoders = {
	Json?: ScalarResolver;
	UUID?: ScalarResolver;
	DateTime?: ScalarResolver;
	Date?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["_Argument"] | GraphQLTypes["_PathFragment"]

export type ValueTypes = {
    ["_Column"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	enumName?:boolean | `@${string}`,
	defaultValue?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_Field"]:AliasType<{
		name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: boolean | `@${string}`
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_RuleMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Validator"]: AliasType<{
	operation?:boolean | `@${string}`,
	arguments?:ValueTypes["_Argument"],
		__typename?: boolean | `@${string}`
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: boolean | `@${string}`
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_PathArgument"]: AliasType<{
	path?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_LiteralArgument"]: AliasType<{
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Json custom scalar type */
["Json"]:unknown;
	["_Relation"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	side?:boolean | `@${string}`,
	targetEntity?:boolean | `@${string}`,
	ownedBy?:boolean | `@${string}`,
	inversedBy?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	onDelete?:boolean | `@${string}`,
	orphanRemoval?:boolean | `@${string}`,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_RelationSide"]:_RelationSide;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_OrderBy"]: AliasType<{
	path?:boolean | `@${string}`,
	direction?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_OrderByDirection"]:_OrderByDirection;
	["Query"]: AliasType<{
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
getGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["General"]],
listGeneral?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["General"]],
paginateGeneral?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralConnection"]],
validateCreateGeneral?: [{	data: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GeneralUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
listImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Image"]],
paginateImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
listGenericPage?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
paginateGenericPage?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
listLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkableUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
listSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
paginateSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SeoUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
listContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Content"]],
paginateContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentReferenceLinkableItem?: [{	by: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
listContentReferenceLinkableItem?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
paginateContentReferenceLinkableItem?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItemConnection"]],
getGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
listGeneralLocale?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
paginateGeneralLocale?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleConnection"]],
validateCreateGeneralLocale?: [{	data: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
listGenericPageLocale?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
paginateGenericPageLocale?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleConnection"]],
validateCreateGenericPageLocale?: [{	data: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
listLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
paginateLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
listVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Video"]],
paginateVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	data: ValueTypes["VideoUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
listLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Link"]],
paginateLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
listPost?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Post"]],
paginatePost?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostConnection"]],
validateCreatePost?: [{	data: ValueTypes["PostCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
listPostLocale?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
paginatePostLocale?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostLocaleConnection"]],
validateCreatePostLocale?: [{	data: ValueTypes["PostLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
listPostArea?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
paginatePostArea?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaConnection"]],
validateCreatePostArea?: [{	data: ValueTypes["PostAreaCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
listPostAreaLocale?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
paginatePostAreaLocale?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocaleConnection"]],
validateCreatePostAreaLocale?: [{	data: ValueTypes["PostAreaLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostAreaLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
listPostOrganization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
paginatePostOrganization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationConnection"]],
validateCreatePostOrganization?: [{	data: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostOrganizationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
listPostOrganizationLocale?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
paginatePostOrganizationLocale?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocaleConnection"]],
validateCreatePostOrganizationLocale?: [{	data: ValueTypes["PostOrganizationLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostOrganizationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["Donation"]],
listDonation?: [{	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Donation"]],
paginateDonation?: [{	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationConnection"]],
validateCreateDonation?: [{	data: ValueTypes["DonationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DonationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItem"]],
listDonationAmountItem?: [{	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItem"]],
paginateDonationAmountItem?: [{	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItemConnection"]],
validateCreateDonationAmountItem?: [{	data: ValueTypes["DonationAmountItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DonationAmountItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
listDonationAmountsRegionItem?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
paginateDonationAmountsRegionItem?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItemConnection"]],
validateCreateDonationAmountsRegionItem?: [{	data: ValueTypes["DonationAmountsRegionItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DonationAmountsRegionItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionList"]],
listDonationAmountsRegionList?: [{	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionList"]],
paginateDonationAmountsRegionList?: [{	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionListConnection"]],
validateCreateDonationAmountsRegionList?: [{	data: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DonationAmountsRegionListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Region"]],
listRegion?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Region"]],
paginateRegion?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RegionConnection"]],
validateCreateRegion?: [{	data: ValueTypes["RegionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RegionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkItem"]],
listLinkItem?: [{	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["LinkItem"]],
paginateLinkItem?: [{	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data: ValueTypes["LinkItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkList"]],
listLinkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data: ValueTypes["LinkListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["Header"]],
listHeader?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Header"]],
paginateHeader?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeaderUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
listFooter?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
paginateFooter?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
listFooterLocale?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostList"]],
listPostList?: [{	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostList"]],
paginatePostList?: [{	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostListConnection"]],
validateCreatePostList?: [{	data: ValueTypes["PostListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostListItem"]],
listPostListItem?: [{	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostListItem"]],
paginatePostListItem?: [{	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostListItemConnection"]],
validateCreatePostListItem?: [{	data: ValueTypes["PostListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["AppBanner"]],
listAppBanner?: [{	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AppBannerOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["AppBanner"]],
paginateAppBanner?: [{	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AppBannerOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["AppBannerConnection"]],
validateCreateAppBanner?: [{	data: ValueTypes["AppBannerCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	data: ValueTypes["AppBannerUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettings"]],
listGenericPageAboutSettings?: [{	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettings"]],
paginateGenericPageAboutSettings?: [{	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsConnection"]],
validateCreateGenericPageAboutSettings?: [{	data: ValueTypes["GenericPageAboutSettingsCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageAboutSettingsUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
listGenericPageAboutSettingsLocale?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
paginateGenericPageAboutSettingsLocale?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleConnection"]],
validateCreateGenericPageAboutSettingsLocale?: [{	data: ValueTypes["GenericPageAboutSettingsLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageAboutSettingsLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["Value"]],
listValue?: [{	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Value"]],
paginateValue?: [{	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ValueConnection"]],
validateCreateValue?: [{	data: ValueTypes["ValueCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ValueUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueItem"]],
listValueItem?: [{	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ValueItem"]],
paginateValueItem?: [{	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ValueItemConnection"]],
validateCreateValueItem?: [{	data: ValueTypes["ValueItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ValueItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueList"]],
listValueList?: [{	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ValueList"]],
paginateValueList?: [{	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ValueListConnection"]],
validateCreateValueList?: [{	data: ValueTypes["ValueListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ValueListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLink"]],
listImageLink?: [{	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLink"]],
paginateImageLink?: [{	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkConnection"]],
validateCreateImageLink?: [{	data: ValueTypes["ImageLinkCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageLinkUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItem"]],
listImageLinkItem?: [{	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItem"]],
paginateImageLinkItem?: [{	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItemConnection"]],
validateCreateImageLinkItem?: [{	data: ValueTypes["ImageLinkItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageLinkItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkList"]],
listImageLinkList?: [{	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkList"]],
paginateImageLinkList?: [{	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkListConnection"]],
validateCreateImageLinkList?: [{	data: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageLinkListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaList"]],
listPostAreaList?: [{	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaList"]],
paginatePostAreaList?: [{	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaListConnection"]],
validateCreatePostAreaList?: [{	data: ValueTypes["PostAreaListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostAreaListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItem"]],
listPostAreaListItem?: [{	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItem"]],
paginatePostAreaListItem?: [{	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItemConnection"]],
validateCreatePostAreaListItem?: [{	data: ValueTypes["PostAreaListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostAreaListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Accordion"]],
listAccordion?: [{	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Accordion"]],
paginateAccordion?: [{	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["AccordionConnection"]],
validateCreateAccordion?: [{	data: ValueTypes["AccordionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["AccordionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["AccordionItem"]],
listAccordionItem?: [{	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["AccordionItem"]],
paginateAccordionItem?: [{	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["AccordionItemConnection"]],
validateCreateAccordionItem?: [{	data: ValueTypes["AccordionItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["AccordionItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
listUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["User"]],
paginateUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserConnection"]],
validateCreateUser?: [{	data: ValueTypes["UserCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
listUserPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paginateUserPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentConnection"]],
validateCreateUserPayment?: [{	data: ValueTypes["UserPaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserPaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
listCurrency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CurrencyOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
paginateCurrency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CurrencyOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CurrencyConnection"]],
validateCreateCurrency?: [{	data: ValueTypes["CurrencyCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
listMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
paginateMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
listMediumItem?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
paginateMediumItem?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
listMediumList?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
paginateMediumList?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderId"]],
listUserPaymentOrderId?: [{	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderIdOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderId"]],
paginateUserPaymentOrderId?: [{	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderIdOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderIdConnection"]],
validateCreateUserPaymentOrderId?: [{	data: ValueTypes["UserPaymentOrderIdCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserPaymentOrderIdUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
listPostRevision?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
paginatePostRevision?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionConnection"]],
validateCreatePostRevision?: [{	data: ValueTypes["PostRevisionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostRevisionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
listUserRecurringPayment?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
paginateUserRecurringPayment?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentConnection"]],
validateCreateUserRecurringPayment?: [{	data: ValueTypes["UserRecurringPaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserRecurringPaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
listUserRecurringPaymentItem?: [{	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
paginateUserRecurringPaymentItem?: [{	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemConnection"]],
validateCreateUserRecurringPaymentItem?: [{	data: ValueTypes["UserRecurringPaymentItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserRecurringPaymentItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
listPostRevisionLocale?: [{	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
paginatePostRevisionLocale?: [{	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocaleConnection"]],
validateCreatePostRevisionLocale?: [{	data: ValueTypes["PostRevisionLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostRevisionLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data: ValueTypes["TranslationCatalogueCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationCatalogueUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationCataloguesIdentifierUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationDomainOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationDomainOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data: ValueTypes["TranslationDomainCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationDomainUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationKey"]],
listTranslationKey?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data: ValueTypes["TranslationKeyCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationKeyUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationValue"]],
listTranslationValue?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data: ValueTypes["TranslationValueCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationValueUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocale"]],
listGenericPageAboutGroupLinksLocale?: [{	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocale"]],
paginateGenericPageAboutGroupLinksLocale?: [{	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleConnection"]],
validateCreateGenericPageAboutGroupLinksLocale?: [{	data: ValueTypes["GenericPageAboutGroupLinksLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberList"]],
listMemberList?: [{	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MemberList"]],
paginateMemberList?: [{	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MemberListConnection"]],
validateCreateMemberList?: [{	data: ValueTypes["MemberListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MemberListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberListItem"]],
listMemberListItem?: [{	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MemberListItem"]],
paginateMemberListItem?: [{	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MemberListItemConnection"]],
validateCreateMemberListItem?: [{	data: ValueTypes["MemberListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MemberListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxForm"]],
listFilledTaxForm?: [{	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FilledTaxFormOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FilledTaxForm"]],
paginateFilledTaxForm?: [{	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FilledTaxFormOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormConnection"]],
validateCreateFilledTaxForm?: [{	data: ValueTypes["FilledTaxFormCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FilledTaxFormUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddress"]],
listFilledTaxFormEmailAddress?: [{	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FilledTaxFormEmailAddressOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddress"]],
paginateFilledTaxFormEmailAddress?: [{	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FilledTaxFormEmailAddressOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressConnection"]],
validateCreateFilledTaxFormEmailAddress?: [{	data: ValueTypes["FilledTaxFormEmailAddressCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FilledTaxFormEmailAddressUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>},ValueTypes["Form"]],
listForm?: [{	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FormOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Form"]],
paginateForm?: [{	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FormOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FormConnection"]],
validateCreateForm?: [{	data: ValueTypes["FormCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FormUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPayment"]],
listCsobPayment?: [{	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPayment"]],
paginateCsobPayment?: [{	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentConnection"]],
validateCreateCsobPayment?: [{	data: ValueTypes["CsobPaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CsobPaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChange"]],
listCsobPaymentStatusChange?: [{	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChange"]],
paginateCsobPaymentStatusChange?: [{	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeConnection"]],
validateCreateCsobPaymentStatusChange?: [{	data: ValueTypes["CsobPaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CsobPaymentStatusChangeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePayment"]],
listStripePayment?: [{	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StripePayment"]],
paginateStripePayment?: [{	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentConnection"]],
validateCreateStripePayment?: [{	data: ValueTypes["StripePaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StripePaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChange"]],
listStripePaymentStatusChange?: [{	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChange"]],
paginateStripePaymentStatusChange?: [{	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChangeConnection"]],
validateCreateStripePaymentStatusChange?: [{	data: ValueTypes["StripePaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StripePaymentStatusChangeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethod"]],
listRegionPaymentMethod?: [{	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionPaymentMethodOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethod"]],
paginateRegionPaymentMethod?: [{	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionPaymentMethodOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethodConnection"]],
validateCreateRegionPaymentMethod?: [{	data: ValueTypes["RegionPaymentMethodCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RegionPaymentMethodUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaMetaData?: [{	by: ValueTypes["PostAreaMetaDataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaMetaData"]],
listPostAreaMetaData?: [{	filter?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaMetaData"]],
paginatePostAreaMetaData?: [{	filter?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaMetaDataConnection"]],
getPostMetaData?: [{	by: ValueTypes["PostMetaDataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostMetaData"]],
listPostMetaData?: [{	filter?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostMetaData"]],
paginatePostMetaData?: [{	filter?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostMetaDataConnection"]],
getPostOrganizationMetaData?: [{	by: ValueTypes["PostOrganizationMetaDataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationMetaData"]],
listPostOrganizationMetaData?: [{	filter?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationMetaData"]],
paginatePostOrganizationMetaData?: [{	filter?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationMetaDataConnection"]],
getTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileItem"]],
listTileItem?: [{	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TileItem"]],
paginateTileItem?: [{	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TileItemConnection"]],
validateCreateTileItem?: [{	data: ValueTypes["TileItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TileItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileList"]],
listTileList?: [{	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TileList"]],
paginateTileList?: [{	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TileListConnection"]],
validateCreateTileList?: [{	data: ValueTypes["TileListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TileListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPage"]],
listFeedPage?: [{	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPage"]],
paginateFeedPage?: [{	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageConnection"]],
validateCreateFeedPage?: [{	data: ValueTypes["FeedPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FeedPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
listFeedPageLocale?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
paginateFeedPageLocale?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocaleConnection"]],
validateCreateFeedPageLocale?: [{	data: ValueTypes["FeedPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FeedPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageSection"]],
listFeedPageSection?: [{	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageSectionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageSection"]],
paginateFeedPageSection?: [{	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageSectionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageSectionConnection"]],
validateCreateFeedPageSection?: [{	data: ValueTypes["FeedPageSectionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FeedPageSectionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripe"]],
listFeedPageTileStripe?: [{	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageTileStripeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripe"]],
paginateFeedPageTileStripe?: [{	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageTileStripeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripeConnection"]],
validateCreateFeedPageTileStripe?: [{	data: ValueTypes["FeedPageTileStripeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FeedPageTileStripeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardItem"]],
listCardItem?: [{	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CardItem"]],
paginateCardItem?: [{	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CardItemConnection"]],
validateCreateCardItem?: [{	data: ValueTypes["CardItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CardItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardList"]],
listCardList?: [{	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CardList"]],
paginateCardList?: [{	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CardListConnection"]],
validateCreateCardList?: [{	data: ValueTypes["CardListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CardListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
listOnBehalfDonation?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
paginateOnBehalfDonation?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationConnection"]],
validateCreateOnBehalfDonation?: [{	data: ValueTypes["OnBehalfDonationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["OnBehalfDonationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollection"]],
listUserPaymentTriesCollection?: [{	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollection"]],
paginateUserPaymentTriesCollection?: [{	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionConnection"]],
validateCreateUserPaymentTriesCollection?: [{	data: ValueTypes["UserPaymentTriesCollectionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserPaymentTriesCollectionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPage"]],
listRecurringPaymentPage?: [{	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPage"]],
paginateRecurringPaymentPage?: [{	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageConnection"]],
validateCreateRecurringPaymentPage?: [{	data: ValueTypes["RecurringPaymentPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecurringPaymentPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
listRecurringPaymentPageLocale?: [{	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
paginateRecurringPaymentPageLocale?: [{	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleConnection"]],
validateCreateRecurringPaymentPageLocale?: [{	data: ValueTypes["RecurringPaymentPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecurringPaymentPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuide"]],
listStoryGuide?: [{	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuide"]],
paginateStoryGuide?: [{	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideConnection"]],
validateCreateStoryGuide?: [{	data: ValueTypes["StoryGuideCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StoryGuideUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItem"]],
listStoryGuideItem?: [{	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItem"]],
paginateStoryGuideItem?: [{	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItemConnection"]],
validateCreateStoryGuideItem?: [{	data: ValueTypes["StoryGuideItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StoryGuideItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideList"]],
listStoryGuideList?: [{	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideList"]],
paginateStoryGuideList?: [{	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideListConnection"]],
validateCreateStoryGuideList?: [{	data: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StoryGuideListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStripePaymentMetadata?: [{	by: ValueTypes["StripePaymentMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentMetadata"]],
listStripePaymentMetadata?: [{	filter?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentMetadata"]],
paginateStripePaymentMetadata?: [{	filter?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentMetadataConnection"]],
getOnBehalfDonationMetadata?: [{	by: ValueTypes["OnBehalfDonationMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationMetadata"]],
listOnBehalfDonationMetadata?: [{	filter?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationMetadata"]],
paginateOnBehalfDonationMetadata?: [{	filter?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationMetadataConnection"]],
getUserPaymentTriesCollectionMetadata?: [{	by: ValueTypes["UserPaymentTriesCollectionMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadata"]],
listUserPaymentTriesCollectionMetadata?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadata"]],
paginateUserPaymentTriesCollectionMetadata?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataConnection"]],
getUserPaymentTriesCollectionMetadataLocale?: [{	by: ValueTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocale"]],
listUserPaymentTriesCollectionMetadataLocale?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocale"]],
paginateUserPaymentTriesCollectionMetadataLocale?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocaleConnection"]],
getCsobPaymentMetadata?: [{	by: ValueTypes["CsobPaymentMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentMetadata"]],
listCsobPaymentMetadata?: [{	filter?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentMetadata"]],
paginateCsobPaymentMetadata?: [{	filter?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentMetadataConnection"]],
getHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarousel"]],
listHeroCarousel?: [{	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarousel"]],
paginateHeroCarousel?: [{	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselConnection"]],
validateCreateHeroCarousel?: [{	data: ValueTypes["HeroCarouselCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeroCarouselUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationList"]],
listPostOrganizationList?: [{	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationList"]],
paginatePostOrganizationList?: [{	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListConnection"]],
validateCreatePostOrganizationList?: [{	data: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItem"]],
listPostOrganizationListItem?: [{	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItem"]],
paginatePostOrganizationListItem?: [{	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItemConnection"]],
validateCreatePostOrganizationListItem?: [{	data: ValueTypes["PostOrganizationListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostOrganizationListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarousel"]],
listInfoCarousel?: [{	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarousel"]],
paginateInfoCarousel?: [{	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselConnection"]],
validateCreateInfoCarousel?: [{	data: ValueTypes["InfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoCarouselUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItem"]],
listInfoCarouselItem?: [{	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItem"]],
paginateInfoCarouselItem?: [{	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemConnection"]],
validateCreateInfoCarouselItem?: [{	data: ValueTypes["InfoCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoCarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarousel"]],
listPersonSeenInfoCarousel?: [{	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarousel"]],
paginatePersonSeenInfoCarousel?: [{	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselConnection"]],
validateCreatePersonSeenInfoCarousel?: [{	data: ValueTypes["PersonSeenInfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PersonSeenInfoCarouselUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPage"]],
listGivenGiftsPage?: [{	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPage"]],
paginateGivenGiftsPage?: [{	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageConnection"]],
validateCreateGivenGiftsPage?: [{	data: ValueTypes["GivenGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GivenGiftsPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
listGivenGiftsPageLocale?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
paginateGivenGiftsPageLocale?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleConnection"]],
validateCreateGivenGiftsPageLocale?: [{	data: ValueTypes["GivenGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GivenGiftsPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPage"]],
listReceivedGiftsPage?: [{	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPage"]],
paginateReceivedGiftsPage?: [{	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageConnection"]],
validateCreateReceivedGiftsPage?: [{	data: ValueTypes["ReceivedGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReceivedGiftsPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
listReceivedGiftsPageLocale?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
paginateReceivedGiftsPageLocale?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleConnection"]],
validateCreateReceivedGiftsPageLocale?: [{	data: ValueTypes["ReceivedGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReceivedGiftsPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigation"]],
listReportNavigation?: [{	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigation"]],
paginateReportNavigation?: [{	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationConnection"]],
validateCreateReportNavigation?: [{	data: ValueTypes["ReportNavigationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReportNavigationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPage"]],
listReportPage?: [{	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPage"]],
paginateReportPage?: [{	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageConnection"]],
validateCreateReportPage?: [{	data: ValueTypes["ReportPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReportPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
listReportPageLocale?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
paginateReportPageLocale?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocaleConnection"]],
validateCreateReportPageLocale?: [{	data: ValueTypes["ReportPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReportPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
listReportNavigationLocale?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
paginateReportNavigationLocale?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocaleConnection"]],
validateCreateReportNavigationLocale?: [{	data: ValueTypes["ReportNavigationLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReportNavigationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
listSentPayment?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
paginateSentPayment?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentConnection"]],
validateCreateSentPayment?: [{	data: ValueTypes["SentPaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SentPaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaSentPaymentCurrencySum?: [{	by: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySum"]],
listPostAreaSentPaymentCurrencySum?: [{	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySum"]],
paginatePostAreaSentPaymentCurrencySum?: [{	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySumConnection"]],
getPostAreaSentPaymentSum?: [{	by: ValueTypes["PostAreaSentPaymentSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentSum"]],
listPostAreaSentPaymentSum?: [{	filter?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentSumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentSum"]],
paginatePostAreaSentPaymentSum?: [{	filter?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentSumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentSumConnection"]],
getNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroup"]],
listNotificationTargetGroup?: [{	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["NotificationTargetGroupOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroup"]],
paginateNotificationTargetGroup?: [{	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["NotificationTargetGroupOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroupConnection"]],
validateCreateNotificationTargetGroup?: [{	data: ValueTypes["NotificationTargetGroupCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	data: ValueTypes["NotificationTargetGroupUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotification"]],
listProcessedNotification?: [{	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotification"]],
paginateProcessedNotification?: [{	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationConnection"]],
validateCreateProcessedNotification?: [{	data: ValueTypes["ProcessedNotificationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ProcessedNotificationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotification"]],
listScheduledNotification?: [{	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotification"]],
paginateScheduledNotification?: [{	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationConnection"]],
validateCreateScheduledNotification?: [{	data: ValueTypes["ScheduledNotificationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ScheduledNotificationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
listProcessedNotificationSource?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
paginateProcessedNotificationSource?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSourceConnection"]],
validateCreateProcessedNotificationSource?: [{	data: ValueTypes["ProcessedNotificationSourceCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ProcessedNotificationSourceUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>},ValueTypes["Device"]],
listDevice?: [{	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DeviceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Device"]],
paginateDevice?: [{	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DeviceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DeviceConnection"]],
validateCreateDevice?: [{	data: ValueTypes["DeviceCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DeviceUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocale"]],
listScheduledNotificationLocale?: [{	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocale"]],
paginateScheduledNotificationLocale?: [{	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleConnection"]],
validateCreateScheduledNotificationLocale?: [{	data: ValueTypes["ScheduledNotificationLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ScheduledNotificationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocale"]],
listInfoCarouselItemLocale?: [{	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocale"]],
paginateInfoCarouselItemLocale?: [{	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleConnection"]],
validateCreateInfoCarouselItemLocale?: [{	data: ValueTypes["InfoCarouselItemLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoCarouselItemLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocale"]],
listSentPaymentLocale?: [{	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocale"]],
paginateSentPaymentLocale?: [{	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocaleConnection"]],
validateCreateSentPaymentLocale?: [{	data: ValueTypes["SentPaymentLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SentPaymentLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserPaymentMetadata?: [{	by: ValueTypes["UserPaymentMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentMetadata"]],
listUserPaymentMetadata?: [{	filter?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentMetadata"]],
paginateUserPaymentMetadata?: [{	filter?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentMetadataConnection"]],
getPostAreaCurrencySum?: [{	by: ValueTypes["PostAreaCurrencySumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySum"]],
listPostAreaCurrencySum?: [{	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySum"]],
paginatePostAreaCurrencySum?: [{	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySumConnection"]],
getPostAreaSum?: [{	by: ValueTypes["PostAreaSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaSum"]],
listPostAreaSum?: [{	filter?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSum"]],
paginatePostAreaSum?: [{	filter?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSumConnection"]],
getPostOrganizationCurrencySum?: [{	by: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySum"]],
listPostOrganizationCurrencySum?: [{	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySum"]],
paginatePostOrganizationCurrencySum?: [{	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySumConnection"]],
getPostOrganizationSum?: [{	by: ValueTypes["PostOrganizationSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationSum"]],
listPostOrganizationSum?: [{	filter?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationSumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationSum"]],
paginatePostOrganizationSum?: [{	filter?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationSumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationSumConnection"]],
getStats?: [{	by: ValueTypes["StatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["Stats"]],
listStats?: [{	filter?: ValueTypes["StatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Stats"]],
paginateStats?: [{	filter?: ValueTypes["StatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StatsConnection"]],
getUserRecurringPaymentItemMetadata?: [{	by: ValueTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemMetadata"]],
listUserRecurringPaymentItemMetadata?: [{	filter?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemMetadata"]],
paginateUserRecurringPaymentItemMetadata?: [{	filter?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemMetadataConnection"]],
getUpcomingUserRecurringPaymentMetadata?: [{	by: ValueTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UpcomingUserRecurringPaymentMetadata"]],
listUpcomingUserRecurringPaymentMetadata?: [{	filter?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UpcomingUserRecurringPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UpcomingUserRecurringPaymentMetadata"]],
paginateUpcomingUserRecurringPaymentMetadata?: [{	filter?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UpcomingUserRecurringPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UpcomingUserRecurringPaymentMetadataConnection"]],
getUserAreaStats?: [{	by: ValueTypes["UserAreaStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserAreaStats"]],
listUserAreaStats?: [{	filter?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserAreaStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserAreaStats"]],
paginateUserAreaStats?: [{	filter?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserAreaStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserAreaStatsConnection"]],
getUserCurrencyStats?: [{	by: ValueTypes["UserCurrencyStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserCurrencyStats"]],
listUserCurrencyStats?: [{	filter?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserCurrencyStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserCurrencyStats"]],
paginateUserCurrencyStats?: [{	filter?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserCurrencyStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserCurrencyStatsConnection"]],
getUserOrganizationStats?: [{	by: ValueTypes["UserOrganizationStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserOrganizationStats"]],
listUserOrganizationStats?: [{	filter?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrganizationStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserOrganizationStats"]],
paginateUserOrganizationStats?: [{	filter?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrganizationStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserOrganizationStatsConnection"]],
getUserPostStats?: [{	by: ValueTypes["UserPostStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPostStats"]],
listUserPostStats?: [{	filter?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPostStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPostStats"]],
paginateUserPostStats?: [{	filter?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPostStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPostStatsConnection"]],
getUserStats?: [{	by: ValueTypes["UserStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserStats"]],
listUserStats?: [{	filter?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserStats"]],
paginateUserStats?: [{	filter?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserStatsConnection"]],
getTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageList"]],
listTextImageList?: [{	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageList"]],
paginateTextImageList?: [{	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageListConnection"]],
validateCreateTextImageList?: [{	data: ValueTypes["TextImageListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TextImageListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageListItem"]],
listTextImageListItem?: [{	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageListItem"]],
paginateTextImageListItem?: [{	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageListItemConnection"]],
validateCreateTextImageListItem?: [{	data: ValueTypes["TextImageListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TextImageListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostCurrencySum?: [{	by: ValueTypes["PostCurrencySumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySum"]],
listPostCurrencySum?: [{	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySum"]],
paginatePostCurrencySum?: [{	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySumConnection"]],
getPostSum?: [{	by: ValueTypes["PostSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostSum"]],
listPostSum?: [{	filter?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostSumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostSum"]],
paginatePostSum?: [{	filter?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostSumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostSumConnection"]],
getPostFundraisingProgress?: [{	by: ValueTypes["PostFundraisingProgressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostFundraisingProgress"]],
listPostFundraisingProgress?: [{	filter?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostFundraisingProgressOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostFundraisingProgress"]],
paginatePostFundraisingProgress?: [{	filter?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostFundraisingProgressOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostFundraisingProgressConnection"]],
getHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItem"]],
listHeroCarouselItem?: [{	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItem"]],
paginateHeroCarouselItem?: [{	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItemConnection"]],
validateCreateHeroCarouselItem?: [{	data: ValueTypes["HeroCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeroCarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
		__typename?: boolean | `@${string}`
}>;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: boolean | `@${string}`
}>;
	["_Enum"]: AliasType<{
	name?:boolean | `@${string}`,
	values?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Entity"]: AliasType<{
	name?:boolean | `@${string}`,
	customPrimaryAllowed?:boolean | `@${string}`,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: boolean | `@${string}`
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["General"]: AliasType<{
	_meta?:ValueTypes["GeneralMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
allAreasIcon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
allOrganizationsIcon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
organizationList?: [{	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationList"]],
localesByLocale?: [{	by: ValueTypes["GeneralLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
localesBySeo?: [{	by: ValueTypes["GeneralLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
localesByAppStoreLink?: [{	by: ValueTypes["GeneralLocalesByAppStoreLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
localesByGooglePlayLink?: [{	by: ValueTypes["GeneralLocalesByGooglePlayLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
paginateLocales?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GeneralMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	allAreasIcon?:ValueTypes["FieldMeta"],
	allOrganizationsIcon?:ValueTypes["FieldMeta"],
	organizationList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FieldMeta"]: AliasType<{
	readable?:boolean | `@${string}`,
	updatable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UUID"]:unknown;
	["One"]:One;
	["GeneralLocale"]: AliasType<{
	_meta?:ValueTypes["GeneralLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["General"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
appStoreLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
googlePlayLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
	allAreasDescription?:boolean | `@${string}`,
	allOrganizationsDescription?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	appStoreLink?:ValueTypes["FieldMeta"],
	googlePlayLink?:ValueTypes["FieldMeta"],
	allAreasDescription?:ValueTypes["FieldMeta"],
	allOrganizationsDescription?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,
	allAreasIcon?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	allOrganizationsIcon?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GeneralWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GeneralWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>
};
	["UUIDCondition"]: {
	and?: Array<ValueTypes["UUIDCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UUIDCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["UUID"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["UUID"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["OneCondition"]: {
	and?: Array<ValueTypes["OneCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["OneCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["One"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["One"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["One"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	allAreasDescription?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	allOrganizationsDescription?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GeneralLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GeneralLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>
};
	["LocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	code?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	label?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	generals?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,
	genericPages?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,
	postAreas?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,
	postOrganizations?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,
	headers?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,
	footers?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,
	postRevisions?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	feedPages?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,
	recurringPaymentPages?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,
	givenGiftsPages?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,
	receivedGiftsPages?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,
	reportPages?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,
	reportNavigations?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,
	scheduledNotifications?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,
	sentPayments?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["LocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>
};
	["StringCondition"]: {
	and?: Array<ValueTypes["StringCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StringCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: string | undefined | null | Variable<any, string>,
	notEq?: string | undefined | null | Variable<any, string>,
	in?: Array<string> | undefined | null | Variable<any, string>,
	notIn?: Array<string> | undefined | null | Variable<any, string>,
	lt?: string | undefined | null | Variable<any, string>,
	lte?: string | undefined | null | Variable<any, string>,
	gt?: string | undefined | null | Variable<any, string>,
	gte?: string | undefined | null | Variable<any, string>,
	contains?: string | undefined | null | Variable<any, string>,
	startsWith?: string | undefined | null | Variable<any, string>,
	endsWith?: string | undefined | null | Variable<any, string>,
	containsCI?: string | undefined | null | Variable<any, string>,
	startsWithCI?: string | undefined | null | Variable<any, string>,
	endsWithCI?: string | undefined | null | Variable<any, string>
};
	["IntCondition"]: {
	and?: Array<ValueTypes["IntCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["IntCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: number | undefined | null | Variable<any, string>,
	notEq?: number | undefined | null | Variable<any, string>,
	in?: Array<number> | undefined | null | Variable<any, string>,
	notIn?: Array<number> | undefined | null | Variable<any, string>,
	lt?: number | undefined | null | Variable<any, string>,
	lte?: number | undefined | null | Variable<any, string>,
	gt?: number | undefined | null | Variable<any, string>,
	gte?: number | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GenericPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GenericPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["GenericPageTypeCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	reportNavigation?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GenericPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GenericPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageTypeCondition"]: {
	and?: Array<ValueTypes["GenericPageTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GenericPageTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GenericPageTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["GenericPageType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["GenericPageType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>
};
	["GenericPageType"]:GenericPageType;
	["ReportNavigationLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	pages?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ReportNavigationLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ReportNavigationLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>
};
	["ReportNavigationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ReportNavigationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ReportNavigationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>
};
	["ContentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	blocks?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	json?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	references?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContentBlockWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentBlockWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ContentReferenceTypeCondition"] | undefined | null | Variable<any, string>,
	primaryText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	linkables?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,
	secondaryText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	contentAlignment?: ValueTypes["ContentAlignmentCondition"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,
	isAppsVisible?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,
	asideMediaContentLayout?: ValueTypes["AsideMediaContentLayoutCondition"] | undefined | null | Variable<any, string>,
	isAsideMediaContentMobileLayout?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	form?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,
	isTitleBigger?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,
	isCentered?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContentReferenceWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentReferenceWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceTypeCondition"]: {
	and?: Array<ValueTypes["ContentReferenceTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentReferenceTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentReferenceTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["ContentReferenceType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["ContentReferenceType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>
};
	["ContentReferenceType"]:ContentReferenceType;
	["ImageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	width?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	height?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	alt?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	fileName?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	focalPointX?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	focalPointY?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>
};
	["FloatCondition"]: {
	and?: Array<ValueTypes["FloatCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FloatCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: number | undefined | null | Variable<any, string>,
	notEq?: number | undefined | null | Variable<any, string>,
	in?: Array<number> | undefined | null | Variable<any, string>,
	notIn?: Array<number> | undefined | null | Variable<any, string>,
	lt?: number | undefined | null | Variable<any, string>,
	lte?: number | undefined | null | Variable<any, string>,
	gt?: number | undefined | null | Variable<any, string>,
	gte?: number | undefined | null | Variable<any, string>
};
	["ContentReferenceLinkableItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	reference?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>
};
	["LinkableWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["LinkableWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LinkableWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>
};
	["PostLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	paymentName?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>
};
	["SeoWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	ogTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	ogDescription?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	noIndex?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	noFollow?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SeoWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SeoWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>
};
	["BooleanCondition"]: {
	and?: Array<ValueTypes["BooleanCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["BooleanCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: boolean | undefined | null | Variable<any, string>,
	notEq?: boolean | undefined | null | Variable<any, string>,
	in?: Array<boolean> | undefined | null | Variable<any, string>,
	notIn?: Array<boolean> | undefined | null | Variable<any, string>,
	lt?: boolean | undefined | null | Variable<any, string>,
	lte?: boolean | undefined | null | Variable<any, string>,
	gt?: boolean | undefined | null | Variable<any, string>,
	gte?: boolean | undefined | null | Variable<any, string>
};
	["PostWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,
	revisions?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,
	isPinnedInArea?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostStateCondition"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,
	fundraiseIsActive?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["DateCondition"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	isHidden?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	color?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	sentPayments?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,
	organizationCurrencySums?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostOrganizationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostOrganizationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	translatedByAI?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostOrganizationLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostOrganizationLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>
};
	["LinkWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["LinkEnumCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	externalLink?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	internalLink?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	isTargetBlank?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["LinkWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LinkWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>
};
	["LinkEnumCondition"]: {
	and?: Array<ValueTypes["LinkEnumCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LinkEnumCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LinkEnumCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["LinkEnum"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["LinkEnum"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["LinkEnum"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["LinkEnum"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["LinkEnum"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["LinkEnum"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["LinkEnum"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["LinkEnum"] | undefined | null | Variable<any, string>
};
	["LinkEnum"]:LinkEnum;
	["PostAreaWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,
	color?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	sentPayments?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,
	shortDescription?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	translatedByAI?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>
};
	["AppBannerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	imageSmall?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	imageBig?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["AppBannerWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["AppBannerWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	regions?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,
	donation?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["DonationAmountsRegionListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["DonationAmountsRegionListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,
	minimumAmount?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>
};
	["DonationAmountItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	amount?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	regionItem?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["DonationAmountItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["DonationAmountItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>
};
	["RegionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	code?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	label?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	enabledPaymentMethods?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,
	donationItems?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,
	timezone?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["RegionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["RegionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>
};
	["CurrencyWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["CurrencyIdentifierCondition"] | undefined | null | Variable<any, string>,
	label?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	sign?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	signAlignment?: ValueTypes["CurrencySignAlignmentCondition"] | undefined | null | Variable<any, string>,
	defaultDonationAmount?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,
	organizationCurrencySums?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,
	postCurrencySums?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CurrencyWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CurrencyWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>
};
	["CurrencyIdentifierCondition"]: {
	and?: Array<ValueTypes["CurrencyIdentifierCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CurrencyIdentifierCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CurrencyIdentifierCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["CurrencyIdentifier"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["CurrencyIdentifier"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>
};
	["CurrencyIdentifier"]:CurrencyIdentifier;
	["CurrencySignAlignmentCondition"]: {
	and?: Array<ValueTypes["CurrencySignAlignmentCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CurrencySignAlignmentCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CurrencySignAlignmentCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["CurrencySignAlignment"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["CurrencySignAlignment"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["CurrencySignAlignment"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["CurrencySignAlignment"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["CurrencySignAlignment"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["CurrencySignAlignment"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["CurrencySignAlignment"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["CurrencySignAlignment"] | undefined | null | Variable<any, string>
};
	["CurrencySignAlignment"]:CurrencySignAlignment;
	["PostAreaSentPaymentCurrencySumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	currencyIdentifier?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaCurrencySumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	currencyIdentifier?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaCurrencySumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaCurrencySumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationCurrencySumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	currencyIdentifier?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>
};
	["PostCurrencySumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	currencyIdentifier?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostCurrencySumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostCurrencySumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>
};
	["RegionPaymentMethodWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	allowRecurringPayments?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["PaymentMethodsCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["RegionPaymentMethodWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["RegionPaymentMethodWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>
};
	["PaymentMethodsCondition"]: {
	and?: Array<ValueTypes["PaymentMethodsCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PaymentMethodsCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PaymentMethodsCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["PaymentMethods"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["PaymentMethods"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>
};
	["PaymentMethods"]:PaymentMethods;
	["DonationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	regionList?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["DonationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["DonationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaMetaDataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	nameWithFallback?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	formattedSpecificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	fullFormattedSpecificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaMetaDataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaMetaDataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>
};
	["SentPaymentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	cents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SentPaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SentPaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>
};
	["DateTimeCondition"]: {
	and?: Array<ValueTypes["DateTimeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["DateTimeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["DateTime"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["DateTime"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>
};
	["DateTime"]:unknown;
	["SentPaymentLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	organizationText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SentPaymentLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SentPaymentLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaSentPaymentSumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	czkPercentage?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaSumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	czkPercentage?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaSumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaSumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationMetaDataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	nameWithFallback?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	formattedSpecificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	fullFormattedSpecificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationSumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	czkPercentage?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostOrganizationSumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostOrganizationSumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	createdById?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	publishedById?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostTypeCondition"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	tileImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	tileVideo?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,
	heroImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,
	isOrganizationVisible?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	sendPublishNotifications?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isArchived?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostRevisionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostRevisionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>
};
	["PostTypeCondition"]: {
	and?: Array<ValueTypes["PostTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["PostType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["PostType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["PostType"] | undefined | null | Variable<any, string>
};
	["PostType"]:PostType;
	["VideoWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	width?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	height?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	poster?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	shapeType?: ValueTypes["VideoShapeTypeCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["VideoWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["VideoWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>
};
	["VideoShapeTypeCondition"]: {
	and?: Array<ValueTypes["VideoShapeTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["VideoShapeTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["VideoShapeTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["VideoShapeType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["VideoShapeType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["VideoShapeType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["VideoShapeType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["VideoShapeType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["VideoShapeType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["VideoShapeType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["VideoShapeType"] | undefined | null | Variable<any, string>
};
	["VideoShapeType"]:VideoShapeType;
	["PostRevisionLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	publishNotificationText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	translatedByAI?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostRevisionLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostRevisionLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>
};
	["PostStateCondition"]: {
	and?: Array<ValueTypes["PostStateCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostStateCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostStateCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["PostState"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["PostState"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["PostState"] | undefined | null | Variable<any, string>
};
	["PostState"]:PostState;
	["PostMetaDataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	titleWithFallback?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	formattedSpecificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	fullFormattedSpecificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	latestRevision?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostMetaDataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostMetaDataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>
};
	["HeroCarouselWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateCondition"] | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HeroCarouselWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HeroCarouselWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>
};
	["DateCondition"]: {
	and?: Array<ValueTypes["DateCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["DateCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["DateCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["Date"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["Date"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["Date"] | undefined | null | Variable<any, string>
};
	["Date"]:unknown;
	["HeroCarouselItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HeroCarouselItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HeroCarouselItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>
};
	["ReportPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	postTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	giftTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ReportPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ReportPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["ReportPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ReportPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ReportPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>
};
	["PostSumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	czkPercentage?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostSumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostSumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>
};
	["PostFundraisingProgressWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	progress?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostFundraisingProgressWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostFundraisingProgressWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	giftTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	giftText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	note?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GivenGiftsPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GivenGiftsPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	giftTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	giftText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	note?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ReceivedGiftsPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ReceivedGiftsPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>
};
	["ContentAlignmentCondition"]: {
	and?: Array<ValueTypes["ContentAlignmentCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentAlignmentCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentAlignmentCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["ContentAlignment"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["ContentAlignment"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>
};
	["ContentAlignment"]:ContentAlignment;
	["ValueListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ValueListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ValueListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>
};
	["ValueItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ValueItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ValueItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>
};
	["ValueWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ValueWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ValueWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>
};
	["ImageLinkListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageLinkListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageLinkListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>
};
	["ImageLinkItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageLinkItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageLinkItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>
};
	["ImageLinkWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageLinkWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageLinkWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostAreaListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostAreaListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>
};
	["AccordionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["AccordionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["AccordionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>
};
	["AccordionItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["AccordionItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["AccordionItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>
};
	["MediumListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["MediumListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>
};
	["MediumItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["MediumItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>
};
	["MediumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["MediumTypeCondition"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["MediumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>
};
	["MediumTypeCondition"]: {
	and?: Array<ValueTypes["MediumTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["MediumType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["MediumType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>
};
	["MediumType"]:MediumType;
	["MemberListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["MemberListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MemberListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>
};
	["MemberListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	position?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["MemberListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MemberListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>
};
	["AsideMediaContentLayoutCondition"]: {
	and?: Array<ValueTypes["AsideMediaContentLayoutCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["AsideMediaContentLayoutCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["AsideMediaContentLayoutCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["AsideMediaContentLayout"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["AsideMediaContentLayout"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>
};
	["AsideMediaContentLayout"]:AsideMediaContentLayout;
	["FormWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["FormTypeCondition"] | undefined | null | Variable<any, string>,
	tax?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FormWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FormWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>
};
	["FormTypeCondition"]: {
	and?: Array<ValueTypes["FormTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FormTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FormTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["FormType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["FormType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["FormType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["FormType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["FormType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["FormType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["FormType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["FormType"] | undefined | null | Variable<any, string>
};
	["FormType"]:FormType;
	["FilledTaxFormWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	userId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	vatId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	address1?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	address2?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	city?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	postalCode?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	state?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	country?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,
	dateFrom?: ValueTypes["DateCondition"] | undefined | null | Variable<any, string>,
	dateTo?: ValueTypes["DateCondition"] | undefined | null | Variable<any, string>,
	year?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	isPdfGenerated?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	pdfObjectKey?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FilledTaxFormWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FilledTaxFormWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostOrganizationListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostOrganizationListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostOrganizationListItemTypeCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostOrganizationListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostOrganizationListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemTypeCondition"]: {
	and?: Array<ValueTypes["PostOrganizationListItemTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostOrganizationListItemTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostOrganizationListItemTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["PostOrganizationListItemType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["PostOrganizationListItemType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemType"]:PostOrganizationListItemType;
	["TextImageListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TextImageListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TextImageListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>
};
	["TextImageListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TextImageListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TextImageListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>
};
	["HeaderLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HeaderLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HeaderLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>
};
	["HeaderWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HeaderWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HeaderWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>
};
	["LinkListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["LinkListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LinkListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>
};
	["LinkItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["LinkItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LinkItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	copyright?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,
	contactEmail?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FooterLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FooterLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>
};
	["FooterWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FooterWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FooterWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	linkGroups?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	settings?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,
	sectionList?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FeedPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FeedPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FeedPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FeedPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>
};
	["TileListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["TileListSizeCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,
	areaType?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TileListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TileListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>
};
	["TileListSizeCondition"]: {
	and?: Array<ValueTypes["TileListSizeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TileListSizeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TileListSizeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["TileListSize"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["TileListSize"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>
};
	["TileListSize"]:TileListSize;
	["TileItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["TileItemTypeCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TileItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TileItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>
};
	["TileItemTypeCondition"]: {
	and?: Array<ValueTypes["TileItemTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TileItemTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TileItemTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["TileItemType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["TileItemType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>
};
	["TileItemType"]:TileItemType;
	["FeedPageSectionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	feedPageLocale?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,
	tileStripeList?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FeedPageSectionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FeedPageSectionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	section?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,
	tileList?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FeedPageTileStripeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FeedPageTileStripeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>
};
	["CardListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CardListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CardListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>
};
	["CardItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CardItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CardItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>
};
	["StoryGuideListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["StoryGuideListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StoryGuideListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>
};
	["StoryGuideItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,
	guide?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["StoryGuideItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StoryGuideItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>
};
	["StoryGuideWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	mediaType?: ValueTypes["MediaTypeCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	secondaryImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["StoryGuideWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StoryGuideWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>
};
	["MediaTypeCondition"]: {
	and?: Array<ValueTypes["MediaTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediaTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediaTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["MediaType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["MediaType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["MediaType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["MediaType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["MediaType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["MediaType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["MediaType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["MediaType"] | undefined | null | Variable<any, string>
};
	["MediaType"]:MediaType;
	["RecurringPaymentPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["RecurringPaymentPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["RecurringPaymentPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>
};
	["PostListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>
};
	["PostListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PostListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PostListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	localMsFromMidnight?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	scheduledDate?: ValueTypes["DateCondition"] | undefined | null | Variable<any, string>,
	internalTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	target?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	processedNotifications?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ScheduledNotificationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ScheduledNotificationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["NotificationTargetTypeCondition"] | undefined | null | Variable<any, string>,
	regions?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["NotificationTargetGroupWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["NotificationTargetGroupWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>
};
	["NotificationTargetTypeCondition"]: {
	and?: Array<ValueTypes["NotificationTargetTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["NotificationTargetTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["NotificationTargetTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["NotificationTargetType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["NotificationTargetType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["NotificationTargetType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["NotificationTargetType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["NotificationTargetType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["NotificationTargetType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["NotificationTargetType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["NotificationTargetType"] | undefined | null | Variable<any, string>
};
	["NotificationTargetType"]:NotificationTargetType;
	["ProcessedNotificationSourceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ProcessedNotificationSourceTypeCondition"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,
	donationReminderUser?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	scheduledNotification?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceTypeCondition"]: {
	and?: Array<ValueTypes["ProcessedNotificationSourceTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ProcessedNotificationSourceTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ProcessedNotificationSourceTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["ProcessedNotificationSourceType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["ProcessedNotificationSourceType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceType"]:ProcessedNotificationSourceType;
	["ProcessedNotificationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	topic?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	sentAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	errorMessage?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	errorCode?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	isSuccess?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	source?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	body?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ProcessedNotificationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ProcessedNotificationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>
};
	["UserWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	payments?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	variableSymbol?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	recurringPayments?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,
	stripeId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	isDeactivated?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	onBehalfDonations?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,
	publicProfileSecret?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	signedUp?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	devices?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,
	processedNotifications?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,
	areaStats?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>,
	organizationStats?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>,
	postStats?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>,
	currencyStats?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>,
	stats?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	cents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethodCondition"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	isReusable?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	isSuccessful?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isFinished?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserPaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserPaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentOrderIdWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	seq?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserPaymentOrderIdWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserPaymentOrderIdWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>
};
	["CsobPaymentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	payId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	statusChanges?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	originalPayId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CsobPaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CsobPaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>
};
	["CsobPaymentStatusChangeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	dttm?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	resultCode?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	message?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	authCode?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	statusDetail?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	actions?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>
};
	["CsobPaymentMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	isSuccessful?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isFinished?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	resolvedOriginalPayId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CsobPaymentMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CsobPaymentMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>
};
	["StripePaymentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	statusChanges?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["StripePaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StripePaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,
	timestamp?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	eventId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	paymentIntentStatus?: ValueTypes["StripePaymentStatusChangePaymentIntentStatusCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangePaymentIntentStatusCondition"]: {
	and?: Array<ValueTypes["StripePaymentStatusChangePaymentIntentStatusCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StripePaymentStatusChangePaymentIntentStatusCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StripePaymentStatusChangePaymentIntentStatusCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["StripePaymentStatusChangePaymentIntentStatus"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["StripePaymentStatusChangePaymentIntentStatus"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangePaymentIntentStatus"]:StripePaymentStatusChangePaymentIntentStatus;
	["StripePaymentMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	isSuccessful?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isFinished?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["StripePaymentMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StripePaymentMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	recurrenceCounter?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	taskId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	payments?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,
	isFailed?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	failedEmailSentAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	activeSince?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	cancelledAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	cents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	interval?: ValueTypes["UserRecurringPaymentIntervalCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserRecurringPaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserRecurringPaymentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentIntervalCondition"]: {
	and?: Array<ValueTypes["UserRecurringPaymentIntervalCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserRecurringPaymentIntervalCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserRecurringPaymentIntervalCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["UserRecurringPaymentInterval"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["UserRecurringPaymentInterval"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentInterval"]:UserRecurringPaymentInterval;
	["UpcomingUserRecurringPaymentMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	recurrenceCounter?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	isBehindPayments?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	nextPaymentDate?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	shouldBeProcessed?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	firstPayment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	firstSuccessfulPayment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	drivingPayment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	isSuccessfullyPaid?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	shouldBeProcessed?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	firstPayment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	lastPayment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	firstSuccessfulPayment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	drivingPayment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentMethodCondition"]: {
	and?: Array<ValueTypes["UserPaymentMethodCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserPaymentMethodCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserPaymentMethodCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["UserPaymentMethod"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["UserPaymentMethod"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>
};
	["UserPaymentMethod"]:UserPaymentMethod;
	["OnBehalfDonationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	secretCode?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	payments?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	onBehalfOf?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["OnBehalfDonationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["OnBehalfDonationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	onBehalfOfDonation?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	cents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	orderUrl?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,
	recurring?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>,
	metadataLocales?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["PaymentMediumCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionMetadataLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	parent?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>
};
	["PaymentMediumCondition"]: {
	and?: Array<ValueTypes["PaymentMediumCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PaymentMediumCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PaymentMediumCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["PaymentMedium"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["PaymentMedium"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>
};
	["PaymentMedium"]:PaymentMedium;
	["UserPaymentMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	organizationUnfiltered?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	countToUser?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	paymentType?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	statusLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	isSuccessful?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isFinished?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	needsCacheUpdate?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isSuccessfulNotCached?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isFinishedNotCached?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	userPayment?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserPaymentMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserPaymentMetadataWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>
};
	["DeviceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	fcmToken?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	ipAddress?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	userAgent?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["DeviceWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["DeviceWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>
};
	["UserAreaStatsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserAreaStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserAreaStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>
};
	["UserOrganizationStatsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserOrganizationStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserOrganizationStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>
};
	["UserPostStatsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserPostStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserPostStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>
};
	["UserCurrencyStatsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,
	totalAmountPaymentsOnce?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	totalAmountPaymentsRegular?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserCurrencyStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserCurrencyStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>
};
	["UserStatsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	totalPaymentsSuccessful?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	totalPaymentsUnsuccessful?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["UserStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UserStatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>
};
	["Locale"]: AliasType<{
	_meta?:ValueTypes["LocaleMeta"],
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
generals?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
genericPages?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
posts?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
postAreas?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
postOrganizations?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
headers?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
footers?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
genericPageAboutSettings?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
postRevisions?: [{	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
flagImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
feedPages?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
recurringPaymentPages?: [{	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
givenGiftsPages?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
receivedGiftsPages?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
reportPages?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
reportNavigations?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
scheduledNotifications?: [{	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocale"]],
sentPayments?: [{	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocale"]],
generalsByRoot?: [{	by: ValueTypes["LocaleGeneralsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
generalsBySeo?: [{	by: ValueTypes["LocaleGeneralsBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
generalsByAppStoreLink?: [{	by: ValueTypes["LocaleGeneralsByAppStoreLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
generalsByGooglePlayLink?: [{	by: ValueTypes["LocaleGeneralsByGooglePlayLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
genericPagesByRoot?: [{	by: ValueTypes["LocaleGenericPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
genericPagesByContent?: [{	by: ValueTypes["LocaleGenericPagesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
genericPagesBySeo?: [{	by: ValueTypes["LocaleGenericPagesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
genericPagesByLink?: [{	by: ValueTypes["LocaleGenericPagesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
postsByRoot?: [{	by: ValueTypes["LocalePostsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
postsByContent?: [{	by: ValueTypes["LocalePostsByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
postsBySeo?: [{	by: ValueTypes["LocalePostsBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
postsByLink?: [{	by: ValueTypes["LocalePostsByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
postAreasByRoot?: [{	by: ValueTypes["LocalePostAreasByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
postAreasByLink?: [{	by: ValueTypes["LocalePostAreasByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
postAreasBySeo?: [{	by: ValueTypes["LocalePostAreasBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
postAreasByBanner?: [{	by: ValueTypes["LocalePostAreasByBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
postAreasByContent?: [{	by: ValueTypes["LocalePostAreasByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
postOrganizationsByRoot?: [{	by: ValueTypes["LocalePostOrganizationsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
postOrganizationsByLink?: [{	by: ValueTypes["LocalePostOrganizationsByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
postOrganizationsByDomain?: [{	by: ValueTypes["LocalePostOrganizationsByDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
postOrganizationsBySeo?: [{	by: ValueTypes["LocalePostOrganizationsBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
postOrganizationsByContent?: [{	by: ValueTypes["LocalePostOrganizationsByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
headersByRoot?: [{	by: ValueTypes["LocaleHeadersByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
headersByLinks?: [{	by: ValueTypes["LocaleHeadersByLinksUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
footersByRoot?: [{	by: ValueTypes["LocaleFootersByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByLinkList?: [{	by: ValueTypes["LocaleFootersByLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByAddressInfo?: [{	by: ValueTypes["LocaleFootersByAddressInfoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByImageLinkList?: [{	by: ValueTypes["LocaleFootersByImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
genericPageAboutSettingsByRoot?: [{	by: ValueTypes["LocaleGenericPageAboutSettingsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
genericPageAboutSettingsByLinkGroups?: [{	by: ValueTypes["LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
postRevisionsByRoot?: [{	by: ValueTypes["LocalePostRevisionsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
postRevisionsByContent?: [{	by: ValueTypes["LocalePostRevisionsByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
postRevisionsBySeo?: [{	by: ValueTypes["LocalePostRevisionsBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
postRevisionsByLeadContent?: [{	by: ValueTypes["LocalePostRevisionsByLeadContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
feedPagesByRoot?: [{	by: ValueTypes["LocaleFeedPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
feedPagesByHeroTiles?: [{	by: ValueTypes["LocaleFeedPagesByHeroTilesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
feedPagesBySectionList?: [{	by: ValueTypes["LocaleFeedPagesBySectionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
feedPagesByCardList?: [{	by: ValueTypes["LocaleFeedPagesByCardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
feedPagesByStoryGuideList?: [{	by: ValueTypes["LocaleFeedPagesByStoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
recurringPaymentPagesByRoot?: [{	by: ValueTypes["LocaleRecurringPaymentPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
recurringPaymentPagesByFavouritePosts?: [{	by: ValueTypes["LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
recurringPaymentPagesByStoryGuideList?: [{	by: ValueTypes["LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
givenGiftsPagesByRoot?: [{	by: ValueTypes["LocaleGivenGiftsPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
givenGiftsPagesByContent?: [{	by: ValueTypes["LocaleGivenGiftsPagesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
givenGiftsPagesBySeo?: [{	by: ValueTypes["LocaleGivenGiftsPagesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
givenGiftsPagesByLink?: [{	by: ValueTypes["LocaleGivenGiftsPagesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
receivedGiftsPagesByRoot?: [{	by: ValueTypes["LocaleReceivedGiftsPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
receivedGiftsPagesByLink?: [{	by: ValueTypes["LocaleReceivedGiftsPagesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
receivedGiftsPagesByContent?: [{	by: ValueTypes["LocaleReceivedGiftsPagesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
receivedGiftsPagesBySeo?: [{	by: ValueTypes["LocaleReceivedGiftsPagesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
reportPagesByRoot?: [{	by: ValueTypes["LocaleReportPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
reportPagesByLink?: [{	by: ValueTypes["LocaleReportPagesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
reportPagesByContent?: [{	by: ValueTypes["LocaleReportPagesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
reportPagesBySeo?: [{	by: ValueTypes["LocaleReportPagesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
reportNavigationsByRoot?: [{	by: ValueTypes["LocaleReportNavigationsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
scheduledNotificationsByRoot?: [{	by: ValueTypes["LocaleScheduledNotificationsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocale"]],
sentPaymentsByRoot?: [{	by: ValueTypes["LocaleSentPaymentsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocale"]],
paginateGenerals?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleConnection"]],
paginateGenericPages?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleConnection"]],
paginatePosts?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostLocaleConnection"]],
paginatePostAreas?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocaleConnection"]],
paginatePostOrganizations?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocaleConnection"]],
paginateHeaders?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleConnection"]],
paginateFooters?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleConnection"]],
paginateGenericPageAboutSettings?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleConnection"]],
paginatePostRevisions?: [{	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocaleConnection"]],
paginateFeedPages?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocaleConnection"]],
paginateRecurringPaymentPages?: [{	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleConnection"]],
paginateGivenGiftsPages?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleConnection"]],
paginateReceivedGiftsPages?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleConnection"]],
paginateReportPages?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocaleConnection"]],
paginateReportNavigations?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocaleConnection"]],
paginateScheduledNotifications?: [{	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleConnection"]],
paginateSentPayments?: [{	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	generals?:ValueTypes["FieldMeta"],
	genericPages?:ValueTypes["FieldMeta"],
	posts?:ValueTypes["FieldMeta"],
	postAreas?:ValueTypes["FieldMeta"],
	postOrganizations?:ValueTypes["FieldMeta"],
	headers?:ValueTypes["FieldMeta"],
	footers?:ValueTypes["FieldMeta"],
	genericPageAboutSettings?:ValueTypes["FieldMeta"],
	postRevisions?:ValueTypes["FieldMeta"],
	flagImage?:ValueTypes["FieldMeta"],
	feedPages?:ValueTypes["FieldMeta"],
	recurringPaymentPages?:ValueTypes["FieldMeta"],
	givenGiftsPages?:ValueTypes["FieldMeta"],
	receivedGiftsPages?:ValueTypes["FieldMeta"],
	reportPages?:ValueTypes["FieldMeta"],
	reportNavigations?:ValueTypes["FieldMeta"],
	scheduledNotifications?:ValueTypes["FieldMeta"],
	sentPayments?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	allAreasDescription?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	allOrganizationsDescription?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["OrderDirection"]:OrderDirection;
	["GeneralOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	allAreasIcon?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	allOrganizationsIcon?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListOrderBy"] | undefined | null | Variable<any, string>
};
	["ImageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	width?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	height?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	alt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fileName?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	focalPointX?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	focalPointY?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["LocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	code?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	label?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["SeoOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ogTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ogDescription?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	noIndex?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	noFollow?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["LinkOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	externalLink?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	internalLink?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	isTargetBlank?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["LinkableOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["GenericPageLocaleOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostLocaleOrderBy"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["PostAreaLocaleOrderBy"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["PostOrganizationLocaleOrderBy"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["ReportPageLocaleOrderBy"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["GivenGiftsPageLocaleOrderBy"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["ReceivedGiftsPageLocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["GenericPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ContentOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>,
	paymentName?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostRevisionOrderBy"] | undefined | null | Variable<any, string>,
	isPinnedInArea?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	state?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostMetaDataOrderBy"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fundraiseIsActive?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostSumOrderBy"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostFundraisingProgressOrderBy"] | undefined | null | Variable<any, string>
};
	["PostOrganizationOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationMetaDataOrderBy"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	isHidden?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	color?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationSumOrderBy"] | undefined | null | Variable<any, string>
};
	["PostAreaOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["DonationAmountsRegionListOrderBy"] | undefined | null | Variable<any, string>,
	color?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionOrderBy"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaMetaDataOrderBy"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaSentPaymentSumOrderBy"] | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaSumOrderBy"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	donation?: ValueTypes["DonationOrderBy"] | undefined | null | Variable<any, string>
};
	["DonationOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	regionList?: ValueTypes["DonationAmountsRegionListOrderBy"] | undefined | null | Variable<any, string>
};
	["RegionOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	code?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	label?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	timezone?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["CurrencyOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	label?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	sign?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	signAlignment?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	defaultDonationAmount?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostAreaMetaDataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	nameWithFallback?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	formattedSpecificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fullFormattedSpecificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>
};
	["PostAreaSentPaymentSumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	czkPercentage?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>
};
	["PostAreaSumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	czkPercentage?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>
};
	["PostOrganizationMetaDataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	nameWithFallback?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	formattedSpecificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fullFormattedSpecificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>
};
	["PostOrganizationSumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	czkPercentage?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>
};
	["PostRevisionOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdById?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	publishedById?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>,
	tileImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	tileVideo?: ValueTypes["VideoOrderBy"] | undefined | null | Variable<any, string>,
	heroImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["DonationAmountsRegionListOrderBy"] | undefined | null | Variable<any, string>,
	isOrganizationVisible?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	sendPublishNotifications?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isArchived?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["VideoOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	width?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	height?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	poster?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	shapeType?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostMetaDataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	titleWithFallback?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	formattedSpecificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fullFormattedSpecificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	latestRevision?: ValueTypes["PostRevisionOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>
};
	["PostSumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	czkPercentage?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>
};
	["PostFundraisingProgressOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	progress?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>
};
	["PostAreaLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["AppBannerOrderBy"] | undefined | null | Variable<any, string>,
	shortDescription?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	translatedByAI?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["AppBannerOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	imageSmall?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	imageBig?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	translatedByAI?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ReportPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	postTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	giftTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>
};
	["ReportPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	giftTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	giftText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	note?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	giftTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	giftText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	note?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["GenericPageLocale"]: AliasType<{
	_meta?:ValueTypes["GenericPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
	subtitle?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPage"]: AliasType<{
	_meta?:ValueTypes["GenericPageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
	type?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
reportNavigation?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
localesByLocale?: [{	by: ValueTypes["GenericPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
localesByContent?: [{	by: ValueTypes["GenericPageLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
localesBySeo?: [{	by: ValueTypes["GenericPageLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
localesByLink?: [{	by: ValueTypes["GenericPageLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleConnection"]],
paginateReportNavigation?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	reportNavigation?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocale"]: AliasType<{
	_meta?:ValueTypes["ReportNavigationLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigation"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
pages?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
paginatePages?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	pages?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigation"]: AliasType<{
	_meta?:ValueTypes["ReportNavigationMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
localesByLocale?: [{	by: ValueTypes["ReportNavigationLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
paginateLocales?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportNavigationOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["ReportNavigationOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ReportNavigationLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	generals?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	genericPages?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	postAreas?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	postOrganizations?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	headers?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	footers?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	postRevisions?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	feedPages?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	recurringPaymentPages?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	givenGiftsPages?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	receivedGiftsPages?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	reportPages?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	reportNavigations?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	scheduledNotifications?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	sentPayments?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	allAreasIcon?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	allOrganizationsIcon?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ImageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["PostOrganizationListItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LinkUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["SeoUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	blocks?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	references?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	linkables?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ValueListUniqueWhere"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["PostAreaListUniqueWhere"] | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["AccordionUniqueWhere"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["MemberListUniqueWhere"] | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["TextImageListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceLinkableItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LinkableUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	revisions?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostMetaDataUniqueWhere"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostSumUniqueWhere"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostFundraisingProgressUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	regions?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	donation?: ValueTypes["DonationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["DonationAmountItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RegionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	enabledPaymentMethods?: ValueTypes["RegionPaymentMethodUniqueWhere"] | undefined | null | Variable<any, string>,
	donationItems?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RegionPaymentMethodUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>
};
	["DonationAmountItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["DonationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	regionList?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostMetaDataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	latestRevision?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostCurrencySumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["PostSumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostFundraisingProgressUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["AppBannerUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	locales?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaMetaDataUniqueWhere"] | undefined | null | Variable<any, string>,
	sentPayments?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaSumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaMetaDataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SentPaymentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaSentPaymentCurrencySumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["PostAreaSentPaymentSumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaCurrencySumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["PostAreaSumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>
};
	["AppBannerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	posts?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationMetaDataUniqueWhere"] | undefined | null | Variable<any, string>,
	sentPayments?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	organizationCurrencySums?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationSumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationMetaDataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationCurrencySumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["PostOrganizationSumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReportPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReportPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ValueListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["ValueItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ValueItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["ImageLinkListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["ImageLinkItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ImageLinkItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["PostAreaListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["PostAreaListItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["AccordionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["AccordionItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["AccordionItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["MediumListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["MediumItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["MemberListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["MemberListItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["MemberListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TextImageListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["TextImageListItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TextImageListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["HeaderLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeaderUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LinkListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["LinkItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LinkItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	linkGroups?: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FeedPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>,
	sectionList?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["CardListUniqueWhere"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TileListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["TileItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TileItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageSectionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tileStripeList?: ValueTypes["FeedPageTileStripeUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["CardListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["CardItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CardItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["StoryGuideListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["StoryGuideItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["StoryGuideItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecurringPaymentPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["PostListUniqueWhere"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["PostListItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportNavigationUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReportNavigationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ScheduledNotificationUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	processedNotifications?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	source?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReportNavigationLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PageInfo"]: AliasType<{
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleEdge"]: AliasType<{
	node?:ValueTypes["ReportNavigationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageEdge"]: AliasType<{
	node?:ValueTypes["GenericPage"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["GenericPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:boolean | `@${string}`,
blocks?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by: ValueTypes["ContentBlocksByReferencesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlockConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	json?:boolean | `@${string}`,
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
references?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByLinkables?: [{	by: ValueTypes["ContentBlockReferencesByLinkablesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByLink?: [{	by: ValueTypes["ContentBlockReferencesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByValueList?: [{	by: ValueTypes["ContentBlockReferencesByValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByImageLinkList?: [{	by: ValueTypes["ContentBlockReferencesByImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByAreaList?: [{	by: ValueTypes["ContentBlockReferencesByAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByAccordion?: [{	by: ValueTypes["ContentBlockReferencesByAccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByMedia?: [{	by: ValueTypes["ContentBlockReferencesByMediaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByMemberList?: [{	by: ValueTypes["ContentBlockReferencesByMemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByContentWithoutBlocks?: [{	by: ValueTypes["ContentBlockReferencesByContentWithoutBlocksUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByOrganizationList?: [{	by: ValueTypes["ContentBlockReferencesByOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByTextImageList?: [{	by: ValueTypes["ContentBlockReferencesByTextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	primaryText?:boolean | `@${string}`,
block?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
linkables?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
video?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
	secondaryText?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
	contentAlignment?:boolean | `@${string}`,
valueList?: [{	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueList"]],
imageLinkList?: [{	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkList"]],
areaList?: [{	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaList"]],
	isAppsVisible?:boolean | `@${string}`,
accordion?: [{	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Accordion"]],
media?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
memberList?: [{	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberList"]],
	asideMediaContentLayout?:boolean | `@${string}`,
	isAsideMediaContentMobileLayout?:boolean | `@${string}`,
form?: [{	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>},ValueTypes["Form"]],
	isTitleBigger?:boolean | `@${string}`,
contentWithoutBlocks?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
heroCarousel?: [{	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarousel"]],
organizationList?: [{	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationList"]],
	isCentered?:boolean | `@${string}`,
posts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Post"]],
textImageList?: [{	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageList"]],
linkablesByItem?: [{	by: ValueTypes["ContentReferenceLinkablesByItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
paginateLinkables?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItemConnection"]],
paginatePosts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	linkables?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	contentAlignment?:ValueTypes["FieldMeta"],
	valueList?:ValueTypes["FieldMeta"],
	imageLinkList?:ValueTypes["FieldMeta"],
	areaList?:ValueTypes["FieldMeta"],
	isAppsVisible?:ValueTypes["FieldMeta"],
	accordion?:ValueTypes["FieldMeta"],
	media?:ValueTypes["FieldMeta"],
	memberList?:ValueTypes["FieldMeta"],
	asideMediaContentLayout?:ValueTypes["FieldMeta"],
	isAsideMediaContentMobileLayout?:ValueTypes["FieldMeta"],
	form?:ValueTypes["FieldMeta"],
	isTitleBigger?:ValueTypes["FieldMeta"],
	contentWithoutBlocks?:ValueTypes["FieldMeta"],
	heroCarousel?:ValueTypes["FieldMeta"],
	organizationList?:ValueTypes["FieldMeta"],
	isCentered?:ValueTypes["FieldMeta"],
	posts?:ValueTypes["FieldMeta"],
	textImageList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	alt?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	focalPointX?:boolean | `@${string}`,
	focalPointY?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
	fileName?:ValueTypes["FieldMeta"],
	focalPointX?:ValueTypes["FieldMeta"],
	focalPointY?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItem"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceLinkableItemMeta"],
	id?:boolean | `@${string}`,
item?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
reference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
	reference?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
genericPage?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
post?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
postArea?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
postOrganization?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
reportPage?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
givenGiftsPage?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
receivedGiftsPage?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	genericPage?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
	postArea?:ValueTypes["FieldMeta"],
	postOrganization?:ValueTypes["FieldMeta"],
	reportPage?:ValueTypes["FieldMeta"],
	givenGiftsPage?:ValueTypes["FieldMeta"],
	receivedGiftsPage?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocale"]: AliasType<{
	_meta?:ValueTypes["PostLocaleMeta"],
	id?:boolean | `@${string}`,
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
root?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
	paymentName?:boolean | `@${string}`,
	publishedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	paymentName?:ValueTypes["FieldMeta"],
	publishedAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	ogTitle?:boolean | `@${string}`,
	ogDescription?:boolean | `@${string}`,
	noIndex?:boolean | `@${string}`,
	noFollow?:boolean | `@${string}`,
ogImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	noIndex?:ValueTypes["FieldMeta"],
	noFollow?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Post"]: AliasType<{
	_meta?:ValueTypes["PostMeta"],
	id?:boolean | `@${string}`,
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
	specificSymbol?:boolean | `@${string}`,
activeRevision?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
revisions?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
locales?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
	isPinnedInArea?:boolean | `@${string}`,
	isPinnedInOrganization?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
meta?: [{	filter?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostMetaData"]],
	isPublishedAtHidden?:boolean | `@${string}`,
heroCarousel?: [{	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarousel"]],
reportPage?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
content?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
	fundraiseIsActive?:boolean | `@${string}`,
	fundraiseEndDate?:boolean | `@${string}`,
	fundraiseTargetAmount?:boolean | `@${string}`,
	fundraiseFakeAddOnAmount?:boolean | `@${string}`,
fundraiseCurrency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
fundraiseCurrencySums?: [{	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySum"]],
fundraiseSum?: [{	filter?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostSum"]],
fundraisingProgress?: [{	filter?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostFundraisingProgress"]],
revisionsByLocales?: [{	by: ValueTypes["PostRevisionsByLocalesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
revisionsByRegionListOverride?: [{	by: ValueTypes["PostRevisionsByRegionListOverrideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
localesByLocale?: [{	by: ValueTypes["PostLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
localesByContent?: [{	by: ValueTypes["PostLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
localesBySeo?: [{	by: ValueTypes["PostLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
localesByLink?: [{	by: ValueTypes["PostLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
paginateRevisions?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionConnection"]],
paginateLocales?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostLocaleConnection"]],
paginateHeroCarousel?: [{	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselConnection"]],
paginateReportPage?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocaleConnection"]],
paginateContent?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceConnection"]],
paginateFundraiseCurrencySums?: [{	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySumConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	specificSymbol?:ValueTypes["FieldMeta"],
	activeRevision?:ValueTypes["FieldMeta"],
	revisions?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	isPinnedInArea?:ValueTypes["FieldMeta"],
	isPinnedInOrganization?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	isPublishedAtHidden?:ValueTypes["FieldMeta"],
	heroCarousel?:ValueTypes["FieldMeta"],
	reportPage?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	fundraiseIsActive?:ValueTypes["FieldMeta"],
	fundraiseEndDate?:ValueTypes["FieldMeta"],
	fundraiseTargetAmount?:ValueTypes["FieldMeta"],
	fundraiseFakeAddOnAmount?:ValueTypes["FieldMeta"],
	fundraiseCurrency?:ValueTypes["FieldMeta"],
	fundraiseCurrencySums?:ValueTypes["FieldMeta"],
	fundraiseSum?:ValueTypes["FieldMeta"],
	fundraisingProgress?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganization"]: AliasType<{
	_meta?:ValueTypes["PostOrganizationMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
posts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Post"]],
icon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
locales?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
	specificSymbol?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
meta?: [{	filter?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationMetaData"]],
mobileHeroImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	isHidden?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
plainIcon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
desktopHeroImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
sentPayments?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
organizationCurrencySums?: [{	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySum"]],
organizationSum?: [{	filter?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationSum"]],
postsBySpecificSymbol?: [{	by: ValueTypes["PostOrganizationPostsBySpecificSymbolUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByActiveRevision?: [{	by: ValueTypes["PostOrganizationPostsByActiveRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByRevisions?: [{	by: ValueTypes["PostOrganizationPostsByRevisionsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByLocales?: [{	by: ValueTypes["PostOrganizationPostsByLocalesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByMeta?: [{	by: ValueTypes["PostOrganizationPostsByMetaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByFundraiseCurrencySums?: [{	by: ValueTypes["PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByFundraiseSum?: [{	by: ValueTypes["PostOrganizationPostsByFundraiseSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByFundraisingProgress?: [{	by: ValueTypes["PostOrganizationPostsByFundraisingProgressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
localesByLocale?: [{	by: ValueTypes["PostOrganizationLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
localesByLink?: [{	by: ValueTypes["PostOrganizationLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
localesByDomain?: [{	by: ValueTypes["PostOrganizationLocalesByDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
localesBySeo?: [{	by: ValueTypes["PostOrganizationLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
localesByContent?: [{	by: ValueTypes["PostOrganizationLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
sentPaymentsByLocales?: [{	by: ValueTypes["PostOrganizationSentPaymentsByLocalesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
paginatePosts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostConnection"]],
paginateLocales?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocaleConnection"]],
paginateSentPayments?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentConnection"]],
paginateOrganizationCurrencySums?: [{	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySumConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	posts?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	specificSymbol?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	mobileHeroImage?:ValueTypes["FieldMeta"],
	isHidden?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	plainIcon?:ValueTypes["FieldMeta"],
	desktopHeroImage?:ValueTypes["FieldMeta"],
	sentPayments?:ValueTypes["FieldMeta"],
	organizationCurrencySums?:ValueTypes["FieldMeta"],
	organizationSum?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocale"]: AliasType<{
	_meta?:ValueTypes["PostOrganizationLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
root?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
domain?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
	translatedByAI?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	translatedByAI?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	externalLink?:boolean | `@${string}`,
internalLink?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
	isTargetBlank?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
	isTargetBlank?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostArea"]: AliasType<{
	_meta?:ValueTypes["PostAreaMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
icon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
locales?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
regionListOverride?: [{	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionList"]],
	color?:boolean | `@${string}`,
posts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Post"]],
	specificSymbol?:boolean | `@${string}`,
region?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Region"]],
meta?: [{	filter?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaMetaData"]],
mobileHeroImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
plainIcon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
sentPayments?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
areaSentPaymentCurrencySums?: [{	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySum"]],
areaSentPaymentSum?: [{	filter?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentSum"]],
areaCurrencySums?: [{	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySum"]],
areaSum?: [{	filter?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaSum"]],
localesByLocale?: [{	by: ValueTypes["PostAreaLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
localesByLink?: [{	by: ValueTypes["PostAreaLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
localesBySeo?: [{	by: ValueTypes["PostAreaLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
localesByBanner?: [{	by: ValueTypes["PostAreaLocalesByBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
localesByContent?: [{	by: ValueTypes["PostAreaLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
postsBySpecificSymbol?: [{	by: ValueTypes["PostAreaPostsBySpecificSymbolUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByActiveRevision?: [{	by: ValueTypes["PostAreaPostsByActiveRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByRevisions?: [{	by: ValueTypes["PostAreaPostsByRevisionsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByLocales?: [{	by: ValueTypes["PostAreaPostsByLocalesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByMeta?: [{	by: ValueTypes["PostAreaPostsByMetaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByFundraiseCurrencySums?: [{	by: ValueTypes["PostAreaPostsByFundraiseCurrencySumsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByFundraiseSum?: [{	by: ValueTypes["PostAreaPostsByFundraiseSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
postsByFundraisingProgress?: [{	by: ValueTypes["PostAreaPostsByFundraisingProgressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
sentPaymentsByLocales?: [{	by: ValueTypes["PostAreaSentPaymentsByLocalesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
paginateLocales?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocaleConnection"]],
paginatePosts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostConnection"]],
paginateSentPayments?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentConnection"]],
paginateAreaSentPaymentCurrencySums?: [{	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySumConnection"]],
paginateAreaCurrencySums?: [{	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySumConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	regionListOverride?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	posts?:ValueTypes["FieldMeta"],
	specificSymbol?:ValueTypes["FieldMeta"],
	region?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	mobileHeroImage?:ValueTypes["FieldMeta"],
	plainIcon?:ValueTypes["FieldMeta"],
	sentPayments?:ValueTypes["FieldMeta"],
	areaSentPaymentCurrencySums?:ValueTypes["FieldMeta"],
	areaSentPaymentSum?:ValueTypes["FieldMeta"],
	areaCurrencySums?:ValueTypes["FieldMeta"],
	areaSum?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocale"]: AliasType<{
	_meta?:ValueTypes["PostAreaLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
root?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
banner?: [{	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["AppBanner"]],
	shortDescription?:boolean | `@${string}`,
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
	translatedByAI?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	banner?:ValueTypes["FieldMeta"],
	shortDescription?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	translatedByAI?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AppBanner"]: AliasType<{
	_meta?:ValueTypes["AppBannerMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
imageSmall?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
imageBig?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
textContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	imageSmall?:ValueTypes["FieldMeta"],
	imageBig?:ValueTypes["FieldMeta"],
	textContent?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionList"]: AliasType<{
	_meta?:ValueTypes["DonationAmountsRegionListMeta"],
	id?:boolean | `@${string}`,
regions?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
donation?: [{	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["Donation"]],
regionsByRegion?: [{	by: ValueTypes["DonationAmountsRegionListRegionsByRegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
regionsByItems?: [{	by: ValueTypes["DonationAmountsRegionListRegionsByItemsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
paginateRegions?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	regions?:ValueTypes["FieldMeta"],
	donation?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItem"]: AliasType<{
	_meta?:ValueTypes["DonationAmountsRegionItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItem"]],
list?: [{	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionList"]],
region?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Region"]],
	minimumAmount?:boolean | `@${string}`,
paginateItems?: [{	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	region?:ValueTypes["FieldMeta"],
	minimumAmount?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItem"]: AliasType<{
	_meta?:ValueTypes["DonationAmountItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
regionItem?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	amount?:ValueTypes["FieldMeta"],
	regionItem?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	amount?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	regionItem?: ValueTypes["DonationAmountsRegionItemOrderBy"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionListOrderBy"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionOrderBy"] | undefined | null | Variable<any, string>,
	minimumAmount?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["Region"]: AliasType<{
	_meta?:ValueTypes["RegionMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
enabledPaymentMethods?: [{	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionPaymentMethodOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethod"]],
donationItems?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
	timezone?:boolean | `@${string}`,
enabledPaymentMethodsByMethod?: [{	by: ValueTypes["RegionEnabledPaymentMethodsByMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethod"]],
donationItemsByList?: [{	by: ValueTypes["RegionDonationItemsByListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
donationItemsByItems?: [{	by: ValueTypes["RegionDonationItemsByItemsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
paginateEnabledPaymentMethods?: [{	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionPaymentMethodOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethodConnection"]],
paginateDonationItems?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["RegionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	enabledPaymentMethods?:ValueTypes["FieldMeta"],
	donationItems?:ValueTypes["FieldMeta"],
	timezone?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Currency"]: AliasType<{
	_meta?:ValueTypes["CurrencyMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	sign?:boolean | `@${string}`,
	signAlignment?:boolean | `@${string}`,
	defaultDonationAmount?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
areaSentPaymentCurrencySums?: [{	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySum"]],
areaCurrencySums?: [{	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySum"]],
organizationCurrencySums?: [{	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySum"]],
postCurrencySums?: [{	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySum"]],
paginateAreaSentPaymentCurrencySums?: [{	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySumConnection"]],
paginateAreaCurrencySums?: [{	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySumConnection"]],
paginateOrganizationCurrencySums?: [{	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySumConnection"]],
paginatePostCurrencySums?: [{	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySumConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	sign?:ValueTypes["FieldMeta"],
	signAlignment?:ValueTypes["FieldMeta"],
	defaultDonationAmount?:ValueTypes["FieldMeta"],
	rateAgainstCzk?:ValueTypes["FieldMeta"],
	areaSentPaymentCurrencySums?:ValueTypes["FieldMeta"],
	areaCurrencySums?:ValueTypes["FieldMeta"],
	organizationCurrencySums?:ValueTypes["FieldMeta"],
	postCurrencySums?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentCurrencySum"]: AliasType<{
	_meta?:ValueTypes["PostAreaSentPaymentCurrencySumMeta"],
	id?:boolean | `@${string}`,
	currencyIdentifier?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentCurrencySumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	currencyIdentifier?:ValueTypes["FieldMeta"],
	rateAgainstCzk?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentCurrencySumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currencyIdentifier?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>
};
	["PostAreaCurrencySum"]: AliasType<{
	_meta?:ValueTypes["PostAreaCurrencySumMeta"],
	id?:boolean | `@${string}`,
	currencyIdentifier?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCurrencySumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	currencyIdentifier?:ValueTypes["FieldMeta"],
	rateAgainstCzk?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCurrencySumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currencyIdentifier?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>
};
	["PostOrganizationCurrencySum"]: AliasType<{
	_meta?:ValueTypes["PostOrganizationCurrencySumMeta"],
	id?:boolean | `@${string}`,
	currencyIdentifier?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCurrencySumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	currencyIdentifier?:ValueTypes["FieldMeta"],
	rateAgainstCzk?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCurrencySumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currencyIdentifier?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>
};
	["PostCurrencySum"]: AliasType<{
	_meta?:ValueTypes["PostCurrencySumMeta"],
	id?:boolean | `@${string}`,
	currencyIdentifier?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostCurrencySumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	currencyIdentifier?:ValueTypes["FieldMeta"],
	rateAgainstCzk?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostCurrencySumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currencyIdentifier?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	rateAgainstCzk?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>
};
	["PostAreaSentPaymentCurrencySumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaSentPaymentCurrencySumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentCurrencySumEdge"]: AliasType<{
	node?:ValueTypes["PostAreaSentPaymentCurrencySum"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCurrencySumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaCurrencySumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCurrencySumEdge"]: AliasType<{
	node?:ValueTypes["PostAreaCurrencySum"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCurrencySumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostOrganizationCurrencySumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCurrencySumEdge"]: AliasType<{
	node?:ValueTypes["PostOrganizationCurrencySum"],
		__typename?: boolean | `@${string}`
}>;
	["PostCurrencySumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostCurrencySumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostCurrencySumEdge"]: AliasType<{
	node?:ValueTypes["PostCurrencySum"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethod"]: AliasType<{
	_meta?:ValueTypes["RegionPaymentMethodMeta"],
	id?:boolean | `@${string}`,
	allowRecurringPayments?:boolean | `@${string}`,
region?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Region"]],
	method?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	allowRecurringPayments?:ValueTypes["FieldMeta"],
	region?:ValueTypes["FieldMeta"],
	method?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	allowRecurringPayments?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionOrderBy"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["RegionEnabledPaymentMethodsByMethodUniqueWhere"]: {
	method?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>
};
	["RegionDonationItemsByListUniqueWhere"]: {
	list?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RegionDonationItemsByItemsUniqueWhere"]: {
	items?: ValueTypes["DonationAmountItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RegionPaymentMethodConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RegionPaymentMethodEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodEdge"]: AliasType<{
	node?:ValueTypes["RegionPaymentMethod"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DonationAmountsRegionItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemEdge"]: AliasType<{
	node?:ValueTypes["DonationAmountsRegionItem"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DonationAmountItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemEdge"]: AliasType<{
	node?:ValueTypes["DonationAmountItem"],
		__typename?: boolean | `@${string}`
}>;
	["Donation"]: AliasType<{
	_meta?:ValueTypes["DonationMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
regionList?: [{	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionList"]],
		__typename?: boolean | `@${string}`
}>;
	["DonationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	regionList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListRegionsByRegionUniqueWhere"]: {
	region?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListRegionsByItemsUniqueWhere"]: {
	items?: ValueTypes["DonationAmountItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaMetaData"]: AliasType<{
	_meta?:ValueTypes["PostAreaMetaDataMeta"],
	id?:boolean | `@${string}`,
	nameWithFallback?:boolean | `@${string}`,
	formattedSpecificSymbol?:boolean | `@${string}`,
	fullFormattedSpecificSymbol?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaMetaDataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	nameWithFallback?:ValueTypes["FieldMeta"],
	formattedSpecificSymbol?:ValueTypes["FieldMeta"],
	fullFormattedSpecificSymbol?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SentPayment"]: AliasType<{
	_meta?:ValueTypes["SentPaymentMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	cents?:boolean | `@${string}`,
	sendAt?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
locales?: [{	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocale"]],
localesByLocale?: [{	by: ValueTypes["SentPaymentLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocale"]],
paginateLocales?: [{	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	cents?:ValueTypes["FieldMeta"],
	sendAt?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocale"]: AliasType<{
	_meta?:ValueTypes["SentPaymentLocaleMeta"],
	id?:boolean | `@${string}`,
	organizationText?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	organizationText?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	organizationText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["SentPaymentOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["SentPaymentOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	cents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>
};
	["SentPaymentLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SentPaymentLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleEdge"]: AliasType<{
	node?:ValueTypes["SentPaymentLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentSum"]: AliasType<{
	_meta?:ValueTypes["PostAreaSentPaymentSumMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
	czkPercentage?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentSumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	czkPercentage?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSum"]: AliasType<{
	_meta?:ValueTypes["PostAreaSumMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
	czkPercentage?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	czkPercentage?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaLocalesByBannerUniqueWhere"]: {
	banner?: ValueTypes["AppBannerUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaPostsBySpecificSymbolUniqueWhere"]: {
	specificSymbol?: number | undefined | null | Variable<any, string>
};
	["PostAreaPostsByActiveRevisionUniqueWhere"]: {
	activeRevision?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaPostsByRevisionsUniqueWhere"]: {
	revisions?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaPostsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaPostsByMetaUniqueWhere"]: {
	meta?: ValueTypes["PostMetaDataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaPostsByFundraiseCurrencySumsUniqueWhere"]: {
	fundraiseCurrencySums?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaPostsByFundraiseSumUniqueWhere"]: {
	fundraiseSum?: ValueTypes["PostSumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaPostsByFundraisingProgressUniqueWhere"]: {
	fundraisingProgress?: ValueTypes["PostFundraisingProgressUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaSentPaymentsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleEdge"]: AliasType<{
	node?:ValueTypes["PostAreaLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostEdge"]: AliasType<{
	node?:ValueTypes["Post"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SentPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentEdge"]: AliasType<{
	node?:ValueTypes["SentPayment"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMetaData"]: AliasType<{
	_meta?:ValueTypes["PostOrganizationMetaDataMeta"],
	id?:boolean | `@${string}`,
	nameWithFallback?:boolean | `@${string}`,
	formattedSpecificSymbol?:boolean | `@${string}`,
	fullFormattedSpecificSymbol?:boolean | `@${string}`,
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMetaDataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	nameWithFallback?:ValueTypes["FieldMeta"],
	formattedSpecificSymbol?:ValueTypes["FieldMeta"],
	fullFormattedSpecificSymbol?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationSum"]: AliasType<{
	_meta?:ValueTypes["PostOrganizationSumMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
	czkPercentage?:boolean | `@${string}`,
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationSumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	czkPercentage?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationPostsBySpecificSymbolUniqueWhere"]: {
	specificSymbol?: number | undefined | null | Variable<any, string>
};
	["PostOrganizationPostsByActiveRevisionUniqueWhere"]: {
	activeRevision?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationPostsByRevisionsUniqueWhere"]: {
	revisions?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationPostsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationPostsByMetaUniqueWhere"]: {
	meta?: ValueTypes["PostMetaDataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere"]: {
	fundraiseCurrencySums?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationPostsByFundraiseSumUniqueWhere"]: {
	fundraiseSum?: ValueTypes["PostSumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationPostsByFundraisingProgressUniqueWhere"]: {
	fundraisingProgress?: ValueTypes["PostFundraisingProgressUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocalesByDomainUniqueWhere"]: {
	domain?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationSentPaymentsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostOrganizationLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleEdge"]: AliasType<{
	node?:ValueTypes["PostOrganizationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevision"]: AliasType<{
	_meta?:ValueTypes["PostRevisionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	createdById?:boolean | `@${string}`,
	publishedById?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	publishedAt?:boolean | `@${string}`,
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
tileImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
tileVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
heroImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
locales?: [{	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
regionListOverride?: [{	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionList"]],
	isOrganizationVisible?:boolean | `@${string}`,
	sendPublishNotifications?:boolean | `@${string}`,
	isArchived?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["PostRevisionLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
localesByContent?: [{	by: ValueTypes["PostRevisionLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
localesBySeo?: [{	by: ValueTypes["PostRevisionLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
localesByLeadContent?: [{	by: ValueTypes["PostRevisionLocalesByLeadContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
paginateLocales?: [{	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	createdById?:ValueTypes["FieldMeta"],
	publishedById?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	publishedAt?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
	tileImage?:ValueTypes["FieldMeta"],
	tileVideo?:ValueTypes["FieldMeta"],
	heroImage?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	regionListOverride?:ValueTypes["FieldMeta"],
	isOrganizationVisible?:ValueTypes["FieldMeta"],
	sendPublishNotifications?:ValueTypes["FieldMeta"],
	isArchived?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Video"]: AliasType<{
	_meta?:ValueTypes["VideoMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
poster?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	shapeType?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	poster?:ValueTypes["FieldMeta"],
	shapeType?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocale"]: AliasType<{
	_meta?:ValueTypes["PostRevisionLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
leadContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
	publishNotificationText?:boolean | `@${string}`,
	translatedByAI?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	leadContent?:ValueTypes["FieldMeta"],
	publishNotificationText?:ValueTypes["FieldMeta"],
	translatedByAI?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostRevisionOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	publishNotificationText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	translatedByAI?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocalesByLeadContentUniqueWhere"]: {
	leadContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostRevisionLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleEdge"]: AliasType<{
	node?:ValueTypes["PostRevisionLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostMetaData"]: AliasType<{
	_meta?:ValueTypes["PostMetaDataMeta"],
	id?:boolean | `@${string}`,
	titleWithFallback?:boolean | `@${string}`,
	formattedSpecificSymbol?:boolean | `@${string}`,
	fullFormattedSpecificSymbol?:boolean | `@${string}`,
latestRevision?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostMetaDataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	titleWithFallback?:ValueTypes["FieldMeta"],
	formattedSpecificSymbol?:ValueTypes["FieldMeta"],
	fullFormattedSpecificSymbol?:ValueTypes["FieldMeta"],
	latestRevision?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarousel"]: AliasType<{
	_meta?:ValueTypes["HeroCarouselMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
posts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Post"]],
items?: [{	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItem"]],
paginatePosts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostConnection"]],
paginateItems?: [{	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	posts?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItem"]: AliasType<{
	_meta?:ValueTypes["HeroCarouselItemMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarousel"]],
item?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["HeroCarouselOrderBy"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>
};
	["HeroCarouselOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["HeroCarouselItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeroCarouselItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemEdge"]: AliasType<{
	node?:ValueTypes["HeroCarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocale"]: AliasType<{
	_meta?:ValueTypes["ReportPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
	postTitle?:boolean | `@${string}`,
	giftTitle?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
root?: [{	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
posts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Post"]],
paginatePosts?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	postTitle?:ValueTypes["FieldMeta"],
	giftTitle?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	posts?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPage"]: AliasType<{
	_meta?:ValueTypes["ReportPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
localesByLocale?: [{	by: ValueTypes["ReportPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
localesByLink?: [{	by: ValueTypes["ReportPageLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
localesByContent?: [{	by: ValueTypes["ReportPageLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
localesBySeo?: [{	by: ValueTypes["ReportPageLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReportPageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReportPageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReportPageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReportPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReportPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["ReportPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	primaryText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentBlockOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoOrderBy"] | undefined | null | Variable<any, string>,
	secondaryText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	contentAlignment?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ValueListOrderBy"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ImageLinkListOrderBy"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["PostAreaListOrderBy"] | undefined | null | Variable<any, string>,
	isAppsVisible?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["AccordionOrderBy"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListOrderBy"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["MemberListOrderBy"] | undefined | null | Variable<any, string>,
	asideMediaContentLayout?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isAsideMediaContentMobileLayout?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	form?: ValueTypes["FormOrderBy"] | undefined | null | Variable<any, string>,
	isTitleBigger?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["HeroCarouselOrderBy"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListOrderBy"] | undefined | null | Variable<any, string>,
	isCentered?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["TextImageListOrderBy"] | undefined | null | Variable<any, string>
};
	["ContentBlockOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	json?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>
};
	["ValueListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ImageLinkListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostAreaListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["AccordionOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["MediumListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["MemberListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["FormOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	tax?: ValueTypes["FilledTaxFormOrderBy"] | undefined | null | Variable<any, string>
};
	["FilledTaxFormOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	userId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	vatId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	address1?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	address2?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	city?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	postalCode?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	state?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	country?: ValueTypes["RegionOrderBy"] | undefined | null | Variable<any, string>,
	dateFrom?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	dateTo?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	year?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isPdfGenerated?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	pdfObjectKey?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["TextImageListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostSum"]: AliasType<{
	_meta?:ValueTypes["PostSumMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
	czkPercentage?:boolean | `@${string}`,
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostSumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	czkPercentage?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostFundraisingProgress"]: AliasType<{
	_meta?:ValueTypes["PostFundraisingProgressMeta"],
	id?:boolean | `@${string}`,
	progress?:boolean | `@${string}`,
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostFundraisingProgressMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	progress?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionsByRegionListOverrideUniqueWhere"]: {
	regionListOverride?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostRevisionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostRevisionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionEdge"]: AliasType<{
	node?:ValueTypes["PostRevision"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleEdge"]: AliasType<{
	node?:ValueTypes["PostLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeroCarouselEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselEdge"]: AliasType<{
	node?:ValueTypes["HeroCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocale"]: AliasType<{
	_meta?:ValueTypes["GivenGiftsPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
	giftTitle?:boolean | `@${string}`,
	giftText?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	giftTitle?:ValueTypes["FieldMeta"],
	giftText?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPage"]: AliasType<{
	_meta?:ValueTypes["GivenGiftsPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
localesByLocale?: [{	by: ValueTypes["GivenGiftsPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
localesByContent?: [{	by: ValueTypes["GivenGiftsPageLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
localesBySeo?: [{	by: ValueTypes["GivenGiftsPageLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
localesByLink?: [{	by: ValueTypes["GivenGiftsPageLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GivenGiftsPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["GivenGiftsPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocale"]: AliasType<{
	_meta?:ValueTypes["ReceivedGiftsPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
	giftTitle?:boolean | `@${string}`,
	giftText?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
root?: [{	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	giftTitle?:ValueTypes["FieldMeta"],
	giftText?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPage"]: AliasType<{
	_meta?:ValueTypes["ReceivedGiftsPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
localesByLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
localesByLink?: [{	by: ValueTypes["ReceivedGiftsPageLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
localesByContent?: [{	by: ValueTypes["ReceivedGiftsPageLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
localesBySeo?: [{	by: ValueTypes["ReceivedGiftsPageLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReceivedGiftsPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["ReceivedGiftsPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	reference?: ValueTypes["ContentReferenceOrderBy"] | undefined | null | Variable<any, string>
};
	["ValueList"]: AliasType<{
	_meta?:ValueTypes["ValueListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ValueItem"]],
paginateItems?: [{	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ValueItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ValueListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItem"]: AliasType<{
	_meta?:ValueTypes["ValueItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueList"]],
item?: [{	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["Value"]],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Value"]: AliasType<{
	_meta?:ValueTypes["ValueMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
textContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
		__typename?: boolean | `@${string}`
}>;
	["ValueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	textContent?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["ValueListOrderBy"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["ValueOrderBy"] | undefined | null | Variable<any, string>
};
	["ValueOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>
};
	["ValueItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ValueItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemEdge"]: AliasType<{
	node?:ValueTypes["ValueItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkList"]: AliasType<{
	_meta?:ValueTypes["ImageLinkListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItem"]],
paginateItems?: [{	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItem"]: AliasType<{
	_meta?:ValueTypes["ImageLinkItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkList"]],
item?: [{	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLink"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLink"]: AliasType<{
	_meta?:ValueTypes["ImageLinkMeta"],
	id?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageLinkListOrderBy"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["ImageLinkOrderBy"] | undefined | null | Variable<any, string>
};
	["ImageLinkOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["ImageLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageLinkItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemEdge"]: AliasType<{
	node?:ValueTypes["ImageLinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaList"]: AliasType<{
	_meta?:ValueTypes["PostAreaListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItem"]],
paginateItems?: [{	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItem"]: AliasType<{
	_meta?:ValueTypes["PostAreaListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaList"]],
item?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostAreaListOrderBy"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>
};
	["PostAreaListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemEdge"]: AliasType<{
	node?:ValueTypes["PostAreaListItem"],
		__typename?: boolean | `@${string}`
}>;
	["Accordion"]: AliasType<{
	_meta?:ValueTypes["AccordionMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["AccordionItem"]],
itemsByDescriptionContent?: [{	by: ValueTypes["AccordionItemsByDescriptionContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["AccordionItem"]],
paginateItems?: [{	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["AccordionItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["AccordionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItem"]: AliasType<{
	_meta?:ValueTypes["AccordionItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Accordion"]],
descriptionContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	descriptionContent?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["AccordionOrderBy"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>
};
	["AccordionItemsByDescriptionContentUniqueWhere"]: {
	descriptionContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["AccordionItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AccordionItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemEdge"]: AliasType<{
	node?:ValueTypes["AccordionItem"],
		__typename?: boolean | `@${string}`
}>;
	["MediumList"]: AliasType<{
	_meta?:ValueTypes["MediumListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
paginateItems?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItem"]: AliasType<{
	_meta?:ValueTypes["MediumItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
medium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Medium"]: AliasType<{
	_meta?:ValueTypes["MediumMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
video?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["MediumListOrderBy"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumOrderBy"] | undefined | null | Variable<any, string>
};
	["MediumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoOrderBy"] | undefined | null | Variable<any, string>
};
	["MediumItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemEdge"]: AliasType<{
	node?:ValueTypes["MediumItem"],
		__typename?: boolean | `@${string}`
}>;
	["MemberList"]: AliasType<{
	_meta?:ValueTypes["MemberListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MemberListItem"]],
itemsByDescriptionContent?: [{	by: ValueTypes["MemberListItemsByDescriptionContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberListItem"]],
paginateItems?: [{	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MemberListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MemberListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItem"]: AliasType<{
	_meta?:ValueTypes["MemberListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberList"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
descriptionContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	position?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	descriptionContent?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	position?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["MemberListOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>
};
	["MemberListItemsByDescriptionContentUniqueWhere"]: {
	descriptionContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["MemberListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MemberListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemEdge"]: AliasType<{
	node?:ValueTypes["MemberListItem"],
		__typename?: boolean | `@${string}`
}>;
	["Form"]: AliasType<{
	_meta?:ValueTypes["FormMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
tax?: [{	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxForm"]],
		__typename?: boolean | `@${string}`
}>;
	["FormMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	tax?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxForm"]: AliasType<{
	_meta?:ValueTypes["FilledTaxFormMeta"],
	id?:boolean | `@${string}`,
	publishedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	vatId?:boolean | `@${string}`,
	address1?:boolean | `@${string}`,
	address2?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	postalCode?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
country?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Region"]],
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
	isPdfGenerated?:boolean | `@${string}`,
	pdfObjectKey?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	publishedAt?:ValueTypes["FieldMeta"],
	userId?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	vatId?:ValueTypes["FieldMeta"],
	address1?:ValueTypes["FieldMeta"],
	address2?:ValueTypes["FieldMeta"],
	city?:ValueTypes["FieldMeta"],
	postalCode?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	country?:ValueTypes["FieldMeta"],
	dateFrom?:ValueTypes["FieldMeta"],
	dateTo?:ValueTypes["FieldMeta"],
	year?:ValueTypes["FieldMeta"],
	isPdfGenerated?:ValueTypes["FieldMeta"],
	pdfObjectKey?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationList"]: AliasType<{
	_meta?:ValueTypes["PostOrganizationListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItem"]],
itemsByLink?: [{	by: ValueTypes["PostOrganizationListItemsByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItem"]],
paginateItems?: [{	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItem"]: AliasType<{
	_meta?:ValueTypes["PostOrganizationListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationList"]],
item?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
	type?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostOrganizationListOrderBy"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostOrganizationListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemEdge"]: AliasType<{
	node?:ValueTypes["PostOrganizationListItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageList"]: AliasType<{
	_meta?:ValueTypes["TextImageListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageListItem"]],
paginateItems?: [{	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItem"]: AliasType<{
	_meta?:ValueTypes["TextImageListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageList"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	text?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["TextImageListOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["TextImageListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextImageListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemEdge"]: AliasType<{
	node?:ValueTypes["TextImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkablesByItemUniqueWhere"]: {
	item?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceLinkableItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceLinkableItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemEdge"]: AliasType<{
	node?:ValueTypes["ContentReferenceLinkableItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockReferencesByLinkablesUniqueWhere"]: {
	linkables?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByValueListUniqueWhere"]: {
	valueList?: ValueTypes["ValueListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByImageLinkListUniqueWhere"]: {
	imageLinkList?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByAreaListUniqueWhere"]: {
	areaList?: ValueTypes["PostAreaListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByAccordionUniqueWhere"]: {
	accordion?: ValueTypes["AccordionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
	media?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByMemberListUniqueWhere"]: {
	memberList?: ValueTypes["MemberListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByContentWithoutBlocksUniqueWhere"]: {
	contentWithoutBlocks?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByOrganizationListUniqueWhere"]: {
	organizationList?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByTextImageListUniqueWhere"]: {
	textImageList?: ValueTypes["TextImageListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocale"]: AliasType<{
	_meta?:ValueTypes["HeaderLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["Header"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
links?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkList"]],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Header"]: AliasType<{
	_meta?:ValueTypes["HeaderMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
locales?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
organizationList?: [{	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationList"]],
localesByLocale?: [{	by: ValueTypes["HeaderLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
localesByLinks?: [{	by: ValueTypes["HeaderLocalesByLinksUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
paginateLocales?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HeaderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	organizationList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["LinkListOrderBy"] | undefined | null | Variable<any, string>
};
	["HeaderOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["PostOrganizationListOrderBy"] | undefined | null | Variable<any, string>
};
	["LinkListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeaderLocalesByLinksUniqueWhere"]: {
	links?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeaderLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleEdge"]: AliasType<{
	node?:ValueTypes["HeaderLocale"],
		__typename?: boolean | `@${string}`
}>;
	["LinkList"]: AliasType<{
	_meta?:ValueTypes["LinkListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["LinkItem"]],
itemsByLink?: [{	by: ValueTypes["LinkListItemsByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkItem"]],
paginateItems?: [{	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItem"]: AliasType<{
	_meta?:ValueTypes["LinkItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkList"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["LinkListOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["LinkListItemsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemEdge"]: AliasType<{
	node?:ValueTypes["LinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocale"]: AliasType<{
	_meta?:ValueTypes["FooterLocaleMeta"],
	id?:boolean | `@${string}`,
	copyright?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
linkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkList"]],
	contactEmail?:boolean | `@${string}`,
addressInfo?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
imageLinkList?: [{	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkList"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	copyright?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	linkList?:ValueTypes["FieldMeta"],
	contactEmail?:ValueTypes["FieldMeta"],
	addressInfo?:ValueTypes["FieldMeta"],
	imageLinkList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
localesByLocale?: [{	by: ValueTypes["FooterLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByLinkList?: [{	by: ValueTypes["FooterLocalesByLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByAddressInfo?: [{	by: ValueTypes["FooterLocalesByAddressInfoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByImageLinkList?: [{	by: ValueTypes["FooterLocalesByImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
paginateLocales?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	copyright?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["LinkListOrderBy"] | undefined | null | Variable<any, string>,
	contactEmail?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ImageLinkListOrderBy"] | undefined | null | Variable<any, string>
};
	["FooterOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByLinkListUniqueWhere"]: {
	linkList?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByAddressInfoUniqueWhere"]: {
	addressInfo?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByImageLinkListUniqueWhere"]: {
	imageLinkList?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleEdge"]: AliasType<{
	node?:ValueTypes["FooterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocale"]: AliasType<{
	_meta?:ValueTypes["GenericPageAboutSettingsLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettings"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
linkGroups?: [{	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocale"]],
linkGroupsByLinkList?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocale"]],
paginateLinkGroups?: [{	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	linkGroups?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettings"]: AliasType<{
	_meta?:ValueTypes["GenericPageAboutSettingsMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
localesByLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
localesByLinkGroups?: [{	by: ValueTypes["GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
paginateLocales?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageAboutSettingsOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere"]: {
	linkGroups?: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageAboutSettingsLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleEdge"]: AliasType<{
	node?:ValueTypes["GenericPageAboutSettingsLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocale"]: AliasType<{
	_meta?:ValueTypes["GenericPageAboutGroupLinksLocaleMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
settings?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
linkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkList"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	settings?:ValueTypes["FieldMeta"],
	linkList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	settings?: ValueTypes["GenericPageAboutSettingsLocaleOrderBy"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["LinkListOrderBy"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere"]: {
	linkList?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageAboutGroupLinksLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleEdge"]: AliasType<{
	node?:ValueTypes["GenericPageAboutGroupLinksLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocale"]: AliasType<{
	_meta?:ValueTypes["FeedPageLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
heroTiles?: [{	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileList"]],
sectionList?: [{	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageSectionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageSection"]],
cardList?: [{	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardList"]],
storyGuideList?: [{	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideList"]],
sectionListByTileStripeList?: [{	by: ValueTypes["FeedPageLocaleSectionListByTileStripeListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageSection"]],
paginateSectionList?: [{	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageSectionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageSectionConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	heroTiles?:ValueTypes["FieldMeta"],
	sectionList?:ValueTypes["FieldMeta"],
	cardList?:ValueTypes["FieldMeta"],
	storyGuideList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPage"]: AliasType<{
	_meta?:ValueTypes["FeedPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
localesByLocale?: [{	by: ValueTypes["FeedPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
localesByHeroTiles?: [{	by: ValueTypes["FeedPageLocalesByHeroTilesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
localesBySectionList?: [{	by: ValueTypes["FeedPageLocalesBySectionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
localesByCardList?: [{	by: ValueTypes["FeedPageLocalesByCardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
localesByStoryGuideList?: [{	by: ValueTypes["FeedPageLocalesByStoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FeedPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["TileListOrderBy"] | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["CardListOrderBy"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["StoryGuideListOrderBy"] | undefined | null | Variable<any, string>
};
	["FeedPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["TileListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	areaType?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>
};
	["CardListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["StoryGuideListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["FeedPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageLocalesByHeroTilesUniqueWhere"]: {
	heroTiles?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageLocalesBySectionListUniqueWhere"]: {
	sectionList?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageLocalesByCardListUniqueWhere"]: {
	cardList?: ValueTypes["CardListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageLocalesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FeedPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["FeedPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["TileList"]: AliasType<{
	_meta?:ValueTypes["TileListMeta"],
	id?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TileItem"]],
areaType?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
itemsByLink?: [{	by: ValueTypes["TileListItemsByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileItem"]],
paginateItems?: [{	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TileItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TileListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	areaType?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TileItem"]: AliasType<{
	_meta?:ValueTypes["TileItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileList"]],
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
		__typename?: boolean | `@${string}`
}>;
	["TileItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["TileListOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>
};
	["TileListItemsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TileItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TileItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemEdge"]: AliasType<{
	node?:ValueTypes["TileItem"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSection"]: AliasType<{
	_meta?:ValueTypes["FeedPageSectionMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
feedPageLocale?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
tileStripeList?: [{	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageTileStripeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripe"]],
paginateTileStripeList?: [{	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageTileStripeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripeConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	feedPageLocale?:ValueTypes["FieldMeta"],
	tileStripeList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripe"]: AliasType<{
	_meta?:ValueTypes["FeedPageTileStripeMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
section?: [{	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageSection"]],
tileList?: [{	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileList"]],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	section?:ValueTypes["FieldMeta"],
	tileList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	section?: ValueTypes["FeedPageSectionOrderBy"] | undefined | null | Variable<any, string>,
	tileList?: ValueTypes["TileListOrderBy"] | undefined | null | Variable<any, string>
};
	["FeedPageSectionOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	feedPageLocale?: ValueTypes["FeedPageLocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FeedPageTileStripeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeEdge"]: AliasType<{
	node?:ValueTypes["FeedPageTileStripe"],
		__typename?: boolean | `@${string}`
}>;
	["CardList"]: AliasType<{
	_meta?:ValueTypes["CardListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CardItem"]],
itemsByLink?: [{	by: ValueTypes["CardListItemsByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardItem"]],
paginateItems?: [{	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CardItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CardListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CardItem"]: AliasType<{
	_meta?:ValueTypes["CardItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardList"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["CardItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["CardListOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["CardListItemsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CardItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CardItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemEdge"]: AliasType<{
	node?:ValueTypes["CardItem"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideList"]: AliasType<{
	_meta?:ValueTypes["StoryGuideListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItem"]],
paginateItems?: [{	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItem"]: AliasType<{
	_meta?:ValueTypes["StoryGuideItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideList"]],
guide?: [{	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuide"]],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	guide?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuide"]: AliasType<{
	_meta?:ValueTypes["StoryGuideMeta"],
	id?:boolean | `@${string}`,
	mediaType?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
secondaryImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	mediaType?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	secondaryImage?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["StoryGuideListOrderBy"] | undefined | null | Variable<any, string>,
	guide?: ValueTypes["StoryGuideOrderBy"] | undefined | null | Variable<any, string>
};
	["StoryGuideOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	mediaType?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	secondaryImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["StoryGuideItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StoryGuideItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemEdge"]: AliasType<{
	node?:ValueTypes["StoryGuideItem"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleSectionListByTileStripeListUniqueWhere"]: {
	tileStripeList?: ValueTypes["FeedPageTileStripeUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FeedPageSectionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FeedPageSectionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionEdge"]: AliasType<{
	node?:ValueTypes["FeedPageSection"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocale"]: AliasType<{
	_meta?:ValueTypes["RecurringPaymentPageLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
favouritePosts?: [{	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostList"]],
storyGuideList?: [{	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideList"]],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	favouritePosts?:ValueTypes["FieldMeta"],
	storyGuideList?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPage"]: AliasType<{
	_meta?:ValueTypes["RecurringPaymentPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
localesByLocale?: [{	by: ValueTypes["RecurringPaymentPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
localesByFavouritePosts?: [{	by: ValueTypes["RecurringPaymentPageLocalesByFavouritePostsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
localesByStoryGuideList?: [{	by: ValueTypes["RecurringPaymentPageLocalesByStoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecurringPaymentPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["PostListOrderBy"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["StoryGuideListOrderBy"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["PostListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocalesByFavouritePostsUniqueWhere"]: {
	favouritePosts?: ValueTypes["PostListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocalesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RecurringPaymentPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["RecurringPaymentPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostList"]: AliasType<{
	_meta?:ValueTypes["PostListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostListItem"]],
paginateItems?: [{	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItem"]: AliasType<{
	_meta?:ValueTypes["PostListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostList"]],
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostListOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>
};
	["PostListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemEdge"]: AliasType<{
	node?:ValueTypes["PostListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocale"]: AliasType<{
	_meta?:ValueTypes["ScheduledNotificationLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotification"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotification"]: AliasType<{
	_meta?:ValueTypes["ScheduledNotificationMeta"],
	id?:boolean | `@${string}`,
	localMsFromMidnight?:boolean | `@${string}`,
	scheduledDate?:boolean | `@${string}`,
	internalTitle?:boolean | `@${string}`,
target?: [{	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroup"]],
locales?: [{	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocale"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	completedAt?:boolean | `@${string}`,
processedNotifications?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
localesByLocale?: [{	by: ValueTypes["ScheduledNotificationLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocale"]],
processedNotificationsByProcessedNotification?: [{	by: ValueTypes["ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
paginateLocales?: [{	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleConnection"]],
paginateProcessedNotifications?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSourceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	localMsFromMidnight?:ValueTypes["FieldMeta"],
	scheduledDate?:ValueTypes["FieldMeta"],
	internalTitle?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	completedAt?:ValueTypes["FieldMeta"],
	processedNotifications?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroup"]: AliasType<{
	_meta?:ValueTypes["NotificationTargetGroupMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
regions?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Region"]],
paginateRegions?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RegionConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	regions?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RegionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RegionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RegionEdge"]: AliasType<{
	node?:ValueTypes["Region"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ScheduledNotificationOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	localMsFromMidnight?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	scheduledDate?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	internalTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	target?: ValueTypes["NotificationTargetGroupOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSource"]: AliasType<{
	_meta?:ValueTypes["ProcessedNotificationSourceMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
processedNotification?: [{	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotification"]],
donationReminderUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
scheduledNotification?: [{	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotification"]],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	processedNotification?:ValueTypes["FieldMeta"],
	donationReminderUser?:ValueTypes["FieldMeta"],
	scheduledNotification?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotification"]: AliasType<{
	_meta?:ValueTypes["ProcessedNotificationMeta"],
	id?:boolean | `@${string}`,
	topic?:boolean | `@${string}`,
	sentAt?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errorCode?:boolean | `@${string}`,
	isSuccess?:boolean | `@${string}`,
source?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
	title?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	topic?:ValueTypes["FieldMeta"],
	sentAt?:ValueTypes["FieldMeta"],
	errorMessage?:ValueTypes["FieldMeta"],
	errorCode?:ValueTypes["FieldMeta"],
	isSuccess?:ValueTypes["FieldMeta"],
	source?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	body?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	_meta?:ValueTypes["UserMeta"],
	id?:boolean | `@${string}`,
	tenantPersonId?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
payments?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
	variableSymbol?:boolean | `@${string}`,
	lastActiveAt?:boolean | `@${string}`,
region?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Region"]],
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
recurringPayments?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
	stripeId?:boolean | `@${string}`,
	isDeactivated?:boolean | `@${string}`,
onBehalfDonations?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
	publicProfileSecret?:boolean | `@${string}`,
	publicProfileCustomNote?:boolean | `@${string}`,
	publicProfileCustomNoteEnabled?:boolean | `@${string}`,
	donationConfirmationEmailEnabled?:boolean | `@${string}`,
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
	signedUp?:boolean | `@${string}`,
devices?: [{	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DeviceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Device"]],
processedNotifications?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
areaStats?: [{	filter?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserAreaStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserAreaStats"]],
organizationStats?: [{	filter?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrganizationStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserOrganizationStats"]],
postStats?: [{	filter?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPostStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPostStats"]],
currencyStats?: [{	filter?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserCurrencyStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserCurrencyStats"]],
stats?: [{	filter?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserStats"]],
paymentsByOrder?: [{	by: ValueTypes["UserPaymentsByOrderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByCsobPayment?: [{	by: ValueTypes["UserPaymentsByCsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByStripePayment?: [{	by: ValueTypes["UserPaymentsByStripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByMetadata?: [{	by: ValueTypes["UserPaymentsByMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
recurringPaymentsByItems?: [{	by: ValueTypes["UserRecurringPaymentsByItemsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
recurringPaymentsByMeta?: [{	by: ValueTypes["UserRecurringPaymentsByMetaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
onBehalfDonationsBySecretCode?: [{	by: ValueTypes["UserOnBehalfDonationsBySecretCodeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
onBehalfDonationsByPayments?: [{	by: ValueTypes["UserOnBehalfDonationsByPaymentsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
onBehalfDonationsByMeta?: [{	by: ValueTypes["UserOnBehalfDonationsByMetaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
devicesByFcmToken?: [{	by: ValueTypes["UserDevicesByFcmTokenUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>},ValueTypes["Device"]],
processedNotificationsByProcessedNotification?: [{	by: ValueTypes["UserProcessedNotificationsByProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
paginatePayments?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentConnection"]],
paginateRecurringPayments?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentConnection"]],
paginateOnBehalfDonations?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationConnection"]],
paginateDevices?: [{	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DeviceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DeviceConnection"]],
paginateProcessedNotifications?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSourceConnection"]],
paginateAreaStats?: [{	filter?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserAreaStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserAreaStatsConnection"]],
paginateOrganizationStats?: [{	filter?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrganizationStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserOrganizationStatsConnection"]],
paginatePostStats?: [{	filter?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPostStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPostStatsConnection"]],
paginateCurrencyStats?: [{	filter?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserCurrencyStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserCurrencyStatsConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	tenantPersonId?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	payments?:ValueTypes["FieldMeta"],
	variableSymbol?:ValueTypes["FieldMeta"],
	lastActiveAt?:ValueTypes["FieldMeta"],
	region?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	recurringPayments?:ValueTypes["FieldMeta"],
	stripeId?:ValueTypes["FieldMeta"],
	isDeactivated?:ValueTypes["FieldMeta"],
	onBehalfDonations?:ValueTypes["FieldMeta"],
	publicProfileSecret?:ValueTypes["FieldMeta"],
	publicProfileCustomNote?:ValueTypes["FieldMeta"],
	publicProfileCustomNoteEnabled?:ValueTypes["FieldMeta"],
	donationConfirmationEmailEnabled?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	signedUp?:ValueTypes["FieldMeta"],
	devices?:ValueTypes["FieldMeta"],
	processedNotifications?:ValueTypes["FieldMeta"],
	areaStats?:ValueTypes["FieldMeta"],
	organizationStats?:ValueTypes["FieldMeta"],
	postStats?:ValueTypes["FieldMeta"],
	currencyStats?:ValueTypes["FieldMeta"],
	stats?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPayment"]: AliasType<{
	_meta?:ValueTypes["UserPaymentMeta"],
	id?:boolean | `@${string}`,
	cents?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	specificSymbol?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
order?: [{	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderId"]],
csobPayment?: [{	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPayment"]],
stripePayment?: [{	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePayment"]],
recurringPaymentItem?: [{	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
	method?:boolean | `@${string}`,
region?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Region"]],
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
	isReusable?:boolean | `@${string}`,
onBehalfDonation?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
triesCollection?: [{	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollection"]],
	successEmailSentAt?:boolean | `@${string}`,
	isSuccessful?:boolean | `@${string}`,
	isFinished?:boolean | `@${string}`,
metadata?: [{	filter?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentMetadata"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	cents?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	specificSymbol?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	csobPayment?:ValueTypes["FieldMeta"],
	stripePayment?:ValueTypes["FieldMeta"],
	recurringPaymentItem?:ValueTypes["FieldMeta"],
	method?:ValueTypes["FieldMeta"],
	region?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	isReusable?:ValueTypes["FieldMeta"],
	onBehalfDonation?:ValueTypes["FieldMeta"],
	triesCollection?:ValueTypes["FieldMeta"],
	successEmailSentAt?:ValueTypes["FieldMeta"],
	isSuccessful?:ValueTypes["FieldMeta"],
	isFinished?:ValueTypes["FieldMeta"],
	metadata?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderId"]: AliasType<{
	_meta?:ValueTypes["UserPaymentOrderIdMeta"],
	id?:boolean | `@${string}`,
	seq?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	seq?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPayment"]: AliasType<{
	_meta?:ValueTypes["CsobPaymentMeta"],
	id?:boolean | `@${string}`,
	payId?:boolean | `@${string}`,
statusChanges?: [{	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChange"]],
payment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
	originalPayId?:boolean | `@${string}`,
metadata?: [{	filter?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentMetadata"]],
paginateStatusChanges?: [{	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	payId?:ValueTypes["FieldMeta"],
	statusChanges?:ValueTypes["FieldMeta"],
	payment?:ValueTypes["FieldMeta"],
	originalPayId?:ValueTypes["FieldMeta"],
	metadata?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChange"]: AliasType<{
	_meta?:ValueTypes["CsobPaymentStatusChangeMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	dttm?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	resultCode?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	authCode?:boolean | `@${string}`,
	statusDetail?:boolean | `@${string}`,
	actions?:boolean | `@${string}`,
payment?: [{	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	dttm?:ValueTypes["FieldMeta"],
	status?:ValueTypes["FieldMeta"],
	resultCode?:ValueTypes["FieldMeta"],
	message?:ValueTypes["FieldMeta"],
	authCode?:ValueTypes["FieldMeta"],
	statusDetail?:ValueTypes["FieldMeta"],
	actions?:ValueTypes["FieldMeta"],
	payment?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	dttm?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	resultCode?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	message?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	authCode?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	statusDetail?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	actions?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["CsobPaymentOrderBy"] | undefined | null | Variable<any, string>
};
	["CsobPaymentOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	payId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	originalPayId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentMetadataOrderBy"] | undefined | null | Variable<any, string>
};
	["UserPaymentOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	cents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentOrderIdOrderBy"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["CsobPaymentOrderBy"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["StripePaymentOrderBy"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserRecurringPaymentItemOrderBy"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionOrderBy"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>,
	isReusable?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["OnBehalfDonationOrderBy"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentTriesCollectionOrderBy"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isSuccessful?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isFinished?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentMetadataOrderBy"] | undefined | null | Variable<any, string>
};
	["UserPaymentOrderIdOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	seq?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["StripePaymentOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentMetadataOrderBy"] | undefined | null | Variable<any, string>
};
	["StripePaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isSuccessful?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isFinished?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["StripePaymentOrderBy"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	recurrenceCounter?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	taskId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentOrderBy"] | undefined | null | Variable<any, string>,
	isFailed?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	failedEmailSentAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemMetadataOrderBy"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	activeSince?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	cancelledAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	cents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	interval?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UpcomingUserRecurringPaymentMetadataOrderBy"] | undefined | null | Variable<any, string>
};
	["UserOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	variableSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionOrderBy"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	stripeId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isDeactivated?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	publicProfileSecret?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	signedUp?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	stats?: ValueTypes["UserStatsOrderBy"] | undefined | null | Variable<any, string>
};
	["UserStatsOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalPaymentsSuccessful?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalPaymentsUnsuccessful?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>
};
	["UpcomingUserRecurringPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	recurrenceCounter?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isBehindPayments?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	nextPaymentDate?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	shouldBeProcessed?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	firstPayment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	firstSuccessfulPayment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	drivingPayment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentOrderBy"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemMetadataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isSuccessfullyPaid?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	shouldBeProcessed?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	firstPayment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	lastPayment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	firstSuccessfulPayment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	drivingPayment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserRecurringPaymentItemOrderBy"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	secretCode?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	onBehalfOf?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationMetadataOrderBy"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationMetadataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>,
	onBehalfOfDonation?: ValueTypes["OnBehalfDonationOrderBy"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	cents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	specificSymbol?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	orderUrl?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["OnBehalfDonationOrderBy"] | undefined | null | Variable<any, string>,
	recurring?: ValueTypes["UserRecurringPaymentOrderBy"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentTriesCollectionMetadataOrderBy"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionMetadataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentTriesCollectionOrderBy"] | undefined | null | Variable<any, string>
};
	["UserPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>,
	organizationUnfiltered?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>,
	countToUser?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>,
	paymentType?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	statusLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isSuccessful?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isFinished?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	needsCacheUpdate?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isSuccessfulNotCached?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isFinishedNotCached?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	userPayment?: ValueTypes["UserPaymentOrderBy"] | undefined | null | Variable<any, string>
};
	["CsobPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isSuccessful?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isFinished?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	resolvedOriginalPayId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["CsobPaymentOrderBy"] | undefined | null | Variable<any, string>
};
	["CsobPaymentMetadata"]: AliasType<{
	_meta?:ValueTypes["CsobPaymentMetadataMeta"],
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	isSuccessful?:boolean | `@${string}`,
	isFinished?:boolean | `@${string}`,
	resolvedOriginalPayId?:boolean | `@${string}`,
csobPayment?: [{	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	status?:ValueTypes["FieldMeta"],
	isSuccessful?:ValueTypes["FieldMeta"],
	isFinished?:ValueTypes["FieldMeta"],
	resolvedOriginalPayId?:ValueTypes["FieldMeta"],
	csobPayment?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CsobPaymentStatusChangeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeEdge"]: AliasType<{
	node?:ValueTypes["CsobPaymentStatusChange"],
		__typename?: boolean | `@${string}`
}>;
	["StripePayment"]: AliasType<{
	_meta?:ValueTypes["StripePaymentMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
statusChanges?: [{	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChange"]],
payment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
metadata?: [{	filter?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentMetadata"]],
paginateStatusChanges?: [{	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChangeConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	statusChanges?:ValueTypes["FieldMeta"],
	payment?:ValueTypes["FieldMeta"],
	metadata?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChange"]: AliasType<{
	_meta?:ValueTypes["StripePaymentStatusChangeMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
payment?: [{	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePayment"]],
	timestamp?:boolean | `@${string}`,
	eventId?:boolean | `@${string}`,
	paymentIntentStatus?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	payment?:ValueTypes["FieldMeta"],
	timestamp?:ValueTypes["FieldMeta"],
	eventId?:ValueTypes["FieldMeta"],
	paymentIntentStatus?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["StripePaymentOrderBy"] | undefined | null | Variable<any, string>,
	timestamp?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	eventId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	paymentIntentStatus?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["StripePaymentMetadata"]: AliasType<{
	_meta?:ValueTypes["StripePaymentMetadataMeta"],
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	isSuccessful?:boolean | `@${string}`,
	isFinished?:boolean | `@${string}`,
stripePayment?: [{	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePayment"]],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	status?:ValueTypes["FieldMeta"],
	isSuccessful?:ValueTypes["FieldMeta"],
	isFinished?:ValueTypes["FieldMeta"],
	stripePayment?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StripePaymentStatusChangeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeEdge"]: AliasType<{
	node?:ValueTypes["StripePaymentStatusChange"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItem"]: AliasType<{
	_meta?:ValueTypes["UserRecurringPaymentItemMeta"],
	id?:boolean | `@${string}`,
	recurrenceCounter?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	taskId?:boolean | `@${string}`,
payments?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
recurringPayment?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
	isFailed?:boolean | `@${string}`,
	failedEmailSentAt?:boolean | `@${string}`,
meta?: [{	filter?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemMetadata"]],
paymentsByOrder?: [{	by: ValueTypes["UserRecurringPaymentItemPaymentsByOrderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByCsobPayment?: [{	by: ValueTypes["UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByStripePayment?: [{	by: ValueTypes["UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByMetadata?: [{	by: ValueTypes["UserRecurringPaymentItemPaymentsByMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paginatePayments?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	recurrenceCounter?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	taskId?:ValueTypes["FieldMeta"],
	payments?:ValueTypes["FieldMeta"],
	recurringPayment?:ValueTypes["FieldMeta"],
	isFailed?:ValueTypes["FieldMeta"],
	failedEmailSentAt?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPayment"]: AliasType<{
	_meta?:ValueTypes["UserRecurringPaymentMeta"],
	id?:boolean | `@${string}`,
	activeSince?:boolean | `@${string}`,
	cancelledAt?:boolean | `@${string}`,
	cents?:boolean | `@${string}`,
	interval?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
items?: [{	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
meta?: [{	filter?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UpcomingUserRecurringPaymentMetadata"]],
itemsByRecurrenceCounter?: [{	by: ValueTypes["UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
itemsByPayments?: [{	by: ValueTypes["UserRecurringPaymentItemsByPaymentsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
itemsByMeta?: [{	by: ValueTypes["UserRecurringPaymentItemsByMetaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
paginateItems?: [{	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	activeSince?:ValueTypes["FieldMeta"],
	cancelledAt?:ValueTypes["FieldMeta"],
	cents?:ValueTypes["FieldMeta"],
	interval?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UpcomingUserRecurringPaymentMetadata"]: AliasType<{
	_meta?:ValueTypes["UpcomingUserRecurringPaymentMetadataMeta"],
	id?:boolean | `@${string}`,
	recurrenceCounter?:boolean | `@${string}`,
	isBehindPayments?:boolean | `@${string}`,
	nextPaymentDate?:boolean | `@${string}`,
	shouldBeProcessed?:boolean | `@${string}`,
firstPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
firstSuccessfulPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
drivingPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
recurringPayment?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["UpcomingUserRecurringPaymentMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	recurrenceCounter?:ValueTypes["FieldMeta"],
	isBehindPayments?:ValueTypes["FieldMeta"],
	nextPaymentDate?:ValueTypes["FieldMeta"],
	shouldBeProcessed?:ValueTypes["FieldMeta"],
	firstPayment?:ValueTypes["FieldMeta"],
	firstSuccessfulPayment?:ValueTypes["FieldMeta"],
	drivingPayment?:ValueTypes["FieldMeta"],
	recurringPayment?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere"]: {
	recurrenceCounter?: number | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemsByPaymentsUniqueWhere"]: {
	payments?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentOrderIdUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	seq?: number | undefined | null | Variable<any, string>
};
	["CsobPaymentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	payId?: string | undefined | null | Variable<any, string>,
	statusChanges?: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CsobPaymentStatusChangeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["CsobPaymentMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["StripePaymentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	statusChanges?: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["StripePaymentMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	userPayment?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemsByMetaUniqueWhere"]: {
	meta?: ValueTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	firstPayment?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	lastPayment?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	recurrenceCounter?: number | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	payments?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UpcomingUserRecurringPaymentMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	firstPayment?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserRecurringPaymentItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemEdge"]: AliasType<{
	node?:ValueTypes["UserRecurringPaymentItem"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMetadata"]: AliasType<{
	_meta?:ValueTypes["UserRecurringPaymentItemMetadataMeta"],
	id?:boolean | `@${string}`,
	isSuccessfullyPaid?:boolean | `@${string}`,
	shouldBeProcessed?:boolean | `@${string}`,
firstPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
lastPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
firstSuccessfulPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
drivingPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
recurringPaymentItem?: [{	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	isSuccessfullyPaid?:ValueTypes["FieldMeta"],
	shouldBeProcessed?:ValueTypes["FieldMeta"],
	firstPayment?:ValueTypes["FieldMeta"],
	lastPayment?:ValueTypes["FieldMeta"],
	firstSuccessfulPayment?:ValueTypes["FieldMeta"],
	drivingPayment?:ValueTypes["FieldMeta"],
	recurringPaymentItem?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemPaymentsByOrderUniqueWhere"]: {
	order?: ValueTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemPaymentsByMetadataUniqueWhere"]: {
	metadata?: ValueTypes["UserPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentEdge"]: AliasType<{
	node?:ValueTypes["UserPayment"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonation"]: AliasType<{
	_meta?:ValueTypes["OnBehalfDonationMeta"],
	id?:boolean | `@${string}`,
	secretCode?:boolean | `@${string}`,
	specificSymbol?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
payments?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
onBehalfOf?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
meta?: [{	filter?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationMetadata"]],
paymentsByOrder?: [{	by: ValueTypes["OnBehalfDonationPaymentsByOrderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByCsobPayment?: [{	by: ValueTypes["OnBehalfDonationPaymentsByCsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByStripePayment?: [{	by: ValueTypes["OnBehalfDonationPaymentsByStripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentsByMetadata?: [{	by: ValueTypes["OnBehalfDonationPaymentsByMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paginatePayments?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	secretCode?:ValueTypes["FieldMeta"],
	specificSymbol?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	payments?:ValueTypes["FieldMeta"],
	onBehalfOf?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMetadata"]: AliasType<{
	_meta?:ValueTypes["OnBehalfDonationMetadataMeta"],
	id?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
onBehalfOfDonation?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
	onBehalfOfDonation?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationPaymentsByOrderUniqueWhere"]: {
	order?: ValueTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationPaymentsByMetadataUniqueWhere"]: {
	metadata?: ValueTypes["UserPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollection"]: AliasType<{
	_meta?:ValueTypes["UserPaymentTriesCollectionMeta"],
	id?:boolean | `@${string}`,
	cents?:boolean | `@${string}`,
	specificSymbol?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	orderUrl?:boolean | `@${string}`,
payment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
onBehalfDonation?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
recurring?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
metadata?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadata"]],
metadataLocales?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocale"]],
	medium?:boolean | `@${string}`,
paymentByOrder?: [{	by: ValueTypes["UserPaymentTriesCollectionPaymentByOrderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentByCsobPayment?: [{	by: ValueTypes["UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentByStripePayment?: [{	by: ValueTypes["UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paymentByMetadata?: [{	by: ValueTypes["UserPaymentTriesCollectionPaymentByMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
metadataLocalesByLocale?: [{	by: ValueTypes["UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocale"]],
paginatePayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentConnection"]],
paginateMetadataLocales?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	cents?:ValueTypes["FieldMeta"],
	specificSymbol?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	orderUrl?:ValueTypes["FieldMeta"],
	payment?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	onBehalfDonation?:ValueTypes["FieldMeta"],
	recurring?:ValueTypes["FieldMeta"],
	metadata?:ValueTypes["FieldMeta"],
	metadataLocales?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadata"]: AliasType<{
	_meta?:ValueTypes["UserPaymentTriesCollectionMetadataMeta"],
	id?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
triesCollection?: [{	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
	triesCollection?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataLocale"]: AliasType<{
	_meta?:ValueTypes["UserPaymentTriesCollectionMetadataLocaleMeta"],
	id?:boolean | `@${string}`,
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
	title?:boolean | `@${string}`,
parent?: [{	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	parent?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	parent?: ValueTypes["UserPaymentTriesCollectionOrderBy"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionPaymentByOrderUniqueWhere"]: {
	order?: ValueTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere"]: {
	csobPayment?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere"]: {
	stripePayment?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionPaymentByMetadataUniqueWhere"]: {
	metadata?: ValueTypes["UserPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionMetadataLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserPaymentTriesCollectionMetadataLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataLocaleEdge"]: AliasType<{
	node?:ValueTypes["UserPaymentTriesCollectionMetadataLocale"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentMetadata"]: AliasType<{
	_meta?:ValueTypes["UserPaymentMetadataMeta"],
	id?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
organizationUnfiltered?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
countToUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
	paymentType?:boolean | `@${string}`,
	statusLabel?:boolean | `@${string}`,
	isSuccessful?:boolean | `@${string}`,
	isFinished?:boolean | `@${string}`,
	needsCacheUpdate?:boolean | `@${string}`,
	isSuccessfulNotCached?:boolean | `@${string}`,
	isFinishedNotCached?:boolean | `@${string}`,
userPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
	organizationUnfiltered?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
	countToUser?:ValueTypes["FieldMeta"],
	paymentType?:ValueTypes["FieldMeta"],
	statusLabel?:ValueTypes["FieldMeta"],
	isSuccessful?:ValueTypes["FieldMeta"],
	isFinished?:ValueTypes["FieldMeta"],
	needsCacheUpdate?:ValueTypes["FieldMeta"],
	isSuccessfulNotCached?:ValueTypes["FieldMeta"],
	isFinishedNotCached?:ValueTypes["FieldMeta"],
	userPayment?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Device"]: AliasType<{
	_meta?:ValueTypes["DeviceMeta"],
	id?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
	fcmToken?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	ipAddress?:boolean | `@${string}`,
	userAgent?:boolean | `@${string}`,
	lastActiveAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DeviceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	fcmToken?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	ipAddress?:ValueTypes["FieldMeta"],
	userAgent?:ValueTypes["FieldMeta"],
	lastActiveAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>,
	fcmToken?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ipAddress?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	userAgent?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationOrderBy"] | undefined | null | Variable<any, string>,
	donationReminderUser?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>,
	scheduledNotification?: ValueTypes["ScheduledNotificationOrderBy"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	topic?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	sentAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	errorMessage?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	errorCode?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isSuccess?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	source?: ValueTypes["ProcessedNotificationSourceOrderBy"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	body?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["UserAreaStats"]: AliasType<{
	_meta?:ValueTypes["UserAreaStatsMeta"],
	id?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
	totalCents?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserAreaStatsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserAreaStatsOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostAreaOrderBy"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>
};
	["UserOrganizationStats"]: AliasType<{
	_meta?:ValueTypes["UserOrganizationStatsMeta"],
	id?:boolean | `@${string}`,
organization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
	totalCents?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserOrganizationStatsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	organization?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserOrganizationStatsOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostOrganizationOrderBy"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>
};
	["UserPostStats"]: AliasType<{
	_meta?:ValueTypes["UserPostStatsMeta"],
	id?:boolean | `@${string}`,
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
	totalCents?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPostStatsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPostStatsOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>
};
	["UserCurrencyStats"]: AliasType<{
	_meta?:ValueTypes["UserCurrencyStatsMeta"],
	id?:boolean | `@${string}`,
currency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
	totalAmountPaymentsOnce?:boolean | `@${string}`,
	totalAmountPaymentsRegular?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserCurrencyStatsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	currency?:ValueTypes["FieldMeta"],
	totalAmountPaymentsOnce?:ValueTypes["FieldMeta"],
	totalAmountPaymentsRegular?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserCurrencyStatsOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["CurrencyOrderBy"] | undefined | null | Variable<any, string>,
	totalAmountPaymentsOnce?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalAmountPaymentsRegular?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>
};
	["UserStats"]: AliasType<{
	_meta?:ValueTypes["UserStatsMeta"],
	id?:boolean | `@${string}`,
	totalPaymentsSuccessful?:boolean | `@${string}`,
	totalPaymentsUnsuccessful?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserStatsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalPaymentsSuccessful?:ValueTypes["FieldMeta"],
	totalPaymentsUnsuccessful?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentsByOrderUniqueWhere"]: {
	order?: ValueTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentsByMetadataUniqueWhere"]: {
	metadata?: ValueTypes["UserPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentsByItemsUniqueWhere"]: {
	items?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentsByMetaUniqueWhere"]: {
	meta?: ValueTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserOnBehalfDonationsBySecretCodeUniqueWhere"]: {
	secretCode?: string | undefined | null | Variable<any, string>
};
	["UserOnBehalfDonationsByPaymentsUniqueWhere"]: {
	payments?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserOnBehalfDonationsByMetaUniqueWhere"]: {
	meta?: ValueTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	onBehalfOfDonation?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	secretCode?: string | undefined | null | Variable<any, string>,
	payments?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserDevicesByFcmTokenUniqueWhere"]: {
	fcmToken?: string | undefined | null | Variable<any, string>
};
	["UserProcessedNotificationsByProcessedNotificationUniqueWhere"]: {
	processedNotification?: ValueTypes["ProcessedNotificationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserRecurringPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentEdge"]: AliasType<{
	node?:ValueTypes["UserRecurringPayment"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OnBehalfDonationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationEdge"]: AliasType<{
	node?:ValueTypes["OnBehalfDonation"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeviceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceEdge"]: AliasType<{
	node?:ValueTypes["Device"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProcessedNotificationSourceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceEdge"]: AliasType<{
	node?:ValueTypes["ProcessedNotificationSource"],
		__typename?: boolean | `@${string}`
}>;
	["UserAreaStatsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserAreaStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserAreaStatsEdge"]: AliasType<{
	node?:ValueTypes["UserAreaStats"],
		__typename?: boolean | `@${string}`
}>;
	["UserOrganizationStatsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserOrganizationStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserOrganizationStatsEdge"]: AliasType<{
	node?:ValueTypes["UserOrganizationStats"],
		__typename?: boolean | `@${string}`
}>;
	["UserPostStatsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserPostStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPostStatsEdge"]: AliasType<{
	node?:ValueTypes["UserPostStats"],
		__typename?: boolean | `@${string}`
}>;
	["UserCurrencyStatsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserCurrencyStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserCurrencyStatsEdge"]: AliasType<{
	node?:ValueTypes["UserCurrencyStats"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere"]: {
	processedNotification?: ValueTypes["ProcessedNotificationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ScheduledNotificationLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleEdge"]: AliasType<{
	node?:ValueTypes["ScheduledNotificationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleGeneralsByRootUniqueWhere"]: {
	root?: ValueTypes["GeneralUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGeneralsBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGeneralsByAppStoreLinkUniqueWhere"]: {
	appStoreLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGeneralsByGooglePlayLinkUniqueWhere"]: {
	googlePlayLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesByRootUniqueWhere"]: {
	root?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostsByRootUniqueWhere"]: {
	root?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostsByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostsBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostAreasByRootUniqueWhere"]: {
	root?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostAreasByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostAreasBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostAreasByBannerUniqueWhere"]: {
	banner?: ValueTypes["AppBannerUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostAreasByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostOrganizationsByRootUniqueWhere"]: {
	root?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostOrganizationsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostOrganizationsByDomainUniqueWhere"]: {
	domain?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostOrganizationsBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostOrganizationsByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHeadersByRootUniqueWhere"]: {
	root?: ValueTypes["HeaderUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHeadersByLinksUniqueWhere"]: {
	links?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByRootUniqueWhere"]: {
	root?: ValueTypes["FooterUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByLinkListUniqueWhere"]: {
	linkList?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByAddressInfoUniqueWhere"]: {
	addressInfo?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByImageLinkListUniqueWhere"]: {
	imageLinkList?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPageAboutSettingsByRootUniqueWhere"]: {
	root?: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere"]: {
	linkGroups?: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostRevisionsByRootUniqueWhere"]: {
	root?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostRevisionsByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostRevisionsBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocalePostRevisionsByLeadContentUniqueWhere"]: {
	leadContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFeedPagesByRootUniqueWhere"]: {
	root?: ValueTypes["FeedPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFeedPagesByHeroTilesUniqueWhere"]: {
	heroTiles?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFeedPagesBySectionListUniqueWhere"]: {
	sectionList?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFeedPagesByCardListUniqueWhere"]: {
	cardList?: ValueTypes["CardListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFeedPagesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleRecurringPaymentPagesByRootUniqueWhere"]: {
	root?: ValueTypes["RecurringPaymentPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere"]: {
	favouritePosts?: ValueTypes["PostListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGivenGiftsPagesByRootUniqueWhere"]: {
	root?: ValueTypes["GivenGiftsPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGivenGiftsPagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGivenGiftsPagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGivenGiftsPagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReceivedGiftsPagesByRootUniqueWhere"]: {
	root?: ValueTypes["ReceivedGiftsPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReceivedGiftsPagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReceivedGiftsPagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReceivedGiftsPagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReportPagesByRootUniqueWhere"]: {
	root?: ValueTypes["ReportPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReportPagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReportPagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReportPagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleReportNavigationsByRootUniqueWhere"]: {
	root?: ValueTypes["ReportNavigationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleScheduledNotificationsByRootUniqueWhere"]: {
	root?: ValueTypes["ScheduledNotificationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleSentPaymentsByRootUniqueWhere"]: {
	root?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GeneralLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleEdge"]: AliasType<{
	node?:ValueTypes["GeneralLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocalesByAppStoreLinkUniqueWhere"]: {
	appStoreLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocalesByGooglePlayLinkUniqueWhere"]: {
	googlePlayLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GeneralEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralEdge"]: AliasType<{
	node?:ValueTypes["General"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationResult"]: AliasType<{
	valid?:boolean | `@${string}`,
	errors?:ValueTypes["_ValidationError"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: boolean | `@${string}`
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: boolean | `@${string}`
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:boolean | `@${string}`,
	alias?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_ValidationMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GeneralCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	allAreasIcon?: ValueTypes["GeneralCreateAllAreasIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	allOrganizationsIcon?: ValueTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["GeneralCreateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GeneralLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GeneralLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	allAreasDescription?: string | undefined | null | Variable<any, string>,
	allOrganizationsDescription?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGeneralsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutGeneralsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateGenericPagesEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateGenericPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	reportNavigation?: Array<ValueTypes["GenericPageCreateReportNavigationEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageCreateReportNavigationEntityRelationInput"]: {
	connect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageConnectOrCreateReportNavigationRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleWithoutPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ReportNavigationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportNavigationWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["ReportNavigationWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportNavigationWithoutLocalesCreateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutReportNavigationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutReportNavigationsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateGeneralsEntityRelationInput"]: {
	connect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateGeneralsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GeneralLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	allAreasDescription?: string | undefined | null | Variable<any, string>,
	allOrganizationsDescription?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["GeneralUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GeneralWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["GeneralWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	allAreasIcon?: ValueTypes["GeneralCreateAllAreasIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	allOrganizationsIcon?: ValueTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["GeneralCreateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralCreateAllAreasIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralConnectOrCreateAllAreasIconRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	width?: number | undefined | null | Variable<any, string>,
	height?: number | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	alt?: string | undefined | null | Variable<any, string>,
	fileName?: string | undefined | null | Variable<any, string>,
	focalPointX?: number | undefined | null | Variable<any, string>,
	focalPointY?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralConnectOrCreateAllAreasIconRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["GeneralCreateAllOrganizationsIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"] | undefined | null | Variable<any, string>
};
	["GeneralConnectOrCreateAllOrganizationsIconRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["GeneralCreateOrganizationListEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralConnectOrCreateOrganizationListRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["PostOrganizationListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostOrganizationListItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationListItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["PostOrganizationListItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemCreateItemEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isHidden?: boolean | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationCreatePostsEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreatePostsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostWithoutOrganizationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostCreateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostCreateAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateAreaRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaWithoutPostsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostAreaCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	region?: ValueTypes["PostAreaCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateIconRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaConnectOrCreateIconRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostAreaCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	shortDescription?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutPostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutPostAreaCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGenericPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutGenericPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreatePostsEntityRelationInput"]: {
	connect?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreatePostsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	paymentName?: string | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	blocks?: Array<ValueTypes["ContentCreateBlocksEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentBlockWithoutContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentConnectOrCreateBlocksRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	references?: Array<ValueTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	contentAlignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isAppsVisible?: boolean | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined | null | Variable<any, string>,
	asideMediaContentLayout?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	isAsideMediaContentMobileLayout?: boolean | undefined | null | Variable<any, string>,
	form?: ValueTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	isTitleBigger?: boolean | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isCentered?: boolean | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ContentReferenceCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateLinkablesEntityRelationInput"]: {
	connect?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>
};
	["VideoUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["VideoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	width?: number | undefined | null | Variable<any, string>,
	height?: number | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	poster?: ValueTypes["VideoCreatePosterEntityRelationInput"] | undefined | null | Variable<any, string>,
	shapeType?: ValueTypes["VideoShapeType"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["VideoConnectOrCreatePosterRelationInput"] | undefined | null | Variable<any, string>
};
	["VideoConnectOrCreatePosterRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
	connect: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["LinkEnum"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	externalLink?: string | undefined | null | Variable<any, string>,
	internalLink?: ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	isTargetBlank?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>
};
	["PostLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	paymentName?: string | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["SeoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	ogTitle?: string | undefined | null | Variable<any, string>,
	ogDescription?: string | undefined | null | Variable<any, string>,
	noIndex?: boolean | undefined | null | Variable<any, string>,
	noFollow?: boolean | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["SeoCreateOgImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined | null | Variable<any, string>
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["PostLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutPostsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreatePostAreasEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreatePostAreasRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	shortDescription?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostAreaCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	region?: ValueTypes["PostAreaCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaCreateRegionListOverrideEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	regions?: Array<ValueTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	donation?: ValueTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListCreateRegionsEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	region?: ValueTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimumAmount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountItemWithoutRegionItemCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["DonationAmountItemWithoutRegionItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	amount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationAmountItemWithoutRegionItemCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionItemCreateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionWithoutDonationItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>
};
	["RegionWithoutDonationItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["RegionCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	enabledPaymentMethods?: Array<ValueTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	timezone?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionCreateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RegionConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["CurrencyUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	organizationCurrencySums?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	postCurrencySums?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CurrencyCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	sign?: string | undefined | null | Variable<any, string>,
	signAlignment?: ValueTypes["CurrencySignAlignment"] | undefined | null | Variable<any, string>,
	defaultDonationAmount?: number | undefined | null | Variable<any, string>,
	rateAgainstCzk?: number | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["CurrencyCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postCurrencySums?: Array<ValueTypes["CurrencyCreatePostCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CurrencyCreateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CurrencyCreatePostCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RegionConnectOrCreateCurrencyRelationInput"]: {
	connect: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["RegionCreateEnabledPaymentMethodsEntityRelationInput"]: {
	connect?: ValueTypes["RegionPaymentMethodUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionPaymentMethodWithoutRegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RegionPaymentMethodWithoutRegionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	allowRecurringPayments?: boolean | undefined | null | Variable<any, string>,
	method?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"]: {
	connect: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RegionPaymentMethodWithoutRegionCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"]: {
	connect: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RegionWithoutDonationItemsCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"]: {
	connect: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionItemWithoutListCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionListCreateDonationEntityRelationInput"]: {
	connect?: ValueTypes["DonationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationWithoutRegionListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"] | undefined | null | Variable<any, string>
};
	["DonationWithoutRegionListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListConnectOrCreateDonationRelationInput"]: {
	connect: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationWithoutRegionListCreateInput"] | Variable<any, string>
};
	["PostAreaConnectOrCreateRegionListOverrideRelationInput"]: {
	connect: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>
};
	["PostAreaCreatePostsEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreatePostsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostWithoutAreaCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostCreateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostCreateOrganizationEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateOrganizationRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationWithoutPostsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isHidden?: boolean | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateIconRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationConnectOrCreateIconRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutPostOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutPostOrganizationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreatePostAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreatePostAreaRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	shortDescription?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutPostAreasCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutPostAreasCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreatePostOrganizationsEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreatePostOrganizationsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isHidden?: boolean | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationCreateAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateAreaRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostAreaCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	region?: ValueTypes["PostAreaCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaCreateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>
};
	["RegionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["RegionCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	enabledPaymentMethods?: Array<ValueTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	donationItems?: Array<ValueTypes["RegionCreateDonationItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	timezone?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionCreateDonationItemsEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RegionConnectOrCreateDonationItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemWithoutRegionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimumAmount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListWithoutRegionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	donation?: ValueTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | Variable<any, string>
};
	["RegionConnectOrCreateDonationItemsRelationInput"]: {
	connect: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | Variable<any, string>
};
	["PostAreaConnectOrCreateRegionRelationInput"]: {
	connect: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["PostAreaCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaMetaDataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaCreateMobileHeroImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaConnectOrCreateMobileHeroImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostAreaCreatePlainIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreatePlainIconRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaConnectOrCreatePlainIconRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostAreaCreateSentPaymentsEntityRelationInput"]: {
	connect?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SentPaymentWithoutAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SentPaymentWithoutAreaCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["SentPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["SentPaymentCreateOrganizationEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentConnectOrCreateOrganizationRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationWithoutSentPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isHidden?: boolean | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationMetaDataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostOrganizationCreateMobileHeroImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationCreatePlainIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationConnectOrCreatePlainIconRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationCreateDesktopHeroImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationCreateOrganizationSumEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationSumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SentPaymentConnectOrCreateOrganizationRelationInput"]: {
	connect: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | Variable<any, string>
};
	["SentPaymentCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SentPaymentLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organizationText?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutSentPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutSentPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateHeadersEntityRelationInput"]: {
	connect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateHeadersRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["HeaderUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeaderWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["HeaderWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HeaderCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["HeaderCreateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["HeaderConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HeaderCreateOrganizationListEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateOrganizationListRelationInput"] | undefined | null | Variable<any, string>
};
	["HeaderConnectOrCreateOrganizationListRelationInput"]: {
	connect: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeaderWithoutLocalesCreateInput"] | Variable<any, string>
};
	["HeaderLocaleCreateLinksEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLinksRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["LinkListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["LinkItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LinkItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkItemConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LinkListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkItemWithoutListCreateInput"] | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateLinksRelationInput"]: {
	connect: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkListCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateHeadersRelationInput"]: {
	connect: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateFootersEntityRelationInput"]: {
	connect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateFootersRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	contactEmail?: string | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["FooterUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["FooterCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["FooterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FooterWithoutLocalesCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateLinkListEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateLinkListRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateLinkListRelationInput"]: {
	connect: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkListCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateAddressInfoEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateAddressInfoRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateImageLinkListEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageLinkListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["ImageLinkListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ImageLinkItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["ImageLinkItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkItemCreateItemEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageLinkUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["ImageLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageLinkCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["ImageLinkCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageLinkConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ImageLinkCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageLinkConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["ImageLinkItemConnectOrCreateItemRelationInput"]: {
	connect: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageLinkCreateInput"] | Variable<any, string>
};
	["ImageLinkListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageLinkItemWithoutListCreateInput"] | Variable<any, string>
};
	["FooterLocaleConnectOrCreateImageLinkListRelationInput"]: {
	connect: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateFootersRelationInput"]: {
	connect: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkGroups?: Array<ValueTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"]: {
	connect: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkListCreateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"]: {
	connect: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"]: {
	connect: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreatePostRevisionsEntityRelationInput"]: {
	connect?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreatePostRevisionsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostRevisionLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishNotificationText?: string | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostRevisionWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	createdById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	publishedById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostRevisionCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileImage?: ValueTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileVideo?: ValueTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroImage?: ValueTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	isOrganizationVisible?: boolean | undefined | null | Variable<any, string>,
	sendPublishNotifications?: boolean | undefined | null | Variable<any, string>,
	isArchived?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionCreatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutRevisionsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>
};
	["PostWithoutRevisionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostCreateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostCreateActiveRevisionEntityRelationInput"]: {
	connect?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostRevisionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateActiveRevisionRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	createdById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	publishedById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostRevisionCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileImage?: ValueTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileVideo?: ValueTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroImage?: ValueTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostRevisionCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	isOrganizationVisible?: boolean | undefined | null | Variable<any, string>,
	sendPublishNotifications?: boolean | undefined | null | Variable<any, string>,
	isArchived?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionCreateTileImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateTileImageRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionConnectOrCreateTileImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostRevisionCreateTileVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateTileVideoRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionConnectOrCreateTileVideoRelationInput"]: {
	connect: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["PostRevisionCreateHeroImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateHeroImageRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionConnectOrCreateHeroImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostRevisionCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostRevisionLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishNotificationText?: string | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutPostRevisionsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutPostRevisionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateFlagImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateFlagImageRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleConnectOrCreateFlagImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleCreateFeedPagesEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateFeedPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FeedPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined | null | Variable<any, string>,
	sectionList?: Array<ValueTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["FeedPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FeedPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleCreateHeroTilesEntityRelationInput"]: {
	connect?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TileListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"] | undefined | null | Variable<any, string>
};
	["TileListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["TileListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaType?: ValueTypes["TileListCreateAreaTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["TileItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TileItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TileItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	type?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	post?: ValueTypes["TileItemCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["TileItemCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["TileItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["TileItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["TileItemCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileItemCreatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>
};
	["PostCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostCreateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostCreateRevisionsEntityRelationInput"]: {
	connect?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostRevisionWithoutPostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateRevisionsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostRevisionWithoutPostCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	createdById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	publishedById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	tileImage?: ValueTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileVideo?: ValueTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroImage?: ValueTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostRevisionCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	isOrganizationVisible?: boolean | undefined | null | Variable<any, string>,
	sendPublishNotifications?: boolean | undefined | null | Variable<any, string>,
	isArchived?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionCreateRegionListOverrideEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionConnectOrCreateRegionListOverrideRelationInput"]: {
	connect: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>
};
	["PostConnectOrCreateRevisionsRelationInput"]: {
	connect: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostRevisionWithoutPostCreateInput"] | Variable<any, string>
};
	["PostCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	paymentName?: string | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutPostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutPostCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreatePostOrganizationEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreatePostOrganizationRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutPostOrganizationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutPostOrganizationsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateRecurringPaymentPagesEntityRelationInput"]: {
	connect?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["RecurringPaymentPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"]: {
	connect?: ValueTypes["PostListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"] | undefined | null | Variable<any, string>
};
	["PostListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["PostListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["PostListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostListItemCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListItemCreatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostListItemConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>
};
	["PostListItemConnectOrCreatePostRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostCreateInput"] | Variable<any, string>
};
	["PostListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostListItemWithoutListCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"]: {
	connect: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostListCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined | null | Variable<any, string>
};
	["StoryGuideListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["StoryGuideListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["StoryGuideItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	guide?: ValueTypes["StoryGuideItemCreateGuideEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideItemCreateGuideEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideItemConnectOrCreateGuideRelationInput"] | undefined | null | Variable<any, string>
};
	["StoryGuideUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["StoryGuideCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	mediaType?: ValueTypes["MediaType"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["StoryGuideCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	secondaryImage?: ValueTypes["StoryGuideCreateSecondaryImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["StoryGuideConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["StoryGuideCreateSecondaryImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"] | undefined | null | Variable<any, string>
};
	["StoryGuideConnectOrCreateSecondaryImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["StoryGuideItemConnectOrCreateGuideRelationInput"]: {
	connect: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StoryGuideCreateInput"] | Variable<any, string>
};
	["StoryGuideListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StoryGuideItemWithoutListCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"]: {
	connect: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"]: {
	connect: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateGivenGiftsPagesEntityRelationInput"]: {
	connect?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateGivenGiftsPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["GivenGiftsPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GivenGiftsPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GivenGiftsPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutGivenGiftsPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutGivenGiftsPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreateReportPageEntityRelationInput"]: {
	connect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateReportPageRelationInput"] | undefined | null | Variable<any, string>
};
	["ReportPageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ReportPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["ReportPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutReportPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutReportPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateReceivedGiftsPagesEntityRelationInput"]: {
	connect?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutReceivedGiftsPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreateGivenGiftsPageEntityRelationInput"]: {
	connect?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"] | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutGivenGiftsPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateReportPagesEntityRelationInput"]: {
	connect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateReportPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutReportPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutReportPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreateReceivedGiftsPageEntityRelationInput"]: {
	connect?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ReceivedGiftsPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutReceivedGiftsPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateReportNavigationsEntityRelationInput"]: {
	connect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateReportNavigationsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	pages?: Array<ValueTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleCreatePagesEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageWithoutReportNavigationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportNavigationLocaleConnectOrCreatePagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageWithoutReportNavigationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	type?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutGenericPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutGenericPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutGenericPageCreateInput"] | Variable<any, string>
};
	["GenericPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleConnectOrCreatePagesRelationInput"]: {
	connect: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageWithoutReportNavigationCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateReportNavigationsRelationInput"]: {
	connect: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateScheduledNotificationsEntityRelationInput"]: {
	connect?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateScheduledNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ScheduledNotificationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ScheduledNotificationWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	localMsFromMidnight?: number | undefined | null | Variable<any, string>,
	scheduledDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	internalTitle?: string | undefined | null | Variable<any, string>,
	target?: ValueTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationCreateTargetEntityRelationInput"]: {
	connect?: ValueTypes["NotificationTargetGroupUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["NotificationTargetGroupCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"] | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["NotificationTargetType"] | undefined | null | Variable<any, string>,
	regions?: Array<ValueTypes["NotificationTargetGroupCreateRegionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupCreateRegionsEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["NotificationTargetGroupConnectOrCreateRegionsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupConnectOrCreateRegionsRelationInput"]: {
	connect: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationConnectOrCreateTargetRelationInput"]: {
	connect: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["NotificationTargetGroupCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]: {
	connect?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	donationReminderUser?: ValueTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"]: {
	connect?: ValueTypes["ProcessedNotificationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ProcessedNotificationWithoutSourceCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationWithoutSourceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	topic?: string | undefined | null | Variable<any, string>,
	sentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	errorMessage?: string | undefined | null | Variable<any, string>,
	errorCode?: string | undefined | null | Variable<any, string>,
	isSuccess?: boolean | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	body?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"]: {
	connect: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ProcessedNotificationWithoutSourceCreateInput"] | Variable<any, string>
};
	["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutProcessedNotificationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"] | undefined | null | Variable<any, string>
};
	["UserUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	payments?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	recurringPayments?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	onBehalfDonations?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	devices?: ValueTypes["DeviceUniqueWhere"] | undefined | null | Variable<any, string>,
	processedNotifications?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	areaStats?: ValueTypes["UserAreaStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	organizationStats?: ValueTypes["UserOrganizationStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	postStats?: ValueTypes["UserPostStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	currencyStats?: ValueTypes["UserCurrencyStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	stats?: ValueTypes["UserStatsUniqueWhere"] | undefined | null | Variable<any, string>
};
	["DeviceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	fcmToken?: string | undefined | null | Variable<any, string>
};
	["UserAreaStatsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["UserOrganizationStatsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["UserPostStatsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["UserCurrencyStatsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["UserStatsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserWithoutProcessedNotificationsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserCreatePaymentsEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentWithoutUserCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreatePaymentsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserPaymentWithoutUserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["UserPaymentCreateOrderEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentOrderIdCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateOrderRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentOrderIdCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	seq?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentConnectOrCreateOrderRelationInput"]: {
	connect: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserPaymentOrderIdCreateInput"] | Variable<any, string>
};
	["UserPaymentCreateCsobPaymentEntityRelationInput"]: {
	connect?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CsobPaymentWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"] | undefined | null | Variable<any, string>
};
	["CsobPaymentWithoutPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	payId?: string | undefined | null | Variable<any, string>,
	statusChanges?: Array<ValueTypes["CsobPaymentCreateStatusChangesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	originalPayId?: string | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentCreateStatusChangesEntityRelationInput"]: {
	connect?: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CsobPaymentConnectOrCreateStatusChangesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CsobPaymentStatusChangeWithoutPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	dttm?: string | undefined | null | Variable<any, string>,
	status?: number | undefined | null | Variable<any, string>,
	resultCode?: number | undefined | null | Variable<any, string>,
	message?: string | undefined | null | Variable<any, string>,
	authCode?: string | undefined | null | Variable<any, string>,
	statusDetail?: string | undefined | null | Variable<any, string>,
	actions?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentConnectOrCreateStatusChangesRelationInput"]: {
	connect: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | Variable<any, string>
};
	["CsobPaymentCreateMetadataEntityRelationInput"]: {
	connect?: ValueTypes["CsobPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentConnectOrCreateCsobPaymentRelationInput"]: {
	connect: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CsobPaymentWithoutPaymentCreateInput"] | Variable<any, string>
};
	["UserPaymentCreateStripePaymentEntityRelationInput"]: {
	connect?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StripePaymentWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"] | undefined | null | Variable<any, string>
};
	["StripePaymentWithoutPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	statusChanges?: Array<ValueTypes["StripePaymentCreateStatusChangesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentCreateStatusChangesEntityRelationInput"]: {
	connect?: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StripePaymentConnectOrCreateStatusChangesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangeWithoutPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	timestamp?: number | undefined | null | Variable<any, string>,
	eventId?: string | undefined | null | Variable<any, string>,
	paymentIntentStatus?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentConnectOrCreateStatusChangesRelationInput"]: {
	connect: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | Variable<any, string>
};
	["StripePaymentCreateMetadataEntityRelationInput"]: {
	connect?: ValueTypes["StripePaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentConnectOrCreateStripePaymentRelationInput"]: {
	connect: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StripePaymentWithoutPaymentCreateInput"] | Variable<any, string>
};
	["UserPaymentCreateRecurringPaymentItemEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemWithoutPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	recurrenceCounter?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	taskId?: string | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	isFailed?: boolean | undefined | null | Variable<any, string>,
	failedEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserRecurringPaymentWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	activeSince?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cancelledAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	interval?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserRecurringPaymentCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["UserRecurringPaymentCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutRecurringPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>
};
	["UserWithoutRecurringPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserCreateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>
};
	["UserConnectOrCreateRegionRelationInput"]: {
	connect: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["UserCreateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["UserConnectOrCreateCurrencyRelationInput"]: {
	connect: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["UserCreateOnBehalfDonationsEntityRelationInput"]: {
	connect?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateOnBehalfDonationsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["OnBehalfDonationWithoutOnBehalfOfCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	secretCode?: string | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["OnBehalfDonationCreatePaymentsEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["OnBehalfDonationConnectOrCreatePaymentsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserPaymentWithoutOnBehalfDonationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentCreateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentConnectOrCreateRegionRelationInput"]: {
	connect: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["UserPaymentCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>
};
	["UserWithoutPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserCreateRecurringPaymentsEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserRecurringPaymentWithoutUserCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateRecurringPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentWithoutUserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	activeSince?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cancelledAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	interval?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["UserRecurringPaymentCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserRecurringPaymentConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	recurrenceCounter?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	taskId?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isFailed?: boolean | undefined | null | Variable<any, string>,
	failedEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserPaymentWithoutRecurringPaymentItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentCreateOnBehalfDonationEntityRelationInput"]: {
	connect?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationWithoutPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	secretCode?: string | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	onBehalfOf?: ValueTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutOnBehalfDonationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"] | undefined | null | Variable<any, string>
};
	["UserWithoutOnBehalfDonationsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateSentPaymentsEntityRelationInput"]: {
	connect?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organizationText?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["SentPaymentLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SentPaymentWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["SentPaymentWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentCreateAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaWithoutSentPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentConnectOrCreateAreaRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaWithoutSentPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostAreaCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	region?: ValueTypes["PostAreaCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaCreateAreaSentPaymentSumEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostAreaCreateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaCreateAreaSumEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaSumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SentPaymentConnectOrCreateAreaRelationInput"]: {
	connect: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaWithoutSentPaymentsCreateInput"] | Variable<any, string>
};
	["SentPaymentLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SentPaymentWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["UserConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleCreateInput"] | Variable<any, string>
};
	["UserCreateDevicesEntityRelationInput"]: {
	connect?: ValueTypes["DeviceUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DeviceWithoutUserCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateDevicesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["DeviceWithoutUserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	fcmToken?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	ipAddress?: string | undefined | null | Variable<any, string>,
	userAgent?: string | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserConnectOrCreateDevicesRelationInput"]: {
	connect: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DeviceWithoutUserCreateInput"] | Variable<any, string>
};
	["UserCreateProcessedNotificationsEntityRelationInput"]: {
	connect?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateProcessedNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	scheduledNotification?: ValueTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"]: {
	connect?: ValueTypes["ScheduledNotificationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"] | undefined | null | Variable<any, string>
};
	["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	localMsFromMidnight?: number | undefined | null | Variable<any, string>,
	scheduledDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	internalTitle?: string | undefined | null | Variable<any, string>,
	target?: ValueTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ScheduledNotificationCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	image?: ValueTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutScheduledNotificationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutScheduledNotificationsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutScheduledNotificationsCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"]: {
	connect: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | Variable<any, string>
};
	["UserConnectOrCreateProcessedNotificationsRelationInput"]: {
	connect: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | Variable<any, string>
};
	["UserCreateAreaStatsEntityRelationInput"]: {
	connect?: ValueTypes["UserAreaStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserCreateOrganizationStatsEntityRelationInput"]: {
	connect?: ValueTypes["UserOrganizationStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserCreatePostStatsEntityRelationInput"]: {
	connect?: ValueTypes["UserPostStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserCreateCurrencyStatsEntityRelationInput"]: {
	connect?: ValueTypes["UserCurrencyStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"]: {
	connect: ValueTypes["UserUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserWithoutOnBehalfDonationsCreateInput"] | Variable<any, string>
};
	["OnBehalfDonationCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"]: {
	connect: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | Variable<any, string>
};
	["UserPaymentCreateTriesCollectionEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentTriesCollectionMetadataUniqueWhere"] | undefined | null | Variable<any, string>,
	metadataLocales?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	parent?: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionWithoutPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	orderUrl?: string | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurring?: ValueTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"] | undefined | null | Variable<any, string>,
	metadataLocales?: Array<ValueTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	medium?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>
};
	["UserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"]: {
	connect: ValueTypes["UserUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"]: {
	connect: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"]: {
	connect?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["OnBehalfDonationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"] | undefined | null | Variable<any, string>
};
	["OnBehalfDonationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	secretCode?: string | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	onBehalfOf?: ValueTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"]: {
	connect: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["OnBehalfDonationCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserRecurringPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	activeSince?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cancelledAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	interval?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["UserRecurringPaymentCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserRecurringPaymentCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"]: {
	connect: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserPaymentConnectOrCreateTriesCollectionRelationInput"]: {
	connect: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | Variable<any, string>
};
	["UserPaymentCreateMetadataEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"]: {
	connect: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | Variable<any, string>
};
	["UserRecurringPaymentItemCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | Variable<any, string>
};
	["UserConnectOrCreateRecurringPaymentsRelationInput"]: {
	connect: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentWithoutUserCreateInput"] | Variable<any, string>
};
	["UserPaymentConnectOrCreateUserRelationInput"]: {
	connect: ValueTypes["UserUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserWithoutPaymentsCreateInput"] | Variable<any, string>
};
	["OnBehalfDonationConnectOrCreatePaymentsRelationInput"]: {
	connect: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | Variable<any, string>
};
	["UserConnectOrCreateOnBehalfDonationsRelationInput"]: {
	connect: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | Variable<any, string>
};
	["UserRecurringPaymentConnectOrCreateUserRelationInput"]: {
	connect: ValueTypes["UserUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserWithoutRecurringPaymentsCreateInput"] | Variable<any, string>
};
	["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"]: {
	connect: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentWithoutItemsCreateInput"] | Variable<any, string>
};
	["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"]: {
	connect: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | Variable<any, string>
};
	["UserConnectOrCreatePaymentsRelationInput"]: {
	connect: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutUserCreateInput"] | Variable<any, string>
};
	["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"]: {
	connect: ValueTypes["UserUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserWithoutProcessedNotificationsCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"]: {
	connect: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ScheduledNotificationWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateScheduledNotificationsRelationInput"]: {
	connect: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateReceivedGiftsPageRelationInput"]: {
	connect: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutReportPageCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["ReportPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["ReportPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleCreatePostsEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutReportPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreatePostsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostWithoutReportPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostCreateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["PostMetaDataUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostCreateHeroCarouselEntityRelationInput"]: {
	connect?: ValueTypes["HeroCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeroCarouselWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateHeroCarouselRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeroCarouselUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["HeroCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeroCarouselItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["HeroCarouselWithoutPostsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["HeroCarouselCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["HeroCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeroCarouselItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeroCarouselConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeroCarouselItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["HeroCarouselItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselItemCreateItemEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeroCarouselItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>
};
	["HeroCarouselItemConnectOrCreateItemRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostCreateInput"] | Variable<any, string>
};
	["HeroCarouselConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeroCarouselItemWithoutListCreateInput"] | Variable<any, string>
};
	["PostConnectOrCreateHeroCarouselRelationInput"]: {
	connect: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeroCarouselWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentReferenceWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentReferenceWithoutPostsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	contentAlignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isAppsVisible?: boolean | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined | null | Variable<any, string>,
	asideMediaContentLayout?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	isAsideMediaContentMobileLayout?: boolean | undefined | null | Variable<any, string>,
	form?: ValueTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	isTitleBigger?: boolean | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isCentered?: boolean | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentWithoutBlocksCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentWithoutBlocksCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentWithoutBlocksCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
	connect: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateValueListEntityRelationInput"]: {
	connect?: ValueTypes["ValueListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ValueListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateValueListRelationInput"] | undefined | null | Variable<any, string>
};
	["ValueListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["ValueListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ValueItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ValueItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ValueListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ValueItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["ValueItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueItemCreateItemEntityRelationInput"]: {
	connect?: ValueTypes["ValueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ValueCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ValueItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>
};
	["ValueUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ValueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["ValueCreateTextContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueCreateTextContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ValueConnectOrCreateTextContentRelationInput"] | undefined | null | Variable<any, string>
};
	["ValueConnectOrCreateTextContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["ValueItemConnectOrCreateItemRelationInput"]: {
	connect: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ValueCreateInput"] | Variable<any, string>
};
	["ValueListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ValueItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateValueListRelationInput"]: {
	connect: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ValueListCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateImageLinkListEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateImageLinkListRelationInput"]: {
	connect: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateAreaListEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateAreaListRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["PostAreaListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostAreaListItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListItemCreateItemEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaListItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaListItemConnectOrCreateItemRelationInput"]: {
	connect: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>
};
	["PostAreaListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaListItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateAreaListRelationInput"]: {
	connect: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaListCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateAccordionEntityRelationInput"]: {
	connect?: ValueTypes["AccordionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["AccordionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateAccordionRelationInput"] | undefined | null | Variable<any, string>
};
	["AccordionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["AccordionCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AccordionCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["AccordionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["AccordionItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AccordionConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["AccordionItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["AccordionItemCreateDescriptionContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AccordionItemCreateDescriptionContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"] | undefined | null | Variable<any, string>
};
	["AccordionItemConnectOrCreateDescriptionContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["AccordionConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["AccordionItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateAccordionRelationInput"]: {
	connect: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["AccordionCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["MediumListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["MediumItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumItemCreateMediumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemCreateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["MediumCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["MediumCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["MediumCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumConnectOrCreateVideoRelationInput"]: {
	connect: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["MediumItemConnectOrCreateMediumRelationInput"]: {
	connect: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumCreateInput"] | Variable<any, string>
};
	["MediumListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateMediaRelationInput"]: {
	connect: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateMemberListEntityRelationInput"]: {
	connect?: ValueTypes["MemberListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MemberListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateMemberListRelationInput"] | undefined | null | Variable<any, string>
};
	["MemberListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["MemberListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MemberListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["MemberListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MemberListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MemberListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["MemberListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	position?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["MemberListItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["MemberListItemCreateDescriptionContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MemberListItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MemberListItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["MemberListItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["MemberListItemCreateDescriptionContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"] | undefined | null | Variable<any, string>
};
	["MemberListItemConnectOrCreateDescriptionContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["MemberListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MemberListItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateMemberListRelationInput"]: {
	connect: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MemberListCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateFormEntityRelationInput"]: {
	connect?: ValueTypes["FormUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FormCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateFormRelationInput"] | undefined | null | Variable<any, string>
};
	["FormUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tax?: ValueTypes["FilledTaxFormUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FilledTaxFormUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["FormCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["FormType"] | undefined | null | Variable<any, string>,
	tax?: ValueTypes["FormCreateTaxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FormCreateTaxEntityRelationInput"]: {
	connect?: ValueTypes["FilledTaxFormUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FilledTaxFormCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FormConnectOrCreateTaxRelationInput"] | undefined | null | Variable<any, string>
};
	["FilledTaxFormCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	userId?: string | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	vatId?: string | undefined | null | Variable<any, string>,
	address1?: string | undefined | null | Variable<any, string>,
	address2?: string | undefined | null | Variable<any, string>,
	city?: string | undefined | null | Variable<any, string>,
	postalCode?: string | undefined | null | Variable<any, string>,
	state?: string | undefined | null | Variable<any, string>,
	country?: ValueTypes["FilledTaxFormCreateCountryEntityRelationInput"] | undefined | null | Variable<any, string>,
	dateFrom?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	dateTo?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	year?: number | undefined | null | Variable<any, string>,
	isPdfGenerated?: boolean | undefined | null | Variable<any, string>,
	pdfObjectKey?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FilledTaxFormCreateCountryEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FilledTaxFormConnectOrCreateCountryRelationInput"] | undefined | null | Variable<any, string>
};
	["FilledTaxFormConnectOrCreateCountryRelationInput"]: {
	connect: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["FormConnectOrCreateTaxRelationInput"]: {
	connect: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FilledTaxFormCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateFormRelationInput"]: {
	connect: ValueTypes["FormUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FormCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateHeroCarouselEntityRelationInput"]: {
	connect?: ValueTypes["HeroCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeroCarouselCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"] | undefined | null | Variable<any, string>
};
	["HeroCarouselCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["HeroCarouselCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["HeroCarouselCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselCreatePostsEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutHeroCarouselCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeroCarouselConnectOrCreatePostsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostWithoutHeroCarouselCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostCreateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostCreateReportPageEntityRelationInput"]: {
	connect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportPageLocaleWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateReportPageRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportPageLocaleWithoutPostsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostConnectOrCreateReportPageRelationInput"]: {
	connect: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportPageLocaleWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostCreateFundraiseCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["PostConnectOrCreateFundraiseCurrencyRelationInput"]: {
	connect: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["PostCreateFundraiseCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostCreateFundraiseSumEntityRelationInput"]: {
	connect?: ValueTypes["PostSumUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PostCreateFundraisingProgressEntityRelationInput"]: {
	connect?: ValueTypes["PostFundraisingProgressUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeroCarouselConnectOrCreatePostsRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostWithoutHeroCarouselCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateHeroCarouselRelationInput"]: {
	connect: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeroCarouselCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateOrganizationListEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateOrganizationListRelationInput"]: {
	connect: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateTextImageListEntityRelationInput"]: {
	connect?: ValueTypes["TextImageListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextImageListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"] | undefined | null | Variable<any, string>
};
	["TextImageListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["TextImageListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["TextImageListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextImageListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextImageListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TextImageListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	image?: ValueTypes["TextImageListItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["TextImageListItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextImageListItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["TextImageListItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["TextImageListItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextImageListItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["TextImageListItemConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["TextImageListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TextImageListItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateTextImageListRelationInput"]: {
	connect: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TextImageListCreateInput"] | Variable<any, string>
};
	["PostConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentReferenceWithoutPostsCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleConnectOrCreatePostsRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostWithoutReportPageCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateReportPagesRelationInput"]: {
	connect: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateGivenGiftsPageRelationInput"]: {
	connect: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"]: {
	connect: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutReportPagesCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateReportPageRelationInput"]: {
	connect: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutGivenGiftsPageCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateGivenGiftsPagesRelationInput"]: {
	connect: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutPostOrganizationsCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleCreateDomainEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleConnectOrCreateDomainRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreatePostOrganizationRelationInput"]: {
	connect: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["PostLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutPostCreateInput"] | Variable<any, string>
};
	["PostConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["TileItemConnectOrCreatePostRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostCreateInput"] | Variable<any, string>
};
	["TileItemCreateAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateAreaRelationInput"] | undefined | null | Variable<any, string>
};
	["TileItemConnectOrCreateAreaRelationInput"]: {
	connect: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>
};
	["TileItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["TileItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["TileItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["TileItemConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["TileItemCreateOrganizationEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateOrganizationRelationInput"] | undefined | null | Variable<any, string>
};
	["TileItemConnectOrCreateOrganizationRelationInput"]: {
	connect: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>
};
	["TileListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TileItemWithoutListCreateInput"] | Variable<any, string>
};
	["TileListCreateAreaTypeEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileListConnectOrCreateAreaTypeRelationInput"] | undefined | null | Variable<any, string>
};
	["TileListConnectOrCreateAreaTypeRelationInput"]: {
	connect: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"]: {
	connect: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TileListCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleCreateSectionListEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateSectionListRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FeedPageSectionWithoutFeedPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	tileStripeList?: Array<ValueTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageSectionCreateTileStripeListEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageTileStripeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageTileStripeWithoutSectionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageSectionConnectOrCreateTileStripeListRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeWithoutSectionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	tileList?: ValueTypes["FeedPageTileStripeCreateTileListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeCreateTileListEntityRelationInput"]: {
	connect?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TileListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"] | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeConnectOrCreateTileListRelationInput"]: {
	connect: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TileListCreateInput"] | Variable<any, string>
};
	["FeedPageSectionConnectOrCreateTileStripeListRelationInput"]: {
	connect: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FeedPageTileStripeWithoutSectionCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleConnectOrCreateSectionListRelationInput"]: {
	connect: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleCreateCardListEntityRelationInput"]: {
	connect?: ValueTypes["CardListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CardListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"] | undefined | null | Variable<any, string>
};
	["CardListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["CardListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CardListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["CardItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CardItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CardListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CardItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["CardItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CardItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CardItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["CardItemConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["CardListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CardItemWithoutListCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleConnectOrCreateCardListRelationInput"]: {
	connect: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CardListCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleCreateStoryGuideListEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined | null | Variable<any, string>
};
	["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"]: {
	connect: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateFeedPagesRelationInput"]: {
	connect: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FeedPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutPostRevisionsCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleCreateLeadContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"] | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["PostRevisionConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostRevisionLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["PostConnectOrCreateActiveRevisionRelationInput"]: {
	connect: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostRevisionCreateInput"] | Variable<any, string>
};
	["PostRevisionConnectOrCreatePostRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostWithoutRevisionsCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostRevisionWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreatePostRevisionsRelationInput"]: {
	connect: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["SentPaymentLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutSentPaymentsCreateInput"] | Variable<any, string>
};
	["SentPaymentConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SentPaymentLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["PostAreaConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SentPaymentWithoutAreaCreateInput"] | Variable<any, string>
};
	["PostOrganizationConnectOrCreateAreaRelationInput"]: {
	connect: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>
};
	["PostOrganizationCreateSentPaymentsEntityRelationInput"]: {
	connect?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SentPaymentWithoutOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SentPaymentWithoutOrganizationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SentPaymentWithoutOrganizationCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreatePostOrganizationsRelationInput"]: {
	connect: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutPostAreasCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleCreateBannerEntityRelationInput"]: {
	connect?: ValueTypes["AppBannerUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["AppBannerCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"] | undefined | null | Variable<any, string>
};
	["AppBannerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	imageSmall?: ValueTypes["AppBannerCreateImageSmallEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageBig?: ValueTypes["AppBannerCreateImageBigEntityRelationInput"] | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["AppBannerCreateTextContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AppBannerCreateImageSmallEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AppBannerConnectOrCreateImageSmallRelationInput"] | undefined | null | Variable<any, string>
};
	["AppBannerConnectOrCreateImageSmallRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["AppBannerCreateImageBigEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AppBannerConnectOrCreateImageBigRelationInput"] | undefined | null | Variable<any, string>
};
	["AppBannerConnectOrCreateImageBigRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["AppBannerCreateTextContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AppBannerConnectOrCreateTextContentRelationInput"] | undefined | null | Variable<any, string>
};
	["AppBannerConnectOrCreateTextContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleConnectOrCreateBannerRelationInput"]: {
	connect: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["AppBannerCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreatePostAreaRelationInput"]: {
	connect: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutPostOrganizationCreateInput"] | Variable<any, string>
};
	["PostOrganizationConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["PostConnectOrCreateOrganizationRelationInput"]: {
	connect: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostAreaConnectOrCreatePostsRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostWithoutAreaCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreatePostAreasRelationInput"]: {
	connect: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["PostLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["PostWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostCreateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreatePostRelationInput"]: {
	connect: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["LinkConnectOrCreateInternalLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreatePostsEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreatePostsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostWithoutContentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreatePostsRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostWithoutContentCreateInput"] | Variable<any, string>
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
	connect: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | Variable<any, string>
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
	connect: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentBlockWithoutContentCreateInput"] | Variable<any, string>
};
	["PostLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreatePostsRelationInput"]: {
	connect: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGenericPagesCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
	connect: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutPostAreaCreateInput"] | Variable<any, string>
};
	["PostAreaConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["PostConnectOrCreateAreaRelationInput"]: {
	connect: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostOrganizationConnectOrCreatePostsRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostWithoutOrganizationCreateInput"] | Variable<any, string>
};
	["PostOrganizationListItemConnectOrCreateItemRelationInput"]: {
	connect: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>
};
	["PostOrganizationListItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["PostOrganizationListItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListItemWithoutListCreateInput"] | Variable<any, string>
};
	["GeneralConnectOrCreateOrganizationListRelationInput"]: {
	connect: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GeneralWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GeneralLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GeneralLocaleCreateAppStoreLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateGeneralsRelationInput"]: {
	connect: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutReportNavigationsCreateInput"] | Variable<any, string>
};
	["GenericPageConnectOrCreateReportNavigationRelationInput"]: {
	connect: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateGenericPagesRelationInput"]: {
	connect: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGeneralsCreateInput"] | Variable<any, string>
};
	["GeneralConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GeneralLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["GeneralUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GeneralUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	allAreasIcon?: ValueTypes["GeneralUpdateAllAreasIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	allOrganizationsIcon?: ValueTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["GeneralUpdateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["GeneralLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GeneralUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GeneralUpdateLocalesRelationInput"]: {
	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GeneralLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["GeneralLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	allAreasDescription?: string | undefined | null | Variable<any, string>,
	allOrganizationsDescription?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGeneralsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutGeneralsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutGeneralsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateGenericPagesEntityRelationInput"]: {
	create?: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateGenericPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertGenericPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateGenericPagesRelationInput"]: {
	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GenericPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["GenericPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageWithoutLocalesUpdateInput"]: {
	type?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	reportNavigation?: Array<ValueTypes["GenericPageUpdateReportNavigationEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageUpdateReportNavigationEntityRelationInput"]: {
	create?: ValueTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageUpdateReportNavigationRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageUpsertReportNavigationRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageUpdateReportNavigationRelationInput"]: {
	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ReportNavigationLocaleWithoutPagesUpdateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleWithoutPagesUpdateInput"]: {
	root?: ValueTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["ReportNavigationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportNavigationWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReportNavigationWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportNavigationLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["ReportNavigationWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportNavigationWithoutLocalesCreateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutReportNavigationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutReportNavigationsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportNavigationLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutReportNavigationsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateGeneralsEntityRelationInput"]: {
	create?: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateGeneralsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertGeneralsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateGeneralsRelationInput"]: {
	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GeneralLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["GeneralLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	allAreasDescription?: string | undefined | null | Variable<any, string>,
	allOrganizationsDescription?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["GeneralUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GeneralWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GeneralWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GeneralWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	allAreasIcon?: ValueTypes["GeneralUpdateAllAreasIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	allOrganizationsIcon?: ValueTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["GeneralUpdateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralUpdateAllAreasIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralConnectOrCreateAllAreasIconRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralUpsertAllAreasIconRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	width?: number | undefined | null | Variable<any, string>,
	height?: number | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	alt?: string | undefined | null | Variable<any, string>,
	fileName?: string | undefined | null | Variable<any, string>,
	focalPointX?: number | undefined | null | Variable<any, string>,
	focalPointY?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralUpsertAllAreasIconRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["GeneralUpdateAllOrganizationsIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralUpsertAllOrganizationsIconRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GeneralUpsertAllOrganizationsIconRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["GeneralUpdateOrganizationListEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralConnectOrCreateOrganizationListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralUpsertOrganizationListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListUpdateInput"]: {
	items?: Array<ValueTypes["PostOrganizationListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["PostOrganizationListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostOrganizationListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostOrganizationListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostOrganizationListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationListUpdateItemsRelationInput"]: {
	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostOrganizationListItemWithoutListUpdateInput"] | Variable<any, string>
};
	["PostOrganizationListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostOrganizationListItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["PostOrganizationListItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemUpdateItemEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationListItemUpsertItemRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isHidden?: boolean | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdatePostsEntityRelationInput"]: {
	create?: ValueTypes["PostWithoutOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationUpdatePostsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationUpsertPostsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdatePostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostWithoutOrganizationUpdateInput"] | Variable<any, string>
};
	["PostWithoutOrganizationUpdateInput"]: {
	area?: ValueTypes["PostUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostUpdateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateAreaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaWithoutPostsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertAreaRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaWithoutPostsUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostAreaUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	region?: ValueTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpdateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateIconRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaUpsertIconRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpsertIconRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostAreaUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["PostAreaLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaUpdateLocalesRelationInput"]: {
	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostAreaLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["PostAreaLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	shortDescription?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutPostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutPostAreaUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutPostAreaUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertGenericPageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGenericPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutGenericPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutGenericPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdatePostsEntityRelationInput"]: {
	create?: ValueTypes["PostLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdatePostsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertPostsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdatePostsRelationInput"]: {
	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["PostLocaleWithoutLocaleUpdateInput"]: {
	content?: ValueTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	paymentName?: string | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentUpdateInput"]: {
	blocks?: Array<ValueTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?: ValueTypes["ContentBlockWithoutContentCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateBlocksRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentUpsertBlocksRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentUpdateBlocksRelationInput"]: {
	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ContentBlockWithoutContentUpdateInput"] | Variable<any, string>
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	references?: Array<ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentBlockUpdateReferencesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentBlockUpsertReferencesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | Variable<any, string>
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	contentAlignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isAppsVisible?: boolean | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined | null | Variable<any, string>,
	asideMediaContentLayout?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	isAsideMediaContentMobileLayout?: boolean | undefined | null | Variable<any, string>,
	form?: ValueTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	isTitleBigger?: boolean | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isCentered?: boolean | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ContentReferenceUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: {
	connect?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["VideoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertVideoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["VideoUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	width?: number | undefined | null | Variable<any, string>,
	height?: number | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	poster?: ValueTypes["VideoUpdatePosterEntityRelationInput"] | undefined | null | Variable<any, string>,
	shapeType?: ValueTypes["VideoShapeType"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["VideoUpdatePosterEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["VideoConnectOrCreatePosterRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["VideoUpsertPosterRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["VideoUpsertPosterRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertVideoRelationInput"]: {
	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkUpdateInput"]: {
	type?: ValueTypes["LinkEnum"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	externalLink?: string | undefined | null | Variable<any, string>,
	internalLink?: ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	isTargetBlank?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkUpsertInternalLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertPostRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleWithoutLinkUpdateInput"]: {
	content?: ValueTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	paymentName?: string | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SeoUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	ogTitle?: string | undefined | null | Variable<any, string>,
	ogDescription?: string | undefined | null | Variable<any, string>,
	noIndex?: boolean | undefined | null | Variable<any, string>,
	noFollow?: boolean | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["SeoUpdateOgImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SeoUpsertOgImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SeoUpsertOgImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["PostLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutPostsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutPostsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdatePostAreasEntityRelationInput"]: {
	create?: ValueTypes["PostAreaLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdatePostAreasRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertPostAreasRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdatePostAreasRelationInput"]: {
	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostAreaLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["PostAreaLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	shortDescription?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostAreaUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	region?: ValueTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpdateRegionListOverrideEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["DonationAmountsRegionListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaUpsertRegionListOverrideRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListUpdateInput"]: {
	regions?: Array<ValueTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	donation?: ValueTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]: {
	create?: ValueTypes["DonationAmountsRegionItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["DonationAmountsRegionListUpdateRegionsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["DonationAmountsRegionListUpsertRegionsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListUpdateRegionsRelationInput"]: {
	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["DonationAmountsRegionItemWithoutListUpdateInput"] | Variable<any, string>
};
	["DonationAmountsRegionItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	region?: ValueTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimumAmount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["DonationAmountItemWithoutRegionItemCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["DonationAmountsRegionItemUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["DonationAmountsRegionItemUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["DonationAmountItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["DonationAmountItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["DonationAmountItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemUpdateItemsRelationInput"]: {
	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["DonationAmountItemWithoutRegionItemUpdateInput"] | Variable<any, string>
};
	["DonationAmountItemWithoutRegionItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	amount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemUpsertItemsRelationInput"]: {
	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["DonationAmountItemWithoutRegionItemUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationAmountItemWithoutRegionItemCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionItemUpdateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionWithoutDonationItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RegionWithoutDonationItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["DonationAmountsRegionItemUpsertRegionRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RegionWithoutDonationItemsUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	enabledPaymentMethods?: Array<ValueTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	timezone?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionUpdateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RegionConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CurrencyUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RegionUpsertCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["CurrencyUpdateInput"]: {
	identifier?: ValueTypes["CurrencyIdentifier"] | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	sign?: string | undefined | null | Variable<any, string>,
	signAlignment?: ValueTypes["CurrencySignAlignment"] | undefined | null | Variable<any, string>,
	defaultDonationAmount?: number | undefined | null | Variable<any, string>,
	rateAgainstCzk?: number | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postCurrencySums?: Array<ValueTypes["CurrencyUpdatePostCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CurrencyUpdatePostCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RegionUpsertCurrencyRelationInput"]: {
	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]: {
	create?: ValueTypes["RegionPaymentMethodWithoutRegionCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RegionUpdateEnabledPaymentMethodsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RegionUpsertEnabledPaymentMethodsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["RegionPaymentMethodUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["RegionPaymentMethodUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["RegionPaymentMethodUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RegionUpdateEnabledPaymentMethodsRelationInput"]: {
	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["RegionPaymentMethodWithoutRegionUpdateInput"] | Variable<any, string>
};
	["RegionPaymentMethodWithoutRegionUpdateInput"]: {
	allowRecurringPayments?: boolean | undefined | null | Variable<any, string>,
	method?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionUpsertEnabledPaymentMethodsRelationInput"]: {
	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["RegionPaymentMethodWithoutRegionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RegionPaymentMethodWithoutRegionCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionItemUpsertRegionRelationInput"]: {
	update: ValueTypes["RegionWithoutDonationItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RegionWithoutDonationItemsCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionListUpsertRegionsRelationInput"]: {
	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["DonationAmountsRegionItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionItemWithoutListCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionListUpdateDonationEntityRelationInput"]: {
	connect?: ValueTypes["DonationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationWithoutRegionListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["DonationWithoutRegionListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["DonationAmountsRegionListUpsertDonationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["DonationWithoutRegionListUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListUpsertDonationRelationInput"]: {
	update: ValueTypes["DonationWithoutRegionListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationWithoutRegionListCreateInput"] | Variable<any, string>
};
	["PostAreaUpsertRegionListOverrideRelationInput"]: {
	update: ValueTypes["DonationAmountsRegionListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>
};
	["PostAreaUpdatePostsEntityRelationInput"]: {
	create?: ValueTypes["PostWithoutAreaCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaUpdatePostsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaUpsertPostsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaUpdatePostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostWithoutAreaUpdateInput"] | Variable<any, string>
};
	["PostWithoutAreaUpdateInput"]: {
	organization?: ValueTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostUpdateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateOrganizationEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateOrganizationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationWithoutPostsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertOrganizationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationWithoutPostsUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isHidden?: boolean | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateIconRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationUpsertIconRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpsertIconRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["PostOrganizationLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdateLocalesRelationInput"]: {
	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostOrganizationLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutPostOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutPostOrganizationUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutPostOrganizationUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdatePostAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreatePostAreaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertPostAreaRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleWithoutLinkUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	shortDescription?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutPostAreasCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutPostAreasUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutPostAreasUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdatePostOrganizationsEntityRelationInput"]: {
	create?: ValueTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdatePostOrganizationsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertPostOrganizationsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdatePostOrganizationsRelationInput"]: {
	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isHidden?: boolean | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdateAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateAreaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationUpsertAreaRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostAreaUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	region?: ValueTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpdateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RegionUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaUpsertRegionRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RegionUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	enabledPaymentMethods?: Array<ValueTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	donationItems?: Array<ValueTypes["RegionUpdateDonationItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	timezone?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionUpdateDonationItemsEntityRelationInput"]: {
	create?: ValueTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RegionUpdateDonationItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RegionUpsertDonationItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RegionUpdateDonationItemsRelationInput"]: {
	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"] | Variable<any, string>
};
	["DonationAmountsRegionItemWithoutRegionUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimumAmount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["DonationAmountsRegionItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListWithoutRegionsUpdateInput"]: {
	donation?: ValueTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemUpsertListRelationInput"]: {
	update: ValueTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | Variable<any, string>
};
	["RegionUpsertDonationItemsRelationInput"]: {
	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | Variable<any, string>
};
	["PostAreaUpsertRegionRelationInput"]: {
	update: ValueTypes["RegionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["PostAreaUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaMetaDataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpdateMobileHeroImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaUpsertMobileHeroImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpsertMobileHeroImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostAreaUpdatePlainIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaConnectOrCreatePlainIconRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaUpsertPlainIconRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpsertPlainIconRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostAreaUpdateSentPaymentsEntityRelationInput"]: {
	create?: ValueTypes["SentPaymentWithoutAreaCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaUpdateSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaUpsertSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaUpdateSentPaymentsRelationInput"]: {
	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["SentPaymentWithoutAreaUpdateInput"] | Variable<any, string>
};
	["SentPaymentWithoutAreaUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CurrencyUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SentPaymentUpsertCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["SentPaymentUpsertCurrencyRelationInput"]: {
	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["SentPaymentUpdateOrganizationEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentConnectOrCreateOrganizationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationWithoutSentPaymentsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SentPaymentUpsertOrganizationRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationWithoutSentPaymentsUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isHidden?: boolean | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	desktopHeroImage?: ValueTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationCurrencySums?: Array<ValueTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationSum?: ValueTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationMetaDataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdateMobileHeroImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationUpsertMobileHeroImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpsertMobileHeroImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationUpdatePlainIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationUpsertPlainIconRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpsertPlainIconRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationUpsertDesktopHeroImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpsertDesktopHeroImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdateOrganizationSumEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationSumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentUpsertOrganizationRelationInput"]: {
	update: ValueTypes["PostOrganizationWithoutSentPaymentsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | Variable<any, string>
};
	["SentPaymentUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["SentPaymentLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SentPaymentUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SentPaymentUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SentPaymentUpdateLocalesRelationInput"]: {
	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["SentPaymentLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["SentPaymentLocaleWithoutRootUpdateInput"]: {
	organizationText?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutSentPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutSentPaymentsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SentPaymentLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutSentPaymentsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
	create?: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateHeadersRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertHeadersRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateHeadersRelationInput"]: {
	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["HeaderUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeaderWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeaderWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeaderWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HeaderUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["HeaderUpdateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeaderUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HeaderUpdateOrganizationListEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateOrganizationListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderUpsertOrganizationListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeaderUpsertOrganizationListRelationInput"]: {
	update: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["HeaderWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeaderWithoutLocalesCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpdateLinksEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLinksRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertLinksRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkListUpdateInput"]: {
	items?: Array<ValueTypes["LinkListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["LinkItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["LinkItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["LinkItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["LinkItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LinkListUpdateItemsRelationInput"]: {
	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["LinkItemWithoutListUpdateInput"] | Variable<any, string>
};
	["LinkItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkItemUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkItemUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LinkListUpsertItemsRelationInput"]: {
	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["LinkItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkItemWithoutListCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpsertLinksRelationInput"]: {
	update: ValueTypes["LinkListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkListCreateInput"] | Variable<any, string>
};
	["LocaleUpsertHeadersRelationInput"]: {
	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateFootersEntityRelationInput"]: {
	create?: ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateFootersRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertFootersRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateFootersRelationInput"]: {
	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FooterLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
	copyright?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	contactEmail?: string | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["FooterUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FooterWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["FooterUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["FooterWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FooterWithoutLocalesCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateLinkListEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateLinkListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertLinkListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertLinkListRelationInput"]: {
	update: ValueTypes["LinkListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkListCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateAddressInfoEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertAddressInfoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertAddressInfoRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateImageLinkListEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageLinkListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertImageLinkListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkListUpdateInput"]: {
	items?: Array<ValueTypes["ImageLinkListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ImageLinkItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageLinkListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageLinkListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ImageLinkItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ImageLinkItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ImageLinkItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ImageLinkListUpdateItemsRelationInput"]: {
	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ImageLinkItemWithoutListUpdateInput"] | Variable<any, string>
};
	["ImageLinkItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["ImageLinkItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkItemUpdateItemEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageLinkItemUpsertItemRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkUpdateInput"]: {
	image?: ValueTypes["ImageLinkUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["ImageLinkUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageLinkUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ImageLinkUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageLinkUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["ImageLinkItemUpsertItemRelationInput"]: {
	update: ValueTypes["ImageLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageLinkCreateInput"] | Variable<any, string>
};
	["ImageLinkListUpsertItemsRelationInput"]: {
	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ImageLinkItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageLinkItemWithoutListCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpsertImageLinkListRelationInput"]: {
	update: ValueTypes["ImageLinkListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>
};
	["LocaleUpsertFootersRelationInput"]: {
	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FooterLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]: {
	create?: ValueTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateGenericPageAboutSettingsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertGenericPageAboutSettingsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateGenericPageAboutSettingsRelationInput"]: {
	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkGroups?: Array<ValueTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageAboutSettingsLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]: {
	create?: ValueTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"]: {
	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"] | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"]: {
	update: ValueTypes["LinkListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkListCreateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"]: {
	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | Variable<any, string>
};
	["LocaleUpsertGenericPageAboutSettingsRelationInput"]: {
	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdatePostRevisionsEntityRelationInput"]: {
	create?: ValueTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdatePostRevisionsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertPostRevisionsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdatePostRevisionsRelationInput"]: {
	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostRevisionLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["PostRevisionLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostRevisionLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishNotificationText?: string | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostRevisionWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostRevisionWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionWithoutLocalesUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	createdById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	publishedById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostRevisionUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileImage?: ValueTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileVideo?: ValueTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroImage?: ValueTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	isOrganizationVisible?: boolean | undefined | null | Variable<any, string>,
	sendPublishNotifications?: boolean | undefined | null | Variable<any, string>,
	isArchived?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionUpdatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutRevisionsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostWithoutRevisionsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionUpsertPostRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostWithoutRevisionsUpdateInput"]: {
	organization?: ValueTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostUpdateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateActiveRevisionEntityRelationInput"]: {
	connect?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostRevisionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateActiveRevisionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostRevisionUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertActiveRevisionRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	createdById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	publishedById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostRevisionUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileImage?: ValueTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileVideo?: ValueTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroImage?: ValueTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostRevisionUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	isOrganizationVisible?: boolean | undefined | null | Variable<any, string>,
	sendPublishNotifications?: boolean | undefined | null | Variable<any, string>,
	isArchived?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionUpdateTileImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateTileImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionUpsertTileImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionUpsertTileImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostRevisionUpdateTileVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateTileVideoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["VideoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionUpsertTileVideoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionUpsertTileVideoRelationInput"]: {
	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["PostRevisionUpdateHeroImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateHeroImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionUpsertHeroImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionUpsertHeroImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostRevisionUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["PostRevisionLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostRevisionUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostRevisionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostRevisionUpdateLocalesRelationInput"]: {
	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostRevisionLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["PostRevisionLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishNotificationText?: string | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutPostRevisionsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutPostRevisionsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutPostRevisionsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateFlagImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateFlagImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertFlagImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpsertFlagImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleUpdateFeedPagesEntityRelationInput"]: {
	create?: ValueTypes["FeedPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateFeedPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertFeedPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateFeedPagesRelationInput"]: {
	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FeedPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["FeedPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined | null | Variable<any, string>,
	sectionList?: Array<ValueTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FeedPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["FeedPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FeedPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleUpdateHeroTilesEntityRelationInput"]: {
	connect?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TileListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TileListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageLocaleUpsertHeroTilesRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileListUpdateInput"]: {
	size?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["TileListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaType?: ValueTypes["TileListUpdateAreaTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["TileItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TileListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TileItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TileItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TileItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TileListUpdateItemsRelationInput"]: {
	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TileItemWithoutListUpdateInput"] | Variable<any, string>
};
	["TileItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	type?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	post?: ValueTypes["TileItemUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["TileItemUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["TileItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["TileItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["TileItemUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileItemUpdatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileItemUpsertPostRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateInput"]: {
	organization?: ValueTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostUpdateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateRevisionsEntityRelationInput"]: {
	create?: ValueTypes["PostRevisionWithoutPostCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateRevisionsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertRevisionsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostRevisionUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostUpdateRevisionsRelationInput"]: {
	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostRevisionWithoutPostUpdateInput"] | Variable<any, string>
};
	["PostRevisionWithoutPostUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	createdById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	publishedById?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostType"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	tileImage?: ValueTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileVideo?: ValueTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroImage?: ValueTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostRevisionUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	isOrganizationVisible?: boolean | undefined | null | Variable<any, string>,
	sendPublishNotifications?: boolean | undefined | null | Variable<any, string>,
	isArchived?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionUpdateRegionListOverrideEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["DonationAmountsRegionListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionUpsertRegionListOverrideRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionUpsertRegionListOverrideRelationInput"]: {
	update: ValueTypes["DonationAmountsRegionListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>
};
	["PostUpsertRevisionsRelationInput"]: {
	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostRevisionWithoutPostUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostRevisionWithoutPostCreateInput"] | Variable<any, string>
};
	["PostUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["PostLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostUpdateLocalesRelationInput"]: {
	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["PostLocaleWithoutRootUpdateInput"]: {
	content?: ValueTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	paymentName?: string | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutPostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutPostUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutPostUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdatePostOrganizationEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreatePostOrganizationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertPostOrganizationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleWithoutLinkUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutPostOrganizationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutPostOrganizationsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutPostOrganizationsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]: {
	create?: ValueTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateRecurringPaymentPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertRecurringPaymentPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateRecurringPaymentPagesRelationInput"]: {
	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["RecurringPaymentPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RecurringPaymentPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecurringPaymentPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["RecurringPaymentPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"]: {
	connect?: ValueTypes["PostListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostListUpdateInput"]: {
	items?: Array<ValueTypes["PostListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["PostListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostListUpdateItemsRelationInput"]: {
	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostListItemWithoutListUpdateInput"] | Variable<any, string>
};
	["PostListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostListItemUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListItemUpdatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostListItemConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostListItemUpsertPostRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostListItemUpsertPostRelationInput"]: {
	update: ValueTypes["PostUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostCreateInput"] | Variable<any, string>
};
	["PostListUpsertItemsRelationInput"]: {
	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostListItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostListItemWithoutListCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"]: {
	update: ValueTypes["PostListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostListCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StoryGuideListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideListUpdateInput"]: {
	items?: Array<ValueTypes["StoryGuideListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["StoryGuideItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StoryGuideListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StoryGuideListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["StoryGuideItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["StoryGuideItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["StoryGuideItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["StoryGuideListUpdateItemsRelationInput"]: {
	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["StoryGuideItemWithoutListUpdateInput"] | Variable<any, string>
};
	["StoryGuideItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	guide?: ValueTypes["StoryGuideItemUpdateGuideEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideItemUpdateGuideEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideItemConnectOrCreateGuideRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StoryGuideUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StoryGuideItemUpsertGuideRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideUpdateInput"]: {
	mediaType?: ValueTypes["MediaType"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["StoryGuideUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	secondaryImage?: ValueTypes["StoryGuideUpdateSecondaryImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StoryGuideUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["StoryGuideUpdateSecondaryImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StoryGuideUpsertSecondaryImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideUpsertSecondaryImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["StoryGuideItemUpsertGuideRelationInput"]: {
	update: ValueTypes["StoryGuideUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StoryGuideCreateInput"] | Variable<any, string>
};
	["StoryGuideListUpsertItemsRelationInput"]: {
	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["StoryGuideItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StoryGuideItemWithoutListCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"]: {
	update: ValueTypes["StoryGuideListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>
};
	["LocaleUpsertRecurringPaymentPagesRelationInput"]: {
	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateGivenGiftsPagesEntityRelationInput"]: {
	create?: ValueTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateGivenGiftsPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertGivenGiftsPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateGivenGiftsPagesRelationInput"]: {
	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["GivenGiftsPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GivenGiftsPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GivenGiftsPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GivenGiftsPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["GivenGiftsPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GivenGiftsPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GivenGiftsPageLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GivenGiftsPageLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutGivenGiftsPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutGivenGiftsPageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GivenGiftsPageLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutGivenGiftsPageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateReportPageEntityRelationInput"]: {
	connect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateReportPageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReportPageLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertReportPageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["ReportPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReportPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["ReportPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutReportPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutReportPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutReportPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]: {
	create?: ValueTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateReceivedGiftsPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertReceivedGiftsPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateReceivedGiftsPagesRelationInput"]: {
	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutReceivedGiftsPageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReceivedGiftsPageLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutReceivedGiftsPageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateGivenGiftsPageEntityRelationInput"]: {
	connect?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertGivenGiftsPageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutGivenGiftsPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GivenGiftsPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutGivenGiftsPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateReportPagesEntityRelationInput"]: {
	create?: ValueTypes["ReportPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateReportPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertReportPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateReportPagesRelationInput"]: {
	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ReportPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["ReportPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutReportPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutReportPageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportPageLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutReportPageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateReceivedGiftsPageEntityRelationInput"]: {
	connect?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertReceivedGiftsPageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["ReceivedGiftsPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReceivedGiftsPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutReceivedGiftsPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateReportNavigationsEntityRelationInput"]: {
	create?: ValueTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateReportNavigationsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertReportNavigationsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateReportNavigationsRelationInput"]: {
	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	pages?: Array<ValueTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleUpdatePagesEntityRelationInput"]: {
	create?: ValueTypes["GenericPageWithoutReportNavigationCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReportNavigationLocaleUpdatePagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportNavigationLocaleUpsertPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleUpdatePagesRelationInput"]: {
	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GenericPageWithoutReportNavigationUpdateInput"] | Variable<any, string>
};
	["GenericPageWithoutReportNavigationUpdateInput"]: {
	locales?: Array<ValueTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	type?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GenericPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["GenericPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutGenericPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutGenericPageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutGenericPageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	post?: ValueTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	postArea?: ValueTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	postOrganization?: ValueTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	reportPage?: ValueTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	givenGiftsPage?: ValueTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	receivedGiftsPage?: ValueTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutGenericPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutGenericPageCreateInput"] | Variable<any, string>
};
	["GenericPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GenericPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleUpsertPagesRelationInput"]: {
	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GenericPageWithoutReportNavigationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageWithoutReportNavigationCreateInput"] | Variable<any, string>
};
	["LocaleUpsertReportNavigationsRelationInput"]: {
	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateScheduledNotificationsEntityRelationInput"]: {
	create?: ValueTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateScheduledNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertScheduledNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateScheduledNotificationsRelationInput"]: {
	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["ScheduledNotificationLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["ScheduledNotificationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ScheduledNotificationWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ScheduledNotificationWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ScheduledNotificationLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationWithoutLocalesUpdateInput"]: {
	localMsFromMidnight?: number | undefined | null | Variable<any, string>,
	scheduledDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	internalTitle?: string | undefined | null | Variable<any, string>,
	target?: ValueTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationUpdateTargetEntityRelationInput"]: {
	connect?: ValueTypes["NotificationTargetGroupUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["NotificationTargetGroupCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["NotificationTargetGroupUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ScheduledNotificationUpsertTargetRelationInput"] | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupUpdateInput"]: {
	type?: ValueTypes["NotificationTargetType"] | undefined | null | Variable<any, string>,
	regions?: Array<ValueTypes["NotificationTargetGroupUpdateRegionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupUpdateRegionsEntityRelationInput"]: {
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["NotificationTargetGroupUpdateRegionsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["NotificationTargetGroupUpsertRegionsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["NotificationTargetGroupUpdateRegionsRelationInput"]: {
	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["RegionUpdateInput"] | Variable<any, string>
};
	["NotificationTargetGroupUpsertRegionsRelationInput"]: {
	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["RegionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationUpsertTargetRelationInput"]: {
	update: ValueTypes["NotificationTargetGroupUpdateInput"] | Variable<any, string>,
	create: ValueTypes["NotificationTargetGroupCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ScheduledNotificationUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]: {
	create?: ValueTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ScheduledNotificationUpdateProcessedNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ScheduledNotificationUpsertProcessedNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ScheduledNotificationUpdateProcessedNotificationsRelationInput"]: {
	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"] | Variable<any, string>
};
	["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"]: {
	type?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	donationReminderUser?: ValueTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"]: {
	connect?: ValueTypes["ProcessedNotificationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ProcessedNotificationWithoutSourceCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ProcessedNotificationWithoutSourceUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationWithoutSourceUpdateInput"]: {
	topic?: string | undefined | null | Variable<any, string>,
	sentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	errorMessage?: string | undefined | null | Variable<any, string>,
	errorCode?: string | undefined | null | Variable<any, string>,
	isSuccess?: boolean | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	body?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"]: {
	update: ValueTypes["ProcessedNotificationWithoutSourceUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ProcessedNotificationWithoutSourceCreateInput"] | Variable<any, string>
};
	["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutProcessedNotificationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserWithoutProcessedNotificationsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserWithoutProcessedNotificationsUpdateInput"]: {
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserUpdatePaymentsEntityRelationInput"]: {
	create?: ValueTypes["UserPaymentWithoutUserCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserUpdatePaymentsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserUpsertPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserUpdatePaymentsRelationInput"]: {
	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["UserPaymentWithoutUserUpdateInput"] | Variable<any, string>
};
	["UserPaymentWithoutUserUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CurrencyUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentUpsertCurrencyRelationInput"]: {
	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["UserPaymentUpdateOrderEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentOrderIdCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateOrderRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserPaymentOrderIdUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertOrderRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentOrderIdUpdateInput"]: {
	seq?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpsertOrderRelationInput"]: {
	update: ValueTypes["UserPaymentOrderIdUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserPaymentOrderIdCreateInput"] | Variable<any, string>
};
	["UserPaymentUpdateCsobPaymentEntityRelationInput"]: {
	connect?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CsobPaymentWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CsobPaymentWithoutPaymentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertCsobPaymentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentWithoutPaymentUpdateInput"]: {
	payId?: string | undefined | null | Variable<any, string>,
	statusChanges?: Array<ValueTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	originalPayId?: string | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentUpdateStatusChangesEntityRelationInput"]: {
	create?: ValueTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CsobPaymentUpdateStatusChangesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CsobPaymentUpsertStatusChangesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CsobPaymentUpdateStatusChangesRelationInput"]: {
	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"] | Variable<any, string>
};
	["CsobPaymentStatusChangeWithoutPaymentUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	dttm?: string | undefined | null | Variable<any, string>,
	status?: number | undefined | null | Variable<any, string>,
	resultCode?: number | undefined | null | Variable<any, string>,
	message?: string | undefined | null | Variable<any, string>,
	authCode?: string | undefined | null | Variable<any, string>,
	statusDetail?: string | undefined | null | Variable<any, string>,
	actions?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentUpsertStatusChangesRelationInput"]: {
	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | Variable<any, string>
};
	["CsobPaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ValueTypes["CsobPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpsertCsobPaymentRelationInput"]: {
	update: ValueTypes["CsobPaymentWithoutPaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CsobPaymentWithoutPaymentCreateInput"] | Variable<any, string>
};
	["UserPaymentUpdateStripePaymentEntityRelationInput"]: {
	connect?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StripePaymentWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StripePaymentWithoutPaymentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertStripePaymentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentWithoutPaymentUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	statusChanges?: Array<ValueTypes["StripePaymentUpdateStatusChangesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentUpdateStatusChangesEntityRelationInput"]: {
	create?: ValueTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StripePaymentUpdateStatusChangesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StripePaymentUpsertStatusChangesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["StripePaymentUpdateStatusChangesRelationInput"]: {
	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"] | Variable<any, string>
};
	["StripePaymentStatusChangeWithoutPaymentUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	timestamp?: number | undefined | null | Variable<any, string>,
	eventId?: string | undefined | null | Variable<any, string>,
	paymentIntentStatus?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentUpsertStatusChangesRelationInput"]: {
	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | Variable<any, string>
};
	["StripePaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ValueTypes["StripePaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpsertStripePaymentRelationInput"]: {
	update: ValueTypes["StripePaymentWithoutPaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StripePaymentWithoutPaymentCreateInput"] | Variable<any, string>
};
	["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertRecurringPaymentItemRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemWithoutPaymentsUpdateInput"]: {
	recurrenceCounter?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	taskId?: string | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	isFailed?: boolean | undefined | null | Variable<any, string>,
	failedEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserRecurringPaymentWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserRecurringPaymentWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentWithoutItemsUpdateInput"]: {
	activeSince?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cancelledAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	interval?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserRecurringPaymentUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CurrencyUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserRecurringPaymentUpsertCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentUpsertCurrencyRelationInput"]: {
	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["UserRecurringPaymentUpdateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutRecurringPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserWithoutRecurringPaymentsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserRecurringPaymentUpsertUserRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserWithoutRecurringPaymentsUpdateInput"]: {
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserUpdateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RegionUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserUpsertRegionRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserUpsertRegionRelationInput"]: {
	update: ValueTypes["RegionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["UserUpdateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CurrencyUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserUpsertCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserUpsertCurrencyRelationInput"]: {
	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["UserUpdateOnBehalfDonationsEntityRelationInput"]: {
	create?: ValueTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserUpdateOnBehalfDonationsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserUpsertOnBehalfDonationsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserUpdateOnBehalfDonationsRelationInput"]: {
	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"] | Variable<any, string>
};
	["OnBehalfDonationWithoutOnBehalfOfUpdateInput"]: {
	secretCode?: string | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["OnBehalfDonationUpdatePaymentsEntityRelationInput"]: {
	create?: ValueTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["OnBehalfDonationUpdatePaymentsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["OnBehalfDonationUpsertPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["OnBehalfDonationUpdatePaymentsRelationInput"]: {
	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"] | Variable<any, string>
};
	["UserPaymentWithoutOnBehalfDonationUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpdateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RegionUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertRegionRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpsertRegionRelationInput"]: {
	update: ValueTypes["RegionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["UserPaymentUpdateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserWithoutPaymentsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertUserRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserWithoutPaymentsUpdateInput"]: {
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserUpdateRecurringPaymentsEntityRelationInput"]: {
	create?: ValueTypes["UserRecurringPaymentWithoutUserCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserUpdateRecurringPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserUpsertRecurringPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserUpdateRecurringPaymentsRelationInput"]: {
	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["UserRecurringPaymentWithoutUserUpdateInput"] | Variable<any, string>
};
	["UserRecurringPaymentWithoutUserUpdateInput"]: {
	activeSince?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cancelledAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	interval?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserRecurringPaymentUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserRecurringPaymentUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentUpdateItemsRelationInput"]: {
	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"] | Variable<any, string>
};
	["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"]: {
	recurrenceCounter?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	taskId?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isFailed?: boolean | undefined | null | Variable<any, string>,
	failedEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]: {
	create?: ValueTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserRecurringPaymentItemUpdatePaymentsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserRecurringPaymentItemUpsertPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemUpdatePaymentsRelationInput"]: {
	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"] | Variable<any, string>
};
	["UserPaymentWithoutRecurringPaymentItemUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpdateOnBehalfDonationEntityRelationInput"]: {
	connect?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["OnBehalfDonationWithoutPaymentsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertOnBehalfDonationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["OnBehalfDonationWithoutPaymentsUpdateInput"]: {
	secretCode?: string | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	onBehalfOf?: ValueTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutOnBehalfDonationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserWithoutOnBehalfDonationsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["OnBehalfDonationUpsertOnBehalfOfRelationInput"] | undefined | null | Variable<any, string>
};
	["UserWithoutOnBehalfDonationsUpdateInput"]: {
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateSentPaymentsEntityRelationInput"]: {
	create?: ValueTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["SentPaymentLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateSentPaymentsRelationInput"]: {
	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["SentPaymentLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["SentPaymentLocaleWithoutLocaleUpdateInput"]: {
	organizationText?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["SentPaymentLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SentPaymentWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SentPaymentWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SentPaymentLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentWithoutLocalesUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentUpdateAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaWithoutSentPaymentsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SentPaymentConnectOrCreateAreaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaWithoutSentPaymentsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SentPaymentUpsertAreaRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaWithoutSentPaymentsUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	icon?: ValueTypes["PostAreaUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	regionListOverride?: ValueTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined | null | Variable<any, string>,
	color?: string | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	region?: ValueTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileHeroImage?: ValueTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	plainIcon?: ValueTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaSentPaymentCurrencySums?: Array<ValueTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSentPaymentSum?: ValueTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaCurrencySums?: Array<ValueTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaSum?: ValueTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaUpdateAreaSumEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaSumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentUpsertAreaRelationInput"]: {
	update: ValueTypes["PostAreaWithoutSentPaymentsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaWithoutSentPaymentsCreateInput"] | Variable<any, string>
};
	["SentPaymentLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["SentPaymentWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SentPaymentWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertSentPaymentsRelationInput"]: {
	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["SentPaymentLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["UserUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleCreateInput"] | Variable<any, string>
};
	["UserUpdateDevicesEntityRelationInput"]: {
	create?: ValueTypes["DeviceWithoutUserCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserUpdateDevicesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserUpsertDevicesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["DeviceUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["DeviceUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["DeviceUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserUpdateDevicesRelationInput"]: {
	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["DeviceWithoutUserUpdateInput"] | Variable<any, string>
};
	["DeviceWithoutUserUpdateInput"]: {
	fcmToken?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	ipAddress?: string | undefined | null | Variable<any, string>,
	userAgent?: string | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserUpsertDevicesRelationInput"]: {
	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["DeviceWithoutUserUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DeviceWithoutUserCreateInput"] | Variable<any, string>
};
	["UserUpdateProcessedNotificationsEntityRelationInput"]: {
	create?: ValueTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserUpdateProcessedNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserUpsertProcessedNotificationsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserUpdateProcessedNotificationsRelationInput"]: {
	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"] | Variable<any, string>
};
	["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"]: {
	type?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	scheduledNotification?: ValueTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"]: {
	connect?: ValueTypes["ScheduledNotificationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"]: {
	localMsFromMidnight?: number | undefined | null | Variable<any, string>,
	scheduledDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	internalTitle?: string | undefined | null | Variable<any, string>,
	target?: ValueTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	image?: ValueTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ScheduledNotificationUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ScheduledNotificationUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ScheduledNotificationUpdateLocalesRelationInput"]: {
	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["ScheduledNotificationLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutScheduledNotificationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutScheduledNotificationsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ScheduledNotificationLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutScheduledNotificationsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutScheduledNotificationsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutScheduledNotificationsCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationUpsertLocalesRelationInput"]: {
	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"]: {
	update: ValueTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | Variable<any, string>
};
	["UserUpsertProcessedNotificationsRelationInput"]: {
	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | Variable<any, string>
};
	["UserUpdateAreaStatsEntityRelationInput"]: {
	connect?: ValueTypes["UserAreaStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserAreaStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserAreaStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserUpdateOrganizationStatsEntityRelationInput"]: {
	connect?: ValueTypes["UserOrganizationStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserOrganizationStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserOrganizationStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserUpdatePostStatsEntityRelationInput"]: {
	connect?: ValueTypes["UserPostStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserPostStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserPostStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserUpdateCurrencyStatsEntityRelationInput"]: {
	connect?: ValueTypes["UserCurrencyStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserCurrencyStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserCurrencyStatsUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["OnBehalfDonationUpsertOnBehalfOfRelationInput"]: {
	update: ValueTypes["UserWithoutOnBehalfDonationsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserWithoutOnBehalfDonationsCreateInput"] | Variable<any, string>
};
	["OnBehalfDonationUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpsertOnBehalfDonationRelationInput"]: {
	update: ValueTypes["OnBehalfDonationWithoutPaymentsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | Variable<any, string>
};
	["UserPaymentUpdateTriesCollectionEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentUpsertTriesCollectionRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionWithoutPaymentUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	orderUrl?: string | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurring?: ValueTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"] | undefined | null | Variable<any, string>,
	metadataLocales?: Array<ValueTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	medium?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUpdateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentTriesCollectionUpsertUserRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserUpdateInput"]: {
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUpsertUserRelationInput"]: {
	update: ValueTypes["UserUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CurrencyUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentTriesCollectionUpsertCurrencyRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUpsertCurrencyRelationInput"]: {
	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"]: {
	connect?: ValueTypes["OnBehalfDonationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["OnBehalfDonationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["OnBehalfDonationUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["OnBehalfDonationUpdateInput"]: {
	secretCode?: string | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	onBehalfOf?: ValueTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"]: {
	update: ValueTypes["OnBehalfDonationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["OnBehalfDonationCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserRecurringPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserRecurringPaymentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentTriesCollectionUpsertRecurringRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentUpdateInput"]: {
	activeSince?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cancelledAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	interval?: ValueTypes["UserRecurringPaymentInterval"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserRecurringPaymentUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUpsertRecurringRelationInput"]: {
	update: ValueTypes["UserRecurringPaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserPaymentUpsertTriesCollectionRelationInput"]: {
	update: ValueTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | Variable<any, string>
};
	["UserPaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentMetadataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemUpsertPaymentsRelationInput"]: {
	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | Variable<any, string>
};
	["UserRecurringPaymentItemUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentUpsertItemsRelationInput"]: {
	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | Variable<any, string>
};
	["UserUpsertRecurringPaymentsRelationInput"]: {
	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["UserRecurringPaymentWithoutUserUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentWithoutUserCreateInput"] | Variable<any, string>
};
	["UserPaymentUpsertUserRelationInput"]: {
	update: ValueTypes["UserWithoutPaymentsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserWithoutPaymentsCreateInput"] | Variable<any, string>
};
	["OnBehalfDonationUpsertPaymentsRelationInput"]: {
	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | Variable<any, string>
};
	["UserUpsertOnBehalfDonationsRelationInput"]: {
	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"] | Variable<any, string>,
	create: ValueTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | Variable<any, string>
};
	["UserRecurringPaymentUpsertUserRelationInput"]: {
	update: ValueTypes["UserWithoutRecurringPaymentsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserWithoutRecurringPaymentsCreateInput"] | Variable<any, string>
};
	["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"]: {
	update: ValueTypes["UserRecurringPaymentWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentWithoutItemsCreateInput"] | Variable<any, string>
};
	["UserPaymentUpsertRecurringPaymentItemRelationInput"]: {
	update: ValueTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | Variable<any, string>
};
	["UserUpsertPaymentsRelationInput"]: {
	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["UserPaymentWithoutUserUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutUserCreateInput"] | Variable<any, string>
};
	["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"]: {
	update: ValueTypes["UserWithoutProcessedNotificationsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserWithoutProcessedNotificationsCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationUpsertProcessedNotificationsRelationInput"]: {
	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["ScheduledNotificationWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ScheduledNotificationWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertScheduledNotificationsRelationInput"]: {
	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReceivedGiftsPageLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReceivedGiftsPageLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["LinkableUpsertReceivedGiftsPageRelationInput"]: {
	update: ValueTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutReportPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutReportPageCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportPageLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportPageLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleUpdatePostsEntityRelationInput"]: {
	create?: ValueTypes["PostWithoutReportPageCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReportPageLocaleUpdatePostsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportPageLocaleUpsertPostsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportPageLocaleUpdatePostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostWithoutReportPageUpdateInput"] | Variable<any, string>
};
	["PostWithoutReportPageUpdateInput"]: {
	organization?: ValueTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostUpdateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["PostMetaDataUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateHeroCarouselEntityRelationInput"]: {
	create?: ValueTypes["HeroCarouselWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateHeroCarouselRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertHeroCarouselRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HeroCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HeroCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HeroCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostUpdateHeroCarouselRelationInput"]: {
	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HeroCarouselWithoutPostsUpdateInput"] | Variable<any, string>
};
	["HeroCarouselWithoutPostsUpdateInput"]: {
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["HeroCarouselUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["HeroCarouselItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeroCarouselUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeroCarouselUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HeroCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HeroCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HeroCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeroCarouselUpdateItemsRelationInput"]: {
	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HeroCarouselItemWithoutListUpdateInput"] | Variable<any, string>
};
	["HeroCarouselItemWithoutListUpdateInput"]: {
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["HeroCarouselItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselItemUpdateItemEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeroCarouselItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeroCarouselItemUpsertItemRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselItemUpsertItemRelationInput"]: {
	update: ValueTypes["PostUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostCreateInput"] | Variable<any, string>
};
	["HeroCarouselUpsertItemsRelationInput"]: {
	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HeroCarouselItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeroCarouselItemWithoutListCreateInput"] | Variable<any, string>
};
	["PostUpsertHeroCarouselRelationInput"]: {
	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HeroCarouselWithoutPostsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeroCarouselWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostUpdateContentEntityRelationInput"]: {
	create?: ValueTypes["ContentReferenceWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateContentRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostUpdateContentRelationInput"]: {
	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ContentReferenceWithoutPostsUpdateInput"] | Variable<any, string>
};
	["ContentReferenceWithoutPostsUpdateInput"]: {
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	contentAlignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isAppsVisible?: boolean | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined | null | Variable<any, string>,
	asideMediaContentLayout?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	isAsideMediaContentMobileLayout?: boolean | undefined | null | Variable<any, string>,
	form?: ValueTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	isTitleBigger?: boolean | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isCentered?: boolean | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertBlockRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentWithoutBlocksCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentWithoutBlocksUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentBlockUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockUpsertContentRelationInput"]: {
	update: ValueTypes["ContentWithoutBlocksUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentWithoutBlocksCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update: ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateValueListEntityRelationInput"]: {
	connect?: ValueTypes["ValueListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ValueListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateValueListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ValueListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertValueListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ValueListUpdateInput"]: {
	items?: Array<ValueTypes["ValueListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ValueItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ValueListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ValueListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ValueItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ValueItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ValueItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ValueListUpdateItemsRelationInput"]: {
	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ValueItemWithoutListUpdateInput"] | Variable<any, string>
};
	["ValueItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["ValueItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueItemUpdateItemEntityRelationInput"]: {
	connect?: ValueTypes["ValueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ValueCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ValueItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ValueUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ValueItemUpsertItemRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ValueUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["ValueUpdateTextContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueUpdateTextContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ValueConnectOrCreateTextContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ValueUpsertTextContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ValueUpsertTextContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["ValueItemUpsertItemRelationInput"]: {
	update: ValueTypes["ValueUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ValueCreateInput"] | Variable<any, string>
};
	["ValueListUpsertItemsRelationInput"]: {
	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ValueItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ValueItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertValueListRelationInput"]: {
	update: ValueTypes["ValueListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ValueListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateImageLinkListEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageLinkListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertImageLinkListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertImageLinkListRelationInput"]: {
	update: ValueTypes["ImageLinkListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateAreaListEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateAreaListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertAreaListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListUpdateInput"]: {
	items?: Array<ValueTypes["PostAreaListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["PostAreaListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostAreaListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostAreaListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostAreaListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostAreaListUpdateItemsRelationInput"]: {
	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostAreaListItemWithoutListUpdateInput"] | Variable<any, string>
};
	["PostAreaListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostAreaListItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListItemUpdateItemEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaListItemConnectOrCreateItemRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaListItemUpsertItemRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListItemUpsertItemRelationInput"]: {
	update: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>
};
	["PostAreaListUpsertItemsRelationInput"]: {
	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostAreaListItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaListItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertAreaListRelationInput"]: {
	update: ValueTypes["PostAreaListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateAccordionEntityRelationInput"]: {
	connect?: ValueTypes["AccordionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["AccordionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateAccordionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["AccordionUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertAccordionRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["AccordionUpdateInput"]: {
	items?: Array<ValueTypes["AccordionUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AccordionUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["AccordionItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["AccordionUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["AccordionUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["AccordionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["AccordionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["AccordionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["AccordionUpdateItemsRelationInput"]: {
	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["AccordionItemWithoutListUpdateInput"] | Variable<any, string>
};
	["AccordionItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AccordionItemUpdateDescriptionContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["AccordionItemUpsertDescriptionContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["AccordionItemUpsertDescriptionContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["AccordionUpsertItemsRelationInput"]: {
	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["AccordionItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["AccordionItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertAccordionRelationInput"]: {
	update: ValueTypes["AccordionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["AccordionCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertMediaRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumListUpdateInput"]: {
	items?: Array<ValueTypes["MediumListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["MediumItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["MediumListUpdateItemsRelationInput"]: {
	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["MediumItemWithoutListUpdateInput"] | Variable<any, string>
};
	["MediumItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumItemUpsertMediumRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumUpdateInput"]: {
	type?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["MediumUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["MediumUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["MediumUpdateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["VideoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumUpsertVideoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumUpsertVideoRelationInput"]: {
	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["MediumItemUpsertMediumRelationInput"]: {
	update: ValueTypes["MediumUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumCreateInput"] | Variable<any, string>
};
	["MediumListUpsertItemsRelationInput"]: {
	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["MediumItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertMediaRelationInput"]: {
	update: ValueTypes["MediumListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateMemberListEntityRelationInput"]: {
	connect?: ValueTypes["MemberListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MemberListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateMemberListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MemberListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertMemberListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MemberListUpdateInput"]: {
	items?: Array<ValueTypes["MemberListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MemberListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["MemberListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MemberListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MemberListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["MemberListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["MemberListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["MemberListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["MemberListUpdateItemsRelationInput"]: {
	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["MemberListItemWithoutListUpdateInput"] | Variable<any, string>
};
	["MemberListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	position?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["MemberListItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MemberListItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MemberListItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MemberListItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MemberListItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["MemberListItemUpdateDescriptionContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MemberListItemUpsertDescriptionContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MemberListItemUpsertDescriptionContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["MemberListUpsertItemsRelationInput"]: {
	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["MemberListItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MemberListItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertMemberListRelationInput"]: {
	update: ValueTypes["MemberListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MemberListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateFormEntityRelationInput"]: {
	connect?: ValueTypes["FormUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FormCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateFormRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FormUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertFormRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FormUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["FormType"] | undefined | null | Variable<any, string>,
	tax?: ValueTypes["FormUpdateTaxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FormUpdateTaxEntityRelationInput"]: {
	connect?: ValueTypes["FilledTaxFormUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FilledTaxFormCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FormConnectOrCreateTaxRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FilledTaxFormUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FormUpsertTaxRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FilledTaxFormUpdateInput"]: {
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	userId?: string | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	vatId?: string | undefined | null | Variable<any, string>,
	address1?: string | undefined | null | Variable<any, string>,
	address2?: string | undefined | null | Variable<any, string>,
	city?: string | undefined | null | Variable<any, string>,
	postalCode?: string | undefined | null | Variable<any, string>,
	state?: string | undefined | null | Variable<any, string>,
	country?: ValueTypes["FilledTaxFormUpdateCountryEntityRelationInput"] | undefined | null | Variable<any, string>,
	dateFrom?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	dateTo?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	year?: number | undefined | null | Variable<any, string>,
	isPdfGenerated?: boolean | undefined | null | Variable<any, string>,
	pdfObjectKey?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FilledTaxFormUpdateCountryEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FilledTaxFormConnectOrCreateCountryRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RegionUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FilledTaxFormUpsertCountryRelationInput"] | undefined | null | Variable<any, string>
};
	["FilledTaxFormUpsertCountryRelationInput"]: {
	update: ValueTypes["RegionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RegionCreateInput"] | Variable<any, string>
};
	["FormUpsertTaxRelationInput"]: {
	update: ValueTypes["FilledTaxFormUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FilledTaxFormCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertFormRelationInput"]: {
	update: ValueTypes["FormUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FormCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertContentWithoutBlocksRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertContentWithoutBlocksRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateHeroCarouselEntityRelationInput"]: {
	connect?: ValueTypes["HeroCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeroCarouselCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeroCarouselUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertHeroCarouselRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselUpdateInput"]: {
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["HeroCarouselUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["HeroCarouselUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselUpdatePostsEntityRelationInput"]: {
	create?: ValueTypes["PostWithoutHeroCarouselCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeroCarouselUpdatePostsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeroCarouselUpsertPostsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeroCarouselUpdatePostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostWithoutHeroCarouselUpdateInput"] | Variable<any, string>
};
	["PostWithoutHeroCarouselUpdateInput"]: {
	organization?: ValueTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostUpdateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateReportPageEntityRelationInput"]: {
	create?: ValueTypes["ReportPageLocaleWithoutPostsCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateReportPageRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertReportPageRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostUpdateReportPageRelationInput"]: {
	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ReportPageLocaleWithoutPostsUpdateInput"] | Variable<any, string>
};
	["ReportPageLocaleWithoutPostsUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostUpsertReportPageRelationInput"]: {
	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ReportPageLocaleWithoutPostsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportPageLocaleWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostUpdateFundraiseCurrencyEntityRelationInput"]: {
	connect?: ValueTypes["CurrencyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CurrencyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CurrencyUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostUpsertFundraiseCurrencyRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostUpsertFundraiseCurrencyRelationInput"]: {
	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>
};
	["PostUpdateFundraiseCurrencySumsEntityRelationInput"]: {
	connect?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostCurrencySumUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostUpdateFundraiseSumEntityRelationInput"]: {
	connect?: ValueTypes["PostSumUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostUpdateFundraisingProgressEntityRelationInput"]: {
	connect?: ValueTypes["PostFundraisingProgressUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselUpsertPostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostWithoutHeroCarouselUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostWithoutHeroCarouselCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertHeroCarouselRelationInput"]: {
	update: ValueTypes["HeroCarouselUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeroCarouselCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateOrganizationListEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertOrganizationListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertOrganizationListRelationInput"]: {
	update: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateTextImageListEntityRelationInput"]: {
	connect?: ValueTypes["TextImageListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextImageListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TextImageListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertTextImageListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListUpdateInput"]: {
	items?: Array<ValueTypes["TextImageListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["TextImageListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TextImageListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TextImageListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TextImageListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TextImageListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TextImageListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TextImageListUpdateItemsRelationInput"]: {
	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TextImageListItemWithoutListUpdateInput"] | Variable<any, string>
};
	["TextImageListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	image?: ValueTypes["TextImageListItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["TextImageListItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextImageListItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TextImageListItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["TextImageListItemUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextImageListItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TextImageListItemUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListItemUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["TextImageListUpsertItemsRelationInput"]: {
	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TextImageListItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TextImageListItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertTextImageListRelationInput"]: {
	update: ValueTypes["TextImageListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TextImageListCreateInput"] | Variable<any, string>
};
	["PostUpsertContentRelationInput"]: {
	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ContentReferenceWithoutPostsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentReferenceWithoutPostsCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleUpsertPostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostWithoutReportPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostWithoutReportPageCreateInput"] | Variable<any, string>
};
	["LocaleUpsertReportPagesRelationInput"]: {
	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ReportPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutGivenGiftsPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | Variable<any, string>
};
	["LinkableUpsertGivenGiftsPageRelationInput"]: {
	update: ValueTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutReceivedGiftsPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | Variable<any, string>
};
	["LocaleUpsertReceivedGiftsPagesRelationInput"]: {
	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutReportPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutReportPagesCreateInput"] | Variable<any, string>
};
	["LinkableUpsertReportPageRelationInput"]: {
	update: ValueTypes["ReportPageLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutGivenGiftsPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutGivenGiftsPageCreateInput"] | Variable<any, string>
};
	["LocaleUpsertGivenGiftsPagesRelationInput"]: {
	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutPostOrganizationsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutPostOrganizationsCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleUpdateDomainEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationLocaleUpsertDomainRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleUpsertDomainRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["LinkableUpsertPostOrganizationRelationInput"]: {
	update: ValueTypes["PostOrganizationLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["PostLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutPostUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutPostCreateInput"] | Variable<any, string>
};
	["PostUpsertLocalesRelationInput"]: {
	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["TileItemUpsertPostRelationInput"]: {
	update: ValueTypes["PostUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostCreateInput"] | Variable<any, string>
};
	["TileItemUpdateAreaEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateAreaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileItemUpsertAreaRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileItemUpsertAreaRelationInput"]: {
	update: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>
};
	["TileItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["TileItemUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileItemUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileItemUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["TileItemUpdateOrganizationEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateOrganizationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileItemUpsertOrganizationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileItemUpsertOrganizationRelationInput"]: {
	update: ValueTypes["PostOrganizationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>
};
	["TileListUpsertItemsRelationInput"]: {
	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TileItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TileItemWithoutListCreateInput"] | Variable<any, string>
};
	["TileListUpdateAreaTypeEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileListConnectOrCreateAreaTypeRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileListUpsertAreaTypeRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileListUpsertAreaTypeRelationInput"]: {
	update: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleUpsertHeroTilesRelationInput"]: {
	update: ValueTypes["TileListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TileListCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleUpdateSectionListEntityRelationInput"]: {
	create?: ValueTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FeedPageLocaleUpdateSectionListRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageLocaleUpsertSectionListRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FeedPageLocaleUpdateSectionListRelationInput"]: {
	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"] | Variable<any, string>
};
	["FeedPageSectionWithoutFeedPageLocaleUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	tileStripeList?: Array<ValueTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageSectionUpdateTileStripeListEntityRelationInput"]: {
	create?: ValueTypes["FeedPageTileStripeWithoutSectionCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FeedPageSectionUpdateTileStripeListRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageSectionUpsertTileStripeListRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FeedPageTileStripeUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FeedPageTileStripeUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FeedPageTileStripeUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FeedPageSectionUpdateTileStripeListRelationInput"]: {
	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FeedPageTileStripeWithoutSectionUpdateInput"] | Variable<any, string>
};
	["FeedPageTileStripeWithoutSectionUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	tileList?: ValueTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeUpdateTileListEntityRelationInput"]: {
	connect?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TileListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TileListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageTileStripeUpsertTileListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeUpsertTileListRelationInput"]: {
	update: ValueTypes["TileListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TileListCreateInput"] | Variable<any, string>
};
	["FeedPageSectionUpsertTileStripeListRelationInput"]: {
	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FeedPageTileStripeWithoutSectionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FeedPageTileStripeWithoutSectionCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleUpsertSectionListRelationInput"]: {
	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleUpdateCardListEntityRelationInput"]: {
	connect?: ValueTypes["CardListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CardListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CardListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageLocaleUpsertCardListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CardListUpdateInput"]: {
	items?: Array<ValueTypes["CardListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CardListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["CardItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CardListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CardListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["CardItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["CardItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["CardItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CardListUpdateItemsRelationInput"]: {
	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["CardItemWithoutListUpdateInput"] | Variable<any, string>
};
	["CardItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["CardItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CardItemUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CardItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CardItemUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CardItemUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["CardListUpsertItemsRelationInput"]: {
	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["CardItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CardItemWithoutListCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleUpsertCardListRelationInput"]: {
	update: ValueTypes["CardListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CardListCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StoryGuideListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageLocaleUpsertStoryGuideListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleUpsertStoryGuideListRelationInput"]: {
	update: ValueTypes["StoryGuideListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>
};
	["LocaleUpsertFeedPagesRelationInput"]: {
	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FeedPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FeedPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutPostRevisionsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutPostRevisionsCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleUpdateLeadContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostRevisionLocaleUpsertLeadContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleUpsertLeadContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["PostRevisionUpsertLocalesRelationInput"]: {
	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostRevisionLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostRevisionLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["PostUpsertActiveRevisionRelationInput"]: {
	update: ValueTypes["PostRevisionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostRevisionCreateInput"] | Variable<any, string>
};
	["PostRevisionUpsertPostRelationInput"]: {
	update: ValueTypes["PostWithoutRevisionsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostWithoutRevisionsCreateInput"] | Variable<any, string>
};
	["PostRevisionLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["PostRevisionWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostRevisionWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertPostRevisionsRelationInput"]: {
	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostRevisionLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["SentPaymentLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutSentPaymentsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutSentPaymentsCreateInput"] | Variable<any, string>
};
	["SentPaymentUpsertLocalesRelationInput"]: {
	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["SentPaymentLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SentPaymentLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["PostAreaUpsertSentPaymentsRelationInput"]: {
	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["SentPaymentWithoutAreaUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SentPaymentWithoutAreaCreateInput"] | Variable<any, string>
};
	["PostOrganizationUpsertAreaRelationInput"]: {
	update: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>
};
	["PostOrganizationUpdateSentPaymentsEntityRelationInput"]: {
	create?: ValueTypes["SentPaymentWithoutOrganizationCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationUpdateSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationUpsertSentPaymentsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["SentPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PostOrganizationUpdateSentPaymentsRelationInput"]: {
	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["SentPaymentWithoutOrganizationUpdateInput"] | Variable<any, string>
};
	["SentPaymentWithoutOrganizationUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationUpsertSentPaymentsRelationInput"]: {
	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["SentPaymentWithoutOrganizationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SentPaymentWithoutOrganizationCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["PostOrganizationWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertPostOrganizationsRelationInput"]: {
	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutPostAreasUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutPostAreasCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleUpdateBannerEntityRelationInput"]: {
	connect?: ValueTypes["AppBannerUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["AppBannerCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["AppBannerUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaLocaleUpsertBannerRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["AppBannerUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	imageSmall?: ValueTypes["AppBannerUpdateImageSmallEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageBig?: ValueTypes["AppBannerUpdateImageBigEntityRelationInput"] | undefined | null | Variable<any, string>,
	textContent?: ValueTypes["AppBannerUpdateTextContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AppBannerUpdateImageSmallEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AppBannerConnectOrCreateImageSmallRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["AppBannerUpsertImageSmallRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["AppBannerUpsertImageSmallRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["AppBannerUpdateImageBigEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AppBannerConnectOrCreateImageBigRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["AppBannerUpsertImageBigRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["AppBannerUpsertImageBigRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["AppBannerUpdateTextContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AppBannerConnectOrCreateTextContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["AppBannerUpsertTextContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["AppBannerUpsertTextContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleUpsertBannerRelationInput"]: {
	update: ValueTypes["AppBannerUpdateInput"] | Variable<any, string>,
	create: ValueTypes["AppBannerCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["LinkableUpsertPostAreaRelationInput"]: {
	update: ValueTypes["PostAreaLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["PostOrganizationLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutPostOrganizationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutPostOrganizationCreateInput"] | Variable<any, string>
};
	["PostOrganizationUpsertLocalesRelationInput"]: {
	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostOrganizationLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["PostUpsertOrganizationRelationInput"]: {
	update: ValueTypes["PostOrganizationWithoutPostsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostAreaUpsertPostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostWithoutAreaUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostWithoutAreaCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["PostAreaWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertPostAreasRelationInput"]: {
	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostAreaLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["PostLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutPostsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostWithoutLocalesUpdateInput"]: {
	organization?: ValueTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	content?: Array<ValueTypes["PostUpdateContentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["PostWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LinkableUpsertPostRelationInput"]: {
	update: ValueTypes["PostLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update: ValueTypes["LinkableUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdatePostsEntityRelationInput"]: {
	create?: ValueTypes["PostWithoutContentCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentReferenceUpdatePostsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertPostsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentReferenceUpdatePostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PostWithoutContentUpdateInput"] | Variable<any, string>
};
	["PostWithoutContentUpdateInput"]: {
	organization?: ValueTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["PostUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	specificSymbol?: number | undefined | null | Variable<any, string>,
	activeRevision?: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null | Variable<any, string>,
	revisions?: Array<ValueTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isPinnedInArea?: boolean | undefined | null | Variable<any, string>,
	isPinnedInOrganization?: boolean | undefined | null | Variable<any, string>,
	state?: ValueTypes["PostState"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["PostUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	isPublishedAtHidden?: boolean | undefined | null | Variable<any, string>,
	heroCarousel?: Array<ValueTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPage?: Array<ValueTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseIsActive?: boolean | undefined | null | Variable<any, string>,
	fundraiseEndDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	fundraiseTargetAmount?: number | undefined | null | Variable<any, string>,
	fundraiseFakeAddOnAmount?: number | undefined | null | Variable<any, string>,
	fundraiseCurrency?: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraiseCurrencySums?: Array<ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fundraiseSum?: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null | Variable<any, string>,
	fundraisingProgress?: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertPostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostWithoutContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostWithoutContentCreateInput"] | Variable<any, string>
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | Variable<any, string>
};
	["ContentUpsertBlocksRelationInput"]: {
	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ContentBlockWithoutContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentBlockWithoutContentCreateInput"] | Variable<any, string>
};
	["PostLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["LocaleUpsertPostsRelationInput"]: {
	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutGenericPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGenericPagesCreateInput"] | Variable<any, string>
};
	["LinkableUpsertGenericPageRelationInput"]: {
	update: ValueTypes["GenericPageLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["PostAreaLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutPostAreaUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutPostAreaCreateInput"] | Variable<any, string>
};
	["PostAreaUpsertLocalesRelationInput"]: {
	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostAreaLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["PostUpsertAreaRelationInput"]: {
	update: ValueTypes["PostAreaWithoutPostsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaWithoutPostsCreateInput"] | Variable<any, string>
};
	["PostOrganizationUpsertPostsRelationInput"]: {
	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostWithoutOrganizationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostWithoutOrganizationCreateInput"] | Variable<any, string>
};
	["PostOrganizationListItemUpsertItemRelationInput"]: {
	update: ValueTypes["PostOrganizationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>
};
	["PostOrganizationListItemUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationListItemUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["PostOrganizationListItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationListItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["PostOrganizationListUpsertItemsRelationInput"]: {
	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PostOrganizationListItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListItemWithoutListCreateInput"] | Variable<any, string>
};
	["GeneralUpsertOrganizationListRelationInput"]: {
	update: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["GeneralWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GeneralWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertAppStoreLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpsertAppStoreLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertGooglePlayLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpsertGooglePlayLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LocaleUpsertGeneralsRelationInput"]: {
	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GeneralLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutReportNavigationsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutReportNavigationsCreateInput"] | Variable<any, string>
};
	["GenericPageUpsertReportNavigationRelationInput"]: {
	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ReportNavigationLocaleWithoutPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["GenericPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertGenericPagesRelationInput"]: {
	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GenericPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutGeneralsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGeneralsCreateInput"] | Variable<any, string>
};
	["GeneralUpsertLocalesRelationInput"]: {
	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GeneralLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GeneralLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	type?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	reportNavigation?: Array<ValueTypes["GenericPageCreateReportNavigationEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageUpdateInput"]: {
	locales?: Array<ValueTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	type?: ValueTypes["GenericPageType"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	reportNavigation?: Array<ValueTypes["GenericPageUpdateReportNavigationEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	references?: Array<ValueTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	references?: Array<ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	contentAlignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isAppsVisible?: boolean | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined | null | Variable<any, string>,
	asideMediaContentLayout?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	isAsideMediaContentMobileLayout?: boolean | undefined | null | Variable<any, string>,
	form?: ValueTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	isTitleBigger?: boolean | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isCentered?: boolean | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ContentReferenceCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpdateInput"]: {
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	contentAlignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	valueList?: ValueTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	areaList?: ValueTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isAppsVisible?: boolean | undefined | null | Variable<any, string>,
	accordion?: ValueTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	memberList?: ValueTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined | null | Variable<any, string>,
	asideMediaContentLayout?: ValueTypes["AsideMediaContentLayout"] | undefined | null | Variable<any, string>,
	isAsideMediaContentMobileLayout?: boolean | undefined | null | Variable<any, string>,
	form?: ValueTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	isTitleBigger?: boolean | undefined | null | Variable<any, string>,
	contentWithoutBlocks?: ValueTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroCarousel?: ValueTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	isCentered?: boolean | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ContentReferenceUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	textImageList?: ValueTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	allAreasDescription?: string | undefined | null | Variable<any, string>,
	allOrganizationsDescription?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpdateInput"]: {
	root?: ValueTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	appStoreLink?: ValueTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	googlePlayLink?: ValueTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	allAreasDescription?: string | undefined | null | Variable<any, string>,
	allOrganizationsDescription?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleEdge"]: AliasType<{
	node?:ValueTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["VideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VideoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VideoEdge"]: AliasType<{
	node?:ValueTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	paymentName?: string | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostLocaleUpdateInput"]: {
	content?: ValueTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	paymentName?: string | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaEdge"]: AliasType<{
	node?:ValueTypes["PostArea"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	shortDescription?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaLocaleUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	banner?: ValueTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	shortDescription?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostOrganizationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationEdge"]: AliasType<{
	node?:ValueTypes["PostOrganization"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationLocaleUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DonationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DonationEdge"]: AliasType<{
	node?:ValueTypes["Donation"],
		__typename?: boolean | `@${string}`
}>;
	["DonationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	regionList?: ValueTypes["DonationCreateRegionListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationCreateRegionListEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationConnectOrCreateRegionListRelationInput"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListWithoutDonationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	regions?: Array<ValueTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationConnectOrCreateRegionListRelationInput"]: {
	connect: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | Variable<any, string>
};
	["DonationUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	regionList?: ValueTypes["DonationUpdateRegionListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationUpdateRegionListEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationConnectOrCreateRegionListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["DonationAmountsRegionListWithoutDonationUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["DonationUpsertRegionListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListWithoutDonationUpdateInput"]: {
	regions?: Array<ValueTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationUpsertRegionListRelationInput"]: {
	update: ValueTypes["DonationAmountsRegionListWithoutDonationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | Variable<any, string>
};
	["DonationAmountItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	amount?: number | undefined | null | Variable<any, string>,
	regionItem?: ValueTypes["DonationAmountItemCreateRegionItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountItemCreateRegionItemEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"] | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimumAmount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountItemConnectOrCreateRegionItemRelationInput"]: {
	connect: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | Variable<any, string>
};
	["DonationAmountItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	amount?: number | undefined | null | Variable<any, string>,
	regionItem?: ValueTypes["DonationAmountItemUpdateRegionItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountItemUpdateRegionItemEntityRelationInput"]: {
	connect?: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["DonationAmountItemUpsertRegionItemRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemWithoutItemsUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimumAmount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountItemUpsertRegionItemRelationInput"]: {
	update: ValueTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | Variable<any, string>
};
	["DonationAmountsRegionItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimumAmount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	list?: ValueTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimumAmount?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DonationAmountsRegionListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DonationAmountsRegionListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListEdge"]: AliasType<{
	node?:ValueTypes["DonationAmountsRegionList"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["LinkItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkListWithoutItemsCreateInput"] | Variable<any, string>
};
	["LinkItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["LinkItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkItemUpsertListRelationInput"]: {
	update: ValueTypes["LinkListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkListWithoutItemsCreateInput"] | Variable<any, string>
};
	["LinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListEdge"]: AliasType<{
	node?:ValueTypes["LinkList"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderEdge"]: AliasType<{
	node?:ValueTypes["Header"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HeaderCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["HeaderCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["HeaderCreateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeaderLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutHeadersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutHeadersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutHeadersCreateInput"] | Variable<any, string>
};
	["HeaderConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeaderLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["HeaderUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HeaderUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["HeaderUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationList?: ValueTypes["HeaderUpdateOrganizationListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["HeaderLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeaderUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderUpdateLocalesRelationInput"]: {
	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HeaderLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutHeadersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutHeadersUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutHeadersUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutHeadersUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutHeadersCreateInput"] | Variable<any, string>
};
	["HeaderUpsertLocalesRelationInput"]: {
	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HeaderLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeaderLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["HeaderLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpdateInput"]: {
	root?: ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	links?: ValueTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: boolean | `@${string}`
}>;
	["FooterCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["FooterCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["FooterCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	contactEmail?: string | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutFootersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutFootersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutFootersCreateInput"] | Variable<any, string>
};
	["FooterConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FooterLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["FooterUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["FooterUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["FooterUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["FooterLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FooterUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterUpdateLocalesRelationInput"]: {
	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FooterLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["FooterLocaleWithoutRootUpdateInput"]: {
	copyright?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	contactEmail?: string | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutFootersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutFootersUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutFootersUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutFootersUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutFootersCreateInput"] | Variable<any, string>
};
	["FooterUpsertLocalesRelationInput"]: {
	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FooterLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FooterLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	contactEmail?: string | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpdateInput"]: {
	copyright?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	contactEmail?: string | undefined | null | Variable<any, string>,
	addressInfo?: ValueTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageLinkList?: ValueTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostListEdge"]: AliasType<{
	node?:ValueTypes["PostList"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostListItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostListItemCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["PostListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["PostListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostListWithoutItemsCreateInput"] | Variable<any, string>
};
	["PostListItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostListItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostListItemUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["PostListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostListItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostListItemUpsertListRelationInput"]: {
	update: ValueTypes["PostListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostListWithoutItemsCreateInput"] | Variable<any, string>
};
	["AppBannerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AppBannerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerEdge"]: AliasType<{
	node?:ValueTypes["AppBanner"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageAboutSettingsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsEdge"]: AliasType<{
	node?:ValueTypes["GenericPageAboutSettings"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkGroups?: Array<ValueTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutGenericPageAboutSettingsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageAboutSettingsUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageAboutSettingsUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsUpdateLocalesRelationInput"]: {
	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkGroups?: Array<ValueTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutGenericPageAboutSettingsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsUpsertLocalesRelationInput"]: {
	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkGroups?: Array<ValueTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleUpdateInput"]: {
	root?: ValueTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkGroups?: Array<ValueTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ValueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ValueEdge"]: AliasType<{
	node?:ValueTypes["Value"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["ValueItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["ValueItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ValueListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ValueListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ValueItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["ValueListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ValueListWithoutItemsCreateInput"] | Variable<any, string>
};
	["ValueItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["ValueItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["ValueItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["ValueListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ValueListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ValueItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ValueListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ValueItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ValueListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ValueItemUpsertListRelationInput"]: {
	update: ValueTypes["ValueListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ValueListWithoutItemsCreateInput"] | Variable<any, string>
};
	["ValueListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ValueListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListEdge"]: AliasType<{
	node?:ValueTypes["ValueList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageLinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkEdge"]: AliasType<{
	node?:ValueTypes["ImageLink"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageLinkItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["ImageLinkItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageLinkListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageLinkListWithoutItemsCreateInput"] | Variable<any, string>
};
	["ImageLinkItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageLinkItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["ImageLinkItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["ImageLinkListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageLinkListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageLinkItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageLinkListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageLinkItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageLinkItemUpsertListRelationInput"]: {
	update: ValueTypes["ImageLinkListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageLinkListWithoutItemsCreateInput"] | Variable<any, string>
};
	["ImageLinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageLinkListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListEdge"]: AliasType<{
	node?:ValueTypes["ImageLinkList"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListEdge"]: AliasType<{
	node?:ValueTypes["PostAreaList"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostAreaListItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostAreaListItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["PostAreaListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostAreaListWithoutItemsCreateInput"] | Variable<any, string>
};
	["PostAreaListItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostAreaListItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostAreaListItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["PostAreaListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostAreaListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostAreaListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostAreaListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostAreaListItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaListItemUpsertListRelationInput"]: {
	update: ValueTypes["PostAreaListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostAreaListWithoutItemsCreateInput"] | Variable<any, string>
};
	["AccordionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AccordionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionEdge"]: AliasType<{
	node?:ValueTypes["Accordion"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["AccordionItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["AccordionItemCreateDescriptionContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AccordionItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["AccordionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["AccordionWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AccordionItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["AccordionWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AccordionItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["AccordionWithoutItemsCreateInput"] | Variable<any, string>
};
	["AccordionItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["AccordionItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AccordionItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["AccordionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["AccordionWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["AccordionItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["AccordionWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["AccordionItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["AccordionWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["AccordionItemUpsertListRelationInput"]: {
	update: ValueTypes["AccordionWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["AccordionWithoutItemsCreateInput"] | Variable<any, string>
};
	["UserConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserEdge"]: AliasType<{
	node?:ValueTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CurrencyConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CurrencyEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyEdge"]: AliasType<{
	node?:ValueTypes["Currency"],
		__typename?: boolean | `@${string}`
}>;
	["MediumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumEdge"]: AliasType<{
	node?:ValueTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["MediumItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumItemCreateMediumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumListWithoutItemsCreateInput"] | Variable<any, string>
};
	["MediumItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["MediumItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemUpsertListRelationInput"]: {
	update: ValueTypes["MediumListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumListWithoutItemsCreateInput"] | Variable<any, string>
};
	["MediumListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListEdge"]: AliasType<{
	node?:ValueTypes["MediumList"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserPaymentOrderIdEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdEdge"]: AliasType<{
	node?:ValueTypes["UserPaymentOrderId"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	recurrenceCounter?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	taskId?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	isFailed?: boolean | undefined | null | Variable<any, string>,
	failedEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserRecurringPaymentItemUpdateInput"]: {
	recurrenceCounter?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	taskId?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recurringPayment?: ValueTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	isFailed?: boolean | undefined | null | Variable<any, string>,
	failedEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	meta?: ValueTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostRevisionLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishNotificationText?: string | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostRevisionLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["PostRevisionLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	leadContent?: ValueTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishNotificationText?: string | undefined | null | Variable<any, string>,
	translatedByAI?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogue"]: AliasType<{
	_meta?:ValueTypes["TranslationCatalogueMeta"],
	id?:boolean | `@${string}`,
domain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationDomain"]],
identifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifier"]],
fallback?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
values?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationValue"]],
valuesByKey?: [{	by: ValueTypes["TranslationCatalogueValuesByKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationValue"]],
paginateValues?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationValueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	fallback?:ValueTypes["FieldMeta"],
	values?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomain"]: AliasType<{
	_meta?:ValueTypes["TranslationDomainMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
catalogues?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
keys?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationKey"]],
cataloguesByIdentifier?: [{	by: ValueTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
cataloguesByValues?: [{	by: ValueTypes["TranslationDomainCataloguesByValuesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
keysByIdentifier?: [{	by: ValueTypes["TranslationDomainKeysByIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationKey"]],
keysByValues?: [{	by: ValueTypes["TranslationDomainKeysByValuesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationKey"]],
paginateCatalogues?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogueConnection"]],
paginateKeys?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationKeyConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	catalogues?:ValueTypes["FieldMeta"],
	keys?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,
	values?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TranslationCatalogueWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TranslationCatalogueWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationDomainWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	catalogues?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,
	keys?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TranslationDomainWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TranslationDomainWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>
};
	["TranslationKeyWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	contentType?: ValueTypes["TranslationKeyContentTypeCondition"] | undefined | null | Variable<any, string>,
	note?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,
	values?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TranslationKeyWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TranslationKeyWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>
};
	["TranslationKeyContentTypeCondition"]: {
	and?: Array<ValueTypes["TranslationKeyContentTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TranslationKeyContentTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TranslationKeyContentTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["TranslationKeyContentType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["TranslationKeyContentType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>
};
	["TranslationKeyContentType"]:TranslationKeyContentType;
	["TranslationValueWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	value?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,
	key?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TranslationValueWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TranslationValueWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	code?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>
};
	["TranslationCatalogueOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationDomainOrderBy"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["TranslationCataloguesIdentifierOrderBy"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueOrderBy"] | undefined | null | Variable<any, string>
};
	["TranslationDomainOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	code?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["TranslationKey"]: AliasType<{
	_meta?:ValueTypes["TranslationKeyMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
	contentType?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
domain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationDomain"]],
values?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationValue"]],
valuesByCatalogue?: [{	by: ValueTypes["TranslationKeyValuesByCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationValue"]],
paginateValues?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationValueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	contentType?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	values?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValue"]: AliasType<{
	_meta?:ValueTypes["TranslationValueMeta"],
	id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
catalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
key?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationKey"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	catalogue?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	value?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationCatalogueOrderBy"] | undefined | null | Variable<any, string>,
	key?: ValueTypes["TranslationKeyOrderBy"] | undefined | null | Variable<any, string>
};
	["TranslationKeyOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	contentType?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	note?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationDomainOrderBy"] | undefined | null | Variable<any, string>
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
	catalogue?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationCatalogueUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null | Variable<any, string>,
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationDomainUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	catalogues?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	keys?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationKeyUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationValueUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	key?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationValueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationValueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueEdge"]: AliasType<{
	node?:ValueTypes["TranslationValue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
	identifier?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
	identifier?: string | undefined | null | Variable<any, string>
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationCatalogueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationCatalogueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueEdge"]: AliasType<{
	node?:ValueTypes["TranslationCatalogue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationKeyEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyEdge"]: AliasType<{
	node?:ValueTypes["TranslationKey"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifier"]: AliasType<{
	_meta?:ValueTypes["TranslationCataloguesIdentifierMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
catalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
catalogueByDomain?: [{	by: ValueTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
catalogueByValues?: [{	by: ValueTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
paginateCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	catalogue?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
	domain?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
	key?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationCatalogueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
	connect?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"] | undefined | null | Variable<any, string>
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	keys?: Array<ValueTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
	connect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationKeyWithoutDomainCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationDomainConnectOrCreateKeysRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationKeyWithoutDomainCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	contentType?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
	connect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationValueWithoutKeyCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationKeyConnectOrCreateValuesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationValueWithoutKeyCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	value?: string | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationValueConnectOrCreateCatalogueRelationInput"] | undefined | null | Variable<any, string>
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"] | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogueConnectOrCreateIdentifierRelationInput"]: {
	connect: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationCatalogueCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"] | undefined | null | Variable<any, string>
};
	["TranslationCatalogueConnectOrCreateFallbackRelationInput"]: {
	connect: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationCatalogueCreateInput"] | Variable<any, string>
};
	["TranslationValueConnectOrCreateCatalogueRelationInput"]: {
	connect: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | Variable<any, string>
};
	["TranslationKeyConnectOrCreateValuesRelationInput"]: {
	connect: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationValueWithoutKeyCreateInput"] | Variable<any, string>
};
	["TranslationDomainConnectOrCreateKeysRelationInput"]: {
	connect: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationKeyWithoutDomainCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueConnectOrCreateDomainRelationInput"]: {
	connect: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
	connect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationCatalogueConnectOrCreateValuesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	value?: string | undefined | null | Variable<any, string>,
	key?: ValueTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
	connect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationKeyWithoutValuesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationValueConnectOrCreateKeyRelationInput"] | undefined | null | Variable<any, string>
};
	["TranslationKeyWithoutValuesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	contentType?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
	connect?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationDomainWithoutKeysCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationKeyConnectOrCreateDomainRelationInput"] | undefined | null | Variable<any, string>
};
	["TranslationDomainWithoutKeysCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	catalogues?: Array<ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationDomainConnectOrCreateCataloguesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainConnectOrCreateCataloguesRelationInput"]: {
	connect: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | Variable<any, string>
};
	["TranslationKeyConnectOrCreateDomainRelationInput"]: {
	connect: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationDomainWithoutKeysCreateInput"] | Variable<any, string>
};
	["TranslationValueConnectOrCreateKeyRelationInput"]: {
	connect: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationKeyWithoutValuesCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueConnectOrCreateValuesRelationInput"]: {
	connect: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueUpdateInput"]: {
	domain?: ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
	connect?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationCatalogueUpsertDomainRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	keys?: Array<ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
	create?: ValueTypes["TranslationKeyWithoutDomainCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationDomainUpdateKeysRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationDomainUpsertKeysRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationDomainUpdateKeysRelationInput"]: {
	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TranslationKeyWithoutDomainUpdateInput"] | Variable<any, string>
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	contentType?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
	create?: ValueTypes["TranslationValueWithoutKeyCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationKeyUpdateValuesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationKeyUpsertValuesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationKeyUpdateValuesRelationInput"]: {
	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TranslationValueWithoutKeyUpdateInput"] | Variable<any, string>
};
	["TranslationValueWithoutKeyUpdateInput"]: {
	value?: string | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationValueConnectOrCreateCatalogueRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationValueUpsertCatalogueRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
	domain?: ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	identifier?: ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationCatalogueUpsertIdentifierRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
	update: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationCatalogueCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationCatalogueUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationCatalogueUpsertFallbackRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
	update: ValueTypes["TranslationCatalogueUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationCatalogueCreateInput"] | Variable<any, string>
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
	update: ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | Variable<any, string>
};
	["TranslationKeyUpsertValuesRelationInput"]: {
	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TranslationValueWithoutKeyUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationValueWithoutKeyCreateInput"] | Variable<any, string>
};
	["TranslationDomainUpsertKeysRelationInput"]: {
	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TranslationKeyWithoutDomainUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationKeyWithoutDomainCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
	update: ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
	create?: ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationCatalogueUpdateValuesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationCatalogueUpsertValuesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TranslationValueWithoutCatalogueUpdateInput"] | Variable<any, string>
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
	value?: string | undefined | null | Variable<any, string>,
	key?: ValueTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
	connect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationKeyWithoutValuesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationValueConnectOrCreateKeyRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationKeyWithoutValuesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationValueUpsertKeyRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	contentType?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
	connect?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationDomainWithoutKeysCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationKeyConnectOrCreateDomainRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationDomainWithoutKeysUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationKeyUpsertDomainRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	catalogues?: Array<ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
	create?: ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationDomainUpdateCataloguesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationDomainUpsertCataloguesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"] | Variable<any, string>
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
	identifier?: ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | Variable<any, string>
};
	["TranslationKeyUpsertDomainRelationInput"]: {
	update: ValueTypes["TranslationDomainWithoutKeysUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationDomainWithoutKeysCreateInput"] | Variable<any, string>
};
	["TranslationValueUpsertKeyRelationInput"]: {
	update: ValueTypes["TranslationKeyWithoutValuesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationKeyWithoutValuesCreateInput"] | Variable<any, string>
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TranslationValueWithoutCatalogueUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | Variable<any, string>
};
	["TranslationCataloguesIdentifierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationCataloguesIdentifierEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierEdge"]: AliasType<{
	node?:ValueTypes["TranslationCataloguesIdentifier"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	catalogue?: Array<ValueTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"]: {
	connect: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | Variable<any, string>
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	catalogue?: Array<ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
	create?: ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | Variable<any, string>
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
	domain?: ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	fallback?: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | Variable<any, string>
};
	["TranslationDomainConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationDomainEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainEdge"]: AliasType<{
	node?:ValueTypes["TranslationDomain"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	catalogues?: Array<ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	keys?: Array<ValueTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationDomainUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	catalogues?: Array<ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	keys?: Array<ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationKeyCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	contentType?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationKeyUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	contentType?: ValueTypes["TranslationKeyContentType"] | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	domain?: ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined | null | Variable<any, string>,
	values?: Array<ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationValueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	value?: string | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined | null | Variable<any, string>,
	key?: ValueTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationValueUpdateInput"]: {
	value?: string | undefined | null | Variable<any, string>,
	catalogue?: ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined | null | Variable<any, string>,
	key?: ValueTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	settings?: ValueTypes["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"]: {
	connect: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	settings?: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkList?: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"]: {
	root?: ValueTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"]: {
	update: ValueTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | Variable<any, string>
};
	["MemberListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MemberListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListEdge"]: AliasType<{
	node?:ValueTypes["MemberList"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	position?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["MemberListItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["MemberListItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["MemberListItemCreateDescriptionContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MemberListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["MemberListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MemberListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MemberListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["MemberListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MemberListItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MemberListWithoutItemsCreateInput"] | Variable<any, string>
};
	["MemberListItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	position?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["MemberListItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["MemberListItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	descriptionContent?: ValueTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MemberListItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["MemberListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MemberListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MemberListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MemberListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MemberListItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MemberListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MemberListItemUpsertListRelationInput"]: {
	update: ValueTypes["MemberListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MemberListWithoutItemsCreateInput"] | Variable<any, string>
};
	["FilledTaxFormConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FilledTaxFormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEdge"]: AliasType<{
	node?:ValueTypes["FilledTaxForm"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddress"]: AliasType<{
	_meta?:ValueTypes["FilledTaxFormEmailAddressMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["FilledTaxFormEmailAddressWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>
};
	["FilledTaxFormEmailAddressOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["FilledTaxFormEmailAddressConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FilledTaxFormEmailAddressEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressEdge"]: AliasType<{
	node?:ValueTypes["FilledTaxFormEmailAddress"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FilledTaxFormEmailAddressUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FormConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FormEdge"]: AliasType<{
	node?:ValueTypes["Form"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CsobPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentEdge"]: AliasType<{
	node?:ValueTypes["CsobPayment"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	payId?: string | undefined | null | Variable<any, string>,
	statusChanges?: Array<ValueTypes["CsobPaymentCreateStatusChangesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	payment?: ValueTypes["CsobPaymentCreatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	originalPayId?: string | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentCreatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentWithoutCsobPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CsobPaymentConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentWithoutCsobPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentConnectOrCreatePaymentRelationInput"]: {
	connect: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutCsobPaymentCreateInput"] | Variable<any, string>
};
	["CsobPaymentUpdateInput"]: {
	payId?: string | undefined | null | Variable<any, string>,
	statusChanges?: Array<ValueTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	payment?: ValueTypes["CsobPaymentUpdatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	originalPayId?: string | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentUpdatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentWithoutCsobPaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CsobPaymentConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserPaymentWithoutCsobPaymentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CsobPaymentUpsertPaymentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentWithoutCsobPaymentUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentUpsertPaymentRelationInput"]: {
	update: ValueTypes["UserPaymentWithoutCsobPaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutCsobPaymentCreateInput"] | Variable<any, string>
};
	["CsobPaymentStatusChangeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	dttm?: string | undefined | null | Variable<any, string>,
	status?: number | undefined | null | Variable<any, string>,
	resultCode?: number | undefined | null | Variable<any, string>,
	message?: string | undefined | null | Variable<any, string>,
	authCode?: string | undefined | null | Variable<any, string>,
	statusDetail?: string | undefined | null | Variable<any, string>,
	actions?: string | undefined | null | Variable<any, string>,
	payment?: ValueTypes["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CsobPaymentWithoutStatusChangesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>
};
	["CsobPaymentWithoutStatusChangesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	payId?: string | undefined | null | Variable<any, string>,
	payment?: ValueTypes["CsobPaymentCreatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	originalPayId?: string | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"]: {
	connect: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CsobPaymentWithoutStatusChangesCreateInput"] | Variable<any, string>
};
	["CsobPaymentStatusChangeUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	dttm?: string | undefined | null | Variable<any, string>,
	status?: number | undefined | null | Variable<any, string>,
	resultCode?: number | undefined | null | Variable<any, string>,
	message?: string | undefined | null | Variable<any, string>,
	authCode?: string | undefined | null | Variable<any, string>,
	statusDetail?: string | undefined | null | Variable<any, string>,
	actions?: string | undefined | null | Variable<any, string>,
	payment?: ValueTypes["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["CsobPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CsobPaymentWithoutStatusChangesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CsobPaymentWithoutStatusChangesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CsobPaymentStatusChangeUpsertPaymentRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentWithoutStatusChangesUpdateInput"]: {
	payId?: string | undefined | null | Variable<any, string>,
	payment?: ValueTypes["CsobPaymentUpdatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	originalPayId?: string | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CsobPaymentStatusChangeUpsertPaymentRelationInput"]: {
	update: ValueTypes["CsobPaymentWithoutStatusChangesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CsobPaymentWithoutStatusChangesCreateInput"] | Variable<any, string>
};
	["StripePaymentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StripePaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentEdge"]: AliasType<{
	node?:ValueTypes["StripePayment"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	statusChanges?: Array<ValueTypes["StripePaymentCreateStatusChangesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	payment?: ValueTypes["StripePaymentCreatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentCreatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentWithoutStripePaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StripePaymentConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>
};
	["UserPaymentWithoutStripePaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentConnectOrCreatePaymentRelationInput"]: {
	connect: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutStripePaymentCreateInput"] | Variable<any, string>
};
	["StripePaymentUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	statusChanges?: Array<ValueTypes["StripePaymentUpdateStatusChangesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	payment?: ValueTypes["StripePaymentUpdatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentUpdatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentWithoutStripePaymentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StripePaymentConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserPaymentWithoutStripePaymentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StripePaymentUpsertPaymentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentWithoutStripePaymentUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	triesCollection?: ValueTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentUpsertPaymentRelationInput"]: {
	update: ValueTypes["UserPaymentWithoutStripePaymentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutStripePaymentCreateInput"] | Variable<any, string>
};
	["StripePaymentStatusChangeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["StripePaymentStatusChangeCreatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	timestamp?: number | undefined | null | Variable<any, string>,
	eventId?: string | undefined | null | Variable<any, string>,
	paymentIntentStatus?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangeCreatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StripePaymentWithoutStatusChangesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>
};
	["StripePaymentWithoutStatusChangesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	identifier?: string | undefined | null | Variable<any, string>,
	payment?: ValueTypes["StripePaymentCreatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"]: {
	connect: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StripePaymentWithoutStatusChangesCreateInput"] | Variable<any, string>
};
	["StripePaymentStatusChangeUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	payment?: ValueTypes["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	timestamp?: number | undefined | null | Variable<any, string>,
	eventId?: string | undefined | null | Variable<any, string>,
	paymentIntentStatus?: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["StripePaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StripePaymentWithoutStatusChangesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StripePaymentWithoutStatusChangesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StripePaymentStatusChangeUpsertPaymentRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentWithoutStatusChangesUpdateInput"]: {
	identifier?: string | undefined | null | Variable<any, string>,
	payment?: ValueTypes["StripePaymentUpdatePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StripePaymentStatusChangeUpsertPaymentRelationInput"]: {
	update: ValueTypes["StripePaymentWithoutStatusChangesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StripePaymentWithoutStatusChangesCreateInput"] | Variable<any, string>
};
	["RegionPaymentMethodCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	allowRecurringPayments?: boolean | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionPaymentMethodCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionPaymentMethodCreateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>
};
	["RegionWithoutEnabledPaymentMethodsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["RegionCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	donationItems?: Array<ValueTypes["RegionCreateDonationItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	timezone?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionPaymentMethodConnectOrCreateRegionRelationInput"]: {
	connect: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | Variable<any, string>
};
	["RegionPaymentMethodUpdateInput"]: {
	allowRecurringPayments?: boolean | undefined | null | Variable<any, string>,
	region?: ValueTypes["RegionPaymentMethodUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["PaymentMethods"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionPaymentMethodUpdateRegionEntityRelationInput"]: {
	connect?: ValueTypes["RegionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RegionPaymentMethodUpsertRegionRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RegionWithoutEnabledPaymentMethodsUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	donationItems?: Array<ValueTypes["RegionUpdateDonationItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	timezone?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RegionPaymentMethodUpsertRegionRelationInput"]: {
	update: ValueTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | Variable<any, string>
};
	["PostAreaMetaDataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaMetaDataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaMetaDataEdge"]: AliasType<{
	node?:ValueTypes["PostAreaMetaData"],
		__typename?: boolean | `@${string}`
}>;
	["PostMetaDataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostMetaDataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostMetaDataEdge"]: AliasType<{
	node?:ValueTypes["PostMetaData"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMetaDataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostOrganizationMetaDataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMetaDataEdge"]: AliasType<{
	node?:ValueTypes["PostOrganizationMetaData"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	type?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["TileItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["TileItemCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["TileItemCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["TileItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["TileItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["TileItemCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TileListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["TileListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	areaType?: ValueTypes["TileListCreateAreaTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TileListWithoutItemsCreateInput"] | Variable<any, string>
};
	["TileItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	type?: ValueTypes["TileItemType"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["TileItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["TileItemUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["TileItemUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["TileItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["TileItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["TileItemUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["TileListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TileListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TileListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileListWithoutItemsUpdateInput"]: {
	size?: ValueTypes["TileListSize"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	areaType?: ValueTypes["TileListUpdateAreaTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileItemUpsertListRelationInput"]: {
	update: ValueTypes["TileListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TileListWithoutItemsCreateInput"] | Variable<any, string>
};
	["TileListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TileListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TileListEdge"]: AliasType<{
	node?:ValueTypes["TileList"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FeedPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageEdge"]: AliasType<{
	node?:ValueTypes["FeedPage"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["FeedPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FeedPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined | null | Variable<any, string>,
	sectionList?: Array<ValueTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutFeedPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutFeedPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutFeedPagesCreateInput"] | Variable<any, string>
};
	["FeedPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FeedPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["FeedPageUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["FeedPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["FeedPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FeedPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FeedPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FeedPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["FeedPageLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined | null | Variable<any, string>,
	sectionList?: Array<ValueTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutFeedPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutFeedPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutFeedPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentPages?: Array<ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutFeedPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutFeedPagesCreateInput"] | Variable<any, string>
};
	["FeedPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FeedPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FeedPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["FeedPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined | null | Variable<any, string>,
	sectionList?: Array<ValueTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleUpdateInput"]: {
	root?: ValueTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined | null | Variable<any, string>,
	sectionList?: Array<ValueTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageSectionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	feedPageLocale?: ValueTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileStripeList?: Array<ValueTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageLocaleWithoutSectionListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["FeedPageLocaleWithoutSectionListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"]: {
	connect: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FeedPageLocaleWithoutSectionListCreateInput"] | Variable<any, string>
};
	["FeedPageSectionUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	feedPageLocale?: ValueTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileStripeList?: Array<ValueTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageLocaleWithoutSectionListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FeedPageLocaleWithoutSectionListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageSectionUpsertFeedPageLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageLocaleWithoutSectionListUpdateInput"]: {
	root?: ValueTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	heroTiles?: ValueTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined | null | Variable<any, string>,
	cardList?: ValueTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageSectionUpsertFeedPageLocaleRelationInput"]: {
	update: ValueTypes["FeedPageLocaleWithoutSectionListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FeedPageLocaleWithoutSectionListCreateInput"] | Variable<any, string>
};
	["FeedPageTileStripeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	section?: ValueTypes["FeedPageTileStripeCreateSectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileList?: ValueTypes["FeedPageTileStripeCreateTileListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeCreateSectionEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"] | undefined | null | Variable<any, string>
};
	["FeedPageSectionWithoutTileStripeListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	feedPageLocale?: ValueTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeConnectOrCreateSectionRelationInput"]: {
	connect: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | Variable<any, string>
};
	["FeedPageTileStripeUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	section?: ValueTypes["FeedPageTileStripeUpdateSectionEntityRelationInput"] | undefined | null | Variable<any, string>,
	tileList?: ValueTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeUpdateSectionEntityRelationInput"]: {
	connect?: ValueTypes["FeedPageSectionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FeedPageSectionWithoutTileStripeListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FeedPageTileStripeUpsertSectionRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageSectionWithoutTileStripeListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	feedPageLocale?: ValueTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FeedPageTileStripeUpsertSectionRelationInput"]: {
	update: ValueTypes["FeedPageSectionWithoutTileStripeListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | Variable<any, string>
};
	["CardItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["CardItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["CardItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CardItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["CardListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CardListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CardItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["CardListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CardItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CardListWithoutItemsCreateInput"] | Variable<any, string>
};
	["CardItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["CardItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["CardItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CardItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["CardListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CardListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CardItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CardListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CardItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CardListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CardItemUpsertListRelationInput"]: {
	update: ValueTypes["CardListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CardListWithoutItemsCreateInput"] | Variable<any, string>
};
	["CardListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CardListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CardListEdge"]: AliasType<{
	node?:ValueTypes["CardList"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserPaymentTriesCollectionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionEdge"]: AliasType<{
	node?:ValueTypes["UserPaymentTriesCollection"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	orderUrl?: string | undefined | null | Variable<any, string>,
	payment?: Array<ValueTypes["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurring?: ValueTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"] | undefined | null | Variable<any, string>,
	metadataLocales?: Array<ValueTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	medium?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserPaymentWithoutTriesCollectionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserPaymentWithoutTriesCollectionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"]: {
	connect: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutTriesCollectionCreateInput"] | Variable<any, string>
};
	["UserPaymentTriesCollectionUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	orderUrl?: string | undefined | null | Variable<any, string>,
	payment?: Array<ValueTypes["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]> | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurring?: ValueTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"] | undefined | null | Variable<any, string>,
	metadataLocales?: Array<ValueTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	medium?: ValueTypes["PaymentMedium"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]: {
	create?: ValueTypes["UserPaymentWithoutTriesCollectionCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserPaymentTriesCollectionUpdatePaymentRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["UserPaymentTriesCollectionUpsertPaymentRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["UserPaymentUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUpdatePaymentRelationInput"]: {
	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["UserPaymentWithoutTriesCollectionUpdateInput"] | Variable<any, string>
};
	["UserPaymentWithoutTriesCollectionUpdateInput"]: {
	cents?: number | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	specificSymbol?: string | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null | Variable<any, string>,
	csobPayment?: ValueTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	stripePayment?: ValueTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPaymentItem?: ValueTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	method?: ValueTypes["UserPaymentMethod"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	isReusable?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonation?: ValueTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null | Variable<any, string>,
	successEmailSentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	isSuccessful?: boolean | undefined | null | Variable<any, string>,
	isFinished?: boolean | undefined | null | Variable<any, string>,
	metadata?: ValueTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentTriesCollectionUpsertPaymentRelationInput"]: {
	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["UserPaymentWithoutTriesCollectionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserPaymentWithoutTriesCollectionCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RecurringPaymentPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageEdge"]: AliasType<{
	node?:ValueTypes["RecurringPaymentPage"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["RecurringPaymentPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutRecurringPaymentPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["RecurringPaymentPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RecurringPaymentPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecurringPaymentPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecurringPaymentPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutRecurringPaymentPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	generals?: Array<ValueTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postAreas?: Array<ValueTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postOrganizations?: Array<ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPageAboutSettings?: Array<ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postRevisions?: Array<ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	flagImage?: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	feedPages?: Array<ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	givenGiftsPages?: Array<ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	receivedGiftsPages?: Array<ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportPages?: Array<ValueTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	reportNavigations?: Array<ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	scheduledNotifications?: Array<ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	sentPayments?: Array<ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["RecurringPaymentPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecurringPaymentPageLocaleUpdateInput"]: {
	root?: ValueTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	favouritePosts?: ValueTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined | null | Variable<any, string>,
	storyGuideList?: ValueTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StoryGuideEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideEdge"]: AliasType<{
	node?:ValueTypes["StoryGuide"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["StoryGuideItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	guide?: ValueTypes["StoryGuideItemCreateGuideEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["StoryGuideListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StoryGuideListWithoutItemsCreateInput"] | Variable<any, string>
};
	["StoryGuideItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["StoryGuideItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	guide?: ValueTypes["StoryGuideItemUpdateGuideEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["StoryGuideListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StoryGuideListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StoryGuideItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StoryGuideListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StoryGuideItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StoryGuideItemUpsertListRelationInput"]: {
	update: ValueTypes["StoryGuideListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StoryGuideListWithoutItemsCreateInput"] | Variable<any, string>
};
	["StoryGuideListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StoryGuideListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListEdge"]: AliasType<{
	node?:ValueTypes["StoryGuideList"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StripePaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentMetadataEdge"]: AliasType<{
	node?:ValueTypes["StripePaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OnBehalfDonationMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMetadataEdge"]: AliasType<{
	node?:ValueTypes["OnBehalfDonationMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserPaymentTriesCollectionMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataEdge"]: AliasType<{
	node?:ValueTypes["UserPaymentTriesCollectionMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CsobPaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentMetadataEdge"]: AliasType<{
	node?:ValueTypes["CsobPaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostOrganizationListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListEdge"]: AliasType<{
	node?:ValueTypes["PostOrganizationList"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostOrganizationListItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostOrganizationListItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationListItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["PostOrganizationListItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["PostOrganizationListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListWithoutItemsCreateInput"] | Variable<any, string>
};
	["PostOrganizationListItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["PostOrganizationListItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["PostOrganizationListItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["PostOrganizationListItemType"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["PostOrganizationListItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["PostOrganizationListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostOrganizationListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PostOrganizationListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostOrganizationListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PostOrganizationListItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostOrganizationListItemUpsertListRelationInput"]: {
	update: ValueTypes["PostOrganizationListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostOrganizationListWithoutItemsCreateInput"] | Variable<any, string>
};
	["InfoCarousel"]: AliasType<{
	_meta?:ValueTypes["InfoCarouselMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	isEnabled?:boolean | `@${string}`,
	validFrom?:boolean | `@${string}`,
	validTo?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItem"]],
seenBy?: [{	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarousel"]],
itemsByLocales?: [{	by: ValueTypes["InfoCarouselItemsByLocalesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItem"]],
seenByByUser?: [{	by: ValueTypes["InfoCarouselSeenByByUserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarousel"]],
paginateItems?: [{	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemConnection"]],
paginateSeenBy?: [{	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	isEnabled?:ValueTypes["FieldMeta"],
	validFrom?:ValueTypes["FieldMeta"],
	validTo?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	seenBy?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItem"]: AliasType<{
	_meta?:ValueTypes["InfoCarouselItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
carousel?: [{	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarousel"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
post?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
	subtitle?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocale"]],
localesByLocale?: [{	by: ValueTypes["InfoCarouselItemLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocale"]],
paginateLocales?: [{	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	carousel?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	post?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	isEnabled?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	validFrom?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	validTo?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,
	seenBy?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["InfoCarouselWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["InfoCarouselWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["InfoCarouselItemTypeCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["InfoCarouselItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["InfoCarouselItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemTypeCondition"]: {
	and?: Array<ValueTypes["InfoCarouselItemTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["InfoCarouselItemTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["InfoCarouselItemTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["InfoCarouselItemType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["InfoCarouselItemType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemType"]:InfoCarouselItemType;
	["InfoCarouselItemLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	seenAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocale"]: AliasType<{
	_meta?:ValueTypes["InfoCarouselItemLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItem"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoCarouselItemOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["PostOrderBy"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["InfoCarouselOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isEnabled?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	validFrom?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	validTo?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InfoCarouselItemLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleEdge"]: AliasType<{
	node?:ValueTypes["InfoCarouselItemLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarousel"]: AliasType<{
	_meta?:ValueTypes["PersonSeenInfoCarouselMeta"],
	id?:boolean | `@${string}`,
	seenAt?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
carousel?: [{	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarousel"]],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	seenAt?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	carousel?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	seenAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserOrderBy"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselOrderBy"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselSeenByByUserUniqueWhere"]: {
	user?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InfoCarouselItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemEdge"]: AliasType<{
	node?:ValueTypes["InfoCarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PersonSeenInfoCarouselEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselEdge"]: AliasType<{
	node?:ValueTypes["PersonSeenInfoCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["InfoCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	seenBy?: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoCarouselConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InfoCarouselEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselEdge"]: AliasType<{
	node?:ValueTypes["InfoCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	isEnabled?: boolean | undefined | null | Variable<any, string>,
	validFrom?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	validTo?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["InfoCarouselCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seenBy?: Array<ValueTypes["InfoCarouselCreateSeenByEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["InfoCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoCarouselItemWithoutCarouselCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["InfoCarouselItemWithoutCarouselCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["InfoCarouselItemCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemCreatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemConnectOrCreatePostRelationInput"]: {
	connect: ValueTypes["PostUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PostCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["InfoCarouselConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselItemWithoutCarouselCreateInput"] | Variable<any, string>
};
	["InfoCarouselCreateSeenByEntityRelationInput"]: {
	connect?: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselConnectOrCreateSeenByRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselWithoutCarouselCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	seenAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"]: {
	connect: ValueTypes["UserUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserCreateInput"] | Variable<any, string>
};
	["InfoCarouselConnectOrCreateSeenByRelationInput"]: {
	connect: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | Variable<any, string>
};
	["InfoCarouselUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	isEnabled?: boolean | undefined | null | Variable<any, string>,
	validFrom?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	validTo?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["InfoCarouselUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seenBy?: Array<ValueTypes["InfoCarouselUpdateSeenByEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["InfoCarouselItemWithoutCarouselCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoCarouselUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoCarouselUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["InfoCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["InfoCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["InfoCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["InfoCarouselUpdateItemsRelationInput"]: {
	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["InfoCarouselItemWithoutCarouselUpdateInput"] | Variable<any, string>
};
	["InfoCarouselItemWithoutCarouselUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoCarouselItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemUpdatePostEntityRelationInput"]: {
	connect?: ValueTypes["PostUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["PostCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemConnectOrCreatePostRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["PostUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoCarouselItemUpsertPostRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemUpsertPostRelationInput"]: {
	update: ValueTypes["PostUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PostCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoCarouselItemUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoCarouselItemUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["InfoCarouselItemUpdateLocalesRelationInput"]: {
	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["InfoCarouselItemLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoCarouselItemLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemUpsertLocalesRelationInput"]: {
	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["InfoCarouselUpsertItemsRelationInput"]: {
	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["InfoCarouselItemWithoutCarouselUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselItemWithoutCarouselCreateInput"] | Variable<any, string>
};
	["InfoCarouselUpdateSeenByEntityRelationInput"]: {
	create?: ValueTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoCarouselUpdateSeenByRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoCarouselUpsertSeenByRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["InfoCarouselUpdateSeenByRelationInput"]: {
	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"] | Variable<any, string>
};
	["PersonSeenInfoCarouselWithoutCarouselUpdateInput"]: {
	seenAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselUpdateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PersonSeenInfoCarouselUpsertUserRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselUpsertUserRelationInput"]: {
	update: ValueTypes["UserUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserCreateInput"] | Variable<any, string>
};
	["InfoCarouselUpsertSeenByRelationInput"]: {
	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"] | Variable<any, string>,
	create: ValueTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselItemCreateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["InfoCarouselItemCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemCreateCarouselEntityRelationInput"]: {
	connect?: ValueTypes["InfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoCarouselWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoCarouselWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	isEnabled?: boolean | undefined | null | Variable<any, string>,
	validFrom?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	validTo?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	seenBy?: Array<ValueTypes["InfoCarouselCreateSeenByEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemConnectOrCreateCarouselRelationInput"]: {
	connect: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselWithoutItemsCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemUpdateCarouselEntityRelationInput"]: {
	connect?: ValueTypes["InfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoCarouselWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoCarouselWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoCarouselItemUpsertCarouselRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselWithoutItemsUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	isEnabled?: boolean | undefined | null | Variable<any, string>,
	validFrom?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	validTo?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	seenBy?: Array<ValueTypes["InfoCarouselUpdateSeenByEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemUpsertCarouselRelationInput"]: {
	update: ValueTypes["InfoCarouselWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselWithoutItemsCreateInput"] | Variable<any, string>
};
	["PersonSeenInfoCarouselCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	seenAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"]: {
	connect?: ValueTypes["InfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoCarouselWithoutSeenByCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoCarouselWithoutSeenByCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	isEnabled?: boolean | undefined | null | Variable<any, string>,
	validFrom?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	validTo?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["InfoCarouselCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"]: {
	connect: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselWithoutSeenByCreateInput"] | Variable<any, string>
};
	["PersonSeenInfoCarouselUpdateInput"]: {
	seenAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"]: {
	connect?: ValueTypes["InfoCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoCarouselWithoutSeenByCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoCarouselWithoutSeenByUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["PersonSeenInfoCarouselUpsertCarouselRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselWithoutSeenByUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	isEnabled?: boolean | undefined | null | Variable<any, string>,
	validFrom?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	validTo?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["InfoCarouselUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PersonSeenInfoCarouselUpsertCarouselRelationInput"]: {
	update: ValueTypes["InfoCarouselWithoutSeenByUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselWithoutSeenByCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GivenGiftsPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageEdge"]: AliasType<{
	node?:ValueTypes["GivenGiftsPage"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GivenGiftsPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GivenGiftsPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GivenGiftsPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GivenGiftsPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GivenGiftsPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GivenGiftsPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["GivenGiftsPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GivenGiftsPageLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReceivedGiftsPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageEdge"]: AliasType<{
	node?:ValueTypes["ReceivedGiftsPage"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ReceivedGiftsPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReceivedGiftsPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReceivedGiftsPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ReceivedGiftsPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReceivedGiftsPageLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	giftText?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReportNavigationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationEdge"]: AliasType<{
	node?:ValueTypes["ReportNavigation"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ReportNavigationCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportNavigationLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportNavigationConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	pages?: Array<ValueTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportNavigationLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ReportNavigationUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ReportNavigationUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ReportNavigationLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReportNavigationUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportNavigationUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportNavigationUpdateLocalesRelationInput"]: {
	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ReportNavigationLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["ReportNavigationLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	pages?: Array<ValueTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationUpsertLocalesRelationInput"]: {
	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ReportNavigationLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportNavigationLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ReportPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReportPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageEdge"]: AliasType<{
	node?:ValueTypes["ReportPage"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ReportPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ReportPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ReportPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ReportPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ReportPageUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ReportPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ReportPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ReportPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ReportPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ReportPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ReportPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ReportPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["ReportPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ReportPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ReportPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ReportPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportPageLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	postTitle?: string | undefined | null | Variable<any, string>,
	giftTitle?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	pages?: Array<ValueTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ReportNavigationLocaleUpdateInput"]: {
	root?: ValueTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	pages?: Array<ValueTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	cents?: number | undefined | null | Variable<any, string>,
	sendAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	area?: ValueTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined | null | Variable<any, string>,
	organization?: ValueTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["PostAreaSentPaymentSumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaSentPaymentSumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentSumEdge"]: AliasType<{
	node?:ValueTypes["PostAreaSentPaymentSum"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NotificationTargetGroupEdge"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupEdge"]: AliasType<{
	node?:ValueTypes["NotificationTargetGroup"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProcessedNotificationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationEdge"]: AliasType<{
	node?:ValueTypes["ProcessedNotification"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	topic?: string | undefined | null | Variable<any, string>,
	sentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	errorMessage?: string | undefined | null | Variable<any, string>,
	errorCode?: string | undefined | null | Variable<any, string>,
	isSuccess?: boolean | undefined | null | Variable<any, string>,
	source?: ValueTypes["ProcessedNotificationCreateSourceEntityRelationInput"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	body?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationCreateSourceEntityRelationInput"]: {
	connect?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"] | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	donationReminderUser?: ValueTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	scheduledNotification?: ValueTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationConnectOrCreateSourceRelationInput"]: {
	connect: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | Variable<any, string>
};
	["ProcessedNotificationUpdateInput"]: {
	topic?: string | undefined | null | Variable<any, string>,
	sentAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	errorMessage?: string | undefined | null | Variable<any, string>,
	errorCode?: string | undefined | null | Variable<any, string>,
	isSuccess?: boolean | undefined | null | Variable<any, string>,
	source?: ValueTypes["ProcessedNotificationUpdateSourceEntityRelationInput"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	body?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationUpdateSourceEntityRelationInput"]: {
	connect?: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ProcessedNotificationUpsertSourceRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"]: {
	type?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	donationReminderUser?: ValueTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	scheduledNotification?: ValueTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationUpsertSourceRelationInput"]: {
	update: ValueTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ScheduledNotificationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationEdge"]: AliasType<{
	node?:ValueTypes["ScheduledNotification"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	localMsFromMidnight?: number | undefined | null | Variable<any, string>,
	scheduledDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	internalTitle?: string | undefined | null | Variable<any, string>,
	target?: ValueTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ScheduledNotificationCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	image?: ValueTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationUpdateInput"]: {
	localMsFromMidnight?: number | undefined | null | Variable<any, string>,
	scheduledDate?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	internalTitle?: string | undefined | null | Variable<any, string>,
	target?: ValueTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	image?: ValueTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	donationReminderUser?: ValueTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	scheduledNotification?: ValueTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ProcessedNotificationSourceUpdateInput"]: {
	type?: ValueTypes["ProcessedNotificationSourceType"] | undefined | null | Variable<any, string>,
	processedNotification?: ValueTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	donationReminderUser?: ValueTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	scheduledNotification?: ValueTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DeviceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["DeviceCreateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	fcmToken?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	ipAddress?: string | undefined | null | Variable<any, string>,
	userAgent?: string | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DeviceCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutDevicesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DeviceConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>
};
	["UserWithoutDevicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserCreateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DeviceConnectOrCreateUserRelationInput"]: {
	connect: ValueTypes["UserUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["UserWithoutDevicesCreateInput"] | Variable<any, string>
};
	["DeviceUpdateInput"]: {
	user?: ValueTypes["DeviceUpdateUserEntityRelationInput"] | undefined | null | Variable<any, string>,
	fcmToken?: string | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	ipAddress?: string | undefined | null | Variable<any, string>,
	userAgent?: string | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DeviceUpdateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["UserWithoutDevicesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["DeviceConnectOrCreateUserRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["UserWithoutDevicesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["DeviceUpsertUserRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["UserWithoutDevicesUpdateInput"]: {
	tenantPersonId?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	payments?: Array<ValueTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	variableSymbol?: number | undefined | null | Variable<any, string>,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	region?: ValueTypes["UserUpdateRegionEntityRelationInput"] | undefined | null | Variable<any, string>,
	currency?: ValueTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null | Variable<any, string>,
	recurringPayments?: Array<ValueTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	stripeId?: string | undefined | null | Variable<any, string>,
	isDeactivated?: boolean | undefined | null | Variable<any, string>,
	onBehalfDonations?: Array<ValueTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	publicProfileSecret?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNote?: string | undefined | null | Variable<any, string>,
	publicProfileCustomNoteEnabled?: boolean | undefined | null | Variable<any, string>,
	donationConfirmationEmailEnabled?: boolean | undefined | null | Variable<any, string>,
	locale?: ValueTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	signedUp?: boolean | undefined | null | Variable<any, string>,
	processedNotifications?: Array<ValueTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	areaStats?: Array<ValueTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	organizationStats?: Array<ValueTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	postStats?: Array<ValueTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	currencyStats?: Array<ValueTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["DeviceUpsertUserRelationInput"]: {
	update: ValueTypes["UserWithoutDevicesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["UserWithoutDevicesCreateInput"] | Variable<any, string>
};
	["ScheduledNotificationLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ScheduledNotificationLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoCarouselItemLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["InfoCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoCarouselItemWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoCarouselItemWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselItemCreateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselItemWithoutLocalesCreateInput"] | Variable<any, string>
};
	["InfoCarouselItemLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoCarouselItemLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["InfoCarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoCarouselItemWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoCarouselItemWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoCarouselItemLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	post?: ValueTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["InfoCarouselItemType"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoCarouselItemLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["InfoCarouselItemWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoCarouselItemWithoutLocalesCreateInput"] | Variable<any, string>
};
	["SentPaymentLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	organizationText?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["SentPaymentLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SentPaymentLocaleUpdateInput"]: {
	organizationText?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["SentPaymentLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["UserPaymentMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserPaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentMetadataEdge"]: AliasType<{
	node?:ValueTypes["UserPaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostAreaSumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSumEdge"]: AliasType<{
	node?:ValueTypes["PostAreaSum"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationSumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostOrganizationSumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationSumEdge"]: AliasType<{
	node?:ValueTypes["PostOrganizationSum"],
		__typename?: boolean | `@${string}`
}>;
	["Stats"]: AliasType<{
	_meta?:ValueTypes["StatsMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
	totalUserCount?:boolean | `@${string}`,
	successfulPaymentCount?:boolean | `@${string}`,
	sentPaymentCount?:boolean | `@${string}`,
	totalAreaCents?:boolean | `@${string}`,
	totalAreaSentPaymentCents?:boolean | `@${string}`,
	totalAreaCzkPercentage?:boolean | `@${string}`,
	totalAreaSentPaymentCzkPercentage?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StatsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	totalUserCount?:ValueTypes["FieldMeta"],
	successfulPaymentCount?:ValueTypes["FieldMeta"],
	sentPaymentCount?:ValueTypes["FieldMeta"],
	totalAreaCents?:ValueTypes["FieldMeta"],
	totalAreaSentPaymentCents?:ValueTypes["FieldMeta"],
	totalAreaCzkPercentage?:ValueTypes["FieldMeta"],
	totalAreaSentPaymentCzkPercentage?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StatsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>
};
	["StatsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	totalUserCount?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	successfulPaymentCount?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	sentPaymentCount?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	totalAreaCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	totalAreaSentPaymentCents?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	totalAreaCzkPercentage?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	totalAreaSentPaymentCzkPercentage?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["StatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StatsWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StatsWhere"] | undefined | null | Variable<any, string>
};
	["StatsOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalUserCount?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successfulPaymentCount?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	sentPaymentCount?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalAreaCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalAreaSentPaymentCents?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalAreaCzkPercentage?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	totalAreaSentPaymentCzkPercentage?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["StatsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEdge"]: AliasType<{
	node?:ValueTypes["Stats"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserRecurringPaymentItemMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMetadataEdge"]: AliasType<{
	node?:ValueTypes["UserRecurringPaymentItemMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["UpcomingUserRecurringPaymentMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UpcomingUserRecurringPaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UpcomingUserRecurringPaymentMetadataEdge"]: AliasType<{
	node?:ValueTypes["UpcomingUserRecurringPaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["UserStatsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserStatsEdge"]: AliasType<{
	node?:ValueTypes["UserStats"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextImageListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListEdge"]: AliasType<{
	node?:ValueTypes["TextImageList"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["TextImageListItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["TextImageListItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["TextImageListItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["TextImageListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextImageListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextImageListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["TextImageListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TextImageListWithoutItemsCreateInput"] | Variable<any, string>
};
	["TextImageListItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["TextImageListItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["TextImageListItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["TextImageListItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["TextImageListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextImageListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextImageListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TextImageListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TextImageListItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextImageListItemUpsertListRelationInput"]: {
	update: ValueTypes["TextImageListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TextImageListWithoutItemsCreateInput"] | Variable<any, string>
};
	["PostSumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostSumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostSumEdge"]: AliasType<{
	node?:ValueTypes["PostSum"],
		__typename?: boolean | `@${string}`
}>;
	["PostFundraisingProgressConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PostFundraisingProgressEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostFundraisingProgressEdge"]: AliasType<{
	node?:ValueTypes["PostFundraisingProgress"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["HeroCarouselItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["HeroCarouselItemCreateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["HeroCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeroCarouselWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeroCarouselItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["HeroCarouselWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["HeroCarouselCreatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeroCarouselWithoutItemsCreateInput"] | Variable<any, string>
};
	["HeroCarouselItemUpdateInput"]: {
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["HeroCarouselItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["HeroCarouselItemUpdateItemEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["HeroCarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeroCarouselWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeroCarouselItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeroCarouselWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeroCarouselItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselWithoutItemsUpdateInput"]: {
	createdAt?: ValueTypes["Date"] | undefined | null | Variable<any, string>,
	posts?: Array<ValueTypes["HeroCarouselUpdatePostsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeroCarouselItemUpsertListRelationInput"]: {
	update: ValueTypes["HeroCarouselWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeroCarouselWithoutItemsCreateInput"] | Variable<any, string>
};
	["QueryTransaction"]: AliasType<{
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
getGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["General"]],
listGeneral?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["General"]],
paginateGeneral?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralConnection"]],
validateCreateGeneral?: [{	data: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GeneralUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
listImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Image"]],
paginateImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
listGenericPage?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
paginateGenericPage?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
listLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkableUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
listSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
paginateSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SeoUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
listContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Content"]],
paginateContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentReferenceLinkableItem?: [{	by: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
listContentReferenceLinkableItem?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
paginateContentReferenceLinkableItem?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItemConnection"]],
getGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
listGeneralLocale?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
paginateGeneralLocale?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleConnection"]],
validateCreateGeneralLocale?: [{	data: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
listGenericPageLocale?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
paginateGenericPageLocale?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleConnection"]],
validateCreateGenericPageLocale?: [{	data: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
listLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
paginateLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
listVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Video"]],
paginateVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	data: ValueTypes["VideoUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
listLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Link"]],
paginateLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["Post"]],
listPost?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Post"]],
paginatePost?: [{	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostConnection"]],
validateCreatePost?: [{	data: ValueTypes["PostCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
listPostLocale?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostLocale"]],
paginatePostLocale?: [{	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostLocaleConnection"]],
validateCreatePostLocale?: [{	data: ValueTypes["PostLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
listPostArea?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostArea"]],
paginatePostArea?: [{	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaConnection"]],
validateCreatePostArea?: [{	data: ValueTypes["PostAreaCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
listPostAreaLocale?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocale"]],
paginatePostAreaLocale?: [{	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocaleConnection"]],
validateCreatePostAreaLocale?: [{	data: ValueTypes["PostAreaLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostAreaLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
listPostOrganization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganization"]],
paginatePostOrganization?: [{	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationConnection"]],
validateCreatePostOrganization?: [{	data: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostOrganizationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
listPostOrganizationLocale?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocale"]],
paginatePostOrganizationLocale?: [{	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocaleConnection"]],
validateCreatePostOrganizationLocale?: [{	data: ValueTypes["PostOrganizationLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostOrganizationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["Donation"]],
listDonation?: [{	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Donation"]],
paginateDonation?: [{	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationConnection"]],
validateCreateDonation?: [{	data: ValueTypes["DonationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DonationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItem"]],
listDonationAmountItem?: [{	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItem"]],
paginateDonationAmountItem?: [{	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItemConnection"]],
validateCreateDonationAmountItem?: [{	data: ValueTypes["DonationAmountItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DonationAmountItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
listDonationAmountsRegionItem?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItem"]],
paginateDonationAmountsRegionItem?: [{	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItemConnection"]],
validateCreateDonationAmountsRegionItem?: [{	data: ValueTypes["DonationAmountsRegionItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DonationAmountsRegionItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionList"]],
listDonationAmountsRegionList?: [{	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionList"]],
paginateDonationAmountsRegionList?: [{	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DonationAmountsRegionListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionListConnection"]],
validateCreateDonationAmountsRegionList?: [{	data: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DonationAmountsRegionListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Region"]],
listRegion?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Region"]],
paginateRegion?: [{	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RegionConnection"]],
validateCreateRegion?: [{	data: ValueTypes["RegionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RegionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkItem"]],
listLinkItem?: [{	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["LinkItem"]],
paginateLinkItem?: [{	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data: ValueTypes["LinkItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkList"]],
listLinkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data: ValueTypes["LinkListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["Header"]],
listHeader?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Header"]],
paginateHeader?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeaderUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
listFooter?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
paginateFooter?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
listFooterLocale?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostList"]],
listPostList?: [{	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostList"]],
paginatePostList?: [{	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostListConnection"]],
validateCreatePostList?: [{	data: ValueTypes["PostListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostListItem"]],
listPostListItem?: [{	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostListItem"]],
paginatePostListItem?: [{	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostListItemConnection"]],
validateCreatePostListItem?: [{	data: ValueTypes["PostListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["AppBanner"]],
listAppBanner?: [{	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AppBannerOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["AppBanner"]],
paginateAppBanner?: [{	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AppBannerOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["AppBannerConnection"]],
validateCreateAppBanner?: [{	data: ValueTypes["AppBannerCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	data: ValueTypes["AppBannerUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettings"]],
listGenericPageAboutSettings?: [{	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettings"]],
paginateGenericPageAboutSettings?: [{	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsConnection"]],
validateCreateGenericPageAboutSettings?: [{	data: ValueTypes["GenericPageAboutSettingsCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageAboutSettingsUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
listGenericPageAboutSettingsLocale?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocale"]],
paginateGenericPageAboutSettingsLocale?: [{	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleConnection"]],
validateCreateGenericPageAboutSettingsLocale?: [{	data: ValueTypes["GenericPageAboutSettingsLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageAboutSettingsLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["Value"]],
listValue?: [{	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Value"]],
paginateValue?: [{	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ValueConnection"]],
validateCreateValue?: [{	data: ValueTypes["ValueCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ValueUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueItem"]],
listValueItem?: [{	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ValueItem"]],
paginateValueItem?: [{	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ValueItemConnection"]],
validateCreateValueItem?: [{	data: ValueTypes["ValueItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ValueItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueList"]],
listValueList?: [{	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ValueList"]],
paginateValueList?: [{	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ValueListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ValueListConnection"]],
validateCreateValueList?: [{	data: ValueTypes["ValueListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ValueListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLink"]],
listImageLink?: [{	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLink"]],
paginateImageLink?: [{	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkConnection"]],
validateCreateImageLink?: [{	data: ValueTypes["ImageLinkCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageLinkUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItem"]],
listImageLinkItem?: [{	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItem"]],
paginateImageLinkItem?: [{	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItemConnection"]],
validateCreateImageLinkItem?: [{	data: ValueTypes["ImageLinkItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageLinkItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkList"]],
listImageLinkList?: [{	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkList"]],
paginateImageLinkList?: [{	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageLinkListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageLinkListConnection"]],
validateCreateImageLinkList?: [{	data: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageLinkListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaList"]],
listPostAreaList?: [{	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaList"]],
paginatePostAreaList?: [{	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaListConnection"]],
validateCreatePostAreaList?: [{	data: ValueTypes["PostAreaListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostAreaListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItem"]],
listPostAreaListItem?: [{	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItem"]],
paginatePostAreaListItem?: [{	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItemConnection"]],
validateCreatePostAreaListItem?: [{	data: ValueTypes["PostAreaListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostAreaListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>},ValueTypes["Accordion"]],
listAccordion?: [{	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Accordion"]],
paginateAccordion?: [{	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["AccordionConnection"]],
validateCreateAccordion?: [{	data: ValueTypes["AccordionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["AccordionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["AccordionItem"]],
listAccordionItem?: [{	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["AccordionItem"]],
paginateAccordionItem?: [{	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["AccordionItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["AccordionItemConnection"]],
validateCreateAccordionItem?: [{	data: ValueTypes["AccordionItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["AccordionItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["User"]],
listUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["User"]],
paginateUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserConnection"]],
validateCreateUser?: [{	data: ValueTypes["UserCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
listUserPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPayment"]],
paginateUserPayment?: [{	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentConnection"]],
validateCreateUserPayment?: [{	data: ValueTypes["UserPaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserPaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
listCurrency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CurrencyOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Currency"]],
paginateCurrency?: [{	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CurrencyOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CurrencyConnection"]],
validateCreateCurrency?: [{	data: ValueTypes["CurrencyCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
listMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
paginateMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
listMediumItem?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
paginateMediumItem?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
listMediumList?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
paginateMediumList?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderId"]],
listUserPaymentOrderId?: [{	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderIdOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderId"]],
paginateUserPaymentOrderId?: [{	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentOrderIdOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderIdConnection"]],
validateCreateUserPaymentOrderId?: [{	data: ValueTypes["UserPaymentOrderIdCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserPaymentOrderIdUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
listPostRevision?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevision"]],
paginatePostRevision?: [{	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionConnection"]],
validateCreatePostRevision?: [{	data: ValueTypes["PostRevisionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostRevisionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
listUserRecurringPayment?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPayment"]],
paginateUserRecurringPayment?: [{	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentConnection"]],
validateCreateUserRecurringPayment?: [{	data: ValueTypes["UserRecurringPaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserRecurringPaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
listUserRecurringPaymentItem?: [{	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItem"]],
paginateUserRecurringPaymentItem?: [{	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemConnection"]],
validateCreateUserRecurringPaymentItem?: [{	data: ValueTypes["UserRecurringPaymentItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserRecurringPaymentItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
listPostRevisionLocale?: [{	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocale"]],
paginatePostRevisionLocale?: [{	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostRevisionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocaleConnection"]],
validateCreatePostRevisionLocale?: [{	data: ValueTypes["PostRevisionLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostRevisionLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data: ValueTypes["TranslationCatalogueCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationCatalogueUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationCataloguesIdentifierUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationDomainOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationDomainOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data: ValueTypes["TranslationDomainCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationDomainUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationKey"]],
listTranslationKey?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data: ValueTypes["TranslationKeyCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationKeyUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationValue"]],
listTranslationValue?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data: ValueTypes["TranslationValueCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationValueUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocale"]],
listGenericPageAboutGroupLinksLocale?: [{	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocale"]],
paginateGenericPageAboutGroupLinksLocale?: [{	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleConnection"]],
validateCreateGenericPageAboutGroupLinksLocale?: [{	data: ValueTypes["GenericPageAboutGroupLinksLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberList"]],
listMemberList?: [{	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MemberList"]],
paginateMemberList?: [{	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MemberListConnection"]],
validateCreateMemberList?: [{	data: ValueTypes["MemberListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MemberListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberListItem"]],
listMemberListItem?: [{	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MemberListItem"]],
paginateMemberListItem?: [{	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MemberListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MemberListItemConnection"]],
validateCreateMemberListItem?: [{	data: ValueTypes["MemberListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MemberListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxForm"]],
listFilledTaxForm?: [{	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FilledTaxFormOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FilledTaxForm"]],
paginateFilledTaxForm?: [{	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FilledTaxFormOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormConnection"]],
validateCreateFilledTaxForm?: [{	data: ValueTypes["FilledTaxFormCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FilledTaxFormUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddress"]],
listFilledTaxFormEmailAddress?: [{	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FilledTaxFormEmailAddressOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddress"]],
paginateFilledTaxFormEmailAddress?: [{	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FilledTaxFormEmailAddressOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressConnection"]],
validateCreateFilledTaxFormEmailAddress?: [{	data: ValueTypes["FilledTaxFormEmailAddressCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FilledTaxFormEmailAddressUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>},ValueTypes["Form"]],
listForm?: [{	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FormOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Form"]],
paginateForm?: [{	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FormOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FormConnection"]],
validateCreateForm?: [{	data: ValueTypes["FormCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FormUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPayment"]],
listCsobPayment?: [{	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPayment"]],
paginateCsobPayment?: [{	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentConnection"]],
validateCreateCsobPayment?: [{	data: ValueTypes["CsobPaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CsobPaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChange"]],
listCsobPaymentStatusChange?: [{	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChange"]],
paginateCsobPaymentStatusChange?: [{	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeConnection"]],
validateCreateCsobPaymentStatusChange?: [{	data: ValueTypes["CsobPaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CsobPaymentStatusChangeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePayment"]],
listStripePayment?: [{	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StripePayment"]],
paginateStripePayment?: [{	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentConnection"]],
validateCreateStripePayment?: [{	data: ValueTypes["StripePaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StripePaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChange"]],
listStripePaymentStatusChange?: [{	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChange"]],
paginateStripePaymentStatusChange?: [{	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChangeConnection"]],
validateCreateStripePaymentStatusChange?: [{	data: ValueTypes["StripePaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StripePaymentStatusChangeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethod"]],
listRegionPaymentMethod?: [{	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionPaymentMethodOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethod"]],
paginateRegionPaymentMethod?: [{	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RegionPaymentMethodOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethodConnection"]],
validateCreateRegionPaymentMethod?: [{	data: ValueTypes["RegionPaymentMethodCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RegionPaymentMethodUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaMetaData?: [{	by: ValueTypes["PostAreaMetaDataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaMetaData"]],
listPostAreaMetaData?: [{	filter?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaMetaData"]],
paginatePostAreaMetaData?: [{	filter?: ValueTypes["PostAreaMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaMetaDataConnection"]],
getPostMetaData?: [{	by: ValueTypes["PostMetaDataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostMetaData"]],
listPostMetaData?: [{	filter?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostMetaData"]],
paginatePostMetaData?: [{	filter?: ValueTypes["PostMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostMetaDataConnection"]],
getPostOrganizationMetaData?: [{	by: ValueTypes["PostOrganizationMetaDataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationMetaData"]],
listPostOrganizationMetaData?: [{	filter?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationMetaData"]],
paginatePostOrganizationMetaData?: [{	filter?: ValueTypes["PostOrganizationMetaDataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationMetaDataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationMetaDataConnection"]],
getTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileItem"]],
listTileItem?: [{	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TileItem"]],
paginateTileItem?: [{	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TileItemConnection"]],
validateCreateTileItem?: [{	data: ValueTypes["TileItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TileItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileList"]],
listTileList?: [{	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TileList"]],
paginateTileList?: [{	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TileListConnection"]],
validateCreateTileList?: [{	data: ValueTypes["TileListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TileListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPage"]],
listFeedPage?: [{	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPage"]],
paginateFeedPage?: [{	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageConnection"]],
validateCreateFeedPage?: [{	data: ValueTypes["FeedPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FeedPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
listFeedPageLocale?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocale"]],
paginateFeedPageLocale?: [{	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocaleConnection"]],
validateCreateFeedPageLocale?: [{	data: ValueTypes["FeedPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FeedPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageSection"]],
listFeedPageSection?: [{	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageSectionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageSection"]],
paginateFeedPageSection?: [{	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageSectionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageSectionConnection"]],
validateCreateFeedPageSection?: [{	data: ValueTypes["FeedPageSectionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FeedPageSectionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripe"]],
listFeedPageTileStripe?: [{	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageTileStripeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripe"]],
paginateFeedPageTileStripe?: [{	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FeedPageTileStripeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripeConnection"]],
validateCreateFeedPageTileStripe?: [{	data: ValueTypes["FeedPageTileStripeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FeedPageTileStripeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardItem"]],
listCardItem?: [{	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CardItem"]],
paginateCardItem?: [{	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CardItemConnection"]],
validateCreateCardItem?: [{	data: ValueTypes["CardItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CardItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardList"]],
listCardList?: [{	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CardList"]],
paginateCardList?: [{	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CardListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CardListConnection"]],
validateCreateCardList?: [{	data: ValueTypes["CardListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CardListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
listOnBehalfDonation?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonation"]],
paginateOnBehalfDonation?: [{	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationConnection"]],
validateCreateOnBehalfDonation?: [{	data: ValueTypes["OnBehalfDonationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["OnBehalfDonationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollection"]],
listUserPaymentTriesCollection?: [{	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollection"]],
paginateUserPaymentTriesCollection?: [{	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionConnection"]],
validateCreateUserPaymentTriesCollection?: [{	data: ValueTypes["UserPaymentTriesCollectionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["UserPaymentTriesCollectionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPage"]],
listRecurringPaymentPage?: [{	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPage"]],
paginateRecurringPaymentPage?: [{	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageConnection"]],
validateCreateRecurringPaymentPage?: [{	data: ValueTypes["RecurringPaymentPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecurringPaymentPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
listRecurringPaymentPageLocale?: [{	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocale"]],
paginateRecurringPaymentPageLocale?: [{	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleConnection"]],
validateCreateRecurringPaymentPageLocale?: [{	data: ValueTypes["RecurringPaymentPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecurringPaymentPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuide"]],
listStoryGuide?: [{	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuide"]],
paginateStoryGuide?: [{	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideConnection"]],
validateCreateStoryGuide?: [{	data: ValueTypes["StoryGuideCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StoryGuideUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItem"]],
listStoryGuideItem?: [{	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItem"]],
paginateStoryGuideItem?: [{	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItemConnection"]],
validateCreateStoryGuideItem?: [{	data: ValueTypes["StoryGuideItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StoryGuideItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideList"]],
listStoryGuideList?: [{	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideList"]],
paginateStoryGuideList?: [{	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StoryGuideListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StoryGuideListConnection"]],
validateCreateStoryGuideList?: [{	data: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StoryGuideListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStripePaymentMetadata?: [{	by: ValueTypes["StripePaymentMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentMetadata"]],
listStripePaymentMetadata?: [{	filter?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentMetadata"]],
paginateStripePaymentMetadata?: [{	filter?: ValueTypes["StripePaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StripePaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StripePaymentMetadataConnection"]],
getOnBehalfDonationMetadata?: [{	by: ValueTypes["OnBehalfDonationMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationMetadata"]],
listOnBehalfDonationMetadata?: [{	filter?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationMetadata"]],
paginateOnBehalfDonationMetadata?: [{	filter?: ValueTypes["OnBehalfDonationMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["OnBehalfDonationMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationMetadataConnection"]],
getUserPaymentTriesCollectionMetadata?: [{	by: ValueTypes["UserPaymentTriesCollectionMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadata"]],
listUserPaymentTriesCollectionMetadata?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadata"]],
paginateUserPaymentTriesCollectionMetadata?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataConnection"]],
getUserPaymentTriesCollectionMetadataLocale?: [{	by: ValueTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocale"]],
listUserPaymentTriesCollectionMetadataLocale?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocale"]],
paginateUserPaymentTriesCollectionMetadataLocale?: [{	filter?: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionMetadataLocaleConnection"]],
getCsobPaymentMetadata?: [{	by: ValueTypes["CsobPaymentMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentMetadata"]],
listCsobPaymentMetadata?: [{	filter?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentMetadata"]],
paginateCsobPaymentMetadata?: [{	filter?: ValueTypes["CsobPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CsobPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentMetadataConnection"]],
getHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarousel"]],
listHeroCarousel?: [{	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarousel"]],
paginateHeroCarousel?: [{	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselConnection"]],
validateCreateHeroCarousel?: [{	data: ValueTypes["HeroCarouselCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeroCarouselUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationList"]],
listPostOrganizationList?: [{	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationList"]],
paginatePostOrganizationList?: [{	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListConnection"]],
validateCreatePostOrganizationList?: [{	data: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItem"]],
listPostOrganizationListItem?: [{	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItem"]],
paginatePostOrganizationListItem?: [{	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItemConnection"]],
validateCreatePostOrganizationListItem?: [{	data: ValueTypes["PostOrganizationListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PostOrganizationListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarousel"]],
listInfoCarousel?: [{	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarousel"]],
paginateInfoCarousel?: [{	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselConnection"]],
validateCreateInfoCarousel?: [{	data: ValueTypes["InfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoCarouselUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItem"]],
listInfoCarouselItem?: [{	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItem"]],
paginateInfoCarouselItem?: [{	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemConnection"]],
validateCreateInfoCarouselItem?: [{	data: ValueTypes["InfoCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoCarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarousel"]],
listPersonSeenInfoCarousel?: [{	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarousel"]],
paginatePersonSeenInfoCarousel?: [{	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselConnection"]],
validateCreatePersonSeenInfoCarousel?: [{	data: ValueTypes["PersonSeenInfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdatePersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	data: ValueTypes["PersonSeenInfoCarouselUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPage"]],
listGivenGiftsPage?: [{	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPage"]],
paginateGivenGiftsPage?: [{	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageConnection"]],
validateCreateGivenGiftsPage?: [{	data: ValueTypes["GivenGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GivenGiftsPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
listGivenGiftsPageLocale?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocale"]],
paginateGivenGiftsPageLocale?: [{	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleConnection"]],
validateCreateGivenGiftsPageLocale?: [{	data: ValueTypes["GivenGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GivenGiftsPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPage"]],
listReceivedGiftsPage?: [{	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPage"]],
paginateReceivedGiftsPage?: [{	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageConnection"]],
validateCreateReceivedGiftsPage?: [{	data: ValueTypes["ReceivedGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReceivedGiftsPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
listReceivedGiftsPageLocale?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocale"]],
paginateReceivedGiftsPageLocale?: [{	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleConnection"]],
validateCreateReceivedGiftsPageLocale?: [{	data: ValueTypes["ReceivedGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReceivedGiftsPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigation"]],
listReportNavigation?: [{	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigation"]],
paginateReportNavigation?: [{	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationConnection"]],
validateCreateReportNavigation?: [{	data: ValueTypes["ReportNavigationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReportNavigationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPage"]],
listReportPage?: [{	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPage"]],
paginateReportPage?: [{	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageConnection"]],
validateCreateReportPage?: [{	data: ValueTypes["ReportPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReportPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
listReportPageLocale?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocale"]],
paginateReportPageLocale?: [{	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocaleConnection"]],
validateCreateReportPageLocale?: [{	data: ValueTypes["ReportPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReportPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
listReportNavigationLocale?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocale"]],
paginateReportNavigationLocale?: [{	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ReportNavigationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocaleConnection"]],
validateCreateReportNavigationLocale?: [{	data: ValueTypes["ReportNavigationLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ReportNavigationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
listSentPayment?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SentPayment"]],
paginateSentPayment?: [{	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentConnection"]],
validateCreateSentPayment?: [{	data: ValueTypes["SentPaymentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SentPaymentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostAreaSentPaymentCurrencySum?: [{	by: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySum"]],
listPostAreaSentPaymentCurrencySum?: [{	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySum"]],
paginatePostAreaSentPaymentCurrencySum?: [{	filter?: ValueTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentCurrencySumConnection"]],
getPostAreaSentPaymentSum?: [{	by: ValueTypes["PostAreaSentPaymentSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentSum"]],
listPostAreaSentPaymentSum?: [{	filter?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentSumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentSum"]],
paginatePostAreaSentPaymentSum?: [{	filter?: ValueTypes["PostAreaSentPaymentSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSentPaymentSumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSentPaymentSumConnection"]],
getNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroup"]],
listNotificationTargetGroup?: [{	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["NotificationTargetGroupOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroup"]],
paginateNotificationTargetGroup?: [{	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["NotificationTargetGroupOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroupConnection"]],
validateCreateNotificationTargetGroup?: [{	data: ValueTypes["NotificationTargetGroupCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	data: ValueTypes["NotificationTargetGroupUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotification"]],
listProcessedNotification?: [{	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotification"]],
paginateProcessedNotification?: [{	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationConnection"]],
validateCreateProcessedNotification?: [{	data: ValueTypes["ProcessedNotificationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ProcessedNotificationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotification"]],
listScheduledNotification?: [{	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotification"]],
paginateScheduledNotification?: [{	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationConnection"]],
validateCreateScheduledNotification?: [{	data: ValueTypes["ScheduledNotificationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ScheduledNotificationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
listProcessedNotificationSource?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSource"]],
paginateProcessedNotificationSource?: [{	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSourceConnection"]],
validateCreateProcessedNotificationSource?: [{	data: ValueTypes["ProcessedNotificationSourceCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ProcessedNotificationSourceUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>},ValueTypes["Device"]],
listDevice?: [{	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DeviceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Device"]],
paginateDevice?: [{	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["DeviceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["DeviceConnection"]],
validateCreateDevice?: [{	data: ValueTypes["DeviceCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	data: ValueTypes["DeviceUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocale"]],
listScheduledNotificationLocale?: [{	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocale"]],
paginateScheduledNotificationLocale?: [{	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleConnection"]],
validateCreateScheduledNotificationLocale?: [{	data: ValueTypes["ScheduledNotificationLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ScheduledNotificationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocale"]],
listInfoCarouselItemLocale?: [{	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocale"]],
paginateInfoCarouselItemLocale?: [{	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleConnection"]],
validateCreateInfoCarouselItemLocale?: [{	data: ValueTypes["InfoCarouselItemLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoCarouselItemLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocale"]],
listSentPaymentLocale?: [{	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocale"]],
paginateSentPaymentLocale?: [{	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SentPaymentLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocaleConnection"]],
validateCreateSentPaymentLocale?: [{	data: ValueTypes["SentPaymentLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SentPaymentLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getUserPaymentMetadata?: [{	by: ValueTypes["UserPaymentMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentMetadata"]],
listUserPaymentMetadata?: [{	filter?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentMetadata"]],
paginateUserPaymentMetadata?: [{	filter?: ValueTypes["UserPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPaymentMetadataConnection"]],
getPostAreaCurrencySum?: [{	by: ValueTypes["PostAreaCurrencySumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySum"]],
listPostAreaCurrencySum?: [{	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySum"]],
paginatePostAreaCurrencySum?: [{	filter?: ValueTypes["PostAreaCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaCurrencySumConnection"]],
getPostAreaSum?: [{	by: ValueTypes["PostAreaSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaSum"]],
listPostAreaSum?: [{	filter?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSum"]],
paginatePostAreaSum?: [{	filter?: ValueTypes["PostAreaSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostAreaSumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostAreaSumConnection"]],
getPostOrganizationCurrencySum?: [{	by: ValueTypes["PostOrganizationCurrencySumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySum"]],
listPostOrganizationCurrencySum?: [{	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySum"]],
paginatePostOrganizationCurrencySum?: [{	filter?: ValueTypes["PostOrganizationCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationCurrencySumConnection"]],
getPostOrganizationSum?: [{	by: ValueTypes["PostOrganizationSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationSum"]],
listPostOrganizationSum?: [{	filter?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationSumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationSum"]],
paginatePostOrganizationSum?: [{	filter?: ValueTypes["PostOrganizationSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostOrganizationSumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationSumConnection"]],
getStats?: [{	by: ValueTypes["StatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["Stats"]],
listStats?: [{	filter?: ValueTypes["StatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Stats"]],
paginateStats?: [{	filter?: ValueTypes["StatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StatsConnection"]],
getUserRecurringPaymentItemMetadata?: [{	by: ValueTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemMetadata"]],
listUserRecurringPaymentItemMetadata?: [{	filter?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemMetadata"]],
paginateUserRecurringPaymentItemMetadata?: [{	filter?: ValueTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserRecurringPaymentItemMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemMetadataConnection"]],
getUpcomingUserRecurringPaymentMetadata?: [{	by: ValueTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>},ValueTypes["UpcomingUserRecurringPaymentMetadata"]],
listUpcomingUserRecurringPaymentMetadata?: [{	filter?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UpcomingUserRecurringPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UpcomingUserRecurringPaymentMetadata"]],
paginateUpcomingUserRecurringPaymentMetadata?: [{	filter?: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UpcomingUserRecurringPaymentMetadataOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UpcomingUserRecurringPaymentMetadataConnection"]],
getUserAreaStats?: [{	by: ValueTypes["UserAreaStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserAreaStats"]],
listUserAreaStats?: [{	filter?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserAreaStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserAreaStats"]],
paginateUserAreaStats?: [{	filter?: ValueTypes["UserAreaStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserAreaStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserAreaStatsConnection"]],
getUserCurrencyStats?: [{	by: ValueTypes["UserCurrencyStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserCurrencyStats"]],
listUserCurrencyStats?: [{	filter?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserCurrencyStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserCurrencyStats"]],
paginateUserCurrencyStats?: [{	filter?: ValueTypes["UserCurrencyStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserCurrencyStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserCurrencyStatsConnection"]],
getUserOrganizationStats?: [{	by: ValueTypes["UserOrganizationStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserOrganizationStats"]],
listUserOrganizationStats?: [{	filter?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrganizationStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserOrganizationStats"]],
paginateUserOrganizationStats?: [{	filter?: ValueTypes["UserOrganizationStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserOrganizationStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserOrganizationStatsConnection"]],
getUserPostStats?: [{	by: ValueTypes["UserPostStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPostStats"]],
listUserPostStats?: [{	filter?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPostStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserPostStats"]],
paginateUserPostStats?: [{	filter?: ValueTypes["UserPostStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserPostStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserPostStatsConnection"]],
getUserStats?: [{	by: ValueTypes["UserStatsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserStats"]],
listUserStats?: [{	filter?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserStatsOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["UserStats"]],
paginateUserStats?: [{	filter?: ValueTypes["UserStatsWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["UserStatsOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["UserStatsConnection"]],
getTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageList"]],
listTextImageList?: [{	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageList"]],
paginateTextImageList?: [{	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageListConnection"]],
validateCreateTextImageList?: [{	data: ValueTypes["TextImageListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TextImageListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageListItem"]],
listTextImageListItem?: [{	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageListItem"]],
paginateTextImageListItem?: [{	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextImageListItemConnection"]],
validateCreateTextImageListItem?: [{	data: ValueTypes["TextImageListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TextImageListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getPostCurrencySum?: [{	by: ValueTypes["PostCurrencySumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySum"]],
listPostCurrencySum?: [{	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySum"]],
paginatePostCurrencySum?: [{	filter?: ValueTypes["PostCurrencySumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostCurrencySumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostCurrencySumConnection"]],
getPostSum?: [{	by: ValueTypes["PostSumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostSum"]],
listPostSum?: [{	filter?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostSumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostSum"]],
paginatePostSum?: [{	filter?: ValueTypes["PostSumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostSumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostSumConnection"]],
getPostFundraisingProgress?: [{	by: ValueTypes["PostFundraisingProgressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostFundraisingProgress"]],
listPostFundraisingProgress?: [{	filter?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostFundraisingProgressOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["PostFundraisingProgress"]],
paginatePostFundraisingProgress?: [{	filter?: ValueTypes["PostFundraisingProgressWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["PostFundraisingProgressOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["PostFundraisingProgressConnection"]],
getHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItem"]],
listHeroCarouselItem?: [{	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItem"]],
paginateHeroCarouselItem?: [{	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeroCarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItemConnection"]],
validateCreateHeroCarouselItem?: [{	data: ValueTypes["HeroCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeroCarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
		__typename?: boolean | `@${string}`
}>;
	["Info"]: AliasType<{
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
generateUploadUrl?: [{	input?: ValueTypes["S3GenerateSignedUploadInput"] | undefined | null | Variable<any, string>},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string | Variable<any, string>,	expiration?: number | undefined | null | Variable<any, string>},ValueTypes["S3SignedRead"]],
createGeneral?: [{	data: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["GeneralCreateResult"]],
deleteGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralDeleteResult"]],
updateGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GeneralUpdateInput"] | Variable<any, string>},ValueTypes["GeneralUpdateResult"]],
upsertGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GeneralUpdateInput"] | Variable<any, string>,	create: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["GeneralUpsertResult"]],
createImage?: [{	data: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageUpdateInput"] | Variable<any, string>},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["ImageUpsertResult"]],
createGenericPage?: [{	data: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkableUpdateInput"] | Variable<any, string>},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkableUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["LinkableUpsertResult"]],
createSeo?: [{	data: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SeoUpdateInput"] | Variable<any, string>},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,	create: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["SeoUpsertResult"]],
createContent?: [{	data: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentUpdateInput"] | Variable<any, string>},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["ContentReferenceUpsertResult"]],
createGeneralLocale?: [{	data: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleCreateResult"]],
deleteGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleDeleteResult"]],
updateGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleUpdateResult"]],
upsertGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleUpsertResult"]],
createGenericPageLocale?: [{	data: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleCreateResult"]],
deleteGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleDeleteResult"]],
updateGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleUpdateResult"]],
upsertGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleUpsertResult"]],
createLocale?: [{	data: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LocaleUpdateInput"] | Variable<any, string>},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["LocaleUpsertResult"]],
createVideo?: [{	data: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["VideoUpdateInput"] | Variable<any, string>},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,	create: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["VideoUpsertResult"]],
createLink?: [{	data: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkUpdateInput"] | Variable<any, string>},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["LinkUpsertResult"]],
createPost?: [{	data: ValueTypes["PostCreateInput"] | Variable<any, string>},ValueTypes["PostCreateResult"]],
deletePost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostDeleteResult"]],
updatePost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostUpdateInput"] | Variable<any, string>},ValueTypes["PostUpdateResult"]],
upsertPost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostCreateInput"] | Variable<any, string>},ValueTypes["PostUpsertResult"]],
createPostLocale?: [{	data: ValueTypes["PostLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostLocaleCreateResult"]],
deletePostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocaleDeleteResult"]],
updatePostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostLocaleUpdateInput"] | Variable<any, string>},ValueTypes["PostLocaleUpdateResult"]],
upsertPostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostLocaleUpsertResult"]],
createPostArea?: [{	data: ValueTypes["PostAreaCreateInput"] | Variable<any, string>},ValueTypes["PostAreaCreateResult"]],
deletePostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaDeleteResult"]],
updatePostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>},ValueTypes["PostAreaUpdateResult"]],
upsertPostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>},ValueTypes["PostAreaUpsertResult"]],
createPostAreaLocale?: [{	data: ValueTypes["PostAreaLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostAreaLocaleCreateResult"]],
deletePostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocaleDeleteResult"]],
updatePostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostAreaLocaleUpdateInput"] | Variable<any, string>},ValueTypes["PostAreaLocaleUpdateResult"]],
upsertPostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostAreaLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostAreaLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostAreaLocaleUpsertResult"]],
createPostOrganization?: [{	data: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationCreateResult"]],
deletePostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationDeleteResult"]],
updatePostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostOrganizationUpdateInput"] | Variable<any, string>},ValueTypes["PostOrganizationUpdateResult"]],
upsertPostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostOrganizationUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationUpsertResult"]],
createPostOrganizationLocale?: [{	data: ValueTypes["PostOrganizationLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationLocaleCreateResult"]],
deletePostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocaleDeleteResult"]],
updatePostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostOrganizationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["PostOrganizationLocaleUpdateResult"]],
upsertPostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostOrganizationLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostOrganizationLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationLocaleUpsertResult"]],
createDonation?: [{	data: ValueTypes["DonationCreateInput"] | Variable<any, string>},ValueTypes["DonationCreateResult"]],
deleteDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationDeleteResult"]],
updateDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DonationUpdateInput"] | Variable<any, string>},ValueTypes["DonationUpdateResult"]],
upsertDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DonationUpdateInput"] | Variable<any, string>,	create: ValueTypes["DonationCreateInput"] | Variable<any, string>},ValueTypes["DonationUpsertResult"]],
createDonationAmountItem?: [{	data: ValueTypes["DonationAmountItemCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountItemCreateResult"]],
deleteDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItemDeleteResult"]],
updateDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DonationAmountItemUpdateInput"] | Variable<any, string>},ValueTypes["DonationAmountItemUpdateResult"]],
upsertDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DonationAmountItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["DonationAmountItemCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountItemUpsertResult"]],
createDonationAmountsRegionItem?: [{	data: ValueTypes["DonationAmountsRegionItemCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionItemCreateResult"]],
deleteDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItemDeleteResult"]],
updateDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DonationAmountsRegionItemUpdateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionItemUpdateResult"]],
upsertDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DonationAmountsRegionItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["DonationAmountsRegionItemCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionItemUpsertResult"]],
createDonationAmountsRegionList?: [{	data: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionListCreateResult"]],
deleteDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionListDeleteResult"]],
updateDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DonationAmountsRegionListUpdateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionListUpdateResult"]],
upsertDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DonationAmountsRegionListUpdateInput"] | Variable<any, string>,	create: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionListUpsertResult"]],
createRegion?: [{	data: ValueTypes["RegionCreateInput"] | Variable<any, string>},ValueTypes["RegionCreateResult"]],
deleteRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["RegionDeleteResult"]],
updateRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RegionUpdateInput"] | Variable<any, string>},ValueTypes["RegionUpdateResult"]],
upsertRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RegionUpdateInput"] | Variable<any, string>,	create: ValueTypes["RegionCreateInput"] | Variable<any, string>},ValueTypes["RegionUpsertResult"]],
createLinkItem?: [{	data: ValueTypes["LinkItemCreateInput"] | Variable<any, string>},ValueTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkItemUpdateInput"] | Variable<any, string>},ValueTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkItemCreateInput"] | Variable<any, string>},ValueTypes["LinkItemUpsertResult"]],
createLinkList?: [{	data: ValueTypes["LinkListCreateInput"] | Variable<any, string>},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkListUpdateInput"] | Variable<any, string>},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkListUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkListCreateInput"] | Variable<any, string>},ValueTypes["LinkListUpsertResult"]],
createHeader?: [{	data: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeaderUpdateInput"] | Variable<any, string>},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeaderUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["HeaderUpsertResult"]],
createHeaderLocale?: [{	data: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleUpsertResult"]],
createFooter?: [{	data: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterUpdateInput"] | Variable<any, string>},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["FooterUpsertResult"]],
createFooterLocale?: [{	data: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["FooterLocaleUpsertResult"]],
createPostList?: [{	data: ValueTypes["PostListCreateInput"] | Variable<any, string>},ValueTypes["PostListCreateResult"]],
deletePostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostListDeleteResult"]],
updatePostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostListUpdateInput"] | Variable<any, string>},ValueTypes["PostListUpdateResult"]],
upsertPostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostListUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostListCreateInput"] | Variable<any, string>},ValueTypes["PostListUpsertResult"]],
createPostListItem?: [{	data: ValueTypes["PostListItemCreateInput"] | Variable<any, string>},ValueTypes["PostListItemCreateResult"]],
deletePostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostListItemDeleteResult"]],
updatePostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostListItemUpdateInput"] | Variable<any, string>},ValueTypes["PostListItemUpdateResult"]],
upsertPostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostListItemCreateInput"] | Variable<any, string>},ValueTypes["PostListItemUpsertResult"]],
createAppBanner?: [{	data: ValueTypes["AppBannerCreateInput"] | Variable<any, string>},ValueTypes["AppBannerCreateResult"]],
deleteAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["AppBannerDeleteResult"]],
updateAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["AppBannerUpdateInput"] | Variable<any, string>},ValueTypes["AppBannerUpdateResult"]],
upsertAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["AppBannerUpdateInput"] | Variable<any, string>,	create: ValueTypes["AppBannerCreateInput"] | Variable<any, string>},ValueTypes["AppBannerUpsertResult"]],
createGenericPageAboutSettings?: [{	data: ValueTypes["GenericPageAboutSettingsCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsCreateResult"]],
deleteGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsDeleteResult"]],
updateGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageAboutSettingsUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsUpdateResult"]],
upsertGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageAboutSettingsUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageAboutSettingsCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsUpsertResult"]],
createGenericPageAboutSettingsLocale?: [{	data: ValueTypes["GenericPageAboutSettingsLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleCreateResult"]],
deleteGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleDeleteResult"]],
updateGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageAboutSettingsLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleUpdateResult"]],
upsertGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageAboutSettingsLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageAboutSettingsLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleUpsertResult"]],
createValue?: [{	data: ValueTypes["ValueCreateInput"] | Variable<any, string>},ValueTypes["ValueCreateResult"]],
deleteValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueDeleteResult"]],
updateValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ValueUpdateInput"] | Variable<any, string>},ValueTypes["ValueUpdateResult"]],
upsertValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ValueUpdateInput"] | Variable<any, string>,	create: ValueTypes["ValueCreateInput"] | Variable<any, string>},ValueTypes["ValueUpsertResult"]],
createValueItem?: [{	data: ValueTypes["ValueItemCreateInput"] | Variable<any, string>},ValueTypes["ValueItemCreateResult"]],
deleteValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueItemDeleteResult"]],
updateValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ValueItemUpdateInput"] | Variable<any, string>},ValueTypes["ValueItemUpdateResult"]],
upsertValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ValueItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["ValueItemCreateInput"] | Variable<any, string>},ValueTypes["ValueItemUpsertResult"]],
createValueList?: [{	data: ValueTypes["ValueListCreateInput"] | Variable<any, string>},ValueTypes["ValueListCreateResult"]],
deleteValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueListDeleteResult"]],
updateValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ValueListUpdateInput"] | Variable<any, string>},ValueTypes["ValueListUpdateResult"]],
upsertValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ValueListUpdateInput"] | Variable<any, string>,	create: ValueTypes["ValueListCreateInput"] | Variable<any, string>},ValueTypes["ValueListUpsertResult"]],
createImageLink?: [{	data: ValueTypes["ImageLinkCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkCreateResult"]],
deleteImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkDeleteResult"]],
updateImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageLinkUpdateInput"] | Variable<any, string>},ValueTypes["ImageLinkUpdateResult"]],
upsertImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageLinkUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageLinkCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkUpsertResult"]],
createImageLinkItem?: [{	data: ValueTypes["ImageLinkItemCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkItemCreateResult"]],
deleteImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItemDeleteResult"]],
updateImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageLinkItemUpdateInput"] | Variable<any, string>},ValueTypes["ImageLinkItemUpdateResult"]],
upsertImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageLinkItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageLinkItemCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkItemUpsertResult"]],
createImageLinkList?: [{	data: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkListCreateResult"]],
deleteImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkListDeleteResult"]],
updateImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageLinkListUpdateInput"] | Variable<any, string>},ValueTypes["ImageLinkListUpdateResult"]],
upsertImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageLinkListUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkListUpsertResult"]],
createPostAreaList?: [{	data: ValueTypes["PostAreaListCreateInput"] | Variable<any, string>},ValueTypes["PostAreaListCreateResult"]],
deletePostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaListDeleteResult"]],
updatePostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostAreaListUpdateInput"] | Variable<any, string>},ValueTypes["PostAreaListUpdateResult"]],
upsertPostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostAreaListUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostAreaListCreateInput"] | Variable<any, string>},ValueTypes["PostAreaListUpsertResult"]],
createPostAreaListItem?: [{	data: ValueTypes["PostAreaListItemCreateInput"] | Variable<any, string>},ValueTypes["PostAreaListItemCreateResult"]],
deletePostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItemDeleteResult"]],
updatePostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostAreaListItemUpdateInput"] | Variable<any, string>},ValueTypes["PostAreaListItemUpdateResult"]],
upsertPostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostAreaListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostAreaListItemCreateInput"] | Variable<any, string>},ValueTypes["PostAreaListItemUpsertResult"]],
createAccordion?: [{	data: ValueTypes["AccordionCreateInput"] | Variable<any, string>},ValueTypes["AccordionCreateResult"]],
deleteAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>},ValueTypes["AccordionDeleteResult"]],
updateAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["AccordionUpdateInput"] | Variable<any, string>},ValueTypes["AccordionUpdateResult"]],
upsertAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["AccordionUpdateInput"] | Variable<any, string>,	create: ValueTypes["AccordionCreateInput"] | Variable<any, string>},ValueTypes["AccordionUpsertResult"]],
createAccordionItem?: [{	data: ValueTypes["AccordionItemCreateInput"] | Variable<any, string>},ValueTypes["AccordionItemCreateResult"]],
deleteAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["AccordionItemDeleteResult"]],
updateAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["AccordionItemUpdateInput"] | Variable<any, string>},ValueTypes["AccordionItemUpdateResult"]],
upsertAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["AccordionItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["AccordionItemCreateInput"] | Variable<any, string>},ValueTypes["AccordionItemUpsertResult"]],
createUser?: [{	data: ValueTypes["UserCreateInput"] | Variable<any, string>},ValueTypes["UserCreateResult"]],
deleteUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserDeleteResult"]],
updateUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserUpdateInput"] | Variable<any, string>},ValueTypes["UserUpdateResult"]],
upsertUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserCreateInput"] | Variable<any, string>},ValueTypes["UserUpsertResult"]],
createUserPayment?: [{	data: ValueTypes["UserPaymentCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentCreateResult"]],
deleteUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentDeleteResult"]],
updateUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserPaymentUpdateInput"] | Variable<any, string>},ValueTypes["UserPaymentUpdateResult"]],
upsertUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserPaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserPaymentCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentUpsertResult"]],
createCurrency?: [{	data: ValueTypes["CurrencyCreateInput"] | Variable<any, string>},ValueTypes["CurrencyCreateResult"]],
deleteCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["CurrencyDeleteResult"]],
updateCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>},ValueTypes["CurrencyUpdateResult"]],
upsertCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>},ValueTypes["CurrencyUpsertResult"]],
createMedium?: [{	data: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumUpdateInput"] | Variable<any, string>},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["MediumUpsertResult"]],
createMediumItem?: [{	data: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>},ValueTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumListUpdateInput"] | Variable<any, string>},ValueTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumListUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["MediumListUpsertResult"]],
createUserPaymentOrderId?: [{	data: ValueTypes["UserPaymentOrderIdCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentOrderIdCreateResult"]],
deleteUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderIdDeleteResult"]],
updateUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserPaymentOrderIdUpdateInput"] | Variable<any, string>},ValueTypes["UserPaymentOrderIdUpdateResult"]],
upsertUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserPaymentOrderIdUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserPaymentOrderIdCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentOrderIdUpsertResult"]],
createPostRevision?: [{	data: ValueTypes["PostRevisionCreateInput"] | Variable<any, string>},ValueTypes["PostRevisionCreateResult"]],
deletePostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionDeleteResult"]],
updatePostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostRevisionUpdateInput"] | Variable<any, string>},ValueTypes["PostRevisionUpdateResult"]],
upsertPostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostRevisionUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostRevisionCreateInput"] | Variable<any, string>},ValueTypes["PostRevisionUpsertResult"]],
createUserRecurringPayment?: [{	data: ValueTypes["UserRecurringPaymentCreateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentCreateResult"]],
deleteUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentDeleteResult"]],
updateUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserRecurringPaymentUpdateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentUpdateResult"]],
upsertUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserRecurringPaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserRecurringPaymentCreateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentUpsertResult"]],
createUserRecurringPaymentItem?: [{	data: ValueTypes["UserRecurringPaymentItemCreateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentItemCreateResult"]],
deleteUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemDeleteResult"]],
updateUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserRecurringPaymentItemUpdateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentItemUpdateResult"]],
upsertUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserRecurringPaymentItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserRecurringPaymentItemCreateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentItemUpsertResult"]],
createPostRevisionLocale?: [{	data: ValueTypes["PostRevisionLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostRevisionLocaleCreateResult"]],
deletePostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocaleDeleteResult"]],
updatePostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostRevisionLocaleUpdateInput"] | Variable<any, string>},ValueTypes["PostRevisionLocaleUpdateResult"]],
upsertPostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostRevisionLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostRevisionLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostRevisionLocaleUpsertResult"]],
createTranslationCatalogue?: [{	data: ValueTypes["TranslationCatalogueCreateInput"] | Variable<any, string>},ValueTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationCatalogueUpdateInput"] | Variable<any, string>},ValueTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationCatalogueUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationCatalogueCreateInput"] | Variable<any, string>},ValueTypes["TranslationCatalogueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationCataloguesIdentifierUpdateInput"] | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationCataloguesIdentifierUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierUpsertResult"]],
createTranslationDomain?: [{	data: ValueTypes["TranslationDomainCreateInput"] | Variable<any, string>},ValueTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationDomainUpdateInput"] | Variable<any, string>},ValueTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationDomainUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationDomainCreateInput"] | Variable<any, string>},ValueTypes["TranslationDomainUpsertResult"]],
createTranslationKey?: [{	data: ValueTypes["TranslationKeyCreateInput"] | Variable<any, string>},ValueTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationKeyUpdateInput"] | Variable<any, string>},ValueTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationKeyUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationKeyCreateInput"] | Variable<any, string>},ValueTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data: ValueTypes["TranslationValueCreateInput"] | Variable<any, string>},ValueTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationValueUpdateInput"] | Variable<any, string>},ValueTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationValueUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationValueCreateInput"] | Variable<any, string>},ValueTypes["TranslationValueUpsertResult"]],
createGenericPageAboutGroupLinksLocale?: [{	data: ValueTypes["GenericPageAboutGroupLinksLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleCreateResult"]],
deleteGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleDeleteResult"]],
updateGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleUpdateResult"]],
upsertGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageAboutGroupLinksLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleUpsertResult"]],
createMemberList?: [{	data: ValueTypes["MemberListCreateInput"] | Variable<any, string>},ValueTypes["MemberListCreateResult"]],
deleteMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberListDeleteResult"]],
updateMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MemberListUpdateInput"] | Variable<any, string>},ValueTypes["MemberListUpdateResult"]],
upsertMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MemberListUpdateInput"] | Variable<any, string>,	create: ValueTypes["MemberListCreateInput"] | Variable<any, string>},ValueTypes["MemberListUpsertResult"]],
createMemberListItem?: [{	data: ValueTypes["MemberListItemCreateInput"] | Variable<any, string>},ValueTypes["MemberListItemCreateResult"]],
deleteMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberListItemDeleteResult"]],
updateMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MemberListItemUpdateInput"] | Variable<any, string>},ValueTypes["MemberListItemUpdateResult"]],
upsertMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MemberListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["MemberListItemCreateInput"] | Variable<any, string>},ValueTypes["MemberListItemUpsertResult"]],
createFilledTaxForm?: [{	data: ValueTypes["FilledTaxFormCreateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormCreateResult"]],
deleteFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormDeleteResult"]],
updateFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FilledTaxFormUpdateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormUpdateResult"]],
upsertFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FilledTaxFormUpdateInput"] | Variable<any, string>,	create: ValueTypes["FilledTaxFormCreateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormUpsertResult"]],
createFilledTaxFormEmailAddress?: [{	data: ValueTypes["FilledTaxFormEmailAddressCreateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressCreateResult"]],
deleteFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressDeleteResult"]],
updateFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FilledTaxFormEmailAddressUpdateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressUpdateResult"]],
upsertFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FilledTaxFormEmailAddressUpdateInput"] | Variable<any, string>,	create: ValueTypes["FilledTaxFormEmailAddressCreateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressUpsertResult"]],
createForm?: [{	data: ValueTypes["FormCreateInput"] | Variable<any, string>},ValueTypes["FormCreateResult"]],
deleteForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>},ValueTypes["FormDeleteResult"]],
updateForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FormUpdateInput"] | Variable<any, string>},ValueTypes["FormUpdateResult"]],
upsertForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FormUpdateInput"] | Variable<any, string>,	create: ValueTypes["FormCreateInput"] | Variable<any, string>},ValueTypes["FormUpsertResult"]],
createCsobPayment?: [{	data: ValueTypes["CsobPaymentCreateInput"] | Variable<any, string>},ValueTypes["CsobPaymentCreateResult"]],
deleteCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentDeleteResult"]],
updateCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CsobPaymentUpdateInput"] | Variable<any, string>},ValueTypes["CsobPaymentUpdateResult"]],
upsertCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CsobPaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["CsobPaymentCreateInput"] | Variable<any, string>},ValueTypes["CsobPaymentUpsertResult"]],
createCsobPaymentStatusChange?: [{	data: ValueTypes["CsobPaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeCreateResult"]],
deleteCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeDeleteResult"]],
updateCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CsobPaymentStatusChangeUpdateInput"] | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeUpdateResult"]],
upsertCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CsobPaymentStatusChangeUpdateInput"] | Variable<any, string>,	create: ValueTypes["CsobPaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeUpsertResult"]],
createStripePayment?: [{	data: ValueTypes["StripePaymentCreateInput"] | Variable<any, string>},ValueTypes["StripePaymentCreateResult"]],
deleteStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentDeleteResult"]],
updateStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StripePaymentUpdateInput"] | Variable<any, string>},ValueTypes["StripePaymentUpdateResult"]],
upsertStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StripePaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["StripePaymentCreateInput"] | Variable<any, string>},ValueTypes["StripePaymentUpsertResult"]],
createStripePaymentStatusChange?: [{	data: ValueTypes["StripePaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["StripePaymentStatusChangeCreateResult"]],
deleteStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChangeDeleteResult"]],
updateStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StripePaymentStatusChangeUpdateInput"] | Variable<any, string>},ValueTypes["StripePaymentStatusChangeUpdateResult"]],
upsertStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StripePaymentStatusChangeUpdateInput"] | Variable<any, string>,	create: ValueTypes["StripePaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["StripePaymentStatusChangeUpsertResult"]],
createRegionPaymentMethod?: [{	data: ValueTypes["RegionPaymentMethodCreateInput"] | Variable<any, string>},ValueTypes["RegionPaymentMethodCreateResult"]],
deleteRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethodDeleteResult"]],
updateRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RegionPaymentMethodUpdateInput"] | Variable<any, string>},ValueTypes["RegionPaymentMethodUpdateResult"]],
upsertRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RegionPaymentMethodUpdateInput"] | Variable<any, string>,	create: ValueTypes["RegionPaymentMethodCreateInput"] | Variable<any, string>},ValueTypes["RegionPaymentMethodUpsertResult"]],
createTileItem?: [{	data: ValueTypes["TileItemCreateInput"] | Variable<any, string>},ValueTypes["TileItemCreateResult"]],
deleteTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileItemDeleteResult"]],
updateTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TileItemUpdateInput"] | Variable<any, string>},ValueTypes["TileItemUpdateResult"]],
upsertTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TileItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["TileItemCreateInput"] | Variable<any, string>},ValueTypes["TileItemUpsertResult"]],
createTileList?: [{	data: ValueTypes["TileListCreateInput"] | Variable<any, string>},ValueTypes["TileListCreateResult"]],
deleteTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileListDeleteResult"]],
updateTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TileListUpdateInput"] | Variable<any, string>},ValueTypes["TileListUpdateResult"]],
upsertTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TileListUpdateInput"] | Variable<any, string>,	create: ValueTypes["TileListCreateInput"] | Variable<any, string>},ValueTypes["TileListUpsertResult"]],
createFeedPage?: [{	data: ValueTypes["FeedPageCreateInput"] | Variable<any, string>},ValueTypes["FeedPageCreateResult"]],
deleteFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageDeleteResult"]],
updateFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FeedPageUpdateInput"] | Variable<any, string>},ValueTypes["FeedPageUpdateResult"]],
upsertFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FeedPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["FeedPageCreateInput"] | Variable<any, string>},ValueTypes["FeedPageUpsertResult"]],
createFeedPageLocale?: [{	data: ValueTypes["FeedPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["FeedPageLocaleCreateResult"]],
deleteFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocaleDeleteResult"]],
updateFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FeedPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["FeedPageLocaleUpdateResult"]],
upsertFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FeedPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["FeedPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["FeedPageLocaleUpsertResult"]],
createFeedPageSection?: [{	data: ValueTypes["FeedPageSectionCreateInput"] | Variable<any, string>},ValueTypes["FeedPageSectionCreateResult"]],
deleteFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageSectionDeleteResult"]],
updateFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FeedPageSectionUpdateInput"] | Variable<any, string>},ValueTypes["FeedPageSectionUpdateResult"]],
upsertFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FeedPageSectionUpdateInput"] | Variable<any, string>,	create: ValueTypes["FeedPageSectionCreateInput"] | Variable<any, string>},ValueTypes["FeedPageSectionUpsertResult"]],
createFeedPageTileStripe?: [{	data: ValueTypes["FeedPageTileStripeCreateInput"] | Variable<any, string>},ValueTypes["FeedPageTileStripeCreateResult"]],
deleteFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripeDeleteResult"]],
updateFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FeedPageTileStripeUpdateInput"] | Variable<any, string>},ValueTypes["FeedPageTileStripeUpdateResult"]],
upsertFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FeedPageTileStripeUpdateInput"] | Variable<any, string>,	create: ValueTypes["FeedPageTileStripeCreateInput"] | Variable<any, string>},ValueTypes["FeedPageTileStripeUpsertResult"]],
createCardItem?: [{	data: ValueTypes["CardItemCreateInput"] | Variable<any, string>},ValueTypes["CardItemCreateResult"]],
deleteCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardItemDeleteResult"]],
updateCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CardItemUpdateInput"] | Variable<any, string>},ValueTypes["CardItemUpdateResult"]],
upsertCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CardItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["CardItemCreateInput"] | Variable<any, string>},ValueTypes["CardItemUpsertResult"]],
createCardList?: [{	data: ValueTypes["CardListCreateInput"] | Variable<any, string>},ValueTypes["CardListCreateResult"]],
deleteCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardListDeleteResult"]],
updateCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CardListUpdateInput"] | Variable<any, string>},ValueTypes["CardListUpdateResult"]],
upsertCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CardListUpdateInput"] | Variable<any, string>,	create: ValueTypes["CardListCreateInput"] | Variable<any, string>},ValueTypes["CardListUpsertResult"]],
createOnBehalfDonation?: [{	data: ValueTypes["OnBehalfDonationCreateInput"] | Variable<any, string>},ValueTypes["OnBehalfDonationCreateResult"]],
deleteOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationDeleteResult"]],
updateOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["OnBehalfDonationUpdateInput"] | Variable<any, string>},ValueTypes["OnBehalfDonationUpdateResult"]],
upsertOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["OnBehalfDonationUpdateInput"] | Variable<any, string>,	create: ValueTypes["OnBehalfDonationCreateInput"] | Variable<any, string>},ValueTypes["OnBehalfDonationUpsertResult"]],
createUserPaymentTriesCollection?: [{	data: ValueTypes["UserPaymentTriesCollectionCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionCreateResult"]],
deleteUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionDeleteResult"]],
updateUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserPaymentTriesCollectionUpdateInput"] | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionUpdateResult"]],
upsertUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserPaymentTriesCollectionUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserPaymentTriesCollectionCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionUpsertResult"]],
createRecurringPaymentPage?: [{	data: ValueTypes["RecurringPaymentPageCreateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageCreateResult"]],
deleteRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageDeleteResult"]],
updateRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecurringPaymentPageUpdateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageUpdateResult"]],
upsertRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecurringPaymentPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecurringPaymentPageCreateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageUpsertResult"]],
createRecurringPaymentPageLocale?: [{	data: ValueTypes["RecurringPaymentPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleCreateResult"]],
deleteRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleDeleteResult"]],
updateRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecurringPaymentPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleUpdateResult"]],
upsertRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecurringPaymentPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecurringPaymentPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleUpsertResult"]],
createStoryGuide?: [{	data: ValueTypes["StoryGuideCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideCreateResult"]],
deleteStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideDeleteResult"]],
updateStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StoryGuideUpdateInput"] | Variable<any, string>},ValueTypes["StoryGuideUpdateResult"]],
upsertStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StoryGuideUpdateInput"] | Variable<any, string>,	create: ValueTypes["StoryGuideCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideUpsertResult"]],
createStoryGuideItem?: [{	data: ValueTypes["StoryGuideItemCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideItemCreateResult"]],
deleteStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItemDeleteResult"]],
updateStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StoryGuideItemUpdateInput"] | Variable<any, string>},ValueTypes["StoryGuideItemUpdateResult"]],
upsertStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StoryGuideItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["StoryGuideItemCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideItemUpsertResult"]],
createStoryGuideList?: [{	data: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideListCreateResult"]],
deleteStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideListDeleteResult"]],
updateStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StoryGuideListUpdateInput"] | Variable<any, string>},ValueTypes["StoryGuideListUpdateResult"]],
upsertStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StoryGuideListUpdateInput"] | Variable<any, string>,	create: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideListUpsertResult"]],
createHeroCarousel?: [{	data: ValueTypes["HeroCarouselCreateInput"] | Variable<any, string>},ValueTypes["HeroCarouselCreateResult"]],
deleteHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselDeleteResult"]],
updateHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeroCarouselUpdateInput"] | Variable<any, string>},ValueTypes["HeroCarouselUpdateResult"]],
upsertHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeroCarouselUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeroCarouselCreateInput"] | Variable<any, string>},ValueTypes["HeroCarouselUpsertResult"]],
createPostOrganizationList?: [{	data: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListCreateResult"]],
deletePostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListDeleteResult"]],
updatePostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListUpdateResult"]],
upsertPostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListUpsertResult"]],
createPostOrganizationListItem?: [{	data: ValueTypes["PostOrganizationListItemCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListItemCreateResult"]],
deletePostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItemDeleteResult"]],
updatePostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostOrganizationListItemUpdateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListItemUpdateResult"]],
upsertPostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostOrganizationListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostOrganizationListItemCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListItemUpsertResult"]],
createInfoCarousel?: [{	data: ValueTypes["InfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselCreateResult"]],
deleteInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselDeleteResult"]],
updateInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoCarouselUpdateInput"] | Variable<any, string>},ValueTypes["InfoCarouselUpdateResult"]],
upsertInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoCarouselUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselUpsertResult"]],
createInfoCarouselItem?: [{	data: ValueTypes["InfoCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemCreateResult"]],
deleteInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemDeleteResult"]],
updateInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoCarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemUpdateResult"]],
upsertInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoCarouselItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemUpsertResult"]],
createPersonSeenInfoCarousel?: [{	data: ValueTypes["PersonSeenInfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselCreateResult"]],
deletePersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselDeleteResult"]],
updatePersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PersonSeenInfoCarouselUpdateInput"] | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselUpdateResult"]],
upsertPersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PersonSeenInfoCarouselUpdateInput"] | Variable<any, string>,	create: ValueTypes["PersonSeenInfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselUpsertResult"]],
createGivenGiftsPage?: [{	data: ValueTypes["GivenGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageCreateResult"]],
deleteGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageDeleteResult"]],
updateGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GivenGiftsPageUpdateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageUpdateResult"]],
upsertGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GivenGiftsPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["GivenGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageUpsertResult"]],
createGivenGiftsPageLocale?: [{	data: ValueTypes["GivenGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleCreateResult"]],
deleteGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleDeleteResult"]],
updateGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GivenGiftsPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleUpdateResult"]],
upsertGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GivenGiftsPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GivenGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleUpsertResult"]],
createReceivedGiftsPage?: [{	data: ValueTypes["ReceivedGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageCreateResult"]],
deleteReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageDeleteResult"]],
updateReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReceivedGiftsPageUpdateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageUpdateResult"]],
upsertReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReceivedGiftsPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReceivedGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageUpsertResult"]],
createReceivedGiftsPageLocale?: [{	data: ValueTypes["ReceivedGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleCreateResult"]],
deleteReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleDeleteResult"]],
updateReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReceivedGiftsPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleUpdateResult"]],
upsertReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReceivedGiftsPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReceivedGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleUpsertResult"]],
createReportNavigation?: [{	data: ValueTypes["ReportNavigationCreateInput"] | Variable<any, string>},ValueTypes["ReportNavigationCreateResult"]],
deleteReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationDeleteResult"]],
updateReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReportNavigationUpdateInput"] | Variable<any, string>},ValueTypes["ReportNavigationUpdateResult"]],
upsertReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReportNavigationUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReportNavigationCreateInput"] | Variable<any, string>},ValueTypes["ReportNavigationUpsertResult"]],
createReportPage?: [{	data: ValueTypes["ReportPageCreateInput"] | Variable<any, string>},ValueTypes["ReportPageCreateResult"]],
deleteReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageDeleteResult"]],
updateReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReportPageUpdateInput"] | Variable<any, string>},ValueTypes["ReportPageUpdateResult"]],
upsertReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReportPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReportPageCreateInput"] | Variable<any, string>},ValueTypes["ReportPageUpsertResult"]],
createReportPageLocale?: [{	data: ValueTypes["ReportPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReportPageLocaleCreateResult"]],
deleteReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocaleDeleteResult"]],
updateReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReportPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ReportPageLocaleUpdateResult"]],
upsertReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReportPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReportPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReportPageLocaleUpsertResult"]],
createReportNavigationLocale?: [{	data: ValueTypes["ReportNavigationLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReportNavigationLocaleCreateResult"]],
deleteReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocaleDeleteResult"]],
updateReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReportNavigationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ReportNavigationLocaleUpdateResult"]],
upsertReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReportNavigationLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReportNavigationLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReportNavigationLocaleUpsertResult"]],
createSentPayment?: [{	data: ValueTypes["SentPaymentCreateInput"] | Variable<any, string>},ValueTypes["SentPaymentCreateResult"]],
deleteSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPaymentDeleteResult"]],
updateSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SentPaymentUpdateInput"] | Variable<any, string>},ValueTypes["SentPaymentUpdateResult"]],
upsertSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SentPaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["SentPaymentCreateInput"] | Variable<any, string>},ValueTypes["SentPaymentUpsertResult"]],
createNotificationTargetGroup?: [{	data: ValueTypes["NotificationTargetGroupCreateInput"] | Variable<any, string>},ValueTypes["NotificationTargetGroupCreateResult"]],
deleteNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroupDeleteResult"]],
updateNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["NotificationTargetGroupUpdateInput"] | Variable<any, string>},ValueTypes["NotificationTargetGroupUpdateResult"]],
upsertNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["NotificationTargetGroupUpdateInput"] | Variable<any, string>,	create: ValueTypes["NotificationTargetGroupCreateInput"] | Variable<any, string>},ValueTypes["NotificationTargetGroupUpsertResult"]],
createProcessedNotification?: [{	data: ValueTypes["ProcessedNotificationCreateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationCreateResult"]],
deleteProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationDeleteResult"]],
updateProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ProcessedNotificationUpdateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationUpdateResult"]],
upsertProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ProcessedNotificationUpdateInput"] | Variable<any, string>,	create: ValueTypes["ProcessedNotificationCreateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationUpsertResult"]],
createScheduledNotification?: [{	data: ValueTypes["ScheduledNotificationCreateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationCreateResult"]],
deleteScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationDeleteResult"]],
updateScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ScheduledNotificationUpdateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationUpdateResult"]],
upsertScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ScheduledNotificationUpdateInput"] | Variable<any, string>,	create: ValueTypes["ScheduledNotificationCreateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationUpsertResult"]],
createProcessedNotificationSource?: [{	data: ValueTypes["ProcessedNotificationSourceCreateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationSourceCreateResult"]],
deleteProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSourceDeleteResult"]],
updateProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ProcessedNotificationSourceUpdateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationSourceUpdateResult"]],
upsertProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ProcessedNotificationSourceUpdateInput"] | Variable<any, string>,	create: ValueTypes["ProcessedNotificationSourceCreateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationSourceUpsertResult"]],
createDevice?: [{	data: ValueTypes["DeviceCreateInput"] | Variable<any, string>},ValueTypes["DeviceCreateResult"]],
deleteDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>},ValueTypes["DeviceDeleteResult"]],
updateDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DeviceUpdateInput"] | Variable<any, string>},ValueTypes["DeviceUpdateResult"]],
upsertDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DeviceUpdateInput"] | Variable<any, string>,	create: ValueTypes["DeviceCreateInput"] | Variable<any, string>},ValueTypes["DeviceUpsertResult"]],
createScheduledNotificationLocale?: [{	data: ValueTypes["ScheduledNotificationLocaleCreateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleCreateResult"]],
deleteScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleDeleteResult"]],
updateScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ScheduledNotificationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleUpdateResult"]],
upsertScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ScheduledNotificationLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ScheduledNotificationLocaleCreateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleUpsertResult"]],
createInfoCarouselItemLocale?: [{	data: ValueTypes["InfoCarouselItemLocaleCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleCreateResult"]],
deleteInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleDeleteResult"]],
updateInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoCarouselItemLocaleUpdateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleUpdateResult"]],
upsertInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoCarouselItemLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoCarouselItemLocaleCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleUpsertResult"]],
createSentPaymentLocale?: [{	data: ValueTypes["SentPaymentLocaleCreateInput"] | Variable<any, string>},ValueTypes["SentPaymentLocaleCreateResult"]],
deleteSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocaleDeleteResult"]],
updateSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SentPaymentLocaleUpdateInput"] | Variable<any, string>},ValueTypes["SentPaymentLocaleUpdateResult"]],
upsertSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SentPaymentLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["SentPaymentLocaleCreateInput"] | Variable<any, string>},ValueTypes["SentPaymentLocaleUpsertResult"]],
createTextImageList?: [{	data: ValueTypes["TextImageListCreateInput"] | Variable<any, string>},ValueTypes["TextImageListCreateResult"]],
deleteTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageListDeleteResult"]],
updateTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TextImageListUpdateInput"] | Variable<any, string>},ValueTypes["TextImageListUpdateResult"]],
upsertTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TextImageListUpdateInput"] | Variable<any, string>,	create: ValueTypes["TextImageListCreateInput"] | Variable<any, string>},ValueTypes["TextImageListUpsertResult"]],
createTextImageListItem?: [{	data: ValueTypes["TextImageListItemCreateInput"] | Variable<any, string>},ValueTypes["TextImageListItemCreateResult"]],
deleteTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageListItemDeleteResult"]],
updateTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TextImageListItemUpdateInput"] | Variable<any, string>},ValueTypes["TextImageListItemUpdateResult"]],
upsertTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TextImageListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["TextImageListItemCreateInput"] | Variable<any, string>},ValueTypes["TextImageListItemUpsertResult"]],
createHeroCarouselItem?: [{	data: ValueTypes["HeroCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["HeroCarouselItemCreateResult"]],
deleteHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItemDeleteResult"]],
updateHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeroCarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["HeroCarouselItemUpdateResult"]],
upsertHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeroCarouselItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeroCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["HeroCarouselItemUpsertResult"]],
transaction?: [{	options?: ValueTypes["MutationTransactionOptions"] | undefined | null | Variable<any, string>},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["S3SignedUpload"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ValueTypes["S3Header"],
	method?:boolean | `@${string}`,
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
	publicUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3Header"]: AliasType<{
	key?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3GenerateSignedUploadInput"]: {
	contentType?: string | undefined | null | Variable<any, string>,
	/** If not provided, extension is detected from a content-type. */
	extension?: string | undefined | null | Variable<any, string>,
	/** Signed URL expiration. */
	expiration?: number | undefined | null | Variable<any, string>,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number | undefined | null | Variable<any, string>,
	/** Can be used as a "directory". */
	prefix?: string | undefined | null | Variable<any, string>,
	/** Suffix after generated id and before the extension. */
	suffix?: string | undefined | null | Variable<any, string>,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string | undefined | null | Variable<any, string>,
	contentDisposition?: ValueTypes["S33ContentDisposition"] | undefined | null | Variable<any, string>,
	/** If not supported by S3 provider, an error is thrown. */
	acl?: ValueTypes["S3Acl"] | undefined | null | Variable<any, string>
};
	["S33ContentDisposition"]:S33ContentDisposition;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ValueTypes["S3Header"],
	method?:boolean | `@${string}`,
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["General"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationResult"]:AliasType<{
		ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"];
		['...on GeneralCreateResult']?: Omit<ValueTypes["GeneralCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralDeleteResult']?: Omit<ValueTypes["GeneralDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralUpdateResult']?: Omit<ValueTypes["GeneralUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralUpsertResult']?: Omit<ValueTypes["GeneralUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageCreateResult']?: Omit<ValueTypes["GenericPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageDeleteResult']?: Omit<ValueTypes["GenericPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageUpdateResult']?: Omit<ValueTypes["GenericPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageUpsertResult']?: Omit<ValueTypes["GenericPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralLocaleCreateResult']?: Omit<ValueTypes["GeneralLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralLocaleDeleteResult']?: Omit<ValueTypes["GeneralLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralLocaleUpdateResult']?: Omit<ValueTypes["GeneralLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralLocaleUpsertResult']?: Omit<ValueTypes["GeneralLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageLocaleCreateResult']?: Omit<ValueTypes["GenericPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageLocaleDeleteResult']?: Omit<ValueTypes["GenericPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageLocaleUpdateResult']?: Omit<ValueTypes["GenericPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageLocaleUpsertResult']?: Omit<ValueTypes["GenericPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleCreateResult']?: Omit<ValueTypes["LocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleDeleteResult']?: Omit<ValueTypes["LocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpdateResult']?: Omit<ValueTypes["LocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpsertResult']?: Omit<ValueTypes["LocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ValueTypes["VideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ValueTypes["VideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ValueTypes["VideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ValueTypes["VideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostCreateResult']?: Omit<ValueTypes["PostCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostDeleteResult']?: Omit<ValueTypes["PostDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostUpdateResult']?: Omit<ValueTypes["PostUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostUpsertResult']?: Omit<ValueTypes["PostUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostLocaleCreateResult']?: Omit<ValueTypes["PostLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostLocaleDeleteResult']?: Omit<ValueTypes["PostLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostLocaleUpdateResult']?: Omit<ValueTypes["PostLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostLocaleUpsertResult']?: Omit<ValueTypes["PostLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaCreateResult']?: Omit<ValueTypes["PostAreaCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaDeleteResult']?: Omit<ValueTypes["PostAreaDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaUpdateResult']?: Omit<ValueTypes["PostAreaUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaUpsertResult']?: Omit<ValueTypes["PostAreaUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaLocaleCreateResult']?: Omit<ValueTypes["PostAreaLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaLocaleDeleteResult']?: Omit<ValueTypes["PostAreaLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaLocaleUpdateResult']?: Omit<ValueTypes["PostAreaLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaLocaleUpsertResult']?: Omit<ValueTypes["PostAreaLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationCreateResult']?: Omit<ValueTypes["PostOrganizationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationDeleteResult']?: Omit<ValueTypes["PostOrganizationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationUpdateResult']?: Omit<ValueTypes["PostOrganizationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationUpsertResult']?: Omit<ValueTypes["PostOrganizationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationLocaleCreateResult']?: Omit<ValueTypes["PostOrganizationLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationLocaleDeleteResult']?: Omit<ValueTypes["PostOrganizationLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationLocaleUpdateResult']?: Omit<ValueTypes["PostOrganizationLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationLocaleUpsertResult']?: Omit<ValueTypes["PostOrganizationLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationCreateResult']?: Omit<ValueTypes["DonationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationDeleteResult']?: Omit<ValueTypes["DonationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationUpdateResult']?: Omit<ValueTypes["DonationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationUpsertResult']?: Omit<ValueTypes["DonationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountItemCreateResult']?: Omit<ValueTypes["DonationAmountItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountItemDeleteResult']?: Omit<ValueTypes["DonationAmountItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountItemUpdateResult']?: Omit<ValueTypes["DonationAmountItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountItemUpsertResult']?: Omit<ValueTypes["DonationAmountItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountsRegionItemCreateResult']?: Omit<ValueTypes["DonationAmountsRegionItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountsRegionItemDeleteResult']?: Omit<ValueTypes["DonationAmountsRegionItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountsRegionItemUpdateResult']?: Omit<ValueTypes["DonationAmountsRegionItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountsRegionItemUpsertResult']?: Omit<ValueTypes["DonationAmountsRegionItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountsRegionListCreateResult']?: Omit<ValueTypes["DonationAmountsRegionListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountsRegionListDeleteResult']?: Omit<ValueTypes["DonationAmountsRegionListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountsRegionListUpdateResult']?: Omit<ValueTypes["DonationAmountsRegionListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DonationAmountsRegionListUpsertResult']?: Omit<ValueTypes["DonationAmountsRegionListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionCreateResult']?: Omit<ValueTypes["RegionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionDeleteResult']?: Omit<ValueTypes["RegionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionUpdateResult']?: Omit<ValueTypes["RegionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionUpsertResult']?: Omit<ValueTypes["RegionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemCreateResult']?: Omit<ValueTypes["LinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemDeleteResult']?: Omit<ValueTypes["LinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemUpdateResult']?: Omit<ValueTypes["LinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemUpsertResult']?: Omit<ValueTypes["LinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListCreateResult']?: Omit<ValueTypes["LinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListDeleteResult']?: Omit<ValueTypes["LinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpdateResult']?: Omit<ValueTypes["LinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpsertResult']?: Omit<ValueTypes["LinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ValueTypes["HeaderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ValueTypes["HeaderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ValueTypes["HeaderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ValueTypes["HeaderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleCreateResult']?: Omit<ValueTypes["HeaderLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleDeleteResult']?: Omit<ValueTypes["HeaderLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleUpdateResult']?: Omit<ValueTypes["HeaderLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleUpsertResult']?: Omit<ValueTypes["HeaderLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleCreateResult']?: Omit<ValueTypes["FooterLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleDeleteResult']?: Omit<ValueTypes["FooterLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleUpdateResult']?: Omit<ValueTypes["FooterLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleUpsertResult']?: Omit<ValueTypes["FooterLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostListCreateResult']?: Omit<ValueTypes["PostListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostListDeleteResult']?: Omit<ValueTypes["PostListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostListUpdateResult']?: Omit<ValueTypes["PostListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostListUpsertResult']?: Omit<ValueTypes["PostListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostListItemCreateResult']?: Omit<ValueTypes["PostListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostListItemDeleteResult']?: Omit<ValueTypes["PostListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostListItemUpdateResult']?: Omit<ValueTypes["PostListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostListItemUpsertResult']?: Omit<ValueTypes["PostListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppBannerCreateResult']?: Omit<ValueTypes["AppBannerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppBannerDeleteResult']?: Omit<ValueTypes["AppBannerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppBannerUpdateResult']?: Omit<ValueTypes["AppBannerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppBannerUpsertResult']?: Omit<ValueTypes["AppBannerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsCreateResult']?: Omit<ValueTypes["GenericPageAboutSettingsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsDeleteResult']?: Omit<ValueTypes["GenericPageAboutSettingsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsUpdateResult']?: Omit<ValueTypes["GenericPageAboutSettingsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsUpsertResult']?: Omit<ValueTypes["GenericPageAboutSettingsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsLocaleCreateResult']?: Omit<ValueTypes["GenericPageAboutSettingsLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsLocaleDeleteResult']?: Omit<ValueTypes["GenericPageAboutSettingsLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsLocaleUpdateResult']?: Omit<ValueTypes["GenericPageAboutSettingsLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsLocaleUpsertResult']?: Omit<ValueTypes["GenericPageAboutSettingsLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueCreateResult']?: Omit<ValueTypes["ValueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueDeleteResult']?: Omit<ValueTypes["ValueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueUpdateResult']?: Omit<ValueTypes["ValueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueUpsertResult']?: Omit<ValueTypes["ValueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueItemCreateResult']?: Omit<ValueTypes["ValueItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueItemDeleteResult']?: Omit<ValueTypes["ValueItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueItemUpdateResult']?: Omit<ValueTypes["ValueItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueItemUpsertResult']?: Omit<ValueTypes["ValueItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueListCreateResult']?: Omit<ValueTypes["ValueListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueListDeleteResult']?: Omit<ValueTypes["ValueListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueListUpdateResult']?: Omit<ValueTypes["ValueListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ValueListUpsertResult']?: Omit<ValueTypes["ValueListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkCreateResult']?: Omit<ValueTypes["ImageLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkDeleteResult']?: Omit<ValueTypes["ImageLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkUpdateResult']?: Omit<ValueTypes["ImageLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkUpsertResult']?: Omit<ValueTypes["ImageLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkItemCreateResult']?: Omit<ValueTypes["ImageLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkItemDeleteResult']?: Omit<ValueTypes["ImageLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkItemUpdateResult']?: Omit<ValueTypes["ImageLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkItemUpsertResult']?: Omit<ValueTypes["ImageLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkListCreateResult']?: Omit<ValueTypes["ImageLinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkListDeleteResult']?: Omit<ValueTypes["ImageLinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkListUpdateResult']?: Omit<ValueTypes["ImageLinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageLinkListUpsertResult']?: Omit<ValueTypes["ImageLinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaListCreateResult']?: Omit<ValueTypes["PostAreaListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaListDeleteResult']?: Omit<ValueTypes["PostAreaListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaListUpdateResult']?: Omit<ValueTypes["PostAreaListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaListUpsertResult']?: Omit<ValueTypes["PostAreaListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaListItemCreateResult']?: Omit<ValueTypes["PostAreaListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaListItemDeleteResult']?: Omit<ValueTypes["PostAreaListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaListItemUpdateResult']?: Omit<ValueTypes["PostAreaListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostAreaListItemUpsertResult']?: Omit<ValueTypes["PostAreaListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AccordionCreateResult']?: Omit<ValueTypes["AccordionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AccordionDeleteResult']?: Omit<ValueTypes["AccordionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AccordionUpdateResult']?: Omit<ValueTypes["AccordionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AccordionUpsertResult']?: Omit<ValueTypes["AccordionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AccordionItemCreateResult']?: Omit<ValueTypes["AccordionItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AccordionItemDeleteResult']?: Omit<ValueTypes["AccordionItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AccordionItemUpdateResult']?: Omit<ValueTypes["AccordionItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AccordionItemUpsertResult']?: Omit<ValueTypes["AccordionItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserCreateResult']?: Omit<ValueTypes["UserCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserDeleteResult']?: Omit<ValueTypes["UserDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserUpdateResult']?: Omit<ValueTypes["UserUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserUpsertResult']?: Omit<ValueTypes["UserUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentCreateResult']?: Omit<ValueTypes["UserPaymentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentDeleteResult']?: Omit<ValueTypes["UserPaymentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentUpdateResult']?: Omit<ValueTypes["UserPaymentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentUpsertResult']?: Omit<ValueTypes["UserPaymentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CurrencyCreateResult']?: Omit<ValueTypes["CurrencyCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CurrencyDeleteResult']?: Omit<ValueTypes["CurrencyDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CurrencyUpdateResult']?: Omit<ValueTypes["CurrencyUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CurrencyUpsertResult']?: Omit<ValueTypes["CurrencyUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumCreateResult']?: Omit<ValueTypes["MediumCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumDeleteResult']?: Omit<ValueTypes["MediumDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpdateResult']?: Omit<ValueTypes["MediumUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpsertResult']?: Omit<ValueTypes["MediumUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemCreateResult']?: Omit<ValueTypes["MediumItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemDeleteResult']?: Omit<ValueTypes["MediumItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemUpdateResult']?: Omit<ValueTypes["MediumItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemUpsertResult']?: Omit<ValueTypes["MediumItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListCreateResult']?: Omit<ValueTypes["MediumListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListDeleteResult']?: Omit<ValueTypes["MediumListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListUpdateResult']?: Omit<ValueTypes["MediumListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListUpsertResult']?: Omit<ValueTypes["MediumListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentOrderIdCreateResult']?: Omit<ValueTypes["UserPaymentOrderIdCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentOrderIdDeleteResult']?: Omit<ValueTypes["UserPaymentOrderIdDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentOrderIdUpdateResult']?: Omit<ValueTypes["UserPaymentOrderIdUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentOrderIdUpsertResult']?: Omit<ValueTypes["UserPaymentOrderIdUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostRevisionCreateResult']?: Omit<ValueTypes["PostRevisionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostRevisionDeleteResult']?: Omit<ValueTypes["PostRevisionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostRevisionUpdateResult']?: Omit<ValueTypes["PostRevisionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostRevisionUpsertResult']?: Omit<ValueTypes["PostRevisionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserRecurringPaymentCreateResult']?: Omit<ValueTypes["UserRecurringPaymentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserRecurringPaymentDeleteResult']?: Omit<ValueTypes["UserRecurringPaymentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserRecurringPaymentUpdateResult']?: Omit<ValueTypes["UserRecurringPaymentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserRecurringPaymentUpsertResult']?: Omit<ValueTypes["UserRecurringPaymentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserRecurringPaymentItemCreateResult']?: Omit<ValueTypes["UserRecurringPaymentItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserRecurringPaymentItemDeleteResult']?: Omit<ValueTypes["UserRecurringPaymentItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserRecurringPaymentItemUpdateResult']?: Omit<ValueTypes["UserRecurringPaymentItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserRecurringPaymentItemUpsertResult']?: Omit<ValueTypes["UserRecurringPaymentItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostRevisionLocaleCreateResult']?: Omit<ValueTypes["PostRevisionLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostRevisionLocaleDeleteResult']?: Omit<ValueTypes["PostRevisionLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostRevisionLocaleUpdateResult']?: Omit<ValueTypes["PostRevisionLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostRevisionLocaleUpsertResult']?: Omit<ValueTypes["PostRevisionLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueCreateResult']?: Omit<ValueTypes["TranslationCatalogueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueDeleteResult']?: Omit<ValueTypes["TranslationCatalogueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueUpdateResult']?: Omit<ValueTypes["TranslationCatalogueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueUpsertResult']?: Omit<ValueTypes["TranslationCatalogueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierCreateResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierDeleteResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpdateResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpsertResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainCreateResult']?: Omit<ValueTypes["TranslationDomainCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainDeleteResult']?: Omit<ValueTypes["TranslationDomainDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainUpdateResult']?: Omit<ValueTypes["TranslationDomainUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainUpsertResult']?: Omit<ValueTypes["TranslationDomainUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyCreateResult']?: Omit<ValueTypes["TranslationKeyCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyDeleteResult']?: Omit<ValueTypes["TranslationKeyDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyUpdateResult']?: Omit<ValueTypes["TranslationKeyUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyUpsertResult']?: Omit<ValueTypes["TranslationKeyUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueCreateResult']?: Omit<ValueTypes["TranslationValueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueDeleteResult']?: Omit<ValueTypes["TranslationValueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueUpdateResult']?: Omit<ValueTypes["TranslationValueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueUpsertResult']?: Omit<ValueTypes["TranslationValueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutGroupLinksLocaleCreateResult']?: Omit<ValueTypes["GenericPageAboutGroupLinksLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutGroupLinksLocaleDeleteResult']?: Omit<ValueTypes["GenericPageAboutGroupLinksLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutGroupLinksLocaleUpdateResult']?: Omit<ValueTypes["GenericPageAboutGroupLinksLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageAboutGroupLinksLocaleUpsertResult']?: Omit<ValueTypes["GenericPageAboutGroupLinksLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListCreateResult']?: Omit<ValueTypes["MemberListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListDeleteResult']?: Omit<ValueTypes["MemberListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListUpdateResult']?: Omit<ValueTypes["MemberListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListUpsertResult']?: Omit<ValueTypes["MemberListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListItemCreateResult']?: Omit<ValueTypes["MemberListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListItemDeleteResult']?: Omit<ValueTypes["MemberListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListItemUpdateResult']?: Omit<ValueTypes["MemberListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListItemUpsertResult']?: Omit<ValueTypes["MemberListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilledTaxFormCreateResult']?: Omit<ValueTypes["FilledTaxFormCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilledTaxFormDeleteResult']?: Omit<ValueTypes["FilledTaxFormDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilledTaxFormUpdateResult']?: Omit<ValueTypes["FilledTaxFormUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilledTaxFormUpsertResult']?: Omit<ValueTypes["FilledTaxFormUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilledTaxFormEmailAddressCreateResult']?: Omit<ValueTypes["FilledTaxFormEmailAddressCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilledTaxFormEmailAddressDeleteResult']?: Omit<ValueTypes["FilledTaxFormEmailAddressDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilledTaxFormEmailAddressUpdateResult']?: Omit<ValueTypes["FilledTaxFormEmailAddressUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilledTaxFormEmailAddressUpsertResult']?: Omit<ValueTypes["FilledTaxFormEmailAddressUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FormCreateResult']?: Omit<ValueTypes["FormCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FormDeleteResult']?: Omit<ValueTypes["FormDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FormUpdateResult']?: Omit<ValueTypes["FormUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FormUpsertResult']?: Omit<ValueTypes["FormUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CsobPaymentCreateResult']?: Omit<ValueTypes["CsobPaymentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CsobPaymentDeleteResult']?: Omit<ValueTypes["CsobPaymentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CsobPaymentUpdateResult']?: Omit<ValueTypes["CsobPaymentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CsobPaymentUpsertResult']?: Omit<ValueTypes["CsobPaymentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CsobPaymentStatusChangeCreateResult']?: Omit<ValueTypes["CsobPaymentStatusChangeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CsobPaymentStatusChangeDeleteResult']?: Omit<ValueTypes["CsobPaymentStatusChangeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CsobPaymentStatusChangeUpdateResult']?: Omit<ValueTypes["CsobPaymentStatusChangeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CsobPaymentStatusChangeUpsertResult']?: Omit<ValueTypes["CsobPaymentStatusChangeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StripePaymentCreateResult']?: Omit<ValueTypes["StripePaymentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StripePaymentDeleteResult']?: Omit<ValueTypes["StripePaymentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StripePaymentUpdateResult']?: Omit<ValueTypes["StripePaymentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StripePaymentUpsertResult']?: Omit<ValueTypes["StripePaymentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StripePaymentStatusChangeCreateResult']?: Omit<ValueTypes["StripePaymentStatusChangeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StripePaymentStatusChangeDeleteResult']?: Omit<ValueTypes["StripePaymentStatusChangeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StripePaymentStatusChangeUpdateResult']?: Omit<ValueTypes["StripePaymentStatusChangeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StripePaymentStatusChangeUpsertResult']?: Omit<ValueTypes["StripePaymentStatusChangeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionPaymentMethodCreateResult']?: Omit<ValueTypes["RegionPaymentMethodCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionPaymentMethodDeleteResult']?: Omit<ValueTypes["RegionPaymentMethodDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionPaymentMethodUpdateResult']?: Omit<ValueTypes["RegionPaymentMethodUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionPaymentMethodUpsertResult']?: Omit<ValueTypes["RegionPaymentMethodUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileItemCreateResult']?: Omit<ValueTypes["TileItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileItemDeleteResult']?: Omit<ValueTypes["TileItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileItemUpdateResult']?: Omit<ValueTypes["TileItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileItemUpsertResult']?: Omit<ValueTypes["TileItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileListCreateResult']?: Omit<ValueTypes["TileListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileListDeleteResult']?: Omit<ValueTypes["TileListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileListUpdateResult']?: Omit<ValueTypes["TileListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileListUpsertResult']?: Omit<ValueTypes["TileListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageCreateResult']?: Omit<ValueTypes["FeedPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageDeleteResult']?: Omit<ValueTypes["FeedPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageUpdateResult']?: Omit<ValueTypes["FeedPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageUpsertResult']?: Omit<ValueTypes["FeedPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageLocaleCreateResult']?: Omit<ValueTypes["FeedPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageLocaleDeleteResult']?: Omit<ValueTypes["FeedPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageLocaleUpdateResult']?: Omit<ValueTypes["FeedPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageLocaleUpsertResult']?: Omit<ValueTypes["FeedPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageSectionCreateResult']?: Omit<ValueTypes["FeedPageSectionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageSectionDeleteResult']?: Omit<ValueTypes["FeedPageSectionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageSectionUpdateResult']?: Omit<ValueTypes["FeedPageSectionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageSectionUpsertResult']?: Omit<ValueTypes["FeedPageSectionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageTileStripeCreateResult']?: Omit<ValueTypes["FeedPageTileStripeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageTileStripeDeleteResult']?: Omit<ValueTypes["FeedPageTileStripeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageTileStripeUpdateResult']?: Omit<ValueTypes["FeedPageTileStripeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FeedPageTileStripeUpsertResult']?: Omit<ValueTypes["FeedPageTileStripeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardItemCreateResult']?: Omit<ValueTypes["CardItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardItemDeleteResult']?: Omit<ValueTypes["CardItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardItemUpdateResult']?: Omit<ValueTypes["CardItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardItemUpsertResult']?: Omit<ValueTypes["CardItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardListCreateResult']?: Omit<ValueTypes["CardListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardListDeleteResult']?: Omit<ValueTypes["CardListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardListUpdateResult']?: Omit<ValueTypes["CardListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardListUpsertResult']?: Omit<ValueTypes["CardListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OnBehalfDonationCreateResult']?: Omit<ValueTypes["OnBehalfDonationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OnBehalfDonationDeleteResult']?: Omit<ValueTypes["OnBehalfDonationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OnBehalfDonationUpdateResult']?: Omit<ValueTypes["OnBehalfDonationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OnBehalfDonationUpsertResult']?: Omit<ValueTypes["OnBehalfDonationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentTriesCollectionCreateResult']?: Omit<ValueTypes["UserPaymentTriesCollectionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentTriesCollectionDeleteResult']?: Omit<ValueTypes["UserPaymentTriesCollectionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentTriesCollectionUpdateResult']?: Omit<ValueTypes["UserPaymentTriesCollectionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserPaymentTriesCollectionUpsertResult']?: Omit<ValueTypes["UserPaymentTriesCollectionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecurringPaymentPageCreateResult']?: Omit<ValueTypes["RecurringPaymentPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecurringPaymentPageDeleteResult']?: Omit<ValueTypes["RecurringPaymentPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecurringPaymentPageUpdateResult']?: Omit<ValueTypes["RecurringPaymentPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecurringPaymentPageUpsertResult']?: Omit<ValueTypes["RecurringPaymentPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecurringPaymentPageLocaleCreateResult']?: Omit<ValueTypes["RecurringPaymentPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecurringPaymentPageLocaleDeleteResult']?: Omit<ValueTypes["RecurringPaymentPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecurringPaymentPageLocaleUpdateResult']?: Omit<ValueTypes["RecurringPaymentPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecurringPaymentPageLocaleUpsertResult']?: Omit<ValueTypes["RecurringPaymentPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideCreateResult']?: Omit<ValueTypes["StoryGuideCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideDeleteResult']?: Omit<ValueTypes["StoryGuideDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideUpdateResult']?: Omit<ValueTypes["StoryGuideUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideUpsertResult']?: Omit<ValueTypes["StoryGuideUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideItemCreateResult']?: Omit<ValueTypes["StoryGuideItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideItemDeleteResult']?: Omit<ValueTypes["StoryGuideItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideItemUpdateResult']?: Omit<ValueTypes["StoryGuideItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideItemUpsertResult']?: Omit<ValueTypes["StoryGuideItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideListCreateResult']?: Omit<ValueTypes["StoryGuideListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideListDeleteResult']?: Omit<ValueTypes["StoryGuideListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideListUpdateResult']?: Omit<ValueTypes["StoryGuideListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoryGuideListUpsertResult']?: Omit<ValueTypes["StoryGuideListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCarouselCreateResult']?: Omit<ValueTypes["HeroCarouselCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCarouselDeleteResult']?: Omit<ValueTypes["HeroCarouselDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCarouselUpdateResult']?: Omit<ValueTypes["HeroCarouselUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCarouselUpsertResult']?: Omit<ValueTypes["HeroCarouselUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationListCreateResult']?: Omit<ValueTypes["PostOrganizationListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationListDeleteResult']?: Omit<ValueTypes["PostOrganizationListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationListUpdateResult']?: Omit<ValueTypes["PostOrganizationListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationListUpsertResult']?: Omit<ValueTypes["PostOrganizationListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationListItemCreateResult']?: Omit<ValueTypes["PostOrganizationListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationListItemDeleteResult']?: Omit<ValueTypes["PostOrganizationListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationListItemUpdateResult']?: Omit<ValueTypes["PostOrganizationListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PostOrganizationListItemUpsertResult']?: Omit<ValueTypes["PostOrganizationListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselCreateResult']?: Omit<ValueTypes["InfoCarouselCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselDeleteResult']?: Omit<ValueTypes["InfoCarouselDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselUpdateResult']?: Omit<ValueTypes["InfoCarouselUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselUpsertResult']?: Omit<ValueTypes["InfoCarouselUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselItemCreateResult']?: Omit<ValueTypes["InfoCarouselItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselItemDeleteResult']?: Omit<ValueTypes["InfoCarouselItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselItemUpdateResult']?: Omit<ValueTypes["InfoCarouselItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselItemUpsertResult']?: Omit<ValueTypes["InfoCarouselItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PersonSeenInfoCarouselCreateResult']?: Omit<ValueTypes["PersonSeenInfoCarouselCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PersonSeenInfoCarouselDeleteResult']?: Omit<ValueTypes["PersonSeenInfoCarouselDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PersonSeenInfoCarouselUpdateResult']?: Omit<ValueTypes["PersonSeenInfoCarouselUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PersonSeenInfoCarouselUpsertResult']?: Omit<ValueTypes["PersonSeenInfoCarouselUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GivenGiftsPageCreateResult']?: Omit<ValueTypes["GivenGiftsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GivenGiftsPageDeleteResult']?: Omit<ValueTypes["GivenGiftsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GivenGiftsPageUpdateResult']?: Omit<ValueTypes["GivenGiftsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GivenGiftsPageUpsertResult']?: Omit<ValueTypes["GivenGiftsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GivenGiftsPageLocaleCreateResult']?: Omit<ValueTypes["GivenGiftsPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GivenGiftsPageLocaleDeleteResult']?: Omit<ValueTypes["GivenGiftsPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GivenGiftsPageLocaleUpdateResult']?: Omit<ValueTypes["GivenGiftsPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GivenGiftsPageLocaleUpsertResult']?: Omit<ValueTypes["GivenGiftsPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReceivedGiftsPageCreateResult']?: Omit<ValueTypes["ReceivedGiftsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReceivedGiftsPageDeleteResult']?: Omit<ValueTypes["ReceivedGiftsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReceivedGiftsPageUpdateResult']?: Omit<ValueTypes["ReceivedGiftsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReceivedGiftsPageUpsertResult']?: Omit<ValueTypes["ReceivedGiftsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReceivedGiftsPageLocaleCreateResult']?: Omit<ValueTypes["ReceivedGiftsPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReceivedGiftsPageLocaleDeleteResult']?: Omit<ValueTypes["ReceivedGiftsPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReceivedGiftsPageLocaleUpdateResult']?: Omit<ValueTypes["ReceivedGiftsPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReceivedGiftsPageLocaleUpsertResult']?: Omit<ValueTypes["ReceivedGiftsPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportNavigationCreateResult']?: Omit<ValueTypes["ReportNavigationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportNavigationDeleteResult']?: Omit<ValueTypes["ReportNavigationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportNavigationUpdateResult']?: Omit<ValueTypes["ReportNavigationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportNavigationUpsertResult']?: Omit<ValueTypes["ReportNavigationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportPageCreateResult']?: Omit<ValueTypes["ReportPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportPageDeleteResult']?: Omit<ValueTypes["ReportPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportPageUpdateResult']?: Omit<ValueTypes["ReportPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportPageUpsertResult']?: Omit<ValueTypes["ReportPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportPageLocaleCreateResult']?: Omit<ValueTypes["ReportPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportPageLocaleDeleteResult']?: Omit<ValueTypes["ReportPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportPageLocaleUpdateResult']?: Omit<ValueTypes["ReportPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportPageLocaleUpsertResult']?: Omit<ValueTypes["ReportPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportNavigationLocaleCreateResult']?: Omit<ValueTypes["ReportNavigationLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportNavigationLocaleDeleteResult']?: Omit<ValueTypes["ReportNavigationLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportNavigationLocaleUpdateResult']?: Omit<ValueTypes["ReportNavigationLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReportNavigationLocaleUpsertResult']?: Omit<ValueTypes["ReportNavigationLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SentPaymentCreateResult']?: Omit<ValueTypes["SentPaymentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SentPaymentDeleteResult']?: Omit<ValueTypes["SentPaymentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SentPaymentUpdateResult']?: Omit<ValueTypes["SentPaymentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SentPaymentUpsertResult']?: Omit<ValueTypes["SentPaymentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NotificationTargetGroupCreateResult']?: Omit<ValueTypes["NotificationTargetGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NotificationTargetGroupDeleteResult']?: Omit<ValueTypes["NotificationTargetGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NotificationTargetGroupUpdateResult']?: Omit<ValueTypes["NotificationTargetGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NotificationTargetGroupUpsertResult']?: Omit<ValueTypes["NotificationTargetGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProcessedNotificationCreateResult']?: Omit<ValueTypes["ProcessedNotificationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProcessedNotificationDeleteResult']?: Omit<ValueTypes["ProcessedNotificationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProcessedNotificationUpdateResult']?: Omit<ValueTypes["ProcessedNotificationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProcessedNotificationUpsertResult']?: Omit<ValueTypes["ProcessedNotificationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScheduledNotificationCreateResult']?: Omit<ValueTypes["ScheduledNotificationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScheduledNotificationDeleteResult']?: Omit<ValueTypes["ScheduledNotificationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScheduledNotificationUpdateResult']?: Omit<ValueTypes["ScheduledNotificationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScheduledNotificationUpsertResult']?: Omit<ValueTypes["ScheduledNotificationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProcessedNotificationSourceCreateResult']?: Omit<ValueTypes["ProcessedNotificationSourceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProcessedNotificationSourceDeleteResult']?: Omit<ValueTypes["ProcessedNotificationSourceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProcessedNotificationSourceUpdateResult']?: Omit<ValueTypes["ProcessedNotificationSourceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProcessedNotificationSourceUpsertResult']?: Omit<ValueTypes["ProcessedNotificationSourceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeviceCreateResult']?: Omit<ValueTypes["DeviceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeviceDeleteResult']?: Omit<ValueTypes["DeviceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeviceUpdateResult']?: Omit<ValueTypes["DeviceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeviceUpsertResult']?: Omit<ValueTypes["DeviceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScheduledNotificationLocaleCreateResult']?: Omit<ValueTypes["ScheduledNotificationLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScheduledNotificationLocaleDeleteResult']?: Omit<ValueTypes["ScheduledNotificationLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScheduledNotificationLocaleUpdateResult']?: Omit<ValueTypes["ScheduledNotificationLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScheduledNotificationLocaleUpsertResult']?: Omit<ValueTypes["ScheduledNotificationLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselItemLocaleCreateResult']?: Omit<ValueTypes["InfoCarouselItemLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselItemLocaleDeleteResult']?: Omit<ValueTypes["InfoCarouselItemLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselItemLocaleUpdateResult']?: Omit<ValueTypes["InfoCarouselItemLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCarouselItemLocaleUpsertResult']?: Omit<ValueTypes["InfoCarouselItemLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SentPaymentLocaleCreateResult']?: Omit<ValueTypes["SentPaymentLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SentPaymentLocaleDeleteResult']?: Omit<ValueTypes["SentPaymentLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SentPaymentLocaleUpdateResult']?: Omit<ValueTypes["SentPaymentLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SentPaymentLocaleUpsertResult']?: Omit<ValueTypes["SentPaymentLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextImageListCreateResult']?: Omit<ValueTypes["TextImageListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextImageListDeleteResult']?: Omit<ValueTypes["TextImageListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextImageListUpdateResult']?: Omit<ValueTypes["TextImageListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextImageListUpsertResult']?: Omit<ValueTypes["TextImageListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextImageListItemCreateResult']?: Omit<ValueTypes["TextImageListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextImageListItemDeleteResult']?: Omit<ValueTypes["TextImageListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextImageListItemUpdateResult']?: Omit<ValueTypes["TextImageListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextImageListItemUpsertResult']?: Omit<ValueTypes["TextImageListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCarouselItemCreateResult']?: Omit<ValueTypes["HeroCarouselItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCarouselItemDeleteResult']?: Omit<ValueTypes["HeroCarouselItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCarouselItemUpdateResult']?: Omit<ValueTypes["HeroCarouselItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCarouselItemUpsertResult']?: Omit<ValueTypes["HeroCarouselItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: boolean | `@${string}`
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["GeneralDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["General"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["General"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["General"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GeneralLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GeneralLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GeneralLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GeneralLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Post"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Post"],
		__typename?: boolean | `@${string}`
}>;
	["PostUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Post"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Post"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostArea"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostArea"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostArea"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostArea"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganization"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganization"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganization"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganization"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Donation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Donation"],
		__typename?: boolean | `@${string}`
}>;
	["DonationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Donation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Donation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountItem"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountsRegionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountsRegionItem"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountsRegionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountsRegionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountsRegionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountsRegionList"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountsRegionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DonationAmountsRegionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Region"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Region"],
		__typename?: boolean | `@${string}`
}>;
	["RegionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Region"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Region"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: boolean | `@${string}`
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostList"],
		__typename?: boolean | `@${string}`
}>;
	["PostListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostListItem"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppBanner"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutSettings"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutSettings"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutSettings"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutSettings"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutSettingsLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutSettingsLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutSettingsLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutSettingsLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Value"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Value"],
		__typename?: boolean | `@${string}`
}>;
	["ValueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Value"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Value"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ValueItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ValueItem"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ValueItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ValueItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ValueList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ValueList"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ValueList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ValueList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLink"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLinkList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaList"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaListItem"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostAreaListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Accordion"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Accordion"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Accordion"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Accordion"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AccordionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AccordionItem"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AccordionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AccordionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["UserUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPayment"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Currency"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Currency"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Currency"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Currency"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPaymentOrderId"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPaymentOrderId"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPaymentOrderId"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPaymentOrderId"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostRevision"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostRevision"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostRevision"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostRevision"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserRecurringPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserRecurringPayment"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserRecurringPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserRecurringPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserRecurringPaymentItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserRecurringPaymentItem"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserRecurringPaymentItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserRecurringPaymentItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostRevisionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostRevisionLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostRevisionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostRevisionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutGroupLinksLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutGroupLinksLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutGroupLinksLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageAboutGroupLinksLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberList"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberListItem"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilledTaxForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilledTaxForm"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilledTaxForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilledTaxForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilledTaxFormEmailAddress"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilledTaxFormEmailAddress"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilledTaxFormEmailAddress"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilledTaxFormEmailAddress"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Form"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Form"],
		__typename?: boolean | `@${string}`
}>;
	["FormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Form"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Form"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CsobPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CsobPayment"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CsobPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CsobPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CsobPaymentStatusChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CsobPaymentStatusChange"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CsobPaymentStatusChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CsobPaymentStatusChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StripePayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StripePayment"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StripePayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StripePayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StripePaymentStatusChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StripePaymentStatusChange"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StripePaymentStatusChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StripePaymentStatusChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegionPaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegionPaymentMethod"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegionPaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegionPaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TileItem"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TileList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TileList"],
		__typename?: boolean | `@${string}`
}>;
	["TileListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TileList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TileList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPage"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageSection"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageTileStripe"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageTileStripe"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageTileStripe"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FeedPageTileStripe"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardItem"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardList"],
		__typename?: boolean | `@${string}`
}>;
	["CardListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OnBehalfDonation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OnBehalfDonation"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OnBehalfDonation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OnBehalfDonation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPaymentTriesCollection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPaymentTriesCollection"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPaymentTriesCollection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserPaymentTriesCollection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecurringPaymentPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecurringPaymentPage"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecurringPaymentPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecurringPaymentPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecurringPaymentPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecurringPaymentPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecurringPaymentPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecurringPaymentPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuide"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuideItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuideItem"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuideItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuideItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuideList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuideList"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuideList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoryGuideList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeroCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeroCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeroCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeroCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationList"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationListItem"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PostOrganizationListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PersonSeenInfoCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PersonSeenInfoCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PersonSeenInfoCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PersonSeenInfoCarousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GivenGiftsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GivenGiftsPage"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GivenGiftsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GivenGiftsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GivenGiftsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GivenGiftsPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GivenGiftsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GivenGiftsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReceivedGiftsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReceivedGiftsPage"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReceivedGiftsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReceivedGiftsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReceivedGiftsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReceivedGiftsPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReceivedGiftsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReceivedGiftsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportNavigation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportNavigation"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportNavigation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportNavigation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportPage"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportNavigationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportNavigationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportNavigationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReportNavigationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SentPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SentPayment"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SentPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SentPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NotificationTargetGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NotificationTargetGroup"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NotificationTargetGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NotificationTargetGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProcessedNotification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProcessedNotification"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProcessedNotification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProcessedNotification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ScheduledNotification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ScheduledNotification"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ScheduledNotification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ScheduledNotification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProcessedNotificationSource"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProcessedNotificationSource"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProcessedNotificationSource"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProcessedNotificationSource"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Device"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Device"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Device"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Device"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ScheduledNotificationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ScheduledNotificationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ScheduledNotificationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ScheduledNotificationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarouselItemLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarouselItemLocale"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarouselItemLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCarouselItemLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SentPaymentLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SentPaymentLocale"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SentPaymentLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SentPaymentLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextImageList"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeroCarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeroCarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeroCarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeroCarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransaction"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
generateUploadUrl?: [{	input?: ValueTypes["S3GenerateSignedUploadInput"] | undefined | null | Variable<any, string>},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string | Variable<any, string>,	expiration?: number | undefined | null | Variable<any, string>},ValueTypes["S3SignedRead"]],
createGeneral?: [{	data: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["GeneralCreateResult"]],
deleteGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralDeleteResult"]],
updateGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GeneralUpdateInput"] | Variable<any, string>},ValueTypes["GeneralUpdateResult"]],
upsertGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GeneralUpdateInput"] | Variable<any, string>,	create: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["GeneralUpsertResult"]],
createImage?: [{	data: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageUpdateInput"] | Variable<any, string>},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["ImageUpsertResult"]],
createGenericPage?: [{	data: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkableUpdateInput"] | Variable<any, string>},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkableUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["LinkableUpsertResult"]],
createSeo?: [{	data: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SeoUpdateInput"] | Variable<any, string>},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,	create: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["SeoUpsertResult"]],
createContent?: [{	data: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentUpdateInput"] | Variable<any, string>},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["ContentReferenceUpsertResult"]],
createGeneralLocale?: [{	data: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleCreateResult"]],
deleteGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleDeleteResult"]],
updateGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleUpdateResult"]],
upsertGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleUpsertResult"]],
createGenericPageLocale?: [{	data: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleCreateResult"]],
deleteGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleDeleteResult"]],
updateGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleUpdateResult"]],
upsertGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleUpsertResult"]],
createLocale?: [{	data: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LocaleUpdateInput"] | Variable<any, string>},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["LocaleUpsertResult"]],
createVideo?: [{	data: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["VideoUpdateInput"] | Variable<any, string>},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,	create: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["VideoUpsertResult"]],
createLink?: [{	data: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkUpdateInput"] | Variable<any, string>},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["LinkUpsertResult"]],
createPost?: [{	data: ValueTypes["PostCreateInput"] | Variable<any, string>},ValueTypes["PostCreateResult"]],
deletePost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostDeleteResult"]],
updatePost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostUpdateInput"] | Variable<any, string>},ValueTypes["PostUpdateResult"]],
upsertPost?: [{	by: ValueTypes["PostUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostCreateInput"] | Variable<any, string>},ValueTypes["PostUpsertResult"]],
createPostLocale?: [{	data: ValueTypes["PostLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostLocaleCreateResult"]],
deletePostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostLocaleDeleteResult"]],
updatePostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostLocaleUpdateInput"] | Variable<any, string>},ValueTypes["PostLocaleUpdateResult"]],
upsertPostLocale?: [{	by: ValueTypes["PostLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostLocaleUpsertResult"]],
createPostArea?: [{	data: ValueTypes["PostAreaCreateInput"] | Variable<any, string>},ValueTypes["PostAreaCreateResult"]],
deletePostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaDeleteResult"]],
updatePostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>},ValueTypes["PostAreaUpdateResult"]],
upsertPostArea?: [{	by: ValueTypes["PostAreaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostAreaUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostAreaCreateInput"] | Variable<any, string>},ValueTypes["PostAreaUpsertResult"]],
createPostAreaLocale?: [{	data: ValueTypes["PostAreaLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostAreaLocaleCreateResult"]],
deletePostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaLocaleDeleteResult"]],
updatePostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostAreaLocaleUpdateInput"] | Variable<any, string>},ValueTypes["PostAreaLocaleUpdateResult"]],
upsertPostAreaLocale?: [{	by: ValueTypes["PostAreaLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostAreaLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostAreaLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostAreaLocaleUpsertResult"]],
createPostOrganization?: [{	data: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationCreateResult"]],
deletePostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationDeleteResult"]],
updatePostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostOrganizationUpdateInput"] | Variable<any, string>},ValueTypes["PostOrganizationUpdateResult"]],
upsertPostOrganization?: [{	by: ValueTypes["PostOrganizationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostOrganizationUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostOrganizationCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationUpsertResult"]],
createPostOrganizationLocale?: [{	data: ValueTypes["PostOrganizationLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationLocaleCreateResult"]],
deletePostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationLocaleDeleteResult"]],
updatePostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostOrganizationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["PostOrganizationLocaleUpdateResult"]],
upsertPostOrganizationLocale?: [{	by: ValueTypes["PostOrganizationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostOrganizationLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostOrganizationLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationLocaleUpsertResult"]],
createDonation?: [{	data: ValueTypes["DonationCreateInput"] | Variable<any, string>},ValueTypes["DonationCreateResult"]],
deleteDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationDeleteResult"]],
updateDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DonationUpdateInput"] | Variable<any, string>},ValueTypes["DonationUpdateResult"]],
upsertDonation?: [{	by: ValueTypes["DonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DonationUpdateInput"] | Variable<any, string>,	create: ValueTypes["DonationCreateInput"] | Variable<any, string>},ValueTypes["DonationUpsertResult"]],
createDonationAmountItem?: [{	data: ValueTypes["DonationAmountItemCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountItemCreateResult"]],
deleteDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountItemDeleteResult"]],
updateDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DonationAmountItemUpdateInput"] | Variable<any, string>},ValueTypes["DonationAmountItemUpdateResult"]],
upsertDonationAmountItem?: [{	by: ValueTypes["DonationAmountItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DonationAmountItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["DonationAmountItemCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountItemUpsertResult"]],
createDonationAmountsRegionItem?: [{	data: ValueTypes["DonationAmountsRegionItemCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionItemCreateResult"]],
deleteDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionItemDeleteResult"]],
updateDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DonationAmountsRegionItemUpdateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionItemUpdateResult"]],
upsertDonationAmountsRegionItem?: [{	by: ValueTypes["DonationAmountsRegionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DonationAmountsRegionItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["DonationAmountsRegionItemCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionItemUpsertResult"]],
createDonationAmountsRegionList?: [{	data: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionListCreateResult"]],
deleteDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>},ValueTypes["DonationAmountsRegionListDeleteResult"]],
updateDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DonationAmountsRegionListUpdateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionListUpdateResult"]],
upsertDonationAmountsRegionList?: [{	by: ValueTypes["DonationAmountsRegionListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DonationAmountsRegionListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DonationAmountsRegionListUpdateInput"] | Variable<any, string>,	create: ValueTypes["DonationAmountsRegionListCreateInput"] | Variable<any, string>},ValueTypes["DonationAmountsRegionListUpsertResult"]],
createRegion?: [{	data: ValueTypes["RegionCreateInput"] | Variable<any, string>},ValueTypes["RegionCreateResult"]],
deleteRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>},ValueTypes["RegionDeleteResult"]],
updateRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RegionUpdateInput"] | Variable<any, string>},ValueTypes["RegionUpdateResult"]],
upsertRegion?: [{	by: ValueTypes["RegionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RegionUpdateInput"] | Variable<any, string>,	create: ValueTypes["RegionCreateInput"] | Variable<any, string>},ValueTypes["RegionUpsertResult"]],
createLinkItem?: [{	data: ValueTypes["LinkItemCreateInput"] | Variable<any, string>},ValueTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkItemUpdateInput"] | Variable<any, string>},ValueTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by: ValueTypes["LinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkItemCreateInput"] | Variable<any, string>},ValueTypes["LinkItemUpsertResult"]],
createLinkList?: [{	data: ValueTypes["LinkListCreateInput"] | Variable<any, string>},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkListUpdateInput"] | Variable<any, string>},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkListUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkListCreateInput"] | Variable<any, string>},ValueTypes["LinkListUpsertResult"]],
createHeader?: [{	data: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeaderUpdateInput"] | Variable<any, string>},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeaderUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["HeaderUpsertResult"]],
createHeaderLocale?: [{	data: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleUpsertResult"]],
createFooter?: [{	data: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterUpdateInput"] | Variable<any, string>},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["FooterUpsertResult"]],
createFooterLocale?: [{	data: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["FooterLocaleUpsertResult"]],
createPostList?: [{	data: ValueTypes["PostListCreateInput"] | Variable<any, string>},ValueTypes["PostListCreateResult"]],
deletePostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostListDeleteResult"]],
updatePostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostListUpdateInput"] | Variable<any, string>},ValueTypes["PostListUpdateResult"]],
upsertPostList?: [{	by: ValueTypes["PostListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostListUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostListCreateInput"] | Variable<any, string>},ValueTypes["PostListUpsertResult"]],
createPostListItem?: [{	data: ValueTypes["PostListItemCreateInput"] | Variable<any, string>},ValueTypes["PostListItemCreateResult"]],
deletePostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostListItemDeleteResult"]],
updatePostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostListItemUpdateInput"] | Variable<any, string>},ValueTypes["PostListItemUpdateResult"]],
upsertPostListItem?: [{	by: ValueTypes["PostListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostListItemCreateInput"] | Variable<any, string>},ValueTypes["PostListItemUpsertResult"]],
createAppBanner?: [{	data: ValueTypes["AppBannerCreateInput"] | Variable<any, string>},ValueTypes["AppBannerCreateResult"]],
deleteAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["AppBannerDeleteResult"]],
updateAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["AppBannerUpdateInput"] | Variable<any, string>},ValueTypes["AppBannerUpdateResult"]],
upsertAppBanner?: [{	by: ValueTypes["AppBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AppBannerWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["AppBannerUpdateInput"] | Variable<any, string>,	create: ValueTypes["AppBannerCreateInput"] | Variable<any, string>},ValueTypes["AppBannerUpsertResult"]],
createGenericPageAboutSettings?: [{	data: ValueTypes["GenericPageAboutSettingsCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsCreateResult"]],
deleteGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsDeleteResult"]],
updateGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageAboutSettingsUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsUpdateResult"]],
upsertGenericPageAboutSettings?: [{	by: ValueTypes["GenericPageAboutSettingsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageAboutSettingsUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageAboutSettingsCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsUpsertResult"]],
createGenericPageAboutSettingsLocale?: [{	data: ValueTypes["GenericPageAboutSettingsLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleCreateResult"]],
deleteGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleDeleteResult"]],
updateGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageAboutSettingsLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleUpdateResult"]],
upsertGenericPageAboutSettingsLocale?: [{	by: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageAboutSettingsLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageAboutSettingsLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutSettingsLocaleUpsertResult"]],
createValue?: [{	data: ValueTypes["ValueCreateInput"] | Variable<any, string>},ValueTypes["ValueCreateResult"]],
deleteValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueDeleteResult"]],
updateValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ValueUpdateInput"] | Variable<any, string>},ValueTypes["ValueUpdateResult"]],
upsertValue?: [{	by: ValueTypes["ValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ValueUpdateInput"] | Variable<any, string>,	create: ValueTypes["ValueCreateInput"] | Variable<any, string>},ValueTypes["ValueUpsertResult"]],
createValueItem?: [{	data: ValueTypes["ValueItemCreateInput"] | Variable<any, string>},ValueTypes["ValueItemCreateResult"]],
deleteValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueItemDeleteResult"]],
updateValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ValueItemUpdateInput"] | Variable<any, string>},ValueTypes["ValueItemUpdateResult"]],
upsertValueItem?: [{	by: ValueTypes["ValueItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ValueItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["ValueItemCreateInput"] | Variable<any, string>},ValueTypes["ValueItemUpsertResult"]],
createValueList?: [{	data: ValueTypes["ValueListCreateInput"] | Variable<any, string>},ValueTypes["ValueListCreateResult"]],
deleteValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ValueListDeleteResult"]],
updateValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ValueListUpdateInput"] | Variable<any, string>},ValueTypes["ValueListUpdateResult"]],
upsertValueList?: [{	by: ValueTypes["ValueListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ValueListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ValueListUpdateInput"] | Variable<any, string>,	create: ValueTypes["ValueListCreateInput"] | Variable<any, string>},ValueTypes["ValueListUpsertResult"]],
createImageLink?: [{	data: ValueTypes["ImageLinkCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkCreateResult"]],
deleteImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkDeleteResult"]],
updateImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageLinkUpdateInput"] | Variable<any, string>},ValueTypes["ImageLinkUpdateResult"]],
upsertImageLink?: [{	by: ValueTypes["ImageLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageLinkUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageLinkCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkUpsertResult"]],
createImageLinkItem?: [{	data: ValueTypes["ImageLinkItemCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkItemCreateResult"]],
deleteImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkItemDeleteResult"]],
updateImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageLinkItemUpdateInput"] | Variable<any, string>},ValueTypes["ImageLinkItemUpdateResult"]],
upsertImageLinkItem?: [{	by: ValueTypes["ImageLinkItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageLinkItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageLinkItemCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkItemUpsertResult"]],
createImageLinkList?: [{	data: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkListCreateResult"]],
deleteImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageLinkListDeleteResult"]],
updateImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageLinkListUpdateInput"] | Variable<any, string>},ValueTypes["ImageLinkListUpdateResult"]],
upsertImageLinkList?: [{	by: ValueTypes["ImageLinkListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageLinkListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageLinkListUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageLinkListCreateInput"] | Variable<any, string>},ValueTypes["ImageLinkListUpsertResult"]],
createPostAreaList?: [{	data: ValueTypes["PostAreaListCreateInput"] | Variable<any, string>},ValueTypes["PostAreaListCreateResult"]],
deletePostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaListDeleteResult"]],
updatePostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostAreaListUpdateInput"] | Variable<any, string>},ValueTypes["PostAreaListUpdateResult"]],
upsertPostAreaList?: [{	by: ValueTypes["PostAreaListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostAreaListUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostAreaListCreateInput"] | Variable<any, string>},ValueTypes["PostAreaListUpsertResult"]],
createPostAreaListItem?: [{	data: ValueTypes["PostAreaListItemCreateInput"] | Variable<any, string>},ValueTypes["PostAreaListItemCreateResult"]],
deletePostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostAreaListItemDeleteResult"]],
updatePostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostAreaListItemUpdateInput"] | Variable<any, string>},ValueTypes["PostAreaListItemUpdateResult"]],
upsertPostAreaListItem?: [{	by: ValueTypes["PostAreaListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostAreaListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostAreaListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostAreaListItemCreateInput"] | Variable<any, string>},ValueTypes["PostAreaListItemUpsertResult"]],
createAccordion?: [{	data: ValueTypes["AccordionCreateInput"] | Variable<any, string>},ValueTypes["AccordionCreateResult"]],
deleteAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>},ValueTypes["AccordionDeleteResult"]],
updateAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["AccordionUpdateInput"] | Variable<any, string>},ValueTypes["AccordionUpdateResult"]],
upsertAccordion?: [{	by: ValueTypes["AccordionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["AccordionUpdateInput"] | Variable<any, string>,	create: ValueTypes["AccordionCreateInput"] | Variable<any, string>},ValueTypes["AccordionUpsertResult"]],
createAccordionItem?: [{	data: ValueTypes["AccordionItemCreateInput"] | Variable<any, string>},ValueTypes["AccordionItemCreateResult"]],
deleteAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["AccordionItemDeleteResult"]],
updateAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["AccordionItemUpdateInput"] | Variable<any, string>},ValueTypes["AccordionItemUpdateResult"]],
upsertAccordionItem?: [{	by: ValueTypes["AccordionItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["AccordionItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["AccordionItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["AccordionItemCreateInput"] | Variable<any, string>},ValueTypes["AccordionItemUpsertResult"]],
createUser?: [{	data: ValueTypes["UserCreateInput"] | Variable<any, string>},ValueTypes["UserCreateResult"]],
deleteUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserDeleteResult"]],
updateUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserUpdateInput"] | Variable<any, string>},ValueTypes["UserUpdateResult"]],
upsertUser?: [{	by: ValueTypes["UserUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserCreateInput"] | Variable<any, string>},ValueTypes["UserUpsertResult"]],
createUserPayment?: [{	data: ValueTypes["UserPaymentCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentCreateResult"]],
deleteUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentDeleteResult"]],
updateUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserPaymentUpdateInput"] | Variable<any, string>},ValueTypes["UserPaymentUpdateResult"]],
upsertUserPayment?: [{	by: ValueTypes["UserPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserPaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserPaymentCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentUpsertResult"]],
createCurrency?: [{	data: ValueTypes["CurrencyCreateInput"] | Variable<any, string>},ValueTypes["CurrencyCreateResult"]],
deleteCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>},ValueTypes["CurrencyDeleteResult"]],
updateCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>},ValueTypes["CurrencyUpdateResult"]],
upsertCurrency?: [{	by: ValueTypes["CurrencyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CurrencyWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CurrencyUpdateInput"] | Variable<any, string>,	create: ValueTypes["CurrencyCreateInput"] | Variable<any, string>},ValueTypes["CurrencyUpsertResult"]],
createMedium?: [{	data: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumUpdateInput"] | Variable<any, string>},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["MediumUpsertResult"]],
createMediumItem?: [{	data: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>},ValueTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumListUpdateInput"] | Variable<any, string>},ValueTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumListUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["MediumListUpsertResult"]],
createUserPaymentOrderId?: [{	data: ValueTypes["UserPaymentOrderIdCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentOrderIdCreateResult"]],
deleteUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentOrderIdDeleteResult"]],
updateUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserPaymentOrderIdUpdateInput"] | Variable<any, string>},ValueTypes["UserPaymentOrderIdUpdateResult"]],
upsertUserPaymentOrderId?: [{	by: ValueTypes["UserPaymentOrderIdUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentOrderIdWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserPaymentOrderIdUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserPaymentOrderIdCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentOrderIdUpsertResult"]],
createPostRevision?: [{	data: ValueTypes["PostRevisionCreateInput"] | Variable<any, string>},ValueTypes["PostRevisionCreateResult"]],
deletePostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionDeleteResult"]],
updatePostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostRevisionUpdateInput"] | Variable<any, string>},ValueTypes["PostRevisionUpdateResult"]],
upsertPostRevision?: [{	by: ValueTypes["PostRevisionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostRevisionUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostRevisionCreateInput"] | Variable<any, string>},ValueTypes["PostRevisionUpsertResult"]],
createUserRecurringPayment?: [{	data: ValueTypes["UserRecurringPaymentCreateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentCreateResult"]],
deleteUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentDeleteResult"]],
updateUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserRecurringPaymentUpdateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentUpdateResult"]],
upsertUserRecurringPayment?: [{	by: ValueTypes["UserRecurringPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserRecurringPaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserRecurringPaymentCreateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentUpsertResult"]],
createUserRecurringPaymentItem?: [{	data: ValueTypes["UserRecurringPaymentItemCreateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentItemCreateResult"]],
deleteUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserRecurringPaymentItemDeleteResult"]],
updateUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserRecurringPaymentItemUpdateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentItemUpdateResult"]],
upsertUserRecurringPaymentItem?: [{	by: ValueTypes["UserRecurringPaymentItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserRecurringPaymentItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserRecurringPaymentItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserRecurringPaymentItemCreateInput"] | Variable<any, string>},ValueTypes["UserRecurringPaymentItemUpsertResult"]],
createPostRevisionLocale?: [{	data: ValueTypes["PostRevisionLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostRevisionLocaleCreateResult"]],
deletePostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostRevisionLocaleDeleteResult"]],
updatePostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostRevisionLocaleUpdateInput"] | Variable<any, string>},ValueTypes["PostRevisionLocaleUpdateResult"]],
upsertPostRevisionLocale?: [{	by: ValueTypes["PostRevisionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostRevisionLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostRevisionLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostRevisionLocaleCreateInput"] | Variable<any, string>},ValueTypes["PostRevisionLocaleUpsertResult"]],
createTranslationCatalogue?: [{	data: ValueTypes["TranslationCatalogueCreateInput"] | Variable<any, string>},ValueTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationCatalogueUpdateInput"] | Variable<any, string>},ValueTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationCatalogueUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationCatalogueCreateInput"] | Variable<any, string>},ValueTypes["TranslationCatalogueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationCataloguesIdentifierUpdateInput"] | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationCataloguesIdentifierUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | Variable<any, string>},ValueTypes["TranslationCataloguesIdentifierUpsertResult"]],
createTranslationDomain?: [{	data: ValueTypes["TranslationDomainCreateInput"] | Variable<any, string>},ValueTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationDomainUpdateInput"] | Variable<any, string>},ValueTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationDomainUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationDomainCreateInput"] | Variable<any, string>},ValueTypes["TranslationDomainUpsertResult"]],
createTranslationKey?: [{	data: ValueTypes["TranslationKeyCreateInput"] | Variable<any, string>},ValueTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationKeyUpdateInput"] | Variable<any, string>},ValueTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationKeyUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationKeyCreateInput"] | Variable<any, string>},ValueTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data: ValueTypes["TranslationValueCreateInput"] | Variable<any, string>},ValueTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationValueUpdateInput"] | Variable<any, string>},ValueTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationValueWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationValueUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationValueCreateInput"] | Variable<any, string>},ValueTypes["TranslationValueUpsertResult"]],
createGenericPageAboutGroupLinksLocale?: [{	data: ValueTypes["GenericPageAboutGroupLinksLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleCreateResult"]],
deleteGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleDeleteResult"]],
updateGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleUpdateResult"]],
upsertGenericPageAboutGroupLinksLocale?: [{	by: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageAboutGroupLinksLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageAboutGroupLinksLocaleUpsertResult"]],
createMemberList?: [{	data: ValueTypes["MemberListCreateInput"] | Variable<any, string>},ValueTypes["MemberListCreateResult"]],
deleteMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberListDeleteResult"]],
updateMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MemberListUpdateInput"] | Variable<any, string>},ValueTypes["MemberListUpdateResult"]],
upsertMemberList?: [{	by: ValueTypes["MemberListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MemberListUpdateInput"] | Variable<any, string>,	create: ValueTypes["MemberListCreateInput"] | Variable<any, string>},ValueTypes["MemberListUpsertResult"]],
createMemberListItem?: [{	data: ValueTypes["MemberListItemCreateInput"] | Variable<any, string>},ValueTypes["MemberListItemCreateResult"]],
deleteMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MemberListItemDeleteResult"]],
updateMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MemberListItemUpdateInput"] | Variable<any, string>},ValueTypes["MemberListItemUpdateResult"]],
upsertMemberListItem?: [{	by: ValueTypes["MemberListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MemberListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MemberListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["MemberListItemCreateInput"] | Variable<any, string>},ValueTypes["MemberListItemUpsertResult"]],
createFilledTaxForm?: [{	data: ValueTypes["FilledTaxFormCreateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormCreateResult"]],
deleteFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormDeleteResult"]],
updateFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FilledTaxFormUpdateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormUpdateResult"]],
upsertFilledTaxForm?: [{	by: ValueTypes["FilledTaxFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FilledTaxFormUpdateInput"] | Variable<any, string>,	create: ValueTypes["FilledTaxFormCreateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormUpsertResult"]],
createFilledTaxFormEmailAddress?: [{	data: ValueTypes["FilledTaxFormEmailAddressCreateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressCreateResult"]],
deleteFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressDeleteResult"]],
updateFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FilledTaxFormEmailAddressUpdateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressUpdateResult"]],
upsertFilledTaxFormEmailAddress?: [{	by: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FilledTaxFormEmailAddressWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FilledTaxFormEmailAddressUpdateInput"] | Variable<any, string>,	create: ValueTypes["FilledTaxFormEmailAddressCreateInput"] | Variable<any, string>},ValueTypes["FilledTaxFormEmailAddressUpsertResult"]],
createForm?: [{	data: ValueTypes["FormCreateInput"] | Variable<any, string>},ValueTypes["FormCreateResult"]],
deleteForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>},ValueTypes["FormDeleteResult"]],
updateForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FormUpdateInput"] | Variable<any, string>},ValueTypes["FormUpdateResult"]],
upsertForm?: [{	by: ValueTypes["FormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FormWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FormUpdateInput"] | Variable<any, string>,	create: ValueTypes["FormCreateInput"] | Variable<any, string>},ValueTypes["FormUpsertResult"]],
createCsobPayment?: [{	data: ValueTypes["CsobPaymentCreateInput"] | Variable<any, string>},ValueTypes["CsobPaymentCreateResult"]],
deleteCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentDeleteResult"]],
updateCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CsobPaymentUpdateInput"] | Variable<any, string>},ValueTypes["CsobPaymentUpdateResult"]],
upsertCsobPayment?: [{	by: ValueTypes["CsobPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CsobPaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["CsobPaymentCreateInput"] | Variable<any, string>},ValueTypes["CsobPaymentUpsertResult"]],
createCsobPaymentStatusChange?: [{	data: ValueTypes["CsobPaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeCreateResult"]],
deleteCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeDeleteResult"]],
updateCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CsobPaymentStatusChangeUpdateInput"] | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeUpdateResult"]],
upsertCsobPaymentStatusChange?: [{	by: ValueTypes["CsobPaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CsobPaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CsobPaymentStatusChangeUpdateInput"] | Variable<any, string>,	create: ValueTypes["CsobPaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["CsobPaymentStatusChangeUpsertResult"]],
createStripePayment?: [{	data: ValueTypes["StripePaymentCreateInput"] | Variable<any, string>},ValueTypes["StripePaymentCreateResult"]],
deleteStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentDeleteResult"]],
updateStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StripePaymentUpdateInput"] | Variable<any, string>},ValueTypes["StripePaymentUpdateResult"]],
upsertStripePayment?: [{	by: ValueTypes["StripePaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StripePaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["StripePaymentCreateInput"] | Variable<any, string>},ValueTypes["StripePaymentUpsertResult"]],
createStripePaymentStatusChange?: [{	data: ValueTypes["StripePaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["StripePaymentStatusChangeCreateResult"]],
deleteStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>},ValueTypes["StripePaymentStatusChangeDeleteResult"]],
updateStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StripePaymentStatusChangeUpdateInput"] | Variable<any, string>},ValueTypes["StripePaymentStatusChangeUpdateResult"]],
upsertStripePaymentStatusChange?: [{	by: ValueTypes["StripePaymentStatusChangeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StripePaymentStatusChangeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StripePaymentStatusChangeUpdateInput"] | Variable<any, string>,	create: ValueTypes["StripePaymentStatusChangeCreateInput"] | Variable<any, string>},ValueTypes["StripePaymentStatusChangeUpsertResult"]],
createRegionPaymentMethod?: [{	data: ValueTypes["RegionPaymentMethodCreateInput"] | Variable<any, string>},ValueTypes["RegionPaymentMethodCreateResult"]],
deleteRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>},ValueTypes["RegionPaymentMethodDeleteResult"]],
updateRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RegionPaymentMethodUpdateInput"] | Variable<any, string>},ValueTypes["RegionPaymentMethodUpdateResult"]],
upsertRegionPaymentMethod?: [{	by: ValueTypes["RegionPaymentMethodUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RegionPaymentMethodWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RegionPaymentMethodUpdateInput"] | Variable<any, string>,	create: ValueTypes["RegionPaymentMethodCreateInput"] | Variable<any, string>},ValueTypes["RegionPaymentMethodUpsertResult"]],
createTileItem?: [{	data: ValueTypes["TileItemCreateInput"] | Variable<any, string>},ValueTypes["TileItemCreateResult"]],
deleteTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileItemDeleteResult"]],
updateTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TileItemUpdateInput"] | Variable<any, string>},ValueTypes["TileItemUpdateResult"]],
upsertTileItem?: [{	by: ValueTypes["TileItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TileItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["TileItemCreateInput"] | Variable<any, string>},ValueTypes["TileItemUpsertResult"]],
createTileList?: [{	data: ValueTypes["TileListCreateInput"] | Variable<any, string>},ValueTypes["TileListCreateResult"]],
deleteTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileListDeleteResult"]],
updateTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TileListUpdateInput"] | Variable<any, string>},ValueTypes["TileListUpdateResult"]],
upsertTileList?: [{	by: ValueTypes["TileListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TileListUpdateInput"] | Variable<any, string>,	create: ValueTypes["TileListCreateInput"] | Variable<any, string>},ValueTypes["TileListUpsertResult"]],
createFeedPage?: [{	data: ValueTypes["FeedPageCreateInput"] | Variable<any, string>},ValueTypes["FeedPageCreateResult"]],
deleteFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageDeleteResult"]],
updateFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FeedPageUpdateInput"] | Variable<any, string>},ValueTypes["FeedPageUpdateResult"]],
upsertFeedPage?: [{	by: ValueTypes["FeedPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FeedPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["FeedPageCreateInput"] | Variable<any, string>},ValueTypes["FeedPageUpsertResult"]],
createFeedPageLocale?: [{	data: ValueTypes["FeedPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["FeedPageLocaleCreateResult"]],
deleteFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageLocaleDeleteResult"]],
updateFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FeedPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["FeedPageLocaleUpdateResult"]],
upsertFeedPageLocale?: [{	by: ValueTypes["FeedPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FeedPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["FeedPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["FeedPageLocaleUpsertResult"]],
createFeedPageSection?: [{	data: ValueTypes["FeedPageSectionCreateInput"] | Variable<any, string>},ValueTypes["FeedPageSectionCreateResult"]],
deleteFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageSectionDeleteResult"]],
updateFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FeedPageSectionUpdateInput"] | Variable<any, string>},ValueTypes["FeedPageSectionUpdateResult"]],
upsertFeedPageSection?: [{	by: ValueTypes["FeedPageSectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageSectionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FeedPageSectionUpdateInput"] | Variable<any, string>,	create: ValueTypes["FeedPageSectionCreateInput"] | Variable<any, string>},ValueTypes["FeedPageSectionUpsertResult"]],
createFeedPageTileStripe?: [{	data: ValueTypes["FeedPageTileStripeCreateInput"] | Variable<any, string>},ValueTypes["FeedPageTileStripeCreateResult"]],
deleteFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>},ValueTypes["FeedPageTileStripeDeleteResult"]],
updateFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FeedPageTileStripeUpdateInput"] | Variable<any, string>},ValueTypes["FeedPageTileStripeUpdateResult"]],
upsertFeedPageTileStripe?: [{	by: ValueTypes["FeedPageTileStripeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FeedPageTileStripeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FeedPageTileStripeUpdateInput"] | Variable<any, string>,	create: ValueTypes["FeedPageTileStripeCreateInput"] | Variable<any, string>},ValueTypes["FeedPageTileStripeUpsertResult"]],
createCardItem?: [{	data: ValueTypes["CardItemCreateInput"] | Variable<any, string>},ValueTypes["CardItemCreateResult"]],
deleteCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardItemDeleteResult"]],
updateCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CardItemUpdateInput"] | Variable<any, string>},ValueTypes["CardItemUpdateResult"]],
upsertCardItem?: [{	by: ValueTypes["CardItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CardItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["CardItemCreateInput"] | Variable<any, string>},ValueTypes["CardItemUpsertResult"]],
createCardList?: [{	data: ValueTypes["CardListCreateInput"] | Variable<any, string>},ValueTypes["CardListCreateResult"]],
deleteCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>},ValueTypes["CardListDeleteResult"]],
updateCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CardListUpdateInput"] | Variable<any, string>},ValueTypes["CardListUpdateResult"]],
upsertCardList?: [{	by: ValueTypes["CardListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CardListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CardListUpdateInput"] | Variable<any, string>,	create: ValueTypes["CardListCreateInput"] | Variable<any, string>},ValueTypes["CardListUpsertResult"]],
createOnBehalfDonation?: [{	data: ValueTypes["OnBehalfDonationCreateInput"] | Variable<any, string>},ValueTypes["OnBehalfDonationCreateResult"]],
deleteOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>},ValueTypes["OnBehalfDonationDeleteResult"]],
updateOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["OnBehalfDonationUpdateInput"] | Variable<any, string>},ValueTypes["OnBehalfDonationUpdateResult"]],
upsertOnBehalfDonation?: [{	by: ValueTypes["OnBehalfDonationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["OnBehalfDonationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["OnBehalfDonationUpdateInput"] | Variable<any, string>,	create: ValueTypes["OnBehalfDonationCreateInput"] | Variable<any, string>},ValueTypes["OnBehalfDonationUpsertResult"]],
createUserPaymentTriesCollection?: [{	data: ValueTypes["UserPaymentTriesCollectionCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionCreateResult"]],
deleteUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionDeleteResult"]],
updateUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["UserPaymentTriesCollectionUpdateInput"] | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionUpdateResult"]],
upsertUserPaymentTriesCollection?: [{	by: ValueTypes["UserPaymentTriesCollectionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["UserPaymentTriesCollectionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["UserPaymentTriesCollectionUpdateInput"] | Variable<any, string>,	create: ValueTypes["UserPaymentTriesCollectionCreateInput"] | Variable<any, string>},ValueTypes["UserPaymentTriesCollectionUpsertResult"]],
createRecurringPaymentPage?: [{	data: ValueTypes["RecurringPaymentPageCreateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageCreateResult"]],
deleteRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageDeleteResult"]],
updateRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecurringPaymentPageUpdateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageUpdateResult"]],
upsertRecurringPaymentPage?: [{	by: ValueTypes["RecurringPaymentPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecurringPaymentPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecurringPaymentPageCreateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageUpsertResult"]],
createRecurringPaymentPageLocale?: [{	data: ValueTypes["RecurringPaymentPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleCreateResult"]],
deleteRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleDeleteResult"]],
updateRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecurringPaymentPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleUpdateResult"]],
upsertRecurringPaymentPageLocale?: [{	by: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecurringPaymentPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecurringPaymentPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecurringPaymentPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["RecurringPaymentPageLocaleUpsertResult"]],
createStoryGuide?: [{	data: ValueTypes["StoryGuideCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideCreateResult"]],
deleteStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideDeleteResult"]],
updateStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StoryGuideUpdateInput"] | Variable<any, string>},ValueTypes["StoryGuideUpdateResult"]],
upsertStoryGuide?: [{	by: ValueTypes["StoryGuideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StoryGuideUpdateInput"] | Variable<any, string>,	create: ValueTypes["StoryGuideCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideUpsertResult"]],
createStoryGuideItem?: [{	data: ValueTypes["StoryGuideItemCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideItemCreateResult"]],
deleteStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideItemDeleteResult"]],
updateStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StoryGuideItemUpdateInput"] | Variable<any, string>},ValueTypes["StoryGuideItemUpdateResult"]],
upsertStoryGuideItem?: [{	by: ValueTypes["StoryGuideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StoryGuideItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["StoryGuideItemCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideItemUpsertResult"]],
createStoryGuideList?: [{	data: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideListCreateResult"]],
deleteStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>},ValueTypes["StoryGuideListDeleteResult"]],
updateStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StoryGuideListUpdateInput"] | Variable<any, string>},ValueTypes["StoryGuideListUpdateResult"]],
upsertStoryGuideList?: [{	by: ValueTypes["StoryGuideListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StoryGuideListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StoryGuideListUpdateInput"] | Variable<any, string>,	create: ValueTypes["StoryGuideListCreateInput"] | Variable<any, string>},ValueTypes["StoryGuideListUpsertResult"]],
createHeroCarousel?: [{	data: ValueTypes["HeroCarouselCreateInput"] | Variable<any, string>},ValueTypes["HeroCarouselCreateResult"]],
deleteHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselDeleteResult"]],
updateHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeroCarouselUpdateInput"] | Variable<any, string>},ValueTypes["HeroCarouselUpdateResult"]],
upsertHeroCarousel?: [{	by: ValueTypes["HeroCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeroCarouselUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeroCarouselCreateInput"] | Variable<any, string>},ValueTypes["HeroCarouselUpsertResult"]],
createPostOrganizationList?: [{	data: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListCreateResult"]],
deletePostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListDeleteResult"]],
updatePostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListUpdateResult"]],
upsertPostOrganizationList?: [{	by: ValueTypes["PostOrganizationListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostOrganizationListUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostOrganizationListCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListUpsertResult"]],
createPostOrganizationListItem?: [{	data: ValueTypes["PostOrganizationListItemCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListItemCreateResult"]],
deletePostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["PostOrganizationListItemDeleteResult"]],
updatePostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PostOrganizationListItemUpdateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListItemUpdateResult"]],
upsertPostOrganizationListItem?: [{	by: ValueTypes["PostOrganizationListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PostOrganizationListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PostOrganizationListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["PostOrganizationListItemCreateInput"] | Variable<any, string>},ValueTypes["PostOrganizationListItemUpsertResult"]],
createInfoCarousel?: [{	data: ValueTypes["InfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselCreateResult"]],
deleteInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselDeleteResult"]],
updateInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoCarouselUpdateInput"] | Variable<any, string>},ValueTypes["InfoCarouselUpdateResult"]],
upsertInfoCarousel?: [{	by: ValueTypes["InfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoCarouselUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselUpsertResult"]],
createInfoCarouselItem?: [{	data: ValueTypes["InfoCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemCreateResult"]],
deleteInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemDeleteResult"]],
updateInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoCarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemUpdateResult"]],
upsertInfoCarouselItem?: [{	by: ValueTypes["InfoCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoCarouselItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemUpsertResult"]],
createPersonSeenInfoCarousel?: [{	data: ValueTypes["PersonSeenInfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselCreateResult"]],
deletePersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselDeleteResult"]],
updatePersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["PersonSeenInfoCarouselUpdateInput"] | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselUpdateResult"]],
upsertPersonSeenInfoCarousel?: [{	by: ValueTypes["PersonSeenInfoCarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["PersonSeenInfoCarouselWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["PersonSeenInfoCarouselUpdateInput"] | Variable<any, string>,	create: ValueTypes["PersonSeenInfoCarouselCreateInput"] | Variable<any, string>},ValueTypes["PersonSeenInfoCarouselUpsertResult"]],
createGivenGiftsPage?: [{	data: ValueTypes["GivenGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageCreateResult"]],
deleteGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageDeleteResult"]],
updateGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GivenGiftsPageUpdateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageUpdateResult"]],
upsertGivenGiftsPage?: [{	by: ValueTypes["GivenGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GivenGiftsPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["GivenGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageUpsertResult"]],
createGivenGiftsPageLocale?: [{	data: ValueTypes["GivenGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleCreateResult"]],
deleteGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleDeleteResult"]],
updateGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GivenGiftsPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleUpdateResult"]],
upsertGivenGiftsPageLocale?: [{	by: ValueTypes["GivenGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GivenGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GivenGiftsPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GivenGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GivenGiftsPageLocaleUpsertResult"]],
createReceivedGiftsPage?: [{	data: ValueTypes["ReceivedGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageCreateResult"]],
deleteReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageDeleteResult"]],
updateReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReceivedGiftsPageUpdateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageUpdateResult"]],
upsertReceivedGiftsPage?: [{	by: ValueTypes["ReceivedGiftsPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReceivedGiftsPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReceivedGiftsPageCreateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageUpsertResult"]],
createReceivedGiftsPageLocale?: [{	data: ValueTypes["ReceivedGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleCreateResult"]],
deleteReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleDeleteResult"]],
updateReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReceivedGiftsPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleUpdateResult"]],
upsertReceivedGiftsPageLocale?: [{	by: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReceivedGiftsPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReceivedGiftsPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReceivedGiftsPageLocaleUpsertResult"]],
createReportNavigation?: [{	data: ValueTypes["ReportNavigationCreateInput"] | Variable<any, string>},ValueTypes["ReportNavigationCreateResult"]],
deleteReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationDeleteResult"]],
updateReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReportNavigationUpdateInput"] | Variable<any, string>},ValueTypes["ReportNavigationUpdateResult"]],
upsertReportNavigation?: [{	by: ValueTypes["ReportNavigationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReportNavigationUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReportNavigationCreateInput"] | Variable<any, string>},ValueTypes["ReportNavigationUpsertResult"]],
createReportPage?: [{	data: ValueTypes["ReportPageCreateInput"] | Variable<any, string>},ValueTypes["ReportPageCreateResult"]],
deleteReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageDeleteResult"]],
updateReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReportPageUpdateInput"] | Variable<any, string>},ValueTypes["ReportPageUpdateResult"]],
upsertReportPage?: [{	by: ValueTypes["ReportPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReportPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReportPageCreateInput"] | Variable<any, string>},ValueTypes["ReportPageUpsertResult"]],
createReportPageLocale?: [{	data: ValueTypes["ReportPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReportPageLocaleCreateResult"]],
deleteReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportPageLocaleDeleteResult"]],
updateReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReportPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ReportPageLocaleUpdateResult"]],
upsertReportPageLocale?: [{	by: ValueTypes["ReportPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReportPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReportPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReportPageLocaleUpsertResult"]],
createReportNavigationLocale?: [{	data: ValueTypes["ReportNavigationLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReportNavigationLocaleCreateResult"]],
deleteReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ReportNavigationLocaleDeleteResult"]],
updateReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ReportNavigationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ReportNavigationLocaleUpdateResult"]],
upsertReportNavigationLocale?: [{	by: ValueTypes["ReportNavigationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ReportNavigationLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ReportNavigationLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ReportNavigationLocaleCreateInput"] | Variable<any, string>},ValueTypes["ReportNavigationLocaleUpsertResult"]],
createSentPayment?: [{	data: ValueTypes["SentPaymentCreateInput"] | Variable<any, string>},ValueTypes["SentPaymentCreateResult"]],
deleteSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPaymentDeleteResult"]],
updateSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SentPaymentUpdateInput"] | Variable<any, string>},ValueTypes["SentPaymentUpdateResult"]],
upsertSentPayment?: [{	by: ValueTypes["SentPaymentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SentPaymentUpdateInput"] | Variable<any, string>,	create: ValueTypes["SentPaymentCreateInput"] | Variable<any, string>},ValueTypes["SentPaymentUpsertResult"]],
createNotificationTargetGroup?: [{	data: ValueTypes["NotificationTargetGroupCreateInput"] | Variable<any, string>},ValueTypes["NotificationTargetGroupCreateResult"]],
deleteNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>},ValueTypes["NotificationTargetGroupDeleteResult"]],
updateNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["NotificationTargetGroupUpdateInput"] | Variable<any, string>},ValueTypes["NotificationTargetGroupUpdateResult"]],
upsertNotificationTargetGroup?: [{	by: ValueTypes["NotificationTargetGroupUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["NotificationTargetGroupWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["NotificationTargetGroupUpdateInput"] | Variable<any, string>,	create: ValueTypes["NotificationTargetGroupCreateInput"] | Variable<any, string>},ValueTypes["NotificationTargetGroupUpsertResult"]],
createProcessedNotification?: [{	data: ValueTypes["ProcessedNotificationCreateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationCreateResult"]],
deleteProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationDeleteResult"]],
updateProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ProcessedNotificationUpdateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationUpdateResult"]],
upsertProcessedNotification?: [{	by: ValueTypes["ProcessedNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ProcessedNotificationUpdateInput"] | Variable<any, string>,	create: ValueTypes["ProcessedNotificationCreateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationUpsertResult"]],
createScheduledNotification?: [{	data: ValueTypes["ScheduledNotificationCreateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationCreateResult"]],
deleteScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationDeleteResult"]],
updateScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ScheduledNotificationUpdateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationUpdateResult"]],
upsertScheduledNotification?: [{	by: ValueTypes["ScheduledNotificationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ScheduledNotificationUpdateInput"] | Variable<any, string>,	create: ValueTypes["ScheduledNotificationCreateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationUpsertResult"]],
createProcessedNotificationSource?: [{	data: ValueTypes["ProcessedNotificationSourceCreateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationSourceCreateResult"]],
deleteProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ProcessedNotificationSourceDeleteResult"]],
updateProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ProcessedNotificationSourceUpdateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationSourceUpdateResult"]],
upsertProcessedNotificationSource?: [{	by: ValueTypes["ProcessedNotificationSourceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ProcessedNotificationSourceWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ProcessedNotificationSourceUpdateInput"] | Variable<any, string>,	create: ValueTypes["ProcessedNotificationSourceCreateInput"] | Variable<any, string>},ValueTypes["ProcessedNotificationSourceUpsertResult"]],
createDevice?: [{	data: ValueTypes["DeviceCreateInput"] | Variable<any, string>},ValueTypes["DeviceCreateResult"]],
deleteDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>},ValueTypes["DeviceDeleteResult"]],
updateDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["DeviceUpdateInput"] | Variable<any, string>},ValueTypes["DeviceUpdateResult"]],
upsertDevice?: [{	by: ValueTypes["DeviceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["DeviceWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["DeviceUpdateInput"] | Variable<any, string>,	create: ValueTypes["DeviceCreateInput"] | Variable<any, string>},ValueTypes["DeviceUpsertResult"]],
createScheduledNotificationLocale?: [{	data: ValueTypes["ScheduledNotificationLocaleCreateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleCreateResult"]],
deleteScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleDeleteResult"]],
updateScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ScheduledNotificationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleUpdateResult"]],
upsertScheduledNotificationLocale?: [{	by: ValueTypes["ScheduledNotificationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ScheduledNotificationLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ScheduledNotificationLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ScheduledNotificationLocaleCreateInput"] | Variable<any, string>},ValueTypes["ScheduledNotificationLocaleUpsertResult"]],
createInfoCarouselItemLocale?: [{	data: ValueTypes["InfoCarouselItemLocaleCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleCreateResult"]],
deleteInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleDeleteResult"]],
updateInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoCarouselItemLocaleUpdateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleUpdateResult"]],
upsertInfoCarouselItemLocale?: [{	by: ValueTypes["InfoCarouselItemLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoCarouselItemLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoCarouselItemLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoCarouselItemLocaleCreateInput"] | Variable<any, string>},ValueTypes["InfoCarouselItemLocaleUpsertResult"]],
createSentPaymentLocale?: [{	data: ValueTypes["SentPaymentLocaleCreateInput"] | Variable<any, string>},ValueTypes["SentPaymentLocaleCreateResult"]],
deleteSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SentPaymentLocaleDeleteResult"]],
updateSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SentPaymentLocaleUpdateInput"] | Variable<any, string>},ValueTypes["SentPaymentLocaleUpdateResult"]],
upsertSentPaymentLocale?: [{	by: ValueTypes["SentPaymentLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SentPaymentLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SentPaymentLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["SentPaymentLocaleCreateInput"] | Variable<any, string>},ValueTypes["SentPaymentLocaleUpsertResult"]],
createTextImageList?: [{	data: ValueTypes["TextImageListCreateInput"] | Variable<any, string>},ValueTypes["TextImageListCreateResult"]],
deleteTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageListDeleteResult"]],
updateTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TextImageListUpdateInput"] | Variable<any, string>},ValueTypes["TextImageListUpdateResult"]],
upsertTextImageList?: [{	by: ValueTypes["TextImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TextImageListUpdateInput"] | Variable<any, string>,	create: ValueTypes["TextImageListCreateInput"] | Variable<any, string>},ValueTypes["TextImageListUpsertResult"]],
createTextImageListItem?: [{	data: ValueTypes["TextImageListItemCreateInput"] | Variable<any, string>},ValueTypes["TextImageListItemCreateResult"]],
deleteTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextImageListItemDeleteResult"]],
updateTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TextImageListItemUpdateInput"] | Variable<any, string>},ValueTypes["TextImageListItemUpdateResult"]],
upsertTextImageListItem?: [{	by: ValueTypes["TextImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextImageListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TextImageListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["TextImageListItemCreateInput"] | Variable<any, string>},ValueTypes["TextImageListItemUpsertResult"]],
createHeroCarouselItem?: [{	data: ValueTypes["HeroCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["HeroCarouselItemCreateResult"]],
deleteHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeroCarouselItemDeleteResult"]],
updateHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeroCarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["HeroCarouselItemUpdateResult"]],
upsertHeroCarouselItem?: [{	by: ValueTypes["HeroCarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeroCarouselItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeroCarouselItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeroCarouselItemCreateInput"] | Variable<any, string>},ValueTypes["HeroCarouselItemUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?: boolean | undefined | null | Variable<any, string>,
	deferUniqueConstraints?: boolean | undefined | null | Variable<any, string>
}
  }

export type ResolverInputTypes = {
    ["_Column"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	enumName?:boolean | `@${string}`,
	defaultValue?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ResolverInputTypes["_Rule"],
	validators?:ResolverInputTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_Field"]:AliasType<{
		name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ResolverInputTypes["_Rule"],
	validators?:ResolverInputTypes["_Validator"];
		['...on _Column']?: Omit<ResolverInputTypes["_Column"],keyof ResolverInputTypes["_Field"]>;
		['...on _Relation']?: Omit<ResolverInputTypes["_Relation"],keyof ResolverInputTypes["_Field"]>;
		__typename?: boolean | `@${string}`
}>;
	["_Rule"]: AliasType<{
	message?:ResolverInputTypes["_RuleMessage"],
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_RuleMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Validator"]: AliasType<{
	operation?:boolean | `@${string}`,
	arguments?:ResolverInputTypes["_Argument"],
		__typename?: boolean | `@${string}`
}>;
	["_Argument"]: AliasType<{
	_ValidatorArgument?:ResolverInputTypes["_ValidatorArgument"],
	_PathArgument?:ResolverInputTypes["_PathArgument"],
	_LiteralArgument?:ResolverInputTypes["_LiteralArgument"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_PathArgument"]: AliasType<{
	path?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_LiteralArgument"]: AliasType<{
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Json custom scalar type */
["Json"]:unknown;
	["_Relation"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	side?:boolean | `@${string}`,
	targetEntity?:boolean | `@${string}`,
	ownedBy?:boolean | `@${string}`,
	inversedBy?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	onDelete?:boolean | `@${string}`,
	orphanRemoval?:boolean | `@${string}`,
	orderBy?:ResolverInputTypes["_OrderBy"],
	rules?:ResolverInputTypes["_Rule"],
	validators?:ResolverInputTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_RelationSide"]:_RelationSide;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_OrderBy"]: AliasType<{
	path?:boolean | `@${string}`,
	direction?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_OrderByDirection"]:_OrderByDirection;
	["Query"]: AliasType<{
	schema?:ResolverInputTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
getGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["General"]],
listGeneral?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["General"]],
paginateGeneral?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralConnection"]],
validateCreateGeneral?: [{	data: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	data: ResolverInputTypes["GeneralUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
listImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Image"]],
paginateImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageConnection"]],
validateCreateImage?: [{	data: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	data: ResolverInputTypes["ImageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPage"]],
listGenericPage?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPage"]],
paginateGenericPage?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	data: ResolverInputTypes["GenericPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
listLinkable?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Linkable"]],
paginateLinkable?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	data: ResolverInputTypes["LinkableUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
listSeo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Seo"]],
paginateSeo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	data: ResolverInputTypes["SeoUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
listContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Content"]],
paginateContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentConnection"]],
validateCreateContent?: [{	data: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	data: ResolverInputTypes["ContentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	data: ResolverInputTypes["ContentBlockUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
listContentReference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	data: ResolverInputTypes["ContentReferenceUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentReferenceLinkableItem?: [{	by: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
listContentReferenceLinkableItem?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
paginateContentReferenceLinkableItem?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItemConnection"]],
getGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
listGeneralLocale?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GeneralLocale"]],
paginateGeneralLocale?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralLocaleConnection"]],
validateCreateGeneralLocale?: [{	data: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	data: ResolverInputTypes["GeneralLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
listGenericPageLocale?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageLocale"]],
paginateGenericPageLocale?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageLocaleConnection"]],
validateCreateGenericPageLocale?: [{	data: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	data: ResolverInputTypes["GenericPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
listLocale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Locale"]],
paginateLocale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	data: ResolverInputTypes["LocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
listVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["VideoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Video"]],
paginateVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["VideoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	data: ResolverInputTypes["VideoUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
listLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Link"]],
paginateLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkConnection"]],
validateCreateLink?: [{	data: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	data: ResolverInputTypes["LinkUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
listPost?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Post"]],
paginatePost?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostConnection"]],
validateCreatePost?: [{	data: ResolverInputTypes["PostCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	data: ResolverInputTypes["PostUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
listPostLocale?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostLocale"]],
paginatePostLocale?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostLocaleConnection"]],
validateCreatePostLocale?: [{	data: ResolverInputTypes["PostLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	data: ResolverInputTypes["PostLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
listPostArea?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostArea"]],
paginatePostArea?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaConnection"]],
validateCreatePostArea?: [{	data: ResolverInputTypes["PostAreaCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	data: ResolverInputTypes["PostAreaUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
listPostAreaLocale?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaLocale"]],
paginatePostAreaLocale?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaLocaleConnection"]],
validateCreatePostAreaLocale?: [{	data: ResolverInputTypes["PostAreaLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	data: ResolverInputTypes["PostAreaLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
listPostOrganization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganization"]],
paginatePostOrganization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationConnection"]],
validateCreatePostOrganization?: [{	data: ResolverInputTypes["PostOrganizationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	data: ResolverInputTypes["PostOrganizationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
listPostOrganizationLocale?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
paginatePostOrganizationLocale?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationLocaleConnection"]],
validateCreatePostOrganizationLocale?: [{	data: ResolverInputTypes["PostOrganizationLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	data: ResolverInputTypes["PostOrganizationLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	filter?: ResolverInputTypes["DonationWhere"] | undefined | null},ResolverInputTypes["Donation"]],
listDonation?: [{	filter?: ResolverInputTypes["DonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Donation"]],
paginateDonation?: [{	filter?: ResolverInputTypes["DonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationConnection"]],
validateCreateDonation?: [{	data: ResolverInputTypes["DonationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	data: ResolverInputTypes["DonationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountItem"]],
listDonationAmountItem?: [{	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountItem"]],
paginateDonationAmountItem?: [{	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountItemConnection"]],
validateCreateDonationAmountItem?: [{	data: ResolverInputTypes["DonationAmountItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	data: ResolverInputTypes["DonationAmountItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
listDonationAmountsRegionItem?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
paginateDonationAmountsRegionItem?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionItemConnection"]],
validateCreateDonationAmountsRegionItem?: [{	data: ResolverInputTypes["DonationAmountsRegionItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	data: ResolverInputTypes["DonationAmountsRegionItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionList"]],
listDonationAmountsRegionList?: [{	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionList"]],
paginateDonationAmountsRegionList?: [{	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionListConnection"]],
validateCreateDonationAmountsRegionList?: [{	data: ResolverInputTypes["DonationAmountsRegionListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	data: ResolverInputTypes["DonationAmountsRegionListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["Region"]],
listRegion?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Region"]],
paginateRegion?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RegionConnection"]],
validateCreateRegion?: [{	data: ResolverInputTypes["RegionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	data: ResolverInputTypes["RegionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null},ResolverInputTypes["LinkItem"]],
listLinkItem?: [{	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["LinkItem"]],
paginateLinkItem?: [{	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data: ResolverInputTypes["LinkItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	data: ResolverInputTypes["LinkItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null},ResolverInputTypes["LinkList"]],
listLinkList?: [{	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["LinkList"]],
paginateLinkList?: [{	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data: ResolverInputTypes["LinkListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	data: ResolverInputTypes["LinkListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["Header"]],
listHeader?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Header"]],
paginateHeader?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderConnection"]],
validateCreateHeader?: [{	data: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	data: ResolverInputTypes["HeaderUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	data: ResolverInputTypes["HeaderLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["Footer"]],
listFooter?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Footer"]],
paginateFooter?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterConnection"]],
validateCreateFooter?: [{	data: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	data: ResolverInputTypes["FooterUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
listFooterLocale?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	data: ResolverInputTypes["FooterLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	filter?: ResolverInputTypes["PostListWhere"] | undefined | null},ResolverInputTypes["PostList"]],
listPostList?: [{	filter?: ResolverInputTypes["PostListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostList"]],
paginatePostList?: [{	filter?: ResolverInputTypes["PostListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostListConnection"]],
validateCreatePostList?: [{	data: ResolverInputTypes["PostListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	data: ResolverInputTypes["PostListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null},ResolverInputTypes["PostListItem"]],
listPostListItem?: [{	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostListItem"]],
paginatePostListItem?: [{	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostListItemConnection"]],
validateCreatePostListItem?: [{	data: ResolverInputTypes["PostListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	data: ResolverInputTypes["PostListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null},ResolverInputTypes["AppBanner"]],
listAppBanner?: [{	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AppBannerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["AppBanner"]],
paginateAppBanner?: [{	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AppBannerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["AppBannerConnection"]],
validateCreateAppBanner?: [{	data: ResolverInputTypes["AppBannerCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	data: ResolverInputTypes["AppBannerUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettings"]],
listGenericPageAboutSettings?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettings"]],
paginateGenericPageAboutSettings?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsConnection"]],
validateCreateGenericPageAboutSettings?: [{	data: ResolverInputTypes["GenericPageAboutSettingsCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	data: ResolverInputTypes["GenericPageAboutSettingsUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
listGenericPageAboutSettingsLocale?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
paginateGenericPageAboutSettingsLocale?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocaleConnection"]],
validateCreateGenericPageAboutSettingsLocale?: [{	data: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	data: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	filter?: ResolverInputTypes["ValueWhere"] | undefined | null},ResolverInputTypes["Value"]],
listValue?: [{	filter?: ResolverInputTypes["ValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Value"]],
paginateValue?: [{	filter?: ResolverInputTypes["ValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ValueConnection"]],
validateCreateValue?: [{	data: ResolverInputTypes["ValueCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	data: ResolverInputTypes["ValueUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null},ResolverInputTypes["ValueItem"]],
listValueItem?: [{	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ValueItem"]],
paginateValueItem?: [{	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ValueItemConnection"]],
validateCreateValueItem?: [{	data: ResolverInputTypes["ValueItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	data: ResolverInputTypes["ValueItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null},ResolverInputTypes["ValueList"]],
listValueList?: [{	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ValueList"]],
paginateValueList?: [{	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ValueListConnection"]],
validateCreateValueList?: [{	data: ResolverInputTypes["ValueListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	data: ResolverInputTypes["ValueListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null},ResolverInputTypes["ImageLink"]],
listImageLink?: [{	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageLink"]],
paginateImageLink?: [{	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageLinkConnection"]],
validateCreateImageLink?: [{	data: ResolverInputTypes["ImageLinkCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	data: ResolverInputTypes["ImageLinkUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null},ResolverInputTypes["ImageLinkItem"]],
listImageLinkItem?: [{	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageLinkItem"]],
paginateImageLinkItem?: [{	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageLinkItemConnection"]],
validateCreateImageLinkItem?: [{	data: ResolverInputTypes["ImageLinkItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	data: ResolverInputTypes["ImageLinkItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null},ResolverInputTypes["ImageLinkList"]],
listImageLinkList?: [{	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageLinkList"]],
paginateImageLinkList?: [{	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageLinkListConnection"]],
validateCreateImageLinkList?: [{	data: ResolverInputTypes["ImageLinkListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	data: ResolverInputTypes["ImageLinkListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null},ResolverInputTypes["PostAreaList"]],
listPostAreaList?: [{	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaList"]],
paginatePostAreaList?: [{	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaListConnection"]],
validateCreatePostAreaList?: [{	data: ResolverInputTypes["PostAreaListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	data: ResolverInputTypes["PostAreaListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null},ResolverInputTypes["PostAreaListItem"]],
listPostAreaListItem?: [{	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaListItem"]],
paginatePostAreaListItem?: [{	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaListItemConnection"]],
validateCreatePostAreaListItem?: [{	data: ResolverInputTypes["PostAreaListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	data: ResolverInputTypes["PostAreaListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null},ResolverInputTypes["Accordion"]],
listAccordion?: [{	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Accordion"]],
paginateAccordion?: [{	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["AccordionConnection"]],
validateCreateAccordion?: [{	data: ResolverInputTypes["AccordionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	data: ResolverInputTypes["AccordionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null},ResolverInputTypes["AccordionItem"]],
listAccordionItem?: [{	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["AccordionItem"]],
paginateAccordionItem?: [{	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["AccordionItemConnection"]],
validateCreateAccordionItem?: [{	data: ResolverInputTypes["AccordionItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	data: ResolverInputTypes["AccordionItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
listUser?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["User"]],
paginateUser?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserConnection"]],
validateCreateUser?: [{	data: ResolverInputTypes["UserCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	data: ResolverInputTypes["UserUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
listUserPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPayment"]],
paginateUserPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentConnection"]],
validateCreateUserPayment?: [{	data: ResolverInputTypes["UserPaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	data: ResolverInputTypes["UserPaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
listCurrency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CurrencyOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Currency"]],
paginateCurrency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CurrencyOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CurrencyConnection"]],
validateCreateCurrency?: [{	data: ResolverInputTypes["CurrencyCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	data: ResolverInputTypes["CurrencyUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["Medium"]],
listMedium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Medium"]],
paginateMedium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	data: ResolverInputTypes["MediumUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null},ResolverInputTypes["MediumItem"]],
listMediumItem?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumItem"]],
paginateMediumItem?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	data: ResolverInputTypes["MediumItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
listMediumList?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumList"]],
paginateMediumList?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	data: ResolverInputTypes["MediumListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null},ResolverInputTypes["UserPaymentOrderId"]],
listUserPaymentOrderId?: [{	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderIdOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentOrderId"]],
paginateUserPaymentOrderId?: [{	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderIdOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentOrderIdConnection"]],
validateCreateUserPaymentOrderId?: [{	data: ResolverInputTypes["UserPaymentOrderIdCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	data: ResolverInputTypes["UserPaymentOrderIdUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevision"]],
listPostRevision?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostRevision"]],
paginatePostRevision?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostRevisionConnection"]],
validateCreatePostRevision?: [{	data: ResolverInputTypes["PostRevisionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	data: ResolverInputTypes["PostRevisionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
listUserRecurringPayment?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
paginateUserRecurringPayment?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentConnection"]],
validateCreateUserRecurringPayment?: [{	data: ResolverInputTypes["UserRecurringPaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	data: ResolverInputTypes["UserRecurringPaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
listUserRecurringPaymentItem?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
paginateUserRecurringPaymentItem?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItemConnection"]],
validateCreateUserRecurringPaymentItem?: [{	data: ResolverInputTypes["UserRecurringPaymentItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	data: ResolverInputTypes["UserRecurringPaymentItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
listPostRevisionLocale?: [{	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
paginatePostRevisionLocale?: [{	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostRevisionLocaleConnection"]],
validateCreatePostRevisionLocale?: [{	data: ResolverInputTypes["PostRevisionLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	data: ResolverInputTypes["PostRevisionLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCatalogueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCatalogueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data: ResolverInputTypes["TranslationCatalogueCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	data: ResolverInputTypes["TranslationCatalogueUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data: ResolverInputTypes["TranslationCataloguesIdentifierCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	data: ResolverInputTypes["TranslationCataloguesIdentifierUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null},ResolverInputTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationDomainOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationDomainOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data: ResolverInputTypes["TranslationDomainCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	data: ResolverInputTypes["TranslationDomainUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null},ResolverInputTypes["TranslationKey"]],
listTranslationKey?: [{	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationKeyOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationKeyOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data: ResolverInputTypes["TranslationKeyCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	data: ResolverInputTypes["TranslationKeyUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null},ResolverInputTypes["TranslationValue"]],
listTranslationValue?: [{	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data: ResolverInputTypes["TranslationValueCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	data: ResolverInputTypes["TranslationValueUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocale"]],
listGenericPageAboutGroupLinksLocale?: [{	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocale"]],
paginateGenericPageAboutGroupLinksLocale?: [{	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocaleConnection"]],
validateCreateGenericPageAboutGroupLinksLocale?: [{	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null},ResolverInputTypes["MemberList"]],
listMemberList?: [{	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MemberList"]],
paginateMemberList?: [{	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MemberListConnection"]],
validateCreateMemberList?: [{	data: ResolverInputTypes["MemberListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	data: ResolverInputTypes["MemberListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null},ResolverInputTypes["MemberListItem"]],
listMemberListItem?: [{	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MemberListItem"]],
paginateMemberListItem?: [{	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MemberListItemConnection"]],
validateCreateMemberListItem?: [{	data: ResolverInputTypes["MemberListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	data: ResolverInputTypes["MemberListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null},ResolverInputTypes["FilledTaxForm"]],
listFilledTaxForm?: [{	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FilledTaxFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FilledTaxForm"]],
paginateFilledTaxForm?: [{	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FilledTaxFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FilledTaxFormConnection"]],
validateCreateFilledTaxForm?: [{	data: ResolverInputTypes["FilledTaxFormCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	data: ResolverInputTypes["FilledTaxFormUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null},ResolverInputTypes["FilledTaxFormEmailAddress"]],
listFilledTaxFormEmailAddress?: [{	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FilledTaxFormEmailAddressOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FilledTaxFormEmailAddress"]],
paginateFilledTaxFormEmailAddress?: [{	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FilledTaxFormEmailAddressOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FilledTaxFormEmailAddressConnection"]],
validateCreateFilledTaxFormEmailAddress?: [{	data: ResolverInputTypes["FilledTaxFormEmailAddressCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	data: ResolverInputTypes["FilledTaxFormEmailAddressUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	filter?: ResolverInputTypes["FormWhere"] | undefined | null},ResolverInputTypes["Form"]],
listForm?: [{	filter?: ResolverInputTypes["FormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Form"]],
paginateForm?: [{	filter?: ResolverInputTypes["FormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FormConnection"]],
validateCreateForm?: [{	data: ResolverInputTypes["FormCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	data: ResolverInputTypes["FormUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null},ResolverInputTypes["CsobPayment"]],
listCsobPayment?: [{	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CsobPayment"]],
paginateCsobPayment?: [{	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CsobPaymentConnection"]],
validateCreateCsobPayment?: [{	data: ResolverInputTypes["CsobPaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	data: ResolverInputTypes["CsobPaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null},ResolverInputTypes["CsobPaymentStatusChange"]],
listCsobPaymentStatusChange?: [{	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CsobPaymentStatusChange"]],
paginateCsobPaymentStatusChange?: [{	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CsobPaymentStatusChangeConnection"]],
validateCreateCsobPaymentStatusChange?: [{	data: ResolverInputTypes["CsobPaymentStatusChangeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	data: ResolverInputTypes["CsobPaymentStatusChangeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null},ResolverInputTypes["StripePayment"]],
listStripePayment?: [{	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StripePayment"]],
paginateStripePayment?: [{	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StripePaymentConnection"]],
validateCreateStripePayment?: [{	data: ResolverInputTypes["StripePaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	data: ResolverInputTypes["StripePaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null},ResolverInputTypes["StripePaymentStatusChange"]],
listStripePaymentStatusChange?: [{	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StripePaymentStatusChange"]],
paginateStripePaymentStatusChange?: [{	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StripePaymentStatusChangeConnection"]],
validateCreateStripePaymentStatusChange?: [{	data: ResolverInputTypes["StripePaymentStatusChangeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	data: ResolverInputTypes["StripePaymentStatusChangeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null},ResolverInputTypes["RegionPaymentMethod"]],
listRegionPaymentMethod?: [{	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionPaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RegionPaymentMethod"]],
paginateRegionPaymentMethod?: [{	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionPaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RegionPaymentMethodConnection"]],
validateCreateRegionPaymentMethod?: [{	data: ResolverInputTypes["RegionPaymentMethodCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	data: ResolverInputTypes["RegionPaymentMethodUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaMetaData?: [{	by: ResolverInputTypes["PostAreaMetaDataUniqueWhere"],	filter?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null},ResolverInputTypes["PostAreaMetaData"]],
listPostAreaMetaData?: [{	filter?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaMetaDataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaMetaData"]],
paginatePostAreaMetaData?: [{	filter?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaMetaDataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaMetaDataConnection"]],
getPostMetaData?: [{	by: ResolverInputTypes["PostMetaDataUniqueWhere"],	filter?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null},ResolverInputTypes["PostMetaData"]],
listPostMetaData?: [{	filter?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostMetaDataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostMetaData"]],
paginatePostMetaData?: [{	filter?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostMetaDataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostMetaDataConnection"]],
getPostOrganizationMetaData?: [{	by: ResolverInputTypes["PostOrganizationMetaDataUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null},ResolverInputTypes["PostOrganizationMetaData"]],
listPostOrganizationMetaData?: [{	filter?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationMetaDataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationMetaData"]],
paginatePostOrganizationMetaData?: [{	filter?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationMetaDataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationMetaDataConnection"]],
getTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null},ResolverInputTypes["TileItem"]],
listTileItem?: [{	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TileItem"]],
paginateTileItem?: [{	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TileItemConnection"]],
validateCreateTileItem?: [{	data: ResolverInputTypes["TileItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	data: ResolverInputTypes["TileItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	filter?: ResolverInputTypes["TileListWhere"] | undefined | null},ResolverInputTypes["TileList"]],
listTileList?: [{	filter?: ResolverInputTypes["TileListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TileList"]],
paginateTileList?: [{	filter?: ResolverInputTypes["TileListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TileListConnection"]],
validateCreateTileList?: [{	data: ResolverInputTypes["TileListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	data: ResolverInputTypes["TileListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null},ResolverInputTypes["FeedPage"]],
listFeedPage?: [{	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPage"]],
paginateFeedPage?: [{	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageConnection"]],
validateCreateFeedPage?: [{	data: ResolverInputTypes["FeedPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	data: ResolverInputTypes["FeedPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
listFeedPageLocale?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageLocale"]],
paginateFeedPageLocale?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageLocaleConnection"]],
validateCreateFeedPageLocale?: [{	data: ResolverInputTypes["FeedPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	data: ResolverInputTypes["FeedPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null},ResolverInputTypes["FeedPageSection"]],
listFeedPageSection?: [{	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageSectionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageSection"]],
paginateFeedPageSection?: [{	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageSectionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageSectionConnection"]],
validateCreateFeedPageSection?: [{	data: ResolverInputTypes["FeedPageSectionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	data: ResolverInputTypes["FeedPageSectionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null},ResolverInputTypes["FeedPageTileStripe"]],
listFeedPageTileStripe?: [{	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageTileStripeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageTileStripe"]],
paginateFeedPageTileStripe?: [{	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageTileStripeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageTileStripeConnection"]],
validateCreateFeedPageTileStripe?: [{	data: ResolverInputTypes["FeedPageTileStripeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	data: ResolverInputTypes["FeedPageTileStripeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null},ResolverInputTypes["CardItem"]],
listCardItem?: [{	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CardItem"]],
paginateCardItem?: [{	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CardItemConnection"]],
validateCreateCardItem?: [{	data: ResolverInputTypes["CardItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	data: ResolverInputTypes["CardItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	filter?: ResolverInputTypes["CardListWhere"] | undefined | null},ResolverInputTypes["CardList"]],
listCardList?: [{	filter?: ResolverInputTypes["CardListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CardList"]],
paginateCardList?: [{	filter?: ResolverInputTypes["CardListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CardListConnection"]],
validateCreateCardList?: [{	data: ResolverInputTypes["CardListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	data: ResolverInputTypes["CardListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
listOnBehalfDonation?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
paginateOnBehalfDonation?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["OnBehalfDonationConnection"]],
validateCreateOnBehalfDonation?: [{	data: ResolverInputTypes["OnBehalfDonationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	data: ResolverInputTypes["OnBehalfDonationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollection"]],
listUserPaymentTriesCollection?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollection"]],
paginateUserPaymentTriesCollection?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionConnection"]],
validateCreateUserPaymentTriesCollection?: [{	data: ResolverInputTypes["UserPaymentTriesCollectionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	data: ResolverInputTypes["UserPaymentTriesCollectionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPage"]],
listRecurringPaymentPage?: [{	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecurringPaymentPage"]],
paginateRecurringPaymentPage?: [{	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageConnection"]],
validateCreateRecurringPaymentPage?: [{	data: ResolverInputTypes["RecurringPaymentPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	data: ResolverInputTypes["RecurringPaymentPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
listRecurringPaymentPageLocale?: [{	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
paginateRecurringPaymentPageLocale?: [{	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageLocaleConnection"]],
validateCreateRecurringPaymentPageLocale?: [{	data: ResolverInputTypes["RecurringPaymentPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	data: ResolverInputTypes["RecurringPaymentPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null},ResolverInputTypes["StoryGuide"]],
listStoryGuide?: [{	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StoryGuide"]],
paginateStoryGuide?: [{	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StoryGuideConnection"]],
validateCreateStoryGuide?: [{	data: ResolverInputTypes["StoryGuideCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	data: ResolverInputTypes["StoryGuideUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null},ResolverInputTypes["StoryGuideItem"]],
listStoryGuideItem?: [{	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StoryGuideItem"]],
paginateStoryGuideItem?: [{	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StoryGuideItemConnection"]],
validateCreateStoryGuideItem?: [{	data: ResolverInputTypes["StoryGuideItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	data: ResolverInputTypes["StoryGuideItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null},ResolverInputTypes["StoryGuideList"]],
listStoryGuideList?: [{	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StoryGuideList"]],
paginateStoryGuideList?: [{	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StoryGuideListConnection"]],
validateCreateStoryGuideList?: [{	data: ResolverInputTypes["StoryGuideListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	data: ResolverInputTypes["StoryGuideListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStripePaymentMetadata?: [{	by: ResolverInputTypes["StripePaymentMetadataUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null},ResolverInputTypes["StripePaymentMetadata"]],
listStripePaymentMetadata?: [{	filter?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StripePaymentMetadata"]],
paginateStripePaymentMetadata?: [{	filter?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StripePaymentMetadataConnection"]],
getOnBehalfDonationMetadata?: [{	by: ResolverInputTypes["OnBehalfDonationMetadataUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonationMetadata"]],
listOnBehalfDonationMetadata?: [{	filter?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["OnBehalfDonationMetadata"]],
paginateOnBehalfDonationMetadata?: [{	filter?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["OnBehalfDonationMetadataConnection"]],
getUserPaymentTriesCollectionMetadata?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadata"]],
listUserPaymentTriesCollectionMetadata?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadata"]],
paginateUserPaymentTriesCollectionMetadata?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataConnection"]],
getUserPaymentTriesCollectionMetadataLocale?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocale"]],
listUserPaymentTriesCollectionMetadataLocale?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocale"]],
paginateUserPaymentTriesCollectionMetadataLocale?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleConnection"]],
getCsobPaymentMetadata?: [{	by: ResolverInputTypes["CsobPaymentMetadataUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["CsobPaymentMetadata"]],
listCsobPaymentMetadata?: [{	filter?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CsobPaymentMetadata"]],
paginateCsobPaymentMetadata?: [{	filter?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CsobPaymentMetadataConnection"]],
getHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null},ResolverInputTypes["HeroCarousel"]],
listHeroCarousel?: [{	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeroCarousel"]],
paginateHeroCarousel?: [{	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeroCarouselConnection"]],
validateCreateHeroCarousel?: [{	data: ResolverInputTypes["HeroCarouselCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	data: ResolverInputTypes["HeroCarouselUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null},ResolverInputTypes["PostOrganizationList"]],
listPostOrganizationList?: [{	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationList"]],
paginatePostOrganizationList?: [{	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationListConnection"]],
validateCreatePostOrganizationList?: [{	data: ResolverInputTypes["PostOrganizationListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	data: ResolverInputTypes["PostOrganizationListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null},ResolverInputTypes["PostOrganizationListItem"]],
listPostOrganizationListItem?: [{	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationListItem"]],
paginatePostOrganizationListItem?: [{	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationListItemConnection"]],
validateCreatePostOrganizationListItem?: [{	data: ResolverInputTypes["PostOrganizationListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	data: ResolverInputTypes["PostOrganizationListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null},ResolverInputTypes["InfoCarousel"]],
listInfoCarousel?: [{	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoCarousel"]],
paginateInfoCarousel?: [{	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoCarouselConnection"]],
validateCreateInfoCarousel?: [{	data: ResolverInputTypes["InfoCarouselCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	data: ResolverInputTypes["InfoCarouselUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItem"]],
listInfoCarouselItem?: [{	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoCarouselItem"]],
paginateInfoCarouselItem?: [{	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoCarouselItemConnection"]],
validateCreateInfoCarouselItem?: [{	data: ResolverInputTypes["InfoCarouselItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	data: ResolverInputTypes["InfoCarouselItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null},ResolverInputTypes["PersonSeenInfoCarousel"]],
listPersonSeenInfoCarousel?: [{	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PersonSeenInfoCarousel"]],
paginatePersonSeenInfoCarousel?: [{	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PersonSeenInfoCarouselConnection"]],
validateCreatePersonSeenInfoCarousel?: [{	data: ResolverInputTypes["PersonSeenInfoCarouselCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	data: ResolverInputTypes["PersonSeenInfoCarouselUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPage"]],
listGivenGiftsPage?: [{	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GivenGiftsPage"]],
paginateGivenGiftsPage?: [{	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GivenGiftsPageConnection"]],
validateCreateGivenGiftsPage?: [{	data: ResolverInputTypes["GivenGiftsPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	data: ResolverInputTypes["GivenGiftsPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
listGivenGiftsPageLocale?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
paginateGivenGiftsPageLocale?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GivenGiftsPageLocaleConnection"]],
validateCreateGivenGiftsPageLocale?: [{	data: ResolverInputTypes["GivenGiftsPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	data: ResolverInputTypes["GivenGiftsPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPage"]],
listReceivedGiftsPage?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPage"]],
paginateReceivedGiftsPage?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageConnection"]],
validateCreateReceivedGiftsPage?: [{	data: ResolverInputTypes["ReceivedGiftsPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	data: ResolverInputTypes["ReceivedGiftsPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
listReceivedGiftsPageLocale?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
paginateReceivedGiftsPageLocale?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocaleConnection"]],
validateCreateReceivedGiftsPageLocale?: [{	data: ResolverInputTypes["ReceivedGiftsPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	data: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null},ResolverInputTypes["ReportNavigation"]],
listReportNavigation?: [{	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportNavigation"]],
paginateReportNavigation?: [{	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportNavigationConnection"]],
validateCreateReportNavigation?: [{	data: ResolverInputTypes["ReportNavigationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	data: ResolverInputTypes["ReportNavigationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null},ResolverInputTypes["ReportPage"]],
listReportPage?: [{	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportPage"]],
paginateReportPage?: [{	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportPageConnection"]],
validateCreateReportPage?: [{	data: ResolverInputTypes["ReportPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	data: ResolverInputTypes["ReportPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
listReportPageLocale?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportPageLocale"]],
paginateReportPageLocale?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportPageLocaleConnection"]],
validateCreateReportPageLocale?: [{	data: ResolverInputTypes["ReportPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	data: ResolverInputTypes["ReportPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
listReportNavigationLocale?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
paginateReportNavigationLocale?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportNavigationLocaleConnection"]],
validateCreateReportNavigationLocale?: [{	data: ResolverInputTypes["ReportNavigationLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	data: ResolverInputTypes["ReportNavigationLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null},ResolverInputTypes["SentPayment"]],
listSentPayment?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SentPayment"]],
paginateSentPayment?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SentPaymentConnection"]],
validateCreateSentPayment?: [{	data: ResolverInputTypes["SentPaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	data: ResolverInputTypes["SentPaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaSentPaymentCurrencySum?: [{	by: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"],	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySum"]],
listPostAreaSentPaymentCurrencySum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySum"]],
paginatePostAreaSentPaymentCurrencySum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySumConnection"]],
getPostAreaSentPaymentSum?: [{	by: ResolverInputTypes["PostAreaSentPaymentSumUniqueWhere"],	filter?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null},ResolverInputTypes["PostAreaSentPaymentSum"]],
listPostAreaSentPaymentSum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentSumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentSum"]],
paginatePostAreaSentPaymentSum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentSumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentSumConnection"]],
getNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null},ResolverInputTypes["NotificationTargetGroup"]],
listNotificationTargetGroup?: [{	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["NotificationTargetGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["NotificationTargetGroup"]],
paginateNotificationTargetGroup?: [{	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["NotificationTargetGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["NotificationTargetGroupConnection"]],
validateCreateNotificationTargetGroup?: [{	data: ResolverInputTypes["NotificationTargetGroupCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	data: ResolverInputTypes["NotificationTargetGroupUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null},ResolverInputTypes["ProcessedNotification"]],
listProcessedNotification?: [{	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ProcessedNotification"]],
paginateProcessedNotification?: [{	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ProcessedNotificationConnection"]],
validateCreateProcessedNotification?: [{	data: ResolverInputTypes["ProcessedNotificationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	data: ResolverInputTypes["ProcessedNotificationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null},ResolverInputTypes["ScheduledNotification"]],
listScheduledNotification?: [{	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ScheduledNotification"]],
paginateScheduledNotification?: [{	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ScheduledNotificationConnection"]],
validateCreateScheduledNotification?: [{	data: ResolverInputTypes["ScheduledNotificationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	data: ResolverInputTypes["ScheduledNotificationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
listProcessedNotificationSource?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
paginateProcessedNotificationSource?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ProcessedNotificationSourceConnection"]],
validateCreateProcessedNotificationSource?: [{	data: ResolverInputTypes["ProcessedNotificationSourceCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	data: ResolverInputTypes["ProcessedNotificationSourceUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null},ResolverInputTypes["Device"]],
listDevice?: [{	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Device"]],
paginateDevice?: [{	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DeviceConnection"]],
validateCreateDevice?: [{	data: ResolverInputTypes["DeviceCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	data: ResolverInputTypes["DeviceUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null},ResolverInputTypes["ScheduledNotificationLocale"]],
listScheduledNotificationLocale?: [{	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ScheduledNotificationLocale"]],
paginateScheduledNotificationLocale?: [{	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ScheduledNotificationLocaleConnection"]],
validateCreateScheduledNotificationLocale?: [{	data: ResolverInputTypes["ScheduledNotificationLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	data: ResolverInputTypes["ScheduledNotificationLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItemLocale"]],
listInfoCarouselItemLocale?: [{	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoCarouselItemLocale"]],
paginateInfoCarouselItemLocale?: [{	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoCarouselItemLocaleConnection"]],
validateCreateInfoCarouselItemLocale?: [{	data: ResolverInputTypes["InfoCarouselItemLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	data: ResolverInputTypes["InfoCarouselItemLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null},ResolverInputTypes["SentPaymentLocale"]],
listSentPaymentLocale?: [{	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SentPaymentLocale"]],
paginateSentPaymentLocale?: [{	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SentPaymentLocaleConnection"]],
validateCreateSentPaymentLocale?: [{	data: ResolverInputTypes["SentPaymentLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	data: ResolverInputTypes["SentPaymentLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserPaymentMetadata?: [{	by: ResolverInputTypes["UserPaymentMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["UserPaymentMetadata"]],
listUserPaymentMetadata?: [{	filter?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentMetadata"]],
paginateUserPaymentMetadata?: [{	filter?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentMetadataConnection"]],
getPostAreaCurrencySum?: [{	by: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"],	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null},ResolverInputTypes["PostAreaCurrencySum"]],
listPostAreaCurrencySum?: [{	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaCurrencySum"]],
paginatePostAreaCurrencySum?: [{	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaCurrencySumConnection"]],
getPostAreaSum?: [{	by: ResolverInputTypes["PostAreaSumUniqueWhere"],	filter?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null},ResolverInputTypes["PostAreaSum"]],
listPostAreaSum?: [{	filter?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaSum"]],
paginatePostAreaSum?: [{	filter?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaSumConnection"]],
getPostOrganizationCurrencySum?: [{	by: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null},ResolverInputTypes["PostOrganizationCurrencySum"]],
listPostOrganizationCurrencySum?: [{	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationCurrencySum"]],
paginatePostOrganizationCurrencySum?: [{	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationCurrencySumConnection"]],
getPostOrganizationSum?: [{	by: ResolverInputTypes["PostOrganizationSumUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null},ResolverInputTypes["PostOrganizationSum"]],
listPostOrganizationSum?: [{	filter?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationSumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationSum"]],
paginatePostOrganizationSum?: [{	filter?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationSumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationSumConnection"]],
getStats?: [{	by: ResolverInputTypes["StatsUniqueWhere"],	filter?: ResolverInputTypes["StatsWhere"] | undefined | null},ResolverInputTypes["Stats"]],
listStats?: [{	filter?: ResolverInputTypes["StatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Stats"]],
paginateStats?: [{	filter?: ResolverInputTypes["StatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StatsConnection"]],
getUserRecurringPaymentItemMetadata?: [{	by: ResolverInputTypes["UserRecurringPaymentItemMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItemMetadata"]],
listUserRecurringPaymentItemMetadata?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItemMetadata"]],
paginateUserRecurringPaymentItemMetadata?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItemMetadataConnection"]],
getUpcomingUserRecurringPaymentMetadata?: [{	by: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"],	filter?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["UpcomingUserRecurringPaymentMetadata"]],
listUpcomingUserRecurringPaymentMetadata?: [{	filter?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UpcomingUserRecurringPaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UpcomingUserRecurringPaymentMetadata"]],
paginateUpcomingUserRecurringPaymentMetadata?: [{	filter?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UpcomingUserRecurringPaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UpcomingUserRecurringPaymentMetadataConnection"]],
getUserAreaStats?: [{	by: ResolverInputTypes["UserAreaStatsUniqueWhere"],	filter?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null},ResolverInputTypes["UserAreaStats"]],
listUserAreaStats?: [{	filter?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserAreaStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserAreaStats"]],
paginateUserAreaStats?: [{	filter?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserAreaStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserAreaStatsConnection"]],
getUserCurrencyStats?: [{	by: ResolverInputTypes["UserCurrencyStatsUniqueWhere"],	filter?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null},ResolverInputTypes["UserCurrencyStats"]],
listUserCurrencyStats?: [{	filter?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserCurrencyStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserCurrencyStats"]],
paginateUserCurrencyStats?: [{	filter?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserCurrencyStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserCurrencyStatsConnection"]],
getUserOrganizationStats?: [{	by: ResolverInputTypes["UserOrganizationStatsUniqueWhere"],	filter?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null},ResolverInputTypes["UserOrganizationStats"]],
listUserOrganizationStats?: [{	filter?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrganizationStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserOrganizationStats"]],
paginateUserOrganizationStats?: [{	filter?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrganizationStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserOrganizationStatsConnection"]],
getUserPostStats?: [{	by: ResolverInputTypes["UserPostStatsUniqueWhere"],	filter?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null},ResolverInputTypes["UserPostStats"]],
listUserPostStats?: [{	filter?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPostStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPostStats"]],
paginateUserPostStats?: [{	filter?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPostStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPostStatsConnection"]],
getUserStats?: [{	by: ResolverInputTypes["UserStatsUniqueWhere"],	filter?: ResolverInputTypes["UserStatsWhere"] | undefined | null},ResolverInputTypes["UserStats"]],
listUserStats?: [{	filter?: ResolverInputTypes["UserStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserStats"]],
paginateUserStats?: [{	filter?: ResolverInputTypes["UserStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserStatsConnection"]],
getTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null},ResolverInputTypes["TextImageList"]],
listTextImageList?: [{	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextImageList"]],
paginateTextImageList?: [{	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextImageListConnection"]],
validateCreateTextImageList?: [{	data: ResolverInputTypes["TextImageListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	data: ResolverInputTypes["TextImageListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null},ResolverInputTypes["TextImageListItem"]],
listTextImageListItem?: [{	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextImageListItem"]],
paginateTextImageListItem?: [{	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextImageListItemConnection"]],
validateCreateTextImageListItem?: [{	data: ResolverInputTypes["TextImageListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	data: ResolverInputTypes["TextImageListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostCurrencySum?: [{	by: ResolverInputTypes["PostCurrencySumUniqueWhere"],	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null},ResolverInputTypes["PostCurrencySum"]],
listPostCurrencySum?: [{	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostCurrencySum"]],
paginatePostCurrencySum?: [{	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostCurrencySumConnection"]],
getPostSum?: [{	by: ResolverInputTypes["PostSumUniqueWhere"],	filter?: ResolverInputTypes["PostSumWhere"] | undefined | null},ResolverInputTypes["PostSum"]],
listPostSum?: [{	filter?: ResolverInputTypes["PostSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostSumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostSum"]],
paginatePostSum?: [{	filter?: ResolverInputTypes["PostSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostSumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostSumConnection"]],
getPostFundraisingProgress?: [{	by: ResolverInputTypes["PostFundraisingProgressUniqueWhere"],	filter?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null},ResolverInputTypes["PostFundraisingProgress"]],
listPostFundraisingProgress?: [{	filter?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostFundraisingProgressOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostFundraisingProgress"]],
paginatePostFundraisingProgress?: [{	filter?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostFundraisingProgressOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostFundraisingProgressConnection"]],
getHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null},ResolverInputTypes["HeroCarouselItem"]],
listHeroCarouselItem?: [{	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeroCarouselItem"]],
paginateHeroCarouselItem?: [{	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeroCarouselItemConnection"]],
validateCreateHeroCarouselItem?: [{	data: ResolverInputTypes["HeroCarouselItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	data: ResolverInputTypes["HeroCarouselItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
	transaction?:ResolverInputTypes["QueryTransaction"],
	_info?:ResolverInputTypes["Info"],
		__typename?: boolean | `@${string}`
}>;
	["_Schema"]: AliasType<{
	enums?:ResolverInputTypes["_Enum"],
	entities?:ResolverInputTypes["_Entity"],
		__typename?: boolean | `@${string}`
}>;
	["_Enum"]: AliasType<{
	name?:boolean | `@${string}`,
	values?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Entity"]: AliasType<{
	name?:boolean | `@${string}`,
	customPrimaryAllowed?:boolean | `@${string}`,
	fields?:ResolverInputTypes["_Field"],
	unique?:ResolverInputTypes["_UniqueConstraint"],
		__typename?: boolean | `@${string}`
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["General"]: AliasType<{
	_meta?:ResolverInputTypes["GeneralMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GeneralLocale"]],
allAreasIcon?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
allOrganizationsIcon?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
organizationList?: [{	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null},ResolverInputTypes["PostOrganizationList"]],
localesByLocale?: [{	by: ResolverInputTypes["GeneralLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["GeneralLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
localesByAppStoreLink?: [{	by: ResolverInputTypes["GeneralLocalesByAppStoreLinkUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
localesByGooglePlayLink?: [{	by: ResolverInputTypes["GeneralLocalesByGooglePlayLinkUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GeneralMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	allAreasIcon?:ResolverInputTypes["FieldMeta"],
	allOrganizationsIcon?:ResolverInputTypes["FieldMeta"],
	organizationList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FieldMeta"]: AliasType<{
	readable?:boolean | `@${string}`,
	updatable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UUID"]:unknown;
	["One"]:One;
	["GeneralLocale"]: AliasType<{
	_meta?:ResolverInputTypes["GeneralLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["General"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
appStoreLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
googlePlayLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
	allAreasDescription?:boolean | `@${string}`,
	allOrganizationsDescription?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	appStoreLink?:ResolverInputTypes["FieldMeta"],
	googlePlayLink?:ResolverInputTypes["FieldMeta"],
	allAreasDescription?:ResolverInputTypes["FieldMeta"],
	allOrganizationsDescription?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,
	allAreasIcon?: ResolverInputTypes["ImageWhere"] | undefined | null,
	allOrganizationsIcon?: ResolverInputTypes["ImageWhere"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GeneralWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GeneralWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GeneralWhere"] | undefined | null
};
	["UUIDCondition"]: {
	and?: Array<ResolverInputTypes["UUIDCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["UUIDCondition"]> | undefined | null,
	not?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["UUID"] | undefined | null,
	notEq?: ResolverInputTypes["UUID"] | undefined | null,
	in?: Array<ResolverInputTypes["UUID"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["UUID"]> | undefined | null,
	lt?: ResolverInputTypes["UUID"] | undefined | null,
	lte?: ResolverInputTypes["UUID"] | undefined | null,
	gt?: ResolverInputTypes["UUID"] | undefined | null,
	gte?: ResolverInputTypes["UUID"] | undefined | null
};
	["OneCondition"]: {
	and?: Array<ResolverInputTypes["OneCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["OneCondition"]> | undefined | null,
	not?: ResolverInputTypes["OneCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["One"] | undefined | null,
	notEq?: ResolverInputTypes["One"] | undefined | null,
	in?: Array<ResolverInputTypes["One"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["One"]> | undefined | null,
	lt?: ResolverInputTypes["One"] | undefined | null,
	lte?: ResolverInputTypes["One"] | undefined | null,
	gt?: ResolverInputTypes["One"] | undefined | null,
	gte?: ResolverInputTypes["One"] | undefined | null
};
	["GeneralLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["GeneralWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	appStoreLink?: ResolverInputTypes["LinkWhere"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["LinkWhere"] | undefined | null,
	allAreasDescription?: ResolverInputTypes["StringCondition"] | undefined | null,
	allOrganizationsDescription?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["GeneralLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GeneralLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null
};
	["LocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	code?: ResolverInputTypes["StringCondition"] | undefined | null,
	label?: ResolverInputTypes["StringCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	generals?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,
	genericPages?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,
	posts?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,
	postAreas?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,
	postOrganizations?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,
	headers?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,
	footers?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,
	genericPageAboutSettings?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,
	postRevisions?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,
	flagImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	feedPages?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,
	recurringPaymentPages?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,
	givenGiftsPages?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,
	receivedGiftsPages?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,
	reportPages?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,
	reportNavigations?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,
	scheduledNotifications?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,
	sentPayments?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["LocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["LocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["LocaleWhere"] | undefined | null
};
	["StringCondition"]: {
	and?: Array<ResolverInputTypes["StringCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["StringCondition"]> | undefined | null,
	not?: ResolverInputTypes["StringCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: string | undefined | null,
	notEq?: string | undefined | null,
	in?: Array<string> | undefined | null,
	notIn?: Array<string> | undefined | null,
	lt?: string | undefined | null,
	lte?: string | undefined | null,
	gt?: string | undefined | null,
	gte?: string | undefined | null,
	contains?: string | undefined | null,
	startsWith?: string | undefined | null,
	endsWith?: string | undefined | null,
	containsCI?: string | undefined | null,
	startsWithCI?: string | undefined | null,
	endsWithCI?: string | undefined | null
};
	["IntCondition"]: {
	and?: Array<ResolverInputTypes["IntCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["IntCondition"]> | undefined | null,
	not?: ResolverInputTypes["IntCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: number | undefined | null,
	notEq?: number | undefined | null,
	in?: Array<number> | undefined | null,
	notIn?: Array<number> | undefined | null,
	lt?: number | undefined | null,
	lte?: number | undefined | null,
	gt?: number | undefined | null,
	gte?: number | undefined | null
};
	["GenericPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["GenericPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null
};
	["GenericPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locales?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,
	type?: ResolverInputTypes["GenericPageTypeCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	reportNavigation?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GenericPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GenericPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GenericPageWhere"] | undefined | null
};
	["GenericPageTypeCondition"]: {
	and?: Array<ResolverInputTypes["GenericPageTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["GenericPageTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["GenericPageTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["GenericPageType"] | undefined | null,
	notEq?: ResolverInputTypes["GenericPageType"] | undefined | null,
	in?: Array<ResolverInputTypes["GenericPageType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["GenericPageType"]> | undefined | null,
	lt?: ResolverInputTypes["GenericPageType"] | undefined | null,
	lte?: ResolverInputTypes["GenericPageType"] | undefined | null,
	gt?: ResolverInputTypes["GenericPageType"] | undefined | null,
	gte?: ResolverInputTypes["GenericPageType"] | undefined | null
};
	["GenericPageType"]:GenericPageType;
	["ReportNavigationLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	pages?: ResolverInputTypes["GenericPageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null
};
	["ReportNavigationWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ReportNavigationWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ReportNavigationWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null
};
	["ContentWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	blocks?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContentWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContentWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContentWhere"] | undefined | null
};
	["ContentBlockWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	json?: ResolverInputTypes["StringCondition"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	references?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContentBlockWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContentBlockWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContentBlockWhere"] | undefined | null
};
	["ContentReferenceWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["ContentReferenceTypeCondition"] | undefined | null,
	primaryText?: ResolverInputTypes["StringCondition"] | undefined | null,
	block?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	linkables?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,
	video?: ResolverInputTypes["VideoWhere"] | undefined | null,
	secondaryText?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	contentAlignment?: ResolverInputTypes["ContentAlignmentCondition"] | undefined | null,
	valueList?: ResolverInputTypes["ValueListWhere"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,
	areaList?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,
	isAppsVisible?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	accordion?: ResolverInputTypes["AccordionWhere"] | undefined | null,
	media?: ResolverInputTypes["MediumListWhere"] | undefined | null,
	memberList?: ResolverInputTypes["MemberListWhere"] | undefined | null,
	asideMediaContentLayout?: ResolverInputTypes["AsideMediaContentLayoutCondition"] | undefined | null,
	isAsideMediaContentMobileLayout?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	form?: ResolverInputTypes["FormWhere"] | undefined | null,
	isTitleBigger?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentWhere"] | undefined | null,
	heroCarousel?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,
	isCentered?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	posts?: ResolverInputTypes["PostWhere"] | undefined | null,
	textImageList?: ResolverInputTypes["TextImageListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContentReferenceWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContentReferenceWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null
};
	["ContentReferenceTypeCondition"]: {
	and?: Array<ResolverInputTypes["ContentReferenceTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["ContentReferenceTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["ContentReferenceTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	notEq?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	in?: Array<ResolverInputTypes["ContentReferenceType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["ContentReferenceType"]> | undefined | null,
	lt?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	lte?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	gt?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	gte?: ResolverInputTypes["ContentReferenceType"] | undefined | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["ImageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	url?: ResolverInputTypes["StringCondition"] | undefined | null,
	width?: ResolverInputTypes["IntCondition"] | undefined | null,
	height?: ResolverInputTypes["IntCondition"] | undefined | null,
	size?: ResolverInputTypes["IntCondition"] | undefined | null,
	type?: ResolverInputTypes["StringCondition"] | undefined | null,
	alt?: ResolverInputTypes["StringCondition"] | undefined | null,
	fileName?: ResolverInputTypes["StringCondition"] | undefined | null,
	focalPointX?: ResolverInputTypes["FloatCondition"] | undefined | null,
	focalPointY?: ResolverInputTypes["FloatCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageWhere"] | undefined | null
};
	["FloatCondition"]: {
	and?: Array<ResolverInputTypes["FloatCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["FloatCondition"]> | undefined | null,
	not?: ResolverInputTypes["FloatCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: number | undefined | null,
	notEq?: number | undefined | null,
	in?: Array<number> | undefined | null,
	notIn?: Array<number> | undefined | null,
	lt?: number | undefined | null,
	lte?: number | undefined | null,
	gt?: number | undefined | null,
	gte?: number | undefined | null
};
	["ContentReferenceLinkableItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	item?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	reference?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null
};
	["LinkableWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	url?: ResolverInputTypes["StringCondition"] | undefined | null,
	genericPage?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,
	post?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,
	postArea?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,
	postOrganization?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,
	reportPage?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["LinkableWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["LinkableWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["LinkableWhere"] | undefined | null
};
	["PostLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	root?: ResolverInputTypes["PostWhere"] | undefined | null,
	paymentName?: ResolverInputTypes["StringCondition"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["PostLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostLocaleWhere"] | undefined | null
};
	["SeoWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	description?: ResolverInputTypes["StringCondition"] | undefined | null,
	ogTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	ogDescription?: ResolverInputTypes["StringCondition"] | undefined | null,
	noIndex?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	noFollow?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	ogImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["SeoWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SeoWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SeoWhere"] | undefined | null
};
	["BooleanCondition"]: {
	and?: Array<ResolverInputTypes["BooleanCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["BooleanCondition"]> | undefined | null,
	not?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: boolean | undefined | null,
	notEq?: boolean | undefined | null,
	in?: Array<boolean> | undefined | null,
	notIn?: Array<boolean> | undefined | null,
	lt?: boolean | undefined | null,
	lte?: boolean | undefined | null,
	gt?: boolean | undefined | null,
	gte?: boolean | undefined | null
};
	["PostWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	specificSymbol?: ResolverInputTypes["IntCondition"] | undefined | null,
	activeRevision?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,
	revisions?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,
	locales?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,
	isPinnedInArea?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isPinnedInOrganization?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	state?: ResolverInputTypes["PostStateCondition"] | undefined | null,
	meta?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null,
	isPublishedAtHidden?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	heroCarousel?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,
	reportPage?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,
	fundraiseIsActive?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["DateCondition"] | undefined | null,
	fundraiseTargetAmount?: ResolverInputTypes["IntCondition"] | undefined | null,
	fundraiseFakeAddOnAmount?: ResolverInputTypes["IntCondition"] | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	fundraiseCurrencySums?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostSumWhere"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostWhere"] | undefined | null
};
	["PostOrganizationWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	posts?: ResolverInputTypes["PostWhere"] | undefined | null,
	icon?: ResolverInputTypes["ImageWhere"] | undefined | null,
	locales?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,
	specificSymbol?: ResolverInputTypes["IntCondition"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	isHidden?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	color?: ResolverInputTypes["StringCondition"] | undefined | null,
	plainIcon?: ResolverInputTypes["ImageWhere"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	sentPayments?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,
	organizationCurrencySums?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostOrganizationWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostOrganizationWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null
};
	["PostOrganizationLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	description?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	root?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	domain?: ResolverInputTypes["LinkWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	translatedByAI?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null
};
	["LinkWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["LinkEnumCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	externalLink?: ResolverInputTypes["StringCondition"] | undefined | null,
	internalLink?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	isTargetBlank?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["LinkWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["LinkWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["LinkWhere"] | undefined | null
};
	["LinkEnumCondition"]: {
	and?: Array<ResolverInputTypes["LinkEnumCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["LinkEnumCondition"]> | undefined | null,
	not?: ResolverInputTypes["LinkEnumCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["LinkEnum"] | undefined | null,
	notEq?: ResolverInputTypes["LinkEnum"] | undefined | null,
	in?: Array<ResolverInputTypes["LinkEnum"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["LinkEnum"]> | undefined | null,
	lt?: ResolverInputTypes["LinkEnum"] | undefined | null,
	lte?: ResolverInputTypes["LinkEnum"] | undefined | null,
	gt?: ResolverInputTypes["LinkEnum"] | undefined | null,
	gte?: ResolverInputTypes["LinkEnum"] | undefined | null
};
	["LinkEnum"]:LinkEnum;
	["PostAreaWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	icon?: ResolverInputTypes["ImageWhere"] | undefined | null,
	locales?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,
	regionListOverride?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,
	color?: ResolverInputTypes["StringCondition"] | undefined | null,
	posts?: ResolverInputTypes["PostWhere"] | undefined | null,
	specificSymbol?: ResolverInputTypes["IntCondition"] | undefined | null,
	region?: ResolverInputTypes["RegionWhere"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	plainIcon?: ResolverInputTypes["ImageWhere"] | undefined | null,
	sentPayments?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,
	areaSentPaymentCurrencySums?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null,
	areaCurrencySums?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaWhere"] | undefined | null
};
	["PostAreaLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	description?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	root?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	banner?: ResolverInputTypes["AppBannerWhere"] | undefined | null,
	shortDescription?: ResolverInputTypes["StringCondition"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	translatedByAI?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null
};
	["AppBannerWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	imageSmall?: ResolverInputTypes["ImageWhere"] | undefined | null,
	imageBig?: ResolverInputTypes["ImageWhere"] | undefined | null,
	textContent?: ResolverInputTypes["ContentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["AppBannerWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["AppBannerWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["AppBannerWhere"] | undefined | null
};
	["DonationAmountsRegionListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	regions?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,
	donation?: ResolverInputTypes["DonationWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null
};
	["DonationAmountsRegionItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	items?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,
	region?: ResolverInputTypes["RegionWhere"] | undefined | null,
	minimumAmount?: ResolverInputTypes["FloatCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null
};
	["DonationAmountItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	amount?: ResolverInputTypes["FloatCondition"] | undefined | null,
	regionItem?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["DonationAmountItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["DonationAmountItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null
};
	["RegionWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	code?: ResolverInputTypes["StringCondition"] | undefined | null,
	label?: ResolverInputTypes["StringCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	enabledPaymentMethods?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,
	donationItems?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,
	timezone?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["RegionWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["RegionWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["RegionWhere"] | undefined | null
};
	["CurrencyWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	identifier?: ResolverInputTypes["CurrencyIdentifierCondition"] | undefined | null,
	label?: ResolverInputTypes["StringCondition"] | undefined | null,
	sign?: ResolverInputTypes["StringCondition"] | undefined | null,
	signAlignment?: ResolverInputTypes["CurrencySignAlignmentCondition"] | undefined | null,
	defaultDonationAmount?: ResolverInputTypes["IntCondition"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["FloatCondition"] | undefined | null,
	areaSentPaymentCurrencySums?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,
	areaCurrencySums?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,
	organizationCurrencySums?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,
	postCurrencySums?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["CurrencyWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CurrencyWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CurrencyWhere"] | undefined | null
};
	["CurrencyIdentifierCondition"]: {
	and?: Array<ResolverInputTypes["CurrencyIdentifierCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["CurrencyIdentifierCondition"]> | undefined | null,
	not?: ResolverInputTypes["CurrencyIdentifierCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null,
	notEq?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null,
	in?: Array<ResolverInputTypes["CurrencyIdentifier"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["CurrencyIdentifier"]> | undefined | null,
	lt?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null,
	lte?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null,
	gt?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null,
	gte?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null
};
	["CurrencyIdentifier"]:CurrencyIdentifier;
	["CurrencySignAlignmentCondition"]: {
	and?: Array<ResolverInputTypes["CurrencySignAlignmentCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["CurrencySignAlignmentCondition"]> | undefined | null,
	not?: ResolverInputTypes["CurrencySignAlignmentCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["CurrencySignAlignment"] | undefined | null,
	notEq?: ResolverInputTypes["CurrencySignAlignment"] | undefined | null,
	in?: Array<ResolverInputTypes["CurrencySignAlignment"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["CurrencySignAlignment"]> | undefined | null,
	lt?: ResolverInputTypes["CurrencySignAlignment"] | undefined | null,
	lte?: ResolverInputTypes["CurrencySignAlignment"] | undefined | null,
	gt?: ResolverInputTypes["CurrencySignAlignment"] | undefined | null,
	gte?: ResolverInputTypes["CurrencySignAlignment"] | undefined | null
};
	["CurrencySignAlignment"]:CurrencySignAlignment;
	["PostAreaSentPaymentCurrencySumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	currencyIdentifier?: ResolverInputTypes["StringCondition"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["FloatCondition"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null
};
	["PostAreaCurrencySumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	currencyIdentifier?: ResolverInputTypes["StringCondition"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["FloatCondition"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null
};
	["PostOrganizationCurrencySumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	currencyIdentifier?: ResolverInputTypes["StringCondition"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["FloatCondition"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null
};
	["PostCurrencySumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	currencyIdentifier?: ResolverInputTypes["StringCondition"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["FloatCondition"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostCurrencySumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostCurrencySumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null
};
	["RegionPaymentMethodWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	allowRecurringPayments?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	region?: ResolverInputTypes["RegionWhere"] | undefined | null,
	method?: ResolverInputTypes["PaymentMethodsCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null
};
	["PaymentMethodsCondition"]: {
	and?: Array<ResolverInputTypes["PaymentMethodsCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["PaymentMethodsCondition"]> | undefined | null,
	not?: ResolverInputTypes["PaymentMethodsCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	notEq?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	in?: Array<ResolverInputTypes["PaymentMethods"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["PaymentMethods"]> | undefined | null,
	lt?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	lte?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	gt?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	gte?: ResolverInputTypes["PaymentMethods"] | undefined | null
};
	["PaymentMethods"]:PaymentMethods;
	["DonationWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	regionList?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["DonationWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["DonationWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["DonationWhere"] | undefined | null
};
	["PostAreaMetaDataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	nameWithFallback?: ResolverInputTypes["StringCondition"] | undefined | null,
	formattedSpecificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	fullFormattedSpecificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null
};
	["SentPaymentWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	cents?: ResolverInputTypes["IntCondition"] | undefined | null,
	sendAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	locales?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["SentPaymentWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SentPaymentWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SentPaymentWhere"] | undefined | null
};
	["DateTimeCondition"]: {
	and?: Array<ResolverInputTypes["DateTimeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["DateTimeCondition"]> | undefined | null,
	not?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["DateTime"] | undefined | null,
	notEq?: ResolverInputTypes["DateTime"] | undefined | null,
	in?: Array<ResolverInputTypes["DateTime"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["DateTime"]> | undefined | null,
	lt?: ResolverInputTypes["DateTime"] | undefined | null,
	lte?: ResolverInputTypes["DateTime"] | undefined | null,
	gt?: ResolverInputTypes["DateTime"] | undefined | null,
	gte?: ResolverInputTypes["DateTime"] | undefined | null
};
	["DateTime"]:unknown;
	["SentPaymentLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	organizationText?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null
};
	["PostAreaSentPaymentSumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	czkPercentage?: ResolverInputTypes["FloatCondition"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null
};
	["PostAreaSumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	czkPercentage?: ResolverInputTypes["FloatCondition"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaSumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaSumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null
};
	["PostOrganizationMetaDataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	nameWithFallback?: ResolverInputTypes["StringCondition"] | undefined | null,
	formattedSpecificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	fullFormattedSpecificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null
};
	["PostOrganizationSumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	czkPercentage?: ResolverInputTypes["FloatCondition"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null
};
	["PostRevisionWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	createdById?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	publishedById?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["PostTypeCondition"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	tileImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	tileVideo?: ResolverInputTypes["VideoWhere"] | undefined | null,
	heroImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	locales?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,
	regionListOverride?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,
	isOrganizationVisible?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	sendPublishNotifications?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isArchived?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["PostRevisionWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostRevisionWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostRevisionWhere"] | undefined | null
};
	["PostTypeCondition"]: {
	and?: Array<ResolverInputTypes["PostTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["PostTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["PostTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["PostType"] | undefined | null,
	notEq?: ResolverInputTypes["PostType"] | undefined | null,
	in?: Array<ResolverInputTypes["PostType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["PostType"]> | undefined | null,
	lt?: ResolverInputTypes["PostType"] | undefined | null,
	lte?: ResolverInputTypes["PostType"] | undefined | null,
	gt?: ResolverInputTypes["PostType"] | undefined | null,
	gte?: ResolverInputTypes["PostType"] | undefined | null
};
	["PostType"]:PostType;
	["VideoWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	url?: ResolverInputTypes["StringCondition"] | undefined | null,
	width?: ResolverInputTypes["IntCondition"] | undefined | null,
	height?: ResolverInputTypes["IntCondition"] | undefined | null,
	size?: ResolverInputTypes["IntCondition"] | undefined | null,
	type?: ResolverInputTypes["StringCondition"] | undefined | null,
	poster?: ResolverInputTypes["ImageWhere"] | undefined | null,
	shapeType?: ResolverInputTypes["VideoShapeTypeCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["VideoWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["VideoWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["VideoWhere"] | undefined | null
};
	["VideoShapeTypeCondition"]: {
	and?: Array<ResolverInputTypes["VideoShapeTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["VideoShapeTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["VideoShapeTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["VideoShapeType"] | undefined | null,
	notEq?: ResolverInputTypes["VideoShapeType"] | undefined | null,
	in?: Array<ResolverInputTypes["VideoShapeType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["VideoShapeType"]> | undefined | null,
	lt?: ResolverInputTypes["VideoShapeType"] | undefined | null,
	lte?: ResolverInputTypes["VideoShapeType"] | undefined | null,
	gt?: ResolverInputTypes["VideoShapeType"] | undefined | null,
	gte?: ResolverInputTypes["VideoShapeType"] | undefined | null
};
	["VideoShapeType"]:VideoShapeType;
	["PostRevisionLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	leadContent?: ResolverInputTypes["ContentWhere"] | undefined | null,
	publishNotificationText?: ResolverInputTypes["StringCondition"] | undefined | null,
	translatedByAI?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null
};
	["PostStateCondition"]: {
	and?: Array<ResolverInputTypes["PostStateCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["PostStateCondition"]> | undefined | null,
	not?: ResolverInputTypes["PostStateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["PostState"] | undefined | null,
	notEq?: ResolverInputTypes["PostState"] | undefined | null,
	in?: Array<ResolverInputTypes["PostState"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["PostState"]> | undefined | null,
	lt?: ResolverInputTypes["PostState"] | undefined | null,
	lte?: ResolverInputTypes["PostState"] | undefined | null,
	gt?: ResolverInputTypes["PostState"] | undefined | null,
	gte?: ResolverInputTypes["PostState"] | undefined | null
};
	["PostState"]:PostState;
	["PostMetaDataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	titleWithFallback?: ResolverInputTypes["StringCondition"] | undefined | null,
	formattedSpecificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	fullFormattedSpecificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	latestRevision?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostMetaDataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostMetaDataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null
};
	["HeroCarouselWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateCondition"] | undefined | null,
	posts?: ResolverInputTypes["PostWhere"] | undefined | null,
	items?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HeroCarouselWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HeroCarouselWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null
};
	["DateCondition"]: {
	and?: Array<ResolverInputTypes["DateCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["DateCondition"]> | undefined | null,
	not?: ResolverInputTypes["DateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["Date"] | undefined | null,
	notEq?: ResolverInputTypes["Date"] | undefined | null,
	in?: Array<ResolverInputTypes["Date"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["Date"]> | undefined | null,
	lt?: ResolverInputTypes["Date"] | undefined | null,
	lte?: ResolverInputTypes["Date"] | undefined | null,
	gt?: ResolverInputTypes["Date"] | undefined | null,
	gte?: ResolverInputTypes["Date"] | undefined | null
};
	["Date"]:unknown;
	["HeroCarouselItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,
	item?: ResolverInputTypes["PostWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null
};
	["ReportPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	postTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	giftTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	root?: ResolverInputTypes["ReportPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	posts?: ResolverInputTypes["PostWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null
};
	["ReportPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ReportPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ReportPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ReportPageWhere"] | undefined | null
};
	["PostSumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	czkPercentage?: ResolverInputTypes["FloatCondition"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostSumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostSumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostSumWhere"] | undefined | null
};
	["PostFundraisingProgressWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	progress?: ResolverInputTypes["FloatCondition"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null
};
	["GivenGiftsPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	giftTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	giftText?: ResolverInputTypes["StringCondition"] | undefined | null,
	note?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null
};
	["GivenGiftsPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null
};
	["ReceivedGiftsPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	giftTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	giftText?: ResolverInputTypes["StringCondition"] | undefined | null,
	note?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null
};
	["ReceivedGiftsPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null
};
	["ContentAlignmentCondition"]: {
	and?: Array<ResolverInputTypes["ContentAlignmentCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["ContentAlignmentCondition"]> | undefined | null,
	not?: ResolverInputTypes["ContentAlignmentCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	notEq?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	in?: Array<ResolverInputTypes["ContentAlignment"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["ContentAlignment"]> | undefined | null,
	lt?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	lte?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	gt?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	gte?: ResolverInputTypes["ContentAlignment"] | undefined | null
};
	["ContentAlignment"]:ContentAlignment;
	["ValueListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["ValueItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ValueListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ValueListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ValueListWhere"] | undefined | null
};
	["ValueItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["ValueListWhere"] | undefined | null,
	item?: ResolverInputTypes["ValueWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ValueItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ValueItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ValueItemWhere"] | undefined | null
};
	["ValueWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	textContent?: ResolverInputTypes["ContentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ValueWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ValueWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ValueWhere"] | undefined | null
};
	["ImageLinkListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageLinkListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageLinkListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null
};
	["ImageLinkItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,
	item?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageLinkItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageLinkItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null
};
	["ImageLinkWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageLinkWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageLinkWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageLinkWhere"] | undefined | null
};
	["PostAreaListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaListWhere"] | undefined | null
};
	["PostAreaListItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,
	item?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostAreaListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostAreaListItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null
};
	["AccordionWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["AccordionWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["AccordionWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["AccordionWhere"] | undefined | null
};
	["AccordionItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["AccordionWhere"] | undefined | null,
	descriptionContent?: ResolverInputTypes["ContentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["AccordionItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["AccordionItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["AccordionItemWhere"] | undefined | null
};
	["MediumListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["MediumItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["MediumListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["MediumListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["MediumListWhere"] | undefined | null
};
	["MediumItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["MediumListWhere"] | undefined | null,
	medium?: ResolverInputTypes["MediumWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["MediumItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["MediumItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["MediumItemWhere"] | undefined | null
};
	["MediumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["MediumTypeCondition"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	video?: ResolverInputTypes["VideoWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["MediumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["MediumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["MediumWhere"] | undefined | null
};
	["MediumTypeCondition"]: {
	and?: Array<ResolverInputTypes["MediumTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["MediumTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["MediumTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["MediumType"] | undefined | null,
	notEq?: ResolverInputTypes["MediumType"] | undefined | null,
	in?: Array<ResolverInputTypes["MediumType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["MediumType"]> | undefined | null,
	lt?: ResolverInputTypes["MediumType"] | undefined | null,
	lte?: ResolverInputTypes["MediumType"] | undefined | null,
	gt?: ResolverInputTypes["MediumType"] | undefined | null,
	gte?: ResolverInputTypes["MediumType"] | undefined | null
};
	["MediumType"]:MediumType;
	["MemberListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["MemberListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["MemberListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["MemberListWhere"] | undefined | null
};
	["MemberListItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	position?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["MemberListWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	descriptionContent?: ResolverInputTypes["ContentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["MemberListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["MemberListItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["MemberListItemWhere"] | undefined | null
};
	["AsideMediaContentLayoutCondition"]: {
	and?: Array<ResolverInputTypes["AsideMediaContentLayoutCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["AsideMediaContentLayoutCondition"]> | undefined | null,
	not?: ResolverInputTypes["AsideMediaContentLayoutCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	notEq?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	in?: Array<ResolverInputTypes["AsideMediaContentLayout"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["AsideMediaContentLayout"]> | undefined | null,
	lt?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	lte?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	gt?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	gte?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null
};
	["AsideMediaContentLayout"]:AsideMediaContentLayout;
	["FormWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	type?: ResolverInputTypes["FormTypeCondition"] | undefined | null,
	tax?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FormWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FormWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FormWhere"] | undefined | null
};
	["FormTypeCondition"]: {
	and?: Array<ResolverInputTypes["FormTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["FormTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["FormTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["FormType"] | undefined | null,
	notEq?: ResolverInputTypes["FormType"] | undefined | null,
	in?: Array<ResolverInputTypes["FormType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["FormType"]> | undefined | null,
	lt?: ResolverInputTypes["FormType"] | undefined | null,
	lte?: ResolverInputTypes["FormType"] | undefined | null,
	gt?: ResolverInputTypes["FormType"] | undefined | null,
	gte?: ResolverInputTypes["FormType"] | undefined | null
};
	["FormType"]:FormType;
	["FilledTaxFormWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	userId?: ResolverInputTypes["StringCondition"] | undefined | null,
	email?: ResolverInputTypes["StringCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	vatId?: ResolverInputTypes["StringCondition"] | undefined | null,
	address1?: ResolverInputTypes["StringCondition"] | undefined | null,
	address2?: ResolverInputTypes["StringCondition"] | undefined | null,
	city?: ResolverInputTypes["StringCondition"] | undefined | null,
	postalCode?: ResolverInputTypes["StringCondition"] | undefined | null,
	state?: ResolverInputTypes["StringCondition"] | undefined | null,
	country?: ResolverInputTypes["RegionWhere"] | undefined | null,
	dateFrom?: ResolverInputTypes["DateCondition"] | undefined | null,
	dateTo?: ResolverInputTypes["DateCondition"] | undefined | null,
	year?: ResolverInputTypes["IntCondition"] | undefined | null,
	isPdfGenerated?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	pdfObjectKey?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["FilledTaxFormWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FilledTaxFormWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null
};
	["PostOrganizationListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostOrganizationListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostOrganizationListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null
};
	["PostOrganizationListItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,
	item?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	type?: ResolverInputTypes["PostOrganizationListItemTypeCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null
};
	["PostOrganizationListItemTypeCondition"]: {
	and?: Array<ResolverInputTypes["PostOrganizationListItemTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["PostOrganizationListItemTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["PostOrganizationListItemTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	notEq?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	in?: Array<ResolverInputTypes["PostOrganizationListItemType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["PostOrganizationListItemType"]> | undefined | null,
	lt?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	lte?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	gt?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	gte?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null
};
	["PostOrganizationListItemType"]:PostOrganizationListItemType;
	["TextImageListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TextImageListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TextImageListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TextImageListWhere"] | undefined | null
};
	["TextImageListItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["TextImageListWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TextImageListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TextImageListItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null
};
	["HeaderLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["HeaderWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	links?: ResolverInputTypes["LinkListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HeaderLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HeaderLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null
};
	["HeaderWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	locales?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HeaderWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HeaderWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HeaderWhere"] | undefined | null
};
	["LinkListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["LinkItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["LinkListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["LinkListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["LinkListWhere"] | undefined | null
};
	["LinkItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["LinkListWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["LinkItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["LinkItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["LinkItemWhere"] | undefined | null
};
	["FooterLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	copyright?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["FooterWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	linkList?: ResolverInputTypes["LinkListWhere"] | undefined | null,
	contactEmail?: ResolverInputTypes["StringCondition"] | undefined | null,
	addressInfo?: ResolverInputTypes["ContentWhere"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FooterLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FooterLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null
};
	["FooterWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FooterWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FooterWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FooterWhere"] | undefined | null
};
	["GenericPageAboutSettingsLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	linkGroups?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null
};
	["GenericPageAboutSettingsWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null
};
	["GenericPageAboutGroupLinksLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	settings?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,
	linkList?: ResolverInputTypes["LinkListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null
};
	["FeedPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["FeedPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	heroTiles?: ResolverInputTypes["TileListWhere"] | undefined | null,
	sectionList?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,
	cardList?: ResolverInputTypes["CardListWhere"] | undefined | null,
	storyGuideList?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null
};
	["FeedPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FeedPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FeedPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FeedPageWhere"] | undefined | null
};
	["TileListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	size?: ResolverInputTypes["TileListSizeCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	items?: ResolverInputTypes["TileItemWhere"] | undefined | null,
	areaType?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TileListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TileListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TileListWhere"] | undefined | null
};
	["TileListSizeCondition"]: {
	and?: Array<ResolverInputTypes["TileListSizeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["TileListSizeCondition"]> | undefined | null,
	not?: ResolverInputTypes["TileListSizeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["TileListSize"] | undefined | null,
	notEq?: ResolverInputTypes["TileListSize"] | undefined | null,
	in?: Array<ResolverInputTypes["TileListSize"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["TileListSize"]> | undefined | null,
	lt?: ResolverInputTypes["TileListSize"] | undefined | null,
	lte?: ResolverInputTypes["TileListSize"] | undefined | null,
	gt?: ResolverInputTypes["TileListSize"] | undefined | null,
	gte?: ResolverInputTypes["TileListSize"] | undefined | null
};
	["TileListSize"]:TileListSize;
	["TileItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	type?: ResolverInputTypes["TileItemTypeCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	description?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["TileListWhere"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TileItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TileItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TileItemWhere"] | undefined | null
};
	["TileItemTypeCondition"]: {
	and?: Array<ResolverInputTypes["TileItemTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["TileItemTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["TileItemTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["TileItemType"] | undefined | null,
	notEq?: ResolverInputTypes["TileItemType"] | undefined | null,
	in?: Array<ResolverInputTypes["TileItemType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["TileItemType"]> | undefined | null,
	lt?: ResolverInputTypes["TileItemType"] | undefined | null,
	lte?: ResolverInputTypes["TileItemType"] | undefined | null,
	gt?: ResolverInputTypes["TileItemType"] | undefined | null,
	gte?: ResolverInputTypes["TileItemType"] | undefined | null
};
	["TileItemType"]:TileItemType;
	["FeedPageSectionWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	feedPageLocale?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,
	tileStripeList?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FeedPageSectionWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FeedPageSectionWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null
};
	["FeedPageTileStripeWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	section?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,
	tileList?: ResolverInputTypes["TileListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null
};
	["CardListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["CardItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["CardListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CardListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CardListWhere"] | undefined | null
};
	["CardItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	description?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["CardListWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["CardItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CardItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CardItemWhere"] | undefined | null
};
	["StoryGuideListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["StoryGuideListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["StoryGuideListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null
};
	["StoryGuideItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,
	guide?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["StoryGuideItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["StoryGuideItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null
};
	["StoryGuideWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	mediaType?: ResolverInputTypes["MediaTypeCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	secondaryImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["StoryGuideWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["StoryGuideWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["StoryGuideWhere"] | undefined | null
};
	["MediaTypeCondition"]: {
	and?: Array<ResolverInputTypes["MediaTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["MediaTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["MediaTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["MediaType"] | undefined | null,
	notEq?: ResolverInputTypes["MediaType"] | undefined | null,
	in?: Array<ResolverInputTypes["MediaType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["MediaType"]> | undefined | null,
	lt?: ResolverInputTypes["MediaType"] | undefined | null,
	lte?: ResolverInputTypes["MediaType"] | undefined | null,
	gt?: ResolverInputTypes["MediaType"] | undefined | null,
	gte?: ResolverInputTypes["MediaType"] | undefined | null
};
	["MediaType"]:MediaType;
	["RecurringPaymentPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	favouritePosts?: ResolverInputTypes["PostListWhere"] | undefined | null,
	storyGuideList?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null
};
	["RecurringPaymentPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null
};
	["PostListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["PostListItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostListWhere"] | undefined | null
};
	["PostListItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["PostListWhere"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PostListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PostListItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PostListItemWhere"] | undefined | null
};
	["ScheduledNotificationLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	description?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null
};
	["ScheduledNotificationWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	localMsFromMidnight?: ResolverInputTypes["IntCondition"] | undefined | null,
	scheduledDate?: ResolverInputTypes["DateCondition"] | undefined | null,
	internalTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	target?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,
	locales?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	completedAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	processedNotifications?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null
};
	["NotificationTargetGroupWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["NotificationTargetTypeCondition"] | undefined | null,
	regions?: ResolverInputTypes["RegionWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null
};
	["NotificationTargetTypeCondition"]: {
	and?: Array<ResolverInputTypes["NotificationTargetTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["NotificationTargetTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["NotificationTargetTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["NotificationTargetType"] | undefined | null,
	notEq?: ResolverInputTypes["NotificationTargetType"] | undefined | null,
	in?: Array<ResolverInputTypes["NotificationTargetType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["NotificationTargetType"]> | undefined | null,
	lt?: ResolverInputTypes["NotificationTargetType"] | undefined | null,
	lte?: ResolverInputTypes["NotificationTargetType"] | undefined | null,
	gt?: ResolverInputTypes["NotificationTargetType"] | undefined | null,
	gte?: ResolverInputTypes["NotificationTargetType"] | undefined | null
};
	["NotificationTargetType"]:NotificationTargetType;
	["ProcessedNotificationSourceWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["ProcessedNotificationSourceTypeCondition"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,
	donationReminderUser?: ResolverInputTypes["UserWhere"] | undefined | null,
	scheduledNotification?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null
};
	["ProcessedNotificationSourceTypeCondition"]: {
	and?: Array<ResolverInputTypes["ProcessedNotificationSourceTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["ProcessedNotificationSourceTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["ProcessedNotificationSourceTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	notEq?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	in?: Array<ResolverInputTypes["ProcessedNotificationSourceType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["ProcessedNotificationSourceType"]> | undefined | null,
	lt?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	lte?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	gt?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	gte?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null
};
	["ProcessedNotificationSourceType"]:ProcessedNotificationSourceType;
	["ProcessedNotificationWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	topic?: ResolverInputTypes["StringCondition"] | undefined | null,
	sentAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	errorMessage?: ResolverInputTypes["StringCondition"] | undefined | null,
	errorCode?: ResolverInputTypes["StringCondition"] | undefined | null,
	isSuccess?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	source?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	body?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null
};
	["UserWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	email?: ResolverInputTypes["StringCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	payments?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	variableSymbol?: ResolverInputTypes["IntCondition"] | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	region?: ResolverInputTypes["RegionWhere"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	recurringPayments?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,
	stripeId?: ResolverInputTypes["StringCondition"] | undefined | null,
	isDeactivated?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	onBehalfDonations?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,
	publicProfileSecret?: ResolverInputTypes["StringCondition"] | undefined | null,
	publicProfileCustomNote?: ResolverInputTypes["StringCondition"] | undefined | null,
	publicProfileCustomNoteEnabled?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	donationConfirmationEmailEnabled?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	signedUp?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	devices?: ResolverInputTypes["DeviceWhere"] | undefined | null,
	processedNotifications?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,
	areaStats?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null,
	organizationStats?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null,
	postStats?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null,
	currencyStats?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null,
	stats?: ResolverInputTypes["UserStatsWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserWhere"] | undefined | null
};
	["UserPaymentWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	cents?: ResolverInputTypes["IntCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	specificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,
	csobPayment?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,
	stripePayment?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethodCondition"] | undefined | null,
	region?: ResolverInputTypes["RegionWhere"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	isReusable?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	onBehalfDonation?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	isSuccessful?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isFinished?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserPaymentWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserPaymentWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserPaymentWhere"] | undefined | null
};
	["UserPaymentOrderIdWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	seq?: ResolverInputTypes["IntCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null
};
	["CsobPaymentWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	payId?: ResolverInputTypes["StringCondition"] | undefined | null,
	statusChanges?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,
	payment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	originalPayId?: ResolverInputTypes["StringCondition"] | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["CsobPaymentWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CsobPaymentWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null
};
	["CsobPaymentStatusChangeWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	dttm?: ResolverInputTypes["StringCondition"] | undefined | null,
	status?: ResolverInputTypes["IntCondition"] | undefined | null,
	resultCode?: ResolverInputTypes["IntCondition"] | undefined | null,
	message?: ResolverInputTypes["StringCondition"] | undefined | null,
	authCode?: ResolverInputTypes["StringCondition"] | undefined | null,
	statusDetail?: ResolverInputTypes["StringCondition"] | undefined | null,
	actions?: ResolverInputTypes["StringCondition"] | undefined | null,
	payment?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null
};
	["CsobPaymentMetadataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	status?: ResolverInputTypes["IntCondition"] | undefined | null,
	isSuccessful?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isFinished?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	resolvedOriginalPayId?: ResolverInputTypes["StringCondition"] | undefined | null,
	csobPayment?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null
};
	["StripePaymentWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	identifier?: ResolverInputTypes["StringCondition"] | undefined | null,
	statusChanges?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,
	payment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["StripePaymentWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["StripePaymentWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["StripePaymentWhere"] | undefined | null
};
	["StripePaymentStatusChangeWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	payment?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,
	timestamp?: ResolverInputTypes["IntCondition"] | undefined | null,
	eventId?: ResolverInputTypes["StringCondition"] | undefined | null,
	paymentIntentStatus?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatusCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null
};
	["StripePaymentStatusChangePaymentIntentStatusCondition"]: {
	and?: Array<ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatusCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatusCondition"]> | undefined | null,
	not?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatusCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	notEq?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	in?: Array<ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"]> | undefined | null,
	lt?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	lte?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	gt?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	gte?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null
};
	["StripePaymentStatusChangePaymentIntentStatus"]:StripePaymentStatusChangePaymentIntentStatus;
	["StripePaymentMetadataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	status?: ResolverInputTypes["IntCondition"] | undefined | null,
	isSuccessful?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isFinished?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	stripePayment?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null
};
	["UserRecurringPaymentItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	recurrenceCounter?: ResolverInputTypes["IntCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	taskId?: ResolverInputTypes["StringCondition"] | undefined | null,
	payments?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,
	isFailed?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	failedEmailSentAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null
};
	["UserRecurringPaymentWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	activeSince?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	cancelledAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	cents?: ResolverInputTypes["IntCondition"] | undefined | null,
	interval?: ResolverInputTypes["UserRecurringPaymentIntervalCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	items?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	meta?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null
};
	["UserRecurringPaymentIntervalCondition"]: {
	and?: Array<ResolverInputTypes["UserRecurringPaymentIntervalCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["UserRecurringPaymentIntervalCondition"]> | undefined | null,
	not?: ResolverInputTypes["UserRecurringPaymentIntervalCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	notEq?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	in?: Array<ResolverInputTypes["UserRecurringPaymentInterval"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["UserRecurringPaymentInterval"]> | undefined | null,
	lt?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	lte?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	gt?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	gte?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null
};
	["UserRecurringPaymentInterval"]:UserRecurringPaymentInterval;
	["UpcomingUserRecurringPaymentMetadataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	recurrenceCounter?: ResolverInputTypes["IntCondition"] | undefined | null,
	isBehindPayments?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	nextPaymentDate?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	shouldBeProcessed?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	firstPayment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	firstSuccessfulPayment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	drivingPayment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null
};
	["UserRecurringPaymentItemMetadataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	isSuccessfullyPaid?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	shouldBeProcessed?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	firstPayment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	lastPayment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	firstSuccessfulPayment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	drivingPayment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null
};
	["UserPaymentMethodCondition"]: {
	and?: Array<ResolverInputTypes["UserPaymentMethodCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["UserPaymentMethodCondition"]> | undefined | null,
	not?: ResolverInputTypes["UserPaymentMethodCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	notEq?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	in?: Array<ResolverInputTypes["UserPaymentMethod"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["UserPaymentMethod"]> | undefined | null,
	lt?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	lte?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	gt?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	gte?: ResolverInputTypes["UserPaymentMethod"] | undefined | null
};
	["UserPaymentMethod"]:UserPaymentMethod;
	["OnBehalfDonationWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	secretCode?: ResolverInputTypes["StringCondition"] | undefined | null,
	specificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	payments?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	onBehalfOf?: ResolverInputTypes["UserWhere"] | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null
};
	["OnBehalfDonationMetadataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	onBehalfOfDonation?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null
};
	["UserPaymentTriesCollectionWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	cents?: ResolverInputTypes["IntCondition"] | undefined | null,
	specificSymbol?: ResolverInputTypes["StringCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	orderUrl?: ResolverInputTypes["StringCondition"] | undefined | null,
	payment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	onBehalfDonation?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,
	recurring?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null,
	metadataLocales?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null,
	medium?: ResolverInputTypes["PaymentMediumCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null
};
	["UserPaymentTriesCollectionMetadataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null
};
	["UserPaymentTriesCollectionMetadataLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	parent?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null
};
	["PaymentMediumCondition"]: {
	and?: Array<ResolverInputTypes["PaymentMediumCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["PaymentMediumCondition"]> | undefined | null,
	not?: ResolverInputTypes["PaymentMediumCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	notEq?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	in?: Array<ResolverInputTypes["PaymentMedium"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["PaymentMedium"]> | undefined | null,
	lt?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	lte?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	gt?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	gte?: ResolverInputTypes["PaymentMedium"] | undefined | null
};
	["PaymentMedium"]:PaymentMedium;
	["UserPaymentMetadataWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	organizationUnfiltered?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	countToUser?: ResolverInputTypes["UserWhere"] | undefined | null,
	paymentType?: ResolverInputTypes["StringCondition"] | undefined | null,
	statusLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	isSuccessful?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isFinished?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	needsCacheUpdate?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isSuccessfulNotCached?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isFinishedNotCached?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	userPayment?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null
};
	["DeviceWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	fcmToken?: ResolverInputTypes["StringCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	ipAddress?: ResolverInputTypes["StringCondition"] | undefined | null,
	userAgent?: ResolverInputTypes["StringCondition"] | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["DeviceWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["DeviceWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["DeviceWhere"] | undefined | null
};
	["UserAreaStatsWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	area?: ResolverInputTypes["PostAreaWhere"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserAreaStatsWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserAreaStatsWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null
};
	["UserOrganizationStatsWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null
};
	["UserPostStatsWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	totalCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserPostStatsWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserPostStatsWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null
};
	["UserCurrencyStatsWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyWhere"] | undefined | null,
	totalAmountPaymentsOnce?: ResolverInputTypes["IntCondition"] | undefined | null,
	totalAmountPaymentsRegular?: ResolverInputTypes["IntCondition"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null
};
	["UserStatsWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	totalPaymentsSuccessful?: ResolverInputTypes["IntCondition"] | undefined | null,
	totalPaymentsUnsuccessful?: ResolverInputTypes["IntCondition"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["UserStatsWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["UserStatsWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["UserStatsWhere"] | undefined | null
};
	["Locale"]: AliasType<{
	_meta?:ResolverInputTypes["LocaleMeta"],
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
generals?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GeneralLocale"]],
genericPages?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageLocale"]],
posts?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostLocale"]],
postAreas?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaLocale"]],
postOrganizations?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
headers?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeaderLocale"]],
footers?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLocale"]],
genericPageAboutSettings?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
postRevisions?: [{	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
flagImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
feedPages?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageLocale"]],
recurringPaymentPages?: [{	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
givenGiftsPages?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
receivedGiftsPages?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
reportPages?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportPageLocale"]],
reportNavigations?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
scheduledNotifications?: [{	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ScheduledNotificationLocale"]],
sentPayments?: [{	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SentPaymentLocale"]],
generalsByRoot?: [{	by: ResolverInputTypes["LocaleGeneralsByRootUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
generalsBySeo?: [{	by: ResolverInputTypes["LocaleGeneralsBySeoUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
generalsByAppStoreLink?: [{	by: ResolverInputTypes["LocaleGeneralsByAppStoreLinkUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
generalsByGooglePlayLink?: [{	by: ResolverInputTypes["LocaleGeneralsByGooglePlayLinkUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
genericPagesByRoot?: [{	by: ResolverInputTypes["LocaleGenericPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
genericPagesByContent?: [{	by: ResolverInputTypes["LocaleGenericPagesByContentUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
genericPagesBySeo?: [{	by: ResolverInputTypes["LocaleGenericPagesBySeoUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
genericPagesByLink?: [{	by: ResolverInputTypes["LocaleGenericPagesByLinkUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
postsByRoot?: [{	by: ResolverInputTypes["LocalePostsByRootUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
postsByContent?: [{	by: ResolverInputTypes["LocalePostsByContentUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
postsBySeo?: [{	by: ResolverInputTypes["LocalePostsBySeoUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
postsByLink?: [{	by: ResolverInputTypes["LocalePostsByLinkUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
postAreasByRoot?: [{	by: ResolverInputTypes["LocalePostAreasByRootUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
postAreasByLink?: [{	by: ResolverInputTypes["LocalePostAreasByLinkUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
postAreasBySeo?: [{	by: ResolverInputTypes["LocalePostAreasBySeoUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
postAreasByBanner?: [{	by: ResolverInputTypes["LocalePostAreasByBannerUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
postAreasByContent?: [{	by: ResolverInputTypes["LocalePostAreasByContentUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
postOrganizationsByRoot?: [{	by: ResolverInputTypes["LocalePostOrganizationsByRootUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
postOrganizationsByLink?: [{	by: ResolverInputTypes["LocalePostOrganizationsByLinkUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
postOrganizationsByDomain?: [{	by: ResolverInputTypes["LocalePostOrganizationsByDomainUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
postOrganizationsBySeo?: [{	by: ResolverInputTypes["LocalePostOrganizationsBySeoUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
postOrganizationsByContent?: [{	by: ResolverInputTypes["LocalePostOrganizationsByContentUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
headersByRoot?: [{	by: ResolverInputTypes["LocaleHeadersByRootUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
headersByLinks?: [{	by: ResolverInputTypes["LocaleHeadersByLinksUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
footersByRoot?: [{	by: ResolverInputTypes["LocaleFootersByRootUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByLinkList?: [{	by: ResolverInputTypes["LocaleFootersByLinkListUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByAddressInfo?: [{	by: ResolverInputTypes["LocaleFootersByAddressInfoUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByImageLinkList?: [{	by: ResolverInputTypes["LocaleFootersByImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
genericPageAboutSettingsByRoot?: [{	by: ResolverInputTypes["LocaleGenericPageAboutSettingsByRootUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
genericPageAboutSettingsByLinkGroups?: [{	by: ResolverInputTypes["LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
postRevisionsByRoot?: [{	by: ResolverInputTypes["LocalePostRevisionsByRootUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
postRevisionsByContent?: [{	by: ResolverInputTypes["LocalePostRevisionsByContentUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
postRevisionsBySeo?: [{	by: ResolverInputTypes["LocalePostRevisionsBySeoUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
postRevisionsByLeadContent?: [{	by: ResolverInputTypes["LocalePostRevisionsByLeadContentUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
feedPagesByRoot?: [{	by: ResolverInputTypes["LocaleFeedPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
feedPagesByHeroTiles?: [{	by: ResolverInputTypes["LocaleFeedPagesByHeroTilesUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
feedPagesBySectionList?: [{	by: ResolverInputTypes["LocaleFeedPagesBySectionListUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
feedPagesByCardList?: [{	by: ResolverInputTypes["LocaleFeedPagesByCardListUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
feedPagesByStoryGuideList?: [{	by: ResolverInputTypes["LocaleFeedPagesByStoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
recurringPaymentPagesByRoot?: [{	by: ResolverInputTypes["LocaleRecurringPaymentPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
recurringPaymentPagesByFavouritePosts?: [{	by: ResolverInputTypes["LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
recurringPaymentPagesByStoryGuideList?: [{	by: ResolverInputTypes["LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
givenGiftsPagesByRoot?: [{	by: ResolverInputTypes["LocaleGivenGiftsPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
givenGiftsPagesByContent?: [{	by: ResolverInputTypes["LocaleGivenGiftsPagesByContentUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
givenGiftsPagesBySeo?: [{	by: ResolverInputTypes["LocaleGivenGiftsPagesBySeoUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
givenGiftsPagesByLink?: [{	by: ResolverInputTypes["LocaleGivenGiftsPagesByLinkUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
receivedGiftsPagesByRoot?: [{	by: ResolverInputTypes["LocaleReceivedGiftsPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
receivedGiftsPagesByLink?: [{	by: ResolverInputTypes["LocaleReceivedGiftsPagesByLinkUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
receivedGiftsPagesByContent?: [{	by: ResolverInputTypes["LocaleReceivedGiftsPagesByContentUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
receivedGiftsPagesBySeo?: [{	by: ResolverInputTypes["LocaleReceivedGiftsPagesBySeoUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
reportPagesByRoot?: [{	by: ResolverInputTypes["LocaleReportPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
reportPagesByLink?: [{	by: ResolverInputTypes["LocaleReportPagesByLinkUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
reportPagesByContent?: [{	by: ResolverInputTypes["LocaleReportPagesByContentUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
reportPagesBySeo?: [{	by: ResolverInputTypes["LocaleReportPagesBySeoUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
reportNavigationsByRoot?: [{	by: ResolverInputTypes["LocaleReportNavigationsByRootUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
scheduledNotificationsByRoot?: [{	by: ResolverInputTypes["LocaleScheduledNotificationsByRootUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null},ResolverInputTypes["ScheduledNotificationLocale"]],
sentPaymentsByRoot?: [{	by: ResolverInputTypes["LocaleSentPaymentsByRootUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null},ResolverInputTypes["SentPaymentLocale"]],
paginateGenerals?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralLocaleConnection"]],
paginateGenericPages?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageLocaleConnection"]],
paginatePosts?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostLocaleConnection"]],
paginatePostAreas?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaLocaleConnection"]],
paginatePostOrganizations?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationLocaleConnection"]],
paginateHeaders?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderLocaleConnection"]],
paginateFooters?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLocaleConnection"]],
paginateGenericPageAboutSettings?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocaleConnection"]],
paginatePostRevisions?: [{	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostRevisionLocaleConnection"]],
paginateFeedPages?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageLocaleConnection"]],
paginateRecurringPaymentPages?: [{	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageLocaleConnection"]],
paginateGivenGiftsPages?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GivenGiftsPageLocaleConnection"]],
paginateReceivedGiftsPages?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocaleConnection"]],
paginateReportPages?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportPageLocaleConnection"]],
paginateReportNavigations?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportNavigationLocaleConnection"]],
paginateScheduledNotifications?: [{	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ScheduledNotificationLocaleConnection"]],
paginateSentPayments?: [{	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SentPaymentLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	code?:ResolverInputTypes["FieldMeta"],
	label?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	generals?:ResolverInputTypes["FieldMeta"],
	genericPages?:ResolverInputTypes["FieldMeta"],
	posts?:ResolverInputTypes["FieldMeta"],
	postAreas?:ResolverInputTypes["FieldMeta"],
	postOrganizations?:ResolverInputTypes["FieldMeta"],
	headers?:ResolverInputTypes["FieldMeta"],
	footers?:ResolverInputTypes["FieldMeta"],
	genericPageAboutSettings?:ResolverInputTypes["FieldMeta"],
	postRevisions?:ResolverInputTypes["FieldMeta"],
	flagImage?:ResolverInputTypes["FieldMeta"],
	feedPages?:ResolverInputTypes["FieldMeta"],
	recurringPaymentPages?:ResolverInputTypes["FieldMeta"],
	givenGiftsPages?:ResolverInputTypes["FieldMeta"],
	receivedGiftsPages?:ResolverInputTypes["FieldMeta"],
	reportPages?:ResolverInputTypes["FieldMeta"],
	reportNavigations?:ResolverInputTypes["FieldMeta"],
	scheduledNotifications?:ResolverInputTypes["FieldMeta"],
	sentPayments?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["GeneralOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	appStoreLink?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	allAreasDescription?: ResolverInputTypes["OrderDirection"] | undefined | null,
	allOrganizationsDescription?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["OrderDirection"]:OrderDirection;
	["GeneralOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	allAreasIcon?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	allOrganizationsIcon?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListOrderBy"] | undefined | null
};
	["ImageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	url?: ResolverInputTypes["OrderDirection"] | undefined | null,
	width?: ResolverInputTypes["OrderDirection"] | undefined | null,
	height?: ResolverInputTypes["OrderDirection"] | undefined | null,
	size?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	alt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fileName?: ResolverInputTypes["OrderDirection"] | undefined | null,
	focalPointX?: ResolverInputTypes["OrderDirection"] | undefined | null,
	focalPointY?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostOrganizationListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["LocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	code?: ResolverInputTypes["OrderDirection"] | undefined | null,
	label?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	flagImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["SeoOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	description?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ogTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ogDescription?: ResolverInputTypes["OrderDirection"] | undefined | null,
	noIndex?: ResolverInputTypes["OrderDirection"] | undefined | null,
	noFollow?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ogImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["LinkOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	externalLink?: ResolverInputTypes["OrderDirection"] | undefined | null,
	internalLink?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	isTargetBlank?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["LinkableOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	url?: ResolverInputTypes["OrderDirection"] | undefined | null,
	genericPage?: ResolverInputTypes["GenericPageLocaleOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostLocaleOrderBy"] | undefined | null,
	postArea?: ResolverInputTypes["PostAreaLocaleOrderBy"] | undefined | null,
	postOrganization?: ResolverInputTypes["PostOrganizationLocaleOrderBy"] | undefined | null,
	reportPage?: ResolverInputTypes["ReportPageLocaleOrderBy"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["GivenGiftsPageLocaleOrderBy"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"] | undefined | null
};
	["GenericPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["GenericPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["GenericPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ContentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	root?: ResolverInputTypes["PostOrderBy"] | undefined | null,
	paymentName?: ResolverInputTypes["OrderDirection"] | undefined | null,
	publishedAt?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	specificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	activeRevision?: ResolverInputTypes["PostRevisionOrderBy"] | undefined | null,
	isPinnedInArea?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isPinnedInOrganization?: ResolverInputTypes["OrderDirection"] | undefined | null,
	state?: ResolverInputTypes["OrderDirection"] | undefined | null,
	meta?: ResolverInputTypes["PostMetaDataOrderBy"] | undefined | null,
	isPublishedAtHidden?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fundraiseIsActive?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fundraiseTargetAmount?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fundraiseFakeAddOnAmount?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostSumOrderBy"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostFundraisingProgressOrderBy"] | undefined | null
};
	["PostOrganizationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	icon?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	specificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationMetaDataOrderBy"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	isHidden?: ResolverInputTypes["OrderDirection"] | undefined | null,
	color?: ResolverInputTypes["OrderDirection"] | undefined | null,
	plainIcon?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationSumOrderBy"] | undefined | null
};
	["PostAreaOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	icon?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	regionListOverride?: ResolverInputTypes["DonationAmountsRegionListOrderBy"] | undefined | null,
	color?: ResolverInputTypes["OrderDirection"] | undefined | null,
	specificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	region?: ResolverInputTypes["RegionOrderBy"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaMetaDataOrderBy"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	plainIcon?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaSentPaymentSumOrderBy"] | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaSumOrderBy"] | undefined | null
};
	["DonationAmountsRegionListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	donation?: ResolverInputTypes["DonationOrderBy"] | undefined | null
};
	["DonationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	regionList?: ResolverInputTypes["DonationAmountsRegionListOrderBy"] | undefined | null
};
	["RegionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	code?: ResolverInputTypes["OrderDirection"] | undefined | null,
	label?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	timezone?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["CurrencyOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	identifier?: ResolverInputTypes["OrderDirection"] | undefined | null,
	label?: ResolverInputTypes["OrderDirection"] | undefined | null,
	sign?: ResolverInputTypes["OrderDirection"] | undefined | null,
	signAlignment?: ResolverInputTypes["OrderDirection"] | undefined | null,
	defaultDonationAmount?: ResolverInputTypes["OrderDirection"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostAreaMetaDataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	nameWithFallback?: ResolverInputTypes["OrderDirection"] | undefined | null,
	formattedSpecificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fullFormattedSpecificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null
};
	["PostAreaSentPaymentSumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	czkPercentage?: ResolverInputTypes["OrderDirection"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null
};
	["PostAreaSumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	czkPercentage?: ResolverInputTypes["OrderDirection"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null
};
	["PostOrganizationMetaDataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	nameWithFallback?: ResolverInputTypes["OrderDirection"] | undefined | null,
	formattedSpecificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fullFormattedSpecificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null
};
	["PostOrganizationSumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	czkPercentage?: ResolverInputTypes["OrderDirection"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null
};
	["PostRevisionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdById?: ResolverInputTypes["OrderDirection"] | undefined | null,
	publishedById?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	publishedAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null,
	tileImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	tileVideo?: ResolverInputTypes["VideoOrderBy"] | undefined | null,
	heroImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	regionListOverride?: ResolverInputTypes["DonationAmountsRegionListOrderBy"] | undefined | null,
	isOrganizationVisible?: ResolverInputTypes["OrderDirection"] | undefined | null,
	sendPublishNotifications?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isArchived?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["VideoOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	url?: ResolverInputTypes["OrderDirection"] | undefined | null,
	width?: ResolverInputTypes["OrderDirection"] | undefined | null,
	height?: ResolverInputTypes["OrderDirection"] | undefined | null,
	size?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	poster?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	shapeType?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostMetaDataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	titleWithFallback?: ResolverInputTypes["OrderDirection"] | undefined | null,
	formattedSpecificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fullFormattedSpecificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	latestRevision?: ResolverInputTypes["PostRevisionOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null
};
	["PostSumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	czkPercentage?: ResolverInputTypes["OrderDirection"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null
};
	["PostFundraisingProgressOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	progress?: ResolverInputTypes["OrderDirection"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null
};
	["PostAreaLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	description?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	root?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	banner?: ResolverInputTypes["AppBannerOrderBy"] | undefined | null,
	shortDescription?: ResolverInputTypes["OrderDirection"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	translatedByAI?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["AppBannerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	imageSmall?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	imageBig?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	textContent?: ResolverInputTypes["ContentOrderBy"] | undefined | null
};
	["PostOrganizationLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	description?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	root?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	domain?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	translatedByAI?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ReportPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	postTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	giftTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	root?: ResolverInputTypes["ReportPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null
};
	["ReportPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["GivenGiftsPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	giftTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	giftText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	note?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null
};
	["GivenGiftsPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ReceivedGiftsPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	giftTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	giftText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	note?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null
};
	["ReceivedGiftsPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["GenericPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["GenericPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
	subtitle?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPage"]: AliasType<{
	_meta?:ResolverInputTypes["GenericPageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageLocale"]],
	type?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
reportNavigation?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["GenericPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
localesByContent?: [{	by: ResolverInputTypes["GenericPageLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["GenericPageLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
localesByLink?: [{	by: ResolverInputTypes["GenericPageLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageLocaleConnection"]],
paginateReportNavigation?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportNavigationLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	reportNavigation?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocale"]: AliasType<{
	_meta?:ResolverInputTypes["ReportNavigationLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null},ResolverInputTypes["ReportNavigation"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
pages?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPage"]],
paginatePages?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	pages?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigation"]: AliasType<{
	_meta?:ResolverInputTypes["ReportNavigationMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["ReportNavigationLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportNavigationLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["ReportNavigationOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null
};
	["ReportNavigationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ReportNavigationLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["LocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	generals?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	genericPages?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	posts?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	postAreas?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	postOrganizations?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	headers?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	footers?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	genericPageAboutSettings?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	postRevisions?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	feedPages?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	recurringPaymentPages?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	givenGiftsPages?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	receivedGiftsPages?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	reportPages?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	reportNavigations?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	scheduledNotifications?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	sentPayments?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null
};
	["GeneralLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GeneralUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	appStoreLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["GeneralUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	allAreasIcon?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	allOrganizationsIcon?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null
};
	["ImageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["PostOrganizationListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["PostOrganizationListItemUniqueWhere"] | undefined | null
};
	["PostOrganizationListItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LinkUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["SeoUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	ogImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["GenericPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["GenericPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null
};
	["ContentUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	blocks?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null
};
	["ContentBlockUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	references?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null
};
	["ContentReferenceUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	linkables?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	valueList?: ResolverInputTypes["ValueListUniqueWhere"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null,
	areaList?: ResolverInputTypes["PostAreaListUniqueWhere"] | undefined | null,
	accordion?: ResolverInputTypes["AccordionUniqueWhere"] | undefined | null,
	media?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	memberList?: ResolverInputTypes["MemberListUniqueWhere"] | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	textImageList?: ResolverInputTypes["TextImageListUniqueWhere"] | undefined | null
};
	["ContentReferenceLinkableItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	item?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LinkableUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	post?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	postArea?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	postOrganization?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	reportPage?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null
};
	["PostLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["PostUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	revisions?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	locales?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	meta?: ResolverInputTypes["PostMetaDataUniqueWhere"] | undefined | null,
	fundraiseCurrencySums?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostSumUniqueWhere"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostFundraisingProgressUniqueWhere"] | undefined | null
};
	["PostRevisionUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	regionListOverride?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null
};
	["PostRevisionLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	leadContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["DonationAmountsRegionListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	regions?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	donation?: ResolverInputTypes["DonationUniqueWhere"] | undefined | null
};
	["DonationAmountsRegionItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	region?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	items?: ResolverInputTypes["DonationAmountItemUniqueWhere"] | undefined | null
};
	["RegionUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	enabledPaymentMethods?: ResolverInputTypes["RegionPaymentMethodUniqueWhere"] | undefined | null,
	donationItems?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null
};
	["RegionPaymentMethodUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	region?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	method?: ResolverInputTypes["PaymentMethods"] | undefined | null
};
	["DonationAmountItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["DonationUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	regionList?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null
};
	["PostMetaDataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	latestRevision?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	post?: ResolverInputTypes["PostUniqueWhere"] | undefined | null
};
	["PostCurrencySumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["PostSumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	post?: ResolverInputTypes["PostUniqueWhere"] | undefined | null
};
	["PostFundraisingProgressUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	post?: ResolverInputTypes["PostUniqueWhere"] | undefined | null
};
	["PostAreaLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	banner?: ResolverInputTypes["AppBannerUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["PostAreaUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	specificSymbol?: number | undefined | null,
	locales?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	regionListOverride?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	posts?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaMetaDataUniqueWhere"] | undefined | null,
	sentPayments?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	areaSentPaymentCurrencySums?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined | null,
	areaCurrencySums?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaSumUniqueWhere"] | undefined | null
};
	["PostAreaMetaDataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	area?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null
};
	["SentPaymentUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null
};
	["SentPaymentLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["PostAreaSentPaymentCurrencySumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["PostAreaSentPaymentSumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	area?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null
};
	["PostAreaCurrencySumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["PostAreaSumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	area?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null
};
	["AppBannerUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	textContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["PostOrganizationLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	domain?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["PostOrganizationUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	specificSymbol?: number | undefined | null,
	posts?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	locales?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationMetaDataUniqueWhere"] | undefined | null,
	sentPayments?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	organizationCurrencySums?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationSumUniqueWhere"] | undefined | null
};
	["PostOrganizationMetaDataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null
};
	["PostOrganizationCurrencySumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["PostOrganizationSumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null
};
	["ReportPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["ReportPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["ReportPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null
};
	["GivenGiftsPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["GivenGiftsPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null
};
	["ReceivedGiftsPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["ReceivedGiftsPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null
};
	["ValueListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["ValueItemUniqueWhere"] | undefined | null
};
	["ValueItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["ImageLinkListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["ImageLinkItemUniqueWhere"] | undefined | null
};
	["ImageLinkItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["PostAreaListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["PostAreaListItemUniqueWhere"] | undefined | null
};
	["PostAreaListItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["AccordionUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["AccordionItemUniqueWhere"] | undefined | null
};
	["AccordionItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	descriptionContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["MediumListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null
};
	["MediumItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["MemberListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["MemberListItemUniqueWhere"] | undefined | null
};
	["MemberListItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	descriptionContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["TextImageListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["TextImageListItemUniqueWhere"] | undefined | null
};
	["TextImageListItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["HeaderLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["HeaderUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	links?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null
};
	["HeaderUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null
};
	["LinkListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["LinkItemUniqueWhere"] | undefined | null
};
	["LinkItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FooterLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["FooterUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	linkList?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	addressInfo?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null
};
	["FooterUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null
};
	["GenericPageAboutSettingsLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	linkGroups?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null
};
	["GenericPageAboutSettingsUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null
};
	["GenericPageAboutGroupLinksLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	linkList?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null
};
	["FeedPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["FeedPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	heroTiles?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null,
	sectionList?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null,
	cardList?: ResolverInputTypes["CardListUniqueWhere"] | undefined | null,
	storyGuideList?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null
};
	["FeedPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null
};
	["TileListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["TileItemUniqueWhere"] | undefined | null
};
	["TileItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FeedPageSectionUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tileStripeList?: ResolverInputTypes["FeedPageTileStripeUniqueWhere"] | undefined | null
};
	["FeedPageTileStripeUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["CardListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["CardItemUniqueWhere"] | undefined | null
};
	["CardItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["StoryGuideListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["StoryGuideItemUniqueWhere"] | undefined | null
};
	["StoryGuideItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["RecurringPaymentPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["RecurringPaymentPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	favouritePosts?: ResolverInputTypes["PostListUniqueWhere"] | undefined | null,
	storyGuideList?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null
};
	["RecurringPaymentPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null
};
	["PostListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["PostListItemUniqueWhere"] | undefined | null
};
	["PostListItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["ReportNavigationLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["ReportNavigationUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["ReportNavigationUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null
};
	["ScheduledNotificationLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["ScheduledNotificationUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["ScheduledNotificationUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	processedNotifications?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null
};
	["ProcessedNotificationSourceUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationUniqueWhere"] | undefined | null
};
	["ProcessedNotificationUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	source?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null
};
	["ReportNavigationLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ReportNavigationLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PageInfo"]: AliasType<{
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["ReportNavigationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GenericPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageEdge"]: AliasType<{
	node?:ResolverInputTypes["GenericPage"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["GenericPageLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["GenericPageLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["GenericPageLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["GenericPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GenericPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["GenericPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Content"]: AliasType<{
	_meta?:ResolverInputTypes["ContentMeta"],
	id?:boolean | `@${string}`,
blocks?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentBlock"]],
blocksByReferences?: [{	by: ResolverInputTypes["ContentBlocksByReferencesUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlock"]],
paginateBlocks?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentBlockConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	blocks?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ResolverInputTypes["ContentBlockMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	json?:boolean | `@${string}`,
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
references?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByLinkables?: [{	by: ResolverInputTypes["ContentBlockReferencesByLinkablesUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByLink?: [{	by: ResolverInputTypes["ContentBlockReferencesByLinkUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByValueList?: [{	by: ResolverInputTypes["ContentBlockReferencesByValueListUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByImageLinkList?: [{	by: ResolverInputTypes["ContentBlockReferencesByImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByAreaList?: [{	by: ResolverInputTypes["ContentBlockReferencesByAreaListUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByAccordion?: [{	by: ResolverInputTypes["ContentBlockReferencesByAccordionUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByMedia?: [{	by: ResolverInputTypes["ContentBlockReferencesByMediaUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByMemberList?: [{	by: ResolverInputTypes["ContentBlockReferencesByMemberListUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByContentWithoutBlocks?: [{	by: ResolverInputTypes["ContentBlockReferencesByContentWithoutBlocksUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByOrganizationList?: [{	by: ResolverInputTypes["ContentBlockReferencesByOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByTextImageList?: [{	by: ResolverInputTypes["ContentBlockReferencesByTextImageListUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
paginateReferences?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	json?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	references?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReference"]: AliasType<{
	_meta?:ResolverInputTypes["ContentReferenceMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	primaryText?:boolean | `@${string}`,
block?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlock"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
linkables?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
video?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
	secondaryText?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
	contentAlignment?:boolean | `@${string}`,
valueList?: [{	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null},ResolverInputTypes["ValueList"]],
imageLinkList?: [{	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null},ResolverInputTypes["ImageLinkList"]],
areaList?: [{	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null},ResolverInputTypes["PostAreaList"]],
	isAppsVisible?:boolean | `@${string}`,
accordion?: [{	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null},ResolverInputTypes["Accordion"]],
media?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
memberList?: [{	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null},ResolverInputTypes["MemberList"]],
	asideMediaContentLayout?:boolean | `@${string}`,
	isAsideMediaContentMobileLayout?:boolean | `@${string}`,
form?: [{	filter?: ResolverInputTypes["FormWhere"] | undefined | null},ResolverInputTypes["Form"]],
	isTitleBigger?:boolean | `@${string}`,
contentWithoutBlocks?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
heroCarousel?: [{	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null},ResolverInputTypes["HeroCarousel"]],
organizationList?: [{	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null},ResolverInputTypes["PostOrganizationList"]],
	isCentered?:boolean | `@${string}`,
posts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Post"]],
textImageList?: [{	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null},ResolverInputTypes["TextImageList"]],
linkablesByItem?: [{	by: ResolverInputTypes["ContentReferenceLinkablesByItemUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
paginateLinkables?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItemConnection"]],
paginatePosts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	primaryText?:ResolverInputTypes["FieldMeta"],
	block?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	linkables?:ResolverInputTypes["FieldMeta"],
	video?:ResolverInputTypes["FieldMeta"],
	secondaryText?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	contentAlignment?:ResolverInputTypes["FieldMeta"],
	valueList?:ResolverInputTypes["FieldMeta"],
	imageLinkList?:ResolverInputTypes["FieldMeta"],
	areaList?:ResolverInputTypes["FieldMeta"],
	isAppsVisible?:ResolverInputTypes["FieldMeta"],
	accordion?:ResolverInputTypes["FieldMeta"],
	media?:ResolverInputTypes["FieldMeta"],
	memberList?:ResolverInputTypes["FieldMeta"],
	asideMediaContentLayout?:ResolverInputTypes["FieldMeta"],
	isAsideMediaContentMobileLayout?:ResolverInputTypes["FieldMeta"],
	form?:ResolverInputTypes["FieldMeta"],
	isTitleBigger?:ResolverInputTypes["FieldMeta"],
	contentWithoutBlocks?:ResolverInputTypes["FieldMeta"],
	heroCarousel?:ResolverInputTypes["FieldMeta"],
	organizationList?:ResolverInputTypes["FieldMeta"],
	isCentered?:ResolverInputTypes["FieldMeta"],
	posts?:ResolverInputTypes["FieldMeta"],
	textImageList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Image"]: AliasType<{
	_meta?:ResolverInputTypes["ImageMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	alt?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	focalPointX?:boolean | `@${string}`,
	focalPointY?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	url?:ResolverInputTypes["FieldMeta"],
	width?:ResolverInputTypes["FieldMeta"],
	height?:ResolverInputTypes["FieldMeta"],
	size?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	alt?:ResolverInputTypes["FieldMeta"],
	fileName?:ResolverInputTypes["FieldMeta"],
	focalPointX?:ResolverInputTypes["FieldMeta"],
	focalPointY?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItem"]: AliasType<{
	_meta?:ResolverInputTypes["ContentReferenceLinkableItemMeta"],
	id?:boolean | `@${string}`,
item?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
reference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	item?:ResolverInputTypes["FieldMeta"],
	reference?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Linkable"]: AliasType<{
	_meta?:ResolverInputTypes["LinkableMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
genericPage?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
post?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
postArea?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
postOrganization?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
reportPage?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
givenGiftsPage?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
receivedGiftsPage?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkableMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	url?:ResolverInputTypes["FieldMeta"],
	genericPage?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
	postArea?:ResolverInputTypes["FieldMeta"],
	postOrganization?:ResolverInputTypes["FieldMeta"],
	reportPage?:ResolverInputTypes["FieldMeta"],
	givenGiftsPage?:ResolverInputTypes["FieldMeta"],
	receivedGiftsPage?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocale"]: AliasType<{
	_meta?:ResolverInputTypes["PostLocaleMeta"],
	id?:boolean | `@${string}`,
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
root?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
	paymentName?:boolean | `@${string}`,
	publishedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	paymentName?:ResolverInputTypes["FieldMeta"],
	publishedAt?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Seo"]: AliasType<{
	_meta?:ResolverInputTypes["SeoMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	ogTitle?:boolean | `@${string}`,
	ogDescription?:boolean | `@${string}`,
	noIndex?:boolean | `@${string}`,
	noFollow?:boolean | `@${string}`,
ogImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	description?:ResolverInputTypes["FieldMeta"],
	ogTitle?:ResolverInputTypes["FieldMeta"],
	ogDescription?:ResolverInputTypes["FieldMeta"],
	noIndex?:ResolverInputTypes["FieldMeta"],
	noFollow?:ResolverInputTypes["FieldMeta"],
	ogImage?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Post"]: AliasType<{
	_meta?:ResolverInputTypes["PostMeta"],
	id?:boolean | `@${string}`,
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
	specificSymbol?:boolean | `@${string}`,
activeRevision?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevision"]],
revisions?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostRevision"]],
locales?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostLocale"]],
	isPinnedInArea?:boolean | `@${string}`,
	isPinnedInOrganization?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
meta?: [{	filter?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null},ResolverInputTypes["PostMetaData"]],
	isPublishedAtHidden?:boolean | `@${string}`,
heroCarousel?: [{	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeroCarousel"]],
reportPage?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportPageLocale"]],
content?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReference"]],
	fundraiseIsActive?:boolean | `@${string}`,
	fundraiseEndDate?:boolean | `@${string}`,
	fundraiseTargetAmount?:boolean | `@${string}`,
	fundraiseFakeAddOnAmount?:boolean | `@${string}`,
fundraiseCurrency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
fundraiseCurrencySums?: [{	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostCurrencySum"]],
fundraiseSum?: [{	filter?: ResolverInputTypes["PostSumWhere"] | undefined | null},ResolverInputTypes["PostSum"]],
fundraisingProgress?: [{	filter?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null},ResolverInputTypes["PostFundraisingProgress"]],
revisionsByLocales?: [{	by: ResolverInputTypes["PostRevisionsByLocalesUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevision"]],
revisionsByRegionListOverride?: [{	by: ResolverInputTypes["PostRevisionsByRegionListOverrideUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevision"]],
localesByLocale?: [{	by: ResolverInputTypes["PostLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
localesByContent?: [{	by: ResolverInputTypes["PostLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["PostLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
localesByLink?: [{	by: ResolverInputTypes["PostLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
paginateRevisions?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostRevisionConnection"]],
paginateLocales?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostLocaleConnection"]],
paginateHeroCarousel?: [{	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeroCarouselConnection"]],
paginateReportPage?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportPageLocaleConnection"]],
paginateContent?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceConnection"]],
paginateFundraiseCurrencySums?: [{	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostCurrencySumConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
	specificSymbol?:ResolverInputTypes["FieldMeta"],
	activeRevision?:ResolverInputTypes["FieldMeta"],
	revisions?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	isPinnedInArea?:ResolverInputTypes["FieldMeta"],
	isPinnedInOrganization?:ResolverInputTypes["FieldMeta"],
	state?:ResolverInputTypes["FieldMeta"],
	meta?:ResolverInputTypes["FieldMeta"],
	isPublishedAtHidden?:ResolverInputTypes["FieldMeta"],
	heroCarousel?:ResolverInputTypes["FieldMeta"],
	reportPage?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	fundraiseIsActive?:ResolverInputTypes["FieldMeta"],
	fundraiseEndDate?:ResolverInputTypes["FieldMeta"],
	fundraiseTargetAmount?:ResolverInputTypes["FieldMeta"],
	fundraiseFakeAddOnAmount?:ResolverInputTypes["FieldMeta"],
	fundraiseCurrency?:ResolverInputTypes["FieldMeta"],
	fundraiseCurrencySums?:ResolverInputTypes["FieldMeta"],
	fundraiseSum?:ResolverInputTypes["FieldMeta"],
	fundraisingProgress?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganization"]: AliasType<{
	_meta?:ResolverInputTypes["PostOrganizationMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
posts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Post"]],
icon?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
locales?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
	specificSymbol?:boolean | `@${string}`,
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
meta?: [{	filter?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null},ResolverInputTypes["PostOrganizationMetaData"]],
mobileHeroImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	isHidden?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
plainIcon?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
desktopHeroImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
sentPayments?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SentPayment"]],
organizationCurrencySums?: [{	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationCurrencySum"]],
organizationSum?: [{	filter?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null},ResolverInputTypes["PostOrganizationSum"]],
postsBySpecificSymbol?: [{	by: ResolverInputTypes["PostOrganizationPostsBySpecificSymbolUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByActiveRevision?: [{	by: ResolverInputTypes["PostOrganizationPostsByActiveRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByRevisions?: [{	by: ResolverInputTypes["PostOrganizationPostsByRevisionsUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByLocales?: [{	by: ResolverInputTypes["PostOrganizationPostsByLocalesUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByMeta?: [{	by: ResolverInputTypes["PostOrganizationPostsByMetaUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByFundraiseCurrencySums?: [{	by: ResolverInputTypes["PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByFundraiseSum?: [{	by: ResolverInputTypes["PostOrganizationPostsByFundraiseSumUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByFundraisingProgress?: [{	by: ResolverInputTypes["PostOrganizationPostsByFundraisingProgressUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
localesByLocale?: [{	by: ResolverInputTypes["PostOrganizationLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
localesByLink?: [{	by: ResolverInputTypes["PostOrganizationLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
localesByDomain?: [{	by: ResolverInputTypes["PostOrganizationLocalesByDomainUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["PostOrganizationLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
localesByContent?: [{	by: ResolverInputTypes["PostOrganizationLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
sentPaymentsByLocales?: [{	by: ResolverInputTypes["PostOrganizationSentPaymentsByLocalesUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null},ResolverInputTypes["SentPayment"]],
paginatePosts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostConnection"]],
paginateLocales?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationLocaleConnection"]],
paginateSentPayments?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SentPaymentConnection"]],
paginateOrganizationCurrencySums?: [{	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationCurrencySumConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	posts?:ResolverInputTypes["FieldMeta"],
	icon?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	specificSymbol?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
	meta?:ResolverInputTypes["FieldMeta"],
	mobileHeroImage?:ResolverInputTypes["FieldMeta"],
	isHidden?:ResolverInputTypes["FieldMeta"],
	color?:ResolverInputTypes["FieldMeta"],
	plainIcon?:ResolverInputTypes["FieldMeta"],
	desktopHeroImage?:ResolverInputTypes["FieldMeta"],
	sentPayments?:ResolverInputTypes["FieldMeta"],
	organizationCurrencySums?:ResolverInputTypes["FieldMeta"],
	organizationSum?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocale"]: AliasType<{
	_meta?:ResolverInputTypes["PostOrganizationLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
root?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
domain?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
	translatedByAI?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	description?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	domain?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	translatedByAI?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Link"]: AliasType<{
	_meta?:ResolverInputTypes["LinkMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	externalLink?:boolean | `@${string}`,
internalLink?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
	isTargetBlank?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LinkMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	externalLink?:ResolverInputTypes["FieldMeta"],
	internalLink?:ResolverInputTypes["FieldMeta"],
	isTargetBlank?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostArea"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
icon?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
locales?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaLocale"]],
regionListOverride?: [{	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionList"]],
	color?:boolean | `@${string}`,
posts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Post"]],
	specificSymbol?:boolean | `@${string}`,
region?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["Region"]],
meta?: [{	filter?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null},ResolverInputTypes["PostAreaMetaData"]],
mobileHeroImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
plainIcon?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
sentPayments?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SentPayment"]],
areaSentPaymentCurrencySums?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySum"]],
areaSentPaymentSum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null},ResolverInputTypes["PostAreaSentPaymentSum"]],
areaCurrencySums?: [{	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaCurrencySum"]],
areaSum?: [{	filter?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null},ResolverInputTypes["PostAreaSum"]],
localesByLocale?: [{	by: ResolverInputTypes["PostAreaLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
localesByLink?: [{	by: ResolverInputTypes["PostAreaLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["PostAreaLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
localesByBanner?: [{	by: ResolverInputTypes["PostAreaLocalesByBannerUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
localesByContent?: [{	by: ResolverInputTypes["PostAreaLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
postsBySpecificSymbol?: [{	by: ResolverInputTypes["PostAreaPostsBySpecificSymbolUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByActiveRevision?: [{	by: ResolverInputTypes["PostAreaPostsByActiveRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByRevisions?: [{	by: ResolverInputTypes["PostAreaPostsByRevisionsUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByLocales?: [{	by: ResolverInputTypes["PostAreaPostsByLocalesUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByMeta?: [{	by: ResolverInputTypes["PostAreaPostsByMetaUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByFundraiseCurrencySums?: [{	by: ResolverInputTypes["PostAreaPostsByFundraiseCurrencySumsUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByFundraiseSum?: [{	by: ResolverInputTypes["PostAreaPostsByFundraiseSumUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
postsByFundraisingProgress?: [{	by: ResolverInputTypes["PostAreaPostsByFundraisingProgressUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
sentPaymentsByLocales?: [{	by: ResolverInputTypes["PostAreaSentPaymentsByLocalesUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null},ResolverInputTypes["SentPayment"]],
paginateLocales?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaLocaleConnection"]],
paginatePosts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostConnection"]],
paginateSentPayments?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SentPaymentConnection"]],
paginateAreaSentPaymentCurrencySums?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySumConnection"]],
paginateAreaCurrencySums?: [{	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaCurrencySumConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	icon?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	regionListOverride?:ResolverInputTypes["FieldMeta"],
	color?:ResolverInputTypes["FieldMeta"],
	posts?:ResolverInputTypes["FieldMeta"],
	specificSymbol?:ResolverInputTypes["FieldMeta"],
	region?:ResolverInputTypes["FieldMeta"],
	meta?:ResolverInputTypes["FieldMeta"],
	mobileHeroImage?:ResolverInputTypes["FieldMeta"],
	plainIcon?:ResolverInputTypes["FieldMeta"],
	sentPayments?:ResolverInputTypes["FieldMeta"],
	areaSentPaymentCurrencySums?:ResolverInputTypes["FieldMeta"],
	areaSentPaymentSum?:ResolverInputTypes["FieldMeta"],
	areaCurrencySums?:ResolverInputTypes["FieldMeta"],
	areaSum?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocale"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
root?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
banner?: [{	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null},ResolverInputTypes["AppBanner"]],
	shortDescription?:boolean | `@${string}`,
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
	translatedByAI?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	description?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	banner?:ResolverInputTypes["FieldMeta"],
	shortDescription?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	translatedByAI?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AppBanner"]: AliasType<{
	_meta?:ResolverInputTypes["AppBannerMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
imageSmall?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
imageBig?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
textContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	imageSmall?:ResolverInputTypes["FieldMeta"],
	imageBig?:ResolverInputTypes["FieldMeta"],
	textContent?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionList"]: AliasType<{
	_meta?:ResolverInputTypes["DonationAmountsRegionListMeta"],
	id?:boolean | `@${string}`,
regions?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
donation?: [{	filter?: ResolverInputTypes["DonationWhere"] | undefined | null},ResolverInputTypes["Donation"]],
regionsByRegion?: [{	by: ResolverInputTypes["DonationAmountsRegionListRegionsByRegionUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
regionsByItems?: [{	by: ResolverInputTypes["DonationAmountsRegionListRegionsByItemsUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
paginateRegions?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	regions?:ResolverInputTypes["FieldMeta"],
	donation?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItem"]: AliasType<{
	_meta?:ResolverInputTypes["DonationAmountsRegionItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountItem"]],
list?: [{	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionList"]],
region?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["Region"]],
	minimumAmount?:boolean | `@${string}`,
paginateItems?: [{	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	region?:ResolverInputTypes["FieldMeta"],
	minimumAmount?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItem"]: AliasType<{
	_meta?:ResolverInputTypes["DonationAmountItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
regionItem?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	amount?:ResolverInputTypes["FieldMeta"],
	regionItem?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	amount?: ResolverInputTypes["OrderDirection"] | undefined | null,
	regionItem?: ResolverInputTypes["DonationAmountsRegionItemOrderBy"] | undefined | null
};
	["DonationAmountsRegionItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionListOrderBy"] | undefined | null,
	region?: ResolverInputTypes["RegionOrderBy"] | undefined | null,
	minimumAmount?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["Region"]: AliasType<{
	_meta?:ResolverInputTypes["RegionMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
enabledPaymentMethods?: [{	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionPaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RegionPaymentMethod"]],
donationItems?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
	timezone?:boolean | `@${string}`,
enabledPaymentMethodsByMethod?: [{	by: ResolverInputTypes["RegionEnabledPaymentMethodsByMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null},ResolverInputTypes["RegionPaymentMethod"]],
donationItemsByList?: [{	by: ResolverInputTypes["RegionDonationItemsByListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
donationItemsByItems?: [{	by: ResolverInputTypes["RegionDonationItemsByItemsUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
paginateEnabledPaymentMethods?: [{	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionPaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RegionPaymentMethodConnection"]],
paginateDonationItems?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["RegionMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	code?:ResolverInputTypes["FieldMeta"],
	label?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	enabledPaymentMethods?:ResolverInputTypes["FieldMeta"],
	donationItems?:ResolverInputTypes["FieldMeta"],
	timezone?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Currency"]: AliasType<{
	_meta?:ResolverInputTypes["CurrencyMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	sign?:boolean | `@${string}`,
	signAlignment?:boolean | `@${string}`,
	defaultDonationAmount?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
areaSentPaymentCurrencySums?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySum"]],
areaCurrencySums?: [{	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaCurrencySum"]],
organizationCurrencySums?: [{	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationCurrencySum"]],
postCurrencySums?: [{	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostCurrencySum"]],
paginateAreaSentPaymentCurrencySums?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySumConnection"]],
paginateAreaCurrencySums?: [{	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaCurrencySumConnection"]],
paginateOrganizationCurrencySums?: [{	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationCurrencySumConnection"]],
paginatePostCurrencySums?: [{	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostCurrencySumConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	identifier?:ResolverInputTypes["FieldMeta"],
	label?:ResolverInputTypes["FieldMeta"],
	sign?:ResolverInputTypes["FieldMeta"],
	signAlignment?:ResolverInputTypes["FieldMeta"],
	defaultDonationAmount?:ResolverInputTypes["FieldMeta"],
	rateAgainstCzk?:ResolverInputTypes["FieldMeta"],
	areaSentPaymentCurrencySums?:ResolverInputTypes["FieldMeta"],
	areaCurrencySums?:ResolverInputTypes["FieldMeta"],
	organizationCurrencySums?:ResolverInputTypes["FieldMeta"],
	postCurrencySums?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentCurrencySum"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaSentPaymentCurrencySumMeta"],
	id?:boolean | `@${string}`,
	currencyIdentifier?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentCurrencySumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	currencyIdentifier?:ResolverInputTypes["FieldMeta"],
	rateAgainstCzk?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentCurrencySumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currencyIdentifier?: ResolverInputTypes["OrderDirection"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null
};
	["PostAreaCurrencySum"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaCurrencySumMeta"],
	id?:boolean | `@${string}`,
	currencyIdentifier?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCurrencySumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	currencyIdentifier?:ResolverInputTypes["FieldMeta"],
	rateAgainstCzk?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCurrencySumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currencyIdentifier?: ResolverInputTypes["OrderDirection"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null
};
	["PostOrganizationCurrencySum"]: AliasType<{
	_meta?:ResolverInputTypes["PostOrganizationCurrencySumMeta"],
	id?:boolean | `@${string}`,
	currencyIdentifier?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCurrencySumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	currencyIdentifier?:ResolverInputTypes["FieldMeta"],
	rateAgainstCzk?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCurrencySumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currencyIdentifier?: ResolverInputTypes["OrderDirection"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null
};
	["PostCurrencySum"]: AliasType<{
	_meta?:ResolverInputTypes["PostCurrencySumMeta"],
	id?:boolean | `@${string}`,
	currencyIdentifier?:boolean | `@${string}`,
	rateAgainstCzk?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostCurrencySumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	currencyIdentifier?:ResolverInputTypes["FieldMeta"],
	rateAgainstCzk?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostCurrencySumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currencyIdentifier?: ResolverInputTypes["OrderDirection"] | undefined | null,
	rateAgainstCzk?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null
};
	["PostAreaSentPaymentCurrencySumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaSentPaymentCurrencySumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentCurrencySumEdge"]: AliasType<{
	node?:ResolverInputTypes["PostAreaSentPaymentCurrencySum"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCurrencySumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaCurrencySumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCurrencySumEdge"]: AliasType<{
	node?:ResolverInputTypes["PostAreaCurrencySum"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCurrencySumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostOrganizationCurrencySumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCurrencySumEdge"]: AliasType<{
	node?:ResolverInputTypes["PostOrganizationCurrencySum"],
		__typename?: boolean | `@${string}`
}>;
	["PostCurrencySumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostCurrencySumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostCurrencySumEdge"]: AliasType<{
	node?:ResolverInputTypes["PostCurrencySum"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethod"]: AliasType<{
	_meta?:ResolverInputTypes["RegionPaymentMethodMeta"],
	id?:boolean | `@${string}`,
	allowRecurringPayments?:boolean | `@${string}`,
region?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["Region"]],
	method?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	allowRecurringPayments?:ResolverInputTypes["FieldMeta"],
	region?:ResolverInputTypes["FieldMeta"],
	method?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	allowRecurringPayments?: ResolverInputTypes["OrderDirection"] | undefined | null,
	region?: ResolverInputTypes["RegionOrderBy"] | undefined | null,
	method?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["RegionEnabledPaymentMethodsByMethodUniqueWhere"]: {
	method?: ResolverInputTypes["PaymentMethods"] | undefined | null
};
	["RegionDonationItemsByListUniqueWhere"]: {
	list?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null
};
	["RegionDonationItemsByItemsUniqueWhere"]: {
	items?: ResolverInputTypes["DonationAmountItemUniqueWhere"] | undefined | null
};
	["RegionPaymentMethodConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["RegionPaymentMethodEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodEdge"]: AliasType<{
	node?:ResolverInputTypes["RegionPaymentMethod"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["DonationAmountsRegionItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemEdge"]: AliasType<{
	node?:ResolverInputTypes["DonationAmountsRegionItem"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["DonationAmountItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemEdge"]: AliasType<{
	node?:ResolverInputTypes["DonationAmountItem"],
		__typename?: boolean | `@${string}`
}>;
	["Donation"]: AliasType<{
	_meta?:ResolverInputTypes["DonationMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
regionList?: [{	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionList"]],
		__typename?: boolean | `@${string}`
}>;
	["DonationMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	regionList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListRegionsByRegionUniqueWhere"]: {
	region?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null
};
	["DonationAmountsRegionListRegionsByItemsUniqueWhere"]: {
	items?: ResolverInputTypes["DonationAmountItemUniqueWhere"] | undefined | null
};
	["PostAreaMetaData"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaMetaDataMeta"],
	id?:boolean | `@${string}`,
	nameWithFallback?:boolean | `@${string}`,
	formattedSpecificSymbol?:boolean | `@${string}`,
	fullFormattedSpecificSymbol?:boolean | `@${string}`,
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaMetaDataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	nameWithFallback?:ResolverInputTypes["FieldMeta"],
	formattedSpecificSymbol?:ResolverInputTypes["FieldMeta"],
	fullFormattedSpecificSymbol?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SentPayment"]: AliasType<{
	_meta?:ResolverInputTypes["SentPaymentMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	cents?:boolean | `@${string}`,
	sendAt?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
locales?: [{	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SentPaymentLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["SentPaymentLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null},ResolverInputTypes["SentPaymentLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SentPaymentLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	cents?:ResolverInputTypes["FieldMeta"],
	sendAt?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocale"]: AliasType<{
	_meta?:ResolverInputTypes["SentPaymentLocaleMeta"],
	id?:boolean | `@${string}`,
	organizationText?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null},ResolverInputTypes["SentPayment"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	organizationText?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	organizationText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["SentPaymentOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null
};
	["SentPaymentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	cents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	sendAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null
};
	["SentPaymentLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["SentPaymentLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SentPaymentLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["SentPaymentLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentSum"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaSentPaymentSumMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
	czkPercentage?:boolean | `@${string}`,
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentSumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	czkPercentage?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSum"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaSumMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
	czkPercentage?:boolean | `@${string}`,
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	czkPercentage?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["PostAreaLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["PostAreaLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["PostAreaLocalesByBannerUniqueWhere"]: {
	banner?: ResolverInputTypes["AppBannerUniqueWhere"] | undefined | null
};
	["PostAreaLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["PostAreaPostsBySpecificSymbolUniqueWhere"]: {
	specificSymbol?: number | undefined | null
};
	["PostAreaPostsByActiveRevisionUniqueWhere"]: {
	activeRevision?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null
};
	["PostAreaPostsByRevisionsUniqueWhere"]: {
	revisions?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null
};
	["PostAreaPostsByLocalesUniqueWhere"]: {
	locales?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null
};
	["PostAreaPostsByMetaUniqueWhere"]: {
	meta?: ResolverInputTypes["PostMetaDataUniqueWhere"] | undefined | null
};
	["PostAreaPostsByFundraiseCurrencySumsUniqueWhere"]: {
	fundraiseCurrencySums?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null
};
	["PostAreaPostsByFundraiseSumUniqueWhere"]: {
	fundraiseSum?: ResolverInputTypes["PostSumUniqueWhere"] | undefined | null
};
	["PostAreaPostsByFundraisingProgressUniqueWhere"]: {
	fundraisingProgress?: ResolverInputTypes["PostFundraisingProgressUniqueWhere"] | undefined | null
};
	["PostAreaSentPaymentsByLocalesUniqueWhere"]: {
	locales?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null
};
	["PostAreaLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["PostAreaLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostEdge"]: AliasType<{
	node?:ResolverInputTypes["Post"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SentPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentEdge"]: AliasType<{
	node?:ResolverInputTypes["SentPayment"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMetaData"]: AliasType<{
	_meta?:ResolverInputTypes["PostOrganizationMetaDataMeta"],
	id?:boolean | `@${string}`,
	nameWithFallback?:boolean | `@${string}`,
	formattedSpecificSymbol?:boolean | `@${string}`,
	fullFormattedSpecificSymbol?:boolean | `@${string}`,
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMetaDataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	nameWithFallback?:ResolverInputTypes["FieldMeta"],
	formattedSpecificSymbol?:ResolverInputTypes["FieldMeta"],
	fullFormattedSpecificSymbol?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationSum"]: AliasType<{
	_meta?:ResolverInputTypes["PostOrganizationSumMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
	czkPercentage?:boolean | `@${string}`,
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationSumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	czkPercentage?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationPostsBySpecificSymbolUniqueWhere"]: {
	specificSymbol?: number | undefined | null
};
	["PostOrganizationPostsByActiveRevisionUniqueWhere"]: {
	activeRevision?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null
};
	["PostOrganizationPostsByRevisionsUniqueWhere"]: {
	revisions?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null
};
	["PostOrganizationPostsByLocalesUniqueWhere"]: {
	locales?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null
};
	["PostOrganizationPostsByMetaUniqueWhere"]: {
	meta?: ResolverInputTypes["PostMetaDataUniqueWhere"] | undefined | null
};
	["PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere"]: {
	fundraiseCurrencySums?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null
};
	["PostOrganizationPostsByFundraiseSumUniqueWhere"]: {
	fundraiseSum?: ResolverInputTypes["PostSumUniqueWhere"] | undefined | null
};
	["PostOrganizationPostsByFundraisingProgressUniqueWhere"]: {
	fundraisingProgress?: ResolverInputTypes["PostFundraisingProgressUniqueWhere"] | undefined | null
};
	["PostOrganizationLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["PostOrganizationLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["PostOrganizationLocalesByDomainUniqueWhere"]: {
	domain?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["PostOrganizationLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["PostOrganizationLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["PostOrganizationSentPaymentsByLocalesUniqueWhere"]: {
	locales?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null
};
	["PostOrganizationLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostOrganizationLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["PostOrganizationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevision"]: AliasType<{
	_meta?:ResolverInputTypes["PostRevisionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	createdById?:boolean | `@${string}`,
	publishedById?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	publishedAt?:boolean | `@${string}`,
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
tileImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
tileVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
heroImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
locales?: [{	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
regionListOverride?: [{	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionList"]],
	isOrganizationVisible?:boolean | `@${string}`,
	sendPublishNotifications?:boolean | `@${string}`,
	isArchived?:boolean | `@${string}`,
localesByLocale?: [{	by: ResolverInputTypes["PostRevisionLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
localesByContent?: [{	by: ResolverInputTypes["PostRevisionLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["PostRevisionLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
localesByLeadContent?: [{	by: ResolverInputTypes["PostRevisionLocalesByLeadContentUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostRevisionLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	createdById?:ResolverInputTypes["FieldMeta"],
	publishedById?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	publishedAt?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
	tileImage?:ResolverInputTypes["FieldMeta"],
	tileVideo?:ResolverInputTypes["FieldMeta"],
	heroImage?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	regionListOverride?:ResolverInputTypes["FieldMeta"],
	isOrganizationVisible?:ResolverInputTypes["FieldMeta"],
	sendPublishNotifications?:ResolverInputTypes["FieldMeta"],
	isArchived?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Video"]: AliasType<{
	_meta?:ResolverInputTypes["VideoMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
poster?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	shapeType?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VideoMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	url?:ResolverInputTypes["FieldMeta"],
	width?:ResolverInputTypes["FieldMeta"],
	height?:ResolverInputTypes["FieldMeta"],
	size?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	poster?:ResolverInputTypes["FieldMeta"],
	shapeType?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocale"]: AliasType<{
	_meta?:ResolverInputTypes["PostRevisionLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevision"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
leadContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
	publishNotificationText?:boolean | `@${string}`,
	translatedByAI?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	leadContent?:ResolverInputTypes["FieldMeta"],
	publishNotificationText?:ResolverInputTypes["FieldMeta"],
	translatedByAI?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["PostRevisionOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	leadContent?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	publishNotificationText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	translatedByAI?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostRevisionLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["PostRevisionLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["PostRevisionLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["PostRevisionLocalesByLeadContentUniqueWhere"]: {
	leadContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["PostRevisionLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostRevisionLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["PostRevisionLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostMetaData"]: AliasType<{
	_meta?:ResolverInputTypes["PostMetaDataMeta"],
	id?:boolean | `@${string}`,
	titleWithFallback?:boolean | `@${string}`,
	formattedSpecificSymbol?:boolean | `@${string}`,
	fullFormattedSpecificSymbol?:boolean | `@${string}`,
latestRevision?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevision"]],
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostMetaDataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	titleWithFallback?:ResolverInputTypes["FieldMeta"],
	formattedSpecificSymbol?:ResolverInputTypes["FieldMeta"],
	fullFormattedSpecificSymbol?:ResolverInputTypes["FieldMeta"],
	latestRevision?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarousel"]: AliasType<{
	_meta?:ResolverInputTypes["HeroCarouselMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
posts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Post"]],
items?: [{	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeroCarouselItem"]],
paginatePosts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostConnection"]],
paginateItems?: [{	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeroCarouselItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	posts?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItem"]: AliasType<{
	_meta?:ResolverInputTypes["HeroCarouselItemMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null},ResolverInputTypes["HeroCarousel"]],
item?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	item?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["HeroCarouselOrderBy"] | undefined | null,
	item?: ResolverInputTypes["PostOrderBy"] | undefined | null
};
	["HeroCarouselOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["HeroCarouselItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HeroCarouselItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemEdge"]: AliasType<{
	node?:ResolverInputTypes["HeroCarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["ReportPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
	postTitle?:boolean | `@${string}`,
	giftTitle?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
root?: [{	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null},ResolverInputTypes["ReportPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
posts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Post"]],
paginatePosts?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
	postTitle?:ResolverInputTypes["FieldMeta"],
	giftTitle?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	posts?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPage"]: AliasType<{
	_meta?:ResolverInputTypes["ReportPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportPageLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["ReportPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
localesByLink?: [{	by: ResolverInputTypes["ReportPageLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
localesByContent?: [{	by: ResolverInputTypes["ReportPageLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["ReportPageLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["ReportPageLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["ReportPageLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["ReportPageLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["ReportPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ReportPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["ReportPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	primaryText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	block?: ResolverInputTypes["ContentBlockOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	video?: ResolverInputTypes["VideoOrderBy"] | undefined | null,
	secondaryText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	contentAlignment?: ResolverInputTypes["OrderDirection"] | undefined | null,
	valueList?: ResolverInputTypes["ValueListOrderBy"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ImageLinkListOrderBy"] | undefined | null,
	areaList?: ResolverInputTypes["PostAreaListOrderBy"] | undefined | null,
	isAppsVisible?: ResolverInputTypes["OrderDirection"] | undefined | null,
	accordion?: ResolverInputTypes["AccordionOrderBy"] | undefined | null,
	media?: ResolverInputTypes["MediumListOrderBy"] | undefined | null,
	memberList?: ResolverInputTypes["MemberListOrderBy"] | undefined | null,
	asideMediaContentLayout?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isAsideMediaContentMobileLayout?: ResolverInputTypes["OrderDirection"] | undefined | null,
	form?: ResolverInputTypes["FormOrderBy"] | undefined | null,
	isTitleBigger?: ResolverInputTypes["OrderDirection"] | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	heroCarousel?: ResolverInputTypes["HeroCarouselOrderBy"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListOrderBy"] | undefined | null,
	isCentered?: ResolverInputTypes["OrderDirection"] | undefined | null,
	textImageList?: ResolverInputTypes["TextImageListOrderBy"] | undefined | null
};
	["ContentBlockOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	json?: ResolverInputTypes["OrderDirection"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null
};
	["ValueListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ImageLinkListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostAreaListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["AccordionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["MediumListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["MemberListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["FormOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	tax?: ResolverInputTypes["FilledTaxFormOrderBy"] | undefined | null
};
	["FilledTaxFormOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	publishedAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	userId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	email?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	vatId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	address1?: ResolverInputTypes["OrderDirection"] | undefined | null,
	address2?: ResolverInputTypes["OrderDirection"] | undefined | null,
	city?: ResolverInputTypes["OrderDirection"] | undefined | null,
	postalCode?: ResolverInputTypes["OrderDirection"] | undefined | null,
	state?: ResolverInputTypes["OrderDirection"] | undefined | null,
	country?: ResolverInputTypes["RegionOrderBy"] | undefined | null,
	dateFrom?: ResolverInputTypes["OrderDirection"] | undefined | null,
	dateTo?: ResolverInputTypes["OrderDirection"] | undefined | null,
	year?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isPdfGenerated?: ResolverInputTypes["OrderDirection"] | undefined | null,
	pdfObjectKey?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["TextImageListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostSum"]: AliasType<{
	_meta?:ResolverInputTypes["PostSumMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
	czkPercentage?:boolean | `@${string}`,
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostSumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	czkPercentage?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostFundraisingProgress"]: AliasType<{
	_meta?:ResolverInputTypes["PostFundraisingProgressMeta"],
	id?:boolean | `@${string}`,
	progress?:boolean | `@${string}`,
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostFundraisingProgressMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	progress?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionsByLocalesUniqueWhere"]: {
	locales?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null
};
	["PostRevisionsByRegionListOverrideUniqueWhere"]: {
	regionListOverride?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null
};
	["PostLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["PostLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["PostLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["PostLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["PostRevisionConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostRevisionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionEdge"]: AliasType<{
	node?:ResolverInputTypes["PostRevision"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["PostLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HeroCarouselEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselEdge"]: AliasType<{
	node?:ResolverInputTypes["HeroCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContentReferenceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ResolverInputTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["GivenGiftsPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
	giftTitle?:boolean | `@${string}`,
	giftText?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
	giftTitle?:ResolverInputTypes["FieldMeta"],
	giftText?:ResolverInputTypes["FieldMeta"],
	note?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPage"]: AliasType<{
	_meta?:ResolverInputTypes["GivenGiftsPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
localesByContent?: [{	by: ResolverInputTypes["GivenGiftsPageLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["GivenGiftsPageLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
localesByLink?: [{	by: ResolverInputTypes["GivenGiftsPageLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GivenGiftsPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["GivenGiftsPageLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["GivenGiftsPageLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["GivenGiftsPageLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["GivenGiftsPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GivenGiftsPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["GivenGiftsPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["ReceivedGiftsPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
	giftTitle?:boolean | `@${string}`,
	giftText?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
root?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
	giftTitle?:ResolverInputTypes["FieldMeta"],
	giftText?:ResolverInputTypes["FieldMeta"],
	note?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPage"]: AliasType<{
	_meta?:ResolverInputTypes["ReceivedGiftsPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
localesByLink?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
localesByContent?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["ReceivedGiftsPageLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["ReceivedGiftsPageLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["ReceivedGiftsPageLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["ReceivedGiftsPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ReceivedGiftsPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["ReceivedGiftsPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	item?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	reference?: ResolverInputTypes["ContentReferenceOrderBy"] | undefined | null
};
	["ValueList"]: AliasType<{
	_meta?:ResolverInputTypes["ValueListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ValueItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ValueItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ValueListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItem"]: AliasType<{
	_meta?:ResolverInputTypes["ValueItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null},ResolverInputTypes["ValueList"]],
item?: [{	filter?: ResolverInputTypes["ValueWhere"] | undefined | null},ResolverInputTypes["Value"]],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	item?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Value"]: AliasType<{
	_meta?:ResolverInputTypes["ValueMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
textContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
		__typename?: boolean | `@${string}`
}>;
	["ValueMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	textContent?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["ValueListOrderBy"] | undefined | null,
	item?: ResolverInputTypes["ValueOrderBy"] | undefined | null
};
	["ValueOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	textContent?: ResolverInputTypes["ContentOrderBy"] | undefined | null
};
	["ValueItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ValueItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemEdge"]: AliasType<{
	node?:ResolverInputTypes["ValueItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkList"]: AliasType<{
	_meta?:ResolverInputTypes["ImageLinkListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageLinkItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageLinkItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItem"]: AliasType<{
	_meta?:ResolverInputTypes["ImageLinkItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null},ResolverInputTypes["ImageLinkList"]],
item?: [{	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null},ResolverInputTypes["ImageLink"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	item?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLink"]: AliasType<{
	_meta?:ResolverInputTypes["ImageLinkMeta"],
	id?:boolean | `@${string}`,
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["ImageLinkListOrderBy"] | undefined | null,
	item?: ResolverInputTypes["ImageLinkOrderBy"] | undefined | null
};
	["ImageLinkOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["ImageLinkItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageLinkItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemEdge"]: AliasType<{
	node?:ResolverInputTypes["ImageLinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaList"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaListItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItem"]: AliasType<{
	_meta?:ResolverInputTypes["PostAreaListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null},ResolverInputTypes["PostAreaList"]],
item?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	item?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["PostAreaListOrderBy"] | undefined | null,
	item?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null
};
	["PostAreaListItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemEdge"]: AliasType<{
	node?:ResolverInputTypes["PostAreaListItem"],
		__typename?: boolean | `@${string}`
}>;
	["Accordion"]: AliasType<{
	_meta?:ResolverInputTypes["AccordionMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["AccordionItem"]],
itemsByDescriptionContent?: [{	by: ResolverInputTypes["AccordionItemsByDescriptionContentUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null},ResolverInputTypes["AccordionItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["AccordionItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["AccordionMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItem"]: AliasType<{
	_meta?:ResolverInputTypes["AccordionItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null},ResolverInputTypes["Accordion"]],
descriptionContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	descriptionContent?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["AccordionOrderBy"] | undefined | null,
	descriptionContent?: ResolverInputTypes["ContentOrderBy"] | undefined | null
};
	["AccordionItemsByDescriptionContentUniqueWhere"]: {
	descriptionContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["AccordionItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["AccordionItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemEdge"]: AliasType<{
	node?:ResolverInputTypes["AccordionItem"],
		__typename?: boolean | `@${string}`
}>;
	["MediumList"]: AliasType<{
	_meta?:ResolverInputTypes["MediumListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItem"]: AliasType<{
	_meta?:ResolverInputTypes["MediumItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
medium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["Medium"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	medium?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Medium"]: AliasType<{
	_meta?:ResolverInputTypes["MediumMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
video?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	video?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["MediumListOrderBy"] | undefined | null,
	medium?: ResolverInputTypes["MediumOrderBy"] | undefined | null
};
	["MediumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	video?: ResolverInputTypes["VideoOrderBy"] | undefined | null
};
	["MediumItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["MediumItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemEdge"]: AliasType<{
	node?:ResolverInputTypes["MediumItem"],
		__typename?: boolean | `@${string}`
}>;
	["MemberList"]: AliasType<{
	_meta?:ResolverInputTypes["MemberListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MemberListItem"]],
itemsByDescriptionContent?: [{	by: ResolverInputTypes["MemberListItemsByDescriptionContentUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null},ResolverInputTypes["MemberListItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MemberListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MemberListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItem"]: AliasType<{
	_meta?:ResolverInputTypes["MemberListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null},ResolverInputTypes["MemberList"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
descriptionContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	position?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	descriptionContent?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	position?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["MemberListOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	descriptionContent?: ResolverInputTypes["ContentOrderBy"] | undefined | null
};
	["MemberListItemsByDescriptionContentUniqueWhere"]: {
	descriptionContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["MemberListItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["MemberListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemEdge"]: AliasType<{
	node?:ResolverInputTypes["MemberListItem"],
		__typename?: boolean | `@${string}`
}>;
	["Form"]: AliasType<{
	_meta?:ResolverInputTypes["FormMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
tax?: [{	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null},ResolverInputTypes["FilledTaxForm"]],
		__typename?: boolean | `@${string}`
}>;
	["FormMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	tax?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxForm"]: AliasType<{
	_meta?:ResolverInputTypes["FilledTaxFormMeta"],
	id?:boolean | `@${string}`,
	publishedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	vatId?:boolean | `@${string}`,
	address1?:boolean | `@${string}`,
	address2?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	postalCode?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
country?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["Region"]],
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
	isPdfGenerated?:boolean | `@${string}`,
	pdfObjectKey?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	publishedAt?:ResolverInputTypes["FieldMeta"],
	userId?:ResolverInputTypes["FieldMeta"],
	email?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	vatId?:ResolverInputTypes["FieldMeta"],
	address1?:ResolverInputTypes["FieldMeta"],
	address2?:ResolverInputTypes["FieldMeta"],
	city?:ResolverInputTypes["FieldMeta"],
	postalCode?:ResolverInputTypes["FieldMeta"],
	state?:ResolverInputTypes["FieldMeta"],
	country?:ResolverInputTypes["FieldMeta"],
	dateFrom?:ResolverInputTypes["FieldMeta"],
	dateTo?:ResolverInputTypes["FieldMeta"],
	year?:ResolverInputTypes["FieldMeta"],
	isPdfGenerated?:ResolverInputTypes["FieldMeta"],
	pdfObjectKey?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationList"]: AliasType<{
	_meta?:ResolverInputTypes["PostOrganizationListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationListItem"]],
itemsByLink?: [{	by: ResolverInputTypes["PostOrganizationListItemsByLinkUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null},ResolverInputTypes["PostOrganizationListItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItem"]: AliasType<{
	_meta?:ResolverInputTypes["PostOrganizationListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null},ResolverInputTypes["PostOrganizationList"]],
item?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
	type?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	item?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["PostOrganizationListOrderBy"] | undefined | null,
	item?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["PostOrganizationListItemsByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["PostOrganizationListItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostOrganizationListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemEdge"]: AliasType<{
	node?:ResolverInputTypes["PostOrganizationListItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageList"]: AliasType<{
	_meta?:ResolverInputTypes["TextImageListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextImageListItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextImageListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItem"]: AliasType<{
	_meta?:ResolverInputTypes["TextImageListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null},ResolverInputTypes["TextImageList"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	text?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["TextImageListOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["TextImageListItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TextImageListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemEdge"]: AliasType<{
	node?:ResolverInputTypes["TextImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkablesByItemUniqueWhere"]: {
	item?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["ContentReferenceLinkableItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContentReferenceLinkableItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemEdge"]: AliasType<{
	node?:ResolverInputTypes["ContentReferenceLinkableItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockReferencesByLinkablesUniqueWhere"]: {
	linkables?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByValueListUniqueWhere"]: {
	valueList?: ResolverInputTypes["ValueListUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByImageLinkListUniqueWhere"]: {
	imageLinkList?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByAreaListUniqueWhere"]: {
	areaList?: ResolverInputTypes["PostAreaListUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByAccordionUniqueWhere"]: {
	accordion?: ResolverInputTypes["AccordionUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
	media?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByMemberListUniqueWhere"]: {
	memberList?: ResolverInputTypes["MemberListUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByContentWithoutBlocksUniqueWhere"]: {
	contentWithoutBlocks?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByOrganizationListUniqueWhere"]: {
	organizationList?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByTextImageListUniqueWhere"]: {
	textImageList?: ResolverInputTypes["TextImageListUniqueWhere"] | undefined | null
};
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContentBlockEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ResolverInputTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocale"]: AliasType<{
	_meta?:ResolverInputTypes["HeaderLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["Header"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
links?: [{	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null},ResolverInputTypes["LinkList"]],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	links?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Header"]: AliasType<{
	_meta?:ResolverInputTypes["HeaderMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
locales?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeaderLocale"]],
organizationList?: [{	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null},ResolverInputTypes["PostOrganizationList"]],
localesByLocale?: [{	by: ResolverInputTypes["HeaderLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
localesByLinks?: [{	by: ResolverInputTypes["HeaderLocalesByLinksUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HeaderMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	organizationList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["HeaderOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	links?: ResolverInputTypes["LinkListOrderBy"] | undefined | null
};
	["HeaderOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	organizationList?: ResolverInputTypes["PostOrganizationListOrderBy"] | undefined | null
};
	["LinkListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["HeaderLocalesByLinksUniqueWhere"]: {
	links?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null
};
	["HeaderLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HeaderLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["HeaderLocale"],
		__typename?: boolean | `@${string}`
}>;
	["LinkList"]: AliasType<{
	_meta?:ResolverInputTypes["LinkListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["LinkItem"]],
itemsByLink?: [{	by: ResolverInputTypes["LinkListItemsByLinkUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null},ResolverInputTypes["LinkItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItem"]: AliasType<{
	_meta?:ResolverInputTypes["LinkItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null},ResolverInputTypes["LinkList"]],
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["LinkListOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["LinkListItemsByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LinkItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["LinkItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemEdge"]: AliasType<{
	node?:ResolverInputTypes["LinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocale"]: AliasType<{
	_meta?:ResolverInputTypes["FooterLocaleMeta"],
	id?:boolean | `@${string}`,
	copyright?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["Footer"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
linkList?: [{	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null},ResolverInputTypes["LinkList"]],
	contactEmail?:boolean | `@${string}`,
addressInfo?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
imageLinkList?: [{	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null},ResolverInputTypes["ImageLinkList"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	copyright?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	linkList?:ResolverInputTypes["FieldMeta"],
	contactEmail?:ResolverInputTypes["FieldMeta"],
	addressInfo?:ResolverInputTypes["FieldMeta"],
	imageLinkList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Footer"]: AliasType<{
	_meta?:ResolverInputTypes["FooterMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLocale"]],
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
localesByLocale?: [{	by: ResolverInputTypes["FooterLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByLinkList?: [{	by: ResolverInputTypes["FooterLocalesByLinkListUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByAddressInfo?: [{	by: ResolverInputTypes["FooterLocalesByAddressInfoUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByImageLinkList?: [{	by: ResolverInputTypes["FooterLocalesByImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	copyright?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["FooterOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	linkList?: ResolverInputTypes["LinkListOrderBy"] | undefined | null,
	contactEmail?: ResolverInputTypes["OrderDirection"] | undefined | null,
	addressInfo?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ImageLinkListOrderBy"] | undefined | null
};
	["FooterOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["FooterLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["FooterLocalesByLinkListUniqueWhere"]: {
	linkList?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null
};
	["FooterLocalesByAddressInfoUniqueWhere"]: {
	addressInfo?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["FooterLocalesByImageLinkListUniqueWhere"]: {
	imageLinkList?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null
};
	["FooterLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FooterLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["FooterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocale"]: AliasType<{
	_meta?:ResolverInputTypes["GenericPageAboutSettingsLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettings"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
linkGroups?: [{	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocale"]],
linkGroupsByLinkList?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocale"]],
paginateLinkGroups?: [{	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	linkGroups?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettings"]: AliasType<{
	_meta?:ResolverInputTypes["GenericPageAboutSettingsMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
localesByLinkGroups?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["GenericPageAboutSettingsOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null
};
	["GenericPageAboutSettingsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["GenericPageAboutSettingsLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere"]: {
	linkGroups?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null
};
	["GenericPageAboutSettingsLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GenericPageAboutSettingsLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["GenericPageAboutSettingsLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocale"]: AliasType<{
	_meta?:ResolverInputTypes["GenericPageAboutGroupLinksLocaleMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
settings?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
linkList?: [{	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null},ResolverInputTypes["LinkList"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	settings?:ResolverInputTypes["FieldMeta"],
	linkList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	settings?: ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"] | undefined | null,
	linkList?: ResolverInputTypes["LinkListOrderBy"] | undefined | null
};
	["GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere"]: {
	linkList?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null
};
	["GenericPageAboutGroupLinksLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GenericPageAboutGroupLinksLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["GenericPageAboutGroupLinksLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["FeedPageLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null},ResolverInputTypes["FeedPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
heroTiles?: [{	filter?: ResolverInputTypes["TileListWhere"] | undefined | null},ResolverInputTypes["TileList"]],
sectionList?: [{	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageSectionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageSection"]],
cardList?: [{	filter?: ResolverInputTypes["CardListWhere"] | undefined | null},ResolverInputTypes["CardList"]],
storyGuideList?: [{	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null},ResolverInputTypes["StoryGuideList"]],
sectionListByTileStripeList?: [{	by: ResolverInputTypes["FeedPageLocaleSectionListByTileStripeListUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null},ResolverInputTypes["FeedPageSection"]],
paginateSectionList?: [{	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageSectionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageSectionConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	heroTiles?:ResolverInputTypes["FieldMeta"],
	sectionList?:ResolverInputTypes["FieldMeta"],
	cardList?:ResolverInputTypes["FieldMeta"],
	storyGuideList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPage"]: AliasType<{
	_meta?:ResolverInputTypes["FeedPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["FeedPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
localesByHeroTiles?: [{	by: ResolverInputTypes["FeedPageLocalesByHeroTilesUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
localesBySectionList?: [{	by: ResolverInputTypes["FeedPageLocalesBySectionListUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
localesByCardList?: [{	by: ResolverInputTypes["FeedPageLocalesByCardListUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
localesByStoryGuideList?: [{	by: ResolverInputTypes["FeedPageLocalesByStoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["FeedPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	heroTiles?: ResolverInputTypes["TileListOrderBy"] | undefined | null,
	cardList?: ResolverInputTypes["CardListOrderBy"] | undefined | null,
	storyGuideList?: ResolverInputTypes["StoryGuideListOrderBy"] | undefined | null
};
	["FeedPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["TileListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	size?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	areaType?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null
};
	["CardListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["StoryGuideListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["FeedPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["FeedPageLocalesByHeroTilesUniqueWhere"]: {
	heroTiles?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null
};
	["FeedPageLocalesBySectionListUniqueWhere"]: {
	sectionList?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null
};
	["FeedPageLocalesByCardListUniqueWhere"]: {
	cardList?: ResolverInputTypes["CardListUniqueWhere"] | undefined | null
};
	["FeedPageLocalesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null
};
	["FeedPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FeedPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["FeedPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["TileList"]: AliasType<{
	_meta?:ResolverInputTypes["TileListMeta"],
	id?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TileItem"]],
areaType?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
itemsByLink?: [{	by: ResolverInputTypes["TileListItemsByLinkUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null},ResolverInputTypes["TileItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TileItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TileListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	size?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
	areaType?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TileItem"]: AliasType<{
	_meta?:ResolverInputTypes["TileItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["TileListWhere"] | undefined | null},ResolverInputTypes["TileList"]],
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
		__typename?: boolean | `@${string}`
}>;
	["TileItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	description?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	description?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["TileListOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null
};
	["TileListItemsByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["TileItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TileItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemEdge"]: AliasType<{
	node?:ResolverInputTypes["TileItem"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSection"]: AliasType<{
	_meta?:ResolverInputTypes["FeedPageSectionMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
feedPageLocale?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
tileStripeList?: [{	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageTileStripeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageTileStripe"]],
paginateTileStripeList?: [{	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageTileStripeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageTileStripeConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	feedPageLocale?:ResolverInputTypes["FieldMeta"],
	tileStripeList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripe"]: AliasType<{
	_meta?:ResolverInputTypes["FeedPageTileStripeMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
section?: [{	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null},ResolverInputTypes["FeedPageSection"]],
tileList?: [{	filter?: ResolverInputTypes["TileListWhere"] | undefined | null},ResolverInputTypes["TileList"]],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	section?:ResolverInputTypes["FieldMeta"],
	tileList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	section?: ResolverInputTypes["FeedPageSectionOrderBy"] | undefined | null,
	tileList?: ResolverInputTypes["TileListOrderBy"] | undefined | null
};
	["FeedPageSectionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	feedPageLocale?: ResolverInputTypes["FeedPageLocaleOrderBy"] | undefined | null
};
	["FeedPageTileStripeConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FeedPageTileStripeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeEdge"]: AliasType<{
	node?:ResolverInputTypes["FeedPageTileStripe"],
		__typename?: boolean | `@${string}`
}>;
	["CardList"]: AliasType<{
	_meta?:ResolverInputTypes["CardListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CardItem"]],
itemsByLink?: [{	by: ResolverInputTypes["CardListItemsByLinkUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null},ResolverInputTypes["CardItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CardItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CardListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CardItem"]: AliasType<{
	_meta?:ResolverInputTypes["CardItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["CardListWhere"] | undefined | null},ResolverInputTypes["CardList"]],
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["CardItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	description?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	description?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["CardListOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["CardListItemsByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["CardItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CardItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemEdge"]: AliasType<{
	node?:ResolverInputTypes["CardItem"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideList"]: AliasType<{
	_meta?:ResolverInputTypes["StoryGuideListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StoryGuideItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StoryGuideItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItem"]: AliasType<{
	_meta?:ResolverInputTypes["StoryGuideItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null},ResolverInputTypes["StoryGuideList"]],
guide?: [{	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null},ResolverInputTypes["StoryGuide"]],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	guide?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuide"]: AliasType<{
	_meta?:ResolverInputTypes["StoryGuideMeta"],
	id?:boolean | `@${string}`,
	mediaType?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
secondaryImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	mediaType?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	secondaryImage?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["StoryGuideListOrderBy"] | undefined | null,
	guide?: ResolverInputTypes["StoryGuideOrderBy"] | undefined | null
};
	["StoryGuideOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	mediaType?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	secondaryImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["StoryGuideItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["StoryGuideItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemEdge"]: AliasType<{
	node?:ResolverInputTypes["StoryGuideItem"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleSectionListByTileStripeListUniqueWhere"]: {
	tileStripeList?: ResolverInputTypes["FeedPageTileStripeUniqueWhere"] | undefined | null
};
	["FeedPageSectionConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FeedPageSectionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionEdge"]: AliasType<{
	node?:ResolverInputTypes["FeedPageSection"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["RecurringPaymentPageLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
favouritePosts?: [{	filter?: ResolverInputTypes["PostListWhere"] | undefined | null},ResolverInputTypes["PostList"]],
storyGuideList?: [{	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null},ResolverInputTypes["StoryGuideList"]],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	favouritePosts?:ResolverInputTypes["FieldMeta"],
	storyGuideList?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPage"]: AliasType<{
	_meta?:ResolverInputTypes["RecurringPaymentPageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
localesByFavouritePosts?: [{	by: ResolverInputTypes["RecurringPaymentPageLocalesByFavouritePostsUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
localesByStoryGuideList?: [{	by: ResolverInputTypes["RecurringPaymentPageLocalesByStoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["RecurringPaymentPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	favouritePosts?: ResolverInputTypes["PostListOrderBy"] | undefined | null,
	storyGuideList?: ResolverInputTypes["StoryGuideListOrderBy"] | undefined | null
};
	["RecurringPaymentPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["PostListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["RecurringPaymentPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["RecurringPaymentPageLocalesByFavouritePostsUniqueWhere"]: {
	favouritePosts?: ResolverInputTypes["PostListUniqueWhere"] | undefined | null
};
	["RecurringPaymentPageLocalesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null
};
	["RecurringPaymentPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["RecurringPaymentPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["RecurringPaymentPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostList"]: AliasType<{
	_meta?:ResolverInputTypes["PostListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostListItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PostListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItem"]: AliasType<{
	_meta?:ResolverInputTypes["PostListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["PostListWhere"] | undefined | null},ResolverInputTypes["PostList"]],
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["PostListOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null
};
	["PostListItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemEdge"]: AliasType<{
	node?:ResolverInputTypes["PostListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocale"]: AliasType<{
	_meta?:ResolverInputTypes["ScheduledNotificationLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null},ResolverInputTypes["ScheduledNotification"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	description?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotification"]: AliasType<{
	_meta?:ResolverInputTypes["ScheduledNotificationMeta"],
	id?:boolean | `@${string}`,
	localMsFromMidnight?:boolean | `@${string}`,
	scheduledDate?:boolean | `@${string}`,
	internalTitle?:boolean | `@${string}`,
target?: [{	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null},ResolverInputTypes["NotificationTargetGroup"]],
locales?: [{	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ScheduledNotificationLocale"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	completedAt?:boolean | `@${string}`,
processedNotifications?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
localesByLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null},ResolverInputTypes["ScheduledNotificationLocale"]],
processedNotificationsByProcessedNotification?: [{	by: ResolverInputTypes["ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
paginateLocales?: [{	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ScheduledNotificationLocaleConnection"]],
paginateProcessedNotifications?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ProcessedNotificationSourceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	localMsFromMidnight?:ResolverInputTypes["FieldMeta"],
	scheduledDate?:ResolverInputTypes["FieldMeta"],
	internalTitle?:ResolverInputTypes["FieldMeta"],
	target?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	completedAt?:ResolverInputTypes["FieldMeta"],
	processedNotifications?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroup"]: AliasType<{
	_meta?:ResolverInputTypes["NotificationTargetGroupMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
regions?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Region"]],
paginateRegions?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RegionConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	regions?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RegionConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["RegionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RegionEdge"]: AliasType<{
	node?:ResolverInputTypes["Region"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	description?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["ScheduledNotificationOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null
};
	["ScheduledNotificationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	localMsFromMidnight?: ResolverInputTypes["OrderDirection"] | undefined | null,
	scheduledDate?: ResolverInputTypes["OrderDirection"] | undefined | null,
	internalTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	target?: ResolverInputTypes["NotificationTargetGroupOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	completedAt?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["NotificationTargetGroupOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ProcessedNotificationSource"]: AliasType<{
	_meta?:ResolverInputTypes["ProcessedNotificationSourceMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
processedNotification?: [{	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null},ResolverInputTypes["ProcessedNotification"]],
donationReminderUser?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
scheduledNotification?: [{	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null},ResolverInputTypes["ScheduledNotification"]],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	processedNotification?:ResolverInputTypes["FieldMeta"],
	donationReminderUser?:ResolverInputTypes["FieldMeta"],
	scheduledNotification?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotification"]: AliasType<{
	_meta?:ResolverInputTypes["ProcessedNotificationMeta"],
	id?:boolean | `@${string}`,
	topic?:boolean | `@${string}`,
	sentAt?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errorCode?:boolean | `@${string}`,
	isSuccess?:boolean | `@${string}`,
source?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
	title?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	topic?:ResolverInputTypes["FieldMeta"],
	sentAt?:ResolverInputTypes["FieldMeta"],
	errorMessage?:ResolverInputTypes["FieldMeta"],
	errorCode?:ResolverInputTypes["FieldMeta"],
	isSuccess?:ResolverInputTypes["FieldMeta"],
	source?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	body?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	_meta?:ResolverInputTypes["UserMeta"],
	id?:boolean | `@${string}`,
	tenantPersonId?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
payments?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPayment"]],
	variableSymbol?:boolean | `@${string}`,
	lastActiveAt?:boolean | `@${string}`,
region?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["Region"]],
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
recurringPayments?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
	stripeId?:boolean | `@${string}`,
	isDeactivated?:boolean | `@${string}`,
onBehalfDonations?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
	publicProfileSecret?:boolean | `@${string}`,
	publicProfileCustomNote?:boolean | `@${string}`,
	publicProfileCustomNoteEnabled?:boolean | `@${string}`,
	donationConfirmationEmailEnabled?:boolean | `@${string}`,
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
	signedUp?:boolean | `@${string}`,
devices?: [{	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Device"]],
processedNotifications?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
areaStats?: [{	filter?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserAreaStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserAreaStats"]],
organizationStats?: [{	filter?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrganizationStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserOrganizationStats"]],
postStats?: [{	filter?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPostStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPostStats"]],
currencyStats?: [{	filter?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserCurrencyStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserCurrencyStats"]],
stats?: [{	filter?: ResolverInputTypes["UserStatsWhere"] | undefined | null},ResolverInputTypes["UserStats"]],
paymentsByOrder?: [{	by: ResolverInputTypes["UserPaymentsByOrderUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByCsobPayment?: [{	by: ResolverInputTypes["UserPaymentsByCsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByStripePayment?: [{	by: ResolverInputTypes["UserPaymentsByStripePaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByMetadata?: [{	by: ResolverInputTypes["UserPaymentsByMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
recurringPaymentsByItems?: [{	by: ResolverInputTypes["UserRecurringPaymentsByItemsUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
recurringPaymentsByMeta?: [{	by: ResolverInputTypes["UserRecurringPaymentsByMetaUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
onBehalfDonationsBySecretCode?: [{	by: ResolverInputTypes["UserOnBehalfDonationsBySecretCodeUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
onBehalfDonationsByPayments?: [{	by: ResolverInputTypes["UserOnBehalfDonationsByPaymentsUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
onBehalfDonationsByMeta?: [{	by: ResolverInputTypes["UserOnBehalfDonationsByMetaUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
devicesByFcmToken?: [{	by: ResolverInputTypes["UserDevicesByFcmTokenUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null},ResolverInputTypes["Device"]],
processedNotificationsByProcessedNotification?: [{	by: ResolverInputTypes["UserProcessedNotificationsByProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
paginatePayments?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentConnection"]],
paginateRecurringPayments?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentConnection"]],
paginateOnBehalfDonations?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["OnBehalfDonationConnection"]],
paginateDevices?: [{	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DeviceConnection"]],
paginateProcessedNotifications?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ProcessedNotificationSourceConnection"]],
paginateAreaStats?: [{	filter?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserAreaStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserAreaStatsConnection"]],
paginateOrganizationStats?: [{	filter?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrganizationStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserOrganizationStatsConnection"]],
paginatePostStats?: [{	filter?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPostStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPostStatsConnection"]],
paginateCurrencyStats?: [{	filter?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserCurrencyStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserCurrencyStatsConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	tenantPersonId?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	email?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	payments?:ResolverInputTypes["FieldMeta"],
	variableSymbol?:ResolverInputTypes["FieldMeta"],
	lastActiveAt?:ResolverInputTypes["FieldMeta"],
	region?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	recurringPayments?:ResolverInputTypes["FieldMeta"],
	stripeId?:ResolverInputTypes["FieldMeta"],
	isDeactivated?:ResolverInputTypes["FieldMeta"],
	onBehalfDonations?:ResolverInputTypes["FieldMeta"],
	publicProfileSecret?:ResolverInputTypes["FieldMeta"],
	publicProfileCustomNote?:ResolverInputTypes["FieldMeta"],
	publicProfileCustomNoteEnabled?:ResolverInputTypes["FieldMeta"],
	donationConfirmationEmailEnabled?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	signedUp?:ResolverInputTypes["FieldMeta"],
	devices?:ResolverInputTypes["FieldMeta"],
	processedNotifications?:ResolverInputTypes["FieldMeta"],
	areaStats?:ResolverInputTypes["FieldMeta"],
	organizationStats?:ResolverInputTypes["FieldMeta"],
	postStats?:ResolverInputTypes["FieldMeta"],
	currencyStats?:ResolverInputTypes["FieldMeta"],
	stats?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPayment"]: AliasType<{
	_meta?:ResolverInputTypes["UserPaymentMeta"],
	id?:boolean | `@${string}`,
	cents?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	specificSymbol?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
order?: [{	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null},ResolverInputTypes["UserPaymentOrderId"]],
csobPayment?: [{	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null},ResolverInputTypes["CsobPayment"]],
stripePayment?: [{	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null},ResolverInputTypes["StripePayment"]],
recurringPaymentItem?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
	method?:boolean | `@${string}`,
region?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["Region"]],
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
	isReusable?:boolean | `@${string}`,
onBehalfDonation?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
triesCollection?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollection"]],
	successEmailSentAt?:boolean | `@${string}`,
	isSuccessful?:boolean | `@${string}`,
	isFinished?:boolean | `@${string}`,
metadata?: [{	filter?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["UserPaymentMetadata"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	cents?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	specificSymbol?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	csobPayment?:ResolverInputTypes["FieldMeta"],
	stripePayment?:ResolverInputTypes["FieldMeta"],
	recurringPaymentItem?:ResolverInputTypes["FieldMeta"],
	method?:ResolverInputTypes["FieldMeta"],
	region?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
	isReusable?:ResolverInputTypes["FieldMeta"],
	onBehalfDonation?:ResolverInputTypes["FieldMeta"],
	triesCollection?:ResolverInputTypes["FieldMeta"],
	successEmailSentAt?:ResolverInputTypes["FieldMeta"],
	isSuccessful?:ResolverInputTypes["FieldMeta"],
	isFinished?:ResolverInputTypes["FieldMeta"],
	metadata?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderId"]: AliasType<{
	_meta?:ResolverInputTypes["UserPaymentOrderIdMeta"],
	id?:boolean | `@${string}`,
	seq?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	seq?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPayment"]: AliasType<{
	_meta?:ResolverInputTypes["CsobPaymentMeta"],
	id?:boolean | `@${string}`,
	payId?:boolean | `@${string}`,
statusChanges?: [{	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CsobPaymentStatusChange"]],
payment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
	originalPayId?:boolean | `@${string}`,
metadata?: [{	filter?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["CsobPaymentMetadata"]],
paginateStatusChanges?: [{	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CsobPaymentStatusChangeConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	payId?:ResolverInputTypes["FieldMeta"],
	statusChanges?:ResolverInputTypes["FieldMeta"],
	payment?:ResolverInputTypes["FieldMeta"],
	originalPayId?:ResolverInputTypes["FieldMeta"],
	metadata?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChange"]: AliasType<{
	_meta?:ResolverInputTypes["CsobPaymentStatusChangeMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	dttm?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	resultCode?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	authCode?:boolean | `@${string}`,
	statusDetail?:boolean | `@${string}`,
	actions?:boolean | `@${string}`,
payment?: [{	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null},ResolverInputTypes["CsobPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	dttm?:ResolverInputTypes["FieldMeta"],
	status?:ResolverInputTypes["FieldMeta"],
	resultCode?:ResolverInputTypes["FieldMeta"],
	message?:ResolverInputTypes["FieldMeta"],
	authCode?:ResolverInputTypes["FieldMeta"],
	statusDetail?:ResolverInputTypes["FieldMeta"],
	actions?:ResolverInputTypes["FieldMeta"],
	payment?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	dttm?: ResolverInputTypes["OrderDirection"] | undefined | null,
	status?: ResolverInputTypes["OrderDirection"] | undefined | null,
	resultCode?: ResolverInputTypes["OrderDirection"] | undefined | null,
	message?: ResolverInputTypes["OrderDirection"] | undefined | null,
	authCode?: ResolverInputTypes["OrderDirection"] | undefined | null,
	statusDetail?: ResolverInputTypes["OrderDirection"] | undefined | null,
	actions?: ResolverInputTypes["OrderDirection"] | undefined | null,
	payment?: ResolverInputTypes["CsobPaymentOrderBy"] | undefined | null
};
	["CsobPaymentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	payId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	payment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	originalPayId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentMetadataOrderBy"] | undefined | null
};
	["UserPaymentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	cents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	specificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentOrderIdOrderBy"] | undefined | null,
	csobPayment?: ResolverInputTypes["CsobPaymentOrderBy"] | undefined | null,
	stripePayment?: ResolverInputTypes["StripePaymentOrderBy"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserRecurringPaymentItemOrderBy"] | undefined | null,
	method?: ResolverInputTypes["OrderDirection"] | undefined | null,
	region?: ResolverInputTypes["RegionOrderBy"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null,
	isReusable?: ResolverInputTypes["OrderDirection"] | undefined | null,
	onBehalfDonation?: ResolverInputTypes["OnBehalfDonationOrderBy"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentTriesCollectionOrderBy"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isSuccessful?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isFinished?: ResolverInputTypes["OrderDirection"] | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentMetadataOrderBy"] | undefined | null
};
	["UserPaymentOrderIdOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	seq?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["StripePaymentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	identifier?: ResolverInputTypes["OrderDirection"] | undefined | null,
	payment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentMetadataOrderBy"] | undefined | null
};
	["StripePaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	status?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isSuccessful?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isFinished?: ResolverInputTypes["OrderDirection"] | undefined | null,
	stripePayment?: ResolverInputTypes["StripePaymentOrderBy"] | undefined | null
};
	["UserRecurringPaymentItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	recurrenceCounter?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	taskId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentOrderBy"] | undefined | null,
	isFailed?: ResolverInputTypes["OrderDirection"] | undefined | null,
	failedEmailSentAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemMetadataOrderBy"] | undefined | null
};
	["UserRecurringPaymentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	activeSince?: ResolverInputTypes["OrderDirection"] | undefined | null,
	cancelledAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	cents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	interval?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null,
	meta?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataOrderBy"] | undefined | null
};
	["UserOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	email?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	variableSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	lastActiveAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	region?: ResolverInputTypes["RegionOrderBy"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	stripeId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isDeactivated?: ResolverInputTypes["OrderDirection"] | undefined | null,
	publicProfileSecret?: ResolverInputTypes["OrderDirection"] | undefined | null,
	publicProfileCustomNote?: ResolverInputTypes["OrderDirection"] | undefined | null,
	publicProfileCustomNoteEnabled?: ResolverInputTypes["OrderDirection"] | undefined | null,
	donationConfirmationEmailEnabled?: ResolverInputTypes["OrderDirection"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	signedUp?: ResolverInputTypes["OrderDirection"] | undefined | null,
	stats?: ResolverInputTypes["UserStatsOrderBy"] | undefined | null
};
	["UserStatsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalPaymentsSuccessful?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalPaymentsUnsuccessful?: ResolverInputTypes["OrderDirection"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null
};
	["UpcomingUserRecurringPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	recurrenceCounter?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isBehindPayments?: ResolverInputTypes["OrderDirection"] | undefined | null,
	nextPaymentDate?: ResolverInputTypes["OrderDirection"] | undefined | null,
	shouldBeProcessed?: ResolverInputTypes["OrderDirection"] | undefined | null,
	firstPayment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	firstSuccessfulPayment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	drivingPayment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentOrderBy"] | undefined | null
};
	["UserRecurringPaymentItemMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isSuccessfullyPaid?: ResolverInputTypes["OrderDirection"] | undefined | null,
	shouldBeProcessed?: ResolverInputTypes["OrderDirection"] | undefined | null,
	firstPayment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	lastPayment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	firstSuccessfulPayment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	drivingPayment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserRecurringPaymentItemOrderBy"] | undefined | null
};
	["OnBehalfDonationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	secretCode?: ResolverInputTypes["OrderDirection"] | undefined | null,
	specificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	onBehalfOf?: ResolverInputTypes["UserOrderBy"] | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationMetadataOrderBy"] | undefined | null
};
	["OnBehalfDonationMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null,
	onBehalfOfDonation?: ResolverInputTypes["OnBehalfDonationOrderBy"] | undefined | null
};
	["UserPaymentTriesCollectionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	cents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	specificSymbol?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	orderUrl?: ResolverInputTypes["OrderDirection"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	onBehalfDonation?: ResolverInputTypes["OnBehalfDonationOrderBy"] | undefined | null,
	recurring?: ResolverInputTypes["UserRecurringPaymentOrderBy"] | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentTriesCollectionMetadataOrderBy"] | undefined | null,
	medium?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["UserPaymentTriesCollectionMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentTriesCollectionOrderBy"] | undefined | null
};
	["UserPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null,
	organizationUnfiltered?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null,
	countToUser?: ResolverInputTypes["UserOrderBy"] | undefined | null,
	paymentType?: ResolverInputTypes["OrderDirection"] | undefined | null,
	statusLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isSuccessful?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isFinished?: ResolverInputTypes["OrderDirection"] | undefined | null,
	needsCacheUpdate?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isSuccessfulNotCached?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isFinishedNotCached?: ResolverInputTypes["OrderDirection"] | undefined | null,
	userPayment?: ResolverInputTypes["UserPaymentOrderBy"] | undefined | null
};
	["CsobPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	status?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isSuccessful?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isFinished?: ResolverInputTypes["OrderDirection"] | undefined | null,
	resolvedOriginalPayId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	csobPayment?: ResolverInputTypes["CsobPaymentOrderBy"] | undefined | null
};
	["CsobPaymentMetadata"]: AliasType<{
	_meta?:ResolverInputTypes["CsobPaymentMetadataMeta"],
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	isSuccessful?:boolean | `@${string}`,
	isFinished?:boolean | `@${string}`,
	resolvedOriginalPayId?:boolean | `@${string}`,
csobPayment?: [{	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null},ResolverInputTypes["CsobPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentMetadataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	status?:ResolverInputTypes["FieldMeta"],
	isSuccessful?:ResolverInputTypes["FieldMeta"],
	isFinished?:ResolverInputTypes["FieldMeta"],
	resolvedOriginalPayId?:ResolverInputTypes["FieldMeta"],
	csobPayment?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CsobPaymentStatusChangeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeEdge"]: AliasType<{
	node?:ResolverInputTypes["CsobPaymentStatusChange"],
		__typename?: boolean | `@${string}`
}>;
	["StripePayment"]: AliasType<{
	_meta?:ResolverInputTypes["StripePaymentMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
statusChanges?: [{	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StripePaymentStatusChange"]],
payment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
metadata?: [{	filter?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null},ResolverInputTypes["StripePaymentMetadata"]],
paginateStatusChanges?: [{	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StripePaymentStatusChangeConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	identifier?:ResolverInputTypes["FieldMeta"],
	statusChanges?:ResolverInputTypes["FieldMeta"],
	payment?:ResolverInputTypes["FieldMeta"],
	metadata?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChange"]: AliasType<{
	_meta?:ResolverInputTypes["StripePaymentStatusChangeMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
payment?: [{	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null},ResolverInputTypes["StripePayment"]],
	timestamp?:boolean | `@${string}`,
	eventId?:boolean | `@${string}`,
	paymentIntentStatus?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	payment?:ResolverInputTypes["FieldMeta"],
	timestamp?:ResolverInputTypes["FieldMeta"],
	eventId?:ResolverInputTypes["FieldMeta"],
	paymentIntentStatus?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	payment?: ResolverInputTypes["StripePaymentOrderBy"] | undefined | null,
	timestamp?: ResolverInputTypes["OrderDirection"] | undefined | null,
	eventId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	paymentIntentStatus?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["StripePaymentMetadata"]: AliasType<{
	_meta?:ResolverInputTypes["StripePaymentMetadataMeta"],
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	isSuccessful?:boolean | `@${string}`,
	isFinished?:boolean | `@${string}`,
stripePayment?: [{	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null},ResolverInputTypes["StripePayment"]],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentMetadataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	status?:ResolverInputTypes["FieldMeta"],
	isSuccessful?:ResolverInputTypes["FieldMeta"],
	isFinished?:ResolverInputTypes["FieldMeta"],
	stripePayment?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["StripePaymentStatusChangeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeEdge"]: AliasType<{
	node?:ResolverInputTypes["StripePaymentStatusChange"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItem"]: AliasType<{
	_meta?:ResolverInputTypes["UserRecurringPaymentItemMeta"],
	id?:boolean | `@${string}`,
	recurrenceCounter?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	taskId?:boolean | `@${string}`,
payments?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPayment"]],
recurringPayment?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
	isFailed?:boolean | `@${string}`,
	failedEmailSentAt?:boolean | `@${string}`,
meta?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItemMetadata"]],
paymentsByOrder?: [{	by: ResolverInputTypes["UserRecurringPaymentItemPaymentsByOrderUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByCsobPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByStripePayment?: [{	by: ResolverInputTypes["UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByMetadata?: [{	by: ResolverInputTypes["UserRecurringPaymentItemPaymentsByMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paginatePayments?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	recurrenceCounter?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	taskId?:ResolverInputTypes["FieldMeta"],
	payments?:ResolverInputTypes["FieldMeta"],
	recurringPayment?:ResolverInputTypes["FieldMeta"],
	isFailed?:ResolverInputTypes["FieldMeta"],
	failedEmailSentAt?:ResolverInputTypes["FieldMeta"],
	meta?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPayment"]: AliasType<{
	_meta?:ResolverInputTypes["UserRecurringPaymentMeta"],
	id?:boolean | `@${string}`,
	activeSince?:boolean | `@${string}`,
	cancelledAt?:boolean | `@${string}`,
	cents?:boolean | `@${string}`,
	interval?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
items?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
meta?: [{	filter?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["UpcomingUserRecurringPaymentMetadata"]],
itemsByRecurrenceCounter?: [{	by: ResolverInputTypes["UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
itemsByPayments?: [{	by: ResolverInputTypes["UserRecurringPaymentItemsByPaymentsUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
itemsByMeta?: [{	by: ResolverInputTypes["UserRecurringPaymentItemsByMetaUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	activeSince?:ResolverInputTypes["FieldMeta"],
	cancelledAt?:ResolverInputTypes["FieldMeta"],
	cents?:ResolverInputTypes["FieldMeta"],
	interval?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
	meta?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UpcomingUserRecurringPaymentMetadata"]: AliasType<{
	_meta?:ResolverInputTypes["UpcomingUserRecurringPaymentMetadataMeta"],
	id?:boolean | `@${string}`,
	recurrenceCounter?:boolean | `@${string}`,
	isBehindPayments?:boolean | `@${string}`,
	nextPaymentDate?:boolean | `@${string}`,
	shouldBeProcessed?:boolean | `@${string}`,
firstPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
firstSuccessfulPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
drivingPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
recurringPayment?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["UpcomingUserRecurringPaymentMetadataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	recurrenceCounter?:ResolverInputTypes["FieldMeta"],
	isBehindPayments?:ResolverInputTypes["FieldMeta"],
	nextPaymentDate?:ResolverInputTypes["FieldMeta"],
	shouldBeProcessed?:ResolverInputTypes["FieldMeta"],
	firstPayment?:ResolverInputTypes["FieldMeta"],
	firstSuccessfulPayment?:ResolverInputTypes["FieldMeta"],
	drivingPayment?:ResolverInputTypes["FieldMeta"],
	recurringPayment?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere"]: {
	recurrenceCounter?: number | undefined | null
};
	["UserRecurringPaymentItemsByPaymentsUniqueWhere"]: {
	payments?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null
};
	["UserPaymentUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null,
	csobPayment?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null,
	stripePayment?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserPaymentOrderIdUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	seq?: number | undefined | null
};
	["CsobPaymentUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	payId?: string | undefined | null,
	statusChanges?: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null,
	payment?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentMetadataUniqueWhere"] | undefined | null
};
	["CsobPaymentStatusChangeUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["CsobPaymentMetadataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	csobPayment?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null
};
	["StripePaymentUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	statusChanges?: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null,
	payment?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentMetadataUniqueWhere"] | undefined | null
};
	["StripePaymentStatusChangeUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["StripePaymentMetadataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	stripePayment?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null
};
	["UserPaymentMetadataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	userPayment?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentItemsByMetaUniqueWhere"]: {
	meta?: ResolverInputTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentItemMetadataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	firstPayment?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	lastPayment?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	recurrenceCounter?: number | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	payments?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null,
	meta?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined | null
};
	["UpcomingUserRecurringPaymentMetadataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	firstPayment?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserRecurringPaymentItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemEdge"]: AliasType<{
	node?:ResolverInputTypes["UserRecurringPaymentItem"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMetadata"]: AliasType<{
	_meta?:ResolverInputTypes["UserRecurringPaymentItemMetadataMeta"],
	id?:boolean | `@${string}`,
	isSuccessfullyPaid?:boolean | `@${string}`,
	shouldBeProcessed?:boolean | `@${string}`,
firstPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
lastPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
firstSuccessfulPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
drivingPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
recurringPaymentItem?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMetadataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	isSuccessfullyPaid?:ResolverInputTypes["FieldMeta"],
	shouldBeProcessed?:ResolverInputTypes["FieldMeta"],
	firstPayment?:ResolverInputTypes["FieldMeta"],
	lastPayment?:ResolverInputTypes["FieldMeta"],
	firstSuccessfulPayment?:ResolverInputTypes["FieldMeta"],
	drivingPayment?:ResolverInputTypes["FieldMeta"],
	recurringPaymentItem?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemPaymentsByOrderUniqueWhere"]: {
	order?: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentItemPaymentsByMetadataUniqueWhere"]: {
	metadata?: ResolverInputTypes["UserPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserPaymentConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentEdge"]: AliasType<{
	node?:ResolverInputTypes["UserPayment"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonation"]: AliasType<{
	_meta?:ResolverInputTypes["OnBehalfDonationMeta"],
	id?:boolean | `@${string}`,
	secretCode?:boolean | `@${string}`,
	specificSymbol?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
payments?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPayment"]],
onBehalfOf?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
meta?: [{	filter?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonationMetadata"]],
paymentsByOrder?: [{	by: ResolverInputTypes["OnBehalfDonationPaymentsByOrderUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByCsobPayment?: [{	by: ResolverInputTypes["OnBehalfDonationPaymentsByCsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByStripePayment?: [{	by: ResolverInputTypes["OnBehalfDonationPaymentsByStripePaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentsByMetadata?: [{	by: ResolverInputTypes["OnBehalfDonationPaymentsByMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paginatePayments?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	secretCode?:ResolverInputTypes["FieldMeta"],
	specificSymbol?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	payments?:ResolverInputTypes["FieldMeta"],
	onBehalfOf?:ResolverInputTypes["FieldMeta"],
	meta?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMetadata"]: AliasType<{
	_meta?:ResolverInputTypes["OnBehalfDonationMetadataMeta"],
	id?:boolean | `@${string}`,
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
onBehalfOfDonation?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMetadataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
	onBehalfOfDonation?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationPaymentsByOrderUniqueWhere"]: {
	order?: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null
};
	["OnBehalfDonationPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null
};
	["OnBehalfDonationPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null
};
	["OnBehalfDonationPaymentsByMetadataUniqueWhere"]: {
	metadata?: ResolverInputTypes["UserPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollection"]: AliasType<{
	_meta?:ResolverInputTypes["UserPaymentTriesCollectionMeta"],
	id?:boolean | `@${string}`,
	cents?:boolean | `@${string}`,
	specificSymbol?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	orderUrl?:boolean | `@${string}`,
payment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPayment"]],
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
onBehalfDonation?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
recurring?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
metadata?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadata"]],
metadataLocales?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocale"]],
	medium?:boolean | `@${string}`,
paymentByOrder?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionPaymentByOrderUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentByCsobPayment?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentByStripePayment?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
paymentByMetadata?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionPaymentByMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
metadataLocalesByLocale?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocale"]],
paginatePayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentConnection"]],
paginateMetadataLocales?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	cents?:ResolverInputTypes["FieldMeta"],
	specificSymbol?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	orderUrl?:ResolverInputTypes["FieldMeta"],
	payment?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	onBehalfDonation?:ResolverInputTypes["FieldMeta"],
	recurring?:ResolverInputTypes["FieldMeta"],
	metadata?:ResolverInputTypes["FieldMeta"],
	metadataLocales?:ResolverInputTypes["FieldMeta"],
	medium?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadata"]: AliasType<{
	_meta?:ResolverInputTypes["UserPaymentTriesCollectionMetadataMeta"],
	id?:boolean | `@${string}`,
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
triesCollection?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
	triesCollection?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataLocale"]: AliasType<{
	_meta?:ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleMeta"],
	id?:boolean | `@${string}`,
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
	title?:boolean | `@${string}`,
parent?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	parent?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	parent?: ResolverInputTypes["UserPaymentTriesCollectionOrderBy"] | undefined | null
};
	["UserPaymentTriesCollectionPaymentByOrderUniqueWhere"]: {
	order?: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere"]: {
	csobPayment?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere"]: {
	stripePayment?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionPaymentByMetadataUniqueWhere"]: {
	metadata?: ResolverInputTypes["UserPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionMetadataLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["UserPaymentTriesCollectionMetadataLocale"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentMetadata"]: AliasType<{
	_meta?:ResolverInputTypes["UserPaymentMetadataMeta"],
	id?:boolean | `@${string}`,
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
organizationUnfiltered?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
countToUser?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
	paymentType?:boolean | `@${string}`,
	statusLabel?:boolean | `@${string}`,
	isSuccessful?:boolean | `@${string}`,
	isFinished?:boolean | `@${string}`,
	needsCacheUpdate?:boolean | `@${string}`,
	isSuccessfulNotCached?:boolean | `@${string}`,
	isFinishedNotCached?:boolean | `@${string}`,
userPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentMetadataMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
	organizationUnfiltered?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
	countToUser?:ResolverInputTypes["FieldMeta"],
	paymentType?:ResolverInputTypes["FieldMeta"],
	statusLabel?:ResolverInputTypes["FieldMeta"],
	isSuccessful?:ResolverInputTypes["FieldMeta"],
	isFinished?:ResolverInputTypes["FieldMeta"],
	needsCacheUpdate?:ResolverInputTypes["FieldMeta"],
	isSuccessfulNotCached?:ResolverInputTypes["FieldMeta"],
	isFinishedNotCached?:ResolverInputTypes["FieldMeta"],
	userPayment?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Device"]: AliasType<{
	_meta?:ResolverInputTypes["DeviceMeta"],
	id?:boolean | `@${string}`,
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
	fcmToken?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	ipAddress?:boolean | `@${string}`,
	userAgent?:boolean | `@${string}`,
	lastActiveAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DeviceMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
	fcmToken?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	ipAddress?:ResolverInputTypes["FieldMeta"],
	userAgent?:ResolverInputTypes["FieldMeta"],
	lastActiveAt?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null,
	fcmToken?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ipAddress?: ResolverInputTypes["OrderDirection"] | undefined | null,
	userAgent?: ResolverInputTypes["OrderDirection"] | undefined | null,
	lastActiveAt?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ProcessedNotificationSourceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationOrderBy"] | undefined | null,
	donationReminderUser?: ResolverInputTypes["UserOrderBy"] | undefined | null,
	scheduledNotification?: ResolverInputTypes["ScheduledNotificationOrderBy"] | undefined | null
};
	["ProcessedNotificationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	topic?: ResolverInputTypes["OrderDirection"] | undefined | null,
	sentAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	errorMessage?: ResolverInputTypes["OrderDirection"] | undefined | null,
	errorCode?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isSuccess?: ResolverInputTypes["OrderDirection"] | undefined | null,
	source?: ResolverInputTypes["ProcessedNotificationSourceOrderBy"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	body?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["UserAreaStats"]: AliasType<{
	_meta?:ResolverInputTypes["UserAreaStatsMeta"],
	id?:boolean | `@${string}`,
area?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
	totalCents?:boolean | `@${string}`,
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserAreaStatsMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	area?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserAreaStatsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	area?: ResolverInputTypes["PostAreaOrderBy"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null
};
	["UserOrganizationStats"]: AliasType<{
	_meta?:ResolverInputTypes["UserOrganizationStatsMeta"],
	id?:boolean | `@${string}`,
organization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
	totalCents?:boolean | `@${string}`,
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserOrganizationStatsMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	organization?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserOrganizationStatsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	organization?: ResolverInputTypes["PostOrganizationOrderBy"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null
};
	["UserPostStats"]: AliasType<{
	_meta?:ResolverInputTypes["UserPostStatsMeta"],
	id?:boolean | `@${string}`,
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
	totalCents?:boolean | `@${string}`,
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserPostStatsMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	totalCents?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPostStatsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	totalCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null
};
	["UserCurrencyStats"]: AliasType<{
	_meta?:ResolverInputTypes["UserCurrencyStatsMeta"],
	id?:boolean | `@${string}`,
currency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
	totalAmountPaymentsOnce?:boolean | `@${string}`,
	totalAmountPaymentsRegular?:boolean | `@${string}`,
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserCurrencyStatsMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	currency?:ResolverInputTypes["FieldMeta"],
	totalAmountPaymentsOnce?:ResolverInputTypes["FieldMeta"],
	totalAmountPaymentsRegular?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserCurrencyStatsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	currency?: ResolverInputTypes["CurrencyOrderBy"] | undefined | null,
	totalAmountPaymentsOnce?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalAmountPaymentsRegular?: ResolverInputTypes["OrderDirection"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null
};
	["UserStats"]: AliasType<{
	_meta?:ResolverInputTypes["UserStatsMeta"],
	id?:boolean | `@${string}`,
	totalPaymentsSuccessful?:boolean | `@${string}`,
	totalPaymentsUnsuccessful?:boolean | `@${string}`,
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserStatsMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	totalPaymentsSuccessful?:ResolverInputTypes["FieldMeta"],
	totalPaymentsUnsuccessful?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentsByOrderUniqueWhere"]: {
	order?: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null
};
	["UserPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null
};
	["UserPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null
};
	["UserPaymentsByMetadataUniqueWhere"]: {
	metadata?: ResolverInputTypes["UserPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentsByItemsUniqueWhere"]: {
	items?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentsByMetaUniqueWhere"]: {
	meta?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserOnBehalfDonationsBySecretCodeUniqueWhere"]: {
	secretCode?: string | undefined | null
};
	["UserOnBehalfDonationsByPaymentsUniqueWhere"]: {
	payments?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null
};
	["UserOnBehalfDonationsByMetaUniqueWhere"]: {
	meta?: ResolverInputTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined | null
};
	["OnBehalfDonationMetadataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	onBehalfOfDonation?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null
};
	["OnBehalfDonationUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	secretCode?: string | undefined | null,
	payments?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined | null
};
	["UserDevicesByFcmTokenUniqueWhere"]: {
	fcmToken?: string | undefined | null
};
	["UserProcessedNotificationsByProcessedNotificationUniqueWhere"]: {
	processedNotification?: ResolverInputTypes["ProcessedNotificationUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserRecurringPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentEdge"]: AliasType<{
	node?:ResolverInputTypes["UserRecurringPayment"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["OnBehalfDonationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationEdge"]: AliasType<{
	node?:ResolverInputTypes["OnBehalfDonation"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["DeviceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceEdge"]: AliasType<{
	node?:ResolverInputTypes["Device"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ProcessedNotificationSourceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceEdge"]: AliasType<{
	node?:ResolverInputTypes["ProcessedNotificationSource"],
		__typename?: boolean | `@${string}`
}>;
	["UserAreaStatsConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserAreaStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserAreaStatsEdge"]: AliasType<{
	node?:ResolverInputTypes["UserAreaStats"],
		__typename?: boolean | `@${string}`
}>;
	["UserOrganizationStatsConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserOrganizationStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserOrganizationStatsEdge"]: AliasType<{
	node?:ResolverInputTypes["UserOrganizationStats"],
		__typename?: boolean | `@${string}`
}>;
	["UserPostStatsConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserPostStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPostStatsEdge"]: AliasType<{
	node?:ResolverInputTypes["UserPostStats"],
		__typename?: boolean | `@${string}`
}>;
	["UserCurrencyStatsConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserCurrencyStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserCurrencyStatsEdge"]: AliasType<{
	node?:ResolverInputTypes["UserCurrencyStats"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere"]: {
	processedNotification?: ResolverInputTypes["ProcessedNotificationUniqueWhere"] | undefined | null
};
	["ScheduledNotificationLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ScheduledNotificationLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["ScheduledNotificationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleGeneralsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["GeneralUniqueWhere"] | undefined | null
};
	["LocaleGeneralsBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleGeneralsByAppStoreLinkUniqueWhere"]: {
	appStoreLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleGeneralsByGooglePlayLinkUniqueWhere"]: {
	googlePlayLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocalePostsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["PostUniqueWhere"] | undefined | null
};
	["LocalePostsByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocalePostsBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocalePostsByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocalePostAreasByRootUniqueWhere"]: {
	root?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null
};
	["LocalePostAreasByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocalePostAreasBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocalePostAreasByBannerUniqueWhere"]: {
	banner?: ResolverInputTypes["AppBannerUniqueWhere"] | undefined | null
};
	["LocalePostAreasByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocalePostOrganizationsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null
};
	["LocalePostOrganizationsByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocalePostOrganizationsByDomainUniqueWhere"]: {
	domain?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocalePostOrganizationsBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocalePostOrganizationsByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleHeadersByRootUniqueWhere"]: {
	root?: ResolverInputTypes["HeaderUniqueWhere"] | undefined | null
};
	["LocaleHeadersByLinksUniqueWhere"]: {
	links?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null
};
	["LocaleFootersByRootUniqueWhere"]: {
	root?: ResolverInputTypes["FooterUniqueWhere"] | undefined | null
};
	["LocaleFootersByLinkListUniqueWhere"]: {
	linkList?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null
};
	["LocaleFootersByAddressInfoUniqueWhere"]: {
	addressInfo?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleFootersByImageLinkListUniqueWhere"]: {
	imageLinkList?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null
};
	["LocaleGenericPageAboutSettingsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"] | undefined | null
};
	["LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere"]: {
	linkGroups?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null
};
	["LocalePostRevisionsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null
};
	["LocalePostRevisionsByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocalePostRevisionsBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocalePostRevisionsByLeadContentUniqueWhere"]: {
	leadContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleFeedPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["FeedPageUniqueWhere"] | undefined | null
};
	["LocaleFeedPagesByHeroTilesUniqueWhere"]: {
	heroTiles?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null
};
	["LocaleFeedPagesBySectionListUniqueWhere"]: {
	sectionList?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null
};
	["LocaleFeedPagesByCardListUniqueWhere"]: {
	cardList?: ResolverInputTypes["CardListUniqueWhere"] | undefined | null
};
	["LocaleFeedPagesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null
};
	["LocaleRecurringPaymentPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["RecurringPaymentPageUniqueWhere"] | undefined | null
};
	["LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere"]: {
	favouritePosts?: ResolverInputTypes["PostListUniqueWhere"] | undefined | null
};
	["LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null
};
	["LocaleGivenGiftsPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["GivenGiftsPageUniqueWhere"] | undefined | null
};
	["LocaleGivenGiftsPagesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleGivenGiftsPagesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleGivenGiftsPagesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleReceivedGiftsPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"] | undefined | null
};
	["LocaleReceivedGiftsPagesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleReceivedGiftsPagesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleReceivedGiftsPagesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleReportPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["ReportPageUniqueWhere"] | undefined | null
};
	["LocaleReportPagesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleReportPagesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleReportPagesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleReportNavigationsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["ReportNavigationUniqueWhere"] | undefined | null
};
	["LocaleScheduledNotificationsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["ScheduledNotificationUniqueWhere"] | undefined | null
};
	["LocaleSentPaymentsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null
};
	["GeneralLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GeneralLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["GeneralLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["GeneralLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["GeneralLocalesByAppStoreLinkUniqueWhere"]: {
	appStoreLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["GeneralLocalesByGooglePlayLinkUniqueWhere"]: {
	googlePlayLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["GeneralConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GeneralEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralEdge"]: AliasType<{
	node?:ResolverInputTypes["General"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationResult"]: AliasType<{
	valid?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_ValidationError"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationError"]: AliasType<{
	path?:ResolverInputTypes["_PathFragment"],
	message?:ResolverInputTypes["_ValidationMessage"],
		__typename?: boolean | `@${string}`
}>;
	["_PathFragment"]: AliasType<{
	_FieldPathFragment?:ResolverInputTypes["_FieldPathFragment"],
	_IndexPathFragment?:ResolverInputTypes["_IndexPathFragment"],
		__typename?: boolean | `@${string}`
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:boolean | `@${string}`,
	alias?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_ValidationMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["GeneralCreateLocalesEntityRelationInput"]> | undefined | null,
	allAreasIcon?: ResolverInputTypes["GeneralCreateAllAreasIconEntityRelationInput"] | undefined | null,
	allOrganizationsIcon?: ResolverInputTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["GeneralCreateOrganizationListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GeneralLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GeneralLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null,
	appStoreLink?: ResolverInputTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined | null,
	allAreasDescription?: string | undefined | null,
	allOrganizationsDescription?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGeneralsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutGeneralsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateGenericPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateGenericPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["GenericPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["GenericPageType"] | undefined | null,
	order?: number | undefined | null,
	reportNavigation?: Array<ResolverInputTypes["GenericPageCreateReportNavigationEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageCreateReportNavigationEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageConnectOrCreateReportNavigationRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportNavigationLocaleWithoutPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportNavigationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportNavigationWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["ReportNavigationWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["ReportNavigationUniqueWhere"],
	create: ResolverInputTypes["ReportNavigationWithoutLocalesCreateInput"]
};
	["ReportNavigationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutReportNavigationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutReportNavigationsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateGeneralsEntityRelationInput"]: {
	connect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateGeneralsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GeneralLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null,
	appStoreLink?: ResolverInputTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined | null,
	allAreasDescription?: string | undefined | null,
	allOrganizationsDescription?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GeneralUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GeneralWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["GeneralWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	allAreasIcon?: ResolverInputTypes["GeneralCreateAllAreasIconEntityRelationInput"] | undefined | null,
	allOrganizationsIcon?: ResolverInputTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["GeneralCreateOrganizationListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralCreateAllAreasIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralConnectOrCreateAllAreasIconRelationInput"] | undefined | null
};
	["ImageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	alt?: string | undefined | null,
	fileName?: string | undefined | null,
	focalPointX?: number | undefined | null,
	focalPointY?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralConnectOrCreateAllAreasIconRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["GeneralCreateAllOrganizationsIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"] | undefined | null
};
	["GeneralConnectOrCreateAllOrganizationsIconRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["GeneralCreateOrganizationListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralConnectOrCreateOrganizationListRelationInput"] | undefined | null
};
	["PostOrganizationListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["PostOrganizationListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationListItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	item?: ResolverInputTypes["PostOrganizationListItemCreateItemEntityRelationInput"] | undefined | null,
	type?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	link?: ResolverInputTypes["PostOrganizationListItemCreateLinkEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["PostOrganizationListItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationListItemCreateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"] | undefined | null
};
	["PostOrganizationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	posts?: Array<ResolverInputTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined | null,
	icon?: ResolverInputTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	area?: ResolverInputTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined | null,
	isHidden?: boolean | undefined | null,
	color?: string | undefined | null,
	plainIcon?: ResolverInputTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationCreatePostsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutOrganizationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreatePostsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostWithoutOrganizationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	area?: ResolverInputTypes["PostCreateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostCreateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostCreateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostCreateAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateAreaRelationInput"] | undefined | null
};
	["PostAreaWithoutPostsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostAreaCreateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined | null,
	color?: string | undefined | null,
	specificSymbol?: number | undefined | null,
	region?: ResolverInputTypes["PostAreaCreateRegionEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaCreateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined | null,
	plainIcon?: ResolverInputTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaCreateIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateIconRelationInput"] | undefined | null
};
	["PostAreaConnectOrCreateIconRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostAreaCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined | null,
	banner?: ResolverInputTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined | null,
	shortDescription?: string | undefined | null,
	content?: ResolverInputTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutPostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutPostAreaCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableCreatePostEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined | null
};
	["GenericPageLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGenericPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutGenericPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreatePostsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreatePostsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	content?: ResolverInputTypes["PostLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostLocaleCreateRootEntityRelationInput"] | undefined | null,
	paymentName?: string | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["ContentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	blocks?: Array<ResolverInputTypes["ContentCreateBlocksEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentBlockWithoutContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentConnectOrCreateBlocksRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	references?: Array<ResolverInputTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	image?: ResolverInputTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null,
	video?: ResolverInputTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null,
	contentAlignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	valueList?: ResolverInputTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined | null,
	areaList?: ResolverInputTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined | null,
	isAppsVisible?: boolean | undefined | null,
	accordion?: ResolverInputTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null,
	memberList?: ResolverInputTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined | null,
	asideMediaContentLayout?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	isAsideMediaContentMobileLayout?: boolean | undefined | null,
	form?: ResolverInputTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined | null,
	isTitleBigger?: boolean | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined | null,
	heroCarousel?: ResolverInputTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined | null,
	isCentered?: boolean | undefined | null,
	posts?: Array<ResolverInputTypes["ContentReferenceCreatePostsEntityRelationInput"]> | undefined | null,
	textImageList?: ResolverInputTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined | null
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ContentReferenceCreateLinkablesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined | null
};
	["VideoUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["VideoCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	poster?: ResolverInputTypes["VideoCreatePosterEntityRelationInput"] | undefined | null,
	shapeType?: ResolverInputTypes["VideoShapeType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["VideoConnectOrCreatePosterRelationInput"] | undefined | null
};
	["VideoConnectOrCreatePosterRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
	connect: ResolverInputTypes["VideoUniqueWhere"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["LinkEnum"] | undefined | null,
	title?: string | undefined | null,
	externalLink?: string | undefined | null,
	internalLink?: ResolverInputTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined | null,
	isTargetBlank?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined | null
};
	["LinkableCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableCreatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreatePostRelationInput"] | undefined | null
};
	["PostLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	content?: ResolverInputTypes["PostLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostLocaleCreateRootEntityRelationInput"] | undefined | null,
	paymentName?: string | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["SeoCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	ogTitle?: string | undefined | null,
	ogDescription?: string | undefined | null,
	noIndex?: boolean | undefined | null,
	noFollow?: boolean | undefined | null,
	ogImage?: ResolverInputTypes["SeoCreateOgImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined | null
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["PostLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutPostsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreatePostAreasEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreatePostAreasRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined | null,
	banner?: ResolverInputTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined | null,
	shortDescription?: string | undefined | null,
	content?: ResolverInputTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["PostAreaWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostAreaCreateIconEntityRelationInput"] | undefined | null,
	regionListOverride?: ResolverInputTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined | null,
	color?: string | undefined | null,
	posts?: Array<ResolverInputTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	region?: ResolverInputTypes["PostAreaCreateRegionEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaCreateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined | null,
	plainIcon?: ResolverInputTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaCreateRegionListOverrideEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"] | undefined | null
};
	["DonationAmountsRegionListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	regions?: Array<ResolverInputTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"]> | undefined | null,
	donation?: ResolverInputTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionListCreateRegionsEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DonationAmountsRegionItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	items?: Array<ResolverInputTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined | null,
	region?: ResolverInputTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined | null,
	minimumAmount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountItemWithoutRegionItemCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DonationAmountItemWithoutRegionItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	amount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["DonationAmountItemUniqueWhere"],
	create: ResolverInputTypes["DonationAmountItemWithoutRegionItemCreateInput"]
};
	["DonationAmountsRegionItemCreateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionWithoutDonationItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"] | undefined | null
};
	["RegionWithoutDonationItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	currency?: ResolverInputTypes["RegionCreateCurrencyEntityRelationInput"] | undefined | null,
	enabledPaymentMethods?: Array<ResolverInputTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"]> | undefined | null,
	timezone?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionCreateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RegionConnectOrCreateCurrencyRelationInput"] | undefined | null
};
	["CurrencyUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null,
	areaSentPaymentCurrencySums?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	areaCurrencySums?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	organizationCurrencySums?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	postCurrencySums?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null
};
	["CurrencyCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null,
	label?: string | undefined | null,
	sign?: string | undefined | null,
	signAlignment?: ResolverInputTypes["CurrencySignAlignment"] | undefined | null,
	defaultDonationAmount?: number | undefined | null,
	rateAgainstCzk?: number | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["CurrencyCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	postCurrencySums?: Array<ResolverInputTypes["CurrencyCreatePostCurrencySumsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CurrencyCreateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CurrencyCreatePostCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RegionConnectOrCreateCurrencyRelationInput"]: {
	connect: ResolverInputTypes["CurrencyUniqueWhere"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["RegionCreateEnabledPaymentMethodsEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionPaymentMethodUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionPaymentMethodWithoutRegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["RegionPaymentMethodWithoutRegionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	allowRecurringPayments?: boolean | undefined | null,
	method?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"]: {
	connect: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],
	create: ResolverInputTypes["RegionPaymentMethodWithoutRegionCreateInput"]
};
	["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"]: {
	connect: ResolverInputTypes["RegionUniqueWhere"],
	create: ResolverInputTypes["RegionWithoutDonationItemsCreateInput"]
};
	["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"]: {
	connect: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],
	create: ResolverInputTypes["DonationAmountsRegionItemWithoutListCreateInput"]
};
	["DonationAmountsRegionListCreateDonationEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationWithoutRegionListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"] | undefined | null
};
	["DonationWithoutRegionListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionListConnectOrCreateDonationRelationInput"]: {
	connect: ResolverInputTypes["DonationUniqueWhere"],
	create: ResolverInputTypes["DonationWithoutRegionListCreateInput"]
};
	["PostAreaConnectOrCreateRegionListOverrideRelationInput"]: {
	connect: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],
	create: ResolverInputTypes["DonationAmountsRegionListCreateInput"]
};
	["PostAreaCreatePostsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreatePostsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostWithoutAreaCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostCreateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostCreateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostCreateOrganizationEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateOrganizationRelationInput"] | undefined | null
};
	["PostOrganizationWithoutPostsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	area?: ResolverInputTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined | null,
	isHidden?: boolean | undefined | null,
	color?: string | undefined | null,
	plainIcon?: ResolverInputTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationCreateIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateIconRelationInput"] | undefined | null
};
	["PostOrganizationConnectOrCreateIconRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	domain?: ResolverInputTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutPostOrganizationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutPostOrganizationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableCreatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreatePostAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreatePostAreaRelationInput"] | undefined | null
};
	["PostAreaLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	root?: ResolverInputTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined | null,
	banner?: ResolverInputTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined | null,
	shortDescription?: string | undefined | null,
	content?: ResolverInputTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutPostAreasCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutPostAreasCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreatePostOrganizationsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreatePostOrganizationsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined | null,
	domain?: ResolverInputTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["PostOrganizationWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	posts?: Array<ResolverInputTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined | null,
	icon?: ResolverInputTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	area?: ResolverInputTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined | null,
	isHidden?: boolean | undefined | null,
	color?: string | undefined | null,
	plainIcon?: ResolverInputTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationCreateAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateAreaRelationInput"] | undefined | null
};
	["PostAreaCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostAreaCreateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined | null,
	color?: string | undefined | null,
	posts?: Array<ResolverInputTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	region?: ResolverInputTypes["PostAreaCreateRegionEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaCreateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined | null,
	plainIcon?: ResolverInputTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaCreateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateRegionRelationInput"] | undefined | null
};
	["RegionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	currency?: ResolverInputTypes["RegionCreateCurrencyEntityRelationInput"] | undefined | null,
	enabledPaymentMethods?: Array<ResolverInputTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"]> | undefined | null,
	donationItems?: Array<ResolverInputTypes["RegionCreateDonationItemsEntityRelationInput"]> | undefined | null,
	timezone?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionCreateDonationItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RegionConnectOrCreateDonationItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DonationAmountsRegionItemWithoutRegionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	items?: Array<ResolverInputTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined | null,
	minimumAmount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"] | undefined | null
};
	["DonationAmountsRegionListWithoutRegionsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	donation?: ResolverInputTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],
	create: ResolverInputTypes["DonationAmountsRegionListWithoutRegionsCreateInput"]
};
	["RegionConnectOrCreateDonationItemsRelationInput"]: {
	connect: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],
	create: ResolverInputTypes["DonationAmountsRegionItemWithoutRegionCreateInput"]
};
	["PostAreaConnectOrCreateRegionRelationInput"]: {
	connect: ResolverInputTypes["RegionUniqueWhere"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["PostAreaCreateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaMetaDataUniqueWhere"] | undefined | null
};
	["PostAreaCreateMobileHeroImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"] | undefined | null
};
	["PostAreaConnectOrCreateMobileHeroImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostAreaCreatePlainIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreatePlainIconRelationInput"] | undefined | null
};
	["PostAreaConnectOrCreatePlainIconRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostAreaCreateSentPaymentsEntityRelationInput"]: {
	connect?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SentPaymentWithoutAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateSentPaymentsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SentPaymentWithoutAreaCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	sendAt?: ResolverInputTypes["DateTime"] | undefined | null,
	currency?: ResolverInputTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null
};
	["SentPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ResolverInputTypes["CurrencyUniqueWhere"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["SentPaymentCreateOrganizationEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentConnectOrCreateOrganizationRelationInput"] | undefined | null
};
	["PostOrganizationWithoutSentPaymentsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	posts?: Array<ResolverInputTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined | null,
	icon?: ResolverInputTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	area?: ResolverInputTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined | null,
	isHidden?: boolean | undefined | null,
	color?: string | undefined | null,
	plainIcon?: ResolverInputTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationCreateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationMetaDataUniqueWhere"] | undefined | null
};
	["PostOrganizationCreateMobileHeroImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"] | undefined | null
};
	["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationCreatePlainIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"] | undefined | null
};
	["PostOrganizationConnectOrCreatePlainIconRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationCreateDesktopHeroImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"] | undefined | null
};
	["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationCreateOrganizationSumEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationSumUniqueWhere"] | undefined | null
};
	["SentPaymentConnectOrCreateOrganizationRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationWithoutSentPaymentsCreateInput"]
};
	["SentPaymentCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SentPaymentLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SentPaymentLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organizationText?: string | undefined | null,
	locale?: ResolverInputTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutSentPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutSentPaymentsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateHeadersEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateHeadersRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined | null,
	links?: ResolverInputTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeaderUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeaderWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["HeaderWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	logo?: ResolverInputTypes["HeaderCreateLogoEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["HeaderCreateOrganizationListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined | null
};
	["HeaderConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HeaderCreateOrganizationListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateOrganizationListRelationInput"] | undefined | null
};
	["HeaderConnectOrCreateOrganizationListRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationListUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationListCreateInput"]
};
	["HeaderLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["HeaderUniqueWhere"],
	create: ResolverInputTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleCreateLinksEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLinksRelationInput"] | undefined | null
};
	["LinkListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["LinkListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["LinkItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	link?: ResolverInputTypes["LinkItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkItemCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkItemConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkItemConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LinkListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["LinkItemUniqueWhere"],
	create: ResolverInputTypes["LinkItemWithoutListCreateInput"]
};
	["HeaderLocaleConnectOrCreateLinksRelationInput"]: {
	connect: ResolverInputTypes["LinkListUniqueWhere"],
	create: ResolverInputTypes["LinkListCreateInput"]
};
	["LocaleConnectOrCreateHeadersRelationInput"]: {
	connect: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	create: ResolverInputTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateFootersEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateFootersRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	copyright?: string | undefined | null,
	root?: ResolverInputTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined | null,
	linkList?: ResolverInputTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined | null,
	contactEmail?: string | undefined | null,
	addressInfo?: ResolverInputTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["FooterWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	logo?: ResolverInputTypes["FooterCreateLogoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterConnectOrCreateLogoRelationInput"] | undefined | null
};
	["FooterConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["FooterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["FooterUniqueWhere"],
	create: ResolverInputTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleCreateLinkListEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateLinkListRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateLinkListRelationInput"]: {
	connect: ResolverInputTypes["LinkListUniqueWhere"],
	create: ResolverInputTypes["LinkListCreateInput"]
};
	["FooterLocaleCreateAddressInfoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateAddressInfoRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["FooterLocaleCreateImageLinkListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"] | undefined | null
};
	["ImageLinkListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["ImageLinkListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ImageLinkItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	item?: ResolverInputTypes["ImageLinkItemCreateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkItemCreateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkItemConnectOrCreateItemRelationInput"] | undefined | null
};
	["ImageLinkUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["ImageLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	image?: ResolverInputTypes["ImageLinkCreateImageEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["ImageLinkCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkConnectOrCreateImageRelationInput"] | undefined | null
};
	["ImageLinkConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ImageLinkCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkConnectOrCreateLinkRelationInput"] | undefined | null
};
	["ImageLinkConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["ImageLinkItemConnectOrCreateItemRelationInput"]: {
	connect: ResolverInputTypes["ImageLinkUniqueWhere"],
	create: ResolverInputTypes["ImageLinkCreateInput"]
};
	["ImageLinkListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["ImageLinkItemUniqueWhere"],
	create: ResolverInputTypes["ImageLinkItemWithoutListCreateInput"]
};
	["FooterLocaleConnectOrCreateImageLinkListRelationInput"]: {
	connect: ResolverInputTypes["ImageLinkListUniqueWhere"],
	create: ResolverInputTypes["ImageLinkListCreateInput"]
};
	["LocaleConnectOrCreateFootersRelationInput"]: {
	connect: ResolverInputTypes["FooterLocaleUniqueWhere"],
	create: ResolverInputTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined | null,
	linkGroups?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["GenericPageAboutSettingsWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],
	create: ResolverInputTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"]
};
	["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	linkList?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"] | undefined | null
};
	["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"]: {
	connect: ResolverInputTypes["LinkListUniqueWhere"],
	create: ResolverInputTypes["LinkListCreateInput"]
};
	["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"]: {
	connect: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]
};
	["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"]: {
	connect: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreatePostRevisionsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreatePostRevisionsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostRevisionLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["PostRevisionLocaleCreateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined | null,
	leadContent?: ResolverInputTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined | null,
	publishNotificationText?: string | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostRevisionWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["PostRevisionWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	createdById?: ResolverInputTypes["UUID"] | undefined | null,
	publishedById?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["PostType"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	post?: ResolverInputTypes["PostRevisionCreatePostEntityRelationInput"] | undefined | null,
	tileImage?: ResolverInputTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined | null,
	tileVideo?: ResolverInputTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined | null,
	heroImage?: ResolverInputTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined | null,
	regionListOverride?: ResolverInputTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined | null,
	isOrganizationVisible?: boolean | undefined | null,
	sendPublishNotifications?: boolean | undefined | null,
	isArchived?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionCreatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutRevisionsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreatePostRelationInput"] | undefined | null
};
	["PostWithoutRevisionsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostCreateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostCreateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostCreateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostCreateActiveRevisionEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostRevisionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateActiveRevisionRelationInput"] | undefined | null
};
	["PostRevisionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	createdById?: ResolverInputTypes["UUID"] | undefined | null,
	publishedById?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["PostType"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	post?: ResolverInputTypes["PostRevisionCreatePostEntityRelationInput"] | undefined | null,
	tileImage?: ResolverInputTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined | null,
	tileVideo?: ResolverInputTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined | null,
	heroImage?: ResolverInputTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostRevisionCreateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined | null,
	isOrganizationVisible?: boolean | undefined | null,
	sendPublishNotifications?: boolean | undefined | null,
	isArchived?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionCreateTileImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateTileImageRelationInput"] | undefined | null
};
	["PostRevisionConnectOrCreateTileImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostRevisionCreateTileVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateTileVideoRelationInput"] | undefined | null
};
	["PostRevisionConnectOrCreateTileVideoRelationInput"]: {
	connect: ResolverInputTypes["VideoUniqueWhere"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["PostRevisionCreateHeroImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateHeroImageRelationInput"] | undefined | null
};
	["PostRevisionConnectOrCreateHeroImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostRevisionCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostRevisionLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostRevisionLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	locale?: ResolverInputTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined | null,
	leadContent?: ResolverInputTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined | null,
	publishNotificationText?: string | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutPostRevisionsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutPostRevisionsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateFlagImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateFlagImageRelationInput"] | undefined | null
};
	["LocaleConnectOrCreateFlagImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleCreateFeedPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateFeedPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FeedPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	heroTiles?: ResolverInputTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined | null,
	sectionList?: Array<ResolverInputTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined | null,
	cardList?: ResolverInputTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["FeedPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["FeedPageUniqueWhere"],
	create: ResolverInputTypes["FeedPageWithoutLocalesCreateInput"]
};
	["FeedPageLocaleCreateHeroTilesEntityRelationInput"]: {
	connect?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TileListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"] | undefined | null
};
	["TileListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	size?: ResolverInputTypes["TileListSize"] | undefined | null,
	title?: string | undefined | null,
	items?: Array<ResolverInputTypes["TileListCreateItemsEntityRelationInput"]> | undefined | null,
	areaType?: ResolverInputTypes["TileListCreateAreaTypeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["TileItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TileItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TileItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	type?: ResolverInputTypes["TileItemType"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	post?: ResolverInputTypes["TileItemCreatePostEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["TileItemCreateAreaEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["TileItemCreateImageEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["TileItemCreateLinkEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["TileItemCreateOrganizationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileItemCreatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreatePostRelationInput"] | undefined | null
};
	["PostCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostCreateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostCreateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostCreateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostCreateRevisionsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostRevisionWithoutPostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateRevisionsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostRevisionWithoutPostCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	createdById?: ResolverInputTypes["UUID"] | undefined | null,
	publishedById?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["PostType"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	tileImage?: ResolverInputTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined | null,
	tileVideo?: ResolverInputTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined | null,
	heroImage?: ResolverInputTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostRevisionCreateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined | null,
	isOrganizationVisible?: boolean | undefined | null,
	sendPublishNotifications?: boolean | undefined | null,
	isArchived?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionCreateRegionListOverrideEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"] | undefined | null
};
	["PostRevisionConnectOrCreateRegionListOverrideRelationInput"]: {
	connect: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],
	create: ResolverInputTypes["DonationAmountsRegionListCreateInput"]
};
	["PostConnectOrCreateRevisionsRelationInput"]: {
	connect: ResolverInputTypes["PostRevisionUniqueWhere"],
	create: ResolverInputTypes["PostRevisionWithoutPostCreateInput"]
};
	["PostCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	content?: ResolverInputTypes["PostLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	paymentName?: string | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutPostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutPostCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreatePostOrganizationEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreatePostOrganizationRelationInput"] | undefined | null
};
	["PostOrganizationLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	root?: ResolverInputTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	domain?: ResolverInputTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutPostOrganizationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutPostOrganizationsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateRecurringPaymentPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	favouritePosts?: ResolverInputTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecurringPaymentPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["RecurringPaymentPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],
	create: ResolverInputTypes["RecurringPaymentPageWithoutLocalesCreateInput"]
};
	["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"] | undefined | null
};
	["PostListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["PostListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostListItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostListItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostListItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	post?: ResolverInputTypes["PostListItemCreatePostEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostListItemCreatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostListItemConnectOrCreatePostRelationInput"] | undefined | null
};
	["PostListItemConnectOrCreatePostRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostCreateInput"]
};
	["PostListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["PostListItemUniqueWhere"],
	create: ResolverInputTypes["PostListItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"]: {
	connect: ResolverInputTypes["PostListUniqueWhere"],
	create: ResolverInputTypes["PostListCreateInput"]
};
	["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined | null
};
	["StoryGuideListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["StoryGuideListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["StoryGuideItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	guide?: ResolverInputTypes["StoryGuideItemCreateGuideEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideItemCreateGuideEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideItemConnectOrCreateGuideRelationInput"] | undefined | null
};
	["StoryGuideUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["StoryGuideCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	mediaType?: ResolverInputTypes["MediaType"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	image?: ResolverInputTypes["StoryGuideCreateImageEntityRelationInput"] | undefined | null,
	secondaryImage?: ResolverInputTypes["StoryGuideCreateSecondaryImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideConnectOrCreateImageRelationInput"] | undefined | null
};
	["StoryGuideConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["StoryGuideCreateSecondaryImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"] | undefined | null
};
	["StoryGuideConnectOrCreateSecondaryImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["StoryGuideItemConnectOrCreateGuideRelationInput"]: {
	connect: ResolverInputTypes["StoryGuideUniqueWhere"],
	create: ResolverInputTypes["StoryGuideCreateInput"]
};
	["StoryGuideListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["StoryGuideItemUniqueWhere"],
	create: ResolverInputTypes["StoryGuideItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"]: {
	connect: ResolverInputTypes["StoryGuideListUniqueWhere"],
	create: ResolverInputTypes["StoryGuideListCreateInput"]
};
	["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"]: {
	connect: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],
	create: ResolverInputTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGivenGiftsPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateGivenGiftsPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GivenGiftsPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GivenGiftsPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GivenGiftsPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["GivenGiftsPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["GivenGiftsPageUniqueWhere"],
	create: ResolverInputTypes["GivenGiftsPageWithoutLocalesCreateInput"]
};
	["GivenGiftsPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["GivenGiftsPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GivenGiftsPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutGivenGiftsPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutGivenGiftsPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableCreatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateReportPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateReportPageRelationInput"] | undefined | null
};
	["ReportPageLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	root?: ResolverInputTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	posts?: Array<ResolverInputTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["ReportPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["ReportPageUniqueWhere"],
	create: ResolverInputTypes["ReportPageWithoutLocalesCreateInput"]
};
	["ReportPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutReportPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutReportPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateReceivedGiftsPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	link?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutReceivedGiftsPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableCreatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateGivenGiftsPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"] | undefined | null
};
	["GivenGiftsPageLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutGivenGiftsPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateReportPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateReportPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	link?: ResolverInputTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	posts?: Array<ResolverInputTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutReportPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutReportPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableCreatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateReceivedGiftsPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"] | undefined | null
};
	["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["ReceivedGiftsPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],
	create: ResolverInputTypes["ReceivedGiftsPageWithoutLocalesCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutReceivedGiftsPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateReportNavigationsEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateReportNavigationsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportNavigationLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined | null,
	pages?: Array<ResolverInputTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationLocaleCreatePagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageWithoutReportNavigationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportNavigationLocaleConnectOrCreatePagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageWithoutReportNavigationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined | null,
	type?: ResolverInputTypes["GenericPageType"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["GenericPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GenericPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutGenericPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutGenericPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	post?: ResolverInputTypes["LinkableCreatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableCreateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["ReportNavigationLocaleConnectOrCreatePagesRelationInput"]: {
	connect: ResolverInputTypes["GenericPageUniqueWhere"],
	create: ResolverInputTypes["GenericPageWithoutReportNavigationCreateInput"]
};
	["LocaleConnectOrCreateReportNavigationsRelationInput"]: {
	connect: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	create: ResolverInputTypes["ReportNavigationLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateScheduledNotificationsEntityRelationInput"]: {
	connect?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateScheduledNotificationsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ScheduledNotificationLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	root?: ResolverInputTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ScheduledNotificationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ScheduledNotificationWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["ScheduledNotificationWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	localMsFromMidnight?: number | undefined | null,
	scheduledDate?: ResolverInputTypes["Date"] | undefined | null,
	internalTitle?: string | undefined | null,
	target?: ResolverInputTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined | null,
	completedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationCreateTargetEntityRelationInput"]: {
	connect?: ResolverInputTypes["NotificationTargetGroupUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["NotificationTargetGroupCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"] | undefined | null
};
	["NotificationTargetGroupUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["NotificationTargetGroupCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["NotificationTargetType"] | undefined | null,
	regions?: Array<ResolverInputTypes["NotificationTargetGroupCreateRegionsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["NotificationTargetGroupCreateRegionsEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["NotificationTargetGroupConnectOrCreateRegionsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["NotificationTargetGroupConnectOrCreateRegionsRelationInput"]: {
	connect: ResolverInputTypes["RegionUniqueWhere"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["ScheduledNotificationConnectOrCreateTargetRelationInput"]: {
	connect: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],
	create: ResolverInputTypes["NotificationTargetGroupCreateInput"]
};
	["ScheduledNotificationCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationConnectOrCreateImageRelationInput"] | undefined | null
};
	["ScheduledNotificationConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]: {
	connect?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined | null,
	donationReminderUser?: ResolverInputTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"]: {
	connect?: ResolverInputTypes["ProcessedNotificationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ProcessedNotificationWithoutSourceCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"] | undefined | null
};
	["ProcessedNotificationWithoutSourceCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	topic?: string | undefined | null,
	sentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	errorMessage?: string | undefined | null,
	errorCode?: string | undefined | null,
	isSuccess?: boolean | undefined | null,
	title?: string | undefined | null,
	body?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"]: {
	connect: ResolverInputTypes["ProcessedNotificationUniqueWhere"],
	create: ResolverInputTypes["ProcessedNotificationWithoutSourceCreateInput"]
};
	["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutProcessedNotificationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"] | undefined | null
};
	["UserUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	email?: string | undefined | null,
	variableSymbol?: number | undefined | null,
	stripeId?: string | undefined | null,
	publicProfileSecret?: string | undefined | null,
	payments?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	recurringPayments?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	onBehalfDonations?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	devices?: ResolverInputTypes["DeviceUniqueWhere"] | undefined | null,
	processedNotifications?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	areaStats?: ResolverInputTypes["UserAreaStatsUniqueWhere"] | undefined | null,
	organizationStats?: ResolverInputTypes["UserOrganizationStatsUniqueWhere"] | undefined | null,
	postStats?: ResolverInputTypes["UserPostStatsUniqueWhere"] | undefined | null,
	currencyStats?: ResolverInputTypes["UserCurrencyStatsUniqueWhere"] | undefined | null,
	stats?: ResolverInputTypes["UserStatsUniqueWhere"] | undefined | null
};
	["DeviceUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	user?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	fcmToken?: string | undefined | null
};
	["UserAreaStatsUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["UserOrganizationStatsUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["UserPostStatsUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["UserCurrencyStatsUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["UserStatsUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	user?: ResolverInputTypes["UserUniqueWhere"] | undefined | null
};
	["UserWithoutProcessedNotificationsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserCreateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserCreateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreatePaymentsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentWithoutUserCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreatePaymentsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UserPaymentWithoutUserCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null
};
	["UserPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ResolverInputTypes["CurrencyUniqueWhere"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["UserPaymentCreateOrderEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentOrderIdCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateOrderRelationInput"] | undefined | null
};
	["UserPaymentOrderIdCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	seq?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentConnectOrCreateOrderRelationInput"]: {
	connect: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],
	create: ResolverInputTypes["UserPaymentOrderIdCreateInput"]
};
	["UserPaymentCreateCsobPaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CsobPaymentWithoutPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"] | undefined | null
};
	["CsobPaymentWithoutPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	payId?: string | undefined | null,
	statusChanges?: Array<ResolverInputTypes["CsobPaymentCreateStatusChangesEntityRelationInput"]> | undefined | null,
	originalPayId?: string | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentCreateStatusChangesEntityRelationInput"]: {
	connect?: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CsobPaymentConnectOrCreateStatusChangesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CsobPaymentStatusChangeWithoutPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	dttm?: string | undefined | null,
	status?: number | undefined | null,
	resultCode?: number | undefined | null,
	message?: string | undefined | null,
	authCode?: string | undefined | null,
	statusDetail?: string | undefined | null,
	actions?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentConnectOrCreateStatusChangesRelationInput"]: {
	connect: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],
	create: ResolverInputTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"]
};
	["CsobPaymentCreateMetadataEntityRelationInput"]: {
	connect?: ResolverInputTypes["CsobPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserPaymentConnectOrCreateCsobPaymentRelationInput"]: {
	connect: ResolverInputTypes["CsobPaymentUniqueWhere"],
	create: ResolverInputTypes["CsobPaymentWithoutPaymentCreateInput"]
};
	["UserPaymentCreateStripePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StripePaymentWithoutPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"] | undefined | null
};
	["StripePaymentWithoutPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	statusChanges?: Array<ResolverInputTypes["StripePaymentCreateStatusChangesEntityRelationInput"]> | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentCreateStatusChangesEntityRelationInput"]: {
	connect?: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StripePaymentConnectOrCreateStatusChangesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["StripePaymentStatusChangeWithoutPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	timestamp?: number | undefined | null,
	eventId?: string | undefined | null,
	paymentIntentStatus?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentConnectOrCreateStatusChangesRelationInput"]: {
	connect: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],
	create: ResolverInputTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"]
};
	["StripePaymentCreateMetadataEntityRelationInput"]: {
	connect?: ResolverInputTypes["StripePaymentMetadataUniqueWhere"] | undefined | null
};
	["UserPaymentConnectOrCreateStripePaymentRelationInput"]: {
	connect: ResolverInputTypes["StripePaymentUniqueWhere"],
	create: ResolverInputTypes["StripePaymentWithoutPaymentCreateInput"]
};
	["UserPaymentCreateRecurringPaymentItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"] | undefined | null
};
	["UserRecurringPaymentItemWithoutPaymentsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	recurrenceCounter?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	taskId?: string | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"] | undefined | null,
	isFailed?: boolean | undefined | null,
	failedEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserRecurringPaymentWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"] | undefined | null
};
	["UserRecurringPaymentWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	activeSince?: ResolverInputTypes["DateTime"] | undefined | null,
	cancelledAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	interval?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	currency?: ResolverInputTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserRecurringPaymentCreateUserEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null
};
	["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ResolverInputTypes["CurrencyUniqueWhere"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["UserRecurringPaymentCreateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutRecurringPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"] | undefined | null
};
	["UserWithoutRecurringPaymentsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserCreateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserCreateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateRegionRelationInput"] | undefined | null
};
	["UserConnectOrCreateRegionRelationInput"]: {
	connect: ResolverInputTypes["RegionUniqueWhere"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["UserCreateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateCurrencyRelationInput"] | undefined | null
};
	["UserConnectOrCreateCurrencyRelationInput"]: {
	connect: ResolverInputTypes["CurrencyUniqueWhere"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["UserCreateOnBehalfDonationsEntityRelationInput"]: {
	connect?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateOnBehalfDonationsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OnBehalfDonationWithoutOnBehalfOfCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	secretCode?: string | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	payments?: Array<ResolverInputTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"]> | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OnBehalfDonationCreatePaymentsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["OnBehalfDonationConnectOrCreatePaymentsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UserPaymentWithoutOnBehalfDonationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentCreateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateRegionRelationInput"] | undefined | null
};
	["UserPaymentConnectOrCreateRegionRelationInput"]: {
	connect: ResolverInputTypes["RegionUniqueWhere"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["UserPaymentCreateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateUserRelationInput"] | undefined | null
};
	["UserWithoutPaymentsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserCreateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserCreateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreateRecurringPaymentsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserRecurringPaymentWithoutUserCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateRecurringPaymentsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UserRecurringPaymentWithoutUserCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	activeSince?: ResolverInputTypes["DateTime"] | undefined | null,
	cancelledAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	interval?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	currency?: ResolverInputTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	items?: Array<ResolverInputTypes["UserRecurringPaymentCreateItemsEntityRelationInput"]> | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserRecurringPaymentConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	recurrenceCounter?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	taskId?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]> | undefined | null,
	isFailed?: boolean | undefined | null,
	failedEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UserPaymentWithoutRecurringPaymentItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentCreateOnBehalfDonationEntityRelationInput"]: {
	connect?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"] | undefined | null
};
	["OnBehalfDonationWithoutPaymentsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	secretCode?: string | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	onBehalfOf?: ResolverInputTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutOnBehalfDonationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"] | undefined | null
};
	["UserWithoutOnBehalfDonationsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserCreateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserCreateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateSentPaymentsEntityRelationInput"]: {
	connect?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateSentPaymentsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SentPaymentLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organizationText?: string | undefined | null,
	root?: ResolverInputTypes["SentPaymentLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SentPaymentWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["SentPaymentWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	sendAt?: ResolverInputTypes["DateTime"] | undefined | null,
	currency?: ResolverInputTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentCreateAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaWithoutSentPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentConnectOrCreateAreaRelationInput"] | undefined | null
};
	["PostAreaWithoutSentPaymentsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostAreaCreateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined | null,
	color?: string | undefined | null,
	posts?: Array<ResolverInputTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	region?: ResolverInputTypes["PostAreaCreateRegionEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaCreateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined | null,
	plainIcon?: ResolverInputTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaCreateAreaSentPaymentSumEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined | null
};
	["PostAreaCreateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaCreateAreaSumEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaSumUniqueWhere"] | undefined | null
};
	["SentPaymentConnectOrCreateAreaRelationInput"]: {
	connect: ResolverInputTypes["PostAreaUniqueWhere"],
	create: ResolverInputTypes["PostAreaWithoutSentPaymentsCreateInput"]
};
	["SentPaymentLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["SentPaymentUniqueWhere"],
	create: ResolverInputTypes["SentPaymentWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],
	create: ResolverInputTypes["SentPaymentLocaleWithoutLocaleCreateInput"]
};
	["UserConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleCreateInput"]
};
	["UserCreateDevicesEntityRelationInput"]: {
	connect?: ResolverInputTypes["DeviceUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DeviceWithoutUserCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateDevicesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeviceWithoutUserCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	fcmToken?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	ipAddress?: string | undefined | null,
	userAgent?: string | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserConnectOrCreateDevicesRelationInput"]: {
	connect: ResolverInputTypes["DeviceUniqueWhere"],
	create: ResolverInputTypes["DeviceWithoutUserCreateInput"]
};
	["UserCreateProcessedNotificationsEntityRelationInput"]: {
	connect?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateProcessedNotificationsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined | null,
	scheduledNotification?: ResolverInputTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"]: {
	connect?: ResolverInputTypes["ScheduledNotificationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"] | undefined | null
};
	["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	localMsFromMidnight?: number | undefined | null,
	scheduledDate?: ResolverInputTypes["Date"] | undefined | null,
	internalTitle?: string | undefined | null,
	target?: ResolverInputTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["ScheduledNotificationCreateLocalesEntityRelationInput"]> | undefined | null,
	image?: ResolverInputTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined | null,
	completedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ScheduledNotificationLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	locale?: ResolverInputTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutScheduledNotificationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutScheduledNotificationsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutScheduledNotificationsCreateInput"]
};
	["ScheduledNotificationConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],
	create: ResolverInputTypes["ScheduledNotificationLocaleWithoutRootCreateInput"]
};
	["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"]: {
	connect: ResolverInputTypes["ScheduledNotificationUniqueWhere"],
	create: ResolverInputTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]
};
	["UserConnectOrCreateProcessedNotificationsRelationInput"]: {
	connect: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],
	create: ResolverInputTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]
};
	["UserCreateAreaStatsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserAreaStatsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserCreateOrganizationStatsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserOrganizationStatsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserCreatePostStatsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPostStatsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserCreateCurrencyStatsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserCurrencyStatsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"]: {
	connect: ResolverInputTypes["UserUniqueWhere"],
	create: ResolverInputTypes["UserWithoutOnBehalfDonationsCreateInput"]
};
	["OnBehalfDonationCreateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined | null
};
	["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"]: {
	connect: ResolverInputTypes["OnBehalfDonationUniqueWhere"],
	create: ResolverInputTypes["OnBehalfDonationWithoutPaymentsCreateInput"]
};
	["UserPaymentCreateTriesCollectionEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"] | undefined | null
};
	["UserPaymentTriesCollectionUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	payment?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentTriesCollectionMetadataUniqueWhere"] | undefined | null,
	metadataLocales?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionMetadataUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	parent?: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionWithoutPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	orderUrl?: string | undefined | null,
	user?: ResolverInputTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"] | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"] | undefined | null,
	recurring?: ResolverInputTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"] | undefined | null,
	metadataLocales?: Array<ResolverInputTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]> | undefined | null,
	medium?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionCreateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"] | undefined | null
};
	["UserCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserCreateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserCreateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"]: {
	connect: ResolverInputTypes["UserUniqueWhere"],
	create: ResolverInputTypes["UserCreateInput"]
};
	["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"] | undefined | null
};
	["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"]: {
	connect: ResolverInputTypes["CurrencyUniqueWhere"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"]: {
	connect?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["OnBehalfDonationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"] | undefined | null
};
	["OnBehalfDonationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	secretCode?: string | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	payments?: Array<ResolverInputTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"]> | undefined | null,
	onBehalfOf?: ResolverInputTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"]: {
	connect: ResolverInputTypes["OnBehalfDonationUniqueWhere"],
	create: ResolverInputTypes["OnBehalfDonationCreateInput"]
};
	["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserRecurringPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"] | undefined | null
};
	["UserRecurringPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	activeSince?: ResolverInputTypes["DateTime"] | undefined | null,
	cancelledAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	interval?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	currency?: ResolverInputTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	items?: Array<ResolverInputTypes["UserRecurringPaymentCreateItemsEntityRelationInput"]> | undefined | null,
	user?: ResolverInputTypes["UserRecurringPaymentCreateUserEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentCreateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"]: {
	connect: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],
	create: ResolverInputTypes["UserRecurringPaymentCreateInput"]
};
	["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserPaymentConnectOrCreateTriesCollectionRelationInput"]: {
	connect: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],
	create: ResolverInputTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"]
};
	["UserPaymentCreateMetadataEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentMetadataUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"]: {
	connect: ResolverInputTypes["UserPaymentUniqueWhere"],
	create: ResolverInputTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"]
};
	["UserRecurringPaymentItemCreateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined | null
};
	["UserRecurringPaymentConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],
	create: ResolverInputTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]
};
	["UserConnectOrCreateRecurringPaymentsRelationInput"]: {
	connect: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],
	create: ResolverInputTypes["UserRecurringPaymentWithoutUserCreateInput"]
};
	["UserPaymentConnectOrCreateUserRelationInput"]: {
	connect: ResolverInputTypes["UserUniqueWhere"],
	create: ResolverInputTypes["UserWithoutPaymentsCreateInput"]
};
	["OnBehalfDonationConnectOrCreatePaymentsRelationInput"]: {
	connect: ResolverInputTypes["UserPaymentUniqueWhere"],
	create: ResolverInputTypes["UserPaymentWithoutOnBehalfDonationCreateInput"]
};
	["UserConnectOrCreateOnBehalfDonationsRelationInput"]: {
	connect: ResolverInputTypes["OnBehalfDonationUniqueWhere"],
	create: ResolverInputTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"]
};
	["UserRecurringPaymentConnectOrCreateUserRelationInput"]: {
	connect: ResolverInputTypes["UserUniqueWhere"],
	create: ResolverInputTypes["UserWithoutRecurringPaymentsCreateInput"]
};
	["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"]: {
	connect: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],
	create: ResolverInputTypes["UserRecurringPaymentWithoutItemsCreateInput"]
};
	["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"]: {
	connect: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],
	create: ResolverInputTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"]
};
	["UserConnectOrCreatePaymentsRelationInput"]: {
	connect: ResolverInputTypes["UserPaymentUniqueWhere"],
	create: ResolverInputTypes["UserPaymentWithoutUserCreateInput"]
};
	["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"]: {
	connect: ResolverInputTypes["UserUniqueWhere"],
	create: ResolverInputTypes["UserWithoutProcessedNotificationsCreateInput"]
};
	["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"]: {
	connect: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],
	create: ResolverInputTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]
};
	["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["ScheduledNotificationUniqueWhere"],
	create: ResolverInputTypes["ScheduledNotificationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateScheduledNotificationsRelationInput"]: {
	connect: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],
	create: ResolverInputTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"]
};
	["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutReceivedGiftsPagesCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["LinkableConnectOrCreateReceivedGiftsPageRelationInput"]: {
	connect: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReportPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutReportPageCreateInput"]
};
	["ReportPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["ReportPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["ReportPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["ReportPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["ReportPageLocaleCreatePostsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutReportPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreatePostsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostWithoutReportPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostCreateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostCreateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostCreateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostCreateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostMetaDataUniqueWhere"] | undefined | null
};
	["PostCreateHeroCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeroCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeroCarouselWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateHeroCarouselRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HeroCarouselUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["HeroCarouselItemUniqueWhere"] | undefined | null
};
	["HeroCarouselItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["HeroCarouselWithoutPostsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	items?: Array<ResolverInputTypes["HeroCarouselCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeroCarouselItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeroCarouselItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeroCarouselConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HeroCarouselItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	order?: number | undefined | null,
	item?: ResolverInputTypes["HeroCarouselItemCreateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselItemCreateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeroCarouselItemConnectOrCreateItemRelationInput"] | undefined | null
};
	["HeroCarouselItemConnectOrCreateItemRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostCreateInput"]
};
	["HeroCarouselConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["HeroCarouselItemUniqueWhere"],
	create: ResolverInputTypes["HeroCarouselItemWithoutListCreateInput"]
};
	["PostConnectOrCreateHeroCarouselRelationInput"]: {
	connect: ResolverInputTypes["HeroCarouselUniqueWhere"],
	create: ResolverInputTypes["HeroCarouselWithoutPostsCreateInput"]
};
	["PostCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentReferenceWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateContentRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceWithoutPostsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	block?: ResolverInputTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null,
	video?: ResolverInputTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null,
	contentAlignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	valueList?: ResolverInputTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined | null,
	areaList?: ResolverInputTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined | null,
	isAppsVisible?: boolean | undefined | null,
	accordion?: ResolverInputTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null,
	memberList?: ResolverInputTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined | null,
	asideMediaContentLayout?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	isAsideMediaContentMobileLayout?: boolean | undefined | null,
	form?: ResolverInputTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined | null,
	isTitleBigger?: boolean | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined | null,
	heroCarousel?: ResolverInputTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined | null,
	isCentered?: boolean | undefined | null,
	textImageList?: ResolverInputTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ResolverInputTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentWithoutBlocksCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
	connect: ResolverInputTypes["ContentBlockUniqueWhere"],
	create: ResolverInputTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceCreateValueListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ValueListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ValueListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateValueListRelationInput"] | undefined | null
};
	["ValueListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["ValueListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["ValueItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ValueItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ValueListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ValueItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	item?: ResolverInputTypes["ValueItemCreateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueItemCreateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["ValueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ValueCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ValueItemConnectOrCreateItemRelationInput"] | undefined | null
};
	["ValueUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	textContent?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["ValueCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	textContent?: ResolverInputTypes["ValueCreateTextContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueCreateTextContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ValueConnectOrCreateTextContentRelationInput"] | undefined | null
};
	["ValueConnectOrCreateTextContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["ValueItemConnectOrCreateItemRelationInput"]: {
	connect: ResolverInputTypes["ValueUniqueWhere"],
	create: ResolverInputTypes["ValueCreateInput"]
};
	["ValueListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["ValueItemUniqueWhere"],
	create: ResolverInputTypes["ValueItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateValueListRelationInput"]: {
	connect: ResolverInputTypes["ValueListUniqueWhere"],
	create: ResolverInputTypes["ValueListCreateInput"]
};
	["ContentReferenceCreateImageLinkListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"] | undefined | null
};
	["ContentReferenceConnectOrCreateImageLinkListRelationInput"]: {
	connect: ResolverInputTypes["ImageLinkListUniqueWhere"],
	create: ResolverInputTypes["ImageLinkListCreateInput"]
};
	["ContentReferenceCreateAreaListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateAreaListRelationInput"] | undefined | null
};
	["PostAreaListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["PostAreaListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaListItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaListItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaListItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	item?: ResolverInputTypes["PostAreaListItemCreateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaListItemCreateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaListItemConnectOrCreateItemRelationInput"] | undefined | null
};
	["PostAreaListItemConnectOrCreateItemRelationInput"]: {
	connect: ResolverInputTypes["PostAreaUniqueWhere"],
	create: ResolverInputTypes["PostAreaCreateInput"]
};
	["PostAreaListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["PostAreaListItemUniqueWhere"],
	create: ResolverInputTypes["PostAreaListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateAreaListRelationInput"]: {
	connect: ResolverInputTypes["PostAreaListUniqueWhere"],
	create: ResolverInputTypes["PostAreaListCreateInput"]
};
	["ContentReferenceCreateAccordionEntityRelationInput"]: {
	connect?: ResolverInputTypes["AccordionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["AccordionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateAccordionRelationInput"] | undefined | null
};
	["AccordionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["AccordionCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AccordionCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["AccordionItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["AccordionItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AccordionConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["AccordionItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	descriptionContent?: ResolverInputTypes["AccordionItemCreateDescriptionContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AccordionItemCreateDescriptionContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"] | undefined | null
};
	["AccordionItemConnectOrCreateDescriptionContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["AccordionConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["AccordionItemUniqueWhere"],
	create: ResolverInputTypes["AccordionItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateAccordionRelationInput"]: {
	connect: ResolverInputTypes["AccordionUniqueWhere"],
	create: ResolverInputTypes["AccordionCreateInput"]
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined | null
};
	["MediumListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["MediumListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["MediumItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	medium?: ResolverInputTypes["MediumItemCreateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemCreateMediumEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined | null
};
	["MediumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["MediumCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["MediumType"] | undefined | null,
	image?: ResolverInputTypes["MediumCreateImageEntityRelationInput"] | undefined | null,
	video?: ResolverInputTypes["MediumCreateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumConnectOrCreateImageRelationInput"] | undefined | null
};
	["MediumConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumConnectOrCreateVideoRelationInput"] | undefined | null
};
	["MediumConnectOrCreateVideoRelationInput"]: {
	connect: ResolverInputTypes["VideoUniqueWhere"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["MediumItemConnectOrCreateMediumRelationInput"]: {
	connect: ResolverInputTypes["MediumUniqueWhere"],
	create: ResolverInputTypes["MediumCreateInput"]
};
	["MediumListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["MediumItemUniqueWhere"],
	create: ResolverInputTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMediaRelationInput"]: {
	connect: ResolverInputTypes["MediumListUniqueWhere"],
	create: ResolverInputTypes["MediumListCreateInput"]
};
	["ContentReferenceCreateMemberListEntityRelationInput"]: {
	connect?: ResolverInputTypes["MemberListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MemberListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateMemberListRelationInput"] | undefined | null
};
	["MemberListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["MemberListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MemberListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["MemberListItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MemberListItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MemberListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["MemberListItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	position?: string | undefined | null,
	image?: ResolverInputTypes["MemberListItemCreateImageEntityRelationInput"] | undefined | null,
	descriptionContent?: ResolverInputTypes["MemberListItemCreateDescriptionContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MemberListItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MemberListItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["MemberListItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["MemberListItemCreateDescriptionContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"] | undefined | null
};
	["MemberListItemConnectOrCreateDescriptionContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["MemberListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["MemberListItemUniqueWhere"],
	create: ResolverInputTypes["MemberListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMemberListRelationInput"]: {
	connect: ResolverInputTypes["MemberListUniqueWhere"],
	create: ResolverInputTypes["MemberListCreateInput"]
};
	["ContentReferenceCreateFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["FormUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FormCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateFormRelationInput"] | undefined | null
};
	["FormUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tax?: ResolverInputTypes["FilledTaxFormUniqueWhere"] | undefined | null
};
	["FilledTaxFormUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["FormCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	type?: ResolverInputTypes["FormType"] | undefined | null,
	tax?: ResolverInputTypes["FormCreateTaxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FormCreateTaxEntityRelationInput"]: {
	connect?: ResolverInputTypes["FilledTaxFormUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FilledTaxFormCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FormConnectOrCreateTaxRelationInput"] | undefined | null
};
	["FilledTaxFormCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	userId?: string | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	vatId?: string | undefined | null,
	address1?: string | undefined | null,
	address2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	state?: string | undefined | null,
	country?: ResolverInputTypes["FilledTaxFormCreateCountryEntityRelationInput"] | undefined | null,
	dateFrom?: ResolverInputTypes["Date"] | undefined | null,
	dateTo?: ResolverInputTypes["Date"] | undefined | null,
	year?: number | undefined | null,
	isPdfGenerated?: boolean | undefined | null,
	pdfObjectKey?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FilledTaxFormCreateCountryEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FilledTaxFormConnectOrCreateCountryRelationInput"] | undefined | null
};
	["FilledTaxFormConnectOrCreateCountryRelationInput"]: {
	connect: ResolverInputTypes["RegionUniqueWhere"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["FormConnectOrCreateTaxRelationInput"]: {
	connect: ResolverInputTypes["FilledTaxFormUniqueWhere"],
	create: ResolverInputTypes["FilledTaxFormCreateInput"]
};
	["ContentReferenceConnectOrCreateFormRelationInput"]: {
	connect: ResolverInputTypes["FormUniqueWhere"],
	create: ResolverInputTypes["FormCreateInput"]
};
	["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"] | undefined | null
};
	["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["ContentReferenceCreateHeroCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeroCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeroCarouselCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"] | undefined | null
};
	["HeroCarouselCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	posts?: Array<ResolverInputTypes["HeroCarouselCreatePostsEntityRelationInput"]> | undefined | null,
	items?: Array<ResolverInputTypes["HeroCarouselCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselCreatePostsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutHeroCarouselCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeroCarouselConnectOrCreatePostsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostWithoutHeroCarouselCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostCreateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostCreateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostCreateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostCreateReportPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportPageLocaleWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateReportPageRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportPageLocaleWithoutPostsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	link?: ResolverInputTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostConnectOrCreateReportPageRelationInput"]: {
	connect: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	create: ResolverInputTypes["ReportPageLocaleWithoutPostsCreateInput"]
};
	["PostCreateFundraiseCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"] | undefined | null
};
	["PostConnectOrCreateFundraiseCurrencyRelationInput"]: {
	connect: ResolverInputTypes["CurrencyUniqueWhere"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["PostCreateFundraiseCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostCreateFundraiseSumEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostSumUniqueWhere"] | undefined | null
};
	["PostCreateFundraisingProgressEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostFundraisingProgressUniqueWhere"] | undefined | null
};
	["HeroCarouselConnectOrCreatePostsRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostWithoutHeroCarouselCreateInput"]
};
	["ContentReferenceConnectOrCreateHeroCarouselRelationInput"]: {
	connect: ResolverInputTypes["HeroCarouselUniqueWhere"],
	create: ResolverInputTypes["HeroCarouselCreateInput"]
};
	["ContentReferenceCreateOrganizationListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"] | undefined | null
};
	["ContentReferenceConnectOrCreateOrganizationListRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationListUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationListCreateInput"]
};
	["ContentReferenceCreateTextImageListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextImageListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextImageListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"] | undefined | null
};
	["TextImageListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["TextImageListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextImageListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextImageListItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextImageListItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextImageListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TextImageListItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	image?: ResolverInputTypes["TextImageListItemCreateImageEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	link?: ResolverInputTypes["TextImageListItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextImageListItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextImageListItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["TextImageListItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["TextImageListItemCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextImageListItemConnectOrCreateLinkRelationInput"] | undefined | null
};
	["TextImageListItemConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["TextImageListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["TextImageListItemUniqueWhere"],
	create: ResolverInputTypes["TextImageListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateTextImageListRelationInput"]: {
	connect: ResolverInputTypes["TextImageListUniqueWhere"],
	create: ResolverInputTypes["TextImageListCreateInput"]
};
	["PostConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentReferenceUniqueWhere"],
	create: ResolverInputTypes["ContentReferenceWithoutPostsCreateInput"]
};
	["ReportPageLocaleConnectOrCreatePostsRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostWithoutReportPageCreateInput"]
};
	["LocaleConnectOrCreateReportPagesRelationInput"]: {
	connect: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	create: ResolverInputTypes["ReportPageLocaleWithoutLocaleCreateInput"]
};
	["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutGivenGiftsPagesCreateInput"]
};
	["LinkableConnectOrCreateGivenGiftsPageRelationInput"]: {
	connect: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutReceivedGiftsPageCreateInput"]
};
	["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"]: {
	connect: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["ReportPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutReportPagesCreateInput"]
};
	["LinkableConnectOrCreateReportPageRelationInput"]: {
	connect: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	create: ResolverInputTypes["ReportPageLocaleWithoutLinkCreateInput"]
};
	["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutGivenGiftsPageCreateInput"]
};
	["LocaleConnectOrCreateGivenGiftsPagesRelationInput"]: {
	connect: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutPostOrganizationsCreateInput"]
};
	["PostOrganizationLocaleCreateDomainEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"] | undefined | null
};
	["PostOrganizationLocaleConnectOrCreateDomainRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["PostOrganizationLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["PostOrganizationLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["PostOrganizationLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["PostOrganizationLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["LinkableConnectOrCreatePostOrganizationRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationLocaleWithoutLinkCreateInput"]
};
	["PostLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutPostCreateInput"]
};
	["PostConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["PostLocaleUniqueWhere"],
	create: ResolverInputTypes["PostLocaleWithoutRootCreateInput"]
};
	["TileItemConnectOrCreatePostRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostCreateInput"]
};
	["TileItemCreateAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateAreaRelationInput"] | undefined | null
};
	["TileItemConnectOrCreateAreaRelationInput"]: {
	connect: ResolverInputTypes["PostAreaUniqueWhere"],
	create: ResolverInputTypes["PostAreaCreateInput"]
};
	["TileItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["TileItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["TileItemCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateLinkRelationInput"] | undefined | null
};
	["TileItemConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["TileItemCreateOrganizationEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateOrganizationRelationInput"] | undefined | null
};
	["TileItemConnectOrCreateOrganizationRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationCreateInput"]
};
	["TileListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["TileItemUniqueWhere"],
	create: ResolverInputTypes["TileItemWithoutListCreateInput"]
};
	["TileListCreateAreaTypeEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileListConnectOrCreateAreaTypeRelationInput"] | undefined | null
};
	["TileListConnectOrCreateAreaTypeRelationInput"]: {
	connect: ResolverInputTypes["PostAreaUniqueWhere"],
	create: ResolverInputTypes["PostAreaCreateInput"]
};
	["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"]: {
	connect: ResolverInputTypes["TileListUniqueWhere"],
	create: ResolverInputTypes["TileListCreateInput"]
};
	["FeedPageLocaleCreateSectionListEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateSectionListRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FeedPageSectionWithoutFeedPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	tileStripeList?: Array<ResolverInputTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageSectionCreateTileStripeListEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageTileStripeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageTileStripeWithoutSectionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageSectionConnectOrCreateTileStripeListRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FeedPageTileStripeWithoutSectionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	tileList?: ResolverInputTypes["FeedPageTileStripeCreateTileListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageTileStripeCreateTileListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TileListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"] | undefined | null
};
	["FeedPageTileStripeConnectOrCreateTileListRelationInput"]: {
	connect: ResolverInputTypes["TileListUniqueWhere"],
	create: ResolverInputTypes["TileListCreateInput"]
};
	["FeedPageSectionConnectOrCreateTileStripeListRelationInput"]: {
	connect: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],
	create: ResolverInputTypes["FeedPageTileStripeWithoutSectionCreateInput"]
};
	["FeedPageLocaleConnectOrCreateSectionListRelationInput"]: {
	connect: ResolverInputTypes["FeedPageSectionUniqueWhere"],
	create: ResolverInputTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"]
};
	["FeedPageLocaleCreateCardListEntityRelationInput"]: {
	connect?: ResolverInputTypes["CardListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CardListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"] | undefined | null
};
	["CardListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["CardListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CardListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["CardItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CardItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CardListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CardItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["CardItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CardItemCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CardItemConnectOrCreateLinkRelationInput"] | undefined | null
};
	["CardItemConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["CardListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["CardItemUniqueWhere"],
	create: ResolverInputTypes["CardItemWithoutListCreateInput"]
};
	["FeedPageLocaleConnectOrCreateCardListRelationInput"]: {
	connect: ResolverInputTypes["CardListUniqueWhere"],
	create: ResolverInputTypes["CardListCreateInput"]
};
	["FeedPageLocaleCreateStoryGuideListEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined | null
};
	["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"]: {
	connect: ResolverInputTypes["StoryGuideListUniqueWhere"],
	create: ResolverInputTypes["StoryGuideListCreateInput"]
};
	["LocaleConnectOrCreateFeedPagesRelationInput"]: {
	connect: ResolverInputTypes["FeedPageLocaleUniqueWhere"],
	create: ResolverInputTypes["FeedPageLocaleWithoutLocaleCreateInput"]
};
	["PostRevisionLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutPostRevisionsCreateInput"]
};
	["PostRevisionLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["PostRevisionLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["PostRevisionLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["PostRevisionLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["PostRevisionLocaleCreateLeadContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"] | undefined | null
};
	["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["PostRevisionConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],
	create: ResolverInputTypes["PostRevisionLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateActiveRevisionRelationInput"]: {
	connect: ResolverInputTypes["PostRevisionUniqueWhere"],
	create: ResolverInputTypes["PostRevisionCreateInput"]
};
	["PostRevisionConnectOrCreatePostRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostWithoutRevisionsCreateInput"]
};
	["PostRevisionLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["PostRevisionUniqueWhere"],
	create: ResolverInputTypes["PostRevisionWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostRevisionsRelationInput"]: {
	connect: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],
	create: ResolverInputTypes["PostRevisionLocaleWithoutLocaleCreateInput"]
};
	["SentPaymentLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutSentPaymentsCreateInput"]
};
	["SentPaymentConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],
	create: ResolverInputTypes["SentPaymentLocaleWithoutRootCreateInput"]
};
	["PostAreaConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ResolverInputTypes["SentPaymentUniqueWhere"],
	create: ResolverInputTypes["SentPaymentWithoutAreaCreateInput"]
};
	["PostOrganizationConnectOrCreateAreaRelationInput"]: {
	connect: ResolverInputTypes["PostAreaUniqueWhere"],
	create: ResolverInputTypes["PostAreaCreateInput"]
};
	["PostOrganizationCreateSentPaymentsEntityRelationInput"]: {
	connect?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SentPaymentWithoutOrganizationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateSentPaymentsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SentPaymentWithoutOrganizationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	sendAt?: ResolverInputTypes["DateTime"] | undefined | null,
	currency?: ResolverInputTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ResolverInputTypes["SentPaymentUniqueWhere"],
	create: ResolverInputTypes["SentPaymentWithoutOrganizationCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostOrganizationsRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationLocaleWithoutLocaleCreateInput"]
};
	["PostAreaLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutPostAreasCreateInput"]
};
	["PostAreaLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["PostAreaLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["PostAreaLocaleCreateBannerEntityRelationInput"]: {
	connect?: ResolverInputTypes["AppBannerUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["AppBannerCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"] | undefined | null
};
	["AppBannerCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	imageSmall?: ResolverInputTypes["AppBannerCreateImageSmallEntityRelationInput"] | undefined | null,
	imageBig?: ResolverInputTypes["AppBannerCreateImageBigEntityRelationInput"] | undefined | null,
	textContent?: ResolverInputTypes["AppBannerCreateTextContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AppBannerCreateImageSmallEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AppBannerConnectOrCreateImageSmallRelationInput"] | undefined | null
};
	["AppBannerConnectOrCreateImageSmallRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["AppBannerCreateImageBigEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AppBannerConnectOrCreateImageBigRelationInput"] | undefined | null
};
	["AppBannerConnectOrCreateImageBigRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["AppBannerCreateTextContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AppBannerConnectOrCreateTextContentRelationInput"] | undefined | null
};
	["AppBannerConnectOrCreateTextContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["PostAreaLocaleConnectOrCreateBannerRelationInput"]: {
	connect: ResolverInputTypes["AppBannerUniqueWhere"],
	create: ResolverInputTypes["AppBannerCreateInput"]
};
	["PostAreaLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["PostAreaLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["LinkableConnectOrCreatePostAreaRelationInput"]: {
	connect: ResolverInputTypes["PostAreaLocaleUniqueWhere"],
	create: ResolverInputTypes["PostAreaLocaleWithoutLinkCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutPostOrganizationCreateInput"]
};
	["PostOrganizationConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateOrganizationRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationWithoutPostsCreateInput"]
};
	["PostAreaConnectOrCreatePostsRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostWithoutAreaCreateInput"]
};
	["PostAreaLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["PostAreaUniqueWhere"],
	create: ResolverInputTypes["PostAreaWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostAreasRelationInput"]: {
	connect: ResolverInputTypes["PostAreaLocaleUniqueWhere"],
	create: ResolverInputTypes["PostAreaLocaleWithoutLocaleCreateInput"]
};
	["PostLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutPostsCreateInput"]
};
	["PostLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["PostWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostCreateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostCreateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostCreateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostWithoutLocalesCreateInput"]
};
	["LinkableConnectOrCreatePostRelationInput"]: {
	connect: ResolverInputTypes["PostLocaleUniqueWhere"],
	create: ResolverInputTypes["PostLocaleWithoutLinkCreateInput"]
};
	["LinkConnectOrCreateInternalLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableCreateInput"]
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["ContentReferenceCreatePostsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreatePostsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PostWithoutContentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organization?: ResolverInputTypes["PostCreateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostCreateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostCreateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostCreateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostCreateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostCreateReportPageEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceConnectOrCreatePostsRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostWithoutContentCreateInput"]
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
	connect: ResolverInputTypes["ContentReferenceUniqueWhere"],
	create: ResolverInputTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
	connect: ResolverInputTypes["ContentBlockUniqueWhere"],
	create: ResolverInputTypes["ContentBlockWithoutContentCreateInput"]
};
	["PostLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["LocaleConnectOrCreatePostsRelationInput"]: {
	connect: ResolverInputTypes["PostLocaleUniqueWhere"],
	create: ResolverInputTypes["PostLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
	connect: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["PostAreaLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutPostAreaCreateInput"]
};
	["PostAreaConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["PostAreaLocaleUniqueWhere"],
	create: ResolverInputTypes["PostAreaLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateAreaRelationInput"]: {
	connect: ResolverInputTypes["PostAreaUniqueWhere"],
	create: ResolverInputTypes["PostAreaWithoutPostsCreateInput"]
};
	["PostOrganizationConnectOrCreatePostsRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostWithoutOrganizationCreateInput"]
};
	["PostOrganizationListItemConnectOrCreateItemRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationCreateInput"]
};
	["PostOrganizationListItemCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"] | undefined | null
};
	["PostOrganizationListItemConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["PostOrganizationListItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["PostOrganizationListItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationListItemWithoutListCreateInput"]
};
	["GeneralConnectOrCreateOrganizationListRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationListUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationListCreateInput"]
};
	["GeneralLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["GeneralUniqueWhere"],
	create: ResolverInputTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GeneralLocaleCreateAppStoreLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"] | undefined | null
};
	["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"] | undefined | null
};
	["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateGeneralsRelationInput"]: {
	connect: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	create: ResolverInputTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutReportNavigationsCreateInput"]
};
	["GenericPageConnectOrCreateReportNavigationRelationInput"]: {
	connect: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	create: ResolverInputTypes["ReportNavigationLocaleWithoutPagesCreateInput"]
};
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["GenericPageUniqueWhere"],
	create: ResolverInputTypes["GenericPageWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateGenericPagesRelationInput"]: {
	connect: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutGeneralsCreateInput"]
};
	["GeneralConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	create: ResolverInputTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["GeneralUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["GeneralUpdateLocalesEntityRelationInput"]> | undefined | null,
	allAreasIcon?: ResolverInputTypes["GeneralUpdateAllAreasIconEntityRelationInput"] | undefined | null,
	allOrganizationsIcon?: ResolverInputTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["GeneralUpdateOrganizationListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["GeneralLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GeneralUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GeneralUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	data: ResolverInputTypes["GeneralLocaleWithoutRootUpdateInput"]
};
	["GeneralLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	appStoreLink?: ResolverInputTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined | null,
	allAreasDescription?: string | undefined | null,
	allOrganizationsDescription?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGeneralsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutGeneralsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutGeneralsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateGenericPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateGenericPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertGenericPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateGenericPagesRelationInput"]: {
	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	data: ResolverInputTypes["GenericPageLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageWithoutLocalesUpdateInput"]: {
	type?: ResolverInputTypes["GenericPageType"] | undefined | null,
	order?: number | undefined | null,
	reportNavigation?: Array<ResolverInputTypes["GenericPageUpdateReportNavigationEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageUpdateReportNavigationEntityRelationInput"]: {
	create?: ResolverInputTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageUpdateReportNavigationRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageUpsertReportNavigationRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageUpdateReportNavigationRelationInput"]: {
	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	data: ResolverInputTypes["ReportNavigationLocaleWithoutPagesUpdateInput"]
};
	["ReportNavigationLocaleWithoutPagesUpdateInput"]: {
	root?: ResolverInputTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportNavigationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportNavigationWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ReportNavigationWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportNavigationLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ReportNavigationWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["ReportNavigationWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["ReportNavigationWithoutLocalesCreateInput"]
};
	["ReportNavigationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutReportNavigationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutReportNavigationsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportNavigationLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutReportNavigationsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateGeneralsEntityRelationInput"]: {
	create?: ResolverInputTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateGeneralsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertGeneralsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateGeneralsRelationInput"]: {
	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	data: ResolverInputTypes["GeneralLocaleWithoutLocaleUpdateInput"]
};
	["GeneralLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	appStoreLink?: ResolverInputTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined | null,
	allAreasDescription?: string | undefined | null,
	allOrganizationsDescription?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GeneralUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GeneralWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GeneralWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GeneralWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	allAreasIcon?: ResolverInputTypes["GeneralUpdateAllAreasIconEntityRelationInput"] | undefined | null,
	allOrganizationsIcon?: ResolverInputTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["GeneralUpdateOrganizationListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralUpdateAllAreasIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralConnectOrCreateAllAreasIconRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralUpsertAllAreasIconRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageUpdateInput"]: {
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	alt?: string | undefined | null,
	fileName?: string | undefined | null,
	focalPointX?: number | undefined | null,
	focalPointY?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralUpsertAllAreasIconRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["GeneralUpdateAllOrganizationsIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralUpsertAllOrganizationsIconRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GeneralUpsertAllOrganizationsIconRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["GeneralUpdateOrganizationListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralConnectOrCreateOrganizationListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralUpsertOrganizationListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationListUpdateInput"]: {
	items?: Array<ResolverInputTypes["PostOrganizationListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostOrganizationListItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostOrganizationListItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostOrganizationListItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostOrganizationListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],
	data: ResolverInputTypes["PostOrganizationListItemWithoutListUpdateInput"]
};
	["PostOrganizationListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	item?: ResolverInputTypes["PostOrganizationListItemUpdateItemEntityRelationInput"] | undefined | null,
	type?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	link?: ResolverInputTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["PostOrganizationListItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationListItemUpdateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationListItemUpsertItemRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationUpdateInput"]: {
	order?: number | undefined | null,
	posts?: Array<ResolverInputTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined | null,
	icon?: ResolverInputTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	area?: ResolverInputTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined | null,
	isHidden?: boolean | undefined | null,
	color?: string | undefined | null,
	plainIcon?: ResolverInputTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationUpdatePostsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostWithoutOrganizationCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationUpdatePostsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationUpsertPostsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationUpdatePostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	data: ResolverInputTypes["PostWithoutOrganizationUpdateInput"]
};
	["PostWithoutOrganizationUpdateInput"]: {
	area?: ResolverInputTypes["PostUpdateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostUpdateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostUpdateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostUpdateAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateAreaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaWithoutPostsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertAreaRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaWithoutPostsUpdateInput"]: {
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostAreaUpdateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined | null,
	color?: string | undefined | null,
	specificSymbol?: number | undefined | null,
	region?: ResolverInputTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined | null,
	plainIcon?: ResolverInputTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaUpdateIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateIconRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaUpsertIconRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaUpsertIconRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostAreaUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["PostAreaLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],
	data: ResolverInputTypes["PostAreaLocaleWithoutRootUpdateInput"]
};
	["PostAreaLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	banner?: ResolverInputTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined | null,
	shortDescription?: string | undefined | null,
	content?: ResolverInputTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutPostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutPostAreaUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutPostAreaUpdateInput"]: {
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertGenericPageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGenericPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutGenericPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutGenericPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdatePostsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdatePostsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertPostsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdatePostsRelationInput"]: {
	by: ResolverInputTypes["PostLocaleUniqueWhere"],
	data: ResolverInputTypes["PostLocaleWithoutLocaleUpdateInput"]
};
	["PostLocaleWithoutLocaleUpdateInput"]: {
	content?: ResolverInputTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined | null,
	paymentName?: string | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentUpdateInput"]: {
	blocks?: Array<ResolverInputTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?: ResolverInputTypes["ContentBlockWithoutContentCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateBlocksRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentUpsertBlocksRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by: ResolverInputTypes["ContentBlockUniqueWhere"],
	data: ResolverInputTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	references?: Array<ResolverInputTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?: ResolverInputTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ContentBlockUpdateReferencesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentBlockUpsertReferencesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by: ResolverInputTypes["ContentReferenceUniqueWhere"],
	data: ResolverInputTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	image?: ResolverInputTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null,
	video?: ResolverInputTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null,
	contentAlignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	valueList?: ResolverInputTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined | null,
	areaList?: ResolverInputTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined | null,
	isAppsVisible?: boolean | undefined | null,
	accordion?: ResolverInputTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null,
	memberList?: ResolverInputTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined | null,
	asideMediaContentLayout?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	isAsideMediaContentMobileLayout?: boolean | undefined | null,
	form?: ResolverInputTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined | null,
	isTitleBigger?: boolean | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined | null,
	heroCarousel?: ResolverInputTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined | null,
	isCentered?: boolean | undefined | null,
	posts?: Array<ResolverInputTypes["ContentReferenceUpdatePostsEntityRelationInput"]> | undefined | null,
	textImageList?: ResolverInputTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["VideoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertVideoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VideoUpdateInput"]: {
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	poster?: ResolverInputTypes["VideoUpdatePosterEntityRelationInput"] | undefined | null,
	shapeType?: ResolverInputTypes["VideoShapeType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VideoUpdatePosterEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["VideoConnectOrCreatePosterRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["VideoUpsertPosterRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VideoUpsertPosterRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertVideoRelationInput"]: {
	update: ResolverInputTypes["VideoUpdateInput"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkUpdateInput"]: {
	type?: ResolverInputTypes["LinkEnum"] | undefined | null,
	title?: string | undefined | null,
	externalLink?: string | undefined | null,
	internalLink?: ResolverInputTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined | null,
	isTargetBlank?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkUpsertInternalLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableUpdateInput"]: {
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreatePostRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertPostRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostLocaleWithoutLinkUpdateInput"]: {
	content?: ResolverInputTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined | null,
	paymentName?: string | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SeoUpdateInput"]: {
	title?: string | undefined | null,
	description?: string | undefined | null,
	ogTitle?: string | undefined | null,
	ogDescription?: string | undefined | null,
	noIndex?: boolean | undefined | null,
	noFollow?: boolean | undefined | null,
	ogImage?: ResolverInputTypes["SeoUpdateOgImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SeoUpsertOgImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["PostLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutPostsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutPostsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdatePostAreasEntityRelationInput"]: {
	create?: ResolverInputTypes["PostAreaLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdatePostAreasRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertPostAreasRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdatePostAreasRelationInput"]: {
	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],
	data: ResolverInputTypes["PostAreaLocaleWithoutLocaleUpdateInput"]
};
	["PostAreaLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	banner?: ResolverInputTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined | null,
	shortDescription?: string | undefined | null,
	content?: ResolverInputTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostAreaUpdateIconEntityRelationInput"] | undefined | null,
	regionListOverride?: ResolverInputTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined | null,
	color?: string | undefined | null,
	posts?: Array<ResolverInputTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	region?: ResolverInputTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined | null,
	plainIcon?: ResolverInputTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaUpdateRegionListOverrideEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"] | undefined | null,
	update?: ResolverInputTypes["DonationAmountsRegionListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaUpsertRegionListOverrideRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DonationAmountsRegionListUpdateInput"]: {
	regions?: Array<ResolverInputTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]> | undefined | null,
	donation?: ResolverInputTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]: {
	create?: ResolverInputTypes["DonationAmountsRegionItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["DonationAmountsRegionListUpdateRegionsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["DonationAmountsRegionListUpsertRegionsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DonationAmountsRegionListUpdateRegionsRelationInput"]: {
	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],
	data: ResolverInputTypes["DonationAmountsRegionItemWithoutListUpdateInput"]
};
	["DonationAmountsRegionItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	items?: Array<ResolverInputTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined | null,
	region?: ResolverInputTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined | null,
	minimumAmount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["DonationAmountItemWithoutRegionItemCreateInput"] | undefined | null,
	update?: ResolverInputTypes["DonationAmountsRegionItemUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["DonationAmountsRegionItemUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["DonationAmountItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["DonationAmountItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["DonationAmountItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DonationAmountsRegionItemUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],
	data: ResolverInputTypes["DonationAmountItemWithoutRegionItemUpdateInput"]
};
	["DonationAmountItemWithoutRegionItemUpdateInput"]: {
	order?: number | undefined | null,
	amount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],
	update: ResolverInputTypes["DonationAmountItemWithoutRegionItemUpdateInput"],
	create: ResolverInputTypes["DonationAmountItemWithoutRegionItemCreateInput"]
};
	["DonationAmountsRegionItemUpdateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionWithoutDonationItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RegionWithoutDonationItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["DonationAmountsRegionItemUpsertRegionRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["RegionWithoutDonationItemsUpdateInput"]: {
	order?: number | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	currency?: ResolverInputTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined | null,
	enabledPaymentMethods?: Array<ResolverInputTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]> | undefined | null,
	timezone?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionUpdateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RegionConnectOrCreateCurrencyRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CurrencyUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RegionUpsertCurrencyRelationInput"] | undefined | null
};
	["CurrencyUpdateInput"]: {
	identifier?: ResolverInputTypes["CurrencyIdentifier"] | undefined | null,
	label?: string | undefined | null,
	sign?: string | undefined | null,
	signAlignment?: ResolverInputTypes["CurrencySignAlignment"] | undefined | null,
	defaultDonationAmount?: number | undefined | null,
	rateAgainstCzk?: number | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	postCurrencySums?: Array<ResolverInputTypes["CurrencyUpdatePostCurrencySumsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CurrencyUpdatePostCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RegionUpsertCurrencyRelationInput"]: {
	update: ResolverInputTypes["CurrencyUpdateInput"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]: {
	create?: ResolverInputTypes["RegionPaymentMethodWithoutRegionCreateInput"] | undefined | null,
	update?: ResolverInputTypes["RegionUpdateEnabledPaymentMethodsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["RegionUpsertEnabledPaymentMethodsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["RegionPaymentMethodUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["RegionPaymentMethodUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["RegionPaymentMethodUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RegionUpdateEnabledPaymentMethodsRelationInput"]: {
	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],
	data: ResolverInputTypes["RegionPaymentMethodWithoutRegionUpdateInput"]
};
	["RegionPaymentMethodWithoutRegionUpdateInput"]: {
	allowRecurringPayments?: boolean | undefined | null,
	method?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionUpsertEnabledPaymentMethodsRelationInput"]: {
	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],
	update: ResolverInputTypes["RegionPaymentMethodWithoutRegionUpdateInput"],
	create: ResolverInputTypes["RegionPaymentMethodWithoutRegionCreateInput"]
};
	["DonationAmountsRegionItemUpsertRegionRelationInput"]: {
	update: ResolverInputTypes["RegionWithoutDonationItemsUpdateInput"],
	create: ResolverInputTypes["RegionWithoutDonationItemsCreateInput"]
};
	["DonationAmountsRegionListUpsertRegionsRelationInput"]: {
	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],
	update: ResolverInputTypes["DonationAmountsRegionItemWithoutListUpdateInput"],
	create: ResolverInputTypes["DonationAmountsRegionItemWithoutListCreateInput"]
};
	["DonationAmountsRegionListUpdateDonationEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationWithoutRegionListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["DonationWithoutRegionListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["DonationAmountsRegionListUpsertDonationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DonationWithoutRegionListUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionListUpsertDonationRelationInput"]: {
	update: ResolverInputTypes["DonationWithoutRegionListUpdateInput"],
	create: ResolverInputTypes["DonationWithoutRegionListCreateInput"]
};
	["PostAreaUpsertRegionListOverrideRelationInput"]: {
	update: ResolverInputTypes["DonationAmountsRegionListUpdateInput"],
	create: ResolverInputTypes["DonationAmountsRegionListCreateInput"]
};
	["PostAreaUpdatePostsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostWithoutAreaCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaUpdatePostsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaUpsertPostsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaUpdatePostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	data: ResolverInputTypes["PostWithoutAreaUpdateInput"]
};
	["PostWithoutAreaUpdateInput"]: {
	organization?: ResolverInputTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostUpdateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostUpdateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostUpdateOrganizationEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationWithoutPostsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateOrganizationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationWithoutPostsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertOrganizationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationWithoutPostsUpdateInput"]: {
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	area?: ResolverInputTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined | null,
	isHidden?: boolean | undefined | null,
	color?: string | undefined | null,
	plainIcon?: ResolverInputTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationUpdateIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateIconRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationUpsertIconRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationUpsertIconRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["PostOrganizationLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],
	data: ResolverInputTypes["PostOrganizationLocaleWithoutRootUpdateInput"]
};
	["PostOrganizationLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	domain?: ResolverInputTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutPostOrganizationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutPostOrganizationUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutPostOrganizationUpdateInput"]: {
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdatePostAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreatePostAreaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertPostAreaRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaLocaleWithoutLinkUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	root?: ResolverInputTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	banner?: ResolverInputTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined | null,
	shortDescription?: string | undefined | null,
	content?: ResolverInputTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutPostAreasCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutPostAreasUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutPostAreasUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdatePostOrganizationsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdatePostOrganizationsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertPostOrganizationsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdatePostOrganizationsRelationInput"]: {
	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],
	data: ResolverInputTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"]
};
	["PostOrganizationLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	domain?: ResolverInputTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	posts?: Array<ResolverInputTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined | null,
	icon?: ResolverInputTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	area?: ResolverInputTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined | null,
	isHidden?: boolean | undefined | null,
	color?: string | undefined | null,
	plainIcon?: ResolverInputTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationUpdateAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateAreaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationUpsertAreaRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaUpdateInput"]: {
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostAreaUpdateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined | null,
	color?: string | undefined | null,
	posts?: Array<ResolverInputTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	region?: ResolverInputTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined | null,
	plainIcon?: ResolverInputTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined | null,
	sentPayments?: Array<ResolverInputTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaUpdateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateRegionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RegionUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaUpsertRegionRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RegionUpdateInput"]: {
	order?: number | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	currency?: ResolverInputTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined | null,
	enabledPaymentMethods?: Array<ResolverInputTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]> | undefined | null,
	donationItems?: Array<ResolverInputTypes["RegionUpdateDonationItemsEntityRelationInput"]> | undefined | null,
	timezone?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionUpdateDonationItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | undefined | null,
	update?: ResolverInputTypes["RegionUpdateDonationItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["RegionUpsertDonationItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RegionUpdateDonationItemsRelationInput"]: {
	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],
	data: ResolverInputTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"]
};
	["DonationAmountsRegionItemWithoutRegionUpdateInput"]: {
	order?: number | undefined | null,
	items?: Array<ResolverInputTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined | null,
	minimumAmount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["DonationAmountsRegionItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["DonationAmountsRegionListWithoutRegionsUpdateInput"]: {
	donation?: ResolverInputTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"],
	create: ResolverInputTypes["DonationAmountsRegionListWithoutRegionsCreateInput"]
};
	["RegionUpsertDonationItemsRelationInput"]: {
	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],
	update: ResolverInputTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"],
	create: ResolverInputTypes["DonationAmountsRegionItemWithoutRegionCreateInput"]
};
	["PostAreaUpsertRegionRelationInput"]: {
	update: ResolverInputTypes["RegionUpdateInput"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["PostAreaUpdateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaMetaDataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaUpdateMobileHeroImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaUpsertMobileHeroImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaUpsertMobileHeroImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostAreaUpdatePlainIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaConnectOrCreatePlainIconRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaUpsertPlainIconRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaUpsertPlainIconRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostAreaUpdateSentPaymentsEntityRelationInput"]: {
	create?: ResolverInputTypes["SentPaymentWithoutAreaCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaUpdateSentPaymentsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaUpsertSentPaymentsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaUpdateSentPaymentsRelationInput"]: {
	by: ResolverInputTypes["SentPaymentUniqueWhere"],
	data: ResolverInputTypes["SentPaymentWithoutAreaUpdateInput"]
};
	["SentPaymentWithoutAreaUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	sendAt?: ResolverInputTypes["DateTime"] | undefined | null,
	currency?: ResolverInputTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CurrencyUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SentPaymentUpsertCurrencyRelationInput"] | undefined | null
};
	["SentPaymentUpsertCurrencyRelationInput"]: {
	update: ResolverInputTypes["CurrencyUpdateInput"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["SentPaymentUpdateOrganizationEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentConnectOrCreateOrganizationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationWithoutSentPaymentsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SentPaymentUpsertOrganizationRelationInput"] | undefined | null
};
	["PostOrganizationWithoutSentPaymentsUpdateInput"]: {
	order?: number | undefined | null,
	posts?: Array<ResolverInputTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined | null,
	icon?: ResolverInputTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	area?: ResolverInputTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined | null,
	isHidden?: boolean | undefined | null,
	color?: string | undefined | null,
	plainIcon?: ResolverInputTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined | null,
	desktopHeroImage?: ResolverInputTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined | null,
	organizationCurrencySums?: Array<ResolverInputTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined | null,
	organizationSum?: ResolverInputTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationUpdateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationMetaDataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationUpdateMobileHeroImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationUpsertMobileHeroImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationUpsertMobileHeroImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationUpdatePlainIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationUpsertPlainIconRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationUpsertPlainIconRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationUpsertDesktopHeroImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationUpsertDesktopHeroImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationUpdateOrganizationSumEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationSumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SentPaymentUpsertOrganizationRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationWithoutSentPaymentsUpdateInput"],
	create: ResolverInputTypes["PostOrganizationWithoutSentPaymentsCreateInput"]
};
	["SentPaymentUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["SentPaymentLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["SentPaymentUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["SentPaymentUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["SentPaymentUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],
	data: ResolverInputTypes["SentPaymentLocaleWithoutRootUpdateInput"]
};
	["SentPaymentLocaleWithoutRootUpdateInput"]: {
	organizationText?: string | undefined | null,
	locale?: ResolverInputTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutSentPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutSentPaymentsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SentPaymentLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutSentPaymentsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
	create?: ResolverInputTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateHeadersRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertHeadersRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateHeadersRelationInput"]: {
	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	data: ResolverInputTypes["HeaderLocaleWithoutLocaleUpdateInput"]
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined | null,
	links?: ResolverInputTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeaderUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeaderWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["HeaderWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["HeaderWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	logo?: ResolverInputTypes["HeaderUpdateLogoEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["HeaderUpdateOrganizationListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeaderUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HeaderUpdateOrganizationListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateOrganizationListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderUpsertOrganizationListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeaderUpsertOrganizationListRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationListUpdateInput"],
	create: ResolverInputTypes["PostOrganizationListCreateInput"]
};
	["HeaderLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["HeaderWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleUpdateLinksEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLinksRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertLinksRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkListUpdateInput"]: {
	items?: Array<ResolverInputTypes["LinkListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["LinkItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LinkListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["LinkItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["LinkItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["LinkItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LinkListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["LinkItemUniqueWhere"],
	data: ResolverInputTypes["LinkItemWithoutListUpdateInput"]
};
	["LinkItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	link?: ResolverInputTypes["LinkItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkItemConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkItemUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkItemUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LinkListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["LinkItemUniqueWhere"],
	update: ResolverInputTypes["LinkItemWithoutListUpdateInput"],
	create: ResolverInputTypes["LinkItemWithoutListCreateInput"]
};
	["HeaderLocaleUpsertLinksRelationInput"]: {
	update: ResolverInputTypes["LinkListUpdateInput"],
	create: ResolverInputTypes["LinkListCreateInput"]
};
	["LocaleUpsertHeadersRelationInput"]: {
	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	update: ResolverInputTypes["HeaderLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateFootersEntityRelationInput"]: {
	create?: ResolverInputTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateFootersRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertFootersRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateFootersRelationInput"]: {
	by: ResolverInputTypes["FooterLocaleUniqueWhere"],
	data: ResolverInputTypes["FooterLocaleWithoutLocaleUpdateInput"]
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
	copyright?: string | undefined | null,
	root?: ResolverInputTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined | null,
	linkList?: ResolverInputTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined | null,
	contactEmail?: string | undefined | null,
	addressInfo?: ResolverInputTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["FooterWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	logo?: ResolverInputTypes["FooterUpdateLogoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["FooterLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["FooterWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleUpdateLinkListEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateLinkListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertLinkListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertLinkListRelationInput"]: {
	update: ResolverInputTypes["LinkListUpdateInput"],
	create: ResolverInputTypes["LinkListCreateInput"]
};
	["FooterLocaleUpdateAddressInfoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertAddressInfoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertAddressInfoRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["FooterLocaleUpdateImageLinkListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageLinkListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertImageLinkListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageLinkListUpdateInput"]: {
	items?: Array<ResolverInputTypes["ImageLinkListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["ImageLinkItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ImageLinkListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageLinkListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ImageLinkItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ImageLinkItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ImageLinkItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ImageLinkListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],
	data: ResolverInputTypes["ImageLinkItemWithoutListUpdateInput"]
};
	["ImageLinkItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	item?: ResolverInputTypes["ImageLinkItemUpdateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkItemUpdateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkItemConnectOrCreateItemRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageLinkItemUpsertItemRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageLinkUpdateInput"]: {
	image?: ResolverInputTypes["ImageLinkUpdateImageEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["ImageLinkUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageLinkUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageLinkUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ImageLinkUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageLinkUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageLinkUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["ImageLinkItemUpsertItemRelationInput"]: {
	update: ResolverInputTypes["ImageLinkUpdateInput"],
	create: ResolverInputTypes["ImageLinkCreateInput"]
};
	["ImageLinkListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],
	update: ResolverInputTypes["ImageLinkItemWithoutListUpdateInput"],
	create: ResolverInputTypes["ImageLinkItemWithoutListCreateInput"]
};
	["FooterLocaleUpsertImageLinkListRelationInput"]: {
	update: ResolverInputTypes["ImageLinkListUpdateInput"],
	create: ResolverInputTypes["ImageLinkListCreateInput"]
};
	["LocaleUpsertFootersRelationInput"]: {
	by: ResolverInputTypes["FooterLocaleUniqueWhere"],
	update: ResolverInputTypes["FooterLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]: {
	create?: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertGenericPageAboutSettingsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateGenericPageAboutSettingsRelationInput"]: {
	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	data: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined | null,
	linkGroups?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageAboutSettingsWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"]
};
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]: {
	create?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"]: {
	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"]
};
	["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"]: {
	order?: number | undefined | null,
	linkList?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"]: {
	update: ResolverInputTypes["LinkListUpdateInput"],
	create: ResolverInputTypes["LinkListCreateInput"]
};
	["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"]: {
	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	update: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"],
	create: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]
};
	["LocaleUpsertGenericPageAboutSettingsRelationInput"]: {
	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	update: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdatePostRevisionsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdatePostRevisionsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertPostRevisionsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdatePostRevisionsRelationInput"]: {
	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],
	data: ResolverInputTypes["PostRevisionLocaleWithoutLocaleUpdateInput"]
};
	["PostRevisionLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["PostRevisionLocaleUpdateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	leadContent?: ResolverInputTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined | null,
	publishNotificationText?: string | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostRevisionWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostRevisionWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionWithoutLocalesUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	createdById?: ResolverInputTypes["UUID"] | undefined | null,
	publishedById?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["PostType"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	post?: ResolverInputTypes["PostRevisionUpdatePostEntityRelationInput"] | undefined | null,
	tileImage?: ResolverInputTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined | null,
	tileVideo?: ResolverInputTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined | null,
	heroImage?: ResolverInputTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined | null,
	regionListOverride?: ResolverInputTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined | null,
	isOrganizationVisible?: boolean | undefined | null,
	sendPublishNotifications?: boolean | undefined | null,
	isArchived?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionUpdatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutRevisionsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreatePostRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostWithoutRevisionsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionUpsertPostRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PostWithoutRevisionsUpdateInput"]: {
	organization?: ResolverInputTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostUpdateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostUpdateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostUpdateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostUpdateActiveRevisionEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostRevisionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateActiveRevisionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostRevisionUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertActiveRevisionRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	createdById?: ResolverInputTypes["UUID"] | undefined | null,
	publishedById?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["PostType"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	post?: ResolverInputTypes["PostRevisionUpdatePostEntityRelationInput"] | undefined | null,
	tileImage?: ResolverInputTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined | null,
	tileVideo?: ResolverInputTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined | null,
	heroImage?: ResolverInputTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostRevisionUpdateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined | null,
	isOrganizationVisible?: boolean | undefined | null,
	sendPublishNotifications?: boolean | undefined | null,
	isArchived?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionUpdateTileImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateTileImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionUpsertTileImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionUpsertTileImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostRevisionUpdateTileVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateTileVideoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["VideoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionUpsertTileVideoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionUpsertTileVideoRelationInput"]: {
	update: ResolverInputTypes["VideoUpdateInput"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["PostRevisionUpdateHeroImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateHeroImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionUpsertHeroImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionUpsertHeroImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostRevisionUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["PostRevisionLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostRevisionUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostRevisionLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostRevisionUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],
	data: ResolverInputTypes["PostRevisionLocaleWithoutRootUpdateInput"]
};
	["PostRevisionLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	locale?: ResolverInputTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	leadContent?: ResolverInputTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined | null,
	publishNotificationText?: string | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutPostRevisionsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutPostRevisionsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutPostRevisionsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateFlagImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateFlagImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertFlagImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleUpsertFlagImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleUpdateFeedPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["FeedPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateFeedPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertFeedPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateFeedPagesRelationInput"]: {
	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],
	data: ResolverInputTypes["FeedPageLocaleWithoutLocaleUpdateInput"]
};
	["FeedPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	heroTiles?: ResolverInputTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined | null,
	sectionList?: Array<ResolverInputTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined | null,
	cardList?: ResolverInputTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["FeedPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["FeedPageWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["FeedPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["FeedPageWithoutLocalesCreateInput"]
};
	["FeedPageLocaleUpdateHeroTilesEntityRelationInput"]: {
	connect?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TileListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TileListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageLocaleUpsertHeroTilesRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileListUpdateInput"]: {
	size?: ResolverInputTypes["TileListSize"] | undefined | null,
	title?: string | undefined | null,
	items?: Array<ResolverInputTypes["TileListUpdateItemsEntityRelationInput"]> | undefined | null,
	areaType?: ResolverInputTypes["TileListUpdateAreaTypeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["TileItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TileListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TileItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TileItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TileItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TileListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["TileItemUniqueWhere"],
	data: ResolverInputTypes["TileItemWithoutListUpdateInput"]
};
	["TileItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	type?: ResolverInputTypes["TileItemType"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	post?: ResolverInputTypes["TileItemUpdatePostEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["TileItemUpdateAreaEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["TileItemUpdateImageEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["TileItemUpdateLinkEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["TileItemUpdateOrganizationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileItemUpdatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreatePostRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileItemUpsertPostRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostUpdateInput"]: {
	organization?: ResolverInputTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostUpdateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostUpdateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostUpdateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostUpdateRevisionsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostRevisionWithoutPostCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateRevisionsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertRevisionsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostRevisionUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostUpdateRevisionsRelationInput"]: {
	by: ResolverInputTypes["PostRevisionUniqueWhere"],
	data: ResolverInputTypes["PostRevisionWithoutPostUpdateInput"]
};
	["PostRevisionWithoutPostUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	createdById?: ResolverInputTypes["UUID"] | undefined | null,
	publishedById?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["PostType"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	tileImage?: ResolverInputTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined | null,
	tileVideo?: ResolverInputTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined | null,
	heroImage?: ResolverInputTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostRevisionUpdateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined | null,
	isOrganizationVisible?: boolean | undefined | null,
	sendPublishNotifications?: boolean | undefined | null,
	isArchived?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionUpdateRegionListOverrideEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"] | undefined | null,
	update?: ResolverInputTypes["DonationAmountsRegionListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionUpsertRegionListOverrideRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionUpsertRegionListOverrideRelationInput"]: {
	update: ResolverInputTypes["DonationAmountsRegionListUpdateInput"],
	create: ResolverInputTypes["DonationAmountsRegionListCreateInput"]
};
	["PostUpsertRevisionsRelationInput"]: {
	by: ResolverInputTypes["PostRevisionUniqueWhere"],
	update: ResolverInputTypes["PostRevisionWithoutPostUpdateInput"],
	create: ResolverInputTypes["PostRevisionWithoutPostCreateInput"]
};
	["PostUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["PostLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["PostLocaleUniqueWhere"],
	data: ResolverInputTypes["PostLocaleWithoutRootUpdateInput"]
};
	["PostLocaleWithoutRootUpdateInput"]: {
	content?: ResolverInputTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	paymentName?: string | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutPostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutPostUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutPostUpdateInput"]: {
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdatePostOrganizationEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreatePostOrganizationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertPostOrganizationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationLocaleWithoutLinkUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	root?: ResolverInputTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	domain?: ResolverInputTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutPostOrganizationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutPostOrganizationsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutPostOrganizationsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateRecurringPaymentPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertRecurringPaymentPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateRecurringPaymentPagesRelationInput"]: {
	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],
	data: ResolverInputTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"]
};
	["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	favouritePosts?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecurringPaymentPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RecurringPaymentPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecurringPaymentPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["RecurringPaymentPageWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["RecurringPaymentPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["RecurringPaymentPageWithoutLocalesCreateInput"]
};
	["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostListUpdateInput"]: {
	items?: Array<ResolverInputTypes["PostListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostListItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostListItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostListItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["PostListItemUniqueWhere"],
	data: ResolverInputTypes["PostListItemWithoutListUpdateInput"]
};
	["PostListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	post?: ResolverInputTypes["PostListItemUpdatePostEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostListItemUpdatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostListItemConnectOrCreatePostRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostListItemUpsertPostRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostListItemUpsertPostRelationInput"]: {
	update: ResolverInputTypes["PostUpdateInput"],
	create: ResolverInputTypes["PostCreateInput"]
};
	["PostListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["PostListItemUniqueWhere"],
	update: ResolverInputTypes["PostListItemWithoutListUpdateInput"],
	create: ResolverInputTypes["PostListItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"]: {
	update: ResolverInputTypes["PostListUpdateInput"],
	create: ResolverInputTypes["PostListCreateInput"]
};
	["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StoryGuideListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StoryGuideListUpdateInput"]: {
	items?: Array<ResolverInputTypes["StoryGuideListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["StoryGuideItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["StoryGuideListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["StoryGuideListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["StoryGuideItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["StoryGuideItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["StoryGuideItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["StoryGuideListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],
	data: ResolverInputTypes["StoryGuideItemWithoutListUpdateInput"]
};
	["StoryGuideItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	guide?: ResolverInputTypes["StoryGuideItemUpdateGuideEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideItemUpdateGuideEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideItemConnectOrCreateGuideRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StoryGuideUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["StoryGuideItemUpsertGuideRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StoryGuideUpdateInput"]: {
	mediaType?: ResolverInputTypes["MediaType"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	image?: ResolverInputTypes["StoryGuideUpdateImageEntityRelationInput"] | undefined | null,
	secondaryImage?: ResolverInputTypes["StoryGuideUpdateSecondaryImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["StoryGuideUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StoryGuideUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["StoryGuideUpdateSecondaryImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["StoryGuideUpsertSecondaryImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StoryGuideUpsertSecondaryImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["StoryGuideItemUpsertGuideRelationInput"]: {
	update: ResolverInputTypes["StoryGuideUpdateInput"],
	create: ResolverInputTypes["StoryGuideCreateInput"]
};
	["StoryGuideListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],
	update: ResolverInputTypes["StoryGuideItemWithoutListUpdateInput"],
	create: ResolverInputTypes["StoryGuideItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"]: {
	update: ResolverInputTypes["StoryGuideListUpdateInput"],
	create: ResolverInputTypes["StoryGuideListCreateInput"]
};
	["LocaleUpsertRecurringPaymentPagesRelationInput"]: {
	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],
	update: ResolverInputTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGivenGiftsPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateGivenGiftsPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertGivenGiftsPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateGivenGiftsPagesRelationInput"]: {
	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],
	data: ResolverInputTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"]
};
	["GivenGiftsPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GivenGiftsPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GivenGiftsPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GivenGiftsPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GivenGiftsPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GivenGiftsPageWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["GivenGiftsPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["GivenGiftsPageWithoutLocalesCreateInput"]
};
	["GivenGiftsPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GivenGiftsPageLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GivenGiftsPageLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GivenGiftsPageLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GivenGiftsPageLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutGivenGiftsPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutGivenGiftsPageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GivenGiftsPageLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutGivenGiftsPageUpdateInput"]: {
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateReportPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateReportPageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ReportPageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertReportPageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ReportPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	root?: ResolverInputTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	posts?: Array<ResolverInputTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ReportPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ReportPageWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["ReportPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["ReportPageWithoutLocalesCreateInput"]
};
	["ReportPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutReportPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutReportPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutReportPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateReceivedGiftsPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertReceivedGiftsPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateReceivedGiftsPagesRelationInput"]: {
	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	data: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"]
};
	["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	link?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutReceivedGiftsPageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReceivedGiftsPageLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutReceivedGiftsPageUpdateInput"]: {
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateGivenGiftsPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertGivenGiftsPageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GivenGiftsPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutGivenGiftsPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GivenGiftsPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutGivenGiftsPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateReportPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["ReportPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateReportPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertReportPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateReportPagesRelationInput"]: {
	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	data: ResolverInputTypes["ReportPageLocaleWithoutLocaleUpdateInput"]
};
	["ReportPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	link?: ResolverInputTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	posts?: Array<ResolverInputTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutReportPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutReportPageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportPageLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutReportPageUpdateInput"]: {
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateReceivedGiftsPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertReceivedGiftsPageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReceivedGiftsPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ReceivedGiftsPageWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["ReceivedGiftsPageWithoutLocalesCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutReceivedGiftsPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateReportNavigationsEntityRelationInput"]: {
	create?: ResolverInputTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateReportNavigationsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertReportNavigationsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateReportNavigationsRelationInput"]: {
	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	data: ResolverInputTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"]
};
	["ReportNavigationLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	pages?: Array<ResolverInputTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationLocaleUpdatePagesEntityRelationInput"]: {
	create?: ResolverInputTypes["GenericPageWithoutReportNavigationCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ReportNavigationLocaleUpdatePagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportNavigationLocaleUpsertPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportNavigationLocaleUpdatePagesRelationInput"]: {
	by: ResolverInputTypes["GenericPageUniqueWhere"],
	data: ResolverInputTypes["GenericPageWithoutReportNavigationUpdateInput"]
};
	["GenericPageWithoutReportNavigationUpdateInput"]: {
	locales?: Array<ResolverInputTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	type?: ResolverInputTypes["GenericPageType"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	data: ResolverInputTypes["GenericPageLocaleWithoutRootUpdateInput"]
};
	["GenericPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutGenericPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutGenericPageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutGenericPageUpdateInput"]: {
	url?: string | undefined | null,
	post?: ResolverInputTypes["LinkableUpdatePostEntityRelationInput"] | undefined | null,
	postArea?: ResolverInputTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined | null,
	postOrganization?: ResolverInputTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined | null,
	reportPage?: ResolverInputTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined | null,
	givenGiftsPage?: ResolverInputTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined | null,
	receivedGiftsPage?: ResolverInputTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutGenericPageUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	update: ResolverInputTypes["GenericPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["ReportNavigationLocaleUpsertPagesRelationInput"]: {
	by: ResolverInputTypes["GenericPageUniqueWhere"],
	update: ResolverInputTypes["GenericPageWithoutReportNavigationUpdateInput"],
	create: ResolverInputTypes["GenericPageWithoutReportNavigationCreateInput"]
};
	["LocaleUpsertReportNavigationsRelationInput"]: {
	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	update: ResolverInputTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["ReportNavigationLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateScheduledNotificationsEntityRelationInput"]: {
	create?: ResolverInputTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateScheduledNotificationsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertScheduledNotificationsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateScheduledNotificationsRelationInput"]: {
	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],
	data: ResolverInputTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"]
};
	["ScheduledNotificationLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	description?: string | undefined | null,
	root?: ResolverInputTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ScheduledNotificationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ScheduledNotificationWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ScheduledNotificationWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ScheduledNotificationLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ScheduledNotificationWithoutLocalesUpdateInput"]: {
	localMsFromMidnight?: number | undefined | null,
	scheduledDate?: ResolverInputTypes["Date"] | undefined | null,
	internalTitle?: string | undefined | null,
	target?: ResolverInputTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined | null,
	completedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationUpdateTargetEntityRelationInput"]: {
	connect?: ResolverInputTypes["NotificationTargetGroupUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["NotificationTargetGroupCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"] | undefined | null,
	update?: ResolverInputTypes["NotificationTargetGroupUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ScheduledNotificationUpsertTargetRelationInput"] | undefined | null
};
	["NotificationTargetGroupUpdateInput"]: {
	type?: ResolverInputTypes["NotificationTargetType"] | undefined | null,
	regions?: Array<ResolverInputTypes["NotificationTargetGroupUpdateRegionsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["NotificationTargetGroupUpdateRegionsEntityRelationInput"]: {
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	update?: ResolverInputTypes["NotificationTargetGroupUpdateRegionsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["NotificationTargetGroupUpsertRegionsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["NotificationTargetGroupUpdateRegionsRelationInput"]: {
	by: ResolverInputTypes["RegionUniqueWhere"],
	data: ResolverInputTypes["RegionUpdateInput"]
};
	["NotificationTargetGroupUpsertRegionsRelationInput"]: {
	by: ResolverInputTypes["RegionUniqueWhere"],
	update: ResolverInputTypes["RegionUpdateInput"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["ScheduledNotificationUpsertTargetRelationInput"]: {
	update: ResolverInputTypes["NotificationTargetGroupUpdateInput"],
	create: ResolverInputTypes["NotificationTargetGroupCreateInput"]
};
	["ScheduledNotificationUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ScheduledNotificationUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ScheduledNotificationUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]: {
	create?: ResolverInputTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ScheduledNotificationUpdateProcessedNotificationsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ScheduledNotificationUpsertProcessedNotificationsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ScheduledNotificationUpdateProcessedNotificationsRelationInput"]: {
	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],
	data: ResolverInputTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"]
};
	["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"]: {
	type?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined | null,
	donationReminderUser?: ResolverInputTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"]: {
	connect?: ResolverInputTypes["ProcessedNotificationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ProcessedNotificationWithoutSourceCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ProcessedNotificationWithoutSourceUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProcessedNotificationWithoutSourceUpdateInput"]: {
	topic?: string | undefined | null,
	sentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	errorMessage?: string | undefined | null,
	errorCode?: string | undefined | null,
	isSuccess?: boolean | undefined | null,
	title?: string | undefined | null,
	body?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"]: {
	update: ResolverInputTypes["ProcessedNotificationWithoutSourceUpdateInput"],
	create: ResolverInputTypes["ProcessedNotificationWithoutSourceCreateInput"]
};
	["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutProcessedNotificationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserWithoutProcessedNotificationsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserWithoutProcessedNotificationsUpdateInput"]: {
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserUpdateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdatePaymentsEntityRelationInput"]: {
	create?: ResolverInputTypes["UserPaymentWithoutUserCreateInput"] | undefined | null,
	update?: ResolverInputTypes["UserUpdatePaymentsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserUpsertPaymentsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdatePaymentsRelationInput"]: {
	by: ResolverInputTypes["UserPaymentUniqueWhere"],
	data: ResolverInputTypes["UserPaymentWithoutUserUpdateInput"]
};
	["UserPaymentWithoutUserUpdateInput"]: {
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CurrencyUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertCurrencyRelationInput"] | undefined | null
};
	["UserPaymentUpsertCurrencyRelationInput"]: {
	update: ResolverInputTypes["CurrencyUpdateInput"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["UserPaymentUpdateOrderEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentOrderIdCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateOrderRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserPaymentOrderIdUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertOrderRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentOrderIdUpdateInput"]: {
	seq?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentUpsertOrderRelationInput"]: {
	update: ResolverInputTypes["UserPaymentOrderIdUpdateInput"],
	create: ResolverInputTypes["UserPaymentOrderIdCreateInput"]
};
	["UserPaymentUpdateCsobPaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CsobPaymentWithoutPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CsobPaymentWithoutPaymentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertCsobPaymentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CsobPaymentWithoutPaymentUpdateInput"]: {
	payId?: string | undefined | null,
	statusChanges?: Array<ResolverInputTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"]> | undefined | null,
	originalPayId?: string | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentUpdateStatusChangesEntityRelationInput"]: {
	create?: ResolverInputTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | undefined | null,
	update?: ResolverInputTypes["CsobPaymentUpdateStatusChangesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["CsobPaymentUpsertStatusChangesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CsobPaymentUpdateStatusChangesRelationInput"]: {
	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],
	data: ResolverInputTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"]
};
	["CsobPaymentStatusChangeWithoutPaymentUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	dttm?: string | undefined | null,
	status?: number | undefined | null,
	resultCode?: number | undefined | null,
	message?: string | undefined | null,
	authCode?: string | undefined | null,
	statusDetail?: string | undefined | null,
	actions?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentUpsertStatusChangesRelationInput"]: {
	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],
	update: ResolverInputTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"],
	create: ResolverInputTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"]
};
	["CsobPaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ResolverInputTypes["CsobPaymentMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentUpsertCsobPaymentRelationInput"]: {
	update: ResolverInputTypes["CsobPaymentWithoutPaymentUpdateInput"],
	create: ResolverInputTypes["CsobPaymentWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateStripePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StripePaymentWithoutPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StripePaymentWithoutPaymentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertStripePaymentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StripePaymentWithoutPaymentUpdateInput"]: {
	identifier?: string | undefined | null,
	statusChanges?: Array<ResolverInputTypes["StripePaymentUpdateStatusChangesEntityRelationInput"]> | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentUpdateStatusChangesEntityRelationInput"]: {
	create?: ResolverInputTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | undefined | null,
	update?: ResolverInputTypes["StripePaymentUpdateStatusChangesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["StripePaymentUpsertStatusChangesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["StripePaymentUpdateStatusChangesRelationInput"]: {
	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],
	data: ResolverInputTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"]
};
	["StripePaymentStatusChangeWithoutPaymentUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	timestamp?: number | undefined | null,
	eventId?: string | undefined | null,
	paymentIntentStatus?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentUpsertStatusChangesRelationInput"]: {
	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],
	update: ResolverInputTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"],
	create: ResolverInputTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"]
};
	["StripePaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ResolverInputTypes["StripePaymentMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentUpsertStripePaymentRelationInput"]: {
	update: ResolverInputTypes["StripePaymentWithoutPaymentUpdateInput"],
	create: ResolverInputTypes["StripePaymentWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertRecurringPaymentItemRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserRecurringPaymentItemWithoutPaymentsUpdateInput"]: {
	recurrenceCounter?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	taskId?: string | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"] | undefined | null,
	isFailed?: boolean | undefined | null,
	failedEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserRecurringPaymentWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserRecurringPaymentWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["UserRecurringPaymentWithoutItemsUpdateInput"]: {
	activeSince?: ResolverInputTypes["DateTime"] | undefined | null,
	cancelledAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	interval?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	currency?: ResolverInputTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserRecurringPaymentUpdateUserEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CurrencyUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserRecurringPaymentUpsertCurrencyRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserRecurringPaymentUpsertCurrencyRelationInput"]: {
	update: ResolverInputTypes["CurrencyUpdateInput"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["UserRecurringPaymentUpdateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutRecurringPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserWithoutRecurringPaymentsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserRecurringPaymentUpsertUserRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserWithoutRecurringPaymentsUpdateInput"]: {
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserUpdateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateRegionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RegionUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserUpsertRegionRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserUpsertRegionRelationInput"]: {
	update: ResolverInputTypes["RegionUpdateInput"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["UserUpdateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateCurrencyRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CurrencyUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserUpsertCurrencyRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserUpsertCurrencyRelationInput"]: {
	update: ResolverInputTypes["CurrencyUpdateInput"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["UserUpdateOnBehalfDonationsEntityRelationInput"]: {
	create?: ResolverInputTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | undefined | null,
	update?: ResolverInputTypes["UserUpdateOnBehalfDonationsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserUpsertOnBehalfDonationsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdateOnBehalfDonationsRelationInput"]: {
	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],
	data: ResolverInputTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"]
};
	["OnBehalfDonationWithoutOnBehalfOfUpdateInput"]: {
	secretCode?: string | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	payments?: Array<ResolverInputTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"]> | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OnBehalfDonationUpdatePaymentsEntityRelationInput"]: {
	create?: ResolverInputTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | undefined | null,
	update?: ResolverInputTypes["OnBehalfDonationUpdatePaymentsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["OnBehalfDonationUpsertPaymentsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OnBehalfDonationUpdatePaymentsRelationInput"]: {
	by: ResolverInputTypes["UserPaymentUniqueWhere"],
	data: ResolverInputTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"]
};
	["UserPaymentWithoutOnBehalfDonationUpdateInput"]: {
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentUpdateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateRegionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RegionUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertRegionRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentUpsertRegionRelationInput"]: {
	update: ResolverInputTypes["RegionUpdateInput"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["UserPaymentUpdateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateUserRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserWithoutPaymentsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertUserRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserWithoutPaymentsUpdateInput"]: {
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserUpdateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdateRecurringPaymentsEntityRelationInput"]: {
	create?: ResolverInputTypes["UserRecurringPaymentWithoutUserCreateInput"] | undefined | null,
	update?: ResolverInputTypes["UserUpdateRecurringPaymentsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserUpsertRecurringPaymentsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdateRecurringPaymentsRelationInput"]: {
	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],
	data: ResolverInputTypes["UserRecurringPaymentWithoutUserUpdateInput"]
};
	["UserRecurringPaymentWithoutUserUpdateInput"]: {
	activeSince?: ResolverInputTypes["DateTime"] | undefined | null,
	cancelledAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	interval?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	currency?: ResolverInputTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	items?: Array<ResolverInputTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"]> | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | undefined | null,
	update?: ResolverInputTypes["UserRecurringPaymentUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserRecurringPaymentUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserRecurringPaymentUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],
	data: ResolverInputTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"]
};
	["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"]: {
	recurrenceCounter?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	taskId?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]> | undefined | null,
	isFailed?: boolean | undefined | null,
	failedEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]: {
	create?: ResolverInputTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | undefined | null,
	update?: ResolverInputTypes["UserRecurringPaymentItemUpdatePaymentsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserRecurringPaymentItemUpsertPaymentsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserRecurringPaymentItemUpdatePaymentsRelationInput"]: {
	by: ResolverInputTypes["UserPaymentUniqueWhere"],
	data: ResolverInputTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"]
};
	["UserPaymentWithoutRecurringPaymentItemUpdateInput"]: {
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentUpdateOnBehalfDonationEntityRelationInput"]: {
	connect?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["OnBehalfDonationWithoutPaymentsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertOnBehalfDonationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OnBehalfDonationWithoutPaymentsUpdateInput"]: {
	secretCode?: string | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	onBehalfOf?: ResolverInputTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutOnBehalfDonationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserWithoutOnBehalfDonationsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["OnBehalfDonationUpsertOnBehalfOfRelationInput"] | undefined | null
};
	["UserWithoutOnBehalfDonationsUpdateInput"]: {
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserUpdateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserUpsertLocaleRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateSentPaymentsEntityRelationInput"]: {
	create?: ResolverInputTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateSentPaymentsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertSentPaymentsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["SentPaymentLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateSentPaymentsRelationInput"]: {
	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],
	data: ResolverInputTypes["SentPaymentLocaleWithoutLocaleUpdateInput"]
};
	["SentPaymentLocaleWithoutLocaleUpdateInput"]: {
	organizationText?: string | undefined | null,
	root?: ResolverInputTypes["SentPaymentLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SentPaymentWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SentPaymentWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SentPaymentLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["SentPaymentWithoutLocalesUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	sendAt?: ResolverInputTypes["DateTime"] | undefined | null,
	currency?: ResolverInputTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentUpdateAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaWithoutSentPaymentsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SentPaymentConnectOrCreateAreaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaWithoutSentPaymentsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SentPaymentUpsertAreaRelationInput"] | undefined | null
};
	["PostAreaWithoutSentPaymentsUpdateInput"]: {
	order?: number | undefined | null,
	icon?: ResolverInputTypes["PostAreaUpdateIconEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined | null,
	regionListOverride?: ResolverInputTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined | null,
	color?: string | undefined | null,
	posts?: Array<ResolverInputTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined | null,
	specificSymbol?: number | undefined | null,
	region?: ResolverInputTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined | null,
	mobileHeroImage?: ResolverInputTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined | null,
	plainIcon?: ResolverInputTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined | null,
	areaSentPaymentCurrencySums?: Array<ResolverInputTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSentPaymentSum?: ResolverInputTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined | null,
	areaCurrencySums?: Array<ResolverInputTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined | null,
	areaSum?: ResolverInputTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaUpdateAreaSumEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaSumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SentPaymentUpsertAreaRelationInput"]: {
	update: ResolverInputTypes["PostAreaWithoutSentPaymentsUpdateInput"],
	create: ResolverInputTypes["PostAreaWithoutSentPaymentsCreateInput"]
};
	["SentPaymentLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["SentPaymentWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["SentPaymentWithoutLocalesCreateInput"]
};
	["LocaleUpsertSentPaymentsRelationInput"]: {
	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],
	update: ResolverInputTypes["SentPaymentLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["SentPaymentLocaleWithoutLocaleCreateInput"]
};
	["UserUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleUpdateInput"],
	create: ResolverInputTypes["LocaleCreateInput"]
};
	["UserUpdateDevicesEntityRelationInput"]: {
	create?: ResolverInputTypes["DeviceWithoutUserCreateInput"] | undefined | null,
	update?: ResolverInputTypes["UserUpdateDevicesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserUpsertDevicesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["DeviceUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["DeviceUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["DeviceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdateDevicesRelationInput"]: {
	by: ResolverInputTypes["DeviceUniqueWhere"],
	data: ResolverInputTypes["DeviceWithoutUserUpdateInput"]
};
	["DeviceWithoutUserUpdateInput"]: {
	fcmToken?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	ipAddress?: string | undefined | null,
	userAgent?: string | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpsertDevicesRelationInput"]: {
	by: ResolverInputTypes["DeviceUniqueWhere"],
	update: ResolverInputTypes["DeviceWithoutUserUpdateInput"],
	create: ResolverInputTypes["DeviceWithoutUserCreateInput"]
};
	["UserUpdateProcessedNotificationsEntityRelationInput"]: {
	create?: ResolverInputTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | undefined | null,
	update?: ResolverInputTypes["UserUpdateProcessedNotificationsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserUpsertProcessedNotificationsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdateProcessedNotificationsRelationInput"]: {
	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],
	data: ResolverInputTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"]
};
	["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"]: {
	type?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined | null,
	scheduledNotification?: ResolverInputTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"]: {
	connect?: ResolverInputTypes["ScheduledNotificationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"]: {
	localMsFromMidnight?: number | undefined | null,
	scheduledDate?: ResolverInputTypes["Date"] | undefined | null,
	internalTitle?: string | undefined | null,
	target?: ResolverInputTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"]> | undefined | null,
	image?: ResolverInputTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined | null,
	completedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ScheduledNotificationUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ScheduledNotificationUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ScheduledNotificationUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],
	data: ResolverInputTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"]
};
	["ScheduledNotificationLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	description?: string | undefined | null,
	locale?: ResolverInputTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutScheduledNotificationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutScheduledNotificationsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ScheduledNotificationLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutScheduledNotificationsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutScheduledNotificationsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutScheduledNotificationsCreateInput"]
};
	["ScheduledNotificationUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],
	update: ResolverInputTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["ScheduledNotificationLocaleWithoutRootCreateInput"]
};
	["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"]: {
	update: ResolverInputTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"],
	create: ResolverInputTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]
};
	["UserUpsertProcessedNotificationsRelationInput"]: {
	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],
	update: ResolverInputTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"],
	create: ResolverInputTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]
};
	["UserUpdateAreaStatsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserAreaStatsUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserAreaStatsUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserAreaStatsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdateOrganizationStatsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserOrganizationStatsUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserOrganizationStatsUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserOrganizationStatsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdatePostStatsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPostStatsUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserPostStatsUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserPostStatsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdateCurrencyStatsEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserCurrencyStatsUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserCurrencyStatsUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserCurrencyStatsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OnBehalfDonationUpsertOnBehalfOfRelationInput"]: {
	update: ResolverInputTypes["UserWithoutOnBehalfDonationsUpdateInput"],
	create: ResolverInputTypes["UserWithoutOnBehalfDonationsCreateInput"]
};
	["OnBehalfDonationUpdateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentUpsertOnBehalfDonationRelationInput"]: {
	update: ResolverInputTypes["OnBehalfDonationWithoutPaymentsUpdateInput"],
	create: ResolverInputTypes["OnBehalfDonationWithoutPaymentsCreateInput"]
};
	["UserPaymentUpdateTriesCollectionEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentUpsertTriesCollectionRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentTriesCollectionWithoutPaymentUpdateInput"]: {
	cents?: number | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	orderUrl?: string | undefined | null,
	user?: ResolverInputTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"] | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"] | undefined | null,
	recurring?: ResolverInputTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"] | undefined | null,
	metadataLocales?: Array<ResolverInputTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]> | undefined | null,
	medium?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionUpdateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentTriesCollectionUpsertUserRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserUpdateInput"]: {
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserUpdateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	devices?: Array<ResolverInputTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionUpsertUserRelationInput"]: {
	update: ResolverInputTypes["UserUpdateInput"],
	create: ResolverInputTypes["UserCreateInput"]
};
	["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CurrencyUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentTriesCollectionUpsertCurrencyRelationInput"] | undefined | null
};
	["UserPaymentTriesCollectionUpsertCurrencyRelationInput"]: {
	update: ResolverInputTypes["CurrencyUpdateInput"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"]: {
	connect?: ResolverInputTypes["OnBehalfDonationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["OnBehalfDonationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["OnBehalfDonationUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OnBehalfDonationUpdateInput"]: {
	secretCode?: string | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	payments?: Array<ResolverInputTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"]> | undefined | null,
	onBehalfOf?: ResolverInputTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"]: {
	update: ResolverInputTypes["OnBehalfDonationUpdateInput"],
	create: ResolverInputTypes["OnBehalfDonationCreateInput"]
};
	["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserRecurringPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserRecurringPaymentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentTriesCollectionUpsertRecurringRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserRecurringPaymentUpdateInput"]: {
	activeSince?: ResolverInputTypes["DateTime"] | undefined | null,
	cancelledAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	interval?: ResolverInputTypes["UserRecurringPaymentInterval"] | undefined | null,
	currency?: ResolverInputTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	items?: Array<ResolverInputTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"]> | undefined | null,
	user?: ResolverInputTypes["UserRecurringPaymentUpdateUserEntityRelationInput"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentUpdateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentTriesCollectionUpsertRecurringRelationInput"]: {
	update: ResolverInputTypes["UserRecurringPaymentUpdateInput"],
	create: ResolverInputTypes["UserRecurringPaymentCreateInput"]
};
	["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserPaymentUpsertTriesCollectionRelationInput"]: {
	update: ResolverInputTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"],
	create: ResolverInputTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserRecurringPaymentItemUpsertPaymentsRelationInput"]: {
	by: ResolverInputTypes["UserPaymentUniqueWhere"],
	update: ResolverInputTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"],
	create: ResolverInputTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"]
};
	["UserRecurringPaymentItemUpdateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserRecurringPaymentUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],
	update: ResolverInputTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"],
	create: ResolverInputTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]
};
	["UserUpsertRecurringPaymentsRelationInput"]: {
	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],
	update: ResolverInputTypes["UserRecurringPaymentWithoutUserUpdateInput"],
	create: ResolverInputTypes["UserRecurringPaymentWithoutUserCreateInput"]
};
	["UserPaymentUpsertUserRelationInput"]: {
	update: ResolverInputTypes["UserWithoutPaymentsUpdateInput"],
	create: ResolverInputTypes["UserWithoutPaymentsCreateInput"]
};
	["OnBehalfDonationUpsertPaymentsRelationInput"]: {
	by: ResolverInputTypes["UserPaymentUniqueWhere"],
	update: ResolverInputTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"],
	create: ResolverInputTypes["UserPaymentWithoutOnBehalfDonationCreateInput"]
};
	["UserUpsertOnBehalfDonationsRelationInput"]: {
	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],
	update: ResolverInputTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"],
	create: ResolverInputTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"]
};
	["UserRecurringPaymentUpsertUserRelationInput"]: {
	update: ResolverInputTypes["UserWithoutRecurringPaymentsUpdateInput"],
	create: ResolverInputTypes["UserWithoutRecurringPaymentsCreateInput"]
};
	["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"]: {
	update: ResolverInputTypes["UserRecurringPaymentWithoutItemsUpdateInput"],
	create: ResolverInputTypes["UserRecurringPaymentWithoutItemsCreateInput"]
};
	["UserPaymentUpsertRecurringPaymentItemRelationInput"]: {
	update: ResolverInputTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"],
	create: ResolverInputTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"]
};
	["UserUpsertPaymentsRelationInput"]: {
	by: ResolverInputTypes["UserPaymentUniqueWhere"],
	update: ResolverInputTypes["UserPaymentWithoutUserUpdateInput"],
	create: ResolverInputTypes["UserPaymentWithoutUserCreateInput"]
};
	["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"]: {
	update: ResolverInputTypes["UserWithoutProcessedNotificationsUpdateInput"],
	create: ResolverInputTypes["UserWithoutProcessedNotificationsCreateInput"]
};
	["ScheduledNotificationUpsertProcessedNotificationsRelationInput"]: {
	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],
	update: ResolverInputTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"],
	create: ResolverInputTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]
};
	["ScheduledNotificationLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["ScheduledNotificationWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["ScheduledNotificationWithoutLocalesCreateInput"]
};
	["LocaleUpsertScheduledNotificationsRelationInput"]: {
	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],
	update: ResolverInputTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"]
};
	["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutReceivedGiftsPagesCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReceivedGiftsPageLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReceivedGiftsPageLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["LinkableUpsertReceivedGiftsPageRelationInput"]: {
	update: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReportPageLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutReportPageUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutReportPageCreateInput"]
};
	["ReportPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportPageLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ReportPageLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["ReportPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportPageLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ReportPageLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["ReportPageLocaleUpdatePostsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostWithoutReportPageCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ReportPageLocaleUpdatePostsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportPageLocaleUpsertPostsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportPageLocaleUpdatePostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	data: ResolverInputTypes["PostWithoutReportPageUpdateInput"]
};
	["PostWithoutReportPageUpdateInput"]: {
	organization?: ResolverInputTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostUpdateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostUpdateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostUpdateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostUpdateMetaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostMetaDataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostUpdateHeroCarouselEntityRelationInput"]: {
	create?: ResolverInputTypes["HeroCarouselWithoutPostsCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateHeroCarouselRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertHeroCarouselRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HeroCarouselUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HeroCarouselUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HeroCarouselUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostUpdateHeroCarouselRelationInput"]: {
	by: ResolverInputTypes["HeroCarouselUniqueWhere"],
	data: ResolverInputTypes["HeroCarouselWithoutPostsUpdateInput"]
};
	["HeroCarouselWithoutPostsUpdateInput"]: {
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	items?: Array<ResolverInputTypes["HeroCarouselUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["HeroCarouselItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["HeroCarouselUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeroCarouselUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HeroCarouselItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HeroCarouselItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HeroCarouselItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["HeroCarouselUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],
	data: ResolverInputTypes["HeroCarouselItemWithoutListUpdateInput"]
};
	["HeroCarouselItemWithoutListUpdateInput"]: {
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	order?: number | undefined | null,
	item?: ResolverInputTypes["HeroCarouselItemUpdateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselItemUpdateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeroCarouselItemConnectOrCreateItemRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeroCarouselItemUpsertItemRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeroCarouselItemUpsertItemRelationInput"]: {
	update: ResolverInputTypes["PostUpdateInput"],
	create: ResolverInputTypes["PostCreateInput"]
};
	["HeroCarouselUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],
	update: ResolverInputTypes["HeroCarouselItemWithoutListUpdateInput"],
	create: ResolverInputTypes["HeroCarouselItemWithoutListCreateInput"]
};
	["PostUpsertHeroCarouselRelationInput"]: {
	by: ResolverInputTypes["HeroCarouselUniqueWhere"],
	update: ResolverInputTypes["HeroCarouselWithoutPostsUpdateInput"],
	create: ResolverInputTypes["HeroCarouselWithoutPostsCreateInput"]
};
	["PostUpdateContentEntityRelationInput"]: {
	create?: ResolverInputTypes["ContentReferenceWithoutPostsCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateContentRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertContentRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostUpdateContentRelationInput"]: {
	by: ResolverInputTypes["ContentReferenceUniqueWhere"],
	data: ResolverInputTypes["ContentReferenceWithoutPostsUpdateInput"]
};
	["ContentReferenceWithoutPostsUpdateInput"]: {
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	block?: ResolverInputTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null,
	video?: ResolverInputTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null,
	contentAlignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	valueList?: ResolverInputTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined | null,
	areaList?: ResolverInputTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined | null,
	isAppsVisible?: boolean | undefined | null,
	accordion?: ResolverInputTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null,
	memberList?: ResolverInputTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined | null,
	asideMediaContentLayout?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	isAsideMediaContentMobileLayout?: boolean | undefined | null,
	form?: ResolverInputTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined | null,
	isTitleBigger?: boolean | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined | null,
	heroCarousel?: ResolverInputTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined | null,
	isCentered?: boolean | undefined | null,
	textImageList?: ResolverInputTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertBlockRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ResolverInputTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentWithoutBlocksCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentWithoutBlocksUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentBlockUpsertContentRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentWithoutBlocksUpdateInput"],
	create: ResolverInputTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update: ResolverInputTypes["ContentBlockWithoutReferencesUpdateInput"],
	create: ResolverInputTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateValueListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ValueListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ValueListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateValueListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ValueListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertValueListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ValueListUpdateInput"]: {
	items?: Array<ResolverInputTypes["ValueListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["ValueItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ValueListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ValueListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ValueItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ValueItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ValueItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ValueListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["ValueItemUniqueWhere"],
	data: ResolverInputTypes["ValueItemWithoutListUpdateInput"]
};
	["ValueItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	item?: ResolverInputTypes["ValueItemUpdateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueItemUpdateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["ValueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ValueCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ValueItemConnectOrCreateItemRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ValueUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ValueItemUpsertItemRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ValueUpdateInput"]: {
	title?: string | undefined | null,
	textContent?: ResolverInputTypes["ValueUpdateTextContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueUpdateTextContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ValueConnectOrCreateTextContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ValueUpsertTextContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ValueUpsertTextContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["ValueItemUpsertItemRelationInput"]: {
	update: ResolverInputTypes["ValueUpdateInput"],
	create: ResolverInputTypes["ValueCreateInput"]
};
	["ValueListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["ValueItemUniqueWhere"],
	update: ResolverInputTypes["ValueItemWithoutListUpdateInput"],
	create: ResolverInputTypes["ValueItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertValueListRelationInput"]: {
	update: ResolverInputTypes["ValueListUpdateInput"],
	create: ResolverInputTypes["ValueListCreateInput"]
};
	["ContentReferenceUpdateImageLinkListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageLinkListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertImageLinkListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertImageLinkListRelationInput"]: {
	update: ResolverInputTypes["ImageLinkListUpdateInput"],
	create: ResolverInputTypes["ImageLinkListCreateInput"]
};
	["ContentReferenceUpdateAreaListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateAreaListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertAreaListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaListUpdateInput"]: {
	items?: Array<ResolverInputTypes["PostAreaListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostAreaListItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostAreaListItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostAreaListItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostAreaListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostAreaListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],
	data: ResolverInputTypes["PostAreaListItemWithoutListUpdateInput"]
};
	["PostAreaListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	item?: ResolverInputTypes["PostAreaListItemUpdateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaListItemUpdateItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaListItemConnectOrCreateItemRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaListItemUpsertItemRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaListItemUpsertItemRelationInput"]: {
	update: ResolverInputTypes["PostAreaUpdateInput"],
	create: ResolverInputTypes["PostAreaCreateInput"]
};
	["PostAreaListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],
	update: ResolverInputTypes["PostAreaListItemWithoutListUpdateInput"],
	create: ResolverInputTypes["PostAreaListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertAreaListRelationInput"]: {
	update: ResolverInputTypes["PostAreaListUpdateInput"],
	create: ResolverInputTypes["PostAreaListCreateInput"]
};
	["ContentReferenceUpdateAccordionEntityRelationInput"]: {
	connect?: ResolverInputTypes["AccordionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["AccordionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateAccordionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["AccordionUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertAccordionRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AccordionUpdateInput"]: {
	items?: Array<ResolverInputTypes["AccordionUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AccordionUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["AccordionItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["AccordionUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["AccordionUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["AccordionItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["AccordionItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["AccordionItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AccordionUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["AccordionItemUniqueWhere"],
	data: ResolverInputTypes["AccordionItemWithoutListUpdateInput"]
};
	["AccordionItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	descriptionContent?: ResolverInputTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AccordionItemUpdateDescriptionContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["AccordionItemUpsertDescriptionContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AccordionItemUpsertDescriptionContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["AccordionUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["AccordionItemUniqueWhere"],
	update: ResolverInputTypes["AccordionItemWithoutListUpdateInput"],
	create: ResolverInputTypes["AccordionItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertAccordionRelationInput"]: {
	update: ResolverInputTypes["AccordionUpdateInput"],
	create: ResolverInputTypes["AccordionCreateInput"]
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MediumListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertMediaRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumListUpdateInput"]: {
	items?: Array<ResolverInputTypes["MediumListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["MediumItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["MediumListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["MediumListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["MediumItemUniqueWhere"],
	data: ResolverInputTypes["MediumItemWithoutListUpdateInput"]
};
	["MediumItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	medium?: ResolverInputTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MediumUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumItemUpsertMediumRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumUpdateInput"]: {
	type?: ResolverInputTypes["MediumType"] | undefined | null,
	image?: ResolverInputTypes["MediumUpdateImageEntityRelationInput"] | undefined | null,
	video?: ResolverInputTypes["MediumUpdateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumConnectOrCreateVideoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["VideoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumUpsertVideoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumUpsertVideoRelationInput"]: {
	update: ResolverInputTypes["VideoUpdateInput"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["MediumItemUpsertMediumRelationInput"]: {
	update: ResolverInputTypes["MediumUpdateInput"],
	create: ResolverInputTypes["MediumCreateInput"]
};
	["MediumListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["MediumItemUniqueWhere"],
	update: ResolverInputTypes["MediumItemWithoutListUpdateInput"],
	create: ResolverInputTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMediaRelationInput"]: {
	update: ResolverInputTypes["MediumListUpdateInput"],
	create: ResolverInputTypes["MediumListCreateInput"]
};
	["ContentReferenceUpdateMemberListEntityRelationInput"]: {
	connect?: ResolverInputTypes["MemberListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MemberListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateMemberListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MemberListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertMemberListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MemberListUpdateInput"]: {
	items?: Array<ResolverInputTypes["MemberListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MemberListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["MemberListItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["MemberListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["MemberListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["MemberListItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["MemberListItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["MemberListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["MemberListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["MemberListItemUniqueWhere"],
	data: ResolverInputTypes["MemberListItemWithoutListUpdateInput"]
};
	["MemberListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	position?: string | undefined | null,
	image?: ResolverInputTypes["MemberListItemUpdateImageEntityRelationInput"] | undefined | null,
	descriptionContent?: ResolverInputTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MemberListItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MemberListItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MemberListItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MemberListItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["MemberListItemUpdateDescriptionContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MemberListItemUpsertDescriptionContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MemberListItemUpsertDescriptionContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["MemberListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["MemberListItemUniqueWhere"],
	update: ResolverInputTypes["MemberListItemWithoutListUpdateInput"],
	create: ResolverInputTypes["MemberListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMemberListRelationInput"]: {
	update: ResolverInputTypes["MemberListUpdateInput"],
	create: ResolverInputTypes["MemberListCreateInput"]
};
	["ContentReferenceUpdateFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["FormUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FormCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateFormRelationInput"] | undefined | null,
	update?: ResolverInputTypes["FormUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertFormRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FormUpdateInput"]: {
	name?: string | undefined | null,
	type?: ResolverInputTypes["FormType"] | undefined | null,
	tax?: ResolverInputTypes["FormUpdateTaxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FormUpdateTaxEntityRelationInput"]: {
	connect?: ResolverInputTypes["FilledTaxFormUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FilledTaxFormCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FormConnectOrCreateTaxRelationInput"] | undefined | null,
	update?: ResolverInputTypes["FilledTaxFormUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FormUpsertTaxRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FilledTaxFormUpdateInput"]: {
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	userId?: string | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	vatId?: string | undefined | null,
	address1?: string | undefined | null,
	address2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	state?: string | undefined | null,
	country?: ResolverInputTypes["FilledTaxFormUpdateCountryEntityRelationInput"] | undefined | null,
	dateFrom?: ResolverInputTypes["Date"] | undefined | null,
	dateTo?: ResolverInputTypes["Date"] | undefined | null,
	year?: number | undefined | null,
	isPdfGenerated?: boolean | undefined | null,
	pdfObjectKey?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FilledTaxFormUpdateCountryEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FilledTaxFormConnectOrCreateCountryRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RegionUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FilledTaxFormUpsertCountryRelationInput"] | undefined | null
};
	["FilledTaxFormUpsertCountryRelationInput"]: {
	update: ResolverInputTypes["RegionUpdateInput"],
	create: ResolverInputTypes["RegionCreateInput"]
};
	["FormUpsertTaxRelationInput"]: {
	update: ResolverInputTypes["FilledTaxFormUpdateInput"],
	create: ResolverInputTypes["FilledTaxFormCreateInput"]
};
	["ContentReferenceUpsertFormRelationInput"]: {
	update: ResolverInputTypes["FormUpdateInput"],
	create: ResolverInputTypes["FormCreateInput"]
};
	["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertContentWithoutBlocksRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertContentWithoutBlocksRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["ContentReferenceUpdateHeroCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeroCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeroCarouselCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"] | undefined | null,
	update?: ResolverInputTypes["HeroCarouselUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertHeroCarouselRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeroCarouselUpdateInput"]: {
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	posts?: Array<ResolverInputTypes["HeroCarouselUpdatePostsEntityRelationInput"]> | undefined | null,
	items?: Array<ResolverInputTypes["HeroCarouselUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselUpdatePostsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostWithoutHeroCarouselCreateInput"] | undefined | null,
	update?: ResolverInputTypes["HeroCarouselUpdatePostsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeroCarouselUpsertPostsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["HeroCarouselUpdatePostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	data: ResolverInputTypes["PostWithoutHeroCarouselUpdateInput"]
};
	["PostWithoutHeroCarouselUpdateInput"]: {
	organization?: ResolverInputTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostUpdateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostUpdateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostUpdateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostUpdateReportPageEntityRelationInput"]: {
	create?: ResolverInputTypes["ReportPageLocaleWithoutPostsCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateReportPageRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertReportPageRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostUpdateReportPageRelationInput"]: {
	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	data: ResolverInputTypes["ReportPageLocaleWithoutPostsUpdateInput"]
};
	["ReportPageLocaleWithoutPostsUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	link?: ResolverInputTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostUpsertReportPageRelationInput"]: {
	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	update: ResolverInputTypes["ReportPageLocaleWithoutPostsUpdateInput"],
	create: ResolverInputTypes["ReportPageLocaleWithoutPostsCreateInput"]
};
	["PostUpdateFundraiseCurrencyEntityRelationInput"]: {
	connect?: ResolverInputTypes["CurrencyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CurrencyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CurrencyUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostUpsertFundraiseCurrencyRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostUpsertFundraiseCurrencyRelationInput"]: {
	update: ResolverInputTypes["CurrencyUpdateInput"],
	create: ResolverInputTypes["CurrencyCreateInput"]
};
	["PostUpdateFundraiseCurrencySumsEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostCurrencySumUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostUpdateFundraiseSumEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostSumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostUpdateFundraisingProgressEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostFundraisingProgressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeroCarouselUpsertPostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	update: ResolverInputTypes["PostWithoutHeroCarouselUpdateInput"],
	create: ResolverInputTypes["PostWithoutHeroCarouselCreateInput"]
};
	["ContentReferenceUpsertHeroCarouselRelationInput"]: {
	update: ResolverInputTypes["HeroCarouselUpdateInput"],
	create: ResolverInputTypes["HeroCarouselCreateInput"]
};
	["ContentReferenceUpdateOrganizationListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertOrganizationListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertOrganizationListRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationListUpdateInput"],
	create: ResolverInputTypes["PostOrganizationListCreateInput"]
};
	["ContentReferenceUpdateTextImageListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextImageListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextImageListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TextImageListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertTextImageListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TextImageListUpdateInput"]: {
	items?: Array<ResolverInputTypes["TextImageListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextImageListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["TextImageListItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TextImageListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TextImageListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TextImageListItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TextImageListItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TextImageListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TextImageListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["TextImageListItemUniqueWhere"],
	data: ResolverInputTypes["TextImageListItemWithoutListUpdateInput"]
};
	["TextImageListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	image?: ResolverInputTypes["TextImageListItemUpdateImageEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	link?: ResolverInputTypes["TextImageListItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextImageListItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextImageListItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TextImageListItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TextImageListItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["TextImageListItemUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextImageListItemConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TextImageListItemUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TextImageListItemUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["TextImageListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["TextImageListItemUniqueWhere"],
	update: ResolverInputTypes["TextImageListItemWithoutListUpdateInput"],
	create: ResolverInputTypes["TextImageListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertTextImageListRelationInput"]: {
	update: ResolverInputTypes["TextImageListUpdateInput"],
	create: ResolverInputTypes["TextImageListCreateInput"]
};
	["PostUpsertContentRelationInput"]: {
	by: ResolverInputTypes["ContentReferenceUniqueWhere"],
	update: ResolverInputTypes["ContentReferenceWithoutPostsUpdateInput"],
	create: ResolverInputTypes["ContentReferenceWithoutPostsCreateInput"]
};
	["ReportPageLocaleUpsertPostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	update: ResolverInputTypes["PostWithoutReportPageUpdateInput"],
	create: ResolverInputTypes["PostWithoutReportPageCreateInput"]
};
	["LocaleUpsertReportPagesRelationInput"]: {
	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	update: ResolverInputTypes["ReportPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["ReportPageLocaleWithoutLocaleCreateInput"]
};
	["GivenGiftsPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutGivenGiftsPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutGivenGiftsPagesCreateInput"]
};
	["LinkableUpsertGivenGiftsPageRelationInput"]: {
	update: ResolverInputTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReceivedGiftsPageLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutReceivedGiftsPageUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutReceivedGiftsPageCreateInput"]
};
	["LocaleUpsertReceivedGiftsPagesRelationInput"]: {
	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	update: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["ReportPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutReportPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutReportPagesCreateInput"]
};
	["LinkableUpsertReportPageRelationInput"]: {
	update: ResolverInputTypes["ReportPageLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["ReportPageLocaleWithoutLinkCreateInput"]
};
	["GivenGiftsPageLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutGivenGiftsPageUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutGivenGiftsPageCreateInput"]
};
	["LocaleUpsertGivenGiftsPagesRelationInput"]: {
	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],
	update: ResolverInputTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["PostOrganizationLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutPostOrganizationsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutPostOrganizationsCreateInput"]
};
	["PostOrganizationLocaleUpdateDomainEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationLocaleUpsertDomainRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationLocaleUpsertDomainRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["PostOrganizationLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["PostOrganizationLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["LinkableUpsertPostOrganizationRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["PostOrganizationLocaleWithoutLinkCreateInput"]
};
	["PostLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutPostUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutPostCreateInput"]
};
	["PostUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["PostLocaleUniqueWhere"],
	update: ResolverInputTypes["PostLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["PostLocaleWithoutRootCreateInput"]
};
	["TileItemUpsertPostRelationInput"]: {
	update: ResolverInputTypes["PostUpdateInput"],
	create: ResolverInputTypes["PostCreateInput"]
};
	["TileItemUpdateAreaEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateAreaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileItemUpsertAreaRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileItemUpsertAreaRelationInput"]: {
	update: ResolverInputTypes["PostAreaUpdateInput"],
	create: ResolverInputTypes["PostAreaCreateInput"]
};
	["TileItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["TileItemUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileItemUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileItemUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["TileItemUpdateOrganizationEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateOrganizationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileItemUpsertOrganizationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileItemUpsertOrganizationRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationUpdateInput"],
	create: ResolverInputTypes["PostOrganizationCreateInput"]
};
	["TileListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["TileItemUniqueWhere"],
	update: ResolverInputTypes["TileItemWithoutListUpdateInput"],
	create: ResolverInputTypes["TileItemWithoutListCreateInput"]
};
	["TileListUpdateAreaTypeEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileListConnectOrCreateAreaTypeRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileListUpsertAreaTypeRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileListUpsertAreaTypeRelationInput"]: {
	update: ResolverInputTypes["PostAreaUpdateInput"],
	create: ResolverInputTypes["PostAreaCreateInput"]
};
	["FeedPageLocaleUpsertHeroTilesRelationInput"]: {
	update: ResolverInputTypes["TileListUpdateInput"],
	create: ResolverInputTypes["TileListCreateInput"]
};
	["FeedPageLocaleUpdateSectionListEntityRelationInput"]: {
	create?: ResolverInputTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["FeedPageLocaleUpdateSectionListRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageLocaleUpsertSectionListRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FeedPageLocaleUpdateSectionListRelationInput"]: {
	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],
	data: ResolverInputTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"]
};
	["FeedPageSectionWithoutFeedPageLocaleUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	tileStripeList?: Array<ResolverInputTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageSectionUpdateTileStripeListEntityRelationInput"]: {
	create?: ResolverInputTypes["FeedPageTileStripeWithoutSectionCreateInput"] | undefined | null,
	update?: ResolverInputTypes["FeedPageSectionUpdateTileStripeListRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageSectionUpsertTileStripeListRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FeedPageTileStripeUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FeedPageTileStripeUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FeedPageTileStripeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FeedPageSectionUpdateTileStripeListRelationInput"]: {
	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],
	data: ResolverInputTypes["FeedPageTileStripeWithoutSectionUpdateInput"]
};
	["FeedPageTileStripeWithoutSectionUpdateInput"]: {
	order?: number | undefined | null,
	tileList?: ResolverInputTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageTileStripeUpdateTileListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TileListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TileListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageTileStripeUpsertTileListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FeedPageTileStripeUpsertTileListRelationInput"]: {
	update: ResolverInputTypes["TileListUpdateInput"],
	create: ResolverInputTypes["TileListCreateInput"]
};
	["FeedPageSectionUpsertTileStripeListRelationInput"]: {
	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],
	update: ResolverInputTypes["FeedPageTileStripeWithoutSectionUpdateInput"],
	create: ResolverInputTypes["FeedPageTileStripeWithoutSectionCreateInput"]
};
	["FeedPageLocaleUpsertSectionListRelationInput"]: {
	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],
	update: ResolverInputTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"],
	create: ResolverInputTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"]
};
	["FeedPageLocaleUpdateCardListEntityRelationInput"]: {
	connect?: ResolverInputTypes["CardListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CardListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CardListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageLocaleUpsertCardListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CardListUpdateInput"]: {
	items?: Array<ResolverInputTypes["CardListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CardListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["CardItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["CardListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["CardListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["CardItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["CardItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["CardItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CardListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["CardItemUniqueWhere"],
	data: ResolverInputTypes["CardItemWithoutListUpdateInput"]
};
	["CardItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["CardItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CardItemUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CardItemConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CardItemUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CardItemUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["CardListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["CardItemUniqueWhere"],
	update: ResolverInputTypes["CardItemWithoutListUpdateInput"],
	create: ResolverInputTypes["CardItemWithoutListCreateInput"]
};
	["FeedPageLocaleUpsertCardListRelationInput"]: {
	update: ResolverInputTypes["CardListUpdateInput"],
	create: ResolverInputTypes["CardListCreateInput"]
};
	["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StoryGuideListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageLocaleUpsertStoryGuideListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FeedPageLocaleUpsertStoryGuideListRelationInput"]: {
	update: ResolverInputTypes["StoryGuideListUpdateInput"],
	create: ResolverInputTypes["StoryGuideListCreateInput"]
};
	["LocaleUpsertFeedPagesRelationInput"]: {
	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],
	update: ResolverInputTypes["FeedPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["FeedPageLocaleWithoutLocaleCreateInput"]
};
	["PostRevisionLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutPostRevisionsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutPostRevisionsCreateInput"]
};
	["PostRevisionLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["PostRevisionLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["PostRevisionLocaleUpdateLeadContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostRevisionLocaleUpsertLeadContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostRevisionLocaleUpsertLeadContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["PostRevisionUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],
	update: ResolverInputTypes["PostRevisionLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["PostRevisionLocaleWithoutRootCreateInput"]
};
	["PostUpsertActiveRevisionRelationInput"]: {
	update: ResolverInputTypes["PostRevisionUpdateInput"],
	create: ResolverInputTypes["PostRevisionCreateInput"]
};
	["PostRevisionUpsertPostRelationInput"]: {
	update: ResolverInputTypes["PostWithoutRevisionsUpdateInput"],
	create: ResolverInputTypes["PostWithoutRevisionsCreateInput"]
};
	["PostRevisionLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["PostRevisionWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["PostRevisionWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostRevisionsRelationInput"]: {
	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],
	update: ResolverInputTypes["PostRevisionLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["PostRevisionLocaleWithoutLocaleCreateInput"]
};
	["SentPaymentLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutSentPaymentsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutSentPaymentsCreateInput"]
};
	["SentPaymentUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],
	update: ResolverInputTypes["SentPaymentLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["SentPaymentLocaleWithoutRootCreateInput"]
};
	["PostAreaUpsertSentPaymentsRelationInput"]: {
	by: ResolverInputTypes["SentPaymentUniqueWhere"],
	update: ResolverInputTypes["SentPaymentWithoutAreaUpdateInput"],
	create: ResolverInputTypes["SentPaymentWithoutAreaCreateInput"]
};
	["PostOrganizationUpsertAreaRelationInput"]: {
	update: ResolverInputTypes["PostAreaUpdateInput"],
	create: ResolverInputTypes["PostAreaCreateInput"]
};
	["PostOrganizationUpdateSentPaymentsEntityRelationInput"]: {
	create?: ResolverInputTypes["SentPaymentWithoutOrganizationCreateInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationUpdateSentPaymentsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationUpsertSentPaymentsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["SentPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PostOrganizationUpdateSentPaymentsRelationInput"]: {
	by: ResolverInputTypes["SentPaymentUniqueWhere"],
	data: ResolverInputTypes["SentPaymentWithoutOrganizationUpdateInput"]
};
	["SentPaymentWithoutOrganizationUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	sendAt?: ResolverInputTypes["DateTime"] | undefined | null,
	currency?: ResolverInputTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationUpsertSentPaymentsRelationInput"]: {
	by: ResolverInputTypes["SentPaymentUniqueWhere"],
	update: ResolverInputTypes["SentPaymentWithoutOrganizationUpdateInput"],
	create: ResolverInputTypes["SentPaymentWithoutOrganizationCreateInput"]
};
	["PostOrganizationLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["PostOrganizationWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostOrganizationsRelationInput"]: {
	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],
	update: ResolverInputTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["PostOrganizationLocaleWithoutLocaleCreateInput"]
};
	["PostAreaLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutPostAreasUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutPostAreasCreateInput"]
};
	["PostAreaLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["PostAreaLocaleUpdateBannerEntityRelationInput"]: {
	connect?: ResolverInputTypes["AppBannerUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["AppBannerCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"] | undefined | null,
	update?: ResolverInputTypes["AppBannerUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaLocaleUpsertBannerRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AppBannerUpdateInput"]: {
	title?: string | undefined | null,
	imageSmall?: ResolverInputTypes["AppBannerUpdateImageSmallEntityRelationInput"] | undefined | null,
	imageBig?: ResolverInputTypes["AppBannerUpdateImageBigEntityRelationInput"] | undefined | null,
	textContent?: ResolverInputTypes["AppBannerUpdateTextContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AppBannerUpdateImageSmallEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AppBannerConnectOrCreateImageSmallRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["AppBannerUpsertImageSmallRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AppBannerUpsertImageSmallRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["AppBannerUpdateImageBigEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AppBannerConnectOrCreateImageBigRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["AppBannerUpsertImageBigRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AppBannerUpsertImageBigRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["AppBannerUpdateTextContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AppBannerConnectOrCreateTextContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["AppBannerUpsertTextContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AppBannerUpsertTextContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["PostAreaLocaleUpsertBannerRelationInput"]: {
	update: ResolverInputTypes["AppBannerUpdateInput"],
	create: ResolverInputTypes["AppBannerCreateInput"]
};
	["PostAreaLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["LinkableUpsertPostAreaRelationInput"]: {
	update: ResolverInputTypes["PostAreaLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["PostAreaLocaleWithoutLinkCreateInput"]
};
	["PostOrganizationLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutPostOrganizationUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutPostOrganizationCreateInput"]
};
	["PostOrganizationUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],
	update: ResolverInputTypes["PostOrganizationLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["PostOrganizationLocaleWithoutRootCreateInput"]
};
	["PostUpsertOrganizationRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationWithoutPostsUpdateInput"],
	create: ResolverInputTypes["PostOrganizationWithoutPostsCreateInput"]
};
	["PostAreaUpsertPostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	update: ResolverInputTypes["PostWithoutAreaUpdateInput"],
	create: ResolverInputTypes["PostWithoutAreaCreateInput"]
};
	["PostAreaLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["PostAreaWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["PostAreaWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostAreasRelationInput"]: {
	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],
	update: ResolverInputTypes["PostAreaLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["PostAreaLocaleWithoutLocaleCreateInput"]
};
	["PostLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutPostsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutPostsCreateInput"]
};
	["PostLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PostWithoutLocalesUpdateInput"]: {
	organization?: ResolverInputTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostUpdateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostUpdateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null,
	content?: Array<ResolverInputTypes["PostUpdateContentEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["PostWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["PostWithoutLocalesCreateInput"]
};
	["LinkableUpsertPostRelationInput"]: {
	update: ResolverInputTypes["PostLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["PostLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableUpdateInput"],
	create: ResolverInputTypes["LinkableCreateInput"]
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["ContentReferenceUpdatePostsEntityRelationInput"]: {
	create?: ResolverInputTypes["PostWithoutContentCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ContentReferenceUpdatePostsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertPostsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceUpdatePostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	data: ResolverInputTypes["PostWithoutContentUpdateInput"]
};
	["PostWithoutContentUpdateInput"]: {
	organization?: ResolverInputTypes["PostUpdateOrganizationEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["PostUpdateAreaEntityRelationInput"] | undefined | null,
	specificSymbol?: number | undefined | null,
	activeRevision?: ResolverInputTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined | null,
	revisions?: Array<ResolverInputTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined | null,
	locales?: Array<ResolverInputTypes["PostUpdateLocalesEntityRelationInput"]> | undefined | null,
	isPinnedInArea?: boolean | undefined | null,
	isPinnedInOrganization?: boolean | undefined | null,
	state?: ResolverInputTypes["PostState"] | undefined | null,
	meta?: ResolverInputTypes["PostUpdateMetaEntityRelationInput"] | undefined | null,
	isPublishedAtHidden?: boolean | undefined | null,
	heroCarousel?: Array<ResolverInputTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined | null,
	reportPage?: Array<ResolverInputTypes["PostUpdateReportPageEntityRelationInput"]> | undefined | null,
	fundraiseIsActive?: boolean | undefined | null,
	fundraiseEndDate?: ResolverInputTypes["Date"] | undefined | null,
	fundraiseTargetAmount?: number | undefined | null,
	fundraiseFakeAddOnAmount?: number | undefined | null,
	fundraiseCurrency?: ResolverInputTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined | null,
	fundraiseCurrencySums?: Array<ResolverInputTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined | null,
	fundraiseSum?: ResolverInputTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined | null,
	fundraisingProgress?: ResolverInputTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpsertPostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	update: ResolverInputTypes["PostWithoutContentUpdateInput"],
	create: ResolverInputTypes["PostWithoutContentCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by: ResolverInputTypes["ContentReferenceUniqueWhere"],
	update: ResolverInputTypes["ContentReferenceWithoutBlockUpdateInput"],
	create: ResolverInputTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
	by: ResolverInputTypes["ContentBlockUniqueWhere"],
	update: ResolverInputTypes["ContentBlockWithoutContentUpdateInput"],
	create: ResolverInputTypes["ContentBlockWithoutContentCreateInput"]
};
	["PostLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["LocaleUpsertPostsRelationInput"]: {
	by: ResolverInputTypes["PostLocaleUniqueWhere"],
	update: ResolverInputTypes["PostLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["PostLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutGenericPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableUpsertGenericPageRelationInput"]: {
	update: ResolverInputTypes["GenericPageLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["PostAreaLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutPostAreaUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutPostAreaCreateInput"]
};
	["PostAreaUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],
	update: ResolverInputTypes["PostAreaLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["PostAreaLocaleWithoutRootCreateInput"]
};
	["PostUpsertAreaRelationInput"]: {
	update: ResolverInputTypes["PostAreaWithoutPostsUpdateInput"],
	create: ResolverInputTypes["PostAreaWithoutPostsCreateInput"]
};
	["PostOrganizationUpsertPostsRelationInput"]: {
	by: ResolverInputTypes["PostUniqueWhere"],
	update: ResolverInputTypes["PostWithoutOrganizationUpdateInput"],
	create: ResolverInputTypes["PostWithoutOrganizationCreateInput"]
};
	["PostOrganizationListItemUpsertItemRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationUpdateInput"],
	create: ResolverInputTypes["PostOrganizationCreateInput"]
};
	["PostOrganizationListItemUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationListItemUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationListItemUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["PostOrganizationListItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationListItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationListItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["PostOrganizationListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],
	update: ResolverInputTypes["PostOrganizationListItemWithoutListUpdateInput"],
	create: ResolverInputTypes["PostOrganizationListItemWithoutListCreateInput"]
};
	["GeneralUpsertOrganizationListRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationListUpdateInput"],
	create: ResolverInputTypes["PostOrganizationListCreateInput"]
};
	["GeneralLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["GeneralWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GeneralLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertAppStoreLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GeneralLocaleUpsertAppStoreLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertGooglePlayLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GeneralLocaleUpsertGooglePlayLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LocaleUpsertGeneralsRelationInput"]: {
	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	update: ResolverInputTypes["GeneralLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["ReportNavigationLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutReportNavigationsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutReportNavigationsCreateInput"]
};
	["GenericPageUpsertReportNavigationRelationInput"]: {
	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	update: ResolverInputTypes["ReportNavigationLocaleWithoutPagesUpdateInput"],
	create: ResolverInputTypes["ReportNavigationLocaleWithoutPagesCreateInput"]
};
	["GenericPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["GenericPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["GenericPageWithoutLocalesCreateInput"]
};
	["LocaleUpsertGenericPagesRelationInput"]: {
	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	update: ResolverInputTypes["GenericPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutGeneralsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutGeneralsCreateInput"]
};
	["GeneralUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	update: ResolverInputTypes["GeneralLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageEdge"]: AliasType<{
	node?:ResolverInputTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined | null,
	type?: ResolverInputTypes["GenericPageType"] | undefined | null,
	order?: number | undefined | null,
	reportNavigation?: Array<ResolverInputTypes["GenericPageCreateReportNavigationEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageUpdateInput"]: {
	locales?: Array<ResolverInputTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	type?: ResolverInputTypes["GenericPageType"] | undefined | null,
	order?: number | undefined | null,
	reportNavigation?: Array<ResolverInputTypes["GenericPageUpdateReportNavigationEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["LinkableEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableEdge"]: AliasType<{
	node?:ResolverInputTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SeoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoEdge"]: AliasType<{
	node?:ResolverInputTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["ContentConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentEdge"]: AliasType<{
	node?:ResolverInputTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ResolverInputTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null,
	references?: Array<ResolverInputTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ResolverInputTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null,
	references?: Array<ResolverInputTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	block?: ResolverInputTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null,
	video?: ResolverInputTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null,
	contentAlignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	valueList?: ResolverInputTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined | null,
	areaList?: ResolverInputTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined | null,
	isAppsVisible?: boolean | undefined | null,
	accordion?: ResolverInputTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null,
	memberList?: ResolverInputTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined | null,
	asideMediaContentLayout?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	isAsideMediaContentMobileLayout?: boolean | undefined | null,
	form?: ResolverInputTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined | null,
	isTitleBigger?: boolean | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined | null,
	heroCarousel?: ResolverInputTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined | null,
	isCentered?: boolean | undefined | null,
	posts?: Array<ResolverInputTypes["ContentReferenceCreatePostsEntityRelationInput"]> | undefined | null,
	textImageList?: ResolverInputTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpdateInput"]: {
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	block?: ResolverInputTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null,
	video?: ResolverInputTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null,
	contentAlignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	valueList?: ResolverInputTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined | null,
	areaList?: ResolverInputTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined | null,
	isAppsVisible?: boolean | undefined | null,
	accordion?: ResolverInputTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null,
	memberList?: ResolverInputTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined | null,
	asideMediaContentLayout?: ResolverInputTypes["AsideMediaContentLayout"] | undefined | null,
	isAsideMediaContentMobileLayout?: boolean | undefined | null,
	form?: ResolverInputTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined | null,
	isTitleBigger?: boolean | undefined | null,
	contentWithoutBlocks?: ResolverInputTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined | null,
	heroCarousel?: ResolverInputTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined | null,
	organizationList?: ResolverInputTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined | null,
	isCentered?: boolean | undefined | null,
	posts?: Array<ResolverInputTypes["ContentReferenceUpdatePostsEntityRelationInput"]> | undefined | null,
	textImageList?: ResolverInputTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null,
	appStoreLink?: ResolverInputTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined | null,
	allAreasDescription?: string | undefined | null,
	allOrganizationsDescription?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleUpdateInput"]: {
	root?: ResolverInputTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	appStoreLink?: ResolverInputTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined | null,
	googlePlayLink?: ResolverInputTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined | null,
	allAreasDescription?: string | undefined | null,
	allOrganizationsDescription?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["LocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["VideoConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["VideoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VideoEdge"]: AliasType<{
	node?:ResolverInputTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["LinkConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["LinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkEdge"]: AliasType<{
	node?:ResolverInputTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	content?: ResolverInputTypes["PostLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostLocaleCreateRootEntityRelationInput"] | undefined | null,
	paymentName?: string | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostLocaleUpdateInput"]: {
	content?: ResolverInputTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined | null,
	paymentName?: string | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaEdge"]: AliasType<{
	node?:ResolverInputTypes["PostArea"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined | null,
	banner?: ResolverInputTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined | null,
	shortDescription?: string | undefined | null,
	content?: ResolverInputTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaLocaleUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	banner?: ResolverInputTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined | null,
	shortDescription?: string | undefined | null,
	content?: ResolverInputTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostOrganizationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationEdge"]: AliasType<{
	node?:ResolverInputTypes["PostOrganization"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	domain?: ResolverInputTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationLocaleUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	link?: ResolverInputTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	domain?: ResolverInputTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["DonationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DonationEdge"]: AliasType<{
	node?:ResolverInputTypes["Donation"],
		__typename?: boolean | `@${string}`
}>;
	["DonationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	regionList?: ResolverInputTypes["DonationCreateRegionListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationCreateRegionListEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationConnectOrCreateRegionListRelationInput"] | undefined | null
};
	["DonationAmountsRegionListWithoutDonationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	regions?: Array<ResolverInputTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationConnectOrCreateRegionListRelationInput"]: {
	connect: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],
	create: ResolverInputTypes["DonationAmountsRegionListWithoutDonationCreateInput"]
};
	["DonationUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	regionList?: ResolverInputTypes["DonationUpdateRegionListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationUpdateRegionListEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationConnectOrCreateRegionListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["DonationAmountsRegionListWithoutDonationUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["DonationUpsertRegionListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DonationAmountsRegionListWithoutDonationUpdateInput"]: {
	regions?: Array<ResolverInputTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationUpsertRegionListRelationInput"]: {
	update: ResolverInputTypes["DonationAmountsRegionListWithoutDonationUpdateInput"],
	create: ResolverInputTypes["DonationAmountsRegionListWithoutDonationCreateInput"]
};
	["DonationAmountItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	amount?: number | undefined | null,
	regionItem?: ResolverInputTypes["DonationAmountItemCreateRegionItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountItemCreateRegionItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"] | undefined | null
};
	["DonationAmountsRegionItemWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined | null,
	region?: ResolverInputTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined | null,
	minimumAmount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountItemConnectOrCreateRegionItemRelationInput"]: {
	connect: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],
	create: ResolverInputTypes["DonationAmountsRegionItemWithoutItemsCreateInput"]
};
	["DonationAmountItemUpdateInput"]: {
	order?: number | undefined | null,
	amount?: number | undefined | null,
	regionItem?: ResolverInputTypes["DonationAmountItemUpdateRegionItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountItemUpdateRegionItemEntityRelationInput"]: {
	connect?: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"] | undefined | null,
	update?: ResolverInputTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["DonationAmountItemUpsertRegionItemRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["DonationAmountsRegionItemWithoutItemsUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined | null,
	region?: ResolverInputTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined | null,
	minimumAmount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountItemUpsertRegionItemRelationInput"]: {
	update: ResolverInputTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"],
	create: ResolverInputTypes["DonationAmountsRegionItemWithoutItemsCreateInput"]
};
	["DonationAmountsRegionItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	items?: Array<ResolverInputTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined | null,
	region?: ResolverInputTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined | null,
	minimumAmount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionItemUpdateInput"]: {
	order?: number | undefined | null,
	items?: Array<ResolverInputTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined | null,
	list?: ResolverInputTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined | null,
	region?: ResolverInputTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined | null,
	minimumAmount?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DonationAmountsRegionListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["DonationAmountsRegionListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListEdge"]: AliasType<{
	node?:ResolverInputTypes["DonationAmountsRegionList"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["LinkItemCreateListEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["LinkItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkItemConnectOrCreateListRelationInput"] | undefined | null
};
	["LinkListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["LinkListUniqueWhere"],
	create: ResolverInputTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["LinkItemUpdateListEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["LinkItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["LinkItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["LinkListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["LinkListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListEdge"]: AliasType<{
	node?:ResolverInputTypes["LinkList"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HeaderEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderEdge"]: AliasType<{
	node?:ResolverInputTypes["Header"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	logo?: ResolverInputTypes["HeaderCreateLogoEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["HeaderCreateLocalesEntityRelationInput"]> | undefined | null,
	organizationList?: ResolverInputTypes["HeaderCreateOrganizationListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeaderLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	links?: ResolverInputTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutHeadersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutHeadersCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	create: ResolverInputTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	logo?: ResolverInputTypes["HeaderUpdateLogoEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["HeaderUpdateLocalesEntityRelationInput"]> | undefined | null,
	organizationList?: ResolverInputTypes["HeaderUpdateOrganizationListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["HeaderLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["HeaderUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	data: ResolverInputTypes["HeaderLocaleWithoutRootUpdateInput"]
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	links?: ResolverInputTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutHeadersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutHeadersUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutHeadersUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutHeadersUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	update: ResolverInputTypes["HeaderLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	links?: ResolverInputTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleUpdateInput"]: {
	root?: ResolverInputTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	links?: ResolverInputTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FooterEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FooterEdge"]: AliasType<{
	node?:ResolverInputTypes["Footer"],
		__typename?: boolean | `@${string}`
}>;
	["FooterCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["FooterCreateLocalesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["FooterCreateLogoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	copyright?: string | undefined | null,
	locale?: ResolverInputTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	linkList?: ResolverInputTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined | null,
	contactEmail?: string | undefined | null,
	addressInfo?: ResolverInputTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutFootersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutFootersCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["FooterLocaleUniqueWhere"],
	create: ResolverInputTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["FooterUpdateLocalesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["FooterUpdateLogoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["FooterLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["FooterUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["FooterLocaleUniqueWhere"],
	data: ResolverInputTypes["FooterLocaleWithoutRootUpdateInput"]
};
	["FooterLocaleWithoutRootUpdateInput"]: {
	copyright?: string | undefined | null,
	locale?: ResolverInputTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	linkList?: ResolverInputTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined | null,
	contactEmail?: string | undefined | null,
	addressInfo?: ResolverInputTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutFootersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutFootersUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutFootersUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutFootersUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["FooterLocaleUniqueWhere"],
	update: ResolverInputTypes["FooterLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	copyright?: string | undefined | null,
	root?: ResolverInputTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	linkList?: ResolverInputTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined | null,
	contactEmail?: string | undefined | null,
	addressInfo?: ResolverInputTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpdateInput"]: {
	copyright?: string | undefined | null,
	root?: ResolverInputTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	linkList?: ResolverInputTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined | null,
	contactEmail?: string | undefined | null,
	addressInfo?: ResolverInputTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined | null,
	imageLinkList?: ResolverInputTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostListEdge"]: AliasType<{
	node?:ResolverInputTypes["PostList"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["PostListItemCreateListEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["PostListItemCreatePostEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostListItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostListItemConnectOrCreateListRelationInput"] | undefined | null
};
	["PostListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostListItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["PostListUniqueWhere"],
	create: ResolverInputTypes["PostListWithoutItemsCreateInput"]
};
	["PostListItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["PostListItemUpdateListEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["PostListItemUpdatePostEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostListItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostListItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostListItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PostListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["PostListItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["PostListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["PostListWithoutItemsCreateInput"]
};
	["AppBannerConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["AppBannerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerEdge"]: AliasType<{
	node?:ResolverInputTypes["AppBanner"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GenericPageAboutSettingsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsEdge"]: AliasType<{
	node?:ResolverInputTypes["GenericPageAboutSettings"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	linkGroups?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutGenericPageAboutSettingsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"]
};
	["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]
};
	["GenericPageAboutSettingsUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageAboutSettingsUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageAboutSettingsUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageAboutSettingsUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	data: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"]
};
	["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	linkGroups?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutGenericPageAboutSettingsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"]
};
	["GenericPageAboutSettingsUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	update: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]
};
	["GenericPageAboutSettingsLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	linkGroups?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleUpdateInput"]: {
	root?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	linkGroups?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ValueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ValueEdge"]: AliasType<{
	node?:ResolverInputTypes["Value"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["ValueItemCreateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["ValueItemCreateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ValueListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ValueListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ValueItemConnectOrCreateListRelationInput"] | undefined | null
};
	["ValueListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["ValueListUniqueWhere"],
	create: ResolverInputTypes["ValueListWithoutItemsCreateInput"]
};
	["ValueItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["ValueItemUpdateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["ValueItemUpdateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ValueItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ValueListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ValueListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ValueItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ValueListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ValueItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ValueListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ValueItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["ValueListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["ValueListWithoutItemsCreateInput"]
};
	["ValueListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ValueListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListEdge"]: AliasType<{
	node?:ResolverInputTypes["ValueList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageLinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkEdge"]: AliasType<{
	node?:ResolverInputTypes["ImageLink"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["ImageLinkItemCreateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["ImageLinkItemCreateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkItemConnectOrCreateListRelationInput"] | undefined | null
};
	["ImageLinkListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["ImageLinkListUniqueWhere"],
	create: ResolverInputTypes["ImageLinkListWithoutItemsCreateInput"]
};
	["ImageLinkItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["ImageLinkItemUpdateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["ImageLinkItemUpdateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageLinkListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageLinkListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageLinkItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageLinkListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageLinkItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ImageLinkItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["ImageLinkListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["ImageLinkListWithoutItemsCreateInput"]
};
	["ImageLinkListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageLinkListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListEdge"]: AliasType<{
	node?:ResolverInputTypes["ImageLinkList"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListEdge"]: AliasType<{
	node?:ResolverInputTypes["PostAreaList"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["PostAreaListItemCreateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["PostAreaListItemCreateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaListItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaListItemConnectOrCreateListRelationInput"] | undefined | null
};
	["PostAreaListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaListItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["PostAreaListUniqueWhere"],
	create: ResolverInputTypes["PostAreaListWithoutItemsCreateInput"]
};
	["PostAreaListItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["PostAreaListItemUpdateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["PostAreaListItemUpdateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaListItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostAreaListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostAreaListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostAreaListItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostAreaListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostAreaListItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PostAreaListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaListItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["PostAreaListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["PostAreaListWithoutItemsCreateInput"]
};
	["AccordionConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["AccordionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionEdge"]: AliasType<{
	node?:ResolverInputTypes["Accordion"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	list?: ResolverInputTypes["AccordionItemCreateListEntityRelationInput"] | undefined | null,
	descriptionContent?: ResolverInputTypes["AccordionItemCreateDescriptionContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AccordionItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["AccordionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["AccordionWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AccordionItemConnectOrCreateListRelationInput"] | undefined | null
};
	["AccordionWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AccordionItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["AccordionUniqueWhere"],
	create: ResolverInputTypes["AccordionWithoutItemsCreateInput"]
};
	["AccordionItemUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	list?: ResolverInputTypes["AccordionItemUpdateListEntityRelationInput"] | undefined | null,
	descriptionContent?: ResolverInputTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AccordionItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["AccordionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["AccordionWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["AccordionItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["AccordionWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["AccordionItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["AccordionWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["AccordionItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["AccordionWithoutItemsUpdateInput"],
	create: ResolverInputTypes["AccordionWithoutItemsCreateInput"]
};
	["UserConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserEdge"]: AliasType<{
	node?:ResolverInputTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentUpdateInput"]: {
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CurrencyConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CurrencyEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyEdge"]: AliasType<{
	node?:ResolverInputTypes["Currency"],
		__typename?: boolean | `@${string}`
}>;
	["MediumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["MediumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumEdge"]: AliasType<{
	node?:ResolverInputTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["MediumItemCreateListEntityRelationInput"] | undefined | null,
	medium?: ResolverInputTypes["MediumItemCreateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumItemConnectOrCreateListRelationInput"] | undefined | null
};
	["MediumListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["MediumListUniqueWhere"],
	create: ResolverInputTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["MediumItemUpdateListEntityRelationInput"] | undefined | null,
	medium?: ResolverInputTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MediumListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumItemUpsertListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["MediumListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["MediumListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListEdge"]: AliasType<{
	node?:ResolverInputTypes["MediumList"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserPaymentOrderIdEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdEdge"]: AliasType<{
	node?:ResolverInputTypes["UserPaymentOrderId"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	recurrenceCounter?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	taskId?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]> | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"] | undefined | null,
	isFailed?: boolean | undefined | null,
	failedEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserRecurringPaymentItemUpdateInput"]: {
	recurrenceCounter?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	taskId?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]> | undefined | null,
	recurringPayment?: ResolverInputTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"] | undefined | null,
	isFailed?: boolean | undefined | null,
	failedEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	meta?: ResolverInputTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["PostRevisionLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined | null,
	leadContent?: ResolverInputTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined | null,
	publishNotificationText?: string | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostRevisionLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["PostRevisionLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	leadContent?: ResolverInputTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined | null,
	publishNotificationText?: string | undefined | null,
	translatedByAI?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogue"]: AliasType<{
	_meta?:ResolverInputTypes["TranslationCatalogueMeta"],
	id?:boolean | `@${string}`,
domain?: [{	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null},ResolverInputTypes["TranslationDomain"]],
identifier?: [{	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifier"]],
fallback?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
values?: [{	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationValue"]],
valuesByKey?: [{	by: ResolverInputTypes["TranslationCatalogueValuesByKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null},ResolverInputTypes["TranslationValue"]],
paginateValues?: [{	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationValueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	domain?:ResolverInputTypes["FieldMeta"],
	identifier?:ResolverInputTypes["FieldMeta"],
	fallback?:ResolverInputTypes["FieldMeta"],
	values?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomain"]: AliasType<{
	_meta?:ResolverInputTypes["TranslationDomainMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
catalogues?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCatalogueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
keys?: [{	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationKeyOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationKey"]],
cataloguesByIdentifier?: [{	by: ResolverInputTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
cataloguesByValues?: [{	by: ResolverInputTypes["TranslationDomainCataloguesByValuesUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
keysByIdentifier?: [{	by: ResolverInputTypes["TranslationDomainKeysByIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null},ResolverInputTypes["TranslationKey"]],
keysByValues?: [{	by: ResolverInputTypes["TranslationDomainKeysByValuesUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null},ResolverInputTypes["TranslationKey"]],
paginateCatalogues?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCatalogueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationCatalogueConnection"]],
paginateKeys?: [{	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationKeyOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationKeyConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	identifier?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	catalogues?:ResolverInputTypes["FieldMeta"],
	keys?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	domain?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,
	identifier?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,
	values?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null
};
	["TranslationDomainWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	identifier?: ResolverInputTypes["StringCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	catalogues?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,
	keys?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TranslationDomainWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TranslationDomainWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null
};
	["TranslationKeyWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	identifier?: ResolverInputTypes["StringCondition"] | undefined | null,
	contentType?: ResolverInputTypes["TranslationKeyContentTypeCondition"] | undefined | null,
	note?: ResolverInputTypes["StringCondition"] | undefined | null,
	domain?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,
	values?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TranslationKeyWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TranslationKeyWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null
};
	["TranslationKeyContentTypeCondition"]: {
	and?: Array<ResolverInputTypes["TranslationKeyContentTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["TranslationKeyContentTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["TranslationKeyContentTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	notEq?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	in?: Array<ResolverInputTypes["TranslationKeyContentType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["TranslationKeyContentType"]> | undefined | null,
	lt?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	lte?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	gt?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	gte?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null
};
	["TranslationKeyContentType"]:TranslationKeyContentType;
	["TranslationValueWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	value?: ResolverInputTypes["StringCondition"] | undefined | null,
	catalogue?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,
	key?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TranslationValueWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TranslationValueWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TranslationValueWhere"] | undefined | null
};
	["TranslationCataloguesIdentifierWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	code?: ResolverInputTypes["StringCondition"] | undefined | null,
	catalogue?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null
};
	["TranslationCatalogueOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	domain?: ResolverInputTypes["TranslationDomainOrderBy"] | undefined | null,
	identifier?: ResolverInputTypes["TranslationCataloguesIdentifierOrderBy"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueOrderBy"] | undefined | null
};
	["TranslationDomainOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	identifier?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["TranslationCataloguesIdentifierOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	code?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["TranslationKey"]: AliasType<{
	_meta?:ResolverInputTypes["TranslationKeyMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
	contentType?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
domain?: [{	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null},ResolverInputTypes["TranslationDomain"]],
values?: [{	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationValue"]],
valuesByCatalogue?: [{	by: ResolverInputTypes["TranslationKeyValuesByCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null},ResolverInputTypes["TranslationValue"]],
paginateValues?: [{	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationValueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	identifier?:ResolverInputTypes["FieldMeta"],
	contentType?:ResolverInputTypes["FieldMeta"],
	note?:ResolverInputTypes["FieldMeta"],
	domain?:ResolverInputTypes["FieldMeta"],
	values?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValue"]: AliasType<{
	_meta?:ResolverInputTypes["TranslationValueMeta"],
	id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
catalogue?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
key?: [{	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null},ResolverInputTypes["TranslationKey"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	value?:ResolverInputTypes["FieldMeta"],
	catalogue?:ResolverInputTypes["FieldMeta"],
	key?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	value?: ResolverInputTypes["OrderDirection"] | undefined | null,
	catalogue?: ResolverInputTypes["TranslationCatalogueOrderBy"] | undefined | null,
	key?: ResolverInputTypes["TranslationKeyOrderBy"] | undefined | null
};
	["TranslationKeyOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	identifier?: ResolverInputTypes["OrderDirection"] | undefined | null,
	contentType?: ResolverInputTypes["OrderDirection"] | undefined | null,
	note?: ResolverInputTypes["OrderDirection"] | undefined | null,
	domain?: ResolverInputTypes["TranslationDomainOrderBy"] | undefined | null
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
	catalogue?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null
};
	["TranslationCatalogueUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	domain?: ResolverInputTypes["TranslationDomainUniqueWhere"] | undefined | null,
	identifier?: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	values?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationDomainUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	catalogues?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	keys?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null
};
	["TranslationKeyUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	domain?: ResolverInputTypes["TranslationDomainUniqueWhere"] | undefined | null,
	identifier?: string | undefined | null,
	values?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationValueUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	catalogue?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	key?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	catalogue?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null
};
	["TranslationValueConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TranslationValueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueEdge"]: AliasType<{
	node?:ResolverInputTypes["TranslationValue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
	identifier?: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
	values?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
	identifier?: string | undefined | null
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
	values?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationCatalogueConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TranslationCatalogueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueEdge"]: AliasType<{
	node?:ResolverInputTypes["TranslationCatalogue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TranslationKeyEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyEdge"]: AliasType<{
	node?:ResolverInputTypes["TranslationKey"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifier"]: AliasType<{
	_meta?:ResolverInputTypes["TranslationCataloguesIdentifierMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
catalogue?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCatalogueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
catalogueByDomain?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
catalogueByValues?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
paginateCatalogue?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCatalogueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationCatalogueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	code?:ResolverInputTypes["FieldMeta"],
	catalogue?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
	domain?: ResolverInputTypes["TranslationDomainUniqueWhere"] | undefined | null
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
	values?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
	key?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null
};
	["TranslationCatalogueCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	domain?: ResolverInputTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null,
	identifier?: ResolverInputTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ResolverInputTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationDomainUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"] | undefined | null
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	keys?: Array<ResolverInputTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationKeyWithoutDomainCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationDomainConnectOrCreateKeysRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationKeyWithoutDomainCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	contentType?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	note?: string | undefined | null,
	values?: Array<ResolverInputTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationValueWithoutKeyCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationKeyConnectOrCreateValuesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationValueWithoutKeyCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	catalogue?: ResolverInputTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationValueConnectOrCreateCatalogueRelationInput"] | undefined | null
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	domain?: ResolverInputTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null,
	identifier?: ResolverInputTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"] | undefined | null
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueConnectOrCreateIdentifierRelationInput"]: {
	connect: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],
	create: ResolverInputTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationCatalogueCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"] | undefined | null
};
	["TranslationCatalogueConnectOrCreateFallbackRelationInput"]: {
	connect: ResolverInputTypes["TranslationCatalogueUniqueWhere"],
	create: ResolverInputTypes["TranslationCatalogueCreateInput"]
};
	["TranslationValueConnectOrCreateCatalogueRelationInput"]: {
	connect: ResolverInputTypes["TranslationCatalogueUniqueWhere"],
	create: ResolverInputTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationKeyConnectOrCreateValuesRelationInput"]: {
	connect: ResolverInputTypes["TranslationValueUniqueWhere"],
	create: ResolverInputTypes["TranslationValueWithoutKeyCreateInput"]
};
	["TranslationDomainConnectOrCreateKeysRelationInput"]: {
	connect: ResolverInputTypes["TranslationKeyUniqueWhere"],
	create: ResolverInputTypes["TranslationKeyWithoutDomainCreateInput"]
};
	["TranslationCatalogueConnectOrCreateDomainRelationInput"]: {
	connect: ResolverInputTypes["TranslationDomainUniqueWhere"],
	create: ResolverInputTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationCatalogueConnectOrCreateValuesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	key?: ResolverInputTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationKeyWithoutValuesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationValueConnectOrCreateKeyRelationInput"] | undefined | null
};
	["TranslationKeyWithoutValuesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	contentType?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	note?: string | undefined | null,
	domain?: ResolverInputTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationDomainUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationDomainWithoutKeysCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationKeyConnectOrCreateDomainRelationInput"] | undefined | null
};
	["TranslationDomainWithoutKeysCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	catalogues?: Array<ResolverInputTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationDomainConnectOrCreateCataloguesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: ResolverInputTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ResolverInputTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainConnectOrCreateCataloguesRelationInput"]: {
	connect: ResolverInputTypes["TranslationCatalogueUniqueWhere"],
	create: ResolverInputTypes["TranslationCatalogueWithoutDomainCreateInput"]
};
	["TranslationKeyConnectOrCreateDomainRelationInput"]: {
	connect: ResolverInputTypes["TranslationDomainUniqueWhere"],
	create: ResolverInputTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationValueConnectOrCreateKeyRelationInput"]: {
	connect: ResolverInputTypes["TranslationKeyUniqueWhere"],
	create: ResolverInputTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationCatalogueConnectOrCreateValuesRelationInput"]: {
	connect: ResolverInputTypes["TranslationValueUniqueWhere"],
	create: ResolverInputTypes["TranslationValueWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpdateInput"]: {
	domain?: ResolverInputTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null,
	identifier?: ResolverInputTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ResolverInputTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationDomainUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationDomainWithoutCataloguesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationCatalogueUpsertDomainRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	keys?: Array<ResolverInputTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
	create?: ResolverInputTypes["TranslationKeyWithoutDomainCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationDomainUpdateKeysRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationDomainUpsertKeysRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationDomainUpdateKeysRelationInput"]: {
	by: ResolverInputTypes["TranslationKeyUniqueWhere"],
	data: ResolverInputTypes["TranslationKeyWithoutDomainUpdateInput"]
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
	identifier?: string | undefined | null,
	contentType?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	note?: string | undefined | null,
	values?: Array<ResolverInputTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
	create?: ResolverInputTypes["TranslationValueWithoutKeyCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationKeyUpdateValuesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationKeyUpsertValuesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationKeyUpdateValuesRelationInput"]: {
	by: ResolverInputTypes["TranslationValueUniqueWhere"],
	data: ResolverInputTypes["TranslationValueWithoutKeyUpdateInput"]
};
	["TranslationValueWithoutKeyUpdateInput"]: {
	value?: string | undefined | null,
	catalogue?: ResolverInputTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationValueConnectOrCreateCatalogueRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationCatalogueWithoutValuesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationValueUpsertCatalogueRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
	domain?: ResolverInputTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null,
	identifier?: ResolverInputTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationCatalogueUpsertIdentifierRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
	update: ResolverInputTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"],
	create: ResolverInputTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationCatalogueCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationCatalogueUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationCatalogueUpsertFallbackRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
	update: ResolverInputTypes["TranslationCatalogueUpdateInput"],
	create: ResolverInputTypes["TranslationCatalogueCreateInput"]
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
	update: ResolverInputTypes["TranslationCatalogueWithoutValuesUpdateInput"],
	create: ResolverInputTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationKeyUpsertValuesRelationInput"]: {
	by: ResolverInputTypes["TranslationValueUniqueWhere"],
	update: ResolverInputTypes["TranslationValueWithoutKeyUpdateInput"],
	create: ResolverInputTypes["TranslationValueWithoutKeyCreateInput"]
};
	["TranslationDomainUpsertKeysRelationInput"]: {
	by: ResolverInputTypes["TranslationKeyUniqueWhere"],
	update: ResolverInputTypes["TranslationKeyWithoutDomainUpdateInput"],
	create: ResolverInputTypes["TranslationKeyWithoutDomainCreateInput"]
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
	update: ResolverInputTypes["TranslationDomainWithoutCataloguesUpdateInput"],
	create: ResolverInputTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
	create?: ResolverInputTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationCatalogueUpdateValuesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationCatalogueUpsertValuesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TranslationValueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
	by: ResolverInputTypes["TranslationValueUniqueWhere"],
	data: ResolverInputTypes["TranslationValueWithoutCatalogueUpdateInput"]
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
	value?: string | undefined | null,
	key?: ResolverInputTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationKeyUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationKeyWithoutValuesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationValueConnectOrCreateKeyRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationKeyWithoutValuesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationValueUpsertKeyRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
	identifier?: string | undefined | null,
	contentType?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	note?: string | undefined | null,
	domain?: ResolverInputTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationDomainUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationDomainWithoutKeysCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationKeyConnectOrCreateDomainRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationDomainWithoutKeysUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationKeyUpsertDomainRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	catalogues?: Array<ResolverInputTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
	create?: ResolverInputTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationDomainUpdateCataloguesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationDomainUpsertCataloguesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],
	data: ResolverInputTypes["TranslationCatalogueWithoutDomainUpdateInput"]
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
	identifier?: ResolverInputTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ResolverInputTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],
	update: ResolverInputTypes["TranslationCatalogueWithoutDomainUpdateInput"],
	create: ResolverInputTypes["TranslationCatalogueWithoutDomainCreateInput"]
};
	["TranslationKeyUpsertDomainRelationInput"]: {
	update: ResolverInputTypes["TranslationDomainWithoutKeysUpdateInput"],
	create: ResolverInputTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationValueUpsertKeyRelationInput"]: {
	update: ResolverInputTypes["TranslationKeyWithoutValuesUpdateInput"],
	create: ResolverInputTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
	by: ResolverInputTypes["TranslationValueUniqueWhere"],
	update: ResolverInputTypes["TranslationValueWithoutCatalogueUpdateInput"],
	create: ResolverInputTypes["TranslationValueWithoutCatalogueCreateInput"]
};
	["TranslationCataloguesIdentifierConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TranslationCataloguesIdentifierEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierEdge"]: AliasType<{
	node?:ResolverInputTypes["TranslationCataloguesIdentifier"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	catalogue?: Array<ResolverInputTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	domain?: ResolverInputTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ResolverInputTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"]: {
	connect: ResolverInputTypes["TranslationCatalogueUniqueWhere"],
	create: ResolverInputTypes["TranslationCatalogueWithoutIdentifierCreateInput"]
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	catalogue?: Array<ResolverInputTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
	create?: ResolverInputTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],
	data: ResolverInputTypes["TranslationCatalogueWithoutIdentifierUpdateInput"]
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
	domain?: ResolverInputTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null,
	fallback?: ResolverInputTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ResolverInputTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],
	update: ResolverInputTypes["TranslationCatalogueWithoutIdentifierUpdateInput"],
	create: ResolverInputTypes["TranslationCatalogueWithoutIdentifierCreateInput"]
};
	["TranslationDomainConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TranslationDomainEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainEdge"]: AliasType<{
	node?:ResolverInputTypes["TranslationDomain"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	catalogues?: Array<ResolverInputTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined | null,
	keys?: Array<ResolverInputTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainUpdateInput"]: {
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	catalogues?: Array<ResolverInputTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined | null,
	keys?: Array<ResolverInputTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	contentType?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	note?: string | undefined | null,
	domain?: ResolverInputTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined | null,
	values?: Array<ResolverInputTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyUpdateInput"]: {
	identifier?: string | undefined | null,
	contentType?: ResolverInputTypes["TranslationKeyContentType"] | undefined | null,
	note?: string | undefined | null,
	domain?: ResolverInputTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined | null,
	values?: Array<ResolverInputTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	catalogue?: ResolverInputTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined | null,
	key?: ResolverInputTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueUpdateInput"]: {
	value?: string | undefined | null,
	catalogue?: ResolverInputTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined | null,
	key?: ResolverInputTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutGroupLinksLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	settings?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"] | undefined | null,
	linkList?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"] | undefined | null
};
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"]: {
	connect: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]
};
	["GenericPageAboutGroupLinksLocaleUpdateInput"]: {
	order?: number | undefined | null,
	settings?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"] | undefined | null,
	linkList?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"]: {
	root?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"]: {
	update: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"],
	create: ResolverInputTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]
};
	["MemberListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["MemberListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListEdge"]: AliasType<{
	node?:ResolverInputTypes["MemberList"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	position?: string | undefined | null,
	list?: ResolverInputTypes["MemberListItemCreateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["MemberListItemCreateImageEntityRelationInput"] | undefined | null,
	descriptionContent?: ResolverInputTypes["MemberListItemCreateDescriptionContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MemberListItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["MemberListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MemberListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MemberListItemConnectOrCreateListRelationInput"] | undefined | null
};
	["MemberListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MemberListItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["MemberListUniqueWhere"],
	create: ResolverInputTypes["MemberListWithoutItemsCreateInput"]
};
	["MemberListItemUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	position?: string | undefined | null,
	list?: ResolverInputTypes["MemberListItemUpdateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["MemberListItemUpdateImageEntityRelationInput"] | undefined | null,
	descriptionContent?: ResolverInputTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MemberListItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["MemberListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MemberListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MemberListItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MemberListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MemberListItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["MemberListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["MemberListItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["MemberListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["MemberListWithoutItemsCreateInput"]
};
	["FilledTaxFormConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FilledTaxFormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEdge"]: AliasType<{
	node?:ResolverInputTypes["FilledTaxForm"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddress"]: AliasType<{
	_meta?:ResolverInputTypes["FilledTaxFormEmailAddressMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	email?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["FilledTaxFormEmailAddressWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	email?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null
};
	["FilledTaxFormEmailAddressOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	email?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["FilledTaxFormEmailAddressConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FilledTaxFormEmailAddressEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressEdge"]: AliasType<{
	node?:ResolverInputTypes["FilledTaxFormEmailAddress"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	email?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FilledTaxFormEmailAddressUpdateInput"]: {
	order?: number | undefined | null,
	email?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FormConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FormEdge"]: AliasType<{
	node?:ResolverInputTypes["Form"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CsobPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentEdge"]: AliasType<{
	node?:ResolverInputTypes["CsobPayment"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	payId?: string | undefined | null,
	statusChanges?: Array<ResolverInputTypes["CsobPaymentCreateStatusChangesEntityRelationInput"]> | undefined | null,
	payment?: ResolverInputTypes["CsobPaymentCreatePaymentEntityRelationInput"] | undefined | null,
	originalPayId?: string | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentCreatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentWithoutCsobPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CsobPaymentConnectOrCreatePaymentRelationInput"] | undefined | null
};
	["UserPaymentWithoutCsobPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentConnectOrCreatePaymentRelationInput"]: {
	connect: ResolverInputTypes["UserPaymentUniqueWhere"],
	create: ResolverInputTypes["UserPaymentWithoutCsobPaymentCreateInput"]
};
	["CsobPaymentUpdateInput"]: {
	payId?: string | undefined | null,
	statusChanges?: Array<ResolverInputTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"]> | undefined | null,
	payment?: ResolverInputTypes["CsobPaymentUpdatePaymentEntityRelationInput"] | undefined | null,
	originalPayId?: string | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentUpdatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentWithoutCsobPaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CsobPaymentConnectOrCreatePaymentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserPaymentWithoutCsobPaymentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CsobPaymentUpsertPaymentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentWithoutCsobPaymentUpdateInput"]: {
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentUpsertPaymentRelationInput"]: {
	update: ResolverInputTypes["UserPaymentWithoutCsobPaymentUpdateInput"],
	create: ResolverInputTypes["UserPaymentWithoutCsobPaymentCreateInput"]
};
	["CsobPaymentStatusChangeCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	dttm?: string | undefined | null,
	status?: number | undefined | null,
	resultCode?: number | undefined | null,
	message?: string | undefined | null,
	authCode?: string | undefined | null,
	statusDetail?: string | undefined | null,
	actions?: string | undefined | null,
	payment?: ResolverInputTypes["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CsobPaymentWithoutStatusChangesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined | null
};
	["CsobPaymentWithoutStatusChangesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	payId?: string | undefined | null,
	payment?: ResolverInputTypes["CsobPaymentCreatePaymentEntityRelationInput"] | undefined | null,
	originalPayId?: string | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"]: {
	connect: ResolverInputTypes["CsobPaymentUniqueWhere"],
	create: ResolverInputTypes["CsobPaymentWithoutStatusChangesCreateInput"]
};
	["CsobPaymentStatusChangeUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	dttm?: string | undefined | null,
	status?: number | undefined | null,
	resultCode?: number | undefined | null,
	message?: string | undefined | null,
	authCode?: string | undefined | null,
	statusDetail?: string | undefined | null,
	actions?: string | undefined | null,
	payment?: ResolverInputTypes["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["CsobPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CsobPaymentWithoutStatusChangesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CsobPaymentWithoutStatusChangesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CsobPaymentStatusChangeUpsertPaymentRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["CsobPaymentWithoutStatusChangesUpdateInput"]: {
	payId?: string | undefined | null,
	payment?: ResolverInputTypes["CsobPaymentUpdatePaymentEntityRelationInput"] | undefined | null,
	originalPayId?: string | undefined | null,
	metadata?: ResolverInputTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CsobPaymentStatusChangeUpsertPaymentRelationInput"]: {
	update: ResolverInputTypes["CsobPaymentWithoutStatusChangesUpdateInput"],
	create: ResolverInputTypes["CsobPaymentWithoutStatusChangesCreateInput"]
};
	["StripePaymentConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["StripePaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentEdge"]: AliasType<{
	node?:ResolverInputTypes["StripePayment"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	statusChanges?: Array<ResolverInputTypes["StripePaymentCreateStatusChangesEntityRelationInput"]> | undefined | null,
	payment?: ResolverInputTypes["StripePaymentCreatePaymentEntityRelationInput"] | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentCreatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentWithoutStripePaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StripePaymentConnectOrCreatePaymentRelationInput"] | undefined | null
};
	["UserPaymentWithoutStripePaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentConnectOrCreatePaymentRelationInput"]: {
	connect: ResolverInputTypes["UserPaymentUniqueWhere"],
	create: ResolverInputTypes["UserPaymentWithoutStripePaymentCreateInput"]
};
	["StripePaymentUpdateInput"]: {
	identifier?: string | undefined | null,
	statusChanges?: Array<ResolverInputTypes["StripePaymentUpdateStatusChangesEntityRelationInput"]> | undefined | null,
	payment?: ResolverInputTypes["StripePaymentUpdatePaymentEntityRelationInput"] | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentUpdatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentWithoutStripePaymentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StripePaymentConnectOrCreatePaymentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserPaymentWithoutStripePaymentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["StripePaymentUpsertPaymentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserPaymentWithoutStripePaymentUpdateInput"]: {
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null,
	triesCollection?: ResolverInputTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentUpsertPaymentRelationInput"]: {
	update: ResolverInputTypes["UserPaymentWithoutStripePaymentUpdateInput"],
	create: ResolverInputTypes["UserPaymentWithoutStripePaymentCreateInput"]
};
	["StripePaymentStatusChangeCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	payment?: ResolverInputTypes["StripePaymentStatusChangeCreatePaymentEntityRelationInput"] | undefined | null,
	timestamp?: number | undefined | null,
	eventId?: string | undefined | null,
	paymentIntentStatus?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentStatusChangeCreatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StripePaymentWithoutStatusChangesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined | null
};
	["StripePaymentWithoutStatusChangesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	payment?: ResolverInputTypes["StripePaymentCreatePaymentEntityRelationInput"] | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"]: {
	connect: ResolverInputTypes["StripePaymentUniqueWhere"],
	create: ResolverInputTypes["StripePaymentWithoutStatusChangesCreateInput"]
};
	["StripePaymentStatusChangeUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	payment?: ResolverInputTypes["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"] | undefined | null,
	timestamp?: number | undefined | null,
	eventId?: string | undefined | null,
	paymentIntentStatus?: ResolverInputTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["StripePaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StripePaymentWithoutStatusChangesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StripePaymentWithoutStatusChangesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["StripePaymentStatusChangeUpsertPaymentRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["StripePaymentWithoutStatusChangesUpdateInput"]: {
	identifier?: string | undefined | null,
	payment?: ResolverInputTypes["StripePaymentUpdatePaymentEntityRelationInput"] | undefined | null,
	metadata?: ResolverInputTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StripePaymentStatusChangeUpsertPaymentRelationInput"]: {
	update: ResolverInputTypes["StripePaymentWithoutStatusChangesUpdateInput"],
	create: ResolverInputTypes["StripePaymentWithoutStatusChangesCreateInput"]
};
	["RegionPaymentMethodCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	allowRecurringPayments?: boolean | undefined | null,
	region?: ResolverInputTypes["RegionPaymentMethodCreateRegionEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionPaymentMethodCreateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"] | undefined | null
};
	["RegionWithoutEnabledPaymentMethodsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	currency?: ResolverInputTypes["RegionCreateCurrencyEntityRelationInput"] | undefined | null,
	donationItems?: Array<ResolverInputTypes["RegionCreateDonationItemsEntityRelationInput"]> | undefined | null,
	timezone?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionPaymentMethodConnectOrCreateRegionRelationInput"]: {
	connect: ResolverInputTypes["RegionUniqueWhere"],
	create: ResolverInputTypes["RegionWithoutEnabledPaymentMethodsCreateInput"]
};
	["RegionPaymentMethodUpdateInput"]: {
	allowRecurringPayments?: boolean | undefined | null,
	region?: ResolverInputTypes["RegionPaymentMethodUpdateRegionEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["PaymentMethods"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionPaymentMethodUpdateRegionEntityRelationInput"]: {
	connect?: ResolverInputTypes["RegionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RegionPaymentMethodUpsertRegionRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["RegionWithoutEnabledPaymentMethodsUpdateInput"]: {
	order?: number | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	currency?: ResolverInputTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined | null,
	donationItems?: Array<ResolverInputTypes["RegionUpdateDonationItemsEntityRelationInput"]> | undefined | null,
	timezone?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RegionPaymentMethodUpsertRegionRelationInput"]: {
	update: ResolverInputTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"],
	create: ResolverInputTypes["RegionWithoutEnabledPaymentMethodsCreateInput"]
};
	["PostAreaMetaDataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaMetaDataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaMetaDataEdge"]: AliasType<{
	node?:ResolverInputTypes["PostAreaMetaData"],
		__typename?: boolean | `@${string}`
}>;
	["PostMetaDataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostMetaDataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostMetaDataEdge"]: AliasType<{
	node?:ResolverInputTypes["PostMetaData"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMetaDataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostOrganizationMetaDataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationMetaDataEdge"]: AliasType<{
	node?:ResolverInputTypes["PostOrganizationMetaData"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	type?: ResolverInputTypes["TileItemType"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	list?: ResolverInputTypes["TileItemCreateListEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["TileItemCreatePostEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["TileItemCreateAreaEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["TileItemCreateImageEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["TileItemCreateLinkEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["TileItemCreateOrganizationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TileListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateListRelationInput"] | undefined | null
};
	["TileListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	size?: ResolverInputTypes["TileListSize"] | undefined | null,
	title?: string | undefined | null,
	areaType?: ResolverInputTypes["TileListCreateAreaTypeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["TileListUniqueWhere"],
	create: ResolverInputTypes["TileListWithoutItemsCreateInput"]
};
	["TileItemUpdateInput"]: {
	order?: number | undefined | null,
	type?: ResolverInputTypes["TileItemType"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	list?: ResolverInputTypes["TileItemUpdateListEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["TileItemUpdatePostEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["TileItemUpdateAreaEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["TileItemUpdateImageEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["TileItemUpdateLinkEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["TileItemUpdateOrganizationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TileListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TileListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TileListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TileListWithoutItemsUpdateInput"]: {
	size?: ResolverInputTypes["TileListSize"] | undefined | null,
	title?: string | undefined | null,
	areaType?: ResolverInputTypes["TileListUpdateAreaTypeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["TileListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["TileListWithoutItemsCreateInput"]
};
	["TileListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TileListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TileListEdge"]: AliasType<{
	node?:ResolverInputTypes["TileList"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FeedPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageEdge"]: AliasType<{
	node?:ResolverInputTypes["FeedPage"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["FeedPageCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FeedPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	heroTiles?: ResolverInputTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined | null,
	sectionList?: Array<ResolverInputTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined | null,
	cardList?: ResolverInputTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutFeedPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutFeedPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutFeedPagesCreateInput"]
};
	["FeedPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["FeedPageLocaleUniqueWhere"],
	create: ResolverInputTypes["FeedPageLocaleWithoutRootCreateInput"]
};
	["FeedPageUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["FeedPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["FeedPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["FeedPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FeedPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],
	data: ResolverInputTypes["FeedPageLocaleWithoutRootUpdateInput"]
};
	["FeedPageLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	heroTiles?: ResolverInputTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined | null,
	sectionList?: Array<ResolverInputTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined | null,
	cardList?: ResolverInputTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutFeedPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutFeedPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutFeedPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	recurringPaymentPages?: Array<ResolverInputTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutFeedPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutFeedPagesCreateInput"]
};
	["FeedPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],
	update: ResolverInputTypes["FeedPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["FeedPageLocaleWithoutRootCreateInput"]
};
	["FeedPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	heroTiles?: ResolverInputTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined | null,
	sectionList?: Array<ResolverInputTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined | null,
	cardList?: ResolverInputTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageLocaleUpdateInput"]: {
	root?: ResolverInputTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	heroTiles?: ResolverInputTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined | null,
	sectionList?: Array<ResolverInputTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined | null,
	cardList?: ResolverInputTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageSectionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	feedPageLocale?: ResolverInputTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"] | undefined | null,
	tileStripeList?: Array<ResolverInputTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageLocaleWithoutSectionListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"] | undefined | null
};
	["FeedPageLocaleWithoutSectionListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	heroTiles?: ResolverInputTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined | null,
	cardList?: ResolverInputTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"]: {
	connect: ResolverInputTypes["FeedPageLocaleUniqueWhere"],
	create: ResolverInputTypes["FeedPageLocaleWithoutSectionListCreateInput"]
};
	["FeedPageSectionUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	feedPageLocale?: ResolverInputTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"] | undefined | null,
	tileStripeList?: Array<ResolverInputTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageLocaleWithoutSectionListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["FeedPageLocaleWithoutSectionListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageSectionUpsertFeedPageLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["FeedPageLocaleWithoutSectionListUpdateInput"]: {
	root?: ResolverInputTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	heroTiles?: ResolverInputTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined | null,
	cardList?: ResolverInputTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageSectionUpsertFeedPageLocaleRelationInput"]: {
	update: ResolverInputTypes["FeedPageLocaleWithoutSectionListUpdateInput"],
	create: ResolverInputTypes["FeedPageLocaleWithoutSectionListCreateInput"]
};
	["FeedPageTileStripeCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	section?: ResolverInputTypes["FeedPageTileStripeCreateSectionEntityRelationInput"] | undefined | null,
	tileList?: ResolverInputTypes["FeedPageTileStripeCreateTileListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageTileStripeCreateSectionEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"] | undefined | null
};
	["FeedPageSectionWithoutTileStripeListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	feedPageLocale?: ResolverInputTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageTileStripeConnectOrCreateSectionRelationInput"]: {
	connect: ResolverInputTypes["FeedPageSectionUniqueWhere"],
	create: ResolverInputTypes["FeedPageSectionWithoutTileStripeListCreateInput"]
};
	["FeedPageTileStripeUpdateInput"]: {
	order?: number | undefined | null,
	section?: ResolverInputTypes["FeedPageTileStripeUpdateSectionEntityRelationInput"] | undefined | null,
	tileList?: ResolverInputTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageTileStripeUpdateSectionEntityRelationInput"]: {
	connect?: ResolverInputTypes["FeedPageSectionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["FeedPageSectionWithoutTileStripeListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FeedPageTileStripeUpsertSectionRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["FeedPageSectionWithoutTileStripeListUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	feedPageLocale?: ResolverInputTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FeedPageTileStripeUpsertSectionRelationInput"]: {
	update: ResolverInputTypes["FeedPageSectionWithoutTileStripeListUpdateInput"],
	create: ResolverInputTypes["FeedPageSectionWithoutTileStripeListCreateInput"]
};
	["CardItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	list?: ResolverInputTypes["CardItemCreateListEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["CardItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CardItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["CardListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CardListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CardItemConnectOrCreateListRelationInput"] | undefined | null
};
	["CardListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CardItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["CardListUniqueWhere"],
	create: ResolverInputTypes["CardListWithoutItemsCreateInput"]
};
	["CardItemUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	list?: ResolverInputTypes["CardItemUpdateListEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["CardItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CardItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["CardListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CardListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CardItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CardListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CardItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["CardListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["CardItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["CardListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["CardListWithoutItemsCreateInput"]
};
	["CardListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CardListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CardListEdge"]: AliasType<{
	node?:ResolverInputTypes["CardList"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserPaymentTriesCollectionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionEdge"]: AliasType<{
	node?:ResolverInputTypes["UserPaymentTriesCollection"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	orderUrl?: string | undefined | null,
	payment?: Array<ResolverInputTypes["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]> | undefined | null,
	user?: ResolverInputTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"] | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"] | undefined | null,
	recurring?: ResolverInputTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"] | undefined | null,
	metadataLocales?: Array<ResolverInputTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]> | undefined | null,
	medium?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserPaymentWithoutTriesCollectionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UserPaymentWithoutTriesCollectionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentCreateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"]: {
	connect: ResolverInputTypes["UserPaymentUniqueWhere"],
	create: ResolverInputTypes["UserPaymentWithoutTriesCollectionCreateInput"]
};
	["UserPaymentTriesCollectionUpdateInput"]: {
	cents?: number | undefined | null,
	specificSymbol?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	orderUrl?: string | undefined | null,
	payment?: Array<ResolverInputTypes["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]> | undefined | null,
	user?: ResolverInputTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"] | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"] | undefined | null,
	recurring?: ResolverInputTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"] | undefined | null,
	metadataLocales?: Array<ResolverInputTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]> | undefined | null,
	medium?: ResolverInputTypes["PaymentMedium"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]: {
	create?: ResolverInputTypes["UserPaymentWithoutTriesCollectionCreateInput"] | undefined | null,
	update?: ResolverInputTypes["UserPaymentTriesCollectionUpdatePaymentRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["UserPaymentTriesCollectionUpsertPaymentRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["UserPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserPaymentTriesCollectionUpdatePaymentRelationInput"]: {
	by: ResolverInputTypes["UserPaymentUniqueWhere"],
	data: ResolverInputTypes["UserPaymentWithoutTriesCollectionUpdateInput"]
};
	["UserPaymentWithoutTriesCollectionUpdateInput"]: {
	cents?: number | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	specificSymbol?: string | undefined | null,
	currency?: ResolverInputTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	order?: ResolverInputTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	csobPayment?: ResolverInputTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined | null,
	stripePayment?: ResolverInputTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined | null,
	recurringPaymentItem?: ResolverInputTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined | null,
	method?: ResolverInputTypes["UserPaymentMethod"] | undefined | null,
	region?: ResolverInputTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined | null,
	user?: ResolverInputTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined | null,
	isReusable?: boolean | undefined | null,
	onBehalfDonation?: ResolverInputTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined | null,
	successEmailSentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	isSuccessful?: boolean | undefined | null,
	isFinished?: boolean | undefined | null,
	metadata?: ResolverInputTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentTriesCollectionUpsertPaymentRelationInput"]: {
	by: ResolverInputTypes["UserPaymentUniqueWhere"],
	update: ResolverInputTypes["UserPaymentWithoutTriesCollectionUpdateInput"],
	create: ResolverInputTypes["UserPaymentWithoutTriesCollectionCreateInput"]
};
	["RecurringPaymentPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["RecurringPaymentPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageEdge"]: AliasType<{
	node?:ResolverInputTypes["RecurringPaymentPage"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["RecurringPaymentPageCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["RecurringPaymentPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	favouritePosts?: ResolverInputTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutRecurringPaymentPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleCreatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutRecurringPaymentPagesCreateInput"]
};
	["RecurringPaymentPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],
	create: ResolverInputTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"]
};
	["RecurringPaymentPageUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["RecurringPaymentPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["RecurringPaymentPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecurringPaymentPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RecurringPaymentPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],
	data: ResolverInputTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"]
};
	["RecurringPaymentPageLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	favouritePosts?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecurringPaymentPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutRecurringPaymentPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	order?: number | undefined | null,
	generals?: Array<ResolverInputTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	posts?: Array<ResolverInputTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	postAreas?: Array<ResolverInputTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined | null,
	postOrganizations?: Array<ResolverInputTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPageAboutSettings?: Array<ResolverInputTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined | null,
	postRevisions?: Array<ResolverInputTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined | null,
	flagImage?: ResolverInputTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined | null,
	feedPages?: Array<ResolverInputTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined | null,
	givenGiftsPages?: Array<ResolverInputTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined | null,
	receivedGiftsPages?: Array<ResolverInputTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined | null,
	reportPages?: Array<ResolverInputTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined | null,
	reportNavigations?: Array<ResolverInputTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined | null,
	scheduledNotifications?: Array<ResolverInputTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined | null,
	sentPayments?: Array<ResolverInputTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutRecurringPaymentPagesCreateInput"]
};
	["RecurringPaymentPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],
	update: ResolverInputTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"]
};
	["RecurringPaymentPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	favouritePosts?: ResolverInputTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecurringPaymentPageLocaleUpdateInput"]: {
	root?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	favouritePosts?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined | null,
	storyGuideList?: ResolverInputTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["StoryGuideEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideEdge"]: AliasType<{
	node?:ResolverInputTypes["StoryGuide"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["StoryGuideItemCreateListEntityRelationInput"] | undefined | null,
	guide?: ResolverInputTypes["StoryGuideItemCreateGuideEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideItemConnectOrCreateListRelationInput"] | undefined | null
};
	["StoryGuideListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["StoryGuideListUniqueWhere"],
	create: ResolverInputTypes["StoryGuideListWithoutItemsCreateInput"]
};
	["StoryGuideItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["StoryGuideItemUpdateListEntityRelationInput"] | undefined | null,
	guide?: ResolverInputTypes["StoryGuideItemUpdateGuideEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["StoryGuideListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StoryGuideListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StoryGuideItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StoryGuideListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["StoryGuideItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["StoryGuideListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["StoryGuideItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["StoryGuideListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["StoryGuideListWithoutItemsCreateInput"]
};
	["StoryGuideListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["StoryGuideListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListEdge"]: AliasType<{
	node?:ResolverInputTypes["StoryGuideList"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentMetadataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["StripePaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentMetadataEdge"]: AliasType<{
	node?:ResolverInputTypes["StripePaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMetadataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["OnBehalfDonationMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationMetadataEdge"]: AliasType<{
	node?:ResolverInputTypes["OnBehalfDonationMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserPaymentTriesCollectionMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionMetadataEdge"]: AliasType<{
	node?:ResolverInputTypes["UserPaymentTriesCollectionMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentMetadataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CsobPaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentMetadataEdge"]: AliasType<{
	node?:ResolverInputTypes["CsobPaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostOrganizationListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListEdge"]: AliasType<{
	node?:ResolverInputTypes["PostOrganizationList"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["PostOrganizationListItemCreateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["PostOrganizationListItemCreateItemEntityRelationInput"] | undefined | null,
	type?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	link?: ResolverInputTypes["PostOrganizationListItemCreateLinkEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["PostOrganizationListItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationListItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListItemConnectOrCreateListRelationInput"] | undefined | null
};
	["PostOrganizationListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationListItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["PostOrganizationListUniqueWhere"],
	create: ResolverInputTypes["PostOrganizationListWithoutItemsCreateInput"]
};
	["PostOrganizationListItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["PostOrganizationListItemUpdateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["PostOrganizationListItemUpdateItemEntityRelationInput"] | undefined | null,
	type?: ResolverInputTypes["PostOrganizationListItemType"] | undefined | null,
	link?: ResolverInputTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["PostOrganizationListItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationListItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostOrganizationListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostOrganizationListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PostOrganizationListItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostOrganizationListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PostOrganizationListItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PostOrganizationListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["PostOrganizationListItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["PostOrganizationListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["PostOrganizationListWithoutItemsCreateInput"]
};
	["InfoCarousel"]: AliasType<{
	_meta?:ResolverInputTypes["InfoCarouselMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	isEnabled?:boolean | `@${string}`,
	validFrom?:boolean | `@${string}`,
	validTo?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoCarouselItem"]],
seenBy?: [{	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PersonSeenInfoCarousel"]],
itemsByLocales?: [{	by: ResolverInputTypes["InfoCarouselItemsByLocalesUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItem"]],
seenByByUser?: [{	by: ResolverInputTypes["InfoCarouselSeenByByUserUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null},ResolverInputTypes["PersonSeenInfoCarousel"]],
paginateItems?: [{	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoCarouselItemConnection"]],
paginateSeenBy?: [{	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PersonSeenInfoCarouselConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	isEnabled?:ResolverInputTypes["FieldMeta"],
	validFrom?:ResolverInputTypes["FieldMeta"],
	validTo?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
	seenBy?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItem"]: AliasType<{
	_meta?:ResolverInputTypes["InfoCarouselItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
carousel?: [{	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null},ResolverInputTypes["InfoCarousel"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
post?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
	subtitle?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoCarouselItemLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItemLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoCarouselItemLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	carousel?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	post?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	isEnabled?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	validFrom?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	validTo?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	items?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,
	seenBy?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["InfoCarouselWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["InfoCarouselWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null
};
	["InfoCarouselItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	post?: ResolverInputTypes["PostWhere"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	type?: ResolverInputTypes["InfoCarouselItemTypeCondition"] | undefined | null,
	locales?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null
};
	["InfoCarouselItemTypeCondition"]: {
	and?: Array<ResolverInputTypes["InfoCarouselItemTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["InfoCarouselItemTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["InfoCarouselItemTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	notEq?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	in?: Array<ResolverInputTypes["InfoCarouselItemType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["InfoCarouselItemType"]> | undefined | null,
	lt?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	lte?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	gt?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	gte?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null
};
	["InfoCarouselItemType"]:InfoCarouselItemType;
	["InfoCarouselItemLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null
};
	["PersonSeenInfoCarouselWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	seenAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	user?: ResolverInputTypes["UserWhere"] | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null
};
	["InfoCarouselItemLocale"]: AliasType<{
	_meta?:ResolverInputTypes["InfoCarouselItemLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItem"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["InfoCarouselItemOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null
};
	["InfoCarouselItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	post?: ResolverInputTypes["PostOrderBy"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["InfoCarouselOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isEnabled?: ResolverInputTypes["OrderDirection"] | undefined | null,
	validFrom?: ResolverInputTypes["OrderDirection"] | undefined | null,
	validTo?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["InfoCarouselItemLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["InfoCarouselItemLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["InfoCarouselItemLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["InfoCarouselItemLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarousel"]: AliasType<{
	_meta?:ResolverInputTypes["PersonSeenInfoCarouselMeta"],
	id?:boolean | `@${string}`,
	seenAt?:boolean | `@${string}`,
user?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
carousel?: [{	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null},ResolverInputTypes["InfoCarousel"]],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	seenAt?:ResolverInputTypes["FieldMeta"],
	user?:ResolverInputTypes["FieldMeta"],
	carousel?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	seenAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	user?: ResolverInputTypes["UserOrderBy"] | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselOrderBy"] | undefined | null
};
	["InfoCarouselItemsByLocalesUniqueWhere"]: {
	locales?: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null
};
	["InfoCarouselItemLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["InfoCarouselItemUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["InfoCarouselItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null
};
	["InfoCarouselSeenByByUserUniqueWhere"]: {
	user?: ResolverInputTypes["UserUniqueWhere"] | undefined | null
};
	["InfoCarouselItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["InfoCarouselItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemEdge"]: AliasType<{
	node?:ResolverInputTypes["InfoCarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PersonSeenInfoCarouselEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselEdge"]: AliasType<{
	node?:ResolverInputTypes["PersonSeenInfoCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["InfoCarouselItemUniqueWhere"] | undefined | null,
	seenBy?: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null
};
	["PersonSeenInfoCarouselUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	user?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselUniqueWhere"] | undefined | null
};
	["InfoCarouselConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["InfoCarouselEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselEdge"]: AliasType<{
	node?:ResolverInputTypes["InfoCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	isEnabled?: boolean | undefined | null,
	validFrom?: ResolverInputTypes["DateTime"] | undefined | null,
	validTo?: ResolverInputTypes["DateTime"] | undefined | null,
	items?: Array<ResolverInputTypes["InfoCarouselCreateItemsEntityRelationInput"]> | undefined | null,
	seenBy?: Array<ResolverInputTypes["InfoCarouselCreateSeenByEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoCarouselItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoCarouselItemWithoutCarouselCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["InfoCarouselItemWithoutCarouselCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	image?: ResolverInputTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	type?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	locales?: Array<ResolverInputTypes["InfoCarouselItemCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["InfoCarouselItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["InfoCarouselItemCreatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemConnectOrCreatePostRelationInput"] | undefined | null
};
	["InfoCarouselItemConnectOrCreatePostRelationInput"]: {
	connect: ResolverInputTypes["PostUniqueWhere"],
	create: ResolverInputTypes["PostCreateInput"]
};
	["InfoCarouselItemCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["InfoCarouselItemLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	locale?: ResolverInputTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleCreateInput"]
};
	["InfoCarouselItemConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],
	create: ResolverInputTypes["InfoCarouselItemLocaleWithoutRootCreateInput"]
};
	["InfoCarouselConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["InfoCarouselItemUniqueWhere"],
	create: ResolverInputTypes["InfoCarouselItemWithoutCarouselCreateInput"]
};
	["InfoCarouselCreateSeenByEntityRelationInput"]: {
	connect?: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselConnectOrCreateSeenByRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PersonSeenInfoCarouselWithoutCarouselCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	seenAt?: ResolverInputTypes["DateTime"] | undefined | null,
	user?: ResolverInputTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PersonSeenInfoCarouselCreateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"] | undefined | null
};
	["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"]: {
	connect: ResolverInputTypes["UserUniqueWhere"],
	create: ResolverInputTypes["UserCreateInput"]
};
	["InfoCarouselConnectOrCreateSeenByRelationInput"]: {
	connect: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],
	create: ResolverInputTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"]
};
	["InfoCarouselUpdateInput"]: {
	name?: string | undefined | null,
	isEnabled?: boolean | undefined | null,
	validFrom?: ResolverInputTypes["DateTime"] | undefined | null,
	validTo?: ResolverInputTypes["DateTime"] | undefined | null,
	items?: Array<ResolverInputTypes["InfoCarouselUpdateItemsEntityRelationInput"]> | undefined | null,
	seenBy?: Array<ResolverInputTypes["InfoCarouselUpdateSeenByEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["InfoCarouselItemWithoutCarouselCreateInput"] | undefined | null,
	update?: ResolverInputTypes["InfoCarouselUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoCarouselUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["InfoCarouselItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["InfoCarouselItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["InfoCarouselItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["InfoCarouselUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],
	data: ResolverInputTypes["InfoCarouselItemWithoutCarouselUpdateInput"]
};
	["InfoCarouselItemWithoutCarouselUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	image?: ResolverInputTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	type?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	locales?: Array<ResolverInputTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoCarouselItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoCarouselItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["InfoCarouselItemUpdatePostEntityRelationInput"]: {
	connect?: ResolverInputTypes["PostUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["PostCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemConnectOrCreatePostRelationInput"] | undefined | null,
	update?: ResolverInputTypes["PostUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoCarouselItemUpsertPostRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoCarouselItemUpsertPostRelationInput"]: {
	update: ResolverInputTypes["PostUpdateInput"],
	create: ResolverInputTypes["PostCreateInput"]
};
	["InfoCarouselItemUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["InfoCarouselItemUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoCarouselItemUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["InfoCarouselItemUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],
	data: ResolverInputTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"]
};
	["InfoCarouselItemLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	locale?: ResolverInputTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoCarouselItemLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoCarouselItemLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleUpdateInput"],
	create: ResolverInputTypes["LocaleCreateInput"]
};
	["InfoCarouselItemUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],
	update: ResolverInputTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["InfoCarouselItemLocaleWithoutRootCreateInput"]
};
	["InfoCarouselUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],
	update: ResolverInputTypes["InfoCarouselItemWithoutCarouselUpdateInput"],
	create: ResolverInputTypes["InfoCarouselItemWithoutCarouselCreateInput"]
};
	["InfoCarouselUpdateSeenByEntityRelationInput"]: {
	create?: ResolverInputTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | undefined | null,
	update?: ResolverInputTypes["InfoCarouselUpdateSeenByRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoCarouselUpsertSeenByRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["InfoCarouselUpdateSeenByRelationInput"]: {
	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],
	data: ResolverInputTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"]
};
	["PersonSeenInfoCarouselWithoutCarouselUpdateInput"]: {
	seenAt?: ResolverInputTypes["DateTime"] | undefined | null,
	user?: ResolverInputTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PersonSeenInfoCarouselUpdateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PersonSeenInfoCarouselUpsertUserRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PersonSeenInfoCarouselUpsertUserRelationInput"]: {
	update: ResolverInputTypes["UserUpdateInput"],
	create: ResolverInputTypes["UserCreateInput"]
};
	["InfoCarouselUpsertSeenByRelationInput"]: {
	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],
	update: ResolverInputTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"],
	create: ResolverInputTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"]
};
	["InfoCarouselItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselItemCreateCarouselEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	type?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	locales?: Array<ResolverInputTypes["InfoCarouselItemCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemCreateCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoCarouselWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"] | undefined | null
};
	["InfoCarouselWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	isEnabled?: boolean | undefined | null,
	validFrom?: ResolverInputTypes["DateTime"] | undefined | null,
	validTo?: ResolverInputTypes["DateTime"] | undefined | null,
	seenBy?: Array<ResolverInputTypes["InfoCarouselCreateSeenByEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemConnectOrCreateCarouselRelationInput"]: {
	connect: ResolverInputTypes["InfoCarouselUniqueWhere"],
	create: ResolverInputTypes["InfoCarouselWithoutItemsCreateInput"]
};
	["InfoCarouselItemUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	type?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	locales?: Array<ResolverInputTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemUpdateCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoCarouselWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"] | undefined | null,
	update?: ResolverInputTypes["InfoCarouselWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoCarouselItemUpsertCarouselRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoCarouselWithoutItemsUpdateInput"]: {
	name?: string | undefined | null,
	isEnabled?: boolean | undefined | null,
	validFrom?: ResolverInputTypes["DateTime"] | undefined | null,
	validTo?: ResolverInputTypes["DateTime"] | undefined | null,
	seenBy?: Array<ResolverInputTypes["InfoCarouselUpdateSeenByEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemUpsertCarouselRelationInput"]: {
	update: ResolverInputTypes["InfoCarouselWithoutItemsUpdateInput"],
	create: ResolverInputTypes["InfoCarouselWithoutItemsCreateInput"]
};
	["PersonSeenInfoCarouselCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	seenAt?: ResolverInputTypes["DateTime"] | undefined | null,
	user?: ResolverInputTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"] | undefined | null,
	carousel?: ResolverInputTypes["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoCarouselWithoutSeenByCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"] | undefined | null
};
	["InfoCarouselWithoutSeenByCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	isEnabled?: boolean | undefined | null,
	validFrom?: ResolverInputTypes["DateTime"] | undefined | null,
	validTo?: ResolverInputTypes["DateTime"] | undefined | null,
	items?: Array<ResolverInputTypes["InfoCarouselCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"]: {
	connect: ResolverInputTypes["InfoCarouselUniqueWhere"],
	create: ResolverInputTypes["InfoCarouselWithoutSeenByCreateInput"]
};
	["PersonSeenInfoCarouselUpdateInput"]: {
	seenAt?: ResolverInputTypes["DateTime"] | undefined | null,
	user?: ResolverInputTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"] | undefined | null,
	carousel?: ResolverInputTypes["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoCarouselWithoutSeenByCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"] | undefined | null,
	update?: ResolverInputTypes["InfoCarouselWithoutSeenByUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["PersonSeenInfoCarouselUpsertCarouselRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoCarouselWithoutSeenByUpdateInput"]: {
	name?: string | undefined | null,
	isEnabled?: boolean | undefined | null,
	validFrom?: ResolverInputTypes["DateTime"] | undefined | null,
	validTo?: ResolverInputTypes["DateTime"] | undefined | null,
	items?: Array<ResolverInputTypes["InfoCarouselUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PersonSeenInfoCarouselUpsertCarouselRelationInput"]: {
	update: ResolverInputTypes["InfoCarouselWithoutSeenByUpdateInput"],
	create: ResolverInputTypes["InfoCarouselWithoutSeenByCreateInput"]
};
	["GivenGiftsPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GivenGiftsPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageEdge"]: AliasType<{
	node?:ResolverInputTypes["GivenGiftsPage"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["GivenGiftsPageCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GivenGiftsPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GivenGiftsPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	locale?: ResolverInputTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GivenGiftsPageLocaleWithoutRootCreateInput"]
};
	["GivenGiftsPageUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["GivenGiftsPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GivenGiftsPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GivenGiftsPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GivenGiftsPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],
	data: ResolverInputTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"]
};
	["GivenGiftsPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	locale?: ResolverInputTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],
	update: ResolverInputTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["GivenGiftsPageLocaleWithoutRootCreateInput"]
};
	["GivenGiftsPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GivenGiftsPageLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	root?: ResolverInputTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ReceivedGiftsPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageEdge"]: AliasType<{
	node?:ResolverInputTypes["ReceivedGiftsPage"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["ReceivedGiftsPageCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ReceivedGiftsPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	link?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"]
};
	["ReceivedGiftsPageUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ReceivedGiftsPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReceivedGiftsPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ReceivedGiftsPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	data: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"]
};
	["ReceivedGiftsPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	link?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	update: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	link?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReceivedGiftsPageLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	giftText?: string | undefined | null,
	note?: string | undefined | null,
	link?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ReportNavigationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationEdge"]: AliasType<{
	node?:ResolverInputTypes["ReportNavigation"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["ReportNavigationCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportNavigationLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportNavigationConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportNavigationLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	pages?: Array<ResolverInputTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	create: ResolverInputTypes["ReportNavigationLocaleWithoutRootCreateInput"]
};
	["ReportNavigationUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["ReportNavigationUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["ReportNavigationLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ReportNavigationUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportNavigationUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportNavigationUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	data: ResolverInputTypes["ReportNavigationLocaleWithoutRootUpdateInput"]
};
	["ReportNavigationLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	pages?: Array<ResolverInputTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],
	update: ResolverInputTypes["ReportNavigationLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["ReportNavigationLocaleWithoutRootCreateInput"]
};
	["ReportPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ReportPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageEdge"]: AliasType<{
	node?:ResolverInputTypes["ReportPage"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["ReportPageCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ReportPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ReportPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	link?: ResolverInputTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	posts?: Array<ResolverInputTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	create: ResolverInputTypes["ReportPageLocaleWithoutRootCreateInput"]
};
	["ReportPageUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["ReportPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["ReportPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ReportPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ReportPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ReportPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ReportPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	data: ResolverInputTypes["ReportPageLocaleWithoutRootUpdateInput"]
};
	["ReportPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	link?: ResolverInputTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	posts?: Array<ResolverInputTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],
	update: ResolverInputTypes["ReportPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["ReportPageLocaleWithoutRootCreateInput"]
};
	["ReportPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	link?: ResolverInputTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	posts?: Array<ResolverInputTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportPageLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	postTitle?: string | undefined | null,
	giftTitle?: string | undefined | null,
	link?: ResolverInputTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ResolverInputTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	posts?: Array<ResolverInputTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	pages?: Array<ResolverInputTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ReportNavigationLocaleUpdateInput"]: {
	root?: ResolverInputTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	pages?: Array<ResolverInputTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	sendAt?: ResolverInputTypes["DateTime"] | undefined | null,
	currency?: ResolverInputTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	cents?: number | undefined | null,
	sendAt?: ResolverInputTypes["DateTime"] | undefined | null,
	currency?: ResolverInputTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined | null,
	area?: ResolverInputTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined | null,
	organization?: ResolverInputTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PostAreaSentPaymentSumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaSentPaymentSumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSentPaymentSumEdge"]: AliasType<{
	node?:ResolverInputTypes["PostAreaSentPaymentSum"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["NotificationTargetGroupEdge"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupEdge"]: AliasType<{
	node?:ResolverInputTypes["NotificationTargetGroup"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ProcessedNotificationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationEdge"]: AliasType<{
	node?:ResolverInputTypes["ProcessedNotification"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	topic?: string | undefined | null,
	sentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	errorMessage?: string | undefined | null,
	errorCode?: string | undefined | null,
	isSuccess?: boolean | undefined | null,
	source?: ResolverInputTypes["ProcessedNotificationCreateSourceEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	body?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationCreateSourceEntityRelationInput"]: {
	connect?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"] | undefined | null
};
	["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	donationReminderUser?: ResolverInputTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined | null,
	scheduledNotification?: ResolverInputTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationConnectOrCreateSourceRelationInput"]: {
	connect: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],
	create: ResolverInputTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]
};
	["ProcessedNotificationUpdateInput"]: {
	topic?: string | undefined | null,
	sentAt?: ResolverInputTypes["DateTime"] | undefined | null,
	errorMessage?: string | undefined | null,
	errorCode?: string | undefined | null,
	isSuccess?: boolean | undefined | null,
	source?: ResolverInputTypes["ProcessedNotificationUpdateSourceEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	body?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationUpdateSourceEntityRelationInput"]: {
	connect?: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ProcessedNotificationUpsertSourceRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"]: {
	type?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	donationReminderUser?: ResolverInputTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined | null,
	scheduledNotification?: ResolverInputTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationUpsertSourceRelationInput"]: {
	update: ResolverInputTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"],
	create: ResolverInputTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]
};
	["ScheduledNotificationConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ScheduledNotificationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationEdge"]: AliasType<{
	node?:ResolverInputTypes["ScheduledNotification"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	localMsFromMidnight?: number | undefined | null,
	scheduledDate?: ResolverInputTypes["Date"] | undefined | null,
	internalTitle?: string | undefined | null,
	target?: ResolverInputTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["ScheduledNotificationCreateLocalesEntityRelationInput"]> | undefined | null,
	image?: ResolverInputTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined | null,
	completedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationUpdateInput"]: {
	localMsFromMidnight?: number | undefined | null,
	scheduledDate?: ResolverInputTypes["Date"] | undefined | null,
	internalTitle?: string | undefined | null,
	target?: ResolverInputTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"]> | undefined | null,
	image?: ResolverInputTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined | null,
	completedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationSourceCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined | null,
	donationReminderUser?: ResolverInputTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined | null,
	scheduledNotification?: ResolverInputTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProcessedNotificationSourceUpdateInput"]: {
	type?: ResolverInputTypes["ProcessedNotificationSourceType"] | undefined | null,
	processedNotification?: ResolverInputTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined | null,
	donationReminderUser?: ResolverInputTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined | null,
	scheduledNotification?: ResolverInputTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	user?: ResolverInputTypes["DeviceCreateUserEntityRelationInput"] | undefined | null,
	fcmToken?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	ipAddress?: string | undefined | null,
	userAgent?: string | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceCreateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutDevicesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DeviceConnectOrCreateUserRelationInput"] | undefined | null
};
	["UserWithoutDevicesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserCreatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserCreateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserCreateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserCreateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserCreatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceConnectOrCreateUserRelationInput"]: {
	connect: ResolverInputTypes["UserUniqueWhere"],
	create: ResolverInputTypes["UserWithoutDevicesCreateInput"]
};
	["DeviceUpdateInput"]: {
	user?: ResolverInputTypes["DeviceUpdateUserEntityRelationInput"] | undefined | null,
	fcmToken?: string | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	ipAddress?: string | undefined | null,
	userAgent?: string | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceUpdateUserEntityRelationInput"]: {
	connect?: ResolverInputTypes["UserUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["UserWithoutDevicesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["DeviceConnectOrCreateUserRelationInput"] | undefined | null,
	update?: ResolverInputTypes["UserWithoutDevicesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["DeviceUpsertUserRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["UserWithoutDevicesUpdateInput"]: {
	tenantPersonId?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	payments?: Array<ResolverInputTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined | null,
	variableSymbol?: number | undefined | null,
	lastActiveAt?: ResolverInputTypes["DateTime"] | undefined | null,
	region?: ResolverInputTypes["UserUpdateRegionEntityRelationInput"] | undefined | null,
	currency?: ResolverInputTypes["UserUpdateCurrencyEntityRelationInput"] | undefined | null,
	recurringPayments?: Array<ResolverInputTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined | null,
	stripeId?: string | undefined | null,
	isDeactivated?: boolean | undefined | null,
	onBehalfDonations?: Array<ResolverInputTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined | null,
	publicProfileSecret?: string | undefined | null,
	publicProfileCustomNote?: string | undefined | null,
	publicProfileCustomNoteEnabled?: boolean | undefined | null,
	donationConfirmationEmailEnabled?: boolean | undefined | null,
	locale?: ResolverInputTypes["UserUpdateLocaleEntityRelationInput"] | undefined | null,
	signedUp?: boolean | undefined | null,
	processedNotifications?: Array<ResolverInputTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined | null,
	areaStats?: Array<ResolverInputTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined | null,
	organizationStats?: Array<ResolverInputTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined | null,
	postStats?: Array<ResolverInputTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined | null,
	currencyStats?: Array<ResolverInputTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceUpsertUserRelationInput"]: {
	update: ResolverInputTypes["UserWithoutDevicesUpdateInput"],
	create: ResolverInputTypes["UserWithoutDevicesCreateInput"]
};
	["ScheduledNotificationLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	root?: ResolverInputTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ScheduledNotificationLocaleUpdateInput"]: {
	title?: string | undefined | null,
	description?: string | undefined | null,
	root?: ResolverInputTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	root?: ResolverInputTypes["InfoCarouselItemLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoCarouselItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoCarouselItemWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["InfoCarouselItemWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselItemCreateCarouselEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	type?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["InfoCarouselItemUniqueWhere"],
	create: ResolverInputTypes["InfoCarouselItemWithoutLocalesCreateInput"]
};
	["InfoCarouselItemLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	root?: ResolverInputTypes["InfoCarouselItemLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoCarouselItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoCarouselItemWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["InfoCarouselItemWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoCarouselItemLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoCarouselItemWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	carousel?: ResolverInputTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined | null,
	post?: ResolverInputTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	type?: ResolverInputTypes["InfoCarouselItemType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoCarouselItemLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["InfoCarouselItemWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["InfoCarouselItemWithoutLocalesCreateInput"]
};
	["SentPaymentLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	organizationText?: string | undefined | null,
	root?: ResolverInputTypes["SentPaymentLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SentPaymentLocaleUpdateInput"]: {
	organizationText?: string | undefined | null,
	root?: ResolverInputTypes["SentPaymentLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserPaymentMetadataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserPaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentMetadataEdge"]: AliasType<{
	node?:ResolverInputTypes["UserPaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostAreaSumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaSumEdge"]: AliasType<{
	node?:ResolverInputTypes["PostAreaSum"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationSumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostOrganizationSumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationSumEdge"]: AliasType<{
	node?:ResolverInputTypes["PostOrganizationSum"],
		__typename?: boolean | `@${string}`
}>;
	["Stats"]: AliasType<{
	_meta?:ResolverInputTypes["StatsMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
	totalUserCount?:boolean | `@${string}`,
	successfulPaymentCount?:boolean | `@${string}`,
	sentPaymentCount?:boolean | `@${string}`,
	totalAreaCents?:boolean | `@${string}`,
	totalAreaSentPaymentCents?:boolean | `@${string}`,
	totalAreaCzkPercentage?:boolean | `@${string}`,
	totalAreaSentPaymentCzkPercentage?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StatsMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	totalUserCount?:ResolverInputTypes["FieldMeta"],
	successfulPaymentCount?:ResolverInputTypes["FieldMeta"],
	sentPaymentCount?:ResolverInputTypes["FieldMeta"],
	totalAreaCents?:ResolverInputTypes["FieldMeta"],
	totalAreaSentPaymentCents?:ResolverInputTypes["FieldMeta"],
	totalAreaCzkPercentage?:ResolverInputTypes["FieldMeta"],
	totalAreaSentPaymentCzkPercentage?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StatsUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null
};
	["StatsWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	totalUserCount?: ResolverInputTypes["IntCondition"] | undefined | null,
	successfulPaymentCount?: ResolverInputTypes["IntCondition"] | undefined | null,
	sentPaymentCount?: ResolverInputTypes["IntCondition"] | undefined | null,
	totalAreaCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	totalAreaSentPaymentCents?: ResolverInputTypes["IntCondition"] | undefined | null,
	totalAreaCzkPercentage?: ResolverInputTypes["FloatCondition"] | undefined | null,
	totalAreaSentPaymentCzkPercentage?: ResolverInputTypes["FloatCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["StatsWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["StatsWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["StatsWhere"] | undefined | null
};
	["StatsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalUserCount?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successfulPaymentCount?: ResolverInputTypes["OrderDirection"] | undefined | null,
	sentPaymentCount?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalAreaCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalAreaSentPaymentCents?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalAreaCzkPercentage?: ResolverInputTypes["OrderDirection"] | undefined | null,
	totalAreaSentPaymentCzkPercentage?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["StatsConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["StatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEdge"]: AliasType<{
	node?:ResolverInputTypes["Stats"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMetadataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserRecurringPaymentItemMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemMetadataEdge"]: AliasType<{
	node?:ResolverInputTypes["UserRecurringPaymentItemMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["UpcomingUserRecurringPaymentMetadataConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UpcomingUserRecurringPaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UpcomingUserRecurringPaymentMetadataEdge"]: AliasType<{
	node?:ResolverInputTypes["UpcomingUserRecurringPaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["UserStatsConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["UserStatsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserStatsEdge"]: AliasType<{
	node?:ResolverInputTypes["UserStats"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TextImageListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListEdge"]: AliasType<{
	node?:ResolverInputTypes["TextImageList"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["TextImageListItemCreateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["TextImageListItemCreateImageEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	link?: ResolverInputTypes["TextImageListItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextImageListItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextImageListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextImageListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextImageListItemConnectOrCreateListRelationInput"] | undefined | null
};
	["TextImageListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextImageListItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["TextImageListUniqueWhere"],
	create: ResolverInputTypes["TextImageListWithoutItemsCreateInput"]
};
	["TextImageListItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["TextImageListItemUpdateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["TextImageListItemUpdateImageEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	link?: ResolverInputTypes["TextImageListItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextImageListItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextImageListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextImageListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextImageListItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TextImageListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TextImageListItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TextImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["TextImageListItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["TextImageListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["TextImageListWithoutItemsCreateInput"]
};
	["PostSumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostSumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostSumEdge"]: AliasType<{
	node?:ResolverInputTypes["PostSum"],
		__typename?: boolean | `@${string}`
}>;
	["PostFundraisingProgressConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["PostFundraisingProgressEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PostFundraisingProgressEdge"]: AliasType<{
	node?:ResolverInputTypes["PostFundraisingProgress"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["HeroCarouselItemCreateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["HeroCarouselItemCreateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeroCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeroCarouselWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeroCarouselItemConnectOrCreateListRelationInput"] | undefined | null
};
	["HeroCarouselWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	posts?: Array<ResolverInputTypes["HeroCarouselCreatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["HeroCarouselUniqueWhere"],
	create: ResolverInputTypes["HeroCarouselWithoutItemsCreateInput"]
};
	["HeroCarouselItemUpdateInput"]: {
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["HeroCarouselItemUpdateListEntityRelationInput"] | undefined | null,
	item?: ResolverInputTypes["HeroCarouselItemUpdateItemEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeroCarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeroCarouselWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeroCarouselItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["HeroCarouselWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeroCarouselItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["HeroCarouselWithoutItemsUpdateInput"]: {
	createdAt?: ResolverInputTypes["Date"] | undefined | null,
	posts?: Array<ResolverInputTypes["HeroCarouselUpdatePostsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCarouselItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["HeroCarouselWithoutItemsUpdateInput"],
	create: ResolverInputTypes["HeroCarouselWithoutItemsCreateInput"]
};
	["QueryTransaction"]: AliasType<{
	schema?:ResolverInputTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
getGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["General"]],
listGeneral?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["General"]],
paginateGeneral?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralConnection"]],
validateCreateGeneral?: [{	data: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	data: ResolverInputTypes["GeneralUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
listImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Image"]],
paginateImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageConnection"]],
validateCreateImage?: [{	data: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	data: ResolverInputTypes["ImageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPage"]],
listGenericPage?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPage"]],
paginateGenericPage?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	data: ResolverInputTypes["GenericPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
listLinkable?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Linkable"]],
paginateLinkable?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	data: ResolverInputTypes["LinkableUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
listSeo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Seo"]],
paginateSeo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	data: ResolverInputTypes["SeoUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
listContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Content"]],
paginateContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentConnection"]],
validateCreateContent?: [{	data: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	data: ResolverInputTypes["ContentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	data: ResolverInputTypes["ContentBlockUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
listContentReference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	data: ResolverInputTypes["ContentReferenceUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentReferenceLinkableItem?: [{	by: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
listContentReferenceLinkableItem?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
paginateContentReferenceLinkableItem?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItemConnection"]],
getGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
listGeneralLocale?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GeneralLocale"]],
paginateGeneralLocale?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralLocaleConnection"]],
validateCreateGeneralLocale?: [{	data: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	data: ResolverInputTypes["GeneralLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
listGenericPageLocale?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageLocale"]],
paginateGenericPageLocale?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageLocaleConnection"]],
validateCreateGenericPageLocale?: [{	data: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	data: ResolverInputTypes["GenericPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
listLocale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Locale"]],
paginateLocale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	data: ResolverInputTypes["LocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
listVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["VideoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Video"]],
paginateVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["VideoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	data: ResolverInputTypes["VideoUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
listLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Link"]],
paginateLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkConnection"]],
validateCreateLink?: [{	data: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	data: ResolverInputTypes["LinkUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["Post"]],
listPost?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Post"]],
paginatePost?: [{	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostConnection"]],
validateCreatePost?: [{	data: ResolverInputTypes["PostCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	data: ResolverInputTypes["PostUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocale"]],
listPostLocale?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostLocale"]],
paginatePostLocale?: [{	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostLocaleConnection"]],
validateCreatePostLocale?: [{	data: ResolverInputTypes["PostLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	data: ResolverInputTypes["PostLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostArea"]],
listPostArea?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostArea"]],
paginatePostArea?: [{	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaConnection"]],
validateCreatePostArea?: [{	data: ResolverInputTypes["PostAreaCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	data: ResolverInputTypes["PostAreaUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocale"]],
listPostAreaLocale?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaLocale"]],
paginatePostAreaLocale?: [{	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaLocaleConnection"]],
validateCreatePostAreaLocale?: [{	data: ResolverInputTypes["PostAreaLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	data: ResolverInputTypes["PostAreaLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganization"]],
listPostOrganization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganization"]],
paginatePostOrganization?: [{	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationConnection"]],
validateCreatePostOrganization?: [{	data: ResolverInputTypes["PostOrganizationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	data: ResolverInputTypes["PostOrganizationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
listPostOrganizationLocale?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationLocale"]],
paginatePostOrganizationLocale?: [{	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationLocaleConnection"]],
validateCreatePostOrganizationLocale?: [{	data: ResolverInputTypes["PostOrganizationLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	data: ResolverInputTypes["PostOrganizationLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	filter?: ResolverInputTypes["DonationWhere"] | undefined | null},ResolverInputTypes["Donation"]],
listDonation?: [{	filter?: ResolverInputTypes["DonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Donation"]],
paginateDonation?: [{	filter?: ResolverInputTypes["DonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationConnection"]],
validateCreateDonation?: [{	data: ResolverInputTypes["DonationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	data: ResolverInputTypes["DonationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountItem"]],
listDonationAmountItem?: [{	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountItem"]],
paginateDonationAmountItem?: [{	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountItemConnection"]],
validateCreateDonationAmountItem?: [{	data: ResolverInputTypes["DonationAmountItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	data: ResolverInputTypes["DonationAmountItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
listDonationAmountsRegionItem?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionItem"]],
paginateDonationAmountsRegionItem?: [{	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionItemConnection"]],
validateCreateDonationAmountsRegionItem?: [{	data: ResolverInputTypes["DonationAmountsRegionItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	data: ResolverInputTypes["DonationAmountsRegionItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionList"]],
listDonationAmountsRegionList?: [{	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionList"]],
paginateDonationAmountsRegionList?: [{	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DonationAmountsRegionListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DonationAmountsRegionListConnection"]],
validateCreateDonationAmountsRegionList?: [{	data: ResolverInputTypes["DonationAmountsRegionListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	data: ResolverInputTypes["DonationAmountsRegionListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["Region"]],
listRegion?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Region"]],
paginateRegion?: [{	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RegionConnection"]],
validateCreateRegion?: [{	data: ResolverInputTypes["RegionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	data: ResolverInputTypes["RegionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null},ResolverInputTypes["LinkItem"]],
listLinkItem?: [{	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["LinkItem"]],
paginateLinkItem?: [{	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data: ResolverInputTypes["LinkItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	data: ResolverInputTypes["LinkItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null},ResolverInputTypes["LinkList"]],
listLinkList?: [{	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["LinkList"]],
paginateLinkList?: [{	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data: ResolverInputTypes["LinkListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	data: ResolverInputTypes["LinkListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["Header"]],
listHeader?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Header"]],
paginateHeader?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderConnection"]],
validateCreateHeader?: [{	data: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	data: ResolverInputTypes["HeaderUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	data: ResolverInputTypes["HeaderLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["Footer"]],
listFooter?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Footer"]],
paginateFooter?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterConnection"]],
validateCreateFooter?: [{	data: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	data: ResolverInputTypes["FooterUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
listFooterLocale?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	data: ResolverInputTypes["FooterLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	filter?: ResolverInputTypes["PostListWhere"] | undefined | null},ResolverInputTypes["PostList"]],
listPostList?: [{	filter?: ResolverInputTypes["PostListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostList"]],
paginatePostList?: [{	filter?: ResolverInputTypes["PostListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostListConnection"]],
validateCreatePostList?: [{	data: ResolverInputTypes["PostListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	data: ResolverInputTypes["PostListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null},ResolverInputTypes["PostListItem"]],
listPostListItem?: [{	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostListItem"]],
paginatePostListItem?: [{	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostListItemConnection"]],
validateCreatePostListItem?: [{	data: ResolverInputTypes["PostListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	data: ResolverInputTypes["PostListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null},ResolverInputTypes["AppBanner"]],
listAppBanner?: [{	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AppBannerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["AppBanner"]],
paginateAppBanner?: [{	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AppBannerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["AppBannerConnection"]],
validateCreateAppBanner?: [{	data: ResolverInputTypes["AppBannerCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	data: ResolverInputTypes["AppBannerUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettings"]],
listGenericPageAboutSettings?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettings"]],
paginateGenericPageAboutSettings?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsConnection"]],
validateCreateGenericPageAboutSettings?: [{	data: ResolverInputTypes["GenericPageAboutSettingsCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	data: ResolverInputTypes["GenericPageAboutSettingsUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
listGenericPageAboutSettingsLocale?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocale"]],
paginateGenericPageAboutSettingsLocale?: [{	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutSettingsLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocaleConnection"]],
validateCreateGenericPageAboutSettingsLocale?: [{	data: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	data: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	filter?: ResolverInputTypes["ValueWhere"] | undefined | null},ResolverInputTypes["Value"]],
listValue?: [{	filter?: ResolverInputTypes["ValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Value"]],
paginateValue?: [{	filter?: ResolverInputTypes["ValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ValueConnection"]],
validateCreateValue?: [{	data: ResolverInputTypes["ValueCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	data: ResolverInputTypes["ValueUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null},ResolverInputTypes["ValueItem"]],
listValueItem?: [{	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ValueItem"]],
paginateValueItem?: [{	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ValueItemConnection"]],
validateCreateValueItem?: [{	data: ResolverInputTypes["ValueItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	data: ResolverInputTypes["ValueItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null},ResolverInputTypes["ValueList"]],
listValueList?: [{	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ValueList"]],
paginateValueList?: [{	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ValueListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ValueListConnection"]],
validateCreateValueList?: [{	data: ResolverInputTypes["ValueListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	data: ResolverInputTypes["ValueListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null},ResolverInputTypes["ImageLink"]],
listImageLink?: [{	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageLink"]],
paginateImageLink?: [{	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageLinkConnection"]],
validateCreateImageLink?: [{	data: ResolverInputTypes["ImageLinkCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	data: ResolverInputTypes["ImageLinkUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null},ResolverInputTypes["ImageLinkItem"]],
listImageLinkItem?: [{	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageLinkItem"]],
paginateImageLinkItem?: [{	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageLinkItemConnection"]],
validateCreateImageLinkItem?: [{	data: ResolverInputTypes["ImageLinkItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	data: ResolverInputTypes["ImageLinkItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null},ResolverInputTypes["ImageLinkList"]],
listImageLinkList?: [{	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageLinkList"]],
paginateImageLinkList?: [{	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageLinkListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageLinkListConnection"]],
validateCreateImageLinkList?: [{	data: ResolverInputTypes["ImageLinkListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	data: ResolverInputTypes["ImageLinkListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null},ResolverInputTypes["PostAreaList"]],
listPostAreaList?: [{	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaList"]],
paginatePostAreaList?: [{	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaListConnection"]],
validateCreatePostAreaList?: [{	data: ResolverInputTypes["PostAreaListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	data: ResolverInputTypes["PostAreaListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null},ResolverInputTypes["PostAreaListItem"]],
listPostAreaListItem?: [{	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaListItem"]],
paginatePostAreaListItem?: [{	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaListItemConnection"]],
validateCreatePostAreaListItem?: [{	data: ResolverInputTypes["PostAreaListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	data: ResolverInputTypes["PostAreaListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null},ResolverInputTypes["Accordion"]],
listAccordion?: [{	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Accordion"]],
paginateAccordion?: [{	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["AccordionConnection"]],
validateCreateAccordion?: [{	data: ResolverInputTypes["AccordionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	data: ResolverInputTypes["AccordionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null},ResolverInputTypes["AccordionItem"]],
listAccordionItem?: [{	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["AccordionItem"]],
paginateAccordionItem?: [{	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["AccordionItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["AccordionItemConnection"]],
validateCreateAccordionItem?: [{	data: ResolverInputTypes["AccordionItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	data: ResolverInputTypes["AccordionItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["User"]],
listUser?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["User"]],
paginateUser?: [{	filter?: ResolverInputTypes["UserWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserConnection"]],
validateCreateUser?: [{	data: ResolverInputTypes["UserCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	data: ResolverInputTypes["UserUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPayment"]],
listUserPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPayment"]],
paginateUserPayment?: [{	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentConnection"]],
validateCreateUserPayment?: [{	data: ResolverInputTypes["UserPaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	data: ResolverInputTypes["UserPaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["Currency"]],
listCurrency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CurrencyOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Currency"]],
paginateCurrency?: [{	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CurrencyOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CurrencyConnection"]],
validateCreateCurrency?: [{	data: ResolverInputTypes["CurrencyCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	data: ResolverInputTypes["CurrencyUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["Medium"]],
listMedium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Medium"]],
paginateMedium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	data: ResolverInputTypes["MediumUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null},ResolverInputTypes["MediumItem"]],
listMediumItem?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumItem"]],
paginateMediumItem?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	data: ResolverInputTypes["MediumItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
listMediumList?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumList"]],
paginateMediumList?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	data: ResolverInputTypes["MediumListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null},ResolverInputTypes["UserPaymentOrderId"]],
listUserPaymentOrderId?: [{	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderIdOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentOrderId"]],
paginateUserPaymentOrderId?: [{	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentOrderIdOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentOrderIdConnection"]],
validateCreateUserPaymentOrderId?: [{	data: ResolverInputTypes["UserPaymentOrderIdCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	data: ResolverInputTypes["UserPaymentOrderIdUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevision"]],
listPostRevision?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostRevision"]],
paginatePostRevision?: [{	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostRevisionConnection"]],
validateCreatePostRevision?: [{	data: ResolverInputTypes["PostRevisionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	data: ResolverInputTypes["PostRevisionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
listUserRecurringPayment?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserRecurringPayment"]],
paginateUserRecurringPayment?: [{	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentConnection"]],
validateCreateUserRecurringPayment?: [{	data: ResolverInputTypes["UserRecurringPaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	data: ResolverInputTypes["UserRecurringPaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
listUserRecurringPaymentItem?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItem"]],
paginateUserRecurringPaymentItem?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItemConnection"]],
validateCreateUserRecurringPaymentItem?: [{	data: ResolverInputTypes["UserRecurringPaymentItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	data: ResolverInputTypes["UserRecurringPaymentItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
listPostRevisionLocale?: [{	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostRevisionLocale"]],
paginatePostRevisionLocale?: [{	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostRevisionLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostRevisionLocaleConnection"]],
validateCreatePostRevisionLocale?: [{	data: ResolverInputTypes["PostRevisionLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	data: ResolverInputTypes["PostRevisionLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCatalogueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCatalogueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data: ResolverInputTypes["TranslationCatalogueCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	data: ResolverInputTypes["TranslationCatalogueUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data: ResolverInputTypes["TranslationCataloguesIdentifierCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	data: ResolverInputTypes["TranslationCataloguesIdentifierUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null},ResolverInputTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationDomainOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationDomainOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data: ResolverInputTypes["TranslationDomainCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	data: ResolverInputTypes["TranslationDomainUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null},ResolverInputTypes["TranslationKey"]],
listTranslationKey?: [{	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationKeyOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationKeyOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data: ResolverInputTypes["TranslationKeyCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	data: ResolverInputTypes["TranslationKeyUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null},ResolverInputTypes["TranslationValue"]],
listTranslationValue?: [{	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data: ResolverInputTypes["TranslationValueCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	data: ResolverInputTypes["TranslationValueUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocale"]],
listGenericPageAboutGroupLinksLocale?: [{	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocale"]],
paginateGenericPageAboutGroupLinksLocale?: [{	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageAboutGroupLinksLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocaleConnection"]],
validateCreateGenericPageAboutGroupLinksLocale?: [{	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null},ResolverInputTypes["MemberList"]],
listMemberList?: [{	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MemberList"]],
paginateMemberList?: [{	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MemberListConnection"]],
validateCreateMemberList?: [{	data: ResolverInputTypes["MemberListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	data: ResolverInputTypes["MemberListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null},ResolverInputTypes["MemberListItem"]],
listMemberListItem?: [{	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MemberListItem"]],
paginateMemberListItem?: [{	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MemberListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MemberListItemConnection"]],
validateCreateMemberListItem?: [{	data: ResolverInputTypes["MemberListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	data: ResolverInputTypes["MemberListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null},ResolverInputTypes["FilledTaxForm"]],
listFilledTaxForm?: [{	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FilledTaxFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FilledTaxForm"]],
paginateFilledTaxForm?: [{	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FilledTaxFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FilledTaxFormConnection"]],
validateCreateFilledTaxForm?: [{	data: ResolverInputTypes["FilledTaxFormCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	data: ResolverInputTypes["FilledTaxFormUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null},ResolverInputTypes["FilledTaxFormEmailAddress"]],
listFilledTaxFormEmailAddress?: [{	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FilledTaxFormEmailAddressOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FilledTaxFormEmailAddress"]],
paginateFilledTaxFormEmailAddress?: [{	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FilledTaxFormEmailAddressOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FilledTaxFormEmailAddressConnection"]],
validateCreateFilledTaxFormEmailAddress?: [{	data: ResolverInputTypes["FilledTaxFormEmailAddressCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	data: ResolverInputTypes["FilledTaxFormEmailAddressUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	filter?: ResolverInputTypes["FormWhere"] | undefined | null},ResolverInputTypes["Form"]],
listForm?: [{	filter?: ResolverInputTypes["FormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Form"]],
paginateForm?: [{	filter?: ResolverInputTypes["FormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FormConnection"]],
validateCreateForm?: [{	data: ResolverInputTypes["FormCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	data: ResolverInputTypes["FormUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null},ResolverInputTypes["CsobPayment"]],
listCsobPayment?: [{	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CsobPayment"]],
paginateCsobPayment?: [{	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CsobPaymentConnection"]],
validateCreateCsobPayment?: [{	data: ResolverInputTypes["CsobPaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	data: ResolverInputTypes["CsobPaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null},ResolverInputTypes["CsobPaymentStatusChange"]],
listCsobPaymentStatusChange?: [{	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CsobPaymentStatusChange"]],
paginateCsobPaymentStatusChange?: [{	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentStatusChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CsobPaymentStatusChangeConnection"]],
validateCreateCsobPaymentStatusChange?: [{	data: ResolverInputTypes["CsobPaymentStatusChangeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	data: ResolverInputTypes["CsobPaymentStatusChangeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null},ResolverInputTypes["StripePayment"]],
listStripePayment?: [{	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StripePayment"]],
paginateStripePayment?: [{	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StripePaymentConnection"]],
validateCreateStripePayment?: [{	data: ResolverInputTypes["StripePaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	data: ResolverInputTypes["StripePaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null},ResolverInputTypes["StripePaymentStatusChange"]],
listStripePaymentStatusChange?: [{	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StripePaymentStatusChange"]],
paginateStripePaymentStatusChange?: [{	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentStatusChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StripePaymentStatusChangeConnection"]],
validateCreateStripePaymentStatusChange?: [{	data: ResolverInputTypes["StripePaymentStatusChangeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	data: ResolverInputTypes["StripePaymentStatusChangeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null},ResolverInputTypes["RegionPaymentMethod"]],
listRegionPaymentMethod?: [{	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionPaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RegionPaymentMethod"]],
paginateRegionPaymentMethod?: [{	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RegionPaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RegionPaymentMethodConnection"]],
validateCreateRegionPaymentMethod?: [{	data: ResolverInputTypes["RegionPaymentMethodCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	data: ResolverInputTypes["RegionPaymentMethodUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaMetaData?: [{	by: ResolverInputTypes["PostAreaMetaDataUniqueWhere"],	filter?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null},ResolverInputTypes["PostAreaMetaData"]],
listPostAreaMetaData?: [{	filter?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaMetaDataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaMetaData"]],
paginatePostAreaMetaData?: [{	filter?: ResolverInputTypes["PostAreaMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaMetaDataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaMetaDataConnection"]],
getPostMetaData?: [{	by: ResolverInputTypes["PostMetaDataUniqueWhere"],	filter?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null},ResolverInputTypes["PostMetaData"]],
listPostMetaData?: [{	filter?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostMetaDataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostMetaData"]],
paginatePostMetaData?: [{	filter?: ResolverInputTypes["PostMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostMetaDataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostMetaDataConnection"]],
getPostOrganizationMetaData?: [{	by: ResolverInputTypes["PostOrganizationMetaDataUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null},ResolverInputTypes["PostOrganizationMetaData"]],
listPostOrganizationMetaData?: [{	filter?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationMetaDataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationMetaData"]],
paginatePostOrganizationMetaData?: [{	filter?: ResolverInputTypes["PostOrganizationMetaDataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationMetaDataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationMetaDataConnection"]],
getTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null},ResolverInputTypes["TileItem"]],
listTileItem?: [{	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TileItem"]],
paginateTileItem?: [{	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TileItemConnection"]],
validateCreateTileItem?: [{	data: ResolverInputTypes["TileItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	data: ResolverInputTypes["TileItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	filter?: ResolverInputTypes["TileListWhere"] | undefined | null},ResolverInputTypes["TileList"]],
listTileList?: [{	filter?: ResolverInputTypes["TileListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TileList"]],
paginateTileList?: [{	filter?: ResolverInputTypes["TileListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TileListConnection"]],
validateCreateTileList?: [{	data: ResolverInputTypes["TileListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	data: ResolverInputTypes["TileListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null},ResolverInputTypes["FeedPage"]],
listFeedPage?: [{	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPage"]],
paginateFeedPage?: [{	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageConnection"]],
validateCreateFeedPage?: [{	data: ResolverInputTypes["FeedPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	data: ResolverInputTypes["FeedPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocale"]],
listFeedPageLocale?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageLocale"]],
paginateFeedPageLocale?: [{	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageLocaleConnection"]],
validateCreateFeedPageLocale?: [{	data: ResolverInputTypes["FeedPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	data: ResolverInputTypes["FeedPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null},ResolverInputTypes["FeedPageSection"]],
listFeedPageSection?: [{	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageSectionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageSection"]],
paginateFeedPageSection?: [{	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageSectionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageSectionConnection"]],
validateCreateFeedPageSection?: [{	data: ResolverInputTypes["FeedPageSectionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	data: ResolverInputTypes["FeedPageSectionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null},ResolverInputTypes["FeedPageTileStripe"]],
listFeedPageTileStripe?: [{	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageTileStripeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FeedPageTileStripe"]],
paginateFeedPageTileStripe?: [{	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FeedPageTileStripeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FeedPageTileStripeConnection"]],
validateCreateFeedPageTileStripe?: [{	data: ResolverInputTypes["FeedPageTileStripeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	data: ResolverInputTypes["FeedPageTileStripeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null},ResolverInputTypes["CardItem"]],
listCardItem?: [{	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CardItem"]],
paginateCardItem?: [{	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CardItemConnection"]],
validateCreateCardItem?: [{	data: ResolverInputTypes["CardItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	data: ResolverInputTypes["CardItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	filter?: ResolverInputTypes["CardListWhere"] | undefined | null},ResolverInputTypes["CardList"]],
listCardList?: [{	filter?: ResolverInputTypes["CardListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CardList"]],
paginateCardList?: [{	filter?: ResolverInputTypes["CardListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CardListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CardListConnection"]],
validateCreateCardList?: [{	data: ResolverInputTypes["CardListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	data: ResolverInputTypes["CardListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
listOnBehalfDonation?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["OnBehalfDonation"]],
paginateOnBehalfDonation?: [{	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["OnBehalfDonationConnection"]],
validateCreateOnBehalfDonation?: [{	data: ResolverInputTypes["OnBehalfDonationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	data: ResolverInputTypes["OnBehalfDonationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollection"]],
listUserPaymentTriesCollection?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollection"]],
paginateUserPaymentTriesCollection?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionConnection"]],
validateCreateUserPaymentTriesCollection?: [{	data: ResolverInputTypes["UserPaymentTriesCollectionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	data: ResolverInputTypes["UserPaymentTriesCollectionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPage"]],
listRecurringPaymentPage?: [{	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecurringPaymentPage"]],
paginateRecurringPaymentPage?: [{	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageConnection"]],
validateCreateRecurringPaymentPage?: [{	data: ResolverInputTypes["RecurringPaymentPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	data: ResolverInputTypes["RecurringPaymentPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
listRecurringPaymentPageLocale?: [{	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageLocale"]],
paginateRecurringPaymentPageLocale?: [{	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecurringPaymentPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecurringPaymentPageLocaleConnection"]],
validateCreateRecurringPaymentPageLocale?: [{	data: ResolverInputTypes["RecurringPaymentPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	data: ResolverInputTypes["RecurringPaymentPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null},ResolverInputTypes["StoryGuide"]],
listStoryGuide?: [{	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StoryGuide"]],
paginateStoryGuide?: [{	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StoryGuideConnection"]],
validateCreateStoryGuide?: [{	data: ResolverInputTypes["StoryGuideCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	data: ResolverInputTypes["StoryGuideUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null},ResolverInputTypes["StoryGuideItem"]],
listStoryGuideItem?: [{	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StoryGuideItem"]],
paginateStoryGuideItem?: [{	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StoryGuideItemConnection"]],
validateCreateStoryGuideItem?: [{	data: ResolverInputTypes["StoryGuideItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	data: ResolverInputTypes["StoryGuideItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null},ResolverInputTypes["StoryGuideList"]],
listStoryGuideList?: [{	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StoryGuideList"]],
paginateStoryGuideList?: [{	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StoryGuideListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StoryGuideListConnection"]],
validateCreateStoryGuideList?: [{	data: ResolverInputTypes["StoryGuideListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	data: ResolverInputTypes["StoryGuideListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStripePaymentMetadata?: [{	by: ResolverInputTypes["StripePaymentMetadataUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null},ResolverInputTypes["StripePaymentMetadata"]],
listStripePaymentMetadata?: [{	filter?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StripePaymentMetadata"]],
paginateStripePaymentMetadata?: [{	filter?: ResolverInputTypes["StripePaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StripePaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StripePaymentMetadataConnection"]],
getOnBehalfDonationMetadata?: [{	by: ResolverInputTypes["OnBehalfDonationMetadataUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonationMetadata"]],
listOnBehalfDonationMetadata?: [{	filter?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["OnBehalfDonationMetadata"]],
paginateOnBehalfDonationMetadata?: [{	filter?: ResolverInputTypes["OnBehalfDonationMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["OnBehalfDonationMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["OnBehalfDonationMetadataConnection"]],
getUserPaymentTriesCollectionMetadata?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadata"]],
listUserPaymentTriesCollectionMetadata?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadata"]],
paginateUserPaymentTriesCollectionMetadata?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataConnection"]],
getUserPaymentTriesCollectionMetadataLocale?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocale"]],
listUserPaymentTriesCollectionMetadataLocale?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocale"]],
paginateUserPaymentTriesCollectionMetadataLocale?: [{	filter?: ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionMetadataLocaleConnection"]],
getCsobPaymentMetadata?: [{	by: ResolverInputTypes["CsobPaymentMetadataUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["CsobPaymentMetadata"]],
listCsobPaymentMetadata?: [{	filter?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CsobPaymentMetadata"]],
paginateCsobPaymentMetadata?: [{	filter?: ResolverInputTypes["CsobPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CsobPaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CsobPaymentMetadataConnection"]],
getHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null},ResolverInputTypes["HeroCarousel"]],
listHeroCarousel?: [{	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeroCarousel"]],
paginateHeroCarousel?: [{	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeroCarouselConnection"]],
validateCreateHeroCarousel?: [{	data: ResolverInputTypes["HeroCarouselCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	data: ResolverInputTypes["HeroCarouselUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null},ResolverInputTypes["PostOrganizationList"]],
listPostOrganizationList?: [{	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationList"]],
paginatePostOrganizationList?: [{	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationListConnection"]],
validateCreatePostOrganizationList?: [{	data: ResolverInputTypes["PostOrganizationListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	data: ResolverInputTypes["PostOrganizationListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null},ResolverInputTypes["PostOrganizationListItem"]],
listPostOrganizationListItem?: [{	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationListItem"]],
paginatePostOrganizationListItem?: [{	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationListItemConnection"]],
validateCreatePostOrganizationListItem?: [{	data: ResolverInputTypes["PostOrganizationListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	data: ResolverInputTypes["PostOrganizationListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null},ResolverInputTypes["InfoCarousel"]],
listInfoCarousel?: [{	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoCarousel"]],
paginateInfoCarousel?: [{	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoCarouselConnection"]],
validateCreateInfoCarousel?: [{	data: ResolverInputTypes["InfoCarouselCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	data: ResolverInputTypes["InfoCarouselUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItem"]],
listInfoCarouselItem?: [{	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoCarouselItem"]],
paginateInfoCarouselItem?: [{	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoCarouselItemConnection"]],
validateCreateInfoCarouselItem?: [{	data: ResolverInputTypes["InfoCarouselItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	data: ResolverInputTypes["InfoCarouselItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null},ResolverInputTypes["PersonSeenInfoCarousel"]],
listPersonSeenInfoCarousel?: [{	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PersonSeenInfoCarousel"]],
paginatePersonSeenInfoCarousel?: [{	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PersonSeenInfoCarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PersonSeenInfoCarouselConnection"]],
validateCreatePersonSeenInfoCarousel?: [{	data: ResolverInputTypes["PersonSeenInfoCarouselCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdatePersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	data: ResolverInputTypes["PersonSeenInfoCarouselUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPage"]],
listGivenGiftsPage?: [{	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GivenGiftsPage"]],
paginateGivenGiftsPage?: [{	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GivenGiftsPageConnection"]],
validateCreateGivenGiftsPage?: [{	data: ResolverInputTypes["GivenGiftsPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	data: ResolverInputTypes["GivenGiftsPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
listGivenGiftsPageLocale?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GivenGiftsPageLocale"]],
paginateGivenGiftsPageLocale?: [{	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GivenGiftsPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GivenGiftsPageLocaleConnection"]],
validateCreateGivenGiftsPageLocale?: [{	data: ResolverInputTypes["GivenGiftsPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	data: ResolverInputTypes["GivenGiftsPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPage"]],
listReceivedGiftsPage?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPage"]],
paginateReceivedGiftsPage?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageConnection"]],
validateCreateReceivedGiftsPage?: [{	data: ResolverInputTypes["ReceivedGiftsPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	data: ResolverInputTypes["ReceivedGiftsPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
listReceivedGiftsPageLocale?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocale"]],
paginateReceivedGiftsPageLocale?: [{	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReceivedGiftsPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocaleConnection"]],
validateCreateReceivedGiftsPageLocale?: [{	data: ResolverInputTypes["ReceivedGiftsPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	data: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null},ResolverInputTypes["ReportNavigation"]],
listReportNavigation?: [{	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportNavigation"]],
paginateReportNavigation?: [{	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportNavigationConnection"]],
validateCreateReportNavigation?: [{	data: ResolverInputTypes["ReportNavigationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	data: ResolverInputTypes["ReportNavigationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null},ResolverInputTypes["ReportPage"]],
listReportPage?: [{	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportPage"]],
paginateReportPage?: [{	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportPageConnection"]],
validateCreateReportPage?: [{	data: ResolverInputTypes["ReportPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	data: ResolverInputTypes["ReportPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocale"]],
listReportPageLocale?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportPageLocale"]],
paginateReportPageLocale?: [{	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportPageLocaleConnection"]],
validateCreateReportPageLocale?: [{	data: ResolverInputTypes["ReportPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	data: ResolverInputTypes["ReportPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
listReportNavigationLocale?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ReportNavigationLocale"]],
paginateReportNavigationLocale?: [{	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ReportNavigationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ReportNavigationLocaleConnection"]],
validateCreateReportNavigationLocale?: [{	data: ResolverInputTypes["ReportNavigationLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	data: ResolverInputTypes["ReportNavigationLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null},ResolverInputTypes["SentPayment"]],
listSentPayment?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SentPayment"]],
paginateSentPayment?: [{	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SentPaymentConnection"]],
validateCreateSentPayment?: [{	data: ResolverInputTypes["SentPaymentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	data: ResolverInputTypes["SentPaymentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostAreaSentPaymentCurrencySum?: [{	by: ResolverInputTypes["PostAreaSentPaymentCurrencySumUniqueWhere"],	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySum"]],
listPostAreaSentPaymentCurrencySum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySum"]],
paginatePostAreaSentPaymentCurrencySum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentCurrencySumConnection"]],
getPostAreaSentPaymentSum?: [{	by: ResolverInputTypes["PostAreaSentPaymentSumUniqueWhere"],	filter?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null},ResolverInputTypes["PostAreaSentPaymentSum"]],
listPostAreaSentPaymentSum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentSumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentSum"]],
paginatePostAreaSentPaymentSum?: [{	filter?: ResolverInputTypes["PostAreaSentPaymentSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSentPaymentSumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaSentPaymentSumConnection"]],
getNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null},ResolverInputTypes["NotificationTargetGroup"]],
listNotificationTargetGroup?: [{	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["NotificationTargetGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["NotificationTargetGroup"]],
paginateNotificationTargetGroup?: [{	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["NotificationTargetGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["NotificationTargetGroupConnection"]],
validateCreateNotificationTargetGroup?: [{	data: ResolverInputTypes["NotificationTargetGroupCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	data: ResolverInputTypes["NotificationTargetGroupUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null},ResolverInputTypes["ProcessedNotification"]],
listProcessedNotification?: [{	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ProcessedNotification"]],
paginateProcessedNotification?: [{	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ProcessedNotificationConnection"]],
validateCreateProcessedNotification?: [{	data: ResolverInputTypes["ProcessedNotificationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	data: ResolverInputTypes["ProcessedNotificationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null},ResolverInputTypes["ScheduledNotification"]],
listScheduledNotification?: [{	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ScheduledNotification"]],
paginateScheduledNotification?: [{	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ScheduledNotificationConnection"]],
validateCreateScheduledNotification?: [{	data: ResolverInputTypes["ScheduledNotificationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	data: ResolverInputTypes["ScheduledNotificationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
listProcessedNotificationSource?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ProcessedNotificationSource"]],
paginateProcessedNotificationSource?: [{	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ProcessedNotificationSourceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ProcessedNotificationSourceConnection"]],
validateCreateProcessedNotificationSource?: [{	data: ResolverInputTypes["ProcessedNotificationSourceCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	data: ResolverInputTypes["ProcessedNotificationSourceUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null},ResolverInputTypes["Device"]],
listDevice?: [{	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Device"]],
paginateDevice?: [{	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["DeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["DeviceConnection"]],
validateCreateDevice?: [{	data: ResolverInputTypes["DeviceCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	data: ResolverInputTypes["DeviceUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null},ResolverInputTypes["ScheduledNotificationLocale"]],
listScheduledNotificationLocale?: [{	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ScheduledNotificationLocale"]],
paginateScheduledNotificationLocale?: [{	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ScheduledNotificationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ScheduledNotificationLocaleConnection"]],
validateCreateScheduledNotificationLocale?: [{	data: ResolverInputTypes["ScheduledNotificationLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	data: ResolverInputTypes["ScheduledNotificationLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItemLocale"]],
listInfoCarouselItemLocale?: [{	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoCarouselItemLocale"]],
paginateInfoCarouselItemLocale?: [{	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoCarouselItemLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoCarouselItemLocaleConnection"]],
validateCreateInfoCarouselItemLocale?: [{	data: ResolverInputTypes["InfoCarouselItemLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	data: ResolverInputTypes["InfoCarouselItemLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null},ResolverInputTypes["SentPaymentLocale"]],
listSentPaymentLocale?: [{	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SentPaymentLocale"]],
paginateSentPaymentLocale?: [{	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SentPaymentLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SentPaymentLocaleConnection"]],
validateCreateSentPaymentLocale?: [{	data: ResolverInputTypes["SentPaymentLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	data: ResolverInputTypes["SentPaymentLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getUserPaymentMetadata?: [{	by: ResolverInputTypes["UserPaymentMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["UserPaymentMetadata"]],
listUserPaymentMetadata?: [{	filter?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPaymentMetadata"]],
paginateUserPaymentMetadata?: [{	filter?: ResolverInputTypes["UserPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPaymentMetadataConnection"]],
getPostAreaCurrencySum?: [{	by: ResolverInputTypes["PostAreaCurrencySumUniqueWhere"],	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null},ResolverInputTypes["PostAreaCurrencySum"]],
listPostAreaCurrencySum?: [{	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaCurrencySum"]],
paginatePostAreaCurrencySum?: [{	filter?: ResolverInputTypes["PostAreaCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaCurrencySumConnection"]],
getPostAreaSum?: [{	by: ResolverInputTypes["PostAreaSumUniqueWhere"],	filter?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null},ResolverInputTypes["PostAreaSum"]],
listPostAreaSum?: [{	filter?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostAreaSum"]],
paginatePostAreaSum?: [{	filter?: ResolverInputTypes["PostAreaSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostAreaSumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostAreaSumConnection"]],
getPostOrganizationCurrencySum?: [{	by: ResolverInputTypes["PostOrganizationCurrencySumUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null},ResolverInputTypes["PostOrganizationCurrencySum"]],
listPostOrganizationCurrencySum?: [{	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationCurrencySum"]],
paginatePostOrganizationCurrencySum?: [{	filter?: ResolverInputTypes["PostOrganizationCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationCurrencySumConnection"]],
getPostOrganizationSum?: [{	by: ResolverInputTypes["PostOrganizationSumUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null},ResolverInputTypes["PostOrganizationSum"]],
listPostOrganizationSum?: [{	filter?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationSumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostOrganizationSum"]],
paginatePostOrganizationSum?: [{	filter?: ResolverInputTypes["PostOrganizationSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostOrganizationSumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostOrganizationSumConnection"]],
getStats?: [{	by: ResolverInputTypes["StatsUniqueWhere"],	filter?: ResolverInputTypes["StatsWhere"] | undefined | null},ResolverInputTypes["Stats"]],
listStats?: [{	filter?: ResolverInputTypes["StatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Stats"]],
paginateStats?: [{	filter?: ResolverInputTypes["StatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StatsConnection"]],
getUserRecurringPaymentItemMetadata?: [{	by: ResolverInputTypes["UserRecurringPaymentItemMetadataUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItemMetadata"]],
listUserRecurringPaymentItemMetadata?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItemMetadata"]],
paginateUserRecurringPaymentItemMetadata?: [{	filter?: ResolverInputTypes["UserRecurringPaymentItemMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserRecurringPaymentItemMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserRecurringPaymentItemMetadataConnection"]],
getUpcomingUserRecurringPaymentMetadata?: [{	by: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"],	filter?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null},ResolverInputTypes["UpcomingUserRecurringPaymentMetadata"]],
listUpcomingUserRecurringPaymentMetadata?: [{	filter?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UpcomingUserRecurringPaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UpcomingUserRecurringPaymentMetadata"]],
paginateUpcomingUserRecurringPaymentMetadata?: [{	filter?: ResolverInputTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UpcomingUserRecurringPaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UpcomingUserRecurringPaymentMetadataConnection"]],
getUserAreaStats?: [{	by: ResolverInputTypes["UserAreaStatsUniqueWhere"],	filter?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null},ResolverInputTypes["UserAreaStats"]],
listUserAreaStats?: [{	filter?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserAreaStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserAreaStats"]],
paginateUserAreaStats?: [{	filter?: ResolverInputTypes["UserAreaStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserAreaStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserAreaStatsConnection"]],
getUserCurrencyStats?: [{	by: ResolverInputTypes["UserCurrencyStatsUniqueWhere"],	filter?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null},ResolverInputTypes["UserCurrencyStats"]],
listUserCurrencyStats?: [{	filter?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserCurrencyStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserCurrencyStats"]],
paginateUserCurrencyStats?: [{	filter?: ResolverInputTypes["UserCurrencyStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserCurrencyStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserCurrencyStatsConnection"]],
getUserOrganizationStats?: [{	by: ResolverInputTypes["UserOrganizationStatsUniqueWhere"],	filter?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null},ResolverInputTypes["UserOrganizationStats"]],
listUserOrganizationStats?: [{	filter?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrganizationStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserOrganizationStats"]],
paginateUserOrganizationStats?: [{	filter?: ResolverInputTypes["UserOrganizationStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserOrganizationStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserOrganizationStatsConnection"]],
getUserPostStats?: [{	by: ResolverInputTypes["UserPostStatsUniqueWhere"],	filter?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null},ResolverInputTypes["UserPostStats"]],
listUserPostStats?: [{	filter?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPostStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserPostStats"]],
paginateUserPostStats?: [{	filter?: ResolverInputTypes["UserPostStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserPostStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserPostStatsConnection"]],
getUserStats?: [{	by: ResolverInputTypes["UserStatsUniqueWhere"],	filter?: ResolverInputTypes["UserStatsWhere"] | undefined | null},ResolverInputTypes["UserStats"]],
listUserStats?: [{	filter?: ResolverInputTypes["UserStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserStatsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["UserStats"]],
paginateUserStats?: [{	filter?: ResolverInputTypes["UserStatsWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["UserStatsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["UserStatsConnection"]],
getTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null},ResolverInputTypes["TextImageList"]],
listTextImageList?: [{	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextImageList"]],
paginateTextImageList?: [{	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextImageListConnection"]],
validateCreateTextImageList?: [{	data: ResolverInputTypes["TextImageListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	data: ResolverInputTypes["TextImageListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null},ResolverInputTypes["TextImageListItem"]],
listTextImageListItem?: [{	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextImageListItem"]],
paginateTextImageListItem?: [{	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextImageListItemConnection"]],
validateCreateTextImageListItem?: [{	data: ResolverInputTypes["TextImageListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	data: ResolverInputTypes["TextImageListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getPostCurrencySum?: [{	by: ResolverInputTypes["PostCurrencySumUniqueWhere"],	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null},ResolverInputTypes["PostCurrencySum"]],
listPostCurrencySum?: [{	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostCurrencySumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostCurrencySum"]],
paginatePostCurrencySum?: [{	filter?: ResolverInputTypes["PostCurrencySumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostCurrencySumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostCurrencySumConnection"]],
getPostSum?: [{	by: ResolverInputTypes["PostSumUniqueWhere"],	filter?: ResolverInputTypes["PostSumWhere"] | undefined | null},ResolverInputTypes["PostSum"]],
listPostSum?: [{	filter?: ResolverInputTypes["PostSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostSumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostSum"]],
paginatePostSum?: [{	filter?: ResolverInputTypes["PostSumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostSumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostSumConnection"]],
getPostFundraisingProgress?: [{	by: ResolverInputTypes["PostFundraisingProgressUniqueWhere"],	filter?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null},ResolverInputTypes["PostFundraisingProgress"]],
listPostFundraisingProgress?: [{	filter?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostFundraisingProgressOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["PostFundraisingProgress"]],
paginatePostFundraisingProgress?: [{	filter?: ResolverInputTypes["PostFundraisingProgressWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["PostFundraisingProgressOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["PostFundraisingProgressConnection"]],
getHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null},ResolverInputTypes["HeroCarouselItem"]],
listHeroCarouselItem?: [{	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeroCarouselItem"]],
paginateHeroCarouselItem?: [{	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeroCarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeroCarouselItemConnection"]],
validateCreateHeroCarouselItem?: [{	data: ResolverInputTypes["HeroCarouselItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	data: ResolverInputTypes["HeroCarouselItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
		__typename?: boolean | `@${string}`
}>;
	["Info"]: AliasType<{
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
generateUploadUrl?: [{	input?: ResolverInputTypes["S3GenerateSignedUploadInput"] | undefined | null},ResolverInputTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string,	expiration?: number | undefined | null},ResolverInputTypes["S3SignedRead"]],
createGeneral?: [{	data: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["GeneralCreateResult"]],
deleteGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["GeneralDeleteResult"]],
updateGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	data: ResolverInputTypes["GeneralUpdateInput"]},ResolverInputTypes["GeneralUpdateResult"]],
upsertGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	update: ResolverInputTypes["GeneralUpdateInput"],	create: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["GeneralUpsertResult"]],
createImage?: [{	data: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["ImageCreateResult"]],
deleteImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["ImageDeleteResult"]],
updateImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	data: ResolverInputTypes["ImageUpdateInput"]},ResolverInputTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	update: ResolverInputTypes["ImageUpdateInput"],	create: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["ImageUpsertResult"]],
createGenericPage?: [{	data: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageUpdateInput"]},ResolverInputTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageUpdateInput"],	create: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	data: ResolverInputTypes["LinkableUpdateInput"]},ResolverInputTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	update: ResolverInputTypes["LinkableUpdateInput"],	create: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["LinkableUpsertResult"]],
createSeo?: [{	data: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	data: ResolverInputTypes["SeoUpdateInput"]},ResolverInputTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	update: ResolverInputTypes["SeoUpdateInput"],	create: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["SeoUpsertResult"]],
createContent?: [{	data: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["ContentCreateResult"]],
deleteContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["ContentDeleteResult"]],
updateContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	data: ResolverInputTypes["ContentUpdateInput"]},ResolverInputTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	update: ResolverInputTypes["ContentUpdateInput"],	create: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	data: ResolverInputTypes["ContentBlockUpdateInput"]},ResolverInputTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	update: ResolverInputTypes["ContentBlockUpdateInput"],	create: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	data: ResolverInputTypes["ContentReferenceUpdateInput"]},ResolverInputTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	update: ResolverInputTypes["ContentReferenceUpdateInput"],	create: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["ContentReferenceUpsertResult"]],
createGeneralLocale?: [{	data: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["GeneralLocaleCreateResult"]],
deleteGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocaleDeleteResult"]],
updateGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GeneralLocaleUpdateInput"]},ResolverInputTypes["GeneralLocaleUpdateResult"]],
upsertGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GeneralLocaleUpdateInput"],	create: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["GeneralLocaleUpsertResult"]],
createGenericPageLocale?: [{	data: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["GenericPageLocaleCreateResult"]],
deleteGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocaleDeleteResult"]],
updateGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageLocaleUpdateInput"]},ResolverInputTypes["GenericPageLocaleUpdateResult"]],
upsertGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageLocaleUpdateInput"],	create: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["GenericPageLocaleUpsertResult"]],
createLocale?: [{	data: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	data: ResolverInputTypes["LocaleUpdateInput"]},ResolverInputTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	update: ResolverInputTypes["LocaleUpdateInput"],	create: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["LocaleUpsertResult"]],
createVideo?: [{	data: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	data: ResolverInputTypes["VideoUpdateInput"]},ResolverInputTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	update: ResolverInputTypes["VideoUpdateInput"],	create: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["VideoUpsertResult"]],
createLink?: [{	data: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["LinkCreateResult"]],
deleteLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["LinkDeleteResult"]],
updateLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	data: ResolverInputTypes["LinkUpdateInput"]},ResolverInputTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	update: ResolverInputTypes["LinkUpdateInput"],	create: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["LinkUpsertResult"]],
createPost?: [{	data: ResolverInputTypes["PostCreateInput"]},ResolverInputTypes["PostCreateResult"]],
deletePost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["PostDeleteResult"]],
updatePost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	data: ResolverInputTypes["PostUpdateInput"]},ResolverInputTypes["PostUpdateResult"]],
upsertPost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	update: ResolverInputTypes["PostUpdateInput"],	create: ResolverInputTypes["PostCreateInput"]},ResolverInputTypes["PostUpsertResult"]],
createPostLocale?: [{	data: ResolverInputTypes["PostLocaleCreateInput"]},ResolverInputTypes["PostLocaleCreateResult"]],
deletePostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocaleDeleteResult"]],
updatePostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	data: ResolverInputTypes["PostLocaleUpdateInput"]},ResolverInputTypes["PostLocaleUpdateResult"]],
upsertPostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	update: ResolverInputTypes["PostLocaleUpdateInput"],	create: ResolverInputTypes["PostLocaleCreateInput"]},ResolverInputTypes["PostLocaleUpsertResult"]],
createPostArea?: [{	data: ResolverInputTypes["PostAreaCreateInput"]},ResolverInputTypes["PostAreaCreateResult"]],
deletePostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostAreaDeleteResult"]],
updatePostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null,	data: ResolverInputTypes["PostAreaUpdateInput"]},ResolverInputTypes["PostAreaUpdateResult"]],
upsertPostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null,	update: ResolverInputTypes["PostAreaUpdateInput"],	create: ResolverInputTypes["PostAreaCreateInput"]},ResolverInputTypes["PostAreaUpsertResult"]],
createPostAreaLocale?: [{	data: ResolverInputTypes["PostAreaLocaleCreateInput"]},ResolverInputTypes["PostAreaLocaleCreateResult"]],
deletePostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocaleDeleteResult"]],
updatePostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	data: ResolverInputTypes["PostAreaLocaleUpdateInput"]},ResolverInputTypes["PostAreaLocaleUpdateResult"]],
upsertPostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	update: ResolverInputTypes["PostAreaLocaleUpdateInput"],	create: ResolverInputTypes["PostAreaLocaleCreateInput"]},ResolverInputTypes["PostAreaLocaleUpsertResult"]],
createPostOrganization?: [{	data: ResolverInputTypes["PostOrganizationCreateInput"]},ResolverInputTypes["PostOrganizationCreateResult"]],
deletePostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganizationDeleteResult"]],
updatePostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,	data: ResolverInputTypes["PostOrganizationUpdateInput"]},ResolverInputTypes["PostOrganizationUpdateResult"]],
upsertPostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,	update: ResolverInputTypes["PostOrganizationUpdateInput"],	create: ResolverInputTypes["PostOrganizationCreateInput"]},ResolverInputTypes["PostOrganizationUpsertResult"]],
createPostOrganizationLocale?: [{	data: ResolverInputTypes["PostOrganizationLocaleCreateInput"]},ResolverInputTypes["PostOrganizationLocaleCreateResult"]],
deletePostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocaleDeleteResult"]],
updatePostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	data: ResolverInputTypes["PostOrganizationLocaleUpdateInput"]},ResolverInputTypes["PostOrganizationLocaleUpdateResult"]],
upsertPostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	update: ResolverInputTypes["PostOrganizationLocaleUpdateInput"],	create: ResolverInputTypes["PostOrganizationLocaleCreateInput"]},ResolverInputTypes["PostOrganizationLocaleUpsertResult"]],
createDonation?: [{	data: ResolverInputTypes["DonationCreateInput"]},ResolverInputTypes["DonationCreateResult"]],
deleteDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	filter?: ResolverInputTypes["DonationWhere"] | undefined | null},ResolverInputTypes["DonationDeleteResult"]],
updateDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	filter?: ResolverInputTypes["DonationWhere"] | undefined | null,	data: ResolverInputTypes["DonationUpdateInput"]},ResolverInputTypes["DonationUpdateResult"]],
upsertDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	filter?: ResolverInputTypes["DonationWhere"] | undefined | null,	update: ResolverInputTypes["DonationUpdateInput"],	create: ResolverInputTypes["DonationCreateInput"]},ResolverInputTypes["DonationUpsertResult"]],
createDonationAmountItem?: [{	data: ResolverInputTypes["DonationAmountItemCreateInput"]},ResolverInputTypes["DonationAmountItemCreateResult"]],
deleteDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountItemDeleteResult"]],
updateDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	data: ResolverInputTypes["DonationAmountItemUpdateInput"]},ResolverInputTypes["DonationAmountItemUpdateResult"]],
upsertDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	update: ResolverInputTypes["DonationAmountItemUpdateInput"],	create: ResolverInputTypes["DonationAmountItemCreateInput"]},ResolverInputTypes["DonationAmountItemUpsertResult"]],
createDonationAmountsRegionItem?: [{	data: ResolverInputTypes["DonationAmountsRegionItemCreateInput"]},ResolverInputTypes["DonationAmountsRegionItemCreateResult"]],
deleteDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItemDeleteResult"]],
updateDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	data: ResolverInputTypes["DonationAmountsRegionItemUpdateInput"]},ResolverInputTypes["DonationAmountsRegionItemUpdateResult"]],
upsertDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	update: ResolverInputTypes["DonationAmountsRegionItemUpdateInput"],	create: ResolverInputTypes["DonationAmountsRegionItemCreateInput"]},ResolverInputTypes["DonationAmountsRegionItemUpsertResult"]],
createDonationAmountsRegionList?: [{	data: ResolverInputTypes["DonationAmountsRegionListCreateInput"]},ResolverInputTypes["DonationAmountsRegionListCreateResult"]],
deleteDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionListDeleteResult"]],
updateDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,	data: ResolverInputTypes["DonationAmountsRegionListUpdateInput"]},ResolverInputTypes["DonationAmountsRegionListUpdateResult"]],
upsertDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,	update: ResolverInputTypes["DonationAmountsRegionListUpdateInput"],	create: ResolverInputTypes["DonationAmountsRegionListCreateInput"]},ResolverInputTypes["DonationAmountsRegionListUpsertResult"]],
createRegion?: [{	data: ResolverInputTypes["RegionCreateInput"]},ResolverInputTypes["RegionCreateResult"]],
deleteRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["RegionDeleteResult"]],
updateRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	data: ResolverInputTypes["RegionUpdateInput"]},ResolverInputTypes["RegionUpdateResult"]],
upsertRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	update: ResolverInputTypes["RegionUpdateInput"],	create: ResolverInputTypes["RegionCreateInput"]},ResolverInputTypes["RegionUpsertResult"]],
createLinkItem?: [{	data: ResolverInputTypes["LinkItemCreateInput"]},ResolverInputTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null},ResolverInputTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	data: ResolverInputTypes["LinkItemUpdateInput"]},ResolverInputTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	update: ResolverInputTypes["LinkItemUpdateInput"],	create: ResolverInputTypes["LinkItemCreateInput"]},ResolverInputTypes["LinkItemUpsertResult"]],
createLinkList?: [{	data: ResolverInputTypes["LinkListCreateInput"]},ResolverInputTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null},ResolverInputTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null,	data: ResolverInputTypes["LinkListUpdateInput"]},ResolverInputTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null,	update: ResolverInputTypes["LinkListUpdateInput"],	create: ResolverInputTypes["LinkListCreateInput"]},ResolverInputTypes["LinkListUpsertResult"]],
createHeader?: [{	data: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["HeaderCreateResult"]],
deleteHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["HeaderDeleteResult"]],
updateHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	data: ResolverInputTypes["HeaderUpdateInput"]},ResolverInputTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	update: ResolverInputTypes["HeaderUpdateInput"],	create: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["HeaderUpsertResult"]],
createHeaderLocale?: [{	data: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	data: ResolverInputTypes["HeaderLocaleUpdateInput"]},ResolverInputTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	update: ResolverInputTypes["HeaderLocaleUpdateInput"],	create: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["HeaderLocaleUpsertResult"]],
createFooter?: [{	data: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["FooterCreateResult"]],
deleteFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["FooterDeleteResult"]],
updateFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	data: ResolverInputTypes["FooterUpdateInput"]},ResolverInputTypes["FooterUpdateResult"]],
upsertFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	update: ResolverInputTypes["FooterUpdateInput"],	create: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["FooterUpsertResult"]],
createFooterLocale?: [{	data: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	data: ResolverInputTypes["FooterLocaleUpdateInput"]},ResolverInputTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	update: ResolverInputTypes["FooterLocaleUpdateInput"],	create: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["FooterLocaleUpsertResult"]],
createPostList?: [{	data: ResolverInputTypes["PostListCreateInput"]},ResolverInputTypes["PostListCreateResult"]],
deletePostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	filter?: ResolverInputTypes["PostListWhere"] | undefined | null},ResolverInputTypes["PostListDeleteResult"]],
updatePostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	filter?: ResolverInputTypes["PostListWhere"] | undefined | null,	data: ResolverInputTypes["PostListUpdateInput"]},ResolverInputTypes["PostListUpdateResult"]],
upsertPostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	filter?: ResolverInputTypes["PostListWhere"] | undefined | null,	update: ResolverInputTypes["PostListUpdateInput"],	create: ResolverInputTypes["PostListCreateInput"]},ResolverInputTypes["PostListUpsertResult"]],
createPostListItem?: [{	data: ResolverInputTypes["PostListItemCreateInput"]},ResolverInputTypes["PostListItemCreateResult"]],
deletePostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null},ResolverInputTypes["PostListItemDeleteResult"]],
updatePostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	data: ResolverInputTypes["PostListItemUpdateInput"]},ResolverInputTypes["PostListItemUpdateResult"]],
upsertPostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	update: ResolverInputTypes["PostListItemUpdateInput"],	create: ResolverInputTypes["PostListItemCreateInput"]},ResolverInputTypes["PostListItemUpsertResult"]],
createAppBanner?: [{	data: ResolverInputTypes["AppBannerCreateInput"]},ResolverInputTypes["AppBannerCreateResult"]],
deleteAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null},ResolverInputTypes["AppBannerDeleteResult"]],
updateAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null,	data: ResolverInputTypes["AppBannerUpdateInput"]},ResolverInputTypes["AppBannerUpdateResult"]],
upsertAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null,	update: ResolverInputTypes["AppBannerUpdateInput"],	create: ResolverInputTypes["AppBannerCreateInput"]},ResolverInputTypes["AppBannerUpsertResult"]],
createGenericPageAboutSettings?: [{	data: ResolverInputTypes["GenericPageAboutSettingsCreateInput"]},ResolverInputTypes["GenericPageAboutSettingsCreateResult"]],
deleteGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsDeleteResult"]],
updateGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageAboutSettingsUpdateInput"]},ResolverInputTypes["GenericPageAboutSettingsUpdateResult"]],
upsertGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageAboutSettingsUpdateInput"],	create: ResolverInputTypes["GenericPageAboutSettingsCreateInput"]},ResolverInputTypes["GenericPageAboutSettingsUpsertResult"]],
createGenericPageAboutSettingsLocale?: [{	data: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateInput"]},ResolverInputTypes["GenericPageAboutSettingsLocaleCreateResult"]],
deleteGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocaleDeleteResult"]],
updateGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateInput"]},ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateResult"]],
upsertGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateInput"],	create: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateInput"]},ResolverInputTypes["GenericPageAboutSettingsLocaleUpsertResult"]],
createValue?: [{	data: ResolverInputTypes["ValueCreateInput"]},ResolverInputTypes["ValueCreateResult"]],
deleteValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	filter?: ResolverInputTypes["ValueWhere"] | undefined | null},ResolverInputTypes["ValueDeleteResult"]],
updateValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	filter?: ResolverInputTypes["ValueWhere"] | undefined | null,	data: ResolverInputTypes["ValueUpdateInput"]},ResolverInputTypes["ValueUpdateResult"]],
upsertValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	filter?: ResolverInputTypes["ValueWhere"] | undefined | null,	update: ResolverInputTypes["ValueUpdateInput"],	create: ResolverInputTypes["ValueCreateInput"]},ResolverInputTypes["ValueUpsertResult"]],
createValueItem?: [{	data: ResolverInputTypes["ValueItemCreateInput"]},ResolverInputTypes["ValueItemCreateResult"]],
deleteValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null},ResolverInputTypes["ValueItemDeleteResult"]],
updateValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	data: ResolverInputTypes["ValueItemUpdateInput"]},ResolverInputTypes["ValueItemUpdateResult"]],
upsertValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	update: ResolverInputTypes["ValueItemUpdateInput"],	create: ResolverInputTypes["ValueItemCreateInput"]},ResolverInputTypes["ValueItemUpsertResult"]],
createValueList?: [{	data: ResolverInputTypes["ValueListCreateInput"]},ResolverInputTypes["ValueListCreateResult"]],
deleteValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null},ResolverInputTypes["ValueListDeleteResult"]],
updateValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null,	data: ResolverInputTypes["ValueListUpdateInput"]},ResolverInputTypes["ValueListUpdateResult"]],
upsertValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null,	update: ResolverInputTypes["ValueListUpdateInput"],	create: ResolverInputTypes["ValueListCreateInput"]},ResolverInputTypes["ValueListUpsertResult"]],
createImageLink?: [{	data: ResolverInputTypes["ImageLinkCreateInput"]},ResolverInputTypes["ImageLinkCreateResult"]],
deleteImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null},ResolverInputTypes["ImageLinkDeleteResult"]],
updateImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,	data: ResolverInputTypes["ImageLinkUpdateInput"]},ResolverInputTypes["ImageLinkUpdateResult"]],
upsertImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,	update: ResolverInputTypes["ImageLinkUpdateInput"],	create: ResolverInputTypes["ImageLinkCreateInput"]},ResolverInputTypes["ImageLinkUpsertResult"]],
createImageLinkItem?: [{	data: ResolverInputTypes["ImageLinkItemCreateInput"]},ResolverInputTypes["ImageLinkItemCreateResult"]],
deleteImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null},ResolverInputTypes["ImageLinkItemDeleteResult"]],
updateImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	data: ResolverInputTypes["ImageLinkItemUpdateInput"]},ResolverInputTypes["ImageLinkItemUpdateResult"]],
upsertImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	update: ResolverInputTypes["ImageLinkItemUpdateInput"],	create: ResolverInputTypes["ImageLinkItemCreateInput"]},ResolverInputTypes["ImageLinkItemUpsertResult"]],
createImageLinkList?: [{	data: ResolverInputTypes["ImageLinkListCreateInput"]},ResolverInputTypes["ImageLinkListCreateResult"]],
deleteImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null},ResolverInputTypes["ImageLinkListDeleteResult"]],
updateImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,	data: ResolverInputTypes["ImageLinkListUpdateInput"]},ResolverInputTypes["ImageLinkListUpdateResult"]],
upsertImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,	update: ResolverInputTypes["ImageLinkListUpdateInput"],	create: ResolverInputTypes["ImageLinkListCreateInput"]},ResolverInputTypes["ImageLinkListUpsertResult"]],
createPostAreaList?: [{	data: ResolverInputTypes["PostAreaListCreateInput"]},ResolverInputTypes["PostAreaListCreateResult"]],
deletePostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null},ResolverInputTypes["PostAreaListDeleteResult"]],
updatePostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,	data: ResolverInputTypes["PostAreaListUpdateInput"]},ResolverInputTypes["PostAreaListUpdateResult"]],
upsertPostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,	update: ResolverInputTypes["PostAreaListUpdateInput"],	create: ResolverInputTypes["PostAreaListCreateInput"]},ResolverInputTypes["PostAreaListUpsertResult"]],
createPostAreaListItem?: [{	data: ResolverInputTypes["PostAreaListItemCreateInput"]},ResolverInputTypes["PostAreaListItemCreateResult"]],
deletePostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null},ResolverInputTypes["PostAreaListItemDeleteResult"]],
updatePostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	data: ResolverInputTypes["PostAreaListItemUpdateInput"]},ResolverInputTypes["PostAreaListItemUpdateResult"]],
upsertPostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	update: ResolverInputTypes["PostAreaListItemUpdateInput"],	create: ResolverInputTypes["PostAreaListItemCreateInput"]},ResolverInputTypes["PostAreaListItemUpsertResult"]],
createAccordion?: [{	data: ResolverInputTypes["AccordionCreateInput"]},ResolverInputTypes["AccordionCreateResult"]],
deleteAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null},ResolverInputTypes["AccordionDeleteResult"]],
updateAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null,	data: ResolverInputTypes["AccordionUpdateInput"]},ResolverInputTypes["AccordionUpdateResult"]],
upsertAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null,	update: ResolverInputTypes["AccordionUpdateInput"],	create: ResolverInputTypes["AccordionCreateInput"]},ResolverInputTypes["AccordionUpsertResult"]],
createAccordionItem?: [{	data: ResolverInputTypes["AccordionItemCreateInput"]},ResolverInputTypes["AccordionItemCreateResult"]],
deleteAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null},ResolverInputTypes["AccordionItemDeleteResult"]],
updateAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	data: ResolverInputTypes["AccordionItemUpdateInput"]},ResolverInputTypes["AccordionItemUpdateResult"]],
upsertAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	update: ResolverInputTypes["AccordionItemUpdateInput"],	create: ResolverInputTypes["AccordionItemCreateInput"]},ResolverInputTypes["AccordionItemUpsertResult"]],
createUser?: [{	data: ResolverInputTypes["UserCreateInput"]},ResolverInputTypes["UserCreateResult"]],
deleteUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["UserDeleteResult"]],
updateUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	filter?: ResolverInputTypes["UserWhere"] | undefined | null,	data: ResolverInputTypes["UserUpdateInput"]},ResolverInputTypes["UserUpdateResult"]],
upsertUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	filter?: ResolverInputTypes["UserWhere"] | undefined | null,	update: ResolverInputTypes["UserUpdateInput"],	create: ResolverInputTypes["UserCreateInput"]},ResolverInputTypes["UserUpsertResult"]],
createUserPayment?: [{	data: ResolverInputTypes["UserPaymentCreateInput"]},ResolverInputTypes["UserPaymentCreateResult"]],
deleteUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPaymentDeleteResult"]],
updateUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	data: ResolverInputTypes["UserPaymentUpdateInput"]},ResolverInputTypes["UserPaymentUpdateResult"]],
upsertUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	update: ResolverInputTypes["UserPaymentUpdateInput"],	create: ResolverInputTypes["UserPaymentCreateInput"]},ResolverInputTypes["UserPaymentUpsertResult"]],
createCurrency?: [{	data: ResolverInputTypes["CurrencyCreateInput"]},ResolverInputTypes["CurrencyCreateResult"]],
deleteCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["CurrencyDeleteResult"]],
updateCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null,	data: ResolverInputTypes["CurrencyUpdateInput"]},ResolverInputTypes["CurrencyUpdateResult"]],
upsertCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null,	update: ResolverInputTypes["CurrencyUpdateInput"],	create: ResolverInputTypes["CurrencyCreateInput"]},ResolverInputTypes["CurrencyUpsertResult"]],
createMedium?: [{	data: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	data: ResolverInputTypes["MediumUpdateInput"]},ResolverInputTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	update: ResolverInputTypes["MediumUpdateInput"],	create: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["MediumUpsertResult"]],
createMediumItem?: [{	data: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null},ResolverInputTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	data: ResolverInputTypes["MediumItemUpdateInput"]},ResolverInputTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	update: ResolverInputTypes["MediumItemUpdateInput"],	create: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	data: ResolverInputTypes["MediumListUpdateInput"]},ResolverInputTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	update: ResolverInputTypes["MediumListUpdateInput"],	create: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["MediumListUpsertResult"]],
createUserPaymentOrderId?: [{	data: ResolverInputTypes["UserPaymentOrderIdCreateInput"]},ResolverInputTypes["UserPaymentOrderIdCreateResult"]],
deleteUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null},ResolverInputTypes["UserPaymentOrderIdDeleteResult"]],
updateUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,	data: ResolverInputTypes["UserPaymentOrderIdUpdateInput"]},ResolverInputTypes["UserPaymentOrderIdUpdateResult"]],
upsertUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,	update: ResolverInputTypes["UserPaymentOrderIdUpdateInput"],	create: ResolverInputTypes["UserPaymentOrderIdCreateInput"]},ResolverInputTypes["UserPaymentOrderIdUpsertResult"]],
createPostRevision?: [{	data: ResolverInputTypes["PostRevisionCreateInput"]},ResolverInputTypes["PostRevisionCreateResult"]],
deletePostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevisionDeleteResult"]],
updatePostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	data: ResolverInputTypes["PostRevisionUpdateInput"]},ResolverInputTypes["PostRevisionUpdateResult"]],
upsertPostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	update: ResolverInputTypes["PostRevisionUpdateInput"],	create: ResolverInputTypes["PostRevisionCreateInput"]},ResolverInputTypes["PostRevisionUpsertResult"]],
createUserRecurringPayment?: [{	data: ResolverInputTypes["UserRecurringPaymentCreateInput"]},ResolverInputTypes["UserRecurringPaymentCreateResult"]],
deleteUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentDeleteResult"]],
updateUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	data: ResolverInputTypes["UserRecurringPaymentUpdateInput"]},ResolverInputTypes["UserRecurringPaymentUpdateResult"]],
upsertUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	update: ResolverInputTypes["UserRecurringPaymentUpdateInput"],	create: ResolverInputTypes["UserRecurringPaymentCreateInput"]},ResolverInputTypes["UserRecurringPaymentUpsertResult"]],
createUserRecurringPaymentItem?: [{	data: ResolverInputTypes["UserRecurringPaymentItemCreateInput"]},ResolverInputTypes["UserRecurringPaymentItemCreateResult"]],
deleteUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItemDeleteResult"]],
updateUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	data: ResolverInputTypes["UserRecurringPaymentItemUpdateInput"]},ResolverInputTypes["UserRecurringPaymentItemUpdateResult"]],
upsertUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	update: ResolverInputTypes["UserRecurringPaymentItemUpdateInput"],	create: ResolverInputTypes["UserRecurringPaymentItemCreateInput"]},ResolverInputTypes["UserRecurringPaymentItemUpsertResult"]],
createPostRevisionLocale?: [{	data: ResolverInputTypes["PostRevisionLocaleCreateInput"]},ResolverInputTypes["PostRevisionLocaleCreateResult"]],
deletePostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocaleDeleteResult"]],
updatePostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	data: ResolverInputTypes["PostRevisionLocaleUpdateInput"]},ResolverInputTypes["PostRevisionLocaleUpdateResult"]],
upsertPostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	update: ResolverInputTypes["PostRevisionLocaleUpdateInput"],	create: ResolverInputTypes["PostRevisionLocaleCreateInput"]},ResolverInputTypes["PostRevisionLocaleUpsertResult"]],
createTranslationCatalogue?: [{	data: ResolverInputTypes["TranslationCatalogueCreateInput"]},ResolverInputTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	data: ResolverInputTypes["TranslationCatalogueUpdateInput"]},ResolverInputTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	update: ResolverInputTypes["TranslationCatalogueUpdateInput"],	create: ResolverInputTypes["TranslationCatalogueCreateInput"]},ResolverInputTypes["TranslationCatalogueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data: ResolverInputTypes["TranslationCataloguesIdentifierCreateInput"]},ResolverInputTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	data: ResolverInputTypes["TranslationCataloguesIdentifierUpdateInput"]},ResolverInputTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	update: ResolverInputTypes["TranslationCataloguesIdentifierUpdateInput"],	create: ResolverInputTypes["TranslationCataloguesIdentifierCreateInput"]},ResolverInputTypes["TranslationCataloguesIdentifierUpsertResult"]],
createTranslationDomain?: [{	data: ResolverInputTypes["TranslationDomainCreateInput"]},ResolverInputTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null},ResolverInputTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,	data: ResolverInputTypes["TranslationDomainUpdateInput"]},ResolverInputTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,	update: ResolverInputTypes["TranslationDomainUpdateInput"],	create: ResolverInputTypes["TranslationDomainCreateInput"]},ResolverInputTypes["TranslationDomainUpsertResult"]],
createTranslationKey?: [{	data: ResolverInputTypes["TranslationKeyCreateInput"]},ResolverInputTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null},ResolverInputTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	data: ResolverInputTypes["TranslationKeyUpdateInput"]},ResolverInputTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	update: ResolverInputTypes["TranslationKeyUpdateInput"],	create: ResolverInputTypes["TranslationKeyCreateInput"]},ResolverInputTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data: ResolverInputTypes["TranslationValueCreateInput"]},ResolverInputTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null},ResolverInputTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	data: ResolverInputTypes["TranslationValueUpdateInput"]},ResolverInputTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	update: ResolverInputTypes["TranslationValueUpdateInput"],	create: ResolverInputTypes["TranslationValueCreateInput"]},ResolverInputTypes["TranslationValueUpsertResult"]],
createGenericPageAboutGroupLinksLocale?: [{	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateInput"]},ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateResult"]],
deleteGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocaleDeleteResult"]],
updateGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateInput"]},ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateResult"]],
upsertGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateInput"],	create: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateInput"]},ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpsertResult"]],
createMemberList?: [{	data: ResolverInputTypes["MemberListCreateInput"]},ResolverInputTypes["MemberListCreateResult"]],
deleteMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null},ResolverInputTypes["MemberListDeleteResult"]],
updateMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null,	data: ResolverInputTypes["MemberListUpdateInput"]},ResolverInputTypes["MemberListUpdateResult"]],
upsertMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null,	update: ResolverInputTypes["MemberListUpdateInput"],	create: ResolverInputTypes["MemberListCreateInput"]},ResolverInputTypes["MemberListUpsertResult"]],
createMemberListItem?: [{	data: ResolverInputTypes["MemberListItemCreateInput"]},ResolverInputTypes["MemberListItemCreateResult"]],
deleteMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null},ResolverInputTypes["MemberListItemDeleteResult"]],
updateMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	data: ResolverInputTypes["MemberListItemUpdateInput"]},ResolverInputTypes["MemberListItemUpdateResult"]],
upsertMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	update: ResolverInputTypes["MemberListItemUpdateInput"],	create: ResolverInputTypes["MemberListItemCreateInput"]},ResolverInputTypes["MemberListItemUpsertResult"]],
createFilledTaxForm?: [{	data: ResolverInputTypes["FilledTaxFormCreateInput"]},ResolverInputTypes["FilledTaxFormCreateResult"]],
deleteFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null},ResolverInputTypes["FilledTaxFormDeleteResult"]],
updateFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,	data: ResolverInputTypes["FilledTaxFormUpdateInput"]},ResolverInputTypes["FilledTaxFormUpdateResult"]],
upsertFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,	update: ResolverInputTypes["FilledTaxFormUpdateInput"],	create: ResolverInputTypes["FilledTaxFormCreateInput"]},ResolverInputTypes["FilledTaxFormUpsertResult"]],
createFilledTaxFormEmailAddress?: [{	data: ResolverInputTypes["FilledTaxFormEmailAddressCreateInput"]},ResolverInputTypes["FilledTaxFormEmailAddressCreateResult"]],
deleteFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null},ResolverInputTypes["FilledTaxFormEmailAddressDeleteResult"]],
updateFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null,	data: ResolverInputTypes["FilledTaxFormEmailAddressUpdateInput"]},ResolverInputTypes["FilledTaxFormEmailAddressUpdateResult"]],
upsertFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null,	update: ResolverInputTypes["FilledTaxFormEmailAddressUpdateInput"],	create: ResolverInputTypes["FilledTaxFormEmailAddressCreateInput"]},ResolverInputTypes["FilledTaxFormEmailAddressUpsertResult"]],
createForm?: [{	data: ResolverInputTypes["FormCreateInput"]},ResolverInputTypes["FormCreateResult"]],
deleteForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	filter?: ResolverInputTypes["FormWhere"] | undefined | null},ResolverInputTypes["FormDeleteResult"]],
updateForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	filter?: ResolverInputTypes["FormWhere"] | undefined | null,	data: ResolverInputTypes["FormUpdateInput"]},ResolverInputTypes["FormUpdateResult"]],
upsertForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	filter?: ResolverInputTypes["FormWhere"] | undefined | null,	update: ResolverInputTypes["FormUpdateInput"],	create: ResolverInputTypes["FormCreateInput"]},ResolverInputTypes["FormUpsertResult"]],
createCsobPayment?: [{	data: ResolverInputTypes["CsobPaymentCreateInput"]},ResolverInputTypes["CsobPaymentCreateResult"]],
deleteCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null},ResolverInputTypes["CsobPaymentDeleteResult"]],
updateCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,	data: ResolverInputTypes["CsobPaymentUpdateInput"]},ResolverInputTypes["CsobPaymentUpdateResult"]],
upsertCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,	update: ResolverInputTypes["CsobPaymentUpdateInput"],	create: ResolverInputTypes["CsobPaymentCreateInput"]},ResolverInputTypes["CsobPaymentUpsertResult"]],
createCsobPaymentStatusChange?: [{	data: ResolverInputTypes["CsobPaymentStatusChangeCreateInput"]},ResolverInputTypes["CsobPaymentStatusChangeCreateResult"]],
deleteCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null},ResolverInputTypes["CsobPaymentStatusChangeDeleteResult"]],
updateCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	data: ResolverInputTypes["CsobPaymentStatusChangeUpdateInput"]},ResolverInputTypes["CsobPaymentStatusChangeUpdateResult"]],
upsertCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	update: ResolverInputTypes["CsobPaymentStatusChangeUpdateInput"],	create: ResolverInputTypes["CsobPaymentStatusChangeCreateInput"]},ResolverInputTypes["CsobPaymentStatusChangeUpsertResult"]],
createStripePayment?: [{	data: ResolverInputTypes["StripePaymentCreateInput"]},ResolverInputTypes["StripePaymentCreateResult"]],
deleteStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null},ResolverInputTypes["StripePaymentDeleteResult"]],
updateStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,	data: ResolverInputTypes["StripePaymentUpdateInput"]},ResolverInputTypes["StripePaymentUpdateResult"]],
upsertStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,	update: ResolverInputTypes["StripePaymentUpdateInput"],	create: ResolverInputTypes["StripePaymentCreateInput"]},ResolverInputTypes["StripePaymentUpsertResult"]],
createStripePaymentStatusChange?: [{	data: ResolverInputTypes["StripePaymentStatusChangeCreateInput"]},ResolverInputTypes["StripePaymentStatusChangeCreateResult"]],
deleteStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null},ResolverInputTypes["StripePaymentStatusChangeDeleteResult"]],
updateStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	data: ResolverInputTypes["StripePaymentStatusChangeUpdateInput"]},ResolverInputTypes["StripePaymentStatusChangeUpdateResult"]],
upsertStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	update: ResolverInputTypes["StripePaymentStatusChangeUpdateInput"],	create: ResolverInputTypes["StripePaymentStatusChangeCreateInput"]},ResolverInputTypes["StripePaymentStatusChangeUpsertResult"]],
createRegionPaymentMethod?: [{	data: ResolverInputTypes["RegionPaymentMethodCreateInput"]},ResolverInputTypes["RegionPaymentMethodCreateResult"]],
deleteRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null},ResolverInputTypes["RegionPaymentMethodDeleteResult"]],
updateRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	data: ResolverInputTypes["RegionPaymentMethodUpdateInput"]},ResolverInputTypes["RegionPaymentMethodUpdateResult"]],
upsertRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	update: ResolverInputTypes["RegionPaymentMethodUpdateInput"],	create: ResolverInputTypes["RegionPaymentMethodCreateInput"]},ResolverInputTypes["RegionPaymentMethodUpsertResult"]],
createTileItem?: [{	data: ResolverInputTypes["TileItemCreateInput"]},ResolverInputTypes["TileItemCreateResult"]],
deleteTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null},ResolverInputTypes["TileItemDeleteResult"]],
updateTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	data: ResolverInputTypes["TileItemUpdateInput"]},ResolverInputTypes["TileItemUpdateResult"]],
upsertTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	update: ResolverInputTypes["TileItemUpdateInput"],	create: ResolverInputTypes["TileItemCreateInput"]},ResolverInputTypes["TileItemUpsertResult"]],
createTileList?: [{	data: ResolverInputTypes["TileListCreateInput"]},ResolverInputTypes["TileListCreateResult"]],
deleteTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	filter?: ResolverInputTypes["TileListWhere"] | undefined | null},ResolverInputTypes["TileListDeleteResult"]],
updateTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	filter?: ResolverInputTypes["TileListWhere"] | undefined | null,	data: ResolverInputTypes["TileListUpdateInput"]},ResolverInputTypes["TileListUpdateResult"]],
upsertTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	filter?: ResolverInputTypes["TileListWhere"] | undefined | null,	update: ResolverInputTypes["TileListUpdateInput"],	create: ResolverInputTypes["TileListCreateInput"]},ResolverInputTypes["TileListUpsertResult"]],
createFeedPage?: [{	data: ResolverInputTypes["FeedPageCreateInput"]},ResolverInputTypes["FeedPageCreateResult"]],
deleteFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null},ResolverInputTypes["FeedPageDeleteResult"]],
updateFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null,	data: ResolverInputTypes["FeedPageUpdateInput"]},ResolverInputTypes["FeedPageUpdateResult"]],
upsertFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null,	update: ResolverInputTypes["FeedPageUpdateInput"],	create: ResolverInputTypes["FeedPageCreateInput"]},ResolverInputTypes["FeedPageUpsertResult"]],
createFeedPageLocale?: [{	data: ResolverInputTypes["FeedPageLocaleCreateInput"]},ResolverInputTypes["FeedPageLocaleCreateResult"]],
deleteFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocaleDeleteResult"]],
updateFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["FeedPageLocaleUpdateInput"]},ResolverInputTypes["FeedPageLocaleUpdateResult"]],
upsertFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["FeedPageLocaleUpdateInput"],	create: ResolverInputTypes["FeedPageLocaleCreateInput"]},ResolverInputTypes["FeedPageLocaleUpsertResult"]],
createFeedPageSection?: [{	data: ResolverInputTypes["FeedPageSectionCreateInput"]},ResolverInputTypes["FeedPageSectionCreateResult"]],
deleteFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null},ResolverInputTypes["FeedPageSectionDeleteResult"]],
updateFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	data: ResolverInputTypes["FeedPageSectionUpdateInput"]},ResolverInputTypes["FeedPageSectionUpdateResult"]],
upsertFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	update: ResolverInputTypes["FeedPageSectionUpdateInput"],	create: ResolverInputTypes["FeedPageSectionCreateInput"]},ResolverInputTypes["FeedPageSectionUpsertResult"]],
createFeedPageTileStripe?: [{	data: ResolverInputTypes["FeedPageTileStripeCreateInput"]},ResolverInputTypes["FeedPageTileStripeCreateResult"]],
deleteFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null},ResolverInputTypes["FeedPageTileStripeDeleteResult"]],
updateFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	data: ResolverInputTypes["FeedPageTileStripeUpdateInput"]},ResolverInputTypes["FeedPageTileStripeUpdateResult"]],
upsertFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	update: ResolverInputTypes["FeedPageTileStripeUpdateInput"],	create: ResolverInputTypes["FeedPageTileStripeCreateInput"]},ResolverInputTypes["FeedPageTileStripeUpsertResult"]],
createCardItem?: [{	data: ResolverInputTypes["CardItemCreateInput"]},ResolverInputTypes["CardItemCreateResult"]],
deleteCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null},ResolverInputTypes["CardItemDeleteResult"]],
updateCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	data: ResolverInputTypes["CardItemUpdateInput"]},ResolverInputTypes["CardItemUpdateResult"]],
upsertCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	update: ResolverInputTypes["CardItemUpdateInput"],	create: ResolverInputTypes["CardItemCreateInput"]},ResolverInputTypes["CardItemUpsertResult"]],
createCardList?: [{	data: ResolverInputTypes["CardListCreateInput"]},ResolverInputTypes["CardListCreateResult"]],
deleteCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	filter?: ResolverInputTypes["CardListWhere"] | undefined | null},ResolverInputTypes["CardListDeleteResult"]],
updateCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	filter?: ResolverInputTypes["CardListWhere"] | undefined | null,	data: ResolverInputTypes["CardListUpdateInput"]},ResolverInputTypes["CardListUpdateResult"]],
upsertCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	filter?: ResolverInputTypes["CardListWhere"] | undefined | null,	update: ResolverInputTypes["CardListUpdateInput"],	create: ResolverInputTypes["CardListCreateInput"]},ResolverInputTypes["CardListUpsertResult"]],
createOnBehalfDonation?: [{	data: ResolverInputTypes["OnBehalfDonationCreateInput"]},ResolverInputTypes["OnBehalfDonationCreateResult"]],
deleteOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonationDeleteResult"]],
updateOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	data: ResolverInputTypes["OnBehalfDonationUpdateInput"]},ResolverInputTypes["OnBehalfDonationUpdateResult"]],
upsertOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	update: ResolverInputTypes["OnBehalfDonationUpdateInput"],	create: ResolverInputTypes["OnBehalfDonationCreateInput"]},ResolverInputTypes["OnBehalfDonationUpsertResult"]],
createUserPaymentTriesCollection?: [{	data: ResolverInputTypes["UserPaymentTriesCollectionCreateInput"]},ResolverInputTypes["UserPaymentTriesCollectionCreateResult"]],
deleteUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionDeleteResult"]],
updateUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,	data: ResolverInputTypes["UserPaymentTriesCollectionUpdateInput"]},ResolverInputTypes["UserPaymentTriesCollectionUpdateResult"]],
upsertUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,	update: ResolverInputTypes["UserPaymentTriesCollectionUpdateInput"],	create: ResolverInputTypes["UserPaymentTriesCollectionCreateInput"]},ResolverInputTypes["UserPaymentTriesCollectionUpsertResult"]],
createRecurringPaymentPage?: [{	data: ResolverInputTypes["RecurringPaymentPageCreateInput"]},ResolverInputTypes["RecurringPaymentPageCreateResult"]],
deleteRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageDeleteResult"]],
updateRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,	data: ResolverInputTypes["RecurringPaymentPageUpdateInput"]},ResolverInputTypes["RecurringPaymentPageUpdateResult"]],
upsertRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,	update: ResolverInputTypes["RecurringPaymentPageUpdateInput"],	create: ResolverInputTypes["RecurringPaymentPageCreateInput"]},ResolverInputTypes["RecurringPaymentPageUpsertResult"]],
createRecurringPaymentPageLocale?: [{	data: ResolverInputTypes["RecurringPaymentPageLocaleCreateInput"]},ResolverInputTypes["RecurringPaymentPageLocaleCreateResult"]],
deleteRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocaleDeleteResult"]],
updateRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["RecurringPaymentPageLocaleUpdateInput"]},ResolverInputTypes["RecurringPaymentPageLocaleUpdateResult"]],
upsertRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["RecurringPaymentPageLocaleUpdateInput"],	create: ResolverInputTypes["RecurringPaymentPageLocaleCreateInput"]},ResolverInputTypes["RecurringPaymentPageLocaleUpsertResult"]],
createStoryGuide?: [{	data: ResolverInputTypes["StoryGuideCreateInput"]},ResolverInputTypes["StoryGuideCreateResult"]],
deleteStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null},ResolverInputTypes["StoryGuideDeleteResult"]],
updateStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,	data: ResolverInputTypes["StoryGuideUpdateInput"]},ResolverInputTypes["StoryGuideUpdateResult"]],
upsertStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,	update: ResolverInputTypes["StoryGuideUpdateInput"],	create: ResolverInputTypes["StoryGuideCreateInput"]},ResolverInputTypes["StoryGuideUpsertResult"]],
createStoryGuideItem?: [{	data: ResolverInputTypes["StoryGuideItemCreateInput"]},ResolverInputTypes["StoryGuideItemCreateResult"]],
deleteStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null},ResolverInputTypes["StoryGuideItemDeleteResult"]],
updateStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	data: ResolverInputTypes["StoryGuideItemUpdateInput"]},ResolverInputTypes["StoryGuideItemUpdateResult"]],
upsertStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	update: ResolverInputTypes["StoryGuideItemUpdateInput"],	create: ResolverInputTypes["StoryGuideItemCreateInput"]},ResolverInputTypes["StoryGuideItemUpsertResult"]],
createStoryGuideList?: [{	data: ResolverInputTypes["StoryGuideListCreateInput"]},ResolverInputTypes["StoryGuideListCreateResult"]],
deleteStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null},ResolverInputTypes["StoryGuideListDeleteResult"]],
updateStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,	data: ResolverInputTypes["StoryGuideListUpdateInput"]},ResolverInputTypes["StoryGuideListUpdateResult"]],
upsertStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,	update: ResolverInputTypes["StoryGuideListUpdateInput"],	create: ResolverInputTypes["StoryGuideListCreateInput"]},ResolverInputTypes["StoryGuideListUpsertResult"]],
createHeroCarousel?: [{	data: ResolverInputTypes["HeroCarouselCreateInput"]},ResolverInputTypes["HeroCarouselCreateResult"]],
deleteHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null},ResolverInputTypes["HeroCarouselDeleteResult"]],
updateHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	data: ResolverInputTypes["HeroCarouselUpdateInput"]},ResolverInputTypes["HeroCarouselUpdateResult"]],
upsertHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	update: ResolverInputTypes["HeroCarouselUpdateInput"],	create: ResolverInputTypes["HeroCarouselCreateInput"]},ResolverInputTypes["HeroCarouselUpsertResult"]],
createPostOrganizationList?: [{	data: ResolverInputTypes["PostOrganizationListCreateInput"]},ResolverInputTypes["PostOrganizationListCreateResult"]],
deletePostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null},ResolverInputTypes["PostOrganizationListDeleteResult"]],
updatePostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,	data: ResolverInputTypes["PostOrganizationListUpdateInput"]},ResolverInputTypes["PostOrganizationListUpdateResult"]],
upsertPostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,	update: ResolverInputTypes["PostOrganizationListUpdateInput"],	create: ResolverInputTypes["PostOrganizationListCreateInput"]},ResolverInputTypes["PostOrganizationListUpsertResult"]],
createPostOrganizationListItem?: [{	data: ResolverInputTypes["PostOrganizationListItemCreateInput"]},ResolverInputTypes["PostOrganizationListItemCreateResult"]],
deletePostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null},ResolverInputTypes["PostOrganizationListItemDeleteResult"]],
updatePostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	data: ResolverInputTypes["PostOrganizationListItemUpdateInput"]},ResolverInputTypes["PostOrganizationListItemUpdateResult"]],
upsertPostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	update: ResolverInputTypes["PostOrganizationListItemUpdateInput"],	create: ResolverInputTypes["PostOrganizationListItemCreateInput"]},ResolverInputTypes["PostOrganizationListItemUpsertResult"]],
createInfoCarousel?: [{	data: ResolverInputTypes["InfoCarouselCreateInput"]},ResolverInputTypes["InfoCarouselCreateResult"]],
deleteInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null},ResolverInputTypes["InfoCarouselDeleteResult"]],
updateInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,	data: ResolverInputTypes["InfoCarouselUpdateInput"]},ResolverInputTypes["InfoCarouselUpdateResult"]],
upsertInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,	update: ResolverInputTypes["InfoCarouselUpdateInput"],	create: ResolverInputTypes["InfoCarouselCreateInput"]},ResolverInputTypes["InfoCarouselUpsertResult"]],
createInfoCarouselItem?: [{	data: ResolverInputTypes["InfoCarouselItemCreateInput"]},ResolverInputTypes["InfoCarouselItemCreateResult"]],
deleteInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItemDeleteResult"]],
updateInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	data: ResolverInputTypes["InfoCarouselItemUpdateInput"]},ResolverInputTypes["InfoCarouselItemUpdateResult"]],
upsertInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	update: ResolverInputTypes["InfoCarouselItemUpdateInput"],	create: ResolverInputTypes["InfoCarouselItemCreateInput"]},ResolverInputTypes["InfoCarouselItemUpsertResult"]],
createPersonSeenInfoCarousel?: [{	data: ResolverInputTypes["PersonSeenInfoCarouselCreateInput"]},ResolverInputTypes["PersonSeenInfoCarouselCreateResult"]],
deletePersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null},ResolverInputTypes["PersonSeenInfoCarouselDeleteResult"]],
updatePersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	data: ResolverInputTypes["PersonSeenInfoCarouselUpdateInput"]},ResolverInputTypes["PersonSeenInfoCarouselUpdateResult"]],
upsertPersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	update: ResolverInputTypes["PersonSeenInfoCarouselUpdateInput"],	create: ResolverInputTypes["PersonSeenInfoCarouselCreateInput"]},ResolverInputTypes["PersonSeenInfoCarouselUpsertResult"]],
createGivenGiftsPage?: [{	data: ResolverInputTypes["GivenGiftsPageCreateInput"]},ResolverInputTypes["GivenGiftsPageCreateResult"]],
deleteGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageDeleteResult"]],
updateGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,	data: ResolverInputTypes["GivenGiftsPageUpdateInput"]},ResolverInputTypes["GivenGiftsPageUpdateResult"]],
upsertGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,	update: ResolverInputTypes["GivenGiftsPageUpdateInput"],	create: ResolverInputTypes["GivenGiftsPageCreateInput"]},ResolverInputTypes["GivenGiftsPageUpsertResult"]],
createGivenGiftsPageLocale?: [{	data: ResolverInputTypes["GivenGiftsPageLocaleCreateInput"]},ResolverInputTypes["GivenGiftsPageLocaleCreateResult"]],
deleteGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocaleDeleteResult"]],
updateGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GivenGiftsPageLocaleUpdateInput"]},ResolverInputTypes["GivenGiftsPageLocaleUpdateResult"]],
upsertGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GivenGiftsPageLocaleUpdateInput"],	create: ResolverInputTypes["GivenGiftsPageLocaleCreateInput"]},ResolverInputTypes["GivenGiftsPageLocaleUpsertResult"]],
createReceivedGiftsPage?: [{	data: ResolverInputTypes["ReceivedGiftsPageCreateInput"]},ResolverInputTypes["ReceivedGiftsPageCreateResult"]],
deleteReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageDeleteResult"]],
updateReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,	data: ResolverInputTypes["ReceivedGiftsPageUpdateInput"]},ResolverInputTypes["ReceivedGiftsPageUpdateResult"]],
upsertReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,	update: ResolverInputTypes["ReceivedGiftsPageUpdateInput"],	create: ResolverInputTypes["ReceivedGiftsPageCreateInput"]},ResolverInputTypes["ReceivedGiftsPageUpsertResult"]],
createReceivedGiftsPageLocale?: [{	data: ResolverInputTypes["ReceivedGiftsPageLocaleCreateInput"]},ResolverInputTypes["ReceivedGiftsPageLocaleCreateResult"]],
deleteReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocaleDeleteResult"]],
updateReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateInput"]},ResolverInputTypes["ReceivedGiftsPageLocaleUpdateResult"]],
upsertReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateInput"],	create: ResolverInputTypes["ReceivedGiftsPageLocaleCreateInput"]},ResolverInputTypes["ReceivedGiftsPageLocaleUpsertResult"]],
createReportNavigation?: [{	data: ResolverInputTypes["ReportNavigationCreateInput"]},ResolverInputTypes["ReportNavigationCreateResult"]],
deleteReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null},ResolverInputTypes["ReportNavigationDeleteResult"]],
updateReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,	data: ResolverInputTypes["ReportNavigationUpdateInput"]},ResolverInputTypes["ReportNavigationUpdateResult"]],
upsertReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,	update: ResolverInputTypes["ReportNavigationUpdateInput"],	create: ResolverInputTypes["ReportNavigationCreateInput"]},ResolverInputTypes["ReportNavigationUpsertResult"]],
createReportPage?: [{	data: ResolverInputTypes["ReportPageCreateInput"]},ResolverInputTypes["ReportPageCreateResult"]],
deleteReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null},ResolverInputTypes["ReportPageDeleteResult"]],
updateReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null,	data: ResolverInputTypes["ReportPageUpdateInput"]},ResolverInputTypes["ReportPageUpdateResult"]],
upsertReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null,	update: ResolverInputTypes["ReportPageUpdateInput"],	create: ResolverInputTypes["ReportPageCreateInput"]},ResolverInputTypes["ReportPageUpsertResult"]],
createReportPageLocale?: [{	data: ResolverInputTypes["ReportPageLocaleCreateInput"]},ResolverInputTypes["ReportPageLocaleCreateResult"]],
deleteReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocaleDeleteResult"]],
updateReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ReportPageLocaleUpdateInput"]},ResolverInputTypes["ReportPageLocaleUpdateResult"]],
upsertReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ReportPageLocaleUpdateInput"],	create: ResolverInputTypes["ReportPageLocaleCreateInput"]},ResolverInputTypes["ReportPageLocaleUpsertResult"]],
createReportNavigationLocale?: [{	data: ResolverInputTypes["ReportNavigationLocaleCreateInput"]},ResolverInputTypes["ReportNavigationLocaleCreateResult"]],
deleteReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null},ResolverInputTypes["ReportNavigationLocaleDeleteResult"]],
updateReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ReportNavigationLocaleUpdateInput"]},ResolverInputTypes["ReportNavigationLocaleUpdateResult"]],
upsertReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ReportNavigationLocaleUpdateInput"],	create: ResolverInputTypes["ReportNavigationLocaleCreateInput"]},ResolverInputTypes["ReportNavigationLocaleUpsertResult"]],
createSentPayment?: [{	data: ResolverInputTypes["SentPaymentCreateInput"]},ResolverInputTypes["SentPaymentCreateResult"]],
deleteSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null},ResolverInputTypes["SentPaymentDeleteResult"]],
updateSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	data: ResolverInputTypes["SentPaymentUpdateInput"]},ResolverInputTypes["SentPaymentUpdateResult"]],
upsertSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	update: ResolverInputTypes["SentPaymentUpdateInput"],	create: ResolverInputTypes["SentPaymentCreateInput"]},ResolverInputTypes["SentPaymentUpsertResult"]],
createNotificationTargetGroup?: [{	data: ResolverInputTypes["NotificationTargetGroupCreateInput"]},ResolverInputTypes["NotificationTargetGroupCreateResult"]],
deleteNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null},ResolverInputTypes["NotificationTargetGroupDeleteResult"]],
updateNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,	data: ResolverInputTypes["NotificationTargetGroupUpdateInput"]},ResolverInputTypes["NotificationTargetGroupUpdateResult"]],
upsertNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,	update: ResolverInputTypes["NotificationTargetGroupUpdateInput"],	create: ResolverInputTypes["NotificationTargetGroupCreateInput"]},ResolverInputTypes["NotificationTargetGroupUpsertResult"]],
createProcessedNotification?: [{	data: ResolverInputTypes["ProcessedNotificationCreateInput"]},ResolverInputTypes["ProcessedNotificationCreateResult"]],
deleteProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationDeleteResult"]],
updateProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,	data: ResolverInputTypes["ProcessedNotificationUpdateInput"]},ResolverInputTypes["ProcessedNotificationUpdateResult"]],
upsertProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,	update: ResolverInputTypes["ProcessedNotificationUpdateInput"],	create: ResolverInputTypes["ProcessedNotificationCreateInput"]},ResolverInputTypes["ProcessedNotificationUpsertResult"]],
createScheduledNotification?: [{	data: ResolverInputTypes["ScheduledNotificationCreateInput"]},ResolverInputTypes["ScheduledNotificationCreateResult"]],
deleteScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null},ResolverInputTypes["ScheduledNotificationDeleteResult"]],
updateScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,	data: ResolverInputTypes["ScheduledNotificationUpdateInput"]},ResolverInputTypes["ScheduledNotificationUpdateResult"]],
upsertScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,	update: ResolverInputTypes["ScheduledNotificationUpdateInput"],	create: ResolverInputTypes["ScheduledNotificationCreateInput"]},ResolverInputTypes["ScheduledNotificationUpsertResult"]],
createProcessedNotificationSource?: [{	data: ResolverInputTypes["ProcessedNotificationSourceCreateInput"]},ResolverInputTypes["ProcessedNotificationSourceCreateResult"]],
deleteProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationSourceDeleteResult"]],
updateProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	data: ResolverInputTypes["ProcessedNotificationSourceUpdateInput"]},ResolverInputTypes["ProcessedNotificationSourceUpdateResult"]],
upsertProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	update: ResolverInputTypes["ProcessedNotificationSourceUpdateInput"],	create: ResolverInputTypes["ProcessedNotificationSourceCreateInput"]},ResolverInputTypes["ProcessedNotificationSourceUpsertResult"]],
createDevice?: [{	data: ResolverInputTypes["DeviceCreateInput"]},ResolverInputTypes["DeviceCreateResult"]],
deleteDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null},ResolverInputTypes["DeviceDeleteResult"]],
updateDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	data: ResolverInputTypes["DeviceUpdateInput"]},ResolverInputTypes["DeviceUpdateResult"]],
upsertDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	update: ResolverInputTypes["DeviceUpdateInput"],	create: ResolverInputTypes["DeviceCreateInput"]},ResolverInputTypes["DeviceUpsertResult"]],
createScheduledNotificationLocale?: [{	data: ResolverInputTypes["ScheduledNotificationLocaleCreateInput"]},ResolverInputTypes["ScheduledNotificationLocaleCreateResult"]],
deleteScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null},ResolverInputTypes["ScheduledNotificationLocaleDeleteResult"]],
updateScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ScheduledNotificationLocaleUpdateInput"]},ResolverInputTypes["ScheduledNotificationLocaleUpdateResult"]],
upsertScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ScheduledNotificationLocaleUpdateInput"],	create: ResolverInputTypes["ScheduledNotificationLocaleCreateInput"]},ResolverInputTypes["ScheduledNotificationLocaleUpsertResult"]],
createInfoCarouselItemLocale?: [{	data: ResolverInputTypes["InfoCarouselItemLocaleCreateInput"]},ResolverInputTypes["InfoCarouselItemLocaleCreateResult"]],
deleteInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItemLocaleDeleteResult"]],
updateInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	data: ResolverInputTypes["InfoCarouselItemLocaleUpdateInput"]},ResolverInputTypes["InfoCarouselItemLocaleUpdateResult"]],
upsertInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	update: ResolverInputTypes["InfoCarouselItemLocaleUpdateInput"],	create: ResolverInputTypes["InfoCarouselItemLocaleCreateInput"]},ResolverInputTypes["InfoCarouselItemLocaleUpsertResult"]],
createSentPaymentLocale?: [{	data: ResolverInputTypes["SentPaymentLocaleCreateInput"]},ResolverInputTypes["SentPaymentLocaleCreateResult"]],
deleteSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null},ResolverInputTypes["SentPaymentLocaleDeleteResult"]],
updateSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	data: ResolverInputTypes["SentPaymentLocaleUpdateInput"]},ResolverInputTypes["SentPaymentLocaleUpdateResult"]],
upsertSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	update: ResolverInputTypes["SentPaymentLocaleUpdateInput"],	create: ResolverInputTypes["SentPaymentLocaleCreateInput"]},ResolverInputTypes["SentPaymentLocaleUpsertResult"]],
createTextImageList?: [{	data: ResolverInputTypes["TextImageListCreateInput"]},ResolverInputTypes["TextImageListCreateResult"]],
deleteTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null},ResolverInputTypes["TextImageListDeleteResult"]],
updateTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null,	data: ResolverInputTypes["TextImageListUpdateInput"]},ResolverInputTypes["TextImageListUpdateResult"]],
upsertTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null,	update: ResolverInputTypes["TextImageListUpdateInput"],	create: ResolverInputTypes["TextImageListCreateInput"]},ResolverInputTypes["TextImageListUpsertResult"]],
createTextImageListItem?: [{	data: ResolverInputTypes["TextImageListItemCreateInput"]},ResolverInputTypes["TextImageListItemCreateResult"]],
deleteTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null},ResolverInputTypes["TextImageListItemDeleteResult"]],
updateTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	data: ResolverInputTypes["TextImageListItemUpdateInput"]},ResolverInputTypes["TextImageListItemUpdateResult"]],
upsertTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	update: ResolverInputTypes["TextImageListItemUpdateInput"],	create: ResolverInputTypes["TextImageListItemCreateInput"]},ResolverInputTypes["TextImageListItemUpsertResult"]],
createHeroCarouselItem?: [{	data: ResolverInputTypes["HeroCarouselItemCreateInput"]},ResolverInputTypes["HeroCarouselItemCreateResult"]],
deleteHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null},ResolverInputTypes["HeroCarouselItemDeleteResult"]],
updateHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	data: ResolverInputTypes["HeroCarouselItemUpdateInput"]},ResolverInputTypes["HeroCarouselItemUpdateResult"]],
upsertHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	update: ResolverInputTypes["HeroCarouselItemUpdateInput"],	create: ResolverInputTypes["HeroCarouselItemCreateInput"]},ResolverInputTypes["HeroCarouselItemUpsertResult"]],
transaction?: [{	options?: ResolverInputTypes["MutationTransactionOptions"] | undefined | null},ResolverInputTypes["MutationTransaction"]],
	query?:ResolverInputTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["S3SignedUpload"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ResolverInputTypes["S3Header"],
	method?:boolean | `@${string}`,
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
	publicUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3Header"]: AliasType<{
	key?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3GenerateSignedUploadInput"]: {
	contentType?: string | undefined | null,
	/** If not provided, extension is detected from a content-type. */
	extension?: string | undefined | null,
	/** Signed URL expiration. */
	expiration?: number | undefined | null,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number | undefined | null,
	/** Can be used as a "directory". */
	prefix?: string | undefined | null,
	/** Suffix after generated id and before the extension. */
	suffix?: string | undefined | null,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string | undefined | null,
	contentDisposition?: ResolverInputTypes["S33ContentDisposition"] | undefined | null,
	/** If not supported by S3 provider, an error is thrown. */
	acl?: ResolverInputTypes["S3Acl"] | undefined | null
};
	["S33ContentDisposition"]:S33ContentDisposition;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ResolverInputTypes["S3Header"],
	method?:boolean | `@${string}`,
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["General"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationResult"]:AliasType<{
		ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"];
		['...on GeneralCreateResult']?: Omit<ResolverInputTypes["GeneralCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralDeleteResult']?: Omit<ResolverInputTypes["GeneralDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralUpdateResult']?: Omit<ResolverInputTypes["GeneralUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralUpsertResult']?: Omit<ResolverInputTypes["GeneralUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ResolverInputTypes["ImageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ResolverInputTypes["ImageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ResolverInputTypes["ImageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ResolverInputTypes["ImageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageCreateResult']?: Omit<ResolverInputTypes["GenericPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageDeleteResult']?: Omit<ResolverInputTypes["GenericPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageUpdateResult']?: Omit<ResolverInputTypes["GenericPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageUpsertResult']?: Omit<ResolverInputTypes["GenericPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ResolverInputTypes["LinkableCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ResolverInputTypes["LinkableDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ResolverInputTypes["LinkableUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ResolverInputTypes["LinkableUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ResolverInputTypes["SeoCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ResolverInputTypes["SeoDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ResolverInputTypes["SeoUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ResolverInputTypes["SeoUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ResolverInputTypes["ContentCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ResolverInputTypes["ContentDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ResolverInputTypes["ContentUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ResolverInputTypes["ContentUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ResolverInputTypes["ContentBlockCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ResolverInputTypes["ContentBlockDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ResolverInputTypes["ContentBlockUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ResolverInputTypes["ContentBlockUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ResolverInputTypes["ContentReferenceCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ResolverInputTypes["ContentReferenceDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ResolverInputTypes["ContentReferenceUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ResolverInputTypes["ContentReferenceUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralLocaleCreateResult']?: Omit<ResolverInputTypes["GeneralLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralLocaleDeleteResult']?: Omit<ResolverInputTypes["GeneralLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralLocaleUpdateResult']?: Omit<ResolverInputTypes["GeneralLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralLocaleUpsertResult']?: Omit<ResolverInputTypes["GeneralLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageLocaleCreateResult']?: Omit<ResolverInputTypes["GenericPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageLocaleDeleteResult']?: Omit<ResolverInputTypes["GenericPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageLocaleUpdateResult']?: Omit<ResolverInputTypes["GenericPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageLocaleUpsertResult']?: Omit<ResolverInputTypes["GenericPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LocaleCreateResult']?: Omit<ResolverInputTypes["LocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LocaleDeleteResult']?: Omit<ResolverInputTypes["LocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LocaleUpdateResult']?: Omit<ResolverInputTypes["LocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LocaleUpsertResult']?: Omit<ResolverInputTypes["LocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ResolverInputTypes["VideoCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ResolverInputTypes["VideoDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ResolverInputTypes["VideoUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ResolverInputTypes["VideoUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ResolverInputTypes["LinkCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ResolverInputTypes["LinkDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ResolverInputTypes["LinkUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ResolverInputTypes["LinkUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostCreateResult']?: Omit<ResolverInputTypes["PostCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostDeleteResult']?: Omit<ResolverInputTypes["PostDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostUpdateResult']?: Omit<ResolverInputTypes["PostUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostUpsertResult']?: Omit<ResolverInputTypes["PostUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostLocaleCreateResult']?: Omit<ResolverInputTypes["PostLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostLocaleDeleteResult']?: Omit<ResolverInputTypes["PostLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostLocaleUpdateResult']?: Omit<ResolverInputTypes["PostLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostLocaleUpsertResult']?: Omit<ResolverInputTypes["PostLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaCreateResult']?: Omit<ResolverInputTypes["PostAreaCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaDeleteResult']?: Omit<ResolverInputTypes["PostAreaDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaUpdateResult']?: Omit<ResolverInputTypes["PostAreaUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaUpsertResult']?: Omit<ResolverInputTypes["PostAreaUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaLocaleCreateResult']?: Omit<ResolverInputTypes["PostAreaLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaLocaleDeleteResult']?: Omit<ResolverInputTypes["PostAreaLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaLocaleUpdateResult']?: Omit<ResolverInputTypes["PostAreaLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaLocaleUpsertResult']?: Omit<ResolverInputTypes["PostAreaLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationCreateResult']?: Omit<ResolverInputTypes["PostOrganizationCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationDeleteResult']?: Omit<ResolverInputTypes["PostOrganizationDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationUpdateResult']?: Omit<ResolverInputTypes["PostOrganizationUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationUpsertResult']?: Omit<ResolverInputTypes["PostOrganizationUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationLocaleCreateResult']?: Omit<ResolverInputTypes["PostOrganizationLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationLocaleDeleteResult']?: Omit<ResolverInputTypes["PostOrganizationLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationLocaleUpdateResult']?: Omit<ResolverInputTypes["PostOrganizationLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationLocaleUpsertResult']?: Omit<ResolverInputTypes["PostOrganizationLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationCreateResult']?: Omit<ResolverInputTypes["DonationCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationDeleteResult']?: Omit<ResolverInputTypes["DonationDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationUpdateResult']?: Omit<ResolverInputTypes["DonationUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationUpsertResult']?: Omit<ResolverInputTypes["DonationUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountItemCreateResult']?: Omit<ResolverInputTypes["DonationAmountItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountItemDeleteResult']?: Omit<ResolverInputTypes["DonationAmountItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountItemUpdateResult']?: Omit<ResolverInputTypes["DonationAmountItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountItemUpsertResult']?: Omit<ResolverInputTypes["DonationAmountItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountsRegionItemCreateResult']?: Omit<ResolverInputTypes["DonationAmountsRegionItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountsRegionItemDeleteResult']?: Omit<ResolverInputTypes["DonationAmountsRegionItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountsRegionItemUpdateResult']?: Omit<ResolverInputTypes["DonationAmountsRegionItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountsRegionItemUpsertResult']?: Omit<ResolverInputTypes["DonationAmountsRegionItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountsRegionListCreateResult']?: Omit<ResolverInputTypes["DonationAmountsRegionListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountsRegionListDeleteResult']?: Omit<ResolverInputTypes["DonationAmountsRegionListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountsRegionListUpdateResult']?: Omit<ResolverInputTypes["DonationAmountsRegionListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DonationAmountsRegionListUpsertResult']?: Omit<ResolverInputTypes["DonationAmountsRegionListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RegionCreateResult']?: Omit<ResolverInputTypes["RegionCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RegionDeleteResult']?: Omit<ResolverInputTypes["RegionDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RegionUpdateResult']?: Omit<ResolverInputTypes["RegionUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RegionUpsertResult']?: Omit<ResolverInputTypes["RegionUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkItemCreateResult']?: Omit<ResolverInputTypes["LinkItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkItemDeleteResult']?: Omit<ResolverInputTypes["LinkItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkItemUpdateResult']?: Omit<ResolverInputTypes["LinkItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkItemUpsertResult']?: Omit<ResolverInputTypes["LinkItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkListCreateResult']?: Omit<ResolverInputTypes["LinkListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkListDeleteResult']?: Omit<ResolverInputTypes["LinkListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkListUpdateResult']?: Omit<ResolverInputTypes["LinkListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkListUpsertResult']?: Omit<ResolverInputTypes["LinkListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ResolverInputTypes["HeaderCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ResolverInputTypes["HeaderDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ResolverInputTypes["HeaderUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ResolverInputTypes["HeaderUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderLocaleCreateResult']?: Omit<ResolverInputTypes["HeaderLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderLocaleDeleteResult']?: Omit<ResolverInputTypes["HeaderLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderLocaleUpdateResult']?: Omit<ResolverInputTypes["HeaderLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderLocaleUpsertResult']?: Omit<ResolverInputTypes["HeaderLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ResolverInputTypes["FooterCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ResolverInputTypes["FooterDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ResolverInputTypes["FooterUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ResolverInputTypes["FooterUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLocaleCreateResult']?: Omit<ResolverInputTypes["FooterLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLocaleDeleteResult']?: Omit<ResolverInputTypes["FooterLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLocaleUpdateResult']?: Omit<ResolverInputTypes["FooterLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLocaleUpsertResult']?: Omit<ResolverInputTypes["FooterLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostListCreateResult']?: Omit<ResolverInputTypes["PostListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostListDeleteResult']?: Omit<ResolverInputTypes["PostListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostListUpdateResult']?: Omit<ResolverInputTypes["PostListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostListUpsertResult']?: Omit<ResolverInputTypes["PostListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostListItemCreateResult']?: Omit<ResolverInputTypes["PostListItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostListItemDeleteResult']?: Omit<ResolverInputTypes["PostListItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostListItemUpdateResult']?: Omit<ResolverInputTypes["PostListItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostListItemUpsertResult']?: Omit<ResolverInputTypes["PostListItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AppBannerCreateResult']?: Omit<ResolverInputTypes["AppBannerCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AppBannerDeleteResult']?: Omit<ResolverInputTypes["AppBannerDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AppBannerUpdateResult']?: Omit<ResolverInputTypes["AppBannerUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AppBannerUpsertResult']?: Omit<ResolverInputTypes["AppBannerUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsCreateResult']?: Omit<ResolverInputTypes["GenericPageAboutSettingsCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsDeleteResult']?: Omit<ResolverInputTypes["GenericPageAboutSettingsDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsUpdateResult']?: Omit<ResolverInputTypes["GenericPageAboutSettingsUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsUpsertResult']?: Omit<ResolverInputTypes["GenericPageAboutSettingsUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsLocaleCreateResult']?: Omit<ResolverInputTypes["GenericPageAboutSettingsLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsLocaleDeleteResult']?: Omit<ResolverInputTypes["GenericPageAboutSettingsLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsLocaleUpdateResult']?: Omit<ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutSettingsLocaleUpsertResult']?: Omit<ResolverInputTypes["GenericPageAboutSettingsLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueCreateResult']?: Omit<ResolverInputTypes["ValueCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueDeleteResult']?: Omit<ResolverInputTypes["ValueDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueUpdateResult']?: Omit<ResolverInputTypes["ValueUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueUpsertResult']?: Omit<ResolverInputTypes["ValueUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueItemCreateResult']?: Omit<ResolverInputTypes["ValueItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueItemDeleteResult']?: Omit<ResolverInputTypes["ValueItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueItemUpdateResult']?: Omit<ResolverInputTypes["ValueItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueItemUpsertResult']?: Omit<ResolverInputTypes["ValueItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueListCreateResult']?: Omit<ResolverInputTypes["ValueListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueListDeleteResult']?: Omit<ResolverInputTypes["ValueListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueListUpdateResult']?: Omit<ResolverInputTypes["ValueListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ValueListUpsertResult']?: Omit<ResolverInputTypes["ValueListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkCreateResult']?: Omit<ResolverInputTypes["ImageLinkCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkDeleteResult']?: Omit<ResolverInputTypes["ImageLinkDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkUpdateResult']?: Omit<ResolverInputTypes["ImageLinkUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkUpsertResult']?: Omit<ResolverInputTypes["ImageLinkUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkItemCreateResult']?: Omit<ResolverInputTypes["ImageLinkItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkItemDeleteResult']?: Omit<ResolverInputTypes["ImageLinkItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkItemUpdateResult']?: Omit<ResolverInputTypes["ImageLinkItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkItemUpsertResult']?: Omit<ResolverInputTypes["ImageLinkItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkListCreateResult']?: Omit<ResolverInputTypes["ImageLinkListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkListDeleteResult']?: Omit<ResolverInputTypes["ImageLinkListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkListUpdateResult']?: Omit<ResolverInputTypes["ImageLinkListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageLinkListUpsertResult']?: Omit<ResolverInputTypes["ImageLinkListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaListCreateResult']?: Omit<ResolverInputTypes["PostAreaListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaListDeleteResult']?: Omit<ResolverInputTypes["PostAreaListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaListUpdateResult']?: Omit<ResolverInputTypes["PostAreaListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaListUpsertResult']?: Omit<ResolverInputTypes["PostAreaListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaListItemCreateResult']?: Omit<ResolverInputTypes["PostAreaListItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaListItemDeleteResult']?: Omit<ResolverInputTypes["PostAreaListItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaListItemUpdateResult']?: Omit<ResolverInputTypes["PostAreaListItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostAreaListItemUpsertResult']?: Omit<ResolverInputTypes["PostAreaListItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AccordionCreateResult']?: Omit<ResolverInputTypes["AccordionCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AccordionDeleteResult']?: Omit<ResolverInputTypes["AccordionDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AccordionUpdateResult']?: Omit<ResolverInputTypes["AccordionUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AccordionUpsertResult']?: Omit<ResolverInputTypes["AccordionUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AccordionItemCreateResult']?: Omit<ResolverInputTypes["AccordionItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AccordionItemDeleteResult']?: Omit<ResolverInputTypes["AccordionItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AccordionItemUpdateResult']?: Omit<ResolverInputTypes["AccordionItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on AccordionItemUpsertResult']?: Omit<ResolverInputTypes["AccordionItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserCreateResult']?: Omit<ResolverInputTypes["UserCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserDeleteResult']?: Omit<ResolverInputTypes["UserDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserUpdateResult']?: Omit<ResolverInputTypes["UserUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserUpsertResult']?: Omit<ResolverInputTypes["UserUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentCreateResult']?: Omit<ResolverInputTypes["UserPaymentCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentDeleteResult']?: Omit<ResolverInputTypes["UserPaymentDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentUpdateResult']?: Omit<ResolverInputTypes["UserPaymentUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentUpsertResult']?: Omit<ResolverInputTypes["UserPaymentUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CurrencyCreateResult']?: Omit<ResolverInputTypes["CurrencyCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CurrencyDeleteResult']?: Omit<ResolverInputTypes["CurrencyDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CurrencyUpdateResult']?: Omit<ResolverInputTypes["CurrencyUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CurrencyUpsertResult']?: Omit<ResolverInputTypes["CurrencyUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumCreateResult']?: Omit<ResolverInputTypes["MediumCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumDeleteResult']?: Omit<ResolverInputTypes["MediumDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumUpdateResult']?: Omit<ResolverInputTypes["MediumUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumUpsertResult']?: Omit<ResolverInputTypes["MediumUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumItemCreateResult']?: Omit<ResolverInputTypes["MediumItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumItemDeleteResult']?: Omit<ResolverInputTypes["MediumItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumItemUpdateResult']?: Omit<ResolverInputTypes["MediumItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumItemUpsertResult']?: Omit<ResolverInputTypes["MediumItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumListCreateResult']?: Omit<ResolverInputTypes["MediumListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumListDeleteResult']?: Omit<ResolverInputTypes["MediumListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumListUpdateResult']?: Omit<ResolverInputTypes["MediumListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumListUpsertResult']?: Omit<ResolverInputTypes["MediumListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentOrderIdCreateResult']?: Omit<ResolverInputTypes["UserPaymentOrderIdCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentOrderIdDeleteResult']?: Omit<ResolverInputTypes["UserPaymentOrderIdDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentOrderIdUpdateResult']?: Omit<ResolverInputTypes["UserPaymentOrderIdUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentOrderIdUpsertResult']?: Omit<ResolverInputTypes["UserPaymentOrderIdUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostRevisionCreateResult']?: Omit<ResolverInputTypes["PostRevisionCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostRevisionDeleteResult']?: Omit<ResolverInputTypes["PostRevisionDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostRevisionUpdateResult']?: Omit<ResolverInputTypes["PostRevisionUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostRevisionUpsertResult']?: Omit<ResolverInputTypes["PostRevisionUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserRecurringPaymentCreateResult']?: Omit<ResolverInputTypes["UserRecurringPaymentCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserRecurringPaymentDeleteResult']?: Omit<ResolverInputTypes["UserRecurringPaymentDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserRecurringPaymentUpdateResult']?: Omit<ResolverInputTypes["UserRecurringPaymentUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserRecurringPaymentUpsertResult']?: Omit<ResolverInputTypes["UserRecurringPaymentUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserRecurringPaymentItemCreateResult']?: Omit<ResolverInputTypes["UserRecurringPaymentItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserRecurringPaymentItemDeleteResult']?: Omit<ResolverInputTypes["UserRecurringPaymentItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserRecurringPaymentItemUpdateResult']?: Omit<ResolverInputTypes["UserRecurringPaymentItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserRecurringPaymentItemUpsertResult']?: Omit<ResolverInputTypes["UserRecurringPaymentItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostRevisionLocaleCreateResult']?: Omit<ResolverInputTypes["PostRevisionLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostRevisionLocaleDeleteResult']?: Omit<ResolverInputTypes["PostRevisionLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostRevisionLocaleUpdateResult']?: Omit<ResolverInputTypes["PostRevisionLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostRevisionLocaleUpsertResult']?: Omit<ResolverInputTypes["PostRevisionLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCatalogueCreateResult']?: Omit<ResolverInputTypes["TranslationCatalogueCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCatalogueDeleteResult']?: Omit<ResolverInputTypes["TranslationCatalogueDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCatalogueUpdateResult']?: Omit<ResolverInputTypes["TranslationCatalogueUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCatalogueUpsertResult']?: Omit<ResolverInputTypes["TranslationCatalogueUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierCreateResult']?: Omit<ResolverInputTypes["TranslationCataloguesIdentifierCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierDeleteResult']?: Omit<ResolverInputTypes["TranslationCataloguesIdentifierDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpdateResult']?: Omit<ResolverInputTypes["TranslationCataloguesIdentifierUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpsertResult']?: Omit<ResolverInputTypes["TranslationCataloguesIdentifierUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationDomainCreateResult']?: Omit<ResolverInputTypes["TranslationDomainCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationDomainDeleteResult']?: Omit<ResolverInputTypes["TranslationDomainDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationDomainUpdateResult']?: Omit<ResolverInputTypes["TranslationDomainUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationDomainUpsertResult']?: Omit<ResolverInputTypes["TranslationDomainUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationKeyCreateResult']?: Omit<ResolverInputTypes["TranslationKeyCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationKeyDeleteResult']?: Omit<ResolverInputTypes["TranslationKeyDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationKeyUpdateResult']?: Omit<ResolverInputTypes["TranslationKeyUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationKeyUpsertResult']?: Omit<ResolverInputTypes["TranslationKeyUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationValueCreateResult']?: Omit<ResolverInputTypes["TranslationValueCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationValueDeleteResult']?: Omit<ResolverInputTypes["TranslationValueDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationValueUpdateResult']?: Omit<ResolverInputTypes["TranslationValueUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationValueUpsertResult']?: Omit<ResolverInputTypes["TranslationValueUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutGroupLinksLocaleCreateResult']?: Omit<ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutGroupLinksLocaleDeleteResult']?: Omit<ResolverInputTypes["GenericPageAboutGroupLinksLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutGroupLinksLocaleUpdateResult']?: Omit<ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageAboutGroupLinksLocaleUpsertResult']?: Omit<ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MemberListCreateResult']?: Omit<ResolverInputTypes["MemberListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MemberListDeleteResult']?: Omit<ResolverInputTypes["MemberListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MemberListUpdateResult']?: Omit<ResolverInputTypes["MemberListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MemberListUpsertResult']?: Omit<ResolverInputTypes["MemberListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MemberListItemCreateResult']?: Omit<ResolverInputTypes["MemberListItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MemberListItemDeleteResult']?: Omit<ResolverInputTypes["MemberListItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MemberListItemUpdateResult']?: Omit<ResolverInputTypes["MemberListItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MemberListItemUpsertResult']?: Omit<ResolverInputTypes["MemberListItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FilledTaxFormCreateResult']?: Omit<ResolverInputTypes["FilledTaxFormCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FilledTaxFormDeleteResult']?: Omit<ResolverInputTypes["FilledTaxFormDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FilledTaxFormUpdateResult']?: Omit<ResolverInputTypes["FilledTaxFormUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FilledTaxFormUpsertResult']?: Omit<ResolverInputTypes["FilledTaxFormUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FilledTaxFormEmailAddressCreateResult']?: Omit<ResolverInputTypes["FilledTaxFormEmailAddressCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FilledTaxFormEmailAddressDeleteResult']?: Omit<ResolverInputTypes["FilledTaxFormEmailAddressDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FilledTaxFormEmailAddressUpdateResult']?: Omit<ResolverInputTypes["FilledTaxFormEmailAddressUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FilledTaxFormEmailAddressUpsertResult']?: Omit<ResolverInputTypes["FilledTaxFormEmailAddressUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FormCreateResult']?: Omit<ResolverInputTypes["FormCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FormDeleteResult']?: Omit<ResolverInputTypes["FormDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FormUpdateResult']?: Omit<ResolverInputTypes["FormUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FormUpsertResult']?: Omit<ResolverInputTypes["FormUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CsobPaymentCreateResult']?: Omit<ResolverInputTypes["CsobPaymentCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CsobPaymentDeleteResult']?: Omit<ResolverInputTypes["CsobPaymentDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CsobPaymentUpdateResult']?: Omit<ResolverInputTypes["CsobPaymentUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CsobPaymentUpsertResult']?: Omit<ResolverInputTypes["CsobPaymentUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CsobPaymentStatusChangeCreateResult']?: Omit<ResolverInputTypes["CsobPaymentStatusChangeCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CsobPaymentStatusChangeDeleteResult']?: Omit<ResolverInputTypes["CsobPaymentStatusChangeDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CsobPaymentStatusChangeUpdateResult']?: Omit<ResolverInputTypes["CsobPaymentStatusChangeUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CsobPaymentStatusChangeUpsertResult']?: Omit<ResolverInputTypes["CsobPaymentStatusChangeUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StripePaymentCreateResult']?: Omit<ResolverInputTypes["StripePaymentCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StripePaymentDeleteResult']?: Omit<ResolverInputTypes["StripePaymentDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StripePaymentUpdateResult']?: Omit<ResolverInputTypes["StripePaymentUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StripePaymentUpsertResult']?: Omit<ResolverInputTypes["StripePaymentUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StripePaymentStatusChangeCreateResult']?: Omit<ResolverInputTypes["StripePaymentStatusChangeCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StripePaymentStatusChangeDeleteResult']?: Omit<ResolverInputTypes["StripePaymentStatusChangeDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StripePaymentStatusChangeUpdateResult']?: Omit<ResolverInputTypes["StripePaymentStatusChangeUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StripePaymentStatusChangeUpsertResult']?: Omit<ResolverInputTypes["StripePaymentStatusChangeUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RegionPaymentMethodCreateResult']?: Omit<ResolverInputTypes["RegionPaymentMethodCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RegionPaymentMethodDeleteResult']?: Omit<ResolverInputTypes["RegionPaymentMethodDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RegionPaymentMethodUpdateResult']?: Omit<ResolverInputTypes["RegionPaymentMethodUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RegionPaymentMethodUpsertResult']?: Omit<ResolverInputTypes["RegionPaymentMethodUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileItemCreateResult']?: Omit<ResolverInputTypes["TileItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileItemDeleteResult']?: Omit<ResolverInputTypes["TileItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileItemUpdateResult']?: Omit<ResolverInputTypes["TileItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileItemUpsertResult']?: Omit<ResolverInputTypes["TileItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileListCreateResult']?: Omit<ResolverInputTypes["TileListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileListDeleteResult']?: Omit<ResolverInputTypes["TileListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileListUpdateResult']?: Omit<ResolverInputTypes["TileListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileListUpsertResult']?: Omit<ResolverInputTypes["TileListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageCreateResult']?: Omit<ResolverInputTypes["FeedPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageDeleteResult']?: Omit<ResolverInputTypes["FeedPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageUpdateResult']?: Omit<ResolverInputTypes["FeedPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageUpsertResult']?: Omit<ResolverInputTypes["FeedPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageLocaleCreateResult']?: Omit<ResolverInputTypes["FeedPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageLocaleDeleteResult']?: Omit<ResolverInputTypes["FeedPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageLocaleUpdateResult']?: Omit<ResolverInputTypes["FeedPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageLocaleUpsertResult']?: Omit<ResolverInputTypes["FeedPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageSectionCreateResult']?: Omit<ResolverInputTypes["FeedPageSectionCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageSectionDeleteResult']?: Omit<ResolverInputTypes["FeedPageSectionDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageSectionUpdateResult']?: Omit<ResolverInputTypes["FeedPageSectionUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageSectionUpsertResult']?: Omit<ResolverInputTypes["FeedPageSectionUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageTileStripeCreateResult']?: Omit<ResolverInputTypes["FeedPageTileStripeCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageTileStripeDeleteResult']?: Omit<ResolverInputTypes["FeedPageTileStripeDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageTileStripeUpdateResult']?: Omit<ResolverInputTypes["FeedPageTileStripeUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FeedPageTileStripeUpsertResult']?: Omit<ResolverInputTypes["FeedPageTileStripeUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CardItemCreateResult']?: Omit<ResolverInputTypes["CardItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CardItemDeleteResult']?: Omit<ResolverInputTypes["CardItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CardItemUpdateResult']?: Omit<ResolverInputTypes["CardItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CardItemUpsertResult']?: Omit<ResolverInputTypes["CardItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CardListCreateResult']?: Omit<ResolverInputTypes["CardListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CardListDeleteResult']?: Omit<ResolverInputTypes["CardListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CardListUpdateResult']?: Omit<ResolverInputTypes["CardListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CardListUpsertResult']?: Omit<ResolverInputTypes["CardListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on OnBehalfDonationCreateResult']?: Omit<ResolverInputTypes["OnBehalfDonationCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on OnBehalfDonationDeleteResult']?: Omit<ResolverInputTypes["OnBehalfDonationDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on OnBehalfDonationUpdateResult']?: Omit<ResolverInputTypes["OnBehalfDonationUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on OnBehalfDonationUpsertResult']?: Omit<ResolverInputTypes["OnBehalfDonationUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentTriesCollectionCreateResult']?: Omit<ResolverInputTypes["UserPaymentTriesCollectionCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentTriesCollectionDeleteResult']?: Omit<ResolverInputTypes["UserPaymentTriesCollectionDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentTriesCollectionUpdateResult']?: Omit<ResolverInputTypes["UserPaymentTriesCollectionUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on UserPaymentTriesCollectionUpsertResult']?: Omit<ResolverInputTypes["UserPaymentTriesCollectionUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecurringPaymentPageCreateResult']?: Omit<ResolverInputTypes["RecurringPaymentPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecurringPaymentPageDeleteResult']?: Omit<ResolverInputTypes["RecurringPaymentPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecurringPaymentPageUpdateResult']?: Omit<ResolverInputTypes["RecurringPaymentPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecurringPaymentPageUpsertResult']?: Omit<ResolverInputTypes["RecurringPaymentPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecurringPaymentPageLocaleCreateResult']?: Omit<ResolverInputTypes["RecurringPaymentPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecurringPaymentPageLocaleDeleteResult']?: Omit<ResolverInputTypes["RecurringPaymentPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecurringPaymentPageLocaleUpdateResult']?: Omit<ResolverInputTypes["RecurringPaymentPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecurringPaymentPageLocaleUpsertResult']?: Omit<ResolverInputTypes["RecurringPaymentPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideCreateResult']?: Omit<ResolverInputTypes["StoryGuideCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideDeleteResult']?: Omit<ResolverInputTypes["StoryGuideDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideUpdateResult']?: Omit<ResolverInputTypes["StoryGuideUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideUpsertResult']?: Omit<ResolverInputTypes["StoryGuideUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideItemCreateResult']?: Omit<ResolverInputTypes["StoryGuideItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideItemDeleteResult']?: Omit<ResolverInputTypes["StoryGuideItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideItemUpdateResult']?: Omit<ResolverInputTypes["StoryGuideItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideItemUpsertResult']?: Omit<ResolverInputTypes["StoryGuideItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideListCreateResult']?: Omit<ResolverInputTypes["StoryGuideListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideListDeleteResult']?: Omit<ResolverInputTypes["StoryGuideListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideListUpdateResult']?: Omit<ResolverInputTypes["StoryGuideListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StoryGuideListUpsertResult']?: Omit<ResolverInputTypes["StoryGuideListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeroCarouselCreateResult']?: Omit<ResolverInputTypes["HeroCarouselCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeroCarouselDeleteResult']?: Omit<ResolverInputTypes["HeroCarouselDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeroCarouselUpdateResult']?: Omit<ResolverInputTypes["HeroCarouselUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeroCarouselUpsertResult']?: Omit<ResolverInputTypes["HeroCarouselUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationListCreateResult']?: Omit<ResolverInputTypes["PostOrganizationListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationListDeleteResult']?: Omit<ResolverInputTypes["PostOrganizationListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationListUpdateResult']?: Omit<ResolverInputTypes["PostOrganizationListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationListUpsertResult']?: Omit<ResolverInputTypes["PostOrganizationListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationListItemCreateResult']?: Omit<ResolverInputTypes["PostOrganizationListItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationListItemDeleteResult']?: Omit<ResolverInputTypes["PostOrganizationListItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationListItemUpdateResult']?: Omit<ResolverInputTypes["PostOrganizationListItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PostOrganizationListItemUpsertResult']?: Omit<ResolverInputTypes["PostOrganizationListItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselCreateResult']?: Omit<ResolverInputTypes["InfoCarouselCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselDeleteResult']?: Omit<ResolverInputTypes["InfoCarouselDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselUpdateResult']?: Omit<ResolverInputTypes["InfoCarouselUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselUpsertResult']?: Omit<ResolverInputTypes["InfoCarouselUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselItemCreateResult']?: Omit<ResolverInputTypes["InfoCarouselItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselItemDeleteResult']?: Omit<ResolverInputTypes["InfoCarouselItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselItemUpdateResult']?: Omit<ResolverInputTypes["InfoCarouselItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselItemUpsertResult']?: Omit<ResolverInputTypes["InfoCarouselItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PersonSeenInfoCarouselCreateResult']?: Omit<ResolverInputTypes["PersonSeenInfoCarouselCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PersonSeenInfoCarouselDeleteResult']?: Omit<ResolverInputTypes["PersonSeenInfoCarouselDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PersonSeenInfoCarouselUpdateResult']?: Omit<ResolverInputTypes["PersonSeenInfoCarouselUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on PersonSeenInfoCarouselUpsertResult']?: Omit<ResolverInputTypes["PersonSeenInfoCarouselUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GivenGiftsPageCreateResult']?: Omit<ResolverInputTypes["GivenGiftsPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GivenGiftsPageDeleteResult']?: Omit<ResolverInputTypes["GivenGiftsPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GivenGiftsPageUpdateResult']?: Omit<ResolverInputTypes["GivenGiftsPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GivenGiftsPageUpsertResult']?: Omit<ResolverInputTypes["GivenGiftsPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GivenGiftsPageLocaleCreateResult']?: Omit<ResolverInputTypes["GivenGiftsPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GivenGiftsPageLocaleDeleteResult']?: Omit<ResolverInputTypes["GivenGiftsPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GivenGiftsPageLocaleUpdateResult']?: Omit<ResolverInputTypes["GivenGiftsPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GivenGiftsPageLocaleUpsertResult']?: Omit<ResolverInputTypes["GivenGiftsPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReceivedGiftsPageCreateResult']?: Omit<ResolverInputTypes["ReceivedGiftsPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReceivedGiftsPageDeleteResult']?: Omit<ResolverInputTypes["ReceivedGiftsPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReceivedGiftsPageUpdateResult']?: Omit<ResolverInputTypes["ReceivedGiftsPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReceivedGiftsPageUpsertResult']?: Omit<ResolverInputTypes["ReceivedGiftsPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReceivedGiftsPageLocaleCreateResult']?: Omit<ResolverInputTypes["ReceivedGiftsPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReceivedGiftsPageLocaleDeleteResult']?: Omit<ResolverInputTypes["ReceivedGiftsPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReceivedGiftsPageLocaleUpdateResult']?: Omit<ResolverInputTypes["ReceivedGiftsPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReceivedGiftsPageLocaleUpsertResult']?: Omit<ResolverInputTypes["ReceivedGiftsPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportNavigationCreateResult']?: Omit<ResolverInputTypes["ReportNavigationCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportNavigationDeleteResult']?: Omit<ResolverInputTypes["ReportNavigationDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportNavigationUpdateResult']?: Omit<ResolverInputTypes["ReportNavigationUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportNavigationUpsertResult']?: Omit<ResolverInputTypes["ReportNavigationUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportPageCreateResult']?: Omit<ResolverInputTypes["ReportPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportPageDeleteResult']?: Omit<ResolverInputTypes["ReportPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportPageUpdateResult']?: Omit<ResolverInputTypes["ReportPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportPageUpsertResult']?: Omit<ResolverInputTypes["ReportPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportPageLocaleCreateResult']?: Omit<ResolverInputTypes["ReportPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportPageLocaleDeleteResult']?: Omit<ResolverInputTypes["ReportPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportPageLocaleUpdateResult']?: Omit<ResolverInputTypes["ReportPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportPageLocaleUpsertResult']?: Omit<ResolverInputTypes["ReportPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportNavigationLocaleCreateResult']?: Omit<ResolverInputTypes["ReportNavigationLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportNavigationLocaleDeleteResult']?: Omit<ResolverInputTypes["ReportNavigationLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportNavigationLocaleUpdateResult']?: Omit<ResolverInputTypes["ReportNavigationLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ReportNavigationLocaleUpsertResult']?: Omit<ResolverInputTypes["ReportNavigationLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SentPaymentCreateResult']?: Omit<ResolverInputTypes["SentPaymentCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SentPaymentDeleteResult']?: Omit<ResolverInputTypes["SentPaymentDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SentPaymentUpdateResult']?: Omit<ResolverInputTypes["SentPaymentUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SentPaymentUpsertResult']?: Omit<ResolverInputTypes["SentPaymentUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on NotificationTargetGroupCreateResult']?: Omit<ResolverInputTypes["NotificationTargetGroupCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on NotificationTargetGroupDeleteResult']?: Omit<ResolverInputTypes["NotificationTargetGroupDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on NotificationTargetGroupUpdateResult']?: Omit<ResolverInputTypes["NotificationTargetGroupUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on NotificationTargetGroupUpsertResult']?: Omit<ResolverInputTypes["NotificationTargetGroupUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ProcessedNotificationCreateResult']?: Omit<ResolverInputTypes["ProcessedNotificationCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ProcessedNotificationDeleteResult']?: Omit<ResolverInputTypes["ProcessedNotificationDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ProcessedNotificationUpdateResult']?: Omit<ResolverInputTypes["ProcessedNotificationUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ProcessedNotificationUpsertResult']?: Omit<ResolverInputTypes["ProcessedNotificationUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ScheduledNotificationCreateResult']?: Omit<ResolverInputTypes["ScheduledNotificationCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ScheduledNotificationDeleteResult']?: Omit<ResolverInputTypes["ScheduledNotificationDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ScheduledNotificationUpdateResult']?: Omit<ResolverInputTypes["ScheduledNotificationUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ScheduledNotificationUpsertResult']?: Omit<ResolverInputTypes["ScheduledNotificationUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ProcessedNotificationSourceCreateResult']?: Omit<ResolverInputTypes["ProcessedNotificationSourceCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ProcessedNotificationSourceDeleteResult']?: Omit<ResolverInputTypes["ProcessedNotificationSourceDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ProcessedNotificationSourceUpdateResult']?: Omit<ResolverInputTypes["ProcessedNotificationSourceUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ProcessedNotificationSourceUpsertResult']?: Omit<ResolverInputTypes["ProcessedNotificationSourceUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DeviceCreateResult']?: Omit<ResolverInputTypes["DeviceCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DeviceDeleteResult']?: Omit<ResolverInputTypes["DeviceDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DeviceUpdateResult']?: Omit<ResolverInputTypes["DeviceUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on DeviceUpsertResult']?: Omit<ResolverInputTypes["DeviceUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ScheduledNotificationLocaleCreateResult']?: Omit<ResolverInputTypes["ScheduledNotificationLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ScheduledNotificationLocaleDeleteResult']?: Omit<ResolverInputTypes["ScheduledNotificationLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ScheduledNotificationLocaleUpdateResult']?: Omit<ResolverInputTypes["ScheduledNotificationLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ScheduledNotificationLocaleUpsertResult']?: Omit<ResolverInputTypes["ScheduledNotificationLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselItemLocaleCreateResult']?: Omit<ResolverInputTypes["InfoCarouselItemLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselItemLocaleDeleteResult']?: Omit<ResolverInputTypes["InfoCarouselItemLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselItemLocaleUpdateResult']?: Omit<ResolverInputTypes["InfoCarouselItemLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoCarouselItemLocaleUpsertResult']?: Omit<ResolverInputTypes["InfoCarouselItemLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SentPaymentLocaleCreateResult']?: Omit<ResolverInputTypes["SentPaymentLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SentPaymentLocaleDeleteResult']?: Omit<ResolverInputTypes["SentPaymentLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SentPaymentLocaleUpdateResult']?: Omit<ResolverInputTypes["SentPaymentLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SentPaymentLocaleUpsertResult']?: Omit<ResolverInputTypes["SentPaymentLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextImageListCreateResult']?: Omit<ResolverInputTypes["TextImageListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextImageListDeleteResult']?: Omit<ResolverInputTypes["TextImageListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextImageListUpdateResult']?: Omit<ResolverInputTypes["TextImageListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextImageListUpsertResult']?: Omit<ResolverInputTypes["TextImageListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextImageListItemCreateResult']?: Omit<ResolverInputTypes["TextImageListItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextImageListItemDeleteResult']?: Omit<ResolverInputTypes["TextImageListItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextImageListItemUpdateResult']?: Omit<ResolverInputTypes["TextImageListItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextImageListItemUpsertResult']?: Omit<ResolverInputTypes["TextImageListItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeroCarouselItemCreateResult']?: Omit<ResolverInputTypes["HeroCarouselItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeroCarouselItemDeleteResult']?: Omit<ResolverInputTypes["HeroCarouselItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeroCarouselItemUpdateResult']?: Omit<ResolverInputTypes["HeroCarouselItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeroCarouselItemUpsertResult']?: Omit<ResolverInputTypes["HeroCarouselItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		__typename?: boolean | `@${string}`
}>;
	["_MutationError"]: AliasType<{
	path?:ResolverInputTypes["_PathFragment"],
	paths?:ResolverInputTypes["_PathFragment"],
	type?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["GeneralDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["General"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["General"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["General"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Image"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Image"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Image"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPage"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Linkable"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Linkable"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Linkable"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Seo"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Seo"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Seo"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Content"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Content"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Content"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentBlock"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentBlock"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentBlock"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentReference"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentReference"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentReference"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GeneralLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GeneralLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GeneralLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GeneralLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Locale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Locale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Locale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Video"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Video"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Video"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Link"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Link"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Link"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Post"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Post"],
		__typename?: boolean | `@${string}`
}>;
	["PostUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Post"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Post"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostArea"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostArea"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostArea"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostArea"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganization"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganization"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganization"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganization"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Donation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Donation"],
		__typename?: boolean | `@${string}`
}>;
	["DonationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Donation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Donation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountItem"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountsRegionItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountsRegionItem"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountsRegionItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountsRegionItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountsRegionList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountsRegionList"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountsRegionList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DonationAmountsRegionListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["DonationAmountsRegionList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Region"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Region"],
		__typename?: boolean | `@${string}`
}>;
	["RegionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Region"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Region"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["LinkItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["LinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["LinkItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["LinkItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["LinkList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["LinkList"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["LinkList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["LinkList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Header"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Header"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Header"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Header"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeaderLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeaderLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeaderLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeaderLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Footer"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Footer"],
		__typename?: boolean | `@${string}`
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Footer"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Footer"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostList"],
		__typename?: boolean | `@${string}`
}>;
	["PostListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostListItem"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["AppBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["AppBanner"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["AppBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AppBannerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["AppBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutSettings"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutSettings"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutSettings"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutSettings"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutSettingsLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutSettingsLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutSettingsLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutSettingsLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutSettingsLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Value"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Value"],
		__typename?: boolean | `@${string}`
}>;
	["ValueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Value"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Value"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ValueItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ValueItem"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ValueItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ValueItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ValueList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ValueList"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ValueList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ValueListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ValueList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLink"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLink"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLink"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLink"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLinkItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLinkItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLinkItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLinkList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLinkList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLinkList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageLinkListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageLinkList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaList"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaListItem"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostAreaListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostAreaListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Accordion"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Accordion"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Accordion"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Accordion"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["AccordionItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["AccordionItem"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["AccordionItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AccordionItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["AccordionItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["User"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["UserUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["User"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["User"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPayment"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Currency"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Currency"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Currency"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CurrencyUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Currency"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Medium"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Medium"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Medium"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumItem"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumList"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPaymentOrderId"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPaymentOrderId"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPaymentOrderId"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentOrderIdUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPaymentOrderId"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostRevision"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostRevision"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostRevision"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostRevision"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserRecurringPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserRecurringPayment"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserRecurringPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserRecurringPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserRecurringPaymentItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserRecurringPaymentItem"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserRecurringPaymentItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserRecurringPaymentItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserRecurringPaymentItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostRevisionLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostRevisionLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostRevisionLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostRevisionLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostRevisionLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationCatalogue"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationCatalogue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationCatalogue"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationCatalogue"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationCataloguesIdentifier"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationCataloguesIdentifier"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationCataloguesIdentifier"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationCataloguesIdentifier"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationDomain"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationDomain"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationDomain"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationDomain"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationKey"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationKey"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationKey"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationKey"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationValue"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationValue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationValue"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationValue"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutGroupLinksLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutGroupLinksLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutGroupLinksLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageAboutGroupLinksLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageAboutGroupLinksLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MemberList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MemberList"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MemberList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MemberList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MemberListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MemberListItem"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MemberListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MemberListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MemberListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FilledTaxForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FilledTaxForm"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FilledTaxForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FilledTaxForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FilledTaxFormEmailAddress"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FilledTaxFormEmailAddress"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FilledTaxFormEmailAddress"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FilledTaxFormEmailAddressUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FilledTaxFormEmailAddress"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Form"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Form"],
		__typename?: boolean | `@${string}`
}>;
	["FormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Form"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Form"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CsobPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CsobPayment"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CsobPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CsobPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CsobPaymentStatusChange"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CsobPaymentStatusChange"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CsobPaymentStatusChange"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CsobPaymentStatusChangeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CsobPaymentStatusChange"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StripePayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StripePayment"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StripePayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StripePayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StripePaymentStatusChange"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StripePaymentStatusChange"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StripePaymentStatusChange"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StripePaymentStatusChangeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StripePaymentStatusChange"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RegionPaymentMethod"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RegionPaymentMethod"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RegionPaymentMethod"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RegionPaymentMethodUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RegionPaymentMethod"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TileItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TileItem"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TileItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TileItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TileList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TileList"],
		__typename?: boolean | `@${string}`
}>;
	["TileListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TileList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TileList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPage"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageSection"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageSection"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageSection"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageSectionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageSection"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageTileStripe"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageTileStripe"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageTileStripe"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FeedPageTileStripeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FeedPageTileStripe"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CardItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CardItem"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CardItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CardItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CardList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CardList"],
		__typename?: boolean | `@${string}`
}>;
	["CardListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CardList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CardListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CardList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["OnBehalfDonation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["OnBehalfDonation"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["OnBehalfDonation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OnBehalfDonationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["OnBehalfDonation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPaymentTriesCollection"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPaymentTriesCollection"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPaymentTriesCollection"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserPaymentTriesCollectionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["UserPaymentTriesCollection"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecurringPaymentPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecurringPaymentPage"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecurringPaymentPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecurringPaymentPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecurringPaymentPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecurringPaymentPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecurringPaymentPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecurringPaymentPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecurringPaymentPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuide"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuide"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuide"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuide"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuideItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuideItem"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuideItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuideItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuideList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuideList"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuideList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoryGuideListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StoryGuideList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeroCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeroCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeroCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeroCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationList"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationListItem"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PostOrganizationListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PostOrganizationListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PersonSeenInfoCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PersonSeenInfoCarousel"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PersonSeenInfoCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PersonSeenInfoCarouselUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["PersonSeenInfoCarousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GivenGiftsPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GivenGiftsPage"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GivenGiftsPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GivenGiftsPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GivenGiftsPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GivenGiftsPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GivenGiftsPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GivenGiftsPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GivenGiftsPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReceivedGiftsPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReceivedGiftsPage"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReceivedGiftsPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReceivedGiftsPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReceivedGiftsPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReceivedGiftsPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReceivedGiftsPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReceivedGiftsPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReceivedGiftsPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportNavigation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportNavigation"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportNavigation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportNavigation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportPage"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportNavigationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportNavigationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportNavigationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ReportNavigationLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ReportNavigationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SentPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SentPayment"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SentPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SentPayment"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["NotificationTargetGroup"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["NotificationTargetGroup"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["NotificationTargetGroup"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NotificationTargetGroupUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["NotificationTargetGroup"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ProcessedNotification"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ProcessedNotification"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ProcessedNotification"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ProcessedNotification"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ScheduledNotification"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ScheduledNotification"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ScheduledNotification"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ScheduledNotification"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ProcessedNotificationSource"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ProcessedNotificationSource"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ProcessedNotificationSource"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProcessedNotificationSourceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ProcessedNotificationSource"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Device"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Device"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Device"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Device"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ScheduledNotificationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ScheduledNotificationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ScheduledNotificationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ScheduledNotificationLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ScheduledNotificationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarouselItemLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarouselItemLocale"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarouselItemLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoCarouselItemLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoCarouselItemLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SentPaymentLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SentPaymentLocale"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SentPaymentLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SentPaymentLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SentPaymentLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextImageList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextImageList"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextImageList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextImageList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextImageListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextImageListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextImageListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextImageListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeroCarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeroCarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeroCarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCarouselItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeroCarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransaction"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	validation?:ResolverInputTypes["_ValidationResult"],
generateUploadUrl?: [{	input?: ResolverInputTypes["S3GenerateSignedUploadInput"] | undefined | null},ResolverInputTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string,	expiration?: number | undefined | null},ResolverInputTypes["S3SignedRead"]],
createGeneral?: [{	data: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["GeneralCreateResult"]],
deleteGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["GeneralDeleteResult"]],
updateGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	data: ResolverInputTypes["GeneralUpdateInput"]},ResolverInputTypes["GeneralUpdateResult"]],
upsertGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	update: ResolverInputTypes["GeneralUpdateInput"],	create: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["GeneralUpsertResult"]],
createImage?: [{	data: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["ImageCreateResult"]],
deleteImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["ImageDeleteResult"]],
updateImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	data: ResolverInputTypes["ImageUpdateInput"]},ResolverInputTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	update: ResolverInputTypes["ImageUpdateInput"],	create: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["ImageUpsertResult"]],
createGenericPage?: [{	data: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageUpdateInput"]},ResolverInputTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageUpdateInput"],	create: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	data: ResolverInputTypes["LinkableUpdateInput"]},ResolverInputTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	update: ResolverInputTypes["LinkableUpdateInput"],	create: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["LinkableUpsertResult"]],
createSeo?: [{	data: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	data: ResolverInputTypes["SeoUpdateInput"]},ResolverInputTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	update: ResolverInputTypes["SeoUpdateInput"],	create: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["SeoUpsertResult"]],
createContent?: [{	data: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["ContentCreateResult"]],
deleteContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["ContentDeleteResult"]],
updateContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	data: ResolverInputTypes["ContentUpdateInput"]},ResolverInputTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	update: ResolverInputTypes["ContentUpdateInput"],	create: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	data: ResolverInputTypes["ContentBlockUpdateInput"]},ResolverInputTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	update: ResolverInputTypes["ContentBlockUpdateInput"],	create: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	data: ResolverInputTypes["ContentReferenceUpdateInput"]},ResolverInputTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	update: ResolverInputTypes["ContentReferenceUpdateInput"],	create: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["ContentReferenceUpsertResult"]],
createGeneralLocale?: [{	data: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["GeneralLocaleCreateResult"]],
deleteGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocaleDeleteResult"]],
updateGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GeneralLocaleUpdateInput"]},ResolverInputTypes["GeneralLocaleUpdateResult"]],
upsertGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GeneralLocaleUpdateInput"],	create: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["GeneralLocaleUpsertResult"]],
createGenericPageLocale?: [{	data: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["GenericPageLocaleCreateResult"]],
deleteGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocaleDeleteResult"]],
updateGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageLocaleUpdateInput"]},ResolverInputTypes["GenericPageLocaleUpdateResult"]],
upsertGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageLocaleUpdateInput"],	create: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["GenericPageLocaleUpsertResult"]],
createLocale?: [{	data: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	data: ResolverInputTypes["LocaleUpdateInput"]},ResolverInputTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	update: ResolverInputTypes["LocaleUpdateInput"],	create: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["LocaleUpsertResult"]],
createVideo?: [{	data: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	data: ResolverInputTypes["VideoUpdateInput"]},ResolverInputTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	update: ResolverInputTypes["VideoUpdateInput"],	create: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["VideoUpsertResult"]],
createLink?: [{	data: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["LinkCreateResult"]],
deleteLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["LinkDeleteResult"]],
updateLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	data: ResolverInputTypes["LinkUpdateInput"]},ResolverInputTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	update: ResolverInputTypes["LinkUpdateInput"],	create: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["LinkUpsertResult"]],
createPost?: [{	data: ResolverInputTypes["PostCreateInput"]},ResolverInputTypes["PostCreateResult"]],
deletePost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null},ResolverInputTypes["PostDeleteResult"]],
updatePost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	data: ResolverInputTypes["PostUpdateInput"]},ResolverInputTypes["PostUpdateResult"]],
upsertPost?: [{	by: ResolverInputTypes["PostUniqueWhere"],	filter?: ResolverInputTypes["PostWhere"] | undefined | null,	update: ResolverInputTypes["PostUpdateInput"],	create: ResolverInputTypes["PostCreateInput"]},ResolverInputTypes["PostUpsertResult"]],
createPostLocale?: [{	data: ResolverInputTypes["PostLocaleCreateInput"]},ResolverInputTypes["PostLocaleCreateResult"]],
deletePostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null},ResolverInputTypes["PostLocaleDeleteResult"]],
updatePostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	data: ResolverInputTypes["PostLocaleUpdateInput"]},ResolverInputTypes["PostLocaleUpdateResult"]],
upsertPostLocale?: [{	by: ResolverInputTypes["PostLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostLocaleWhere"] | undefined | null,	update: ResolverInputTypes["PostLocaleUpdateInput"],	create: ResolverInputTypes["PostLocaleCreateInput"]},ResolverInputTypes["PostLocaleUpsertResult"]],
createPostArea?: [{	data: ResolverInputTypes["PostAreaCreateInput"]},ResolverInputTypes["PostAreaCreateResult"]],
deletePostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null},ResolverInputTypes["PostAreaDeleteResult"]],
updatePostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null,	data: ResolverInputTypes["PostAreaUpdateInput"]},ResolverInputTypes["PostAreaUpdateResult"]],
upsertPostArea?: [{	by: ResolverInputTypes["PostAreaUniqueWhere"],	filter?: ResolverInputTypes["PostAreaWhere"] | undefined | null,	update: ResolverInputTypes["PostAreaUpdateInput"],	create: ResolverInputTypes["PostAreaCreateInput"]},ResolverInputTypes["PostAreaUpsertResult"]],
createPostAreaLocale?: [{	data: ResolverInputTypes["PostAreaLocaleCreateInput"]},ResolverInputTypes["PostAreaLocaleCreateResult"]],
deletePostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null},ResolverInputTypes["PostAreaLocaleDeleteResult"]],
updatePostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	data: ResolverInputTypes["PostAreaLocaleUpdateInput"]},ResolverInputTypes["PostAreaLocaleUpdateResult"]],
upsertPostAreaLocale?: [{	by: ResolverInputTypes["PostAreaLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostAreaLocaleWhere"] | undefined | null,	update: ResolverInputTypes["PostAreaLocaleUpdateInput"],	create: ResolverInputTypes["PostAreaLocaleCreateInput"]},ResolverInputTypes["PostAreaLocaleUpsertResult"]],
createPostOrganization?: [{	data: ResolverInputTypes["PostOrganizationCreateInput"]},ResolverInputTypes["PostOrganizationCreateResult"]],
deletePostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null},ResolverInputTypes["PostOrganizationDeleteResult"]],
updatePostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,	data: ResolverInputTypes["PostOrganizationUpdateInput"]},ResolverInputTypes["PostOrganizationUpdateResult"]],
upsertPostOrganization?: [{	by: ResolverInputTypes["PostOrganizationUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationWhere"] | undefined | null,	update: ResolverInputTypes["PostOrganizationUpdateInput"],	create: ResolverInputTypes["PostOrganizationCreateInput"]},ResolverInputTypes["PostOrganizationUpsertResult"]],
createPostOrganizationLocale?: [{	data: ResolverInputTypes["PostOrganizationLocaleCreateInput"]},ResolverInputTypes["PostOrganizationLocaleCreateResult"]],
deletePostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null},ResolverInputTypes["PostOrganizationLocaleDeleteResult"]],
updatePostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	data: ResolverInputTypes["PostOrganizationLocaleUpdateInput"]},ResolverInputTypes["PostOrganizationLocaleUpdateResult"]],
upsertPostOrganizationLocale?: [{	by: ResolverInputTypes["PostOrganizationLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationLocaleWhere"] | undefined | null,	update: ResolverInputTypes["PostOrganizationLocaleUpdateInput"],	create: ResolverInputTypes["PostOrganizationLocaleCreateInput"]},ResolverInputTypes["PostOrganizationLocaleUpsertResult"]],
createDonation?: [{	data: ResolverInputTypes["DonationCreateInput"]},ResolverInputTypes["DonationCreateResult"]],
deleteDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	filter?: ResolverInputTypes["DonationWhere"] | undefined | null},ResolverInputTypes["DonationDeleteResult"]],
updateDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	filter?: ResolverInputTypes["DonationWhere"] | undefined | null,	data: ResolverInputTypes["DonationUpdateInput"]},ResolverInputTypes["DonationUpdateResult"]],
upsertDonation?: [{	by: ResolverInputTypes["DonationUniqueWhere"],	filter?: ResolverInputTypes["DonationWhere"] | undefined | null,	update: ResolverInputTypes["DonationUpdateInput"],	create: ResolverInputTypes["DonationCreateInput"]},ResolverInputTypes["DonationUpsertResult"]],
createDonationAmountItem?: [{	data: ResolverInputTypes["DonationAmountItemCreateInput"]},ResolverInputTypes["DonationAmountItemCreateResult"]],
deleteDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountItemDeleteResult"]],
updateDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	data: ResolverInputTypes["DonationAmountItemUpdateInput"]},ResolverInputTypes["DonationAmountItemUpdateResult"]],
upsertDonationAmountItem?: [{	by: ResolverInputTypes["DonationAmountItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountItemWhere"] | undefined | null,	update: ResolverInputTypes["DonationAmountItemUpdateInput"],	create: ResolverInputTypes["DonationAmountItemCreateInput"]},ResolverInputTypes["DonationAmountItemUpsertResult"]],
createDonationAmountsRegionItem?: [{	data: ResolverInputTypes["DonationAmountsRegionItemCreateInput"]},ResolverInputTypes["DonationAmountsRegionItemCreateResult"]],
deleteDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionItemDeleteResult"]],
updateDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	data: ResolverInputTypes["DonationAmountsRegionItemUpdateInput"]},ResolverInputTypes["DonationAmountsRegionItemUpdateResult"]],
upsertDonationAmountsRegionItem?: [{	by: ResolverInputTypes["DonationAmountsRegionItemUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionItemWhere"] | undefined | null,	update: ResolverInputTypes["DonationAmountsRegionItemUpdateInput"],	create: ResolverInputTypes["DonationAmountsRegionItemCreateInput"]},ResolverInputTypes["DonationAmountsRegionItemUpsertResult"]],
createDonationAmountsRegionList?: [{	data: ResolverInputTypes["DonationAmountsRegionListCreateInput"]},ResolverInputTypes["DonationAmountsRegionListCreateResult"]],
deleteDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null},ResolverInputTypes["DonationAmountsRegionListDeleteResult"]],
updateDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,	data: ResolverInputTypes["DonationAmountsRegionListUpdateInput"]},ResolverInputTypes["DonationAmountsRegionListUpdateResult"]],
upsertDonationAmountsRegionList?: [{	by: ResolverInputTypes["DonationAmountsRegionListUniqueWhere"],	filter?: ResolverInputTypes["DonationAmountsRegionListWhere"] | undefined | null,	update: ResolverInputTypes["DonationAmountsRegionListUpdateInput"],	create: ResolverInputTypes["DonationAmountsRegionListCreateInput"]},ResolverInputTypes["DonationAmountsRegionListUpsertResult"]],
createRegion?: [{	data: ResolverInputTypes["RegionCreateInput"]},ResolverInputTypes["RegionCreateResult"]],
deleteRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	filter?: ResolverInputTypes["RegionWhere"] | undefined | null},ResolverInputTypes["RegionDeleteResult"]],
updateRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	data: ResolverInputTypes["RegionUpdateInput"]},ResolverInputTypes["RegionUpdateResult"]],
upsertRegion?: [{	by: ResolverInputTypes["RegionUniqueWhere"],	filter?: ResolverInputTypes["RegionWhere"] | undefined | null,	update: ResolverInputTypes["RegionUpdateInput"],	create: ResolverInputTypes["RegionCreateInput"]},ResolverInputTypes["RegionUpsertResult"]],
createLinkItem?: [{	data: ResolverInputTypes["LinkItemCreateInput"]},ResolverInputTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null},ResolverInputTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	data: ResolverInputTypes["LinkItemUpdateInput"]},ResolverInputTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by: ResolverInputTypes["LinkItemUniqueWhere"],	filter?: ResolverInputTypes["LinkItemWhere"] | undefined | null,	update: ResolverInputTypes["LinkItemUpdateInput"],	create: ResolverInputTypes["LinkItemCreateInput"]},ResolverInputTypes["LinkItemUpsertResult"]],
createLinkList?: [{	data: ResolverInputTypes["LinkListCreateInput"]},ResolverInputTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null},ResolverInputTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null,	data: ResolverInputTypes["LinkListUpdateInput"]},ResolverInputTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by: ResolverInputTypes["LinkListUniqueWhere"],	filter?: ResolverInputTypes["LinkListWhere"] | undefined | null,	update: ResolverInputTypes["LinkListUpdateInput"],	create: ResolverInputTypes["LinkListCreateInput"]},ResolverInputTypes["LinkListUpsertResult"]],
createHeader?: [{	data: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["HeaderCreateResult"]],
deleteHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["HeaderDeleteResult"]],
updateHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	data: ResolverInputTypes["HeaderUpdateInput"]},ResolverInputTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	update: ResolverInputTypes["HeaderUpdateInput"],	create: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["HeaderUpsertResult"]],
createHeaderLocale?: [{	data: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	data: ResolverInputTypes["HeaderLocaleUpdateInput"]},ResolverInputTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	update: ResolverInputTypes["HeaderLocaleUpdateInput"],	create: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["HeaderLocaleUpsertResult"]],
createFooter?: [{	data: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["FooterCreateResult"]],
deleteFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["FooterDeleteResult"]],
updateFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	data: ResolverInputTypes["FooterUpdateInput"]},ResolverInputTypes["FooterUpdateResult"]],
upsertFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	update: ResolverInputTypes["FooterUpdateInput"],	create: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["FooterUpsertResult"]],
createFooterLocale?: [{	data: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	data: ResolverInputTypes["FooterLocaleUpdateInput"]},ResolverInputTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	update: ResolverInputTypes["FooterLocaleUpdateInput"],	create: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["FooterLocaleUpsertResult"]],
createPostList?: [{	data: ResolverInputTypes["PostListCreateInput"]},ResolverInputTypes["PostListCreateResult"]],
deletePostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	filter?: ResolverInputTypes["PostListWhere"] | undefined | null},ResolverInputTypes["PostListDeleteResult"]],
updatePostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	filter?: ResolverInputTypes["PostListWhere"] | undefined | null,	data: ResolverInputTypes["PostListUpdateInput"]},ResolverInputTypes["PostListUpdateResult"]],
upsertPostList?: [{	by: ResolverInputTypes["PostListUniqueWhere"],	filter?: ResolverInputTypes["PostListWhere"] | undefined | null,	update: ResolverInputTypes["PostListUpdateInput"],	create: ResolverInputTypes["PostListCreateInput"]},ResolverInputTypes["PostListUpsertResult"]],
createPostListItem?: [{	data: ResolverInputTypes["PostListItemCreateInput"]},ResolverInputTypes["PostListItemCreateResult"]],
deletePostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null},ResolverInputTypes["PostListItemDeleteResult"]],
updatePostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	data: ResolverInputTypes["PostListItemUpdateInput"]},ResolverInputTypes["PostListItemUpdateResult"]],
upsertPostListItem?: [{	by: ResolverInputTypes["PostListItemUniqueWhere"],	filter?: ResolverInputTypes["PostListItemWhere"] | undefined | null,	update: ResolverInputTypes["PostListItemUpdateInput"],	create: ResolverInputTypes["PostListItemCreateInput"]},ResolverInputTypes["PostListItemUpsertResult"]],
createAppBanner?: [{	data: ResolverInputTypes["AppBannerCreateInput"]},ResolverInputTypes["AppBannerCreateResult"]],
deleteAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null},ResolverInputTypes["AppBannerDeleteResult"]],
updateAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null,	data: ResolverInputTypes["AppBannerUpdateInput"]},ResolverInputTypes["AppBannerUpdateResult"]],
upsertAppBanner?: [{	by: ResolverInputTypes["AppBannerUniqueWhere"],	filter?: ResolverInputTypes["AppBannerWhere"] | undefined | null,	update: ResolverInputTypes["AppBannerUpdateInput"],	create: ResolverInputTypes["AppBannerCreateInput"]},ResolverInputTypes["AppBannerUpsertResult"]],
createGenericPageAboutSettings?: [{	data: ResolverInputTypes["GenericPageAboutSettingsCreateInput"]},ResolverInputTypes["GenericPageAboutSettingsCreateResult"]],
deleteGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsDeleteResult"]],
updateGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageAboutSettingsUpdateInput"]},ResolverInputTypes["GenericPageAboutSettingsUpdateResult"]],
upsertGenericPageAboutSettings?: [{	by: ResolverInputTypes["GenericPageAboutSettingsUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageAboutSettingsUpdateInput"],	create: ResolverInputTypes["GenericPageAboutSettingsCreateInput"]},ResolverInputTypes["GenericPageAboutSettingsUpsertResult"]],
createGenericPageAboutSettingsLocale?: [{	data: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateInput"]},ResolverInputTypes["GenericPageAboutSettingsLocaleCreateResult"]],
deleteGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutSettingsLocaleDeleteResult"]],
updateGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateInput"]},ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateResult"]],
upsertGenericPageAboutSettingsLocale?: [{	by: ResolverInputTypes["GenericPageAboutSettingsLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutSettingsLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageAboutSettingsLocaleUpdateInput"],	create: ResolverInputTypes["GenericPageAboutSettingsLocaleCreateInput"]},ResolverInputTypes["GenericPageAboutSettingsLocaleUpsertResult"]],
createValue?: [{	data: ResolverInputTypes["ValueCreateInput"]},ResolverInputTypes["ValueCreateResult"]],
deleteValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	filter?: ResolverInputTypes["ValueWhere"] | undefined | null},ResolverInputTypes["ValueDeleteResult"]],
updateValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	filter?: ResolverInputTypes["ValueWhere"] | undefined | null,	data: ResolverInputTypes["ValueUpdateInput"]},ResolverInputTypes["ValueUpdateResult"]],
upsertValue?: [{	by: ResolverInputTypes["ValueUniqueWhere"],	filter?: ResolverInputTypes["ValueWhere"] | undefined | null,	update: ResolverInputTypes["ValueUpdateInput"],	create: ResolverInputTypes["ValueCreateInput"]},ResolverInputTypes["ValueUpsertResult"]],
createValueItem?: [{	data: ResolverInputTypes["ValueItemCreateInput"]},ResolverInputTypes["ValueItemCreateResult"]],
deleteValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null},ResolverInputTypes["ValueItemDeleteResult"]],
updateValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	data: ResolverInputTypes["ValueItemUpdateInput"]},ResolverInputTypes["ValueItemUpdateResult"]],
upsertValueItem?: [{	by: ResolverInputTypes["ValueItemUniqueWhere"],	filter?: ResolverInputTypes["ValueItemWhere"] | undefined | null,	update: ResolverInputTypes["ValueItemUpdateInput"],	create: ResolverInputTypes["ValueItemCreateInput"]},ResolverInputTypes["ValueItemUpsertResult"]],
createValueList?: [{	data: ResolverInputTypes["ValueListCreateInput"]},ResolverInputTypes["ValueListCreateResult"]],
deleteValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null},ResolverInputTypes["ValueListDeleteResult"]],
updateValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null,	data: ResolverInputTypes["ValueListUpdateInput"]},ResolverInputTypes["ValueListUpdateResult"]],
upsertValueList?: [{	by: ResolverInputTypes["ValueListUniqueWhere"],	filter?: ResolverInputTypes["ValueListWhere"] | undefined | null,	update: ResolverInputTypes["ValueListUpdateInput"],	create: ResolverInputTypes["ValueListCreateInput"]},ResolverInputTypes["ValueListUpsertResult"]],
createImageLink?: [{	data: ResolverInputTypes["ImageLinkCreateInput"]},ResolverInputTypes["ImageLinkCreateResult"]],
deleteImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null},ResolverInputTypes["ImageLinkDeleteResult"]],
updateImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,	data: ResolverInputTypes["ImageLinkUpdateInput"]},ResolverInputTypes["ImageLinkUpdateResult"]],
upsertImageLink?: [{	by: ResolverInputTypes["ImageLinkUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkWhere"] | undefined | null,	update: ResolverInputTypes["ImageLinkUpdateInput"],	create: ResolverInputTypes["ImageLinkCreateInput"]},ResolverInputTypes["ImageLinkUpsertResult"]],
createImageLinkItem?: [{	data: ResolverInputTypes["ImageLinkItemCreateInput"]},ResolverInputTypes["ImageLinkItemCreateResult"]],
deleteImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null},ResolverInputTypes["ImageLinkItemDeleteResult"]],
updateImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	data: ResolverInputTypes["ImageLinkItemUpdateInput"]},ResolverInputTypes["ImageLinkItemUpdateResult"]],
upsertImageLinkItem?: [{	by: ResolverInputTypes["ImageLinkItemUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkItemWhere"] | undefined | null,	update: ResolverInputTypes["ImageLinkItemUpdateInput"],	create: ResolverInputTypes["ImageLinkItemCreateInput"]},ResolverInputTypes["ImageLinkItemUpsertResult"]],
createImageLinkList?: [{	data: ResolverInputTypes["ImageLinkListCreateInput"]},ResolverInputTypes["ImageLinkListCreateResult"]],
deleteImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null},ResolverInputTypes["ImageLinkListDeleteResult"]],
updateImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,	data: ResolverInputTypes["ImageLinkListUpdateInput"]},ResolverInputTypes["ImageLinkListUpdateResult"]],
upsertImageLinkList?: [{	by: ResolverInputTypes["ImageLinkListUniqueWhere"],	filter?: ResolverInputTypes["ImageLinkListWhere"] | undefined | null,	update: ResolverInputTypes["ImageLinkListUpdateInput"],	create: ResolverInputTypes["ImageLinkListCreateInput"]},ResolverInputTypes["ImageLinkListUpsertResult"]],
createPostAreaList?: [{	data: ResolverInputTypes["PostAreaListCreateInput"]},ResolverInputTypes["PostAreaListCreateResult"]],
deletePostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null},ResolverInputTypes["PostAreaListDeleteResult"]],
updatePostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,	data: ResolverInputTypes["PostAreaListUpdateInput"]},ResolverInputTypes["PostAreaListUpdateResult"]],
upsertPostAreaList?: [{	by: ResolverInputTypes["PostAreaListUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListWhere"] | undefined | null,	update: ResolverInputTypes["PostAreaListUpdateInput"],	create: ResolverInputTypes["PostAreaListCreateInput"]},ResolverInputTypes["PostAreaListUpsertResult"]],
createPostAreaListItem?: [{	data: ResolverInputTypes["PostAreaListItemCreateInput"]},ResolverInputTypes["PostAreaListItemCreateResult"]],
deletePostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null},ResolverInputTypes["PostAreaListItemDeleteResult"]],
updatePostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	data: ResolverInputTypes["PostAreaListItemUpdateInput"]},ResolverInputTypes["PostAreaListItemUpdateResult"]],
upsertPostAreaListItem?: [{	by: ResolverInputTypes["PostAreaListItemUniqueWhere"],	filter?: ResolverInputTypes["PostAreaListItemWhere"] | undefined | null,	update: ResolverInputTypes["PostAreaListItemUpdateInput"],	create: ResolverInputTypes["PostAreaListItemCreateInput"]},ResolverInputTypes["PostAreaListItemUpsertResult"]],
createAccordion?: [{	data: ResolverInputTypes["AccordionCreateInput"]},ResolverInputTypes["AccordionCreateResult"]],
deleteAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null},ResolverInputTypes["AccordionDeleteResult"]],
updateAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null,	data: ResolverInputTypes["AccordionUpdateInput"]},ResolverInputTypes["AccordionUpdateResult"]],
upsertAccordion?: [{	by: ResolverInputTypes["AccordionUniqueWhere"],	filter?: ResolverInputTypes["AccordionWhere"] | undefined | null,	update: ResolverInputTypes["AccordionUpdateInput"],	create: ResolverInputTypes["AccordionCreateInput"]},ResolverInputTypes["AccordionUpsertResult"]],
createAccordionItem?: [{	data: ResolverInputTypes["AccordionItemCreateInput"]},ResolverInputTypes["AccordionItemCreateResult"]],
deleteAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null},ResolverInputTypes["AccordionItemDeleteResult"]],
updateAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	data: ResolverInputTypes["AccordionItemUpdateInput"]},ResolverInputTypes["AccordionItemUpdateResult"]],
upsertAccordionItem?: [{	by: ResolverInputTypes["AccordionItemUniqueWhere"],	filter?: ResolverInputTypes["AccordionItemWhere"] | undefined | null,	update: ResolverInputTypes["AccordionItemUpdateInput"],	create: ResolverInputTypes["AccordionItemCreateInput"]},ResolverInputTypes["AccordionItemUpsertResult"]],
createUser?: [{	data: ResolverInputTypes["UserCreateInput"]},ResolverInputTypes["UserCreateResult"]],
deleteUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	filter?: ResolverInputTypes["UserWhere"] | undefined | null},ResolverInputTypes["UserDeleteResult"]],
updateUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	filter?: ResolverInputTypes["UserWhere"] | undefined | null,	data: ResolverInputTypes["UserUpdateInput"]},ResolverInputTypes["UserUpdateResult"]],
upsertUser?: [{	by: ResolverInputTypes["UserUniqueWhere"],	filter?: ResolverInputTypes["UserWhere"] | undefined | null,	update: ResolverInputTypes["UserUpdateInput"],	create: ResolverInputTypes["UserCreateInput"]},ResolverInputTypes["UserUpsertResult"]],
createUserPayment?: [{	data: ResolverInputTypes["UserPaymentCreateInput"]},ResolverInputTypes["UserPaymentCreateResult"]],
deleteUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null},ResolverInputTypes["UserPaymentDeleteResult"]],
updateUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	data: ResolverInputTypes["UserPaymentUpdateInput"]},ResolverInputTypes["UserPaymentUpdateResult"]],
upsertUserPayment?: [{	by: ResolverInputTypes["UserPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentWhere"] | undefined | null,	update: ResolverInputTypes["UserPaymentUpdateInput"],	create: ResolverInputTypes["UserPaymentCreateInput"]},ResolverInputTypes["UserPaymentUpsertResult"]],
createCurrency?: [{	data: ResolverInputTypes["CurrencyCreateInput"]},ResolverInputTypes["CurrencyCreateResult"]],
deleteCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null},ResolverInputTypes["CurrencyDeleteResult"]],
updateCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null,	data: ResolverInputTypes["CurrencyUpdateInput"]},ResolverInputTypes["CurrencyUpdateResult"]],
upsertCurrency?: [{	by: ResolverInputTypes["CurrencyUniqueWhere"],	filter?: ResolverInputTypes["CurrencyWhere"] | undefined | null,	update: ResolverInputTypes["CurrencyUpdateInput"],	create: ResolverInputTypes["CurrencyCreateInput"]},ResolverInputTypes["CurrencyUpsertResult"]],
createMedium?: [{	data: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	data: ResolverInputTypes["MediumUpdateInput"]},ResolverInputTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	update: ResolverInputTypes["MediumUpdateInput"],	create: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["MediumUpsertResult"]],
createMediumItem?: [{	data: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null},ResolverInputTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	data: ResolverInputTypes["MediumItemUpdateInput"]},ResolverInputTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	update: ResolverInputTypes["MediumItemUpdateInput"],	create: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	data: ResolverInputTypes["MediumListUpdateInput"]},ResolverInputTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	update: ResolverInputTypes["MediumListUpdateInput"],	create: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["MediumListUpsertResult"]],
createUserPaymentOrderId?: [{	data: ResolverInputTypes["UserPaymentOrderIdCreateInput"]},ResolverInputTypes["UserPaymentOrderIdCreateResult"]],
deleteUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null},ResolverInputTypes["UserPaymentOrderIdDeleteResult"]],
updateUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,	data: ResolverInputTypes["UserPaymentOrderIdUpdateInput"]},ResolverInputTypes["UserPaymentOrderIdUpdateResult"]],
upsertUserPaymentOrderId?: [{	by: ResolverInputTypes["UserPaymentOrderIdUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentOrderIdWhere"] | undefined | null,	update: ResolverInputTypes["UserPaymentOrderIdUpdateInput"],	create: ResolverInputTypes["UserPaymentOrderIdCreateInput"]},ResolverInputTypes["UserPaymentOrderIdUpsertResult"]],
createPostRevision?: [{	data: ResolverInputTypes["PostRevisionCreateInput"]},ResolverInputTypes["PostRevisionCreateResult"]],
deletePostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null},ResolverInputTypes["PostRevisionDeleteResult"]],
updatePostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	data: ResolverInputTypes["PostRevisionUpdateInput"]},ResolverInputTypes["PostRevisionUpdateResult"]],
upsertPostRevision?: [{	by: ResolverInputTypes["PostRevisionUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionWhere"] | undefined | null,	update: ResolverInputTypes["PostRevisionUpdateInput"],	create: ResolverInputTypes["PostRevisionCreateInput"]},ResolverInputTypes["PostRevisionUpsertResult"]],
createUserRecurringPayment?: [{	data: ResolverInputTypes["UserRecurringPaymentCreateInput"]},ResolverInputTypes["UserRecurringPaymentCreateResult"]],
deleteUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentDeleteResult"]],
updateUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	data: ResolverInputTypes["UserRecurringPaymentUpdateInput"]},ResolverInputTypes["UserRecurringPaymentUpdateResult"]],
upsertUserRecurringPayment?: [{	by: ResolverInputTypes["UserRecurringPaymentUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentWhere"] | undefined | null,	update: ResolverInputTypes["UserRecurringPaymentUpdateInput"],	create: ResolverInputTypes["UserRecurringPaymentCreateInput"]},ResolverInputTypes["UserRecurringPaymentUpsertResult"]],
createUserRecurringPaymentItem?: [{	data: ResolverInputTypes["UserRecurringPaymentItemCreateInput"]},ResolverInputTypes["UserRecurringPaymentItemCreateResult"]],
deleteUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null},ResolverInputTypes["UserRecurringPaymentItemDeleteResult"]],
updateUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	data: ResolverInputTypes["UserRecurringPaymentItemUpdateInput"]},ResolverInputTypes["UserRecurringPaymentItemUpdateResult"]],
upsertUserRecurringPaymentItem?: [{	by: ResolverInputTypes["UserRecurringPaymentItemUniqueWhere"],	filter?: ResolverInputTypes["UserRecurringPaymentItemWhere"] | undefined | null,	update: ResolverInputTypes["UserRecurringPaymentItemUpdateInput"],	create: ResolverInputTypes["UserRecurringPaymentItemCreateInput"]},ResolverInputTypes["UserRecurringPaymentItemUpsertResult"]],
createPostRevisionLocale?: [{	data: ResolverInputTypes["PostRevisionLocaleCreateInput"]},ResolverInputTypes["PostRevisionLocaleCreateResult"]],
deletePostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null},ResolverInputTypes["PostRevisionLocaleDeleteResult"]],
updatePostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	data: ResolverInputTypes["PostRevisionLocaleUpdateInput"]},ResolverInputTypes["PostRevisionLocaleUpdateResult"]],
upsertPostRevisionLocale?: [{	by: ResolverInputTypes["PostRevisionLocaleUniqueWhere"],	filter?: ResolverInputTypes["PostRevisionLocaleWhere"] | undefined | null,	update: ResolverInputTypes["PostRevisionLocaleUpdateInput"],	create: ResolverInputTypes["PostRevisionLocaleCreateInput"]},ResolverInputTypes["PostRevisionLocaleUpsertResult"]],
createTranslationCatalogue?: [{	data: ResolverInputTypes["TranslationCatalogueCreateInput"]},ResolverInputTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null},ResolverInputTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	data: ResolverInputTypes["TranslationCatalogueUpdateInput"]},ResolverInputTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by: ResolverInputTypes["TranslationCatalogueUniqueWhere"],	filter?: ResolverInputTypes["TranslationCatalogueWhere"] | undefined | null,	update: ResolverInputTypes["TranslationCatalogueUpdateInput"],	create: ResolverInputTypes["TranslationCatalogueCreateInput"]},ResolverInputTypes["TranslationCatalogueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data: ResolverInputTypes["TranslationCataloguesIdentifierCreateInput"]},ResolverInputTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ResolverInputTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	data: ResolverInputTypes["TranslationCataloguesIdentifierUpdateInput"]},ResolverInputTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by: ResolverInputTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ResolverInputTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	update: ResolverInputTypes["TranslationCataloguesIdentifierUpdateInput"],	create: ResolverInputTypes["TranslationCataloguesIdentifierCreateInput"]},ResolverInputTypes["TranslationCataloguesIdentifierUpsertResult"]],
createTranslationDomain?: [{	data: ResolverInputTypes["TranslationDomainCreateInput"]},ResolverInputTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null},ResolverInputTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,	data: ResolverInputTypes["TranslationDomainUpdateInput"]},ResolverInputTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by: ResolverInputTypes["TranslationDomainUniqueWhere"],	filter?: ResolverInputTypes["TranslationDomainWhere"] | undefined | null,	update: ResolverInputTypes["TranslationDomainUpdateInput"],	create: ResolverInputTypes["TranslationDomainCreateInput"]},ResolverInputTypes["TranslationDomainUpsertResult"]],
createTranslationKey?: [{	data: ResolverInputTypes["TranslationKeyCreateInput"]},ResolverInputTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null},ResolverInputTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	data: ResolverInputTypes["TranslationKeyUpdateInput"]},ResolverInputTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by: ResolverInputTypes["TranslationKeyUniqueWhere"],	filter?: ResolverInputTypes["TranslationKeyWhere"] | undefined | null,	update: ResolverInputTypes["TranslationKeyUpdateInput"],	create: ResolverInputTypes["TranslationKeyCreateInput"]},ResolverInputTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data: ResolverInputTypes["TranslationValueCreateInput"]},ResolverInputTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null},ResolverInputTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	data: ResolverInputTypes["TranslationValueUpdateInput"]},ResolverInputTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by: ResolverInputTypes["TranslationValueUniqueWhere"],	filter?: ResolverInputTypes["TranslationValueWhere"] | undefined | null,	update: ResolverInputTypes["TranslationValueUpdateInput"],	create: ResolverInputTypes["TranslationValueCreateInput"]},ResolverInputTypes["TranslationValueUpsertResult"]],
createGenericPageAboutGroupLinksLocale?: [{	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateInput"]},ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateResult"]],
deleteGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageAboutGroupLinksLocaleDeleteResult"]],
updateGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateInput"]},ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateResult"]],
upsertGenericPageAboutGroupLinksLocale?: [{	by: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpdateInput"],	create: ResolverInputTypes["GenericPageAboutGroupLinksLocaleCreateInput"]},ResolverInputTypes["GenericPageAboutGroupLinksLocaleUpsertResult"]],
createMemberList?: [{	data: ResolverInputTypes["MemberListCreateInput"]},ResolverInputTypes["MemberListCreateResult"]],
deleteMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null},ResolverInputTypes["MemberListDeleteResult"]],
updateMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null,	data: ResolverInputTypes["MemberListUpdateInput"]},ResolverInputTypes["MemberListUpdateResult"]],
upsertMemberList?: [{	by: ResolverInputTypes["MemberListUniqueWhere"],	filter?: ResolverInputTypes["MemberListWhere"] | undefined | null,	update: ResolverInputTypes["MemberListUpdateInput"],	create: ResolverInputTypes["MemberListCreateInput"]},ResolverInputTypes["MemberListUpsertResult"]],
createMemberListItem?: [{	data: ResolverInputTypes["MemberListItemCreateInput"]},ResolverInputTypes["MemberListItemCreateResult"]],
deleteMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null},ResolverInputTypes["MemberListItemDeleteResult"]],
updateMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	data: ResolverInputTypes["MemberListItemUpdateInput"]},ResolverInputTypes["MemberListItemUpdateResult"]],
upsertMemberListItem?: [{	by: ResolverInputTypes["MemberListItemUniqueWhere"],	filter?: ResolverInputTypes["MemberListItemWhere"] | undefined | null,	update: ResolverInputTypes["MemberListItemUpdateInput"],	create: ResolverInputTypes["MemberListItemCreateInput"]},ResolverInputTypes["MemberListItemUpsertResult"]],
createFilledTaxForm?: [{	data: ResolverInputTypes["FilledTaxFormCreateInput"]},ResolverInputTypes["FilledTaxFormCreateResult"]],
deleteFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null},ResolverInputTypes["FilledTaxFormDeleteResult"]],
updateFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,	data: ResolverInputTypes["FilledTaxFormUpdateInput"]},ResolverInputTypes["FilledTaxFormUpdateResult"]],
upsertFilledTaxForm?: [{	by: ResolverInputTypes["FilledTaxFormUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormWhere"] | undefined | null,	update: ResolverInputTypes["FilledTaxFormUpdateInput"],	create: ResolverInputTypes["FilledTaxFormCreateInput"]},ResolverInputTypes["FilledTaxFormUpsertResult"]],
createFilledTaxFormEmailAddress?: [{	data: ResolverInputTypes["FilledTaxFormEmailAddressCreateInput"]},ResolverInputTypes["FilledTaxFormEmailAddressCreateResult"]],
deleteFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null},ResolverInputTypes["FilledTaxFormEmailAddressDeleteResult"]],
updateFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null,	data: ResolverInputTypes["FilledTaxFormEmailAddressUpdateInput"]},ResolverInputTypes["FilledTaxFormEmailAddressUpdateResult"]],
upsertFilledTaxFormEmailAddress?: [{	by: ResolverInputTypes["FilledTaxFormEmailAddressUniqueWhere"],	filter?: ResolverInputTypes["FilledTaxFormEmailAddressWhere"] | undefined | null,	update: ResolverInputTypes["FilledTaxFormEmailAddressUpdateInput"],	create: ResolverInputTypes["FilledTaxFormEmailAddressCreateInput"]},ResolverInputTypes["FilledTaxFormEmailAddressUpsertResult"]],
createForm?: [{	data: ResolverInputTypes["FormCreateInput"]},ResolverInputTypes["FormCreateResult"]],
deleteForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	filter?: ResolverInputTypes["FormWhere"] | undefined | null},ResolverInputTypes["FormDeleteResult"]],
updateForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	filter?: ResolverInputTypes["FormWhere"] | undefined | null,	data: ResolverInputTypes["FormUpdateInput"]},ResolverInputTypes["FormUpdateResult"]],
upsertForm?: [{	by: ResolverInputTypes["FormUniqueWhere"],	filter?: ResolverInputTypes["FormWhere"] | undefined | null,	update: ResolverInputTypes["FormUpdateInput"],	create: ResolverInputTypes["FormCreateInput"]},ResolverInputTypes["FormUpsertResult"]],
createCsobPayment?: [{	data: ResolverInputTypes["CsobPaymentCreateInput"]},ResolverInputTypes["CsobPaymentCreateResult"]],
deleteCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null},ResolverInputTypes["CsobPaymentDeleteResult"]],
updateCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,	data: ResolverInputTypes["CsobPaymentUpdateInput"]},ResolverInputTypes["CsobPaymentUpdateResult"]],
upsertCsobPayment?: [{	by: ResolverInputTypes["CsobPaymentUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentWhere"] | undefined | null,	update: ResolverInputTypes["CsobPaymentUpdateInput"],	create: ResolverInputTypes["CsobPaymentCreateInput"]},ResolverInputTypes["CsobPaymentUpsertResult"]],
createCsobPaymentStatusChange?: [{	data: ResolverInputTypes["CsobPaymentStatusChangeCreateInput"]},ResolverInputTypes["CsobPaymentStatusChangeCreateResult"]],
deleteCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null},ResolverInputTypes["CsobPaymentStatusChangeDeleteResult"]],
updateCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	data: ResolverInputTypes["CsobPaymentStatusChangeUpdateInput"]},ResolverInputTypes["CsobPaymentStatusChangeUpdateResult"]],
upsertCsobPaymentStatusChange?: [{	by: ResolverInputTypes["CsobPaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["CsobPaymentStatusChangeWhere"] | undefined | null,	update: ResolverInputTypes["CsobPaymentStatusChangeUpdateInput"],	create: ResolverInputTypes["CsobPaymentStatusChangeCreateInput"]},ResolverInputTypes["CsobPaymentStatusChangeUpsertResult"]],
createStripePayment?: [{	data: ResolverInputTypes["StripePaymentCreateInput"]},ResolverInputTypes["StripePaymentCreateResult"]],
deleteStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null},ResolverInputTypes["StripePaymentDeleteResult"]],
updateStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,	data: ResolverInputTypes["StripePaymentUpdateInput"]},ResolverInputTypes["StripePaymentUpdateResult"]],
upsertStripePayment?: [{	by: ResolverInputTypes["StripePaymentUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentWhere"] | undefined | null,	update: ResolverInputTypes["StripePaymentUpdateInput"],	create: ResolverInputTypes["StripePaymentCreateInput"]},ResolverInputTypes["StripePaymentUpsertResult"]],
createStripePaymentStatusChange?: [{	data: ResolverInputTypes["StripePaymentStatusChangeCreateInput"]},ResolverInputTypes["StripePaymentStatusChangeCreateResult"]],
deleteStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null},ResolverInputTypes["StripePaymentStatusChangeDeleteResult"]],
updateStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	data: ResolverInputTypes["StripePaymentStatusChangeUpdateInput"]},ResolverInputTypes["StripePaymentStatusChangeUpdateResult"]],
upsertStripePaymentStatusChange?: [{	by: ResolverInputTypes["StripePaymentStatusChangeUniqueWhere"],	filter?: ResolverInputTypes["StripePaymentStatusChangeWhere"] | undefined | null,	update: ResolverInputTypes["StripePaymentStatusChangeUpdateInput"],	create: ResolverInputTypes["StripePaymentStatusChangeCreateInput"]},ResolverInputTypes["StripePaymentStatusChangeUpsertResult"]],
createRegionPaymentMethod?: [{	data: ResolverInputTypes["RegionPaymentMethodCreateInput"]},ResolverInputTypes["RegionPaymentMethodCreateResult"]],
deleteRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null},ResolverInputTypes["RegionPaymentMethodDeleteResult"]],
updateRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	data: ResolverInputTypes["RegionPaymentMethodUpdateInput"]},ResolverInputTypes["RegionPaymentMethodUpdateResult"]],
upsertRegionPaymentMethod?: [{	by: ResolverInputTypes["RegionPaymentMethodUniqueWhere"],	filter?: ResolverInputTypes["RegionPaymentMethodWhere"] | undefined | null,	update: ResolverInputTypes["RegionPaymentMethodUpdateInput"],	create: ResolverInputTypes["RegionPaymentMethodCreateInput"]},ResolverInputTypes["RegionPaymentMethodUpsertResult"]],
createTileItem?: [{	data: ResolverInputTypes["TileItemCreateInput"]},ResolverInputTypes["TileItemCreateResult"]],
deleteTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null},ResolverInputTypes["TileItemDeleteResult"]],
updateTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	data: ResolverInputTypes["TileItemUpdateInput"]},ResolverInputTypes["TileItemUpdateResult"]],
upsertTileItem?: [{	by: ResolverInputTypes["TileItemUniqueWhere"],	filter?: ResolverInputTypes["TileItemWhere"] | undefined | null,	update: ResolverInputTypes["TileItemUpdateInput"],	create: ResolverInputTypes["TileItemCreateInput"]},ResolverInputTypes["TileItemUpsertResult"]],
createTileList?: [{	data: ResolverInputTypes["TileListCreateInput"]},ResolverInputTypes["TileListCreateResult"]],
deleteTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	filter?: ResolverInputTypes["TileListWhere"] | undefined | null},ResolverInputTypes["TileListDeleteResult"]],
updateTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	filter?: ResolverInputTypes["TileListWhere"] | undefined | null,	data: ResolverInputTypes["TileListUpdateInput"]},ResolverInputTypes["TileListUpdateResult"]],
upsertTileList?: [{	by: ResolverInputTypes["TileListUniqueWhere"],	filter?: ResolverInputTypes["TileListWhere"] | undefined | null,	update: ResolverInputTypes["TileListUpdateInput"],	create: ResolverInputTypes["TileListCreateInput"]},ResolverInputTypes["TileListUpsertResult"]],
createFeedPage?: [{	data: ResolverInputTypes["FeedPageCreateInput"]},ResolverInputTypes["FeedPageCreateResult"]],
deleteFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null},ResolverInputTypes["FeedPageDeleteResult"]],
updateFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null,	data: ResolverInputTypes["FeedPageUpdateInput"]},ResolverInputTypes["FeedPageUpdateResult"]],
upsertFeedPage?: [{	by: ResolverInputTypes["FeedPageUniqueWhere"],	filter?: ResolverInputTypes["FeedPageWhere"] | undefined | null,	update: ResolverInputTypes["FeedPageUpdateInput"],	create: ResolverInputTypes["FeedPageCreateInput"]},ResolverInputTypes["FeedPageUpsertResult"]],
createFeedPageLocale?: [{	data: ResolverInputTypes["FeedPageLocaleCreateInput"]},ResolverInputTypes["FeedPageLocaleCreateResult"]],
deleteFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null},ResolverInputTypes["FeedPageLocaleDeleteResult"]],
updateFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["FeedPageLocaleUpdateInput"]},ResolverInputTypes["FeedPageLocaleUpdateResult"]],
upsertFeedPageLocale?: [{	by: ResolverInputTypes["FeedPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["FeedPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["FeedPageLocaleUpdateInput"],	create: ResolverInputTypes["FeedPageLocaleCreateInput"]},ResolverInputTypes["FeedPageLocaleUpsertResult"]],
createFeedPageSection?: [{	data: ResolverInputTypes["FeedPageSectionCreateInput"]},ResolverInputTypes["FeedPageSectionCreateResult"]],
deleteFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null},ResolverInputTypes["FeedPageSectionDeleteResult"]],
updateFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	data: ResolverInputTypes["FeedPageSectionUpdateInput"]},ResolverInputTypes["FeedPageSectionUpdateResult"]],
upsertFeedPageSection?: [{	by: ResolverInputTypes["FeedPageSectionUniqueWhere"],	filter?: ResolverInputTypes["FeedPageSectionWhere"] | undefined | null,	update: ResolverInputTypes["FeedPageSectionUpdateInput"],	create: ResolverInputTypes["FeedPageSectionCreateInput"]},ResolverInputTypes["FeedPageSectionUpsertResult"]],
createFeedPageTileStripe?: [{	data: ResolverInputTypes["FeedPageTileStripeCreateInput"]},ResolverInputTypes["FeedPageTileStripeCreateResult"]],
deleteFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null},ResolverInputTypes["FeedPageTileStripeDeleteResult"]],
updateFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	data: ResolverInputTypes["FeedPageTileStripeUpdateInput"]},ResolverInputTypes["FeedPageTileStripeUpdateResult"]],
upsertFeedPageTileStripe?: [{	by: ResolverInputTypes["FeedPageTileStripeUniqueWhere"],	filter?: ResolverInputTypes["FeedPageTileStripeWhere"] | undefined | null,	update: ResolverInputTypes["FeedPageTileStripeUpdateInput"],	create: ResolverInputTypes["FeedPageTileStripeCreateInput"]},ResolverInputTypes["FeedPageTileStripeUpsertResult"]],
createCardItem?: [{	data: ResolverInputTypes["CardItemCreateInput"]},ResolverInputTypes["CardItemCreateResult"]],
deleteCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null},ResolverInputTypes["CardItemDeleteResult"]],
updateCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	data: ResolverInputTypes["CardItemUpdateInput"]},ResolverInputTypes["CardItemUpdateResult"]],
upsertCardItem?: [{	by: ResolverInputTypes["CardItemUniqueWhere"],	filter?: ResolverInputTypes["CardItemWhere"] | undefined | null,	update: ResolverInputTypes["CardItemUpdateInput"],	create: ResolverInputTypes["CardItemCreateInput"]},ResolverInputTypes["CardItemUpsertResult"]],
createCardList?: [{	data: ResolverInputTypes["CardListCreateInput"]},ResolverInputTypes["CardListCreateResult"]],
deleteCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	filter?: ResolverInputTypes["CardListWhere"] | undefined | null},ResolverInputTypes["CardListDeleteResult"]],
updateCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	filter?: ResolverInputTypes["CardListWhere"] | undefined | null,	data: ResolverInputTypes["CardListUpdateInput"]},ResolverInputTypes["CardListUpdateResult"]],
upsertCardList?: [{	by: ResolverInputTypes["CardListUniqueWhere"],	filter?: ResolverInputTypes["CardListWhere"] | undefined | null,	update: ResolverInputTypes["CardListUpdateInput"],	create: ResolverInputTypes["CardListCreateInput"]},ResolverInputTypes["CardListUpsertResult"]],
createOnBehalfDonation?: [{	data: ResolverInputTypes["OnBehalfDonationCreateInput"]},ResolverInputTypes["OnBehalfDonationCreateResult"]],
deleteOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null},ResolverInputTypes["OnBehalfDonationDeleteResult"]],
updateOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	data: ResolverInputTypes["OnBehalfDonationUpdateInput"]},ResolverInputTypes["OnBehalfDonationUpdateResult"]],
upsertOnBehalfDonation?: [{	by: ResolverInputTypes["OnBehalfDonationUniqueWhere"],	filter?: ResolverInputTypes["OnBehalfDonationWhere"] | undefined | null,	update: ResolverInputTypes["OnBehalfDonationUpdateInput"],	create: ResolverInputTypes["OnBehalfDonationCreateInput"]},ResolverInputTypes["OnBehalfDonationUpsertResult"]],
createUserPaymentTriesCollection?: [{	data: ResolverInputTypes["UserPaymentTriesCollectionCreateInput"]},ResolverInputTypes["UserPaymentTriesCollectionCreateResult"]],
deleteUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null},ResolverInputTypes["UserPaymentTriesCollectionDeleteResult"]],
updateUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,	data: ResolverInputTypes["UserPaymentTriesCollectionUpdateInput"]},ResolverInputTypes["UserPaymentTriesCollectionUpdateResult"]],
upsertUserPaymentTriesCollection?: [{	by: ResolverInputTypes["UserPaymentTriesCollectionUniqueWhere"],	filter?: ResolverInputTypes["UserPaymentTriesCollectionWhere"] | undefined | null,	update: ResolverInputTypes["UserPaymentTriesCollectionUpdateInput"],	create: ResolverInputTypes["UserPaymentTriesCollectionCreateInput"]},ResolverInputTypes["UserPaymentTriesCollectionUpsertResult"]],
createRecurringPaymentPage?: [{	data: ResolverInputTypes["RecurringPaymentPageCreateInput"]},ResolverInputTypes["RecurringPaymentPageCreateResult"]],
deleteRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageDeleteResult"]],
updateRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,	data: ResolverInputTypes["RecurringPaymentPageUpdateInput"]},ResolverInputTypes["RecurringPaymentPageUpdateResult"]],
upsertRecurringPaymentPage?: [{	by: ResolverInputTypes["RecurringPaymentPageUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageWhere"] | undefined | null,	update: ResolverInputTypes["RecurringPaymentPageUpdateInput"],	create: ResolverInputTypes["RecurringPaymentPageCreateInput"]},ResolverInputTypes["RecurringPaymentPageUpsertResult"]],
createRecurringPaymentPageLocale?: [{	data: ResolverInputTypes["RecurringPaymentPageLocaleCreateInput"]},ResolverInputTypes["RecurringPaymentPageLocaleCreateResult"]],
deleteRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null},ResolverInputTypes["RecurringPaymentPageLocaleDeleteResult"]],
updateRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["RecurringPaymentPageLocaleUpdateInput"]},ResolverInputTypes["RecurringPaymentPageLocaleUpdateResult"]],
upsertRecurringPaymentPageLocale?: [{	by: ResolverInputTypes["RecurringPaymentPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecurringPaymentPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["RecurringPaymentPageLocaleUpdateInput"],	create: ResolverInputTypes["RecurringPaymentPageLocaleCreateInput"]},ResolverInputTypes["RecurringPaymentPageLocaleUpsertResult"]],
createStoryGuide?: [{	data: ResolverInputTypes["StoryGuideCreateInput"]},ResolverInputTypes["StoryGuideCreateResult"]],
deleteStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null},ResolverInputTypes["StoryGuideDeleteResult"]],
updateStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,	data: ResolverInputTypes["StoryGuideUpdateInput"]},ResolverInputTypes["StoryGuideUpdateResult"]],
upsertStoryGuide?: [{	by: ResolverInputTypes["StoryGuideUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideWhere"] | undefined | null,	update: ResolverInputTypes["StoryGuideUpdateInput"],	create: ResolverInputTypes["StoryGuideCreateInput"]},ResolverInputTypes["StoryGuideUpsertResult"]],
createStoryGuideItem?: [{	data: ResolverInputTypes["StoryGuideItemCreateInput"]},ResolverInputTypes["StoryGuideItemCreateResult"]],
deleteStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null},ResolverInputTypes["StoryGuideItemDeleteResult"]],
updateStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	data: ResolverInputTypes["StoryGuideItemUpdateInput"]},ResolverInputTypes["StoryGuideItemUpdateResult"]],
upsertStoryGuideItem?: [{	by: ResolverInputTypes["StoryGuideItemUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideItemWhere"] | undefined | null,	update: ResolverInputTypes["StoryGuideItemUpdateInput"],	create: ResolverInputTypes["StoryGuideItemCreateInput"]},ResolverInputTypes["StoryGuideItemUpsertResult"]],
createStoryGuideList?: [{	data: ResolverInputTypes["StoryGuideListCreateInput"]},ResolverInputTypes["StoryGuideListCreateResult"]],
deleteStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null},ResolverInputTypes["StoryGuideListDeleteResult"]],
updateStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,	data: ResolverInputTypes["StoryGuideListUpdateInput"]},ResolverInputTypes["StoryGuideListUpdateResult"]],
upsertStoryGuideList?: [{	by: ResolverInputTypes["StoryGuideListUniqueWhere"],	filter?: ResolverInputTypes["StoryGuideListWhere"] | undefined | null,	update: ResolverInputTypes["StoryGuideListUpdateInput"],	create: ResolverInputTypes["StoryGuideListCreateInput"]},ResolverInputTypes["StoryGuideListUpsertResult"]],
createHeroCarousel?: [{	data: ResolverInputTypes["HeroCarouselCreateInput"]},ResolverInputTypes["HeroCarouselCreateResult"]],
deleteHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null},ResolverInputTypes["HeroCarouselDeleteResult"]],
updateHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	data: ResolverInputTypes["HeroCarouselUpdateInput"]},ResolverInputTypes["HeroCarouselUpdateResult"]],
upsertHeroCarousel?: [{	by: ResolverInputTypes["HeroCarouselUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselWhere"] | undefined | null,	update: ResolverInputTypes["HeroCarouselUpdateInput"],	create: ResolverInputTypes["HeroCarouselCreateInput"]},ResolverInputTypes["HeroCarouselUpsertResult"]],
createPostOrganizationList?: [{	data: ResolverInputTypes["PostOrganizationListCreateInput"]},ResolverInputTypes["PostOrganizationListCreateResult"]],
deletePostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null},ResolverInputTypes["PostOrganizationListDeleteResult"]],
updatePostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,	data: ResolverInputTypes["PostOrganizationListUpdateInput"]},ResolverInputTypes["PostOrganizationListUpdateResult"]],
upsertPostOrganizationList?: [{	by: ResolverInputTypes["PostOrganizationListUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListWhere"] | undefined | null,	update: ResolverInputTypes["PostOrganizationListUpdateInput"],	create: ResolverInputTypes["PostOrganizationListCreateInput"]},ResolverInputTypes["PostOrganizationListUpsertResult"]],
createPostOrganizationListItem?: [{	data: ResolverInputTypes["PostOrganizationListItemCreateInput"]},ResolverInputTypes["PostOrganizationListItemCreateResult"]],
deletePostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null},ResolverInputTypes["PostOrganizationListItemDeleteResult"]],
updatePostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	data: ResolverInputTypes["PostOrganizationListItemUpdateInput"]},ResolverInputTypes["PostOrganizationListItemUpdateResult"]],
upsertPostOrganizationListItem?: [{	by: ResolverInputTypes["PostOrganizationListItemUniqueWhere"],	filter?: ResolverInputTypes["PostOrganizationListItemWhere"] | undefined | null,	update: ResolverInputTypes["PostOrganizationListItemUpdateInput"],	create: ResolverInputTypes["PostOrganizationListItemCreateInput"]},ResolverInputTypes["PostOrganizationListItemUpsertResult"]],
createInfoCarousel?: [{	data: ResolverInputTypes["InfoCarouselCreateInput"]},ResolverInputTypes["InfoCarouselCreateResult"]],
deleteInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null},ResolverInputTypes["InfoCarouselDeleteResult"]],
updateInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,	data: ResolverInputTypes["InfoCarouselUpdateInput"]},ResolverInputTypes["InfoCarouselUpdateResult"]],
upsertInfoCarousel?: [{	by: ResolverInputTypes["InfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselWhere"] | undefined | null,	update: ResolverInputTypes["InfoCarouselUpdateInput"],	create: ResolverInputTypes["InfoCarouselCreateInput"]},ResolverInputTypes["InfoCarouselUpsertResult"]],
createInfoCarouselItem?: [{	data: ResolverInputTypes["InfoCarouselItemCreateInput"]},ResolverInputTypes["InfoCarouselItemCreateResult"]],
deleteInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItemDeleteResult"]],
updateInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	data: ResolverInputTypes["InfoCarouselItemUpdateInput"]},ResolverInputTypes["InfoCarouselItemUpdateResult"]],
upsertInfoCarouselItem?: [{	by: ResolverInputTypes["InfoCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemWhere"] | undefined | null,	update: ResolverInputTypes["InfoCarouselItemUpdateInput"],	create: ResolverInputTypes["InfoCarouselItemCreateInput"]},ResolverInputTypes["InfoCarouselItemUpsertResult"]],
createPersonSeenInfoCarousel?: [{	data: ResolverInputTypes["PersonSeenInfoCarouselCreateInput"]},ResolverInputTypes["PersonSeenInfoCarouselCreateResult"]],
deletePersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null},ResolverInputTypes["PersonSeenInfoCarouselDeleteResult"]],
updatePersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	data: ResolverInputTypes["PersonSeenInfoCarouselUpdateInput"]},ResolverInputTypes["PersonSeenInfoCarouselUpdateResult"]],
upsertPersonSeenInfoCarousel?: [{	by: ResolverInputTypes["PersonSeenInfoCarouselUniqueWhere"],	filter?: ResolverInputTypes["PersonSeenInfoCarouselWhere"] | undefined | null,	update: ResolverInputTypes["PersonSeenInfoCarouselUpdateInput"],	create: ResolverInputTypes["PersonSeenInfoCarouselCreateInput"]},ResolverInputTypes["PersonSeenInfoCarouselUpsertResult"]],
createGivenGiftsPage?: [{	data: ResolverInputTypes["GivenGiftsPageCreateInput"]},ResolverInputTypes["GivenGiftsPageCreateResult"]],
deleteGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageDeleteResult"]],
updateGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,	data: ResolverInputTypes["GivenGiftsPageUpdateInput"]},ResolverInputTypes["GivenGiftsPageUpdateResult"]],
upsertGivenGiftsPage?: [{	by: ResolverInputTypes["GivenGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageWhere"] | undefined | null,	update: ResolverInputTypes["GivenGiftsPageUpdateInput"],	create: ResolverInputTypes["GivenGiftsPageCreateInput"]},ResolverInputTypes["GivenGiftsPageUpsertResult"]],
createGivenGiftsPageLocale?: [{	data: ResolverInputTypes["GivenGiftsPageLocaleCreateInput"]},ResolverInputTypes["GivenGiftsPageLocaleCreateResult"]],
deleteGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["GivenGiftsPageLocaleDeleteResult"]],
updateGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GivenGiftsPageLocaleUpdateInput"]},ResolverInputTypes["GivenGiftsPageLocaleUpdateResult"]],
upsertGivenGiftsPageLocale?: [{	by: ResolverInputTypes["GivenGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GivenGiftsPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GivenGiftsPageLocaleUpdateInput"],	create: ResolverInputTypes["GivenGiftsPageLocaleCreateInput"]},ResolverInputTypes["GivenGiftsPageLocaleUpsertResult"]],
createReceivedGiftsPage?: [{	data: ResolverInputTypes["ReceivedGiftsPageCreateInput"]},ResolverInputTypes["ReceivedGiftsPageCreateResult"]],
deleteReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageDeleteResult"]],
updateReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,	data: ResolverInputTypes["ReceivedGiftsPageUpdateInput"]},ResolverInputTypes["ReceivedGiftsPageUpdateResult"]],
upsertReceivedGiftsPage?: [{	by: ResolverInputTypes["ReceivedGiftsPageUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageWhere"] | undefined | null,	update: ResolverInputTypes["ReceivedGiftsPageUpdateInput"],	create: ResolverInputTypes["ReceivedGiftsPageCreateInput"]},ResolverInputTypes["ReceivedGiftsPageUpsertResult"]],
createReceivedGiftsPageLocale?: [{	data: ResolverInputTypes["ReceivedGiftsPageLocaleCreateInput"]},ResolverInputTypes["ReceivedGiftsPageLocaleCreateResult"]],
deleteReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReceivedGiftsPageLocaleDeleteResult"]],
updateReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateInput"]},ResolverInputTypes["ReceivedGiftsPageLocaleUpdateResult"]],
upsertReceivedGiftsPageLocale?: [{	by: ResolverInputTypes["ReceivedGiftsPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReceivedGiftsPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ReceivedGiftsPageLocaleUpdateInput"],	create: ResolverInputTypes["ReceivedGiftsPageLocaleCreateInput"]},ResolverInputTypes["ReceivedGiftsPageLocaleUpsertResult"]],
createReportNavigation?: [{	data: ResolverInputTypes["ReportNavigationCreateInput"]},ResolverInputTypes["ReportNavigationCreateResult"]],
deleteReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null},ResolverInputTypes["ReportNavigationDeleteResult"]],
updateReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,	data: ResolverInputTypes["ReportNavigationUpdateInput"]},ResolverInputTypes["ReportNavigationUpdateResult"]],
upsertReportNavigation?: [{	by: ResolverInputTypes["ReportNavigationUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationWhere"] | undefined | null,	update: ResolverInputTypes["ReportNavigationUpdateInput"],	create: ResolverInputTypes["ReportNavigationCreateInput"]},ResolverInputTypes["ReportNavigationUpsertResult"]],
createReportPage?: [{	data: ResolverInputTypes["ReportPageCreateInput"]},ResolverInputTypes["ReportPageCreateResult"]],
deleteReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null},ResolverInputTypes["ReportPageDeleteResult"]],
updateReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null,	data: ResolverInputTypes["ReportPageUpdateInput"]},ResolverInputTypes["ReportPageUpdateResult"]],
upsertReportPage?: [{	by: ResolverInputTypes["ReportPageUniqueWhere"],	filter?: ResolverInputTypes["ReportPageWhere"] | undefined | null,	update: ResolverInputTypes["ReportPageUpdateInput"],	create: ResolverInputTypes["ReportPageCreateInput"]},ResolverInputTypes["ReportPageUpsertResult"]],
createReportPageLocale?: [{	data: ResolverInputTypes["ReportPageLocaleCreateInput"]},ResolverInputTypes["ReportPageLocaleCreateResult"]],
deleteReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null},ResolverInputTypes["ReportPageLocaleDeleteResult"]],
updateReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ReportPageLocaleUpdateInput"]},ResolverInputTypes["ReportPageLocaleUpdateResult"]],
upsertReportPageLocale?: [{	by: ResolverInputTypes["ReportPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ReportPageLocaleUpdateInput"],	create: ResolverInputTypes["ReportPageLocaleCreateInput"]},ResolverInputTypes["ReportPageLocaleUpsertResult"]],
createReportNavigationLocale?: [{	data: ResolverInputTypes["ReportNavigationLocaleCreateInput"]},ResolverInputTypes["ReportNavigationLocaleCreateResult"]],
deleteReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null},ResolverInputTypes["ReportNavigationLocaleDeleteResult"]],
updateReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ReportNavigationLocaleUpdateInput"]},ResolverInputTypes["ReportNavigationLocaleUpdateResult"]],
upsertReportNavigationLocale?: [{	by: ResolverInputTypes["ReportNavigationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ReportNavigationLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ReportNavigationLocaleUpdateInput"],	create: ResolverInputTypes["ReportNavigationLocaleCreateInput"]},ResolverInputTypes["ReportNavigationLocaleUpsertResult"]],
createSentPayment?: [{	data: ResolverInputTypes["SentPaymentCreateInput"]},ResolverInputTypes["SentPaymentCreateResult"]],
deleteSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null},ResolverInputTypes["SentPaymentDeleteResult"]],
updateSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	data: ResolverInputTypes["SentPaymentUpdateInput"]},ResolverInputTypes["SentPaymentUpdateResult"]],
upsertSentPayment?: [{	by: ResolverInputTypes["SentPaymentUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentWhere"] | undefined | null,	update: ResolverInputTypes["SentPaymentUpdateInput"],	create: ResolverInputTypes["SentPaymentCreateInput"]},ResolverInputTypes["SentPaymentUpsertResult"]],
createNotificationTargetGroup?: [{	data: ResolverInputTypes["NotificationTargetGroupCreateInput"]},ResolverInputTypes["NotificationTargetGroupCreateResult"]],
deleteNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null},ResolverInputTypes["NotificationTargetGroupDeleteResult"]],
updateNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,	data: ResolverInputTypes["NotificationTargetGroupUpdateInput"]},ResolverInputTypes["NotificationTargetGroupUpdateResult"]],
upsertNotificationTargetGroup?: [{	by: ResolverInputTypes["NotificationTargetGroupUniqueWhere"],	filter?: ResolverInputTypes["NotificationTargetGroupWhere"] | undefined | null,	update: ResolverInputTypes["NotificationTargetGroupUpdateInput"],	create: ResolverInputTypes["NotificationTargetGroupCreateInput"]},ResolverInputTypes["NotificationTargetGroupUpsertResult"]],
createProcessedNotification?: [{	data: ResolverInputTypes["ProcessedNotificationCreateInput"]},ResolverInputTypes["ProcessedNotificationCreateResult"]],
deleteProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationDeleteResult"]],
updateProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,	data: ResolverInputTypes["ProcessedNotificationUpdateInput"]},ResolverInputTypes["ProcessedNotificationUpdateResult"]],
upsertProcessedNotification?: [{	by: ResolverInputTypes["ProcessedNotificationUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationWhere"] | undefined | null,	update: ResolverInputTypes["ProcessedNotificationUpdateInput"],	create: ResolverInputTypes["ProcessedNotificationCreateInput"]},ResolverInputTypes["ProcessedNotificationUpsertResult"]],
createScheduledNotification?: [{	data: ResolverInputTypes["ScheduledNotificationCreateInput"]},ResolverInputTypes["ScheduledNotificationCreateResult"]],
deleteScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null},ResolverInputTypes["ScheduledNotificationDeleteResult"]],
updateScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,	data: ResolverInputTypes["ScheduledNotificationUpdateInput"]},ResolverInputTypes["ScheduledNotificationUpdateResult"]],
upsertScheduledNotification?: [{	by: ResolverInputTypes["ScheduledNotificationUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationWhere"] | undefined | null,	update: ResolverInputTypes["ScheduledNotificationUpdateInput"],	create: ResolverInputTypes["ScheduledNotificationCreateInput"]},ResolverInputTypes["ScheduledNotificationUpsertResult"]],
createProcessedNotificationSource?: [{	data: ResolverInputTypes["ProcessedNotificationSourceCreateInput"]},ResolverInputTypes["ProcessedNotificationSourceCreateResult"]],
deleteProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null},ResolverInputTypes["ProcessedNotificationSourceDeleteResult"]],
updateProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	data: ResolverInputTypes["ProcessedNotificationSourceUpdateInput"]},ResolverInputTypes["ProcessedNotificationSourceUpdateResult"]],
upsertProcessedNotificationSource?: [{	by: ResolverInputTypes["ProcessedNotificationSourceUniqueWhere"],	filter?: ResolverInputTypes["ProcessedNotificationSourceWhere"] | undefined | null,	update: ResolverInputTypes["ProcessedNotificationSourceUpdateInput"],	create: ResolverInputTypes["ProcessedNotificationSourceCreateInput"]},ResolverInputTypes["ProcessedNotificationSourceUpsertResult"]],
createDevice?: [{	data: ResolverInputTypes["DeviceCreateInput"]},ResolverInputTypes["DeviceCreateResult"]],
deleteDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null},ResolverInputTypes["DeviceDeleteResult"]],
updateDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	data: ResolverInputTypes["DeviceUpdateInput"]},ResolverInputTypes["DeviceUpdateResult"]],
upsertDevice?: [{	by: ResolverInputTypes["DeviceUniqueWhere"],	filter?: ResolverInputTypes["DeviceWhere"] | undefined | null,	update: ResolverInputTypes["DeviceUpdateInput"],	create: ResolverInputTypes["DeviceCreateInput"]},ResolverInputTypes["DeviceUpsertResult"]],
createScheduledNotificationLocale?: [{	data: ResolverInputTypes["ScheduledNotificationLocaleCreateInput"]},ResolverInputTypes["ScheduledNotificationLocaleCreateResult"]],
deleteScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null},ResolverInputTypes["ScheduledNotificationLocaleDeleteResult"]],
updateScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ScheduledNotificationLocaleUpdateInput"]},ResolverInputTypes["ScheduledNotificationLocaleUpdateResult"]],
upsertScheduledNotificationLocale?: [{	by: ResolverInputTypes["ScheduledNotificationLocaleUniqueWhere"],	filter?: ResolverInputTypes["ScheduledNotificationLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ScheduledNotificationLocaleUpdateInput"],	create: ResolverInputTypes["ScheduledNotificationLocaleCreateInput"]},ResolverInputTypes["ScheduledNotificationLocaleUpsertResult"]],
createInfoCarouselItemLocale?: [{	data: ResolverInputTypes["InfoCarouselItemLocaleCreateInput"]},ResolverInputTypes["InfoCarouselItemLocaleCreateResult"]],
deleteInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null},ResolverInputTypes["InfoCarouselItemLocaleDeleteResult"]],
updateInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	data: ResolverInputTypes["InfoCarouselItemLocaleUpdateInput"]},ResolverInputTypes["InfoCarouselItemLocaleUpdateResult"]],
upsertInfoCarouselItemLocale?: [{	by: ResolverInputTypes["InfoCarouselItemLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoCarouselItemLocaleWhere"] | undefined | null,	update: ResolverInputTypes["InfoCarouselItemLocaleUpdateInput"],	create: ResolverInputTypes["InfoCarouselItemLocaleCreateInput"]},ResolverInputTypes["InfoCarouselItemLocaleUpsertResult"]],
createSentPaymentLocale?: [{	data: ResolverInputTypes["SentPaymentLocaleCreateInput"]},ResolverInputTypes["SentPaymentLocaleCreateResult"]],
deleteSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null},ResolverInputTypes["SentPaymentLocaleDeleteResult"]],
updateSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	data: ResolverInputTypes["SentPaymentLocaleUpdateInput"]},ResolverInputTypes["SentPaymentLocaleUpdateResult"]],
upsertSentPaymentLocale?: [{	by: ResolverInputTypes["SentPaymentLocaleUniqueWhere"],	filter?: ResolverInputTypes["SentPaymentLocaleWhere"] | undefined | null,	update: ResolverInputTypes["SentPaymentLocaleUpdateInput"],	create: ResolverInputTypes["SentPaymentLocaleCreateInput"]},ResolverInputTypes["SentPaymentLocaleUpsertResult"]],
createTextImageList?: [{	data: ResolverInputTypes["TextImageListCreateInput"]},ResolverInputTypes["TextImageListCreateResult"]],
deleteTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null},ResolverInputTypes["TextImageListDeleteResult"]],
updateTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null,	data: ResolverInputTypes["TextImageListUpdateInput"]},ResolverInputTypes["TextImageListUpdateResult"]],
upsertTextImageList?: [{	by: ResolverInputTypes["TextImageListUniqueWhere"],	filter?: ResolverInputTypes["TextImageListWhere"] | undefined | null,	update: ResolverInputTypes["TextImageListUpdateInput"],	create: ResolverInputTypes["TextImageListCreateInput"]},ResolverInputTypes["TextImageListUpsertResult"]],
createTextImageListItem?: [{	data: ResolverInputTypes["TextImageListItemCreateInput"]},ResolverInputTypes["TextImageListItemCreateResult"]],
deleteTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null},ResolverInputTypes["TextImageListItemDeleteResult"]],
updateTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	data: ResolverInputTypes["TextImageListItemUpdateInput"]},ResolverInputTypes["TextImageListItemUpdateResult"]],
upsertTextImageListItem?: [{	by: ResolverInputTypes["TextImageListItemUniqueWhere"],	filter?: ResolverInputTypes["TextImageListItemWhere"] | undefined | null,	update: ResolverInputTypes["TextImageListItemUpdateInput"],	create: ResolverInputTypes["TextImageListItemCreateInput"]},ResolverInputTypes["TextImageListItemUpsertResult"]],
createHeroCarouselItem?: [{	data: ResolverInputTypes["HeroCarouselItemCreateInput"]},ResolverInputTypes["HeroCarouselItemCreateResult"]],
deleteHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null},ResolverInputTypes["HeroCarouselItemDeleteResult"]],
updateHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	data: ResolverInputTypes["HeroCarouselItemUpdateInput"]},ResolverInputTypes["HeroCarouselItemUpdateResult"]],
upsertHeroCarouselItem?: [{	by: ResolverInputTypes["HeroCarouselItemUniqueWhere"],	filter?: ResolverInputTypes["HeroCarouselItemWhere"] | undefined | null,	update: ResolverInputTypes["HeroCarouselItemUpdateInput"],	create: ResolverInputTypes["HeroCarouselItemCreateInput"]},ResolverInputTypes["HeroCarouselItemUpsertResult"]],
	query?:ResolverInputTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?: boolean | undefined | null,
	deferUniqueConstraints?: boolean | undefined | null
}
  }

export type ModelTypes = {
    ["_Column"]: {
		name: string,
	type: string,
	enumName?: string | undefined,
	defaultValue?: ModelTypes["Json"] | undefined,
	nullable: boolean,
	rules: Array<ModelTypes["_Rule"]>,
	validators: Array<ModelTypes["_Validator"]>
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Rule"]: {
		message?: ModelTypes["_RuleMessage"] | undefined,
	validator: number
};
	["_RuleMessage"]: {
		text?: string | undefined
};
	["_Validator"]: {
		operation: string,
	arguments: Array<ModelTypes["_Argument"]>
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator: number
};
	["_PathArgument"]: {
		path: Array<string>
};
	["_LiteralArgument"]: {
		value?: ModelTypes["Json"] | undefined
};
	/** Json custom scalar type */
["Json"]:any;
	["_Relation"]: {
		name: string,
	type: string,
	side: ModelTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string | undefined,
	inversedBy?: string | undefined,
	nullable?: boolean | undefined,
	onDelete?: ModelTypes["_OnDeleteBehaviour"] | undefined,
	orphanRemoval?: boolean | undefined,
	orderBy?: Array<ModelTypes["_OrderBy"]> | undefined,
	rules: Array<ModelTypes["_Rule"]>,
	validators: Array<ModelTypes["_Validator"]>
};
	["_RelationSide"]:_RelationSide;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_OrderBy"]: {
		path: Array<string>,
	direction: ModelTypes["_OrderByDirection"]
};
	["_OrderByDirection"]:_OrderByDirection;
	["Query"]: {
		schema?: ModelTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined,
	getGeneral?: ModelTypes["General"] | undefined,
	listGeneral: Array<ModelTypes["General"]>,
	paginateGeneral: ModelTypes["GeneralConnection"],
	validateCreateGeneral: ModelTypes["_ValidationResult"],
	validateUpdateGeneral: ModelTypes["_ValidationResult"],
	getImage?: ModelTypes["Image"] | undefined,
	listImage: Array<ModelTypes["Image"]>,
	paginateImage: ModelTypes["ImageConnection"],
	validateCreateImage: ModelTypes["_ValidationResult"],
	validateUpdateImage: ModelTypes["_ValidationResult"],
	getGenericPage?: ModelTypes["GenericPage"] | undefined,
	listGenericPage: Array<ModelTypes["GenericPage"]>,
	paginateGenericPage: ModelTypes["GenericPageConnection"],
	validateCreateGenericPage: ModelTypes["_ValidationResult"],
	validateUpdateGenericPage: ModelTypes["_ValidationResult"],
	getLinkable?: ModelTypes["Linkable"] | undefined,
	listLinkable: Array<ModelTypes["Linkable"]>,
	paginateLinkable: ModelTypes["LinkableConnection"],
	validateCreateLinkable: ModelTypes["_ValidationResult"],
	validateUpdateLinkable: ModelTypes["_ValidationResult"],
	getSeo?: ModelTypes["Seo"] | undefined,
	listSeo: Array<ModelTypes["Seo"]>,
	paginateSeo: ModelTypes["SeoConnection"],
	validateCreateSeo: ModelTypes["_ValidationResult"],
	validateUpdateSeo: ModelTypes["_ValidationResult"],
	getContent?: ModelTypes["Content"] | undefined,
	listContent: Array<ModelTypes["Content"]>,
	paginateContent: ModelTypes["ContentConnection"],
	validateCreateContent: ModelTypes["_ValidationResult"],
	validateUpdateContent: ModelTypes["_ValidationResult"],
	getContentBlock?: ModelTypes["ContentBlock"] | undefined,
	listContentBlock: Array<ModelTypes["ContentBlock"]>,
	paginateContentBlock: ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock: ModelTypes["_ValidationResult"],
	validateUpdateContentBlock: ModelTypes["_ValidationResult"],
	getContentReference?: ModelTypes["ContentReference"] | undefined,
	listContentReference: Array<ModelTypes["ContentReference"]>,
	paginateContentReference: ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference: ModelTypes["_ValidationResult"],
	validateUpdateContentReference: ModelTypes["_ValidationResult"],
	getContentReferenceLinkableItem?: ModelTypes["ContentReferenceLinkableItem"] | undefined,
	listContentReferenceLinkableItem: Array<ModelTypes["ContentReferenceLinkableItem"]>,
	paginateContentReferenceLinkableItem: ModelTypes["ContentReferenceLinkableItemConnection"],
	getGeneralLocale?: ModelTypes["GeneralLocale"] | undefined,
	listGeneralLocale: Array<ModelTypes["GeneralLocale"]>,
	paginateGeneralLocale: ModelTypes["GeneralLocaleConnection"],
	validateCreateGeneralLocale: ModelTypes["_ValidationResult"],
	validateUpdateGeneralLocale: ModelTypes["_ValidationResult"],
	getGenericPageLocale?: ModelTypes["GenericPageLocale"] | undefined,
	listGenericPageLocale: Array<ModelTypes["GenericPageLocale"]>,
	paginateGenericPageLocale: ModelTypes["GenericPageLocaleConnection"],
	validateCreateGenericPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageLocale: ModelTypes["_ValidationResult"],
	getLocale?: ModelTypes["Locale"] | undefined,
	listLocale: Array<ModelTypes["Locale"]>,
	paginateLocale: ModelTypes["LocaleConnection"],
	validateCreateLocale: ModelTypes["_ValidationResult"],
	validateUpdateLocale: ModelTypes["_ValidationResult"],
	getVideo?: ModelTypes["Video"] | undefined,
	listVideo: Array<ModelTypes["Video"]>,
	paginateVideo: ModelTypes["VideoConnection"],
	validateCreateVideo: ModelTypes["_ValidationResult"],
	validateUpdateVideo: ModelTypes["_ValidationResult"],
	getLink?: ModelTypes["Link"] | undefined,
	listLink: Array<ModelTypes["Link"]>,
	paginateLink: ModelTypes["LinkConnection"],
	validateCreateLink: ModelTypes["_ValidationResult"],
	validateUpdateLink: ModelTypes["_ValidationResult"],
	getPost?: ModelTypes["Post"] | undefined,
	listPost: Array<ModelTypes["Post"]>,
	paginatePost: ModelTypes["PostConnection"],
	validateCreatePost: ModelTypes["_ValidationResult"],
	validateUpdatePost: ModelTypes["_ValidationResult"],
	getPostLocale?: ModelTypes["PostLocale"] | undefined,
	listPostLocale: Array<ModelTypes["PostLocale"]>,
	paginatePostLocale: ModelTypes["PostLocaleConnection"],
	validateCreatePostLocale: ModelTypes["_ValidationResult"],
	validateUpdatePostLocale: ModelTypes["_ValidationResult"],
	getPostArea?: ModelTypes["PostArea"] | undefined,
	listPostArea: Array<ModelTypes["PostArea"]>,
	paginatePostArea: ModelTypes["PostAreaConnection"],
	validateCreatePostArea: ModelTypes["_ValidationResult"],
	validateUpdatePostArea: ModelTypes["_ValidationResult"],
	getPostAreaLocale?: ModelTypes["PostAreaLocale"] | undefined,
	listPostAreaLocale: Array<ModelTypes["PostAreaLocale"]>,
	paginatePostAreaLocale: ModelTypes["PostAreaLocaleConnection"],
	validateCreatePostAreaLocale: ModelTypes["_ValidationResult"],
	validateUpdatePostAreaLocale: ModelTypes["_ValidationResult"],
	getPostOrganization?: ModelTypes["PostOrganization"] | undefined,
	listPostOrganization: Array<ModelTypes["PostOrganization"]>,
	paginatePostOrganization: ModelTypes["PostOrganizationConnection"],
	validateCreatePostOrganization: ModelTypes["_ValidationResult"],
	validateUpdatePostOrganization: ModelTypes["_ValidationResult"],
	getPostOrganizationLocale?: ModelTypes["PostOrganizationLocale"] | undefined,
	listPostOrganizationLocale: Array<ModelTypes["PostOrganizationLocale"]>,
	paginatePostOrganizationLocale: ModelTypes["PostOrganizationLocaleConnection"],
	validateCreatePostOrganizationLocale: ModelTypes["_ValidationResult"],
	validateUpdatePostOrganizationLocale: ModelTypes["_ValidationResult"],
	getDonation?: ModelTypes["Donation"] | undefined,
	listDonation: Array<ModelTypes["Donation"]>,
	paginateDonation: ModelTypes["DonationConnection"],
	validateCreateDonation: ModelTypes["_ValidationResult"],
	validateUpdateDonation: ModelTypes["_ValidationResult"],
	getDonationAmountItem?: ModelTypes["DonationAmountItem"] | undefined,
	listDonationAmountItem: Array<ModelTypes["DonationAmountItem"]>,
	paginateDonationAmountItem: ModelTypes["DonationAmountItemConnection"],
	validateCreateDonationAmountItem: ModelTypes["_ValidationResult"],
	validateUpdateDonationAmountItem: ModelTypes["_ValidationResult"],
	getDonationAmountsRegionItem?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	listDonationAmountsRegionItem: Array<ModelTypes["DonationAmountsRegionItem"]>,
	paginateDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemConnection"],
	validateCreateDonationAmountsRegionItem: ModelTypes["_ValidationResult"],
	validateUpdateDonationAmountsRegionItem: ModelTypes["_ValidationResult"],
	getDonationAmountsRegionList?: ModelTypes["DonationAmountsRegionList"] | undefined,
	listDonationAmountsRegionList: Array<ModelTypes["DonationAmountsRegionList"]>,
	paginateDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListConnection"],
	validateCreateDonationAmountsRegionList: ModelTypes["_ValidationResult"],
	validateUpdateDonationAmountsRegionList: ModelTypes["_ValidationResult"],
	getRegion?: ModelTypes["Region"] | undefined,
	listRegion: Array<ModelTypes["Region"]>,
	paginateRegion: ModelTypes["RegionConnection"],
	validateCreateRegion: ModelTypes["_ValidationResult"],
	validateUpdateRegion: ModelTypes["_ValidationResult"],
	getLinkItem?: ModelTypes["LinkItem"] | undefined,
	listLinkItem: Array<ModelTypes["LinkItem"]>,
	paginateLinkItem: ModelTypes["LinkItemConnection"],
	validateCreateLinkItem: ModelTypes["_ValidationResult"],
	validateUpdateLinkItem: ModelTypes["_ValidationResult"],
	getLinkList?: ModelTypes["LinkList"] | undefined,
	listLinkList: Array<ModelTypes["LinkList"]>,
	paginateLinkList: ModelTypes["LinkListConnection"],
	validateCreateLinkList: ModelTypes["_ValidationResult"],
	validateUpdateLinkList: ModelTypes["_ValidationResult"],
	getHeader?: ModelTypes["Header"] | undefined,
	listHeader: Array<ModelTypes["Header"]>,
	paginateHeader: ModelTypes["HeaderConnection"],
	validateCreateHeader: ModelTypes["_ValidationResult"],
	validateUpdateHeader: ModelTypes["_ValidationResult"],
	getHeaderLocale?: ModelTypes["HeaderLocale"] | undefined,
	listHeaderLocale: Array<ModelTypes["HeaderLocale"]>,
	paginateHeaderLocale: ModelTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: ModelTypes["_ValidationResult"],
	validateUpdateHeaderLocale: ModelTypes["_ValidationResult"],
	getFooter?: ModelTypes["Footer"] | undefined,
	listFooter: Array<ModelTypes["Footer"]>,
	paginateFooter: ModelTypes["FooterConnection"],
	validateCreateFooter: ModelTypes["_ValidationResult"],
	validateUpdateFooter: ModelTypes["_ValidationResult"],
	getFooterLocale?: ModelTypes["FooterLocale"] | undefined,
	listFooterLocale: Array<ModelTypes["FooterLocale"]>,
	paginateFooterLocale: ModelTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: ModelTypes["_ValidationResult"],
	validateUpdateFooterLocale: ModelTypes["_ValidationResult"],
	getPostList?: ModelTypes["PostList"] | undefined,
	listPostList: Array<ModelTypes["PostList"]>,
	paginatePostList: ModelTypes["PostListConnection"],
	validateCreatePostList: ModelTypes["_ValidationResult"],
	validateUpdatePostList: ModelTypes["_ValidationResult"],
	getPostListItem?: ModelTypes["PostListItem"] | undefined,
	listPostListItem: Array<ModelTypes["PostListItem"]>,
	paginatePostListItem: ModelTypes["PostListItemConnection"],
	validateCreatePostListItem: ModelTypes["_ValidationResult"],
	validateUpdatePostListItem: ModelTypes["_ValidationResult"],
	getAppBanner?: ModelTypes["AppBanner"] | undefined,
	listAppBanner: Array<ModelTypes["AppBanner"]>,
	paginateAppBanner: ModelTypes["AppBannerConnection"],
	validateCreateAppBanner: ModelTypes["_ValidationResult"],
	validateUpdateAppBanner: ModelTypes["_ValidationResult"],
	getGenericPageAboutSettings?: ModelTypes["GenericPageAboutSettings"] | undefined,
	listGenericPageAboutSettings: Array<ModelTypes["GenericPageAboutSettings"]>,
	paginateGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsConnection"],
	validateCreateGenericPageAboutSettings: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageAboutSettings: ModelTypes["_ValidationResult"],
	getGenericPageAboutSettingsLocale?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	listGenericPageAboutSettingsLocale: Array<ModelTypes["GenericPageAboutSettingsLocale"]>,
	paginateGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleConnection"],
	validateCreateGenericPageAboutSettingsLocale: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageAboutSettingsLocale: ModelTypes["_ValidationResult"],
	getValue?: ModelTypes["Value"] | undefined,
	listValue: Array<ModelTypes["Value"]>,
	paginateValue: ModelTypes["ValueConnection"],
	validateCreateValue: ModelTypes["_ValidationResult"],
	validateUpdateValue: ModelTypes["_ValidationResult"],
	getValueItem?: ModelTypes["ValueItem"] | undefined,
	listValueItem: Array<ModelTypes["ValueItem"]>,
	paginateValueItem: ModelTypes["ValueItemConnection"],
	validateCreateValueItem: ModelTypes["_ValidationResult"],
	validateUpdateValueItem: ModelTypes["_ValidationResult"],
	getValueList?: ModelTypes["ValueList"] | undefined,
	listValueList: Array<ModelTypes["ValueList"]>,
	paginateValueList: ModelTypes["ValueListConnection"],
	validateCreateValueList: ModelTypes["_ValidationResult"],
	validateUpdateValueList: ModelTypes["_ValidationResult"],
	getImageLink?: ModelTypes["ImageLink"] | undefined,
	listImageLink: Array<ModelTypes["ImageLink"]>,
	paginateImageLink: ModelTypes["ImageLinkConnection"],
	validateCreateImageLink: ModelTypes["_ValidationResult"],
	validateUpdateImageLink: ModelTypes["_ValidationResult"],
	getImageLinkItem?: ModelTypes["ImageLinkItem"] | undefined,
	listImageLinkItem: Array<ModelTypes["ImageLinkItem"]>,
	paginateImageLinkItem: ModelTypes["ImageLinkItemConnection"],
	validateCreateImageLinkItem: ModelTypes["_ValidationResult"],
	validateUpdateImageLinkItem: ModelTypes["_ValidationResult"],
	getImageLinkList?: ModelTypes["ImageLinkList"] | undefined,
	listImageLinkList: Array<ModelTypes["ImageLinkList"]>,
	paginateImageLinkList: ModelTypes["ImageLinkListConnection"],
	validateCreateImageLinkList: ModelTypes["_ValidationResult"],
	validateUpdateImageLinkList: ModelTypes["_ValidationResult"],
	getPostAreaList?: ModelTypes["PostAreaList"] | undefined,
	listPostAreaList: Array<ModelTypes["PostAreaList"]>,
	paginatePostAreaList: ModelTypes["PostAreaListConnection"],
	validateCreatePostAreaList: ModelTypes["_ValidationResult"],
	validateUpdatePostAreaList: ModelTypes["_ValidationResult"],
	getPostAreaListItem?: ModelTypes["PostAreaListItem"] | undefined,
	listPostAreaListItem: Array<ModelTypes["PostAreaListItem"]>,
	paginatePostAreaListItem: ModelTypes["PostAreaListItemConnection"],
	validateCreatePostAreaListItem: ModelTypes["_ValidationResult"],
	validateUpdatePostAreaListItem: ModelTypes["_ValidationResult"],
	getAccordion?: ModelTypes["Accordion"] | undefined,
	listAccordion: Array<ModelTypes["Accordion"]>,
	paginateAccordion: ModelTypes["AccordionConnection"],
	validateCreateAccordion: ModelTypes["_ValidationResult"],
	validateUpdateAccordion: ModelTypes["_ValidationResult"],
	getAccordionItem?: ModelTypes["AccordionItem"] | undefined,
	listAccordionItem: Array<ModelTypes["AccordionItem"]>,
	paginateAccordionItem: ModelTypes["AccordionItemConnection"],
	validateCreateAccordionItem: ModelTypes["_ValidationResult"],
	validateUpdateAccordionItem: ModelTypes["_ValidationResult"],
	getUser?: ModelTypes["User"] | undefined,
	listUser: Array<ModelTypes["User"]>,
	paginateUser: ModelTypes["UserConnection"],
	validateCreateUser: ModelTypes["_ValidationResult"],
	validateUpdateUser: ModelTypes["_ValidationResult"],
	getUserPayment?: ModelTypes["UserPayment"] | undefined,
	listUserPayment: Array<ModelTypes["UserPayment"]>,
	paginateUserPayment: ModelTypes["UserPaymentConnection"],
	validateCreateUserPayment: ModelTypes["_ValidationResult"],
	validateUpdateUserPayment: ModelTypes["_ValidationResult"],
	getCurrency?: ModelTypes["Currency"] | undefined,
	listCurrency: Array<ModelTypes["Currency"]>,
	paginateCurrency: ModelTypes["CurrencyConnection"],
	validateCreateCurrency: ModelTypes["_ValidationResult"],
	validateUpdateCurrency: ModelTypes["_ValidationResult"],
	getMedium?: ModelTypes["Medium"] | undefined,
	listMedium: Array<ModelTypes["Medium"]>,
	paginateMedium: ModelTypes["MediumConnection"],
	validateCreateMedium: ModelTypes["_ValidationResult"],
	validateUpdateMedium: ModelTypes["_ValidationResult"],
	getMediumItem?: ModelTypes["MediumItem"] | undefined,
	listMediumItem: Array<ModelTypes["MediumItem"]>,
	paginateMediumItem: ModelTypes["MediumItemConnection"],
	validateCreateMediumItem: ModelTypes["_ValidationResult"],
	validateUpdateMediumItem: ModelTypes["_ValidationResult"],
	getMediumList?: ModelTypes["MediumList"] | undefined,
	listMediumList: Array<ModelTypes["MediumList"]>,
	paginateMediumList: ModelTypes["MediumListConnection"],
	validateCreateMediumList: ModelTypes["_ValidationResult"],
	validateUpdateMediumList: ModelTypes["_ValidationResult"],
	getUserPaymentOrderId?: ModelTypes["UserPaymentOrderId"] | undefined,
	listUserPaymentOrderId: Array<ModelTypes["UserPaymentOrderId"]>,
	paginateUserPaymentOrderId: ModelTypes["UserPaymentOrderIdConnection"],
	validateCreateUserPaymentOrderId: ModelTypes["_ValidationResult"],
	validateUpdateUserPaymentOrderId: ModelTypes["_ValidationResult"],
	getPostRevision?: ModelTypes["PostRevision"] | undefined,
	listPostRevision: Array<ModelTypes["PostRevision"]>,
	paginatePostRevision: ModelTypes["PostRevisionConnection"],
	validateCreatePostRevision: ModelTypes["_ValidationResult"],
	validateUpdatePostRevision: ModelTypes["_ValidationResult"],
	getUserRecurringPayment?: ModelTypes["UserRecurringPayment"] | undefined,
	listUserRecurringPayment: Array<ModelTypes["UserRecurringPayment"]>,
	paginateUserRecurringPayment: ModelTypes["UserRecurringPaymentConnection"],
	validateCreateUserRecurringPayment: ModelTypes["_ValidationResult"],
	validateUpdateUserRecurringPayment: ModelTypes["_ValidationResult"],
	getUserRecurringPaymentItem?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	listUserRecurringPaymentItem: Array<ModelTypes["UserRecurringPaymentItem"]>,
	paginateUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemConnection"],
	validateCreateUserRecurringPaymentItem: ModelTypes["_ValidationResult"],
	validateUpdateUserRecurringPaymentItem: ModelTypes["_ValidationResult"],
	getPostRevisionLocale?: ModelTypes["PostRevisionLocale"] | undefined,
	listPostRevisionLocale: Array<ModelTypes["PostRevisionLocale"]>,
	paginatePostRevisionLocale: ModelTypes["PostRevisionLocaleConnection"],
	validateCreatePostRevisionLocale: ModelTypes["_ValidationResult"],
	validateUpdatePostRevisionLocale: ModelTypes["_ValidationResult"],
	getTranslationCatalogue?: ModelTypes["TranslationCatalogue"] | undefined,
	listTranslationCatalogue: Array<ModelTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: ModelTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: ModelTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: ModelTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: ModelTypes["TranslationCataloguesIdentifier"] | undefined,
	listTranslationCataloguesIdentifier: Array<ModelTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: ModelTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: ModelTypes["_ValidationResult"],
	getTranslationDomain?: ModelTypes["TranslationDomain"] | undefined,
	listTranslationDomain: Array<ModelTypes["TranslationDomain"]>,
	paginateTranslationDomain: ModelTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: ModelTypes["_ValidationResult"],
	validateUpdateTranslationDomain: ModelTypes["_ValidationResult"],
	getTranslationKey?: ModelTypes["TranslationKey"] | undefined,
	listTranslationKey: Array<ModelTypes["TranslationKey"]>,
	paginateTranslationKey: ModelTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: ModelTypes["_ValidationResult"],
	validateUpdateTranslationKey: ModelTypes["_ValidationResult"],
	getTranslationValue?: ModelTypes["TranslationValue"] | undefined,
	listTranslationValue: Array<ModelTypes["TranslationValue"]>,
	paginateTranslationValue: ModelTypes["TranslationValueConnection"],
	validateCreateTranslationValue: ModelTypes["_ValidationResult"],
	validateUpdateTranslationValue: ModelTypes["_ValidationResult"],
	getGenericPageAboutGroupLinksLocale?: ModelTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	listGenericPageAboutGroupLinksLocale: Array<ModelTypes["GenericPageAboutGroupLinksLocale"]>,
	paginateGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleConnection"],
	validateCreateGenericPageAboutGroupLinksLocale: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageAboutGroupLinksLocale: ModelTypes["_ValidationResult"],
	getMemberList?: ModelTypes["MemberList"] | undefined,
	listMemberList: Array<ModelTypes["MemberList"]>,
	paginateMemberList: ModelTypes["MemberListConnection"],
	validateCreateMemberList: ModelTypes["_ValidationResult"],
	validateUpdateMemberList: ModelTypes["_ValidationResult"],
	getMemberListItem?: ModelTypes["MemberListItem"] | undefined,
	listMemberListItem: Array<ModelTypes["MemberListItem"]>,
	paginateMemberListItem: ModelTypes["MemberListItemConnection"],
	validateCreateMemberListItem: ModelTypes["_ValidationResult"],
	validateUpdateMemberListItem: ModelTypes["_ValidationResult"],
	getFilledTaxForm?: ModelTypes["FilledTaxForm"] | undefined,
	listFilledTaxForm: Array<ModelTypes["FilledTaxForm"]>,
	paginateFilledTaxForm: ModelTypes["FilledTaxFormConnection"],
	validateCreateFilledTaxForm: ModelTypes["_ValidationResult"],
	validateUpdateFilledTaxForm: ModelTypes["_ValidationResult"],
	getFilledTaxFormEmailAddress?: ModelTypes["FilledTaxFormEmailAddress"] | undefined,
	listFilledTaxFormEmailAddress: Array<ModelTypes["FilledTaxFormEmailAddress"]>,
	paginateFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressConnection"],
	validateCreateFilledTaxFormEmailAddress: ModelTypes["_ValidationResult"],
	validateUpdateFilledTaxFormEmailAddress: ModelTypes["_ValidationResult"],
	getForm?: ModelTypes["Form"] | undefined,
	listForm: Array<ModelTypes["Form"]>,
	paginateForm: ModelTypes["FormConnection"],
	validateCreateForm: ModelTypes["_ValidationResult"],
	validateUpdateForm: ModelTypes["_ValidationResult"],
	getCsobPayment?: ModelTypes["CsobPayment"] | undefined,
	listCsobPayment: Array<ModelTypes["CsobPayment"]>,
	paginateCsobPayment: ModelTypes["CsobPaymentConnection"],
	validateCreateCsobPayment: ModelTypes["_ValidationResult"],
	validateUpdateCsobPayment: ModelTypes["_ValidationResult"],
	getCsobPaymentStatusChange?: ModelTypes["CsobPaymentStatusChange"] | undefined,
	listCsobPaymentStatusChange: Array<ModelTypes["CsobPaymentStatusChange"]>,
	paginateCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeConnection"],
	validateCreateCsobPaymentStatusChange: ModelTypes["_ValidationResult"],
	validateUpdateCsobPaymentStatusChange: ModelTypes["_ValidationResult"],
	getStripePayment?: ModelTypes["StripePayment"] | undefined,
	listStripePayment: Array<ModelTypes["StripePayment"]>,
	paginateStripePayment: ModelTypes["StripePaymentConnection"],
	validateCreateStripePayment: ModelTypes["_ValidationResult"],
	validateUpdateStripePayment: ModelTypes["_ValidationResult"],
	getStripePaymentStatusChange?: ModelTypes["StripePaymentStatusChange"] | undefined,
	listStripePaymentStatusChange: Array<ModelTypes["StripePaymentStatusChange"]>,
	paginateStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeConnection"],
	validateCreateStripePaymentStatusChange: ModelTypes["_ValidationResult"],
	validateUpdateStripePaymentStatusChange: ModelTypes["_ValidationResult"],
	getRegionPaymentMethod?: ModelTypes["RegionPaymentMethod"] | undefined,
	listRegionPaymentMethod: Array<ModelTypes["RegionPaymentMethod"]>,
	paginateRegionPaymentMethod: ModelTypes["RegionPaymentMethodConnection"],
	validateCreateRegionPaymentMethod: ModelTypes["_ValidationResult"],
	validateUpdateRegionPaymentMethod: ModelTypes["_ValidationResult"],
	getPostAreaMetaData?: ModelTypes["PostAreaMetaData"] | undefined,
	listPostAreaMetaData: Array<ModelTypes["PostAreaMetaData"]>,
	paginatePostAreaMetaData: ModelTypes["PostAreaMetaDataConnection"],
	getPostMetaData?: ModelTypes["PostMetaData"] | undefined,
	listPostMetaData: Array<ModelTypes["PostMetaData"]>,
	paginatePostMetaData: ModelTypes["PostMetaDataConnection"],
	getPostOrganizationMetaData?: ModelTypes["PostOrganizationMetaData"] | undefined,
	listPostOrganizationMetaData: Array<ModelTypes["PostOrganizationMetaData"]>,
	paginatePostOrganizationMetaData: ModelTypes["PostOrganizationMetaDataConnection"],
	getTileItem?: ModelTypes["TileItem"] | undefined,
	listTileItem: Array<ModelTypes["TileItem"]>,
	paginateTileItem: ModelTypes["TileItemConnection"],
	validateCreateTileItem: ModelTypes["_ValidationResult"],
	validateUpdateTileItem: ModelTypes["_ValidationResult"],
	getTileList?: ModelTypes["TileList"] | undefined,
	listTileList: Array<ModelTypes["TileList"]>,
	paginateTileList: ModelTypes["TileListConnection"],
	validateCreateTileList: ModelTypes["_ValidationResult"],
	validateUpdateTileList: ModelTypes["_ValidationResult"],
	getFeedPage?: ModelTypes["FeedPage"] | undefined,
	listFeedPage: Array<ModelTypes["FeedPage"]>,
	paginateFeedPage: ModelTypes["FeedPageConnection"],
	validateCreateFeedPage: ModelTypes["_ValidationResult"],
	validateUpdateFeedPage: ModelTypes["_ValidationResult"],
	getFeedPageLocale?: ModelTypes["FeedPageLocale"] | undefined,
	listFeedPageLocale: Array<ModelTypes["FeedPageLocale"]>,
	paginateFeedPageLocale: ModelTypes["FeedPageLocaleConnection"],
	validateCreateFeedPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateFeedPageLocale: ModelTypes["_ValidationResult"],
	getFeedPageSection?: ModelTypes["FeedPageSection"] | undefined,
	listFeedPageSection: Array<ModelTypes["FeedPageSection"]>,
	paginateFeedPageSection: ModelTypes["FeedPageSectionConnection"],
	validateCreateFeedPageSection: ModelTypes["_ValidationResult"],
	validateUpdateFeedPageSection: ModelTypes["_ValidationResult"],
	getFeedPageTileStripe?: ModelTypes["FeedPageTileStripe"] | undefined,
	listFeedPageTileStripe: Array<ModelTypes["FeedPageTileStripe"]>,
	paginateFeedPageTileStripe: ModelTypes["FeedPageTileStripeConnection"],
	validateCreateFeedPageTileStripe: ModelTypes["_ValidationResult"],
	validateUpdateFeedPageTileStripe: ModelTypes["_ValidationResult"],
	getCardItem?: ModelTypes["CardItem"] | undefined,
	listCardItem: Array<ModelTypes["CardItem"]>,
	paginateCardItem: ModelTypes["CardItemConnection"],
	validateCreateCardItem: ModelTypes["_ValidationResult"],
	validateUpdateCardItem: ModelTypes["_ValidationResult"],
	getCardList?: ModelTypes["CardList"] | undefined,
	listCardList: Array<ModelTypes["CardList"]>,
	paginateCardList: ModelTypes["CardListConnection"],
	validateCreateCardList: ModelTypes["_ValidationResult"],
	validateUpdateCardList: ModelTypes["_ValidationResult"],
	getOnBehalfDonation?: ModelTypes["OnBehalfDonation"] | undefined,
	listOnBehalfDonation: Array<ModelTypes["OnBehalfDonation"]>,
	paginateOnBehalfDonation: ModelTypes["OnBehalfDonationConnection"],
	validateCreateOnBehalfDonation: ModelTypes["_ValidationResult"],
	validateUpdateOnBehalfDonation: ModelTypes["_ValidationResult"],
	getUserPaymentTriesCollection?: ModelTypes["UserPaymentTriesCollection"] | undefined,
	listUserPaymentTriesCollection: Array<ModelTypes["UserPaymentTriesCollection"]>,
	paginateUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionConnection"],
	validateCreateUserPaymentTriesCollection: ModelTypes["_ValidationResult"],
	validateUpdateUserPaymentTriesCollection: ModelTypes["_ValidationResult"],
	getRecurringPaymentPage?: ModelTypes["RecurringPaymentPage"] | undefined,
	listRecurringPaymentPage: Array<ModelTypes["RecurringPaymentPage"]>,
	paginateRecurringPaymentPage: ModelTypes["RecurringPaymentPageConnection"],
	validateCreateRecurringPaymentPage: ModelTypes["_ValidationResult"],
	validateUpdateRecurringPaymentPage: ModelTypes["_ValidationResult"],
	getRecurringPaymentPageLocale?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	listRecurringPaymentPageLocale: Array<ModelTypes["RecurringPaymentPageLocale"]>,
	paginateRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleConnection"],
	validateCreateRecurringPaymentPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateRecurringPaymentPageLocale: ModelTypes["_ValidationResult"],
	getStoryGuide?: ModelTypes["StoryGuide"] | undefined,
	listStoryGuide: Array<ModelTypes["StoryGuide"]>,
	paginateStoryGuide: ModelTypes["StoryGuideConnection"],
	validateCreateStoryGuide: ModelTypes["_ValidationResult"],
	validateUpdateStoryGuide: ModelTypes["_ValidationResult"],
	getStoryGuideItem?: ModelTypes["StoryGuideItem"] | undefined,
	listStoryGuideItem: Array<ModelTypes["StoryGuideItem"]>,
	paginateStoryGuideItem: ModelTypes["StoryGuideItemConnection"],
	validateCreateStoryGuideItem: ModelTypes["_ValidationResult"],
	validateUpdateStoryGuideItem: ModelTypes["_ValidationResult"],
	getStoryGuideList?: ModelTypes["StoryGuideList"] | undefined,
	listStoryGuideList: Array<ModelTypes["StoryGuideList"]>,
	paginateStoryGuideList: ModelTypes["StoryGuideListConnection"],
	validateCreateStoryGuideList: ModelTypes["_ValidationResult"],
	validateUpdateStoryGuideList: ModelTypes["_ValidationResult"],
	getStripePaymentMetadata?: ModelTypes["StripePaymentMetadata"] | undefined,
	listStripePaymentMetadata: Array<ModelTypes["StripePaymentMetadata"]>,
	paginateStripePaymentMetadata: ModelTypes["StripePaymentMetadataConnection"],
	getOnBehalfDonationMetadata?: ModelTypes["OnBehalfDonationMetadata"] | undefined,
	listOnBehalfDonationMetadata: Array<ModelTypes["OnBehalfDonationMetadata"]>,
	paginateOnBehalfDonationMetadata: ModelTypes["OnBehalfDonationMetadataConnection"],
	getUserPaymentTriesCollectionMetadata?: ModelTypes["UserPaymentTriesCollectionMetadata"] | undefined,
	listUserPaymentTriesCollectionMetadata: Array<ModelTypes["UserPaymentTriesCollectionMetadata"]>,
	paginateUserPaymentTriesCollectionMetadata: ModelTypes["UserPaymentTriesCollectionMetadataConnection"],
	getUserPaymentTriesCollectionMetadataLocale?: ModelTypes["UserPaymentTriesCollectionMetadataLocale"] | undefined,
	listUserPaymentTriesCollectionMetadataLocale: Array<ModelTypes["UserPaymentTriesCollectionMetadataLocale"]>,
	paginateUserPaymentTriesCollectionMetadataLocale: ModelTypes["UserPaymentTriesCollectionMetadataLocaleConnection"],
	getCsobPaymentMetadata?: ModelTypes["CsobPaymentMetadata"] | undefined,
	listCsobPaymentMetadata: Array<ModelTypes["CsobPaymentMetadata"]>,
	paginateCsobPaymentMetadata: ModelTypes["CsobPaymentMetadataConnection"],
	getHeroCarousel?: ModelTypes["HeroCarousel"] | undefined,
	listHeroCarousel: Array<ModelTypes["HeroCarousel"]>,
	paginateHeroCarousel: ModelTypes["HeroCarouselConnection"],
	validateCreateHeroCarousel: ModelTypes["_ValidationResult"],
	validateUpdateHeroCarousel: ModelTypes["_ValidationResult"],
	getPostOrganizationList?: ModelTypes["PostOrganizationList"] | undefined,
	listPostOrganizationList: Array<ModelTypes["PostOrganizationList"]>,
	paginatePostOrganizationList: ModelTypes["PostOrganizationListConnection"],
	validateCreatePostOrganizationList: ModelTypes["_ValidationResult"],
	validateUpdatePostOrganizationList: ModelTypes["_ValidationResult"],
	getPostOrganizationListItem?: ModelTypes["PostOrganizationListItem"] | undefined,
	listPostOrganizationListItem: Array<ModelTypes["PostOrganizationListItem"]>,
	paginatePostOrganizationListItem: ModelTypes["PostOrganizationListItemConnection"],
	validateCreatePostOrganizationListItem: ModelTypes["_ValidationResult"],
	validateUpdatePostOrganizationListItem: ModelTypes["_ValidationResult"],
	getInfoCarousel?: ModelTypes["InfoCarousel"] | undefined,
	listInfoCarousel: Array<ModelTypes["InfoCarousel"]>,
	paginateInfoCarousel: ModelTypes["InfoCarouselConnection"],
	validateCreateInfoCarousel: ModelTypes["_ValidationResult"],
	validateUpdateInfoCarousel: ModelTypes["_ValidationResult"],
	getInfoCarouselItem?: ModelTypes["InfoCarouselItem"] | undefined,
	listInfoCarouselItem: Array<ModelTypes["InfoCarouselItem"]>,
	paginateInfoCarouselItem: ModelTypes["InfoCarouselItemConnection"],
	validateCreateInfoCarouselItem: ModelTypes["_ValidationResult"],
	validateUpdateInfoCarouselItem: ModelTypes["_ValidationResult"],
	getPersonSeenInfoCarousel?: ModelTypes["PersonSeenInfoCarousel"] | undefined,
	listPersonSeenInfoCarousel: Array<ModelTypes["PersonSeenInfoCarousel"]>,
	paginatePersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselConnection"],
	validateCreatePersonSeenInfoCarousel: ModelTypes["_ValidationResult"],
	validateUpdatePersonSeenInfoCarousel: ModelTypes["_ValidationResult"],
	getGivenGiftsPage?: ModelTypes["GivenGiftsPage"] | undefined,
	listGivenGiftsPage: Array<ModelTypes["GivenGiftsPage"]>,
	paginateGivenGiftsPage: ModelTypes["GivenGiftsPageConnection"],
	validateCreateGivenGiftsPage: ModelTypes["_ValidationResult"],
	validateUpdateGivenGiftsPage: ModelTypes["_ValidationResult"],
	getGivenGiftsPageLocale?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	listGivenGiftsPageLocale: Array<ModelTypes["GivenGiftsPageLocale"]>,
	paginateGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleConnection"],
	validateCreateGivenGiftsPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateGivenGiftsPageLocale: ModelTypes["_ValidationResult"],
	getReceivedGiftsPage?: ModelTypes["ReceivedGiftsPage"] | undefined,
	listReceivedGiftsPage: Array<ModelTypes["ReceivedGiftsPage"]>,
	paginateReceivedGiftsPage: ModelTypes["ReceivedGiftsPageConnection"],
	validateCreateReceivedGiftsPage: ModelTypes["_ValidationResult"],
	validateUpdateReceivedGiftsPage: ModelTypes["_ValidationResult"],
	getReceivedGiftsPageLocale?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	listReceivedGiftsPageLocale: Array<ModelTypes["ReceivedGiftsPageLocale"]>,
	paginateReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleConnection"],
	validateCreateReceivedGiftsPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateReceivedGiftsPageLocale: ModelTypes["_ValidationResult"],
	getReportNavigation?: ModelTypes["ReportNavigation"] | undefined,
	listReportNavigation: Array<ModelTypes["ReportNavigation"]>,
	paginateReportNavigation: ModelTypes["ReportNavigationConnection"],
	validateCreateReportNavigation: ModelTypes["_ValidationResult"],
	validateUpdateReportNavigation: ModelTypes["_ValidationResult"],
	getReportPage?: ModelTypes["ReportPage"] | undefined,
	listReportPage: Array<ModelTypes["ReportPage"]>,
	paginateReportPage: ModelTypes["ReportPageConnection"],
	validateCreateReportPage: ModelTypes["_ValidationResult"],
	validateUpdateReportPage: ModelTypes["_ValidationResult"],
	getReportPageLocale?: ModelTypes["ReportPageLocale"] | undefined,
	listReportPageLocale: Array<ModelTypes["ReportPageLocale"]>,
	paginateReportPageLocale: ModelTypes["ReportPageLocaleConnection"],
	validateCreateReportPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateReportPageLocale: ModelTypes["_ValidationResult"],
	getReportNavigationLocale?: ModelTypes["ReportNavigationLocale"] | undefined,
	listReportNavigationLocale: Array<ModelTypes["ReportNavigationLocale"]>,
	paginateReportNavigationLocale: ModelTypes["ReportNavigationLocaleConnection"],
	validateCreateReportNavigationLocale: ModelTypes["_ValidationResult"],
	validateUpdateReportNavigationLocale: ModelTypes["_ValidationResult"],
	getSentPayment?: ModelTypes["SentPayment"] | undefined,
	listSentPayment: Array<ModelTypes["SentPayment"]>,
	paginateSentPayment: ModelTypes["SentPaymentConnection"],
	validateCreateSentPayment: ModelTypes["_ValidationResult"],
	validateUpdateSentPayment: ModelTypes["_ValidationResult"],
	getPostAreaSentPaymentCurrencySum?: ModelTypes["PostAreaSentPaymentCurrencySum"] | undefined,
	listPostAreaSentPaymentCurrencySum: Array<ModelTypes["PostAreaSentPaymentCurrencySum"]>,
	paginatePostAreaSentPaymentCurrencySum: ModelTypes["PostAreaSentPaymentCurrencySumConnection"],
	getPostAreaSentPaymentSum?: ModelTypes["PostAreaSentPaymentSum"] | undefined,
	listPostAreaSentPaymentSum: Array<ModelTypes["PostAreaSentPaymentSum"]>,
	paginatePostAreaSentPaymentSum: ModelTypes["PostAreaSentPaymentSumConnection"],
	getNotificationTargetGroup?: ModelTypes["NotificationTargetGroup"] | undefined,
	listNotificationTargetGroup: Array<ModelTypes["NotificationTargetGroup"]>,
	paginateNotificationTargetGroup: ModelTypes["NotificationTargetGroupConnection"],
	validateCreateNotificationTargetGroup: ModelTypes["_ValidationResult"],
	validateUpdateNotificationTargetGroup: ModelTypes["_ValidationResult"],
	getProcessedNotification?: ModelTypes["ProcessedNotification"] | undefined,
	listProcessedNotification: Array<ModelTypes["ProcessedNotification"]>,
	paginateProcessedNotification: ModelTypes["ProcessedNotificationConnection"],
	validateCreateProcessedNotification: ModelTypes["_ValidationResult"],
	validateUpdateProcessedNotification: ModelTypes["_ValidationResult"],
	getScheduledNotification?: ModelTypes["ScheduledNotification"] | undefined,
	listScheduledNotification: Array<ModelTypes["ScheduledNotification"]>,
	paginateScheduledNotification: ModelTypes["ScheduledNotificationConnection"],
	validateCreateScheduledNotification: ModelTypes["_ValidationResult"],
	validateUpdateScheduledNotification: ModelTypes["_ValidationResult"],
	getProcessedNotificationSource?: ModelTypes["ProcessedNotificationSource"] | undefined,
	listProcessedNotificationSource: Array<ModelTypes["ProcessedNotificationSource"]>,
	paginateProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceConnection"],
	validateCreateProcessedNotificationSource: ModelTypes["_ValidationResult"],
	validateUpdateProcessedNotificationSource: ModelTypes["_ValidationResult"],
	getDevice?: ModelTypes["Device"] | undefined,
	listDevice: Array<ModelTypes["Device"]>,
	paginateDevice: ModelTypes["DeviceConnection"],
	validateCreateDevice: ModelTypes["_ValidationResult"],
	validateUpdateDevice: ModelTypes["_ValidationResult"],
	getScheduledNotificationLocale?: ModelTypes["ScheduledNotificationLocale"] | undefined,
	listScheduledNotificationLocale: Array<ModelTypes["ScheduledNotificationLocale"]>,
	paginateScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleConnection"],
	validateCreateScheduledNotificationLocale: ModelTypes["_ValidationResult"],
	validateUpdateScheduledNotificationLocale: ModelTypes["_ValidationResult"],
	getInfoCarouselItemLocale?: ModelTypes["InfoCarouselItemLocale"] | undefined,
	listInfoCarouselItemLocale: Array<ModelTypes["InfoCarouselItemLocale"]>,
	paginateInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleConnection"],
	validateCreateInfoCarouselItemLocale: ModelTypes["_ValidationResult"],
	validateUpdateInfoCarouselItemLocale: ModelTypes["_ValidationResult"],
	getSentPaymentLocale?: ModelTypes["SentPaymentLocale"] | undefined,
	listSentPaymentLocale: Array<ModelTypes["SentPaymentLocale"]>,
	paginateSentPaymentLocale: ModelTypes["SentPaymentLocaleConnection"],
	validateCreateSentPaymentLocale: ModelTypes["_ValidationResult"],
	validateUpdateSentPaymentLocale: ModelTypes["_ValidationResult"],
	getUserPaymentMetadata?: ModelTypes["UserPaymentMetadata"] | undefined,
	listUserPaymentMetadata: Array<ModelTypes["UserPaymentMetadata"]>,
	paginateUserPaymentMetadata: ModelTypes["UserPaymentMetadataConnection"],
	getPostAreaCurrencySum?: ModelTypes["PostAreaCurrencySum"] | undefined,
	listPostAreaCurrencySum: Array<ModelTypes["PostAreaCurrencySum"]>,
	paginatePostAreaCurrencySum: ModelTypes["PostAreaCurrencySumConnection"],
	getPostAreaSum?: ModelTypes["PostAreaSum"] | undefined,
	listPostAreaSum: Array<ModelTypes["PostAreaSum"]>,
	paginatePostAreaSum: ModelTypes["PostAreaSumConnection"],
	getPostOrganizationCurrencySum?: ModelTypes["PostOrganizationCurrencySum"] | undefined,
	listPostOrganizationCurrencySum: Array<ModelTypes["PostOrganizationCurrencySum"]>,
	paginatePostOrganizationCurrencySum: ModelTypes["PostOrganizationCurrencySumConnection"],
	getPostOrganizationSum?: ModelTypes["PostOrganizationSum"] | undefined,
	listPostOrganizationSum: Array<ModelTypes["PostOrganizationSum"]>,
	paginatePostOrganizationSum: ModelTypes["PostOrganizationSumConnection"],
	getStats?: ModelTypes["Stats"] | undefined,
	listStats: Array<ModelTypes["Stats"]>,
	paginateStats: ModelTypes["StatsConnection"],
	getUserRecurringPaymentItemMetadata?: ModelTypes["UserRecurringPaymentItemMetadata"] | undefined,
	listUserRecurringPaymentItemMetadata: Array<ModelTypes["UserRecurringPaymentItemMetadata"]>,
	paginateUserRecurringPaymentItemMetadata: ModelTypes["UserRecurringPaymentItemMetadataConnection"],
	getUpcomingUserRecurringPaymentMetadata?: ModelTypes["UpcomingUserRecurringPaymentMetadata"] | undefined,
	listUpcomingUserRecurringPaymentMetadata: Array<ModelTypes["UpcomingUserRecurringPaymentMetadata"]>,
	paginateUpcomingUserRecurringPaymentMetadata: ModelTypes["UpcomingUserRecurringPaymentMetadataConnection"],
	getUserAreaStats?: ModelTypes["UserAreaStats"] | undefined,
	listUserAreaStats: Array<ModelTypes["UserAreaStats"]>,
	paginateUserAreaStats: ModelTypes["UserAreaStatsConnection"],
	getUserCurrencyStats?: ModelTypes["UserCurrencyStats"] | undefined,
	listUserCurrencyStats: Array<ModelTypes["UserCurrencyStats"]>,
	paginateUserCurrencyStats: ModelTypes["UserCurrencyStatsConnection"],
	getUserOrganizationStats?: ModelTypes["UserOrganizationStats"] | undefined,
	listUserOrganizationStats: Array<ModelTypes["UserOrganizationStats"]>,
	paginateUserOrganizationStats: ModelTypes["UserOrganizationStatsConnection"],
	getUserPostStats?: ModelTypes["UserPostStats"] | undefined,
	listUserPostStats: Array<ModelTypes["UserPostStats"]>,
	paginateUserPostStats: ModelTypes["UserPostStatsConnection"],
	getUserStats?: ModelTypes["UserStats"] | undefined,
	listUserStats: Array<ModelTypes["UserStats"]>,
	paginateUserStats: ModelTypes["UserStatsConnection"],
	getTextImageList?: ModelTypes["TextImageList"] | undefined,
	listTextImageList: Array<ModelTypes["TextImageList"]>,
	paginateTextImageList: ModelTypes["TextImageListConnection"],
	validateCreateTextImageList: ModelTypes["_ValidationResult"],
	validateUpdateTextImageList: ModelTypes["_ValidationResult"],
	getTextImageListItem?: ModelTypes["TextImageListItem"] | undefined,
	listTextImageListItem: Array<ModelTypes["TextImageListItem"]>,
	paginateTextImageListItem: ModelTypes["TextImageListItemConnection"],
	validateCreateTextImageListItem: ModelTypes["_ValidationResult"],
	validateUpdateTextImageListItem: ModelTypes["_ValidationResult"],
	getPostCurrencySum?: ModelTypes["PostCurrencySum"] | undefined,
	listPostCurrencySum: Array<ModelTypes["PostCurrencySum"]>,
	paginatePostCurrencySum: ModelTypes["PostCurrencySumConnection"],
	getPostSum?: ModelTypes["PostSum"] | undefined,
	listPostSum: Array<ModelTypes["PostSum"]>,
	paginatePostSum: ModelTypes["PostSumConnection"],
	getPostFundraisingProgress?: ModelTypes["PostFundraisingProgress"] | undefined,
	listPostFundraisingProgress: Array<ModelTypes["PostFundraisingProgress"]>,
	paginatePostFundraisingProgress: ModelTypes["PostFundraisingProgressConnection"],
	getHeroCarouselItem?: ModelTypes["HeroCarouselItem"] | undefined,
	listHeroCarouselItem: Array<ModelTypes["HeroCarouselItem"]>,
	paginateHeroCarouselItem: ModelTypes["HeroCarouselItemConnection"],
	validateCreateHeroCarouselItem: ModelTypes["_ValidationResult"],
	validateUpdateHeroCarouselItem: ModelTypes["_ValidationResult"],
	transaction?: ModelTypes["QueryTransaction"] | undefined,
	_info?: ModelTypes["Info"] | undefined
};
	["_Schema"]: {
		enums: Array<ModelTypes["_Enum"]>,
	entities: Array<ModelTypes["_Entity"]>
};
	["_Enum"]: {
		name: string,
	values: Array<string>
};
	["_Entity"]: {
		name: string,
	customPrimaryAllowed: boolean,
	fields: Array<ModelTypes["_Field"]>,
	unique: Array<ModelTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
		fields: Array<string>
};
	["General"]: {
		_meta?: ModelTypes["GeneralMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["GeneralLocale"]>,
	allAreasIcon?: ModelTypes["Image"] | undefined,
	allOrganizationsIcon?: ModelTypes["Image"] | undefined,
	organizationList?: ModelTypes["PostOrganizationList"] | undefined,
	localesByLocale?: ModelTypes["GeneralLocale"] | undefined,
	localesBySeo?: ModelTypes["GeneralLocale"] | undefined,
	localesByAppStoreLink?: ModelTypes["GeneralLocale"] | undefined,
	localesByGooglePlayLink?: ModelTypes["GeneralLocale"] | undefined,
	paginateLocales: ModelTypes["GeneralLocaleConnection"]
};
	["GeneralMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	allAreasIcon?: ModelTypes["FieldMeta"] | undefined,
	allOrganizationsIcon?: ModelTypes["FieldMeta"] | undefined,
	organizationList?: ModelTypes["FieldMeta"] | undefined
};
	["FieldMeta"]: {
		readable?: boolean | undefined,
	updatable?: boolean | undefined
};
	["UUID"]:any;
	["One"]:One;
	["GeneralLocale"]: {
		_meta?: ModelTypes["GeneralLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["General"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	appStoreLink?: ModelTypes["Link"] | undefined,
	googlePlayLink?: ModelTypes["Link"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined
};
	["GeneralLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	appStoreLink?: ModelTypes["FieldMeta"] | undefined,
	googlePlayLink?: ModelTypes["FieldMeta"] | undefined,
	allAreasDescription?: ModelTypes["FieldMeta"] | undefined,
	allOrganizationsDescription?: ModelTypes["FieldMeta"] | undefined
};
	["GeneralWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["GeneralLocaleWhere"] | undefined,
	allAreasIcon?: ModelTypes["ImageWhere"] | undefined,
	allOrganizationsIcon?: ModelTypes["ImageWhere"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListWhere"] | undefined,
	and?: Array<ModelTypes["GeneralWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GeneralWhere"] | undefined> | undefined,
	not?: ModelTypes["GeneralWhere"] | undefined
};
	["UUIDCondition"]: {
	and?: Array<ModelTypes["UUIDCondition"]> | undefined,
	or?: Array<ModelTypes["UUIDCondition"]> | undefined,
	not?: ModelTypes["UUIDCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["UUID"] | undefined,
	notEq?: ModelTypes["UUID"] | undefined,
	in?: Array<ModelTypes["UUID"]> | undefined,
	notIn?: Array<ModelTypes["UUID"]> | undefined,
	lt?: ModelTypes["UUID"] | undefined,
	lte?: ModelTypes["UUID"] | undefined,
	gt?: ModelTypes["UUID"] | undefined,
	gte?: ModelTypes["UUID"] | undefined
};
	["OneCondition"]: {
	and?: Array<ModelTypes["OneCondition"]> | undefined,
	or?: Array<ModelTypes["OneCondition"]> | undefined,
	not?: ModelTypes["OneCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["One"] | undefined,
	notEq?: ModelTypes["One"] | undefined,
	in?: Array<ModelTypes["One"]> | undefined,
	notIn?: Array<ModelTypes["One"]> | undefined,
	lt?: ModelTypes["One"] | undefined,
	lte?: ModelTypes["One"] | undefined,
	gt?: ModelTypes["One"] | undefined,
	gte?: ModelTypes["One"] | undefined
};
	["GeneralLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["GeneralWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	appStoreLink?: ModelTypes["LinkWhere"] | undefined,
	googlePlayLink?: ModelTypes["LinkWhere"] | undefined,
	allAreasDescription?: ModelTypes["StringCondition"] | undefined,
	allOrganizationsDescription?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["GeneralLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GeneralLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["GeneralLocaleWhere"] | undefined
};
	["LocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	code?: ModelTypes["StringCondition"] | undefined,
	label?: ModelTypes["StringCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	generals?: ModelTypes["GeneralLocaleWhere"] | undefined,
	genericPages?: ModelTypes["GenericPageLocaleWhere"] | undefined,
	posts?: ModelTypes["PostLocaleWhere"] | undefined,
	postAreas?: ModelTypes["PostAreaLocaleWhere"] | undefined,
	postOrganizations?: ModelTypes["PostOrganizationLocaleWhere"] | undefined,
	headers?: ModelTypes["HeaderLocaleWhere"] | undefined,
	footers?: ModelTypes["FooterLocaleWhere"] | undefined,
	genericPageAboutSettings?: ModelTypes["GenericPageAboutSettingsLocaleWhere"] | undefined,
	postRevisions?: ModelTypes["PostRevisionLocaleWhere"] | undefined,
	flagImage?: ModelTypes["ImageWhere"] | undefined,
	feedPages?: ModelTypes["FeedPageLocaleWhere"] | undefined,
	recurringPaymentPages?: ModelTypes["RecurringPaymentPageLocaleWhere"] | undefined,
	givenGiftsPages?: ModelTypes["GivenGiftsPageLocaleWhere"] | undefined,
	receivedGiftsPages?: ModelTypes["ReceivedGiftsPageLocaleWhere"] | undefined,
	reportPages?: ModelTypes["ReportPageLocaleWhere"] | undefined,
	reportNavigations?: ModelTypes["ReportNavigationLocaleWhere"] | undefined,
	scheduledNotifications?: ModelTypes["ScheduledNotificationLocaleWhere"] | undefined,
	sentPayments?: ModelTypes["SentPaymentLocaleWhere"] | undefined,
	and?: Array<ModelTypes["LocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["LocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["LocaleWhere"] | undefined
};
	["StringCondition"]: {
	and?: Array<ModelTypes["StringCondition"]> | undefined,
	or?: Array<ModelTypes["StringCondition"]> | undefined,
	not?: ModelTypes["StringCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: string | undefined,
	notEq?: string | undefined,
	in?: Array<string> | undefined,
	notIn?: Array<string> | undefined,
	lt?: string | undefined,
	lte?: string | undefined,
	gt?: string | undefined,
	gte?: string | undefined,
	contains?: string | undefined,
	startsWith?: string | undefined,
	endsWith?: string | undefined,
	containsCI?: string | undefined,
	startsWithCI?: string | undefined,
	endsWithCI?: string | undefined
};
	["IntCondition"]: {
	and?: Array<ModelTypes["IntCondition"]> | undefined,
	or?: Array<ModelTypes["IntCondition"]> | undefined,
	not?: ModelTypes["IntCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["GenericPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["GenericPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["GenericPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GenericPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["GenericPageLocaleWhere"] | undefined
};
	["GenericPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locales?: ModelTypes["GenericPageLocaleWhere"] | undefined,
	type?: ModelTypes["GenericPageTypeCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	reportNavigation?: ModelTypes["ReportNavigationLocaleWhere"] | undefined,
	and?: Array<ModelTypes["GenericPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GenericPageWhere"] | undefined> | undefined,
	not?: ModelTypes["GenericPageWhere"] | undefined
};
	["GenericPageTypeCondition"]: {
	and?: Array<ModelTypes["GenericPageTypeCondition"]> | undefined,
	or?: Array<ModelTypes["GenericPageTypeCondition"]> | undefined,
	not?: ModelTypes["GenericPageTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["GenericPageType"] | undefined,
	notEq?: ModelTypes["GenericPageType"] | undefined,
	in?: Array<ModelTypes["GenericPageType"]> | undefined,
	notIn?: Array<ModelTypes["GenericPageType"]> | undefined,
	lt?: ModelTypes["GenericPageType"] | undefined,
	lte?: ModelTypes["GenericPageType"] | undefined,
	gt?: ModelTypes["GenericPageType"] | undefined,
	gte?: ModelTypes["GenericPageType"] | undefined
};
	["GenericPageType"]:GenericPageType;
	["ReportNavigationLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["ReportNavigationWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	pages?: ModelTypes["GenericPageWhere"] | undefined,
	and?: Array<ModelTypes["ReportNavigationLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ReportNavigationLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["ReportNavigationLocaleWhere"] | undefined
};
	["ReportNavigationWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["ReportNavigationLocaleWhere"] | undefined,
	and?: Array<ModelTypes["ReportNavigationWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ReportNavigationWhere"] | undefined> | undefined,
	not?: ModelTypes["ReportNavigationWhere"] | undefined
};
	["ContentWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	blocks?: ModelTypes["ContentBlockWhere"] | undefined,
	and?: Array<ModelTypes["ContentWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContentWhere"] | undefined> | undefined,
	not?: ModelTypes["ContentWhere"] | undefined
};
	["ContentBlockWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	json?: ModelTypes["StringCondition"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	references?: ModelTypes["ContentReferenceWhere"] | undefined,
	and?: Array<ModelTypes["ContentBlockWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContentBlockWhere"] | undefined> | undefined,
	not?: ModelTypes["ContentBlockWhere"] | undefined
};
	["ContentReferenceWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["ContentReferenceTypeCondition"] | undefined,
	primaryText?: ModelTypes["StringCondition"] | undefined,
	block?: ModelTypes["ContentBlockWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	linkables?: ModelTypes["ContentReferenceLinkableItemWhere"] | undefined,
	video?: ModelTypes["VideoWhere"] | undefined,
	secondaryText?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	contentAlignment?: ModelTypes["ContentAlignmentCondition"] | undefined,
	valueList?: ModelTypes["ValueListWhere"] | undefined,
	imageLinkList?: ModelTypes["ImageLinkListWhere"] | undefined,
	areaList?: ModelTypes["PostAreaListWhere"] | undefined,
	isAppsVisible?: ModelTypes["BooleanCondition"] | undefined,
	accordion?: ModelTypes["AccordionWhere"] | undefined,
	media?: ModelTypes["MediumListWhere"] | undefined,
	memberList?: ModelTypes["MemberListWhere"] | undefined,
	asideMediaContentLayout?: ModelTypes["AsideMediaContentLayoutCondition"] | undefined,
	isAsideMediaContentMobileLayout?: ModelTypes["BooleanCondition"] | undefined,
	form?: ModelTypes["FormWhere"] | undefined,
	isTitleBigger?: ModelTypes["BooleanCondition"] | undefined,
	contentWithoutBlocks?: ModelTypes["ContentWhere"] | undefined,
	heroCarousel?: ModelTypes["HeroCarouselWhere"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListWhere"] | undefined,
	isCentered?: ModelTypes["BooleanCondition"] | undefined,
	posts?: ModelTypes["PostWhere"] | undefined,
	textImageList?: ModelTypes["TextImageListWhere"] | undefined,
	and?: Array<ModelTypes["ContentReferenceWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContentReferenceWhere"] | undefined> | undefined,
	not?: ModelTypes["ContentReferenceWhere"] | undefined
};
	["ContentReferenceTypeCondition"]: {
	and?: Array<ModelTypes["ContentReferenceTypeCondition"]> | undefined,
	or?: Array<ModelTypes["ContentReferenceTypeCondition"]> | undefined,
	not?: ModelTypes["ContentReferenceTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["ContentReferenceType"] | undefined,
	notEq?: ModelTypes["ContentReferenceType"] | undefined,
	in?: Array<ModelTypes["ContentReferenceType"]> | undefined,
	notIn?: Array<ModelTypes["ContentReferenceType"]> | undefined,
	lt?: ModelTypes["ContentReferenceType"] | undefined,
	lte?: ModelTypes["ContentReferenceType"] | undefined,
	gt?: ModelTypes["ContentReferenceType"] | undefined,
	gte?: ModelTypes["ContentReferenceType"] | undefined
};
	["ContentReferenceType"]:ContentReferenceType;
	["ImageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	url?: ModelTypes["StringCondition"] | undefined,
	width?: ModelTypes["IntCondition"] | undefined,
	height?: ModelTypes["IntCondition"] | undefined,
	size?: ModelTypes["IntCondition"] | undefined,
	type?: ModelTypes["StringCondition"] | undefined,
	alt?: ModelTypes["StringCondition"] | undefined,
	fileName?: ModelTypes["StringCondition"] | undefined,
	focalPointX?: ModelTypes["FloatCondition"] | undefined,
	focalPointY?: ModelTypes["FloatCondition"] | undefined,
	and?: Array<ModelTypes["ImageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageWhere"] | undefined
};
	["FloatCondition"]: {
	and?: Array<ModelTypes["FloatCondition"]> | undefined,
	or?: Array<ModelTypes["FloatCondition"]> | undefined,
	not?: ModelTypes["FloatCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["ContentReferenceLinkableItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	item?: ModelTypes["LinkableWhere"] | undefined,
	reference?: ModelTypes["ContentReferenceWhere"] | undefined,
	and?: Array<ModelTypes["ContentReferenceLinkableItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContentReferenceLinkableItemWhere"] | undefined> | undefined,
	not?: ModelTypes["ContentReferenceLinkableItemWhere"] | undefined
};
	["LinkableWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	url?: ModelTypes["StringCondition"] | undefined,
	genericPage?: ModelTypes["GenericPageLocaleWhere"] | undefined,
	post?: ModelTypes["PostLocaleWhere"] | undefined,
	postArea?: ModelTypes["PostAreaLocaleWhere"] | undefined,
	postOrganization?: ModelTypes["PostOrganizationLocaleWhere"] | undefined,
	reportPage?: ModelTypes["ReportPageLocaleWhere"] | undefined,
	givenGiftsPage?: ModelTypes["GivenGiftsPageLocaleWhere"] | undefined,
	receivedGiftsPage?: ModelTypes["ReceivedGiftsPageLocaleWhere"] | undefined,
	and?: Array<ModelTypes["LinkableWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["LinkableWhere"] | undefined> | undefined,
	not?: ModelTypes["LinkableWhere"] | undefined
};
	["PostLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	root?: ModelTypes["PostWhere"] | undefined,
	paymentName?: ModelTypes["StringCondition"] | undefined,
	publishedAt?: ModelTypes["DateTimeCondition"] | undefined,
	and?: Array<ModelTypes["PostLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["PostLocaleWhere"] | undefined
};
	["SeoWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	description?: ModelTypes["StringCondition"] | undefined,
	ogTitle?: ModelTypes["StringCondition"] | undefined,
	ogDescription?: ModelTypes["StringCondition"] | undefined,
	noIndex?: ModelTypes["BooleanCondition"] | undefined,
	noFollow?: ModelTypes["BooleanCondition"] | undefined,
	ogImage?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["SeoWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SeoWhere"] | undefined> | undefined,
	not?: ModelTypes["SeoWhere"] | undefined
};
	["BooleanCondition"]: {
	and?: Array<ModelTypes["BooleanCondition"]> | undefined,
	or?: Array<ModelTypes["BooleanCondition"]> | undefined,
	not?: ModelTypes["BooleanCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: boolean | undefined,
	notEq?: boolean | undefined,
	in?: Array<boolean> | undefined,
	notIn?: Array<boolean> | undefined,
	lt?: boolean | undefined,
	lte?: boolean | undefined,
	gt?: boolean | undefined,
	gte?: boolean | undefined
};
	["PostWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	specificSymbol?: ModelTypes["IntCondition"] | undefined,
	activeRevision?: ModelTypes["PostRevisionWhere"] | undefined,
	revisions?: ModelTypes["PostRevisionWhere"] | undefined,
	locales?: ModelTypes["PostLocaleWhere"] | undefined,
	isPinnedInArea?: ModelTypes["BooleanCondition"] | undefined,
	isPinnedInOrganization?: ModelTypes["BooleanCondition"] | undefined,
	state?: ModelTypes["PostStateCondition"] | undefined,
	meta?: ModelTypes["PostMetaDataWhere"] | undefined,
	isPublishedAtHidden?: ModelTypes["BooleanCondition"] | undefined,
	heroCarousel?: ModelTypes["HeroCarouselWhere"] | undefined,
	reportPage?: ModelTypes["ReportPageLocaleWhere"] | undefined,
	content?: ModelTypes["ContentReferenceWhere"] | undefined,
	fundraiseIsActive?: ModelTypes["BooleanCondition"] | undefined,
	fundraiseEndDate?: ModelTypes["DateCondition"] | undefined,
	fundraiseTargetAmount?: ModelTypes["IntCondition"] | undefined,
	fundraiseFakeAddOnAmount?: ModelTypes["IntCondition"] | undefined,
	fundraiseCurrency?: ModelTypes["CurrencyWhere"] | undefined,
	fundraiseCurrencySums?: ModelTypes["PostCurrencySumWhere"] | undefined,
	fundraiseSum?: ModelTypes["PostSumWhere"] | undefined,
	fundraisingProgress?: ModelTypes["PostFundraisingProgressWhere"] | undefined,
	and?: Array<ModelTypes["PostWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostWhere"] | undefined> | undefined,
	not?: ModelTypes["PostWhere"] | undefined
};
	["PostOrganizationWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	posts?: ModelTypes["PostWhere"] | undefined,
	icon?: ModelTypes["ImageWhere"] | undefined,
	locales?: ModelTypes["PostOrganizationLocaleWhere"] | undefined,
	specificSymbol?: ModelTypes["IntCondition"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	meta?: ModelTypes["PostOrganizationMetaDataWhere"] | undefined,
	mobileHeroImage?: ModelTypes["ImageWhere"] | undefined,
	isHidden?: ModelTypes["BooleanCondition"] | undefined,
	color?: ModelTypes["StringCondition"] | undefined,
	plainIcon?: ModelTypes["ImageWhere"] | undefined,
	desktopHeroImage?: ModelTypes["ImageWhere"] | undefined,
	sentPayments?: ModelTypes["SentPaymentWhere"] | undefined,
	organizationCurrencySums?: ModelTypes["PostOrganizationCurrencySumWhere"] | undefined,
	organizationSum?: ModelTypes["PostOrganizationSumWhere"] | undefined,
	and?: Array<ModelTypes["PostOrganizationWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostOrganizationWhere"] | undefined> | undefined,
	not?: ModelTypes["PostOrganizationWhere"] | undefined
};
	["PostOrganizationLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	description?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	root?: ModelTypes["PostOrganizationWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	domain?: ModelTypes["LinkWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	translatedByAI?: ModelTypes["BooleanCondition"] | undefined,
	and?: Array<ModelTypes["PostOrganizationLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostOrganizationLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["PostOrganizationLocaleWhere"] | undefined
};
	["LinkWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["LinkEnumCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	externalLink?: ModelTypes["StringCondition"] | undefined,
	internalLink?: ModelTypes["LinkableWhere"] | undefined,
	isTargetBlank?: ModelTypes["BooleanCondition"] | undefined,
	and?: Array<ModelTypes["LinkWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["LinkWhere"] | undefined> | undefined,
	not?: ModelTypes["LinkWhere"] | undefined
};
	["LinkEnumCondition"]: {
	and?: Array<ModelTypes["LinkEnumCondition"]> | undefined,
	or?: Array<ModelTypes["LinkEnumCondition"]> | undefined,
	not?: ModelTypes["LinkEnumCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["LinkEnum"] | undefined,
	notEq?: ModelTypes["LinkEnum"] | undefined,
	in?: Array<ModelTypes["LinkEnum"]> | undefined,
	notIn?: Array<ModelTypes["LinkEnum"]> | undefined,
	lt?: ModelTypes["LinkEnum"] | undefined,
	lte?: ModelTypes["LinkEnum"] | undefined,
	gt?: ModelTypes["LinkEnum"] | undefined,
	gte?: ModelTypes["LinkEnum"] | undefined
};
	["LinkEnum"]:LinkEnum;
	["PostAreaWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	icon?: ModelTypes["ImageWhere"] | undefined,
	locales?: ModelTypes["PostAreaLocaleWhere"] | undefined,
	regionListOverride?: ModelTypes["DonationAmountsRegionListWhere"] | undefined,
	color?: ModelTypes["StringCondition"] | undefined,
	posts?: ModelTypes["PostWhere"] | undefined,
	specificSymbol?: ModelTypes["IntCondition"] | undefined,
	region?: ModelTypes["RegionWhere"] | undefined,
	meta?: ModelTypes["PostAreaMetaDataWhere"] | undefined,
	mobileHeroImage?: ModelTypes["ImageWhere"] | undefined,
	plainIcon?: ModelTypes["ImageWhere"] | undefined,
	sentPayments?: ModelTypes["SentPaymentWhere"] | undefined,
	areaSentPaymentCurrencySums?: ModelTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaSentPaymentSumWhere"] | undefined,
	areaCurrencySums?: ModelTypes["PostAreaCurrencySumWhere"] | undefined,
	areaSum?: ModelTypes["PostAreaSumWhere"] | undefined,
	and?: Array<ModelTypes["PostAreaWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaWhere"] | undefined
};
	["PostAreaLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	description?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	root?: ModelTypes["PostAreaWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	banner?: ModelTypes["AppBannerWhere"] | undefined,
	shortDescription?: ModelTypes["StringCondition"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	translatedByAI?: ModelTypes["BooleanCondition"] | undefined,
	and?: Array<ModelTypes["PostAreaLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaLocaleWhere"] | undefined
};
	["AppBannerWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	imageSmall?: ModelTypes["ImageWhere"] | undefined,
	imageBig?: ModelTypes["ImageWhere"] | undefined,
	textContent?: ModelTypes["ContentWhere"] | undefined,
	and?: Array<ModelTypes["AppBannerWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["AppBannerWhere"] | undefined> | undefined,
	not?: ModelTypes["AppBannerWhere"] | undefined
};
	["DonationAmountsRegionListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	regions?: ModelTypes["DonationAmountsRegionItemWhere"] | undefined,
	donation?: ModelTypes["DonationWhere"] | undefined,
	and?: Array<ModelTypes["DonationAmountsRegionListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["DonationAmountsRegionListWhere"] | undefined> | undefined,
	not?: ModelTypes["DonationAmountsRegionListWhere"] | undefined
};
	["DonationAmountsRegionItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	items?: ModelTypes["DonationAmountItemWhere"] | undefined,
	list?: ModelTypes["DonationAmountsRegionListWhere"] | undefined,
	region?: ModelTypes["RegionWhere"] | undefined,
	minimumAmount?: ModelTypes["FloatCondition"] | undefined,
	and?: Array<ModelTypes["DonationAmountsRegionItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["DonationAmountsRegionItemWhere"] | undefined> | undefined,
	not?: ModelTypes["DonationAmountsRegionItemWhere"] | undefined
};
	["DonationAmountItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	amount?: ModelTypes["FloatCondition"] | undefined,
	regionItem?: ModelTypes["DonationAmountsRegionItemWhere"] | undefined,
	and?: Array<ModelTypes["DonationAmountItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["DonationAmountItemWhere"] | undefined> | undefined,
	not?: ModelTypes["DonationAmountItemWhere"] | undefined
};
	["RegionWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	code?: ModelTypes["StringCondition"] | undefined,
	label?: ModelTypes["StringCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	enabledPaymentMethods?: ModelTypes["RegionPaymentMethodWhere"] | undefined,
	donationItems?: ModelTypes["DonationAmountsRegionItemWhere"] | undefined,
	timezone?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["RegionWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["RegionWhere"] | undefined> | undefined,
	not?: ModelTypes["RegionWhere"] | undefined
};
	["CurrencyWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	identifier?: ModelTypes["CurrencyIdentifierCondition"] | undefined,
	label?: ModelTypes["StringCondition"] | undefined,
	sign?: ModelTypes["StringCondition"] | undefined,
	signAlignment?: ModelTypes["CurrencySignAlignmentCondition"] | undefined,
	defaultDonationAmount?: ModelTypes["IntCondition"] | undefined,
	rateAgainstCzk?: ModelTypes["FloatCondition"] | undefined,
	areaSentPaymentCurrencySums?: ModelTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined,
	areaCurrencySums?: ModelTypes["PostAreaCurrencySumWhere"] | undefined,
	organizationCurrencySums?: ModelTypes["PostOrganizationCurrencySumWhere"] | undefined,
	postCurrencySums?: ModelTypes["PostCurrencySumWhere"] | undefined,
	and?: Array<ModelTypes["CurrencyWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CurrencyWhere"] | undefined> | undefined,
	not?: ModelTypes["CurrencyWhere"] | undefined
};
	["CurrencyIdentifierCondition"]: {
	and?: Array<ModelTypes["CurrencyIdentifierCondition"]> | undefined,
	or?: Array<ModelTypes["CurrencyIdentifierCondition"]> | undefined,
	not?: ModelTypes["CurrencyIdentifierCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["CurrencyIdentifier"] | undefined,
	notEq?: ModelTypes["CurrencyIdentifier"] | undefined,
	in?: Array<ModelTypes["CurrencyIdentifier"]> | undefined,
	notIn?: Array<ModelTypes["CurrencyIdentifier"]> | undefined,
	lt?: ModelTypes["CurrencyIdentifier"] | undefined,
	lte?: ModelTypes["CurrencyIdentifier"] | undefined,
	gt?: ModelTypes["CurrencyIdentifier"] | undefined,
	gte?: ModelTypes["CurrencyIdentifier"] | undefined
};
	["CurrencyIdentifier"]:CurrencyIdentifier;
	["CurrencySignAlignmentCondition"]: {
	and?: Array<ModelTypes["CurrencySignAlignmentCondition"]> | undefined,
	or?: Array<ModelTypes["CurrencySignAlignmentCondition"]> | undefined,
	not?: ModelTypes["CurrencySignAlignmentCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["CurrencySignAlignment"] | undefined,
	notEq?: ModelTypes["CurrencySignAlignment"] | undefined,
	in?: Array<ModelTypes["CurrencySignAlignment"]> | undefined,
	notIn?: Array<ModelTypes["CurrencySignAlignment"]> | undefined,
	lt?: ModelTypes["CurrencySignAlignment"] | undefined,
	lte?: ModelTypes["CurrencySignAlignment"] | undefined,
	gt?: ModelTypes["CurrencySignAlignment"] | undefined,
	gte?: ModelTypes["CurrencySignAlignment"] | undefined
};
	["CurrencySignAlignment"]:CurrencySignAlignment;
	["PostAreaSentPaymentCurrencySumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	currencyIdentifier?: ModelTypes["StringCondition"] | undefined,
	rateAgainstCzk?: ModelTypes["FloatCondition"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	and?: Array<ModelTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined
};
	["PostAreaCurrencySumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	currencyIdentifier?: ModelTypes["StringCondition"] | undefined,
	rateAgainstCzk?: ModelTypes["FloatCondition"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	and?: Array<ModelTypes["PostAreaCurrencySumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaCurrencySumWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaCurrencySumWhere"] | undefined
};
	["PostOrganizationCurrencySumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	currencyIdentifier?: ModelTypes["StringCondition"] | undefined,
	rateAgainstCzk?: ModelTypes["FloatCondition"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	and?: Array<ModelTypes["PostOrganizationCurrencySumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostOrganizationCurrencySumWhere"] | undefined> | undefined,
	not?: ModelTypes["PostOrganizationCurrencySumWhere"] | undefined
};
	["PostCurrencySumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	currencyIdentifier?: ModelTypes["StringCondition"] | undefined,
	rateAgainstCzk?: ModelTypes["FloatCondition"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	and?: Array<ModelTypes["PostCurrencySumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostCurrencySumWhere"] | undefined> | undefined,
	not?: ModelTypes["PostCurrencySumWhere"] | undefined
};
	["RegionPaymentMethodWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	allowRecurringPayments?: ModelTypes["BooleanCondition"] | undefined,
	region?: ModelTypes["RegionWhere"] | undefined,
	method?: ModelTypes["PaymentMethodsCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	and?: Array<ModelTypes["RegionPaymentMethodWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["RegionPaymentMethodWhere"] | undefined> | undefined,
	not?: ModelTypes["RegionPaymentMethodWhere"] | undefined
};
	["PaymentMethodsCondition"]: {
	and?: Array<ModelTypes["PaymentMethodsCondition"]> | undefined,
	or?: Array<ModelTypes["PaymentMethodsCondition"]> | undefined,
	not?: ModelTypes["PaymentMethodsCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["PaymentMethods"] | undefined,
	notEq?: ModelTypes["PaymentMethods"] | undefined,
	in?: Array<ModelTypes["PaymentMethods"]> | undefined,
	notIn?: Array<ModelTypes["PaymentMethods"]> | undefined,
	lt?: ModelTypes["PaymentMethods"] | undefined,
	lte?: ModelTypes["PaymentMethods"] | undefined,
	gt?: ModelTypes["PaymentMethods"] | undefined,
	gte?: ModelTypes["PaymentMethods"] | undefined
};
	["PaymentMethods"]:PaymentMethods;
	["DonationWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	regionList?: ModelTypes["DonationAmountsRegionListWhere"] | undefined,
	and?: Array<ModelTypes["DonationWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["DonationWhere"] | undefined> | undefined,
	not?: ModelTypes["DonationWhere"] | undefined
};
	["PostAreaMetaDataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	nameWithFallback?: ModelTypes["StringCondition"] | undefined,
	formattedSpecificSymbol?: ModelTypes["StringCondition"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["StringCondition"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	and?: Array<ModelTypes["PostAreaMetaDataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaMetaDataWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaMetaDataWhere"] | undefined
};
	["SentPaymentWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	cents?: ModelTypes["IntCondition"] | undefined,
	sendAt?: ModelTypes["DateTimeCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	locales?: ModelTypes["SentPaymentLocaleWhere"] | undefined,
	and?: Array<ModelTypes["SentPaymentWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SentPaymentWhere"] | undefined> | undefined,
	not?: ModelTypes["SentPaymentWhere"] | undefined
};
	["DateTimeCondition"]: {
	and?: Array<ModelTypes["DateTimeCondition"]> | undefined,
	or?: Array<ModelTypes["DateTimeCondition"]> | undefined,
	not?: ModelTypes["DateTimeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["DateTime"] | undefined,
	notEq?: ModelTypes["DateTime"] | undefined,
	in?: Array<ModelTypes["DateTime"]> | undefined,
	notIn?: Array<ModelTypes["DateTime"]> | undefined,
	lt?: ModelTypes["DateTime"] | undefined,
	lte?: ModelTypes["DateTime"] | undefined,
	gt?: ModelTypes["DateTime"] | undefined,
	gte?: ModelTypes["DateTime"] | undefined
};
	["DateTime"]:any;
	["SentPaymentLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	organizationText?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["SentPaymentWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	and?: Array<ModelTypes["SentPaymentLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SentPaymentLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["SentPaymentLocaleWhere"] | undefined
};
	["PostAreaSentPaymentSumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	czkPercentage?: ModelTypes["FloatCondition"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	and?: Array<ModelTypes["PostAreaSentPaymentSumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaSentPaymentSumWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaSentPaymentSumWhere"] | undefined
};
	["PostAreaSumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	czkPercentage?: ModelTypes["FloatCondition"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	and?: Array<ModelTypes["PostAreaSumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaSumWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaSumWhere"] | undefined
};
	["PostOrganizationMetaDataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	nameWithFallback?: ModelTypes["StringCondition"] | undefined,
	formattedSpecificSymbol?: ModelTypes["StringCondition"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["StringCondition"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	and?: Array<ModelTypes["PostOrganizationMetaDataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostOrganizationMetaDataWhere"] | undefined> | undefined,
	not?: ModelTypes["PostOrganizationMetaDataWhere"] | undefined
};
	["PostOrganizationSumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	czkPercentage?: ModelTypes["FloatCondition"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	and?: Array<ModelTypes["PostOrganizationSumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostOrganizationSumWhere"] | undefined> | undefined,
	not?: ModelTypes["PostOrganizationSumWhere"] | undefined
};
	["PostRevisionWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	createdById?: ModelTypes["UUIDCondition"] | undefined,
	publishedById?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["PostTypeCondition"] | undefined,
	publishedAt?: ModelTypes["DateTimeCondition"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	tileImage?: ModelTypes["ImageWhere"] | undefined,
	tileVideo?: ModelTypes["VideoWhere"] | undefined,
	heroImage?: ModelTypes["ImageWhere"] | undefined,
	locales?: ModelTypes["PostRevisionLocaleWhere"] | undefined,
	regionListOverride?: ModelTypes["DonationAmountsRegionListWhere"] | undefined,
	isOrganizationVisible?: ModelTypes["BooleanCondition"] | undefined,
	sendPublishNotifications?: ModelTypes["BooleanCondition"] | undefined,
	isArchived?: ModelTypes["BooleanCondition"] | undefined,
	and?: Array<ModelTypes["PostRevisionWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostRevisionWhere"] | undefined> | undefined,
	not?: ModelTypes["PostRevisionWhere"] | undefined
};
	["PostTypeCondition"]: {
	and?: Array<ModelTypes["PostTypeCondition"]> | undefined,
	or?: Array<ModelTypes["PostTypeCondition"]> | undefined,
	not?: ModelTypes["PostTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["PostType"] | undefined,
	notEq?: ModelTypes["PostType"] | undefined,
	in?: Array<ModelTypes["PostType"]> | undefined,
	notIn?: Array<ModelTypes["PostType"]> | undefined,
	lt?: ModelTypes["PostType"] | undefined,
	lte?: ModelTypes["PostType"] | undefined,
	gt?: ModelTypes["PostType"] | undefined,
	gte?: ModelTypes["PostType"] | undefined
};
	["PostType"]:PostType;
	["VideoWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	url?: ModelTypes["StringCondition"] | undefined,
	width?: ModelTypes["IntCondition"] | undefined,
	height?: ModelTypes["IntCondition"] | undefined,
	size?: ModelTypes["IntCondition"] | undefined,
	type?: ModelTypes["StringCondition"] | undefined,
	poster?: ModelTypes["ImageWhere"] | undefined,
	shapeType?: ModelTypes["VideoShapeTypeCondition"] | undefined,
	and?: Array<ModelTypes["VideoWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["VideoWhere"] | undefined> | undefined,
	not?: ModelTypes["VideoWhere"] | undefined
};
	["VideoShapeTypeCondition"]: {
	and?: Array<ModelTypes["VideoShapeTypeCondition"]> | undefined,
	or?: Array<ModelTypes["VideoShapeTypeCondition"]> | undefined,
	not?: ModelTypes["VideoShapeTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["VideoShapeType"] | undefined,
	notEq?: ModelTypes["VideoShapeType"] | undefined,
	in?: Array<ModelTypes["VideoShapeType"]> | undefined,
	notIn?: Array<ModelTypes["VideoShapeType"]> | undefined,
	lt?: ModelTypes["VideoShapeType"] | undefined,
	lte?: ModelTypes["VideoShapeType"] | undefined,
	gt?: ModelTypes["VideoShapeType"] | undefined,
	gte?: ModelTypes["VideoShapeType"] | undefined
};
	["VideoShapeType"]:VideoShapeType;
	["PostRevisionLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["PostRevisionWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	leadContent?: ModelTypes["ContentWhere"] | undefined,
	publishNotificationText?: ModelTypes["StringCondition"] | undefined,
	translatedByAI?: ModelTypes["BooleanCondition"] | undefined,
	and?: Array<ModelTypes["PostRevisionLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostRevisionLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["PostRevisionLocaleWhere"] | undefined
};
	["PostStateCondition"]: {
	and?: Array<ModelTypes["PostStateCondition"]> | undefined,
	or?: Array<ModelTypes["PostStateCondition"]> | undefined,
	not?: ModelTypes["PostStateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["PostState"] | undefined,
	notEq?: ModelTypes["PostState"] | undefined,
	in?: Array<ModelTypes["PostState"]> | undefined,
	notIn?: Array<ModelTypes["PostState"]> | undefined,
	lt?: ModelTypes["PostState"] | undefined,
	lte?: ModelTypes["PostState"] | undefined,
	gt?: ModelTypes["PostState"] | undefined,
	gte?: ModelTypes["PostState"] | undefined
};
	["PostState"]:PostState;
	["PostMetaDataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	titleWithFallback?: ModelTypes["StringCondition"] | undefined,
	formattedSpecificSymbol?: ModelTypes["StringCondition"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["StringCondition"] | undefined,
	latestRevision?: ModelTypes["PostRevisionWhere"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	and?: Array<ModelTypes["PostMetaDataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostMetaDataWhere"] | undefined> | undefined,
	not?: ModelTypes["PostMetaDataWhere"] | undefined
};
	["HeroCarouselWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateCondition"] | undefined,
	posts?: ModelTypes["PostWhere"] | undefined,
	items?: ModelTypes["HeroCarouselItemWhere"] | undefined,
	and?: Array<ModelTypes["HeroCarouselWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HeroCarouselWhere"] | undefined> | undefined,
	not?: ModelTypes["HeroCarouselWhere"] | undefined
};
	["DateCondition"]: {
	and?: Array<ModelTypes["DateCondition"]> | undefined,
	or?: Array<ModelTypes["DateCondition"]> | undefined,
	not?: ModelTypes["DateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["Date"] | undefined,
	notEq?: ModelTypes["Date"] | undefined,
	in?: Array<ModelTypes["Date"]> | undefined,
	notIn?: Array<ModelTypes["Date"]> | undefined,
	lt?: ModelTypes["Date"] | undefined,
	lte?: ModelTypes["Date"] | undefined,
	gt?: ModelTypes["Date"] | undefined,
	gte?: ModelTypes["Date"] | undefined
};
	["Date"]:any;
	["HeroCarouselItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["HeroCarouselWhere"] | undefined,
	item?: ModelTypes["PostWhere"] | undefined,
	and?: Array<ModelTypes["HeroCarouselItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HeroCarouselItemWhere"] | undefined> | undefined,
	not?: ModelTypes["HeroCarouselItemWhere"] | undefined
};
	["ReportPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	postTitle?: ModelTypes["StringCondition"] | undefined,
	giftTitle?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	root?: ModelTypes["ReportPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	posts?: ModelTypes["PostWhere"] | undefined,
	and?: Array<ModelTypes["ReportPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ReportPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["ReportPageLocaleWhere"] | undefined
};
	["ReportPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["ReportPageLocaleWhere"] | undefined,
	and?: Array<ModelTypes["ReportPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ReportPageWhere"] | undefined> | undefined,
	not?: ModelTypes["ReportPageWhere"] | undefined
};
	["PostSumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	czkPercentage?: ModelTypes["FloatCondition"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	and?: Array<ModelTypes["PostSumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostSumWhere"] | undefined> | undefined,
	not?: ModelTypes["PostSumWhere"] | undefined
};
	["PostFundraisingProgressWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	progress?: ModelTypes["FloatCondition"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	and?: Array<ModelTypes["PostFundraisingProgressWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostFundraisingProgressWhere"] | undefined> | undefined,
	not?: ModelTypes["PostFundraisingProgressWhere"] | undefined
};
	["GivenGiftsPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	giftTitle?: ModelTypes["StringCondition"] | undefined,
	giftText?: ModelTypes["StringCondition"] | undefined,
	note?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["GivenGiftsPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	and?: Array<ModelTypes["GivenGiftsPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GivenGiftsPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["GivenGiftsPageLocaleWhere"] | undefined
};
	["GivenGiftsPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["GivenGiftsPageLocaleWhere"] | undefined,
	and?: Array<ModelTypes["GivenGiftsPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GivenGiftsPageWhere"] | undefined> | undefined,
	not?: ModelTypes["GivenGiftsPageWhere"] | undefined
};
	["ReceivedGiftsPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	giftTitle?: ModelTypes["StringCondition"] | undefined,
	giftText?: ModelTypes["StringCondition"] | undefined,
	note?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	root?: ModelTypes["ReceivedGiftsPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	and?: Array<ModelTypes["ReceivedGiftsPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ReceivedGiftsPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["ReceivedGiftsPageLocaleWhere"] | undefined
};
	["ReceivedGiftsPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["ReceivedGiftsPageLocaleWhere"] | undefined,
	and?: Array<ModelTypes["ReceivedGiftsPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ReceivedGiftsPageWhere"] | undefined> | undefined,
	not?: ModelTypes["ReceivedGiftsPageWhere"] | undefined
};
	["ContentAlignmentCondition"]: {
	and?: Array<ModelTypes["ContentAlignmentCondition"]> | undefined,
	or?: Array<ModelTypes["ContentAlignmentCondition"]> | undefined,
	not?: ModelTypes["ContentAlignmentCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["ContentAlignment"] | undefined,
	notEq?: ModelTypes["ContentAlignment"] | undefined,
	in?: Array<ModelTypes["ContentAlignment"]> | undefined,
	notIn?: Array<ModelTypes["ContentAlignment"]> | undefined,
	lt?: ModelTypes["ContentAlignment"] | undefined,
	lte?: ModelTypes["ContentAlignment"] | undefined,
	gt?: ModelTypes["ContentAlignment"] | undefined,
	gte?: ModelTypes["ContentAlignment"] | undefined
};
	["ContentAlignment"]:ContentAlignment;
	["ValueListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["ValueItemWhere"] | undefined,
	and?: Array<ModelTypes["ValueListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ValueListWhere"] | undefined> | undefined,
	not?: ModelTypes["ValueListWhere"] | undefined
};
	["ValueItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["ValueListWhere"] | undefined,
	item?: ModelTypes["ValueWhere"] | undefined,
	and?: Array<ModelTypes["ValueItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ValueItemWhere"] | undefined> | undefined,
	not?: ModelTypes["ValueItemWhere"] | undefined
};
	["ValueWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	textContent?: ModelTypes["ContentWhere"] | undefined,
	and?: Array<ModelTypes["ValueWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ValueWhere"] | undefined> | undefined,
	not?: ModelTypes["ValueWhere"] | undefined
};
	["ImageLinkListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["ImageLinkItemWhere"] | undefined,
	and?: Array<ModelTypes["ImageLinkListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageLinkListWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageLinkListWhere"] | undefined
};
	["ImageLinkItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["ImageLinkListWhere"] | undefined,
	item?: ModelTypes["ImageLinkWhere"] | undefined,
	and?: Array<ModelTypes["ImageLinkItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageLinkItemWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageLinkItemWhere"] | undefined
};
	["ImageLinkWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["ImageLinkWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageLinkWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageLinkWhere"] | undefined
};
	["PostAreaListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["PostAreaListItemWhere"] | undefined,
	and?: Array<ModelTypes["PostAreaListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaListWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaListWhere"] | undefined
};
	["PostAreaListItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["PostAreaListWhere"] | undefined,
	item?: ModelTypes["PostAreaWhere"] | undefined,
	and?: Array<ModelTypes["PostAreaListItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostAreaListItemWhere"] | undefined> | undefined,
	not?: ModelTypes["PostAreaListItemWhere"] | undefined
};
	["AccordionWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["AccordionItemWhere"] | undefined,
	and?: Array<ModelTypes["AccordionWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["AccordionWhere"] | undefined> | undefined,
	not?: ModelTypes["AccordionWhere"] | undefined
};
	["AccordionItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["AccordionWhere"] | undefined,
	descriptionContent?: ModelTypes["ContentWhere"] | undefined,
	and?: Array<ModelTypes["AccordionItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["AccordionItemWhere"] | undefined> | undefined,
	not?: ModelTypes["AccordionItemWhere"] | undefined
};
	["MediumListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["MediumItemWhere"] | undefined,
	and?: Array<ModelTypes["MediumListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["MediumListWhere"] | undefined> | undefined,
	not?: ModelTypes["MediumListWhere"] | undefined
};
	["MediumItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["MediumListWhere"] | undefined,
	medium?: ModelTypes["MediumWhere"] | undefined,
	and?: Array<ModelTypes["MediumItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["MediumItemWhere"] | undefined> | undefined,
	not?: ModelTypes["MediumItemWhere"] | undefined
};
	["MediumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["MediumTypeCondition"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	video?: ModelTypes["VideoWhere"] | undefined,
	and?: Array<ModelTypes["MediumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["MediumWhere"] | undefined> | undefined,
	not?: ModelTypes["MediumWhere"] | undefined
};
	["MediumTypeCondition"]: {
	and?: Array<ModelTypes["MediumTypeCondition"]> | undefined,
	or?: Array<ModelTypes["MediumTypeCondition"]> | undefined,
	not?: ModelTypes["MediumTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["MediumType"] | undefined,
	notEq?: ModelTypes["MediumType"] | undefined,
	in?: Array<ModelTypes["MediumType"]> | undefined,
	notIn?: Array<ModelTypes["MediumType"]> | undefined,
	lt?: ModelTypes["MediumType"] | undefined,
	lte?: ModelTypes["MediumType"] | undefined,
	gt?: ModelTypes["MediumType"] | undefined,
	gte?: ModelTypes["MediumType"] | undefined
};
	["MediumType"]:MediumType;
	["MemberListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["MemberListItemWhere"] | undefined,
	and?: Array<ModelTypes["MemberListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["MemberListWhere"] | undefined> | undefined,
	not?: ModelTypes["MemberListWhere"] | undefined
};
	["MemberListItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	position?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["MemberListWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	descriptionContent?: ModelTypes["ContentWhere"] | undefined,
	and?: Array<ModelTypes["MemberListItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["MemberListItemWhere"] | undefined> | undefined,
	not?: ModelTypes["MemberListItemWhere"] | undefined
};
	["AsideMediaContentLayoutCondition"]: {
	and?: Array<ModelTypes["AsideMediaContentLayoutCondition"]> | undefined,
	or?: Array<ModelTypes["AsideMediaContentLayoutCondition"]> | undefined,
	not?: ModelTypes["AsideMediaContentLayoutCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["AsideMediaContentLayout"] | undefined,
	notEq?: ModelTypes["AsideMediaContentLayout"] | undefined,
	in?: Array<ModelTypes["AsideMediaContentLayout"]> | undefined,
	notIn?: Array<ModelTypes["AsideMediaContentLayout"]> | undefined,
	lt?: ModelTypes["AsideMediaContentLayout"] | undefined,
	lte?: ModelTypes["AsideMediaContentLayout"] | undefined,
	gt?: ModelTypes["AsideMediaContentLayout"] | undefined,
	gte?: ModelTypes["AsideMediaContentLayout"] | undefined
};
	["AsideMediaContentLayout"]:AsideMediaContentLayout;
	["FormWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	type?: ModelTypes["FormTypeCondition"] | undefined,
	tax?: ModelTypes["FilledTaxFormWhere"] | undefined,
	and?: Array<ModelTypes["FormWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FormWhere"] | undefined> | undefined,
	not?: ModelTypes["FormWhere"] | undefined
};
	["FormTypeCondition"]: {
	and?: Array<ModelTypes["FormTypeCondition"]> | undefined,
	or?: Array<ModelTypes["FormTypeCondition"]> | undefined,
	not?: ModelTypes["FormTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["FormType"] | undefined,
	notEq?: ModelTypes["FormType"] | undefined,
	in?: Array<ModelTypes["FormType"]> | undefined,
	notIn?: Array<ModelTypes["FormType"]> | undefined,
	lt?: ModelTypes["FormType"] | undefined,
	lte?: ModelTypes["FormType"] | undefined,
	gt?: ModelTypes["FormType"] | undefined,
	gte?: ModelTypes["FormType"] | undefined
};
	["FormType"]:FormType;
	["FilledTaxFormWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	publishedAt?: ModelTypes["DateTimeCondition"] | undefined,
	userId?: ModelTypes["StringCondition"] | undefined,
	email?: ModelTypes["StringCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	vatId?: ModelTypes["StringCondition"] | undefined,
	address1?: ModelTypes["StringCondition"] | undefined,
	address2?: ModelTypes["StringCondition"] | undefined,
	city?: ModelTypes["StringCondition"] | undefined,
	postalCode?: ModelTypes["StringCondition"] | undefined,
	state?: ModelTypes["StringCondition"] | undefined,
	country?: ModelTypes["RegionWhere"] | undefined,
	dateFrom?: ModelTypes["DateCondition"] | undefined,
	dateTo?: ModelTypes["DateCondition"] | undefined,
	year?: ModelTypes["IntCondition"] | undefined,
	isPdfGenerated?: ModelTypes["BooleanCondition"] | undefined,
	pdfObjectKey?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["FilledTaxFormWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FilledTaxFormWhere"] | undefined> | undefined,
	not?: ModelTypes["FilledTaxFormWhere"] | undefined
};
	["PostOrganizationListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["PostOrganizationListItemWhere"] | undefined,
	and?: Array<ModelTypes["PostOrganizationListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostOrganizationListWhere"] | undefined> | undefined,
	not?: ModelTypes["PostOrganizationListWhere"] | undefined
};
	["PostOrganizationListItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["PostOrganizationListWhere"] | undefined,
	item?: ModelTypes["PostOrganizationWhere"] | undefined,
	type?: ModelTypes["PostOrganizationListItemTypeCondition"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["PostOrganizationListItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostOrganizationListItemWhere"] | undefined> | undefined,
	not?: ModelTypes["PostOrganizationListItemWhere"] | undefined
};
	["PostOrganizationListItemTypeCondition"]: {
	and?: Array<ModelTypes["PostOrganizationListItemTypeCondition"]> | undefined,
	or?: Array<ModelTypes["PostOrganizationListItemTypeCondition"]> | undefined,
	not?: ModelTypes["PostOrganizationListItemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["PostOrganizationListItemType"] | undefined,
	notEq?: ModelTypes["PostOrganizationListItemType"] | undefined,
	in?: Array<ModelTypes["PostOrganizationListItemType"]> | undefined,
	notIn?: Array<ModelTypes["PostOrganizationListItemType"]> | undefined,
	lt?: ModelTypes["PostOrganizationListItemType"] | undefined,
	lte?: ModelTypes["PostOrganizationListItemType"] | undefined,
	gt?: ModelTypes["PostOrganizationListItemType"] | undefined,
	gte?: ModelTypes["PostOrganizationListItemType"] | undefined
};
	["PostOrganizationListItemType"]:PostOrganizationListItemType;
	["TextImageListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["TextImageListItemWhere"] | undefined,
	and?: Array<ModelTypes["TextImageListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TextImageListWhere"] | undefined> | undefined,
	not?: ModelTypes["TextImageListWhere"] | undefined
};
	["TextImageListItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["TextImageListWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["TextImageListItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TextImageListItemWhere"] | undefined> | undefined,
	not?: ModelTypes["TextImageListItemWhere"] | undefined
};
	["HeaderLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["HeaderWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	links?: ModelTypes["LinkListWhere"] | undefined,
	and?: Array<ModelTypes["HeaderLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HeaderLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["HeaderLocaleWhere"] | undefined
};
	["HeaderWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	locales?: ModelTypes["HeaderLocaleWhere"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListWhere"] | undefined,
	and?: Array<ModelTypes["HeaderWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HeaderWhere"] | undefined> | undefined,
	not?: ModelTypes["HeaderWhere"] | undefined
};
	["LinkListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["LinkItemWhere"] | undefined,
	and?: Array<ModelTypes["LinkListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["LinkListWhere"] | undefined> | undefined,
	not?: ModelTypes["LinkListWhere"] | undefined
};
	["LinkItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["LinkListWhere"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["LinkItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["LinkItemWhere"] | undefined> | undefined,
	not?: ModelTypes["LinkItemWhere"] | undefined
};
	["FooterLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	copyright?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["FooterWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	linkList?: ModelTypes["LinkListWhere"] | undefined,
	contactEmail?: ModelTypes["StringCondition"] | undefined,
	addressInfo?: ModelTypes["ContentWhere"] | undefined,
	imageLinkList?: ModelTypes["ImageLinkListWhere"] | undefined,
	and?: Array<ModelTypes["FooterLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FooterLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["FooterLocaleWhere"] | undefined
};
	["FooterWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["FooterLocaleWhere"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["FooterWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FooterWhere"] | undefined> | undefined,
	not?: ModelTypes["FooterWhere"] | undefined
};
	["GenericPageAboutSettingsLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["GenericPageAboutSettingsWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	linkGroups?: ModelTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined,
	and?: Array<ModelTypes["GenericPageAboutSettingsLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GenericPageAboutSettingsLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["GenericPageAboutSettingsLocaleWhere"] | undefined
};
	["GenericPageAboutSettingsWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["GenericPageAboutSettingsLocaleWhere"] | undefined,
	and?: Array<ModelTypes["GenericPageAboutSettingsWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GenericPageAboutSettingsWhere"] | undefined> | undefined,
	not?: ModelTypes["GenericPageAboutSettingsWhere"] | undefined
};
	["GenericPageAboutGroupLinksLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	settings?: ModelTypes["GenericPageAboutSettingsLocaleWhere"] | undefined,
	linkList?: ModelTypes["LinkListWhere"] | undefined,
	and?: Array<ModelTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined
};
	["FeedPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["FeedPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	heroTiles?: ModelTypes["TileListWhere"] | undefined,
	sectionList?: ModelTypes["FeedPageSectionWhere"] | undefined,
	cardList?: ModelTypes["CardListWhere"] | undefined,
	storyGuideList?: ModelTypes["StoryGuideListWhere"] | undefined,
	and?: Array<ModelTypes["FeedPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FeedPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["FeedPageLocaleWhere"] | undefined
};
	["FeedPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["FeedPageLocaleWhere"] | undefined,
	and?: Array<ModelTypes["FeedPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FeedPageWhere"] | undefined> | undefined,
	not?: ModelTypes["FeedPageWhere"] | undefined
};
	["TileListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	size?: ModelTypes["TileListSizeCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	items?: ModelTypes["TileItemWhere"] | undefined,
	areaType?: ModelTypes["PostAreaWhere"] | undefined,
	and?: Array<ModelTypes["TileListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TileListWhere"] | undefined> | undefined,
	not?: ModelTypes["TileListWhere"] | undefined
};
	["TileListSizeCondition"]: {
	and?: Array<ModelTypes["TileListSizeCondition"]> | undefined,
	or?: Array<ModelTypes["TileListSizeCondition"]> | undefined,
	not?: ModelTypes["TileListSizeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["TileListSize"] | undefined,
	notEq?: ModelTypes["TileListSize"] | undefined,
	in?: Array<ModelTypes["TileListSize"]> | undefined,
	notIn?: Array<ModelTypes["TileListSize"]> | undefined,
	lt?: ModelTypes["TileListSize"] | undefined,
	lte?: ModelTypes["TileListSize"] | undefined,
	gt?: ModelTypes["TileListSize"] | undefined,
	gte?: ModelTypes["TileListSize"] | undefined
};
	["TileListSize"]:TileListSize;
	["TileItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	type?: ModelTypes["TileItemTypeCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	description?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["TileListWhere"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	and?: Array<ModelTypes["TileItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TileItemWhere"] | undefined> | undefined,
	not?: ModelTypes["TileItemWhere"] | undefined
};
	["TileItemTypeCondition"]: {
	and?: Array<ModelTypes["TileItemTypeCondition"]> | undefined,
	or?: Array<ModelTypes["TileItemTypeCondition"]> | undefined,
	not?: ModelTypes["TileItemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["TileItemType"] | undefined,
	notEq?: ModelTypes["TileItemType"] | undefined,
	in?: Array<ModelTypes["TileItemType"]> | undefined,
	notIn?: Array<ModelTypes["TileItemType"]> | undefined,
	lt?: ModelTypes["TileItemType"] | undefined,
	lte?: ModelTypes["TileItemType"] | undefined,
	gt?: ModelTypes["TileItemType"] | undefined,
	gte?: ModelTypes["TileItemType"] | undefined
};
	["TileItemType"]:TileItemType;
	["FeedPageSectionWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	feedPageLocale?: ModelTypes["FeedPageLocaleWhere"] | undefined,
	tileStripeList?: ModelTypes["FeedPageTileStripeWhere"] | undefined,
	and?: Array<ModelTypes["FeedPageSectionWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FeedPageSectionWhere"] | undefined> | undefined,
	not?: ModelTypes["FeedPageSectionWhere"] | undefined
};
	["FeedPageTileStripeWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	section?: ModelTypes["FeedPageSectionWhere"] | undefined,
	tileList?: ModelTypes["TileListWhere"] | undefined,
	and?: Array<ModelTypes["FeedPageTileStripeWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FeedPageTileStripeWhere"] | undefined> | undefined,
	not?: ModelTypes["FeedPageTileStripeWhere"] | undefined
};
	["CardListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["CardItemWhere"] | undefined,
	and?: Array<ModelTypes["CardListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CardListWhere"] | undefined> | undefined,
	not?: ModelTypes["CardListWhere"] | undefined
};
	["CardItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	description?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["CardListWhere"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["CardItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CardItemWhere"] | undefined> | undefined,
	not?: ModelTypes["CardItemWhere"] | undefined
};
	["StoryGuideListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["StoryGuideItemWhere"] | undefined,
	and?: Array<ModelTypes["StoryGuideListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["StoryGuideListWhere"] | undefined> | undefined,
	not?: ModelTypes["StoryGuideListWhere"] | undefined
};
	["StoryGuideItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["StoryGuideListWhere"] | undefined,
	guide?: ModelTypes["StoryGuideWhere"] | undefined,
	and?: Array<ModelTypes["StoryGuideItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["StoryGuideItemWhere"] | undefined> | undefined,
	not?: ModelTypes["StoryGuideItemWhere"] | undefined
};
	["StoryGuideWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	mediaType?: ModelTypes["MediaTypeCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	secondaryImage?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["StoryGuideWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["StoryGuideWhere"] | undefined> | undefined,
	not?: ModelTypes["StoryGuideWhere"] | undefined
};
	["MediaTypeCondition"]: {
	and?: Array<ModelTypes["MediaTypeCondition"]> | undefined,
	or?: Array<ModelTypes["MediaTypeCondition"]> | undefined,
	not?: ModelTypes["MediaTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["MediaType"] | undefined,
	notEq?: ModelTypes["MediaType"] | undefined,
	in?: Array<ModelTypes["MediaType"]> | undefined,
	notIn?: Array<ModelTypes["MediaType"]> | undefined,
	lt?: ModelTypes["MediaType"] | undefined,
	lte?: ModelTypes["MediaType"] | undefined,
	gt?: ModelTypes["MediaType"] | undefined,
	gte?: ModelTypes["MediaType"] | undefined
};
	["MediaType"]:MediaType;
	["RecurringPaymentPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["RecurringPaymentPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	favouritePosts?: ModelTypes["PostListWhere"] | undefined,
	storyGuideList?: ModelTypes["StoryGuideListWhere"] | undefined,
	and?: Array<ModelTypes["RecurringPaymentPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["RecurringPaymentPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["RecurringPaymentPageLocaleWhere"] | undefined
};
	["RecurringPaymentPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["RecurringPaymentPageLocaleWhere"] | undefined,
	and?: Array<ModelTypes["RecurringPaymentPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["RecurringPaymentPageWhere"] | undefined> | undefined,
	not?: ModelTypes["RecurringPaymentPageWhere"] | undefined
};
	["PostListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["PostListItemWhere"] | undefined,
	and?: Array<ModelTypes["PostListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostListWhere"] | undefined> | undefined,
	not?: ModelTypes["PostListWhere"] | undefined
};
	["PostListItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["PostListWhere"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	and?: Array<ModelTypes["PostListItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PostListItemWhere"] | undefined> | undefined,
	not?: ModelTypes["PostListItemWhere"] | undefined
};
	["ScheduledNotificationLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	description?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["ScheduledNotificationWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	and?: Array<ModelTypes["ScheduledNotificationLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ScheduledNotificationLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["ScheduledNotificationLocaleWhere"] | undefined
};
	["ScheduledNotificationWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	localMsFromMidnight?: ModelTypes["IntCondition"] | undefined,
	scheduledDate?: ModelTypes["DateCondition"] | undefined,
	internalTitle?: ModelTypes["StringCondition"] | undefined,
	target?: ModelTypes["NotificationTargetGroupWhere"] | undefined,
	locales?: ModelTypes["ScheduledNotificationLocaleWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	completedAt?: ModelTypes["DateTimeCondition"] | undefined,
	processedNotifications?: ModelTypes["ProcessedNotificationSourceWhere"] | undefined,
	and?: Array<ModelTypes["ScheduledNotificationWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ScheduledNotificationWhere"] | undefined> | undefined,
	not?: ModelTypes["ScheduledNotificationWhere"] | undefined
};
	["NotificationTargetGroupWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["NotificationTargetTypeCondition"] | undefined,
	regions?: ModelTypes["RegionWhere"] | undefined,
	and?: Array<ModelTypes["NotificationTargetGroupWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["NotificationTargetGroupWhere"] | undefined> | undefined,
	not?: ModelTypes["NotificationTargetGroupWhere"] | undefined
};
	["NotificationTargetTypeCondition"]: {
	and?: Array<ModelTypes["NotificationTargetTypeCondition"]> | undefined,
	or?: Array<ModelTypes["NotificationTargetTypeCondition"]> | undefined,
	not?: ModelTypes["NotificationTargetTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["NotificationTargetType"] | undefined,
	notEq?: ModelTypes["NotificationTargetType"] | undefined,
	in?: Array<ModelTypes["NotificationTargetType"]> | undefined,
	notIn?: Array<ModelTypes["NotificationTargetType"]> | undefined,
	lt?: ModelTypes["NotificationTargetType"] | undefined,
	lte?: ModelTypes["NotificationTargetType"] | undefined,
	gt?: ModelTypes["NotificationTargetType"] | undefined,
	gte?: ModelTypes["NotificationTargetType"] | undefined
};
	["NotificationTargetType"]:NotificationTargetType;
	["ProcessedNotificationSourceWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["ProcessedNotificationSourceTypeCondition"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationWhere"] | undefined,
	donationReminderUser?: ModelTypes["UserWhere"] | undefined,
	scheduledNotification?: ModelTypes["ScheduledNotificationWhere"] | undefined,
	and?: Array<ModelTypes["ProcessedNotificationSourceWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ProcessedNotificationSourceWhere"] | undefined> | undefined,
	not?: ModelTypes["ProcessedNotificationSourceWhere"] | undefined
};
	["ProcessedNotificationSourceTypeCondition"]: {
	and?: Array<ModelTypes["ProcessedNotificationSourceTypeCondition"]> | undefined,
	or?: Array<ModelTypes["ProcessedNotificationSourceTypeCondition"]> | undefined,
	not?: ModelTypes["ProcessedNotificationSourceTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	notEq?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	in?: Array<ModelTypes["ProcessedNotificationSourceType"]> | undefined,
	notIn?: Array<ModelTypes["ProcessedNotificationSourceType"]> | undefined,
	lt?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	lte?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	gt?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	gte?: ModelTypes["ProcessedNotificationSourceType"] | undefined
};
	["ProcessedNotificationSourceType"]:ProcessedNotificationSourceType;
	["ProcessedNotificationWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	topic?: ModelTypes["StringCondition"] | undefined,
	sentAt?: ModelTypes["DateTimeCondition"] | undefined,
	errorMessage?: ModelTypes["StringCondition"] | undefined,
	errorCode?: ModelTypes["StringCondition"] | undefined,
	isSuccess?: ModelTypes["BooleanCondition"] | undefined,
	source?: ModelTypes["ProcessedNotificationSourceWhere"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	body?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["ProcessedNotificationWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ProcessedNotificationWhere"] | undefined> | undefined,
	not?: ModelTypes["ProcessedNotificationWhere"] | undefined
};
	["UserWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	tenantPersonId?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	email?: ModelTypes["StringCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	payments?: ModelTypes["UserPaymentWhere"] | undefined,
	variableSymbol?: ModelTypes["IntCondition"] | undefined,
	lastActiveAt?: ModelTypes["DateTimeCondition"] | undefined,
	region?: ModelTypes["RegionWhere"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	recurringPayments?: ModelTypes["UserRecurringPaymentWhere"] | undefined,
	stripeId?: ModelTypes["StringCondition"] | undefined,
	isDeactivated?: ModelTypes["BooleanCondition"] | undefined,
	onBehalfDonations?: ModelTypes["OnBehalfDonationWhere"] | undefined,
	publicProfileSecret?: ModelTypes["StringCondition"] | undefined,
	publicProfileCustomNote?: ModelTypes["StringCondition"] | undefined,
	publicProfileCustomNoteEnabled?: ModelTypes["BooleanCondition"] | undefined,
	donationConfirmationEmailEnabled?: ModelTypes["BooleanCondition"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	signedUp?: ModelTypes["BooleanCondition"] | undefined,
	devices?: ModelTypes["DeviceWhere"] | undefined,
	processedNotifications?: ModelTypes["ProcessedNotificationSourceWhere"] | undefined,
	areaStats?: ModelTypes["UserAreaStatsWhere"] | undefined,
	organizationStats?: ModelTypes["UserOrganizationStatsWhere"] | undefined,
	postStats?: ModelTypes["UserPostStatsWhere"] | undefined,
	currencyStats?: ModelTypes["UserCurrencyStatsWhere"] | undefined,
	stats?: ModelTypes["UserStatsWhere"] | undefined,
	and?: Array<ModelTypes["UserWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserWhere"] | undefined> | undefined,
	not?: ModelTypes["UserWhere"] | undefined
};
	["UserPaymentWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	cents?: ModelTypes["IntCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	specificSymbol?: ModelTypes["StringCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	order?: ModelTypes["UserPaymentOrderIdWhere"] | undefined,
	csobPayment?: ModelTypes["CsobPaymentWhere"] | undefined,
	stripePayment?: ModelTypes["StripePaymentWhere"] | undefined,
	recurringPaymentItem?: ModelTypes["UserRecurringPaymentItemWhere"] | undefined,
	method?: ModelTypes["UserPaymentMethodCondition"] | undefined,
	region?: ModelTypes["RegionWhere"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	isReusable?: ModelTypes["BooleanCondition"] | undefined,
	onBehalfDonation?: ModelTypes["OnBehalfDonationWhere"] | undefined,
	triesCollection?: ModelTypes["UserPaymentTriesCollectionWhere"] | undefined,
	successEmailSentAt?: ModelTypes["DateTimeCondition"] | undefined,
	isSuccessful?: ModelTypes["BooleanCondition"] | undefined,
	isFinished?: ModelTypes["BooleanCondition"] | undefined,
	metadata?: ModelTypes["UserPaymentMetadataWhere"] | undefined,
	and?: Array<ModelTypes["UserPaymentWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserPaymentWhere"] | undefined> | undefined,
	not?: ModelTypes["UserPaymentWhere"] | undefined
};
	["UserPaymentOrderIdWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	seq?: ModelTypes["IntCondition"] | undefined,
	and?: Array<ModelTypes["UserPaymentOrderIdWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserPaymentOrderIdWhere"] | undefined> | undefined,
	not?: ModelTypes["UserPaymentOrderIdWhere"] | undefined
};
	["CsobPaymentWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	payId?: ModelTypes["StringCondition"] | undefined,
	statusChanges?: ModelTypes["CsobPaymentStatusChangeWhere"] | undefined,
	payment?: ModelTypes["UserPaymentWhere"] | undefined,
	originalPayId?: ModelTypes["StringCondition"] | undefined,
	metadata?: ModelTypes["CsobPaymentMetadataWhere"] | undefined,
	and?: Array<ModelTypes["CsobPaymentWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CsobPaymentWhere"] | undefined> | undefined,
	not?: ModelTypes["CsobPaymentWhere"] | undefined
};
	["CsobPaymentStatusChangeWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	dttm?: ModelTypes["StringCondition"] | undefined,
	status?: ModelTypes["IntCondition"] | undefined,
	resultCode?: ModelTypes["IntCondition"] | undefined,
	message?: ModelTypes["StringCondition"] | undefined,
	authCode?: ModelTypes["StringCondition"] | undefined,
	statusDetail?: ModelTypes["StringCondition"] | undefined,
	actions?: ModelTypes["StringCondition"] | undefined,
	payment?: ModelTypes["CsobPaymentWhere"] | undefined,
	and?: Array<ModelTypes["CsobPaymentStatusChangeWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CsobPaymentStatusChangeWhere"] | undefined> | undefined,
	not?: ModelTypes["CsobPaymentStatusChangeWhere"] | undefined
};
	["CsobPaymentMetadataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	status?: ModelTypes["IntCondition"] | undefined,
	isSuccessful?: ModelTypes["BooleanCondition"] | undefined,
	isFinished?: ModelTypes["BooleanCondition"] | undefined,
	resolvedOriginalPayId?: ModelTypes["StringCondition"] | undefined,
	csobPayment?: ModelTypes["CsobPaymentWhere"] | undefined,
	and?: Array<ModelTypes["CsobPaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CsobPaymentMetadataWhere"] | undefined> | undefined,
	not?: ModelTypes["CsobPaymentMetadataWhere"] | undefined
};
	["StripePaymentWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	identifier?: ModelTypes["StringCondition"] | undefined,
	statusChanges?: ModelTypes["StripePaymentStatusChangeWhere"] | undefined,
	payment?: ModelTypes["UserPaymentWhere"] | undefined,
	metadata?: ModelTypes["StripePaymentMetadataWhere"] | undefined,
	and?: Array<ModelTypes["StripePaymentWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["StripePaymentWhere"] | undefined> | undefined,
	not?: ModelTypes["StripePaymentWhere"] | undefined
};
	["StripePaymentStatusChangeWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	payment?: ModelTypes["StripePaymentWhere"] | undefined,
	timestamp?: ModelTypes["IntCondition"] | undefined,
	eventId?: ModelTypes["StringCondition"] | undefined,
	paymentIntentStatus?: ModelTypes["StripePaymentStatusChangePaymentIntentStatusCondition"] | undefined,
	and?: Array<ModelTypes["StripePaymentStatusChangeWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["StripePaymentStatusChangeWhere"] | undefined> | undefined,
	not?: ModelTypes["StripePaymentStatusChangeWhere"] | undefined
};
	["StripePaymentStatusChangePaymentIntentStatusCondition"]: {
	and?: Array<ModelTypes["StripePaymentStatusChangePaymentIntentStatusCondition"]> | undefined,
	or?: Array<ModelTypes["StripePaymentStatusChangePaymentIntentStatusCondition"]> | undefined,
	not?: ModelTypes["StripePaymentStatusChangePaymentIntentStatusCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	notEq?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	in?: Array<ModelTypes["StripePaymentStatusChangePaymentIntentStatus"]> | undefined,
	notIn?: Array<ModelTypes["StripePaymentStatusChangePaymentIntentStatus"]> | undefined,
	lt?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	lte?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	gt?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	gte?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined
};
	["StripePaymentStatusChangePaymentIntentStatus"]:StripePaymentStatusChangePaymentIntentStatus;
	["StripePaymentMetadataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	status?: ModelTypes["IntCondition"] | undefined,
	isSuccessful?: ModelTypes["BooleanCondition"] | undefined,
	isFinished?: ModelTypes["BooleanCondition"] | undefined,
	stripePayment?: ModelTypes["StripePaymentWhere"] | undefined,
	and?: Array<ModelTypes["StripePaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["StripePaymentMetadataWhere"] | undefined> | undefined,
	not?: ModelTypes["StripePaymentMetadataWhere"] | undefined
};
	["UserRecurringPaymentItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	recurrenceCounter?: ModelTypes["IntCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	taskId?: ModelTypes["StringCondition"] | undefined,
	payments?: ModelTypes["UserPaymentWhere"] | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentWhere"] | undefined,
	isFailed?: ModelTypes["BooleanCondition"] | undefined,
	failedEmailSentAt?: ModelTypes["DateTimeCondition"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemMetadataWhere"] | undefined,
	and?: Array<ModelTypes["UserRecurringPaymentItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserRecurringPaymentItemWhere"] | undefined> | undefined,
	not?: ModelTypes["UserRecurringPaymentItemWhere"] | undefined
};
	["UserRecurringPaymentWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	activeSince?: ModelTypes["DateTimeCondition"] | undefined,
	cancelledAt?: ModelTypes["DateTimeCondition"] | undefined,
	cents?: ModelTypes["IntCondition"] | undefined,
	interval?: ModelTypes["UserRecurringPaymentIntervalCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	items?: ModelTypes["UserRecurringPaymentItemWhere"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	meta?: ModelTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined,
	and?: Array<ModelTypes["UserRecurringPaymentWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserRecurringPaymentWhere"] | undefined> | undefined,
	not?: ModelTypes["UserRecurringPaymentWhere"] | undefined
};
	["UserRecurringPaymentIntervalCondition"]: {
	and?: Array<ModelTypes["UserRecurringPaymentIntervalCondition"]> | undefined,
	or?: Array<ModelTypes["UserRecurringPaymentIntervalCondition"]> | undefined,
	not?: ModelTypes["UserRecurringPaymentIntervalCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	notEq?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	in?: Array<ModelTypes["UserRecurringPaymentInterval"]> | undefined,
	notIn?: Array<ModelTypes["UserRecurringPaymentInterval"]> | undefined,
	lt?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	lte?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	gt?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	gte?: ModelTypes["UserRecurringPaymentInterval"] | undefined
};
	["UserRecurringPaymentInterval"]:UserRecurringPaymentInterval;
	["UpcomingUserRecurringPaymentMetadataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	recurrenceCounter?: ModelTypes["IntCondition"] | undefined,
	isBehindPayments?: ModelTypes["BooleanCondition"] | undefined,
	nextPaymentDate?: ModelTypes["DateTimeCondition"] | undefined,
	shouldBeProcessed?: ModelTypes["BooleanCondition"] | undefined,
	firstPayment?: ModelTypes["UserPaymentWhere"] | undefined,
	firstSuccessfulPayment?: ModelTypes["UserPaymentWhere"] | undefined,
	drivingPayment?: ModelTypes["UserPaymentWhere"] | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentWhere"] | undefined,
	and?: Array<ModelTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined> | undefined,
	not?: ModelTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined
};
	["UserRecurringPaymentItemMetadataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	isSuccessfullyPaid?: ModelTypes["BooleanCondition"] | undefined,
	shouldBeProcessed?: ModelTypes["BooleanCondition"] | undefined,
	firstPayment?: ModelTypes["UserPaymentWhere"] | undefined,
	lastPayment?: ModelTypes["UserPaymentWhere"] | undefined,
	firstSuccessfulPayment?: ModelTypes["UserPaymentWhere"] | undefined,
	drivingPayment?: ModelTypes["UserPaymentWhere"] | undefined,
	recurringPaymentItem?: ModelTypes["UserRecurringPaymentItemWhere"] | undefined,
	and?: Array<ModelTypes["UserRecurringPaymentItemMetadataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserRecurringPaymentItemMetadataWhere"] | undefined> | undefined,
	not?: ModelTypes["UserRecurringPaymentItemMetadataWhere"] | undefined
};
	["UserPaymentMethodCondition"]: {
	and?: Array<ModelTypes["UserPaymentMethodCondition"]> | undefined,
	or?: Array<ModelTypes["UserPaymentMethodCondition"]> | undefined,
	not?: ModelTypes["UserPaymentMethodCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["UserPaymentMethod"] | undefined,
	notEq?: ModelTypes["UserPaymentMethod"] | undefined,
	in?: Array<ModelTypes["UserPaymentMethod"]> | undefined,
	notIn?: Array<ModelTypes["UserPaymentMethod"]> | undefined,
	lt?: ModelTypes["UserPaymentMethod"] | undefined,
	lte?: ModelTypes["UserPaymentMethod"] | undefined,
	gt?: ModelTypes["UserPaymentMethod"] | undefined,
	gte?: ModelTypes["UserPaymentMethod"] | undefined
};
	["UserPaymentMethod"]:UserPaymentMethod;
	["OnBehalfDonationWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	secretCode?: ModelTypes["StringCondition"] | undefined,
	specificSymbol?: ModelTypes["StringCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	payments?: ModelTypes["UserPaymentWhere"] | undefined,
	onBehalfOf?: ModelTypes["UserWhere"] | undefined,
	meta?: ModelTypes["OnBehalfDonationMetadataWhere"] | undefined,
	and?: Array<ModelTypes["OnBehalfDonationWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["OnBehalfDonationWhere"] | undefined> | undefined,
	not?: ModelTypes["OnBehalfDonationWhere"] | undefined
};
	["OnBehalfDonationMetadataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	onBehalfOfDonation?: ModelTypes["OnBehalfDonationWhere"] | undefined,
	and?: Array<ModelTypes["OnBehalfDonationMetadataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["OnBehalfDonationMetadataWhere"] | undefined> | undefined,
	not?: ModelTypes["OnBehalfDonationMetadataWhere"] | undefined
};
	["UserPaymentTriesCollectionWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	cents?: ModelTypes["IntCondition"] | undefined,
	specificSymbol?: ModelTypes["StringCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	orderUrl?: ModelTypes["StringCondition"] | undefined,
	payment?: ModelTypes["UserPaymentWhere"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	onBehalfDonation?: ModelTypes["OnBehalfDonationWhere"] | undefined,
	recurring?: ModelTypes["UserRecurringPaymentWhere"] | undefined,
	metadata?: ModelTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined,
	metadataLocales?: ModelTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined,
	medium?: ModelTypes["PaymentMediumCondition"] | undefined,
	and?: Array<ModelTypes["UserPaymentTriesCollectionWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserPaymentTriesCollectionWhere"] | undefined> | undefined,
	not?: ModelTypes["UserPaymentTriesCollectionWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	triesCollection?: ModelTypes["UserPaymentTriesCollectionWhere"] | undefined,
	and?: Array<ModelTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined> | undefined,
	not?: ModelTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	parent?: ModelTypes["UserPaymentTriesCollectionWhere"] | undefined,
	and?: Array<ModelTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined
};
	["PaymentMediumCondition"]: {
	and?: Array<ModelTypes["PaymentMediumCondition"]> | undefined,
	or?: Array<ModelTypes["PaymentMediumCondition"]> | undefined,
	not?: ModelTypes["PaymentMediumCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["PaymentMedium"] | undefined,
	notEq?: ModelTypes["PaymentMedium"] | undefined,
	in?: Array<ModelTypes["PaymentMedium"]> | undefined,
	notIn?: Array<ModelTypes["PaymentMedium"]> | undefined,
	lt?: ModelTypes["PaymentMedium"] | undefined,
	lte?: ModelTypes["PaymentMedium"] | undefined,
	gt?: ModelTypes["PaymentMedium"] | undefined,
	gte?: ModelTypes["PaymentMedium"] | undefined
};
	["PaymentMedium"]:PaymentMedium;
	["UserPaymentMetadataWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	organizationUnfiltered?: ModelTypes["PostOrganizationWhere"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	countToUser?: ModelTypes["UserWhere"] | undefined,
	paymentType?: ModelTypes["StringCondition"] | undefined,
	statusLabel?: ModelTypes["StringCondition"] | undefined,
	isSuccessful?: ModelTypes["BooleanCondition"] | undefined,
	isFinished?: ModelTypes["BooleanCondition"] | undefined,
	needsCacheUpdate?: ModelTypes["BooleanCondition"] | undefined,
	isSuccessfulNotCached?: ModelTypes["BooleanCondition"] | undefined,
	isFinishedNotCached?: ModelTypes["BooleanCondition"] | undefined,
	userPayment?: ModelTypes["UserPaymentWhere"] | undefined,
	and?: Array<ModelTypes["UserPaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserPaymentMetadataWhere"] | undefined> | undefined,
	not?: ModelTypes["UserPaymentMetadataWhere"] | undefined
};
	["DeviceWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	fcmToken?: ModelTypes["StringCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	ipAddress?: ModelTypes["StringCondition"] | undefined,
	userAgent?: ModelTypes["StringCondition"] | undefined,
	lastActiveAt?: ModelTypes["DateTimeCondition"] | undefined,
	and?: Array<ModelTypes["DeviceWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["DeviceWhere"] | undefined> | undefined,
	not?: ModelTypes["DeviceWhere"] | undefined
};
	["UserAreaStatsWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	area?: ModelTypes["PostAreaWhere"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	and?: Array<ModelTypes["UserAreaStatsWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserAreaStatsWhere"] | undefined> | undefined,
	not?: ModelTypes["UserAreaStatsWhere"] | undefined
};
	["UserOrganizationStatsWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	organization?: ModelTypes["PostOrganizationWhere"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	and?: Array<ModelTypes["UserOrganizationStatsWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserOrganizationStatsWhere"] | undefined> | undefined,
	not?: ModelTypes["UserOrganizationStatsWhere"] | undefined
};
	["UserPostStatsWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	totalCents?: ModelTypes["IntCondition"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	and?: Array<ModelTypes["UserPostStatsWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserPostStatsWhere"] | undefined> | undefined,
	not?: ModelTypes["UserPostStatsWhere"] | undefined
};
	["UserCurrencyStatsWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	currency?: ModelTypes["CurrencyWhere"] | undefined,
	totalAmountPaymentsOnce?: ModelTypes["IntCondition"] | undefined,
	totalAmountPaymentsRegular?: ModelTypes["IntCondition"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	and?: Array<ModelTypes["UserCurrencyStatsWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserCurrencyStatsWhere"] | undefined> | undefined,
	not?: ModelTypes["UserCurrencyStatsWhere"] | undefined
};
	["UserStatsWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	totalPaymentsSuccessful?: ModelTypes["IntCondition"] | undefined,
	totalPaymentsUnsuccessful?: ModelTypes["IntCondition"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	and?: Array<ModelTypes["UserStatsWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["UserStatsWhere"] | undefined> | undefined,
	not?: ModelTypes["UserStatsWhere"] | undefined
};
	["Locale"]: {
		_meta?: ModelTypes["LocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	code: string,
	label?: string | undefined,
	order: number,
	generals: Array<ModelTypes["GeneralLocale"]>,
	genericPages: Array<ModelTypes["GenericPageLocale"]>,
	posts: Array<ModelTypes["PostLocale"]>,
	postAreas: Array<ModelTypes["PostAreaLocale"]>,
	postOrganizations: Array<ModelTypes["PostOrganizationLocale"]>,
	headers: Array<ModelTypes["HeaderLocale"]>,
	footers: Array<ModelTypes["FooterLocale"]>,
	genericPageAboutSettings: Array<ModelTypes["GenericPageAboutSettingsLocale"]>,
	postRevisions: Array<ModelTypes["PostRevisionLocale"]>,
	flagImage?: ModelTypes["Image"] | undefined,
	feedPages: Array<ModelTypes["FeedPageLocale"]>,
	recurringPaymentPages: Array<ModelTypes["RecurringPaymentPageLocale"]>,
	givenGiftsPages: Array<ModelTypes["GivenGiftsPageLocale"]>,
	receivedGiftsPages: Array<ModelTypes["ReceivedGiftsPageLocale"]>,
	reportPages: Array<ModelTypes["ReportPageLocale"]>,
	reportNavigations: Array<ModelTypes["ReportNavigationLocale"]>,
	scheduledNotifications: Array<ModelTypes["ScheduledNotificationLocale"]>,
	sentPayments: Array<ModelTypes["SentPaymentLocale"]>,
	generalsByRoot?: ModelTypes["GeneralLocale"] | undefined,
	generalsBySeo?: ModelTypes["GeneralLocale"] | undefined,
	generalsByAppStoreLink?: ModelTypes["GeneralLocale"] | undefined,
	generalsByGooglePlayLink?: ModelTypes["GeneralLocale"] | undefined,
	genericPagesByRoot?: ModelTypes["GenericPageLocale"] | undefined,
	genericPagesByContent?: ModelTypes["GenericPageLocale"] | undefined,
	genericPagesBySeo?: ModelTypes["GenericPageLocale"] | undefined,
	genericPagesByLink?: ModelTypes["GenericPageLocale"] | undefined,
	postsByRoot?: ModelTypes["PostLocale"] | undefined,
	postsByContent?: ModelTypes["PostLocale"] | undefined,
	postsBySeo?: ModelTypes["PostLocale"] | undefined,
	postsByLink?: ModelTypes["PostLocale"] | undefined,
	postAreasByRoot?: ModelTypes["PostAreaLocale"] | undefined,
	postAreasByLink?: ModelTypes["PostAreaLocale"] | undefined,
	postAreasBySeo?: ModelTypes["PostAreaLocale"] | undefined,
	postAreasByBanner?: ModelTypes["PostAreaLocale"] | undefined,
	postAreasByContent?: ModelTypes["PostAreaLocale"] | undefined,
	postOrganizationsByRoot?: ModelTypes["PostOrganizationLocale"] | undefined,
	postOrganizationsByLink?: ModelTypes["PostOrganizationLocale"] | undefined,
	postOrganizationsByDomain?: ModelTypes["PostOrganizationLocale"] | undefined,
	postOrganizationsBySeo?: ModelTypes["PostOrganizationLocale"] | undefined,
	postOrganizationsByContent?: ModelTypes["PostOrganizationLocale"] | undefined,
	headersByRoot?: ModelTypes["HeaderLocale"] | undefined,
	headersByLinks?: ModelTypes["HeaderLocale"] | undefined,
	footersByRoot?: ModelTypes["FooterLocale"] | undefined,
	footersByLinkList?: ModelTypes["FooterLocale"] | undefined,
	footersByAddressInfo?: ModelTypes["FooterLocale"] | undefined,
	footersByImageLinkList?: ModelTypes["FooterLocale"] | undefined,
	genericPageAboutSettingsByRoot?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	genericPageAboutSettingsByLinkGroups?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	postRevisionsByRoot?: ModelTypes["PostRevisionLocale"] | undefined,
	postRevisionsByContent?: ModelTypes["PostRevisionLocale"] | undefined,
	postRevisionsBySeo?: ModelTypes["PostRevisionLocale"] | undefined,
	postRevisionsByLeadContent?: ModelTypes["PostRevisionLocale"] | undefined,
	feedPagesByRoot?: ModelTypes["FeedPageLocale"] | undefined,
	feedPagesByHeroTiles?: ModelTypes["FeedPageLocale"] | undefined,
	feedPagesBySectionList?: ModelTypes["FeedPageLocale"] | undefined,
	feedPagesByCardList?: ModelTypes["FeedPageLocale"] | undefined,
	feedPagesByStoryGuideList?: ModelTypes["FeedPageLocale"] | undefined,
	recurringPaymentPagesByRoot?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	recurringPaymentPagesByFavouritePosts?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	recurringPaymentPagesByStoryGuideList?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	givenGiftsPagesByRoot?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	givenGiftsPagesByContent?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	givenGiftsPagesBySeo?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	givenGiftsPagesByLink?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	receivedGiftsPagesByRoot?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	receivedGiftsPagesByLink?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	receivedGiftsPagesByContent?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	receivedGiftsPagesBySeo?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	reportPagesByRoot?: ModelTypes["ReportPageLocale"] | undefined,
	reportPagesByLink?: ModelTypes["ReportPageLocale"] | undefined,
	reportPagesByContent?: ModelTypes["ReportPageLocale"] | undefined,
	reportPagesBySeo?: ModelTypes["ReportPageLocale"] | undefined,
	reportNavigationsByRoot?: ModelTypes["ReportNavigationLocale"] | undefined,
	scheduledNotificationsByRoot?: ModelTypes["ScheduledNotificationLocale"] | undefined,
	sentPaymentsByRoot?: ModelTypes["SentPaymentLocale"] | undefined,
	paginateGenerals: ModelTypes["GeneralLocaleConnection"],
	paginateGenericPages: ModelTypes["GenericPageLocaleConnection"],
	paginatePosts: ModelTypes["PostLocaleConnection"],
	paginatePostAreas: ModelTypes["PostAreaLocaleConnection"],
	paginatePostOrganizations: ModelTypes["PostOrganizationLocaleConnection"],
	paginateHeaders: ModelTypes["HeaderLocaleConnection"],
	paginateFooters: ModelTypes["FooterLocaleConnection"],
	paginateGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsLocaleConnection"],
	paginatePostRevisions: ModelTypes["PostRevisionLocaleConnection"],
	paginateFeedPages: ModelTypes["FeedPageLocaleConnection"],
	paginateRecurringPaymentPages: ModelTypes["RecurringPaymentPageLocaleConnection"],
	paginateGivenGiftsPages: ModelTypes["GivenGiftsPageLocaleConnection"],
	paginateReceivedGiftsPages: ModelTypes["ReceivedGiftsPageLocaleConnection"],
	paginateReportPages: ModelTypes["ReportPageLocaleConnection"],
	paginateReportNavigations: ModelTypes["ReportNavigationLocaleConnection"],
	paginateScheduledNotifications: ModelTypes["ScheduledNotificationLocaleConnection"],
	paginateSentPayments: ModelTypes["SentPaymentLocaleConnection"]
};
	["LocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	code?: ModelTypes["FieldMeta"] | undefined,
	label?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	generals?: ModelTypes["FieldMeta"] | undefined,
	genericPages?: ModelTypes["FieldMeta"] | undefined,
	posts?: ModelTypes["FieldMeta"] | undefined,
	postAreas?: ModelTypes["FieldMeta"] | undefined,
	postOrganizations?: ModelTypes["FieldMeta"] | undefined,
	headers?: ModelTypes["FieldMeta"] | undefined,
	footers?: ModelTypes["FieldMeta"] | undefined,
	genericPageAboutSettings?: ModelTypes["FieldMeta"] | undefined,
	postRevisions?: ModelTypes["FieldMeta"] | undefined,
	flagImage?: ModelTypes["FieldMeta"] | undefined,
	feedPages?: ModelTypes["FieldMeta"] | undefined,
	recurringPaymentPages?: ModelTypes["FieldMeta"] | undefined,
	givenGiftsPages?: ModelTypes["FieldMeta"] | undefined,
	receivedGiftsPages?: ModelTypes["FieldMeta"] | undefined,
	reportPages?: ModelTypes["FieldMeta"] | undefined,
	reportNavigations?: ModelTypes["FieldMeta"] | undefined,
	scheduledNotifications?: ModelTypes["FieldMeta"] | undefined,
	sentPayments?: ModelTypes["FieldMeta"] | undefined
};
	["GeneralLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["GeneralOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	appStoreLink?: ModelTypes["LinkOrderBy"] | undefined,
	googlePlayLink?: ModelTypes["LinkOrderBy"] | undefined,
	allAreasDescription?: ModelTypes["OrderDirection"] | undefined,
	allOrganizationsDescription?: ModelTypes["OrderDirection"] | undefined
};
	["OrderDirection"]:OrderDirection;
	["GeneralOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	allAreasIcon?: ModelTypes["ImageOrderBy"] | undefined,
	allOrganizationsIcon?: ModelTypes["ImageOrderBy"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListOrderBy"] | undefined
};
	["ImageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	url?: ModelTypes["OrderDirection"] | undefined,
	width?: ModelTypes["OrderDirection"] | undefined,
	height?: ModelTypes["OrderDirection"] | undefined,
	size?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	alt?: ModelTypes["OrderDirection"] | undefined,
	fileName?: ModelTypes["OrderDirection"] | undefined,
	focalPointX?: ModelTypes["OrderDirection"] | undefined,
	focalPointY?: ModelTypes["OrderDirection"] | undefined
};
	["PostOrganizationListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["LocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	code?: ModelTypes["OrderDirection"] | undefined,
	label?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	flagImage?: ModelTypes["ImageOrderBy"] | undefined
};
	["SeoOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	description?: ModelTypes["OrderDirection"] | undefined,
	ogTitle?: ModelTypes["OrderDirection"] | undefined,
	ogDescription?: ModelTypes["OrderDirection"] | undefined,
	noIndex?: ModelTypes["OrderDirection"] | undefined,
	noFollow?: ModelTypes["OrderDirection"] | undefined,
	ogImage?: ModelTypes["ImageOrderBy"] | undefined
};
	["LinkOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	externalLink?: ModelTypes["OrderDirection"] | undefined,
	internalLink?: ModelTypes["LinkableOrderBy"] | undefined,
	isTargetBlank?: ModelTypes["OrderDirection"] | undefined
};
	["LinkableOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	url?: ModelTypes["OrderDirection"] | undefined,
	genericPage?: ModelTypes["GenericPageLocaleOrderBy"] | undefined,
	post?: ModelTypes["PostLocaleOrderBy"] | undefined,
	postArea?: ModelTypes["PostAreaLocaleOrderBy"] | undefined,
	postOrganization?: ModelTypes["PostOrganizationLocaleOrderBy"] | undefined,
	reportPage?: ModelTypes["ReportPageLocaleOrderBy"] | undefined,
	givenGiftsPage?: ModelTypes["GivenGiftsPageLocaleOrderBy"] | undefined,
	receivedGiftsPage?: ModelTypes["ReceivedGiftsPageLocaleOrderBy"] | undefined
};
	["GenericPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["GenericPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined
};
	["GenericPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined
};
	["ContentOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["PostLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	root?: ModelTypes["PostOrderBy"] | undefined,
	paymentName?: ModelTypes["OrderDirection"] | undefined,
	publishedAt?: ModelTypes["OrderDirection"] | undefined
};
	["PostOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined,
	specificSymbol?: ModelTypes["OrderDirection"] | undefined,
	activeRevision?: ModelTypes["PostRevisionOrderBy"] | undefined,
	isPinnedInArea?: ModelTypes["OrderDirection"] | undefined,
	isPinnedInOrganization?: ModelTypes["OrderDirection"] | undefined,
	state?: ModelTypes["OrderDirection"] | undefined,
	meta?: ModelTypes["PostMetaDataOrderBy"] | undefined,
	isPublishedAtHidden?: ModelTypes["OrderDirection"] | undefined,
	fundraiseIsActive?: ModelTypes["OrderDirection"] | undefined,
	fundraiseEndDate?: ModelTypes["OrderDirection"] | undefined,
	fundraiseTargetAmount?: ModelTypes["OrderDirection"] | undefined,
	fundraiseFakeAddOnAmount?: ModelTypes["OrderDirection"] | undefined,
	fundraiseCurrency?: ModelTypes["CurrencyOrderBy"] | undefined,
	fundraiseSum?: ModelTypes["PostSumOrderBy"] | undefined,
	fundraisingProgress?: ModelTypes["PostFundraisingProgressOrderBy"] | undefined
};
	["PostOrganizationOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	icon?: ModelTypes["ImageOrderBy"] | undefined,
	specificSymbol?: ModelTypes["OrderDirection"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined,
	meta?: ModelTypes["PostOrganizationMetaDataOrderBy"] | undefined,
	mobileHeroImage?: ModelTypes["ImageOrderBy"] | undefined,
	isHidden?: ModelTypes["OrderDirection"] | undefined,
	color?: ModelTypes["OrderDirection"] | undefined,
	plainIcon?: ModelTypes["ImageOrderBy"] | undefined,
	desktopHeroImage?: ModelTypes["ImageOrderBy"] | undefined,
	organizationSum?: ModelTypes["PostOrganizationSumOrderBy"] | undefined
};
	["PostAreaOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	icon?: ModelTypes["ImageOrderBy"] | undefined,
	regionListOverride?: ModelTypes["DonationAmountsRegionListOrderBy"] | undefined,
	color?: ModelTypes["OrderDirection"] | undefined,
	specificSymbol?: ModelTypes["OrderDirection"] | undefined,
	region?: ModelTypes["RegionOrderBy"] | undefined,
	meta?: ModelTypes["PostAreaMetaDataOrderBy"] | undefined,
	mobileHeroImage?: ModelTypes["ImageOrderBy"] | undefined,
	plainIcon?: ModelTypes["ImageOrderBy"] | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaSentPaymentSumOrderBy"] | undefined,
	areaSum?: ModelTypes["PostAreaSumOrderBy"] | undefined
};
	["DonationAmountsRegionListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	donation?: ModelTypes["DonationOrderBy"] | undefined
};
	["DonationOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	regionList?: ModelTypes["DonationAmountsRegionListOrderBy"] | undefined
};
	["RegionOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	code?: ModelTypes["OrderDirection"] | undefined,
	label?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	timezone?: ModelTypes["OrderDirection"] | undefined
};
	["CurrencyOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	identifier?: ModelTypes["OrderDirection"] | undefined,
	label?: ModelTypes["OrderDirection"] | undefined,
	sign?: ModelTypes["OrderDirection"] | undefined,
	signAlignment?: ModelTypes["OrderDirection"] | undefined,
	defaultDonationAmount?: ModelTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: ModelTypes["OrderDirection"] | undefined
};
	["PostAreaMetaDataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	nameWithFallback?: ModelTypes["OrderDirection"] | undefined,
	formattedSpecificSymbol?: ModelTypes["OrderDirection"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["OrderDirection"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined
};
	["PostAreaSentPaymentSumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	czkPercentage?: ModelTypes["OrderDirection"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined
};
	["PostAreaSumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	czkPercentage?: ModelTypes["OrderDirection"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined
};
	["PostOrganizationMetaDataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	nameWithFallback?: ModelTypes["OrderDirection"] | undefined,
	formattedSpecificSymbol?: ModelTypes["OrderDirection"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["OrderDirection"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined
};
	["PostOrganizationSumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	czkPercentage?: ModelTypes["OrderDirection"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined
};
	["PostRevisionOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	createdById?: ModelTypes["OrderDirection"] | undefined,
	publishedById?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	publishedAt?: ModelTypes["OrderDirection"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined,
	tileImage?: ModelTypes["ImageOrderBy"] | undefined,
	tileVideo?: ModelTypes["VideoOrderBy"] | undefined,
	heroImage?: ModelTypes["ImageOrderBy"] | undefined,
	regionListOverride?: ModelTypes["DonationAmountsRegionListOrderBy"] | undefined,
	isOrganizationVisible?: ModelTypes["OrderDirection"] | undefined,
	sendPublishNotifications?: ModelTypes["OrderDirection"] | undefined,
	isArchived?: ModelTypes["OrderDirection"] | undefined
};
	["VideoOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	url?: ModelTypes["OrderDirection"] | undefined,
	width?: ModelTypes["OrderDirection"] | undefined,
	height?: ModelTypes["OrderDirection"] | undefined,
	size?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	poster?: ModelTypes["ImageOrderBy"] | undefined,
	shapeType?: ModelTypes["OrderDirection"] | undefined
};
	["PostMetaDataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	titleWithFallback?: ModelTypes["OrderDirection"] | undefined,
	formattedSpecificSymbol?: ModelTypes["OrderDirection"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["OrderDirection"] | undefined,
	latestRevision?: ModelTypes["PostRevisionOrderBy"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined
};
	["PostSumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	czkPercentage?: ModelTypes["OrderDirection"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined
};
	["PostFundraisingProgressOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	progress?: ModelTypes["OrderDirection"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined
};
	["PostAreaLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	description?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	root?: ModelTypes["PostAreaOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	banner?: ModelTypes["AppBannerOrderBy"] | undefined,
	shortDescription?: ModelTypes["OrderDirection"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	translatedByAI?: ModelTypes["OrderDirection"] | undefined
};
	["AppBannerOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	imageSmall?: ModelTypes["ImageOrderBy"] | undefined,
	imageBig?: ModelTypes["ImageOrderBy"] | undefined,
	textContent?: ModelTypes["ContentOrderBy"] | undefined
};
	["PostOrganizationLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	description?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	root?: ModelTypes["PostOrganizationOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	domain?: ModelTypes["LinkOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	translatedByAI?: ModelTypes["OrderDirection"] | undefined
};
	["ReportPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined,
	postTitle?: ModelTypes["OrderDirection"] | undefined,
	giftTitle?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	root?: ModelTypes["ReportPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined
};
	["ReportPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["GivenGiftsPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined,
	giftTitle?: ModelTypes["OrderDirection"] | undefined,
	giftText?: ModelTypes["OrderDirection"] | undefined,
	note?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["GivenGiftsPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined
};
	["GivenGiftsPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["ReceivedGiftsPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined,
	giftTitle?: ModelTypes["OrderDirection"] | undefined,
	giftText?: ModelTypes["OrderDirection"] | undefined,
	note?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	root?: ModelTypes["ReceivedGiftsPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined
};
	["ReceivedGiftsPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["GenericPageLocale"]: {
		_meta?: ModelTypes["GenericPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	root?: ModelTypes["GenericPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	subtitle?: string | undefined
};
	["GenericPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined
};
	["GenericPage"]: {
		_meta?: ModelTypes["GenericPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	locales: Array<ModelTypes["GenericPageLocale"]>,
	type: ModelTypes["GenericPageType"],
	order: number,
	reportNavigation: Array<ModelTypes["ReportNavigationLocale"]>,
	localesByLocale?: ModelTypes["GenericPageLocale"] | undefined,
	localesByContent?: ModelTypes["GenericPageLocale"] | undefined,
	localesBySeo?: ModelTypes["GenericPageLocale"] | undefined,
	localesByLink?: ModelTypes["GenericPageLocale"] | undefined,
	paginateLocales: ModelTypes["GenericPageLocaleConnection"],
	paginateReportNavigation: ModelTypes["ReportNavigationLocaleConnection"]
};
	["GenericPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	reportNavigation?: ModelTypes["FieldMeta"] | undefined
};
	["ReportNavigationLocale"]: {
		_meta?: ModelTypes["ReportNavigationLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["ReportNavigation"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	pages: Array<ModelTypes["GenericPage"]>,
	paginatePages: ModelTypes["GenericPageConnection"]
};
	["ReportNavigationLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	pages?: ModelTypes["FieldMeta"] | undefined
};
	["ReportNavigation"]: {
		_meta?: ModelTypes["ReportNavigationMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["ReportNavigationLocale"]>,
	localesByLocale?: ModelTypes["ReportNavigationLocale"] | undefined,
	paginateLocales: ModelTypes["ReportNavigationLocaleConnection"]
};
	["ReportNavigationMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["ReportNavigationLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["ReportNavigationOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined
};
	["ReportNavigationOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["ReportNavigationLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["LocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	generals?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	genericPages?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	posts?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	postAreas?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	postOrganizations?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	headers?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	footers?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	genericPageAboutSettings?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	postRevisions?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	feedPages?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	recurringPaymentPages?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	givenGiftsPages?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	receivedGiftsPages?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	reportPages?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	reportNavigations?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	scheduledNotifications?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	sentPayments?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined
};
	["GeneralLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GeneralUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	appStoreLink?: ModelTypes["LinkUniqueWhere"] | undefined,
	googlePlayLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["GeneralUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	allAreasIcon?: ModelTypes["ImageUniqueWhere"] | undefined,
	allOrganizationsIcon?: ModelTypes["ImageUniqueWhere"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined
};
	["ImageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["PostOrganizationListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["PostOrganizationListItemUniqueWhere"] | undefined
};
	["PostOrganizationListItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LinkUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["SeoUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	ogImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["GenericPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined
};
	["ContentUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	blocks?: ModelTypes["ContentBlockUniqueWhere"] | undefined
};
	["ContentBlockUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	references?: ModelTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentReferenceUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	linkables?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined,
	valueList?: ModelTypes["ValueListUniqueWhere"] | undefined,
	imageLinkList?: ModelTypes["ImageLinkListUniqueWhere"] | undefined,
	areaList?: ModelTypes["PostAreaListUniqueWhere"] | undefined,
	accordion?: ModelTypes["AccordionUniqueWhere"] | undefined,
	media?: ModelTypes["MediumListUniqueWhere"] | undefined,
	memberList?: ModelTypes["MemberListUniqueWhere"] | undefined,
	contentWithoutBlocks?: ModelTypes["ContentUniqueWhere"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	textImageList?: ModelTypes["TextImageListUniqueWhere"] | undefined
};
	["ContentReferenceLinkableItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	item?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LinkableUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	post?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	postArea?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	postOrganization?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	reportPage?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	givenGiftsPage?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	receivedGiftsPage?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined
};
	["PostLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["PostUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["PostUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	revisions?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	locales?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	meta?: ModelTypes["PostMetaDataUniqueWhere"] | undefined,
	fundraiseCurrencySums?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	fundraiseSum?: ModelTypes["PostSumUniqueWhere"] | undefined,
	fundraisingProgress?: ModelTypes["PostFundraisingProgressUniqueWhere"] | undefined
};
	["PostRevisionUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	regionListOverride?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined
};
	["PostRevisionLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	leadContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["DonationAmountsRegionListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	regions?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	donation?: ModelTypes["DonationUniqueWhere"] | undefined
};
	["DonationAmountsRegionItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	list?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	region?: ModelTypes["RegionUniqueWhere"] | undefined,
	items?: ModelTypes["DonationAmountItemUniqueWhere"] | undefined
};
	["RegionUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	enabledPaymentMethods?: ModelTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	donationItems?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined
};
	["RegionPaymentMethodUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	region?: ModelTypes["RegionUniqueWhere"] | undefined,
	method?: ModelTypes["PaymentMethods"] | undefined
};
	["DonationAmountItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["DonationUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	regionList?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined
};
	["PostMetaDataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	latestRevision?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	post?: ModelTypes["PostUniqueWhere"] | undefined
};
	["PostCurrencySumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["PostSumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	post?: ModelTypes["PostUniqueWhere"] | undefined
};
	["PostFundraisingProgressUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	post?: ModelTypes["PostUniqueWhere"] | undefined
};
	["PostAreaLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	banner?: ModelTypes["AppBannerUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["PostAreaUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	specificSymbol?: number | undefined,
	locales?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	regionListOverride?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	posts?: ModelTypes["PostUniqueWhere"] | undefined,
	meta?: ModelTypes["PostAreaMetaDataUniqueWhere"] | undefined,
	sentPayments?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	areaSentPaymentCurrencySums?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined,
	areaCurrencySums?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	areaSum?: ModelTypes["PostAreaSumUniqueWhere"] | undefined
};
	["PostAreaMetaDataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	area?: ModelTypes["PostAreaUniqueWhere"] | undefined
};
	["SentPaymentUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined
};
	["SentPaymentLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["PostAreaSentPaymentCurrencySumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["PostAreaSentPaymentSumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	area?: ModelTypes["PostAreaUniqueWhere"] | undefined
};
	["PostAreaCurrencySumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["PostAreaSumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	area?: ModelTypes["PostAreaUniqueWhere"] | undefined
};
	["AppBannerUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	textContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["PostOrganizationLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	domain?: ModelTypes["LinkUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["PostOrganizationUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	specificSymbol?: number | undefined,
	posts?: ModelTypes["PostUniqueWhere"] | undefined,
	locales?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	meta?: ModelTypes["PostOrganizationMetaDataUniqueWhere"] | undefined,
	sentPayments?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	organizationCurrencySums?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	organizationSum?: ModelTypes["PostOrganizationSumUniqueWhere"] | undefined
};
	["PostOrganizationMetaDataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostOrganizationUniqueWhere"] | undefined
};
	["PostOrganizationCurrencySumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["PostOrganizationSumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostOrganizationUniqueWhere"] | undefined
};
	["ReportPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["ReportPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["ReportPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined
};
	["GivenGiftsPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GivenGiftsPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["GivenGiftsPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["ReceivedGiftsPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["ReceivedGiftsPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined
};
	["ValueListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["ValueItemUniqueWhere"] | undefined
};
	["ValueItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["ImageLinkListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["ImageLinkItemUniqueWhere"] | undefined
};
	["ImageLinkItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["PostAreaListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["PostAreaListItemUniqueWhere"] | undefined
};
	["PostAreaListItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["AccordionUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["AccordionItemUniqueWhere"] | undefined
};
	["AccordionItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	descriptionContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["MediumListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["MediumItemUniqueWhere"] | undefined
};
	["MediumItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["MemberListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["MemberListItemUniqueWhere"] | undefined
};
	["MemberListItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	descriptionContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["TextImageListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["TextImageListItemUniqueWhere"] | undefined
};
	["TextImageListItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["HeaderLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["HeaderUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	links?: ModelTypes["LinkListUniqueWhere"] | undefined
};
	["HeaderUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined
};
	["LinkListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["LinkItemUniqueWhere"] | undefined
};
	["LinkItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["FooterUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	linkList?: ModelTypes["LinkListUniqueWhere"] | undefined,
	addressInfo?: ModelTypes["ContentUniqueWhere"] | undefined,
	imageLinkList?: ModelTypes["ImageLinkListUniqueWhere"] | undefined
};
	["FooterUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["FooterLocaleUniqueWhere"] | undefined
};
	["GenericPageAboutSettingsLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GenericPageAboutSettingsUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	linkGroups?: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined
};
	["GenericPageAboutSettingsUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined
};
	["GenericPageAboutGroupLinksLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	linkList?: ModelTypes["LinkListUniqueWhere"] | undefined
};
	["FeedPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["FeedPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	heroTiles?: ModelTypes["TileListUniqueWhere"] | undefined,
	sectionList?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined,
	cardList?: ModelTypes["CardListUniqueWhere"] | undefined,
	storyGuideList?: ModelTypes["StoryGuideListUniqueWhere"] | undefined
};
	["FeedPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined
};
	["TileListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["TileItemUniqueWhere"] | undefined
};
	["TileItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FeedPageSectionUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	tileStripeList?: ModelTypes["FeedPageTileStripeUniqueWhere"] | undefined
};
	["FeedPageTileStripeUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["CardListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["CardItemUniqueWhere"] | undefined
};
	["CardItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["StoryGuideListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["StoryGuideItemUniqueWhere"] | undefined
};
	["StoryGuideItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["RecurringPaymentPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["RecurringPaymentPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	favouritePosts?: ModelTypes["PostListUniqueWhere"] | undefined,
	storyGuideList?: ModelTypes["StoryGuideListUniqueWhere"] | undefined
};
	["RecurringPaymentPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined
};
	["PostListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["PostListItemUniqueWhere"] | undefined
};
	["PostListItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["ReportNavigationLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["ReportNavigationUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["ReportNavigationUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined
};
	["ScheduledNotificationLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["ScheduledNotificationUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["ScheduledNotificationUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined,
	processedNotifications?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined
};
	["ProcessedNotificationSourceUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationUniqueWhere"] | undefined
};
	["ProcessedNotificationUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	source?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined
};
	["ReportNavigationLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ReportNavigationLocaleEdge"]>
};
	["PageInfo"]: {
		totalCount: number
};
	["ReportNavigationLocaleEdge"]: {
		node: ModelTypes["ReportNavigationLocale"]
};
	["GenericPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GenericPageEdge"]>
};
	["GenericPageEdge"]: {
		node: ModelTypes["GenericPage"]
};
	["GenericPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["GenericPageLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["GenericPageLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["GenericPageLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["GenericPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GenericPageLocaleEdge"]>
};
	["GenericPageLocaleEdge"]: {
		node: ModelTypes["GenericPageLocale"]
};
	["Content"]: {
		_meta?: ModelTypes["ContentMeta"] | undefined,
	id: ModelTypes["UUID"],
	blocks: Array<ModelTypes["ContentBlock"]>,
	blocksByReferences?: ModelTypes["ContentBlock"] | undefined,
	paginateBlocks: ModelTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	blocks?: ModelTypes["FieldMeta"] | undefined
};
	["ContentBlock"]: {
		_meta?: ModelTypes["ContentBlockMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	json: string,
	content?: ModelTypes["Content"] | undefined,
	references: Array<ModelTypes["ContentReference"]>,
	referencesByLinkables?: ModelTypes["ContentReference"] | undefined,
	referencesByLink?: ModelTypes["ContentReference"] | undefined,
	referencesByValueList?: ModelTypes["ContentReference"] | undefined,
	referencesByImageLinkList?: ModelTypes["ContentReference"] | undefined,
	referencesByAreaList?: ModelTypes["ContentReference"] | undefined,
	referencesByAccordion?: ModelTypes["ContentReference"] | undefined,
	referencesByMedia?: ModelTypes["ContentReference"] | undefined,
	referencesByMemberList?: ModelTypes["ContentReference"] | undefined,
	referencesByContentWithoutBlocks?: ModelTypes["ContentReference"] | undefined,
	referencesByOrganizationList?: ModelTypes["ContentReference"] | undefined,
	referencesByTextImageList?: ModelTypes["ContentReference"] | undefined,
	paginateReferences: ModelTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	json?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	references?: ModelTypes["FieldMeta"] | undefined
};
	["ContentReference"]: {
		_meta?: ModelTypes["ContentReferenceMeta"] | undefined,
	id: ModelTypes["UUID"],
	type: ModelTypes["ContentReferenceType"],
	primaryText?: string | undefined,
	block?: ModelTypes["ContentBlock"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	linkables: Array<ModelTypes["ContentReferenceLinkableItem"]>,
	video?: ModelTypes["Video"] | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["Link"] | undefined,
	contentAlignment: ModelTypes["ContentAlignment"],
	valueList?: ModelTypes["ValueList"] | undefined,
	imageLinkList?: ModelTypes["ImageLinkList"] | undefined,
	areaList?: ModelTypes["PostAreaList"] | undefined,
	isAppsVisible: boolean,
	accordion?: ModelTypes["Accordion"] | undefined,
	media?: ModelTypes["MediumList"] | undefined,
	memberList?: ModelTypes["MemberList"] | undefined,
	asideMediaContentLayout: ModelTypes["AsideMediaContentLayout"],
	isAsideMediaContentMobileLayout: boolean,
	form?: ModelTypes["Form"] | undefined,
	isTitleBigger: boolean,
	contentWithoutBlocks?: ModelTypes["Content"] | undefined,
	heroCarousel?: ModelTypes["HeroCarousel"] | undefined,
	organizationList?: ModelTypes["PostOrganizationList"] | undefined,
	isCentered: boolean,
	posts: Array<ModelTypes["Post"]>,
	textImageList?: ModelTypes["TextImageList"] | undefined,
	linkablesByItem?: ModelTypes["ContentReferenceLinkableItem"] | undefined,
	paginateLinkables: ModelTypes["ContentReferenceLinkableItemConnection"],
	paginatePosts: ModelTypes["PostConnection"]
};
	["ContentReferenceMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	primaryText?: ModelTypes["FieldMeta"] | undefined,
	block?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	linkables?: ModelTypes["FieldMeta"] | undefined,
	video?: ModelTypes["FieldMeta"] | undefined,
	secondaryText?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	contentAlignment?: ModelTypes["FieldMeta"] | undefined,
	valueList?: ModelTypes["FieldMeta"] | undefined,
	imageLinkList?: ModelTypes["FieldMeta"] | undefined,
	areaList?: ModelTypes["FieldMeta"] | undefined,
	isAppsVisible?: ModelTypes["FieldMeta"] | undefined,
	accordion?: ModelTypes["FieldMeta"] | undefined,
	media?: ModelTypes["FieldMeta"] | undefined,
	memberList?: ModelTypes["FieldMeta"] | undefined,
	asideMediaContentLayout?: ModelTypes["FieldMeta"] | undefined,
	isAsideMediaContentMobileLayout?: ModelTypes["FieldMeta"] | undefined,
	form?: ModelTypes["FieldMeta"] | undefined,
	isTitleBigger?: ModelTypes["FieldMeta"] | undefined,
	contentWithoutBlocks?: ModelTypes["FieldMeta"] | undefined,
	heroCarousel?: ModelTypes["FieldMeta"] | undefined,
	organizationList?: ModelTypes["FieldMeta"] | undefined,
	isCentered?: ModelTypes["FieldMeta"] | undefined,
	posts?: ModelTypes["FieldMeta"] | undefined,
	textImageList?: ModelTypes["FieldMeta"] | undefined
};
	["Image"]: {
		_meta?: ModelTypes["ImageMeta"] | undefined,
	id: ModelTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined
};
	["ImageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	url?: ModelTypes["FieldMeta"] | undefined,
	width?: ModelTypes["FieldMeta"] | undefined,
	height?: ModelTypes["FieldMeta"] | undefined,
	size?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	alt?: ModelTypes["FieldMeta"] | undefined,
	fileName?: ModelTypes["FieldMeta"] | undefined,
	focalPointX?: ModelTypes["FieldMeta"] | undefined,
	focalPointY?: ModelTypes["FieldMeta"] | undefined
};
	["ContentReferenceLinkableItem"]: {
		_meta?: ModelTypes["ContentReferenceLinkableItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	item?: ModelTypes["Linkable"] | undefined,
	reference?: ModelTypes["ContentReference"] | undefined
};
	["ContentReferenceLinkableItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	item?: ModelTypes["FieldMeta"] | undefined,
	reference?: ModelTypes["FieldMeta"] | undefined
};
	["Linkable"]: {
		_meta?: ModelTypes["LinkableMeta"] | undefined,
	id: ModelTypes["UUID"],
	url: string,
	genericPage?: ModelTypes["GenericPageLocale"] | undefined,
	post?: ModelTypes["PostLocale"] | undefined,
	postArea?: ModelTypes["PostAreaLocale"] | undefined,
	postOrganization?: ModelTypes["PostOrganizationLocale"] | undefined,
	reportPage?: ModelTypes["ReportPageLocale"] | undefined,
	givenGiftsPage?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	receivedGiftsPage?: ModelTypes["ReceivedGiftsPageLocale"] | undefined
};
	["LinkableMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	url?: ModelTypes["FieldMeta"] | undefined,
	genericPage?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined,
	postArea?: ModelTypes["FieldMeta"] | undefined,
	postOrganization?: ModelTypes["FieldMeta"] | undefined,
	reportPage?: ModelTypes["FieldMeta"] | undefined,
	givenGiftsPage?: ModelTypes["FieldMeta"] | undefined,
	receivedGiftsPage?: ModelTypes["FieldMeta"] | undefined
};
	["PostLocale"]: {
		_meta?: ModelTypes["PostLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	root?: ModelTypes["Post"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined
};
	["PostLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	paymentName?: ModelTypes["FieldMeta"] | undefined,
	publishedAt?: ModelTypes["FieldMeta"] | undefined
};
	["Seo"]: {
		_meta?: ModelTypes["SeoMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: ModelTypes["Image"] | undefined
};
	["SeoMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	description?: ModelTypes["FieldMeta"] | undefined,
	ogTitle?: ModelTypes["FieldMeta"] | undefined,
	ogDescription?: ModelTypes["FieldMeta"] | undefined,
	noIndex?: ModelTypes["FieldMeta"] | undefined,
	noFollow?: ModelTypes["FieldMeta"] | undefined,
	ogImage?: ModelTypes["FieldMeta"] | undefined
};
	["Post"]: {
		_meta?: ModelTypes["PostMeta"] | undefined,
	id: ModelTypes["UUID"],
	organization?: ModelTypes["PostOrganization"] | undefined,
	area?: ModelTypes["PostArea"] | undefined,
	specificSymbol: number,
	activeRevision?: ModelTypes["PostRevision"] | undefined,
	revisions: Array<ModelTypes["PostRevision"]>,
	locales: Array<ModelTypes["PostLocale"]>,
	isPinnedInArea: boolean,
	isPinnedInOrganization: boolean,
	state: ModelTypes["PostState"],
	meta?: ModelTypes["PostMetaData"] | undefined,
	isPublishedAtHidden: boolean,
	heroCarousel: Array<ModelTypes["HeroCarousel"]>,
	reportPage: Array<ModelTypes["ReportPageLocale"]>,
	content: Array<ModelTypes["ContentReference"]>,
	fundraiseIsActive: boolean,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["Currency"] | undefined,
	fundraiseCurrencySums: Array<ModelTypes["PostCurrencySum"]>,
	fundraiseSum?: ModelTypes["PostSum"] | undefined,
	fundraisingProgress?: ModelTypes["PostFundraisingProgress"] | undefined,
	revisionsByLocales?: ModelTypes["PostRevision"] | undefined,
	revisionsByRegionListOverride?: ModelTypes["PostRevision"] | undefined,
	localesByLocale?: ModelTypes["PostLocale"] | undefined,
	localesByContent?: ModelTypes["PostLocale"] | undefined,
	localesBySeo?: ModelTypes["PostLocale"] | undefined,
	localesByLink?: ModelTypes["PostLocale"] | undefined,
	paginateRevisions: ModelTypes["PostRevisionConnection"],
	paginateLocales: ModelTypes["PostLocaleConnection"],
	paginateHeroCarousel: ModelTypes["HeroCarouselConnection"],
	paginateReportPage: ModelTypes["ReportPageLocaleConnection"],
	paginateContent: ModelTypes["ContentReferenceConnection"],
	paginateFundraiseCurrencySums: ModelTypes["PostCurrencySumConnection"]
};
	["PostMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined,
	specificSymbol?: ModelTypes["FieldMeta"] | undefined,
	activeRevision?: ModelTypes["FieldMeta"] | undefined,
	revisions?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	isPinnedInArea?: ModelTypes["FieldMeta"] | undefined,
	isPinnedInOrganization?: ModelTypes["FieldMeta"] | undefined,
	state?: ModelTypes["FieldMeta"] | undefined,
	meta?: ModelTypes["FieldMeta"] | undefined,
	isPublishedAtHidden?: ModelTypes["FieldMeta"] | undefined,
	heroCarousel?: ModelTypes["FieldMeta"] | undefined,
	reportPage?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	fundraiseIsActive?: ModelTypes["FieldMeta"] | undefined,
	fundraiseEndDate?: ModelTypes["FieldMeta"] | undefined,
	fundraiseTargetAmount?: ModelTypes["FieldMeta"] | undefined,
	fundraiseFakeAddOnAmount?: ModelTypes["FieldMeta"] | undefined,
	fundraiseCurrency?: ModelTypes["FieldMeta"] | undefined,
	fundraiseCurrencySums?: ModelTypes["FieldMeta"] | undefined,
	fundraiseSum?: ModelTypes["FieldMeta"] | undefined,
	fundraisingProgress?: ModelTypes["FieldMeta"] | undefined
};
	["PostOrganization"]: {
		_meta?: ModelTypes["PostOrganizationMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	posts: Array<ModelTypes["Post"]>,
	icon?: ModelTypes["Image"] | undefined,
	locales: Array<ModelTypes["PostOrganizationLocale"]>,
	specificSymbol: number,
	area?: ModelTypes["PostArea"] | undefined,
	meta?: ModelTypes["PostOrganizationMetaData"] | undefined,
	mobileHeroImage?: ModelTypes["Image"] | undefined,
	isHidden: boolean,
	color?: string | undefined,
	plainIcon?: ModelTypes["Image"] | undefined,
	desktopHeroImage?: ModelTypes["Image"] | undefined,
	sentPayments: Array<ModelTypes["SentPayment"]>,
	organizationCurrencySums: Array<ModelTypes["PostOrganizationCurrencySum"]>,
	organizationSum?: ModelTypes["PostOrganizationSum"] | undefined,
	postsBySpecificSymbol?: ModelTypes["Post"] | undefined,
	postsByActiveRevision?: ModelTypes["Post"] | undefined,
	postsByRevisions?: ModelTypes["Post"] | undefined,
	postsByLocales?: ModelTypes["Post"] | undefined,
	postsByMeta?: ModelTypes["Post"] | undefined,
	postsByFundraiseCurrencySums?: ModelTypes["Post"] | undefined,
	postsByFundraiseSum?: ModelTypes["Post"] | undefined,
	postsByFundraisingProgress?: ModelTypes["Post"] | undefined,
	localesByLocale?: ModelTypes["PostOrganizationLocale"] | undefined,
	localesByLink?: ModelTypes["PostOrganizationLocale"] | undefined,
	localesByDomain?: ModelTypes["PostOrganizationLocale"] | undefined,
	localesBySeo?: ModelTypes["PostOrganizationLocale"] | undefined,
	localesByContent?: ModelTypes["PostOrganizationLocale"] | undefined,
	sentPaymentsByLocales?: ModelTypes["SentPayment"] | undefined,
	paginatePosts: ModelTypes["PostConnection"],
	paginateLocales: ModelTypes["PostOrganizationLocaleConnection"],
	paginateSentPayments: ModelTypes["SentPaymentConnection"],
	paginateOrganizationCurrencySums: ModelTypes["PostOrganizationCurrencySumConnection"]
};
	["PostOrganizationMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	posts?: ModelTypes["FieldMeta"] | undefined,
	icon?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	specificSymbol?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined,
	meta?: ModelTypes["FieldMeta"] | undefined,
	mobileHeroImage?: ModelTypes["FieldMeta"] | undefined,
	isHidden?: ModelTypes["FieldMeta"] | undefined,
	color?: ModelTypes["FieldMeta"] | undefined,
	plainIcon?: ModelTypes["FieldMeta"] | undefined,
	desktopHeroImage?: ModelTypes["FieldMeta"] | undefined,
	sentPayments?: ModelTypes["FieldMeta"] | undefined,
	organizationCurrencySums?: ModelTypes["FieldMeta"] | undefined,
	organizationSum?: ModelTypes["FieldMeta"] | undefined
};
	["PostOrganizationLocale"]: {
		_meta?: ModelTypes["PostOrganizationLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	name: string,
	description?: string | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	root?: ModelTypes["PostOrganization"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	domain?: ModelTypes["Link"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	translatedByAI: boolean
};
	["PostOrganizationLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	description?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	domain?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	translatedByAI?: ModelTypes["FieldMeta"] | undefined
};
	["Link"]: {
		_meta?: ModelTypes["LinkMeta"] | undefined,
	id: ModelTypes["UUID"],
	type: ModelTypes["LinkEnum"],
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: ModelTypes["Linkable"] | undefined,
	isTargetBlank: boolean
};
	["LinkMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	externalLink?: ModelTypes["FieldMeta"] | undefined,
	internalLink?: ModelTypes["FieldMeta"] | undefined,
	isTargetBlank?: ModelTypes["FieldMeta"] | undefined
};
	["PostArea"]: {
		_meta?: ModelTypes["PostAreaMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	icon?: ModelTypes["Image"] | undefined,
	locales: Array<ModelTypes["PostAreaLocale"]>,
	regionListOverride?: ModelTypes["DonationAmountsRegionList"] | undefined,
	color?: string | undefined,
	posts: Array<ModelTypes["Post"]>,
	specificSymbol: number,
	region?: ModelTypes["Region"] | undefined,
	meta?: ModelTypes["PostAreaMetaData"] | undefined,
	mobileHeroImage?: ModelTypes["Image"] | undefined,
	plainIcon?: ModelTypes["Image"] | undefined,
	sentPayments: Array<ModelTypes["SentPayment"]>,
	areaSentPaymentCurrencySums: Array<ModelTypes["PostAreaSentPaymentCurrencySum"]>,
	areaSentPaymentSum?: ModelTypes["PostAreaSentPaymentSum"] | undefined,
	areaCurrencySums: Array<ModelTypes["PostAreaCurrencySum"]>,
	areaSum?: ModelTypes["PostAreaSum"] | undefined,
	localesByLocale?: ModelTypes["PostAreaLocale"] | undefined,
	localesByLink?: ModelTypes["PostAreaLocale"] | undefined,
	localesBySeo?: ModelTypes["PostAreaLocale"] | undefined,
	localesByBanner?: ModelTypes["PostAreaLocale"] | undefined,
	localesByContent?: ModelTypes["PostAreaLocale"] | undefined,
	postsBySpecificSymbol?: ModelTypes["Post"] | undefined,
	postsByActiveRevision?: ModelTypes["Post"] | undefined,
	postsByRevisions?: ModelTypes["Post"] | undefined,
	postsByLocales?: ModelTypes["Post"] | undefined,
	postsByMeta?: ModelTypes["Post"] | undefined,
	postsByFundraiseCurrencySums?: ModelTypes["Post"] | undefined,
	postsByFundraiseSum?: ModelTypes["Post"] | undefined,
	postsByFundraisingProgress?: ModelTypes["Post"] | undefined,
	sentPaymentsByLocales?: ModelTypes["SentPayment"] | undefined,
	paginateLocales: ModelTypes["PostAreaLocaleConnection"],
	paginatePosts: ModelTypes["PostConnection"],
	paginateSentPayments: ModelTypes["SentPaymentConnection"],
	paginateAreaSentPaymentCurrencySums: ModelTypes["PostAreaSentPaymentCurrencySumConnection"],
	paginateAreaCurrencySums: ModelTypes["PostAreaCurrencySumConnection"]
};
	["PostAreaMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	icon?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	regionListOverride?: ModelTypes["FieldMeta"] | undefined,
	color?: ModelTypes["FieldMeta"] | undefined,
	posts?: ModelTypes["FieldMeta"] | undefined,
	specificSymbol?: ModelTypes["FieldMeta"] | undefined,
	region?: ModelTypes["FieldMeta"] | undefined,
	meta?: ModelTypes["FieldMeta"] | undefined,
	mobileHeroImage?: ModelTypes["FieldMeta"] | undefined,
	plainIcon?: ModelTypes["FieldMeta"] | undefined,
	sentPayments?: ModelTypes["FieldMeta"] | undefined,
	areaSentPaymentCurrencySums?: ModelTypes["FieldMeta"] | undefined,
	areaSentPaymentSum?: ModelTypes["FieldMeta"] | undefined,
	areaCurrencySums?: ModelTypes["FieldMeta"] | undefined,
	areaSum?: ModelTypes["FieldMeta"] | undefined
};
	["PostAreaLocale"]: {
		_meta?: ModelTypes["PostAreaLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	name: string,
	description?: string | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	root?: ModelTypes["PostArea"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	banner?: ModelTypes["AppBanner"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["Content"] | undefined,
	translatedByAI: boolean
};
	["PostAreaLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	description?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	banner?: ModelTypes["FieldMeta"] | undefined,
	shortDescription?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	translatedByAI?: ModelTypes["FieldMeta"] | undefined
};
	["AppBanner"]: {
		_meta?: ModelTypes["AppBannerMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	imageSmall?: ModelTypes["Image"] | undefined,
	imageBig?: ModelTypes["Image"] | undefined,
	textContent?: ModelTypes["Content"] | undefined
};
	["AppBannerMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	imageSmall?: ModelTypes["FieldMeta"] | undefined,
	imageBig?: ModelTypes["FieldMeta"] | undefined,
	textContent?: ModelTypes["FieldMeta"] | undefined
};
	["DonationAmountsRegionList"]: {
		_meta?: ModelTypes["DonationAmountsRegionListMeta"] | undefined,
	id: ModelTypes["UUID"],
	regions: Array<ModelTypes["DonationAmountsRegionItem"]>,
	donation?: ModelTypes["Donation"] | undefined,
	regionsByRegion?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	regionsByItems?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	paginateRegions: ModelTypes["DonationAmountsRegionItemConnection"]
};
	["DonationAmountsRegionListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	regions?: ModelTypes["FieldMeta"] | undefined,
	donation?: ModelTypes["FieldMeta"] | undefined
};
	["DonationAmountsRegionItem"]: {
		_meta?: ModelTypes["DonationAmountsRegionItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order?: number | undefined,
	items: Array<ModelTypes["DonationAmountItem"]>,
	list?: ModelTypes["DonationAmountsRegionList"] | undefined,
	region?: ModelTypes["Region"] | undefined,
	minimumAmount?: number | undefined,
	paginateItems: ModelTypes["DonationAmountItemConnection"]
};
	["DonationAmountsRegionItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	region?: ModelTypes["FieldMeta"] | undefined,
	minimumAmount?: ModelTypes["FieldMeta"] | undefined
};
	["DonationAmountItem"]: {
		_meta?: ModelTypes["DonationAmountItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	amount?: number | undefined,
	regionItem?: ModelTypes["DonationAmountsRegionItem"] | undefined
};
	["DonationAmountItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	amount?: ModelTypes["FieldMeta"] | undefined,
	regionItem?: ModelTypes["FieldMeta"] | undefined
};
	["DonationAmountItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	amount?: ModelTypes["OrderDirection"] | undefined,
	regionItem?: ModelTypes["DonationAmountsRegionItemOrderBy"] | undefined
};
	["DonationAmountsRegionItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["DonationAmountsRegionListOrderBy"] | undefined,
	region?: ModelTypes["RegionOrderBy"] | undefined,
	minimumAmount?: ModelTypes["OrderDirection"] | undefined
};
	["Region"]: {
		_meta?: ModelTypes["RegionMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	code: string,
	label?: string | undefined,
	currency?: ModelTypes["Currency"] | undefined,
	enabledPaymentMethods: Array<ModelTypes["RegionPaymentMethod"]>,
	donationItems: Array<ModelTypes["DonationAmountsRegionItem"]>,
	timezone?: string | undefined,
	enabledPaymentMethodsByMethod?: ModelTypes["RegionPaymentMethod"] | undefined,
	donationItemsByList?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	donationItemsByItems?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	paginateEnabledPaymentMethods: ModelTypes["RegionPaymentMethodConnection"],
	paginateDonationItems: ModelTypes["DonationAmountsRegionItemConnection"]
};
	["RegionMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	code?: ModelTypes["FieldMeta"] | undefined,
	label?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	enabledPaymentMethods?: ModelTypes["FieldMeta"] | undefined,
	donationItems?: ModelTypes["FieldMeta"] | undefined,
	timezone?: ModelTypes["FieldMeta"] | undefined
};
	["Currency"]: {
		_meta?: ModelTypes["CurrencyMeta"] | undefined,
	id: ModelTypes["UUID"],
	identifier: ModelTypes["CurrencyIdentifier"],
	label: string,
	sign: string,
	signAlignment: ModelTypes["CurrencySignAlignment"],
	defaultDonationAmount: number,
	rateAgainstCzk: number,
	areaSentPaymentCurrencySums: Array<ModelTypes["PostAreaSentPaymentCurrencySum"]>,
	areaCurrencySums: Array<ModelTypes["PostAreaCurrencySum"]>,
	organizationCurrencySums: Array<ModelTypes["PostOrganizationCurrencySum"]>,
	postCurrencySums: Array<ModelTypes["PostCurrencySum"]>,
	paginateAreaSentPaymentCurrencySums: ModelTypes["PostAreaSentPaymentCurrencySumConnection"],
	paginateAreaCurrencySums: ModelTypes["PostAreaCurrencySumConnection"],
	paginateOrganizationCurrencySums: ModelTypes["PostOrganizationCurrencySumConnection"],
	paginatePostCurrencySums: ModelTypes["PostCurrencySumConnection"]
};
	["CurrencyMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	identifier?: ModelTypes["FieldMeta"] | undefined,
	label?: ModelTypes["FieldMeta"] | undefined,
	sign?: ModelTypes["FieldMeta"] | undefined,
	signAlignment?: ModelTypes["FieldMeta"] | undefined,
	defaultDonationAmount?: ModelTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: ModelTypes["FieldMeta"] | undefined,
	areaSentPaymentCurrencySums?: ModelTypes["FieldMeta"] | undefined,
	areaCurrencySums?: ModelTypes["FieldMeta"] | undefined,
	organizationCurrencySums?: ModelTypes["FieldMeta"] | undefined,
	postCurrencySums?: ModelTypes["FieldMeta"] | undefined
};
	["PostAreaSentPaymentCurrencySum"]: {
		_meta?: ModelTypes["PostAreaSentPaymentCurrencySumMeta"] | undefined,
	id: ModelTypes["UUID"],
	currencyIdentifier: string,
	rateAgainstCzk: number,
	totalCents: number,
	currency?: ModelTypes["Currency"] | undefined,
	area?: ModelTypes["PostArea"] | undefined
};
	["PostAreaSentPaymentCurrencySumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	currencyIdentifier?: ModelTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined
};
	["PostAreaSentPaymentCurrencySumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	currencyIdentifier?: ModelTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: ModelTypes["OrderDirection"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined
};
	["PostAreaCurrencySum"]: {
		_meta?: ModelTypes["PostAreaCurrencySumMeta"] | undefined,
	id: ModelTypes["UUID"],
	currencyIdentifier: string,
	rateAgainstCzk: number,
	totalCents: number,
	currency?: ModelTypes["Currency"] | undefined,
	area?: ModelTypes["PostArea"] | undefined
};
	["PostAreaCurrencySumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	currencyIdentifier?: ModelTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined
};
	["PostAreaCurrencySumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	currencyIdentifier?: ModelTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: ModelTypes["OrderDirection"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined
};
	["PostOrganizationCurrencySum"]: {
		_meta?: ModelTypes["PostOrganizationCurrencySumMeta"] | undefined,
	id: ModelTypes["UUID"],
	currencyIdentifier: string,
	rateAgainstCzk: number,
	totalCents: number,
	currency?: ModelTypes["Currency"] | undefined,
	organization?: ModelTypes["PostOrganization"] | undefined
};
	["PostOrganizationCurrencySumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	currencyIdentifier?: ModelTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined
};
	["PostOrganizationCurrencySumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	currencyIdentifier?: ModelTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: ModelTypes["OrderDirection"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined
};
	["PostCurrencySum"]: {
		_meta?: ModelTypes["PostCurrencySumMeta"] | undefined,
	id: ModelTypes["UUID"],
	currencyIdentifier: string,
	rateAgainstCzk: number,
	totalCents: number,
	currency?: ModelTypes["Currency"] | undefined,
	post?: ModelTypes["Post"] | undefined
};
	["PostCurrencySumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	currencyIdentifier?: ModelTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined
};
	["PostCurrencySumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	currencyIdentifier?: ModelTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: ModelTypes["OrderDirection"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined
};
	["PostAreaSentPaymentCurrencySumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaSentPaymentCurrencySumEdge"]>
};
	["PostAreaSentPaymentCurrencySumEdge"]: {
		node: ModelTypes["PostAreaSentPaymentCurrencySum"]
};
	["PostAreaCurrencySumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaCurrencySumEdge"]>
};
	["PostAreaCurrencySumEdge"]: {
		node: ModelTypes["PostAreaCurrencySum"]
};
	["PostOrganizationCurrencySumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostOrganizationCurrencySumEdge"]>
};
	["PostOrganizationCurrencySumEdge"]: {
		node: ModelTypes["PostOrganizationCurrencySum"]
};
	["PostCurrencySumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostCurrencySumEdge"]>
};
	["PostCurrencySumEdge"]: {
		node: ModelTypes["PostCurrencySum"]
};
	["RegionPaymentMethod"]: {
		_meta?: ModelTypes["RegionPaymentMethodMeta"] | undefined,
	id: ModelTypes["UUID"],
	allowRecurringPayments: boolean,
	region?: ModelTypes["Region"] | undefined,
	method: ModelTypes["PaymentMethods"],
	order: number
};
	["RegionPaymentMethodMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	allowRecurringPayments?: ModelTypes["FieldMeta"] | undefined,
	region?: ModelTypes["FieldMeta"] | undefined,
	method?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined
};
	["RegionPaymentMethodOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	allowRecurringPayments?: ModelTypes["OrderDirection"] | undefined,
	region?: ModelTypes["RegionOrderBy"] | undefined,
	method?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined
};
	["RegionEnabledPaymentMethodsByMethodUniqueWhere"]: {
	method?: ModelTypes["PaymentMethods"] | undefined
};
	["RegionDonationItemsByListUniqueWhere"]: {
	list?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined
};
	["RegionDonationItemsByItemsUniqueWhere"]: {
	items?: ModelTypes["DonationAmountItemUniqueWhere"] | undefined
};
	["RegionPaymentMethodConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["RegionPaymentMethodEdge"]>
};
	["RegionPaymentMethodEdge"]: {
		node: ModelTypes["RegionPaymentMethod"]
};
	["DonationAmountsRegionItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["DonationAmountsRegionItemEdge"]>
};
	["DonationAmountsRegionItemEdge"]: {
		node: ModelTypes["DonationAmountsRegionItem"]
};
	["DonationAmountItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["DonationAmountItemEdge"]>
};
	["DonationAmountItemEdge"]: {
		node: ModelTypes["DonationAmountItem"]
};
	["Donation"]: {
		_meta?: ModelTypes["DonationMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	regionList?: ModelTypes["DonationAmountsRegionList"] | undefined
};
	["DonationMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	regionList?: ModelTypes["FieldMeta"] | undefined
};
	["DonationAmountsRegionListRegionsByRegionUniqueWhere"]: {
	region?: ModelTypes["RegionUniqueWhere"] | undefined
};
	["DonationAmountsRegionListRegionsByItemsUniqueWhere"]: {
	items?: ModelTypes["DonationAmountItemUniqueWhere"] | undefined
};
	["PostAreaMetaData"]: {
		_meta?: ModelTypes["PostAreaMetaDataMeta"] | undefined,
	id: ModelTypes["UUID"],
	nameWithFallback: string,
	formattedSpecificSymbol: string,
	fullFormattedSpecificSymbol: string,
	area?: ModelTypes["PostArea"] | undefined
};
	["PostAreaMetaDataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	nameWithFallback?: ModelTypes["FieldMeta"] | undefined,
	formattedSpecificSymbol?: ModelTypes["FieldMeta"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined
};
	["SentPayment"]: {
		_meta?: ModelTypes["SentPaymentMeta"] | undefined,
	id: ModelTypes["UUID"],
	createdAt: ModelTypes["DateTime"],
	cents: number,
	sendAt: ModelTypes["DateTime"],
	currency?: ModelTypes["Currency"] | undefined,
	area?: ModelTypes["PostArea"] | undefined,
	organization?: ModelTypes["PostOrganization"] | undefined,
	locales: Array<ModelTypes["SentPaymentLocale"]>,
	localesByLocale?: ModelTypes["SentPaymentLocale"] | undefined,
	paginateLocales: ModelTypes["SentPaymentLocaleConnection"]
};
	["SentPaymentMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	cents?: ModelTypes["FieldMeta"] | undefined,
	sendAt?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["SentPaymentLocale"]: {
		_meta?: ModelTypes["SentPaymentLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	organizationText?: string | undefined,
	root?: ModelTypes["SentPayment"] | undefined,
	locale?: ModelTypes["Locale"] | undefined
};
	["SentPaymentLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	organizationText?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined
};
	["SentPaymentLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	organizationText?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["SentPaymentOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined
};
	["SentPaymentOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	cents?: ModelTypes["OrderDirection"] | undefined,
	sendAt?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined
};
	["SentPaymentLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["SentPaymentLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SentPaymentLocaleEdge"]>
};
	["SentPaymentLocaleEdge"]: {
		node: ModelTypes["SentPaymentLocale"]
};
	["PostAreaSentPaymentSum"]: {
		_meta?: ModelTypes["PostAreaSentPaymentSumMeta"] | undefined,
	id: ModelTypes["UUID"],
	totalCents: number,
	czkPercentage: number,
	area?: ModelTypes["PostArea"] | undefined
};
	["PostAreaSentPaymentSumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	czkPercentage?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined
};
	["PostAreaSum"]: {
		_meta?: ModelTypes["PostAreaSumMeta"] | undefined,
	id: ModelTypes["UUID"],
	totalCents: number,
	czkPercentage: number,
	area?: ModelTypes["PostArea"] | undefined
};
	["PostAreaSumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	czkPercentage?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined
};
	["PostAreaLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["PostAreaLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["PostAreaLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["PostAreaLocalesByBannerUniqueWhere"]: {
	banner?: ModelTypes["AppBannerUniqueWhere"] | undefined
};
	["PostAreaLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["PostAreaPostsBySpecificSymbolUniqueWhere"]: {
	specificSymbol?: number | undefined
};
	["PostAreaPostsByActiveRevisionUniqueWhere"]: {
	activeRevision?: ModelTypes["PostRevisionUniqueWhere"] | undefined
};
	["PostAreaPostsByRevisionsUniqueWhere"]: {
	revisions?: ModelTypes["PostRevisionUniqueWhere"] | undefined
};
	["PostAreaPostsByLocalesUniqueWhere"]: {
	locales?: ModelTypes["PostLocaleUniqueWhere"] | undefined
};
	["PostAreaPostsByMetaUniqueWhere"]: {
	meta?: ModelTypes["PostMetaDataUniqueWhere"] | undefined
};
	["PostAreaPostsByFundraiseCurrencySumsUniqueWhere"]: {
	fundraiseCurrencySums?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined
};
	["PostAreaPostsByFundraiseSumUniqueWhere"]: {
	fundraiseSum?: ModelTypes["PostSumUniqueWhere"] | undefined
};
	["PostAreaPostsByFundraisingProgressUniqueWhere"]: {
	fundraisingProgress?: ModelTypes["PostFundraisingProgressUniqueWhere"] | undefined
};
	["PostAreaSentPaymentsByLocalesUniqueWhere"]: {
	locales?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined
};
	["PostAreaLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaLocaleEdge"]>
};
	["PostAreaLocaleEdge"]: {
		node: ModelTypes["PostAreaLocale"]
};
	["PostConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostEdge"]>
};
	["PostEdge"]: {
		node: ModelTypes["Post"]
};
	["SentPaymentConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SentPaymentEdge"]>
};
	["SentPaymentEdge"]: {
		node: ModelTypes["SentPayment"]
};
	["PostOrganizationMetaData"]: {
		_meta?: ModelTypes["PostOrganizationMetaDataMeta"] | undefined,
	id: ModelTypes["UUID"],
	nameWithFallback: string,
	formattedSpecificSymbol: string,
	fullFormattedSpecificSymbol: string,
	organization?: ModelTypes["PostOrganization"] | undefined
};
	["PostOrganizationMetaDataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	nameWithFallback?: ModelTypes["FieldMeta"] | undefined,
	formattedSpecificSymbol?: ModelTypes["FieldMeta"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined
};
	["PostOrganizationSum"]: {
		_meta?: ModelTypes["PostOrganizationSumMeta"] | undefined,
	id: ModelTypes["UUID"],
	totalCents: number,
	czkPercentage: number,
	organization?: ModelTypes["PostOrganization"] | undefined
};
	["PostOrganizationSumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	czkPercentage?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined
};
	["PostOrganizationPostsBySpecificSymbolUniqueWhere"]: {
	specificSymbol?: number | undefined
};
	["PostOrganizationPostsByActiveRevisionUniqueWhere"]: {
	activeRevision?: ModelTypes["PostRevisionUniqueWhere"] | undefined
};
	["PostOrganizationPostsByRevisionsUniqueWhere"]: {
	revisions?: ModelTypes["PostRevisionUniqueWhere"] | undefined
};
	["PostOrganizationPostsByLocalesUniqueWhere"]: {
	locales?: ModelTypes["PostLocaleUniqueWhere"] | undefined
};
	["PostOrganizationPostsByMetaUniqueWhere"]: {
	meta?: ModelTypes["PostMetaDataUniqueWhere"] | undefined
};
	["PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere"]: {
	fundraiseCurrencySums?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined
};
	["PostOrganizationPostsByFundraiseSumUniqueWhere"]: {
	fundraiseSum?: ModelTypes["PostSumUniqueWhere"] | undefined
};
	["PostOrganizationPostsByFundraisingProgressUniqueWhere"]: {
	fundraisingProgress?: ModelTypes["PostFundraisingProgressUniqueWhere"] | undefined
};
	["PostOrganizationLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["PostOrganizationLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["PostOrganizationLocalesByDomainUniqueWhere"]: {
	domain?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["PostOrganizationLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["PostOrganizationLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["PostOrganizationSentPaymentsByLocalesUniqueWhere"]: {
	locales?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined
};
	["PostOrganizationLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostOrganizationLocaleEdge"]>
};
	["PostOrganizationLocaleEdge"]: {
		node: ModelTypes["PostOrganizationLocale"]
};
	["PostRevision"]: {
		_meta?: ModelTypes["PostRevisionMeta"] | undefined,
	id: ModelTypes["UUID"],
	createdAt: ModelTypes["DateTime"],
	createdById?: ModelTypes["UUID"] | undefined,
	publishedById?: ModelTypes["UUID"] | undefined,
	type: ModelTypes["PostType"],
	publishedAt?: ModelTypes["DateTime"] | undefined,
	post?: ModelTypes["Post"] | undefined,
	tileImage?: ModelTypes["Image"] | undefined,
	tileVideo?: ModelTypes["Video"] | undefined,
	heroImage?: ModelTypes["Image"] | undefined,
	locales: Array<ModelTypes["PostRevisionLocale"]>,
	regionListOverride?: ModelTypes["DonationAmountsRegionList"] | undefined,
	isOrganizationVisible: boolean,
	sendPublishNotifications: boolean,
	isArchived: boolean,
	localesByLocale?: ModelTypes["PostRevisionLocale"] | undefined,
	localesByContent?: ModelTypes["PostRevisionLocale"] | undefined,
	localesBySeo?: ModelTypes["PostRevisionLocale"] | undefined,
	localesByLeadContent?: ModelTypes["PostRevisionLocale"] | undefined,
	paginateLocales: ModelTypes["PostRevisionLocaleConnection"]
};
	["PostRevisionMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	createdById?: ModelTypes["FieldMeta"] | undefined,
	publishedById?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	publishedAt?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined,
	tileImage?: ModelTypes["FieldMeta"] | undefined,
	tileVideo?: ModelTypes["FieldMeta"] | undefined,
	heroImage?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	regionListOverride?: ModelTypes["FieldMeta"] | undefined,
	isOrganizationVisible?: ModelTypes["FieldMeta"] | undefined,
	sendPublishNotifications?: ModelTypes["FieldMeta"] | undefined,
	isArchived?: ModelTypes["FieldMeta"] | undefined
};
	["Video"]: {
		_meta?: ModelTypes["VideoMeta"] | undefined,
	id: ModelTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	poster?: ModelTypes["Image"] | undefined,
	shapeType?: ModelTypes["VideoShapeType"] | undefined
};
	["VideoMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	url?: ModelTypes["FieldMeta"] | undefined,
	width?: ModelTypes["FieldMeta"] | undefined,
	height?: ModelTypes["FieldMeta"] | undefined,
	size?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	poster?: ModelTypes["FieldMeta"] | undefined,
	shapeType?: ModelTypes["FieldMeta"] | undefined
};
	["PostRevisionLocale"]: {
		_meta?: ModelTypes["PostRevisionLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	root?: ModelTypes["PostRevision"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	leadContent?: ModelTypes["Content"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI: boolean
};
	["PostRevisionLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	leadContent?: ModelTypes["FieldMeta"] | undefined,
	publishNotificationText?: ModelTypes["FieldMeta"] | undefined,
	translatedByAI?: ModelTypes["FieldMeta"] | undefined
};
	["PostRevisionLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["PostRevisionOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	leadContent?: ModelTypes["ContentOrderBy"] | undefined,
	publishNotificationText?: ModelTypes["OrderDirection"] | undefined,
	translatedByAI?: ModelTypes["OrderDirection"] | undefined
};
	["PostRevisionLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["PostRevisionLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["PostRevisionLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["PostRevisionLocalesByLeadContentUniqueWhere"]: {
	leadContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["PostRevisionLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostRevisionLocaleEdge"]>
};
	["PostRevisionLocaleEdge"]: {
		node: ModelTypes["PostRevisionLocale"]
};
	["PostMetaData"]: {
		_meta?: ModelTypes["PostMetaDataMeta"] | undefined,
	id: ModelTypes["UUID"],
	titleWithFallback: string,
	formattedSpecificSymbol: string,
	fullFormattedSpecificSymbol: string,
	latestRevision?: ModelTypes["PostRevision"] | undefined,
	post?: ModelTypes["Post"] | undefined
};
	["PostMetaDataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	titleWithFallback?: ModelTypes["FieldMeta"] | undefined,
	formattedSpecificSymbol?: ModelTypes["FieldMeta"] | undefined,
	fullFormattedSpecificSymbol?: ModelTypes["FieldMeta"] | undefined,
	latestRevision?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined
};
	["HeroCarousel"]: {
		_meta?: ModelTypes["HeroCarouselMeta"] | undefined,
	id: ModelTypes["UUID"],
	createdAt?: ModelTypes["Date"] | undefined,
	posts: Array<ModelTypes["Post"]>,
	items: Array<ModelTypes["HeroCarouselItem"]>,
	paginatePosts: ModelTypes["PostConnection"],
	paginateItems: ModelTypes["HeroCarouselItemConnection"]
};
	["HeroCarouselMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	posts?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["HeroCarouselItem"]: {
		_meta?: ModelTypes["HeroCarouselItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	createdAt?: ModelTypes["Date"] | undefined,
	order: number,
	list?: ModelTypes["HeroCarousel"] | undefined,
	item?: ModelTypes["Post"] | undefined
};
	["HeroCarouselItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	item?: ModelTypes["FieldMeta"] | undefined
};
	["HeroCarouselItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["HeroCarouselOrderBy"] | undefined,
	item?: ModelTypes["PostOrderBy"] | undefined
};
	["HeroCarouselOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined
};
	["HeroCarouselItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HeroCarouselItemEdge"]>
};
	["HeroCarouselItemEdge"]: {
		node: ModelTypes["HeroCarouselItem"]
};
	["ReportPageLocale"]: {
		_meta?: ModelTypes["ReportPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	root?: ModelTypes["ReportPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	posts: Array<ModelTypes["Post"]>,
	paginatePosts: ModelTypes["PostConnection"]
};
	["ReportPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined,
	postTitle?: ModelTypes["FieldMeta"] | undefined,
	giftTitle?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	posts?: ModelTypes["FieldMeta"] | undefined
};
	["ReportPage"]: {
		_meta?: ModelTypes["ReportPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["ReportPageLocale"]>,
	localesByLocale?: ModelTypes["ReportPageLocale"] | undefined,
	localesByLink?: ModelTypes["ReportPageLocale"] | undefined,
	localesByContent?: ModelTypes["ReportPageLocale"] | undefined,
	localesBySeo?: ModelTypes["ReportPageLocale"] | undefined,
	paginateLocales: ModelTypes["ReportPageLocaleConnection"]
};
	["ReportPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["ReportPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["ReportPageLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["ReportPageLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["ReportPageLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["ReportPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ReportPageLocaleEdge"]>
};
	["ReportPageLocaleEdge"]: {
		node: ModelTypes["ReportPageLocale"]
};
	["ContentReferenceOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	primaryText?: ModelTypes["OrderDirection"] | undefined,
	block?: ModelTypes["ContentBlockOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	video?: ModelTypes["VideoOrderBy"] | undefined,
	secondaryText?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined,
	contentAlignment?: ModelTypes["OrderDirection"] | undefined,
	valueList?: ModelTypes["ValueListOrderBy"] | undefined,
	imageLinkList?: ModelTypes["ImageLinkListOrderBy"] | undefined,
	areaList?: ModelTypes["PostAreaListOrderBy"] | undefined,
	isAppsVisible?: ModelTypes["OrderDirection"] | undefined,
	accordion?: ModelTypes["AccordionOrderBy"] | undefined,
	media?: ModelTypes["MediumListOrderBy"] | undefined,
	memberList?: ModelTypes["MemberListOrderBy"] | undefined,
	asideMediaContentLayout?: ModelTypes["OrderDirection"] | undefined,
	isAsideMediaContentMobileLayout?: ModelTypes["OrderDirection"] | undefined,
	form?: ModelTypes["FormOrderBy"] | undefined,
	isTitleBigger?: ModelTypes["OrderDirection"] | undefined,
	contentWithoutBlocks?: ModelTypes["ContentOrderBy"] | undefined,
	heroCarousel?: ModelTypes["HeroCarouselOrderBy"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListOrderBy"] | undefined,
	isCentered?: ModelTypes["OrderDirection"] | undefined,
	textImageList?: ModelTypes["TextImageListOrderBy"] | undefined
};
	["ContentBlockOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	json?: ModelTypes["OrderDirection"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined
};
	["ValueListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["ImageLinkListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["PostAreaListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["AccordionOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["MediumListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["MemberListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["FormOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	tax?: ModelTypes["FilledTaxFormOrderBy"] | undefined
};
	["FilledTaxFormOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	publishedAt?: ModelTypes["OrderDirection"] | undefined,
	userId?: ModelTypes["OrderDirection"] | undefined,
	email?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	vatId?: ModelTypes["OrderDirection"] | undefined,
	address1?: ModelTypes["OrderDirection"] | undefined,
	address2?: ModelTypes["OrderDirection"] | undefined,
	city?: ModelTypes["OrderDirection"] | undefined,
	postalCode?: ModelTypes["OrderDirection"] | undefined,
	state?: ModelTypes["OrderDirection"] | undefined,
	country?: ModelTypes["RegionOrderBy"] | undefined,
	dateFrom?: ModelTypes["OrderDirection"] | undefined,
	dateTo?: ModelTypes["OrderDirection"] | undefined,
	year?: ModelTypes["OrderDirection"] | undefined,
	isPdfGenerated?: ModelTypes["OrderDirection"] | undefined,
	pdfObjectKey?: ModelTypes["OrderDirection"] | undefined
};
	["TextImageListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["PostSum"]: {
		_meta?: ModelTypes["PostSumMeta"] | undefined,
	id: ModelTypes["UUID"],
	totalCents: number,
	czkPercentage: number,
	post?: ModelTypes["Post"] | undefined
};
	["PostSumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	czkPercentage?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined
};
	["PostFundraisingProgress"]: {
		_meta?: ModelTypes["PostFundraisingProgressMeta"] | undefined,
	id: ModelTypes["UUID"],
	progress?: number | undefined,
	post?: ModelTypes["Post"] | undefined
};
	["PostFundraisingProgressMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	progress?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined
};
	["PostRevisionsByLocalesUniqueWhere"]: {
	locales?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined
};
	["PostRevisionsByRegionListOverrideUniqueWhere"]: {
	regionListOverride?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined
};
	["PostLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["PostLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["PostLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["PostLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["PostRevisionConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostRevisionEdge"]>
};
	["PostRevisionEdge"]: {
		node: ModelTypes["PostRevision"]
};
	["PostLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostLocaleEdge"]>
};
	["PostLocaleEdge"]: {
		node: ModelTypes["PostLocale"]
};
	["HeroCarouselConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HeroCarouselEdge"]>
};
	["HeroCarouselEdge"]: {
		node: ModelTypes["HeroCarousel"]
};
	["ContentReferenceConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
		node: ModelTypes["ContentReference"]
};
	["GivenGiftsPageLocale"]: {
		_meta?: ModelTypes["GivenGiftsPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["GivenGiftsPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	link?: ModelTypes["Linkable"] | undefined
};
	["GivenGiftsPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined,
	giftTitle?: ModelTypes["FieldMeta"] | undefined,
	giftText?: ModelTypes["FieldMeta"] | undefined,
	note?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined
};
	["GivenGiftsPage"]: {
		_meta?: ModelTypes["GivenGiftsPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["GivenGiftsPageLocale"]>,
	localesByLocale?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	localesByContent?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	localesBySeo?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	localesByLink?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	paginateLocales: ModelTypes["GivenGiftsPageLocaleConnection"]
};
	["GivenGiftsPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["GivenGiftsPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["GivenGiftsPageLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["GivenGiftsPageLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["GivenGiftsPageLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["GivenGiftsPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GivenGiftsPageLocaleEdge"]>
};
	["GivenGiftsPageLocaleEdge"]: {
		node: ModelTypes["GivenGiftsPageLocale"]
};
	["ReceivedGiftsPageLocale"]: {
		_meta?: ModelTypes["ReceivedGiftsPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	root?: ModelTypes["ReceivedGiftsPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined
};
	["ReceivedGiftsPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined,
	giftTitle?: ModelTypes["FieldMeta"] | undefined,
	giftText?: ModelTypes["FieldMeta"] | undefined,
	note?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined
};
	["ReceivedGiftsPage"]: {
		_meta?: ModelTypes["ReceivedGiftsPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["ReceivedGiftsPageLocale"]>,
	localesByLocale?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	localesByLink?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	localesByContent?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	localesBySeo?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	paginateLocales: ModelTypes["ReceivedGiftsPageLocaleConnection"]
};
	["ReceivedGiftsPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["ReceivedGiftsPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ReceivedGiftsPageLocaleEdge"]>
};
	["ReceivedGiftsPageLocaleEdge"]: {
		node: ModelTypes["ReceivedGiftsPageLocale"]
};
	["ContentReferenceLinkableItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	item?: ModelTypes["LinkableOrderBy"] | undefined,
	reference?: ModelTypes["ContentReferenceOrderBy"] | undefined
};
	["ValueList"]: {
		_meta?: ModelTypes["ValueListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["ValueItem"]>,
	paginateItems: ModelTypes["ValueItemConnection"]
};
	["ValueListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["ValueItem"]: {
		_meta?: ModelTypes["ValueItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["ValueList"] | undefined,
	item?: ModelTypes["Value"] | undefined
};
	["ValueItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	item?: ModelTypes["FieldMeta"] | undefined
};
	["Value"]: {
		_meta?: ModelTypes["ValueMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	textContent?: ModelTypes["Content"] | undefined
};
	["ValueMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	textContent?: ModelTypes["FieldMeta"] | undefined
};
	["ValueItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["ValueListOrderBy"] | undefined,
	item?: ModelTypes["ValueOrderBy"] | undefined
};
	["ValueOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	textContent?: ModelTypes["ContentOrderBy"] | undefined
};
	["ValueItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ValueItemEdge"]>
};
	["ValueItemEdge"]: {
		node: ModelTypes["ValueItem"]
};
	["ImageLinkList"]: {
		_meta?: ModelTypes["ImageLinkListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["ImageLinkItem"]>,
	paginateItems: ModelTypes["ImageLinkItemConnection"]
};
	["ImageLinkListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["ImageLinkItem"]: {
		_meta?: ModelTypes["ImageLinkItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["ImageLinkList"] | undefined,
	item?: ModelTypes["ImageLink"] | undefined
};
	["ImageLinkItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	item?: ModelTypes["FieldMeta"] | undefined
};
	["ImageLink"]: {
		_meta?: ModelTypes["ImageLinkMeta"] | undefined,
	id: ModelTypes["UUID"],
	image?: ModelTypes["Image"] | undefined,
	link?: ModelTypes["Link"] | undefined
};
	["ImageLinkMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined
};
	["ImageLinkItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["ImageLinkListOrderBy"] | undefined,
	item?: ModelTypes["ImageLinkOrderBy"] | undefined
};
	["ImageLinkOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined
};
	["ImageLinkItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageLinkItemEdge"]>
};
	["ImageLinkItemEdge"]: {
		node: ModelTypes["ImageLinkItem"]
};
	["PostAreaList"]: {
		_meta?: ModelTypes["PostAreaListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["PostAreaListItem"]>,
	paginateItems: ModelTypes["PostAreaListItemConnection"]
};
	["PostAreaListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["PostAreaListItem"]: {
		_meta?: ModelTypes["PostAreaListItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["PostAreaList"] | undefined,
	item?: ModelTypes["PostArea"] | undefined
};
	["PostAreaListItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	item?: ModelTypes["FieldMeta"] | undefined
};
	["PostAreaListItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["PostAreaListOrderBy"] | undefined,
	item?: ModelTypes["PostAreaOrderBy"] | undefined
};
	["PostAreaListItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaListItemEdge"]>
};
	["PostAreaListItemEdge"]: {
		node: ModelTypes["PostAreaListItem"]
};
	["Accordion"]: {
		_meta?: ModelTypes["AccordionMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["AccordionItem"]>,
	itemsByDescriptionContent?: ModelTypes["AccordionItem"] | undefined,
	paginateItems: ModelTypes["AccordionItemConnection"]
};
	["AccordionMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["AccordionItem"]: {
		_meta?: ModelTypes["AccordionItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	name: string,
	list?: ModelTypes["Accordion"] | undefined,
	descriptionContent?: ModelTypes["Content"] | undefined
};
	["AccordionItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	descriptionContent?: ModelTypes["FieldMeta"] | undefined
};
	["AccordionItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["AccordionOrderBy"] | undefined,
	descriptionContent?: ModelTypes["ContentOrderBy"] | undefined
};
	["AccordionItemsByDescriptionContentUniqueWhere"]: {
	descriptionContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["AccordionItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["AccordionItemEdge"]>
};
	["AccordionItemEdge"]: {
		node: ModelTypes["AccordionItem"]
};
	["MediumList"]: {
		_meta?: ModelTypes["MediumListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["MediumItem"]>,
	paginateItems: ModelTypes["MediumItemConnection"]
};
	["MediumListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["MediumItem"]: {
		_meta?: ModelTypes["MediumItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["MediumList"] | undefined,
	medium?: ModelTypes["Medium"] | undefined
};
	["MediumItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	medium?: ModelTypes["FieldMeta"] | undefined
};
	["Medium"]: {
		_meta?: ModelTypes["MediumMeta"] | undefined,
	id: ModelTypes["UUID"],
	type: ModelTypes["MediumType"],
	image?: ModelTypes["Image"] | undefined,
	video?: ModelTypes["Video"] | undefined
};
	["MediumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	video?: ModelTypes["FieldMeta"] | undefined
};
	["MediumItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["MediumListOrderBy"] | undefined,
	medium?: ModelTypes["MediumOrderBy"] | undefined
};
	["MediumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	video?: ModelTypes["VideoOrderBy"] | undefined
};
	["MediumItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["MediumItemEdge"]>
};
	["MediumItemEdge"]: {
		node: ModelTypes["MediumItem"]
};
	["MemberList"]: {
		_meta?: ModelTypes["MemberListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["MemberListItem"]>,
	itemsByDescriptionContent?: ModelTypes["MemberListItem"] | undefined,
	paginateItems: ModelTypes["MemberListItemConnection"]
};
	["MemberListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["MemberListItem"]: {
		_meta?: ModelTypes["MemberListItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	name: string,
	position?: string | undefined,
	list?: ModelTypes["MemberList"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	descriptionContent?: ModelTypes["Content"] | undefined
};
	["MemberListItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	position?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	descriptionContent?: ModelTypes["FieldMeta"] | undefined
};
	["MemberListItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	position?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["MemberListOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	descriptionContent?: ModelTypes["ContentOrderBy"] | undefined
};
	["MemberListItemsByDescriptionContentUniqueWhere"]: {
	descriptionContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["MemberListItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["MemberListItemEdge"]>
};
	["MemberListItemEdge"]: {
		node: ModelTypes["MemberListItem"]
};
	["Form"]: {
		_meta?: ModelTypes["FormMeta"] | undefined,
	id: ModelTypes["UUID"],
	name?: string | undefined,
	type: ModelTypes["FormType"],
	tax?: ModelTypes["FilledTaxForm"] | undefined
};
	["FormMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	tax?: ModelTypes["FieldMeta"] | undefined
};
	["FilledTaxForm"]: {
		_meta?: ModelTypes["FilledTaxFormMeta"] | undefined,
	id: ModelTypes["UUID"],
	publishedAt: ModelTypes["DateTime"],
	userId: string,
	email: string,
	name: string,
	vatId: string,
	address1: string,
	address2?: string | undefined,
	city: string,
	postalCode: string,
	state: string,
	country?: ModelTypes["Region"] | undefined,
	dateFrom?: ModelTypes["Date"] | undefined,
	dateTo?: ModelTypes["Date"] | undefined,
	year?: number | undefined,
	isPdfGenerated: boolean,
	pdfObjectKey?: string | undefined
};
	["FilledTaxFormMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	publishedAt?: ModelTypes["FieldMeta"] | undefined,
	userId?: ModelTypes["FieldMeta"] | undefined,
	email?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	vatId?: ModelTypes["FieldMeta"] | undefined,
	address1?: ModelTypes["FieldMeta"] | undefined,
	address2?: ModelTypes["FieldMeta"] | undefined,
	city?: ModelTypes["FieldMeta"] | undefined,
	postalCode?: ModelTypes["FieldMeta"] | undefined,
	state?: ModelTypes["FieldMeta"] | undefined,
	country?: ModelTypes["FieldMeta"] | undefined,
	dateFrom?: ModelTypes["FieldMeta"] | undefined,
	dateTo?: ModelTypes["FieldMeta"] | undefined,
	year?: ModelTypes["FieldMeta"] | undefined,
	isPdfGenerated?: ModelTypes["FieldMeta"] | undefined,
	pdfObjectKey?: ModelTypes["FieldMeta"] | undefined
};
	["PostOrganizationList"]: {
		_meta?: ModelTypes["PostOrganizationListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["PostOrganizationListItem"]>,
	itemsByLink?: ModelTypes["PostOrganizationListItem"] | undefined,
	paginateItems: ModelTypes["PostOrganizationListItemConnection"]
};
	["PostOrganizationListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["PostOrganizationListItem"]: {
		_meta?: ModelTypes["PostOrganizationListItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["PostOrganizationList"] | undefined,
	item?: ModelTypes["PostOrganization"] | undefined,
	type?: ModelTypes["PostOrganizationListItemType"] | undefined,
	link?: ModelTypes["Link"] | undefined,
	image?: ModelTypes["Image"] | undefined
};
	["PostOrganizationListItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	item?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined
};
	["PostOrganizationListItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["PostOrganizationListOrderBy"] | undefined,
	item?: ModelTypes["PostOrganizationOrderBy"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined
};
	["PostOrganizationListItemsByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["PostOrganizationListItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostOrganizationListItemEdge"]>
};
	["PostOrganizationListItemEdge"]: {
		node: ModelTypes["PostOrganizationListItem"]
};
	["TextImageList"]: {
		_meta?: ModelTypes["TextImageListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["TextImageListItem"]>,
	paginateItems: ModelTypes["TextImageListItemConnection"]
};
	["TextImageListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["TextImageListItem"]: {
		_meta?: ModelTypes["TextImageListItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["TextImageList"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	text?: string | undefined,
	link?: ModelTypes["Link"] | undefined
};
	["TextImageListItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined
};
	["TextImageListItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["TextImageListOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined
};
	["TextImageListItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TextImageListItemEdge"]>
};
	["TextImageListItemEdge"]: {
		node: ModelTypes["TextImageListItem"]
};
	["ContentReferenceLinkablesByItemUniqueWhere"]: {
	item?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["ContentReferenceLinkableItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContentReferenceLinkableItemEdge"]>
};
	["ContentReferenceLinkableItemEdge"]: {
		node: ModelTypes["ContentReferenceLinkableItem"]
};
	["ContentBlockReferencesByLinkablesUniqueWhere"]: {
	linkables?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["ContentBlockReferencesByValueListUniqueWhere"]: {
	valueList?: ModelTypes["ValueListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByImageLinkListUniqueWhere"]: {
	imageLinkList?: ModelTypes["ImageLinkListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByAreaListUniqueWhere"]: {
	areaList?: ModelTypes["PostAreaListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByAccordionUniqueWhere"]: {
	accordion?: ModelTypes["AccordionUniqueWhere"] | undefined
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
	media?: ModelTypes["MediumListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByMemberListUniqueWhere"]: {
	memberList?: ModelTypes["MemberListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByContentWithoutBlocksUniqueWhere"]: {
	contentWithoutBlocks?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["ContentBlockReferencesByOrganizationListUniqueWhere"]: {
	organizationList?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByTextImageListUniqueWhere"]: {
	textImageList?: ModelTypes["TextImageListUniqueWhere"] | undefined
};
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?: ModelTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentBlockConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
		node: ModelTypes["ContentBlock"]
};
	["HeaderLocale"]: {
		_meta?: ModelTypes["HeaderLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["Header"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	links?: ModelTypes["LinkList"] | undefined
};
	["HeaderLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	links?: ModelTypes["FieldMeta"] | undefined
};
	["Header"]: {
		_meta?: ModelTypes["HeaderMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	logo?: ModelTypes["Image"] | undefined,
	locales: Array<ModelTypes["HeaderLocale"]>,
	organizationList?: ModelTypes["PostOrganizationList"] | undefined,
	localesByLocale?: ModelTypes["HeaderLocale"] | undefined,
	localesByLinks?: ModelTypes["HeaderLocale"] | undefined,
	paginateLocales: ModelTypes["HeaderLocaleConnection"]
};
	["HeaderMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	organizationList?: ModelTypes["FieldMeta"] | undefined
};
	["HeaderLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["HeaderOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	links?: ModelTypes["LinkListOrderBy"] | undefined
};
	["HeaderOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	organizationList?: ModelTypes["PostOrganizationListOrderBy"] | undefined
};
	["LinkListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["HeaderLocalesByLinksUniqueWhere"]: {
	links?: ModelTypes["LinkListUniqueWhere"] | undefined
};
	["HeaderLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HeaderLocaleEdge"]>
};
	["HeaderLocaleEdge"]: {
		node: ModelTypes["HeaderLocale"]
};
	["LinkList"]: {
		_meta?: ModelTypes["LinkListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["LinkItem"]>,
	itemsByLink?: ModelTypes["LinkItem"] | undefined,
	paginateItems: ModelTypes["LinkItemConnection"]
};
	["LinkListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["LinkItem"]: {
		_meta?: ModelTypes["LinkItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["LinkList"] | undefined,
	link?: ModelTypes["Link"] | undefined
};
	["LinkItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined
};
	["LinkItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["LinkListOrderBy"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined
};
	["LinkListItemsByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LinkItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["LinkItemEdge"]>
};
	["LinkItemEdge"]: {
		node: ModelTypes["LinkItem"]
};
	["FooterLocale"]: {
		_meta?: ModelTypes["FooterLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	copyright?: string | undefined,
	root?: ModelTypes["Footer"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	linkList?: ModelTypes["LinkList"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: ModelTypes["Content"] | undefined,
	imageLinkList?: ModelTypes["ImageLinkList"] | undefined
};
	["FooterLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	copyright?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	linkList?: ModelTypes["FieldMeta"] | undefined,
	contactEmail?: ModelTypes["FieldMeta"] | undefined,
	addressInfo?: ModelTypes["FieldMeta"] | undefined,
	imageLinkList?: ModelTypes["FieldMeta"] | undefined
};
	["Footer"]: {
		_meta?: ModelTypes["FooterMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["FooterLocale"]>,
	logo?: ModelTypes["Image"] | undefined,
	localesByLocale?: ModelTypes["FooterLocale"] | undefined,
	localesByLinkList?: ModelTypes["FooterLocale"] | undefined,
	localesByAddressInfo?: ModelTypes["FooterLocale"] | undefined,
	localesByImageLinkList?: ModelTypes["FooterLocale"] | undefined,
	paginateLocales: ModelTypes["FooterLocaleConnection"]
};
	["FooterMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined
};
	["FooterLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	copyright?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["FooterOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	linkList?: ModelTypes["LinkListOrderBy"] | undefined,
	contactEmail?: ModelTypes["OrderDirection"] | undefined,
	addressInfo?: ModelTypes["ContentOrderBy"] | undefined,
	imageLinkList?: ModelTypes["ImageLinkListOrderBy"] | undefined
};
	["FooterOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined
};
	["FooterLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["FooterLocalesByLinkListUniqueWhere"]: {
	linkList?: ModelTypes["LinkListUniqueWhere"] | undefined
};
	["FooterLocalesByAddressInfoUniqueWhere"]: {
	addressInfo?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["FooterLocalesByImageLinkListUniqueWhere"]: {
	imageLinkList?: ModelTypes["ImageLinkListUniqueWhere"] | undefined
};
	["FooterLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FooterLocaleEdge"]>
};
	["FooterLocaleEdge"]: {
		node: ModelTypes["FooterLocale"]
};
	["GenericPageAboutSettingsLocale"]: {
		_meta?: ModelTypes["GenericPageAboutSettingsLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["GenericPageAboutSettings"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	linkGroups: Array<ModelTypes["GenericPageAboutGroupLinksLocale"]>,
	linkGroupsByLinkList?: ModelTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	paginateLinkGroups: ModelTypes["GenericPageAboutGroupLinksLocaleConnection"]
};
	["GenericPageAboutSettingsLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	linkGroups?: ModelTypes["FieldMeta"] | undefined
};
	["GenericPageAboutSettings"]: {
		_meta?: ModelTypes["GenericPageAboutSettingsMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["GenericPageAboutSettingsLocale"]>,
	localesByLocale?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	localesByLinkGroups?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	paginateLocales: ModelTypes["GenericPageAboutSettingsLocaleConnection"]
};
	["GenericPageAboutSettingsMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["GenericPageAboutSettingsLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["GenericPageAboutSettingsOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined
};
	["GenericPageAboutSettingsOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["GenericPageAboutSettingsLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere"]: {
	linkGroups?: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined
};
	["GenericPageAboutSettingsLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GenericPageAboutSettingsLocaleEdge"]>
};
	["GenericPageAboutSettingsLocaleEdge"]: {
		node: ModelTypes["GenericPageAboutSettingsLocale"]
};
	["GenericPageAboutGroupLinksLocale"]: {
		_meta?: ModelTypes["GenericPageAboutGroupLinksLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	settings?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	linkList?: ModelTypes["LinkList"] | undefined
};
	["GenericPageAboutGroupLinksLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	settings?: ModelTypes["FieldMeta"] | undefined,
	linkList?: ModelTypes["FieldMeta"] | undefined
};
	["GenericPageAboutGroupLinksLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	settings?: ModelTypes["GenericPageAboutSettingsLocaleOrderBy"] | undefined,
	linkList?: ModelTypes["LinkListOrderBy"] | undefined
};
	["GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere"]: {
	linkList?: ModelTypes["LinkListUniqueWhere"] | undefined
};
	["GenericPageAboutGroupLinksLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GenericPageAboutGroupLinksLocaleEdge"]>
};
	["GenericPageAboutGroupLinksLocaleEdge"]: {
		node: ModelTypes["GenericPageAboutGroupLinksLocale"]
};
	["FeedPageLocale"]: {
		_meta?: ModelTypes["FeedPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["FeedPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	heroTiles?: ModelTypes["TileList"] | undefined,
	sectionList: Array<ModelTypes["FeedPageSection"]>,
	cardList?: ModelTypes["CardList"] | undefined,
	storyGuideList?: ModelTypes["StoryGuideList"] | undefined,
	sectionListByTileStripeList?: ModelTypes["FeedPageSection"] | undefined,
	paginateSectionList: ModelTypes["FeedPageSectionConnection"]
};
	["FeedPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	heroTiles?: ModelTypes["FieldMeta"] | undefined,
	sectionList?: ModelTypes["FieldMeta"] | undefined,
	cardList?: ModelTypes["FieldMeta"] | undefined,
	storyGuideList?: ModelTypes["FieldMeta"] | undefined
};
	["FeedPage"]: {
		_meta?: ModelTypes["FeedPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["FeedPageLocale"]>,
	localesByLocale?: ModelTypes["FeedPageLocale"] | undefined,
	localesByHeroTiles?: ModelTypes["FeedPageLocale"] | undefined,
	localesBySectionList?: ModelTypes["FeedPageLocale"] | undefined,
	localesByCardList?: ModelTypes["FeedPageLocale"] | undefined,
	localesByStoryGuideList?: ModelTypes["FeedPageLocale"] | undefined,
	paginateLocales: ModelTypes["FeedPageLocaleConnection"]
};
	["FeedPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["FeedPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["FeedPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	heroTiles?: ModelTypes["TileListOrderBy"] | undefined,
	cardList?: ModelTypes["CardListOrderBy"] | undefined,
	storyGuideList?: ModelTypes["StoryGuideListOrderBy"] | undefined
};
	["FeedPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["TileListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	size?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	areaType?: ModelTypes["PostAreaOrderBy"] | undefined
};
	["CardListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["StoryGuideListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["FeedPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["FeedPageLocalesByHeroTilesUniqueWhere"]: {
	heroTiles?: ModelTypes["TileListUniqueWhere"] | undefined
};
	["FeedPageLocalesBySectionListUniqueWhere"]: {
	sectionList?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined
};
	["FeedPageLocalesByCardListUniqueWhere"]: {
	cardList?: ModelTypes["CardListUniqueWhere"] | undefined
};
	["FeedPageLocalesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ModelTypes["StoryGuideListUniqueWhere"] | undefined
};
	["FeedPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FeedPageLocaleEdge"]>
};
	["FeedPageLocaleEdge"]: {
		node: ModelTypes["FeedPageLocale"]
};
	["TileList"]: {
		_meta?: ModelTypes["TileListMeta"] | undefined,
	id: ModelTypes["UUID"],
	size: ModelTypes["TileListSize"],
	title?: string | undefined,
	items: Array<ModelTypes["TileItem"]>,
	areaType?: ModelTypes["PostArea"] | undefined,
	itemsByLink?: ModelTypes["TileItem"] | undefined,
	paginateItems: ModelTypes["TileItemConnection"]
};
	["TileListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	size?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined,
	areaType?: ModelTypes["FieldMeta"] | undefined
};
	["TileItem"]: {
		_meta?: ModelTypes["TileItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	type: ModelTypes["TileItemType"],
	title?: string | undefined,
	description?: string | undefined,
	list?: ModelTypes["TileList"] | undefined,
	post?: ModelTypes["Post"] | undefined,
	area?: ModelTypes["PostArea"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	link?: ModelTypes["Link"] | undefined,
	organization?: ModelTypes["PostOrganization"] | undefined
};
	["TileItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	description?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined
};
	["TileItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	description?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["TileListOrderBy"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined
};
	["TileListItemsByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["TileItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TileItemEdge"]>
};
	["TileItemEdge"]: {
		node: ModelTypes["TileItem"]
};
	["FeedPageSection"]: {
		_meta?: ModelTypes["FeedPageSectionMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	title?: string | undefined,
	feedPageLocale?: ModelTypes["FeedPageLocale"] | undefined,
	tileStripeList: Array<ModelTypes["FeedPageTileStripe"]>,
	paginateTileStripeList: ModelTypes["FeedPageTileStripeConnection"]
};
	["FeedPageSectionMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	feedPageLocale?: ModelTypes["FieldMeta"] | undefined,
	tileStripeList?: ModelTypes["FieldMeta"] | undefined
};
	["FeedPageTileStripe"]: {
		_meta?: ModelTypes["FeedPageTileStripeMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	section?: ModelTypes["FeedPageSection"] | undefined,
	tileList?: ModelTypes["TileList"] | undefined
};
	["FeedPageTileStripeMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	section?: ModelTypes["FieldMeta"] | undefined,
	tileList?: ModelTypes["FieldMeta"] | undefined
};
	["FeedPageTileStripeOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	section?: ModelTypes["FeedPageSectionOrderBy"] | undefined,
	tileList?: ModelTypes["TileListOrderBy"] | undefined
};
	["FeedPageSectionOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	feedPageLocale?: ModelTypes["FeedPageLocaleOrderBy"] | undefined
};
	["FeedPageTileStripeConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FeedPageTileStripeEdge"]>
};
	["FeedPageTileStripeEdge"]: {
		node: ModelTypes["FeedPageTileStripe"]
};
	["CardList"]: {
		_meta?: ModelTypes["CardListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["CardItem"]>,
	itemsByLink?: ModelTypes["CardItem"] | undefined,
	paginateItems: ModelTypes["CardItemConnection"]
};
	["CardListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["CardItem"]: {
		_meta?: ModelTypes["CardItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	title?: string | undefined,
	description?: string | undefined,
	list?: ModelTypes["CardList"] | undefined,
	link?: ModelTypes["Link"] | undefined
};
	["CardItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	description?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined
};
	["CardItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	description?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["CardListOrderBy"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined
};
	["CardListItemsByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["CardItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CardItemEdge"]>
};
	["CardItemEdge"]: {
		node: ModelTypes["CardItem"]
};
	["StoryGuideList"]: {
		_meta?: ModelTypes["StoryGuideListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["StoryGuideItem"]>,
	paginateItems: ModelTypes["StoryGuideItemConnection"]
};
	["StoryGuideListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["StoryGuideItem"]: {
		_meta?: ModelTypes["StoryGuideItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["StoryGuideList"] | undefined,
	guide?: ModelTypes["StoryGuide"] | undefined
};
	["StoryGuideItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	guide?: ModelTypes["FieldMeta"] | undefined
};
	["StoryGuide"]: {
		_meta?: ModelTypes["StoryGuideMeta"] | undefined,
	id: ModelTypes["UUID"],
	mediaType: ModelTypes["MediaType"],
	title: string,
	subtitle: string,
	image?: ModelTypes["Image"] | undefined,
	secondaryImage?: ModelTypes["Image"] | undefined
};
	["StoryGuideMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	mediaType?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	secondaryImage?: ModelTypes["FieldMeta"] | undefined
};
	["StoryGuideItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["StoryGuideListOrderBy"] | undefined,
	guide?: ModelTypes["StoryGuideOrderBy"] | undefined
};
	["StoryGuideOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	mediaType?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	secondaryImage?: ModelTypes["ImageOrderBy"] | undefined
};
	["StoryGuideItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["StoryGuideItemEdge"]>
};
	["StoryGuideItemEdge"]: {
		node: ModelTypes["StoryGuideItem"]
};
	["FeedPageLocaleSectionListByTileStripeListUniqueWhere"]: {
	tileStripeList?: ModelTypes["FeedPageTileStripeUniqueWhere"] | undefined
};
	["FeedPageSectionConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FeedPageSectionEdge"]>
};
	["FeedPageSectionEdge"]: {
		node: ModelTypes["FeedPageSection"]
};
	["RecurringPaymentPageLocale"]: {
		_meta?: ModelTypes["RecurringPaymentPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["RecurringPaymentPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	favouritePosts?: ModelTypes["PostList"] | undefined,
	storyGuideList?: ModelTypes["StoryGuideList"] | undefined
};
	["RecurringPaymentPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	favouritePosts?: ModelTypes["FieldMeta"] | undefined,
	storyGuideList?: ModelTypes["FieldMeta"] | undefined
};
	["RecurringPaymentPage"]: {
		_meta?: ModelTypes["RecurringPaymentPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["RecurringPaymentPageLocale"]>,
	localesByLocale?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	localesByFavouritePosts?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	localesByStoryGuideList?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	paginateLocales: ModelTypes["RecurringPaymentPageLocaleConnection"]
};
	["RecurringPaymentPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["RecurringPaymentPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["RecurringPaymentPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	favouritePosts?: ModelTypes["PostListOrderBy"] | undefined,
	storyGuideList?: ModelTypes["StoryGuideListOrderBy"] | undefined
};
	["RecurringPaymentPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["PostListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["RecurringPaymentPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["RecurringPaymentPageLocalesByFavouritePostsUniqueWhere"]: {
	favouritePosts?: ModelTypes["PostListUniqueWhere"] | undefined
};
	["RecurringPaymentPageLocalesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ModelTypes["StoryGuideListUniqueWhere"] | undefined
};
	["RecurringPaymentPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["RecurringPaymentPageLocaleEdge"]>
};
	["RecurringPaymentPageLocaleEdge"]: {
		node: ModelTypes["RecurringPaymentPageLocale"]
};
	["PostList"]: {
		_meta?: ModelTypes["PostListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["PostListItem"]>,
	paginateItems: ModelTypes["PostListItemConnection"]
};
	["PostListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["PostListItem"]: {
		_meta?: ModelTypes["PostListItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["PostList"] | undefined,
	post?: ModelTypes["Post"] | undefined
};
	["PostListItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined
};
	["PostListItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["PostListOrderBy"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined
};
	["PostListItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostListItemEdge"]>
};
	["PostListItemEdge"]: {
		node: ModelTypes["PostListItem"]
};
	["ScheduledNotificationLocale"]: {
		_meta?: ModelTypes["ScheduledNotificationLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title: string,
	description: string,
	root?: ModelTypes["ScheduledNotification"] | undefined,
	locale?: ModelTypes["Locale"] | undefined
};
	["ScheduledNotificationLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	description?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined
};
	["ScheduledNotification"]: {
		_meta?: ModelTypes["ScheduledNotificationMeta"] | undefined,
	id: ModelTypes["UUID"],
	localMsFromMidnight: number,
	scheduledDate: ModelTypes["Date"],
	internalTitle?: string | undefined,
	target?: ModelTypes["NotificationTargetGroup"] | undefined,
	locales: Array<ModelTypes["ScheduledNotificationLocale"]>,
	image?: ModelTypes["Image"] | undefined,
	completedAt?: ModelTypes["DateTime"] | undefined,
	processedNotifications: Array<ModelTypes["ProcessedNotificationSource"]>,
	localesByLocale?: ModelTypes["ScheduledNotificationLocale"] | undefined,
	processedNotificationsByProcessedNotification?: ModelTypes["ProcessedNotificationSource"] | undefined,
	paginateLocales: ModelTypes["ScheduledNotificationLocaleConnection"],
	paginateProcessedNotifications: ModelTypes["ProcessedNotificationSourceConnection"]
};
	["ScheduledNotificationMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	localMsFromMidnight?: ModelTypes["FieldMeta"] | undefined,
	scheduledDate?: ModelTypes["FieldMeta"] | undefined,
	internalTitle?: ModelTypes["FieldMeta"] | undefined,
	target?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	completedAt?: ModelTypes["FieldMeta"] | undefined,
	processedNotifications?: ModelTypes["FieldMeta"] | undefined
};
	["NotificationTargetGroup"]: {
		_meta?: ModelTypes["NotificationTargetGroupMeta"] | undefined,
	id: ModelTypes["UUID"],
	type: ModelTypes["NotificationTargetType"],
	regions: Array<ModelTypes["Region"]>,
	paginateRegions: ModelTypes["RegionConnection"]
};
	["NotificationTargetGroupMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	regions?: ModelTypes["FieldMeta"] | undefined
};
	["RegionConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["RegionEdge"]>
};
	["RegionEdge"]: {
		node: ModelTypes["Region"]
};
	["ScheduledNotificationLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	description?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["ScheduledNotificationOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined
};
	["ScheduledNotificationOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	localMsFromMidnight?: ModelTypes["OrderDirection"] | undefined,
	scheduledDate?: ModelTypes["OrderDirection"] | undefined,
	internalTitle?: ModelTypes["OrderDirection"] | undefined,
	target?: ModelTypes["NotificationTargetGroupOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	completedAt?: ModelTypes["OrderDirection"] | undefined
};
	["NotificationTargetGroupOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined
};
	["ProcessedNotificationSource"]: {
		_meta?: ModelTypes["ProcessedNotificationSourceMeta"] | undefined,
	id: ModelTypes["UUID"],
	type: ModelTypes["ProcessedNotificationSourceType"],
	processedNotification?: ModelTypes["ProcessedNotification"] | undefined,
	donationReminderUser?: ModelTypes["User"] | undefined,
	scheduledNotification?: ModelTypes["ScheduledNotification"] | undefined
};
	["ProcessedNotificationSourceMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	processedNotification?: ModelTypes["FieldMeta"] | undefined,
	donationReminderUser?: ModelTypes["FieldMeta"] | undefined,
	scheduledNotification?: ModelTypes["FieldMeta"] | undefined
};
	["ProcessedNotification"]: {
		_meta?: ModelTypes["ProcessedNotificationMeta"] | undefined,
	id: ModelTypes["UUID"],
	topic: string,
	sentAt: ModelTypes["DateTime"],
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess: boolean,
	source?: ModelTypes["ProcessedNotificationSource"] | undefined,
	title?: string | undefined,
	body?: string | undefined
};
	["ProcessedNotificationMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	topic?: ModelTypes["FieldMeta"] | undefined,
	sentAt?: ModelTypes["FieldMeta"] | undefined,
	errorMessage?: ModelTypes["FieldMeta"] | undefined,
	errorCode?: ModelTypes["FieldMeta"] | undefined,
	isSuccess?: ModelTypes["FieldMeta"] | undefined,
	source?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	body?: ModelTypes["FieldMeta"] | undefined
};
	["User"]: {
		_meta?: ModelTypes["UserMeta"] | undefined,
	id: ModelTypes["UUID"],
	tenantPersonId: ModelTypes["UUID"],
	createdAt?: ModelTypes["DateTime"] | undefined,
	email: string,
	name?: string | undefined,
	payments: Array<ModelTypes["UserPayment"]>,
	variableSymbol: number,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["Region"] | undefined,
	currency?: ModelTypes["Currency"] | undefined,
	recurringPayments: Array<ModelTypes["UserRecurringPayment"]>,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations: Array<ModelTypes["OnBehalfDonation"]>,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	signedUp?: boolean | undefined,
	devices: Array<ModelTypes["Device"]>,
	processedNotifications: Array<ModelTypes["ProcessedNotificationSource"]>,
	areaStats: Array<ModelTypes["UserAreaStats"]>,
	organizationStats: Array<ModelTypes["UserOrganizationStats"]>,
	postStats: Array<ModelTypes["UserPostStats"]>,
	currencyStats: Array<ModelTypes["UserCurrencyStats"]>,
	stats?: ModelTypes["UserStats"] | undefined,
	paymentsByOrder?: ModelTypes["UserPayment"] | undefined,
	paymentsByCsobPayment?: ModelTypes["UserPayment"] | undefined,
	paymentsByStripePayment?: ModelTypes["UserPayment"] | undefined,
	paymentsByMetadata?: ModelTypes["UserPayment"] | undefined,
	recurringPaymentsByItems?: ModelTypes["UserRecurringPayment"] | undefined,
	recurringPaymentsByMeta?: ModelTypes["UserRecurringPayment"] | undefined,
	onBehalfDonationsBySecretCode?: ModelTypes["OnBehalfDonation"] | undefined,
	onBehalfDonationsByPayments?: ModelTypes["OnBehalfDonation"] | undefined,
	onBehalfDonationsByMeta?: ModelTypes["OnBehalfDonation"] | undefined,
	devicesByFcmToken?: ModelTypes["Device"] | undefined,
	processedNotificationsByProcessedNotification?: ModelTypes["ProcessedNotificationSource"] | undefined,
	paginatePayments: ModelTypes["UserPaymentConnection"],
	paginateRecurringPayments: ModelTypes["UserRecurringPaymentConnection"],
	paginateOnBehalfDonations: ModelTypes["OnBehalfDonationConnection"],
	paginateDevices: ModelTypes["DeviceConnection"],
	paginateProcessedNotifications: ModelTypes["ProcessedNotificationSourceConnection"],
	paginateAreaStats: ModelTypes["UserAreaStatsConnection"],
	paginateOrganizationStats: ModelTypes["UserOrganizationStatsConnection"],
	paginatePostStats: ModelTypes["UserPostStatsConnection"],
	paginateCurrencyStats: ModelTypes["UserCurrencyStatsConnection"]
};
	["UserMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	tenantPersonId?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	email?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	payments?: ModelTypes["FieldMeta"] | undefined,
	variableSymbol?: ModelTypes["FieldMeta"] | undefined,
	lastActiveAt?: ModelTypes["FieldMeta"] | undefined,
	region?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	recurringPayments?: ModelTypes["FieldMeta"] | undefined,
	stripeId?: ModelTypes["FieldMeta"] | undefined,
	isDeactivated?: ModelTypes["FieldMeta"] | undefined,
	onBehalfDonations?: ModelTypes["FieldMeta"] | undefined,
	publicProfileSecret?: ModelTypes["FieldMeta"] | undefined,
	publicProfileCustomNote?: ModelTypes["FieldMeta"] | undefined,
	publicProfileCustomNoteEnabled?: ModelTypes["FieldMeta"] | undefined,
	donationConfirmationEmailEnabled?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	signedUp?: ModelTypes["FieldMeta"] | undefined,
	devices?: ModelTypes["FieldMeta"] | undefined,
	processedNotifications?: ModelTypes["FieldMeta"] | undefined,
	areaStats?: ModelTypes["FieldMeta"] | undefined,
	organizationStats?: ModelTypes["FieldMeta"] | undefined,
	postStats?: ModelTypes["FieldMeta"] | undefined,
	currencyStats?: ModelTypes["FieldMeta"] | undefined,
	stats?: ModelTypes["FieldMeta"] | undefined
};
	["UserPayment"]: {
		_meta?: ModelTypes["UserPaymentMeta"] | undefined,
	id: ModelTypes["UUID"],
	cents: number,
	createdAt: ModelTypes["DateTime"],
	specificSymbol: string,
	currency?: ModelTypes["Currency"] | undefined,
	order?: ModelTypes["UserPaymentOrderId"] | undefined,
	csobPayment?: ModelTypes["CsobPayment"] | undefined,
	stripePayment?: ModelTypes["StripePayment"] | undefined,
	recurringPaymentItem?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	method: ModelTypes["UserPaymentMethod"],
	region?: ModelTypes["Region"] | undefined,
	user?: ModelTypes["User"] | undefined,
	isReusable: boolean,
	onBehalfDonation?: ModelTypes["OnBehalfDonation"] | undefined,
	triesCollection?: ModelTypes["UserPaymentTriesCollection"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful: boolean,
	isFinished: boolean,
	metadata?: ModelTypes["UserPaymentMetadata"] | undefined
};
	["UserPaymentMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	cents?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	specificSymbol?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	csobPayment?: ModelTypes["FieldMeta"] | undefined,
	stripePayment?: ModelTypes["FieldMeta"] | undefined,
	recurringPaymentItem?: ModelTypes["FieldMeta"] | undefined,
	method?: ModelTypes["FieldMeta"] | undefined,
	region?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined,
	isReusable?: ModelTypes["FieldMeta"] | undefined,
	onBehalfDonation?: ModelTypes["FieldMeta"] | undefined,
	triesCollection?: ModelTypes["FieldMeta"] | undefined,
	successEmailSentAt?: ModelTypes["FieldMeta"] | undefined,
	isSuccessful?: ModelTypes["FieldMeta"] | undefined,
	isFinished?: ModelTypes["FieldMeta"] | undefined,
	metadata?: ModelTypes["FieldMeta"] | undefined
};
	["UserPaymentOrderId"]: {
		_meta?: ModelTypes["UserPaymentOrderIdMeta"] | undefined,
	id: ModelTypes["UUID"],
	seq: number
};
	["UserPaymentOrderIdMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	seq?: ModelTypes["FieldMeta"] | undefined
};
	["CsobPayment"]: {
		_meta?: ModelTypes["CsobPaymentMeta"] | undefined,
	id: ModelTypes["UUID"],
	payId?: string | undefined,
	statusChanges: Array<ModelTypes["CsobPaymentStatusChange"]>,
	payment?: ModelTypes["UserPayment"] | undefined,
	originalPayId?: string | undefined,
	metadata?: ModelTypes["CsobPaymentMetadata"] | undefined,
	paginateStatusChanges: ModelTypes["CsobPaymentStatusChangeConnection"]
};
	["CsobPaymentMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	payId?: ModelTypes["FieldMeta"] | undefined,
	statusChanges?: ModelTypes["FieldMeta"] | undefined,
	payment?: ModelTypes["FieldMeta"] | undefined,
	originalPayId?: ModelTypes["FieldMeta"] | undefined,
	metadata?: ModelTypes["FieldMeta"] | undefined
};
	["CsobPaymentStatusChange"]: {
		_meta?: ModelTypes["CsobPaymentStatusChangeMeta"] | undefined,
	id: ModelTypes["UUID"],
	createdAt: ModelTypes["DateTime"],
	dttm?: string | undefined,
	status: number,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	payment?: ModelTypes["CsobPayment"] | undefined
};
	["CsobPaymentStatusChangeMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	dttm?: ModelTypes["FieldMeta"] | undefined,
	status?: ModelTypes["FieldMeta"] | undefined,
	resultCode?: ModelTypes["FieldMeta"] | undefined,
	message?: ModelTypes["FieldMeta"] | undefined,
	authCode?: ModelTypes["FieldMeta"] | undefined,
	statusDetail?: ModelTypes["FieldMeta"] | undefined,
	actions?: ModelTypes["FieldMeta"] | undefined,
	payment?: ModelTypes["FieldMeta"] | undefined
};
	["CsobPaymentStatusChangeOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	dttm?: ModelTypes["OrderDirection"] | undefined,
	status?: ModelTypes["OrderDirection"] | undefined,
	resultCode?: ModelTypes["OrderDirection"] | undefined,
	message?: ModelTypes["OrderDirection"] | undefined,
	authCode?: ModelTypes["OrderDirection"] | undefined,
	statusDetail?: ModelTypes["OrderDirection"] | undefined,
	actions?: ModelTypes["OrderDirection"] | undefined,
	payment?: ModelTypes["CsobPaymentOrderBy"] | undefined
};
	["CsobPaymentOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	payId?: ModelTypes["OrderDirection"] | undefined,
	payment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	originalPayId?: ModelTypes["OrderDirection"] | undefined,
	metadata?: ModelTypes["CsobPaymentMetadataOrderBy"] | undefined
};
	["UserPaymentOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	cents?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	specificSymbol?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	order?: ModelTypes["UserPaymentOrderIdOrderBy"] | undefined,
	csobPayment?: ModelTypes["CsobPaymentOrderBy"] | undefined,
	stripePayment?: ModelTypes["StripePaymentOrderBy"] | undefined,
	recurringPaymentItem?: ModelTypes["UserRecurringPaymentItemOrderBy"] | undefined,
	method?: ModelTypes["OrderDirection"] | undefined,
	region?: ModelTypes["RegionOrderBy"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined,
	isReusable?: ModelTypes["OrderDirection"] | undefined,
	onBehalfDonation?: ModelTypes["OnBehalfDonationOrderBy"] | undefined,
	triesCollection?: ModelTypes["UserPaymentTriesCollectionOrderBy"] | undefined,
	successEmailSentAt?: ModelTypes["OrderDirection"] | undefined,
	isSuccessful?: ModelTypes["OrderDirection"] | undefined,
	isFinished?: ModelTypes["OrderDirection"] | undefined,
	metadata?: ModelTypes["UserPaymentMetadataOrderBy"] | undefined
};
	["UserPaymentOrderIdOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	seq?: ModelTypes["OrderDirection"] | undefined
};
	["StripePaymentOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	identifier?: ModelTypes["OrderDirection"] | undefined,
	payment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	metadata?: ModelTypes["StripePaymentMetadataOrderBy"] | undefined
};
	["StripePaymentMetadataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	status?: ModelTypes["OrderDirection"] | undefined,
	isSuccessful?: ModelTypes["OrderDirection"] | undefined,
	isFinished?: ModelTypes["OrderDirection"] | undefined,
	stripePayment?: ModelTypes["StripePaymentOrderBy"] | undefined
};
	["UserRecurringPaymentItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	recurrenceCounter?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	taskId?: ModelTypes["OrderDirection"] | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentOrderBy"] | undefined,
	isFailed?: ModelTypes["OrderDirection"] | undefined,
	failedEmailSentAt?: ModelTypes["OrderDirection"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemMetadataOrderBy"] | undefined
};
	["UserRecurringPaymentOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	activeSince?: ModelTypes["OrderDirection"] | undefined,
	cancelledAt?: ModelTypes["OrderDirection"] | undefined,
	cents?: ModelTypes["OrderDirection"] | undefined,
	interval?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined,
	meta?: ModelTypes["UpcomingUserRecurringPaymentMetadataOrderBy"] | undefined
};
	["UserOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	tenantPersonId?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	email?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	variableSymbol?: ModelTypes["OrderDirection"] | undefined,
	lastActiveAt?: ModelTypes["OrderDirection"] | undefined,
	region?: ModelTypes["RegionOrderBy"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	stripeId?: ModelTypes["OrderDirection"] | undefined,
	isDeactivated?: ModelTypes["OrderDirection"] | undefined,
	publicProfileSecret?: ModelTypes["OrderDirection"] | undefined,
	publicProfileCustomNote?: ModelTypes["OrderDirection"] | undefined,
	publicProfileCustomNoteEnabled?: ModelTypes["OrderDirection"] | undefined,
	donationConfirmationEmailEnabled?: ModelTypes["OrderDirection"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	signedUp?: ModelTypes["OrderDirection"] | undefined,
	stats?: ModelTypes["UserStatsOrderBy"] | undefined
};
	["UserStatsOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	totalPaymentsSuccessful?: ModelTypes["OrderDirection"] | undefined,
	totalPaymentsUnsuccessful?: ModelTypes["OrderDirection"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined
};
	["UpcomingUserRecurringPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	recurrenceCounter?: ModelTypes["OrderDirection"] | undefined,
	isBehindPayments?: ModelTypes["OrderDirection"] | undefined,
	nextPaymentDate?: ModelTypes["OrderDirection"] | undefined,
	shouldBeProcessed?: ModelTypes["OrderDirection"] | undefined,
	firstPayment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	firstSuccessfulPayment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	drivingPayment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentOrderBy"] | undefined
};
	["UserRecurringPaymentItemMetadataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	isSuccessfullyPaid?: ModelTypes["OrderDirection"] | undefined,
	shouldBeProcessed?: ModelTypes["OrderDirection"] | undefined,
	firstPayment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	lastPayment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	firstSuccessfulPayment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	drivingPayment?: ModelTypes["UserPaymentOrderBy"] | undefined,
	recurringPaymentItem?: ModelTypes["UserRecurringPaymentItemOrderBy"] | undefined
};
	["OnBehalfDonationOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	secretCode?: ModelTypes["OrderDirection"] | undefined,
	specificSymbol?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	onBehalfOf?: ModelTypes["UserOrderBy"] | undefined,
	meta?: ModelTypes["OnBehalfDonationMetadataOrderBy"] | undefined
};
	["OnBehalfDonationMetadataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined,
	onBehalfOfDonation?: ModelTypes["OnBehalfDonationOrderBy"] | undefined
};
	["UserPaymentTriesCollectionOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	cents?: ModelTypes["OrderDirection"] | undefined,
	specificSymbol?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	orderUrl?: ModelTypes["OrderDirection"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	onBehalfDonation?: ModelTypes["OnBehalfDonationOrderBy"] | undefined,
	recurring?: ModelTypes["UserRecurringPaymentOrderBy"] | undefined,
	metadata?: ModelTypes["UserPaymentTriesCollectionMetadataOrderBy"] | undefined,
	medium?: ModelTypes["OrderDirection"] | undefined
};
	["UserPaymentTriesCollectionMetadataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined,
	triesCollection?: ModelTypes["UserPaymentTriesCollectionOrderBy"] | undefined
};
	["UserPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined,
	organizationUnfiltered?: ModelTypes["PostOrganizationOrderBy"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined,
	countToUser?: ModelTypes["UserOrderBy"] | undefined,
	paymentType?: ModelTypes["OrderDirection"] | undefined,
	statusLabel?: ModelTypes["OrderDirection"] | undefined,
	isSuccessful?: ModelTypes["OrderDirection"] | undefined,
	isFinished?: ModelTypes["OrderDirection"] | undefined,
	needsCacheUpdate?: ModelTypes["OrderDirection"] | undefined,
	isSuccessfulNotCached?: ModelTypes["OrderDirection"] | undefined,
	isFinishedNotCached?: ModelTypes["OrderDirection"] | undefined,
	userPayment?: ModelTypes["UserPaymentOrderBy"] | undefined
};
	["CsobPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	status?: ModelTypes["OrderDirection"] | undefined,
	isSuccessful?: ModelTypes["OrderDirection"] | undefined,
	isFinished?: ModelTypes["OrderDirection"] | undefined,
	resolvedOriginalPayId?: ModelTypes["OrderDirection"] | undefined,
	csobPayment?: ModelTypes["CsobPaymentOrderBy"] | undefined
};
	["CsobPaymentMetadata"]: {
		_meta?: ModelTypes["CsobPaymentMetadataMeta"] | undefined,
	id: ModelTypes["UUID"],
	status: number,
	isSuccessful: boolean,
	isFinished: boolean,
	resolvedOriginalPayId?: string | undefined,
	csobPayment?: ModelTypes["CsobPayment"] | undefined
};
	["CsobPaymentMetadataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	status?: ModelTypes["FieldMeta"] | undefined,
	isSuccessful?: ModelTypes["FieldMeta"] | undefined,
	isFinished?: ModelTypes["FieldMeta"] | undefined,
	resolvedOriginalPayId?: ModelTypes["FieldMeta"] | undefined,
	csobPayment?: ModelTypes["FieldMeta"] | undefined
};
	["CsobPaymentStatusChangeConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CsobPaymentStatusChangeEdge"]>
};
	["CsobPaymentStatusChangeEdge"]: {
		node: ModelTypes["CsobPaymentStatusChange"]
};
	["StripePayment"]: {
		_meta?: ModelTypes["StripePaymentMeta"] | undefined,
	id: ModelTypes["UUID"],
	identifier?: string | undefined,
	statusChanges: Array<ModelTypes["StripePaymentStatusChange"]>,
	payment?: ModelTypes["UserPayment"] | undefined,
	metadata?: ModelTypes["StripePaymentMetadata"] | undefined,
	paginateStatusChanges: ModelTypes["StripePaymentStatusChangeConnection"]
};
	["StripePaymentMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	identifier?: ModelTypes["FieldMeta"] | undefined,
	statusChanges?: ModelTypes["FieldMeta"] | undefined,
	payment?: ModelTypes["FieldMeta"] | undefined,
	metadata?: ModelTypes["FieldMeta"] | undefined
};
	["StripePaymentStatusChange"]: {
		_meta?: ModelTypes["StripePaymentStatusChangeMeta"] | undefined,
	id: ModelTypes["UUID"],
	createdAt: ModelTypes["DateTime"],
	payment?: ModelTypes["StripePayment"] | undefined,
	timestamp: number,
	eventId: string,
	paymentIntentStatus?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined
};
	["StripePaymentStatusChangeMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	payment?: ModelTypes["FieldMeta"] | undefined,
	timestamp?: ModelTypes["FieldMeta"] | undefined,
	eventId?: ModelTypes["FieldMeta"] | undefined,
	paymentIntentStatus?: ModelTypes["FieldMeta"] | undefined
};
	["StripePaymentStatusChangeOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	payment?: ModelTypes["StripePaymentOrderBy"] | undefined,
	timestamp?: ModelTypes["OrderDirection"] | undefined,
	eventId?: ModelTypes["OrderDirection"] | undefined,
	paymentIntentStatus?: ModelTypes["OrderDirection"] | undefined
};
	["StripePaymentMetadata"]: {
		_meta?: ModelTypes["StripePaymentMetadataMeta"] | undefined,
	id: ModelTypes["UUID"],
	status: number,
	isSuccessful: boolean,
	isFinished: boolean,
	stripePayment?: ModelTypes["StripePayment"] | undefined
};
	["StripePaymentMetadataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	status?: ModelTypes["FieldMeta"] | undefined,
	isSuccessful?: ModelTypes["FieldMeta"] | undefined,
	isFinished?: ModelTypes["FieldMeta"] | undefined,
	stripePayment?: ModelTypes["FieldMeta"] | undefined
};
	["StripePaymentStatusChangeConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["StripePaymentStatusChangeEdge"]>
};
	["StripePaymentStatusChangeEdge"]: {
		node: ModelTypes["StripePaymentStatusChange"]
};
	["UserRecurringPaymentItem"]: {
		_meta?: ModelTypes["UserRecurringPaymentItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	recurrenceCounter: number,
	createdAt: ModelTypes["DateTime"],
	taskId?: string | undefined,
	payments: Array<ModelTypes["UserPayment"]>,
	recurringPayment?: ModelTypes["UserRecurringPayment"] | undefined,
	isFailed: boolean,
	failedEmailSentAt?: ModelTypes["DateTime"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemMetadata"] | undefined,
	paymentsByOrder?: ModelTypes["UserPayment"] | undefined,
	paymentsByCsobPayment?: ModelTypes["UserPayment"] | undefined,
	paymentsByStripePayment?: ModelTypes["UserPayment"] | undefined,
	paymentsByMetadata?: ModelTypes["UserPayment"] | undefined,
	paginatePayments: ModelTypes["UserPaymentConnection"]
};
	["UserRecurringPaymentItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	recurrenceCounter?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	taskId?: ModelTypes["FieldMeta"] | undefined,
	payments?: ModelTypes["FieldMeta"] | undefined,
	recurringPayment?: ModelTypes["FieldMeta"] | undefined,
	isFailed?: ModelTypes["FieldMeta"] | undefined,
	failedEmailSentAt?: ModelTypes["FieldMeta"] | undefined,
	meta?: ModelTypes["FieldMeta"] | undefined
};
	["UserRecurringPayment"]: {
		_meta?: ModelTypes["UserRecurringPaymentMeta"] | undefined,
	id: ModelTypes["UUID"],
	activeSince: ModelTypes["DateTime"],
	cancelledAt?: ModelTypes["DateTime"] | undefined,
	cents: number,
	interval: ModelTypes["UserRecurringPaymentInterval"],
	currency?: ModelTypes["Currency"] | undefined,
	items: Array<ModelTypes["UserRecurringPaymentItem"]>,
	user?: ModelTypes["User"] | undefined,
	meta?: ModelTypes["UpcomingUserRecurringPaymentMetadata"] | undefined,
	itemsByRecurrenceCounter?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	itemsByPayments?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	itemsByMeta?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	paginateItems: ModelTypes["UserRecurringPaymentItemConnection"]
};
	["UserRecurringPaymentMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	activeSince?: ModelTypes["FieldMeta"] | undefined,
	cancelledAt?: ModelTypes["FieldMeta"] | undefined,
	cents?: ModelTypes["FieldMeta"] | undefined,
	interval?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined,
	meta?: ModelTypes["FieldMeta"] | undefined
};
	["UpcomingUserRecurringPaymentMetadata"]: {
		_meta?: ModelTypes["UpcomingUserRecurringPaymentMetadataMeta"] | undefined,
	id: ModelTypes["UUID"],
	recurrenceCounter: number,
	isBehindPayments: boolean,
	nextPaymentDate: ModelTypes["DateTime"],
	shouldBeProcessed: boolean,
	firstPayment?: ModelTypes["UserPayment"] | undefined,
	firstSuccessfulPayment?: ModelTypes["UserPayment"] | undefined,
	drivingPayment?: ModelTypes["UserPayment"] | undefined,
	recurringPayment?: ModelTypes["UserRecurringPayment"] | undefined
};
	["UpcomingUserRecurringPaymentMetadataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	recurrenceCounter?: ModelTypes["FieldMeta"] | undefined,
	isBehindPayments?: ModelTypes["FieldMeta"] | undefined,
	nextPaymentDate?: ModelTypes["FieldMeta"] | undefined,
	shouldBeProcessed?: ModelTypes["FieldMeta"] | undefined,
	firstPayment?: ModelTypes["FieldMeta"] | undefined,
	firstSuccessfulPayment?: ModelTypes["FieldMeta"] | undefined,
	drivingPayment?: ModelTypes["FieldMeta"] | undefined,
	recurringPayment?: ModelTypes["FieldMeta"] | undefined
};
	["UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere"]: {
	recurrenceCounter?: number | undefined
};
	["UserRecurringPaymentItemsByPaymentsUniqueWhere"]: {
	payments?: ModelTypes["UserPaymentUniqueWhere"] | undefined
};
	["UserPaymentUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: ModelTypes["UserPaymentOrderIdUniqueWhere"] | undefined,
	csobPayment?: ModelTypes["CsobPaymentUniqueWhere"] | undefined,
	stripePayment?: ModelTypes["StripePaymentUniqueWhere"] | undefined,
	metadata?: ModelTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentOrderIdUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	seq?: number | undefined
};
	["CsobPaymentUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	payId?: string | undefined,
	statusChanges?: ModelTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	payment?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	metadata?: ModelTypes["CsobPaymentMetadataUniqueWhere"] | undefined
};
	["CsobPaymentStatusChangeUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["CsobPaymentMetadataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	csobPayment?: ModelTypes["CsobPaymentUniqueWhere"] | undefined
};
	["StripePaymentUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	statusChanges?: ModelTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	payment?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	metadata?: ModelTypes["StripePaymentMetadataUniqueWhere"] | undefined
};
	["StripePaymentStatusChangeUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["StripePaymentMetadataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	stripePayment?: ModelTypes["StripePaymentUniqueWhere"] | undefined
};
	["UserPaymentMetadataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	userPayment?: ModelTypes["UserPaymentUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemsByMetaUniqueWhere"]: {
	meta?: ModelTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemMetadataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	firstPayment?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	lastPayment?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	recurringPaymentItem?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	recurrenceCounter?: number | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	payments?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	meta?: ModelTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined
};
	["UpcomingUserRecurringPaymentMetadataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	firstPayment?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserRecurringPaymentItemEdge"]>
};
	["UserRecurringPaymentItemEdge"]: {
		node: ModelTypes["UserRecurringPaymentItem"]
};
	["UserRecurringPaymentItemMetadata"]: {
		_meta?: ModelTypes["UserRecurringPaymentItemMetadataMeta"] | undefined,
	id: ModelTypes["UUID"],
	isSuccessfullyPaid: boolean,
	shouldBeProcessed: boolean,
	firstPayment?: ModelTypes["UserPayment"] | undefined,
	lastPayment?: ModelTypes["UserPayment"] | undefined,
	firstSuccessfulPayment?: ModelTypes["UserPayment"] | undefined,
	drivingPayment?: ModelTypes["UserPayment"] | undefined,
	recurringPaymentItem?: ModelTypes["UserRecurringPaymentItem"] | undefined
};
	["UserRecurringPaymentItemMetadataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	isSuccessfullyPaid?: ModelTypes["FieldMeta"] | undefined,
	shouldBeProcessed?: ModelTypes["FieldMeta"] | undefined,
	firstPayment?: ModelTypes["FieldMeta"] | undefined,
	lastPayment?: ModelTypes["FieldMeta"] | undefined,
	firstSuccessfulPayment?: ModelTypes["FieldMeta"] | undefined,
	drivingPayment?: ModelTypes["FieldMeta"] | undefined,
	recurringPaymentItem?: ModelTypes["FieldMeta"] | undefined
};
	["UserRecurringPaymentItemPaymentsByOrderUniqueWhere"]: {
	order?: ModelTypes["UserPaymentOrderIdUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ModelTypes["CsobPaymentUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ModelTypes["StripePaymentUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemPaymentsByMetadataUniqueWhere"]: {
	metadata?: ModelTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserPaymentEdge"]>
};
	["UserPaymentEdge"]: {
		node: ModelTypes["UserPayment"]
};
	["OnBehalfDonation"]: {
		_meta?: ModelTypes["OnBehalfDonationMeta"] | undefined,
	id: ModelTypes["UUID"],
	secretCode: string,
	specificSymbol: string,
	createdAt?: ModelTypes["DateTime"] | undefined,
	payments: Array<ModelTypes["UserPayment"]>,
	onBehalfOf?: ModelTypes["User"] | undefined,
	meta?: ModelTypes["OnBehalfDonationMetadata"] | undefined,
	paymentsByOrder?: ModelTypes["UserPayment"] | undefined,
	paymentsByCsobPayment?: ModelTypes["UserPayment"] | undefined,
	paymentsByStripePayment?: ModelTypes["UserPayment"] | undefined,
	paymentsByMetadata?: ModelTypes["UserPayment"] | undefined,
	paginatePayments: ModelTypes["UserPaymentConnection"]
};
	["OnBehalfDonationMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	secretCode?: ModelTypes["FieldMeta"] | undefined,
	specificSymbol?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	payments?: ModelTypes["FieldMeta"] | undefined,
	onBehalfOf?: ModelTypes["FieldMeta"] | undefined,
	meta?: ModelTypes["FieldMeta"] | undefined
};
	["OnBehalfDonationMetadata"]: {
		_meta?: ModelTypes["OnBehalfDonationMetadataMeta"] | undefined,
	id: ModelTypes["UUID"],
	area?: ModelTypes["PostArea"] | undefined,
	organization?: ModelTypes["PostOrganization"] | undefined,
	post?: ModelTypes["Post"] | undefined,
	onBehalfOfDonation?: ModelTypes["OnBehalfDonation"] | undefined
};
	["OnBehalfDonationMetadataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined,
	onBehalfOfDonation?: ModelTypes["FieldMeta"] | undefined
};
	["OnBehalfDonationPaymentsByOrderUniqueWhere"]: {
	order?: ModelTypes["UserPaymentOrderIdUniqueWhere"] | undefined
};
	["OnBehalfDonationPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ModelTypes["CsobPaymentUniqueWhere"] | undefined
};
	["OnBehalfDonationPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ModelTypes["StripePaymentUniqueWhere"] | undefined
};
	["OnBehalfDonationPaymentsByMetadataUniqueWhere"]: {
	metadata?: ModelTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentTriesCollection"]: {
		_meta?: ModelTypes["UserPaymentTriesCollectionMeta"] | undefined,
	id: ModelTypes["UUID"],
	cents: number,
	specificSymbol: string,
	createdAt: ModelTypes["DateTime"],
	orderUrl?: string | undefined,
	payment: Array<ModelTypes["UserPayment"]>,
	user?: ModelTypes["User"] | undefined,
	currency?: ModelTypes["Currency"] | undefined,
	onBehalfDonation?: ModelTypes["OnBehalfDonation"] | undefined,
	recurring?: ModelTypes["UserRecurringPayment"] | undefined,
	metadata?: ModelTypes["UserPaymentTriesCollectionMetadata"] | undefined,
	metadataLocales: Array<ModelTypes["UserPaymentTriesCollectionMetadataLocale"]>,
	medium?: ModelTypes["PaymentMedium"] | undefined,
	paymentByOrder?: ModelTypes["UserPayment"] | undefined,
	paymentByCsobPayment?: ModelTypes["UserPayment"] | undefined,
	paymentByStripePayment?: ModelTypes["UserPayment"] | undefined,
	paymentByMetadata?: ModelTypes["UserPayment"] | undefined,
	metadataLocalesByLocale?: ModelTypes["UserPaymentTriesCollectionMetadataLocale"] | undefined,
	paginatePayment: ModelTypes["UserPaymentConnection"],
	paginateMetadataLocales: ModelTypes["UserPaymentTriesCollectionMetadataLocaleConnection"]
};
	["UserPaymentTriesCollectionMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	cents?: ModelTypes["FieldMeta"] | undefined,
	specificSymbol?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	orderUrl?: ModelTypes["FieldMeta"] | undefined,
	payment?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	onBehalfDonation?: ModelTypes["FieldMeta"] | undefined,
	recurring?: ModelTypes["FieldMeta"] | undefined,
	metadata?: ModelTypes["FieldMeta"] | undefined,
	metadataLocales?: ModelTypes["FieldMeta"] | undefined,
	medium?: ModelTypes["FieldMeta"] | undefined
};
	["UserPaymentTriesCollectionMetadata"]: {
		_meta?: ModelTypes["UserPaymentTriesCollectionMetadataMeta"] | undefined,
	id: ModelTypes["UUID"],
	area?: ModelTypes["PostArea"] | undefined,
	organization?: ModelTypes["PostOrganization"] | undefined,
	post?: ModelTypes["Post"] | undefined,
	triesCollection?: ModelTypes["UserPaymentTriesCollection"] | undefined
};
	["UserPaymentTriesCollectionMetadataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined,
	triesCollection?: ModelTypes["FieldMeta"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocale"]: {
		_meta?: ModelTypes["UserPaymentTriesCollectionMetadataLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	locale?: ModelTypes["Locale"] | undefined,
	title?: string | undefined,
	parent?: ModelTypes["UserPaymentTriesCollection"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	parent?: ModelTypes["FieldMeta"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	parent?: ModelTypes["UserPaymentTriesCollectionOrderBy"] | undefined
};
	["UserPaymentTriesCollectionPaymentByOrderUniqueWhere"]: {
	order?: ModelTypes["UserPaymentOrderIdUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere"]: {
	csobPayment?: ModelTypes["CsobPaymentUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere"]: {
	stripePayment?: ModelTypes["StripePaymentUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionPaymentByMetadataUniqueWhere"]: {
	metadata?: ModelTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserPaymentTriesCollectionMetadataLocaleEdge"]>
};
	["UserPaymentTriesCollectionMetadataLocaleEdge"]: {
		node: ModelTypes["UserPaymentTriesCollectionMetadataLocale"]
};
	["UserPaymentMetadata"]: {
		_meta?: ModelTypes["UserPaymentMetadataMeta"] | undefined,
	id: ModelTypes["UUID"],
	area?: ModelTypes["PostArea"] | undefined,
	organization?: ModelTypes["PostOrganization"] | undefined,
	organizationUnfiltered?: ModelTypes["PostOrganization"] | undefined,
	post?: ModelTypes["Post"] | undefined,
	countToUser?: ModelTypes["User"] | undefined,
	paymentType: string,
	statusLabel: string,
	isSuccessful: boolean,
	isFinished: boolean,
	needsCacheUpdate: boolean,
	isSuccessfulNotCached: boolean,
	isFinishedNotCached: boolean,
	userPayment?: ModelTypes["UserPayment"] | undefined
};
	["UserPaymentMetadataMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined,
	organizationUnfiltered?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined,
	countToUser?: ModelTypes["FieldMeta"] | undefined,
	paymentType?: ModelTypes["FieldMeta"] | undefined,
	statusLabel?: ModelTypes["FieldMeta"] | undefined,
	isSuccessful?: ModelTypes["FieldMeta"] | undefined,
	isFinished?: ModelTypes["FieldMeta"] | undefined,
	needsCacheUpdate?: ModelTypes["FieldMeta"] | undefined,
	isSuccessfulNotCached?: ModelTypes["FieldMeta"] | undefined,
	isFinishedNotCached?: ModelTypes["FieldMeta"] | undefined,
	userPayment?: ModelTypes["FieldMeta"] | undefined
};
	["Device"]: {
		_meta?: ModelTypes["DeviceMeta"] | undefined,
	id: ModelTypes["UUID"],
	user?: ModelTypes["User"] | undefined,
	fcmToken: string,
	createdAt?: ModelTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined
};
	["DeviceMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined,
	fcmToken?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	ipAddress?: ModelTypes["FieldMeta"] | undefined,
	userAgent?: ModelTypes["FieldMeta"] | undefined,
	lastActiveAt?: ModelTypes["FieldMeta"] | undefined
};
	["DeviceOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined,
	fcmToken?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	ipAddress?: ModelTypes["OrderDirection"] | undefined,
	userAgent?: ModelTypes["OrderDirection"] | undefined,
	lastActiveAt?: ModelTypes["OrderDirection"] | undefined
};
	["ProcessedNotificationSourceOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationOrderBy"] | undefined,
	donationReminderUser?: ModelTypes["UserOrderBy"] | undefined,
	scheduledNotification?: ModelTypes["ScheduledNotificationOrderBy"] | undefined
};
	["ProcessedNotificationOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	topic?: ModelTypes["OrderDirection"] | undefined,
	sentAt?: ModelTypes["OrderDirection"] | undefined,
	errorMessage?: ModelTypes["OrderDirection"] | undefined,
	errorCode?: ModelTypes["OrderDirection"] | undefined,
	isSuccess?: ModelTypes["OrderDirection"] | undefined,
	source?: ModelTypes["ProcessedNotificationSourceOrderBy"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	body?: ModelTypes["OrderDirection"] | undefined
};
	["UserAreaStats"]: {
		_meta?: ModelTypes["UserAreaStatsMeta"] | undefined,
	id: ModelTypes["UUID"],
	area?: ModelTypes["PostArea"] | undefined,
	currency?: ModelTypes["Currency"] | undefined,
	totalCents: number,
	user?: ModelTypes["User"] | undefined
};
	["UserAreaStatsMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	area?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined
};
	["UserAreaStatsOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	area?: ModelTypes["PostAreaOrderBy"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined
};
	["UserOrganizationStats"]: {
		_meta?: ModelTypes["UserOrganizationStatsMeta"] | undefined,
	id: ModelTypes["UUID"],
	organization?: ModelTypes["PostOrganization"] | undefined,
	currency?: ModelTypes["Currency"] | undefined,
	totalCents: number,
	user?: ModelTypes["User"] | undefined
};
	["UserOrganizationStatsMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	organization?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined
};
	["UserOrganizationStatsOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	organization?: ModelTypes["PostOrganizationOrderBy"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined
};
	["UserPostStats"]: {
		_meta?: ModelTypes["UserPostStatsMeta"] | undefined,
	id: ModelTypes["UUID"],
	post?: ModelTypes["Post"] | undefined,
	currency?: ModelTypes["Currency"] | undefined,
	totalCents: number,
	user?: ModelTypes["User"] | undefined
};
	["UserPostStatsMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	totalCents?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined
};
	["UserPostStatsOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	totalCents?: ModelTypes["OrderDirection"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined
};
	["UserCurrencyStats"]: {
		_meta?: ModelTypes["UserCurrencyStatsMeta"] | undefined,
	id: ModelTypes["UUID"],
	currency?: ModelTypes["Currency"] | undefined,
	totalAmountPaymentsOnce: number,
	totalAmountPaymentsRegular: number,
	user?: ModelTypes["User"] | undefined
};
	["UserCurrencyStatsMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	currency?: ModelTypes["FieldMeta"] | undefined,
	totalAmountPaymentsOnce?: ModelTypes["FieldMeta"] | undefined,
	totalAmountPaymentsRegular?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined
};
	["UserCurrencyStatsOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	currency?: ModelTypes["CurrencyOrderBy"] | undefined,
	totalAmountPaymentsOnce?: ModelTypes["OrderDirection"] | undefined,
	totalAmountPaymentsRegular?: ModelTypes["OrderDirection"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined
};
	["UserStats"]: {
		_meta?: ModelTypes["UserStatsMeta"] | undefined,
	id: ModelTypes["UUID"],
	totalPaymentsSuccessful: number,
	totalPaymentsUnsuccessful: number,
	user?: ModelTypes["User"] | undefined
};
	["UserStatsMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	totalPaymentsSuccessful?: ModelTypes["FieldMeta"] | undefined,
	totalPaymentsUnsuccessful?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined
};
	["UserPaymentsByOrderUniqueWhere"]: {
	order?: ModelTypes["UserPaymentOrderIdUniqueWhere"] | undefined
};
	["UserPaymentsByCsobPaymentUniqueWhere"]: {
	csobPayment?: ModelTypes["CsobPaymentUniqueWhere"] | undefined
};
	["UserPaymentsByStripePaymentUniqueWhere"]: {
	stripePayment?: ModelTypes["StripePaymentUniqueWhere"] | undefined
};
	["UserPaymentsByMetadataUniqueWhere"]: {
	metadata?: ModelTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentsByItemsUniqueWhere"]: {
	items?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined
};
	["UserRecurringPaymentsByMetaUniqueWhere"]: {
	meta?: ModelTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined
};
	["UserOnBehalfDonationsBySecretCodeUniqueWhere"]: {
	secretCode?: string | undefined
};
	["UserOnBehalfDonationsByPaymentsUniqueWhere"]: {
	payments?: ModelTypes["UserPaymentUniqueWhere"] | undefined
};
	["UserOnBehalfDonationsByMetaUniqueWhere"]: {
	meta?: ModelTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined
};
	["OnBehalfDonationMetadataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	onBehalfOfDonation?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined
};
	["OnBehalfDonationUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	secretCode?: string | undefined,
	payments?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	meta?: ModelTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined
};
	["UserDevicesByFcmTokenUniqueWhere"]: {
	fcmToken?: string | undefined
};
	["UserProcessedNotificationsByProcessedNotificationUniqueWhere"]: {
	processedNotification?: ModelTypes["ProcessedNotificationUniqueWhere"] | undefined
};
	["UserRecurringPaymentConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserRecurringPaymentEdge"]>
};
	["UserRecurringPaymentEdge"]: {
		node: ModelTypes["UserRecurringPayment"]
};
	["OnBehalfDonationConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["OnBehalfDonationEdge"]>
};
	["OnBehalfDonationEdge"]: {
		node: ModelTypes["OnBehalfDonation"]
};
	["DeviceConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["DeviceEdge"]>
};
	["DeviceEdge"]: {
		node: ModelTypes["Device"]
};
	["ProcessedNotificationSourceConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ProcessedNotificationSourceEdge"]>
};
	["ProcessedNotificationSourceEdge"]: {
		node: ModelTypes["ProcessedNotificationSource"]
};
	["UserAreaStatsConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserAreaStatsEdge"]>
};
	["UserAreaStatsEdge"]: {
		node: ModelTypes["UserAreaStats"]
};
	["UserOrganizationStatsConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserOrganizationStatsEdge"]>
};
	["UserOrganizationStatsEdge"]: {
		node: ModelTypes["UserOrganizationStats"]
};
	["UserPostStatsConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserPostStatsEdge"]>
};
	["UserPostStatsEdge"]: {
		node: ModelTypes["UserPostStats"]
};
	["UserCurrencyStatsConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserCurrencyStatsEdge"]>
};
	["UserCurrencyStatsEdge"]: {
		node: ModelTypes["UserCurrencyStats"]
};
	["ScheduledNotificationLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere"]: {
	processedNotification?: ModelTypes["ProcessedNotificationUniqueWhere"] | undefined
};
	["ScheduledNotificationLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ScheduledNotificationLocaleEdge"]>
};
	["ScheduledNotificationLocaleEdge"]: {
		node: ModelTypes["ScheduledNotificationLocale"]
};
	["LocaleGeneralsByRootUniqueWhere"]: {
	root?: ModelTypes["GeneralUniqueWhere"] | undefined
};
	["LocaleGeneralsBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGeneralsByAppStoreLinkUniqueWhere"]: {
	appStoreLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleGeneralsByGooglePlayLinkUniqueWhere"]: {
	googlePlayLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleGenericPagesByRootUniqueWhere"]: {
	root?: ModelTypes["GenericPageUniqueWhere"] | undefined
};
	["LocaleGenericPagesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleGenericPagesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGenericPagesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePostsByRootUniqueWhere"]: {
	root?: ModelTypes["PostUniqueWhere"] | undefined
};
	["LocalePostsByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocalePostsBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocalePostsByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePostAreasByRootUniqueWhere"]: {
	root?: ModelTypes["PostAreaUniqueWhere"] | undefined
};
	["LocalePostAreasByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePostAreasBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocalePostAreasByBannerUniqueWhere"]: {
	banner?: ModelTypes["AppBannerUniqueWhere"] | undefined
};
	["LocalePostAreasByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocalePostOrganizationsByRootUniqueWhere"]: {
	root?: ModelTypes["PostOrganizationUniqueWhere"] | undefined
};
	["LocalePostOrganizationsByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePostOrganizationsByDomainUniqueWhere"]: {
	domain?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocalePostOrganizationsBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocalePostOrganizationsByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleHeadersByRootUniqueWhere"]: {
	root?: ModelTypes["HeaderUniqueWhere"] | undefined
};
	["LocaleHeadersByLinksUniqueWhere"]: {
	links?: ModelTypes["LinkListUniqueWhere"] | undefined
};
	["LocaleFootersByRootUniqueWhere"]: {
	root?: ModelTypes["FooterUniqueWhere"] | undefined
};
	["LocaleFootersByLinkListUniqueWhere"]: {
	linkList?: ModelTypes["LinkListUniqueWhere"] | undefined
};
	["LocaleFootersByAddressInfoUniqueWhere"]: {
	addressInfo?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleFootersByImageLinkListUniqueWhere"]: {
	imageLinkList?: ModelTypes["ImageLinkListUniqueWhere"] | undefined
};
	["LocaleGenericPageAboutSettingsByRootUniqueWhere"]: {
	root?: ModelTypes["GenericPageAboutSettingsUniqueWhere"] | undefined
};
	["LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere"]: {
	linkGroups?: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined
};
	["LocalePostRevisionsByRootUniqueWhere"]: {
	root?: ModelTypes["PostRevisionUniqueWhere"] | undefined
};
	["LocalePostRevisionsByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocalePostRevisionsBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocalePostRevisionsByLeadContentUniqueWhere"]: {
	leadContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleFeedPagesByRootUniqueWhere"]: {
	root?: ModelTypes["FeedPageUniqueWhere"] | undefined
};
	["LocaleFeedPagesByHeroTilesUniqueWhere"]: {
	heroTiles?: ModelTypes["TileListUniqueWhere"] | undefined
};
	["LocaleFeedPagesBySectionListUniqueWhere"]: {
	sectionList?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined
};
	["LocaleFeedPagesByCardListUniqueWhere"]: {
	cardList?: ModelTypes["CardListUniqueWhere"] | undefined
};
	["LocaleFeedPagesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ModelTypes["StoryGuideListUniqueWhere"] | undefined
};
	["LocaleRecurringPaymentPagesByRootUniqueWhere"]: {
	root?: ModelTypes["RecurringPaymentPageUniqueWhere"] | undefined
};
	["LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere"]: {
	favouritePosts?: ModelTypes["PostListUniqueWhere"] | undefined
};
	["LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere"]: {
	storyGuideList?: ModelTypes["StoryGuideListUniqueWhere"] | undefined
};
	["LocaleGivenGiftsPagesByRootUniqueWhere"]: {
	root?: ModelTypes["GivenGiftsPageUniqueWhere"] | undefined
};
	["LocaleGivenGiftsPagesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleGivenGiftsPagesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGivenGiftsPagesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleReceivedGiftsPagesByRootUniqueWhere"]: {
	root?: ModelTypes["ReceivedGiftsPageUniqueWhere"] | undefined
};
	["LocaleReceivedGiftsPagesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleReceivedGiftsPagesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleReceivedGiftsPagesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleReportPagesByRootUniqueWhere"]: {
	root?: ModelTypes["ReportPageUniqueWhere"] | undefined
};
	["LocaleReportPagesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleReportPagesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleReportPagesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleReportNavigationsByRootUniqueWhere"]: {
	root?: ModelTypes["ReportNavigationUniqueWhere"] | undefined
};
	["LocaleScheduledNotificationsByRootUniqueWhere"]: {
	root?: ModelTypes["ScheduledNotificationUniqueWhere"] | undefined
};
	["LocaleSentPaymentsByRootUniqueWhere"]: {
	root?: ModelTypes["SentPaymentUniqueWhere"] | undefined
};
	["GeneralLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GeneralLocaleEdge"]>
};
	["GeneralLocaleEdge"]: {
		node: ModelTypes["GeneralLocale"]
};
	["GeneralLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["GeneralLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["GeneralLocalesByAppStoreLinkUniqueWhere"]: {
	appStoreLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["GeneralLocalesByGooglePlayLinkUniqueWhere"]: {
	googlePlayLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["GeneralConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GeneralEdge"]>
};
	["GeneralEdge"]: {
		node: ModelTypes["General"]
};
	["_ValidationResult"]: {
		valid: boolean,
	errors: Array<ModelTypes["_ValidationError"]>
};
	["_ValidationError"]: {
		path: Array<ModelTypes["_PathFragment"]>,
	message: ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field: string
};
	["_IndexPathFragment"]: {
		index: number,
	alias?: string | undefined
};
	["_ValidationMessage"]: {
		text: string
};
	["GeneralCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["GeneralCreateLocalesEntityRelationInput"]> | undefined,
	allAreasIcon?: ModelTypes["GeneralCreateAllAreasIconEntityRelationInput"] | undefined,
	allOrganizationsIcon?: ModelTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["GeneralCreateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GeneralLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GeneralLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	appStoreLink?: ModelTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: ModelTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGeneralsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGeneralsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateGenericPagesEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateGenericPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GenericPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	reportNavigation?: Array<ModelTypes["GenericPageCreateReportNavigationEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageCreateReportNavigationEntityRelationInput"]: {
	connect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageConnectOrCreateReportNavigationRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationLocaleWithoutPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["ReportNavigationUniqueWhere"] | undefined,
	create?: ModelTypes["ReportNavigationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ReportNavigationWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["ReportNavigationUniqueWhere"],
	create: ModelTypes["ReportNavigationWithoutLocalesCreateInput"]
};
	["ReportNavigationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutReportNavigationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutReportNavigationsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateGeneralsEntityRelationInput"]: {
	connect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateGeneralsRelationInput"] | undefined,
	alias?: string | undefined
};
	["GeneralLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	appStoreLink?: ModelTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: ModelTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["GeneralUniqueWhere"] | undefined,
	create?: ModelTypes["GeneralWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GeneralWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	allAreasIcon?: ModelTypes["GeneralCreateAllAreasIconEntityRelationInput"] | undefined,
	allOrganizationsIcon?: ModelTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["GeneralCreateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralCreateAllAreasIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralConnectOrCreateAllAreasIconRelationInput"] | undefined
};
	["ImageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralConnectOrCreateAllAreasIconRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["GeneralCreateAllOrganizationsIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"] | undefined
};
	["GeneralConnectOrCreateAllOrganizationsIconRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["GeneralCreateOrganizationListEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralConnectOrCreateOrganizationListRelationInput"] | undefined
};
	["PostOrganizationListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["PostOrganizationListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListItemUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationListItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	item?: ModelTypes["PostOrganizationListItemCreateItemEntityRelationInput"] | undefined,
	type?: ModelTypes["PostOrganizationListItemType"] | undefined,
	link?: ModelTypes["PostOrganizationListItemCreateLinkEntityRelationInput"] | undefined,
	image?: ModelTypes["PostOrganizationListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemCreateItemEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"] | undefined
};
	["PostOrganizationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	posts?: Array<ModelTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined,
	icon?: ModelTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: ModelTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: ModelTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: ModelTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<ModelTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: ModelTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationCreatePostsEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutOrganizationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutOrganizationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	area?: ModelTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateAreaRelationInput"] | undefined
};
	["PostAreaWithoutPostsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: ModelTypes["PostAreaCreateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	specificSymbol?: number | undefined,
	region?: ModelTypes["PostAreaCreateRegionEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostAreaCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: ModelTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<ModelTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: ModelTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaCreateIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateIconRelationInput"] | undefined
};
	["PostAreaConnectOrCreateIconRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostAreaCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostAreaLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined,
	banner?: ModelTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutPostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutPostAreaCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined
};
	["GenericPageLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGenericPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGenericPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreatePostsEntityRelationInput"]: {
	connect?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	content?: ModelTypes["PostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostLocaleCreateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["ContentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	blocks?: Array<ModelTypes["ContentCreateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	create?: ModelTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentConnectOrCreateBlocksRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	references?: Array<ModelTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	create?: ModelTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	image?: ModelTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	video?: ModelTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	contentAlignment?: ModelTypes["ContentAlignment"] | undefined,
	valueList?: ModelTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined,
	areaList?: ModelTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: ModelTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	memberList?: ModelTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: ModelTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: ModelTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: ModelTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: ModelTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	posts?: Array<ModelTypes["ContentReferenceCreatePostsEntityRelationInput"]> | undefined,
	textImageList?: ModelTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["ContentReferenceCreateLinkablesEntityRelationInput"]: {
	connect?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined
};
	["VideoUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["VideoCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	poster?: ModelTypes["VideoCreatePosterEntityRelationInput"] | undefined,
	shapeType?: ModelTypes["VideoShapeType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["VideoConnectOrCreatePosterRelationInput"] | undefined
};
	["VideoConnectOrCreatePosterRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
	connect: ModelTypes["VideoUniqueWhere"],
	create: ModelTypes["VideoCreateInput"]
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["LinkEnum"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: ModelTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined,
	isTargetBlank?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined
};
	["LinkableCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreatePostRelationInput"] | undefined
};
	["PostLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	content?: ModelTypes["PostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined,
	root?: ModelTypes["PostLocaleCreateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["SeoCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: ModelTypes["SeoCreateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["PostLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutPostsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreatePostAreasEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreatePostAreasRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostAreaLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined,
	banner?: ModelTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["PostAreaWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: ModelTypes["PostAreaCreateIconEntityRelationInput"] | undefined,
	regionListOverride?: ModelTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<ModelTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: ModelTypes["PostAreaCreateRegionEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostAreaCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: ModelTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<ModelTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: ModelTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaCreateRegionListOverrideEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"] | undefined
};
	["DonationAmountsRegionListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	regions?: Array<ModelTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"]> | undefined,
	donation?: ModelTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListCreateRegionsEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["DonationAmountsRegionItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	items?: Array<ModelTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined,
	region?: ModelTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountItemUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountItemWithoutRegionItemCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["DonationAmountItemWithoutRegionItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	amount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["DonationAmountItemUniqueWhere"],
	create: ModelTypes["DonationAmountItemWithoutRegionItemCreateInput"]
};
	["DonationAmountsRegionItemCreateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionWithoutDonationItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"] | undefined
};
	["RegionWithoutDonationItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: ModelTypes["RegionCreateCurrencyEntityRelationInput"] | undefined,
	enabledPaymentMethods?: Array<ModelTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionCreateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RegionConnectOrCreateCurrencyRelationInput"] | undefined
};
	["CurrencyUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: ModelTypes["CurrencyIdentifier"] | undefined,
	areaSentPaymentCurrencySums?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	areaCurrencySums?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	organizationCurrencySums?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	postCurrencySums?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined
};
	["CurrencyCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: ModelTypes["CurrencyIdentifier"] | undefined,
	label?: string | undefined,
	sign?: string | undefined,
	signAlignment?: ModelTypes["CurrencySignAlignment"] | undefined,
	defaultDonationAmount?: number | undefined,
	rateAgainstCzk?: number | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaCurrencySums?: Array<ModelTypes["CurrencyCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<ModelTypes["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	postCurrencySums?: Array<ModelTypes["CurrencyCreatePostCurrencySumsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyCreateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyCreatePostCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RegionConnectOrCreateCurrencyRelationInput"]: {
	connect: ModelTypes["CurrencyUniqueWhere"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["RegionCreateEnabledPaymentMethodsEntityRelationInput"]: {
	connect?: ModelTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	create?: ModelTypes["RegionPaymentMethodWithoutRegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"] | undefined,
	alias?: string | undefined
};
	["RegionPaymentMethodWithoutRegionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	allowRecurringPayments?: boolean | undefined,
	method?: ModelTypes["PaymentMethods"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"]: {
	connect: ModelTypes["RegionPaymentMethodUniqueWhere"],
	create: ModelTypes["RegionPaymentMethodWithoutRegionCreateInput"]
};
	["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"]: {
	connect: ModelTypes["RegionUniqueWhere"],
	create: ModelTypes["RegionWithoutDonationItemsCreateInput"]
};
	["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"]: {
	connect: ModelTypes["DonationAmountsRegionItemUniqueWhere"],
	create: ModelTypes["DonationAmountsRegionItemWithoutListCreateInput"]
};
	["DonationAmountsRegionListCreateDonationEntityRelationInput"]: {
	connect?: ModelTypes["DonationUniqueWhere"] | undefined,
	create?: ModelTypes["DonationWithoutRegionListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"] | undefined
};
	["DonationWithoutRegionListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListConnectOrCreateDonationRelationInput"]: {
	connect: ModelTypes["DonationUniqueWhere"],
	create: ModelTypes["DonationWithoutRegionListCreateInput"]
};
	["PostAreaConnectOrCreateRegionListOverrideRelationInput"]: {
	connect: ModelTypes["DonationAmountsRegionListUniqueWhere"],
	create: ModelTypes["DonationAmountsRegionListCreateInput"]
};
	["PostAreaCreatePostsEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutAreaCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateOrganizationEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateOrganizationRelationInput"] | undefined
};
	["PostOrganizationWithoutPostsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: ModelTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: ModelTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: ModelTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: ModelTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<ModelTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: ModelTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationCreateIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateIconRelationInput"] | undefined
};
	["PostOrganizationConnectOrCreateIconRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined,
	domain?: ModelTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: ModelTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutPostOrganizationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutPostOrganizationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreatePostAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreatePostAreaRelationInput"] | undefined
};
	["PostAreaLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	root?: ModelTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined,
	banner?: ModelTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutPostAreasCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutPostAreasCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreatePostOrganizationsEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreatePostOrganizationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined,
	domain?: ModelTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: ModelTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["PostOrganizationWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	posts?: Array<ModelTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined,
	icon?: ModelTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	area?: ModelTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: ModelTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: ModelTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<ModelTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: ModelTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationCreateAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateAreaRelationInput"] | undefined
};
	["PostAreaCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: ModelTypes["PostAreaCreateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<ModelTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: ModelTypes["PostAreaCreateRegionEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostAreaCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: ModelTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<ModelTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: ModelTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaCreateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateRegionRelationInput"] | undefined
};
	["RegionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: ModelTypes["RegionCreateCurrencyEntityRelationInput"] | undefined,
	enabledPaymentMethods?: Array<ModelTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"]> | undefined,
	donationItems?: Array<ModelTypes["RegionCreateDonationItemsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionCreateDonationItemsEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RegionConnectOrCreateDonationItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["DonationAmountsRegionItemWithoutRegionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	items?: Array<ModelTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined,
	list?: ModelTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"] | undefined
};
	["DonationAmountsRegionListWithoutRegionsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	donation?: ModelTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["DonationAmountsRegionListUniqueWhere"],
	create: ModelTypes["DonationAmountsRegionListWithoutRegionsCreateInput"]
};
	["RegionConnectOrCreateDonationItemsRelationInput"]: {
	connect: ModelTypes["DonationAmountsRegionItemUniqueWhere"],
	create: ModelTypes["DonationAmountsRegionItemWithoutRegionCreateInput"]
};
	["PostAreaConnectOrCreateRegionRelationInput"]: {
	connect: ModelTypes["RegionUniqueWhere"],
	create: ModelTypes["RegionCreateInput"]
};
	["PostAreaCreateMetaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaMetaDataUniqueWhere"] | undefined
};
	["PostAreaCreateMobileHeroImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"] | undefined
};
	["PostAreaConnectOrCreateMobileHeroImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostAreaCreatePlainIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreatePlainIconRelationInput"] | undefined
};
	["PostAreaConnectOrCreatePlainIconRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostAreaCreateSentPaymentsEntityRelationInput"]: {
	connect?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["SentPaymentWithoutAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateSentPaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SentPaymentWithoutAreaCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: ModelTypes["DateTime"] | undefined,
	currency?: ModelTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined,
	organization?: ModelTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentConnectOrCreateCurrencyRelationInput"] | undefined
};
	["SentPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ModelTypes["CurrencyUniqueWhere"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["SentPaymentCreateOrganizationEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentConnectOrCreateOrganizationRelationInput"] | undefined
};
	["PostOrganizationWithoutSentPaymentsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	posts?: Array<ModelTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined,
	icon?: ModelTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: ModelTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: ModelTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: ModelTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined,
	organizationCurrencySums?: Array<ModelTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: ModelTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationCreateMetaEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationMetaDataUniqueWhere"] | undefined
};
	["PostOrganizationCreateMobileHeroImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"] | undefined
};
	["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationCreatePlainIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"] | undefined
};
	["PostOrganizationConnectOrCreatePlainIconRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationCreateDesktopHeroImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"] | undefined
};
	["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationCreateOrganizationSumEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationSumUniqueWhere"] | undefined
};
	["SentPaymentConnectOrCreateOrganizationRelationInput"]: {
	connect: ModelTypes["PostOrganizationUniqueWhere"],
	create: ModelTypes["PostOrganizationWithoutSentPaymentsCreateInput"]
};
	["SentPaymentCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["SentPaymentLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["SentPaymentLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organizationText?: string | undefined,
	locale?: ModelTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutSentPaymentsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateHeadersEntityRelationInput"]: {
	connect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateHeadersRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined,
	links?: ModelTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["HeaderUniqueWhere"] | undefined,
	create?: ModelTypes["HeaderWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["HeaderWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	logo?: ModelTypes["HeaderCreateLogoEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["HeaderCreateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined
};
	["HeaderConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["HeaderCreateOrganizationListEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateOrganizationListRelationInput"] | undefined
};
	["HeaderConnectOrCreateOrganizationListRelationInput"]: {
	connect: ModelTypes["PostOrganizationListUniqueWhere"],
	create: ModelTypes["PostOrganizationListCreateInput"]
};
	["HeaderLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["HeaderUniqueWhere"],
	create: ModelTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleCreateLinksEntityRelationInput"]: {
	connect?: ModelTypes["LinkListUniqueWhere"] | undefined,
	create?: ModelTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLinksRelationInput"] | undefined
};
	["LinkListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["LinkListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["LinkItemUniqueWhere"] | undefined,
	create?: ModelTypes["LinkItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["LinkItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	link?: ModelTypes["LinkItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkItemConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkItemConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["LinkListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["LinkItemUniqueWhere"],
	create: ModelTypes["LinkItemWithoutListCreateInput"]
};
	["HeaderLocaleConnectOrCreateLinksRelationInput"]: {
	connect: ModelTypes["LinkListUniqueWhere"],
	create: ModelTypes["LinkListCreateInput"]
};
	["LocaleConnectOrCreateHeadersRelationInput"]: {
	connect: ModelTypes["HeaderLocaleUniqueWhere"],
	create: ModelTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateFootersEntityRelationInput"]: {
	connect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateFootersRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	copyright?: string | undefined,
	root?: ModelTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined,
	linkList?: ModelTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: ModelTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["FooterUniqueWhere"] | undefined,
	create?: ModelTypes["FooterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["FooterWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	logo?: ModelTypes["FooterCreateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterConnectOrCreateLogoRelationInput"] | undefined
};
	["FooterConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["FooterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["FooterUniqueWhere"],
	create: ModelTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleCreateLinkListEntityRelationInput"]: {
	connect?: ModelTypes["LinkListUniqueWhere"] | undefined,
	create?: ModelTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateLinkListRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateLinkListRelationInput"]: {
	connect: ModelTypes["LinkListUniqueWhere"],
	create: ModelTypes["LinkListCreateInput"]
};
	["FooterLocaleCreateAddressInfoEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateAddressInfoRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["FooterLocaleCreateImageLinkListEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"] | undefined
};
	["ImageLinkListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["ImageLinkListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkItemUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ImageLinkItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	item?: ModelTypes["ImageLinkItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemCreateItemEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkItemConnectOrCreateItemRelationInput"] | undefined
};
	["ImageLinkUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["ImageLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	image?: ModelTypes["ImageLinkCreateImageEntityRelationInput"] | undefined,
	link?: ModelTypes["ImageLinkCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkConnectOrCreateImageRelationInput"] | undefined
};
	["ImageLinkConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["ImageLinkCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkConnectOrCreateLinkRelationInput"] | undefined
};
	["ImageLinkConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["ImageLinkItemConnectOrCreateItemRelationInput"]: {
	connect: ModelTypes["ImageLinkUniqueWhere"],
	create: ModelTypes["ImageLinkCreateInput"]
};
	["ImageLinkListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["ImageLinkItemUniqueWhere"],
	create: ModelTypes["ImageLinkItemWithoutListCreateInput"]
};
	["FooterLocaleConnectOrCreateImageLinkListRelationInput"]: {
	connect: ModelTypes["ImageLinkListUniqueWhere"],
	create: ModelTypes["ImageLinkListCreateInput"]
};
	["LocaleConnectOrCreateFootersRelationInput"]: {
	connect: ModelTypes["FooterLocaleUniqueWhere"],
	create: ModelTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined,
	linkGroups?: Array<ModelTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageAboutSettingsUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GenericPageAboutSettingsWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["GenericPageAboutSettingsUniqueWhere"],
	create: ModelTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"]
};
	["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	linkList?: ModelTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"]: {
	connect?: ModelTypes["LinkListUniqueWhere"] | undefined,
	create?: ModelTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"] | undefined
};
	["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"]: {
	connect: ModelTypes["LinkListUniqueWhere"],
	create: ModelTypes["LinkListCreateInput"]
};
	["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"]: {
	connect: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	create: ModelTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]
};
	["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"]: {
	connect: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: ModelTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreatePostRevisionsEntityRelationInput"]: {
	connect?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreatePostRevisionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostRevisionLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["PostRevisionLocaleCreateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined,
	leadContent?: ModelTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	create?: ModelTypes["PostRevisionWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["PostRevisionWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	createdById?: ModelTypes["UUID"] | undefined,
	publishedById?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["PostType"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	post?: ModelTypes["PostRevisionCreatePostEntityRelationInput"] | undefined,
	tileImage?: ModelTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined,
	tileVideo?: ModelTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined,
	heroImage?: ModelTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined,
	regionListOverride?: ModelTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionCreatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutRevisionsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreatePostRelationInput"] | undefined
};
	["PostWithoutRevisionsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateActiveRevisionEntityRelationInput"]: {
	connect?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	create?: ModelTypes["PostRevisionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateActiveRevisionRelationInput"] | undefined
};
	["PostRevisionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	createdById?: ModelTypes["UUID"] | undefined,
	publishedById?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["PostType"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	post?: ModelTypes["PostRevisionCreatePostEntityRelationInput"] | undefined,
	tileImage?: ModelTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined,
	tileVideo?: ModelTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined,
	heroImage?: ModelTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostRevisionCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionCreateTileImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateTileImageRelationInput"] | undefined
};
	["PostRevisionConnectOrCreateTileImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostRevisionCreateTileVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateTileVideoRelationInput"] | undefined
};
	["PostRevisionConnectOrCreateTileVideoRelationInput"]: {
	connect: ModelTypes["VideoUniqueWhere"],
	create: ModelTypes["VideoCreateInput"]
};
	["PostRevisionCreateHeroImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateHeroImageRelationInput"] | undefined
};
	["PostRevisionConnectOrCreateHeroImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostRevisionCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostRevisionLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostRevisionLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: ModelTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined,
	leadContent?: ModelTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutPostRevisionsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutPostRevisionsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateFlagImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateFlagImageRelationInput"] | undefined
};
	["LocaleConnectOrCreateFlagImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleCreateFeedPagesEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateFeedPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["FeedPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined,
	heroTiles?: ModelTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<ModelTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined,
	cardList?: ModelTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["FeedPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["FeedPageUniqueWhere"],
	create: ModelTypes["FeedPageWithoutLocalesCreateInput"]
};
	["FeedPageLocaleCreateHeroTilesEntityRelationInput"]: {
	connect?: ModelTypes["TileListUniqueWhere"] | undefined,
	create?: ModelTypes["TileListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"] | undefined
};
	["TileListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	size?: ModelTypes["TileListSize"] | undefined,
	title?: string | undefined,
	items?: Array<ModelTypes["TileListCreateItemsEntityRelationInput"]> | undefined,
	areaType?: ModelTypes["TileListCreateAreaTypeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["TileItemUniqueWhere"] | undefined,
	create?: ModelTypes["TileItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["TileItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	type?: ModelTypes["TileItemType"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	post?: ModelTypes["TileItemCreatePostEntityRelationInput"] | undefined,
	area?: ModelTypes["TileItemCreateAreaEntityRelationInput"] | undefined,
	image?: ModelTypes["TileItemCreateImageEntityRelationInput"] | undefined,
	link?: ModelTypes["TileItemCreateLinkEntityRelationInput"] | undefined,
	organization?: ModelTypes["TileItemCreateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemCreatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreatePostRelationInput"] | undefined
};
	["PostCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateRevisionsEntityRelationInput"]: {
	connect?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	create?: ModelTypes["PostRevisionWithoutPostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateRevisionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostRevisionWithoutPostCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	createdById?: ModelTypes["UUID"] | undefined,
	publishedById?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["PostType"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	tileImage?: ModelTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined,
	tileVideo?: ModelTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined,
	heroImage?: ModelTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostRevisionCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionCreateRegionListOverrideEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"] | undefined
};
	["PostRevisionConnectOrCreateRegionListOverrideRelationInput"]: {
	connect: ModelTypes["DonationAmountsRegionListUniqueWhere"],
	create: ModelTypes["DonationAmountsRegionListCreateInput"]
};
	["PostConnectOrCreateRevisionsRelationInput"]: {
	connect: ModelTypes["PostRevisionUniqueWhere"],
	create: ModelTypes["PostRevisionWithoutPostCreateInput"]
};
	["PostCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	content?: ModelTypes["PostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutPostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutPostCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreatePostOrganizationEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreatePostOrganizationRelationInput"] | undefined
};
	["PostOrganizationLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	root?: ModelTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined,
	domain?: ModelTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: ModelTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutPostOrganizationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutPostOrganizationsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateRecurringPaymentPagesEntityRelationInput"]: {
	connect?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"] | undefined,
	favouritePosts?: ModelTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["RecurringPaymentPageUniqueWhere"] | undefined,
	create?: ModelTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["RecurringPaymentPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["RecurringPaymentPageUniqueWhere"],
	create: ModelTypes["RecurringPaymentPageWithoutLocalesCreateInput"]
};
	["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"]: {
	connect?: ModelTypes["PostListUniqueWhere"] | undefined,
	create?: ModelTypes["PostListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"] | undefined
};
	["PostListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["PostListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["PostListItemUniqueWhere"] | undefined,
	create?: ModelTypes["PostListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostListItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	post?: ModelTypes["PostListItemCreatePostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemCreatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostListItemConnectOrCreatePostRelationInput"] | undefined
};
	["PostListItemConnectOrCreatePostRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostCreateInput"]
};
	["PostListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["PostListItemUniqueWhere"],
	create: ModelTypes["PostListItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"]: {
	connect: ModelTypes["PostListUniqueWhere"],
	create: ModelTypes["PostListCreateInput"]
};
	["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined
};
	["StoryGuideListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["StoryGuideListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideItemUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["StoryGuideItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	guide?: ModelTypes["StoryGuideItemCreateGuideEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemCreateGuideEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideItemConnectOrCreateGuideRelationInput"] | undefined
};
	["StoryGuideUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["StoryGuideCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	mediaType?: ModelTypes["MediaType"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	image?: ModelTypes["StoryGuideCreateImageEntityRelationInput"] | undefined,
	secondaryImage?: ModelTypes["StoryGuideCreateSecondaryImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideConnectOrCreateImageRelationInput"] | undefined
};
	["StoryGuideConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["StoryGuideCreateSecondaryImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"] | undefined
};
	["StoryGuideConnectOrCreateSecondaryImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["StoryGuideItemConnectOrCreateGuideRelationInput"]: {
	connect: ModelTypes["StoryGuideUniqueWhere"],
	create: ModelTypes["StoryGuideCreateInput"]
};
	["StoryGuideListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["StoryGuideItemUniqueWhere"],
	create: ModelTypes["StoryGuideItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"]: {
	connect: ModelTypes["StoryGuideListUniqueWhere"],
	create: ModelTypes["StoryGuideListCreateInput"]
};
	["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"]: {
	connect: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"],
	create: ModelTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGivenGiftsPagesEntityRelationInput"]: {
	connect?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateGivenGiftsPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GivenGiftsPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["GivenGiftsPageUniqueWhere"] | undefined,
	create?: ModelTypes["GivenGiftsPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GivenGiftsPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["GivenGiftsPageUniqueWhere"],
	create: ModelTypes["GivenGiftsPageWithoutLocalesCreateInput"]
};
	["GivenGiftsPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["GivenGiftsPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["GivenGiftsPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutGivenGiftsPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutGivenGiftsPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateReportPageEntityRelationInput"]: {
	connect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReportPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateReportPageRelationInput"] | undefined
};
	["ReportPageLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	root?: ModelTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	posts?: Array<ModelTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["ReportPageUniqueWhere"] | undefined,
	create?: ModelTypes["ReportPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ReportPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["ReportPageUniqueWhere"],
	create: ModelTypes["ReportPageWithoutLocalesCreateInput"]
};
	["ReportPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutReportPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutReportPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateReceivedGiftsPagesEntityRelationInput"]: {
	connect?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: ModelTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutReceivedGiftsPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateGivenGiftsPageEntityRelationInput"]: {
	connect?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"] | undefined
};
	["GivenGiftsPageLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGivenGiftsPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateReportPagesEntityRelationInput"]: {
	connect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReportPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateReportPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	posts?: Array<ModelTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutReportPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutReportPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateReceivedGiftsPageEntityRelationInput"]: {
	connect?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"] | undefined
};
	["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["ReceivedGiftsPageUniqueWhere"] | undefined,
	create?: ModelTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ReceivedGiftsPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["ReceivedGiftsPageUniqueWhere"],
	create: ModelTypes["ReceivedGiftsPageWithoutLocalesCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutReceivedGiftsPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateReportNavigationsEntityRelationInput"]: {
	connect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateReportNavigationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined,
	pages?: Array<ModelTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleCreatePagesEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageWithoutReportNavigationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportNavigationLocaleConnectOrCreatePagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageWithoutReportNavigationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined,
	type?: ModelTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: ModelTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["GenericPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["GenericPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutGenericPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutGenericPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	post?: ModelTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["GenericPageLocaleUniqueWhere"],
	create: ModelTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["ReportNavigationLocaleConnectOrCreatePagesRelationInput"]: {
	connect: ModelTypes["GenericPageUniqueWhere"],
	create: ModelTypes["GenericPageWithoutReportNavigationCreateInput"]
};
	["LocaleConnectOrCreateReportNavigationsRelationInput"]: {
	connect: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	create: ModelTypes["ReportNavigationLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateScheduledNotificationsEntityRelationInput"]: {
	connect?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateScheduledNotificationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ScheduledNotificationLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	root?: ModelTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["ScheduledNotificationUniqueWhere"] | undefined,
	create?: ModelTypes["ScheduledNotificationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ScheduledNotificationWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	localMsFromMidnight?: number | undefined,
	scheduledDate?: ModelTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: ModelTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined,
	image?: ModelTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined,
	completedAt?: ModelTypes["DateTime"] | undefined,
	processedNotifications?: Array<ModelTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationCreateTargetEntityRelationInput"]: {
	connect?: ModelTypes["NotificationTargetGroupUniqueWhere"] | undefined,
	create?: ModelTypes["NotificationTargetGroupCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"] | undefined
};
	["NotificationTargetGroupUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["NotificationTargetGroupCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["NotificationTargetType"] | undefined,
	regions?: Array<ModelTypes["NotificationTargetGroupCreateRegionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["NotificationTargetGroupCreateRegionsEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["NotificationTargetGroupConnectOrCreateRegionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["NotificationTargetGroupConnectOrCreateRegionsRelationInput"]: {
	connect: ModelTypes["RegionUniqueWhere"],
	create: ModelTypes["RegionCreateInput"]
};
	["ScheduledNotificationConnectOrCreateTargetRelationInput"]: {
	connect: ModelTypes["NotificationTargetGroupUniqueWhere"],
	create: ModelTypes["NotificationTargetGroupCreateInput"]
};
	["ScheduledNotificationCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationConnectOrCreateImageRelationInput"] | undefined
};
	["ScheduledNotificationConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]: {
	connect?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	create?: ModelTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined,
	donationReminderUser?: ModelTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"]: {
	connect?: ModelTypes["ProcessedNotificationUniqueWhere"] | undefined,
	create?: ModelTypes["ProcessedNotificationWithoutSourceCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"] | undefined
};
	["ProcessedNotificationWithoutSourceCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	topic?: string | undefined,
	sentAt?: ModelTypes["DateTime"] | undefined,
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess?: boolean | undefined,
	title?: string | undefined,
	body?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"]: {
	connect: ModelTypes["ProcessedNotificationUniqueWhere"],
	create: ModelTypes["ProcessedNotificationWithoutSourceCreateInput"]
};
	["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutProcessedNotificationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"] | undefined
};
	["UserUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	email?: string | undefined,
	variableSymbol?: number | undefined,
	stripeId?: string | undefined,
	publicProfileSecret?: string | undefined,
	payments?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	recurringPayments?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	onBehalfDonations?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	devices?: ModelTypes["DeviceUniqueWhere"] | undefined,
	processedNotifications?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	areaStats?: ModelTypes["UserAreaStatsUniqueWhere"] | undefined,
	organizationStats?: ModelTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	postStats?: ModelTypes["UserPostStatsUniqueWhere"] | undefined,
	currencyStats?: ModelTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	stats?: ModelTypes["UserStatsUniqueWhere"] | undefined
};
	["DeviceUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	user?: ModelTypes["UserUniqueWhere"] | undefined,
	fcmToken?: string | undefined
};
	["UserAreaStatsUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["UserOrganizationStatsUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["UserPostStatsUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["UserCurrencyStatsUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["UserStatsUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	user?: ModelTypes["UserUniqueWhere"] | undefined
};
	["UserWithoutProcessedNotificationsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreatePaymentsEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentWithoutUserCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreatePaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserPaymentWithoutUserCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateCurrencyRelationInput"] | undefined
};
	["UserPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ModelTypes["CurrencyUniqueWhere"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["UserPaymentCreateOrderEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentOrderIdUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentOrderIdCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateOrderRelationInput"] | undefined
};
	["UserPaymentOrderIdCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	seq?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentConnectOrCreateOrderRelationInput"]: {
	connect: ModelTypes["UserPaymentOrderIdUniqueWhere"],
	create: ModelTypes["UserPaymentOrderIdCreateInput"]
};
	["UserPaymentCreateCsobPaymentEntityRelationInput"]: {
	connect?: ModelTypes["CsobPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["CsobPaymentWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"] | undefined
};
	["CsobPaymentWithoutPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	payId?: string | undefined,
	statusChanges?: Array<ModelTypes["CsobPaymentCreateStatusChangesEntityRelationInput"]> | undefined,
	originalPayId?: string | undefined,
	metadata?: ModelTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentCreateStatusChangesEntityRelationInput"]: {
	connect?: ModelTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	create?: ModelTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CsobPaymentConnectOrCreateStatusChangesRelationInput"] | undefined,
	alias?: string | undefined
};
	["CsobPaymentStatusChangeWithoutPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	dttm?: string | undefined,
	status?: number | undefined,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentConnectOrCreateStatusChangesRelationInput"]: {
	connect: ModelTypes["CsobPaymentStatusChangeUniqueWhere"],
	create: ModelTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"]
};
	["CsobPaymentCreateMetadataEntityRelationInput"]: {
	connect?: ModelTypes["CsobPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentConnectOrCreateCsobPaymentRelationInput"]: {
	connect: ModelTypes["CsobPaymentUniqueWhere"],
	create: ModelTypes["CsobPaymentWithoutPaymentCreateInput"]
};
	["UserPaymentCreateStripePaymentEntityRelationInput"]: {
	connect?: ModelTypes["StripePaymentUniqueWhere"] | undefined,
	create?: ModelTypes["StripePaymentWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"] | undefined
};
	["StripePaymentWithoutPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	statusChanges?: Array<ModelTypes["StripePaymentCreateStatusChangesEntityRelationInput"]> | undefined,
	metadata?: ModelTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentCreateStatusChangesEntityRelationInput"]: {
	connect?: ModelTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	create?: ModelTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StripePaymentConnectOrCreateStatusChangesRelationInput"] | undefined,
	alias?: string | undefined
};
	["StripePaymentStatusChangeWithoutPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	timestamp?: number | undefined,
	eventId?: string | undefined,
	paymentIntentStatus?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentConnectOrCreateStatusChangesRelationInput"]: {
	connect: ModelTypes["StripePaymentStatusChangeUniqueWhere"],
	create: ModelTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"]
};
	["StripePaymentCreateMetadataEntityRelationInput"]: {
	connect?: ModelTypes["StripePaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentConnectOrCreateStripePaymentRelationInput"]: {
	connect: ModelTypes["StripePaymentUniqueWhere"],
	create: ModelTypes["StripePaymentWithoutPaymentCreateInput"]
};
	["UserPaymentCreateRecurringPaymentItemEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	create?: ModelTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"] | undefined
};
	["UserRecurringPaymentItemWithoutPaymentsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	recurrenceCounter?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"] | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: ModelTypes["DateTime"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserRecurringPaymentWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"] | undefined
};
	["UserRecurringPaymentWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	activeSince?: ModelTypes["DateTime"] | undefined,
	cancelledAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: ModelTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined,
	user?: ModelTypes["UserRecurringPaymentCreateUserEntityRelationInput"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentCreateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"] | undefined
};
	["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"]: {
	connect: ModelTypes["CurrencyUniqueWhere"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["UserRecurringPaymentCreateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutRecurringPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"] | undefined
};
	["UserWithoutRecurringPaymentsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<ModelTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateRegionRelationInput"] | undefined
};
	["UserConnectOrCreateRegionRelationInput"]: {
	connect: ModelTypes["RegionUniqueWhere"],
	create: ModelTypes["RegionCreateInput"]
};
	["UserCreateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateCurrencyRelationInput"] | undefined
};
	["UserConnectOrCreateCurrencyRelationInput"]: {
	connect: ModelTypes["CurrencyUniqueWhere"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["UserCreateOnBehalfDonationsEntityRelationInput"]: {
	connect?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: ModelTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateOnBehalfDonationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["OnBehalfDonationWithoutOnBehalfOfCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	payments?: Array<ModelTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"]> | undefined,
	meta?: ModelTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OnBehalfDonationCreatePaymentsEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["OnBehalfDonationConnectOrCreatePaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserPaymentWithoutOnBehalfDonationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	triesCollection?: ModelTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentCreateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateRegionRelationInput"] | undefined
};
	["UserPaymentConnectOrCreateRegionRelationInput"]: {
	connect: ModelTypes["RegionUniqueWhere"],
	create: ModelTypes["RegionCreateInput"]
};
	["UserPaymentCreateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateUserRelationInput"] | undefined
};
	["UserWithoutPaymentsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<ModelTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateRecurringPaymentsEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserRecurringPaymentWithoutUserCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateRecurringPaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserRecurringPaymentWithoutUserCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	activeSince?: ModelTypes["DateTime"] | undefined,
	cancelledAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: ModelTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined,
	items?: Array<ModelTypes["UserRecurringPaymentCreateItemsEntityRelationInput"]> | undefined,
	meta?: ModelTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	create?: ModelTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserRecurringPaymentConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	recurrenceCounter?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	payments?: Array<ModelTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]> | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: ModelTypes["DateTime"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserPaymentWithoutRecurringPaymentItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentCreateOnBehalfDonationEntityRelationInput"]: {
	connect?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: ModelTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"] | undefined
};
	["OnBehalfDonationWithoutPaymentsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	onBehalfOf?: ModelTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"] | undefined,
	meta?: ModelTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutOnBehalfDonationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"] | undefined
};
	["UserWithoutOnBehalfDonationsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<ModelTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateSentPaymentsEntityRelationInput"]: {
	connect?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateSentPaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SentPaymentLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organizationText?: string | undefined,
	root?: ModelTypes["SentPaymentLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["SentPaymentWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["SentPaymentWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: ModelTypes["DateTime"] | undefined,
	currency?: ModelTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined,
	area?: ModelTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined,
	organization?: ModelTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentCreateAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentConnectOrCreateAreaRelationInput"] | undefined
};
	["PostAreaWithoutSentPaymentsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: ModelTypes["PostAreaCreateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<ModelTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: ModelTypes["PostAreaCreateRegionEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostAreaCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: ModelTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<ModelTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: ModelTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaCreateAreaSentPaymentSumEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined
};
	["PostAreaCreateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaCreateAreaSumEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaSumUniqueWhere"] | undefined
};
	["SentPaymentConnectOrCreateAreaRelationInput"]: {
	connect: ModelTypes["PostAreaUniqueWhere"],
	create: ModelTypes["PostAreaWithoutSentPaymentsCreateInput"]
};
	["SentPaymentLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["SentPaymentUniqueWhere"],
	create: ModelTypes["SentPaymentWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ModelTypes["SentPaymentLocaleUniqueWhere"],
	create: ModelTypes["SentPaymentLocaleWithoutLocaleCreateInput"]
};
	["UserConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleCreateInput"]
};
	["UserCreateDevicesEntityRelationInput"]: {
	connect?: ModelTypes["DeviceUniqueWhere"] | undefined,
	create?: ModelTypes["DeviceWithoutUserCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateDevicesRelationInput"] | undefined,
	alias?: string | undefined
};
	["DeviceWithoutUserCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	fcmToken?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserConnectOrCreateDevicesRelationInput"]: {
	connect: ModelTypes["DeviceUniqueWhere"],
	create: ModelTypes["DeviceWithoutUserCreateInput"]
};
	["UserCreateProcessedNotificationsEntityRelationInput"]: {
	connect?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	create?: ModelTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateProcessedNotificationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined,
	scheduledNotification?: ModelTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"]: {
	connect?: ModelTypes["ScheduledNotificationUniqueWhere"] | undefined,
	create?: ModelTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"] | undefined
};
	["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	localMsFromMidnight?: number | undefined,
	scheduledDate?: ModelTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: ModelTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["ScheduledNotificationCreateLocalesEntityRelationInput"]> | undefined,
	image?: ModelTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined,
	completedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ScheduledNotificationLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	locale?: ModelTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutScheduledNotificationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutScheduledNotificationsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutScheduledNotificationsCreateInput"]
};
	["ScheduledNotificationConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["ScheduledNotificationLocaleUniqueWhere"],
	create: ModelTypes["ScheduledNotificationLocaleWithoutRootCreateInput"]
};
	["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"]: {
	connect: ModelTypes["ScheduledNotificationUniqueWhere"],
	create: ModelTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]
};
	["UserConnectOrCreateProcessedNotificationsRelationInput"]: {
	connect: ModelTypes["ProcessedNotificationSourceUniqueWhere"],
	create: ModelTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]
};
	["UserCreateAreaStatsEntityRelationInput"]: {
	connect?: ModelTypes["UserAreaStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserCreateOrganizationStatsEntityRelationInput"]: {
	connect?: ModelTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserCreatePostStatsEntityRelationInput"]: {
	connect?: ModelTypes["UserPostStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserCreateCurrencyStatsEntityRelationInput"]: {
	connect?: ModelTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"]: {
	connect: ModelTypes["UserUniqueWhere"],
	create: ModelTypes["UserWithoutOnBehalfDonationsCreateInput"]
};
	["OnBehalfDonationCreateMetaEntityRelationInput"]: {
	connect?: ModelTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined
};
	["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"]: {
	connect: ModelTypes["OnBehalfDonationUniqueWhere"],
	create: ModelTypes["OnBehalfDonationWithoutPaymentsCreateInput"]
};
	["UserPaymentCreateTriesCollectionEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"] | undefined
};
	["UserPaymentTriesCollectionUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	payment?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	metadata?: ModelTypes["UserPaymentTriesCollectionMetadataUniqueWhere"] | undefined,
	metadataLocales?: ModelTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	triesCollection?: ModelTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	parent?: ModelTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionWithoutPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	orderUrl?: string | undefined,
	user?: ModelTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"] | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"] | undefined,
	recurring?: ModelTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"] | undefined,
	metadataLocales?: Array<ModelTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]> | undefined,
	medium?: ModelTypes["PaymentMedium"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionCreateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"] | undefined
};
	["UserCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<ModelTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"]: {
	connect: ModelTypes["UserUniqueWhere"],
	create: ModelTypes["UserCreateInput"]
};
	["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"] | undefined
};
	["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"]: {
	connect: ModelTypes["CurrencyUniqueWhere"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"]: {
	connect?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: ModelTypes["OnBehalfDonationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"] | undefined
};
	["OnBehalfDonationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	payments?: Array<ModelTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"]> | undefined,
	onBehalfOf?: ModelTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"] | undefined,
	meta?: ModelTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"]: {
	connect: ModelTypes["OnBehalfDonationUniqueWhere"],
	create: ModelTypes["OnBehalfDonationCreateInput"]
};
	["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserRecurringPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"] | undefined
};
	["UserRecurringPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	activeSince?: ModelTypes["DateTime"] | undefined,
	cancelledAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: ModelTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined,
	items?: Array<ModelTypes["UserRecurringPaymentCreateItemsEntityRelationInput"]> | undefined,
	user?: ModelTypes["UserRecurringPaymentCreateUserEntityRelationInput"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentCreateMetaEntityRelationInput"]: {
	connect?: ModelTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"]: {
	connect: ModelTypes["UserRecurringPaymentUniqueWhere"],
	create: ModelTypes["UserRecurringPaymentCreateInput"]
};
	["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserPaymentConnectOrCreateTriesCollectionRelationInput"]: {
	connect: ModelTypes["UserPaymentTriesCollectionUniqueWhere"],
	create: ModelTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"]
};
	["UserPaymentCreateMetadataEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"]: {
	connect: ModelTypes["UserPaymentUniqueWhere"],
	create: ModelTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"]
};
	["UserRecurringPaymentItemCreateMetaEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["UserRecurringPaymentItemUniqueWhere"],
	create: ModelTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]
};
	["UserConnectOrCreateRecurringPaymentsRelationInput"]: {
	connect: ModelTypes["UserRecurringPaymentUniqueWhere"],
	create: ModelTypes["UserRecurringPaymentWithoutUserCreateInput"]
};
	["UserPaymentConnectOrCreateUserRelationInput"]: {
	connect: ModelTypes["UserUniqueWhere"],
	create: ModelTypes["UserWithoutPaymentsCreateInput"]
};
	["OnBehalfDonationConnectOrCreatePaymentsRelationInput"]: {
	connect: ModelTypes["UserPaymentUniqueWhere"],
	create: ModelTypes["UserPaymentWithoutOnBehalfDonationCreateInput"]
};
	["UserConnectOrCreateOnBehalfDonationsRelationInput"]: {
	connect: ModelTypes["OnBehalfDonationUniqueWhere"],
	create: ModelTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"]
};
	["UserRecurringPaymentConnectOrCreateUserRelationInput"]: {
	connect: ModelTypes["UserUniqueWhere"],
	create: ModelTypes["UserWithoutRecurringPaymentsCreateInput"]
};
	["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"]: {
	connect: ModelTypes["UserRecurringPaymentUniqueWhere"],
	create: ModelTypes["UserRecurringPaymentWithoutItemsCreateInput"]
};
	["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"]: {
	connect: ModelTypes["UserRecurringPaymentItemUniqueWhere"],
	create: ModelTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"]
};
	["UserConnectOrCreatePaymentsRelationInput"]: {
	connect: ModelTypes["UserPaymentUniqueWhere"],
	create: ModelTypes["UserPaymentWithoutUserCreateInput"]
};
	["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"]: {
	connect: ModelTypes["UserUniqueWhere"],
	create: ModelTypes["UserWithoutProcessedNotificationsCreateInput"]
};
	["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"]: {
	connect: ModelTypes["ProcessedNotificationSourceUniqueWhere"],
	create: ModelTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]
};
	["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["ScheduledNotificationUniqueWhere"],
	create: ModelTypes["ScheduledNotificationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateScheduledNotificationsRelationInput"]: {
	connect: ModelTypes["ScheduledNotificationLocaleUniqueWhere"],
	create: ModelTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"]
};
	["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutReceivedGiftsPagesCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["LinkableConnectOrCreateReceivedGiftsPageRelationInput"]: {
	connect: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: ModelTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReportPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutReportPageCreateInput"]
};
	["ReportPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["ReportPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["ReportPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["ReportPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["ReportPageLocaleCreatePostsEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutReportPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutReportPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateMetaEntityRelationInput"]: {
	connect?: ModelTypes["PostMetaDataUniqueWhere"] | undefined
};
	["PostCreateHeroCarouselEntityRelationInput"]: {
	connect?: ModelTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["HeroCarouselWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateHeroCarouselRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeroCarouselUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["HeroCarouselItemUniqueWhere"] | undefined
};
	["HeroCarouselItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["HeroCarouselWithoutPostsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["Date"] | undefined,
	items?: Array<ModelTypes["HeroCarouselCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["HeroCarouselItemUniqueWhere"] | undefined,
	create?: ModelTypes["HeroCarouselItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeroCarouselConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeroCarouselItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["Date"] | undefined,
	order?: number | undefined,
	item?: ModelTypes["HeroCarouselItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemCreateItemEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeroCarouselItemConnectOrCreateItemRelationInput"] | undefined
};
	["HeroCarouselItemConnectOrCreateItemRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostCreateInput"]
};
	["HeroCarouselConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["HeroCarouselItemUniqueWhere"],
	create: ModelTypes["HeroCarouselItemWithoutListCreateInput"]
};
	["PostConnectOrCreateHeroCarouselRelationInput"]: {
	connect: ModelTypes["HeroCarouselUniqueWhere"],
	create: ModelTypes["HeroCarouselWithoutPostsCreateInput"]
};
	["PostCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	create?: ModelTypes["ContentReferenceWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateContentRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceWithoutPostsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: ModelTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined,
	image?: ModelTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	video?: ModelTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	contentAlignment?: ModelTypes["ContentAlignment"] | undefined,
	valueList?: ModelTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined,
	areaList?: ModelTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: ModelTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	memberList?: ModelTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: ModelTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: ModelTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: ModelTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: ModelTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	textImageList?: ModelTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	create?: ModelTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: ModelTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentWithoutBlocksCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined
};
	["ContentWithoutBlocksCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
	connect: ModelTypes["ContentBlockUniqueWhere"],
	create: ModelTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceCreateValueListEntityRelationInput"]: {
	connect?: ModelTypes["ValueListUniqueWhere"] | undefined,
	create?: ModelTypes["ValueListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateValueListRelationInput"] | undefined
};
	["ValueListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["ValueListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["ValueItemUniqueWhere"] | undefined,
	create?: ModelTypes["ValueItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ValueListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ValueItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	item?: ModelTypes["ValueItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemCreateItemEntityRelationInput"]: {
	connect?: ModelTypes["ValueUniqueWhere"] | undefined,
	create?: ModelTypes["ValueCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ValueItemConnectOrCreateItemRelationInput"] | undefined
};
	["ValueUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	textContent?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["ValueCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	textContent?: ModelTypes["ValueCreateTextContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueCreateTextContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ValueConnectOrCreateTextContentRelationInput"] | undefined
};
	["ValueConnectOrCreateTextContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["ValueItemConnectOrCreateItemRelationInput"]: {
	connect: ModelTypes["ValueUniqueWhere"],
	create: ModelTypes["ValueCreateInput"]
};
	["ValueListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["ValueItemUniqueWhere"],
	create: ModelTypes["ValueItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateValueListRelationInput"]: {
	connect: ModelTypes["ValueListUniqueWhere"],
	create: ModelTypes["ValueListCreateInput"]
};
	["ContentReferenceCreateImageLinkListEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateImageLinkListRelationInput"]: {
	connect: ModelTypes["ImageLinkListUniqueWhere"],
	create: ModelTypes["ImageLinkListCreateInput"]
};
	["ContentReferenceCreateAreaListEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaListUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateAreaListRelationInput"] | undefined
};
	["PostAreaListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["PostAreaListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaListItemUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostAreaListItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	item?: ModelTypes["PostAreaListItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemCreateItemEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaListItemConnectOrCreateItemRelationInput"] | undefined
};
	["PostAreaListItemConnectOrCreateItemRelationInput"]: {
	connect: ModelTypes["PostAreaUniqueWhere"],
	create: ModelTypes["PostAreaCreateInput"]
};
	["PostAreaListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["PostAreaListItemUniqueWhere"],
	create: ModelTypes["PostAreaListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateAreaListRelationInput"]: {
	connect: ModelTypes["PostAreaListUniqueWhere"],
	create: ModelTypes["PostAreaListCreateInput"]
};
	["ContentReferenceCreateAccordionEntityRelationInput"]: {
	connect?: ModelTypes["AccordionUniqueWhere"] | undefined,
	create?: ModelTypes["AccordionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateAccordionRelationInput"] | undefined
};
	["AccordionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["AccordionCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["AccordionItemUniqueWhere"] | undefined,
	create?: ModelTypes["AccordionItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AccordionConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["AccordionItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	descriptionContent?: ModelTypes["AccordionItemCreateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemCreateDescriptionContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"] | undefined
};
	["AccordionItemConnectOrCreateDescriptionContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["AccordionConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["AccordionItemUniqueWhere"],
	create: ModelTypes["AccordionItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateAccordionRelationInput"]: {
	connect: ModelTypes["AccordionUniqueWhere"],
	create: ModelTypes["AccordionCreateInput"]
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined
};
	["MediumListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["MediumListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["MediumItemUniqueWhere"] | undefined,
	create?: ModelTypes["MediumItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["MediumItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	medium?: ModelTypes["MediumItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemCreateMediumEntityRelationInput"]: {
	connect?: ModelTypes["MediumUniqueWhere"] | undefined,
	create?: ModelTypes["MediumCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined
};
	["MediumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["MediumCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["MediumType"] | undefined,
	image?: ModelTypes["MediumCreateImageEntityRelationInput"] | undefined,
	video?: ModelTypes["MediumCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumConnectOrCreateImageRelationInput"] | undefined
};
	["MediumConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumConnectOrCreateVideoRelationInput"] | undefined
};
	["MediumConnectOrCreateVideoRelationInput"]: {
	connect: ModelTypes["VideoUniqueWhere"],
	create: ModelTypes["VideoCreateInput"]
};
	["MediumItemConnectOrCreateMediumRelationInput"]: {
	connect: ModelTypes["MediumUniqueWhere"],
	create: ModelTypes["MediumCreateInput"]
};
	["MediumListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["MediumItemUniqueWhere"],
	create: ModelTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMediaRelationInput"]: {
	connect: ModelTypes["MediumListUniqueWhere"],
	create: ModelTypes["MediumListCreateInput"]
};
	["ContentReferenceCreateMemberListEntityRelationInput"]: {
	connect?: ModelTypes["MemberListUniqueWhere"] | undefined,
	create?: ModelTypes["MemberListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateMemberListRelationInput"] | undefined
};
	["MemberListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["MemberListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["MemberListItemUniqueWhere"] | undefined,
	create?: ModelTypes["MemberListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MemberListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["MemberListItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	position?: string | undefined,
	image?: ModelTypes["MemberListItemCreateImageEntityRelationInput"] | undefined,
	descriptionContent?: ModelTypes["MemberListItemCreateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MemberListItemConnectOrCreateImageRelationInput"] | undefined
};
	["MemberListItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["MemberListItemCreateDescriptionContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"] | undefined
};
	["MemberListItemConnectOrCreateDescriptionContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["MemberListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["MemberListItemUniqueWhere"],
	create: ModelTypes["MemberListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMemberListRelationInput"]: {
	connect: ModelTypes["MemberListUniqueWhere"],
	create: ModelTypes["MemberListCreateInput"]
};
	["ContentReferenceCreateFormEntityRelationInput"]: {
	connect?: ModelTypes["FormUniqueWhere"] | undefined,
	create?: ModelTypes["FormCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateFormRelationInput"] | undefined
};
	["FormUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	tax?: ModelTypes["FilledTaxFormUniqueWhere"] | undefined
};
	["FilledTaxFormUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["FormCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	type?: ModelTypes["FormType"] | undefined,
	tax?: ModelTypes["FormCreateTaxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FormCreateTaxEntityRelationInput"]: {
	connect?: ModelTypes["FilledTaxFormUniqueWhere"] | undefined,
	create?: ModelTypes["FilledTaxFormCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FormConnectOrCreateTaxRelationInput"] | undefined
};
	["FilledTaxFormCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	userId?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	vatId?: string | undefined,
	address1?: string | undefined,
	address2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	state?: string | undefined,
	country?: ModelTypes["FilledTaxFormCreateCountryEntityRelationInput"] | undefined,
	dateFrom?: ModelTypes["Date"] | undefined,
	dateTo?: ModelTypes["Date"] | undefined,
	year?: number | undefined,
	isPdfGenerated?: boolean | undefined,
	pdfObjectKey?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FilledTaxFormCreateCountryEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FilledTaxFormConnectOrCreateCountryRelationInput"] | undefined
};
	["FilledTaxFormConnectOrCreateCountryRelationInput"]: {
	connect: ModelTypes["RegionUniqueWhere"],
	create: ModelTypes["RegionCreateInput"]
};
	["FormConnectOrCreateTaxRelationInput"]: {
	connect: ModelTypes["FilledTaxFormUniqueWhere"],
	create: ModelTypes["FilledTaxFormCreateInput"]
};
	["ContentReferenceConnectOrCreateFormRelationInput"]: {
	connect: ModelTypes["FormUniqueWhere"],
	create: ModelTypes["FormCreateInput"]
};
	["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["ContentReferenceCreateHeroCarouselEntityRelationInput"]: {
	connect?: ModelTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["HeroCarouselCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"] | undefined
};
	["HeroCarouselCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["Date"] | undefined,
	posts?: Array<ModelTypes["HeroCarouselCreatePostsEntityRelationInput"]> | undefined,
	items?: Array<ModelTypes["HeroCarouselCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselCreatePostsEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutHeroCarouselCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeroCarouselConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutHeroCarouselCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	reportPage?: Array<ModelTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateReportPageEntityRelationInput"]: {
	connect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReportPageLocaleWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateReportPageRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportPageLocaleWithoutPostsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostConnectOrCreateReportPageRelationInput"]: {
	connect: ModelTypes["ReportPageLocaleUniqueWhere"],
	create: ModelTypes["ReportPageLocaleWithoutPostsCreateInput"]
};
	["PostCreateFundraiseCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"] | undefined
};
	["PostConnectOrCreateFundraiseCurrencyRelationInput"]: {
	connect: ModelTypes["CurrencyUniqueWhere"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["PostCreateFundraiseCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostCreateFundraiseSumEntityRelationInput"]: {
	connect?: ModelTypes["PostSumUniqueWhere"] | undefined
};
	["PostCreateFundraisingProgressEntityRelationInput"]: {
	connect?: ModelTypes["PostFundraisingProgressUniqueWhere"] | undefined
};
	["HeroCarouselConnectOrCreatePostsRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostWithoutHeroCarouselCreateInput"]
};
	["ContentReferenceConnectOrCreateHeroCarouselRelationInput"]: {
	connect: ModelTypes["HeroCarouselUniqueWhere"],
	create: ModelTypes["HeroCarouselCreateInput"]
};
	["ContentReferenceCreateOrganizationListEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateOrganizationListRelationInput"]: {
	connect: ModelTypes["PostOrganizationListUniqueWhere"],
	create: ModelTypes["PostOrganizationListCreateInput"]
};
	["ContentReferenceCreateTextImageListEntityRelationInput"]: {
	connect?: ModelTypes["TextImageListUniqueWhere"] | undefined,
	create?: ModelTypes["TextImageListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"] | undefined
};
	["TextImageListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["TextImageListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["TextImageListItemUniqueWhere"] | undefined,
	create?: ModelTypes["TextImageListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextImageListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["TextImageListItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	image?: ModelTypes["TextImageListItemCreateImageEntityRelationInput"] | undefined,
	text?: string | undefined,
	link?: ModelTypes["TextImageListItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextImageListItemConnectOrCreateImageRelationInput"] | undefined
};
	["TextImageListItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["TextImageListItemCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextImageListItemConnectOrCreateLinkRelationInput"] | undefined
};
	["TextImageListItemConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["TextImageListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["TextImageListItemUniqueWhere"],
	create: ModelTypes["TextImageListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateTextImageListRelationInput"]: {
	connect: ModelTypes["TextImageListUniqueWhere"],
	create: ModelTypes["TextImageListCreateInput"]
};
	["PostConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentReferenceUniqueWhere"],
	create: ModelTypes["ContentReferenceWithoutPostsCreateInput"]
};
	["ReportPageLocaleConnectOrCreatePostsRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostWithoutReportPageCreateInput"]
};
	["LocaleConnectOrCreateReportPagesRelationInput"]: {
	connect: ModelTypes["ReportPageLocaleUniqueWhere"],
	create: ModelTypes["ReportPageLocaleWithoutLocaleCreateInput"]
};
	["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutGivenGiftsPagesCreateInput"]
};
	["LinkableConnectOrCreateGivenGiftsPageRelationInput"]: {
	connect: ModelTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: ModelTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutReceivedGiftsPageCreateInput"]
};
	["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"]: {
	connect: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: ModelTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["ReportPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutReportPagesCreateInput"]
};
	["LinkableConnectOrCreateReportPageRelationInput"]: {
	connect: ModelTypes["ReportPageLocaleUniqueWhere"],
	create: ModelTypes["ReportPageLocaleWithoutLinkCreateInput"]
};
	["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutGivenGiftsPageCreateInput"]
};
	["LocaleConnectOrCreateGivenGiftsPagesRelationInput"]: {
	connect: ModelTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: ModelTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutPostOrganizationsCreateInput"]
};
	["PostOrganizationLocaleCreateDomainEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"] | undefined
};
	["PostOrganizationLocaleConnectOrCreateDomainRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["PostOrganizationLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["PostOrganizationLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["PostOrganizationLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["PostOrganizationLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["LinkableConnectOrCreatePostOrganizationRelationInput"]: {
	connect: ModelTypes["PostOrganizationLocaleUniqueWhere"],
	create: ModelTypes["PostOrganizationLocaleWithoutLinkCreateInput"]
};
	["PostLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutPostCreateInput"]
};
	["PostConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["PostLocaleUniqueWhere"],
	create: ModelTypes["PostLocaleWithoutRootCreateInput"]
};
	["TileItemConnectOrCreatePostRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostCreateInput"]
};
	["TileItemCreateAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateAreaRelationInput"] | undefined
};
	["TileItemConnectOrCreateAreaRelationInput"]: {
	connect: ModelTypes["PostAreaUniqueWhere"],
	create: ModelTypes["PostAreaCreateInput"]
};
	["TileItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateImageRelationInput"] | undefined
};
	["TileItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["TileItemCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateLinkRelationInput"] | undefined
};
	["TileItemConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["TileItemCreateOrganizationEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateOrganizationRelationInput"] | undefined
};
	["TileItemConnectOrCreateOrganizationRelationInput"]: {
	connect: ModelTypes["PostOrganizationUniqueWhere"],
	create: ModelTypes["PostOrganizationCreateInput"]
};
	["TileListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["TileItemUniqueWhere"],
	create: ModelTypes["TileItemWithoutListCreateInput"]
};
	["TileListCreateAreaTypeEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileListConnectOrCreateAreaTypeRelationInput"] | undefined
};
	["TileListConnectOrCreateAreaTypeRelationInput"]: {
	connect: ModelTypes["PostAreaUniqueWhere"],
	create: ModelTypes["PostAreaCreateInput"]
};
	["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"]: {
	connect: ModelTypes["TileListUniqueWhere"],
	create: ModelTypes["TileListCreateInput"]
};
	["FeedPageLocaleCreateSectionListEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateSectionListRelationInput"] | undefined,
	alias?: string | undefined
};
	["FeedPageSectionWithoutFeedPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	tileStripeList?: Array<ModelTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionCreateTileStripeListEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageTileStripeUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageTileStripeWithoutSectionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageSectionConnectOrCreateTileStripeListRelationInput"] | undefined,
	alias?: string | undefined
};
	["FeedPageTileStripeWithoutSectionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	tileList?: ModelTypes["FeedPageTileStripeCreateTileListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeCreateTileListEntityRelationInput"]: {
	connect?: ModelTypes["TileListUniqueWhere"] | undefined,
	create?: ModelTypes["TileListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"] | undefined
};
	["FeedPageTileStripeConnectOrCreateTileListRelationInput"]: {
	connect: ModelTypes["TileListUniqueWhere"],
	create: ModelTypes["TileListCreateInput"]
};
	["FeedPageSectionConnectOrCreateTileStripeListRelationInput"]: {
	connect: ModelTypes["FeedPageTileStripeUniqueWhere"],
	create: ModelTypes["FeedPageTileStripeWithoutSectionCreateInput"]
};
	["FeedPageLocaleConnectOrCreateSectionListRelationInput"]: {
	connect: ModelTypes["FeedPageSectionUniqueWhere"],
	create: ModelTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"]
};
	["FeedPageLocaleCreateCardListEntityRelationInput"]: {
	connect?: ModelTypes["CardListUniqueWhere"] | undefined,
	create?: ModelTypes["CardListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"] | undefined
};
	["CardListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["CardListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["CardItemUniqueWhere"] | undefined,
	create?: ModelTypes["CardItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CardListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["CardItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["CardItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CardItemConnectOrCreateLinkRelationInput"] | undefined
};
	["CardItemConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["CardListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["CardItemUniqueWhere"],
	create: ModelTypes["CardItemWithoutListCreateInput"]
};
	["FeedPageLocaleConnectOrCreateCardListRelationInput"]: {
	connect: ModelTypes["CardListUniqueWhere"],
	create: ModelTypes["CardListCreateInput"]
};
	["FeedPageLocaleCreateStoryGuideListEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined
};
	["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"]: {
	connect: ModelTypes["StoryGuideListUniqueWhere"],
	create: ModelTypes["StoryGuideListCreateInput"]
};
	["LocaleConnectOrCreateFeedPagesRelationInput"]: {
	connect: ModelTypes["FeedPageLocaleUniqueWhere"],
	create: ModelTypes["FeedPageLocaleWithoutLocaleCreateInput"]
};
	["PostRevisionLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutPostRevisionsCreateInput"]
};
	["PostRevisionLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["PostRevisionLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["PostRevisionLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["PostRevisionLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["PostRevisionLocaleCreateLeadContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"] | undefined
};
	["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["PostRevisionConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["PostRevisionLocaleUniqueWhere"],
	create: ModelTypes["PostRevisionLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateActiveRevisionRelationInput"]: {
	connect: ModelTypes["PostRevisionUniqueWhere"],
	create: ModelTypes["PostRevisionCreateInput"]
};
	["PostRevisionConnectOrCreatePostRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostWithoutRevisionsCreateInput"]
};
	["PostRevisionLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["PostRevisionUniqueWhere"],
	create: ModelTypes["PostRevisionWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostRevisionsRelationInput"]: {
	connect: ModelTypes["PostRevisionLocaleUniqueWhere"],
	create: ModelTypes["PostRevisionLocaleWithoutLocaleCreateInput"]
};
	["SentPaymentLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutSentPaymentsCreateInput"]
};
	["SentPaymentConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["SentPaymentLocaleUniqueWhere"],
	create: ModelTypes["SentPaymentLocaleWithoutRootCreateInput"]
};
	["PostAreaConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ModelTypes["SentPaymentUniqueWhere"],
	create: ModelTypes["SentPaymentWithoutAreaCreateInput"]
};
	["PostOrganizationConnectOrCreateAreaRelationInput"]: {
	connect: ModelTypes["PostAreaUniqueWhere"],
	create: ModelTypes["PostAreaCreateInput"]
};
	["PostOrganizationCreateSentPaymentsEntityRelationInput"]: {
	connect?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["SentPaymentWithoutOrganizationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateSentPaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SentPaymentWithoutOrganizationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: ModelTypes["DateTime"] | undefined,
	currency?: ModelTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined,
	area?: ModelTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationConnectOrCreateSentPaymentsRelationInput"]: {
	connect: ModelTypes["SentPaymentUniqueWhere"],
	create: ModelTypes["SentPaymentWithoutOrganizationCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["PostOrganizationUniqueWhere"],
	create: ModelTypes["PostOrganizationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostOrganizationsRelationInput"]: {
	connect: ModelTypes["PostOrganizationLocaleUniqueWhere"],
	create: ModelTypes["PostOrganizationLocaleWithoutLocaleCreateInput"]
};
	["PostAreaLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutPostAreasCreateInput"]
};
	["PostAreaLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["PostAreaLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["PostAreaLocaleCreateBannerEntityRelationInput"]: {
	connect?: ModelTypes["AppBannerUniqueWhere"] | undefined,
	create?: ModelTypes["AppBannerCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"] | undefined
};
	["AppBannerCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	imageSmall?: ModelTypes["AppBannerCreateImageSmallEntityRelationInput"] | undefined,
	imageBig?: ModelTypes["AppBannerCreateImageBigEntityRelationInput"] | undefined,
	textContent?: ModelTypes["AppBannerCreateTextContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AppBannerCreateImageSmallEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AppBannerConnectOrCreateImageSmallRelationInput"] | undefined
};
	["AppBannerConnectOrCreateImageSmallRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["AppBannerCreateImageBigEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AppBannerConnectOrCreateImageBigRelationInput"] | undefined
};
	["AppBannerConnectOrCreateImageBigRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["AppBannerCreateTextContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AppBannerConnectOrCreateTextContentRelationInput"] | undefined
};
	["AppBannerConnectOrCreateTextContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["PostAreaLocaleConnectOrCreateBannerRelationInput"]: {
	connect: ModelTypes["AppBannerUniqueWhere"],
	create: ModelTypes["AppBannerCreateInput"]
};
	["PostAreaLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["PostAreaLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["LinkableConnectOrCreatePostAreaRelationInput"]: {
	connect: ModelTypes["PostAreaLocaleUniqueWhere"],
	create: ModelTypes["PostAreaLocaleWithoutLinkCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutPostOrganizationCreateInput"]
};
	["PostOrganizationConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["PostOrganizationLocaleUniqueWhere"],
	create: ModelTypes["PostOrganizationLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateOrganizationRelationInput"]: {
	connect: ModelTypes["PostOrganizationUniqueWhere"],
	create: ModelTypes["PostOrganizationWithoutPostsCreateInput"]
};
	["PostAreaConnectOrCreatePostsRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostWithoutAreaCreateInput"]
};
	["PostAreaLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["PostAreaUniqueWhere"],
	create: ModelTypes["PostAreaWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostAreasRelationInput"]: {
	connect: ModelTypes["PostAreaLocaleUniqueWhere"],
	create: ModelTypes["PostAreaLocaleWithoutLocaleCreateInput"]
};
	["PostLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutPostsCreateInput"]
};
	["PostLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["PostWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostWithoutLocalesCreateInput"]
};
	["LinkableConnectOrCreatePostRelationInput"]: {
	connect: ModelTypes["PostLocaleUniqueWhere"],
	create: ModelTypes["PostLocaleWithoutLinkCreateInput"]
};
	["LinkConnectOrCreateInternalLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableCreateInput"]
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["ContentReferenceCreatePostsEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutContentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organization?: ModelTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceConnectOrCreatePostsRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostWithoutContentCreateInput"]
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
	connect: ModelTypes["ContentReferenceUniqueWhere"],
	create: ModelTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
	connect: ModelTypes["ContentBlockUniqueWhere"],
	create: ModelTypes["ContentBlockWithoutContentCreateInput"]
};
	["PostLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["LocaleConnectOrCreatePostsRelationInput"]: {
	connect: ModelTypes["PostLocaleUniqueWhere"],
	create: ModelTypes["PostLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
	connect: ModelTypes["GenericPageLocaleUniqueWhere"],
	create: ModelTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["PostAreaLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutPostAreaCreateInput"]
};
	["PostAreaConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["PostAreaLocaleUniqueWhere"],
	create: ModelTypes["PostAreaLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateAreaRelationInput"]: {
	connect: ModelTypes["PostAreaUniqueWhere"],
	create: ModelTypes["PostAreaWithoutPostsCreateInput"]
};
	["PostOrganizationConnectOrCreatePostsRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostWithoutOrganizationCreateInput"]
};
	["PostOrganizationListItemConnectOrCreateItemRelationInput"]: {
	connect: ModelTypes["PostOrganizationUniqueWhere"],
	create: ModelTypes["PostOrganizationCreateInput"]
};
	["PostOrganizationListItemCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"] | undefined
};
	["PostOrganizationListItemConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["PostOrganizationListItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"] | undefined
};
	["PostOrganizationListItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["PostOrganizationListItemUniqueWhere"],
	create: ModelTypes["PostOrganizationListItemWithoutListCreateInput"]
};
	["GeneralConnectOrCreateOrganizationListRelationInput"]: {
	connect: ModelTypes["PostOrganizationListUniqueWhere"],
	create: ModelTypes["PostOrganizationListCreateInput"]
};
	["GeneralLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["GeneralUniqueWhere"],
	create: ModelTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["GeneralLocaleCreateAppStoreLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"] | undefined
};
	["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"] | undefined
};
	["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateGeneralsRelationInput"]: {
	connect: ModelTypes["GeneralLocaleUniqueWhere"],
	create: ModelTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutReportNavigationsCreateInput"]
};
	["GenericPageConnectOrCreateReportNavigationRelationInput"]: {
	connect: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	create: ModelTypes["ReportNavigationLocaleWithoutPagesCreateInput"]
};
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["GenericPageUniqueWhere"],
	create: ModelTypes["GenericPageWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateGenericPagesRelationInput"]: {
	connect: ModelTypes["GenericPageLocaleUniqueWhere"],
	create: ModelTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutGeneralsCreateInput"]
};
	["GeneralConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["GeneralLocaleUniqueWhere"],
	create: ModelTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["GeneralUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["GeneralUpdateLocalesEntityRelationInput"]> | undefined,
	allAreasIcon?: ModelTypes["GeneralUpdateAllAreasIconEntityRelationInput"] | undefined,
	allOrganizationsIcon?: ModelTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["GeneralUpdateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["GeneralLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["GeneralUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["GeneralUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GeneralUpdateLocalesRelationInput"]: {
	by: ModelTypes["GeneralLocaleUniqueWhere"],
	data: ModelTypes["GeneralLocaleWithoutRootUpdateInput"]
};
	["GeneralLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	appStoreLink?: ModelTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: ModelTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGeneralsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutGeneralsUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGeneralsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateGenericPagesEntityRelationInput"]: {
	create?: ModelTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateGenericPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertGenericPagesRelationInput"] | undefined,
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGenericPagesRelationInput"]: {
	by: ModelTypes["GenericPageLocaleUniqueWhere"],
	data: ModelTypes["GenericPageLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["GenericPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GenericPageWithoutLocalesUpdateInput"]: {
	type?: ModelTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	reportNavigation?: Array<ModelTypes["GenericPageUpdateReportNavigationEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateReportNavigationEntityRelationInput"]: {
	create?: ModelTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | undefined,
	update?: ModelTypes["GenericPageUpdateReportNavigationRelationInput"] | undefined,
	upsert?: ModelTypes["GenericPageUpsertReportNavigationRelationInput"] | undefined,
	connect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageUpdateReportNavigationRelationInput"]: {
	by: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	data: ModelTypes["ReportNavigationLocaleWithoutPagesUpdateInput"]
};
	["ReportNavigationLocaleWithoutPagesUpdateInput"]: {
	root?: ModelTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["ReportNavigationUniqueWhere"] | undefined,
	create?: ModelTypes["ReportNavigationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["ReportNavigationWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["ReportNavigationLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ReportNavigationWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["ReportNavigationWithoutLocalesUpdateInput"],
	create: ModelTypes["ReportNavigationWithoutLocalesCreateInput"]
};
	["ReportNavigationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutReportNavigationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutReportNavigationsUpdateInput"] | undefined,
	upsert?: ModelTypes["ReportNavigationLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutReportNavigationsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateGeneralsEntityRelationInput"]: {
	create?: ModelTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateGeneralsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertGeneralsRelationInput"] | undefined,
	connect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGeneralsRelationInput"]: {
	by: ModelTypes["GeneralLocaleUniqueWhere"],
	data: ModelTypes["GeneralLocaleWithoutLocaleUpdateInput"]
};
	["GeneralLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	appStoreLink?: ModelTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: ModelTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["GeneralUniqueWhere"] | undefined,
	create?: ModelTypes["GeneralWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["GeneralWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GeneralWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	allAreasIcon?: ModelTypes["GeneralUpdateAllAreasIconEntityRelationInput"] | undefined,
	allOrganizationsIcon?: ModelTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["GeneralUpdateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralUpdateAllAreasIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralConnectOrCreateAllAreasIconRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralUpsertAllAreasIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageUpdateInput"]: {
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralUpsertAllAreasIconRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["GeneralUpdateAllOrganizationsIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralUpsertAllOrganizationsIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralUpsertAllOrganizationsIconRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["GeneralUpdateOrganizationListEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralConnectOrCreateOrganizationListRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationListUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralUpsertOrganizationListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationListUpdateInput"]: {
	items?: Array<ModelTypes["PostOrganizationListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["PostOrganizationListItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["PostOrganizationListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["PostOrganizationListItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostOrganizationListItemUniqueWhere"] | undefined,
	delete?: ModelTypes["PostOrganizationListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationListUpdateItemsRelationInput"]: {
	by: ModelTypes["PostOrganizationListItemUniqueWhere"],
	data: ModelTypes["PostOrganizationListItemWithoutListUpdateInput"]
};
	["PostOrganizationListItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	item?: ModelTypes["PostOrganizationListItemUpdateItemEntityRelationInput"] | undefined,
	type?: ModelTypes["PostOrganizationListItemType"] | undefined,
	link?: ModelTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"] | undefined,
	image?: ModelTypes["PostOrganizationListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemUpdateItemEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationListItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpdateInput"]: {
	order?: number | undefined,
	posts?: Array<ModelTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined,
	icon?: ModelTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: ModelTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: ModelTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: ModelTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<ModelTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: ModelTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpdatePostsEntityRelationInput"]: {
	create?: ModelTypes["PostWithoutOrganizationCreateInput"] | undefined,
	update?: ModelTypes["PostOrganizationUpdatePostsRelationInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationUpsertPostsRelationInput"] | undefined,
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostUniqueWhere"] | undefined,
	delete?: ModelTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationUpdatePostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	data: ModelTypes["PostWithoutOrganizationUpdateInput"]
};
	["PostWithoutOrganizationUpdateInput"]: {
	area?: ModelTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateAreaRelationInput"] | undefined,
	update?: ModelTypes["PostAreaWithoutPostsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostUpsertAreaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaWithoutPostsUpdateInput"]: {
	order?: number | undefined,
	icon?: ModelTypes["PostAreaUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	specificSymbol?: number | undefined,
	region?: ModelTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: ModelTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<ModelTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: ModelTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaUpdateIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateIconRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaUpsertIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpsertIconRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostAreaUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["PostAreaLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["PostAreaUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["PostAreaUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdateLocalesRelationInput"]: {
	by: ModelTypes["PostAreaLocaleUniqueWhere"],
	data: ModelTypes["PostAreaLocaleWithoutRootUpdateInput"]
};
	["PostAreaLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined,
	banner?: ModelTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutPostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutPostAreaUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutPostAreaUpdateInput"]: {
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined,
	update?: ModelTypes["GenericPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertGenericPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGenericPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutGenericPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGenericPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdatePostsEntityRelationInput"]: {
	create?: ModelTypes["PostLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdatePostsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertPostsRelationInput"] | undefined,
	connect?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePostsRelationInput"]: {
	by: ModelTypes["PostLocaleUniqueWhere"],
	data: ModelTypes["PostLocaleWithoutLocaleUpdateInput"]
};
	["PostLocaleWithoutLocaleUpdateInput"]: {
	content?: ModelTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["PostLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentUpdateInput"]: {
	blocks?: Array<ModelTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?: ModelTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	update?: ModelTypes["ContentUpdateBlocksRelationInput"] | undefined,
	upsert?: ModelTypes["ContentUpsertBlocksRelationInput"] | undefined,
	connect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	delete?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentUpdateBlocksRelationInput"]: {
	by: ModelTypes["ContentBlockUniqueWhere"],
	data: ModelTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?: number | undefined,
	json?: string | undefined,
	references?: Array<ModelTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?: ModelTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	update?: ModelTypes["ContentBlockUpdateReferencesRelationInput"] | undefined,
	upsert?: ModelTypes["ContentBlockUpsertReferencesRelationInput"] | undefined,
	connect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	delete?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by: ModelTypes["ContentReferenceUniqueWhere"],
	data: ModelTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	image?: ModelTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	video?: ModelTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	contentAlignment?: ModelTypes["ContentAlignment"] | undefined,
	valueList?: ModelTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined,
	areaList?: ModelTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: ModelTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	memberList?: ModelTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: ModelTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: ModelTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: ModelTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: ModelTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	posts?: Array<ModelTypes["ContentReferenceUpdatePostsEntityRelationInput"]> | undefined,
	textImageList?: ModelTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: {
	connect?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	delete?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined,
	update?: ModelTypes["VideoUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpdateInput"]: {
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	poster?: ModelTypes["VideoUpdatePosterEntityRelationInput"] | undefined,
	shapeType?: ModelTypes["VideoShapeType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoUpdatePosterEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["VideoConnectOrCreatePosterRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["VideoUpsertPosterRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpsertPosterRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertVideoRelationInput"]: {
	update: ModelTypes["VideoUpdateInput"],
	create: ModelTypes["VideoCreateInput"]
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkUpdateInput"]: {
	type?: ModelTypes["LinkEnum"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: ModelTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined,
	isTargetBlank?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkUpsertInternalLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableUpdateInput"]: {
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreatePostRelationInput"] | undefined,
	update?: ModelTypes["PostLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertPostRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostLocaleWithoutLinkUpdateInput"]: {
	content?: ModelTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	root?: ModelTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["PostLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpdateInput"]: {
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: ModelTypes["SeoUpdateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["SeoUpsertOgImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpsertOgImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["PostLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutPostsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPostsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdatePostAreasEntityRelationInput"]: {
	create?: ModelTypes["PostAreaLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdatePostAreasRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertPostAreasRelationInput"] | undefined,
	connect?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePostAreasRelationInput"]: {
	by: ModelTypes["PostAreaLocaleUniqueWhere"],
	data: ModelTypes["PostAreaLocaleWithoutLocaleUpdateInput"]
};
	["PostAreaLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined,
	banner?: ModelTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["PostAreaWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostAreaWithoutLocalesUpdateInput"]: {
	order?: number | undefined,
	icon?: ModelTypes["PostAreaUpdateIconEntityRelationInput"] | undefined,
	regionListOverride?: ModelTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<ModelTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: ModelTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: ModelTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<ModelTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: ModelTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaUpdateRegionListOverrideEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"] | undefined,
	update?: ModelTypes["DonationAmountsRegionListUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaUpsertRegionListOverrideRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DonationAmountsRegionListUpdateInput"]: {
	regions?: Array<ModelTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]> | undefined,
	donation?: ModelTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]: {
	create?: ModelTypes["DonationAmountsRegionItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["DonationAmountsRegionListUpdateRegionsRelationInput"] | undefined,
	upsert?: ModelTypes["DonationAmountsRegionListUpsertRegionsRelationInput"] | undefined,
	connect?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	delete?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DonationAmountsRegionListUpdateRegionsRelationInput"]: {
	by: ModelTypes["DonationAmountsRegionItemUniqueWhere"],
	data: ModelTypes["DonationAmountsRegionItemWithoutListUpdateInput"]
};
	["DonationAmountsRegionItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	items?: Array<ModelTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined,
	region?: ModelTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["DonationAmountItemWithoutRegionItemCreateInput"] | undefined,
	update?: ModelTypes["DonationAmountsRegionItemUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["DonationAmountsRegionItemUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["DonationAmountItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["DonationAmountItemUniqueWhere"] | undefined,
	delete?: ModelTypes["DonationAmountItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DonationAmountsRegionItemUpdateItemsRelationInput"]: {
	by: ModelTypes["DonationAmountItemUniqueWhere"],
	data: ModelTypes["DonationAmountItemWithoutRegionItemUpdateInput"]
};
	["DonationAmountItemWithoutRegionItemUpdateInput"]: {
	order?: number | undefined,
	amount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpsertItemsRelationInput"]: {
	by: ModelTypes["DonationAmountItemUniqueWhere"],
	update: ModelTypes["DonationAmountItemWithoutRegionItemUpdateInput"],
	create: ModelTypes["DonationAmountItemWithoutRegionItemCreateInput"]
};
	["DonationAmountsRegionItemUpdateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionWithoutDonationItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"] | undefined,
	update?: ModelTypes["RegionWithoutDonationItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["DonationAmountsRegionItemUpsertRegionRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["RegionWithoutDonationItemsUpdateInput"]: {
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: ModelTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined,
	enabledPaymentMethods?: Array<ModelTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionUpdateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RegionConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: ModelTypes["CurrencyUpdateInput"] | undefined,
	upsert?: ModelTypes["RegionUpsertCurrencyRelationInput"] | undefined
};
	["CurrencyUpdateInput"]: {
	identifier?: ModelTypes["CurrencyIdentifier"] | undefined,
	label?: string | undefined,
	sign?: string | undefined,
	signAlignment?: ModelTypes["CurrencySignAlignment"] | undefined,
	defaultDonationAmount?: number | undefined,
	rateAgainstCzk?: number | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaCurrencySums?: Array<ModelTypes["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<ModelTypes["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	postCurrencySums?: Array<ModelTypes["CurrencyUpdatePostCurrencySumsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	delete?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	delete?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	delete?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyUpdatePostCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	delete?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RegionUpsertCurrencyRelationInput"]: {
	update: ModelTypes["CurrencyUpdateInput"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]: {
	create?: ModelTypes["RegionPaymentMethodWithoutRegionCreateInput"] | undefined,
	update?: ModelTypes["RegionUpdateEnabledPaymentMethodsRelationInput"] | undefined,
	upsert?: ModelTypes["RegionUpsertEnabledPaymentMethodsRelationInput"] | undefined,
	connect?: ModelTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	disconnect?: ModelTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	delete?: ModelTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RegionUpdateEnabledPaymentMethodsRelationInput"]: {
	by: ModelTypes["RegionPaymentMethodUniqueWhere"],
	data: ModelTypes["RegionPaymentMethodWithoutRegionUpdateInput"]
};
	["RegionPaymentMethodWithoutRegionUpdateInput"]: {
	allowRecurringPayments?: boolean | undefined,
	method?: ModelTypes["PaymentMethods"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionUpsertEnabledPaymentMethodsRelationInput"]: {
	by: ModelTypes["RegionPaymentMethodUniqueWhere"],
	update: ModelTypes["RegionPaymentMethodWithoutRegionUpdateInput"],
	create: ModelTypes["RegionPaymentMethodWithoutRegionCreateInput"]
};
	["DonationAmountsRegionItemUpsertRegionRelationInput"]: {
	update: ModelTypes["RegionWithoutDonationItemsUpdateInput"],
	create: ModelTypes["RegionWithoutDonationItemsCreateInput"]
};
	["DonationAmountsRegionListUpsertRegionsRelationInput"]: {
	by: ModelTypes["DonationAmountsRegionItemUniqueWhere"],
	update: ModelTypes["DonationAmountsRegionItemWithoutListUpdateInput"],
	create: ModelTypes["DonationAmountsRegionItemWithoutListCreateInput"]
};
	["DonationAmountsRegionListUpdateDonationEntityRelationInput"]: {
	connect?: ModelTypes["DonationUniqueWhere"] | undefined,
	create?: ModelTypes["DonationWithoutRegionListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"] | undefined,
	update?: ModelTypes["DonationWithoutRegionListUpdateInput"] | undefined,
	upsert?: ModelTypes["DonationAmountsRegionListUpsertDonationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DonationWithoutRegionListUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListUpsertDonationRelationInput"]: {
	update: ModelTypes["DonationWithoutRegionListUpdateInput"],
	create: ModelTypes["DonationWithoutRegionListCreateInput"]
};
	["PostAreaUpsertRegionListOverrideRelationInput"]: {
	update: ModelTypes["DonationAmountsRegionListUpdateInput"],
	create: ModelTypes["DonationAmountsRegionListCreateInput"]
};
	["PostAreaUpdatePostsEntityRelationInput"]: {
	create?: ModelTypes["PostWithoutAreaCreateInput"] | undefined,
	update?: ModelTypes["PostAreaUpdatePostsRelationInput"] | undefined,
	upsert?: ModelTypes["PostAreaUpsertPostsRelationInput"] | undefined,
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostUniqueWhere"] | undefined,
	delete?: ModelTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdatePostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	data: ModelTypes["PostWithoutAreaUpdateInput"]
};
	["PostWithoutAreaUpdateInput"]: {
	organization?: ModelTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateOrganizationEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateOrganizationRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationWithoutPostsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostUpsertOrganizationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationWithoutPostsUpdateInput"]: {
	order?: number | undefined,
	icon?: ModelTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: ModelTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: ModelTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: ModelTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<ModelTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: ModelTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpdateIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateIconRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationUpsertIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpsertIconRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["PostOrganizationLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["PostOrganizationUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationUpdateLocalesRelationInput"]: {
	by: ModelTypes["PostOrganizationLocaleUniqueWhere"],
	data: ModelTypes["PostOrganizationLocaleWithoutRootUpdateInput"]
};
	["PostOrganizationLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	domain?: ModelTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: ModelTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutPostOrganizationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutPostOrganizationUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutPostOrganizationUpdateInput"]: {
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdatePostAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreatePostAreaRelationInput"] | undefined,
	update?: ModelTypes["PostAreaLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertPostAreaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaLocaleWithoutLinkUpdateInput"]: {
	name?: string | undefined,
	description?: string | undefined,
	root?: ModelTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined,
	banner?: ModelTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutPostAreasCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutPostAreasUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPostAreasUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdatePostOrganizationsEntityRelationInput"]: {
	create?: ModelTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdatePostOrganizationsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertPostOrganizationsRelationInput"] | undefined,
	connect?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePostOrganizationsRelationInput"]: {
	by: ModelTypes["PostOrganizationLocaleUniqueWhere"],
	data: ModelTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"]
};
	["PostOrganizationLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined,
	domain?: ModelTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: ModelTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationWithoutLocalesUpdateInput"]: {
	order?: number | undefined,
	posts?: Array<ModelTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined,
	icon?: ModelTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	area?: ModelTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: ModelTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: ModelTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<ModelTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: ModelTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpdateAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateAreaRelationInput"] | undefined,
	update?: ModelTypes["PostAreaUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationUpsertAreaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpdateInput"]: {
	order?: number | undefined,
	icon?: ModelTypes["PostAreaUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<ModelTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: ModelTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: ModelTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<ModelTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<ModelTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: ModelTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaUpdateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateRegionRelationInput"] | undefined,
	update?: ModelTypes["RegionUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaUpsertRegionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RegionUpdateInput"]: {
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: ModelTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined,
	enabledPaymentMethods?: Array<ModelTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]> | undefined,
	donationItems?: Array<ModelTypes["RegionUpdateDonationItemsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionUpdateDonationItemsEntityRelationInput"]: {
	create?: ModelTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | undefined,
	update?: ModelTypes["RegionUpdateDonationItemsRelationInput"] | undefined,
	upsert?: ModelTypes["RegionUpsertDonationItemsRelationInput"] | undefined,
	connect?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	delete?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RegionUpdateDonationItemsRelationInput"]: {
	by: ModelTypes["DonationAmountsRegionItemUniqueWhere"],
	data: ModelTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"]
};
	["DonationAmountsRegionItemWithoutRegionUpdateInput"]: {
	order?: number | undefined,
	items?: Array<ModelTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined,
	list?: ModelTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"] | undefined,
	upsert?: ModelTypes["DonationAmountsRegionItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["DonationAmountsRegionListWithoutRegionsUpdateInput"]: {
	donation?: ModelTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpsertListRelationInput"]: {
	update: ModelTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"],
	create: ModelTypes["DonationAmountsRegionListWithoutRegionsCreateInput"]
};
	["RegionUpsertDonationItemsRelationInput"]: {
	by: ModelTypes["DonationAmountsRegionItemUniqueWhere"],
	update: ModelTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"],
	create: ModelTypes["DonationAmountsRegionItemWithoutRegionCreateInput"]
};
	["PostAreaUpsertRegionRelationInput"]: {
	update: ModelTypes["RegionUpdateInput"],
	create: ModelTypes["RegionCreateInput"]
};
	["PostAreaUpdateMetaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaMetaDataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpdateMobileHeroImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaUpsertMobileHeroImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpsertMobileHeroImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostAreaUpdatePlainIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaConnectOrCreatePlainIconRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaUpsertPlainIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpsertPlainIconRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostAreaUpdateSentPaymentsEntityRelationInput"]: {
	create?: ModelTypes["SentPaymentWithoutAreaCreateInput"] | undefined,
	update?: ModelTypes["PostAreaUpdateSentPaymentsRelationInput"] | undefined,
	upsert?: ModelTypes["PostAreaUpsertSentPaymentsRelationInput"] | undefined,
	connect?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	disconnect?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	delete?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdateSentPaymentsRelationInput"]: {
	by: ModelTypes["SentPaymentUniqueWhere"],
	data: ModelTypes["SentPaymentWithoutAreaUpdateInput"]
};
	["SentPaymentWithoutAreaUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: ModelTypes["DateTime"] | undefined,
	currency?: ModelTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	organization?: ModelTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: ModelTypes["CurrencyUpdateInput"] | undefined,
	upsert?: ModelTypes["SentPaymentUpsertCurrencyRelationInput"] | undefined
};
	["SentPaymentUpsertCurrencyRelationInput"]: {
	update: ModelTypes["CurrencyUpdateInput"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["SentPaymentUpdateOrganizationEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentConnectOrCreateOrganizationRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationWithoutSentPaymentsUpdateInput"] | undefined,
	upsert?: ModelTypes["SentPaymentUpsertOrganizationRelationInput"] | undefined
};
	["PostOrganizationWithoutSentPaymentsUpdateInput"]: {
	order?: number | undefined,
	posts?: Array<ModelTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined,
	icon?: ModelTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: ModelTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: ModelTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: ModelTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined,
	organizationCurrencySums?: Array<ModelTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: ModelTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpdateMetaEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationMetaDataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpdateMobileHeroImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationUpsertMobileHeroImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpsertMobileHeroImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationUpdatePlainIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationUpsertPlainIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpsertPlainIconRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationUpsertDesktopHeroImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpsertDesktopHeroImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	delete?: ModelTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationUpdateOrganizationSumEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationSumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SentPaymentUpsertOrganizationRelationInput"]: {
	update: ModelTypes["PostOrganizationWithoutSentPaymentsUpdateInput"],
	create: ModelTypes["PostOrganizationWithoutSentPaymentsCreateInput"]
};
	["SentPaymentUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["SentPaymentLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["SentPaymentUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["SentPaymentUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SentPaymentUpdateLocalesRelationInput"]: {
	by: ModelTypes["SentPaymentLocaleUniqueWhere"],
	data: ModelTypes["SentPaymentLocaleWithoutRootUpdateInput"]
};
	["SentPaymentLocaleWithoutRootUpdateInput"]: {
	organizationText?: string | undefined,
	locale?: ModelTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutSentPaymentsUpdateInput"] | undefined,
	upsert?: ModelTypes["SentPaymentLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutSentPaymentsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
	create?: ModelTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateHeadersRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertHeadersRelationInput"] | undefined,
	connect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateHeadersRelationInput"]: {
	by: ModelTypes["HeaderLocaleUniqueWhere"],
	data: ModelTypes["HeaderLocaleWithoutLocaleUpdateInput"]
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined,
	links?: ModelTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["HeaderUniqueWhere"] | undefined,
	create?: ModelTypes["HeaderWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["HeaderWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HeaderWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	logo?: ModelTypes["HeaderUpdateLogoEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["HeaderUpdateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["HeaderUpdateOrganizationListEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateOrganizationListRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationListUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderUpsertOrganizationListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderUpsertOrganizationListRelationInput"]: {
	update: ModelTypes["PostOrganizationListUpdateInput"],
	create: ModelTypes["PostOrganizationListCreateInput"]
};
	["HeaderLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["HeaderWithoutLocalesUpdateInput"],
	create: ModelTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleUpdateLinksEntityRelationInput"]: {
	connect?: ModelTypes["LinkListUniqueWhere"] | undefined,
	create?: ModelTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLinksRelationInput"] | undefined,
	update?: ModelTypes["LinkListUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertLinksRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkListUpdateInput"]: {
	items?: Array<ModelTypes["LinkListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["LinkItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["LinkListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["LinkListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["LinkItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["LinkItemUniqueWhere"] | undefined,
	delete?: ModelTypes["LinkItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LinkListUpdateItemsRelationInput"]: {
	by: ModelTypes["LinkItemUniqueWhere"],
	data: ModelTypes["LinkItemWithoutListUpdateInput"]
};
	["LinkItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	link?: ModelTypes["LinkItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkItemUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["LinkListUpsertItemsRelationInput"]: {
	by: ModelTypes["LinkItemUniqueWhere"],
	update: ModelTypes["LinkItemWithoutListUpdateInput"],
	create: ModelTypes["LinkItemWithoutListCreateInput"]
};
	["HeaderLocaleUpsertLinksRelationInput"]: {
	update: ModelTypes["LinkListUpdateInput"],
	create: ModelTypes["LinkListCreateInput"]
};
	["LocaleUpsertHeadersRelationInput"]: {
	by: ModelTypes["HeaderLocaleUniqueWhere"],
	update: ModelTypes["HeaderLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateFootersEntityRelationInput"]: {
	create?: ModelTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateFootersRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertFootersRelationInput"] | undefined,
	connect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateFootersRelationInput"]: {
	by: ModelTypes["FooterLocaleUniqueWhere"],
	data: ModelTypes["FooterLocaleWithoutLocaleUpdateInput"]
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
	copyright?: string | undefined,
	root?: ModelTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined,
	linkList?: ModelTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: ModelTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["FooterUniqueWhere"] | undefined,
	create?: ModelTypes["FooterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["FooterWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FooterWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	logo?: ModelTypes["FooterUpdateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["FooterLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["FooterWithoutLocalesUpdateInput"],
	create: ModelTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleUpdateLinkListEntityRelationInput"]: {
	connect?: ModelTypes["LinkListUniqueWhere"] | undefined,
	create?: ModelTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateLinkListRelationInput"] | undefined,
	update?: ModelTypes["LinkListUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertLinkListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertLinkListRelationInput"]: {
	update: ModelTypes["LinkListUpdateInput"],
	create: ModelTypes["LinkListCreateInput"]
};
	["FooterLocaleUpdateAddressInfoEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertAddressInfoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertAddressInfoRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["FooterLocaleUpdateImageLinkListEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"] | undefined,
	update?: ModelTypes["ImageLinkListUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertImageLinkListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageLinkListUpdateInput"]: {
	items?: Array<ModelTypes["ImageLinkListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["ImageLinkItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["ImageLinkListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["ImageLinkListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["ImageLinkItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ImageLinkItemUniqueWhere"] | undefined,
	delete?: ModelTypes["ImageLinkItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ImageLinkListUpdateItemsRelationInput"]: {
	by: ModelTypes["ImageLinkItemUniqueWhere"],
	data: ModelTypes["ImageLinkItemWithoutListUpdateInput"]
};
	["ImageLinkItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	item?: ModelTypes["ImageLinkItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemUpdateItemEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkItemConnectOrCreateItemRelationInput"] | undefined,
	update?: ModelTypes["ImageLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["ImageLinkItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageLinkUpdateInput"]: {
	image?: ModelTypes["ImageLinkUpdateImageEntityRelationInput"] | undefined,
	link?: ModelTypes["ImageLinkUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["ImageLinkUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageLinkUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["ImageLinkUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["ImageLinkUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageLinkUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["ImageLinkItemUpsertItemRelationInput"]: {
	update: ModelTypes["ImageLinkUpdateInput"],
	create: ModelTypes["ImageLinkCreateInput"]
};
	["ImageLinkListUpsertItemsRelationInput"]: {
	by: ModelTypes["ImageLinkItemUniqueWhere"],
	update: ModelTypes["ImageLinkItemWithoutListUpdateInput"],
	create: ModelTypes["ImageLinkItemWithoutListCreateInput"]
};
	["FooterLocaleUpsertImageLinkListRelationInput"]: {
	update: ModelTypes["ImageLinkListUpdateInput"],
	create: ModelTypes["ImageLinkListCreateInput"]
};
	["LocaleUpsertFootersRelationInput"]: {
	by: ModelTypes["FooterLocaleUniqueWhere"],
	update: ModelTypes["FooterLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]: {
	create?: ModelTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateGenericPageAboutSettingsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertGenericPageAboutSettingsRelationInput"] | undefined,
	connect?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGenericPageAboutSettingsRelationInput"]: {
	by: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	data: ModelTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined,
	linkGroups?: Array<ModelTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageAboutSettingsUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageAboutSettingsLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GenericPageAboutSettingsWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"],
	create: ModelTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"]
};
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]: {
	create?: ModelTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | undefined,
	update?: ModelTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"] | undefined,
	upsert?: ModelTypes["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"] | undefined,
	connect?: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"]: {
	by: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	data: ModelTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"]
};
	["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"]: {
	order?: number | undefined,
	linkList?: ModelTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"]: {
	connect?: ModelTypes["LinkListUniqueWhere"] | undefined,
	create?: ModelTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"] | undefined,
	update?: ModelTypes["LinkListUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"]: {
	update: ModelTypes["LinkListUpdateInput"],
	create: ModelTypes["LinkListCreateInput"]
};
	["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"]: {
	by: ModelTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	update: ModelTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"],
	create: ModelTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]
};
	["LocaleUpsertGenericPageAboutSettingsRelationInput"]: {
	by: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	update: ModelTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdatePostRevisionsEntityRelationInput"]: {
	create?: ModelTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdatePostRevisionsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertPostRevisionsRelationInput"] | undefined,
	connect?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePostRevisionsRelationInput"]: {
	by: ModelTypes["PostRevisionLocaleUniqueWhere"],
	data: ModelTypes["PostRevisionLocaleWithoutLocaleUpdateInput"]
};
	["PostRevisionLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["PostRevisionLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined,
	leadContent?: ModelTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	create?: ModelTypes["PostRevisionWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["PostRevisionWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostRevisionWithoutLocalesUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	createdById?: ModelTypes["UUID"] | undefined,
	publishedById?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["PostType"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	post?: ModelTypes["PostRevisionUpdatePostEntityRelationInput"] | undefined,
	tileImage?: ModelTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined,
	tileVideo?: ModelTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined,
	heroImage?: ModelTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined,
	regionListOverride?: ModelTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionUpdatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutRevisionsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreatePostRelationInput"] | undefined,
	update?: ModelTypes["PostWithoutRevisionsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionUpsertPostRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostWithoutRevisionsUpdateInput"]: {
	organization?: ModelTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateActiveRevisionEntityRelationInput"]: {
	connect?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	create?: ModelTypes["PostRevisionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateActiveRevisionRelationInput"] | undefined,
	update?: ModelTypes["PostRevisionUpdateInput"] | undefined,
	upsert?: ModelTypes["PostUpsertActiveRevisionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	createdById?: ModelTypes["UUID"] | undefined,
	publishedById?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["PostType"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	post?: ModelTypes["PostRevisionUpdatePostEntityRelationInput"] | undefined,
	tileImage?: ModelTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined,
	tileVideo?: ModelTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined,
	heroImage?: ModelTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostRevisionUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionUpdateTileImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateTileImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionUpsertTileImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpsertTileImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostRevisionUpdateTileVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateTileVideoRelationInput"] | undefined,
	update?: ModelTypes["VideoUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionUpsertTileVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpsertTileVideoRelationInput"]: {
	update: ModelTypes["VideoUpdateInput"],
	create: ModelTypes["VideoCreateInput"]
};
	["PostRevisionUpdateHeroImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateHeroImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionUpsertHeroImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpsertHeroImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostRevisionUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["PostRevisionLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["PostRevisionUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["PostRevisionUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostRevisionUpdateLocalesRelationInput"]: {
	by: ModelTypes["PostRevisionLocaleUniqueWhere"],
	data: ModelTypes["PostRevisionLocaleWithoutRootUpdateInput"]
};
	["PostRevisionLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	locale?: ModelTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined,
	leadContent?: ModelTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutPostRevisionsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutPostRevisionsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPostRevisionsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateFlagImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateFlagImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertFlagImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LocaleUpsertFlagImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleUpdateFeedPagesEntityRelationInput"]: {
	create?: ModelTypes["FeedPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateFeedPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertFeedPagesRelationInput"] | undefined,
	connect?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateFeedPagesRelationInput"]: {
	by: ModelTypes["FeedPageLocaleUniqueWhere"],
	data: ModelTypes["FeedPageLocaleWithoutLocaleUpdateInput"]
};
	["FeedPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined,
	heroTiles?: ModelTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<ModelTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined,
	cardList?: ModelTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["FeedPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["FeedPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FeedPageWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["FeedPageWithoutLocalesUpdateInput"],
	create: ModelTypes["FeedPageWithoutLocalesCreateInput"]
};
	["FeedPageLocaleUpdateHeroTilesEntityRelationInput"]: {
	connect?: ModelTypes["TileListUniqueWhere"] | undefined,
	create?: ModelTypes["TileListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"] | undefined,
	update?: ModelTypes["TileListUpdateInput"] | undefined,
	upsert?: ModelTypes["FeedPageLocaleUpsertHeroTilesRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileListUpdateInput"]: {
	size?: ModelTypes["TileListSize"] | undefined,
	title?: string | undefined,
	items?: Array<ModelTypes["TileListUpdateItemsEntityRelationInput"]> | undefined,
	areaType?: ModelTypes["TileListUpdateAreaTypeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["TileItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["TileListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["TileListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["TileItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TileItemUniqueWhere"] | undefined,
	delete?: ModelTypes["TileItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TileListUpdateItemsRelationInput"]: {
	by: ModelTypes["TileItemUniqueWhere"],
	data: ModelTypes["TileItemWithoutListUpdateInput"]
};
	["TileItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	type?: ModelTypes["TileItemType"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	post?: ModelTypes["TileItemUpdatePostEntityRelationInput"] | undefined,
	area?: ModelTypes["TileItemUpdateAreaEntityRelationInput"] | undefined,
	image?: ModelTypes["TileItemUpdateImageEntityRelationInput"] | undefined,
	link?: ModelTypes["TileItemUpdateLinkEntityRelationInput"] | undefined,
	organization?: ModelTypes["TileItemUpdateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemUpdatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreatePostRelationInput"] | undefined,
	update?: ModelTypes["PostUpdateInput"] | undefined,
	upsert?: ModelTypes["TileItemUpsertPostRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostUpdateInput"]: {
	organization?: ModelTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateRevisionsEntityRelationInput"]: {
	create?: ModelTypes["PostRevisionWithoutPostCreateInput"] | undefined,
	update?: ModelTypes["PostUpdateRevisionsRelationInput"] | undefined,
	upsert?: ModelTypes["PostUpsertRevisionsRelationInput"] | undefined,
	connect?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	delete?: ModelTypes["PostRevisionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateRevisionsRelationInput"]: {
	by: ModelTypes["PostRevisionUniqueWhere"],
	data: ModelTypes["PostRevisionWithoutPostUpdateInput"]
};
	["PostRevisionWithoutPostUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	createdById?: ModelTypes["UUID"] | undefined,
	publishedById?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["PostType"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	tileImage?: ModelTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined,
	tileVideo?: ModelTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined,
	heroImage?: ModelTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostRevisionUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionUpdateRegionListOverrideEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"] | undefined,
	update?: ModelTypes["DonationAmountsRegionListUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionUpsertRegionListOverrideRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpsertRegionListOverrideRelationInput"]: {
	update: ModelTypes["DonationAmountsRegionListUpdateInput"],
	create: ModelTypes["DonationAmountsRegionListCreateInput"]
};
	["PostUpsertRevisionsRelationInput"]: {
	by: ModelTypes["PostRevisionUniqueWhere"],
	update: ModelTypes["PostRevisionWithoutPostUpdateInput"],
	create: ModelTypes["PostRevisionWithoutPostCreateInput"]
};
	["PostUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["PostLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["PostUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["PostUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["PostLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateLocalesRelationInput"]: {
	by: ModelTypes["PostLocaleUniqueWhere"],
	data: ModelTypes["PostLocaleWithoutRootUpdateInput"]
};
	["PostLocaleWithoutRootUpdateInput"]: {
	content?: ModelTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutPostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutPostUpdateInput"] | undefined,
	upsert?: ModelTypes["PostLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutPostUpdateInput"]: {
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdatePostOrganizationEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreatePostOrganizationRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertPostOrganizationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationLocaleWithoutLinkUpdateInput"]: {
	name?: string | undefined,
	description?: string | undefined,
	root?: ModelTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	domain?: ModelTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: ModelTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutPostOrganizationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutPostOrganizationsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPostOrganizationsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]: {
	create?: ModelTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateRecurringPaymentPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertRecurringPaymentPagesRelationInput"] | undefined,
	connect?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateRecurringPaymentPagesRelationInput"]: {
	by: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"],
	data: ModelTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"]
};
	["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"] | undefined,
	favouritePosts?: ModelTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["RecurringPaymentPageUniqueWhere"] | undefined,
	create?: ModelTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["RecurringPaymentPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["RecurringPaymentPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["RecurringPaymentPageWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["RecurringPaymentPageWithoutLocalesUpdateInput"],
	create: ModelTypes["RecurringPaymentPageWithoutLocalesCreateInput"]
};
	["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"]: {
	connect?: ModelTypes["PostListUniqueWhere"] | undefined,
	create?: ModelTypes["PostListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"] | undefined,
	update?: ModelTypes["PostListUpdateInput"] | undefined,
	upsert?: ModelTypes["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostListUpdateInput"]: {
	items?: Array<ModelTypes["PostListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["PostListItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["PostListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["PostListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["PostListItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostListItemUniqueWhere"] | undefined,
	delete?: ModelTypes["PostListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostListUpdateItemsRelationInput"]: {
	by: ModelTypes["PostListItemUniqueWhere"],
	data: ModelTypes["PostListItemWithoutListUpdateInput"]
};
	["PostListItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	post?: ModelTypes["PostListItemUpdatePostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemUpdatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostListItemConnectOrCreatePostRelationInput"] | undefined,
	update?: ModelTypes["PostUpdateInput"] | undefined,
	upsert?: ModelTypes["PostListItemUpsertPostRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostListItemUpsertPostRelationInput"]: {
	update: ModelTypes["PostUpdateInput"],
	create: ModelTypes["PostCreateInput"]
};
	["PostListUpsertItemsRelationInput"]: {
	by: ModelTypes["PostListItemUniqueWhere"],
	update: ModelTypes["PostListItemWithoutListUpdateInput"],
	create: ModelTypes["PostListItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"]: {
	update: ModelTypes["PostListUpdateInput"],
	create: ModelTypes["PostListCreateInput"]
};
	["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined,
	update?: ModelTypes["StoryGuideListUpdateInput"] | undefined,
	upsert?: ModelTypes["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StoryGuideListUpdateInput"]: {
	items?: Array<ModelTypes["StoryGuideListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["StoryGuideItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["StoryGuideListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["StoryGuideListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["StoryGuideItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["StoryGuideItemUniqueWhere"] | undefined,
	delete?: ModelTypes["StoryGuideItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StoryGuideListUpdateItemsRelationInput"]: {
	by: ModelTypes["StoryGuideItemUniqueWhere"],
	data: ModelTypes["StoryGuideItemWithoutListUpdateInput"]
};
	["StoryGuideItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	guide?: ModelTypes["StoryGuideItemUpdateGuideEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemUpdateGuideEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideItemConnectOrCreateGuideRelationInput"] | undefined,
	update?: ModelTypes["StoryGuideUpdateInput"] | undefined,
	upsert?: ModelTypes["StoryGuideItemUpsertGuideRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StoryGuideUpdateInput"]: {
	mediaType?: ModelTypes["MediaType"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	image?: ModelTypes["StoryGuideUpdateImageEntityRelationInput"] | undefined,
	secondaryImage?: ModelTypes["StoryGuideUpdateSecondaryImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["StoryGuideUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StoryGuideUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["StoryGuideUpdateSecondaryImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["StoryGuideUpsertSecondaryImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StoryGuideUpsertSecondaryImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["StoryGuideItemUpsertGuideRelationInput"]: {
	update: ModelTypes["StoryGuideUpdateInput"],
	create: ModelTypes["StoryGuideCreateInput"]
};
	["StoryGuideListUpsertItemsRelationInput"]: {
	by: ModelTypes["StoryGuideItemUniqueWhere"],
	update: ModelTypes["StoryGuideItemWithoutListUpdateInput"],
	create: ModelTypes["StoryGuideItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"]: {
	update: ModelTypes["StoryGuideListUpdateInput"],
	create: ModelTypes["StoryGuideListCreateInput"]
};
	["LocaleUpsertRecurringPaymentPagesRelationInput"]: {
	by: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"],
	update: ModelTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGivenGiftsPagesEntityRelationInput"]: {
	create?: ModelTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateGivenGiftsPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertGivenGiftsPagesRelationInput"] | undefined,
	connect?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGivenGiftsPagesRelationInput"]: {
	by: ModelTypes["GivenGiftsPageLocaleUniqueWhere"],
	data: ModelTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"]
};
	["GivenGiftsPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["GivenGiftsPageUniqueWhere"] | undefined,
	create?: ModelTypes["GivenGiftsPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["GivenGiftsPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["GivenGiftsPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GivenGiftsPageWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["GivenGiftsPageWithoutLocalesUpdateInput"],
	create: ModelTypes["GivenGiftsPageWithoutLocalesCreateInput"]
};
	["GivenGiftsPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["GivenGiftsPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GivenGiftsPageLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["GivenGiftsPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GivenGiftsPageLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutGivenGiftsPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutGivenGiftsPageUpdateInput"] | undefined,
	upsert?: ModelTypes["GivenGiftsPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutGivenGiftsPageUpdateInput"]: {
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateReportPageEntityRelationInput"]: {
	connect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReportPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateReportPageRelationInput"] | undefined,
	update?: ModelTypes["ReportPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertReportPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReportPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	root?: ModelTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	posts?: Array<ModelTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["ReportPageUniqueWhere"] | undefined,
	create?: ModelTypes["ReportPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["ReportPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["ReportPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ReportPageWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["ReportPageWithoutLocalesUpdateInput"],
	create: ModelTypes["ReportPageWithoutLocalesCreateInput"]
};
	["ReportPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutReportPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutReportPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["ReportPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutReportPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]: {
	create?: ModelTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateReceivedGiftsPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertReceivedGiftsPagesRelationInput"] | undefined,
	connect?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateReceivedGiftsPagesRelationInput"]: {
	by: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	data: ModelTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"]
};
	["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: ModelTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutReceivedGiftsPageUpdateInput"] | undefined,
	upsert?: ModelTypes["ReceivedGiftsPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutReceivedGiftsPageUpdateInput"]: {
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateGivenGiftsPageEntityRelationInput"]: {
	connect?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"] | undefined,
	update?: ModelTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertGivenGiftsPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GivenGiftsPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutGivenGiftsPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["GivenGiftsPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGivenGiftsPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateReportPagesEntityRelationInput"]: {
	create?: ModelTypes["ReportPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateReportPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertReportPagesRelationInput"] | undefined,
	connect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateReportPagesRelationInput"]: {
	by: ModelTypes["ReportPageLocaleUniqueWhere"],
	data: ModelTypes["ReportPageLocaleWithoutLocaleUpdateInput"]
};
	["ReportPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	posts?: Array<ModelTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutReportPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutReportPageUpdateInput"] | undefined,
	upsert?: ModelTypes["ReportPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutReportPageUpdateInput"]: {
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: ModelTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateReceivedGiftsPageEntityRelationInput"]: {
	connect?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"] | undefined,
	update?: ModelTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertReceivedGiftsPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["ReceivedGiftsPageUniqueWhere"] | undefined,
	create?: ModelTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["ReceivedGiftsPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ReceivedGiftsPageWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"],
	create: ModelTypes["ReceivedGiftsPageWithoutLocalesCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutReceivedGiftsPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateReportNavigationsEntityRelationInput"]: {
	create?: ModelTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateReportNavigationsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertReportNavigationsRelationInput"] | undefined,
	connect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateReportNavigationsRelationInput"]: {
	by: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	data: ModelTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"]
};
	["ReportNavigationLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined,
	pages?: Array<ModelTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleUpdatePagesEntityRelationInput"]: {
	create?: ModelTypes["GenericPageWithoutReportNavigationCreateInput"] | undefined,
	update?: ModelTypes["ReportNavigationLocaleUpdatePagesRelationInput"] | undefined,
	upsert?: ModelTypes["ReportNavigationLocaleUpsertPagesRelationInput"] | undefined,
	connect?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	delete?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationLocaleUpdatePagesRelationInput"]: {
	by: ModelTypes["GenericPageUniqueWhere"],
	data: ModelTypes["GenericPageWithoutReportNavigationUpdateInput"]
};
	["GenericPageWithoutReportNavigationUpdateInput"]: {
	locales?: Array<ModelTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined,
	type?: ModelTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["GenericPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["GenericPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["GenericPageLocaleUniqueWhere"],
	data: ModelTypes["GenericPageLocaleWithoutRootUpdateInput"]
};
	["GenericPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	locale?: ModelTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutGenericPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutGenericPageUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutGenericPageUpdateInput"]: {
	url?: string | undefined,
	post?: ModelTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: ModelTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: ModelTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: ModelTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: ModelTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: ModelTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutGenericPageUpdateInput"],
	create: ModelTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["GenericPageLocaleUniqueWhere"],
	update: ModelTypes["GenericPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["ReportNavigationLocaleUpsertPagesRelationInput"]: {
	by: ModelTypes["GenericPageUniqueWhere"],
	update: ModelTypes["GenericPageWithoutReportNavigationUpdateInput"],
	create: ModelTypes["GenericPageWithoutReportNavigationCreateInput"]
};
	["LocaleUpsertReportNavigationsRelationInput"]: {
	by: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	update: ModelTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["ReportNavigationLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateScheduledNotificationsEntityRelationInput"]: {
	create?: ModelTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateScheduledNotificationsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertScheduledNotificationsRelationInput"] | undefined,
	connect?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateScheduledNotificationsRelationInput"]: {
	by: ModelTypes["ScheduledNotificationLocaleUniqueWhere"],
	data: ModelTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"]
};
	["ScheduledNotificationLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	description?: string | undefined,
	root?: ModelTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["ScheduledNotificationUniqueWhere"] | undefined,
	create?: ModelTypes["ScheduledNotificationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["ScheduledNotificationWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["ScheduledNotificationLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ScheduledNotificationWithoutLocalesUpdateInput"]: {
	localMsFromMidnight?: number | undefined,
	scheduledDate?: ModelTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: ModelTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined,
	image?: ModelTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined,
	completedAt?: ModelTypes["DateTime"] | undefined,
	processedNotifications?: Array<ModelTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationUpdateTargetEntityRelationInput"]: {
	connect?: ModelTypes["NotificationTargetGroupUniqueWhere"] | undefined,
	create?: ModelTypes["NotificationTargetGroupCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"] | undefined,
	update?: ModelTypes["NotificationTargetGroupUpdateInput"] | undefined,
	upsert?: ModelTypes["ScheduledNotificationUpsertTargetRelationInput"] | undefined
};
	["NotificationTargetGroupUpdateInput"]: {
	type?: ModelTypes["NotificationTargetType"] | undefined,
	regions?: Array<ModelTypes["NotificationTargetGroupUpdateRegionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["NotificationTargetGroupUpdateRegionsEntityRelationInput"]: {
	create?: ModelTypes["RegionCreateInput"] | undefined,
	update?: ModelTypes["NotificationTargetGroupUpdateRegionsRelationInput"] | undefined,
	upsert?: ModelTypes["NotificationTargetGroupUpsertRegionsRelationInput"] | undefined,
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	disconnect?: ModelTypes["RegionUniqueWhere"] | undefined,
	delete?: ModelTypes["RegionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["NotificationTargetGroupUpdateRegionsRelationInput"]: {
	by: ModelTypes["RegionUniqueWhere"],
	data: ModelTypes["RegionUpdateInput"]
};
	["NotificationTargetGroupUpsertRegionsRelationInput"]: {
	by: ModelTypes["RegionUniqueWhere"],
	update: ModelTypes["RegionUpdateInput"],
	create: ModelTypes["RegionCreateInput"]
};
	["ScheduledNotificationUpsertTargetRelationInput"]: {
	update: ModelTypes["NotificationTargetGroupUpdateInput"],
	create: ModelTypes["NotificationTargetGroupCreateInput"]
};
	["ScheduledNotificationUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["ScheduledNotificationUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ScheduledNotificationUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]: {
	create?: ModelTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | undefined,
	update?: ModelTypes["ScheduledNotificationUpdateProcessedNotificationsRelationInput"] | undefined,
	upsert?: ModelTypes["ScheduledNotificationUpsertProcessedNotificationsRelationInput"] | undefined,
	connect?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	delete?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ScheduledNotificationUpdateProcessedNotificationsRelationInput"]: {
	by: ModelTypes["ProcessedNotificationSourceUniqueWhere"],
	data: ModelTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"]
};
	["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"]: {
	type?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined,
	donationReminderUser?: ModelTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"]: {
	connect?: ModelTypes["ProcessedNotificationUniqueWhere"] | undefined,
	create?: ModelTypes["ProcessedNotificationWithoutSourceCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"] | undefined,
	update?: ModelTypes["ProcessedNotificationWithoutSourceUpdateInput"] | undefined,
	upsert?: ModelTypes["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProcessedNotificationWithoutSourceUpdateInput"]: {
	topic?: string | undefined,
	sentAt?: ModelTypes["DateTime"] | undefined,
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess?: boolean | undefined,
	title?: string | undefined,
	body?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"]: {
	update: ModelTypes["ProcessedNotificationWithoutSourceUpdateInput"],
	create: ModelTypes["ProcessedNotificationWithoutSourceCreateInput"]
};
	["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutProcessedNotificationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"] | undefined,
	update?: ModelTypes["UserWithoutProcessedNotificationsUpdateInput"] | undefined,
	upsert?: ModelTypes["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutProcessedNotificationsUpdateInput"]: {
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdatePaymentsEntityRelationInput"]: {
	create?: ModelTypes["UserPaymentWithoutUserCreateInput"] | undefined,
	update?: ModelTypes["UserUpdatePaymentsRelationInput"] | undefined,
	upsert?: ModelTypes["UserUpsertPaymentsRelationInput"] | undefined,
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	delete?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdatePaymentsRelationInput"]: {
	by: ModelTypes["UserPaymentUniqueWhere"],
	data: ModelTypes["UserPaymentWithoutUserUpdateInput"]
};
	["UserPaymentWithoutUserUpdateInput"]: {
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: ModelTypes["CurrencyUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertCurrencyRelationInput"] | undefined
};
	["UserPaymentUpsertCurrencyRelationInput"]: {
	update: ModelTypes["CurrencyUpdateInput"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["UserPaymentUpdateOrderEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentOrderIdUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentOrderIdCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateOrderRelationInput"] | undefined,
	update?: ModelTypes["UserPaymentOrderIdUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertOrderRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentOrderIdUpdateInput"]: {
	seq?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpsertOrderRelationInput"]: {
	update: ModelTypes["UserPaymentOrderIdUpdateInput"],
	create: ModelTypes["UserPaymentOrderIdCreateInput"]
};
	["UserPaymentUpdateCsobPaymentEntityRelationInput"]: {
	connect?: ModelTypes["CsobPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["CsobPaymentWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"] | undefined,
	update?: ModelTypes["CsobPaymentWithoutPaymentUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertCsobPaymentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CsobPaymentWithoutPaymentUpdateInput"]: {
	payId?: string | undefined,
	statusChanges?: Array<ModelTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"]> | undefined,
	originalPayId?: string | undefined,
	metadata?: ModelTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentUpdateStatusChangesEntityRelationInput"]: {
	create?: ModelTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | undefined,
	update?: ModelTypes["CsobPaymentUpdateStatusChangesRelationInput"] | undefined,
	upsert?: ModelTypes["CsobPaymentUpsertStatusChangesRelationInput"] | undefined,
	connect?: ModelTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	disconnect?: ModelTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	delete?: ModelTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CsobPaymentUpdateStatusChangesRelationInput"]: {
	by: ModelTypes["CsobPaymentStatusChangeUniqueWhere"],
	data: ModelTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"]
};
	["CsobPaymentStatusChangeWithoutPaymentUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	dttm?: string | undefined,
	status?: number | undefined,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentUpsertStatusChangesRelationInput"]: {
	by: ModelTypes["CsobPaymentStatusChangeUniqueWhere"],
	update: ModelTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"],
	create: ModelTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"]
};
	["CsobPaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ModelTypes["CsobPaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentUpsertCsobPaymentRelationInput"]: {
	update: ModelTypes["CsobPaymentWithoutPaymentUpdateInput"],
	create: ModelTypes["CsobPaymentWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateStripePaymentEntityRelationInput"]: {
	connect?: ModelTypes["StripePaymentUniqueWhere"] | undefined,
	create?: ModelTypes["StripePaymentWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"] | undefined,
	update?: ModelTypes["StripePaymentWithoutPaymentUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertStripePaymentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StripePaymentWithoutPaymentUpdateInput"]: {
	identifier?: string | undefined,
	statusChanges?: Array<ModelTypes["StripePaymentUpdateStatusChangesEntityRelationInput"]> | undefined,
	metadata?: ModelTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentUpdateStatusChangesEntityRelationInput"]: {
	create?: ModelTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | undefined,
	update?: ModelTypes["StripePaymentUpdateStatusChangesRelationInput"] | undefined,
	upsert?: ModelTypes["StripePaymentUpsertStatusChangesRelationInput"] | undefined,
	connect?: ModelTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	disconnect?: ModelTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	delete?: ModelTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StripePaymentUpdateStatusChangesRelationInput"]: {
	by: ModelTypes["StripePaymentStatusChangeUniqueWhere"],
	data: ModelTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"]
};
	["StripePaymentStatusChangeWithoutPaymentUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	timestamp?: number | undefined,
	eventId?: string | undefined,
	paymentIntentStatus?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentUpsertStatusChangesRelationInput"]: {
	by: ModelTypes["StripePaymentStatusChangeUniqueWhere"],
	update: ModelTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"],
	create: ModelTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"]
};
	["StripePaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ModelTypes["StripePaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentUpsertStripePaymentRelationInput"]: {
	update: ModelTypes["StripePaymentWithoutPaymentUpdateInput"],
	create: ModelTypes["StripePaymentWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	create?: ModelTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"] | undefined,
	update?: ModelTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertRecurringPaymentItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentItemWithoutPaymentsUpdateInput"]: {
	recurrenceCounter?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"] | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: ModelTypes["DateTime"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserRecurringPaymentWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"] | undefined,
	update?: ModelTypes["UserRecurringPaymentWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentWithoutItemsUpdateInput"]: {
	activeSince?: ModelTypes["DateTime"] | undefined,
	cancelledAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: ModelTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	user?: ModelTypes["UserRecurringPaymentUpdateUserEntityRelationInput"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentUpdateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: ModelTypes["CurrencyUpdateInput"] | undefined,
	upsert?: ModelTypes["UserRecurringPaymentUpsertCurrencyRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentUpsertCurrencyRelationInput"]: {
	update: ModelTypes["CurrencyUpdateInput"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["UserRecurringPaymentUpdateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutRecurringPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"] | undefined,
	update?: ModelTypes["UserWithoutRecurringPaymentsUpdateInput"] | undefined,
	upsert?: ModelTypes["UserRecurringPaymentUpsertUserRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutRecurringPaymentsUpdateInput"]: {
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<ModelTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateRegionRelationInput"] | undefined,
	update?: ModelTypes["RegionUpdateInput"] | undefined,
	upsert?: ModelTypes["UserUpsertRegionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserUpsertRegionRelationInput"]: {
	update: ModelTypes["RegionUpdateInput"],
	create: ModelTypes["RegionCreateInput"]
};
	["UserUpdateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: ModelTypes["CurrencyUpdateInput"] | undefined,
	upsert?: ModelTypes["UserUpsertCurrencyRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserUpsertCurrencyRelationInput"]: {
	update: ModelTypes["CurrencyUpdateInput"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["UserUpdateOnBehalfDonationsEntityRelationInput"]: {
	create?: ModelTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | undefined,
	update?: ModelTypes["UserUpdateOnBehalfDonationsRelationInput"] | undefined,
	upsert?: ModelTypes["UserUpsertOnBehalfDonationsRelationInput"] | undefined,
	connect?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	disconnect?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	delete?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateOnBehalfDonationsRelationInput"]: {
	by: ModelTypes["OnBehalfDonationUniqueWhere"],
	data: ModelTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"]
};
	["OnBehalfDonationWithoutOnBehalfOfUpdateInput"]: {
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	payments?: Array<ModelTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"]> | undefined,
	meta?: ModelTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OnBehalfDonationUpdatePaymentsEntityRelationInput"]: {
	create?: ModelTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | undefined,
	update?: ModelTypes["OnBehalfDonationUpdatePaymentsRelationInput"] | undefined,
	upsert?: ModelTypes["OnBehalfDonationUpsertPaymentsRelationInput"] | undefined,
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	delete?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OnBehalfDonationUpdatePaymentsRelationInput"]: {
	by: ModelTypes["UserPaymentUniqueWhere"],
	data: ModelTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"]
};
	["UserPaymentWithoutOnBehalfDonationUpdateInput"]: {
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	triesCollection?: ModelTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpdateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateRegionRelationInput"] | undefined,
	update?: ModelTypes["RegionUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertRegionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentUpsertRegionRelationInput"]: {
	update: ModelTypes["RegionUpdateInput"],
	create: ModelTypes["RegionCreateInput"]
};
	["UserPaymentUpdateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateUserRelationInput"] | undefined,
	update?: ModelTypes["UserWithoutPaymentsUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertUserRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutPaymentsUpdateInput"]: {
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<ModelTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateRecurringPaymentsEntityRelationInput"]: {
	create?: ModelTypes["UserRecurringPaymentWithoutUserCreateInput"] | undefined,
	update?: ModelTypes["UserUpdateRecurringPaymentsRelationInput"] | undefined,
	upsert?: ModelTypes["UserUpsertRecurringPaymentsRelationInput"] | undefined,
	connect?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	delete?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateRecurringPaymentsRelationInput"]: {
	by: ModelTypes["UserRecurringPaymentUniqueWhere"],
	data: ModelTypes["UserRecurringPaymentWithoutUserUpdateInput"]
};
	["UserRecurringPaymentWithoutUserUpdateInput"]: {
	activeSince?: ModelTypes["DateTime"] | undefined,
	cancelledAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: ModelTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	items?: Array<ModelTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"]> | undefined,
	meta?: ModelTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | undefined,
	update?: ModelTypes["UserRecurringPaymentUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["UserRecurringPaymentUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	delete?: ModelTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserRecurringPaymentUpdateItemsRelationInput"]: {
	by: ModelTypes["UserRecurringPaymentItemUniqueWhere"],
	data: ModelTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"]
};
	["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"]: {
	recurrenceCounter?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	payments?: Array<ModelTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]> | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: ModelTypes["DateTime"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]: {
	create?: ModelTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | undefined,
	update?: ModelTypes["UserRecurringPaymentItemUpdatePaymentsRelationInput"] | undefined,
	upsert?: ModelTypes["UserRecurringPaymentItemUpsertPaymentsRelationInput"] | undefined,
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	delete?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserRecurringPaymentItemUpdatePaymentsRelationInput"]: {
	by: ModelTypes["UserPaymentUniqueWhere"],
	data: ModelTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"]
};
	["UserPaymentWithoutRecurringPaymentItemUpdateInput"]: {
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpdateOnBehalfDonationEntityRelationInput"]: {
	connect?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: ModelTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"] | undefined,
	update?: ModelTypes["OnBehalfDonationWithoutPaymentsUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertOnBehalfDonationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OnBehalfDonationWithoutPaymentsUpdateInput"]: {
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	onBehalfOf?: ModelTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"] | undefined,
	meta?: ModelTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutOnBehalfDonationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"] | undefined,
	update?: ModelTypes["UserWithoutOnBehalfDonationsUpdateInput"] | undefined,
	upsert?: ModelTypes["OnBehalfDonationUpsertOnBehalfOfRelationInput"] | undefined
};
	["UserWithoutOnBehalfDonationsUpdateInput"]: {
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<ModelTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["UserUpsertLocaleRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LocaleUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateSentPaymentsEntityRelationInput"]: {
	create?: ModelTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateSentPaymentsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertSentPaymentsRelationInput"] | undefined,
	connect?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateSentPaymentsRelationInput"]: {
	by: ModelTypes["SentPaymentLocaleUniqueWhere"],
	data: ModelTypes["SentPaymentLocaleWithoutLocaleUpdateInput"]
};
	["SentPaymentLocaleWithoutLocaleUpdateInput"]: {
	organizationText?: string | undefined,
	root?: ModelTypes["SentPaymentLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["SentPaymentWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["SentPaymentWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["SentPaymentLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["SentPaymentWithoutLocalesUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: ModelTypes["DateTime"] | undefined,
	currency?: ModelTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	area?: ModelTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined,
	organization?: ModelTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentUpdateAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SentPaymentConnectOrCreateAreaRelationInput"] | undefined,
	update?: ModelTypes["PostAreaWithoutSentPaymentsUpdateInput"] | undefined,
	upsert?: ModelTypes["SentPaymentUpsertAreaRelationInput"] | undefined
};
	["PostAreaWithoutSentPaymentsUpdateInput"]: {
	order?: number | undefined,
	icon?: ModelTypes["PostAreaUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: ModelTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<ModelTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: ModelTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined,
	meta?: ModelTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: ModelTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: ModelTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined,
	areaSentPaymentCurrencySums?: Array<ModelTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: ModelTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<ModelTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: ModelTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	delete?: ModelTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	delete?: ModelTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdateAreaSumEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaSumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SentPaymentUpsertAreaRelationInput"]: {
	update: ModelTypes["PostAreaWithoutSentPaymentsUpdateInput"],
	create: ModelTypes["PostAreaWithoutSentPaymentsCreateInput"]
};
	["SentPaymentLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["SentPaymentWithoutLocalesUpdateInput"],
	create: ModelTypes["SentPaymentWithoutLocalesCreateInput"]
};
	["LocaleUpsertSentPaymentsRelationInput"]: {
	by: ModelTypes["SentPaymentLocaleUniqueWhere"],
	update: ModelTypes["SentPaymentLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["SentPaymentLocaleWithoutLocaleCreateInput"]
};
	["UserUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleUpdateInput"],
	create: ModelTypes["LocaleCreateInput"]
};
	["UserUpdateDevicesEntityRelationInput"]: {
	create?: ModelTypes["DeviceWithoutUserCreateInput"] | undefined,
	update?: ModelTypes["UserUpdateDevicesRelationInput"] | undefined,
	upsert?: ModelTypes["UserUpsertDevicesRelationInput"] | undefined,
	connect?: ModelTypes["DeviceUniqueWhere"] | undefined,
	disconnect?: ModelTypes["DeviceUniqueWhere"] | undefined,
	delete?: ModelTypes["DeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateDevicesRelationInput"]: {
	by: ModelTypes["DeviceUniqueWhere"],
	data: ModelTypes["DeviceWithoutUserUpdateInput"]
};
	["DeviceWithoutUserUpdateInput"]: {
	fcmToken?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpsertDevicesRelationInput"]: {
	by: ModelTypes["DeviceUniqueWhere"],
	update: ModelTypes["DeviceWithoutUserUpdateInput"],
	create: ModelTypes["DeviceWithoutUserCreateInput"]
};
	["UserUpdateProcessedNotificationsEntityRelationInput"]: {
	create?: ModelTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | undefined,
	update?: ModelTypes["UserUpdateProcessedNotificationsRelationInput"] | undefined,
	upsert?: ModelTypes["UserUpsertProcessedNotificationsRelationInput"] | undefined,
	connect?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	delete?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateProcessedNotificationsRelationInput"]: {
	by: ModelTypes["ProcessedNotificationSourceUniqueWhere"],
	data: ModelTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"]
};
	["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"]: {
	type?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined,
	scheduledNotification?: ModelTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"]: {
	connect?: ModelTypes["ScheduledNotificationUniqueWhere"] | undefined,
	create?: ModelTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"] | undefined,
	update?: ModelTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"] | undefined,
	upsert?: ModelTypes["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"]: {
	localMsFromMidnight?: number | undefined,
	scheduledDate?: ModelTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: ModelTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"]> | undefined,
	image?: ModelTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined,
	completedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["ScheduledNotificationUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["ScheduledNotificationUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ScheduledNotificationUpdateLocalesRelationInput"]: {
	by: ModelTypes["ScheduledNotificationLocaleUniqueWhere"],
	data: ModelTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"]
};
	["ScheduledNotificationLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	description?: string | undefined,
	locale?: ModelTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutScheduledNotificationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutScheduledNotificationsUpdateInput"] | undefined,
	upsert?: ModelTypes["ScheduledNotificationLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutScheduledNotificationsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutScheduledNotificationsUpdateInput"],
	create: ModelTypes["LocaleWithoutScheduledNotificationsCreateInput"]
};
	["ScheduledNotificationUpsertLocalesRelationInput"]: {
	by: ModelTypes["ScheduledNotificationLocaleUniqueWhere"],
	update: ModelTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"],
	create: ModelTypes["ScheduledNotificationLocaleWithoutRootCreateInput"]
};
	["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"]: {
	update: ModelTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"],
	create: ModelTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]
};
	["UserUpsertProcessedNotificationsRelationInput"]: {
	by: ModelTypes["ProcessedNotificationSourceUniqueWhere"],
	update: ModelTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"],
	create: ModelTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]
};
	["UserUpdateAreaStatsEntityRelationInput"]: {
	connect?: ModelTypes["UserAreaStatsUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserAreaStatsUniqueWhere"] | undefined,
	delete?: ModelTypes["UserAreaStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateOrganizationStatsEntityRelationInput"]: {
	connect?: ModelTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	delete?: ModelTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdatePostStatsEntityRelationInput"]: {
	connect?: ModelTypes["UserPostStatsUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserPostStatsUniqueWhere"] | undefined,
	delete?: ModelTypes["UserPostStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateCurrencyStatsEntityRelationInput"]: {
	connect?: ModelTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	delete?: ModelTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OnBehalfDonationUpsertOnBehalfOfRelationInput"]: {
	update: ModelTypes["UserWithoutOnBehalfDonationsUpdateInput"],
	create: ModelTypes["UserWithoutOnBehalfDonationsCreateInput"]
};
	["OnBehalfDonationUpdateMetaEntityRelationInput"]: {
	connect?: ModelTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentUpsertOnBehalfDonationRelationInput"]: {
	update: ModelTypes["OnBehalfDonationWithoutPaymentsUpdateInput"],
	create: ModelTypes["OnBehalfDonationWithoutPaymentsCreateInput"]
};
	["UserPaymentUpdateTriesCollectionEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"] | undefined,
	update?: ModelTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentUpsertTriesCollectionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentTriesCollectionWithoutPaymentUpdateInput"]: {
	cents?: number | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	orderUrl?: string | undefined,
	user?: ModelTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"] | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	recurring?: ModelTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"] | undefined,
	metadataLocales?: Array<ModelTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]> | undefined,
	medium?: ModelTypes["PaymentMedium"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpdateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"] | undefined,
	update?: ModelTypes["UserUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentTriesCollectionUpsertUserRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserUpdateInput"]: {
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<ModelTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<ModelTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpsertUserRelationInput"]: {
	update: ModelTypes["UserUpdateInput"],
	create: ModelTypes["UserCreateInput"]
};
	["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: ModelTypes["CurrencyUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentTriesCollectionUpsertCurrencyRelationInput"] | undefined
};
	["UserPaymentTriesCollectionUpsertCurrencyRelationInput"]: {
	update: ModelTypes["CurrencyUpdateInput"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"]: {
	connect?: ModelTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: ModelTypes["OnBehalfDonationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"] | undefined,
	update?: ModelTypes["OnBehalfDonationUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OnBehalfDonationUpdateInput"]: {
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	payments?: Array<ModelTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"]> | undefined,
	onBehalfOf?: ModelTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"] | undefined,
	meta?: ModelTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"]: {
	update: ModelTypes["OnBehalfDonationUpdateInput"],
	create: ModelTypes["OnBehalfDonationCreateInput"]
};
	["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserRecurringPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"] | undefined,
	update?: ModelTypes["UserRecurringPaymentUpdateInput"] | undefined,
	upsert?: ModelTypes["UserPaymentTriesCollectionUpsertRecurringRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentUpdateInput"]: {
	activeSince?: ModelTypes["DateTime"] | undefined,
	cancelledAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: ModelTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: ModelTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	items?: Array<ModelTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"]> | undefined,
	user?: ModelTypes["UserRecurringPaymentUpdateUserEntityRelationInput"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentUpdateMetaEntityRelationInput"]: {
	connect?: ModelTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentTriesCollectionUpsertRecurringRelationInput"]: {
	update: ModelTypes["UserRecurringPaymentUpdateInput"],
	create: ModelTypes["UserRecurringPaymentCreateInput"]
};
	["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserPaymentUpsertTriesCollectionRelationInput"]: {
	update: ModelTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"],
	create: ModelTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateMetadataEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentItemUpsertPaymentsRelationInput"]: {
	by: ModelTypes["UserPaymentUniqueWhere"],
	update: ModelTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"],
	create: ModelTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"]
};
	["UserRecurringPaymentItemUpdateMetaEntityRelationInput"]: {
	connect?: ModelTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentUpsertItemsRelationInput"]: {
	by: ModelTypes["UserRecurringPaymentItemUniqueWhere"],
	update: ModelTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"],
	create: ModelTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]
};
	["UserUpsertRecurringPaymentsRelationInput"]: {
	by: ModelTypes["UserRecurringPaymentUniqueWhere"],
	update: ModelTypes["UserRecurringPaymentWithoutUserUpdateInput"],
	create: ModelTypes["UserRecurringPaymentWithoutUserCreateInput"]
};
	["UserPaymentUpsertUserRelationInput"]: {
	update: ModelTypes["UserWithoutPaymentsUpdateInput"],
	create: ModelTypes["UserWithoutPaymentsCreateInput"]
};
	["OnBehalfDonationUpsertPaymentsRelationInput"]: {
	by: ModelTypes["UserPaymentUniqueWhere"],
	update: ModelTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"],
	create: ModelTypes["UserPaymentWithoutOnBehalfDonationCreateInput"]
};
	["UserUpsertOnBehalfDonationsRelationInput"]: {
	by: ModelTypes["OnBehalfDonationUniqueWhere"],
	update: ModelTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"],
	create: ModelTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"]
};
	["UserRecurringPaymentUpsertUserRelationInput"]: {
	update: ModelTypes["UserWithoutRecurringPaymentsUpdateInput"],
	create: ModelTypes["UserWithoutRecurringPaymentsCreateInput"]
};
	["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"]: {
	update: ModelTypes["UserRecurringPaymentWithoutItemsUpdateInput"],
	create: ModelTypes["UserRecurringPaymentWithoutItemsCreateInput"]
};
	["UserPaymentUpsertRecurringPaymentItemRelationInput"]: {
	update: ModelTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"],
	create: ModelTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"]
};
	["UserUpsertPaymentsRelationInput"]: {
	by: ModelTypes["UserPaymentUniqueWhere"],
	update: ModelTypes["UserPaymentWithoutUserUpdateInput"],
	create: ModelTypes["UserPaymentWithoutUserCreateInput"]
};
	["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"]: {
	update: ModelTypes["UserWithoutProcessedNotificationsUpdateInput"],
	create: ModelTypes["UserWithoutProcessedNotificationsCreateInput"]
};
	["ScheduledNotificationUpsertProcessedNotificationsRelationInput"]: {
	by: ModelTypes["ProcessedNotificationSourceUniqueWhere"],
	update: ModelTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"],
	create: ModelTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]
};
	["ScheduledNotificationLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["ScheduledNotificationWithoutLocalesUpdateInput"],
	create: ModelTypes["ScheduledNotificationWithoutLocalesCreateInput"]
};
	["LocaleUpsertScheduledNotificationsRelationInput"]: {
	by: ModelTypes["ScheduledNotificationLocaleUniqueWhere"],
	update: ModelTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"]
};
	["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutReceivedGiftsPagesCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["ReceivedGiftsPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["ReceivedGiftsPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["LinkableUpsertReceivedGiftsPageRelationInput"]: {
	update: ModelTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReportPageLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutReportPageUpdateInput"],
	create: ModelTypes["LinkableWithoutReportPageCreateInput"]
};
	["ReportPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["ReportPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReportPageLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["ReportPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["ReportPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReportPageLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["ReportPageLocaleUpdatePostsEntityRelationInput"]: {
	create?: ModelTypes["PostWithoutReportPageCreateInput"] | undefined,
	update?: ModelTypes["ReportPageLocaleUpdatePostsRelationInput"] | undefined,
	upsert?: ModelTypes["ReportPageLocaleUpsertPostsRelationInput"] | undefined,
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostUniqueWhere"] | undefined,
	delete?: ModelTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReportPageLocaleUpdatePostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	data: ModelTypes["PostWithoutReportPageUpdateInput"]
};
	["PostWithoutReportPageUpdateInput"]: {
	organization?: ModelTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateMetaEntityRelationInput"]: {
	connect?: ModelTypes["PostMetaDataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostUpdateHeroCarouselEntityRelationInput"]: {
	create?: ModelTypes["HeroCarouselWithoutPostsCreateInput"] | undefined,
	update?: ModelTypes["PostUpdateHeroCarouselRelationInput"] | undefined,
	upsert?: ModelTypes["PostUpsertHeroCarouselRelationInput"] | undefined,
	connect?: ModelTypes["HeroCarouselUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HeroCarouselUniqueWhere"] | undefined,
	delete?: ModelTypes["HeroCarouselUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateHeroCarouselRelationInput"]: {
	by: ModelTypes["HeroCarouselUniqueWhere"],
	data: ModelTypes["HeroCarouselWithoutPostsUpdateInput"]
};
	["HeroCarouselWithoutPostsUpdateInput"]: {
	createdAt?: ModelTypes["Date"] | undefined,
	items?: Array<ModelTypes["HeroCarouselUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["HeroCarouselItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["HeroCarouselUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["HeroCarouselUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["HeroCarouselItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HeroCarouselItemUniqueWhere"] | undefined,
	delete?: ModelTypes["HeroCarouselItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeroCarouselUpdateItemsRelationInput"]: {
	by: ModelTypes["HeroCarouselItemUniqueWhere"],
	data: ModelTypes["HeroCarouselItemWithoutListUpdateInput"]
};
	["HeroCarouselItemWithoutListUpdateInput"]: {
	createdAt?: ModelTypes["Date"] | undefined,
	order?: number | undefined,
	item?: ModelTypes["HeroCarouselItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemUpdateItemEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeroCarouselItemConnectOrCreateItemRelationInput"] | undefined,
	update?: ModelTypes["PostUpdateInput"] | undefined,
	upsert?: ModelTypes["HeroCarouselItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeroCarouselItemUpsertItemRelationInput"]: {
	update: ModelTypes["PostUpdateInput"],
	create: ModelTypes["PostCreateInput"]
};
	["HeroCarouselUpsertItemsRelationInput"]: {
	by: ModelTypes["HeroCarouselItemUniqueWhere"],
	update: ModelTypes["HeroCarouselItemWithoutListUpdateInput"],
	create: ModelTypes["HeroCarouselItemWithoutListCreateInput"]
};
	["PostUpsertHeroCarouselRelationInput"]: {
	by: ModelTypes["HeroCarouselUniqueWhere"],
	update: ModelTypes["HeroCarouselWithoutPostsUpdateInput"],
	create: ModelTypes["HeroCarouselWithoutPostsCreateInput"]
};
	["PostUpdateContentEntityRelationInput"]: {
	create?: ModelTypes["ContentReferenceWithoutPostsCreateInput"] | undefined,
	update?: ModelTypes["PostUpdateContentRelationInput"] | undefined,
	upsert?: ModelTypes["PostUpsertContentRelationInput"] | undefined,
	connect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	delete?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateContentRelationInput"]: {
	by: ModelTypes["ContentReferenceUniqueWhere"],
	data: ModelTypes["ContentReferenceWithoutPostsUpdateInput"]
};
	["ContentReferenceWithoutPostsUpdateInput"]: {
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: ModelTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined,
	image?: ModelTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	video?: ModelTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	contentAlignment?: ModelTypes["ContentAlignment"] | undefined,
	valueList?: ModelTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined,
	areaList?: ModelTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: ModelTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	memberList?: ModelTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: ModelTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: ModelTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: ModelTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: ModelTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	textImageList?: ModelTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	connect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	create?: ModelTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined,
	update?: ModelTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertBlockRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?: number | undefined,
	json?: string | undefined,
	content?: ModelTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentWithoutBlocksCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentWithoutBlocksUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentBlockUpsertContentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpsertContentRelationInput"]: {
	update: ModelTypes["ContentWithoutBlocksUpdateInput"],
	create: ModelTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update: ModelTypes["ContentBlockWithoutReferencesUpdateInput"],
	create: ModelTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateValueListEntityRelationInput"]: {
	connect?: ModelTypes["ValueListUniqueWhere"] | undefined,
	create?: ModelTypes["ValueListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateValueListRelationInput"] | undefined,
	update?: ModelTypes["ValueListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertValueListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ValueListUpdateInput"]: {
	items?: Array<ModelTypes["ValueListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["ValueItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["ValueListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["ValueListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["ValueItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ValueItemUniqueWhere"] | undefined,
	delete?: ModelTypes["ValueItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ValueListUpdateItemsRelationInput"]: {
	by: ModelTypes["ValueItemUniqueWhere"],
	data: ModelTypes["ValueItemWithoutListUpdateInput"]
};
	["ValueItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	item?: ModelTypes["ValueItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemUpdateItemEntityRelationInput"]: {
	connect?: ModelTypes["ValueUniqueWhere"] | undefined,
	create?: ModelTypes["ValueCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ValueItemConnectOrCreateItemRelationInput"] | undefined,
	update?: ModelTypes["ValueUpdateInput"] | undefined,
	upsert?: ModelTypes["ValueItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ValueUpdateInput"]: {
	title?: string | undefined,
	textContent?: ModelTypes["ValueUpdateTextContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueUpdateTextContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ValueConnectOrCreateTextContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["ValueUpsertTextContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ValueUpsertTextContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["ValueItemUpsertItemRelationInput"]: {
	update: ModelTypes["ValueUpdateInput"],
	create: ModelTypes["ValueCreateInput"]
};
	["ValueListUpsertItemsRelationInput"]: {
	by: ModelTypes["ValueItemUniqueWhere"],
	update: ModelTypes["ValueItemWithoutListUpdateInput"],
	create: ModelTypes["ValueItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertValueListRelationInput"]: {
	update: ModelTypes["ValueListUpdateInput"],
	create: ModelTypes["ValueListCreateInput"]
};
	["ContentReferenceUpdateImageLinkListEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"] | undefined,
	update?: ModelTypes["ImageLinkListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertImageLinkListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertImageLinkListRelationInput"]: {
	update: ModelTypes["ImageLinkListUpdateInput"],
	create: ModelTypes["ImageLinkListCreateInput"]
};
	["ContentReferenceUpdateAreaListEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaListUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateAreaListRelationInput"] | undefined,
	update?: ModelTypes["PostAreaListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertAreaListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaListUpdateInput"]: {
	items?: Array<ModelTypes["PostAreaListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["PostAreaListItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["PostAreaListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["PostAreaListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["PostAreaListItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostAreaListItemUniqueWhere"] | undefined,
	delete?: ModelTypes["PostAreaListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaListUpdateItemsRelationInput"]: {
	by: ModelTypes["PostAreaListItemUniqueWhere"],
	data: ModelTypes["PostAreaListItemWithoutListUpdateInput"]
};
	["PostAreaListItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	item?: ModelTypes["PostAreaListItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemUpdateItemEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaListItemConnectOrCreateItemRelationInput"] | undefined,
	update?: ModelTypes["PostAreaUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaListItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaListItemUpsertItemRelationInput"]: {
	update: ModelTypes["PostAreaUpdateInput"],
	create: ModelTypes["PostAreaCreateInput"]
};
	["PostAreaListUpsertItemsRelationInput"]: {
	by: ModelTypes["PostAreaListItemUniqueWhere"],
	update: ModelTypes["PostAreaListItemWithoutListUpdateInput"],
	create: ModelTypes["PostAreaListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertAreaListRelationInput"]: {
	update: ModelTypes["PostAreaListUpdateInput"],
	create: ModelTypes["PostAreaListCreateInput"]
};
	["ContentReferenceUpdateAccordionEntityRelationInput"]: {
	connect?: ModelTypes["AccordionUniqueWhere"] | undefined,
	create?: ModelTypes["AccordionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateAccordionRelationInput"] | undefined,
	update?: ModelTypes["AccordionUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertAccordionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AccordionUpdateInput"]: {
	items?: Array<ModelTypes["AccordionUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["AccordionItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["AccordionUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["AccordionUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["AccordionItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["AccordionItemUniqueWhere"] | undefined,
	delete?: ModelTypes["AccordionItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AccordionUpdateItemsRelationInput"]: {
	by: ModelTypes["AccordionItemUniqueWhere"],
	data: ModelTypes["AccordionItemWithoutListUpdateInput"]
};
	["AccordionItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	name?: string | undefined,
	descriptionContent?: ModelTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemUpdateDescriptionContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["AccordionItemUpsertDescriptionContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AccordionItemUpsertDescriptionContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["AccordionUpsertItemsRelationInput"]: {
	by: ModelTypes["AccordionItemUniqueWhere"],
	update: ModelTypes["AccordionItemWithoutListUpdateInput"],
	create: ModelTypes["AccordionItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertAccordionRelationInput"]: {
	update: ModelTypes["AccordionUpdateInput"],
	create: ModelTypes["AccordionCreateInput"]
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined,
	update?: ModelTypes["MediumListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertMediaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumListUpdateInput"]: {
	items?: Array<ModelTypes["MediumListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["MediumItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["MediumListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["MediumListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["MediumItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["MediumItemUniqueWhere"] | undefined,
	delete?: ModelTypes["MediumItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MediumListUpdateItemsRelationInput"]: {
	by: ModelTypes["MediumItemUniqueWhere"],
	data: ModelTypes["MediumItemWithoutListUpdateInput"]
};
	["MediumItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	medium?: ModelTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
	connect?: ModelTypes["MediumUniqueWhere"] | undefined,
	create?: ModelTypes["MediumCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined,
	update?: ModelTypes["MediumUpdateInput"] | undefined,
	upsert?: ModelTypes["MediumItemUpsertMediumRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpdateInput"]: {
	type?: ModelTypes["MediumType"] | undefined,
	image?: ModelTypes["MediumUpdateImageEntityRelationInput"] | undefined,
	video?: ModelTypes["MediumUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["MediumUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumConnectOrCreateVideoRelationInput"] | undefined,
	update?: ModelTypes["VideoUpdateInput"] | undefined,
	upsert?: ModelTypes["MediumUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpsertVideoRelationInput"]: {
	update: ModelTypes["VideoUpdateInput"],
	create: ModelTypes["VideoCreateInput"]
};
	["MediumItemUpsertMediumRelationInput"]: {
	update: ModelTypes["MediumUpdateInput"],
	create: ModelTypes["MediumCreateInput"]
};
	["MediumListUpsertItemsRelationInput"]: {
	by: ModelTypes["MediumItemUniqueWhere"],
	update: ModelTypes["MediumItemWithoutListUpdateInput"],
	create: ModelTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMediaRelationInput"]: {
	update: ModelTypes["MediumListUpdateInput"],
	create: ModelTypes["MediumListCreateInput"]
};
	["ContentReferenceUpdateMemberListEntityRelationInput"]: {
	connect?: ModelTypes["MemberListUniqueWhere"] | undefined,
	create?: ModelTypes["MemberListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateMemberListRelationInput"] | undefined,
	update?: ModelTypes["MemberListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertMemberListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MemberListUpdateInput"]: {
	items?: Array<ModelTypes["MemberListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["MemberListItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["MemberListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["MemberListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["MemberListItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["MemberListItemUniqueWhere"] | undefined,
	delete?: ModelTypes["MemberListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MemberListUpdateItemsRelationInput"]: {
	by: ModelTypes["MemberListItemUniqueWhere"],
	data: ModelTypes["MemberListItemWithoutListUpdateInput"]
};
	["MemberListItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	name?: string | undefined,
	position?: string | undefined,
	image?: ModelTypes["MemberListItemUpdateImageEntityRelationInput"] | undefined,
	descriptionContent?: ModelTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MemberListItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["MemberListItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MemberListItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["MemberListItemUpdateDescriptionContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["MemberListItemUpsertDescriptionContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MemberListItemUpsertDescriptionContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["MemberListUpsertItemsRelationInput"]: {
	by: ModelTypes["MemberListItemUniqueWhere"],
	update: ModelTypes["MemberListItemWithoutListUpdateInput"],
	create: ModelTypes["MemberListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMemberListRelationInput"]: {
	update: ModelTypes["MemberListUpdateInput"],
	create: ModelTypes["MemberListCreateInput"]
};
	["ContentReferenceUpdateFormEntityRelationInput"]: {
	connect?: ModelTypes["FormUniqueWhere"] | undefined,
	create?: ModelTypes["FormCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateFormRelationInput"] | undefined,
	update?: ModelTypes["FormUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FormUpdateInput"]: {
	name?: string | undefined,
	type?: ModelTypes["FormType"] | undefined,
	tax?: ModelTypes["FormUpdateTaxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FormUpdateTaxEntityRelationInput"]: {
	connect?: ModelTypes["FilledTaxFormUniqueWhere"] | undefined,
	create?: ModelTypes["FilledTaxFormCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FormConnectOrCreateTaxRelationInput"] | undefined,
	update?: ModelTypes["FilledTaxFormUpdateInput"] | undefined,
	upsert?: ModelTypes["FormUpsertTaxRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FilledTaxFormUpdateInput"]: {
	publishedAt?: ModelTypes["DateTime"] | undefined,
	userId?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	vatId?: string | undefined,
	address1?: string | undefined,
	address2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	state?: string | undefined,
	country?: ModelTypes["FilledTaxFormUpdateCountryEntityRelationInput"] | undefined,
	dateFrom?: ModelTypes["Date"] | undefined,
	dateTo?: ModelTypes["Date"] | undefined,
	year?: number | undefined,
	isPdfGenerated?: boolean | undefined,
	pdfObjectKey?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FilledTaxFormUpdateCountryEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FilledTaxFormConnectOrCreateCountryRelationInput"] | undefined,
	update?: ModelTypes["RegionUpdateInput"] | undefined,
	upsert?: ModelTypes["FilledTaxFormUpsertCountryRelationInput"] | undefined
};
	["FilledTaxFormUpsertCountryRelationInput"]: {
	update: ModelTypes["RegionUpdateInput"],
	create: ModelTypes["RegionCreateInput"]
};
	["FormUpsertTaxRelationInput"]: {
	update: ModelTypes["FilledTaxFormUpdateInput"],
	create: ModelTypes["FilledTaxFormCreateInput"]
};
	["ContentReferenceUpsertFormRelationInput"]: {
	update: ModelTypes["FormUpdateInput"],
	create: ModelTypes["FormCreateInput"]
};
	["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertContentWithoutBlocksRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertContentWithoutBlocksRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["ContentReferenceUpdateHeroCarouselEntityRelationInput"]: {
	connect?: ModelTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["HeroCarouselCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"] | undefined,
	update?: ModelTypes["HeroCarouselUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertHeroCarouselRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeroCarouselUpdateInput"]: {
	createdAt?: ModelTypes["Date"] | undefined,
	posts?: Array<ModelTypes["HeroCarouselUpdatePostsEntityRelationInput"]> | undefined,
	items?: Array<ModelTypes["HeroCarouselUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselUpdatePostsEntityRelationInput"]: {
	create?: ModelTypes["PostWithoutHeroCarouselCreateInput"] | undefined,
	update?: ModelTypes["HeroCarouselUpdatePostsRelationInput"] | undefined,
	upsert?: ModelTypes["HeroCarouselUpsertPostsRelationInput"] | undefined,
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostUniqueWhere"] | undefined,
	delete?: ModelTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeroCarouselUpdatePostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	data: ModelTypes["PostWithoutHeroCarouselUpdateInput"]
};
	["PostWithoutHeroCarouselUpdateInput"]: {
	organization?: ModelTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	reportPage?: Array<ModelTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateReportPageEntityRelationInput"]: {
	create?: ModelTypes["ReportPageLocaleWithoutPostsCreateInput"] | undefined,
	update?: ModelTypes["PostUpdateReportPageRelationInput"] | undefined,
	upsert?: ModelTypes["PostUpsertReportPageRelationInput"] | undefined,
	connect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateReportPageRelationInput"]: {
	by: ModelTypes["ReportPageLocaleUniqueWhere"],
	data: ModelTypes["ReportPageLocaleWithoutPostsUpdateInput"]
};
	["ReportPageLocaleWithoutPostsUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpsertReportPageRelationInput"]: {
	by: ModelTypes["ReportPageLocaleUniqueWhere"],
	update: ModelTypes["ReportPageLocaleWithoutPostsUpdateInput"],
	create: ModelTypes["ReportPageLocaleWithoutPostsCreateInput"]
};
	["PostUpdateFundraiseCurrencyEntityRelationInput"]: {
	connect?: ModelTypes["CurrencyUniqueWhere"] | undefined,
	create?: ModelTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"] | undefined,
	update?: ModelTypes["CurrencyUpdateInput"] | undefined,
	upsert?: ModelTypes["PostUpsertFundraiseCurrencyRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostUpsertFundraiseCurrencyRelationInput"]: {
	update: ModelTypes["CurrencyUpdateInput"],
	create: ModelTypes["CurrencyCreateInput"]
};
	["PostUpdateFundraiseCurrencySumsEntityRelationInput"]: {
	connect?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	delete?: ModelTypes["PostCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateFundraiseSumEntityRelationInput"]: {
	connect?: ModelTypes["PostSumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostUpdateFundraisingProgressEntityRelationInput"]: {
	connect?: ModelTypes["PostFundraisingProgressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeroCarouselUpsertPostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	update: ModelTypes["PostWithoutHeroCarouselUpdateInput"],
	create: ModelTypes["PostWithoutHeroCarouselCreateInput"]
};
	["ContentReferenceUpsertHeroCarouselRelationInput"]: {
	update: ModelTypes["HeroCarouselUpdateInput"],
	create: ModelTypes["HeroCarouselCreateInput"]
};
	["ContentReferenceUpdateOrganizationListEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertOrganizationListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertOrganizationListRelationInput"]: {
	update: ModelTypes["PostOrganizationListUpdateInput"],
	create: ModelTypes["PostOrganizationListCreateInput"]
};
	["ContentReferenceUpdateTextImageListEntityRelationInput"]: {
	connect?: ModelTypes["TextImageListUniqueWhere"] | undefined,
	create?: ModelTypes["TextImageListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"] | undefined,
	update?: ModelTypes["TextImageListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertTextImageListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextImageListUpdateInput"]: {
	items?: Array<ModelTypes["TextImageListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["TextImageListItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["TextImageListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["TextImageListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["TextImageListItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TextImageListItemUniqueWhere"] | undefined,
	delete?: ModelTypes["TextImageListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TextImageListUpdateItemsRelationInput"]: {
	by: ModelTypes["TextImageListItemUniqueWhere"],
	data: ModelTypes["TextImageListItemWithoutListUpdateInput"]
};
	["TextImageListItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	image?: ModelTypes["TextImageListItemUpdateImageEntityRelationInput"] | undefined,
	text?: string | undefined,
	link?: ModelTypes["TextImageListItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextImageListItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["TextImageListItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextImageListItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["TextImageListItemUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextImageListItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["TextImageListItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextImageListItemUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["TextImageListUpsertItemsRelationInput"]: {
	by: ModelTypes["TextImageListItemUniqueWhere"],
	update: ModelTypes["TextImageListItemWithoutListUpdateInput"],
	create: ModelTypes["TextImageListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertTextImageListRelationInput"]: {
	update: ModelTypes["TextImageListUpdateInput"],
	create: ModelTypes["TextImageListCreateInput"]
};
	["PostUpsertContentRelationInput"]: {
	by: ModelTypes["ContentReferenceUniqueWhere"],
	update: ModelTypes["ContentReferenceWithoutPostsUpdateInput"],
	create: ModelTypes["ContentReferenceWithoutPostsCreateInput"]
};
	["ReportPageLocaleUpsertPostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	update: ModelTypes["PostWithoutReportPageUpdateInput"],
	create: ModelTypes["PostWithoutReportPageCreateInput"]
};
	["LocaleUpsertReportPagesRelationInput"]: {
	by: ModelTypes["ReportPageLocaleUniqueWhere"],
	update: ModelTypes["ReportPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["ReportPageLocaleWithoutLocaleCreateInput"]
};
	["GivenGiftsPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutGivenGiftsPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutGivenGiftsPagesCreateInput"]
};
	["LinkableUpsertGivenGiftsPageRelationInput"]: {
	update: ModelTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReceivedGiftsPageLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutReceivedGiftsPageUpdateInput"],
	create: ModelTypes["LinkableWithoutReceivedGiftsPageCreateInput"]
};
	["LocaleUpsertReceivedGiftsPagesRelationInput"]: {
	by: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	update: ModelTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["ReportPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutReportPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutReportPagesCreateInput"]
};
	["LinkableUpsertReportPageRelationInput"]: {
	update: ModelTypes["ReportPageLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["ReportPageLocaleWithoutLinkCreateInput"]
};
	["GivenGiftsPageLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutGivenGiftsPageUpdateInput"],
	create: ModelTypes["LinkableWithoutGivenGiftsPageCreateInput"]
};
	["LocaleUpsertGivenGiftsPagesRelationInput"]: {
	by: ModelTypes["GivenGiftsPageLocaleUniqueWhere"],
	update: ModelTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["PostOrganizationLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutPostOrganizationsUpdateInput"],
	create: ModelTypes["LocaleWithoutPostOrganizationsCreateInput"]
};
	["PostOrganizationLocaleUpdateDomainEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationLocaleUpsertDomainRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationLocaleUpsertDomainRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["PostOrganizationLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["PostOrganizationLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["LinkableUpsertPostOrganizationRelationInput"]: {
	update: ModelTypes["PostOrganizationLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["PostOrganizationLocaleWithoutLinkCreateInput"]
};
	["PostLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutPostUpdateInput"],
	create: ModelTypes["LinkableWithoutPostCreateInput"]
};
	["PostUpsertLocalesRelationInput"]: {
	by: ModelTypes["PostLocaleUniqueWhere"],
	update: ModelTypes["PostLocaleWithoutRootUpdateInput"],
	create: ModelTypes["PostLocaleWithoutRootCreateInput"]
};
	["TileItemUpsertPostRelationInput"]: {
	update: ModelTypes["PostUpdateInput"],
	create: ModelTypes["PostCreateInput"]
};
	["TileItemUpdateAreaEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateAreaRelationInput"] | undefined,
	update?: ModelTypes["PostAreaUpdateInput"] | undefined,
	upsert?: ModelTypes["TileItemUpsertAreaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileItemUpsertAreaRelationInput"]: {
	update: ModelTypes["PostAreaUpdateInput"],
	create: ModelTypes["PostAreaCreateInput"]
};
	["TileItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["TileItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["TileItemUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["TileItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileItemUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["TileItemUpdateOrganizationEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateOrganizationRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationUpdateInput"] | undefined,
	upsert?: ModelTypes["TileItemUpsertOrganizationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileItemUpsertOrganizationRelationInput"]: {
	update: ModelTypes["PostOrganizationUpdateInput"],
	create: ModelTypes["PostOrganizationCreateInput"]
};
	["TileListUpsertItemsRelationInput"]: {
	by: ModelTypes["TileItemUniqueWhere"],
	update: ModelTypes["TileItemWithoutListUpdateInput"],
	create: ModelTypes["TileItemWithoutListCreateInput"]
};
	["TileListUpdateAreaTypeEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileListConnectOrCreateAreaTypeRelationInput"] | undefined,
	update?: ModelTypes["PostAreaUpdateInput"] | undefined,
	upsert?: ModelTypes["TileListUpsertAreaTypeRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileListUpsertAreaTypeRelationInput"]: {
	update: ModelTypes["PostAreaUpdateInput"],
	create: ModelTypes["PostAreaCreateInput"]
};
	["FeedPageLocaleUpsertHeroTilesRelationInput"]: {
	update: ModelTypes["TileListUpdateInput"],
	create: ModelTypes["TileListCreateInput"]
};
	["FeedPageLocaleUpdateSectionListEntityRelationInput"]: {
	create?: ModelTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | undefined,
	update?: ModelTypes["FeedPageLocaleUpdateSectionListRelationInput"] | undefined,
	upsert?: ModelTypes["FeedPageLocaleUpsertSectionListRelationInput"] | undefined,
	connect?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined,
	delete?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FeedPageLocaleUpdateSectionListRelationInput"]: {
	by: ModelTypes["FeedPageSectionUniqueWhere"],
	data: ModelTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"]
};
	["FeedPageSectionWithoutFeedPageLocaleUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	tileStripeList?: Array<ModelTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionUpdateTileStripeListEntityRelationInput"]: {
	create?: ModelTypes["FeedPageTileStripeWithoutSectionCreateInput"] | undefined,
	update?: ModelTypes["FeedPageSectionUpdateTileStripeListRelationInput"] | undefined,
	upsert?: ModelTypes["FeedPageSectionUpsertTileStripeListRelationInput"] | undefined,
	connect?: ModelTypes["FeedPageTileStripeUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FeedPageTileStripeUniqueWhere"] | undefined,
	delete?: ModelTypes["FeedPageTileStripeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FeedPageSectionUpdateTileStripeListRelationInput"]: {
	by: ModelTypes["FeedPageTileStripeUniqueWhere"],
	data: ModelTypes["FeedPageTileStripeWithoutSectionUpdateInput"]
};
	["FeedPageTileStripeWithoutSectionUpdateInput"]: {
	order?: number | undefined,
	tileList?: ModelTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeUpdateTileListEntityRelationInput"]: {
	connect?: ModelTypes["TileListUniqueWhere"] | undefined,
	create?: ModelTypes["TileListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"] | undefined,
	update?: ModelTypes["TileListUpdateInput"] | undefined,
	upsert?: ModelTypes["FeedPageTileStripeUpsertTileListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FeedPageTileStripeUpsertTileListRelationInput"]: {
	update: ModelTypes["TileListUpdateInput"],
	create: ModelTypes["TileListCreateInput"]
};
	["FeedPageSectionUpsertTileStripeListRelationInput"]: {
	by: ModelTypes["FeedPageTileStripeUniqueWhere"],
	update: ModelTypes["FeedPageTileStripeWithoutSectionUpdateInput"],
	create: ModelTypes["FeedPageTileStripeWithoutSectionCreateInput"]
};
	["FeedPageLocaleUpsertSectionListRelationInput"]: {
	by: ModelTypes["FeedPageSectionUniqueWhere"],
	update: ModelTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"],
	create: ModelTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"]
};
	["FeedPageLocaleUpdateCardListEntityRelationInput"]: {
	connect?: ModelTypes["CardListUniqueWhere"] | undefined,
	create?: ModelTypes["CardListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"] | undefined,
	update?: ModelTypes["CardListUpdateInput"] | undefined,
	upsert?: ModelTypes["FeedPageLocaleUpsertCardListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CardListUpdateInput"]: {
	items?: Array<ModelTypes["CardListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["CardItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["CardListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["CardListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["CardItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["CardItemUniqueWhere"] | undefined,
	delete?: ModelTypes["CardItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CardListUpdateItemsRelationInput"]: {
	by: ModelTypes["CardItemUniqueWhere"],
	data: ModelTypes["CardItemWithoutListUpdateInput"]
};
	["CardItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["CardItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CardItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["CardItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CardItemUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["CardListUpsertItemsRelationInput"]: {
	by: ModelTypes["CardItemUniqueWhere"],
	update: ModelTypes["CardItemWithoutListUpdateInput"],
	create: ModelTypes["CardItemWithoutListCreateInput"]
};
	["FeedPageLocaleUpsertCardListRelationInput"]: {
	update: ModelTypes["CardListUpdateInput"],
	create: ModelTypes["CardListCreateInput"]
};
	["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined,
	update?: ModelTypes["StoryGuideListUpdateInput"] | undefined,
	upsert?: ModelTypes["FeedPageLocaleUpsertStoryGuideListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FeedPageLocaleUpsertStoryGuideListRelationInput"]: {
	update: ModelTypes["StoryGuideListUpdateInput"],
	create: ModelTypes["StoryGuideListCreateInput"]
};
	["LocaleUpsertFeedPagesRelationInput"]: {
	by: ModelTypes["FeedPageLocaleUniqueWhere"],
	update: ModelTypes["FeedPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["FeedPageLocaleWithoutLocaleCreateInput"]
};
	["PostRevisionLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutPostRevisionsUpdateInput"],
	create: ModelTypes["LocaleWithoutPostRevisionsCreateInput"]
};
	["PostRevisionLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["PostRevisionLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["PostRevisionLocaleUpdateLeadContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["PostRevisionLocaleUpsertLeadContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionLocaleUpsertLeadContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["PostRevisionUpsertLocalesRelationInput"]: {
	by: ModelTypes["PostRevisionLocaleUniqueWhere"],
	update: ModelTypes["PostRevisionLocaleWithoutRootUpdateInput"],
	create: ModelTypes["PostRevisionLocaleWithoutRootCreateInput"]
};
	["PostUpsertActiveRevisionRelationInput"]: {
	update: ModelTypes["PostRevisionUpdateInput"],
	create: ModelTypes["PostRevisionCreateInput"]
};
	["PostRevisionUpsertPostRelationInput"]: {
	update: ModelTypes["PostWithoutRevisionsUpdateInput"],
	create: ModelTypes["PostWithoutRevisionsCreateInput"]
};
	["PostRevisionLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["PostRevisionWithoutLocalesUpdateInput"],
	create: ModelTypes["PostRevisionWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostRevisionsRelationInput"]: {
	by: ModelTypes["PostRevisionLocaleUniqueWhere"],
	update: ModelTypes["PostRevisionLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["PostRevisionLocaleWithoutLocaleCreateInput"]
};
	["SentPaymentLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutSentPaymentsUpdateInput"],
	create: ModelTypes["LocaleWithoutSentPaymentsCreateInput"]
};
	["SentPaymentUpsertLocalesRelationInput"]: {
	by: ModelTypes["SentPaymentLocaleUniqueWhere"],
	update: ModelTypes["SentPaymentLocaleWithoutRootUpdateInput"],
	create: ModelTypes["SentPaymentLocaleWithoutRootCreateInput"]
};
	["PostAreaUpsertSentPaymentsRelationInput"]: {
	by: ModelTypes["SentPaymentUniqueWhere"],
	update: ModelTypes["SentPaymentWithoutAreaUpdateInput"],
	create: ModelTypes["SentPaymentWithoutAreaCreateInput"]
};
	["PostOrganizationUpsertAreaRelationInput"]: {
	update: ModelTypes["PostAreaUpdateInput"],
	create: ModelTypes["PostAreaCreateInput"]
};
	["PostOrganizationUpdateSentPaymentsEntityRelationInput"]: {
	create?: ModelTypes["SentPaymentWithoutOrganizationCreateInput"] | undefined,
	update?: ModelTypes["PostOrganizationUpdateSentPaymentsRelationInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationUpsertSentPaymentsRelationInput"] | undefined,
	connect?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	disconnect?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	delete?: ModelTypes["SentPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationUpdateSentPaymentsRelationInput"]: {
	by: ModelTypes["SentPaymentUniqueWhere"],
	data: ModelTypes["SentPaymentWithoutOrganizationUpdateInput"]
};
	["SentPaymentWithoutOrganizationUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: ModelTypes["DateTime"] | undefined,
	currency?: ModelTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	area?: ModelTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpsertSentPaymentsRelationInput"]: {
	by: ModelTypes["SentPaymentUniqueWhere"],
	update: ModelTypes["SentPaymentWithoutOrganizationUpdateInput"],
	create: ModelTypes["SentPaymentWithoutOrganizationCreateInput"]
};
	["PostOrganizationLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["PostOrganizationWithoutLocalesUpdateInput"],
	create: ModelTypes["PostOrganizationWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostOrganizationsRelationInput"]: {
	by: ModelTypes["PostOrganizationLocaleUniqueWhere"],
	update: ModelTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["PostOrganizationLocaleWithoutLocaleCreateInput"]
};
	["PostAreaLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutPostAreasUpdateInput"],
	create: ModelTypes["LocaleWithoutPostAreasCreateInput"]
};
	["PostAreaLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["PostAreaLocaleUpdateBannerEntityRelationInput"]: {
	connect?: ModelTypes["AppBannerUniqueWhere"] | undefined,
	create?: ModelTypes["AppBannerCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"] | undefined,
	update?: ModelTypes["AppBannerUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaLocaleUpsertBannerRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AppBannerUpdateInput"]: {
	title?: string | undefined,
	imageSmall?: ModelTypes["AppBannerUpdateImageSmallEntityRelationInput"] | undefined,
	imageBig?: ModelTypes["AppBannerUpdateImageBigEntityRelationInput"] | undefined,
	textContent?: ModelTypes["AppBannerUpdateTextContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AppBannerUpdateImageSmallEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AppBannerConnectOrCreateImageSmallRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["AppBannerUpsertImageSmallRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AppBannerUpsertImageSmallRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["AppBannerUpdateImageBigEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AppBannerConnectOrCreateImageBigRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["AppBannerUpsertImageBigRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AppBannerUpsertImageBigRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["AppBannerUpdateTextContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AppBannerConnectOrCreateTextContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["AppBannerUpsertTextContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AppBannerUpsertTextContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["PostAreaLocaleUpsertBannerRelationInput"]: {
	update: ModelTypes["AppBannerUpdateInput"],
	create: ModelTypes["AppBannerCreateInput"]
};
	["PostAreaLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["LinkableUpsertPostAreaRelationInput"]: {
	update: ModelTypes["PostAreaLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["PostAreaLocaleWithoutLinkCreateInput"]
};
	["PostOrganizationLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutPostOrganizationUpdateInput"],
	create: ModelTypes["LinkableWithoutPostOrganizationCreateInput"]
};
	["PostOrganizationUpsertLocalesRelationInput"]: {
	by: ModelTypes["PostOrganizationLocaleUniqueWhere"],
	update: ModelTypes["PostOrganizationLocaleWithoutRootUpdateInput"],
	create: ModelTypes["PostOrganizationLocaleWithoutRootCreateInput"]
};
	["PostUpsertOrganizationRelationInput"]: {
	update: ModelTypes["PostOrganizationWithoutPostsUpdateInput"],
	create: ModelTypes["PostOrganizationWithoutPostsCreateInput"]
};
	["PostAreaUpsertPostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	update: ModelTypes["PostWithoutAreaUpdateInput"],
	create: ModelTypes["PostWithoutAreaCreateInput"]
};
	["PostAreaLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["PostAreaWithoutLocalesUpdateInput"],
	create: ModelTypes["PostAreaWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostAreasRelationInput"]: {
	by: ModelTypes["PostAreaLocaleUniqueWhere"],
	update: ModelTypes["PostAreaLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["PostAreaLocaleWithoutLocaleCreateInput"]
};
	["PostLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutPostsUpdateInput"],
	create: ModelTypes["LocaleWithoutPostsCreateInput"]
};
	["PostLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["PostWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["PostLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostWithoutLocalesUpdateInput"]: {
	organization?: ModelTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<ModelTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["PostWithoutLocalesUpdateInput"],
	create: ModelTypes["PostWithoutLocalesCreateInput"]
};
	["LinkableUpsertPostRelationInput"]: {
	update: ModelTypes["PostLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["PostLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update: ModelTypes["LinkableUpdateInput"],
	create: ModelTypes["LinkableCreateInput"]
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["ContentReferenceUpdatePostsEntityRelationInput"]: {
	create?: ModelTypes["PostWithoutContentCreateInput"] | undefined,
	update?: ModelTypes["ContentReferenceUpdatePostsRelationInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertPostsRelationInput"] | undefined,
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PostUniqueWhere"] | undefined,
	delete?: ModelTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceUpdatePostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	data: ModelTypes["PostWithoutContentUpdateInput"]
};
	["PostWithoutContentUpdateInput"]: {
	organization?: ModelTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: ModelTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: ModelTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<ModelTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<ModelTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: ModelTypes["PostState"] | undefined,
	meta?: ModelTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<ModelTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<ModelTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: ModelTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: ModelTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<ModelTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: ModelTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: ModelTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpsertPostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	update: ModelTypes["PostWithoutContentUpdateInput"],
	create: ModelTypes["PostWithoutContentCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by: ModelTypes["ContentReferenceUniqueWhere"],
	update: ModelTypes["ContentReferenceWithoutBlockUpdateInput"],
	create: ModelTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
	by: ModelTypes["ContentBlockUniqueWhere"],
	update: ModelTypes["ContentBlockWithoutContentUpdateInput"],
	create: ModelTypes["ContentBlockWithoutContentCreateInput"]
};
	["PostLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["LocaleUpsertPostsRelationInput"]: {
	by: ModelTypes["PostLocaleUniqueWhere"],
	update: ModelTypes["PostLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["PostLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutGenericPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableUpsertGenericPageRelationInput"]: {
	update: ModelTypes["GenericPageLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["PostAreaLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutPostAreaUpdateInput"],
	create: ModelTypes["LinkableWithoutPostAreaCreateInput"]
};
	["PostAreaUpsertLocalesRelationInput"]: {
	by: ModelTypes["PostAreaLocaleUniqueWhere"],
	update: ModelTypes["PostAreaLocaleWithoutRootUpdateInput"],
	create: ModelTypes["PostAreaLocaleWithoutRootCreateInput"]
};
	["PostUpsertAreaRelationInput"]: {
	update: ModelTypes["PostAreaWithoutPostsUpdateInput"],
	create: ModelTypes["PostAreaWithoutPostsCreateInput"]
};
	["PostOrganizationUpsertPostsRelationInput"]: {
	by: ModelTypes["PostUniqueWhere"],
	update: ModelTypes["PostWithoutOrganizationUpdateInput"],
	create: ModelTypes["PostWithoutOrganizationCreateInput"]
};
	["PostOrganizationListItemUpsertItemRelationInput"]: {
	update: ModelTypes["PostOrganizationUpdateInput"],
	create: ModelTypes["PostOrganizationCreateInput"]
};
	["PostOrganizationListItemUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationListItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationListItemUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["PostOrganizationListItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationListItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationListItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["PostOrganizationListUpsertItemsRelationInput"]: {
	by: ModelTypes["PostOrganizationListItemUniqueWhere"],
	update: ModelTypes["PostOrganizationListItemWithoutListUpdateInput"],
	create: ModelTypes["PostOrganizationListItemWithoutListCreateInput"]
};
	["GeneralUpsertOrganizationListRelationInput"]: {
	update: ModelTypes["PostOrganizationListUpdateInput"],
	create: ModelTypes["PostOrganizationListCreateInput"]
};
	["GeneralLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["GeneralWithoutLocalesUpdateInput"],
	create: ModelTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertAppStoreLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralLocaleUpsertAppStoreLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertGooglePlayLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralLocaleUpsertGooglePlayLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["LocaleUpsertGeneralsRelationInput"]: {
	by: ModelTypes["GeneralLocaleUniqueWhere"],
	update: ModelTypes["GeneralLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["ReportNavigationLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutReportNavigationsUpdateInput"],
	create: ModelTypes["LocaleWithoutReportNavigationsCreateInput"]
};
	["GenericPageUpsertReportNavigationRelationInput"]: {
	by: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	update: ModelTypes["ReportNavigationLocaleWithoutPagesUpdateInput"],
	create: ModelTypes["ReportNavigationLocaleWithoutPagesCreateInput"]
};
	["GenericPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["GenericPageWithoutLocalesUpdateInput"],
	create: ModelTypes["GenericPageWithoutLocalesCreateInput"]
};
	["LocaleUpsertGenericPagesRelationInput"]: {
	by: ModelTypes["GenericPageLocaleUniqueWhere"],
	update: ModelTypes["GenericPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutGeneralsUpdateInput"],
	create: ModelTypes["LocaleWithoutGeneralsCreateInput"]
};
	["GeneralUpsertLocalesRelationInput"]: {
	by: ModelTypes["GeneralLocaleUniqueWhere"],
	update: ModelTypes["GeneralLocaleWithoutRootUpdateInput"],
	create: ModelTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["ImageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageEdge"]>
};
	["ImageEdge"]: {
		node: ModelTypes["Image"]
};
	["GenericPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined,
	type?: ModelTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	reportNavigation?: Array<ModelTypes["GenericPageCreateReportNavigationEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateInput"]: {
	locales?: Array<ModelTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined,
	type?: ModelTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	reportNavigation?: Array<ModelTypes["GenericPageUpdateReportNavigationEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
		node: ModelTypes["Linkable"]
};
	["SeoConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SeoEdge"]>
};
	["SeoEdge"]: {
		node: ModelTypes["Seo"]
};
	["ContentConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContentEdge"]>
};
	["ContentEdge"]: {
		node: ModelTypes["Content"]
};
	["ContentBlockCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: ModelTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	references?: Array<ModelTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateInput"]: {
	order?: number | undefined,
	json?: string | undefined,
	content?: ModelTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	references?: Array<ModelTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: ModelTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined,
	image?: ModelTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	video?: ModelTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	contentAlignment?: ModelTypes["ContentAlignment"] | undefined,
	valueList?: ModelTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined,
	areaList?: ModelTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: ModelTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	memberList?: ModelTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: ModelTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: ModelTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: ModelTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: ModelTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	posts?: Array<ModelTypes["ContentReferenceCreatePostsEntityRelationInput"]> | undefined,
	textImageList?: ModelTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateInput"]: {
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: ModelTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined,
	image?: ModelTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	video?: ModelTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	contentAlignment?: ModelTypes["ContentAlignment"] | undefined,
	valueList?: ModelTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined,
	areaList?: ModelTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: ModelTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	memberList?: ModelTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: ModelTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: ModelTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: ModelTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: ModelTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: ModelTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	posts?: Array<ModelTypes["ContentReferenceUpdatePostsEntityRelationInput"]> | undefined,
	textImageList?: ModelTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	appStoreLink?: ModelTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: ModelTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateInput"]: {
	root?: ModelTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	appStoreLink?: ModelTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: ModelTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
		node: ModelTypes["Locale"]
};
	["VideoConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["VideoEdge"]>
};
	["VideoEdge"]: {
		node: ModelTypes["Video"]
};
	["LinkConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["LinkEdge"]>
};
	["LinkEdge"]: {
		node: ModelTypes["Link"]
};
	["PostLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	content?: ModelTypes["PostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined,
	root?: ModelTypes["PostLocaleCreateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpdateInput"]: {
	content?: ModelTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	root?: ModelTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaEdge"]>
};
	["PostAreaEdge"]: {
		node: ModelTypes["PostArea"]
};
	["PostAreaLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined,
	banner?: ModelTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleUpdateInput"]: {
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined,
	banner?: ModelTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: ModelTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostOrganizationEdge"]>
};
	["PostOrganizationEdge"]: {
		node: ModelTypes["PostOrganization"]
};
	["PostOrganizationLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined,
	domain?: ModelTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: ModelTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleUpdateInput"]: {
	name?: string | undefined,
	description?: string | undefined,
	link?: ModelTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	domain?: ModelTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: ModelTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["DonationEdge"]>
};
	["DonationEdge"]: {
		node: ModelTypes["Donation"]
};
	["DonationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	regionList?: ModelTypes["DonationCreateRegionListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationCreateRegionListEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationConnectOrCreateRegionListRelationInput"] | undefined
};
	["DonationAmountsRegionListWithoutDonationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	regions?: Array<ModelTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationConnectOrCreateRegionListRelationInput"]: {
	connect: ModelTypes["DonationAmountsRegionListUniqueWhere"],
	create: ModelTypes["DonationAmountsRegionListWithoutDonationCreateInput"]
};
	["DonationUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	regionList?: ModelTypes["DonationUpdateRegionListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationUpdateRegionListEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationConnectOrCreateRegionListRelationInput"] | undefined,
	update?: ModelTypes["DonationAmountsRegionListWithoutDonationUpdateInput"] | undefined,
	upsert?: ModelTypes["DonationUpsertRegionListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DonationAmountsRegionListWithoutDonationUpdateInput"]: {
	regions?: Array<ModelTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationUpsertRegionListRelationInput"]: {
	update: ModelTypes["DonationAmountsRegionListWithoutDonationUpdateInput"],
	create: ModelTypes["DonationAmountsRegionListWithoutDonationCreateInput"]
};
	["DonationAmountItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	amount?: number | undefined,
	regionItem?: ModelTypes["DonationAmountItemCreateRegionItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountItemCreateRegionItemEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"] | undefined
};
	["DonationAmountsRegionItemWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined,
	region?: ModelTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountItemConnectOrCreateRegionItemRelationInput"]: {
	connect: ModelTypes["DonationAmountsRegionItemUniqueWhere"],
	create: ModelTypes["DonationAmountsRegionItemWithoutItemsCreateInput"]
};
	["DonationAmountItemUpdateInput"]: {
	order?: number | undefined,
	amount?: number | undefined,
	regionItem?: ModelTypes["DonationAmountItemUpdateRegionItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountItemUpdateRegionItemEntityRelationInput"]: {
	connect?: ModelTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	create?: ModelTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"] | undefined,
	update?: ModelTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["DonationAmountItemUpsertRegionItemRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["DonationAmountsRegionItemWithoutItemsUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined,
	region?: ModelTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountItemUpsertRegionItemRelationInput"]: {
	update: ModelTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"],
	create: ModelTypes["DonationAmountsRegionItemWithoutItemsCreateInput"]
};
	["DonationAmountsRegionItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	items?: Array<ModelTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined,
	list?: ModelTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined,
	region?: ModelTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpdateInput"]: {
	order?: number | undefined,
	items?: Array<ModelTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined,
	list?: ModelTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined,
	region?: ModelTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["DonationAmountsRegionListEdge"]>
};
	["DonationAmountsRegionListEdge"]: {
		node: ModelTypes["DonationAmountsRegionList"]
};
	["LinkItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["LinkItemCreateListEntityRelationInput"] | undefined,
	link?: ModelTypes["LinkItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["LinkListUniqueWhere"] | undefined,
	create?: ModelTypes["LinkListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkItemConnectOrCreateListRelationInput"] | undefined
};
	["LinkListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["LinkListUniqueWhere"],
	create: ModelTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["LinkItemUpdateListEntityRelationInput"] | undefined,
	link?: ModelTypes["LinkItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["LinkListUniqueWhere"] | undefined,
	create?: ModelTypes["LinkListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["LinkListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["LinkItemUpsertListRelationInput"]: {
	update: ModelTypes["LinkListWithoutItemsUpdateInput"],
	create: ModelTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["LinkListEdge"]>
};
	["LinkListEdge"]: {
		node: ModelTypes["LinkList"]
};
	["HeaderConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
		node: ModelTypes["Header"]
};
	["HeaderCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	logo?: ModelTypes["HeaderCreateLogoEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["HeaderCreateLocalesEntityRelationInput"]> | undefined,
	organizationList?: ModelTypes["HeaderCreateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HeaderLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined,
	links?: ModelTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutHeadersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutHeadersCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["HeaderLocaleUniqueWhere"],
	create: ModelTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	logo?: ModelTypes["HeaderUpdateLogoEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["HeaderUpdateLocalesEntityRelationInput"]> | undefined,
	organizationList?: ModelTypes["HeaderUpdateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["HeaderLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["HeaderUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["HeaderUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeaderUpdateLocalesRelationInput"]: {
	by: ModelTypes["HeaderLocaleUniqueWhere"],
	data: ModelTypes["HeaderLocaleWithoutRootUpdateInput"]
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined,
	links?: ModelTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutHeadersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutHeadersUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutHeadersUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutHeadersUpdateInput"],
	create: ModelTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderUpsertLocalesRelationInput"]: {
	by: ModelTypes["HeaderLocaleUniqueWhere"],
	update: ModelTypes["HeaderLocaleWithoutRootUpdateInput"],
	create: ModelTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined,
	links?: ModelTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateInput"]: {
	root?: ModelTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined,
	links?: ModelTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FooterEdge"]>
};
	["FooterEdge"]: {
		node: ModelTypes["Footer"]
};
	["FooterCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["FooterCreateLocalesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["FooterCreateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["FooterLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	copyright?: string | undefined,
	locale?: ModelTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined,
	linkList?: ModelTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: ModelTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutFootersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutFootersCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["FooterLocaleUniqueWhere"],
	create: ModelTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["FooterUpdateLocalesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["FooterUpdateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["FooterLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["FooterUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["FooterUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FooterUpdateLocalesRelationInput"]: {
	by: ModelTypes["FooterLocaleUniqueWhere"],
	data: ModelTypes["FooterLocaleWithoutRootUpdateInput"]
};
	["FooterLocaleWithoutRootUpdateInput"]: {
	copyright?: string | undefined,
	locale?: ModelTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linkList?: ModelTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: ModelTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutFootersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutFootersUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutFootersUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutFootersUpdateInput"],
	create: ModelTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterUpsertLocalesRelationInput"]: {
	by: ModelTypes["FooterLocaleUniqueWhere"],
	update: ModelTypes["FooterLocaleWithoutRootUpdateInput"],
	create: ModelTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	copyright?: string | undefined,
	root?: ModelTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined,
	linkList?: ModelTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: ModelTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateInput"]: {
	copyright?: string | undefined,
	root?: ModelTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linkList?: ModelTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: ModelTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: ModelTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostListEdge"]>
};
	["PostListEdge"]: {
		node: ModelTypes["PostList"]
};
	["PostListItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["PostListItemCreateListEntityRelationInput"] | undefined,
	post?: ModelTypes["PostListItemCreatePostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["PostListUniqueWhere"] | undefined,
	create?: ModelTypes["PostListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostListItemConnectOrCreateListRelationInput"] | undefined
};
	["PostListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["PostListUniqueWhere"],
	create: ModelTypes["PostListWithoutItemsCreateInput"]
};
	["PostListItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["PostListItemUpdateListEntityRelationInput"] | undefined,
	post?: ModelTypes["PostListItemUpdatePostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["PostListUniqueWhere"] | undefined,
	create?: ModelTypes["PostListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostListItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["PostListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["PostListItemUpsertListRelationInput"]: {
	update: ModelTypes["PostListWithoutItemsUpdateInput"],
	create: ModelTypes["PostListWithoutItemsCreateInput"]
};
	["AppBannerConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["AppBannerEdge"]>
};
	["AppBannerEdge"]: {
		node: ModelTypes["AppBanner"]
};
	["GenericPageAboutSettingsConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GenericPageAboutSettingsEdge"]>
};
	["GenericPageAboutSettingsEdge"]: {
		node: ModelTypes["GenericPageAboutSettings"]
};
	["GenericPageAboutSettingsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined,
	linkGroups?: Array<ModelTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGenericPageAboutSettingsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"]
};
	["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: ModelTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]
};
	["GenericPageAboutSettingsUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["GenericPageAboutSettingsUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["GenericPageAboutSettingsUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutSettingsUpdateLocalesRelationInput"]: {
	by: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	data: ModelTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"]
};
	["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linkGroups?: Array<ModelTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGenericPageAboutSettingsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"],
	create: ModelTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"]
};
	["GenericPageAboutSettingsUpsertLocalesRelationInput"]: {
	by: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	update: ModelTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"],
	create: ModelTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]
};
	["GenericPageAboutSettingsLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined,
	linkGroups?: Array<ModelTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpdateInput"]: {
	root?: ModelTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linkGroups?: Array<ModelTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ValueEdge"]>
};
	["ValueEdge"]: {
		node: ModelTypes["Value"]
};
	["ValueItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["ValueItemCreateListEntityRelationInput"] | undefined,
	item?: ModelTypes["ValueItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["ValueListUniqueWhere"] | undefined,
	create?: ModelTypes["ValueListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ValueItemConnectOrCreateListRelationInput"] | undefined
};
	["ValueListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["ValueListUniqueWhere"],
	create: ModelTypes["ValueListWithoutItemsCreateInput"]
};
	["ValueItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["ValueItemUpdateListEntityRelationInput"] | undefined,
	item?: ModelTypes["ValueItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["ValueListUniqueWhere"] | undefined,
	create?: ModelTypes["ValueListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ValueItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["ValueListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["ValueItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ValueListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["ValueItemUpsertListRelationInput"]: {
	update: ModelTypes["ValueListWithoutItemsUpdateInput"],
	create: ModelTypes["ValueListWithoutItemsCreateInput"]
};
	["ValueListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ValueListEdge"]>
};
	["ValueListEdge"]: {
		node: ModelTypes["ValueList"]
};
	["ImageLinkConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageLinkEdge"]>
};
	["ImageLinkEdge"]: {
		node: ModelTypes["ImageLink"]
};
	["ImageLinkItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["ImageLinkItemCreateListEntityRelationInput"] | undefined,
	item?: ModelTypes["ImageLinkItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkItemConnectOrCreateListRelationInput"] | undefined
};
	["ImageLinkListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["ImageLinkListUniqueWhere"],
	create: ModelTypes["ImageLinkListWithoutItemsCreateInput"]
};
	["ImageLinkItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["ImageLinkItemUpdateListEntityRelationInput"] | undefined,
	item?: ModelTypes["ImageLinkItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageLinkListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageLinkItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["ImageLinkListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["ImageLinkItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ImageLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemUpsertListRelationInput"]: {
	update: ModelTypes["ImageLinkListWithoutItemsUpdateInput"],
	create: ModelTypes["ImageLinkListWithoutItemsCreateInput"]
};
	["ImageLinkListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageLinkListEdge"]>
};
	["ImageLinkListEdge"]: {
		node: ModelTypes["ImageLinkList"]
};
	["PostAreaListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaListEdge"]>
};
	["PostAreaListEdge"]: {
		node: ModelTypes["PostAreaList"]
};
	["PostAreaListItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["PostAreaListItemCreateListEntityRelationInput"] | undefined,
	item?: ModelTypes["PostAreaListItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaListUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaListItemConnectOrCreateListRelationInput"] | undefined
};
	["PostAreaListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["PostAreaListUniqueWhere"],
	create: ModelTypes["PostAreaListWithoutItemsCreateInput"]
};
	["PostAreaListItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["PostAreaListItemUpdateListEntityRelationInput"] | undefined,
	item?: ModelTypes["PostAreaListItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["PostAreaListUniqueWhere"] | undefined,
	create?: ModelTypes["PostAreaListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostAreaListItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["PostAreaListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostAreaListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostAreaListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemUpsertListRelationInput"]: {
	update: ModelTypes["PostAreaListWithoutItemsUpdateInput"],
	create: ModelTypes["PostAreaListWithoutItemsCreateInput"]
};
	["AccordionConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["AccordionEdge"]>
};
	["AccordionEdge"]: {
		node: ModelTypes["Accordion"]
};
	["AccordionItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	list?: ModelTypes["AccordionItemCreateListEntityRelationInput"] | undefined,
	descriptionContent?: ModelTypes["AccordionItemCreateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["AccordionUniqueWhere"] | undefined,
	create?: ModelTypes["AccordionWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AccordionItemConnectOrCreateListRelationInput"] | undefined
};
	["AccordionWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["AccordionUniqueWhere"],
	create: ModelTypes["AccordionWithoutItemsCreateInput"]
};
	["AccordionItemUpdateInput"]: {
	order?: number | undefined,
	name?: string | undefined,
	list?: ModelTypes["AccordionItemUpdateListEntityRelationInput"] | undefined,
	descriptionContent?: ModelTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["AccordionUniqueWhere"] | undefined,
	create?: ModelTypes["AccordionWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["AccordionItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["AccordionWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["AccordionItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["AccordionWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["AccordionItemUpsertListRelationInput"]: {
	update: ModelTypes["AccordionWithoutItemsUpdateInput"],
	create: ModelTypes["AccordionWithoutItemsCreateInput"]
};
	["UserConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserEdge"]>
};
	["UserEdge"]: {
		node: ModelTypes["User"]
};
	["UserPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpdateInput"]: {
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CurrencyConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CurrencyEdge"]>
};
	["CurrencyEdge"]: {
		node: ModelTypes["Currency"]
};
	["MediumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["MediumEdge"]>
};
	["MediumEdge"]: {
		node: ModelTypes["Medium"]
};
	["MediumItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["MediumItemCreateListEntityRelationInput"] | undefined,
	medium?: ModelTypes["MediumItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumItemConnectOrCreateListRelationInput"] | undefined
};
	["MediumListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["MediumListUniqueWhere"],
	create: ModelTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["MediumItemUpdateListEntityRelationInput"] | undefined,
	medium?: ModelTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["MediumListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["MediumItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpsertListRelationInput"]: {
	update: ModelTypes["MediumListWithoutItemsUpdateInput"],
	create: ModelTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["MediumListEdge"]>
};
	["MediumListEdge"]: {
		node: ModelTypes["MediumList"]
};
	["UserPaymentOrderIdConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserPaymentOrderIdEdge"]>
};
	["UserPaymentOrderIdEdge"]: {
		node: ModelTypes["UserPaymentOrderId"]
};
	["UserRecurringPaymentItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	recurrenceCounter?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	payments?: Array<ModelTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]> | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"] | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: ModelTypes["DateTime"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemUpdateInput"]: {
	recurrenceCounter?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	payments?: Array<ModelTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]> | undefined,
	recurringPayment?: ModelTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"] | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: ModelTypes["DateTime"] | undefined,
	meta?: ModelTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["PostRevisionLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined,
	leadContent?: ModelTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["PostRevisionLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined,
	leadContent?: ModelTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogue"]: {
		_meta?: ModelTypes["TranslationCatalogueMeta"] | undefined,
	id: ModelTypes["UUID"],
	domain?: ModelTypes["TranslationDomain"] | undefined,
	identifier?: ModelTypes["TranslationCataloguesIdentifier"] | undefined,
	fallback?: ModelTypes["TranslationCatalogue"] | undefined,
	values: Array<ModelTypes["TranslationValue"]>,
	valuesByKey?: ModelTypes["TranslationValue"] | undefined,
	paginateValues: ModelTypes["TranslationValueConnection"]
};
	["TranslationCatalogueMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	domain?: ModelTypes["FieldMeta"] | undefined,
	identifier?: ModelTypes["FieldMeta"] | undefined,
	fallback?: ModelTypes["FieldMeta"] | undefined,
	values?: ModelTypes["FieldMeta"] | undefined
};
	["TranslationDomain"]: {
		_meta?: ModelTypes["TranslationDomainMeta"] | undefined,
	id: ModelTypes["UUID"],
	identifier: string,
	name: string,
	catalogues: Array<ModelTypes["TranslationCatalogue"]>,
	keys: Array<ModelTypes["TranslationKey"]>,
	cataloguesByIdentifier?: ModelTypes["TranslationCatalogue"] | undefined,
	cataloguesByValues?: ModelTypes["TranslationCatalogue"] | undefined,
	keysByIdentifier?: ModelTypes["TranslationKey"] | undefined,
	keysByValues?: ModelTypes["TranslationKey"] | undefined,
	paginateCatalogues: ModelTypes["TranslationCatalogueConnection"],
	paginateKeys: ModelTypes["TranslationKeyConnection"]
};
	["TranslationDomainMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	identifier?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	catalogues?: ModelTypes["FieldMeta"] | undefined,
	keys?: ModelTypes["FieldMeta"] | undefined
};
	["TranslationCatalogueWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	domain?: ModelTypes["TranslationDomainWhere"] | undefined,
	identifier?: ModelTypes["TranslationCataloguesIdentifierWhere"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueWhere"] | undefined,
	values?: ModelTypes["TranslationValueWhere"] | undefined,
	and?: Array<ModelTypes["TranslationCatalogueWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TranslationCatalogueWhere"] | undefined> | undefined,
	not?: ModelTypes["TranslationCatalogueWhere"] | undefined
};
	["TranslationDomainWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	identifier?: ModelTypes["StringCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	catalogues?: ModelTypes["TranslationCatalogueWhere"] | undefined,
	keys?: ModelTypes["TranslationKeyWhere"] | undefined,
	and?: Array<ModelTypes["TranslationDomainWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TranslationDomainWhere"] | undefined> | undefined,
	not?: ModelTypes["TranslationDomainWhere"] | undefined
};
	["TranslationKeyWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	identifier?: ModelTypes["StringCondition"] | undefined,
	contentType?: ModelTypes["TranslationKeyContentTypeCondition"] | undefined,
	note?: ModelTypes["StringCondition"] | undefined,
	domain?: ModelTypes["TranslationDomainWhere"] | undefined,
	values?: ModelTypes["TranslationValueWhere"] | undefined,
	and?: Array<ModelTypes["TranslationKeyWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TranslationKeyWhere"] | undefined> | undefined,
	not?: ModelTypes["TranslationKeyWhere"] | undefined
};
	["TranslationKeyContentTypeCondition"]: {
	and?: Array<ModelTypes["TranslationKeyContentTypeCondition"]> | undefined,
	or?: Array<ModelTypes["TranslationKeyContentTypeCondition"]> | undefined,
	not?: ModelTypes["TranslationKeyContentTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["TranslationKeyContentType"] | undefined,
	notEq?: ModelTypes["TranslationKeyContentType"] | undefined,
	in?: Array<ModelTypes["TranslationKeyContentType"]> | undefined,
	notIn?: Array<ModelTypes["TranslationKeyContentType"]> | undefined,
	lt?: ModelTypes["TranslationKeyContentType"] | undefined,
	lte?: ModelTypes["TranslationKeyContentType"] | undefined,
	gt?: ModelTypes["TranslationKeyContentType"] | undefined,
	gte?: ModelTypes["TranslationKeyContentType"] | undefined
};
	["TranslationKeyContentType"]:TranslationKeyContentType;
	["TranslationValueWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	value?: ModelTypes["StringCondition"] | undefined,
	catalogue?: ModelTypes["TranslationCatalogueWhere"] | undefined,
	key?: ModelTypes["TranslationKeyWhere"] | undefined,
	and?: Array<ModelTypes["TranslationValueWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TranslationValueWhere"] | undefined> | undefined,
	not?: ModelTypes["TranslationValueWhere"] | undefined
};
	["TranslationCataloguesIdentifierWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	code?: ModelTypes["StringCondition"] | undefined,
	catalogue?: ModelTypes["TranslationCatalogueWhere"] | undefined,
	and?: Array<ModelTypes["TranslationCataloguesIdentifierWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TranslationCataloguesIdentifierWhere"] | undefined> | undefined,
	not?: ModelTypes["TranslationCataloguesIdentifierWhere"] | undefined
};
	["TranslationCatalogueOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	domain?: ModelTypes["TranslationDomainOrderBy"] | undefined,
	identifier?: ModelTypes["TranslationCataloguesIdentifierOrderBy"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueOrderBy"] | undefined
};
	["TranslationDomainOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	identifier?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined
};
	["TranslationCataloguesIdentifierOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	code?: ModelTypes["OrderDirection"] | undefined
};
	["TranslationKey"]: {
		_meta?: ModelTypes["TranslationKeyMeta"] | undefined,
	id: ModelTypes["UUID"],
	identifier: string,
	contentType: ModelTypes["TranslationKeyContentType"],
	note?: string | undefined,
	domain?: ModelTypes["TranslationDomain"] | undefined,
	values: Array<ModelTypes["TranslationValue"]>,
	valuesByCatalogue?: ModelTypes["TranslationValue"] | undefined,
	paginateValues: ModelTypes["TranslationValueConnection"]
};
	["TranslationKeyMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	identifier?: ModelTypes["FieldMeta"] | undefined,
	contentType?: ModelTypes["FieldMeta"] | undefined,
	note?: ModelTypes["FieldMeta"] | undefined,
	domain?: ModelTypes["FieldMeta"] | undefined,
	values?: ModelTypes["FieldMeta"] | undefined
};
	["TranslationValue"]: {
		_meta?: ModelTypes["TranslationValueMeta"] | undefined,
	id: ModelTypes["UUID"],
	value: string,
	catalogue?: ModelTypes["TranslationCatalogue"] | undefined,
	key?: ModelTypes["TranslationKey"] | undefined
};
	["TranslationValueMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	value?: ModelTypes["FieldMeta"] | undefined,
	catalogue?: ModelTypes["FieldMeta"] | undefined,
	key?: ModelTypes["FieldMeta"] | undefined
};
	["TranslationValueOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	value?: ModelTypes["OrderDirection"] | undefined,
	catalogue?: ModelTypes["TranslationCatalogueOrderBy"] | undefined,
	key?: ModelTypes["TranslationKeyOrderBy"] | undefined
};
	["TranslationKeyOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	identifier?: ModelTypes["OrderDirection"] | undefined,
	contentType?: ModelTypes["OrderDirection"] | undefined,
	note?: ModelTypes["OrderDirection"] | undefined,
	domain?: ModelTypes["TranslationDomainOrderBy"] | undefined
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
	catalogue?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined
};
	["TranslationCatalogueUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	domain?: ModelTypes["TranslationDomainUniqueWhere"] | undefined,
	identifier?: ModelTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	values?: ModelTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationDomainUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	catalogues?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	keys?: ModelTypes["TranslationKeyUniqueWhere"] | undefined
};
	["TranslationKeyUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	domain?: ModelTypes["TranslationDomainUniqueWhere"] | undefined,
	identifier?: string | undefined,
	values?: ModelTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationValueUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	catalogue?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	key?: ModelTypes["TranslationKeyUniqueWhere"] | undefined
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	catalogue?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined
};
	["TranslationValueConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TranslationValueEdge"]>
};
	["TranslationValueEdge"]: {
		node: ModelTypes["TranslationValue"]
};
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
	identifier?: ModelTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
	values?: ModelTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
	identifier?: string | undefined
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
	values?: ModelTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationCatalogueConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TranslationCatalogueEdge"]>
};
	["TranslationCatalogueEdge"]: {
		node: ModelTypes["TranslationCatalogue"]
};
	["TranslationKeyConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TranslationKeyEdge"]>
};
	["TranslationKeyEdge"]: {
		node: ModelTypes["TranslationKey"]
};
	["TranslationCataloguesIdentifier"]: {
		_meta?: ModelTypes["TranslationCataloguesIdentifierMeta"] | undefined,
	id: ModelTypes["UUID"],
	name: string,
	code: string,
	catalogue: Array<ModelTypes["TranslationCatalogue"]>,
	catalogueByDomain?: ModelTypes["TranslationCatalogue"] | undefined,
	catalogueByValues?: ModelTypes["TranslationCatalogue"] | undefined,
	paginateCatalogue: ModelTypes["TranslationCatalogueConnection"]
};
	["TranslationCataloguesIdentifierMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	code?: ModelTypes["FieldMeta"] | undefined,
	catalogue?: ModelTypes["FieldMeta"] | undefined
};
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
	domain?: ModelTypes["TranslationDomainUniqueWhere"] | undefined
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
	values?: ModelTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
	key?: ModelTypes["TranslationKeyUniqueWhere"] | undefined
};
	["TranslationCatalogueCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	domain?: ModelTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	identifier?: ModelTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<ModelTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
	connect?: ModelTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"] | undefined
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	keys?: Array<ModelTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
	connect?: ModelTypes["TranslationKeyUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationKeyWithoutDomainCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationDomainConnectOrCreateKeysRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationKeyWithoutDomainCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: ModelTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	values?: Array<ModelTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
	connect?: ModelTypes["TranslationValueUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationValueWithoutKeyCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationKeyConnectOrCreateValuesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationValueWithoutKeyCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	value?: string | undefined,
	catalogue?: ModelTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
	connect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationValueConnectOrCreateCatalogueRelationInput"] | undefined
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	domain?: ModelTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	identifier?: ModelTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
	connect?: ModelTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"] | undefined
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueConnectOrCreateIdentifierRelationInput"]: {
	connect: ModelTypes["TranslationCataloguesIdentifierUniqueWhere"],
	create: ModelTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
	connect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationCatalogueCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"] | undefined
};
	["TranslationCatalogueConnectOrCreateFallbackRelationInput"]: {
	connect: ModelTypes["TranslationCatalogueUniqueWhere"],
	create: ModelTypes["TranslationCatalogueCreateInput"]
};
	["TranslationValueConnectOrCreateCatalogueRelationInput"]: {
	connect: ModelTypes["TranslationCatalogueUniqueWhere"],
	create: ModelTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationKeyConnectOrCreateValuesRelationInput"]: {
	connect: ModelTypes["TranslationValueUniqueWhere"],
	create: ModelTypes["TranslationValueWithoutKeyCreateInput"]
};
	["TranslationDomainConnectOrCreateKeysRelationInput"]: {
	connect: ModelTypes["TranslationKeyUniqueWhere"],
	create: ModelTypes["TranslationKeyWithoutDomainCreateInput"]
};
	["TranslationCatalogueConnectOrCreateDomainRelationInput"]: {
	connect: ModelTypes["TranslationDomainUniqueWhere"],
	create: ModelTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
	connect?: ModelTypes["TranslationValueUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationCatalogueConnectOrCreateValuesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	value?: string | undefined,
	key?: ModelTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
	connect?: ModelTypes["TranslationKeyUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationKeyWithoutValuesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationValueConnectOrCreateKeyRelationInput"] | undefined
};
	["TranslationKeyWithoutValuesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: ModelTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	domain?: ModelTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
	connect?: ModelTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationDomainWithoutKeysCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationKeyConnectOrCreateDomainRelationInput"] | undefined
};
	["TranslationDomainWithoutKeysCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<ModelTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
	connect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationDomainConnectOrCreateCataloguesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: ModelTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<ModelTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainConnectOrCreateCataloguesRelationInput"]: {
	connect: ModelTypes["TranslationCatalogueUniqueWhere"],
	create: ModelTypes["TranslationCatalogueWithoutDomainCreateInput"]
};
	["TranslationKeyConnectOrCreateDomainRelationInput"]: {
	connect: ModelTypes["TranslationDomainUniqueWhere"],
	create: ModelTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationValueConnectOrCreateKeyRelationInput"]: {
	connect: ModelTypes["TranslationKeyUniqueWhere"],
	create: ModelTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationCatalogueConnectOrCreateValuesRelationInput"]: {
	connect: ModelTypes["TranslationValueUniqueWhere"],
	create: ModelTypes["TranslationValueWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpdateInput"]: {
	domain?: ModelTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	identifier?: ModelTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<ModelTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
	connect?: ModelTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"] | undefined,
	update?: ModelTypes["TranslationDomainWithoutCataloguesUpdateInput"] | undefined,
	upsert?: ModelTypes["TranslationCatalogueUpsertDomainRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
	identifier?: string | undefined,
	name?: string | undefined,
	keys?: Array<ModelTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
	create?: ModelTypes["TranslationKeyWithoutDomainCreateInput"] | undefined,
	update?: ModelTypes["TranslationDomainUpdateKeysRelationInput"] | undefined,
	upsert?: ModelTypes["TranslationDomainUpsertKeysRelationInput"] | undefined,
	connect?: ModelTypes["TranslationKeyUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TranslationKeyUniqueWhere"] | undefined,
	delete?: ModelTypes["TranslationKeyUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationDomainUpdateKeysRelationInput"]: {
	by: ModelTypes["TranslationKeyUniqueWhere"],
	data: ModelTypes["TranslationKeyWithoutDomainUpdateInput"]
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
	identifier?: string | undefined,
	contentType?: ModelTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	values?: Array<ModelTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
	create?: ModelTypes["TranslationValueWithoutKeyCreateInput"] | undefined,
	update?: ModelTypes["TranslationKeyUpdateValuesRelationInput"] | undefined,
	upsert?: ModelTypes["TranslationKeyUpsertValuesRelationInput"] | undefined,
	connect?: ModelTypes["TranslationValueUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TranslationValueUniqueWhere"] | undefined,
	delete?: ModelTypes["TranslationValueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationKeyUpdateValuesRelationInput"]: {
	by: ModelTypes["TranslationValueUniqueWhere"],
	data: ModelTypes["TranslationValueWithoutKeyUpdateInput"]
};
	["TranslationValueWithoutKeyUpdateInput"]: {
	value?: string | undefined,
	catalogue?: ModelTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
	connect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationValueConnectOrCreateCatalogueRelationInput"] | undefined,
	update?: ModelTypes["TranslationCatalogueWithoutValuesUpdateInput"] | undefined,
	upsert?: ModelTypes["TranslationValueUpsertCatalogueRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
	domain?: ModelTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	identifier?: ModelTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
	connect?: ModelTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"] | undefined,
	update?: ModelTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | undefined,
	upsert?: ModelTypes["TranslationCatalogueUpsertIdentifierRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
	name?: string | undefined,
	code?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
	update: ModelTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"],
	create: ModelTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
	connect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationCatalogueCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"] | undefined,
	update?: ModelTypes["TranslationCatalogueUpdateInput"] | undefined,
	upsert?: ModelTypes["TranslationCatalogueUpsertFallbackRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
	update: ModelTypes["TranslationCatalogueUpdateInput"],
	create: ModelTypes["TranslationCatalogueCreateInput"]
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
	update: ModelTypes["TranslationCatalogueWithoutValuesUpdateInput"],
	create: ModelTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationKeyUpsertValuesRelationInput"]: {
	by: ModelTypes["TranslationValueUniqueWhere"],
	update: ModelTypes["TranslationValueWithoutKeyUpdateInput"],
	create: ModelTypes["TranslationValueWithoutKeyCreateInput"]
};
	["TranslationDomainUpsertKeysRelationInput"]: {
	by: ModelTypes["TranslationKeyUniqueWhere"],
	update: ModelTypes["TranslationKeyWithoutDomainUpdateInput"],
	create: ModelTypes["TranslationKeyWithoutDomainCreateInput"]
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
	update: ModelTypes["TranslationDomainWithoutCataloguesUpdateInput"],
	create: ModelTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
	create?: ModelTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined,
	update?: ModelTypes["TranslationCatalogueUpdateValuesRelationInput"] | undefined,
	upsert?: ModelTypes["TranslationCatalogueUpsertValuesRelationInput"] | undefined,
	connect?: ModelTypes["TranslationValueUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TranslationValueUniqueWhere"] | undefined,
	delete?: ModelTypes["TranslationValueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
	by: ModelTypes["TranslationValueUniqueWhere"],
	data: ModelTypes["TranslationValueWithoutCatalogueUpdateInput"]
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
	value?: string | undefined,
	key?: ModelTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
	connect?: ModelTypes["TranslationKeyUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationKeyWithoutValuesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationValueConnectOrCreateKeyRelationInput"] | undefined,
	update?: ModelTypes["TranslationKeyWithoutValuesUpdateInput"] | undefined,
	upsert?: ModelTypes["TranslationValueUpsertKeyRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
	identifier?: string | undefined,
	contentType?: ModelTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	domain?: ModelTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
	connect?: ModelTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationDomainWithoutKeysCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationKeyConnectOrCreateDomainRelationInput"] | undefined,
	update?: ModelTypes["TranslationDomainWithoutKeysUpdateInput"] | undefined,
	upsert?: ModelTypes["TranslationKeyUpsertDomainRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
	identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<ModelTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
	create?: ModelTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined,
	update?: ModelTypes["TranslationDomainUpdateCataloguesRelationInput"] | undefined,
	upsert?: ModelTypes["TranslationDomainUpsertCataloguesRelationInput"] | undefined,
	connect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	delete?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
	by: ModelTypes["TranslationCatalogueUniqueWhere"],
	data: ModelTypes["TranslationCatalogueWithoutDomainUpdateInput"]
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
	identifier?: ModelTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<ModelTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
	by: ModelTypes["TranslationCatalogueUniqueWhere"],
	update: ModelTypes["TranslationCatalogueWithoutDomainUpdateInput"],
	create: ModelTypes["TranslationCatalogueWithoutDomainCreateInput"]
};
	["TranslationKeyUpsertDomainRelationInput"]: {
	update: ModelTypes["TranslationDomainWithoutKeysUpdateInput"],
	create: ModelTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationValueUpsertKeyRelationInput"]: {
	update: ModelTypes["TranslationKeyWithoutValuesUpdateInput"],
	create: ModelTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
	by: ModelTypes["TranslationValueUniqueWhere"],
	update: ModelTypes["TranslationValueWithoutCatalogueUpdateInput"],
	create: ModelTypes["TranslationValueWithoutCatalogueCreateInput"]
};
	["TranslationCataloguesIdentifierConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TranslationCataloguesIdentifierEdge"]>
};
	["TranslationCataloguesIdentifierEdge"]: {
		node: ModelTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	catalogue?: Array<ModelTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
	connect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	domain?: ModelTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<ModelTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"]: {
	connect: ModelTypes["TranslationCatalogueUniqueWhere"],
	create: ModelTypes["TranslationCatalogueWithoutIdentifierCreateInput"]
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
	name?: string | undefined,
	code?: string | undefined,
	catalogue?: Array<ModelTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
	create?: ModelTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined,
	update?: ModelTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"] | undefined,
	upsert?: ModelTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"] | undefined,
	connect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	delete?: ModelTypes["TranslationCatalogueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
	by: ModelTypes["TranslationCatalogueUniqueWhere"],
	data: ModelTypes["TranslationCatalogueWithoutIdentifierUpdateInput"]
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
	domain?: ModelTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	fallback?: ModelTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<ModelTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
	by: ModelTypes["TranslationCatalogueUniqueWhere"],
	update: ModelTypes["TranslationCatalogueWithoutIdentifierUpdateInput"],
	create: ModelTypes["TranslationCatalogueWithoutIdentifierCreateInput"]
};
	["TranslationDomainConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TranslationDomainEdge"]>
};
	["TranslationDomainEdge"]: {
		node: ModelTypes["TranslationDomain"]
};
	["TranslationDomainCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<ModelTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined,
	keys?: Array<ModelTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateInput"]: {
	identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<ModelTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined,
	keys?: Array<ModelTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: ModelTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	domain?: ModelTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined,
	values?: Array<ModelTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateInput"]: {
	identifier?: string | undefined,
	contentType?: ModelTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	domain?: ModelTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined,
	values?: Array<ModelTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	value?: string | undefined,
	catalogue?: ModelTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined,
	key?: ModelTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateInput"]: {
	value?: string | undefined,
	catalogue?: ModelTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined,
	key?: ModelTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	settings?: ModelTypes["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"] | undefined,
	linkList?: ModelTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"] | undefined
};
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"]: {
	connect: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: ModelTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]
};
	["GenericPageAboutGroupLinksLocaleUpdateInput"]: {
	order?: number | undefined,
	settings?: ModelTypes["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"] | undefined,
	linkList?: ModelTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"] | undefined,
	update?: ModelTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"]: {
	root?: ModelTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"]: {
	update: ModelTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"],
	create: ModelTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]
};
	["MemberListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["MemberListEdge"]>
};
	["MemberListEdge"]: {
		node: ModelTypes["MemberList"]
};
	["MemberListItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	position?: string | undefined,
	list?: ModelTypes["MemberListItemCreateListEntityRelationInput"] | undefined,
	image?: ModelTypes["MemberListItemCreateImageEntityRelationInput"] | undefined,
	descriptionContent?: ModelTypes["MemberListItemCreateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["MemberListUniqueWhere"] | undefined,
	create?: ModelTypes["MemberListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MemberListItemConnectOrCreateListRelationInput"] | undefined
};
	["MemberListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["MemberListUniqueWhere"],
	create: ModelTypes["MemberListWithoutItemsCreateInput"]
};
	["MemberListItemUpdateInput"]: {
	order?: number | undefined,
	name?: string | undefined,
	position?: string | undefined,
	list?: ModelTypes["MemberListItemUpdateListEntityRelationInput"] | undefined,
	image?: ModelTypes["MemberListItemUpdateImageEntityRelationInput"] | undefined,
	descriptionContent?: ModelTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["MemberListUniqueWhere"] | undefined,
	create?: ModelTypes["MemberListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MemberListItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["MemberListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["MemberListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["MemberListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["MemberListItemUpsertListRelationInput"]: {
	update: ModelTypes["MemberListWithoutItemsUpdateInput"],
	create: ModelTypes["MemberListWithoutItemsCreateInput"]
};
	["FilledTaxFormConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FilledTaxFormEdge"]>
};
	["FilledTaxFormEdge"]: {
		node: ModelTypes["FilledTaxForm"]
};
	["FilledTaxFormEmailAddress"]: {
		_meta?: ModelTypes["FilledTaxFormEmailAddressMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	email: string
};
	["FilledTaxFormEmailAddressMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	email?: ModelTypes["FieldMeta"] | undefined
};
	["FilledTaxFormEmailAddressUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["FilledTaxFormEmailAddressWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	email?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["FilledTaxFormEmailAddressWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FilledTaxFormEmailAddressWhere"] | undefined> | undefined,
	not?: ModelTypes["FilledTaxFormEmailAddressWhere"] | undefined
};
	["FilledTaxFormEmailAddressOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	email?: ModelTypes["OrderDirection"] | undefined
};
	["FilledTaxFormEmailAddressConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FilledTaxFormEmailAddressEdge"]>
};
	["FilledTaxFormEmailAddressEdge"]: {
		node: ModelTypes["FilledTaxFormEmailAddress"]
};
	["FilledTaxFormEmailAddressCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	email?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FilledTaxFormEmailAddressUpdateInput"]: {
	order?: number | undefined,
	email?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FormConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FormEdge"]>
};
	["FormEdge"]: {
		node: ModelTypes["Form"]
};
	["CsobPaymentConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CsobPaymentEdge"]>
};
	["CsobPaymentEdge"]: {
		node: ModelTypes["CsobPayment"]
};
	["CsobPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	payId?: string | undefined,
	statusChanges?: Array<ModelTypes["CsobPaymentCreateStatusChangesEntityRelationInput"]> | undefined,
	payment?: ModelTypes["CsobPaymentCreatePaymentEntityRelationInput"] | undefined,
	originalPayId?: string | undefined,
	metadata?: ModelTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentCreatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentWithoutCsobPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CsobPaymentConnectOrCreatePaymentRelationInput"] | undefined
};
	["UserPaymentWithoutCsobPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentConnectOrCreatePaymentRelationInput"]: {
	connect: ModelTypes["UserPaymentUniqueWhere"],
	create: ModelTypes["UserPaymentWithoutCsobPaymentCreateInput"]
};
	["CsobPaymentUpdateInput"]: {
	payId?: string | undefined,
	statusChanges?: Array<ModelTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"]> | undefined,
	payment?: ModelTypes["CsobPaymentUpdatePaymentEntityRelationInput"] | undefined,
	originalPayId?: string | undefined,
	metadata?: ModelTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentUpdatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentWithoutCsobPaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CsobPaymentConnectOrCreatePaymentRelationInput"] | undefined,
	update?: ModelTypes["UserPaymentWithoutCsobPaymentUpdateInput"] | undefined,
	upsert?: ModelTypes["CsobPaymentUpsertPaymentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentWithoutCsobPaymentUpdateInput"]: {
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentUpsertPaymentRelationInput"]: {
	update: ModelTypes["UserPaymentWithoutCsobPaymentUpdateInput"],
	create: ModelTypes["UserPaymentWithoutCsobPaymentCreateInput"]
};
	["CsobPaymentStatusChangeCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	dttm?: string | undefined,
	status?: number | undefined,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	payment?: ModelTypes["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["CsobPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["CsobPaymentWithoutStatusChangesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined
};
	["CsobPaymentWithoutStatusChangesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	payId?: string | undefined,
	payment?: ModelTypes["CsobPaymentCreatePaymentEntityRelationInput"] | undefined,
	originalPayId?: string | undefined,
	metadata?: ModelTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"]: {
	connect: ModelTypes["CsobPaymentUniqueWhere"],
	create: ModelTypes["CsobPaymentWithoutStatusChangesCreateInput"]
};
	["CsobPaymentStatusChangeUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	dttm?: string | undefined,
	status?: number | undefined,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	payment?: ModelTypes["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["CsobPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["CsobPaymentWithoutStatusChangesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined,
	update?: ModelTypes["CsobPaymentWithoutStatusChangesUpdateInput"] | undefined,
	upsert?: ModelTypes["CsobPaymentStatusChangeUpsertPaymentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["CsobPaymentWithoutStatusChangesUpdateInput"]: {
	payId?: string | undefined,
	payment?: ModelTypes["CsobPaymentUpdatePaymentEntityRelationInput"] | undefined,
	originalPayId?: string | undefined,
	metadata?: ModelTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentStatusChangeUpsertPaymentRelationInput"]: {
	update: ModelTypes["CsobPaymentWithoutStatusChangesUpdateInput"],
	create: ModelTypes["CsobPaymentWithoutStatusChangesCreateInput"]
};
	["StripePaymentConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["StripePaymentEdge"]>
};
	["StripePaymentEdge"]: {
		node: ModelTypes["StripePayment"]
};
	["StripePaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	statusChanges?: Array<ModelTypes["StripePaymentCreateStatusChangesEntityRelationInput"]> | undefined,
	payment?: ModelTypes["StripePaymentCreatePaymentEntityRelationInput"] | undefined,
	metadata?: ModelTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentCreatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentWithoutStripePaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StripePaymentConnectOrCreatePaymentRelationInput"] | undefined
};
	["UserPaymentWithoutStripePaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentConnectOrCreatePaymentRelationInput"]: {
	connect: ModelTypes["UserPaymentUniqueWhere"],
	create: ModelTypes["UserPaymentWithoutStripePaymentCreateInput"]
};
	["StripePaymentUpdateInput"]: {
	identifier?: string | undefined,
	statusChanges?: Array<ModelTypes["StripePaymentUpdateStatusChangesEntityRelationInput"]> | undefined,
	payment?: ModelTypes["StripePaymentUpdatePaymentEntityRelationInput"] | undefined,
	metadata?: ModelTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentUpdatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentWithoutStripePaymentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StripePaymentConnectOrCreatePaymentRelationInput"] | undefined,
	update?: ModelTypes["UserPaymentWithoutStripePaymentUpdateInput"] | undefined,
	upsert?: ModelTypes["StripePaymentUpsertPaymentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentWithoutStripePaymentUpdateInput"]: {
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: ModelTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentUpsertPaymentRelationInput"]: {
	update: ModelTypes["UserPaymentWithoutStripePaymentUpdateInput"],
	create: ModelTypes["UserPaymentWithoutStripePaymentCreateInput"]
};
	["StripePaymentStatusChangeCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	payment?: ModelTypes["StripePaymentStatusChangeCreatePaymentEntityRelationInput"] | undefined,
	timestamp?: number | undefined,
	eventId?: string | undefined,
	paymentIntentStatus?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentStatusChangeCreatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["StripePaymentUniqueWhere"] | undefined,
	create?: ModelTypes["StripePaymentWithoutStatusChangesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined
};
	["StripePaymentWithoutStatusChangesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	identifier?: string | undefined,
	payment?: ModelTypes["StripePaymentCreatePaymentEntityRelationInput"] | undefined,
	metadata?: ModelTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"]: {
	connect: ModelTypes["StripePaymentUniqueWhere"],
	create: ModelTypes["StripePaymentWithoutStatusChangesCreateInput"]
};
	["StripePaymentStatusChangeUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	payment?: ModelTypes["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"] | undefined,
	timestamp?: number | undefined,
	eventId?: string | undefined,
	paymentIntentStatus?: ModelTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["StripePaymentUniqueWhere"] | undefined,
	create?: ModelTypes["StripePaymentWithoutStatusChangesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined,
	update?: ModelTypes["StripePaymentWithoutStatusChangesUpdateInput"] | undefined,
	upsert?: ModelTypes["StripePaymentStatusChangeUpsertPaymentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["StripePaymentWithoutStatusChangesUpdateInput"]: {
	identifier?: string | undefined,
	payment?: ModelTypes["StripePaymentUpdatePaymentEntityRelationInput"] | undefined,
	metadata?: ModelTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentStatusChangeUpsertPaymentRelationInput"]: {
	update: ModelTypes["StripePaymentWithoutStatusChangesUpdateInput"],
	create: ModelTypes["StripePaymentWithoutStatusChangesCreateInput"]
};
	["RegionPaymentMethodCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	allowRecurringPayments?: boolean | undefined,
	region?: ModelTypes["RegionPaymentMethodCreateRegionEntityRelationInput"] | undefined,
	method?: ModelTypes["PaymentMethods"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionPaymentMethodCreateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"] | undefined
};
	["RegionWithoutEnabledPaymentMethodsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: ModelTypes["RegionCreateCurrencyEntityRelationInput"] | undefined,
	donationItems?: Array<ModelTypes["RegionCreateDonationItemsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionPaymentMethodConnectOrCreateRegionRelationInput"]: {
	connect: ModelTypes["RegionUniqueWhere"],
	create: ModelTypes["RegionWithoutEnabledPaymentMethodsCreateInput"]
};
	["RegionPaymentMethodUpdateInput"]: {
	allowRecurringPayments?: boolean | undefined,
	region?: ModelTypes["RegionPaymentMethodUpdateRegionEntityRelationInput"] | undefined,
	method?: ModelTypes["PaymentMethods"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionPaymentMethodUpdateRegionEntityRelationInput"]: {
	connect?: ModelTypes["RegionUniqueWhere"] | undefined,
	create?: ModelTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"] | undefined,
	update?: ModelTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"] | undefined,
	upsert?: ModelTypes["RegionPaymentMethodUpsertRegionRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["RegionWithoutEnabledPaymentMethodsUpdateInput"]: {
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: ModelTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined,
	donationItems?: Array<ModelTypes["RegionUpdateDonationItemsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionPaymentMethodUpsertRegionRelationInput"]: {
	update: ModelTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"],
	create: ModelTypes["RegionWithoutEnabledPaymentMethodsCreateInput"]
};
	["PostAreaMetaDataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaMetaDataEdge"]>
};
	["PostAreaMetaDataEdge"]: {
		node: ModelTypes["PostAreaMetaData"]
};
	["PostMetaDataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostMetaDataEdge"]>
};
	["PostMetaDataEdge"]: {
		node: ModelTypes["PostMetaData"]
};
	["PostOrganizationMetaDataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostOrganizationMetaDataEdge"]>
};
	["PostOrganizationMetaDataEdge"]: {
		node: ModelTypes["PostOrganizationMetaData"]
};
	["TileItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	type?: ModelTypes["TileItemType"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	list?: ModelTypes["TileItemCreateListEntityRelationInput"] | undefined,
	post?: ModelTypes["TileItemCreatePostEntityRelationInput"] | undefined,
	area?: ModelTypes["TileItemCreateAreaEntityRelationInput"] | undefined,
	image?: ModelTypes["TileItemCreateImageEntityRelationInput"] | undefined,
	link?: ModelTypes["TileItemCreateLinkEntityRelationInput"] | undefined,
	organization?: ModelTypes["TileItemCreateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["TileListUniqueWhere"] | undefined,
	create?: ModelTypes["TileListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateListRelationInput"] | undefined
};
	["TileListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	size?: ModelTypes["TileListSize"] | undefined,
	title?: string | undefined,
	areaType?: ModelTypes["TileListCreateAreaTypeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["TileListUniqueWhere"],
	create: ModelTypes["TileListWithoutItemsCreateInput"]
};
	["TileItemUpdateInput"]: {
	order?: number | undefined,
	type?: ModelTypes["TileItemType"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	list?: ModelTypes["TileItemUpdateListEntityRelationInput"] | undefined,
	post?: ModelTypes["TileItemUpdatePostEntityRelationInput"] | undefined,
	area?: ModelTypes["TileItemUpdateAreaEntityRelationInput"] | undefined,
	image?: ModelTypes["TileItemUpdateImageEntityRelationInput"] | undefined,
	link?: ModelTypes["TileItemUpdateLinkEntityRelationInput"] | undefined,
	organization?: ModelTypes["TileItemUpdateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["TileListUniqueWhere"] | undefined,
	create?: ModelTypes["TileListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["TileListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["TileItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TileListWithoutItemsUpdateInput"]: {
	size?: ModelTypes["TileListSize"] | undefined,
	title?: string | undefined,
	areaType?: ModelTypes["TileListUpdateAreaTypeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemUpsertListRelationInput"]: {
	update: ModelTypes["TileListWithoutItemsUpdateInput"],
	create: ModelTypes["TileListWithoutItemsCreateInput"]
};
	["TileListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TileListEdge"]>
};
	["TileListEdge"]: {
		node: ModelTypes["TileList"]
};
	["FeedPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FeedPageEdge"]>
};
	["FeedPageEdge"]: {
		node: ModelTypes["FeedPage"]
};
	["FeedPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["FeedPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["FeedPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	heroTiles?: ModelTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<ModelTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined,
	cardList?: ModelTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutFeedPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutFeedPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutFeedPagesCreateInput"]
};
	["FeedPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["FeedPageLocaleUniqueWhere"],
	create: ModelTypes["FeedPageLocaleWithoutRootCreateInput"]
};
	["FeedPageUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["FeedPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["FeedPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["FeedPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["FeedPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FeedPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["FeedPageLocaleUniqueWhere"],
	data: ModelTypes["FeedPageLocaleWithoutRootUpdateInput"]
};
	["FeedPageLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	heroTiles?: ModelTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<ModelTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined,
	cardList?: ModelTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutFeedPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutFeedPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["FeedPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutFeedPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	recurringPaymentPages?: Array<ModelTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutFeedPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutFeedPagesCreateInput"]
};
	["FeedPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["FeedPageLocaleUniqueWhere"],
	update: ModelTypes["FeedPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["FeedPageLocaleWithoutRootCreateInput"]
};
	["FeedPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	heroTiles?: ModelTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<ModelTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined,
	cardList?: ModelTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpdateInput"]: {
	root?: ModelTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	heroTiles?: ModelTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<ModelTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined,
	cardList?: ModelTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	feedPageLocale?: ModelTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"] | undefined,
	tileStripeList?: Array<ModelTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageLocaleWithoutSectionListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"] | undefined
};
	["FeedPageLocaleWithoutSectionListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	heroTiles?: ModelTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined,
	cardList?: ModelTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"]: {
	connect: ModelTypes["FeedPageLocaleUniqueWhere"],
	create: ModelTypes["FeedPageLocaleWithoutSectionListCreateInput"]
};
	["FeedPageSectionUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	feedPageLocale?: ModelTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"] | undefined,
	tileStripeList?: Array<ModelTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageLocaleWithoutSectionListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"] | undefined,
	update?: ModelTypes["FeedPageLocaleWithoutSectionListUpdateInput"] | undefined,
	upsert?: ModelTypes["FeedPageSectionUpsertFeedPageLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FeedPageLocaleWithoutSectionListUpdateInput"]: {
	root?: ModelTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	heroTiles?: ModelTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined,
	cardList?: ModelTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionUpsertFeedPageLocaleRelationInput"]: {
	update: ModelTypes["FeedPageLocaleWithoutSectionListUpdateInput"],
	create: ModelTypes["FeedPageLocaleWithoutSectionListCreateInput"]
};
	["FeedPageTileStripeCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	section?: ModelTypes["FeedPageTileStripeCreateSectionEntityRelationInput"] | undefined,
	tileList?: ModelTypes["FeedPageTileStripeCreateTileListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeCreateSectionEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"] | undefined
};
	["FeedPageSectionWithoutTileStripeListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	feedPageLocale?: ModelTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeConnectOrCreateSectionRelationInput"]: {
	connect: ModelTypes["FeedPageSectionUniqueWhere"],
	create: ModelTypes["FeedPageSectionWithoutTileStripeListCreateInput"]
};
	["FeedPageTileStripeUpdateInput"]: {
	order?: number | undefined,
	section?: ModelTypes["FeedPageTileStripeUpdateSectionEntityRelationInput"] | undefined,
	tileList?: ModelTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeUpdateSectionEntityRelationInput"]: {
	connect?: ModelTypes["FeedPageSectionUniqueWhere"] | undefined,
	create?: ModelTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"] | undefined,
	update?: ModelTypes["FeedPageSectionWithoutTileStripeListUpdateInput"] | undefined,
	upsert?: ModelTypes["FeedPageTileStripeUpsertSectionRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FeedPageSectionWithoutTileStripeListUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	feedPageLocale?: ModelTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeUpsertSectionRelationInput"]: {
	update: ModelTypes["FeedPageSectionWithoutTileStripeListUpdateInput"],
	create: ModelTypes["FeedPageSectionWithoutTileStripeListCreateInput"]
};
	["CardItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	description?: string | undefined,
	list?: ModelTypes["CardItemCreateListEntityRelationInput"] | undefined,
	link?: ModelTypes["CardItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["CardListUniqueWhere"] | undefined,
	create?: ModelTypes["CardListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CardItemConnectOrCreateListRelationInput"] | undefined
};
	["CardListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["CardListUniqueWhere"],
	create: ModelTypes["CardListWithoutItemsCreateInput"]
};
	["CardItemUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	description?: string | undefined,
	list?: ModelTypes["CardItemUpdateListEntityRelationInput"] | undefined,
	link?: ModelTypes["CardItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["CardListUniqueWhere"] | undefined,
	create?: ModelTypes["CardListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CardItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["CardListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["CardItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["CardListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["CardItemUpsertListRelationInput"]: {
	update: ModelTypes["CardListWithoutItemsUpdateInput"],
	create: ModelTypes["CardListWithoutItemsCreateInput"]
};
	["CardListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CardListEdge"]>
};
	["CardListEdge"]: {
		node: ModelTypes["CardList"]
};
	["UserPaymentTriesCollectionConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserPaymentTriesCollectionEdge"]>
};
	["UserPaymentTriesCollectionEdge"]: {
		node: ModelTypes["UserPaymentTriesCollection"]
};
	["UserPaymentTriesCollectionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	orderUrl?: string | undefined,
	payment?: Array<ModelTypes["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]> | undefined,
	user?: ModelTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"] | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"] | undefined,
	recurring?: ModelTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"] | undefined,
	metadataLocales?: Array<ModelTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]> | undefined,
	medium?: ModelTypes["PaymentMedium"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]: {
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	create?: ModelTypes["UserPaymentWithoutTriesCollectionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserPaymentWithoutTriesCollectionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"]: {
	connect: ModelTypes["UserPaymentUniqueWhere"],
	create: ModelTypes["UserPaymentWithoutTriesCollectionCreateInput"]
};
	["UserPaymentTriesCollectionUpdateInput"]: {
	cents?: number | undefined,
	specificSymbol?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	orderUrl?: string | undefined,
	payment?: Array<ModelTypes["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]> | undefined,
	user?: ModelTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"] | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	recurring?: ModelTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"] | undefined,
	metadataLocales?: Array<ModelTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]> | undefined,
	medium?: ModelTypes["PaymentMedium"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]: {
	create?: ModelTypes["UserPaymentWithoutTriesCollectionCreateInput"] | undefined,
	update?: ModelTypes["UserPaymentTriesCollectionUpdatePaymentRelationInput"] | undefined,
	upsert?: ModelTypes["UserPaymentTriesCollectionUpsertPaymentRelationInput"] | undefined,
	connect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	disconnect?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	delete?: ModelTypes["UserPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserPaymentTriesCollectionUpdatePaymentRelationInput"]: {
	by: ModelTypes["UserPaymentUniqueWhere"],
	data: ModelTypes["UserPaymentWithoutTriesCollectionUpdateInput"]
};
	["UserPaymentWithoutTriesCollectionUpdateInput"]: {
	cents?: number | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: ModelTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: ModelTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: ModelTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: ModelTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: ModelTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: ModelTypes["UserPaymentMethod"] | undefined,
	region?: ModelTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: ModelTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: ModelTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	successEmailSentAt?: ModelTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: ModelTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpsertPaymentRelationInput"]: {
	by: ModelTypes["UserPaymentUniqueWhere"],
	update: ModelTypes["UserPaymentWithoutTriesCollectionUpdateInput"],
	create: ModelTypes["UserPaymentWithoutTriesCollectionCreateInput"]
};
	["RecurringPaymentPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["RecurringPaymentPageEdge"]>
};
	["RecurringPaymentPageEdge"]: {
		node: ModelTypes["RecurringPaymentPage"]
};
	["RecurringPaymentPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["RecurringPaymentPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["RecurringPaymentPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	favouritePosts?: ModelTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutRecurringPaymentPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutRecurringPaymentPagesCreateInput"]
};
	["RecurringPaymentPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"],
	create: ModelTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"]
};
	["RecurringPaymentPageUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["RecurringPaymentPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["RecurringPaymentPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["RecurringPaymentPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RecurringPaymentPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"],
	data: ModelTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"]
};
	["RecurringPaymentPageLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	favouritePosts?: ModelTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["RecurringPaymentPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutRecurringPaymentPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<ModelTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<ModelTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<ModelTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<ModelTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<ModelTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<ModelTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: ModelTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<ModelTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<ModelTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<ModelTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<ModelTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<ModelTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<ModelTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<ModelTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutRecurringPaymentPagesCreateInput"]
};
	["RecurringPaymentPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["RecurringPaymentPageLocaleUniqueWhere"],
	update: ModelTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"]
};
	["RecurringPaymentPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	favouritePosts?: ModelTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpdateInput"]: {
	root?: ModelTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	favouritePosts?: ModelTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: ModelTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["StoryGuideEdge"]>
};
	["StoryGuideEdge"]: {
		node: ModelTypes["StoryGuide"]
};
	["StoryGuideItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["StoryGuideItemCreateListEntityRelationInput"] | undefined,
	guide?: ModelTypes["StoryGuideItemCreateGuideEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideItemConnectOrCreateListRelationInput"] | undefined
};
	["StoryGuideListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["StoryGuideListUniqueWhere"],
	create: ModelTypes["StoryGuideListWithoutItemsCreateInput"]
};
	["StoryGuideItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["StoryGuideItemUpdateListEntityRelationInput"] | undefined,
	guide?: ModelTypes["StoryGuideItemUpdateGuideEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: ModelTypes["StoryGuideListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StoryGuideItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["StoryGuideListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["StoryGuideItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["StoryGuideListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemUpsertListRelationInput"]: {
	update: ModelTypes["StoryGuideListWithoutItemsUpdateInput"],
	create: ModelTypes["StoryGuideListWithoutItemsCreateInput"]
};
	["StoryGuideListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["StoryGuideListEdge"]>
};
	["StoryGuideListEdge"]: {
		node: ModelTypes["StoryGuideList"]
};
	["StripePaymentMetadataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["StripePaymentMetadataEdge"]>
};
	["StripePaymentMetadataEdge"]: {
		node: ModelTypes["StripePaymentMetadata"]
};
	["OnBehalfDonationMetadataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["OnBehalfDonationMetadataEdge"]>
};
	["OnBehalfDonationMetadataEdge"]: {
		node: ModelTypes["OnBehalfDonationMetadata"]
};
	["UserPaymentTriesCollectionMetadataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserPaymentTriesCollectionMetadataEdge"]>
};
	["UserPaymentTriesCollectionMetadataEdge"]: {
		node: ModelTypes["UserPaymentTriesCollectionMetadata"]
};
	["CsobPaymentMetadataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CsobPaymentMetadataEdge"]>
};
	["CsobPaymentMetadataEdge"]: {
		node: ModelTypes["CsobPaymentMetadata"]
};
	["PostOrganizationListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostOrganizationListEdge"]>
};
	["PostOrganizationListEdge"]: {
		node: ModelTypes["PostOrganizationList"]
};
	["PostOrganizationListItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["PostOrganizationListItemCreateListEntityRelationInput"] | undefined,
	item?: ModelTypes["PostOrganizationListItemCreateItemEntityRelationInput"] | undefined,
	type?: ModelTypes["PostOrganizationListItemType"] | undefined,
	link?: ModelTypes["PostOrganizationListItemCreateLinkEntityRelationInput"] | undefined,
	image?: ModelTypes["PostOrganizationListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListItemConnectOrCreateListRelationInput"] | undefined
};
	["PostOrganizationListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["PostOrganizationListUniqueWhere"],
	create: ModelTypes["PostOrganizationListWithoutItemsCreateInput"]
};
	["PostOrganizationListItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["PostOrganizationListItemUpdateListEntityRelationInput"] | undefined,
	item?: ModelTypes["PostOrganizationListItemUpdateItemEntityRelationInput"] | undefined,
	type?: ModelTypes["PostOrganizationListItemType"] | undefined,
	link?: ModelTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"] | undefined,
	image?: ModelTypes["PostOrganizationListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: ModelTypes["PostOrganizationListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PostOrganizationListItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["PostOrganizationListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["PostOrganizationListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemUpsertListRelationInput"]: {
	update: ModelTypes["PostOrganizationListWithoutItemsUpdateInput"],
	create: ModelTypes["PostOrganizationListWithoutItemsCreateInput"]
};
	["InfoCarousel"]: {
		_meta?: ModelTypes["InfoCarouselMeta"] | undefined,
	id: ModelTypes["UUID"],
	name: string,
	isEnabled: boolean,
	validFrom?: ModelTypes["DateTime"] | undefined,
	validTo?: ModelTypes["DateTime"] | undefined,
	items: Array<ModelTypes["InfoCarouselItem"]>,
	seenBy: Array<ModelTypes["PersonSeenInfoCarousel"]>,
	itemsByLocales?: ModelTypes["InfoCarouselItem"] | undefined,
	seenByByUser?: ModelTypes["PersonSeenInfoCarousel"] | undefined,
	paginateItems: ModelTypes["InfoCarouselItemConnection"],
	paginateSeenBy: ModelTypes["PersonSeenInfoCarouselConnection"]
};
	["InfoCarouselMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	isEnabled?: ModelTypes["FieldMeta"] | undefined,
	validFrom?: ModelTypes["FieldMeta"] | undefined,
	validTo?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined,
	seenBy?: ModelTypes["FieldMeta"] | undefined
};
	["InfoCarouselItem"]: {
		_meta?: ModelTypes["InfoCarouselItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	title?: string | undefined,
	carousel?: ModelTypes["InfoCarousel"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	post?: ModelTypes["Post"] | undefined,
	subtitle?: string | undefined,
	type: ModelTypes["InfoCarouselItemType"],
	locales: Array<ModelTypes["InfoCarouselItemLocale"]>,
	localesByLocale?: ModelTypes["InfoCarouselItemLocale"] | undefined,
	paginateLocales: ModelTypes["InfoCarouselItemLocaleConnection"]
};
	["InfoCarouselItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	carousel?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	post?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["InfoCarouselWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	isEnabled?: ModelTypes["BooleanCondition"] | undefined,
	validFrom?: ModelTypes["DateTimeCondition"] | undefined,
	validTo?: ModelTypes["DateTimeCondition"] | undefined,
	items?: ModelTypes["InfoCarouselItemWhere"] | undefined,
	seenBy?: ModelTypes["PersonSeenInfoCarouselWhere"] | undefined,
	and?: Array<ModelTypes["InfoCarouselWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["InfoCarouselWhere"] | undefined> | undefined,
	not?: ModelTypes["InfoCarouselWhere"] | undefined
};
	["InfoCarouselItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	carousel?: ModelTypes["InfoCarouselWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	post?: ModelTypes["PostWhere"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	type?: ModelTypes["InfoCarouselItemTypeCondition"] | undefined,
	locales?: ModelTypes["InfoCarouselItemLocaleWhere"] | undefined,
	and?: Array<ModelTypes["InfoCarouselItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["InfoCarouselItemWhere"] | undefined> | undefined,
	not?: ModelTypes["InfoCarouselItemWhere"] | undefined
};
	["InfoCarouselItemTypeCondition"]: {
	and?: Array<ModelTypes["InfoCarouselItemTypeCondition"]> | undefined,
	or?: Array<ModelTypes["InfoCarouselItemTypeCondition"]> | undefined,
	not?: ModelTypes["InfoCarouselItemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["InfoCarouselItemType"] | undefined,
	notEq?: ModelTypes["InfoCarouselItemType"] | undefined,
	in?: Array<ModelTypes["InfoCarouselItemType"]> | undefined,
	notIn?: Array<ModelTypes["InfoCarouselItemType"]> | undefined,
	lt?: ModelTypes["InfoCarouselItemType"] | undefined,
	lte?: ModelTypes["InfoCarouselItemType"] | undefined,
	gt?: ModelTypes["InfoCarouselItemType"] | undefined,
	gte?: ModelTypes["InfoCarouselItemType"] | undefined
};
	["InfoCarouselItemType"]:InfoCarouselItemType;
	["InfoCarouselItemLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["InfoCarouselItemWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	and?: Array<ModelTypes["InfoCarouselItemLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["InfoCarouselItemLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["InfoCarouselItemLocaleWhere"] | undefined
};
	["PersonSeenInfoCarouselWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	seenAt?: ModelTypes["DateTimeCondition"] | undefined,
	user?: ModelTypes["UserWhere"] | undefined,
	carousel?: ModelTypes["InfoCarouselWhere"] | undefined,
	and?: Array<ModelTypes["PersonSeenInfoCarouselWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["PersonSeenInfoCarouselWhere"] | undefined> | undefined,
	not?: ModelTypes["PersonSeenInfoCarouselWhere"] | undefined
};
	["InfoCarouselItemLocale"]: {
		_meta?: ModelTypes["InfoCarouselItemLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	root?: ModelTypes["InfoCarouselItem"] | undefined,
	locale?: ModelTypes["Locale"] | undefined
};
	["InfoCarouselItemLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined
};
	["InfoCarouselItemLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["InfoCarouselItemOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined
};
	["InfoCarouselItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	carousel?: ModelTypes["InfoCarouselOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	post?: ModelTypes["PostOrderBy"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined
};
	["InfoCarouselOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	isEnabled?: ModelTypes["OrderDirection"] | undefined,
	validFrom?: ModelTypes["OrderDirection"] | undefined,
	validTo?: ModelTypes["OrderDirection"] | undefined
};
	["InfoCarouselItemLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["InfoCarouselItemLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["InfoCarouselItemLocaleEdge"]>
};
	["InfoCarouselItemLocaleEdge"]: {
		node: ModelTypes["InfoCarouselItemLocale"]
};
	["PersonSeenInfoCarousel"]: {
		_meta?: ModelTypes["PersonSeenInfoCarouselMeta"] | undefined,
	id: ModelTypes["UUID"],
	seenAt: ModelTypes["DateTime"],
	user?: ModelTypes["User"] | undefined,
	carousel?: ModelTypes["InfoCarousel"] | undefined
};
	["PersonSeenInfoCarouselMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	seenAt?: ModelTypes["FieldMeta"] | undefined,
	user?: ModelTypes["FieldMeta"] | undefined,
	carousel?: ModelTypes["FieldMeta"] | undefined
};
	["PersonSeenInfoCarouselOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	seenAt?: ModelTypes["OrderDirection"] | undefined,
	user?: ModelTypes["UserOrderBy"] | undefined,
	carousel?: ModelTypes["InfoCarouselOrderBy"] | undefined
};
	["InfoCarouselItemsByLocalesUniqueWhere"]: {
	locales?: ModelTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined
};
	["InfoCarouselItemLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["InfoCarouselItemUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["InfoCarouselItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined
};
	["InfoCarouselSeenByByUserUniqueWhere"]: {
	user?: ModelTypes["UserUniqueWhere"] | undefined
};
	["InfoCarouselItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["InfoCarouselItemEdge"]>
};
	["InfoCarouselItemEdge"]: {
		node: ModelTypes["InfoCarouselItem"]
};
	["PersonSeenInfoCarouselConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PersonSeenInfoCarouselEdge"]>
};
	["PersonSeenInfoCarouselEdge"]: {
		node: ModelTypes["PersonSeenInfoCarousel"]
};
	["InfoCarouselUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["InfoCarouselItemUniqueWhere"] | undefined,
	seenBy?: ModelTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined
};
	["PersonSeenInfoCarouselUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	user?: ModelTypes["UserUniqueWhere"] | undefined,
	carousel?: ModelTypes["InfoCarouselUniqueWhere"] | undefined
};
	["InfoCarouselConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["InfoCarouselEdge"]>
};
	["InfoCarouselEdge"]: {
		node: ModelTypes["InfoCarousel"]
};
	["InfoCarouselCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: ModelTypes["DateTime"] | undefined,
	validTo?: ModelTypes["DateTime"] | undefined,
	items?: Array<ModelTypes["InfoCarouselCreateItemsEntityRelationInput"]> | undefined,
	seenBy?: Array<ModelTypes["InfoCarouselCreateSeenByEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["InfoCarouselItemUniqueWhere"] | undefined,
	create?: ModelTypes["InfoCarouselItemWithoutCarouselCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselItemWithoutCarouselCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	image?: ModelTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined,
	post?: ModelTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: ModelTypes["InfoCarouselItemType"] | undefined,
	locales?: Array<ModelTypes["InfoCarouselItemCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemConnectOrCreateImageRelationInput"] | undefined
};
	["InfoCarouselItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["InfoCarouselItemCreatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemConnectOrCreatePostRelationInput"] | undefined
};
	["InfoCarouselItemConnectOrCreatePostRelationInput"]: {
	connect: ModelTypes["PostUniqueWhere"],
	create: ModelTypes["PostCreateInput"]
};
	["InfoCarouselItemCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselItemLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	locale?: ModelTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleCreateInput"]
};
	["InfoCarouselItemConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["InfoCarouselItemLocaleUniqueWhere"],
	create: ModelTypes["InfoCarouselItemLocaleWithoutRootCreateInput"]
};
	["InfoCarouselConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["InfoCarouselItemUniqueWhere"],
	create: ModelTypes["InfoCarouselItemWithoutCarouselCreateInput"]
};
	["InfoCarouselCreateSeenByEntityRelationInput"]: {
	connect?: ModelTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselConnectOrCreateSeenByRelationInput"] | undefined,
	alias?: string | undefined
};
	["PersonSeenInfoCarouselWithoutCarouselCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	seenAt?: ModelTypes["DateTime"] | undefined,
	user?: ModelTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselCreateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"] | undefined
};
	["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"]: {
	connect: ModelTypes["UserUniqueWhere"],
	create: ModelTypes["UserCreateInput"]
};
	["InfoCarouselConnectOrCreateSeenByRelationInput"]: {
	connect: ModelTypes["PersonSeenInfoCarouselUniqueWhere"],
	create: ModelTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"]
};
	["InfoCarouselUpdateInput"]: {
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: ModelTypes["DateTime"] | undefined,
	validTo?: ModelTypes["DateTime"] | undefined,
	items?: Array<ModelTypes["InfoCarouselUpdateItemsEntityRelationInput"]> | undefined,
	seenBy?: Array<ModelTypes["InfoCarouselUpdateSeenByEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["InfoCarouselItemWithoutCarouselCreateInput"] | undefined,
	update?: ModelTypes["InfoCarouselUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["InfoCarouselUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["InfoCarouselItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["InfoCarouselItemUniqueWhere"] | undefined,
	delete?: ModelTypes["InfoCarouselItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselUpdateItemsRelationInput"]: {
	by: ModelTypes["InfoCarouselItemUniqueWhere"],
	data: ModelTypes["InfoCarouselItemWithoutCarouselUpdateInput"]
};
	["InfoCarouselItemWithoutCarouselUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	image?: ModelTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined,
	post?: ModelTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: ModelTypes["InfoCarouselItemType"] | undefined,
	locales?: Array<ModelTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoCarouselItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["InfoCarouselItemUpdatePostEntityRelationInput"]: {
	connect?: ModelTypes["PostUniqueWhere"] | undefined,
	create?: ModelTypes["PostCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemConnectOrCreatePostRelationInput"] | undefined,
	update?: ModelTypes["PostUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoCarouselItemUpsertPostRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselItemUpsertPostRelationInput"]: {
	update: ModelTypes["PostUpdateInput"],
	create: ModelTypes["PostCreateInput"]
};
	["InfoCarouselItemUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["InfoCarouselItemUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["InfoCarouselItemUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselItemUpdateLocalesRelationInput"]: {
	by: ModelTypes["InfoCarouselItemLocaleUniqueWhere"],
	data: ModelTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"]
};
	["InfoCarouselItemLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	locale?: ModelTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoCarouselItemLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselItemLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleUpdateInput"],
	create: ModelTypes["LocaleCreateInput"]
};
	["InfoCarouselItemUpsertLocalesRelationInput"]: {
	by: ModelTypes["InfoCarouselItemLocaleUniqueWhere"],
	update: ModelTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"],
	create: ModelTypes["InfoCarouselItemLocaleWithoutRootCreateInput"]
};
	["InfoCarouselUpsertItemsRelationInput"]: {
	by: ModelTypes["InfoCarouselItemUniqueWhere"],
	update: ModelTypes["InfoCarouselItemWithoutCarouselUpdateInput"],
	create: ModelTypes["InfoCarouselItemWithoutCarouselCreateInput"]
};
	["InfoCarouselUpdateSeenByEntityRelationInput"]: {
	create?: ModelTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | undefined,
	update?: ModelTypes["InfoCarouselUpdateSeenByRelationInput"] | undefined,
	upsert?: ModelTypes["InfoCarouselUpsertSeenByRelationInput"] | undefined,
	connect?: ModelTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined,
	disconnect?: ModelTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined,
	delete?: ModelTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselUpdateSeenByRelationInput"]: {
	by: ModelTypes["PersonSeenInfoCarouselUniqueWhere"],
	data: ModelTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"]
};
	["PersonSeenInfoCarouselWithoutCarouselUpdateInput"]: {
	seenAt?: ModelTypes["DateTime"] | undefined,
	user?: ModelTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselUpdateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"] | undefined,
	update?: ModelTypes["UserUpdateInput"] | undefined,
	upsert?: ModelTypes["PersonSeenInfoCarouselUpsertUserRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PersonSeenInfoCarouselUpsertUserRelationInput"]: {
	update: ModelTypes["UserUpdateInput"],
	create: ModelTypes["UserCreateInput"]
};
	["InfoCarouselUpsertSeenByRelationInput"]: {
	by: ModelTypes["PersonSeenInfoCarouselUniqueWhere"],
	update: ModelTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"],
	create: ModelTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"]
};
	["InfoCarouselItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	carousel?: ModelTypes["InfoCarouselItemCreateCarouselEntityRelationInput"] | undefined,
	image?: ModelTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined,
	post?: ModelTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: ModelTypes["InfoCarouselItemType"] | undefined,
	locales?: Array<ModelTypes["InfoCarouselItemCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemCreateCarouselEntityRelationInput"]: {
	connect?: ModelTypes["InfoCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["InfoCarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"] | undefined
};
	["InfoCarouselWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: ModelTypes["DateTime"] | undefined,
	validTo?: ModelTypes["DateTime"] | undefined,
	seenBy?: Array<ModelTypes["InfoCarouselCreateSeenByEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemConnectOrCreateCarouselRelationInput"]: {
	connect: ModelTypes["InfoCarouselUniqueWhere"],
	create: ModelTypes["InfoCarouselWithoutItemsCreateInput"]
};
	["InfoCarouselItemUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	carousel?: ModelTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"] | undefined,
	image?: ModelTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined,
	post?: ModelTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: ModelTypes["InfoCarouselItemType"] | undefined,
	locales?: Array<ModelTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemUpdateCarouselEntityRelationInput"]: {
	connect?: ModelTypes["InfoCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["InfoCarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"] | undefined,
	update?: ModelTypes["InfoCarouselWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoCarouselItemUpsertCarouselRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselWithoutItemsUpdateInput"]: {
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: ModelTypes["DateTime"] | undefined,
	validTo?: ModelTypes["DateTime"] | undefined,
	seenBy?: Array<ModelTypes["InfoCarouselUpdateSeenByEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemUpsertCarouselRelationInput"]: {
	update: ModelTypes["InfoCarouselWithoutItemsUpdateInput"],
	create: ModelTypes["InfoCarouselWithoutItemsCreateInput"]
};
	["PersonSeenInfoCarouselCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	seenAt?: ModelTypes["DateTime"] | undefined,
	user?: ModelTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"] | undefined,
	carousel?: ModelTypes["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"]: {
	connect?: ModelTypes["InfoCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["InfoCarouselWithoutSeenByCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"] | undefined
};
	["InfoCarouselWithoutSeenByCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: ModelTypes["DateTime"] | undefined,
	validTo?: ModelTypes["DateTime"] | undefined,
	items?: Array<ModelTypes["InfoCarouselCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"]: {
	connect: ModelTypes["InfoCarouselUniqueWhere"],
	create: ModelTypes["InfoCarouselWithoutSeenByCreateInput"]
};
	["PersonSeenInfoCarouselUpdateInput"]: {
	seenAt?: ModelTypes["DateTime"] | undefined,
	user?: ModelTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"] | undefined,
	carousel?: ModelTypes["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"]: {
	connect?: ModelTypes["InfoCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["InfoCarouselWithoutSeenByCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"] | undefined,
	update?: ModelTypes["InfoCarouselWithoutSeenByUpdateInput"] | undefined,
	upsert?: ModelTypes["PersonSeenInfoCarouselUpsertCarouselRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselWithoutSeenByUpdateInput"]: {
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: ModelTypes["DateTime"] | undefined,
	validTo?: ModelTypes["DateTime"] | undefined,
	items?: Array<ModelTypes["InfoCarouselUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselUpsertCarouselRelationInput"]: {
	update: ModelTypes["InfoCarouselWithoutSeenByUpdateInput"],
	create: ModelTypes["InfoCarouselWithoutSeenByCreateInput"]
};
	["GivenGiftsPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GivenGiftsPageEdge"]>
};
	["GivenGiftsPageEdge"]: {
		node: ModelTypes["GivenGiftsPage"]
};
	["GivenGiftsPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["GivenGiftsPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GivenGiftsPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GivenGiftsPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	locale?: ModelTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: ModelTypes["GivenGiftsPageLocaleWithoutRootCreateInput"]
};
	["GivenGiftsPageUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["GivenGiftsPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["GivenGiftsPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["GivenGiftsPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GivenGiftsPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["GivenGiftsPageLocaleUniqueWhere"],
	data: ModelTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"]
};
	["GivenGiftsPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	locale?: ModelTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["GivenGiftsPageLocaleUniqueWhere"],
	update: ModelTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["GivenGiftsPageLocaleWithoutRootCreateInput"]
};
	["GivenGiftsPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: ModelTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ReceivedGiftsPageEdge"]>
};
	["ReceivedGiftsPageEdge"]: {
		node: ModelTypes["ReceivedGiftsPage"]
};
	["ReceivedGiftsPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["ReceivedGiftsPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReceivedGiftsPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: ModelTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: ModelTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"]
};
	["ReceivedGiftsPageUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["ReceivedGiftsPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["ReceivedGiftsPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReceivedGiftsPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	data: ModelTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"]
};
	["ReceivedGiftsPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: ModelTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	update: ModelTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: ModelTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: ModelTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ReportNavigationEdge"]>
};
	["ReportNavigationEdge"]: {
		node: ModelTypes["ReportNavigation"]
};
	["ReportNavigationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["ReportNavigationCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReportNavigationLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportNavigationConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined,
	pages?: Array<ModelTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	create: ModelTypes["ReportNavigationLocaleWithoutRootCreateInput"]
};
	["ReportNavigationUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["ReportNavigationUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["ReportNavigationLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["ReportNavigationUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["ReportNavigationUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationUpdateLocalesRelationInput"]: {
	by: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	data: ModelTypes["ReportNavigationLocaleWithoutRootUpdateInput"]
};
	["ReportNavigationLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	pages?: Array<ModelTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationUpsertLocalesRelationInput"]: {
	by: ModelTypes["ReportNavigationLocaleUniqueWhere"],
	update: ModelTypes["ReportNavigationLocaleWithoutRootUpdateInput"],
	create: ModelTypes["ReportNavigationLocaleWithoutRootCreateInput"]
};
	["ReportPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ReportPageEdge"]>
};
	["ReportPageEdge"]: {
		node: ModelTypes["ReportPage"]
};
	["ReportPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["ReportPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ReportPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ReportPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	posts?: Array<ModelTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["ReportPageLocaleUniqueWhere"],
	create: ModelTypes["ReportPageLocaleWithoutRootCreateInput"]
};
	["ReportPageUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["ReportPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["ReportPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["ReportPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["ReportPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ReportPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReportPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["ReportPageLocaleUniqueWhere"],
	data: ModelTypes["ReportPageLocaleWithoutRootUpdateInput"]
};
	["ReportPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	posts?: Array<ModelTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["ReportPageLocaleUniqueWhere"],
	update: ModelTypes["ReportPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["ReportPageLocaleWithoutRootCreateInput"]
};
	["ReportPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	posts?: Array<ModelTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: ModelTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: ModelTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	posts?: Array<ModelTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined,
	pages?: Array<ModelTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleUpdateInput"]: {
	root?: ModelTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	pages?: Array<ModelTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: ModelTypes["DateTime"] | undefined,
	currency?: ModelTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined,
	area?: ModelTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined,
	organization?: ModelTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: ModelTypes["DateTime"] | undefined,
	currency?: ModelTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	area?: ModelTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined,
	organization?: ModelTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaSentPaymentSumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaSentPaymentSumEdge"]>
};
	["PostAreaSentPaymentSumEdge"]: {
		node: ModelTypes["PostAreaSentPaymentSum"]
};
	["NotificationTargetGroupConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["NotificationTargetGroupEdge"]>
};
	["NotificationTargetGroupEdge"]: {
		node: ModelTypes["NotificationTargetGroup"]
};
	["ProcessedNotificationConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ProcessedNotificationEdge"]>
};
	["ProcessedNotificationEdge"]: {
		node: ModelTypes["ProcessedNotification"]
};
	["ProcessedNotificationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	topic?: string | undefined,
	sentAt?: ModelTypes["DateTime"] | undefined,
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess?: boolean | undefined,
	source?: ModelTypes["ProcessedNotificationCreateSourceEntityRelationInput"] | undefined,
	title?: string | undefined,
	body?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationCreateSourceEntityRelationInput"]: {
	connect?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	create?: ModelTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"] | undefined
};
	["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	donationReminderUser?: ModelTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined,
	scheduledNotification?: ModelTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationConnectOrCreateSourceRelationInput"]: {
	connect: ModelTypes["ProcessedNotificationSourceUniqueWhere"],
	create: ModelTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]
};
	["ProcessedNotificationUpdateInput"]: {
	topic?: string | undefined,
	sentAt?: ModelTypes["DateTime"] | undefined,
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess?: boolean | undefined,
	source?: ModelTypes["ProcessedNotificationUpdateSourceEntityRelationInput"] | undefined,
	title?: string | undefined,
	body?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationUpdateSourceEntityRelationInput"]: {
	connect?: ModelTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	create?: ModelTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"] | undefined,
	update?: ModelTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"] | undefined,
	upsert?: ModelTypes["ProcessedNotificationUpsertSourceRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"]: {
	type?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	donationReminderUser?: ModelTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined,
	scheduledNotification?: ModelTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationUpsertSourceRelationInput"]: {
	update: ModelTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"],
	create: ModelTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]
};
	["ScheduledNotificationConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ScheduledNotificationEdge"]>
};
	["ScheduledNotificationEdge"]: {
		node: ModelTypes["ScheduledNotification"]
};
	["ScheduledNotificationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	localMsFromMidnight?: number | undefined,
	scheduledDate?: ModelTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: ModelTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["ScheduledNotificationCreateLocalesEntityRelationInput"]> | undefined,
	image?: ModelTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined,
	completedAt?: ModelTypes["DateTime"] | undefined,
	processedNotifications?: Array<ModelTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationUpdateInput"]: {
	localMsFromMidnight?: number | undefined,
	scheduledDate?: ModelTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: ModelTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"]> | undefined,
	image?: ModelTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined,
	completedAt?: ModelTypes["DateTime"] | undefined,
	processedNotifications?: Array<ModelTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined,
	donationReminderUser?: ModelTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined,
	scheduledNotification?: ModelTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceUpdateInput"]: {
	type?: ModelTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: ModelTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined,
	donationReminderUser?: ModelTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined,
	scheduledNotification?: ModelTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	user?: ModelTypes["DeviceCreateUserEntityRelationInput"] | undefined,
	fcmToken?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceCreateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutDevicesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DeviceConnectOrCreateUserRelationInput"] | undefined
};
	["UserWithoutDevicesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	processedNotifications?: Array<ModelTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceConnectOrCreateUserRelationInput"]: {
	connect: ModelTypes["UserUniqueWhere"],
	create: ModelTypes["UserWithoutDevicesCreateInput"]
};
	["DeviceUpdateInput"]: {
	user?: ModelTypes["DeviceUpdateUserEntityRelationInput"] | undefined,
	fcmToken?: string | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceUpdateUserEntityRelationInput"]: {
	connect?: ModelTypes["UserUniqueWhere"] | undefined,
	create?: ModelTypes["UserWithoutDevicesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["DeviceConnectOrCreateUserRelationInput"] | undefined,
	update?: ModelTypes["UserWithoutDevicesUpdateInput"] | undefined,
	upsert?: ModelTypes["DeviceUpsertUserRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["UserWithoutDevicesUpdateInput"]: {
	tenantPersonId?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<ModelTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: ModelTypes["DateTime"] | undefined,
	region?: ModelTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: ModelTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<ModelTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<ModelTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: ModelTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	processedNotifications?: Array<ModelTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<ModelTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<ModelTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<ModelTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<ModelTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceUpsertUserRelationInput"]: {
	update: ModelTypes["UserWithoutDevicesUpdateInput"],
	create: ModelTypes["UserWithoutDevicesCreateInput"]
};
	["ScheduledNotificationLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	root?: ModelTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleUpdateInput"]: {
	title?: string | undefined,
	description?: string | undefined,
	root?: ModelTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	root?: ModelTypes["InfoCarouselItemLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["InfoCarouselItemUniqueWhere"] | undefined,
	create?: ModelTypes["InfoCarouselItemWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["InfoCarouselItemWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	carousel?: ModelTypes["InfoCarouselItemCreateCarouselEntityRelationInput"] | undefined,
	image?: ModelTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined,
	post?: ModelTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: ModelTypes["InfoCarouselItemType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["InfoCarouselItemUniqueWhere"],
	create: ModelTypes["InfoCarouselItemWithoutLocalesCreateInput"]
};
	["InfoCarouselItemLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	root?: ModelTypes["InfoCarouselItemLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["InfoCarouselItemUniqueWhere"] | undefined,
	create?: ModelTypes["InfoCarouselItemWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["InfoCarouselItemWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoCarouselItemLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselItemWithoutLocalesUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	carousel?: ModelTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"] | undefined,
	image?: ModelTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined,
	post?: ModelTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: ModelTypes["InfoCarouselItemType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["InfoCarouselItemWithoutLocalesUpdateInput"],
	create: ModelTypes["InfoCarouselItemWithoutLocalesCreateInput"]
};
	["SentPaymentLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	organizationText?: string | undefined,
	root?: ModelTypes["SentPaymentLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleUpdateInput"]: {
	organizationText?: string | undefined,
	root?: ModelTypes["SentPaymentLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentMetadataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserPaymentMetadataEdge"]>
};
	["UserPaymentMetadataEdge"]: {
		node: ModelTypes["UserPaymentMetadata"]
};
	["PostAreaSumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostAreaSumEdge"]>
};
	["PostAreaSumEdge"]: {
		node: ModelTypes["PostAreaSum"]
};
	["PostOrganizationSumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostOrganizationSumEdge"]>
};
	["PostOrganizationSumEdge"]: {
		node: ModelTypes["PostOrganizationSum"]
};
	["Stats"]: {
		_meta?: ModelTypes["StatsMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	totalUserCount: number,
	successfulPaymentCount: number,
	sentPaymentCount: number,
	totalAreaCents: number,
	totalAreaSentPaymentCents: number,
	totalAreaCzkPercentage: number,
	totalAreaSentPaymentCzkPercentage: number
};
	["StatsMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	totalUserCount?: ModelTypes["FieldMeta"] | undefined,
	successfulPaymentCount?: ModelTypes["FieldMeta"] | undefined,
	sentPaymentCount?: ModelTypes["FieldMeta"] | undefined,
	totalAreaCents?: ModelTypes["FieldMeta"] | undefined,
	totalAreaSentPaymentCents?: ModelTypes["FieldMeta"] | undefined,
	totalAreaCzkPercentage?: ModelTypes["FieldMeta"] | undefined,
	totalAreaSentPaymentCzkPercentage?: ModelTypes["FieldMeta"] | undefined
};
	["StatsUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined
};
	["StatsWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	totalUserCount?: ModelTypes["IntCondition"] | undefined,
	successfulPaymentCount?: ModelTypes["IntCondition"] | undefined,
	sentPaymentCount?: ModelTypes["IntCondition"] | undefined,
	totalAreaCents?: ModelTypes["IntCondition"] | undefined,
	totalAreaSentPaymentCents?: ModelTypes["IntCondition"] | undefined,
	totalAreaCzkPercentage?: ModelTypes["FloatCondition"] | undefined,
	totalAreaSentPaymentCzkPercentage?: ModelTypes["FloatCondition"] | undefined,
	and?: Array<ModelTypes["StatsWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["StatsWhere"] | undefined> | undefined,
	not?: ModelTypes["StatsWhere"] | undefined
};
	["StatsOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	totalUserCount?: ModelTypes["OrderDirection"] | undefined,
	successfulPaymentCount?: ModelTypes["OrderDirection"] | undefined,
	sentPaymentCount?: ModelTypes["OrderDirection"] | undefined,
	totalAreaCents?: ModelTypes["OrderDirection"] | undefined,
	totalAreaSentPaymentCents?: ModelTypes["OrderDirection"] | undefined,
	totalAreaCzkPercentage?: ModelTypes["OrderDirection"] | undefined,
	totalAreaSentPaymentCzkPercentage?: ModelTypes["OrderDirection"] | undefined
};
	["StatsConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["StatsEdge"]>
};
	["StatsEdge"]: {
		node: ModelTypes["Stats"]
};
	["UserRecurringPaymentItemMetadataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserRecurringPaymentItemMetadataEdge"]>
};
	["UserRecurringPaymentItemMetadataEdge"]: {
		node: ModelTypes["UserRecurringPaymentItemMetadata"]
};
	["UpcomingUserRecurringPaymentMetadataConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UpcomingUserRecurringPaymentMetadataEdge"]>
};
	["UpcomingUserRecurringPaymentMetadataEdge"]: {
		node: ModelTypes["UpcomingUserRecurringPaymentMetadata"]
};
	["UserStatsConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["UserStatsEdge"]>
};
	["UserStatsEdge"]: {
		node: ModelTypes["UserStats"]
};
	["TextImageListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TextImageListEdge"]>
};
	["TextImageListEdge"]: {
		node: ModelTypes["TextImageList"]
};
	["TextImageListItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["TextImageListItemCreateListEntityRelationInput"] | undefined,
	image?: ModelTypes["TextImageListItemCreateImageEntityRelationInput"] | undefined,
	text?: string | undefined,
	link?: ModelTypes["TextImageListItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["TextImageListUniqueWhere"] | undefined,
	create?: ModelTypes["TextImageListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextImageListItemConnectOrCreateListRelationInput"] | undefined
};
	["TextImageListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["TextImageListUniqueWhere"],
	create: ModelTypes["TextImageListWithoutItemsCreateInput"]
};
	["TextImageListItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["TextImageListItemUpdateListEntityRelationInput"] | undefined,
	image?: ModelTypes["TextImageListItemUpdateImageEntityRelationInput"] | undefined,
	text?: string | undefined,
	link?: ModelTypes["TextImageListItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["TextImageListUniqueWhere"] | undefined,
	create?: ModelTypes["TextImageListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextImageListItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["TextImageListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["TextImageListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TextImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemUpsertListRelationInput"]: {
	update: ModelTypes["TextImageListWithoutItemsUpdateInput"],
	create: ModelTypes["TextImageListWithoutItemsCreateInput"]
};
	["PostSumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostSumEdge"]>
};
	["PostSumEdge"]: {
		node: ModelTypes["PostSum"]
};
	["PostFundraisingProgressConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["PostFundraisingProgressEdge"]>
};
	["PostFundraisingProgressEdge"]: {
		node: ModelTypes["PostFundraisingProgress"]
};
	["HeroCarouselItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["Date"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["HeroCarouselItemCreateListEntityRelationInput"] | undefined,
	item?: ModelTypes["HeroCarouselItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["HeroCarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeroCarouselItemConnectOrCreateListRelationInput"] | undefined
};
	["HeroCarouselWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["Date"] | undefined,
	posts?: Array<ModelTypes["HeroCarouselCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["HeroCarouselUniqueWhere"],
	create: ModelTypes["HeroCarouselWithoutItemsCreateInput"]
};
	["HeroCarouselItemUpdateInput"]: {
	createdAt?: ModelTypes["Date"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["HeroCarouselItemUpdateListEntityRelationInput"] | undefined,
	item?: ModelTypes["HeroCarouselItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: ModelTypes["HeroCarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeroCarouselItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["HeroCarouselWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["HeroCarouselItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HeroCarouselWithoutItemsUpdateInput"]: {
	createdAt?: ModelTypes["Date"] | undefined,
	posts?: Array<ModelTypes["HeroCarouselUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemUpsertListRelationInput"]: {
	update: ModelTypes["HeroCarouselWithoutItemsUpdateInput"],
	create: ModelTypes["HeroCarouselWithoutItemsCreateInput"]
};
	["QueryTransaction"]: {
		schema?: ModelTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined,
	getGeneral?: ModelTypes["General"] | undefined,
	listGeneral: Array<ModelTypes["General"]>,
	paginateGeneral: ModelTypes["GeneralConnection"],
	validateCreateGeneral: ModelTypes["_ValidationResult"],
	validateUpdateGeneral: ModelTypes["_ValidationResult"],
	getImage?: ModelTypes["Image"] | undefined,
	listImage: Array<ModelTypes["Image"]>,
	paginateImage: ModelTypes["ImageConnection"],
	validateCreateImage: ModelTypes["_ValidationResult"],
	validateUpdateImage: ModelTypes["_ValidationResult"],
	getGenericPage?: ModelTypes["GenericPage"] | undefined,
	listGenericPage: Array<ModelTypes["GenericPage"]>,
	paginateGenericPage: ModelTypes["GenericPageConnection"],
	validateCreateGenericPage: ModelTypes["_ValidationResult"],
	validateUpdateGenericPage: ModelTypes["_ValidationResult"],
	getLinkable?: ModelTypes["Linkable"] | undefined,
	listLinkable: Array<ModelTypes["Linkable"]>,
	paginateLinkable: ModelTypes["LinkableConnection"],
	validateCreateLinkable: ModelTypes["_ValidationResult"],
	validateUpdateLinkable: ModelTypes["_ValidationResult"],
	getSeo?: ModelTypes["Seo"] | undefined,
	listSeo: Array<ModelTypes["Seo"]>,
	paginateSeo: ModelTypes["SeoConnection"],
	validateCreateSeo: ModelTypes["_ValidationResult"],
	validateUpdateSeo: ModelTypes["_ValidationResult"],
	getContent?: ModelTypes["Content"] | undefined,
	listContent: Array<ModelTypes["Content"]>,
	paginateContent: ModelTypes["ContentConnection"],
	validateCreateContent: ModelTypes["_ValidationResult"],
	validateUpdateContent: ModelTypes["_ValidationResult"],
	getContentBlock?: ModelTypes["ContentBlock"] | undefined,
	listContentBlock: Array<ModelTypes["ContentBlock"]>,
	paginateContentBlock: ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock: ModelTypes["_ValidationResult"],
	validateUpdateContentBlock: ModelTypes["_ValidationResult"],
	getContentReference?: ModelTypes["ContentReference"] | undefined,
	listContentReference: Array<ModelTypes["ContentReference"]>,
	paginateContentReference: ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference: ModelTypes["_ValidationResult"],
	validateUpdateContentReference: ModelTypes["_ValidationResult"],
	getContentReferenceLinkableItem?: ModelTypes["ContentReferenceLinkableItem"] | undefined,
	listContentReferenceLinkableItem: Array<ModelTypes["ContentReferenceLinkableItem"]>,
	paginateContentReferenceLinkableItem: ModelTypes["ContentReferenceLinkableItemConnection"],
	getGeneralLocale?: ModelTypes["GeneralLocale"] | undefined,
	listGeneralLocale: Array<ModelTypes["GeneralLocale"]>,
	paginateGeneralLocale: ModelTypes["GeneralLocaleConnection"],
	validateCreateGeneralLocale: ModelTypes["_ValidationResult"],
	validateUpdateGeneralLocale: ModelTypes["_ValidationResult"],
	getGenericPageLocale?: ModelTypes["GenericPageLocale"] | undefined,
	listGenericPageLocale: Array<ModelTypes["GenericPageLocale"]>,
	paginateGenericPageLocale: ModelTypes["GenericPageLocaleConnection"],
	validateCreateGenericPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageLocale: ModelTypes["_ValidationResult"],
	getLocale?: ModelTypes["Locale"] | undefined,
	listLocale: Array<ModelTypes["Locale"]>,
	paginateLocale: ModelTypes["LocaleConnection"],
	validateCreateLocale: ModelTypes["_ValidationResult"],
	validateUpdateLocale: ModelTypes["_ValidationResult"],
	getVideo?: ModelTypes["Video"] | undefined,
	listVideo: Array<ModelTypes["Video"]>,
	paginateVideo: ModelTypes["VideoConnection"],
	validateCreateVideo: ModelTypes["_ValidationResult"],
	validateUpdateVideo: ModelTypes["_ValidationResult"],
	getLink?: ModelTypes["Link"] | undefined,
	listLink: Array<ModelTypes["Link"]>,
	paginateLink: ModelTypes["LinkConnection"],
	validateCreateLink: ModelTypes["_ValidationResult"],
	validateUpdateLink: ModelTypes["_ValidationResult"],
	getPost?: ModelTypes["Post"] | undefined,
	listPost: Array<ModelTypes["Post"]>,
	paginatePost: ModelTypes["PostConnection"],
	validateCreatePost: ModelTypes["_ValidationResult"],
	validateUpdatePost: ModelTypes["_ValidationResult"],
	getPostLocale?: ModelTypes["PostLocale"] | undefined,
	listPostLocale: Array<ModelTypes["PostLocale"]>,
	paginatePostLocale: ModelTypes["PostLocaleConnection"],
	validateCreatePostLocale: ModelTypes["_ValidationResult"],
	validateUpdatePostLocale: ModelTypes["_ValidationResult"],
	getPostArea?: ModelTypes["PostArea"] | undefined,
	listPostArea: Array<ModelTypes["PostArea"]>,
	paginatePostArea: ModelTypes["PostAreaConnection"],
	validateCreatePostArea: ModelTypes["_ValidationResult"],
	validateUpdatePostArea: ModelTypes["_ValidationResult"],
	getPostAreaLocale?: ModelTypes["PostAreaLocale"] | undefined,
	listPostAreaLocale: Array<ModelTypes["PostAreaLocale"]>,
	paginatePostAreaLocale: ModelTypes["PostAreaLocaleConnection"],
	validateCreatePostAreaLocale: ModelTypes["_ValidationResult"],
	validateUpdatePostAreaLocale: ModelTypes["_ValidationResult"],
	getPostOrganization?: ModelTypes["PostOrganization"] | undefined,
	listPostOrganization: Array<ModelTypes["PostOrganization"]>,
	paginatePostOrganization: ModelTypes["PostOrganizationConnection"],
	validateCreatePostOrganization: ModelTypes["_ValidationResult"],
	validateUpdatePostOrganization: ModelTypes["_ValidationResult"],
	getPostOrganizationLocale?: ModelTypes["PostOrganizationLocale"] | undefined,
	listPostOrganizationLocale: Array<ModelTypes["PostOrganizationLocale"]>,
	paginatePostOrganizationLocale: ModelTypes["PostOrganizationLocaleConnection"],
	validateCreatePostOrganizationLocale: ModelTypes["_ValidationResult"],
	validateUpdatePostOrganizationLocale: ModelTypes["_ValidationResult"],
	getDonation?: ModelTypes["Donation"] | undefined,
	listDonation: Array<ModelTypes["Donation"]>,
	paginateDonation: ModelTypes["DonationConnection"],
	validateCreateDonation: ModelTypes["_ValidationResult"],
	validateUpdateDonation: ModelTypes["_ValidationResult"],
	getDonationAmountItem?: ModelTypes["DonationAmountItem"] | undefined,
	listDonationAmountItem: Array<ModelTypes["DonationAmountItem"]>,
	paginateDonationAmountItem: ModelTypes["DonationAmountItemConnection"],
	validateCreateDonationAmountItem: ModelTypes["_ValidationResult"],
	validateUpdateDonationAmountItem: ModelTypes["_ValidationResult"],
	getDonationAmountsRegionItem?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	listDonationAmountsRegionItem: Array<ModelTypes["DonationAmountsRegionItem"]>,
	paginateDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemConnection"],
	validateCreateDonationAmountsRegionItem: ModelTypes["_ValidationResult"],
	validateUpdateDonationAmountsRegionItem: ModelTypes["_ValidationResult"],
	getDonationAmountsRegionList?: ModelTypes["DonationAmountsRegionList"] | undefined,
	listDonationAmountsRegionList: Array<ModelTypes["DonationAmountsRegionList"]>,
	paginateDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListConnection"],
	validateCreateDonationAmountsRegionList: ModelTypes["_ValidationResult"],
	validateUpdateDonationAmountsRegionList: ModelTypes["_ValidationResult"],
	getRegion?: ModelTypes["Region"] | undefined,
	listRegion: Array<ModelTypes["Region"]>,
	paginateRegion: ModelTypes["RegionConnection"],
	validateCreateRegion: ModelTypes["_ValidationResult"],
	validateUpdateRegion: ModelTypes["_ValidationResult"],
	getLinkItem?: ModelTypes["LinkItem"] | undefined,
	listLinkItem: Array<ModelTypes["LinkItem"]>,
	paginateLinkItem: ModelTypes["LinkItemConnection"],
	validateCreateLinkItem: ModelTypes["_ValidationResult"],
	validateUpdateLinkItem: ModelTypes["_ValidationResult"],
	getLinkList?: ModelTypes["LinkList"] | undefined,
	listLinkList: Array<ModelTypes["LinkList"]>,
	paginateLinkList: ModelTypes["LinkListConnection"],
	validateCreateLinkList: ModelTypes["_ValidationResult"],
	validateUpdateLinkList: ModelTypes["_ValidationResult"],
	getHeader?: ModelTypes["Header"] | undefined,
	listHeader: Array<ModelTypes["Header"]>,
	paginateHeader: ModelTypes["HeaderConnection"],
	validateCreateHeader: ModelTypes["_ValidationResult"],
	validateUpdateHeader: ModelTypes["_ValidationResult"],
	getHeaderLocale?: ModelTypes["HeaderLocale"] | undefined,
	listHeaderLocale: Array<ModelTypes["HeaderLocale"]>,
	paginateHeaderLocale: ModelTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: ModelTypes["_ValidationResult"],
	validateUpdateHeaderLocale: ModelTypes["_ValidationResult"],
	getFooter?: ModelTypes["Footer"] | undefined,
	listFooter: Array<ModelTypes["Footer"]>,
	paginateFooter: ModelTypes["FooterConnection"],
	validateCreateFooter: ModelTypes["_ValidationResult"],
	validateUpdateFooter: ModelTypes["_ValidationResult"],
	getFooterLocale?: ModelTypes["FooterLocale"] | undefined,
	listFooterLocale: Array<ModelTypes["FooterLocale"]>,
	paginateFooterLocale: ModelTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: ModelTypes["_ValidationResult"],
	validateUpdateFooterLocale: ModelTypes["_ValidationResult"],
	getPostList?: ModelTypes["PostList"] | undefined,
	listPostList: Array<ModelTypes["PostList"]>,
	paginatePostList: ModelTypes["PostListConnection"],
	validateCreatePostList: ModelTypes["_ValidationResult"],
	validateUpdatePostList: ModelTypes["_ValidationResult"],
	getPostListItem?: ModelTypes["PostListItem"] | undefined,
	listPostListItem: Array<ModelTypes["PostListItem"]>,
	paginatePostListItem: ModelTypes["PostListItemConnection"],
	validateCreatePostListItem: ModelTypes["_ValidationResult"],
	validateUpdatePostListItem: ModelTypes["_ValidationResult"],
	getAppBanner?: ModelTypes["AppBanner"] | undefined,
	listAppBanner: Array<ModelTypes["AppBanner"]>,
	paginateAppBanner: ModelTypes["AppBannerConnection"],
	validateCreateAppBanner: ModelTypes["_ValidationResult"],
	validateUpdateAppBanner: ModelTypes["_ValidationResult"],
	getGenericPageAboutSettings?: ModelTypes["GenericPageAboutSettings"] | undefined,
	listGenericPageAboutSettings: Array<ModelTypes["GenericPageAboutSettings"]>,
	paginateGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsConnection"],
	validateCreateGenericPageAboutSettings: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageAboutSettings: ModelTypes["_ValidationResult"],
	getGenericPageAboutSettingsLocale?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	listGenericPageAboutSettingsLocale: Array<ModelTypes["GenericPageAboutSettingsLocale"]>,
	paginateGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleConnection"],
	validateCreateGenericPageAboutSettingsLocale: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageAboutSettingsLocale: ModelTypes["_ValidationResult"],
	getValue?: ModelTypes["Value"] | undefined,
	listValue: Array<ModelTypes["Value"]>,
	paginateValue: ModelTypes["ValueConnection"],
	validateCreateValue: ModelTypes["_ValidationResult"],
	validateUpdateValue: ModelTypes["_ValidationResult"],
	getValueItem?: ModelTypes["ValueItem"] | undefined,
	listValueItem: Array<ModelTypes["ValueItem"]>,
	paginateValueItem: ModelTypes["ValueItemConnection"],
	validateCreateValueItem: ModelTypes["_ValidationResult"],
	validateUpdateValueItem: ModelTypes["_ValidationResult"],
	getValueList?: ModelTypes["ValueList"] | undefined,
	listValueList: Array<ModelTypes["ValueList"]>,
	paginateValueList: ModelTypes["ValueListConnection"],
	validateCreateValueList: ModelTypes["_ValidationResult"],
	validateUpdateValueList: ModelTypes["_ValidationResult"],
	getImageLink?: ModelTypes["ImageLink"] | undefined,
	listImageLink: Array<ModelTypes["ImageLink"]>,
	paginateImageLink: ModelTypes["ImageLinkConnection"],
	validateCreateImageLink: ModelTypes["_ValidationResult"],
	validateUpdateImageLink: ModelTypes["_ValidationResult"],
	getImageLinkItem?: ModelTypes["ImageLinkItem"] | undefined,
	listImageLinkItem: Array<ModelTypes["ImageLinkItem"]>,
	paginateImageLinkItem: ModelTypes["ImageLinkItemConnection"],
	validateCreateImageLinkItem: ModelTypes["_ValidationResult"],
	validateUpdateImageLinkItem: ModelTypes["_ValidationResult"],
	getImageLinkList?: ModelTypes["ImageLinkList"] | undefined,
	listImageLinkList: Array<ModelTypes["ImageLinkList"]>,
	paginateImageLinkList: ModelTypes["ImageLinkListConnection"],
	validateCreateImageLinkList: ModelTypes["_ValidationResult"],
	validateUpdateImageLinkList: ModelTypes["_ValidationResult"],
	getPostAreaList?: ModelTypes["PostAreaList"] | undefined,
	listPostAreaList: Array<ModelTypes["PostAreaList"]>,
	paginatePostAreaList: ModelTypes["PostAreaListConnection"],
	validateCreatePostAreaList: ModelTypes["_ValidationResult"],
	validateUpdatePostAreaList: ModelTypes["_ValidationResult"],
	getPostAreaListItem?: ModelTypes["PostAreaListItem"] | undefined,
	listPostAreaListItem: Array<ModelTypes["PostAreaListItem"]>,
	paginatePostAreaListItem: ModelTypes["PostAreaListItemConnection"],
	validateCreatePostAreaListItem: ModelTypes["_ValidationResult"],
	validateUpdatePostAreaListItem: ModelTypes["_ValidationResult"],
	getAccordion?: ModelTypes["Accordion"] | undefined,
	listAccordion: Array<ModelTypes["Accordion"]>,
	paginateAccordion: ModelTypes["AccordionConnection"],
	validateCreateAccordion: ModelTypes["_ValidationResult"],
	validateUpdateAccordion: ModelTypes["_ValidationResult"],
	getAccordionItem?: ModelTypes["AccordionItem"] | undefined,
	listAccordionItem: Array<ModelTypes["AccordionItem"]>,
	paginateAccordionItem: ModelTypes["AccordionItemConnection"],
	validateCreateAccordionItem: ModelTypes["_ValidationResult"],
	validateUpdateAccordionItem: ModelTypes["_ValidationResult"],
	getUser?: ModelTypes["User"] | undefined,
	listUser: Array<ModelTypes["User"]>,
	paginateUser: ModelTypes["UserConnection"],
	validateCreateUser: ModelTypes["_ValidationResult"],
	validateUpdateUser: ModelTypes["_ValidationResult"],
	getUserPayment?: ModelTypes["UserPayment"] | undefined,
	listUserPayment: Array<ModelTypes["UserPayment"]>,
	paginateUserPayment: ModelTypes["UserPaymentConnection"],
	validateCreateUserPayment: ModelTypes["_ValidationResult"],
	validateUpdateUserPayment: ModelTypes["_ValidationResult"],
	getCurrency?: ModelTypes["Currency"] | undefined,
	listCurrency: Array<ModelTypes["Currency"]>,
	paginateCurrency: ModelTypes["CurrencyConnection"],
	validateCreateCurrency: ModelTypes["_ValidationResult"],
	validateUpdateCurrency: ModelTypes["_ValidationResult"],
	getMedium?: ModelTypes["Medium"] | undefined,
	listMedium: Array<ModelTypes["Medium"]>,
	paginateMedium: ModelTypes["MediumConnection"],
	validateCreateMedium: ModelTypes["_ValidationResult"],
	validateUpdateMedium: ModelTypes["_ValidationResult"],
	getMediumItem?: ModelTypes["MediumItem"] | undefined,
	listMediumItem: Array<ModelTypes["MediumItem"]>,
	paginateMediumItem: ModelTypes["MediumItemConnection"],
	validateCreateMediumItem: ModelTypes["_ValidationResult"],
	validateUpdateMediumItem: ModelTypes["_ValidationResult"],
	getMediumList?: ModelTypes["MediumList"] | undefined,
	listMediumList: Array<ModelTypes["MediumList"]>,
	paginateMediumList: ModelTypes["MediumListConnection"],
	validateCreateMediumList: ModelTypes["_ValidationResult"],
	validateUpdateMediumList: ModelTypes["_ValidationResult"],
	getUserPaymentOrderId?: ModelTypes["UserPaymentOrderId"] | undefined,
	listUserPaymentOrderId: Array<ModelTypes["UserPaymentOrderId"]>,
	paginateUserPaymentOrderId: ModelTypes["UserPaymentOrderIdConnection"],
	validateCreateUserPaymentOrderId: ModelTypes["_ValidationResult"],
	validateUpdateUserPaymentOrderId: ModelTypes["_ValidationResult"],
	getPostRevision?: ModelTypes["PostRevision"] | undefined,
	listPostRevision: Array<ModelTypes["PostRevision"]>,
	paginatePostRevision: ModelTypes["PostRevisionConnection"],
	validateCreatePostRevision: ModelTypes["_ValidationResult"],
	validateUpdatePostRevision: ModelTypes["_ValidationResult"],
	getUserRecurringPayment?: ModelTypes["UserRecurringPayment"] | undefined,
	listUserRecurringPayment: Array<ModelTypes["UserRecurringPayment"]>,
	paginateUserRecurringPayment: ModelTypes["UserRecurringPaymentConnection"],
	validateCreateUserRecurringPayment: ModelTypes["_ValidationResult"],
	validateUpdateUserRecurringPayment: ModelTypes["_ValidationResult"],
	getUserRecurringPaymentItem?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	listUserRecurringPaymentItem: Array<ModelTypes["UserRecurringPaymentItem"]>,
	paginateUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemConnection"],
	validateCreateUserRecurringPaymentItem: ModelTypes["_ValidationResult"],
	validateUpdateUserRecurringPaymentItem: ModelTypes["_ValidationResult"],
	getPostRevisionLocale?: ModelTypes["PostRevisionLocale"] | undefined,
	listPostRevisionLocale: Array<ModelTypes["PostRevisionLocale"]>,
	paginatePostRevisionLocale: ModelTypes["PostRevisionLocaleConnection"],
	validateCreatePostRevisionLocale: ModelTypes["_ValidationResult"],
	validateUpdatePostRevisionLocale: ModelTypes["_ValidationResult"],
	getTranslationCatalogue?: ModelTypes["TranslationCatalogue"] | undefined,
	listTranslationCatalogue: Array<ModelTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: ModelTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: ModelTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: ModelTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: ModelTypes["TranslationCataloguesIdentifier"] | undefined,
	listTranslationCataloguesIdentifier: Array<ModelTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: ModelTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: ModelTypes["_ValidationResult"],
	getTranslationDomain?: ModelTypes["TranslationDomain"] | undefined,
	listTranslationDomain: Array<ModelTypes["TranslationDomain"]>,
	paginateTranslationDomain: ModelTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: ModelTypes["_ValidationResult"],
	validateUpdateTranslationDomain: ModelTypes["_ValidationResult"],
	getTranslationKey?: ModelTypes["TranslationKey"] | undefined,
	listTranslationKey: Array<ModelTypes["TranslationKey"]>,
	paginateTranslationKey: ModelTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: ModelTypes["_ValidationResult"],
	validateUpdateTranslationKey: ModelTypes["_ValidationResult"],
	getTranslationValue?: ModelTypes["TranslationValue"] | undefined,
	listTranslationValue: Array<ModelTypes["TranslationValue"]>,
	paginateTranslationValue: ModelTypes["TranslationValueConnection"],
	validateCreateTranslationValue: ModelTypes["_ValidationResult"],
	validateUpdateTranslationValue: ModelTypes["_ValidationResult"],
	getGenericPageAboutGroupLinksLocale?: ModelTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	listGenericPageAboutGroupLinksLocale: Array<ModelTypes["GenericPageAboutGroupLinksLocale"]>,
	paginateGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleConnection"],
	validateCreateGenericPageAboutGroupLinksLocale: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageAboutGroupLinksLocale: ModelTypes["_ValidationResult"],
	getMemberList?: ModelTypes["MemberList"] | undefined,
	listMemberList: Array<ModelTypes["MemberList"]>,
	paginateMemberList: ModelTypes["MemberListConnection"],
	validateCreateMemberList: ModelTypes["_ValidationResult"],
	validateUpdateMemberList: ModelTypes["_ValidationResult"],
	getMemberListItem?: ModelTypes["MemberListItem"] | undefined,
	listMemberListItem: Array<ModelTypes["MemberListItem"]>,
	paginateMemberListItem: ModelTypes["MemberListItemConnection"],
	validateCreateMemberListItem: ModelTypes["_ValidationResult"],
	validateUpdateMemberListItem: ModelTypes["_ValidationResult"],
	getFilledTaxForm?: ModelTypes["FilledTaxForm"] | undefined,
	listFilledTaxForm: Array<ModelTypes["FilledTaxForm"]>,
	paginateFilledTaxForm: ModelTypes["FilledTaxFormConnection"],
	validateCreateFilledTaxForm: ModelTypes["_ValidationResult"],
	validateUpdateFilledTaxForm: ModelTypes["_ValidationResult"],
	getFilledTaxFormEmailAddress?: ModelTypes["FilledTaxFormEmailAddress"] | undefined,
	listFilledTaxFormEmailAddress: Array<ModelTypes["FilledTaxFormEmailAddress"]>,
	paginateFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressConnection"],
	validateCreateFilledTaxFormEmailAddress: ModelTypes["_ValidationResult"],
	validateUpdateFilledTaxFormEmailAddress: ModelTypes["_ValidationResult"],
	getForm?: ModelTypes["Form"] | undefined,
	listForm: Array<ModelTypes["Form"]>,
	paginateForm: ModelTypes["FormConnection"],
	validateCreateForm: ModelTypes["_ValidationResult"],
	validateUpdateForm: ModelTypes["_ValidationResult"],
	getCsobPayment?: ModelTypes["CsobPayment"] | undefined,
	listCsobPayment: Array<ModelTypes["CsobPayment"]>,
	paginateCsobPayment: ModelTypes["CsobPaymentConnection"],
	validateCreateCsobPayment: ModelTypes["_ValidationResult"],
	validateUpdateCsobPayment: ModelTypes["_ValidationResult"],
	getCsobPaymentStatusChange?: ModelTypes["CsobPaymentStatusChange"] | undefined,
	listCsobPaymentStatusChange: Array<ModelTypes["CsobPaymentStatusChange"]>,
	paginateCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeConnection"],
	validateCreateCsobPaymentStatusChange: ModelTypes["_ValidationResult"],
	validateUpdateCsobPaymentStatusChange: ModelTypes["_ValidationResult"],
	getStripePayment?: ModelTypes["StripePayment"] | undefined,
	listStripePayment: Array<ModelTypes["StripePayment"]>,
	paginateStripePayment: ModelTypes["StripePaymentConnection"],
	validateCreateStripePayment: ModelTypes["_ValidationResult"],
	validateUpdateStripePayment: ModelTypes["_ValidationResult"],
	getStripePaymentStatusChange?: ModelTypes["StripePaymentStatusChange"] | undefined,
	listStripePaymentStatusChange: Array<ModelTypes["StripePaymentStatusChange"]>,
	paginateStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeConnection"],
	validateCreateStripePaymentStatusChange: ModelTypes["_ValidationResult"],
	validateUpdateStripePaymentStatusChange: ModelTypes["_ValidationResult"],
	getRegionPaymentMethod?: ModelTypes["RegionPaymentMethod"] | undefined,
	listRegionPaymentMethod: Array<ModelTypes["RegionPaymentMethod"]>,
	paginateRegionPaymentMethod: ModelTypes["RegionPaymentMethodConnection"],
	validateCreateRegionPaymentMethod: ModelTypes["_ValidationResult"],
	validateUpdateRegionPaymentMethod: ModelTypes["_ValidationResult"],
	getPostAreaMetaData?: ModelTypes["PostAreaMetaData"] | undefined,
	listPostAreaMetaData: Array<ModelTypes["PostAreaMetaData"]>,
	paginatePostAreaMetaData: ModelTypes["PostAreaMetaDataConnection"],
	getPostMetaData?: ModelTypes["PostMetaData"] | undefined,
	listPostMetaData: Array<ModelTypes["PostMetaData"]>,
	paginatePostMetaData: ModelTypes["PostMetaDataConnection"],
	getPostOrganizationMetaData?: ModelTypes["PostOrganizationMetaData"] | undefined,
	listPostOrganizationMetaData: Array<ModelTypes["PostOrganizationMetaData"]>,
	paginatePostOrganizationMetaData: ModelTypes["PostOrganizationMetaDataConnection"],
	getTileItem?: ModelTypes["TileItem"] | undefined,
	listTileItem: Array<ModelTypes["TileItem"]>,
	paginateTileItem: ModelTypes["TileItemConnection"],
	validateCreateTileItem: ModelTypes["_ValidationResult"],
	validateUpdateTileItem: ModelTypes["_ValidationResult"],
	getTileList?: ModelTypes["TileList"] | undefined,
	listTileList: Array<ModelTypes["TileList"]>,
	paginateTileList: ModelTypes["TileListConnection"],
	validateCreateTileList: ModelTypes["_ValidationResult"],
	validateUpdateTileList: ModelTypes["_ValidationResult"],
	getFeedPage?: ModelTypes["FeedPage"] | undefined,
	listFeedPage: Array<ModelTypes["FeedPage"]>,
	paginateFeedPage: ModelTypes["FeedPageConnection"],
	validateCreateFeedPage: ModelTypes["_ValidationResult"],
	validateUpdateFeedPage: ModelTypes["_ValidationResult"],
	getFeedPageLocale?: ModelTypes["FeedPageLocale"] | undefined,
	listFeedPageLocale: Array<ModelTypes["FeedPageLocale"]>,
	paginateFeedPageLocale: ModelTypes["FeedPageLocaleConnection"],
	validateCreateFeedPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateFeedPageLocale: ModelTypes["_ValidationResult"],
	getFeedPageSection?: ModelTypes["FeedPageSection"] | undefined,
	listFeedPageSection: Array<ModelTypes["FeedPageSection"]>,
	paginateFeedPageSection: ModelTypes["FeedPageSectionConnection"],
	validateCreateFeedPageSection: ModelTypes["_ValidationResult"],
	validateUpdateFeedPageSection: ModelTypes["_ValidationResult"],
	getFeedPageTileStripe?: ModelTypes["FeedPageTileStripe"] | undefined,
	listFeedPageTileStripe: Array<ModelTypes["FeedPageTileStripe"]>,
	paginateFeedPageTileStripe: ModelTypes["FeedPageTileStripeConnection"],
	validateCreateFeedPageTileStripe: ModelTypes["_ValidationResult"],
	validateUpdateFeedPageTileStripe: ModelTypes["_ValidationResult"],
	getCardItem?: ModelTypes["CardItem"] | undefined,
	listCardItem: Array<ModelTypes["CardItem"]>,
	paginateCardItem: ModelTypes["CardItemConnection"],
	validateCreateCardItem: ModelTypes["_ValidationResult"],
	validateUpdateCardItem: ModelTypes["_ValidationResult"],
	getCardList?: ModelTypes["CardList"] | undefined,
	listCardList: Array<ModelTypes["CardList"]>,
	paginateCardList: ModelTypes["CardListConnection"],
	validateCreateCardList: ModelTypes["_ValidationResult"],
	validateUpdateCardList: ModelTypes["_ValidationResult"],
	getOnBehalfDonation?: ModelTypes["OnBehalfDonation"] | undefined,
	listOnBehalfDonation: Array<ModelTypes["OnBehalfDonation"]>,
	paginateOnBehalfDonation: ModelTypes["OnBehalfDonationConnection"],
	validateCreateOnBehalfDonation: ModelTypes["_ValidationResult"],
	validateUpdateOnBehalfDonation: ModelTypes["_ValidationResult"],
	getUserPaymentTriesCollection?: ModelTypes["UserPaymentTriesCollection"] | undefined,
	listUserPaymentTriesCollection: Array<ModelTypes["UserPaymentTriesCollection"]>,
	paginateUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionConnection"],
	validateCreateUserPaymentTriesCollection: ModelTypes["_ValidationResult"],
	validateUpdateUserPaymentTriesCollection: ModelTypes["_ValidationResult"],
	getRecurringPaymentPage?: ModelTypes["RecurringPaymentPage"] | undefined,
	listRecurringPaymentPage: Array<ModelTypes["RecurringPaymentPage"]>,
	paginateRecurringPaymentPage: ModelTypes["RecurringPaymentPageConnection"],
	validateCreateRecurringPaymentPage: ModelTypes["_ValidationResult"],
	validateUpdateRecurringPaymentPage: ModelTypes["_ValidationResult"],
	getRecurringPaymentPageLocale?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	listRecurringPaymentPageLocale: Array<ModelTypes["RecurringPaymentPageLocale"]>,
	paginateRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleConnection"],
	validateCreateRecurringPaymentPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateRecurringPaymentPageLocale: ModelTypes["_ValidationResult"],
	getStoryGuide?: ModelTypes["StoryGuide"] | undefined,
	listStoryGuide: Array<ModelTypes["StoryGuide"]>,
	paginateStoryGuide: ModelTypes["StoryGuideConnection"],
	validateCreateStoryGuide: ModelTypes["_ValidationResult"],
	validateUpdateStoryGuide: ModelTypes["_ValidationResult"],
	getStoryGuideItem?: ModelTypes["StoryGuideItem"] | undefined,
	listStoryGuideItem: Array<ModelTypes["StoryGuideItem"]>,
	paginateStoryGuideItem: ModelTypes["StoryGuideItemConnection"],
	validateCreateStoryGuideItem: ModelTypes["_ValidationResult"],
	validateUpdateStoryGuideItem: ModelTypes["_ValidationResult"],
	getStoryGuideList?: ModelTypes["StoryGuideList"] | undefined,
	listStoryGuideList: Array<ModelTypes["StoryGuideList"]>,
	paginateStoryGuideList: ModelTypes["StoryGuideListConnection"],
	validateCreateStoryGuideList: ModelTypes["_ValidationResult"],
	validateUpdateStoryGuideList: ModelTypes["_ValidationResult"],
	getStripePaymentMetadata?: ModelTypes["StripePaymentMetadata"] | undefined,
	listStripePaymentMetadata: Array<ModelTypes["StripePaymentMetadata"]>,
	paginateStripePaymentMetadata: ModelTypes["StripePaymentMetadataConnection"],
	getOnBehalfDonationMetadata?: ModelTypes["OnBehalfDonationMetadata"] | undefined,
	listOnBehalfDonationMetadata: Array<ModelTypes["OnBehalfDonationMetadata"]>,
	paginateOnBehalfDonationMetadata: ModelTypes["OnBehalfDonationMetadataConnection"],
	getUserPaymentTriesCollectionMetadata?: ModelTypes["UserPaymentTriesCollectionMetadata"] | undefined,
	listUserPaymentTriesCollectionMetadata: Array<ModelTypes["UserPaymentTriesCollectionMetadata"]>,
	paginateUserPaymentTriesCollectionMetadata: ModelTypes["UserPaymentTriesCollectionMetadataConnection"],
	getUserPaymentTriesCollectionMetadataLocale?: ModelTypes["UserPaymentTriesCollectionMetadataLocale"] | undefined,
	listUserPaymentTriesCollectionMetadataLocale: Array<ModelTypes["UserPaymentTriesCollectionMetadataLocale"]>,
	paginateUserPaymentTriesCollectionMetadataLocale: ModelTypes["UserPaymentTriesCollectionMetadataLocaleConnection"],
	getCsobPaymentMetadata?: ModelTypes["CsobPaymentMetadata"] | undefined,
	listCsobPaymentMetadata: Array<ModelTypes["CsobPaymentMetadata"]>,
	paginateCsobPaymentMetadata: ModelTypes["CsobPaymentMetadataConnection"],
	getHeroCarousel?: ModelTypes["HeroCarousel"] | undefined,
	listHeroCarousel: Array<ModelTypes["HeroCarousel"]>,
	paginateHeroCarousel: ModelTypes["HeroCarouselConnection"],
	validateCreateHeroCarousel: ModelTypes["_ValidationResult"],
	validateUpdateHeroCarousel: ModelTypes["_ValidationResult"],
	getPostOrganizationList?: ModelTypes["PostOrganizationList"] | undefined,
	listPostOrganizationList: Array<ModelTypes["PostOrganizationList"]>,
	paginatePostOrganizationList: ModelTypes["PostOrganizationListConnection"],
	validateCreatePostOrganizationList: ModelTypes["_ValidationResult"],
	validateUpdatePostOrganizationList: ModelTypes["_ValidationResult"],
	getPostOrganizationListItem?: ModelTypes["PostOrganizationListItem"] | undefined,
	listPostOrganizationListItem: Array<ModelTypes["PostOrganizationListItem"]>,
	paginatePostOrganizationListItem: ModelTypes["PostOrganizationListItemConnection"],
	validateCreatePostOrganizationListItem: ModelTypes["_ValidationResult"],
	validateUpdatePostOrganizationListItem: ModelTypes["_ValidationResult"],
	getInfoCarousel?: ModelTypes["InfoCarousel"] | undefined,
	listInfoCarousel: Array<ModelTypes["InfoCarousel"]>,
	paginateInfoCarousel: ModelTypes["InfoCarouselConnection"],
	validateCreateInfoCarousel: ModelTypes["_ValidationResult"],
	validateUpdateInfoCarousel: ModelTypes["_ValidationResult"],
	getInfoCarouselItem?: ModelTypes["InfoCarouselItem"] | undefined,
	listInfoCarouselItem: Array<ModelTypes["InfoCarouselItem"]>,
	paginateInfoCarouselItem: ModelTypes["InfoCarouselItemConnection"],
	validateCreateInfoCarouselItem: ModelTypes["_ValidationResult"],
	validateUpdateInfoCarouselItem: ModelTypes["_ValidationResult"],
	getPersonSeenInfoCarousel?: ModelTypes["PersonSeenInfoCarousel"] | undefined,
	listPersonSeenInfoCarousel: Array<ModelTypes["PersonSeenInfoCarousel"]>,
	paginatePersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselConnection"],
	validateCreatePersonSeenInfoCarousel: ModelTypes["_ValidationResult"],
	validateUpdatePersonSeenInfoCarousel: ModelTypes["_ValidationResult"],
	getGivenGiftsPage?: ModelTypes["GivenGiftsPage"] | undefined,
	listGivenGiftsPage: Array<ModelTypes["GivenGiftsPage"]>,
	paginateGivenGiftsPage: ModelTypes["GivenGiftsPageConnection"],
	validateCreateGivenGiftsPage: ModelTypes["_ValidationResult"],
	validateUpdateGivenGiftsPage: ModelTypes["_ValidationResult"],
	getGivenGiftsPageLocale?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	listGivenGiftsPageLocale: Array<ModelTypes["GivenGiftsPageLocale"]>,
	paginateGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleConnection"],
	validateCreateGivenGiftsPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateGivenGiftsPageLocale: ModelTypes["_ValidationResult"],
	getReceivedGiftsPage?: ModelTypes["ReceivedGiftsPage"] | undefined,
	listReceivedGiftsPage: Array<ModelTypes["ReceivedGiftsPage"]>,
	paginateReceivedGiftsPage: ModelTypes["ReceivedGiftsPageConnection"],
	validateCreateReceivedGiftsPage: ModelTypes["_ValidationResult"],
	validateUpdateReceivedGiftsPage: ModelTypes["_ValidationResult"],
	getReceivedGiftsPageLocale?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	listReceivedGiftsPageLocale: Array<ModelTypes["ReceivedGiftsPageLocale"]>,
	paginateReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleConnection"],
	validateCreateReceivedGiftsPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateReceivedGiftsPageLocale: ModelTypes["_ValidationResult"],
	getReportNavigation?: ModelTypes["ReportNavigation"] | undefined,
	listReportNavigation: Array<ModelTypes["ReportNavigation"]>,
	paginateReportNavigation: ModelTypes["ReportNavigationConnection"],
	validateCreateReportNavigation: ModelTypes["_ValidationResult"],
	validateUpdateReportNavigation: ModelTypes["_ValidationResult"],
	getReportPage?: ModelTypes["ReportPage"] | undefined,
	listReportPage: Array<ModelTypes["ReportPage"]>,
	paginateReportPage: ModelTypes["ReportPageConnection"],
	validateCreateReportPage: ModelTypes["_ValidationResult"],
	validateUpdateReportPage: ModelTypes["_ValidationResult"],
	getReportPageLocale?: ModelTypes["ReportPageLocale"] | undefined,
	listReportPageLocale: Array<ModelTypes["ReportPageLocale"]>,
	paginateReportPageLocale: ModelTypes["ReportPageLocaleConnection"],
	validateCreateReportPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateReportPageLocale: ModelTypes["_ValidationResult"],
	getReportNavigationLocale?: ModelTypes["ReportNavigationLocale"] | undefined,
	listReportNavigationLocale: Array<ModelTypes["ReportNavigationLocale"]>,
	paginateReportNavigationLocale: ModelTypes["ReportNavigationLocaleConnection"],
	validateCreateReportNavigationLocale: ModelTypes["_ValidationResult"],
	validateUpdateReportNavigationLocale: ModelTypes["_ValidationResult"],
	getSentPayment?: ModelTypes["SentPayment"] | undefined,
	listSentPayment: Array<ModelTypes["SentPayment"]>,
	paginateSentPayment: ModelTypes["SentPaymentConnection"],
	validateCreateSentPayment: ModelTypes["_ValidationResult"],
	validateUpdateSentPayment: ModelTypes["_ValidationResult"],
	getPostAreaSentPaymentCurrencySum?: ModelTypes["PostAreaSentPaymentCurrencySum"] | undefined,
	listPostAreaSentPaymentCurrencySum: Array<ModelTypes["PostAreaSentPaymentCurrencySum"]>,
	paginatePostAreaSentPaymentCurrencySum: ModelTypes["PostAreaSentPaymentCurrencySumConnection"],
	getPostAreaSentPaymentSum?: ModelTypes["PostAreaSentPaymentSum"] | undefined,
	listPostAreaSentPaymentSum: Array<ModelTypes["PostAreaSentPaymentSum"]>,
	paginatePostAreaSentPaymentSum: ModelTypes["PostAreaSentPaymentSumConnection"],
	getNotificationTargetGroup?: ModelTypes["NotificationTargetGroup"] | undefined,
	listNotificationTargetGroup: Array<ModelTypes["NotificationTargetGroup"]>,
	paginateNotificationTargetGroup: ModelTypes["NotificationTargetGroupConnection"],
	validateCreateNotificationTargetGroup: ModelTypes["_ValidationResult"],
	validateUpdateNotificationTargetGroup: ModelTypes["_ValidationResult"],
	getProcessedNotification?: ModelTypes["ProcessedNotification"] | undefined,
	listProcessedNotification: Array<ModelTypes["ProcessedNotification"]>,
	paginateProcessedNotification: ModelTypes["ProcessedNotificationConnection"],
	validateCreateProcessedNotification: ModelTypes["_ValidationResult"],
	validateUpdateProcessedNotification: ModelTypes["_ValidationResult"],
	getScheduledNotification?: ModelTypes["ScheduledNotification"] | undefined,
	listScheduledNotification: Array<ModelTypes["ScheduledNotification"]>,
	paginateScheduledNotification: ModelTypes["ScheduledNotificationConnection"],
	validateCreateScheduledNotification: ModelTypes["_ValidationResult"],
	validateUpdateScheduledNotification: ModelTypes["_ValidationResult"],
	getProcessedNotificationSource?: ModelTypes["ProcessedNotificationSource"] | undefined,
	listProcessedNotificationSource: Array<ModelTypes["ProcessedNotificationSource"]>,
	paginateProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceConnection"],
	validateCreateProcessedNotificationSource: ModelTypes["_ValidationResult"],
	validateUpdateProcessedNotificationSource: ModelTypes["_ValidationResult"],
	getDevice?: ModelTypes["Device"] | undefined,
	listDevice: Array<ModelTypes["Device"]>,
	paginateDevice: ModelTypes["DeviceConnection"],
	validateCreateDevice: ModelTypes["_ValidationResult"],
	validateUpdateDevice: ModelTypes["_ValidationResult"],
	getScheduledNotificationLocale?: ModelTypes["ScheduledNotificationLocale"] | undefined,
	listScheduledNotificationLocale: Array<ModelTypes["ScheduledNotificationLocale"]>,
	paginateScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleConnection"],
	validateCreateScheduledNotificationLocale: ModelTypes["_ValidationResult"],
	validateUpdateScheduledNotificationLocale: ModelTypes["_ValidationResult"],
	getInfoCarouselItemLocale?: ModelTypes["InfoCarouselItemLocale"] | undefined,
	listInfoCarouselItemLocale: Array<ModelTypes["InfoCarouselItemLocale"]>,
	paginateInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleConnection"],
	validateCreateInfoCarouselItemLocale: ModelTypes["_ValidationResult"],
	validateUpdateInfoCarouselItemLocale: ModelTypes["_ValidationResult"],
	getSentPaymentLocale?: ModelTypes["SentPaymentLocale"] | undefined,
	listSentPaymentLocale: Array<ModelTypes["SentPaymentLocale"]>,
	paginateSentPaymentLocale: ModelTypes["SentPaymentLocaleConnection"],
	validateCreateSentPaymentLocale: ModelTypes["_ValidationResult"],
	validateUpdateSentPaymentLocale: ModelTypes["_ValidationResult"],
	getUserPaymentMetadata?: ModelTypes["UserPaymentMetadata"] | undefined,
	listUserPaymentMetadata: Array<ModelTypes["UserPaymentMetadata"]>,
	paginateUserPaymentMetadata: ModelTypes["UserPaymentMetadataConnection"],
	getPostAreaCurrencySum?: ModelTypes["PostAreaCurrencySum"] | undefined,
	listPostAreaCurrencySum: Array<ModelTypes["PostAreaCurrencySum"]>,
	paginatePostAreaCurrencySum: ModelTypes["PostAreaCurrencySumConnection"],
	getPostAreaSum?: ModelTypes["PostAreaSum"] | undefined,
	listPostAreaSum: Array<ModelTypes["PostAreaSum"]>,
	paginatePostAreaSum: ModelTypes["PostAreaSumConnection"],
	getPostOrganizationCurrencySum?: ModelTypes["PostOrganizationCurrencySum"] | undefined,
	listPostOrganizationCurrencySum: Array<ModelTypes["PostOrganizationCurrencySum"]>,
	paginatePostOrganizationCurrencySum: ModelTypes["PostOrganizationCurrencySumConnection"],
	getPostOrganizationSum?: ModelTypes["PostOrganizationSum"] | undefined,
	listPostOrganizationSum: Array<ModelTypes["PostOrganizationSum"]>,
	paginatePostOrganizationSum: ModelTypes["PostOrganizationSumConnection"],
	getStats?: ModelTypes["Stats"] | undefined,
	listStats: Array<ModelTypes["Stats"]>,
	paginateStats: ModelTypes["StatsConnection"],
	getUserRecurringPaymentItemMetadata?: ModelTypes["UserRecurringPaymentItemMetadata"] | undefined,
	listUserRecurringPaymentItemMetadata: Array<ModelTypes["UserRecurringPaymentItemMetadata"]>,
	paginateUserRecurringPaymentItemMetadata: ModelTypes["UserRecurringPaymentItemMetadataConnection"],
	getUpcomingUserRecurringPaymentMetadata?: ModelTypes["UpcomingUserRecurringPaymentMetadata"] | undefined,
	listUpcomingUserRecurringPaymentMetadata: Array<ModelTypes["UpcomingUserRecurringPaymentMetadata"]>,
	paginateUpcomingUserRecurringPaymentMetadata: ModelTypes["UpcomingUserRecurringPaymentMetadataConnection"],
	getUserAreaStats?: ModelTypes["UserAreaStats"] | undefined,
	listUserAreaStats: Array<ModelTypes["UserAreaStats"]>,
	paginateUserAreaStats: ModelTypes["UserAreaStatsConnection"],
	getUserCurrencyStats?: ModelTypes["UserCurrencyStats"] | undefined,
	listUserCurrencyStats: Array<ModelTypes["UserCurrencyStats"]>,
	paginateUserCurrencyStats: ModelTypes["UserCurrencyStatsConnection"],
	getUserOrganizationStats?: ModelTypes["UserOrganizationStats"] | undefined,
	listUserOrganizationStats: Array<ModelTypes["UserOrganizationStats"]>,
	paginateUserOrganizationStats: ModelTypes["UserOrganizationStatsConnection"],
	getUserPostStats?: ModelTypes["UserPostStats"] | undefined,
	listUserPostStats: Array<ModelTypes["UserPostStats"]>,
	paginateUserPostStats: ModelTypes["UserPostStatsConnection"],
	getUserStats?: ModelTypes["UserStats"] | undefined,
	listUserStats: Array<ModelTypes["UserStats"]>,
	paginateUserStats: ModelTypes["UserStatsConnection"],
	getTextImageList?: ModelTypes["TextImageList"] | undefined,
	listTextImageList: Array<ModelTypes["TextImageList"]>,
	paginateTextImageList: ModelTypes["TextImageListConnection"],
	validateCreateTextImageList: ModelTypes["_ValidationResult"],
	validateUpdateTextImageList: ModelTypes["_ValidationResult"],
	getTextImageListItem?: ModelTypes["TextImageListItem"] | undefined,
	listTextImageListItem: Array<ModelTypes["TextImageListItem"]>,
	paginateTextImageListItem: ModelTypes["TextImageListItemConnection"],
	validateCreateTextImageListItem: ModelTypes["_ValidationResult"],
	validateUpdateTextImageListItem: ModelTypes["_ValidationResult"],
	getPostCurrencySum?: ModelTypes["PostCurrencySum"] | undefined,
	listPostCurrencySum: Array<ModelTypes["PostCurrencySum"]>,
	paginatePostCurrencySum: ModelTypes["PostCurrencySumConnection"],
	getPostSum?: ModelTypes["PostSum"] | undefined,
	listPostSum: Array<ModelTypes["PostSum"]>,
	paginatePostSum: ModelTypes["PostSumConnection"],
	getPostFundraisingProgress?: ModelTypes["PostFundraisingProgress"] | undefined,
	listPostFundraisingProgress: Array<ModelTypes["PostFundraisingProgress"]>,
	paginatePostFundraisingProgress: ModelTypes["PostFundraisingProgressConnection"],
	getHeroCarouselItem?: ModelTypes["HeroCarouselItem"] | undefined,
	listHeroCarouselItem: Array<ModelTypes["HeroCarouselItem"]>,
	paginateHeroCarouselItem: ModelTypes["HeroCarouselItemConnection"],
	validateCreateHeroCarouselItem: ModelTypes["_ValidationResult"],
	validateUpdateHeroCarouselItem: ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?: string | undefined
};
	["Mutation"]: {
		generateUploadUrl: ModelTypes["S3SignedUpload"],
	generateReadUrl: ModelTypes["S3SignedRead"],
	createGeneral: ModelTypes["GeneralCreateResult"],
	deleteGeneral: ModelTypes["GeneralDeleteResult"],
	updateGeneral: ModelTypes["GeneralUpdateResult"],
	upsertGeneral: ModelTypes["GeneralUpsertResult"],
	createImage: ModelTypes["ImageCreateResult"],
	deleteImage: ModelTypes["ImageDeleteResult"],
	updateImage: ModelTypes["ImageUpdateResult"],
	upsertImage: ModelTypes["ImageUpsertResult"],
	createGenericPage: ModelTypes["GenericPageCreateResult"],
	deleteGenericPage: ModelTypes["GenericPageDeleteResult"],
	updateGenericPage: ModelTypes["GenericPageUpdateResult"],
	upsertGenericPage: ModelTypes["GenericPageUpsertResult"],
	createLinkable: ModelTypes["LinkableCreateResult"],
	deleteLinkable: ModelTypes["LinkableDeleteResult"],
	updateLinkable: ModelTypes["LinkableUpdateResult"],
	upsertLinkable: ModelTypes["LinkableUpsertResult"],
	createSeo: ModelTypes["SeoCreateResult"],
	deleteSeo: ModelTypes["SeoDeleteResult"],
	updateSeo: ModelTypes["SeoUpdateResult"],
	upsertSeo: ModelTypes["SeoUpsertResult"],
	createContent: ModelTypes["ContentCreateResult"],
	deleteContent: ModelTypes["ContentDeleteResult"],
	updateContent: ModelTypes["ContentUpdateResult"],
	upsertContent: ModelTypes["ContentUpsertResult"],
	createContentBlock: ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock: ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock: ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock: ModelTypes["ContentBlockUpsertResult"],
	createContentReference: ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference: ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference: ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference: ModelTypes["ContentReferenceUpsertResult"],
	createGeneralLocale: ModelTypes["GeneralLocaleCreateResult"],
	deleteGeneralLocale: ModelTypes["GeneralLocaleDeleteResult"],
	updateGeneralLocale: ModelTypes["GeneralLocaleUpdateResult"],
	upsertGeneralLocale: ModelTypes["GeneralLocaleUpsertResult"],
	createGenericPageLocale: ModelTypes["GenericPageLocaleCreateResult"],
	deleteGenericPageLocale: ModelTypes["GenericPageLocaleDeleteResult"],
	updateGenericPageLocale: ModelTypes["GenericPageLocaleUpdateResult"],
	upsertGenericPageLocale: ModelTypes["GenericPageLocaleUpsertResult"],
	createLocale: ModelTypes["LocaleCreateResult"],
	deleteLocale: ModelTypes["LocaleDeleteResult"],
	updateLocale: ModelTypes["LocaleUpdateResult"],
	upsertLocale: ModelTypes["LocaleUpsertResult"],
	createVideo: ModelTypes["VideoCreateResult"],
	deleteVideo: ModelTypes["VideoDeleteResult"],
	updateVideo: ModelTypes["VideoUpdateResult"],
	upsertVideo: ModelTypes["VideoUpsertResult"],
	createLink: ModelTypes["LinkCreateResult"],
	deleteLink: ModelTypes["LinkDeleteResult"],
	updateLink: ModelTypes["LinkUpdateResult"],
	upsertLink: ModelTypes["LinkUpsertResult"],
	createPost: ModelTypes["PostCreateResult"],
	deletePost: ModelTypes["PostDeleteResult"],
	updatePost: ModelTypes["PostUpdateResult"],
	upsertPost: ModelTypes["PostUpsertResult"],
	createPostLocale: ModelTypes["PostLocaleCreateResult"],
	deletePostLocale: ModelTypes["PostLocaleDeleteResult"],
	updatePostLocale: ModelTypes["PostLocaleUpdateResult"],
	upsertPostLocale: ModelTypes["PostLocaleUpsertResult"],
	createPostArea: ModelTypes["PostAreaCreateResult"],
	deletePostArea: ModelTypes["PostAreaDeleteResult"],
	updatePostArea: ModelTypes["PostAreaUpdateResult"],
	upsertPostArea: ModelTypes["PostAreaUpsertResult"],
	createPostAreaLocale: ModelTypes["PostAreaLocaleCreateResult"],
	deletePostAreaLocale: ModelTypes["PostAreaLocaleDeleteResult"],
	updatePostAreaLocale: ModelTypes["PostAreaLocaleUpdateResult"],
	upsertPostAreaLocale: ModelTypes["PostAreaLocaleUpsertResult"],
	createPostOrganization: ModelTypes["PostOrganizationCreateResult"],
	deletePostOrganization: ModelTypes["PostOrganizationDeleteResult"],
	updatePostOrganization: ModelTypes["PostOrganizationUpdateResult"],
	upsertPostOrganization: ModelTypes["PostOrganizationUpsertResult"],
	createPostOrganizationLocale: ModelTypes["PostOrganizationLocaleCreateResult"],
	deletePostOrganizationLocale: ModelTypes["PostOrganizationLocaleDeleteResult"],
	updatePostOrganizationLocale: ModelTypes["PostOrganizationLocaleUpdateResult"],
	upsertPostOrganizationLocale: ModelTypes["PostOrganizationLocaleUpsertResult"],
	createDonation: ModelTypes["DonationCreateResult"],
	deleteDonation: ModelTypes["DonationDeleteResult"],
	updateDonation: ModelTypes["DonationUpdateResult"],
	upsertDonation: ModelTypes["DonationUpsertResult"],
	createDonationAmountItem: ModelTypes["DonationAmountItemCreateResult"],
	deleteDonationAmountItem: ModelTypes["DonationAmountItemDeleteResult"],
	updateDonationAmountItem: ModelTypes["DonationAmountItemUpdateResult"],
	upsertDonationAmountItem: ModelTypes["DonationAmountItemUpsertResult"],
	createDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemCreateResult"],
	deleteDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemDeleteResult"],
	updateDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemUpdateResult"],
	upsertDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemUpsertResult"],
	createDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListCreateResult"],
	deleteDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListDeleteResult"],
	updateDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListUpdateResult"],
	upsertDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListUpsertResult"],
	createRegion: ModelTypes["RegionCreateResult"],
	deleteRegion: ModelTypes["RegionDeleteResult"],
	updateRegion: ModelTypes["RegionUpdateResult"],
	upsertRegion: ModelTypes["RegionUpsertResult"],
	createLinkItem: ModelTypes["LinkItemCreateResult"],
	deleteLinkItem: ModelTypes["LinkItemDeleteResult"],
	updateLinkItem: ModelTypes["LinkItemUpdateResult"],
	upsertLinkItem: ModelTypes["LinkItemUpsertResult"],
	createLinkList: ModelTypes["LinkListCreateResult"],
	deleteLinkList: ModelTypes["LinkListDeleteResult"],
	updateLinkList: ModelTypes["LinkListUpdateResult"],
	upsertLinkList: ModelTypes["LinkListUpsertResult"],
	createHeader: ModelTypes["HeaderCreateResult"],
	deleteHeader: ModelTypes["HeaderDeleteResult"],
	updateHeader: ModelTypes["HeaderUpdateResult"],
	upsertHeader: ModelTypes["HeaderUpsertResult"],
	createHeaderLocale: ModelTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: ModelTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: ModelTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: ModelTypes["HeaderLocaleUpsertResult"],
	createFooter: ModelTypes["FooterCreateResult"],
	deleteFooter: ModelTypes["FooterDeleteResult"],
	updateFooter: ModelTypes["FooterUpdateResult"],
	upsertFooter: ModelTypes["FooterUpsertResult"],
	createFooterLocale: ModelTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: ModelTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: ModelTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: ModelTypes["FooterLocaleUpsertResult"],
	createPostList: ModelTypes["PostListCreateResult"],
	deletePostList: ModelTypes["PostListDeleteResult"],
	updatePostList: ModelTypes["PostListUpdateResult"],
	upsertPostList: ModelTypes["PostListUpsertResult"],
	createPostListItem: ModelTypes["PostListItemCreateResult"],
	deletePostListItem: ModelTypes["PostListItemDeleteResult"],
	updatePostListItem: ModelTypes["PostListItemUpdateResult"],
	upsertPostListItem: ModelTypes["PostListItemUpsertResult"],
	createAppBanner: ModelTypes["AppBannerCreateResult"],
	deleteAppBanner: ModelTypes["AppBannerDeleteResult"],
	updateAppBanner: ModelTypes["AppBannerUpdateResult"],
	upsertAppBanner: ModelTypes["AppBannerUpsertResult"],
	createGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsCreateResult"],
	deleteGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsDeleteResult"],
	updateGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsUpdateResult"],
	upsertGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsUpsertResult"],
	createGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleCreateResult"],
	deleteGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleDeleteResult"],
	updateGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleUpdateResult"],
	upsertGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleUpsertResult"],
	createValue: ModelTypes["ValueCreateResult"],
	deleteValue: ModelTypes["ValueDeleteResult"],
	updateValue: ModelTypes["ValueUpdateResult"],
	upsertValue: ModelTypes["ValueUpsertResult"],
	createValueItem: ModelTypes["ValueItemCreateResult"],
	deleteValueItem: ModelTypes["ValueItemDeleteResult"],
	updateValueItem: ModelTypes["ValueItemUpdateResult"],
	upsertValueItem: ModelTypes["ValueItemUpsertResult"],
	createValueList: ModelTypes["ValueListCreateResult"],
	deleteValueList: ModelTypes["ValueListDeleteResult"],
	updateValueList: ModelTypes["ValueListUpdateResult"],
	upsertValueList: ModelTypes["ValueListUpsertResult"],
	createImageLink: ModelTypes["ImageLinkCreateResult"],
	deleteImageLink: ModelTypes["ImageLinkDeleteResult"],
	updateImageLink: ModelTypes["ImageLinkUpdateResult"],
	upsertImageLink: ModelTypes["ImageLinkUpsertResult"],
	createImageLinkItem: ModelTypes["ImageLinkItemCreateResult"],
	deleteImageLinkItem: ModelTypes["ImageLinkItemDeleteResult"],
	updateImageLinkItem: ModelTypes["ImageLinkItemUpdateResult"],
	upsertImageLinkItem: ModelTypes["ImageLinkItemUpsertResult"],
	createImageLinkList: ModelTypes["ImageLinkListCreateResult"],
	deleteImageLinkList: ModelTypes["ImageLinkListDeleteResult"],
	updateImageLinkList: ModelTypes["ImageLinkListUpdateResult"],
	upsertImageLinkList: ModelTypes["ImageLinkListUpsertResult"],
	createPostAreaList: ModelTypes["PostAreaListCreateResult"],
	deletePostAreaList: ModelTypes["PostAreaListDeleteResult"],
	updatePostAreaList: ModelTypes["PostAreaListUpdateResult"],
	upsertPostAreaList: ModelTypes["PostAreaListUpsertResult"],
	createPostAreaListItem: ModelTypes["PostAreaListItemCreateResult"],
	deletePostAreaListItem: ModelTypes["PostAreaListItemDeleteResult"],
	updatePostAreaListItem: ModelTypes["PostAreaListItemUpdateResult"],
	upsertPostAreaListItem: ModelTypes["PostAreaListItemUpsertResult"],
	createAccordion: ModelTypes["AccordionCreateResult"],
	deleteAccordion: ModelTypes["AccordionDeleteResult"],
	updateAccordion: ModelTypes["AccordionUpdateResult"],
	upsertAccordion: ModelTypes["AccordionUpsertResult"],
	createAccordionItem: ModelTypes["AccordionItemCreateResult"],
	deleteAccordionItem: ModelTypes["AccordionItemDeleteResult"],
	updateAccordionItem: ModelTypes["AccordionItemUpdateResult"],
	upsertAccordionItem: ModelTypes["AccordionItemUpsertResult"],
	createUser: ModelTypes["UserCreateResult"],
	deleteUser: ModelTypes["UserDeleteResult"],
	updateUser: ModelTypes["UserUpdateResult"],
	upsertUser: ModelTypes["UserUpsertResult"],
	createUserPayment: ModelTypes["UserPaymentCreateResult"],
	deleteUserPayment: ModelTypes["UserPaymentDeleteResult"],
	updateUserPayment: ModelTypes["UserPaymentUpdateResult"],
	upsertUserPayment: ModelTypes["UserPaymentUpsertResult"],
	createCurrency: ModelTypes["CurrencyCreateResult"],
	deleteCurrency: ModelTypes["CurrencyDeleteResult"],
	updateCurrency: ModelTypes["CurrencyUpdateResult"],
	upsertCurrency: ModelTypes["CurrencyUpsertResult"],
	createMedium: ModelTypes["MediumCreateResult"],
	deleteMedium: ModelTypes["MediumDeleteResult"],
	updateMedium: ModelTypes["MediumUpdateResult"],
	upsertMedium: ModelTypes["MediumUpsertResult"],
	createMediumItem: ModelTypes["MediumItemCreateResult"],
	deleteMediumItem: ModelTypes["MediumItemDeleteResult"],
	updateMediumItem: ModelTypes["MediumItemUpdateResult"],
	upsertMediumItem: ModelTypes["MediumItemUpsertResult"],
	createMediumList: ModelTypes["MediumListCreateResult"],
	deleteMediumList: ModelTypes["MediumListDeleteResult"],
	updateMediumList: ModelTypes["MediumListUpdateResult"],
	upsertMediumList: ModelTypes["MediumListUpsertResult"],
	createUserPaymentOrderId: ModelTypes["UserPaymentOrderIdCreateResult"],
	deleteUserPaymentOrderId: ModelTypes["UserPaymentOrderIdDeleteResult"],
	updateUserPaymentOrderId: ModelTypes["UserPaymentOrderIdUpdateResult"],
	upsertUserPaymentOrderId: ModelTypes["UserPaymentOrderIdUpsertResult"],
	createPostRevision: ModelTypes["PostRevisionCreateResult"],
	deletePostRevision: ModelTypes["PostRevisionDeleteResult"],
	updatePostRevision: ModelTypes["PostRevisionUpdateResult"],
	upsertPostRevision: ModelTypes["PostRevisionUpsertResult"],
	createUserRecurringPayment: ModelTypes["UserRecurringPaymentCreateResult"],
	deleteUserRecurringPayment: ModelTypes["UserRecurringPaymentDeleteResult"],
	updateUserRecurringPayment: ModelTypes["UserRecurringPaymentUpdateResult"],
	upsertUserRecurringPayment: ModelTypes["UserRecurringPaymentUpsertResult"],
	createUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemCreateResult"],
	deleteUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemDeleteResult"],
	updateUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemUpdateResult"],
	upsertUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemUpsertResult"],
	createPostRevisionLocale: ModelTypes["PostRevisionLocaleCreateResult"],
	deletePostRevisionLocale: ModelTypes["PostRevisionLocaleDeleteResult"],
	updatePostRevisionLocale: ModelTypes["PostRevisionLocaleUpdateResult"],
	upsertPostRevisionLocale: ModelTypes["PostRevisionLocaleUpsertResult"],
	createTranslationCatalogue: ModelTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: ModelTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: ModelTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: ModelTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationDomain: ModelTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: ModelTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: ModelTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: ModelTypes["TranslationDomainUpsertResult"],
	createTranslationKey: ModelTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: ModelTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: ModelTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: ModelTypes["TranslationKeyUpsertResult"],
	createTranslationValue: ModelTypes["TranslationValueCreateResult"],
	deleteTranslationValue: ModelTypes["TranslationValueDeleteResult"],
	updateTranslationValue: ModelTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: ModelTypes["TranslationValueUpsertResult"],
	createGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleCreateResult"],
	deleteGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleDeleteResult"],
	updateGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleUpdateResult"],
	upsertGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleUpsertResult"],
	createMemberList: ModelTypes["MemberListCreateResult"],
	deleteMemberList: ModelTypes["MemberListDeleteResult"],
	updateMemberList: ModelTypes["MemberListUpdateResult"],
	upsertMemberList: ModelTypes["MemberListUpsertResult"],
	createMemberListItem: ModelTypes["MemberListItemCreateResult"],
	deleteMemberListItem: ModelTypes["MemberListItemDeleteResult"],
	updateMemberListItem: ModelTypes["MemberListItemUpdateResult"],
	upsertMemberListItem: ModelTypes["MemberListItemUpsertResult"],
	createFilledTaxForm: ModelTypes["FilledTaxFormCreateResult"],
	deleteFilledTaxForm: ModelTypes["FilledTaxFormDeleteResult"],
	updateFilledTaxForm: ModelTypes["FilledTaxFormUpdateResult"],
	upsertFilledTaxForm: ModelTypes["FilledTaxFormUpsertResult"],
	createFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressCreateResult"],
	deleteFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressDeleteResult"],
	updateFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressUpdateResult"],
	upsertFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressUpsertResult"],
	createForm: ModelTypes["FormCreateResult"],
	deleteForm: ModelTypes["FormDeleteResult"],
	updateForm: ModelTypes["FormUpdateResult"],
	upsertForm: ModelTypes["FormUpsertResult"],
	createCsobPayment: ModelTypes["CsobPaymentCreateResult"],
	deleteCsobPayment: ModelTypes["CsobPaymentDeleteResult"],
	updateCsobPayment: ModelTypes["CsobPaymentUpdateResult"],
	upsertCsobPayment: ModelTypes["CsobPaymentUpsertResult"],
	createCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeCreateResult"],
	deleteCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeDeleteResult"],
	updateCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeUpdateResult"],
	upsertCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeUpsertResult"],
	createStripePayment: ModelTypes["StripePaymentCreateResult"],
	deleteStripePayment: ModelTypes["StripePaymentDeleteResult"],
	updateStripePayment: ModelTypes["StripePaymentUpdateResult"],
	upsertStripePayment: ModelTypes["StripePaymentUpsertResult"],
	createStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeCreateResult"],
	deleteStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeDeleteResult"],
	updateStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeUpdateResult"],
	upsertStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeUpsertResult"],
	createRegionPaymentMethod: ModelTypes["RegionPaymentMethodCreateResult"],
	deleteRegionPaymentMethod: ModelTypes["RegionPaymentMethodDeleteResult"],
	updateRegionPaymentMethod: ModelTypes["RegionPaymentMethodUpdateResult"],
	upsertRegionPaymentMethod: ModelTypes["RegionPaymentMethodUpsertResult"],
	createTileItem: ModelTypes["TileItemCreateResult"],
	deleteTileItem: ModelTypes["TileItemDeleteResult"],
	updateTileItem: ModelTypes["TileItemUpdateResult"],
	upsertTileItem: ModelTypes["TileItemUpsertResult"],
	createTileList: ModelTypes["TileListCreateResult"],
	deleteTileList: ModelTypes["TileListDeleteResult"],
	updateTileList: ModelTypes["TileListUpdateResult"],
	upsertTileList: ModelTypes["TileListUpsertResult"],
	createFeedPage: ModelTypes["FeedPageCreateResult"],
	deleteFeedPage: ModelTypes["FeedPageDeleteResult"],
	updateFeedPage: ModelTypes["FeedPageUpdateResult"],
	upsertFeedPage: ModelTypes["FeedPageUpsertResult"],
	createFeedPageLocale: ModelTypes["FeedPageLocaleCreateResult"],
	deleteFeedPageLocale: ModelTypes["FeedPageLocaleDeleteResult"],
	updateFeedPageLocale: ModelTypes["FeedPageLocaleUpdateResult"],
	upsertFeedPageLocale: ModelTypes["FeedPageLocaleUpsertResult"],
	createFeedPageSection: ModelTypes["FeedPageSectionCreateResult"],
	deleteFeedPageSection: ModelTypes["FeedPageSectionDeleteResult"],
	updateFeedPageSection: ModelTypes["FeedPageSectionUpdateResult"],
	upsertFeedPageSection: ModelTypes["FeedPageSectionUpsertResult"],
	createFeedPageTileStripe: ModelTypes["FeedPageTileStripeCreateResult"],
	deleteFeedPageTileStripe: ModelTypes["FeedPageTileStripeDeleteResult"],
	updateFeedPageTileStripe: ModelTypes["FeedPageTileStripeUpdateResult"],
	upsertFeedPageTileStripe: ModelTypes["FeedPageTileStripeUpsertResult"],
	createCardItem: ModelTypes["CardItemCreateResult"],
	deleteCardItem: ModelTypes["CardItemDeleteResult"],
	updateCardItem: ModelTypes["CardItemUpdateResult"],
	upsertCardItem: ModelTypes["CardItemUpsertResult"],
	createCardList: ModelTypes["CardListCreateResult"],
	deleteCardList: ModelTypes["CardListDeleteResult"],
	updateCardList: ModelTypes["CardListUpdateResult"],
	upsertCardList: ModelTypes["CardListUpsertResult"],
	createOnBehalfDonation: ModelTypes["OnBehalfDonationCreateResult"],
	deleteOnBehalfDonation: ModelTypes["OnBehalfDonationDeleteResult"],
	updateOnBehalfDonation: ModelTypes["OnBehalfDonationUpdateResult"],
	upsertOnBehalfDonation: ModelTypes["OnBehalfDonationUpsertResult"],
	createUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionCreateResult"],
	deleteUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionDeleteResult"],
	updateUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionUpdateResult"],
	upsertUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionUpsertResult"],
	createRecurringPaymentPage: ModelTypes["RecurringPaymentPageCreateResult"],
	deleteRecurringPaymentPage: ModelTypes["RecurringPaymentPageDeleteResult"],
	updateRecurringPaymentPage: ModelTypes["RecurringPaymentPageUpdateResult"],
	upsertRecurringPaymentPage: ModelTypes["RecurringPaymentPageUpsertResult"],
	createRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleCreateResult"],
	deleteRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleDeleteResult"],
	updateRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleUpdateResult"],
	upsertRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleUpsertResult"],
	createStoryGuide: ModelTypes["StoryGuideCreateResult"],
	deleteStoryGuide: ModelTypes["StoryGuideDeleteResult"],
	updateStoryGuide: ModelTypes["StoryGuideUpdateResult"],
	upsertStoryGuide: ModelTypes["StoryGuideUpsertResult"],
	createStoryGuideItem: ModelTypes["StoryGuideItemCreateResult"],
	deleteStoryGuideItem: ModelTypes["StoryGuideItemDeleteResult"],
	updateStoryGuideItem: ModelTypes["StoryGuideItemUpdateResult"],
	upsertStoryGuideItem: ModelTypes["StoryGuideItemUpsertResult"],
	createStoryGuideList: ModelTypes["StoryGuideListCreateResult"],
	deleteStoryGuideList: ModelTypes["StoryGuideListDeleteResult"],
	updateStoryGuideList: ModelTypes["StoryGuideListUpdateResult"],
	upsertStoryGuideList: ModelTypes["StoryGuideListUpsertResult"],
	createHeroCarousel: ModelTypes["HeroCarouselCreateResult"],
	deleteHeroCarousel: ModelTypes["HeroCarouselDeleteResult"],
	updateHeroCarousel: ModelTypes["HeroCarouselUpdateResult"],
	upsertHeroCarousel: ModelTypes["HeroCarouselUpsertResult"],
	createPostOrganizationList: ModelTypes["PostOrganizationListCreateResult"],
	deletePostOrganizationList: ModelTypes["PostOrganizationListDeleteResult"],
	updatePostOrganizationList: ModelTypes["PostOrganizationListUpdateResult"],
	upsertPostOrganizationList: ModelTypes["PostOrganizationListUpsertResult"],
	createPostOrganizationListItem: ModelTypes["PostOrganizationListItemCreateResult"],
	deletePostOrganizationListItem: ModelTypes["PostOrganizationListItemDeleteResult"],
	updatePostOrganizationListItem: ModelTypes["PostOrganizationListItemUpdateResult"],
	upsertPostOrganizationListItem: ModelTypes["PostOrganizationListItemUpsertResult"],
	createInfoCarousel: ModelTypes["InfoCarouselCreateResult"],
	deleteInfoCarousel: ModelTypes["InfoCarouselDeleteResult"],
	updateInfoCarousel: ModelTypes["InfoCarouselUpdateResult"],
	upsertInfoCarousel: ModelTypes["InfoCarouselUpsertResult"],
	createInfoCarouselItem: ModelTypes["InfoCarouselItemCreateResult"],
	deleteInfoCarouselItem: ModelTypes["InfoCarouselItemDeleteResult"],
	updateInfoCarouselItem: ModelTypes["InfoCarouselItemUpdateResult"],
	upsertInfoCarouselItem: ModelTypes["InfoCarouselItemUpsertResult"],
	createPersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselCreateResult"],
	deletePersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselDeleteResult"],
	updatePersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselUpdateResult"],
	upsertPersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselUpsertResult"],
	createGivenGiftsPage: ModelTypes["GivenGiftsPageCreateResult"],
	deleteGivenGiftsPage: ModelTypes["GivenGiftsPageDeleteResult"],
	updateGivenGiftsPage: ModelTypes["GivenGiftsPageUpdateResult"],
	upsertGivenGiftsPage: ModelTypes["GivenGiftsPageUpsertResult"],
	createGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleCreateResult"],
	deleteGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleDeleteResult"],
	updateGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleUpdateResult"],
	upsertGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleUpsertResult"],
	createReceivedGiftsPage: ModelTypes["ReceivedGiftsPageCreateResult"],
	deleteReceivedGiftsPage: ModelTypes["ReceivedGiftsPageDeleteResult"],
	updateReceivedGiftsPage: ModelTypes["ReceivedGiftsPageUpdateResult"],
	upsertReceivedGiftsPage: ModelTypes["ReceivedGiftsPageUpsertResult"],
	createReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleCreateResult"],
	deleteReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleDeleteResult"],
	updateReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleUpdateResult"],
	upsertReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleUpsertResult"],
	createReportNavigation: ModelTypes["ReportNavigationCreateResult"],
	deleteReportNavigation: ModelTypes["ReportNavigationDeleteResult"],
	updateReportNavigation: ModelTypes["ReportNavigationUpdateResult"],
	upsertReportNavigation: ModelTypes["ReportNavigationUpsertResult"],
	createReportPage: ModelTypes["ReportPageCreateResult"],
	deleteReportPage: ModelTypes["ReportPageDeleteResult"],
	updateReportPage: ModelTypes["ReportPageUpdateResult"],
	upsertReportPage: ModelTypes["ReportPageUpsertResult"],
	createReportPageLocale: ModelTypes["ReportPageLocaleCreateResult"],
	deleteReportPageLocale: ModelTypes["ReportPageLocaleDeleteResult"],
	updateReportPageLocale: ModelTypes["ReportPageLocaleUpdateResult"],
	upsertReportPageLocale: ModelTypes["ReportPageLocaleUpsertResult"],
	createReportNavigationLocale: ModelTypes["ReportNavigationLocaleCreateResult"],
	deleteReportNavigationLocale: ModelTypes["ReportNavigationLocaleDeleteResult"],
	updateReportNavigationLocale: ModelTypes["ReportNavigationLocaleUpdateResult"],
	upsertReportNavigationLocale: ModelTypes["ReportNavigationLocaleUpsertResult"],
	createSentPayment: ModelTypes["SentPaymentCreateResult"],
	deleteSentPayment: ModelTypes["SentPaymentDeleteResult"],
	updateSentPayment: ModelTypes["SentPaymentUpdateResult"],
	upsertSentPayment: ModelTypes["SentPaymentUpsertResult"],
	createNotificationTargetGroup: ModelTypes["NotificationTargetGroupCreateResult"],
	deleteNotificationTargetGroup: ModelTypes["NotificationTargetGroupDeleteResult"],
	updateNotificationTargetGroup: ModelTypes["NotificationTargetGroupUpdateResult"],
	upsertNotificationTargetGroup: ModelTypes["NotificationTargetGroupUpsertResult"],
	createProcessedNotification: ModelTypes["ProcessedNotificationCreateResult"],
	deleteProcessedNotification: ModelTypes["ProcessedNotificationDeleteResult"],
	updateProcessedNotification: ModelTypes["ProcessedNotificationUpdateResult"],
	upsertProcessedNotification: ModelTypes["ProcessedNotificationUpsertResult"],
	createScheduledNotification: ModelTypes["ScheduledNotificationCreateResult"],
	deleteScheduledNotification: ModelTypes["ScheduledNotificationDeleteResult"],
	updateScheduledNotification: ModelTypes["ScheduledNotificationUpdateResult"],
	upsertScheduledNotification: ModelTypes["ScheduledNotificationUpsertResult"],
	createProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceCreateResult"],
	deleteProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceDeleteResult"],
	updateProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceUpdateResult"],
	upsertProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceUpsertResult"],
	createDevice: ModelTypes["DeviceCreateResult"],
	deleteDevice: ModelTypes["DeviceDeleteResult"],
	updateDevice: ModelTypes["DeviceUpdateResult"],
	upsertDevice: ModelTypes["DeviceUpsertResult"],
	createScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleCreateResult"],
	deleteScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleDeleteResult"],
	updateScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleUpdateResult"],
	upsertScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleUpsertResult"],
	createInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleCreateResult"],
	deleteInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleDeleteResult"],
	updateInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleUpdateResult"],
	upsertInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleUpsertResult"],
	createSentPaymentLocale: ModelTypes["SentPaymentLocaleCreateResult"],
	deleteSentPaymentLocale: ModelTypes["SentPaymentLocaleDeleteResult"],
	updateSentPaymentLocale: ModelTypes["SentPaymentLocaleUpdateResult"],
	upsertSentPaymentLocale: ModelTypes["SentPaymentLocaleUpsertResult"],
	createTextImageList: ModelTypes["TextImageListCreateResult"],
	deleteTextImageList: ModelTypes["TextImageListDeleteResult"],
	updateTextImageList: ModelTypes["TextImageListUpdateResult"],
	upsertTextImageList: ModelTypes["TextImageListUpsertResult"],
	createTextImageListItem: ModelTypes["TextImageListItemCreateResult"],
	deleteTextImageListItem: ModelTypes["TextImageListItemDeleteResult"],
	updateTextImageListItem: ModelTypes["TextImageListItemUpdateResult"],
	upsertTextImageListItem: ModelTypes["TextImageListItemUpsertResult"],
	createHeroCarouselItem: ModelTypes["HeroCarouselItemCreateResult"],
	deleteHeroCarouselItem: ModelTypes["HeroCarouselItemDeleteResult"],
	updateHeroCarouselItem: ModelTypes["HeroCarouselItemUpdateResult"],
	upsertHeroCarouselItem: ModelTypes["HeroCarouselItemUpsertResult"],
	transaction: ModelTypes["MutationTransaction"],
	query: ModelTypes["Query"]
};
	["S3SignedUpload"]: {
		url: string,
	headers: Array<ModelTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
		key: string,
	value: string
};
	["S3GenerateSignedUploadInput"]: {
	contentType?: string | undefined,
	/** If not provided, extension is detected from a content-type. */
	extension?: string | undefined,
	/** Signed URL expiration. */
	expiration?: number | undefined,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number | undefined,
	/** Can be used as a "directory". */
	prefix?: string | undefined,
	/** Suffix after generated id and before the extension. */
	suffix?: string | undefined,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string | undefined,
	contentDisposition?: ModelTypes["S33ContentDisposition"] | undefined,
	/** If not supported by S3 provider, an error is thrown. */
	acl?: ModelTypes["S3Acl"] | undefined
};
	["S33ContentDisposition"]:S33ContentDisposition;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: {
		url: string,
	headers: Array<ModelTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string
};
	["GeneralCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["General"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["GeneralCreateResult"] | ModelTypes["GeneralDeleteResult"] | ModelTypes["GeneralUpdateResult"] | ModelTypes["GeneralUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["GenericPageCreateResult"] | ModelTypes["GenericPageDeleteResult"] | ModelTypes["GenericPageUpdateResult"] | ModelTypes["GenericPageUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["GeneralLocaleCreateResult"] | ModelTypes["GeneralLocaleDeleteResult"] | ModelTypes["GeneralLocaleUpdateResult"] | ModelTypes["GeneralLocaleUpsertResult"] | ModelTypes["GenericPageLocaleCreateResult"] | ModelTypes["GenericPageLocaleDeleteResult"] | ModelTypes["GenericPageLocaleUpdateResult"] | ModelTypes["GenericPageLocaleUpsertResult"] | ModelTypes["LocaleCreateResult"] | ModelTypes["LocaleDeleteResult"] | ModelTypes["LocaleUpdateResult"] | ModelTypes["LocaleUpsertResult"] | ModelTypes["VideoCreateResult"] | ModelTypes["VideoDeleteResult"] | ModelTypes["VideoUpdateResult"] | ModelTypes["VideoUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["PostCreateResult"] | ModelTypes["PostDeleteResult"] | ModelTypes["PostUpdateResult"] | ModelTypes["PostUpsertResult"] | ModelTypes["PostLocaleCreateResult"] | ModelTypes["PostLocaleDeleteResult"] | ModelTypes["PostLocaleUpdateResult"] | ModelTypes["PostLocaleUpsertResult"] | ModelTypes["PostAreaCreateResult"] | ModelTypes["PostAreaDeleteResult"] | ModelTypes["PostAreaUpdateResult"] | ModelTypes["PostAreaUpsertResult"] | ModelTypes["PostAreaLocaleCreateResult"] | ModelTypes["PostAreaLocaleDeleteResult"] | ModelTypes["PostAreaLocaleUpdateResult"] | ModelTypes["PostAreaLocaleUpsertResult"] | ModelTypes["PostOrganizationCreateResult"] | ModelTypes["PostOrganizationDeleteResult"] | ModelTypes["PostOrganizationUpdateResult"] | ModelTypes["PostOrganizationUpsertResult"] | ModelTypes["PostOrganizationLocaleCreateResult"] | ModelTypes["PostOrganizationLocaleDeleteResult"] | ModelTypes["PostOrganizationLocaleUpdateResult"] | ModelTypes["PostOrganizationLocaleUpsertResult"] | ModelTypes["DonationCreateResult"] | ModelTypes["DonationDeleteResult"] | ModelTypes["DonationUpdateResult"] | ModelTypes["DonationUpsertResult"] | ModelTypes["DonationAmountItemCreateResult"] | ModelTypes["DonationAmountItemDeleteResult"] | ModelTypes["DonationAmountItemUpdateResult"] | ModelTypes["DonationAmountItemUpsertResult"] | ModelTypes["DonationAmountsRegionItemCreateResult"] | ModelTypes["DonationAmountsRegionItemDeleteResult"] | ModelTypes["DonationAmountsRegionItemUpdateResult"] | ModelTypes["DonationAmountsRegionItemUpsertResult"] | ModelTypes["DonationAmountsRegionListCreateResult"] | ModelTypes["DonationAmountsRegionListDeleteResult"] | ModelTypes["DonationAmountsRegionListUpdateResult"] | ModelTypes["DonationAmountsRegionListUpsertResult"] | ModelTypes["RegionCreateResult"] | ModelTypes["RegionDeleteResult"] | ModelTypes["RegionUpdateResult"] | ModelTypes["RegionUpsertResult"] | ModelTypes["LinkItemCreateResult"] | ModelTypes["LinkItemDeleteResult"] | ModelTypes["LinkItemUpdateResult"] | ModelTypes["LinkItemUpsertResult"] | ModelTypes["LinkListCreateResult"] | ModelTypes["LinkListDeleteResult"] | ModelTypes["LinkListUpdateResult"] | ModelTypes["LinkListUpsertResult"] | ModelTypes["HeaderCreateResult"] | ModelTypes["HeaderDeleteResult"] | ModelTypes["HeaderUpdateResult"] | ModelTypes["HeaderUpsertResult"] | ModelTypes["HeaderLocaleCreateResult"] | ModelTypes["HeaderLocaleDeleteResult"] | ModelTypes["HeaderLocaleUpdateResult"] | ModelTypes["HeaderLocaleUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["FooterLocaleCreateResult"] | ModelTypes["FooterLocaleDeleteResult"] | ModelTypes["FooterLocaleUpdateResult"] | ModelTypes["FooterLocaleUpsertResult"] | ModelTypes["PostListCreateResult"] | ModelTypes["PostListDeleteResult"] | ModelTypes["PostListUpdateResult"] | ModelTypes["PostListUpsertResult"] | ModelTypes["PostListItemCreateResult"] | ModelTypes["PostListItemDeleteResult"] | ModelTypes["PostListItemUpdateResult"] | ModelTypes["PostListItemUpsertResult"] | ModelTypes["AppBannerCreateResult"] | ModelTypes["AppBannerDeleteResult"] | ModelTypes["AppBannerUpdateResult"] | ModelTypes["AppBannerUpsertResult"] | ModelTypes["GenericPageAboutSettingsCreateResult"] | ModelTypes["GenericPageAboutSettingsDeleteResult"] | ModelTypes["GenericPageAboutSettingsUpdateResult"] | ModelTypes["GenericPageAboutSettingsUpsertResult"] | ModelTypes["GenericPageAboutSettingsLocaleCreateResult"] | ModelTypes["GenericPageAboutSettingsLocaleDeleteResult"] | ModelTypes["GenericPageAboutSettingsLocaleUpdateResult"] | ModelTypes["GenericPageAboutSettingsLocaleUpsertResult"] | ModelTypes["ValueCreateResult"] | ModelTypes["ValueDeleteResult"] | ModelTypes["ValueUpdateResult"] | ModelTypes["ValueUpsertResult"] | ModelTypes["ValueItemCreateResult"] | ModelTypes["ValueItemDeleteResult"] | ModelTypes["ValueItemUpdateResult"] | ModelTypes["ValueItemUpsertResult"] | ModelTypes["ValueListCreateResult"] | ModelTypes["ValueListDeleteResult"] | ModelTypes["ValueListUpdateResult"] | ModelTypes["ValueListUpsertResult"] | ModelTypes["ImageLinkCreateResult"] | ModelTypes["ImageLinkDeleteResult"] | ModelTypes["ImageLinkUpdateResult"] | ModelTypes["ImageLinkUpsertResult"] | ModelTypes["ImageLinkItemCreateResult"] | ModelTypes["ImageLinkItemDeleteResult"] | ModelTypes["ImageLinkItemUpdateResult"] | ModelTypes["ImageLinkItemUpsertResult"] | ModelTypes["ImageLinkListCreateResult"] | ModelTypes["ImageLinkListDeleteResult"] | ModelTypes["ImageLinkListUpdateResult"] | ModelTypes["ImageLinkListUpsertResult"] | ModelTypes["PostAreaListCreateResult"] | ModelTypes["PostAreaListDeleteResult"] | ModelTypes["PostAreaListUpdateResult"] | ModelTypes["PostAreaListUpsertResult"] | ModelTypes["PostAreaListItemCreateResult"] | ModelTypes["PostAreaListItemDeleteResult"] | ModelTypes["PostAreaListItemUpdateResult"] | ModelTypes["PostAreaListItemUpsertResult"] | ModelTypes["AccordionCreateResult"] | ModelTypes["AccordionDeleteResult"] | ModelTypes["AccordionUpdateResult"] | ModelTypes["AccordionUpsertResult"] | ModelTypes["AccordionItemCreateResult"] | ModelTypes["AccordionItemDeleteResult"] | ModelTypes["AccordionItemUpdateResult"] | ModelTypes["AccordionItemUpsertResult"] | ModelTypes["UserCreateResult"] | ModelTypes["UserDeleteResult"] | ModelTypes["UserUpdateResult"] | ModelTypes["UserUpsertResult"] | ModelTypes["UserPaymentCreateResult"] | ModelTypes["UserPaymentDeleteResult"] | ModelTypes["UserPaymentUpdateResult"] | ModelTypes["UserPaymentUpsertResult"] | ModelTypes["CurrencyCreateResult"] | ModelTypes["CurrencyDeleteResult"] | ModelTypes["CurrencyUpdateResult"] | ModelTypes["CurrencyUpsertResult"] | ModelTypes["MediumCreateResult"] | ModelTypes["MediumDeleteResult"] | ModelTypes["MediumUpdateResult"] | ModelTypes["MediumUpsertResult"] | ModelTypes["MediumItemCreateResult"] | ModelTypes["MediumItemDeleteResult"] | ModelTypes["MediumItemUpdateResult"] | ModelTypes["MediumItemUpsertResult"] | ModelTypes["MediumListCreateResult"] | ModelTypes["MediumListDeleteResult"] | ModelTypes["MediumListUpdateResult"] | ModelTypes["MediumListUpsertResult"] | ModelTypes["UserPaymentOrderIdCreateResult"] | ModelTypes["UserPaymentOrderIdDeleteResult"] | ModelTypes["UserPaymentOrderIdUpdateResult"] | ModelTypes["UserPaymentOrderIdUpsertResult"] | ModelTypes["PostRevisionCreateResult"] | ModelTypes["PostRevisionDeleteResult"] | ModelTypes["PostRevisionUpdateResult"] | ModelTypes["PostRevisionUpsertResult"] | ModelTypes["UserRecurringPaymentCreateResult"] | ModelTypes["UserRecurringPaymentDeleteResult"] | ModelTypes["UserRecurringPaymentUpdateResult"] | ModelTypes["UserRecurringPaymentUpsertResult"] | ModelTypes["UserRecurringPaymentItemCreateResult"] | ModelTypes["UserRecurringPaymentItemDeleteResult"] | ModelTypes["UserRecurringPaymentItemUpdateResult"] | ModelTypes["UserRecurringPaymentItemUpsertResult"] | ModelTypes["PostRevisionLocaleCreateResult"] | ModelTypes["PostRevisionLocaleDeleteResult"] | ModelTypes["PostRevisionLocaleUpdateResult"] | ModelTypes["PostRevisionLocaleUpsertResult"] | ModelTypes["TranslationCatalogueCreateResult"] | ModelTypes["TranslationCatalogueDeleteResult"] | ModelTypes["TranslationCatalogueUpdateResult"] | ModelTypes["TranslationCatalogueUpsertResult"] | ModelTypes["TranslationCataloguesIdentifierCreateResult"] | ModelTypes["TranslationCataloguesIdentifierDeleteResult"] | ModelTypes["TranslationCataloguesIdentifierUpdateResult"] | ModelTypes["TranslationCataloguesIdentifierUpsertResult"] | ModelTypes["TranslationDomainCreateResult"] | ModelTypes["TranslationDomainDeleteResult"] | ModelTypes["TranslationDomainUpdateResult"] | ModelTypes["TranslationDomainUpsertResult"] | ModelTypes["TranslationKeyCreateResult"] | ModelTypes["TranslationKeyDeleteResult"] | ModelTypes["TranslationKeyUpdateResult"] | ModelTypes["TranslationKeyUpsertResult"] | ModelTypes["TranslationValueCreateResult"] | ModelTypes["TranslationValueDeleteResult"] | ModelTypes["TranslationValueUpdateResult"] | ModelTypes["TranslationValueUpsertResult"] | ModelTypes["GenericPageAboutGroupLinksLocaleCreateResult"] | ModelTypes["GenericPageAboutGroupLinksLocaleDeleteResult"] | ModelTypes["GenericPageAboutGroupLinksLocaleUpdateResult"] | ModelTypes["GenericPageAboutGroupLinksLocaleUpsertResult"] | ModelTypes["MemberListCreateResult"] | ModelTypes["MemberListDeleteResult"] | ModelTypes["MemberListUpdateResult"] | ModelTypes["MemberListUpsertResult"] | ModelTypes["MemberListItemCreateResult"] | ModelTypes["MemberListItemDeleteResult"] | ModelTypes["MemberListItemUpdateResult"] | ModelTypes["MemberListItemUpsertResult"] | ModelTypes["FilledTaxFormCreateResult"] | ModelTypes["FilledTaxFormDeleteResult"] | ModelTypes["FilledTaxFormUpdateResult"] | ModelTypes["FilledTaxFormUpsertResult"] | ModelTypes["FilledTaxFormEmailAddressCreateResult"] | ModelTypes["FilledTaxFormEmailAddressDeleteResult"] | ModelTypes["FilledTaxFormEmailAddressUpdateResult"] | ModelTypes["FilledTaxFormEmailAddressUpsertResult"] | ModelTypes["FormCreateResult"] | ModelTypes["FormDeleteResult"] | ModelTypes["FormUpdateResult"] | ModelTypes["FormUpsertResult"] | ModelTypes["CsobPaymentCreateResult"] | ModelTypes["CsobPaymentDeleteResult"] | ModelTypes["CsobPaymentUpdateResult"] | ModelTypes["CsobPaymentUpsertResult"] | ModelTypes["CsobPaymentStatusChangeCreateResult"] | ModelTypes["CsobPaymentStatusChangeDeleteResult"] | ModelTypes["CsobPaymentStatusChangeUpdateResult"] | ModelTypes["CsobPaymentStatusChangeUpsertResult"] | ModelTypes["StripePaymentCreateResult"] | ModelTypes["StripePaymentDeleteResult"] | ModelTypes["StripePaymentUpdateResult"] | ModelTypes["StripePaymentUpsertResult"] | ModelTypes["StripePaymentStatusChangeCreateResult"] | ModelTypes["StripePaymentStatusChangeDeleteResult"] | ModelTypes["StripePaymentStatusChangeUpdateResult"] | ModelTypes["StripePaymentStatusChangeUpsertResult"] | ModelTypes["RegionPaymentMethodCreateResult"] | ModelTypes["RegionPaymentMethodDeleteResult"] | ModelTypes["RegionPaymentMethodUpdateResult"] | ModelTypes["RegionPaymentMethodUpsertResult"] | ModelTypes["TileItemCreateResult"] | ModelTypes["TileItemDeleteResult"] | ModelTypes["TileItemUpdateResult"] | ModelTypes["TileItemUpsertResult"] | ModelTypes["TileListCreateResult"] | ModelTypes["TileListDeleteResult"] | ModelTypes["TileListUpdateResult"] | ModelTypes["TileListUpsertResult"] | ModelTypes["FeedPageCreateResult"] | ModelTypes["FeedPageDeleteResult"] | ModelTypes["FeedPageUpdateResult"] | ModelTypes["FeedPageUpsertResult"] | ModelTypes["FeedPageLocaleCreateResult"] | ModelTypes["FeedPageLocaleDeleteResult"] | ModelTypes["FeedPageLocaleUpdateResult"] | ModelTypes["FeedPageLocaleUpsertResult"] | ModelTypes["FeedPageSectionCreateResult"] | ModelTypes["FeedPageSectionDeleteResult"] | ModelTypes["FeedPageSectionUpdateResult"] | ModelTypes["FeedPageSectionUpsertResult"] | ModelTypes["FeedPageTileStripeCreateResult"] | ModelTypes["FeedPageTileStripeDeleteResult"] | ModelTypes["FeedPageTileStripeUpdateResult"] | ModelTypes["FeedPageTileStripeUpsertResult"] | ModelTypes["CardItemCreateResult"] | ModelTypes["CardItemDeleteResult"] | ModelTypes["CardItemUpdateResult"] | ModelTypes["CardItemUpsertResult"] | ModelTypes["CardListCreateResult"] | ModelTypes["CardListDeleteResult"] | ModelTypes["CardListUpdateResult"] | ModelTypes["CardListUpsertResult"] | ModelTypes["OnBehalfDonationCreateResult"] | ModelTypes["OnBehalfDonationDeleteResult"] | ModelTypes["OnBehalfDonationUpdateResult"] | ModelTypes["OnBehalfDonationUpsertResult"] | ModelTypes["UserPaymentTriesCollectionCreateResult"] | ModelTypes["UserPaymentTriesCollectionDeleteResult"] | ModelTypes["UserPaymentTriesCollectionUpdateResult"] | ModelTypes["UserPaymentTriesCollectionUpsertResult"] | ModelTypes["RecurringPaymentPageCreateResult"] | ModelTypes["RecurringPaymentPageDeleteResult"] | ModelTypes["RecurringPaymentPageUpdateResult"] | ModelTypes["RecurringPaymentPageUpsertResult"] | ModelTypes["RecurringPaymentPageLocaleCreateResult"] | ModelTypes["RecurringPaymentPageLocaleDeleteResult"] | ModelTypes["RecurringPaymentPageLocaleUpdateResult"] | ModelTypes["RecurringPaymentPageLocaleUpsertResult"] | ModelTypes["StoryGuideCreateResult"] | ModelTypes["StoryGuideDeleteResult"] | ModelTypes["StoryGuideUpdateResult"] | ModelTypes["StoryGuideUpsertResult"] | ModelTypes["StoryGuideItemCreateResult"] | ModelTypes["StoryGuideItemDeleteResult"] | ModelTypes["StoryGuideItemUpdateResult"] | ModelTypes["StoryGuideItemUpsertResult"] | ModelTypes["StoryGuideListCreateResult"] | ModelTypes["StoryGuideListDeleteResult"] | ModelTypes["StoryGuideListUpdateResult"] | ModelTypes["StoryGuideListUpsertResult"] | ModelTypes["HeroCarouselCreateResult"] | ModelTypes["HeroCarouselDeleteResult"] | ModelTypes["HeroCarouselUpdateResult"] | ModelTypes["HeroCarouselUpsertResult"] | ModelTypes["PostOrganizationListCreateResult"] | ModelTypes["PostOrganizationListDeleteResult"] | ModelTypes["PostOrganizationListUpdateResult"] | ModelTypes["PostOrganizationListUpsertResult"] | ModelTypes["PostOrganizationListItemCreateResult"] | ModelTypes["PostOrganizationListItemDeleteResult"] | ModelTypes["PostOrganizationListItemUpdateResult"] | ModelTypes["PostOrganizationListItemUpsertResult"] | ModelTypes["InfoCarouselCreateResult"] | ModelTypes["InfoCarouselDeleteResult"] | ModelTypes["InfoCarouselUpdateResult"] | ModelTypes["InfoCarouselUpsertResult"] | ModelTypes["InfoCarouselItemCreateResult"] | ModelTypes["InfoCarouselItemDeleteResult"] | ModelTypes["InfoCarouselItemUpdateResult"] | ModelTypes["InfoCarouselItemUpsertResult"] | ModelTypes["PersonSeenInfoCarouselCreateResult"] | ModelTypes["PersonSeenInfoCarouselDeleteResult"] | ModelTypes["PersonSeenInfoCarouselUpdateResult"] | ModelTypes["PersonSeenInfoCarouselUpsertResult"] | ModelTypes["GivenGiftsPageCreateResult"] | ModelTypes["GivenGiftsPageDeleteResult"] | ModelTypes["GivenGiftsPageUpdateResult"] | ModelTypes["GivenGiftsPageUpsertResult"] | ModelTypes["GivenGiftsPageLocaleCreateResult"] | ModelTypes["GivenGiftsPageLocaleDeleteResult"] | ModelTypes["GivenGiftsPageLocaleUpdateResult"] | ModelTypes["GivenGiftsPageLocaleUpsertResult"] | ModelTypes["ReceivedGiftsPageCreateResult"] | ModelTypes["ReceivedGiftsPageDeleteResult"] | ModelTypes["ReceivedGiftsPageUpdateResult"] | ModelTypes["ReceivedGiftsPageUpsertResult"] | ModelTypes["ReceivedGiftsPageLocaleCreateResult"] | ModelTypes["ReceivedGiftsPageLocaleDeleteResult"] | ModelTypes["ReceivedGiftsPageLocaleUpdateResult"] | ModelTypes["ReceivedGiftsPageLocaleUpsertResult"] | ModelTypes["ReportNavigationCreateResult"] | ModelTypes["ReportNavigationDeleteResult"] | ModelTypes["ReportNavigationUpdateResult"] | ModelTypes["ReportNavigationUpsertResult"] | ModelTypes["ReportPageCreateResult"] | ModelTypes["ReportPageDeleteResult"] | ModelTypes["ReportPageUpdateResult"] | ModelTypes["ReportPageUpsertResult"] | ModelTypes["ReportPageLocaleCreateResult"] | ModelTypes["ReportPageLocaleDeleteResult"] | ModelTypes["ReportPageLocaleUpdateResult"] | ModelTypes["ReportPageLocaleUpsertResult"] | ModelTypes["ReportNavigationLocaleCreateResult"] | ModelTypes["ReportNavigationLocaleDeleteResult"] | ModelTypes["ReportNavigationLocaleUpdateResult"] | ModelTypes["ReportNavigationLocaleUpsertResult"] | ModelTypes["SentPaymentCreateResult"] | ModelTypes["SentPaymentDeleteResult"] | ModelTypes["SentPaymentUpdateResult"] | ModelTypes["SentPaymentUpsertResult"] | ModelTypes["NotificationTargetGroupCreateResult"] | ModelTypes["NotificationTargetGroupDeleteResult"] | ModelTypes["NotificationTargetGroupUpdateResult"] | ModelTypes["NotificationTargetGroupUpsertResult"] | ModelTypes["ProcessedNotificationCreateResult"] | ModelTypes["ProcessedNotificationDeleteResult"] | ModelTypes["ProcessedNotificationUpdateResult"] | ModelTypes["ProcessedNotificationUpsertResult"] | ModelTypes["ScheduledNotificationCreateResult"] | ModelTypes["ScheduledNotificationDeleteResult"] | ModelTypes["ScheduledNotificationUpdateResult"] | ModelTypes["ScheduledNotificationUpsertResult"] | ModelTypes["ProcessedNotificationSourceCreateResult"] | ModelTypes["ProcessedNotificationSourceDeleteResult"] | ModelTypes["ProcessedNotificationSourceUpdateResult"] | ModelTypes["ProcessedNotificationSourceUpsertResult"] | ModelTypes["DeviceCreateResult"] | ModelTypes["DeviceDeleteResult"] | ModelTypes["DeviceUpdateResult"] | ModelTypes["DeviceUpsertResult"] | ModelTypes["ScheduledNotificationLocaleCreateResult"] | ModelTypes["ScheduledNotificationLocaleDeleteResult"] | ModelTypes["ScheduledNotificationLocaleUpdateResult"] | ModelTypes["ScheduledNotificationLocaleUpsertResult"] | ModelTypes["InfoCarouselItemLocaleCreateResult"] | ModelTypes["InfoCarouselItemLocaleDeleteResult"] | ModelTypes["InfoCarouselItemLocaleUpdateResult"] | ModelTypes["InfoCarouselItemLocaleUpsertResult"] | ModelTypes["SentPaymentLocaleCreateResult"] | ModelTypes["SentPaymentLocaleDeleteResult"] | ModelTypes["SentPaymentLocaleUpdateResult"] | ModelTypes["SentPaymentLocaleUpsertResult"] | ModelTypes["TextImageListCreateResult"] | ModelTypes["TextImageListDeleteResult"] | ModelTypes["TextImageListUpdateResult"] | ModelTypes["TextImageListUpsertResult"] | ModelTypes["TextImageListItemCreateResult"] | ModelTypes["TextImageListItemDeleteResult"] | ModelTypes["TextImageListItemUpdateResult"] | ModelTypes["TextImageListItemUpsertResult"] | ModelTypes["HeroCarouselItemCreateResult"] | ModelTypes["HeroCarouselItemDeleteResult"] | ModelTypes["HeroCarouselItemUpdateResult"] | ModelTypes["HeroCarouselItemUpsertResult"];
	["_MutationError"]: {
		path: Array<ModelTypes["_PathFragment"]>,
	paths: Array<Array<ModelTypes["_PathFragment"]>>,
	type: ModelTypes["_MutationErrorType"],
	message?: string | undefined
};
	["_MutationErrorType"]:_MutationErrorType;
	["GeneralDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["General"] | undefined
};
	["GeneralUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["General"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GeneralUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["General"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Image"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Image"] | undefined
};
	["ImageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Image"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Image"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPage"] | undefined
};
	["GenericPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Linkable"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Linkable"] | undefined
};
	["LinkableUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Linkable"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Linkable"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Seo"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Seo"] | undefined
};
	["SeoUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Seo"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Seo"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Content"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Content"] | undefined
};
	["ContentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Content"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Content"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentBlock"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentBlock"] | undefined
};
	["ContentBlockUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentBlock"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentBlock"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentReference"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentReference"] | undefined
};
	["ContentReferenceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentReference"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentReference"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GeneralLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GeneralLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GeneralLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GeneralLocale"] | undefined
};
	["GeneralLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GeneralLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GeneralLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GeneralLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageLocale"] | undefined
};
	["GenericPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Locale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Locale"] | undefined
};
	["LocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Locale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Locale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Video"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Video"] | undefined
};
	["VideoUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Video"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Video"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Link"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Link"] | undefined
};
	["LinkUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Link"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Link"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Post"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Post"] | undefined
};
	["PostUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Post"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Post"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostLocale"] | undefined
};
	["PostLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostArea"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostArea"] | undefined
};
	["PostAreaUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostArea"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostArea"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaLocale"] | undefined
};
	["PostAreaLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganization"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganization"] | undefined
};
	["PostOrganizationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganization"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganization"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationLocale"] | undefined
};
	["PostOrganizationLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Donation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Donation"] | undefined
};
	["DonationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Donation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Donation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountItem"] | undefined
};
	["DonationAmountItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountsRegionItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountsRegionItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountsRegionItem"] | undefined
};
	["DonationAmountsRegionItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountsRegionItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountsRegionItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountsRegionListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountsRegionList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountsRegionListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountsRegionList"] | undefined
};
	["DonationAmountsRegionListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountsRegionList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DonationAmountsRegionListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["DonationAmountsRegionList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RegionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Region"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RegionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Region"] | undefined
};
	["RegionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Region"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RegionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Region"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["LinkItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["LinkItem"] | undefined
};
	["LinkItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["LinkItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["LinkItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["LinkList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["LinkList"] | undefined
};
	["LinkListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["LinkList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["LinkList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Header"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Header"] | undefined
};
	["HeaderUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Header"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Header"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeaderLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeaderLocale"] | undefined
};
	["HeaderLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeaderLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeaderLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Footer"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Footer"] | undefined
};
	["FooterUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Footer"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Footer"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLocale"] | undefined
};
	["FooterLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostList"] | undefined
};
	["PostListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostListItem"] | undefined
};
	["PostListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AppBannerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["AppBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AppBannerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["AppBanner"] | undefined
};
	["AppBannerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["AppBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AppBannerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["AppBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutSettings"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutSettings"] | undefined
};
	["GenericPageAboutSettingsUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutSettings"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutSettings"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined
};
	["GenericPageAboutSettingsLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutSettingsLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Value"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Value"] | undefined
};
	["ValueUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Value"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Value"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ValueItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ValueItem"] | undefined
};
	["ValueItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ValueItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ValueItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ValueList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ValueList"] | undefined
};
	["ValueListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ValueList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ValueListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ValueList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLink"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLink"] | undefined
};
	["ImageLinkUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLink"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLink"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLinkItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLinkItem"] | undefined
};
	["ImageLinkItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLinkItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLinkItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLinkList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLinkList"] | undefined
};
	["ImageLinkListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLinkList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageLinkListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageLinkList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaList"] | undefined
};
	["PostAreaListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaListItem"] | undefined
};
	["PostAreaListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostAreaListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostAreaListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AccordionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Accordion"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AccordionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Accordion"] | undefined
};
	["AccordionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Accordion"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AccordionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Accordion"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AccordionItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["AccordionItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AccordionItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["AccordionItem"] | undefined
};
	["AccordionItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["AccordionItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["AccordionItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["AccordionItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["User"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["User"] | undefined
};
	["UserUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["User"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["User"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPayment"] | undefined
};
	["UserPaymentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CurrencyCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Currency"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CurrencyDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Currency"] | undefined
};
	["CurrencyUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Currency"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CurrencyUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Currency"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Medium"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Medium"] | undefined
};
	["MediumUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Medium"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Medium"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumItem"] | undefined
};
	["MediumItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumList"] | undefined
};
	["MediumListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentOrderIdCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPaymentOrderId"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentOrderIdDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPaymentOrderId"] | undefined
};
	["UserPaymentOrderIdUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPaymentOrderId"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentOrderIdUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPaymentOrderId"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostRevisionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostRevision"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostRevisionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostRevision"] | undefined
};
	["PostRevisionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostRevision"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostRevisionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostRevision"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserRecurringPaymentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserRecurringPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserRecurringPaymentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserRecurringPayment"] | undefined
};
	["UserRecurringPaymentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserRecurringPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserRecurringPaymentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserRecurringPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserRecurringPaymentItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserRecurringPaymentItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserRecurringPaymentItem"] | undefined
};
	["UserRecurringPaymentItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserRecurringPaymentItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserRecurringPaymentItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostRevisionLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostRevisionLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostRevisionLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostRevisionLocale"] | undefined
};
	["PostRevisionLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostRevisionLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostRevisionLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostRevisionLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationCatalogue"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationCatalogue"] | undefined
};
	["TranslationCatalogueUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationCatalogue"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationCatalogue"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationCataloguesIdentifier"] | undefined
};
	["TranslationCataloguesIdentifierUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationDomainCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationDomain"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationDomainDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationDomain"] | undefined
};
	["TranslationDomainUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationDomain"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationDomainUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationDomain"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationKeyCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationKey"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationKeyDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationKey"] | undefined
};
	["TranslationKeyUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationKey"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationKeyUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationKey"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationValueCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationValue"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationValueDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationValue"] | undefined
};
	["TranslationValueUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationValue"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationValueUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationValue"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutGroupLinksLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutGroupLinksLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutGroupLinksLocale"] | undefined
};
	["GenericPageAboutGroupLinksLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageAboutGroupLinksLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MemberListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MemberList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MemberListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MemberList"] | undefined
};
	["MemberListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MemberList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MemberListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MemberList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MemberListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MemberListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MemberListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MemberListItem"] | undefined
};
	["MemberListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MemberListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MemberListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MemberListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FilledTaxFormCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FilledTaxForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FilledTaxFormDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FilledTaxForm"] | undefined
};
	["FilledTaxFormUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FilledTaxForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FilledTaxFormUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FilledTaxForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FilledTaxFormEmailAddressCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FilledTaxFormEmailAddress"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FilledTaxFormEmailAddressDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FilledTaxFormEmailAddress"] | undefined
};
	["FilledTaxFormEmailAddressUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FilledTaxFormEmailAddress"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FilledTaxFormEmailAddressUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FilledTaxFormEmailAddress"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FormCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Form"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FormDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Form"] | undefined
};
	["FormUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Form"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FormUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Form"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CsobPaymentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CsobPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CsobPaymentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CsobPayment"] | undefined
};
	["CsobPaymentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CsobPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CsobPaymentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CsobPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CsobPaymentStatusChangeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CsobPaymentStatusChange"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CsobPaymentStatusChangeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CsobPaymentStatusChange"] | undefined
};
	["CsobPaymentStatusChangeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CsobPaymentStatusChange"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CsobPaymentStatusChangeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CsobPaymentStatusChange"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StripePaymentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StripePayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StripePaymentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StripePayment"] | undefined
};
	["StripePaymentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StripePayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StripePaymentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StripePayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StripePaymentStatusChangeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StripePaymentStatusChange"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StripePaymentStatusChangeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StripePaymentStatusChange"] | undefined
};
	["StripePaymentStatusChangeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StripePaymentStatusChange"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StripePaymentStatusChangeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StripePaymentStatusChange"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RegionPaymentMethodCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RegionPaymentMethod"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RegionPaymentMethodDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RegionPaymentMethod"] | undefined
};
	["RegionPaymentMethodUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RegionPaymentMethod"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RegionPaymentMethodUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RegionPaymentMethod"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TileItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TileItem"] | undefined
};
	["TileItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TileItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TileItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TileList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TileList"] | undefined
};
	["TileListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TileList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TileList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPage"] | undefined
};
	["FeedPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageLocale"] | undefined
};
	["FeedPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageSectionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageSection"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageSectionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageSection"] | undefined
};
	["FeedPageSectionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageSection"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageSectionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageSection"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageTileStripeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageTileStripe"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageTileStripeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageTileStripe"] | undefined
};
	["FeedPageTileStripeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageTileStripe"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FeedPageTileStripeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FeedPageTileStripe"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CardItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CardItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CardItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CardItem"] | undefined
};
	["CardItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CardItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CardItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CardItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CardListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CardList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CardListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CardList"] | undefined
};
	["CardListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CardList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CardListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CardList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["OnBehalfDonationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["OnBehalfDonation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["OnBehalfDonationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["OnBehalfDonation"] | undefined
};
	["OnBehalfDonationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["OnBehalfDonation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["OnBehalfDonationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["OnBehalfDonation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentTriesCollectionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPaymentTriesCollection"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentTriesCollectionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPaymentTriesCollection"] | undefined
};
	["UserPaymentTriesCollectionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPaymentTriesCollection"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["UserPaymentTriesCollectionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["UserPaymentTriesCollection"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecurringPaymentPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecurringPaymentPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecurringPaymentPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecurringPaymentPage"] | undefined
};
	["RecurringPaymentPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecurringPaymentPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecurringPaymentPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecurringPaymentPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecurringPaymentPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecurringPaymentPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecurringPaymentPageLocale"] | undefined
};
	["RecurringPaymentPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecurringPaymentPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecurringPaymentPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuide"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuide"] | undefined
};
	["StoryGuideUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuide"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuide"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuideItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuideItem"] | undefined
};
	["StoryGuideItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuideItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuideItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuideList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuideList"] | undefined
};
	["StoryGuideListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuideList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StoryGuideListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StoryGuideList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeroCarouselCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeroCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeroCarouselDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeroCarousel"] | undefined
};
	["HeroCarouselUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeroCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeroCarouselUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeroCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationList"] | undefined
};
	["PostOrganizationListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationListItem"] | undefined
};
	["PostOrganizationListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PostOrganizationListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PostOrganizationListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarousel"] | undefined
};
	["InfoCarouselUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarouselItem"] | undefined
};
	["InfoCarouselItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PersonSeenInfoCarouselCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PersonSeenInfoCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PersonSeenInfoCarouselDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PersonSeenInfoCarousel"] | undefined
};
	["PersonSeenInfoCarouselUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PersonSeenInfoCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["PersonSeenInfoCarouselUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["PersonSeenInfoCarousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GivenGiftsPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GivenGiftsPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GivenGiftsPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GivenGiftsPage"] | undefined
};
	["GivenGiftsPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GivenGiftsPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GivenGiftsPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GivenGiftsPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GivenGiftsPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GivenGiftsPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GivenGiftsPageLocale"] | undefined
};
	["GivenGiftsPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GivenGiftsPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GivenGiftsPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReceivedGiftsPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReceivedGiftsPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReceivedGiftsPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReceivedGiftsPage"] | undefined
};
	["ReceivedGiftsPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReceivedGiftsPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReceivedGiftsPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReceivedGiftsPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReceivedGiftsPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReceivedGiftsPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReceivedGiftsPageLocale"] | undefined
};
	["ReceivedGiftsPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReceivedGiftsPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReceivedGiftsPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportNavigationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportNavigation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportNavigationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportNavigation"] | undefined
};
	["ReportNavigationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportNavigation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportNavigationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportNavigation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportPage"] | undefined
};
	["ReportPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportPageLocale"] | undefined
};
	["ReportPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportNavigationLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportNavigationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportNavigationLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportNavigationLocale"] | undefined
};
	["ReportNavigationLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportNavigationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ReportNavigationLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ReportNavigationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SentPaymentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SentPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SentPaymentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SentPayment"] | undefined
};
	["SentPaymentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SentPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SentPaymentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SentPayment"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["NotificationTargetGroupCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["NotificationTargetGroup"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["NotificationTargetGroupDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["NotificationTargetGroup"] | undefined
};
	["NotificationTargetGroupUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["NotificationTargetGroup"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["NotificationTargetGroupUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["NotificationTargetGroup"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ProcessedNotificationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ProcessedNotification"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ProcessedNotificationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ProcessedNotification"] | undefined
};
	["ProcessedNotificationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ProcessedNotification"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ProcessedNotificationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ProcessedNotification"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ScheduledNotificationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ScheduledNotification"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ScheduledNotificationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ScheduledNotification"] | undefined
};
	["ScheduledNotificationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ScheduledNotification"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ScheduledNotificationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ScheduledNotification"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ProcessedNotificationSourceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ProcessedNotificationSource"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ProcessedNotificationSourceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ProcessedNotificationSource"] | undefined
};
	["ProcessedNotificationSourceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ProcessedNotificationSource"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ProcessedNotificationSourceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ProcessedNotificationSource"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DeviceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Device"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DeviceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Device"] | undefined
};
	["DeviceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Device"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["DeviceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Device"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ScheduledNotificationLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ScheduledNotificationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ScheduledNotificationLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ScheduledNotificationLocale"] | undefined
};
	["ScheduledNotificationLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ScheduledNotificationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ScheduledNotificationLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ScheduledNotificationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselItemLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarouselItemLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselItemLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarouselItemLocale"] | undefined
};
	["InfoCarouselItemLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarouselItemLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoCarouselItemLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoCarouselItemLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SentPaymentLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SentPaymentLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SentPaymentLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SentPaymentLocale"] | undefined
};
	["SentPaymentLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SentPaymentLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SentPaymentLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SentPaymentLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextImageListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextImageList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextImageListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextImageList"] | undefined
};
	["TextImageListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextImageList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextImageListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextImageList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextImageListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextImageListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextImageListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextImageListItem"] | undefined
};
	["TextImageListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextImageListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextImageListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextImageListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeroCarouselItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeroCarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeroCarouselItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeroCarouselItem"] | undefined
};
	["HeroCarouselItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeroCarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeroCarouselItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeroCarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	validation: ModelTypes["_ValidationResult"],
	generateUploadUrl: ModelTypes["S3SignedUpload"],
	generateReadUrl: ModelTypes["S3SignedRead"],
	createGeneral: ModelTypes["GeneralCreateResult"],
	deleteGeneral: ModelTypes["GeneralDeleteResult"],
	updateGeneral: ModelTypes["GeneralUpdateResult"],
	upsertGeneral: ModelTypes["GeneralUpsertResult"],
	createImage: ModelTypes["ImageCreateResult"],
	deleteImage: ModelTypes["ImageDeleteResult"],
	updateImage: ModelTypes["ImageUpdateResult"],
	upsertImage: ModelTypes["ImageUpsertResult"],
	createGenericPage: ModelTypes["GenericPageCreateResult"],
	deleteGenericPage: ModelTypes["GenericPageDeleteResult"],
	updateGenericPage: ModelTypes["GenericPageUpdateResult"],
	upsertGenericPage: ModelTypes["GenericPageUpsertResult"],
	createLinkable: ModelTypes["LinkableCreateResult"],
	deleteLinkable: ModelTypes["LinkableDeleteResult"],
	updateLinkable: ModelTypes["LinkableUpdateResult"],
	upsertLinkable: ModelTypes["LinkableUpsertResult"],
	createSeo: ModelTypes["SeoCreateResult"],
	deleteSeo: ModelTypes["SeoDeleteResult"],
	updateSeo: ModelTypes["SeoUpdateResult"],
	upsertSeo: ModelTypes["SeoUpsertResult"],
	createContent: ModelTypes["ContentCreateResult"],
	deleteContent: ModelTypes["ContentDeleteResult"],
	updateContent: ModelTypes["ContentUpdateResult"],
	upsertContent: ModelTypes["ContentUpsertResult"],
	createContentBlock: ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock: ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock: ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock: ModelTypes["ContentBlockUpsertResult"],
	createContentReference: ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference: ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference: ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference: ModelTypes["ContentReferenceUpsertResult"],
	createGeneralLocale: ModelTypes["GeneralLocaleCreateResult"],
	deleteGeneralLocale: ModelTypes["GeneralLocaleDeleteResult"],
	updateGeneralLocale: ModelTypes["GeneralLocaleUpdateResult"],
	upsertGeneralLocale: ModelTypes["GeneralLocaleUpsertResult"],
	createGenericPageLocale: ModelTypes["GenericPageLocaleCreateResult"],
	deleteGenericPageLocale: ModelTypes["GenericPageLocaleDeleteResult"],
	updateGenericPageLocale: ModelTypes["GenericPageLocaleUpdateResult"],
	upsertGenericPageLocale: ModelTypes["GenericPageLocaleUpsertResult"],
	createLocale: ModelTypes["LocaleCreateResult"],
	deleteLocale: ModelTypes["LocaleDeleteResult"],
	updateLocale: ModelTypes["LocaleUpdateResult"],
	upsertLocale: ModelTypes["LocaleUpsertResult"],
	createVideo: ModelTypes["VideoCreateResult"],
	deleteVideo: ModelTypes["VideoDeleteResult"],
	updateVideo: ModelTypes["VideoUpdateResult"],
	upsertVideo: ModelTypes["VideoUpsertResult"],
	createLink: ModelTypes["LinkCreateResult"],
	deleteLink: ModelTypes["LinkDeleteResult"],
	updateLink: ModelTypes["LinkUpdateResult"],
	upsertLink: ModelTypes["LinkUpsertResult"],
	createPost: ModelTypes["PostCreateResult"],
	deletePost: ModelTypes["PostDeleteResult"],
	updatePost: ModelTypes["PostUpdateResult"],
	upsertPost: ModelTypes["PostUpsertResult"],
	createPostLocale: ModelTypes["PostLocaleCreateResult"],
	deletePostLocale: ModelTypes["PostLocaleDeleteResult"],
	updatePostLocale: ModelTypes["PostLocaleUpdateResult"],
	upsertPostLocale: ModelTypes["PostLocaleUpsertResult"],
	createPostArea: ModelTypes["PostAreaCreateResult"],
	deletePostArea: ModelTypes["PostAreaDeleteResult"],
	updatePostArea: ModelTypes["PostAreaUpdateResult"],
	upsertPostArea: ModelTypes["PostAreaUpsertResult"],
	createPostAreaLocale: ModelTypes["PostAreaLocaleCreateResult"],
	deletePostAreaLocale: ModelTypes["PostAreaLocaleDeleteResult"],
	updatePostAreaLocale: ModelTypes["PostAreaLocaleUpdateResult"],
	upsertPostAreaLocale: ModelTypes["PostAreaLocaleUpsertResult"],
	createPostOrganization: ModelTypes["PostOrganizationCreateResult"],
	deletePostOrganization: ModelTypes["PostOrganizationDeleteResult"],
	updatePostOrganization: ModelTypes["PostOrganizationUpdateResult"],
	upsertPostOrganization: ModelTypes["PostOrganizationUpsertResult"],
	createPostOrganizationLocale: ModelTypes["PostOrganizationLocaleCreateResult"],
	deletePostOrganizationLocale: ModelTypes["PostOrganizationLocaleDeleteResult"],
	updatePostOrganizationLocale: ModelTypes["PostOrganizationLocaleUpdateResult"],
	upsertPostOrganizationLocale: ModelTypes["PostOrganizationLocaleUpsertResult"],
	createDonation: ModelTypes["DonationCreateResult"],
	deleteDonation: ModelTypes["DonationDeleteResult"],
	updateDonation: ModelTypes["DonationUpdateResult"],
	upsertDonation: ModelTypes["DonationUpsertResult"],
	createDonationAmountItem: ModelTypes["DonationAmountItemCreateResult"],
	deleteDonationAmountItem: ModelTypes["DonationAmountItemDeleteResult"],
	updateDonationAmountItem: ModelTypes["DonationAmountItemUpdateResult"],
	upsertDonationAmountItem: ModelTypes["DonationAmountItemUpsertResult"],
	createDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemCreateResult"],
	deleteDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemDeleteResult"],
	updateDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemUpdateResult"],
	upsertDonationAmountsRegionItem: ModelTypes["DonationAmountsRegionItemUpsertResult"],
	createDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListCreateResult"],
	deleteDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListDeleteResult"],
	updateDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListUpdateResult"],
	upsertDonationAmountsRegionList: ModelTypes["DonationAmountsRegionListUpsertResult"],
	createRegion: ModelTypes["RegionCreateResult"],
	deleteRegion: ModelTypes["RegionDeleteResult"],
	updateRegion: ModelTypes["RegionUpdateResult"],
	upsertRegion: ModelTypes["RegionUpsertResult"],
	createLinkItem: ModelTypes["LinkItemCreateResult"],
	deleteLinkItem: ModelTypes["LinkItemDeleteResult"],
	updateLinkItem: ModelTypes["LinkItemUpdateResult"],
	upsertLinkItem: ModelTypes["LinkItemUpsertResult"],
	createLinkList: ModelTypes["LinkListCreateResult"],
	deleteLinkList: ModelTypes["LinkListDeleteResult"],
	updateLinkList: ModelTypes["LinkListUpdateResult"],
	upsertLinkList: ModelTypes["LinkListUpsertResult"],
	createHeader: ModelTypes["HeaderCreateResult"],
	deleteHeader: ModelTypes["HeaderDeleteResult"],
	updateHeader: ModelTypes["HeaderUpdateResult"],
	upsertHeader: ModelTypes["HeaderUpsertResult"],
	createHeaderLocale: ModelTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: ModelTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: ModelTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: ModelTypes["HeaderLocaleUpsertResult"],
	createFooter: ModelTypes["FooterCreateResult"],
	deleteFooter: ModelTypes["FooterDeleteResult"],
	updateFooter: ModelTypes["FooterUpdateResult"],
	upsertFooter: ModelTypes["FooterUpsertResult"],
	createFooterLocale: ModelTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: ModelTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: ModelTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: ModelTypes["FooterLocaleUpsertResult"],
	createPostList: ModelTypes["PostListCreateResult"],
	deletePostList: ModelTypes["PostListDeleteResult"],
	updatePostList: ModelTypes["PostListUpdateResult"],
	upsertPostList: ModelTypes["PostListUpsertResult"],
	createPostListItem: ModelTypes["PostListItemCreateResult"],
	deletePostListItem: ModelTypes["PostListItemDeleteResult"],
	updatePostListItem: ModelTypes["PostListItemUpdateResult"],
	upsertPostListItem: ModelTypes["PostListItemUpsertResult"],
	createAppBanner: ModelTypes["AppBannerCreateResult"],
	deleteAppBanner: ModelTypes["AppBannerDeleteResult"],
	updateAppBanner: ModelTypes["AppBannerUpdateResult"],
	upsertAppBanner: ModelTypes["AppBannerUpsertResult"],
	createGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsCreateResult"],
	deleteGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsDeleteResult"],
	updateGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsUpdateResult"],
	upsertGenericPageAboutSettings: ModelTypes["GenericPageAboutSettingsUpsertResult"],
	createGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleCreateResult"],
	deleteGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleDeleteResult"],
	updateGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleUpdateResult"],
	upsertGenericPageAboutSettingsLocale: ModelTypes["GenericPageAboutSettingsLocaleUpsertResult"],
	createValue: ModelTypes["ValueCreateResult"],
	deleteValue: ModelTypes["ValueDeleteResult"],
	updateValue: ModelTypes["ValueUpdateResult"],
	upsertValue: ModelTypes["ValueUpsertResult"],
	createValueItem: ModelTypes["ValueItemCreateResult"],
	deleteValueItem: ModelTypes["ValueItemDeleteResult"],
	updateValueItem: ModelTypes["ValueItemUpdateResult"],
	upsertValueItem: ModelTypes["ValueItemUpsertResult"],
	createValueList: ModelTypes["ValueListCreateResult"],
	deleteValueList: ModelTypes["ValueListDeleteResult"],
	updateValueList: ModelTypes["ValueListUpdateResult"],
	upsertValueList: ModelTypes["ValueListUpsertResult"],
	createImageLink: ModelTypes["ImageLinkCreateResult"],
	deleteImageLink: ModelTypes["ImageLinkDeleteResult"],
	updateImageLink: ModelTypes["ImageLinkUpdateResult"],
	upsertImageLink: ModelTypes["ImageLinkUpsertResult"],
	createImageLinkItem: ModelTypes["ImageLinkItemCreateResult"],
	deleteImageLinkItem: ModelTypes["ImageLinkItemDeleteResult"],
	updateImageLinkItem: ModelTypes["ImageLinkItemUpdateResult"],
	upsertImageLinkItem: ModelTypes["ImageLinkItemUpsertResult"],
	createImageLinkList: ModelTypes["ImageLinkListCreateResult"],
	deleteImageLinkList: ModelTypes["ImageLinkListDeleteResult"],
	updateImageLinkList: ModelTypes["ImageLinkListUpdateResult"],
	upsertImageLinkList: ModelTypes["ImageLinkListUpsertResult"],
	createPostAreaList: ModelTypes["PostAreaListCreateResult"],
	deletePostAreaList: ModelTypes["PostAreaListDeleteResult"],
	updatePostAreaList: ModelTypes["PostAreaListUpdateResult"],
	upsertPostAreaList: ModelTypes["PostAreaListUpsertResult"],
	createPostAreaListItem: ModelTypes["PostAreaListItemCreateResult"],
	deletePostAreaListItem: ModelTypes["PostAreaListItemDeleteResult"],
	updatePostAreaListItem: ModelTypes["PostAreaListItemUpdateResult"],
	upsertPostAreaListItem: ModelTypes["PostAreaListItemUpsertResult"],
	createAccordion: ModelTypes["AccordionCreateResult"],
	deleteAccordion: ModelTypes["AccordionDeleteResult"],
	updateAccordion: ModelTypes["AccordionUpdateResult"],
	upsertAccordion: ModelTypes["AccordionUpsertResult"],
	createAccordionItem: ModelTypes["AccordionItemCreateResult"],
	deleteAccordionItem: ModelTypes["AccordionItemDeleteResult"],
	updateAccordionItem: ModelTypes["AccordionItemUpdateResult"],
	upsertAccordionItem: ModelTypes["AccordionItemUpsertResult"],
	createUser: ModelTypes["UserCreateResult"],
	deleteUser: ModelTypes["UserDeleteResult"],
	updateUser: ModelTypes["UserUpdateResult"],
	upsertUser: ModelTypes["UserUpsertResult"],
	createUserPayment: ModelTypes["UserPaymentCreateResult"],
	deleteUserPayment: ModelTypes["UserPaymentDeleteResult"],
	updateUserPayment: ModelTypes["UserPaymentUpdateResult"],
	upsertUserPayment: ModelTypes["UserPaymentUpsertResult"],
	createCurrency: ModelTypes["CurrencyCreateResult"],
	deleteCurrency: ModelTypes["CurrencyDeleteResult"],
	updateCurrency: ModelTypes["CurrencyUpdateResult"],
	upsertCurrency: ModelTypes["CurrencyUpsertResult"],
	createMedium: ModelTypes["MediumCreateResult"],
	deleteMedium: ModelTypes["MediumDeleteResult"],
	updateMedium: ModelTypes["MediumUpdateResult"],
	upsertMedium: ModelTypes["MediumUpsertResult"],
	createMediumItem: ModelTypes["MediumItemCreateResult"],
	deleteMediumItem: ModelTypes["MediumItemDeleteResult"],
	updateMediumItem: ModelTypes["MediumItemUpdateResult"],
	upsertMediumItem: ModelTypes["MediumItemUpsertResult"],
	createMediumList: ModelTypes["MediumListCreateResult"],
	deleteMediumList: ModelTypes["MediumListDeleteResult"],
	updateMediumList: ModelTypes["MediumListUpdateResult"],
	upsertMediumList: ModelTypes["MediumListUpsertResult"],
	createUserPaymentOrderId: ModelTypes["UserPaymentOrderIdCreateResult"],
	deleteUserPaymentOrderId: ModelTypes["UserPaymentOrderIdDeleteResult"],
	updateUserPaymentOrderId: ModelTypes["UserPaymentOrderIdUpdateResult"],
	upsertUserPaymentOrderId: ModelTypes["UserPaymentOrderIdUpsertResult"],
	createPostRevision: ModelTypes["PostRevisionCreateResult"],
	deletePostRevision: ModelTypes["PostRevisionDeleteResult"],
	updatePostRevision: ModelTypes["PostRevisionUpdateResult"],
	upsertPostRevision: ModelTypes["PostRevisionUpsertResult"],
	createUserRecurringPayment: ModelTypes["UserRecurringPaymentCreateResult"],
	deleteUserRecurringPayment: ModelTypes["UserRecurringPaymentDeleteResult"],
	updateUserRecurringPayment: ModelTypes["UserRecurringPaymentUpdateResult"],
	upsertUserRecurringPayment: ModelTypes["UserRecurringPaymentUpsertResult"],
	createUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemCreateResult"],
	deleteUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemDeleteResult"],
	updateUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemUpdateResult"],
	upsertUserRecurringPaymentItem: ModelTypes["UserRecurringPaymentItemUpsertResult"],
	createPostRevisionLocale: ModelTypes["PostRevisionLocaleCreateResult"],
	deletePostRevisionLocale: ModelTypes["PostRevisionLocaleDeleteResult"],
	updatePostRevisionLocale: ModelTypes["PostRevisionLocaleUpdateResult"],
	upsertPostRevisionLocale: ModelTypes["PostRevisionLocaleUpsertResult"],
	createTranslationCatalogue: ModelTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: ModelTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: ModelTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: ModelTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: ModelTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationDomain: ModelTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: ModelTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: ModelTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: ModelTypes["TranslationDomainUpsertResult"],
	createTranslationKey: ModelTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: ModelTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: ModelTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: ModelTypes["TranslationKeyUpsertResult"],
	createTranslationValue: ModelTypes["TranslationValueCreateResult"],
	deleteTranslationValue: ModelTypes["TranslationValueDeleteResult"],
	updateTranslationValue: ModelTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: ModelTypes["TranslationValueUpsertResult"],
	createGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleCreateResult"],
	deleteGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleDeleteResult"],
	updateGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleUpdateResult"],
	upsertGenericPageAboutGroupLinksLocale: ModelTypes["GenericPageAboutGroupLinksLocaleUpsertResult"],
	createMemberList: ModelTypes["MemberListCreateResult"],
	deleteMemberList: ModelTypes["MemberListDeleteResult"],
	updateMemberList: ModelTypes["MemberListUpdateResult"],
	upsertMemberList: ModelTypes["MemberListUpsertResult"],
	createMemberListItem: ModelTypes["MemberListItemCreateResult"],
	deleteMemberListItem: ModelTypes["MemberListItemDeleteResult"],
	updateMemberListItem: ModelTypes["MemberListItemUpdateResult"],
	upsertMemberListItem: ModelTypes["MemberListItemUpsertResult"],
	createFilledTaxForm: ModelTypes["FilledTaxFormCreateResult"],
	deleteFilledTaxForm: ModelTypes["FilledTaxFormDeleteResult"],
	updateFilledTaxForm: ModelTypes["FilledTaxFormUpdateResult"],
	upsertFilledTaxForm: ModelTypes["FilledTaxFormUpsertResult"],
	createFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressCreateResult"],
	deleteFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressDeleteResult"],
	updateFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressUpdateResult"],
	upsertFilledTaxFormEmailAddress: ModelTypes["FilledTaxFormEmailAddressUpsertResult"],
	createForm: ModelTypes["FormCreateResult"],
	deleteForm: ModelTypes["FormDeleteResult"],
	updateForm: ModelTypes["FormUpdateResult"],
	upsertForm: ModelTypes["FormUpsertResult"],
	createCsobPayment: ModelTypes["CsobPaymentCreateResult"],
	deleteCsobPayment: ModelTypes["CsobPaymentDeleteResult"],
	updateCsobPayment: ModelTypes["CsobPaymentUpdateResult"],
	upsertCsobPayment: ModelTypes["CsobPaymentUpsertResult"],
	createCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeCreateResult"],
	deleteCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeDeleteResult"],
	updateCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeUpdateResult"],
	upsertCsobPaymentStatusChange: ModelTypes["CsobPaymentStatusChangeUpsertResult"],
	createStripePayment: ModelTypes["StripePaymentCreateResult"],
	deleteStripePayment: ModelTypes["StripePaymentDeleteResult"],
	updateStripePayment: ModelTypes["StripePaymentUpdateResult"],
	upsertStripePayment: ModelTypes["StripePaymentUpsertResult"],
	createStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeCreateResult"],
	deleteStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeDeleteResult"],
	updateStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeUpdateResult"],
	upsertStripePaymentStatusChange: ModelTypes["StripePaymentStatusChangeUpsertResult"],
	createRegionPaymentMethod: ModelTypes["RegionPaymentMethodCreateResult"],
	deleteRegionPaymentMethod: ModelTypes["RegionPaymentMethodDeleteResult"],
	updateRegionPaymentMethod: ModelTypes["RegionPaymentMethodUpdateResult"],
	upsertRegionPaymentMethod: ModelTypes["RegionPaymentMethodUpsertResult"],
	createTileItem: ModelTypes["TileItemCreateResult"],
	deleteTileItem: ModelTypes["TileItemDeleteResult"],
	updateTileItem: ModelTypes["TileItemUpdateResult"],
	upsertTileItem: ModelTypes["TileItemUpsertResult"],
	createTileList: ModelTypes["TileListCreateResult"],
	deleteTileList: ModelTypes["TileListDeleteResult"],
	updateTileList: ModelTypes["TileListUpdateResult"],
	upsertTileList: ModelTypes["TileListUpsertResult"],
	createFeedPage: ModelTypes["FeedPageCreateResult"],
	deleteFeedPage: ModelTypes["FeedPageDeleteResult"],
	updateFeedPage: ModelTypes["FeedPageUpdateResult"],
	upsertFeedPage: ModelTypes["FeedPageUpsertResult"],
	createFeedPageLocale: ModelTypes["FeedPageLocaleCreateResult"],
	deleteFeedPageLocale: ModelTypes["FeedPageLocaleDeleteResult"],
	updateFeedPageLocale: ModelTypes["FeedPageLocaleUpdateResult"],
	upsertFeedPageLocale: ModelTypes["FeedPageLocaleUpsertResult"],
	createFeedPageSection: ModelTypes["FeedPageSectionCreateResult"],
	deleteFeedPageSection: ModelTypes["FeedPageSectionDeleteResult"],
	updateFeedPageSection: ModelTypes["FeedPageSectionUpdateResult"],
	upsertFeedPageSection: ModelTypes["FeedPageSectionUpsertResult"],
	createFeedPageTileStripe: ModelTypes["FeedPageTileStripeCreateResult"],
	deleteFeedPageTileStripe: ModelTypes["FeedPageTileStripeDeleteResult"],
	updateFeedPageTileStripe: ModelTypes["FeedPageTileStripeUpdateResult"],
	upsertFeedPageTileStripe: ModelTypes["FeedPageTileStripeUpsertResult"],
	createCardItem: ModelTypes["CardItemCreateResult"],
	deleteCardItem: ModelTypes["CardItemDeleteResult"],
	updateCardItem: ModelTypes["CardItemUpdateResult"],
	upsertCardItem: ModelTypes["CardItemUpsertResult"],
	createCardList: ModelTypes["CardListCreateResult"],
	deleteCardList: ModelTypes["CardListDeleteResult"],
	updateCardList: ModelTypes["CardListUpdateResult"],
	upsertCardList: ModelTypes["CardListUpsertResult"],
	createOnBehalfDonation: ModelTypes["OnBehalfDonationCreateResult"],
	deleteOnBehalfDonation: ModelTypes["OnBehalfDonationDeleteResult"],
	updateOnBehalfDonation: ModelTypes["OnBehalfDonationUpdateResult"],
	upsertOnBehalfDonation: ModelTypes["OnBehalfDonationUpsertResult"],
	createUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionCreateResult"],
	deleteUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionDeleteResult"],
	updateUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionUpdateResult"],
	upsertUserPaymentTriesCollection: ModelTypes["UserPaymentTriesCollectionUpsertResult"],
	createRecurringPaymentPage: ModelTypes["RecurringPaymentPageCreateResult"],
	deleteRecurringPaymentPage: ModelTypes["RecurringPaymentPageDeleteResult"],
	updateRecurringPaymentPage: ModelTypes["RecurringPaymentPageUpdateResult"],
	upsertRecurringPaymentPage: ModelTypes["RecurringPaymentPageUpsertResult"],
	createRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleCreateResult"],
	deleteRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleDeleteResult"],
	updateRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleUpdateResult"],
	upsertRecurringPaymentPageLocale: ModelTypes["RecurringPaymentPageLocaleUpsertResult"],
	createStoryGuide: ModelTypes["StoryGuideCreateResult"],
	deleteStoryGuide: ModelTypes["StoryGuideDeleteResult"],
	updateStoryGuide: ModelTypes["StoryGuideUpdateResult"],
	upsertStoryGuide: ModelTypes["StoryGuideUpsertResult"],
	createStoryGuideItem: ModelTypes["StoryGuideItemCreateResult"],
	deleteStoryGuideItem: ModelTypes["StoryGuideItemDeleteResult"],
	updateStoryGuideItem: ModelTypes["StoryGuideItemUpdateResult"],
	upsertStoryGuideItem: ModelTypes["StoryGuideItemUpsertResult"],
	createStoryGuideList: ModelTypes["StoryGuideListCreateResult"],
	deleteStoryGuideList: ModelTypes["StoryGuideListDeleteResult"],
	updateStoryGuideList: ModelTypes["StoryGuideListUpdateResult"],
	upsertStoryGuideList: ModelTypes["StoryGuideListUpsertResult"],
	createHeroCarousel: ModelTypes["HeroCarouselCreateResult"],
	deleteHeroCarousel: ModelTypes["HeroCarouselDeleteResult"],
	updateHeroCarousel: ModelTypes["HeroCarouselUpdateResult"],
	upsertHeroCarousel: ModelTypes["HeroCarouselUpsertResult"],
	createPostOrganizationList: ModelTypes["PostOrganizationListCreateResult"],
	deletePostOrganizationList: ModelTypes["PostOrganizationListDeleteResult"],
	updatePostOrganizationList: ModelTypes["PostOrganizationListUpdateResult"],
	upsertPostOrganizationList: ModelTypes["PostOrganizationListUpsertResult"],
	createPostOrganizationListItem: ModelTypes["PostOrganizationListItemCreateResult"],
	deletePostOrganizationListItem: ModelTypes["PostOrganizationListItemDeleteResult"],
	updatePostOrganizationListItem: ModelTypes["PostOrganizationListItemUpdateResult"],
	upsertPostOrganizationListItem: ModelTypes["PostOrganizationListItemUpsertResult"],
	createInfoCarousel: ModelTypes["InfoCarouselCreateResult"],
	deleteInfoCarousel: ModelTypes["InfoCarouselDeleteResult"],
	updateInfoCarousel: ModelTypes["InfoCarouselUpdateResult"],
	upsertInfoCarousel: ModelTypes["InfoCarouselUpsertResult"],
	createInfoCarouselItem: ModelTypes["InfoCarouselItemCreateResult"],
	deleteInfoCarouselItem: ModelTypes["InfoCarouselItemDeleteResult"],
	updateInfoCarouselItem: ModelTypes["InfoCarouselItemUpdateResult"],
	upsertInfoCarouselItem: ModelTypes["InfoCarouselItemUpsertResult"],
	createPersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselCreateResult"],
	deletePersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselDeleteResult"],
	updatePersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselUpdateResult"],
	upsertPersonSeenInfoCarousel: ModelTypes["PersonSeenInfoCarouselUpsertResult"],
	createGivenGiftsPage: ModelTypes["GivenGiftsPageCreateResult"],
	deleteGivenGiftsPage: ModelTypes["GivenGiftsPageDeleteResult"],
	updateGivenGiftsPage: ModelTypes["GivenGiftsPageUpdateResult"],
	upsertGivenGiftsPage: ModelTypes["GivenGiftsPageUpsertResult"],
	createGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleCreateResult"],
	deleteGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleDeleteResult"],
	updateGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleUpdateResult"],
	upsertGivenGiftsPageLocale: ModelTypes["GivenGiftsPageLocaleUpsertResult"],
	createReceivedGiftsPage: ModelTypes["ReceivedGiftsPageCreateResult"],
	deleteReceivedGiftsPage: ModelTypes["ReceivedGiftsPageDeleteResult"],
	updateReceivedGiftsPage: ModelTypes["ReceivedGiftsPageUpdateResult"],
	upsertReceivedGiftsPage: ModelTypes["ReceivedGiftsPageUpsertResult"],
	createReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleCreateResult"],
	deleteReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleDeleteResult"],
	updateReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleUpdateResult"],
	upsertReceivedGiftsPageLocale: ModelTypes["ReceivedGiftsPageLocaleUpsertResult"],
	createReportNavigation: ModelTypes["ReportNavigationCreateResult"],
	deleteReportNavigation: ModelTypes["ReportNavigationDeleteResult"],
	updateReportNavigation: ModelTypes["ReportNavigationUpdateResult"],
	upsertReportNavigation: ModelTypes["ReportNavigationUpsertResult"],
	createReportPage: ModelTypes["ReportPageCreateResult"],
	deleteReportPage: ModelTypes["ReportPageDeleteResult"],
	updateReportPage: ModelTypes["ReportPageUpdateResult"],
	upsertReportPage: ModelTypes["ReportPageUpsertResult"],
	createReportPageLocale: ModelTypes["ReportPageLocaleCreateResult"],
	deleteReportPageLocale: ModelTypes["ReportPageLocaleDeleteResult"],
	updateReportPageLocale: ModelTypes["ReportPageLocaleUpdateResult"],
	upsertReportPageLocale: ModelTypes["ReportPageLocaleUpsertResult"],
	createReportNavigationLocale: ModelTypes["ReportNavigationLocaleCreateResult"],
	deleteReportNavigationLocale: ModelTypes["ReportNavigationLocaleDeleteResult"],
	updateReportNavigationLocale: ModelTypes["ReportNavigationLocaleUpdateResult"],
	upsertReportNavigationLocale: ModelTypes["ReportNavigationLocaleUpsertResult"],
	createSentPayment: ModelTypes["SentPaymentCreateResult"],
	deleteSentPayment: ModelTypes["SentPaymentDeleteResult"],
	updateSentPayment: ModelTypes["SentPaymentUpdateResult"],
	upsertSentPayment: ModelTypes["SentPaymentUpsertResult"],
	createNotificationTargetGroup: ModelTypes["NotificationTargetGroupCreateResult"],
	deleteNotificationTargetGroup: ModelTypes["NotificationTargetGroupDeleteResult"],
	updateNotificationTargetGroup: ModelTypes["NotificationTargetGroupUpdateResult"],
	upsertNotificationTargetGroup: ModelTypes["NotificationTargetGroupUpsertResult"],
	createProcessedNotification: ModelTypes["ProcessedNotificationCreateResult"],
	deleteProcessedNotification: ModelTypes["ProcessedNotificationDeleteResult"],
	updateProcessedNotification: ModelTypes["ProcessedNotificationUpdateResult"],
	upsertProcessedNotification: ModelTypes["ProcessedNotificationUpsertResult"],
	createScheduledNotification: ModelTypes["ScheduledNotificationCreateResult"],
	deleteScheduledNotification: ModelTypes["ScheduledNotificationDeleteResult"],
	updateScheduledNotification: ModelTypes["ScheduledNotificationUpdateResult"],
	upsertScheduledNotification: ModelTypes["ScheduledNotificationUpsertResult"],
	createProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceCreateResult"],
	deleteProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceDeleteResult"],
	updateProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceUpdateResult"],
	upsertProcessedNotificationSource: ModelTypes["ProcessedNotificationSourceUpsertResult"],
	createDevice: ModelTypes["DeviceCreateResult"],
	deleteDevice: ModelTypes["DeviceDeleteResult"],
	updateDevice: ModelTypes["DeviceUpdateResult"],
	upsertDevice: ModelTypes["DeviceUpsertResult"],
	createScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleCreateResult"],
	deleteScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleDeleteResult"],
	updateScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleUpdateResult"],
	upsertScheduledNotificationLocale: ModelTypes["ScheduledNotificationLocaleUpsertResult"],
	createInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleCreateResult"],
	deleteInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleDeleteResult"],
	updateInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleUpdateResult"],
	upsertInfoCarouselItemLocale: ModelTypes["InfoCarouselItemLocaleUpsertResult"],
	createSentPaymentLocale: ModelTypes["SentPaymentLocaleCreateResult"],
	deleteSentPaymentLocale: ModelTypes["SentPaymentLocaleDeleteResult"],
	updateSentPaymentLocale: ModelTypes["SentPaymentLocaleUpdateResult"],
	upsertSentPaymentLocale: ModelTypes["SentPaymentLocaleUpsertResult"],
	createTextImageList: ModelTypes["TextImageListCreateResult"],
	deleteTextImageList: ModelTypes["TextImageListDeleteResult"],
	updateTextImageList: ModelTypes["TextImageListUpdateResult"],
	upsertTextImageList: ModelTypes["TextImageListUpsertResult"],
	createTextImageListItem: ModelTypes["TextImageListItemCreateResult"],
	deleteTextImageListItem: ModelTypes["TextImageListItemDeleteResult"],
	updateTextImageListItem: ModelTypes["TextImageListItemUpdateResult"],
	upsertTextImageListItem: ModelTypes["TextImageListItemUpsertResult"],
	createHeroCarouselItem: ModelTypes["HeroCarouselItemCreateResult"],
	deleteHeroCarouselItem: ModelTypes["HeroCarouselItemDeleteResult"],
	updateHeroCarouselItem: ModelTypes["HeroCarouselItemUpdateResult"],
	upsertHeroCarouselItem: ModelTypes["HeroCarouselItemUpsertResult"],
	query?: ModelTypes["Query"] | undefined
};
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?: boolean | undefined,
	deferUniqueConstraints?: boolean | undefined
}
    }

export type GraphQLTypes = {
    ["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string | undefined,
	defaultValue?: GraphQLTypes["Json"] | undefined,
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean | undefined,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"] | undefined,
	validator: number
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string | undefined
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
        	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
        	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"] | undefined
};
	/** Json custom scalar type */
["Json"]: "scalar" & { name: "Json" };
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string | undefined,
	inversedBy?: string | undefined,
	nullable?: boolean | undefined,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"] | undefined,
	orphanRemoval?: boolean | undefined,
	orderBy?: Array<GraphQLTypes["_OrderBy"]> | undefined,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_RelationSide"]: _RelationSide;
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_OrderByDirection"]: _OrderByDirection;
	["Query"]: {
	__typename: "Query",
	schema?: GraphQLTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined,
	getGeneral?: GraphQLTypes["General"] | undefined,
	listGeneral: Array<GraphQLTypes["General"]>,
	paginateGeneral: GraphQLTypes["GeneralConnection"],
	validateCreateGeneral: GraphQLTypes["_ValidationResult"],
	validateUpdateGeneral: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"] | undefined,
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getGenericPage?: GraphQLTypes["GenericPage"] | undefined,
	listGenericPage: Array<GraphQLTypes["GenericPage"]>,
	paginateGenericPage: GraphQLTypes["GenericPageConnection"],
	validateCreateGenericPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPage: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"] | undefined,
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"] | undefined,
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"] | undefined,
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"] | undefined,
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"] | undefined,
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getContentReferenceLinkableItem?: GraphQLTypes["ContentReferenceLinkableItem"] | undefined,
	listContentReferenceLinkableItem: Array<GraphQLTypes["ContentReferenceLinkableItem"]>,
	paginateContentReferenceLinkableItem: GraphQLTypes["ContentReferenceLinkableItemConnection"],
	getGeneralLocale?: GraphQLTypes["GeneralLocale"] | undefined,
	listGeneralLocale: Array<GraphQLTypes["GeneralLocale"]>,
	paginateGeneralLocale: GraphQLTypes["GeneralLocaleConnection"],
	validateCreateGeneralLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGeneralLocale: GraphQLTypes["_ValidationResult"],
	getGenericPageLocale?: GraphQLTypes["GenericPageLocale"] | undefined,
	listGenericPageLocale: Array<GraphQLTypes["GenericPageLocale"]>,
	paginateGenericPageLocale: GraphQLTypes["GenericPageLocaleConnection"],
	validateCreateGenericPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageLocale: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"] | undefined,
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"] | undefined,
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"] | undefined,
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getPost?: GraphQLTypes["Post"] | undefined,
	listPost: Array<GraphQLTypes["Post"]>,
	paginatePost: GraphQLTypes["PostConnection"],
	validateCreatePost: GraphQLTypes["_ValidationResult"],
	validateUpdatePost: GraphQLTypes["_ValidationResult"],
	getPostLocale?: GraphQLTypes["PostLocale"] | undefined,
	listPostLocale: Array<GraphQLTypes["PostLocale"]>,
	paginatePostLocale: GraphQLTypes["PostLocaleConnection"],
	validateCreatePostLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePostLocale: GraphQLTypes["_ValidationResult"],
	getPostArea?: GraphQLTypes["PostArea"] | undefined,
	listPostArea: Array<GraphQLTypes["PostArea"]>,
	paginatePostArea: GraphQLTypes["PostAreaConnection"],
	validateCreatePostArea: GraphQLTypes["_ValidationResult"],
	validateUpdatePostArea: GraphQLTypes["_ValidationResult"],
	getPostAreaLocale?: GraphQLTypes["PostAreaLocale"] | undefined,
	listPostAreaLocale: Array<GraphQLTypes["PostAreaLocale"]>,
	paginatePostAreaLocale: GraphQLTypes["PostAreaLocaleConnection"],
	validateCreatePostAreaLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePostAreaLocale: GraphQLTypes["_ValidationResult"],
	getPostOrganization?: GraphQLTypes["PostOrganization"] | undefined,
	listPostOrganization: Array<GraphQLTypes["PostOrganization"]>,
	paginatePostOrganization: GraphQLTypes["PostOrganizationConnection"],
	validateCreatePostOrganization: GraphQLTypes["_ValidationResult"],
	validateUpdatePostOrganization: GraphQLTypes["_ValidationResult"],
	getPostOrganizationLocale?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	listPostOrganizationLocale: Array<GraphQLTypes["PostOrganizationLocale"]>,
	paginatePostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleConnection"],
	validateCreatePostOrganizationLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePostOrganizationLocale: GraphQLTypes["_ValidationResult"],
	getDonation?: GraphQLTypes["Donation"] | undefined,
	listDonation: Array<GraphQLTypes["Donation"]>,
	paginateDonation: GraphQLTypes["DonationConnection"],
	validateCreateDonation: GraphQLTypes["_ValidationResult"],
	validateUpdateDonation: GraphQLTypes["_ValidationResult"],
	getDonationAmountItem?: GraphQLTypes["DonationAmountItem"] | undefined,
	listDonationAmountItem: Array<GraphQLTypes["DonationAmountItem"]>,
	paginateDonationAmountItem: GraphQLTypes["DonationAmountItemConnection"],
	validateCreateDonationAmountItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDonationAmountItem: GraphQLTypes["_ValidationResult"],
	getDonationAmountsRegionItem?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	listDonationAmountsRegionItem: Array<GraphQLTypes["DonationAmountsRegionItem"]>,
	paginateDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemConnection"],
	validateCreateDonationAmountsRegionItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDonationAmountsRegionItem: GraphQLTypes["_ValidationResult"],
	getDonationAmountsRegionList?: GraphQLTypes["DonationAmountsRegionList"] | undefined,
	listDonationAmountsRegionList: Array<GraphQLTypes["DonationAmountsRegionList"]>,
	paginateDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListConnection"],
	validateCreateDonationAmountsRegionList: GraphQLTypes["_ValidationResult"],
	validateUpdateDonationAmountsRegionList: GraphQLTypes["_ValidationResult"],
	getRegion?: GraphQLTypes["Region"] | undefined,
	listRegion: Array<GraphQLTypes["Region"]>,
	paginateRegion: GraphQLTypes["RegionConnection"],
	validateCreateRegion: GraphQLTypes["_ValidationResult"],
	validateUpdateRegion: GraphQLTypes["_ValidationResult"],
	getLinkItem?: GraphQLTypes["LinkItem"] | undefined,
	listLinkItem: Array<GraphQLTypes["LinkItem"]>,
	paginateLinkItem: GraphQLTypes["LinkItemConnection"],
	validateCreateLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkItem: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"] | undefined,
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"] | undefined,
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLocale?: GraphQLTypes["HeaderLocale"] | undefined,
	listHeaderLocale: Array<GraphQLTypes["HeaderLocale"]>,
	paginateHeaderLocale: GraphQLTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLocale: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"] | undefined,
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLocale?: GraphQLTypes["FooterLocale"] | undefined,
	listFooterLocale: Array<GraphQLTypes["FooterLocale"]>,
	paginateFooterLocale: GraphQLTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLocale: GraphQLTypes["_ValidationResult"],
	getPostList?: GraphQLTypes["PostList"] | undefined,
	listPostList: Array<GraphQLTypes["PostList"]>,
	paginatePostList: GraphQLTypes["PostListConnection"],
	validateCreatePostList: GraphQLTypes["_ValidationResult"],
	validateUpdatePostList: GraphQLTypes["_ValidationResult"],
	getPostListItem?: GraphQLTypes["PostListItem"] | undefined,
	listPostListItem: Array<GraphQLTypes["PostListItem"]>,
	paginatePostListItem: GraphQLTypes["PostListItemConnection"],
	validateCreatePostListItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePostListItem: GraphQLTypes["_ValidationResult"],
	getAppBanner?: GraphQLTypes["AppBanner"] | undefined,
	listAppBanner: Array<GraphQLTypes["AppBanner"]>,
	paginateAppBanner: GraphQLTypes["AppBannerConnection"],
	validateCreateAppBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateAppBanner: GraphQLTypes["_ValidationResult"],
	getGenericPageAboutSettings?: GraphQLTypes["GenericPageAboutSettings"] | undefined,
	listGenericPageAboutSettings: Array<GraphQLTypes["GenericPageAboutSettings"]>,
	paginateGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsConnection"],
	validateCreateGenericPageAboutSettings: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageAboutSettings: GraphQLTypes["_ValidationResult"],
	getGenericPageAboutSettingsLocale?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	listGenericPageAboutSettingsLocale: Array<GraphQLTypes["GenericPageAboutSettingsLocale"]>,
	paginateGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleConnection"],
	validateCreateGenericPageAboutSettingsLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageAboutSettingsLocale: GraphQLTypes["_ValidationResult"],
	getValue?: GraphQLTypes["Value"] | undefined,
	listValue: Array<GraphQLTypes["Value"]>,
	paginateValue: GraphQLTypes["ValueConnection"],
	validateCreateValue: GraphQLTypes["_ValidationResult"],
	validateUpdateValue: GraphQLTypes["_ValidationResult"],
	getValueItem?: GraphQLTypes["ValueItem"] | undefined,
	listValueItem: Array<GraphQLTypes["ValueItem"]>,
	paginateValueItem: GraphQLTypes["ValueItemConnection"],
	validateCreateValueItem: GraphQLTypes["_ValidationResult"],
	validateUpdateValueItem: GraphQLTypes["_ValidationResult"],
	getValueList?: GraphQLTypes["ValueList"] | undefined,
	listValueList: Array<GraphQLTypes["ValueList"]>,
	paginateValueList: GraphQLTypes["ValueListConnection"],
	validateCreateValueList: GraphQLTypes["_ValidationResult"],
	validateUpdateValueList: GraphQLTypes["_ValidationResult"],
	getImageLink?: GraphQLTypes["ImageLink"] | undefined,
	listImageLink: Array<GraphQLTypes["ImageLink"]>,
	paginateImageLink: GraphQLTypes["ImageLinkConnection"],
	validateCreateImageLink: GraphQLTypes["_ValidationResult"],
	validateUpdateImageLink: GraphQLTypes["_ValidationResult"],
	getImageLinkItem?: GraphQLTypes["ImageLinkItem"] | undefined,
	listImageLinkItem: Array<GraphQLTypes["ImageLinkItem"]>,
	paginateImageLinkItem: GraphQLTypes["ImageLinkItemConnection"],
	validateCreateImageLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageLinkItem: GraphQLTypes["_ValidationResult"],
	getImageLinkList?: GraphQLTypes["ImageLinkList"] | undefined,
	listImageLinkList: Array<GraphQLTypes["ImageLinkList"]>,
	paginateImageLinkList: GraphQLTypes["ImageLinkListConnection"],
	validateCreateImageLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageLinkList: GraphQLTypes["_ValidationResult"],
	getPostAreaList?: GraphQLTypes["PostAreaList"] | undefined,
	listPostAreaList: Array<GraphQLTypes["PostAreaList"]>,
	paginatePostAreaList: GraphQLTypes["PostAreaListConnection"],
	validateCreatePostAreaList: GraphQLTypes["_ValidationResult"],
	validateUpdatePostAreaList: GraphQLTypes["_ValidationResult"],
	getPostAreaListItem?: GraphQLTypes["PostAreaListItem"] | undefined,
	listPostAreaListItem: Array<GraphQLTypes["PostAreaListItem"]>,
	paginatePostAreaListItem: GraphQLTypes["PostAreaListItemConnection"],
	validateCreatePostAreaListItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePostAreaListItem: GraphQLTypes["_ValidationResult"],
	getAccordion?: GraphQLTypes["Accordion"] | undefined,
	listAccordion: Array<GraphQLTypes["Accordion"]>,
	paginateAccordion: GraphQLTypes["AccordionConnection"],
	validateCreateAccordion: GraphQLTypes["_ValidationResult"],
	validateUpdateAccordion: GraphQLTypes["_ValidationResult"],
	getAccordionItem?: GraphQLTypes["AccordionItem"] | undefined,
	listAccordionItem: Array<GraphQLTypes["AccordionItem"]>,
	paginateAccordionItem: GraphQLTypes["AccordionItemConnection"],
	validateCreateAccordionItem: GraphQLTypes["_ValidationResult"],
	validateUpdateAccordionItem: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"] | undefined,
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getUserPayment?: GraphQLTypes["UserPayment"] | undefined,
	listUserPayment: Array<GraphQLTypes["UserPayment"]>,
	paginateUserPayment: GraphQLTypes["UserPaymentConnection"],
	validateCreateUserPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateUserPayment: GraphQLTypes["_ValidationResult"],
	getCurrency?: GraphQLTypes["Currency"] | undefined,
	listCurrency: Array<GraphQLTypes["Currency"]>,
	paginateCurrency: GraphQLTypes["CurrencyConnection"],
	validateCreateCurrency: GraphQLTypes["_ValidationResult"],
	validateUpdateCurrency: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"] | undefined,
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getMediumItem?: GraphQLTypes["MediumItem"] | undefined,
	listMediumItem: Array<GraphQLTypes["MediumItem"]>,
	paginateMediumItem: GraphQLTypes["MediumItemConnection"],
	validateCreateMediumItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumItem: GraphQLTypes["_ValidationResult"],
	getMediumList?: GraphQLTypes["MediumList"] | undefined,
	listMediumList: Array<GraphQLTypes["MediumList"]>,
	paginateMediumList: GraphQLTypes["MediumListConnection"],
	validateCreateMediumList: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumList: GraphQLTypes["_ValidationResult"],
	getUserPaymentOrderId?: GraphQLTypes["UserPaymentOrderId"] | undefined,
	listUserPaymentOrderId: Array<GraphQLTypes["UserPaymentOrderId"]>,
	paginateUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdConnection"],
	validateCreateUserPaymentOrderId: GraphQLTypes["_ValidationResult"],
	validateUpdateUserPaymentOrderId: GraphQLTypes["_ValidationResult"],
	getPostRevision?: GraphQLTypes["PostRevision"] | undefined,
	listPostRevision: Array<GraphQLTypes["PostRevision"]>,
	paginatePostRevision: GraphQLTypes["PostRevisionConnection"],
	validateCreatePostRevision: GraphQLTypes["_ValidationResult"],
	validateUpdatePostRevision: GraphQLTypes["_ValidationResult"],
	getUserRecurringPayment?: GraphQLTypes["UserRecurringPayment"] | undefined,
	listUserRecurringPayment: Array<GraphQLTypes["UserRecurringPayment"]>,
	paginateUserRecurringPayment: GraphQLTypes["UserRecurringPaymentConnection"],
	validateCreateUserRecurringPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateUserRecurringPayment: GraphQLTypes["_ValidationResult"],
	getUserRecurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	listUserRecurringPaymentItem: Array<GraphQLTypes["UserRecurringPaymentItem"]>,
	paginateUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemConnection"],
	validateCreateUserRecurringPaymentItem: GraphQLTypes["_ValidationResult"],
	validateUpdateUserRecurringPaymentItem: GraphQLTypes["_ValidationResult"],
	getPostRevisionLocale?: GraphQLTypes["PostRevisionLocale"] | undefined,
	listPostRevisionLocale: Array<GraphQLTypes["PostRevisionLocale"]>,
	paginatePostRevisionLocale: GraphQLTypes["PostRevisionLocaleConnection"],
	validateCreatePostRevisionLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePostRevisionLocale: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"] | undefined,
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"] | undefined,
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"] | undefined,
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getGenericPageAboutGroupLinksLocale?: GraphQLTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	listGenericPageAboutGroupLinksLocale: Array<GraphQLTypes["GenericPageAboutGroupLinksLocale"]>,
	paginateGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleConnection"],
	validateCreateGenericPageAboutGroupLinksLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageAboutGroupLinksLocale: GraphQLTypes["_ValidationResult"],
	getMemberList?: GraphQLTypes["MemberList"] | undefined,
	listMemberList: Array<GraphQLTypes["MemberList"]>,
	paginateMemberList: GraphQLTypes["MemberListConnection"],
	validateCreateMemberList: GraphQLTypes["_ValidationResult"],
	validateUpdateMemberList: GraphQLTypes["_ValidationResult"],
	getMemberListItem?: GraphQLTypes["MemberListItem"] | undefined,
	listMemberListItem: Array<GraphQLTypes["MemberListItem"]>,
	paginateMemberListItem: GraphQLTypes["MemberListItemConnection"],
	validateCreateMemberListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMemberListItem: GraphQLTypes["_ValidationResult"],
	getFilledTaxForm?: GraphQLTypes["FilledTaxForm"] | undefined,
	listFilledTaxForm: Array<GraphQLTypes["FilledTaxForm"]>,
	paginateFilledTaxForm: GraphQLTypes["FilledTaxFormConnection"],
	validateCreateFilledTaxForm: GraphQLTypes["_ValidationResult"],
	validateUpdateFilledTaxForm: GraphQLTypes["_ValidationResult"],
	getFilledTaxFormEmailAddress?: GraphQLTypes["FilledTaxFormEmailAddress"] | undefined,
	listFilledTaxFormEmailAddress: Array<GraphQLTypes["FilledTaxFormEmailAddress"]>,
	paginateFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressConnection"],
	validateCreateFilledTaxFormEmailAddress: GraphQLTypes["_ValidationResult"],
	validateUpdateFilledTaxFormEmailAddress: GraphQLTypes["_ValidationResult"],
	getForm?: GraphQLTypes["Form"] | undefined,
	listForm: Array<GraphQLTypes["Form"]>,
	paginateForm: GraphQLTypes["FormConnection"],
	validateCreateForm: GraphQLTypes["_ValidationResult"],
	validateUpdateForm: GraphQLTypes["_ValidationResult"],
	getCsobPayment?: GraphQLTypes["CsobPayment"] | undefined,
	listCsobPayment: Array<GraphQLTypes["CsobPayment"]>,
	paginateCsobPayment: GraphQLTypes["CsobPaymentConnection"],
	validateCreateCsobPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateCsobPayment: GraphQLTypes["_ValidationResult"],
	getCsobPaymentStatusChange?: GraphQLTypes["CsobPaymentStatusChange"] | undefined,
	listCsobPaymentStatusChange: Array<GraphQLTypes["CsobPaymentStatusChange"]>,
	paginateCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeConnection"],
	validateCreateCsobPaymentStatusChange: GraphQLTypes["_ValidationResult"],
	validateUpdateCsobPaymentStatusChange: GraphQLTypes["_ValidationResult"],
	getStripePayment?: GraphQLTypes["StripePayment"] | undefined,
	listStripePayment: Array<GraphQLTypes["StripePayment"]>,
	paginateStripePayment: GraphQLTypes["StripePaymentConnection"],
	validateCreateStripePayment: GraphQLTypes["_ValidationResult"],
	validateUpdateStripePayment: GraphQLTypes["_ValidationResult"],
	getStripePaymentStatusChange?: GraphQLTypes["StripePaymentStatusChange"] | undefined,
	listStripePaymentStatusChange: Array<GraphQLTypes["StripePaymentStatusChange"]>,
	paginateStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeConnection"],
	validateCreateStripePaymentStatusChange: GraphQLTypes["_ValidationResult"],
	validateUpdateStripePaymentStatusChange: GraphQLTypes["_ValidationResult"],
	getRegionPaymentMethod?: GraphQLTypes["RegionPaymentMethod"] | undefined,
	listRegionPaymentMethod: Array<GraphQLTypes["RegionPaymentMethod"]>,
	paginateRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodConnection"],
	validateCreateRegionPaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateRegionPaymentMethod: GraphQLTypes["_ValidationResult"],
	getPostAreaMetaData?: GraphQLTypes["PostAreaMetaData"] | undefined,
	listPostAreaMetaData: Array<GraphQLTypes["PostAreaMetaData"]>,
	paginatePostAreaMetaData: GraphQLTypes["PostAreaMetaDataConnection"],
	getPostMetaData?: GraphQLTypes["PostMetaData"] | undefined,
	listPostMetaData: Array<GraphQLTypes["PostMetaData"]>,
	paginatePostMetaData: GraphQLTypes["PostMetaDataConnection"],
	getPostOrganizationMetaData?: GraphQLTypes["PostOrganizationMetaData"] | undefined,
	listPostOrganizationMetaData: Array<GraphQLTypes["PostOrganizationMetaData"]>,
	paginatePostOrganizationMetaData: GraphQLTypes["PostOrganizationMetaDataConnection"],
	getTileItem?: GraphQLTypes["TileItem"] | undefined,
	listTileItem: Array<GraphQLTypes["TileItem"]>,
	paginateTileItem: GraphQLTypes["TileItemConnection"],
	validateCreateTileItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTileItem: GraphQLTypes["_ValidationResult"],
	getTileList?: GraphQLTypes["TileList"] | undefined,
	listTileList: Array<GraphQLTypes["TileList"]>,
	paginateTileList: GraphQLTypes["TileListConnection"],
	validateCreateTileList: GraphQLTypes["_ValidationResult"],
	validateUpdateTileList: GraphQLTypes["_ValidationResult"],
	getFeedPage?: GraphQLTypes["FeedPage"] | undefined,
	listFeedPage: Array<GraphQLTypes["FeedPage"]>,
	paginateFeedPage: GraphQLTypes["FeedPageConnection"],
	validateCreateFeedPage: GraphQLTypes["_ValidationResult"],
	validateUpdateFeedPage: GraphQLTypes["_ValidationResult"],
	getFeedPageLocale?: GraphQLTypes["FeedPageLocale"] | undefined,
	listFeedPageLocale: Array<GraphQLTypes["FeedPageLocale"]>,
	paginateFeedPageLocale: GraphQLTypes["FeedPageLocaleConnection"],
	validateCreateFeedPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFeedPageLocale: GraphQLTypes["_ValidationResult"],
	getFeedPageSection?: GraphQLTypes["FeedPageSection"] | undefined,
	listFeedPageSection: Array<GraphQLTypes["FeedPageSection"]>,
	paginateFeedPageSection: GraphQLTypes["FeedPageSectionConnection"],
	validateCreateFeedPageSection: GraphQLTypes["_ValidationResult"],
	validateUpdateFeedPageSection: GraphQLTypes["_ValidationResult"],
	getFeedPageTileStripe?: GraphQLTypes["FeedPageTileStripe"] | undefined,
	listFeedPageTileStripe: Array<GraphQLTypes["FeedPageTileStripe"]>,
	paginateFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeConnection"],
	validateCreateFeedPageTileStripe: GraphQLTypes["_ValidationResult"],
	validateUpdateFeedPageTileStripe: GraphQLTypes["_ValidationResult"],
	getCardItem?: GraphQLTypes["CardItem"] | undefined,
	listCardItem: Array<GraphQLTypes["CardItem"]>,
	paginateCardItem: GraphQLTypes["CardItemConnection"],
	validateCreateCardItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCardItem: GraphQLTypes["_ValidationResult"],
	getCardList?: GraphQLTypes["CardList"] | undefined,
	listCardList: Array<GraphQLTypes["CardList"]>,
	paginateCardList: GraphQLTypes["CardListConnection"],
	validateCreateCardList: GraphQLTypes["_ValidationResult"],
	validateUpdateCardList: GraphQLTypes["_ValidationResult"],
	getOnBehalfDonation?: GraphQLTypes["OnBehalfDonation"] | undefined,
	listOnBehalfDonation: Array<GraphQLTypes["OnBehalfDonation"]>,
	paginateOnBehalfDonation: GraphQLTypes["OnBehalfDonationConnection"],
	validateCreateOnBehalfDonation: GraphQLTypes["_ValidationResult"],
	validateUpdateOnBehalfDonation: GraphQLTypes["_ValidationResult"],
	getUserPaymentTriesCollection?: GraphQLTypes["UserPaymentTriesCollection"] | undefined,
	listUserPaymentTriesCollection: Array<GraphQLTypes["UserPaymentTriesCollection"]>,
	paginateUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionConnection"],
	validateCreateUserPaymentTriesCollection: GraphQLTypes["_ValidationResult"],
	validateUpdateUserPaymentTriesCollection: GraphQLTypes["_ValidationResult"],
	getRecurringPaymentPage?: GraphQLTypes["RecurringPaymentPage"] | undefined,
	listRecurringPaymentPage: Array<GraphQLTypes["RecurringPaymentPage"]>,
	paginateRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageConnection"],
	validateCreateRecurringPaymentPage: GraphQLTypes["_ValidationResult"],
	validateUpdateRecurringPaymentPage: GraphQLTypes["_ValidationResult"],
	getRecurringPaymentPageLocale?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	listRecurringPaymentPageLocale: Array<GraphQLTypes["RecurringPaymentPageLocale"]>,
	paginateRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleConnection"],
	validateCreateRecurringPaymentPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateRecurringPaymentPageLocale: GraphQLTypes["_ValidationResult"],
	getStoryGuide?: GraphQLTypes["StoryGuide"] | undefined,
	listStoryGuide: Array<GraphQLTypes["StoryGuide"]>,
	paginateStoryGuide: GraphQLTypes["StoryGuideConnection"],
	validateCreateStoryGuide: GraphQLTypes["_ValidationResult"],
	validateUpdateStoryGuide: GraphQLTypes["_ValidationResult"],
	getStoryGuideItem?: GraphQLTypes["StoryGuideItem"] | undefined,
	listStoryGuideItem: Array<GraphQLTypes["StoryGuideItem"]>,
	paginateStoryGuideItem: GraphQLTypes["StoryGuideItemConnection"],
	validateCreateStoryGuideItem: GraphQLTypes["_ValidationResult"],
	validateUpdateStoryGuideItem: GraphQLTypes["_ValidationResult"],
	getStoryGuideList?: GraphQLTypes["StoryGuideList"] | undefined,
	listStoryGuideList: Array<GraphQLTypes["StoryGuideList"]>,
	paginateStoryGuideList: GraphQLTypes["StoryGuideListConnection"],
	validateCreateStoryGuideList: GraphQLTypes["_ValidationResult"],
	validateUpdateStoryGuideList: GraphQLTypes["_ValidationResult"],
	getStripePaymentMetadata?: GraphQLTypes["StripePaymentMetadata"] | undefined,
	listStripePaymentMetadata: Array<GraphQLTypes["StripePaymentMetadata"]>,
	paginateStripePaymentMetadata: GraphQLTypes["StripePaymentMetadataConnection"],
	getOnBehalfDonationMetadata?: GraphQLTypes["OnBehalfDonationMetadata"] | undefined,
	listOnBehalfDonationMetadata: Array<GraphQLTypes["OnBehalfDonationMetadata"]>,
	paginateOnBehalfDonationMetadata: GraphQLTypes["OnBehalfDonationMetadataConnection"],
	getUserPaymentTriesCollectionMetadata?: GraphQLTypes["UserPaymentTriesCollectionMetadata"] | undefined,
	listUserPaymentTriesCollectionMetadata: Array<GraphQLTypes["UserPaymentTriesCollectionMetadata"]>,
	paginateUserPaymentTriesCollectionMetadata: GraphQLTypes["UserPaymentTriesCollectionMetadataConnection"],
	getUserPaymentTriesCollectionMetadataLocale?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocale"] | undefined,
	listUserPaymentTriesCollectionMetadataLocale: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataLocale"]>,
	paginateUserPaymentTriesCollectionMetadataLocale: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleConnection"],
	getCsobPaymentMetadata?: GraphQLTypes["CsobPaymentMetadata"] | undefined,
	listCsobPaymentMetadata: Array<GraphQLTypes["CsobPaymentMetadata"]>,
	paginateCsobPaymentMetadata: GraphQLTypes["CsobPaymentMetadataConnection"],
	getHeroCarousel?: GraphQLTypes["HeroCarousel"] | undefined,
	listHeroCarousel: Array<GraphQLTypes["HeroCarousel"]>,
	paginateHeroCarousel: GraphQLTypes["HeroCarouselConnection"],
	validateCreateHeroCarousel: GraphQLTypes["_ValidationResult"],
	validateUpdateHeroCarousel: GraphQLTypes["_ValidationResult"],
	getPostOrganizationList?: GraphQLTypes["PostOrganizationList"] | undefined,
	listPostOrganizationList: Array<GraphQLTypes["PostOrganizationList"]>,
	paginatePostOrganizationList: GraphQLTypes["PostOrganizationListConnection"],
	validateCreatePostOrganizationList: GraphQLTypes["_ValidationResult"],
	validateUpdatePostOrganizationList: GraphQLTypes["_ValidationResult"],
	getPostOrganizationListItem?: GraphQLTypes["PostOrganizationListItem"] | undefined,
	listPostOrganizationListItem: Array<GraphQLTypes["PostOrganizationListItem"]>,
	paginatePostOrganizationListItem: GraphQLTypes["PostOrganizationListItemConnection"],
	validateCreatePostOrganizationListItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePostOrganizationListItem: GraphQLTypes["_ValidationResult"],
	getInfoCarousel?: GraphQLTypes["InfoCarousel"] | undefined,
	listInfoCarousel: Array<GraphQLTypes["InfoCarousel"]>,
	paginateInfoCarousel: GraphQLTypes["InfoCarouselConnection"],
	validateCreateInfoCarousel: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoCarousel: GraphQLTypes["_ValidationResult"],
	getInfoCarouselItem?: GraphQLTypes["InfoCarouselItem"] | undefined,
	listInfoCarouselItem: Array<GraphQLTypes["InfoCarouselItem"]>,
	paginateInfoCarouselItem: GraphQLTypes["InfoCarouselItemConnection"],
	validateCreateInfoCarouselItem: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoCarouselItem: GraphQLTypes["_ValidationResult"],
	getPersonSeenInfoCarousel?: GraphQLTypes["PersonSeenInfoCarousel"] | undefined,
	listPersonSeenInfoCarousel: Array<GraphQLTypes["PersonSeenInfoCarousel"]>,
	paginatePersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselConnection"],
	validateCreatePersonSeenInfoCarousel: GraphQLTypes["_ValidationResult"],
	validateUpdatePersonSeenInfoCarousel: GraphQLTypes["_ValidationResult"],
	getGivenGiftsPage?: GraphQLTypes["GivenGiftsPage"] | undefined,
	listGivenGiftsPage: Array<GraphQLTypes["GivenGiftsPage"]>,
	paginateGivenGiftsPage: GraphQLTypes["GivenGiftsPageConnection"],
	validateCreateGivenGiftsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGivenGiftsPage: GraphQLTypes["_ValidationResult"],
	getGivenGiftsPageLocale?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	listGivenGiftsPageLocale: Array<GraphQLTypes["GivenGiftsPageLocale"]>,
	paginateGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleConnection"],
	validateCreateGivenGiftsPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGivenGiftsPageLocale: GraphQLTypes["_ValidationResult"],
	getReceivedGiftsPage?: GraphQLTypes["ReceivedGiftsPage"] | undefined,
	listReceivedGiftsPage: Array<GraphQLTypes["ReceivedGiftsPage"]>,
	paginateReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageConnection"],
	validateCreateReceivedGiftsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateReceivedGiftsPage: GraphQLTypes["_ValidationResult"],
	getReceivedGiftsPageLocale?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	listReceivedGiftsPageLocale: Array<GraphQLTypes["ReceivedGiftsPageLocale"]>,
	paginateReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleConnection"],
	validateCreateReceivedGiftsPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateReceivedGiftsPageLocale: GraphQLTypes["_ValidationResult"],
	getReportNavigation?: GraphQLTypes["ReportNavigation"] | undefined,
	listReportNavigation: Array<GraphQLTypes["ReportNavigation"]>,
	paginateReportNavigation: GraphQLTypes["ReportNavigationConnection"],
	validateCreateReportNavigation: GraphQLTypes["_ValidationResult"],
	validateUpdateReportNavigation: GraphQLTypes["_ValidationResult"],
	getReportPage?: GraphQLTypes["ReportPage"] | undefined,
	listReportPage: Array<GraphQLTypes["ReportPage"]>,
	paginateReportPage: GraphQLTypes["ReportPageConnection"],
	validateCreateReportPage: GraphQLTypes["_ValidationResult"],
	validateUpdateReportPage: GraphQLTypes["_ValidationResult"],
	getReportPageLocale?: GraphQLTypes["ReportPageLocale"] | undefined,
	listReportPageLocale: Array<GraphQLTypes["ReportPageLocale"]>,
	paginateReportPageLocale: GraphQLTypes["ReportPageLocaleConnection"],
	validateCreateReportPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateReportPageLocale: GraphQLTypes["_ValidationResult"],
	getReportNavigationLocale?: GraphQLTypes["ReportNavigationLocale"] | undefined,
	listReportNavigationLocale: Array<GraphQLTypes["ReportNavigationLocale"]>,
	paginateReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleConnection"],
	validateCreateReportNavigationLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateReportNavigationLocale: GraphQLTypes["_ValidationResult"],
	getSentPayment?: GraphQLTypes["SentPayment"] | undefined,
	listSentPayment: Array<GraphQLTypes["SentPayment"]>,
	paginateSentPayment: GraphQLTypes["SentPaymentConnection"],
	validateCreateSentPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateSentPayment: GraphQLTypes["_ValidationResult"],
	getPostAreaSentPaymentCurrencySum?: GraphQLTypes["PostAreaSentPaymentCurrencySum"] | undefined,
	listPostAreaSentPaymentCurrencySum: Array<GraphQLTypes["PostAreaSentPaymentCurrencySum"]>,
	paginatePostAreaSentPaymentCurrencySum: GraphQLTypes["PostAreaSentPaymentCurrencySumConnection"],
	getPostAreaSentPaymentSum?: GraphQLTypes["PostAreaSentPaymentSum"] | undefined,
	listPostAreaSentPaymentSum: Array<GraphQLTypes["PostAreaSentPaymentSum"]>,
	paginatePostAreaSentPaymentSum: GraphQLTypes["PostAreaSentPaymentSumConnection"],
	getNotificationTargetGroup?: GraphQLTypes["NotificationTargetGroup"] | undefined,
	listNotificationTargetGroup: Array<GraphQLTypes["NotificationTargetGroup"]>,
	paginateNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupConnection"],
	validateCreateNotificationTargetGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateNotificationTargetGroup: GraphQLTypes["_ValidationResult"],
	getProcessedNotification?: GraphQLTypes["ProcessedNotification"] | undefined,
	listProcessedNotification: Array<GraphQLTypes["ProcessedNotification"]>,
	paginateProcessedNotification: GraphQLTypes["ProcessedNotificationConnection"],
	validateCreateProcessedNotification: GraphQLTypes["_ValidationResult"],
	validateUpdateProcessedNotification: GraphQLTypes["_ValidationResult"],
	getScheduledNotification?: GraphQLTypes["ScheduledNotification"] | undefined,
	listScheduledNotification: Array<GraphQLTypes["ScheduledNotification"]>,
	paginateScheduledNotification: GraphQLTypes["ScheduledNotificationConnection"],
	validateCreateScheduledNotification: GraphQLTypes["_ValidationResult"],
	validateUpdateScheduledNotification: GraphQLTypes["_ValidationResult"],
	getProcessedNotificationSource?: GraphQLTypes["ProcessedNotificationSource"] | undefined,
	listProcessedNotificationSource: Array<GraphQLTypes["ProcessedNotificationSource"]>,
	paginateProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceConnection"],
	validateCreateProcessedNotificationSource: GraphQLTypes["_ValidationResult"],
	validateUpdateProcessedNotificationSource: GraphQLTypes["_ValidationResult"],
	getDevice?: GraphQLTypes["Device"] | undefined,
	listDevice: Array<GraphQLTypes["Device"]>,
	paginateDevice: GraphQLTypes["DeviceConnection"],
	validateCreateDevice: GraphQLTypes["_ValidationResult"],
	validateUpdateDevice: GraphQLTypes["_ValidationResult"],
	getScheduledNotificationLocale?: GraphQLTypes["ScheduledNotificationLocale"] | undefined,
	listScheduledNotificationLocale: Array<GraphQLTypes["ScheduledNotificationLocale"]>,
	paginateScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleConnection"],
	validateCreateScheduledNotificationLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateScheduledNotificationLocale: GraphQLTypes["_ValidationResult"],
	getInfoCarouselItemLocale?: GraphQLTypes["InfoCarouselItemLocale"] | undefined,
	listInfoCarouselItemLocale: Array<GraphQLTypes["InfoCarouselItemLocale"]>,
	paginateInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleConnection"],
	validateCreateInfoCarouselItemLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoCarouselItemLocale: GraphQLTypes["_ValidationResult"],
	getSentPaymentLocale?: GraphQLTypes["SentPaymentLocale"] | undefined,
	listSentPaymentLocale: Array<GraphQLTypes["SentPaymentLocale"]>,
	paginateSentPaymentLocale: GraphQLTypes["SentPaymentLocaleConnection"],
	validateCreateSentPaymentLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSentPaymentLocale: GraphQLTypes["_ValidationResult"],
	getUserPaymentMetadata?: GraphQLTypes["UserPaymentMetadata"] | undefined,
	listUserPaymentMetadata: Array<GraphQLTypes["UserPaymentMetadata"]>,
	paginateUserPaymentMetadata: GraphQLTypes["UserPaymentMetadataConnection"],
	getPostAreaCurrencySum?: GraphQLTypes["PostAreaCurrencySum"] | undefined,
	listPostAreaCurrencySum: Array<GraphQLTypes["PostAreaCurrencySum"]>,
	paginatePostAreaCurrencySum: GraphQLTypes["PostAreaCurrencySumConnection"],
	getPostAreaSum?: GraphQLTypes["PostAreaSum"] | undefined,
	listPostAreaSum: Array<GraphQLTypes["PostAreaSum"]>,
	paginatePostAreaSum: GraphQLTypes["PostAreaSumConnection"],
	getPostOrganizationCurrencySum?: GraphQLTypes["PostOrganizationCurrencySum"] | undefined,
	listPostOrganizationCurrencySum: Array<GraphQLTypes["PostOrganizationCurrencySum"]>,
	paginatePostOrganizationCurrencySum: GraphQLTypes["PostOrganizationCurrencySumConnection"],
	getPostOrganizationSum?: GraphQLTypes["PostOrganizationSum"] | undefined,
	listPostOrganizationSum: Array<GraphQLTypes["PostOrganizationSum"]>,
	paginatePostOrganizationSum: GraphQLTypes["PostOrganizationSumConnection"],
	getStats?: GraphQLTypes["Stats"] | undefined,
	listStats: Array<GraphQLTypes["Stats"]>,
	paginateStats: GraphQLTypes["StatsConnection"],
	getUserRecurringPaymentItemMetadata?: GraphQLTypes["UserRecurringPaymentItemMetadata"] | undefined,
	listUserRecurringPaymentItemMetadata: Array<GraphQLTypes["UserRecurringPaymentItemMetadata"]>,
	paginateUserRecurringPaymentItemMetadata: GraphQLTypes["UserRecurringPaymentItemMetadataConnection"],
	getUpcomingUserRecurringPaymentMetadata?: GraphQLTypes["UpcomingUserRecurringPaymentMetadata"] | undefined,
	listUpcomingUserRecurringPaymentMetadata: Array<GraphQLTypes["UpcomingUserRecurringPaymentMetadata"]>,
	paginateUpcomingUserRecurringPaymentMetadata: GraphQLTypes["UpcomingUserRecurringPaymentMetadataConnection"],
	getUserAreaStats?: GraphQLTypes["UserAreaStats"] | undefined,
	listUserAreaStats: Array<GraphQLTypes["UserAreaStats"]>,
	paginateUserAreaStats: GraphQLTypes["UserAreaStatsConnection"],
	getUserCurrencyStats?: GraphQLTypes["UserCurrencyStats"] | undefined,
	listUserCurrencyStats: Array<GraphQLTypes["UserCurrencyStats"]>,
	paginateUserCurrencyStats: GraphQLTypes["UserCurrencyStatsConnection"],
	getUserOrganizationStats?: GraphQLTypes["UserOrganizationStats"] | undefined,
	listUserOrganizationStats: Array<GraphQLTypes["UserOrganizationStats"]>,
	paginateUserOrganizationStats: GraphQLTypes["UserOrganizationStatsConnection"],
	getUserPostStats?: GraphQLTypes["UserPostStats"] | undefined,
	listUserPostStats: Array<GraphQLTypes["UserPostStats"]>,
	paginateUserPostStats: GraphQLTypes["UserPostStatsConnection"],
	getUserStats?: GraphQLTypes["UserStats"] | undefined,
	listUserStats: Array<GraphQLTypes["UserStats"]>,
	paginateUserStats: GraphQLTypes["UserStatsConnection"],
	getTextImageList?: GraphQLTypes["TextImageList"] | undefined,
	listTextImageList: Array<GraphQLTypes["TextImageList"]>,
	paginateTextImageList: GraphQLTypes["TextImageListConnection"],
	validateCreateTextImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextImageList: GraphQLTypes["_ValidationResult"],
	getTextImageListItem?: GraphQLTypes["TextImageListItem"] | undefined,
	listTextImageListItem: Array<GraphQLTypes["TextImageListItem"]>,
	paginateTextImageListItem: GraphQLTypes["TextImageListItemConnection"],
	validateCreateTextImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextImageListItem: GraphQLTypes["_ValidationResult"],
	getPostCurrencySum?: GraphQLTypes["PostCurrencySum"] | undefined,
	listPostCurrencySum: Array<GraphQLTypes["PostCurrencySum"]>,
	paginatePostCurrencySum: GraphQLTypes["PostCurrencySumConnection"],
	getPostSum?: GraphQLTypes["PostSum"] | undefined,
	listPostSum: Array<GraphQLTypes["PostSum"]>,
	paginatePostSum: GraphQLTypes["PostSumConnection"],
	getPostFundraisingProgress?: GraphQLTypes["PostFundraisingProgress"] | undefined,
	listPostFundraisingProgress: Array<GraphQLTypes["PostFundraisingProgress"]>,
	paginatePostFundraisingProgress: GraphQLTypes["PostFundraisingProgressConnection"],
	getHeroCarouselItem?: GraphQLTypes["HeroCarouselItem"] | undefined,
	listHeroCarouselItem: Array<GraphQLTypes["HeroCarouselItem"]>,
	paginateHeroCarouselItem: GraphQLTypes["HeroCarouselItemConnection"],
	validateCreateHeroCarouselItem: GraphQLTypes["_ValidationResult"],
	validateUpdateHeroCarouselItem: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"] | undefined,
	_info?: GraphQLTypes["Info"] | undefined
};
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["General"]: {
	__typename: "General",
	_meta?: GraphQLTypes["GeneralMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["GeneralLocale"]>,
	allAreasIcon?: GraphQLTypes["Image"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["Image"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationList"] | undefined,
	localesByLocale?: GraphQLTypes["GeneralLocale"] | undefined,
	localesBySeo?: GraphQLTypes["GeneralLocale"] | undefined,
	localesByAppStoreLink?: GraphQLTypes["GeneralLocale"] | undefined,
	localesByGooglePlayLink?: GraphQLTypes["GeneralLocale"] | undefined,
	paginateLocales: GraphQLTypes["GeneralLocaleConnection"]
};
	["GeneralMeta"]: {
	__typename: "GeneralMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	allAreasIcon?: GraphQLTypes["FieldMeta"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["FieldMeta"] | undefined,
	organizationList?: GraphQLTypes["FieldMeta"] | undefined
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean | undefined,
	updatable?: boolean | undefined
};
	["UUID"]: "scalar" & { name: "UUID" };
	["One"]: One;
	["GeneralLocale"]: {
	__typename: "GeneralLocale",
	_meta?: GraphQLTypes["GeneralLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["General"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	appStoreLink?: GraphQLTypes["Link"] | undefined,
	googlePlayLink?: GraphQLTypes["Link"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined
};
	["GeneralLocaleMeta"]: {
	__typename: "GeneralLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	appStoreLink?: GraphQLTypes["FieldMeta"] | undefined,
	googlePlayLink?: GraphQLTypes["FieldMeta"] | undefined,
	allAreasDescription?: GraphQLTypes["FieldMeta"] | undefined,
	allOrganizationsDescription?: GraphQLTypes["FieldMeta"] | undefined
};
	["GeneralWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["GeneralLocaleWhere"] | undefined,
	allAreasIcon?: GraphQLTypes["ImageWhere"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["ImageWhere"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListWhere"] | undefined,
	and?: Array<GraphQLTypes["GeneralWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GeneralWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GeneralWhere"] | undefined
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]> | undefined,
	or?: Array<GraphQLTypes["UUIDCondition"]> | undefined,
	not?: GraphQLTypes["UUIDCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["UUID"] | undefined,
	notEq?: GraphQLTypes["UUID"] | undefined,
	in?: Array<GraphQLTypes["UUID"]> | undefined,
	notIn?: Array<GraphQLTypes["UUID"]> | undefined,
	lt?: GraphQLTypes["UUID"] | undefined,
	lte?: GraphQLTypes["UUID"] | undefined,
	gt?: GraphQLTypes["UUID"] | undefined,
	gte?: GraphQLTypes["UUID"] | undefined
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]> | undefined,
	or?: Array<GraphQLTypes["OneCondition"]> | undefined,
	not?: GraphQLTypes["OneCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["One"] | undefined,
	notEq?: GraphQLTypes["One"] | undefined,
	in?: Array<GraphQLTypes["One"]> | undefined,
	notIn?: Array<GraphQLTypes["One"]> | undefined,
	lt?: GraphQLTypes["One"] | undefined,
	lte?: GraphQLTypes["One"] | undefined,
	gt?: GraphQLTypes["One"] | undefined,
	gte?: GraphQLTypes["One"] | undefined
};
	["GeneralLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["GeneralWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	appStoreLink?: GraphQLTypes["LinkWhere"] | undefined,
	googlePlayLink?: GraphQLTypes["LinkWhere"] | undefined,
	allAreasDescription?: GraphQLTypes["StringCondition"] | undefined,
	allOrganizationsDescription?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["GeneralLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GeneralLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GeneralLocaleWhere"] | undefined
};
	["LocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	label?: GraphQLTypes["StringCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	generals?: GraphQLTypes["GeneralLocaleWhere"] | undefined,
	genericPages?: GraphQLTypes["GenericPageLocaleWhere"] | undefined,
	posts?: GraphQLTypes["PostLocaleWhere"] | undefined,
	postAreas?: GraphQLTypes["PostAreaLocaleWhere"] | undefined,
	postOrganizations?: GraphQLTypes["PostOrganizationLocaleWhere"] | undefined,
	headers?: GraphQLTypes["HeaderLocaleWhere"] | undefined,
	footers?: GraphQLTypes["FooterLocaleWhere"] | undefined,
	genericPageAboutSettings?: GraphQLTypes["GenericPageAboutSettingsLocaleWhere"] | undefined,
	postRevisions?: GraphQLTypes["PostRevisionLocaleWhere"] | undefined,
	flagImage?: GraphQLTypes["ImageWhere"] | undefined,
	feedPages?: GraphQLTypes["FeedPageLocaleWhere"] | undefined,
	recurringPaymentPages?: GraphQLTypes["RecurringPaymentPageLocaleWhere"] | undefined,
	givenGiftsPages?: GraphQLTypes["GivenGiftsPageLocaleWhere"] | undefined,
	receivedGiftsPages?: GraphQLTypes["ReceivedGiftsPageLocaleWhere"] | undefined,
	reportPages?: GraphQLTypes["ReportPageLocaleWhere"] | undefined,
	reportNavigations?: GraphQLTypes["ReportNavigationLocaleWhere"] | undefined,
	scheduledNotifications?: GraphQLTypes["ScheduledNotificationLocaleWhere"] | undefined,
	sentPayments?: GraphQLTypes["SentPaymentLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["LocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LocaleWhere"] | undefined
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]> | undefined,
	or?: Array<GraphQLTypes["StringCondition"]> | undefined,
	not?: GraphQLTypes["StringCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: string | undefined,
	notEq?: string | undefined,
	in?: Array<string> | undefined,
	notIn?: Array<string> | undefined,
	lt?: string | undefined,
	lte?: string | undefined,
	gt?: string | undefined,
	gte?: string | undefined,
	contains?: string | undefined,
	startsWith?: string | undefined,
	endsWith?: string | undefined,
	containsCI?: string | undefined,
	startsWithCI?: string | undefined,
	endsWithCI?: string | undefined
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]> | undefined,
	or?: Array<GraphQLTypes["IntCondition"]> | undefined,
	not?: GraphQLTypes["IntCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["GenericPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["GenericPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["GenericPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GenericPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GenericPageLocaleWhere"] | undefined
};
	["GenericPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["GenericPageLocaleWhere"] | undefined,
	type?: GraphQLTypes["GenericPageTypeCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	reportNavigation?: GraphQLTypes["ReportNavigationLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["GenericPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GenericPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GenericPageWhere"] | undefined
};
	["GenericPageTypeCondition"]: {
		and?: Array<GraphQLTypes["GenericPageTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["GenericPageTypeCondition"]> | undefined,
	not?: GraphQLTypes["GenericPageTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["GenericPageType"] | undefined,
	notEq?: GraphQLTypes["GenericPageType"] | undefined,
	in?: Array<GraphQLTypes["GenericPageType"]> | undefined,
	notIn?: Array<GraphQLTypes["GenericPageType"]> | undefined,
	lt?: GraphQLTypes["GenericPageType"] | undefined,
	lte?: GraphQLTypes["GenericPageType"] | undefined,
	gt?: GraphQLTypes["GenericPageType"] | undefined,
	gte?: GraphQLTypes["GenericPageType"] | undefined
};
	["GenericPageType"]: GenericPageType;
	["ReportNavigationLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["ReportNavigationWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	pages?: GraphQLTypes["GenericPageWhere"] | undefined,
	and?: Array<GraphQLTypes["ReportNavigationLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ReportNavigationLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ReportNavigationLocaleWhere"] | undefined
};
	["ReportNavigationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["ReportNavigationLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ReportNavigationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ReportNavigationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ReportNavigationWhere"] | undefined
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	blocks?: GraphQLTypes["ContentBlockWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentWhere"] | undefined
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	json?: GraphQLTypes["StringCondition"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	references?: GraphQLTypes["ContentReferenceWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentBlockWhere"] | undefined
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["ContentReferenceTypeCondition"] | undefined,
	primaryText?: GraphQLTypes["StringCondition"] | undefined,
	block?: GraphQLTypes["ContentBlockWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	linkables?: GraphQLTypes["ContentReferenceLinkableItemWhere"] | undefined,
	video?: GraphQLTypes["VideoWhere"] | undefined,
	secondaryText?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	contentAlignment?: GraphQLTypes["ContentAlignmentCondition"] | undefined,
	valueList?: GraphQLTypes["ValueListWhere"] | undefined,
	imageLinkList?: GraphQLTypes["ImageLinkListWhere"] | undefined,
	areaList?: GraphQLTypes["PostAreaListWhere"] | undefined,
	isAppsVisible?: GraphQLTypes["BooleanCondition"] | undefined,
	accordion?: GraphQLTypes["AccordionWhere"] | undefined,
	media?: GraphQLTypes["MediumListWhere"] | undefined,
	memberList?: GraphQLTypes["MemberListWhere"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["AsideMediaContentLayoutCondition"] | undefined,
	isAsideMediaContentMobileLayout?: GraphQLTypes["BooleanCondition"] | undefined,
	form?: GraphQLTypes["FormWhere"] | undefined,
	isTitleBigger?: GraphQLTypes["BooleanCondition"] | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentWhere"] | undefined,
	heroCarousel?: GraphQLTypes["HeroCarouselWhere"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListWhere"] | undefined,
	isCentered?: GraphQLTypes["BooleanCondition"] | undefined,
	posts?: GraphQLTypes["PostWhere"] | undefined,
	textImageList?: GraphQLTypes["TextImageListWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentReferenceWhere"] | undefined
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]> | undefined,
	not?: GraphQLTypes["ContentReferenceTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ContentReferenceType"] | undefined,
	notEq?: GraphQLTypes["ContentReferenceType"] | undefined,
	in?: Array<GraphQLTypes["ContentReferenceType"]> | undefined,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]> | undefined,
	lt?: GraphQLTypes["ContentReferenceType"] | undefined,
	lte?: GraphQLTypes["ContentReferenceType"] | undefined,
	gt?: GraphQLTypes["ContentReferenceType"] | undefined,
	gte?: GraphQLTypes["ContentReferenceType"] | undefined
};
	["ContentReferenceType"]: ContentReferenceType;
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	width?: GraphQLTypes["IntCondition"] | undefined,
	height?: GraphQLTypes["IntCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	alt?: GraphQLTypes["StringCondition"] | undefined,
	fileName?: GraphQLTypes["StringCondition"] | undefined,
	focalPointX?: GraphQLTypes["FloatCondition"] | undefined,
	focalPointY?: GraphQLTypes["FloatCondition"] | undefined,
	and?: Array<GraphQLTypes["ImageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageWhere"] | undefined
};
	["FloatCondition"]: {
		and?: Array<GraphQLTypes["FloatCondition"]> | undefined,
	or?: Array<GraphQLTypes["FloatCondition"]> | undefined,
	not?: GraphQLTypes["FloatCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["ContentReferenceLinkableItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	item?: GraphQLTypes["LinkableWhere"] | undefined,
	reference?: GraphQLTypes["ContentReferenceWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentReferenceLinkableItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentReferenceLinkableItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentReferenceLinkableItemWhere"] | undefined
};
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	genericPage?: GraphQLTypes["GenericPageLocaleWhere"] | undefined,
	post?: GraphQLTypes["PostLocaleWhere"] | undefined,
	postArea?: GraphQLTypes["PostAreaLocaleWhere"] | undefined,
	postOrganization?: GraphQLTypes["PostOrganizationLocaleWhere"] | undefined,
	reportPage?: GraphQLTypes["ReportPageLocaleWhere"] | undefined,
	givenGiftsPage?: GraphQLTypes["GivenGiftsPageLocaleWhere"] | undefined,
	receivedGiftsPage?: GraphQLTypes["ReceivedGiftsPageLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkableWhere"] | undefined
};
	["PostLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	root?: GraphQLTypes["PostWhere"] | undefined,
	paymentName?: GraphQLTypes["StringCondition"] | undefined,
	publishedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["PostLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostLocaleWhere"] | undefined
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	ogTitle?: GraphQLTypes["StringCondition"] | undefined,
	ogDescription?: GraphQLTypes["StringCondition"] | undefined,
	noIndex?: GraphQLTypes["BooleanCondition"] | undefined,
	noFollow?: GraphQLTypes["BooleanCondition"] | undefined,
	ogImage?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["SeoWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SeoWhere"] | undefined
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]> | undefined,
	or?: Array<GraphQLTypes["BooleanCondition"]> | undefined,
	not?: GraphQLTypes["BooleanCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: boolean | undefined,
	notEq?: boolean | undefined,
	in?: Array<boolean> | undefined,
	notIn?: Array<boolean> | undefined,
	lt?: boolean | undefined,
	lte?: boolean | undefined,
	gt?: boolean | undefined,
	gte?: boolean | undefined
};
	["PostWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	specificSymbol?: GraphQLTypes["IntCondition"] | undefined,
	activeRevision?: GraphQLTypes["PostRevisionWhere"] | undefined,
	revisions?: GraphQLTypes["PostRevisionWhere"] | undefined,
	locales?: GraphQLTypes["PostLocaleWhere"] | undefined,
	isPinnedInArea?: GraphQLTypes["BooleanCondition"] | undefined,
	isPinnedInOrganization?: GraphQLTypes["BooleanCondition"] | undefined,
	state?: GraphQLTypes["PostStateCondition"] | undefined,
	meta?: GraphQLTypes["PostMetaDataWhere"] | undefined,
	isPublishedAtHidden?: GraphQLTypes["BooleanCondition"] | undefined,
	heroCarousel?: GraphQLTypes["HeroCarouselWhere"] | undefined,
	reportPage?: GraphQLTypes["ReportPageLocaleWhere"] | undefined,
	content?: GraphQLTypes["ContentReferenceWhere"] | undefined,
	fundraiseIsActive?: GraphQLTypes["BooleanCondition"] | undefined,
	fundraiseEndDate?: GraphQLTypes["DateCondition"] | undefined,
	fundraiseTargetAmount?: GraphQLTypes["IntCondition"] | undefined,
	fundraiseFakeAddOnAmount?: GraphQLTypes["IntCondition"] | undefined,
	fundraiseCurrency?: GraphQLTypes["CurrencyWhere"] | undefined,
	fundraiseCurrencySums?: GraphQLTypes["PostCurrencySumWhere"] | undefined,
	fundraiseSum?: GraphQLTypes["PostSumWhere"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostFundraisingProgressWhere"] | undefined,
	and?: Array<GraphQLTypes["PostWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostWhere"] | undefined
};
	["PostOrganizationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	posts?: GraphQLTypes["PostWhere"] | undefined,
	icon?: GraphQLTypes["ImageWhere"] | undefined,
	locales?: GraphQLTypes["PostOrganizationLocaleWhere"] | undefined,
	specificSymbol?: GraphQLTypes["IntCondition"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	meta?: GraphQLTypes["PostOrganizationMetaDataWhere"] | undefined,
	mobileHeroImage?: GraphQLTypes["ImageWhere"] | undefined,
	isHidden?: GraphQLTypes["BooleanCondition"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	plainIcon?: GraphQLTypes["ImageWhere"] | undefined,
	desktopHeroImage?: GraphQLTypes["ImageWhere"] | undefined,
	sentPayments?: GraphQLTypes["SentPaymentWhere"] | undefined,
	organizationCurrencySums?: GraphQLTypes["PostOrganizationCurrencySumWhere"] | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationSumWhere"] | undefined,
	and?: Array<GraphQLTypes["PostOrganizationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostOrganizationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostOrganizationWhere"] | undefined
};
	["PostOrganizationLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	root?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	domain?: GraphQLTypes["LinkWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	translatedByAI?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["PostOrganizationLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostOrganizationLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostOrganizationLocaleWhere"] | undefined
};
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["LinkEnumCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	externalLink?: GraphQLTypes["StringCondition"] | undefined,
	internalLink?: GraphQLTypes["LinkableWhere"] | undefined,
	isTargetBlank?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["LinkWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkWhere"] | undefined
};
	["LinkEnumCondition"]: {
		and?: Array<GraphQLTypes["LinkEnumCondition"]> | undefined,
	or?: Array<GraphQLTypes["LinkEnumCondition"]> | undefined,
	not?: GraphQLTypes["LinkEnumCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["LinkEnum"] | undefined,
	notEq?: GraphQLTypes["LinkEnum"] | undefined,
	in?: Array<GraphQLTypes["LinkEnum"]> | undefined,
	notIn?: Array<GraphQLTypes["LinkEnum"]> | undefined,
	lt?: GraphQLTypes["LinkEnum"] | undefined,
	lte?: GraphQLTypes["LinkEnum"] | undefined,
	gt?: GraphQLTypes["LinkEnum"] | undefined,
	gte?: GraphQLTypes["LinkEnum"] | undefined
};
	["LinkEnum"]: LinkEnum;
	["PostAreaWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	icon?: GraphQLTypes["ImageWhere"] | undefined,
	locales?: GraphQLTypes["PostAreaLocaleWhere"] | undefined,
	regionListOverride?: GraphQLTypes["DonationAmountsRegionListWhere"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	posts?: GraphQLTypes["PostWhere"] | undefined,
	specificSymbol?: GraphQLTypes["IntCondition"] | undefined,
	region?: GraphQLTypes["RegionWhere"] | undefined,
	meta?: GraphQLTypes["PostAreaMetaDataWhere"] | undefined,
	mobileHeroImage?: GraphQLTypes["ImageWhere"] | undefined,
	plainIcon?: GraphQLTypes["ImageWhere"] | undefined,
	sentPayments?: GraphQLTypes["SentPaymentWhere"] | undefined,
	areaSentPaymentCurrencySums?: GraphQLTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaSentPaymentSumWhere"] | undefined,
	areaCurrencySums?: GraphQLTypes["PostAreaCurrencySumWhere"] | undefined,
	areaSum?: GraphQLTypes["PostAreaSumWhere"] | undefined,
	and?: Array<GraphQLTypes["PostAreaWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaWhere"] | undefined
};
	["PostAreaLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	root?: GraphQLTypes["PostAreaWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	banner?: GraphQLTypes["AppBannerWhere"] | undefined,
	shortDescription?: GraphQLTypes["StringCondition"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	translatedByAI?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["PostAreaLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaLocaleWhere"] | undefined
};
	["AppBannerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	imageSmall?: GraphQLTypes["ImageWhere"] | undefined,
	imageBig?: GraphQLTypes["ImageWhere"] | undefined,
	textContent?: GraphQLTypes["ContentWhere"] | undefined,
	and?: Array<GraphQLTypes["AppBannerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AppBannerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AppBannerWhere"] | undefined
};
	["DonationAmountsRegionListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	regions?: GraphQLTypes["DonationAmountsRegionItemWhere"] | undefined,
	donation?: GraphQLTypes["DonationWhere"] | undefined,
	and?: Array<GraphQLTypes["DonationAmountsRegionListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DonationAmountsRegionListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DonationAmountsRegionListWhere"] | undefined
};
	["DonationAmountsRegionItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	items?: GraphQLTypes["DonationAmountItemWhere"] | undefined,
	list?: GraphQLTypes["DonationAmountsRegionListWhere"] | undefined,
	region?: GraphQLTypes["RegionWhere"] | undefined,
	minimumAmount?: GraphQLTypes["FloatCondition"] | undefined,
	and?: Array<GraphQLTypes["DonationAmountsRegionItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DonationAmountsRegionItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DonationAmountsRegionItemWhere"] | undefined
};
	["DonationAmountItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	amount?: GraphQLTypes["FloatCondition"] | undefined,
	regionItem?: GraphQLTypes["DonationAmountsRegionItemWhere"] | undefined,
	and?: Array<GraphQLTypes["DonationAmountItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DonationAmountItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DonationAmountItemWhere"] | undefined
};
	["RegionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	label?: GraphQLTypes["StringCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	enabledPaymentMethods?: GraphQLTypes["RegionPaymentMethodWhere"] | undefined,
	donationItems?: GraphQLTypes["DonationAmountsRegionItemWhere"] | undefined,
	timezone?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["RegionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RegionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RegionWhere"] | undefined
};
	["CurrencyWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	identifier?: GraphQLTypes["CurrencyIdentifierCondition"] | undefined,
	label?: GraphQLTypes["StringCondition"] | undefined,
	sign?: GraphQLTypes["StringCondition"] | undefined,
	signAlignment?: GraphQLTypes["CurrencySignAlignmentCondition"] | undefined,
	defaultDonationAmount?: GraphQLTypes["IntCondition"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FloatCondition"] | undefined,
	areaSentPaymentCurrencySums?: GraphQLTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined,
	areaCurrencySums?: GraphQLTypes["PostAreaCurrencySumWhere"] | undefined,
	organizationCurrencySums?: GraphQLTypes["PostOrganizationCurrencySumWhere"] | undefined,
	postCurrencySums?: GraphQLTypes["PostCurrencySumWhere"] | undefined,
	and?: Array<GraphQLTypes["CurrencyWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CurrencyWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CurrencyWhere"] | undefined
};
	["CurrencyIdentifierCondition"]: {
		and?: Array<GraphQLTypes["CurrencyIdentifierCondition"]> | undefined,
	or?: Array<GraphQLTypes["CurrencyIdentifierCondition"]> | undefined,
	not?: GraphQLTypes["CurrencyIdentifierCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["CurrencyIdentifier"] | undefined,
	notEq?: GraphQLTypes["CurrencyIdentifier"] | undefined,
	in?: Array<GraphQLTypes["CurrencyIdentifier"]> | undefined,
	notIn?: Array<GraphQLTypes["CurrencyIdentifier"]> | undefined,
	lt?: GraphQLTypes["CurrencyIdentifier"] | undefined,
	lte?: GraphQLTypes["CurrencyIdentifier"] | undefined,
	gt?: GraphQLTypes["CurrencyIdentifier"] | undefined,
	gte?: GraphQLTypes["CurrencyIdentifier"] | undefined
};
	["CurrencyIdentifier"]: CurrencyIdentifier;
	["CurrencySignAlignmentCondition"]: {
		and?: Array<GraphQLTypes["CurrencySignAlignmentCondition"]> | undefined,
	or?: Array<GraphQLTypes["CurrencySignAlignmentCondition"]> | undefined,
	not?: GraphQLTypes["CurrencySignAlignmentCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["CurrencySignAlignment"] | undefined,
	notEq?: GraphQLTypes["CurrencySignAlignment"] | undefined,
	in?: Array<GraphQLTypes["CurrencySignAlignment"]> | undefined,
	notIn?: Array<GraphQLTypes["CurrencySignAlignment"]> | undefined,
	lt?: GraphQLTypes["CurrencySignAlignment"] | undefined,
	lte?: GraphQLTypes["CurrencySignAlignment"] | undefined,
	gt?: GraphQLTypes["CurrencySignAlignment"] | undefined,
	gte?: GraphQLTypes["CurrencySignAlignment"] | undefined
};
	["CurrencySignAlignment"]: CurrencySignAlignment;
	["PostAreaSentPaymentCurrencySumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	currencyIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FloatCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	and?: Array<GraphQLTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaSentPaymentCurrencySumWhere"] | undefined
};
	["PostAreaCurrencySumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	currencyIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FloatCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	and?: Array<GraphQLTypes["PostAreaCurrencySumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaCurrencySumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaCurrencySumWhere"] | undefined
};
	["PostOrganizationCurrencySumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	currencyIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FloatCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	and?: Array<GraphQLTypes["PostOrganizationCurrencySumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostOrganizationCurrencySumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostOrganizationCurrencySumWhere"] | undefined
};
	["PostCurrencySumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	currencyIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FloatCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	and?: Array<GraphQLTypes["PostCurrencySumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostCurrencySumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostCurrencySumWhere"] | undefined
};
	["RegionPaymentMethodWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	allowRecurringPayments?: GraphQLTypes["BooleanCondition"] | undefined,
	region?: GraphQLTypes["RegionWhere"] | undefined,
	method?: GraphQLTypes["PaymentMethodsCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["RegionPaymentMethodWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RegionPaymentMethodWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RegionPaymentMethodWhere"] | undefined
};
	["PaymentMethodsCondition"]: {
		and?: Array<GraphQLTypes["PaymentMethodsCondition"]> | undefined,
	or?: Array<GraphQLTypes["PaymentMethodsCondition"]> | undefined,
	not?: GraphQLTypes["PaymentMethodsCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PaymentMethods"] | undefined,
	notEq?: GraphQLTypes["PaymentMethods"] | undefined,
	in?: Array<GraphQLTypes["PaymentMethods"]> | undefined,
	notIn?: Array<GraphQLTypes["PaymentMethods"]> | undefined,
	lt?: GraphQLTypes["PaymentMethods"] | undefined,
	lte?: GraphQLTypes["PaymentMethods"] | undefined,
	gt?: GraphQLTypes["PaymentMethods"] | undefined,
	gte?: GraphQLTypes["PaymentMethods"] | undefined
};
	["PaymentMethods"]: PaymentMethods;
	["DonationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	regionList?: GraphQLTypes["DonationAmountsRegionListWhere"] | undefined,
	and?: Array<GraphQLTypes["DonationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DonationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DonationWhere"] | undefined
};
	["PostAreaMetaDataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	nameWithFallback?: GraphQLTypes["StringCondition"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	and?: Array<GraphQLTypes["PostAreaMetaDataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaMetaDataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaMetaDataWhere"] | undefined
};
	["SentPaymentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	cents?: GraphQLTypes["IntCondition"] | undefined,
	sendAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	locales?: GraphQLTypes["SentPaymentLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["SentPaymentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SentPaymentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SentPaymentWhere"] | undefined
};
	["DateTimeCondition"]: {
		and?: Array<GraphQLTypes["DateTimeCondition"]> | undefined,
	or?: Array<GraphQLTypes["DateTimeCondition"]> | undefined,
	not?: GraphQLTypes["DateTimeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["DateTime"] | undefined,
	notEq?: GraphQLTypes["DateTime"] | undefined,
	in?: Array<GraphQLTypes["DateTime"]> | undefined,
	notIn?: Array<GraphQLTypes["DateTime"]> | undefined,
	lt?: GraphQLTypes["DateTime"] | undefined,
	lte?: GraphQLTypes["DateTime"] | undefined,
	gt?: GraphQLTypes["DateTime"] | undefined,
	gte?: GraphQLTypes["DateTime"] | undefined
};
	["DateTime"]: "scalar" & { name: "DateTime" };
	["SentPaymentLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	organizationText?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["SentPaymentWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["SentPaymentLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SentPaymentLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SentPaymentLocaleWhere"] | undefined
};
	["PostAreaSentPaymentSumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	czkPercentage?: GraphQLTypes["FloatCondition"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	and?: Array<GraphQLTypes["PostAreaSentPaymentSumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaSentPaymentSumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaSentPaymentSumWhere"] | undefined
};
	["PostAreaSumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	czkPercentage?: GraphQLTypes["FloatCondition"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	and?: Array<GraphQLTypes["PostAreaSumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaSumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaSumWhere"] | undefined
};
	["PostOrganizationMetaDataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	nameWithFallback?: GraphQLTypes["StringCondition"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	and?: Array<GraphQLTypes["PostOrganizationMetaDataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostOrganizationMetaDataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostOrganizationMetaDataWhere"] | undefined
};
	["PostOrganizationSumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	czkPercentage?: GraphQLTypes["FloatCondition"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	and?: Array<GraphQLTypes["PostOrganizationSumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostOrganizationSumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostOrganizationSumWhere"] | undefined
};
	["PostRevisionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	createdById?: GraphQLTypes["UUIDCondition"] | undefined,
	publishedById?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["PostTypeCondition"] | undefined,
	publishedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	tileImage?: GraphQLTypes["ImageWhere"] | undefined,
	tileVideo?: GraphQLTypes["VideoWhere"] | undefined,
	heroImage?: GraphQLTypes["ImageWhere"] | undefined,
	locales?: GraphQLTypes["PostRevisionLocaleWhere"] | undefined,
	regionListOverride?: GraphQLTypes["DonationAmountsRegionListWhere"] | undefined,
	isOrganizationVisible?: GraphQLTypes["BooleanCondition"] | undefined,
	sendPublishNotifications?: GraphQLTypes["BooleanCondition"] | undefined,
	isArchived?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["PostRevisionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostRevisionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostRevisionWhere"] | undefined
};
	["PostTypeCondition"]: {
		and?: Array<GraphQLTypes["PostTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["PostTypeCondition"]> | undefined,
	not?: GraphQLTypes["PostTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PostType"] | undefined,
	notEq?: GraphQLTypes["PostType"] | undefined,
	in?: Array<GraphQLTypes["PostType"]> | undefined,
	notIn?: Array<GraphQLTypes["PostType"]> | undefined,
	lt?: GraphQLTypes["PostType"] | undefined,
	lte?: GraphQLTypes["PostType"] | undefined,
	gt?: GraphQLTypes["PostType"] | undefined,
	gte?: GraphQLTypes["PostType"] | undefined
};
	["PostType"]: PostType;
	["VideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	width?: GraphQLTypes["IntCondition"] | undefined,
	height?: GraphQLTypes["IntCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	poster?: GraphQLTypes["ImageWhere"] | undefined,
	shapeType?: GraphQLTypes["VideoShapeTypeCondition"] | undefined,
	and?: Array<GraphQLTypes["VideoWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VideoWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VideoWhere"] | undefined
};
	["VideoShapeTypeCondition"]: {
		and?: Array<GraphQLTypes["VideoShapeTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["VideoShapeTypeCondition"]> | undefined,
	not?: GraphQLTypes["VideoShapeTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["VideoShapeType"] | undefined,
	notEq?: GraphQLTypes["VideoShapeType"] | undefined,
	in?: Array<GraphQLTypes["VideoShapeType"]> | undefined,
	notIn?: Array<GraphQLTypes["VideoShapeType"]> | undefined,
	lt?: GraphQLTypes["VideoShapeType"] | undefined,
	lte?: GraphQLTypes["VideoShapeType"] | undefined,
	gt?: GraphQLTypes["VideoShapeType"] | undefined,
	gte?: GraphQLTypes["VideoShapeType"] | undefined
};
	["VideoShapeType"]: VideoShapeType;
	["PostRevisionLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["PostRevisionWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	leadContent?: GraphQLTypes["ContentWhere"] | undefined,
	publishNotificationText?: GraphQLTypes["StringCondition"] | undefined,
	translatedByAI?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["PostRevisionLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostRevisionLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostRevisionLocaleWhere"] | undefined
};
	["PostStateCondition"]: {
		and?: Array<GraphQLTypes["PostStateCondition"]> | undefined,
	or?: Array<GraphQLTypes["PostStateCondition"]> | undefined,
	not?: GraphQLTypes["PostStateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PostState"] | undefined,
	notEq?: GraphQLTypes["PostState"] | undefined,
	in?: Array<GraphQLTypes["PostState"]> | undefined,
	notIn?: Array<GraphQLTypes["PostState"]> | undefined,
	lt?: GraphQLTypes["PostState"] | undefined,
	lte?: GraphQLTypes["PostState"] | undefined,
	gt?: GraphQLTypes["PostState"] | undefined,
	gte?: GraphQLTypes["PostState"] | undefined
};
	["PostState"]: PostState;
	["PostMetaDataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	titleWithFallback?: GraphQLTypes["StringCondition"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	latestRevision?: GraphQLTypes["PostRevisionWhere"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	and?: Array<GraphQLTypes["PostMetaDataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostMetaDataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostMetaDataWhere"] | undefined
};
	["HeroCarouselWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateCondition"] | undefined,
	posts?: GraphQLTypes["PostWhere"] | undefined,
	items?: GraphQLTypes["HeroCarouselItemWhere"] | undefined,
	and?: Array<GraphQLTypes["HeroCarouselWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HeroCarouselWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HeroCarouselWhere"] | undefined
};
	["DateCondition"]: {
		and?: Array<GraphQLTypes["DateCondition"]> | undefined,
	or?: Array<GraphQLTypes["DateCondition"]> | undefined,
	not?: GraphQLTypes["DateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["Date"] | undefined,
	notEq?: GraphQLTypes["Date"] | undefined,
	in?: Array<GraphQLTypes["Date"]> | undefined,
	notIn?: Array<GraphQLTypes["Date"]> | undefined,
	lt?: GraphQLTypes["Date"] | undefined,
	lte?: GraphQLTypes["Date"] | undefined,
	gt?: GraphQLTypes["Date"] | undefined,
	gte?: GraphQLTypes["Date"] | undefined
};
	["Date"]: "scalar" & { name: "Date" };
	["HeroCarouselItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["HeroCarouselWhere"] | undefined,
	item?: GraphQLTypes["PostWhere"] | undefined,
	and?: Array<GraphQLTypes["HeroCarouselItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HeroCarouselItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HeroCarouselItemWhere"] | undefined
};
	["ReportPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	postTitle?: GraphQLTypes["StringCondition"] | undefined,
	giftTitle?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	root?: GraphQLTypes["ReportPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	posts?: GraphQLTypes["PostWhere"] | undefined,
	and?: Array<GraphQLTypes["ReportPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ReportPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ReportPageLocaleWhere"] | undefined
};
	["ReportPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["ReportPageLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ReportPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ReportPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ReportPageWhere"] | undefined
};
	["PostSumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	czkPercentage?: GraphQLTypes["FloatCondition"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	and?: Array<GraphQLTypes["PostSumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostSumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostSumWhere"] | undefined
};
	["PostFundraisingProgressWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	progress?: GraphQLTypes["FloatCondition"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	and?: Array<GraphQLTypes["PostFundraisingProgressWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostFundraisingProgressWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostFundraisingProgressWhere"] | undefined
};
	["GivenGiftsPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	giftTitle?: GraphQLTypes["StringCondition"] | undefined,
	giftText?: GraphQLTypes["StringCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["GivenGiftsPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	and?: Array<GraphQLTypes["GivenGiftsPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GivenGiftsPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GivenGiftsPageLocaleWhere"] | undefined
};
	["GivenGiftsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["GivenGiftsPageLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["GivenGiftsPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GivenGiftsPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GivenGiftsPageWhere"] | undefined
};
	["ReceivedGiftsPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	giftTitle?: GraphQLTypes["StringCondition"] | undefined,
	giftText?: GraphQLTypes["StringCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	and?: Array<GraphQLTypes["ReceivedGiftsPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ReceivedGiftsPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ReceivedGiftsPageLocaleWhere"] | undefined
};
	["ReceivedGiftsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["ReceivedGiftsPageLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ReceivedGiftsPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ReceivedGiftsPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ReceivedGiftsPageWhere"] | undefined
};
	["ContentAlignmentCondition"]: {
		and?: Array<GraphQLTypes["ContentAlignmentCondition"]> | undefined,
	or?: Array<GraphQLTypes["ContentAlignmentCondition"]> | undefined,
	not?: GraphQLTypes["ContentAlignmentCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ContentAlignment"] | undefined,
	notEq?: GraphQLTypes["ContentAlignment"] | undefined,
	in?: Array<GraphQLTypes["ContentAlignment"]> | undefined,
	notIn?: Array<GraphQLTypes["ContentAlignment"]> | undefined,
	lt?: GraphQLTypes["ContentAlignment"] | undefined,
	lte?: GraphQLTypes["ContentAlignment"] | undefined,
	gt?: GraphQLTypes["ContentAlignment"] | undefined,
	gte?: GraphQLTypes["ContentAlignment"] | undefined
};
	["ContentAlignment"]: ContentAlignment;
	["ValueListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ValueItemWhere"] | undefined,
	and?: Array<GraphQLTypes["ValueListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ValueListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ValueListWhere"] | undefined
};
	["ValueItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["ValueListWhere"] | undefined,
	item?: GraphQLTypes["ValueWhere"] | undefined,
	and?: Array<GraphQLTypes["ValueItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ValueItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ValueItemWhere"] | undefined
};
	["ValueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	textContent?: GraphQLTypes["ContentWhere"] | undefined,
	and?: Array<GraphQLTypes["ValueWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ValueWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ValueWhere"] | undefined
};
	["ImageLinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ImageLinkItemWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageLinkListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageLinkListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageLinkListWhere"] | undefined
};
	["ImageLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["ImageLinkListWhere"] | undefined,
	item?: GraphQLTypes["ImageLinkWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageLinkItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageLinkItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageLinkItemWhere"] | undefined
};
	["ImageLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageLinkWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageLinkWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageLinkWhere"] | undefined
};
	["PostAreaListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["PostAreaListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["PostAreaListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaListWhere"] | undefined
};
	["PostAreaListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["PostAreaListWhere"] | undefined,
	item?: GraphQLTypes["PostAreaWhere"] | undefined,
	and?: Array<GraphQLTypes["PostAreaListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostAreaListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostAreaListItemWhere"] | undefined
};
	["AccordionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["AccordionItemWhere"] | undefined,
	and?: Array<GraphQLTypes["AccordionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AccordionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AccordionWhere"] | undefined
};
	["AccordionItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["AccordionWhere"] | undefined,
	descriptionContent?: GraphQLTypes["ContentWhere"] | undefined,
	and?: Array<GraphQLTypes["AccordionItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AccordionItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AccordionItemWhere"] | undefined
};
	["MediumListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["MediumItemWhere"] | undefined,
	and?: Array<GraphQLTypes["MediumListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MediumListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MediumListWhere"] | undefined
};
	["MediumItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["MediumListWhere"] | undefined,
	medium?: GraphQLTypes["MediumWhere"] | undefined,
	and?: Array<GraphQLTypes["MediumItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MediumItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MediumItemWhere"] | undefined
};
	["MediumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["MediumTypeCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	video?: GraphQLTypes["VideoWhere"] | undefined,
	and?: Array<GraphQLTypes["MediumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MediumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MediumWhere"] | undefined
};
	["MediumTypeCondition"]: {
		and?: Array<GraphQLTypes["MediumTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["MediumTypeCondition"]> | undefined,
	not?: GraphQLTypes["MediumTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["MediumType"] | undefined,
	notEq?: GraphQLTypes["MediumType"] | undefined,
	in?: Array<GraphQLTypes["MediumType"]> | undefined,
	notIn?: Array<GraphQLTypes["MediumType"]> | undefined,
	lt?: GraphQLTypes["MediumType"] | undefined,
	lte?: GraphQLTypes["MediumType"] | undefined,
	gt?: GraphQLTypes["MediumType"] | undefined,
	gte?: GraphQLTypes["MediumType"] | undefined
};
	["MediumType"]: MediumType;
	["MemberListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["MemberListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["MemberListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MemberListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MemberListWhere"] | undefined
};
	["MemberListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	position?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["MemberListWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	descriptionContent?: GraphQLTypes["ContentWhere"] | undefined,
	and?: Array<GraphQLTypes["MemberListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MemberListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MemberListItemWhere"] | undefined
};
	["AsideMediaContentLayoutCondition"]: {
		and?: Array<GraphQLTypes["AsideMediaContentLayoutCondition"]> | undefined,
	or?: Array<GraphQLTypes["AsideMediaContentLayoutCondition"]> | undefined,
	not?: GraphQLTypes["AsideMediaContentLayoutCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	notEq?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	in?: Array<GraphQLTypes["AsideMediaContentLayout"]> | undefined,
	notIn?: Array<GraphQLTypes["AsideMediaContentLayout"]> | undefined,
	lt?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	lte?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	gt?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	gte?: GraphQLTypes["AsideMediaContentLayout"] | undefined
};
	["AsideMediaContentLayout"]: AsideMediaContentLayout;
	["FormWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	type?: GraphQLTypes["FormTypeCondition"] | undefined,
	tax?: GraphQLTypes["FilledTaxFormWhere"] | undefined,
	and?: Array<GraphQLTypes["FormWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FormWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FormWhere"] | undefined
};
	["FormTypeCondition"]: {
		and?: Array<GraphQLTypes["FormTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["FormTypeCondition"]> | undefined,
	not?: GraphQLTypes["FormTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["FormType"] | undefined,
	notEq?: GraphQLTypes["FormType"] | undefined,
	in?: Array<GraphQLTypes["FormType"]> | undefined,
	notIn?: Array<GraphQLTypes["FormType"]> | undefined,
	lt?: GraphQLTypes["FormType"] | undefined,
	lte?: GraphQLTypes["FormType"] | undefined,
	gt?: GraphQLTypes["FormType"] | undefined,
	gte?: GraphQLTypes["FormType"] | undefined
};
	["FormType"]: FormType;
	["FilledTaxFormWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	publishedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	userId?: GraphQLTypes["StringCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	vatId?: GraphQLTypes["StringCondition"] | undefined,
	address1?: GraphQLTypes["StringCondition"] | undefined,
	address2?: GraphQLTypes["StringCondition"] | undefined,
	city?: GraphQLTypes["StringCondition"] | undefined,
	postalCode?: GraphQLTypes["StringCondition"] | undefined,
	state?: GraphQLTypes["StringCondition"] | undefined,
	country?: GraphQLTypes["RegionWhere"] | undefined,
	dateFrom?: GraphQLTypes["DateCondition"] | undefined,
	dateTo?: GraphQLTypes["DateCondition"] | undefined,
	year?: GraphQLTypes["IntCondition"] | undefined,
	isPdfGenerated?: GraphQLTypes["BooleanCondition"] | undefined,
	pdfObjectKey?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["FilledTaxFormWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FilledTaxFormWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FilledTaxFormWhere"] | undefined
};
	["PostOrganizationListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["PostOrganizationListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["PostOrganizationListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostOrganizationListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostOrganizationListWhere"] | undefined
};
	["PostOrganizationListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["PostOrganizationListWhere"] | undefined,
	item?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	type?: GraphQLTypes["PostOrganizationListItemTypeCondition"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["PostOrganizationListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostOrganizationListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostOrganizationListItemWhere"] | undefined
};
	["PostOrganizationListItemTypeCondition"]: {
		and?: Array<GraphQLTypes["PostOrganizationListItemTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["PostOrganizationListItemTypeCondition"]> | undefined,
	not?: GraphQLTypes["PostOrganizationListItemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	notEq?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	in?: Array<GraphQLTypes["PostOrganizationListItemType"]> | undefined,
	notIn?: Array<GraphQLTypes["PostOrganizationListItemType"]> | undefined,
	lt?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	lte?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	gt?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	gte?: GraphQLTypes["PostOrganizationListItemType"] | undefined
};
	["PostOrganizationListItemType"]: PostOrganizationListItemType;
	["TextImageListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["TextImageListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["TextImageListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TextImageListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TextImageListWhere"] | undefined
};
	["TextImageListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["TextImageListWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["TextImageListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TextImageListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TextImageListItemWhere"] | undefined
};
	["HeaderLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["HeaderWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	links?: GraphQLTypes["LinkListWhere"] | undefined,
	and?: Array<GraphQLTypes["HeaderLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HeaderLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HeaderLocaleWhere"] | undefined
};
	["HeaderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	locales?: GraphQLTypes["HeaderLocaleWhere"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListWhere"] | undefined,
	and?: Array<GraphQLTypes["HeaderWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HeaderWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HeaderWhere"] | undefined
};
	["LinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["LinkItemWhere"] | undefined,
	and?: Array<GraphQLTypes["LinkListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkListWhere"] | undefined
};
	["LinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["LinkListWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["LinkItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkItemWhere"] | undefined
};
	["FooterLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	copyright?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["FooterWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	linkList?: GraphQLTypes["LinkListWhere"] | undefined,
	contactEmail?: GraphQLTypes["StringCondition"] | undefined,
	addressInfo?: GraphQLTypes["ContentWhere"] | undefined,
	imageLinkList?: GraphQLTypes["ImageLinkListWhere"] | undefined,
	and?: Array<GraphQLTypes["FooterLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FooterLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FooterLocaleWhere"] | undefined
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["FooterLocaleWhere"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["FooterWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FooterWhere"] | undefined
};
	["GenericPageAboutSettingsLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["GenericPageAboutSettingsWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	linkGroups?: GraphQLTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["GenericPageAboutSettingsLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GenericPageAboutSettingsLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GenericPageAboutSettingsLocaleWhere"] | undefined
};
	["GenericPageAboutSettingsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["GenericPageAboutSettingsLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["GenericPageAboutSettingsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GenericPageAboutSettingsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GenericPageAboutSettingsWhere"] | undefined
};
	["GenericPageAboutGroupLinksLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	settings?: GraphQLTypes["GenericPageAboutSettingsLocaleWhere"] | undefined,
	linkList?: GraphQLTypes["LinkListWhere"] | undefined,
	and?: Array<GraphQLTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GenericPageAboutGroupLinksLocaleWhere"] | undefined
};
	["FeedPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["FeedPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	heroTiles?: GraphQLTypes["TileListWhere"] | undefined,
	sectionList?: GraphQLTypes["FeedPageSectionWhere"] | undefined,
	cardList?: GraphQLTypes["CardListWhere"] | undefined,
	storyGuideList?: GraphQLTypes["StoryGuideListWhere"] | undefined,
	and?: Array<GraphQLTypes["FeedPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FeedPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FeedPageLocaleWhere"] | undefined
};
	["FeedPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["FeedPageLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["FeedPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FeedPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FeedPageWhere"] | undefined
};
	["TileListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	size?: GraphQLTypes["TileListSizeCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	items?: GraphQLTypes["TileItemWhere"] | undefined,
	areaType?: GraphQLTypes["PostAreaWhere"] | undefined,
	and?: Array<GraphQLTypes["TileListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TileListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TileListWhere"] | undefined
};
	["TileListSizeCondition"]: {
		and?: Array<GraphQLTypes["TileListSizeCondition"]> | undefined,
	or?: Array<GraphQLTypes["TileListSizeCondition"]> | undefined,
	not?: GraphQLTypes["TileListSizeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["TileListSize"] | undefined,
	notEq?: GraphQLTypes["TileListSize"] | undefined,
	in?: Array<GraphQLTypes["TileListSize"]> | undefined,
	notIn?: Array<GraphQLTypes["TileListSize"]> | undefined,
	lt?: GraphQLTypes["TileListSize"] | undefined,
	lte?: GraphQLTypes["TileListSize"] | undefined,
	gt?: GraphQLTypes["TileListSize"] | undefined,
	gte?: GraphQLTypes["TileListSize"] | undefined
};
	["TileListSize"]: TileListSize;
	["TileItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["TileItemTypeCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["TileListWhere"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	and?: Array<GraphQLTypes["TileItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TileItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TileItemWhere"] | undefined
};
	["TileItemTypeCondition"]: {
		and?: Array<GraphQLTypes["TileItemTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["TileItemTypeCondition"]> | undefined,
	not?: GraphQLTypes["TileItemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["TileItemType"] | undefined,
	notEq?: GraphQLTypes["TileItemType"] | undefined,
	in?: Array<GraphQLTypes["TileItemType"]> | undefined,
	notIn?: Array<GraphQLTypes["TileItemType"]> | undefined,
	lt?: GraphQLTypes["TileItemType"] | undefined,
	lte?: GraphQLTypes["TileItemType"] | undefined,
	gt?: GraphQLTypes["TileItemType"] | undefined,
	gte?: GraphQLTypes["TileItemType"] | undefined
};
	["TileItemType"]: TileItemType;
	["FeedPageSectionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	feedPageLocale?: GraphQLTypes["FeedPageLocaleWhere"] | undefined,
	tileStripeList?: GraphQLTypes["FeedPageTileStripeWhere"] | undefined,
	and?: Array<GraphQLTypes["FeedPageSectionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FeedPageSectionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FeedPageSectionWhere"] | undefined
};
	["FeedPageTileStripeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	section?: GraphQLTypes["FeedPageSectionWhere"] | undefined,
	tileList?: GraphQLTypes["TileListWhere"] | undefined,
	and?: Array<GraphQLTypes["FeedPageTileStripeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FeedPageTileStripeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FeedPageTileStripeWhere"] | undefined
};
	["CardListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["CardItemWhere"] | undefined,
	and?: Array<GraphQLTypes["CardListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CardListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CardListWhere"] | undefined
};
	["CardItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["CardListWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["CardItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CardItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CardItemWhere"] | undefined
};
	["StoryGuideListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["StoryGuideItemWhere"] | undefined,
	and?: Array<GraphQLTypes["StoryGuideListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StoryGuideListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StoryGuideListWhere"] | undefined
};
	["StoryGuideItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["StoryGuideListWhere"] | undefined,
	guide?: GraphQLTypes["StoryGuideWhere"] | undefined,
	and?: Array<GraphQLTypes["StoryGuideItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StoryGuideItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StoryGuideItemWhere"] | undefined
};
	["StoryGuideWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	mediaType?: GraphQLTypes["MediaTypeCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	secondaryImage?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["StoryGuideWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StoryGuideWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StoryGuideWhere"] | undefined
};
	["MediaTypeCondition"]: {
		and?: Array<GraphQLTypes["MediaTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["MediaTypeCondition"]> | undefined,
	not?: GraphQLTypes["MediaTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["MediaType"] | undefined,
	notEq?: GraphQLTypes["MediaType"] | undefined,
	in?: Array<GraphQLTypes["MediaType"]> | undefined,
	notIn?: Array<GraphQLTypes["MediaType"]> | undefined,
	lt?: GraphQLTypes["MediaType"] | undefined,
	lte?: GraphQLTypes["MediaType"] | undefined,
	gt?: GraphQLTypes["MediaType"] | undefined,
	gte?: GraphQLTypes["MediaType"] | undefined
};
	["MediaType"]: MediaType;
	["RecurringPaymentPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["RecurringPaymentPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	favouritePosts?: GraphQLTypes["PostListWhere"] | undefined,
	storyGuideList?: GraphQLTypes["StoryGuideListWhere"] | undefined,
	and?: Array<GraphQLTypes["RecurringPaymentPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RecurringPaymentPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RecurringPaymentPageLocaleWhere"] | undefined
};
	["RecurringPaymentPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["RecurringPaymentPageLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["RecurringPaymentPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RecurringPaymentPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RecurringPaymentPageWhere"] | undefined
};
	["PostListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["PostListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["PostListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostListWhere"] | undefined
};
	["PostListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["PostListWhere"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	and?: Array<GraphQLTypes["PostListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PostListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PostListItemWhere"] | undefined
};
	["ScheduledNotificationLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ScheduledNotificationWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ScheduledNotificationLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ScheduledNotificationLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ScheduledNotificationLocaleWhere"] | undefined
};
	["ScheduledNotificationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	localMsFromMidnight?: GraphQLTypes["IntCondition"] | undefined,
	scheduledDate?: GraphQLTypes["DateCondition"] | undefined,
	internalTitle?: GraphQLTypes["StringCondition"] | undefined,
	target?: GraphQLTypes["NotificationTargetGroupWhere"] | undefined,
	locales?: GraphQLTypes["ScheduledNotificationLocaleWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	completedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	processedNotifications?: GraphQLTypes["ProcessedNotificationSourceWhere"] | undefined,
	and?: Array<GraphQLTypes["ScheduledNotificationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ScheduledNotificationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ScheduledNotificationWhere"] | undefined
};
	["NotificationTargetGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["NotificationTargetTypeCondition"] | undefined,
	regions?: GraphQLTypes["RegionWhere"] | undefined,
	and?: Array<GraphQLTypes["NotificationTargetGroupWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["NotificationTargetGroupWhere"] | undefined> | undefined,
	not?: GraphQLTypes["NotificationTargetGroupWhere"] | undefined
};
	["NotificationTargetTypeCondition"]: {
		and?: Array<GraphQLTypes["NotificationTargetTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["NotificationTargetTypeCondition"]> | undefined,
	not?: GraphQLTypes["NotificationTargetTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["NotificationTargetType"] | undefined,
	notEq?: GraphQLTypes["NotificationTargetType"] | undefined,
	in?: Array<GraphQLTypes["NotificationTargetType"]> | undefined,
	notIn?: Array<GraphQLTypes["NotificationTargetType"]> | undefined,
	lt?: GraphQLTypes["NotificationTargetType"] | undefined,
	lte?: GraphQLTypes["NotificationTargetType"] | undefined,
	gt?: GraphQLTypes["NotificationTargetType"] | undefined,
	gte?: GraphQLTypes["NotificationTargetType"] | undefined
};
	["NotificationTargetType"]: NotificationTargetType;
	["ProcessedNotificationSourceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["ProcessedNotificationSourceTypeCondition"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationWhere"] | undefined,
	donationReminderUser?: GraphQLTypes["UserWhere"] | undefined,
	scheduledNotification?: GraphQLTypes["ScheduledNotificationWhere"] | undefined,
	and?: Array<GraphQLTypes["ProcessedNotificationSourceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProcessedNotificationSourceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProcessedNotificationSourceWhere"] | undefined
};
	["ProcessedNotificationSourceTypeCondition"]: {
		and?: Array<GraphQLTypes["ProcessedNotificationSourceTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ProcessedNotificationSourceTypeCondition"]> | undefined,
	not?: GraphQLTypes["ProcessedNotificationSourceTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	notEq?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	in?: Array<GraphQLTypes["ProcessedNotificationSourceType"]> | undefined,
	notIn?: Array<GraphQLTypes["ProcessedNotificationSourceType"]> | undefined,
	lt?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	lte?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	gt?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	gte?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined
};
	["ProcessedNotificationSourceType"]: ProcessedNotificationSourceType;
	["ProcessedNotificationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	topic?: GraphQLTypes["StringCondition"] | undefined,
	sentAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	errorMessage?: GraphQLTypes["StringCondition"] | undefined,
	errorCode?: GraphQLTypes["StringCondition"] | undefined,
	isSuccess?: GraphQLTypes["BooleanCondition"] | undefined,
	source?: GraphQLTypes["ProcessedNotificationSourceWhere"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	body?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ProcessedNotificationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProcessedNotificationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProcessedNotificationWhere"] | undefined
};
	["UserWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	tenantPersonId?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	payments?: GraphQLTypes["UserPaymentWhere"] | undefined,
	variableSymbol?: GraphQLTypes["IntCondition"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	region?: GraphQLTypes["RegionWhere"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	recurringPayments?: GraphQLTypes["UserRecurringPaymentWhere"] | undefined,
	stripeId?: GraphQLTypes["StringCondition"] | undefined,
	isDeactivated?: GraphQLTypes["BooleanCondition"] | undefined,
	onBehalfDonations?: GraphQLTypes["OnBehalfDonationWhere"] | undefined,
	publicProfileSecret?: GraphQLTypes["StringCondition"] | undefined,
	publicProfileCustomNote?: GraphQLTypes["StringCondition"] | undefined,
	publicProfileCustomNoteEnabled?: GraphQLTypes["BooleanCondition"] | undefined,
	donationConfirmationEmailEnabled?: GraphQLTypes["BooleanCondition"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	signedUp?: GraphQLTypes["BooleanCondition"] | undefined,
	devices?: GraphQLTypes["DeviceWhere"] | undefined,
	processedNotifications?: GraphQLTypes["ProcessedNotificationSourceWhere"] | undefined,
	areaStats?: GraphQLTypes["UserAreaStatsWhere"] | undefined,
	organizationStats?: GraphQLTypes["UserOrganizationStatsWhere"] | undefined,
	postStats?: GraphQLTypes["UserPostStatsWhere"] | undefined,
	currencyStats?: GraphQLTypes["UserCurrencyStatsWhere"] | undefined,
	stats?: GraphQLTypes["UserStatsWhere"] | undefined,
	and?: Array<GraphQLTypes["UserWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserWhere"] | undefined
};
	["UserPaymentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	cents?: GraphQLTypes["IntCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	specificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	order?: GraphQLTypes["UserPaymentOrderIdWhere"] | undefined,
	csobPayment?: GraphQLTypes["CsobPaymentWhere"] | undefined,
	stripePayment?: GraphQLTypes["StripePaymentWhere"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItemWhere"] | undefined,
	method?: GraphQLTypes["UserPaymentMethodCondition"] | undefined,
	region?: GraphQLTypes["RegionWhere"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	isReusable?: GraphQLTypes["BooleanCondition"] | undefined,
	onBehalfDonation?: GraphQLTypes["OnBehalfDonationWhere"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentTriesCollectionWhere"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	isSuccessful?: GraphQLTypes["BooleanCondition"] | undefined,
	isFinished?: GraphQLTypes["BooleanCondition"] | undefined,
	metadata?: GraphQLTypes["UserPaymentMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["UserPaymentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserPaymentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserPaymentWhere"] | undefined
};
	["UserPaymentOrderIdWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	seq?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["UserPaymentOrderIdWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserPaymentOrderIdWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserPaymentOrderIdWhere"] | undefined
};
	["CsobPaymentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	payId?: GraphQLTypes["StringCondition"] | undefined,
	statusChanges?: GraphQLTypes["CsobPaymentStatusChangeWhere"] | undefined,
	payment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	originalPayId?: GraphQLTypes["StringCondition"] | undefined,
	metadata?: GraphQLTypes["CsobPaymentMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["CsobPaymentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CsobPaymentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CsobPaymentWhere"] | undefined
};
	["CsobPaymentStatusChangeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	dttm?: GraphQLTypes["StringCondition"] | undefined,
	status?: GraphQLTypes["IntCondition"] | undefined,
	resultCode?: GraphQLTypes["IntCondition"] | undefined,
	message?: GraphQLTypes["StringCondition"] | undefined,
	authCode?: GraphQLTypes["StringCondition"] | undefined,
	statusDetail?: GraphQLTypes["StringCondition"] | undefined,
	actions?: GraphQLTypes["StringCondition"] | undefined,
	payment?: GraphQLTypes["CsobPaymentWhere"] | undefined,
	and?: Array<GraphQLTypes["CsobPaymentStatusChangeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CsobPaymentStatusChangeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CsobPaymentStatusChangeWhere"] | undefined
};
	["CsobPaymentMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	status?: GraphQLTypes["IntCondition"] | undefined,
	isSuccessful?: GraphQLTypes["BooleanCondition"] | undefined,
	isFinished?: GraphQLTypes["BooleanCondition"] | undefined,
	resolvedOriginalPayId?: GraphQLTypes["StringCondition"] | undefined,
	csobPayment?: GraphQLTypes["CsobPaymentWhere"] | undefined,
	and?: Array<GraphQLTypes["CsobPaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CsobPaymentMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CsobPaymentMetadataWhere"] | undefined
};
	["StripePaymentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	identifier?: GraphQLTypes["StringCondition"] | undefined,
	statusChanges?: GraphQLTypes["StripePaymentStatusChangeWhere"] | undefined,
	payment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	metadata?: GraphQLTypes["StripePaymentMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["StripePaymentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StripePaymentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StripePaymentWhere"] | undefined
};
	["StripePaymentStatusChangeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	payment?: GraphQLTypes["StripePaymentWhere"] | undefined,
	timestamp?: GraphQLTypes["IntCondition"] | undefined,
	eventId?: GraphQLTypes["StringCondition"] | undefined,
	paymentIntentStatus?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatusCondition"] | undefined,
	and?: Array<GraphQLTypes["StripePaymentStatusChangeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StripePaymentStatusChangeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StripePaymentStatusChangeWhere"] | undefined
};
	["StripePaymentStatusChangePaymentIntentStatusCondition"]: {
		and?: Array<GraphQLTypes["StripePaymentStatusChangePaymentIntentStatusCondition"]> | undefined,
	or?: Array<GraphQLTypes["StripePaymentStatusChangePaymentIntentStatusCondition"]> | undefined,
	not?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatusCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	notEq?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	in?: Array<GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"]> | undefined,
	notIn?: Array<GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"]> | undefined,
	lt?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	lte?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	gt?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	gte?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined
};
	["StripePaymentStatusChangePaymentIntentStatus"]: StripePaymentStatusChangePaymentIntentStatus;
	["StripePaymentMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	status?: GraphQLTypes["IntCondition"] | undefined,
	isSuccessful?: GraphQLTypes["BooleanCondition"] | undefined,
	isFinished?: GraphQLTypes["BooleanCondition"] | undefined,
	stripePayment?: GraphQLTypes["StripePaymentWhere"] | undefined,
	and?: Array<GraphQLTypes["StripePaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StripePaymentMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StripePaymentMetadataWhere"] | undefined
};
	["UserRecurringPaymentItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	recurrenceCounter?: GraphQLTypes["IntCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	taskId?: GraphQLTypes["StringCondition"] | undefined,
	payments?: GraphQLTypes["UserPaymentWhere"] | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentWhere"] | undefined,
	isFailed?: GraphQLTypes["BooleanCondition"] | undefined,
	failedEmailSentAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["UserRecurringPaymentItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserRecurringPaymentItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserRecurringPaymentItemWhere"] | undefined
};
	["UserRecurringPaymentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	activeSince?: GraphQLTypes["DateTimeCondition"] | undefined,
	cancelledAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	cents?: GraphQLTypes["IntCondition"] | undefined,
	interval?: GraphQLTypes["UserRecurringPaymentIntervalCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	items?: GraphQLTypes["UserRecurringPaymentItemWhere"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	meta?: GraphQLTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["UserRecurringPaymentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserRecurringPaymentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserRecurringPaymentWhere"] | undefined
};
	["UserRecurringPaymentIntervalCondition"]: {
		and?: Array<GraphQLTypes["UserRecurringPaymentIntervalCondition"]> | undefined,
	or?: Array<GraphQLTypes["UserRecurringPaymentIntervalCondition"]> | undefined,
	not?: GraphQLTypes["UserRecurringPaymentIntervalCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	notEq?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	in?: Array<GraphQLTypes["UserRecurringPaymentInterval"]> | undefined,
	notIn?: Array<GraphQLTypes["UserRecurringPaymentInterval"]> | undefined,
	lt?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	lte?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	gt?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	gte?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined
};
	["UserRecurringPaymentInterval"]: UserRecurringPaymentInterval;
	["UpcomingUserRecurringPaymentMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	recurrenceCounter?: GraphQLTypes["IntCondition"] | undefined,
	isBehindPayments?: GraphQLTypes["BooleanCondition"] | undefined,
	nextPaymentDate?: GraphQLTypes["DateTimeCondition"] | undefined,
	shouldBeProcessed?: GraphQLTypes["BooleanCondition"] | undefined,
	firstPayment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	firstSuccessfulPayment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	drivingPayment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentWhere"] | undefined,
	and?: Array<GraphQLTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UpcomingUserRecurringPaymentMetadataWhere"] | undefined
};
	["UserRecurringPaymentItemMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	isSuccessfullyPaid?: GraphQLTypes["BooleanCondition"] | undefined,
	shouldBeProcessed?: GraphQLTypes["BooleanCondition"] | undefined,
	firstPayment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	lastPayment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	firstSuccessfulPayment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	drivingPayment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItemWhere"] | undefined,
	and?: Array<GraphQLTypes["UserRecurringPaymentItemMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserRecurringPaymentItemMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserRecurringPaymentItemMetadataWhere"] | undefined
};
	["UserPaymentMethodCondition"]: {
		and?: Array<GraphQLTypes["UserPaymentMethodCondition"]> | undefined,
	or?: Array<GraphQLTypes["UserPaymentMethodCondition"]> | undefined,
	not?: GraphQLTypes["UserPaymentMethodCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["UserPaymentMethod"] | undefined,
	notEq?: GraphQLTypes["UserPaymentMethod"] | undefined,
	in?: Array<GraphQLTypes["UserPaymentMethod"]> | undefined,
	notIn?: Array<GraphQLTypes["UserPaymentMethod"]> | undefined,
	lt?: GraphQLTypes["UserPaymentMethod"] | undefined,
	lte?: GraphQLTypes["UserPaymentMethod"] | undefined,
	gt?: GraphQLTypes["UserPaymentMethod"] | undefined,
	gte?: GraphQLTypes["UserPaymentMethod"] | undefined
};
	["UserPaymentMethod"]: UserPaymentMethod;
	["OnBehalfDonationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	secretCode?: GraphQLTypes["StringCondition"] | undefined,
	specificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	payments?: GraphQLTypes["UserPaymentWhere"] | undefined,
	onBehalfOf?: GraphQLTypes["UserWhere"] | undefined,
	meta?: GraphQLTypes["OnBehalfDonationMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["OnBehalfDonationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OnBehalfDonationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OnBehalfDonationWhere"] | undefined
};
	["OnBehalfDonationMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	onBehalfOfDonation?: GraphQLTypes["OnBehalfDonationWhere"] | undefined,
	and?: Array<GraphQLTypes["OnBehalfDonationMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OnBehalfDonationMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OnBehalfDonationMetadataWhere"] | undefined
};
	["UserPaymentTriesCollectionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	cents?: GraphQLTypes["IntCondition"] | undefined,
	specificSymbol?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	orderUrl?: GraphQLTypes["StringCondition"] | undefined,
	payment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	onBehalfDonation?: GraphQLTypes["OnBehalfDonationWhere"] | undefined,
	recurring?: GraphQLTypes["UserRecurringPaymentWhere"] | undefined,
	metadata?: GraphQLTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined,
	metadataLocales?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined,
	medium?: GraphQLTypes["PaymentMediumCondition"] | undefined,
	and?: Array<GraphQLTypes["UserPaymentTriesCollectionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserPaymentTriesCollectionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserPaymentTriesCollectionWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentTriesCollectionWhere"] | undefined,
	and?: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserPaymentTriesCollectionMetadataWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	parent?: GraphQLTypes["UserPaymentTriesCollectionWhere"] | undefined,
	and?: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleWhere"] | undefined
};
	["PaymentMediumCondition"]: {
		and?: Array<GraphQLTypes["PaymentMediumCondition"]> | undefined,
	or?: Array<GraphQLTypes["PaymentMediumCondition"]> | undefined,
	not?: GraphQLTypes["PaymentMediumCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PaymentMedium"] | undefined,
	notEq?: GraphQLTypes["PaymentMedium"] | undefined,
	in?: Array<GraphQLTypes["PaymentMedium"]> | undefined,
	notIn?: Array<GraphQLTypes["PaymentMedium"]> | undefined,
	lt?: GraphQLTypes["PaymentMedium"] | undefined,
	lte?: GraphQLTypes["PaymentMedium"] | undefined,
	gt?: GraphQLTypes["PaymentMedium"] | undefined,
	gte?: GraphQLTypes["PaymentMedium"] | undefined
};
	["PaymentMedium"]: PaymentMedium;
	["UserPaymentMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	organizationUnfiltered?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	countToUser?: GraphQLTypes["UserWhere"] | undefined,
	paymentType?: GraphQLTypes["StringCondition"] | undefined,
	statusLabel?: GraphQLTypes["StringCondition"] | undefined,
	isSuccessful?: GraphQLTypes["BooleanCondition"] | undefined,
	isFinished?: GraphQLTypes["BooleanCondition"] | undefined,
	needsCacheUpdate?: GraphQLTypes["BooleanCondition"] | undefined,
	isSuccessfulNotCached?: GraphQLTypes["BooleanCondition"] | undefined,
	isFinishedNotCached?: GraphQLTypes["BooleanCondition"] | undefined,
	userPayment?: GraphQLTypes["UserPaymentWhere"] | undefined,
	and?: Array<GraphQLTypes["UserPaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserPaymentMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserPaymentMetadataWhere"] | undefined
};
	["DeviceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	fcmToken?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	ipAddress?: GraphQLTypes["StringCondition"] | undefined,
	userAgent?: GraphQLTypes["StringCondition"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["DeviceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeviceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeviceWhere"] | undefined
};
	["UserAreaStatsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	area?: GraphQLTypes["PostAreaWhere"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["UserAreaStatsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserAreaStatsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserAreaStatsWhere"] | undefined
};
	["UserOrganizationStatsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	organization?: GraphQLTypes["PostOrganizationWhere"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["UserOrganizationStatsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserOrganizationStatsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserOrganizationStatsWhere"] | undefined
};
	["UserPostStatsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["UserPostStatsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserPostStatsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserPostStatsWhere"] | undefined
};
	["UserCurrencyStatsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	currency?: GraphQLTypes["CurrencyWhere"] | undefined,
	totalAmountPaymentsOnce?: GraphQLTypes["IntCondition"] | undefined,
	totalAmountPaymentsRegular?: GraphQLTypes["IntCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["UserCurrencyStatsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserCurrencyStatsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserCurrencyStatsWhere"] | undefined
};
	["UserStatsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalPaymentsSuccessful?: GraphQLTypes["IntCondition"] | undefined,
	totalPaymentsUnsuccessful?: GraphQLTypes["IntCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["UserStatsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserStatsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserStatsWhere"] | undefined
};
	["Locale"]: {
	__typename: "Locale",
	_meta?: GraphQLTypes["LocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	code: string,
	label?: string | undefined,
	order: number,
	generals: Array<GraphQLTypes["GeneralLocale"]>,
	genericPages: Array<GraphQLTypes["GenericPageLocale"]>,
	posts: Array<GraphQLTypes["PostLocale"]>,
	postAreas: Array<GraphQLTypes["PostAreaLocale"]>,
	postOrganizations: Array<GraphQLTypes["PostOrganizationLocale"]>,
	headers: Array<GraphQLTypes["HeaderLocale"]>,
	footers: Array<GraphQLTypes["FooterLocale"]>,
	genericPageAboutSettings: Array<GraphQLTypes["GenericPageAboutSettingsLocale"]>,
	postRevisions: Array<GraphQLTypes["PostRevisionLocale"]>,
	flagImage?: GraphQLTypes["Image"] | undefined,
	feedPages: Array<GraphQLTypes["FeedPageLocale"]>,
	recurringPaymentPages: Array<GraphQLTypes["RecurringPaymentPageLocale"]>,
	givenGiftsPages: Array<GraphQLTypes["GivenGiftsPageLocale"]>,
	receivedGiftsPages: Array<GraphQLTypes["ReceivedGiftsPageLocale"]>,
	reportPages: Array<GraphQLTypes["ReportPageLocale"]>,
	reportNavigations: Array<GraphQLTypes["ReportNavigationLocale"]>,
	scheduledNotifications: Array<GraphQLTypes["ScheduledNotificationLocale"]>,
	sentPayments: Array<GraphQLTypes["SentPaymentLocale"]>,
	generalsByRoot?: GraphQLTypes["GeneralLocale"] | undefined,
	generalsBySeo?: GraphQLTypes["GeneralLocale"] | undefined,
	generalsByAppStoreLink?: GraphQLTypes["GeneralLocale"] | undefined,
	generalsByGooglePlayLink?: GraphQLTypes["GeneralLocale"] | undefined,
	genericPagesByRoot?: GraphQLTypes["GenericPageLocale"] | undefined,
	genericPagesByContent?: GraphQLTypes["GenericPageLocale"] | undefined,
	genericPagesBySeo?: GraphQLTypes["GenericPageLocale"] | undefined,
	genericPagesByLink?: GraphQLTypes["GenericPageLocale"] | undefined,
	postsByRoot?: GraphQLTypes["PostLocale"] | undefined,
	postsByContent?: GraphQLTypes["PostLocale"] | undefined,
	postsBySeo?: GraphQLTypes["PostLocale"] | undefined,
	postsByLink?: GraphQLTypes["PostLocale"] | undefined,
	postAreasByRoot?: GraphQLTypes["PostAreaLocale"] | undefined,
	postAreasByLink?: GraphQLTypes["PostAreaLocale"] | undefined,
	postAreasBySeo?: GraphQLTypes["PostAreaLocale"] | undefined,
	postAreasByBanner?: GraphQLTypes["PostAreaLocale"] | undefined,
	postAreasByContent?: GraphQLTypes["PostAreaLocale"] | undefined,
	postOrganizationsByRoot?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	postOrganizationsByLink?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	postOrganizationsByDomain?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	postOrganizationsBySeo?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	postOrganizationsByContent?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	headersByRoot?: GraphQLTypes["HeaderLocale"] | undefined,
	headersByLinks?: GraphQLTypes["HeaderLocale"] | undefined,
	footersByRoot?: GraphQLTypes["FooterLocale"] | undefined,
	footersByLinkList?: GraphQLTypes["FooterLocale"] | undefined,
	footersByAddressInfo?: GraphQLTypes["FooterLocale"] | undefined,
	footersByImageLinkList?: GraphQLTypes["FooterLocale"] | undefined,
	genericPageAboutSettingsByRoot?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	genericPageAboutSettingsByLinkGroups?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	postRevisionsByRoot?: GraphQLTypes["PostRevisionLocale"] | undefined,
	postRevisionsByContent?: GraphQLTypes["PostRevisionLocale"] | undefined,
	postRevisionsBySeo?: GraphQLTypes["PostRevisionLocale"] | undefined,
	postRevisionsByLeadContent?: GraphQLTypes["PostRevisionLocale"] | undefined,
	feedPagesByRoot?: GraphQLTypes["FeedPageLocale"] | undefined,
	feedPagesByHeroTiles?: GraphQLTypes["FeedPageLocale"] | undefined,
	feedPagesBySectionList?: GraphQLTypes["FeedPageLocale"] | undefined,
	feedPagesByCardList?: GraphQLTypes["FeedPageLocale"] | undefined,
	feedPagesByStoryGuideList?: GraphQLTypes["FeedPageLocale"] | undefined,
	recurringPaymentPagesByRoot?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	recurringPaymentPagesByFavouritePosts?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	recurringPaymentPagesByStoryGuideList?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	givenGiftsPagesByRoot?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	givenGiftsPagesByContent?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	givenGiftsPagesBySeo?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	givenGiftsPagesByLink?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	receivedGiftsPagesByRoot?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	receivedGiftsPagesByLink?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	receivedGiftsPagesByContent?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	receivedGiftsPagesBySeo?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	reportPagesByRoot?: GraphQLTypes["ReportPageLocale"] | undefined,
	reportPagesByLink?: GraphQLTypes["ReportPageLocale"] | undefined,
	reportPagesByContent?: GraphQLTypes["ReportPageLocale"] | undefined,
	reportPagesBySeo?: GraphQLTypes["ReportPageLocale"] | undefined,
	reportNavigationsByRoot?: GraphQLTypes["ReportNavigationLocale"] | undefined,
	scheduledNotificationsByRoot?: GraphQLTypes["ScheduledNotificationLocale"] | undefined,
	sentPaymentsByRoot?: GraphQLTypes["SentPaymentLocale"] | undefined,
	paginateGenerals: GraphQLTypes["GeneralLocaleConnection"],
	paginateGenericPages: GraphQLTypes["GenericPageLocaleConnection"],
	paginatePosts: GraphQLTypes["PostLocaleConnection"],
	paginatePostAreas: GraphQLTypes["PostAreaLocaleConnection"],
	paginatePostOrganizations: GraphQLTypes["PostOrganizationLocaleConnection"],
	paginateHeaders: GraphQLTypes["HeaderLocaleConnection"],
	paginateFooters: GraphQLTypes["FooterLocaleConnection"],
	paginateGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsLocaleConnection"],
	paginatePostRevisions: GraphQLTypes["PostRevisionLocaleConnection"],
	paginateFeedPages: GraphQLTypes["FeedPageLocaleConnection"],
	paginateRecurringPaymentPages: GraphQLTypes["RecurringPaymentPageLocaleConnection"],
	paginateGivenGiftsPages: GraphQLTypes["GivenGiftsPageLocaleConnection"],
	paginateReceivedGiftsPages: GraphQLTypes["ReceivedGiftsPageLocaleConnection"],
	paginateReportPages: GraphQLTypes["ReportPageLocaleConnection"],
	paginateReportNavigations: GraphQLTypes["ReportNavigationLocaleConnection"],
	paginateScheduledNotifications: GraphQLTypes["ScheduledNotificationLocaleConnection"],
	paginateSentPayments: GraphQLTypes["SentPaymentLocaleConnection"]
};
	["LocaleMeta"]: {
	__typename: "LocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	label?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	generals?: GraphQLTypes["FieldMeta"] | undefined,
	genericPages?: GraphQLTypes["FieldMeta"] | undefined,
	posts?: GraphQLTypes["FieldMeta"] | undefined,
	postAreas?: GraphQLTypes["FieldMeta"] | undefined,
	postOrganizations?: GraphQLTypes["FieldMeta"] | undefined,
	headers?: GraphQLTypes["FieldMeta"] | undefined,
	footers?: GraphQLTypes["FieldMeta"] | undefined,
	genericPageAboutSettings?: GraphQLTypes["FieldMeta"] | undefined,
	postRevisions?: GraphQLTypes["FieldMeta"] | undefined,
	flagImage?: GraphQLTypes["FieldMeta"] | undefined,
	feedPages?: GraphQLTypes["FieldMeta"] | undefined,
	recurringPaymentPages?: GraphQLTypes["FieldMeta"] | undefined,
	givenGiftsPages?: GraphQLTypes["FieldMeta"] | undefined,
	receivedGiftsPages?: GraphQLTypes["FieldMeta"] | undefined,
	reportPages?: GraphQLTypes["FieldMeta"] | undefined,
	reportNavigations?: GraphQLTypes["FieldMeta"] | undefined,
	scheduledNotifications?: GraphQLTypes["FieldMeta"] | undefined,
	sentPayments?: GraphQLTypes["FieldMeta"] | undefined
};
	["GeneralLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["GeneralOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	appStoreLink?: GraphQLTypes["LinkOrderBy"] | undefined,
	googlePlayLink?: GraphQLTypes["LinkOrderBy"] | undefined,
	allAreasDescription?: GraphQLTypes["OrderDirection"] | undefined,
	allOrganizationsDescription?: GraphQLTypes["OrderDirection"] | undefined
};
	["OrderDirection"]: OrderDirection;
	["GeneralOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	allAreasIcon?: GraphQLTypes["ImageOrderBy"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["ImageOrderBy"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListOrderBy"] | undefined
};
	["ImageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	width?: GraphQLTypes["OrderDirection"] | undefined,
	height?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	alt?: GraphQLTypes["OrderDirection"] | undefined,
	fileName?: GraphQLTypes["OrderDirection"] | undefined,
	focalPointX?: GraphQLTypes["OrderDirection"] | undefined,
	focalPointY?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostOrganizationListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["LocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	label?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	flagImage?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["SeoOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	ogTitle?: GraphQLTypes["OrderDirection"] | undefined,
	ogDescription?: GraphQLTypes["OrderDirection"] | undefined,
	noIndex?: GraphQLTypes["OrderDirection"] | undefined,
	noFollow?: GraphQLTypes["OrderDirection"] | undefined,
	ogImage?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["LinkOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	externalLink?: GraphQLTypes["OrderDirection"] | undefined,
	internalLink?: GraphQLTypes["LinkableOrderBy"] | undefined,
	isTargetBlank?: GraphQLTypes["OrderDirection"] | undefined
};
	["LinkableOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	genericPage?: GraphQLTypes["GenericPageLocaleOrderBy"] | undefined,
	post?: GraphQLTypes["PostLocaleOrderBy"] | undefined,
	postArea?: GraphQLTypes["PostAreaLocaleOrderBy"] | undefined,
	postOrganization?: GraphQLTypes["PostOrganizationLocaleOrderBy"] | undefined,
	reportPage?: GraphQLTypes["ReportPageLocaleOrderBy"] | undefined,
	givenGiftsPage?: GraphQLTypes["GivenGiftsPageLocaleOrderBy"] | undefined,
	receivedGiftsPage?: GraphQLTypes["ReceivedGiftsPageLocaleOrderBy"] | undefined
};
	["GenericPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["GenericPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined
};
	["GenericPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["ContentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	root?: GraphQLTypes["PostOrderBy"] | undefined,
	paymentName?: GraphQLTypes["OrderDirection"] | undefined,
	publishedAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	specificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	activeRevision?: GraphQLTypes["PostRevisionOrderBy"] | undefined,
	isPinnedInArea?: GraphQLTypes["OrderDirection"] | undefined,
	isPinnedInOrganization?: GraphQLTypes["OrderDirection"] | undefined,
	state?: GraphQLTypes["OrderDirection"] | undefined,
	meta?: GraphQLTypes["PostMetaDataOrderBy"] | undefined,
	isPublishedAtHidden?: GraphQLTypes["OrderDirection"] | undefined,
	fundraiseIsActive?: GraphQLTypes["OrderDirection"] | undefined,
	fundraiseEndDate?: GraphQLTypes["OrderDirection"] | undefined,
	fundraiseTargetAmount?: GraphQLTypes["OrderDirection"] | undefined,
	fundraiseFakeAddOnAmount?: GraphQLTypes["OrderDirection"] | undefined,
	fundraiseCurrency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	fundraiseSum?: GraphQLTypes["PostSumOrderBy"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostFundraisingProgressOrderBy"] | undefined
};
	["PostOrganizationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	icon?: GraphQLTypes["ImageOrderBy"] | undefined,
	specificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	meta?: GraphQLTypes["PostOrganizationMetaDataOrderBy"] | undefined,
	mobileHeroImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	isHidden?: GraphQLTypes["OrderDirection"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined,
	plainIcon?: GraphQLTypes["ImageOrderBy"] | undefined,
	desktopHeroImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationSumOrderBy"] | undefined
};
	["PostAreaOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	icon?: GraphQLTypes["ImageOrderBy"] | undefined,
	regionListOverride?: GraphQLTypes["DonationAmountsRegionListOrderBy"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined,
	specificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	region?: GraphQLTypes["RegionOrderBy"] | undefined,
	meta?: GraphQLTypes["PostAreaMetaDataOrderBy"] | undefined,
	mobileHeroImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	plainIcon?: GraphQLTypes["ImageOrderBy"] | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaSentPaymentSumOrderBy"] | undefined,
	areaSum?: GraphQLTypes["PostAreaSumOrderBy"] | undefined
};
	["DonationAmountsRegionListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	donation?: GraphQLTypes["DonationOrderBy"] | undefined
};
	["DonationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	regionList?: GraphQLTypes["DonationAmountsRegionListOrderBy"] | undefined
};
	["RegionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	label?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	timezone?: GraphQLTypes["OrderDirection"] | undefined
};
	["CurrencyOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	identifier?: GraphQLTypes["OrderDirection"] | undefined,
	label?: GraphQLTypes["OrderDirection"] | undefined,
	sign?: GraphQLTypes["OrderDirection"] | undefined,
	signAlignment?: GraphQLTypes["OrderDirection"] | undefined,
	defaultDonationAmount?: GraphQLTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostAreaMetaDataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	nameWithFallback?: GraphQLTypes["OrderDirection"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined
};
	["PostAreaSentPaymentSumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	czkPercentage?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined
};
	["PostAreaSumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	czkPercentage?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined
};
	["PostOrganizationMetaDataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	nameWithFallback?: GraphQLTypes["OrderDirection"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined
};
	["PostOrganizationSumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	czkPercentage?: GraphQLTypes["OrderDirection"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined
};
	["PostRevisionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	createdById?: GraphQLTypes["OrderDirection"] | undefined,
	publishedById?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	publishedAt?: GraphQLTypes["OrderDirection"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined,
	tileImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	tileVideo?: GraphQLTypes["VideoOrderBy"] | undefined,
	heroImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	regionListOverride?: GraphQLTypes["DonationAmountsRegionListOrderBy"] | undefined,
	isOrganizationVisible?: GraphQLTypes["OrderDirection"] | undefined,
	sendPublishNotifications?: GraphQLTypes["OrderDirection"] | undefined,
	isArchived?: GraphQLTypes["OrderDirection"] | undefined
};
	["VideoOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	width?: GraphQLTypes["OrderDirection"] | undefined,
	height?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	poster?: GraphQLTypes["ImageOrderBy"] | undefined,
	shapeType?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostMetaDataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	titleWithFallback?: GraphQLTypes["OrderDirection"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	latestRevision?: GraphQLTypes["PostRevisionOrderBy"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined
};
	["PostSumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	czkPercentage?: GraphQLTypes["OrderDirection"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined
};
	["PostFundraisingProgressOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	progress?: GraphQLTypes["OrderDirection"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined
};
	["PostAreaLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	root?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	banner?: GraphQLTypes["AppBannerOrderBy"] | undefined,
	shortDescription?: GraphQLTypes["OrderDirection"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	translatedByAI?: GraphQLTypes["OrderDirection"] | undefined
};
	["AppBannerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	imageSmall?: GraphQLTypes["ImageOrderBy"] | undefined,
	imageBig?: GraphQLTypes["ImageOrderBy"] | undefined,
	textContent?: GraphQLTypes["ContentOrderBy"] | undefined
};
	["PostOrganizationLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	root?: GraphQLTypes["PostOrganizationOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	domain?: GraphQLTypes["LinkOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	translatedByAI?: GraphQLTypes["OrderDirection"] | undefined
};
	["ReportPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined,
	postTitle?: GraphQLTypes["OrderDirection"] | undefined,
	giftTitle?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	root?: GraphQLTypes["ReportPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined
};
	["ReportPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["GivenGiftsPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined,
	giftTitle?: GraphQLTypes["OrderDirection"] | undefined,
	giftText?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["GivenGiftsPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined
};
	["GivenGiftsPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["ReceivedGiftsPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined,
	giftTitle?: GraphQLTypes["OrderDirection"] | undefined,
	giftText?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined
};
	["ReceivedGiftsPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["GenericPageLocale"]: {
	__typename: "GenericPageLocale",
	_meta?: GraphQLTypes["GenericPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	root?: GraphQLTypes["GenericPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	subtitle?: string | undefined
};
	["GenericPageLocaleMeta"]: {
	__typename: "GenericPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined
};
	["GenericPage"]: {
	__typename: "GenericPage",
	_meta?: GraphQLTypes["GenericPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["GenericPageLocale"]>,
	type: GraphQLTypes["GenericPageType"],
	order: number,
	reportNavigation: Array<GraphQLTypes["ReportNavigationLocale"]>,
	localesByLocale?: GraphQLTypes["GenericPageLocale"] | undefined,
	localesByContent?: GraphQLTypes["GenericPageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["GenericPageLocale"] | undefined,
	localesByLink?: GraphQLTypes["GenericPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["GenericPageLocaleConnection"],
	paginateReportNavigation: GraphQLTypes["ReportNavigationLocaleConnection"]
};
	["GenericPageMeta"]: {
	__typename: "GenericPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	reportNavigation?: GraphQLTypes["FieldMeta"] | undefined
};
	["ReportNavigationLocale"]: {
	__typename: "ReportNavigationLocale",
	_meta?: GraphQLTypes["ReportNavigationLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["ReportNavigation"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	pages: Array<GraphQLTypes["GenericPage"]>,
	paginatePages: GraphQLTypes["GenericPageConnection"]
};
	["ReportNavigationLocaleMeta"]: {
	__typename: "ReportNavigationLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	pages?: GraphQLTypes["FieldMeta"] | undefined
};
	["ReportNavigation"]: {
	__typename: "ReportNavigation",
	_meta?: GraphQLTypes["ReportNavigationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["ReportNavigationLocale"]>,
	localesByLocale?: GraphQLTypes["ReportNavigationLocale"] | undefined,
	paginateLocales: GraphQLTypes["ReportNavigationLocaleConnection"]
};
	["ReportNavigationMeta"]: {
	__typename: "ReportNavigationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["ReportNavigationLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ReportNavigationOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["ReportNavigationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["ReportNavigationLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["LocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	generals?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	genericPages?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	posts?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	postAreas?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	postOrganizations?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	headers?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	footers?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	genericPageAboutSettings?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	postRevisions?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	feedPages?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	recurringPaymentPages?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	givenGiftsPages?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	receivedGiftsPages?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	reportPages?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	reportNavigations?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	scheduledNotifications?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	sentPayments?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined
};
	["GeneralLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GeneralUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	appStoreLink?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	googlePlayLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["GeneralUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	allAreasIcon?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PostOrganizationListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["PostOrganizationListItemUniqueWhere"] | undefined
};
	["PostOrganizationListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	ogImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["GenericPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	references?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	linkables?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	valueList?: GraphQLTypes["ValueListUniqueWhere"] | undefined,
	imageLinkList?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined,
	areaList?: GraphQLTypes["PostAreaListUniqueWhere"] | undefined,
	accordion?: GraphQLTypes["AccordionUniqueWhere"] | undefined,
	media?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	memberList?: GraphQLTypes["MemberListUniqueWhere"] | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	textImageList?: GraphQLTypes["TextImageListUniqueWhere"] | undefined
};
	["ContentReferenceLinkableItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	item?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	post?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	postArea?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	postOrganization?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	reportPage?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	givenGiftsPage?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	receivedGiftsPage?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined
};
	["PostLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["PostUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["PostUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	revisions?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	locales?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	meta?: GraphQLTypes["PostMetaDataUniqueWhere"] | undefined,
	fundraiseCurrencySums?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	fundraiseSum?: GraphQLTypes["PostSumUniqueWhere"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostFundraisingProgressUniqueWhere"] | undefined
};
	["PostRevisionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	regionListOverride?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined
};
	["PostRevisionLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	leadContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["DonationAmountsRegionListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	regions?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	donation?: GraphQLTypes["DonationUniqueWhere"] | undefined
};
	["DonationAmountsRegionItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	list?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	region?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	items?: GraphQLTypes["DonationAmountItemUniqueWhere"] | undefined
};
	["RegionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	enabledPaymentMethods?: GraphQLTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	donationItems?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined
};
	["RegionPaymentMethodUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	region?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	method?: GraphQLTypes["PaymentMethods"] | undefined
};
	["DonationAmountItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["DonationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	regionList?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined
};
	["PostMetaDataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	latestRevision?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	post?: GraphQLTypes["PostUniqueWhere"] | undefined
};
	["PostCurrencySumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PostSumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	post?: GraphQLTypes["PostUniqueWhere"] | undefined
};
	["PostFundraisingProgressUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	post?: GraphQLTypes["PostUniqueWhere"] | undefined
};
	["PostAreaLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	banner?: GraphQLTypes["AppBannerUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PostAreaUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	specificSymbol?: number | undefined,
	locales?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	regionListOverride?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	posts?: GraphQLTypes["PostUniqueWhere"] | undefined,
	meta?: GraphQLTypes["PostAreaMetaDataUniqueWhere"] | undefined,
	sentPayments?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	areaSentPaymentCurrencySums?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined,
	areaCurrencySums?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	areaSum?: GraphQLTypes["PostAreaSumUniqueWhere"] | undefined
};
	["PostAreaMetaDataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	area?: GraphQLTypes["PostAreaUniqueWhere"] | undefined
};
	["SentPaymentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined
};
	["SentPaymentLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PostAreaSentPaymentCurrencySumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PostAreaSentPaymentSumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	area?: GraphQLTypes["PostAreaUniqueWhere"] | undefined
};
	["PostAreaCurrencySumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PostAreaSumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	area?: GraphQLTypes["PostAreaUniqueWhere"] | undefined
};
	["AppBannerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	textContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PostOrganizationLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	domain?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PostOrganizationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	specificSymbol?: number | undefined,
	posts?: GraphQLTypes["PostUniqueWhere"] | undefined,
	locales?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	meta?: GraphQLTypes["PostOrganizationMetaDataUniqueWhere"] | undefined,
	sentPayments?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	organizationCurrencySums?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationSumUniqueWhere"] | undefined
};
	["PostOrganizationMetaDataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined
};
	["PostOrganizationCurrencySumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PostOrganizationSumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined
};
	["ReportPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ReportPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["ReportPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined
};
	["GivenGiftsPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GivenGiftsPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["GivenGiftsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["ReceivedGiftsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined
};
	["ValueListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ValueItemUniqueWhere"] | undefined
};
	["ValueItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ImageLinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ImageLinkItemUniqueWhere"] | undefined
};
	["ImageLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PostAreaListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["PostAreaListItemUniqueWhere"] | undefined
};
	["PostAreaListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["AccordionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["AccordionItemUniqueWhere"] | undefined
};
	["AccordionItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	descriptionContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["MediumListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["MediumItemUniqueWhere"] | undefined
};
	["MediumItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["MemberListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["MemberListItemUniqueWhere"] | undefined
};
	["MemberListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	descriptionContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["TextImageListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["TextImageListItemUniqueWhere"] | undefined
};
	["TextImageListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["HeaderLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["HeaderUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	links?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["HeaderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined
};
	["LinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["LinkItemUniqueWhere"] | undefined
};
	["LinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["FooterUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	linkList?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	addressInfo?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	imageLinkList?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined
};
	["GenericPageAboutSettingsLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GenericPageAboutSettingsUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	linkGroups?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined
};
	["GenericPageAboutSettingsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined
};
	["GenericPageAboutGroupLinksLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	linkList?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["FeedPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["FeedPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	heroTiles?: GraphQLTypes["TileListUniqueWhere"] | undefined,
	sectionList?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined,
	cardList?: GraphQLTypes["CardListUniqueWhere"] | undefined,
	storyGuideList?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined
};
	["FeedPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined
};
	["TileListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["TileItemUniqueWhere"] | undefined
};
	["TileItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FeedPageSectionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tileStripeList?: GraphQLTypes["FeedPageTileStripeUniqueWhere"] | undefined
};
	["FeedPageTileStripeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CardListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["CardItemUniqueWhere"] | undefined
};
	["CardItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["StoryGuideListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["StoryGuideItemUniqueWhere"] | undefined
};
	["StoryGuideItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["RecurringPaymentPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["RecurringPaymentPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	favouritePosts?: GraphQLTypes["PostListUniqueWhere"] | undefined,
	storyGuideList?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined
};
	["RecurringPaymentPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined
};
	["PostListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["PostListItemUniqueWhere"] | undefined
};
	["PostListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ReportNavigationLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ReportNavigationUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ReportNavigationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined
};
	["ScheduledNotificationLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ScheduledNotificationUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ScheduledNotificationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	processedNotifications?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined
};
	["ProcessedNotificationSourceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationUniqueWhere"] | undefined
};
	["ProcessedNotificationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	source?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined
};
	["ReportNavigationLocaleConnection"]: {
	__typename: "ReportNavigationLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReportNavigationLocaleEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["ReportNavigationLocaleEdge"]: {
	__typename: "ReportNavigationLocaleEdge",
	node: GraphQLTypes["ReportNavigationLocale"]
};
	["GenericPageConnection"]: {
	__typename: "GenericPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageEdge"]>
};
	["GenericPageEdge"]: {
	__typename: "GenericPageEdge",
	node: GraphQLTypes["GenericPage"]
};
	["GenericPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["GenericPageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["GenericPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["GenericPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["GenericPageLocaleConnection"]: {
	__typename: "GenericPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageLocaleEdge"]>
};
	["GenericPageLocaleEdge"]: {
	__typename: "GenericPageLocaleEdge",
	node: GraphQLTypes["GenericPageLocale"]
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"] | undefined,
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	blocks?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"] | undefined,
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByLinkables?: GraphQLTypes["ContentReference"] | undefined,
	referencesByLink?: GraphQLTypes["ContentReference"] | undefined,
	referencesByValueList?: GraphQLTypes["ContentReference"] | undefined,
	referencesByImageLinkList?: GraphQLTypes["ContentReference"] | undefined,
	referencesByAreaList?: GraphQLTypes["ContentReference"] | undefined,
	referencesByAccordion?: GraphQLTypes["ContentReference"] | undefined,
	referencesByMedia?: GraphQLTypes["ContentReference"] | undefined,
	referencesByMemberList?: GraphQLTypes["ContentReference"] | undefined,
	referencesByContentWithoutBlocks?: GraphQLTypes["ContentReference"] | undefined,
	referencesByOrganizationList?: GraphQLTypes["ContentReference"] | undefined,
	referencesByTextImageList?: GraphQLTypes["ContentReference"] | undefined,
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	json?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	references?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	primaryText?: string | undefined,
	block?: GraphQLTypes["ContentBlock"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	linkables: Array<GraphQLTypes["ContentReferenceLinkableItem"]>,
	video?: GraphQLTypes["Video"] | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	contentAlignment: GraphQLTypes["ContentAlignment"],
	valueList?: GraphQLTypes["ValueList"] | undefined,
	imageLinkList?: GraphQLTypes["ImageLinkList"] | undefined,
	areaList?: GraphQLTypes["PostAreaList"] | undefined,
	isAppsVisible: boolean,
	accordion?: GraphQLTypes["Accordion"] | undefined,
	media?: GraphQLTypes["MediumList"] | undefined,
	memberList?: GraphQLTypes["MemberList"] | undefined,
	asideMediaContentLayout: GraphQLTypes["AsideMediaContentLayout"],
	isAsideMediaContentMobileLayout: boolean,
	form?: GraphQLTypes["Form"] | undefined,
	isTitleBigger: boolean,
	contentWithoutBlocks?: GraphQLTypes["Content"] | undefined,
	heroCarousel?: GraphQLTypes["HeroCarousel"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationList"] | undefined,
	isCentered: boolean,
	posts: Array<GraphQLTypes["Post"]>,
	textImageList?: GraphQLTypes["TextImageList"] | undefined,
	linkablesByItem?: GraphQLTypes["ContentReferenceLinkableItem"] | undefined,
	paginateLinkables: GraphQLTypes["ContentReferenceLinkableItemConnection"],
	paginatePosts: GraphQLTypes["PostConnection"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	primaryText?: GraphQLTypes["FieldMeta"] | undefined,
	block?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	linkables?: GraphQLTypes["FieldMeta"] | undefined,
	video?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryText?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	contentAlignment?: GraphQLTypes["FieldMeta"] | undefined,
	valueList?: GraphQLTypes["FieldMeta"] | undefined,
	imageLinkList?: GraphQLTypes["FieldMeta"] | undefined,
	areaList?: GraphQLTypes["FieldMeta"] | undefined,
	isAppsVisible?: GraphQLTypes["FieldMeta"] | undefined,
	accordion?: GraphQLTypes["FieldMeta"] | undefined,
	media?: GraphQLTypes["FieldMeta"] | undefined,
	memberList?: GraphQLTypes["FieldMeta"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["FieldMeta"] | undefined,
	isAsideMediaContentMobileLayout?: GraphQLTypes["FieldMeta"] | undefined,
	form?: GraphQLTypes["FieldMeta"] | undefined,
	isTitleBigger?: GraphQLTypes["FieldMeta"] | undefined,
	contentWithoutBlocks?: GraphQLTypes["FieldMeta"] | undefined,
	heroCarousel?: GraphQLTypes["FieldMeta"] | undefined,
	organizationList?: GraphQLTypes["FieldMeta"] | undefined,
	isCentered?: GraphQLTypes["FieldMeta"] | undefined,
	posts?: GraphQLTypes["FieldMeta"] | undefined,
	textImageList?: GraphQLTypes["FieldMeta"] | undefined
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	alt?: GraphQLTypes["FieldMeta"] | undefined,
	fileName?: GraphQLTypes["FieldMeta"] | undefined,
	focalPointX?: GraphQLTypes["FieldMeta"] | undefined,
	focalPointY?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentReferenceLinkableItem"]: {
	__typename: "ContentReferenceLinkableItem",
	_meta?: GraphQLTypes["ContentReferenceLinkableItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	item?: GraphQLTypes["Linkable"] | undefined,
	reference?: GraphQLTypes["ContentReference"] | undefined
};
	["ContentReferenceLinkableItemMeta"]: {
	__typename: "ContentReferenceLinkableItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined,
	reference?: GraphQLTypes["FieldMeta"] | undefined
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	genericPage?: GraphQLTypes["GenericPageLocale"] | undefined,
	post?: GraphQLTypes["PostLocale"] | undefined,
	postArea?: GraphQLTypes["PostAreaLocale"] | undefined,
	postOrganization?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	reportPage?: GraphQLTypes["ReportPageLocale"] | undefined,
	givenGiftsPage?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	receivedGiftsPage?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	genericPage?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined,
	postArea?: GraphQLTypes["FieldMeta"] | undefined,
	postOrganization?: GraphQLTypes["FieldMeta"] | undefined,
	reportPage?: GraphQLTypes["FieldMeta"] | undefined,
	givenGiftsPage?: GraphQLTypes["FieldMeta"] | undefined,
	receivedGiftsPage?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostLocale"]: {
	__typename: "PostLocale",
	_meta?: GraphQLTypes["PostLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	root?: GraphQLTypes["Post"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined
};
	["PostLocaleMeta"]: {
	__typename: "PostLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	paymentName?: GraphQLTypes["FieldMeta"] | undefined,
	publishedAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: GraphQLTypes["Image"] | undefined
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	ogTitle?: GraphQLTypes["FieldMeta"] | undefined,
	ogDescription?: GraphQLTypes["FieldMeta"] | undefined,
	noIndex?: GraphQLTypes["FieldMeta"] | undefined,
	noFollow?: GraphQLTypes["FieldMeta"] | undefined,
	ogImage?: GraphQLTypes["FieldMeta"] | undefined
};
	["Post"]: {
	__typename: "Post",
	_meta?: GraphQLTypes["PostMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	organization?: GraphQLTypes["PostOrganization"] | undefined,
	area?: GraphQLTypes["PostArea"] | undefined,
	specificSymbol: number,
	activeRevision?: GraphQLTypes["PostRevision"] | undefined,
	revisions: Array<GraphQLTypes["PostRevision"]>,
	locales: Array<GraphQLTypes["PostLocale"]>,
	isPinnedInArea: boolean,
	isPinnedInOrganization: boolean,
	state: GraphQLTypes["PostState"],
	meta?: GraphQLTypes["PostMetaData"] | undefined,
	isPublishedAtHidden: boolean,
	heroCarousel: Array<GraphQLTypes["HeroCarousel"]>,
	reportPage: Array<GraphQLTypes["ReportPageLocale"]>,
	content: Array<GraphQLTypes["ContentReference"]>,
	fundraiseIsActive: boolean,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["Currency"] | undefined,
	fundraiseCurrencySums: Array<GraphQLTypes["PostCurrencySum"]>,
	fundraiseSum?: GraphQLTypes["PostSum"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostFundraisingProgress"] | undefined,
	revisionsByLocales?: GraphQLTypes["PostRevision"] | undefined,
	revisionsByRegionListOverride?: GraphQLTypes["PostRevision"] | undefined,
	localesByLocale?: GraphQLTypes["PostLocale"] | undefined,
	localesByContent?: GraphQLTypes["PostLocale"] | undefined,
	localesBySeo?: GraphQLTypes["PostLocale"] | undefined,
	localesByLink?: GraphQLTypes["PostLocale"] | undefined,
	paginateRevisions: GraphQLTypes["PostRevisionConnection"],
	paginateLocales: GraphQLTypes["PostLocaleConnection"],
	paginateHeroCarousel: GraphQLTypes["HeroCarouselConnection"],
	paginateReportPage: GraphQLTypes["ReportPageLocaleConnection"],
	paginateContent: GraphQLTypes["ContentReferenceConnection"],
	paginateFundraiseCurrencySums: GraphQLTypes["PostCurrencySumConnection"]
};
	["PostMeta"]: {
	__typename: "PostMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	specificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	activeRevision?: GraphQLTypes["FieldMeta"] | undefined,
	revisions?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	isPinnedInArea?: GraphQLTypes["FieldMeta"] | undefined,
	isPinnedInOrganization?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	isPublishedAtHidden?: GraphQLTypes["FieldMeta"] | undefined,
	heroCarousel?: GraphQLTypes["FieldMeta"] | undefined,
	reportPage?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	fundraiseIsActive?: GraphQLTypes["FieldMeta"] | undefined,
	fundraiseEndDate?: GraphQLTypes["FieldMeta"] | undefined,
	fundraiseTargetAmount?: GraphQLTypes["FieldMeta"] | undefined,
	fundraiseFakeAddOnAmount?: GraphQLTypes["FieldMeta"] | undefined,
	fundraiseCurrency?: GraphQLTypes["FieldMeta"] | undefined,
	fundraiseCurrencySums?: GraphQLTypes["FieldMeta"] | undefined,
	fundraiseSum?: GraphQLTypes["FieldMeta"] | undefined,
	fundraisingProgress?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostOrganization"]: {
	__typename: "PostOrganization",
	_meta?: GraphQLTypes["PostOrganizationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	posts: Array<GraphQLTypes["Post"]>,
	icon?: GraphQLTypes["Image"] | undefined,
	locales: Array<GraphQLTypes["PostOrganizationLocale"]>,
	specificSymbol: number,
	area?: GraphQLTypes["PostArea"] | undefined,
	meta?: GraphQLTypes["PostOrganizationMetaData"] | undefined,
	mobileHeroImage?: GraphQLTypes["Image"] | undefined,
	isHidden: boolean,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["Image"] | undefined,
	desktopHeroImage?: GraphQLTypes["Image"] | undefined,
	sentPayments: Array<GraphQLTypes["SentPayment"]>,
	organizationCurrencySums: Array<GraphQLTypes["PostOrganizationCurrencySum"]>,
	organizationSum?: GraphQLTypes["PostOrganizationSum"] | undefined,
	postsBySpecificSymbol?: GraphQLTypes["Post"] | undefined,
	postsByActiveRevision?: GraphQLTypes["Post"] | undefined,
	postsByRevisions?: GraphQLTypes["Post"] | undefined,
	postsByLocales?: GraphQLTypes["Post"] | undefined,
	postsByMeta?: GraphQLTypes["Post"] | undefined,
	postsByFundraiseCurrencySums?: GraphQLTypes["Post"] | undefined,
	postsByFundraiseSum?: GraphQLTypes["Post"] | undefined,
	postsByFundraisingProgress?: GraphQLTypes["Post"] | undefined,
	localesByLocale?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	localesByLink?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	localesByDomain?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	localesBySeo?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	localesByContent?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	sentPaymentsByLocales?: GraphQLTypes["SentPayment"] | undefined,
	paginatePosts: GraphQLTypes["PostConnection"],
	paginateLocales: GraphQLTypes["PostOrganizationLocaleConnection"],
	paginateSentPayments: GraphQLTypes["SentPaymentConnection"],
	paginateOrganizationCurrencySums: GraphQLTypes["PostOrganizationCurrencySumConnection"]
};
	["PostOrganizationMeta"]: {
	__typename: "PostOrganizationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	posts?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	specificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	mobileHeroImage?: GraphQLTypes["FieldMeta"] | undefined,
	isHidden?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	plainIcon?: GraphQLTypes["FieldMeta"] | undefined,
	desktopHeroImage?: GraphQLTypes["FieldMeta"] | undefined,
	sentPayments?: GraphQLTypes["FieldMeta"] | undefined,
	organizationCurrencySums?: GraphQLTypes["FieldMeta"] | undefined,
	organizationSum?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostOrganizationLocale"]: {
	__typename: "PostOrganizationLocale",
	_meta?: GraphQLTypes["PostOrganizationLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	description?: string | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	root?: GraphQLTypes["PostOrganization"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	domain?: GraphQLTypes["Link"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	translatedByAI: boolean
};
	["PostOrganizationLocaleMeta"]: {
	__typename: "PostOrganizationLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	domain?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	translatedByAI?: GraphQLTypes["FieldMeta"] | undefined
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkEnum"],
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["Linkable"] | undefined,
	isTargetBlank: boolean
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	externalLink?: GraphQLTypes["FieldMeta"] | undefined,
	internalLink?: GraphQLTypes["FieldMeta"] | undefined,
	isTargetBlank?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostArea"]: {
	__typename: "PostArea",
	_meta?: GraphQLTypes["PostAreaMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	icon?: GraphQLTypes["Image"] | undefined,
	locales: Array<GraphQLTypes["PostAreaLocale"]>,
	regionListOverride?: GraphQLTypes["DonationAmountsRegionList"] | undefined,
	color?: string | undefined,
	posts: Array<GraphQLTypes["Post"]>,
	specificSymbol: number,
	region?: GraphQLTypes["Region"] | undefined,
	meta?: GraphQLTypes["PostAreaMetaData"] | undefined,
	mobileHeroImage?: GraphQLTypes["Image"] | undefined,
	plainIcon?: GraphQLTypes["Image"] | undefined,
	sentPayments: Array<GraphQLTypes["SentPayment"]>,
	areaSentPaymentCurrencySums: Array<GraphQLTypes["PostAreaSentPaymentCurrencySum"]>,
	areaSentPaymentSum?: GraphQLTypes["PostAreaSentPaymentSum"] | undefined,
	areaCurrencySums: Array<GraphQLTypes["PostAreaCurrencySum"]>,
	areaSum?: GraphQLTypes["PostAreaSum"] | undefined,
	localesByLocale?: GraphQLTypes["PostAreaLocale"] | undefined,
	localesByLink?: GraphQLTypes["PostAreaLocale"] | undefined,
	localesBySeo?: GraphQLTypes["PostAreaLocale"] | undefined,
	localesByBanner?: GraphQLTypes["PostAreaLocale"] | undefined,
	localesByContent?: GraphQLTypes["PostAreaLocale"] | undefined,
	postsBySpecificSymbol?: GraphQLTypes["Post"] | undefined,
	postsByActiveRevision?: GraphQLTypes["Post"] | undefined,
	postsByRevisions?: GraphQLTypes["Post"] | undefined,
	postsByLocales?: GraphQLTypes["Post"] | undefined,
	postsByMeta?: GraphQLTypes["Post"] | undefined,
	postsByFundraiseCurrencySums?: GraphQLTypes["Post"] | undefined,
	postsByFundraiseSum?: GraphQLTypes["Post"] | undefined,
	postsByFundraisingProgress?: GraphQLTypes["Post"] | undefined,
	sentPaymentsByLocales?: GraphQLTypes["SentPayment"] | undefined,
	paginateLocales: GraphQLTypes["PostAreaLocaleConnection"],
	paginatePosts: GraphQLTypes["PostConnection"],
	paginateSentPayments: GraphQLTypes["SentPaymentConnection"],
	paginateAreaSentPaymentCurrencySums: GraphQLTypes["PostAreaSentPaymentCurrencySumConnection"],
	paginateAreaCurrencySums: GraphQLTypes["PostAreaCurrencySumConnection"]
};
	["PostAreaMeta"]: {
	__typename: "PostAreaMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	regionListOverride?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	posts?: GraphQLTypes["FieldMeta"] | undefined,
	specificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	region?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	mobileHeroImage?: GraphQLTypes["FieldMeta"] | undefined,
	plainIcon?: GraphQLTypes["FieldMeta"] | undefined,
	sentPayments?: GraphQLTypes["FieldMeta"] | undefined,
	areaSentPaymentCurrencySums?: GraphQLTypes["FieldMeta"] | undefined,
	areaSentPaymentSum?: GraphQLTypes["FieldMeta"] | undefined,
	areaCurrencySums?: GraphQLTypes["FieldMeta"] | undefined,
	areaSum?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostAreaLocale"]: {
	__typename: "PostAreaLocale",
	_meta?: GraphQLTypes["PostAreaLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	description?: string | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	root?: GraphQLTypes["PostArea"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	banner?: GraphQLTypes["AppBanner"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	translatedByAI: boolean
};
	["PostAreaLocaleMeta"]: {
	__typename: "PostAreaLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	banner?: GraphQLTypes["FieldMeta"] | undefined,
	shortDescription?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	translatedByAI?: GraphQLTypes["FieldMeta"] | undefined
};
	["AppBanner"]: {
	__typename: "AppBanner",
	_meta?: GraphQLTypes["AppBannerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	imageSmall?: GraphQLTypes["Image"] | undefined,
	imageBig?: GraphQLTypes["Image"] | undefined,
	textContent?: GraphQLTypes["Content"] | undefined
};
	["AppBannerMeta"]: {
	__typename: "AppBannerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	imageSmall?: GraphQLTypes["FieldMeta"] | undefined,
	imageBig?: GraphQLTypes["FieldMeta"] | undefined,
	textContent?: GraphQLTypes["FieldMeta"] | undefined
};
	["DonationAmountsRegionList"]: {
	__typename: "DonationAmountsRegionList",
	_meta?: GraphQLTypes["DonationAmountsRegionListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	regions: Array<GraphQLTypes["DonationAmountsRegionItem"]>,
	donation?: GraphQLTypes["Donation"] | undefined,
	regionsByRegion?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	regionsByItems?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	paginateRegions: GraphQLTypes["DonationAmountsRegionItemConnection"]
};
	["DonationAmountsRegionListMeta"]: {
	__typename: "DonationAmountsRegionListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	regions?: GraphQLTypes["FieldMeta"] | undefined,
	donation?: GraphQLTypes["FieldMeta"] | undefined
};
	["DonationAmountsRegionItem"]: {
	__typename: "DonationAmountsRegionItem",
	_meta?: GraphQLTypes["DonationAmountsRegionItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	items: Array<GraphQLTypes["DonationAmountItem"]>,
	list?: GraphQLTypes["DonationAmountsRegionList"] | undefined,
	region?: GraphQLTypes["Region"] | undefined,
	minimumAmount?: number | undefined,
	paginateItems: GraphQLTypes["DonationAmountItemConnection"]
};
	["DonationAmountsRegionItemMeta"]: {
	__typename: "DonationAmountsRegionItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	region?: GraphQLTypes["FieldMeta"] | undefined,
	minimumAmount?: GraphQLTypes["FieldMeta"] | undefined
};
	["DonationAmountItem"]: {
	__typename: "DonationAmountItem",
	_meta?: GraphQLTypes["DonationAmountItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	amount?: number | undefined,
	regionItem?: GraphQLTypes["DonationAmountsRegionItem"] | undefined
};
	["DonationAmountItemMeta"]: {
	__typename: "DonationAmountItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	amount?: GraphQLTypes["FieldMeta"] | undefined,
	regionItem?: GraphQLTypes["FieldMeta"] | undefined
};
	["DonationAmountItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	amount?: GraphQLTypes["OrderDirection"] | undefined,
	regionItem?: GraphQLTypes["DonationAmountsRegionItemOrderBy"] | undefined
};
	["DonationAmountsRegionItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["DonationAmountsRegionListOrderBy"] | undefined,
	region?: GraphQLTypes["RegionOrderBy"] | undefined,
	minimumAmount?: GraphQLTypes["OrderDirection"] | undefined
};
	["Region"]: {
	__typename: "Region",
	_meta?: GraphQLTypes["RegionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	code: string,
	label?: string | undefined,
	currency?: GraphQLTypes["Currency"] | undefined,
	enabledPaymentMethods: Array<GraphQLTypes["RegionPaymentMethod"]>,
	donationItems: Array<GraphQLTypes["DonationAmountsRegionItem"]>,
	timezone?: string | undefined,
	enabledPaymentMethodsByMethod?: GraphQLTypes["RegionPaymentMethod"] | undefined,
	donationItemsByList?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	donationItemsByItems?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	paginateEnabledPaymentMethods: GraphQLTypes["RegionPaymentMethodConnection"],
	paginateDonationItems: GraphQLTypes["DonationAmountsRegionItemConnection"]
};
	["RegionMeta"]: {
	__typename: "RegionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	label?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	enabledPaymentMethods?: GraphQLTypes["FieldMeta"] | undefined,
	donationItems?: GraphQLTypes["FieldMeta"] | undefined,
	timezone?: GraphQLTypes["FieldMeta"] | undefined
};
	["Currency"]: {
	__typename: "Currency",
	_meta?: GraphQLTypes["CurrencyMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	identifier: GraphQLTypes["CurrencyIdentifier"],
	label: string,
	sign: string,
	signAlignment: GraphQLTypes["CurrencySignAlignment"],
	defaultDonationAmount: number,
	rateAgainstCzk: number,
	areaSentPaymentCurrencySums: Array<GraphQLTypes["PostAreaSentPaymentCurrencySum"]>,
	areaCurrencySums: Array<GraphQLTypes["PostAreaCurrencySum"]>,
	organizationCurrencySums: Array<GraphQLTypes["PostOrganizationCurrencySum"]>,
	postCurrencySums: Array<GraphQLTypes["PostCurrencySum"]>,
	paginateAreaSentPaymentCurrencySums: GraphQLTypes["PostAreaSentPaymentCurrencySumConnection"],
	paginateAreaCurrencySums: GraphQLTypes["PostAreaCurrencySumConnection"],
	paginateOrganizationCurrencySums: GraphQLTypes["PostOrganizationCurrencySumConnection"],
	paginatePostCurrencySums: GraphQLTypes["PostCurrencySumConnection"]
};
	["CurrencyMeta"]: {
	__typename: "CurrencyMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	label?: GraphQLTypes["FieldMeta"] | undefined,
	sign?: GraphQLTypes["FieldMeta"] | undefined,
	signAlignment?: GraphQLTypes["FieldMeta"] | undefined,
	defaultDonationAmount?: GraphQLTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FieldMeta"] | undefined,
	areaSentPaymentCurrencySums?: GraphQLTypes["FieldMeta"] | undefined,
	areaCurrencySums?: GraphQLTypes["FieldMeta"] | undefined,
	organizationCurrencySums?: GraphQLTypes["FieldMeta"] | undefined,
	postCurrencySums?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostAreaSentPaymentCurrencySum"]: {
	__typename: "PostAreaSentPaymentCurrencySum",
	_meta?: GraphQLTypes["PostAreaSentPaymentCurrencySumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	currencyIdentifier: string,
	rateAgainstCzk: number,
	totalCents: number,
	currency?: GraphQLTypes["Currency"] | undefined,
	area?: GraphQLTypes["PostArea"] | undefined
};
	["PostAreaSentPaymentCurrencySumMeta"]: {
	__typename: "PostAreaSentPaymentCurrencySumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	currencyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostAreaSentPaymentCurrencySumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	currencyIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined
};
	["PostAreaCurrencySum"]: {
	__typename: "PostAreaCurrencySum",
	_meta?: GraphQLTypes["PostAreaCurrencySumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	currencyIdentifier: string,
	rateAgainstCzk: number,
	totalCents: number,
	currency?: GraphQLTypes["Currency"] | undefined,
	area?: GraphQLTypes["PostArea"] | undefined
};
	["PostAreaCurrencySumMeta"]: {
	__typename: "PostAreaCurrencySumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	currencyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostAreaCurrencySumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	currencyIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined
};
	["PostOrganizationCurrencySum"]: {
	__typename: "PostOrganizationCurrencySum",
	_meta?: GraphQLTypes["PostOrganizationCurrencySumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	currencyIdentifier: string,
	rateAgainstCzk: number,
	totalCents: number,
	currency?: GraphQLTypes["Currency"] | undefined,
	organization?: GraphQLTypes["PostOrganization"] | undefined
};
	["PostOrganizationCurrencySumMeta"]: {
	__typename: "PostOrganizationCurrencySumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	currencyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostOrganizationCurrencySumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	currencyIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined
};
	["PostCurrencySum"]: {
	__typename: "PostCurrencySum",
	_meta?: GraphQLTypes["PostCurrencySumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	currencyIdentifier: string,
	rateAgainstCzk: number,
	totalCents: number,
	currency?: GraphQLTypes["Currency"] | undefined,
	post?: GraphQLTypes["Post"] | undefined
};
	["PostCurrencySumMeta"]: {
	__typename: "PostCurrencySumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	currencyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	rateAgainstCzk?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostCurrencySumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	currencyIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	rateAgainstCzk?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined
};
	["PostAreaSentPaymentCurrencySumConnection"]: {
	__typename: "PostAreaSentPaymentCurrencySumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaSentPaymentCurrencySumEdge"]>
};
	["PostAreaSentPaymentCurrencySumEdge"]: {
	__typename: "PostAreaSentPaymentCurrencySumEdge",
	node: GraphQLTypes["PostAreaSentPaymentCurrencySum"]
};
	["PostAreaCurrencySumConnection"]: {
	__typename: "PostAreaCurrencySumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaCurrencySumEdge"]>
};
	["PostAreaCurrencySumEdge"]: {
	__typename: "PostAreaCurrencySumEdge",
	node: GraphQLTypes["PostAreaCurrencySum"]
};
	["PostOrganizationCurrencySumConnection"]: {
	__typename: "PostOrganizationCurrencySumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostOrganizationCurrencySumEdge"]>
};
	["PostOrganizationCurrencySumEdge"]: {
	__typename: "PostOrganizationCurrencySumEdge",
	node: GraphQLTypes["PostOrganizationCurrencySum"]
};
	["PostCurrencySumConnection"]: {
	__typename: "PostCurrencySumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostCurrencySumEdge"]>
};
	["PostCurrencySumEdge"]: {
	__typename: "PostCurrencySumEdge",
	node: GraphQLTypes["PostCurrencySum"]
};
	["RegionPaymentMethod"]: {
	__typename: "RegionPaymentMethod",
	_meta?: GraphQLTypes["RegionPaymentMethodMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	allowRecurringPayments: boolean,
	region?: GraphQLTypes["Region"] | undefined,
	method: GraphQLTypes["PaymentMethods"],
	order: number
};
	["RegionPaymentMethodMeta"]: {
	__typename: "RegionPaymentMethodMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	allowRecurringPayments?: GraphQLTypes["FieldMeta"] | undefined,
	region?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["RegionPaymentMethodOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	allowRecurringPayments?: GraphQLTypes["OrderDirection"] | undefined,
	region?: GraphQLTypes["RegionOrderBy"] | undefined,
	method?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["RegionEnabledPaymentMethodsByMethodUniqueWhere"]: {
		method?: GraphQLTypes["PaymentMethods"] | undefined
};
	["RegionDonationItemsByListUniqueWhere"]: {
		list?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined
};
	["RegionDonationItemsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["DonationAmountItemUniqueWhere"] | undefined
};
	["RegionPaymentMethodConnection"]: {
	__typename: "RegionPaymentMethodConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RegionPaymentMethodEdge"]>
};
	["RegionPaymentMethodEdge"]: {
	__typename: "RegionPaymentMethodEdge",
	node: GraphQLTypes["RegionPaymentMethod"]
};
	["DonationAmountsRegionItemConnection"]: {
	__typename: "DonationAmountsRegionItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DonationAmountsRegionItemEdge"]>
};
	["DonationAmountsRegionItemEdge"]: {
	__typename: "DonationAmountsRegionItemEdge",
	node: GraphQLTypes["DonationAmountsRegionItem"]
};
	["DonationAmountItemConnection"]: {
	__typename: "DonationAmountItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DonationAmountItemEdge"]>
};
	["DonationAmountItemEdge"]: {
	__typename: "DonationAmountItemEdge",
	node: GraphQLTypes["DonationAmountItem"]
};
	["Donation"]: {
	__typename: "Donation",
	_meta?: GraphQLTypes["DonationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	regionList?: GraphQLTypes["DonationAmountsRegionList"] | undefined
};
	["DonationMeta"]: {
	__typename: "DonationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	regionList?: GraphQLTypes["FieldMeta"] | undefined
};
	["DonationAmountsRegionListRegionsByRegionUniqueWhere"]: {
		region?: GraphQLTypes["RegionUniqueWhere"] | undefined
};
	["DonationAmountsRegionListRegionsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["DonationAmountItemUniqueWhere"] | undefined
};
	["PostAreaMetaData"]: {
	__typename: "PostAreaMetaData",
	_meta?: GraphQLTypes["PostAreaMetaDataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	nameWithFallback: string,
	formattedSpecificSymbol: string,
	fullFormattedSpecificSymbol: string,
	area?: GraphQLTypes["PostArea"] | undefined
};
	["PostAreaMetaDataMeta"]: {
	__typename: "PostAreaMetaDataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	nameWithFallback?: GraphQLTypes["FieldMeta"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined
};
	["SentPayment"]: {
	__typename: "SentPayment",
	_meta?: GraphQLTypes["SentPaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	cents: number,
	sendAt: GraphQLTypes["DateTime"],
	currency?: GraphQLTypes["Currency"] | undefined,
	area?: GraphQLTypes["PostArea"] | undefined,
	organization?: GraphQLTypes["PostOrganization"] | undefined,
	locales: Array<GraphQLTypes["SentPaymentLocale"]>,
	localesByLocale?: GraphQLTypes["SentPaymentLocale"] | undefined,
	paginateLocales: GraphQLTypes["SentPaymentLocaleConnection"]
};
	["SentPaymentMeta"]: {
	__typename: "SentPaymentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	cents?: GraphQLTypes["FieldMeta"] | undefined,
	sendAt?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["SentPaymentLocale"]: {
	__typename: "SentPaymentLocale",
	_meta?: GraphQLTypes["SentPaymentLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	organizationText?: string | undefined,
	root?: GraphQLTypes["SentPayment"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["SentPaymentLocaleMeta"]: {
	__typename: "SentPaymentLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	organizationText?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["SentPaymentLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	organizationText?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["SentPaymentOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["SentPaymentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	cents?: GraphQLTypes["OrderDirection"] | undefined,
	sendAt?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined
};
	["SentPaymentLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["SentPaymentLocaleConnection"]: {
	__typename: "SentPaymentLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SentPaymentLocaleEdge"]>
};
	["SentPaymentLocaleEdge"]: {
	__typename: "SentPaymentLocaleEdge",
	node: GraphQLTypes["SentPaymentLocale"]
};
	["PostAreaSentPaymentSum"]: {
	__typename: "PostAreaSentPaymentSum",
	_meta?: GraphQLTypes["PostAreaSentPaymentSumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalCents: number,
	czkPercentage: number,
	area?: GraphQLTypes["PostArea"] | undefined
};
	["PostAreaSentPaymentSumMeta"]: {
	__typename: "PostAreaSentPaymentSumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	czkPercentage?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostAreaSum"]: {
	__typename: "PostAreaSum",
	_meta?: GraphQLTypes["PostAreaSumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalCents: number,
	czkPercentage: number,
	area?: GraphQLTypes["PostArea"] | undefined
};
	["PostAreaSumMeta"]: {
	__typename: "PostAreaSumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	czkPercentage?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostAreaLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PostAreaLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["PostAreaLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["PostAreaLocalesByBannerUniqueWhere"]: {
		banner?: GraphQLTypes["AppBannerUniqueWhere"] | undefined
};
	["PostAreaLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PostAreaPostsBySpecificSymbolUniqueWhere"]: {
		specificSymbol?: number | undefined
};
	["PostAreaPostsByActiveRevisionUniqueWhere"]: {
		activeRevision?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined
};
	["PostAreaPostsByRevisionsUniqueWhere"]: {
		revisions?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined
};
	["PostAreaPostsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined
};
	["PostAreaPostsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["PostMetaDataUniqueWhere"] | undefined
};
	["PostAreaPostsByFundraiseCurrencySumsUniqueWhere"]: {
		fundraiseCurrencySums?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined
};
	["PostAreaPostsByFundraiseSumUniqueWhere"]: {
		fundraiseSum?: GraphQLTypes["PostSumUniqueWhere"] | undefined
};
	["PostAreaPostsByFundraisingProgressUniqueWhere"]: {
		fundraisingProgress?: GraphQLTypes["PostFundraisingProgressUniqueWhere"] | undefined
};
	["PostAreaSentPaymentsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined
};
	["PostAreaLocaleConnection"]: {
	__typename: "PostAreaLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaLocaleEdge"]>
};
	["PostAreaLocaleEdge"]: {
	__typename: "PostAreaLocaleEdge",
	node: GraphQLTypes["PostAreaLocale"]
};
	["PostConnection"]: {
	__typename: "PostConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostEdge"]>
};
	["PostEdge"]: {
	__typename: "PostEdge",
	node: GraphQLTypes["Post"]
};
	["SentPaymentConnection"]: {
	__typename: "SentPaymentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SentPaymentEdge"]>
};
	["SentPaymentEdge"]: {
	__typename: "SentPaymentEdge",
	node: GraphQLTypes["SentPayment"]
};
	["PostOrganizationMetaData"]: {
	__typename: "PostOrganizationMetaData",
	_meta?: GraphQLTypes["PostOrganizationMetaDataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	nameWithFallback: string,
	formattedSpecificSymbol: string,
	fullFormattedSpecificSymbol: string,
	organization?: GraphQLTypes["PostOrganization"] | undefined
};
	["PostOrganizationMetaDataMeta"]: {
	__typename: "PostOrganizationMetaDataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	nameWithFallback?: GraphQLTypes["FieldMeta"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostOrganizationSum"]: {
	__typename: "PostOrganizationSum",
	_meta?: GraphQLTypes["PostOrganizationSumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalCents: number,
	czkPercentage: number,
	organization?: GraphQLTypes["PostOrganization"] | undefined
};
	["PostOrganizationSumMeta"]: {
	__typename: "PostOrganizationSumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	czkPercentage?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostOrganizationPostsBySpecificSymbolUniqueWhere"]: {
		specificSymbol?: number | undefined
};
	["PostOrganizationPostsByActiveRevisionUniqueWhere"]: {
		activeRevision?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined
};
	["PostOrganizationPostsByRevisionsUniqueWhere"]: {
		revisions?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined
};
	["PostOrganizationPostsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined
};
	["PostOrganizationPostsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["PostMetaDataUniqueWhere"] | undefined
};
	["PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere"]: {
		fundraiseCurrencySums?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined
};
	["PostOrganizationPostsByFundraiseSumUniqueWhere"]: {
		fundraiseSum?: GraphQLTypes["PostSumUniqueWhere"] | undefined
};
	["PostOrganizationPostsByFundraisingProgressUniqueWhere"]: {
		fundraisingProgress?: GraphQLTypes["PostFundraisingProgressUniqueWhere"] | undefined
};
	["PostOrganizationLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PostOrganizationLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["PostOrganizationLocalesByDomainUniqueWhere"]: {
		domain?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["PostOrganizationLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["PostOrganizationLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PostOrganizationSentPaymentsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined
};
	["PostOrganizationLocaleConnection"]: {
	__typename: "PostOrganizationLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostOrganizationLocaleEdge"]>
};
	["PostOrganizationLocaleEdge"]: {
	__typename: "PostOrganizationLocaleEdge",
	node: GraphQLTypes["PostOrganizationLocale"]
};
	["PostRevision"]: {
	__typename: "PostRevision",
	_meta?: GraphQLTypes["PostRevisionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	createdById?: GraphQLTypes["UUID"] | undefined,
	publishedById?: GraphQLTypes["UUID"] | undefined,
	type: GraphQLTypes["PostType"],
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	post?: GraphQLTypes["Post"] | undefined,
	tileImage?: GraphQLTypes["Image"] | undefined,
	tileVideo?: GraphQLTypes["Video"] | undefined,
	heroImage?: GraphQLTypes["Image"] | undefined,
	locales: Array<GraphQLTypes["PostRevisionLocale"]>,
	regionListOverride?: GraphQLTypes["DonationAmountsRegionList"] | undefined,
	isOrganizationVisible: boolean,
	sendPublishNotifications: boolean,
	isArchived: boolean,
	localesByLocale?: GraphQLTypes["PostRevisionLocale"] | undefined,
	localesByContent?: GraphQLTypes["PostRevisionLocale"] | undefined,
	localesBySeo?: GraphQLTypes["PostRevisionLocale"] | undefined,
	localesByLeadContent?: GraphQLTypes["PostRevisionLocale"] | undefined,
	paginateLocales: GraphQLTypes["PostRevisionLocaleConnection"]
};
	["PostRevisionMeta"]: {
	__typename: "PostRevisionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	createdById?: GraphQLTypes["FieldMeta"] | undefined,
	publishedById?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	publishedAt?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined,
	tileImage?: GraphQLTypes["FieldMeta"] | undefined,
	tileVideo?: GraphQLTypes["FieldMeta"] | undefined,
	heroImage?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	regionListOverride?: GraphQLTypes["FieldMeta"] | undefined,
	isOrganizationVisible?: GraphQLTypes["FieldMeta"] | undefined,
	sendPublishNotifications?: GraphQLTypes["FieldMeta"] | undefined,
	isArchived?: GraphQLTypes["FieldMeta"] | undefined
};
	["Video"]: {
	__typename: "Video",
	_meta?: GraphQLTypes["VideoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	poster?: GraphQLTypes["Image"] | undefined,
	shapeType?: GraphQLTypes["VideoShapeType"] | undefined
};
	["VideoMeta"]: {
	__typename: "VideoMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	poster?: GraphQLTypes["FieldMeta"] | undefined,
	shapeType?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostRevisionLocale"]: {
	__typename: "PostRevisionLocale",
	_meta?: GraphQLTypes["PostRevisionLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	root?: GraphQLTypes["PostRevision"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	leadContent?: GraphQLTypes["Content"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI: boolean
};
	["PostRevisionLocaleMeta"]: {
	__typename: "PostRevisionLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	leadContent?: GraphQLTypes["FieldMeta"] | undefined,
	publishNotificationText?: GraphQLTypes["FieldMeta"] | undefined,
	translatedByAI?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostRevisionLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["PostRevisionOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	leadContent?: GraphQLTypes["ContentOrderBy"] | undefined,
	publishNotificationText?: GraphQLTypes["OrderDirection"] | undefined,
	translatedByAI?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostRevisionLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PostRevisionLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PostRevisionLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["PostRevisionLocalesByLeadContentUniqueWhere"]: {
		leadContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PostRevisionLocaleConnection"]: {
	__typename: "PostRevisionLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostRevisionLocaleEdge"]>
};
	["PostRevisionLocaleEdge"]: {
	__typename: "PostRevisionLocaleEdge",
	node: GraphQLTypes["PostRevisionLocale"]
};
	["PostMetaData"]: {
	__typename: "PostMetaData",
	_meta?: GraphQLTypes["PostMetaDataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	titleWithFallback: string,
	formattedSpecificSymbol: string,
	fullFormattedSpecificSymbol: string,
	latestRevision?: GraphQLTypes["PostRevision"] | undefined,
	post?: GraphQLTypes["Post"] | undefined
};
	["PostMetaDataMeta"]: {
	__typename: "PostMetaDataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	titleWithFallback?: GraphQLTypes["FieldMeta"] | undefined,
	formattedSpecificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	fullFormattedSpecificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	latestRevision?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined
};
	["HeroCarousel"]: {
	__typename: "HeroCarousel",
	_meta?: GraphQLTypes["HeroCarouselMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["Date"] | undefined,
	posts: Array<GraphQLTypes["Post"]>,
	items: Array<GraphQLTypes["HeroCarouselItem"]>,
	paginatePosts: GraphQLTypes["PostConnection"],
	paginateItems: GraphQLTypes["HeroCarouselItemConnection"]
};
	["HeroCarouselMeta"]: {
	__typename: "HeroCarouselMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	posts?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["HeroCarouselItem"]: {
	__typename: "HeroCarouselItem",
	_meta?: GraphQLTypes["HeroCarouselItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["Date"] | undefined,
	order: number,
	list?: GraphQLTypes["HeroCarousel"] | undefined,
	item?: GraphQLTypes["Post"] | undefined
};
	["HeroCarouselItemMeta"]: {
	__typename: "HeroCarouselItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined
};
	["HeroCarouselItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["HeroCarouselOrderBy"] | undefined,
	item?: GraphQLTypes["PostOrderBy"] | undefined
};
	["HeroCarouselOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["HeroCarouselItemConnection"]: {
	__typename: "HeroCarouselItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeroCarouselItemEdge"]>
};
	["HeroCarouselItemEdge"]: {
	__typename: "HeroCarouselItemEdge",
	node: GraphQLTypes["HeroCarouselItem"]
};
	["ReportPageLocale"]: {
	__typename: "ReportPageLocale",
	_meta?: GraphQLTypes["ReportPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	root?: GraphQLTypes["ReportPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	posts: Array<GraphQLTypes["Post"]>,
	paginatePosts: GraphQLTypes["PostConnection"]
};
	["ReportPageLocaleMeta"]: {
	__typename: "ReportPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined,
	postTitle?: GraphQLTypes["FieldMeta"] | undefined,
	giftTitle?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	posts?: GraphQLTypes["FieldMeta"] | undefined
};
	["ReportPage"]: {
	__typename: "ReportPage",
	_meta?: GraphQLTypes["ReportPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["ReportPageLocale"]>,
	localesByLocale?: GraphQLTypes["ReportPageLocale"] | undefined,
	localesByLink?: GraphQLTypes["ReportPageLocale"] | undefined,
	localesByContent?: GraphQLTypes["ReportPageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["ReportPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["ReportPageLocaleConnection"]
};
	["ReportPageMeta"]: {
	__typename: "ReportPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["ReportPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ReportPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["ReportPageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["ReportPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["ReportPageLocaleConnection"]: {
	__typename: "ReportPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReportPageLocaleEdge"]>
};
	["ReportPageLocaleEdge"]: {
	__typename: "ReportPageLocaleEdge",
	node: GraphQLTypes["ReportPageLocale"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	primaryText?: GraphQLTypes["OrderDirection"] | undefined,
	block?: GraphQLTypes["ContentBlockOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	video?: GraphQLTypes["VideoOrderBy"] | undefined,
	secondaryText?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	contentAlignment?: GraphQLTypes["OrderDirection"] | undefined,
	valueList?: GraphQLTypes["ValueListOrderBy"] | undefined,
	imageLinkList?: GraphQLTypes["ImageLinkListOrderBy"] | undefined,
	areaList?: GraphQLTypes["PostAreaListOrderBy"] | undefined,
	isAppsVisible?: GraphQLTypes["OrderDirection"] | undefined,
	accordion?: GraphQLTypes["AccordionOrderBy"] | undefined,
	media?: GraphQLTypes["MediumListOrderBy"] | undefined,
	memberList?: GraphQLTypes["MemberListOrderBy"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["OrderDirection"] | undefined,
	isAsideMediaContentMobileLayout?: GraphQLTypes["OrderDirection"] | undefined,
	form?: GraphQLTypes["FormOrderBy"] | undefined,
	isTitleBigger?: GraphQLTypes["OrderDirection"] | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentOrderBy"] | undefined,
	heroCarousel?: GraphQLTypes["HeroCarouselOrderBy"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListOrderBy"] | undefined,
	isCentered?: GraphQLTypes["OrderDirection"] | undefined,
	textImageList?: GraphQLTypes["TextImageListOrderBy"] | undefined
};
	["ContentBlockOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	json?: GraphQLTypes["OrderDirection"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined
};
	["ValueListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["ImageLinkListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostAreaListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["AccordionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["MediumListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["MemberListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["FormOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	tax?: GraphQLTypes["FilledTaxFormOrderBy"] | undefined
};
	["FilledTaxFormOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	publishedAt?: GraphQLTypes["OrderDirection"] | undefined,
	userId?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	vatId?: GraphQLTypes["OrderDirection"] | undefined,
	address1?: GraphQLTypes["OrderDirection"] | undefined,
	address2?: GraphQLTypes["OrderDirection"] | undefined,
	city?: GraphQLTypes["OrderDirection"] | undefined,
	postalCode?: GraphQLTypes["OrderDirection"] | undefined,
	state?: GraphQLTypes["OrderDirection"] | undefined,
	country?: GraphQLTypes["RegionOrderBy"] | undefined,
	dateFrom?: GraphQLTypes["OrderDirection"] | undefined,
	dateTo?: GraphQLTypes["OrderDirection"] | undefined,
	year?: GraphQLTypes["OrderDirection"] | undefined,
	isPdfGenerated?: GraphQLTypes["OrderDirection"] | undefined,
	pdfObjectKey?: GraphQLTypes["OrderDirection"] | undefined
};
	["TextImageListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostSum"]: {
	__typename: "PostSum",
	_meta?: GraphQLTypes["PostSumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalCents: number,
	czkPercentage: number,
	post?: GraphQLTypes["Post"] | undefined
};
	["PostSumMeta"]: {
	__typename: "PostSumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	czkPercentage?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostFundraisingProgress"]: {
	__typename: "PostFundraisingProgress",
	_meta?: GraphQLTypes["PostFundraisingProgressMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	progress?: number | undefined,
	post?: GraphQLTypes["Post"] | undefined
};
	["PostFundraisingProgressMeta"]: {
	__typename: "PostFundraisingProgressMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	progress?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostRevisionsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined
};
	["PostRevisionsByRegionListOverrideUniqueWhere"]: {
		regionListOverride?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined
};
	["PostLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PostLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PostLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["PostLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["PostRevisionConnection"]: {
	__typename: "PostRevisionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostRevisionEdge"]>
};
	["PostRevisionEdge"]: {
	__typename: "PostRevisionEdge",
	node: GraphQLTypes["PostRevision"]
};
	["PostLocaleConnection"]: {
	__typename: "PostLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostLocaleEdge"]>
};
	["PostLocaleEdge"]: {
	__typename: "PostLocaleEdge",
	node: GraphQLTypes["PostLocale"]
};
	["HeroCarouselConnection"]: {
	__typename: "HeroCarouselConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeroCarouselEdge"]>
};
	["HeroCarouselEdge"]: {
	__typename: "HeroCarouselEdge",
	node: GraphQLTypes["HeroCarousel"]
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["GivenGiftsPageLocale"]: {
	__typename: "GivenGiftsPageLocale",
	_meta?: GraphQLTypes["GivenGiftsPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["GivenGiftsPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined
};
	["GivenGiftsPageLocaleMeta"]: {
	__typename: "GivenGiftsPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined,
	giftTitle?: GraphQLTypes["FieldMeta"] | undefined,
	giftText?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["GivenGiftsPage"]: {
	__typename: "GivenGiftsPage",
	_meta?: GraphQLTypes["GivenGiftsPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["GivenGiftsPageLocale"]>,
	localesByLocale?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	localesByContent?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	localesByLink?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["GivenGiftsPageLocaleConnection"]
};
	["GivenGiftsPageMeta"]: {
	__typename: "GivenGiftsPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["GivenGiftsPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["GivenGiftsPageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["GivenGiftsPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["GivenGiftsPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["GivenGiftsPageLocaleConnection"]: {
	__typename: "GivenGiftsPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GivenGiftsPageLocaleEdge"]>
};
	["GivenGiftsPageLocaleEdge"]: {
	__typename: "GivenGiftsPageLocaleEdge",
	node: GraphQLTypes["GivenGiftsPageLocale"]
};
	["ReceivedGiftsPageLocale"]: {
	__typename: "ReceivedGiftsPageLocale",
	_meta?: GraphQLTypes["ReceivedGiftsPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	root?: GraphQLTypes["ReceivedGiftsPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined
};
	["ReceivedGiftsPageLocaleMeta"]: {
	__typename: "ReceivedGiftsPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined,
	giftTitle?: GraphQLTypes["FieldMeta"] | undefined,
	giftText?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined
};
	["ReceivedGiftsPage"]: {
	__typename: "ReceivedGiftsPage",
	_meta?: GraphQLTypes["ReceivedGiftsPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["ReceivedGiftsPageLocale"]>,
	localesByLocale?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	localesByLink?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	localesByContent?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["ReceivedGiftsPageLocaleConnection"]
};
	["ReceivedGiftsPageMeta"]: {
	__typename: "ReceivedGiftsPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["ReceivedGiftsPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["ReceivedGiftsPageLocaleConnection"]: {
	__typename: "ReceivedGiftsPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReceivedGiftsPageLocaleEdge"]>
};
	["ReceivedGiftsPageLocaleEdge"]: {
	__typename: "ReceivedGiftsPageLocaleEdge",
	node: GraphQLTypes["ReceivedGiftsPageLocale"]
};
	["ContentReferenceLinkableItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	item?: GraphQLTypes["LinkableOrderBy"] | undefined,
	reference?: GraphQLTypes["ContentReferenceOrderBy"] | undefined
};
	["ValueList"]: {
	__typename: "ValueList",
	_meta?: GraphQLTypes["ValueListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ValueItem"]>,
	paginateItems: GraphQLTypes["ValueItemConnection"]
};
	["ValueListMeta"]: {
	__typename: "ValueListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["ValueItem"]: {
	__typename: "ValueItem",
	_meta?: GraphQLTypes["ValueItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ValueList"] | undefined,
	item?: GraphQLTypes["Value"] | undefined
};
	["ValueItemMeta"]: {
	__typename: "ValueItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined
};
	["Value"]: {
	__typename: "Value",
	_meta?: GraphQLTypes["ValueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	textContent?: GraphQLTypes["Content"] | undefined
};
	["ValueMeta"]: {
	__typename: "ValueMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	textContent?: GraphQLTypes["FieldMeta"] | undefined
};
	["ValueItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ValueListOrderBy"] | undefined,
	item?: GraphQLTypes["ValueOrderBy"] | undefined
};
	["ValueOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	textContent?: GraphQLTypes["ContentOrderBy"] | undefined
};
	["ValueItemConnection"]: {
	__typename: "ValueItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ValueItemEdge"]>
};
	["ValueItemEdge"]: {
	__typename: "ValueItemEdge",
	node: GraphQLTypes["ValueItem"]
};
	["ImageLinkList"]: {
	__typename: "ImageLinkList",
	_meta?: GraphQLTypes["ImageLinkListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ImageLinkItem"]>,
	paginateItems: GraphQLTypes["ImageLinkItemConnection"]
};
	["ImageLinkListMeta"]: {
	__typename: "ImageLinkListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageLinkItem"]: {
	__typename: "ImageLinkItem",
	_meta?: GraphQLTypes["ImageLinkItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ImageLinkList"] | undefined,
	item?: GraphQLTypes["ImageLink"] | undefined
};
	["ImageLinkItemMeta"]: {
	__typename: "ImageLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageLink"]: {
	__typename: "ImageLink",
	_meta?: GraphQLTypes["ImageLinkMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	image?: GraphQLTypes["Image"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["ImageLinkMeta"]: {
	__typename: "ImageLinkMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageLinkItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ImageLinkListOrderBy"] | undefined,
	item?: GraphQLTypes["ImageLinkOrderBy"] | undefined
};
	["ImageLinkOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["ImageLinkItemConnection"]: {
	__typename: "ImageLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageLinkItemEdge"]>
};
	["ImageLinkItemEdge"]: {
	__typename: "ImageLinkItemEdge",
	node: GraphQLTypes["ImageLinkItem"]
};
	["PostAreaList"]: {
	__typename: "PostAreaList",
	_meta?: GraphQLTypes["PostAreaListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["PostAreaListItem"]>,
	paginateItems: GraphQLTypes["PostAreaListItemConnection"]
};
	["PostAreaListMeta"]: {
	__typename: "PostAreaListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostAreaListItem"]: {
	__typename: "PostAreaListItem",
	_meta?: GraphQLTypes["PostAreaListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["PostAreaList"] | undefined,
	item?: GraphQLTypes["PostArea"] | undefined
};
	["PostAreaListItemMeta"]: {
	__typename: "PostAreaListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostAreaListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["PostAreaListOrderBy"] | undefined,
	item?: GraphQLTypes["PostAreaOrderBy"] | undefined
};
	["PostAreaListItemConnection"]: {
	__typename: "PostAreaListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaListItemEdge"]>
};
	["PostAreaListItemEdge"]: {
	__typename: "PostAreaListItemEdge",
	node: GraphQLTypes["PostAreaListItem"]
};
	["Accordion"]: {
	__typename: "Accordion",
	_meta?: GraphQLTypes["AccordionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["AccordionItem"]>,
	itemsByDescriptionContent?: GraphQLTypes["AccordionItem"] | undefined,
	paginateItems: GraphQLTypes["AccordionItemConnection"]
};
	["AccordionMeta"]: {
	__typename: "AccordionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["AccordionItem"]: {
	__typename: "AccordionItem",
	_meta?: GraphQLTypes["AccordionItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	name: string,
	list?: GraphQLTypes["Accordion"] | undefined,
	descriptionContent?: GraphQLTypes["Content"] | undefined
};
	["AccordionItemMeta"]: {
	__typename: "AccordionItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	descriptionContent?: GraphQLTypes["FieldMeta"] | undefined
};
	["AccordionItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["AccordionOrderBy"] | undefined,
	descriptionContent?: GraphQLTypes["ContentOrderBy"] | undefined
};
	["AccordionItemsByDescriptionContentUniqueWhere"]: {
		descriptionContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["AccordionItemConnection"]: {
	__typename: "AccordionItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AccordionItemEdge"]>
};
	["AccordionItemEdge"]: {
	__typename: "AccordionItemEdge",
	node: GraphQLTypes["AccordionItem"]
};
	["MediumList"]: {
	__typename: "MediumList",
	_meta?: GraphQLTypes["MediumListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["MediumItem"]>,
	paginateItems: GraphQLTypes["MediumItemConnection"]
};
	["MediumListMeta"]: {
	__typename: "MediumListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["MediumItem"]: {
	__typename: "MediumItem",
	_meta?: GraphQLTypes["MediumItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["MediumList"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined
};
	["MediumItemMeta"]: {
	__typename: "MediumItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined
};
	["Medium"]: {
	__typename: "Medium",
	_meta?: GraphQLTypes["MediumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["MediumType"],
	image?: GraphQLTypes["Image"] | undefined,
	video?: GraphQLTypes["Video"] | undefined
};
	["MediumMeta"]: {
	__typename: "MediumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	video?: GraphQLTypes["FieldMeta"] | undefined
};
	["MediumItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["MediumListOrderBy"] | undefined,
	medium?: GraphQLTypes["MediumOrderBy"] | undefined
};
	["MediumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	video?: GraphQLTypes["VideoOrderBy"] | undefined
};
	["MediumItemConnection"]: {
	__typename: "MediumItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumItemEdge"]>
};
	["MediumItemEdge"]: {
	__typename: "MediumItemEdge",
	node: GraphQLTypes["MediumItem"]
};
	["MemberList"]: {
	__typename: "MemberList",
	_meta?: GraphQLTypes["MemberListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["MemberListItem"]>,
	itemsByDescriptionContent?: GraphQLTypes["MemberListItem"] | undefined,
	paginateItems: GraphQLTypes["MemberListItemConnection"]
};
	["MemberListMeta"]: {
	__typename: "MemberListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["MemberListItem"]: {
	__typename: "MemberListItem",
	_meta?: GraphQLTypes["MemberListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	name: string,
	position?: string | undefined,
	list?: GraphQLTypes["MemberList"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	descriptionContent?: GraphQLTypes["Content"] | undefined
};
	["MemberListItemMeta"]: {
	__typename: "MemberListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	position?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	descriptionContent?: GraphQLTypes["FieldMeta"] | undefined
};
	["MemberListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	position?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["MemberListOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	descriptionContent?: GraphQLTypes["ContentOrderBy"] | undefined
};
	["MemberListItemsByDescriptionContentUniqueWhere"]: {
		descriptionContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["MemberListItemConnection"]: {
	__typename: "MemberListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MemberListItemEdge"]>
};
	["MemberListItemEdge"]: {
	__typename: "MemberListItemEdge",
	node: GraphQLTypes["MemberListItem"]
};
	["Form"]: {
	__typename: "Form",
	_meta?: GraphQLTypes["FormMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	type: GraphQLTypes["FormType"],
	tax?: GraphQLTypes["FilledTaxForm"] | undefined
};
	["FormMeta"]: {
	__typename: "FormMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	tax?: GraphQLTypes["FieldMeta"] | undefined
};
	["FilledTaxForm"]: {
	__typename: "FilledTaxForm",
	_meta?: GraphQLTypes["FilledTaxFormMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	publishedAt: GraphQLTypes["DateTime"],
	userId: string,
	email: string,
	name: string,
	vatId: string,
	address1: string,
	address2?: string | undefined,
	city: string,
	postalCode: string,
	state: string,
	country?: GraphQLTypes["Region"] | undefined,
	dateFrom?: GraphQLTypes["Date"] | undefined,
	dateTo?: GraphQLTypes["Date"] | undefined,
	year?: number | undefined,
	isPdfGenerated: boolean,
	pdfObjectKey?: string | undefined
};
	["FilledTaxFormMeta"]: {
	__typename: "FilledTaxFormMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	publishedAt?: GraphQLTypes["FieldMeta"] | undefined,
	userId?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	vatId?: GraphQLTypes["FieldMeta"] | undefined,
	address1?: GraphQLTypes["FieldMeta"] | undefined,
	address2?: GraphQLTypes["FieldMeta"] | undefined,
	city?: GraphQLTypes["FieldMeta"] | undefined,
	postalCode?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	country?: GraphQLTypes["FieldMeta"] | undefined,
	dateFrom?: GraphQLTypes["FieldMeta"] | undefined,
	dateTo?: GraphQLTypes["FieldMeta"] | undefined,
	year?: GraphQLTypes["FieldMeta"] | undefined,
	isPdfGenerated?: GraphQLTypes["FieldMeta"] | undefined,
	pdfObjectKey?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostOrganizationList"]: {
	__typename: "PostOrganizationList",
	_meta?: GraphQLTypes["PostOrganizationListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["PostOrganizationListItem"]>,
	itemsByLink?: GraphQLTypes["PostOrganizationListItem"] | undefined,
	paginateItems: GraphQLTypes["PostOrganizationListItemConnection"]
};
	["PostOrganizationListMeta"]: {
	__typename: "PostOrganizationListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostOrganizationListItem"]: {
	__typename: "PostOrganizationListItem",
	_meta?: GraphQLTypes["PostOrganizationListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["PostOrganizationList"] | undefined,
	item?: GraphQLTypes["PostOrganization"] | undefined,
	type?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["PostOrganizationListItemMeta"]: {
	__typename: "PostOrganizationListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostOrganizationListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["PostOrganizationListOrderBy"] | undefined,
	item?: GraphQLTypes["PostOrganizationOrderBy"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["PostOrganizationListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["PostOrganizationListItemConnection"]: {
	__typename: "PostOrganizationListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostOrganizationListItemEdge"]>
};
	["PostOrganizationListItemEdge"]: {
	__typename: "PostOrganizationListItemEdge",
	node: GraphQLTypes["PostOrganizationListItem"]
};
	["TextImageList"]: {
	__typename: "TextImageList",
	_meta?: GraphQLTypes["TextImageListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["TextImageListItem"]>,
	paginateItems: GraphQLTypes["TextImageListItemConnection"]
};
	["TextImageListMeta"]: {
	__typename: "TextImageListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextImageListItem"]: {
	__typename: "TextImageListItem",
	_meta?: GraphQLTypes["TextImageListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["TextImageList"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	text?: string | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["TextImageListItemMeta"]: {
	__typename: "TextImageListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextImageListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["TextImageListOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["TextImageListItemConnection"]: {
	__typename: "TextImageListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextImageListItemEdge"]>
};
	["TextImageListItemEdge"]: {
	__typename: "TextImageListItemEdge",
	node: GraphQLTypes["TextImageListItem"]
};
	["ContentReferenceLinkablesByItemUniqueWhere"]: {
		item?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["ContentReferenceLinkableItemConnection"]: {
	__typename: "ContentReferenceLinkableItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceLinkableItemEdge"]>
};
	["ContentReferenceLinkableItemEdge"]: {
	__typename: "ContentReferenceLinkableItemEdge",
	node: GraphQLTypes["ContentReferenceLinkableItem"]
};
	["ContentBlockReferencesByLinkablesUniqueWhere"]: {
		linkables?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["ContentBlockReferencesByValueListUniqueWhere"]: {
		valueList?: GraphQLTypes["ValueListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByImageLinkListUniqueWhere"]: {
		imageLinkList?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByAreaListUniqueWhere"]: {
		areaList?: GraphQLTypes["PostAreaListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByAccordionUniqueWhere"]: {
		accordion?: GraphQLTypes["AccordionUniqueWhere"] | undefined
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
		media?: GraphQLTypes["MediumListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByMemberListUniqueWhere"]: {
		memberList?: GraphQLTypes["MemberListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByContentWithoutBlocksUniqueWhere"]: {
		contentWithoutBlocks?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["ContentBlockReferencesByOrganizationListUniqueWhere"]: {
		organizationList?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByTextImageListUniqueWhere"]: {
		textImageList?: GraphQLTypes["TextImageListUniqueWhere"] | undefined
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["HeaderLocale"]: {
	__typename: "HeaderLocale",
	_meta?: GraphQLTypes["HeaderLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["Header"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	links?: GraphQLTypes["LinkList"] | undefined
};
	["HeaderLocaleMeta"]: {
	__typename: "HeaderLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	links?: GraphQLTypes["FieldMeta"] | undefined
};
	["Header"]: {
	__typename: "Header",
	_meta?: GraphQLTypes["HeaderMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	logo?: GraphQLTypes["Image"] | undefined,
	locales: Array<GraphQLTypes["HeaderLocale"]>,
	organizationList?: GraphQLTypes["PostOrganizationList"] | undefined,
	localesByLocale?: GraphQLTypes["HeaderLocale"] | undefined,
	localesByLinks?: GraphQLTypes["HeaderLocale"] | undefined,
	paginateLocales: GraphQLTypes["HeaderLocaleConnection"]
};
	["HeaderMeta"]: {
	__typename: "HeaderMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	organizationList?: GraphQLTypes["FieldMeta"] | undefined
};
	["HeaderLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["HeaderOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	links?: GraphQLTypes["LinkListOrderBy"] | undefined
};
	["HeaderOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	organizationList?: GraphQLTypes["PostOrganizationListOrderBy"] | undefined
};
	["LinkListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["HeaderLocalesByLinksUniqueWhere"]: {
		links?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["HeaderLocaleConnection"]: {
	__typename: "HeaderLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderLocaleEdge"]>
};
	["HeaderLocaleEdge"]: {
	__typename: "HeaderLocaleEdge",
	node: GraphQLTypes["HeaderLocale"]
};
	["LinkList"]: {
	__typename: "LinkList",
	_meta?: GraphQLTypes["LinkListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["LinkItem"]>,
	itemsByLink?: GraphQLTypes["LinkItem"] | undefined,
	paginateItems: GraphQLTypes["LinkItemConnection"]
};
	["LinkListMeta"]: {
	__typename: "LinkListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["LinkItem"]: {
	__typename: "LinkItem",
	_meta?: GraphQLTypes["LinkItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["LinkList"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["LinkItemMeta"]: {
	__typename: "LinkItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["LinkItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["LinkListOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["LinkListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LinkItemConnection"]: {
	__typename: "LinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkItemEdge"]>
};
	["LinkItemEdge"]: {
	__typename: "LinkItemEdge",
	node: GraphQLTypes["LinkItem"]
};
	["FooterLocale"]: {
	__typename: "FooterLocale",
	_meta?: GraphQLTypes["FooterLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	copyright?: string | undefined,
	root?: GraphQLTypes["Footer"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	linkList?: GraphQLTypes["LinkList"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: GraphQLTypes["Content"] | undefined,
	imageLinkList?: GraphQLTypes["ImageLinkList"] | undefined
};
	["FooterLocaleMeta"]: {
	__typename: "FooterLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	copyright?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	linkList?: GraphQLTypes["FieldMeta"] | undefined,
	contactEmail?: GraphQLTypes["FieldMeta"] | undefined,
	addressInfo?: GraphQLTypes["FieldMeta"] | undefined,
	imageLinkList?: GraphQLTypes["FieldMeta"] | undefined
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["FooterLocale"]>,
	logo?: GraphQLTypes["Image"] | undefined,
	localesByLocale?: GraphQLTypes["FooterLocale"] | undefined,
	localesByLinkList?: GraphQLTypes["FooterLocale"] | undefined,
	localesByAddressInfo?: GraphQLTypes["FooterLocale"] | undefined,
	localesByImageLinkList?: GraphQLTypes["FooterLocale"] | undefined,
	paginateLocales: GraphQLTypes["FooterLocaleConnection"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined
};
	["FooterLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	copyright?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["FooterOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	linkList?: GraphQLTypes["LinkListOrderBy"] | undefined,
	contactEmail?: GraphQLTypes["OrderDirection"] | undefined,
	addressInfo?: GraphQLTypes["ContentOrderBy"] | undefined,
	imageLinkList?: GraphQLTypes["ImageLinkListOrderBy"] | undefined
};
	["FooterOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["FooterLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["FooterLocalesByLinkListUniqueWhere"]: {
		linkList?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["FooterLocalesByAddressInfoUniqueWhere"]: {
		addressInfo?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["FooterLocalesByImageLinkListUniqueWhere"]: {
		imageLinkList?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined
};
	["FooterLocaleConnection"]: {
	__typename: "FooterLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLocaleEdge"]>
};
	["FooterLocaleEdge"]: {
	__typename: "FooterLocaleEdge",
	node: GraphQLTypes["FooterLocale"]
};
	["GenericPageAboutSettingsLocale"]: {
	__typename: "GenericPageAboutSettingsLocale",
	_meta?: GraphQLTypes["GenericPageAboutSettingsLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["GenericPageAboutSettings"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	linkGroups: Array<GraphQLTypes["GenericPageAboutGroupLinksLocale"]>,
	linkGroupsByLinkList?: GraphQLTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	paginateLinkGroups: GraphQLTypes["GenericPageAboutGroupLinksLocaleConnection"]
};
	["GenericPageAboutSettingsLocaleMeta"]: {
	__typename: "GenericPageAboutSettingsLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	linkGroups?: GraphQLTypes["FieldMeta"] | undefined
};
	["GenericPageAboutSettings"]: {
	__typename: "GenericPageAboutSettings",
	_meta?: GraphQLTypes["GenericPageAboutSettingsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["GenericPageAboutSettingsLocale"]>,
	localesByLocale?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	localesByLinkGroups?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	paginateLocales: GraphQLTypes["GenericPageAboutSettingsLocaleConnection"]
};
	["GenericPageAboutSettingsMeta"]: {
	__typename: "GenericPageAboutSettingsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["GenericPageAboutSettingsLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["GenericPageAboutSettingsOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["GenericPageAboutSettingsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["GenericPageAboutSettingsLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere"]: {
		linkGroups?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined
};
	["GenericPageAboutSettingsLocaleConnection"]: {
	__typename: "GenericPageAboutSettingsLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageAboutSettingsLocaleEdge"]>
};
	["GenericPageAboutSettingsLocaleEdge"]: {
	__typename: "GenericPageAboutSettingsLocaleEdge",
	node: GraphQLTypes["GenericPageAboutSettingsLocale"]
};
	["GenericPageAboutGroupLinksLocale"]: {
	__typename: "GenericPageAboutGroupLinksLocale",
	_meta?: GraphQLTypes["GenericPageAboutGroupLinksLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	settings?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	linkList?: GraphQLTypes["LinkList"] | undefined
};
	["GenericPageAboutGroupLinksLocaleMeta"]: {
	__typename: "GenericPageAboutGroupLinksLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	settings?: GraphQLTypes["FieldMeta"] | undefined,
	linkList?: GraphQLTypes["FieldMeta"] | undefined
};
	["GenericPageAboutGroupLinksLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	settings?: GraphQLTypes["GenericPageAboutSettingsLocaleOrderBy"] | undefined,
	linkList?: GraphQLTypes["LinkListOrderBy"] | undefined
};
	["GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere"]: {
		linkList?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["GenericPageAboutGroupLinksLocaleConnection"]: {
	__typename: "GenericPageAboutGroupLinksLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageAboutGroupLinksLocaleEdge"]>
};
	["GenericPageAboutGroupLinksLocaleEdge"]: {
	__typename: "GenericPageAboutGroupLinksLocaleEdge",
	node: GraphQLTypes["GenericPageAboutGroupLinksLocale"]
};
	["FeedPageLocale"]: {
	__typename: "FeedPageLocale",
	_meta?: GraphQLTypes["FeedPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["FeedPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	heroTiles?: GraphQLTypes["TileList"] | undefined,
	sectionList: Array<GraphQLTypes["FeedPageSection"]>,
	cardList?: GraphQLTypes["CardList"] | undefined,
	storyGuideList?: GraphQLTypes["StoryGuideList"] | undefined,
	sectionListByTileStripeList?: GraphQLTypes["FeedPageSection"] | undefined,
	paginateSectionList: GraphQLTypes["FeedPageSectionConnection"]
};
	["FeedPageLocaleMeta"]: {
	__typename: "FeedPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	heroTiles?: GraphQLTypes["FieldMeta"] | undefined,
	sectionList?: GraphQLTypes["FieldMeta"] | undefined,
	cardList?: GraphQLTypes["FieldMeta"] | undefined,
	storyGuideList?: GraphQLTypes["FieldMeta"] | undefined
};
	["FeedPage"]: {
	__typename: "FeedPage",
	_meta?: GraphQLTypes["FeedPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["FeedPageLocale"]>,
	localesByLocale?: GraphQLTypes["FeedPageLocale"] | undefined,
	localesByHeroTiles?: GraphQLTypes["FeedPageLocale"] | undefined,
	localesBySectionList?: GraphQLTypes["FeedPageLocale"] | undefined,
	localesByCardList?: GraphQLTypes["FeedPageLocale"] | undefined,
	localesByStoryGuideList?: GraphQLTypes["FeedPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["FeedPageLocaleConnection"]
};
	["FeedPageMeta"]: {
	__typename: "FeedPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["FeedPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["FeedPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	heroTiles?: GraphQLTypes["TileListOrderBy"] | undefined,
	cardList?: GraphQLTypes["CardListOrderBy"] | undefined,
	storyGuideList?: GraphQLTypes["StoryGuideListOrderBy"] | undefined
};
	["FeedPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["TileListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	areaType?: GraphQLTypes["PostAreaOrderBy"] | undefined
};
	["CardListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["StoryGuideListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["FeedPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["FeedPageLocalesByHeroTilesUniqueWhere"]: {
		heroTiles?: GraphQLTypes["TileListUniqueWhere"] | undefined
};
	["FeedPageLocalesBySectionListUniqueWhere"]: {
		sectionList?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined
};
	["FeedPageLocalesByCardListUniqueWhere"]: {
		cardList?: GraphQLTypes["CardListUniqueWhere"] | undefined
};
	["FeedPageLocalesByStoryGuideListUniqueWhere"]: {
		storyGuideList?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined
};
	["FeedPageLocaleConnection"]: {
	__typename: "FeedPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FeedPageLocaleEdge"]>
};
	["FeedPageLocaleEdge"]: {
	__typename: "FeedPageLocaleEdge",
	node: GraphQLTypes["FeedPageLocale"]
};
	["TileList"]: {
	__typename: "TileList",
	_meta?: GraphQLTypes["TileListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	size: GraphQLTypes["TileListSize"],
	title?: string | undefined,
	items: Array<GraphQLTypes["TileItem"]>,
	areaType?: GraphQLTypes["PostArea"] | undefined,
	itemsByLink?: GraphQLTypes["TileItem"] | undefined,
	paginateItems: GraphQLTypes["TileItemConnection"]
};
	["TileListMeta"]: {
	__typename: "TileListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	areaType?: GraphQLTypes["FieldMeta"] | undefined
};
	["TileItem"]: {
	__typename: "TileItem",
	_meta?: GraphQLTypes["TileItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	type: GraphQLTypes["TileItemType"],
	title?: string | undefined,
	description?: string | undefined,
	list?: GraphQLTypes["TileList"] | undefined,
	post?: GraphQLTypes["Post"] | undefined,
	area?: GraphQLTypes["PostArea"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	organization?: GraphQLTypes["PostOrganization"] | undefined
};
	["TileItemMeta"]: {
	__typename: "TileItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined
};
	["TileItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["TileListOrderBy"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined
};
	["TileListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["TileItemConnection"]: {
	__typename: "TileItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TileItemEdge"]>
};
	["TileItemEdge"]: {
	__typename: "TileItemEdge",
	node: GraphQLTypes["TileItem"]
};
	["FeedPageSection"]: {
	__typename: "FeedPageSection",
	_meta?: GraphQLTypes["FeedPageSectionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	feedPageLocale?: GraphQLTypes["FeedPageLocale"] | undefined,
	tileStripeList: Array<GraphQLTypes["FeedPageTileStripe"]>,
	paginateTileStripeList: GraphQLTypes["FeedPageTileStripeConnection"]
};
	["FeedPageSectionMeta"]: {
	__typename: "FeedPageSectionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	feedPageLocale?: GraphQLTypes["FieldMeta"] | undefined,
	tileStripeList?: GraphQLTypes["FieldMeta"] | undefined
};
	["FeedPageTileStripe"]: {
	__typename: "FeedPageTileStripe",
	_meta?: GraphQLTypes["FeedPageTileStripeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	section?: GraphQLTypes["FeedPageSection"] | undefined,
	tileList?: GraphQLTypes["TileList"] | undefined
};
	["FeedPageTileStripeMeta"]: {
	__typename: "FeedPageTileStripeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	section?: GraphQLTypes["FieldMeta"] | undefined,
	tileList?: GraphQLTypes["FieldMeta"] | undefined
};
	["FeedPageTileStripeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	section?: GraphQLTypes["FeedPageSectionOrderBy"] | undefined,
	tileList?: GraphQLTypes["TileListOrderBy"] | undefined
};
	["FeedPageSectionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	feedPageLocale?: GraphQLTypes["FeedPageLocaleOrderBy"] | undefined
};
	["FeedPageTileStripeConnection"]: {
	__typename: "FeedPageTileStripeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FeedPageTileStripeEdge"]>
};
	["FeedPageTileStripeEdge"]: {
	__typename: "FeedPageTileStripeEdge",
	node: GraphQLTypes["FeedPageTileStripe"]
};
	["CardList"]: {
	__typename: "CardList",
	_meta?: GraphQLTypes["CardListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["CardItem"]>,
	itemsByLink?: GraphQLTypes["CardItem"] | undefined,
	paginateItems: GraphQLTypes["CardItemConnection"]
};
	["CardListMeta"]: {
	__typename: "CardListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["CardItem"]: {
	__typename: "CardItem",
	_meta?: GraphQLTypes["CardItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	description?: string | undefined,
	list?: GraphQLTypes["CardList"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["CardItemMeta"]: {
	__typename: "CardItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["CardItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["CardListOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["CardListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["CardItemConnection"]: {
	__typename: "CardItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CardItemEdge"]>
};
	["CardItemEdge"]: {
	__typename: "CardItemEdge",
	node: GraphQLTypes["CardItem"]
};
	["StoryGuideList"]: {
	__typename: "StoryGuideList",
	_meta?: GraphQLTypes["StoryGuideListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["StoryGuideItem"]>,
	paginateItems: GraphQLTypes["StoryGuideItemConnection"]
};
	["StoryGuideListMeta"]: {
	__typename: "StoryGuideListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["StoryGuideItem"]: {
	__typename: "StoryGuideItem",
	_meta?: GraphQLTypes["StoryGuideItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["StoryGuideList"] | undefined,
	guide?: GraphQLTypes["StoryGuide"] | undefined
};
	["StoryGuideItemMeta"]: {
	__typename: "StoryGuideItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	guide?: GraphQLTypes["FieldMeta"] | undefined
};
	["StoryGuide"]: {
	__typename: "StoryGuide",
	_meta?: GraphQLTypes["StoryGuideMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	mediaType: GraphQLTypes["MediaType"],
	title: string,
	subtitle: string,
	image?: GraphQLTypes["Image"] | undefined,
	secondaryImage?: GraphQLTypes["Image"] | undefined
};
	["StoryGuideMeta"]: {
	__typename: "StoryGuideMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	mediaType?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryImage?: GraphQLTypes["FieldMeta"] | undefined
};
	["StoryGuideItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["StoryGuideListOrderBy"] | undefined,
	guide?: GraphQLTypes["StoryGuideOrderBy"] | undefined
};
	["StoryGuideOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	mediaType?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	secondaryImage?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["StoryGuideItemConnection"]: {
	__typename: "StoryGuideItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StoryGuideItemEdge"]>
};
	["StoryGuideItemEdge"]: {
	__typename: "StoryGuideItemEdge",
	node: GraphQLTypes["StoryGuideItem"]
};
	["FeedPageLocaleSectionListByTileStripeListUniqueWhere"]: {
		tileStripeList?: GraphQLTypes["FeedPageTileStripeUniqueWhere"] | undefined
};
	["FeedPageSectionConnection"]: {
	__typename: "FeedPageSectionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FeedPageSectionEdge"]>
};
	["FeedPageSectionEdge"]: {
	__typename: "FeedPageSectionEdge",
	node: GraphQLTypes["FeedPageSection"]
};
	["RecurringPaymentPageLocale"]: {
	__typename: "RecurringPaymentPageLocale",
	_meta?: GraphQLTypes["RecurringPaymentPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["RecurringPaymentPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	favouritePosts?: GraphQLTypes["PostList"] | undefined,
	storyGuideList?: GraphQLTypes["StoryGuideList"] | undefined
};
	["RecurringPaymentPageLocaleMeta"]: {
	__typename: "RecurringPaymentPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	favouritePosts?: GraphQLTypes["FieldMeta"] | undefined,
	storyGuideList?: GraphQLTypes["FieldMeta"] | undefined
};
	["RecurringPaymentPage"]: {
	__typename: "RecurringPaymentPage",
	_meta?: GraphQLTypes["RecurringPaymentPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["RecurringPaymentPageLocale"]>,
	localesByLocale?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	localesByFavouritePosts?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	localesByStoryGuideList?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["RecurringPaymentPageLocaleConnection"]
};
	["RecurringPaymentPageMeta"]: {
	__typename: "RecurringPaymentPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["RecurringPaymentPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["RecurringPaymentPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	favouritePosts?: GraphQLTypes["PostListOrderBy"] | undefined,
	storyGuideList?: GraphQLTypes["StoryGuideListOrderBy"] | undefined
};
	["RecurringPaymentPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["PostListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["RecurringPaymentPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["RecurringPaymentPageLocalesByFavouritePostsUniqueWhere"]: {
		favouritePosts?: GraphQLTypes["PostListUniqueWhere"] | undefined
};
	["RecurringPaymentPageLocalesByStoryGuideListUniqueWhere"]: {
		storyGuideList?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined
};
	["RecurringPaymentPageLocaleConnection"]: {
	__typename: "RecurringPaymentPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RecurringPaymentPageLocaleEdge"]>
};
	["RecurringPaymentPageLocaleEdge"]: {
	__typename: "RecurringPaymentPageLocaleEdge",
	node: GraphQLTypes["RecurringPaymentPageLocale"]
};
	["PostList"]: {
	__typename: "PostList",
	_meta?: GraphQLTypes["PostListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["PostListItem"]>,
	paginateItems: GraphQLTypes["PostListItemConnection"]
};
	["PostListMeta"]: {
	__typename: "PostListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostListItem"]: {
	__typename: "PostListItem",
	_meta?: GraphQLTypes["PostListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["PostList"] | undefined,
	post?: GraphQLTypes["Post"] | undefined
};
	["PostListItemMeta"]: {
	__typename: "PostListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined
};
	["PostListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["PostListOrderBy"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined
};
	["PostListItemConnection"]: {
	__typename: "PostListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostListItemEdge"]>
};
	["PostListItemEdge"]: {
	__typename: "PostListItemEdge",
	node: GraphQLTypes["PostListItem"]
};
	["ScheduledNotificationLocale"]: {
	__typename: "ScheduledNotificationLocale",
	_meta?: GraphQLTypes["ScheduledNotificationLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title: string,
	description: string,
	root?: GraphQLTypes["ScheduledNotification"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ScheduledNotificationLocaleMeta"]: {
	__typename: "ScheduledNotificationLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ScheduledNotification"]: {
	__typename: "ScheduledNotification",
	_meta?: GraphQLTypes["ScheduledNotificationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	localMsFromMidnight: number,
	scheduledDate: GraphQLTypes["Date"],
	internalTitle?: string | undefined,
	target?: GraphQLTypes["NotificationTargetGroup"] | undefined,
	locales: Array<GraphQLTypes["ScheduledNotificationLocale"]>,
	image?: GraphQLTypes["Image"] | undefined,
	completedAt?: GraphQLTypes["DateTime"] | undefined,
	processedNotifications: Array<GraphQLTypes["ProcessedNotificationSource"]>,
	localesByLocale?: GraphQLTypes["ScheduledNotificationLocale"] | undefined,
	processedNotificationsByProcessedNotification?: GraphQLTypes["ProcessedNotificationSource"] | undefined,
	paginateLocales: GraphQLTypes["ScheduledNotificationLocaleConnection"],
	paginateProcessedNotifications: GraphQLTypes["ProcessedNotificationSourceConnection"]
};
	["ScheduledNotificationMeta"]: {
	__typename: "ScheduledNotificationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	localMsFromMidnight?: GraphQLTypes["FieldMeta"] | undefined,
	scheduledDate?: GraphQLTypes["FieldMeta"] | undefined,
	internalTitle?: GraphQLTypes["FieldMeta"] | undefined,
	target?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	completedAt?: GraphQLTypes["FieldMeta"] | undefined,
	processedNotifications?: GraphQLTypes["FieldMeta"] | undefined
};
	["NotificationTargetGroup"]: {
	__typename: "NotificationTargetGroup",
	_meta?: GraphQLTypes["NotificationTargetGroupMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["NotificationTargetType"],
	regions: Array<GraphQLTypes["Region"]>,
	paginateRegions: GraphQLTypes["RegionConnection"]
};
	["NotificationTargetGroupMeta"]: {
	__typename: "NotificationTargetGroupMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	regions?: GraphQLTypes["FieldMeta"] | undefined
};
	["RegionConnection"]: {
	__typename: "RegionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RegionEdge"]>
};
	["RegionEdge"]: {
	__typename: "RegionEdge",
	node: GraphQLTypes["Region"]
};
	["ScheduledNotificationLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ScheduledNotificationOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["ScheduledNotificationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	localMsFromMidnight?: GraphQLTypes["OrderDirection"] | undefined,
	scheduledDate?: GraphQLTypes["OrderDirection"] | undefined,
	internalTitle?: GraphQLTypes["OrderDirection"] | undefined,
	target?: GraphQLTypes["NotificationTargetGroupOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	completedAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["NotificationTargetGroupOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProcessedNotificationSource"]: {
	__typename: "ProcessedNotificationSource",
	_meta?: GraphQLTypes["ProcessedNotificationSourceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ProcessedNotificationSourceType"],
	processedNotification?: GraphQLTypes["ProcessedNotification"] | undefined,
	donationReminderUser?: GraphQLTypes["User"] | undefined,
	scheduledNotification?: GraphQLTypes["ScheduledNotification"] | undefined
};
	["ProcessedNotificationSourceMeta"]: {
	__typename: "ProcessedNotificationSourceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	processedNotification?: GraphQLTypes["FieldMeta"] | undefined,
	donationReminderUser?: GraphQLTypes["FieldMeta"] | undefined,
	scheduledNotification?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProcessedNotification"]: {
	__typename: "ProcessedNotification",
	_meta?: GraphQLTypes["ProcessedNotificationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	topic: string,
	sentAt: GraphQLTypes["DateTime"],
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess: boolean,
	source?: GraphQLTypes["ProcessedNotificationSource"] | undefined,
	title?: string | undefined,
	body?: string | undefined
};
	["ProcessedNotificationMeta"]: {
	__typename: "ProcessedNotificationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	topic?: GraphQLTypes["FieldMeta"] | undefined,
	sentAt?: GraphQLTypes["FieldMeta"] | undefined,
	errorMessage?: GraphQLTypes["FieldMeta"] | undefined,
	errorCode?: GraphQLTypes["FieldMeta"] | undefined,
	isSuccess?: GraphQLTypes["FieldMeta"] | undefined,
	source?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	body?: GraphQLTypes["FieldMeta"] | undefined
};
	["User"]: {
	__typename: "User",
	_meta?: GraphQLTypes["UserMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	tenantPersonId: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email: string,
	name?: string | undefined,
	payments: Array<GraphQLTypes["UserPayment"]>,
	variableSymbol: number,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["Region"] | undefined,
	currency?: GraphQLTypes["Currency"] | undefined,
	recurringPayments: Array<GraphQLTypes["UserRecurringPayment"]>,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations: Array<GraphQLTypes["OnBehalfDonation"]>,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	signedUp?: boolean | undefined,
	devices: Array<GraphQLTypes["Device"]>,
	processedNotifications: Array<GraphQLTypes["ProcessedNotificationSource"]>,
	areaStats: Array<GraphQLTypes["UserAreaStats"]>,
	organizationStats: Array<GraphQLTypes["UserOrganizationStats"]>,
	postStats: Array<GraphQLTypes["UserPostStats"]>,
	currencyStats: Array<GraphQLTypes["UserCurrencyStats"]>,
	stats?: GraphQLTypes["UserStats"] | undefined,
	paymentsByOrder?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByCsobPayment?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByStripePayment?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByMetadata?: GraphQLTypes["UserPayment"] | undefined,
	recurringPaymentsByItems?: GraphQLTypes["UserRecurringPayment"] | undefined,
	recurringPaymentsByMeta?: GraphQLTypes["UserRecurringPayment"] | undefined,
	onBehalfDonationsBySecretCode?: GraphQLTypes["OnBehalfDonation"] | undefined,
	onBehalfDonationsByPayments?: GraphQLTypes["OnBehalfDonation"] | undefined,
	onBehalfDonationsByMeta?: GraphQLTypes["OnBehalfDonation"] | undefined,
	devicesByFcmToken?: GraphQLTypes["Device"] | undefined,
	processedNotificationsByProcessedNotification?: GraphQLTypes["ProcessedNotificationSource"] | undefined,
	paginatePayments: GraphQLTypes["UserPaymentConnection"],
	paginateRecurringPayments: GraphQLTypes["UserRecurringPaymentConnection"],
	paginateOnBehalfDonations: GraphQLTypes["OnBehalfDonationConnection"],
	paginateDevices: GraphQLTypes["DeviceConnection"],
	paginateProcessedNotifications: GraphQLTypes["ProcessedNotificationSourceConnection"],
	paginateAreaStats: GraphQLTypes["UserAreaStatsConnection"],
	paginateOrganizationStats: GraphQLTypes["UserOrganizationStatsConnection"],
	paginatePostStats: GraphQLTypes["UserPostStatsConnection"],
	paginateCurrencyStats: GraphQLTypes["UserCurrencyStatsConnection"]
};
	["UserMeta"]: {
	__typename: "UserMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	tenantPersonId?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	payments?: GraphQLTypes["FieldMeta"] | undefined,
	variableSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	lastActiveAt?: GraphQLTypes["FieldMeta"] | undefined,
	region?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	recurringPayments?: GraphQLTypes["FieldMeta"] | undefined,
	stripeId?: GraphQLTypes["FieldMeta"] | undefined,
	isDeactivated?: GraphQLTypes["FieldMeta"] | undefined,
	onBehalfDonations?: GraphQLTypes["FieldMeta"] | undefined,
	publicProfileSecret?: GraphQLTypes["FieldMeta"] | undefined,
	publicProfileCustomNote?: GraphQLTypes["FieldMeta"] | undefined,
	publicProfileCustomNoteEnabled?: GraphQLTypes["FieldMeta"] | undefined,
	donationConfirmationEmailEnabled?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	signedUp?: GraphQLTypes["FieldMeta"] | undefined,
	devices?: GraphQLTypes["FieldMeta"] | undefined,
	processedNotifications?: GraphQLTypes["FieldMeta"] | undefined,
	areaStats?: GraphQLTypes["FieldMeta"] | undefined,
	organizationStats?: GraphQLTypes["FieldMeta"] | undefined,
	postStats?: GraphQLTypes["FieldMeta"] | undefined,
	currencyStats?: GraphQLTypes["FieldMeta"] | undefined,
	stats?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserPayment"]: {
	__typename: "UserPayment",
	_meta?: GraphQLTypes["UserPaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	cents: number,
	createdAt: GraphQLTypes["DateTime"],
	specificSymbol: string,
	currency?: GraphQLTypes["Currency"] | undefined,
	order?: GraphQLTypes["UserPaymentOrderId"] | undefined,
	csobPayment?: GraphQLTypes["CsobPayment"] | undefined,
	stripePayment?: GraphQLTypes["StripePayment"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	method: GraphQLTypes["UserPaymentMethod"],
	region?: GraphQLTypes["Region"] | undefined,
	user?: GraphQLTypes["User"] | undefined,
	isReusable: boolean,
	onBehalfDonation?: GraphQLTypes["OnBehalfDonation"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentTriesCollection"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful: boolean,
	isFinished: boolean,
	metadata?: GraphQLTypes["UserPaymentMetadata"] | undefined
};
	["UserPaymentMeta"]: {
	__typename: "UserPaymentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	cents?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	specificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	csobPayment?: GraphQLTypes["FieldMeta"] | undefined,
	stripePayment?: GraphQLTypes["FieldMeta"] | undefined,
	recurringPaymentItem?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	region?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	isReusable?: GraphQLTypes["FieldMeta"] | undefined,
	onBehalfDonation?: GraphQLTypes["FieldMeta"] | undefined,
	triesCollection?: GraphQLTypes["FieldMeta"] | undefined,
	successEmailSentAt?: GraphQLTypes["FieldMeta"] | undefined,
	isSuccessful?: GraphQLTypes["FieldMeta"] | undefined,
	isFinished?: GraphQLTypes["FieldMeta"] | undefined,
	metadata?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserPaymentOrderId"]: {
	__typename: "UserPaymentOrderId",
	_meta?: GraphQLTypes["UserPaymentOrderIdMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	seq: number
};
	["UserPaymentOrderIdMeta"]: {
	__typename: "UserPaymentOrderIdMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	seq?: GraphQLTypes["FieldMeta"] | undefined
};
	["CsobPayment"]: {
	__typename: "CsobPayment",
	_meta?: GraphQLTypes["CsobPaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	payId?: string | undefined,
	statusChanges: Array<GraphQLTypes["CsobPaymentStatusChange"]>,
	payment?: GraphQLTypes["UserPayment"] | undefined,
	originalPayId?: string | undefined,
	metadata?: GraphQLTypes["CsobPaymentMetadata"] | undefined,
	paginateStatusChanges: GraphQLTypes["CsobPaymentStatusChangeConnection"]
};
	["CsobPaymentMeta"]: {
	__typename: "CsobPaymentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	payId?: GraphQLTypes["FieldMeta"] | undefined,
	statusChanges?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined,
	originalPayId?: GraphQLTypes["FieldMeta"] | undefined,
	metadata?: GraphQLTypes["FieldMeta"] | undefined
};
	["CsobPaymentStatusChange"]: {
	__typename: "CsobPaymentStatusChange",
	_meta?: GraphQLTypes["CsobPaymentStatusChangeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	dttm?: string | undefined,
	status: number,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	payment?: GraphQLTypes["CsobPayment"] | undefined
};
	["CsobPaymentStatusChangeMeta"]: {
	__typename: "CsobPaymentStatusChangeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	dttm?: GraphQLTypes["FieldMeta"] | undefined,
	status?: GraphQLTypes["FieldMeta"] | undefined,
	resultCode?: GraphQLTypes["FieldMeta"] | undefined,
	message?: GraphQLTypes["FieldMeta"] | undefined,
	authCode?: GraphQLTypes["FieldMeta"] | undefined,
	statusDetail?: GraphQLTypes["FieldMeta"] | undefined,
	actions?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined
};
	["CsobPaymentStatusChangeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	dttm?: GraphQLTypes["OrderDirection"] | undefined,
	status?: GraphQLTypes["OrderDirection"] | undefined,
	resultCode?: GraphQLTypes["OrderDirection"] | undefined,
	message?: GraphQLTypes["OrderDirection"] | undefined,
	authCode?: GraphQLTypes["OrderDirection"] | undefined,
	statusDetail?: GraphQLTypes["OrderDirection"] | undefined,
	actions?: GraphQLTypes["OrderDirection"] | undefined,
	payment?: GraphQLTypes["CsobPaymentOrderBy"] | undefined
};
	["CsobPaymentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	payId?: GraphQLTypes["OrderDirection"] | undefined,
	payment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	originalPayId?: GraphQLTypes["OrderDirection"] | undefined,
	metadata?: GraphQLTypes["CsobPaymentMetadataOrderBy"] | undefined
};
	["UserPaymentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	cents?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	specificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	order?: GraphQLTypes["UserPaymentOrderIdOrderBy"] | undefined,
	csobPayment?: GraphQLTypes["CsobPaymentOrderBy"] | undefined,
	stripePayment?: GraphQLTypes["StripePaymentOrderBy"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItemOrderBy"] | undefined,
	method?: GraphQLTypes["OrderDirection"] | undefined,
	region?: GraphQLTypes["RegionOrderBy"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined,
	isReusable?: GraphQLTypes["OrderDirection"] | undefined,
	onBehalfDonation?: GraphQLTypes["OnBehalfDonationOrderBy"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentTriesCollectionOrderBy"] | undefined,
	successEmailSentAt?: GraphQLTypes["OrderDirection"] | undefined,
	isSuccessful?: GraphQLTypes["OrderDirection"] | undefined,
	isFinished?: GraphQLTypes["OrderDirection"] | undefined,
	metadata?: GraphQLTypes["UserPaymentMetadataOrderBy"] | undefined
};
	["UserPaymentOrderIdOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	seq?: GraphQLTypes["OrderDirection"] | undefined
};
	["StripePaymentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	identifier?: GraphQLTypes["OrderDirection"] | undefined,
	payment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	metadata?: GraphQLTypes["StripePaymentMetadataOrderBy"] | undefined
};
	["StripePaymentMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	status?: GraphQLTypes["OrderDirection"] | undefined,
	isSuccessful?: GraphQLTypes["OrderDirection"] | undefined,
	isFinished?: GraphQLTypes["OrderDirection"] | undefined,
	stripePayment?: GraphQLTypes["StripePaymentOrderBy"] | undefined
};
	["UserRecurringPaymentItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	recurrenceCounter?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	taskId?: GraphQLTypes["OrderDirection"] | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentOrderBy"] | undefined,
	isFailed?: GraphQLTypes["OrderDirection"] | undefined,
	failedEmailSentAt?: GraphQLTypes["OrderDirection"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemMetadataOrderBy"] | undefined
};
	["UserRecurringPaymentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	activeSince?: GraphQLTypes["OrderDirection"] | undefined,
	cancelledAt?: GraphQLTypes["OrderDirection"] | undefined,
	cents?: GraphQLTypes["OrderDirection"] | undefined,
	interval?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined,
	meta?: GraphQLTypes["UpcomingUserRecurringPaymentMetadataOrderBy"] | undefined
};
	["UserOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	tenantPersonId?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	variableSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	lastActiveAt?: GraphQLTypes["OrderDirection"] | undefined,
	region?: GraphQLTypes["RegionOrderBy"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	stripeId?: GraphQLTypes["OrderDirection"] | undefined,
	isDeactivated?: GraphQLTypes["OrderDirection"] | undefined,
	publicProfileSecret?: GraphQLTypes["OrderDirection"] | undefined,
	publicProfileCustomNote?: GraphQLTypes["OrderDirection"] | undefined,
	publicProfileCustomNoteEnabled?: GraphQLTypes["OrderDirection"] | undefined,
	donationConfirmationEmailEnabled?: GraphQLTypes["OrderDirection"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	signedUp?: GraphQLTypes["OrderDirection"] | undefined,
	stats?: GraphQLTypes["UserStatsOrderBy"] | undefined
};
	["UserStatsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalPaymentsSuccessful?: GraphQLTypes["OrderDirection"] | undefined,
	totalPaymentsUnsuccessful?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined
};
	["UpcomingUserRecurringPaymentMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	recurrenceCounter?: GraphQLTypes["OrderDirection"] | undefined,
	isBehindPayments?: GraphQLTypes["OrderDirection"] | undefined,
	nextPaymentDate?: GraphQLTypes["OrderDirection"] | undefined,
	shouldBeProcessed?: GraphQLTypes["OrderDirection"] | undefined,
	firstPayment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	firstSuccessfulPayment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	drivingPayment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentOrderBy"] | undefined
};
	["UserRecurringPaymentItemMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	isSuccessfullyPaid?: GraphQLTypes["OrderDirection"] | undefined,
	shouldBeProcessed?: GraphQLTypes["OrderDirection"] | undefined,
	firstPayment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	lastPayment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	firstSuccessfulPayment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	drivingPayment?: GraphQLTypes["UserPaymentOrderBy"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItemOrderBy"] | undefined
};
	["OnBehalfDonationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	secretCode?: GraphQLTypes["OrderDirection"] | undefined,
	specificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	onBehalfOf?: GraphQLTypes["UserOrderBy"] | undefined,
	meta?: GraphQLTypes["OnBehalfDonationMetadataOrderBy"] | undefined
};
	["OnBehalfDonationMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined,
	onBehalfOfDonation?: GraphQLTypes["OnBehalfDonationOrderBy"] | undefined
};
	["UserPaymentTriesCollectionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	cents?: GraphQLTypes["OrderDirection"] | undefined,
	specificSymbol?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	orderUrl?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	onBehalfDonation?: GraphQLTypes["OnBehalfDonationOrderBy"] | undefined,
	recurring?: GraphQLTypes["UserRecurringPaymentOrderBy"] | undefined,
	metadata?: GraphQLTypes["UserPaymentTriesCollectionMetadataOrderBy"] | undefined,
	medium?: GraphQLTypes["OrderDirection"] | undefined
};
	["UserPaymentTriesCollectionMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentTriesCollectionOrderBy"] | undefined
};
	["UserPaymentMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined,
	organizationUnfiltered?: GraphQLTypes["PostOrganizationOrderBy"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined,
	countToUser?: GraphQLTypes["UserOrderBy"] | undefined,
	paymentType?: GraphQLTypes["OrderDirection"] | undefined,
	statusLabel?: GraphQLTypes["OrderDirection"] | undefined,
	isSuccessful?: GraphQLTypes["OrderDirection"] | undefined,
	isFinished?: GraphQLTypes["OrderDirection"] | undefined,
	needsCacheUpdate?: GraphQLTypes["OrderDirection"] | undefined,
	isSuccessfulNotCached?: GraphQLTypes["OrderDirection"] | undefined,
	isFinishedNotCached?: GraphQLTypes["OrderDirection"] | undefined,
	userPayment?: GraphQLTypes["UserPaymentOrderBy"] | undefined
};
	["CsobPaymentMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	status?: GraphQLTypes["OrderDirection"] | undefined,
	isSuccessful?: GraphQLTypes["OrderDirection"] | undefined,
	isFinished?: GraphQLTypes["OrderDirection"] | undefined,
	resolvedOriginalPayId?: GraphQLTypes["OrderDirection"] | undefined,
	csobPayment?: GraphQLTypes["CsobPaymentOrderBy"] | undefined
};
	["CsobPaymentMetadata"]: {
	__typename: "CsobPaymentMetadata",
	_meta?: GraphQLTypes["CsobPaymentMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	status: number,
	isSuccessful: boolean,
	isFinished: boolean,
	resolvedOriginalPayId?: string | undefined,
	csobPayment?: GraphQLTypes["CsobPayment"] | undefined
};
	["CsobPaymentMetadataMeta"]: {
	__typename: "CsobPaymentMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	status?: GraphQLTypes["FieldMeta"] | undefined,
	isSuccessful?: GraphQLTypes["FieldMeta"] | undefined,
	isFinished?: GraphQLTypes["FieldMeta"] | undefined,
	resolvedOriginalPayId?: GraphQLTypes["FieldMeta"] | undefined,
	csobPayment?: GraphQLTypes["FieldMeta"] | undefined
};
	["CsobPaymentStatusChangeConnection"]: {
	__typename: "CsobPaymentStatusChangeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CsobPaymentStatusChangeEdge"]>
};
	["CsobPaymentStatusChangeEdge"]: {
	__typename: "CsobPaymentStatusChangeEdge",
	node: GraphQLTypes["CsobPaymentStatusChange"]
};
	["StripePayment"]: {
	__typename: "StripePayment",
	_meta?: GraphQLTypes["StripePaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	identifier?: string | undefined,
	statusChanges: Array<GraphQLTypes["StripePaymentStatusChange"]>,
	payment?: GraphQLTypes["UserPayment"] | undefined,
	metadata?: GraphQLTypes["StripePaymentMetadata"] | undefined,
	paginateStatusChanges: GraphQLTypes["StripePaymentStatusChangeConnection"]
};
	["StripePaymentMeta"]: {
	__typename: "StripePaymentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	statusChanges?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined,
	metadata?: GraphQLTypes["FieldMeta"] | undefined
};
	["StripePaymentStatusChange"]: {
	__typename: "StripePaymentStatusChange",
	_meta?: GraphQLTypes["StripePaymentStatusChangeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	payment?: GraphQLTypes["StripePayment"] | undefined,
	timestamp: number,
	eventId: string,
	paymentIntentStatus?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined
};
	["StripePaymentStatusChangeMeta"]: {
	__typename: "StripePaymentStatusChangeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined,
	timestamp?: GraphQLTypes["FieldMeta"] | undefined,
	eventId?: GraphQLTypes["FieldMeta"] | undefined,
	paymentIntentStatus?: GraphQLTypes["FieldMeta"] | undefined
};
	["StripePaymentStatusChangeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	payment?: GraphQLTypes["StripePaymentOrderBy"] | undefined,
	timestamp?: GraphQLTypes["OrderDirection"] | undefined,
	eventId?: GraphQLTypes["OrderDirection"] | undefined,
	paymentIntentStatus?: GraphQLTypes["OrderDirection"] | undefined
};
	["StripePaymentMetadata"]: {
	__typename: "StripePaymentMetadata",
	_meta?: GraphQLTypes["StripePaymentMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	status: number,
	isSuccessful: boolean,
	isFinished: boolean,
	stripePayment?: GraphQLTypes["StripePayment"] | undefined
};
	["StripePaymentMetadataMeta"]: {
	__typename: "StripePaymentMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	status?: GraphQLTypes["FieldMeta"] | undefined,
	isSuccessful?: GraphQLTypes["FieldMeta"] | undefined,
	isFinished?: GraphQLTypes["FieldMeta"] | undefined,
	stripePayment?: GraphQLTypes["FieldMeta"] | undefined
};
	["StripePaymentStatusChangeConnection"]: {
	__typename: "StripePaymentStatusChangeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StripePaymentStatusChangeEdge"]>
};
	["StripePaymentStatusChangeEdge"]: {
	__typename: "StripePaymentStatusChangeEdge",
	node: GraphQLTypes["StripePaymentStatusChange"]
};
	["UserRecurringPaymentItem"]: {
	__typename: "UserRecurringPaymentItem",
	_meta?: GraphQLTypes["UserRecurringPaymentItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	recurrenceCounter: number,
	createdAt: GraphQLTypes["DateTime"],
	taskId?: string | undefined,
	payments: Array<GraphQLTypes["UserPayment"]>,
	recurringPayment?: GraphQLTypes["UserRecurringPayment"] | undefined,
	isFailed: boolean,
	failedEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemMetadata"] | undefined,
	paymentsByOrder?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByCsobPayment?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByStripePayment?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByMetadata?: GraphQLTypes["UserPayment"] | undefined,
	paginatePayments: GraphQLTypes["UserPaymentConnection"]
};
	["UserRecurringPaymentItemMeta"]: {
	__typename: "UserRecurringPaymentItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	recurrenceCounter?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	taskId?: GraphQLTypes["FieldMeta"] | undefined,
	payments?: GraphQLTypes["FieldMeta"] | undefined,
	recurringPayment?: GraphQLTypes["FieldMeta"] | undefined,
	isFailed?: GraphQLTypes["FieldMeta"] | undefined,
	failedEmailSentAt?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserRecurringPayment"]: {
	__typename: "UserRecurringPayment",
	_meta?: GraphQLTypes["UserRecurringPaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	activeSince: GraphQLTypes["DateTime"],
	cancelledAt?: GraphQLTypes["DateTime"] | undefined,
	cents: number,
	interval: GraphQLTypes["UserRecurringPaymentInterval"],
	currency?: GraphQLTypes["Currency"] | undefined,
	items: Array<GraphQLTypes["UserRecurringPaymentItem"]>,
	user?: GraphQLTypes["User"] | undefined,
	meta?: GraphQLTypes["UpcomingUserRecurringPaymentMetadata"] | undefined,
	itemsByRecurrenceCounter?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	itemsByPayments?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	itemsByMeta?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	paginateItems: GraphQLTypes["UserRecurringPaymentItemConnection"]
};
	["UserRecurringPaymentMeta"]: {
	__typename: "UserRecurringPaymentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	activeSince?: GraphQLTypes["FieldMeta"] | undefined,
	cancelledAt?: GraphQLTypes["FieldMeta"] | undefined,
	cents?: GraphQLTypes["FieldMeta"] | undefined,
	interval?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined
};
	["UpcomingUserRecurringPaymentMetadata"]: {
	__typename: "UpcomingUserRecurringPaymentMetadata",
	_meta?: GraphQLTypes["UpcomingUserRecurringPaymentMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	recurrenceCounter: number,
	isBehindPayments: boolean,
	nextPaymentDate: GraphQLTypes["DateTime"],
	shouldBeProcessed: boolean,
	firstPayment?: GraphQLTypes["UserPayment"] | undefined,
	firstSuccessfulPayment?: GraphQLTypes["UserPayment"] | undefined,
	drivingPayment?: GraphQLTypes["UserPayment"] | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPayment"] | undefined
};
	["UpcomingUserRecurringPaymentMetadataMeta"]: {
	__typename: "UpcomingUserRecurringPaymentMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	recurrenceCounter?: GraphQLTypes["FieldMeta"] | undefined,
	isBehindPayments?: GraphQLTypes["FieldMeta"] | undefined,
	nextPaymentDate?: GraphQLTypes["FieldMeta"] | undefined,
	shouldBeProcessed?: GraphQLTypes["FieldMeta"] | undefined,
	firstPayment?: GraphQLTypes["FieldMeta"] | undefined,
	firstSuccessfulPayment?: GraphQLTypes["FieldMeta"] | undefined,
	drivingPayment?: GraphQLTypes["FieldMeta"] | undefined,
	recurringPayment?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere"]: {
		recurrenceCounter?: number | undefined
};
	["UserRecurringPaymentItemsByPaymentsUniqueWhere"]: {
		payments?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined
};
	["UserPaymentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: GraphQLTypes["UserPaymentOrderIdUniqueWhere"] | undefined,
	csobPayment?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined,
	stripePayment?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined,
	metadata?: GraphQLTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentOrderIdUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	seq?: number | undefined
};
	["CsobPaymentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	payId?: string | undefined,
	statusChanges?: GraphQLTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	payment?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	metadata?: GraphQLTypes["CsobPaymentMetadataUniqueWhere"] | undefined
};
	["CsobPaymentStatusChangeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CsobPaymentMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	csobPayment?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined
};
	["StripePaymentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	statusChanges?: GraphQLTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	payment?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	metadata?: GraphQLTypes["StripePaymentMetadataUniqueWhere"] | undefined
};
	["StripePaymentStatusChangeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["StripePaymentMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	stripePayment?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined
};
	["UserPaymentMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	userPayment?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	firstPayment?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	lastPayment?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	recurrenceCounter?: number | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	payments?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	meta?: GraphQLTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined
};
	["UpcomingUserRecurringPaymentMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	firstPayment?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemConnection"]: {
	__typename: "UserRecurringPaymentItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserRecurringPaymentItemEdge"]>
};
	["UserRecurringPaymentItemEdge"]: {
	__typename: "UserRecurringPaymentItemEdge",
	node: GraphQLTypes["UserRecurringPaymentItem"]
};
	["UserRecurringPaymentItemMetadata"]: {
	__typename: "UserRecurringPaymentItemMetadata",
	_meta?: GraphQLTypes["UserRecurringPaymentItemMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	isSuccessfullyPaid: boolean,
	shouldBeProcessed: boolean,
	firstPayment?: GraphQLTypes["UserPayment"] | undefined,
	lastPayment?: GraphQLTypes["UserPayment"] | undefined,
	firstSuccessfulPayment?: GraphQLTypes["UserPayment"] | undefined,
	drivingPayment?: GraphQLTypes["UserPayment"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItem"] | undefined
};
	["UserRecurringPaymentItemMetadataMeta"]: {
	__typename: "UserRecurringPaymentItemMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	isSuccessfullyPaid?: GraphQLTypes["FieldMeta"] | undefined,
	shouldBeProcessed?: GraphQLTypes["FieldMeta"] | undefined,
	firstPayment?: GraphQLTypes["FieldMeta"] | undefined,
	lastPayment?: GraphQLTypes["FieldMeta"] | undefined,
	firstSuccessfulPayment?: GraphQLTypes["FieldMeta"] | undefined,
	drivingPayment?: GraphQLTypes["FieldMeta"] | undefined,
	recurringPaymentItem?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserRecurringPaymentItemPaymentsByOrderUniqueWhere"]: {
		order?: GraphQLTypes["UserPaymentOrderIdUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere"]: {
		csobPayment?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere"]: {
		stripePayment?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemPaymentsByMetadataUniqueWhere"]: {
		metadata?: GraphQLTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentConnection"]: {
	__typename: "UserPaymentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserPaymentEdge"]>
};
	["UserPaymentEdge"]: {
	__typename: "UserPaymentEdge",
	node: GraphQLTypes["UserPayment"]
};
	["OnBehalfDonation"]: {
	__typename: "OnBehalfDonation",
	_meta?: GraphQLTypes["OnBehalfDonationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	secretCode: string,
	specificSymbol: string,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	payments: Array<GraphQLTypes["UserPayment"]>,
	onBehalfOf?: GraphQLTypes["User"] | undefined,
	meta?: GraphQLTypes["OnBehalfDonationMetadata"] | undefined,
	paymentsByOrder?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByCsobPayment?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByStripePayment?: GraphQLTypes["UserPayment"] | undefined,
	paymentsByMetadata?: GraphQLTypes["UserPayment"] | undefined,
	paginatePayments: GraphQLTypes["UserPaymentConnection"]
};
	["OnBehalfDonationMeta"]: {
	__typename: "OnBehalfDonationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	secretCode?: GraphQLTypes["FieldMeta"] | undefined,
	specificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	payments?: GraphQLTypes["FieldMeta"] | undefined,
	onBehalfOf?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined
};
	["OnBehalfDonationMetadata"]: {
	__typename: "OnBehalfDonationMetadata",
	_meta?: GraphQLTypes["OnBehalfDonationMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	area?: GraphQLTypes["PostArea"] | undefined,
	organization?: GraphQLTypes["PostOrganization"] | undefined,
	post?: GraphQLTypes["Post"] | undefined,
	onBehalfOfDonation?: GraphQLTypes["OnBehalfDonation"] | undefined
};
	["OnBehalfDonationMetadataMeta"]: {
	__typename: "OnBehalfDonationMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined,
	onBehalfOfDonation?: GraphQLTypes["FieldMeta"] | undefined
};
	["OnBehalfDonationPaymentsByOrderUniqueWhere"]: {
		order?: GraphQLTypes["UserPaymentOrderIdUniqueWhere"] | undefined
};
	["OnBehalfDonationPaymentsByCsobPaymentUniqueWhere"]: {
		csobPayment?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined
};
	["OnBehalfDonationPaymentsByStripePaymentUniqueWhere"]: {
		stripePayment?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined
};
	["OnBehalfDonationPaymentsByMetadataUniqueWhere"]: {
		metadata?: GraphQLTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentTriesCollection"]: {
	__typename: "UserPaymentTriesCollection",
	_meta?: GraphQLTypes["UserPaymentTriesCollectionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	cents: number,
	specificSymbol: string,
	createdAt: GraphQLTypes["DateTime"],
	orderUrl?: string | undefined,
	payment: Array<GraphQLTypes["UserPayment"]>,
	user?: GraphQLTypes["User"] | undefined,
	currency?: GraphQLTypes["Currency"] | undefined,
	onBehalfDonation?: GraphQLTypes["OnBehalfDonation"] | undefined,
	recurring?: GraphQLTypes["UserRecurringPayment"] | undefined,
	metadata?: GraphQLTypes["UserPaymentTriesCollectionMetadata"] | undefined,
	metadataLocales: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataLocale"]>,
	medium?: GraphQLTypes["PaymentMedium"] | undefined,
	paymentByOrder?: GraphQLTypes["UserPayment"] | undefined,
	paymentByCsobPayment?: GraphQLTypes["UserPayment"] | undefined,
	paymentByStripePayment?: GraphQLTypes["UserPayment"] | undefined,
	paymentByMetadata?: GraphQLTypes["UserPayment"] | undefined,
	metadataLocalesByLocale?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocale"] | undefined,
	paginatePayment: GraphQLTypes["UserPaymentConnection"],
	paginateMetadataLocales: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleConnection"]
};
	["UserPaymentTriesCollectionMeta"]: {
	__typename: "UserPaymentTriesCollectionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	cents?: GraphQLTypes["FieldMeta"] | undefined,
	specificSymbol?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	orderUrl?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	onBehalfDonation?: GraphQLTypes["FieldMeta"] | undefined,
	recurring?: GraphQLTypes["FieldMeta"] | undefined,
	metadata?: GraphQLTypes["FieldMeta"] | undefined,
	metadataLocales?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserPaymentTriesCollectionMetadata"]: {
	__typename: "UserPaymentTriesCollectionMetadata",
	_meta?: GraphQLTypes["UserPaymentTriesCollectionMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	area?: GraphQLTypes["PostArea"] | undefined,
	organization?: GraphQLTypes["PostOrganization"] | undefined,
	post?: GraphQLTypes["Post"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentTriesCollection"] | undefined
};
	["UserPaymentTriesCollectionMetadataMeta"]: {
	__typename: "UserPaymentTriesCollectionMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined,
	triesCollection?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocale"]: {
	__typename: "UserPaymentTriesCollectionMetadataLocale",
	_meta?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locale?: GraphQLTypes["Locale"] | undefined,
	title?: string | undefined,
	parent?: GraphQLTypes["UserPaymentTriesCollection"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleMeta"]: {
	__typename: "UserPaymentTriesCollectionMetadataLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	parent?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	parent?: GraphQLTypes["UserPaymentTriesCollectionOrderBy"] | undefined
};
	["UserPaymentTriesCollectionPaymentByOrderUniqueWhere"]: {
		order?: GraphQLTypes["UserPaymentOrderIdUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere"]: {
		csobPayment?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere"]: {
		stripePayment?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionPaymentByMetadataUniqueWhere"]: {
		metadata?: GraphQLTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleConnection"]: {
	__typename: "UserPaymentTriesCollectionMetadataLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleEdge"]>
};
	["UserPaymentTriesCollectionMetadataLocaleEdge"]: {
	__typename: "UserPaymentTriesCollectionMetadataLocaleEdge",
	node: GraphQLTypes["UserPaymentTriesCollectionMetadataLocale"]
};
	["UserPaymentMetadata"]: {
	__typename: "UserPaymentMetadata",
	_meta?: GraphQLTypes["UserPaymentMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	area?: GraphQLTypes["PostArea"] | undefined,
	organization?: GraphQLTypes["PostOrganization"] | undefined,
	organizationUnfiltered?: GraphQLTypes["PostOrganization"] | undefined,
	post?: GraphQLTypes["Post"] | undefined,
	countToUser?: GraphQLTypes["User"] | undefined,
	paymentType: string,
	statusLabel: string,
	isSuccessful: boolean,
	isFinished: boolean,
	needsCacheUpdate: boolean,
	isSuccessfulNotCached: boolean,
	isFinishedNotCached: boolean,
	userPayment?: GraphQLTypes["UserPayment"] | undefined
};
	["UserPaymentMetadataMeta"]: {
	__typename: "UserPaymentMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined,
	organizationUnfiltered?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined,
	countToUser?: GraphQLTypes["FieldMeta"] | undefined,
	paymentType?: GraphQLTypes["FieldMeta"] | undefined,
	statusLabel?: GraphQLTypes["FieldMeta"] | undefined,
	isSuccessful?: GraphQLTypes["FieldMeta"] | undefined,
	isFinished?: GraphQLTypes["FieldMeta"] | undefined,
	needsCacheUpdate?: GraphQLTypes["FieldMeta"] | undefined,
	isSuccessfulNotCached?: GraphQLTypes["FieldMeta"] | undefined,
	isFinishedNotCached?: GraphQLTypes["FieldMeta"] | undefined,
	userPayment?: GraphQLTypes["FieldMeta"] | undefined
};
	["Device"]: {
	__typename: "Device",
	_meta?: GraphQLTypes["DeviceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	user?: GraphQLTypes["User"] | undefined,
	fcmToken: string,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined
};
	["DeviceMeta"]: {
	__typename: "DeviceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	fcmToken?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	ipAddress?: GraphQLTypes["FieldMeta"] | undefined,
	userAgent?: GraphQLTypes["FieldMeta"] | undefined,
	lastActiveAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeviceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined,
	fcmToken?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	ipAddress?: GraphQLTypes["OrderDirection"] | undefined,
	userAgent?: GraphQLTypes["OrderDirection"] | undefined,
	lastActiveAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProcessedNotificationSourceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationOrderBy"] | undefined,
	donationReminderUser?: GraphQLTypes["UserOrderBy"] | undefined,
	scheduledNotification?: GraphQLTypes["ScheduledNotificationOrderBy"] | undefined
};
	["ProcessedNotificationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	topic?: GraphQLTypes["OrderDirection"] | undefined,
	sentAt?: GraphQLTypes["OrderDirection"] | undefined,
	errorMessage?: GraphQLTypes["OrderDirection"] | undefined,
	errorCode?: GraphQLTypes["OrderDirection"] | undefined,
	isSuccess?: GraphQLTypes["OrderDirection"] | undefined,
	source?: GraphQLTypes["ProcessedNotificationSourceOrderBy"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	body?: GraphQLTypes["OrderDirection"] | undefined
};
	["UserAreaStats"]: {
	__typename: "UserAreaStats",
	_meta?: GraphQLTypes["UserAreaStatsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	area?: GraphQLTypes["PostArea"] | undefined,
	currency?: GraphQLTypes["Currency"] | undefined,
	totalCents: number,
	user?: GraphQLTypes["User"] | undefined
};
	["UserAreaStatsMeta"]: {
	__typename: "UserAreaStatsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserAreaStatsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["PostAreaOrderBy"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined
};
	["UserOrganizationStats"]: {
	__typename: "UserOrganizationStats",
	_meta?: GraphQLTypes["UserOrganizationStatsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	organization?: GraphQLTypes["PostOrganization"] | undefined,
	currency?: GraphQLTypes["Currency"] | undefined,
	totalCents: number,
	user?: GraphQLTypes["User"] | undefined
};
	["UserOrganizationStatsMeta"]: {
	__typename: "UserOrganizationStatsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	organization?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserOrganizationStatsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	organization?: GraphQLTypes["PostOrganizationOrderBy"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined
};
	["UserPostStats"]: {
	__typename: "UserPostStats",
	_meta?: GraphQLTypes["UserPostStatsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	post?: GraphQLTypes["Post"] | undefined,
	currency?: GraphQLTypes["Currency"] | undefined,
	totalCents: number,
	user?: GraphQLTypes["User"] | undefined
};
	["UserPostStatsMeta"]: {
	__typename: "UserPostStatsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserPostStatsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined
};
	["UserCurrencyStats"]: {
	__typename: "UserCurrencyStats",
	_meta?: GraphQLTypes["UserCurrencyStatsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	currency?: GraphQLTypes["Currency"] | undefined,
	totalAmountPaymentsOnce: number,
	totalAmountPaymentsRegular: number,
	user?: GraphQLTypes["User"] | undefined
};
	["UserCurrencyStatsMeta"]: {
	__typename: "UserCurrencyStatsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	currency?: GraphQLTypes["FieldMeta"] | undefined,
	totalAmountPaymentsOnce?: GraphQLTypes["FieldMeta"] | undefined,
	totalAmountPaymentsRegular?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserCurrencyStatsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	currency?: GraphQLTypes["CurrencyOrderBy"] | undefined,
	totalAmountPaymentsOnce?: GraphQLTypes["OrderDirection"] | undefined,
	totalAmountPaymentsRegular?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined
};
	["UserStats"]: {
	__typename: "UserStats",
	_meta?: GraphQLTypes["UserStatsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalPaymentsSuccessful: number,
	totalPaymentsUnsuccessful: number,
	user?: GraphQLTypes["User"] | undefined
};
	["UserStatsMeta"]: {
	__typename: "UserStatsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalPaymentsSuccessful?: GraphQLTypes["FieldMeta"] | undefined,
	totalPaymentsUnsuccessful?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserPaymentsByOrderUniqueWhere"]: {
		order?: GraphQLTypes["UserPaymentOrderIdUniqueWhere"] | undefined
};
	["UserPaymentsByCsobPaymentUniqueWhere"]: {
		csobPayment?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined
};
	["UserPaymentsByStripePaymentUniqueWhere"]: {
		stripePayment?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined
};
	["UserPaymentsByMetadataUniqueWhere"]: {
		metadata?: GraphQLTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined
};
	["UserRecurringPaymentsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined
};
	["UserOnBehalfDonationsBySecretCodeUniqueWhere"]: {
		secretCode?: string | undefined
};
	["UserOnBehalfDonationsByPaymentsUniqueWhere"]: {
		payments?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined
};
	["UserOnBehalfDonationsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined
};
	["OnBehalfDonationMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	onBehalfOfDonation?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined
};
	["OnBehalfDonationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	secretCode?: string | undefined,
	payments?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	meta?: GraphQLTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined
};
	["UserDevicesByFcmTokenUniqueWhere"]: {
		fcmToken?: string | undefined
};
	["UserProcessedNotificationsByProcessedNotificationUniqueWhere"]: {
		processedNotification?: GraphQLTypes["ProcessedNotificationUniqueWhere"] | undefined
};
	["UserRecurringPaymentConnection"]: {
	__typename: "UserRecurringPaymentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserRecurringPaymentEdge"]>
};
	["UserRecurringPaymentEdge"]: {
	__typename: "UserRecurringPaymentEdge",
	node: GraphQLTypes["UserRecurringPayment"]
};
	["OnBehalfDonationConnection"]: {
	__typename: "OnBehalfDonationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OnBehalfDonationEdge"]>
};
	["OnBehalfDonationEdge"]: {
	__typename: "OnBehalfDonationEdge",
	node: GraphQLTypes["OnBehalfDonation"]
};
	["DeviceConnection"]: {
	__typename: "DeviceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeviceEdge"]>
};
	["DeviceEdge"]: {
	__typename: "DeviceEdge",
	node: GraphQLTypes["Device"]
};
	["ProcessedNotificationSourceConnection"]: {
	__typename: "ProcessedNotificationSourceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProcessedNotificationSourceEdge"]>
};
	["ProcessedNotificationSourceEdge"]: {
	__typename: "ProcessedNotificationSourceEdge",
	node: GraphQLTypes["ProcessedNotificationSource"]
};
	["UserAreaStatsConnection"]: {
	__typename: "UserAreaStatsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserAreaStatsEdge"]>
};
	["UserAreaStatsEdge"]: {
	__typename: "UserAreaStatsEdge",
	node: GraphQLTypes["UserAreaStats"]
};
	["UserOrganizationStatsConnection"]: {
	__typename: "UserOrganizationStatsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserOrganizationStatsEdge"]>
};
	["UserOrganizationStatsEdge"]: {
	__typename: "UserOrganizationStatsEdge",
	node: GraphQLTypes["UserOrganizationStats"]
};
	["UserPostStatsConnection"]: {
	__typename: "UserPostStatsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserPostStatsEdge"]>
};
	["UserPostStatsEdge"]: {
	__typename: "UserPostStatsEdge",
	node: GraphQLTypes["UserPostStats"]
};
	["UserCurrencyStatsConnection"]: {
	__typename: "UserCurrencyStatsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserCurrencyStatsEdge"]>
};
	["UserCurrencyStatsEdge"]: {
	__typename: "UserCurrencyStatsEdge",
	node: GraphQLTypes["UserCurrencyStats"]
};
	["ScheduledNotificationLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere"]: {
		processedNotification?: GraphQLTypes["ProcessedNotificationUniqueWhere"] | undefined
};
	["ScheduledNotificationLocaleConnection"]: {
	__typename: "ScheduledNotificationLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ScheduledNotificationLocaleEdge"]>
};
	["ScheduledNotificationLocaleEdge"]: {
	__typename: "ScheduledNotificationLocaleEdge",
	node: GraphQLTypes["ScheduledNotificationLocale"]
};
	["LocaleGeneralsByRootUniqueWhere"]: {
		root?: GraphQLTypes["GeneralUniqueWhere"] | undefined
};
	["LocaleGeneralsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGeneralsByAppStoreLinkUniqueWhere"]: {
		appStoreLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleGeneralsByGooglePlayLinkUniqueWhere"]: {
		googlePlayLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleGenericPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["GenericPageUniqueWhere"] | undefined
};
	["LocaleGenericPagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleGenericPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGenericPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePostsByRootUniqueWhere"]: {
		root?: GraphQLTypes["PostUniqueWhere"] | undefined
};
	["LocalePostsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocalePostsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocalePostsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePostAreasByRootUniqueWhere"]: {
		root?: GraphQLTypes["PostAreaUniqueWhere"] | undefined
};
	["LocalePostAreasByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePostAreasBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocalePostAreasByBannerUniqueWhere"]: {
		banner?: GraphQLTypes["AppBannerUniqueWhere"] | undefined
};
	["LocalePostAreasByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocalePostOrganizationsByRootUniqueWhere"]: {
		root?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined
};
	["LocalePostOrganizationsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePostOrganizationsByDomainUniqueWhere"]: {
		domain?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocalePostOrganizationsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocalePostOrganizationsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleHeadersByRootUniqueWhere"]: {
		root?: GraphQLTypes["HeaderUniqueWhere"] | undefined
};
	["LocaleHeadersByLinksUniqueWhere"]: {
		links?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["LocaleFootersByRootUniqueWhere"]: {
		root?: GraphQLTypes["FooterUniqueWhere"] | undefined
};
	["LocaleFootersByLinkListUniqueWhere"]: {
		linkList?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["LocaleFootersByAddressInfoUniqueWhere"]: {
		addressInfo?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleFootersByImageLinkListUniqueWhere"]: {
		imageLinkList?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined
};
	["LocaleGenericPageAboutSettingsByRootUniqueWhere"]: {
		root?: GraphQLTypes["GenericPageAboutSettingsUniqueWhere"] | undefined
};
	["LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere"]: {
		linkGroups?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined
};
	["LocalePostRevisionsByRootUniqueWhere"]: {
		root?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined
};
	["LocalePostRevisionsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocalePostRevisionsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocalePostRevisionsByLeadContentUniqueWhere"]: {
		leadContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleFeedPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["FeedPageUniqueWhere"] | undefined
};
	["LocaleFeedPagesByHeroTilesUniqueWhere"]: {
		heroTiles?: GraphQLTypes["TileListUniqueWhere"] | undefined
};
	["LocaleFeedPagesBySectionListUniqueWhere"]: {
		sectionList?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined
};
	["LocaleFeedPagesByCardListUniqueWhere"]: {
		cardList?: GraphQLTypes["CardListUniqueWhere"] | undefined
};
	["LocaleFeedPagesByStoryGuideListUniqueWhere"]: {
		storyGuideList?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined
};
	["LocaleRecurringPaymentPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["RecurringPaymentPageUniqueWhere"] | undefined
};
	["LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere"]: {
		favouritePosts?: GraphQLTypes["PostListUniqueWhere"] | undefined
};
	["LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere"]: {
		storyGuideList?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined
};
	["LocaleGivenGiftsPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["GivenGiftsPageUniqueWhere"] | undefined
};
	["LocaleGivenGiftsPagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleGivenGiftsPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGivenGiftsPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleReceivedGiftsPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["ReceivedGiftsPageUniqueWhere"] | undefined
};
	["LocaleReceivedGiftsPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleReceivedGiftsPagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleReceivedGiftsPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleReportPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["ReportPageUniqueWhere"] | undefined
};
	["LocaleReportPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleReportPagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleReportPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleReportNavigationsByRootUniqueWhere"]: {
		root?: GraphQLTypes["ReportNavigationUniqueWhere"] | undefined
};
	["LocaleScheduledNotificationsByRootUniqueWhere"]: {
		root?: GraphQLTypes["ScheduledNotificationUniqueWhere"] | undefined
};
	["LocaleSentPaymentsByRootUniqueWhere"]: {
		root?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined
};
	["GeneralLocaleConnection"]: {
	__typename: "GeneralLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GeneralLocaleEdge"]>
};
	["GeneralLocaleEdge"]: {
	__typename: "GeneralLocaleEdge",
	node: GraphQLTypes["GeneralLocale"]
};
	["GeneralLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["GeneralLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["GeneralLocalesByAppStoreLinkUniqueWhere"]: {
		appStoreLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["GeneralLocalesByGooglePlayLinkUniqueWhere"]: {
		googlePlayLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["GeneralConnection"]: {
	__typename: "GeneralConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GeneralEdge"]>
};
	["GeneralEdge"]: {
	__typename: "GeneralEdge",
	node: GraphQLTypes["General"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
        	__typename:"_FieldPathFragment" | "_IndexPathFragment"
        	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string | undefined
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["GeneralCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["GeneralCreateLocalesEntityRelationInput"]> | undefined,
	allAreasIcon?: GraphQLTypes["GeneralCreateAllAreasIconEntityRelationInput"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["GeneralCreateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GeneralLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GeneralLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	appStoreLink?: GraphQLTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: GraphQLTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGeneralsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGeneralsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateGenericPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateGenericPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GenericPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	reportNavigation?: Array<GraphQLTypes["GenericPageCreateReportNavigationEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageCreateReportNavigationEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateReportNavigationRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationLocaleWithoutPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportNavigationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportNavigationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ReportNavigationWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["ReportNavigationUniqueWhere"],
	create: GraphQLTypes["ReportNavigationWithoutLocalesCreateInput"]
};
	["ReportNavigationLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutReportNavigationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutReportNavigationsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateGeneralsEntityRelationInput"]: {
		connect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateGeneralsRelationInput"] | undefined,
	alias?: string | undefined
};
	["GeneralLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	appStoreLink?: GraphQLTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: GraphQLTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GeneralUniqueWhere"] | undefined,
	create?: GraphQLTypes["GeneralWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GeneralWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	allAreasIcon?: GraphQLTypes["GeneralCreateAllAreasIconEntityRelationInput"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["GeneralCreateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralCreateAllAreasIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralConnectOrCreateAllAreasIconRelationInput"] | undefined
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralConnectOrCreateAllAreasIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["GeneralCreateAllOrganizationsIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"] | undefined
};
	["GeneralConnectOrCreateAllOrganizationsIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["GeneralCreateOrganizationListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralConnectOrCreateOrganizationListRelationInput"] | undefined
};
	["PostOrganizationListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["PostOrganizationListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	item?: GraphQLTypes["PostOrganizationListItemCreateItemEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	link?: GraphQLTypes["PostOrganizationListItemCreateLinkEntityRelationInput"] | undefined,
	image?: GraphQLTypes["PostOrganizationListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemCreateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"] | undefined
};
	["PostOrganizationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	posts?: Array<GraphQLTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined,
	icon?: GraphQLTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: GraphQLTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: GraphQLTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationCreatePostsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutOrganizationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutOrganizationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	area?: GraphQLTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateAreaRelationInput"] | undefined
};
	["PostAreaWithoutPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: GraphQLTypes["PostAreaCreateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	specificSymbol?: number | undefined,
	region?: GraphQLTypes["PostAreaCreateRegionEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostAreaCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: GraphQLTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<GraphQLTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: GraphQLTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateIconRelationInput"] | undefined
};
	["PostAreaConnectOrCreateIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostAreaCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostAreaLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutPostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutPostAreaCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined
};
	["GenericPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGenericPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGenericPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreatePostsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	content?: GraphQLTypes["PostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostLocaleCreateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentConnectOrCreateBlocksRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	contentAlignment?: GraphQLTypes["ContentAlignment"] | undefined,
	valueList?: GraphQLTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined,
	areaList?: GraphQLTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: GraphQLTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	memberList?: GraphQLTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: GraphQLTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: GraphQLTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	posts?: Array<GraphQLTypes["ContentReferenceCreatePostsEntityRelationInput"]> | undefined,
	textImageList?: GraphQLTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateLinkablesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined
};
	["VideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["VideoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	poster?: GraphQLTypes["VideoCreatePosterEntityRelationInput"] | undefined,
	shapeType?: GraphQLTypes["VideoShapeType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoCreatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["VideoConnectOrCreatePosterRelationInput"] | undefined
};
	["VideoConnectOrCreatePosterRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
		connect: GraphQLTypes["VideoUniqueWhere"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["LinkEnum"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined,
	isTargetBlank?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreatePostRelationInput"] | undefined
};
	["PostLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	content?: GraphQLTypes["PostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostLocaleCreateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PostLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreatePostAreasEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreatePostAreasRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostAreaLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["PostAreaWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: GraphQLTypes["PostAreaCreateIconEntityRelationInput"] | undefined,
	regionListOverride?: GraphQLTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<GraphQLTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: GraphQLTypes["PostAreaCreateRegionEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostAreaCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: GraphQLTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<GraphQLTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: GraphQLTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaCreateRegionListOverrideEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"] | undefined
};
	["DonationAmountsRegionListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	regions?: Array<GraphQLTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"]> | undefined,
	donation?: GraphQLTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListCreateRegionsEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["DonationAmountsRegionItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	items?: Array<GraphQLTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined,
	region?: GraphQLTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountItemWithoutRegionItemCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["DonationAmountItemWithoutRegionItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	amount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["DonationAmountItemUniqueWhere"],
	create: GraphQLTypes["DonationAmountItemWithoutRegionItemCreateInput"]
};
	["DonationAmountsRegionItemCreateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionWithoutDonationItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"] | undefined
};
	["RegionWithoutDonationItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: GraphQLTypes["RegionCreateCurrencyEntityRelationInput"] | undefined,
	enabledPaymentMethods?: Array<GraphQLTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionCreateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RegionConnectOrCreateCurrencyRelationInput"] | undefined
};
	["CurrencyUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: GraphQLTypes["CurrencyIdentifier"] | undefined,
	areaSentPaymentCurrencySums?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	areaCurrencySums?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	organizationCurrencySums?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	postCurrencySums?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined
};
	["CurrencyCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: GraphQLTypes["CurrencyIdentifier"] | undefined,
	label?: string | undefined,
	sign?: string | undefined,
	signAlignment?: GraphQLTypes["CurrencySignAlignment"] | undefined,
	defaultDonationAmount?: number | undefined,
	rateAgainstCzk?: number | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaCurrencySums?: Array<GraphQLTypes["CurrencyCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	postCurrencySums?: Array<GraphQLTypes["CurrencyCreatePostCurrencySumsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyCreateAreaCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyCreatePostCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RegionConnectOrCreateCurrencyRelationInput"]: {
		connect: GraphQLTypes["CurrencyUniqueWhere"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["RegionCreateEnabledPaymentMethodsEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionPaymentMethodWithoutRegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"] | undefined,
	alias?: string | undefined
};
	["RegionPaymentMethodWithoutRegionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	allowRecurringPayments?: boolean | undefined,
	method?: GraphQLTypes["PaymentMethods"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"]: {
		connect: GraphQLTypes["RegionPaymentMethodUniqueWhere"],
	create: GraphQLTypes["RegionPaymentMethodWithoutRegionCreateInput"]
};
	["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionWithoutDonationItemsCreateInput"]
};
	["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"]: {
		connect: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"],
	create: GraphQLTypes["DonationAmountsRegionItemWithoutListCreateInput"]
};
	["DonationAmountsRegionListCreateDonationEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationWithoutRegionListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"] | undefined
};
	["DonationWithoutRegionListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListConnectOrCreateDonationRelationInput"]: {
		connect: GraphQLTypes["DonationUniqueWhere"],
	create: GraphQLTypes["DonationWithoutRegionListCreateInput"]
};
	["PostAreaConnectOrCreateRegionListOverrideRelationInput"]: {
		connect: GraphQLTypes["DonationAmountsRegionListUniqueWhere"],
	create: GraphQLTypes["DonationAmountsRegionListCreateInput"]
};
	["PostAreaCreatePostsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutAreaCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateOrganizationEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateOrganizationRelationInput"] | undefined
};
	["PostOrganizationWithoutPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: GraphQLTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: GraphQLTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: GraphQLTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateIconRelationInput"] | undefined
};
	["PostOrganizationConnectOrCreateIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined,
	domain?: GraphQLTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutPostOrganizationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutPostOrganizationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreatePostAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreatePostAreaRelationInput"] | undefined
};
	["PostAreaLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPostAreasCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutPostAreasCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreatePostOrganizationsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreatePostOrganizationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined,
	domain?: GraphQLTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["PostOrganizationWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	posts?: Array<GraphQLTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined,
	icon?: GraphQLTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	area?: GraphQLTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: GraphQLTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationCreateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateAreaRelationInput"] | undefined
};
	["PostAreaCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: GraphQLTypes["PostAreaCreateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<GraphQLTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: GraphQLTypes["PostAreaCreateRegionEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostAreaCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: GraphQLTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostAreaCreateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<GraphQLTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: GraphQLTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaCreateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateRegionRelationInput"] | undefined
};
	["RegionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: GraphQLTypes["RegionCreateCurrencyEntityRelationInput"] | undefined,
	enabledPaymentMethods?: Array<GraphQLTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"]> | undefined,
	donationItems?: Array<GraphQLTypes["RegionCreateDonationItemsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionCreateDonationItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RegionConnectOrCreateDonationItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["DonationAmountsRegionItemWithoutRegionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	items?: Array<GraphQLTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined,
	list?: GraphQLTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"] | undefined
};
	["DonationAmountsRegionListWithoutRegionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	donation?: GraphQLTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["DonationAmountsRegionListUniqueWhere"],
	create: GraphQLTypes["DonationAmountsRegionListWithoutRegionsCreateInput"]
};
	["RegionConnectOrCreateDonationItemsRelationInput"]: {
		connect: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"],
	create: GraphQLTypes["DonationAmountsRegionItemWithoutRegionCreateInput"]
};
	["PostAreaConnectOrCreateRegionRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["PostAreaCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaMetaDataUniqueWhere"] | undefined
};
	["PostAreaCreateMobileHeroImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"] | undefined
};
	["PostAreaConnectOrCreateMobileHeroImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostAreaCreatePlainIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreatePlainIconRelationInput"] | undefined
};
	["PostAreaConnectOrCreatePlainIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostAreaCreateSentPaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["SentPaymentWithoutAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateSentPaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SentPaymentWithoutAreaCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: GraphQLTypes["DateTime"] | undefined,
	currency?: GraphQLTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentCreateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentConnectOrCreateCurrencyRelationInput"] | undefined
};
	["SentPaymentConnectOrCreateCurrencyRelationInput"]: {
		connect: GraphQLTypes["CurrencyUniqueWhere"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["SentPaymentCreateOrganizationEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentConnectOrCreateOrganizationRelationInput"] | undefined
};
	["PostOrganizationWithoutSentPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	posts?: Array<GraphQLTypes["PostOrganizationCreatePostsEntityRelationInput"]> | undefined,
	icon?: GraphQLTypes["PostOrganizationCreateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostOrganizationCreateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: GraphQLTypes["PostOrganizationCreateAreaEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostOrganizationCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["PostOrganizationCreatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: GraphQLTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"] | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationMetaDataUniqueWhere"] | undefined
};
	["PostOrganizationCreateMobileHeroImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"] | undefined
};
	["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationCreatePlainIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"] | undefined
};
	["PostOrganizationConnectOrCreatePlainIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationCreateDesktopHeroImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"] | undefined
};
	["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationCreateOrganizationSumEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationSumUniqueWhere"] | undefined
};
	["SentPaymentConnectOrCreateOrganizationRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationUniqueWhere"],
	create: GraphQLTypes["PostOrganizationWithoutSentPaymentsCreateInput"]
};
	["SentPaymentCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["SentPaymentLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["SentPaymentLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organizationText?: string | undefined,
	locale?: GraphQLTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutSentPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateHeadersEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateHeadersRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined,
	links?: GraphQLTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["HeaderWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["HeaderCreateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined
};
	["HeaderConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HeaderCreateOrganizationListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateOrganizationListRelationInput"] | undefined
};
	["HeaderConnectOrCreateOrganizationListRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationListUniqueWhere"],
	create: GraphQLTypes["PostOrganizationListCreateInput"]
};
	["HeaderLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["HeaderUniqueWhere"],
	create: GraphQLTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLinksRelationInput"] | undefined
};
	["LinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["LinkListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["LinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	link?: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkItemConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkItemConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LinkListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["LinkItemUniqueWhere"],
	create: GraphQLTypes["LinkItemWithoutListCreateInput"]
};
	["HeaderLocaleConnectOrCreateLinksRelationInput"]: {
		connect: GraphQLTypes["LinkListUniqueWhere"],
	create: GraphQLTypes["LinkListCreateInput"]
};
	["LocaleConnectOrCreateHeadersRelationInput"]: {
		connect: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateFootersEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateFootersRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	copyright?: string | undefined,
	root?: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined,
	linkList?: GraphQLTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: GraphQLTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["FooterWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	logo?: GraphQLTypes["FooterCreateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterConnectOrCreateLogoRelationInput"] | undefined
};
	["FooterConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["FooterUniqueWhere"],
	create: GraphQLTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleCreateLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateLinkListRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateLinkListRelationInput"]: {
		connect: GraphQLTypes["LinkListUniqueWhere"],
	create: GraphQLTypes["LinkListCreateInput"]
};
	["FooterLocaleCreateAddressInfoEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateAddressInfoRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["FooterLocaleCreateImageLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"] | undefined
};
	["ImageLinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ImageLinkListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ImageLinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	item?: GraphQLTypes["ImageLinkItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemCreateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkItemConnectOrCreateItemRelationInput"] | undefined
};
	["ImageLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ImageLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	image?: GraphQLTypes["ImageLinkCreateImageEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ImageLinkCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkConnectOrCreateImageRelationInput"] | undefined
};
	["ImageLinkConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ImageLinkCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkConnectOrCreateLinkRelationInput"] | undefined
};
	["ImageLinkConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["ImageLinkItemConnectOrCreateItemRelationInput"]: {
		connect: GraphQLTypes["ImageLinkUniqueWhere"],
	create: GraphQLTypes["ImageLinkCreateInput"]
};
	["ImageLinkListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ImageLinkItemUniqueWhere"],
	create: GraphQLTypes["ImageLinkItemWithoutListCreateInput"]
};
	["FooterLocaleConnectOrCreateImageLinkListRelationInput"]: {
		connect: GraphQLTypes["ImageLinkListUniqueWhere"],
	create: GraphQLTypes["ImageLinkListCreateInput"]
};
	["LocaleConnectOrCreateFootersRelationInput"]: {
		connect: GraphQLTypes["FooterLocaleUniqueWhere"],
	create: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined,
	linkGroups?: Array<GraphQLTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageAboutSettingsUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GenericPageAboutSettingsWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["GenericPageAboutSettingsUniqueWhere"],
	create: GraphQLTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"]
};
	["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	linkList?: GraphQLTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"] | undefined
};
	["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"]: {
		connect: GraphQLTypes["LinkListUniqueWhere"],
	create: GraphQLTypes["LinkListCreateInput"]
};
	["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"]: {
		connect: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]
};
	["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"]: {
		connect: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreatePostRevisionsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreatePostRevisionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostRevisionLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["PostRevisionLocaleCreateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined,
	leadContent?: GraphQLTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostRevisionWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["PostRevisionWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	createdById?: GraphQLTypes["UUID"] | undefined,
	publishedById?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["PostType"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	post?: GraphQLTypes["PostRevisionCreatePostEntityRelationInput"] | undefined,
	tileImage?: GraphQLTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined,
	tileVideo?: GraphQLTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined,
	heroImage?: GraphQLTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined,
	regionListOverride?: GraphQLTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionCreatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutRevisionsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreatePostRelationInput"] | undefined
};
	["PostWithoutRevisionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateActiveRevisionEntityRelationInput"]: {
		connect?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostRevisionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateActiveRevisionRelationInput"] | undefined
};
	["PostRevisionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	createdById?: GraphQLTypes["UUID"] | undefined,
	publishedById?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["PostType"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	post?: GraphQLTypes["PostRevisionCreatePostEntityRelationInput"] | undefined,
	tileImage?: GraphQLTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined,
	tileVideo?: GraphQLTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined,
	heroImage?: GraphQLTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostRevisionCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionCreateTileImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateTileImageRelationInput"] | undefined
};
	["PostRevisionConnectOrCreateTileImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostRevisionCreateTileVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateTileVideoRelationInput"] | undefined
};
	["PostRevisionConnectOrCreateTileVideoRelationInput"]: {
		connect: GraphQLTypes["VideoUniqueWhere"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["PostRevisionCreateHeroImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateHeroImageRelationInput"] | undefined
};
	["PostRevisionConnectOrCreateHeroImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostRevisionCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostRevisionLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostRevisionLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: GraphQLTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined,
	leadContent?: GraphQLTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPostRevisionsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutPostRevisionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateFlagImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateFlagImageRelationInput"] | undefined
};
	["LocaleConnectOrCreateFlagImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleCreateFeedPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateFeedPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["FeedPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined,
	heroTiles?: GraphQLTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<GraphQLTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined,
	cardList?: GraphQLTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["FeedPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["FeedPageUniqueWhere"],
	create: GraphQLTypes["FeedPageWithoutLocalesCreateInput"]
};
	["FeedPageLocaleCreateHeroTilesEntityRelationInput"]: {
		connect?: GraphQLTypes["TileListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TileListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"] | undefined
};
	["TileListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	size?: GraphQLTypes["TileListSize"] | undefined,
	title?: string | undefined,
	items?: Array<GraphQLTypes["TileListCreateItemsEntityRelationInput"]> | undefined,
	areaType?: GraphQLTypes["TileListCreateAreaTypeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["TileItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["TileItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["TileItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	type?: GraphQLTypes["TileItemType"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	post?: GraphQLTypes["TileItemCreatePostEntityRelationInput"] | undefined,
	area?: GraphQLTypes["TileItemCreateAreaEntityRelationInput"] | undefined,
	image?: GraphQLTypes["TileItemCreateImageEntityRelationInput"] | undefined,
	link?: GraphQLTypes["TileItemCreateLinkEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["TileItemCreateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemCreatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreatePostRelationInput"] | undefined
};
	["PostCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateRevisionsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostRevisionWithoutPostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateRevisionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostRevisionWithoutPostCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	createdById?: GraphQLTypes["UUID"] | undefined,
	publishedById?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["PostType"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	tileImage?: GraphQLTypes["PostRevisionCreateTileImageEntityRelationInput"] | undefined,
	tileVideo?: GraphQLTypes["PostRevisionCreateTileVideoEntityRelationInput"] | undefined,
	heroImage?: GraphQLTypes["PostRevisionCreateHeroImageEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostRevisionCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionCreateRegionListOverrideEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"] | undefined
};
	["PostRevisionConnectOrCreateRegionListOverrideRelationInput"]: {
		connect: GraphQLTypes["DonationAmountsRegionListUniqueWhere"],
	create: GraphQLTypes["DonationAmountsRegionListCreateInput"]
};
	["PostConnectOrCreateRevisionsRelationInput"]: {
		connect: GraphQLTypes["PostRevisionUniqueWhere"],
	create: GraphQLTypes["PostRevisionWithoutPostCreateInput"]
};
	["PostCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	content?: GraphQLTypes["PostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutPostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutPostCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreatePostOrganizationEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreatePostOrganizationRelationInput"] | undefined
};
	["PostOrganizationLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined,
	domain?: GraphQLTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPostOrganizationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutPostOrganizationsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateRecurringPaymentPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"] | undefined,
	favouritePosts?: GraphQLTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["RecurringPaymentPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["RecurringPaymentPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["RecurringPaymentPageUniqueWhere"],
	create: GraphQLTypes["RecurringPaymentPageWithoutLocalesCreateInput"]
};
	["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"] | undefined
};
	["PostListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["PostListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	post?: GraphQLTypes["PostListItemCreatePostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemCreatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostListItemConnectOrCreatePostRelationInput"] | undefined
};
	["PostListItemConnectOrCreatePostRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostCreateInput"]
};
	["PostListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["PostListItemUniqueWhere"],
	create: GraphQLTypes["PostListItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"]: {
		connect: GraphQLTypes["PostListUniqueWhere"],
	create: GraphQLTypes["PostListCreateInput"]
};
	["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined
};
	["StoryGuideListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["StoryGuideListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["StoryGuideItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	guide?: GraphQLTypes["StoryGuideItemCreateGuideEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemCreateGuideEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideItemConnectOrCreateGuideRelationInput"] | undefined
};
	["StoryGuideUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["StoryGuideCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	mediaType?: GraphQLTypes["MediaType"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	image?: GraphQLTypes["StoryGuideCreateImageEntityRelationInput"] | undefined,
	secondaryImage?: GraphQLTypes["StoryGuideCreateSecondaryImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideConnectOrCreateImageRelationInput"] | undefined
};
	["StoryGuideConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["StoryGuideCreateSecondaryImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"] | undefined
};
	["StoryGuideConnectOrCreateSecondaryImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["StoryGuideItemConnectOrCreateGuideRelationInput"]: {
		connect: GraphQLTypes["StoryGuideUniqueWhere"],
	create: GraphQLTypes["StoryGuideCreateInput"]
};
	["StoryGuideListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["StoryGuideItemUniqueWhere"],
	create: GraphQLTypes["StoryGuideItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"]: {
		connect: GraphQLTypes["StoryGuideListUniqueWhere"],
	create: GraphQLTypes["StoryGuideListCreateInput"]
};
	["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"]: {
		connect: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"],
	create: GraphQLTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGivenGiftsPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateGivenGiftsPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GivenGiftsPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GivenGiftsPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["GivenGiftsPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GivenGiftsPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["GivenGiftsPageUniqueWhere"],
	create: GraphQLTypes["GivenGiftsPageWithoutLocalesCreateInput"]
};
	["GivenGiftsPageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["GivenGiftsPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GivenGiftsPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutGivenGiftsPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutGivenGiftsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateReportPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateReportPageRelationInput"] | undefined
};
	["ReportPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	root?: GraphQLTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	posts?: Array<GraphQLTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ReportPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["ReportPageUniqueWhere"],
	create: GraphQLTypes["ReportPageWithoutLocalesCreateInput"]
};
	["ReportPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutReportPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutReportPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateReceivedGiftsPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: GraphQLTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutReceivedGiftsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateGivenGiftsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"] | undefined
};
	["GivenGiftsPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGivenGiftsPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateReportPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateReportPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	posts?: Array<GraphQLTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutReportPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutReportPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateReceivedGiftsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"] | undefined
};
	["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ReceivedGiftsPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ReceivedGiftsPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["ReceivedGiftsPageUniqueWhere"],
	create: GraphQLTypes["ReceivedGiftsPageWithoutLocalesCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutReceivedGiftsPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateReportNavigationsEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateReportNavigationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined,
	pages?: Array<GraphQLTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleCreatePagesEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageWithoutReportNavigationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportNavigationLocaleConnectOrCreatePagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageWithoutReportNavigationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined,
	type?: GraphQLTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: GraphQLTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["GenericPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GenericPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutGenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	post?: GraphQLTypes["LinkableCreatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableCreatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableCreatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableCreateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableCreateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["ReportNavigationLocaleConnectOrCreatePagesRelationInput"]: {
		connect: GraphQLTypes["GenericPageUniqueWhere"],
	create: GraphQLTypes["GenericPageWithoutReportNavigationCreateInput"]
};
	["LocaleConnectOrCreateReportNavigationsRelationInput"]: {
		connect: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	create: GraphQLTypes["ReportNavigationLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateScheduledNotificationsEntityRelationInput"]: {
		connect?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateScheduledNotificationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ScheduledNotificationLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ScheduledNotificationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ScheduledNotificationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ScheduledNotificationWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	localMsFromMidnight?: number | undefined,
	scheduledDate?: GraphQLTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: GraphQLTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined,
	completedAt?: GraphQLTypes["DateTime"] | undefined,
	processedNotifications?: Array<GraphQLTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["NotificationTargetGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["NotificationTargetGroupCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"] | undefined
};
	["NotificationTargetGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["NotificationTargetGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["NotificationTargetType"] | undefined,
	regions?: Array<GraphQLTypes["NotificationTargetGroupCreateRegionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["NotificationTargetGroupCreateRegionsEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["NotificationTargetGroupConnectOrCreateRegionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["NotificationTargetGroupConnectOrCreateRegionsRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["ScheduledNotificationConnectOrCreateTargetRelationInput"]: {
		connect: GraphQLTypes["NotificationTargetGroupUniqueWhere"],
	create: GraphQLTypes["NotificationTargetGroupCreateInput"]
};
	["ScheduledNotificationCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationConnectOrCreateImageRelationInput"] | undefined
};
	["ScheduledNotificationConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined,
	donationReminderUser?: GraphQLTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"]: {
		connect?: GraphQLTypes["ProcessedNotificationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProcessedNotificationWithoutSourceCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"] | undefined
};
	["ProcessedNotificationWithoutSourceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	topic?: string | undefined,
	sentAt?: GraphQLTypes["DateTime"] | undefined,
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess?: boolean | undefined,
	title?: string | undefined,
	body?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"]: {
		connect: GraphQLTypes["ProcessedNotificationUniqueWhere"],
	create: GraphQLTypes["ProcessedNotificationWithoutSourceCreateInput"]
};
	["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutProcessedNotificationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"] | undefined
};
	["UserUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	email?: string | undefined,
	variableSymbol?: number | undefined,
	stripeId?: string | undefined,
	publicProfileSecret?: string | undefined,
	payments?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	recurringPayments?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	onBehalfDonations?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	devices?: GraphQLTypes["DeviceUniqueWhere"] | undefined,
	processedNotifications?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	areaStats?: GraphQLTypes["UserAreaStatsUniqueWhere"] | undefined,
	organizationStats?: GraphQLTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	postStats?: GraphQLTypes["UserPostStatsUniqueWhere"] | undefined,
	currencyStats?: GraphQLTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	stats?: GraphQLTypes["UserStatsUniqueWhere"] | undefined
};
	["DeviceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	user?: GraphQLTypes["UserUniqueWhere"] | undefined,
	fcmToken?: string | undefined
};
	["UserAreaStatsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["UserOrganizationStatsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["UserPostStatsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["UserCurrencyStatsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["UserStatsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	user?: GraphQLTypes["UserUniqueWhere"] | undefined
};
	["UserWithoutProcessedNotificationsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreatePaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentWithoutUserCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreatePaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserPaymentWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentCreateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateCurrencyRelationInput"] | undefined
};
	["UserPaymentConnectOrCreateCurrencyRelationInput"]: {
		connect: GraphQLTypes["CurrencyUniqueWhere"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["UserPaymentCreateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentOrderIdUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentOrderIdCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateOrderRelationInput"] | undefined
};
	["UserPaymentOrderIdCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	seq?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentConnectOrCreateOrderRelationInput"]: {
		connect: GraphQLTypes["UserPaymentOrderIdUniqueWhere"],
	create: GraphQLTypes["UserPaymentOrderIdCreateInput"]
};
	["UserPaymentCreateCsobPaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["CsobPaymentWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"] | undefined
};
	["CsobPaymentWithoutPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	payId?: string | undefined,
	statusChanges?: Array<GraphQLTypes["CsobPaymentCreateStatusChangesEntityRelationInput"]> | undefined,
	originalPayId?: string | undefined,
	metadata?: GraphQLTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentCreateStatusChangesEntityRelationInput"]: {
		connect?: GraphQLTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	create?: GraphQLTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CsobPaymentConnectOrCreateStatusChangesRelationInput"] | undefined,
	alias?: string | undefined
};
	["CsobPaymentStatusChangeWithoutPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	dttm?: string | undefined,
	status?: number | undefined,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentConnectOrCreateStatusChangesRelationInput"]: {
		connect: GraphQLTypes["CsobPaymentStatusChangeUniqueWhere"],
	create: GraphQLTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"]
};
	["CsobPaymentCreateMetadataEntityRelationInput"]: {
		connect?: GraphQLTypes["CsobPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentConnectOrCreateCsobPaymentRelationInput"]: {
		connect: GraphQLTypes["CsobPaymentUniqueWhere"],
	create: GraphQLTypes["CsobPaymentWithoutPaymentCreateInput"]
};
	["UserPaymentCreateStripePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["StripePaymentWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"] | undefined
};
	["StripePaymentWithoutPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	statusChanges?: Array<GraphQLTypes["StripePaymentCreateStatusChangesEntityRelationInput"]> | undefined,
	metadata?: GraphQLTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentCreateStatusChangesEntityRelationInput"]: {
		connect?: GraphQLTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	create?: GraphQLTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StripePaymentConnectOrCreateStatusChangesRelationInput"] | undefined,
	alias?: string | undefined
};
	["StripePaymentStatusChangeWithoutPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	timestamp?: number | undefined,
	eventId?: string | undefined,
	paymentIntentStatus?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentConnectOrCreateStatusChangesRelationInput"]: {
		connect: GraphQLTypes["StripePaymentStatusChangeUniqueWhere"],
	create: GraphQLTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"]
};
	["StripePaymentCreateMetadataEntityRelationInput"]: {
		connect?: GraphQLTypes["StripePaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentConnectOrCreateStripePaymentRelationInput"]: {
		connect: GraphQLTypes["StripePaymentUniqueWhere"],
	create: GraphQLTypes["StripePaymentWithoutPaymentCreateInput"]
};
	["UserPaymentCreateRecurringPaymentItemEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"] | undefined
};
	["UserRecurringPaymentItemWithoutPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	recurrenceCounter?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"] | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserRecurringPaymentWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"] | undefined
};
	["UserRecurringPaymentWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	activeSince?: GraphQLTypes["DateTime"] | undefined,
	cancelledAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: GraphQLTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserRecurringPaymentCreateUserEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentCreateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"] | undefined
};
	["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"]: {
		connect: GraphQLTypes["CurrencyUniqueWhere"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["UserRecurringPaymentCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutRecurringPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"] | undefined
};
	["UserWithoutRecurringPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<GraphQLTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateRegionRelationInput"] | undefined
};
	["UserConnectOrCreateRegionRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["UserCreateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateCurrencyRelationInput"] | undefined
};
	["UserConnectOrCreateCurrencyRelationInput"]: {
		connect: GraphQLTypes["CurrencyUniqueWhere"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["UserCreateOnBehalfDonationsEntityRelationInput"]: {
		connect?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: GraphQLTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateOnBehalfDonationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["OnBehalfDonationWithoutOnBehalfOfCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	payments?: Array<GraphQLTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"]> | undefined,
	meta?: GraphQLTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OnBehalfDonationCreatePaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["OnBehalfDonationConnectOrCreatePaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserPaymentWithoutOnBehalfDonationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	triesCollection?: GraphQLTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentCreateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateRegionRelationInput"] | undefined
};
	["UserPaymentConnectOrCreateRegionRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["UserPaymentCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateUserRelationInput"] | undefined
};
	["UserWithoutPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<GraphQLTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateRecurringPaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserRecurringPaymentWithoutUserCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateRecurringPaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserRecurringPaymentWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	activeSince?: GraphQLTypes["DateTime"] | undefined,
	cancelledAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: GraphQLTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["UserRecurringPaymentCreateItemsEntityRelationInput"]> | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserRecurringPaymentConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	recurrenceCounter?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	payments?: Array<GraphQLTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]> | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserPaymentWithoutRecurringPaymentItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentCreateOnBehalfDonationEntityRelationInput"]: {
		connect?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: GraphQLTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"] | undefined
};
	["OnBehalfDonationWithoutPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	onBehalfOf?: GraphQLTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutOnBehalfDonationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"] | undefined
};
	["UserWithoutOnBehalfDonationsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<GraphQLTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateSentPaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateSentPaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SentPaymentLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organizationText?: string | undefined,
	root?: GraphQLTypes["SentPaymentLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["SentPaymentWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["SentPaymentWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: GraphQLTypes["DateTime"] | undefined,
	currency?: GraphQLTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined,
	area?: GraphQLTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentCreateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentConnectOrCreateAreaRelationInput"] | undefined
};
	["PostAreaWithoutSentPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	icon?: GraphQLTypes["PostAreaCreateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostAreaCreateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostAreaCreateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<GraphQLTypes["PostAreaCreatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: GraphQLTypes["PostAreaCreateRegionEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostAreaCreateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostAreaCreateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: GraphQLTypes["PostAreaCreatePlainIconEntityRelationInput"] | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<GraphQLTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: GraphQLTypes["PostAreaCreateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaCreateAreaSentPaymentSumEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined
};
	["PostAreaCreateAreaCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaCreateAreaSumEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaSumUniqueWhere"] | undefined
};
	["SentPaymentConnectOrCreateAreaRelationInput"]: {
		connect: GraphQLTypes["PostAreaUniqueWhere"],
	create: GraphQLTypes["PostAreaWithoutSentPaymentsCreateInput"]
};
	["SentPaymentLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["SentPaymentUniqueWhere"],
	create: GraphQLTypes["SentPaymentWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateSentPaymentsRelationInput"]: {
		connect: GraphQLTypes["SentPaymentLocaleUniqueWhere"],
	create: GraphQLTypes["SentPaymentLocaleWithoutLocaleCreateInput"]
};
	["UserConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleCreateInput"]
};
	["UserCreateDevicesEntityRelationInput"]: {
		connect?: GraphQLTypes["DeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeviceWithoutUserCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateDevicesRelationInput"] | undefined,
	alias?: string | undefined
};
	["DeviceWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	fcmToken?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserConnectOrCreateDevicesRelationInput"]: {
		connect: GraphQLTypes["DeviceUniqueWhere"],
	create: GraphQLTypes["DeviceWithoutUserCreateInput"]
};
	["UserCreateProcessedNotificationsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateProcessedNotificationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined,
	scheduledNotification?: GraphQLTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"]: {
		connect?: GraphQLTypes["ScheduledNotificationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"] | undefined
};
	["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	localMsFromMidnight?: number | undefined,
	scheduledDate?: GraphQLTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: GraphQLTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["ScheduledNotificationCreateLocalesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined,
	completedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ScheduledNotificationLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	locale?: GraphQLTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutScheduledNotificationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutScheduledNotificationsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutScheduledNotificationsCreateInput"]
};
	["ScheduledNotificationConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"],
	create: GraphQLTypes["ScheduledNotificationLocaleWithoutRootCreateInput"]
};
	["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"]: {
		connect: GraphQLTypes["ScheduledNotificationUniqueWhere"],
	create: GraphQLTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]
};
	["UserConnectOrCreateProcessedNotificationsRelationInput"]: {
		connect: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"],
	create: GraphQLTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]
};
	["UserCreateAreaStatsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserAreaStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserCreateOrganizationStatsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserCreatePostStatsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPostStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserCreateCurrencyStatsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutOnBehalfDonationsCreateInput"]
};
	["OnBehalfDonationCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined
};
	["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"]: {
		connect: GraphQLTypes["OnBehalfDonationUniqueWhere"],
	create: GraphQLTypes["OnBehalfDonationWithoutPaymentsCreateInput"]
};
	["UserPaymentCreateTriesCollectionEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"] | undefined
};
	["UserPaymentTriesCollectionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	payment?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	metadata?: GraphQLTypes["UserPaymentTriesCollectionMetadataUniqueWhere"] | undefined,
	metadataLocales?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	parent?: GraphQLTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionWithoutPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	orderUrl?: string | undefined,
	user?: GraphQLTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"] | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"] | undefined,
	recurring?: GraphQLTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"] | undefined,
	metadataLocales?: Array<GraphQLTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]> | undefined,
	medium?: GraphQLTypes["PaymentMedium"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"] | undefined
};
	["UserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<GraphQLTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserCreateInput"]
};
	["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"] | undefined
};
	["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"]: {
		connect: GraphQLTypes["CurrencyUniqueWhere"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"]: {
		connect?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: GraphQLTypes["OnBehalfDonationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"] | undefined
};
	["OnBehalfDonationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	payments?: Array<GraphQLTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"]> | undefined,
	onBehalfOf?: GraphQLTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OnBehalfDonationCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"]: {
		connect: GraphQLTypes["OnBehalfDonationUniqueWhere"],
	create: GraphQLTypes["OnBehalfDonationCreateInput"]
};
	["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserRecurringPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"] | undefined
};
	["UserRecurringPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	activeSince?: GraphQLTypes["DateTime"] | undefined,
	cancelledAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: GraphQLTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["UserRecurringPaymentCreateItemsEntityRelationInput"]> | undefined,
	user?: GraphQLTypes["UserRecurringPaymentCreateUserEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined
};
	["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"]: {
		connect: GraphQLTypes["UserRecurringPaymentUniqueWhere"],
	create: GraphQLTypes["UserRecurringPaymentCreateInput"]
};
	["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserPaymentConnectOrCreateTriesCollectionRelationInput"]: {
		connect: GraphQLTypes["UserPaymentTriesCollectionUniqueWhere"],
	create: GraphQLTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"]
};
	["UserPaymentCreateMetadataEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"]: {
		connect: GraphQLTypes["UserPaymentUniqueWhere"],
	create: GraphQLTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"]
};
	["UserRecurringPaymentItemCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined
};
	["UserRecurringPaymentConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"],
	create: GraphQLTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]
};
	["UserConnectOrCreateRecurringPaymentsRelationInput"]: {
		connect: GraphQLTypes["UserRecurringPaymentUniqueWhere"],
	create: GraphQLTypes["UserRecurringPaymentWithoutUserCreateInput"]
};
	["UserPaymentConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutPaymentsCreateInput"]
};
	["OnBehalfDonationConnectOrCreatePaymentsRelationInput"]: {
		connect: GraphQLTypes["UserPaymentUniqueWhere"],
	create: GraphQLTypes["UserPaymentWithoutOnBehalfDonationCreateInput"]
};
	["UserConnectOrCreateOnBehalfDonationsRelationInput"]: {
		connect: GraphQLTypes["OnBehalfDonationUniqueWhere"],
	create: GraphQLTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"]
};
	["UserRecurringPaymentConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutRecurringPaymentsCreateInput"]
};
	["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"]: {
		connect: GraphQLTypes["UserRecurringPaymentUniqueWhere"],
	create: GraphQLTypes["UserRecurringPaymentWithoutItemsCreateInput"]
};
	["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"]: {
		connect: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"],
	create: GraphQLTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"]
};
	["UserConnectOrCreatePaymentsRelationInput"]: {
		connect: GraphQLTypes["UserPaymentUniqueWhere"],
	create: GraphQLTypes["UserPaymentWithoutUserCreateInput"]
};
	["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutProcessedNotificationsCreateInput"]
};
	["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"]: {
		connect: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"],
	create: GraphQLTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]
};
	["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["ScheduledNotificationUniqueWhere"],
	create: GraphQLTypes["ScheduledNotificationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateScheduledNotificationsRelationInput"]: {
		connect: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"],
	create: GraphQLTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"]
};
	["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutReceivedGiftsPagesCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["LinkableConnectOrCreateReceivedGiftsPageRelationInput"]: {
		connect: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReportPageLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutReportPageCreateInput"]
};
	["ReportPageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["ReportPageLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ReportPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["ReportPageLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ReportPageLocaleCreatePostsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutReportPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutReportPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostMetaDataUniqueWhere"] | undefined
};
	["PostCreateHeroCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeroCarouselWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateHeroCarouselRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeroCarouselUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["HeroCarouselItemUniqueWhere"] | undefined
};
	["HeroCarouselItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["HeroCarouselWithoutPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["Date"] | undefined,
	items?: Array<GraphQLTypes["HeroCarouselCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["HeroCarouselItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeroCarouselItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeroCarouselConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeroCarouselItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["Date"] | undefined,
	order?: number | undefined,
	item?: GraphQLTypes["HeroCarouselItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemCreateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeroCarouselItemConnectOrCreateItemRelationInput"] | undefined
};
	["HeroCarouselItemConnectOrCreateItemRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostCreateInput"]
};
	["HeroCarouselConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["HeroCarouselItemUniqueWhere"],
	create: GraphQLTypes["HeroCarouselItemWithoutListCreateInput"]
};
	["PostConnectOrCreateHeroCarouselRelationInput"]: {
		connect: GraphQLTypes["HeroCarouselUniqueWhere"],
	create: GraphQLTypes["HeroCarouselWithoutPostsCreateInput"]
};
	["PostCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentReferenceWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateContentRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceWithoutPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	contentAlignment?: GraphQLTypes["ContentAlignment"] | undefined,
	valueList?: GraphQLTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined,
	areaList?: GraphQLTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: GraphQLTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	memberList?: GraphQLTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: GraphQLTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: GraphQLTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	textImageList?: GraphQLTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
		connect: GraphQLTypes["ContentBlockUniqueWhere"],
	create: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceCreateValueListEntityRelationInput"]: {
		connect?: GraphQLTypes["ValueListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ValueListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateValueListRelationInput"] | undefined
};
	["ValueListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ValueListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ValueItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ValueItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ValueListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ValueItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	item?: GraphQLTypes["ValueItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemCreateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ValueUniqueWhere"] | undefined,
	create?: GraphQLTypes["ValueCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ValueItemConnectOrCreateItemRelationInput"] | undefined
};
	["ValueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	textContent?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["ValueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	textContent?: GraphQLTypes["ValueCreateTextContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueCreateTextContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ValueConnectOrCreateTextContentRelationInput"] | undefined
};
	["ValueConnectOrCreateTextContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ValueItemConnectOrCreateItemRelationInput"]: {
		connect: GraphQLTypes["ValueUniqueWhere"],
	create: GraphQLTypes["ValueCreateInput"]
};
	["ValueListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ValueItemUniqueWhere"],
	create: GraphQLTypes["ValueItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateValueListRelationInput"]: {
		connect: GraphQLTypes["ValueListUniqueWhere"],
	create: GraphQLTypes["ValueListCreateInput"]
};
	["ContentReferenceCreateImageLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateImageLinkListRelationInput"]: {
		connect: GraphQLTypes["ImageLinkListUniqueWhere"],
	create: GraphQLTypes["ImageLinkListCreateInput"]
};
	["ContentReferenceCreateAreaListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateAreaListRelationInput"] | undefined
};
	["PostAreaListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["PostAreaListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostAreaListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	item?: GraphQLTypes["PostAreaListItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemCreateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaListItemConnectOrCreateItemRelationInput"] | undefined
};
	["PostAreaListItemConnectOrCreateItemRelationInput"]: {
		connect: GraphQLTypes["PostAreaUniqueWhere"],
	create: GraphQLTypes["PostAreaCreateInput"]
};
	["PostAreaListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["PostAreaListItemUniqueWhere"],
	create: GraphQLTypes["PostAreaListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateAreaListRelationInput"]: {
		connect: GraphQLTypes["PostAreaListUniqueWhere"],
	create: GraphQLTypes["PostAreaListCreateInput"]
};
	["ContentReferenceCreateAccordionEntityRelationInput"]: {
		connect?: GraphQLTypes["AccordionUniqueWhere"] | undefined,
	create?: GraphQLTypes["AccordionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateAccordionRelationInput"] | undefined
};
	["AccordionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["AccordionCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["AccordionItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["AccordionItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AccordionConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["AccordionItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	descriptionContent?: GraphQLTypes["AccordionItemCreateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemCreateDescriptionContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"] | undefined
};
	["AccordionItemConnectOrCreateDescriptionContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["AccordionConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["AccordionItemUniqueWhere"],
	create: GraphQLTypes["AccordionItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateAccordionRelationInput"]: {
		connect: GraphQLTypes["AccordionUniqueWhere"],
	create: GraphQLTypes["AccordionCreateInput"]
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined
};
	["MediumListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["MediumListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["MediumItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	medium?: GraphQLTypes["MediumItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined
};
	["MediumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["MediumCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["MediumType"] | undefined,
	image?: GraphQLTypes["MediumCreateImageEntityRelationInput"] | undefined,
	video?: GraphQLTypes["MediumCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateImageRelationInput"] | undefined
};
	["MediumConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateVideoRelationInput"] | undefined
};
	["MediumConnectOrCreateVideoRelationInput"]: {
		connect: GraphQLTypes["VideoUniqueWhere"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["MediumItemConnectOrCreateMediumRelationInput"]: {
		connect: GraphQLTypes["MediumUniqueWhere"],
	create: GraphQLTypes["MediumCreateInput"]
};
	["MediumListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["MediumItemUniqueWhere"],
	create: GraphQLTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMediaRelationInput"]: {
		connect: GraphQLTypes["MediumListUniqueWhere"],
	create: GraphQLTypes["MediumListCreateInput"]
};
	["ContentReferenceCreateMemberListEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MemberListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateMemberListRelationInput"] | undefined
};
	["MemberListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["MemberListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["MemberListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MemberListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["MemberListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	position?: string | undefined,
	image?: GraphQLTypes["MemberListItemCreateImageEntityRelationInput"] | undefined,
	descriptionContent?: GraphQLTypes["MemberListItemCreateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MemberListItemConnectOrCreateImageRelationInput"] | undefined
};
	["MemberListItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MemberListItemCreateDescriptionContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"] | undefined
};
	["MemberListItemConnectOrCreateDescriptionContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["MemberListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["MemberListItemUniqueWhere"],
	create: GraphQLTypes["MemberListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMemberListRelationInput"]: {
		connect: GraphQLTypes["MemberListUniqueWhere"],
	create: GraphQLTypes["MemberListCreateInput"]
};
	["ContentReferenceCreateFormEntityRelationInput"]: {
		connect?: GraphQLTypes["FormUniqueWhere"] | undefined,
	create?: GraphQLTypes["FormCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateFormRelationInput"] | undefined
};
	["FormUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tax?: GraphQLTypes["FilledTaxFormUniqueWhere"] | undefined
};
	["FilledTaxFormUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["FormCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	type?: GraphQLTypes["FormType"] | undefined,
	tax?: GraphQLTypes["FormCreateTaxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FormCreateTaxEntityRelationInput"]: {
		connect?: GraphQLTypes["FilledTaxFormUniqueWhere"] | undefined,
	create?: GraphQLTypes["FilledTaxFormCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FormConnectOrCreateTaxRelationInput"] | undefined
};
	["FilledTaxFormCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	userId?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	vatId?: string | undefined,
	address1?: string | undefined,
	address2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	state?: string | undefined,
	country?: GraphQLTypes["FilledTaxFormCreateCountryEntityRelationInput"] | undefined,
	dateFrom?: GraphQLTypes["Date"] | undefined,
	dateTo?: GraphQLTypes["Date"] | undefined,
	year?: number | undefined,
	isPdfGenerated?: boolean | undefined,
	pdfObjectKey?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FilledTaxFormCreateCountryEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FilledTaxFormConnectOrCreateCountryRelationInput"] | undefined
};
	["FilledTaxFormConnectOrCreateCountryRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["FormConnectOrCreateTaxRelationInput"]: {
		connect: GraphQLTypes["FilledTaxFormUniqueWhere"],
	create: GraphQLTypes["FilledTaxFormCreateInput"]
};
	["ContentReferenceConnectOrCreateFormRelationInput"]: {
		connect: GraphQLTypes["FormUniqueWhere"],
	create: GraphQLTypes["FormCreateInput"]
};
	["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ContentReferenceCreateHeroCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeroCarouselCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"] | undefined
};
	["HeroCarouselCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["Date"] | undefined,
	posts?: Array<GraphQLTypes["HeroCarouselCreatePostsEntityRelationInput"]> | undefined,
	items?: Array<GraphQLTypes["HeroCarouselCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselCreatePostsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutHeroCarouselCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeroCarouselConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutHeroCarouselCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	reportPage?: Array<GraphQLTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostCreateReportPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportPageLocaleWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateReportPageRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportPageLocaleWithoutPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostConnectOrCreateReportPageRelationInput"]: {
		connect: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	create: GraphQLTypes["ReportPageLocaleWithoutPostsCreateInput"]
};
	["PostCreateFundraiseCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"] | undefined
};
	["PostConnectOrCreateFundraiseCurrencyRelationInput"]: {
		connect: GraphQLTypes["CurrencyUniqueWhere"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["PostCreateFundraiseCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostCreateFundraiseSumEntityRelationInput"]: {
		connect?: GraphQLTypes["PostSumUniqueWhere"] | undefined
};
	["PostCreateFundraisingProgressEntityRelationInput"]: {
		connect?: GraphQLTypes["PostFundraisingProgressUniqueWhere"] | undefined
};
	["HeroCarouselConnectOrCreatePostsRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostWithoutHeroCarouselCreateInput"]
};
	["ContentReferenceConnectOrCreateHeroCarouselRelationInput"]: {
		connect: GraphQLTypes["HeroCarouselUniqueWhere"],
	create: GraphQLTypes["HeroCarouselCreateInput"]
};
	["ContentReferenceCreateOrganizationListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateOrganizationListRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationListUniqueWhere"],
	create: GraphQLTypes["PostOrganizationListCreateInput"]
};
	["ContentReferenceCreateTextImageListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextImageListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"] | undefined
};
	["TextImageListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["TextImageListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["TextImageListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextImageListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextImageListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["TextImageListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	image?: GraphQLTypes["TextImageListItemCreateImageEntityRelationInput"] | undefined,
	text?: string | undefined,
	link?: GraphQLTypes["TextImageListItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextImageListItemConnectOrCreateImageRelationInput"] | undefined
};
	["TextImageListItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["TextImageListItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextImageListItemConnectOrCreateLinkRelationInput"] | undefined
};
	["TextImageListItemConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["TextImageListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["TextImageListItemUniqueWhere"],
	create: GraphQLTypes["TextImageListItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateTextImageListRelationInput"]: {
		connect: GraphQLTypes["TextImageListUniqueWhere"],
	create: GraphQLTypes["TextImageListCreateInput"]
};
	["PostConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceUniqueWhere"],
	create: GraphQLTypes["ContentReferenceWithoutPostsCreateInput"]
};
	["ReportPageLocaleConnectOrCreatePostsRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostWithoutReportPageCreateInput"]
};
	["LocaleConnectOrCreateReportPagesRelationInput"]: {
		connect: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	create: GraphQLTypes["ReportPageLocaleWithoutLocaleCreateInput"]
};
	["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutGivenGiftsPagesCreateInput"]
};
	["LinkableConnectOrCreateGivenGiftsPageRelationInput"]: {
		connect: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: GraphQLTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutReceivedGiftsPageCreateInput"]
};
	["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"]: {
		connect: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["ReportPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutReportPagesCreateInput"]
};
	["LinkableConnectOrCreateReportPageRelationInput"]: {
		connect: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	create: GraphQLTypes["ReportPageLocaleWithoutLinkCreateInput"]
};
	["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutGivenGiftsPageCreateInput"]
};
	["LocaleConnectOrCreateGivenGiftsPagesRelationInput"]: {
		connect: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: GraphQLTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutPostOrganizationsCreateInput"]
};
	["PostOrganizationLocaleCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"] | undefined
};
	["PostOrganizationLocaleConnectOrCreateDomainRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["PostOrganizationLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["PostOrganizationLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PostOrganizationLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["PostOrganizationLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["LinkableConnectOrCreatePostOrganizationRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationLocaleUniqueWhere"],
	create: GraphQLTypes["PostOrganizationLocaleWithoutLinkCreateInput"]
};
	["PostLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutPostCreateInput"]
};
	["PostConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["PostLocaleUniqueWhere"],
	create: GraphQLTypes["PostLocaleWithoutRootCreateInput"]
};
	["TileItemConnectOrCreatePostRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostCreateInput"]
};
	["TileItemCreateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateAreaRelationInput"] | undefined
};
	["TileItemConnectOrCreateAreaRelationInput"]: {
		connect: GraphQLTypes["PostAreaUniqueWhere"],
	create: GraphQLTypes["PostAreaCreateInput"]
};
	["TileItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateImageRelationInput"] | undefined
};
	["TileItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["TileItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateLinkRelationInput"] | undefined
};
	["TileItemConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["TileItemCreateOrganizationEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateOrganizationRelationInput"] | undefined
};
	["TileItemConnectOrCreateOrganizationRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationUniqueWhere"],
	create: GraphQLTypes["PostOrganizationCreateInput"]
};
	["TileListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["TileItemUniqueWhere"],
	create: GraphQLTypes["TileItemWithoutListCreateInput"]
};
	["TileListCreateAreaTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileListConnectOrCreateAreaTypeRelationInput"] | undefined
};
	["TileListConnectOrCreateAreaTypeRelationInput"]: {
		connect: GraphQLTypes["PostAreaUniqueWhere"],
	create: GraphQLTypes["PostAreaCreateInput"]
};
	["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"]: {
		connect: GraphQLTypes["TileListUniqueWhere"],
	create: GraphQLTypes["TileListCreateInput"]
};
	["FeedPageLocaleCreateSectionListEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateSectionListRelationInput"] | undefined,
	alias?: string | undefined
};
	["FeedPageSectionWithoutFeedPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	tileStripeList?: Array<GraphQLTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionCreateTileStripeListEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageTileStripeUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageTileStripeWithoutSectionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageSectionConnectOrCreateTileStripeListRelationInput"] | undefined,
	alias?: string | undefined
};
	["FeedPageTileStripeWithoutSectionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	tileList?: GraphQLTypes["FeedPageTileStripeCreateTileListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeCreateTileListEntityRelationInput"]: {
		connect?: GraphQLTypes["TileListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TileListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"] | undefined
};
	["FeedPageTileStripeConnectOrCreateTileListRelationInput"]: {
		connect: GraphQLTypes["TileListUniqueWhere"],
	create: GraphQLTypes["TileListCreateInput"]
};
	["FeedPageSectionConnectOrCreateTileStripeListRelationInput"]: {
		connect: GraphQLTypes["FeedPageTileStripeUniqueWhere"],
	create: GraphQLTypes["FeedPageTileStripeWithoutSectionCreateInput"]
};
	["FeedPageLocaleConnectOrCreateSectionListRelationInput"]: {
		connect: GraphQLTypes["FeedPageSectionUniqueWhere"],
	create: GraphQLTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"]
};
	["FeedPageLocaleCreateCardListEntityRelationInput"]: {
		connect?: GraphQLTypes["CardListUniqueWhere"] | undefined,
	create?: GraphQLTypes["CardListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"] | undefined
};
	["CardListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["CardListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["CardItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["CardItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CardListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["CardItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["CardItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CardItemConnectOrCreateLinkRelationInput"] | undefined
};
	["CardItemConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["CardListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["CardItemUniqueWhere"],
	create: GraphQLTypes["CardItemWithoutListCreateInput"]
};
	["FeedPageLocaleConnectOrCreateCardListRelationInput"]: {
		connect: GraphQLTypes["CardListUniqueWhere"],
	create: GraphQLTypes["CardListCreateInput"]
};
	["FeedPageLocaleCreateStoryGuideListEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined
};
	["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"]: {
		connect: GraphQLTypes["StoryGuideListUniqueWhere"],
	create: GraphQLTypes["StoryGuideListCreateInput"]
};
	["LocaleConnectOrCreateFeedPagesRelationInput"]: {
		connect: GraphQLTypes["FeedPageLocaleUniqueWhere"],
	create: GraphQLTypes["FeedPageLocaleWithoutLocaleCreateInput"]
};
	["PostRevisionLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutPostRevisionsCreateInput"]
};
	["PostRevisionLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["PostRevisionLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PostRevisionLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["PostRevisionLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PostRevisionLocaleCreateLeadContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"] | undefined
};
	["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PostRevisionConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["PostRevisionLocaleUniqueWhere"],
	create: GraphQLTypes["PostRevisionLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateActiveRevisionRelationInput"]: {
		connect: GraphQLTypes["PostRevisionUniqueWhere"],
	create: GraphQLTypes["PostRevisionCreateInput"]
};
	["PostRevisionConnectOrCreatePostRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostWithoutRevisionsCreateInput"]
};
	["PostRevisionLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["PostRevisionUniqueWhere"],
	create: GraphQLTypes["PostRevisionWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostRevisionsRelationInput"]: {
		connect: GraphQLTypes["PostRevisionLocaleUniqueWhere"],
	create: GraphQLTypes["PostRevisionLocaleWithoutLocaleCreateInput"]
};
	["SentPaymentLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutSentPaymentsCreateInput"]
};
	["SentPaymentConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["SentPaymentLocaleUniqueWhere"],
	create: GraphQLTypes["SentPaymentLocaleWithoutRootCreateInput"]
};
	["PostAreaConnectOrCreateSentPaymentsRelationInput"]: {
		connect: GraphQLTypes["SentPaymentUniqueWhere"],
	create: GraphQLTypes["SentPaymentWithoutAreaCreateInput"]
};
	["PostOrganizationConnectOrCreateAreaRelationInput"]: {
		connect: GraphQLTypes["PostAreaUniqueWhere"],
	create: GraphQLTypes["PostAreaCreateInput"]
};
	["PostOrganizationCreateSentPaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["SentPaymentWithoutOrganizationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateSentPaymentsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SentPaymentWithoutOrganizationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: GraphQLTypes["DateTime"] | undefined,
	currency?: GraphQLTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined,
	area?: GraphQLTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationConnectOrCreateSentPaymentsRelationInput"]: {
		connect: GraphQLTypes["SentPaymentUniqueWhere"],
	create: GraphQLTypes["SentPaymentWithoutOrganizationCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationUniqueWhere"],
	create: GraphQLTypes["PostOrganizationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostOrganizationsRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationLocaleUniqueWhere"],
	create: GraphQLTypes["PostOrganizationLocaleWithoutLocaleCreateInput"]
};
	["PostAreaLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutPostAreasCreateInput"]
};
	["PostAreaLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["PostAreaLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PostAreaLocaleCreateBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["AppBannerUniqueWhere"] | undefined,
	create?: GraphQLTypes["AppBannerCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"] | undefined
};
	["AppBannerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	imageSmall?: GraphQLTypes["AppBannerCreateImageSmallEntityRelationInput"] | undefined,
	imageBig?: GraphQLTypes["AppBannerCreateImageBigEntityRelationInput"] | undefined,
	textContent?: GraphQLTypes["AppBannerCreateTextContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AppBannerCreateImageSmallEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AppBannerConnectOrCreateImageSmallRelationInput"] | undefined
};
	["AppBannerConnectOrCreateImageSmallRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["AppBannerCreateImageBigEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AppBannerConnectOrCreateImageBigRelationInput"] | undefined
};
	["AppBannerConnectOrCreateImageBigRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["AppBannerCreateTextContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AppBannerConnectOrCreateTextContentRelationInput"] | undefined
};
	["AppBannerConnectOrCreateTextContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PostAreaLocaleConnectOrCreateBannerRelationInput"]: {
		connect: GraphQLTypes["AppBannerUniqueWhere"],
	create: GraphQLTypes["AppBannerCreateInput"]
};
	["PostAreaLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["PostAreaLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["LinkableConnectOrCreatePostAreaRelationInput"]: {
		connect: GraphQLTypes["PostAreaLocaleUniqueWhere"],
	create: GraphQLTypes["PostAreaLocaleWithoutLinkCreateInput"]
};
	["PostOrganizationLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutPostOrganizationCreateInput"]
};
	["PostOrganizationConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationLocaleUniqueWhere"],
	create: GraphQLTypes["PostOrganizationLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateOrganizationRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationUniqueWhere"],
	create: GraphQLTypes["PostOrganizationWithoutPostsCreateInput"]
};
	["PostAreaConnectOrCreatePostsRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostWithoutAreaCreateInput"]
};
	["PostAreaLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["PostAreaUniqueWhere"],
	create: GraphQLTypes["PostAreaWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreatePostAreasRelationInput"]: {
		connect: GraphQLTypes["PostAreaLocaleUniqueWhere"],
	create: GraphQLTypes["PostAreaLocaleWithoutLocaleCreateInput"]
};
	["PostLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutPostsCreateInput"]
};
	["PostLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["PostWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostCreateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostWithoutLocalesCreateInput"]
};
	["LinkableConnectOrCreatePostRelationInput"]: {
		connect: GraphQLTypes["PostLocaleUniqueWhere"],
	create: GraphQLTypes["PostLocaleWithoutLinkCreateInput"]
};
	["LinkConnectOrCreateInternalLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableCreateInput"]
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreatePostsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreatePostsRelationInput"] | undefined,
	alias?: string | undefined
};
	["PostWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organization?: GraphQLTypes["PostCreateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostCreateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostCreateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostCreateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostCreateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostCreateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostCreateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostCreateReportPageEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostCreateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostCreateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostCreateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceConnectOrCreatePostsRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostWithoutContentCreateInput"]
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceUniqueWhere"],
	create: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
		connect: GraphQLTypes["ContentBlockUniqueWhere"],
	create: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["PostLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["LocaleConnectOrCreatePostsRelationInput"]: {
		connect: GraphQLTypes["PostLocaleUniqueWhere"],
	create: GraphQLTypes["PostLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
		connect: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["PostAreaLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutPostAreaCreateInput"]
};
	["PostAreaConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["PostAreaLocaleUniqueWhere"],
	create: GraphQLTypes["PostAreaLocaleWithoutRootCreateInput"]
};
	["PostConnectOrCreateAreaRelationInput"]: {
		connect: GraphQLTypes["PostAreaUniqueWhere"],
	create: GraphQLTypes["PostAreaWithoutPostsCreateInput"]
};
	["PostOrganizationConnectOrCreatePostsRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostWithoutOrganizationCreateInput"]
};
	["PostOrganizationListItemConnectOrCreateItemRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationUniqueWhere"],
	create: GraphQLTypes["PostOrganizationCreateInput"]
};
	["PostOrganizationListItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"] | undefined
};
	["PostOrganizationListItemConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["PostOrganizationListItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"] | undefined
};
	["PostOrganizationListItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationListItemUniqueWhere"],
	create: GraphQLTypes["PostOrganizationListItemWithoutListCreateInput"]
};
	["GeneralConnectOrCreateOrganizationListRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationListUniqueWhere"],
	create: GraphQLTypes["PostOrganizationListCreateInput"]
};
	["GeneralLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["GeneralUniqueWhere"],
	create: GraphQLTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GeneralLocaleCreateAppStoreLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"] | undefined
};
	["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"] | undefined
};
	["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateGeneralsRelationInput"]: {
		connect: GraphQLTypes["GeneralLocaleUniqueWhere"],
	create: GraphQLTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutReportNavigationsCreateInput"]
};
	["GenericPageConnectOrCreateReportNavigationRelationInput"]: {
		connect: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	create: GraphQLTypes["ReportNavigationLocaleWithoutPagesCreateInput"]
};
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["GenericPageUniqueWhere"],
	create: GraphQLTypes["GenericPageWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateGenericPagesRelationInput"]: {
		connect: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutGeneralsCreateInput"]
};
	["GeneralConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["GeneralLocaleUniqueWhere"],
	create: GraphQLTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["GeneralUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["GeneralUpdateLocalesEntityRelationInput"]> | undefined,
	allAreasIcon?: GraphQLTypes["GeneralUpdateAllAreasIconEntityRelationInput"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["GeneralUpdateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["GeneralLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["GeneralUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["GeneralUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GeneralUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["GeneralLocaleUniqueWhere"],
	data: GraphQLTypes["GeneralLocaleWithoutRootUpdateInput"]
};
	["GeneralLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	appStoreLink?: GraphQLTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: GraphQLTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGeneralsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutGeneralsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGeneralsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateGenericPagesEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateGenericPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertGenericPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGenericPagesRelationInput"]: {
		by: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	data: GraphQLTypes["GenericPageLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["GenericPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GenericPageWithoutLocalesUpdateInput"]: {
		type?: GraphQLTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	reportNavigation?: Array<GraphQLTypes["GenericPageUpdateReportNavigationEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateReportNavigationEntityRelationInput"]: {
		create?: GraphQLTypes["ReportNavigationLocaleWithoutPagesCreateInput"] | undefined,
	update?: GraphQLTypes["GenericPageUpdateReportNavigationRelationInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageUpsertReportNavigationRelationInput"] | undefined,
	connect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageUpdateReportNavigationRelationInput"]: {
		by: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	data: GraphQLTypes["ReportNavigationLocaleWithoutPagesUpdateInput"]
};
	["ReportNavigationLocaleWithoutPagesUpdateInput"]: {
		root?: GraphQLTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportNavigationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportNavigationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["ReportNavigationWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReportNavigationLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ReportNavigationWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["ReportNavigationWithoutLocalesUpdateInput"],
	create: GraphQLTypes["ReportNavigationWithoutLocalesCreateInput"]
};
	["ReportNavigationLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutReportNavigationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutReportNavigationsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReportNavigationLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutReportNavigationsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateGeneralsEntityRelationInput"]: {
		create?: GraphQLTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateGeneralsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertGeneralsRelationInput"] | undefined,
	connect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGeneralsRelationInput"]: {
		by: GraphQLTypes["GeneralLocaleUniqueWhere"],
	data: GraphQLTypes["GeneralLocaleWithoutLocaleUpdateInput"]
};
	["GeneralLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	appStoreLink?: GraphQLTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: GraphQLTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GeneralUniqueWhere"] | undefined,
	create?: GraphQLTypes["GeneralWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["GeneralWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GeneralWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	allAreasIcon?: GraphQLTypes["GeneralUpdateAllAreasIconEntityRelationInput"] | undefined,
	allOrganizationsIcon?: GraphQLTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["GeneralUpdateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralUpdateAllAreasIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralConnectOrCreateAllAreasIconRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralUpsertAllAreasIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageUpdateInput"]: {
		url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralUpsertAllAreasIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["GeneralUpdateAllOrganizationsIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralUpsertAllOrganizationsIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralUpsertAllOrganizationsIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["GeneralUpdateOrganizationListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralConnectOrCreateOrganizationListRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralUpsertOrganizationListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationListUpdateInput"]: {
		items?: Array<GraphQLTypes["PostOrganizationListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["PostOrganizationListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostOrganizationListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostOrganizationListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostOrganizationListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["PostOrganizationListItemUniqueWhere"],
	data: GraphQLTypes["PostOrganizationListItemWithoutListUpdateInput"]
};
	["PostOrganizationListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	item?: GraphQLTypes["PostOrganizationListItemUpdateItemEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	link?: GraphQLTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"] | undefined,
	image?: GraphQLTypes["PostOrganizationListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemUpdateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationListItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpdateInput"]: {
		order?: number | undefined,
	posts?: Array<GraphQLTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined,
	icon?: GraphQLTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: GraphQLTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: GraphQLTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpdatePostsEntityRelationInput"]: {
		create?: GraphQLTypes["PostWithoutOrganizationCreateInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationUpdatePostsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationUpsertPostsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationUpdatePostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	data: GraphQLTypes["PostWithoutOrganizationUpdateInput"]
};
	["PostWithoutOrganizationUpdateInput"]: {
		area?: GraphQLTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateAreaRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaWithoutPostsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertAreaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaWithoutPostsUpdateInput"]: {
		order?: number | undefined,
	icon?: GraphQLTypes["PostAreaUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	specificSymbol?: number | undefined,
	region?: GraphQLTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: GraphQLTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<GraphQLTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: GraphQLTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaUpdateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateIconRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaUpsertIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpsertIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostAreaUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PostAreaLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["PostAreaUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["PostAreaLocaleUniqueWhere"],
	data: GraphQLTypes["PostAreaLocaleWithoutRootUpdateInput"]
};
	["PostAreaLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutPostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutPostAreaUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutPostAreaUpdateInput"]: {
		url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined,
	update?: GraphQLTypes["GenericPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertGenericPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGenericPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutGenericPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGenericPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdatePostsEntityRelationInput"]: {
		create?: GraphQLTypes["PostLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdatePostsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertPostsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePostsRelationInput"]: {
		by: GraphQLTypes["PostLocaleUniqueWhere"],
	data: GraphQLTypes["PostLocaleWithoutLocaleUpdateInput"]
};
	["PostLocaleWithoutLocaleUpdateInput"]: {
		content?: GraphQLTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"] | undefined,
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentUpdateBlocksRelationInput"]: {
		by: GraphQLTypes["ContentBlockUniqueWhere"],
	data: GraphQLTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	data: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	contentAlignment?: GraphQLTypes["ContentAlignment"] | undefined,
	valueList?: GraphQLTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined,
	areaList?: GraphQLTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: GraphQLTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	memberList?: GraphQLTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: GraphQLTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: GraphQLTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	posts?: Array<GraphQLTypes["ContentReferenceUpdatePostsEntityRelationInput"]> | undefined,
	textImageList?: GraphQLTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined,
	update?: GraphQLTypes["VideoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpdateInput"]: {
		url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	poster?: GraphQLTypes["VideoUpdatePosterEntityRelationInput"] | undefined,
	shapeType?: GraphQLTypes["VideoShapeType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoUpdatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["VideoConnectOrCreatePosterRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VideoUpsertPosterRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpsertPosterRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertVideoRelationInput"]: {
		update: GraphQLTypes["VideoUpdateInput"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkEnum"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined,
	isTargetBlank?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableUpdateInput"]: {
		url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreatePostRelationInput"] | undefined,
	update?: GraphQLTypes["PostLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertPostRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostLocaleWithoutLinkUpdateInput"]: {
		content?: GraphQLTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpdateInput"]: {
		title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpsertOgImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PostLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutPostsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPostsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdatePostAreasEntityRelationInput"]: {
		create?: GraphQLTypes["PostAreaLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdatePostAreasRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertPostAreasRelationInput"] | undefined,
	connect?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePostAreasRelationInput"]: {
		by: GraphQLTypes["PostAreaLocaleUniqueWhere"],
	data: GraphQLTypes["PostAreaLocaleWithoutLocaleUpdateInput"]
};
	["PostAreaLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostAreaWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	icon?: GraphQLTypes["PostAreaUpdateIconEntityRelationInput"] | undefined,
	regionListOverride?: GraphQLTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<GraphQLTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: GraphQLTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: GraphQLTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<GraphQLTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: GraphQLTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaUpdateRegionListOverrideEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"] | undefined,
	update?: GraphQLTypes["DonationAmountsRegionListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaUpsertRegionListOverrideRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DonationAmountsRegionListUpdateInput"]: {
		regions?: Array<GraphQLTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]> | undefined,
	donation?: GraphQLTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]: {
		create?: GraphQLTypes["DonationAmountsRegionItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["DonationAmountsRegionListUpdateRegionsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DonationAmountsRegionListUpsertRegionsRelationInput"] | undefined,
	connect?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DonationAmountsRegionListUpdateRegionsRelationInput"]: {
		by: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"],
	data: GraphQLTypes["DonationAmountsRegionItemWithoutListUpdateInput"]
};
	["DonationAmountsRegionItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	items?: Array<GraphQLTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined,
	region?: GraphQLTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["DonationAmountItemWithoutRegionItemCreateInput"] | undefined,
	update?: GraphQLTypes["DonationAmountsRegionItemUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DonationAmountsRegionItemUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["DonationAmountItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DonationAmountItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DonationAmountItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DonationAmountsRegionItemUpdateItemsRelationInput"]: {
		by: GraphQLTypes["DonationAmountItemUniqueWhere"],
	data: GraphQLTypes["DonationAmountItemWithoutRegionItemUpdateInput"]
};
	["DonationAmountItemWithoutRegionItemUpdateInput"]: {
		order?: number | undefined,
	amount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpsertItemsRelationInput"]: {
		by: GraphQLTypes["DonationAmountItemUniqueWhere"],
	update: GraphQLTypes["DonationAmountItemWithoutRegionItemUpdateInput"],
	create: GraphQLTypes["DonationAmountItemWithoutRegionItemCreateInput"]
};
	["DonationAmountsRegionItemUpdateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionWithoutDonationItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"] | undefined,
	update?: GraphQLTypes["RegionWithoutDonationItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DonationAmountsRegionItemUpsertRegionRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["RegionWithoutDonationItemsUpdateInput"]: {
		order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: GraphQLTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined,
	enabledPaymentMethods?: Array<GraphQLTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionUpdateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RegionConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: GraphQLTypes["CurrencyUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RegionUpsertCurrencyRelationInput"] | undefined
};
	["CurrencyUpdateInput"]: {
		identifier?: GraphQLTypes["CurrencyIdentifier"] | undefined,
	label?: string | undefined,
	sign?: string | undefined,
	signAlignment?: GraphQLTypes["CurrencySignAlignment"] | undefined,
	defaultDonationAmount?: number | undefined,
	rateAgainstCzk?: number | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaCurrencySums?: Array<GraphQLTypes["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	postCurrencySums?: Array<GraphQLTypes["CurrencyUpdatePostCurrencySumsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CurrencyUpdatePostCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RegionUpsertCurrencyRelationInput"]: {
		update: GraphQLTypes["CurrencyUpdateInput"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]: {
		create?: GraphQLTypes["RegionPaymentMethodWithoutRegionCreateInput"] | undefined,
	update?: GraphQLTypes["RegionUpdateEnabledPaymentMethodsRelationInput"] | undefined,
	upsert?: GraphQLTypes["RegionUpsertEnabledPaymentMethodsRelationInput"] | undefined,
	connect?: GraphQLTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RegionPaymentMethodUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RegionUpdateEnabledPaymentMethodsRelationInput"]: {
		by: GraphQLTypes["RegionPaymentMethodUniqueWhere"],
	data: GraphQLTypes["RegionPaymentMethodWithoutRegionUpdateInput"]
};
	["RegionPaymentMethodWithoutRegionUpdateInput"]: {
		allowRecurringPayments?: boolean | undefined,
	method?: GraphQLTypes["PaymentMethods"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionUpsertEnabledPaymentMethodsRelationInput"]: {
		by: GraphQLTypes["RegionPaymentMethodUniqueWhere"],
	update: GraphQLTypes["RegionPaymentMethodWithoutRegionUpdateInput"],
	create: GraphQLTypes["RegionPaymentMethodWithoutRegionCreateInput"]
};
	["DonationAmountsRegionItemUpsertRegionRelationInput"]: {
		update: GraphQLTypes["RegionWithoutDonationItemsUpdateInput"],
	create: GraphQLTypes["RegionWithoutDonationItemsCreateInput"]
};
	["DonationAmountsRegionListUpsertRegionsRelationInput"]: {
		by: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"],
	update: GraphQLTypes["DonationAmountsRegionItemWithoutListUpdateInput"],
	create: GraphQLTypes["DonationAmountsRegionItemWithoutListCreateInput"]
};
	["DonationAmountsRegionListUpdateDonationEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationWithoutRegionListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"] | undefined,
	update?: GraphQLTypes["DonationWithoutRegionListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DonationAmountsRegionListUpsertDonationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DonationWithoutRegionListUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListUpsertDonationRelationInput"]: {
		update: GraphQLTypes["DonationWithoutRegionListUpdateInput"],
	create: GraphQLTypes["DonationWithoutRegionListCreateInput"]
};
	["PostAreaUpsertRegionListOverrideRelationInput"]: {
		update: GraphQLTypes["DonationAmountsRegionListUpdateInput"],
	create: GraphQLTypes["DonationAmountsRegionListCreateInput"]
};
	["PostAreaUpdatePostsEntityRelationInput"]: {
		create?: GraphQLTypes["PostWithoutAreaCreateInput"] | undefined,
	update?: GraphQLTypes["PostAreaUpdatePostsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaUpsertPostsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdatePostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	data: GraphQLTypes["PostWithoutAreaUpdateInput"]
};
	["PostWithoutAreaUpdateInput"]: {
		organization?: GraphQLTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateOrganizationEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationWithoutPostsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateOrganizationRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationWithoutPostsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertOrganizationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationWithoutPostsUpdateInput"]: {
		order?: number | undefined,
	icon?: GraphQLTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: GraphQLTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: GraphQLTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpdateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateIconRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationUpsertIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpsertIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PostOrganizationLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["PostOrganizationLocaleUniqueWhere"],
	data: GraphQLTypes["PostOrganizationLocaleWithoutRootUpdateInput"]
};
	["PostOrganizationLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	domain?: GraphQLTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutPostOrganizationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutPostOrganizationUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutPostOrganizationUpdateInput"]: {
		url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdatePostAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreatePostAreaRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertPostAreaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaLocaleWithoutLinkUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPostAreasCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutPostAreasUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPostAreasUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdatePostOrganizationsEntityRelationInput"]: {
		create?: GraphQLTypes["PostOrganizationLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdatePostOrganizationsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertPostOrganizationsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePostOrganizationsRelationInput"]: {
		by: GraphQLTypes["PostOrganizationLocaleUniqueWhere"],
	data: GraphQLTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"]
};
	["PostOrganizationLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined,
	domain?: GraphQLTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	posts?: Array<GraphQLTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined,
	icon?: GraphQLTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	area?: GraphQLTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: GraphQLTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"]> | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpdateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateAreaRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationUpsertAreaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpdateInput"]: {
		order?: number | undefined,
	icon?: GraphQLTypes["PostAreaUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<GraphQLTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: GraphQLTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: GraphQLTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined,
	sentPayments?: Array<GraphQLTypes["PostAreaUpdateSentPaymentsEntityRelationInput"]> | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<GraphQLTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: GraphQLTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaUpdateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateRegionRelationInput"] | undefined,
	update?: GraphQLTypes["RegionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaUpsertRegionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RegionUpdateInput"]: {
		order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: GraphQLTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined,
	enabledPaymentMethods?: Array<GraphQLTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]> | undefined,
	donationItems?: Array<GraphQLTypes["RegionUpdateDonationItemsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionUpdateDonationItemsEntityRelationInput"]: {
		create?: GraphQLTypes["DonationAmountsRegionItemWithoutRegionCreateInput"] | undefined,
	update?: GraphQLTypes["RegionUpdateDonationItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["RegionUpsertDonationItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RegionUpdateDonationItemsRelationInput"]: {
		by: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"],
	data: GraphQLTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"]
};
	["DonationAmountsRegionItemWithoutRegionUpdateInput"]: {
		order?: number | undefined,
	items?: Array<GraphQLTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined,
	list?: GraphQLTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionListWithoutRegionsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DonationAmountsRegionItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["DonationAmountsRegionListWithoutRegionsUpdateInput"]: {
		donation?: GraphQLTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpsertListRelationInput"]: {
		update: GraphQLTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"],
	create: GraphQLTypes["DonationAmountsRegionListWithoutRegionsCreateInput"]
};
	["RegionUpsertDonationItemsRelationInput"]: {
		by: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"],
	update: GraphQLTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"],
	create: GraphQLTypes["DonationAmountsRegionItemWithoutRegionCreateInput"]
};
	["PostAreaUpsertRegionRelationInput"]: {
		update: GraphQLTypes["RegionUpdateInput"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["PostAreaUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaMetaDataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpdateMobileHeroImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaUpsertMobileHeroImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpsertMobileHeroImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostAreaUpdatePlainIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaConnectOrCreatePlainIconRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaUpsertPlainIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpsertPlainIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostAreaUpdateSentPaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["SentPaymentWithoutAreaCreateInput"] | undefined,
	update?: GraphQLTypes["PostAreaUpdateSentPaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaUpsertSentPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdateSentPaymentsRelationInput"]: {
		by: GraphQLTypes["SentPaymentUniqueWhere"],
	data: GraphQLTypes["SentPaymentWithoutAreaUpdateInput"]
};
	["SentPaymentWithoutAreaUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: GraphQLTypes["DateTime"] | undefined,
	currency?: GraphQLTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentUpdateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: GraphQLTypes["CurrencyUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SentPaymentUpsertCurrencyRelationInput"] | undefined
};
	["SentPaymentUpsertCurrencyRelationInput"]: {
		update: GraphQLTypes["CurrencyUpdateInput"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["SentPaymentUpdateOrganizationEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentConnectOrCreateOrganizationRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationWithoutSentPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SentPaymentUpsertOrganizationRelationInput"] | undefined
};
	["PostOrganizationWithoutSentPaymentsUpdateInput"]: {
		order?: number | undefined,
	posts?: Array<GraphQLTypes["PostOrganizationUpdatePostsEntityRelationInput"]> | undefined,
	icon?: GraphQLTypes["PostOrganizationUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostOrganizationUpdateLocalesEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	area?: GraphQLTypes["PostOrganizationUpdateAreaEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostOrganizationUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"] | undefined,
	isHidden?: boolean | undefined,
	color?: string | undefined,
	plainIcon?: GraphQLTypes["PostOrganizationUpdatePlainIconEntityRelationInput"] | undefined,
	desktopHeroImage?: GraphQLTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"] | undefined,
	organizationCurrencySums?: Array<GraphQLTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]> | undefined,
	organizationSum?: GraphQLTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationMetaDataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpdateMobileHeroImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationUpsertMobileHeroImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpsertMobileHeroImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationUpdatePlainIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationUpsertPlainIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpsertPlainIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationUpsertDesktopHeroImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationUpsertDesktopHeroImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostOrganizationCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationUpdateOrganizationSumEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationSumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SentPaymentUpsertOrganizationRelationInput"]: {
		update: GraphQLTypes["PostOrganizationWithoutSentPaymentsUpdateInput"],
	create: GraphQLTypes["PostOrganizationWithoutSentPaymentsCreateInput"]
};
	["SentPaymentUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["SentPaymentLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["SentPaymentUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["SentPaymentUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SentPaymentUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["SentPaymentLocaleUniqueWhere"],
	data: GraphQLTypes["SentPaymentLocaleWithoutRootUpdateInput"]
};
	["SentPaymentLocaleWithoutRootUpdateInput"]: {
		organizationText?: string | undefined,
	locale?: GraphQLTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutSentPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SentPaymentLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutSentPaymentsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateHeadersRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertHeadersRelationInput"] | undefined,
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateHeadersRelationInput"]: {
		by: GraphQLTypes["HeaderLocaleUniqueWhere"],
	data: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"]
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined,
	links?: GraphQLTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["HeaderWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HeaderWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["HeaderUpdateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HeaderUpdateOrganizationListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateOrganizationListRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderUpsertOrganizationListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderUpsertOrganizationListRelationInput"]: {
		update: GraphQLTypes["PostOrganizationListUpdateInput"],
	create: GraphQLTypes["PostOrganizationListCreateInput"]
};
	["HeaderLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["HeaderWithoutLocalesUpdateInput"],
	create: GraphQLTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleUpdateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLinksRelationInput"] | undefined,
	update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertLinksRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["LinkListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["LinkListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LinkListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["LinkItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["LinkItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LinkListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["LinkItemUniqueWhere"],
	data: GraphQLTypes["LinkItemWithoutListUpdateInput"]
};
	["LinkItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	link?: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkItemUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LinkListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["LinkItemUniqueWhere"],
	update: GraphQLTypes["LinkItemWithoutListUpdateInput"],
	create: GraphQLTypes["LinkItemWithoutListCreateInput"]
};
	["HeaderLocaleUpsertLinksRelationInput"]: {
		update: GraphQLTypes["LinkListUpdateInput"],
	create: GraphQLTypes["LinkListCreateInput"]
};
	["LocaleUpsertHeadersRelationInput"]: {
		by: GraphQLTypes["HeaderLocaleUniqueWhere"],
	update: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateFootersEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateFootersRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertFootersRelationInput"] | undefined,
	connect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateFootersRelationInput"]: {
		by: GraphQLTypes["FooterLocaleUniqueWhere"],
	data: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"]
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
		copyright?: string | undefined,
	root?: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined,
	linkList?: GraphQLTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: GraphQLTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["FooterWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FooterWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	logo?: GraphQLTypes["FooterUpdateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["FooterWithoutLocalesUpdateInput"],
	create: GraphQLTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleUpdateLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateLinkListRelationInput"] | undefined,
	update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertLinkListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertLinkListRelationInput"]: {
		update: GraphQLTypes["LinkListUpdateInput"],
	create: GraphQLTypes["LinkListCreateInput"]
};
	["FooterLocaleUpdateAddressInfoEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertAddressInfoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertAddressInfoRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["FooterLocaleUpdateImageLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"] | undefined,
	update?: GraphQLTypes["ImageLinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertImageLinkListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageLinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["ImageLinkListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ImageLinkItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ImageLinkListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ImageLinkListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageLinkItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ImageLinkItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ImageLinkItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ImageLinkListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ImageLinkItemUniqueWhere"],
	data: GraphQLTypes["ImageLinkItemWithoutListUpdateInput"]
};
	["ImageLinkItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	item?: GraphQLTypes["ImageLinkItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemUpdateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkItemConnectOrCreateItemRelationInput"] | undefined,
	update?: GraphQLTypes["ImageLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageLinkItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageLinkUpdateInput"]: {
		image?: GraphQLTypes["ImageLinkUpdateImageEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ImageLinkUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageLinkUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageLinkUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ImageLinkUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageLinkUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageLinkUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["ImageLinkItemUpsertItemRelationInput"]: {
		update: GraphQLTypes["ImageLinkUpdateInput"],
	create: GraphQLTypes["ImageLinkCreateInput"]
};
	["ImageLinkListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ImageLinkItemUniqueWhere"],
	update: GraphQLTypes["ImageLinkItemWithoutListUpdateInput"],
	create: GraphQLTypes["ImageLinkItemWithoutListCreateInput"]
};
	["FooterLocaleUpsertImageLinkListRelationInput"]: {
		update: GraphQLTypes["ImageLinkListUpdateInput"],
	create: GraphQLTypes["ImageLinkListCreateInput"]
};
	["LocaleUpsertFootersRelationInput"]: {
		by: GraphQLTypes["FooterLocaleUniqueWhere"],
	update: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateGenericPageAboutSettingsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertGenericPageAboutSettingsRelationInput"] | undefined,
	connect?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGenericPageAboutSettingsRelationInput"]: {
		by: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	data: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined,
	linkGroups?: Array<GraphQLTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageAboutSettingsUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageAboutSettingsLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GenericPageAboutSettingsWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"],
	create: GraphQLTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"]
};
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"] | undefined,
	update?: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"] | undefined,
	connect?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"]: {
		by: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	data: GraphQLTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"]
};
	["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"]: {
		order?: number | undefined,
	linkList?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"] | undefined,
	update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"]: {
		update: GraphQLTypes["LinkListUpdateInput"],
	create: GraphQLTypes["LinkListCreateInput"]
};
	["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"]: {
		by: GraphQLTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"],
	update: GraphQLTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"],
	create: GraphQLTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]
};
	["LocaleUpsertGenericPageAboutSettingsRelationInput"]: {
		by: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	update: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdatePostRevisionsEntityRelationInput"]: {
		create?: GraphQLTypes["PostRevisionLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdatePostRevisionsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertPostRevisionsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePostRevisionsRelationInput"]: {
		by: GraphQLTypes["PostRevisionLocaleUniqueWhere"],
	data: GraphQLTypes["PostRevisionLocaleWithoutLocaleUpdateInput"]
};
	["PostRevisionLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["PostRevisionLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined,
	leadContent?: GraphQLTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostRevisionWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["PostRevisionWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostRevisionWithoutLocalesUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	createdById?: GraphQLTypes["UUID"] | undefined,
	publishedById?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["PostType"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	post?: GraphQLTypes["PostRevisionUpdatePostEntityRelationInput"] | undefined,
	tileImage?: GraphQLTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined,
	tileVideo?: GraphQLTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined,
	heroImage?: GraphQLTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined,
	regionListOverride?: GraphQLTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionUpdatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutRevisionsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreatePostRelationInput"] | undefined,
	update?: GraphQLTypes["PostWithoutRevisionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionUpsertPostRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostWithoutRevisionsUpdateInput"]: {
		organization?: GraphQLTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateActiveRevisionEntityRelationInput"]: {
		connect?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostRevisionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateActiveRevisionRelationInput"] | undefined,
	update?: GraphQLTypes["PostRevisionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertActiveRevisionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	createdById?: GraphQLTypes["UUID"] | undefined,
	publishedById?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["PostType"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	post?: GraphQLTypes["PostRevisionUpdatePostEntityRelationInput"] | undefined,
	tileImage?: GraphQLTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined,
	tileVideo?: GraphQLTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined,
	heroImage?: GraphQLTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostRevisionUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionUpdateTileImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateTileImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionUpsertTileImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpsertTileImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostRevisionUpdateTileVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateTileVideoRelationInput"] | undefined,
	update?: GraphQLTypes["VideoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionUpsertTileVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpsertTileVideoRelationInput"]: {
		update: GraphQLTypes["VideoUpdateInput"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["PostRevisionUpdateHeroImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateHeroImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionUpsertHeroImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpsertHeroImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostRevisionUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PostRevisionLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["PostRevisionUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostRevisionLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostRevisionUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["PostRevisionLocaleUniqueWhere"],
	data: GraphQLTypes["PostRevisionLocaleWithoutRootUpdateInput"]
};
	["PostRevisionLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	locale?: GraphQLTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined,
	leadContent?: GraphQLTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPostRevisionsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutPostRevisionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPostRevisionsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateFlagImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateFlagImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertFlagImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LocaleUpsertFlagImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleUpdateFeedPagesEntityRelationInput"]: {
		create?: GraphQLTypes["FeedPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateFeedPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertFeedPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateFeedPagesRelationInput"]: {
		by: GraphQLTypes["FeedPageLocaleUniqueWhere"],
	data: GraphQLTypes["FeedPageLocaleWithoutLocaleUpdateInput"]
};
	["FeedPageLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined,
	heroTiles?: GraphQLTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<GraphQLTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined,
	cardList?: GraphQLTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["FeedPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FeedPageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["FeedPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["FeedPageWithoutLocalesCreateInput"]
};
	["FeedPageLocaleUpdateHeroTilesEntityRelationInput"]: {
		connect?: GraphQLTypes["TileListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TileListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"] | undefined,
	update?: GraphQLTypes["TileListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageLocaleUpsertHeroTilesRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileListUpdateInput"]: {
		size?: GraphQLTypes["TileListSize"] | undefined,
	title?: string | undefined,
	items?: Array<GraphQLTypes["TileListUpdateItemsEntityRelationInput"]> | undefined,
	areaType?: GraphQLTypes["TileListUpdateAreaTypeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["TileItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["TileListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TileListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["TileItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TileItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TileItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TileListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["TileItemUniqueWhere"],
	data: GraphQLTypes["TileItemWithoutListUpdateInput"]
};
	["TileItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	type?: GraphQLTypes["TileItemType"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	post?: GraphQLTypes["TileItemUpdatePostEntityRelationInput"] | undefined,
	area?: GraphQLTypes["TileItemUpdateAreaEntityRelationInput"] | undefined,
	image?: GraphQLTypes["TileItemUpdateImageEntityRelationInput"] | undefined,
	link?: GraphQLTypes["TileItemUpdateLinkEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["TileItemUpdateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemUpdatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreatePostRelationInput"] | undefined,
	update?: GraphQLTypes["PostUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileItemUpsertPostRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostUpdateInput"]: {
		organization?: GraphQLTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateRevisionsEntityRelationInput"]: {
		create?: GraphQLTypes["PostRevisionWithoutPostCreateInput"] | undefined,
	update?: GraphQLTypes["PostUpdateRevisionsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertRevisionsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostRevisionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateRevisionsRelationInput"]: {
		by: GraphQLTypes["PostRevisionUniqueWhere"],
	data: GraphQLTypes["PostRevisionWithoutPostUpdateInput"]
};
	["PostRevisionWithoutPostUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	createdById?: GraphQLTypes["UUID"] | undefined,
	publishedById?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["PostType"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	tileImage?: GraphQLTypes["PostRevisionUpdateTileImageEntityRelationInput"] | undefined,
	tileVideo?: GraphQLTypes["PostRevisionUpdateTileVideoEntityRelationInput"] | undefined,
	heroImage?: GraphQLTypes["PostRevisionUpdateHeroImageEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostRevisionUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"] | undefined,
	isOrganizationVisible?: boolean | undefined,
	sendPublishNotifications?: boolean | undefined,
	isArchived?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionUpdateRegionListOverrideEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"] | undefined,
	update?: GraphQLTypes["DonationAmountsRegionListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionUpsertRegionListOverrideRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionUpsertRegionListOverrideRelationInput"]: {
		update: GraphQLTypes["DonationAmountsRegionListUpdateInput"],
	create: GraphQLTypes["DonationAmountsRegionListCreateInput"]
};
	["PostUpsertRevisionsRelationInput"]: {
		by: GraphQLTypes["PostRevisionUniqueWhere"],
	update: GraphQLTypes["PostRevisionWithoutPostUpdateInput"],
	create: GraphQLTypes["PostRevisionWithoutPostCreateInput"]
};
	["PostUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PostLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["PostUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["PostLocaleUniqueWhere"],
	data: GraphQLTypes["PostLocaleWithoutRootUpdateInput"]
};
	["PostLocaleWithoutRootUpdateInput"]: {
		content?: GraphQLTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutPostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutPostUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutPostUpdateInput"]: {
		url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdatePostOrganizationEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreatePostOrganizationRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertPostOrganizationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationLocaleWithoutLinkUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	domain?: GraphQLTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPostOrganizationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutPostOrganizationsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPostOrganizationsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]: {
		create?: GraphQLTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateRecurringPaymentPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertRecurringPaymentPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateRecurringPaymentPagesRelationInput"]: {
		by: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"],
	data: GraphQLTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"]
};
	["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"] | undefined,
	favouritePosts?: GraphQLTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["RecurringPaymentPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecurringPaymentPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["RecurringPaymentPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RecurringPaymentPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["RecurringPaymentPageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["RecurringPaymentPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["RecurringPaymentPageWithoutLocalesCreateInput"]
};
	["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"] | undefined,
	update?: GraphQLTypes["PostListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostListUpdateInput"]: {
		items?: Array<GraphQLTypes["PostListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["PostListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["PostListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["PostListItemUniqueWhere"],
	data: GraphQLTypes["PostListItemWithoutListUpdateInput"]
};
	["PostListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	post?: GraphQLTypes["PostListItemUpdatePostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemUpdatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostListItemConnectOrCreatePostRelationInput"] | undefined,
	update?: GraphQLTypes["PostUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostListItemUpsertPostRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostListItemUpsertPostRelationInput"]: {
		update: GraphQLTypes["PostUpdateInput"],
	create: GraphQLTypes["PostCreateInput"]
};
	["PostListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["PostListItemUniqueWhere"],
	update: GraphQLTypes["PostListItemWithoutListUpdateInput"],
	create: GraphQLTypes["PostListItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"]: {
		update: GraphQLTypes["PostListUpdateInput"],
	create: GraphQLTypes["PostListCreateInput"]
};
	["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined,
	update?: GraphQLTypes["StoryGuideListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StoryGuideListUpdateInput"]: {
		items?: Array<GraphQLTypes["StoryGuideListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["StoryGuideItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["StoryGuideListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["StoryGuideListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["StoryGuideItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["StoryGuideItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["StoryGuideItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StoryGuideListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["StoryGuideItemUniqueWhere"],
	data: GraphQLTypes["StoryGuideItemWithoutListUpdateInput"]
};
	["StoryGuideItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	guide?: GraphQLTypes["StoryGuideItemUpdateGuideEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemUpdateGuideEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideItemConnectOrCreateGuideRelationInput"] | undefined,
	update?: GraphQLTypes["StoryGuideUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StoryGuideItemUpsertGuideRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StoryGuideUpdateInput"]: {
		mediaType?: GraphQLTypes["MediaType"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	image?: GraphQLTypes["StoryGuideUpdateImageEntityRelationInput"] | undefined,
	secondaryImage?: GraphQLTypes["StoryGuideUpdateSecondaryImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StoryGuideUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StoryGuideUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["StoryGuideUpdateSecondaryImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StoryGuideUpsertSecondaryImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StoryGuideUpsertSecondaryImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["StoryGuideItemUpsertGuideRelationInput"]: {
		update: GraphQLTypes["StoryGuideUpdateInput"],
	create: GraphQLTypes["StoryGuideCreateInput"]
};
	["StoryGuideListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["StoryGuideItemUniqueWhere"],
	update: GraphQLTypes["StoryGuideItemWithoutListUpdateInput"],
	create: GraphQLTypes["StoryGuideItemWithoutListCreateInput"]
};
	["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"]: {
		update: GraphQLTypes["StoryGuideListUpdateInput"],
	create: GraphQLTypes["StoryGuideListCreateInput"]
};
	["LocaleUpsertRecurringPaymentPagesRelationInput"]: {
		by: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"],
	update: GraphQLTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGivenGiftsPagesEntityRelationInput"]: {
		create?: GraphQLTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateGivenGiftsPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertGivenGiftsPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGivenGiftsPagesRelationInput"]: {
		by: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"],
	data: GraphQLTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"]
};
	["GivenGiftsPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GivenGiftsPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["GivenGiftsPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["GivenGiftsPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GivenGiftsPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GivenGiftsPageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["GivenGiftsPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["GivenGiftsPageWithoutLocalesCreateInput"]
};
	["GivenGiftsPageLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GivenGiftsPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GivenGiftsPageLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GivenGiftsPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GivenGiftsPageLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutGivenGiftsPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutGivenGiftsPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GivenGiftsPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutGivenGiftsPageUpdateInput"]: {
		url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateReportPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateReportPageRelationInput"] | undefined,
	update?: GraphQLTypes["ReportPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertReportPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReportPageLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	root?: GraphQLTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	posts?: Array<GraphQLTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["ReportPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReportPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ReportPageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["ReportPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["ReportPageWithoutLocalesCreateInput"]
};
	["ReportPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutReportPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutReportPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReportPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutReportPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]: {
		create?: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateReceivedGiftsPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertReceivedGiftsPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateReceivedGiftsPagesRelationInput"]: {
		by: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	data: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"]
};
	["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutReceivedGiftsPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutReceivedGiftsPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReceivedGiftsPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutReceivedGiftsPageUpdateInput"]: {
		url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateGivenGiftsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"] | undefined,
	update?: GraphQLTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertGivenGiftsPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GivenGiftsPageLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGivenGiftsPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutGivenGiftsPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GivenGiftsPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGivenGiftsPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateReportPagesEntityRelationInput"]: {
		create?: GraphQLTypes["ReportPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateReportPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertReportPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateReportPagesRelationInput"]: {
		by: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	data: GraphQLTypes["ReportPageLocaleWithoutLocaleUpdateInput"]
};
	["ReportPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	posts?: Array<GraphQLTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutReportPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutReportPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReportPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutReportPageUpdateInput"]: {
		url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateReceivedGiftsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"] | undefined,
	update?: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertReceivedGiftsPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ReceivedGiftsPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReceivedGiftsPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReceivedGiftsPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ReceivedGiftsPageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["ReceivedGiftsPageWithoutLocalesCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutReceivedGiftsPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutReceivedGiftsPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateReportNavigationsEntityRelationInput"]: {
		create?: GraphQLTypes["ReportNavigationLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateReportNavigationsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertReportNavigationsRelationInput"] | undefined,
	connect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateReportNavigationsRelationInput"]: {
		by: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	data: GraphQLTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"]
};
	["ReportNavigationLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined,
	pages?: Array<GraphQLTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleUpdatePagesEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageWithoutReportNavigationCreateInput"] | undefined,
	update?: GraphQLTypes["ReportNavigationLocaleUpdatePagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ReportNavigationLocaleUpsertPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationLocaleUpdatePagesRelationInput"]: {
		by: GraphQLTypes["GenericPageUniqueWhere"],
	data: GraphQLTypes["GenericPageWithoutReportNavigationUpdateInput"]
};
	["GenericPageWithoutReportNavigationUpdateInput"]: {
		locales?: Array<GraphQLTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined,
	type?: GraphQLTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["GenericPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	data: GraphQLTypes["GenericPageLocaleWithoutRootUpdateInput"]
};
	["GenericPageLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	locale?: GraphQLTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutGenericPageUpdateInput"]: {
		url?: string | undefined,
	post?: GraphQLTypes["LinkableUpdatePostEntityRelationInput"] | undefined,
	postArea?: GraphQLTypes["LinkableUpdatePostAreaEntityRelationInput"] | undefined,
	postOrganization?: GraphQLTypes["LinkableUpdatePostOrganizationEntityRelationInput"] | undefined,
	reportPage?: GraphQLTypes["LinkableUpdateReportPageEntityRelationInput"] | undefined,
	givenGiftsPage?: GraphQLTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"] | undefined,
	receivedGiftsPage?: GraphQLTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	update: GraphQLTypes["GenericPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["ReportNavigationLocaleUpsertPagesRelationInput"]: {
		by: GraphQLTypes["GenericPageUniqueWhere"],
	update: GraphQLTypes["GenericPageWithoutReportNavigationUpdateInput"],
	create: GraphQLTypes["GenericPageWithoutReportNavigationCreateInput"]
};
	["LocaleUpsertReportNavigationsRelationInput"]: {
		by: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	update: GraphQLTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["ReportNavigationLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateScheduledNotificationsEntityRelationInput"]: {
		create?: GraphQLTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateScheduledNotificationsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertScheduledNotificationsRelationInput"] | undefined,
	connect?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateScheduledNotificationsRelationInput"]: {
		by: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"],
	data: GraphQLTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"]
};
	["ScheduledNotificationLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ScheduledNotificationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ScheduledNotificationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["ScheduledNotificationWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ScheduledNotificationLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ScheduledNotificationWithoutLocalesUpdateInput"]: {
		localMsFromMidnight?: number | undefined,
	scheduledDate?: GraphQLTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: GraphQLTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined,
	completedAt?: GraphQLTypes["DateTime"] | undefined,
	processedNotifications?: Array<GraphQLTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationUpdateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["NotificationTargetGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["NotificationTargetGroupCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"] | undefined,
	update?: GraphQLTypes["NotificationTargetGroupUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ScheduledNotificationUpsertTargetRelationInput"] | undefined
};
	["NotificationTargetGroupUpdateInput"]: {
		type?: GraphQLTypes["NotificationTargetType"] | undefined,
	regions?: Array<GraphQLTypes["NotificationTargetGroupUpdateRegionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["NotificationTargetGroupUpdateRegionsEntityRelationInput"]: {
		create?: GraphQLTypes["RegionCreateInput"] | undefined,
	update?: GraphQLTypes["NotificationTargetGroupUpdateRegionsRelationInput"] | undefined,
	upsert?: GraphQLTypes["NotificationTargetGroupUpsertRegionsRelationInput"] | undefined,
	connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["NotificationTargetGroupUpdateRegionsRelationInput"]: {
		by: GraphQLTypes["RegionUniqueWhere"],
	data: GraphQLTypes["RegionUpdateInput"]
};
	["NotificationTargetGroupUpsertRegionsRelationInput"]: {
		by: GraphQLTypes["RegionUniqueWhere"],
	update: GraphQLTypes["RegionUpdateInput"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["ScheduledNotificationUpsertTargetRelationInput"]: {
		update: GraphQLTypes["NotificationTargetGroupUpdateInput"],
	create: GraphQLTypes["NotificationTargetGroupCreateInput"]
};
	["ScheduledNotificationUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ScheduledNotificationUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ScheduledNotificationUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]: {
		create?: GraphQLTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"] | undefined,
	update?: GraphQLTypes["ScheduledNotificationUpdateProcessedNotificationsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ScheduledNotificationUpsertProcessedNotificationsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ScheduledNotificationUpdateProcessedNotificationsRelationInput"]: {
		by: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"],
	data: GraphQLTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"]
};
	["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"]: {
		type?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined,
	donationReminderUser?: GraphQLTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"]: {
		connect?: GraphQLTypes["ProcessedNotificationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProcessedNotificationWithoutSourceCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"] | undefined,
	update?: GraphQLTypes["ProcessedNotificationWithoutSourceUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProcessedNotificationWithoutSourceUpdateInput"]: {
		topic?: string | undefined,
	sentAt?: GraphQLTypes["DateTime"] | undefined,
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess?: boolean | undefined,
	title?: string | undefined,
	body?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"]: {
		update: GraphQLTypes["ProcessedNotificationWithoutSourceUpdateInput"],
	create: GraphQLTypes["ProcessedNotificationWithoutSourceCreateInput"]
};
	["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutProcessedNotificationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"] | undefined,
	update?: GraphQLTypes["UserWithoutProcessedNotificationsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutProcessedNotificationsUpdateInput"]: {
		tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdatePaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["UserPaymentWithoutUserCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdatePaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdatePaymentsRelationInput"]: {
		by: GraphQLTypes["UserPaymentUniqueWhere"],
	data: GraphQLTypes["UserPaymentWithoutUserUpdateInput"]
};
	["UserPaymentWithoutUserUpdateInput"]: {
		cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpdateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: GraphQLTypes["CurrencyUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertCurrencyRelationInput"] | undefined
};
	["UserPaymentUpsertCurrencyRelationInput"]: {
		update: GraphQLTypes["CurrencyUpdateInput"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["UserPaymentUpdateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentOrderIdUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentOrderIdCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateOrderRelationInput"] | undefined,
	update?: GraphQLTypes["UserPaymentOrderIdUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertOrderRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentOrderIdUpdateInput"]: {
		seq?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpsertOrderRelationInput"]: {
		update: GraphQLTypes["UserPaymentOrderIdUpdateInput"],
	create: GraphQLTypes["UserPaymentOrderIdCreateInput"]
};
	["UserPaymentUpdateCsobPaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["CsobPaymentWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"] | undefined,
	update?: GraphQLTypes["CsobPaymentWithoutPaymentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertCsobPaymentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CsobPaymentWithoutPaymentUpdateInput"]: {
		payId?: string | undefined,
	statusChanges?: Array<GraphQLTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"]> | undefined,
	originalPayId?: string | undefined,
	metadata?: GraphQLTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentUpdateStatusChangesEntityRelationInput"]: {
		create?: GraphQLTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"] | undefined,
	update?: GraphQLTypes["CsobPaymentUpdateStatusChangesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CsobPaymentUpsertStatusChangesRelationInput"] | undefined,
	connect?: GraphQLTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CsobPaymentStatusChangeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CsobPaymentUpdateStatusChangesRelationInput"]: {
		by: GraphQLTypes["CsobPaymentStatusChangeUniqueWhere"],
	data: GraphQLTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"]
};
	["CsobPaymentStatusChangeWithoutPaymentUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	dttm?: string | undefined,
	status?: number | undefined,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentUpsertStatusChangesRelationInput"]: {
		by: GraphQLTypes["CsobPaymentStatusChangeUniqueWhere"],
	update: GraphQLTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"],
	create: GraphQLTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"]
};
	["CsobPaymentUpdateMetadataEntityRelationInput"]: {
		connect?: GraphQLTypes["CsobPaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentUpsertCsobPaymentRelationInput"]: {
		update: GraphQLTypes["CsobPaymentWithoutPaymentUpdateInput"],
	create: GraphQLTypes["CsobPaymentWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateStripePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["StripePaymentWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"] | undefined,
	update?: GraphQLTypes["StripePaymentWithoutPaymentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertStripePaymentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StripePaymentWithoutPaymentUpdateInput"]: {
		identifier?: string | undefined,
	statusChanges?: Array<GraphQLTypes["StripePaymentUpdateStatusChangesEntityRelationInput"]> | undefined,
	metadata?: GraphQLTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentUpdateStatusChangesEntityRelationInput"]: {
		create?: GraphQLTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"] | undefined,
	update?: GraphQLTypes["StripePaymentUpdateStatusChangesRelationInput"] | undefined,
	upsert?: GraphQLTypes["StripePaymentUpsertStatusChangesRelationInput"] | undefined,
	connect?: GraphQLTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	delete?: GraphQLTypes["StripePaymentStatusChangeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StripePaymentUpdateStatusChangesRelationInput"]: {
		by: GraphQLTypes["StripePaymentStatusChangeUniqueWhere"],
	data: GraphQLTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"]
};
	["StripePaymentStatusChangeWithoutPaymentUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	timestamp?: number | undefined,
	eventId?: string | undefined,
	paymentIntentStatus?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentUpsertStatusChangesRelationInput"]: {
		by: GraphQLTypes["StripePaymentStatusChangeUniqueWhere"],
	update: GraphQLTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"],
	create: GraphQLTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"]
};
	["StripePaymentUpdateMetadataEntityRelationInput"]: {
		connect?: GraphQLTypes["StripePaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentUpsertStripePaymentRelationInput"]: {
		update: GraphQLTypes["StripePaymentWithoutPaymentUpdateInput"],
	create: GraphQLTypes["StripePaymentWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"] | undefined,
	update?: GraphQLTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertRecurringPaymentItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentItemWithoutPaymentsUpdateInput"]: {
		recurrenceCounter?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"] | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserRecurringPaymentWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"] | undefined,
	update?: GraphQLTypes["UserRecurringPaymentWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentWithoutItemsUpdateInput"]: {
		activeSince?: GraphQLTypes["DateTime"] | undefined,
	cancelledAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: GraphQLTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserRecurringPaymentUpdateUserEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentUpdateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: GraphQLTypes["CurrencyUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserRecurringPaymentUpsertCurrencyRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentUpsertCurrencyRelationInput"]: {
		update: GraphQLTypes["CurrencyUpdateInput"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["UserRecurringPaymentUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutRecurringPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"] | undefined,
	update?: GraphQLTypes["UserWithoutRecurringPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserRecurringPaymentUpsertUserRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutRecurringPaymentsUpdateInput"]: {
		tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<GraphQLTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateRegionRelationInput"] | undefined,
	update?: GraphQLTypes["RegionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertRegionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserUpsertRegionRelationInput"]: {
		update: GraphQLTypes["RegionUpdateInput"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["UserUpdateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: GraphQLTypes["CurrencyUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertCurrencyRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserUpsertCurrencyRelationInput"]: {
		update: GraphQLTypes["CurrencyUpdateInput"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["UserUpdateOnBehalfDonationsEntityRelationInput"]: {
		create?: GraphQLTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdateOnBehalfDonationsRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertOnBehalfDonationsRelationInput"] | undefined,
	connect?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateOnBehalfDonationsRelationInput"]: {
		by: GraphQLTypes["OnBehalfDonationUniqueWhere"],
	data: GraphQLTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"]
};
	["OnBehalfDonationWithoutOnBehalfOfUpdateInput"]: {
		secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	payments?: Array<GraphQLTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"]> | undefined,
	meta?: GraphQLTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OnBehalfDonationUpdatePaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["UserPaymentWithoutOnBehalfDonationCreateInput"] | undefined,
	update?: GraphQLTypes["OnBehalfDonationUpdatePaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OnBehalfDonationUpsertPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OnBehalfDonationUpdatePaymentsRelationInput"]: {
		by: GraphQLTypes["UserPaymentUniqueWhere"],
	data: GraphQLTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"]
};
	["UserPaymentWithoutOnBehalfDonationUpdateInput"]: {
		cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	triesCollection?: GraphQLTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpdateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateRegionRelationInput"] | undefined,
	update?: GraphQLTypes["RegionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertRegionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentUpsertRegionRelationInput"]: {
		update: GraphQLTypes["RegionUpdateInput"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["UserPaymentUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateUserRelationInput"] | undefined,
	update?: GraphQLTypes["UserWithoutPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertUserRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutPaymentsUpdateInput"]: {
		tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<GraphQLTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateRecurringPaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["UserRecurringPaymentWithoutUserCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdateRecurringPaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertRecurringPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateRecurringPaymentsRelationInput"]: {
		by: GraphQLTypes["UserRecurringPaymentUniqueWhere"],
	data: GraphQLTypes["UserRecurringPaymentWithoutUserUpdateInput"]
};
	["UserRecurringPaymentWithoutUserUpdateInput"]: {
		activeSince?: GraphQLTypes["DateTime"] | undefined,
	cancelledAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: GraphQLTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"]> | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"] | undefined,
	update?: GraphQLTypes["UserRecurringPaymentUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserRecurringPaymentUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserRecurringPaymentUpdateItemsRelationInput"]: {
		by: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"],
	data: GraphQLTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"]
};
	["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"]: {
		recurrenceCounter?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	payments?: Array<GraphQLTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]> | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"] | undefined,
	update?: GraphQLTypes["UserRecurringPaymentItemUpdatePaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserRecurringPaymentItemUpsertPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserRecurringPaymentItemUpdatePaymentsRelationInput"]: {
		by: GraphQLTypes["UserPaymentUniqueWhere"],
	data: GraphQLTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"]
};
	["UserPaymentWithoutRecurringPaymentItemUpdateInput"]: {
		cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpdateOnBehalfDonationEntityRelationInput"]: {
		connect?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: GraphQLTypes["OnBehalfDonationWithoutPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"] | undefined,
	update?: GraphQLTypes["OnBehalfDonationWithoutPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertOnBehalfDonationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OnBehalfDonationWithoutPaymentsUpdateInput"]: {
		secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	onBehalfOf?: GraphQLTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutOnBehalfDonationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"] | undefined,
	update?: GraphQLTypes["UserWithoutOnBehalfDonationsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OnBehalfDonationUpsertOnBehalfOfRelationInput"] | undefined
};
	["UserWithoutOnBehalfDonationsUpdateInput"]: {
		tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<GraphQLTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertLocaleRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LocaleUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateSentPaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["SentPaymentLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateSentPaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertSentPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SentPaymentLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateSentPaymentsRelationInput"]: {
		by: GraphQLTypes["SentPaymentLocaleUniqueWhere"],
	data: GraphQLTypes["SentPaymentLocaleWithoutLocaleUpdateInput"]
};
	["SentPaymentLocaleWithoutLocaleUpdateInput"]: {
		organizationText?: string | undefined,
	root?: GraphQLTypes["SentPaymentLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["SentPaymentWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["SentPaymentWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SentPaymentLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["SentPaymentWithoutLocalesUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: GraphQLTypes["DateTime"] | undefined,
	currency?: GraphQLTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	area?: GraphQLTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentUpdateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaWithoutSentPaymentsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SentPaymentConnectOrCreateAreaRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaWithoutSentPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SentPaymentUpsertAreaRelationInput"] | undefined
};
	["PostAreaWithoutSentPaymentsUpdateInput"]: {
		order?: number | undefined,
	icon?: GraphQLTypes["PostAreaUpdateIconEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PostAreaUpdateLocalesEntityRelationInput"]> | undefined,
	regionListOverride?: GraphQLTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"] | undefined,
	color?: string | undefined,
	posts?: Array<GraphQLTypes["PostAreaUpdatePostsEntityRelationInput"]> | undefined,
	specificSymbol?: number | undefined,
	region?: GraphQLTypes["PostAreaUpdateRegionEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["PostAreaUpdateMetaEntityRelationInput"] | undefined,
	mobileHeroImage?: GraphQLTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"] | undefined,
	plainIcon?: GraphQLTypes["PostAreaUpdatePlainIconEntityRelationInput"] | undefined,
	areaSentPaymentCurrencySums?: Array<GraphQLTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]> | undefined,
	areaSentPaymentSum?: GraphQLTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"] | undefined,
	areaCurrencySums?: Array<GraphQLTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]> | undefined,
	areaSum?: GraphQLTypes["PostAreaUpdateAreaSumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostAreaSentPaymentCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaSentPaymentSumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostAreaCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaUpdateAreaSumEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaSumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SentPaymentUpsertAreaRelationInput"]: {
		update: GraphQLTypes["PostAreaWithoutSentPaymentsUpdateInput"],
	create: GraphQLTypes["PostAreaWithoutSentPaymentsCreateInput"]
};
	["SentPaymentLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["SentPaymentWithoutLocalesUpdateInput"],
	create: GraphQLTypes["SentPaymentWithoutLocalesCreateInput"]
};
	["LocaleUpsertSentPaymentsRelationInput"]: {
		by: GraphQLTypes["SentPaymentLocaleUniqueWhere"],
	update: GraphQLTypes["SentPaymentLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["SentPaymentLocaleWithoutLocaleCreateInput"]
};
	["UserUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleUpdateInput"],
	create: GraphQLTypes["LocaleCreateInput"]
};
	["UserUpdateDevicesEntityRelationInput"]: {
		create?: GraphQLTypes["DeviceWithoutUserCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdateDevicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertDevicesRelationInput"] | undefined,
	connect?: GraphQLTypes["DeviceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeviceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateDevicesRelationInput"]: {
		by: GraphQLTypes["DeviceUniqueWhere"],
	data: GraphQLTypes["DeviceWithoutUserUpdateInput"]
};
	["DeviceWithoutUserUpdateInput"]: {
		fcmToken?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpsertDevicesRelationInput"]: {
		by: GraphQLTypes["DeviceUniqueWhere"],
	update: GraphQLTypes["DeviceWithoutUserUpdateInput"],
	create: GraphQLTypes["DeviceWithoutUserCreateInput"]
};
	["UserUpdateProcessedNotificationsEntityRelationInput"]: {
		create?: GraphQLTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdateProcessedNotificationsRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertProcessedNotificationsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateProcessedNotificationsRelationInput"]: {
		by: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"],
	data: GraphQLTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"]
};
	["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"]: {
		type?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined,
	scheduledNotification?: GraphQLTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"]: {
		connect?: GraphQLTypes["ScheduledNotificationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"] | undefined,
	update?: GraphQLTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"]: {
		localMsFromMidnight?: number | undefined,
	scheduledDate?: GraphQLTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: GraphQLTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined,
	completedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ScheduledNotificationLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ScheduledNotificationUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ScheduledNotificationUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ScheduledNotificationUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"],
	data: GraphQLTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"]
};
	["ScheduledNotificationLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	description?: string | undefined,
	locale?: GraphQLTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutScheduledNotificationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutScheduledNotificationsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ScheduledNotificationLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutScheduledNotificationsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutScheduledNotificationsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutScheduledNotificationsCreateInput"]
};
	["ScheduledNotificationUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"],
	update: GraphQLTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["ScheduledNotificationLocaleWithoutRootCreateInput"]
};
	["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"]: {
		update: GraphQLTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"],
	create: GraphQLTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]
};
	["UserUpsertProcessedNotificationsRelationInput"]: {
		by: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"],
	update: GraphQLTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"],
	create: GraphQLTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]
};
	["UserUpdateAreaStatsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserAreaStatsUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserAreaStatsUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserAreaStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateOrganizationStatsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserOrganizationStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdatePostStatsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPostStatsUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserPostStatsUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserPostStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateCurrencyStatsEntityRelationInput"]: {
		connect?: GraphQLTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserCurrencyStatsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OnBehalfDonationUpsertOnBehalfOfRelationInput"]: {
		update: GraphQLTypes["UserWithoutOnBehalfDonationsUpdateInput"],
	create: GraphQLTypes["UserWithoutOnBehalfDonationsCreateInput"]
};
	["OnBehalfDonationUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["OnBehalfDonationMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentUpsertOnBehalfDonationRelationInput"]: {
		update: GraphQLTypes["OnBehalfDonationWithoutPaymentsUpdateInput"],
	create: GraphQLTypes["OnBehalfDonationWithoutPaymentsCreateInput"]
};
	["UserPaymentUpdateTriesCollectionEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentTriesCollectionUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"] | undefined,
	update?: GraphQLTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentUpsertTriesCollectionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentTriesCollectionWithoutPaymentUpdateInput"]: {
		cents?: number | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	orderUrl?: string | undefined,
	user?: GraphQLTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"] | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	recurring?: GraphQLTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"] | undefined,
	metadataLocales?: Array<GraphQLTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]> | undefined,
	medium?: GraphQLTypes["PaymentMedium"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"] | undefined,
	update?: GraphQLTypes["UserUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentTriesCollectionUpsertUserRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserUpdateInput"]: {
		tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	processedNotifications?: Array<GraphQLTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserUpdateInput"],
	create: GraphQLTypes["UserCreateInput"]
};
	["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"] | undefined,
	update?: GraphQLTypes["CurrencyUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentTriesCollectionUpsertCurrencyRelationInput"] | undefined
};
	["UserPaymentTriesCollectionUpsertCurrencyRelationInput"]: {
		update: GraphQLTypes["CurrencyUpdateInput"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"]: {
		connect?: GraphQLTypes["OnBehalfDonationUniqueWhere"] | undefined,
	create?: GraphQLTypes["OnBehalfDonationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"] | undefined,
	update?: GraphQLTypes["OnBehalfDonationUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OnBehalfDonationUpdateInput"]: {
		secretCode?: string | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	payments?: Array<GraphQLTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"]> | undefined,
	onBehalfOf?: GraphQLTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OnBehalfDonationUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"]: {
		update: GraphQLTypes["OnBehalfDonationUpdateInput"],
	create: GraphQLTypes["OnBehalfDonationCreateInput"]
};
	["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserRecurringPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"] | undefined,
	update?: GraphQLTypes["UserRecurringPaymentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentTriesCollectionUpsertRecurringRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentUpdateInput"]: {
		activeSince?: GraphQLTypes["DateTime"] | undefined,
	cancelledAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	interval?: GraphQLTypes["UserRecurringPaymentInterval"] | undefined,
	currency?: GraphQLTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"]> | undefined,
	user?: GraphQLTypes["UserRecurringPaymentUpdateUserEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentTriesCollectionUpsertRecurringRelationInput"]: {
		update: GraphQLTypes["UserRecurringPaymentUpdateInput"],
	create: GraphQLTypes["UserRecurringPaymentCreateInput"]
};
	["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserPaymentUpsertTriesCollectionRelationInput"]: {
		update: GraphQLTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"],
	create: GraphQLTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"]
};
	["UserPaymentUpdateMetadataEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentItemUpsertPaymentsRelationInput"]: {
		by: GraphQLTypes["UserPaymentUniqueWhere"],
	update: GraphQLTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"],
	create: GraphQLTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"]
};
	["UserRecurringPaymentItemUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRecurringPaymentItemMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserRecurringPaymentUpsertItemsRelationInput"]: {
		by: GraphQLTypes["UserRecurringPaymentItemUniqueWhere"],
	update: GraphQLTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"],
	create: GraphQLTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]
};
	["UserUpsertRecurringPaymentsRelationInput"]: {
		by: GraphQLTypes["UserRecurringPaymentUniqueWhere"],
	update: GraphQLTypes["UserRecurringPaymentWithoutUserUpdateInput"],
	create: GraphQLTypes["UserRecurringPaymentWithoutUserCreateInput"]
};
	["UserPaymentUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutPaymentsUpdateInput"],
	create: GraphQLTypes["UserWithoutPaymentsCreateInput"]
};
	["OnBehalfDonationUpsertPaymentsRelationInput"]: {
		by: GraphQLTypes["UserPaymentUniqueWhere"],
	update: GraphQLTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"],
	create: GraphQLTypes["UserPaymentWithoutOnBehalfDonationCreateInput"]
};
	["UserUpsertOnBehalfDonationsRelationInput"]: {
		by: GraphQLTypes["OnBehalfDonationUniqueWhere"],
	update: GraphQLTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"],
	create: GraphQLTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"]
};
	["UserRecurringPaymentUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutRecurringPaymentsUpdateInput"],
	create: GraphQLTypes["UserWithoutRecurringPaymentsCreateInput"]
};
	["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"]: {
		update: GraphQLTypes["UserRecurringPaymentWithoutItemsUpdateInput"],
	create: GraphQLTypes["UserRecurringPaymentWithoutItemsCreateInput"]
};
	["UserPaymentUpsertRecurringPaymentItemRelationInput"]: {
		update: GraphQLTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"],
	create: GraphQLTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"]
};
	["UserUpsertPaymentsRelationInput"]: {
		by: GraphQLTypes["UserPaymentUniqueWhere"],
	update: GraphQLTypes["UserPaymentWithoutUserUpdateInput"],
	create: GraphQLTypes["UserPaymentWithoutUserCreateInput"]
};
	["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutProcessedNotificationsUpdateInput"],
	create: GraphQLTypes["UserWithoutProcessedNotificationsCreateInput"]
};
	["ScheduledNotificationUpsertProcessedNotificationsRelationInput"]: {
		by: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"],
	update: GraphQLTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"],
	create: GraphQLTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]
};
	["ScheduledNotificationLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["ScheduledNotificationWithoutLocalesUpdateInput"],
	create: GraphQLTypes["ScheduledNotificationWithoutLocalesCreateInput"]
};
	["LocaleUpsertScheduledNotificationsRelationInput"]: {
		by: GraphQLTypes["ScheduledNotificationLocaleUniqueWhere"],
	update: GraphQLTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"]
};
	["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutReceivedGiftsPagesCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReceivedGiftsPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReceivedGiftsPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertReceivedGiftsPageRelationInput"]: {
		update: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReportPageLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutReportPageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutReportPageCreateInput"]
};
	["ReportPageLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReportPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReportPageLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ReportPageLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ReportPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ReportPageLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ReportPageLocaleUpdatePostsEntityRelationInput"]: {
		create?: GraphQLTypes["PostWithoutReportPageCreateInput"] | undefined,
	update?: GraphQLTypes["ReportPageLocaleUpdatePostsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ReportPageLocaleUpsertPostsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReportPageLocaleUpdatePostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	data: GraphQLTypes["PostWithoutReportPageUpdateInput"]
};
	["PostWithoutReportPageUpdateInput"]: {
		organization?: GraphQLTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostMetaDataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostUpdateHeroCarouselEntityRelationInput"]: {
		create?: GraphQLTypes["HeroCarouselWithoutPostsCreateInput"] | undefined,
	update?: GraphQLTypes["PostUpdateHeroCarouselRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertHeroCarouselRelationInput"] | undefined,
	connect?: GraphQLTypes["HeroCarouselUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HeroCarouselUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HeroCarouselUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateHeroCarouselRelationInput"]: {
		by: GraphQLTypes["HeroCarouselUniqueWhere"],
	data: GraphQLTypes["HeroCarouselWithoutPostsUpdateInput"]
};
	["HeroCarouselWithoutPostsUpdateInput"]: {
		createdAt?: GraphQLTypes["Date"] | undefined,
	items?: Array<GraphQLTypes["HeroCarouselUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["HeroCarouselItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["HeroCarouselUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["HeroCarouselUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["HeroCarouselItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HeroCarouselItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HeroCarouselItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeroCarouselUpdateItemsRelationInput"]: {
		by: GraphQLTypes["HeroCarouselItemUniqueWhere"],
	data: GraphQLTypes["HeroCarouselItemWithoutListUpdateInput"]
};
	["HeroCarouselItemWithoutListUpdateInput"]: {
		createdAt?: GraphQLTypes["Date"] | undefined,
	order?: number | undefined,
	item?: GraphQLTypes["HeroCarouselItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemUpdateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeroCarouselItemConnectOrCreateItemRelationInput"] | undefined,
	update?: GraphQLTypes["PostUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeroCarouselItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeroCarouselItemUpsertItemRelationInput"]: {
		update: GraphQLTypes["PostUpdateInput"],
	create: GraphQLTypes["PostCreateInput"]
};
	["HeroCarouselUpsertItemsRelationInput"]: {
		by: GraphQLTypes["HeroCarouselItemUniqueWhere"],
	update: GraphQLTypes["HeroCarouselItemWithoutListUpdateInput"],
	create: GraphQLTypes["HeroCarouselItemWithoutListCreateInput"]
};
	["PostUpsertHeroCarouselRelationInput"]: {
		by: GraphQLTypes["HeroCarouselUniqueWhere"],
	update: GraphQLTypes["HeroCarouselWithoutPostsUpdateInput"],
	create: GraphQLTypes["HeroCarouselWithoutPostsCreateInput"]
};
	["PostUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutPostsCreateInput"] | undefined,
	update?: GraphQLTypes["PostUpdateContentRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertContentRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateContentRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	data: GraphQLTypes["ContentReferenceWithoutPostsUpdateInput"]
};
	["ContentReferenceWithoutPostsUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	contentAlignment?: GraphQLTypes["ContentAlignment"] | undefined,
	valueList?: GraphQLTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined,
	areaList?: GraphQLTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: GraphQLTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	memberList?: GraphQLTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: GraphQLTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: GraphQLTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	textImageList?: GraphQLTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined,
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ContentBlockUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	create: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	create: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateValueListEntityRelationInput"]: {
		connect?: GraphQLTypes["ValueListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ValueListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateValueListRelationInput"] | undefined,
	update?: GraphQLTypes["ValueListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertValueListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ValueListUpdateInput"]: {
		items?: Array<GraphQLTypes["ValueListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ValueItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ValueListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ValueListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ValueItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ValueItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ValueItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ValueListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ValueItemUniqueWhere"],
	data: GraphQLTypes["ValueItemWithoutListUpdateInput"]
};
	["ValueItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	item?: GraphQLTypes["ValueItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemUpdateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ValueUniqueWhere"] | undefined,
	create?: GraphQLTypes["ValueCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ValueItemConnectOrCreateItemRelationInput"] | undefined,
	update?: GraphQLTypes["ValueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ValueItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ValueUpdateInput"]: {
		title?: string | undefined,
	textContent?: GraphQLTypes["ValueUpdateTextContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueUpdateTextContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ValueConnectOrCreateTextContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ValueUpsertTextContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ValueUpsertTextContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ValueItemUpsertItemRelationInput"]: {
		update: GraphQLTypes["ValueUpdateInput"],
	create: GraphQLTypes["ValueCreateInput"]
};
	["ValueListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ValueItemUniqueWhere"],
	update: GraphQLTypes["ValueItemWithoutListUpdateInput"],
	create: GraphQLTypes["ValueItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertValueListRelationInput"]: {
		update: GraphQLTypes["ValueListUpdateInput"],
	create: GraphQLTypes["ValueListCreateInput"]
};
	["ContentReferenceUpdateImageLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"] | undefined,
	update?: GraphQLTypes["ImageLinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertImageLinkListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertImageLinkListRelationInput"]: {
		update: GraphQLTypes["ImageLinkListUpdateInput"],
	create: GraphQLTypes["ImageLinkListCreateInput"]
};
	["ContentReferenceUpdateAreaListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateAreaListRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertAreaListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaListUpdateInput"]: {
		items?: Array<GraphQLTypes["PostAreaListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["PostAreaListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["PostAreaListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostAreaListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostAreaListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostAreaListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostAreaListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["PostAreaListItemUniqueWhere"],
	data: GraphQLTypes["PostAreaListItemWithoutListUpdateInput"]
};
	["PostAreaListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	item?: GraphQLTypes["PostAreaListItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemUpdateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaListItemConnectOrCreateItemRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaListItemUpsertItemRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaListItemUpsertItemRelationInput"]: {
		update: GraphQLTypes["PostAreaUpdateInput"],
	create: GraphQLTypes["PostAreaCreateInput"]
};
	["PostAreaListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["PostAreaListItemUniqueWhere"],
	update: GraphQLTypes["PostAreaListItemWithoutListUpdateInput"],
	create: GraphQLTypes["PostAreaListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertAreaListRelationInput"]: {
		update: GraphQLTypes["PostAreaListUpdateInput"],
	create: GraphQLTypes["PostAreaListCreateInput"]
};
	["ContentReferenceUpdateAccordionEntityRelationInput"]: {
		connect?: GraphQLTypes["AccordionUniqueWhere"] | undefined,
	create?: GraphQLTypes["AccordionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateAccordionRelationInput"] | undefined,
	update?: GraphQLTypes["AccordionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertAccordionRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AccordionUpdateInput"]: {
		items?: Array<GraphQLTypes["AccordionUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["AccordionItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["AccordionUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["AccordionUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["AccordionItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["AccordionItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["AccordionItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AccordionUpdateItemsRelationInput"]: {
		by: GraphQLTypes["AccordionItemUniqueWhere"],
	data: GraphQLTypes["AccordionItemWithoutListUpdateInput"]
};
	["AccordionItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	descriptionContent?: GraphQLTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemUpdateDescriptionContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AccordionItemUpsertDescriptionContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AccordionItemUpsertDescriptionContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["AccordionUpsertItemsRelationInput"]: {
		by: GraphQLTypes["AccordionItemUniqueWhere"],
	update: GraphQLTypes["AccordionItemWithoutListUpdateInput"],
	create: GraphQLTypes["AccordionItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertAccordionRelationInput"]: {
		update: GraphQLTypes["AccordionUpdateInput"],
	create: GraphQLTypes["AccordionCreateInput"]
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined,
	update?: GraphQLTypes["MediumListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertMediaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumListUpdateInput"]: {
		items?: Array<GraphQLTypes["MediumListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MediumItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["MediumListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["MediumListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["MediumItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["MediumItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["MediumItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MediumListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["MediumItemUniqueWhere"],
	data: GraphQLTypes["MediumItemWithoutListUpdateInput"]
};
	["MediumItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	medium?: GraphQLTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined,
	update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumItemUpsertMediumRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpdateInput"]: {
		type?: GraphQLTypes["MediumType"] | undefined,
	image?: GraphQLTypes["MediumUpdateImageEntityRelationInput"] | undefined,
	video?: GraphQLTypes["MediumUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateVideoRelationInput"] | undefined,
	update?: GraphQLTypes["VideoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpsertVideoRelationInput"]: {
		update: GraphQLTypes["VideoUpdateInput"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["MediumItemUpsertMediumRelationInput"]: {
		update: GraphQLTypes["MediumUpdateInput"],
	create: GraphQLTypes["MediumCreateInput"]
};
	["MediumListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["MediumItemUniqueWhere"],
	update: GraphQLTypes["MediumItemWithoutListUpdateInput"],
	create: GraphQLTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMediaRelationInput"]: {
		update: GraphQLTypes["MediumListUpdateInput"],
	create: GraphQLTypes["MediumListCreateInput"]
};
	["ContentReferenceUpdateMemberListEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MemberListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateMemberListRelationInput"] | undefined,
	update?: GraphQLTypes["MemberListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertMemberListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MemberListUpdateInput"]: {
		items?: Array<GraphQLTypes["MemberListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MemberListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["MemberListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["MemberListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["MemberListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["MemberListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["MemberListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MemberListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["MemberListItemUniqueWhere"],
	data: GraphQLTypes["MemberListItemWithoutListUpdateInput"]
};
	["MemberListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	position?: string | undefined,
	image?: GraphQLTypes["MemberListItemUpdateImageEntityRelationInput"] | undefined,
	descriptionContent?: GraphQLTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MemberListItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MemberListItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MemberListItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MemberListItemUpdateDescriptionContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MemberListItemUpsertDescriptionContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MemberListItemUpsertDescriptionContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["MemberListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["MemberListItemUniqueWhere"],
	update: GraphQLTypes["MemberListItemWithoutListUpdateInput"],
	create: GraphQLTypes["MemberListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMemberListRelationInput"]: {
		update: GraphQLTypes["MemberListUpdateInput"],
	create: GraphQLTypes["MemberListCreateInput"]
};
	["ContentReferenceUpdateFormEntityRelationInput"]: {
		connect?: GraphQLTypes["FormUniqueWhere"] | undefined,
	create?: GraphQLTypes["FormCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateFormRelationInput"] | undefined,
	update?: GraphQLTypes["FormUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FormUpdateInput"]: {
		name?: string | undefined,
	type?: GraphQLTypes["FormType"] | undefined,
	tax?: GraphQLTypes["FormUpdateTaxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FormUpdateTaxEntityRelationInput"]: {
		connect?: GraphQLTypes["FilledTaxFormUniqueWhere"] | undefined,
	create?: GraphQLTypes["FilledTaxFormCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FormConnectOrCreateTaxRelationInput"] | undefined,
	update?: GraphQLTypes["FilledTaxFormUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FormUpsertTaxRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FilledTaxFormUpdateInput"]: {
		publishedAt?: GraphQLTypes["DateTime"] | undefined,
	userId?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	vatId?: string | undefined,
	address1?: string | undefined,
	address2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	state?: string | undefined,
	country?: GraphQLTypes["FilledTaxFormUpdateCountryEntityRelationInput"] | undefined,
	dateFrom?: GraphQLTypes["Date"] | undefined,
	dateTo?: GraphQLTypes["Date"] | undefined,
	year?: number | undefined,
	isPdfGenerated?: boolean | undefined,
	pdfObjectKey?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FilledTaxFormUpdateCountryEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FilledTaxFormConnectOrCreateCountryRelationInput"] | undefined,
	update?: GraphQLTypes["RegionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FilledTaxFormUpsertCountryRelationInput"] | undefined
};
	["FilledTaxFormUpsertCountryRelationInput"]: {
		update: GraphQLTypes["RegionUpdateInput"],
	create: GraphQLTypes["RegionCreateInput"]
};
	["FormUpsertTaxRelationInput"]: {
		update: GraphQLTypes["FilledTaxFormUpdateInput"],
	create: GraphQLTypes["FilledTaxFormCreateInput"]
};
	["ContentReferenceUpsertFormRelationInput"]: {
		update: GraphQLTypes["FormUpdateInput"],
	create: GraphQLTypes["FormCreateInput"]
};
	["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertContentWithoutBlocksRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertContentWithoutBlocksRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ContentReferenceUpdateHeroCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeroCarouselCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"] | undefined,
	update?: GraphQLTypes["HeroCarouselUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertHeroCarouselRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeroCarouselUpdateInput"]: {
		createdAt?: GraphQLTypes["Date"] | undefined,
	posts?: Array<GraphQLTypes["HeroCarouselUpdatePostsEntityRelationInput"]> | undefined,
	items?: Array<GraphQLTypes["HeroCarouselUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselUpdatePostsEntityRelationInput"]: {
		create?: GraphQLTypes["PostWithoutHeroCarouselCreateInput"] | undefined,
	update?: GraphQLTypes["HeroCarouselUpdatePostsRelationInput"] | undefined,
	upsert?: GraphQLTypes["HeroCarouselUpsertPostsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeroCarouselUpdatePostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	data: GraphQLTypes["PostWithoutHeroCarouselUpdateInput"]
};
	["PostWithoutHeroCarouselUpdateInput"]: {
		organization?: GraphQLTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	reportPage?: Array<GraphQLTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpdateReportPageEntityRelationInput"]: {
		create?: GraphQLTypes["ReportPageLocaleWithoutPostsCreateInput"] | undefined,
	update?: GraphQLTypes["PostUpdateReportPageRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertReportPageRelationInput"] | undefined,
	connect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateReportPageRelationInput"]: {
		by: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	data: GraphQLTypes["ReportPageLocaleWithoutPostsUpdateInput"]
};
	["ReportPageLocaleWithoutPostsUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostUpsertReportPageRelationInput"]: {
		by: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	update: GraphQLTypes["ReportPageLocaleWithoutPostsUpdateInput"],
	create: GraphQLTypes["ReportPageLocaleWithoutPostsCreateInput"]
};
	["PostUpdateFundraiseCurrencyEntityRelationInput"]: {
		connect?: GraphQLTypes["CurrencyUniqueWhere"] | undefined,
	create?: GraphQLTypes["CurrencyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"] | undefined,
	update?: GraphQLTypes["CurrencyUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostUpsertFundraiseCurrencyRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostUpsertFundraiseCurrencyRelationInput"]: {
		update: GraphQLTypes["CurrencyUpdateInput"],
	create: GraphQLTypes["CurrencyCreateInput"]
};
	["PostUpdateFundraiseCurrencySumsEntityRelationInput"]: {
		connect?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostCurrencySumUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostUpdateFundraiseSumEntityRelationInput"]: {
		connect?: GraphQLTypes["PostSumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostUpdateFundraisingProgressEntityRelationInput"]: {
		connect?: GraphQLTypes["PostFundraisingProgressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeroCarouselUpsertPostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	update: GraphQLTypes["PostWithoutHeroCarouselUpdateInput"],
	create: GraphQLTypes["PostWithoutHeroCarouselCreateInput"]
};
	["ContentReferenceUpsertHeroCarouselRelationInput"]: {
		update: GraphQLTypes["HeroCarouselUpdateInput"],
	create: GraphQLTypes["HeroCarouselCreateInput"]
};
	["ContentReferenceUpdateOrganizationListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertOrganizationListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertOrganizationListRelationInput"]: {
		update: GraphQLTypes["PostOrganizationListUpdateInput"],
	create: GraphQLTypes["PostOrganizationListCreateInput"]
};
	["ContentReferenceUpdateTextImageListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextImageListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"] | undefined,
	update?: GraphQLTypes["TextImageListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertTextImageListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextImageListUpdateInput"]: {
		items?: Array<GraphQLTypes["TextImageListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["TextImageListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["TextImageListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TextImageListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["TextImageListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TextImageListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TextImageListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TextImageListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["TextImageListItemUniqueWhere"],
	data: GraphQLTypes["TextImageListItemWithoutListUpdateInput"]
};
	["TextImageListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	image?: GraphQLTypes["TextImageListItemUpdateImageEntityRelationInput"] | undefined,
	text?: string | undefined,
	link?: GraphQLTypes["TextImageListItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextImageListItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TextImageListItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextImageListItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["TextImageListItemUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextImageListItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TextImageListItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextImageListItemUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["TextImageListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["TextImageListItemUniqueWhere"],
	update: GraphQLTypes["TextImageListItemWithoutListUpdateInput"],
	create: GraphQLTypes["TextImageListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertTextImageListRelationInput"]: {
		update: GraphQLTypes["TextImageListUpdateInput"],
	create: GraphQLTypes["TextImageListCreateInput"]
};
	["PostUpsertContentRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	update: GraphQLTypes["ContentReferenceWithoutPostsUpdateInput"],
	create: GraphQLTypes["ContentReferenceWithoutPostsCreateInput"]
};
	["ReportPageLocaleUpsertPostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	update: GraphQLTypes["PostWithoutReportPageUpdateInput"],
	create: GraphQLTypes["PostWithoutReportPageCreateInput"]
};
	["LocaleUpsertReportPagesRelationInput"]: {
		by: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	update: GraphQLTypes["ReportPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["ReportPageLocaleWithoutLocaleCreateInput"]
};
	["GivenGiftsPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutGivenGiftsPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutGivenGiftsPagesCreateInput"]
};
	["LinkableUpsertGivenGiftsPageRelationInput"]: {
		update: GraphQLTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"]
};
	["ReceivedGiftsPageLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutReceivedGiftsPageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutReceivedGiftsPageCreateInput"]
};
	["LocaleUpsertReceivedGiftsPagesRelationInput"]: {
		by: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	update: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["ReportPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutReportPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutReportPagesCreateInput"]
};
	["LinkableUpsertReportPageRelationInput"]: {
		update: GraphQLTypes["ReportPageLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["ReportPageLocaleWithoutLinkCreateInput"]
};
	["GivenGiftsPageLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutGivenGiftsPageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutGivenGiftsPageCreateInput"]
};
	["LocaleUpsertGivenGiftsPagesRelationInput"]: {
		by: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"],
	update: GraphQLTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"]
};
	["PostOrganizationLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutPostOrganizationsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutPostOrganizationsCreateInput"]
};
	["PostOrganizationLocaleUpdateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationLocaleUpsertDomainRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationLocaleUpsertDomainRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["PostOrganizationLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PostOrganizationLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["LinkableUpsertPostOrganizationRelationInput"]: {
		update: GraphQLTypes["PostOrganizationLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["PostOrganizationLocaleWithoutLinkCreateInput"]
};
	["PostLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutPostUpdateInput"],
	create: GraphQLTypes["LinkableWithoutPostCreateInput"]
};
	["PostUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["PostLocaleUniqueWhere"],
	update: GraphQLTypes["PostLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["PostLocaleWithoutRootCreateInput"]
};
	["TileItemUpsertPostRelationInput"]: {
		update: GraphQLTypes["PostUpdateInput"],
	create: GraphQLTypes["PostCreateInput"]
};
	["TileItemUpdateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateAreaRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileItemUpsertAreaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileItemUpsertAreaRelationInput"]: {
		update: GraphQLTypes["PostAreaUpdateInput"],
	create: GraphQLTypes["PostAreaCreateInput"]
};
	["TileItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["TileItemUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileItemUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["TileItemUpdateOrganizationEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateOrganizationRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileItemUpsertOrganizationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileItemUpsertOrganizationRelationInput"]: {
		update: GraphQLTypes["PostOrganizationUpdateInput"],
	create: GraphQLTypes["PostOrganizationCreateInput"]
};
	["TileListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["TileItemUniqueWhere"],
	update: GraphQLTypes["TileItemWithoutListUpdateInput"],
	create: GraphQLTypes["TileItemWithoutListCreateInput"]
};
	["TileListUpdateAreaTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileListConnectOrCreateAreaTypeRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileListUpsertAreaTypeRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileListUpsertAreaTypeRelationInput"]: {
		update: GraphQLTypes["PostAreaUpdateInput"],
	create: GraphQLTypes["PostAreaCreateInput"]
};
	["FeedPageLocaleUpsertHeroTilesRelationInput"]: {
		update: GraphQLTypes["TileListUpdateInput"],
	create: GraphQLTypes["TileListCreateInput"]
};
	["FeedPageLocaleUpdateSectionListEntityRelationInput"]: {
		create?: GraphQLTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["FeedPageLocaleUpdateSectionListRelationInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageLocaleUpsertSectionListRelationInput"] | undefined,
	connect?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FeedPageLocaleUpdateSectionListRelationInput"]: {
		by: GraphQLTypes["FeedPageSectionUniqueWhere"],
	data: GraphQLTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"]
};
	["FeedPageSectionWithoutFeedPageLocaleUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	tileStripeList?: Array<GraphQLTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionUpdateTileStripeListEntityRelationInput"]: {
		create?: GraphQLTypes["FeedPageTileStripeWithoutSectionCreateInput"] | undefined,
	update?: GraphQLTypes["FeedPageSectionUpdateTileStripeListRelationInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageSectionUpsertTileStripeListRelationInput"] | undefined,
	connect?: GraphQLTypes["FeedPageTileStripeUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FeedPageTileStripeUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FeedPageTileStripeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FeedPageSectionUpdateTileStripeListRelationInput"]: {
		by: GraphQLTypes["FeedPageTileStripeUniqueWhere"],
	data: GraphQLTypes["FeedPageTileStripeWithoutSectionUpdateInput"]
};
	["FeedPageTileStripeWithoutSectionUpdateInput"]: {
		order?: number | undefined,
	tileList?: GraphQLTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeUpdateTileListEntityRelationInput"]: {
		connect?: GraphQLTypes["TileListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TileListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"] | undefined,
	update?: GraphQLTypes["TileListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageTileStripeUpsertTileListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FeedPageTileStripeUpsertTileListRelationInput"]: {
		update: GraphQLTypes["TileListUpdateInput"],
	create: GraphQLTypes["TileListCreateInput"]
};
	["FeedPageSectionUpsertTileStripeListRelationInput"]: {
		by: GraphQLTypes["FeedPageTileStripeUniqueWhere"],
	update: GraphQLTypes["FeedPageTileStripeWithoutSectionUpdateInput"],
	create: GraphQLTypes["FeedPageTileStripeWithoutSectionCreateInput"]
};
	["FeedPageLocaleUpsertSectionListRelationInput"]: {
		by: GraphQLTypes["FeedPageSectionUniqueWhere"],
	update: GraphQLTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"],
	create: GraphQLTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"]
};
	["FeedPageLocaleUpdateCardListEntityRelationInput"]: {
		connect?: GraphQLTypes["CardListUniqueWhere"] | undefined,
	create?: GraphQLTypes["CardListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"] | undefined,
	update?: GraphQLTypes["CardListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageLocaleUpsertCardListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CardListUpdateInput"]: {
		items?: Array<GraphQLTypes["CardListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["CardItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["CardListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CardListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["CardItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CardItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CardItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CardListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["CardItemUniqueWhere"],
	data: GraphQLTypes["CardItemWithoutListUpdateInput"]
};
	["CardItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["CardItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CardItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CardItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CardItemUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["CardListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["CardItemUniqueWhere"],
	update: GraphQLTypes["CardItemWithoutListUpdateInput"],
	create: GraphQLTypes["CardItemWithoutListCreateInput"]
};
	["FeedPageLocaleUpsertCardListRelationInput"]: {
		update: GraphQLTypes["CardListUpdateInput"],
	create: GraphQLTypes["CardListCreateInput"]
};
	["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"] | undefined,
	update?: GraphQLTypes["StoryGuideListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageLocaleUpsertStoryGuideListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FeedPageLocaleUpsertStoryGuideListRelationInput"]: {
		update: GraphQLTypes["StoryGuideListUpdateInput"],
	create: GraphQLTypes["StoryGuideListCreateInput"]
};
	["LocaleUpsertFeedPagesRelationInput"]: {
		by: GraphQLTypes["FeedPageLocaleUniqueWhere"],
	update: GraphQLTypes["FeedPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["FeedPageLocaleWithoutLocaleCreateInput"]
};
	["PostRevisionLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutPostRevisionsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutPostRevisionsCreateInput"]
};
	["PostRevisionLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PostRevisionLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PostRevisionLocaleUpdateLeadContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostRevisionLocaleUpsertLeadContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostRevisionLocaleUpsertLeadContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PostRevisionUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["PostRevisionLocaleUniqueWhere"],
	update: GraphQLTypes["PostRevisionLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["PostRevisionLocaleWithoutRootCreateInput"]
};
	["PostUpsertActiveRevisionRelationInput"]: {
		update: GraphQLTypes["PostRevisionUpdateInput"],
	create: GraphQLTypes["PostRevisionCreateInput"]
};
	["PostRevisionUpsertPostRelationInput"]: {
		update: GraphQLTypes["PostWithoutRevisionsUpdateInput"],
	create: GraphQLTypes["PostWithoutRevisionsCreateInput"]
};
	["PostRevisionLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["PostRevisionWithoutLocalesUpdateInput"],
	create: GraphQLTypes["PostRevisionWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostRevisionsRelationInput"]: {
		by: GraphQLTypes["PostRevisionLocaleUniqueWhere"],
	update: GraphQLTypes["PostRevisionLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["PostRevisionLocaleWithoutLocaleCreateInput"]
};
	["SentPaymentLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutSentPaymentsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutSentPaymentsCreateInput"]
};
	["SentPaymentUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["SentPaymentLocaleUniqueWhere"],
	update: GraphQLTypes["SentPaymentLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["SentPaymentLocaleWithoutRootCreateInput"]
};
	["PostAreaUpsertSentPaymentsRelationInput"]: {
		by: GraphQLTypes["SentPaymentUniqueWhere"],
	update: GraphQLTypes["SentPaymentWithoutAreaUpdateInput"],
	create: GraphQLTypes["SentPaymentWithoutAreaCreateInput"]
};
	["PostOrganizationUpsertAreaRelationInput"]: {
		update: GraphQLTypes["PostAreaUpdateInput"],
	create: GraphQLTypes["PostAreaCreateInput"]
};
	["PostOrganizationUpdateSentPaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["SentPaymentWithoutOrganizationCreateInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationUpdateSentPaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationUpsertSentPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SentPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PostOrganizationUpdateSentPaymentsRelationInput"]: {
		by: GraphQLTypes["SentPaymentUniqueWhere"],
	data: GraphQLTypes["SentPaymentWithoutOrganizationUpdateInput"]
};
	["SentPaymentWithoutOrganizationUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: GraphQLTypes["DateTime"] | undefined,
	currency?: GraphQLTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	area?: GraphQLTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationUpsertSentPaymentsRelationInput"]: {
		by: GraphQLTypes["SentPaymentUniqueWhere"],
	update: GraphQLTypes["SentPaymentWithoutOrganizationUpdateInput"],
	create: GraphQLTypes["SentPaymentWithoutOrganizationCreateInput"]
};
	["PostOrganizationLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["PostOrganizationWithoutLocalesUpdateInput"],
	create: GraphQLTypes["PostOrganizationWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostOrganizationsRelationInput"]: {
		by: GraphQLTypes["PostOrganizationLocaleUniqueWhere"],
	update: GraphQLTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["PostOrganizationLocaleWithoutLocaleCreateInput"]
};
	["PostAreaLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutPostAreasUpdateInput"],
	create: GraphQLTypes["LocaleWithoutPostAreasCreateInput"]
};
	["PostAreaLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PostAreaLocaleUpdateBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["AppBannerUniqueWhere"] | undefined,
	create?: GraphQLTypes["AppBannerCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"] | undefined,
	update?: GraphQLTypes["AppBannerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaLocaleUpsertBannerRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AppBannerUpdateInput"]: {
		title?: string | undefined,
	imageSmall?: GraphQLTypes["AppBannerUpdateImageSmallEntityRelationInput"] | undefined,
	imageBig?: GraphQLTypes["AppBannerUpdateImageBigEntityRelationInput"] | undefined,
	textContent?: GraphQLTypes["AppBannerUpdateTextContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AppBannerUpdateImageSmallEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AppBannerConnectOrCreateImageSmallRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AppBannerUpsertImageSmallRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AppBannerUpsertImageSmallRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["AppBannerUpdateImageBigEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AppBannerConnectOrCreateImageBigRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AppBannerUpsertImageBigRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AppBannerUpsertImageBigRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["AppBannerUpdateTextContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AppBannerConnectOrCreateTextContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AppBannerUpsertTextContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AppBannerUpsertTextContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PostAreaLocaleUpsertBannerRelationInput"]: {
		update: GraphQLTypes["AppBannerUpdateInput"],
	create: GraphQLTypes["AppBannerCreateInput"]
};
	["PostAreaLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostAreaLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["LinkableUpsertPostAreaRelationInput"]: {
		update: GraphQLTypes["PostAreaLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["PostAreaLocaleWithoutLinkCreateInput"]
};
	["PostOrganizationLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutPostOrganizationUpdateInput"],
	create: GraphQLTypes["LinkableWithoutPostOrganizationCreateInput"]
};
	["PostOrganizationUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["PostOrganizationLocaleUniqueWhere"],
	update: GraphQLTypes["PostOrganizationLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["PostOrganizationLocaleWithoutRootCreateInput"]
};
	["PostUpsertOrganizationRelationInput"]: {
		update: GraphQLTypes["PostOrganizationWithoutPostsUpdateInput"],
	create: GraphQLTypes["PostOrganizationWithoutPostsCreateInput"]
};
	["PostAreaUpsertPostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	update: GraphQLTypes["PostWithoutAreaUpdateInput"],
	create: GraphQLTypes["PostWithoutAreaCreateInput"]
};
	["PostAreaLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["PostAreaWithoutLocalesUpdateInput"],
	create: GraphQLTypes["PostAreaWithoutLocalesCreateInput"]
};
	["LocaleUpsertPostAreasRelationInput"]: {
		by: GraphQLTypes["PostAreaLocaleUniqueWhere"],
	update: GraphQLTypes["PostAreaLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["PostAreaLocaleWithoutLocaleCreateInput"]
};
	["PostLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutPostsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutPostsCreateInput"]
};
	["PostLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["PostWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostWithoutLocalesUpdateInput"]: {
		organization?: GraphQLTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	content?: Array<GraphQLTypes["PostUpdateContentEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["PostWithoutLocalesUpdateInput"],
	create: GraphQLTypes["PostWithoutLocalesCreateInput"]
};
	["LinkableUpsertPostRelationInput"]: {
		update: GraphQLTypes["PostLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["PostLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update: GraphQLTypes["LinkableUpdateInput"],
	create: GraphQLTypes["LinkableCreateInput"]
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdatePostsEntityRelationInput"]: {
		create?: GraphQLTypes["PostWithoutContentCreateInput"] | undefined,
	update?: GraphQLTypes["ContentReferenceUpdatePostsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertPostsRelationInput"] | undefined,
	connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PostUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceUpdatePostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	data: GraphQLTypes["PostWithoutContentUpdateInput"]
};
	["PostWithoutContentUpdateInput"]: {
		organization?: GraphQLTypes["PostUpdateOrganizationEntityRelationInput"] | undefined,
	area?: GraphQLTypes["PostUpdateAreaEntityRelationInput"] | undefined,
	specificSymbol?: number | undefined,
	activeRevision?: GraphQLTypes["PostUpdateActiveRevisionEntityRelationInput"] | undefined,
	revisions?: Array<GraphQLTypes["PostUpdateRevisionsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["PostUpdateLocalesEntityRelationInput"]> | undefined,
	isPinnedInArea?: boolean | undefined,
	isPinnedInOrganization?: boolean | undefined,
	state?: GraphQLTypes["PostState"] | undefined,
	meta?: GraphQLTypes["PostUpdateMetaEntityRelationInput"] | undefined,
	isPublishedAtHidden?: boolean | undefined,
	heroCarousel?: Array<GraphQLTypes["PostUpdateHeroCarouselEntityRelationInput"]> | undefined,
	reportPage?: Array<GraphQLTypes["PostUpdateReportPageEntityRelationInput"]> | undefined,
	fundraiseIsActive?: boolean | undefined,
	fundraiseEndDate?: GraphQLTypes["Date"] | undefined,
	fundraiseTargetAmount?: number | undefined,
	fundraiseFakeAddOnAmount?: number | undefined,
	fundraiseCurrency?: GraphQLTypes["PostUpdateFundraiseCurrencyEntityRelationInput"] | undefined,
	fundraiseCurrencySums?: Array<GraphQLTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"]> | undefined,
	fundraiseSum?: GraphQLTypes["PostUpdateFundraiseSumEntityRelationInput"] | undefined,
	fundraisingProgress?: GraphQLTypes["PostUpdateFundraisingProgressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpsertPostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	update: GraphQLTypes["PostWithoutContentUpdateInput"],
	create: GraphQLTypes["PostWithoutContentCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	update: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"],
	create: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
		by: GraphQLTypes["ContentBlockUniqueWhere"],
	update: GraphQLTypes["ContentBlockWithoutContentUpdateInput"],
	create: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["PostLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["LocaleUpsertPostsRelationInput"]: {
		by: GraphQLTypes["PostLocaleUniqueWhere"],
	update: GraphQLTypes["PostLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["PostLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutGenericPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableUpsertGenericPageRelationInput"]: {
		update: GraphQLTypes["GenericPageLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["PostAreaLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutPostAreaUpdateInput"],
	create: GraphQLTypes["LinkableWithoutPostAreaCreateInput"]
};
	["PostAreaUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["PostAreaLocaleUniqueWhere"],
	update: GraphQLTypes["PostAreaLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["PostAreaLocaleWithoutRootCreateInput"]
};
	["PostUpsertAreaRelationInput"]: {
		update: GraphQLTypes["PostAreaWithoutPostsUpdateInput"],
	create: GraphQLTypes["PostAreaWithoutPostsCreateInput"]
};
	["PostOrganizationUpsertPostsRelationInput"]: {
		by: GraphQLTypes["PostUniqueWhere"],
	update: GraphQLTypes["PostWithoutOrganizationUpdateInput"],
	create: GraphQLTypes["PostWithoutOrganizationCreateInput"]
};
	["PostOrganizationListItemUpsertItemRelationInput"]: {
		update: GraphQLTypes["PostOrganizationUpdateInput"],
	create: GraphQLTypes["PostOrganizationCreateInput"]
};
	["PostOrganizationListItemUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationListItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationListItemUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["PostOrganizationListItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationListItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationListItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["PostOrganizationListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["PostOrganizationListItemUniqueWhere"],
	update: GraphQLTypes["PostOrganizationListItemWithoutListUpdateInput"],
	create: GraphQLTypes["PostOrganizationListItemWithoutListCreateInput"]
};
	["GeneralUpsertOrganizationListRelationInput"]: {
		update: GraphQLTypes["PostOrganizationListUpdateInput"],
	create: GraphQLTypes["PostOrganizationListCreateInput"]
};
	["GeneralLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["GeneralWithoutLocalesUpdateInput"],
	create: GraphQLTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertAppStoreLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralLocaleUpsertAppStoreLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertGooglePlayLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralLocaleUpsertGooglePlayLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LocaleUpsertGeneralsRelationInput"]: {
		by: GraphQLTypes["GeneralLocaleUniqueWhere"],
	update: GraphQLTypes["GeneralLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["ReportNavigationLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutReportNavigationsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutReportNavigationsCreateInput"]
};
	["GenericPageUpsertReportNavigationRelationInput"]: {
		by: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	update: GraphQLTypes["ReportNavigationLocaleWithoutPagesUpdateInput"],
	create: GraphQLTypes["ReportNavigationLocaleWithoutPagesCreateInput"]
};
	["GenericPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["GenericPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["GenericPageWithoutLocalesCreateInput"]
};
	["LocaleUpsertGenericPagesRelationInput"]: {
		by: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	update: GraphQLTypes["GenericPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutGeneralsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutGeneralsCreateInput"]
};
	["GeneralUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["GeneralLocaleUniqueWhere"],
	update: GraphQLTypes["GeneralLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["GenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined,
	type?: GraphQLTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	reportNavigation?: Array<GraphQLTypes["GenericPageCreateReportNavigationEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateInput"]: {
		locales?: Array<GraphQLTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined,
	type?: GraphQLTypes["GenericPageType"] | undefined,
	order?: number | undefined,
	reportNavigation?: Array<GraphQLTypes["GenericPageUpdateReportNavigationEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	contentAlignment?: GraphQLTypes["ContentAlignment"] | undefined,
	valueList?: GraphQLTypes["ContentReferenceCreateValueListEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | undefined,
	areaList?: GraphQLTypes["ContentReferenceCreateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: GraphQLTypes["ContentReferenceCreateAccordionEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	memberList?: GraphQLTypes["ContentReferenceCreateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: GraphQLTypes["ContentReferenceCreateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: GraphQLTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["ContentReferenceCreateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	posts?: Array<GraphQLTypes["ContentReferenceCreatePostsEntityRelationInput"]> | undefined,
	textImageList?: GraphQLTypes["ContentReferenceCreateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	contentAlignment?: GraphQLTypes["ContentAlignment"] | undefined,
	valueList?: GraphQLTypes["ContentReferenceUpdateValueListEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | undefined,
	areaList?: GraphQLTypes["ContentReferenceUpdateAreaListEntityRelationInput"] | undefined,
	isAppsVisible?: boolean | undefined,
	accordion?: GraphQLTypes["ContentReferenceUpdateAccordionEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	memberList?: GraphQLTypes["ContentReferenceUpdateMemberListEntityRelationInput"] | undefined,
	asideMediaContentLayout?: GraphQLTypes["AsideMediaContentLayout"] | undefined,
	isAsideMediaContentMobileLayout?: boolean | undefined,
	form?: GraphQLTypes["ContentReferenceUpdateFormEntityRelationInput"] | undefined,
	isTitleBigger?: boolean | undefined,
	contentWithoutBlocks?: GraphQLTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"] | undefined,
	heroCarousel?: GraphQLTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"] | undefined,
	organizationList?: GraphQLTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"] | undefined,
	isCentered?: boolean | undefined,
	posts?: Array<GraphQLTypes["ContentReferenceUpdatePostsEntityRelationInput"]> | undefined,
	textImageList?: GraphQLTypes["ContentReferenceUpdateTextImageListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	appStoreLink?: GraphQLTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: GraphQLTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateInput"]: {
		root?: GraphQLTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	appStoreLink?: GraphQLTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"] | undefined,
	googlePlayLink?: GraphQLTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"] | undefined,
	allAreasDescription?: string | undefined,
	allOrganizationsDescription?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleConnection"]: {
	__typename: "LocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
	__typename: "LocaleEdge",
	node: GraphQLTypes["Locale"]
};
	["VideoConnection"]: {
	__typename: "VideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VideoEdge"]>
};
	["VideoEdge"]: {
	__typename: "VideoEdge",
	node: GraphQLTypes["Video"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["PostLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	content?: GraphQLTypes["PostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["PostLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostLocaleCreateLocaleEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostLocaleCreateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostLocaleUpdateInput"]: {
		content?: GraphQLTypes["PostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["PostLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostLocaleUpdateRootEntityRelationInput"] | undefined,
	paymentName?: string | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaConnection"]: {
	__typename: "PostAreaConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaEdge"]>
};
	["PostAreaEdge"]: {
	__typename: "PostAreaEdge",
	node: GraphQLTypes["PostArea"]
};
	["PostAreaLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostAreaLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostAreaLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostAreaLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostAreaLocaleCreateSeoEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["PostAreaLocaleCreateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["PostAreaLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaLocaleUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostAreaLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostAreaLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostAreaLocaleUpdateSeoEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["PostAreaLocaleUpdateBannerEntityRelationInput"] | undefined,
	shortDescription?: string | undefined,
	content?: GraphQLTypes["PostAreaLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationConnection"]: {
	__typename: "PostOrganizationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostOrganizationEdge"]>
};
	["PostOrganizationEdge"]: {
	__typename: "PostOrganizationEdge",
	node: GraphQLTypes["PostOrganization"]
};
	["PostOrganizationLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostOrganizationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"] | undefined,
	domain?: GraphQLTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostOrganizationLocaleCreateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationLocaleUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	link?: GraphQLTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	domain?: GraphQLTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"] | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationConnection"]: {
	__typename: "DonationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DonationEdge"]>
};
	["DonationEdge"]: {
	__typename: "DonationEdge",
	node: GraphQLTypes["Donation"]
};
	["DonationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	regionList?: GraphQLTypes["DonationCreateRegionListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationCreateRegionListEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationConnectOrCreateRegionListRelationInput"] | undefined
};
	["DonationAmountsRegionListWithoutDonationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	regions?: Array<GraphQLTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationConnectOrCreateRegionListRelationInput"]: {
		connect: GraphQLTypes["DonationAmountsRegionListUniqueWhere"],
	create: GraphQLTypes["DonationAmountsRegionListWithoutDonationCreateInput"]
};
	["DonationUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	regionList?: GraphQLTypes["DonationUpdateRegionListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationUpdateRegionListEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionListUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionListWithoutDonationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationConnectOrCreateRegionListRelationInput"] | undefined,
	update?: GraphQLTypes["DonationAmountsRegionListWithoutDonationUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DonationUpsertRegionListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DonationAmountsRegionListWithoutDonationUpdateInput"]: {
		regions?: Array<GraphQLTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationUpsertRegionListRelationInput"]: {
		update: GraphQLTypes["DonationAmountsRegionListWithoutDonationUpdateInput"],
	create: GraphQLTypes["DonationAmountsRegionListWithoutDonationCreateInput"]
};
	["DonationAmountItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	amount?: number | undefined,
	regionItem?: GraphQLTypes["DonationAmountItemCreateRegionItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountItemCreateRegionItemEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"] | undefined
};
	["DonationAmountsRegionItemWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined,
	region?: GraphQLTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountItemConnectOrCreateRegionItemRelationInput"]: {
		connect: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"],
	create: GraphQLTypes["DonationAmountsRegionItemWithoutItemsCreateInput"]
};
	["DonationAmountItemUpdateInput"]: {
		order?: number | undefined,
	amount?: number | undefined,
	regionItem?: GraphQLTypes["DonationAmountItemUpdateRegionItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountItemUpdateRegionItemEntityRelationInput"]: {
		connect?: GraphQLTypes["DonationAmountsRegionItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["DonationAmountsRegionItemWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"] | undefined,
	update?: GraphQLTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DonationAmountItemUpsertRegionItemRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["DonationAmountsRegionItemWithoutItemsUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined,
	region?: GraphQLTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountItemUpsertRegionItemRelationInput"]: {
		update: GraphQLTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"],
	create: GraphQLTypes["DonationAmountsRegionItemWithoutItemsCreateInput"]
};
	["DonationAmountsRegionItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	items?: Array<GraphQLTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"]> | undefined,
	list?: GraphQLTypes["DonationAmountsRegionItemCreateListEntityRelationInput"] | undefined,
	region?: GraphQLTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionItemUpdateInput"]: {
		order?: number | undefined,
	items?: Array<GraphQLTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]> | undefined,
	list?: GraphQLTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"] | undefined,
	region?: GraphQLTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"] | undefined,
	minimumAmount?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["DonationAmountsRegionListConnection"]: {
	__typename: "DonationAmountsRegionListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DonationAmountsRegionListEdge"]>
};
	["DonationAmountsRegionListEdge"]: {
	__typename: "DonationAmountsRegionListEdge",
	node: GraphQLTypes["DonationAmountsRegionList"]
};
	["LinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["LinkItemCreateListEntityRelationInput"] | undefined,
	link?: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkItemConnectOrCreateListRelationInput"] | undefined
};
	["LinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["LinkListUniqueWhere"],
	create: GraphQLTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["LinkItemUpdateListEntityRelationInput"] | undefined,
	link?: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["LinkItemUpsertListRelationInput"]: {
		update: GraphQLTypes["LinkListWithoutItemsUpdateInput"],
	create: GraphQLTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkListConnection"]: {
	__typename: "LinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkListEdge"]>
};
	["LinkListEdge"]: {
	__typename: "LinkListEdge",
	node: GraphQLTypes["LinkList"]
};
	["HeaderConnection"]: {
	__typename: "HeaderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
	__typename: "HeaderEdge",
	node: GraphQLTypes["Header"]
};
	["HeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["HeaderCreateLocalesEntityRelationInput"]> | undefined,
	organizationList?: GraphQLTypes["HeaderCreateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined,
	links?: GraphQLTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutHeadersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["HeaderUpdateLocalesEntityRelationInput"]> | undefined,
	organizationList?: GraphQLTypes["HeaderUpdateOrganizationListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["HeaderUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["HeaderUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeaderUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["HeaderLocaleUniqueWhere"],
	data: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"]
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined,
	links?: GraphQLTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutHeadersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutHeadersUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutHeadersUpdateInput"],
	create: GraphQLTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["HeaderLocaleUniqueWhere"],
	update: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined,
	links?: GraphQLTypes["HeaderLocaleCreateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateInput"]: {
		root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined,
	links?: GraphQLTypes["HeaderLocaleUpdateLinksEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["FooterCreateLocalesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["FooterCreateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	copyright?: string | undefined,
	locale?: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined,
	linkList?: GraphQLTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: GraphQLTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutFootersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutFootersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["FooterLocaleUniqueWhere"],
	create: GraphQLTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["FooterUpdateLocalesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["FooterUpdateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["FooterUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["FooterUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FooterUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["FooterLocaleUniqueWhere"],
	data: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"]
};
	["FooterLocaleWithoutRootUpdateInput"]: {
		copyright?: string | undefined,
	locale?: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linkList?: GraphQLTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: GraphQLTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutFootersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutFootersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutFootersUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutFootersUpdateInput"],
	create: GraphQLTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["FooterLocaleUniqueWhere"],
	update: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	copyright?: string | undefined,
	root?: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined,
	linkList?: GraphQLTypes["FooterLocaleCreateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: GraphQLTypes["FooterLocaleCreateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["FooterLocaleCreateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateInput"]: {
		copyright?: string | undefined,
	root?: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linkList?: GraphQLTypes["FooterLocaleUpdateLinkListEntityRelationInput"] | undefined,
	contactEmail?: string | undefined,
	addressInfo?: GraphQLTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"] | undefined,
	imageLinkList?: GraphQLTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListConnection"]: {
	__typename: "PostListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostListEdge"]>
};
	["PostListEdge"]: {
	__typename: "PostListEdge",
	node: GraphQLTypes["PostList"]
};
	["PostListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["PostListItemCreateListEntityRelationInput"] | undefined,
	post?: GraphQLTypes["PostListItemCreatePostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostListItemConnectOrCreateListRelationInput"] | undefined
};
	["PostListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["PostListUniqueWhere"],
	create: GraphQLTypes["PostListWithoutItemsCreateInput"]
};
	["PostListItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["PostListItemUpdateListEntityRelationInput"] | undefined,
	post?: GraphQLTypes["PostListItemUpdatePostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostListItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostListItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["PostListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["PostListItemUpsertListRelationInput"]: {
		update: GraphQLTypes["PostListWithoutItemsUpdateInput"],
	create: GraphQLTypes["PostListWithoutItemsCreateInput"]
};
	["AppBannerConnection"]: {
	__typename: "AppBannerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AppBannerEdge"]>
};
	["AppBannerEdge"]: {
	__typename: "AppBannerEdge",
	node: GraphQLTypes["AppBanner"]
};
	["GenericPageAboutSettingsConnection"]: {
	__typename: "GenericPageAboutSettingsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageAboutSettingsEdge"]>
};
	["GenericPageAboutSettingsEdge"]: {
	__typename: "GenericPageAboutSettingsEdge",
	node: GraphQLTypes["GenericPageAboutSettings"]
};
	["GenericPageAboutSettingsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined,
	linkGroups?: Array<GraphQLTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGenericPageAboutSettingsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"]
};
	["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]
};
	["GenericPageAboutSettingsUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["GenericPageAboutSettingsUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageAboutSettingsUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageAboutSettingsUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	data: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"]
};
	["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linkGroups?: Array<GraphQLTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGenericPageAboutSettingsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"]
};
	["GenericPageAboutSettingsUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	update: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]
};
	["GenericPageAboutSettingsLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined,
	linkGroups?: Array<GraphQLTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleUpdateInput"]: {
		root?: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linkGroups?: Array<GraphQLTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueConnection"]: {
	__typename: "ValueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ValueEdge"]>
};
	["ValueEdge"]: {
	__typename: "ValueEdge",
	node: GraphQLTypes["Value"]
};
	["ValueItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["ValueItemCreateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["ValueItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ValueListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ValueListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ValueItemConnectOrCreateListRelationInput"] | undefined
};
	["ValueListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["ValueListUniqueWhere"],
	create: GraphQLTypes["ValueListWithoutItemsCreateInput"]
};
	["ValueItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["ValueItemUpdateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["ValueItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ValueItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ValueListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ValueListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ValueItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["ValueListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ValueItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ValueListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ValueItemUpsertListRelationInput"]: {
		update: GraphQLTypes["ValueListWithoutItemsUpdateInput"],
	create: GraphQLTypes["ValueListWithoutItemsCreateInput"]
};
	["ValueListConnection"]: {
	__typename: "ValueListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ValueListEdge"]>
};
	["ValueListEdge"]: {
	__typename: "ValueListEdge",
	node: GraphQLTypes["ValueList"]
};
	["ImageLinkConnection"]: {
	__typename: "ImageLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageLinkEdge"]>
};
	["ImageLinkEdge"]: {
	__typename: "ImageLinkEdge",
	node: GraphQLTypes["ImageLink"]
};
	["ImageLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["ImageLinkItemCreateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["ImageLinkItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkItemConnectOrCreateListRelationInput"] | undefined
};
	["ImageLinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["ImageLinkListUniqueWhere"],
	create: GraphQLTypes["ImageLinkListWithoutItemsCreateInput"]
};
	["ImageLinkItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["ImageLinkItemUpdateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["ImageLinkItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageLinkItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageLinkListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageLinkItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["ImageLinkListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageLinkItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ImageLinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ImageLinkItemUpsertListRelationInput"]: {
		update: GraphQLTypes["ImageLinkListWithoutItemsUpdateInput"],
	create: GraphQLTypes["ImageLinkListWithoutItemsCreateInput"]
};
	["ImageLinkListConnection"]: {
	__typename: "ImageLinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageLinkListEdge"]>
};
	["ImageLinkListEdge"]: {
	__typename: "ImageLinkListEdge",
	node: GraphQLTypes["ImageLinkList"]
};
	["PostAreaListConnection"]: {
	__typename: "PostAreaListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaListEdge"]>
};
	["PostAreaListEdge"]: {
	__typename: "PostAreaListEdge",
	node: GraphQLTypes["PostAreaList"]
};
	["PostAreaListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["PostAreaListItemCreateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["PostAreaListItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaListItemConnectOrCreateListRelationInput"] | undefined
};
	["PostAreaListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["PostAreaListUniqueWhere"],
	create: GraphQLTypes["PostAreaListWithoutItemsCreateInput"]
};
	["PostAreaListItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["PostAreaListItemUpdateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["PostAreaListItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaListItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostAreaListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostAreaListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostAreaListItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["PostAreaListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostAreaListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostAreaListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["PostAreaListItemUpsertListRelationInput"]: {
		update: GraphQLTypes["PostAreaListWithoutItemsUpdateInput"],
	create: GraphQLTypes["PostAreaListWithoutItemsCreateInput"]
};
	["AccordionConnection"]: {
	__typename: "AccordionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AccordionEdge"]>
};
	["AccordionEdge"]: {
	__typename: "AccordionEdge",
	node: GraphQLTypes["Accordion"]
};
	["AccordionItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	list?: GraphQLTypes["AccordionItemCreateListEntityRelationInput"] | undefined,
	descriptionContent?: GraphQLTypes["AccordionItemCreateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["AccordionUniqueWhere"] | undefined,
	create?: GraphQLTypes["AccordionWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AccordionItemConnectOrCreateListRelationInput"] | undefined
};
	["AccordionWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["AccordionUniqueWhere"],
	create: GraphQLTypes["AccordionWithoutItemsCreateInput"]
};
	["AccordionItemUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	list?: GraphQLTypes["AccordionItemUpdateListEntityRelationInput"] | undefined,
	descriptionContent?: GraphQLTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AccordionItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["AccordionUniqueWhere"] | undefined,
	create?: GraphQLTypes["AccordionWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["AccordionItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["AccordionWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AccordionItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["AccordionWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["AccordionItemUpsertListRelationInput"]: {
		update: GraphQLTypes["AccordionWithoutItemsUpdateInput"],
	create: GraphQLTypes["AccordionWithoutItemsCreateInput"]
};
	["UserConnection"]: {
	__typename: "UserConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserEdge"]>
};
	["UserEdge"]: {
	__typename: "UserEdge",
	node: GraphQLTypes["User"]
};
	["UserPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentUpdateInput"]: {
		cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CurrencyConnection"]: {
	__typename: "CurrencyConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CurrencyEdge"]>
};
	["CurrencyEdge"]: {
	__typename: "CurrencyEdge",
	node: GraphQLTypes["Currency"]
};
	["MediumConnection"]: {
	__typename: "MediumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumEdge"]>
};
	["MediumEdge"]: {
	__typename: "MediumEdge",
	node: GraphQLTypes["Medium"]
};
	["MediumItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["MediumItemCreateListEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["MediumItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumItemConnectOrCreateListRelationInput"] | undefined
};
	["MediumListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["MediumListUniqueWhere"],
	create: GraphQLTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["MediumItemUpdateListEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["MediumListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["MediumItemUpsertListRelationInput"]: {
		update: GraphQLTypes["MediumListWithoutItemsUpdateInput"],
	create: GraphQLTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumListConnection"]: {
	__typename: "MediumListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumListEdge"]>
};
	["MediumListEdge"]: {
	__typename: "MediumListEdge",
	node: GraphQLTypes["MediumList"]
};
	["UserPaymentOrderIdConnection"]: {
	__typename: "UserPaymentOrderIdConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserPaymentOrderIdEdge"]>
};
	["UserPaymentOrderIdEdge"]: {
	__typename: "UserPaymentOrderIdEdge",
	node: GraphQLTypes["UserPaymentOrderId"]
};
	["UserRecurringPaymentItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	recurrenceCounter?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	payments?: Array<GraphQLTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]> | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"] | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserRecurringPaymentItemUpdateInput"]: {
		recurrenceCounter?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	taskId?: string | undefined,
	payments?: Array<GraphQLTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]> | undefined,
	recurringPayment?: GraphQLTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"] | undefined,
	isFailed?: boolean | undefined,
	failedEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["PostRevisionLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostRevisionLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostRevisionLocaleCreateSeoEntityRelationInput"] | undefined,
	leadContent?: GraphQLTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostRevisionLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["PostRevisionLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PostRevisionLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"] | undefined,
	leadContent?: GraphQLTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"] | undefined,
	publishNotificationText?: string | undefined,
	translatedByAI?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogue"]: {
	__typename: "TranslationCatalogue",
	_meta?: GraphQLTypes["TranslationCatalogueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomain"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogue"] | undefined,
	values: Array<GraphQLTypes["TranslationValue"]>,
	valuesByKey?: GraphQLTypes["TranslationValue"] | undefined,
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationCatalogueMeta"]: {
	__typename: "TranslationCatalogueMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	domain?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	fallback?: GraphQLTypes["FieldMeta"] | undefined,
	values?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationDomain"]: {
	__typename: "TranslationDomain",
	_meta?: GraphQLTypes["TranslationDomainMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	identifier: string,
	name: string,
	catalogues: Array<GraphQLTypes["TranslationCatalogue"]>,
	keys: Array<GraphQLTypes["TranslationKey"]>,
	cataloguesByIdentifier?: GraphQLTypes["TranslationCatalogue"] | undefined,
	cataloguesByValues?: GraphQLTypes["TranslationCatalogue"] | undefined,
	keysByIdentifier?: GraphQLTypes["TranslationKey"] | undefined,
	keysByValues?: GraphQLTypes["TranslationKey"] | undefined,
	paginateCatalogues: GraphQLTypes["TranslationCatalogueConnection"],
	paginateKeys: GraphQLTypes["TranslationKeyConnection"]
};
	["TranslationDomainMeta"]: {
	__typename: "TranslationDomainMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	catalogues?: GraphQLTypes["FieldMeta"] | undefined,
	keys?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationCatalogueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	domain?: GraphQLTypes["TranslationDomainWhere"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueWhere"] | undefined,
	values?: GraphQLTypes["TranslationValueWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationCatalogueWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationCatalogueWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationCatalogueWhere"] | undefined
};
	["TranslationDomainWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	identifier?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	catalogues?: GraphQLTypes["TranslationCatalogueWhere"] | undefined,
	keys?: GraphQLTypes["TranslationKeyWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationDomainWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationDomainWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationDomainWhere"] | undefined
};
	["TranslationKeyWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	identifier?: GraphQLTypes["StringCondition"] | undefined,
	contentType?: GraphQLTypes["TranslationKeyContentTypeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	domain?: GraphQLTypes["TranslationDomainWhere"] | undefined,
	values?: GraphQLTypes["TranslationValueWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationKeyWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationKeyWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationKeyWhere"] | undefined
};
	["TranslationKeyContentTypeCondition"]: {
		and?: Array<GraphQLTypes["TranslationKeyContentTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["TranslationKeyContentTypeCondition"]> | undefined,
	not?: GraphQLTypes["TranslationKeyContentTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	notEq?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	in?: Array<GraphQLTypes["TranslationKeyContentType"]> | undefined,
	notIn?: Array<GraphQLTypes["TranslationKeyContentType"]> | undefined,
	lt?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	lte?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	gt?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	gte?: GraphQLTypes["TranslationKeyContentType"] | undefined
};
	["TranslationKeyContentType"]: TranslationKeyContentType;
	["TranslationValueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	value?: GraphQLTypes["StringCondition"] | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueWhere"] | undefined,
	key?: GraphQLTypes["TranslationKeyWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationValueWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationValueWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationValueWhere"] | undefined
};
	["TranslationCataloguesIdentifierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined
};
	["TranslationCatalogueOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	domain?: GraphQLTypes["TranslationDomainOrderBy"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierOrderBy"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueOrderBy"] | undefined
};
	["TranslationDomainOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	identifier?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined
};
	["TranslationCataloguesIdentifierOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined
};
	["TranslationKey"]: {
	__typename: "TranslationKey",
	_meta?: GraphQLTypes["TranslationKeyMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	identifier: string,
	contentType: GraphQLTypes["TranslationKeyContentType"],
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationDomain"] | undefined,
	values: Array<GraphQLTypes["TranslationValue"]>,
	valuesByCatalogue?: GraphQLTypes["TranslationValue"] | undefined,
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationKeyMeta"]: {
	__typename: "TranslationKeyMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	contentType?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	domain?: GraphQLTypes["FieldMeta"] | undefined,
	values?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationValue"]: {
	__typename: "TranslationValue",
	_meta?: GraphQLTypes["TranslationValueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	value: string,
	catalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	key?: GraphQLTypes["TranslationKey"] | undefined
};
	["TranslationValueMeta"]: {
	__typename: "TranslationValueMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	value?: GraphQLTypes["FieldMeta"] | undefined,
	catalogue?: GraphQLTypes["FieldMeta"] | undefined,
	key?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationValueOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	value?: GraphQLTypes["OrderDirection"] | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueOrderBy"] | undefined,
	key?: GraphQLTypes["TranslationKeyOrderBy"] | undefined
};
	["TranslationKeyOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	identifier?: GraphQLTypes["OrderDirection"] | undefined,
	contentType?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	domain?: GraphQLTypes["TranslationDomainOrderBy"] | undefined
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
		catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined
};
	["TranslationCatalogueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationDomainUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	catalogues?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	keys?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined
};
	["TranslationKeyUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	identifier?: string | undefined,
	values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationValueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	key?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined
};
	["TranslationValueConnection"]: {
	__typename: "TranslationValueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationValueEdge"]>
};
	["TranslationValueEdge"]: {
	__typename: "TranslationValueEdge",
	node: GraphQLTypes["TranslationValue"]
};
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
		identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
		identifier?: string | undefined
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationCatalogueConnection"]: {
	__typename: "TranslationCatalogueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCatalogueEdge"]>
};
	["TranslationCatalogueEdge"]: {
	__typename: "TranslationCatalogueEdge",
	node: GraphQLTypes["TranslationCatalogue"]
};
	["TranslationKeyConnection"]: {
	__typename: "TranslationKeyConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationKeyEdge"]>
};
	["TranslationKeyEdge"]: {
	__typename: "TranslationKeyEdge",
	node: GraphQLTypes["TranslationKey"]
};
	["TranslationCataloguesIdentifier"]: {
	__typename: "TranslationCataloguesIdentifier",
	_meta?: GraphQLTypes["TranslationCataloguesIdentifierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	catalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	catalogueByDomain?: GraphQLTypes["TranslationCatalogue"] | undefined,
	catalogueByValues?: GraphQLTypes["TranslationCatalogue"] | undefined,
	paginateCatalogue: GraphQLTypes["TranslationCatalogueConnection"]
};
	["TranslationCataloguesIdentifierMeta"]: {
	__typename: "TranslationCataloguesIdentifierMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	catalogue?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
		domain?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
		key?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined
};
	["TranslationCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"] | undefined
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	keys?: Array<GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationDomainConnectOrCreateKeysRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationKeyWithoutDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	values?: Array<GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationKeyConnectOrCreateValuesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationValueWithoutKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	catalogue?: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationValueConnectOrCreateCatalogueRelationInput"] | undefined
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"] | undefined
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueConnectOrCreateIdentifierRelationInput"]: {
		connect: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"],
	create: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"] | undefined
};
	["TranslationCatalogueConnectOrCreateFallbackRelationInput"]: {
		connect: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create: GraphQLTypes["TranslationCatalogueCreateInput"]
};
	["TranslationValueConnectOrCreateCatalogueRelationInput"]: {
		connect: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationKeyConnectOrCreateValuesRelationInput"]: {
		connect: GraphQLTypes["TranslationValueUniqueWhere"],
	create: GraphQLTypes["TranslationValueWithoutKeyCreateInput"]
};
	["TranslationDomainConnectOrCreateKeysRelationInput"]: {
		connect: GraphQLTypes["TranslationKeyUniqueWhere"],
	create: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"]
};
	["TranslationCatalogueConnectOrCreateDomainRelationInput"]: {
		connect: GraphQLTypes["TranslationDomainUniqueWhere"],
	create: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationCatalogueConnectOrCreateValuesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	key?: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationValueConnectOrCreateKeyRelationInput"] | undefined
};
	["TranslationKeyWithoutValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationKeyConnectOrCreateDomainRelationInput"] | undefined
};
	["TranslationDomainWithoutKeysCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationDomainConnectOrCreateCataloguesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainConnectOrCreateCataloguesRelationInput"]: {
		connect: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"]
};
	["TranslationKeyConnectOrCreateDomainRelationInput"]: {
		connect: GraphQLTypes["TranslationDomainUniqueWhere"],
	create: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationValueConnectOrCreateKeyRelationInput"]: {
		connect: GraphQLTypes["TranslationKeyUniqueWhere"],
	create: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationCatalogueConnectOrCreateValuesRelationInput"]: {
		connect: GraphQLTypes["TranslationValueUniqueWhere"],
	create: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"] | undefined,
	update?: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCatalogueUpsertDomainRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
		identifier?: string | undefined,
	name?: string | undefined,
	keys?: Array<GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationDomainUpdateKeysRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationDomainUpsertKeysRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationDomainUpdateKeysRelationInput"]: {
		by: GraphQLTypes["TranslationKeyUniqueWhere"],
	data: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"]
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
		identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	values?: Array<GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationKeyUpdateValuesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationKeyUpsertValuesRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationKeyUpdateValuesRelationInput"]: {
		by: GraphQLTypes["TranslationValueUniqueWhere"],
	data: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"]
};
	["TranslationValueWithoutKeyUpdateInput"]: {
		value?: string | undefined,
	catalogue?: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationValueConnectOrCreateCatalogueRelationInput"] | undefined,
	update?: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationValueUpsertCatalogueRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"] | undefined,
	update?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCatalogueUpsertIdentifierRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
		update: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"],
	create: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"] | undefined,
	update?: GraphQLTypes["TranslationCatalogueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCatalogueUpsertFallbackRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
		update: GraphQLTypes["TranslationCatalogueUpdateInput"],
	create: GraphQLTypes["TranslationCatalogueCreateInput"]
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
		update: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"],
	create: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationKeyUpsertValuesRelationInput"]: {
		by: GraphQLTypes["TranslationValueUniqueWhere"],
	update: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"],
	create: GraphQLTypes["TranslationValueWithoutKeyCreateInput"]
};
	["TranslationDomainUpsertKeysRelationInput"]: {
		by: GraphQLTypes["TranslationKeyUniqueWhere"],
	update: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"],
	create: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"]
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
		update: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"],
	create: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationCatalogueUpdateValuesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCatalogueUpsertValuesRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
		by: GraphQLTypes["TranslationValueUniqueWhere"],
	data: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"]
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
		value?: string | undefined,
	key?: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationValueConnectOrCreateKeyRelationInput"] | undefined,
	update?: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationValueUpsertKeyRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
		identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationKeyConnectOrCreateDomainRelationInput"] | undefined,
	update?: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationKeyUpsertDomainRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
		identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationDomainUpdateCataloguesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationDomainUpsertCataloguesRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
		by: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	data: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"]
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
		identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
		by: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	update: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"],
	create: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"]
};
	["TranslationKeyUpsertDomainRelationInput"]: {
		update: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"],
	create: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationValueUpsertKeyRelationInput"]: {
		update: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"],
	create: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
		by: GraphQLTypes["TranslationValueUniqueWhere"],
	update: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"],
	create: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"]
};
	["TranslationCataloguesIdentifierConnection"]: {
	__typename: "TranslationCataloguesIdentifierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCataloguesIdentifierEdge"]>
};
	["TranslationCataloguesIdentifierEdge"]: {
	__typename: "TranslationCataloguesIdentifierEdge",
	node: GraphQLTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	catalogue?: Array<GraphQLTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"]: {
		connect: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"]
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	catalogue?: Array<GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
		by: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	data: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"]
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
		by: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	update: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"],
	create: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"]
};
	["TranslationDomainConnection"]: {
	__typename: "TranslationDomainConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationDomainEdge"]>
};
	["TranslationDomainEdge"]: {
	__typename: "TranslationDomainEdge",
	node: GraphQLTypes["TranslationDomain"]
};
	["TranslationDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined,
	keys?: Array<GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateInput"]: {
		identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined,
	keys?: Array<GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateInput"]: {
		identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationKeyContentType"] | undefined,
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	catalogue?: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined,
	key?: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateInput"]: {
		value?: string | undefined,
	catalogue?: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined,
	key?: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	settings?: GraphQLTypes["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"] | undefined,
	linkList?: GraphQLTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"] | undefined
};
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"]: {
		connect: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]
};
	["GenericPageAboutGroupLinksLocaleUpdateInput"]: {
		order?: number | undefined,
	settings?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"] | undefined,
	linkList?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageAboutSettingsLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"] | undefined,
	update?: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"]: {
		root?: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"]: {
		update: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"],
	create: GraphQLTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]
};
	["MemberListConnection"]: {
	__typename: "MemberListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MemberListEdge"]>
};
	["MemberListEdge"]: {
	__typename: "MemberListEdge",
	node: GraphQLTypes["MemberList"]
};
	["MemberListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	position?: string | undefined,
	list?: GraphQLTypes["MemberListItemCreateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["MemberListItemCreateImageEntityRelationInput"] | undefined,
	descriptionContent?: GraphQLTypes["MemberListItemCreateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MemberListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MemberListItemConnectOrCreateListRelationInput"] | undefined
};
	["MemberListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["MemberListUniqueWhere"],
	create: GraphQLTypes["MemberListWithoutItemsCreateInput"]
};
	["MemberListItemUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	position?: string | undefined,
	list?: GraphQLTypes["MemberListItemUpdateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["MemberListItemUpdateImageEntityRelationInput"] | undefined,
	descriptionContent?: GraphQLTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MemberListItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MemberListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MemberListItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["MemberListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MemberListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["MemberListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["MemberListItemUpsertListRelationInput"]: {
		update: GraphQLTypes["MemberListWithoutItemsUpdateInput"],
	create: GraphQLTypes["MemberListWithoutItemsCreateInput"]
};
	["FilledTaxFormConnection"]: {
	__typename: "FilledTaxFormConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FilledTaxFormEdge"]>
};
	["FilledTaxFormEdge"]: {
	__typename: "FilledTaxFormEdge",
	node: GraphQLTypes["FilledTaxForm"]
};
	["FilledTaxFormEmailAddress"]: {
	__typename: "FilledTaxFormEmailAddress",
	_meta?: GraphQLTypes["FilledTaxFormEmailAddressMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	email: string
};
	["FilledTaxFormEmailAddressMeta"]: {
	__typename: "FilledTaxFormEmailAddressMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined
};
	["FilledTaxFormEmailAddressUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["FilledTaxFormEmailAddressWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["FilledTaxFormEmailAddressWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FilledTaxFormEmailAddressWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FilledTaxFormEmailAddressWhere"] | undefined
};
	["FilledTaxFormEmailAddressOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined
};
	["FilledTaxFormEmailAddressConnection"]: {
	__typename: "FilledTaxFormEmailAddressConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FilledTaxFormEmailAddressEdge"]>
};
	["FilledTaxFormEmailAddressEdge"]: {
	__typename: "FilledTaxFormEmailAddressEdge",
	node: GraphQLTypes["FilledTaxFormEmailAddress"]
};
	["FilledTaxFormEmailAddressCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	email?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FilledTaxFormEmailAddressUpdateInput"]: {
		order?: number | undefined,
	email?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FormConnection"]: {
	__typename: "FormConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FormEdge"]>
};
	["FormEdge"]: {
	__typename: "FormEdge",
	node: GraphQLTypes["Form"]
};
	["CsobPaymentConnection"]: {
	__typename: "CsobPaymentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CsobPaymentEdge"]>
};
	["CsobPaymentEdge"]: {
	__typename: "CsobPaymentEdge",
	node: GraphQLTypes["CsobPayment"]
};
	["CsobPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	payId?: string | undefined,
	statusChanges?: Array<GraphQLTypes["CsobPaymentCreateStatusChangesEntityRelationInput"]> | undefined,
	payment?: GraphQLTypes["CsobPaymentCreatePaymentEntityRelationInput"] | undefined,
	originalPayId?: string | undefined,
	metadata?: GraphQLTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentCreatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentWithoutCsobPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CsobPaymentConnectOrCreatePaymentRelationInput"] | undefined
};
	["UserPaymentWithoutCsobPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentConnectOrCreatePaymentRelationInput"]: {
		connect: GraphQLTypes["UserPaymentUniqueWhere"],
	create: GraphQLTypes["UserPaymentWithoutCsobPaymentCreateInput"]
};
	["CsobPaymentUpdateInput"]: {
		payId?: string | undefined,
	statusChanges?: Array<GraphQLTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"]> | undefined,
	payment?: GraphQLTypes["CsobPaymentUpdatePaymentEntityRelationInput"] | undefined,
	originalPayId?: string | undefined,
	metadata?: GraphQLTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentUpdatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentWithoutCsobPaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CsobPaymentConnectOrCreatePaymentRelationInput"] | undefined,
	update?: GraphQLTypes["UserPaymentWithoutCsobPaymentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CsobPaymentUpsertPaymentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentWithoutCsobPaymentUpdateInput"]: {
		cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentUpsertPaymentRelationInput"]: {
		update: GraphQLTypes["UserPaymentWithoutCsobPaymentUpdateInput"],
	create: GraphQLTypes["UserPaymentWithoutCsobPaymentCreateInput"]
};
	["CsobPaymentStatusChangeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	dttm?: string | undefined,
	status?: number | undefined,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	payment?: GraphQLTypes["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["CsobPaymentWithoutStatusChangesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined
};
	["CsobPaymentWithoutStatusChangesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	payId?: string | undefined,
	payment?: GraphQLTypes["CsobPaymentCreatePaymentEntityRelationInput"] | undefined,
	originalPayId?: string | undefined,
	metadata?: GraphQLTypes["CsobPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"]: {
		connect: GraphQLTypes["CsobPaymentUniqueWhere"],
	create: GraphQLTypes["CsobPaymentWithoutStatusChangesCreateInput"]
};
	["CsobPaymentStatusChangeUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	dttm?: string | undefined,
	status?: number | undefined,
	resultCode?: number | undefined,
	message?: string | undefined,
	authCode?: string | undefined,
	statusDetail?: string | undefined,
	actions?: string | undefined,
	payment?: GraphQLTypes["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["CsobPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["CsobPaymentWithoutStatusChangesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined,
	update?: GraphQLTypes["CsobPaymentWithoutStatusChangesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CsobPaymentStatusChangeUpsertPaymentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["CsobPaymentWithoutStatusChangesUpdateInput"]: {
		payId?: string | undefined,
	payment?: GraphQLTypes["CsobPaymentUpdatePaymentEntityRelationInput"] | undefined,
	originalPayId?: string | undefined,
	metadata?: GraphQLTypes["CsobPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CsobPaymentStatusChangeUpsertPaymentRelationInput"]: {
		update: GraphQLTypes["CsobPaymentWithoutStatusChangesUpdateInput"],
	create: GraphQLTypes["CsobPaymentWithoutStatusChangesCreateInput"]
};
	["StripePaymentConnection"]: {
	__typename: "StripePaymentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StripePaymentEdge"]>
};
	["StripePaymentEdge"]: {
	__typename: "StripePaymentEdge",
	node: GraphQLTypes["StripePayment"]
};
	["StripePaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	statusChanges?: Array<GraphQLTypes["StripePaymentCreateStatusChangesEntityRelationInput"]> | undefined,
	payment?: GraphQLTypes["StripePaymentCreatePaymentEntityRelationInput"] | undefined,
	metadata?: GraphQLTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentCreatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentWithoutStripePaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StripePaymentConnectOrCreatePaymentRelationInput"] | undefined
};
	["UserPaymentWithoutStripePaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentCreateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentConnectOrCreatePaymentRelationInput"]: {
		connect: GraphQLTypes["UserPaymentUniqueWhere"],
	create: GraphQLTypes["UserPaymentWithoutStripePaymentCreateInput"]
};
	["StripePaymentUpdateInput"]: {
		identifier?: string | undefined,
	statusChanges?: Array<GraphQLTypes["StripePaymentUpdateStatusChangesEntityRelationInput"]> | undefined,
	payment?: GraphQLTypes["StripePaymentUpdatePaymentEntityRelationInput"] | undefined,
	metadata?: GraphQLTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentUpdatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentWithoutStripePaymentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StripePaymentConnectOrCreatePaymentRelationInput"] | undefined,
	update?: GraphQLTypes["UserPaymentWithoutStripePaymentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StripePaymentUpsertPaymentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserPaymentWithoutStripePaymentUpdateInput"]: {
		cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	triesCollection?: GraphQLTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentUpsertPaymentRelationInput"]: {
		update: GraphQLTypes["UserPaymentWithoutStripePaymentUpdateInput"],
	create: GraphQLTypes["UserPaymentWithoutStripePaymentCreateInput"]
};
	["StripePaymentStatusChangeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	payment?: GraphQLTypes["StripePaymentStatusChangeCreatePaymentEntityRelationInput"] | undefined,
	timestamp?: number | undefined,
	eventId?: string | undefined,
	paymentIntentStatus?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentStatusChangeCreatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["StripePaymentWithoutStatusChangesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined
};
	["StripePaymentWithoutStatusChangesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	payment?: GraphQLTypes["StripePaymentCreatePaymentEntityRelationInput"] | undefined,
	metadata?: GraphQLTypes["StripePaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"]: {
		connect: GraphQLTypes["StripePaymentUniqueWhere"],
	create: GraphQLTypes["StripePaymentWithoutStatusChangesCreateInput"]
};
	["StripePaymentStatusChangeUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	payment?: GraphQLTypes["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"] | undefined,
	timestamp?: number | undefined,
	eventId?: string | undefined,
	paymentIntentStatus?: GraphQLTypes["StripePaymentStatusChangePaymentIntentStatus"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["StripePaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["StripePaymentWithoutStatusChangesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"] | undefined,
	update?: GraphQLTypes["StripePaymentWithoutStatusChangesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StripePaymentStatusChangeUpsertPaymentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["StripePaymentWithoutStatusChangesUpdateInput"]: {
		identifier?: string | undefined,
	payment?: GraphQLTypes["StripePaymentUpdatePaymentEntityRelationInput"] | undefined,
	metadata?: GraphQLTypes["StripePaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StripePaymentStatusChangeUpsertPaymentRelationInput"]: {
		update: GraphQLTypes["StripePaymentWithoutStatusChangesUpdateInput"],
	create: GraphQLTypes["StripePaymentWithoutStatusChangesCreateInput"]
};
	["RegionPaymentMethodCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	allowRecurringPayments?: boolean | undefined,
	region?: GraphQLTypes["RegionPaymentMethodCreateRegionEntityRelationInput"] | undefined,
	method?: GraphQLTypes["PaymentMethods"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionPaymentMethodCreateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"] | undefined
};
	["RegionWithoutEnabledPaymentMethodsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: GraphQLTypes["RegionCreateCurrencyEntityRelationInput"] | undefined,
	donationItems?: Array<GraphQLTypes["RegionCreateDonationItemsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionPaymentMethodConnectOrCreateRegionRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionWithoutEnabledPaymentMethodsCreateInput"]
};
	["RegionPaymentMethodUpdateInput"]: {
		allowRecurringPayments?: boolean | undefined,
	region?: GraphQLTypes["RegionPaymentMethodUpdateRegionEntityRelationInput"] | undefined,
	method?: GraphQLTypes["PaymentMethods"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionPaymentMethodUpdateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RegionWithoutEnabledPaymentMethodsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"] | undefined,
	update?: GraphQLTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RegionPaymentMethodUpsertRegionRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["RegionWithoutEnabledPaymentMethodsUpdateInput"]: {
		order?: number | undefined,
	code?: string | undefined,
	label?: string | undefined,
	currency?: GraphQLTypes["RegionUpdateCurrencyEntityRelationInput"] | undefined,
	donationItems?: Array<GraphQLTypes["RegionUpdateDonationItemsEntityRelationInput"]> | undefined,
	timezone?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RegionPaymentMethodUpsertRegionRelationInput"]: {
		update: GraphQLTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"],
	create: GraphQLTypes["RegionWithoutEnabledPaymentMethodsCreateInput"]
};
	["PostAreaMetaDataConnection"]: {
	__typename: "PostAreaMetaDataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaMetaDataEdge"]>
};
	["PostAreaMetaDataEdge"]: {
	__typename: "PostAreaMetaDataEdge",
	node: GraphQLTypes["PostAreaMetaData"]
};
	["PostMetaDataConnection"]: {
	__typename: "PostMetaDataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostMetaDataEdge"]>
};
	["PostMetaDataEdge"]: {
	__typename: "PostMetaDataEdge",
	node: GraphQLTypes["PostMetaData"]
};
	["PostOrganizationMetaDataConnection"]: {
	__typename: "PostOrganizationMetaDataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostOrganizationMetaDataEdge"]>
};
	["PostOrganizationMetaDataEdge"]: {
	__typename: "PostOrganizationMetaDataEdge",
	node: GraphQLTypes["PostOrganizationMetaData"]
};
	["TileItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	type?: GraphQLTypes["TileItemType"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	list?: GraphQLTypes["TileItemCreateListEntityRelationInput"] | undefined,
	post?: GraphQLTypes["TileItemCreatePostEntityRelationInput"] | undefined,
	area?: GraphQLTypes["TileItemCreateAreaEntityRelationInput"] | undefined,
	image?: GraphQLTypes["TileItemCreateImageEntityRelationInput"] | undefined,
	link?: GraphQLTypes["TileItemCreateLinkEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["TileItemCreateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TileListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TileListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateListRelationInput"] | undefined
};
	["TileListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	size?: GraphQLTypes["TileListSize"] | undefined,
	title?: string | undefined,
	areaType?: GraphQLTypes["TileListCreateAreaTypeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["TileListUniqueWhere"],
	create: GraphQLTypes["TileListWithoutItemsCreateInput"]
};
	["TileItemUpdateInput"]: {
		order?: number | undefined,
	type?: GraphQLTypes["TileItemType"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	list?: GraphQLTypes["TileItemUpdateListEntityRelationInput"] | undefined,
	post?: GraphQLTypes["TileItemUpdatePostEntityRelationInput"] | undefined,
	area?: GraphQLTypes["TileItemUpdateAreaEntityRelationInput"] | undefined,
	image?: GraphQLTypes["TileItemUpdateImageEntityRelationInput"] | undefined,
	link?: GraphQLTypes["TileItemUpdateLinkEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["TileItemUpdateOrganizationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TileListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TileListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["TileListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TileListWithoutItemsUpdateInput"]: {
		size?: GraphQLTypes["TileListSize"] | undefined,
	title?: string | undefined,
	areaType?: GraphQLTypes["TileListUpdateAreaTypeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileItemUpsertListRelationInput"]: {
		update: GraphQLTypes["TileListWithoutItemsUpdateInput"],
	create: GraphQLTypes["TileListWithoutItemsCreateInput"]
};
	["TileListConnection"]: {
	__typename: "TileListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TileListEdge"]>
};
	["TileListEdge"]: {
	__typename: "TileListEdge",
	node: GraphQLTypes["TileList"]
};
	["FeedPageConnection"]: {
	__typename: "FeedPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FeedPageEdge"]>
};
	["FeedPageEdge"]: {
	__typename: "FeedPageEdge",
	node: GraphQLTypes["FeedPage"]
};
	["FeedPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["FeedPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["FeedPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	heroTiles?: GraphQLTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<GraphQLTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined,
	cardList?: GraphQLTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutFeedPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutFeedPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutFeedPagesCreateInput"]
};
	["FeedPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["FeedPageLocaleUniqueWhere"],
	create: GraphQLTypes["FeedPageLocaleWithoutRootCreateInput"]
};
	["FeedPageUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["FeedPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["FeedPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["FeedPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FeedPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["FeedPageLocaleUniqueWhere"],
	data: GraphQLTypes["FeedPageLocaleWithoutRootUpdateInput"]
};
	["FeedPageLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	heroTiles?: GraphQLTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<GraphQLTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined,
	cardList?: GraphQLTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutFeedPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutFeedPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutFeedPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	recurringPaymentPages?: Array<GraphQLTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutFeedPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutFeedPagesCreateInput"]
};
	["FeedPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["FeedPageLocaleUniqueWhere"],
	update: GraphQLTypes["FeedPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["FeedPageLocaleWithoutRootCreateInput"]
};
	["FeedPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	heroTiles?: GraphQLTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<GraphQLTypes["FeedPageLocaleCreateSectionListEntityRelationInput"]> | undefined,
	cardList?: GraphQLTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageLocaleUpdateInput"]: {
		root?: GraphQLTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	heroTiles?: GraphQLTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined,
	sectionList?: Array<GraphQLTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"]> | undefined,
	cardList?: GraphQLTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	feedPageLocale?: GraphQLTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"] | undefined,
	tileStripeList?: Array<GraphQLTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageLocaleWithoutSectionListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"] | undefined
};
	["FeedPageLocaleWithoutSectionListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["FeedPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["FeedPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	heroTiles?: GraphQLTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"] | undefined,
	cardList?: GraphQLTypes["FeedPageLocaleCreateCardListEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"]: {
		connect: GraphQLTypes["FeedPageLocaleUniqueWhere"],
	create: GraphQLTypes["FeedPageLocaleWithoutSectionListCreateInput"]
};
	["FeedPageSectionUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	feedPageLocale?: GraphQLTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"] | undefined,
	tileStripeList?: Array<GraphQLTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageLocaleWithoutSectionListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["FeedPageLocaleWithoutSectionListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageSectionUpsertFeedPageLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FeedPageLocaleWithoutSectionListUpdateInput"]: {
		root?: GraphQLTypes["FeedPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	heroTiles?: GraphQLTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"] | undefined,
	cardList?: GraphQLTypes["FeedPageLocaleUpdateCardListEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageSectionUpsertFeedPageLocaleRelationInput"]: {
		update: GraphQLTypes["FeedPageLocaleWithoutSectionListUpdateInput"],
	create: GraphQLTypes["FeedPageLocaleWithoutSectionListCreateInput"]
};
	["FeedPageTileStripeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	section?: GraphQLTypes["FeedPageTileStripeCreateSectionEntityRelationInput"] | undefined,
	tileList?: GraphQLTypes["FeedPageTileStripeCreateTileListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeCreateSectionEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"] | undefined
};
	["FeedPageSectionWithoutTileStripeListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	feedPageLocale?: GraphQLTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeConnectOrCreateSectionRelationInput"]: {
		connect: GraphQLTypes["FeedPageSectionUniqueWhere"],
	create: GraphQLTypes["FeedPageSectionWithoutTileStripeListCreateInput"]
};
	["FeedPageTileStripeUpdateInput"]: {
		order?: number | undefined,
	section?: GraphQLTypes["FeedPageTileStripeUpdateSectionEntityRelationInput"] | undefined,
	tileList?: GraphQLTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeUpdateSectionEntityRelationInput"]: {
		connect?: GraphQLTypes["FeedPageSectionUniqueWhere"] | undefined,
	create?: GraphQLTypes["FeedPageSectionWithoutTileStripeListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"] | undefined,
	update?: GraphQLTypes["FeedPageSectionWithoutTileStripeListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FeedPageTileStripeUpsertSectionRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FeedPageSectionWithoutTileStripeListUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	feedPageLocale?: GraphQLTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FeedPageTileStripeUpsertSectionRelationInput"]: {
		update: GraphQLTypes["FeedPageSectionWithoutTileStripeListUpdateInput"],
	create: GraphQLTypes["FeedPageSectionWithoutTileStripeListCreateInput"]
};
	["CardItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	description?: string | undefined,
	list?: GraphQLTypes["CardItemCreateListEntityRelationInput"] | undefined,
	link?: GraphQLTypes["CardItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["CardListUniqueWhere"] | undefined,
	create?: GraphQLTypes["CardListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CardItemConnectOrCreateListRelationInput"] | undefined
};
	["CardListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["CardListUniqueWhere"],
	create: GraphQLTypes["CardListWithoutItemsCreateInput"]
};
	["CardItemUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	description?: string | undefined,
	list?: GraphQLTypes["CardItemUpdateListEntityRelationInput"] | undefined,
	link?: GraphQLTypes["CardItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CardItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["CardListUniqueWhere"] | undefined,
	create?: GraphQLTypes["CardListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CardItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["CardListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CardItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["CardListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["CardItemUpsertListRelationInput"]: {
		update: GraphQLTypes["CardListWithoutItemsUpdateInput"],
	create: GraphQLTypes["CardListWithoutItemsCreateInput"]
};
	["CardListConnection"]: {
	__typename: "CardListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CardListEdge"]>
};
	["CardListEdge"]: {
	__typename: "CardListEdge",
	node: GraphQLTypes["CardList"]
};
	["UserPaymentTriesCollectionConnection"]: {
	__typename: "UserPaymentTriesCollectionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserPaymentTriesCollectionEdge"]>
};
	["UserPaymentTriesCollectionEdge"]: {
	__typename: "UserPaymentTriesCollectionEdge",
	node: GraphQLTypes["UserPaymentTriesCollection"]
};
	["UserPaymentTriesCollectionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	orderUrl?: string | undefined,
	payment?: Array<GraphQLTypes["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]> | undefined,
	user?: GraphQLTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"] | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"] | undefined,
	recurring?: GraphQLTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"] | undefined,
	metadataLocales?: Array<GraphQLTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]> | undefined,
	medium?: GraphQLTypes["PaymentMedium"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserPaymentWithoutTriesCollectionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"] | undefined,
	alias?: string | undefined
};
	["UserPaymentWithoutTriesCollectionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentCreateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentCreateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentCreateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentCreateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentCreateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentCreateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentCreateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"]: {
		connect: GraphQLTypes["UserPaymentUniqueWhere"],
	create: GraphQLTypes["UserPaymentWithoutTriesCollectionCreateInput"]
};
	["UserPaymentTriesCollectionUpdateInput"]: {
		cents?: number | undefined,
	specificSymbol?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	orderUrl?: string | undefined,
	payment?: Array<GraphQLTypes["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]> | undefined,
	user?: GraphQLTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"] | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	recurring?: GraphQLTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"] | undefined,
	metadataLocales?: Array<GraphQLTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]> | undefined,
	medium?: GraphQLTypes["PaymentMedium"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]: {
		create?: GraphQLTypes["UserPaymentWithoutTriesCollectionCreateInput"] | undefined,
	update?: GraphQLTypes["UserPaymentTriesCollectionUpdatePaymentRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserPaymentTriesCollectionUpsertPaymentRelationInput"] | undefined,
	connect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserPaymentTriesCollectionUpdatePaymentRelationInput"]: {
		by: GraphQLTypes["UserPaymentUniqueWhere"],
	data: GraphQLTypes["UserPaymentWithoutTriesCollectionUpdateInput"]
};
	["UserPaymentWithoutTriesCollectionUpdateInput"]: {
		cents?: number | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	specificSymbol?: string | undefined,
	currency?: GraphQLTypes["UserPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	order?: GraphQLTypes["UserPaymentUpdateOrderEntityRelationInput"] | undefined,
	csobPayment?: GraphQLTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"] | undefined,
	stripePayment?: GraphQLTypes["UserPaymentUpdateStripePaymentEntityRelationInput"] | undefined,
	recurringPaymentItem?: GraphQLTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"] | undefined,
	method?: GraphQLTypes["UserPaymentMethod"] | undefined,
	region?: GraphQLTypes["UserPaymentUpdateRegionEntityRelationInput"] | undefined,
	user?: GraphQLTypes["UserPaymentUpdateUserEntityRelationInput"] | undefined,
	isReusable?: boolean | undefined,
	onBehalfDonation?: GraphQLTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"] | undefined,
	successEmailSentAt?: GraphQLTypes["DateTime"] | undefined,
	isSuccessful?: boolean | undefined,
	isFinished?: boolean | undefined,
	metadata?: GraphQLTypes["UserPaymentUpdateMetadataEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentTriesCollectionUpsertPaymentRelationInput"]: {
		by: GraphQLTypes["UserPaymentUniqueWhere"],
	update: GraphQLTypes["UserPaymentWithoutTriesCollectionUpdateInput"],
	create: GraphQLTypes["UserPaymentWithoutTriesCollectionCreateInput"]
};
	["RecurringPaymentPageConnection"]: {
	__typename: "RecurringPaymentPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RecurringPaymentPageEdge"]>
};
	["RecurringPaymentPageEdge"]: {
	__typename: "RecurringPaymentPageEdge",
	node: GraphQLTypes["RecurringPaymentPage"]
};
	["RecurringPaymentPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["RecurringPaymentPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["RecurringPaymentPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	favouritePosts?: GraphQLTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutRecurringPaymentPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleCreateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleCreatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleCreatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleCreatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleCreatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleCreateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleCreateFeedPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleCreateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleCreateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleCreateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleCreateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutRecurringPaymentPagesCreateInput"]
};
	["RecurringPaymentPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"],
	create: GraphQLTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"]
};
	["RecurringPaymentPageUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["RecurringPaymentPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["RecurringPaymentPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["RecurringPaymentPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RecurringPaymentPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"],
	data: GraphQLTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"]
};
	["RecurringPaymentPageLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	favouritePosts?: GraphQLTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutRecurringPaymentPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RecurringPaymentPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutRecurringPaymentPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	order?: number | undefined,
	generals?: Array<GraphQLTypes["LocaleUpdateGeneralsEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	posts?: Array<GraphQLTypes["LocaleUpdatePostsEntityRelationInput"]> | undefined,
	postAreas?: Array<GraphQLTypes["LocaleUpdatePostAreasEntityRelationInput"]> | undefined,
	postOrganizations?: Array<GraphQLTypes["LocaleUpdatePostOrganizationsEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPageAboutSettings?: Array<GraphQLTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]> | undefined,
	postRevisions?: Array<GraphQLTypes["LocaleUpdatePostRevisionsEntityRelationInput"]> | undefined,
	flagImage?: GraphQLTypes["LocaleUpdateFlagImageEntityRelationInput"] | undefined,
	feedPages?: Array<GraphQLTypes["LocaleUpdateFeedPagesEntityRelationInput"]> | undefined,
	givenGiftsPages?: Array<GraphQLTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"]> | undefined,
	receivedGiftsPages?: Array<GraphQLTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]> | undefined,
	reportPages?: Array<GraphQLTypes["LocaleUpdateReportPagesEntityRelationInput"]> | undefined,
	reportNavigations?: Array<GraphQLTypes["LocaleUpdateReportNavigationsEntityRelationInput"]> | undefined,
	scheduledNotifications?: Array<GraphQLTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"]> | undefined,
	sentPayments?: Array<GraphQLTypes["LocaleUpdateSentPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutRecurringPaymentPagesCreateInput"]
};
	["RecurringPaymentPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["RecurringPaymentPageLocaleUniqueWhere"],
	update: GraphQLTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"]
};
	["RecurringPaymentPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	favouritePosts?: GraphQLTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecurringPaymentPageLocaleUpdateInput"]: {
		root?: GraphQLTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	favouritePosts?: GraphQLTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"] | undefined,
	storyGuideList?: GraphQLTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideConnection"]: {
	__typename: "StoryGuideConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StoryGuideEdge"]>
};
	["StoryGuideEdge"]: {
	__typename: "StoryGuideEdge",
	node: GraphQLTypes["StoryGuide"]
};
	["StoryGuideItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["StoryGuideItemCreateListEntityRelationInput"] | undefined,
	guide?: GraphQLTypes["StoryGuideItemCreateGuideEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideItemConnectOrCreateListRelationInput"] | undefined
};
	["StoryGuideListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["StoryGuideListUniqueWhere"],
	create: GraphQLTypes["StoryGuideListWithoutItemsCreateInput"]
};
	["StoryGuideItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["StoryGuideItemUpdateListEntityRelationInput"] | undefined,
	guide?: GraphQLTypes["StoryGuideItemUpdateGuideEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StoryGuideItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["StoryGuideListUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoryGuideListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StoryGuideItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["StoryGuideListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StoryGuideItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["StoryGuideListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["StoryGuideItemUpsertListRelationInput"]: {
		update: GraphQLTypes["StoryGuideListWithoutItemsUpdateInput"],
	create: GraphQLTypes["StoryGuideListWithoutItemsCreateInput"]
};
	["StoryGuideListConnection"]: {
	__typename: "StoryGuideListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StoryGuideListEdge"]>
};
	["StoryGuideListEdge"]: {
	__typename: "StoryGuideListEdge",
	node: GraphQLTypes["StoryGuideList"]
};
	["StripePaymentMetadataConnection"]: {
	__typename: "StripePaymentMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StripePaymentMetadataEdge"]>
};
	["StripePaymentMetadataEdge"]: {
	__typename: "StripePaymentMetadataEdge",
	node: GraphQLTypes["StripePaymentMetadata"]
};
	["OnBehalfDonationMetadataConnection"]: {
	__typename: "OnBehalfDonationMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OnBehalfDonationMetadataEdge"]>
};
	["OnBehalfDonationMetadataEdge"]: {
	__typename: "OnBehalfDonationMetadataEdge",
	node: GraphQLTypes["OnBehalfDonationMetadata"]
};
	["UserPaymentTriesCollectionMetadataConnection"]: {
	__typename: "UserPaymentTriesCollectionMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataEdge"]>
};
	["UserPaymentTriesCollectionMetadataEdge"]: {
	__typename: "UserPaymentTriesCollectionMetadataEdge",
	node: GraphQLTypes["UserPaymentTriesCollectionMetadata"]
};
	["CsobPaymentMetadataConnection"]: {
	__typename: "CsobPaymentMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CsobPaymentMetadataEdge"]>
};
	["CsobPaymentMetadataEdge"]: {
	__typename: "CsobPaymentMetadataEdge",
	node: GraphQLTypes["CsobPaymentMetadata"]
};
	["PostOrganizationListConnection"]: {
	__typename: "PostOrganizationListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostOrganizationListEdge"]>
};
	["PostOrganizationListEdge"]: {
	__typename: "PostOrganizationListEdge",
	node: GraphQLTypes["PostOrganizationList"]
};
	["PostOrganizationListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["PostOrganizationListItemCreateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["PostOrganizationListItemCreateItemEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	link?: GraphQLTypes["PostOrganizationListItemCreateLinkEntityRelationInput"] | undefined,
	image?: GraphQLTypes["PostOrganizationListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListItemConnectOrCreateListRelationInput"] | undefined
};
	["PostOrganizationListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["PostOrganizationListUniqueWhere"],
	create: GraphQLTypes["PostOrganizationListWithoutItemsCreateInput"]
};
	["PostOrganizationListItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["PostOrganizationListItemUpdateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["PostOrganizationListItemUpdateItemEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PostOrganizationListItemType"] | undefined,
	link?: GraphQLTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"] | undefined,
	image?: GraphQLTypes["PostOrganizationListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["PostOrganizationListUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostOrganizationListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PostOrganizationListItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["PostOrganizationListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PostOrganizationListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PostOrganizationListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["PostOrganizationListItemUpsertListRelationInput"]: {
		update: GraphQLTypes["PostOrganizationListWithoutItemsUpdateInput"],
	create: GraphQLTypes["PostOrganizationListWithoutItemsCreateInput"]
};
	["InfoCarousel"]: {
	__typename: "InfoCarousel",
	_meta?: GraphQLTypes["InfoCarouselMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	isEnabled: boolean,
	validFrom?: GraphQLTypes["DateTime"] | undefined,
	validTo?: GraphQLTypes["DateTime"] | undefined,
	items: Array<GraphQLTypes["InfoCarouselItem"]>,
	seenBy: Array<GraphQLTypes["PersonSeenInfoCarousel"]>,
	itemsByLocales?: GraphQLTypes["InfoCarouselItem"] | undefined,
	seenByByUser?: GraphQLTypes["PersonSeenInfoCarousel"] | undefined,
	paginateItems: GraphQLTypes["InfoCarouselItemConnection"],
	paginateSeenBy: GraphQLTypes["PersonSeenInfoCarouselConnection"]
};
	["InfoCarouselMeta"]: {
	__typename: "InfoCarouselMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	isEnabled?: GraphQLTypes["FieldMeta"] | undefined,
	validFrom?: GraphQLTypes["FieldMeta"] | undefined,
	validTo?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	seenBy?: GraphQLTypes["FieldMeta"] | undefined
};
	["InfoCarouselItem"]: {
	__typename: "InfoCarouselItem",
	_meta?: GraphQLTypes["InfoCarouselItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	carousel?: GraphQLTypes["InfoCarousel"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	post?: GraphQLTypes["Post"] | undefined,
	subtitle?: string | undefined,
	type: GraphQLTypes["InfoCarouselItemType"],
	locales: Array<GraphQLTypes["InfoCarouselItemLocale"]>,
	localesByLocale?: GraphQLTypes["InfoCarouselItemLocale"] | undefined,
	paginateLocales: GraphQLTypes["InfoCarouselItemLocaleConnection"]
};
	["InfoCarouselItemMeta"]: {
	__typename: "InfoCarouselItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	carousel?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	post?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["InfoCarouselWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	isEnabled?: GraphQLTypes["BooleanCondition"] | undefined,
	validFrom?: GraphQLTypes["DateTimeCondition"] | undefined,
	validTo?: GraphQLTypes["DateTimeCondition"] | undefined,
	items?: GraphQLTypes["InfoCarouselItemWhere"] | undefined,
	seenBy?: GraphQLTypes["PersonSeenInfoCarouselWhere"] | undefined,
	and?: Array<GraphQLTypes["InfoCarouselWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InfoCarouselWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InfoCarouselWhere"] | undefined
};
	["InfoCarouselItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	carousel?: GraphQLTypes["InfoCarouselWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	post?: GraphQLTypes["PostWhere"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	type?: GraphQLTypes["InfoCarouselItemTypeCondition"] | undefined,
	locales?: GraphQLTypes["InfoCarouselItemLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["InfoCarouselItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InfoCarouselItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InfoCarouselItemWhere"] | undefined
};
	["InfoCarouselItemTypeCondition"]: {
		and?: Array<GraphQLTypes["InfoCarouselItemTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["InfoCarouselItemTypeCondition"]> | undefined,
	not?: GraphQLTypes["InfoCarouselItemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	notEq?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	in?: Array<GraphQLTypes["InfoCarouselItemType"]> | undefined,
	notIn?: Array<GraphQLTypes["InfoCarouselItemType"]> | undefined,
	lt?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	lte?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	gt?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	gte?: GraphQLTypes["InfoCarouselItemType"] | undefined
};
	["InfoCarouselItemType"]: InfoCarouselItemType;
	["InfoCarouselItemLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["InfoCarouselItemWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["InfoCarouselItemLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InfoCarouselItemLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InfoCarouselItemLocaleWhere"] | undefined
};
	["PersonSeenInfoCarouselWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	seenAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	carousel?: GraphQLTypes["InfoCarouselWhere"] | undefined,
	and?: Array<GraphQLTypes["PersonSeenInfoCarouselWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PersonSeenInfoCarouselWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PersonSeenInfoCarouselWhere"] | undefined
};
	["InfoCarouselItemLocale"]: {
	__typename: "InfoCarouselItemLocale",
	_meta?: GraphQLTypes["InfoCarouselItemLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	root?: GraphQLTypes["InfoCarouselItem"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["InfoCarouselItemLocaleMeta"]: {
	__typename: "InfoCarouselItemLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["InfoCarouselItemLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["InfoCarouselItemOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["InfoCarouselItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	carousel?: GraphQLTypes["InfoCarouselOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	post?: GraphQLTypes["PostOrderBy"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined
};
	["InfoCarouselOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	isEnabled?: GraphQLTypes["OrderDirection"] | undefined,
	validFrom?: GraphQLTypes["OrderDirection"] | undefined,
	validTo?: GraphQLTypes["OrderDirection"] | undefined
};
	["InfoCarouselItemLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["InfoCarouselItemLocaleConnection"]: {
	__typename: "InfoCarouselItemLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InfoCarouselItemLocaleEdge"]>
};
	["InfoCarouselItemLocaleEdge"]: {
	__typename: "InfoCarouselItemLocaleEdge",
	node: GraphQLTypes["InfoCarouselItemLocale"]
};
	["PersonSeenInfoCarousel"]: {
	__typename: "PersonSeenInfoCarousel",
	_meta?: GraphQLTypes["PersonSeenInfoCarouselMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	seenAt: GraphQLTypes["DateTime"],
	user?: GraphQLTypes["User"] | undefined,
	carousel?: GraphQLTypes["InfoCarousel"] | undefined
};
	["PersonSeenInfoCarouselMeta"]: {
	__typename: "PersonSeenInfoCarouselMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	seenAt?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	carousel?: GraphQLTypes["FieldMeta"] | undefined
};
	["PersonSeenInfoCarouselOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	seenAt?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined,
	carousel?: GraphQLTypes["InfoCarouselOrderBy"] | undefined
};
	["InfoCarouselItemsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined
};
	["InfoCarouselItemLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["InfoCarouselItemUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["InfoCarouselItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined
};
	["InfoCarouselSeenByByUserUniqueWhere"]: {
		user?: GraphQLTypes["UserUniqueWhere"] | undefined
};
	["InfoCarouselItemConnection"]: {
	__typename: "InfoCarouselItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InfoCarouselItemEdge"]>
};
	["InfoCarouselItemEdge"]: {
	__typename: "InfoCarouselItemEdge",
	node: GraphQLTypes["InfoCarouselItem"]
};
	["PersonSeenInfoCarouselConnection"]: {
	__typename: "PersonSeenInfoCarouselConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PersonSeenInfoCarouselEdge"]>
};
	["PersonSeenInfoCarouselEdge"]: {
	__typename: "PersonSeenInfoCarouselEdge",
	node: GraphQLTypes["PersonSeenInfoCarousel"]
};
	["InfoCarouselUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["InfoCarouselItemUniqueWhere"] | undefined,
	seenBy?: GraphQLTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined
};
	["PersonSeenInfoCarouselUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	user?: GraphQLTypes["UserUniqueWhere"] | undefined,
	carousel?: GraphQLTypes["InfoCarouselUniqueWhere"] | undefined
};
	["InfoCarouselConnection"]: {
	__typename: "InfoCarouselConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InfoCarouselEdge"]>
};
	["InfoCarouselEdge"]: {
	__typename: "InfoCarouselEdge",
	node: GraphQLTypes["InfoCarousel"]
};
	["InfoCarouselCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: GraphQLTypes["DateTime"] | undefined,
	validTo?: GraphQLTypes["DateTime"] | undefined,
	items?: Array<GraphQLTypes["InfoCarouselCreateItemsEntityRelationInput"]> | undefined,
	seenBy?: Array<GraphQLTypes["InfoCarouselCreateSeenByEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoCarouselItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoCarouselItemWithoutCarouselCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselItemWithoutCarouselCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	image?: GraphQLTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	locales?: Array<GraphQLTypes["InfoCarouselItemCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemConnectOrCreateImageRelationInput"] | undefined
};
	["InfoCarouselItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["InfoCarouselItemCreatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemConnectOrCreatePostRelationInput"] | undefined
};
	["InfoCarouselItemConnectOrCreatePostRelationInput"]: {
		connect: GraphQLTypes["PostUniqueWhere"],
	create: GraphQLTypes["PostCreateInput"]
};
	["InfoCarouselItemCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselItemLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	locale?: GraphQLTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleCreateInput"]
};
	["InfoCarouselItemConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"],
	create: GraphQLTypes["InfoCarouselItemLocaleWithoutRootCreateInput"]
};
	["InfoCarouselConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["InfoCarouselItemUniqueWhere"],
	create: GraphQLTypes["InfoCarouselItemWithoutCarouselCreateInput"]
};
	["InfoCarouselCreateSeenByEntityRelationInput"]: {
		connect?: GraphQLTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselConnectOrCreateSeenByRelationInput"] | undefined,
	alias?: string | undefined
};
	["PersonSeenInfoCarouselWithoutCarouselCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	seenAt?: GraphQLTypes["DateTime"] | undefined,
	user?: GraphQLTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"] | undefined
};
	["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserCreateInput"]
};
	["InfoCarouselConnectOrCreateSeenByRelationInput"]: {
		connect: GraphQLTypes["PersonSeenInfoCarouselUniqueWhere"],
	create: GraphQLTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"]
};
	["InfoCarouselUpdateInput"]: {
		name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: GraphQLTypes["DateTime"] | undefined,
	validTo?: GraphQLTypes["DateTime"] | undefined,
	items?: Array<GraphQLTypes["InfoCarouselUpdateItemsEntityRelationInput"]> | undefined,
	seenBy?: Array<GraphQLTypes["InfoCarouselUpdateSeenByEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["InfoCarouselItemWithoutCarouselCreateInput"] | undefined,
	update?: GraphQLTypes["InfoCarouselUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["InfoCarouselUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["InfoCarouselItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InfoCarouselItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InfoCarouselItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselUpdateItemsRelationInput"]: {
		by: GraphQLTypes["InfoCarouselItemUniqueWhere"],
	data: GraphQLTypes["InfoCarouselItemWithoutCarouselUpdateInput"]
};
	["InfoCarouselItemWithoutCarouselUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	image?: GraphQLTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	locales?: Array<GraphQLTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoCarouselItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["InfoCarouselItemUpdatePostEntityRelationInput"]: {
		connect?: GraphQLTypes["PostUniqueWhere"] | undefined,
	create?: GraphQLTypes["PostCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemConnectOrCreatePostRelationInput"] | undefined,
	update?: GraphQLTypes["PostUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoCarouselItemUpsertPostRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselItemUpsertPostRelationInput"]: {
		update: GraphQLTypes["PostUpdateInput"],
	create: GraphQLTypes["PostCreateInput"]
};
	["InfoCarouselItemUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["InfoCarouselItemLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["InfoCarouselItemUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["InfoCarouselItemUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselItemUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"],
	data: GraphQLTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"]
};
	["InfoCarouselItemLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	locale?: GraphQLTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoCarouselItemLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselItemLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleUpdateInput"],
	create: GraphQLTypes["LocaleCreateInput"]
};
	["InfoCarouselItemUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["InfoCarouselItemLocaleUniqueWhere"],
	update: GraphQLTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["InfoCarouselItemLocaleWithoutRootCreateInput"]
};
	["InfoCarouselUpsertItemsRelationInput"]: {
		by: GraphQLTypes["InfoCarouselItemUniqueWhere"],
	update: GraphQLTypes["InfoCarouselItemWithoutCarouselUpdateInput"],
	create: GraphQLTypes["InfoCarouselItemWithoutCarouselCreateInput"]
};
	["InfoCarouselUpdateSeenByEntityRelationInput"]: {
		create?: GraphQLTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"] | undefined,
	update?: GraphQLTypes["InfoCarouselUpdateSeenByRelationInput"] | undefined,
	upsert?: GraphQLTypes["InfoCarouselUpsertSeenByRelationInput"] | undefined,
	connect?: GraphQLTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PersonSeenInfoCarouselUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InfoCarouselUpdateSeenByRelationInput"]: {
		by: GraphQLTypes["PersonSeenInfoCarouselUniqueWhere"],
	data: GraphQLTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"]
};
	["PersonSeenInfoCarouselWithoutCarouselUpdateInput"]: {
		seenAt?: GraphQLTypes["DateTime"] | undefined,
	user?: GraphQLTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"] | undefined,
	update?: GraphQLTypes["UserUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PersonSeenInfoCarouselUpsertUserRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["PersonSeenInfoCarouselUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserUpdateInput"],
	create: GraphQLTypes["UserCreateInput"]
};
	["InfoCarouselUpsertSeenByRelationInput"]: {
		by: GraphQLTypes["PersonSeenInfoCarouselUniqueWhere"],
	update: GraphQLTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"],
	create: GraphQLTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"]
};
	["InfoCarouselItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	carousel?: GraphQLTypes["InfoCarouselItemCreateCarouselEntityRelationInput"] | undefined,
	image?: GraphQLTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	locales?: Array<GraphQLTypes["InfoCarouselItemCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemCreateCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoCarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"] | undefined
};
	["InfoCarouselWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: GraphQLTypes["DateTime"] | undefined,
	validTo?: GraphQLTypes["DateTime"] | undefined,
	seenBy?: Array<GraphQLTypes["InfoCarouselCreateSeenByEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemConnectOrCreateCarouselRelationInput"]: {
		connect: GraphQLTypes["InfoCarouselUniqueWhere"],
	create: GraphQLTypes["InfoCarouselWithoutItemsCreateInput"]
};
	["InfoCarouselItemUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	carousel?: GraphQLTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"] | undefined,
	image?: GraphQLTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	locales?: Array<GraphQLTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemUpdateCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoCarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"] | undefined,
	update?: GraphQLTypes["InfoCarouselWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoCarouselItemUpsertCarouselRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselWithoutItemsUpdateInput"]: {
		name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: GraphQLTypes["DateTime"] | undefined,
	validTo?: GraphQLTypes["DateTime"] | undefined,
	seenBy?: Array<GraphQLTypes["InfoCarouselUpdateSeenByEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemUpsertCarouselRelationInput"]: {
		update: GraphQLTypes["InfoCarouselWithoutItemsUpdateInput"],
	create: GraphQLTypes["InfoCarouselWithoutItemsCreateInput"]
};
	["PersonSeenInfoCarouselCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	seenAt?: GraphQLTypes["DateTime"] | undefined,
	user?: GraphQLTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"] | undefined,
	carousel?: GraphQLTypes["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoCarouselWithoutSeenByCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"] | undefined
};
	["InfoCarouselWithoutSeenByCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: GraphQLTypes["DateTime"] | undefined,
	validTo?: GraphQLTypes["DateTime"] | undefined,
	items?: Array<GraphQLTypes["InfoCarouselCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"]: {
		connect: GraphQLTypes["InfoCarouselUniqueWhere"],
	create: GraphQLTypes["InfoCarouselWithoutSeenByCreateInput"]
};
	["PersonSeenInfoCarouselUpdateInput"]: {
		seenAt?: GraphQLTypes["DateTime"] | undefined,
	user?: GraphQLTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"] | undefined,
	carousel?: GraphQLTypes["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoCarouselWithoutSeenByCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"] | undefined,
	update?: GraphQLTypes["InfoCarouselWithoutSeenByUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PersonSeenInfoCarouselUpsertCarouselRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselWithoutSeenByUpdateInput"]: {
		name?: string | undefined,
	isEnabled?: boolean | undefined,
	validFrom?: GraphQLTypes["DateTime"] | undefined,
	validTo?: GraphQLTypes["DateTime"] | undefined,
	items?: Array<GraphQLTypes["InfoCarouselUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PersonSeenInfoCarouselUpsertCarouselRelationInput"]: {
		update: GraphQLTypes["InfoCarouselWithoutSeenByUpdateInput"],
	create: GraphQLTypes["InfoCarouselWithoutSeenByCreateInput"]
};
	["GivenGiftsPageConnection"]: {
	__typename: "GivenGiftsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GivenGiftsPageEdge"]>
};
	["GivenGiftsPageEdge"]: {
	__typename: "GivenGiftsPageEdge",
	node: GraphQLTypes["GivenGiftsPage"]
};
	["GivenGiftsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["GivenGiftsPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GivenGiftsPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GivenGiftsPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	locale?: GraphQLTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"],
	create: GraphQLTypes["GivenGiftsPageLocaleWithoutRootCreateInput"]
};
	["GivenGiftsPageUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["GivenGiftsPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["GivenGiftsPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["GivenGiftsPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["GivenGiftsPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GivenGiftsPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"],
	data: GraphQLTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"]
};
	["GivenGiftsPageLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	locale?: GraphQLTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["GivenGiftsPageLocaleUniqueWhere"],
	update: GraphQLTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["GivenGiftsPageLocaleWithoutRootCreateInput"]
};
	["GivenGiftsPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GivenGiftsPageLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	root?: GraphQLTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageConnection"]: {
	__typename: "ReceivedGiftsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReceivedGiftsPageEdge"]>
};
	["ReceivedGiftsPageEdge"]: {
	__typename: "ReceivedGiftsPageEdge",
	node: GraphQLTypes["ReceivedGiftsPage"]
};
	["ReceivedGiftsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["ReceivedGiftsPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReceivedGiftsPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: GraphQLTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	create: GraphQLTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"]
};
	["ReceivedGiftsPageUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ReceivedGiftsPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ReceivedGiftsPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReceivedGiftsPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	data: GraphQLTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"]
};
	["ReceivedGiftsPageLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["ReceivedGiftsPageLocaleUniqueWhere"],
	update: GraphQLTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"]
};
	["ReceivedGiftsPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: GraphQLTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReceivedGiftsPageLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	giftTitle?: string | undefined,
	giftText?: string | undefined,
	note?: string | undefined,
	link?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationConnection"]: {
	__typename: "ReportNavigationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReportNavigationEdge"]>
};
	["ReportNavigationEdge"]: {
	__typename: "ReportNavigationEdge",
	node: GraphQLTypes["ReportNavigation"]
};
	["ReportNavigationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["ReportNavigationCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportNavigationLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportNavigationConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined,
	pages?: Array<GraphQLTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	create: GraphQLTypes["ReportNavigationLocaleWithoutRootCreateInput"]
};
	["ReportNavigationUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["ReportNavigationUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ReportNavigationLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ReportNavigationUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ReportNavigationUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ReportNavigationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReportNavigationUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	data: GraphQLTypes["ReportNavigationLocaleWithoutRootUpdateInput"]
};
	["ReportNavigationLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	pages?: Array<GraphQLTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["ReportNavigationLocaleUniqueWhere"],
	update: GraphQLTypes["ReportNavigationLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["ReportNavigationLocaleWithoutRootCreateInput"]
};
	["ReportPageConnection"]: {
	__typename: "ReportPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReportPageEdge"]>
};
	["ReportPageEdge"]: {
	__typename: "ReportPageEdge",
	node: GraphQLTypes["ReportPage"]
};
	["ReportPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["ReportPageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ReportPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ReportPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ReportPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	posts?: Array<GraphQLTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	create: GraphQLTypes["ReportPageLocaleWithoutRootCreateInput"]
};
	["ReportPageUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["ReportPageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ReportPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ReportPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ReportPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ReportPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ReportPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	data: GraphQLTypes["ReportPageLocaleWithoutRootUpdateInput"]
};
	["ReportPageLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	posts?: Array<GraphQLTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["ReportPageLocaleUniqueWhere"],
	update: GraphQLTypes["ReportPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["ReportPageLocaleWithoutRootCreateInput"]
};
	["ReportPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["ReportPageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReportPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleCreateSeoEntityRelationInput"] | undefined,
	posts?: Array<GraphQLTypes["ReportPageLocaleCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportPageLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	postTitle?: string | undefined,
	giftTitle?: string | undefined,
	link?: GraphQLTypes["ReportPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["ReportPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["ReportPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["ReportPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	posts?: Array<GraphQLTypes["ReportPageLocaleUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ReportNavigationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"] | undefined,
	pages?: Array<GraphQLTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ReportNavigationLocaleUpdateInput"]: {
		root?: GraphQLTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	pages?: Array<GraphQLTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: GraphQLTypes["DateTime"] | undefined,
	currency?: GraphQLTypes["SentPaymentCreateCurrencyEntityRelationInput"] | undefined,
	area?: GraphQLTypes["SentPaymentCreateAreaEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["SentPaymentCreateOrganizationEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["SentPaymentCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	cents?: number | undefined,
	sendAt?: GraphQLTypes["DateTime"] | undefined,
	currency?: GraphQLTypes["SentPaymentUpdateCurrencyEntityRelationInput"] | undefined,
	area?: GraphQLTypes["SentPaymentUpdateAreaEntityRelationInput"] | undefined,
	organization?: GraphQLTypes["SentPaymentUpdateOrganizationEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["SentPaymentUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PostAreaSentPaymentSumConnection"]: {
	__typename: "PostAreaSentPaymentSumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaSentPaymentSumEdge"]>
};
	["PostAreaSentPaymentSumEdge"]: {
	__typename: "PostAreaSentPaymentSumEdge",
	node: GraphQLTypes["PostAreaSentPaymentSum"]
};
	["NotificationTargetGroupConnection"]: {
	__typename: "NotificationTargetGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NotificationTargetGroupEdge"]>
};
	["NotificationTargetGroupEdge"]: {
	__typename: "NotificationTargetGroupEdge",
	node: GraphQLTypes["NotificationTargetGroup"]
};
	["ProcessedNotificationConnection"]: {
	__typename: "ProcessedNotificationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProcessedNotificationEdge"]>
};
	["ProcessedNotificationEdge"]: {
	__typename: "ProcessedNotificationEdge",
	node: GraphQLTypes["ProcessedNotification"]
};
	["ProcessedNotificationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	topic?: string | undefined,
	sentAt?: GraphQLTypes["DateTime"] | undefined,
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess?: boolean | undefined,
	source?: GraphQLTypes["ProcessedNotificationCreateSourceEntityRelationInput"] | undefined,
	title?: string | undefined,
	body?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationCreateSourceEntityRelationInput"]: {
		connect?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"] | undefined
};
	["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	donationReminderUser?: GraphQLTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined,
	scheduledNotification?: GraphQLTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationConnectOrCreateSourceRelationInput"]: {
		connect: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"],
	create: GraphQLTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]
};
	["ProcessedNotificationUpdateInput"]: {
		topic?: string | undefined,
	sentAt?: GraphQLTypes["DateTime"] | undefined,
	errorMessage?: string | undefined,
	errorCode?: string | undefined,
	isSuccess?: boolean | undefined,
	source?: GraphQLTypes["ProcessedNotificationUpdateSourceEntityRelationInput"] | undefined,
	title?: string | undefined,
	body?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationUpdateSourceEntityRelationInput"]: {
		connect?: GraphQLTypes["ProcessedNotificationSourceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"] | undefined,
	update?: GraphQLTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProcessedNotificationUpsertSourceRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"]: {
		type?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	donationReminderUser?: GraphQLTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined,
	scheduledNotification?: GraphQLTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationUpsertSourceRelationInput"]: {
		update: GraphQLTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"],
	create: GraphQLTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]
};
	["ScheduledNotificationConnection"]: {
	__typename: "ScheduledNotificationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ScheduledNotificationEdge"]>
};
	["ScheduledNotificationEdge"]: {
	__typename: "ScheduledNotificationEdge",
	node: GraphQLTypes["ScheduledNotification"]
};
	["ScheduledNotificationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	localMsFromMidnight?: number | undefined,
	scheduledDate?: GraphQLTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: GraphQLTypes["ScheduledNotificationCreateTargetEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["ScheduledNotificationCreateLocalesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ScheduledNotificationCreateImageEntityRelationInput"] | undefined,
	completedAt?: GraphQLTypes["DateTime"] | undefined,
	processedNotifications?: Array<GraphQLTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationUpdateInput"]: {
		localMsFromMidnight?: number | undefined,
	scheduledDate?: GraphQLTypes["Date"] | undefined,
	internalTitle?: string | undefined,
	target?: GraphQLTypes["ScheduledNotificationUpdateTargetEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ScheduledNotificationUpdateImageEntityRelationInput"] | undefined,
	completedAt?: GraphQLTypes["DateTime"] | undefined,
	processedNotifications?: Array<GraphQLTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"] | undefined,
	donationReminderUser?: GraphQLTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"] | undefined,
	scheduledNotification?: GraphQLTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProcessedNotificationSourceUpdateInput"]: {
		type?: GraphQLTypes["ProcessedNotificationSourceType"] | undefined,
	processedNotification?: GraphQLTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"] | undefined,
	donationReminderUser?: GraphQLTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"] | undefined,
	scheduledNotification?: GraphQLTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	user?: GraphQLTypes["DeviceCreateUserEntityRelationInput"] | undefined,
	fcmToken?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutDevicesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DeviceConnectOrCreateUserRelationInput"] | undefined
};
	["UserWithoutDevicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserCreatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserCreateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserCreateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserCreateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserCreateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserCreateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	processedNotifications?: Array<GraphQLTypes["UserCreateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserCreateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserCreateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserCreatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserCreateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutDevicesCreateInput"]
};
	["DeviceUpdateInput"]: {
		user?: GraphQLTypes["DeviceUpdateUserEntityRelationInput"] | undefined,
	fcmToken?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	ipAddress?: string | undefined,
	userAgent?: string | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutDevicesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["DeviceConnectOrCreateUserRelationInput"] | undefined,
	update?: GraphQLTypes["UserWithoutDevicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeviceUpsertUserRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["UserWithoutDevicesUpdateInput"]: {
		tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	name?: string | undefined,
	payments?: Array<GraphQLTypes["UserUpdatePaymentsEntityRelationInput"]> | undefined,
	variableSymbol?: number | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	region?: GraphQLTypes["UserUpdateRegionEntityRelationInput"] | undefined,
	currency?: GraphQLTypes["UserUpdateCurrencyEntityRelationInput"] | undefined,
	recurringPayments?: Array<GraphQLTypes["UserUpdateRecurringPaymentsEntityRelationInput"]> | undefined,
	stripeId?: string | undefined,
	isDeactivated?: boolean | undefined,
	onBehalfDonations?: Array<GraphQLTypes["UserUpdateOnBehalfDonationsEntityRelationInput"]> | undefined,
	publicProfileSecret?: string | undefined,
	publicProfileCustomNote?: string | undefined,
	publicProfileCustomNoteEnabled?: boolean | undefined,
	donationConfirmationEmailEnabled?: boolean | undefined,
	locale?: GraphQLTypes["UserUpdateLocaleEntityRelationInput"] | undefined,
	signedUp?: boolean | undefined,
	processedNotifications?: Array<GraphQLTypes["UserUpdateProcessedNotificationsEntityRelationInput"]> | undefined,
	areaStats?: Array<GraphQLTypes["UserUpdateAreaStatsEntityRelationInput"]> | undefined,
	organizationStats?: Array<GraphQLTypes["UserUpdateOrganizationStatsEntityRelationInput"]> | undefined,
	postStats?: Array<GraphQLTypes["UserUpdatePostStatsEntityRelationInput"]> | undefined,
	currencyStats?: Array<GraphQLTypes["UserUpdateCurrencyStatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutDevicesUpdateInput"],
	create: GraphQLTypes["UserWithoutDevicesCreateInput"]
};
	["ScheduledNotificationLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ScheduledNotificationLocaleUpdateInput"]: {
		title?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	root?: GraphQLTypes["InfoCarouselItemLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoCarouselItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoCarouselItemWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["InfoCarouselItemWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	carousel?: GraphQLTypes["InfoCarouselItemCreateCarouselEntityRelationInput"] | undefined,
	image?: GraphQLTypes["InfoCarouselItemCreateImageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["InfoCarouselItemCreatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["InfoCarouselItemUniqueWhere"],
	create: GraphQLTypes["InfoCarouselItemWithoutLocalesCreateInput"]
};
	["InfoCarouselItemLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	root?: GraphQLTypes["InfoCarouselItemLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoCarouselItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoCarouselItemWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["InfoCarouselItemWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoCarouselItemLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoCarouselItemWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	carousel?: GraphQLTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"] | undefined,
	image?: GraphQLTypes["InfoCarouselItemUpdateImageEntityRelationInput"] | undefined,
	post?: GraphQLTypes["InfoCarouselItemUpdatePostEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	type?: GraphQLTypes["InfoCarouselItemType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoCarouselItemLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["InfoCarouselItemWithoutLocalesUpdateInput"],
	create: GraphQLTypes["InfoCarouselItemWithoutLocalesCreateInput"]
};
	["SentPaymentLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	organizationText?: string | undefined,
	root?: GraphQLTypes["SentPaymentLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SentPaymentLocaleUpdateInput"]: {
		organizationText?: string | undefined,
	root?: GraphQLTypes["SentPaymentLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserPaymentMetadataConnection"]: {
	__typename: "UserPaymentMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserPaymentMetadataEdge"]>
};
	["UserPaymentMetadataEdge"]: {
	__typename: "UserPaymentMetadataEdge",
	node: GraphQLTypes["UserPaymentMetadata"]
};
	["PostAreaSumConnection"]: {
	__typename: "PostAreaSumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostAreaSumEdge"]>
};
	["PostAreaSumEdge"]: {
	__typename: "PostAreaSumEdge",
	node: GraphQLTypes["PostAreaSum"]
};
	["PostOrganizationSumConnection"]: {
	__typename: "PostOrganizationSumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostOrganizationSumEdge"]>
};
	["PostOrganizationSumEdge"]: {
	__typename: "PostOrganizationSumEdge",
	node: GraphQLTypes["PostOrganizationSum"]
};
	["Stats"]: {
	__typename: "Stats",
	_meta?: GraphQLTypes["StatsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	totalUserCount: number,
	successfulPaymentCount: number,
	sentPaymentCount: number,
	totalAreaCents: number,
	totalAreaSentPaymentCents: number,
	totalAreaCzkPercentage: number,
	totalAreaSentPaymentCzkPercentage: number
};
	["StatsMeta"]: {
	__typename: "StatsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	totalUserCount?: GraphQLTypes["FieldMeta"] | undefined,
	successfulPaymentCount?: GraphQLTypes["FieldMeta"] | undefined,
	sentPaymentCount?: GraphQLTypes["FieldMeta"] | undefined,
	totalAreaCents?: GraphQLTypes["FieldMeta"] | undefined,
	totalAreaSentPaymentCents?: GraphQLTypes["FieldMeta"] | undefined,
	totalAreaCzkPercentage?: GraphQLTypes["FieldMeta"] | undefined,
	totalAreaSentPaymentCzkPercentage?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined
};
	["StatsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	totalUserCount?: GraphQLTypes["IntCondition"] | undefined,
	successfulPaymentCount?: GraphQLTypes["IntCondition"] | undefined,
	sentPaymentCount?: GraphQLTypes["IntCondition"] | undefined,
	totalAreaCents?: GraphQLTypes["IntCondition"] | undefined,
	totalAreaSentPaymentCents?: GraphQLTypes["IntCondition"] | undefined,
	totalAreaCzkPercentage?: GraphQLTypes["FloatCondition"] | undefined,
	totalAreaSentPaymentCzkPercentage?: GraphQLTypes["FloatCondition"] | undefined,
	and?: Array<GraphQLTypes["StatsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StatsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StatsWhere"] | undefined
};
	["StatsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	totalUserCount?: GraphQLTypes["OrderDirection"] | undefined,
	successfulPaymentCount?: GraphQLTypes["OrderDirection"] | undefined,
	sentPaymentCount?: GraphQLTypes["OrderDirection"] | undefined,
	totalAreaCents?: GraphQLTypes["OrderDirection"] | undefined,
	totalAreaSentPaymentCents?: GraphQLTypes["OrderDirection"] | undefined,
	totalAreaCzkPercentage?: GraphQLTypes["OrderDirection"] | undefined,
	totalAreaSentPaymentCzkPercentage?: GraphQLTypes["OrderDirection"] | undefined
};
	["StatsConnection"]: {
	__typename: "StatsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsEdge"]>
};
	["StatsEdge"]: {
	__typename: "StatsEdge",
	node: GraphQLTypes["Stats"]
};
	["UserRecurringPaymentItemMetadataConnection"]: {
	__typename: "UserRecurringPaymentItemMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserRecurringPaymentItemMetadataEdge"]>
};
	["UserRecurringPaymentItemMetadataEdge"]: {
	__typename: "UserRecurringPaymentItemMetadataEdge",
	node: GraphQLTypes["UserRecurringPaymentItemMetadata"]
};
	["UpcomingUserRecurringPaymentMetadataConnection"]: {
	__typename: "UpcomingUserRecurringPaymentMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UpcomingUserRecurringPaymentMetadataEdge"]>
};
	["UpcomingUserRecurringPaymentMetadataEdge"]: {
	__typename: "UpcomingUserRecurringPaymentMetadataEdge",
	node: GraphQLTypes["UpcomingUserRecurringPaymentMetadata"]
};
	["UserStatsConnection"]: {
	__typename: "UserStatsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserStatsEdge"]>
};
	["UserStatsEdge"]: {
	__typename: "UserStatsEdge",
	node: GraphQLTypes["UserStats"]
};
	["TextImageListConnection"]: {
	__typename: "TextImageListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextImageListEdge"]>
};
	["TextImageListEdge"]: {
	__typename: "TextImageListEdge",
	node: GraphQLTypes["TextImageList"]
};
	["TextImageListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["TextImageListItemCreateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["TextImageListItemCreateImageEntityRelationInput"] | undefined,
	text?: string | undefined,
	link?: GraphQLTypes["TextImageListItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextImageListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextImageListItemConnectOrCreateListRelationInput"] | undefined
};
	["TextImageListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["TextImageListUniqueWhere"],
	create: GraphQLTypes["TextImageListWithoutItemsCreateInput"]
};
	["TextImageListItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["TextImageListItemUpdateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["TextImageListItemUpdateImageEntityRelationInput"] | undefined,
	text?: string | undefined,
	link?: GraphQLTypes["TextImageListItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextImageListItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextImageListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextImageListItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["TextImageListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TextImageListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TextImageListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["TextImageListItemUpsertListRelationInput"]: {
		update: GraphQLTypes["TextImageListWithoutItemsUpdateInput"],
	create: GraphQLTypes["TextImageListWithoutItemsCreateInput"]
};
	["PostSumConnection"]: {
	__typename: "PostSumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostSumEdge"]>
};
	["PostSumEdge"]: {
	__typename: "PostSumEdge",
	node: GraphQLTypes["PostSum"]
};
	["PostFundraisingProgressConnection"]: {
	__typename: "PostFundraisingProgressConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PostFundraisingProgressEdge"]>
};
	["PostFundraisingProgressEdge"]: {
	__typename: "PostFundraisingProgressEdge",
	node: GraphQLTypes["PostFundraisingProgress"]
};
	["HeroCarouselItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["Date"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["HeroCarouselItemCreateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["HeroCarouselItemCreateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeroCarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeroCarouselItemConnectOrCreateListRelationInput"] | undefined
};
	["HeroCarouselWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["Date"] | undefined,
	posts?: Array<GraphQLTypes["HeroCarouselCreatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["HeroCarouselUniqueWhere"],
	create: GraphQLTypes["HeroCarouselWithoutItemsCreateInput"]
};
	["HeroCarouselItemUpdateInput"]: {
		createdAt?: GraphQLTypes["Date"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["HeroCarouselItemUpdateListEntityRelationInput"] | undefined,
	item?: GraphQLTypes["HeroCarouselItemUpdateItemEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["HeroCarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeroCarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeroCarouselItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["HeroCarouselWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeroCarouselItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HeroCarouselWithoutItemsUpdateInput"]: {
		createdAt?: GraphQLTypes["Date"] | undefined,
	posts?: Array<GraphQLTypes["HeroCarouselUpdatePostsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCarouselItemUpsertListRelationInput"]: {
		update: GraphQLTypes["HeroCarouselWithoutItemsUpdateInput"],
	create: GraphQLTypes["HeroCarouselWithoutItemsCreateInput"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	schema?: GraphQLTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined,
	getGeneral?: GraphQLTypes["General"] | undefined,
	listGeneral: Array<GraphQLTypes["General"]>,
	paginateGeneral: GraphQLTypes["GeneralConnection"],
	validateCreateGeneral: GraphQLTypes["_ValidationResult"],
	validateUpdateGeneral: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"] | undefined,
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getGenericPage?: GraphQLTypes["GenericPage"] | undefined,
	listGenericPage: Array<GraphQLTypes["GenericPage"]>,
	paginateGenericPage: GraphQLTypes["GenericPageConnection"],
	validateCreateGenericPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPage: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"] | undefined,
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"] | undefined,
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"] | undefined,
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"] | undefined,
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"] | undefined,
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getContentReferenceLinkableItem?: GraphQLTypes["ContentReferenceLinkableItem"] | undefined,
	listContentReferenceLinkableItem: Array<GraphQLTypes["ContentReferenceLinkableItem"]>,
	paginateContentReferenceLinkableItem: GraphQLTypes["ContentReferenceLinkableItemConnection"],
	getGeneralLocale?: GraphQLTypes["GeneralLocale"] | undefined,
	listGeneralLocale: Array<GraphQLTypes["GeneralLocale"]>,
	paginateGeneralLocale: GraphQLTypes["GeneralLocaleConnection"],
	validateCreateGeneralLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGeneralLocale: GraphQLTypes["_ValidationResult"],
	getGenericPageLocale?: GraphQLTypes["GenericPageLocale"] | undefined,
	listGenericPageLocale: Array<GraphQLTypes["GenericPageLocale"]>,
	paginateGenericPageLocale: GraphQLTypes["GenericPageLocaleConnection"],
	validateCreateGenericPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageLocale: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"] | undefined,
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"] | undefined,
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"] | undefined,
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getPost?: GraphQLTypes["Post"] | undefined,
	listPost: Array<GraphQLTypes["Post"]>,
	paginatePost: GraphQLTypes["PostConnection"],
	validateCreatePost: GraphQLTypes["_ValidationResult"],
	validateUpdatePost: GraphQLTypes["_ValidationResult"],
	getPostLocale?: GraphQLTypes["PostLocale"] | undefined,
	listPostLocale: Array<GraphQLTypes["PostLocale"]>,
	paginatePostLocale: GraphQLTypes["PostLocaleConnection"],
	validateCreatePostLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePostLocale: GraphQLTypes["_ValidationResult"],
	getPostArea?: GraphQLTypes["PostArea"] | undefined,
	listPostArea: Array<GraphQLTypes["PostArea"]>,
	paginatePostArea: GraphQLTypes["PostAreaConnection"],
	validateCreatePostArea: GraphQLTypes["_ValidationResult"],
	validateUpdatePostArea: GraphQLTypes["_ValidationResult"],
	getPostAreaLocale?: GraphQLTypes["PostAreaLocale"] | undefined,
	listPostAreaLocale: Array<GraphQLTypes["PostAreaLocale"]>,
	paginatePostAreaLocale: GraphQLTypes["PostAreaLocaleConnection"],
	validateCreatePostAreaLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePostAreaLocale: GraphQLTypes["_ValidationResult"],
	getPostOrganization?: GraphQLTypes["PostOrganization"] | undefined,
	listPostOrganization: Array<GraphQLTypes["PostOrganization"]>,
	paginatePostOrganization: GraphQLTypes["PostOrganizationConnection"],
	validateCreatePostOrganization: GraphQLTypes["_ValidationResult"],
	validateUpdatePostOrganization: GraphQLTypes["_ValidationResult"],
	getPostOrganizationLocale?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	listPostOrganizationLocale: Array<GraphQLTypes["PostOrganizationLocale"]>,
	paginatePostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleConnection"],
	validateCreatePostOrganizationLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePostOrganizationLocale: GraphQLTypes["_ValidationResult"],
	getDonation?: GraphQLTypes["Donation"] | undefined,
	listDonation: Array<GraphQLTypes["Donation"]>,
	paginateDonation: GraphQLTypes["DonationConnection"],
	validateCreateDonation: GraphQLTypes["_ValidationResult"],
	validateUpdateDonation: GraphQLTypes["_ValidationResult"],
	getDonationAmountItem?: GraphQLTypes["DonationAmountItem"] | undefined,
	listDonationAmountItem: Array<GraphQLTypes["DonationAmountItem"]>,
	paginateDonationAmountItem: GraphQLTypes["DonationAmountItemConnection"],
	validateCreateDonationAmountItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDonationAmountItem: GraphQLTypes["_ValidationResult"],
	getDonationAmountsRegionItem?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	listDonationAmountsRegionItem: Array<GraphQLTypes["DonationAmountsRegionItem"]>,
	paginateDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemConnection"],
	validateCreateDonationAmountsRegionItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDonationAmountsRegionItem: GraphQLTypes["_ValidationResult"],
	getDonationAmountsRegionList?: GraphQLTypes["DonationAmountsRegionList"] | undefined,
	listDonationAmountsRegionList: Array<GraphQLTypes["DonationAmountsRegionList"]>,
	paginateDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListConnection"],
	validateCreateDonationAmountsRegionList: GraphQLTypes["_ValidationResult"],
	validateUpdateDonationAmountsRegionList: GraphQLTypes["_ValidationResult"],
	getRegion?: GraphQLTypes["Region"] | undefined,
	listRegion: Array<GraphQLTypes["Region"]>,
	paginateRegion: GraphQLTypes["RegionConnection"],
	validateCreateRegion: GraphQLTypes["_ValidationResult"],
	validateUpdateRegion: GraphQLTypes["_ValidationResult"],
	getLinkItem?: GraphQLTypes["LinkItem"] | undefined,
	listLinkItem: Array<GraphQLTypes["LinkItem"]>,
	paginateLinkItem: GraphQLTypes["LinkItemConnection"],
	validateCreateLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkItem: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"] | undefined,
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"] | undefined,
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLocale?: GraphQLTypes["HeaderLocale"] | undefined,
	listHeaderLocale: Array<GraphQLTypes["HeaderLocale"]>,
	paginateHeaderLocale: GraphQLTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLocale: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"] | undefined,
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLocale?: GraphQLTypes["FooterLocale"] | undefined,
	listFooterLocale: Array<GraphQLTypes["FooterLocale"]>,
	paginateFooterLocale: GraphQLTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLocale: GraphQLTypes["_ValidationResult"],
	getPostList?: GraphQLTypes["PostList"] | undefined,
	listPostList: Array<GraphQLTypes["PostList"]>,
	paginatePostList: GraphQLTypes["PostListConnection"],
	validateCreatePostList: GraphQLTypes["_ValidationResult"],
	validateUpdatePostList: GraphQLTypes["_ValidationResult"],
	getPostListItem?: GraphQLTypes["PostListItem"] | undefined,
	listPostListItem: Array<GraphQLTypes["PostListItem"]>,
	paginatePostListItem: GraphQLTypes["PostListItemConnection"],
	validateCreatePostListItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePostListItem: GraphQLTypes["_ValidationResult"],
	getAppBanner?: GraphQLTypes["AppBanner"] | undefined,
	listAppBanner: Array<GraphQLTypes["AppBanner"]>,
	paginateAppBanner: GraphQLTypes["AppBannerConnection"],
	validateCreateAppBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateAppBanner: GraphQLTypes["_ValidationResult"],
	getGenericPageAboutSettings?: GraphQLTypes["GenericPageAboutSettings"] | undefined,
	listGenericPageAboutSettings: Array<GraphQLTypes["GenericPageAboutSettings"]>,
	paginateGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsConnection"],
	validateCreateGenericPageAboutSettings: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageAboutSettings: GraphQLTypes["_ValidationResult"],
	getGenericPageAboutSettingsLocale?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	listGenericPageAboutSettingsLocale: Array<GraphQLTypes["GenericPageAboutSettingsLocale"]>,
	paginateGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleConnection"],
	validateCreateGenericPageAboutSettingsLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageAboutSettingsLocale: GraphQLTypes["_ValidationResult"],
	getValue?: GraphQLTypes["Value"] | undefined,
	listValue: Array<GraphQLTypes["Value"]>,
	paginateValue: GraphQLTypes["ValueConnection"],
	validateCreateValue: GraphQLTypes["_ValidationResult"],
	validateUpdateValue: GraphQLTypes["_ValidationResult"],
	getValueItem?: GraphQLTypes["ValueItem"] | undefined,
	listValueItem: Array<GraphQLTypes["ValueItem"]>,
	paginateValueItem: GraphQLTypes["ValueItemConnection"],
	validateCreateValueItem: GraphQLTypes["_ValidationResult"],
	validateUpdateValueItem: GraphQLTypes["_ValidationResult"],
	getValueList?: GraphQLTypes["ValueList"] | undefined,
	listValueList: Array<GraphQLTypes["ValueList"]>,
	paginateValueList: GraphQLTypes["ValueListConnection"],
	validateCreateValueList: GraphQLTypes["_ValidationResult"],
	validateUpdateValueList: GraphQLTypes["_ValidationResult"],
	getImageLink?: GraphQLTypes["ImageLink"] | undefined,
	listImageLink: Array<GraphQLTypes["ImageLink"]>,
	paginateImageLink: GraphQLTypes["ImageLinkConnection"],
	validateCreateImageLink: GraphQLTypes["_ValidationResult"],
	validateUpdateImageLink: GraphQLTypes["_ValidationResult"],
	getImageLinkItem?: GraphQLTypes["ImageLinkItem"] | undefined,
	listImageLinkItem: Array<GraphQLTypes["ImageLinkItem"]>,
	paginateImageLinkItem: GraphQLTypes["ImageLinkItemConnection"],
	validateCreateImageLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageLinkItem: GraphQLTypes["_ValidationResult"],
	getImageLinkList?: GraphQLTypes["ImageLinkList"] | undefined,
	listImageLinkList: Array<GraphQLTypes["ImageLinkList"]>,
	paginateImageLinkList: GraphQLTypes["ImageLinkListConnection"],
	validateCreateImageLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageLinkList: GraphQLTypes["_ValidationResult"],
	getPostAreaList?: GraphQLTypes["PostAreaList"] | undefined,
	listPostAreaList: Array<GraphQLTypes["PostAreaList"]>,
	paginatePostAreaList: GraphQLTypes["PostAreaListConnection"],
	validateCreatePostAreaList: GraphQLTypes["_ValidationResult"],
	validateUpdatePostAreaList: GraphQLTypes["_ValidationResult"],
	getPostAreaListItem?: GraphQLTypes["PostAreaListItem"] | undefined,
	listPostAreaListItem: Array<GraphQLTypes["PostAreaListItem"]>,
	paginatePostAreaListItem: GraphQLTypes["PostAreaListItemConnection"],
	validateCreatePostAreaListItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePostAreaListItem: GraphQLTypes["_ValidationResult"],
	getAccordion?: GraphQLTypes["Accordion"] | undefined,
	listAccordion: Array<GraphQLTypes["Accordion"]>,
	paginateAccordion: GraphQLTypes["AccordionConnection"],
	validateCreateAccordion: GraphQLTypes["_ValidationResult"],
	validateUpdateAccordion: GraphQLTypes["_ValidationResult"],
	getAccordionItem?: GraphQLTypes["AccordionItem"] | undefined,
	listAccordionItem: Array<GraphQLTypes["AccordionItem"]>,
	paginateAccordionItem: GraphQLTypes["AccordionItemConnection"],
	validateCreateAccordionItem: GraphQLTypes["_ValidationResult"],
	validateUpdateAccordionItem: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"] | undefined,
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getUserPayment?: GraphQLTypes["UserPayment"] | undefined,
	listUserPayment: Array<GraphQLTypes["UserPayment"]>,
	paginateUserPayment: GraphQLTypes["UserPaymentConnection"],
	validateCreateUserPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateUserPayment: GraphQLTypes["_ValidationResult"],
	getCurrency?: GraphQLTypes["Currency"] | undefined,
	listCurrency: Array<GraphQLTypes["Currency"]>,
	paginateCurrency: GraphQLTypes["CurrencyConnection"],
	validateCreateCurrency: GraphQLTypes["_ValidationResult"],
	validateUpdateCurrency: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"] | undefined,
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getMediumItem?: GraphQLTypes["MediumItem"] | undefined,
	listMediumItem: Array<GraphQLTypes["MediumItem"]>,
	paginateMediumItem: GraphQLTypes["MediumItemConnection"],
	validateCreateMediumItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumItem: GraphQLTypes["_ValidationResult"],
	getMediumList?: GraphQLTypes["MediumList"] | undefined,
	listMediumList: Array<GraphQLTypes["MediumList"]>,
	paginateMediumList: GraphQLTypes["MediumListConnection"],
	validateCreateMediumList: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumList: GraphQLTypes["_ValidationResult"],
	getUserPaymentOrderId?: GraphQLTypes["UserPaymentOrderId"] | undefined,
	listUserPaymentOrderId: Array<GraphQLTypes["UserPaymentOrderId"]>,
	paginateUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdConnection"],
	validateCreateUserPaymentOrderId: GraphQLTypes["_ValidationResult"],
	validateUpdateUserPaymentOrderId: GraphQLTypes["_ValidationResult"],
	getPostRevision?: GraphQLTypes["PostRevision"] | undefined,
	listPostRevision: Array<GraphQLTypes["PostRevision"]>,
	paginatePostRevision: GraphQLTypes["PostRevisionConnection"],
	validateCreatePostRevision: GraphQLTypes["_ValidationResult"],
	validateUpdatePostRevision: GraphQLTypes["_ValidationResult"],
	getUserRecurringPayment?: GraphQLTypes["UserRecurringPayment"] | undefined,
	listUserRecurringPayment: Array<GraphQLTypes["UserRecurringPayment"]>,
	paginateUserRecurringPayment: GraphQLTypes["UserRecurringPaymentConnection"],
	validateCreateUserRecurringPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateUserRecurringPayment: GraphQLTypes["_ValidationResult"],
	getUserRecurringPaymentItem?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	listUserRecurringPaymentItem: Array<GraphQLTypes["UserRecurringPaymentItem"]>,
	paginateUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemConnection"],
	validateCreateUserRecurringPaymentItem: GraphQLTypes["_ValidationResult"],
	validateUpdateUserRecurringPaymentItem: GraphQLTypes["_ValidationResult"],
	getPostRevisionLocale?: GraphQLTypes["PostRevisionLocale"] | undefined,
	listPostRevisionLocale: Array<GraphQLTypes["PostRevisionLocale"]>,
	paginatePostRevisionLocale: GraphQLTypes["PostRevisionLocaleConnection"],
	validateCreatePostRevisionLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePostRevisionLocale: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"] | undefined,
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"] | undefined,
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"] | undefined,
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getGenericPageAboutGroupLinksLocale?: GraphQLTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	listGenericPageAboutGroupLinksLocale: Array<GraphQLTypes["GenericPageAboutGroupLinksLocale"]>,
	paginateGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleConnection"],
	validateCreateGenericPageAboutGroupLinksLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageAboutGroupLinksLocale: GraphQLTypes["_ValidationResult"],
	getMemberList?: GraphQLTypes["MemberList"] | undefined,
	listMemberList: Array<GraphQLTypes["MemberList"]>,
	paginateMemberList: GraphQLTypes["MemberListConnection"],
	validateCreateMemberList: GraphQLTypes["_ValidationResult"],
	validateUpdateMemberList: GraphQLTypes["_ValidationResult"],
	getMemberListItem?: GraphQLTypes["MemberListItem"] | undefined,
	listMemberListItem: Array<GraphQLTypes["MemberListItem"]>,
	paginateMemberListItem: GraphQLTypes["MemberListItemConnection"],
	validateCreateMemberListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMemberListItem: GraphQLTypes["_ValidationResult"],
	getFilledTaxForm?: GraphQLTypes["FilledTaxForm"] | undefined,
	listFilledTaxForm: Array<GraphQLTypes["FilledTaxForm"]>,
	paginateFilledTaxForm: GraphQLTypes["FilledTaxFormConnection"],
	validateCreateFilledTaxForm: GraphQLTypes["_ValidationResult"],
	validateUpdateFilledTaxForm: GraphQLTypes["_ValidationResult"],
	getFilledTaxFormEmailAddress?: GraphQLTypes["FilledTaxFormEmailAddress"] | undefined,
	listFilledTaxFormEmailAddress: Array<GraphQLTypes["FilledTaxFormEmailAddress"]>,
	paginateFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressConnection"],
	validateCreateFilledTaxFormEmailAddress: GraphQLTypes["_ValidationResult"],
	validateUpdateFilledTaxFormEmailAddress: GraphQLTypes["_ValidationResult"],
	getForm?: GraphQLTypes["Form"] | undefined,
	listForm: Array<GraphQLTypes["Form"]>,
	paginateForm: GraphQLTypes["FormConnection"],
	validateCreateForm: GraphQLTypes["_ValidationResult"],
	validateUpdateForm: GraphQLTypes["_ValidationResult"],
	getCsobPayment?: GraphQLTypes["CsobPayment"] | undefined,
	listCsobPayment: Array<GraphQLTypes["CsobPayment"]>,
	paginateCsobPayment: GraphQLTypes["CsobPaymentConnection"],
	validateCreateCsobPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateCsobPayment: GraphQLTypes["_ValidationResult"],
	getCsobPaymentStatusChange?: GraphQLTypes["CsobPaymentStatusChange"] | undefined,
	listCsobPaymentStatusChange: Array<GraphQLTypes["CsobPaymentStatusChange"]>,
	paginateCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeConnection"],
	validateCreateCsobPaymentStatusChange: GraphQLTypes["_ValidationResult"],
	validateUpdateCsobPaymentStatusChange: GraphQLTypes["_ValidationResult"],
	getStripePayment?: GraphQLTypes["StripePayment"] | undefined,
	listStripePayment: Array<GraphQLTypes["StripePayment"]>,
	paginateStripePayment: GraphQLTypes["StripePaymentConnection"],
	validateCreateStripePayment: GraphQLTypes["_ValidationResult"],
	validateUpdateStripePayment: GraphQLTypes["_ValidationResult"],
	getStripePaymentStatusChange?: GraphQLTypes["StripePaymentStatusChange"] | undefined,
	listStripePaymentStatusChange: Array<GraphQLTypes["StripePaymentStatusChange"]>,
	paginateStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeConnection"],
	validateCreateStripePaymentStatusChange: GraphQLTypes["_ValidationResult"],
	validateUpdateStripePaymentStatusChange: GraphQLTypes["_ValidationResult"],
	getRegionPaymentMethod?: GraphQLTypes["RegionPaymentMethod"] | undefined,
	listRegionPaymentMethod: Array<GraphQLTypes["RegionPaymentMethod"]>,
	paginateRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodConnection"],
	validateCreateRegionPaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateRegionPaymentMethod: GraphQLTypes["_ValidationResult"],
	getPostAreaMetaData?: GraphQLTypes["PostAreaMetaData"] | undefined,
	listPostAreaMetaData: Array<GraphQLTypes["PostAreaMetaData"]>,
	paginatePostAreaMetaData: GraphQLTypes["PostAreaMetaDataConnection"],
	getPostMetaData?: GraphQLTypes["PostMetaData"] | undefined,
	listPostMetaData: Array<GraphQLTypes["PostMetaData"]>,
	paginatePostMetaData: GraphQLTypes["PostMetaDataConnection"],
	getPostOrganizationMetaData?: GraphQLTypes["PostOrganizationMetaData"] | undefined,
	listPostOrganizationMetaData: Array<GraphQLTypes["PostOrganizationMetaData"]>,
	paginatePostOrganizationMetaData: GraphQLTypes["PostOrganizationMetaDataConnection"],
	getTileItem?: GraphQLTypes["TileItem"] | undefined,
	listTileItem: Array<GraphQLTypes["TileItem"]>,
	paginateTileItem: GraphQLTypes["TileItemConnection"],
	validateCreateTileItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTileItem: GraphQLTypes["_ValidationResult"],
	getTileList?: GraphQLTypes["TileList"] | undefined,
	listTileList: Array<GraphQLTypes["TileList"]>,
	paginateTileList: GraphQLTypes["TileListConnection"],
	validateCreateTileList: GraphQLTypes["_ValidationResult"],
	validateUpdateTileList: GraphQLTypes["_ValidationResult"],
	getFeedPage?: GraphQLTypes["FeedPage"] | undefined,
	listFeedPage: Array<GraphQLTypes["FeedPage"]>,
	paginateFeedPage: GraphQLTypes["FeedPageConnection"],
	validateCreateFeedPage: GraphQLTypes["_ValidationResult"],
	validateUpdateFeedPage: GraphQLTypes["_ValidationResult"],
	getFeedPageLocale?: GraphQLTypes["FeedPageLocale"] | undefined,
	listFeedPageLocale: Array<GraphQLTypes["FeedPageLocale"]>,
	paginateFeedPageLocale: GraphQLTypes["FeedPageLocaleConnection"],
	validateCreateFeedPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFeedPageLocale: GraphQLTypes["_ValidationResult"],
	getFeedPageSection?: GraphQLTypes["FeedPageSection"] | undefined,
	listFeedPageSection: Array<GraphQLTypes["FeedPageSection"]>,
	paginateFeedPageSection: GraphQLTypes["FeedPageSectionConnection"],
	validateCreateFeedPageSection: GraphQLTypes["_ValidationResult"],
	validateUpdateFeedPageSection: GraphQLTypes["_ValidationResult"],
	getFeedPageTileStripe?: GraphQLTypes["FeedPageTileStripe"] | undefined,
	listFeedPageTileStripe: Array<GraphQLTypes["FeedPageTileStripe"]>,
	paginateFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeConnection"],
	validateCreateFeedPageTileStripe: GraphQLTypes["_ValidationResult"],
	validateUpdateFeedPageTileStripe: GraphQLTypes["_ValidationResult"],
	getCardItem?: GraphQLTypes["CardItem"] | undefined,
	listCardItem: Array<GraphQLTypes["CardItem"]>,
	paginateCardItem: GraphQLTypes["CardItemConnection"],
	validateCreateCardItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCardItem: GraphQLTypes["_ValidationResult"],
	getCardList?: GraphQLTypes["CardList"] | undefined,
	listCardList: Array<GraphQLTypes["CardList"]>,
	paginateCardList: GraphQLTypes["CardListConnection"],
	validateCreateCardList: GraphQLTypes["_ValidationResult"],
	validateUpdateCardList: GraphQLTypes["_ValidationResult"],
	getOnBehalfDonation?: GraphQLTypes["OnBehalfDonation"] | undefined,
	listOnBehalfDonation: Array<GraphQLTypes["OnBehalfDonation"]>,
	paginateOnBehalfDonation: GraphQLTypes["OnBehalfDonationConnection"],
	validateCreateOnBehalfDonation: GraphQLTypes["_ValidationResult"],
	validateUpdateOnBehalfDonation: GraphQLTypes["_ValidationResult"],
	getUserPaymentTriesCollection?: GraphQLTypes["UserPaymentTriesCollection"] | undefined,
	listUserPaymentTriesCollection: Array<GraphQLTypes["UserPaymentTriesCollection"]>,
	paginateUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionConnection"],
	validateCreateUserPaymentTriesCollection: GraphQLTypes["_ValidationResult"],
	validateUpdateUserPaymentTriesCollection: GraphQLTypes["_ValidationResult"],
	getRecurringPaymentPage?: GraphQLTypes["RecurringPaymentPage"] | undefined,
	listRecurringPaymentPage: Array<GraphQLTypes["RecurringPaymentPage"]>,
	paginateRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageConnection"],
	validateCreateRecurringPaymentPage: GraphQLTypes["_ValidationResult"],
	validateUpdateRecurringPaymentPage: GraphQLTypes["_ValidationResult"],
	getRecurringPaymentPageLocale?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	listRecurringPaymentPageLocale: Array<GraphQLTypes["RecurringPaymentPageLocale"]>,
	paginateRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleConnection"],
	validateCreateRecurringPaymentPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateRecurringPaymentPageLocale: GraphQLTypes["_ValidationResult"],
	getStoryGuide?: GraphQLTypes["StoryGuide"] | undefined,
	listStoryGuide: Array<GraphQLTypes["StoryGuide"]>,
	paginateStoryGuide: GraphQLTypes["StoryGuideConnection"],
	validateCreateStoryGuide: GraphQLTypes["_ValidationResult"],
	validateUpdateStoryGuide: GraphQLTypes["_ValidationResult"],
	getStoryGuideItem?: GraphQLTypes["StoryGuideItem"] | undefined,
	listStoryGuideItem: Array<GraphQLTypes["StoryGuideItem"]>,
	paginateStoryGuideItem: GraphQLTypes["StoryGuideItemConnection"],
	validateCreateStoryGuideItem: GraphQLTypes["_ValidationResult"],
	validateUpdateStoryGuideItem: GraphQLTypes["_ValidationResult"],
	getStoryGuideList?: GraphQLTypes["StoryGuideList"] | undefined,
	listStoryGuideList: Array<GraphQLTypes["StoryGuideList"]>,
	paginateStoryGuideList: GraphQLTypes["StoryGuideListConnection"],
	validateCreateStoryGuideList: GraphQLTypes["_ValidationResult"],
	validateUpdateStoryGuideList: GraphQLTypes["_ValidationResult"],
	getStripePaymentMetadata?: GraphQLTypes["StripePaymentMetadata"] | undefined,
	listStripePaymentMetadata: Array<GraphQLTypes["StripePaymentMetadata"]>,
	paginateStripePaymentMetadata: GraphQLTypes["StripePaymentMetadataConnection"],
	getOnBehalfDonationMetadata?: GraphQLTypes["OnBehalfDonationMetadata"] | undefined,
	listOnBehalfDonationMetadata: Array<GraphQLTypes["OnBehalfDonationMetadata"]>,
	paginateOnBehalfDonationMetadata: GraphQLTypes["OnBehalfDonationMetadataConnection"],
	getUserPaymentTriesCollectionMetadata?: GraphQLTypes["UserPaymentTriesCollectionMetadata"] | undefined,
	listUserPaymentTriesCollectionMetadata: Array<GraphQLTypes["UserPaymentTriesCollectionMetadata"]>,
	paginateUserPaymentTriesCollectionMetadata: GraphQLTypes["UserPaymentTriesCollectionMetadataConnection"],
	getUserPaymentTriesCollectionMetadataLocale?: GraphQLTypes["UserPaymentTriesCollectionMetadataLocale"] | undefined,
	listUserPaymentTriesCollectionMetadataLocale: Array<GraphQLTypes["UserPaymentTriesCollectionMetadataLocale"]>,
	paginateUserPaymentTriesCollectionMetadataLocale: GraphQLTypes["UserPaymentTriesCollectionMetadataLocaleConnection"],
	getCsobPaymentMetadata?: GraphQLTypes["CsobPaymentMetadata"] | undefined,
	listCsobPaymentMetadata: Array<GraphQLTypes["CsobPaymentMetadata"]>,
	paginateCsobPaymentMetadata: GraphQLTypes["CsobPaymentMetadataConnection"],
	getHeroCarousel?: GraphQLTypes["HeroCarousel"] | undefined,
	listHeroCarousel: Array<GraphQLTypes["HeroCarousel"]>,
	paginateHeroCarousel: GraphQLTypes["HeroCarouselConnection"],
	validateCreateHeroCarousel: GraphQLTypes["_ValidationResult"],
	validateUpdateHeroCarousel: GraphQLTypes["_ValidationResult"],
	getPostOrganizationList?: GraphQLTypes["PostOrganizationList"] | undefined,
	listPostOrganizationList: Array<GraphQLTypes["PostOrganizationList"]>,
	paginatePostOrganizationList: GraphQLTypes["PostOrganizationListConnection"],
	validateCreatePostOrganizationList: GraphQLTypes["_ValidationResult"],
	validateUpdatePostOrganizationList: GraphQLTypes["_ValidationResult"],
	getPostOrganizationListItem?: GraphQLTypes["PostOrganizationListItem"] | undefined,
	listPostOrganizationListItem: Array<GraphQLTypes["PostOrganizationListItem"]>,
	paginatePostOrganizationListItem: GraphQLTypes["PostOrganizationListItemConnection"],
	validateCreatePostOrganizationListItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePostOrganizationListItem: GraphQLTypes["_ValidationResult"],
	getInfoCarousel?: GraphQLTypes["InfoCarousel"] | undefined,
	listInfoCarousel: Array<GraphQLTypes["InfoCarousel"]>,
	paginateInfoCarousel: GraphQLTypes["InfoCarouselConnection"],
	validateCreateInfoCarousel: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoCarousel: GraphQLTypes["_ValidationResult"],
	getInfoCarouselItem?: GraphQLTypes["InfoCarouselItem"] | undefined,
	listInfoCarouselItem: Array<GraphQLTypes["InfoCarouselItem"]>,
	paginateInfoCarouselItem: GraphQLTypes["InfoCarouselItemConnection"],
	validateCreateInfoCarouselItem: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoCarouselItem: GraphQLTypes["_ValidationResult"],
	getPersonSeenInfoCarousel?: GraphQLTypes["PersonSeenInfoCarousel"] | undefined,
	listPersonSeenInfoCarousel: Array<GraphQLTypes["PersonSeenInfoCarousel"]>,
	paginatePersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselConnection"],
	validateCreatePersonSeenInfoCarousel: GraphQLTypes["_ValidationResult"],
	validateUpdatePersonSeenInfoCarousel: GraphQLTypes["_ValidationResult"],
	getGivenGiftsPage?: GraphQLTypes["GivenGiftsPage"] | undefined,
	listGivenGiftsPage: Array<GraphQLTypes["GivenGiftsPage"]>,
	paginateGivenGiftsPage: GraphQLTypes["GivenGiftsPageConnection"],
	validateCreateGivenGiftsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGivenGiftsPage: GraphQLTypes["_ValidationResult"],
	getGivenGiftsPageLocale?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	listGivenGiftsPageLocale: Array<GraphQLTypes["GivenGiftsPageLocale"]>,
	paginateGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleConnection"],
	validateCreateGivenGiftsPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGivenGiftsPageLocale: GraphQLTypes["_ValidationResult"],
	getReceivedGiftsPage?: GraphQLTypes["ReceivedGiftsPage"] | undefined,
	listReceivedGiftsPage: Array<GraphQLTypes["ReceivedGiftsPage"]>,
	paginateReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageConnection"],
	validateCreateReceivedGiftsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateReceivedGiftsPage: GraphQLTypes["_ValidationResult"],
	getReceivedGiftsPageLocale?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	listReceivedGiftsPageLocale: Array<GraphQLTypes["ReceivedGiftsPageLocale"]>,
	paginateReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleConnection"],
	validateCreateReceivedGiftsPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateReceivedGiftsPageLocale: GraphQLTypes["_ValidationResult"],
	getReportNavigation?: GraphQLTypes["ReportNavigation"] | undefined,
	listReportNavigation: Array<GraphQLTypes["ReportNavigation"]>,
	paginateReportNavigation: GraphQLTypes["ReportNavigationConnection"],
	validateCreateReportNavigation: GraphQLTypes["_ValidationResult"],
	validateUpdateReportNavigation: GraphQLTypes["_ValidationResult"],
	getReportPage?: GraphQLTypes["ReportPage"] | undefined,
	listReportPage: Array<GraphQLTypes["ReportPage"]>,
	paginateReportPage: GraphQLTypes["ReportPageConnection"],
	validateCreateReportPage: GraphQLTypes["_ValidationResult"],
	validateUpdateReportPage: GraphQLTypes["_ValidationResult"],
	getReportPageLocale?: GraphQLTypes["ReportPageLocale"] | undefined,
	listReportPageLocale: Array<GraphQLTypes["ReportPageLocale"]>,
	paginateReportPageLocale: GraphQLTypes["ReportPageLocaleConnection"],
	validateCreateReportPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateReportPageLocale: GraphQLTypes["_ValidationResult"],
	getReportNavigationLocale?: GraphQLTypes["ReportNavigationLocale"] | undefined,
	listReportNavigationLocale: Array<GraphQLTypes["ReportNavigationLocale"]>,
	paginateReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleConnection"],
	validateCreateReportNavigationLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateReportNavigationLocale: GraphQLTypes["_ValidationResult"],
	getSentPayment?: GraphQLTypes["SentPayment"] | undefined,
	listSentPayment: Array<GraphQLTypes["SentPayment"]>,
	paginateSentPayment: GraphQLTypes["SentPaymentConnection"],
	validateCreateSentPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateSentPayment: GraphQLTypes["_ValidationResult"],
	getPostAreaSentPaymentCurrencySum?: GraphQLTypes["PostAreaSentPaymentCurrencySum"] | undefined,
	listPostAreaSentPaymentCurrencySum: Array<GraphQLTypes["PostAreaSentPaymentCurrencySum"]>,
	paginatePostAreaSentPaymentCurrencySum: GraphQLTypes["PostAreaSentPaymentCurrencySumConnection"],
	getPostAreaSentPaymentSum?: GraphQLTypes["PostAreaSentPaymentSum"] | undefined,
	listPostAreaSentPaymentSum: Array<GraphQLTypes["PostAreaSentPaymentSum"]>,
	paginatePostAreaSentPaymentSum: GraphQLTypes["PostAreaSentPaymentSumConnection"],
	getNotificationTargetGroup?: GraphQLTypes["NotificationTargetGroup"] | undefined,
	listNotificationTargetGroup: Array<GraphQLTypes["NotificationTargetGroup"]>,
	paginateNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupConnection"],
	validateCreateNotificationTargetGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateNotificationTargetGroup: GraphQLTypes["_ValidationResult"],
	getProcessedNotification?: GraphQLTypes["ProcessedNotification"] | undefined,
	listProcessedNotification: Array<GraphQLTypes["ProcessedNotification"]>,
	paginateProcessedNotification: GraphQLTypes["ProcessedNotificationConnection"],
	validateCreateProcessedNotification: GraphQLTypes["_ValidationResult"],
	validateUpdateProcessedNotification: GraphQLTypes["_ValidationResult"],
	getScheduledNotification?: GraphQLTypes["ScheduledNotification"] | undefined,
	listScheduledNotification: Array<GraphQLTypes["ScheduledNotification"]>,
	paginateScheduledNotification: GraphQLTypes["ScheduledNotificationConnection"],
	validateCreateScheduledNotification: GraphQLTypes["_ValidationResult"],
	validateUpdateScheduledNotification: GraphQLTypes["_ValidationResult"],
	getProcessedNotificationSource?: GraphQLTypes["ProcessedNotificationSource"] | undefined,
	listProcessedNotificationSource: Array<GraphQLTypes["ProcessedNotificationSource"]>,
	paginateProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceConnection"],
	validateCreateProcessedNotificationSource: GraphQLTypes["_ValidationResult"],
	validateUpdateProcessedNotificationSource: GraphQLTypes["_ValidationResult"],
	getDevice?: GraphQLTypes["Device"] | undefined,
	listDevice: Array<GraphQLTypes["Device"]>,
	paginateDevice: GraphQLTypes["DeviceConnection"],
	validateCreateDevice: GraphQLTypes["_ValidationResult"],
	validateUpdateDevice: GraphQLTypes["_ValidationResult"],
	getScheduledNotificationLocale?: GraphQLTypes["ScheduledNotificationLocale"] | undefined,
	listScheduledNotificationLocale: Array<GraphQLTypes["ScheduledNotificationLocale"]>,
	paginateScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleConnection"],
	validateCreateScheduledNotificationLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateScheduledNotificationLocale: GraphQLTypes["_ValidationResult"],
	getInfoCarouselItemLocale?: GraphQLTypes["InfoCarouselItemLocale"] | undefined,
	listInfoCarouselItemLocale: Array<GraphQLTypes["InfoCarouselItemLocale"]>,
	paginateInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleConnection"],
	validateCreateInfoCarouselItemLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoCarouselItemLocale: GraphQLTypes["_ValidationResult"],
	getSentPaymentLocale?: GraphQLTypes["SentPaymentLocale"] | undefined,
	listSentPaymentLocale: Array<GraphQLTypes["SentPaymentLocale"]>,
	paginateSentPaymentLocale: GraphQLTypes["SentPaymentLocaleConnection"],
	validateCreateSentPaymentLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSentPaymentLocale: GraphQLTypes["_ValidationResult"],
	getUserPaymentMetadata?: GraphQLTypes["UserPaymentMetadata"] | undefined,
	listUserPaymentMetadata: Array<GraphQLTypes["UserPaymentMetadata"]>,
	paginateUserPaymentMetadata: GraphQLTypes["UserPaymentMetadataConnection"],
	getPostAreaCurrencySum?: GraphQLTypes["PostAreaCurrencySum"] | undefined,
	listPostAreaCurrencySum: Array<GraphQLTypes["PostAreaCurrencySum"]>,
	paginatePostAreaCurrencySum: GraphQLTypes["PostAreaCurrencySumConnection"],
	getPostAreaSum?: GraphQLTypes["PostAreaSum"] | undefined,
	listPostAreaSum: Array<GraphQLTypes["PostAreaSum"]>,
	paginatePostAreaSum: GraphQLTypes["PostAreaSumConnection"],
	getPostOrganizationCurrencySum?: GraphQLTypes["PostOrganizationCurrencySum"] | undefined,
	listPostOrganizationCurrencySum: Array<GraphQLTypes["PostOrganizationCurrencySum"]>,
	paginatePostOrganizationCurrencySum: GraphQLTypes["PostOrganizationCurrencySumConnection"],
	getPostOrganizationSum?: GraphQLTypes["PostOrganizationSum"] | undefined,
	listPostOrganizationSum: Array<GraphQLTypes["PostOrganizationSum"]>,
	paginatePostOrganizationSum: GraphQLTypes["PostOrganizationSumConnection"],
	getStats?: GraphQLTypes["Stats"] | undefined,
	listStats: Array<GraphQLTypes["Stats"]>,
	paginateStats: GraphQLTypes["StatsConnection"],
	getUserRecurringPaymentItemMetadata?: GraphQLTypes["UserRecurringPaymentItemMetadata"] | undefined,
	listUserRecurringPaymentItemMetadata: Array<GraphQLTypes["UserRecurringPaymentItemMetadata"]>,
	paginateUserRecurringPaymentItemMetadata: GraphQLTypes["UserRecurringPaymentItemMetadataConnection"],
	getUpcomingUserRecurringPaymentMetadata?: GraphQLTypes["UpcomingUserRecurringPaymentMetadata"] | undefined,
	listUpcomingUserRecurringPaymentMetadata: Array<GraphQLTypes["UpcomingUserRecurringPaymentMetadata"]>,
	paginateUpcomingUserRecurringPaymentMetadata: GraphQLTypes["UpcomingUserRecurringPaymentMetadataConnection"],
	getUserAreaStats?: GraphQLTypes["UserAreaStats"] | undefined,
	listUserAreaStats: Array<GraphQLTypes["UserAreaStats"]>,
	paginateUserAreaStats: GraphQLTypes["UserAreaStatsConnection"],
	getUserCurrencyStats?: GraphQLTypes["UserCurrencyStats"] | undefined,
	listUserCurrencyStats: Array<GraphQLTypes["UserCurrencyStats"]>,
	paginateUserCurrencyStats: GraphQLTypes["UserCurrencyStatsConnection"],
	getUserOrganizationStats?: GraphQLTypes["UserOrganizationStats"] | undefined,
	listUserOrganizationStats: Array<GraphQLTypes["UserOrganizationStats"]>,
	paginateUserOrganizationStats: GraphQLTypes["UserOrganizationStatsConnection"],
	getUserPostStats?: GraphQLTypes["UserPostStats"] | undefined,
	listUserPostStats: Array<GraphQLTypes["UserPostStats"]>,
	paginateUserPostStats: GraphQLTypes["UserPostStatsConnection"],
	getUserStats?: GraphQLTypes["UserStats"] | undefined,
	listUserStats: Array<GraphQLTypes["UserStats"]>,
	paginateUserStats: GraphQLTypes["UserStatsConnection"],
	getTextImageList?: GraphQLTypes["TextImageList"] | undefined,
	listTextImageList: Array<GraphQLTypes["TextImageList"]>,
	paginateTextImageList: GraphQLTypes["TextImageListConnection"],
	validateCreateTextImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextImageList: GraphQLTypes["_ValidationResult"],
	getTextImageListItem?: GraphQLTypes["TextImageListItem"] | undefined,
	listTextImageListItem: Array<GraphQLTypes["TextImageListItem"]>,
	paginateTextImageListItem: GraphQLTypes["TextImageListItemConnection"],
	validateCreateTextImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextImageListItem: GraphQLTypes["_ValidationResult"],
	getPostCurrencySum?: GraphQLTypes["PostCurrencySum"] | undefined,
	listPostCurrencySum: Array<GraphQLTypes["PostCurrencySum"]>,
	paginatePostCurrencySum: GraphQLTypes["PostCurrencySumConnection"],
	getPostSum?: GraphQLTypes["PostSum"] | undefined,
	listPostSum: Array<GraphQLTypes["PostSum"]>,
	paginatePostSum: GraphQLTypes["PostSumConnection"],
	getPostFundraisingProgress?: GraphQLTypes["PostFundraisingProgress"] | undefined,
	listPostFundraisingProgress: Array<GraphQLTypes["PostFundraisingProgress"]>,
	paginatePostFundraisingProgress: GraphQLTypes["PostFundraisingProgressConnection"],
	getHeroCarouselItem?: GraphQLTypes["HeroCarouselItem"] | undefined,
	listHeroCarouselItem: Array<GraphQLTypes["HeroCarouselItem"]>,
	paginateHeroCarouselItem: GraphQLTypes["HeroCarouselItemConnection"],
	validateCreateHeroCarouselItem: GraphQLTypes["_ValidationResult"],
	validateUpdateHeroCarouselItem: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string | undefined
};
	["Mutation"]: {
	__typename: "Mutation",
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"],
	createGeneral: GraphQLTypes["GeneralCreateResult"],
	deleteGeneral: GraphQLTypes["GeneralDeleteResult"],
	updateGeneral: GraphQLTypes["GeneralUpdateResult"],
	upsertGeneral: GraphQLTypes["GeneralUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createGenericPage: GraphQLTypes["GenericPageCreateResult"],
	deleteGenericPage: GraphQLTypes["GenericPageDeleteResult"],
	updateGenericPage: GraphQLTypes["GenericPageUpdateResult"],
	upsertGenericPage: GraphQLTypes["GenericPageUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createGeneralLocale: GraphQLTypes["GeneralLocaleCreateResult"],
	deleteGeneralLocale: GraphQLTypes["GeneralLocaleDeleteResult"],
	updateGeneralLocale: GraphQLTypes["GeneralLocaleUpdateResult"],
	upsertGeneralLocale: GraphQLTypes["GeneralLocaleUpsertResult"],
	createGenericPageLocale: GraphQLTypes["GenericPageLocaleCreateResult"],
	deleteGenericPageLocale: GraphQLTypes["GenericPageLocaleDeleteResult"],
	updateGenericPageLocale: GraphQLTypes["GenericPageLocaleUpdateResult"],
	upsertGenericPageLocale: GraphQLTypes["GenericPageLocaleUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createPost: GraphQLTypes["PostCreateResult"],
	deletePost: GraphQLTypes["PostDeleteResult"],
	updatePost: GraphQLTypes["PostUpdateResult"],
	upsertPost: GraphQLTypes["PostUpsertResult"],
	createPostLocale: GraphQLTypes["PostLocaleCreateResult"],
	deletePostLocale: GraphQLTypes["PostLocaleDeleteResult"],
	updatePostLocale: GraphQLTypes["PostLocaleUpdateResult"],
	upsertPostLocale: GraphQLTypes["PostLocaleUpsertResult"],
	createPostArea: GraphQLTypes["PostAreaCreateResult"],
	deletePostArea: GraphQLTypes["PostAreaDeleteResult"],
	updatePostArea: GraphQLTypes["PostAreaUpdateResult"],
	upsertPostArea: GraphQLTypes["PostAreaUpsertResult"],
	createPostAreaLocale: GraphQLTypes["PostAreaLocaleCreateResult"],
	deletePostAreaLocale: GraphQLTypes["PostAreaLocaleDeleteResult"],
	updatePostAreaLocale: GraphQLTypes["PostAreaLocaleUpdateResult"],
	upsertPostAreaLocale: GraphQLTypes["PostAreaLocaleUpsertResult"],
	createPostOrganization: GraphQLTypes["PostOrganizationCreateResult"],
	deletePostOrganization: GraphQLTypes["PostOrganizationDeleteResult"],
	updatePostOrganization: GraphQLTypes["PostOrganizationUpdateResult"],
	upsertPostOrganization: GraphQLTypes["PostOrganizationUpsertResult"],
	createPostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleCreateResult"],
	deletePostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleDeleteResult"],
	updatePostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleUpdateResult"],
	upsertPostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleUpsertResult"],
	createDonation: GraphQLTypes["DonationCreateResult"],
	deleteDonation: GraphQLTypes["DonationDeleteResult"],
	updateDonation: GraphQLTypes["DonationUpdateResult"],
	upsertDonation: GraphQLTypes["DonationUpsertResult"],
	createDonationAmountItem: GraphQLTypes["DonationAmountItemCreateResult"],
	deleteDonationAmountItem: GraphQLTypes["DonationAmountItemDeleteResult"],
	updateDonationAmountItem: GraphQLTypes["DonationAmountItemUpdateResult"],
	upsertDonationAmountItem: GraphQLTypes["DonationAmountItemUpsertResult"],
	createDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemCreateResult"],
	deleteDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemDeleteResult"],
	updateDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemUpdateResult"],
	upsertDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemUpsertResult"],
	createDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListCreateResult"],
	deleteDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListDeleteResult"],
	updateDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListUpdateResult"],
	upsertDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListUpsertResult"],
	createRegion: GraphQLTypes["RegionCreateResult"],
	deleteRegion: GraphQLTypes["RegionDeleteResult"],
	updateRegion: GraphQLTypes["RegionUpdateResult"],
	upsertRegion: GraphQLTypes["RegionUpsertResult"],
	createLinkItem: GraphQLTypes["LinkItemCreateResult"],
	deleteLinkItem: GraphQLTypes["LinkItemDeleteResult"],
	updateLinkItem: GraphQLTypes["LinkItemUpdateResult"],
	upsertLinkItem: GraphQLTypes["LinkItemUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLocale: GraphQLTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: GraphQLTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: GraphQLTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: GraphQLTypes["HeaderLocaleUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLocale: GraphQLTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: GraphQLTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: GraphQLTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: GraphQLTypes["FooterLocaleUpsertResult"],
	createPostList: GraphQLTypes["PostListCreateResult"],
	deletePostList: GraphQLTypes["PostListDeleteResult"],
	updatePostList: GraphQLTypes["PostListUpdateResult"],
	upsertPostList: GraphQLTypes["PostListUpsertResult"],
	createPostListItem: GraphQLTypes["PostListItemCreateResult"],
	deletePostListItem: GraphQLTypes["PostListItemDeleteResult"],
	updatePostListItem: GraphQLTypes["PostListItemUpdateResult"],
	upsertPostListItem: GraphQLTypes["PostListItemUpsertResult"],
	createAppBanner: GraphQLTypes["AppBannerCreateResult"],
	deleteAppBanner: GraphQLTypes["AppBannerDeleteResult"],
	updateAppBanner: GraphQLTypes["AppBannerUpdateResult"],
	upsertAppBanner: GraphQLTypes["AppBannerUpsertResult"],
	createGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsCreateResult"],
	deleteGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsDeleteResult"],
	updateGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsUpdateResult"],
	upsertGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsUpsertResult"],
	createGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleCreateResult"],
	deleteGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleDeleteResult"],
	updateGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateResult"],
	upsertGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleUpsertResult"],
	createValue: GraphQLTypes["ValueCreateResult"],
	deleteValue: GraphQLTypes["ValueDeleteResult"],
	updateValue: GraphQLTypes["ValueUpdateResult"],
	upsertValue: GraphQLTypes["ValueUpsertResult"],
	createValueItem: GraphQLTypes["ValueItemCreateResult"],
	deleteValueItem: GraphQLTypes["ValueItemDeleteResult"],
	updateValueItem: GraphQLTypes["ValueItemUpdateResult"],
	upsertValueItem: GraphQLTypes["ValueItemUpsertResult"],
	createValueList: GraphQLTypes["ValueListCreateResult"],
	deleteValueList: GraphQLTypes["ValueListDeleteResult"],
	updateValueList: GraphQLTypes["ValueListUpdateResult"],
	upsertValueList: GraphQLTypes["ValueListUpsertResult"],
	createImageLink: GraphQLTypes["ImageLinkCreateResult"],
	deleteImageLink: GraphQLTypes["ImageLinkDeleteResult"],
	updateImageLink: GraphQLTypes["ImageLinkUpdateResult"],
	upsertImageLink: GraphQLTypes["ImageLinkUpsertResult"],
	createImageLinkItem: GraphQLTypes["ImageLinkItemCreateResult"],
	deleteImageLinkItem: GraphQLTypes["ImageLinkItemDeleteResult"],
	updateImageLinkItem: GraphQLTypes["ImageLinkItemUpdateResult"],
	upsertImageLinkItem: GraphQLTypes["ImageLinkItemUpsertResult"],
	createImageLinkList: GraphQLTypes["ImageLinkListCreateResult"],
	deleteImageLinkList: GraphQLTypes["ImageLinkListDeleteResult"],
	updateImageLinkList: GraphQLTypes["ImageLinkListUpdateResult"],
	upsertImageLinkList: GraphQLTypes["ImageLinkListUpsertResult"],
	createPostAreaList: GraphQLTypes["PostAreaListCreateResult"],
	deletePostAreaList: GraphQLTypes["PostAreaListDeleteResult"],
	updatePostAreaList: GraphQLTypes["PostAreaListUpdateResult"],
	upsertPostAreaList: GraphQLTypes["PostAreaListUpsertResult"],
	createPostAreaListItem: GraphQLTypes["PostAreaListItemCreateResult"],
	deletePostAreaListItem: GraphQLTypes["PostAreaListItemDeleteResult"],
	updatePostAreaListItem: GraphQLTypes["PostAreaListItemUpdateResult"],
	upsertPostAreaListItem: GraphQLTypes["PostAreaListItemUpsertResult"],
	createAccordion: GraphQLTypes["AccordionCreateResult"],
	deleteAccordion: GraphQLTypes["AccordionDeleteResult"],
	updateAccordion: GraphQLTypes["AccordionUpdateResult"],
	upsertAccordion: GraphQLTypes["AccordionUpsertResult"],
	createAccordionItem: GraphQLTypes["AccordionItemCreateResult"],
	deleteAccordionItem: GraphQLTypes["AccordionItemDeleteResult"],
	updateAccordionItem: GraphQLTypes["AccordionItemUpdateResult"],
	upsertAccordionItem: GraphQLTypes["AccordionItemUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createUserPayment: GraphQLTypes["UserPaymentCreateResult"],
	deleteUserPayment: GraphQLTypes["UserPaymentDeleteResult"],
	updateUserPayment: GraphQLTypes["UserPaymentUpdateResult"],
	upsertUserPayment: GraphQLTypes["UserPaymentUpsertResult"],
	createCurrency: GraphQLTypes["CurrencyCreateResult"],
	deleteCurrency: GraphQLTypes["CurrencyDeleteResult"],
	updateCurrency: GraphQLTypes["CurrencyUpdateResult"],
	upsertCurrency: GraphQLTypes["CurrencyUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createMediumItem: GraphQLTypes["MediumItemCreateResult"],
	deleteMediumItem: GraphQLTypes["MediumItemDeleteResult"],
	updateMediumItem: GraphQLTypes["MediumItemUpdateResult"],
	upsertMediumItem: GraphQLTypes["MediumItemUpsertResult"],
	createMediumList: GraphQLTypes["MediumListCreateResult"],
	deleteMediumList: GraphQLTypes["MediumListDeleteResult"],
	updateMediumList: GraphQLTypes["MediumListUpdateResult"],
	upsertMediumList: GraphQLTypes["MediumListUpsertResult"],
	createUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdCreateResult"],
	deleteUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdDeleteResult"],
	updateUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdUpdateResult"],
	upsertUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdUpsertResult"],
	createPostRevision: GraphQLTypes["PostRevisionCreateResult"],
	deletePostRevision: GraphQLTypes["PostRevisionDeleteResult"],
	updatePostRevision: GraphQLTypes["PostRevisionUpdateResult"],
	upsertPostRevision: GraphQLTypes["PostRevisionUpsertResult"],
	createUserRecurringPayment: GraphQLTypes["UserRecurringPaymentCreateResult"],
	deleteUserRecurringPayment: GraphQLTypes["UserRecurringPaymentDeleteResult"],
	updateUserRecurringPayment: GraphQLTypes["UserRecurringPaymentUpdateResult"],
	upsertUserRecurringPayment: GraphQLTypes["UserRecurringPaymentUpsertResult"],
	createUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemCreateResult"],
	deleteUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemDeleteResult"],
	updateUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemUpdateResult"],
	upsertUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemUpsertResult"],
	createPostRevisionLocale: GraphQLTypes["PostRevisionLocaleCreateResult"],
	deletePostRevisionLocale: GraphQLTypes["PostRevisionLocaleDeleteResult"],
	updatePostRevisionLocale: GraphQLTypes["PostRevisionLocaleUpdateResult"],
	upsertPostRevisionLocale: GraphQLTypes["PostRevisionLocaleUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleCreateResult"],
	deleteGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleDeleteResult"],
	updateGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpdateResult"],
	upsertGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpsertResult"],
	createMemberList: GraphQLTypes["MemberListCreateResult"],
	deleteMemberList: GraphQLTypes["MemberListDeleteResult"],
	updateMemberList: GraphQLTypes["MemberListUpdateResult"],
	upsertMemberList: GraphQLTypes["MemberListUpsertResult"],
	createMemberListItem: GraphQLTypes["MemberListItemCreateResult"],
	deleteMemberListItem: GraphQLTypes["MemberListItemDeleteResult"],
	updateMemberListItem: GraphQLTypes["MemberListItemUpdateResult"],
	upsertMemberListItem: GraphQLTypes["MemberListItemUpsertResult"],
	createFilledTaxForm: GraphQLTypes["FilledTaxFormCreateResult"],
	deleteFilledTaxForm: GraphQLTypes["FilledTaxFormDeleteResult"],
	updateFilledTaxForm: GraphQLTypes["FilledTaxFormUpdateResult"],
	upsertFilledTaxForm: GraphQLTypes["FilledTaxFormUpsertResult"],
	createFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressCreateResult"],
	deleteFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressDeleteResult"],
	updateFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressUpdateResult"],
	upsertFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressUpsertResult"],
	createForm: GraphQLTypes["FormCreateResult"],
	deleteForm: GraphQLTypes["FormDeleteResult"],
	updateForm: GraphQLTypes["FormUpdateResult"],
	upsertForm: GraphQLTypes["FormUpsertResult"],
	createCsobPayment: GraphQLTypes["CsobPaymentCreateResult"],
	deleteCsobPayment: GraphQLTypes["CsobPaymentDeleteResult"],
	updateCsobPayment: GraphQLTypes["CsobPaymentUpdateResult"],
	upsertCsobPayment: GraphQLTypes["CsobPaymentUpsertResult"],
	createCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeCreateResult"],
	deleteCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeDeleteResult"],
	updateCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeUpdateResult"],
	upsertCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeUpsertResult"],
	createStripePayment: GraphQLTypes["StripePaymentCreateResult"],
	deleteStripePayment: GraphQLTypes["StripePaymentDeleteResult"],
	updateStripePayment: GraphQLTypes["StripePaymentUpdateResult"],
	upsertStripePayment: GraphQLTypes["StripePaymentUpsertResult"],
	createStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeCreateResult"],
	deleteStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeDeleteResult"],
	updateStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeUpdateResult"],
	upsertStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeUpsertResult"],
	createRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodCreateResult"],
	deleteRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodDeleteResult"],
	updateRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodUpdateResult"],
	upsertRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodUpsertResult"],
	createTileItem: GraphQLTypes["TileItemCreateResult"],
	deleteTileItem: GraphQLTypes["TileItemDeleteResult"],
	updateTileItem: GraphQLTypes["TileItemUpdateResult"],
	upsertTileItem: GraphQLTypes["TileItemUpsertResult"],
	createTileList: GraphQLTypes["TileListCreateResult"],
	deleteTileList: GraphQLTypes["TileListDeleteResult"],
	updateTileList: GraphQLTypes["TileListUpdateResult"],
	upsertTileList: GraphQLTypes["TileListUpsertResult"],
	createFeedPage: GraphQLTypes["FeedPageCreateResult"],
	deleteFeedPage: GraphQLTypes["FeedPageDeleteResult"],
	updateFeedPage: GraphQLTypes["FeedPageUpdateResult"],
	upsertFeedPage: GraphQLTypes["FeedPageUpsertResult"],
	createFeedPageLocale: GraphQLTypes["FeedPageLocaleCreateResult"],
	deleteFeedPageLocale: GraphQLTypes["FeedPageLocaleDeleteResult"],
	updateFeedPageLocale: GraphQLTypes["FeedPageLocaleUpdateResult"],
	upsertFeedPageLocale: GraphQLTypes["FeedPageLocaleUpsertResult"],
	createFeedPageSection: GraphQLTypes["FeedPageSectionCreateResult"],
	deleteFeedPageSection: GraphQLTypes["FeedPageSectionDeleteResult"],
	updateFeedPageSection: GraphQLTypes["FeedPageSectionUpdateResult"],
	upsertFeedPageSection: GraphQLTypes["FeedPageSectionUpsertResult"],
	createFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeCreateResult"],
	deleteFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeDeleteResult"],
	updateFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeUpdateResult"],
	upsertFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeUpsertResult"],
	createCardItem: GraphQLTypes["CardItemCreateResult"],
	deleteCardItem: GraphQLTypes["CardItemDeleteResult"],
	updateCardItem: GraphQLTypes["CardItemUpdateResult"],
	upsertCardItem: GraphQLTypes["CardItemUpsertResult"],
	createCardList: GraphQLTypes["CardListCreateResult"],
	deleteCardList: GraphQLTypes["CardListDeleteResult"],
	updateCardList: GraphQLTypes["CardListUpdateResult"],
	upsertCardList: GraphQLTypes["CardListUpsertResult"],
	createOnBehalfDonation: GraphQLTypes["OnBehalfDonationCreateResult"],
	deleteOnBehalfDonation: GraphQLTypes["OnBehalfDonationDeleteResult"],
	updateOnBehalfDonation: GraphQLTypes["OnBehalfDonationUpdateResult"],
	upsertOnBehalfDonation: GraphQLTypes["OnBehalfDonationUpsertResult"],
	createUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionCreateResult"],
	deleteUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionDeleteResult"],
	updateUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionUpdateResult"],
	upsertUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionUpsertResult"],
	createRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageCreateResult"],
	deleteRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageDeleteResult"],
	updateRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageUpdateResult"],
	upsertRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageUpsertResult"],
	createRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleCreateResult"],
	deleteRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleDeleteResult"],
	updateRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleUpdateResult"],
	upsertRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleUpsertResult"],
	createStoryGuide: GraphQLTypes["StoryGuideCreateResult"],
	deleteStoryGuide: GraphQLTypes["StoryGuideDeleteResult"],
	updateStoryGuide: GraphQLTypes["StoryGuideUpdateResult"],
	upsertStoryGuide: GraphQLTypes["StoryGuideUpsertResult"],
	createStoryGuideItem: GraphQLTypes["StoryGuideItemCreateResult"],
	deleteStoryGuideItem: GraphQLTypes["StoryGuideItemDeleteResult"],
	updateStoryGuideItem: GraphQLTypes["StoryGuideItemUpdateResult"],
	upsertStoryGuideItem: GraphQLTypes["StoryGuideItemUpsertResult"],
	createStoryGuideList: GraphQLTypes["StoryGuideListCreateResult"],
	deleteStoryGuideList: GraphQLTypes["StoryGuideListDeleteResult"],
	updateStoryGuideList: GraphQLTypes["StoryGuideListUpdateResult"],
	upsertStoryGuideList: GraphQLTypes["StoryGuideListUpsertResult"],
	createHeroCarousel: GraphQLTypes["HeroCarouselCreateResult"],
	deleteHeroCarousel: GraphQLTypes["HeroCarouselDeleteResult"],
	updateHeroCarousel: GraphQLTypes["HeroCarouselUpdateResult"],
	upsertHeroCarousel: GraphQLTypes["HeroCarouselUpsertResult"],
	createPostOrganizationList: GraphQLTypes["PostOrganizationListCreateResult"],
	deletePostOrganizationList: GraphQLTypes["PostOrganizationListDeleteResult"],
	updatePostOrganizationList: GraphQLTypes["PostOrganizationListUpdateResult"],
	upsertPostOrganizationList: GraphQLTypes["PostOrganizationListUpsertResult"],
	createPostOrganizationListItem: GraphQLTypes["PostOrganizationListItemCreateResult"],
	deletePostOrganizationListItem: GraphQLTypes["PostOrganizationListItemDeleteResult"],
	updatePostOrganizationListItem: GraphQLTypes["PostOrganizationListItemUpdateResult"],
	upsertPostOrganizationListItem: GraphQLTypes["PostOrganizationListItemUpsertResult"],
	createInfoCarousel: GraphQLTypes["InfoCarouselCreateResult"],
	deleteInfoCarousel: GraphQLTypes["InfoCarouselDeleteResult"],
	updateInfoCarousel: GraphQLTypes["InfoCarouselUpdateResult"],
	upsertInfoCarousel: GraphQLTypes["InfoCarouselUpsertResult"],
	createInfoCarouselItem: GraphQLTypes["InfoCarouselItemCreateResult"],
	deleteInfoCarouselItem: GraphQLTypes["InfoCarouselItemDeleteResult"],
	updateInfoCarouselItem: GraphQLTypes["InfoCarouselItemUpdateResult"],
	upsertInfoCarouselItem: GraphQLTypes["InfoCarouselItemUpsertResult"],
	createPersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselCreateResult"],
	deletePersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselDeleteResult"],
	updatePersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselUpdateResult"],
	upsertPersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselUpsertResult"],
	createGivenGiftsPage: GraphQLTypes["GivenGiftsPageCreateResult"],
	deleteGivenGiftsPage: GraphQLTypes["GivenGiftsPageDeleteResult"],
	updateGivenGiftsPage: GraphQLTypes["GivenGiftsPageUpdateResult"],
	upsertGivenGiftsPage: GraphQLTypes["GivenGiftsPageUpsertResult"],
	createGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleCreateResult"],
	deleteGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleDeleteResult"],
	updateGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleUpdateResult"],
	upsertGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleUpsertResult"],
	createReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageCreateResult"],
	deleteReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageDeleteResult"],
	updateReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageUpdateResult"],
	upsertReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageUpsertResult"],
	createReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleCreateResult"],
	deleteReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleDeleteResult"],
	updateReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleUpdateResult"],
	upsertReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleUpsertResult"],
	createReportNavigation: GraphQLTypes["ReportNavigationCreateResult"],
	deleteReportNavigation: GraphQLTypes["ReportNavigationDeleteResult"],
	updateReportNavigation: GraphQLTypes["ReportNavigationUpdateResult"],
	upsertReportNavigation: GraphQLTypes["ReportNavigationUpsertResult"],
	createReportPage: GraphQLTypes["ReportPageCreateResult"],
	deleteReportPage: GraphQLTypes["ReportPageDeleteResult"],
	updateReportPage: GraphQLTypes["ReportPageUpdateResult"],
	upsertReportPage: GraphQLTypes["ReportPageUpsertResult"],
	createReportPageLocale: GraphQLTypes["ReportPageLocaleCreateResult"],
	deleteReportPageLocale: GraphQLTypes["ReportPageLocaleDeleteResult"],
	updateReportPageLocale: GraphQLTypes["ReportPageLocaleUpdateResult"],
	upsertReportPageLocale: GraphQLTypes["ReportPageLocaleUpsertResult"],
	createReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleCreateResult"],
	deleteReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleDeleteResult"],
	updateReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleUpdateResult"],
	upsertReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleUpsertResult"],
	createSentPayment: GraphQLTypes["SentPaymentCreateResult"],
	deleteSentPayment: GraphQLTypes["SentPaymentDeleteResult"],
	updateSentPayment: GraphQLTypes["SentPaymentUpdateResult"],
	upsertSentPayment: GraphQLTypes["SentPaymentUpsertResult"],
	createNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupCreateResult"],
	deleteNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupDeleteResult"],
	updateNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupUpdateResult"],
	upsertNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupUpsertResult"],
	createProcessedNotification: GraphQLTypes["ProcessedNotificationCreateResult"],
	deleteProcessedNotification: GraphQLTypes["ProcessedNotificationDeleteResult"],
	updateProcessedNotification: GraphQLTypes["ProcessedNotificationUpdateResult"],
	upsertProcessedNotification: GraphQLTypes["ProcessedNotificationUpsertResult"],
	createScheduledNotification: GraphQLTypes["ScheduledNotificationCreateResult"],
	deleteScheduledNotification: GraphQLTypes["ScheduledNotificationDeleteResult"],
	updateScheduledNotification: GraphQLTypes["ScheduledNotificationUpdateResult"],
	upsertScheduledNotification: GraphQLTypes["ScheduledNotificationUpsertResult"],
	createProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceCreateResult"],
	deleteProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceDeleteResult"],
	updateProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceUpdateResult"],
	upsertProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceUpsertResult"],
	createDevice: GraphQLTypes["DeviceCreateResult"],
	deleteDevice: GraphQLTypes["DeviceDeleteResult"],
	updateDevice: GraphQLTypes["DeviceUpdateResult"],
	upsertDevice: GraphQLTypes["DeviceUpsertResult"],
	createScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleCreateResult"],
	deleteScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleDeleteResult"],
	updateScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleUpdateResult"],
	upsertScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleUpsertResult"],
	createInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleCreateResult"],
	deleteInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleDeleteResult"],
	updateInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleUpdateResult"],
	upsertInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleUpsertResult"],
	createSentPaymentLocale: GraphQLTypes["SentPaymentLocaleCreateResult"],
	deleteSentPaymentLocale: GraphQLTypes["SentPaymentLocaleDeleteResult"],
	updateSentPaymentLocale: GraphQLTypes["SentPaymentLocaleUpdateResult"],
	upsertSentPaymentLocale: GraphQLTypes["SentPaymentLocaleUpsertResult"],
	createTextImageList: GraphQLTypes["TextImageListCreateResult"],
	deleteTextImageList: GraphQLTypes["TextImageListDeleteResult"],
	updateTextImageList: GraphQLTypes["TextImageListUpdateResult"],
	upsertTextImageList: GraphQLTypes["TextImageListUpsertResult"],
	createTextImageListItem: GraphQLTypes["TextImageListItemCreateResult"],
	deleteTextImageListItem: GraphQLTypes["TextImageListItemDeleteResult"],
	updateTextImageListItem: GraphQLTypes["TextImageListItemUpdateResult"],
	upsertTextImageListItem: GraphQLTypes["TextImageListItemUpsertResult"],
	createHeroCarouselItem: GraphQLTypes["HeroCarouselItemCreateResult"],
	deleteHeroCarouselItem: GraphQLTypes["HeroCarouselItemDeleteResult"],
	updateHeroCarouselItem: GraphQLTypes["HeroCarouselItemUpdateResult"],
	upsertHeroCarouselItem: GraphQLTypes["HeroCarouselItemUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"]
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3GenerateSignedUploadInput"]: {
		contentType?: string | undefined,
	/** If not provided, extension is detected from a content-type. */
	extension?: string | undefined,
	/** Signed URL expiration. */
	expiration?: number | undefined,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number | undefined,
	/** Can be used as a "directory". */
	prefix?: string | undefined,
	/** Suffix after generated id and before the extension. */
	suffix?: string | undefined,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string | undefined,
	contentDisposition?: GraphQLTypes["S33ContentDisposition"] | undefined,
	/** If not supported by S3 provider, an error is thrown. */
	acl?: GraphQLTypes["S3Acl"] | undefined
};
	["S33ContentDisposition"]: S33ContentDisposition;
	["S3Acl"]: S3Acl;
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string
};
	["GeneralCreateResult"]: {
	__typename: "GeneralCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["General"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"GeneralCreateResult" | "GeneralDeleteResult" | "GeneralUpdateResult" | "GeneralUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "GenericPageCreateResult" | "GenericPageDeleteResult" | "GenericPageUpdateResult" | "GenericPageUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "GeneralLocaleCreateResult" | "GeneralLocaleDeleteResult" | "GeneralLocaleUpdateResult" | "GeneralLocaleUpsertResult" | "GenericPageLocaleCreateResult" | "GenericPageLocaleDeleteResult" | "GenericPageLocaleUpdateResult" | "GenericPageLocaleUpsertResult" | "LocaleCreateResult" | "LocaleDeleteResult" | "LocaleUpdateResult" | "LocaleUpsertResult" | "VideoCreateResult" | "VideoDeleteResult" | "VideoUpdateResult" | "VideoUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "PostCreateResult" | "PostDeleteResult" | "PostUpdateResult" | "PostUpsertResult" | "PostLocaleCreateResult" | "PostLocaleDeleteResult" | "PostLocaleUpdateResult" | "PostLocaleUpsertResult" | "PostAreaCreateResult" | "PostAreaDeleteResult" | "PostAreaUpdateResult" | "PostAreaUpsertResult" | "PostAreaLocaleCreateResult" | "PostAreaLocaleDeleteResult" | "PostAreaLocaleUpdateResult" | "PostAreaLocaleUpsertResult" | "PostOrganizationCreateResult" | "PostOrganizationDeleteResult" | "PostOrganizationUpdateResult" | "PostOrganizationUpsertResult" | "PostOrganizationLocaleCreateResult" | "PostOrganizationLocaleDeleteResult" | "PostOrganizationLocaleUpdateResult" | "PostOrganizationLocaleUpsertResult" | "DonationCreateResult" | "DonationDeleteResult" | "DonationUpdateResult" | "DonationUpsertResult" | "DonationAmountItemCreateResult" | "DonationAmountItemDeleteResult" | "DonationAmountItemUpdateResult" | "DonationAmountItemUpsertResult" | "DonationAmountsRegionItemCreateResult" | "DonationAmountsRegionItemDeleteResult" | "DonationAmountsRegionItemUpdateResult" | "DonationAmountsRegionItemUpsertResult" | "DonationAmountsRegionListCreateResult" | "DonationAmountsRegionListDeleteResult" | "DonationAmountsRegionListUpdateResult" | "DonationAmountsRegionListUpsertResult" | "RegionCreateResult" | "RegionDeleteResult" | "RegionUpdateResult" | "RegionUpsertResult" | "LinkItemCreateResult" | "LinkItemDeleteResult" | "LinkItemUpdateResult" | "LinkItemUpsertResult" | "LinkListCreateResult" | "LinkListDeleteResult" | "LinkListUpdateResult" | "LinkListUpsertResult" | "HeaderCreateResult" | "HeaderDeleteResult" | "HeaderUpdateResult" | "HeaderUpsertResult" | "HeaderLocaleCreateResult" | "HeaderLocaleDeleteResult" | "HeaderLocaleUpdateResult" | "HeaderLocaleUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "FooterLocaleCreateResult" | "FooterLocaleDeleteResult" | "FooterLocaleUpdateResult" | "FooterLocaleUpsertResult" | "PostListCreateResult" | "PostListDeleteResult" | "PostListUpdateResult" | "PostListUpsertResult" | "PostListItemCreateResult" | "PostListItemDeleteResult" | "PostListItemUpdateResult" | "PostListItemUpsertResult" | "AppBannerCreateResult" | "AppBannerDeleteResult" | "AppBannerUpdateResult" | "AppBannerUpsertResult" | "GenericPageAboutSettingsCreateResult" | "GenericPageAboutSettingsDeleteResult" | "GenericPageAboutSettingsUpdateResult" | "GenericPageAboutSettingsUpsertResult" | "GenericPageAboutSettingsLocaleCreateResult" | "GenericPageAboutSettingsLocaleDeleteResult" | "GenericPageAboutSettingsLocaleUpdateResult" | "GenericPageAboutSettingsLocaleUpsertResult" | "ValueCreateResult" | "ValueDeleteResult" | "ValueUpdateResult" | "ValueUpsertResult" | "ValueItemCreateResult" | "ValueItemDeleteResult" | "ValueItemUpdateResult" | "ValueItemUpsertResult" | "ValueListCreateResult" | "ValueListDeleteResult" | "ValueListUpdateResult" | "ValueListUpsertResult" | "ImageLinkCreateResult" | "ImageLinkDeleteResult" | "ImageLinkUpdateResult" | "ImageLinkUpsertResult" | "ImageLinkItemCreateResult" | "ImageLinkItemDeleteResult" | "ImageLinkItemUpdateResult" | "ImageLinkItemUpsertResult" | "ImageLinkListCreateResult" | "ImageLinkListDeleteResult" | "ImageLinkListUpdateResult" | "ImageLinkListUpsertResult" | "PostAreaListCreateResult" | "PostAreaListDeleteResult" | "PostAreaListUpdateResult" | "PostAreaListUpsertResult" | "PostAreaListItemCreateResult" | "PostAreaListItemDeleteResult" | "PostAreaListItemUpdateResult" | "PostAreaListItemUpsertResult" | "AccordionCreateResult" | "AccordionDeleteResult" | "AccordionUpdateResult" | "AccordionUpsertResult" | "AccordionItemCreateResult" | "AccordionItemDeleteResult" | "AccordionItemUpdateResult" | "AccordionItemUpsertResult" | "UserCreateResult" | "UserDeleteResult" | "UserUpdateResult" | "UserUpsertResult" | "UserPaymentCreateResult" | "UserPaymentDeleteResult" | "UserPaymentUpdateResult" | "UserPaymentUpsertResult" | "CurrencyCreateResult" | "CurrencyDeleteResult" | "CurrencyUpdateResult" | "CurrencyUpsertResult" | "MediumCreateResult" | "MediumDeleteResult" | "MediumUpdateResult" | "MediumUpsertResult" | "MediumItemCreateResult" | "MediumItemDeleteResult" | "MediumItemUpdateResult" | "MediumItemUpsertResult" | "MediumListCreateResult" | "MediumListDeleteResult" | "MediumListUpdateResult" | "MediumListUpsertResult" | "UserPaymentOrderIdCreateResult" | "UserPaymentOrderIdDeleteResult" | "UserPaymentOrderIdUpdateResult" | "UserPaymentOrderIdUpsertResult" | "PostRevisionCreateResult" | "PostRevisionDeleteResult" | "PostRevisionUpdateResult" | "PostRevisionUpsertResult" | "UserRecurringPaymentCreateResult" | "UserRecurringPaymentDeleteResult" | "UserRecurringPaymentUpdateResult" | "UserRecurringPaymentUpsertResult" | "UserRecurringPaymentItemCreateResult" | "UserRecurringPaymentItemDeleteResult" | "UserRecurringPaymentItemUpdateResult" | "UserRecurringPaymentItemUpsertResult" | "PostRevisionLocaleCreateResult" | "PostRevisionLocaleDeleteResult" | "PostRevisionLocaleUpdateResult" | "PostRevisionLocaleUpsertResult" | "TranslationCatalogueCreateResult" | "TranslationCatalogueDeleteResult" | "TranslationCatalogueUpdateResult" | "TranslationCatalogueUpsertResult" | "TranslationCataloguesIdentifierCreateResult" | "TranslationCataloguesIdentifierDeleteResult" | "TranslationCataloguesIdentifierUpdateResult" | "TranslationCataloguesIdentifierUpsertResult" | "TranslationDomainCreateResult" | "TranslationDomainDeleteResult" | "TranslationDomainUpdateResult" | "TranslationDomainUpsertResult" | "TranslationKeyCreateResult" | "TranslationKeyDeleteResult" | "TranslationKeyUpdateResult" | "TranslationKeyUpsertResult" | "TranslationValueCreateResult" | "TranslationValueDeleteResult" | "TranslationValueUpdateResult" | "TranslationValueUpsertResult" | "GenericPageAboutGroupLinksLocaleCreateResult" | "GenericPageAboutGroupLinksLocaleDeleteResult" | "GenericPageAboutGroupLinksLocaleUpdateResult" | "GenericPageAboutGroupLinksLocaleUpsertResult" | "MemberListCreateResult" | "MemberListDeleteResult" | "MemberListUpdateResult" | "MemberListUpsertResult" | "MemberListItemCreateResult" | "MemberListItemDeleteResult" | "MemberListItemUpdateResult" | "MemberListItemUpsertResult" | "FilledTaxFormCreateResult" | "FilledTaxFormDeleteResult" | "FilledTaxFormUpdateResult" | "FilledTaxFormUpsertResult" | "FilledTaxFormEmailAddressCreateResult" | "FilledTaxFormEmailAddressDeleteResult" | "FilledTaxFormEmailAddressUpdateResult" | "FilledTaxFormEmailAddressUpsertResult" | "FormCreateResult" | "FormDeleteResult" | "FormUpdateResult" | "FormUpsertResult" | "CsobPaymentCreateResult" | "CsobPaymentDeleteResult" | "CsobPaymentUpdateResult" | "CsobPaymentUpsertResult" | "CsobPaymentStatusChangeCreateResult" | "CsobPaymentStatusChangeDeleteResult" | "CsobPaymentStatusChangeUpdateResult" | "CsobPaymentStatusChangeUpsertResult" | "StripePaymentCreateResult" | "StripePaymentDeleteResult" | "StripePaymentUpdateResult" | "StripePaymentUpsertResult" | "StripePaymentStatusChangeCreateResult" | "StripePaymentStatusChangeDeleteResult" | "StripePaymentStatusChangeUpdateResult" | "StripePaymentStatusChangeUpsertResult" | "RegionPaymentMethodCreateResult" | "RegionPaymentMethodDeleteResult" | "RegionPaymentMethodUpdateResult" | "RegionPaymentMethodUpsertResult" | "TileItemCreateResult" | "TileItemDeleteResult" | "TileItemUpdateResult" | "TileItemUpsertResult" | "TileListCreateResult" | "TileListDeleteResult" | "TileListUpdateResult" | "TileListUpsertResult" | "FeedPageCreateResult" | "FeedPageDeleteResult" | "FeedPageUpdateResult" | "FeedPageUpsertResult" | "FeedPageLocaleCreateResult" | "FeedPageLocaleDeleteResult" | "FeedPageLocaleUpdateResult" | "FeedPageLocaleUpsertResult" | "FeedPageSectionCreateResult" | "FeedPageSectionDeleteResult" | "FeedPageSectionUpdateResult" | "FeedPageSectionUpsertResult" | "FeedPageTileStripeCreateResult" | "FeedPageTileStripeDeleteResult" | "FeedPageTileStripeUpdateResult" | "FeedPageTileStripeUpsertResult" | "CardItemCreateResult" | "CardItemDeleteResult" | "CardItemUpdateResult" | "CardItemUpsertResult" | "CardListCreateResult" | "CardListDeleteResult" | "CardListUpdateResult" | "CardListUpsertResult" | "OnBehalfDonationCreateResult" | "OnBehalfDonationDeleteResult" | "OnBehalfDonationUpdateResult" | "OnBehalfDonationUpsertResult" | "UserPaymentTriesCollectionCreateResult" | "UserPaymentTriesCollectionDeleteResult" | "UserPaymentTriesCollectionUpdateResult" | "UserPaymentTriesCollectionUpsertResult" | "RecurringPaymentPageCreateResult" | "RecurringPaymentPageDeleteResult" | "RecurringPaymentPageUpdateResult" | "RecurringPaymentPageUpsertResult" | "RecurringPaymentPageLocaleCreateResult" | "RecurringPaymentPageLocaleDeleteResult" | "RecurringPaymentPageLocaleUpdateResult" | "RecurringPaymentPageLocaleUpsertResult" | "StoryGuideCreateResult" | "StoryGuideDeleteResult" | "StoryGuideUpdateResult" | "StoryGuideUpsertResult" | "StoryGuideItemCreateResult" | "StoryGuideItemDeleteResult" | "StoryGuideItemUpdateResult" | "StoryGuideItemUpsertResult" | "StoryGuideListCreateResult" | "StoryGuideListDeleteResult" | "StoryGuideListUpdateResult" | "StoryGuideListUpsertResult" | "HeroCarouselCreateResult" | "HeroCarouselDeleteResult" | "HeroCarouselUpdateResult" | "HeroCarouselUpsertResult" | "PostOrganizationListCreateResult" | "PostOrganizationListDeleteResult" | "PostOrganizationListUpdateResult" | "PostOrganizationListUpsertResult" | "PostOrganizationListItemCreateResult" | "PostOrganizationListItemDeleteResult" | "PostOrganizationListItemUpdateResult" | "PostOrganizationListItemUpsertResult" | "InfoCarouselCreateResult" | "InfoCarouselDeleteResult" | "InfoCarouselUpdateResult" | "InfoCarouselUpsertResult" | "InfoCarouselItemCreateResult" | "InfoCarouselItemDeleteResult" | "InfoCarouselItemUpdateResult" | "InfoCarouselItemUpsertResult" | "PersonSeenInfoCarouselCreateResult" | "PersonSeenInfoCarouselDeleteResult" | "PersonSeenInfoCarouselUpdateResult" | "PersonSeenInfoCarouselUpsertResult" | "GivenGiftsPageCreateResult" | "GivenGiftsPageDeleteResult" | "GivenGiftsPageUpdateResult" | "GivenGiftsPageUpsertResult" | "GivenGiftsPageLocaleCreateResult" | "GivenGiftsPageLocaleDeleteResult" | "GivenGiftsPageLocaleUpdateResult" | "GivenGiftsPageLocaleUpsertResult" | "ReceivedGiftsPageCreateResult" | "ReceivedGiftsPageDeleteResult" | "ReceivedGiftsPageUpdateResult" | "ReceivedGiftsPageUpsertResult" | "ReceivedGiftsPageLocaleCreateResult" | "ReceivedGiftsPageLocaleDeleteResult" | "ReceivedGiftsPageLocaleUpdateResult" | "ReceivedGiftsPageLocaleUpsertResult" | "ReportNavigationCreateResult" | "ReportNavigationDeleteResult" | "ReportNavigationUpdateResult" | "ReportNavigationUpsertResult" | "ReportPageCreateResult" | "ReportPageDeleteResult" | "ReportPageUpdateResult" | "ReportPageUpsertResult" | "ReportPageLocaleCreateResult" | "ReportPageLocaleDeleteResult" | "ReportPageLocaleUpdateResult" | "ReportPageLocaleUpsertResult" | "ReportNavigationLocaleCreateResult" | "ReportNavigationLocaleDeleteResult" | "ReportNavigationLocaleUpdateResult" | "ReportNavigationLocaleUpsertResult" | "SentPaymentCreateResult" | "SentPaymentDeleteResult" | "SentPaymentUpdateResult" | "SentPaymentUpsertResult" | "NotificationTargetGroupCreateResult" | "NotificationTargetGroupDeleteResult" | "NotificationTargetGroupUpdateResult" | "NotificationTargetGroupUpsertResult" | "ProcessedNotificationCreateResult" | "ProcessedNotificationDeleteResult" | "ProcessedNotificationUpdateResult" | "ProcessedNotificationUpsertResult" | "ScheduledNotificationCreateResult" | "ScheduledNotificationDeleteResult" | "ScheduledNotificationUpdateResult" | "ScheduledNotificationUpsertResult" | "ProcessedNotificationSourceCreateResult" | "ProcessedNotificationSourceDeleteResult" | "ProcessedNotificationSourceUpdateResult" | "ProcessedNotificationSourceUpsertResult" | "DeviceCreateResult" | "DeviceDeleteResult" | "DeviceUpdateResult" | "DeviceUpsertResult" | "ScheduledNotificationLocaleCreateResult" | "ScheduledNotificationLocaleDeleteResult" | "ScheduledNotificationLocaleUpdateResult" | "ScheduledNotificationLocaleUpsertResult" | "InfoCarouselItemLocaleCreateResult" | "InfoCarouselItemLocaleDeleteResult" | "InfoCarouselItemLocaleUpdateResult" | "InfoCarouselItemLocaleUpsertResult" | "SentPaymentLocaleCreateResult" | "SentPaymentLocaleDeleteResult" | "SentPaymentLocaleUpdateResult" | "SentPaymentLocaleUpsertResult" | "TextImageListCreateResult" | "TextImageListDeleteResult" | "TextImageListUpdateResult" | "TextImageListUpsertResult" | "TextImageListItemCreateResult" | "TextImageListItemDeleteResult" | "TextImageListItemUpdateResult" | "TextImageListItemUpsertResult" | "HeroCarouselItemCreateResult" | "HeroCarouselItemDeleteResult" | "HeroCarouselItemUpdateResult" | "HeroCarouselItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on GeneralCreateResult']: '__union' & GraphQLTypes["GeneralCreateResult"];
	['...on GeneralDeleteResult']: '__union' & GraphQLTypes["GeneralDeleteResult"];
	['...on GeneralUpdateResult']: '__union' & GraphQLTypes["GeneralUpdateResult"];
	['...on GeneralUpsertResult']: '__union' & GraphQLTypes["GeneralUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on GenericPageCreateResult']: '__union' & GraphQLTypes["GenericPageCreateResult"];
	['...on GenericPageDeleteResult']: '__union' & GraphQLTypes["GenericPageDeleteResult"];
	['...on GenericPageUpdateResult']: '__union' & GraphQLTypes["GenericPageUpdateResult"];
	['...on GenericPageUpsertResult']: '__union' & GraphQLTypes["GenericPageUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on GeneralLocaleCreateResult']: '__union' & GraphQLTypes["GeneralLocaleCreateResult"];
	['...on GeneralLocaleDeleteResult']: '__union' & GraphQLTypes["GeneralLocaleDeleteResult"];
	['...on GeneralLocaleUpdateResult']: '__union' & GraphQLTypes["GeneralLocaleUpdateResult"];
	['...on GeneralLocaleUpsertResult']: '__union' & GraphQLTypes["GeneralLocaleUpsertResult"];
	['...on GenericPageLocaleCreateResult']: '__union' & GraphQLTypes["GenericPageLocaleCreateResult"];
	['...on GenericPageLocaleDeleteResult']: '__union' & GraphQLTypes["GenericPageLocaleDeleteResult"];
	['...on GenericPageLocaleUpdateResult']: '__union' & GraphQLTypes["GenericPageLocaleUpdateResult"];
	['...on GenericPageLocaleUpsertResult']: '__union' & GraphQLTypes["GenericPageLocaleUpsertResult"];
	['...on LocaleCreateResult']: '__union' & GraphQLTypes["LocaleCreateResult"];
	['...on LocaleDeleteResult']: '__union' & GraphQLTypes["LocaleDeleteResult"];
	['...on LocaleUpdateResult']: '__union' & GraphQLTypes["LocaleUpdateResult"];
	['...on LocaleUpsertResult']: '__union' & GraphQLTypes["LocaleUpsertResult"];
	['...on VideoCreateResult']: '__union' & GraphQLTypes["VideoCreateResult"];
	['...on VideoDeleteResult']: '__union' & GraphQLTypes["VideoDeleteResult"];
	['...on VideoUpdateResult']: '__union' & GraphQLTypes["VideoUpdateResult"];
	['...on VideoUpsertResult']: '__union' & GraphQLTypes["VideoUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on PostCreateResult']: '__union' & GraphQLTypes["PostCreateResult"];
	['...on PostDeleteResult']: '__union' & GraphQLTypes["PostDeleteResult"];
	['...on PostUpdateResult']: '__union' & GraphQLTypes["PostUpdateResult"];
	['...on PostUpsertResult']: '__union' & GraphQLTypes["PostUpsertResult"];
	['...on PostLocaleCreateResult']: '__union' & GraphQLTypes["PostLocaleCreateResult"];
	['...on PostLocaleDeleteResult']: '__union' & GraphQLTypes["PostLocaleDeleteResult"];
	['...on PostLocaleUpdateResult']: '__union' & GraphQLTypes["PostLocaleUpdateResult"];
	['...on PostLocaleUpsertResult']: '__union' & GraphQLTypes["PostLocaleUpsertResult"];
	['...on PostAreaCreateResult']: '__union' & GraphQLTypes["PostAreaCreateResult"];
	['...on PostAreaDeleteResult']: '__union' & GraphQLTypes["PostAreaDeleteResult"];
	['...on PostAreaUpdateResult']: '__union' & GraphQLTypes["PostAreaUpdateResult"];
	['...on PostAreaUpsertResult']: '__union' & GraphQLTypes["PostAreaUpsertResult"];
	['...on PostAreaLocaleCreateResult']: '__union' & GraphQLTypes["PostAreaLocaleCreateResult"];
	['...on PostAreaLocaleDeleteResult']: '__union' & GraphQLTypes["PostAreaLocaleDeleteResult"];
	['...on PostAreaLocaleUpdateResult']: '__union' & GraphQLTypes["PostAreaLocaleUpdateResult"];
	['...on PostAreaLocaleUpsertResult']: '__union' & GraphQLTypes["PostAreaLocaleUpsertResult"];
	['...on PostOrganizationCreateResult']: '__union' & GraphQLTypes["PostOrganizationCreateResult"];
	['...on PostOrganizationDeleteResult']: '__union' & GraphQLTypes["PostOrganizationDeleteResult"];
	['...on PostOrganizationUpdateResult']: '__union' & GraphQLTypes["PostOrganizationUpdateResult"];
	['...on PostOrganizationUpsertResult']: '__union' & GraphQLTypes["PostOrganizationUpsertResult"];
	['...on PostOrganizationLocaleCreateResult']: '__union' & GraphQLTypes["PostOrganizationLocaleCreateResult"];
	['...on PostOrganizationLocaleDeleteResult']: '__union' & GraphQLTypes["PostOrganizationLocaleDeleteResult"];
	['...on PostOrganizationLocaleUpdateResult']: '__union' & GraphQLTypes["PostOrganizationLocaleUpdateResult"];
	['...on PostOrganizationLocaleUpsertResult']: '__union' & GraphQLTypes["PostOrganizationLocaleUpsertResult"];
	['...on DonationCreateResult']: '__union' & GraphQLTypes["DonationCreateResult"];
	['...on DonationDeleteResult']: '__union' & GraphQLTypes["DonationDeleteResult"];
	['...on DonationUpdateResult']: '__union' & GraphQLTypes["DonationUpdateResult"];
	['...on DonationUpsertResult']: '__union' & GraphQLTypes["DonationUpsertResult"];
	['...on DonationAmountItemCreateResult']: '__union' & GraphQLTypes["DonationAmountItemCreateResult"];
	['...on DonationAmountItemDeleteResult']: '__union' & GraphQLTypes["DonationAmountItemDeleteResult"];
	['...on DonationAmountItemUpdateResult']: '__union' & GraphQLTypes["DonationAmountItemUpdateResult"];
	['...on DonationAmountItemUpsertResult']: '__union' & GraphQLTypes["DonationAmountItemUpsertResult"];
	['...on DonationAmountsRegionItemCreateResult']: '__union' & GraphQLTypes["DonationAmountsRegionItemCreateResult"];
	['...on DonationAmountsRegionItemDeleteResult']: '__union' & GraphQLTypes["DonationAmountsRegionItemDeleteResult"];
	['...on DonationAmountsRegionItemUpdateResult']: '__union' & GraphQLTypes["DonationAmountsRegionItemUpdateResult"];
	['...on DonationAmountsRegionItemUpsertResult']: '__union' & GraphQLTypes["DonationAmountsRegionItemUpsertResult"];
	['...on DonationAmountsRegionListCreateResult']: '__union' & GraphQLTypes["DonationAmountsRegionListCreateResult"];
	['...on DonationAmountsRegionListDeleteResult']: '__union' & GraphQLTypes["DonationAmountsRegionListDeleteResult"];
	['...on DonationAmountsRegionListUpdateResult']: '__union' & GraphQLTypes["DonationAmountsRegionListUpdateResult"];
	['...on DonationAmountsRegionListUpsertResult']: '__union' & GraphQLTypes["DonationAmountsRegionListUpsertResult"];
	['...on RegionCreateResult']: '__union' & GraphQLTypes["RegionCreateResult"];
	['...on RegionDeleteResult']: '__union' & GraphQLTypes["RegionDeleteResult"];
	['...on RegionUpdateResult']: '__union' & GraphQLTypes["RegionUpdateResult"];
	['...on RegionUpsertResult']: '__union' & GraphQLTypes["RegionUpsertResult"];
	['...on LinkItemCreateResult']: '__union' & GraphQLTypes["LinkItemCreateResult"];
	['...on LinkItemDeleteResult']: '__union' & GraphQLTypes["LinkItemDeleteResult"];
	['...on LinkItemUpdateResult']: '__union' & GraphQLTypes["LinkItemUpdateResult"];
	['...on LinkItemUpsertResult']: '__union' & GraphQLTypes["LinkItemUpsertResult"];
	['...on LinkListCreateResult']: '__union' & GraphQLTypes["LinkListCreateResult"];
	['...on LinkListDeleteResult']: '__union' & GraphQLTypes["LinkListDeleteResult"];
	['...on LinkListUpdateResult']: '__union' & GraphQLTypes["LinkListUpdateResult"];
	['...on LinkListUpsertResult']: '__union' & GraphQLTypes["LinkListUpsertResult"];
	['...on HeaderCreateResult']: '__union' & GraphQLTypes["HeaderCreateResult"];
	['...on HeaderDeleteResult']: '__union' & GraphQLTypes["HeaderDeleteResult"];
	['...on HeaderUpdateResult']: '__union' & GraphQLTypes["HeaderUpdateResult"];
	['...on HeaderUpsertResult']: '__union' & GraphQLTypes["HeaderUpsertResult"];
	['...on HeaderLocaleCreateResult']: '__union' & GraphQLTypes["HeaderLocaleCreateResult"];
	['...on HeaderLocaleDeleteResult']: '__union' & GraphQLTypes["HeaderLocaleDeleteResult"];
	['...on HeaderLocaleUpdateResult']: '__union' & GraphQLTypes["HeaderLocaleUpdateResult"];
	['...on HeaderLocaleUpsertResult']: '__union' & GraphQLTypes["HeaderLocaleUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on FooterLocaleCreateResult']: '__union' & GraphQLTypes["FooterLocaleCreateResult"];
	['...on FooterLocaleDeleteResult']: '__union' & GraphQLTypes["FooterLocaleDeleteResult"];
	['...on FooterLocaleUpdateResult']: '__union' & GraphQLTypes["FooterLocaleUpdateResult"];
	['...on FooterLocaleUpsertResult']: '__union' & GraphQLTypes["FooterLocaleUpsertResult"];
	['...on PostListCreateResult']: '__union' & GraphQLTypes["PostListCreateResult"];
	['...on PostListDeleteResult']: '__union' & GraphQLTypes["PostListDeleteResult"];
	['...on PostListUpdateResult']: '__union' & GraphQLTypes["PostListUpdateResult"];
	['...on PostListUpsertResult']: '__union' & GraphQLTypes["PostListUpsertResult"];
	['...on PostListItemCreateResult']: '__union' & GraphQLTypes["PostListItemCreateResult"];
	['...on PostListItemDeleteResult']: '__union' & GraphQLTypes["PostListItemDeleteResult"];
	['...on PostListItemUpdateResult']: '__union' & GraphQLTypes["PostListItemUpdateResult"];
	['...on PostListItemUpsertResult']: '__union' & GraphQLTypes["PostListItemUpsertResult"];
	['...on AppBannerCreateResult']: '__union' & GraphQLTypes["AppBannerCreateResult"];
	['...on AppBannerDeleteResult']: '__union' & GraphQLTypes["AppBannerDeleteResult"];
	['...on AppBannerUpdateResult']: '__union' & GraphQLTypes["AppBannerUpdateResult"];
	['...on AppBannerUpsertResult']: '__union' & GraphQLTypes["AppBannerUpsertResult"];
	['...on GenericPageAboutSettingsCreateResult']: '__union' & GraphQLTypes["GenericPageAboutSettingsCreateResult"];
	['...on GenericPageAboutSettingsDeleteResult']: '__union' & GraphQLTypes["GenericPageAboutSettingsDeleteResult"];
	['...on GenericPageAboutSettingsUpdateResult']: '__union' & GraphQLTypes["GenericPageAboutSettingsUpdateResult"];
	['...on GenericPageAboutSettingsUpsertResult']: '__union' & GraphQLTypes["GenericPageAboutSettingsUpsertResult"];
	['...on GenericPageAboutSettingsLocaleCreateResult']: '__union' & GraphQLTypes["GenericPageAboutSettingsLocaleCreateResult"];
	['...on GenericPageAboutSettingsLocaleDeleteResult']: '__union' & GraphQLTypes["GenericPageAboutSettingsLocaleDeleteResult"];
	['...on GenericPageAboutSettingsLocaleUpdateResult']: '__union' & GraphQLTypes["GenericPageAboutSettingsLocaleUpdateResult"];
	['...on GenericPageAboutSettingsLocaleUpsertResult']: '__union' & GraphQLTypes["GenericPageAboutSettingsLocaleUpsertResult"];
	['...on ValueCreateResult']: '__union' & GraphQLTypes["ValueCreateResult"];
	['...on ValueDeleteResult']: '__union' & GraphQLTypes["ValueDeleteResult"];
	['...on ValueUpdateResult']: '__union' & GraphQLTypes["ValueUpdateResult"];
	['...on ValueUpsertResult']: '__union' & GraphQLTypes["ValueUpsertResult"];
	['...on ValueItemCreateResult']: '__union' & GraphQLTypes["ValueItemCreateResult"];
	['...on ValueItemDeleteResult']: '__union' & GraphQLTypes["ValueItemDeleteResult"];
	['...on ValueItemUpdateResult']: '__union' & GraphQLTypes["ValueItemUpdateResult"];
	['...on ValueItemUpsertResult']: '__union' & GraphQLTypes["ValueItemUpsertResult"];
	['...on ValueListCreateResult']: '__union' & GraphQLTypes["ValueListCreateResult"];
	['...on ValueListDeleteResult']: '__union' & GraphQLTypes["ValueListDeleteResult"];
	['...on ValueListUpdateResult']: '__union' & GraphQLTypes["ValueListUpdateResult"];
	['...on ValueListUpsertResult']: '__union' & GraphQLTypes["ValueListUpsertResult"];
	['...on ImageLinkCreateResult']: '__union' & GraphQLTypes["ImageLinkCreateResult"];
	['...on ImageLinkDeleteResult']: '__union' & GraphQLTypes["ImageLinkDeleteResult"];
	['...on ImageLinkUpdateResult']: '__union' & GraphQLTypes["ImageLinkUpdateResult"];
	['...on ImageLinkUpsertResult']: '__union' & GraphQLTypes["ImageLinkUpsertResult"];
	['...on ImageLinkItemCreateResult']: '__union' & GraphQLTypes["ImageLinkItemCreateResult"];
	['...on ImageLinkItemDeleteResult']: '__union' & GraphQLTypes["ImageLinkItemDeleteResult"];
	['...on ImageLinkItemUpdateResult']: '__union' & GraphQLTypes["ImageLinkItemUpdateResult"];
	['...on ImageLinkItemUpsertResult']: '__union' & GraphQLTypes["ImageLinkItemUpsertResult"];
	['...on ImageLinkListCreateResult']: '__union' & GraphQLTypes["ImageLinkListCreateResult"];
	['...on ImageLinkListDeleteResult']: '__union' & GraphQLTypes["ImageLinkListDeleteResult"];
	['...on ImageLinkListUpdateResult']: '__union' & GraphQLTypes["ImageLinkListUpdateResult"];
	['...on ImageLinkListUpsertResult']: '__union' & GraphQLTypes["ImageLinkListUpsertResult"];
	['...on PostAreaListCreateResult']: '__union' & GraphQLTypes["PostAreaListCreateResult"];
	['...on PostAreaListDeleteResult']: '__union' & GraphQLTypes["PostAreaListDeleteResult"];
	['...on PostAreaListUpdateResult']: '__union' & GraphQLTypes["PostAreaListUpdateResult"];
	['...on PostAreaListUpsertResult']: '__union' & GraphQLTypes["PostAreaListUpsertResult"];
	['...on PostAreaListItemCreateResult']: '__union' & GraphQLTypes["PostAreaListItemCreateResult"];
	['...on PostAreaListItemDeleteResult']: '__union' & GraphQLTypes["PostAreaListItemDeleteResult"];
	['...on PostAreaListItemUpdateResult']: '__union' & GraphQLTypes["PostAreaListItemUpdateResult"];
	['...on PostAreaListItemUpsertResult']: '__union' & GraphQLTypes["PostAreaListItemUpsertResult"];
	['...on AccordionCreateResult']: '__union' & GraphQLTypes["AccordionCreateResult"];
	['...on AccordionDeleteResult']: '__union' & GraphQLTypes["AccordionDeleteResult"];
	['...on AccordionUpdateResult']: '__union' & GraphQLTypes["AccordionUpdateResult"];
	['...on AccordionUpsertResult']: '__union' & GraphQLTypes["AccordionUpsertResult"];
	['...on AccordionItemCreateResult']: '__union' & GraphQLTypes["AccordionItemCreateResult"];
	['...on AccordionItemDeleteResult']: '__union' & GraphQLTypes["AccordionItemDeleteResult"];
	['...on AccordionItemUpdateResult']: '__union' & GraphQLTypes["AccordionItemUpdateResult"];
	['...on AccordionItemUpsertResult']: '__union' & GraphQLTypes["AccordionItemUpsertResult"];
	['...on UserCreateResult']: '__union' & GraphQLTypes["UserCreateResult"];
	['...on UserDeleteResult']: '__union' & GraphQLTypes["UserDeleteResult"];
	['...on UserUpdateResult']: '__union' & GraphQLTypes["UserUpdateResult"];
	['...on UserUpsertResult']: '__union' & GraphQLTypes["UserUpsertResult"];
	['...on UserPaymentCreateResult']: '__union' & GraphQLTypes["UserPaymentCreateResult"];
	['...on UserPaymentDeleteResult']: '__union' & GraphQLTypes["UserPaymentDeleteResult"];
	['...on UserPaymentUpdateResult']: '__union' & GraphQLTypes["UserPaymentUpdateResult"];
	['...on UserPaymentUpsertResult']: '__union' & GraphQLTypes["UserPaymentUpsertResult"];
	['...on CurrencyCreateResult']: '__union' & GraphQLTypes["CurrencyCreateResult"];
	['...on CurrencyDeleteResult']: '__union' & GraphQLTypes["CurrencyDeleteResult"];
	['...on CurrencyUpdateResult']: '__union' & GraphQLTypes["CurrencyUpdateResult"];
	['...on CurrencyUpsertResult']: '__union' & GraphQLTypes["CurrencyUpsertResult"];
	['...on MediumCreateResult']: '__union' & GraphQLTypes["MediumCreateResult"];
	['...on MediumDeleteResult']: '__union' & GraphQLTypes["MediumDeleteResult"];
	['...on MediumUpdateResult']: '__union' & GraphQLTypes["MediumUpdateResult"];
	['...on MediumUpsertResult']: '__union' & GraphQLTypes["MediumUpsertResult"];
	['...on MediumItemCreateResult']: '__union' & GraphQLTypes["MediumItemCreateResult"];
	['...on MediumItemDeleteResult']: '__union' & GraphQLTypes["MediumItemDeleteResult"];
	['...on MediumItemUpdateResult']: '__union' & GraphQLTypes["MediumItemUpdateResult"];
	['...on MediumItemUpsertResult']: '__union' & GraphQLTypes["MediumItemUpsertResult"];
	['...on MediumListCreateResult']: '__union' & GraphQLTypes["MediumListCreateResult"];
	['...on MediumListDeleteResult']: '__union' & GraphQLTypes["MediumListDeleteResult"];
	['...on MediumListUpdateResult']: '__union' & GraphQLTypes["MediumListUpdateResult"];
	['...on MediumListUpsertResult']: '__union' & GraphQLTypes["MediumListUpsertResult"];
	['...on UserPaymentOrderIdCreateResult']: '__union' & GraphQLTypes["UserPaymentOrderIdCreateResult"];
	['...on UserPaymentOrderIdDeleteResult']: '__union' & GraphQLTypes["UserPaymentOrderIdDeleteResult"];
	['...on UserPaymentOrderIdUpdateResult']: '__union' & GraphQLTypes["UserPaymentOrderIdUpdateResult"];
	['...on UserPaymentOrderIdUpsertResult']: '__union' & GraphQLTypes["UserPaymentOrderIdUpsertResult"];
	['...on PostRevisionCreateResult']: '__union' & GraphQLTypes["PostRevisionCreateResult"];
	['...on PostRevisionDeleteResult']: '__union' & GraphQLTypes["PostRevisionDeleteResult"];
	['...on PostRevisionUpdateResult']: '__union' & GraphQLTypes["PostRevisionUpdateResult"];
	['...on PostRevisionUpsertResult']: '__union' & GraphQLTypes["PostRevisionUpsertResult"];
	['...on UserRecurringPaymentCreateResult']: '__union' & GraphQLTypes["UserRecurringPaymentCreateResult"];
	['...on UserRecurringPaymentDeleteResult']: '__union' & GraphQLTypes["UserRecurringPaymentDeleteResult"];
	['...on UserRecurringPaymentUpdateResult']: '__union' & GraphQLTypes["UserRecurringPaymentUpdateResult"];
	['...on UserRecurringPaymentUpsertResult']: '__union' & GraphQLTypes["UserRecurringPaymentUpsertResult"];
	['...on UserRecurringPaymentItemCreateResult']: '__union' & GraphQLTypes["UserRecurringPaymentItemCreateResult"];
	['...on UserRecurringPaymentItemDeleteResult']: '__union' & GraphQLTypes["UserRecurringPaymentItemDeleteResult"];
	['...on UserRecurringPaymentItemUpdateResult']: '__union' & GraphQLTypes["UserRecurringPaymentItemUpdateResult"];
	['...on UserRecurringPaymentItemUpsertResult']: '__union' & GraphQLTypes["UserRecurringPaymentItemUpsertResult"];
	['...on PostRevisionLocaleCreateResult']: '__union' & GraphQLTypes["PostRevisionLocaleCreateResult"];
	['...on PostRevisionLocaleDeleteResult']: '__union' & GraphQLTypes["PostRevisionLocaleDeleteResult"];
	['...on PostRevisionLocaleUpdateResult']: '__union' & GraphQLTypes["PostRevisionLocaleUpdateResult"];
	['...on PostRevisionLocaleUpsertResult']: '__union' & GraphQLTypes["PostRevisionLocaleUpsertResult"];
	['...on TranslationCatalogueCreateResult']: '__union' & GraphQLTypes["TranslationCatalogueCreateResult"];
	['...on TranslationCatalogueDeleteResult']: '__union' & GraphQLTypes["TranslationCatalogueDeleteResult"];
	['...on TranslationCatalogueUpdateResult']: '__union' & GraphQLTypes["TranslationCatalogueUpdateResult"];
	['...on TranslationCatalogueUpsertResult']: '__union' & GraphQLTypes["TranslationCatalogueUpsertResult"];
	['...on TranslationCataloguesIdentifierCreateResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierCreateResult"];
	['...on TranslationCataloguesIdentifierDeleteResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"];
	['...on TranslationCataloguesIdentifierUpdateResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"];
	['...on TranslationCataloguesIdentifierUpsertResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"];
	['...on TranslationDomainCreateResult']: '__union' & GraphQLTypes["TranslationDomainCreateResult"];
	['...on TranslationDomainDeleteResult']: '__union' & GraphQLTypes["TranslationDomainDeleteResult"];
	['...on TranslationDomainUpdateResult']: '__union' & GraphQLTypes["TranslationDomainUpdateResult"];
	['...on TranslationDomainUpsertResult']: '__union' & GraphQLTypes["TranslationDomainUpsertResult"];
	['...on TranslationKeyCreateResult']: '__union' & GraphQLTypes["TranslationKeyCreateResult"];
	['...on TranslationKeyDeleteResult']: '__union' & GraphQLTypes["TranslationKeyDeleteResult"];
	['...on TranslationKeyUpdateResult']: '__union' & GraphQLTypes["TranslationKeyUpdateResult"];
	['...on TranslationKeyUpsertResult']: '__union' & GraphQLTypes["TranslationKeyUpsertResult"];
	['...on TranslationValueCreateResult']: '__union' & GraphQLTypes["TranslationValueCreateResult"];
	['...on TranslationValueDeleteResult']: '__union' & GraphQLTypes["TranslationValueDeleteResult"];
	['...on TranslationValueUpdateResult']: '__union' & GraphQLTypes["TranslationValueUpdateResult"];
	['...on TranslationValueUpsertResult']: '__union' & GraphQLTypes["TranslationValueUpsertResult"];
	['...on GenericPageAboutGroupLinksLocaleCreateResult']: '__union' & GraphQLTypes["GenericPageAboutGroupLinksLocaleCreateResult"];
	['...on GenericPageAboutGroupLinksLocaleDeleteResult']: '__union' & GraphQLTypes["GenericPageAboutGroupLinksLocaleDeleteResult"];
	['...on GenericPageAboutGroupLinksLocaleUpdateResult']: '__union' & GraphQLTypes["GenericPageAboutGroupLinksLocaleUpdateResult"];
	['...on GenericPageAboutGroupLinksLocaleUpsertResult']: '__union' & GraphQLTypes["GenericPageAboutGroupLinksLocaleUpsertResult"];
	['...on MemberListCreateResult']: '__union' & GraphQLTypes["MemberListCreateResult"];
	['...on MemberListDeleteResult']: '__union' & GraphQLTypes["MemberListDeleteResult"];
	['...on MemberListUpdateResult']: '__union' & GraphQLTypes["MemberListUpdateResult"];
	['...on MemberListUpsertResult']: '__union' & GraphQLTypes["MemberListUpsertResult"];
	['...on MemberListItemCreateResult']: '__union' & GraphQLTypes["MemberListItemCreateResult"];
	['...on MemberListItemDeleteResult']: '__union' & GraphQLTypes["MemberListItemDeleteResult"];
	['...on MemberListItemUpdateResult']: '__union' & GraphQLTypes["MemberListItemUpdateResult"];
	['...on MemberListItemUpsertResult']: '__union' & GraphQLTypes["MemberListItemUpsertResult"];
	['...on FilledTaxFormCreateResult']: '__union' & GraphQLTypes["FilledTaxFormCreateResult"];
	['...on FilledTaxFormDeleteResult']: '__union' & GraphQLTypes["FilledTaxFormDeleteResult"];
	['...on FilledTaxFormUpdateResult']: '__union' & GraphQLTypes["FilledTaxFormUpdateResult"];
	['...on FilledTaxFormUpsertResult']: '__union' & GraphQLTypes["FilledTaxFormUpsertResult"];
	['...on FilledTaxFormEmailAddressCreateResult']: '__union' & GraphQLTypes["FilledTaxFormEmailAddressCreateResult"];
	['...on FilledTaxFormEmailAddressDeleteResult']: '__union' & GraphQLTypes["FilledTaxFormEmailAddressDeleteResult"];
	['...on FilledTaxFormEmailAddressUpdateResult']: '__union' & GraphQLTypes["FilledTaxFormEmailAddressUpdateResult"];
	['...on FilledTaxFormEmailAddressUpsertResult']: '__union' & GraphQLTypes["FilledTaxFormEmailAddressUpsertResult"];
	['...on FormCreateResult']: '__union' & GraphQLTypes["FormCreateResult"];
	['...on FormDeleteResult']: '__union' & GraphQLTypes["FormDeleteResult"];
	['...on FormUpdateResult']: '__union' & GraphQLTypes["FormUpdateResult"];
	['...on FormUpsertResult']: '__union' & GraphQLTypes["FormUpsertResult"];
	['...on CsobPaymentCreateResult']: '__union' & GraphQLTypes["CsobPaymentCreateResult"];
	['...on CsobPaymentDeleteResult']: '__union' & GraphQLTypes["CsobPaymentDeleteResult"];
	['...on CsobPaymentUpdateResult']: '__union' & GraphQLTypes["CsobPaymentUpdateResult"];
	['...on CsobPaymentUpsertResult']: '__union' & GraphQLTypes["CsobPaymentUpsertResult"];
	['...on CsobPaymentStatusChangeCreateResult']: '__union' & GraphQLTypes["CsobPaymentStatusChangeCreateResult"];
	['...on CsobPaymentStatusChangeDeleteResult']: '__union' & GraphQLTypes["CsobPaymentStatusChangeDeleteResult"];
	['...on CsobPaymentStatusChangeUpdateResult']: '__union' & GraphQLTypes["CsobPaymentStatusChangeUpdateResult"];
	['...on CsobPaymentStatusChangeUpsertResult']: '__union' & GraphQLTypes["CsobPaymentStatusChangeUpsertResult"];
	['...on StripePaymentCreateResult']: '__union' & GraphQLTypes["StripePaymentCreateResult"];
	['...on StripePaymentDeleteResult']: '__union' & GraphQLTypes["StripePaymentDeleteResult"];
	['...on StripePaymentUpdateResult']: '__union' & GraphQLTypes["StripePaymentUpdateResult"];
	['...on StripePaymentUpsertResult']: '__union' & GraphQLTypes["StripePaymentUpsertResult"];
	['...on StripePaymentStatusChangeCreateResult']: '__union' & GraphQLTypes["StripePaymentStatusChangeCreateResult"];
	['...on StripePaymentStatusChangeDeleteResult']: '__union' & GraphQLTypes["StripePaymentStatusChangeDeleteResult"];
	['...on StripePaymentStatusChangeUpdateResult']: '__union' & GraphQLTypes["StripePaymentStatusChangeUpdateResult"];
	['...on StripePaymentStatusChangeUpsertResult']: '__union' & GraphQLTypes["StripePaymentStatusChangeUpsertResult"];
	['...on RegionPaymentMethodCreateResult']: '__union' & GraphQLTypes["RegionPaymentMethodCreateResult"];
	['...on RegionPaymentMethodDeleteResult']: '__union' & GraphQLTypes["RegionPaymentMethodDeleteResult"];
	['...on RegionPaymentMethodUpdateResult']: '__union' & GraphQLTypes["RegionPaymentMethodUpdateResult"];
	['...on RegionPaymentMethodUpsertResult']: '__union' & GraphQLTypes["RegionPaymentMethodUpsertResult"];
	['...on TileItemCreateResult']: '__union' & GraphQLTypes["TileItemCreateResult"];
	['...on TileItemDeleteResult']: '__union' & GraphQLTypes["TileItemDeleteResult"];
	['...on TileItemUpdateResult']: '__union' & GraphQLTypes["TileItemUpdateResult"];
	['...on TileItemUpsertResult']: '__union' & GraphQLTypes["TileItemUpsertResult"];
	['...on TileListCreateResult']: '__union' & GraphQLTypes["TileListCreateResult"];
	['...on TileListDeleteResult']: '__union' & GraphQLTypes["TileListDeleteResult"];
	['...on TileListUpdateResult']: '__union' & GraphQLTypes["TileListUpdateResult"];
	['...on TileListUpsertResult']: '__union' & GraphQLTypes["TileListUpsertResult"];
	['...on FeedPageCreateResult']: '__union' & GraphQLTypes["FeedPageCreateResult"];
	['...on FeedPageDeleteResult']: '__union' & GraphQLTypes["FeedPageDeleteResult"];
	['...on FeedPageUpdateResult']: '__union' & GraphQLTypes["FeedPageUpdateResult"];
	['...on FeedPageUpsertResult']: '__union' & GraphQLTypes["FeedPageUpsertResult"];
	['...on FeedPageLocaleCreateResult']: '__union' & GraphQLTypes["FeedPageLocaleCreateResult"];
	['...on FeedPageLocaleDeleteResult']: '__union' & GraphQLTypes["FeedPageLocaleDeleteResult"];
	['...on FeedPageLocaleUpdateResult']: '__union' & GraphQLTypes["FeedPageLocaleUpdateResult"];
	['...on FeedPageLocaleUpsertResult']: '__union' & GraphQLTypes["FeedPageLocaleUpsertResult"];
	['...on FeedPageSectionCreateResult']: '__union' & GraphQLTypes["FeedPageSectionCreateResult"];
	['...on FeedPageSectionDeleteResult']: '__union' & GraphQLTypes["FeedPageSectionDeleteResult"];
	['...on FeedPageSectionUpdateResult']: '__union' & GraphQLTypes["FeedPageSectionUpdateResult"];
	['...on FeedPageSectionUpsertResult']: '__union' & GraphQLTypes["FeedPageSectionUpsertResult"];
	['...on FeedPageTileStripeCreateResult']: '__union' & GraphQLTypes["FeedPageTileStripeCreateResult"];
	['...on FeedPageTileStripeDeleteResult']: '__union' & GraphQLTypes["FeedPageTileStripeDeleteResult"];
	['...on FeedPageTileStripeUpdateResult']: '__union' & GraphQLTypes["FeedPageTileStripeUpdateResult"];
	['...on FeedPageTileStripeUpsertResult']: '__union' & GraphQLTypes["FeedPageTileStripeUpsertResult"];
	['...on CardItemCreateResult']: '__union' & GraphQLTypes["CardItemCreateResult"];
	['...on CardItemDeleteResult']: '__union' & GraphQLTypes["CardItemDeleteResult"];
	['...on CardItemUpdateResult']: '__union' & GraphQLTypes["CardItemUpdateResult"];
	['...on CardItemUpsertResult']: '__union' & GraphQLTypes["CardItemUpsertResult"];
	['...on CardListCreateResult']: '__union' & GraphQLTypes["CardListCreateResult"];
	['...on CardListDeleteResult']: '__union' & GraphQLTypes["CardListDeleteResult"];
	['...on CardListUpdateResult']: '__union' & GraphQLTypes["CardListUpdateResult"];
	['...on CardListUpsertResult']: '__union' & GraphQLTypes["CardListUpsertResult"];
	['...on OnBehalfDonationCreateResult']: '__union' & GraphQLTypes["OnBehalfDonationCreateResult"];
	['...on OnBehalfDonationDeleteResult']: '__union' & GraphQLTypes["OnBehalfDonationDeleteResult"];
	['...on OnBehalfDonationUpdateResult']: '__union' & GraphQLTypes["OnBehalfDonationUpdateResult"];
	['...on OnBehalfDonationUpsertResult']: '__union' & GraphQLTypes["OnBehalfDonationUpsertResult"];
	['...on UserPaymentTriesCollectionCreateResult']: '__union' & GraphQLTypes["UserPaymentTriesCollectionCreateResult"];
	['...on UserPaymentTriesCollectionDeleteResult']: '__union' & GraphQLTypes["UserPaymentTriesCollectionDeleteResult"];
	['...on UserPaymentTriesCollectionUpdateResult']: '__union' & GraphQLTypes["UserPaymentTriesCollectionUpdateResult"];
	['...on UserPaymentTriesCollectionUpsertResult']: '__union' & GraphQLTypes["UserPaymentTriesCollectionUpsertResult"];
	['...on RecurringPaymentPageCreateResult']: '__union' & GraphQLTypes["RecurringPaymentPageCreateResult"];
	['...on RecurringPaymentPageDeleteResult']: '__union' & GraphQLTypes["RecurringPaymentPageDeleteResult"];
	['...on RecurringPaymentPageUpdateResult']: '__union' & GraphQLTypes["RecurringPaymentPageUpdateResult"];
	['...on RecurringPaymentPageUpsertResult']: '__union' & GraphQLTypes["RecurringPaymentPageUpsertResult"];
	['...on RecurringPaymentPageLocaleCreateResult']: '__union' & GraphQLTypes["RecurringPaymentPageLocaleCreateResult"];
	['...on RecurringPaymentPageLocaleDeleteResult']: '__union' & GraphQLTypes["RecurringPaymentPageLocaleDeleteResult"];
	['...on RecurringPaymentPageLocaleUpdateResult']: '__union' & GraphQLTypes["RecurringPaymentPageLocaleUpdateResult"];
	['...on RecurringPaymentPageLocaleUpsertResult']: '__union' & GraphQLTypes["RecurringPaymentPageLocaleUpsertResult"];
	['...on StoryGuideCreateResult']: '__union' & GraphQLTypes["StoryGuideCreateResult"];
	['...on StoryGuideDeleteResult']: '__union' & GraphQLTypes["StoryGuideDeleteResult"];
	['...on StoryGuideUpdateResult']: '__union' & GraphQLTypes["StoryGuideUpdateResult"];
	['...on StoryGuideUpsertResult']: '__union' & GraphQLTypes["StoryGuideUpsertResult"];
	['...on StoryGuideItemCreateResult']: '__union' & GraphQLTypes["StoryGuideItemCreateResult"];
	['...on StoryGuideItemDeleteResult']: '__union' & GraphQLTypes["StoryGuideItemDeleteResult"];
	['...on StoryGuideItemUpdateResult']: '__union' & GraphQLTypes["StoryGuideItemUpdateResult"];
	['...on StoryGuideItemUpsertResult']: '__union' & GraphQLTypes["StoryGuideItemUpsertResult"];
	['...on StoryGuideListCreateResult']: '__union' & GraphQLTypes["StoryGuideListCreateResult"];
	['...on StoryGuideListDeleteResult']: '__union' & GraphQLTypes["StoryGuideListDeleteResult"];
	['...on StoryGuideListUpdateResult']: '__union' & GraphQLTypes["StoryGuideListUpdateResult"];
	['...on StoryGuideListUpsertResult']: '__union' & GraphQLTypes["StoryGuideListUpsertResult"];
	['...on HeroCarouselCreateResult']: '__union' & GraphQLTypes["HeroCarouselCreateResult"];
	['...on HeroCarouselDeleteResult']: '__union' & GraphQLTypes["HeroCarouselDeleteResult"];
	['...on HeroCarouselUpdateResult']: '__union' & GraphQLTypes["HeroCarouselUpdateResult"];
	['...on HeroCarouselUpsertResult']: '__union' & GraphQLTypes["HeroCarouselUpsertResult"];
	['...on PostOrganizationListCreateResult']: '__union' & GraphQLTypes["PostOrganizationListCreateResult"];
	['...on PostOrganizationListDeleteResult']: '__union' & GraphQLTypes["PostOrganizationListDeleteResult"];
	['...on PostOrganizationListUpdateResult']: '__union' & GraphQLTypes["PostOrganizationListUpdateResult"];
	['...on PostOrganizationListUpsertResult']: '__union' & GraphQLTypes["PostOrganizationListUpsertResult"];
	['...on PostOrganizationListItemCreateResult']: '__union' & GraphQLTypes["PostOrganizationListItemCreateResult"];
	['...on PostOrganizationListItemDeleteResult']: '__union' & GraphQLTypes["PostOrganizationListItemDeleteResult"];
	['...on PostOrganizationListItemUpdateResult']: '__union' & GraphQLTypes["PostOrganizationListItemUpdateResult"];
	['...on PostOrganizationListItemUpsertResult']: '__union' & GraphQLTypes["PostOrganizationListItemUpsertResult"];
	['...on InfoCarouselCreateResult']: '__union' & GraphQLTypes["InfoCarouselCreateResult"];
	['...on InfoCarouselDeleteResult']: '__union' & GraphQLTypes["InfoCarouselDeleteResult"];
	['...on InfoCarouselUpdateResult']: '__union' & GraphQLTypes["InfoCarouselUpdateResult"];
	['...on InfoCarouselUpsertResult']: '__union' & GraphQLTypes["InfoCarouselUpsertResult"];
	['...on InfoCarouselItemCreateResult']: '__union' & GraphQLTypes["InfoCarouselItemCreateResult"];
	['...on InfoCarouselItemDeleteResult']: '__union' & GraphQLTypes["InfoCarouselItemDeleteResult"];
	['...on InfoCarouselItemUpdateResult']: '__union' & GraphQLTypes["InfoCarouselItemUpdateResult"];
	['...on InfoCarouselItemUpsertResult']: '__union' & GraphQLTypes["InfoCarouselItemUpsertResult"];
	['...on PersonSeenInfoCarouselCreateResult']: '__union' & GraphQLTypes["PersonSeenInfoCarouselCreateResult"];
	['...on PersonSeenInfoCarouselDeleteResult']: '__union' & GraphQLTypes["PersonSeenInfoCarouselDeleteResult"];
	['...on PersonSeenInfoCarouselUpdateResult']: '__union' & GraphQLTypes["PersonSeenInfoCarouselUpdateResult"];
	['...on PersonSeenInfoCarouselUpsertResult']: '__union' & GraphQLTypes["PersonSeenInfoCarouselUpsertResult"];
	['...on GivenGiftsPageCreateResult']: '__union' & GraphQLTypes["GivenGiftsPageCreateResult"];
	['...on GivenGiftsPageDeleteResult']: '__union' & GraphQLTypes["GivenGiftsPageDeleteResult"];
	['...on GivenGiftsPageUpdateResult']: '__union' & GraphQLTypes["GivenGiftsPageUpdateResult"];
	['...on GivenGiftsPageUpsertResult']: '__union' & GraphQLTypes["GivenGiftsPageUpsertResult"];
	['...on GivenGiftsPageLocaleCreateResult']: '__union' & GraphQLTypes["GivenGiftsPageLocaleCreateResult"];
	['...on GivenGiftsPageLocaleDeleteResult']: '__union' & GraphQLTypes["GivenGiftsPageLocaleDeleteResult"];
	['...on GivenGiftsPageLocaleUpdateResult']: '__union' & GraphQLTypes["GivenGiftsPageLocaleUpdateResult"];
	['...on GivenGiftsPageLocaleUpsertResult']: '__union' & GraphQLTypes["GivenGiftsPageLocaleUpsertResult"];
	['...on ReceivedGiftsPageCreateResult']: '__union' & GraphQLTypes["ReceivedGiftsPageCreateResult"];
	['...on ReceivedGiftsPageDeleteResult']: '__union' & GraphQLTypes["ReceivedGiftsPageDeleteResult"];
	['...on ReceivedGiftsPageUpdateResult']: '__union' & GraphQLTypes["ReceivedGiftsPageUpdateResult"];
	['...on ReceivedGiftsPageUpsertResult']: '__union' & GraphQLTypes["ReceivedGiftsPageUpsertResult"];
	['...on ReceivedGiftsPageLocaleCreateResult']: '__union' & GraphQLTypes["ReceivedGiftsPageLocaleCreateResult"];
	['...on ReceivedGiftsPageLocaleDeleteResult']: '__union' & GraphQLTypes["ReceivedGiftsPageLocaleDeleteResult"];
	['...on ReceivedGiftsPageLocaleUpdateResult']: '__union' & GraphQLTypes["ReceivedGiftsPageLocaleUpdateResult"];
	['...on ReceivedGiftsPageLocaleUpsertResult']: '__union' & GraphQLTypes["ReceivedGiftsPageLocaleUpsertResult"];
	['...on ReportNavigationCreateResult']: '__union' & GraphQLTypes["ReportNavigationCreateResult"];
	['...on ReportNavigationDeleteResult']: '__union' & GraphQLTypes["ReportNavigationDeleteResult"];
	['...on ReportNavigationUpdateResult']: '__union' & GraphQLTypes["ReportNavigationUpdateResult"];
	['...on ReportNavigationUpsertResult']: '__union' & GraphQLTypes["ReportNavigationUpsertResult"];
	['...on ReportPageCreateResult']: '__union' & GraphQLTypes["ReportPageCreateResult"];
	['...on ReportPageDeleteResult']: '__union' & GraphQLTypes["ReportPageDeleteResult"];
	['...on ReportPageUpdateResult']: '__union' & GraphQLTypes["ReportPageUpdateResult"];
	['...on ReportPageUpsertResult']: '__union' & GraphQLTypes["ReportPageUpsertResult"];
	['...on ReportPageLocaleCreateResult']: '__union' & GraphQLTypes["ReportPageLocaleCreateResult"];
	['...on ReportPageLocaleDeleteResult']: '__union' & GraphQLTypes["ReportPageLocaleDeleteResult"];
	['...on ReportPageLocaleUpdateResult']: '__union' & GraphQLTypes["ReportPageLocaleUpdateResult"];
	['...on ReportPageLocaleUpsertResult']: '__union' & GraphQLTypes["ReportPageLocaleUpsertResult"];
	['...on ReportNavigationLocaleCreateResult']: '__union' & GraphQLTypes["ReportNavigationLocaleCreateResult"];
	['...on ReportNavigationLocaleDeleteResult']: '__union' & GraphQLTypes["ReportNavigationLocaleDeleteResult"];
	['...on ReportNavigationLocaleUpdateResult']: '__union' & GraphQLTypes["ReportNavigationLocaleUpdateResult"];
	['...on ReportNavigationLocaleUpsertResult']: '__union' & GraphQLTypes["ReportNavigationLocaleUpsertResult"];
	['...on SentPaymentCreateResult']: '__union' & GraphQLTypes["SentPaymentCreateResult"];
	['...on SentPaymentDeleteResult']: '__union' & GraphQLTypes["SentPaymentDeleteResult"];
	['...on SentPaymentUpdateResult']: '__union' & GraphQLTypes["SentPaymentUpdateResult"];
	['...on SentPaymentUpsertResult']: '__union' & GraphQLTypes["SentPaymentUpsertResult"];
	['...on NotificationTargetGroupCreateResult']: '__union' & GraphQLTypes["NotificationTargetGroupCreateResult"];
	['...on NotificationTargetGroupDeleteResult']: '__union' & GraphQLTypes["NotificationTargetGroupDeleteResult"];
	['...on NotificationTargetGroupUpdateResult']: '__union' & GraphQLTypes["NotificationTargetGroupUpdateResult"];
	['...on NotificationTargetGroupUpsertResult']: '__union' & GraphQLTypes["NotificationTargetGroupUpsertResult"];
	['...on ProcessedNotificationCreateResult']: '__union' & GraphQLTypes["ProcessedNotificationCreateResult"];
	['...on ProcessedNotificationDeleteResult']: '__union' & GraphQLTypes["ProcessedNotificationDeleteResult"];
	['...on ProcessedNotificationUpdateResult']: '__union' & GraphQLTypes["ProcessedNotificationUpdateResult"];
	['...on ProcessedNotificationUpsertResult']: '__union' & GraphQLTypes["ProcessedNotificationUpsertResult"];
	['...on ScheduledNotificationCreateResult']: '__union' & GraphQLTypes["ScheduledNotificationCreateResult"];
	['...on ScheduledNotificationDeleteResult']: '__union' & GraphQLTypes["ScheduledNotificationDeleteResult"];
	['...on ScheduledNotificationUpdateResult']: '__union' & GraphQLTypes["ScheduledNotificationUpdateResult"];
	['...on ScheduledNotificationUpsertResult']: '__union' & GraphQLTypes["ScheduledNotificationUpsertResult"];
	['...on ProcessedNotificationSourceCreateResult']: '__union' & GraphQLTypes["ProcessedNotificationSourceCreateResult"];
	['...on ProcessedNotificationSourceDeleteResult']: '__union' & GraphQLTypes["ProcessedNotificationSourceDeleteResult"];
	['...on ProcessedNotificationSourceUpdateResult']: '__union' & GraphQLTypes["ProcessedNotificationSourceUpdateResult"];
	['...on ProcessedNotificationSourceUpsertResult']: '__union' & GraphQLTypes["ProcessedNotificationSourceUpsertResult"];
	['...on DeviceCreateResult']: '__union' & GraphQLTypes["DeviceCreateResult"];
	['...on DeviceDeleteResult']: '__union' & GraphQLTypes["DeviceDeleteResult"];
	['...on DeviceUpdateResult']: '__union' & GraphQLTypes["DeviceUpdateResult"];
	['...on DeviceUpsertResult']: '__union' & GraphQLTypes["DeviceUpsertResult"];
	['...on ScheduledNotificationLocaleCreateResult']: '__union' & GraphQLTypes["ScheduledNotificationLocaleCreateResult"];
	['...on ScheduledNotificationLocaleDeleteResult']: '__union' & GraphQLTypes["ScheduledNotificationLocaleDeleteResult"];
	['...on ScheduledNotificationLocaleUpdateResult']: '__union' & GraphQLTypes["ScheduledNotificationLocaleUpdateResult"];
	['...on ScheduledNotificationLocaleUpsertResult']: '__union' & GraphQLTypes["ScheduledNotificationLocaleUpsertResult"];
	['...on InfoCarouselItemLocaleCreateResult']: '__union' & GraphQLTypes["InfoCarouselItemLocaleCreateResult"];
	['...on InfoCarouselItemLocaleDeleteResult']: '__union' & GraphQLTypes["InfoCarouselItemLocaleDeleteResult"];
	['...on InfoCarouselItemLocaleUpdateResult']: '__union' & GraphQLTypes["InfoCarouselItemLocaleUpdateResult"];
	['...on InfoCarouselItemLocaleUpsertResult']: '__union' & GraphQLTypes["InfoCarouselItemLocaleUpsertResult"];
	['...on SentPaymentLocaleCreateResult']: '__union' & GraphQLTypes["SentPaymentLocaleCreateResult"];
	['...on SentPaymentLocaleDeleteResult']: '__union' & GraphQLTypes["SentPaymentLocaleDeleteResult"];
	['...on SentPaymentLocaleUpdateResult']: '__union' & GraphQLTypes["SentPaymentLocaleUpdateResult"];
	['...on SentPaymentLocaleUpsertResult']: '__union' & GraphQLTypes["SentPaymentLocaleUpsertResult"];
	['...on TextImageListCreateResult']: '__union' & GraphQLTypes["TextImageListCreateResult"];
	['...on TextImageListDeleteResult']: '__union' & GraphQLTypes["TextImageListDeleteResult"];
	['...on TextImageListUpdateResult']: '__union' & GraphQLTypes["TextImageListUpdateResult"];
	['...on TextImageListUpsertResult']: '__union' & GraphQLTypes["TextImageListUpsertResult"];
	['...on TextImageListItemCreateResult']: '__union' & GraphQLTypes["TextImageListItemCreateResult"];
	['...on TextImageListItemDeleteResult']: '__union' & GraphQLTypes["TextImageListItemDeleteResult"];
	['...on TextImageListItemUpdateResult']: '__union' & GraphQLTypes["TextImageListItemUpdateResult"];
	['...on TextImageListItemUpsertResult']: '__union' & GraphQLTypes["TextImageListItemUpsertResult"];
	['...on HeroCarouselItemCreateResult']: '__union' & GraphQLTypes["HeroCarouselItemCreateResult"];
	['...on HeroCarouselItemDeleteResult']: '__union' & GraphQLTypes["HeroCarouselItemDeleteResult"];
	['...on HeroCarouselItemUpdateResult']: '__union' & GraphQLTypes["HeroCarouselItemUpdateResult"];
	['...on HeroCarouselItemUpsertResult']: '__union' & GraphQLTypes["HeroCarouselItemUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<Array<GraphQLTypes["_PathFragment"]>>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string | undefined
};
	["_MutationErrorType"]: _MutationErrorType;
	["GeneralDeleteResult"]: {
	__typename: "GeneralDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["General"] | undefined
};
	["GeneralUpdateResult"]: {
	__typename: "GeneralUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["General"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GeneralUpsertResult"]: {
	__typename: "GeneralUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["General"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageCreateResult"]: {
	__typename: "GenericPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageDeleteResult"]: {
	__typename: "GenericPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"] | undefined
};
	["GenericPageUpdateResult"]: {
	__typename: "GenericPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageUpsertResult"]: {
	__typename: "GenericPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GeneralLocaleCreateResult"]: {
	__typename: "GeneralLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GeneralLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GeneralLocaleDeleteResult"]: {
	__typename: "GeneralLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GeneralLocale"] | undefined
};
	["GeneralLocaleUpdateResult"]: {
	__typename: "GeneralLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GeneralLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GeneralLocaleUpsertResult"]: {
	__typename: "GeneralLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GeneralLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageLocaleCreateResult"]: {
	__typename: "GenericPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageLocaleDeleteResult"]: {
	__typename: "GenericPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageLocale"] | undefined
};
	["GenericPageLocaleUpdateResult"]: {
	__typename: "GenericPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageLocaleUpsertResult"]: {
	__typename: "GenericPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
	__typename: "LocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
	__typename: "LocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined
};
	["LocaleUpdateResult"]: {
	__typename: "LocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
	__typename: "LocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
	__typename: "VideoCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
	__typename: "VideoDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined
};
	["VideoUpdateResult"]: {
	__typename: "VideoUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
	__typename: "VideoUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostCreateResult"]: {
	__typename: "PostCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Post"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostDeleteResult"]: {
	__typename: "PostDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Post"] | undefined
};
	["PostUpdateResult"]: {
	__typename: "PostUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Post"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostUpsertResult"]: {
	__typename: "PostUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Post"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostLocaleCreateResult"]: {
	__typename: "PostLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostLocaleDeleteResult"]: {
	__typename: "PostLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostLocale"] | undefined
};
	["PostLocaleUpdateResult"]: {
	__typename: "PostLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostLocaleUpsertResult"]: {
	__typename: "PostLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaCreateResult"]: {
	__typename: "PostAreaCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostArea"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaDeleteResult"]: {
	__typename: "PostAreaDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostArea"] | undefined
};
	["PostAreaUpdateResult"]: {
	__typename: "PostAreaUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostArea"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaUpsertResult"]: {
	__typename: "PostAreaUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostArea"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaLocaleCreateResult"]: {
	__typename: "PostAreaLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaLocaleDeleteResult"]: {
	__typename: "PostAreaLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaLocale"] | undefined
};
	["PostAreaLocaleUpdateResult"]: {
	__typename: "PostAreaLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaLocaleUpsertResult"]: {
	__typename: "PostAreaLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationCreateResult"]: {
	__typename: "PostOrganizationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganization"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationDeleteResult"]: {
	__typename: "PostOrganizationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganization"] | undefined
};
	["PostOrganizationUpdateResult"]: {
	__typename: "PostOrganizationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganization"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationUpsertResult"]: {
	__typename: "PostOrganizationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganization"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationLocaleCreateResult"]: {
	__typename: "PostOrganizationLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationLocaleDeleteResult"]: {
	__typename: "PostOrganizationLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationLocale"] | undefined
};
	["PostOrganizationLocaleUpdateResult"]: {
	__typename: "PostOrganizationLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationLocaleUpsertResult"]: {
	__typename: "PostOrganizationLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationCreateResult"]: {
	__typename: "DonationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Donation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationDeleteResult"]: {
	__typename: "DonationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Donation"] | undefined
};
	["DonationUpdateResult"]: {
	__typename: "DonationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Donation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationUpsertResult"]: {
	__typename: "DonationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Donation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountItemCreateResult"]: {
	__typename: "DonationAmountItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountItemDeleteResult"]: {
	__typename: "DonationAmountItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountItem"] | undefined
};
	["DonationAmountItemUpdateResult"]: {
	__typename: "DonationAmountItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountItemUpsertResult"]: {
	__typename: "DonationAmountItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountsRegionItemCreateResult"]: {
	__typename: "DonationAmountsRegionItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountsRegionItemDeleteResult"]: {
	__typename: "DonationAmountsRegionItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountsRegionItem"] | undefined
};
	["DonationAmountsRegionItemUpdateResult"]: {
	__typename: "DonationAmountsRegionItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountsRegionItemUpsertResult"]: {
	__typename: "DonationAmountsRegionItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountsRegionItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountsRegionListCreateResult"]: {
	__typename: "DonationAmountsRegionListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountsRegionList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountsRegionListDeleteResult"]: {
	__typename: "DonationAmountsRegionListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountsRegionList"] | undefined
};
	["DonationAmountsRegionListUpdateResult"]: {
	__typename: "DonationAmountsRegionListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountsRegionList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DonationAmountsRegionListUpsertResult"]: {
	__typename: "DonationAmountsRegionListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DonationAmountsRegionList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionCreateResult"]: {
	__typename: "RegionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Region"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionDeleteResult"]: {
	__typename: "RegionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Region"] | undefined
};
	["RegionUpdateResult"]: {
	__typename: "RegionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Region"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionUpsertResult"]: {
	__typename: "RegionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Region"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemCreateResult"]: {
	__typename: "LinkItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemDeleteResult"]: {
	__typename: "LinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"] | undefined
};
	["LinkItemUpdateResult"]: {
	__typename: "LinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemUpsertResult"]: {
	__typename: "LinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
	__typename: "LinkListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
	__typename: "LinkListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined
};
	["LinkListUpdateResult"]: {
	__typename: "LinkListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
	__typename: "LinkListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
	__typename: "HeaderCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
	__typename: "HeaderDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"] | undefined
};
	["HeaderUpdateResult"]: {
	__typename: "HeaderUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
	__typename: "HeaderUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleCreateResult"]: {
	__typename: "HeaderLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleDeleteResult"]: {
	__typename: "HeaderLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"] | undefined
};
	["HeaderLocaleUpdateResult"]: {
	__typename: "HeaderLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleUpsertResult"]: {
	__typename: "HeaderLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"] | undefined
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleCreateResult"]: {
	__typename: "FooterLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleDeleteResult"]: {
	__typename: "FooterLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"] | undefined
};
	["FooterLocaleUpdateResult"]: {
	__typename: "FooterLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleUpsertResult"]: {
	__typename: "FooterLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostListCreateResult"]: {
	__typename: "PostListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostListDeleteResult"]: {
	__typename: "PostListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostList"] | undefined
};
	["PostListUpdateResult"]: {
	__typename: "PostListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostListUpsertResult"]: {
	__typename: "PostListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostListItemCreateResult"]: {
	__typename: "PostListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostListItemDeleteResult"]: {
	__typename: "PostListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostListItem"] | undefined
};
	["PostListItemUpdateResult"]: {
	__typename: "PostListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostListItemUpsertResult"]: {
	__typename: "PostListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppBannerCreateResult"]: {
	__typename: "AppBannerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppBannerDeleteResult"]: {
	__typename: "AppBannerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppBanner"] | undefined
};
	["AppBannerUpdateResult"]: {
	__typename: "AppBannerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppBannerUpsertResult"]: {
	__typename: "AppBannerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsCreateResult"]: {
	__typename: "GenericPageAboutSettingsCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutSettings"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsDeleteResult"]: {
	__typename: "GenericPageAboutSettingsDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutSettings"] | undefined
};
	["GenericPageAboutSettingsUpdateResult"]: {
	__typename: "GenericPageAboutSettingsUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutSettings"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsUpsertResult"]: {
	__typename: "GenericPageAboutSettingsUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutSettings"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsLocaleCreateResult"]: {
	__typename: "GenericPageAboutSettingsLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsLocaleDeleteResult"]: {
	__typename: "GenericPageAboutSettingsLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined
};
	["GenericPageAboutSettingsLocaleUpdateResult"]: {
	__typename: "GenericPageAboutSettingsLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutSettingsLocaleUpsertResult"]: {
	__typename: "GenericPageAboutSettingsLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutSettingsLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueCreateResult"]: {
	__typename: "ValueCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Value"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueDeleteResult"]: {
	__typename: "ValueDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Value"] | undefined
};
	["ValueUpdateResult"]: {
	__typename: "ValueUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Value"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueUpsertResult"]: {
	__typename: "ValueUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Value"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueItemCreateResult"]: {
	__typename: "ValueItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ValueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueItemDeleteResult"]: {
	__typename: "ValueItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ValueItem"] | undefined
};
	["ValueItemUpdateResult"]: {
	__typename: "ValueItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ValueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueItemUpsertResult"]: {
	__typename: "ValueItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ValueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueListCreateResult"]: {
	__typename: "ValueListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ValueList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueListDeleteResult"]: {
	__typename: "ValueListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ValueList"] | undefined
};
	["ValueListUpdateResult"]: {
	__typename: "ValueListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ValueList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ValueListUpsertResult"]: {
	__typename: "ValueListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ValueList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkCreateResult"]: {
	__typename: "ImageLinkCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLink"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkDeleteResult"]: {
	__typename: "ImageLinkDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLink"] | undefined
};
	["ImageLinkUpdateResult"]: {
	__typename: "ImageLinkUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLink"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkUpsertResult"]: {
	__typename: "ImageLinkUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLink"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkItemCreateResult"]: {
	__typename: "ImageLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkItemDeleteResult"]: {
	__typename: "ImageLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLinkItem"] | undefined
};
	["ImageLinkItemUpdateResult"]: {
	__typename: "ImageLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkItemUpsertResult"]: {
	__typename: "ImageLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkListCreateResult"]: {
	__typename: "ImageLinkListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkListDeleteResult"]: {
	__typename: "ImageLinkListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLinkList"] | undefined
};
	["ImageLinkListUpdateResult"]: {
	__typename: "ImageLinkListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageLinkListUpsertResult"]: {
	__typename: "ImageLinkListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaListCreateResult"]: {
	__typename: "PostAreaListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaListDeleteResult"]: {
	__typename: "PostAreaListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaList"] | undefined
};
	["PostAreaListUpdateResult"]: {
	__typename: "PostAreaListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaListUpsertResult"]: {
	__typename: "PostAreaListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaListItemCreateResult"]: {
	__typename: "PostAreaListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaListItemDeleteResult"]: {
	__typename: "PostAreaListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaListItem"] | undefined
};
	["PostAreaListItemUpdateResult"]: {
	__typename: "PostAreaListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostAreaListItemUpsertResult"]: {
	__typename: "PostAreaListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostAreaListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AccordionCreateResult"]: {
	__typename: "AccordionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Accordion"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AccordionDeleteResult"]: {
	__typename: "AccordionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Accordion"] | undefined
};
	["AccordionUpdateResult"]: {
	__typename: "AccordionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Accordion"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AccordionUpsertResult"]: {
	__typename: "AccordionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Accordion"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AccordionItemCreateResult"]: {
	__typename: "AccordionItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AccordionItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AccordionItemDeleteResult"]: {
	__typename: "AccordionItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AccordionItem"] | undefined
};
	["AccordionItemUpdateResult"]: {
	__typename: "AccordionItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AccordionItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AccordionItemUpsertResult"]: {
	__typename: "AccordionItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AccordionItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserCreateResult"]: {
	__typename: "UserCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeleteResult"]: {
	__typename: "UserDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined
};
	["UserUpdateResult"]: {
	__typename: "UserUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserUpsertResult"]: {
	__typename: "UserUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentCreateResult"]: {
	__typename: "UserPaymentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentDeleteResult"]: {
	__typename: "UserPaymentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPayment"] | undefined
};
	["UserPaymentUpdateResult"]: {
	__typename: "UserPaymentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentUpsertResult"]: {
	__typename: "UserPaymentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CurrencyCreateResult"]: {
	__typename: "CurrencyCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Currency"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CurrencyDeleteResult"]: {
	__typename: "CurrencyDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Currency"] | undefined
};
	["CurrencyUpdateResult"]: {
	__typename: "CurrencyUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Currency"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CurrencyUpsertResult"]: {
	__typename: "CurrencyUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Currency"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
	__typename: "MediumCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
	__typename: "MediumDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined
};
	["MediumUpdateResult"]: {
	__typename: "MediumUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
	__typename: "MediumUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemCreateResult"]: {
	__typename: "MediumItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemDeleteResult"]: {
	__typename: "MediumItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"] | undefined
};
	["MediumItemUpdateResult"]: {
	__typename: "MediumItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemUpsertResult"]: {
	__typename: "MediumItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListCreateResult"]: {
	__typename: "MediumListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListDeleteResult"]: {
	__typename: "MediumListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"] | undefined
};
	["MediumListUpdateResult"]: {
	__typename: "MediumListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListUpsertResult"]: {
	__typename: "MediumListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentOrderIdCreateResult"]: {
	__typename: "UserPaymentOrderIdCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPaymentOrderId"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentOrderIdDeleteResult"]: {
	__typename: "UserPaymentOrderIdDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPaymentOrderId"] | undefined
};
	["UserPaymentOrderIdUpdateResult"]: {
	__typename: "UserPaymentOrderIdUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPaymentOrderId"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentOrderIdUpsertResult"]: {
	__typename: "UserPaymentOrderIdUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPaymentOrderId"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostRevisionCreateResult"]: {
	__typename: "PostRevisionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostRevision"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostRevisionDeleteResult"]: {
	__typename: "PostRevisionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostRevision"] | undefined
};
	["PostRevisionUpdateResult"]: {
	__typename: "PostRevisionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostRevision"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostRevisionUpsertResult"]: {
	__typename: "PostRevisionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostRevision"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserRecurringPaymentCreateResult"]: {
	__typename: "UserRecurringPaymentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserRecurringPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserRecurringPaymentDeleteResult"]: {
	__typename: "UserRecurringPaymentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserRecurringPayment"] | undefined
};
	["UserRecurringPaymentUpdateResult"]: {
	__typename: "UserRecurringPaymentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserRecurringPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserRecurringPaymentUpsertResult"]: {
	__typename: "UserRecurringPaymentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserRecurringPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserRecurringPaymentItemCreateResult"]: {
	__typename: "UserRecurringPaymentItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserRecurringPaymentItemDeleteResult"]: {
	__typename: "UserRecurringPaymentItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserRecurringPaymentItem"] | undefined
};
	["UserRecurringPaymentItemUpdateResult"]: {
	__typename: "UserRecurringPaymentItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserRecurringPaymentItemUpsertResult"]: {
	__typename: "UserRecurringPaymentItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserRecurringPaymentItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostRevisionLocaleCreateResult"]: {
	__typename: "PostRevisionLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostRevisionLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostRevisionLocaleDeleteResult"]: {
	__typename: "PostRevisionLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostRevisionLocale"] | undefined
};
	["PostRevisionLocaleUpdateResult"]: {
	__typename: "PostRevisionLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostRevisionLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostRevisionLocaleUpsertResult"]: {
	__typename: "PostRevisionLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostRevisionLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueCreateResult"]: {
	__typename: "TranslationCatalogueCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueDeleteResult"]: {
	__typename: "TranslationCatalogueDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined
};
	["TranslationCatalogueUpdateResult"]: {
	__typename: "TranslationCatalogueUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueUpsertResult"]: {
	__typename: "TranslationCatalogueUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierCreateResult"]: {
	__typename: "TranslationCataloguesIdentifierCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierDeleteResult"]: {
	__typename: "TranslationCataloguesIdentifierDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined
};
	["TranslationCataloguesIdentifierUpdateResult"]: {
	__typename: "TranslationCataloguesIdentifierUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierUpsertResult"]: {
	__typename: "TranslationCataloguesIdentifierUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainCreateResult"]: {
	__typename: "TranslationDomainCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainDeleteResult"]: {
	__typename: "TranslationDomainDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined
};
	["TranslationDomainUpdateResult"]: {
	__typename: "TranslationDomainUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainUpsertResult"]: {
	__typename: "TranslationDomainUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyCreateResult"]: {
	__typename: "TranslationKeyCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyDeleteResult"]: {
	__typename: "TranslationKeyDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined
};
	["TranslationKeyUpdateResult"]: {
	__typename: "TranslationKeyUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyUpsertResult"]: {
	__typename: "TranslationKeyUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueCreateResult"]: {
	__typename: "TranslationValueCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueDeleteResult"]: {
	__typename: "TranslationValueDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined
};
	["TranslationValueUpdateResult"]: {
	__typename: "TranslationValueUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueUpsertResult"]: {
	__typename: "TranslationValueUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutGroupLinksLocaleCreateResult"]: {
	__typename: "GenericPageAboutGroupLinksLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutGroupLinksLocaleDeleteResult"]: {
	__typename: "GenericPageAboutGroupLinksLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutGroupLinksLocale"] | undefined
};
	["GenericPageAboutGroupLinksLocaleUpdateResult"]: {
	__typename: "GenericPageAboutGroupLinksLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageAboutGroupLinksLocaleUpsertResult"]: {
	__typename: "GenericPageAboutGroupLinksLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageAboutGroupLinksLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListCreateResult"]: {
	__typename: "MemberListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListDeleteResult"]: {
	__typename: "MemberListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberList"] | undefined
};
	["MemberListUpdateResult"]: {
	__typename: "MemberListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListUpsertResult"]: {
	__typename: "MemberListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListItemCreateResult"]: {
	__typename: "MemberListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListItemDeleteResult"]: {
	__typename: "MemberListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberListItem"] | undefined
};
	["MemberListItemUpdateResult"]: {
	__typename: "MemberListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListItemUpsertResult"]: {
	__typename: "MemberListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilledTaxFormCreateResult"]: {
	__typename: "FilledTaxFormCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilledTaxForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilledTaxFormDeleteResult"]: {
	__typename: "FilledTaxFormDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilledTaxForm"] | undefined
};
	["FilledTaxFormUpdateResult"]: {
	__typename: "FilledTaxFormUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilledTaxForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilledTaxFormUpsertResult"]: {
	__typename: "FilledTaxFormUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilledTaxForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilledTaxFormEmailAddressCreateResult"]: {
	__typename: "FilledTaxFormEmailAddressCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilledTaxFormEmailAddress"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilledTaxFormEmailAddressDeleteResult"]: {
	__typename: "FilledTaxFormEmailAddressDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilledTaxFormEmailAddress"] | undefined
};
	["FilledTaxFormEmailAddressUpdateResult"]: {
	__typename: "FilledTaxFormEmailAddressUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilledTaxFormEmailAddress"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilledTaxFormEmailAddressUpsertResult"]: {
	__typename: "FilledTaxFormEmailAddressUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilledTaxFormEmailAddress"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FormCreateResult"]: {
	__typename: "FormCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Form"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FormDeleteResult"]: {
	__typename: "FormDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Form"] | undefined
};
	["FormUpdateResult"]: {
	__typename: "FormUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Form"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FormUpsertResult"]: {
	__typename: "FormUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Form"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CsobPaymentCreateResult"]: {
	__typename: "CsobPaymentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CsobPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CsobPaymentDeleteResult"]: {
	__typename: "CsobPaymentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CsobPayment"] | undefined
};
	["CsobPaymentUpdateResult"]: {
	__typename: "CsobPaymentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CsobPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CsobPaymentUpsertResult"]: {
	__typename: "CsobPaymentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CsobPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CsobPaymentStatusChangeCreateResult"]: {
	__typename: "CsobPaymentStatusChangeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CsobPaymentStatusChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CsobPaymentStatusChangeDeleteResult"]: {
	__typename: "CsobPaymentStatusChangeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CsobPaymentStatusChange"] | undefined
};
	["CsobPaymentStatusChangeUpdateResult"]: {
	__typename: "CsobPaymentStatusChangeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CsobPaymentStatusChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CsobPaymentStatusChangeUpsertResult"]: {
	__typename: "CsobPaymentStatusChangeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CsobPaymentStatusChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StripePaymentCreateResult"]: {
	__typename: "StripePaymentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StripePayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StripePaymentDeleteResult"]: {
	__typename: "StripePaymentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StripePayment"] | undefined
};
	["StripePaymentUpdateResult"]: {
	__typename: "StripePaymentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StripePayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StripePaymentUpsertResult"]: {
	__typename: "StripePaymentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StripePayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StripePaymentStatusChangeCreateResult"]: {
	__typename: "StripePaymentStatusChangeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StripePaymentStatusChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StripePaymentStatusChangeDeleteResult"]: {
	__typename: "StripePaymentStatusChangeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StripePaymentStatusChange"] | undefined
};
	["StripePaymentStatusChangeUpdateResult"]: {
	__typename: "StripePaymentStatusChangeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StripePaymentStatusChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StripePaymentStatusChangeUpsertResult"]: {
	__typename: "StripePaymentStatusChangeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StripePaymentStatusChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionPaymentMethodCreateResult"]: {
	__typename: "RegionPaymentMethodCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegionPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionPaymentMethodDeleteResult"]: {
	__typename: "RegionPaymentMethodDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegionPaymentMethod"] | undefined
};
	["RegionPaymentMethodUpdateResult"]: {
	__typename: "RegionPaymentMethodUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegionPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionPaymentMethodUpsertResult"]: {
	__typename: "RegionPaymentMethodUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegionPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileItemCreateResult"]: {
	__typename: "TileItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileItemDeleteResult"]: {
	__typename: "TileItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TileItem"] | undefined
};
	["TileItemUpdateResult"]: {
	__typename: "TileItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileItemUpsertResult"]: {
	__typename: "TileItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileListCreateResult"]: {
	__typename: "TileListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TileList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileListDeleteResult"]: {
	__typename: "TileListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TileList"] | undefined
};
	["TileListUpdateResult"]: {
	__typename: "TileListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TileList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileListUpsertResult"]: {
	__typename: "TileListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TileList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageCreateResult"]: {
	__typename: "FeedPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageDeleteResult"]: {
	__typename: "FeedPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPage"] | undefined
};
	["FeedPageUpdateResult"]: {
	__typename: "FeedPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageUpsertResult"]: {
	__typename: "FeedPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageLocaleCreateResult"]: {
	__typename: "FeedPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageLocaleDeleteResult"]: {
	__typename: "FeedPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageLocale"] | undefined
};
	["FeedPageLocaleUpdateResult"]: {
	__typename: "FeedPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageLocaleUpsertResult"]: {
	__typename: "FeedPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageSectionCreateResult"]: {
	__typename: "FeedPageSectionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageSection"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageSectionDeleteResult"]: {
	__typename: "FeedPageSectionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageSection"] | undefined
};
	["FeedPageSectionUpdateResult"]: {
	__typename: "FeedPageSectionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageSection"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageSectionUpsertResult"]: {
	__typename: "FeedPageSectionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageSection"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageTileStripeCreateResult"]: {
	__typename: "FeedPageTileStripeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageTileStripe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageTileStripeDeleteResult"]: {
	__typename: "FeedPageTileStripeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageTileStripe"] | undefined
};
	["FeedPageTileStripeUpdateResult"]: {
	__typename: "FeedPageTileStripeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageTileStripe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FeedPageTileStripeUpsertResult"]: {
	__typename: "FeedPageTileStripeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FeedPageTileStripe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardItemCreateResult"]: {
	__typename: "CardItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardItemDeleteResult"]: {
	__typename: "CardItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardItem"] | undefined
};
	["CardItemUpdateResult"]: {
	__typename: "CardItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardItemUpsertResult"]: {
	__typename: "CardItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardListCreateResult"]: {
	__typename: "CardListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardListDeleteResult"]: {
	__typename: "CardListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardList"] | undefined
};
	["CardListUpdateResult"]: {
	__typename: "CardListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardListUpsertResult"]: {
	__typename: "CardListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OnBehalfDonationCreateResult"]: {
	__typename: "OnBehalfDonationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OnBehalfDonation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OnBehalfDonationDeleteResult"]: {
	__typename: "OnBehalfDonationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OnBehalfDonation"] | undefined
};
	["OnBehalfDonationUpdateResult"]: {
	__typename: "OnBehalfDonationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OnBehalfDonation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OnBehalfDonationUpsertResult"]: {
	__typename: "OnBehalfDonationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OnBehalfDonation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentTriesCollectionCreateResult"]: {
	__typename: "UserPaymentTriesCollectionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPaymentTriesCollection"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentTriesCollectionDeleteResult"]: {
	__typename: "UserPaymentTriesCollectionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPaymentTriesCollection"] | undefined
};
	["UserPaymentTriesCollectionUpdateResult"]: {
	__typename: "UserPaymentTriesCollectionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPaymentTriesCollection"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserPaymentTriesCollectionUpsertResult"]: {
	__typename: "UserPaymentTriesCollectionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserPaymentTriesCollection"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecurringPaymentPageCreateResult"]: {
	__typename: "RecurringPaymentPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecurringPaymentPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecurringPaymentPageDeleteResult"]: {
	__typename: "RecurringPaymentPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecurringPaymentPage"] | undefined
};
	["RecurringPaymentPageUpdateResult"]: {
	__typename: "RecurringPaymentPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecurringPaymentPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecurringPaymentPageUpsertResult"]: {
	__typename: "RecurringPaymentPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecurringPaymentPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecurringPaymentPageLocaleCreateResult"]: {
	__typename: "RecurringPaymentPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecurringPaymentPageLocaleDeleteResult"]: {
	__typename: "RecurringPaymentPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined
};
	["RecurringPaymentPageLocaleUpdateResult"]: {
	__typename: "RecurringPaymentPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecurringPaymentPageLocaleUpsertResult"]: {
	__typename: "RecurringPaymentPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecurringPaymentPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideCreateResult"]: {
	__typename: "StoryGuideCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideDeleteResult"]: {
	__typename: "StoryGuideDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuide"] | undefined
};
	["StoryGuideUpdateResult"]: {
	__typename: "StoryGuideUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideUpsertResult"]: {
	__typename: "StoryGuideUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideItemCreateResult"]: {
	__typename: "StoryGuideItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuideItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideItemDeleteResult"]: {
	__typename: "StoryGuideItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuideItem"] | undefined
};
	["StoryGuideItemUpdateResult"]: {
	__typename: "StoryGuideItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuideItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideItemUpsertResult"]: {
	__typename: "StoryGuideItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuideItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideListCreateResult"]: {
	__typename: "StoryGuideListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuideList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideListDeleteResult"]: {
	__typename: "StoryGuideListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuideList"] | undefined
};
	["StoryGuideListUpdateResult"]: {
	__typename: "StoryGuideListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuideList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoryGuideListUpsertResult"]: {
	__typename: "StoryGuideListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoryGuideList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCarouselCreateResult"]: {
	__typename: "HeroCarouselCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeroCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCarouselDeleteResult"]: {
	__typename: "HeroCarouselDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeroCarousel"] | undefined
};
	["HeroCarouselUpdateResult"]: {
	__typename: "HeroCarouselUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeroCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCarouselUpsertResult"]: {
	__typename: "HeroCarouselUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeroCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationListCreateResult"]: {
	__typename: "PostOrganizationListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationListDeleteResult"]: {
	__typename: "PostOrganizationListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationList"] | undefined
};
	["PostOrganizationListUpdateResult"]: {
	__typename: "PostOrganizationListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationListUpsertResult"]: {
	__typename: "PostOrganizationListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationListItemCreateResult"]: {
	__typename: "PostOrganizationListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationListItemDeleteResult"]: {
	__typename: "PostOrganizationListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationListItem"] | undefined
};
	["PostOrganizationListItemUpdateResult"]: {
	__typename: "PostOrganizationListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PostOrganizationListItemUpsertResult"]: {
	__typename: "PostOrganizationListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PostOrganizationListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselCreateResult"]: {
	__typename: "InfoCarouselCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselDeleteResult"]: {
	__typename: "InfoCarouselDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarousel"] | undefined
};
	["InfoCarouselUpdateResult"]: {
	__typename: "InfoCarouselUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselUpsertResult"]: {
	__typename: "InfoCarouselUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselItemCreateResult"]: {
	__typename: "InfoCarouselItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselItemDeleteResult"]: {
	__typename: "InfoCarouselItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarouselItem"] | undefined
};
	["InfoCarouselItemUpdateResult"]: {
	__typename: "InfoCarouselItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselItemUpsertResult"]: {
	__typename: "InfoCarouselItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PersonSeenInfoCarouselCreateResult"]: {
	__typename: "PersonSeenInfoCarouselCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PersonSeenInfoCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PersonSeenInfoCarouselDeleteResult"]: {
	__typename: "PersonSeenInfoCarouselDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PersonSeenInfoCarousel"] | undefined
};
	["PersonSeenInfoCarouselUpdateResult"]: {
	__typename: "PersonSeenInfoCarouselUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PersonSeenInfoCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PersonSeenInfoCarouselUpsertResult"]: {
	__typename: "PersonSeenInfoCarouselUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PersonSeenInfoCarousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GivenGiftsPageCreateResult"]: {
	__typename: "GivenGiftsPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GivenGiftsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GivenGiftsPageDeleteResult"]: {
	__typename: "GivenGiftsPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GivenGiftsPage"] | undefined
};
	["GivenGiftsPageUpdateResult"]: {
	__typename: "GivenGiftsPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GivenGiftsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GivenGiftsPageUpsertResult"]: {
	__typename: "GivenGiftsPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GivenGiftsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GivenGiftsPageLocaleCreateResult"]: {
	__typename: "GivenGiftsPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GivenGiftsPageLocaleDeleteResult"]: {
	__typename: "GivenGiftsPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GivenGiftsPageLocale"] | undefined
};
	["GivenGiftsPageLocaleUpdateResult"]: {
	__typename: "GivenGiftsPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GivenGiftsPageLocaleUpsertResult"]: {
	__typename: "GivenGiftsPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GivenGiftsPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReceivedGiftsPageCreateResult"]: {
	__typename: "ReceivedGiftsPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReceivedGiftsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReceivedGiftsPageDeleteResult"]: {
	__typename: "ReceivedGiftsPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReceivedGiftsPage"] | undefined
};
	["ReceivedGiftsPageUpdateResult"]: {
	__typename: "ReceivedGiftsPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReceivedGiftsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReceivedGiftsPageUpsertResult"]: {
	__typename: "ReceivedGiftsPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReceivedGiftsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReceivedGiftsPageLocaleCreateResult"]: {
	__typename: "ReceivedGiftsPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReceivedGiftsPageLocaleDeleteResult"]: {
	__typename: "ReceivedGiftsPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined
};
	["ReceivedGiftsPageLocaleUpdateResult"]: {
	__typename: "ReceivedGiftsPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReceivedGiftsPageLocaleUpsertResult"]: {
	__typename: "ReceivedGiftsPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReceivedGiftsPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportNavigationCreateResult"]: {
	__typename: "ReportNavigationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportNavigation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportNavigationDeleteResult"]: {
	__typename: "ReportNavigationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportNavigation"] | undefined
};
	["ReportNavigationUpdateResult"]: {
	__typename: "ReportNavigationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportNavigation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportNavigationUpsertResult"]: {
	__typename: "ReportNavigationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportNavigation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportPageCreateResult"]: {
	__typename: "ReportPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportPageDeleteResult"]: {
	__typename: "ReportPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportPage"] | undefined
};
	["ReportPageUpdateResult"]: {
	__typename: "ReportPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportPageUpsertResult"]: {
	__typename: "ReportPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportPageLocaleCreateResult"]: {
	__typename: "ReportPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportPageLocaleDeleteResult"]: {
	__typename: "ReportPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportPageLocale"] | undefined
};
	["ReportPageLocaleUpdateResult"]: {
	__typename: "ReportPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportPageLocaleUpsertResult"]: {
	__typename: "ReportPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportNavigationLocaleCreateResult"]: {
	__typename: "ReportNavigationLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportNavigationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportNavigationLocaleDeleteResult"]: {
	__typename: "ReportNavigationLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportNavigationLocale"] | undefined
};
	["ReportNavigationLocaleUpdateResult"]: {
	__typename: "ReportNavigationLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportNavigationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReportNavigationLocaleUpsertResult"]: {
	__typename: "ReportNavigationLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReportNavigationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SentPaymentCreateResult"]: {
	__typename: "SentPaymentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SentPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SentPaymentDeleteResult"]: {
	__typename: "SentPaymentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SentPayment"] | undefined
};
	["SentPaymentUpdateResult"]: {
	__typename: "SentPaymentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SentPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SentPaymentUpsertResult"]: {
	__typename: "SentPaymentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SentPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NotificationTargetGroupCreateResult"]: {
	__typename: "NotificationTargetGroupCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NotificationTargetGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NotificationTargetGroupDeleteResult"]: {
	__typename: "NotificationTargetGroupDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NotificationTargetGroup"] | undefined
};
	["NotificationTargetGroupUpdateResult"]: {
	__typename: "NotificationTargetGroupUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NotificationTargetGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NotificationTargetGroupUpsertResult"]: {
	__typename: "NotificationTargetGroupUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NotificationTargetGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProcessedNotificationCreateResult"]: {
	__typename: "ProcessedNotificationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProcessedNotification"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProcessedNotificationDeleteResult"]: {
	__typename: "ProcessedNotificationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProcessedNotification"] | undefined
};
	["ProcessedNotificationUpdateResult"]: {
	__typename: "ProcessedNotificationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProcessedNotification"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProcessedNotificationUpsertResult"]: {
	__typename: "ProcessedNotificationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProcessedNotification"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScheduledNotificationCreateResult"]: {
	__typename: "ScheduledNotificationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ScheduledNotification"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScheduledNotificationDeleteResult"]: {
	__typename: "ScheduledNotificationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ScheduledNotification"] | undefined
};
	["ScheduledNotificationUpdateResult"]: {
	__typename: "ScheduledNotificationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ScheduledNotification"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScheduledNotificationUpsertResult"]: {
	__typename: "ScheduledNotificationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ScheduledNotification"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProcessedNotificationSourceCreateResult"]: {
	__typename: "ProcessedNotificationSourceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProcessedNotificationSource"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProcessedNotificationSourceDeleteResult"]: {
	__typename: "ProcessedNotificationSourceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProcessedNotificationSource"] | undefined
};
	["ProcessedNotificationSourceUpdateResult"]: {
	__typename: "ProcessedNotificationSourceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProcessedNotificationSource"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProcessedNotificationSourceUpsertResult"]: {
	__typename: "ProcessedNotificationSourceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProcessedNotificationSource"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceCreateResult"]: {
	__typename: "DeviceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Device"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceDeleteResult"]: {
	__typename: "DeviceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Device"] | undefined
};
	["DeviceUpdateResult"]: {
	__typename: "DeviceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Device"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceUpsertResult"]: {
	__typename: "DeviceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Device"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScheduledNotificationLocaleCreateResult"]: {
	__typename: "ScheduledNotificationLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ScheduledNotificationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScheduledNotificationLocaleDeleteResult"]: {
	__typename: "ScheduledNotificationLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ScheduledNotificationLocale"] | undefined
};
	["ScheduledNotificationLocaleUpdateResult"]: {
	__typename: "ScheduledNotificationLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ScheduledNotificationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScheduledNotificationLocaleUpsertResult"]: {
	__typename: "ScheduledNotificationLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ScheduledNotificationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselItemLocaleCreateResult"]: {
	__typename: "InfoCarouselItemLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarouselItemLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselItemLocaleDeleteResult"]: {
	__typename: "InfoCarouselItemLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarouselItemLocale"] | undefined
};
	["InfoCarouselItemLocaleUpdateResult"]: {
	__typename: "InfoCarouselItemLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarouselItemLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCarouselItemLocaleUpsertResult"]: {
	__typename: "InfoCarouselItemLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCarouselItemLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SentPaymentLocaleCreateResult"]: {
	__typename: "SentPaymentLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SentPaymentLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SentPaymentLocaleDeleteResult"]: {
	__typename: "SentPaymentLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SentPaymentLocale"] | undefined
};
	["SentPaymentLocaleUpdateResult"]: {
	__typename: "SentPaymentLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SentPaymentLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SentPaymentLocaleUpsertResult"]: {
	__typename: "SentPaymentLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SentPaymentLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextImageListCreateResult"]: {
	__typename: "TextImageListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextImageListDeleteResult"]: {
	__typename: "TextImageListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextImageList"] | undefined
};
	["TextImageListUpdateResult"]: {
	__typename: "TextImageListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextImageListUpsertResult"]: {
	__typename: "TextImageListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextImageListItemCreateResult"]: {
	__typename: "TextImageListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextImageListItemDeleteResult"]: {
	__typename: "TextImageListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextImageListItem"] | undefined
};
	["TextImageListItemUpdateResult"]: {
	__typename: "TextImageListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextImageListItemUpsertResult"]: {
	__typename: "TextImageListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCarouselItemCreateResult"]: {
	__typename: "HeroCarouselItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeroCarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCarouselItemDeleteResult"]: {
	__typename: "HeroCarouselItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeroCarouselItem"] | undefined
};
	["HeroCarouselItemUpdateResult"]: {
	__typename: "HeroCarouselItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeroCarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCarouselItemUpsertResult"]: {
	__typename: "HeroCarouselItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeroCarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"],
	createGeneral: GraphQLTypes["GeneralCreateResult"],
	deleteGeneral: GraphQLTypes["GeneralDeleteResult"],
	updateGeneral: GraphQLTypes["GeneralUpdateResult"],
	upsertGeneral: GraphQLTypes["GeneralUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createGenericPage: GraphQLTypes["GenericPageCreateResult"],
	deleteGenericPage: GraphQLTypes["GenericPageDeleteResult"],
	updateGenericPage: GraphQLTypes["GenericPageUpdateResult"],
	upsertGenericPage: GraphQLTypes["GenericPageUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createGeneralLocale: GraphQLTypes["GeneralLocaleCreateResult"],
	deleteGeneralLocale: GraphQLTypes["GeneralLocaleDeleteResult"],
	updateGeneralLocale: GraphQLTypes["GeneralLocaleUpdateResult"],
	upsertGeneralLocale: GraphQLTypes["GeneralLocaleUpsertResult"],
	createGenericPageLocale: GraphQLTypes["GenericPageLocaleCreateResult"],
	deleteGenericPageLocale: GraphQLTypes["GenericPageLocaleDeleteResult"],
	updateGenericPageLocale: GraphQLTypes["GenericPageLocaleUpdateResult"],
	upsertGenericPageLocale: GraphQLTypes["GenericPageLocaleUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createPost: GraphQLTypes["PostCreateResult"],
	deletePost: GraphQLTypes["PostDeleteResult"],
	updatePost: GraphQLTypes["PostUpdateResult"],
	upsertPost: GraphQLTypes["PostUpsertResult"],
	createPostLocale: GraphQLTypes["PostLocaleCreateResult"],
	deletePostLocale: GraphQLTypes["PostLocaleDeleteResult"],
	updatePostLocale: GraphQLTypes["PostLocaleUpdateResult"],
	upsertPostLocale: GraphQLTypes["PostLocaleUpsertResult"],
	createPostArea: GraphQLTypes["PostAreaCreateResult"],
	deletePostArea: GraphQLTypes["PostAreaDeleteResult"],
	updatePostArea: GraphQLTypes["PostAreaUpdateResult"],
	upsertPostArea: GraphQLTypes["PostAreaUpsertResult"],
	createPostAreaLocale: GraphQLTypes["PostAreaLocaleCreateResult"],
	deletePostAreaLocale: GraphQLTypes["PostAreaLocaleDeleteResult"],
	updatePostAreaLocale: GraphQLTypes["PostAreaLocaleUpdateResult"],
	upsertPostAreaLocale: GraphQLTypes["PostAreaLocaleUpsertResult"],
	createPostOrganization: GraphQLTypes["PostOrganizationCreateResult"],
	deletePostOrganization: GraphQLTypes["PostOrganizationDeleteResult"],
	updatePostOrganization: GraphQLTypes["PostOrganizationUpdateResult"],
	upsertPostOrganization: GraphQLTypes["PostOrganizationUpsertResult"],
	createPostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleCreateResult"],
	deletePostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleDeleteResult"],
	updatePostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleUpdateResult"],
	upsertPostOrganizationLocale: GraphQLTypes["PostOrganizationLocaleUpsertResult"],
	createDonation: GraphQLTypes["DonationCreateResult"],
	deleteDonation: GraphQLTypes["DonationDeleteResult"],
	updateDonation: GraphQLTypes["DonationUpdateResult"],
	upsertDonation: GraphQLTypes["DonationUpsertResult"],
	createDonationAmountItem: GraphQLTypes["DonationAmountItemCreateResult"],
	deleteDonationAmountItem: GraphQLTypes["DonationAmountItemDeleteResult"],
	updateDonationAmountItem: GraphQLTypes["DonationAmountItemUpdateResult"],
	upsertDonationAmountItem: GraphQLTypes["DonationAmountItemUpsertResult"],
	createDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemCreateResult"],
	deleteDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemDeleteResult"],
	updateDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemUpdateResult"],
	upsertDonationAmountsRegionItem: GraphQLTypes["DonationAmountsRegionItemUpsertResult"],
	createDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListCreateResult"],
	deleteDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListDeleteResult"],
	updateDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListUpdateResult"],
	upsertDonationAmountsRegionList: GraphQLTypes["DonationAmountsRegionListUpsertResult"],
	createRegion: GraphQLTypes["RegionCreateResult"],
	deleteRegion: GraphQLTypes["RegionDeleteResult"],
	updateRegion: GraphQLTypes["RegionUpdateResult"],
	upsertRegion: GraphQLTypes["RegionUpsertResult"],
	createLinkItem: GraphQLTypes["LinkItemCreateResult"],
	deleteLinkItem: GraphQLTypes["LinkItemDeleteResult"],
	updateLinkItem: GraphQLTypes["LinkItemUpdateResult"],
	upsertLinkItem: GraphQLTypes["LinkItemUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLocale: GraphQLTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: GraphQLTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: GraphQLTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: GraphQLTypes["HeaderLocaleUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLocale: GraphQLTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: GraphQLTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: GraphQLTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: GraphQLTypes["FooterLocaleUpsertResult"],
	createPostList: GraphQLTypes["PostListCreateResult"],
	deletePostList: GraphQLTypes["PostListDeleteResult"],
	updatePostList: GraphQLTypes["PostListUpdateResult"],
	upsertPostList: GraphQLTypes["PostListUpsertResult"],
	createPostListItem: GraphQLTypes["PostListItemCreateResult"],
	deletePostListItem: GraphQLTypes["PostListItemDeleteResult"],
	updatePostListItem: GraphQLTypes["PostListItemUpdateResult"],
	upsertPostListItem: GraphQLTypes["PostListItemUpsertResult"],
	createAppBanner: GraphQLTypes["AppBannerCreateResult"],
	deleteAppBanner: GraphQLTypes["AppBannerDeleteResult"],
	updateAppBanner: GraphQLTypes["AppBannerUpdateResult"],
	upsertAppBanner: GraphQLTypes["AppBannerUpsertResult"],
	createGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsCreateResult"],
	deleteGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsDeleteResult"],
	updateGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsUpdateResult"],
	upsertGenericPageAboutSettings: GraphQLTypes["GenericPageAboutSettingsUpsertResult"],
	createGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleCreateResult"],
	deleteGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleDeleteResult"],
	updateGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleUpdateResult"],
	upsertGenericPageAboutSettingsLocale: GraphQLTypes["GenericPageAboutSettingsLocaleUpsertResult"],
	createValue: GraphQLTypes["ValueCreateResult"],
	deleteValue: GraphQLTypes["ValueDeleteResult"],
	updateValue: GraphQLTypes["ValueUpdateResult"],
	upsertValue: GraphQLTypes["ValueUpsertResult"],
	createValueItem: GraphQLTypes["ValueItemCreateResult"],
	deleteValueItem: GraphQLTypes["ValueItemDeleteResult"],
	updateValueItem: GraphQLTypes["ValueItemUpdateResult"],
	upsertValueItem: GraphQLTypes["ValueItemUpsertResult"],
	createValueList: GraphQLTypes["ValueListCreateResult"],
	deleteValueList: GraphQLTypes["ValueListDeleteResult"],
	updateValueList: GraphQLTypes["ValueListUpdateResult"],
	upsertValueList: GraphQLTypes["ValueListUpsertResult"],
	createImageLink: GraphQLTypes["ImageLinkCreateResult"],
	deleteImageLink: GraphQLTypes["ImageLinkDeleteResult"],
	updateImageLink: GraphQLTypes["ImageLinkUpdateResult"],
	upsertImageLink: GraphQLTypes["ImageLinkUpsertResult"],
	createImageLinkItem: GraphQLTypes["ImageLinkItemCreateResult"],
	deleteImageLinkItem: GraphQLTypes["ImageLinkItemDeleteResult"],
	updateImageLinkItem: GraphQLTypes["ImageLinkItemUpdateResult"],
	upsertImageLinkItem: GraphQLTypes["ImageLinkItemUpsertResult"],
	createImageLinkList: GraphQLTypes["ImageLinkListCreateResult"],
	deleteImageLinkList: GraphQLTypes["ImageLinkListDeleteResult"],
	updateImageLinkList: GraphQLTypes["ImageLinkListUpdateResult"],
	upsertImageLinkList: GraphQLTypes["ImageLinkListUpsertResult"],
	createPostAreaList: GraphQLTypes["PostAreaListCreateResult"],
	deletePostAreaList: GraphQLTypes["PostAreaListDeleteResult"],
	updatePostAreaList: GraphQLTypes["PostAreaListUpdateResult"],
	upsertPostAreaList: GraphQLTypes["PostAreaListUpsertResult"],
	createPostAreaListItem: GraphQLTypes["PostAreaListItemCreateResult"],
	deletePostAreaListItem: GraphQLTypes["PostAreaListItemDeleteResult"],
	updatePostAreaListItem: GraphQLTypes["PostAreaListItemUpdateResult"],
	upsertPostAreaListItem: GraphQLTypes["PostAreaListItemUpsertResult"],
	createAccordion: GraphQLTypes["AccordionCreateResult"],
	deleteAccordion: GraphQLTypes["AccordionDeleteResult"],
	updateAccordion: GraphQLTypes["AccordionUpdateResult"],
	upsertAccordion: GraphQLTypes["AccordionUpsertResult"],
	createAccordionItem: GraphQLTypes["AccordionItemCreateResult"],
	deleteAccordionItem: GraphQLTypes["AccordionItemDeleteResult"],
	updateAccordionItem: GraphQLTypes["AccordionItemUpdateResult"],
	upsertAccordionItem: GraphQLTypes["AccordionItemUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createUserPayment: GraphQLTypes["UserPaymentCreateResult"],
	deleteUserPayment: GraphQLTypes["UserPaymentDeleteResult"],
	updateUserPayment: GraphQLTypes["UserPaymentUpdateResult"],
	upsertUserPayment: GraphQLTypes["UserPaymentUpsertResult"],
	createCurrency: GraphQLTypes["CurrencyCreateResult"],
	deleteCurrency: GraphQLTypes["CurrencyDeleteResult"],
	updateCurrency: GraphQLTypes["CurrencyUpdateResult"],
	upsertCurrency: GraphQLTypes["CurrencyUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createMediumItem: GraphQLTypes["MediumItemCreateResult"],
	deleteMediumItem: GraphQLTypes["MediumItemDeleteResult"],
	updateMediumItem: GraphQLTypes["MediumItemUpdateResult"],
	upsertMediumItem: GraphQLTypes["MediumItemUpsertResult"],
	createMediumList: GraphQLTypes["MediumListCreateResult"],
	deleteMediumList: GraphQLTypes["MediumListDeleteResult"],
	updateMediumList: GraphQLTypes["MediumListUpdateResult"],
	upsertMediumList: GraphQLTypes["MediumListUpsertResult"],
	createUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdCreateResult"],
	deleteUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdDeleteResult"],
	updateUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdUpdateResult"],
	upsertUserPaymentOrderId: GraphQLTypes["UserPaymentOrderIdUpsertResult"],
	createPostRevision: GraphQLTypes["PostRevisionCreateResult"],
	deletePostRevision: GraphQLTypes["PostRevisionDeleteResult"],
	updatePostRevision: GraphQLTypes["PostRevisionUpdateResult"],
	upsertPostRevision: GraphQLTypes["PostRevisionUpsertResult"],
	createUserRecurringPayment: GraphQLTypes["UserRecurringPaymentCreateResult"],
	deleteUserRecurringPayment: GraphQLTypes["UserRecurringPaymentDeleteResult"],
	updateUserRecurringPayment: GraphQLTypes["UserRecurringPaymentUpdateResult"],
	upsertUserRecurringPayment: GraphQLTypes["UserRecurringPaymentUpsertResult"],
	createUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemCreateResult"],
	deleteUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemDeleteResult"],
	updateUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemUpdateResult"],
	upsertUserRecurringPaymentItem: GraphQLTypes["UserRecurringPaymentItemUpsertResult"],
	createPostRevisionLocale: GraphQLTypes["PostRevisionLocaleCreateResult"],
	deletePostRevisionLocale: GraphQLTypes["PostRevisionLocaleDeleteResult"],
	updatePostRevisionLocale: GraphQLTypes["PostRevisionLocaleUpdateResult"],
	upsertPostRevisionLocale: GraphQLTypes["PostRevisionLocaleUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleCreateResult"],
	deleteGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleDeleteResult"],
	updateGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpdateResult"],
	upsertGenericPageAboutGroupLinksLocale: GraphQLTypes["GenericPageAboutGroupLinksLocaleUpsertResult"],
	createMemberList: GraphQLTypes["MemberListCreateResult"],
	deleteMemberList: GraphQLTypes["MemberListDeleteResult"],
	updateMemberList: GraphQLTypes["MemberListUpdateResult"],
	upsertMemberList: GraphQLTypes["MemberListUpsertResult"],
	createMemberListItem: GraphQLTypes["MemberListItemCreateResult"],
	deleteMemberListItem: GraphQLTypes["MemberListItemDeleteResult"],
	updateMemberListItem: GraphQLTypes["MemberListItemUpdateResult"],
	upsertMemberListItem: GraphQLTypes["MemberListItemUpsertResult"],
	createFilledTaxForm: GraphQLTypes["FilledTaxFormCreateResult"],
	deleteFilledTaxForm: GraphQLTypes["FilledTaxFormDeleteResult"],
	updateFilledTaxForm: GraphQLTypes["FilledTaxFormUpdateResult"],
	upsertFilledTaxForm: GraphQLTypes["FilledTaxFormUpsertResult"],
	createFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressCreateResult"],
	deleteFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressDeleteResult"],
	updateFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressUpdateResult"],
	upsertFilledTaxFormEmailAddress: GraphQLTypes["FilledTaxFormEmailAddressUpsertResult"],
	createForm: GraphQLTypes["FormCreateResult"],
	deleteForm: GraphQLTypes["FormDeleteResult"],
	updateForm: GraphQLTypes["FormUpdateResult"],
	upsertForm: GraphQLTypes["FormUpsertResult"],
	createCsobPayment: GraphQLTypes["CsobPaymentCreateResult"],
	deleteCsobPayment: GraphQLTypes["CsobPaymentDeleteResult"],
	updateCsobPayment: GraphQLTypes["CsobPaymentUpdateResult"],
	upsertCsobPayment: GraphQLTypes["CsobPaymentUpsertResult"],
	createCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeCreateResult"],
	deleteCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeDeleteResult"],
	updateCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeUpdateResult"],
	upsertCsobPaymentStatusChange: GraphQLTypes["CsobPaymentStatusChangeUpsertResult"],
	createStripePayment: GraphQLTypes["StripePaymentCreateResult"],
	deleteStripePayment: GraphQLTypes["StripePaymentDeleteResult"],
	updateStripePayment: GraphQLTypes["StripePaymentUpdateResult"],
	upsertStripePayment: GraphQLTypes["StripePaymentUpsertResult"],
	createStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeCreateResult"],
	deleteStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeDeleteResult"],
	updateStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeUpdateResult"],
	upsertStripePaymentStatusChange: GraphQLTypes["StripePaymentStatusChangeUpsertResult"],
	createRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodCreateResult"],
	deleteRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodDeleteResult"],
	updateRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodUpdateResult"],
	upsertRegionPaymentMethod: GraphQLTypes["RegionPaymentMethodUpsertResult"],
	createTileItem: GraphQLTypes["TileItemCreateResult"],
	deleteTileItem: GraphQLTypes["TileItemDeleteResult"],
	updateTileItem: GraphQLTypes["TileItemUpdateResult"],
	upsertTileItem: GraphQLTypes["TileItemUpsertResult"],
	createTileList: GraphQLTypes["TileListCreateResult"],
	deleteTileList: GraphQLTypes["TileListDeleteResult"],
	updateTileList: GraphQLTypes["TileListUpdateResult"],
	upsertTileList: GraphQLTypes["TileListUpsertResult"],
	createFeedPage: GraphQLTypes["FeedPageCreateResult"],
	deleteFeedPage: GraphQLTypes["FeedPageDeleteResult"],
	updateFeedPage: GraphQLTypes["FeedPageUpdateResult"],
	upsertFeedPage: GraphQLTypes["FeedPageUpsertResult"],
	createFeedPageLocale: GraphQLTypes["FeedPageLocaleCreateResult"],
	deleteFeedPageLocale: GraphQLTypes["FeedPageLocaleDeleteResult"],
	updateFeedPageLocale: GraphQLTypes["FeedPageLocaleUpdateResult"],
	upsertFeedPageLocale: GraphQLTypes["FeedPageLocaleUpsertResult"],
	createFeedPageSection: GraphQLTypes["FeedPageSectionCreateResult"],
	deleteFeedPageSection: GraphQLTypes["FeedPageSectionDeleteResult"],
	updateFeedPageSection: GraphQLTypes["FeedPageSectionUpdateResult"],
	upsertFeedPageSection: GraphQLTypes["FeedPageSectionUpsertResult"],
	createFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeCreateResult"],
	deleteFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeDeleteResult"],
	updateFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeUpdateResult"],
	upsertFeedPageTileStripe: GraphQLTypes["FeedPageTileStripeUpsertResult"],
	createCardItem: GraphQLTypes["CardItemCreateResult"],
	deleteCardItem: GraphQLTypes["CardItemDeleteResult"],
	updateCardItem: GraphQLTypes["CardItemUpdateResult"],
	upsertCardItem: GraphQLTypes["CardItemUpsertResult"],
	createCardList: GraphQLTypes["CardListCreateResult"],
	deleteCardList: GraphQLTypes["CardListDeleteResult"],
	updateCardList: GraphQLTypes["CardListUpdateResult"],
	upsertCardList: GraphQLTypes["CardListUpsertResult"],
	createOnBehalfDonation: GraphQLTypes["OnBehalfDonationCreateResult"],
	deleteOnBehalfDonation: GraphQLTypes["OnBehalfDonationDeleteResult"],
	updateOnBehalfDonation: GraphQLTypes["OnBehalfDonationUpdateResult"],
	upsertOnBehalfDonation: GraphQLTypes["OnBehalfDonationUpsertResult"],
	createUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionCreateResult"],
	deleteUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionDeleteResult"],
	updateUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionUpdateResult"],
	upsertUserPaymentTriesCollection: GraphQLTypes["UserPaymentTriesCollectionUpsertResult"],
	createRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageCreateResult"],
	deleteRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageDeleteResult"],
	updateRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageUpdateResult"],
	upsertRecurringPaymentPage: GraphQLTypes["RecurringPaymentPageUpsertResult"],
	createRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleCreateResult"],
	deleteRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleDeleteResult"],
	updateRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleUpdateResult"],
	upsertRecurringPaymentPageLocale: GraphQLTypes["RecurringPaymentPageLocaleUpsertResult"],
	createStoryGuide: GraphQLTypes["StoryGuideCreateResult"],
	deleteStoryGuide: GraphQLTypes["StoryGuideDeleteResult"],
	updateStoryGuide: GraphQLTypes["StoryGuideUpdateResult"],
	upsertStoryGuide: GraphQLTypes["StoryGuideUpsertResult"],
	createStoryGuideItem: GraphQLTypes["StoryGuideItemCreateResult"],
	deleteStoryGuideItem: GraphQLTypes["StoryGuideItemDeleteResult"],
	updateStoryGuideItem: GraphQLTypes["StoryGuideItemUpdateResult"],
	upsertStoryGuideItem: GraphQLTypes["StoryGuideItemUpsertResult"],
	createStoryGuideList: GraphQLTypes["StoryGuideListCreateResult"],
	deleteStoryGuideList: GraphQLTypes["StoryGuideListDeleteResult"],
	updateStoryGuideList: GraphQLTypes["StoryGuideListUpdateResult"],
	upsertStoryGuideList: GraphQLTypes["StoryGuideListUpsertResult"],
	createHeroCarousel: GraphQLTypes["HeroCarouselCreateResult"],
	deleteHeroCarousel: GraphQLTypes["HeroCarouselDeleteResult"],
	updateHeroCarousel: GraphQLTypes["HeroCarouselUpdateResult"],
	upsertHeroCarousel: GraphQLTypes["HeroCarouselUpsertResult"],
	createPostOrganizationList: GraphQLTypes["PostOrganizationListCreateResult"],
	deletePostOrganizationList: GraphQLTypes["PostOrganizationListDeleteResult"],
	updatePostOrganizationList: GraphQLTypes["PostOrganizationListUpdateResult"],
	upsertPostOrganizationList: GraphQLTypes["PostOrganizationListUpsertResult"],
	createPostOrganizationListItem: GraphQLTypes["PostOrganizationListItemCreateResult"],
	deletePostOrganizationListItem: GraphQLTypes["PostOrganizationListItemDeleteResult"],
	updatePostOrganizationListItem: GraphQLTypes["PostOrganizationListItemUpdateResult"],
	upsertPostOrganizationListItem: GraphQLTypes["PostOrganizationListItemUpsertResult"],
	createInfoCarousel: GraphQLTypes["InfoCarouselCreateResult"],
	deleteInfoCarousel: GraphQLTypes["InfoCarouselDeleteResult"],
	updateInfoCarousel: GraphQLTypes["InfoCarouselUpdateResult"],
	upsertInfoCarousel: GraphQLTypes["InfoCarouselUpsertResult"],
	createInfoCarouselItem: GraphQLTypes["InfoCarouselItemCreateResult"],
	deleteInfoCarouselItem: GraphQLTypes["InfoCarouselItemDeleteResult"],
	updateInfoCarouselItem: GraphQLTypes["InfoCarouselItemUpdateResult"],
	upsertInfoCarouselItem: GraphQLTypes["InfoCarouselItemUpsertResult"],
	createPersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselCreateResult"],
	deletePersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselDeleteResult"],
	updatePersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselUpdateResult"],
	upsertPersonSeenInfoCarousel: GraphQLTypes["PersonSeenInfoCarouselUpsertResult"],
	createGivenGiftsPage: GraphQLTypes["GivenGiftsPageCreateResult"],
	deleteGivenGiftsPage: GraphQLTypes["GivenGiftsPageDeleteResult"],
	updateGivenGiftsPage: GraphQLTypes["GivenGiftsPageUpdateResult"],
	upsertGivenGiftsPage: GraphQLTypes["GivenGiftsPageUpsertResult"],
	createGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleCreateResult"],
	deleteGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleDeleteResult"],
	updateGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleUpdateResult"],
	upsertGivenGiftsPageLocale: GraphQLTypes["GivenGiftsPageLocaleUpsertResult"],
	createReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageCreateResult"],
	deleteReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageDeleteResult"],
	updateReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageUpdateResult"],
	upsertReceivedGiftsPage: GraphQLTypes["ReceivedGiftsPageUpsertResult"],
	createReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleCreateResult"],
	deleteReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleDeleteResult"],
	updateReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleUpdateResult"],
	upsertReceivedGiftsPageLocale: GraphQLTypes["ReceivedGiftsPageLocaleUpsertResult"],
	createReportNavigation: GraphQLTypes["ReportNavigationCreateResult"],
	deleteReportNavigation: GraphQLTypes["ReportNavigationDeleteResult"],
	updateReportNavigation: GraphQLTypes["ReportNavigationUpdateResult"],
	upsertReportNavigation: GraphQLTypes["ReportNavigationUpsertResult"],
	createReportPage: GraphQLTypes["ReportPageCreateResult"],
	deleteReportPage: GraphQLTypes["ReportPageDeleteResult"],
	updateReportPage: GraphQLTypes["ReportPageUpdateResult"],
	upsertReportPage: GraphQLTypes["ReportPageUpsertResult"],
	createReportPageLocale: GraphQLTypes["ReportPageLocaleCreateResult"],
	deleteReportPageLocale: GraphQLTypes["ReportPageLocaleDeleteResult"],
	updateReportPageLocale: GraphQLTypes["ReportPageLocaleUpdateResult"],
	upsertReportPageLocale: GraphQLTypes["ReportPageLocaleUpsertResult"],
	createReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleCreateResult"],
	deleteReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleDeleteResult"],
	updateReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleUpdateResult"],
	upsertReportNavigationLocale: GraphQLTypes["ReportNavigationLocaleUpsertResult"],
	createSentPayment: GraphQLTypes["SentPaymentCreateResult"],
	deleteSentPayment: GraphQLTypes["SentPaymentDeleteResult"],
	updateSentPayment: GraphQLTypes["SentPaymentUpdateResult"],
	upsertSentPayment: GraphQLTypes["SentPaymentUpsertResult"],
	createNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupCreateResult"],
	deleteNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupDeleteResult"],
	updateNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupUpdateResult"],
	upsertNotificationTargetGroup: GraphQLTypes["NotificationTargetGroupUpsertResult"],
	createProcessedNotification: GraphQLTypes["ProcessedNotificationCreateResult"],
	deleteProcessedNotification: GraphQLTypes["ProcessedNotificationDeleteResult"],
	updateProcessedNotification: GraphQLTypes["ProcessedNotificationUpdateResult"],
	upsertProcessedNotification: GraphQLTypes["ProcessedNotificationUpsertResult"],
	createScheduledNotification: GraphQLTypes["ScheduledNotificationCreateResult"],
	deleteScheduledNotification: GraphQLTypes["ScheduledNotificationDeleteResult"],
	updateScheduledNotification: GraphQLTypes["ScheduledNotificationUpdateResult"],
	upsertScheduledNotification: GraphQLTypes["ScheduledNotificationUpsertResult"],
	createProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceCreateResult"],
	deleteProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceDeleteResult"],
	updateProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceUpdateResult"],
	upsertProcessedNotificationSource: GraphQLTypes["ProcessedNotificationSourceUpsertResult"],
	createDevice: GraphQLTypes["DeviceCreateResult"],
	deleteDevice: GraphQLTypes["DeviceDeleteResult"],
	updateDevice: GraphQLTypes["DeviceUpdateResult"],
	upsertDevice: GraphQLTypes["DeviceUpsertResult"],
	createScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleCreateResult"],
	deleteScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleDeleteResult"],
	updateScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleUpdateResult"],
	upsertScheduledNotificationLocale: GraphQLTypes["ScheduledNotificationLocaleUpsertResult"],
	createInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleCreateResult"],
	deleteInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleDeleteResult"],
	updateInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleUpdateResult"],
	upsertInfoCarouselItemLocale: GraphQLTypes["InfoCarouselItemLocaleUpsertResult"],
	createSentPaymentLocale: GraphQLTypes["SentPaymentLocaleCreateResult"],
	deleteSentPaymentLocale: GraphQLTypes["SentPaymentLocaleDeleteResult"],
	updateSentPaymentLocale: GraphQLTypes["SentPaymentLocaleUpdateResult"],
	upsertSentPaymentLocale: GraphQLTypes["SentPaymentLocaleUpsertResult"],
	createTextImageList: GraphQLTypes["TextImageListCreateResult"],
	deleteTextImageList: GraphQLTypes["TextImageListDeleteResult"],
	updateTextImageList: GraphQLTypes["TextImageListUpdateResult"],
	upsertTextImageList: GraphQLTypes["TextImageListUpsertResult"],
	createTextImageListItem: GraphQLTypes["TextImageListItemCreateResult"],
	deleteTextImageListItem: GraphQLTypes["TextImageListItemDeleteResult"],
	updateTextImageListItem: GraphQLTypes["TextImageListItemUpdateResult"],
	upsertTextImageListItem: GraphQLTypes["TextImageListItemUpsertResult"],
	createHeroCarouselItem: GraphQLTypes["HeroCarouselItemCreateResult"],
	deleteHeroCarouselItem: GraphQLTypes["HeroCarouselItemDeleteResult"],
	updateHeroCarouselItem: GraphQLTypes["HeroCarouselItemUpdateResult"],
	upsertHeroCarouselItem: GraphQLTypes["HeroCarouselItemUpsertResult"],
	query?: GraphQLTypes["Query"] | undefined
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean | undefined,
	deferUniqueConstraints?: boolean | undefined
}
    }
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export const enum One {
	One = "One"
}
export const enum GenericPageType {
	default = "default",
	about = "about",
	areas = "areas",
	organizations = "organizations",
	both = "both"
}
export const enum ContentReferenceType {
	accordion = "accordion",
	appBanner = "appBanner",
	heroCarousel = "heroCarousel",
	areaList = "areaList",
	organizationList = "organizationList",
	textImageList = "textImageList",
	asideMediaContent = "asideMediaContent",
	button = "button",
	contentMedia = "contentMedia",
	form = "form",
	gridImages = "gridImages",
	hideContentBelow = "hideContentBelow",
	image = "image",
	values = "values",
	video = "video",
	linkables = "linkables",
	link = "link",
	members = "members",
	youtubeEmbed = "youtubeEmbed",
	posts = "posts"
}
export const enum LinkEnum {
	internal = "internal",
	external = "external"
}
export const enum CurrencyIdentifier {
	CZK = "CZK",
	USD = "USD",
	EUR = "EUR",
	GBP = "GBP",
	HUF = "HUF",
	PLN = "PLN",
	RON = "RON",
	NOK = "NOK",
	SEK = "SEK"
}
export const enum CurrencySignAlignment {
	left = "left",
	right = "right"
}
export const enum PaymentMethods {
	stripe = "stripe",
	csob = "csob"
}
export const enum PostType {
	donate = "donate",
	advertising = "advertising",
	content = "content"
}
export const enum VideoShapeType {
	rounded = "rounded",
	squared = "squared"
}
export const enum PostState {
	draft = "draft",
	published = "published",
	edited = "edited"
}
export const enum ContentAlignment {
	left = "left",
	right = "right"
}
export const enum MediumType {
	image = "image",
	video = "video"
}
export const enum AsideMediaContentLayout {
	default = "default",
	wide = "wide"
}
export const enum FormType {
	tax = "tax"
}
export const enum PostOrganizationListItemType {
	organization = "organization",
	custom = "custom"
}
export const enum TileListSize {
	s = "s",
	m = "m",
	l = "l"
}
export const enum TileItemType {
	post = "post",
	area = "area",
	organization = "organization",
	donation = "donation",
	custom = "custom"
}
export const enum MediaType {
	singleImage = "singleImage",
	stripes = "stripes"
}
export const enum NotificationTargetType {
	everyone = "everyone",
	specified = "specified"
}
export const enum ProcessedNotificationSourceType {
	scheduled = "scheduled",
	automatic = "automatic",
	donationReminder = "donationReminder",
	failedPayment = "failedPayment"
}
export const enum StripePaymentStatusChangePaymentIntentStatus {
	requires_payment_method = "requires_payment_method",
	requires_confirmation = "requires_confirmation",
	requires_action = "requires_action",
	processing = "processing",
	requires_capture = "requires_capture",
	canceled = "canceled",
	succeeded = "succeeded"
}
export const enum UserRecurringPaymentInterval {
	monthly = "monthly"
}
export const enum UserPaymentMethod {
	card = "card",
	googlepay = "googlepay",
	applepay = "applepay"
}
export const enum PaymentMedium {
	mobileApp = "mobileApp",
	web = "web"
}
export const enum OrderDirection {
	asc = "asc",
	desc = "desc",
	ascNullsFirst = "ascNullsFirst",
	descNullsLast = "descNullsLast"
}
export const enum TranslationKeyContentType {
	textPlain = "textPlain",
	textHtml = "textHtml"
}
export const enum InfoCarouselItemType {
	info = "info",
	post = "post"
}
export const enum S33ContentDisposition {
	ATTACHMENT = "ATTACHMENT",
	INLINE = "INLINE"
}
export const enum S3Acl {
	PUBLIC_READ = "PUBLIC_READ",
	PRIVATE = "PRIVATE",
	NONE = "NONE"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}

type ZEUS_VARIABLES = {
	["Json"]: ValueTypes["Json"];
	["_RelationSide"]: ValueTypes["_RelationSide"];
	["_OnDeleteBehaviour"]: ValueTypes["_OnDeleteBehaviour"];
	["_OrderByDirection"]: ValueTypes["_OrderByDirection"];
	["UUID"]: ValueTypes["UUID"];
	["One"]: ValueTypes["One"];
	["GeneralWhere"]: ValueTypes["GeneralWhere"];
	["UUIDCondition"]: ValueTypes["UUIDCondition"];
	["OneCondition"]: ValueTypes["OneCondition"];
	["GeneralLocaleWhere"]: ValueTypes["GeneralLocaleWhere"];
	["LocaleWhere"]: ValueTypes["LocaleWhere"];
	["StringCondition"]: ValueTypes["StringCondition"];
	["IntCondition"]: ValueTypes["IntCondition"];
	["GenericPageLocaleWhere"]: ValueTypes["GenericPageLocaleWhere"];
	["GenericPageWhere"]: ValueTypes["GenericPageWhere"];
	["GenericPageTypeCondition"]: ValueTypes["GenericPageTypeCondition"];
	["GenericPageType"]: ValueTypes["GenericPageType"];
	["ReportNavigationLocaleWhere"]: ValueTypes["ReportNavigationLocaleWhere"];
	["ReportNavigationWhere"]: ValueTypes["ReportNavigationWhere"];
	["ContentWhere"]: ValueTypes["ContentWhere"];
	["ContentBlockWhere"]: ValueTypes["ContentBlockWhere"];
	["ContentReferenceWhere"]: ValueTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: ValueTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: ValueTypes["ContentReferenceType"];
	["ImageWhere"]: ValueTypes["ImageWhere"];
	["FloatCondition"]: ValueTypes["FloatCondition"];
	["ContentReferenceLinkableItemWhere"]: ValueTypes["ContentReferenceLinkableItemWhere"];
	["LinkableWhere"]: ValueTypes["LinkableWhere"];
	["PostLocaleWhere"]: ValueTypes["PostLocaleWhere"];
	["SeoWhere"]: ValueTypes["SeoWhere"];
	["BooleanCondition"]: ValueTypes["BooleanCondition"];
	["PostWhere"]: ValueTypes["PostWhere"];
	["PostOrganizationWhere"]: ValueTypes["PostOrganizationWhere"];
	["PostOrganizationLocaleWhere"]: ValueTypes["PostOrganizationLocaleWhere"];
	["LinkWhere"]: ValueTypes["LinkWhere"];
	["LinkEnumCondition"]: ValueTypes["LinkEnumCondition"];
	["LinkEnum"]: ValueTypes["LinkEnum"];
	["PostAreaWhere"]: ValueTypes["PostAreaWhere"];
	["PostAreaLocaleWhere"]: ValueTypes["PostAreaLocaleWhere"];
	["AppBannerWhere"]: ValueTypes["AppBannerWhere"];
	["DonationAmountsRegionListWhere"]: ValueTypes["DonationAmountsRegionListWhere"];
	["DonationAmountsRegionItemWhere"]: ValueTypes["DonationAmountsRegionItemWhere"];
	["DonationAmountItemWhere"]: ValueTypes["DonationAmountItemWhere"];
	["RegionWhere"]: ValueTypes["RegionWhere"];
	["CurrencyWhere"]: ValueTypes["CurrencyWhere"];
	["CurrencyIdentifierCondition"]: ValueTypes["CurrencyIdentifierCondition"];
	["CurrencyIdentifier"]: ValueTypes["CurrencyIdentifier"];
	["CurrencySignAlignmentCondition"]: ValueTypes["CurrencySignAlignmentCondition"];
	["CurrencySignAlignment"]: ValueTypes["CurrencySignAlignment"];
	["PostAreaSentPaymentCurrencySumWhere"]: ValueTypes["PostAreaSentPaymentCurrencySumWhere"];
	["PostAreaCurrencySumWhere"]: ValueTypes["PostAreaCurrencySumWhere"];
	["PostOrganizationCurrencySumWhere"]: ValueTypes["PostOrganizationCurrencySumWhere"];
	["PostCurrencySumWhere"]: ValueTypes["PostCurrencySumWhere"];
	["RegionPaymentMethodWhere"]: ValueTypes["RegionPaymentMethodWhere"];
	["PaymentMethodsCondition"]: ValueTypes["PaymentMethodsCondition"];
	["PaymentMethods"]: ValueTypes["PaymentMethods"];
	["DonationWhere"]: ValueTypes["DonationWhere"];
	["PostAreaMetaDataWhere"]: ValueTypes["PostAreaMetaDataWhere"];
	["SentPaymentWhere"]: ValueTypes["SentPaymentWhere"];
	["DateTimeCondition"]: ValueTypes["DateTimeCondition"];
	["DateTime"]: ValueTypes["DateTime"];
	["SentPaymentLocaleWhere"]: ValueTypes["SentPaymentLocaleWhere"];
	["PostAreaSentPaymentSumWhere"]: ValueTypes["PostAreaSentPaymentSumWhere"];
	["PostAreaSumWhere"]: ValueTypes["PostAreaSumWhere"];
	["PostOrganizationMetaDataWhere"]: ValueTypes["PostOrganizationMetaDataWhere"];
	["PostOrganizationSumWhere"]: ValueTypes["PostOrganizationSumWhere"];
	["PostRevisionWhere"]: ValueTypes["PostRevisionWhere"];
	["PostTypeCondition"]: ValueTypes["PostTypeCondition"];
	["PostType"]: ValueTypes["PostType"];
	["VideoWhere"]: ValueTypes["VideoWhere"];
	["VideoShapeTypeCondition"]: ValueTypes["VideoShapeTypeCondition"];
	["VideoShapeType"]: ValueTypes["VideoShapeType"];
	["PostRevisionLocaleWhere"]: ValueTypes["PostRevisionLocaleWhere"];
	["PostStateCondition"]: ValueTypes["PostStateCondition"];
	["PostState"]: ValueTypes["PostState"];
	["PostMetaDataWhere"]: ValueTypes["PostMetaDataWhere"];
	["HeroCarouselWhere"]: ValueTypes["HeroCarouselWhere"];
	["DateCondition"]: ValueTypes["DateCondition"];
	["Date"]: ValueTypes["Date"];
	["HeroCarouselItemWhere"]: ValueTypes["HeroCarouselItemWhere"];
	["ReportPageLocaleWhere"]: ValueTypes["ReportPageLocaleWhere"];
	["ReportPageWhere"]: ValueTypes["ReportPageWhere"];
	["PostSumWhere"]: ValueTypes["PostSumWhere"];
	["PostFundraisingProgressWhere"]: ValueTypes["PostFundraisingProgressWhere"];
	["GivenGiftsPageLocaleWhere"]: ValueTypes["GivenGiftsPageLocaleWhere"];
	["GivenGiftsPageWhere"]: ValueTypes["GivenGiftsPageWhere"];
	["ReceivedGiftsPageLocaleWhere"]: ValueTypes["ReceivedGiftsPageLocaleWhere"];
	["ReceivedGiftsPageWhere"]: ValueTypes["ReceivedGiftsPageWhere"];
	["ContentAlignmentCondition"]: ValueTypes["ContentAlignmentCondition"];
	["ContentAlignment"]: ValueTypes["ContentAlignment"];
	["ValueListWhere"]: ValueTypes["ValueListWhere"];
	["ValueItemWhere"]: ValueTypes["ValueItemWhere"];
	["ValueWhere"]: ValueTypes["ValueWhere"];
	["ImageLinkListWhere"]: ValueTypes["ImageLinkListWhere"];
	["ImageLinkItemWhere"]: ValueTypes["ImageLinkItemWhere"];
	["ImageLinkWhere"]: ValueTypes["ImageLinkWhere"];
	["PostAreaListWhere"]: ValueTypes["PostAreaListWhere"];
	["PostAreaListItemWhere"]: ValueTypes["PostAreaListItemWhere"];
	["AccordionWhere"]: ValueTypes["AccordionWhere"];
	["AccordionItemWhere"]: ValueTypes["AccordionItemWhere"];
	["MediumListWhere"]: ValueTypes["MediumListWhere"];
	["MediumItemWhere"]: ValueTypes["MediumItemWhere"];
	["MediumWhere"]: ValueTypes["MediumWhere"];
	["MediumTypeCondition"]: ValueTypes["MediumTypeCondition"];
	["MediumType"]: ValueTypes["MediumType"];
	["MemberListWhere"]: ValueTypes["MemberListWhere"];
	["MemberListItemWhere"]: ValueTypes["MemberListItemWhere"];
	["AsideMediaContentLayoutCondition"]: ValueTypes["AsideMediaContentLayoutCondition"];
	["AsideMediaContentLayout"]: ValueTypes["AsideMediaContentLayout"];
	["FormWhere"]: ValueTypes["FormWhere"];
	["FormTypeCondition"]: ValueTypes["FormTypeCondition"];
	["FormType"]: ValueTypes["FormType"];
	["FilledTaxFormWhere"]: ValueTypes["FilledTaxFormWhere"];
	["PostOrganizationListWhere"]: ValueTypes["PostOrganizationListWhere"];
	["PostOrganizationListItemWhere"]: ValueTypes["PostOrganizationListItemWhere"];
	["PostOrganizationListItemTypeCondition"]: ValueTypes["PostOrganizationListItemTypeCondition"];
	["PostOrganizationListItemType"]: ValueTypes["PostOrganizationListItemType"];
	["TextImageListWhere"]: ValueTypes["TextImageListWhere"];
	["TextImageListItemWhere"]: ValueTypes["TextImageListItemWhere"];
	["HeaderLocaleWhere"]: ValueTypes["HeaderLocaleWhere"];
	["HeaderWhere"]: ValueTypes["HeaderWhere"];
	["LinkListWhere"]: ValueTypes["LinkListWhere"];
	["LinkItemWhere"]: ValueTypes["LinkItemWhere"];
	["FooterLocaleWhere"]: ValueTypes["FooterLocaleWhere"];
	["FooterWhere"]: ValueTypes["FooterWhere"];
	["GenericPageAboutSettingsLocaleWhere"]: ValueTypes["GenericPageAboutSettingsLocaleWhere"];
	["GenericPageAboutSettingsWhere"]: ValueTypes["GenericPageAboutSettingsWhere"];
	["GenericPageAboutGroupLinksLocaleWhere"]: ValueTypes["GenericPageAboutGroupLinksLocaleWhere"];
	["FeedPageLocaleWhere"]: ValueTypes["FeedPageLocaleWhere"];
	["FeedPageWhere"]: ValueTypes["FeedPageWhere"];
	["TileListWhere"]: ValueTypes["TileListWhere"];
	["TileListSizeCondition"]: ValueTypes["TileListSizeCondition"];
	["TileListSize"]: ValueTypes["TileListSize"];
	["TileItemWhere"]: ValueTypes["TileItemWhere"];
	["TileItemTypeCondition"]: ValueTypes["TileItemTypeCondition"];
	["TileItemType"]: ValueTypes["TileItemType"];
	["FeedPageSectionWhere"]: ValueTypes["FeedPageSectionWhere"];
	["FeedPageTileStripeWhere"]: ValueTypes["FeedPageTileStripeWhere"];
	["CardListWhere"]: ValueTypes["CardListWhere"];
	["CardItemWhere"]: ValueTypes["CardItemWhere"];
	["StoryGuideListWhere"]: ValueTypes["StoryGuideListWhere"];
	["StoryGuideItemWhere"]: ValueTypes["StoryGuideItemWhere"];
	["StoryGuideWhere"]: ValueTypes["StoryGuideWhere"];
	["MediaTypeCondition"]: ValueTypes["MediaTypeCondition"];
	["MediaType"]: ValueTypes["MediaType"];
	["RecurringPaymentPageLocaleWhere"]: ValueTypes["RecurringPaymentPageLocaleWhere"];
	["RecurringPaymentPageWhere"]: ValueTypes["RecurringPaymentPageWhere"];
	["PostListWhere"]: ValueTypes["PostListWhere"];
	["PostListItemWhere"]: ValueTypes["PostListItemWhere"];
	["ScheduledNotificationLocaleWhere"]: ValueTypes["ScheduledNotificationLocaleWhere"];
	["ScheduledNotificationWhere"]: ValueTypes["ScheduledNotificationWhere"];
	["NotificationTargetGroupWhere"]: ValueTypes["NotificationTargetGroupWhere"];
	["NotificationTargetTypeCondition"]: ValueTypes["NotificationTargetTypeCondition"];
	["NotificationTargetType"]: ValueTypes["NotificationTargetType"];
	["ProcessedNotificationSourceWhere"]: ValueTypes["ProcessedNotificationSourceWhere"];
	["ProcessedNotificationSourceTypeCondition"]: ValueTypes["ProcessedNotificationSourceTypeCondition"];
	["ProcessedNotificationSourceType"]: ValueTypes["ProcessedNotificationSourceType"];
	["ProcessedNotificationWhere"]: ValueTypes["ProcessedNotificationWhere"];
	["UserWhere"]: ValueTypes["UserWhere"];
	["UserPaymentWhere"]: ValueTypes["UserPaymentWhere"];
	["UserPaymentOrderIdWhere"]: ValueTypes["UserPaymentOrderIdWhere"];
	["CsobPaymentWhere"]: ValueTypes["CsobPaymentWhere"];
	["CsobPaymentStatusChangeWhere"]: ValueTypes["CsobPaymentStatusChangeWhere"];
	["CsobPaymentMetadataWhere"]: ValueTypes["CsobPaymentMetadataWhere"];
	["StripePaymentWhere"]: ValueTypes["StripePaymentWhere"];
	["StripePaymentStatusChangeWhere"]: ValueTypes["StripePaymentStatusChangeWhere"];
	["StripePaymentStatusChangePaymentIntentStatusCondition"]: ValueTypes["StripePaymentStatusChangePaymentIntentStatusCondition"];
	["StripePaymentStatusChangePaymentIntentStatus"]: ValueTypes["StripePaymentStatusChangePaymentIntentStatus"];
	["StripePaymentMetadataWhere"]: ValueTypes["StripePaymentMetadataWhere"];
	["UserRecurringPaymentItemWhere"]: ValueTypes["UserRecurringPaymentItemWhere"];
	["UserRecurringPaymentWhere"]: ValueTypes["UserRecurringPaymentWhere"];
	["UserRecurringPaymentIntervalCondition"]: ValueTypes["UserRecurringPaymentIntervalCondition"];
	["UserRecurringPaymentInterval"]: ValueTypes["UserRecurringPaymentInterval"];
	["UpcomingUserRecurringPaymentMetadataWhere"]: ValueTypes["UpcomingUserRecurringPaymentMetadataWhere"];
	["UserRecurringPaymentItemMetadataWhere"]: ValueTypes["UserRecurringPaymentItemMetadataWhere"];
	["UserPaymentMethodCondition"]: ValueTypes["UserPaymentMethodCondition"];
	["UserPaymentMethod"]: ValueTypes["UserPaymentMethod"];
	["OnBehalfDonationWhere"]: ValueTypes["OnBehalfDonationWhere"];
	["OnBehalfDonationMetadataWhere"]: ValueTypes["OnBehalfDonationMetadataWhere"];
	["UserPaymentTriesCollectionWhere"]: ValueTypes["UserPaymentTriesCollectionWhere"];
	["UserPaymentTriesCollectionMetadataWhere"]: ValueTypes["UserPaymentTriesCollectionMetadataWhere"];
	["UserPaymentTriesCollectionMetadataLocaleWhere"]: ValueTypes["UserPaymentTriesCollectionMetadataLocaleWhere"];
	["PaymentMediumCondition"]: ValueTypes["PaymentMediumCondition"];
	["PaymentMedium"]: ValueTypes["PaymentMedium"];
	["UserPaymentMetadataWhere"]: ValueTypes["UserPaymentMetadataWhere"];
	["DeviceWhere"]: ValueTypes["DeviceWhere"];
	["UserAreaStatsWhere"]: ValueTypes["UserAreaStatsWhere"];
	["UserOrganizationStatsWhere"]: ValueTypes["UserOrganizationStatsWhere"];
	["UserPostStatsWhere"]: ValueTypes["UserPostStatsWhere"];
	["UserCurrencyStatsWhere"]: ValueTypes["UserCurrencyStatsWhere"];
	["UserStatsWhere"]: ValueTypes["UserStatsWhere"];
	["GeneralLocaleOrderBy"]: ValueTypes["GeneralLocaleOrderBy"];
	["OrderDirection"]: ValueTypes["OrderDirection"];
	["GeneralOrderBy"]: ValueTypes["GeneralOrderBy"];
	["ImageOrderBy"]: ValueTypes["ImageOrderBy"];
	["PostOrganizationListOrderBy"]: ValueTypes["PostOrganizationListOrderBy"];
	["LocaleOrderBy"]: ValueTypes["LocaleOrderBy"];
	["SeoOrderBy"]: ValueTypes["SeoOrderBy"];
	["LinkOrderBy"]: ValueTypes["LinkOrderBy"];
	["LinkableOrderBy"]: ValueTypes["LinkableOrderBy"];
	["GenericPageLocaleOrderBy"]: ValueTypes["GenericPageLocaleOrderBy"];
	["GenericPageOrderBy"]: ValueTypes["GenericPageOrderBy"];
	["ContentOrderBy"]: ValueTypes["ContentOrderBy"];
	["PostLocaleOrderBy"]: ValueTypes["PostLocaleOrderBy"];
	["PostOrderBy"]: ValueTypes["PostOrderBy"];
	["PostOrganizationOrderBy"]: ValueTypes["PostOrganizationOrderBy"];
	["PostAreaOrderBy"]: ValueTypes["PostAreaOrderBy"];
	["DonationAmountsRegionListOrderBy"]: ValueTypes["DonationAmountsRegionListOrderBy"];
	["DonationOrderBy"]: ValueTypes["DonationOrderBy"];
	["RegionOrderBy"]: ValueTypes["RegionOrderBy"];
	["CurrencyOrderBy"]: ValueTypes["CurrencyOrderBy"];
	["PostAreaMetaDataOrderBy"]: ValueTypes["PostAreaMetaDataOrderBy"];
	["PostAreaSentPaymentSumOrderBy"]: ValueTypes["PostAreaSentPaymentSumOrderBy"];
	["PostAreaSumOrderBy"]: ValueTypes["PostAreaSumOrderBy"];
	["PostOrganizationMetaDataOrderBy"]: ValueTypes["PostOrganizationMetaDataOrderBy"];
	["PostOrganizationSumOrderBy"]: ValueTypes["PostOrganizationSumOrderBy"];
	["PostRevisionOrderBy"]: ValueTypes["PostRevisionOrderBy"];
	["VideoOrderBy"]: ValueTypes["VideoOrderBy"];
	["PostMetaDataOrderBy"]: ValueTypes["PostMetaDataOrderBy"];
	["PostSumOrderBy"]: ValueTypes["PostSumOrderBy"];
	["PostFundraisingProgressOrderBy"]: ValueTypes["PostFundraisingProgressOrderBy"];
	["PostAreaLocaleOrderBy"]: ValueTypes["PostAreaLocaleOrderBy"];
	["AppBannerOrderBy"]: ValueTypes["AppBannerOrderBy"];
	["PostOrganizationLocaleOrderBy"]: ValueTypes["PostOrganizationLocaleOrderBy"];
	["ReportPageLocaleOrderBy"]: ValueTypes["ReportPageLocaleOrderBy"];
	["ReportPageOrderBy"]: ValueTypes["ReportPageOrderBy"];
	["GivenGiftsPageLocaleOrderBy"]: ValueTypes["GivenGiftsPageLocaleOrderBy"];
	["GivenGiftsPageOrderBy"]: ValueTypes["GivenGiftsPageOrderBy"];
	["ReceivedGiftsPageLocaleOrderBy"]: ValueTypes["ReceivedGiftsPageLocaleOrderBy"];
	["ReceivedGiftsPageOrderBy"]: ValueTypes["ReceivedGiftsPageOrderBy"];
	["ReportNavigationLocaleOrderBy"]: ValueTypes["ReportNavigationLocaleOrderBy"];
	["ReportNavigationOrderBy"]: ValueTypes["ReportNavigationOrderBy"];
	["ReportNavigationLocalesByLocaleUniqueWhere"]: ValueTypes["ReportNavigationLocalesByLocaleUniqueWhere"];
	["LocaleUniqueWhere"]: ValueTypes["LocaleUniqueWhere"];
	["GeneralLocaleUniqueWhere"]: ValueTypes["GeneralLocaleUniqueWhere"];
	["GeneralUniqueWhere"]: ValueTypes["GeneralUniqueWhere"];
	["ImageUniqueWhere"]: ValueTypes["ImageUniqueWhere"];
	["PostOrganizationListUniqueWhere"]: ValueTypes["PostOrganizationListUniqueWhere"];
	["PostOrganizationListItemUniqueWhere"]: ValueTypes["PostOrganizationListItemUniqueWhere"];
	["LinkUniqueWhere"]: ValueTypes["LinkUniqueWhere"];
	["SeoUniqueWhere"]: ValueTypes["SeoUniqueWhere"];
	["GenericPageLocaleUniqueWhere"]: ValueTypes["GenericPageLocaleUniqueWhere"];
	["GenericPageUniqueWhere"]: ValueTypes["GenericPageUniqueWhere"];
	["ContentUniqueWhere"]: ValueTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: ValueTypes["ContentBlockUniqueWhere"];
	["ContentReferenceUniqueWhere"]: ValueTypes["ContentReferenceUniqueWhere"];
	["ContentReferenceLinkableItemUniqueWhere"]: ValueTypes["ContentReferenceLinkableItemUniqueWhere"];
	["LinkableUniqueWhere"]: ValueTypes["LinkableUniqueWhere"];
	["PostLocaleUniqueWhere"]: ValueTypes["PostLocaleUniqueWhere"];
	["PostUniqueWhere"]: ValueTypes["PostUniqueWhere"];
	["PostRevisionUniqueWhere"]: ValueTypes["PostRevisionUniqueWhere"];
	["PostRevisionLocaleUniqueWhere"]: ValueTypes["PostRevisionLocaleUniqueWhere"];
	["DonationAmountsRegionListUniqueWhere"]: ValueTypes["DonationAmountsRegionListUniqueWhere"];
	["DonationAmountsRegionItemUniqueWhere"]: ValueTypes["DonationAmountsRegionItemUniqueWhere"];
	["RegionUniqueWhere"]: ValueTypes["RegionUniqueWhere"];
	["RegionPaymentMethodUniqueWhere"]: ValueTypes["RegionPaymentMethodUniqueWhere"];
	["DonationAmountItemUniqueWhere"]: ValueTypes["DonationAmountItemUniqueWhere"];
	["DonationUniqueWhere"]: ValueTypes["DonationUniqueWhere"];
	["PostMetaDataUniqueWhere"]: ValueTypes["PostMetaDataUniqueWhere"];
	["PostCurrencySumUniqueWhere"]: ValueTypes["PostCurrencySumUniqueWhere"];
	["PostSumUniqueWhere"]: ValueTypes["PostSumUniqueWhere"];
	["PostFundraisingProgressUniqueWhere"]: ValueTypes["PostFundraisingProgressUniqueWhere"];
	["PostAreaLocaleUniqueWhere"]: ValueTypes["PostAreaLocaleUniqueWhere"];
	["PostAreaUniqueWhere"]: ValueTypes["PostAreaUniqueWhere"];
	["PostAreaMetaDataUniqueWhere"]: ValueTypes["PostAreaMetaDataUniqueWhere"];
	["SentPaymentUniqueWhere"]: ValueTypes["SentPaymentUniqueWhere"];
	["SentPaymentLocaleUniqueWhere"]: ValueTypes["SentPaymentLocaleUniqueWhere"];
	["PostAreaSentPaymentCurrencySumUniqueWhere"]: ValueTypes["PostAreaSentPaymentCurrencySumUniqueWhere"];
	["PostAreaSentPaymentSumUniqueWhere"]: ValueTypes["PostAreaSentPaymentSumUniqueWhere"];
	["PostAreaCurrencySumUniqueWhere"]: ValueTypes["PostAreaCurrencySumUniqueWhere"];
	["PostAreaSumUniqueWhere"]: ValueTypes["PostAreaSumUniqueWhere"];
	["AppBannerUniqueWhere"]: ValueTypes["AppBannerUniqueWhere"];
	["PostOrganizationLocaleUniqueWhere"]: ValueTypes["PostOrganizationLocaleUniqueWhere"];
	["PostOrganizationUniqueWhere"]: ValueTypes["PostOrganizationUniqueWhere"];
	["PostOrganizationMetaDataUniqueWhere"]: ValueTypes["PostOrganizationMetaDataUniqueWhere"];
	["PostOrganizationCurrencySumUniqueWhere"]: ValueTypes["PostOrganizationCurrencySumUniqueWhere"];
	["PostOrganizationSumUniqueWhere"]: ValueTypes["PostOrganizationSumUniqueWhere"];
	["ReportPageLocaleUniqueWhere"]: ValueTypes["ReportPageLocaleUniqueWhere"];
	["ReportPageUniqueWhere"]: ValueTypes["ReportPageUniqueWhere"];
	["GivenGiftsPageLocaleUniqueWhere"]: ValueTypes["GivenGiftsPageLocaleUniqueWhere"];
	["GivenGiftsPageUniqueWhere"]: ValueTypes["GivenGiftsPageUniqueWhere"];
	["ReceivedGiftsPageLocaleUniqueWhere"]: ValueTypes["ReceivedGiftsPageLocaleUniqueWhere"];
	["ReceivedGiftsPageUniqueWhere"]: ValueTypes["ReceivedGiftsPageUniqueWhere"];
	["ValueListUniqueWhere"]: ValueTypes["ValueListUniqueWhere"];
	["ValueItemUniqueWhere"]: ValueTypes["ValueItemUniqueWhere"];
	["ImageLinkListUniqueWhere"]: ValueTypes["ImageLinkListUniqueWhere"];
	["ImageLinkItemUniqueWhere"]: ValueTypes["ImageLinkItemUniqueWhere"];
	["PostAreaListUniqueWhere"]: ValueTypes["PostAreaListUniqueWhere"];
	["PostAreaListItemUniqueWhere"]: ValueTypes["PostAreaListItemUniqueWhere"];
	["AccordionUniqueWhere"]: ValueTypes["AccordionUniqueWhere"];
	["AccordionItemUniqueWhere"]: ValueTypes["AccordionItemUniqueWhere"];
	["MediumListUniqueWhere"]: ValueTypes["MediumListUniqueWhere"];
	["MediumItemUniqueWhere"]: ValueTypes["MediumItemUniqueWhere"];
	["MemberListUniqueWhere"]: ValueTypes["MemberListUniqueWhere"];
	["MemberListItemUniqueWhere"]: ValueTypes["MemberListItemUniqueWhere"];
	["TextImageListUniqueWhere"]: ValueTypes["TextImageListUniqueWhere"];
	["TextImageListItemUniqueWhere"]: ValueTypes["TextImageListItemUniqueWhere"];
	["HeaderLocaleUniqueWhere"]: ValueTypes["HeaderLocaleUniqueWhere"];
	["HeaderUniqueWhere"]: ValueTypes["HeaderUniqueWhere"];
	["LinkListUniqueWhere"]: ValueTypes["LinkListUniqueWhere"];
	["LinkItemUniqueWhere"]: ValueTypes["LinkItemUniqueWhere"];
	["FooterLocaleUniqueWhere"]: ValueTypes["FooterLocaleUniqueWhere"];
	["FooterUniqueWhere"]: ValueTypes["FooterUniqueWhere"];
	["GenericPageAboutSettingsLocaleUniqueWhere"]: ValueTypes["GenericPageAboutSettingsLocaleUniqueWhere"];
	["GenericPageAboutSettingsUniqueWhere"]: ValueTypes["GenericPageAboutSettingsUniqueWhere"];
	["GenericPageAboutGroupLinksLocaleUniqueWhere"]: ValueTypes["GenericPageAboutGroupLinksLocaleUniqueWhere"];
	["FeedPageLocaleUniqueWhere"]: ValueTypes["FeedPageLocaleUniqueWhere"];
	["FeedPageUniqueWhere"]: ValueTypes["FeedPageUniqueWhere"];
	["TileListUniqueWhere"]: ValueTypes["TileListUniqueWhere"];
	["TileItemUniqueWhere"]: ValueTypes["TileItemUniqueWhere"];
	["FeedPageSectionUniqueWhere"]: ValueTypes["FeedPageSectionUniqueWhere"];
	["FeedPageTileStripeUniqueWhere"]: ValueTypes["FeedPageTileStripeUniqueWhere"];
	["CardListUniqueWhere"]: ValueTypes["CardListUniqueWhere"];
	["CardItemUniqueWhere"]: ValueTypes["CardItemUniqueWhere"];
	["StoryGuideListUniqueWhere"]: ValueTypes["StoryGuideListUniqueWhere"];
	["StoryGuideItemUniqueWhere"]: ValueTypes["StoryGuideItemUniqueWhere"];
	["RecurringPaymentPageLocaleUniqueWhere"]: ValueTypes["RecurringPaymentPageLocaleUniqueWhere"];
	["RecurringPaymentPageUniqueWhere"]: ValueTypes["RecurringPaymentPageUniqueWhere"];
	["PostListUniqueWhere"]: ValueTypes["PostListUniqueWhere"];
	["PostListItemUniqueWhere"]: ValueTypes["PostListItemUniqueWhere"];
	["ReportNavigationLocaleUniqueWhere"]: ValueTypes["ReportNavigationLocaleUniqueWhere"];
	["ReportNavigationUniqueWhere"]: ValueTypes["ReportNavigationUniqueWhere"];
	["ScheduledNotificationLocaleUniqueWhere"]: ValueTypes["ScheduledNotificationLocaleUniqueWhere"];
	["ScheduledNotificationUniqueWhere"]: ValueTypes["ScheduledNotificationUniqueWhere"];
	["ProcessedNotificationSourceUniqueWhere"]: ValueTypes["ProcessedNotificationSourceUniqueWhere"];
	["ProcessedNotificationUniqueWhere"]: ValueTypes["ProcessedNotificationUniqueWhere"];
	["GenericPageLocalesByLocaleUniqueWhere"]: ValueTypes["GenericPageLocalesByLocaleUniqueWhere"];
	["GenericPageLocalesByContentUniqueWhere"]: ValueTypes["GenericPageLocalesByContentUniqueWhere"];
	["GenericPageLocalesBySeoUniqueWhere"]: ValueTypes["GenericPageLocalesBySeoUniqueWhere"];
	["GenericPageLocalesByLinkUniqueWhere"]: ValueTypes["GenericPageLocalesByLinkUniqueWhere"];
	["DonationAmountItemOrderBy"]: ValueTypes["DonationAmountItemOrderBy"];
	["DonationAmountsRegionItemOrderBy"]: ValueTypes["DonationAmountsRegionItemOrderBy"];
	["PostAreaSentPaymentCurrencySumOrderBy"]: ValueTypes["PostAreaSentPaymentCurrencySumOrderBy"];
	["PostAreaCurrencySumOrderBy"]: ValueTypes["PostAreaCurrencySumOrderBy"];
	["PostOrganizationCurrencySumOrderBy"]: ValueTypes["PostOrganizationCurrencySumOrderBy"];
	["PostCurrencySumOrderBy"]: ValueTypes["PostCurrencySumOrderBy"];
	["RegionPaymentMethodOrderBy"]: ValueTypes["RegionPaymentMethodOrderBy"];
	["RegionEnabledPaymentMethodsByMethodUniqueWhere"]: ValueTypes["RegionEnabledPaymentMethodsByMethodUniqueWhere"];
	["RegionDonationItemsByListUniqueWhere"]: ValueTypes["RegionDonationItemsByListUniqueWhere"];
	["RegionDonationItemsByItemsUniqueWhere"]: ValueTypes["RegionDonationItemsByItemsUniqueWhere"];
	["DonationAmountsRegionListRegionsByRegionUniqueWhere"]: ValueTypes["DonationAmountsRegionListRegionsByRegionUniqueWhere"];
	["DonationAmountsRegionListRegionsByItemsUniqueWhere"]: ValueTypes["DonationAmountsRegionListRegionsByItemsUniqueWhere"];
	["SentPaymentLocaleOrderBy"]: ValueTypes["SentPaymentLocaleOrderBy"];
	["SentPaymentOrderBy"]: ValueTypes["SentPaymentOrderBy"];
	["SentPaymentLocalesByLocaleUniqueWhere"]: ValueTypes["SentPaymentLocalesByLocaleUniqueWhere"];
	["PostAreaLocalesByLocaleUniqueWhere"]: ValueTypes["PostAreaLocalesByLocaleUniqueWhere"];
	["PostAreaLocalesByLinkUniqueWhere"]: ValueTypes["PostAreaLocalesByLinkUniqueWhere"];
	["PostAreaLocalesBySeoUniqueWhere"]: ValueTypes["PostAreaLocalesBySeoUniqueWhere"];
	["PostAreaLocalesByBannerUniqueWhere"]: ValueTypes["PostAreaLocalesByBannerUniqueWhere"];
	["PostAreaLocalesByContentUniqueWhere"]: ValueTypes["PostAreaLocalesByContentUniqueWhere"];
	["PostAreaPostsBySpecificSymbolUniqueWhere"]: ValueTypes["PostAreaPostsBySpecificSymbolUniqueWhere"];
	["PostAreaPostsByActiveRevisionUniqueWhere"]: ValueTypes["PostAreaPostsByActiveRevisionUniqueWhere"];
	["PostAreaPostsByRevisionsUniqueWhere"]: ValueTypes["PostAreaPostsByRevisionsUniqueWhere"];
	["PostAreaPostsByLocalesUniqueWhere"]: ValueTypes["PostAreaPostsByLocalesUniqueWhere"];
	["PostAreaPostsByMetaUniqueWhere"]: ValueTypes["PostAreaPostsByMetaUniqueWhere"];
	["PostAreaPostsByFundraiseCurrencySumsUniqueWhere"]: ValueTypes["PostAreaPostsByFundraiseCurrencySumsUniqueWhere"];
	["PostAreaPostsByFundraiseSumUniqueWhere"]: ValueTypes["PostAreaPostsByFundraiseSumUniqueWhere"];
	["PostAreaPostsByFundraisingProgressUniqueWhere"]: ValueTypes["PostAreaPostsByFundraisingProgressUniqueWhere"];
	["PostAreaSentPaymentsByLocalesUniqueWhere"]: ValueTypes["PostAreaSentPaymentsByLocalesUniqueWhere"];
	["PostOrganizationPostsBySpecificSymbolUniqueWhere"]: ValueTypes["PostOrganizationPostsBySpecificSymbolUniqueWhere"];
	["PostOrganizationPostsByActiveRevisionUniqueWhere"]: ValueTypes["PostOrganizationPostsByActiveRevisionUniqueWhere"];
	["PostOrganizationPostsByRevisionsUniqueWhere"]: ValueTypes["PostOrganizationPostsByRevisionsUniqueWhere"];
	["PostOrganizationPostsByLocalesUniqueWhere"]: ValueTypes["PostOrganizationPostsByLocalesUniqueWhere"];
	["PostOrganizationPostsByMetaUniqueWhere"]: ValueTypes["PostOrganizationPostsByMetaUniqueWhere"];
	["PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere"]: ValueTypes["PostOrganizationPostsByFundraiseCurrencySumsUniqueWhere"];
	["PostOrganizationPostsByFundraiseSumUniqueWhere"]: ValueTypes["PostOrganizationPostsByFundraiseSumUniqueWhere"];
	["PostOrganizationPostsByFundraisingProgressUniqueWhere"]: ValueTypes["PostOrganizationPostsByFundraisingProgressUniqueWhere"];
	["PostOrganizationLocalesByLocaleUniqueWhere"]: ValueTypes["PostOrganizationLocalesByLocaleUniqueWhere"];
	["PostOrganizationLocalesByLinkUniqueWhere"]: ValueTypes["PostOrganizationLocalesByLinkUniqueWhere"];
	["PostOrganizationLocalesByDomainUniqueWhere"]: ValueTypes["PostOrganizationLocalesByDomainUniqueWhere"];
	["PostOrganizationLocalesBySeoUniqueWhere"]: ValueTypes["PostOrganizationLocalesBySeoUniqueWhere"];
	["PostOrganizationLocalesByContentUniqueWhere"]: ValueTypes["PostOrganizationLocalesByContentUniqueWhere"];
	["PostOrganizationSentPaymentsByLocalesUniqueWhere"]: ValueTypes["PostOrganizationSentPaymentsByLocalesUniqueWhere"];
	["PostRevisionLocaleOrderBy"]: ValueTypes["PostRevisionLocaleOrderBy"];
	["PostRevisionLocalesByLocaleUniqueWhere"]: ValueTypes["PostRevisionLocalesByLocaleUniqueWhere"];
	["PostRevisionLocalesByContentUniqueWhere"]: ValueTypes["PostRevisionLocalesByContentUniqueWhere"];
	["PostRevisionLocalesBySeoUniqueWhere"]: ValueTypes["PostRevisionLocalesBySeoUniqueWhere"];
	["PostRevisionLocalesByLeadContentUniqueWhere"]: ValueTypes["PostRevisionLocalesByLeadContentUniqueWhere"];
	["HeroCarouselItemOrderBy"]: ValueTypes["HeroCarouselItemOrderBy"];
	["HeroCarouselOrderBy"]: ValueTypes["HeroCarouselOrderBy"];
	["ReportPageLocalesByLocaleUniqueWhere"]: ValueTypes["ReportPageLocalesByLocaleUniqueWhere"];
	["ReportPageLocalesByLinkUniqueWhere"]: ValueTypes["ReportPageLocalesByLinkUniqueWhere"];
	["ReportPageLocalesByContentUniqueWhere"]: ValueTypes["ReportPageLocalesByContentUniqueWhere"];
	["ReportPageLocalesBySeoUniqueWhere"]: ValueTypes["ReportPageLocalesBySeoUniqueWhere"];
	["ContentReferenceOrderBy"]: ValueTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: ValueTypes["ContentBlockOrderBy"];
	["ValueListOrderBy"]: ValueTypes["ValueListOrderBy"];
	["ImageLinkListOrderBy"]: ValueTypes["ImageLinkListOrderBy"];
	["PostAreaListOrderBy"]: ValueTypes["PostAreaListOrderBy"];
	["AccordionOrderBy"]: ValueTypes["AccordionOrderBy"];
	["MediumListOrderBy"]: ValueTypes["MediumListOrderBy"];
	["MemberListOrderBy"]: ValueTypes["MemberListOrderBy"];
	["FormOrderBy"]: ValueTypes["FormOrderBy"];
	["FilledTaxFormOrderBy"]: ValueTypes["FilledTaxFormOrderBy"];
	["TextImageListOrderBy"]: ValueTypes["TextImageListOrderBy"];
	["PostRevisionsByLocalesUniqueWhere"]: ValueTypes["PostRevisionsByLocalesUniqueWhere"];
	["PostRevisionsByRegionListOverrideUniqueWhere"]: ValueTypes["PostRevisionsByRegionListOverrideUniqueWhere"];
	["PostLocalesByLocaleUniqueWhere"]: ValueTypes["PostLocalesByLocaleUniqueWhere"];
	["PostLocalesByContentUniqueWhere"]: ValueTypes["PostLocalesByContentUniqueWhere"];
	["PostLocalesBySeoUniqueWhere"]: ValueTypes["PostLocalesBySeoUniqueWhere"];
	["PostLocalesByLinkUniqueWhere"]: ValueTypes["PostLocalesByLinkUniqueWhere"];
	["GivenGiftsPageLocalesByLocaleUniqueWhere"]: ValueTypes["GivenGiftsPageLocalesByLocaleUniqueWhere"];
	["GivenGiftsPageLocalesByContentUniqueWhere"]: ValueTypes["GivenGiftsPageLocalesByContentUniqueWhere"];
	["GivenGiftsPageLocalesBySeoUniqueWhere"]: ValueTypes["GivenGiftsPageLocalesBySeoUniqueWhere"];
	["GivenGiftsPageLocalesByLinkUniqueWhere"]: ValueTypes["GivenGiftsPageLocalesByLinkUniqueWhere"];
	["ReceivedGiftsPageLocalesByLocaleUniqueWhere"]: ValueTypes["ReceivedGiftsPageLocalesByLocaleUniqueWhere"];
	["ReceivedGiftsPageLocalesByLinkUniqueWhere"]: ValueTypes["ReceivedGiftsPageLocalesByLinkUniqueWhere"];
	["ReceivedGiftsPageLocalesByContentUniqueWhere"]: ValueTypes["ReceivedGiftsPageLocalesByContentUniqueWhere"];
	["ReceivedGiftsPageLocalesBySeoUniqueWhere"]: ValueTypes["ReceivedGiftsPageLocalesBySeoUniqueWhere"];
	["ContentReferenceLinkableItemOrderBy"]: ValueTypes["ContentReferenceLinkableItemOrderBy"];
	["ValueItemOrderBy"]: ValueTypes["ValueItemOrderBy"];
	["ValueOrderBy"]: ValueTypes["ValueOrderBy"];
	["ImageLinkItemOrderBy"]: ValueTypes["ImageLinkItemOrderBy"];
	["ImageLinkOrderBy"]: ValueTypes["ImageLinkOrderBy"];
	["PostAreaListItemOrderBy"]: ValueTypes["PostAreaListItemOrderBy"];
	["AccordionItemOrderBy"]: ValueTypes["AccordionItemOrderBy"];
	["AccordionItemsByDescriptionContentUniqueWhere"]: ValueTypes["AccordionItemsByDescriptionContentUniqueWhere"];
	["MediumItemOrderBy"]: ValueTypes["MediumItemOrderBy"];
	["MediumOrderBy"]: ValueTypes["MediumOrderBy"];
	["MemberListItemOrderBy"]: ValueTypes["MemberListItemOrderBy"];
	["MemberListItemsByDescriptionContentUniqueWhere"]: ValueTypes["MemberListItemsByDescriptionContentUniqueWhere"];
	["PostOrganizationListItemOrderBy"]: ValueTypes["PostOrganizationListItemOrderBy"];
	["PostOrganizationListItemsByLinkUniqueWhere"]: ValueTypes["PostOrganizationListItemsByLinkUniqueWhere"];
	["TextImageListItemOrderBy"]: ValueTypes["TextImageListItemOrderBy"];
	["ContentReferenceLinkablesByItemUniqueWhere"]: ValueTypes["ContentReferenceLinkablesByItemUniqueWhere"];
	["ContentBlockReferencesByLinkablesUniqueWhere"]: ValueTypes["ContentBlockReferencesByLinkablesUniqueWhere"];
	["ContentBlockReferencesByLinkUniqueWhere"]: ValueTypes["ContentBlockReferencesByLinkUniqueWhere"];
	["ContentBlockReferencesByValueListUniqueWhere"]: ValueTypes["ContentBlockReferencesByValueListUniqueWhere"];
	["ContentBlockReferencesByImageLinkListUniqueWhere"]: ValueTypes["ContentBlockReferencesByImageLinkListUniqueWhere"];
	["ContentBlockReferencesByAreaListUniqueWhere"]: ValueTypes["ContentBlockReferencesByAreaListUniqueWhere"];
	["ContentBlockReferencesByAccordionUniqueWhere"]: ValueTypes["ContentBlockReferencesByAccordionUniqueWhere"];
	["ContentBlockReferencesByMediaUniqueWhere"]: ValueTypes["ContentBlockReferencesByMediaUniqueWhere"];
	["ContentBlockReferencesByMemberListUniqueWhere"]: ValueTypes["ContentBlockReferencesByMemberListUniqueWhere"];
	["ContentBlockReferencesByContentWithoutBlocksUniqueWhere"]: ValueTypes["ContentBlockReferencesByContentWithoutBlocksUniqueWhere"];
	["ContentBlockReferencesByOrganizationListUniqueWhere"]: ValueTypes["ContentBlockReferencesByOrganizationListUniqueWhere"];
	["ContentBlockReferencesByTextImageListUniqueWhere"]: ValueTypes["ContentBlockReferencesByTextImageListUniqueWhere"];
	["ContentBlocksByReferencesUniqueWhere"]: ValueTypes["ContentBlocksByReferencesUniqueWhere"];
	["HeaderLocaleOrderBy"]: ValueTypes["HeaderLocaleOrderBy"];
	["HeaderOrderBy"]: ValueTypes["HeaderOrderBy"];
	["LinkListOrderBy"]: ValueTypes["LinkListOrderBy"];
	["HeaderLocalesByLocaleUniqueWhere"]: ValueTypes["HeaderLocalesByLocaleUniqueWhere"];
	["HeaderLocalesByLinksUniqueWhere"]: ValueTypes["HeaderLocalesByLinksUniqueWhere"];
	["LinkItemOrderBy"]: ValueTypes["LinkItemOrderBy"];
	["LinkListItemsByLinkUniqueWhere"]: ValueTypes["LinkListItemsByLinkUniqueWhere"];
	["FooterLocaleOrderBy"]: ValueTypes["FooterLocaleOrderBy"];
	["FooterOrderBy"]: ValueTypes["FooterOrderBy"];
	["FooterLocalesByLocaleUniqueWhere"]: ValueTypes["FooterLocalesByLocaleUniqueWhere"];
	["FooterLocalesByLinkListUniqueWhere"]: ValueTypes["FooterLocalesByLinkListUniqueWhere"];
	["FooterLocalesByAddressInfoUniqueWhere"]: ValueTypes["FooterLocalesByAddressInfoUniqueWhere"];
	["FooterLocalesByImageLinkListUniqueWhere"]: ValueTypes["FooterLocalesByImageLinkListUniqueWhere"];
	["GenericPageAboutSettingsLocaleOrderBy"]: ValueTypes["GenericPageAboutSettingsLocaleOrderBy"];
	["GenericPageAboutSettingsOrderBy"]: ValueTypes["GenericPageAboutSettingsOrderBy"];
	["GenericPageAboutSettingsLocalesByLocaleUniqueWhere"]: ValueTypes["GenericPageAboutSettingsLocalesByLocaleUniqueWhere"];
	["GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere"]: ValueTypes["GenericPageAboutSettingsLocalesByLinkGroupsUniqueWhere"];
	["GenericPageAboutGroupLinksLocaleOrderBy"]: ValueTypes["GenericPageAboutGroupLinksLocaleOrderBy"];
	["GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere"]: ValueTypes["GenericPageAboutSettingsLocaleLinkGroupsByLinkListUniqueWhere"];
	["FeedPageLocaleOrderBy"]: ValueTypes["FeedPageLocaleOrderBy"];
	["FeedPageOrderBy"]: ValueTypes["FeedPageOrderBy"];
	["TileListOrderBy"]: ValueTypes["TileListOrderBy"];
	["CardListOrderBy"]: ValueTypes["CardListOrderBy"];
	["StoryGuideListOrderBy"]: ValueTypes["StoryGuideListOrderBy"];
	["FeedPageLocalesByLocaleUniqueWhere"]: ValueTypes["FeedPageLocalesByLocaleUniqueWhere"];
	["FeedPageLocalesByHeroTilesUniqueWhere"]: ValueTypes["FeedPageLocalesByHeroTilesUniqueWhere"];
	["FeedPageLocalesBySectionListUniqueWhere"]: ValueTypes["FeedPageLocalesBySectionListUniqueWhere"];
	["FeedPageLocalesByCardListUniqueWhere"]: ValueTypes["FeedPageLocalesByCardListUniqueWhere"];
	["FeedPageLocalesByStoryGuideListUniqueWhere"]: ValueTypes["FeedPageLocalesByStoryGuideListUniqueWhere"];
	["TileItemOrderBy"]: ValueTypes["TileItemOrderBy"];
	["TileListItemsByLinkUniqueWhere"]: ValueTypes["TileListItemsByLinkUniqueWhere"];
	["FeedPageTileStripeOrderBy"]: ValueTypes["FeedPageTileStripeOrderBy"];
	["FeedPageSectionOrderBy"]: ValueTypes["FeedPageSectionOrderBy"];
	["CardItemOrderBy"]: ValueTypes["CardItemOrderBy"];
	["CardListItemsByLinkUniqueWhere"]: ValueTypes["CardListItemsByLinkUniqueWhere"];
	["StoryGuideItemOrderBy"]: ValueTypes["StoryGuideItemOrderBy"];
	["StoryGuideOrderBy"]: ValueTypes["StoryGuideOrderBy"];
	["FeedPageLocaleSectionListByTileStripeListUniqueWhere"]: ValueTypes["FeedPageLocaleSectionListByTileStripeListUniqueWhere"];
	["RecurringPaymentPageLocaleOrderBy"]: ValueTypes["RecurringPaymentPageLocaleOrderBy"];
	["RecurringPaymentPageOrderBy"]: ValueTypes["RecurringPaymentPageOrderBy"];
	["PostListOrderBy"]: ValueTypes["PostListOrderBy"];
	["RecurringPaymentPageLocalesByLocaleUniqueWhere"]: ValueTypes["RecurringPaymentPageLocalesByLocaleUniqueWhere"];
	["RecurringPaymentPageLocalesByFavouritePostsUniqueWhere"]: ValueTypes["RecurringPaymentPageLocalesByFavouritePostsUniqueWhere"];
	["RecurringPaymentPageLocalesByStoryGuideListUniqueWhere"]: ValueTypes["RecurringPaymentPageLocalesByStoryGuideListUniqueWhere"];
	["PostListItemOrderBy"]: ValueTypes["PostListItemOrderBy"];
	["ScheduledNotificationLocaleOrderBy"]: ValueTypes["ScheduledNotificationLocaleOrderBy"];
	["ScheduledNotificationOrderBy"]: ValueTypes["ScheduledNotificationOrderBy"];
	["NotificationTargetGroupOrderBy"]: ValueTypes["NotificationTargetGroupOrderBy"];
	["CsobPaymentStatusChangeOrderBy"]: ValueTypes["CsobPaymentStatusChangeOrderBy"];
	["CsobPaymentOrderBy"]: ValueTypes["CsobPaymentOrderBy"];
	["UserPaymentOrderBy"]: ValueTypes["UserPaymentOrderBy"];
	["UserPaymentOrderIdOrderBy"]: ValueTypes["UserPaymentOrderIdOrderBy"];
	["StripePaymentOrderBy"]: ValueTypes["StripePaymentOrderBy"];
	["StripePaymentMetadataOrderBy"]: ValueTypes["StripePaymentMetadataOrderBy"];
	["UserRecurringPaymentItemOrderBy"]: ValueTypes["UserRecurringPaymentItemOrderBy"];
	["UserRecurringPaymentOrderBy"]: ValueTypes["UserRecurringPaymentOrderBy"];
	["UserOrderBy"]: ValueTypes["UserOrderBy"];
	["UserStatsOrderBy"]: ValueTypes["UserStatsOrderBy"];
	["UpcomingUserRecurringPaymentMetadataOrderBy"]: ValueTypes["UpcomingUserRecurringPaymentMetadataOrderBy"];
	["UserRecurringPaymentItemMetadataOrderBy"]: ValueTypes["UserRecurringPaymentItemMetadataOrderBy"];
	["OnBehalfDonationOrderBy"]: ValueTypes["OnBehalfDonationOrderBy"];
	["OnBehalfDonationMetadataOrderBy"]: ValueTypes["OnBehalfDonationMetadataOrderBy"];
	["UserPaymentTriesCollectionOrderBy"]: ValueTypes["UserPaymentTriesCollectionOrderBy"];
	["UserPaymentTriesCollectionMetadataOrderBy"]: ValueTypes["UserPaymentTriesCollectionMetadataOrderBy"];
	["UserPaymentMetadataOrderBy"]: ValueTypes["UserPaymentMetadataOrderBy"];
	["CsobPaymentMetadataOrderBy"]: ValueTypes["CsobPaymentMetadataOrderBy"];
	["StripePaymentStatusChangeOrderBy"]: ValueTypes["StripePaymentStatusChangeOrderBy"];
	["UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere"]: ValueTypes["UserRecurringPaymentItemsByRecurrenceCounterUniqueWhere"];
	["UserRecurringPaymentItemsByPaymentsUniqueWhere"]: ValueTypes["UserRecurringPaymentItemsByPaymentsUniqueWhere"];
	["UserPaymentUniqueWhere"]: ValueTypes["UserPaymentUniqueWhere"];
	["UserPaymentOrderIdUniqueWhere"]: ValueTypes["UserPaymentOrderIdUniqueWhere"];
	["CsobPaymentUniqueWhere"]: ValueTypes["CsobPaymentUniqueWhere"];
	["CsobPaymentStatusChangeUniqueWhere"]: ValueTypes["CsobPaymentStatusChangeUniqueWhere"];
	["CsobPaymentMetadataUniqueWhere"]: ValueTypes["CsobPaymentMetadataUniqueWhere"];
	["StripePaymentUniqueWhere"]: ValueTypes["StripePaymentUniqueWhere"];
	["StripePaymentStatusChangeUniqueWhere"]: ValueTypes["StripePaymentStatusChangeUniqueWhere"];
	["StripePaymentMetadataUniqueWhere"]: ValueTypes["StripePaymentMetadataUniqueWhere"];
	["UserPaymentMetadataUniqueWhere"]: ValueTypes["UserPaymentMetadataUniqueWhere"];
	["UserRecurringPaymentItemsByMetaUniqueWhere"]: ValueTypes["UserRecurringPaymentItemsByMetaUniqueWhere"];
	["UserRecurringPaymentItemMetadataUniqueWhere"]: ValueTypes["UserRecurringPaymentItemMetadataUniqueWhere"];
	["UserRecurringPaymentItemUniqueWhere"]: ValueTypes["UserRecurringPaymentItemUniqueWhere"];
	["UserRecurringPaymentUniqueWhere"]: ValueTypes["UserRecurringPaymentUniqueWhere"];
	["UpcomingUserRecurringPaymentMetadataUniqueWhere"]: ValueTypes["UpcomingUserRecurringPaymentMetadataUniqueWhere"];
	["UserRecurringPaymentItemPaymentsByOrderUniqueWhere"]: ValueTypes["UserRecurringPaymentItemPaymentsByOrderUniqueWhere"];
	["UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere"]: ValueTypes["UserRecurringPaymentItemPaymentsByCsobPaymentUniqueWhere"];
	["UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere"]: ValueTypes["UserRecurringPaymentItemPaymentsByStripePaymentUniqueWhere"];
	["UserRecurringPaymentItemPaymentsByMetadataUniqueWhere"]: ValueTypes["UserRecurringPaymentItemPaymentsByMetadataUniqueWhere"];
	["OnBehalfDonationPaymentsByOrderUniqueWhere"]: ValueTypes["OnBehalfDonationPaymentsByOrderUniqueWhere"];
	["OnBehalfDonationPaymentsByCsobPaymentUniqueWhere"]: ValueTypes["OnBehalfDonationPaymentsByCsobPaymentUniqueWhere"];
	["OnBehalfDonationPaymentsByStripePaymentUniqueWhere"]: ValueTypes["OnBehalfDonationPaymentsByStripePaymentUniqueWhere"];
	["OnBehalfDonationPaymentsByMetadataUniqueWhere"]: ValueTypes["OnBehalfDonationPaymentsByMetadataUniqueWhere"];
	["UserPaymentTriesCollectionMetadataLocaleOrderBy"]: ValueTypes["UserPaymentTriesCollectionMetadataLocaleOrderBy"];
	["UserPaymentTriesCollectionPaymentByOrderUniqueWhere"]: ValueTypes["UserPaymentTriesCollectionPaymentByOrderUniqueWhere"];
	["UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere"]: ValueTypes["UserPaymentTriesCollectionPaymentByCsobPaymentUniqueWhere"];
	["UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere"]: ValueTypes["UserPaymentTriesCollectionPaymentByStripePaymentUniqueWhere"];
	["UserPaymentTriesCollectionPaymentByMetadataUniqueWhere"]: ValueTypes["UserPaymentTriesCollectionPaymentByMetadataUniqueWhere"];
	["UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere"]: ValueTypes["UserPaymentTriesCollectionMetadataLocalesByLocaleUniqueWhere"];
	["DeviceOrderBy"]: ValueTypes["DeviceOrderBy"];
	["ProcessedNotificationSourceOrderBy"]: ValueTypes["ProcessedNotificationSourceOrderBy"];
	["ProcessedNotificationOrderBy"]: ValueTypes["ProcessedNotificationOrderBy"];
	["UserAreaStatsOrderBy"]: ValueTypes["UserAreaStatsOrderBy"];
	["UserOrganizationStatsOrderBy"]: ValueTypes["UserOrganizationStatsOrderBy"];
	["UserPostStatsOrderBy"]: ValueTypes["UserPostStatsOrderBy"];
	["UserCurrencyStatsOrderBy"]: ValueTypes["UserCurrencyStatsOrderBy"];
	["UserPaymentsByOrderUniqueWhere"]: ValueTypes["UserPaymentsByOrderUniqueWhere"];
	["UserPaymentsByCsobPaymentUniqueWhere"]: ValueTypes["UserPaymentsByCsobPaymentUniqueWhere"];
	["UserPaymentsByStripePaymentUniqueWhere"]: ValueTypes["UserPaymentsByStripePaymentUniqueWhere"];
	["UserPaymentsByMetadataUniqueWhere"]: ValueTypes["UserPaymentsByMetadataUniqueWhere"];
	["UserRecurringPaymentsByItemsUniqueWhere"]: ValueTypes["UserRecurringPaymentsByItemsUniqueWhere"];
	["UserRecurringPaymentsByMetaUniqueWhere"]: ValueTypes["UserRecurringPaymentsByMetaUniqueWhere"];
	["UserOnBehalfDonationsBySecretCodeUniqueWhere"]: ValueTypes["UserOnBehalfDonationsBySecretCodeUniqueWhere"];
	["UserOnBehalfDonationsByPaymentsUniqueWhere"]: ValueTypes["UserOnBehalfDonationsByPaymentsUniqueWhere"];
	["UserOnBehalfDonationsByMetaUniqueWhere"]: ValueTypes["UserOnBehalfDonationsByMetaUniqueWhere"];
	["OnBehalfDonationMetadataUniqueWhere"]: ValueTypes["OnBehalfDonationMetadataUniqueWhere"];
	["OnBehalfDonationUniqueWhere"]: ValueTypes["OnBehalfDonationUniqueWhere"];
	["UserDevicesByFcmTokenUniqueWhere"]: ValueTypes["UserDevicesByFcmTokenUniqueWhere"];
	["UserProcessedNotificationsByProcessedNotificationUniqueWhere"]: ValueTypes["UserProcessedNotificationsByProcessedNotificationUniqueWhere"];
	["ScheduledNotificationLocalesByLocaleUniqueWhere"]: ValueTypes["ScheduledNotificationLocalesByLocaleUniqueWhere"];
	["ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere"]: ValueTypes["ScheduledNotificationProcessedNotificationsByProcessedNotificationUniqueWhere"];
	["LocaleGeneralsByRootUniqueWhere"]: ValueTypes["LocaleGeneralsByRootUniqueWhere"];
	["LocaleGeneralsBySeoUniqueWhere"]: ValueTypes["LocaleGeneralsBySeoUniqueWhere"];
	["LocaleGeneralsByAppStoreLinkUniqueWhere"]: ValueTypes["LocaleGeneralsByAppStoreLinkUniqueWhere"];
	["LocaleGeneralsByGooglePlayLinkUniqueWhere"]: ValueTypes["LocaleGeneralsByGooglePlayLinkUniqueWhere"];
	["LocaleGenericPagesByRootUniqueWhere"]: ValueTypes["LocaleGenericPagesByRootUniqueWhere"];
	["LocaleGenericPagesByContentUniqueWhere"]: ValueTypes["LocaleGenericPagesByContentUniqueWhere"];
	["LocaleGenericPagesBySeoUniqueWhere"]: ValueTypes["LocaleGenericPagesBySeoUniqueWhere"];
	["LocaleGenericPagesByLinkUniqueWhere"]: ValueTypes["LocaleGenericPagesByLinkUniqueWhere"];
	["LocalePostsByRootUniqueWhere"]: ValueTypes["LocalePostsByRootUniqueWhere"];
	["LocalePostsByContentUniqueWhere"]: ValueTypes["LocalePostsByContentUniqueWhere"];
	["LocalePostsBySeoUniqueWhere"]: ValueTypes["LocalePostsBySeoUniqueWhere"];
	["LocalePostsByLinkUniqueWhere"]: ValueTypes["LocalePostsByLinkUniqueWhere"];
	["LocalePostAreasByRootUniqueWhere"]: ValueTypes["LocalePostAreasByRootUniqueWhere"];
	["LocalePostAreasByLinkUniqueWhere"]: ValueTypes["LocalePostAreasByLinkUniqueWhere"];
	["LocalePostAreasBySeoUniqueWhere"]: ValueTypes["LocalePostAreasBySeoUniqueWhere"];
	["LocalePostAreasByBannerUniqueWhere"]: ValueTypes["LocalePostAreasByBannerUniqueWhere"];
	["LocalePostAreasByContentUniqueWhere"]: ValueTypes["LocalePostAreasByContentUniqueWhere"];
	["LocalePostOrganizationsByRootUniqueWhere"]: ValueTypes["LocalePostOrganizationsByRootUniqueWhere"];
	["LocalePostOrganizationsByLinkUniqueWhere"]: ValueTypes["LocalePostOrganizationsByLinkUniqueWhere"];
	["LocalePostOrganizationsByDomainUniqueWhere"]: ValueTypes["LocalePostOrganizationsByDomainUniqueWhere"];
	["LocalePostOrganizationsBySeoUniqueWhere"]: ValueTypes["LocalePostOrganizationsBySeoUniqueWhere"];
	["LocalePostOrganizationsByContentUniqueWhere"]: ValueTypes["LocalePostOrganizationsByContentUniqueWhere"];
	["LocaleHeadersByRootUniqueWhere"]: ValueTypes["LocaleHeadersByRootUniqueWhere"];
	["LocaleHeadersByLinksUniqueWhere"]: ValueTypes["LocaleHeadersByLinksUniqueWhere"];
	["LocaleFootersByRootUniqueWhere"]: ValueTypes["LocaleFootersByRootUniqueWhere"];
	["LocaleFootersByLinkListUniqueWhere"]: ValueTypes["LocaleFootersByLinkListUniqueWhere"];
	["LocaleFootersByAddressInfoUniqueWhere"]: ValueTypes["LocaleFootersByAddressInfoUniqueWhere"];
	["LocaleFootersByImageLinkListUniqueWhere"]: ValueTypes["LocaleFootersByImageLinkListUniqueWhere"];
	["LocaleGenericPageAboutSettingsByRootUniqueWhere"]: ValueTypes["LocaleGenericPageAboutSettingsByRootUniqueWhere"];
	["LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere"]: ValueTypes["LocaleGenericPageAboutSettingsByLinkGroupsUniqueWhere"];
	["LocalePostRevisionsByRootUniqueWhere"]: ValueTypes["LocalePostRevisionsByRootUniqueWhere"];
	["LocalePostRevisionsByContentUniqueWhere"]: ValueTypes["LocalePostRevisionsByContentUniqueWhere"];
	["LocalePostRevisionsBySeoUniqueWhere"]: ValueTypes["LocalePostRevisionsBySeoUniqueWhere"];
	["LocalePostRevisionsByLeadContentUniqueWhere"]: ValueTypes["LocalePostRevisionsByLeadContentUniqueWhere"];
	["LocaleFeedPagesByRootUniqueWhere"]: ValueTypes["LocaleFeedPagesByRootUniqueWhere"];
	["LocaleFeedPagesByHeroTilesUniqueWhere"]: ValueTypes["LocaleFeedPagesByHeroTilesUniqueWhere"];
	["LocaleFeedPagesBySectionListUniqueWhere"]: ValueTypes["LocaleFeedPagesBySectionListUniqueWhere"];
	["LocaleFeedPagesByCardListUniqueWhere"]: ValueTypes["LocaleFeedPagesByCardListUniqueWhere"];
	["LocaleFeedPagesByStoryGuideListUniqueWhere"]: ValueTypes["LocaleFeedPagesByStoryGuideListUniqueWhere"];
	["LocaleRecurringPaymentPagesByRootUniqueWhere"]: ValueTypes["LocaleRecurringPaymentPagesByRootUniqueWhere"];
	["LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere"]: ValueTypes["LocaleRecurringPaymentPagesByFavouritePostsUniqueWhere"];
	["LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere"]: ValueTypes["LocaleRecurringPaymentPagesByStoryGuideListUniqueWhere"];
	["LocaleGivenGiftsPagesByRootUniqueWhere"]: ValueTypes["LocaleGivenGiftsPagesByRootUniqueWhere"];
	["LocaleGivenGiftsPagesByContentUniqueWhere"]: ValueTypes["LocaleGivenGiftsPagesByContentUniqueWhere"];
	["LocaleGivenGiftsPagesBySeoUniqueWhere"]: ValueTypes["LocaleGivenGiftsPagesBySeoUniqueWhere"];
	["LocaleGivenGiftsPagesByLinkUniqueWhere"]: ValueTypes["LocaleGivenGiftsPagesByLinkUniqueWhere"];
	["LocaleReceivedGiftsPagesByRootUniqueWhere"]: ValueTypes["LocaleReceivedGiftsPagesByRootUniqueWhere"];
	["LocaleReceivedGiftsPagesByLinkUniqueWhere"]: ValueTypes["LocaleReceivedGiftsPagesByLinkUniqueWhere"];
	["LocaleReceivedGiftsPagesByContentUniqueWhere"]: ValueTypes["LocaleReceivedGiftsPagesByContentUniqueWhere"];
	["LocaleReceivedGiftsPagesBySeoUniqueWhere"]: ValueTypes["LocaleReceivedGiftsPagesBySeoUniqueWhere"];
	["LocaleReportPagesByRootUniqueWhere"]: ValueTypes["LocaleReportPagesByRootUniqueWhere"];
	["LocaleReportPagesByLinkUniqueWhere"]: ValueTypes["LocaleReportPagesByLinkUniqueWhere"];
	["LocaleReportPagesByContentUniqueWhere"]: ValueTypes["LocaleReportPagesByContentUniqueWhere"];
	["LocaleReportPagesBySeoUniqueWhere"]: ValueTypes["LocaleReportPagesBySeoUniqueWhere"];
	["LocaleReportNavigationsByRootUniqueWhere"]: ValueTypes["LocaleReportNavigationsByRootUniqueWhere"];
	["LocaleScheduledNotificationsByRootUniqueWhere"]: ValueTypes["LocaleScheduledNotificationsByRootUniqueWhere"];
	["LocaleSentPaymentsByRootUniqueWhere"]: ValueTypes["LocaleSentPaymentsByRootUniqueWhere"];
	["GeneralLocalesByLocaleUniqueWhere"]: ValueTypes["GeneralLocalesByLocaleUniqueWhere"];
	["GeneralLocalesBySeoUniqueWhere"]: ValueTypes["GeneralLocalesBySeoUniqueWhere"];
	["GeneralLocalesByAppStoreLinkUniqueWhere"]: ValueTypes["GeneralLocalesByAppStoreLinkUniqueWhere"];
	["GeneralLocalesByGooglePlayLinkUniqueWhere"]: ValueTypes["GeneralLocalesByGooglePlayLinkUniqueWhere"];
	["GeneralCreateInput"]: ValueTypes["GeneralCreateInput"];
	["GeneralCreateLocalesEntityRelationInput"]: ValueTypes["GeneralCreateLocalesEntityRelationInput"];
	["GeneralLocaleWithoutRootCreateInput"]: ValueTypes["GeneralLocaleWithoutRootCreateInput"];
	["GeneralLocaleCreateLocaleEntityRelationInput"]: ValueTypes["GeneralLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutGeneralsCreateInput"]: ValueTypes["LocaleWithoutGeneralsCreateInput"];
	["LocaleCreateGenericPagesEntityRelationInput"]: ValueTypes["LocaleCreateGenericPagesEntityRelationInput"];
	["GenericPageLocaleWithoutLocaleCreateInput"]: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"];
	["GenericPageLocaleCreateRootEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateRootEntityRelationInput"];
	["GenericPageWithoutLocalesCreateInput"]: ValueTypes["GenericPageWithoutLocalesCreateInput"];
	["GenericPageCreateReportNavigationEntityRelationInput"]: ValueTypes["GenericPageCreateReportNavigationEntityRelationInput"];
	["ReportNavigationLocaleWithoutPagesCreateInput"]: ValueTypes["ReportNavigationLocaleWithoutPagesCreateInput"];
	["ReportNavigationLocaleCreateRootEntityRelationInput"]: ValueTypes["ReportNavigationLocaleCreateRootEntityRelationInput"];
	["ReportNavigationWithoutLocalesCreateInput"]: ValueTypes["ReportNavigationWithoutLocalesCreateInput"];
	["ReportNavigationLocaleConnectOrCreateRootRelationInput"]: ValueTypes["ReportNavigationLocaleConnectOrCreateRootRelationInput"];
	["ReportNavigationLocaleCreateLocaleEntityRelationInput"]: ValueTypes["ReportNavigationLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutReportNavigationsCreateInput"]: ValueTypes["LocaleWithoutReportNavigationsCreateInput"];
	["LocaleCreateGeneralsEntityRelationInput"]: ValueTypes["LocaleCreateGeneralsEntityRelationInput"];
	["GeneralLocaleWithoutLocaleCreateInput"]: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"];
	["GeneralLocaleCreateRootEntityRelationInput"]: ValueTypes["GeneralLocaleCreateRootEntityRelationInput"];
	["GeneralWithoutLocalesCreateInput"]: ValueTypes["GeneralWithoutLocalesCreateInput"];
	["GeneralCreateAllAreasIconEntityRelationInput"]: ValueTypes["GeneralCreateAllAreasIconEntityRelationInput"];
	["ImageCreateInput"]: ValueTypes["ImageCreateInput"];
	["GeneralConnectOrCreateAllAreasIconRelationInput"]: ValueTypes["GeneralConnectOrCreateAllAreasIconRelationInput"];
	["GeneralCreateAllOrganizationsIconEntityRelationInput"]: ValueTypes["GeneralCreateAllOrganizationsIconEntityRelationInput"];
	["GeneralConnectOrCreateAllOrganizationsIconRelationInput"]: ValueTypes["GeneralConnectOrCreateAllOrganizationsIconRelationInput"];
	["GeneralCreateOrganizationListEntityRelationInput"]: ValueTypes["GeneralCreateOrganizationListEntityRelationInput"];
	["PostOrganizationListCreateInput"]: ValueTypes["PostOrganizationListCreateInput"];
	["PostOrganizationListCreateItemsEntityRelationInput"]: ValueTypes["PostOrganizationListCreateItemsEntityRelationInput"];
	["PostOrganizationListItemWithoutListCreateInput"]: ValueTypes["PostOrganizationListItemWithoutListCreateInput"];
	["PostOrganizationListItemCreateItemEntityRelationInput"]: ValueTypes["PostOrganizationListItemCreateItemEntityRelationInput"];
	["PostOrganizationCreateInput"]: ValueTypes["PostOrganizationCreateInput"];
	["PostOrganizationCreatePostsEntityRelationInput"]: ValueTypes["PostOrganizationCreatePostsEntityRelationInput"];
	["PostWithoutOrganizationCreateInput"]: ValueTypes["PostWithoutOrganizationCreateInput"];
	["PostCreateAreaEntityRelationInput"]: ValueTypes["PostCreateAreaEntityRelationInput"];
	["PostAreaWithoutPostsCreateInput"]: ValueTypes["PostAreaWithoutPostsCreateInput"];
	["PostAreaCreateIconEntityRelationInput"]: ValueTypes["PostAreaCreateIconEntityRelationInput"];
	["PostAreaConnectOrCreateIconRelationInput"]: ValueTypes["PostAreaConnectOrCreateIconRelationInput"];
	["PostAreaCreateLocalesEntityRelationInput"]: ValueTypes["PostAreaCreateLocalesEntityRelationInput"];
	["PostAreaLocaleWithoutRootCreateInput"]: ValueTypes["PostAreaLocaleWithoutRootCreateInput"];
	["PostAreaLocaleCreateLinkEntityRelationInput"]: ValueTypes["PostAreaLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutPostAreaCreateInput"]: ValueTypes["LinkableWithoutPostAreaCreateInput"];
	["LinkableCreateGenericPageEntityRelationInput"]: ValueTypes["LinkableCreateGenericPageEntityRelationInput"];
	["GenericPageLocaleWithoutLinkCreateInput"]: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"];
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutGenericPagesCreateInput"]: ValueTypes["LocaleWithoutGenericPagesCreateInput"];
	["LocaleCreatePostsEntityRelationInput"]: ValueTypes["LocaleCreatePostsEntityRelationInput"];
	["PostLocaleWithoutLocaleCreateInput"]: ValueTypes["PostLocaleWithoutLocaleCreateInput"];
	["PostLocaleCreateContentEntityRelationInput"]: ValueTypes["PostLocaleCreateContentEntityRelationInput"];
	["ContentCreateInput"]: ValueTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: ValueTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: ValueTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: ValueTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: ValueTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateImageEntityRelationInput"]: ValueTypes["ContentReferenceCreateImageEntityRelationInput"];
	["ContentReferenceConnectOrCreateImageRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateImageRelationInput"];
	["ContentReferenceCreateLinkablesEntityRelationInput"]: ValueTypes["ContentReferenceCreateLinkablesEntityRelationInput"];
	["ContentReferenceCreateVideoEntityRelationInput"]: ValueTypes["ContentReferenceCreateVideoEntityRelationInput"];
	["VideoUniqueWhere"]: ValueTypes["VideoUniqueWhere"];
	["VideoCreateInput"]: ValueTypes["VideoCreateInput"];
	["VideoCreatePosterEntityRelationInput"]: ValueTypes["VideoCreatePosterEntityRelationInput"];
	["VideoConnectOrCreatePosterRelationInput"]: ValueTypes["VideoConnectOrCreatePosterRelationInput"];
	["ContentReferenceConnectOrCreateVideoRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateVideoRelationInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: ValueTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: ValueTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableCreateInput"]: ValueTypes["LinkableCreateInput"];
	["LinkableCreatePostEntityRelationInput"]: ValueTypes["LinkableCreatePostEntityRelationInput"];
	["PostLocaleWithoutLinkCreateInput"]: ValueTypes["PostLocaleWithoutLinkCreateInput"];
	["PostLocaleCreateSeoEntityRelationInput"]: ValueTypes["PostLocaleCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: ValueTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: ValueTypes["SeoCreateOgImageEntityRelationInput"];
	["SeoConnectOrCreateOgImageRelationInput"]: ValueTypes["SeoConnectOrCreateOgImageRelationInput"];
	["PostLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["PostLocaleConnectOrCreateSeoRelationInput"];
	["PostLocaleCreateLocaleEntityRelationInput"]: ValueTypes["PostLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPostsCreateInput"]: ValueTypes["LocaleWithoutPostsCreateInput"];
	["LocaleCreatePostAreasEntityRelationInput"]: ValueTypes["LocaleCreatePostAreasEntityRelationInput"];
	["PostAreaLocaleWithoutLocaleCreateInput"]: ValueTypes["PostAreaLocaleWithoutLocaleCreateInput"];
	["PostAreaLocaleCreateRootEntityRelationInput"]: ValueTypes["PostAreaLocaleCreateRootEntityRelationInput"];
	["PostAreaWithoutLocalesCreateInput"]: ValueTypes["PostAreaWithoutLocalesCreateInput"];
	["PostAreaCreateRegionListOverrideEntityRelationInput"]: ValueTypes["PostAreaCreateRegionListOverrideEntityRelationInput"];
	["DonationAmountsRegionListCreateInput"]: ValueTypes["DonationAmountsRegionListCreateInput"];
	["DonationAmountsRegionListCreateRegionsEntityRelationInput"]: ValueTypes["DonationAmountsRegionListCreateRegionsEntityRelationInput"];
	["DonationAmountsRegionItemWithoutListCreateInput"]: ValueTypes["DonationAmountsRegionItemWithoutListCreateInput"];
	["DonationAmountsRegionItemCreateItemsEntityRelationInput"]: ValueTypes["DonationAmountsRegionItemCreateItemsEntityRelationInput"];
	["DonationAmountItemWithoutRegionItemCreateInput"]: ValueTypes["DonationAmountItemWithoutRegionItemCreateInput"];
	["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"]: ValueTypes["DonationAmountsRegionItemConnectOrCreateItemsRelationInput"];
	["DonationAmountsRegionItemCreateRegionEntityRelationInput"]: ValueTypes["DonationAmountsRegionItemCreateRegionEntityRelationInput"];
	["RegionWithoutDonationItemsCreateInput"]: ValueTypes["RegionWithoutDonationItemsCreateInput"];
	["RegionCreateCurrencyEntityRelationInput"]: ValueTypes["RegionCreateCurrencyEntityRelationInput"];
	["CurrencyUniqueWhere"]: ValueTypes["CurrencyUniqueWhere"];
	["CurrencyCreateInput"]: ValueTypes["CurrencyCreateInput"];
	["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: ValueTypes["CurrencyCreateAreaSentPaymentCurrencySumsEntityRelationInput"];
	["CurrencyCreateAreaCurrencySumsEntityRelationInput"]: ValueTypes["CurrencyCreateAreaCurrencySumsEntityRelationInput"];
	["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"]: ValueTypes["CurrencyCreateOrganizationCurrencySumsEntityRelationInput"];
	["CurrencyCreatePostCurrencySumsEntityRelationInput"]: ValueTypes["CurrencyCreatePostCurrencySumsEntityRelationInput"];
	["RegionConnectOrCreateCurrencyRelationInput"]: ValueTypes["RegionConnectOrCreateCurrencyRelationInput"];
	["RegionCreateEnabledPaymentMethodsEntityRelationInput"]: ValueTypes["RegionCreateEnabledPaymentMethodsEntityRelationInput"];
	["RegionPaymentMethodWithoutRegionCreateInput"]: ValueTypes["RegionPaymentMethodWithoutRegionCreateInput"];
	["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"]: ValueTypes["RegionConnectOrCreateEnabledPaymentMethodsRelationInput"];
	["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"]: ValueTypes["DonationAmountsRegionItemConnectOrCreateRegionRelationInput"];
	["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"]: ValueTypes["DonationAmountsRegionListConnectOrCreateRegionsRelationInput"];
	["DonationAmountsRegionListCreateDonationEntityRelationInput"]: ValueTypes["DonationAmountsRegionListCreateDonationEntityRelationInput"];
	["DonationWithoutRegionListCreateInput"]: ValueTypes["DonationWithoutRegionListCreateInput"];
	["DonationAmountsRegionListConnectOrCreateDonationRelationInput"]: ValueTypes["DonationAmountsRegionListConnectOrCreateDonationRelationInput"];
	["PostAreaConnectOrCreateRegionListOverrideRelationInput"]: ValueTypes["PostAreaConnectOrCreateRegionListOverrideRelationInput"];
	["PostAreaCreatePostsEntityRelationInput"]: ValueTypes["PostAreaCreatePostsEntityRelationInput"];
	["PostWithoutAreaCreateInput"]: ValueTypes["PostWithoutAreaCreateInput"];
	["PostCreateOrganizationEntityRelationInput"]: ValueTypes["PostCreateOrganizationEntityRelationInput"];
	["PostOrganizationWithoutPostsCreateInput"]: ValueTypes["PostOrganizationWithoutPostsCreateInput"];
	["PostOrganizationCreateIconEntityRelationInput"]: ValueTypes["PostOrganizationCreateIconEntityRelationInput"];
	["PostOrganizationConnectOrCreateIconRelationInput"]: ValueTypes["PostOrganizationConnectOrCreateIconRelationInput"];
	["PostOrganizationCreateLocalesEntityRelationInput"]: ValueTypes["PostOrganizationCreateLocalesEntityRelationInput"];
	["PostOrganizationLocaleWithoutRootCreateInput"]: ValueTypes["PostOrganizationLocaleWithoutRootCreateInput"];
	["PostOrganizationLocaleCreateLinkEntityRelationInput"]: ValueTypes["PostOrganizationLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutPostOrganizationCreateInput"]: ValueTypes["LinkableWithoutPostOrganizationCreateInput"];
	["LinkableCreatePostAreaEntityRelationInput"]: ValueTypes["LinkableCreatePostAreaEntityRelationInput"];
	["PostAreaLocaleWithoutLinkCreateInput"]: ValueTypes["PostAreaLocaleWithoutLinkCreateInput"];
	["PostAreaLocaleCreateLocaleEntityRelationInput"]: ValueTypes["PostAreaLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPostAreasCreateInput"]: ValueTypes["LocaleWithoutPostAreasCreateInput"];
	["LocaleCreatePostOrganizationsEntityRelationInput"]: ValueTypes["LocaleCreatePostOrganizationsEntityRelationInput"];
	["PostOrganizationLocaleWithoutLocaleCreateInput"]: ValueTypes["PostOrganizationLocaleWithoutLocaleCreateInput"];
	["PostOrganizationLocaleCreateRootEntityRelationInput"]: ValueTypes["PostOrganizationLocaleCreateRootEntityRelationInput"];
	["PostOrganizationWithoutLocalesCreateInput"]: ValueTypes["PostOrganizationWithoutLocalesCreateInput"];
	["PostOrganizationCreateAreaEntityRelationInput"]: ValueTypes["PostOrganizationCreateAreaEntityRelationInput"];
	["PostAreaCreateInput"]: ValueTypes["PostAreaCreateInput"];
	["PostAreaCreateRegionEntityRelationInput"]: ValueTypes["PostAreaCreateRegionEntityRelationInput"];
	["RegionCreateInput"]: ValueTypes["RegionCreateInput"];
	["RegionCreateDonationItemsEntityRelationInput"]: ValueTypes["RegionCreateDonationItemsEntityRelationInput"];
	["DonationAmountsRegionItemWithoutRegionCreateInput"]: ValueTypes["DonationAmountsRegionItemWithoutRegionCreateInput"];
	["DonationAmountsRegionItemCreateListEntityRelationInput"]: ValueTypes["DonationAmountsRegionItemCreateListEntityRelationInput"];
	["DonationAmountsRegionListWithoutRegionsCreateInput"]: ValueTypes["DonationAmountsRegionListWithoutRegionsCreateInput"];
	["DonationAmountsRegionItemConnectOrCreateListRelationInput"]: ValueTypes["DonationAmountsRegionItemConnectOrCreateListRelationInput"];
	["RegionConnectOrCreateDonationItemsRelationInput"]: ValueTypes["RegionConnectOrCreateDonationItemsRelationInput"];
	["PostAreaConnectOrCreateRegionRelationInput"]: ValueTypes["PostAreaConnectOrCreateRegionRelationInput"];
	["PostAreaCreateMetaEntityRelationInput"]: ValueTypes["PostAreaCreateMetaEntityRelationInput"];
	["PostAreaCreateMobileHeroImageEntityRelationInput"]: ValueTypes["PostAreaCreateMobileHeroImageEntityRelationInput"];
	["PostAreaConnectOrCreateMobileHeroImageRelationInput"]: ValueTypes["PostAreaConnectOrCreateMobileHeroImageRelationInput"];
	["PostAreaCreatePlainIconEntityRelationInput"]: ValueTypes["PostAreaCreatePlainIconEntityRelationInput"];
	["PostAreaConnectOrCreatePlainIconRelationInput"]: ValueTypes["PostAreaConnectOrCreatePlainIconRelationInput"];
	["PostAreaCreateSentPaymentsEntityRelationInput"]: ValueTypes["PostAreaCreateSentPaymentsEntityRelationInput"];
	["SentPaymentWithoutAreaCreateInput"]: ValueTypes["SentPaymentWithoutAreaCreateInput"];
	["SentPaymentCreateCurrencyEntityRelationInput"]: ValueTypes["SentPaymentCreateCurrencyEntityRelationInput"];
	["SentPaymentConnectOrCreateCurrencyRelationInput"]: ValueTypes["SentPaymentConnectOrCreateCurrencyRelationInput"];
	["SentPaymentCreateOrganizationEntityRelationInput"]: ValueTypes["SentPaymentCreateOrganizationEntityRelationInput"];
	["PostOrganizationWithoutSentPaymentsCreateInput"]: ValueTypes["PostOrganizationWithoutSentPaymentsCreateInput"];
	["PostOrganizationCreateMetaEntityRelationInput"]: ValueTypes["PostOrganizationCreateMetaEntityRelationInput"];
	["PostOrganizationCreateMobileHeroImageEntityRelationInput"]: ValueTypes["PostOrganizationCreateMobileHeroImageEntityRelationInput"];
	["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"]: ValueTypes["PostOrganizationConnectOrCreateMobileHeroImageRelationInput"];
	["PostOrganizationCreatePlainIconEntityRelationInput"]: ValueTypes["PostOrganizationCreatePlainIconEntityRelationInput"];
	["PostOrganizationConnectOrCreatePlainIconRelationInput"]: ValueTypes["PostOrganizationConnectOrCreatePlainIconRelationInput"];
	["PostOrganizationCreateDesktopHeroImageEntityRelationInput"]: ValueTypes["PostOrganizationCreateDesktopHeroImageEntityRelationInput"];
	["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"]: ValueTypes["PostOrganizationConnectOrCreateDesktopHeroImageRelationInput"];
	["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"]: ValueTypes["PostOrganizationCreateOrganizationCurrencySumsEntityRelationInput"];
	["PostOrganizationCreateOrganizationSumEntityRelationInput"]: ValueTypes["PostOrganizationCreateOrganizationSumEntityRelationInput"];
	["SentPaymentConnectOrCreateOrganizationRelationInput"]: ValueTypes["SentPaymentConnectOrCreateOrganizationRelationInput"];
	["SentPaymentCreateLocalesEntityRelationInput"]: ValueTypes["SentPaymentCreateLocalesEntityRelationInput"];
	["SentPaymentLocaleWithoutRootCreateInput"]: ValueTypes["SentPaymentLocaleWithoutRootCreateInput"];
	["SentPaymentLocaleCreateLocaleEntityRelationInput"]: ValueTypes["SentPaymentLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutSentPaymentsCreateInput"]: ValueTypes["LocaleWithoutSentPaymentsCreateInput"];
	["LocaleCreateHeadersEntityRelationInput"]: ValueTypes["LocaleCreateHeadersEntityRelationInput"];
	["HeaderLocaleWithoutLocaleCreateInput"]: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"];
	["HeaderLocaleCreateRootEntityRelationInput"]: ValueTypes["HeaderLocaleCreateRootEntityRelationInput"];
	["HeaderWithoutLocalesCreateInput"]: ValueTypes["HeaderWithoutLocalesCreateInput"];
	["HeaderCreateLogoEntityRelationInput"]: ValueTypes["HeaderCreateLogoEntityRelationInput"];
	["HeaderConnectOrCreateLogoRelationInput"]: ValueTypes["HeaderConnectOrCreateLogoRelationInput"];
	["HeaderCreateOrganizationListEntityRelationInput"]: ValueTypes["HeaderCreateOrganizationListEntityRelationInput"];
	["HeaderConnectOrCreateOrganizationListRelationInput"]: ValueTypes["HeaderConnectOrCreateOrganizationListRelationInput"];
	["HeaderLocaleConnectOrCreateRootRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateRootRelationInput"];
	["HeaderLocaleCreateLinksEntityRelationInput"]: ValueTypes["HeaderLocaleCreateLinksEntityRelationInput"];
	["LinkListCreateInput"]: ValueTypes["LinkListCreateInput"];
	["LinkListCreateItemsEntityRelationInput"]: ValueTypes["LinkListCreateItemsEntityRelationInput"];
	["LinkItemWithoutListCreateInput"]: ValueTypes["LinkItemWithoutListCreateInput"];
	["LinkItemCreateLinkEntityRelationInput"]: ValueTypes["LinkItemCreateLinkEntityRelationInput"];
	["LinkItemConnectOrCreateLinkRelationInput"]: ValueTypes["LinkItemConnectOrCreateLinkRelationInput"];
	["LinkListConnectOrCreateItemsRelationInput"]: ValueTypes["LinkListConnectOrCreateItemsRelationInput"];
	["HeaderLocaleConnectOrCreateLinksRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateLinksRelationInput"];
	["LocaleConnectOrCreateHeadersRelationInput"]: ValueTypes["LocaleConnectOrCreateHeadersRelationInput"];
	["LocaleCreateFootersEntityRelationInput"]: ValueTypes["LocaleCreateFootersEntityRelationInput"];
	["FooterLocaleWithoutLocaleCreateInput"]: ValueTypes["FooterLocaleWithoutLocaleCreateInput"];
	["FooterLocaleCreateRootEntityRelationInput"]: ValueTypes["FooterLocaleCreateRootEntityRelationInput"];
	["FooterWithoutLocalesCreateInput"]: ValueTypes["FooterWithoutLocalesCreateInput"];
	["FooterCreateLogoEntityRelationInput"]: ValueTypes["FooterCreateLogoEntityRelationInput"];
	["FooterConnectOrCreateLogoRelationInput"]: ValueTypes["FooterConnectOrCreateLogoRelationInput"];
	["FooterLocaleConnectOrCreateRootRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateRootRelationInput"];
	["FooterLocaleCreateLinkListEntityRelationInput"]: ValueTypes["FooterLocaleCreateLinkListEntityRelationInput"];
	["FooterLocaleConnectOrCreateLinkListRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateLinkListRelationInput"];
	["FooterLocaleCreateAddressInfoEntityRelationInput"]: ValueTypes["FooterLocaleCreateAddressInfoEntityRelationInput"];
	["FooterLocaleConnectOrCreateAddressInfoRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateAddressInfoRelationInput"];
	["FooterLocaleCreateImageLinkListEntityRelationInput"]: ValueTypes["FooterLocaleCreateImageLinkListEntityRelationInput"];
	["ImageLinkListCreateInput"]: ValueTypes["ImageLinkListCreateInput"];
	["ImageLinkListCreateItemsEntityRelationInput"]: ValueTypes["ImageLinkListCreateItemsEntityRelationInput"];
	["ImageLinkItemWithoutListCreateInput"]: ValueTypes["ImageLinkItemWithoutListCreateInput"];
	["ImageLinkItemCreateItemEntityRelationInput"]: ValueTypes["ImageLinkItemCreateItemEntityRelationInput"];
	["ImageLinkUniqueWhere"]: ValueTypes["ImageLinkUniqueWhere"];
	["ImageLinkCreateInput"]: ValueTypes["ImageLinkCreateInput"];
	["ImageLinkCreateImageEntityRelationInput"]: ValueTypes["ImageLinkCreateImageEntityRelationInput"];
	["ImageLinkConnectOrCreateImageRelationInput"]: ValueTypes["ImageLinkConnectOrCreateImageRelationInput"];
	["ImageLinkCreateLinkEntityRelationInput"]: ValueTypes["ImageLinkCreateLinkEntityRelationInput"];
	["ImageLinkConnectOrCreateLinkRelationInput"]: ValueTypes["ImageLinkConnectOrCreateLinkRelationInput"];
	["ImageLinkItemConnectOrCreateItemRelationInput"]: ValueTypes["ImageLinkItemConnectOrCreateItemRelationInput"];
	["ImageLinkListConnectOrCreateItemsRelationInput"]: ValueTypes["ImageLinkListConnectOrCreateItemsRelationInput"];
	["FooterLocaleConnectOrCreateImageLinkListRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateImageLinkListRelationInput"];
	["LocaleConnectOrCreateFootersRelationInput"]: ValueTypes["LocaleConnectOrCreateFootersRelationInput"];
	["LocaleCreateGenericPageAboutSettingsEntityRelationInput"]: ValueTypes["LocaleCreateGenericPageAboutSettingsEntityRelationInput"];
	["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"]: ValueTypes["GenericPageAboutSettingsLocaleWithoutLocaleCreateInput"];
	["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleCreateRootEntityRelationInput"];
	["GenericPageAboutSettingsWithoutLocalesCreateInput"]: ValueTypes["GenericPageAboutSettingsWithoutLocalesCreateInput"];
	["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleConnectOrCreateRootRelationInput"];
	["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleCreateLinkGroupsEntityRelationInput"];
	["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsCreateInput"];
	["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleCreateLinkListEntityRelationInput"];
	["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateLinkListRelationInput"];
	["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleConnectOrCreateLinkGroupsRelationInput"];
	["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"]: ValueTypes["LocaleConnectOrCreateGenericPageAboutSettingsRelationInput"];
	["LocaleCreatePostRevisionsEntityRelationInput"]: ValueTypes["LocaleCreatePostRevisionsEntityRelationInput"];
	["PostRevisionLocaleWithoutLocaleCreateInput"]: ValueTypes["PostRevisionLocaleWithoutLocaleCreateInput"];
	["PostRevisionLocaleCreateRootEntityRelationInput"]: ValueTypes["PostRevisionLocaleCreateRootEntityRelationInput"];
	["PostRevisionWithoutLocalesCreateInput"]: ValueTypes["PostRevisionWithoutLocalesCreateInput"];
	["PostRevisionCreatePostEntityRelationInput"]: ValueTypes["PostRevisionCreatePostEntityRelationInput"];
	["PostWithoutRevisionsCreateInput"]: ValueTypes["PostWithoutRevisionsCreateInput"];
	["PostCreateActiveRevisionEntityRelationInput"]: ValueTypes["PostCreateActiveRevisionEntityRelationInput"];
	["PostRevisionCreateInput"]: ValueTypes["PostRevisionCreateInput"];
	["PostRevisionCreateTileImageEntityRelationInput"]: ValueTypes["PostRevisionCreateTileImageEntityRelationInput"];
	["PostRevisionConnectOrCreateTileImageRelationInput"]: ValueTypes["PostRevisionConnectOrCreateTileImageRelationInput"];
	["PostRevisionCreateTileVideoEntityRelationInput"]: ValueTypes["PostRevisionCreateTileVideoEntityRelationInput"];
	["PostRevisionConnectOrCreateTileVideoRelationInput"]: ValueTypes["PostRevisionConnectOrCreateTileVideoRelationInput"];
	["PostRevisionCreateHeroImageEntityRelationInput"]: ValueTypes["PostRevisionCreateHeroImageEntityRelationInput"];
	["PostRevisionConnectOrCreateHeroImageRelationInput"]: ValueTypes["PostRevisionConnectOrCreateHeroImageRelationInput"];
	["PostRevisionCreateLocalesEntityRelationInput"]: ValueTypes["PostRevisionCreateLocalesEntityRelationInput"];
	["PostRevisionLocaleWithoutRootCreateInput"]: ValueTypes["PostRevisionLocaleWithoutRootCreateInput"];
	["PostRevisionLocaleCreateLocaleEntityRelationInput"]: ValueTypes["PostRevisionLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPostRevisionsCreateInput"]: ValueTypes["LocaleWithoutPostRevisionsCreateInput"];
	["LocaleCreateFlagImageEntityRelationInput"]: ValueTypes["LocaleCreateFlagImageEntityRelationInput"];
	["LocaleConnectOrCreateFlagImageRelationInput"]: ValueTypes["LocaleConnectOrCreateFlagImageRelationInput"];
	["LocaleCreateFeedPagesEntityRelationInput"]: ValueTypes["LocaleCreateFeedPagesEntityRelationInput"];
	["FeedPageLocaleWithoutLocaleCreateInput"]: ValueTypes["FeedPageLocaleWithoutLocaleCreateInput"];
	["FeedPageLocaleCreateRootEntityRelationInput"]: ValueTypes["FeedPageLocaleCreateRootEntityRelationInput"];
	["FeedPageWithoutLocalesCreateInput"]: ValueTypes["FeedPageWithoutLocalesCreateInput"];
	["FeedPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["FeedPageLocaleConnectOrCreateRootRelationInput"];
	["FeedPageLocaleCreateHeroTilesEntityRelationInput"]: ValueTypes["FeedPageLocaleCreateHeroTilesEntityRelationInput"];
	["TileListCreateInput"]: ValueTypes["TileListCreateInput"];
	["TileListCreateItemsEntityRelationInput"]: ValueTypes["TileListCreateItemsEntityRelationInput"];
	["TileItemWithoutListCreateInput"]: ValueTypes["TileItemWithoutListCreateInput"];
	["TileItemCreatePostEntityRelationInput"]: ValueTypes["TileItemCreatePostEntityRelationInput"];
	["PostCreateInput"]: ValueTypes["PostCreateInput"];
	["PostCreateRevisionsEntityRelationInput"]: ValueTypes["PostCreateRevisionsEntityRelationInput"];
	["PostRevisionWithoutPostCreateInput"]: ValueTypes["PostRevisionWithoutPostCreateInput"];
	["PostRevisionCreateRegionListOverrideEntityRelationInput"]: ValueTypes["PostRevisionCreateRegionListOverrideEntityRelationInput"];
	["PostRevisionConnectOrCreateRegionListOverrideRelationInput"]: ValueTypes["PostRevisionConnectOrCreateRegionListOverrideRelationInput"];
	["PostConnectOrCreateRevisionsRelationInput"]: ValueTypes["PostConnectOrCreateRevisionsRelationInput"];
	["PostCreateLocalesEntityRelationInput"]: ValueTypes["PostCreateLocalesEntityRelationInput"];
	["PostLocaleWithoutRootCreateInput"]: ValueTypes["PostLocaleWithoutRootCreateInput"];
	["PostLocaleCreateLinkEntityRelationInput"]: ValueTypes["PostLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutPostCreateInput"]: ValueTypes["LinkableWithoutPostCreateInput"];
	["LinkableCreatePostOrganizationEntityRelationInput"]: ValueTypes["LinkableCreatePostOrganizationEntityRelationInput"];
	["PostOrganizationLocaleWithoutLinkCreateInput"]: ValueTypes["PostOrganizationLocaleWithoutLinkCreateInput"];
	["PostOrganizationLocaleCreateLocaleEntityRelationInput"]: ValueTypes["PostOrganizationLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPostOrganizationsCreateInput"]: ValueTypes["LocaleWithoutPostOrganizationsCreateInput"];
	["LocaleCreateRecurringPaymentPagesEntityRelationInput"]: ValueTypes["LocaleCreateRecurringPaymentPagesEntityRelationInput"];
	["RecurringPaymentPageLocaleWithoutLocaleCreateInput"]: ValueTypes["RecurringPaymentPageLocaleWithoutLocaleCreateInput"];
	["RecurringPaymentPageLocaleCreateRootEntityRelationInput"]: ValueTypes["RecurringPaymentPageLocaleCreateRootEntityRelationInput"];
	["RecurringPaymentPageWithoutLocalesCreateInput"]: ValueTypes["RecurringPaymentPageWithoutLocalesCreateInput"];
	["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateRootRelationInput"];
	["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"]: ValueTypes["RecurringPaymentPageLocaleCreateFavouritePostsEntityRelationInput"];
	["PostListCreateInput"]: ValueTypes["PostListCreateInput"];
	["PostListCreateItemsEntityRelationInput"]: ValueTypes["PostListCreateItemsEntityRelationInput"];
	["PostListItemWithoutListCreateInput"]: ValueTypes["PostListItemWithoutListCreateInput"];
	["PostListItemCreatePostEntityRelationInput"]: ValueTypes["PostListItemCreatePostEntityRelationInput"];
	["PostListItemConnectOrCreatePostRelationInput"]: ValueTypes["PostListItemConnectOrCreatePostRelationInput"];
	["PostListConnectOrCreateItemsRelationInput"]: ValueTypes["PostListConnectOrCreateItemsRelationInput"];
	["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"]: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateFavouritePostsRelationInput"];
	["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"]: ValueTypes["RecurringPaymentPageLocaleCreateStoryGuideListEntityRelationInput"];
	["StoryGuideListCreateInput"]: ValueTypes["StoryGuideListCreateInput"];
	["StoryGuideListCreateItemsEntityRelationInput"]: ValueTypes["StoryGuideListCreateItemsEntityRelationInput"];
	["StoryGuideItemWithoutListCreateInput"]: ValueTypes["StoryGuideItemWithoutListCreateInput"];
	["StoryGuideItemCreateGuideEntityRelationInput"]: ValueTypes["StoryGuideItemCreateGuideEntityRelationInput"];
	["StoryGuideUniqueWhere"]: ValueTypes["StoryGuideUniqueWhere"];
	["StoryGuideCreateInput"]: ValueTypes["StoryGuideCreateInput"];
	["StoryGuideCreateImageEntityRelationInput"]: ValueTypes["StoryGuideCreateImageEntityRelationInput"];
	["StoryGuideConnectOrCreateImageRelationInput"]: ValueTypes["StoryGuideConnectOrCreateImageRelationInput"];
	["StoryGuideCreateSecondaryImageEntityRelationInput"]: ValueTypes["StoryGuideCreateSecondaryImageEntityRelationInput"];
	["StoryGuideConnectOrCreateSecondaryImageRelationInput"]: ValueTypes["StoryGuideConnectOrCreateSecondaryImageRelationInput"];
	["StoryGuideItemConnectOrCreateGuideRelationInput"]: ValueTypes["StoryGuideItemConnectOrCreateGuideRelationInput"];
	["StoryGuideListConnectOrCreateItemsRelationInput"]: ValueTypes["StoryGuideListConnectOrCreateItemsRelationInput"];
	["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"]: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateStoryGuideListRelationInput"];
	["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateRecurringPaymentPagesRelationInput"];
	["LocaleCreateGivenGiftsPagesEntityRelationInput"]: ValueTypes["LocaleCreateGivenGiftsPagesEntityRelationInput"];
	["GivenGiftsPageLocaleWithoutLocaleCreateInput"]: ValueTypes["GivenGiftsPageLocaleWithoutLocaleCreateInput"];
	["GivenGiftsPageLocaleCreateRootEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleCreateRootEntityRelationInput"];
	["GivenGiftsPageWithoutLocalesCreateInput"]: ValueTypes["GivenGiftsPageWithoutLocalesCreateInput"];
	["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["GivenGiftsPageLocaleConnectOrCreateRootRelationInput"];
	["GivenGiftsPageLocaleCreateContentEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleCreateContentEntityRelationInput"];
	["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"]: ValueTypes["GivenGiftsPageLocaleConnectOrCreateContentRelationInput"];
	["GivenGiftsPageLocaleCreateSeoEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleCreateSeoEntityRelationInput"];
	["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["GivenGiftsPageLocaleConnectOrCreateSeoRelationInput"];
	["GivenGiftsPageLocaleCreateLinkEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutGivenGiftsPageCreateInput"]: ValueTypes["LinkableWithoutGivenGiftsPageCreateInput"];
	["LinkableCreateReportPageEntityRelationInput"]: ValueTypes["LinkableCreateReportPageEntityRelationInput"];
	["ReportPageLocaleWithoutLinkCreateInput"]: ValueTypes["ReportPageLocaleWithoutLinkCreateInput"];
	["ReportPageLocaleCreateRootEntityRelationInput"]: ValueTypes["ReportPageLocaleCreateRootEntityRelationInput"];
	["ReportPageWithoutLocalesCreateInput"]: ValueTypes["ReportPageWithoutLocalesCreateInput"];
	["ReportPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["ReportPageLocaleConnectOrCreateRootRelationInput"];
	["ReportPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["ReportPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutReportPagesCreateInput"]: ValueTypes["LocaleWithoutReportPagesCreateInput"];
	["LocaleCreateReceivedGiftsPagesEntityRelationInput"]: ValueTypes["LocaleCreateReceivedGiftsPagesEntityRelationInput"];
	["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"]: ValueTypes["ReceivedGiftsPageLocaleWithoutLocaleCreateInput"];
	["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutReceivedGiftsPageCreateInput"]: ValueTypes["LinkableWithoutReceivedGiftsPageCreateInput"];
	["LinkableCreateGivenGiftsPageEntityRelationInput"]: ValueTypes["LinkableCreateGivenGiftsPageEntityRelationInput"];
	["GivenGiftsPageLocaleWithoutLinkCreateInput"]: ValueTypes["GivenGiftsPageLocaleWithoutLinkCreateInput"];
	["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutGivenGiftsPagesCreateInput"]: ValueTypes["LocaleWithoutGivenGiftsPagesCreateInput"];
	["LocaleCreateReportPagesEntityRelationInput"]: ValueTypes["LocaleCreateReportPagesEntityRelationInput"];
	["ReportPageLocaleWithoutLocaleCreateInput"]: ValueTypes["ReportPageLocaleWithoutLocaleCreateInput"];
	["ReportPageLocaleCreateLinkEntityRelationInput"]: ValueTypes["ReportPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutReportPageCreateInput"]: ValueTypes["LinkableWithoutReportPageCreateInput"];
	["LinkableCreateReceivedGiftsPageEntityRelationInput"]: ValueTypes["LinkableCreateReceivedGiftsPageEntityRelationInput"];
	["ReceivedGiftsPageLocaleWithoutLinkCreateInput"]: ValueTypes["ReceivedGiftsPageLocaleWithoutLinkCreateInput"];
	["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleCreateRootEntityRelationInput"];
	["ReceivedGiftsPageWithoutLocalesCreateInput"]: ValueTypes["ReceivedGiftsPageWithoutLocalesCreateInput"];
	["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateRootRelationInput"];
	["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutReceivedGiftsPagesCreateInput"]: ValueTypes["LocaleWithoutReceivedGiftsPagesCreateInput"];
	["LocaleCreateReportNavigationsEntityRelationInput"]: ValueTypes["LocaleCreateReportNavigationsEntityRelationInput"];
	["ReportNavigationLocaleWithoutLocaleCreateInput"]: ValueTypes["ReportNavigationLocaleWithoutLocaleCreateInput"];
	["ReportNavigationLocaleCreatePagesEntityRelationInput"]: ValueTypes["ReportNavigationLocaleCreatePagesEntityRelationInput"];
	["GenericPageWithoutReportNavigationCreateInput"]: ValueTypes["GenericPageWithoutReportNavigationCreateInput"];
	["GenericPageCreateLocalesEntityRelationInput"]: ValueTypes["GenericPageCreateLocalesEntityRelationInput"];
	["GenericPageLocaleWithoutRootCreateInput"]: ValueTypes["GenericPageLocaleWithoutRootCreateInput"];
	["GenericPageLocaleCreateContentEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"];
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateContentRelationInput"];
	["GenericPageLocaleCreateSeoEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"];
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"];
	["GenericPageLocaleCreateLinkEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutGenericPageCreateInput"]: ValueTypes["LinkableWithoutGenericPageCreateInput"];
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"];
	["GenericPageConnectOrCreateLocalesRelationInput"]: ValueTypes["GenericPageConnectOrCreateLocalesRelationInput"];
	["ReportNavigationLocaleConnectOrCreatePagesRelationInput"]: ValueTypes["ReportNavigationLocaleConnectOrCreatePagesRelationInput"];
	["LocaleConnectOrCreateReportNavigationsRelationInput"]: ValueTypes["LocaleConnectOrCreateReportNavigationsRelationInput"];
	["LocaleCreateScheduledNotificationsEntityRelationInput"]: ValueTypes["LocaleCreateScheduledNotificationsEntityRelationInput"];
	["ScheduledNotificationLocaleWithoutLocaleCreateInput"]: ValueTypes["ScheduledNotificationLocaleWithoutLocaleCreateInput"];
	["ScheduledNotificationLocaleCreateRootEntityRelationInput"]: ValueTypes["ScheduledNotificationLocaleCreateRootEntityRelationInput"];
	["ScheduledNotificationWithoutLocalesCreateInput"]: ValueTypes["ScheduledNotificationWithoutLocalesCreateInput"];
	["ScheduledNotificationCreateTargetEntityRelationInput"]: ValueTypes["ScheduledNotificationCreateTargetEntityRelationInput"];
	["NotificationTargetGroupUniqueWhere"]: ValueTypes["NotificationTargetGroupUniqueWhere"];
	["NotificationTargetGroupCreateInput"]: ValueTypes["NotificationTargetGroupCreateInput"];
	["NotificationTargetGroupCreateRegionsEntityRelationInput"]: ValueTypes["NotificationTargetGroupCreateRegionsEntityRelationInput"];
	["NotificationTargetGroupConnectOrCreateRegionsRelationInput"]: ValueTypes["NotificationTargetGroupConnectOrCreateRegionsRelationInput"];
	["ScheduledNotificationConnectOrCreateTargetRelationInput"]: ValueTypes["ScheduledNotificationConnectOrCreateTargetRelationInput"];
	["ScheduledNotificationCreateImageEntityRelationInput"]: ValueTypes["ScheduledNotificationCreateImageEntityRelationInput"];
	["ScheduledNotificationConnectOrCreateImageRelationInput"]: ValueTypes["ScheduledNotificationConnectOrCreateImageRelationInput"];
	["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"]: ValueTypes["ScheduledNotificationCreateProcessedNotificationsEntityRelationInput"];
	["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"]: ValueTypes["ProcessedNotificationSourceWithoutScheduledNotificationCreateInput"];
	["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"]: ValueTypes["ProcessedNotificationSourceCreateProcessedNotificationEntityRelationInput"];
	["ProcessedNotificationWithoutSourceCreateInput"]: ValueTypes["ProcessedNotificationWithoutSourceCreateInput"];
	["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"]: ValueTypes["ProcessedNotificationSourceConnectOrCreateProcessedNotificationRelationInput"];
	["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"]: ValueTypes["ProcessedNotificationSourceCreateDonationReminderUserEntityRelationInput"];
	["UserUniqueWhere"]: ValueTypes["UserUniqueWhere"];
	["DeviceUniqueWhere"]: ValueTypes["DeviceUniqueWhere"];
	["UserAreaStatsUniqueWhere"]: ValueTypes["UserAreaStatsUniqueWhere"];
	["UserOrganizationStatsUniqueWhere"]: ValueTypes["UserOrganizationStatsUniqueWhere"];
	["UserPostStatsUniqueWhere"]: ValueTypes["UserPostStatsUniqueWhere"];
	["UserCurrencyStatsUniqueWhere"]: ValueTypes["UserCurrencyStatsUniqueWhere"];
	["UserStatsUniqueWhere"]: ValueTypes["UserStatsUniqueWhere"];
	["UserWithoutProcessedNotificationsCreateInput"]: ValueTypes["UserWithoutProcessedNotificationsCreateInput"];
	["UserCreatePaymentsEntityRelationInput"]: ValueTypes["UserCreatePaymentsEntityRelationInput"];
	["UserPaymentWithoutUserCreateInput"]: ValueTypes["UserPaymentWithoutUserCreateInput"];
	["UserPaymentCreateCurrencyEntityRelationInput"]: ValueTypes["UserPaymentCreateCurrencyEntityRelationInput"];
	["UserPaymentConnectOrCreateCurrencyRelationInput"]: ValueTypes["UserPaymentConnectOrCreateCurrencyRelationInput"];
	["UserPaymentCreateOrderEntityRelationInput"]: ValueTypes["UserPaymentCreateOrderEntityRelationInput"];
	["UserPaymentOrderIdCreateInput"]: ValueTypes["UserPaymentOrderIdCreateInput"];
	["UserPaymentConnectOrCreateOrderRelationInput"]: ValueTypes["UserPaymentConnectOrCreateOrderRelationInput"];
	["UserPaymentCreateCsobPaymentEntityRelationInput"]: ValueTypes["UserPaymentCreateCsobPaymentEntityRelationInput"];
	["CsobPaymentWithoutPaymentCreateInput"]: ValueTypes["CsobPaymentWithoutPaymentCreateInput"];
	["CsobPaymentCreateStatusChangesEntityRelationInput"]: ValueTypes["CsobPaymentCreateStatusChangesEntityRelationInput"];
	["CsobPaymentStatusChangeWithoutPaymentCreateInput"]: ValueTypes["CsobPaymentStatusChangeWithoutPaymentCreateInput"];
	["CsobPaymentConnectOrCreateStatusChangesRelationInput"]: ValueTypes["CsobPaymentConnectOrCreateStatusChangesRelationInput"];
	["CsobPaymentCreateMetadataEntityRelationInput"]: ValueTypes["CsobPaymentCreateMetadataEntityRelationInput"];
	["UserPaymentConnectOrCreateCsobPaymentRelationInput"]: ValueTypes["UserPaymentConnectOrCreateCsobPaymentRelationInput"];
	["UserPaymentCreateStripePaymentEntityRelationInput"]: ValueTypes["UserPaymentCreateStripePaymentEntityRelationInput"];
	["StripePaymentWithoutPaymentCreateInput"]: ValueTypes["StripePaymentWithoutPaymentCreateInput"];
	["StripePaymentCreateStatusChangesEntityRelationInput"]: ValueTypes["StripePaymentCreateStatusChangesEntityRelationInput"];
	["StripePaymentStatusChangeWithoutPaymentCreateInput"]: ValueTypes["StripePaymentStatusChangeWithoutPaymentCreateInput"];
	["StripePaymentConnectOrCreateStatusChangesRelationInput"]: ValueTypes["StripePaymentConnectOrCreateStatusChangesRelationInput"];
	["StripePaymentCreateMetadataEntityRelationInput"]: ValueTypes["StripePaymentCreateMetadataEntityRelationInput"];
	["UserPaymentConnectOrCreateStripePaymentRelationInput"]: ValueTypes["UserPaymentConnectOrCreateStripePaymentRelationInput"];
	["UserPaymentCreateRecurringPaymentItemEntityRelationInput"]: ValueTypes["UserPaymentCreateRecurringPaymentItemEntityRelationInput"];
	["UserRecurringPaymentItemWithoutPaymentsCreateInput"]: ValueTypes["UserRecurringPaymentItemWithoutPaymentsCreateInput"];
	["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"]: ValueTypes["UserRecurringPaymentItemCreateRecurringPaymentEntityRelationInput"];
	["UserRecurringPaymentWithoutItemsCreateInput"]: ValueTypes["UserRecurringPaymentWithoutItemsCreateInput"];
	["UserRecurringPaymentCreateCurrencyEntityRelationInput"]: ValueTypes["UserRecurringPaymentCreateCurrencyEntityRelationInput"];
	["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"]: ValueTypes["UserRecurringPaymentConnectOrCreateCurrencyRelationInput"];
	["UserRecurringPaymentCreateUserEntityRelationInput"]: ValueTypes["UserRecurringPaymentCreateUserEntityRelationInput"];
	["UserWithoutRecurringPaymentsCreateInput"]: ValueTypes["UserWithoutRecurringPaymentsCreateInput"];
	["UserCreateRegionEntityRelationInput"]: ValueTypes["UserCreateRegionEntityRelationInput"];
	["UserConnectOrCreateRegionRelationInput"]: ValueTypes["UserConnectOrCreateRegionRelationInput"];
	["UserCreateCurrencyEntityRelationInput"]: ValueTypes["UserCreateCurrencyEntityRelationInput"];
	["UserConnectOrCreateCurrencyRelationInput"]: ValueTypes["UserConnectOrCreateCurrencyRelationInput"];
	["UserCreateOnBehalfDonationsEntityRelationInput"]: ValueTypes["UserCreateOnBehalfDonationsEntityRelationInput"];
	["OnBehalfDonationWithoutOnBehalfOfCreateInput"]: ValueTypes["OnBehalfDonationWithoutOnBehalfOfCreateInput"];
	["OnBehalfDonationCreatePaymentsEntityRelationInput"]: ValueTypes["OnBehalfDonationCreatePaymentsEntityRelationInput"];
	["UserPaymentWithoutOnBehalfDonationCreateInput"]: ValueTypes["UserPaymentWithoutOnBehalfDonationCreateInput"];
	["UserPaymentCreateRegionEntityRelationInput"]: ValueTypes["UserPaymentCreateRegionEntityRelationInput"];
	["UserPaymentConnectOrCreateRegionRelationInput"]: ValueTypes["UserPaymentConnectOrCreateRegionRelationInput"];
	["UserPaymentCreateUserEntityRelationInput"]: ValueTypes["UserPaymentCreateUserEntityRelationInput"];
	["UserWithoutPaymentsCreateInput"]: ValueTypes["UserWithoutPaymentsCreateInput"];
	["UserCreateRecurringPaymentsEntityRelationInput"]: ValueTypes["UserCreateRecurringPaymentsEntityRelationInput"];
	["UserRecurringPaymentWithoutUserCreateInput"]: ValueTypes["UserRecurringPaymentWithoutUserCreateInput"];
	["UserRecurringPaymentCreateItemsEntityRelationInput"]: ValueTypes["UserRecurringPaymentCreateItemsEntityRelationInput"];
	["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"]: ValueTypes["UserRecurringPaymentItemWithoutRecurringPaymentCreateInput"];
	["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"]: ValueTypes["UserRecurringPaymentItemCreatePaymentsEntityRelationInput"];
	["UserPaymentWithoutRecurringPaymentItemCreateInput"]: ValueTypes["UserPaymentWithoutRecurringPaymentItemCreateInput"];
	["UserPaymentCreateOnBehalfDonationEntityRelationInput"]: ValueTypes["UserPaymentCreateOnBehalfDonationEntityRelationInput"];
	["OnBehalfDonationWithoutPaymentsCreateInput"]: ValueTypes["OnBehalfDonationWithoutPaymentsCreateInput"];
	["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"]: ValueTypes["OnBehalfDonationCreateOnBehalfOfEntityRelationInput"];
	["UserWithoutOnBehalfDonationsCreateInput"]: ValueTypes["UserWithoutOnBehalfDonationsCreateInput"];
	["UserCreateLocaleEntityRelationInput"]: ValueTypes["UserCreateLocaleEntityRelationInput"];
	["LocaleCreateInput"]: ValueTypes["LocaleCreateInput"];
	["LocaleCreateSentPaymentsEntityRelationInput"]: ValueTypes["LocaleCreateSentPaymentsEntityRelationInput"];
	["SentPaymentLocaleWithoutLocaleCreateInput"]: ValueTypes["SentPaymentLocaleWithoutLocaleCreateInput"];
	["SentPaymentLocaleCreateRootEntityRelationInput"]: ValueTypes["SentPaymentLocaleCreateRootEntityRelationInput"];
	["SentPaymentWithoutLocalesCreateInput"]: ValueTypes["SentPaymentWithoutLocalesCreateInput"];
	["SentPaymentCreateAreaEntityRelationInput"]: ValueTypes["SentPaymentCreateAreaEntityRelationInput"];
	["PostAreaWithoutSentPaymentsCreateInput"]: ValueTypes["PostAreaWithoutSentPaymentsCreateInput"];
	["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"]: ValueTypes["PostAreaCreateAreaSentPaymentCurrencySumsEntityRelationInput"];
	["PostAreaCreateAreaSentPaymentSumEntityRelationInput"]: ValueTypes["PostAreaCreateAreaSentPaymentSumEntityRelationInput"];
	["PostAreaCreateAreaCurrencySumsEntityRelationInput"]: ValueTypes["PostAreaCreateAreaCurrencySumsEntityRelationInput"];
	["PostAreaCreateAreaSumEntityRelationInput"]: ValueTypes["PostAreaCreateAreaSumEntityRelationInput"];
	["SentPaymentConnectOrCreateAreaRelationInput"]: ValueTypes["SentPaymentConnectOrCreateAreaRelationInput"];
	["SentPaymentLocaleConnectOrCreateRootRelationInput"]: ValueTypes["SentPaymentLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateSentPaymentsRelationInput"]: ValueTypes["LocaleConnectOrCreateSentPaymentsRelationInput"];
	["UserConnectOrCreateLocaleRelationInput"]: ValueTypes["UserConnectOrCreateLocaleRelationInput"];
	["UserCreateDevicesEntityRelationInput"]: ValueTypes["UserCreateDevicesEntityRelationInput"];
	["DeviceWithoutUserCreateInput"]: ValueTypes["DeviceWithoutUserCreateInput"];
	["UserConnectOrCreateDevicesRelationInput"]: ValueTypes["UserConnectOrCreateDevicesRelationInput"];
	["UserCreateProcessedNotificationsEntityRelationInput"]: ValueTypes["UserCreateProcessedNotificationsEntityRelationInput"];
	["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"]: ValueTypes["ProcessedNotificationSourceWithoutDonationReminderUserCreateInput"];
	["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"]: ValueTypes["ProcessedNotificationSourceCreateScheduledNotificationEntityRelationInput"];
	["ScheduledNotificationWithoutProcessedNotificationsCreateInput"]: ValueTypes["ScheduledNotificationWithoutProcessedNotificationsCreateInput"];
	["ScheduledNotificationCreateLocalesEntityRelationInput"]: ValueTypes["ScheduledNotificationCreateLocalesEntityRelationInput"];
	["ScheduledNotificationLocaleWithoutRootCreateInput"]: ValueTypes["ScheduledNotificationLocaleWithoutRootCreateInput"];
	["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"]: ValueTypes["ScheduledNotificationLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutScheduledNotificationsCreateInput"]: ValueTypes["LocaleWithoutScheduledNotificationsCreateInput"];
	["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["ScheduledNotificationLocaleConnectOrCreateLocaleRelationInput"];
	["ScheduledNotificationConnectOrCreateLocalesRelationInput"]: ValueTypes["ScheduledNotificationConnectOrCreateLocalesRelationInput"];
	["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"]: ValueTypes["ProcessedNotificationSourceConnectOrCreateScheduledNotificationRelationInput"];
	["UserConnectOrCreateProcessedNotificationsRelationInput"]: ValueTypes["UserConnectOrCreateProcessedNotificationsRelationInput"];
	["UserCreateAreaStatsEntityRelationInput"]: ValueTypes["UserCreateAreaStatsEntityRelationInput"];
	["UserCreateOrganizationStatsEntityRelationInput"]: ValueTypes["UserCreateOrganizationStatsEntityRelationInput"];
	["UserCreatePostStatsEntityRelationInput"]: ValueTypes["UserCreatePostStatsEntityRelationInput"];
	["UserCreateCurrencyStatsEntityRelationInput"]: ValueTypes["UserCreateCurrencyStatsEntityRelationInput"];
	["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"]: ValueTypes["OnBehalfDonationConnectOrCreateOnBehalfOfRelationInput"];
	["OnBehalfDonationCreateMetaEntityRelationInput"]: ValueTypes["OnBehalfDonationCreateMetaEntityRelationInput"];
	["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"]: ValueTypes["UserPaymentConnectOrCreateOnBehalfDonationRelationInput"];
	["UserPaymentCreateTriesCollectionEntityRelationInput"]: ValueTypes["UserPaymentCreateTriesCollectionEntityRelationInput"];
	["UserPaymentTriesCollectionUniqueWhere"]: ValueTypes["UserPaymentTriesCollectionUniqueWhere"];
	["UserPaymentTriesCollectionMetadataUniqueWhere"]: ValueTypes["UserPaymentTriesCollectionMetadataUniqueWhere"];
	["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"]: ValueTypes["UserPaymentTriesCollectionMetadataLocaleUniqueWhere"];
	["UserPaymentTriesCollectionWithoutPaymentCreateInput"]: ValueTypes["UserPaymentTriesCollectionWithoutPaymentCreateInput"];
	["UserPaymentTriesCollectionCreateUserEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionCreateUserEntityRelationInput"];
	["UserCreateInput"]: ValueTypes["UserCreateInput"];
	["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"]: ValueTypes["UserPaymentTriesCollectionConnectOrCreateUserRelationInput"];
	["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionCreateCurrencyEntityRelationInput"];
	["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"]: ValueTypes["UserPaymentTriesCollectionConnectOrCreateCurrencyRelationInput"];
	["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionCreateOnBehalfDonationEntityRelationInput"];
	["OnBehalfDonationCreateInput"]: ValueTypes["OnBehalfDonationCreateInput"];
	["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"]: ValueTypes["UserPaymentTriesCollectionConnectOrCreateOnBehalfDonationRelationInput"];
	["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionCreateRecurringEntityRelationInput"];
	["UserRecurringPaymentCreateInput"]: ValueTypes["UserRecurringPaymentCreateInput"];
	["UserRecurringPaymentCreateMetaEntityRelationInput"]: ValueTypes["UserRecurringPaymentCreateMetaEntityRelationInput"];
	["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"]: ValueTypes["UserPaymentTriesCollectionConnectOrCreateRecurringRelationInput"];
	["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionCreateMetadataLocalesEntityRelationInput"];
	["UserPaymentConnectOrCreateTriesCollectionRelationInput"]: ValueTypes["UserPaymentConnectOrCreateTriesCollectionRelationInput"];
	["UserPaymentCreateMetadataEntityRelationInput"]: ValueTypes["UserPaymentCreateMetadataEntityRelationInput"];
	["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"]: ValueTypes["UserRecurringPaymentItemConnectOrCreatePaymentsRelationInput"];
	["UserRecurringPaymentItemCreateMetaEntityRelationInput"]: ValueTypes["UserRecurringPaymentItemCreateMetaEntityRelationInput"];
	["UserRecurringPaymentConnectOrCreateItemsRelationInput"]: ValueTypes["UserRecurringPaymentConnectOrCreateItemsRelationInput"];
	["UserConnectOrCreateRecurringPaymentsRelationInput"]: ValueTypes["UserConnectOrCreateRecurringPaymentsRelationInput"];
	["UserPaymentConnectOrCreateUserRelationInput"]: ValueTypes["UserPaymentConnectOrCreateUserRelationInput"];
	["OnBehalfDonationConnectOrCreatePaymentsRelationInput"]: ValueTypes["OnBehalfDonationConnectOrCreatePaymentsRelationInput"];
	["UserConnectOrCreateOnBehalfDonationsRelationInput"]: ValueTypes["UserConnectOrCreateOnBehalfDonationsRelationInput"];
	["UserRecurringPaymentConnectOrCreateUserRelationInput"]: ValueTypes["UserRecurringPaymentConnectOrCreateUserRelationInput"];
	["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"]: ValueTypes["UserRecurringPaymentItemConnectOrCreateRecurringPaymentRelationInput"];
	["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"]: ValueTypes["UserPaymentConnectOrCreateRecurringPaymentItemRelationInput"];
	["UserConnectOrCreatePaymentsRelationInput"]: ValueTypes["UserConnectOrCreatePaymentsRelationInput"];
	["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"]: ValueTypes["ProcessedNotificationSourceConnectOrCreateDonationReminderUserRelationInput"];
	["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"]: ValueTypes["ScheduledNotificationConnectOrCreateProcessedNotificationsRelationInput"];
	["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"]: ValueTypes["ScheduledNotificationLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateScheduledNotificationsRelationInput"]: ValueTypes["LocaleConnectOrCreateScheduledNotificationsRelationInput"];
	["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateLocaleRelationInput"];
	["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleCreateContentEntityRelationInput"];
	["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateContentRelationInput"];
	["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleCreateSeoEntityRelationInput"];
	["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateSeoRelationInput"];
	["LinkableConnectOrCreateReceivedGiftsPageRelationInput"]: ValueTypes["LinkableConnectOrCreateReceivedGiftsPageRelationInput"];
	["ReportPageLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["ReportPageLocaleConnectOrCreateLinkRelationInput"];
	["ReportPageLocaleCreateContentEntityRelationInput"]: ValueTypes["ReportPageLocaleCreateContentEntityRelationInput"];
	["ReportPageLocaleConnectOrCreateContentRelationInput"]: ValueTypes["ReportPageLocaleConnectOrCreateContentRelationInput"];
	["ReportPageLocaleCreateSeoEntityRelationInput"]: ValueTypes["ReportPageLocaleCreateSeoEntityRelationInput"];
	["ReportPageLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["ReportPageLocaleConnectOrCreateSeoRelationInput"];
	["ReportPageLocaleCreatePostsEntityRelationInput"]: ValueTypes["ReportPageLocaleCreatePostsEntityRelationInput"];
	["PostWithoutReportPageCreateInput"]: ValueTypes["PostWithoutReportPageCreateInput"];
	["PostCreateMetaEntityRelationInput"]: ValueTypes["PostCreateMetaEntityRelationInput"];
	["PostCreateHeroCarouselEntityRelationInput"]: ValueTypes["PostCreateHeroCarouselEntityRelationInput"];
	["HeroCarouselUniqueWhere"]: ValueTypes["HeroCarouselUniqueWhere"];
	["HeroCarouselItemUniqueWhere"]: ValueTypes["HeroCarouselItemUniqueWhere"];
	["HeroCarouselWithoutPostsCreateInput"]: ValueTypes["HeroCarouselWithoutPostsCreateInput"];
	["HeroCarouselCreateItemsEntityRelationInput"]: ValueTypes["HeroCarouselCreateItemsEntityRelationInput"];
	["HeroCarouselItemWithoutListCreateInput"]: ValueTypes["HeroCarouselItemWithoutListCreateInput"];
	["HeroCarouselItemCreateItemEntityRelationInput"]: ValueTypes["HeroCarouselItemCreateItemEntityRelationInput"];
	["HeroCarouselItemConnectOrCreateItemRelationInput"]: ValueTypes["HeroCarouselItemConnectOrCreateItemRelationInput"];
	["HeroCarouselConnectOrCreateItemsRelationInput"]: ValueTypes["HeroCarouselConnectOrCreateItemsRelationInput"];
	["PostConnectOrCreateHeroCarouselRelationInput"]: ValueTypes["PostConnectOrCreateHeroCarouselRelationInput"];
	["PostCreateContentEntityRelationInput"]: ValueTypes["PostCreateContentEntityRelationInput"];
	["ContentReferenceWithoutPostsCreateInput"]: ValueTypes["ContentReferenceWithoutPostsCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: ValueTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: ValueTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: ValueTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: ValueTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockConnectOrCreateContentRelationInput"]: ValueTypes["ContentBlockConnectOrCreateContentRelationInput"];
	["ContentReferenceConnectOrCreateBlockRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateBlockRelationInput"];
	["ContentReferenceCreateValueListEntityRelationInput"]: ValueTypes["ContentReferenceCreateValueListEntityRelationInput"];
	["ValueListCreateInput"]: ValueTypes["ValueListCreateInput"];
	["ValueListCreateItemsEntityRelationInput"]: ValueTypes["ValueListCreateItemsEntityRelationInput"];
	["ValueItemWithoutListCreateInput"]: ValueTypes["ValueItemWithoutListCreateInput"];
	["ValueItemCreateItemEntityRelationInput"]: ValueTypes["ValueItemCreateItemEntityRelationInput"];
	["ValueUniqueWhere"]: ValueTypes["ValueUniqueWhere"];
	["ValueCreateInput"]: ValueTypes["ValueCreateInput"];
	["ValueCreateTextContentEntityRelationInput"]: ValueTypes["ValueCreateTextContentEntityRelationInput"];
	["ValueConnectOrCreateTextContentRelationInput"]: ValueTypes["ValueConnectOrCreateTextContentRelationInput"];
	["ValueItemConnectOrCreateItemRelationInput"]: ValueTypes["ValueItemConnectOrCreateItemRelationInput"];
	["ValueListConnectOrCreateItemsRelationInput"]: ValueTypes["ValueListConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateValueListRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateValueListRelationInput"];
	["ContentReferenceCreateImageLinkListEntityRelationInput"]: ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"];
	["ContentReferenceConnectOrCreateImageLinkListRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateImageLinkListRelationInput"];
	["ContentReferenceCreateAreaListEntityRelationInput"]: ValueTypes["ContentReferenceCreateAreaListEntityRelationInput"];
	["PostAreaListCreateInput"]: ValueTypes["PostAreaListCreateInput"];
	["PostAreaListCreateItemsEntityRelationInput"]: ValueTypes["PostAreaListCreateItemsEntityRelationInput"];
	["PostAreaListItemWithoutListCreateInput"]: ValueTypes["PostAreaListItemWithoutListCreateInput"];
	["PostAreaListItemCreateItemEntityRelationInput"]: ValueTypes["PostAreaListItemCreateItemEntityRelationInput"];
	["PostAreaListItemConnectOrCreateItemRelationInput"]: ValueTypes["PostAreaListItemConnectOrCreateItemRelationInput"];
	["PostAreaListConnectOrCreateItemsRelationInput"]: ValueTypes["PostAreaListConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateAreaListRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateAreaListRelationInput"];
	["ContentReferenceCreateAccordionEntityRelationInput"]: ValueTypes["ContentReferenceCreateAccordionEntityRelationInput"];
	["AccordionCreateInput"]: ValueTypes["AccordionCreateInput"];
	["AccordionCreateItemsEntityRelationInput"]: ValueTypes["AccordionCreateItemsEntityRelationInput"];
	["AccordionItemWithoutListCreateInput"]: ValueTypes["AccordionItemWithoutListCreateInput"];
	["AccordionItemCreateDescriptionContentEntityRelationInput"]: ValueTypes["AccordionItemCreateDescriptionContentEntityRelationInput"];
	["AccordionItemConnectOrCreateDescriptionContentRelationInput"]: ValueTypes["AccordionItemConnectOrCreateDescriptionContentRelationInput"];
	["AccordionConnectOrCreateItemsRelationInput"]: ValueTypes["AccordionConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateAccordionRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateAccordionRelationInput"];
	["ContentReferenceCreateMediaEntityRelationInput"]: ValueTypes["ContentReferenceCreateMediaEntityRelationInput"];
	["MediumListCreateInput"]: ValueTypes["MediumListCreateInput"];
	["MediumListCreateItemsEntityRelationInput"]: ValueTypes["MediumListCreateItemsEntityRelationInput"];
	["MediumItemWithoutListCreateInput"]: ValueTypes["MediumItemWithoutListCreateInput"];
	["MediumItemCreateMediumEntityRelationInput"]: ValueTypes["MediumItemCreateMediumEntityRelationInput"];
	["MediumUniqueWhere"]: ValueTypes["MediumUniqueWhere"];
	["MediumCreateInput"]: ValueTypes["MediumCreateInput"];
	["MediumCreateImageEntityRelationInput"]: ValueTypes["MediumCreateImageEntityRelationInput"];
	["MediumConnectOrCreateImageRelationInput"]: ValueTypes["MediumConnectOrCreateImageRelationInput"];
	["MediumCreateVideoEntityRelationInput"]: ValueTypes["MediumCreateVideoEntityRelationInput"];
	["MediumConnectOrCreateVideoRelationInput"]: ValueTypes["MediumConnectOrCreateVideoRelationInput"];
	["MediumItemConnectOrCreateMediumRelationInput"]: ValueTypes["MediumItemConnectOrCreateMediumRelationInput"];
	["MediumListConnectOrCreateItemsRelationInput"]: ValueTypes["MediumListConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateMediaRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateMediaRelationInput"];
	["ContentReferenceCreateMemberListEntityRelationInput"]: ValueTypes["ContentReferenceCreateMemberListEntityRelationInput"];
	["MemberListCreateInput"]: ValueTypes["MemberListCreateInput"];
	["MemberListCreateItemsEntityRelationInput"]: ValueTypes["MemberListCreateItemsEntityRelationInput"];
	["MemberListItemWithoutListCreateInput"]: ValueTypes["MemberListItemWithoutListCreateInput"];
	["MemberListItemCreateImageEntityRelationInput"]: ValueTypes["MemberListItemCreateImageEntityRelationInput"];
	["MemberListItemConnectOrCreateImageRelationInput"]: ValueTypes["MemberListItemConnectOrCreateImageRelationInput"];
	["MemberListItemCreateDescriptionContentEntityRelationInput"]: ValueTypes["MemberListItemCreateDescriptionContentEntityRelationInput"];
	["MemberListItemConnectOrCreateDescriptionContentRelationInput"]: ValueTypes["MemberListItemConnectOrCreateDescriptionContentRelationInput"];
	["MemberListConnectOrCreateItemsRelationInput"]: ValueTypes["MemberListConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateMemberListRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateMemberListRelationInput"];
	["ContentReferenceCreateFormEntityRelationInput"]: ValueTypes["ContentReferenceCreateFormEntityRelationInput"];
	["FormUniqueWhere"]: ValueTypes["FormUniqueWhere"];
	["FilledTaxFormUniqueWhere"]: ValueTypes["FilledTaxFormUniqueWhere"];
	["FormCreateInput"]: ValueTypes["FormCreateInput"];
	["FormCreateTaxEntityRelationInput"]: ValueTypes["FormCreateTaxEntityRelationInput"];
	["FilledTaxFormCreateInput"]: ValueTypes["FilledTaxFormCreateInput"];
	["FilledTaxFormCreateCountryEntityRelationInput"]: ValueTypes["FilledTaxFormCreateCountryEntityRelationInput"];
	["FilledTaxFormConnectOrCreateCountryRelationInput"]: ValueTypes["FilledTaxFormConnectOrCreateCountryRelationInput"];
	["FormConnectOrCreateTaxRelationInput"]: ValueTypes["FormConnectOrCreateTaxRelationInput"];
	["ContentReferenceConnectOrCreateFormRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateFormRelationInput"];
	["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"]: ValueTypes["ContentReferenceCreateContentWithoutBlocksEntityRelationInput"];
	["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateContentWithoutBlocksRelationInput"];
	["ContentReferenceCreateHeroCarouselEntityRelationInput"]: ValueTypes["ContentReferenceCreateHeroCarouselEntityRelationInput"];
	["HeroCarouselCreateInput"]: ValueTypes["HeroCarouselCreateInput"];
	["HeroCarouselCreatePostsEntityRelationInput"]: ValueTypes["HeroCarouselCreatePostsEntityRelationInput"];
	["PostWithoutHeroCarouselCreateInput"]: ValueTypes["PostWithoutHeroCarouselCreateInput"];
	["PostCreateReportPageEntityRelationInput"]: ValueTypes["PostCreateReportPageEntityRelationInput"];
	["ReportPageLocaleWithoutPostsCreateInput"]: ValueTypes["ReportPageLocaleWithoutPostsCreateInput"];
	["PostConnectOrCreateReportPageRelationInput"]: ValueTypes["PostConnectOrCreateReportPageRelationInput"];
	["PostCreateFundraiseCurrencyEntityRelationInput"]: ValueTypes["PostCreateFundraiseCurrencyEntityRelationInput"];
	["PostConnectOrCreateFundraiseCurrencyRelationInput"]: ValueTypes["PostConnectOrCreateFundraiseCurrencyRelationInput"];
	["PostCreateFundraiseCurrencySumsEntityRelationInput"]: ValueTypes["PostCreateFundraiseCurrencySumsEntityRelationInput"];
	["PostCreateFundraiseSumEntityRelationInput"]: ValueTypes["PostCreateFundraiseSumEntityRelationInput"];
	["PostCreateFundraisingProgressEntityRelationInput"]: ValueTypes["PostCreateFundraisingProgressEntityRelationInput"];
	["HeroCarouselConnectOrCreatePostsRelationInput"]: ValueTypes["HeroCarouselConnectOrCreatePostsRelationInput"];
	["ContentReferenceConnectOrCreateHeroCarouselRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateHeroCarouselRelationInput"];
	["ContentReferenceCreateOrganizationListEntityRelationInput"]: ValueTypes["ContentReferenceCreateOrganizationListEntityRelationInput"];
	["ContentReferenceConnectOrCreateOrganizationListRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateOrganizationListRelationInput"];
	["ContentReferenceCreateTextImageListEntityRelationInput"]: ValueTypes["ContentReferenceCreateTextImageListEntityRelationInput"];
	["TextImageListCreateInput"]: ValueTypes["TextImageListCreateInput"];
	["TextImageListCreateItemsEntityRelationInput"]: ValueTypes["TextImageListCreateItemsEntityRelationInput"];
	["TextImageListItemWithoutListCreateInput"]: ValueTypes["TextImageListItemWithoutListCreateInput"];
	["TextImageListItemCreateImageEntityRelationInput"]: ValueTypes["TextImageListItemCreateImageEntityRelationInput"];
	["TextImageListItemConnectOrCreateImageRelationInput"]: ValueTypes["TextImageListItemConnectOrCreateImageRelationInput"];
	["TextImageListItemCreateLinkEntityRelationInput"]: ValueTypes["TextImageListItemCreateLinkEntityRelationInput"];
	["TextImageListItemConnectOrCreateLinkRelationInput"]: ValueTypes["TextImageListItemConnectOrCreateLinkRelationInput"];
	["TextImageListConnectOrCreateItemsRelationInput"]: ValueTypes["TextImageListConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateTextImageListRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateTextImageListRelationInput"];
	["PostConnectOrCreateContentRelationInput"]: ValueTypes["PostConnectOrCreateContentRelationInput"];
	["ReportPageLocaleConnectOrCreatePostsRelationInput"]: ValueTypes["ReportPageLocaleConnectOrCreatePostsRelationInput"];
	["LocaleConnectOrCreateReportPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateReportPagesRelationInput"];
	["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["GivenGiftsPageLocaleConnectOrCreateLocaleRelationInput"];
	["LinkableConnectOrCreateGivenGiftsPageRelationInput"]: ValueTypes["LinkableConnectOrCreateGivenGiftsPageRelationInput"];
	["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleConnectOrCreateLinkRelationInput"];
	["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateReceivedGiftsPagesRelationInput"];
	["ReportPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["ReportPageLocaleConnectOrCreateLocaleRelationInput"];
	["LinkableConnectOrCreateReportPageRelationInput"]: ValueTypes["LinkableConnectOrCreateReportPageRelationInput"];
	["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["GivenGiftsPageLocaleConnectOrCreateLinkRelationInput"];
	["LocaleConnectOrCreateGivenGiftsPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateGivenGiftsPagesRelationInput"];
	["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["PostOrganizationLocaleConnectOrCreateLocaleRelationInput"];
	["PostOrganizationLocaleCreateDomainEntityRelationInput"]: ValueTypes["PostOrganizationLocaleCreateDomainEntityRelationInput"];
	["PostOrganizationLocaleConnectOrCreateDomainRelationInput"]: ValueTypes["PostOrganizationLocaleConnectOrCreateDomainRelationInput"];
	["PostOrganizationLocaleCreateSeoEntityRelationInput"]: ValueTypes["PostOrganizationLocaleCreateSeoEntityRelationInput"];
	["PostOrganizationLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["PostOrganizationLocaleConnectOrCreateSeoRelationInput"];
	["PostOrganizationLocaleCreateContentEntityRelationInput"]: ValueTypes["PostOrganizationLocaleCreateContentEntityRelationInput"];
	["PostOrganizationLocaleConnectOrCreateContentRelationInput"]: ValueTypes["PostOrganizationLocaleConnectOrCreateContentRelationInput"];
	["LinkableConnectOrCreatePostOrganizationRelationInput"]: ValueTypes["LinkableConnectOrCreatePostOrganizationRelationInput"];
	["PostLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["PostLocaleConnectOrCreateLinkRelationInput"];
	["PostConnectOrCreateLocalesRelationInput"]: ValueTypes["PostConnectOrCreateLocalesRelationInput"];
	["TileItemConnectOrCreatePostRelationInput"]: ValueTypes["TileItemConnectOrCreatePostRelationInput"];
	["TileItemCreateAreaEntityRelationInput"]: ValueTypes["TileItemCreateAreaEntityRelationInput"];
	["TileItemConnectOrCreateAreaRelationInput"]: ValueTypes["TileItemConnectOrCreateAreaRelationInput"];
	["TileItemCreateImageEntityRelationInput"]: ValueTypes["TileItemCreateImageEntityRelationInput"];
	["TileItemConnectOrCreateImageRelationInput"]: ValueTypes["TileItemConnectOrCreateImageRelationInput"];
	["TileItemCreateLinkEntityRelationInput"]: ValueTypes["TileItemCreateLinkEntityRelationInput"];
	["TileItemConnectOrCreateLinkRelationInput"]: ValueTypes["TileItemConnectOrCreateLinkRelationInput"];
	["TileItemCreateOrganizationEntityRelationInput"]: ValueTypes["TileItemCreateOrganizationEntityRelationInput"];
	["TileItemConnectOrCreateOrganizationRelationInput"]: ValueTypes["TileItemConnectOrCreateOrganizationRelationInput"];
	["TileListConnectOrCreateItemsRelationInput"]: ValueTypes["TileListConnectOrCreateItemsRelationInput"];
	["TileListCreateAreaTypeEntityRelationInput"]: ValueTypes["TileListCreateAreaTypeEntityRelationInput"];
	["TileListConnectOrCreateAreaTypeRelationInput"]: ValueTypes["TileListConnectOrCreateAreaTypeRelationInput"];
	["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"]: ValueTypes["FeedPageLocaleConnectOrCreateHeroTilesRelationInput"];
	["FeedPageLocaleCreateSectionListEntityRelationInput"]: ValueTypes["FeedPageLocaleCreateSectionListEntityRelationInput"];
	["FeedPageSectionWithoutFeedPageLocaleCreateInput"]: ValueTypes["FeedPageSectionWithoutFeedPageLocaleCreateInput"];
	["FeedPageSectionCreateTileStripeListEntityRelationInput"]: ValueTypes["FeedPageSectionCreateTileStripeListEntityRelationInput"];
	["FeedPageTileStripeWithoutSectionCreateInput"]: ValueTypes["FeedPageTileStripeWithoutSectionCreateInput"];
	["FeedPageTileStripeCreateTileListEntityRelationInput"]: ValueTypes["FeedPageTileStripeCreateTileListEntityRelationInput"];
	["FeedPageTileStripeConnectOrCreateTileListRelationInput"]: ValueTypes["FeedPageTileStripeConnectOrCreateTileListRelationInput"];
	["FeedPageSectionConnectOrCreateTileStripeListRelationInput"]: ValueTypes["FeedPageSectionConnectOrCreateTileStripeListRelationInput"];
	["FeedPageLocaleConnectOrCreateSectionListRelationInput"]: ValueTypes["FeedPageLocaleConnectOrCreateSectionListRelationInput"];
	["FeedPageLocaleCreateCardListEntityRelationInput"]: ValueTypes["FeedPageLocaleCreateCardListEntityRelationInput"];
	["CardListCreateInput"]: ValueTypes["CardListCreateInput"];
	["CardListCreateItemsEntityRelationInput"]: ValueTypes["CardListCreateItemsEntityRelationInput"];
	["CardItemWithoutListCreateInput"]: ValueTypes["CardItemWithoutListCreateInput"];
	["CardItemCreateLinkEntityRelationInput"]: ValueTypes["CardItemCreateLinkEntityRelationInput"];
	["CardItemConnectOrCreateLinkRelationInput"]: ValueTypes["CardItemConnectOrCreateLinkRelationInput"];
	["CardListConnectOrCreateItemsRelationInput"]: ValueTypes["CardListConnectOrCreateItemsRelationInput"];
	["FeedPageLocaleConnectOrCreateCardListRelationInput"]: ValueTypes["FeedPageLocaleConnectOrCreateCardListRelationInput"];
	["FeedPageLocaleCreateStoryGuideListEntityRelationInput"]: ValueTypes["FeedPageLocaleCreateStoryGuideListEntityRelationInput"];
	["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"]: ValueTypes["FeedPageLocaleConnectOrCreateStoryGuideListRelationInput"];
	["LocaleConnectOrCreateFeedPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateFeedPagesRelationInput"];
	["PostRevisionLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["PostRevisionLocaleConnectOrCreateLocaleRelationInput"];
	["PostRevisionLocaleCreateContentEntityRelationInput"]: ValueTypes["PostRevisionLocaleCreateContentEntityRelationInput"];
	["PostRevisionLocaleConnectOrCreateContentRelationInput"]: ValueTypes["PostRevisionLocaleConnectOrCreateContentRelationInput"];
	["PostRevisionLocaleCreateSeoEntityRelationInput"]: ValueTypes["PostRevisionLocaleCreateSeoEntityRelationInput"];
	["PostRevisionLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["PostRevisionLocaleConnectOrCreateSeoRelationInput"];
	["PostRevisionLocaleCreateLeadContentEntityRelationInput"]: ValueTypes["PostRevisionLocaleCreateLeadContentEntityRelationInput"];
	["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"]: ValueTypes["PostRevisionLocaleConnectOrCreateLeadContentRelationInput"];
	["PostRevisionConnectOrCreateLocalesRelationInput"]: ValueTypes["PostRevisionConnectOrCreateLocalesRelationInput"];
	["PostConnectOrCreateActiveRevisionRelationInput"]: ValueTypes["PostConnectOrCreateActiveRevisionRelationInput"];
	["PostRevisionConnectOrCreatePostRelationInput"]: ValueTypes["PostRevisionConnectOrCreatePostRelationInput"];
	["PostRevisionLocaleConnectOrCreateRootRelationInput"]: ValueTypes["PostRevisionLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreatePostRevisionsRelationInput"]: ValueTypes["LocaleConnectOrCreatePostRevisionsRelationInput"];
	["SentPaymentLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["SentPaymentLocaleConnectOrCreateLocaleRelationInput"];
	["SentPaymentConnectOrCreateLocalesRelationInput"]: ValueTypes["SentPaymentConnectOrCreateLocalesRelationInput"];
	["PostAreaConnectOrCreateSentPaymentsRelationInput"]: ValueTypes["PostAreaConnectOrCreateSentPaymentsRelationInput"];
	["PostOrganizationConnectOrCreateAreaRelationInput"]: ValueTypes["PostOrganizationConnectOrCreateAreaRelationInput"];
	["PostOrganizationCreateSentPaymentsEntityRelationInput"]: ValueTypes["PostOrganizationCreateSentPaymentsEntityRelationInput"];
	["SentPaymentWithoutOrganizationCreateInput"]: ValueTypes["SentPaymentWithoutOrganizationCreateInput"];
	["PostOrganizationConnectOrCreateSentPaymentsRelationInput"]: ValueTypes["PostOrganizationConnectOrCreateSentPaymentsRelationInput"];
	["PostOrganizationLocaleConnectOrCreateRootRelationInput"]: ValueTypes["PostOrganizationLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreatePostOrganizationsRelationInput"]: ValueTypes["LocaleConnectOrCreatePostOrganizationsRelationInput"];
	["PostAreaLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["PostAreaLocaleConnectOrCreateLocaleRelationInput"];
	["PostAreaLocaleCreateSeoEntityRelationInput"]: ValueTypes["PostAreaLocaleCreateSeoEntityRelationInput"];
	["PostAreaLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["PostAreaLocaleConnectOrCreateSeoRelationInput"];
	["PostAreaLocaleCreateBannerEntityRelationInput"]: ValueTypes["PostAreaLocaleCreateBannerEntityRelationInput"];
	["AppBannerCreateInput"]: ValueTypes["AppBannerCreateInput"];
	["AppBannerCreateImageSmallEntityRelationInput"]: ValueTypes["AppBannerCreateImageSmallEntityRelationInput"];
	["AppBannerConnectOrCreateImageSmallRelationInput"]: ValueTypes["AppBannerConnectOrCreateImageSmallRelationInput"];
	["AppBannerCreateImageBigEntityRelationInput"]: ValueTypes["AppBannerCreateImageBigEntityRelationInput"];
	["AppBannerConnectOrCreateImageBigRelationInput"]: ValueTypes["AppBannerConnectOrCreateImageBigRelationInput"];
	["AppBannerCreateTextContentEntityRelationInput"]: ValueTypes["AppBannerCreateTextContentEntityRelationInput"];
	["AppBannerConnectOrCreateTextContentRelationInput"]: ValueTypes["AppBannerConnectOrCreateTextContentRelationInput"];
	["PostAreaLocaleConnectOrCreateBannerRelationInput"]: ValueTypes["PostAreaLocaleConnectOrCreateBannerRelationInput"];
	["PostAreaLocaleCreateContentEntityRelationInput"]: ValueTypes["PostAreaLocaleCreateContentEntityRelationInput"];
	["PostAreaLocaleConnectOrCreateContentRelationInput"]: ValueTypes["PostAreaLocaleConnectOrCreateContentRelationInput"];
	["LinkableConnectOrCreatePostAreaRelationInput"]: ValueTypes["LinkableConnectOrCreatePostAreaRelationInput"];
	["PostOrganizationLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["PostOrganizationLocaleConnectOrCreateLinkRelationInput"];
	["PostOrganizationConnectOrCreateLocalesRelationInput"]: ValueTypes["PostOrganizationConnectOrCreateLocalesRelationInput"];
	["PostConnectOrCreateOrganizationRelationInput"]: ValueTypes["PostConnectOrCreateOrganizationRelationInput"];
	["PostAreaConnectOrCreatePostsRelationInput"]: ValueTypes["PostAreaConnectOrCreatePostsRelationInput"];
	["PostAreaLocaleConnectOrCreateRootRelationInput"]: ValueTypes["PostAreaLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreatePostAreasRelationInput"]: ValueTypes["LocaleConnectOrCreatePostAreasRelationInput"];
	["PostLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["PostLocaleConnectOrCreateLocaleRelationInput"];
	["PostLocaleCreateRootEntityRelationInput"]: ValueTypes["PostLocaleCreateRootEntityRelationInput"];
	["PostWithoutLocalesCreateInput"]: ValueTypes["PostWithoutLocalesCreateInput"];
	["PostLocaleConnectOrCreateRootRelationInput"]: ValueTypes["PostLocaleConnectOrCreateRootRelationInput"];
	["LinkableConnectOrCreatePostRelationInput"]: ValueTypes["LinkableConnectOrCreatePostRelationInput"];
	["LinkConnectOrCreateInternalLinkRelationInput"]: ValueTypes["LinkConnectOrCreateInternalLinkRelationInput"];
	["ContentReferenceConnectOrCreateLinkRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateLinkRelationInput"];
	["ContentReferenceCreatePostsEntityRelationInput"]: ValueTypes["ContentReferenceCreatePostsEntityRelationInput"];
	["PostWithoutContentCreateInput"]: ValueTypes["PostWithoutContentCreateInput"];
	["ContentReferenceConnectOrCreatePostsRelationInput"]: ValueTypes["ContentReferenceConnectOrCreatePostsRelationInput"];
	["ContentBlockConnectOrCreateReferencesRelationInput"]: ValueTypes["ContentBlockConnectOrCreateReferencesRelationInput"];
	["ContentConnectOrCreateBlocksRelationInput"]: ValueTypes["ContentConnectOrCreateBlocksRelationInput"];
	["PostLocaleConnectOrCreateContentRelationInput"]: ValueTypes["PostLocaleConnectOrCreateContentRelationInput"];
	["LocaleConnectOrCreatePostsRelationInput"]: ValueTypes["LocaleConnectOrCreatePostsRelationInput"];
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"];
	["LinkableConnectOrCreateGenericPageRelationInput"]: ValueTypes["LinkableConnectOrCreateGenericPageRelationInput"];
	["PostAreaLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["PostAreaLocaleConnectOrCreateLinkRelationInput"];
	["PostAreaConnectOrCreateLocalesRelationInput"]: ValueTypes["PostAreaConnectOrCreateLocalesRelationInput"];
	["PostConnectOrCreateAreaRelationInput"]: ValueTypes["PostConnectOrCreateAreaRelationInput"];
	["PostOrganizationConnectOrCreatePostsRelationInput"]: ValueTypes["PostOrganizationConnectOrCreatePostsRelationInput"];
	["PostOrganizationListItemConnectOrCreateItemRelationInput"]: ValueTypes["PostOrganizationListItemConnectOrCreateItemRelationInput"];
	["PostOrganizationListItemCreateLinkEntityRelationInput"]: ValueTypes["PostOrganizationListItemCreateLinkEntityRelationInput"];
	["PostOrganizationListItemConnectOrCreateLinkRelationInput"]: ValueTypes["PostOrganizationListItemConnectOrCreateLinkRelationInput"];
	["PostOrganizationListItemCreateImageEntityRelationInput"]: ValueTypes["PostOrganizationListItemCreateImageEntityRelationInput"];
	["PostOrganizationListItemConnectOrCreateImageRelationInput"]: ValueTypes["PostOrganizationListItemConnectOrCreateImageRelationInput"];
	["PostOrganizationListConnectOrCreateItemsRelationInput"]: ValueTypes["PostOrganizationListConnectOrCreateItemsRelationInput"];
	["GeneralConnectOrCreateOrganizationListRelationInput"]: ValueTypes["GeneralConnectOrCreateOrganizationListRelationInput"];
	["GeneralLocaleConnectOrCreateRootRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateRootRelationInput"];
	["GeneralLocaleCreateSeoEntityRelationInput"]: ValueTypes["GeneralLocaleCreateSeoEntityRelationInput"];
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateSeoRelationInput"];
	["GeneralLocaleCreateAppStoreLinkEntityRelationInput"]: ValueTypes["GeneralLocaleCreateAppStoreLinkEntityRelationInput"];
	["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateAppStoreLinkRelationInput"];
	["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"]: ValueTypes["GeneralLocaleCreateGooglePlayLinkEntityRelationInput"];
	["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateGooglePlayLinkRelationInput"];
	["LocaleConnectOrCreateGeneralsRelationInput"]: ValueTypes["LocaleConnectOrCreateGeneralsRelationInput"];
	["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["ReportNavigationLocaleConnectOrCreateLocaleRelationInput"];
	["GenericPageConnectOrCreateReportNavigationRelationInput"]: ValueTypes["GenericPageConnectOrCreateReportNavigationRelationInput"];
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateGenericPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateGenericPagesRelationInput"];
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"];
	["GeneralConnectOrCreateLocalesRelationInput"]: ValueTypes["GeneralConnectOrCreateLocalesRelationInput"];
	["GeneralUpdateInput"]: ValueTypes["GeneralUpdateInput"];
	["GeneralUpdateLocalesEntityRelationInput"]: ValueTypes["GeneralUpdateLocalesEntityRelationInput"];
	["GeneralUpdateLocalesRelationInput"]: ValueTypes["GeneralUpdateLocalesRelationInput"];
	["GeneralLocaleWithoutRootUpdateInput"]: ValueTypes["GeneralLocaleWithoutRootUpdateInput"];
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutGeneralsUpdateInput"]: ValueTypes["LocaleWithoutGeneralsUpdateInput"];
	["LocaleUpdateGenericPagesEntityRelationInput"]: ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"];
	["LocaleUpdateGenericPagesRelationInput"]: ValueTypes["LocaleUpdateGenericPagesRelationInput"];
	["GenericPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["GenericPageLocaleWithoutLocaleUpdateInput"];
	["GenericPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateRootEntityRelationInput"];
	["GenericPageWithoutLocalesUpdateInput"]: ValueTypes["GenericPageWithoutLocalesUpdateInput"];
	["GenericPageUpdateReportNavigationEntityRelationInput"]: ValueTypes["GenericPageUpdateReportNavigationEntityRelationInput"];
	["GenericPageUpdateReportNavigationRelationInput"]: ValueTypes["GenericPageUpdateReportNavigationRelationInput"];
	["ReportNavigationLocaleWithoutPagesUpdateInput"]: ValueTypes["ReportNavigationLocaleWithoutPagesUpdateInput"];
	["ReportNavigationLocaleUpdateRootEntityRelationInput"]: ValueTypes["ReportNavigationLocaleUpdateRootEntityRelationInput"];
	["ReportNavigationWithoutLocalesUpdateInput"]: ValueTypes["ReportNavigationWithoutLocalesUpdateInput"];
	["ReportNavigationLocaleUpsertRootRelationInput"]: ValueTypes["ReportNavigationLocaleUpsertRootRelationInput"];
	["ReportNavigationLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["ReportNavigationLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutReportNavigationsUpdateInput"]: ValueTypes["LocaleWithoutReportNavigationsUpdateInput"];
	["LocaleUpdateGeneralsEntityRelationInput"]: ValueTypes["LocaleUpdateGeneralsEntityRelationInput"];
	["LocaleUpdateGeneralsRelationInput"]: ValueTypes["LocaleUpdateGeneralsRelationInput"];
	["GeneralLocaleWithoutLocaleUpdateInput"]: ValueTypes["GeneralLocaleWithoutLocaleUpdateInput"];
	["GeneralLocaleUpdateRootEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateRootEntityRelationInput"];
	["GeneralWithoutLocalesUpdateInput"]: ValueTypes["GeneralWithoutLocalesUpdateInput"];
	["GeneralUpdateAllAreasIconEntityRelationInput"]: ValueTypes["GeneralUpdateAllAreasIconEntityRelationInput"];
	["ImageUpdateInput"]: ValueTypes["ImageUpdateInput"];
	["GeneralUpsertAllAreasIconRelationInput"]: ValueTypes["GeneralUpsertAllAreasIconRelationInput"];
	["GeneralUpdateAllOrganizationsIconEntityRelationInput"]: ValueTypes["GeneralUpdateAllOrganizationsIconEntityRelationInput"];
	["GeneralUpsertAllOrganizationsIconRelationInput"]: ValueTypes["GeneralUpsertAllOrganizationsIconRelationInput"];
	["GeneralUpdateOrganizationListEntityRelationInput"]: ValueTypes["GeneralUpdateOrganizationListEntityRelationInput"];
	["PostOrganizationListUpdateInput"]: ValueTypes["PostOrganizationListUpdateInput"];
	["PostOrganizationListUpdateItemsEntityRelationInput"]: ValueTypes["PostOrganizationListUpdateItemsEntityRelationInput"];
	["PostOrganizationListUpdateItemsRelationInput"]: ValueTypes["PostOrganizationListUpdateItemsRelationInput"];
	["PostOrganizationListItemWithoutListUpdateInput"]: ValueTypes["PostOrganizationListItemWithoutListUpdateInput"];
	["PostOrganizationListItemUpdateItemEntityRelationInput"]: ValueTypes["PostOrganizationListItemUpdateItemEntityRelationInput"];
	["PostOrganizationUpdateInput"]: ValueTypes["PostOrganizationUpdateInput"];
	["PostOrganizationUpdatePostsEntityRelationInput"]: ValueTypes["PostOrganizationUpdatePostsEntityRelationInput"];
	["PostOrganizationUpdatePostsRelationInput"]: ValueTypes["PostOrganizationUpdatePostsRelationInput"];
	["PostWithoutOrganizationUpdateInput"]: ValueTypes["PostWithoutOrganizationUpdateInput"];
	["PostUpdateAreaEntityRelationInput"]: ValueTypes["PostUpdateAreaEntityRelationInput"];
	["PostAreaWithoutPostsUpdateInput"]: ValueTypes["PostAreaWithoutPostsUpdateInput"];
	["PostAreaUpdateIconEntityRelationInput"]: ValueTypes["PostAreaUpdateIconEntityRelationInput"];
	["PostAreaUpsertIconRelationInput"]: ValueTypes["PostAreaUpsertIconRelationInput"];
	["PostAreaUpdateLocalesEntityRelationInput"]: ValueTypes["PostAreaUpdateLocalesEntityRelationInput"];
	["PostAreaUpdateLocalesRelationInput"]: ValueTypes["PostAreaUpdateLocalesRelationInput"];
	["PostAreaLocaleWithoutRootUpdateInput"]: ValueTypes["PostAreaLocaleWithoutRootUpdateInput"];
	["PostAreaLocaleUpdateLinkEntityRelationInput"]: ValueTypes["PostAreaLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutPostAreaUpdateInput"]: ValueTypes["LinkableWithoutPostAreaUpdateInput"];
	["LinkableUpdateGenericPageEntityRelationInput"]: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"];
	["GenericPageLocaleWithoutLinkUpdateInput"]: ValueTypes["GenericPageLocaleWithoutLinkUpdateInput"];
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutGenericPagesUpdateInput"]: ValueTypes["LocaleWithoutGenericPagesUpdateInput"];
	["LocaleUpdatePostsEntityRelationInput"]: ValueTypes["LocaleUpdatePostsEntityRelationInput"];
	["LocaleUpdatePostsRelationInput"]: ValueTypes["LocaleUpdatePostsRelationInput"];
	["PostLocaleWithoutLocaleUpdateInput"]: ValueTypes["PostLocaleWithoutLocaleUpdateInput"];
	["PostLocaleUpdateContentEntityRelationInput"]: ValueTypes["PostLocaleUpdateContentEntityRelationInput"];
	["ContentUpdateInput"]: ValueTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: ValueTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: ValueTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: ValueTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: ValueTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: ValueTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateImageEntityRelationInput"]: ValueTypes["ContentReferenceUpdateImageEntityRelationInput"];
	["ContentReferenceUpsertImageRelationInput"]: ValueTypes["ContentReferenceUpsertImageRelationInput"];
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: ValueTypes["ContentReferenceUpdateLinkablesEntityRelationInput"];
	["ContentReferenceUpdateVideoEntityRelationInput"]: ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"];
	["VideoUpdateInput"]: ValueTypes["VideoUpdateInput"];
	["VideoUpdatePosterEntityRelationInput"]: ValueTypes["VideoUpdatePosterEntityRelationInput"];
	["VideoUpsertPosterRelationInput"]: ValueTypes["VideoUpsertPosterRelationInput"];
	["ContentReferenceUpsertVideoRelationInput"]: ValueTypes["ContentReferenceUpsertVideoRelationInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: ValueTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: ValueTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: ValueTypes["LinkableUpdateInput"];
	["LinkableUpdatePostEntityRelationInput"]: ValueTypes["LinkableUpdatePostEntityRelationInput"];
	["PostLocaleWithoutLinkUpdateInput"]: ValueTypes["PostLocaleWithoutLinkUpdateInput"];
	["PostLocaleUpdateSeoEntityRelationInput"]: ValueTypes["PostLocaleUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: ValueTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: ValueTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: ValueTypes["SeoUpsertOgImageRelationInput"];
	["PostLocaleUpsertSeoRelationInput"]: ValueTypes["PostLocaleUpsertSeoRelationInput"];
	["PostLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["PostLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPostsUpdateInput"]: ValueTypes["LocaleWithoutPostsUpdateInput"];
	["LocaleUpdatePostAreasEntityRelationInput"]: ValueTypes["LocaleUpdatePostAreasEntityRelationInput"];
	["LocaleUpdatePostAreasRelationInput"]: ValueTypes["LocaleUpdatePostAreasRelationInput"];
	["PostAreaLocaleWithoutLocaleUpdateInput"]: ValueTypes["PostAreaLocaleWithoutLocaleUpdateInput"];
	["PostAreaLocaleUpdateRootEntityRelationInput"]: ValueTypes["PostAreaLocaleUpdateRootEntityRelationInput"];
	["PostAreaWithoutLocalesUpdateInput"]: ValueTypes["PostAreaWithoutLocalesUpdateInput"];
	["PostAreaUpdateRegionListOverrideEntityRelationInput"]: ValueTypes["PostAreaUpdateRegionListOverrideEntityRelationInput"];
	["DonationAmountsRegionListUpdateInput"]: ValueTypes["DonationAmountsRegionListUpdateInput"];
	["DonationAmountsRegionListUpdateRegionsEntityRelationInput"]: ValueTypes["DonationAmountsRegionListUpdateRegionsEntityRelationInput"];
	["DonationAmountsRegionListUpdateRegionsRelationInput"]: ValueTypes["DonationAmountsRegionListUpdateRegionsRelationInput"];
	["DonationAmountsRegionItemWithoutListUpdateInput"]: ValueTypes["DonationAmountsRegionItemWithoutListUpdateInput"];
	["DonationAmountsRegionItemUpdateItemsEntityRelationInput"]: ValueTypes["DonationAmountsRegionItemUpdateItemsEntityRelationInput"];
	["DonationAmountsRegionItemUpdateItemsRelationInput"]: ValueTypes["DonationAmountsRegionItemUpdateItemsRelationInput"];
	["DonationAmountItemWithoutRegionItemUpdateInput"]: ValueTypes["DonationAmountItemWithoutRegionItemUpdateInput"];
	["DonationAmountsRegionItemUpsertItemsRelationInput"]: ValueTypes["DonationAmountsRegionItemUpsertItemsRelationInput"];
	["DonationAmountsRegionItemUpdateRegionEntityRelationInput"]: ValueTypes["DonationAmountsRegionItemUpdateRegionEntityRelationInput"];
	["RegionWithoutDonationItemsUpdateInput"]: ValueTypes["RegionWithoutDonationItemsUpdateInput"];
	["RegionUpdateCurrencyEntityRelationInput"]: ValueTypes["RegionUpdateCurrencyEntityRelationInput"];
	["CurrencyUpdateInput"]: ValueTypes["CurrencyUpdateInput"];
	["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: ValueTypes["CurrencyUpdateAreaSentPaymentCurrencySumsEntityRelationInput"];
	["CurrencyUpdateAreaCurrencySumsEntityRelationInput"]: ValueTypes["CurrencyUpdateAreaCurrencySumsEntityRelationInput"];
	["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"]: ValueTypes["CurrencyUpdateOrganizationCurrencySumsEntityRelationInput"];
	["CurrencyUpdatePostCurrencySumsEntityRelationInput"]: ValueTypes["CurrencyUpdatePostCurrencySumsEntityRelationInput"];
	["RegionUpsertCurrencyRelationInput"]: ValueTypes["RegionUpsertCurrencyRelationInput"];
	["RegionUpdateEnabledPaymentMethodsEntityRelationInput"]: ValueTypes["RegionUpdateEnabledPaymentMethodsEntityRelationInput"];
	["RegionUpdateEnabledPaymentMethodsRelationInput"]: ValueTypes["RegionUpdateEnabledPaymentMethodsRelationInput"];
	["RegionPaymentMethodWithoutRegionUpdateInput"]: ValueTypes["RegionPaymentMethodWithoutRegionUpdateInput"];
	["RegionUpsertEnabledPaymentMethodsRelationInput"]: ValueTypes["RegionUpsertEnabledPaymentMethodsRelationInput"];
	["DonationAmountsRegionItemUpsertRegionRelationInput"]: ValueTypes["DonationAmountsRegionItemUpsertRegionRelationInput"];
	["DonationAmountsRegionListUpsertRegionsRelationInput"]: ValueTypes["DonationAmountsRegionListUpsertRegionsRelationInput"];
	["DonationAmountsRegionListUpdateDonationEntityRelationInput"]: ValueTypes["DonationAmountsRegionListUpdateDonationEntityRelationInput"];
	["DonationWithoutRegionListUpdateInput"]: ValueTypes["DonationWithoutRegionListUpdateInput"];
	["DonationAmountsRegionListUpsertDonationRelationInput"]: ValueTypes["DonationAmountsRegionListUpsertDonationRelationInput"];
	["PostAreaUpsertRegionListOverrideRelationInput"]: ValueTypes["PostAreaUpsertRegionListOverrideRelationInput"];
	["PostAreaUpdatePostsEntityRelationInput"]: ValueTypes["PostAreaUpdatePostsEntityRelationInput"];
	["PostAreaUpdatePostsRelationInput"]: ValueTypes["PostAreaUpdatePostsRelationInput"];
	["PostWithoutAreaUpdateInput"]: ValueTypes["PostWithoutAreaUpdateInput"];
	["PostUpdateOrganizationEntityRelationInput"]: ValueTypes["PostUpdateOrganizationEntityRelationInput"];
	["PostOrganizationWithoutPostsUpdateInput"]: ValueTypes["PostOrganizationWithoutPostsUpdateInput"];
	["PostOrganizationUpdateIconEntityRelationInput"]: ValueTypes["PostOrganizationUpdateIconEntityRelationInput"];
	["PostOrganizationUpsertIconRelationInput"]: ValueTypes["PostOrganizationUpsertIconRelationInput"];
	["PostOrganizationUpdateLocalesEntityRelationInput"]: ValueTypes["PostOrganizationUpdateLocalesEntityRelationInput"];
	["PostOrganizationUpdateLocalesRelationInput"]: ValueTypes["PostOrganizationUpdateLocalesRelationInput"];
	["PostOrganizationLocaleWithoutRootUpdateInput"]: ValueTypes["PostOrganizationLocaleWithoutRootUpdateInput"];
	["PostOrganizationLocaleUpdateLinkEntityRelationInput"]: ValueTypes["PostOrganizationLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutPostOrganizationUpdateInput"]: ValueTypes["LinkableWithoutPostOrganizationUpdateInput"];
	["LinkableUpdatePostAreaEntityRelationInput"]: ValueTypes["LinkableUpdatePostAreaEntityRelationInput"];
	["PostAreaLocaleWithoutLinkUpdateInput"]: ValueTypes["PostAreaLocaleWithoutLinkUpdateInput"];
	["PostAreaLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["PostAreaLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPostAreasUpdateInput"]: ValueTypes["LocaleWithoutPostAreasUpdateInput"];
	["LocaleUpdatePostOrganizationsEntityRelationInput"]: ValueTypes["LocaleUpdatePostOrganizationsEntityRelationInput"];
	["LocaleUpdatePostOrganizationsRelationInput"]: ValueTypes["LocaleUpdatePostOrganizationsRelationInput"];
	["PostOrganizationLocaleWithoutLocaleUpdateInput"]: ValueTypes["PostOrganizationLocaleWithoutLocaleUpdateInput"];
	["PostOrganizationLocaleUpdateRootEntityRelationInput"]: ValueTypes["PostOrganizationLocaleUpdateRootEntityRelationInput"];
	["PostOrganizationWithoutLocalesUpdateInput"]: ValueTypes["PostOrganizationWithoutLocalesUpdateInput"];
	["PostOrganizationUpdateAreaEntityRelationInput"]: ValueTypes["PostOrganizationUpdateAreaEntityRelationInput"];
	["PostAreaUpdateInput"]: ValueTypes["PostAreaUpdateInput"];
	["PostAreaUpdateRegionEntityRelationInput"]: ValueTypes["PostAreaUpdateRegionEntityRelationInput"];
	["RegionUpdateInput"]: ValueTypes["RegionUpdateInput"];
	["RegionUpdateDonationItemsEntityRelationInput"]: ValueTypes["RegionUpdateDonationItemsEntityRelationInput"];
	["RegionUpdateDonationItemsRelationInput"]: ValueTypes["RegionUpdateDonationItemsRelationInput"];
	["DonationAmountsRegionItemWithoutRegionUpdateInput"]: ValueTypes["DonationAmountsRegionItemWithoutRegionUpdateInput"];
	["DonationAmountsRegionItemUpdateListEntityRelationInput"]: ValueTypes["DonationAmountsRegionItemUpdateListEntityRelationInput"];
	["DonationAmountsRegionListWithoutRegionsUpdateInput"]: ValueTypes["DonationAmountsRegionListWithoutRegionsUpdateInput"];
	["DonationAmountsRegionItemUpsertListRelationInput"]: ValueTypes["DonationAmountsRegionItemUpsertListRelationInput"];
	["RegionUpsertDonationItemsRelationInput"]: ValueTypes["RegionUpsertDonationItemsRelationInput"];
	["PostAreaUpsertRegionRelationInput"]: ValueTypes["PostAreaUpsertRegionRelationInput"];
	["PostAreaUpdateMetaEntityRelationInput"]: ValueTypes["PostAreaUpdateMetaEntityRelationInput"];
	["PostAreaUpdateMobileHeroImageEntityRelationInput"]: ValueTypes["PostAreaUpdateMobileHeroImageEntityRelationInput"];
	["PostAreaUpsertMobileHeroImageRelationInput"]: ValueTypes["PostAreaUpsertMobileHeroImageRelationInput"];
	["PostAreaUpdatePlainIconEntityRelationInput"]: ValueTypes["PostAreaUpdatePlainIconEntityRelationInput"];
	["PostAreaUpsertPlainIconRelationInput"]: ValueTypes["PostAreaUpsertPlainIconRelationInput"];
	["PostAreaUpdateSentPaymentsEntityRelationInput"]: ValueTypes["PostAreaUpdateSentPaymentsEntityRelationInput"];
	["PostAreaUpdateSentPaymentsRelationInput"]: ValueTypes["PostAreaUpdateSentPaymentsRelationInput"];
	["SentPaymentWithoutAreaUpdateInput"]: ValueTypes["SentPaymentWithoutAreaUpdateInput"];
	["SentPaymentUpdateCurrencyEntityRelationInput"]: ValueTypes["SentPaymentUpdateCurrencyEntityRelationInput"];
	["SentPaymentUpsertCurrencyRelationInput"]: ValueTypes["SentPaymentUpsertCurrencyRelationInput"];
	["SentPaymentUpdateOrganizationEntityRelationInput"]: ValueTypes["SentPaymentUpdateOrganizationEntityRelationInput"];
	["PostOrganizationWithoutSentPaymentsUpdateInput"]: ValueTypes["PostOrganizationWithoutSentPaymentsUpdateInput"];
	["PostOrganizationUpdateMetaEntityRelationInput"]: ValueTypes["PostOrganizationUpdateMetaEntityRelationInput"];
	["PostOrganizationUpdateMobileHeroImageEntityRelationInput"]: ValueTypes["PostOrganizationUpdateMobileHeroImageEntityRelationInput"];
	["PostOrganizationUpsertMobileHeroImageRelationInput"]: ValueTypes["PostOrganizationUpsertMobileHeroImageRelationInput"];
	["PostOrganizationUpdatePlainIconEntityRelationInput"]: ValueTypes["PostOrganizationUpdatePlainIconEntityRelationInput"];
	["PostOrganizationUpsertPlainIconRelationInput"]: ValueTypes["PostOrganizationUpsertPlainIconRelationInput"];
	["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"]: ValueTypes["PostOrganizationUpdateDesktopHeroImageEntityRelationInput"];
	["PostOrganizationUpsertDesktopHeroImageRelationInput"]: ValueTypes["PostOrganizationUpsertDesktopHeroImageRelationInput"];
	["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"]: ValueTypes["PostOrganizationUpdateOrganizationCurrencySumsEntityRelationInput"];
	["PostOrganizationUpdateOrganizationSumEntityRelationInput"]: ValueTypes["PostOrganizationUpdateOrganizationSumEntityRelationInput"];
	["SentPaymentUpsertOrganizationRelationInput"]: ValueTypes["SentPaymentUpsertOrganizationRelationInput"];
	["SentPaymentUpdateLocalesEntityRelationInput"]: ValueTypes["SentPaymentUpdateLocalesEntityRelationInput"];
	["SentPaymentUpdateLocalesRelationInput"]: ValueTypes["SentPaymentUpdateLocalesRelationInput"];
	["SentPaymentLocaleWithoutRootUpdateInput"]: ValueTypes["SentPaymentLocaleWithoutRootUpdateInput"];
	["SentPaymentLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["SentPaymentLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutSentPaymentsUpdateInput"]: ValueTypes["LocaleWithoutSentPaymentsUpdateInput"];
	["LocaleUpdateHeadersEntityRelationInput"]: ValueTypes["LocaleUpdateHeadersEntityRelationInput"];
	["LocaleUpdateHeadersRelationInput"]: ValueTypes["LocaleUpdateHeadersRelationInput"];
	["HeaderLocaleWithoutLocaleUpdateInput"]: ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"];
	["HeaderLocaleUpdateRootEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"];
	["HeaderWithoutLocalesUpdateInput"]: ValueTypes["HeaderWithoutLocalesUpdateInput"];
	["HeaderUpdateLogoEntityRelationInput"]: ValueTypes["HeaderUpdateLogoEntityRelationInput"];
	["HeaderUpsertLogoRelationInput"]: ValueTypes["HeaderUpsertLogoRelationInput"];
	["HeaderUpdateOrganizationListEntityRelationInput"]: ValueTypes["HeaderUpdateOrganizationListEntityRelationInput"];
	["HeaderUpsertOrganizationListRelationInput"]: ValueTypes["HeaderUpsertOrganizationListRelationInput"];
	["HeaderLocaleUpsertRootRelationInput"]: ValueTypes["HeaderLocaleUpsertRootRelationInput"];
	["HeaderLocaleUpdateLinksEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateLinksEntityRelationInput"];
	["LinkListUpdateInput"]: ValueTypes["LinkListUpdateInput"];
	["LinkListUpdateItemsEntityRelationInput"]: ValueTypes["LinkListUpdateItemsEntityRelationInput"];
	["LinkListUpdateItemsRelationInput"]: ValueTypes["LinkListUpdateItemsRelationInput"];
	["LinkItemWithoutListUpdateInput"]: ValueTypes["LinkItemWithoutListUpdateInput"];
	["LinkItemUpdateLinkEntityRelationInput"]: ValueTypes["LinkItemUpdateLinkEntityRelationInput"];
	["LinkItemUpsertLinkRelationInput"]: ValueTypes["LinkItemUpsertLinkRelationInput"];
	["LinkListUpsertItemsRelationInput"]: ValueTypes["LinkListUpsertItemsRelationInput"];
	["HeaderLocaleUpsertLinksRelationInput"]: ValueTypes["HeaderLocaleUpsertLinksRelationInput"];
	["LocaleUpsertHeadersRelationInput"]: ValueTypes["LocaleUpsertHeadersRelationInput"];
	["LocaleUpdateFootersEntityRelationInput"]: ValueTypes["LocaleUpdateFootersEntityRelationInput"];
	["LocaleUpdateFootersRelationInput"]: ValueTypes["LocaleUpdateFootersRelationInput"];
	["FooterLocaleWithoutLocaleUpdateInput"]: ValueTypes["FooterLocaleWithoutLocaleUpdateInput"];
	["FooterLocaleUpdateRootEntityRelationInput"]: ValueTypes["FooterLocaleUpdateRootEntityRelationInput"];
	["FooterWithoutLocalesUpdateInput"]: ValueTypes["FooterWithoutLocalesUpdateInput"];
	["FooterUpdateLogoEntityRelationInput"]: ValueTypes["FooterUpdateLogoEntityRelationInput"];
	["FooterUpsertLogoRelationInput"]: ValueTypes["FooterUpsertLogoRelationInput"];
	["FooterLocaleUpsertRootRelationInput"]: ValueTypes["FooterLocaleUpsertRootRelationInput"];
	["FooterLocaleUpdateLinkListEntityRelationInput"]: ValueTypes["FooterLocaleUpdateLinkListEntityRelationInput"];
	["FooterLocaleUpsertLinkListRelationInput"]: ValueTypes["FooterLocaleUpsertLinkListRelationInput"];
	["FooterLocaleUpdateAddressInfoEntityRelationInput"]: ValueTypes["FooterLocaleUpdateAddressInfoEntityRelationInput"];
	["FooterLocaleUpsertAddressInfoRelationInput"]: ValueTypes["FooterLocaleUpsertAddressInfoRelationInput"];
	["FooterLocaleUpdateImageLinkListEntityRelationInput"]: ValueTypes["FooterLocaleUpdateImageLinkListEntityRelationInput"];
	["ImageLinkListUpdateInput"]: ValueTypes["ImageLinkListUpdateInput"];
	["ImageLinkListUpdateItemsEntityRelationInput"]: ValueTypes["ImageLinkListUpdateItemsEntityRelationInput"];
	["ImageLinkListUpdateItemsRelationInput"]: ValueTypes["ImageLinkListUpdateItemsRelationInput"];
	["ImageLinkItemWithoutListUpdateInput"]: ValueTypes["ImageLinkItemWithoutListUpdateInput"];
	["ImageLinkItemUpdateItemEntityRelationInput"]: ValueTypes["ImageLinkItemUpdateItemEntityRelationInput"];
	["ImageLinkUpdateInput"]: ValueTypes["ImageLinkUpdateInput"];
	["ImageLinkUpdateImageEntityRelationInput"]: ValueTypes["ImageLinkUpdateImageEntityRelationInput"];
	["ImageLinkUpsertImageRelationInput"]: ValueTypes["ImageLinkUpsertImageRelationInput"];
	["ImageLinkUpdateLinkEntityRelationInput"]: ValueTypes["ImageLinkUpdateLinkEntityRelationInput"];
	["ImageLinkUpsertLinkRelationInput"]: ValueTypes["ImageLinkUpsertLinkRelationInput"];
	["ImageLinkItemUpsertItemRelationInput"]: ValueTypes["ImageLinkItemUpsertItemRelationInput"];
	["ImageLinkListUpsertItemsRelationInput"]: ValueTypes["ImageLinkListUpsertItemsRelationInput"];
	["FooterLocaleUpsertImageLinkListRelationInput"]: ValueTypes["FooterLocaleUpsertImageLinkListRelationInput"];
	["LocaleUpsertFootersRelationInput"]: ValueTypes["LocaleUpsertFootersRelationInput"];
	["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"]: ValueTypes["LocaleUpdateGenericPageAboutSettingsEntityRelationInput"];
	["LocaleUpdateGenericPageAboutSettingsRelationInput"]: ValueTypes["LocaleUpdateGenericPageAboutSettingsRelationInput"];
	["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"]: ValueTypes["GenericPageAboutSettingsLocaleWithoutLocaleUpdateInput"];
	["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleUpdateRootEntityRelationInput"];
	["GenericPageAboutSettingsWithoutLocalesUpdateInput"]: ValueTypes["GenericPageAboutSettingsWithoutLocalesUpdateInput"];
	["GenericPageAboutSettingsLocaleUpsertRootRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleUpsertRootRelationInput"];
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsEntityRelationInput"];
	["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleUpdateLinkGroupsRelationInput"];
	["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleWithoutSettingsUpdateInput"];
	["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateLinkListEntityRelationInput"];
	["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleUpsertLinkListRelationInput"];
	["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleUpsertLinkGroupsRelationInput"];
	["LocaleUpsertGenericPageAboutSettingsRelationInput"]: ValueTypes["LocaleUpsertGenericPageAboutSettingsRelationInput"];
	["LocaleUpdatePostRevisionsEntityRelationInput"]: ValueTypes["LocaleUpdatePostRevisionsEntityRelationInput"];
	["LocaleUpdatePostRevisionsRelationInput"]: ValueTypes["LocaleUpdatePostRevisionsRelationInput"];
	["PostRevisionLocaleWithoutLocaleUpdateInput"]: ValueTypes["PostRevisionLocaleWithoutLocaleUpdateInput"];
	["PostRevisionLocaleUpdateRootEntityRelationInput"]: ValueTypes["PostRevisionLocaleUpdateRootEntityRelationInput"];
	["PostRevisionWithoutLocalesUpdateInput"]: ValueTypes["PostRevisionWithoutLocalesUpdateInput"];
	["PostRevisionUpdatePostEntityRelationInput"]: ValueTypes["PostRevisionUpdatePostEntityRelationInput"];
	["PostWithoutRevisionsUpdateInput"]: ValueTypes["PostWithoutRevisionsUpdateInput"];
	["PostUpdateActiveRevisionEntityRelationInput"]: ValueTypes["PostUpdateActiveRevisionEntityRelationInput"];
	["PostRevisionUpdateInput"]: ValueTypes["PostRevisionUpdateInput"];
	["PostRevisionUpdateTileImageEntityRelationInput"]: ValueTypes["PostRevisionUpdateTileImageEntityRelationInput"];
	["PostRevisionUpsertTileImageRelationInput"]: ValueTypes["PostRevisionUpsertTileImageRelationInput"];
	["PostRevisionUpdateTileVideoEntityRelationInput"]: ValueTypes["PostRevisionUpdateTileVideoEntityRelationInput"];
	["PostRevisionUpsertTileVideoRelationInput"]: ValueTypes["PostRevisionUpsertTileVideoRelationInput"];
	["PostRevisionUpdateHeroImageEntityRelationInput"]: ValueTypes["PostRevisionUpdateHeroImageEntityRelationInput"];
	["PostRevisionUpsertHeroImageRelationInput"]: ValueTypes["PostRevisionUpsertHeroImageRelationInput"];
	["PostRevisionUpdateLocalesEntityRelationInput"]: ValueTypes["PostRevisionUpdateLocalesEntityRelationInput"];
	["PostRevisionUpdateLocalesRelationInput"]: ValueTypes["PostRevisionUpdateLocalesRelationInput"];
	["PostRevisionLocaleWithoutRootUpdateInput"]: ValueTypes["PostRevisionLocaleWithoutRootUpdateInput"];
	["PostRevisionLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["PostRevisionLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPostRevisionsUpdateInput"]: ValueTypes["LocaleWithoutPostRevisionsUpdateInput"];
	["LocaleUpdateFlagImageEntityRelationInput"]: ValueTypes["LocaleUpdateFlagImageEntityRelationInput"];
	["LocaleUpsertFlagImageRelationInput"]: ValueTypes["LocaleUpsertFlagImageRelationInput"];
	["LocaleUpdateFeedPagesEntityRelationInput"]: ValueTypes["LocaleUpdateFeedPagesEntityRelationInput"];
	["LocaleUpdateFeedPagesRelationInput"]: ValueTypes["LocaleUpdateFeedPagesRelationInput"];
	["FeedPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["FeedPageLocaleWithoutLocaleUpdateInput"];
	["FeedPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["FeedPageLocaleUpdateRootEntityRelationInput"];
	["FeedPageWithoutLocalesUpdateInput"]: ValueTypes["FeedPageWithoutLocalesUpdateInput"];
	["FeedPageLocaleUpsertRootRelationInput"]: ValueTypes["FeedPageLocaleUpsertRootRelationInput"];
	["FeedPageLocaleUpdateHeroTilesEntityRelationInput"]: ValueTypes["FeedPageLocaleUpdateHeroTilesEntityRelationInput"];
	["TileListUpdateInput"]: ValueTypes["TileListUpdateInput"];
	["TileListUpdateItemsEntityRelationInput"]: ValueTypes["TileListUpdateItemsEntityRelationInput"];
	["TileListUpdateItemsRelationInput"]: ValueTypes["TileListUpdateItemsRelationInput"];
	["TileItemWithoutListUpdateInput"]: ValueTypes["TileItemWithoutListUpdateInput"];
	["TileItemUpdatePostEntityRelationInput"]: ValueTypes["TileItemUpdatePostEntityRelationInput"];
	["PostUpdateInput"]: ValueTypes["PostUpdateInput"];
	["PostUpdateRevisionsEntityRelationInput"]: ValueTypes["PostUpdateRevisionsEntityRelationInput"];
	["PostUpdateRevisionsRelationInput"]: ValueTypes["PostUpdateRevisionsRelationInput"];
	["PostRevisionWithoutPostUpdateInput"]: ValueTypes["PostRevisionWithoutPostUpdateInput"];
	["PostRevisionUpdateRegionListOverrideEntityRelationInput"]: ValueTypes["PostRevisionUpdateRegionListOverrideEntityRelationInput"];
	["PostRevisionUpsertRegionListOverrideRelationInput"]: ValueTypes["PostRevisionUpsertRegionListOverrideRelationInput"];
	["PostUpsertRevisionsRelationInput"]: ValueTypes["PostUpsertRevisionsRelationInput"];
	["PostUpdateLocalesEntityRelationInput"]: ValueTypes["PostUpdateLocalesEntityRelationInput"];
	["PostUpdateLocalesRelationInput"]: ValueTypes["PostUpdateLocalesRelationInput"];
	["PostLocaleWithoutRootUpdateInput"]: ValueTypes["PostLocaleWithoutRootUpdateInput"];
	["PostLocaleUpdateLinkEntityRelationInput"]: ValueTypes["PostLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutPostUpdateInput"]: ValueTypes["LinkableWithoutPostUpdateInput"];
	["LinkableUpdatePostOrganizationEntityRelationInput"]: ValueTypes["LinkableUpdatePostOrganizationEntityRelationInput"];
	["PostOrganizationLocaleWithoutLinkUpdateInput"]: ValueTypes["PostOrganizationLocaleWithoutLinkUpdateInput"];
	["PostOrganizationLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["PostOrganizationLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPostOrganizationsUpdateInput"]: ValueTypes["LocaleWithoutPostOrganizationsUpdateInput"];
	["LocaleUpdateRecurringPaymentPagesEntityRelationInput"]: ValueTypes["LocaleUpdateRecurringPaymentPagesEntityRelationInput"];
	["LocaleUpdateRecurringPaymentPagesRelationInput"]: ValueTypes["LocaleUpdateRecurringPaymentPagesRelationInput"];
	["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["RecurringPaymentPageLocaleWithoutLocaleUpdateInput"];
	["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["RecurringPaymentPageLocaleUpdateRootEntityRelationInput"];
	["RecurringPaymentPageWithoutLocalesUpdateInput"]: ValueTypes["RecurringPaymentPageWithoutLocalesUpdateInput"];
	["RecurringPaymentPageLocaleUpsertRootRelationInput"]: ValueTypes["RecurringPaymentPageLocaleUpsertRootRelationInput"];
	["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"]: ValueTypes["RecurringPaymentPageLocaleUpdateFavouritePostsEntityRelationInput"];
	["PostListUpdateInput"]: ValueTypes["PostListUpdateInput"];
	["PostListUpdateItemsEntityRelationInput"]: ValueTypes["PostListUpdateItemsEntityRelationInput"];
	["PostListUpdateItemsRelationInput"]: ValueTypes["PostListUpdateItemsRelationInput"];
	["PostListItemWithoutListUpdateInput"]: ValueTypes["PostListItemWithoutListUpdateInput"];
	["PostListItemUpdatePostEntityRelationInput"]: ValueTypes["PostListItemUpdatePostEntityRelationInput"];
	["PostListItemUpsertPostRelationInput"]: ValueTypes["PostListItemUpsertPostRelationInput"];
	["PostListUpsertItemsRelationInput"]: ValueTypes["PostListUpsertItemsRelationInput"];
	["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"]: ValueTypes["RecurringPaymentPageLocaleUpsertFavouritePostsRelationInput"];
	["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"]: ValueTypes["RecurringPaymentPageLocaleUpdateStoryGuideListEntityRelationInput"];
	["StoryGuideListUpdateInput"]: ValueTypes["StoryGuideListUpdateInput"];
	["StoryGuideListUpdateItemsEntityRelationInput"]: ValueTypes["StoryGuideListUpdateItemsEntityRelationInput"];
	["StoryGuideListUpdateItemsRelationInput"]: ValueTypes["StoryGuideListUpdateItemsRelationInput"];
	["StoryGuideItemWithoutListUpdateInput"]: ValueTypes["StoryGuideItemWithoutListUpdateInput"];
	["StoryGuideItemUpdateGuideEntityRelationInput"]: ValueTypes["StoryGuideItemUpdateGuideEntityRelationInput"];
	["StoryGuideUpdateInput"]: ValueTypes["StoryGuideUpdateInput"];
	["StoryGuideUpdateImageEntityRelationInput"]: ValueTypes["StoryGuideUpdateImageEntityRelationInput"];
	["StoryGuideUpsertImageRelationInput"]: ValueTypes["StoryGuideUpsertImageRelationInput"];
	["StoryGuideUpdateSecondaryImageEntityRelationInput"]: ValueTypes["StoryGuideUpdateSecondaryImageEntityRelationInput"];
	["StoryGuideUpsertSecondaryImageRelationInput"]: ValueTypes["StoryGuideUpsertSecondaryImageRelationInput"];
	["StoryGuideItemUpsertGuideRelationInput"]: ValueTypes["StoryGuideItemUpsertGuideRelationInput"];
	["StoryGuideListUpsertItemsRelationInput"]: ValueTypes["StoryGuideListUpsertItemsRelationInput"];
	["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"]: ValueTypes["RecurringPaymentPageLocaleUpsertStoryGuideListRelationInput"];
	["LocaleUpsertRecurringPaymentPagesRelationInput"]: ValueTypes["LocaleUpsertRecurringPaymentPagesRelationInput"];
	["LocaleUpdateGivenGiftsPagesEntityRelationInput"]: ValueTypes["LocaleUpdateGivenGiftsPagesEntityRelationInput"];
	["LocaleUpdateGivenGiftsPagesRelationInput"]: ValueTypes["LocaleUpdateGivenGiftsPagesRelationInput"];
	["GivenGiftsPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["GivenGiftsPageLocaleWithoutLocaleUpdateInput"];
	["GivenGiftsPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpdateRootEntityRelationInput"];
	["GivenGiftsPageWithoutLocalesUpdateInput"]: ValueTypes["GivenGiftsPageWithoutLocalesUpdateInput"];
	["GivenGiftsPageLocaleUpsertRootRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpsertRootRelationInput"];
	["GivenGiftsPageLocaleUpdateContentEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpdateContentEntityRelationInput"];
	["GivenGiftsPageLocaleUpsertContentRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpsertContentRelationInput"];
	["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpdateSeoEntityRelationInput"];
	["GivenGiftsPageLocaleUpsertSeoRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpsertSeoRelationInput"];
	["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutGivenGiftsPageUpdateInput"]: ValueTypes["LinkableWithoutGivenGiftsPageUpdateInput"];
	["LinkableUpdateReportPageEntityRelationInput"]: ValueTypes["LinkableUpdateReportPageEntityRelationInput"];
	["ReportPageLocaleWithoutLinkUpdateInput"]: ValueTypes["ReportPageLocaleWithoutLinkUpdateInput"];
	["ReportPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["ReportPageLocaleUpdateRootEntityRelationInput"];
	["ReportPageWithoutLocalesUpdateInput"]: ValueTypes["ReportPageWithoutLocalesUpdateInput"];
	["ReportPageLocaleUpsertRootRelationInput"]: ValueTypes["ReportPageLocaleUpsertRootRelationInput"];
	["ReportPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["ReportPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutReportPagesUpdateInput"]: ValueTypes["LocaleWithoutReportPagesUpdateInput"];
	["LocaleUpdateReceivedGiftsPagesEntityRelationInput"]: ValueTypes["LocaleUpdateReceivedGiftsPagesEntityRelationInput"];
	["LocaleUpdateReceivedGiftsPagesRelationInput"]: ValueTypes["LocaleUpdateReceivedGiftsPagesRelationInput"];
	["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["ReceivedGiftsPageLocaleWithoutLocaleUpdateInput"];
	["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutReceivedGiftsPageUpdateInput"]: ValueTypes["LinkableWithoutReceivedGiftsPageUpdateInput"];
	["LinkableUpdateGivenGiftsPageEntityRelationInput"]: ValueTypes["LinkableUpdateGivenGiftsPageEntityRelationInput"];
	["GivenGiftsPageLocaleWithoutLinkUpdateInput"]: ValueTypes["GivenGiftsPageLocaleWithoutLinkUpdateInput"];
	["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutGivenGiftsPagesUpdateInput"]: ValueTypes["LocaleWithoutGivenGiftsPagesUpdateInput"];
	["LocaleUpdateReportPagesEntityRelationInput"]: ValueTypes["LocaleUpdateReportPagesEntityRelationInput"];
	["LocaleUpdateReportPagesRelationInput"]: ValueTypes["LocaleUpdateReportPagesRelationInput"];
	["ReportPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["ReportPageLocaleWithoutLocaleUpdateInput"];
	["ReportPageLocaleUpdateLinkEntityRelationInput"]: ValueTypes["ReportPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutReportPageUpdateInput"]: ValueTypes["LinkableWithoutReportPageUpdateInput"];
	["LinkableUpdateReceivedGiftsPageEntityRelationInput"]: ValueTypes["LinkableUpdateReceivedGiftsPageEntityRelationInput"];
	["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"]: ValueTypes["ReceivedGiftsPageLocaleWithoutLinkUpdateInput"];
	["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpdateRootEntityRelationInput"];
	["ReceivedGiftsPageWithoutLocalesUpdateInput"]: ValueTypes["ReceivedGiftsPageWithoutLocalesUpdateInput"];
	["ReceivedGiftsPageLocaleUpsertRootRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpsertRootRelationInput"];
	["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutReceivedGiftsPagesUpdateInput"]: ValueTypes["LocaleWithoutReceivedGiftsPagesUpdateInput"];
	["LocaleUpdateReportNavigationsEntityRelationInput"]: ValueTypes["LocaleUpdateReportNavigationsEntityRelationInput"];
	["LocaleUpdateReportNavigationsRelationInput"]: ValueTypes["LocaleUpdateReportNavigationsRelationInput"];
	["ReportNavigationLocaleWithoutLocaleUpdateInput"]: ValueTypes["ReportNavigationLocaleWithoutLocaleUpdateInput"];
	["ReportNavigationLocaleUpdatePagesEntityRelationInput"]: ValueTypes["ReportNavigationLocaleUpdatePagesEntityRelationInput"];
	["ReportNavigationLocaleUpdatePagesRelationInput"]: ValueTypes["ReportNavigationLocaleUpdatePagesRelationInput"];
	["GenericPageWithoutReportNavigationUpdateInput"]: ValueTypes["GenericPageWithoutReportNavigationUpdateInput"];
	["GenericPageUpdateLocalesEntityRelationInput"]: ValueTypes["GenericPageUpdateLocalesEntityRelationInput"];
	["GenericPageUpdateLocalesRelationInput"]: ValueTypes["GenericPageUpdateLocalesRelationInput"];
	["GenericPageLocaleWithoutRootUpdateInput"]: ValueTypes["GenericPageLocaleWithoutRootUpdateInput"];
	["GenericPageLocaleUpdateContentEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"];
	["GenericPageLocaleUpsertContentRelationInput"]: ValueTypes["GenericPageLocaleUpsertContentRelationInput"];
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"];
	["GenericPageLocaleUpsertSeoRelationInput"]: ValueTypes["GenericPageLocaleUpsertSeoRelationInput"];
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutGenericPageUpdateInput"]: ValueTypes["LinkableWithoutGenericPageUpdateInput"];
	["GenericPageLocaleUpsertLinkRelationInput"]: ValueTypes["GenericPageLocaleUpsertLinkRelationInput"];
	["GenericPageUpsertLocalesRelationInput"]: ValueTypes["GenericPageUpsertLocalesRelationInput"];
	["ReportNavigationLocaleUpsertPagesRelationInput"]: ValueTypes["ReportNavigationLocaleUpsertPagesRelationInput"];
	["LocaleUpsertReportNavigationsRelationInput"]: ValueTypes["LocaleUpsertReportNavigationsRelationInput"];
	["LocaleUpdateScheduledNotificationsEntityRelationInput"]: ValueTypes["LocaleUpdateScheduledNotificationsEntityRelationInput"];
	["LocaleUpdateScheduledNotificationsRelationInput"]: ValueTypes["LocaleUpdateScheduledNotificationsRelationInput"];
	["ScheduledNotificationLocaleWithoutLocaleUpdateInput"]: ValueTypes["ScheduledNotificationLocaleWithoutLocaleUpdateInput"];
	["ScheduledNotificationLocaleUpdateRootEntityRelationInput"]: ValueTypes["ScheduledNotificationLocaleUpdateRootEntityRelationInput"];
	["ScheduledNotificationWithoutLocalesUpdateInput"]: ValueTypes["ScheduledNotificationWithoutLocalesUpdateInput"];
	["ScheduledNotificationUpdateTargetEntityRelationInput"]: ValueTypes["ScheduledNotificationUpdateTargetEntityRelationInput"];
	["NotificationTargetGroupUpdateInput"]: ValueTypes["NotificationTargetGroupUpdateInput"];
	["NotificationTargetGroupUpdateRegionsEntityRelationInput"]: ValueTypes["NotificationTargetGroupUpdateRegionsEntityRelationInput"];
	["NotificationTargetGroupUpdateRegionsRelationInput"]: ValueTypes["NotificationTargetGroupUpdateRegionsRelationInput"];
	["NotificationTargetGroupUpsertRegionsRelationInput"]: ValueTypes["NotificationTargetGroupUpsertRegionsRelationInput"];
	["ScheduledNotificationUpsertTargetRelationInput"]: ValueTypes["ScheduledNotificationUpsertTargetRelationInput"];
	["ScheduledNotificationUpdateImageEntityRelationInput"]: ValueTypes["ScheduledNotificationUpdateImageEntityRelationInput"];
	["ScheduledNotificationUpsertImageRelationInput"]: ValueTypes["ScheduledNotificationUpsertImageRelationInput"];
	["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"]: ValueTypes["ScheduledNotificationUpdateProcessedNotificationsEntityRelationInput"];
	["ScheduledNotificationUpdateProcessedNotificationsRelationInput"]: ValueTypes["ScheduledNotificationUpdateProcessedNotificationsRelationInput"];
	["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"]: ValueTypes["ProcessedNotificationSourceWithoutScheduledNotificationUpdateInput"];
	["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"]: ValueTypes["ProcessedNotificationSourceUpdateProcessedNotificationEntityRelationInput"];
	["ProcessedNotificationWithoutSourceUpdateInput"]: ValueTypes["ProcessedNotificationWithoutSourceUpdateInput"];
	["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"]: ValueTypes["ProcessedNotificationSourceUpsertProcessedNotificationRelationInput"];
	["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"]: ValueTypes["ProcessedNotificationSourceUpdateDonationReminderUserEntityRelationInput"];
	["UserWithoutProcessedNotificationsUpdateInput"]: ValueTypes["UserWithoutProcessedNotificationsUpdateInput"];
	["UserUpdatePaymentsEntityRelationInput"]: ValueTypes["UserUpdatePaymentsEntityRelationInput"];
	["UserUpdatePaymentsRelationInput"]: ValueTypes["UserUpdatePaymentsRelationInput"];
	["UserPaymentWithoutUserUpdateInput"]: ValueTypes["UserPaymentWithoutUserUpdateInput"];
	["UserPaymentUpdateCurrencyEntityRelationInput"]: ValueTypes["UserPaymentUpdateCurrencyEntityRelationInput"];
	["UserPaymentUpsertCurrencyRelationInput"]: ValueTypes["UserPaymentUpsertCurrencyRelationInput"];
	["UserPaymentUpdateOrderEntityRelationInput"]: ValueTypes["UserPaymentUpdateOrderEntityRelationInput"];
	["UserPaymentOrderIdUpdateInput"]: ValueTypes["UserPaymentOrderIdUpdateInput"];
	["UserPaymentUpsertOrderRelationInput"]: ValueTypes["UserPaymentUpsertOrderRelationInput"];
	["UserPaymentUpdateCsobPaymentEntityRelationInput"]: ValueTypes["UserPaymentUpdateCsobPaymentEntityRelationInput"];
	["CsobPaymentWithoutPaymentUpdateInput"]: ValueTypes["CsobPaymentWithoutPaymentUpdateInput"];
	["CsobPaymentUpdateStatusChangesEntityRelationInput"]: ValueTypes["CsobPaymentUpdateStatusChangesEntityRelationInput"];
	["CsobPaymentUpdateStatusChangesRelationInput"]: ValueTypes["CsobPaymentUpdateStatusChangesRelationInput"];
	["CsobPaymentStatusChangeWithoutPaymentUpdateInput"]: ValueTypes["CsobPaymentStatusChangeWithoutPaymentUpdateInput"];
	["CsobPaymentUpsertStatusChangesRelationInput"]: ValueTypes["CsobPaymentUpsertStatusChangesRelationInput"];
	["CsobPaymentUpdateMetadataEntityRelationInput"]: ValueTypes["CsobPaymentUpdateMetadataEntityRelationInput"];
	["UserPaymentUpsertCsobPaymentRelationInput"]: ValueTypes["UserPaymentUpsertCsobPaymentRelationInput"];
	["UserPaymentUpdateStripePaymentEntityRelationInput"]: ValueTypes["UserPaymentUpdateStripePaymentEntityRelationInput"];
	["StripePaymentWithoutPaymentUpdateInput"]: ValueTypes["StripePaymentWithoutPaymentUpdateInput"];
	["StripePaymentUpdateStatusChangesEntityRelationInput"]: ValueTypes["StripePaymentUpdateStatusChangesEntityRelationInput"];
	["StripePaymentUpdateStatusChangesRelationInput"]: ValueTypes["StripePaymentUpdateStatusChangesRelationInput"];
	["StripePaymentStatusChangeWithoutPaymentUpdateInput"]: ValueTypes["StripePaymentStatusChangeWithoutPaymentUpdateInput"];
	["StripePaymentUpsertStatusChangesRelationInput"]: ValueTypes["StripePaymentUpsertStatusChangesRelationInput"];
	["StripePaymentUpdateMetadataEntityRelationInput"]: ValueTypes["StripePaymentUpdateMetadataEntityRelationInput"];
	["UserPaymentUpsertStripePaymentRelationInput"]: ValueTypes["UserPaymentUpsertStripePaymentRelationInput"];
	["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"]: ValueTypes["UserPaymentUpdateRecurringPaymentItemEntityRelationInput"];
	["UserRecurringPaymentItemWithoutPaymentsUpdateInput"]: ValueTypes["UserRecurringPaymentItemWithoutPaymentsUpdateInput"];
	["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"]: ValueTypes["UserRecurringPaymentItemUpdateRecurringPaymentEntityRelationInput"];
	["UserRecurringPaymentWithoutItemsUpdateInput"]: ValueTypes["UserRecurringPaymentWithoutItemsUpdateInput"];
	["UserRecurringPaymentUpdateCurrencyEntityRelationInput"]: ValueTypes["UserRecurringPaymentUpdateCurrencyEntityRelationInput"];
	["UserRecurringPaymentUpsertCurrencyRelationInput"]: ValueTypes["UserRecurringPaymentUpsertCurrencyRelationInput"];
	["UserRecurringPaymentUpdateUserEntityRelationInput"]: ValueTypes["UserRecurringPaymentUpdateUserEntityRelationInput"];
	["UserWithoutRecurringPaymentsUpdateInput"]: ValueTypes["UserWithoutRecurringPaymentsUpdateInput"];
	["UserUpdateRegionEntityRelationInput"]: ValueTypes["UserUpdateRegionEntityRelationInput"];
	["UserUpsertRegionRelationInput"]: ValueTypes["UserUpsertRegionRelationInput"];
	["UserUpdateCurrencyEntityRelationInput"]: ValueTypes["UserUpdateCurrencyEntityRelationInput"];
	["UserUpsertCurrencyRelationInput"]: ValueTypes["UserUpsertCurrencyRelationInput"];
	["UserUpdateOnBehalfDonationsEntityRelationInput"]: ValueTypes["UserUpdateOnBehalfDonationsEntityRelationInput"];
	["UserUpdateOnBehalfDonationsRelationInput"]: ValueTypes["UserUpdateOnBehalfDonationsRelationInput"];
	["OnBehalfDonationWithoutOnBehalfOfUpdateInput"]: ValueTypes["OnBehalfDonationWithoutOnBehalfOfUpdateInput"];
	["OnBehalfDonationUpdatePaymentsEntityRelationInput"]: ValueTypes["OnBehalfDonationUpdatePaymentsEntityRelationInput"];
	["OnBehalfDonationUpdatePaymentsRelationInput"]: ValueTypes["OnBehalfDonationUpdatePaymentsRelationInput"];
	["UserPaymentWithoutOnBehalfDonationUpdateInput"]: ValueTypes["UserPaymentWithoutOnBehalfDonationUpdateInput"];
	["UserPaymentUpdateRegionEntityRelationInput"]: ValueTypes["UserPaymentUpdateRegionEntityRelationInput"];
	["UserPaymentUpsertRegionRelationInput"]: ValueTypes["UserPaymentUpsertRegionRelationInput"];
	["UserPaymentUpdateUserEntityRelationInput"]: ValueTypes["UserPaymentUpdateUserEntityRelationInput"];
	["UserWithoutPaymentsUpdateInput"]: ValueTypes["UserWithoutPaymentsUpdateInput"];
	["UserUpdateRecurringPaymentsEntityRelationInput"]: ValueTypes["UserUpdateRecurringPaymentsEntityRelationInput"];
	["UserUpdateRecurringPaymentsRelationInput"]: ValueTypes["UserUpdateRecurringPaymentsRelationInput"];
	["UserRecurringPaymentWithoutUserUpdateInput"]: ValueTypes["UserRecurringPaymentWithoutUserUpdateInput"];
	["UserRecurringPaymentUpdateItemsEntityRelationInput"]: ValueTypes["UserRecurringPaymentUpdateItemsEntityRelationInput"];
	["UserRecurringPaymentUpdateItemsRelationInput"]: ValueTypes["UserRecurringPaymentUpdateItemsRelationInput"];
	["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"]: ValueTypes["UserRecurringPaymentItemWithoutRecurringPaymentUpdateInput"];
	["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"]: ValueTypes["UserRecurringPaymentItemUpdatePaymentsEntityRelationInput"];
	["UserRecurringPaymentItemUpdatePaymentsRelationInput"]: ValueTypes["UserRecurringPaymentItemUpdatePaymentsRelationInput"];
	["UserPaymentWithoutRecurringPaymentItemUpdateInput"]: ValueTypes["UserPaymentWithoutRecurringPaymentItemUpdateInput"];
	["UserPaymentUpdateOnBehalfDonationEntityRelationInput"]: ValueTypes["UserPaymentUpdateOnBehalfDonationEntityRelationInput"];
	["OnBehalfDonationWithoutPaymentsUpdateInput"]: ValueTypes["OnBehalfDonationWithoutPaymentsUpdateInput"];
	["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"]: ValueTypes["OnBehalfDonationUpdateOnBehalfOfEntityRelationInput"];
	["UserWithoutOnBehalfDonationsUpdateInput"]: ValueTypes["UserWithoutOnBehalfDonationsUpdateInput"];
	["UserUpdateLocaleEntityRelationInput"]: ValueTypes["UserUpdateLocaleEntityRelationInput"];
	["LocaleUpdateInput"]: ValueTypes["LocaleUpdateInput"];
	["LocaleUpdateSentPaymentsEntityRelationInput"]: ValueTypes["LocaleUpdateSentPaymentsEntityRelationInput"];
	["LocaleUpdateSentPaymentsRelationInput"]: ValueTypes["LocaleUpdateSentPaymentsRelationInput"];
	["SentPaymentLocaleWithoutLocaleUpdateInput"]: ValueTypes["SentPaymentLocaleWithoutLocaleUpdateInput"];
	["SentPaymentLocaleUpdateRootEntityRelationInput"]: ValueTypes["SentPaymentLocaleUpdateRootEntityRelationInput"];
	["SentPaymentWithoutLocalesUpdateInput"]: ValueTypes["SentPaymentWithoutLocalesUpdateInput"];
	["SentPaymentUpdateAreaEntityRelationInput"]: ValueTypes["SentPaymentUpdateAreaEntityRelationInput"];
	["PostAreaWithoutSentPaymentsUpdateInput"]: ValueTypes["PostAreaWithoutSentPaymentsUpdateInput"];
	["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"]: ValueTypes["PostAreaUpdateAreaSentPaymentCurrencySumsEntityRelationInput"];
	["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"]: ValueTypes["PostAreaUpdateAreaSentPaymentSumEntityRelationInput"];
	["PostAreaUpdateAreaCurrencySumsEntityRelationInput"]: ValueTypes["PostAreaUpdateAreaCurrencySumsEntityRelationInput"];
	["PostAreaUpdateAreaSumEntityRelationInput"]: ValueTypes["PostAreaUpdateAreaSumEntityRelationInput"];
	["SentPaymentUpsertAreaRelationInput"]: ValueTypes["SentPaymentUpsertAreaRelationInput"];
	["SentPaymentLocaleUpsertRootRelationInput"]: ValueTypes["SentPaymentLocaleUpsertRootRelationInput"];
	["LocaleUpsertSentPaymentsRelationInput"]: ValueTypes["LocaleUpsertSentPaymentsRelationInput"];
	["UserUpsertLocaleRelationInput"]: ValueTypes["UserUpsertLocaleRelationInput"];
	["UserUpdateDevicesEntityRelationInput"]: ValueTypes["UserUpdateDevicesEntityRelationInput"];
	["UserUpdateDevicesRelationInput"]: ValueTypes["UserUpdateDevicesRelationInput"];
	["DeviceWithoutUserUpdateInput"]: ValueTypes["DeviceWithoutUserUpdateInput"];
	["UserUpsertDevicesRelationInput"]: ValueTypes["UserUpsertDevicesRelationInput"];
	["UserUpdateProcessedNotificationsEntityRelationInput"]: ValueTypes["UserUpdateProcessedNotificationsEntityRelationInput"];
	["UserUpdateProcessedNotificationsRelationInput"]: ValueTypes["UserUpdateProcessedNotificationsRelationInput"];
	["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"]: ValueTypes["ProcessedNotificationSourceWithoutDonationReminderUserUpdateInput"];
	["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"]: ValueTypes["ProcessedNotificationSourceUpdateScheduledNotificationEntityRelationInput"];
	["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"]: ValueTypes["ScheduledNotificationWithoutProcessedNotificationsUpdateInput"];
	["ScheduledNotificationUpdateLocalesEntityRelationInput"]: ValueTypes["ScheduledNotificationUpdateLocalesEntityRelationInput"];
	["ScheduledNotificationUpdateLocalesRelationInput"]: ValueTypes["ScheduledNotificationUpdateLocalesRelationInput"];
	["ScheduledNotificationLocaleWithoutRootUpdateInput"]: ValueTypes["ScheduledNotificationLocaleWithoutRootUpdateInput"];
	["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["ScheduledNotificationLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutScheduledNotificationsUpdateInput"]: ValueTypes["LocaleWithoutScheduledNotificationsUpdateInput"];
	["ScheduledNotificationLocaleUpsertLocaleRelationInput"]: ValueTypes["ScheduledNotificationLocaleUpsertLocaleRelationInput"];
	["ScheduledNotificationUpsertLocalesRelationInput"]: ValueTypes["ScheduledNotificationUpsertLocalesRelationInput"];
	["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"]: ValueTypes["ProcessedNotificationSourceUpsertScheduledNotificationRelationInput"];
	["UserUpsertProcessedNotificationsRelationInput"]: ValueTypes["UserUpsertProcessedNotificationsRelationInput"];
	["UserUpdateAreaStatsEntityRelationInput"]: ValueTypes["UserUpdateAreaStatsEntityRelationInput"];
	["UserUpdateOrganizationStatsEntityRelationInput"]: ValueTypes["UserUpdateOrganizationStatsEntityRelationInput"];
	["UserUpdatePostStatsEntityRelationInput"]: ValueTypes["UserUpdatePostStatsEntityRelationInput"];
	["UserUpdateCurrencyStatsEntityRelationInput"]: ValueTypes["UserUpdateCurrencyStatsEntityRelationInput"];
	["OnBehalfDonationUpsertOnBehalfOfRelationInput"]: ValueTypes["OnBehalfDonationUpsertOnBehalfOfRelationInput"];
	["OnBehalfDonationUpdateMetaEntityRelationInput"]: ValueTypes["OnBehalfDonationUpdateMetaEntityRelationInput"];
	["UserPaymentUpsertOnBehalfDonationRelationInput"]: ValueTypes["UserPaymentUpsertOnBehalfDonationRelationInput"];
	["UserPaymentUpdateTriesCollectionEntityRelationInput"]: ValueTypes["UserPaymentUpdateTriesCollectionEntityRelationInput"];
	["UserPaymentTriesCollectionWithoutPaymentUpdateInput"]: ValueTypes["UserPaymentTriesCollectionWithoutPaymentUpdateInput"];
	["UserPaymentTriesCollectionUpdateUserEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpdateUserEntityRelationInput"];
	["UserUpdateInput"]: ValueTypes["UserUpdateInput"];
	["UserPaymentTriesCollectionUpsertUserRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpsertUserRelationInput"];
	["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpdateCurrencyEntityRelationInput"];
	["UserPaymentTriesCollectionUpsertCurrencyRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpsertCurrencyRelationInput"];
	["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpdateOnBehalfDonationEntityRelationInput"];
	["OnBehalfDonationUpdateInput"]: ValueTypes["OnBehalfDonationUpdateInput"];
	["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpsertOnBehalfDonationRelationInput"];
	["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpdateRecurringEntityRelationInput"];
	["UserRecurringPaymentUpdateInput"]: ValueTypes["UserRecurringPaymentUpdateInput"];
	["UserRecurringPaymentUpdateMetaEntityRelationInput"]: ValueTypes["UserRecurringPaymentUpdateMetaEntityRelationInput"];
	["UserPaymentTriesCollectionUpsertRecurringRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpsertRecurringRelationInput"];
	["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpdateMetadataLocalesEntityRelationInput"];
	["UserPaymentUpsertTriesCollectionRelationInput"]: ValueTypes["UserPaymentUpsertTriesCollectionRelationInput"];
	["UserPaymentUpdateMetadataEntityRelationInput"]: ValueTypes["UserPaymentUpdateMetadataEntityRelationInput"];
	["UserRecurringPaymentItemUpsertPaymentsRelationInput"]: ValueTypes["UserRecurringPaymentItemUpsertPaymentsRelationInput"];
	["UserRecurringPaymentItemUpdateMetaEntityRelationInput"]: ValueTypes["UserRecurringPaymentItemUpdateMetaEntityRelationInput"];
	["UserRecurringPaymentUpsertItemsRelationInput"]: ValueTypes["UserRecurringPaymentUpsertItemsRelationInput"];
	["UserUpsertRecurringPaymentsRelationInput"]: ValueTypes["UserUpsertRecurringPaymentsRelationInput"];
	["UserPaymentUpsertUserRelationInput"]: ValueTypes["UserPaymentUpsertUserRelationInput"];
	["OnBehalfDonationUpsertPaymentsRelationInput"]: ValueTypes["OnBehalfDonationUpsertPaymentsRelationInput"];
	["UserUpsertOnBehalfDonationsRelationInput"]: ValueTypes["UserUpsertOnBehalfDonationsRelationInput"];
	["UserRecurringPaymentUpsertUserRelationInput"]: ValueTypes["UserRecurringPaymentUpsertUserRelationInput"];
	["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"]: ValueTypes["UserRecurringPaymentItemUpsertRecurringPaymentRelationInput"];
	["UserPaymentUpsertRecurringPaymentItemRelationInput"]: ValueTypes["UserPaymentUpsertRecurringPaymentItemRelationInput"];
	["UserUpsertPaymentsRelationInput"]: ValueTypes["UserUpsertPaymentsRelationInput"];
	["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"]: ValueTypes["ProcessedNotificationSourceUpsertDonationReminderUserRelationInput"];
	["ScheduledNotificationUpsertProcessedNotificationsRelationInput"]: ValueTypes["ScheduledNotificationUpsertProcessedNotificationsRelationInput"];
	["ScheduledNotificationLocaleUpsertRootRelationInput"]: ValueTypes["ScheduledNotificationLocaleUpsertRootRelationInput"];
	["LocaleUpsertScheduledNotificationsRelationInput"]: ValueTypes["LocaleUpsertScheduledNotificationsRelationInput"];
	["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpsertLocaleRelationInput"];
	["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpdateContentEntityRelationInput"];
	["ReceivedGiftsPageLocaleUpsertContentRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpsertContentRelationInput"];
	["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpdateSeoEntityRelationInput"];
	["ReceivedGiftsPageLocaleUpsertSeoRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpsertSeoRelationInput"];
	["LinkableUpsertReceivedGiftsPageRelationInput"]: ValueTypes["LinkableUpsertReceivedGiftsPageRelationInput"];
	["ReportPageLocaleUpsertLinkRelationInput"]: ValueTypes["ReportPageLocaleUpsertLinkRelationInput"];
	["ReportPageLocaleUpdateContentEntityRelationInput"]: ValueTypes["ReportPageLocaleUpdateContentEntityRelationInput"];
	["ReportPageLocaleUpsertContentRelationInput"]: ValueTypes["ReportPageLocaleUpsertContentRelationInput"];
	["ReportPageLocaleUpdateSeoEntityRelationInput"]: ValueTypes["ReportPageLocaleUpdateSeoEntityRelationInput"];
	["ReportPageLocaleUpsertSeoRelationInput"]: ValueTypes["ReportPageLocaleUpsertSeoRelationInput"];
	["ReportPageLocaleUpdatePostsEntityRelationInput"]: ValueTypes["ReportPageLocaleUpdatePostsEntityRelationInput"];
	["ReportPageLocaleUpdatePostsRelationInput"]: ValueTypes["ReportPageLocaleUpdatePostsRelationInput"];
	["PostWithoutReportPageUpdateInput"]: ValueTypes["PostWithoutReportPageUpdateInput"];
	["PostUpdateMetaEntityRelationInput"]: ValueTypes["PostUpdateMetaEntityRelationInput"];
	["PostUpdateHeroCarouselEntityRelationInput"]: ValueTypes["PostUpdateHeroCarouselEntityRelationInput"];
	["PostUpdateHeroCarouselRelationInput"]: ValueTypes["PostUpdateHeroCarouselRelationInput"];
	["HeroCarouselWithoutPostsUpdateInput"]: ValueTypes["HeroCarouselWithoutPostsUpdateInput"];
	["HeroCarouselUpdateItemsEntityRelationInput"]: ValueTypes["HeroCarouselUpdateItemsEntityRelationInput"];
	["HeroCarouselUpdateItemsRelationInput"]: ValueTypes["HeroCarouselUpdateItemsRelationInput"];
	["HeroCarouselItemWithoutListUpdateInput"]: ValueTypes["HeroCarouselItemWithoutListUpdateInput"];
	["HeroCarouselItemUpdateItemEntityRelationInput"]: ValueTypes["HeroCarouselItemUpdateItemEntityRelationInput"];
	["HeroCarouselItemUpsertItemRelationInput"]: ValueTypes["HeroCarouselItemUpsertItemRelationInput"];
	["HeroCarouselUpsertItemsRelationInput"]: ValueTypes["HeroCarouselUpsertItemsRelationInput"];
	["PostUpsertHeroCarouselRelationInput"]: ValueTypes["PostUpsertHeroCarouselRelationInput"];
	["PostUpdateContentEntityRelationInput"]: ValueTypes["PostUpdateContentEntityRelationInput"];
	["PostUpdateContentRelationInput"]: ValueTypes["PostUpdateContentRelationInput"];
	["ContentReferenceWithoutPostsUpdateInput"]: ValueTypes["ContentReferenceWithoutPostsUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: ValueTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: ValueTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: ValueTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: ValueTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceUpsertBlockRelationInput"]: ValueTypes["ContentReferenceUpsertBlockRelationInput"];
	["ContentReferenceUpdateValueListEntityRelationInput"]: ValueTypes["ContentReferenceUpdateValueListEntityRelationInput"];
	["ValueListUpdateInput"]: ValueTypes["ValueListUpdateInput"];
	["ValueListUpdateItemsEntityRelationInput"]: ValueTypes["ValueListUpdateItemsEntityRelationInput"];
	["ValueListUpdateItemsRelationInput"]: ValueTypes["ValueListUpdateItemsRelationInput"];
	["ValueItemWithoutListUpdateInput"]: ValueTypes["ValueItemWithoutListUpdateInput"];
	["ValueItemUpdateItemEntityRelationInput"]: ValueTypes["ValueItemUpdateItemEntityRelationInput"];
	["ValueUpdateInput"]: ValueTypes["ValueUpdateInput"];
	["ValueUpdateTextContentEntityRelationInput"]: ValueTypes["ValueUpdateTextContentEntityRelationInput"];
	["ValueUpsertTextContentRelationInput"]: ValueTypes["ValueUpsertTextContentRelationInput"];
	["ValueItemUpsertItemRelationInput"]: ValueTypes["ValueItemUpsertItemRelationInput"];
	["ValueListUpsertItemsRelationInput"]: ValueTypes["ValueListUpsertItemsRelationInput"];
	["ContentReferenceUpsertValueListRelationInput"]: ValueTypes["ContentReferenceUpsertValueListRelationInput"];
	["ContentReferenceUpdateImageLinkListEntityRelationInput"]: ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"];
	["ContentReferenceUpsertImageLinkListRelationInput"]: ValueTypes["ContentReferenceUpsertImageLinkListRelationInput"];
	["ContentReferenceUpdateAreaListEntityRelationInput"]: ValueTypes["ContentReferenceUpdateAreaListEntityRelationInput"];
	["PostAreaListUpdateInput"]: ValueTypes["PostAreaListUpdateInput"];
	["PostAreaListUpdateItemsEntityRelationInput"]: ValueTypes["PostAreaListUpdateItemsEntityRelationInput"];
	["PostAreaListUpdateItemsRelationInput"]: ValueTypes["PostAreaListUpdateItemsRelationInput"];
	["PostAreaListItemWithoutListUpdateInput"]: ValueTypes["PostAreaListItemWithoutListUpdateInput"];
	["PostAreaListItemUpdateItemEntityRelationInput"]: ValueTypes["PostAreaListItemUpdateItemEntityRelationInput"];
	["PostAreaListItemUpsertItemRelationInput"]: ValueTypes["PostAreaListItemUpsertItemRelationInput"];
	["PostAreaListUpsertItemsRelationInput"]: ValueTypes["PostAreaListUpsertItemsRelationInput"];
	["ContentReferenceUpsertAreaListRelationInput"]: ValueTypes["ContentReferenceUpsertAreaListRelationInput"];
	["ContentReferenceUpdateAccordionEntityRelationInput"]: ValueTypes["ContentReferenceUpdateAccordionEntityRelationInput"];
	["AccordionUpdateInput"]: ValueTypes["AccordionUpdateInput"];
	["AccordionUpdateItemsEntityRelationInput"]: ValueTypes["AccordionUpdateItemsEntityRelationInput"];
	["AccordionUpdateItemsRelationInput"]: ValueTypes["AccordionUpdateItemsRelationInput"];
	["AccordionItemWithoutListUpdateInput"]: ValueTypes["AccordionItemWithoutListUpdateInput"];
	["AccordionItemUpdateDescriptionContentEntityRelationInput"]: ValueTypes["AccordionItemUpdateDescriptionContentEntityRelationInput"];
	["AccordionItemUpsertDescriptionContentRelationInput"]: ValueTypes["AccordionItemUpsertDescriptionContentRelationInput"];
	["AccordionUpsertItemsRelationInput"]: ValueTypes["AccordionUpsertItemsRelationInput"];
	["ContentReferenceUpsertAccordionRelationInput"]: ValueTypes["ContentReferenceUpsertAccordionRelationInput"];
	["ContentReferenceUpdateMediaEntityRelationInput"]: ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"];
	["MediumListUpdateInput"]: ValueTypes["MediumListUpdateInput"];
	["MediumListUpdateItemsEntityRelationInput"]: ValueTypes["MediumListUpdateItemsEntityRelationInput"];
	["MediumListUpdateItemsRelationInput"]: ValueTypes["MediumListUpdateItemsRelationInput"];
	["MediumItemWithoutListUpdateInput"]: ValueTypes["MediumItemWithoutListUpdateInput"];
	["MediumItemUpdateMediumEntityRelationInput"]: ValueTypes["MediumItemUpdateMediumEntityRelationInput"];
	["MediumUpdateInput"]: ValueTypes["MediumUpdateInput"];
	["MediumUpdateImageEntityRelationInput"]: ValueTypes["MediumUpdateImageEntityRelationInput"];
	["MediumUpsertImageRelationInput"]: ValueTypes["MediumUpsertImageRelationInput"];
	["MediumUpdateVideoEntityRelationInput"]: ValueTypes["MediumUpdateVideoEntityRelationInput"];
	["MediumUpsertVideoRelationInput"]: ValueTypes["MediumUpsertVideoRelationInput"];
	["MediumItemUpsertMediumRelationInput"]: ValueTypes["MediumItemUpsertMediumRelationInput"];
	["MediumListUpsertItemsRelationInput"]: ValueTypes["MediumListUpsertItemsRelationInput"];
	["ContentReferenceUpsertMediaRelationInput"]: ValueTypes["ContentReferenceUpsertMediaRelationInput"];
	["ContentReferenceUpdateMemberListEntityRelationInput"]: ValueTypes["ContentReferenceUpdateMemberListEntityRelationInput"];
	["MemberListUpdateInput"]: ValueTypes["MemberListUpdateInput"];
	["MemberListUpdateItemsEntityRelationInput"]: ValueTypes["MemberListUpdateItemsEntityRelationInput"];
	["MemberListUpdateItemsRelationInput"]: ValueTypes["MemberListUpdateItemsRelationInput"];
	["MemberListItemWithoutListUpdateInput"]: ValueTypes["MemberListItemWithoutListUpdateInput"];
	["MemberListItemUpdateImageEntityRelationInput"]: ValueTypes["MemberListItemUpdateImageEntityRelationInput"];
	["MemberListItemUpsertImageRelationInput"]: ValueTypes["MemberListItemUpsertImageRelationInput"];
	["MemberListItemUpdateDescriptionContentEntityRelationInput"]: ValueTypes["MemberListItemUpdateDescriptionContentEntityRelationInput"];
	["MemberListItemUpsertDescriptionContentRelationInput"]: ValueTypes["MemberListItemUpsertDescriptionContentRelationInput"];
	["MemberListUpsertItemsRelationInput"]: ValueTypes["MemberListUpsertItemsRelationInput"];
	["ContentReferenceUpsertMemberListRelationInput"]: ValueTypes["ContentReferenceUpsertMemberListRelationInput"];
	["ContentReferenceUpdateFormEntityRelationInput"]: ValueTypes["ContentReferenceUpdateFormEntityRelationInput"];
	["FormUpdateInput"]: ValueTypes["FormUpdateInput"];
	["FormUpdateTaxEntityRelationInput"]: ValueTypes["FormUpdateTaxEntityRelationInput"];
	["FilledTaxFormUpdateInput"]: ValueTypes["FilledTaxFormUpdateInput"];
	["FilledTaxFormUpdateCountryEntityRelationInput"]: ValueTypes["FilledTaxFormUpdateCountryEntityRelationInput"];
	["FilledTaxFormUpsertCountryRelationInput"]: ValueTypes["FilledTaxFormUpsertCountryRelationInput"];
	["FormUpsertTaxRelationInput"]: ValueTypes["FormUpsertTaxRelationInput"];
	["ContentReferenceUpsertFormRelationInput"]: ValueTypes["ContentReferenceUpsertFormRelationInput"];
	["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"]: ValueTypes["ContentReferenceUpdateContentWithoutBlocksEntityRelationInput"];
	["ContentReferenceUpsertContentWithoutBlocksRelationInput"]: ValueTypes["ContentReferenceUpsertContentWithoutBlocksRelationInput"];
	["ContentReferenceUpdateHeroCarouselEntityRelationInput"]: ValueTypes["ContentReferenceUpdateHeroCarouselEntityRelationInput"];
	["HeroCarouselUpdateInput"]: ValueTypes["HeroCarouselUpdateInput"];
	["HeroCarouselUpdatePostsEntityRelationInput"]: ValueTypes["HeroCarouselUpdatePostsEntityRelationInput"];
	["HeroCarouselUpdatePostsRelationInput"]: ValueTypes["HeroCarouselUpdatePostsRelationInput"];
	["PostWithoutHeroCarouselUpdateInput"]: ValueTypes["PostWithoutHeroCarouselUpdateInput"];
	["PostUpdateReportPageEntityRelationInput"]: ValueTypes["PostUpdateReportPageEntityRelationInput"];
	["PostUpdateReportPageRelationInput"]: ValueTypes["PostUpdateReportPageRelationInput"];
	["ReportPageLocaleWithoutPostsUpdateInput"]: ValueTypes["ReportPageLocaleWithoutPostsUpdateInput"];
	["PostUpsertReportPageRelationInput"]: ValueTypes["PostUpsertReportPageRelationInput"];
	["PostUpdateFundraiseCurrencyEntityRelationInput"]: ValueTypes["PostUpdateFundraiseCurrencyEntityRelationInput"];
	["PostUpsertFundraiseCurrencyRelationInput"]: ValueTypes["PostUpsertFundraiseCurrencyRelationInput"];
	["PostUpdateFundraiseCurrencySumsEntityRelationInput"]: ValueTypes["PostUpdateFundraiseCurrencySumsEntityRelationInput"];
	["PostUpdateFundraiseSumEntityRelationInput"]: ValueTypes["PostUpdateFundraiseSumEntityRelationInput"];
	["PostUpdateFundraisingProgressEntityRelationInput"]: ValueTypes["PostUpdateFundraisingProgressEntityRelationInput"];
	["HeroCarouselUpsertPostsRelationInput"]: ValueTypes["HeroCarouselUpsertPostsRelationInput"];
	["ContentReferenceUpsertHeroCarouselRelationInput"]: ValueTypes["ContentReferenceUpsertHeroCarouselRelationInput"];
	["ContentReferenceUpdateOrganizationListEntityRelationInput"]: ValueTypes["ContentReferenceUpdateOrganizationListEntityRelationInput"];
	["ContentReferenceUpsertOrganizationListRelationInput"]: ValueTypes["ContentReferenceUpsertOrganizationListRelationInput"];
	["ContentReferenceUpdateTextImageListEntityRelationInput"]: ValueTypes["ContentReferenceUpdateTextImageListEntityRelationInput"];
	["TextImageListUpdateInput"]: ValueTypes["TextImageListUpdateInput"];
	["TextImageListUpdateItemsEntityRelationInput"]: ValueTypes["TextImageListUpdateItemsEntityRelationInput"];
	["TextImageListUpdateItemsRelationInput"]: ValueTypes["TextImageListUpdateItemsRelationInput"];
	["TextImageListItemWithoutListUpdateInput"]: ValueTypes["TextImageListItemWithoutListUpdateInput"];
	["TextImageListItemUpdateImageEntityRelationInput"]: ValueTypes["TextImageListItemUpdateImageEntityRelationInput"];
	["TextImageListItemUpsertImageRelationInput"]: ValueTypes["TextImageListItemUpsertImageRelationInput"];
	["TextImageListItemUpdateLinkEntityRelationInput"]: ValueTypes["TextImageListItemUpdateLinkEntityRelationInput"];
	["TextImageListItemUpsertLinkRelationInput"]: ValueTypes["TextImageListItemUpsertLinkRelationInput"];
	["TextImageListUpsertItemsRelationInput"]: ValueTypes["TextImageListUpsertItemsRelationInput"];
	["ContentReferenceUpsertTextImageListRelationInput"]: ValueTypes["ContentReferenceUpsertTextImageListRelationInput"];
	["PostUpsertContentRelationInput"]: ValueTypes["PostUpsertContentRelationInput"];
	["ReportPageLocaleUpsertPostsRelationInput"]: ValueTypes["ReportPageLocaleUpsertPostsRelationInput"];
	["LocaleUpsertReportPagesRelationInput"]: ValueTypes["LocaleUpsertReportPagesRelationInput"];
	["GivenGiftsPageLocaleUpsertLocaleRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertGivenGiftsPageRelationInput"]: ValueTypes["LinkableUpsertGivenGiftsPageRelationInput"];
	["ReceivedGiftsPageLocaleUpsertLinkRelationInput"]: ValueTypes["ReceivedGiftsPageLocaleUpsertLinkRelationInput"];
	["LocaleUpsertReceivedGiftsPagesRelationInput"]: ValueTypes["LocaleUpsertReceivedGiftsPagesRelationInput"];
	["ReportPageLocaleUpsertLocaleRelationInput"]: ValueTypes["ReportPageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertReportPageRelationInput"]: ValueTypes["LinkableUpsertReportPageRelationInput"];
	["GivenGiftsPageLocaleUpsertLinkRelationInput"]: ValueTypes["GivenGiftsPageLocaleUpsertLinkRelationInput"];
	["LocaleUpsertGivenGiftsPagesRelationInput"]: ValueTypes["LocaleUpsertGivenGiftsPagesRelationInput"];
	["PostOrganizationLocaleUpsertLocaleRelationInput"]: ValueTypes["PostOrganizationLocaleUpsertLocaleRelationInput"];
	["PostOrganizationLocaleUpdateDomainEntityRelationInput"]: ValueTypes["PostOrganizationLocaleUpdateDomainEntityRelationInput"];
	["PostOrganizationLocaleUpsertDomainRelationInput"]: ValueTypes["PostOrganizationLocaleUpsertDomainRelationInput"];
	["PostOrganizationLocaleUpdateSeoEntityRelationInput"]: ValueTypes["PostOrganizationLocaleUpdateSeoEntityRelationInput"];
	["PostOrganizationLocaleUpsertSeoRelationInput"]: ValueTypes["PostOrganizationLocaleUpsertSeoRelationInput"];
	["PostOrganizationLocaleUpdateContentEntityRelationInput"]: ValueTypes["PostOrganizationLocaleUpdateContentEntityRelationInput"];
	["PostOrganizationLocaleUpsertContentRelationInput"]: ValueTypes["PostOrganizationLocaleUpsertContentRelationInput"];
	["LinkableUpsertPostOrganizationRelationInput"]: ValueTypes["LinkableUpsertPostOrganizationRelationInput"];
	["PostLocaleUpsertLinkRelationInput"]: ValueTypes["PostLocaleUpsertLinkRelationInput"];
	["PostUpsertLocalesRelationInput"]: ValueTypes["PostUpsertLocalesRelationInput"];
	["TileItemUpsertPostRelationInput"]: ValueTypes["TileItemUpsertPostRelationInput"];
	["TileItemUpdateAreaEntityRelationInput"]: ValueTypes["TileItemUpdateAreaEntityRelationInput"];
	["TileItemUpsertAreaRelationInput"]: ValueTypes["TileItemUpsertAreaRelationInput"];
	["TileItemUpdateImageEntityRelationInput"]: ValueTypes["TileItemUpdateImageEntityRelationInput"];
	["TileItemUpsertImageRelationInput"]: ValueTypes["TileItemUpsertImageRelationInput"];
	["TileItemUpdateLinkEntityRelationInput"]: ValueTypes["TileItemUpdateLinkEntityRelationInput"];
	["TileItemUpsertLinkRelationInput"]: ValueTypes["TileItemUpsertLinkRelationInput"];
	["TileItemUpdateOrganizationEntityRelationInput"]: ValueTypes["TileItemUpdateOrganizationEntityRelationInput"];
	["TileItemUpsertOrganizationRelationInput"]: ValueTypes["TileItemUpsertOrganizationRelationInput"];
	["TileListUpsertItemsRelationInput"]: ValueTypes["TileListUpsertItemsRelationInput"];
	["TileListUpdateAreaTypeEntityRelationInput"]: ValueTypes["TileListUpdateAreaTypeEntityRelationInput"];
	["TileListUpsertAreaTypeRelationInput"]: ValueTypes["TileListUpsertAreaTypeRelationInput"];
	["FeedPageLocaleUpsertHeroTilesRelationInput"]: ValueTypes["FeedPageLocaleUpsertHeroTilesRelationInput"];
	["FeedPageLocaleUpdateSectionListEntityRelationInput"]: ValueTypes["FeedPageLocaleUpdateSectionListEntityRelationInput"];
	["FeedPageLocaleUpdateSectionListRelationInput"]: ValueTypes["FeedPageLocaleUpdateSectionListRelationInput"];
	["FeedPageSectionWithoutFeedPageLocaleUpdateInput"]: ValueTypes["FeedPageSectionWithoutFeedPageLocaleUpdateInput"];
	["FeedPageSectionUpdateTileStripeListEntityRelationInput"]: ValueTypes["FeedPageSectionUpdateTileStripeListEntityRelationInput"];
	["FeedPageSectionUpdateTileStripeListRelationInput"]: ValueTypes["FeedPageSectionUpdateTileStripeListRelationInput"];
	["FeedPageTileStripeWithoutSectionUpdateInput"]: ValueTypes["FeedPageTileStripeWithoutSectionUpdateInput"];
	["FeedPageTileStripeUpdateTileListEntityRelationInput"]: ValueTypes["FeedPageTileStripeUpdateTileListEntityRelationInput"];
	["FeedPageTileStripeUpsertTileListRelationInput"]: ValueTypes["FeedPageTileStripeUpsertTileListRelationInput"];
	["FeedPageSectionUpsertTileStripeListRelationInput"]: ValueTypes["FeedPageSectionUpsertTileStripeListRelationInput"];
	["FeedPageLocaleUpsertSectionListRelationInput"]: ValueTypes["FeedPageLocaleUpsertSectionListRelationInput"];
	["FeedPageLocaleUpdateCardListEntityRelationInput"]: ValueTypes["FeedPageLocaleUpdateCardListEntityRelationInput"];
	["CardListUpdateInput"]: ValueTypes["CardListUpdateInput"];
	["CardListUpdateItemsEntityRelationInput"]: ValueTypes["CardListUpdateItemsEntityRelationInput"];
	["CardListUpdateItemsRelationInput"]: ValueTypes["CardListUpdateItemsRelationInput"];
	["CardItemWithoutListUpdateInput"]: ValueTypes["CardItemWithoutListUpdateInput"];
	["CardItemUpdateLinkEntityRelationInput"]: ValueTypes["CardItemUpdateLinkEntityRelationInput"];
	["CardItemUpsertLinkRelationInput"]: ValueTypes["CardItemUpsertLinkRelationInput"];
	["CardListUpsertItemsRelationInput"]: ValueTypes["CardListUpsertItemsRelationInput"];
	["FeedPageLocaleUpsertCardListRelationInput"]: ValueTypes["FeedPageLocaleUpsertCardListRelationInput"];
	["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"]: ValueTypes["FeedPageLocaleUpdateStoryGuideListEntityRelationInput"];
	["FeedPageLocaleUpsertStoryGuideListRelationInput"]: ValueTypes["FeedPageLocaleUpsertStoryGuideListRelationInput"];
	["LocaleUpsertFeedPagesRelationInput"]: ValueTypes["LocaleUpsertFeedPagesRelationInput"];
	["PostRevisionLocaleUpsertLocaleRelationInput"]: ValueTypes["PostRevisionLocaleUpsertLocaleRelationInput"];
	["PostRevisionLocaleUpdateContentEntityRelationInput"]: ValueTypes["PostRevisionLocaleUpdateContentEntityRelationInput"];
	["PostRevisionLocaleUpsertContentRelationInput"]: ValueTypes["PostRevisionLocaleUpsertContentRelationInput"];
	["PostRevisionLocaleUpdateSeoEntityRelationInput"]: ValueTypes["PostRevisionLocaleUpdateSeoEntityRelationInput"];
	["PostRevisionLocaleUpsertSeoRelationInput"]: ValueTypes["PostRevisionLocaleUpsertSeoRelationInput"];
	["PostRevisionLocaleUpdateLeadContentEntityRelationInput"]: ValueTypes["PostRevisionLocaleUpdateLeadContentEntityRelationInput"];
	["PostRevisionLocaleUpsertLeadContentRelationInput"]: ValueTypes["PostRevisionLocaleUpsertLeadContentRelationInput"];
	["PostRevisionUpsertLocalesRelationInput"]: ValueTypes["PostRevisionUpsertLocalesRelationInput"];
	["PostUpsertActiveRevisionRelationInput"]: ValueTypes["PostUpsertActiveRevisionRelationInput"];
	["PostRevisionUpsertPostRelationInput"]: ValueTypes["PostRevisionUpsertPostRelationInput"];
	["PostRevisionLocaleUpsertRootRelationInput"]: ValueTypes["PostRevisionLocaleUpsertRootRelationInput"];
	["LocaleUpsertPostRevisionsRelationInput"]: ValueTypes["LocaleUpsertPostRevisionsRelationInput"];
	["SentPaymentLocaleUpsertLocaleRelationInput"]: ValueTypes["SentPaymentLocaleUpsertLocaleRelationInput"];
	["SentPaymentUpsertLocalesRelationInput"]: ValueTypes["SentPaymentUpsertLocalesRelationInput"];
	["PostAreaUpsertSentPaymentsRelationInput"]: ValueTypes["PostAreaUpsertSentPaymentsRelationInput"];
	["PostOrganizationUpsertAreaRelationInput"]: ValueTypes["PostOrganizationUpsertAreaRelationInput"];
	["PostOrganizationUpdateSentPaymentsEntityRelationInput"]: ValueTypes["PostOrganizationUpdateSentPaymentsEntityRelationInput"];
	["PostOrganizationUpdateSentPaymentsRelationInput"]: ValueTypes["PostOrganizationUpdateSentPaymentsRelationInput"];
	["SentPaymentWithoutOrganizationUpdateInput"]: ValueTypes["SentPaymentWithoutOrganizationUpdateInput"];
	["PostOrganizationUpsertSentPaymentsRelationInput"]: ValueTypes["PostOrganizationUpsertSentPaymentsRelationInput"];
	["PostOrganizationLocaleUpsertRootRelationInput"]: ValueTypes["PostOrganizationLocaleUpsertRootRelationInput"];
	["LocaleUpsertPostOrganizationsRelationInput"]: ValueTypes["LocaleUpsertPostOrganizationsRelationInput"];
	["PostAreaLocaleUpsertLocaleRelationInput"]: ValueTypes["PostAreaLocaleUpsertLocaleRelationInput"];
	["PostAreaLocaleUpdateSeoEntityRelationInput"]: ValueTypes["PostAreaLocaleUpdateSeoEntityRelationInput"];
	["PostAreaLocaleUpsertSeoRelationInput"]: ValueTypes["PostAreaLocaleUpsertSeoRelationInput"];
	["PostAreaLocaleUpdateBannerEntityRelationInput"]: ValueTypes["PostAreaLocaleUpdateBannerEntityRelationInput"];
	["AppBannerUpdateInput"]: ValueTypes["AppBannerUpdateInput"];
	["AppBannerUpdateImageSmallEntityRelationInput"]: ValueTypes["AppBannerUpdateImageSmallEntityRelationInput"];
	["AppBannerUpsertImageSmallRelationInput"]: ValueTypes["AppBannerUpsertImageSmallRelationInput"];
	["AppBannerUpdateImageBigEntityRelationInput"]: ValueTypes["AppBannerUpdateImageBigEntityRelationInput"];
	["AppBannerUpsertImageBigRelationInput"]: ValueTypes["AppBannerUpsertImageBigRelationInput"];
	["AppBannerUpdateTextContentEntityRelationInput"]: ValueTypes["AppBannerUpdateTextContentEntityRelationInput"];
	["AppBannerUpsertTextContentRelationInput"]: ValueTypes["AppBannerUpsertTextContentRelationInput"];
	["PostAreaLocaleUpsertBannerRelationInput"]: ValueTypes["PostAreaLocaleUpsertBannerRelationInput"];
	["PostAreaLocaleUpdateContentEntityRelationInput"]: ValueTypes["PostAreaLocaleUpdateContentEntityRelationInput"];
	["PostAreaLocaleUpsertContentRelationInput"]: ValueTypes["PostAreaLocaleUpsertContentRelationInput"];
	["LinkableUpsertPostAreaRelationInput"]: ValueTypes["LinkableUpsertPostAreaRelationInput"];
	["PostOrganizationLocaleUpsertLinkRelationInput"]: ValueTypes["PostOrganizationLocaleUpsertLinkRelationInput"];
	["PostOrganizationUpsertLocalesRelationInput"]: ValueTypes["PostOrganizationUpsertLocalesRelationInput"];
	["PostUpsertOrganizationRelationInput"]: ValueTypes["PostUpsertOrganizationRelationInput"];
	["PostAreaUpsertPostsRelationInput"]: ValueTypes["PostAreaUpsertPostsRelationInput"];
	["PostAreaLocaleUpsertRootRelationInput"]: ValueTypes["PostAreaLocaleUpsertRootRelationInput"];
	["LocaleUpsertPostAreasRelationInput"]: ValueTypes["LocaleUpsertPostAreasRelationInput"];
	["PostLocaleUpsertLocaleRelationInput"]: ValueTypes["PostLocaleUpsertLocaleRelationInput"];
	["PostLocaleUpdateRootEntityRelationInput"]: ValueTypes["PostLocaleUpdateRootEntityRelationInput"];
	["PostWithoutLocalesUpdateInput"]: ValueTypes["PostWithoutLocalesUpdateInput"];
	["PostLocaleUpsertRootRelationInput"]: ValueTypes["PostLocaleUpsertRootRelationInput"];
	["LinkableUpsertPostRelationInput"]: ValueTypes["LinkableUpsertPostRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: ValueTypes["LinkUpsertInternalLinkRelationInput"];
	["ContentReferenceUpsertLinkRelationInput"]: ValueTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdatePostsEntityRelationInput"]: ValueTypes["ContentReferenceUpdatePostsEntityRelationInput"];
	["ContentReferenceUpdatePostsRelationInput"]: ValueTypes["ContentReferenceUpdatePostsRelationInput"];
	["PostWithoutContentUpdateInput"]: ValueTypes["PostWithoutContentUpdateInput"];
	["ContentReferenceUpsertPostsRelationInput"]: ValueTypes["ContentReferenceUpsertPostsRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: ValueTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: ValueTypes["ContentUpsertBlocksRelationInput"];
	["PostLocaleUpsertContentRelationInput"]: ValueTypes["PostLocaleUpsertContentRelationInput"];
	["LocaleUpsertPostsRelationInput"]: ValueTypes["LocaleUpsertPostsRelationInput"];
	["GenericPageLocaleUpsertLocaleRelationInput"]: ValueTypes["GenericPageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertGenericPageRelationInput"]: ValueTypes["LinkableUpsertGenericPageRelationInput"];
	["PostAreaLocaleUpsertLinkRelationInput"]: ValueTypes["PostAreaLocaleUpsertLinkRelationInput"];
	["PostAreaUpsertLocalesRelationInput"]: ValueTypes["PostAreaUpsertLocalesRelationInput"];
	["PostUpsertAreaRelationInput"]: ValueTypes["PostUpsertAreaRelationInput"];
	["PostOrganizationUpsertPostsRelationInput"]: ValueTypes["PostOrganizationUpsertPostsRelationInput"];
	["PostOrganizationListItemUpsertItemRelationInput"]: ValueTypes["PostOrganizationListItemUpsertItemRelationInput"];
	["PostOrganizationListItemUpdateLinkEntityRelationInput"]: ValueTypes["PostOrganizationListItemUpdateLinkEntityRelationInput"];
	["PostOrganizationListItemUpsertLinkRelationInput"]: ValueTypes["PostOrganizationListItemUpsertLinkRelationInput"];
	["PostOrganizationListItemUpdateImageEntityRelationInput"]: ValueTypes["PostOrganizationListItemUpdateImageEntityRelationInput"];
	["PostOrganizationListItemUpsertImageRelationInput"]: ValueTypes["PostOrganizationListItemUpsertImageRelationInput"];
	["PostOrganizationListUpsertItemsRelationInput"]: ValueTypes["PostOrganizationListUpsertItemsRelationInput"];
	["GeneralUpsertOrganizationListRelationInput"]: ValueTypes["GeneralUpsertOrganizationListRelationInput"];
	["GeneralLocaleUpsertRootRelationInput"]: ValueTypes["GeneralLocaleUpsertRootRelationInput"];
	["GeneralLocaleUpdateSeoEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateSeoEntityRelationInput"];
	["GeneralLocaleUpsertSeoRelationInput"]: ValueTypes["GeneralLocaleUpsertSeoRelationInput"];
	["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateAppStoreLinkEntityRelationInput"];
	["GeneralLocaleUpsertAppStoreLinkRelationInput"]: ValueTypes["GeneralLocaleUpsertAppStoreLinkRelationInput"];
	["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateGooglePlayLinkEntityRelationInput"];
	["GeneralLocaleUpsertGooglePlayLinkRelationInput"]: ValueTypes["GeneralLocaleUpsertGooglePlayLinkRelationInput"];
	["LocaleUpsertGeneralsRelationInput"]: ValueTypes["LocaleUpsertGeneralsRelationInput"];
	["ReportNavigationLocaleUpsertLocaleRelationInput"]: ValueTypes["ReportNavigationLocaleUpsertLocaleRelationInput"];
	["GenericPageUpsertReportNavigationRelationInput"]: ValueTypes["GenericPageUpsertReportNavigationRelationInput"];
	["GenericPageLocaleUpsertRootRelationInput"]: ValueTypes["GenericPageLocaleUpsertRootRelationInput"];
	["LocaleUpsertGenericPagesRelationInput"]: ValueTypes["LocaleUpsertGenericPagesRelationInput"];
	["GeneralLocaleUpsertLocaleRelationInput"]: ValueTypes["GeneralLocaleUpsertLocaleRelationInput"];
	["GeneralUpsertLocalesRelationInput"]: ValueTypes["GeneralUpsertLocalesRelationInput"];
	["GenericPageCreateInput"]: ValueTypes["GenericPageCreateInput"];
	["GenericPageUpdateInput"]: ValueTypes["GenericPageUpdateInput"];
	["ContentBlockCreateInput"]: ValueTypes["ContentBlockCreateInput"];
	["ContentBlockUpdateInput"]: ValueTypes["ContentBlockUpdateInput"];
	["ContentReferenceCreateInput"]: ValueTypes["ContentReferenceCreateInput"];
	["ContentReferenceUpdateInput"]: ValueTypes["ContentReferenceUpdateInput"];
	["GeneralLocaleCreateInput"]: ValueTypes["GeneralLocaleCreateInput"];
	["GeneralLocaleUpdateInput"]: ValueTypes["GeneralLocaleUpdateInput"];
	["GenericPageLocaleCreateInput"]: ValueTypes["GenericPageLocaleCreateInput"];
	["GenericPageLocaleUpdateInput"]: ValueTypes["GenericPageLocaleUpdateInput"];
	["PostLocaleCreateInput"]: ValueTypes["PostLocaleCreateInput"];
	["PostLocaleUpdateInput"]: ValueTypes["PostLocaleUpdateInput"];
	["PostAreaLocaleCreateInput"]: ValueTypes["PostAreaLocaleCreateInput"];
	["PostAreaLocaleUpdateInput"]: ValueTypes["PostAreaLocaleUpdateInput"];
	["PostOrganizationLocaleCreateInput"]: ValueTypes["PostOrganizationLocaleCreateInput"];
	["PostOrganizationLocaleUpdateInput"]: ValueTypes["PostOrganizationLocaleUpdateInput"];
	["DonationCreateInput"]: ValueTypes["DonationCreateInput"];
	["DonationCreateRegionListEntityRelationInput"]: ValueTypes["DonationCreateRegionListEntityRelationInput"];
	["DonationAmountsRegionListWithoutDonationCreateInput"]: ValueTypes["DonationAmountsRegionListWithoutDonationCreateInput"];
	["DonationConnectOrCreateRegionListRelationInput"]: ValueTypes["DonationConnectOrCreateRegionListRelationInput"];
	["DonationUpdateInput"]: ValueTypes["DonationUpdateInput"];
	["DonationUpdateRegionListEntityRelationInput"]: ValueTypes["DonationUpdateRegionListEntityRelationInput"];
	["DonationAmountsRegionListWithoutDonationUpdateInput"]: ValueTypes["DonationAmountsRegionListWithoutDonationUpdateInput"];
	["DonationUpsertRegionListRelationInput"]: ValueTypes["DonationUpsertRegionListRelationInput"];
	["DonationAmountItemCreateInput"]: ValueTypes["DonationAmountItemCreateInput"];
	["DonationAmountItemCreateRegionItemEntityRelationInput"]: ValueTypes["DonationAmountItemCreateRegionItemEntityRelationInput"];
	["DonationAmountsRegionItemWithoutItemsCreateInput"]: ValueTypes["DonationAmountsRegionItemWithoutItemsCreateInput"];
	["DonationAmountItemConnectOrCreateRegionItemRelationInput"]: ValueTypes["DonationAmountItemConnectOrCreateRegionItemRelationInput"];
	["DonationAmountItemUpdateInput"]: ValueTypes["DonationAmountItemUpdateInput"];
	["DonationAmountItemUpdateRegionItemEntityRelationInput"]: ValueTypes["DonationAmountItemUpdateRegionItemEntityRelationInput"];
	["DonationAmountsRegionItemWithoutItemsUpdateInput"]: ValueTypes["DonationAmountsRegionItemWithoutItemsUpdateInput"];
	["DonationAmountItemUpsertRegionItemRelationInput"]: ValueTypes["DonationAmountItemUpsertRegionItemRelationInput"];
	["DonationAmountsRegionItemCreateInput"]: ValueTypes["DonationAmountsRegionItemCreateInput"];
	["DonationAmountsRegionItemUpdateInput"]: ValueTypes["DonationAmountsRegionItemUpdateInput"];
	["LinkItemCreateInput"]: ValueTypes["LinkItemCreateInput"];
	["LinkItemCreateListEntityRelationInput"]: ValueTypes["LinkItemCreateListEntityRelationInput"];
	["LinkListWithoutItemsCreateInput"]: ValueTypes["LinkListWithoutItemsCreateInput"];
	["LinkItemConnectOrCreateListRelationInput"]: ValueTypes["LinkItemConnectOrCreateListRelationInput"];
	["LinkItemUpdateInput"]: ValueTypes["LinkItemUpdateInput"];
	["LinkItemUpdateListEntityRelationInput"]: ValueTypes["LinkItemUpdateListEntityRelationInput"];
	["LinkListWithoutItemsUpdateInput"]: ValueTypes["LinkListWithoutItemsUpdateInput"];
	["LinkItemUpsertListRelationInput"]: ValueTypes["LinkItemUpsertListRelationInput"];
	["HeaderCreateInput"]: ValueTypes["HeaderCreateInput"];
	["HeaderCreateLocalesEntityRelationInput"]: ValueTypes["HeaderCreateLocalesEntityRelationInput"];
	["HeaderLocaleWithoutRootCreateInput"]: ValueTypes["HeaderLocaleWithoutRootCreateInput"];
	["HeaderLocaleCreateLocaleEntityRelationInput"]: ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutHeadersCreateInput"]: ValueTypes["LocaleWithoutHeadersCreateInput"];
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"];
	["HeaderConnectOrCreateLocalesRelationInput"]: ValueTypes["HeaderConnectOrCreateLocalesRelationInput"];
	["HeaderUpdateInput"]: ValueTypes["HeaderUpdateInput"];
	["HeaderUpdateLocalesEntityRelationInput"]: ValueTypes["HeaderUpdateLocalesEntityRelationInput"];
	["HeaderUpdateLocalesRelationInput"]: ValueTypes["HeaderUpdateLocalesRelationInput"];
	["HeaderLocaleWithoutRootUpdateInput"]: ValueTypes["HeaderLocaleWithoutRootUpdateInput"];
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutHeadersUpdateInput"]: ValueTypes["LocaleWithoutHeadersUpdateInput"];
	["HeaderLocaleUpsertLocaleRelationInput"]: ValueTypes["HeaderLocaleUpsertLocaleRelationInput"];
	["HeaderUpsertLocalesRelationInput"]: ValueTypes["HeaderUpsertLocalesRelationInput"];
	["HeaderLocaleCreateInput"]: ValueTypes["HeaderLocaleCreateInput"];
	["HeaderLocaleUpdateInput"]: ValueTypes["HeaderLocaleUpdateInput"];
	["FooterCreateInput"]: ValueTypes["FooterCreateInput"];
	["FooterCreateLocalesEntityRelationInput"]: ValueTypes["FooterCreateLocalesEntityRelationInput"];
	["FooterLocaleWithoutRootCreateInput"]: ValueTypes["FooterLocaleWithoutRootCreateInput"];
	["FooterLocaleCreateLocaleEntityRelationInput"]: ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutFootersCreateInput"]: ValueTypes["LocaleWithoutFootersCreateInput"];
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateLocaleRelationInput"];
	["FooterConnectOrCreateLocalesRelationInput"]: ValueTypes["FooterConnectOrCreateLocalesRelationInput"];
	["FooterUpdateInput"]: ValueTypes["FooterUpdateInput"];
	["FooterUpdateLocalesEntityRelationInput"]: ValueTypes["FooterUpdateLocalesEntityRelationInput"];
	["FooterUpdateLocalesRelationInput"]: ValueTypes["FooterUpdateLocalesRelationInput"];
	["FooterLocaleWithoutRootUpdateInput"]: ValueTypes["FooterLocaleWithoutRootUpdateInput"];
	["FooterLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutFootersUpdateInput"]: ValueTypes["LocaleWithoutFootersUpdateInput"];
	["FooterLocaleUpsertLocaleRelationInput"]: ValueTypes["FooterLocaleUpsertLocaleRelationInput"];
	["FooterUpsertLocalesRelationInput"]: ValueTypes["FooterUpsertLocalesRelationInput"];
	["FooterLocaleCreateInput"]: ValueTypes["FooterLocaleCreateInput"];
	["FooterLocaleUpdateInput"]: ValueTypes["FooterLocaleUpdateInput"];
	["PostListItemCreateInput"]: ValueTypes["PostListItemCreateInput"];
	["PostListItemCreateListEntityRelationInput"]: ValueTypes["PostListItemCreateListEntityRelationInput"];
	["PostListWithoutItemsCreateInput"]: ValueTypes["PostListWithoutItemsCreateInput"];
	["PostListItemConnectOrCreateListRelationInput"]: ValueTypes["PostListItemConnectOrCreateListRelationInput"];
	["PostListItemUpdateInput"]: ValueTypes["PostListItemUpdateInput"];
	["PostListItemUpdateListEntityRelationInput"]: ValueTypes["PostListItemUpdateListEntityRelationInput"];
	["PostListWithoutItemsUpdateInput"]: ValueTypes["PostListWithoutItemsUpdateInput"];
	["PostListItemUpsertListRelationInput"]: ValueTypes["PostListItemUpsertListRelationInput"];
	["GenericPageAboutSettingsCreateInput"]: ValueTypes["GenericPageAboutSettingsCreateInput"];
	["GenericPageAboutSettingsCreateLocalesEntityRelationInput"]: ValueTypes["GenericPageAboutSettingsCreateLocalesEntityRelationInput"];
	["GenericPageAboutSettingsLocaleWithoutRootCreateInput"]: ValueTypes["GenericPageAboutSettingsLocaleWithoutRootCreateInput"];
	["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutGenericPageAboutSettingsCreateInput"]: ValueTypes["LocaleWithoutGenericPageAboutSettingsCreateInput"];
	["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleConnectOrCreateLocaleRelationInput"];
	["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"]: ValueTypes["GenericPageAboutSettingsConnectOrCreateLocalesRelationInput"];
	["GenericPageAboutSettingsUpdateInput"]: ValueTypes["GenericPageAboutSettingsUpdateInput"];
	["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"]: ValueTypes["GenericPageAboutSettingsUpdateLocalesEntityRelationInput"];
	["GenericPageAboutSettingsUpdateLocalesRelationInput"]: ValueTypes["GenericPageAboutSettingsUpdateLocalesRelationInput"];
	["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"]: ValueTypes["GenericPageAboutSettingsLocaleWithoutRootUpdateInput"];
	["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutGenericPageAboutSettingsUpdateInput"]: ValueTypes["LocaleWithoutGenericPageAboutSettingsUpdateInput"];
	["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"]: ValueTypes["GenericPageAboutSettingsLocaleUpsertLocaleRelationInput"];
	["GenericPageAboutSettingsUpsertLocalesRelationInput"]: ValueTypes["GenericPageAboutSettingsUpsertLocalesRelationInput"];
	["GenericPageAboutSettingsLocaleCreateInput"]: ValueTypes["GenericPageAboutSettingsLocaleCreateInput"];
	["GenericPageAboutSettingsLocaleUpdateInput"]: ValueTypes["GenericPageAboutSettingsLocaleUpdateInput"];
	["ValueItemCreateInput"]: ValueTypes["ValueItemCreateInput"];
	["ValueItemCreateListEntityRelationInput"]: ValueTypes["ValueItemCreateListEntityRelationInput"];
	["ValueListWithoutItemsCreateInput"]: ValueTypes["ValueListWithoutItemsCreateInput"];
	["ValueItemConnectOrCreateListRelationInput"]: ValueTypes["ValueItemConnectOrCreateListRelationInput"];
	["ValueItemUpdateInput"]: ValueTypes["ValueItemUpdateInput"];
	["ValueItemUpdateListEntityRelationInput"]: ValueTypes["ValueItemUpdateListEntityRelationInput"];
	["ValueListWithoutItemsUpdateInput"]: ValueTypes["ValueListWithoutItemsUpdateInput"];
	["ValueItemUpsertListRelationInput"]: ValueTypes["ValueItemUpsertListRelationInput"];
	["ImageLinkItemCreateInput"]: ValueTypes["ImageLinkItemCreateInput"];
	["ImageLinkItemCreateListEntityRelationInput"]: ValueTypes["ImageLinkItemCreateListEntityRelationInput"];
	["ImageLinkListWithoutItemsCreateInput"]: ValueTypes["ImageLinkListWithoutItemsCreateInput"];
	["ImageLinkItemConnectOrCreateListRelationInput"]: ValueTypes["ImageLinkItemConnectOrCreateListRelationInput"];
	["ImageLinkItemUpdateInput"]: ValueTypes["ImageLinkItemUpdateInput"];
	["ImageLinkItemUpdateListEntityRelationInput"]: ValueTypes["ImageLinkItemUpdateListEntityRelationInput"];
	["ImageLinkListWithoutItemsUpdateInput"]: ValueTypes["ImageLinkListWithoutItemsUpdateInput"];
	["ImageLinkItemUpsertListRelationInput"]: ValueTypes["ImageLinkItemUpsertListRelationInput"];
	["PostAreaListItemCreateInput"]: ValueTypes["PostAreaListItemCreateInput"];
	["PostAreaListItemCreateListEntityRelationInput"]: ValueTypes["PostAreaListItemCreateListEntityRelationInput"];
	["PostAreaListWithoutItemsCreateInput"]: ValueTypes["PostAreaListWithoutItemsCreateInput"];
	["PostAreaListItemConnectOrCreateListRelationInput"]: ValueTypes["PostAreaListItemConnectOrCreateListRelationInput"];
	["PostAreaListItemUpdateInput"]: ValueTypes["PostAreaListItemUpdateInput"];
	["PostAreaListItemUpdateListEntityRelationInput"]: ValueTypes["PostAreaListItemUpdateListEntityRelationInput"];
	["PostAreaListWithoutItemsUpdateInput"]: ValueTypes["PostAreaListWithoutItemsUpdateInput"];
	["PostAreaListItemUpsertListRelationInput"]: ValueTypes["PostAreaListItemUpsertListRelationInput"];
	["AccordionItemCreateInput"]: ValueTypes["AccordionItemCreateInput"];
	["AccordionItemCreateListEntityRelationInput"]: ValueTypes["AccordionItemCreateListEntityRelationInput"];
	["AccordionWithoutItemsCreateInput"]: ValueTypes["AccordionWithoutItemsCreateInput"];
	["AccordionItemConnectOrCreateListRelationInput"]: ValueTypes["AccordionItemConnectOrCreateListRelationInput"];
	["AccordionItemUpdateInput"]: ValueTypes["AccordionItemUpdateInput"];
	["AccordionItemUpdateListEntityRelationInput"]: ValueTypes["AccordionItemUpdateListEntityRelationInput"];
	["AccordionWithoutItemsUpdateInput"]: ValueTypes["AccordionWithoutItemsUpdateInput"];
	["AccordionItemUpsertListRelationInput"]: ValueTypes["AccordionItemUpsertListRelationInput"];
	["UserPaymentCreateInput"]: ValueTypes["UserPaymentCreateInput"];
	["UserPaymentUpdateInput"]: ValueTypes["UserPaymentUpdateInput"];
	["MediumItemCreateInput"]: ValueTypes["MediumItemCreateInput"];
	["MediumItemCreateListEntityRelationInput"]: ValueTypes["MediumItemCreateListEntityRelationInput"];
	["MediumListWithoutItemsCreateInput"]: ValueTypes["MediumListWithoutItemsCreateInput"];
	["MediumItemConnectOrCreateListRelationInput"]: ValueTypes["MediumItemConnectOrCreateListRelationInput"];
	["MediumItemUpdateInput"]: ValueTypes["MediumItemUpdateInput"];
	["MediumItemUpdateListEntityRelationInput"]: ValueTypes["MediumItemUpdateListEntityRelationInput"];
	["MediumListWithoutItemsUpdateInput"]: ValueTypes["MediumListWithoutItemsUpdateInput"];
	["MediumItemUpsertListRelationInput"]: ValueTypes["MediumItemUpsertListRelationInput"];
	["UserRecurringPaymentItemCreateInput"]: ValueTypes["UserRecurringPaymentItemCreateInput"];
	["UserRecurringPaymentItemUpdateInput"]: ValueTypes["UserRecurringPaymentItemUpdateInput"];
	["PostRevisionLocaleCreateInput"]: ValueTypes["PostRevisionLocaleCreateInput"];
	["PostRevisionLocaleUpdateInput"]: ValueTypes["PostRevisionLocaleUpdateInput"];
	["TranslationCatalogueWhere"]: ValueTypes["TranslationCatalogueWhere"];
	["TranslationDomainWhere"]: ValueTypes["TranslationDomainWhere"];
	["TranslationKeyWhere"]: ValueTypes["TranslationKeyWhere"];
	["TranslationKeyContentTypeCondition"]: ValueTypes["TranslationKeyContentTypeCondition"];
	["TranslationKeyContentType"]: ValueTypes["TranslationKeyContentType"];
	["TranslationValueWhere"]: ValueTypes["TranslationValueWhere"];
	["TranslationCataloguesIdentifierWhere"]: ValueTypes["TranslationCataloguesIdentifierWhere"];
	["TranslationCatalogueOrderBy"]: ValueTypes["TranslationCatalogueOrderBy"];
	["TranslationDomainOrderBy"]: ValueTypes["TranslationDomainOrderBy"];
	["TranslationCataloguesIdentifierOrderBy"]: ValueTypes["TranslationCataloguesIdentifierOrderBy"];
	["TranslationValueOrderBy"]: ValueTypes["TranslationValueOrderBy"];
	["TranslationKeyOrderBy"]: ValueTypes["TranslationKeyOrderBy"];
	["TranslationKeyValuesByCatalogueUniqueWhere"]: ValueTypes["TranslationKeyValuesByCatalogueUniqueWhere"];
	["TranslationCatalogueUniqueWhere"]: ValueTypes["TranslationCatalogueUniqueWhere"];
	["TranslationDomainUniqueWhere"]: ValueTypes["TranslationDomainUniqueWhere"];
	["TranslationKeyUniqueWhere"]: ValueTypes["TranslationKeyUniqueWhere"];
	["TranslationValueUniqueWhere"]: ValueTypes["TranslationValueUniqueWhere"];
	["TranslationCataloguesIdentifierUniqueWhere"]: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"];
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: ValueTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"];
	["TranslationDomainCataloguesByValuesUniqueWhere"]: ValueTypes["TranslationDomainCataloguesByValuesUniqueWhere"];
	["TranslationDomainKeysByIdentifierUniqueWhere"]: ValueTypes["TranslationDomainKeysByIdentifierUniqueWhere"];
	["TranslationDomainKeysByValuesUniqueWhere"]: ValueTypes["TranslationDomainKeysByValuesUniqueWhere"];
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: ValueTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"];
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: ValueTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"];
	["TranslationCatalogueValuesByKeyUniqueWhere"]: ValueTypes["TranslationCatalogueValuesByKeyUniqueWhere"];
	["TranslationCatalogueCreateInput"]: ValueTypes["TranslationCatalogueCreateInput"];
	["TranslationCatalogueCreateDomainEntityRelationInput"]: ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"];
	["TranslationDomainWithoutCataloguesCreateInput"]: ValueTypes["TranslationDomainWithoutCataloguesCreateInput"];
	["TranslationDomainCreateKeysEntityRelationInput"]: ValueTypes["TranslationDomainCreateKeysEntityRelationInput"];
	["TranslationKeyWithoutDomainCreateInput"]: ValueTypes["TranslationKeyWithoutDomainCreateInput"];
	["TranslationKeyCreateValuesEntityRelationInput"]: ValueTypes["TranslationKeyCreateValuesEntityRelationInput"];
	["TranslationValueWithoutKeyCreateInput"]: ValueTypes["TranslationValueWithoutKeyCreateInput"];
	["TranslationValueCreateCatalogueEntityRelationInput"]: ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutValuesCreateInput"]: ValueTypes["TranslationCatalogueWithoutValuesCreateInput"];
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"];
	["TranslationCatalogueConnectOrCreateIdentifierRelationInput"]: ValueTypes["TranslationCatalogueConnectOrCreateIdentifierRelationInput"];
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"];
	["TranslationCatalogueConnectOrCreateFallbackRelationInput"]: ValueTypes["TranslationCatalogueConnectOrCreateFallbackRelationInput"];
	["TranslationValueConnectOrCreateCatalogueRelationInput"]: ValueTypes["TranslationValueConnectOrCreateCatalogueRelationInput"];
	["TranslationKeyConnectOrCreateValuesRelationInput"]: ValueTypes["TranslationKeyConnectOrCreateValuesRelationInput"];
	["TranslationDomainConnectOrCreateKeysRelationInput"]: ValueTypes["TranslationDomainConnectOrCreateKeysRelationInput"];
	["TranslationCatalogueConnectOrCreateDomainRelationInput"]: ValueTypes["TranslationCatalogueConnectOrCreateDomainRelationInput"];
	["TranslationCatalogueCreateValuesEntityRelationInput"]: ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"];
	["TranslationValueWithoutCatalogueCreateInput"]: ValueTypes["TranslationValueWithoutCatalogueCreateInput"];
	["TranslationValueCreateKeyEntityRelationInput"]: ValueTypes["TranslationValueCreateKeyEntityRelationInput"];
	["TranslationKeyWithoutValuesCreateInput"]: ValueTypes["TranslationKeyWithoutValuesCreateInput"];
	["TranslationKeyCreateDomainEntityRelationInput"]: ValueTypes["TranslationKeyCreateDomainEntityRelationInput"];
	["TranslationDomainWithoutKeysCreateInput"]: ValueTypes["TranslationDomainWithoutKeysCreateInput"];
	["TranslationDomainCreateCataloguesEntityRelationInput"]: ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"];
	["TranslationCatalogueWithoutDomainCreateInput"]: ValueTypes["TranslationCatalogueWithoutDomainCreateInput"];
	["TranslationDomainConnectOrCreateCataloguesRelationInput"]: ValueTypes["TranslationDomainConnectOrCreateCataloguesRelationInput"];
	["TranslationKeyConnectOrCreateDomainRelationInput"]: ValueTypes["TranslationKeyConnectOrCreateDomainRelationInput"];
	["TranslationValueConnectOrCreateKeyRelationInput"]: ValueTypes["TranslationValueConnectOrCreateKeyRelationInput"];
	["TranslationCatalogueConnectOrCreateValuesRelationInput"]: ValueTypes["TranslationCatalogueConnectOrCreateValuesRelationInput"];
	["TranslationCatalogueUpdateInput"]: ValueTypes["TranslationCatalogueUpdateInput"];
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"];
	["TranslationDomainWithoutCataloguesUpdateInput"]: ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"];
	["TranslationDomainUpdateKeysEntityRelationInput"]: ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"];
	["TranslationDomainUpdateKeysRelationInput"]: ValueTypes["TranslationDomainUpdateKeysRelationInput"];
	["TranslationKeyWithoutDomainUpdateInput"]: ValueTypes["TranslationKeyWithoutDomainUpdateInput"];
	["TranslationKeyUpdateValuesEntityRelationInput"]: ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"];
	["TranslationKeyUpdateValuesRelationInput"]: ValueTypes["TranslationKeyUpdateValuesRelationInput"];
	["TranslationValueWithoutKeyUpdateInput"]: ValueTypes["TranslationValueWithoutKeyUpdateInput"];
	["TranslationValueUpdateCatalogueEntityRelationInput"]: ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutValuesUpdateInput"]: ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"];
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"];
	["TranslationCatalogueUpsertIdentifierRelationInput"]: ValueTypes["TranslationCatalogueUpsertIdentifierRelationInput"];
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"];
	["TranslationCatalogueUpsertFallbackRelationInput"]: ValueTypes["TranslationCatalogueUpsertFallbackRelationInput"];
	["TranslationValueUpsertCatalogueRelationInput"]: ValueTypes["TranslationValueUpsertCatalogueRelationInput"];
	["TranslationKeyUpsertValuesRelationInput"]: ValueTypes["TranslationKeyUpsertValuesRelationInput"];
	["TranslationDomainUpsertKeysRelationInput"]: ValueTypes["TranslationDomainUpsertKeysRelationInput"];
	["TranslationCatalogueUpsertDomainRelationInput"]: ValueTypes["TranslationCatalogueUpsertDomainRelationInput"];
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"];
	["TranslationCatalogueUpdateValuesRelationInput"]: ValueTypes["TranslationCatalogueUpdateValuesRelationInput"];
	["TranslationValueWithoutCatalogueUpdateInput"]: ValueTypes["TranslationValueWithoutCatalogueUpdateInput"];
	["TranslationValueUpdateKeyEntityRelationInput"]: ValueTypes["TranslationValueUpdateKeyEntityRelationInput"];
	["TranslationKeyWithoutValuesUpdateInput"]: ValueTypes["TranslationKeyWithoutValuesUpdateInput"];
	["TranslationKeyUpdateDomainEntityRelationInput"]: ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"];
	["TranslationDomainWithoutKeysUpdateInput"]: ValueTypes["TranslationDomainWithoutKeysUpdateInput"];
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"];
	["TranslationDomainUpdateCataloguesRelationInput"]: ValueTypes["TranslationDomainUpdateCataloguesRelationInput"];
	["TranslationCatalogueWithoutDomainUpdateInput"]: ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"];
	["TranslationDomainUpsertCataloguesRelationInput"]: ValueTypes["TranslationDomainUpsertCataloguesRelationInput"];
	["TranslationKeyUpsertDomainRelationInput"]: ValueTypes["TranslationKeyUpsertDomainRelationInput"];
	["TranslationValueUpsertKeyRelationInput"]: ValueTypes["TranslationValueUpsertKeyRelationInput"];
	["TranslationCatalogueUpsertValuesRelationInput"]: ValueTypes["TranslationCatalogueUpsertValuesRelationInput"];
	["TranslationCataloguesIdentifierCreateInput"]: ValueTypes["TranslationCataloguesIdentifierCreateInput"];
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: ValueTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutIdentifierCreateInput"]: ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"];
	["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"]: ValueTypes["TranslationCataloguesIdentifierConnectOrCreateCatalogueRelationInput"];
	["TranslationCataloguesIdentifierUpdateInput"]: ValueTypes["TranslationCataloguesIdentifierUpdateInput"];
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"];
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"];
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"];
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: ValueTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"];
	["TranslationDomainCreateInput"]: ValueTypes["TranslationDomainCreateInput"];
	["TranslationDomainUpdateInput"]: ValueTypes["TranslationDomainUpdateInput"];
	["TranslationKeyCreateInput"]: ValueTypes["TranslationKeyCreateInput"];
	["TranslationKeyUpdateInput"]: ValueTypes["TranslationKeyUpdateInput"];
	["TranslationValueCreateInput"]: ValueTypes["TranslationValueCreateInput"];
	["TranslationValueUpdateInput"]: ValueTypes["TranslationValueUpdateInput"];
	["GenericPageAboutGroupLinksLocaleCreateInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleCreateInput"];
	["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleCreateSettingsEntityRelationInput"];
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"]: ValueTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsCreateInput"];
	["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleConnectOrCreateSettingsRelationInput"];
	["GenericPageAboutGroupLinksLocaleUpdateInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateInput"];
	["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleUpdateSettingsEntityRelationInput"];
	["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"]: ValueTypes["GenericPageAboutSettingsLocaleWithoutLinkGroupsUpdateInput"];
	["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"]: ValueTypes["GenericPageAboutGroupLinksLocaleUpsertSettingsRelationInput"];
	["MemberListItemCreateInput"]: ValueTypes["MemberListItemCreateInput"];
	["MemberListItemCreateListEntityRelationInput"]: ValueTypes["MemberListItemCreateListEntityRelationInput"];
	["MemberListWithoutItemsCreateInput"]: ValueTypes["MemberListWithoutItemsCreateInput"];
	["MemberListItemConnectOrCreateListRelationInput"]: ValueTypes["MemberListItemConnectOrCreateListRelationInput"];
	["MemberListItemUpdateInput"]: ValueTypes["MemberListItemUpdateInput"];
	["MemberListItemUpdateListEntityRelationInput"]: ValueTypes["MemberListItemUpdateListEntityRelationInput"];
	["MemberListWithoutItemsUpdateInput"]: ValueTypes["MemberListWithoutItemsUpdateInput"];
	["MemberListItemUpsertListRelationInput"]: ValueTypes["MemberListItemUpsertListRelationInput"];
	["FilledTaxFormEmailAddressUniqueWhere"]: ValueTypes["FilledTaxFormEmailAddressUniqueWhere"];
	["FilledTaxFormEmailAddressWhere"]: ValueTypes["FilledTaxFormEmailAddressWhere"];
	["FilledTaxFormEmailAddressOrderBy"]: ValueTypes["FilledTaxFormEmailAddressOrderBy"];
	["FilledTaxFormEmailAddressCreateInput"]: ValueTypes["FilledTaxFormEmailAddressCreateInput"];
	["FilledTaxFormEmailAddressUpdateInput"]: ValueTypes["FilledTaxFormEmailAddressUpdateInput"];
	["CsobPaymentCreateInput"]: ValueTypes["CsobPaymentCreateInput"];
	["CsobPaymentCreatePaymentEntityRelationInput"]: ValueTypes["CsobPaymentCreatePaymentEntityRelationInput"];
	["UserPaymentWithoutCsobPaymentCreateInput"]: ValueTypes["UserPaymentWithoutCsobPaymentCreateInput"];
	["CsobPaymentConnectOrCreatePaymentRelationInput"]: ValueTypes["CsobPaymentConnectOrCreatePaymentRelationInput"];
	["CsobPaymentUpdateInput"]: ValueTypes["CsobPaymentUpdateInput"];
	["CsobPaymentUpdatePaymentEntityRelationInput"]: ValueTypes["CsobPaymentUpdatePaymentEntityRelationInput"];
	["UserPaymentWithoutCsobPaymentUpdateInput"]: ValueTypes["UserPaymentWithoutCsobPaymentUpdateInput"];
	["CsobPaymentUpsertPaymentRelationInput"]: ValueTypes["CsobPaymentUpsertPaymentRelationInput"];
	["CsobPaymentStatusChangeCreateInput"]: ValueTypes["CsobPaymentStatusChangeCreateInput"];
	["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"]: ValueTypes["CsobPaymentStatusChangeCreatePaymentEntityRelationInput"];
	["CsobPaymentWithoutStatusChangesCreateInput"]: ValueTypes["CsobPaymentWithoutStatusChangesCreateInput"];
	["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"]: ValueTypes["CsobPaymentStatusChangeConnectOrCreatePaymentRelationInput"];
	["CsobPaymentStatusChangeUpdateInput"]: ValueTypes["CsobPaymentStatusChangeUpdateInput"];
	["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"]: ValueTypes["CsobPaymentStatusChangeUpdatePaymentEntityRelationInput"];
	["CsobPaymentWithoutStatusChangesUpdateInput"]: ValueTypes["CsobPaymentWithoutStatusChangesUpdateInput"];
	["CsobPaymentStatusChangeUpsertPaymentRelationInput"]: ValueTypes["CsobPaymentStatusChangeUpsertPaymentRelationInput"];
	["StripePaymentCreateInput"]: ValueTypes["StripePaymentCreateInput"];
	["StripePaymentCreatePaymentEntityRelationInput"]: ValueTypes["StripePaymentCreatePaymentEntityRelationInput"];
	["UserPaymentWithoutStripePaymentCreateInput"]: ValueTypes["UserPaymentWithoutStripePaymentCreateInput"];
	["StripePaymentConnectOrCreatePaymentRelationInput"]: ValueTypes["StripePaymentConnectOrCreatePaymentRelationInput"];
	["StripePaymentUpdateInput"]: ValueTypes["StripePaymentUpdateInput"];
	["StripePaymentUpdatePaymentEntityRelationInput"]: ValueTypes["StripePaymentUpdatePaymentEntityRelationInput"];
	["UserPaymentWithoutStripePaymentUpdateInput"]: ValueTypes["UserPaymentWithoutStripePaymentUpdateInput"];
	["StripePaymentUpsertPaymentRelationInput"]: ValueTypes["StripePaymentUpsertPaymentRelationInput"];
	["StripePaymentStatusChangeCreateInput"]: ValueTypes["StripePaymentStatusChangeCreateInput"];
	["StripePaymentStatusChangeCreatePaymentEntityRelationInput"]: ValueTypes["StripePaymentStatusChangeCreatePaymentEntityRelationInput"];
	["StripePaymentWithoutStatusChangesCreateInput"]: ValueTypes["StripePaymentWithoutStatusChangesCreateInput"];
	["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"]: ValueTypes["StripePaymentStatusChangeConnectOrCreatePaymentRelationInput"];
	["StripePaymentStatusChangeUpdateInput"]: ValueTypes["StripePaymentStatusChangeUpdateInput"];
	["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"]: ValueTypes["StripePaymentStatusChangeUpdatePaymentEntityRelationInput"];
	["StripePaymentWithoutStatusChangesUpdateInput"]: ValueTypes["StripePaymentWithoutStatusChangesUpdateInput"];
	["StripePaymentStatusChangeUpsertPaymentRelationInput"]: ValueTypes["StripePaymentStatusChangeUpsertPaymentRelationInput"];
	["RegionPaymentMethodCreateInput"]: ValueTypes["RegionPaymentMethodCreateInput"];
	["RegionPaymentMethodCreateRegionEntityRelationInput"]: ValueTypes["RegionPaymentMethodCreateRegionEntityRelationInput"];
	["RegionWithoutEnabledPaymentMethodsCreateInput"]: ValueTypes["RegionWithoutEnabledPaymentMethodsCreateInput"];
	["RegionPaymentMethodConnectOrCreateRegionRelationInput"]: ValueTypes["RegionPaymentMethodConnectOrCreateRegionRelationInput"];
	["RegionPaymentMethodUpdateInput"]: ValueTypes["RegionPaymentMethodUpdateInput"];
	["RegionPaymentMethodUpdateRegionEntityRelationInput"]: ValueTypes["RegionPaymentMethodUpdateRegionEntityRelationInput"];
	["RegionWithoutEnabledPaymentMethodsUpdateInput"]: ValueTypes["RegionWithoutEnabledPaymentMethodsUpdateInput"];
	["RegionPaymentMethodUpsertRegionRelationInput"]: ValueTypes["RegionPaymentMethodUpsertRegionRelationInput"];
	["TileItemCreateInput"]: ValueTypes["TileItemCreateInput"];
	["TileItemCreateListEntityRelationInput"]: ValueTypes["TileItemCreateListEntityRelationInput"];
	["TileListWithoutItemsCreateInput"]: ValueTypes["TileListWithoutItemsCreateInput"];
	["TileItemConnectOrCreateListRelationInput"]: ValueTypes["TileItemConnectOrCreateListRelationInput"];
	["TileItemUpdateInput"]: ValueTypes["TileItemUpdateInput"];
	["TileItemUpdateListEntityRelationInput"]: ValueTypes["TileItemUpdateListEntityRelationInput"];
	["TileListWithoutItemsUpdateInput"]: ValueTypes["TileListWithoutItemsUpdateInput"];
	["TileItemUpsertListRelationInput"]: ValueTypes["TileItemUpsertListRelationInput"];
	["FeedPageCreateInput"]: ValueTypes["FeedPageCreateInput"];
	["FeedPageCreateLocalesEntityRelationInput"]: ValueTypes["FeedPageCreateLocalesEntityRelationInput"];
	["FeedPageLocaleWithoutRootCreateInput"]: ValueTypes["FeedPageLocaleWithoutRootCreateInput"];
	["FeedPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["FeedPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutFeedPagesCreateInput"]: ValueTypes["LocaleWithoutFeedPagesCreateInput"];
	["FeedPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["FeedPageLocaleConnectOrCreateLocaleRelationInput"];
	["FeedPageConnectOrCreateLocalesRelationInput"]: ValueTypes["FeedPageConnectOrCreateLocalesRelationInput"];
	["FeedPageUpdateInput"]: ValueTypes["FeedPageUpdateInput"];
	["FeedPageUpdateLocalesEntityRelationInput"]: ValueTypes["FeedPageUpdateLocalesEntityRelationInput"];
	["FeedPageUpdateLocalesRelationInput"]: ValueTypes["FeedPageUpdateLocalesRelationInput"];
	["FeedPageLocaleWithoutRootUpdateInput"]: ValueTypes["FeedPageLocaleWithoutRootUpdateInput"];
	["FeedPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["FeedPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutFeedPagesUpdateInput"]: ValueTypes["LocaleWithoutFeedPagesUpdateInput"];
	["FeedPageLocaleUpsertLocaleRelationInput"]: ValueTypes["FeedPageLocaleUpsertLocaleRelationInput"];
	["FeedPageUpsertLocalesRelationInput"]: ValueTypes["FeedPageUpsertLocalesRelationInput"];
	["FeedPageLocaleCreateInput"]: ValueTypes["FeedPageLocaleCreateInput"];
	["FeedPageLocaleUpdateInput"]: ValueTypes["FeedPageLocaleUpdateInput"];
	["FeedPageSectionCreateInput"]: ValueTypes["FeedPageSectionCreateInput"];
	["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"]: ValueTypes["FeedPageSectionCreateFeedPageLocaleEntityRelationInput"];
	["FeedPageLocaleWithoutSectionListCreateInput"]: ValueTypes["FeedPageLocaleWithoutSectionListCreateInput"];
	["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"]: ValueTypes["FeedPageSectionConnectOrCreateFeedPageLocaleRelationInput"];
	["FeedPageSectionUpdateInput"]: ValueTypes["FeedPageSectionUpdateInput"];
	["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"]: ValueTypes["FeedPageSectionUpdateFeedPageLocaleEntityRelationInput"];
	["FeedPageLocaleWithoutSectionListUpdateInput"]: ValueTypes["FeedPageLocaleWithoutSectionListUpdateInput"];
	["FeedPageSectionUpsertFeedPageLocaleRelationInput"]: ValueTypes["FeedPageSectionUpsertFeedPageLocaleRelationInput"];
	["FeedPageTileStripeCreateInput"]: ValueTypes["FeedPageTileStripeCreateInput"];
	["FeedPageTileStripeCreateSectionEntityRelationInput"]: ValueTypes["FeedPageTileStripeCreateSectionEntityRelationInput"];
	["FeedPageSectionWithoutTileStripeListCreateInput"]: ValueTypes["FeedPageSectionWithoutTileStripeListCreateInput"];
	["FeedPageTileStripeConnectOrCreateSectionRelationInput"]: ValueTypes["FeedPageTileStripeConnectOrCreateSectionRelationInput"];
	["FeedPageTileStripeUpdateInput"]: ValueTypes["FeedPageTileStripeUpdateInput"];
	["FeedPageTileStripeUpdateSectionEntityRelationInput"]: ValueTypes["FeedPageTileStripeUpdateSectionEntityRelationInput"];
	["FeedPageSectionWithoutTileStripeListUpdateInput"]: ValueTypes["FeedPageSectionWithoutTileStripeListUpdateInput"];
	["FeedPageTileStripeUpsertSectionRelationInput"]: ValueTypes["FeedPageTileStripeUpsertSectionRelationInput"];
	["CardItemCreateInput"]: ValueTypes["CardItemCreateInput"];
	["CardItemCreateListEntityRelationInput"]: ValueTypes["CardItemCreateListEntityRelationInput"];
	["CardListWithoutItemsCreateInput"]: ValueTypes["CardListWithoutItemsCreateInput"];
	["CardItemConnectOrCreateListRelationInput"]: ValueTypes["CardItemConnectOrCreateListRelationInput"];
	["CardItemUpdateInput"]: ValueTypes["CardItemUpdateInput"];
	["CardItemUpdateListEntityRelationInput"]: ValueTypes["CardItemUpdateListEntityRelationInput"];
	["CardListWithoutItemsUpdateInput"]: ValueTypes["CardListWithoutItemsUpdateInput"];
	["CardItemUpsertListRelationInput"]: ValueTypes["CardItemUpsertListRelationInput"];
	["UserPaymentTriesCollectionCreateInput"]: ValueTypes["UserPaymentTriesCollectionCreateInput"];
	["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionCreatePaymentEntityRelationInput"];
	["UserPaymentWithoutTriesCollectionCreateInput"]: ValueTypes["UserPaymentWithoutTriesCollectionCreateInput"];
	["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"]: ValueTypes["UserPaymentTriesCollectionConnectOrCreatePaymentRelationInput"];
	["UserPaymentTriesCollectionUpdateInput"]: ValueTypes["UserPaymentTriesCollectionUpdateInput"];
	["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpdatePaymentEntityRelationInput"];
	["UserPaymentTriesCollectionUpdatePaymentRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpdatePaymentRelationInput"];
	["UserPaymentWithoutTriesCollectionUpdateInput"]: ValueTypes["UserPaymentWithoutTriesCollectionUpdateInput"];
	["UserPaymentTriesCollectionUpsertPaymentRelationInput"]: ValueTypes["UserPaymentTriesCollectionUpsertPaymentRelationInput"];
	["RecurringPaymentPageCreateInput"]: ValueTypes["RecurringPaymentPageCreateInput"];
	["RecurringPaymentPageCreateLocalesEntityRelationInput"]: ValueTypes["RecurringPaymentPageCreateLocalesEntityRelationInput"];
	["RecurringPaymentPageLocaleWithoutRootCreateInput"]: ValueTypes["RecurringPaymentPageLocaleWithoutRootCreateInput"];
	["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["RecurringPaymentPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutRecurringPaymentPagesCreateInput"]: ValueTypes["LocaleWithoutRecurringPaymentPagesCreateInput"];
	["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["RecurringPaymentPageLocaleConnectOrCreateLocaleRelationInput"];
	["RecurringPaymentPageConnectOrCreateLocalesRelationInput"]: ValueTypes["RecurringPaymentPageConnectOrCreateLocalesRelationInput"];
	["RecurringPaymentPageUpdateInput"]: ValueTypes["RecurringPaymentPageUpdateInput"];
	["RecurringPaymentPageUpdateLocalesEntityRelationInput"]: ValueTypes["RecurringPaymentPageUpdateLocalesEntityRelationInput"];
	["RecurringPaymentPageUpdateLocalesRelationInput"]: ValueTypes["RecurringPaymentPageUpdateLocalesRelationInput"];
	["RecurringPaymentPageLocaleWithoutRootUpdateInput"]: ValueTypes["RecurringPaymentPageLocaleWithoutRootUpdateInput"];
	["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["RecurringPaymentPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutRecurringPaymentPagesUpdateInput"]: ValueTypes["LocaleWithoutRecurringPaymentPagesUpdateInput"];
	["RecurringPaymentPageLocaleUpsertLocaleRelationInput"]: ValueTypes["RecurringPaymentPageLocaleUpsertLocaleRelationInput"];
	["RecurringPaymentPageUpsertLocalesRelationInput"]: ValueTypes["RecurringPaymentPageUpsertLocalesRelationInput"];
	["RecurringPaymentPageLocaleCreateInput"]: ValueTypes["RecurringPaymentPageLocaleCreateInput"];
	["RecurringPaymentPageLocaleUpdateInput"]: ValueTypes["RecurringPaymentPageLocaleUpdateInput"];
	["StoryGuideItemCreateInput"]: ValueTypes["StoryGuideItemCreateInput"];
	["StoryGuideItemCreateListEntityRelationInput"]: ValueTypes["StoryGuideItemCreateListEntityRelationInput"];
	["StoryGuideListWithoutItemsCreateInput"]: ValueTypes["StoryGuideListWithoutItemsCreateInput"];
	["StoryGuideItemConnectOrCreateListRelationInput"]: ValueTypes["StoryGuideItemConnectOrCreateListRelationInput"];
	["StoryGuideItemUpdateInput"]: ValueTypes["StoryGuideItemUpdateInput"];
	["StoryGuideItemUpdateListEntityRelationInput"]: ValueTypes["StoryGuideItemUpdateListEntityRelationInput"];
	["StoryGuideListWithoutItemsUpdateInput"]: ValueTypes["StoryGuideListWithoutItemsUpdateInput"];
	["StoryGuideItemUpsertListRelationInput"]: ValueTypes["StoryGuideItemUpsertListRelationInput"];
	["PostOrganizationListItemCreateInput"]: ValueTypes["PostOrganizationListItemCreateInput"];
	["PostOrganizationListItemCreateListEntityRelationInput"]: ValueTypes["PostOrganizationListItemCreateListEntityRelationInput"];
	["PostOrganizationListWithoutItemsCreateInput"]: ValueTypes["PostOrganizationListWithoutItemsCreateInput"];
	["PostOrganizationListItemConnectOrCreateListRelationInput"]: ValueTypes["PostOrganizationListItemConnectOrCreateListRelationInput"];
	["PostOrganizationListItemUpdateInput"]: ValueTypes["PostOrganizationListItemUpdateInput"];
	["PostOrganizationListItemUpdateListEntityRelationInput"]: ValueTypes["PostOrganizationListItemUpdateListEntityRelationInput"];
	["PostOrganizationListWithoutItemsUpdateInput"]: ValueTypes["PostOrganizationListWithoutItemsUpdateInput"];
	["PostOrganizationListItemUpsertListRelationInput"]: ValueTypes["PostOrganizationListItemUpsertListRelationInput"];
	["InfoCarouselWhere"]: ValueTypes["InfoCarouselWhere"];
	["InfoCarouselItemWhere"]: ValueTypes["InfoCarouselItemWhere"];
	["InfoCarouselItemTypeCondition"]: ValueTypes["InfoCarouselItemTypeCondition"];
	["InfoCarouselItemType"]: ValueTypes["InfoCarouselItemType"];
	["InfoCarouselItemLocaleWhere"]: ValueTypes["InfoCarouselItemLocaleWhere"];
	["PersonSeenInfoCarouselWhere"]: ValueTypes["PersonSeenInfoCarouselWhere"];
	["InfoCarouselItemLocaleOrderBy"]: ValueTypes["InfoCarouselItemLocaleOrderBy"];
	["InfoCarouselItemOrderBy"]: ValueTypes["InfoCarouselItemOrderBy"];
	["InfoCarouselOrderBy"]: ValueTypes["InfoCarouselOrderBy"];
	["InfoCarouselItemLocalesByLocaleUniqueWhere"]: ValueTypes["InfoCarouselItemLocalesByLocaleUniqueWhere"];
	["PersonSeenInfoCarouselOrderBy"]: ValueTypes["PersonSeenInfoCarouselOrderBy"];
	["InfoCarouselItemsByLocalesUniqueWhere"]: ValueTypes["InfoCarouselItemsByLocalesUniqueWhere"];
	["InfoCarouselItemLocaleUniqueWhere"]: ValueTypes["InfoCarouselItemLocaleUniqueWhere"];
	["InfoCarouselItemUniqueWhere"]: ValueTypes["InfoCarouselItemUniqueWhere"];
	["InfoCarouselSeenByByUserUniqueWhere"]: ValueTypes["InfoCarouselSeenByByUserUniqueWhere"];
	["InfoCarouselUniqueWhere"]: ValueTypes["InfoCarouselUniqueWhere"];
	["PersonSeenInfoCarouselUniqueWhere"]: ValueTypes["PersonSeenInfoCarouselUniqueWhere"];
	["InfoCarouselCreateInput"]: ValueTypes["InfoCarouselCreateInput"];
	["InfoCarouselCreateItemsEntityRelationInput"]: ValueTypes["InfoCarouselCreateItemsEntityRelationInput"];
	["InfoCarouselItemWithoutCarouselCreateInput"]: ValueTypes["InfoCarouselItemWithoutCarouselCreateInput"];
	["InfoCarouselItemCreateImageEntityRelationInput"]: ValueTypes["InfoCarouselItemCreateImageEntityRelationInput"];
	["InfoCarouselItemConnectOrCreateImageRelationInput"]: ValueTypes["InfoCarouselItemConnectOrCreateImageRelationInput"];
	["InfoCarouselItemCreatePostEntityRelationInput"]: ValueTypes["InfoCarouselItemCreatePostEntityRelationInput"];
	["InfoCarouselItemConnectOrCreatePostRelationInput"]: ValueTypes["InfoCarouselItemConnectOrCreatePostRelationInput"];
	["InfoCarouselItemCreateLocalesEntityRelationInput"]: ValueTypes["InfoCarouselItemCreateLocalesEntityRelationInput"];
	["InfoCarouselItemLocaleWithoutRootCreateInput"]: ValueTypes["InfoCarouselItemLocaleWithoutRootCreateInput"];
	["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"]: ValueTypes["InfoCarouselItemLocaleCreateLocaleEntityRelationInput"];
	["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["InfoCarouselItemLocaleConnectOrCreateLocaleRelationInput"];
	["InfoCarouselItemConnectOrCreateLocalesRelationInput"]: ValueTypes["InfoCarouselItemConnectOrCreateLocalesRelationInput"];
	["InfoCarouselConnectOrCreateItemsRelationInput"]: ValueTypes["InfoCarouselConnectOrCreateItemsRelationInput"];
	["InfoCarouselCreateSeenByEntityRelationInput"]: ValueTypes["InfoCarouselCreateSeenByEntityRelationInput"];
	["PersonSeenInfoCarouselWithoutCarouselCreateInput"]: ValueTypes["PersonSeenInfoCarouselWithoutCarouselCreateInput"];
	["PersonSeenInfoCarouselCreateUserEntityRelationInput"]: ValueTypes["PersonSeenInfoCarouselCreateUserEntityRelationInput"];
	["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"]: ValueTypes["PersonSeenInfoCarouselConnectOrCreateUserRelationInput"];
	["InfoCarouselConnectOrCreateSeenByRelationInput"]: ValueTypes["InfoCarouselConnectOrCreateSeenByRelationInput"];
	["InfoCarouselUpdateInput"]: ValueTypes["InfoCarouselUpdateInput"];
	["InfoCarouselUpdateItemsEntityRelationInput"]: ValueTypes["InfoCarouselUpdateItemsEntityRelationInput"];
	["InfoCarouselUpdateItemsRelationInput"]: ValueTypes["InfoCarouselUpdateItemsRelationInput"];
	["InfoCarouselItemWithoutCarouselUpdateInput"]: ValueTypes["InfoCarouselItemWithoutCarouselUpdateInput"];
	["InfoCarouselItemUpdateImageEntityRelationInput"]: ValueTypes["InfoCarouselItemUpdateImageEntityRelationInput"];
	["InfoCarouselItemUpsertImageRelationInput"]: ValueTypes["InfoCarouselItemUpsertImageRelationInput"];
	["InfoCarouselItemUpdatePostEntityRelationInput"]: ValueTypes["InfoCarouselItemUpdatePostEntityRelationInput"];
	["InfoCarouselItemUpsertPostRelationInput"]: ValueTypes["InfoCarouselItemUpsertPostRelationInput"];
	["InfoCarouselItemUpdateLocalesEntityRelationInput"]: ValueTypes["InfoCarouselItemUpdateLocalesEntityRelationInput"];
	["InfoCarouselItemUpdateLocalesRelationInput"]: ValueTypes["InfoCarouselItemUpdateLocalesRelationInput"];
	["InfoCarouselItemLocaleWithoutRootUpdateInput"]: ValueTypes["InfoCarouselItemLocaleWithoutRootUpdateInput"];
	["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["InfoCarouselItemLocaleUpdateLocaleEntityRelationInput"];
	["InfoCarouselItemLocaleUpsertLocaleRelationInput"]: ValueTypes["InfoCarouselItemLocaleUpsertLocaleRelationInput"];
	["InfoCarouselItemUpsertLocalesRelationInput"]: ValueTypes["InfoCarouselItemUpsertLocalesRelationInput"];
	["InfoCarouselUpsertItemsRelationInput"]: ValueTypes["InfoCarouselUpsertItemsRelationInput"];
	["InfoCarouselUpdateSeenByEntityRelationInput"]: ValueTypes["InfoCarouselUpdateSeenByEntityRelationInput"];
	["InfoCarouselUpdateSeenByRelationInput"]: ValueTypes["InfoCarouselUpdateSeenByRelationInput"];
	["PersonSeenInfoCarouselWithoutCarouselUpdateInput"]: ValueTypes["PersonSeenInfoCarouselWithoutCarouselUpdateInput"];
	["PersonSeenInfoCarouselUpdateUserEntityRelationInput"]: ValueTypes["PersonSeenInfoCarouselUpdateUserEntityRelationInput"];
	["PersonSeenInfoCarouselUpsertUserRelationInput"]: ValueTypes["PersonSeenInfoCarouselUpsertUserRelationInput"];
	["InfoCarouselUpsertSeenByRelationInput"]: ValueTypes["InfoCarouselUpsertSeenByRelationInput"];
	["InfoCarouselItemCreateInput"]: ValueTypes["InfoCarouselItemCreateInput"];
	["InfoCarouselItemCreateCarouselEntityRelationInput"]: ValueTypes["InfoCarouselItemCreateCarouselEntityRelationInput"];
	["InfoCarouselWithoutItemsCreateInput"]: ValueTypes["InfoCarouselWithoutItemsCreateInput"];
	["InfoCarouselItemConnectOrCreateCarouselRelationInput"]: ValueTypes["InfoCarouselItemConnectOrCreateCarouselRelationInput"];
	["InfoCarouselItemUpdateInput"]: ValueTypes["InfoCarouselItemUpdateInput"];
	["InfoCarouselItemUpdateCarouselEntityRelationInput"]: ValueTypes["InfoCarouselItemUpdateCarouselEntityRelationInput"];
	["InfoCarouselWithoutItemsUpdateInput"]: ValueTypes["InfoCarouselWithoutItemsUpdateInput"];
	["InfoCarouselItemUpsertCarouselRelationInput"]: ValueTypes["InfoCarouselItemUpsertCarouselRelationInput"];
	["PersonSeenInfoCarouselCreateInput"]: ValueTypes["PersonSeenInfoCarouselCreateInput"];
	["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"]: ValueTypes["PersonSeenInfoCarouselCreateCarouselEntityRelationInput"];
	["InfoCarouselWithoutSeenByCreateInput"]: ValueTypes["InfoCarouselWithoutSeenByCreateInput"];
	["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"]: ValueTypes["PersonSeenInfoCarouselConnectOrCreateCarouselRelationInput"];
	["PersonSeenInfoCarouselUpdateInput"]: ValueTypes["PersonSeenInfoCarouselUpdateInput"];
	["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"]: ValueTypes["PersonSeenInfoCarouselUpdateCarouselEntityRelationInput"];
	["InfoCarouselWithoutSeenByUpdateInput"]: ValueTypes["InfoCarouselWithoutSeenByUpdateInput"];
	["PersonSeenInfoCarouselUpsertCarouselRelationInput"]: ValueTypes["PersonSeenInfoCarouselUpsertCarouselRelationInput"];
	["GivenGiftsPageCreateInput"]: ValueTypes["GivenGiftsPageCreateInput"];
	["GivenGiftsPageCreateLocalesEntityRelationInput"]: ValueTypes["GivenGiftsPageCreateLocalesEntityRelationInput"];
	["GivenGiftsPageLocaleWithoutRootCreateInput"]: ValueTypes["GivenGiftsPageLocaleWithoutRootCreateInput"];
	["GivenGiftsPageConnectOrCreateLocalesRelationInput"]: ValueTypes["GivenGiftsPageConnectOrCreateLocalesRelationInput"];
	["GivenGiftsPageUpdateInput"]: ValueTypes["GivenGiftsPageUpdateInput"];
	["GivenGiftsPageUpdateLocalesEntityRelationInput"]: ValueTypes["GivenGiftsPageUpdateLocalesEntityRelationInput"];
	["GivenGiftsPageUpdateLocalesRelationInput"]: ValueTypes["GivenGiftsPageUpdateLocalesRelationInput"];
	["GivenGiftsPageLocaleWithoutRootUpdateInput"]: ValueTypes["GivenGiftsPageLocaleWithoutRootUpdateInput"];
	["GivenGiftsPageUpsertLocalesRelationInput"]: ValueTypes["GivenGiftsPageUpsertLocalesRelationInput"];
	["GivenGiftsPageLocaleCreateInput"]: ValueTypes["GivenGiftsPageLocaleCreateInput"];
	["GivenGiftsPageLocaleUpdateInput"]: ValueTypes["GivenGiftsPageLocaleUpdateInput"];
	["ReceivedGiftsPageCreateInput"]: ValueTypes["ReceivedGiftsPageCreateInput"];
	["ReceivedGiftsPageCreateLocalesEntityRelationInput"]: ValueTypes["ReceivedGiftsPageCreateLocalesEntityRelationInput"];
	["ReceivedGiftsPageLocaleWithoutRootCreateInput"]: ValueTypes["ReceivedGiftsPageLocaleWithoutRootCreateInput"];
	["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"]: ValueTypes["ReceivedGiftsPageConnectOrCreateLocalesRelationInput"];
	["ReceivedGiftsPageUpdateInput"]: ValueTypes["ReceivedGiftsPageUpdateInput"];
	["ReceivedGiftsPageUpdateLocalesEntityRelationInput"]: ValueTypes["ReceivedGiftsPageUpdateLocalesEntityRelationInput"];
	["ReceivedGiftsPageUpdateLocalesRelationInput"]: ValueTypes["ReceivedGiftsPageUpdateLocalesRelationInput"];
	["ReceivedGiftsPageLocaleWithoutRootUpdateInput"]: ValueTypes["ReceivedGiftsPageLocaleWithoutRootUpdateInput"];
	["ReceivedGiftsPageUpsertLocalesRelationInput"]: ValueTypes["ReceivedGiftsPageUpsertLocalesRelationInput"];
	["ReceivedGiftsPageLocaleCreateInput"]: ValueTypes["ReceivedGiftsPageLocaleCreateInput"];
	["ReceivedGiftsPageLocaleUpdateInput"]: ValueTypes["ReceivedGiftsPageLocaleUpdateInput"];
	["ReportNavigationCreateInput"]: ValueTypes["ReportNavigationCreateInput"];
	["ReportNavigationCreateLocalesEntityRelationInput"]: ValueTypes["ReportNavigationCreateLocalesEntityRelationInput"];
	["ReportNavigationLocaleWithoutRootCreateInput"]: ValueTypes["ReportNavigationLocaleWithoutRootCreateInput"];
	["ReportNavigationConnectOrCreateLocalesRelationInput"]: ValueTypes["ReportNavigationConnectOrCreateLocalesRelationInput"];
	["ReportNavigationUpdateInput"]: ValueTypes["ReportNavigationUpdateInput"];
	["ReportNavigationUpdateLocalesEntityRelationInput"]: ValueTypes["ReportNavigationUpdateLocalesEntityRelationInput"];
	["ReportNavigationUpdateLocalesRelationInput"]: ValueTypes["ReportNavigationUpdateLocalesRelationInput"];
	["ReportNavigationLocaleWithoutRootUpdateInput"]: ValueTypes["ReportNavigationLocaleWithoutRootUpdateInput"];
	["ReportNavigationUpsertLocalesRelationInput"]: ValueTypes["ReportNavigationUpsertLocalesRelationInput"];
	["ReportPageCreateInput"]: ValueTypes["ReportPageCreateInput"];
	["ReportPageCreateLocalesEntityRelationInput"]: ValueTypes["ReportPageCreateLocalesEntityRelationInput"];
	["ReportPageLocaleWithoutRootCreateInput"]: ValueTypes["ReportPageLocaleWithoutRootCreateInput"];
	["ReportPageConnectOrCreateLocalesRelationInput"]: ValueTypes["ReportPageConnectOrCreateLocalesRelationInput"];
	["ReportPageUpdateInput"]: ValueTypes["ReportPageUpdateInput"];
	["ReportPageUpdateLocalesEntityRelationInput"]: ValueTypes["ReportPageUpdateLocalesEntityRelationInput"];
	["ReportPageUpdateLocalesRelationInput"]: ValueTypes["ReportPageUpdateLocalesRelationInput"];
	["ReportPageLocaleWithoutRootUpdateInput"]: ValueTypes["ReportPageLocaleWithoutRootUpdateInput"];
	["ReportPageUpsertLocalesRelationInput"]: ValueTypes["ReportPageUpsertLocalesRelationInput"];
	["ReportPageLocaleCreateInput"]: ValueTypes["ReportPageLocaleCreateInput"];
	["ReportPageLocaleUpdateInput"]: ValueTypes["ReportPageLocaleUpdateInput"];
	["ReportNavigationLocaleCreateInput"]: ValueTypes["ReportNavigationLocaleCreateInput"];
	["ReportNavigationLocaleUpdateInput"]: ValueTypes["ReportNavigationLocaleUpdateInput"];
	["SentPaymentCreateInput"]: ValueTypes["SentPaymentCreateInput"];
	["SentPaymentUpdateInput"]: ValueTypes["SentPaymentUpdateInput"];
	["ProcessedNotificationCreateInput"]: ValueTypes["ProcessedNotificationCreateInput"];
	["ProcessedNotificationCreateSourceEntityRelationInput"]: ValueTypes["ProcessedNotificationCreateSourceEntityRelationInput"];
	["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"]: ValueTypes["ProcessedNotificationSourceWithoutProcessedNotificationCreateInput"];
	["ProcessedNotificationConnectOrCreateSourceRelationInput"]: ValueTypes["ProcessedNotificationConnectOrCreateSourceRelationInput"];
	["ProcessedNotificationUpdateInput"]: ValueTypes["ProcessedNotificationUpdateInput"];
	["ProcessedNotificationUpdateSourceEntityRelationInput"]: ValueTypes["ProcessedNotificationUpdateSourceEntityRelationInput"];
	["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"]: ValueTypes["ProcessedNotificationSourceWithoutProcessedNotificationUpdateInput"];
	["ProcessedNotificationUpsertSourceRelationInput"]: ValueTypes["ProcessedNotificationUpsertSourceRelationInput"];
	["ScheduledNotificationCreateInput"]: ValueTypes["ScheduledNotificationCreateInput"];
	["ScheduledNotificationUpdateInput"]: ValueTypes["ScheduledNotificationUpdateInput"];
	["ProcessedNotificationSourceCreateInput"]: ValueTypes["ProcessedNotificationSourceCreateInput"];
	["ProcessedNotificationSourceUpdateInput"]: ValueTypes["ProcessedNotificationSourceUpdateInput"];
	["DeviceCreateInput"]: ValueTypes["DeviceCreateInput"];
	["DeviceCreateUserEntityRelationInput"]: ValueTypes["DeviceCreateUserEntityRelationInput"];
	["UserWithoutDevicesCreateInput"]: ValueTypes["UserWithoutDevicesCreateInput"];
	["DeviceConnectOrCreateUserRelationInput"]: ValueTypes["DeviceConnectOrCreateUserRelationInput"];
	["DeviceUpdateInput"]: ValueTypes["DeviceUpdateInput"];
	["DeviceUpdateUserEntityRelationInput"]: ValueTypes["DeviceUpdateUserEntityRelationInput"];
	["UserWithoutDevicesUpdateInput"]: ValueTypes["UserWithoutDevicesUpdateInput"];
	["DeviceUpsertUserRelationInput"]: ValueTypes["DeviceUpsertUserRelationInput"];
	["ScheduledNotificationLocaleCreateInput"]: ValueTypes["ScheduledNotificationLocaleCreateInput"];
	["ScheduledNotificationLocaleUpdateInput"]: ValueTypes["ScheduledNotificationLocaleUpdateInput"];
	["InfoCarouselItemLocaleCreateInput"]: ValueTypes["InfoCarouselItemLocaleCreateInput"];
	["InfoCarouselItemLocaleCreateRootEntityRelationInput"]: ValueTypes["InfoCarouselItemLocaleCreateRootEntityRelationInput"];
	["InfoCarouselItemWithoutLocalesCreateInput"]: ValueTypes["InfoCarouselItemWithoutLocalesCreateInput"];
	["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"]: ValueTypes["InfoCarouselItemLocaleConnectOrCreateRootRelationInput"];
	["InfoCarouselItemLocaleUpdateInput"]: ValueTypes["InfoCarouselItemLocaleUpdateInput"];
	["InfoCarouselItemLocaleUpdateRootEntityRelationInput"]: ValueTypes["InfoCarouselItemLocaleUpdateRootEntityRelationInput"];
	["InfoCarouselItemWithoutLocalesUpdateInput"]: ValueTypes["InfoCarouselItemWithoutLocalesUpdateInput"];
	["InfoCarouselItemLocaleUpsertRootRelationInput"]: ValueTypes["InfoCarouselItemLocaleUpsertRootRelationInput"];
	["SentPaymentLocaleCreateInput"]: ValueTypes["SentPaymentLocaleCreateInput"];
	["SentPaymentLocaleUpdateInput"]: ValueTypes["SentPaymentLocaleUpdateInput"];
	["StatsUniqueWhere"]: ValueTypes["StatsUniqueWhere"];
	["StatsWhere"]: ValueTypes["StatsWhere"];
	["StatsOrderBy"]: ValueTypes["StatsOrderBy"];
	["TextImageListItemCreateInput"]: ValueTypes["TextImageListItemCreateInput"];
	["TextImageListItemCreateListEntityRelationInput"]: ValueTypes["TextImageListItemCreateListEntityRelationInput"];
	["TextImageListWithoutItemsCreateInput"]: ValueTypes["TextImageListWithoutItemsCreateInput"];
	["TextImageListItemConnectOrCreateListRelationInput"]: ValueTypes["TextImageListItemConnectOrCreateListRelationInput"];
	["TextImageListItemUpdateInput"]: ValueTypes["TextImageListItemUpdateInput"];
	["TextImageListItemUpdateListEntityRelationInput"]: ValueTypes["TextImageListItemUpdateListEntityRelationInput"];
	["TextImageListWithoutItemsUpdateInput"]: ValueTypes["TextImageListWithoutItemsUpdateInput"];
	["TextImageListItemUpsertListRelationInput"]: ValueTypes["TextImageListItemUpsertListRelationInput"];
	["HeroCarouselItemCreateInput"]: ValueTypes["HeroCarouselItemCreateInput"];
	["HeroCarouselItemCreateListEntityRelationInput"]: ValueTypes["HeroCarouselItemCreateListEntityRelationInput"];
	["HeroCarouselWithoutItemsCreateInput"]: ValueTypes["HeroCarouselWithoutItemsCreateInput"];
	["HeroCarouselItemConnectOrCreateListRelationInput"]: ValueTypes["HeroCarouselItemConnectOrCreateListRelationInput"];
	["HeroCarouselItemUpdateInput"]: ValueTypes["HeroCarouselItemUpdateInput"];
	["HeroCarouselItemUpdateListEntityRelationInput"]: ValueTypes["HeroCarouselItemUpdateListEntityRelationInput"];
	["HeroCarouselWithoutItemsUpdateInput"]: ValueTypes["HeroCarouselWithoutItemsUpdateInput"];
	["HeroCarouselItemUpsertListRelationInput"]: ValueTypes["HeroCarouselItemUpsertListRelationInput"];
	["S3GenerateSignedUploadInput"]: ValueTypes["S3GenerateSignedUploadInput"];
	["S33ContentDisposition"]: ValueTypes["S33ContentDisposition"];
	["S3Acl"]: ValueTypes["S3Acl"];
	["_MutationErrorType"]: ValueTypes["_MutationErrorType"];
	["MutationTransactionOptions"]: ValueTypes["MutationTransactionOptions"];
}